var LC = Object.defineProperty;
var aC = (t, e, n) => e in t ? LC(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n;
var V2 = (t, e, n) => (aC(t, typeof e != "symbol" ? e + "" : e, n), n);
var x5 = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function s4(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function CC(t) {
  try {
    return JSON.stringify(t);
  } catch {
    return '"[Circular]"';
  }
}
var cC = uC;
function uC(t, e, n) {
  var i = n && n.stringify || CC, s = 1;
  if (typeof t == "object" && t !== null) {
    var r = e.length + s;
    if (r === 1)
      return t;
    var o = new Array(r);
    o[0] = i(t);
    for (var l = 1; l < r; l++)
      o[l] = i(e[l]);
    return o.join(" ");
  }
  if (typeof t != "string")
    return t;
  var L = e.length;
  if (L === 0)
    return t;
  for (var a = "", C = 1 - s, c = -1, h = t && t.length || 0, d = 0; d < h; ) {
    if (t.charCodeAt(d) === 37 && d + 1 < h) {
      switch (c = c > -1 ? c : 0, t.charCodeAt(d + 1)) {
        case 100:
        case 102:
          if (C >= L || e[C] == null)
            break;
          c < d && (a += t.slice(c, d)), a += Number(e[C]), c = d + 2, d++;
          break;
        case 105:
          if (C >= L || e[C] == null)
            break;
          c < d && (a += t.slice(c, d)), a += Math.floor(Number(e[C])), c = d + 2, d++;
          break;
        case 79:
        case 111:
        case 106:
          if (C >= L || e[C] === void 0)
            break;
          c < d && (a += t.slice(c, d));
          var f = typeof e[C];
          if (f === "string") {
            a += "'" + e[C] + "'", c = d + 2, d++;
            break;
          }
          if (f === "function") {
            a += e[C].name || "<anonymous>", c = d + 2, d++;
            break;
          }
          a += i(e[C]), c = d + 2, d++;
          break;
        case 115:
          if (C >= L)
            break;
          c < d && (a += t.slice(c, d)), a += String(e[C]), c = d + 2, d++;
          break;
        case 37:
          c < d && (a += t.slice(c, d)), a += "%", c = d + 2, d++, C--;
          break;
      }
      ++C;
    }
    ++d;
  }
  return c === -1 ? t : (c < h && (a += t.slice(c)), a);
}
const yn = cC;
var hC = G3;
const I0 = MC().console || {}, dC = {
  mapHttpRequest: _5,
  mapHttpResponse: _5,
  wrapRequestSerializer: v7,
  wrapResponseSerializer: v7,
  wrapErrorSerializer: v7,
  req: _5,
  res: _5,
  err: wC
};
function gC(t, e) {
  return Array.isArray(t) ? t.filter(function(i) {
    return i !== "!stdSerializers.err";
  }) : t === !0 ? Object.keys(e) : !1;
}
function G3(t) {
  t = t || {}, t.browser = t.browser || {};
  const e = t.browser.transmit;
  if (e && typeof e.send != "function")
    throw Error("pino: transmit option must have a send function");
  const n = t.browser.write || I0;
  t.browser.write && (t.browser.asObject = !0);
  const i = t.serializers || {}, s = gC(t.browser.serialize, i);
  let r = t.browser.serialize;
  Array.isArray(t.browser.serialize) && t.browser.serialize.indexOf("!stdSerializers.err") > -1 && (r = !1);
  const o = ["error", "fatal", "warn", "info", "debug", "trace"];
  typeof n == "function" && (n.error = n.fatal = n.warn = n.info = n.debug = n.trace = n), (t.enabled === !1 || t.browser.disabled) && (t.level = "silent");
  const l = t.level || "info", L = Object.create(n);
  L.log || (L.log = F0), Object.defineProperty(L, "levelVal", {
    get: C
  }), Object.defineProperty(L, "level", {
    get: c,
    set: h
  });
  const a = {
    transmit: e,
    serialize: s,
    asObject: t.browser.asObject,
    levels: o,
    timestamp: xC(t)
  };
  L.levels = G3.levels, L.level = l, L.setMaxListeners = L.getMaxListeners = L.emit = L.addListener = L.on = L.prependListener = L.once = L.prependOnceListener = L.removeListener = L.removeAllListeners = L.listeners = L.listenerCount = L.eventNames = L.write = L.flush = F0, L.serializers = i, L._serialize = s, L._stdErrSerialize = r, L.child = d, e && (L._logEvent = s6());
  function C() {
    return this.level === "silent" ? 1 / 0 : this.levels.values[this.level];
  }
  function c() {
    return this._level;
  }
  function h(f) {
    if (f !== "silent" && !this.levels.values[f])
      throw Error("unknown level " + f);
    this._level = f, x9(a, L, "error", "log"), x9(a, L, "fatal", "error"), x9(a, L, "warn", "error"), x9(a, L, "info", "log"), x9(a, L, "debug", "log"), x9(a, L, "trace", "log");
  }
  function d(f, x) {
    if (!f)
      throw new Error("missing bindings for child Pino");
    x = x || {}, s && f.serializers && (x.serializers = f.serializers);
    const k = x.serializers;
    if (s && k) {
      var m = Object.assign({}, i, k), g = t.browser.serialize === !0 ? Object.keys(m) : s;
      delete f.serializers, R8([f], g, m, this._stdErrSerialize);
    }
    function w(Z) {
      this._childLevel = (Z._childLevel | 0) + 1, this.error = _9(Z, f, "error"), this.fatal = _9(Z, f, "fatal"), this.warn = _9(Z, f, "warn"), this.info = _9(Z, f, "info"), this.debug = _9(Z, f, "debug"), this.trace = _9(Z, f, "trace"), m && (this.serializers = m, this._serialize = g), e && (this._logEvent = s6(
        [].concat(Z._logEvent.bindings, f)
      ));
    }
    return w.prototype = this, new w(this);
  }
  return L;
}
G3.levels = {
  values: {
    fatal: 60,
    error: 50,
    warn: 40,
    info: 30,
    debug: 20,
    trace: 10
  },
  labels: {
    10: "trace",
    20: "debug",
    30: "info",
    40: "warn",
    50: "error",
    60: "fatal"
  }
};
G3.stdSerializers = dC;
G3.stdTimeFunctions = Object.assign({}, { nullTime: Us, epochTime: Ws, unixTime: _C, isoTime: vC });
function x9(t, e, n, i) {
  const s = Object.getPrototypeOf(e);
  e[n] = e.levelVal > e.levels.values[n] ? F0 : s[n] ? s[n] : I0[n] || I0[i] || F0, fC(t, e, n);
}
function fC(t, e, n) {
  !t.transmit && e[n] === F0 || (e[n] = function(i) {
    return function() {
      const r = t.timestamp(), o = new Array(arguments.length), l = Object.getPrototypeOf && Object.getPrototypeOf(this) === I0 ? I0 : this;
      for (var L = 0; L < o.length; L++)
        o[L] = arguments[L];
      if (t.serialize && !t.asObject && R8(o, this._serialize, this.serializers, this._stdErrSerialize), t.asObject ? i.call(l, pC(this, n, o, r)) : i.apply(l, o), t.transmit) {
        const a = t.transmit.level || e.level, C = G3.levels.values[a], c = G3.levels.values[n];
        if (c < C)
          return;
        mC(this, {
          ts: r,
          methodLevel: n,
          methodValue: c,
          transmitLevel: a,
          transmitValue: G3.levels.values[t.transmit.level || e.level],
          send: t.transmit.send,
          val: e.levelVal
        }, o);
      }
    };
  }(e[n]));
}
function pC(t, e, n, i) {
  t._serialize && R8(n, t._serialize, t.serializers, t._stdErrSerialize);
  const s = n.slice();
  let r = s[0];
  const o = {};
  i && (o.time = i), o.level = G3.levels.values[e];
  let l = (t._childLevel | 0) + 1;
  if (l < 1 && (l = 1), r !== null && typeof r == "object") {
    for (; l-- && typeof s[0] == "object"; )
      Object.assign(o, s.shift());
    r = s.length ? yn(s.shift(), s) : void 0;
  } else
    typeof r == "string" && (r = yn(s.shift(), s));
  return r !== void 0 && (o.msg = r), o;
}
function R8(t, e, n, i) {
  for (const s in t)
    if (i && t[s] instanceof Error)
      t[s] = G3.stdSerializers.err(t[s]);
    else if (typeof t[s] == "object" && !Array.isArray(t[s]))
      for (const r in t[s])
        e && e.indexOf(r) > -1 && r in n && (t[s][r] = n[r](t[s][r]));
}
function _9(t, e, n) {
  return function() {
    const i = new Array(1 + arguments.length);
    i[0] = e;
    for (var s = 1; s < i.length; s++)
      i[s] = arguments[s - 1];
    return t[n].apply(this, i);
  };
}
function mC(t, e, n) {
  const i = e.send, s = e.ts, r = e.methodLevel, o = e.methodValue, l = e.val, L = t._logEvent.bindings;
  R8(
    n,
    t._serialize || Object.keys(t.serializers),
    t.serializers,
    t._stdErrSerialize === void 0 ? !0 : t._stdErrSerialize
  ), t._logEvent.ts = s, t._logEvent.messages = n.filter(function(a) {
    return L.indexOf(a) === -1;
  }), t._logEvent.level.label = r, t._logEvent.level.value = o, i(r, t._logEvent, l), t._logEvent = s6(L);
}
function s6(t) {
  return {
    ts: 0,
    messages: [],
    bindings: t || [],
    level: { label: "", value: 0 }
  };
}
function wC(t) {
  const e = {
    type: t.constructor.name,
    msg: t.message,
    stack: t.stack
  };
  for (const n in t)
    e[n] === void 0 && (e[n] = t[n]);
  return e;
}
function xC(t) {
  return typeof t.timestamp == "function" ? t.timestamp : t.timestamp === !1 ? Us : Ws;
}
function _5() {
  return {};
}
function v7(t) {
  return t;
}
function F0() {
}
function Us() {
  return !1;
}
function Ws() {
  return Date.now();
}
function _C() {
  return Math.round(Date.now() / 1e3);
}
function vC() {
  return new Date(Date.now()).toISOString();
}
function MC() {
  function t(e) {
    return typeof e < "u" && e;
  }
  try {
    return typeof globalThis < "u" || Object.defineProperty(Object.prototype, "globalThis", {
      get: function() {
        return delete Object.prototype.globalThis, this.globalThis = this;
      },
      configurable: !0
    }), globalThis;
  } catch {
    return t(self) || t(window) || t(this) || {};
  }
}
const RC = /* @__PURE__ */ s4(hC), yC = RC({
  level: "warn"
}), An = ["log", "trace", "debug", "info", "warn", "error"];
function AC(t, e) {
  t[e] = (console[e] || console.log).bind(console);
}
function ZC(t, e, n) {
  t[e] = (console[e] || console.log).bind(
    console,
    n[0],
    n[1]
  );
}
function kC(t) {
  An.forEach((n) => AC(t, n));
  const e = t.child;
  return t.child = function(n) {
    const i = e.call(t, n);
    return An.forEach(
      (s) => ZC(i, s, ["%c" + n.name || "", "color: #00f"])
    ), i;
  }, t;
}
const y8 = kC(yC);
function K9(t, e) {
  const n = /* @__PURE__ */ Object.create(null), i = t.split(",");
  for (let s = 0; s < i.length; s++)
    n[i[s]] = !0;
  return e ? (s) => !!n[s.toLowerCase()] : (s) => !!n[s];
}
const TC = "Infinity,undefined,NaN,isFinite,isNaN,parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt", SC = /* @__PURE__ */ K9(TC);
function w2(t) {
  if (e2(t)) {
    const e = {};
    for (let n = 0; n < t.length; n++) {
      const i = t[n], s = r1(i) ? FC(i) : w2(i);
      if (s)
        for (const r in s)
          e[r] = s[r];
    }
    return e;
  } else {
    if (r1(t))
      return t;
    if (B2(t))
      return t;
  }
}
const bC = /;(?![^(]*\))/g, EC = /:([^]+)/, IC = /\/\*.*?\*\//gs;
function FC(t) {
  const e = {};
  return t.replace(IC, "").split(bC).forEach((n) => {
    if (n) {
      const i = n.split(EC);
      i.length > 1 && (e[i[0].trim()] = i[1].trim());
    }
  }), e;
}
function v2(t) {
  let e = "";
  if (r1(t))
    e = t;
  else if (e2(t))
    for (let n = 0; n < t.length; n++) {
      const i = v2(t[n]);
      i && (e += i + " ");
    }
  else if (B2(t))
    for (const n in t)
      t[n] && (e += n + " ");
  return e.trim();
}
function OC(t) {
  if (!t)
    return null;
  let { class: e, style: n } = t;
  return e && !r1(e) && (t.class = v2(e)), n && (t.style = w2(n)), t;
}
const NC = "itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly", Hs = /* @__PURE__ */ K9(NC);
function $s(t) {
  return !!t || t === "";
}
function DC(t, e) {
  if (t.length !== e.length)
    return !1;
  let n = !0;
  for (let i = 0; n && i < t.length; i++)
    n = d4(t[i], e[i]);
  return n;
}
function d4(t, e) {
  if (t === e)
    return !0;
  let n = Zn(t), i = Zn(e);
  if (n || i)
    return n && i ? t.getTime() === e.getTime() : !1;
  if (n = O0(t), i = O0(e), n || i)
    return t === e;
  if (n = e2(t), i = e2(e), n || i)
    return n && i ? DC(t, e) : !1;
  if (n = B2(t), i = B2(e), n || i) {
    if (!n || !i)
      return !1;
    const s = Object.keys(t).length, r = Object.keys(e).length;
    if (s !== r)
      return !1;
    for (const o in t) {
      const l = t.hasOwnProperty(o), L = e.hasOwnProperty(o);
      if (l && !L || !l && L || !d4(t[o], e[o]))
        return !1;
    }
  }
  return String(t) === String(e);
}
function K0(t, e) {
  return t.findIndex((n) => d4(n, e));
}
const m1 = (t) => r1(t) ? t : t == null ? "" : e2(t) || B2(t) && (t.toString === Gs || !p2(t.toString)) ? JSON.stringify(t, Vs, 2) : String(t), Vs = (t, e) => e && e.__v_isRef ? Vs(t, e.value) : S9(e) ? {
  [`Map(${e.size})`]: [...e.entries()].reduce((n, [i, s]) => (n[`${i} =>`] = s, n), {})
} : d9(e) ? {
  [`Set(${e.size})`]: [...e.values()]
} : B2(e) && !e2(e) && !J5(e) ? String(e) : e, X2 = {}, T9 = [], o3 = () => {
}, PC = () => !1, BC = /^on[^a-z]/, w4 = (t) => BC.test(t), re = (t) => t.startsWith("onUpdate:"), U2 = Object.assign, oe = (t, e) => {
  const n = t.indexOf(e);
  n > -1 && t.splice(n, 1);
}, zC = Object.prototype.hasOwnProperty, $2 = (t, e) => zC.call(t, e), e2 = Array.isArray, S9 = (t) => Y0(t) === "[object Map]", d9 = (t) => Y0(t) === "[object Set]", Zn = (t) => Y0(t) === "[object Date]", p2 = (t) => typeof t == "function", r1 = (t) => typeof t == "string", O0 = (t) => typeof t == "symbol", B2 = (t) => t !== null && typeof t == "object", A8 = (t) => B2(t) && p2(t.then) && p2(t.catch), Gs = Object.prototype.toString, Y0 = (t) => Gs.call(t), UC = (t) => Y0(t).slice(8, -1), J5 = (t) => Y0(t) === "[object Object]", le = (t) => r1(t) && t !== "NaN" && t[0] !== "-" && "" + parseInt(t, 10) === t, b9 = /* @__PURE__ */ K9(
  // the leading comma is intentional so empty string "" is also included
  ",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted"
), Z8 = (t) => {
  const e = /* @__PURE__ */ Object.create(null);
  return (n) => e[n] || (e[n] = t(n));
}, WC = /-(\w)/g, G1 = Z8((t) => t.replace(WC, (e, n) => n ? n.toUpperCase() : "")), HC = /\B([A-Z])/g, W1 = Z8((t) => t.replace(HC, "-$1").toLowerCase()), Q0 = Z8((t) => t.charAt(0).toUpperCase() + t.slice(1)), E9 = Z8((t) => t ? `on${Q0(t)}` : ""), z9 = (t, e) => !Object.is(t, e), I4 = (t, e) => {
  for (let n = 0; n < t.length; n++)
    t[n](e);
}, e8 = (t, e, n) => {
  Object.defineProperty(t, e, {
    configurable: !0,
    enumerable: !1,
    value: n
  });
}, Q3 = (t) => {
  const e = parseFloat(t);
  return isNaN(e) ? t : e;
};
let kn;
const $C = () => kn || (kn = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {});
let d3;
class Le {
  constructor(e = !1) {
    this.detached = e, this.active = !0, this.effects = [], this.cleanups = [], this.parent = d3, !e && d3 && (this.index = (d3.scopes || (d3.scopes = [])).push(this) - 1);
  }
  run(e) {
    if (this.active) {
      const n = d3;
      try {
        return d3 = this, e();
      } finally {
        d3 = n;
      }
    }
  }
  /**
   * This should only be called on non-detached scopes
   * @internal
   */
  on() {
    d3 = this;
  }
  /**
   * This should only be called on non-detached scopes
   * @internal
   */
  off() {
    d3 = this.parent;
  }
  stop(e) {
    if (this.active) {
      let n, i;
      for (n = 0, i = this.effects.length; n < i; n++)
        this.effects[n].stop();
      for (n = 0, i = this.cleanups.length; n < i; n++)
        this.cleanups[n]();
      if (this.scopes)
        for (n = 0, i = this.scopes.length; n < i; n++)
          this.scopes[n].stop(!0);
      if (!this.detached && this.parent && !e) {
        const s = this.parent.scopes.pop();
        s && s !== this && (this.parent.scopes[this.index] = s, s.index = this.index);
      }
      this.parent = void 0, this.active = !1;
    }
  }
}
function js(t) {
  return new Le(t);
}
function qs(t, e = d3) {
  e && e.active && e.effects.push(t);
}
function VC() {
  return d3;
}
function GC(t) {
  d3 && d3.cleanups.push(t);
}
const ae = (t) => {
  const e = new Set(t);
  return e.w = 0, e.n = 0, e;
}, Ks = (t) => (t.w & D4) > 0, Ys = (t) => (t.n & D4) > 0, jC = ({ deps: t }) => {
  if (t.length)
    for (let e = 0; e < t.length; e++)
      t[e].w |= D4;
}, qC = (t) => {
  const { deps: e } = t;
  if (e.length) {
    let n = 0;
    for (let i = 0; i < e.length; i++) {
      const s = e[i];
      Ks(s) && !Ys(s) ? s.delete(t) : e[n++] = s, s.w &= ~D4, s.n &= ~D4;
    }
    e.length = n;
  }
}, r6 = /* @__PURE__ */ new WeakMap();
let w0 = 0, D4 = 1;
const o6 = 30;
let I3;
const n9 = Symbol(""), l6 = Symbol("");
class X0 {
  constructor(e, n = null, i) {
    this.fn = e, this.scheduler = n, this.active = !0, this.deps = [], this.parent = void 0, qs(this, i);
  }
  run() {
    if (!this.active)
      return this.fn();
    let e = I3, n = F4;
    for (; e; ) {
      if (e === this)
        return;
      e = e.parent;
    }
    try {
      return this.parent = I3, I3 = this, F4 = !0, D4 = 1 << ++w0, w0 <= o6 ? jC(this) : Tn(this), this.fn();
    } finally {
      w0 <= o6 && qC(this), D4 = 1 << --w0, I3 = this.parent, F4 = n, this.parent = void 0, this.deferStop && this.stop();
    }
  }
  stop() {
    I3 === this ? this.deferStop = !0 : this.active && (Tn(this), this.onStop && this.onStop(), this.active = !1);
  }
}
function Tn(t) {
  const { deps: e } = t;
  if (e.length) {
    for (let n = 0; n < e.length; n++)
      e[n].delete(t);
    e.length = 0;
  }
}
function KC(t, e) {
  t.effect && (t = t.effect.fn);
  const n = new X0(t);
  e && (U2(n, e), e.scope && qs(n, e.scope)), (!e || !e.lazy) && n.run();
  const i = n.run.bind(n);
  return i.effect = n, i;
}
function YC(t) {
  t.effect.stop();
}
let F4 = !0;
const Qs = [];
function Y9() {
  Qs.push(F4), F4 = !1;
}
function Q9() {
  const t = Qs.pop();
  F4 = t === void 0 ? !0 : t;
}
function L3(t, e, n) {
  if (F4 && I3) {
    let i = r6.get(t);
    i || r6.set(t, i = /* @__PURE__ */ new Map());
    let s = i.get(n);
    s || i.set(n, s = ae()), Xs(s);
  }
}
function Xs(t, e) {
  let n = !1;
  w0 <= o6 ? Ys(t) || (t.n |= D4, n = !Ks(t)) : n = !t.has(I3), n && (t.add(I3), I3.deps.push(t));
}
function X3(t, e, n, i, s, r) {
  const o = r6.get(t);
  if (!o)
    return;
  let l = [];
  if (e === "clear")
    l = [...o.values()];
  else if (n === "length" && e2(t)) {
    const L = Q3(i);
    o.forEach((a, C) => {
      (C === "length" || C >= L) && l.push(a);
    });
  } else
    switch (n !== void 0 && l.push(o.get(n)), e) {
      case "add":
        e2(t) ? le(n) && l.push(o.get("length")) : (l.push(o.get(n9)), S9(t) && l.push(o.get(l6)));
        break;
      case "delete":
        e2(t) || (l.push(o.get(n9)), S9(t) && l.push(o.get(l6)));
        break;
      case "set":
        S9(t) && l.push(o.get(n9));
        break;
    }
  if (l.length === 1)
    l[0] && L6(l[0]);
  else {
    const L = [];
    for (const a of l)
      a && L.push(...a);
    L6(ae(L));
  }
}
function L6(t, e) {
  const n = e2(t) ? t : [...t];
  for (const i of n)
    i.computed && Sn(i);
  for (const i of n)
    i.computed || Sn(i);
}
function Sn(t, e) {
  (t !== I3 || t.allowRecurse) && (t.scheduler ? t.scheduler() : t.run());
}
const QC = /* @__PURE__ */ K9("__proto__,__v_isRef,__isVue"), Js = new Set(
  /* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((t) => t !== "arguments" && t !== "caller").map((t) => Symbol[t]).filter(O0)
), XC = /* @__PURE__ */ k8(), JC = /* @__PURE__ */ k8(!1, !0), ec = /* @__PURE__ */ k8(!0), tc = /* @__PURE__ */ k8(!0, !0), bn = /* @__PURE__ */ nc();
function nc() {
  const t = {};
  return ["includes", "indexOf", "lastIndexOf"].forEach((e) => {
    t[e] = function(...n) {
      const i = I2(this);
      for (let r = 0, o = this.length; r < o; r++)
        L3(i, "get", r + "");
      const s = i[e](...n);
      return s === -1 || s === !1 ? i[e](...n.map(I2)) : s;
    };
  }), ["push", "pop", "shift", "unshift", "splice"].forEach((e) => {
    t[e] = function(...n) {
      Y9();
      const i = I2(this)[e].apply(this, n);
      return Q9(), i;
    };
  }), t;
}
function k8(t = !1, e = !1) {
  return function(i, s, r) {
    if (s === "__v_isReactive")
      return !t;
    if (s === "__v_isReadonly")
      return t;
    if (s === "__v_isShallow")
      return e;
    if (s === "__v_raw" && r === (t ? e ? or : rr : e ? sr : ir).get(i))
      return i;
    const o = e2(i);
    if (!t && o && $2(bn, s))
      return Reflect.get(bn, s, r);
    const l = Reflect.get(i, s, r);
    return (O0(s) ? Js.has(s) : QC(s)) || (t || L3(i, "get", s), e) ? l : R1(l) ? o && le(s) ? l : l.value : B2(l) ? t ? ce(l) : J3(l) : l;
  };
}
const ic = /* @__PURE__ */ er(), sc = /* @__PURE__ */ er(!0);
function er(t = !1) {
  return function(n, i, s, r) {
    let o = n[i];
    if (a9(o) && R1(o) && !R1(s))
      return !1;
    if (!t && (!N0(s) && !a9(s) && (o = I2(o), s = I2(s)), !e2(n) && R1(o) && !R1(s)))
      return o.value = s, !0;
    const l = e2(n) && le(i) ? Number(i) < n.length : $2(n, i), L = Reflect.set(n, i, s, r);
    return n === I2(r) && (l ? z9(s, o) && X3(n, "set", i, s) : X3(n, "add", i, s)), L;
  };
}
function rc(t, e) {
  const n = $2(t, e);
  t[e];
  const i = Reflect.deleteProperty(t, e);
  return i && n && X3(t, "delete", e, void 0), i;
}
function oc(t, e) {
  const n = Reflect.has(t, e);
  return (!O0(e) || !Js.has(e)) && L3(t, "has", e), n;
}
function lc(t) {
  return L3(t, "iterate", e2(t) ? "length" : n9), Reflect.ownKeys(t);
}
const tr = {
  get: XC,
  set: ic,
  deleteProperty: rc,
  has: oc,
  ownKeys: lc
}, nr = {
  get: ec,
  set(t, e) {
    return !0;
  },
  deleteProperty(t, e) {
    return !0;
  }
}, Lc = /* @__PURE__ */ U2({}, tr, {
  get: JC,
  set: sc
}), ac = /* @__PURE__ */ U2({}, nr, {
  get: tc
}), Ce = (t) => t, T8 = (t) => Reflect.getPrototypeOf(t);
function v5(t, e, n = !1, i = !1) {
  t = t.__v_raw;
  const s = I2(t), r = I2(e);
  n || (e !== r && L3(s, "get", e), L3(s, "get", r));
  const { has: o } = T8(s), l = i ? Ce : n ? de : D0;
  if (o.call(s, e))
    return l(t.get(e));
  if (o.call(s, r))
    return l(t.get(r));
  t !== s && t.get(e);
}
function M5(t, e = !1) {
  const n = this.__v_raw, i = I2(n), s = I2(t);
  return e || (t !== s && L3(i, "has", t), L3(i, "has", s)), t === s ? n.has(t) : n.has(t) || n.has(s);
}
function R5(t, e = !1) {
  return t = t.__v_raw, !e && L3(I2(t), "iterate", n9), Reflect.get(t, "size", t);
}
function En(t) {
  t = I2(t);
  const e = I2(this);
  return T8(e).has.call(e, t) || (e.add(t), X3(e, "add", t, t)), this;
}
function In(t, e) {
  e = I2(e);
  const n = I2(this), { has: i, get: s } = T8(n);
  let r = i.call(n, t);
  r || (t = I2(t), r = i.call(n, t));
  const o = s.call(n, t);
  return n.set(t, e), r ? z9(e, o) && X3(n, "set", t, e) : X3(n, "add", t, e), this;
}
function Fn(t) {
  const e = I2(this), { has: n, get: i } = T8(e);
  let s = n.call(e, t);
  s || (t = I2(t), s = n.call(e, t)), i && i.call(e, t);
  const r = e.delete(t);
  return s && X3(e, "delete", t, void 0), r;
}
function On() {
  const t = I2(this), e = t.size !== 0, n = t.clear();
  return e && X3(t, "clear", void 0, void 0), n;
}
function y5(t, e) {
  return function(i, s) {
    const r = this, o = r.__v_raw, l = I2(o), L = e ? Ce : t ? de : D0;
    return !t && L3(l, "iterate", n9), o.forEach((a, C) => i.call(s, L(a), L(C), r));
  };
}
function A5(t, e, n) {
  return function(...i) {
    const s = this.__v_raw, r = I2(s), o = S9(r), l = t === "entries" || t === Symbol.iterator && o, L = t === "keys" && o, a = s[t](...i), C = n ? Ce : e ? de : D0;
    return !e && L3(r, "iterate", L ? l6 : n9), {
      // iterator protocol
      next() {
        const { value: c, done: h } = a.next();
        return h ? { value: c, done: h } : {
          value: l ? [C(c[0]), C(c[1])] : C(c),
          done: h
        };
      },
      // iterable protocol
      [Symbol.iterator]() {
        return this;
      }
    };
  };
}
function v4(t) {
  return function(...e) {
    return t === "delete" ? !1 : this;
  };
}
function Cc() {
  const t = {
    get(r) {
      return v5(this, r);
    },
    get size() {
      return R5(this);
    },
    has: M5,
    add: En,
    set: In,
    delete: Fn,
    clear: On,
    forEach: y5(!1, !1)
  }, e = {
    get(r) {
      return v5(this, r, !1, !0);
    },
    get size() {
      return R5(this);
    },
    has: M5,
    add: En,
    set: In,
    delete: Fn,
    clear: On,
    forEach: y5(!1, !0)
  }, n = {
    get(r) {
      return v5(this, r, !0);
    },
    get size() {
      return R5(this, !0);
    },
    has(r) {
      return M5.call(this, r, !0);
    },
    add: v4(
      "add"
      /* TriggerOpTypes.ADD */
    ),
    set: v4(
      "set"
      /* TriggerOpTypes.SET */
    ),
    delete: v4(
      "delete"
      /* TriggerOpTypes.DELETE */
    ),
    clear: v4(
      "clear"
      /* TriggerOpTypes.CLEAR */
    ),
    forEach: y5(!0, !1)
  }, i = {
    get(r) {
      return v5(this, r, !0, !0);
    },
    get size() {
      return R5(this, !0);
    },
    has(r) {
      return M5.call(this, r, !0);
    },
    add: v4(
      "add"
      /* TriggerOpTypes.ADD */
    ),
    set: v4(
      "set"
      /* TriggerOpTypes.SET */
    ),
    delete: v4(
      "delete"
      /* TriggerOpTypes.DELETE */
    ),
    clear: v4(
      "clear"
      /* TriggerOpTypes.CLEAR */
    ),
    forEach: y5(!0, !0)
  };
  return ["keys", "values", "entries", Symbol.iterator].forEach((r) => {
    t[r] = A5(r, !1, !1), n[r] = A5(r, !0, !1), e[r] = A5(r, !1, !0), i[r] = A5(r, !0, !0);
  }), [
    t,
    n,
    e,
    i
  ];
}
const [cc, uc, hc, dc] = /* @__PURE__ */ Cc();
function S8(t, e) {
  const n = e ? t ? dc : hc : t ? uc : cc;
  return (i, s, r) => s === "__v_isReactive" ? !t : s === "__v_isReadonly" ? t : s === "__v_raw" ? i : Reflect.get($2(n, s) && s in i ? n : i, s, r);
}
const gc = {
  get: /* @__PURE__ */ S8(!1, !1)
}, fc = {
  get: /* @__PURE__ */ S8(!1, !0)
}, pc = {
  get: /* @__PURE__ */ S8(!0, !1)
}, mc = {
  get: /* @__PURE__ */ S8(!0, !0)
}, ir = /* @__PURE__ */ new WeakMap(), sr = /* @__PURE__ */ new WeakMap(), rr = /* @__PURE__ */ new WeakMap(), or = /* @__PURE__ */ new WeakMap();
function wc(t) {
  switch (t) {
    case "Object":
    case "Array":
      return 1;
    case "Map":
    case "Set":
    case "WeakMap":
    case "WeakSet":
      return 2;
    default:
      return 0;
  }
}
function xc(t) {
  return t.__v_skip || !Object.isExtensible(t) ? 0 : wc(UC(t));
}
function J3(t) {
  return a9(t) ? t : b8(t, !1, tr, gc, ir);
}
function lr(t) {
  return b8(t, !1, Lc, fc, sr);
}
function ce(t) {
  return b8(t, !0, nr, pc, rr);
}
function _c(t) {
  return b8(t, !0, ac, mc, or);
}
function b8(t, e, n, i, s) {
  if (!B2(t) || t.__v_raw && !(e && t.__v_isReactive))
    return t;
  const r = s.get(t);
  if (r)
    return r;
  const o = xc(t);
  if (o === 0)
    return t;
  const l = new Proxy(t, o === 2 ? i : n);
  return s.set(t, l), l;
}
function u4(t) {
  return a9(t) ? u4(t.__v_raw) : !!(t && t.__v_isReactive);
}
function a9(t) {
  return !!(t && t.__v_isReadonly);
}
function N0(t) {
  return !!(t && t.__v_isShallow);
}
function ue(t) {
  return u4(t) || a9(t);
}
function I2(t) {
  const e = t && t.__v_raw;
  return e ? I2(e) : t;
}
function he(t) {
  return e8(t, "__v_skip", !0), t;
}
const D0 = (t) => B2(t) ? J3(t) : t, de = (t) => B2(t) ? ce(t) : t;
function ge(t) {
  F4 && I3 && (t = I2(t), Xs(t.dep || (t.dep = ae())));
}
function E8(t, e) {
  t = I2(t), t.dep && L6(t.dep);
}
function R1(t) {
  return !!(t && t.__v_isRef === !0);
}
function R2(t) {
  return ar(t, !1);
}
function Lr(t) {
  return ar(t, !0);
}
function ar(t, e) {
  return R1(t) ? t : new vc(t, e);
}
class vc {
  constructor(e, n) {
    this.__v_isShallow = n, this.dep = void 0, this.__v_isRef = !0, this._rawValue = n ? e : I2(e), this._value = n ? e : D0(e);
  }
  get value() {
    return ge(this), this._value;
  }
  set value(e) {
    const n = this.__v_isShallow || N0(e) || a9(e);
    e = n ? e : I2(e), z9(e, this._rawValue) && (this._rawValue = e, this._value = n ? e : D0(e), E8(this));
  }
}
function Mc(t) {
  E8(t);
}
function O(t) {
  return R1(t) ? t.value : t;
}
const Rc = {
  get: (t, e, n) => O(Reflect.get(t, e, n)),
  set: (t, e, n, i) => {
    const s = t[e];
    return R1(s) && !R1(n) ? (s.value = n, !0) : Reflect.set(t, e, n, i);
  }
};
function fe(t) {
  return u4(t) ? t : new Proxy(t, Rc);
}
class yc {
  constructor(e) {
    this.dep = void 0, this.__v_isRef = !0;
    const { get: n, set: i } = e(() => ge(this), () => E8(this));
    this._get = n, this._set = i;
  }
  get value() {
    return this._get();
  }
  set value(e) {
    this._set(e);
  }
}
function Ac(t) {
  return new yc(t);
}
function g9(t) {
  const e = e2(t) ? new Array(t.length) : {};
  for (const n in t)
    e[n] = Cr(t, n);
  return e;
}
class Zc {
  constructor(e, n, i) {
    this._object = e, this._key = n, this._defaultValue = i, this.__v_isRef = !0;
  }
  get value() {
    const e = this._object[this._key];
    return e === void 0 ? this._defaultValue : e;
  }
  set value(e) {
    this._object[this._key] = e;
  }
}
function Cr(t, e, n) {
  const i = t[e];
  return R1(i) ? i : new Zc(t, e, n);
}
var cr;
class kc {
  constructor(e, n, i, s) {
    this._setter = n, this.dep = void 0, this.__v_isRef = !0, this[cr] = !1, this._dirty = !0, this.effect = new X0(e, () => {
      this._dirty || (this._dirty = !0, E8(this));
    }), this.effect.computed = this, this.effect.active = this._cacheable = !s, this.__v_isReadonly = i;
  }
  get value() {
    const e = I2(this);
    return ge(e), (e._dirty || !e._cacheable) && (e._dirty = !1, e._value = e.effect.run()), e._value;
  }
  set value(e) {
    this._setter(e);
  }
}
cr = "__v_isReadonly";
function Tc(t, e, n = !1) {
  let i, s;
  const r = p2(t);
  return r ? (i = t, s = o3) : (i = t.get, s = t.set), new kc(i, s, r || !s, n);
}
function Sc(t, ...e) {
}
function j3(t, e, n, i) {
  let s;
  try {
    s = i ? t(...i) : t();
  } catch (r) {
    f9(r, e, n);
  }
  return s;
}
function l3(t, e, n, i) {
  if (p2(t)) {
    const r = j3(t, e, n, i);
    return r && A8(r) && r.catch((o) => {
      f9(o, e, n);
    }), r;
  }
  const s = [];
  for (let r = 0; r < t.length; r++)
    s.push(l3(t[r], e, n, i));
  return s;
}
function f9(t, e, n, i = !0) {
  const s = e ? e.vnode : null;
  if (e) {
    let r = e.parent;
    const o = e.proxy, l = n;
    for (; r; ) {
      const a = r.ec;
      if (a) {
        for (let C = 0; C < a.length; C++)
          if (a[C](t, o, l) === !1)
            return;
      }
      r = r.parent;
    }
    const L = e.appContext.config.errorHandler;
    if (L) {
      j3(L, null, 10, [t, o, l]);
      return;
    }
  }
  bc(t, n, s, i);
}
function bc(t, e, n, i = !0) {
  console.error(t);
}
let P0 = !1, a6 = !1;
const F1 = [];
let H3 = 0;
const I9 = [];
let C4 = null, Y4 = 0;
const ur = /* @__PURE__ */ Promise.resolve();
let pe = null;
function P4(t) {
  const e = pe || ur;
  return t ? e.then(this ? t.bind(this) : t) : e;
}
function Ec(t) {
  let e = H3 + 1, n = F1.length;
  for (; e < n; ) {
    const i = e + n >>> 1;
    B0(F1[i]) < t ? e = i + 1 : n = i;
  }
  return e;
}
function I8(t) {
  (!F1.length || !F1.includes(t, P0 && t.allowRecurse ? H3 + 1 : H3)) && (t.id == null ? F1.push(t) : F1.splice(Ec(t.id), 0, t), hr());
}
function hr() {
  !P0 && !a6 && (a6 = !0, pe = ur.then(dr));
}
function Ic(t) {
  const e = F1.indexOf(t);
  e > H3 && F1.splice(e, 1);
}
function me(t) {
  e2(t) ? I9.push(...t) : (!C4 || !C4.includes(t, t.allowRecurse ? Y4 + 1 : Y4)) && I9.push(t), hr();
}
function Nn(t, e = P0 ? H3 + 1 : 0) {
  for (; e < F1.length; e++) {
    const n = F1[e];
    n && n.pre && (F1.splice(e, 1), e--, n());
  }
}
function t8(t) {
  if (I9.length) {
    const e = [...new Set(I9)];
    if (I9.length = 0, C4) {
      C4.push(...e);
      return;
    }
    for (C4 = e, C4.sort((n, i) => B0(n) - B0(i)), Y4 = 0; Y4 < C4.length; Y4++)
      C4[Y4]();
    C4 = null, Y4 = 0;
  }
}
const B0 = (t) => t.id == null ? 1 / 0 : t.id, Fc = (t, e) => {
  const n = B0(t) - B0(e);
  if (n === 0) {
    if (t.pre && !e.pre)
      return -1;
    if (e.pre && !t.pre)
      return 1;
  }
  return n;
};
function dr(t) {
  a6 = !1, P0 = !0, F1.sort(Fc);
  const e = o3;
  try {
    for (H3 = 0; H3 < F1.length; H3++) {
      const n = F1[H3];
      n && n.active !== !1 && j3(
        n,
        null,
        14
        /* ErrorCodes.SCHEDULER */
      );
    }
  } finally {
    H3 = 0, F1.length = 0, t8(), P0 = !1, pe = null, (F1.length || I9.length) && dr();
  }
}
let A9, Z5 = [];
function gr(t, e) {
  var n, i;
  A9 = t, A9 ? (A9.enabled = !0, Z5.forEach(({ event: s, args: r }) => A9.emit(s, ...r)), Z5 = []) : /* handle late devtools injection - only do this if we are in an actual */ /* browser environment to avoid the timer handle stalling test runner exit */ /* (#4815) */ typeof window < "u" && // some envs mock window but not fully
  window.HTMLElement && // also exclude jsdom
  !(!((i = (n = window.navigator) === null || n === void 0 ? void 0 : n.userAgent) === null || i === void 0) && i.includes("jsdom")) ? ((e.__VUE_DEVTOOLS_HOOK_REPLAY__ = e.__VUE_DEVTOOLS_HOOK_REPLAY__ || []).push((r) => {
    gr(r, e);
  }), setTimeout(() => {
    A9 || (e.__VUE_DEVTOOLS_HOOK_REPLAY__ = null, Z5 = []);
  }, 3e3)) : Z5 = [];
}
function Oc(t, e, ...n) {
}
const we = {
  MODE: 2
};
function Nc(t) {
  U2(we, t);
}
function Dn(t, e) {
  const n = e && e.type.compatConfig;
  return n && t in n ? n[t] : we[t];
}
function Y2(t, e, n = !1) {
  if (!n && e && e.type.__isBuiltIn)
    return !1;
  const i = Dn("MODE", e) || 2, s = Dn(t, e);
  return (p2(i) ? i(e && e.type) : i) === 2 ? s !== !1 : s === !0 || s === "suppress-warning";
}
function T1(t, e, ...n) {
  if (!Y2(t, e))
    throw new Error(`${t} compat has been disabled.`);
}
function g4(t, e, ...n) {
  return Y2(t, e);
}
function F8(t, e, ...n) {
  return Y2(t, e);
}
const C6 = /* @__PURE__ */ new WeakMap();
function xe(t) {
  let e = C6.get(t);
  return e || C6.set(t, e = /* @__PURE__ */ Object.create(null)), e;
}
function _e(t, e, n) {
  if (e2(e))
    e.forEach((i) => _e(t, i, n));
  else {
    e.startsWith("hook:") ? T1("INSTANCE_EVENT_HOOKS", t, e) : T1("INSTANCE_EVENT_EMITTER", t);
    const i = xe(t);
    (i[e] || (i[e] = [])).push(n);
  }
  return t.proxy;
}
function Dc(t, e, n) {
  const i = (...s) => {
    ve(t, e, i), n.call(t.proxy, ...s);
  };
  return i.fn = n, _e(t, e, i), t.proxy;
}
function ve(t, e, n) {
  T1("INSTANCE_EVENT_EMITTER", t);
  const i = t.proxy;
  if (!e)
    return C6.set(t, /* @__PURE__ */ Object.create(null)), i;
  if (e2(e))
    return e.forEach((o) => ve(t, o, n)), i;
  const s = xe(t), r = s[e];
  return r ? n ? (s[e] = r.filter((o) => !(o === n || o.fn === n)), i) : (s[e] = void 0, i) : i;
}
function Pc(t, e, n) {
  const i = xe(t)[e];
  return i && l3(i.map((s) => s.bind(t.proxy)), t, 6, n), t.proxy;
}
const O8 = "onModelCompat:";
function Bc(t) {
  const { type: e, shapeFlag: n, props: i, dynamicProps: s } = t, r = e;
  if (n & 6 && i && "modelValue" in i) {
    if (!Y2(
      "COMPONENT_V_MODEL",
      // this is a special case where we want to use the vnode component's
      // compat config instead of the current rendering instance (which is the
      // parent of the component that exposes v-model)
      { type: e }
    ))
      return;
    const o = r.model || {};
    fr(o, r.mixins);
    const { prop: l = "value", event: L = "input" } = o;
    l !== "modelValue" && (i[l] = i.modelValue, delete i.modelValue), s && (s[s.indexOf("modelValue")] = l), i[O8 + L] = i["onUpdate:modelValue"], delete i["onUpdate:modelValue"];
  }
}
function fr(t, e) {
  e && e.forEach((n) => {
    n.model && U2(t, n.model), n.mixins && fr(t, n.mixins);
  });
}
function zc(t, e, n) {
  if (!Y2("COMPONENT_V_MODEL", t))
    return;
  const i = t.vnode.props, s = i && i[O8 + e];
  s && j3(s, t, 6, n);
}
function Uc(t, e, ...n) {
  if (t.isUnmounted)
    return;
  const i = t.vnode.props || X2;
  let s = n;
  const r = e.startsWith("update:"), o = r && e.slice(7);
  if (o && o in i) {
    const C = `${o === "modelValue" ? "model" : o}Modifiers`, { number: c, trim: h } = i[C] || X2;
    h && (s = n.map((d) => r1(d) ? d.trim() : d)), c && (s = n.map(Q3));
  }
  let l, L = i[l = E9(e)] || // also try camelCase event handler (#2249)
  i[l = E9(G1(e))];
  !L && r && (L = i[l = E9(W1(e))]), L && l3(L, t, 6, s);
  const a = i[l + "Once"];
  if (a) {
    if (!t.emitted)
      t.emitted = {};
    else if (t.emitted[l])
      return;
    t.emitted[l] = !0, l3(a, t, 6, s);
  }
  return zc(t, e, s), Pc(t, e, s);
}
function pr(t, e, n = !1) {
  const i = e.emitsCache, s = i.get(t);
  if (s !== void 0)
    return s;
  const r = t.emits;
  let o = {}, l = !1;
  if (!p2(t)) {
    const L = (a) => {
      const C = pr(a, e, !0);
      C && (l = !0, U2(o, C));
    };
    !n && e.mixins.length && e.mixins.forEach(L), t.extends && L(t.extends), t.mixins && t.mixins.forEach(L);
  }
  return !r && !l ? (B2(t) && i.set(t, null), null) : (e2(r) ? r.forEach((L) => o[L] = null) : U2(o, r), B2(t) && i.set(t, o), o);
}
function N8(t, e) {
  return !t || !w4(e) ? !1 : e.startsWith(O8) ? !0 : (e = e.slice(2).replace(/Once$/, ""), $2(t, e[0].toLowerCase() + e.slice(1)) || $2(t, W1(e)) || $2(t, e));
}
let p1 = null, F9 = null;
function z0(t) {
  const e = p1;
  return p1 = t, F9 = t && t.type.__scopeId || null, F9 || (F9 = t && t.type._scopeId || null), e;
}
function r4(t) {
  F9 = t;
}
function o4() {
  F9 = null;
}
const Wc = (t) => h3;
function h3(t, e = p1, n) {
  if (!e || t._n)
    return t;
  const i = (...s) => {
    i._d && p6(-1);
    const r = z0(e);
    let o;
    try {
      o = t(...s);
    } finally {
      z0(r), i._d && p6(1);
    }
    return o;
  };
  return i._n = !0, i._c = !0, i._d = !0, n && (i._ns = !0), i;
}
function j5(t) {
  const { type: e, vnode: n, proxy: i, withProxy: s, props: r, propsOptions: [o], slots: l, attrs: L, emit: a, render: C, renderCache: c, data: h, setupState: d, ctx: f, inheritAttrs: x } = t;
  let k, m;
  const g = z0(t);
  try {
    if (n.shapeFlag & 4) {
      const Z = s || i;
      k = g3(C.call(Z, Z, c, r, d, h, f)), m = L;
    } else {
      const Z = e;
      k = g3(Z.length > 1 ? Z(r, { attrs: L, slots: l, emit: a }) : Z(
        r,
        null
        /* we know it doesn't need it */
      )), m = e.props ? L : $c(L);
    }
  } catch (Z) {
    R0.length = 0, f9(
      Z,
      t,
      1
      /* ErrorCodes.RENDER_FUNCTION */
    ), k = N(S1);
  }
  let w = k;
  if (m && x !== !1) {
    const Z = Object.keys(m), { shapeFlag: b } = w;
    Z.length && b & 7 && (o && Z.some(re) && (m = Vc(m, o)), w = T3(w, m));
  }
  if (Y2("INSTANCE_ATTRS_CLASS_STYLE", t) && n.shapeFlag & 4 && w.shapeFlag & 7) {
    const { class: Z, style: b } = n.props || {};
    (Z || b) && (w = T3(w, {
      class: Z,
      style: b
    }));
  }
  return n.dirs && (w = T3(w), w.dirs = w.dirs ? w.dirs.concat(n.dirs) : n.dirs), n.transition && (w.transition = n.transition), k = w, z0(g), k;
}
function Hc(t) {
  let e;
  for (let n = 0; n < t.length; n++) {
    const i = t[n];
    if (_3(i)) {
      if (i.type !== S1 || i.children === "v-if") {
        if (e)
          return;
        e = i;
      }
    } else
      return;
  }
  return e;
}
const $c = (t) => {
  let e;
  for (const n in t)
    (n === "class" || n === "style" || w4(n)) && ((e || (e = {}))[n] = t[n]);
  return e;
}, Vc = (t, e) => {
  const n = {};
  for (const i in t)
    (!re(i) || !(i.slice(9) in e)) && (n[i] = t[i]);
  return n;
};
function Gc(t, e, n) {
  const { props: i, children: s, component: r } = t, { props: o, children: l, patchFlag: L } = e, a = r.emitsOptions;
  if (e.dirs || e.transition)
    return !0;
  if (n && L >= 0) {
    if (L & 1024)
      return !0;
    if (L & 16)
      return i ? Pn(i, o, a) : !!o;
    if (L & 8) {
      const C = e.dynamicProps;
      for (let c = 0; c < C.length; c++) {
        const h = C[c];
        if (o[h] !== i[h] && !N8(a, h))
          return !0;
      }
    }
  } else
    return (s || l) && (!l || !l.$stable) ? !0 : i === o ? !1 : i ? o ? Pn(i, o, a) : !0 : !!o;
  return !1;
}
function Pn(t, e, n) {
  const i = Object.keys(e);
  if (i.length !== Object.keys(t).length)
    return !0;
  for (let s = 0; s < i.length; s++) {
    const r = i[s];
    if (e[r] !== t[r] && !N8(n, r))
      return !0;
  }
  return !1;
}
function Me({ vnode: t, parent: e }, n) {
  for (; e && e.subTree === t; )
    (t = e.vnode).el = n, e = e.parent;
}
const mr = (t) => t.__isSuspense, jc = {
  name: "Suspense",
  // In order to make Suspense tree-shakable, we need to avoid importing it
  // directly in the renderer. The renderer checks for the __isSuspense flag
  // on a vnode's type and calls the `process` method, passing in renderer
  // internals.
  __isSuspense: !0,
  process(t, e, n, i, s, r, o, l, L, a) {
    t == null ? Kc(e, n, i, s, r, o, l, L, a) : Yc(t, e, n, i, s, o, l, L, a);
  },
  hydrate: Qc,
  create: Re,
  normalize: Xc
}, qc = jc;
function U0(t, e) {
  const n = t.props && t.props[e];
  p2(n) && n();
}
function Kc(t, e, n, i, s, r, o, l, L) {
  const { p: a, o: { createElement: C } } = L, c = C("div"), h = t.suspense = Re(t, s, i, e, c, n, r, o, l, L);
  a(null, h.pendingBranch = t.ssContent, c, null, i, h, r, o), h.deps > 0 ? (U0(t, "onPending"), U0(t, "onFallback"), a(
    null,
    t.ssFallback,
    e,
    n,
    i,
    null,
    // fallback tree will not have suspense context
    r,
    o
  ), O9(h, t.ssFallback)) : h.resolve();
}
function Yc(t, e, n, i, s, r, o, l, { p: L, um: a, o: { createElement: C } }) {
  const c = e.suspense = t.suspense;
  c.vnode = e, e.el = t.el;
  const h = e.ssContent, d = e.ssFallback, { activeBranch: f, pendingBranch: x, isInFallback: k, isHydrating: m } = c;
  if (x)
    c.pendingBranch = h, $3(h, x) ? (L(x, h, c.hiddenContainer, null, s, c, r, o, l), c.deps <= 0 ? c.resolve() : k && (L(
      f,
      d,
      n,
      i,
      s,
      null,
      // fallback tree will not have suspense context
      r,
      o,
      l
    ), O9(c, d))) : (c.pendingId++, m ? (c.isHydrating = !1, c.activeBranch = x) : a(x, s, c), c.deps = 0, c.effects.length = 0, c.hiddenContainer = C("div"), k ? (L(null, h, c.hiddenContainer, null, s, c, r, o, l), c.deps <= 0 ? c.resolve() : (L(
      f,
      d,
      n,
      i,
      s,
      null,
      // fallback tree will not have suspense context
      r,
      o,
      l
    ), O9(c, d))) : f && $3(h, f) ? (L(f, h, n, i, s, c, r, o, l), c.resolve(!0)) : (L(null, h, c.hiddenContainer, null, s, c, r, o, l), c.deps <= 0 && c.resolve()));
  else if (f && $3(h, f))
    L(f, h, n, i, s, c, r, o, l), O9(c, h);
  else if (U0(e, "onPending"), c.pendingBranch = h, c.pendingId++, L(null, h, c.hiddenContainer, null, s, c, r, o, l), c.deps <= 0)
    c.resolve();
  else {
    const { timeout: g, pendingId: w } = c;
    g > 0 ? setTimeout(() => {
      c.pendingId === w && c.fallback(d);
    }, g) : g === 0 && c.fallback(d);
  }
}
function Re(t, e, n, i, s, r, o, l, L, a, C = !1) {
  const { p: c, m: h, um: d, n: f, o: { parentNode: x, remove: k } } = a, m = Q3(t.props && t.props.timeout), g = {
    vnode: t,
    parent: e,
    parentComponent: n,
    isSVG: o,
    container: i,
    hiddenContainer: s,
    anchor: r,
    deps: 0,
    pendingId: 0,
    timeout: typeof m == "number" ? m : -1,
    activeBranch: null,
    pendingBranch: null,
    isInFallback: !0,
    isHydrating: C,
    isUnmounted: !1,
    effects: [],
    resolve(w = !1) {
      const { vnode: Z, activeBranch: b, pendingBranch: z, pendingId: K, effects: E, parentComponent: L2, container: t2 } = g;
      if (g.isHydrating)
        g.isHydrating = !1;
      else if (!w) {
        const m2 = b && z.transition && z.transition.mode === "out-in";
        m2 && (b.transition.afterLeave = () => {
          K === g.pendingId && h(
            z,
            t2,
            P,
            0
            /* MoveType.ENTER */
          );
        });
        let { anchor: P } = g;
        b && (P = f(b), d(b, L2, g, !0)), m2 || h(
          z,
          t2,
          P,
          0
          /* MoveType.ENTER */
        );
      }
      O9(g, z), g.pendingBranch = null, g.isInFallback = !1;
      let u2 = g.parent, N2 = !1;
      for (; u2; ) {
        if (u2.pendingBranch) {
          u2.effects.push(...E), N2 = !0;
          break;
        }
        u2 = u2.parent;
      }
      N2 || me(E), g.effects = [], U0(Z, "onResolve");
    },
    fallback(w) {
      if (!g.pendingBranch)
        return;
      const { vnode: Z, activeBranch: b, parentComponent: z, container: K, isSVG: E } = g;
      U0(Z, "onFallback");
      const L2 = f(b), t2 = () => {
        g.isInFallback && (c(
          null,
          w,
          K,
          L2,
          z,
          null,
          // fallback tree will not have suspense context
          E,
          l,
          L
        ), O9(g, w));
      }, u2 = w.transition && w.transition.mode === "out-in";
      u2 && (b.transition.afterLeave = t2), g.isInFallback = !0, d(
        b,
        z,
        null,
        // no suspense so unmount hooks fire now
        !0
        // shouldRemove
      ), u2 || t2();
    },
    move(w, Z, b) {
      g.activeBranch && h(g.activeBranch, w, Z, b), g.container = w;
    },
    next() {
      return g.activeBranch && f(g.activeBranch);
    },
    registerDep(w, Z) {
      const b = !!g.pendingBranch;
      b && g.deps++;
      const z = w.vnode.el;
      w.asyncDep.catch((K) => {
        f9(
          K,
          w,
          0
          /* ErrorCodes.SETUP_FUNCTION */
        );
      }).then((K) => {
        if (w.isUnmounted || g.isUnmounted || g.pendingId !== w.suspenseId)
          return;
        w.asyncResolved = !0;
        const { vnode: E } = w;
        m6(w, K, !1), z && (E.el = z);
        const L2 = !z && w.subTree.el;
        Z(
          w,
          E,
          // component may have been moved before resolve.
          // if this is not a hydration, instance.subTree will be the comment
          // placeholder.
          x(z || w.subTree.el),
          // anchor will not be used if this is hydration, so only need to
          // consider the comment placeholder case.
          z ? null : f(w.subTree),
          g,
          o,
          L
        ), L2 && k(L2), Me(w, E.el), b && --g.deps === 0 && g.resolve();
      });
    },
    unmount(w, Z) {
      g.isUnmounted = !0, g.activeBranch && d(g.activeBranch, n, w, Z), g.pendingBranch && d(g.pendingBranch, n, w, Z);
    }
  };
  return g;
}
function Qc(t, e, n, i, s, r, o, l, L) {
  const a = e.suspense = Re(
    e,
    i,
    n,
    t.parentNode,
    document.createElement("div"),
    null,
    s,
    r,
    o,
    l,
    !0
    /* hydrating */
  ), C = L(t, a.pendingBranch = e.ssContent, n, a, r, o);
  return a.deps === 0 && a.resolve(), C;
}
function Xc(t) {
  const { shapeFlag: e, children: n } = t, i = e & 32;
  t.ssContent = Bn(i ? n.default : n), t.ssFallback = i ? Bn(n.fallback) : N(S1);
}
function Bn(t) {
  let e;
  if (p2(t)) {
    const n = u9 && t._c;
    n && (t._d = !1, T()), t = t(), n && (t._d = !0, e = s3, Lo());
  }
  return e2(t) && (t = Hc(t)), t = g3(t), e && !t.dynamicChildren && (t.dynamicChildren = e.filter((n) => n !== t)), t;
}
function wr(t, e) {
  e && e.pendingBranch ? e2(t) ? e.effects.push(...t) : e.effects.push(t) : me(t);
}
function O9(t, e) {
  t.activeBranch = e;
  const { vnode: n, parentComponent: i } = t, s = n.el = e.el;
  i && i.subTree === n && (i.vnode.el = s, Me(i, s));
}
function a3(t, e) {
  if (_1) {
    let n = _1.provides;
    const i = _1.parent && _1.parent.provides;
    i === n && (n = _1.provides = Object.create(i)), n[t] = e;
  }
}
function u1(t, e, n = !1) {
  const i = _1 || p1;
  if (i) {
    const s = i.parent == null ? i.vnode.appContext && i.vnode.appContext.provides : i.parent.provides;
    if (s && t in s)
      return s[t];
    if (arguments.length > 1)
      return n && p2(e) ? e.call(i.proxy) : e;
  }
}
function x3(t, e) {
  return J0(t, null, e);
}
function xr(t, e) {
  return J0(t, null, { flush: "post" });
}
function Jc(t, e) {
  return J0(t, null, { flush: "sync" });
}
const k5 = {};
function m3(t, e, n) {
  return J0(t, e, n);
}
function J0(t, e, { immediate: n, deep: i, flush: s, onTrack: r, onTrigger: o } = X2) {
  const l = _1;
  let L, a = !1, C = !1;
  if (R1(t) ? (L = () => t.value, a = N0(t)) : u4(t) ? (L = () => t, i = !0) : e2(t) ? (C = !0, a = t.some((w) => u4(w) || N0(w)), L = () => t.map((w) => {
    if (R1(w))
      return w.value;
    if (u4(w))
      return T4(w);
    if (p2(w))
      return j3(
        w,
        l,
        2
        /* ErrorCodes.WATCH_GETTER */
      );
  })) : p2(t) ? e ? L = () => j3(
    t,
    l,
    2
    /* ErrorCodes.WATCH_GETTER */
  ) : L = () => {
    if (!(l && l.isUnmounted))
      return c && c(), l3(t, l, 3, [h]);
  } : L = o3, e && !i) {
    const w = L;
    L = () => {
      const Z = w();
      return e2(Z) && F8("WATCH_ARRAY", l) && T4(Z), Z;
    };
  }
  if (e && i) {
    const w = L;
    L = () => T4(w());
  }
  let c, h = (w) => {
    c = m.onStop = () => {
      j3(
        w,
        l,
        4
        /* ErrorCodes.WATCH_CLEANUP */
      );
    };
  }, d;
  if (W9)
    if (h = o3, e ? n && l3(e, l, 3, [
      L(),
      C ? [] : void 0,
      h
    ]) : L(), s === "sync") {
      const w = po();
      d = w.__watcherHandles || (w.__watcherHandles = []);
    } else
      return o3;
  let f = C ? new Array(t.length).fill(k5) : k5;
  const x = () => {
    if (m.active)
      if (e) {
        const w = m.run();
        (i || a || (C ? w.some((Z, b) => z9(Z, f[b])) : z9(w, f)) || e2(w) && Y2("WATCH_ARRAY", l)) && (c && c(), l3(e, l, 3, [
          w,
          // pass undefined as the old value when it's changed for the first time
          f === k5 ? void 0 : C && f[0] === k5 ? [] : f,
          h
        ]), f = w);
      } else
        m.run();
  };
  x.allowRecurse = !!e;
  let k;
  s === "sync" ? k = x : s === "post" ? k = () => g1(x, l && l.suspense) : (x.pre = !0, l && (x.id = l.uid), k = () => I8(x));
  const m = new X0(L, k);
  e ? n ? x() : f = m.run() : s === "post" ? g1(m.run.bind(m), l && l.suspense) : m.run();
  const g = () => {
    m.stop(), l && l.scope && oe(l.scope.effects, m);
  };
  return d && d.push(g), g;
}
function eu(t, e, n) {
  const i = this.proxy, s = r1(t) ? t.includes(".") ? _r(i, t) : () => i[t] : t.bind(i, i);
  let r;
  p2(e) ? r = e : (r = e.handler, n = e);
  const o = _1;
  B4(this);
  const l = J0(s, r.bind(i), n);
  return o ? B4(o) : O4(), l;
}
function _r(t, e) {
  const n = e.split(".");
  return () => {
    let i = t;
    for (let s = 0; s < n.length && i; s++)
      i = i[n[s]];
    return i;
  };
}
function T4(t, e) {
  if (!B2(t) || t.__v_skip || (e = e || /* @__PURE__ */ new Set(), e.has(t)))
    return t;
  if (e.add(t), R1(t))
    T4(t.value, e);
  else if (e2(t))
    for (let n = 0; n < t.length; n++)
      T4(t[n], e);
  else if (d9(t) || S9(t))
    t.forEach((n) => {
      T4(n, e);
    });
  else if (J5(t))
    for (const n in t)
      T4(t[n], e);
  return t;
}
function ye() {
  const t = {
    isMounted: !1,
    isLeaving: !1,
    isUnmounting: !1,
    leavingVNodes: /* @__PURE__ */ new Map()
  };
  return s1(() => {
    t.isMounted = !0;
  }), W0(() => {
    t.isUnmounting = !0;
  }), t;
}
const y3 = [Function, Array], vr = {
  name: "BaseTransition",
  props: {
    mode: String,
    appear: Boolean,
    persisted: Boolean,
    // enter
    onBeforeEnter: y3,
    onEnter: y3,
    onAfterEnter: y3,
    onEnterCancelled: y3,
    // leave
    onBeforeLeave: y3,
    onLeave: y3,
    onAfterLeave: y3,
    onLeaveCancelled: y3,
    // appear
    onBeforeAppear: y3,
    onAppear: y3,
    onAfterAppear: y3,
    onAppearCancelled: y3
  },
  setup(t, { slots: e }) {
    const n = l4(), i = ye();
    let s;
    return () => {
      const r = e.default && D8(e.default(), !0);
      if (!r || !r.length)
        return;
      let o = r[0];
      if (r.length > 1) {
        for (const x of r)
          if (x.type !== S1) {
            o = x;
            break;
          }
      }
      const l = I2(t), { mode: L } = l;
      if (i.isLeaving)
        return M7(o);
      const a = zn(o);
      if (!a)
        return M7(o);
      const C = U9(a, l, i, n);
      C9(a, C);
      const c = n.subTree, h = c && zn(c);
      let d = !1;
      const { getTransitionKey: f } = a.type;
      if (f) {
        const x = f();
        s === void 0 ? s = x : x !== s && (s = x, d = !0);
      }
      if (h && h.type !== S1 && (!$3(a, h) || d)) {
        const x = U9(h, l, i, n);
        if (C9(h, x), L === "out-in")
          return i.isLeaving = !0, x.afterLeave = () => {
            i.isLeaving = !1, n.update.active !== !1 && n.update();
          }, M7(o);
        L === "in-out" && a.type !== S1 && (x.delayLeave = (k, m, g) => {
          const w = Mr(i, h);
          w[String(h.key)] = h, k._leaveCb = () => {
            m(), k._leaveCb = void 0, delete C.delayedLeave;
          }, C.delayedLeave = g;
        });
      }
      return o;
    };
  }
};
vr.__isBuiltIn = !0;
const Ae = vr;
function Mr(t, e) {
  const { leavingVNodes: n } = t;
  let i = n.get(e.type);
  return i || (i = /* @__PURE__ */ Object.create(null), n.set(e.type, i)), i;
}
function U9(t, e, n, i) {
  const { appear: s, mode: r, persisted: o = !1, onBeforeEnter: l, onEnter: L, onAfterEnter: a, onEnterCancelled: C, onBeforeLeave: c, onLeave: h, onAfterLeave: d, onLeaveCancelled: f, onBeforeAppear: x, onAppear: k, onAfterAppear: m, onAppearCancelled: g } = e, w = String(t.key), Z = Mr(n, t), b = (E, L2) => {
    E && l3(E, i, 9, L2);
  }, z = (E, L2) => {
    const t2 = L2[1];
    b(E, L2), e2(E) ? E.every((u2) => u2.length <= 1) && t2() : E.length <= 1 && t2();
  }, K = {
    mode: r,
    persisted: o,
    beforeEnter(E) {
      let L2 = l;
      if (!n.isMounted)
        if (s)
          L2 = x || l;
        else
          return;
      E._leaveCb && E._leaveCb(
        !0
        /* cancelled */
      );
      const t2 = Z[w];
      t2 && $3(t, t2) && t2.el._leaveCb && t2.el._leaveCb(), b(L2, [E]);
    },
    enter(E) {
      let L2 = L, t2 = a, u2 = C;
      if (!n.isMounted)
        if (s)
          L2 = k || L, t2 = m || a, u2 = g || C;
        else
          return;
      let N2 = !1;
      const m2 = E._enterCb = (P) => {
        N2 || (N2 = !0, P ? b(u2, [E]) : b(t2, [E]), K.delayedLeave && K.delayedLeave(), E._enterCb = void 0);
      };
      L2 ? z(L2, [E, m2]) : m2();
    },
    leave(E, L2) {
      const t2 = String(t.key);
      if (E._enterCb && E._enterCb(
        !0
        /* cancelled */
      ), n.isUnmounting)
        return L2();
      b(c, [E]);
      let u2 = !1;
      const N2 = E._leaveCb = (m2) => {
        u2 || (u2 = !0, L2(), m2 ? b(f, [E]) : b(d, [E]), E._leaveCb = void 0, Z[t2] === t && delete Z[t2]);
      };
      Z[t2] = t, h ? z(h, [E, N2]) : N2();
    },
    clone(E) {
      return U9(E, e, n, i);
    }
  };
  return K;
}
function M7(t) {
  if (e5(t))
    return t = T3(t), t.children = null, t;
}
function zn(t) {
  return e5(t) ? t.children ? t.children[0] : void 0 : t;
}
function C9(t, e) {
  t.shapeFlag & 6 && t.component ? C9(t.component.subTree, e) : t.shapeFlag & 128 ? (t.ssContent.transition = e.clone(t.ssContent), t.ssFallback.transition = e.clone(t.ssFallback)) : t.transition = e;
}
function D8(t, e = !1, n) {
  let i = [], s = 0;
  for (let r = 0; r < t.length; r++) {
    let o = t[r];
    const l = n == null ? o.key : String(n) + String(o.key != null ? o.key : r);
    o.type === P2 ? (o.patchFlag & 128 && s++, i = i.concat(D8(o.children, e, l))) : (e || o.type !== S1) && i.push(l != null ? T3(o, { key: l }) : o);
  }
  if (s > 1)
    for (let r = 0; r < i.length; r++)
      i[r].patchFlag = -2;
  return i;
}
function q2(t) {
  return p2(t) ? { setup: t, name: t.name } : t;
}
const i9 = (t) => !!t.type.__asyncLoader;
function v0(t) {
  p2(t) && (t = { loader: t });
  const {
    loader: e,
    loadingComponent: n,
    errorComponent: i,
    delay: s = 200,
    timeout: r,
    // undefined = never times out
    suspensible: o = !0,
    onError: l
  } = t;
  let L = null, a, C = 0;
  const c = () => (C++, L = null, h()), h = () => {
    let d;
    return L || (d = L = e().catch((f) => {
      if (f = f instanceof Error ? f : new Error(String(f)), l)
        return new Promise((x, k) => {
          l(f, () => x(c()), () => k(f), C + 1);
        });
      throw f;
    }).then((f) => d !== L && L ? L : (f && (f.__esModule || f[Symbol.toStringTag] === "Module") && (f = f.default), a = f, f)));
  };
  return q2({
    name: "AsyncComponentWrapper",
    __asyncLoader: h,
    get __asyncResolved() {
      return a;
    },
    setup() {
      const d = _1;
      if (a)
        return () => R7(a, d);
      const f = (g) => {
        L = null, f9(
          g,
          d,
          13,
          !i
          /* do not throw in dev if user provided error component */
        );
      };
      if (o && d.suspense || W9)
        return h().then((g) => () => R7(g, d)).catch((g) => (f(g), () => i ? N(i, {
          error: g
        }) : null));
      const x = R2(!1), k = R2(), m = R2(!!s);
      return s && setTimeout(() => {
        m.value = !1;
      }, s), r != null && setTimeout(() => {
        if (!x.value && !k.value) {
          const g = new Error(`Async component timed out after ${r}ms.`);
          f(g), k.value = g;
        }
      }, r), h().then(() => {
        x.value = !0, d.parent && e5(d.parent.vnode) && I8(d.parent.update);
      }).catch((g) => {
        f(g), k.value = g;
      }), () => {
        if (x.value && a)
          return R7(a, d);
        if (k.value && i)
          return N(i, {
            error: k.value
          });
        if (n && !m.value)
          return N(n);
      };
    }
  });
}
function R7(t, e) {
  const { ref: n, props: i, children: s, ce: r } = e.vnode, o = N(t, i, s);
  return o.ref = n, o.ce = r, delete e.vnode.ce, o;
}
const e5 = (t) => t.type.__isKeepAlive, Rr = {
  name: "KeepAlive",
  // Marker for special handling inside the renderer. We are not using a ===
  // check directly on KeepAlive in the renderer, because importing it directly
  // would prevent it from being tree-shaken.
  __isKeepAlive: !0,
  props: {
    include: [String, RegExp, Array],
    exclude: [String, RegExp, Array],
    max: [String, Number]
  },
  setup(t, { slots: e }) {
    const n = l4(), i = n.ctx;
    if (!i.renderer)
      return () => {
        const g = e.default && e.default();
        return g && g.length === 1 ? g[0] : g;
      };
    const s = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Set();
    let o = null;
    const l = n.suspense, { renderer: { p: L, m: a, um: C, o: { createElement: c } } } = i, h = c("div");
    i.activate = (g, w, Z, b, z) => {
      const K = g.component;
      a(g, w, Z, 0, l), L(K.vnode, g, w, Z, K, l, b, g.slotScopeIds, z), g1(() => {
        K.isDeactivated = !1, K.a && I4(K.a);
        const E = g.props && g.props.onVnodeMounted;
        E && t3(E, K.parent, g);
      }, l);
    }, i.deactivate = (g) => {
      const w = g.component;
      a(g, h, null, 1, l), g1(() => {
        w.da && I4(w.da);
        const Z = g.props && g.props.onVnodeUnmounted;
        Z && t3(Z, w.parent, g), w.isDeactivated = !0;
      }, l);
    };
    function d(g) {
      y7(g), C(g, n, l, !0);
    }
    function f(g) {
      s.forEach((w, Z) => {
        const b = _6(w.type);
        b && (!g || !g(b)) && x(Z);
      });
    }
    function x(g) {
      const w = s.get(g);
      !o || w.type !== o.type ? d(w) : o && y7(o), s.delete(g), r.delete(g);
    }
    m3(
      () => [t.include, t.exclude],
      ([g, w]) => {
        g && f((Z) => x0(g, Z)), w && f((Z) => !x0(w, Z));
      },
      // prune post-render after `current` has been updated
      { flush: "post", deep: !0 }
    );
    let k = null;
    const m = () => {
      k != null && s.set(k, A7(n.subTree));
    };
    return s1(m), t5(m), W0(() => {
      s.forEach((g) => {
        const { subTree: w, suspense: Z } = n, b = A7(w);
        if (g.type === b.type) {
          y7(b);
          const z = b.component.da;
          z && g1(z, Z);
          return;
        }
        d(g);
      });
    }), () => {
      if (k = null, !e.default)
        return null;
      const g = e.default(), w = g[0];
      if (g.length > 1)
        return o = null, g;
      if (!_3(w) || !(w.shapeFlag & 4) && !(w.shapeFlag & 128))
        return o = null, w;
      let Z = A7(w);
      const b = Z.type, z = _6(i9(Z) ? Z.type.__asyncResolved || {} : b), { include: K, exclude: E, max: L2 } = t;
      if (K && (!z || !x0(K, z)) || E && z && x0(E, z))
        return o = Z, w;
      const t2 = Z.key == null ? b : Z.key, u2 = s.get(t2);
      return Z.el && (Z = T3(Z), w.shapeFlag & 128 && (w.ssContent = Z)), k = t2, u2 ? (Z.el = u2.el, Z.component = u2.component, Z.transition && C9(Z, Z.transition), Z.shapeFlag |= 512, r.delete(t2), r.add(t2)) : (r.add(t2), L2 && r.size > parseInt(L2, 10) && x(r.values().next().value)), Z.shapeFlag |= 256, o = Z, mr(w.type) ? w : Z;
    };
  }
};
Rr.__isBuildIn = !0;
const yr = Rr;
function x0(t, e) {
  return e2(t) ? t.some((n) => x0(n, e)) : r1(t) ? t.split(",").includes(e) : t.test ? t.test(e) : !1;
}
function Ar(t, e) {
  kr(t, "a", e);
}
function Zr(t, e) {
  kr(t, "da", e);
}
function kr(t, e, n = _1) {
  const i = t.__wdc || (t.__wdc = () => {
    let s = n;
    for (; s; ) {
      if (s.isDeactivated)
        return;
      s = s.parent;
    }
    return t();
  });
  if (P8(e, i, n), n) {
    let s = n.parent;
    for (; s && s.parent; )
      e5(s.parent.vnode) && tu(i, e, n, s), s = s.parent;
  }
}
function tu(t, e, n, i) {
  const s = P8(
    e,
    t,
    i,
    !0
    /* prepend */
  );
  x1(() => {
    oe(i[e], s);
  }, n);
}
function y7(t) {
  t.shapeFlag &= -257, t.shapeFlag &= -513;
}
function A7(t) {
  return t.shapeFlag & 128 ? t.ssContent : t;
}
function P8(t, e, n = _1, i = !1) {
  if (n) {
    const s = n[t] || (n[t] = []), r = e.__weh || (e.__weh = (...o) => {
      if (n.isUnmounted)
        return;
      Y9(), B4(n);
      const l = l3(e, n, t, o);
      return O4(), Q9(), l;
    });
    return i ? s.unshift(r) : s.push(r), r;
  }
}
const x4 = (t) => (e, n = _1) => (
  // post-create lifecycle registrations are noops during SSR (except for serverPrefetch)
  (!W9 || t === "sp") && P8(t, (...i) => e(...i), n)
), Tr = x4(
  "bm"
  /* LifecycleHooks.BEFORE_MOUNT */
), s1 = x4(
  "m"
  /* LifecycleHooks.MOUNTED */
), Sr = x4(
  "bu"
  /* LifecycleHooks.BEFORE_UPDATE */
), t5 = x4(
  "u"
  /* LifecycleHooks.UPDATED */
), W0 = x4(
  "bum"
  /* LifecycleHooks.BEFORE_UNMOUNT */
), x1 = x4(
  "um"
  /* LifecycleHooks.UNMOUNTED */
), br = x4(
  "sp"
  /* LifecycleHooks.SERVER_PREFETCH */
), Er = x4(
  "rtg"
  /* LifecycleHooks.RENDER_TRIGGERED */
), Ir = x4(
  "rtc"
  /* LifecycleHooks.RENDER_TRACKED */
);
function Fr(t, e = _1) {
  P8("ec", t, e);
}
function nu(t) {
  T1("INSTANCE_CHILDREN", t);
  const e = t.subTree, n = [];
  return e && Or(e, n), n;
}
function Or(t, e) {
  if (t.component)
    e.push(t.component.proxy);
  else if (t.shapeFlag & 16) {
    const n = t.children;
    for (let i = 0; i < n.length; i++)
      Or(n[i], e);
  }
}
function Nr(t) {
  T1("INSTANCE_LISTENERS", t);
  const e = {}, n = t.vnode.props;
  if (!n)
    return e;
  for (const i in n)
    w4(i) && (e[i[2].toLowerCase() + i.slice(3)] = n[i]);
  return e;
}
const iu = {
  beforeMount: "bind",
  mounted: "inserted",
  updated: ["update", "componentUpdated"],
  unmounted: "unbind"
};
function su(t, e, n) {
  const i = iu[t];
  if (i)
    if (e2(i)) {
      const s = [];
      return i.forEach((r) => {
        const o = e[r];
        o && (g4("CUSTOM_DIR", n, r, t), s.push(o));
      }), s.length ? s : void 0;
    } else
      return e[i] && g4("CUSTOM_DIR", n, i, t), e[i];
}
function H0(t, e) {
  const n = p1;
  if (n === null)
    return t;
  const i = V8(n) || n.proxy, s = t.dirs || (t.dirs = []);
  for (let r = 0; r < e.length; r++) {
    let [o, l, L, a = X2] = e[r];
    o && (p2(o) && (o = {
      mounted: o,
      updated: o
    }), o.deep && T4(l), s.push({
      dir: o,
      instance: i,
      value: l,
      oldValue: void 0,
      arg: L,
      modifiers: a
    }));
  }
  return t;
}
function W3(t, e, n, i) {
  const s = t.dirs, r = e && e.dirs;
  for (let o = 0; o < s.length; o++) {
    const l = s[o];
    r && (l.oldValue = r[o].value);
    let L = l.dir[i];
    L || (L = su(i, l.dir, n)), L && (Y9(), l3(L, n, 8, [
      t.el,
      l,
      t,
      e
    ]), Q9());
  }
}
const Ze = "components", ru = "directives", ou = "filters";
function i2(t, e) {
  return z8(Ze, t, !0, e) || t;
}
const Dr = Symbol();
function B8(t) {
  return r1(t) ? z8(Ze, t, !1) || t : t || Dr;
}
function Pr(t) {
  return z8(ru, t);
}
function Br(t) {
  return z8(ou, t);
}
function z8(t, e, n = !0, i = !1) {
  const s = p1 || _1;
  if (s) {
    const r = s.type;
    if (t === Ze) {
      const l = _6(
        r,
        !1
        /* do not include inferred name to avoid breaking existing code */
      );
      if (l && (l === e || l === G1(e) || l === Q0(G1(e))))
        return r;
    }
    const o = (
      // local registration
      // check instance[type] first which is resolved for options API
      Un(s[t] || r[t], e) || // global registration
      Un(s.appContext[t], e)
    );
    return !o && i ? r : o;
  }
}
function Un(t, e) {
  return t && (t[e] || t[G1(e)] || t[Q0(G1(e))]);
}
function lu(t) {
  const e = t.type, n = e.render;
  if (!(!n || n._rc || n._compatChecked || n._compatWrapped)) {
    if (n.length >= 2) {
      n._compatChecked = !0;
      return;
    }
    if (F8("RENDER_FUNCTION", t)) {
      const i = e.render = function() {
        return n.call(this, n8);
      };
      i._compatWrapped = !0;
    }
  }
}
function n8(t, e, n) {
  if (t || (t = S1), typeof t == "string") {
    const r = W1(t);
    (r === "transition" || r === "transition-group" || r === "keep-alive") && (t = `__compat__${r}`), t = B8(t);
  }
  const i = arguments.length, s = e2(e);
  return i === 2 || s ? B2(e) && !s ? _3(e) ? T5(N(t, null, [e])) : T5(Hn(N(t, Wn(e, t)), e)) : T5(N(t, null, e)) : (_3(n) && (n = [n]), T5(Hn(N(t, Wn(e, t), n), e)));
}
const Lu = /* @__PURE__ */ K9("staticStyle,staticClass,directives,model,hook");
function Wn(t, e) {
  if (!t)
    return null;
  const n = {};
  for (const i in t)
    if (i === "attrs" || i === "domProps" || i === "props")
      U2(n, t[i]);
    else if (i === "on" || i === "nativeOn") {
      const s = t[i];
      for (const r in s) {
        let o = au(r);
        i === "nativeOn" && (o += "Native");
        const l = n[o], L = s[r];
        l !== L && (l ? n[o] = [].concat(l, L) : n[o] = L);
      }
    } else
      Lu(i) || (n[i] = t[i]);
  if (t.staticClass && (n.class = v2([t.staticClass, n.class])), t.staticStyle && (n.style = w2([t.staticStyle, n.style])), t.model && B2(e)) {
    const { prop: i = "value", event: s = "input" } = e.model || {};
    n[i] = t.model.value, n[O8 + s] = t.model.callback;
  }
  return n;
}
function au(t) {
  return t[0] === "&" && (t = t.slice(1) + "Passive"), t[0] === "~" && (t = t.slice(1) + "Once"), t[0] === "!" && (t = t.slice(1) + "Capture"), E9(t);
}
function Hn(t, e) {
  return e && e.directives ? H0(t, e.directives.map(({ name: n, value: i, arg: s, modifiers: r }) => [
    Pr(n),
    i,
    s,
    r
  ])) : t;
}
function T5(t) {
  const { props: e, children: n } = t;
  let i;
  if (t.shapeFlag & 6 && e2(n)) {
    i = {};
    for (let r = 0; r < n.length; r++) {
      const o = n[r], l = _3(o) && o.props && o.props.slot || "default", L = i[l] || (i[l] = []);
      _3(o) && o.type === "template" ? L.push(o.children) : L.push(o);
    }
    if (i)
      for (const r in i) {
        const o = i[r];
        i[r] = () => o, i[r]._ns = !0;
      }
  }
  const s = e && e.scopedSlots;
  return s && (delete e.scopedSlots, i ? U2(i, s) : i = s), i && H8(t, i), t;
}
function zr(t) {
  if (Y2(
    "RENDER_FUNCTION",
    p1,
    !0
    /* enable for built-ins */
  ) && Y2(
    "PRIVATE_APIS",
    p1,
    !0
    /* enable for built-ins */
  )) {
    const e = p1, n = () => t.component && t.component.proxy;
    let i;
    Object.defineProperties(t, {
      tag: { get: () => t.type },
      data: { get: () => t.props || {}, set: (s) => t.props = s },
      elm: { get: () => t.el },
      componentInstance: { get: n },
      child: { get: n },
      text: { get: () => r1(t.children) ? t.children : null },
      context: { get: () => e && e.proxy },
      componentOptions: {
        get: () => {
          if (t.shapeFlag & 4)
            return i || (i = {
              Ctor: t.type,
              propsData: t.props,
              children: t.children
            });
        }
      }
    });
  }
}
const Z7 = /* @__PURE__ */ new Map(), Ur = {
  get(t, e) {
    const n = t[e];
    return n && n();
  }
};
function Cu(t) {
  if (Z7.has(t))
    return Z7.get(t);
  const e = t.render, n = (i, s) => {
    const r = l4(), o = {
      props: i,
      children: r.vnode.children || [],
      data: r.vnode.props || {},
      scopedSlots: s.slots,
      parent: r.parent && r.parent.proxy,
      slots() {
        return new Proxy(s.slots, Ur);
      },
      get listeners() {
        return Nr(r);
      },
      get injections() {
        if (t.inject) {
          const l = {};
          return jr(t.inject, l), l;
        }
        return {};
      }
    };
    return e(n8, o);
  };
  return n.props = t.props, n.displayName = t.name, n.compatConfig = t.compatConfig, n.inheritAttrs = !1, Z7.set(t, n), n;
}
function e4(t, e, n, i) {
  let s;
  const r = n && n[i];
  if (e2(t) || r1(t)) {
    s = new Array(t.length);
    for (let o = 0, l = t.length; o < l; o++)
      s[o] = e(t[o], o, void 0, r && r[o]);
  } else if (typeof t == "number") {
    s = new Array(t);
    for (let o = 0; o < t; o++)
      s[o] = e(o + 1, o, void 0, r && r[o]);
  } else if (B2(t))
    if (t[Symbol.iterator])
      s = Array.from(t, (o, l) => e(o, l, void 0, r && r[l]));
    else {
      const o = Object.keys(t);
      s = new Array(o.length);
      for (let l = 0, L = o.length; l < L; l++) {
        const a = o[l];
        s[l] = e(t[a], a, l, r && r[l]);
      }
    }
  else
    s = [];
  return n && (n[i] = s), s;
}
function Wr(t, e) {
  for (let n = 0; n < e.length; n++) {
    const i = e[n];
    if (e2(i))
      for (let s = 0; s < i.length; s++)
        t[i[s].name] = i[s].fn;
    else
      i && (t[i.name] = i.key ? (...s) => {
        const r = i.fn(...s);
        return r && (r.key = i.key), r;
      } : i.fn);
  }
  return t;
}
function ke(t, e, n = {}, i, s) {
  if (p1.isCE || p1.parent && i9(p1.parent) && p1.parent.isCE)
    return e !== "default" && (n.name = e), N("slot", n, i && i());
  let r = t[e];
  r && r._c && (r._d = !1), T();
  const o = r && Hr(r(n)), l = T2(
    P2,
    {
      key: n.key || // slot content array of a dynamic conditional slot may have a branch
      // key attached in the `createSlots` helper, respect that
      o && o.key || `_${e}`
    },
    o || (i ? i() : []),
    o && t._ === 1 ? 64 : -2
    /* PatchFlags.BAIL */
  );
  return !s && l.scopeId && (l.slotScopeIds = [l.scopeId + "-s"]), r && r._c && (r._d = !0), l;
}
function Hr(t) {
  return t.some((e) => _3(e) ? !(e.type === S1 || e.type === P2 && !Hr(e.children)) : !0) ? t : null;
}
function $r(t, e) {
  const n = {};
  for (const i in t)
    n[e && /[A-Z]/.test(i) ? `on:${i}` : E9(i)] = t[i];
  return n;
}
function cu(t) {
  const e = {};
  for (let n = 0; n < t.length; n++)
    t[n] && U2(e, t[n]);
  return e;
}
function uu(t, e, n, i, s) {
  if (n && B2(n)) {
    e2(n) && (n = cu(n));
    for (const r in n)
      if (b9(r))
        t[r] = n[r];
      else if (r === "class")
        t.class = v2([t.class, n.class]);
      else if (r === "style")
        t.style = v2([t.style, n.style]);
      else {
        const o = t.attrs || (t.attrs = {}), l = G1(r), L = W1(r);
        if (!(l in o) && !(L in o) && (o[r] = n[r], s)) {
          const a = t.on || (t.on = {});
          a[`update:${r}`] = function(C) {
            n[r] = C;
          };
        }
      }
  }
  return t;
}
function hu(t, e) {
  return $8(t, $r(e));
}
function du(t, e, n, i, s) {
  return s && (i = $8(i, s)), ke(t.slots, e, i, n && (() => n));
}
function gu(t, e, n) {
  return Wr(e || { $stable: !n }, Vr(t));
}
function Vr(t) {
  for (let e = 0; e < t.length; e++) {
    const n = t[e];
    n && (e2(n) ? Vr(n) : n.name = n.key || "default");
  }
  return t;
}
const $n = /* @__PURE__ */ new WeakMap();
function fu(t, e) {
  let n = $n.get(t);
  if (n || $n.set(t, n = []), n[e])
    return n[e];
  const i = t.type.staticRenderFns[e], s = t.proxy;
  return n[e] = i.call(s, null, s);
}
function pu(t, e, n, i, s, r) {
  const l = t.appContext.config.keyCodes || {}, L = l[n] || i;
  if (r && s && !l[n])
    return Vn(r, s);
  if (L)
    return Vn(L, e);
  if (s)
    return W1(s) !== n;
}
function Vn(t, e) {
  return e2(t) ? !t.includes(e) : t !== e;
}
function mu(t) {
  return t;
}
function wu(t, e) {
  for (let n = 0; n < e.length; n += 2) {
    const i = e[n];
    typeof i == "string" && i && (t[e[n]] = e[n + 1]);
  }
  return t;
}
function xu(t, e) {
  return typeof t == "string" ? e + t : t;
}
function _u(t) {
  const e = (i, s, r) => {
    i[s] = r;
  }, n = (i, s) => {
    delete i[s];
  };
  U2(t, {
    $set: (i) => (T1("INSTANCE_SET", i), e),
    $delete: (i) => (T1("INSTANCE_DELETE", i), n),
    $mount: (i) => (T1(
      "GLOBAL_MOUNT",
      null
      /* this warning is global */
    ), i.ctx._compat_mount || o3),
    $destroy: (i) => (T1("INSTANCE_DESTROY", i), i.ctx._compat_destroy || o3),
    // overrides existing accessor
    $slots: (i) => Y2("RENDER_FUNCTION", i) && i.render && i.render._compatWrapped ? new Proxy(i.slots, Ur) : i.slots,
    $scopedSlots: (i) => {
      T1("INSTANCE_SCOPED_SLOTS", i);
      const s = {};
      for (const r in i.slots) {
        const o = i.slots[r];
        o._ns || (s[r] = o);
      }
      return s;
    },
    $on: (i) => _e.bind(null, i),
    $once: (i) => Dc.bind(null, i),
    $off: (i) => ve.bind(null, i),
    $children: nu,
    $listeners: Nr
  }), Y2("PRIVATE_APIS", null) && U2(t, {
    // needed by many libs / render fns
    $vnode: (i) => i.vnode,
    // inject additional properties into $options for compat
    // e.g. vuex needs this.$options.parent
    $options: (i) => {
      const s = U2({}, n5(i));
      return s.parent = i.proxy.$parent, s.propsData = i.vnode.props, s;
    },
    // some private properties that are likely accessed...
    _self: (i) => i.proxy,
    _uid: (i) => i.uid,
    _data: (i) => i.data,
    _isMounted: (i) => i.isMounted,
    _isDestroyed: (i) => i.isUnmounted,
    // v2 render helpers
    $createElement: () => n8,
    _c: () => n8,
    _o: () => mu,
    _n: () => Q3,
    _s: () => m1,
    _l: () => e4,
    _t: (i) => du.bind(null, i),
    _q: () => d4,
    _i: () => K0,
    _m: (i) => fu.bind(null, i),
    _f: () => Br,
    _k: (i) => pu.bind(null, i),
    _b: () => uu,
    _v: () => q3,
    _e: () => x2,
    _u: () => gu,
    _g: () => hu,
    _d: () => wu,
    _p: () => xu
  });
}
const c6 = (t) => t ? uo(t) ? V8(t) || t.proxy : c6(t.parent) : null, N9 = (
  // Move PURE marker to new line to workaround compiler discarding it
  // due to type annotation
  /* @__PURE__ */ U2(/* @__PURE__ */ Object.create(null), {
    $: (t) => t,
    $el: (t) => t.vnode.el,
    $data: (t) => t.data,
    $props: (t) => t.props,
    $attrs: (t) => t.attrs,
    $slots: (t) => t.slots,
    $refs: (t) => t.refs,
    $parent: (t) => c6(t.parent),
    $root: (t) => c6(t.root),
    $emit: (t) => t.emit,
    $options: (t) => n5(t),
    $forceUpdate: (t) => t.f || (t.f = () => I8(t.update)),
    $nextTick: (t) => t.n || (t.n = P4.bind(t.proxy)),
    $watch: (t) => eu.bind(t)
  })
);
_u(N9);
const k7 = (t, e) => t !== X2 && !t.__isScriptSetup && $2(t, e), u6 = {
  get({ _: t }, e) {
    const { ctx: n, setupState: i, data: s, props: r, accessCache: o, type: l, appContext: L } = t;
    let a;
    if (e[0] !== "$") {
      const d = o[e];
      if (d !== void 0)
        switch (d) {
          case 1:
            return i[e];
          case 2:
            return s[e];
          case 4:
            return n[e];
          case 3:
            return r[e];
        }
      else {
        if (k7(i, e))
          return o[e] = 1, i[e];
        if (s !== X2 && $2(s, e))
          return o[e] = 2, s[e];
        if (
          // only cache other properties when instance has declared (thus stable)
          // props
          (a = t.propsOptions[0]) && $2(a, e)
        )
          return o[e] = 3, r[e];
        if (n !== X2 && $2(n, e))
          return o[e] = 4, n[e];
        h6 && (o[e] = 0);
      }
    }
    const C = N9[e];
    let c, h;
    if (C)
      return e === "$attrs" && L3(t, "get", e), C(t);
    if (
      // css module (injected by vue-loader)
      (c = l.__cssModules) && (c = c[e])
    )
      return c;
    if (n !== X2 && $2(n, e))
      return o[e] = 4, n[e];
    if (
      // global properties
      h = L.config.globalProperties, $2(h, e)
    ) {
      const d = Object.getOwnPropertyDescriptor(h, e);
      if (d.get)
        return d.get.call(t.proxy);
      {
        const f = h[e];
        return p2(f) ? Object.assign(f.bind(t.proxy), f) : f;
      }
    }
  },
  set({ _: t }, e, n) {
    const { data: i, setupState: s, ctx: r } = t;
    return k7(s, e) ? (s[e] = n, !0) : i !== X2 && $2(i, e) ? (i[e] = n, !0) : $2(t.props, e) || e[0] === "$" && e.slice(1) in t ? !1 : (r[e] = n, !0);
  },
  has({ _: { data: t, setupState: e, accessCache: n, ctx: i, appContext: s, propsOptions: r } }, o) {
    let l;
    return !!n[o] || t !== X2 && $2(t, o) || k7(e, o) || (l = r[0]) && $2(l, o) || $2(i, o) || $2(N9, o) || $2(s.config.globalProperties, o);
  },
  defineProperty(t, e, n) {
    return n.get != null ? t._.accessCache[e] = 0 : $2(n, "value") && this.set(t, e, n.value, null), Reflect.defineProperty(t, e, n);
  }
}, vu = /* @__PURE__ */ U2({}, u6, {
  get(t, e) {
    if (e !== Symbol.unscopables)
      return u6.get(t, e, t);
  },
  has(t, e) {
    return e[0] !== "_" && !SC(e);
  }
});
function Gr(t, e) {
  for (const n in e) {
    const i = t[n], s = e[n];
    n in t && J5(i) && J5(s) ? Gr(i, s) : t[n] = s;
  }
  return t;
}
let h6 = !0;
function Mu(t) {
  const e = n5(t), n = t.proxy, i = t.ctx;
  h6 = !1, e.beforeCreate && Gn(
    e.beforeCreate,
    t,
    "bc"
    /* LifecycleHooks.BEFORE_CREATE */
  );
  const {
    // state
    data: s,
    computed: r,
    methods: o,
    watch: l,
    provide: L,
    inject: a,
    // lifecycle
    created: C,
    beforeMount: c,
    mounted: h,
    beforeUpdate: d,
    updated: f,
    activated: x,
    deactivated: k,
    beforeDestroy: m,
    beforeUnmount: g,
    destroyed: w,
    unmounted: Z,
    render: b,
    renderTracked: z,
    renderTriggered: K,
    errorCaptured: E,
    serverPrefetch: L2,
    // public API
    expose: t2,
    inheritAttrs: u2,
    // assets
    components: N2,
    directives: m2,
    filters: P
  } = e;
  if (a && jr(a, i, null, t.appContext.config.unwrapInjectedRef), o)
    for (const s2 in o) {
      const g2 = o[s2];
      p2(g2) && (i[s2] = g2.bind(n));
    }
  if (s) {
    const s2 = s.call(n, n);
    B2(s2) && (t.data = J3(s2));
  }
  if (h6 = !0, r)
    for (const s2 in r) {
      const g2 = r[s2], J2 = p2(g2) ? g2.bind(n, n) : p2(g2.get) ? g2.get.bind(n, n) : o3, S2 = !p2(g2) && p2(g2.set) ? g2.set.bind(n) : o3, y1 = I({
        get: J2,
        set: S2
      });
      Object.defineProperty(i, s2, {
        enumerable: !0,
        configurable: !0,
        get: () => y1.value,
        set: (E2) => y1.value = E2
      });
    }
  if (l)
    for (const s2 in l)
      qr(l[s2], i, n, s2);
  if (L) {
    const s2 = p2(L) ? L.call(n) : L;
    Reflect.ownKeys(s2).forEach((g2) => {
      a3(g2, s2[g2]);
    });
  }
  C && Gn(
    C,
    t,
    "c"
    /* LifecycleHooks.CREATED */
  );
  function $(s2, g2) {
    e2(g2) ? g2.forEach((J2) => s2(J2.bind(n))) : g2 && s2(g2.bind(n));
  }
  if ($(Tr, c), $(s1, h), $(Sr, d), $(t5, f), $(Ar, x), $(Zr, k), $(Fr, E), $(Ir, z), $(Er, K), $(W0, g), $(x1, Z), $(br, L2), m && g4("OPTIONS_BEFORE_DESTROY", t) && $(W0, m), w && g4("OPTIONS_DESTROYED", t) && $(x1, w), e2(t2))
    if (t2.length) {
      const s2 = t.exposed || (t.exposed = {});
      t2.forEach((g2) => {
        Object.defineProperty(s2, g2, {
          get: () => n[g2],
          set: (J2) => n[g2] = J2
        });
      });
    } else
      t.exposed || (t.exposed = {});
  b && t.render === o3 && (t.render = b), u2 != null && (t.inheritAttrs = u2), N2 && (t.components = N2), m2 && (t.directives = m2), P && Y2("FILTERS", t) && (t.filters = P);
}
function jr(t, e, n = o3, i = !1) {
  e2(t) && (t = d6(t));
  for (const s in t) {
    const r = t[s];
    let o;
    B2(r) ? "default" in r ? o = u1(
      r.from || s,
      r.default,
      !0
      /* treat default function as factory */
    ) : o = u1(r.from || s) : o = u1(r), R1(o) && i ? Object.defineProperty(e, s, {
      enumerable: !0,
      configurable: !0,
      get: () => o.value,
      set: (l) => o.value = l
    }) : e[s] = o;
  }
}
function Gn(t, e, n) {
  l3(e2(t) ? t.map((i) => i.bind(e.proxy)) : t.bind(e.proxy), e, n);
}
function qr(t, e, n, i) {
  const s = i.includes(".") ? _r(n, i) : () => n[i];
  if (r1(t)) {
    const r = e[t];
    p2(r) && m3(s, r);
  } else if (p2(t))
    m3(s, t.bind(n));
  else if (B2(t))
    if (e2(t))
      t.forEach((r) => qr(r, e, n, i));
    else {
      const r = p2(t.handler) ? t.handler.bind(n) : e[t.handler];
      p2(r) && m3(s, r, t);
    }
}
function n5(t) {
  const e = t.type, { mixins: n, extends: i } = e, { mixins: s, optionsCache: r, config: { optionMergeStrategies: o } } = t.appContext, l = r.get(e);
  let L;
  return l ? L = l : !s.length && !n && !i ? Y2("PRIVATE_APIS", t) ? (L = U2({}, e), L.parent = t.parent && t.parent.proxy, L.propsData = t.vnode.props) : L = e : (L = {}, s.length && s.forEach((a) => s9(L, a, o, !0)), s9(L, e, o)), B2(e) && r.set(e, L), L;
}
function s9(t, e, n, i = !1) {
  p2(e) && (e = e.options);
  const { mixins: s, extends: r } = e;
  r && s9(t, r, n, !0), s && s.forEach((o) => s9(t, o, n, !0));
  for (const o in e)
    if (!(i && o === "expose")) {
      const l = r9[o] || n && n[o];
      t[o] = l ? l(t[o], e[o]) : e[o];
    }
  return t;
}
const r9 = {
  data: jn,
  props: A4,
  emits: A4,
  // objects
  methods: A4,
  computed: A4,
  // lifecycle
  beforeCreate: z1,
  created: z1,
  beforeMount: z1,
  mounted: z1,
  beforeUpdate: z1,
  updated: z1,
  beforeDestroy: z1,
  beforeUnmount: z1,
  destroyed: z1,
  unmounted: z1,
  activated: z1,
  deactivated: z1,
  errorCaptured: z1,
  serverPrefetch: z1,
  // assets
  components: A4,
  directives: A4,
  // watch
  watch: yu,
  // provide / inject
  provide: jn,
  inject: Ru
};
r9.filters = A4;
function jn(t, e) {
  return e ? t ? function() {
    return (Y2("OPTIONS_DATA_MERGE", null) ? Gr : U2)(p2(t) ? t.call(this, this) : t, p2(e) ? e.call(this, this) : e);
  } : e : t;
}
function Ru(t, e) {
  return A4(d6(t), d6(e));
}
function d6(t) {
  if (e2(t)) {
    const e = {};
    for (let n = 0; n < t.length; n++)
      e[t[n]] = t[n];
    return e;
  }
  return t;
}
function z1(t, e) {
  return t ? [...new Set([].concat(t, e))] : e;
}
function A4(t, e) {
  return t ? U2(U2(/* @__PURE__ */ Object.create(null), t), e) : e;
}
function yu(t, e) {
  if (!t)
    return e;
  if (!e)
    return t;
  const n = U2(/* @__PURE__ */ Object.create(null), t);
  for (const i in e)
    n[i] = z1(t[i], e[i]);
  return n;
}
function Au(t, e, n) {
  return new Proxy({}, {
    get(i, s) {
      if (s === "$options")
        return n5(t);
      if (s in e)
        return e[s];
      const r = t.type.inject;
      if (r) {
        if (e2(r)) {
          if (r.includes(s))
            return u1(s);
        } else if (s in r)
          return u1(s);
      }
    }
  });
}
function Kr(t, e) {
  return !!(t === "is" || (t === "class" || t === "style") && Y2("INSTANCE_ATTRS_CLASS_STYLE", e) || w4(t) && Y2("INSTANCE_LISTENERS", e) || t.startsWith("routerView") || t === "registerRouteInstance");
}
function Zu(t, e, n, i = !1) {
  const s = {}, r = {};
  e8(r, U8, 1), t.propsDefaults = /* @__PURE__ */ Object.create(null), Yr(t, e, s, r);
  for (const o in t.propsOptions[0])
    o in s || (s[o] = void 0);
  n ? t.props = i ? s : lr(s) : t.type.props ? t.props = s : t.props = r, t.attrs = r;
}
function ku(t, e, n, i) {
  const { props: s, attrs: r, vnode: { patchFlag: o } } = t, l = I2(s), [L] = t.propsOptions;
  let a = !1;
  if (
    // always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    (i || o > 0) && !(o & 16)
  ) {
    if (o & 8) {
      const C = t.vnode.dynamicProps;
      for (let c = 0; c < C.length; c++) {
        let h = C[c];
        if (N8(t.emitsOptions, h))
          continue;
        const d = e[h];
        if (L)
          if ($2(r, h))
            d !== r[h] && (r[h] = d, a = !0);
          else {
            const f = G1(h);
            s[f] = g6(
              L,
              l,
              f,
              d,
              t,
              !1
              /* isAbsent */
            );
          }
        else {
          if (w4(h) && h.endsWith("Native"))
            h = h.slice(0, -6);
          else if (Kr(h, t))
            continue;
          d !== r[h] && (r[h] = d, a = !0);
        }
      }
    }
  } else {
    Yr(t, e, s, r) && (a = !0);
    let C;
    for (const c in l)
      (!e || // for camelCase
      !$2(e, c) && // it's possible the original props was passed in as kebab-case
      // and converted to camelCase (#955)
      ((C = W1(c)) === c || !$2(e, C))) && (L ? n && // for camelCase
      (n[c] !== void 0 || // for kebab-case
      n[C] !== void 0) && (s[c] = g6(
        L,
        l,
        c,
        void 0,
        t,
        !0
        /* isAbsent */
      )) : delete s[c]);
    if (r !== l)
      for (const c in r)
        (!e || !$2(e, c) && !$2(e, c + "Native")) && (delete r[c], a = !0);
  }
  a && X3(t, "set", "$attrs");
}
function Yr(t, e, n, i) {
  const [s, r] = t.propsOptions;
  let o = !1, l;
  if (e)
    for (let L in e) {
      if (b9(L) || (L.startsWith("onHook:") && g4("INSTANCE_EVENT_HOOKS", t, L.slice(2).toLowerCase()), L === "inline-template"))
        continue;
      const a = e[L];
      let C;
      if (s && $2(s, C = G1(L)))
        !r || !r.includes(C) ? n[C] = a : (l || (l = {}))[C] = a;
      else if (!N8(t.emitsOptions, L)) {
        if (w4(L) && L.endsWith("Native"))
          L = L.slice(0, -6);
        else if (Kr(L, t))
          continue;
        (!(L in i) || a !== i[L]) && (i[L] = a, o = !0);
      }
    }
  if (r) {
    const L = I2(n), a = l || X2;
    for (let C = 0; C < r.length; C++) {
      const c = r[C];
      n[c] = g6(s, L, c, a[c], t, !$2(a, c));
    }
  }
  return o;
}
function g6(t, e, n, i, s, r) {
  const o = t[n];
  if (o != null) {
    const l = $2(o, "default");
    if (l && i === void 0) {
      const L = o.default;
      if (o.type !== Function && p2(L)) {
        const { propsDefaults: a } = s;
        n in a ? i = a[n] : (B4(s), i = a[n] = L.call(Y2("PROPS_DEFAULT_THIS", s) ? Au(s, e) : null, e), O4());
      } else
        i = L;
    }
    o[
      0
      /* BooleanFlags.shouldCast */
    ] && (r && !l ? i = !1 : o[
      1
      /* BooleanFlags.shouldCastTrue */
    ] && (i === "" || i === W1(n)) && (i = !0));
  }
  return i;
}
function Qr(t, e, n = !1) {
  const i = e.propsCache, s = i.get(t);
  if (s)
    return s;
  const r = t.props, o = {}, l = [];
  let L = !1;
  if (!p2(t)) {
    const C = (c) => {
      p2(c) && (c = c.options), L = !0;
      const [h, d] = Qr(c, e, !0);
      U2(o, h), d && l.push(...d);
    };
    !n && e.mixins.length && e.mixins.forEach(C), t.extends && C(t.extends), t.mixins && t.mixins.forEach(C);
  }
  if (!r && !L)
    return B2(t) && i.set(t, T9), T9;
  if (e2(r))
    for (let C = 0; C < r.length; C++) {
      const c = G1(r[C]);
      qn(c) && (o[c] = X2);
    }
  else if (r)
    for (const C in r) {
      const c = G1(C);
      if (qn(c)) {
        const h = r[C], d = o[c] = e2(h) || p2(h) ? { type: h } : Object.assign({}, h);
        if (d) {
          const f = Qn(Boolean, d.type), x = Qn(String, d.type);
          d[
            0
            /* BooleanFlags.shouldCast */
          ] = f > -1, d[
            1
            /* BooleanFlags.shouldCastTrue */
          ] = x < 0 || f < x, (f > -1 || $2(d, "default")) && l.push(c);
        }
      }
    }
  const a = [o, l];
  return B2(t) && i.set(t, a), a;
}
function qn(t) {
  return t[0] !== "$";
}
function Kn(t) {
  const e = t && t.toString().match(/^\s*function (\w+)/);
  return e ? e[1] : t === null ? "null" : "";
}
function Yn(t, e) {
  return Kn(t) === Kn(e);
}
function Qn(t, e) {
  return e2(e) ? e.findIndex((n) => Yn(n, t)) : p2(e) && Yn(e, t) ? 0 : -1;
}
const Xr = (t) => t[0] === "_" || t === "$stable", Te = (t) => e2(t) ? t.map(g3) : [g3(t)], Tu = (t, e, n) => {
  if (e._n)
    return e;
  const i = h3((...s) => Te(e(...s)), n);
  return i._c = !1, i;
}, Jr = (t, e, n) => {
  const i = t._ctx;
  for (const s in t) {
    if (Xr(s))
      continue;
    const r = t[s];
    if (p2(r))
      e[s] = Tu(s, r, i);
    else if (r != null) {
      const o = Te(r);
      e[s] = () => o;
    }
  }
}, eo = (t, e) => {
  const n = Te(e);
  t.slots.default = () => n;
}, Su = (t, e) => {
  if (t.vnode.shapeFlag & 32) {
    const n = e._;
    n ? (t.slots = I2(e), e8(e, "_", n)) : Jr(e, t.slots = {});
  } else
    t.slots = {}, e && eo(t, e);
  e8(t.slots, U8, 1);
}, bu = (t, e, n) => {
  const { vnode: i, slots: s } = t;
  let r = !0, o = X2;
  if (i.shapeFlag & 32) {
    const l = e._;
    l ? n && l === 1 ? r = !1 : (U2(s, e), !n && l === 1 && delete s._) : (r = !e.$stable, Jr(e, s)), o = e;
  } else
    e && (eo(t, e), o = { default: 1 });
  if (r)
    for (const l in s)
      !Xr(l) && !(l in o) && delete s[l];
};
function Eu(t) {
  t.optionMergeStrategies = new Proxy({}, {
    get(e, n) {
      if (n in e)
        return e[n];
      if (n in r9 && g4("CONFIG_OPTION_MERGE_STRATS", null))
        return r9[n];
    }
  });
}
let i3, Q4;
function Iu(t, e) {
  i3 = e({});
  const n = Q4 = function L(a = {}) {
    return i(a, L);
  };
  function i(L = {}, a) {
    T1("GLOBAL_MOUNT", null);
    const { data: C } = L;
    C && !p2(C) && g4("OPTIONS_DATA_FN", null) && (L.data = () => C);
    const c = t(L);
    a !== n && to(c, a);
    const h = c._createRoot(L);
    return L.el ? h.$mount(L.el) : h;
  }
  n.version = "2.6.14-compat:3.2.45", n.config = i3.config, n.use = (L, ...a) => (L && p2(L.install) ? L.install(n, ...a) : p2(L) && L(n, ...a), n), n.mixin = (L) => (i3.mixin(L), n), n.component = (L, a) => a ? (i3.component(L, a), n) : i3.component(L), n.directive = (L, a) => a ? (i3.directive(L, a), n) : i3.directive(L), n.options = { _base: n };
  let s = 1;
  n.cid = s, n.nextTick = P4;
  const r = /* @__PURE__ */ new WeakMap();
  function o(L = {}) {
    if (T1("GLOBAL_EXTEND", null), p2(L) && (L = L.options), r.has(L))
      return r.get(L);
    const a = this;
    function C(h) {
      return i(h ? s9(U2({}, C.options), h, r9) : C.options, C);
    }
    C.super = a, C.prototype = Object.create(n.prototype), C.prototype.constructor = C;
    const c = {};
    for (const h in a.options) {
      const d = a.options[h];
      c[h] = e2(d) ? d.slice() : B2(d) ? U2(/* @__PURE__ */ Object.create(null), d) : d;
    }
    return C.options = s9(c, L, r9), C.options._base = C, C.extend = o.bind(C), C.mixin = a.mixin, C.use = a.use, C.cid = ++s, r.set(L, C), C;
  }
  n.extend = o.bind(n), n.set = (L, a, C) => {
    T1("GLOBAL_SET", null), L[a] = C;
  }, n.delete = (L, a) => {
    T1("GLOBAL_DELETE", null), delete L[a];
  }, n.observable = (L) => (T1("GLOBAL_OBSERVABLE", null), J3(L)), n.filter = (L, a) => a ? (i3.filter(L, a), n) : i3.filter(L);
  const l = {
    warn: o3,
    extend: U2,
    mergeOptions: (L, a, C) => s9(L, a, C ? void 0 : r9),
    defineReactive: Uu
  };
  return Object.defineProperty(n, "util", {
    get() {
      return T1("GLOBAL_PRIVATE_UTIL", null), l;
    }
  }), n.configureCompat = Nc, n;
}
function Fu(t, e, n) {
  Ou(t, e), Eu(t.config), i3 && (Pu(t, e, n), Nu(t), Du(t));
}
function Ou(t, e) {
  e.filters = {}, t.filter = (n, i) => (T1("FILTERS", null), i ? (e.filters[n] = i, t) : e.filters[n]);
}
function Nu(t) {
  Object.defineProperties(t, {
    // so that app.use() can work with legacy plugins that extend prototypes
    prototype: {
      get() {
        return t.config.globalProperties;
      }
    },
    nextTick: { value: P4 },
    extend: { value: Q4.extend },
    set: { value: Q4.set },
    delete: { value: Q4.delete },
    observable: { value: Q4.observable },
    util: {
      get() {
        return Q4.util;
      }
    }
  });
}
function Du(t) {
  t._context.mixins = [...i3._context.mixins], ["components", "directives", "filters"].forEach((e) => {
    t._context[e] = Object.create(i3._context[e]);
  });
  for (const e in i3.config) {
    if (e === "isNativeTag" || x6() && (e === "isCustomElement" || e === "compilerOptions"))
      continue;
    const n = i3.config[e];
    t.config[e] = B2(n) ? Object.create(n) : n, e === "ignoredElements" && Y2("CONFIG_IGNORED_ELEMENTS", null) && !x6() && e2(n) && (t.config.compilerOptions.isCustomElement = (i) => n.some((s) => r1(s) ? s === i : s.test(i)));
  }
  to(t, Q4);
}
function to(t, e) {
  const n = Y2("GLOBAL_PROTOTYPE", null);
  n && (t.config.globalProperties = Object.create(e.prototype));
  const i = Object.getOwnPropertyDescriptors(e.prototype);
  for (const s in i)
    s !== "constructor" && n && Object.defineProperty(t.config.globalProperties, s, i[s]);
}
function Pu(t, e, n) {
  let i = !1;
  t._createRoot = (s) => {
    const r = t._component, o = N(r, s.propsData || null);
    o.appContext = e;
    const l = !p2(r) && !r.render && !r.template, L = () => {
    }, a = be(o, null, null);
    return l && (a.render = L), Ee(a), o.component = a, o.isCompatRoot = !0, a.ctx._compat_mount = (C) => {
      if (i)
        return;
      let c;
      if (typeof C == "string") {
        const d = document.querySelector(C);
        if (!d)
          return;
        c = d;
      } else
        c = C || document.createElement("div");
      const h = c instanceof SVGElement;
      return l && a.render === L && (a.render = null, r.template = c.innerHTML, Ie(
        a,
        !1,
        !0
        /* skip options */
      )), c.innerHTML = "", n(o, c, h), c instanceof Element && (c.removeAttribute("v-cloak"), c.setAttribute("data-v-app", "")), i = !0, t._container = c, c.__vue_app__ = t, a.proxy;
    }, a.ctx._compat_destroy = () => {
      if (i)
        n(null, t._container), delete t._container.__vue_app__;
      else {
        const { bum: C, scope: c, um: h } = a;
        C && I4(C), Y2("INSTANCE_EVENT_HOOKS", a) && a.emit("hook:beforeDestroy"), c && c.stop(), h && I4(h), Y2("INSTANCE_EVENT_HOOKS", a) && a.emit("hook:destroyed");
      }
    }, a.proxy;
  };
}
const Bu = [
  "push",
  "pop",
  "shift",
  "unshift",
  "splice",
  "sort",
  "reverse"
], zu = /* @__PURE__ */ new WeakSet();
function Uu(t, e, n) {
  if (B2(n) && !u4(n) && !zu.has(n)) {
    const s = J3(n);
    e2(n) ? Bu.forEach((r) => {
      n[r] = (...o) => {
        Array.prototype[r].call(s, ...o);
      };
    }) : Object.keys(n).forEach((r) => {
      try {
        T7(n, r, n[r]);
      } catch {
      }
    });
  }
  const i = t.$;
  i && t === i.proxy ? (T7(i.ctx, e, n), i.accessCache = /* @__PURE__ */ Object.create(null)) : u4(t) ? t[e] = n : T7(t, e, n);
}
function T7(t, e, n) {
  n = B2(n) ? J3(n) : n, Object.defineProperty(t, e, {
    enumerable: !0,
    configurable: !0,
    get() {
      return L3(t, "get", e), n;
    },
    set(i) {
      n = B2(i) ? J3(i) : i, X3(t, "set", e, i);
    }
  });
}
function no() {
  return {
    app: null,
    config: {
      isNativeTag: PC,
      performance: !1,
      globalProperties: {},
      optionMergeStrategies: {},
      errorHandler: void 0,
      warnHandler: void 0,
      compilerOptions: {}
    },
    mixins: [],
    components: {},
    directives: {},
    provides: /* @__PURE__ */ Object.create(null),
    optionsCache: /* @__PURE__ */ new WeakMap(),
    propsCache: /* @__PURE__ */ new WeakMap(),
    emitsCache: /* @__PURE__ */ new WeakMap()
  };
}
let Wu = 0;
function Hu(t, e) {
  return function(i, s = null) {
    p2(i) || (i = Object.assign({}, i)), s != null && !B2(s) && (s = null);
    const r = no(), o = /* @__PURE__ */ new Set();
    let l = !1;
    const L = r.app = {
      _uid: Wu++,
      _component: i,
      _props: s,
      _container: null,
      _context: r,
      _instance: null,
      version: wo,
      get config() {
        return r.config;
      },
      set config(a) {
      },
      use(a, ...C) {
        return o.has(a) || (a && p2(a.install) ? (o.add(a), a.install(L, ...C)) : p2(a) && (o.add(a), a(L, ...C))), L;
      },
      mixin(a) {
        return r.mixins.includes(a) || r.mixins.push(a), L;
      },
      component(a, C) {
        return C ? (r.components[a] = C, L) : r.components[a];
      },
      directive(a, C) {
        return C ? (r.directives[a] = C, L) : r.directives[a];
      },
      mount(a, C, c) {
        if (!l) {
          const h = N(i, s);
          return h.appContext = r, C && e ? e(h, a) : t(h, a, c), l = !0, L._container = a, a.__vue_app__ = L, V8(h.component) || h.component.proxy;
        }
      },
      unmount() {
        l && (t(null, L._container), delete L._container.__vue_app__);
      },
      provide(a, C) {
        return r.provides[a] = C, L;
      }
    };
    return Fu(L, r, t), L;
  };
}
function i8(t, e, n, i, s = !1) {
  if (e2(t)) {
    t.forEach((h, d) => i8(h, e && (e2(e) ? e[d] : e), n, i, s));
    return;
  }
  if (i9(i) && !s)
    return;
  const r = i.shapeFlag & 4 ? V8(i.component) || i.component.proxy : i.el, o = s ? null : r, { i: l, r: L } = t, a = e && e.r, C = l.refs === X2 ? l.refs = {} : l.refs, c = l.setupState;
  if (a != null && a !== L && (r1(a) ? (C[a] = null, $2(c, a) && (c[a] = null)) : R1(a) && (a.value = null)), p2(L))
    j3(L, l, 12, [o, C]);
  else {
    const h = r1(L), d = R1(L);
    if (h || d) {
      const f = () => {
        if (t.f) {
          const x = h ? $2(c, L) ? c[L] : C[L] : L.value;
          s ? e2(x) && oe(x, r) : e2(x) ? x.includes(r) || x.push(r) : h ? (C[L] = [r], $2(c, L) && (c[L] = C[L])) : (L.value = [r], t.k && (C[t.k] = L.value));
        } else
          h ? (C[L] = o, $2(c, L) && (c[L] = o)) : d && (L.value = o, t.k && (C[t.k] = o));
      };
      o ? (f.id = -1, g1(f, n)) : f();
    }
  }
}
let M4 = !1;
const S5 = (t) => /svg/.test(t.namespaceURI) && t.tagName !== "foreignObject", b5 = (t) => t.nodeType === 8;
function $u(t) {
  const { mt: e, p: n, o: { patchProp: i, createText: s, nextSibling: r, parentNode: o, remove: l, insert: L, createComment: a } } = t, C = (m, g) => {
    if (!g.hasChildNodes()) {
      n(null, m, g), t8(), g._vnode = m;
      return;
    }
    M4 = !1, c(g.firstChild, m, null, null, null), t8(), g._vnode = m, M4 && console.error("Hydration completed but contains mismatches.");
  }, c = (m, g, w, Z, b, z = !1) => {
    const K = b5(m) && m.data === "[", E = () => x(m, g, w, Z, b, K), { type: L2, ref: t2, shapeFlag: u2, patchFlag: N2 } = g;
    let m2 = m.nodeType;
    g.el = m, N2 === -2 && (z = !1, g.dynamicChildren = null);
    let P = null;
    switch (L2) {
      case c9:
        m2 !== 3 ? g.children === "" ? (L(g.el = s(""), o(m), m), P = m) : P = E() : (m.data !== g.children && (M4 = !0, m.data = g.children), P = r(m));
        break;
      case S1:
        m2 !== 8 || K ? P = E() : P = r(m);
        break;
      case o9:
        if (K && (m = r(m), m2 = m.nodeType), m2 === 1 || m2 === 3) {
          P = m;
          const W2 = !g.children.length;
          for (let $ = 0; $ < g.staticCount; $++)
            W2 && (g.children += P.nodeType === 1 ? P.outerHTML : P.data), $ === g.staticCount - 1 && (g.anchor = P), P = r(P);
          return K ? r(P) : P;
        } else
          E();
        break;
      case P2:
        K ? P = f(m, g, w, Z, b, z) : P = E();
        break;
      default:
        if (u2 & 1)
          m2 !== 1 || g.type.toLowerCase() !== m.tagName.toLowerCase() ? P = E() : P = h(m, g, w, Z, b, z);
        else if (u2 & 6) {
          g.slotScopeIds = b;
          const W2 = o(m);
          if (e(g, W2, null, w, Z, S5(W2), z), P = K ? k(m) : r(m), P && b5(P) && P.data === "teleport end" && (P = r(P)), i9(g)) {
            let $;
            K ? ($ = N(P2), $.anchor = P ? P.previousSibling : W2.lastChild) : $ = m.nodeType === 3 ? q3("") : N("div"), $.el = m, g.component.subTree = $;
          }
        } else
          u2 & 64 ? m2 !== 8 ? P = E() : P = g.type.hydrate(m, g, w, Z, b, z, t, d) : u2 & 128 && (P = g.type.hydrate(m, g, w, Z, S5(o(m)), b, z, t, c));
    }
    return t2 != null && i8(t2, null, Z, g), P;
  }, h = (m, g, w, Z, b, z) => {
    z = z || !!g.dynamicChildren;
    const { type: K, props: E, patchFlag: L2, shapeFlag: t2, dirs: u2 } = g, N2 = K === "input" && u2 || K === "option";
    if (N2 || L2 !== -1) {
      if (u2 && W3(g, null, w, "created"), E)
        if (N2 || !z || L2 & 48)
          for (const P in E)
            (N2 && P.endsWith("value") || w4(P) && !b9(P)) && i(m, P, null, E[P], !1, void 0, w);
        else
          E.onClick && i(m, "onClick", null, E.onClick, !1, void 0, w);
      let m2;
      if ((m2 = E && E.onVnodeBeforeMount) && t3(m2, w, g), u2 && W3(g, null, w, "beforeMount"), ((m2 = E && E.onVnodeMounted) || u2) && wr(() => {
        m2 && t3(m2, w, g), u2 && W3(g, null, w, "mounted");
      }, Z), t2 & 16 && // skip if element has innerHTML / textContent
      !(E && (E.innerHTML || E.textContent))) {
        let P = d(m.firstChild, g, m, w, Z, b, z);
        for (; P; ) {
          M4 = !0;
          const W2 = P;
          P = P.nextSibling, l(W2);
        }
      } else
        t2 & 8 && m.textContent !== g.children && (M4 = !0, m.textContent = g.children);
    }
    return m.nextSibling;
  }, d = (m, g, w, Z, b, z, K) => {
    K = K || !!g.dynamicChildren;
    const E = g.children, L2 = E.length;
    for (let t2 = 0; t2 < L2; t2++) {
      const u2 = K ? E[t2] : E[t2] = g3(E[t2]);
      if (m)
        m = c(m, u2, Z, b, z, K);
      else {
        if (u2.type === c9 && !u2.children)
          continue;
        M4 = !0, n(null, u2, w, null, Z, b, S5(w), z);
      }
    }
    return m;
  }, f = (m, g, w, Z, b, z) => {
    const { slotScopeIds: K } = g;
    K && (b = b ? b.concat(K) : K);
    const E = o(m), L2 = d(r(m), g, E, w, Z, b, z);
    return L2 && b5(L2) && L2.data === "]" ? r(g.anchor = L2) : (M4 = !0, L(g.anchor = a("]"), E, L2), L2);
  }, x = (m, g, w, Z, b, z) => {
    if (M4 = !0, g.el = null, z) {
      const L2 = k(m);
      for (; ; ) {
        const t2 = r(m);
        if (t2 && t2 !== L2)
          l(t2);
        else
          break;
      }
    }
    const K = r(m), E = o(m);
    return l(m), n(null, g, E, K, w, Z, S5(E), b), K;
  }, k = (m) => {
    let g = 0;
    for (; m; )
      if (m = r(m), m && b5(m) && (m.data === "[" && g++, m.data === "]")) {
        if (g === 0)
          return r(m);
        g--;
      }
    return m;
  };
  return [C, c];
}
const g1 = wr;
function io(t) {
  return ro(t);
}
function so(t) {
  return ro(t, $u);
}
function ro(t, e) {
  const n = $C();
  n.__VUE__ = !0;
  const { insert: i, remove: s, patchProp: r, createElement: o, createText: l, createComment: L, setText: a, setElementText: C, parentNode: c, nextSibling: h, setScopeId: d = o3, insertStaticContent: f } = t, x = (p, v, S, D = null, F = null, V = null, J = !1, G = null, q = !!v.dynamicChildren) => {
    if (p === v)
      return;
    p && !$3(p, v) && (D = n1(p), E2(p, F, V, !0), p = null), v.patchFlag === -2 && (q = !1, v.dynamicChildren = null);
    const { type: W, ref: H, shapeFlag: l2 } = v;
    switch (W) {
      case c9:
        k(p, v, S, D);
        break;
      case S1:
        m(p, v, S, D);
        break;
      case o9:
        p == null && g(v, S, D, J);
        break;
      case P2:
        N2(p, v, S, D, F, V, J, G, q);
        break;
      default:
        l2 & 1 ? b(p, v, S, D, F, V, J, G, q) : l2 & 6 ? m2(p, v, S, D, F, V, J, G, q) : (l2 & 64 || l2 & 128) && W.process(p, v, S, D, F, V, J, G, q, w1);
    }
    H != null && F && i8(H, p && p.ref, V, v || p, !v);
  }, k = (p, v, S, D) => {
    if (p == null)
      i(v.el = l(v.children), S, D);
    else {
      const F = v.el = p.el;
      v.children !== p.children && a(F, v.children);
    }
  }, m = (p, v, S, D) => {
    p == null ? i(v.el = L(v.children || ""), S, D) : v.el = p.el;
  }, g = (p, v, S, D) => {
    [p.el, p.anchor] = f(p.children, v, S, D, p.el, p.anchor);
  }, w = ({ el: p, anchor: v }, S, D) => {
    let F;
    for (; p && p !== v; )
      F = h(p), i(p, S, D), p = F;
    i(v, S, D);
  }, Z = ({ el: p, anchor: v }) => {
    let S;
    for (; p && p !== v; )
      S = h(p), s(p), p = S;
    s(v);
  }, b = (p, v, S, D, F, V, J, G, q) => {
    J = J || v.type === "svg", p == null ? z(v, S, D, F, V, J, G, q) : L2(p, v, F, V, J, G, q);
  }, z = (p, v, S, D, F, V, J, G) => {
    let q, W;
    const { type: H, props: l2, shapeFlag: n2, transition: r2, dirs: A2 } = p;
    if (q = p.el = o(p.type, V, l2 && l2.is, l2), n2 & 8 ? C(q, p.children) : n2 & 16 && E(p.children, q, null, D, F, V && H !== "foreignObject", J, G), A2 && W3(p, null, D, "created"), l2) {
      for (const H2 in l2)
        H2 !== "value" && !b9(H2) && r(q, H2, null, l2[H2], V, p.children, D, F, F2);
      "value" in l2 && r(q, "value", null, l2.value), (W = l2.onVnodeBeforeMount) && t3(W, D, p);
    }
    K(q, p, p.scopeId, J, D), A2 && W3(p, null, D, "beforeMount");
    const z2 = (!F || F && !F.pendingBranch) && r2 && !r2.persisted;
    z2 && r2.beforeEnter(q), i(q, v, S), ((W = l2 && l2.onVnodeMounted) || z2 || A2) && g1(() => {
      W && t3(W, D, p), z2 && r2.enter(q), A2 && W3(p, null, D, "mounted");
    }, F);
  }, K = (p, v, S, D, F) => {
    if (S && d(p, S), D)
      for (let V = 0; V < D.length; V++)
        d(p, D[V]);
    if (F) {
      let V = F.subTree;
      if (v === V) {
        const J = F.vnode;
        K(p, J, J.scopeId, J.slotScopeIds, F.parent);
      }
    }
  }, E = (p, v, S, D, F, V, J, G, q = 0) => {
    for (let W = q; W < p.length; W++) {
      const H = p[W] = G ? Z4(p[W]) : g3(p[W]);
      x(null, H, v, S, D, F, V, J, G);
    }
  }, L2 = (p, v, S, D, F, V, J) => {
    const G = v.el = p.el;
    let { patchFlag: q, dynamicChildren: W, dirs: H } = v;
    q |= p.patchFlag & 16;
    const l2 = p.props || X2, n2 = v.props || X2;
    let r2;
    S && V4(S, !1), (r2 = n2.onVnodeBeforeUpdate) && t3(r2, S, v, p), H && W3(v, p, S, "beforeUpdate"), S && V4(S, !0);
    const A2 = F && v.type !== "foreignObject";
    if (W ? t2(p.dynamicChildren, W, G, S, D, A2, V) : J || g2(p, v, G, null, S, D, A2, V, !1), q > 0) {
      if (q & 16)
        u2(G, v, l2, n2, S, D, F);
      else if (q & 2 && l2.class !== n2.class && r(G, "class", null, n2.class, F), q & 4 && r(G, "style", l2.style, n2.style, F), q & 8) {
        const z2 = v.dynamicProps;
        for (let H2 = 0; H2 < z2.length; H2++) {
          const Q2 = z2[H2], o2 = l2[Q2], h2 = n2[Q2];
          (h2 !== o2 || Q2 === "value") && r(G, Q2, o2, h2, F, p.children, S, D, F2);
        }
      }
      q & 1 && p.children !== v.children && C(G, v.children);
    } else
      !J && W == null && u2(G, v, l2, n2, S, D, F);
    ((r2 = n2.onVnodeUpdated) || H) && g1(() => {
      r2 && t3(r2, S, v, p), H && W3(v, p, S, "updated");
    }, D);
  }, t2 = (p, v, S, D, F, V, J) => {
    for (let G = 0; G < v.length; G++) {
      const q = p[G], W = v[G], H = (
        // oldVNode may be an errored async setup() component inside Suspense
        // which will not have a mounted element
        q.el && // - In the case of a Fragment, we need to provide the actual parent
        // of the Fragment itself so it can move its children.
        (q.type === P2 || // - In the case of different nodes, there is going to be a replacement
        // which also requires the correct parent container
        !$3(q, W) || // - In the case of a component, it could contain anything.
        q.shapeFlag & 70) ? c(q.el) : (
          // In other cases, the parent container is not actually used so we
          // just pass the block element here to avoid a DOM parentNode call.
          S
        )
      );
      x(q, W, H, null, D, F, V, J, !0);
    }
  }, u2 = (p, v, S, D, F, V, J) => {
    if (S !== D) {
      if (S !== X2)
        for (const G in S)
          !b9(G) && !(G in D) && r(p, G, S[G], null, J, v.children, F, V, F2);
      for (const G in D) {
        if (b9(G))
          continue;
        const q = D[G], W = S[G];
        q !== W && G !== "value" && r(p, G, W, q, J, v.children, F, V, F2);
      }
      "value" in D && r(p, "value", S.value, D.value);
    }
  }, N2 = (p, v, S, D, F, V, J, G, q) => {
    const W = v.el = p ? p.el : l(""), H = v.anchor = p ? p.anchor : l("");
    let { patchFlag: l2, dynamicChildren: n2, slotScopeIds: r2 } = v;
    r2 && (G = G ? G.concat(r2) : r2), p == null ? (i(W, S, D), i(H, S, D), E(v.children, S, H, F, V, J, G, q)) : l2 > 0 && l2 & 64 && n2 && // #2715 the previous fragment could've been a BAILed one as a result
    // of renderSlot() with no valid children
    p.dynamicChildren ? (t2(p.dynamicChildren, n2, S, F, V, J, G), // #2080 if the stable fragment has a key, it's a <template v-for> that may
    //  get moved around. Make sure all root level vnodes inherit el.
    // #2134 or if it's a component root, it may also get moved around
    // as the component is being moved.
    (v.key != null || F && v === F.subTree) && Se(
      p,
      v,
      !0
      /* shallow */
    )) : g2(p, v, S, H, F, V, J, G, q);
  }, m2 = (p, v, S, D, F, V, J, G, q) => {
    v.slotScopeIds = G, p == null ? v.shapeFlag & 512 ? F.ctx.activate(v, S, D, J, q) : P(v, S, D, F, V, J, q) : W2(p, v, q);
  }, P = (p, v, S, D, F, V, J) => {
    const G = p.isCompatRoot && p.component, q = G || (p.component = be(p, D, F));
    if (e5(p) && (q.ctx.renderer = w1), G || Ee(q), q.asyncDep) {
      if (F && F.registerDep(q, $), !p.el) {
        const W = q.subTree = N(S1);
        m(null, W, v, S);
      }
      return;
    }
    $(q, p, v, S, F, V, J);
  }, W2 = (p, v, S) => {
    const D = v.component = p.component;
    if (Gc(p, v, S))
      if (D.asyncDep && !D.asyncResolved) {
        s2(D, v, S);
        return;
      } else
        D.next = v, Ic(D.update), D.update();
    else
      v.el = p.el, D.vnode = v;
  }, $ = (p, v, S, D, F, V, J) => {
    const G = () => {
      if (p.isMounted) {
        let { next: H, bu: l2, u: n2, parent: r2, vnode: A2 } = p, z2 = H, H2;
        V4(p, !1), H ? (H.el = A2.el, s2(p, H, J)) : H = A2, l2 && I4(l2), (H2 = H.props && H.props.onVnodeBeforeUpdate) && t3(H2, r2, H, A2), Y2("INSTANCE_EVENT_HOOKS", p) && p.emit("hook:beforeUpdate"), V4(p, !0);
        const Q2 = j5(p), o2 = p.subTree;
        p.subTree = Q2, x(
          o2,
          Q2,
          // parent may have changed if it's in a teleport
          c(o2.el),
          // anchor may have changed if it's in a fragment
          n1(o2),
          p,
          F,
          V
        ), H.el = Q2.el, z2 === null && Me(p, Q2.el), n2 && g1(n2, F), (H2 = H.props && H.props.onVnodeUpdated) && g1(() => t3(H2, r2, H, A2), F), Y2("INSTANCE_EVENT_HOOKS", p) && g1(() => p.emit("hook:updated"), F);
      } else {
        let H;
        const { el: l2, props: n2 } = v, { bm: r2, m: A2, parent: z2 } = p, H2 = i9(v);
        if (V4(p, !1), r2 && I4(r2), !H2 && (H = n2 && n2.onVnodeBeforeMount) && t3(H, z2, v), Y2("INSTANCE_EVENT_HOOKS", p) && p.emit("hook:beforeMount"), V4(p, !0), l2 && d1) {
          const Q2 = () => {
            p.subTree = j5(p), d1(l2, p.subTree, p, F, null);
          };
          H2 ? v.type.__asyncLoader().then(
            // note: we are moving the render call into an async callback,
            // which means it won't track dependencies - but it's ok because
            // a server-rendered async wrapper is already in resolved state
            // and it will never need to change.
            () => !p.isUnmounted && Q2()
          ) : Q2();
        } else {
          const Q2 = p.subTree = j5(p);
          x(null, Q2, S, D, p, F, V), v.el = Q2.el;
        }
        if (A2 && g1(A2, F), !H2 && (H = n2 && n2.onVnodeMounted)) {
          const Q2 = v;
          g1(() => t3(H, z2, Q2), F);
        }
        Y2("INSTANCE_EVENT_HOOKS", p) && g1(() => p.emit("hook:mounted"), F), (v.shapeFlag & 256 || z2 && i9(z2.vnode) && z2.vnode.shapeFlag & 256) && (p.a && g1(p.a, F), Y2("INSTANCE_EVENT_HOOKS", p) && g1(() => p.emit("hook:activated"), F)), p.isMounted = !0, v = S = D = null;
      }
    }, q = p.effect = new X0(
      G,
      () => I8(W),
      p.scope
      // track it in component's effect scope
    ), W = p.update = () => q.run();
    W.id = p.uid, V4(p, !0), W();
  }, s2 = (p, v, S) => {
    v.component = p;
    const D = p.vnode.props;
    p.vnode = v, p.next = null, ku(p, v.props, D, S), bu(p, v.children, S), Y9(), Nn(), Q9();
  }, g2 = (p, v, S, D, F, V, J, G, q = !1) => {
    const W = p && p.children, H = p ? p.shapeFlag : 0, l2 = v.children, { patchFlag: n2, shapeFlag: r2 } = v;
    if (n2 > 0) {
      if (n2 & 128) {
        S2(W, l2, S, D, F, V, J, G, q);
        return;
      } else if (n2 & 256) {
        J2(W, l2, S, D, F, V, J, G, q);
        return;
      }
    }
    r2 & 8 ? (H & 16 && F2(W, F, V), l2 !== W && C(S, l2)) : H & 16 ? r2 & 16 ? S2(W, l2, S, D, F, V, J, G, q) : F2(W, F, V, !0) : (H & 8 && C(S, ""), r2 & 16 && E(l2, S, D, F, V, J, G, q));
  }, J2 = (p, v, S, D, F, V, J, G, q) => {
    p = p || T9, v = v || T9;
    const W = p.length, H = v.length, l2 = Math.min(W, H);
    let n2;
    for (n2 = 0; n2 < l2; n2++) {
      const r2 = v[n2] = q ? Z4(v[n2]) : g3(v[n2]);
      x(p[n2], r2, S, null, F, V, J, G, q);
    }
    W > H ? F2(p, F, V, !0, !1, l2) : E(v, S, D, F, V, J, G, q, l2);
  }, S2 = (p, v, S, D, F, V, J, G, q) => {
    let W = 0;
    const H = v.length;
    let l2 = p.length - 1, n2 = H - 1;
    for (; W <= l2 && W <= n2; ) {
      const r2 = p[W], A2 = v[W] = q ? Z4(v[W]) : g3(v[W]);
      if ($3(r2, A2))
        x(r2, A2, S, null, F, V, J, G, q);
      else
        break;
      W++;
    }
    for (; W <= l2 && W <= n2; ) {
      const r2 = p[l2], A2 = v[n2] = q ? Z4(v[n2]) : g3(v[n2]);
      if ($3(r2, A2))
        x(r2, A2, S, null, F, V, J, G, q);
      else
        break;
      l2--, n2--;
    }
    if (W > l2) {
      if (W <= n2) {
        const r2 = n2 + 1, A2 = r2 < H ? v[r2].el : D;
        for (; W <= n2; )
          x(null, v[W] = q ? Z4(v[W]) : g3(v[W]), S, A2, F, V, J, G, q), W++;
      }
    } else if (W > n2)
      for (; W <= l2; )
        E2(p[W], F, V, !0), W++;
    else {
      const r2 = W, A2 = W, z2 = /* @__PURE__ */ new Map();
      for (W = A2; W <= n2; W++) {
        const C1 = v[W] = q ? Z4(v[W]) : g3(v[W]);
        C1.key != null && z2.set(C1.key, W);
      }
      let H2, Q2 = 0;
      const o2 = n2 - A2 + 1;
      let h2 = !1, y2 = 0;
      const Z2 = new Array(o2);
      for (W = 0; W < o2; W++)
        Z2[W] = 0;
      for (W = r2; W <= l2; W++) {
        const C1 = p[W];
        if (Q2 >= o2) {
          E2(C1, F, V, !0);
          continue;
        }
        let b1;
        if (C1.key != null)
          b1 = z2.get(C1.key);
        else
          for (H2 = A2; H2 <= n2; H2++)
            if (Z2[H2 - A2] === 0 && $3(C1, v[H2])) {
              b1 = H2;
              break;
            }
        b1 === void 0 ? E2(C1, F, V, !0) : (Z2[b1 - A2] = W + 1, b1 >= y2 ? y2 = b1 : h2 = !0, x(C1, v[b1], S, null, F, V, J, G, q), Q2++);
      }
      const o1 = h2 ? Vu(Z2) : T9;
      for (H2 = o1.length - 1, W = o2 - 1; W >= 0; W--) {
        const C1 = A2 + W, b1 = v[C1], m5 = C1 + 1 < H ? v[C1 + 1].el : D;
        Z2[W] === 0 ? x(null, b1, S, m5, F, V, J, G, q) : h2 && (H2 < 0 || W !== o1[H2] ? y1(
          b1,
          S,
          m5,
          2
          /* MoveType.REORDER */
        ) : H2--);
      }
    }
  }, y1 = (p, v, S, D, F = null) => {
    const { el: V, type: J, transition: G, children: q, shapeFlag: W } = p;
    if (W & 6) {
      y1(p.component.subTree, v, S, D);
      return;
    }
    if (W & 128) {
      p.suspense.move(v, S, D);
      return;
    }
    if (W & 64) {
      J.move(p, v, S, w1);
      return;
    }
    if (J === P2) {
      i(V, v, S);
      for (let l2 = 0; l2 < q.length; l2++)
        y1(q[l2], v, S, D);
      i(p.anchor, v, S);
      return;
    }
    if (J === o9) {
      w(p, v, S);
      return;
    }
    if (D !== 2 && W & 1 && G)
      if (D === 0)
        G.beforeEnter(V), i(V, v, S), g1(() => G.enter(V), F);
      else {
        const { leave: l2, delayLeave: n2, afterLeave: r2 } = G, A2 = () => i(V, v, S), z2 = () => {
          l2(V, () => {
            A2(), r2 && r2();
          });
        };
        n2 ? n2(V, A2, z2) : z2();
      }
    else
      i(V, v, S);
  }, E2 = (p, v, S, D = !1, F = !1) => {
    const { type: V, props: J, ref: G, children: q, dynamicChildren: W, shapeFlag: H, patchFlag: l2, dirs: n2 } = p;
    if (G != null && i8(G, null, S, p, !0), H & 256) {
      v.ctx.deactivate(p);
      return;
    }
    const r2 = H & 1 && n2, A2 = !i9(p);
    let z2;
    if (A2 && (z2 = J && J.onVnodeBeforeUnmount) && t3(z2, v, p), H & 6)
      b2(p.component, S, D);
    else {
      if (H & 128) {
        p.suspense.unmount(S, D);
        return;
      }
      r2 && W3(p, null, v, "beforeUnmount"), H & 64 ? p.type.remove(p, v, S, F, w1, D) : W && // #1153: fast path should not be taken for non-stable (v-for) fragments
      (V !== P2 || l2 > 0 && l2 & 64) ? F2(W, v, S, !1, !0) : (V === P2 && l2 & 384 || !F && H & 16) && F2(q, v, S), D && U(p);
    }
    (A2 && (z2 = J && J.onVnodeUnmounted) || r2) && g1(() => {
      z2 && t3(z2, v, p), r2 && W3(p, null, v, "unmounted");
    }, S);
  }, U = (p) => {
    const { type: v, el: S, anchor: D, transition: F } = p;
    if (v === P2) {
      Q(S, D);
      return;
    }
    if (v === o9) {
      Z(p);
      return;
    }
    const V = () => {
      s(S), F && !F.persisted && F.afterLeave && F.afterLeave();
    };
    if (p.shapeFlag & 1 && F && !F.persisted) {
      const { leave: J, delayLeave: G } = F, q = () => J(S, V);
      G ? G(p.el, V, q) : q();
    } else
      V();
  }, Q = (p, v) => {
    let S;
    for (; p !== v; )
      S = h(p), s(p), p = S;
    s(v);
  }, b2 = (p, v, S) => {
    const { bum: D, scope: F, update: V, subTree: J, um: G } = p;
    D && I4(D), Y2("INSTANCE_EVENT_HOOKS", p) && p.emit("hook:beforeDestroy"), F.stop(), V && (V.active = !1, E2(J, p, v, S)), G && g1(G, v), Y2("INSTANCE_EVENT_HOOKS", p) && g1(() => p.emit("hook:destroyed"), v), g1(() => {
      p.isUnmounted = !0;
    }, v), v && v.pendingBranch && !v.isUnmounted && p.asyncDep && !p.asyncResolved && p.suspenseId === v.pendingId && (v.deps--, v.deps === 0 && v.resolve());
  }, F2 = (p, v, S, D = !1, F = !1, V = 0) => {
    for (let J = V; J < p.length; J++)
      E2(p[J], v, S, D, F);
  }, n1 = (p) => p.shapeFlag & 6 ? n1(p.component.subTree) : p.shapeFlag & 128 ? p.suspense.next() : h(p.anchor || p.el), J1 = (p, v, S) => {
    p == null ? v._vnode && E2(v._vnode, null, null, !0) : x(v._vnode || null, p, v, null, null, null, S), Nn(), t8(), v._vnode = p;
  }, w1 = {
    p: x,
    um: E2,
    m: y1,
    r: U,
    mt: P,
    mc: E,
    pc: g2,
    pbc: t2,
    n: n1,
    o: t
  };
  let A1, d1;
  return e && ([A1, d1] = e(w1)), {
    render: J1,
    hydrate: A1,
    createApp: Hu(J1, A1)
  };
}
function V4({ effect: t, update: e }, n) {
  t.allowRecurse = e.allowRecurse = n;
}
function Se(t, e, n = !1) {
  const i = t.children, s = e.children;
  if (e2(i) && e2(s))
    for (let r = 0; r < i.length; r++) {
      const o = i[r];
      let l = s[r];
      l.shapeFlag & 1 && !l.dynamicChildren && ((l.patchFlag <= 0 || l.patchFlag === 32) && (l = s[r] = Z4(s[r]), l.el = o.el), n || Se(o, l)), l.type === c9 && (l.el = o.el);
    }
}
function Vu(t) {
  const e = t.slice(), n = [0];
  let i, s, r, o, l;
  const L = t.length;
  for (i = 0; i < L; i++) {
    const a = t[i];
    if (a !== 0) {
      if (s = n[n.length - 1], t[s] < a) {
        e[i] = s, n.push(i);
        continue;
      }
      for (r = 0, o = n.length - 1; r < o; )
        l = r + o >> 1, t[n[l]] < a ? r = l + 1 : o = l;
      a < t[n[r]] && (r > 0 && (e[i] = n[r - 1]), n[r] = i);
    }
  }
  for (r = n.length, o = n[r - 1]; r-- > 0; )
    n[r] = o, o = e[o];
  return n;
}
const Gu = (t) => t.__isTeleport, M0 = (t) => t && (t.disabled || t.disabled === ""), Xn = (t) => typeof SVGElement < "u" && t instanceof SVGElement, f6 = (t, e) => {
  const n = t && t.to;
  return r1(n) ? e ? e(n) : null : n;
}, ju = {
  __isTeleport: !0,
  process(t, e, n, i, s, r, o, l, L, a) {
    const { mc: C, pc: c, pbc: h, o: { insert: d, querySelector: f, createText: x, createComment: k } } = a, m = M0(e.props);
    let { shapeFlag: g, children: w, dynamicChildren: Z } = e;
    if (t == null) {
      const b = e.el = x(""), z = e.anchor = x("");
      d(b, n, i), d(z, n, i);
      const K = e.target = f6(e.props, f), E = e.targetAnchor = x("");
      K && (d(E, K), o = o || Xn(K));
      const L2 = (t2, u2) => {
        g & 16 && C(w, t2, u2, s, r, o, l, L);
      };
      m ? L2(n, z) : K && L2(K, E);
    } else {
      e.el = t.el;
      const b = e.anchor = t.anchor, z = e.target = t.target, K = e.targetAnchor = t.targetAnchor, E = M0(t.props), L2 = E ? n : z, t2 = E ? b : K;
      if (o = o || Xn(z), Z ? (h(t.dynamicChildren, Z, L2, s, r, o, l), Se(t, e, !0)) : L || c(t, e, L2, t2, s, r, o, l, !1), m)
        E || E5(
          e,
          n,
          b,
          a,
          1
          /* TeleportMoveTypes.TOGGLE */
        );
      else if ((e.props && e.props.to) !== (t.props && t.props.to)) {
        const u2 = e.target = f6(e.props, f);
        u2 && E5(
          e,
          u2,
          null,
          a,
          0
          /* TeleportMoveTypes.TARGET_CHANGE */
        );
      } else
        E && E5(
          e,
          z,
          K,
          a,
          1
          /* TeleportMoveTypes.TOGGLE */
        );
    }
    lo(e);
  },
  remove(t, e, n, i, { um: s, o: { remove: r } }, o) {
    const { shapeFlag: l, children: L, anchor: a, targetAnchor: C, target: c, props: h } = t;
    if (c && r(C), (o || !M0(h)) && (r(a), l & 16))
      for (let d = 0; d < L.length; d++) {
        const f = L[d];
        s(f, e, n, !0, !!f.dynamicChildren);
      }
  },
  move: E5,
  hydrate: qu
};
function E5(t, e, n, { o: { insert: i }, m: s }, r = 2) {
  r === 0 && i(t.targetAnchor, e, n);
  const { el: o, anchor: l, shapeFlag: L, children: a, props: C } = t, c = r === 2;
  if (c && i(o, e, n), (!c || M0(C)) && L & 16)
    for (let h = 0; h < a.length; h++)
      s(
        a[h],
        e,
        n,
        2
        /* MoveType.REORDER */
      );
  c && i(l, e, n);
}
function qu(t, e, n, i, s, r, { o: { nextSibling: o, parentNode: l, querySelector: L } }, a) {
  const C = e.target = f6(e.props, L);
  if (C) {
    const c = C._lpa || C.firstChild;
    if (e.shapeFlag & 16)
      if (M0(e.props))
        e.anchor = a(o(t), e, l(t), n, i, s, r), e.targetAnchor = c;
      else {
        e.anchor = o(t);
        let h = c;
        for (; h; )
          if (h = o(h), h && h.nodeType === 8 && h.data === "teleport anchor") {
            e.targetAnchor = h, C._lpa = e.targetAnchor && o(e.targetAnchor);
            break;
          }
        a(c, e, C, n, i, s, r);
      }
    lo(e);
  }
  return e.anchor && o(e.anchor);
}
const oo = ju;
function lo(t) {
  const e = t.ctx;
  if (e && e.ut) {
    let n = t.children[0].el;
    for (; n !== t.targetAnchor; )
      n.nodeType === 1 && n.setAttribute("data-v-owner", e.uid), n = n.nextSibling;
    e.ut();
  }
}
const S7 = /* @__PURE__ */ new Map();
function Ku(t) {
  if (S7.has(t))
    return S7.get(t);
  let e, n;
  const i = new Promise((o, l) => {
    e = o, n = l;
  }), s = t(e, n);
  let r;
  return A8(s) ? r = v0(() => s) : B2(s) && !_3(s) && !e2(s) ? r = v0({
    loader: () => s.component,
    loadingComponent: s.loading,
    errorComponent: s.error,
    delay: s.delay,
    timeout: s.timeout
  }) : s == null ? r = v0(() => i) : r = t, S7.set(t, r), r;
}
function Yu(t, e) {
  return t.__isBuiltIn ? t : (p2(t) && t.cid && (t = t.options), p2(t) && F8("COMPONENT_ASYNC", e, t) ? Ku(t) : B2(t) && t.functional && g4("COMPONENT_FUNCTIONAL", e, t) ? Cu(t) : t);
}
const P2 = Symbol(void 0), c9 = Symbol(void 0), S1 = Symbol(void 0), o9 = Symbol(void 0), R0 = [];
let s3 = null;
function T(t = !1) {
  R0.push(s3 = t ? null : []);
}
function Lo() {
  R0.pop(), s3 = R0[R0.length - 1] || null;
}
let u9 = 1;
function p6(t) {
  u9 += t;
}
function ao(t) {
  return t.dynamicChildren = u9 > 0 ? s3 || T9 : null, Lo(), u9 > 0 && s3 && s3.push(t), t;
}
function B(t, e, n, i, s, r) {
  return ao(_(
    t,
    e,
    n,
    i,
    s,
    r,
    !0
    /* isBlock */
  ));
}
function T2(t, e, n, i, s) {
  return ao(N(
    t,
    e,
    n,
    i,
    s,
    !0
    /* isBlock: prevent a block from tracking itself */
  ));
}
function _3(t) {
  return t ? t.__v_isVNode === !0 : !1;
}
function $3(t, e) {
  return t.type === e.type && t.key === e.key;
}
function Qu(t) {
}
const U8 = "__vInternal", Co = ({ key: t }) => t ?? null, q5 = ({ ref: t, ref_key: e, ref_for: n }) => t != null ? r1(t) || R1(t) || p2(t) ? { i: p1, r: t, k: e, f: !!n } : t : null;
function _(t, e = null, n = null, i = 0, s = null, r = t === P2 ? 0 : 1, o = !1, l = !1) {
  const L = {
    __v_isVNode: !0,
    __v_skip: !0,
    type: t,
    props: e,
    key: e && Co(e),
    ref: e && q5(e),
    scopeId: F9,
    slotScopeIds: null,
    children: n,
    component: null,
    suspense: null,
    ssContent: null,
    ssFallback: null,
    dirs: null,
    transition: null,
    el: null,
    anchor: null,
    target: null,
    targetAnchor: null,
    staticCount: 0,
    shapeFlag: r,
    patchFlag: i,
    dynamicProps: s,
    dynamicChildren: null,
    appContext: null,
    ctx: p1
  };
  return l ? (H8(L, n), r & 128 && t.normalize(L)) : n && (L.shapeFlag |= r1(n) ? 8 : 16), u9 > 0 && // avoid a block node from tracking itself
  !o && // has current parent block
  s3 && // presence of a patch flag indicates this node needs patching on updates.
  // component nodes also should always be patched, because even if the
  // component doesn't need to update, it needs to persist the instance on to
  // the next vnode so that it can be properly unmounted later.
  (L.patchFlag > 0 || r & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
  // vnode should not be considered dynamic due to handler caching.
  L.patchFlag !== 32 && s3.push(L), Bc(L), zr(L), L;
}
const N = Xu;
function Xu(t, e = null, n = null, i = 0, s = null, r = !1) {
  if ((!t || t === Dr) && (t = S1), _3(t)) {
    const l = T3(
      t,
      e,
      !0
      /* mergeRef: true */
    );
    return n && H8(l, n), u9 > 0 && !r && s3 && (l.shapeFlag & 6 ? s3[s3.indexOf(t)] = l : s3.push(l)), l.patchFlag |= -2, l;
  }
  if (sh(t) && (t = t.__vccOpts), t = Yu(t, p1), e) {
    e = co(e);
    let { class: l, style: L } = e;
    l && !r1(l) && (e.class = v2(l)), B2(L) && (ue(L) && !e2(L) && (L = U2({}, L)), e.style = w2(L));
  }
  const o = r1(t) ? 1 : mr(t) ? 128 : Gu(t) ? 64 : B2(t) ? 4 : p2(t) ? 2 : 0;
  return _(t, e, n, i, s, o, r, !0);
}
function co(t) {
  return t ? ue(t) || U8 in t ? U2({}, t) : t : null;
}
function T3(t, e, n = !1) {
  const { props: i, ref: s, patchFlag: r, children: o } = t, l = e ? $8(i || {}, e) : i, L = {
    __v_isVNode: !0,
    __v_skip: !0,
    type: t.type,
    props: l,
    key: l && Co(l),
    ref: e && e.ref ? (
      // #2078 in the case of <component :is="vnode" ref="extra"/>
      // if the vnode itself already has a ref, cloneVNode will need to merge
      // the refs so the single vnode can be set on multiple refs
      n && s ? e2(s) ? s.concat(q5(e)) : [s, q5(e)] : q5(e)
    ) : s,
    scopeId: t.scopeId,
    slotScopeIds: t.slotScopeIds,
    children: o,
    target: t.target,
    targetAnchor: t.targetAnchor,
    staticCount: t.staticCount,
    shapeFlag: t.shapeFlag,
    // if the vnode is cloned with extra props, we can no longer assume its
    // existing patch flag to be reliable and need to add the FULL_PROPS flag.
    // note: preserve flag for fragments since they use the flag for children
    // fast paths only.
    patchFlag: e && t.type !== P2 ? r === -1 ? 16 : r | 16 : r,
    dynamicProps: t.dynamicProps,
    dynamicChildren: t.dynamicChildren,
    appContext: t.appContext,
    dirs: t.dirs,
    transition: t.transition,
    // These should technically only be non-null on mounted VNodes. However,
    // they *should* be copied for kept-alive vnodes. So we just always copy
    // them since them being non-null during a mount doesn't affect the logic as
    // they will simply be overwritten.
    component: t.component,
    suspense: t.suspense,
    ssContent: t.ssContent && T3(t.ssContent),
    ssFallback: t.ssFallback && T3(t.ssFallback),
    el: t.el,
    anchor: t.anchor,
    ctx: t.ctx
  };
  return zr(L), L;
}
function q3(t = " ", e = 0) {
  return N(c9, null, t, e);
}
function W8(t, e) {
  const n = N(o9, null, t);
  return n.staticCount = e, n;
}
function x2(t = "", e = !1) {
  return e ? (T(), T2(S1, null, t)) : N(S1, null, t);
}
function g3(t) {
  return t == null || typeof t == "boolean" ? N(S1) : e2(t) ? N(
    P2,
    null,
    // #3666, avoid reference pollution when reusing vnode
    t.slice()
  ) : typeof t == "object" ? Z4(t) : N(c9, null, String(t));
}
function Z4(t) {
  return t.el === null && t.patchFlag !== -1 || t.memo ? t : T3(t);
}
function H8(t, e) {
  let n = 0;
  const { shapeFlag: i } = t;
  if (e == null)
    e = null;
  else if (e2(e))
    n = 16;
  else if (typeof e == "object")
    if (i & 65) {
      const s = e.default;
      s && (s._c && (s._d = !1), H8(t, s()), s._c && (s._d = !0));
      return;
    } else {
      n = 32;
      const s = e._;
      !s && !(U8 in e) ? e._ctx = p1 : s === 3 && p1 && (p1.slots._ === 1 ? e._ = 1 : (e._ = 2, t.patchFlag |= 1024));
    }
  else
    p2(e) ? (e = { default: e, _ctx: p1 }, n = 32) : (e = String(e), i & 64 ? (n = 16, e = [q3(e)]) : n = 8);
  t.children = e, t.shapeFlag |= n;
}
function $8(...t) {
  const e = {};
  for (let n = 0; n < t.length; n++) {
    const i = t[n];
    for (const s in i)
      if (s === "class")
        e.class !== i.class && (e.class = v2([e.class, i.class]));
      else if (s === "style")
        e.style = w2([e.style, i.style]);
      else if (w4(s)) {
        const r = e[s], o = i[s];
        o && r !== o && !(e2(r) && r.includes(o)) && (e[s] = r ? [].concat(r, o) : o);
      } else
        s !== "" && (e[s] = i[s]);
  }
  return e;
}
function t3(t, e, n, i = null) {
  l3(t, e, 7, [
    n,
    i
  ]);
}
const Ju = no();
let eh = 0;
function be(t, e, n) {
  const i = t.type, s = (e ? e.appContext : t.appContext) || Ju, r = {
    uid: eh++,
    vnode: t,
    type: i,
    parent: e,
    appContext: s,
    root: null,
    next: null,
    subTree: null,
    effect: null,
    update: null,
    scope: new Le(
      !0
      /* detached */
    ),
    render: null,
    proxy: null,
    exposed: null,
    exposeProxy: null,
    withProxy: null,
    provides: e ? e.provides : Object.create(s.provides),
    accessCache: null,
    renderCache: [],
    // local resolved assets
    components: null,
    directives: null,
    // resolved props and emits options
    propsOptions: Qr(i, s),
    emitsOptions: pr(i, s),
    // emit
    emit: null,
    emitted: null,
    // props default value
    propsDefaults: X2,
    // inheritAttrs
    inheritAttrs: i.inheritAttrs,
    // state
    ctx: X2,
    data: X2,
    props: X2,
    attrs: X2,
    slots: X2,
    refs: X2,
    setupState: X2,
    setupContext: null,
    // suspense related
    suspense: n,
    suspenseId: n ? n.pendingId : 0,
    asyncDep: null,
    asyncResolved: !1,
    // lifecycle hooks
    // not using enums here because it results in computed properties
    isMounted: !1,
    isUnmounted: !1,
    isDeactivated: !1,
    bc: null,
    c: null,
    bm: null,
    m: null,
    bu: null,
    u: null,
    um: null,
    bum: null,
    da: null,
    a: null,
    rtg: null,
    rtc: null,
    ec: null,
    sp: null
  };
  return r.ctx = { _: r }, r.root = e ? e.root : r, r.emit = Uc.bind(null, r), t.ce && t.ce(r), r;
}
let _1 = null;
const l4 = () => _1 || p1, B4 = (t) => {
  _1 = t, t.scope.on();
}, O4 = () => {
  _1 && _1.scope.off(), _1 = null;
};
function uo(t) {
  return t.vnode.shapeFlag & 4;
}
let W9 = !1;
function Ee(t, e = !1) {
  W9 = e;
  const { props: n, children: i } = t.vnode, s = uo(t);
  Zu(t, n, s, e), Su(t, i);
  const r = s ? th(t, e) : void 0;
  return W9 = !1, r;
}
function th(t, e) {
  const n = t.type;
  t.accessCache = /* @__PURE__ */ Object.create(null), t.proxy = he(new Proxy(t.ctx, u6));
  const { setup: i } = n;
  if (i) {
    const s = t.setupContext = i.length > 1 ? ho(t) : null;
    B4(t), Y9();
    const r = j3(i, t, 0, [t.props, s]);
    if (Q9(), O4(), A8(r)) {
      if (r.then(O4, O4), e)
        return r.then((o) => {
          m6(t, o, e);
        }).catch((o) => {
          f9(
            o,
            t,
            0
            /* ErrorCodes.SETUP_FUNCTION */
          );
        });
      t.asyncDep = r;
    } else
      m6(t, r, e);
  } else
    Ie(t, e);
}
function m6(t, e, n) {
  p2(e) ? t.type.__ssrInlineRender ? t.ssrRender = e : t.render = e : B2(e) && (t.setupState = fe(e)), Ie(t, n);
}
let s8, w6;
function nh(t) {
  s8 = t, w6 = (e) => {
    e.render._rc && (e.withProxy = new Proxy(e.ctx, vu));
  };
}
const x6 = () => !s8;
function Ie(t, e, n) {
  const i = t.type;
  if (lu(t), !t.render) {
    if (!e && s8 && !i.render) {
      const s = t.vnode.props && t.vnode.props["inline-template"] || i.template || n5(t).template;
      if (s) {
        const { isCustomElement: r, compilerOptions: o } = t.appContext.config, { delimiters: l, compilerOptions: L } = i, a = U2(U2({
          isCustomElement: r,
          delimiters: l
        }, o), L);
        a.compatConfig = Object.create(we), i.compatConfig && U2(a.compatConfig, i.compatConfig), i.render = s8(s, a);
      }
    }
    t.render = i.render || o3, w6 && w6(t);
  }
  n || (B4(t), Y9(), Mu(t), Q9(), O4());
}
function ih(t) {
  return new Proxy(t.attrs, {
    get(e, n) {
      return L3(t, "get", "$attrs"), e[n];
    }
  });
}
function ho(t) {
  const e = (i) => {
    t.exposed = i || {};
  };
  let n;
  return {
    get attrs() {
      return n || (n = ih(t));
    },
    slots: t.slots,
    emit: t.emit,
    expose: e
  };
}
function V8(t) {
  if (t.exposed)
    return t.exposeProxy || (t.exposeProxy = new Proxy(fe(he(t.exposed)), {
      get(e, n) {
        if (n in e)
          return e[n];
        if (n in N9)
          return N9[n](t);
      },
      has(e, n) {
        return n in e || n in N9;
      }
    }));
}
function _6(t, e = !0) {
  return p2(t) ? t.displayName || t.name : t.name || e && t.__name;
}
function sh(t) {
  return p2(t) && "__vccOpts" in t;
}
const I = (t, e) => Tc(t, e, W9);
function rh() {
  return null;
}
function oh() {
  return null;
}
function lh(t) {
}
function Lh(t, e) {
  return null;
}
function ah() {
  return go().slots;
}
function Ch() {
  return go().attrs;
}
function go() {
  const t = l4();
  return t.setupContext || (t.setupContext = ho(t));
}
function ch(t, e) {
  const n = e2(t) ? t.reduce((i, s) => (i[s] = {}, i), {}) : t;
  for (const i in e) {
    const s = n[i];
    s ? e2(s) || p2(s) ? n[i] = { type: s, default: e[i] } : s.default = e[i] : s === null && (n[i] = { default: e[i] });
  }
  return n;
}
function uh(t, e) {
  const n = {};
  for (const i in t)
    e.includes(i) || Object.defineProperty(n, i, {
      enumerable: !0,
      get: () => t[i]
    });
  return n;
}
function hh(t) {
  const e = l4();
  let n = t();
  return O4(), A8(n) && (n = n.catch((i) => {
    throw B4(e), i;
  })), [n, () => B4(e)];
}
function f1(t, e, n) {
  const i = arguments.length;
  return i === 2 ? B2(e) && !e2(e) ? _3(e) ? N(t, null, [e]) : N(t, e) : N(t, null, e) : (i > 3 ? n = Array.prototype.slice.call(arguments, 2) : i === 3 && _3(n) && (n = [n]), N(t, e, n));
}
const fo = Symbol(""), po = () => u1(fo);
function dh() {
}
function gh(t, e, n, i) {
  const s = n[i];
  if (s && mo(s, t))
    return s;
  const r = e();
  return r.memo = t.slice(), n[i] = r;
}
function mo(t, e) {
  const n = t.memo;
  if (n.length != e.length)
    return !1;
  for (let i = 0; i < n.length; i++)
    if (z9(n[i], e[i]))
      return !1;
  return u9 > 0 && s3 && s3.push(t), !0;
}
const wo = "3.2.45", fh = {
  createComponentInstance: be,
  setupComponent: Ee,
  renderComponentRoot: j5,
  setCurrentRenderingInstance: z0,
  isVNode: _3,
  normalizeVNode: g3
}, ph = fh, mh = Br, wh = {
  warnDeprecation: Oc,
  createCompatVue: Iu,
  isCompatEnabled: Y2,
  checkCompatEnabled: F8,
  softAssertCompatEnabled: g4
}, t4 = wh, xh = "http://www.w3.org/2000/svg", X4 = typeof document < "u" ? document : null, Jn = X4 && /* @__PURE__ */ X4.createElement("template"), _h = {
  insert: (t, e, n) => {
    e.insertBefore(t, n || null);
  },
  remove: (t) => {
    const e = t.parentNode;
    e && e.removeChild(t);
  },
  createElement: (t, e, n, i) => {
    const s = e ? X4.createElementNS(xh, t) : X4.createElement(t, n ? { is: n } : void 0);
    return t === "select" && i && i.multiple != null && s.setAttribute("multiple", i.multiple), s;
  },
  createText: (t) => X4.createTextNode(t),
  createComment: (t) => X4.createComment(t),
  setText: (t, e) => {
    t.nodeValue = e;
  },
  setElementText: (t, e) => {
    t.textContent = e;
  },
  parentNode: (t) => t.parentNode,
  nextSibling: (t) => t.nextSibling,
  querySelector: (t) => X4.querySelector(t),
  setScopeId(t, e) {
    t.setAttribute(e, "");
  },
  // __UNSAFE__
  // Reason: innerHTML.
  // Static content here can only come from compiled templates.
  // As long as the user only uses trusted templates, this is safe.
  insertStaticContent(t, e, n, i, s, r) {
    const o = n ? n.previousSibling : e.lastChild;
    if (s && (s === r || s.nextSibling))
      for (; e.insertBefore(s.cloneNode(!0), n), !(s === r || !(s = s.nextSibling)); )
        ;
    else {
      Jn.innerHTML = i ? `<svg>${t}</svg>` : t;
      const l = Jn.content;
      if (i) {
        const L = l.firstChild;
        for (; L.firstChild; )
          l.appendChild(L.firstChild);
        l.removeChild(L);
      }
      e.insertBefore(l, n);
    }
    return [
      // first
      o ? o.nextSibling : e.firstChild,
      // last
      n ? n.previousSibling : e.lastChild
    ];
  }
};
function vh(t, e, n) {
  const i = t._vtc;
  i && (e = (e ? [e, ...i] : [...i]).join(" ")), e == null ? t.removeAttribute("class") : n ? t.setAttribute("class", e) : t.className = e;
}
function Mh(t, e, n) {
  const i = t.style, s = r1(n);
  if (n && !s) {
    for (const r in n)
      v6(i, r, n[r]);
    if (e && !r1(e))
      for (const r in e)
        n[r] == null && v6(i, r, "");
  } else {
    const r = i.display;
    s ? e !== n && (i.cssText = n) : e && t.removeAttribute("style"), "_vod" in t && (i.display = r);
  }
}
const ei = /\s*!important$/;
function v6(t, e, n) {
  if (e2(n))
    n.forEach((i) => v6(t, e, i));
  else if (n == null && (n = ""), e.startsWith("--"))
    t.setProperty(e, n);
  else {
    const i = Rh(t, e);
    ei.test(n) ? t.setProperty(W1(i), n.replace(ei, ""), "important") : t[i] = n;
  }
}
const ti = ["Webkit", "Moz", "ms"], b7 = {};
function Rh(t, e) {
  const n = b7[e];
  if (n)
    return n;
  let i = G1(e);
  if (i !== "filter" && i in t)
    return b7[e] = i;
  i = Q0(i);
  for (let s = 0; s < ti.length; s++) {
    const r = ti[s] + i;
    if (r in t)
      return b7[e] = r;
  }
  return e;
}
const ni = "http://www.w3.org/1999/xlink";
function yh(t, e, n, i, s) {
  if (i && e.startsWith("xlink:"))
    n == null ? t.removeAttributeNS(ni, e.slice(6, e.length)) : t.setAttributeNS(ni, e, n);
  else {
    if (Zh(t, e, n, s))
      return;
    const r = Hs(e);
    n == null || r && !$s(n) ? t.removeAttribute(e) : t.setAttribute(e, r ? "" : n);
  }
}
const Ah = /* @__PURE__ */ K9("contenteditable,draggable,spellcheck");
function Zh(t, e, n, i = null) {
  if (Ah(e)) {
    const s = n === null ? "false" : typeof n != "boolean" && n !== void 0 ? "true" : null;
    if (s && t4.softAssertCompatEnabled("ATTR_ENUMERATED_COERCION", i, e, n, s))
      return t.setAttribute(e, s), !0;
  } else if (n === !1 && !Hs(e) && t4.softAssertCompatEnabled("ATTR_FALSE_VALUE", i, e))
    return t.removeAttribute(e), !0;
  return !1;
}
function kh(t, e, n, i, s, r, o) {
  if (e === "innerHTML" || e === "textContent") {
    i && o(i, s, r), t[e] = n ?? "";
    return;
  }
  if (e === "value" && t.tagName !== "PROGRESS" && // custom elements may use _value internally
  !t.tagName.includes("-")) {
    t._value = n;
    const L = n ?? "";
    (t.value !== L || // #4956: always set for OPTION elements because its value falls back to
    // textContent if no value attribute is present. And setting .value for
    // OPTION has no side effect
    t.tagName === "OPTION") && (t.value = L), n == null && t.removeAttribute(e);
    return;
  }
  let l = !1;
  if (n === "" || n == null) {
    const L = typeof t[e];
    L === "boolean" ? n = $s(n) : n == null && L === "string" ? (n = "", l = !0) : L === "number" && (n = 0, l = !0);
  } else if (n === !1 && t4.isCompatEnabled("ATTR_FALSE_VALUE", s)) {
    const L = typeof t[e];
    (L === "string" || L === "number") && (n = L === "number" ? 0 : "", l = !0);
  }
  try {
    t[e] = n;
  } catch {
  }
  l && t.removeAttribute(e);
}
function c4(t, e, n, i) {
  t.addEventListener(e, n, i);
}
function Th(t, e, n, i) {
  t.removeEventListener(e, n, i);
}
function Sh(t, e, n, i, s = null) {
  const r = t._vei || (t._vei = {}), o = r[e];
  if (i && o)
    o.value = i;
  else {
    const [l, L] = bh(e);
    if (i) {
      const a = r[e] = Fh(i, s);
      c4(t, l, a, L);
    } else
      o && (Th(t, l, o, L), r[e] = void 0);
  }
}
const ii = /(?:Once|Passive|Capture)$/;
function bh(t) {
  let e;
  if (ii.test(t)) {
    e = {};
    let i;
    for (; i = t.match(ii); )
      t = t.slice(0, t.length - i[0].length), e[i[0].toLowerCase()] = !0;
  }
  return [t[2] === ":" ? t.slice(3) : W1(t.slice(2)), e];
}
let E7 = 0;
const Eh = /* @__PURE__ */ Promise.resolve(), Ih = () => E7 || (Eh.then(() => E7 = 0), E7 = Date.now());
function Fh(t, e) {
  const n = (i) => {
    if (!i._vts)
      i._vts = Date.now();
    else if (i._vts <= n.attached)
      return;
    l3(Oh(i, n.value), e, 5, [i]);
  };
  return n.value = t, n.attached = Ih(), n;
}
function Oh(t, e) {
  if (e2(e)) {
    const n = t.stopImmediatePropagation;
    return t.stopImmediatePropagation = () => {
      n.call(t), t._stopped = !0;
    }, e.map((i) => (s) => !s._stopped && i && i(s));
  } else
    return e;
}
const si = /^on[a-z]/, Nh = (t, e, n, i, s = !1, r, o, l, L) => {
  e === "class" ? vh(t, i, s) : e === "style" ? Mh(t, n, i) : w4(e) ? re(e) || Sh(t, e, n, i, o) : (e[0] === "." ? (e = e.slice(1), !0) : e[0] === "^" ? (e = e.slice(1), !1) : Dh(t, e, i, s)) ? kh(t, e, i, r, o, l, L) : (e === "true-value" ? t._trueValue = i : e === "false-value" && (t._falseValue = i), yh(t, e, i, s, o));
};
function Dh(t, e, n, i) {
  return i ? !!(e === "innerHTML" || e === "textContent" || e in t && si.test(e) && p2(n)) : e === "spellcheck" || e === "draggable" || e === "translate" || e === "form" || e === "list" && t.tagName === "INPUT" || e === "type" && t.tagName === "TEXTAREA" || si.test(e) && r1(n) ? !1 : e in t;
}
function xo(t, e) {
  const n = q2(t);
  class i extends G8 {
    constructor(r) {
      super(n, r, e);
    }
  }
  return i.def = n, i;
}
const Ph = (t) => xo(t, Oo), Bh = typeof HTMLElement < "u" ? HTMLElement : class {
};
class G8 extends Bh {
  constructor(e, n = {}, i) {
    super(), this._def = e, this._props = n, this._instance = null, this._connected = !1, this._resolved = !1, this._numberProps = null, this.shadowRoot && i ? i(this._createVNode(), this.shadowRoot) : (this.attachShadow({ mode: "open" }), this._def.__asyncLoader || this._resolveProps(this._def));
  }
  connectedCallback() {
    this._connected = !0, this._instance || (this._resolved ? this._update() : this._resolveDef());
  }
  disconnectedCallback() {
    this._connected = !1, P4(() => {
      this._connected || (y6(null, this.shadowRoot), this._instance = null);
    });
  }
  /**
   * resolve inner component definition (handle possible async component)
   */
  _resolveDef() {
    this._resolved = !0;
    for (let i = 0; i < this.attributes.length; i++)
      this._setAttr(this.attributes[i].name);
    new MutationObserver((i) => {
      for (const s of i)
        this._setAttr(s.attributeName);
    }).observe(this, { attributes: !0 });
    const e = (i, s = !1) => {
      const { props: r, styles: o } = i;
      let l;
      if (r && !e2(r))
        for (const L in r) {
          const a = r[L];
          (a === Number || a && a.type === Number) && (L in this._props && (this._props[L] = Q3(this._props[L])), (l || (l = /* @__PURE__ */ Object.create(null)))[G1(L)] = !0);
        }
      this._numberProps = l, s && this._resolveProps(i), this._applyStyles(o), this._update();
    }, n = this._def.__asyncLoader;
    n ? n().then((i) => e(i, !0)) : e(this._def);
  }
  _resolveProps(e) {
    const { props: n } = e, i = e2(n) ? n : Object.keys(n || {});
    for (const s of Object.keys(this))
      s[0] !== "_" && i.includes(s) && this._setProp(s, this[s], !0, !1);
    for (const s of i.map(G1))
      Object.defineProperty(this, s, {
        get() {
          return this._getProp(s);
        },
        set(r) {
          this._setProp(s, r);
        }
      });
  }
  _setAttr(e) {
    let n = this.getAttribute(e);
    const i = G1(e);
    this._numberProps && this._numberProps[i] && (n = Q3(n)), this._setProp(i, n, !1);
  }
  /**
   * @internal
   */
  _getProp(e) {
    return this._props[e];
  }
  /**
   * @internal
   */
  _setProp(e, n, i = !0, s = !0) {
    n !== this._props[e] && (this._props[e] = n, s && this._instance && this._update(), i && (n === !0 ? this.setAttribute(W1(e), "") : typeof n == "string" || typeof n == "number" ? this.setAttribute(W1(e), n + "") : n || this.removeAttribute(W1(e))));
  }
  _update() {
    y6(this._createVNode(), this.shadowRoot);
  }
  _createVNode() {
    const e = N(this._def, U2({}, this._props));
    return this._instance || (e.ce = (n) => {
      this._instance = n, n.isCE = !0;
      const i = (r, o) => {
        this.dispatchEvent(new CustomEvent(r, {
          detail: o
        }));
      };
      n.emit = (r, ...o) => {
        i(r, o), W1(r) !== r && i(W1(r), o);
      };
      let s = this;
      for (; s = s && (s.parentNode || s.host); )
        if (s instanceof G8) {
          n.parent = s._instance, n.provides = s._instance.provides;
          break;
        }
    }), e;
  }
  _applyStyles(e) {
    e && e.forEach((n) => {
      const i = document.createElement("style");
      i.textContent = n, this.shadowRoot.appendChild(i);
    });
  }
}
function zh(t = "$style") {
  {
    const e = l4();
    if (!e)
      return X2;
    const n = e.type.__cssModules;
    if (!n)
      return X2;
    const i = n[t];
    return i || X2;
  }
}
function Uh(t) {
  const e = l4();
  if (!e)
    return;
  const n = e.ut = (s = t(e.proxy)) => {
    Array.from(document.querySelectorAll(`[data-v-owner="${e.uid}"]`)).forEach((r) => R6(r, s));
  }, i = () => {
    const s = t(e.proxy);
    M6(e.subTree, s), n(s);
  };
  xr(i), s1(() => {
    const s = new MutationObserver(i);
    s.observe(e.subTree.el.parentNode, { childList: !0 }), x1(() => s.disconnect());
  });
}
function M6(t, e) {
  if (t.shapeFlag & 128) {
    const n = t.suspense;
    t = n.activeBranch, n.pendingBranch && !n.isHydrating && n.effects.push(() => {
      M6(n.activeBranch, e);
    });
  }
  for (; t.component; )
    t = t.component.subTree;
  if (t.shapeFlag & 1 && t.el)
    R6(t.el, e);
  else if (t.type === P2)
    t.children.forEach((n) => M6(n, e));
  else if (t.type === o9) {
    let { el: n, anchor: i } = t;
    for (; n && (R6(n, e), n !== i); )
      n = n.nextSibling;
  }
}
function R6(t, e) {
  if (t.nodeType === 1) {
    const n = t.style;
    for (const i in e)
      n.setProperty(`--${i}`, e[i]);
  }
}
const R4 = "transition", o0 = "animation", i5 = (t, { slots: e }) => f1(Ae, vo(t), e);
i5.displayName = "Transition";
i5.__isBuiltIn = !0;
const _o = {
  name: String,
  type: String,
  css: {
    type: Boolean,
    default: !0
  },
  duration: [String, Number, Object],
  enterFromClass: String,
  enterActiveClass: String,
  enterToClass: String,
  appearFromClass: String,
  appearActiveClass: String,
  appearToClass: String,
  leaveFromClass: String,
  leaveActiveClass: String,
  leaveToClass: String
}, Wh = i5.props = /* @__PURE__ */ U2({}, Ae.props, _o), G4 = (t, e = []) => {
  e2(t) ? t.forEach((n) => n(...e)) : t && t(...e);
}, ri = (t) => t ? e2(t) ? t.some((e) => e.length > 1) : t.length > 1 : !1;
function vo(t) {
  const e = {};
  for (const $ in t)
    $ in _o || (e[$] = t[$]);
  if (t.css === !1)
    return e;
  const { name: n = "v", type: i, duration: s, enterFromClass: r = `${n}-enter-from`, enterActiveClass: o = `${n}-enter-active`, enterToClass: l = `${n}-enter-to`, appearFromClass: L = r, appearActiveClass: a = o, appearToClass: C = l, leaveFromClass: c = `${n}-leave-from`, leaveActiveClass: h = `${n}-leave-active`, leaveToClass: d = `${n}-leave-to` } = t, f = t4.isCompatEnabled("TRANSITION_CLASSES", null);
  let x, k, m;
  if (f) {
    const $ = (s2) => s2.replace(/-from$/, "");
    t.enterFromClass || (x = $(r)), t.appearFromClass || (k = $(L)), t.leaveFromClass || (m = $(c));
  }
  const g = Hh(s), w = g && g[0], Z = g && g[1], { onBeforeEnter: b, onEnter: z, onEnterCancelled: K, onLeave: E, onLeaveCancelled: L2, onBeforeAppear: t2 = b, onAppear: u2 = z, onAppearCancelled: N2 = K } = e, m2 = ($, s2, g2) => {
    z3($, s2 ? C : l), z3($, s2 ? a : o), g2 && g2();
  }, P = ($, s2) => {
    $._isLeaving = !1, z3($, c), z3($, d), z3($, h), s2 && s2();
  }, W2 = ($) => (s2, g2) => {
    const J2 = $ ? u2 : z, S2 = () => m2(s2, $, g2);
    G4(J2, [s2, S2]), oi(() => {
      z3(s2, $ ? L : r), f && z3(s2, $ ? k : x), Z3(s2, $ ? C : l), ri(J2) || li(s2, i, w, S2);
    });
  };
  return U2(e, {
    onBeforeEnter($) {
      G4(b, [$]), Z3($, r), f && Z3($, x), Z3($, o);
    },
    onBeforeAppear($) {
      G4(t2, [$]), Z3($, L), f && Z3($, k), Z3($, a);
    },
    onEnter: W2(!1),
    onAppear: W2(!0),
    onLeave($, s2) {
      $._isLeaving = !0;
      const g2 = () => P($, s2);
      Z3($, c), f && Z3($, m), Ro(), Z3($, h), oi(() => {
        $._isLeaving && (z3($, c), f && z3($, m), Z3($, d), ri(E) || li($, i, Z, g2));
      }), G4(E, [$, g2]);
    },
    onEnterCancelled($) {
      m2($, !1), G4(K, [$]);
    },
    onAppearCancelled($) {
      m2($, !0), G4(N2, [$]);
    },
    onLeaveCancelled($) {
      P($), G4(L2, [$]);
    }
  });
}
function Hh(t) {
  if (t == null)
    return null;
  if (B2(t))
    return [I7(t.enter), I7(t.leave)];
  {
    const e = I7(t);
    return [e, e];
  }
}
function I7(t) {
  return Q3(t);
}
function Z3(t, e) {
  e.split(/\s+/).forEach((n) => n && t.classList.add(n)), (t._vtc || (t._vtc = /* @__PURE__ */ new Set())).add(e);
}
function z3(t, e) {
  e.split(/\s+/).forEach((i) => i && t.classList.remove(i));
  const { _vtc: n } = t;
  n && (n.delete(e), n.size || (t._vtc = void 0));
}
function oi(t) {
  requestAnimationFrame(() => {
    requestAnimationFrame(t);
  });
}
let $h = 0;
function li(t, e, n, i) {
  const s = t._endId = ++$h, r = () => {
    s === t._endId && i();
  };
  if (n)
    return setTimeout(r, n);
  const { type: o, timeout: l, propCount: L } = Mo(t, e);
  if (!o)
    return i();
  const a = o + "end";
  let C = 0;
  const c = () => {
    t.removeEventListener(a, h), r();
  }, h = (d) => {
    d.target === t && ++C >= L && c();
  };
  setTimeout(() => {
    C < L && c();
  }, l + 1), t.addEventListener(a, h);
}
function Mo(t, e) {
  const n = window.getComputedStyle(t), i = (f) => (n[f] || "").split(", "), s = i(`${R4}Delay`), r = i(`${R4}Duration`), o = Li(s, r), l = i(`${o0}Delay`), L = i(`${o0}Duration`), a = Li(l, L);
  let C = null, c = 0, h = 0;
  e === R4 ? o > 0 && (C = R4, c = o, h = r.length) : e === o0 ? a > 0 && (C = o0, c = a, h = L.length) : (c = Math.max(o, a), C = c > 0 ? o > a ? R4 : o0 : null, h = C ? C === R4 ? r.length : L.length : 0);
  const d = C === R4 && /\b(transform|all)(,|$)/.test(i(`${R4}Property`).toString());
  return {
    type: C,
    timeout: c,
    propCount: h,
    hasTransform: d
  };
}
function Li(t, e) {
  for (; t.length < e.length; )
    t = t.concat(t);
  return Math.max(...e.map((n, i) => ai(n) + ai(t[i])));
}
function ai(t) {
  return Number(t.slice(0, -1).replace(",", ".")) * 1e3;
}
function Ro() {
  return document.body.offsetHeight;
}
const yo = /* @__PURE__ */ new WeakMap(), Ao = /* @__PURE__ */ new WeakMap(), Zo = {
  name: "TransitionGroup",
  props: /* @__PURE__ */ U2({}, Wh, {
    tag: String,
    moveClass: String
  }),
  setup(t, { slots: e }) {
    const n = l4(), i = ye();
    let s, r;
    return t5(() => {
      if (!s.length)
        return;
      const o = t.moveClass || `${t.name || "v"}-move`;
      if (!qh(s[0].el, n.vnode.el, o))
        return;
      s.forEach(Vh), s.forEach(Gh);
      const l = s.filter(jh);
      Ro(), l.forEach((L) => {
        const a = L.el, C = a.style;
        Z3(a, o), C.transform = C.webkitTransform = C.transitionDuration = "";
        const c = a._moveCb = (h) => {
          h && h.target !== a || (!h || /transform$/.test(h.propertyName)) && (a.removeEventListener("transitionend", c), a._moveCb = null, z3(a, o));
        };
        a.addEventListener("transitionend", c);
      });
    }), () => {
      const o = I2(t), l = vo(o);
      let L = o.tag || P2;
      !o.tag && t4.checkCompatEnabled("TRANSITION_GROUP_ROOT", n.parent) && (L = "span"), s = r, r = e.default ? D8(e.default()) : [];
      for (let a = 0; a < r.length; a++) {
        const C = r[a];
        C.key != null && C9(C, U9(C, l, i, n));
      }
      if (s)
        for (let a = 0; a < s.length; a++) {
          const C = s[a];
          C9(C, U9(C, l, i, n)), yo.set(C, C.el.getBoundingClientRect());
        }
      return N(L, null, r);
    };
  }
};
Zo.__isBuiltIn = !0;
const ko = Zo;
function Vh(t) {
  const e = t.el;
  e._moveCb && e._moveCb(), e._enterCb && e._enterCb();
}
function Gh(t) {
  Ao.set(t, t.el.getBoundingClientRect());
}
function jh(t) {
  const e = yo.get(t), n = Ao.get(t), i = e.left - n.left, s = e.top - n.top;
  if (i || s) {
    const r = t.el.style;
    return r.transform = r.webkitTransform = `translate(${i}px,${s}px)`, r.transitionDuration = "0s", t;
  }
}
function qh(t, e, n) {
  const i = t.cloneNode();
  t._vtc && t._vtc.forEach((o) => {
    o.split(/\s+/).forEach((l) => l && i.classList.remove(l));
  }), n.split(/\s+/).forEach((o) => o && i.classList.add(o)), i.style.display = "none";
  const s = e.nodeType === 1 ? e : e.parentNode;
  s.appendChild(i);
  const { hasTransform: r } = Mo(i);
  return s.removeChild(i), r;
}
const z4 = (t) => {
  const e = t.props["onUpdate:modelValue"] || t.props["onModelCompat:input"];
  return e2(e) ? (n) => I4(e, n) : e;
};
function Kh(t) {
  t.target.composing = !0;
}
function Ci(t) {
  const e = t.target;
  e.composing && (e.composing = !1, e.dispatchEvent(new Event("input")));
}
const r8 = {
  created(t, { modifiers: { lazy: e, trim: n, number: i } }, s) {
    t._assign = z4(s);
    const r = i || s.props && s.props.type === "number";
    c4(t, e ? "change" : "input", (o) => {
      if (o.target.composing)
        return;
      let l = t.value;
      n && (l = l.trim()), r && (l = Q3(l)), t._assign(l);
    }), n && c4(t, "change", () => {
      t.value = t.value.trim();
    }), e || (c4(t, "compositionstart", Kh), c4(t, "compositionend", Ci), c4(t, "change", Ci));
  },
  // set value on mounted so it's after min/max for type="range"
  mounted(t, { value: e }) {
    t.value = e ?? "";
  },
  beforeUpdate(t, { value: e, modifiers: { lazy: n, trim: i, number: s } }, r) {
    if (t._assign = z4(r), t.composing || document.activeElement === t && t.type !== "range" && (n || i && t.value.trim() === e || (s || t.type === "number") && Q3(t.value) === e))
      return;
    const o = e ?? "";
    t.value !== o && (t.value = o);
  }
}, Fe = {
  // #4096 array checkboxes need to be deep traversed
  deep: !0,
  created(t, e, n) {
    t._assign = z4(n), c4(t, "change", () => {
      const i = t._modelValue, s = H9(t), r = t.checked, o = t._assign;
      if (e2(i)) {
        const l = K0(i, s), L = l !== -1;
        if (r && !L)
          o(i.concat(s));
        else if (!r && L) {
          const a = [...i];
          a.splice(l, 1), o(a);
        }
      } else if (d9(i)) {
        const l = new Set(i);
        r ? l.add(s) : l.delete(s), o(l);
      } else
        o(So(t, r));
    });
  },
  // set initial checked on mount to wait for true-value/false-value
  mounted: ci,
  beforeUpdate(t, e, n) {
    t._assign = z4(n), ci(t, e, n);
  }
};
function ci(t, { value: e, oldValue: n }, i) {
  t._modelValue = e, e2(e) ? t.checked = K0(e, i.props.value) > -1 : d9(e) ? t.checked = e.has(i.props.value) : e !== n && (t.checked = d4(e, So(t, !0)));
}
const Oe = {
  created(t, { value: e }, n) {
    t.checked = d4(e, n.props.value), t._assign = z4(n), c4(t, "change", () => {
      t._assign(H9(t));
    });
  },
  beforeUpdate(t, { value: e, oldValue: n }, i) {
    t._assign = z4(i), e !== n && (t.checked = d4(e, i.props.value));
  }
}, To = {
  // <select multiple> value need to be deep traversed
  deep: !0,
  created(t, { value: e, modifiers: { number: n } }, i) {
    const s = d9(e);
    c4(t, "change", () => {
      const r = Array.prototype.filter.call(t.options, (o) => o.selected).map((o) => n ? Q3(H9(o)) : H9(o));
      t._assign(t.multiple ? s ? new Set(r) : r : r[0]);
    }), t._assign = z4(i);
  },
  // set value in mounted & updated because <select> relies on its children
  // <option>s.
  mounted(t, { value: e }) {
    ui(t, e);
  },
  beforeUpdate(t, e, n) {
    t._assign = z4(n);
  },
  updated(t, { value: e }) {
    ui(t, e);
  }
};
function ui(t, e) {
  const n = t.multiple;
  if (!(n && !e2(e) && !d9(e))) {
    for (let i = 0, s = t.options.length; i < s; i++) {
      const r = t.options[i], o = H9(r);
      if (n)
        e2(e) ? r.selected = K0(e, o) > -1 : r.selected = e.has(o);
      else if (d4(H9(r), e)) {
        t.selectedIndex !== i && (t.selectedIndex = i);
        return;
      }
    }
    !n && t.selectedIndex !== -1 && (t.selectedIndex = -1);
  }
}
function H9(t) {
  return "_value" in t ? t._value : t.value;
}
function So(t, e) {
  const n = e ? "_trueValue" : "_falseValue";
  return n in t ? t[n] : e;
}
const Ne = {
  created(t, e, n) {
    I5(t, e, n, null, "created");
  },
  mounted(t, e, n) {
    I5(t, e, n, null, "mounted");
  },
  beforeUpdate(t, e, n, i) {
    I5(t, e, n, i, "beforeUpdate");
  },
  updated(t, e, n, i) {
    I5(t, e, n, i, "updated");
  }
};
function bo(t, e) {
  switch (t) {
    case "SELECT":
      return To;
    case "TEXTAREA":
      return r8;
    default:
      switch (e) {
        case "checkbox":
          return Fe;
        case "radio":
          return Oe;
        default:
          return r8;
      }
  }
}
function I5(t, e, n, i, s) {
  const o = bo(t.tagName, n.props && n.props.type)[s];
  o && o(t, e, n, i);
}
function Yh() {
  r8.getSSRProps = ({ value: t }) => ({ value: t }), Oe.getSSRProps = ({ value: t }, e) => {
    if (e.props && d4(e.props.value, t))
      return { checked: !0 };
  }, Fe.getSSRProps = ({ value: t }, e) => {
    if (e2(t)) {
      if (e.props && K0(t, e.props.value) > -1)
        return { checked: !0 };
    } else if (d9(t)) {
      if (e.props && t.has(e.props.value))
        return { checked: !0 };
    } else if (t)
      return { checked: !0 };
  }, Ne.getSSRProps = (t, e) => {
    if (typeof e.type != "string")
      return;
    const n = bo(
      // resolveDynamicModel expects an uppercase tag name, but vnode.type is lowercase
      e.type.toUpperCase(),
      e.props && e.props.type
    );
    if (n.getSSRProps)
      return n.getSSRProps(t, e);
  };
}
const Qh = ["ctrl", "shift", "alt", "meta"], Xh = {
  stop: (t) => t.stopPropagation(),
  prevent: (t) => t.preventDefault(),
  self: (t) => t.target !== t.currentTarget,
  ctrl: (t) => !t.ctrlKey,
  shift: (t) => !t.shiftKey,
  alt: (t) => !t.altKey,
  meta: (t) => !t.metaKey,
  left: (t) => "button" in t && t.button !== 0,
  middle: (t) => "button" in t && t.button !== 1,
  right: (t) => "button" in t && t.button !== 2,
  exact: (t, e) => Qh.some((n) => t[`${n}Key`] && !e.includes(n))
}, s5 = (t, e) => (n, ...i) => {
  for (let s = 0; s < e.length; s++) {
    const r = Xh[e[s]];
    if (r && r(n, e))
      return;
  }
  return t(n, ...i);
}, Jh = {
  esc: "escape",
  space: " ",
  up: "arrow-up",
  left: "arrow-left",
  right: "arrow-right",
  down: "arrow-down",
  delete: "backspace"
}, ed = (t, e) => {
  let n, i = null;
  return i = l4(), t4.isCompatEnabled("CONFIG_KEY_CODES", i) && i && (n = i.appContext.config.keyCodes), (s) => {
    if (!("key" in s))
      return;
    const r = W1(s.key);
    if (e.some((o) => o === r || Jh[o] === r))
      return t(s);
    {
      const o = String(s.keyCode);
      if (t4.isCompatEnabled("V_ON_KEYCODE_MODIFIER", i) && e.some((l) => l == o))
        return t(s);
      if (n)
        for (const l of e) {
          const L = n[l];
          if (L && (e2(L) ? L.some((C) => String(C) === o) : String(L) === o))
            return t(s);
        }
    }
  };
}, $9 = {
  beforeMount(t, { value: e }, { transition: n }) {
    t._vod = t.style.display === "none" ? "" : t.style.display, n && e ? n.beforeEnter(t) : l0(t, e);
  },
  mounted(t, { value: e }, { transition: n }) {
    n && e && n.enter(t);
  },
  updated(t, { value: e, oldValue: n }, { transition: i }) {
    !e != !n && (i ? e ? (i.beforeEnter(t), l0(t, !0), i.enter(t)) : i.leave(t, () => {
      l0(t, !1);
    }) : l0(t, e));
  },
  beforeUnmount(t, { value: e }) {
    l0(t, e);
  }
};
function l0(t, e) {
  t.style.display = e ? t._vod : "none";
}
function td() {
  $9.getSSRProps = ({ value: t }) => {
    if (!t)
      return { style: { display: "none" } };
  };
}
const Eo = /* @__PURE__ */ U2({ patchProp: Nh }, _h);
let y0, hi = !1;
function Io() {
  return y0 || (y0 = io(Eo));
}
function Fo() {
  return y0 = hi ? y0 : so(Eo), hi = !0, y0;
}
const y6 = (...t) => {
  Io().render(...t);
}, Oo = (...t) => {
  Fo().hydrate(...t);
}, r5 = (...t) => {
  const e = Io().createApp(...t), { mount: n } = e;
  return e.mount = (i) => {
    const s = No(i);
    if (!s)
      return;
    const r = e._component;
    !p2(r) && !r.render && !r.template && (r.template = s.innerHTML), s.innerHTML = "";
    const o = n(s, !1, s instanceof SVGElement);
    return s instanceof Element && (s.removeAttribute("v-cloak"), s.setAttribute("data-v-app", "")), o;
  }, e;
}, nd = (...t) => {
  const e = Fo().createApp(...t), { mount: n } = e;
  return e.mount = (i) => {
    const s = No(i);
    if (s)
      return n(s, !0, s instanceof SVGElement);
  }, e;
};
function No(t) {
  return r1(t) ? document.querySelector(t) : t;
}
let di = !1;
const id = () => {
  di || (di = !0, Yh(), td());
};
var sd = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  render: y6,
  hydrate: Oo,
  createApp: r5,
  createSSRApp: nd,
  initDirectivesForSSR: id,
  defineCustomElement: xo,
  defineSSRCustomElement: Ph,
  VueElement: G8,
  useCssModule: zh,
  useCssVars: Uh,
  Transition: i5,
  TransitionGroup: ko,
  vModelText: r8,
  vModelCheckbox: Fe,
  vModelRadio: Oe,
  vModelSelect: To,
  vModelDynamic: Ne,
  withModifiers: s5,
  withKeys: ed,
  vShow: $9,
  reactive: J3,
  ref: R2,
  readonly: ce,
  unref: O,
  proxyRefs: fe,
  isRef: R1,
  toRef: Cr,
  toRefs: g9,
  isProxy: ue,
  isReactive: u4,
  isReadonly: a9,
  isShallow: N0,
  customRef: Ac,
  triggerRef: Mc,
  shallowRef: Lr,
  shallowReactive: lr,
  shallowReadonly: _c,
  markRaw: he,
  toRaw: I2,
  effect: KC,
  stop: YC,
  ReactiveEffect: X0,
  effectScope: js,
  EffectScope: Le,
  getCurrentScope: VC,
  onScopeDispose: GC,
  computed: I,
  watch: m3,
  watchEffect: x3,
  watchPostEffect: xr,
  watchSyncEffect: Jc,
  onBeforeMount: Tr,
  onMounted: s1,
  onBeforeUpdate: Sr,
  onUpdated: t5,
  onBeforeUnmount: W0,
  onUnmounted: x1,
  onActivated: Ar,
  onDeactivated: Zr,
  onRenderTracked: Ir,
  onRenderTriggered: Er,
  onErrorCaptured: Fr,
  onServerPrefetch: br,
  provide: a3,
  inject: u1,
  nextTick: P4,
  defineComponent: q2,
  defineAsyncComponent: v0,
  useAttrs: Ch,
  useSlots: ah,
  defineProps: rh,
  defineEmits: oh,
  defineExpose: lh,
  withDefaults: Lh,
  mergeDefaults: ch,
  createPropsRestProxy: uh,
  withAsyncContext: hh,
  getCurrentInstance: l4,
  h: f1,
  createVNode: N,
  cloneVNode: T3,
  mergeProps: $8,
  isVNode: _3,
  Fragment: P2,
  Text: c9,
  Comment: S1,
  Static: o9,
  Teleport: oo,
  Suspense: qc,
  KeepAlive: yr,
  BaseTransition: Ae,
  withDirectives: H0,
  useSSRContext: po,
  ssrContextKey: fo,
  createRenderer: io,
  createHydrationRenderer: so,
  queuePostFlushCb: me,
  warn: Sc,
  handleError: f9,
  callWithErrorHandling: j3,
  callWithAsyncErrorHandling: l3,
  resolveComponent: i2,
  resolveDirective: Pr,
  resolveDynamicComponent: B8,
  registerRuntimeCompiler: nh,
  isRuntimeOnly: x6,
  useTransitionState: ye,
  resolveTransitionHooks: U9,
  setTransitionHooks: C9,
  getTransitionRawChildren: D8,
  initCustomFormatter: dh,
  get devtools() {
    return A9;
  },
  setDevtoolsHook: gr,
  withCtx: h3,
  pushScopeId: r4,
  popScopeId: o4,
  withScopeId: Wc,
  renderList: e4,
  toHandlers: $r,
  renderSlot: ke,
  createSlots: Wr,
  withMemo: gh,
  isMemoSame: mo,
  openBlock: T,
  createBlock: T2,
  setBlockTracking: p6,
  createTextVNode: q3,
  createCommentVNode: x2,
  createStaticVNode: W8,
  createElementVNode: _,
  createElementBlock: B,
  guardReactiveProps: co,
  toDisplayString: m1,
  camelize: G1,
  capitalize: Q0,
  toHandlerKey: E9,
  normalizeProps: OC,
  normalizeClass: v2,
  normalizeStyle: w2,
  transformVNodeArgs: Qu,
  version: wo,
  ssrUtils: ph,
  resolveFilter: mh,
  compatUtils: t4
});
function rd(...t) {
  const e = r5(...t);
  return t4.isCompatEnabled("RENDER_FUNCTION", null) && (e.component("__compat__transition", i5), e.component("__compat__transition-group", ko), e.component("__compat__keep-alive", yr), e._context.directives.show = $9, e._context.directives.model = Ne), e;
}
function od() {
  const t = t4.createCompatVue(r5, rd);
  return U2(t, sd), t;
}
const Do = od();
Do.compile = () => {
};
const { configureCompat: GB } = Do;
function ld() {
  return Po().__VUE_DEVTOOLS_GLOBAL_HOOK__;
}
function Po() {
  return typeof navigator < "u" && typeof window < "u" ? window : typeof global < "u" ? global : {};
}
const Ld = typeof Proxy == "function", ad = "devtools-plugin:setup", Cd = "plugin:settings:set";
let v9, A6;
function cd() {
  var t;
  return v9 !== void 0 || (typeof window < "u" && window.performance ? (v9 = !0, A6 = window.performance) : typeof global < "u" && (!((t = global.perf_hooks) === null || t === void 0) && t.performance) ? (v9 = !0, A6 = global.perf_hooks.performance) : v9 = !1), v9;
}
function ud() {
  return cd() ? A6.now() : Date.now();
}
class hd {
  constructor(e, n) {
    this.target = null, this.targetQueue = [], this.onQueue = [], this.plugin = e, this.hook = n;
    const i = {};
    if (e.settings)
      for (const o in e.settings) {
        const l = e.settings[o];
        i[o] = l.defaultValue;
      }
    const s = `__vue-devtools-plugin-settings__${e.id}`;
    let r = Object.assign({}, i);
    try {
      const o = localStorage.getItem(s), l = JSON.parse(o);
      Object.assign(r, l);
    } catch {
    }
    this.fallbacks = {
      getSettings() {
        return r;
      },
      setSettings(o) {
        try {
          localStorage.setItem(s, JSON.stringify(o));
        } catch {
        }
        r = o;
      },
      now() {
        return ud();
      }
    }, n && n.on(Cd, (o, l) => {
      o === this.plugin.id && this.fallbacks.setSettings(l);
    }), this.proxiedOn = new Proxy({}, {
      get: (o, l) => this.target ? this.target.on[l] : (...L) => {
        this.onQueue.push({
          method: l,
          args: L
        });
      }
    }), this.proxiedTarget = new Proxy({}, {
      get: (o, l) => this.target ? this.target[l] : l === "on" ? this.proxiedOn : Object.keys(this.fallbacks).includes(l) ? (...L) => (this.targetQueue.push({
        method: l,
        args: L,
        resolve: () => {
        }
      }), this.fallbacks[l](...L)) : (...L) => new Promise((a) => {
        this.targetQueue.push({
          method: l,
          args: L,
          resolve: a
        });
      })
    });
  }
  async setRealTarget(e) {
    this.target = e;
    for (const n of this.onQueue)
      this.target.on[n.method](...n.args);
    for (const n of this.targetQueue)
      n.resolve(await this.target[n.method](...n.args));
  }
}
function dd(t, e) {
  const n = t, i = Po(), s = ld(), r = Ld && n.enableEarlyProxy;
  if (s && (i.__VUE_DEVTOOLS_PLUGIN_API_AVAILABLE__ || !r))
    s.emit(ad, t, e);
  else {
    const o = r ? new hd(n, s) : null;
    (i.__VUE_DEVTOOLS_PLUGINS__ = i.__VUE_DEVTOOLS_PLUGINS__ || []).push({
      pluginDescriptor: n,
      setupFn: e,
      proxy: o
    }), o && e(o.proxiedTarget);
  }
}
/*!
 * vuex v4.1.0
 * (c) 2022 Evan You
 * @license MIT
 */
var Bo = "store";
function F3(t) {
  return t === void 0 && (t = null), u1(t !== null ? t : Bo);
}
function X9(t, e) {
  Object.keys(t).forEach(function(n) {
    return e(t[n], n);
  });
}
function zo(t) {
  return t !== null && typeof t == "object";
}
function gd(t) {
  return t && typeof t.then == "function";
}
function fd(t, e) {
  return function() {
    return t(e);
  };
}
function Uo(t, e, n) {
  return e.indexOf(t) < 0 && (n && n.prepend ? e.unshift(t) : e.push(t)), function() {
    var i = e.indexOf(t);
    i > -1 && e.splice(i, 1);
  };
}
function Wo(t, e) {
  t._actions = /* @__PURE__ */ Object.create(null), t._mutations = /* @__PURE__ */ Object.create(null), t._wrappedGetters = /* @__PURE__ */ Object.create(null), t._modulesNamespaceMap = /* @__PURE__ */ Object.create(null);
  var n = t.state;
  j8(t, n, [], t._modules.root, !0), De(t, n, e);
}
function De(t, e, n) {
  var i = t._state, s = t._scope;
  t.getters = {}, t._makeLocalGettersCache = /* @__PURE__ */ Object.create(null);
  var r = t._wrappedGetters, o = {}, l = {}, L = js(!0);
  L.run(function() {
    X9(r, function(a, C) {
      o[C] = fd(a, t), l[C] = I(function() {
        return o[C]();
      }), Object.defineProperty(t.getters, C, {
        get: function() {
          return l[C].value;
        },
        enumerable: !0
        // for local getters
      });
    });
  }), t._state = J3({
    data: e
  }), t._scope = L, t.strict && _d(t), i && n && t._withCommit(function() {
    i.data = null;
  }), s && s.stop();
}
function j8(t, e, n, i, s) {
  var r = !n.length, o = t._modules.getNamespace(n);
  if (i.namespaced && (t._modulesNamespaceMap[o], t._modulesNamespaceMap[o] = i), !r && !s) {
    var l = Pe(e, n.slice(0, -1)), L = n[n.length - 1];
    t._withCommit(function() {
      l[L] = i.state;
    });
  }
  var a = i.context = pd(t, o, n);
  i.forEachMutation(function(C, c) {
    var h = o + c;
    md(t, h, C, a);
  }), i.forEachAction(function(C, c) {
    var h = C.root ? c : o + c, d = C.handler || C;
    wd(t, h, d, a);
  }), i.forEachGetter(function(C, c) {
    var h = o + c;
    xd(t, h, C, a);
  }), i.forEachChild(function(C, c) {
    j8(t, e, n.concat(c), C, s);
  });
}
function pd(t, e, n) {
  var i = e === "", s = {
    dispatch: i ? t.dispatch : function(r, o, l) {
      var L = o8(r, o, l), a = L.payload, C = L.options, c = L.type;
      return (!C || !C.root) && (c = e + c), t.dispatch(c, a);
    },
    commit: i ? t.commit : function(r, o, l) {
      var L = o8(r, o, l), a = L.payload, C = L.options, c = L.type;
      (!C || !C.root) && (c = e + c), t.commit(c, a, C);
    }
  };
  return Object.defineProperties(s, {
    getters: {
      get: i ? function() {
        return t.getters;
      } : function() {
        return Ho(t, e);
      }
    },
    state: {
      get: function() {
        return Pe(t.state, n);
      }
    }
  }), s;
}
function Ho(t, e) {
  if (!t._makeLocalGettersCache[e]) {
    var n = {}, i = e.length;
    Object.keys(t.getters).forEach(function(s) {
      if (s.slice(0, i) === e) {
        var r = s.slice(i);
        Object.defineProperty(n, r, {
          get: function() {
            return t.getters[s];
          },
          enumerable: !0
        });
      }
    }), t._makeLocalGettersCache[e] = n;
  }
  return t._makeLocalGettersCache[e];
}
function md(t, e, n, i) {
  var s = t._mutations[e] || (t._mutations[e] = []);
  s.push(function(o) {
    n.call(t, i.state, o);
  });
}
function wd(t, e, n, i) {
  var s = t._actions[e] || (t._actions[e] = []);
  s.push(function(o) {
    var l = n.call(t, {
      dispatch: i.dispatch,
      commit: i.commit,
      getters: i.getters,
      state: i.state,
      rootGetters: t.getters,
      rootState: t.state
    }, o);
    return gd(l) || (l = Promise.resolve(l)), t._devtoolHook ? l.catch(function(L) {
      throw t._devtoolHook.emit("vuex:error", L), L;
    }) : l;
  });
}
function xd(t, e, n, i) {
  t._wrappedGetters[e] || (t._wrappedGetters[e] = function(r) {
    return n(
      i.state,
      // local state
      i.getters,
      // local getters
      r.state,
      // root state
      r.getters
      // root getters
    );
  });
}
function _d(t) {
  m3(function() {
    return t._state.data;
  }, function() {
  }, { deep: !0, flush: "sync" });
}
function Pe(t, e) {
  return e.reduce(function(n, i) {
    return n[i];
  }, t);
}
function o8(t, e, n) {
  return zo(t) && t.type && (n = e, e = t, t = t.type), { type: t, payload: e, options: n };
}
var vd = "vuex bindings", gi = "vuex:mutations", F7 = "vuex:actions", M9 = "vuex", Md = 0;
function Rd(t, e) {
  dd(
    {
      id: "org.vuejs.vuex",
      app: t,
      label: "Vuex",
      homepage: "https://next.vuex.vuejs.org/",
      logo: "https://vuejs.org/images/icons/favicon-96x96.png",
      packageName: "vuex",
      componentStateTypes: [vd]
    },
    function(n) {
      n.addTimelineLayer({
        id: gi,
        label: "Vuex Mutations",
        color: fi
      }), n.addTimelineLayer({
        id: F7,
        label: "Vuex Actions",
        color: fi
      }), n.addInspector({
        id: M9,
        label: "Vuex",
        icon: "storage",
        treeFilterPlaceholder: "Filter stores..."
      }), n.on.getInspectorTree(function(i) {
        if (i.app === t && i.inspectorId === M9)
          if (i.filter) {
            var s = [];
            jo(s, e._modules.root, i.filter, ""), i.rootNodes = s;
          } else
            i.rootNodes = [
              Go(e._modules.root, "")
            ];
      }), n.on.getInspectorState(function(i) {
        if (i.app === t && i.inspectorId === M9) {
          var s = i.nodeId;
          Ho(e, s), i.state = Zd(
            Td(e._modules, s),
            s === "root" ? e.getters : e._makeLocalGettersCache,
            s
          );
        }
      }), n.on.editInspectorState(function(i) {
        if (i.app === t && i.inspectorId === M9) {
          var s = i.nodeId, r = i.path;
          s !== "root" && (r = s.split("/").filter(Boolean).concat(r)), e._withCommit(function() {
            i.set(e._state.data, r, i.state.value);
          });
        }
      }), e.subscribe(function(i, s) {
        var r = {};
        i.payload && (r.payload = i.payload), r.state = s, n.notifyComponentUpdate(), n.sendInspectorTree(M9), n.sendInspectorState(M9), n.addTimelineEvent({
          layerId: gi,
          event: {
            time: Date.now(),
            title: i.type,
            data: r
          }
        });
      }), e.subscribeAction({
        before: function(i, s) {
          var r = {};
          i.payload && (r.payload = i.payload), i._id = Md++, i._time = Date.now(), r.state = s, n.addTimelineEvent({
            layerId: F7,
            event: {
              time: i._time,
              title: i.type,
              groupId: i._id,
              subtitle: "start",
              data: r
            }
          });
        },
        after: function(i, s) {
          var r = {}, o = Date.now() - i._time;
          r.duration = {
            _custom: {
              type: "duration",
              display: o + "ms",
              tooltip: "Action duration",
              value: o
            }
          }, i.payload && (r.payload = i.payload), r.state = s, n.addTimelineEvent({
            layerId: F7,
            event: {
              time: Date.now(),
              title: i.type,
              groupId: i._id,
              subtitle: "end",
              data: r
            }
          });
        }
      });
    }
  );
}
var fi = 8702998, yd = 6710886, Ad = 16777215, $o = {
  label: "namespaced",
  textColor: Ad,
  backgroundColor: yd
};
function Vo(t) {
  return t && t !== "root" ? t.split("/").slice(-2, -1)[0] : "Root";
}
function Go(t, e) {
  return {
    id: e || "root",
    // all modules end with a `/`, we want the last segment only
    // cart/ -> cart
    // nested/cart/ -> cart
    label: Vo(e),
    tags: t.namespaced ? [$o] : [],
    children: Object.keys(t._children).map(
      function(n) {
        return Go(
          t._children[n],
          e + n + "/"
        );
      }
    )
  };
}
function jo(t, e, n, i) {
  i.includes(n) && t.push({
    id: i || "root",
    label: i.endsWith("/") ? i.slice(0, i.length - 1) : i || "Root",
    tags: e.namespaced ? [$o] : []
  }), Object.keys(e._children).forEach(function(s) {
    jo(t, e._children[s], n, i + s + "/");
  });
}
function Zd(t, e, n) {
  e = n === "root" ? e : e[n];
  var i = Object.keys(e), s = {
    state: Object.keys(t.state).map(function(o) {
      return {
        key: o,
        editable: !0,
        value: t.state[o]
      };
    })
  };
  if (i.length) {
    var r = kd(e);
    s.getters = Object.keys(r).map(function(o) {
      return {
        key: o.endsWith("/") ? Vo(o) : o,
        editable: !1,
        value: Z6(function() {
          return r[o];
        })
      };
    });
  }
  return s;
}
function kd(t) {
  var e = {};
  return Object.keys(t).forEach(function(n) {
    var i = n.split("/");
    if (i.length > 1) {
      var s = e, r = i.pop();
      i.forEach(function(o) {
        s[o] || (s[o] = {
          _custom: {
            value: {},
            display: o,
            tooltip: "Module",
            abstract: !0
          }
        }), s = s[o]._custom.value;
      }), s[r] = Z6(function() {
        return t[n];
      });
    } else
      e[n] = Z6(function() {
        return t[n];
      });
  }), e;
}
function Td(t, e) {
  var n = e.split("/").filter(function(i) {
    return i;
  });
  return n.reduce(
    function(i, s, r) {
      var o = i[s];
      if (!o)
        throw new Error('Missing module "' + s + '" for path "' + e + '".');
      return r === n.length - 1 ? o : o._children;
    },
    e === "root" ? t : t.root._children
  );
}
function Z6(t) {
  try {
    return t();
  } catch (e) {
    return e;
  }
}
var O3 = function(e, n) {
  this.runtime = n, this._children = /* @__PURE__ */ Object.create(null), this._rawModule = e;
  var i = e.state;
  this.state = (typeof i == "function" ? i() : i) || {};
}, qo = { namespaced: { configurable: !0 } };
qo.namespaced.get = function() {
  return !!this._rawModule.namespaced;
};
O3.prototype.addChild = function(e, n) {
  this._children[e] = n;
};
O3.prototype.removeChild = function(e) {
  delete this._children[e];
};
O3.prototype.getChild = function(e) {
  return this._children[e];
};
O3.prototype.hasChild = function(e) {
  return e in this._children;
};
O3.prototype.update = function(e) {
  this._rawModule.namespaced = e.namespaced, e.actions && (this._rawModule.actions = e.actions), e.mutations && (this._rawModule.mutations = e.mutations), e.getters && (this._rawModule.getters = e.getters);
};
O3.prototype.forEachChild = function(e) {
  X9(this._children, e);
};
O3.prototype.forEachGetter = function(e) {
  this._rawModule.getters && X9(this._rawModule.getters, e);
};
O3.prototype.forEachAction = function(e) {
  this._rawModule.actions && X9(this._rawModule.actions, e);
};
O3.prototype.forEachMutation = function(e) {
  this._rawModule.mutations && X9(this._rawModule.mutations, e);
};
Object.defineProperties(O3.prototype, qo);
var p9 = function(e) {
  this.register([], e, !1);
};
p9.prototype.get = function(e) {
  return e.reduce(function(n, i) {
    return n.getChild(i);
  }, this.root);
};
p9.prototype.getNamespace = function(e) {
  var n = this.root;
  return e.reduce(function(i, s) {
    return n = n.getChild(s), i + (n.namespaced ? s + "/" : "");
  }, "");
};
p9.prototype.update = function(e) {
  Ko([], this.root, e);
};
p9.prototype.register = function(e, n, i) {
  var s = this;
  i === void 0 && (i = !0);
  var r = new O3(n, i);
  if (e.length === 0)
    this.root = r;
  else {
    var o = this.get(e.slice(0, -1));
    o.addChild(e[e.length - 1], r);
  }
  n.modules && X9(n.modules, function(l, L) {
    s.register(e.concat(L), l, i);
  });
};
p9.prototype.unregister = function(e) {
  var n = this.get(e.slice(0, -1)), i = e[e.length - 1], s = n.getChild(i);
  s && s.runtime && n.removeChild(i);
};
p9.prototype.isRegistered = function(e) {
  var n = this.get(e.slice(0, -1)), i = e[e.length - 1];
  return n ? n.hasChild(i) : !1;
};
function Ko(t, e, n) {
  if (e.update(n), n.modules)
    for (var i in n.modules) {
      if (!e.getChild(i))
        return;
      Ko(
        t.concat(i),
        e.getChild(i),
        n.modules[i]
      );
    }
}
function Yo(t) {
  return new C3(t);
}
var C3 = function(e) {
  var n = this;
  e === void 0 && (e = {});
  var i = e.plugins;
  i === void 0 && (i = []);
  var s = e.strict;
  s === void 0 && (s = !1);
  var r = e.devtools;
  this._committing = !1, this._actions = /* @__PURE__ */ Object.create(null), this._actionSubscribers = [], this._mutations = /* @__PURE__ */ Object.create(null), this._wrappedGetters = /* @__PURE__ */ Object.create(null), this._modules = new p9(e), this._modulesNamespaceMap = /* @__PURE__ */ Object.create(null), this._subscribers = [], this._makeLocalGettersCache = /* @__PURE__ */ Object.create(null), this._scope = null, this._devtools = r;
  var o = this, l = this, L = l.dispatch, a = l.commit;
  this.dispatch = function(h, d) {
    return L.call(o, h, d);
  }, this.commit = function(h, d, f) {
    return a.call(o, h, d, f);
  }, this.strict = s;
  var C = this._modules.root.state;
  j8(this, C, [], this._modules.root), De(this, C), i.forEach(function(c) {
    return c(n);
  });
}, Be = { state: { configurable: !0 } };
C3.prototype.install = function(e, n) {
  e.provide(n || Bo, this), e.config.globalProperties.$store = this;
  var i = this._devtools !== void 0 ? this._devtools : !1;
  i && Rd(e, this);
};
Be.state.get = function() {
  return this._state.data;
};
Be.state.set = function(t) {
};
C3.prototype.commit = function(e, n, i) {
  var s = this, r = o8(e, n, i), o = r.type, l = r.payload, L = { type: o, payload: l }, a = this._mutations[o];
  a && (this._withCommit(function() {
    a.forEach(function(c) {
      c(l);
    });
  }), this._subscribers.slice().forEach(function(C) {
    return C(L, s.state);
  }));
};
C3.prototype.dispatch = function(e, n) {
  var i = this, s = o8(e, n), r = s.type, o = s.payload, l = { type: r, payload: o }, L = this._actions[r];
  if (L) {
    try {
      this._actionSubscribers.slice().filter(function(C) {
        return C.before;
      }).forEach(function(C) {
        return C.before(l, i.state);
      });
    } catch {
    }
    var a = L.length > 1 ? Promise.all(L.map(function(C) {
      return C(o);
    })) : L[0](o);
    return new Promise(function(C, c) {
      a.then(function(h) {
        try {
          i._actionSubscribers.filter(function(d) {
            return d.after;
          }).forEach(function(d) {
            return d.after(l, i.state);
          });
        } catch {
        }
        C(h);
      }, function(h) {
        try {
          i._actionSubscribers.filter(function(d) {
            return d.error;
          }).forEach(function(d) {
            return d.error(l, i.state, h);
          });
        } catch {
        }
        c(h);
      });
    });
  }
};
C3.prototype.subscribe = function(e, n) {
  return Uo(e, this._subscribers, n);
};
C3.prototype.subscribeAction = function(e, n) {
  var i = typeof e == "function" ? { before: e } : e;
  return Uo(i, this._actionSubscribers, n);
};
C3.prototype.watch = function(e, n, i) {
  var s = this;
  return m3(function() {
    return e(s.state, s.getters);
  }, n, Object.assign({}, i));
};
C3.prototype.replaceState = function(e) {
  var n = this;
  this._withCommit(function() {
    n._state.data = e;
  });
};
C3.prototype.registerModule = function(e, n, i) {
  i === void 0 && (i = {}), typeof e == "string" && (e = [e]), this._modules.register(e, n), j8(this, this.state, e, this._modules.get(e), i.preserveState), De(this, this.state);
};
C3.prototype.unregisterModule = function(e) {
  var n = this;
  typeof e == "string" && (e = [e]), this._modules.unregister(e), this._withCommit(function() {
    var i = Pe(n.state, e.slice(0, -1));
    delete i[e[e.length - 1]];
  }), Wo(this);
};
C3.prototype.hasModule = function(e) {
  return typeof e == "string" && (e = [e]), this._modules.isRegistered(e);
};
C3.prototype.hotUpdate = function(e) {
  this._modules.update(e), Wo(this, !0);
};
C3.prototype._withCommit = function(e) {
  var n = this._committing;
  this._committing = !0, e(), this._committing = n;
};
Object.defineProperties(C3.prototype, Be);
var q8 = Ue(function(t, e) {
  var n = {};
  return ze(e).forEach(function(i) {
    var s = i.key, r = i.val;
    n[s] = function() {
      var l = this.$store.state, L = this.$store.getters;
      if (t) {
        var a = We(this.$store, "mapState", t);
        if (!a)
          return;
        l = a.context.state, L = a.context.getters;
      }
      return typeof r == "function" ? r.call(this, l, L) : l[r];
    }, n[s].vuex = !0;
  }), n;
}), Qo = Ue(function(t, e) {
  var n = {};
  return ze(e).forEach(function(i) {
    var s = i.key, r = i.val;
    n[s] = function() {
      for (var l = [], L = arguments.length; L--; )
        l[L] = arguments[L];
      var a = this.$store.commit;
      if (t) {
        var C = We(this.$store, "mapMutations", t);
        if (!C)
          return;
        a = C.context.commit;
      }
      return typeof r == "function" ? r.apply(this, [a].concat(l)) : a.apply(this.$store, [r].concat(l));
    };
  }), n;
}), R3 = Ue(function(t, e) {
  var n = {};
  return ze(e).forEach(function(i) {
    var s = i.key, r = i.val;
    r = t + r, n[s] = function() {
      if (!(t && !We(this.$store, "mapGetters", t)))
        return this.$store.getters[r];
    }, n[s].vuex = !0;
  }), n;
});
function ze(t) {
  return Sd(t) ? Array.isArray(t) ? t.map(function(e) {
    return { key: e, val: e };
  }) : Object.keys(t).map(function(e) {
    return { key: e, val: t[e] };
  }) : [];
}
function Sd(t) {
  return Array.isArray(t) || zo(t);
}
function Ue(t) {
  return function(e, n) {
    return typeof e != "string" ? (n = e, e = "") : e.charAt(e.length - 1) !== "/" && (e += "/"), t(e, n);
  };
}
function We(t, e, n) {
  var i = t._modulesNamespaceMap[n];
  return i;
}
String.prototype.seed = String.prototype.seed || Math.round(Math.random() * Math.pow(2, 32));
String.prototype.hashCode = function() {
  const t = this.toString();
  let e, n;
  const i = t.length & 3, s = t.length - i;
  let r = String.prototype.seed;
  const o = 3432918353, l = 461845907;
  let L = 0;
  for (; L < s; )
    n = t.charCodeAt(L) & 255 | (t.charCodeAt(++L) & 255) << 8 | (t.charCodeAt(++L) & 255) << 16 | (t.charCodeAt(++L) & 255) << 24, ++L, n = (n & 65535) * o + (((n >>> 16) * o & 65535) << 16) & 4294967295, n = n << 15 | n >>> 17, n = (n & 65535) * l + (((n >>> 16) * l & 65535) << 16) & 4294967295, r ^= n, r = r << 13 | r >>> 19, e = (r & 65535) * 5 + (((r >>> 16) * 5 & 65535) << 16) & 4294967295, r = (e & 65535) + 27492 + (((e >>> 16) + 58964 & 65535) << 16);
  switch (n = 0, i) {
    case 3:
      n ^= (t.charCodeAt(L + 2) & 255) << 16;
    case 2:
      n ^= (t.charCodeAt(L + 1) & 255) << 8;
    case 1:
      n ^= t.charCodeAt(L) & 255, n = (n & 65535) * o + (((n >>> 16) * o & 65535) << 16) & 4294967295, n = n << 15 | n >>> 17, n = (n & 65535) * l + (((n >>> 16) * l & 65535) << 16) & 4294967295, r ^= n;
  }
  return r ^= t.length, r ^= r >>> 16, r = (r & 65535) * 2246822507 + (((r >>> 16) * 2246822507 & 65535) << 16) & 4294967295, r ^= r >>> 13, r = (r & 65535) * 3266489909 + (((r >>> 16) * 3266489909 & 65535) << 16) & 4294967295, r ^= r >>> 16, r >>> 0;
};
/*! https://mths.be/codepointat v0.2.0 by @mathias */
String.prototype.codePointAt || function() {
  var t = function() {
    let n;
    try {
      const i = {}, s = Object.defineProperty;
      n = s(i, i, i) && s;
    } catch {
    }
    return n;
  }();
  const e = function(n) {
    if (this == null)
      throw TypeError();
    const i = String(this), s = i.length;
    let r = n ? Number(n) : 0;
    if (r !== r && (r = 0), r < 0 || r >= s)
      return;
    const o = i.charCodeAt(r);
    let l;
    return (
      // check if it’s the start of a surrogate pair
      o >= 55296 && o <= 56319 && // high surrogate
      s > r + 1 && (l = i.charCodeAt(r + 1), l >= 56320 && l <= 57343) ? (o - 55296) * 1024 + l - 56320 + 65536 : o
    );
  };
  t ? t(String.prototype, "codePointAt", {
    value: e,
    configurable: !0,
    writable: !0
  }) : String.prototype.codePointAt = e;
}();
/*! https://mths.be/fromcodepoint v0.2.1 by @mathias */
String.fromCodePoint || function() {
  const t = function() {
    let s;
    try {
      const r = {}, o = Object.defineProperty;
      s = o(r, r, r) && o;
    } catch {
    }
    return s;
  }(), e = String.fromCharCode, n = Math.floor, i = function(s) {
    const o = [];
    let l, L, a = -1;
    const C = arguments.length;
    if (!C)
      return "";
    let c = "";
    for (; ++a < C; ) {
      let h = Number(arguments[a]);
      if (!isFinite(h) || // `NaN`, `+Infinity`, or `-Infinity`
      h < 0 || // not a valid Unicode code point
      h > 1114111 || // not a valid Unicode code point
      n(h) !== h)
        throw RangeError("Invalid code point: " + h);
      h <= 65535 ? o.push(h) : (h -= 65536, l = (h >> 10) + 55296, L = h % 1024 + 56320, o.push(l, L)), (a + 1 === C || o.length > 16384) && (c += e.apply(null, o), o.length = 0);
    }
    return c;
  };
  t ? t(String, "fromCodePoint", {
    value: i,
    configurable: !0,
    writable: !0
  }) : String.fromCodePoint = i;
}();
class j {
  constructor() {
    this.source = null, this.type = null, this.channel = null, this.start = null, this.stop = null, this.tokenIndex = null, this.line = null, this.column = null, this._text = null;
  }
  getTokenSource() {
    return this.source[0];
  }
  getInputStream() {
    return this.source[1];
  }
  get text() {
    return this._text;
  }
  set text(e) {
    this._text = e;
  }
}
j.INVALID_TYPE = 0;
j.EPSILON = -2;
j.MIN_USER_TOKEN_TYPE = 1;
j.EOF = -1;
j.DEFAULT_CHANNEL = 0;
j.HIDDEN_CHANNEL = 1;
function V9(t, e) {
  if (!Array.isArray(t) || !Array.isArray(e))
    return !1;
  if (t === e)
    return !0;
  if (t.length !== e.length)
    return !1;
  for (let n = 0; n < t.length; n++)
    if (t[n] !== e[n] && (!t[n].equals || !t[n].equals(e[n])))
      return !1;
  return !0;
}
class v3 {
  constructor() {
    this.count = 0, this.hash = 0;
  }
  update() {
    for (let e = 0; e < arguments.length; e++) {
      const n = arguments[e];
      if (n != null)
        if (Array.isArray(n))
          this.update.apply(this, n);
        else {
          let i = 0;
          switch (typeof n) {
            case "undefined":
            case "function":
              continue;
            case "number":
            case "boolean":
              i = n;
              break;
            case "string":
              i = n.hashCode();
              break;
            default:
              n.updateHashCode ? n.updateHashCode(this) : console.log("No updateHashCode for " + n.toString());
              continue;
          }
          i = i * 3432918353, i = i << 15 | i >>> 32 - 15, i = i * 461845907, this.count = this.count + 1;
          let s = this.hash ^ i;
          s = s << 13 | s >>> 32 - 13, s = s * 5 + 3864292196, this.hash = s;
        }
    }
  }
  finish() {
    let e = this.hash ^ this.count * 4;
    return e = e ^ e >>> 16, e = e * 2246822507, e = e ^ e >>> 13, e = e * 3266489909, e = e ^ e >>> 16, e;
  }
  static hashStuff() {
    const e = new v3();
    return e.update.apply(e, arguments), e.finish();
  }
}
function Xo(t) {
  return t ? t.hashCode() : -1;
}
function Jo(t, e) {
  return t ? t.equals(e) : t === e;
}
function bd(t) {
  return t === null ? "null" : t;
}
function S4(t) {
  return Array.isArray(t) ? "[" + t.map(bd).join(", ") + "]" : "null";
}
const F5 = "h-";
class w3 {
  constructor(e, n) {
    this.data = {}, this.hashFunction = e || Xo, this.equalsFunction = n || Jo;
  }
  add(e) {
    const n = F5 + this.hashFunction(e);
    if (n in this.data) {
      const i = this.data[n];
      for (let s = 0; s < i.length; s++)
        if (this.equalsFunction(e, i[s]))
          return i[s];
      return i.push(e), e;
    } else
      return this.data[n] = [e], e;
  }
  has(e) {
    return this.get(e) != null;
  }
  get(e) {
    const n = F5 + this.hashFunction(e);
    if (n in this.data) {
      const i = this.data[n];
      for (let s = 0; s < i.length; s++)
        if (this.equalsFunction(e, i[s]))
          return i[s];
    }
    return null;
  }
  values() {
    return Object.keys(this.data).filter((e) => e.startsWith(F5)).flatMap((e) => this.data[e], this);
  }
  toString() {
    return S4(this.values());
  }
  get length() {
    return Object.keys(this.data).filter((e) => e.startsWith(F5)).map((e) => this.data[e].length, this).reduce((e, n) => e + n, 0);
  }
}
class j2 {
  hashCode() {
    const e = new v3();
    return this.updateHashCode(e), e.finish();
  }
  /**
   * For context independent predicates, we evaluate them without a local
   * context (i.e., null context). That way, we can evaluate them without
   * having to create proper rule-specific context during prediction (as
   * opposed to the parser, which creates them naturally). In a practical
   * sense, this avoids a cast exception from RuleContext to myruleContext.
   *
   * <p>For context dependent predicates, we must pass in a local context so that
   * references such as $arg evaluate properly as _localctx.arg. We only
   * capture context dependent predicates in the context in which we begin
   * prediction, so we passed in the outer context here in case of context
   * dependent predicate evaluation.</p>
   */
  evaluate(e, n) {
  }
  /**
   * Evaluate the precedence predicates for the context and reduce the result.
   *
   * @param parser The parser instance.
   * @param outerContext The current parser context object.
   * @return The simplified semantic context after precedence predicates are
   * evaluated, which will be one of the following values.
   * <ul>
   * <li>{@link //NONE}: if the predicate simplifies to {@code true} after
   * precedence predicates are evaluated.</li>
   * <li>{@code null}: if the predicate simplifies to {@code false} after
   * precedence predicates are evaluated.</li>
   * <li>{@code this}: if the semantic context is not changed as a result of
   * precedence predicate evaluation.</li>
   * <li>A non-{@code null} {@link SemanticContext}: the new simplified
   * semantic context after precedence predicates are evaluated.</li>
   * </ul>
   */
  evalPrecedence(e, n) {
    return this;
  }
  static andContext(e, n) {
    if (e === null || e === j2.NONE)
      return n;
    if (n === null || n === j2.NONE)
      return e;
    const i = new A0(e, n);
    return i.opnds.length === 1 ? i.opnds[0] : i;
  }
  static orContext(e, n) {
    if (e === null)
      return n;
    if (n === null)
      return e;
    if (e === j2.NONE || n === j2.NONE)
      return j2.NONE;
    const i = new Z0(e, n);
    return i.opnds.length === 1 ? i.opnds[0] : i;
  }
}
class A0 extends j2 {
  /**
   * A semantic context which is true whenever none of the contained contexts
   * is false
   */
  constructor(e, n) {
    super();
    const i = new w3();
    e instanceof A0 ? e.opnds.map(function(r) {
      i.add(r);
    }) : i.add(e), n instanceof A0 ? n.opnds.map(function(r) {
      i.add(r);
    }) : i.add(n);
    const s = el(i);
    if (s.length > 0) {
      let r = null;
      s.map(function(o) {
        (r === null || o.precedence < r.precedence) && (r = o);
      }), i.add(r);
    }
    this.opnds = Array.from(i.values());
  }
  equals(e) {
    return this === e ? !0 : e instanceof A0 ? V9(this.opnds, e.opnds) : !1;
  }
  updateHashCode(e) {
    e.update(this.opnds, "AND");
  }
  /**
   * {@inheritDoc}
   *
   * <p>
   * The evaluation of predicates by this context is short-circuiting, but
   * unordered.</p>
   */
  evaluate(e, n) {
    for (let i = 0; i < this.opnds.length; i++)
      if (!this.opnds[i].evaluate(e, n))
        return !1;
    return !0;
  }
  evalPrecedence(e, n) {
    let i = !1;
    const s = [];
    for (let o = 0; o < this.opnds.length; o++) {
      const l = this.opnds[o], L = l.evalPrecedence(e, n);
      if (i |= L !== l, L === null)
        return null;
      L !== j2.NONE && s.push(L);
    }
    if (!i)
      return this;
    if (s.length === 0)
      return j2.NONE;
    let r = null;
    return s.map(function(o) {
      r = r === null ? o : j2.andContext(r, o);
    }), r;
  }
  toString() {
    const e = this.opnds.map((n) => n.toString());
    return (e.length > 3 ? e.slice(3) : e).join("&&");
  }
}
class Z0 extends j2 {
  /**
   * A semantic context which is true whenever at least one of the contained
   * contexts is true
   */
  constructor(e, n) {
    super();
    const i = new w3();
    e instanceof Z0 ? e.opnds.map(function(r) {
      i.add(r);
    }) : i.add(e), n instanceof Z0 ? n.opnds.map(function(r) {
      i.add(r);
    }) : i.add(n);
    const s = el(i);
    if (s.length > 0) {
      const r = s.sort(function(l, L) {
        return l.compareTo(L);
      }), o = r[r.length - 1];
      i.add(o);
    }
    this.opnds = Array.from(i.values());
  }
  equals(e) {
    return this === e ? !0 : e instanceof Z0 ? V9(this.opnds, e.opnds) : !1;
  }
  updateHashCode(e) {
    e.update(this.opnds, "OR");
  }
  /**
   * <p>
   * The evaluation of predicates by this context is short-circuiting, but
   * unordered.</p>
   */
  evaluate(e, n) {
    for (let i = 0; i < this.opnds.length; i++)
      if (this.opnds[i].evaluate(e, n))
        return !0;
    return !1;
  }
  evalPrecedence(e, n) {
    let i = !1;
    const s = [];
    for (let o = 0; o < this.opnds.length; o++) {
      const l = this.opnds[o], L = l.evalPrecedence(e, n);
      if (i |= L !== l, L === j2.NONE)
        return j2.NONE;
      L !== null && s.push(L);
    }
    return i ? (s.length === 0, null) : this;
  }
  toString() {
    const e = this.opnds.map((n) => n.toString());
    return (e.length > 3 ? e.slice(3) : e).join("||");
  }
}
function el(t) {
  const e = [];
  return t.values().map(function(n) {
    n instanceof j2.PrecedencePredicate && e.push(n);
  }), e;
}
function pi(t, e) {
  if (t === null) {
    const n = { state: null, alt: null, context: null, semanticContext: null };
    return e && (n.reachesIntoOuterContext = 0), n;
  } else {
    const n = {};
    return n.state = t.state || null, n.alt = t.alt === void 0 ? null : t.alt, n.context = t.context || null, n.semanticContext = t.semanticContext || null, e && (n.reachesIntoOuterContext = t.reachesIntoOuterContext || 0, n.precedenceFilterSuppressed = t.precedenceFilterSuppressed || !1), n;
  }
}
class c1 {
  /**
   * @param {Object} params A tuple: (ATN state, predicted alt, syntactic, semantic context).
   * The syntactic context is a graph-structured stack node whose
   * path(s) to the root is the rule invocation(s)
   * chain used to arrive at the state.  The semantic context is
   * the tree of semantic predicates encountered before reaching
   * an ATN state
   */
  constructor(e, n) {
    this.checkContext(e, n), e = pi(e), n = pi(n, !0), this.state = e.state !== null ? e.state : n.state, this.alt = e.alt !== null ? e.alt : n.alt, this.context = e.context !== null ? e.context : n.context, this.semanticContext = e.semanticContext !== null ? e.semanticContext : n.semanticContext !== null ? n.semanticContext : j2.NONE, this.reachesIntoOuterContext = n.reachesIntoOuterContext, this.precedenceFilterSuppressed = n.precedenceFilterSuppressed;
  }
  checkContext(e, n) {
    (e.context === null || e.context === void 0) && (n === null || n.context === null || n.context === void 0) && (this.context = null);
  }
  hashCode() {
    const e = new v3();
    return this.updateHashCode(e), e.finish();
  }
  updateHashCode(e) {
    e.update(this.state.stateNumber, this.alt, this.context, this.semanticContext);
  }
  /**
   * An ATN configuration is equal to another if both have
   * the same state, they predict the same alternative, and
   * syntactic/semantic contexts are the same
   */
  equals(e) {
    return this === e ? !0 : e instanceof c1 ? this.state.stateNumber === e.state.stateNumber && this.alt === e.alt && (this.context === null ? e.context === null : this.context.equals(e.context)) && this.semanticContext.equals(e.semanticContext) && this.precedenceFilterSuppressed === e.precedenceFilterSuppressed : !1;
  }
  hashCodeForConfigSet() {
    const e = new v3();
    return e.update(this.state.stateNumber, this.alt, this.semanticContext), e.finish();
  }
  equalsForConfigSet(e) {
    return this === e ? !0 : e instanceof c1 ? this.state.stateNumber === e.state.stateNumber && this.alt === e.alt && this.semanticContext.equals(e.semanticContext) : !1;
  }
  toString() {
    return "(" + this.state + "," + this.alt + (this.context !== null ? ",[" + this.context.toString() + "]" : "") + (this.semanticContext !== j2.NONE ? "," + this.semanticContext.toString() : "") + (this.reachesIntoOuterContext > 0 ? ",up=" + this.reachesIntoOuterContext : "") + ")";
  }
}
class G2 {
  constructor(e, n) {
    this.start = e, this.stop = n;
  }
  clone() {
    return new G2(this.start, this.stop);
  }
  contains(e) {
    return e >= this.start && e < this.stop;
  }
  toString() {
    return this.start === this.stop - 1 ? this.start.toString() : this.start.toString() + ".." + (this.stop - 1).toString();
  }
  get length() {
    return this.stop - this.start;
  }
}
G2.INVALID_INTERVAL = new G2(-1, -2);
class S3 {
  constructor() {
    this.intervals = null, this.readOnly = !1;
  }
  first(e) {
    return this.intervals === null || this.intervals.length === 0 ? j.INVALID_TYPE : this.intervals[0].start;
  }
  addOne(e) {
    this.addInterval(new G2(e, e + 1));
  }
  addRange(e, n) {
    this.addInterval(new G2(e, n + 1));
  }
  addInterval(e) {
    if (this.intervals === null)
      this.intervals = [], this.intervals.push(e.clone());
    else {
      for (let n = 0; n < this.intervals.length; n++) {
        const i = this.intervals[n];
        if (e.stop < i.start) {
          this.intervals.splice(n, 0, e);
          return;
        } else if (e.stop === i.start) {
          this.intervals[n] = new G2(e.start, i.stop);
          return;
        } else if (e.start <= i.stop) {
          this.intervals[n] = new G2(Math.min(i.start, e.start), Math.max(i.stop, e.stop)), this.reduce(n);
          return;
        }
      }
      this.intervals.push(e.clone());
    }
  }
  addSet(e) {
    return e.intervals !== null && e.intervals.forEach((n) => this.addInterval(n), this), this;
  }
  reduce(e) {
    if (e < this.intervals.length - 1) {
      const n = this.intervals[e], i = this.intervals[e + 1];
      n.stop >= i.stop ? (this.intervals.splice(e + 1, 1), this.reduce(e)) : n.stop >= i.start && (this.intervals[e] = new G2(n.start, i.stop), this.intervals.splice(e + 1, 1));
    }
  }
  complement(e, n) {
    const i = new S3();
    return i.addInterval(new G2(e, n + 1)), this.intervals !== null && this.intervals.forEach((s) => i.removeRange(s)), i;
  }
  contains(e) {
    if (this.intervals === null)
      return !1;
    for (let n = 0; n < this.intervals.length; n++)
      if (this.intervals[n].contains(e))
        return !0;
    return !1;
  }
  removeRange(e) {
    if (e.start === e.stop - 1)
      this.removeOne(e.start);
    else if (this.intervals !== null) {
      let n = 0;
      for (let i = 0; i < this.intervals.length; i++) {
        const s = this.intervals[n];
        if (e.stop <= s.start)
          return;
        if (e.start > s.start && e.stop < s.stop) {
          this.intervals[n] = new G2(s.start, e.start);
          const r = new G2(e.stop, s.stop);
          this.intervals.splice(n, 0, r);
          return;
        } else
          e.start <= s.start && e.stop >= s.stop ? (this.intervals.splice(n, 1), n = n - 1) : e.start < s.stop ? this.intervals[n] = new G2(s.start, e.start) : e.stop < s.stop && (this.intervals[n] = new G2(e.stop, s.stop));
        n += 1;
      }
    }
  }
  removeOne(e) {
    if (this.intervals !== null)
      for (let n = 0; n < this.intervals.length; n++) {
        const i = this.intervals[n];
        if (e < i.start)
          return;
        if (e === i.start && e === i.stop - 1) {
          this.intervals.splice(n, 1);
          return;
        } else if (e === i.start) {
          this.intervals[n] = new G2(i.start + 1, i.stop);
          return;
        } else if (e === i.stop - 1) {
          this.intervals[n] = new G2(i.start, i.stop - 1);
          return;
        } else if (e < i.stop - 1) {
          const s = new G2(i.start, e);
          i.start = e + 1, this.intervals.splice(n, 0, s);
          return;
        }
      }
  }
  toString(e, n, i) {
    return e = e || null, n = n || null, i = i || !1, this.intervals === null ? "{}" : e !== null || n !== null ? this.toTokenString(e, n) : i ? this.toCharString() : this.toIndexString();
  }
  toCharString() {
    const e = [];
    for (let n = 0; n < this.intervals.length; n++) {
      const i = this.intervals[n];
      i.stop === i.start + 1 ? i.start === j.EOF ? e.push("<EOF>") : e.push("'" + String.fromCharCode(i.start) + "'") : e.push("'" + String.fromCharCode(i.start) + "'..'" + String.fromCharCode(i.stop - 1) + "'");
    }
    return e.length > 1 ? "{" + e.join(", ") + "}" : e[0];
  }
  toIndexString() {
    const e = [];
    for (let n = 0; n < this.intervals.length; n++) {
      const i = this.intervals[n];
      i.stop === i.start + 1 ? i.start === j.EOF ? e.push("<EOF>") : e.push(i.start.toString()) : e.push(i.start.toString() + ".." + (i.stop - 1).toString());
    }
    return e.length > 1 ? "{" + e.join(", ") + "}" : e[0];
  }
  toTokenString(e, n) {
    const i = [];
    for (let s = 0; s < this.intervals.length; s++) {
      const r = this.intervals[s];
      for (let o = r.start; o < r.stop; o++)
        i.push(this.elementName(e, n, o));
    }
    return i.length > 1 ? "{" + i.join(", ") + "}" : i[0];
  }
  elementName(e, n, i) {
    return i === j.EOF ? "<EOF>" : i === j.EPSILON ? "<EPSILON>" : e[i] || n[i];
  }
  get length() {
    return this.intervals.map((e) => e.length).reduce((e, n) => e + n);
  }
}
class c2 {
  constructor() {
    this.atn = null, this.stateNumber = c2.INVALID_STATE_NUMBER, this.stateType = null, this.ruleIndex = 0, this.epsilonOnlyTransitions = !1, this.transitions = [], this.nextTokenWithinRule = null;
  }
  toString() {
    return this.stateNumber;
  }
  equals(e) {
    return e instanceof c2 ? this.stateNumber === e.stateNumber : !1;
  }
  isNonGreedyExitState() {
    return !1;
  }
  addTransition(e, n) {
    n === void 0 && (n = -1), this.transitions.length === 0 ? this.epsilonOnlyTransitions = e.isEpsilon : this.epsilonOnlyTransitions !== e.isEpsilon && (this.epsilonOnlyTransitions = !1), n === -1 ? this.transitions.push(e) : this.transitions.splice(n, 1, e);
  }
}
c2.INVALID_TYPE = 0;
c2.BASIC = 1;
c2.RULE_START = 2;
c2.BLOCK_START = 3;
c2.PLUS_BLOCK_START = 4;
c2.STAR_BLOCK_START = 5;
c2.TOKEN_START = 6;
c2.RULE_STOP = 7;
c2.BLOCK_END = 8;
c2.STAR_LOOP_BACK = 9;
c2.STAR_LOOP_ENTRY = 10;
c2.PLUS_LOOP_BACK = 11;
c2.LOOP_END = 12;
c2.serializationNames = [
  "INVALID",
  "BASIC",
  "RULE_START",
  "BLOCK_START",
  "PLUS_BLOCK_START",
  "STAR_BLOCK_START",
  "TOKEN_START",
  "RULE_STOP",
  "BLOCK_END",
  "STAR_LOOP_BACK",
  "STAR_LOOP_ENTRY",
  "PLUS_LOOP_BACK",
  "LOOP_END"
];
c2.INVALID_STATE_NUMBER = -1;
class H1 extends c2 {
  constructor() {
    return super(), this.stateType = c2.RULE_STOP, this;
  }
}
class a2 {
  constructor(e) {
    if (e == null)
      throw "target cannot be null.";
    this.target = e, this.isEpsilon = !1, this.label = null;
  }
}
a2.EPSILON = 1;
a2.RANGE = 2;
a2.RULE = 3;
a2.PREDICATE = 4;
a2.ATOM = 5;
a2.ACTION = 6;
a2.SET = 7;
a2.NOT_SET = 8;
a2.WILDCARD = 9;
a2.PRECEDENCE = 10;
a2.serializationNames = [
  "INVALID",
  "EPSILON",
  "RANGE",
  "RULE",
  "PREDICATE",
  "ATOM",
  "ACTION",
  "SET",
  "NOT_SET",
  "WILDCARD",
  "PRECEDENCE"
];
a2.serializationTypes = {
  EpsilonTransition: a2.EPSILON,
  RangeTransition: a2.RANGE,
  RuleTransition: a2.RULE,
  PredicateTransition: a2.PREDICATE,
  AtomTransition: a2.ATOM,
  ActionTransition: a2.ACTION,
  SetTransition: a2.SET,
  NotSetTransition: a2.NOT_SET,
  WildcardTransition: a2.WILDCARD,
  PrecedencePredicateTransition: a2.PRECEDENCE
};
class l8 extends a2 {
  constructor(e, n, i, s) {
    super(e), this.ruleIndex = n, this.precedence = i, this.followState = s, this.serializationType = a2.RULE, this.isEpsilon = !0;
  }
  matches(e, n, i) {
    return !1;
  }
}
class He extends a2 {
  constructor(e, n) {
    super(e), this.serializationType = a2.SET, n != null ? this.label = n : (this.label = new S3(), this.label.addOne(j.INVALID_TYPE));
  }
  matches(e, n, i) {
    return this.label.contains(e);
  }
  toString() {
    return this.label.toString();
  }
}
class $e extends He {
  constructor(e, n) {
    super(e, n), this.serializationType = a2.NOT_SET;
  }
  matches(e, n, i) {
    return e >= n && e <= i && !super.matches(e, n, i);
  }
  toString() {
    return "~" + super.toString();
  }
}
class tl extends a2 {
  constructor(e) {
    super(e), this.serializationType = a2.WILDCARD;
  }
  matches(e, n, i) {
    return e >= n && e <= i;
  }
  toString() {
    return ".";
  }
}
class Ve extends a2 {
  constructor(e) {
    super(e);
  }
}
class Ed {
}
class Id extends Ed {
}
class nl extends Id {
}
class L8 extends nl {
  getRuleContext() {
    throw new Error("missing interface implementation");
  }
}
class f4 extends nl {
}
class K8 extends f4 {
}
function Fd(t, e) {
  return t = t.replace(/\t/g, "\\t").replace(/\n/g, "\\n").replace(/\r/g, "\\r"), e && (t = t.replace(/ /g, "·")), t;
}
const U3 = {
  /**
   * Print out a whole tree in LISP form. {@link //getNodeText} is used on the
   *  node payloads to get the text for the nodes.  Detect
   *  parse trees and extract data appropriately.
   */
  toStringTree: function(t, e, n) {
    e = e || null, n = n || null, n !== null && (e = n.ruleNames);
    let i = U3.getNodeText(t, e);
    i = Fd(i, !1);
    const s = t.getChildCount();
    if (s === 0)
      return i;
    let r = "(" + i + " ";
    s > 0 && (i = U3.toStringTree(t.getChild(0), e), r = r.concat(i));
    for (let o = 1; o < s; o++)
      i = U3.toStringTree(t.getChild(o), e), r = r.concat(" " + i);
    return r = r.concat(")"), r;
  },
  getNodeText: function(t, e, n) {
    if (e = e || null, n = n || null, n !== null && (e = n.ruleNames), e !== null)
      if (t instanceof L8) {
        const r = t.getRuleContext().getAltNumber();
        return r != 0 ? e[t.ruleIndex] + ":" + r : e[t.ruleIndex];
      } else {
        if (t instanceof K8)
          return t.toString();
        if (t instanceof f4 && t.symbol !== null)
          return t.symbol.text;
      }
    const i = t.getPayload();
    return i instanceof j ? i.text : t.getPayload().toString();
  },
  /**
   * Return ordered list of all children of this node
   */
  getChildren: function(t) {
    const e = [];
    for (let n = 0; n < t.getChildCount(); n++)
      e.push(t.getChild(n));
    return e;
  },
  /**
   * Return a list of all ancestors of this node.  The first node of
   * list is the root and the last is the parent of this node.
   */
  getAncestors: function(t) {
    let e = [];
    for (t = t.getParent(); t !== null; )
      e = [t].concat(e), t = t.getParent();
    return e;
  },
  findAllTokenNodes: function(t, e) {
    return U3.findAllNodes(t, e, !0);
  },
  findAllRuleNodes: function(t, e) {
    return U3.findAllNodes(t, e, !1);
  },
  findAllNodes: function(t, e, n) {
    const i = [];
    return U3._findAllNodes(t, e, n, i), i;
  },
  _findAllNodes: function(t, e, n, i) {
    n && t instanceof f4 ? t.symbol.type === e && i.push(t) : !n && t instanceof L8 && t.ruleIndex === e && i.push(t);
    for (let s = 0; s < t.getChildCount(); s++)
      U3._findAllNodes(t.getChild(s), e, n, i);
  },
  descendants: function(t) {
    let e = [t];
    for (let n = 0; n < t.getChildCount(); n++)
      e = e.concat(U3.descendants(t.getChild(n)));
    return e;
  }
};
class G9 extends L8 {
  /** A rule context is a record of a single rule invocation. It knows
   * which context invoked it, if any. If there is no parent context, then
   * naturally the invoking state is not valid.  The parent link
   * provides a chain upwards from the current rule invocation to the root
   * of the invocation tree, forming a stack. We actually carry no
   * information about the rule associated with this context (except
   * when parsing). We keep only the state number of the invoking state from
   * the ATN submachine that invoked this. Contrast this with the s
   * pointer inside ParserRuleContext that tracks the current state
   * being "executed" for the current rule.
   *
   * The parent contexts are useful for computing lookahead sets and
   * getting error information.
   *
   * These objects are used during parsing and prediction.
   * For the special case of parsers, we use the subclass
   * ParserRuleContext.
   *
   * @see ParserRuleContext
   */
  constructor(e, n) {
    super(), this.parentCtx = e || null, this.invokingState = n || -1;
  }
  depth() {
    let e = 0, n = this;
    for (; n !== null; )
      n = n.parentCtx, e += 1;
    return e;
  }
  /**
   * A context is empty if there is no invoking state; meaning nobody call
   * current context.
   */
  isEmpty() {
    return this.invokingState === -1;
  }
  // satisfy the ParseTree / SyntaxTree interface
  getSourceInterval() {
    return G2.INVALID_INTERVAL;
  }
  getRuleContext() {
    return this;
  }
  getPayload() {
    return this;
  }
  /**
   * Return the combined text of all child nodes. This method only considers
   * tokens which have been added to the parse tree.
   * <p>
   * Since tokens on hidden channels (e.g. whitespace or comments) are not
   * added to the parse trees, they will not appear in the output of this
   * method.
   */
  getText() {
    return this.getChildCount() === 0 ? "" : this.children.map(function(e) {
      return e.getText();
    }).join("");
  }
  /**
   * For rule associated with this parse tree internal node, return
   * the outer alternative number used to match the input. Default
   * implementation does not compute nor store this alt num. Create
   * a subclass of ParserRuleContext with backing field and set
   * option contextSuperClass.
   * to set it.
   */
  getAltNumber() {
    return 0;
  }
  /**
   * Set the outer alternative number for this context node. Default
   * implementation does nothing to avoid backing field overhead for
   * trees that don't need it.  Create
   * a subclass of ParserRuleContext with backing field and set
   * option contextSuperClass.
   */
  setAltNumber(e) {
  }
  getChild(e) {
    return null;
  }
  getChildCount() {
    return 0;
  }
  accept(e) {
    return e.visitChildren(this);
  }
  /**
   * Print out a whole tree, not just a node, in LISP format
   * (root child1 .. childN). Print just a node if this is a leaf.
   */
  toStringTree(e, n) {
    return U3.toStringTree(this, e, n);
  }
  toString(e, n) {
    e = e || null, n = n || null;
    let i = this, s = "[";
    for (; i !== null && i !== n; ) {
      if (e === null)
        i.isEmpty() || (s += i.invokingState);
      else {
        const r = i.ruleIndex, o = r >= 0 && r < e.length ? e[r] : "" + r;
        s += o;
      }
      i.parentCtx !== null && (e !== null || !i.parentCtx.isEmpty()) && (s += " "), i = i.parentCtx;
    }
    return s += "]", s;
  }
}
class O2 {
  constructor(e) {
    this.cachedHashCode = e;
  }
  /**
   * Stores the computed hash code of this {@link PredictionContext}. The hash
   * code is computed in parts to match the following reference algorithm.
   *
   * <pre>
   * private int referenceHashCode() {
   * int hash = {@link MurmurHash//initialize MurmurHash.initialize}({@link
   * //INITIAL_HASH});
   *
   * for (int i = 0; i &lt; {@link //size()}; i++) {
   * hash = {@link MurmurHash//update MurmurHash.update}(hash, {@link //getParent
   * getParent}(i));
   * }
   *
   * for (int i = 0; i &lt; {@link //size()}; i++) {
   * hash = {@link MurmurHash//update MurmurHash.update}(hash, {@link
   * //getReturnState getReturnState}(i));
   * }
   *
   * hash = {@link MurmurHash//finish MurmurHash.finish}(hash, 2// {@link
   * //size()});
   * return hash;
   * }
   * </pre>
   * This means only the {@link //EMPTY} context is in set.
   */
  isEmpty() {
    return this === O2.EMPTY;
  }
  hasEmptyPath() {
    return this.getReturnState(this.length - 1) === O2.EMPTY_RETURN_STATE;
  }
  hashCode() {
    return this.cachedHashCode;
  }
  updateHashCode(e) {
    e.update(this.cachedHashCode);
  }
}
O2.EMPTY = null;
O2.EMPTY_RETURN_STATE = 2147483647;
O2.globalNodeCount = 1;
O2.id = O2.globalNodeCount;
class n4 extends O2 {
  constructor(e, n) {
    const i = new v3();
    i.update(e, n);
    const s = i.finish();
    return super(s), this.parents = e, this.returnStates = n, this;
  }
  isEmpty() {
    return this.returnStates[0] === O2.EMPTY_RETURN_STATE;
  }
  getParent(e) {
    return this.parents[e];
  }
  getReturnState(e) {
    return this.returnStates[e];
  }
  equals(e) {
    return this === e ? !0 : e instanceof n4 ? this.hashCode() !== e.hashCode() ? !1 : V9(this.returnStates, e.returnStates) && V9(this.parents, e.parents) : !1;
  }
  toString() {
    if (this.isEmpty())
      return "[]";
    {
      let e = "[";
      for (let n = 0; n < this.returnStates.length; n++) {
        if (n > 0 && (e = e + ", "), this.returnStates[n] === O2.EMPTY_RETURN_STATE) {
          e = e + "$";
          continue;
        }
        e = e + this.returnStates[n], this.parents[n] !== null ? e = e + " " + this.parents[n] : e = e + "null";
      }
      return e + "]";
    }
  }
  get length() {
    return this.returnStates.length;
  }
}
class $1 extends O2 {
  constructor(e, n) {
    let i = 0;
    const s = new v3();
    e !== null ? s.update(e, n) : s.update(1), i = s.finish(), super(i), this.parentCtx = e, this.returnState = n;
  }
  getParent(e) {
    return this.parentCtx;
  }
  getReturnState(e) {
    return this.returnState;
  }
  equals(e) {
    return this === e ? !0 : e instanceof $1 ? this.hashCode() !== e.hashCode() || this.returnState !== e.returnState ? !1 : this.parentCtx == null ? e.parentCtx == null : this.parentCtx.equals(e.parentCtx) : !1;
  }
  toString() {
    const e = this.parentCtx === null ? "" : this.parentCtx.toString();
    return e.length === 0 ? this.returnState === O2.EMPTY_RETURN_STATE ? "$" : "" + this.returnState : "" + this.returnState + " " + e;
  }
  get length() {
    return 1;
  }
  static create(e, n) {
    return n === O2.EMPTY_RETURN_STATE && e === null ? O2.EMPTY : new $1(e, n);
  }
}
class k6 extends $1 {
  constructor() {
    super(null, O2.EMPTY_RETURN_STATE);
  }
  isEmpty() {
    return !0;
  }
  getParent(e) {
    return null;
  }
  getReturnState(e) {
    return this.returnState;
  }
  equals(e) {
    return this === e;
  }
  toString() {
    return "$";
  }
}
O2.EMPTY = new k6();
const L0 = "h-";
class o5 {
  constructor(e, n) {
    this.data = {}, this.hashFunction = e || Xo, this.equalsFunction = n || Jo;
  }
  set(e, n) {
    const i = L0 + this.hashFunction(e);
    if (i in this.data) {
      const s = this.data[i];
      for (let r = 0; r < s.length; r++) {
        const o = s[r];
        if (this.equalsFunction(e, o.key)) {
          const l = o.value;
          return o.value = n, l;
        }
      }
      return s.push({ key: e, value: n }), n;
    } else
      return this.data[i] = [{ key: e, value: n }], n;
  }
  containsKey(e) {
    const n = L0 + this.hashFunction(e);
    if (n in this.data) {
      const i = this.data[n];
      for (let s = 0; s < i.length; s++) {
        const r = i[s];
        if (this.equalsFunction(e, r.key))
          return !0;
      }
    }
    return !1;
  }
  get(e) {
    const n = L0 + this.hashFunction(e);
    if (n in this.data) {
      const i = this.data[n];
      for (let s = 0; s < i.length; s++) {
        const r = i[s];
        if (this.equalsFunction(e, r.key))
          return r.value;
      }
    }
    return null;
  }
  entries() {
    return Object.keys(this.data).filter((e) => e.startsWith(L0)).flatMap((e) => this.data[e], this);
  }
  getKeys() {
    return this.entries().map((e) => e.key);
  }
  getValues() {
    return this.entries().map((e) => e.value);
  }
  toString() {
    return "[" + this.entries().map((n) => "{" + n.key + ":" + n.value + "}").join(", ") + "]";
  }
  get length() {
    return Object.keys(this.data).filter((e) => e.startsWith(L0)).map((e) => this.data[e].length, this).reduce((e, n) => e + n, 0);
  }
}
function Ge(t, e) {
  if (e == null && (e = G9.EMPTY), e.parentCtx === null || e === G9.EMPTY)
    return O2.EMPTY;
  const n = Ge(t, e.parentCtx), s = t.states[e.invokingState].transitions[0];
  return $1.create(n, s.followState.stateNumber);
}
function il(t, e, n) {
  if (t.isEmpty())
    return t;
  let i = n.get(t) || null;
  if (i !== null)
    return i;
  if (i = e.get(t), i !== null)
    return n.set(t, i), i;
  let s = !1, r = [];
  for (let l = 0; l < r.length; l++) {
    const L = il(t.getParent(l), e, n);
    if (s || L !== t.getParent(l)) {
      if (!s) {
        r = [];
        for (let a = 0; a < t.length; a++)
          r[a] = t.getParent(a);
        s = !0;
      }
      r[l] = L;
    }
  }
  if (!s)
    return e.add(t), n.set(t, t), t;
  let o = null;
  return r.length === 0 ? o = O2.EMPTY : r.length === 1 ? o = $1.create(r[0], t.getReturnState(0)) : o = new n4(r, t.returnStates), e.add(o), n.set(o, o), n.set(t, o), o;
}
function je(t, e, n, i) {
  if (t === e)
    return t;
  if (t instanceof $1 && e instanceof $1)
    return Dd(t, e, n, i);
  if (n) {
    if (t instanceof k6)
      return t;
    if (e instanceof k6)
      return e;
  }
  return t instanceof $1 && (t = new n4([t.getParent()], [t.returnState])), e instanceof $1 && (e = new n4([e.getParent()], [e.returnState])), Od(t, e, n, i);
}
function Od(t, e, n, i) {
  if (i !== null) {
    let C = i.get(t, e);
    if (C !== null || (C = i.get(e, t), C !== null))
      return C;
  }
  let s = 0, r = 0, o = 0, l = [], L = [];
  for (; s < t.returnStates.length && r < e.returnStates.length; ) {
    const C = t.parents[s], c = e.parents[r];
    if (t.returnStates[s] === e.returnStates[r]) {
      const h = t.returnStates[s];
      h === O2.EMPTY_RETURN_STATE && C === null && c === null || C !== null && c !== null && C === c ? (L[o] = C, l[o] = h) : (L[o] = je(C, c, n, i), l[o] = h), s += 1, r += 1;
    } else
      t.returnStates[s] < e.returnStates[r] ? (L[o] = C, l[o] = t.returnStates[s], s += 1) : (L[o] = c, l[o] = e.returnStates[r], r += 1);
    o += 1;
  }
  if (s < t.returnStates.length)
    for (let C = s; C < t.returnStates.length; C++)
      L[o] = t.parents[C], l[o] = t.returnStates[C], o += 1;
  else
    for (let C = r; C < e.returnStates.length; C++)
      L[o] = e.parents[C], l[o] = e.returnStates[C], o += 1;
  if (o < L.length) {
    if (o === 1) {
      const C = $1.create(
        L[0],
        l[0]
      );
      return i !== null && i.set(t, e, C), C;
    }
    L = L.slice(0, o), l = l.slice(0, o);
  }
  const a = new n4(L, l);
  return a === t ? (i !== null && i.set(t, e, t), t) : a === e ? (i !== null && i.set(t, e, e), e) : (Nd(L), i !== null && i.set(t, e, a), a);
}
function Nd(t) {
  const e = new o5();
  for (let n = 0; n < t.length; n++) {
    const i = t[n];
    e.containsKey(i) || e.set(i, i);
  }
  for (let n = 0; n < t.length; n++)
    t[n] = e.get(t[n]);
}
function Dd(t, e, n, i) {
  if (i !== null) {
    let r = i.get(t, e);
    if (r !== null || (r = i.get(e, t), r !== null))
      return r;
  }
  const s = Pd(t, e, n);
  if (s !== null)
    return i !== null && i.set(t, e, s), s;
  if (t.returnState === e.returnState) {
    const r = je(t.parentCtx, e.parentCtx, n, i);
    if (r === t.parentCtx)
      return t;
    if (r === e.parentCtx)
      return e;
    const o = $1.create(r, t.returnState);
    return i !== null && i.set(t, e, o), o;
  } else {
    let r = null;
    if ((t === e || t.parentCtx !== null && t.parentCtx === e.parentCtx) && (r = t.parentCtx), r !== null) {
      const a = [t.returnState, e.returnState];
      t.returnState > e.returnState && (a[0] = e.returnState, a[1] = t.returnState);
      const C = [r, r], c = new n4(C, a);
      return i !== null && i.set(t, e, c), c;
    }
    const o = [t.returnState, e.returnState];
    let l = [t.parentCtx, e.parentCtx];
    t.returnState > e.returnState && (o[0] = e.returnState, o[1] = t.returnState, l = [e.parentCtx, t.parentCtx]);
    const L = new n4(l, o);
    return i !== null && i.set(t, e, L), L;
  }
}
function Pd(t, e, n) {
  if (n) {
    if (t === O2.EMPTY || e === O2.EMPTY)
      return O2.EMPTY;
  } else {
    if (t === O2.EMPTY && e === O2.EMPTY)
      return O2.EMPTY;
    if (t === O2.EMPTY) {
      const i = [
        e.returnState,
        O2.EMPTY_RETURN_STATE
      ], s = [e.parentCtx, null];
      return new n4(s, i);
    } else if (e === O2.EMPTY) {
      const i = [t.returnState, O2.EMPTY_RETURN_STATE], s = [t.parentCtx, null];
      return new n4(s, i);
    }
  }
  return null;
}
class K3 {
  constructor() {
    this.data = [];
  }
  add(e) {
    this.data[e] = !0;
  }
  or(e) {
    Object.keys(e.data).map((n) => this.add(n), this);
  }
  remove(e) {
    delete this.data[e];
  }
  has(e) {
    return this.data[e] === !0;
  }
  values() {
    return Object.keys(this.data);
  }
  minValue() {
    return Math.min.apply(null, this.values());
  }
  hashCode() {
    return v3.hashStuff(this.values());
  }
  equals(e) {
    return e instanceof K3 && V9(this.data, e.data);
  }
  toString() {
    return "{" + this.values().join(", ") + "}";
  }
  get length() {
    return this.values().length;
  }
}
class j9 {
  constructor(e) {
    this.atn = e;
  }
  /**
   * Calculates the SLL(1) expected lookahead set for each outgoing transition
   * of an {@link ATNState}. The returned array has one element for each
   * outgoing transition in {@code s}. If the closure from transition
   * <em>i</em> leads to a semantic predicate before matching a symbol, the
   * element at index <em>i</em> of the result will be {@code null}.
   *
   * @param s the ATN state
   * @return the expected symbols for each outgoing transition of {@code s}.
   */
  getDecisionLookahead(e) {
    if (e === null)
      return null;
    const n = e.transitions.length, i = [];
    for (let s = 0; s < n; s++) {
      i[s] = new S3();
      const r = new w3(), o = !1;
      this._LOOK(
        e.transition(s).target,
        null,
        O2.EMPTY,
        i[s],
        r,
        new K3(),
        o,
        !1
      ), (i[s].length === 0 || i[s].contains(j9.HIT_PRED)) && (i[s] = null);
    }
    return i;
  }
  /**
   * Compute set of tokens that can follow {@code s} in the ATN in the
   * specified {@code ctx}.
   *
   * <p>If {@code ctx} is {@code null} and the end of the rule containing
   * {@code s} is reached, {@link Token//EPSILON} is added to the result set.
   * If {@code ctx} is not {@code null} and the end of the outermost rule is
   * reached, {@link Token//EOF} is added to the result set.</p>
   *
   * @param s the ATN state
   * @param stopState the ATN state to stop at. This can be a
   * {@link BlockEndState} to detect epsilon paths through a closure.
   * @param ctx the complete parser context, or {@code null} if the context
   * should be ignored
   *
   * @return The set of tokens that can follow {@code s} in the ATN in the
   * specified {@code ctx}.
   */
  LOOK(e, n, i) {
    const s = new S3(), r = !0;
    i = i || null;
    const o = i !== null ? Ge(e.atn, i) : null;
    return this._LOOK(e, n, o, s, new w3(), new K3(), r, !0), s;
  }
  /**
   * Compute set of tokens that can follow {@code s} in the ATN in the
   * specified {@code ctx}.
   *
   * <p>If {@code ctx} is {@code null} and {@code stopState} or the end of the
   * rule containing {@code s} is reached, {@link Token//EPSILON} is added to
   * the result set. If {@code ctx} is not {@code null} and {@code addEOF} is
   * {@code true} and {@code stopState} or the end of the outermost rule is
   * reached, {@link Token//EOF} is added to the result set.</p>
   *
   * @param s the ATN state.
   * @param stopState the ATN state to stop at. This can be a
   * {@link BlockEndState} to detect epsilon paths through a closure.
   * @param ctx The outer context, or {@code null} if the outer context should
   * not be used.
   * @param look The result lookahead set.
   * @param lookBusy A set used for preventing epsilon closures in the ATN
   * from causing a stack overflow. Outside code should pass
   * {@code new CustomizedSet<ATNConfig>} for this argument.
   * @param calledRuleStack A set used for preventing left recursion in the
   * ATN from causing a stack overflow. Outside code should pass
   * {@code new BitSet()} for this argument.
   * @param seeThruPreds {@code true} to true semantic predicates as
   * implicitly {@code true} and "see through them", otherwise {@code false}
   * to treat semantic predicates as opaque and add {@link //HIT_PRED} to the
   * result if one is encountered.
   * @param addEOF Add {@link Token//EOF} to the result if the end of the
   * outermost context is reached. This parameter has no effect if {@code ctx}
   * is {@code null}.
   */
  _LOOK(e, n, i, s, r, o, l, L) {
    const a = new c1({ state: e, alt: 0, context: i }, null);
    if (!r.has(a)) {
      if (r.add(a), e === n) {
        if (i === null) {
          s.addOne(j.EPSILON);
          return;
        } else if (i.isEmpty() && L) {
          s.addOne(j.EOF);
          return;
        }
      }
      if (e instanceof H1) {
        if (i === null) {
          s.addOne(j.EPSILON);
          return;
        } else if (i.isEmpty() && L) {
          s.addOne(j.EOF);
          return;
        }
        if (i !== O2.EMPTY) {
          const C = o.has(e.ruleIndex);
          try {
            o.remove(e.ruleIndex);
            for (let c = 0; c < i.length; c++) {
              const h = this.atn.states[i.getReturnState(c)];
              this._LOOK(h, n, i.getParent(c), s, r, o, l, L);
            }
          } finally {
            C && o.add(e.ruleIndex);
          }
          return;
        }
      }
      for (let C = 0; C < e.transitions.length; C++) {
        const c = e.transitions[C];
        if (c.constructor === l8) {
          if (o.has(c.target.ruleIndex))
            continue;
          const h = $1.create(i, c.followState.stateNumber);
          try {
            o.add(c.target.ruleIndex), this._LOOK(c.target, n, h, s, r, o, l, L);
          } finally {
            o.remove(c.target.ruleIndex);
          }
        } else if (c instanceof Ve)
          l ? this._LOOK(c.target, n, i, s, r, o, l, L) : s.addOne(j9.HIT_PRED);
        else if (c.isEpsilon)
          this._LOOK(c.target, n, i, s, r, o, l, L);
        else if (c.constructor === tl)
          s.addRange(j.MIN_USER_TOKEN_TYPE, this.atn.maxTokenType);
        else {
          let h = c.label;
          h !== null && (c instanceof $e && (h = h.complement(j.MIN_USER_TOKEN_TYPE, this.atn.maxTokenType)), s.addSet(h));
        }
      }
    }
  }
}
j9.HIT_PRED = j.INVALID_TYPE;
class l1 {
  constructor(e, n) {
    this.grammarType = e, this.maxTokenType = n, this.states = [], this.decisionToState = [], this.ruleToStartState = [], this.ruleToStopState = null, this.modeNameToStartState = {}, this.ruleToTokenType = null, this.lexerActions = null, this.modeToStartState = [];
  }
  /**
   * Compute the set of valid tokens that can occur starting in state {@code s}.
   * If {@code ctx} is null, the set of tokens will not include what can follow
   * the rule surrounding {@code s}. In other words, the set will be
   * restricted to tokens reachable staying within {@code s}'s rule
   */
  nextTokensInContext(e, n) {
    return new j9(this).LOOK(e, null, n);
  }
  /**
   * Compute the set of valid tokens that can occur starting in {@code s} and
   * staying in same rule. {@link Token//EPSILON} is in set if we reach end of
   * rule
   */
  nextTokensNoContext(e) {
    return e.nextTokenWithinRule !== null || (e.nextTokenWithinRule = this.nextTokensInContext(e, null), e.nextTokenWithinRule.readOnly = !0), e.nextTokenWithinRule;
  }
  nextTokens(e, n) {
    return n === void 0 ? this.nextTokensNoContext(e) : this.nextTokensInContext(e, n);
  }
  addState(e) {
    e !== null && (e.atn = this, e.stateNumber = this.states.length), this.states.push(e);
  }
  removeState(e) {
    this.states[e.stateNumber] = null;
  }
  defineDecisionState(e) {
    return this.decisionToState.push(e), e.decision = this.decisionToState.length - 1, e.decision;
  }
  getDecisionState(e) {
    return this.decisionToState.length === 0 ? null : this.decisionToState[e];
  }
  /**
   * Computes the set of input symbols which could follow ATN state number
   * {@code stateNumber} in the specified full {@code context}. This method
   * considers the complete parser context, but does not evaluate semantic
   * predicates (i.e. all predicates encountered during the calculation are
   * assumed true). If a path in the ATN exists from the starting state to the
   * {@link RuleStopState} of the outermost context without matching any
   * symbols, {@link Token//EOF} is added to the returned set.
   *
   * <p>If {@code context} is {@code null}, it is treated as
   * {@link ParserRuleContext//EMPTY}.</p>
   *
   * @param stateNumber the ATN state number
   * @param ctx the full parse context
   *
   * @return {IntervalSet} The set of potentially valid input symbols which could follow the
   * specified state in the specified context.
   *
   * @throws IllegalArgumentException if the ATN does not contain a state with
   * number {@code stateNumber}
   */
  getExpectedTokens(e, n) {
    if (e < 0 || e >= this.states.length)
      throw "Invalid state number.";
    const i = this.states[e];
    let s = this.nextTokens(i);
    if (!s.contains(j.EPSILON))
      return s;
    const r = new S3();
    for (r.addSet(s), r.removeOne(j.EPSILON); n !== null && n.invokingState >= 0 && s.contains(j.EPSILON); ) {
      const l = this.states[n.invokingState].transitions[0];
      s = this.nextTokens(l.followState), r.addSet(s), r.removeOne(j.EPSILON), n = n.parentCtx;
    }
    return s.contains(j.EPSILON) && r.addOne(j.EOF), r;
  }
}
l1.INVALID_ALT_NUMBER = 0;
const O5 = {
  LEXER: 0,
  PARSER: 1
};
class mi extends c2 {
  constructor() {
    super(), this.stateType = c2.BASIC;
  }
}
class J9 extends c2 {
  constructor() {
    return super(), this.decision = -1, this.nonGreedy = !1, this;
  }
}
class D9 extends J9 {
  constructor() {
    return super(), this.endState = null, this;
  }
}
class O7 extends c2 {
  constructor() {
    return super(), this.stateType = c2.BLOCK_END, this.startState = null, this;
  }
}
class R9 extends c2 {
  constructor() {
    return super(), this.stateType = c2.LOOP_END, this.loopBackState = null, this;
  }
}
class wi extends c2 {
  constructor() {
    return super(), this.stateType = c2.RULE_START, this.stopState = null, this.isPrecedenceRule = !1, this;
  }
}
class Bd extends J9 {
  constructor() {
    return super(), this.stateType = c2.TOKEN_START, this;
  }
}
class xi extends J9 {
  constructor() {
    return super(), this.stateType = c2.PLUS_LOOP_BACK, this;
  }
}
class N7 extends c2 {
  constructor() {
    return super(), this.stateType = c2.STAR_LOOP_BACK, this;
  }
}
class q4 extends J9 {
  constructor() {
    return super(), this.stateType = c2.STAR_LOOP_ENTRY, this.loopBackState = null, this.isPrecedenceDecision = null, this;
  }
}
class D7 extends D9 {
  constructor() {
    return super(), this.stateType = c2.PLUS_BLOCK_START, this.loopBackState = null, this;
  }
}
class P7 extends D9 {
  constructor() {
    return super(), this.stateType = c2.STAR_BLOCK_START, this;
  }
}
class _i extends D9 {
  constructor() {
    return super(), this.stateType = c2.BLOCK_START, this;
  }
}
class K5 extends a2 {
  constructor(e, n) {
    super(e), this.label_ = n, this.label = this.makeLabel(), this.serializationType = a2.ATOM;
  }
  makeLabel() {
    const e = new S3();
    return e.addOne(this.label_), e;
  }
  matches(e, n, i) {
    return this.label_ === e;
  }
  toString() {
    return this.label_;
  }
}
class vi extends a2 {
  constructor(e, n, i) {
    super(e), this.serializationType = a2.RANGE, this.start = n, this.stop = i, this.label = this.makeLabel();
  }
  makeLabel() {
    const e = new S3();
    return e.addRange(this.start, this.stop), e;
  }
  matches(e, n, i) {
    return e >= this.start && e <= this.stop;
  }
  toString() {
    return "'" + String.fromCharCode(this.start) + "'..'" + String.fromCharCode(this.stop) + "'";
  }
}
class sl extends a2 {
  constructor(e, n, i, s) {
    super(e), this.serializationType = a2.ACTION, this.ruleIndex = n, this.actionIndex = i === void 0 ? -1 : i, this.isCtxDependent = s === void 0 ? !1 : s, this.isEpsilon = !0;
  }
  matches(e, n, i) {
    return !1;
  }
  toString() {
    return "action_" + this.ruleIndex + ":" + this.actionIndex;
  }
}
class a0 extends a2 {
  constructor(e, n) {
    super(e), this.serializationType = a2.EPSILON, this.isEpsilon = !0, this.outermostPrecedenceReturn = n;
  }
  matches(e, n, i) {
    return !1;
  }
  toString() {
    return "epsilon";
  }
}
class Y8 extends j2 {
  constructor(e, n, i) {
    super(), this.ruleIndex = e === void 0 ? -1 : e, this.predIndex = n === void 0 ? -1 : n, this.isCtxDependent = i === void 0 ? !1 : i;
  }
  evaluate(e, n) {
    const i = this.isCtxDependent ? n : null;
    return e.sempred(i, this.ruleIndex, this.predIndex);
  }
  updateHashCode(e) {
    e.update(this.ruleIndex, this.predIndex, this.isCtxDependent);
  }
  equals(e) {
    return this === e ? !0 : e instanceof Y8 ? this.ruleIndex === e.ruleIndex && this.predIndex === e.predIndex && this.isCtxDependent === e.isCtxDependent : !1;
  }
  toString() {
    return "{" + this.ruleIndex + ":" + this.predIndex + "}?";
  }
}
j2.NONE = new Y8();
class rl extends Ve {
  constructor(e, n, i, s) {
    super(e), this.serializationType = a2.PREDICATE, this.ruleIndex = n, this.predIndex = i, this.isCtxDependent = s, this.isEpsilon = !0;
  }
  matches(e, n, i) {
    return !1;
  }
  getPredicate() {
    return new Y8(this.ruleIndex, this.predIndex, this.isCtxDependent);
  }
  toString() {
    return "pred_" + this.ruleIndex + ":" + this.predIndex;
  }
}
class Q8 extends j2 {
  constructor(e) {
    super(), this.precedence = e === void 0 ? 0 : e;
  }
  evaluate(e, n) {
    return e.precpred(n, this.precedence);
  }
  evalPrecedence(e, n) {
    return e.precpred(n, this.precedence) ? j2.NONE : null;
  }
  compareTo(e) {
    return this.precedence - e.precedence;
  }
  updateHashCode(e) {
    e.update(this.precedence);
  }
  equals(e) {
    return this === e ? !0 : e instanceof Q8 ? this.precedence === e.precedence : !1;
  }
  toString() {
    return "{" + this.precedence + ">=prec}?";
  }
}
j2.PrecedencePredicate = Q8;
class zd extends Ve {
  constructor(e, n) {
    super(e), this.serializationType = a2.PRECEDENCE, this.precedence = n, this.isEpsilon = !0;
  }
  matches(e, n, i) {
    return !1;
  }
  getPredicate() {
    return new Q8(this.precedence);
  }
  toString() {
    return this.precedence + " >= _p";
  }
}
class $0 {
  constructor(e) {
    e === void 0 && (e = null), this.readOnly = !1, this.verifyATN = e === null ? !0 : e.verifyATN, this.generateRuleBypassTransitions = e === null ? !1 : e.generateRuleBypassTransitions;
  }
}
$0.defaultOptions = new $0();
$0.defaultOptions.readOnly = !0;
const I1 = {
  // The type of a {@link LexerChannelAction} action.
  CHANNEL: 0,
  // The type of a {@link LexerCustomAction} action
  CUSTOM: 1,
  // The type of a {@link LexerModeAction} action.
  MODE: 2,
  //The type of a {@link LexerMoreAction} action.
  MORE: 3,
  //The type of a {@link LexerPopModeAction} action.
  POP_MODE: 4,
  //The type of a {@link LexerPushModeAction} action.
  PUSH_MODE: 5,
  //The type of a {@link LexerSkipAction} action.
  SKIP: 6,
  //The type of a {@link LexerTypeAction} action.
  TYPE: 7
};
class _4 {
  constructor(e) {
    this.actionType = e, this.isPositionDependent = !1;
  }
  hashCode() {
    const e = new v3();
    return this.updateHashCode(e), e.finish();
  }
  updateHashCode(e) {
    e.update(this.actionType);
  }
  equals(e) {
    return this === e;
  }
}
class T6 extends _4 {
  constructor() {
    super(I1.SKIP);
  }
  execute(e) {
    e.skip();
  }
  toString() {
    return "skip";
  }
}
T6.INSTANCE = new T6();
class qe extends _4 {
  constructor(e) {
    super(I1.CHANNEL), this.channel = e;
  }
  /**
   * <p>This action is implemented by calling {@link Lexer//setChannel} with the
   * value provided by {@link //getChannel}.</p>
   */
  execute(e) {
    e._channel = this.channel;
  }
  updateHashCode(e) {
    e.update(this.actionType, this.channel);
  }
  equals(e) {
    return this === e ? !0 : e instanceof qe ? this.channel === e.channel : !1;
  }
  toString() {
    return "channel(" + this.channel + ")";
  }
}
class Ke extends _4 {
  /**
   * Constructs a custom lexer action with the specified rule and action
   * indexes.
   *
   * @param ruleIndex The rule index to use for calls to
   * {@link Recognizer//action}.
   * @param actionIndex The action index to use for calls to
   * {@link Recognizer//action}.
   */
  constructor(e, n) {
    super(I1.CUSTOM), this.ruleIndex = e, this.actionIndex = n, this.isPositionDependent = !0;
  }
  /**
   * <p>Custom actions are implemented by calling {@link Lexer//action} with the
   * appropriate rule and action indexes.</p>
   */
  execute(e) {
    e.action(null, this.ruleIndex, this.actionIndex);
  }
  updateHashCode(e) {
    e.update(this.actionType, this.ruleIndex, this.actionIndex);
  }
  equals(e) {
    return this === e ? !0 : e instanceof Ke ? this.ruleIndex === e.ruleIndex && this.actionIndex === e.actionIndex : !1;
  }
}
class S6 extends _4 {
  constructor() {
    super(I1.MORE);
  }
  /**
   * <p>This action is implemented by calling {@link Lexer//popMode}.</p>
   */
  execute(e) {
    e.more();
  }
  toString() {
    return "more";
  }
}
S6.INSTANCE = new S6();
class Ye extends _4 {
  constructor(e) {
    super(I1.TYPE), this.type = e;
  }
  execute(e) {
    e.type = this.type;
  }
  updateHashCode(e) {
    e.update(this.actionType, this.type);
  }
  equals(e) {
    return this === e ? !0 : e instanceof Ye ? this.type === e.type : !1;
  }
  toString() {
    return "type(" + this.type + ")";
  }
}
class Qe extends _4 {
  constructor(e) {
    super(I1.PUSH_MODE), this.mode = e;
  }
  /**
   * <p>This action is implemented by calling {@link Lexer//pushMode} with the
   * value provided by {@link //getMode}.</p>
   */
  execute(e) {
    e.pushMode(this.mode);
  }
  updateHashCode(e) {
    e.update(this.actionType, this.mode);
  }
  equals(e) {
    return this === e ? !0 : e instanceof Qe ? this.mode === e.mode : !1;
  }
  toString() {
    return "pushMode(" + this.mode + ")";
  }
}
class b6 extends _4 {
  constructor() {
    super(I1.POP_MODE);
  }
  /**
   * <p>This action is implemented by calling {@link Lexer//popMode}.</p>
   */
  execute(e) {
    e.popMode();
  }
  toString() {
    return "popMode";
  }
}
b6.INSTANCE = new b6();
class Xe extends _4 {
  constructor(e) {
    super(I1.MODE), this.mode = e;
  }
  /**
   * <p>This action is implemented by calling {@link Lexer//mode} with the
   * value provided by {@link //getMode}.</p>
   */
  execute(e) {
    e.mode(this.mode);
  }
  updateHashCode(e) {
    e.update(this.actionType, this.mode);
  }
  equals(e) {
    return this === e ? !0 : e instanceof Xe ? this.mode === e.mode : !1;
  }
  toString() {
    return "mode(" + this.mode + ")";
  }
}
const B7 = 4;
function N5(t, e) {
  const n = [];
  return n[t - 1] = e, n.map(function(i) {
    return e;
  });
}
class ol {
  constructor(e) {
    e == null && (e = $0.defaultOptions), this.deserializationOptions = e, this.stateFactories = null, this.actionFactories = null;
  }
  deserialize(e) {
    const n = this.reset(e);
    this.checkVersion(n), n && this.skipUUID();
    const i = this.readATN();
    this.readStates(i, n), this.readRules(i, n), this.readModes(i);
    const s = [];
    return this.readSets(i, s, this.readInt.bind(this)), n && this.readSets(i, s, this.readInt32.bind(this)), this.readEdges(i, s), this.readDecisions(i), this.readLexerActions(i, n), this.markPrecedenceDecisions(i), this.verifyATN(i), this.deserializationOptions.generateRuleBypassTransitions && i.grammarType === O5.PARSER && (this.generateRuleBypassTransitions(i), this.verifyATN(i)), i;
  }
  reset(e) {
    if ((e.charCodeAt ? e.charCodeAt(0) : e[0]) === B7 - 1) {
      const i = function(r) {
        const o = r.charCodeAt(0);
        return o > 1 ? o - 2 : o + 65534;
      }, s = e.split("").map(i);
      return s[0] = e.charCodeAt(0), this.data = s, this.pos = 0, !0;
    } else
      return this.data = e, this.pos = 0, !1;
  }
  skipUUID() {
    let e = 0;
    for (; e++ < 8; )
      this.readInt();
  }
  checkVersion(e) {
    const n = this.readInt();
    if (!e && n !== B7)
      throw "Could not deserialize ATN with version " + n + " (expected " + B7 + ").";
  }
  readATN() {
    const e = this.readInt(), n = this.readInt();
    return new l1(e, n);
  }
  readStates(e, n) {
    let i, s, r;
    const o = [], l = [], L = this.readInt();
    for (let c = 0; c < L; c++) {
      const h = this.readInt();
      if (h === c2.INVALID_TYPE) {
        e.addState(null);
        continue;
      }
      let d = this.readInt();
      n && d === 65535 && (d = -1);
      const f = this.stateFactory(h, d);
      if (h === c2.LOOP_END) {
        const x = this.readInt();
        o.push([f, x]);
      } else if (f instanceof D9) {
        const x = this.readInt();
        l.push([f, x]);
      }
      e.addState(f);
    }
    for (i = 0; i < o.length; i++)
      s = o[i], s[0].loopBackState = e.states[s[1]];
    for (i = 0; i < l.length; i++)
      s = l[i], s[0].endState = e.states[s[1]];
    let a = this.readInt();
    for (i = 0; i < a; i++)
      r = this.readInt(), e.states[r].nonGreedy = !0;
    let C = this.readInt();
    for (i = 0; i < C; i++)
      r = this.readInt(), e.states[r].isPrecedenceRule = !0;
  }
  readRules(e, n) {
    let i;
    const s = this.readInt();
    for (e.grammarType === O5.LEXER && (e.ruleToTokenType = N5(s, 0)), e.ruleToStartState = N5(s, 0), i = 0; i < s; i++) {
      const r = this.readInt();
      if (e.ruleToStartState[i] = e.states[r], e.grammarType === O5.LEXER) {
        let o = this.readInt();
        n && o === 65535 && (o = j.EOF), e.ruleToTokenType[i] = o;
      }
    }
    for (e.ruleToStopState = N5(s, 0), i = 0; i < e.states.length; i++) {
      const r = e.states[i];
      r instanceof H1 && (e.ruleToStopState[r.ruleIndex] = r, e.ruleToStartState[r.ruleIndex].stopState = r);
    }
  }
  readModes(e) {
    const n = this.readInt();
    for (let i = 0; i < n; i++) {
      let s = this.readInt();
      e.modeToStartState.push(e.states[s]);
    }
  }
  readSets(e, n, i) {
    const s = this.readInt();
    for (let r = 0; r < s; r++) {
      const o = new S3();
      n.push(o);
      const l = this.readInt();
      this.readInt() !== 0 && o.addOne(-1);
      for (let a = 0; a < l; a++) {
        const C = i(), c = i();
        o.addRange(C, c);
      }
    }
  }
  readEdges(e, n) {
    let i, s, r, o, l;
    const L = this.readInt();
    for (i = 0; i < L; i++) {
      const a = this.readInt(), C = this.readInt(), c = this.readInt(), h = this.readInt(), d = this.readInt(), f = this.readInt();
      o = this.edgeFactory(e, c, a, C, h, d, f, n), e.states[a].addTransition(o);
    }
    for (i = 0; i < e.states.length; i++)
      for (r = e.states[i], s = 0; s < r.transitions.length; s++) {
        const a = r.transitions[s];
        if (!(a instanceof l8))
          continue;
        let C = -1;
        e.ruleToStartState[a.target.ruleIndex].isPrecedenceRule && a.precedence === 0 && (C = a.target.ruleIndex), o = new a0(a.followState, C), e.ruleToStopState[a.target.ruleIndex].addTransition(o);
      }
    for (i = 0; i < e.states.length; i++) {
      if (r = e.states[i], r instanceof D9) {
        if (r.endState === null || r.endState.startState !== null)
          throw "IllegalState";
        r.endState.startState = r;
      }
      if (r instanceof xi)
        for (s = 0; s < r.transitions.length; s++)
          l = r.transitions[s].target, l instanceof D7 && (l.loopBackState = r);
      else if (r instanceof N7)
        for (s = 0; s < r.transitions.length; s++)
          l = r.transitions[s].target, l instanceof q4 && (l.loopBackState = r);
    }
  }
  readDecisions(e) {
    const n = this.readInt();
    for (let i = 0; i < n; i++) {
      const s = this.readInt(), r = e.states[s];
      e.decisionToState.push(r), r.decision = i;
    }
  }
  readLexerActions(e, n) {
    if (e.grammarType === O5.LEXER) {
      const i = this.readInt();
      e.lexerActions = N5(i, null);
      for (let s = 0; s < i; s++) {
        const r = this.readInt();
        let o = this.readInt();
        n && o === 65535 && (o = -1);
        let l = this.readInt();
        n && l === 65535 && (l = -1), e.lexerActions[s] = this.lexerActionFactory(r, o, l);
      }
    }
  }
  generateRuleBypassTransitions(e) {
    let n;
    const i = e.ruleToStartState.length;
    for (n = 0; n < i; n++)
      e.ruleToTokenType[n] = e.maxTokenType + n + 1;
    for (n = 0; n < i; n++)
      this.generateRuleBypassTransition(e, n);
  }
  generateRuleBypassTransition(e, n) {
    let i, s;
    const r = new _i();
    r.ruleIndex = n, e.addState(r);
    const o = new O7();
    o.ruleIndex = n, e.addState(o), r.endState = o, e.defineDecisionState(r), o.startState = r;
    let l = null, L = null;
    if (e.ruleToStartState[n].isPrecedenceRule) {
      for (L = null, i = 0; i < e.states.length; i++)
        if (s = e.states[i], this.stateIsEndStateFor(s, n)) {
          L = s, l = s.loopBackState.transitions[0];
          break;
        }
      if (l === null)
        throw "Couldn't identify final state of the precedence rule prefix section.";
    } else
      L = e.ruleToStopState[n];
    for (i = 0; i < e.states.length; i++) {
      s = e.states[i];
      for (let h = 0; h < s.transitions.length; h++) {
        const d = s.transitions[h];
        d !== l && d.target === L && (d.target = o);
      }
    }
    const a = e.ruleToStartState[n], C = a.transitions.length;
    for (; C > 0; )
      r.addTransition(a.transitions[C - 1]), a.transitions = a.transitions.slice(-1);
    e.ruleToStartState[n].addTransition(new a0(r)), o.addTransition(new a0(L));
    const c = new mi();
    e.addState(c), c.addTransition(new K5(o, e.ruleToTokenType[n])), r.addTransition(new a0(c));
  }
  stateIsEndStateFor(e, n) {
    if (e.ruleIndex !== n || !(e instanceof q4))
      return null;
    const i = e.transitions[e.transitions.length - 1].target;
    return i instanceof R9 && i.epsilonOnlyTransitions && i.transitions[0].target instanceof H1 ? e : null;
  }
  /**
   * Analyze the {@link StarLoopEntryState} states in the specified ATN to set
   * the {@link StarLoopEntryState//isPrecedenceDecision} field to the
   * correct value.
   * @param atn The ATN.
   */
  markPrecedenceDecisions(e) {
    for (let n = 0; n < e.states.length; n++) {
      const i = e.states[n];
      if (i instanceof q4 && e.ruleToStartState[i.ruleIndex].isPrecedenceRule) {
        const s = i.transitions[i.transitions.length - 1].target;
        s instanceof R9 && s.epsilonOnlyTransitions && s.transitions[0].target instanceof H1 && (i.isPrecedenceDecision = !0);
      }
    }
  }
  verifyATN(e) {
    if (this.deserializationOptions.verifyATN)
      for (let n = 0; n < e.states.length; n++) {
        const i = e.states[n];
        if (i !== null)
          if (this.checkCondition(i.epsilonOnlyTransitions || i.transitions.length <= 1), i instanceof D7)
            this.checkCondition(i.loopBackState !== null);
          else if (i instanceof q4)
            if (this.checkCondition(i.loopBackState !== null), this.checkCondition(i.transitions.length === 2), i.transitions[0].target instanceof P7)
              this.checkCondition(i.transitions[1].target instanceof R9), this.checkCondition(!i.nonGreedy);
            else if (i.transitions[0].target instanceof R9)
              this.checkCondition(i.transitions[1].target instanceof P7), this.checkCondition(i.nonGreedy);
            else
              throw "IllegalState";
          else
            i instanceof N7 ? (this.checkCondition(i.transitions.length === 1), this.checkCondition(i.transitions[0].target instanceof q4)) : i instanceof R9 ? this.checkCondition(i.loopBackState !== null) : i instanceof wi ? this.checkCondition(i.stopState !== null) : i instanceof D9 ? this.checkCondition(i.endState !== null) : i instanceof O7 ? this.checkCondition(i.startState !== null) : i instanceof J9 ? this.checkCondition(i.transitions.length <= 1 || i.decision >= 0) : this.checkCondition(i.transitions.length <= 1 || i instanceof H1);
      }
  }
  checkCondition(e, n) {
    if (!e)
      throw n == null && (n = "IllegalState"), n;
  }
  readInt() {
    return this.data[this.pos++];
  }
  readInt32() {
    const e = this.readInt(), n = this.readInt();
    return e | n << 16;
  }
  edgeFactory(e, n, i, s, r, o, l, L) {
    const a = e.states[s];
    switch (n) {
      case a2.EPSILON:
        return new a0(a);
      case a2.RANGE:
        return l !== 0 ? new vi(a, j.EOF, o) : new vi(a, r, o);
      case a2.RULE:
        return new l8(e.states[r], o, l, a);
      case a2.PREDICATE:
        return new rl(a, r, o, l !== 0);
      case a2.PRECEDENCE:
        return new zd(a, r);
      case a2.ATOM:
        return l !== 0 ? new K5(a, j.EOF) : new K5(a, r);
      case a2.ACTION:
        return new sl(a, r, o, l !== 0);
      case a2.SET:
        return new He(a, L[r]);
      case a2.NOT_SET:
        return new $e(a, L[r]);
      case a2.WILDCARD:
        return new tl(a);
      default:
        throw "The specified transition type: " + n + " is not valid.";
    }
  }
  stateFactory(e, n) {
    if (this.stateFactories === null) {
      const i = [];
      i[c2.INVALID_TYPE] = null, i[c2.BASIC] = () => new mi(), i[c2.RULE_START] = () => new wi(), i[c2.BLOCK_START] = () => new _i(), i[c2.PLUS_BLOCK_START] = () => new D7(), i[c2.STAR_BLOCK_START] = () => new P7(), i[c2.TOKEN_START] = () => new Bd(), i[c2.RULE_STOP] = () => new H1(), i[c2.BLOCK_END] = () => new O7(), i[c2.STAR_LOOP_BACK] = () => new N7(), i[c2.STAR_LOOP_ENTRY] = () => new q4(), i[c2.PLUS_LOOP_BACK] = () => new xi(), i[c2.LOOP_END] = () => new R9(), this.stateFactories = i;
    }
    if (e > this.stateFactories.length || this.stateFactories[e] === null)
      throw "The specified state type " + e + " is not valid.";
    {
      const i = this.stateFactories[e]();
      if (i !== null)
        return i.ruleIndex = n, i;
    }
  }
  lexerActionFactory(e, n, i) {
    if (this.actionFactories === null) {
      const s = [];
      s[I1.CHANNEL] = (r, o) => new qe(r), s[I1.CUSTOM] = (r, o) => new Ke(r, o), s[I1.MODE] = (r, o) => new Xe(r), s[I1.MORE] = (r, o) => S6.INSTANCE, s[I1.POP_MODE] = (r, o) => b6.INSTANCE, s[I1.PUSH_MODE] = (r, o) => new Qe(r), s[I1.SKIP] = (r, o) => T6.INSTANCE, s[I1.TYPE] = (r, o) => new Ye(r), this.actionFactories = s;
    }
    if (e > this.actionFactories.length || this.actionFactories[e] === null)
      throw "The specified lexer action type " + e + " is not valid.";
    return this.actionFactories[e](n, i);
  }
}
class X8 {
  syntaxError(e, n, i, s, r, o) {
  }
  reportAmbiguity(e, n, i, s, r, o, l) {
  }
  reportAttemptingFullContext(e, n, i, s, r, o) {
  }
  reportContextSensitivity(e, n, i, s, r, o) {
  }
}
class E6 extends X8 {
  constructor() {
    super();
  }
  syntaxError(e, n, i, s, r, o) {
    console.error("line " + i + ":" + s + " " + r);
  }
}
E6.INSTANCE = new E6();
class Ud extends X8 {
  constructor(e) {
    if (super(), e === null)
      throw "delegates";
    return this.delegates = e, this;
  }
  syntaxError(e, n, i, s, r, o) {
    this.delegates.map((l) => l.syntaxError(e, n, i, s, r, o));
  }
  reportAmbiguity(e, n, i, s, r, o, l) {
    this.delegates.map((L) => L.reportAmbiguity(e, n, i, s, r, o, l));
  }
  reportAttemptingFullContext(e, n, i, s, r, o) {
    this.delegates.map((l) => l.reportAttemptingFullContext(e, n, i, s, r, o));
  }
  reportContextSensitivity(e, n, i, s, r, o) {
    this.delegates.map((l) => l.reportContextSensitivity(e, n, i, s, r, o));
  }
}
class J8 {
  constructor() {
    this._listeners = [E6.INSTANCE], this._interp = null, this._stateNumber = -1;
  }
  checkVersion(e) {
    const n = "4.11.0";
    n !== e && console.log("ANTLR runtime and generated code versions disagree: " + n + "!=" + e);
  }
  addErrorListener(e) {
    this._listeners.push(e);
  }
  removeErrorListeners() {
    this._listeners = [];
  }
  getLiteralNames() {
    return Object.getPrototypeOf(this).constructor.literalNames || [];
  }
  getSymbolicNames() {
    return Object.getPrototypeOf(this).constructor.symbolicNames || [];
  }
  getTokenNames() {
    if (!this.tokenNames) {
      const e = this.getLiteralNames(), n = this.getSymbolicNames(), i = e.length > n.length ? e.length : n.length;
      this.tokenNames = [];
      for (let s = 0; s < i; s++)
        this.tokenNames[s] = e[s] || n[s] || "<INVALID";
    }
    return this.tokenNames;
  }
  getTokenTypeMap() {
    const e = this.getTokenNames();
    if (e === null)
      throw "The current recognizer does not provide a list of token names.";
    let n = this.tokenTypeMapCache[e];
    return n === void 0 && (n = e.reduce(function(i, s, r) {
      i[s] = r;
    }), n.EOF = j.EOF, this.tokenTypeMapCache[e] = n), n;
  }
  /**
   * Get a map from rule names to rule indexes.
   * <p>Used for XPath and tree pattern compilation.</p>
   */
  getRuleIndexMap() {
    const e = this.ruleNames;
    if (e === null)
      throw "The current recognizer does not provide a list of rule names.";
    let n = this.ruleIndexMapCache[e];
    return n === void 0 && (n = e.reduce(function(i, s, r) {
      i[s] = r;
    }), this.ruleIndexMapCache[e] = n), n;
  }
  getTokenType(e) {
    const n = this.getTokenTypeMap()[e];
    return n !== void 0 ? n : j.INVALID_TYPE;
  }
  // What is the error header, normally line/character position information?
  getErrorHeader(e) {
    const n = e.getOffendingToken().line, i = e.getOffendingToken().column;
    return "line " + n + ":" + i;
  }
  /**
   * How should a token be displayed in an error message? The default
   * is to display just the text, but during development you might
   * want to have a lot of information spit out.  Override in that case
   * to use t.toString() (which, for CommonToken, dumps everything about
   * the token). This is better than forcing you to override a method in
   * your token objects because you don't have to go modify your lexer
   * so that it creates a new Java type.
   *
   * @deprecated This method is not called by the ANTLR 4 Runtime. Specific
   * implementations of {@link ANTLRErrorStrategy} may provide a similar
   * feature when necessary. For example, see
   * {@link DefaultErrorStrategy//getTokenErrorDisplay}.*/
  getTokenErrorDisplay(e) {
    if (e === null)
      return "<no token>";
    let n = e.text;
    return n === null && (e.type === j.EOF ? n = "<EOF>" : n = "<" + e.type + ">"), n = n.replace(`
`, "\\n").replace("\r", "\\r").replace("	", "\\t"), "'" + n + "'";
  }
  getErrorListenerDispatch() {
    return new Ud(this._listeners);
  }
  /**
   * subclass needs to override these if there are sempreds or actions
   * that the ATN interp needs to execute
   */
  sempred(e, n, i) {
    return !0;
  }
  precpred(e, n) {
    return !0;
  }
  get state() {
    return this._stateNumber;
  }
  set state(e) {
    this._stateNumber = e;
  }
}
J8.tokenTypeMapCache = {};
J8.ruleIndexMapCache = {};
class h9 extends j {
  constructor(e, n, i, s, r) {
    super(), this.source = e !== void 0 ? e : h9.EMPTY_SOURCE, this.type = n !== void 0 ? n : null, this.channel = i !== void 0 ? i : j.DEFAULT_CHANNEL, this.start = s !== void 0 ? s : -1, this.stop = r !== void 0 ? r : -1, this.tokenIndex = -1, this.source[0] !== null ? (this.line = e[0].line, this.column = e[0].column) : this.column = -1;
  }
  /**
   * Constructs a new {@link CommonToken} as a copy of another {@link Token}.
   *
   * <p>
   * If {@code oldToken} is also a {@link CommonToken} instance, the newly
   * constructed token will share a reference to the {@link //text} field and
   * the {@link Pair} stored in {@link //source}. Otherwise, {@link //text} will
   * be assigned the result of calling {@link //getText}, and {@link //source}
   * will be constructed from the result of {@link Token//getTokenSource} and
   * {@link Token//getInputStream}.</p>
   *
   * @param oldToken The token to copy.
   */
  clone() {
    const e = new h9(this.source, this.type, this.channel, this.start, this.stop);
    return e.tokenIndex = this.tokenIndex, e.line = this.line, e.column = this.column, e.text = this.text, e;
  }
  toString() {
    let e = this.text;
    return e !== null ? e = e.replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/\t/g, "\\t") : e = "<no text>", "[@" + this.tokenIndex + "," + this.start + ":" + this.stop + "='" + e + "',<" + this.type + ">" + (this.channel > 0 ? ",channel=" + this.channel : "") + "," + this.line + ":" + this.column + "]";
  }
  get text() {
    if (this._text !== null)
      return this._text;
    const e = this.getInputStream();
    if (e === null)
      return null;
    const n = e.size;
    return this.start < n && this.stop < n ? e.getText(this.start, this.stop) : "<EOF>";
  }
  set text(e) {
    this._text = e;
  }
}
h9.EMPTY_SOURCE = [null, null];
class Wd {
}
class I6 extends Wd {
  constructor(e) {
    super(), this.copyText = e === void 0 ? !1 : e;
  }
  create(e, n, i, s, r, o, l, L) {
    const a = new h9(e, n, s, r, o);
    return a.line = l, a.column = L, i !== null ? a.text = i : this.copyText && e[1] !== null && (a.text = e[1].getText(r, o)), a;
  }
  createThin(e, n) {
    const i = new h9(null, e);
    return i.text = n, i;
  }
}
I6.DEFAULT = new I6();
class H4 extends Error {
  constructor(e) {
    super(e.message), Error.captureStackTrace && Error.captureStackTrace(this, H4), this.message = e.message, this.recognizer = e.recognizer, this.input = e.input, this.ctx = e.ctx, this.offendingToken = null, this.offendingState = -1, this.recognizer !== null && (this.offendingState = this.recognizer.state);
  }
  /**
   * Gets the set of input symbols which could potentially follow the
   * previously matched symbol at the time this exception was thrown.
   *
   * <p>If the set of expected tokens is not known and could not be computed,
   * this method returns {@code null}.</p>
   *
   * @return The set of token types that could potentially follow the current
   * state in the ATN, or {@code null} if the information is not available.
   */
  getExpectedTokens() {
    return this.recognizer !== null ? this.recognizer.atn.getExpectedTokens(this.offendingState, this.ctx) : null;
  }
  // <p>If the state number is not known, this method returns -1.</p>
  toString() {
    return this.message;
  }
}
class Je extends H4 {
  constructor(e, n, i, s) {
    super({ message: "", recognizer: e, input: n, ctx: null }), this.startIndex = i, this.deadEndConfigs = s;
  }
  toString() {
    let e = "";
    return this.startIndex >= 0 && this.startIndex < this.input.size && (e = this.input.getText(new G2(this.startIndex, this.startIndex))), "LexerNoViableAltException" + e;
  }
}
let V1 = class y4 extends J8 {
  constructor(e) {
    super(), this._input = e, this._factory = I6.DEFAULT, this._tokenFactorySourcePair = [this, e], this._interp = null, this._token = null, this._tokenStartCharIndex = -1, this._tokenStartLine = -1, this._tokenStartColumn = -1, this._hitEOF = !1, this._channel = j.DEFAULT_CHANNEL, this._type = j.INVALID_TYPE, this._modeStack = [], this._mode = y4.DEFAULT_MODE, this._text = null;
  }
  reset() {
    this._input !== null && this._input.seek(0), this._token = null, this._type = j.INVALID_TYPE, this._channel = j.DEFAULT_CHANNEL, this._tokenStartCharIndex = -1, this._tokenStartColumn = -1, this._tokenStartLine = -1, this._text = null, this._hitEOF = !1, this._mode = y4.DEFAULT_MODE, this._modeStack = [], this._interp.reset();
  }
  // Return a token from this source; i.e., match a token on the char stream.
  nextToken() {
    if (this._input === null)
      throw "nextToken requires a non-null input stream.";
    const e = this._input.mark();
    try {
      for (; ; ) {
        if (this._hitEOF)
          return this.emitEOF(), this._token;
        this._token = null, this._channel = j.DEFAULT_CHANNEL, this._tokenStartCharIndex = this._input.index, this._tokenStartColumn = this._interp.column, this._tokenStartLine = this._interp.line, this._text = null;
        let n = !1;
        for (; ; ) {
          this._type = j.INVALID_TYPE;
          let i = y4.SKIP;
          try {
            i = this._interp.match(this._input, this._mode);
          } catch (s) {
            if (s instanceof H4)
              this.notifyListeners(s), this.recover(s);
            else
              throw console.log(s.stack), s;
          }
          if (this._input.LA(1) === j.EOF && (this._hitEOF = !0), this._type === j.INVALID_TYPE && (this._type = i), this._type === y4.SKIP) {
            n = !0;
            break;
          }
          if (this._type !== y4.MORE)
            break;
        }
        if (!n)
          return this._token === null && this.emit(), this._token;
      }
    } finally {
      this._input.release(e);
    }
  }
  /**
   * Instruct the lexer to skip creating a token for current lexer rule
   * and look for another token. nextToken() knows to keep looking when
   * a lexer rule finishes with token set to SKIP_TOKEN. Recall that
   * if token==null at end of any token rule, it creates one for you
   * and emits it.
   */
  skip() {
    this._type = y4.SKIP;
  }
  more() {
    this._type = y4.MORE;
  }
  mode(e) {
    this._mode = e;
  }
  pushMode(e) {
    this._interp.debug && console.log("pushMode " + e), this._modeStack.push(this._mode), this.mode(e);
  }
  popMode() {
    if (this._modeStack.length === 0)
      throw "Empty Stack";
    return this._interp.debug && console.log("popMode back to " + this._modeStack.slice(0, -1)), this.mode(this._modeStack.pop()), this._mode;
  }
  /**
   * By default does not support multiple emits per nextToken invocation
   * for efficiency reasons. Subclass and override this method, nextToken,
   * and getToken (to push tokens into a list and pull from that list
   * rather than a single variable as this implementation does).
   */
  emitToken(e) {
    this._token = e;
  }
  /**
   * The standard method called to automatically emit a token at the
   * outermost lexical rule. The token object should point into the
   * char buffer start..stop. If there is a text override in 'text',
   * use that to set the token's text. Override this method to emit
   * custom Token objects or provide a new factory.
   */
  emit() {
    const e = this._factory.create(
      this._tokenFactorySourcePair,
      this._type,
      this._text,
      this._channel,
      this._tokenStartCharIndex,
      this.getCharIndex() - 1,
      this._tokenStartLine,
      this._tokenStartColumn
    );
    return this.emitToken(e), e;
  }
  emitEOF() {
    const e = this.column, n = this.line, i = this._factory.create(
      this._tokenFactorySourcePair,
      j.EOF,
      null,
      j.DEFAULT_CHANNEL,
      this._input.index,
      this._input.index - 1,
      n,
      e
    );
    return this.emitToken(i), i;
  }
  // What is the index of the current character of lookahead?///
  getCharIndex() {
    return this._input.index;
  }
  /**
   * Return a list of all Token objects in input char stream.
   * Forces load of all tokens. Does not include EOF token.
   */
  getAllTokens() {
    const e = [];
    let n = this.nextToken();
    for (; n.type !== j.EOF; )
      e.push(n), n = this.nextToken();
    return e;
  }
  notifyListeners(e) {
    const n = this._tokenStartCharIndex, i = this._input.index, s = this._input.getText(n, i), r = "token recognition error at: '" + this.getErrorDisplay(s) + "'";
    this.getErrorListenerDispatch().syntaxError(
      this,
      null,
      this._tokenStartLine,
      this._tokenStartColumn,
      r,
      e
    );
  }
  getErrorDisplay(e) {
    const n = [];
    for (let i = 0; i < e.length; i++)
      n.push(e[i]);
    return n.join("");
  }
  getErrorDisplayForChar(e) {
    return e.charCodeAt(0) === j.EOF ? "<EOF>" : e === `
` ? "\\n" : e === "	" ? "\\t" : e === "\r" ? "\\r" : e;
  }
  getCharErrorDisplay(e) {
    return "'" + this.getErrorDisplayForChar(e) + "'";
  }
  /**
   * Lexers can normally match any char in it's vocabulary after matching
   * a token, so do the easy thing and just kill a character and hope
   * it all works out. You can instead use the rule invocation stack
   * to do sophisticated error recovery if you are in a fragment rule.
   */
  recover(e) {
    this._input.LA(1) !== j.EOF && (e instanceof Je ? this._interp.consume(this._input) : this._input.consume());
  }
  get inputStream() {
    return this._input;
  }
  set inputStream(e) {
    this._input = null, this._tokenFactorySourcePair = [this, this._input], this.reset(), this._input = e, this._tokenFactorySourcePair = [this, this._input];
  }
  get sourceName() {
    return this._input.sourceName;
  }
  get type() {
    return this._type;
  }
  set type(e) {
    this._type = e;
  }
  get line() {
    return this._interp.line;
  }
  set line(e) {
    this._interp.line = e;
  }
  get column() {
    return this._interp.column;
  }
  set column(e) {
    this._interp.column = e;
  }
  get text() {
    return this._text !== null ? this._text : this._interp.getText(this._input);
  }
  set text(e) {
    this._text = e;
  }
};
V1.DEFAULT_MODE = 0;
V1.MORE = -2;
V1.SKIP = -3;
V1.DEFAULT_TOKEN_CHANNEL = j.DEFAULT_CHANNEL;
V1.HIDDEN = j.HIDDEN_CHANNEL;
V1.MIN_CHAR_VALUE = 0;
V1.MAX_CHAR_VALUE = 1114111;
function Hd(t) {
  return t.hashCodeForConfigSet();
}
function $d(t, e) {
  return t === e ? !0 : t === null || e === null ? !1 : t.equalsForConfigSet(e);
}
class U1 {
  constructor(e) {
    this.configLookup = new w3(Hd, $d), this.fullCtx = e === void 0 ? !0 : e, this.readOnly = !1, this.configs = [], this.uniqueAlt = 0, this.conflictingAlts = null, this.hasSemanticContext = !1, this.dipsIntoOuterContext = !1, this.cachedHashCode = -1;
  }
  /**
   * Adding a new config means merging contexts with existing configs for
   * {@code (s, i, pi, _)}, where {@code s} is the
   * {@link ATNConfig//state}, {@code i} is the {@link ATNConfig//alt}, and
   * {@code pi} is the {@link ATNConfig//semanticContext}. We use
   * {@code (s,i,pi)} as key.
   *
   * <p>This method updates {@link //dipsIntoOuterContext} and
   * {@link //hasSemanticContext} when necessary.</p>
   */
  add(e, n) {
    if (n === void 0 && (n = null), this.readOnly)
      throw "This set is readonly";
    e.semanticContext !== j2.NONE && (this.hasSemanticContext = !0), e.reachesIntoOuterContext > 0 && (this.dipsIntoOuterContext = !0);
    const i = this.configLookup.add(e);
    if (i === e)
      return this.cachedHashCode = -1, this.configs.push(e), !0;
    const s = !this.fullCtx, r = je(i.context, e.context, s, n);
    return i.reachesIntoOuterContext = Math.max(i.reachesIntoOuterContext, e.reachesIntoOuterContext), e.precedenceFilterSuppressed && (i.precedenceFilterSuppressed = !0), i.context = r, !0;
  }
  getStates() {
    const e = new w3();
    for (let n = 0; n < this.configs.length; n++)
      e.add(this.configs[n].state);
    return e;
  }
  getPredicates() {
    const e = [];
    for (let n = 0; n < this.configs.length; n++) {
      const i = this.configs[n].semanticContext;
      i !== j2.NONE && e.push(i.semanticContext);
    }
    return e;
  }
  optimizeConfigs(e) {
    if (this.readOnly)
      throw "This set is readonly";
    if (this.configLookup.length !== 0)
      for (let n = 0; n < this.configs.length; n++) {
        const i = this.configs[n];
        i.context = e.getCachedContext(i.context);
      }
  }
  addAll(e) {
    for (let n = 0; n < e.length; n++)
      this.add(e[n]);
    return !1;
  }
  equals(e) {
    return this === e || e instanceof U1 && V9(this.configs, e.configs) && this.fullCtx === e.fullCtx && this.uniqueAlt === e.uniqueAlt && this.conflictingAlts === e.conflictingAlts && this.hasSemanticContext === e.hasSemanticContext && this.dipsIntoOuterContext === e.dipsIntoOuterContext;
  }
  hashCode() {
    const e = new v3();
    return e.update(this.configs), e.finish();
  }
  updateHashCode(e) {
    this.readOnly ? (this.cachedHashCode === -1 && (this.cachedHashCode = this.hashCode()), e.update(this.cachedHashCode)) : e.update(this.hashCode());
  }
  isEmpty() {
    return this.configs.length === 0;
  }
  contains(e) {
    if (this.configLookup === null)
      throw "This method is not implemented for readonly sets.";
    return this.configLookup.contains(e);
  }
  containsFast(e) {
    if (this.configLookup === null)
      throw "This method is not implemented for readonly sets.";
    return this.configLookup.containsFast(e);
  }
  clear() {
    if (this.readOnly)
      throw "This set is readonly";
    this.configs = [], this.cachedHashCode = -1, this.configLookup = new w3();
  }
  setReadonly(e) {
    this.readOnly = e, e && (this.configLookup = null);
  }
  toString() {
    return S4(this.configs) + (this.hasSemanticContext ? ",hasSemanticContext=" + this.hasSemanticContext : "") + (this.uniqueAlt !== l1.INVALID_ALT_NUMBER ? ",uniqueAlt=" + this.uniqueAlt : "") + (this.conflictingAlts !== null ? ",conflictingAlts=" + this.conflictingAlts : "") + (this.dipsIntoOuterContext ? ",dipsIntoOuterContext" : "");
  }
  get items() {
    return this.configs;
  }
  get length() {
    return this.configs.length;
  }
}
class h4 {
  constructor(e, n) {
    return e === null && (e = -1), n === null && (n = new U1()), this.stateNumber = e, this.configs = n, this.edges = null, this.isAcceptState = !1, this.prediction = 0, this.lexerActionExecutor = null, this.requiresFullContext = !1, this.predicates = null, this;
  }
  /**
   * Get the set of all alts mentioned by all ATN configurations in this
   * DFA state.
   */
  getAltSet() {
    const e = new w3();
    if (this.configs !== null)
      for (let n = 0; n < this.configs.length; n++) {
        const i = this.configs[n];
        e.add(i.alt);
      }
    return e.length === 0 ? null : e;
  }
  /**
   * Two {@link DFAState} instances are equal if their ATN configuration sets
   * are the same. This method is used to see if a state already exists.
   *
   * <p>Because the number of alternatives and number of ATN configurations are
   * finite, there is a finite number of DFA states that can be processed.
   * This is necessary to show that the algorithm terminates.</p>
   *
   * <p>Cannot test the DFA state numbers here because in
   * {@link ParserATNSimulator//addDFAState} we need to know if any other state
   * exists that has this exact set of ATN configurations. The
   * {@link //stateNumber} is irrelevant.</p>
   */
  equals(e) {
    return this === e || e instanceof h4 && this.configs.equals(e.configs);
  }
  toString() {
    let e = "" + this.stateNumber + ":" + this.configs;
    return this.isAcceptState && (e = e + "=>", this.predicates !== null ? e = e + this.predicates : e = e + this.prediction), e;
  }
  hashCode() {
    const e = new v3();
    return e.update(this.configs), e.finish();
  }
}
class V3 {
  constructor(e, n) {
    return this.atn = e, this.sharedContextCache = n, this;
  }
  getCachedContext(e) {
    if (this.sharedContextCache === null)
      return e;
    const n = new o5();
    return il(e, this.sharedContextCache, n);
  }
}
V3.ERROR = new h4(2147483647, new U1());
class Mi extends U1 {
  constructor() {
    super(), this.configLookup = new w3();
  }
}
class n3 extends c1 {
  constructor(e, n) {
    super(e, n);
    const i = e.lexerActionExecutor || null;
    return this.lexerActionExecutor = i || (n !== null ? n.lexerActionExecutor : null), this.passedThroughNonGreedyDecision = n !== null ? this.checkNonGreedyDecision(n, this.state) : !1, this.hashCodeForConfigSet = n3.prototype.hashCode, this.equalsForConfigSet = n3.prototype.equals, this;
  }
  updateHashCode(e) {
    e.update(this.state.stateNumber, this.alt, this.context, this.semanticContext, this.passedThroughNonGreedyDecision, this.lexerActionExecutor);
  }
  equals(e) {
    return this === e || e instanceof n3 && this.passedThroughNonGreedyDecision === e.passedThroughNonGreedyDecision && (this.lexerActionExecutor ? this.lexerActionExecutor.equals(e.lexerActionExecutor) : !e.lexerActionExecutor) && super.equals(e);
  }
  checkNonGreedyDecision(e, n) {
    return e.passedThroughNonGreedyDecision || n instanceof J9 && n.nonGreedy;
  }
}
class k0 extends _4 {
  constructor(e, n) {
    super(n.actionType), this.offset = e, this.action = n, this.isPositionDependent = !0;
  }
  /**
   * <p>This method calls {@link //execute} on the result of {@link //getAction}
   * using the provided {@code lexer}.</p>
   */
  execute(e) {
    this.action.execute(e);
  }
  updateHashCode(e) {
    e.update(this.actionType, this.offset, this.action);
  }
  equals(e) {
    return this === e ? !0 : e instanceof k0 ? this.offset === e.offset && this.action === e.action : !1;
  }
}
class Z9 {
  /**
   * Represents an executor for a sequence of lexer actions which traversed during
   * the matching operation of a lexer rule (token).
   *
   * <p>The executor tracks position information for position-dependent lexer actions
   * efficiently, ensuring that actions appearing only at the end of the rule do
   * not cause bloating of the {@link DFA} created for the lexer.</p>
   */
  constructor(e) {
    return this.lexerActions = e === null ? [] : e, this.cachedHashCode = v3.hashStuff(e), this;
  }
  /**
   * Creates a {@link LexerActionExecutor} which encodes the current offset
   * for position-dependent lexer actions.
   *
   * <p>Normally, when the executor encounters lexer actions where
   * {@link LexerAction//isPositionDependent} returns {@code true}, it calls
   * {@link IntStream//seek} on the input {@link CharStream} to set the input
   * position to the <em>end</em> of the current token. This behavior provides
   * for efficient DFA representation of lexer actions which appear at the end
   * of a lexer rule, even when the lexer rule matches a variable number of
   * characters.</p>
   *
   * <p>Prior to traversing a match transition in the ATN, the current offset
   * from the token start index is assigned to all position-dependent lexer
   * actions which have not already been assigned a fixed offset. By storing
   * the offsets relative to the token start index, the DFA representation of
   * lexer actions which appear in the middle of tokens remains efficient due
   * to sharing among tokens of the same length, regardless of their absolute
   * position in the input stream.</p>
   *
   * <p>If the current executor already has offsets assigned to all
   * position-dependent lexer actions, the method returns {@code this}.</p>
   *
   * @param offset The current offset to assign to all position-dependent
   * lexer actions which do not already have offsets assigned.
   *
   * @return {LexerActionExecutor} A {@link LexerActionExecutor} which stores input stream offsets
   * for all position-dependent lexer actions.
   */
  fixOffsetBeforeMatch(e) {
    let n = null;
    for (let i = 0; i < this.lexerActions.length; i++)
      this.lexerActions[i].isPositionDependent && !(this.lexerActions[i] instanceof k0) && (n === null && (n = this.lexerActions.concat([])), n[i] = new k0(
        e,
        this.lexerActions[i]
      ));
    return n === null ? this : new Z9(n);
  }
  /**
   * Execute the actions encapsulated by this executor within the context of a
   * particular {@link Lexer}.
   *
   * <p>This method calls {@link IntStream//seek} to set the position of the
   * {@code input} {@link CharStream} prior to calling
   * {@link LexerAction//execute} on a position-dependent action. Before the
   * method returns, the input position will be restored to the same position
   * it was in when the method was invoked.</p>
   *
   * @param lexer The lexer instance.
   * @param input The input stream which is the source for the current token.
   * When this method is called, the current {@link IntStream//index} for
   * {@code input} should be the start of the following token, i.e. 1
   * character past the end of the current token.
   * @param startIndex The token start index. This value may be passed to
   * {@link IntStream//seek} to set the {@code input} position to the beginning
   * of the token.
   */
  execute(e, n, i) {
    let s = !1;
    const r = n.index;
    try {
      for (let o = 0; o < this.lexerActions.length; o++) {
        let l = this.lexerActions[o];
        if (l instanceof k0) {
          const L = l.offset;
          n.seek(i + L), l = l.action, s = i + L !== r;
        } else
          l.isPositionDependent && (n.seek(r), s = !1);
        l.execute(e);
      }
    } finally {
      s && n.seek(r);
    }
  }
  hashCode() {
    return this.cachedHashCode;
  }
  updateHashCode(e) {
    e.update(this.cachedHashCode);
  }
  equals(e) {
    if (this === e)
      return !0;
    if (e instanceof Z9) {
      if (this.cachedHashCode != e.cachedHashCode)
        return !1;
      if (this.lexerActions.length != e.lexerActions.length)
        return !1;
      {
        const n = this.lexerActions.length;
        for (let i = 0; i < n; ++i)
          if (!this.lexerActions[i].equals(e.lexerActions[i]))
            return !1;
        return !0;
      }
    } else
      return !1;
  }
  /**
   * Creates a {@link LexerActionExecutor} which executes the actions for
   * the input {@code lexerActionExecutor} followed by a specified
   * {@code lexerAction}.
   *
   * @param lexerActionExecutor The executor for actions already traversed by
   * the lexer while matching a token within a particular
   * {@link LexerATNConfig}. If this is {@code null}, the method behaves as
   * though it were an empty executor.
   * @param lexerAction The lexer action to execute after the actions
   * specified in {@code lexerActionExecutor}.
   *
   * @return {LexerActionExecutor} A {@link LexerActionExecutor} for executing the combine actions
   * of {@code lexerActionExecutor} and {@code lexerAction}.
   */
  static append(e, n) {
    if (e === null)
      return new Z9([n]);
    const i = e.lexerActions.concat([n]);
    return new Z9(i);
  }
}
function Ri(t) {
  t.index = -1, t.line = 0, t.column = -1, t.dfaState = null;
}
class Vd {
  constructor() {
    Ri(this);
  }
  reset() {
    Ri(this);
  }
}
class L1 extends V3 {
  /**
   * When we hit an accept state in either the DFA or the ATN, we
   * have to notify the character stream to start buffering characters
   * via {@link IntStream//mark} and record the current state. The current sim state
   * includes the current index into the input, the current line,
   * and current character position in that line. Note that the Lexer is
   * tracking the starting line and characterization of the token. These
   * variables track the "state" of the simulator when it hits an accept state.
   *
   * <p>We track these variables separately for the DFA and ATN simulation
   * because the DFA simulation often has to fail over to the ATN
   * simulation. If the ATN simulation fails, we need the DFA to fall
   * back to its previously accepted state, if any. If the ATN succeeds,
   * then the ATN does the accept and the DFA simulator that invoked it
   * can simply return the predicted token type.</p>
   */
  constructor(e, n, i, s) {
    super(n, s), this.decisionToDFA = i, this.recog = e, this.startIndex = -1, this.line = 1, this.column = 0, this.mode = V1.DEFAULT_MODE, this.prevAccept = new Vd();
  }
  copyState(e) {
    this.column = e.column, this.line = e.line, this.mode = e.mode, this.startIndex = e.startIndex;
  }
  match(e, n) {
    this.mode = n;
    const i = e.mark();
    try {
      this.startIndex = e.index, this.prevAccept.reset();
      const s = this.decisionToDFA[n];
      return s.s0 === null ? this.matchATN(e) : this.execATN(e, s.s0);
    } finally {
      e.release(i);
    }
  }
  reset() {
    this.prevAccept.reset(), this.startIndex = -1, this.line = 1, this.column = 0, this.mode = V1.DEFAULT_MODE;
  }
  matchATN(e) {
    const n = this.atn.modeToStartState[this.mode];
    L1.debug && console.log("matchATN mode " + this.mode + " start: " + n);
    const i = this.mode, s = this.computeStartState(e, n), r = s.hasSemanticContext;
    s.hasSemanticContext = !1;
    const o = this.addDFAState(s);
    r || (this.decisionToDFA[this.mode].s0 = o);
    const l = this.execATN(e, o);
    return L1.debug && console.log("DFA after matchATN: " + this.decisionToDFA[i].toLexerString()), l;
  }
  execATN(e, n) {
    L1.debug && console.log("start state closure=" + n.configs), n.isAcceptState && this.captureSimState(this.prevAccept, e, n);
    let i = e.LA(1), s = n;
    for (; ; ) {
      L1.debug && console.log("execATN loop starting closure: " + s.configs);
      let r = this.getExistingTargetState(s, i);
      if (r === null && (r = this.computeTargetState(e, s, i)), r === V3.ERROR || (i !== j.EOF && this.consume(e), r.isAcceptState && (this.captureSimState(this.prevAccept, e, r), i === j.EOF)))
        break;
      i = e.LA(1), s = r;
    }
    return this.failOrAccept(this.prevAccept, e, s.configs, i);
  }
  /**
   * Get an existing target state for an edge in the DFA. If the target state
   * for the edge has not yet been computed or is otherwise not available,
   * this method returns {@code null}.
   *
   * @param s The current DFA state
   * @param t The next input symbol
   * @return The existing target DFA state for the given input symbol
   * {@code t}, or {@code null} if the target state for this edge is not
   * already cached
   */
  getExistingTargetState(e, n) {
    if (e.edges === null || n < L1.MIN_DFA_EDGE || n > L1.MAX_DFA_EDGE)
      return null;
    let i = e.edges[n - L1.MIN_DFA_EDGE];
    return i === void 0 && (i = null), L1.debug && i !== null && console.log("reuse state " + e.stateNumber + " edge to " + i.stateNumber), i;
  }
  /**
   * Compute a target state for an edge in the DFA, and attempt to add the
   * computed state and corresponding edge to the DFA.
   *
   * @param input The input stream
   * @param s The current DFA state
   * @param t The next input symbol
   *
   * @return The computed target DFA state for the given input symbol
   * {@code t}. If {@code t} does not lead to a valid DFA state, this method
   * returns {@link //ERROR}.
   */
  computeTargetState(e, n, i) {
    const s = new Mi();
    return this.getReachableConfigSet(e, n.configs, s, i), s.items.length === 0 ? (s.hasSemanticContext || this.addDFAEdge(n, i, V3.ERROR), V3.ERROR) : this.addDFAEdge(n, i, null, s);
  }
  failOrAccept(e, n, i, s) {
    if (this.prevAccept.dfaState !== null) {
      const r = e.dfaState.lexerActionExecutor;
      return this.accept(
        n,
        r,
        this.startIndex,
        e.index,
        e.line,
        e.column
      ), e.dfaState.prediction;
    } else {
      if (s === j.EOF && n.index === this.startIndex)
        return j.EOF;
      throw new Je(this.recog, n, this.startIndex, i);
    }
  }
  /**
   * Given a starting configuration set, figure out all ATN configurations
   * we can reach upon input {@code t}. Parameter {@code reach} is a return
   * parameter.
   */
  getReachableConfigSet(e, n, i, s) {
    let r = l1.INVALID_ALT_NUMBER;
    for (let o = 0; o < n.items.length; o++) {
      const l = n.items[o], L = l.alt === r;
      if (!(L && l.passedThroughNonGreedyDecision)) {
        L1.debug && console.log(`testing %s at %s
`, this.getTokenName(s), l.toString(this.recog, !0));
        for (let a = 0; a < l.state.transitions.length; a++) {
          const C = l.state.transitions[a], c = this.getReachableTarget(C, s);
          if (c !== null) {
            let h = l.lexerActionExecutor;
            h !== null && (h = h.fixOffsetBeforeMatch(e.index - this.startIndex));
            const d = s === j.EOF, f = new n3({ state: c, lexerActionExecutor: h }, l);
            this.closure(
              e,
              f,
              i,
              L,
              !0,
              d
            ) && (r = l.alt);
          }
        }
      }
    }
  }
  accept(e, n, i, s, r, o) {
    L1.debug && console.log(`ACTION %s
`, n), e.seek(s), this.line = r, this.column = o, n !== null && this.recog !== null && n.execute(this.recog, e, i);
  }
  getReachableTarget(e, n) {
    return e.matches(n, 0, V1.MAX_CHAR_VALUE) ? e.target : null;
  }
  computeStartState(e, n) {
    const i = O2.EMPTY, s = new Mi();
    for (let r = 0; r < n.transitions.length; r++) {
      const o = n.transitions[r].target, l = new n3({ state: o, alt: r + 1, context: i }, null);
      this.closure(e, l, s, !1, !1, !1);
    }
    return s;
  }
  /**
   * Since the alternatives within any lexer decision are ordered by
   * preference, this method stops pursuing the closure as soon as an accept
   * state is reached. After the first accept state is reached by depth-first
   * search from {@code config}, all other (potentially reachable) states for
   * this rule would have a lower priority.
   *
   * @return {Boolean} {@code true} if an accept state is reached, otherwise
   * {@code false}.
   */
  closure(e, n, i, s, r, o) {
    let l = null;
    if (L1.debug && console.log("closure(" + n.toString(this.recog, !0) + ")"), n.state instanceof H1) {
      if (L1.debug && (this.recog !== null ? console.log(`closure at %s rule stop %s
`, this.recog.ruleNames[n.state.ruleIndex], n) : console.log(`closure at rule stop %s
`, n)), n.context === null || n.context.hasEmptyPath()) {
        if (n.context === null || n.context.isEmpty())
          return i.add(n), !0;
        i.add(new n3({ state: n.state, context: O2.EMPTY }, n)), s = !0;
      }
      if (n.context !== null && !n.context.isEmpty()) {
        for (let L = 0; L < n.context.length; L++)
          if (n.context.getReturnState(L) !== O2.EMPTY_RETURN_STATE) {
            const a = n.context.getParent(L), C = this.atn.states[n.context.getReturnState(L)];
            l = new n3({ state: C, context: a }, n), s = this.closure(
              e,
              l,
              i,
              s,
              r,
              o
            );
          }
      }
      return s;
    }
    n.state.epsilonOnlyTransitions || (!s || !n.passedThroughNonGreedyDecision) && i.add(n);
    for (let L = 0; L < n.state.transitions.length; L++) {
      const a = n.state.transitions[L];
      l = this.getEpsilonTarget(e, n, a, i, r, o), l !== null && (s = this.closure(
        e,
        l,
        i,
        s,
        r,
        o
      ));
    }
    return s;
  }
  // side-effect: can alter configs.hasSemanticContext
  getEpsilonTarget(e, n, i, s, r, o) {
    let l = null;
    if (i.serializationType === a2.RULE) {
      const L = $1.create(n.context, i.followState.stateNumber);
      l = new n3({ state: i.target, context: L }, n);
    } else {
      if (i.serializationType === a2.PRECEDENCE)
        throw "Precedence predicates are not supported in lexers.";
      if (i.serializationType === a2.PREDICATE)
        L1.debug && console.log("EVAL rule " + i.ruleIndex + ":" + i.predIndex), s.hasSemanticContext = !0, this.evaluatePredicate(e, i.ruleIndex, i.predIndex, r) && (l = new n3({ state: i.target }, n));
      else if (i.serializationType === a2.ACTION)
        if (n.context === null || n.context.hasEmptyPath()) {
          const L = Z9.append(
            n.lexerActionExecutor,
            this.atn.lexerActions[i.actionIndex]
          );
          l = new n3({ state: i.target, lexerActionExecutor: L }, n);
        } else
          l = new n3({ state: i.target }, n);
      else
        i.serializationType === a2.EPSILON ? l = new n3({ state: i.target }, n) : (i.serializationType === a2.ATOM || i.serializationType === a2.RANGE || i.serializationType === a2.SET) && o && i.matches(j.EOF, 0, V1.MAX_CHAR_VALUE) && (l = new n3({ state: i.target }, n));
    }
    return l;
  }
  /**
   * Evaluate a predicate specified in the lexer.
   *
   * <p>If {@code speculative} is {@code true}, this method was called before
   * {@link //consume} for the matched character. This method should call
   * {@link //consume} before evaluating the predicate to ensure position
   * sensitive values, including {@link Lexer//getText}, {@link Lexer//getLine},
   * and {@link Lexer//getcolumn}, properly reflect the current
   * lexer state. This method should restore {@code input} and the simulator
   * to the original state before returning (i.e. undo the actions made by the
   * call to {@link //consume}.</p>
   *
   * @param input The input stream.
   * @param ruleIndex The rule containing the predicate.
   * @param predIndex The index of the predicate within the rule.
   * @param speculative {@code true} if the current index in {@code input} is
   * one character before the predicate's location.
   *
   * @return {@code true} if the specified predicate evaluates to
   * {@code true}.
   */
  evaluatePredicate(e, n, i, s) {
    if (this.recog === null)
      return !0;
    if (!s)
      return this.recog.sempred(null, n, i);
    const r = this.column, o = this.line, l = e.index, L = e.mark();
    try {
      return this.consume(e), this.recog.sempred(null, n, i);
    } finally {
      this.column = r, this.line = o, e.seek(l), e.release(L);
    }
  }
  captureSimState(e, n, i) {
    e.index = n.index, e.line = this.line, e.column = this.column, e.dfaState = i;
  }
  addDFAEdge(e, n, i, s) {
    if (i === void 0 && (i = null), s === void 0 && (s = null), i === null && s !== null) {
      const r = s.hasSemanticContext;
      if (s.hasSemanticContext = !1, i = this.addDFAState(s), r)
        return i;
    }
    return n < L1.MIN_DFA_EDGE || n > L1.MAX_DFA_EDGE || (L1.debug && console.log("EDGE " + e + " -> " + i + " upon " + n), e.edges === null && (e.edges = []), e.edges[n - L1.MIN_DFA_EDGE] = i), i;
  }
  /**
   * Add a new DFA state if there isn't one with this set of
   * configurations already. This method also detects the first
   * configuration containing an ATN rule stop state. Later, when
   * traversing the DFA, we will know which rule to accept.
   */
  addDFAState(e) {
    const n = new h4(null, e);
    let i = null;
    for (let l = 0; l < e.items.length; l++) {
      const L = e.items[l];
      if (L.state instanceof H1) {
        i = L;
        break;
      }
    }
    i !== null && (n.isAcceptState = !0, n.lexerActionExecutor = i.lexerActionExecutor, n.prediction = this.atn.ruleToTokenType[i.state.ruleIndex]);
    const s = this.decisionToDFA[this.mode], r = s.states.get(n);
    if (r !== null)
      return r;
    const o = n;
    return o.stateNumber = s.states.length, e.setReadonly(!0), o.configs = e, s.states.add(o), o;
  }
  getDFA(e) {
    return this.decisionToDFA[e];
  }
  // Get the text matched so far for the current token.
  getText(e) {
    return e.getText(this.startIndex, e.index - 1);
  }
  consume(e) {
    e.LA(1) === `
`.charCodeAt(0) ? (this.line += 1, this.column = 0) : this.column += 1, e.consume();
  }
  getTokenName(e) {
    return e === -1 ? "EOF" : "'" + String.fromCharCode(e) + "'";
  }
}
L1.debug = !1;
L1.dfa_debug = !1;
L1.MIN_DFA_EDGE = 0;
L1.MAX_DFA_EDGE = 127;
class ll {
  constructor(e, n) {
    this.alt = n, this.pred = e;
  }
  toString() {
    return "(" + this.pred + ", " + this.alt + ")";
  }
}
class Gd {
  constructor() {
    this.data = {};
  }
  get(e) {
    return this.data["k-" + e] || null;
  }
  set(e, n) {
    this.data["k-" + e] = n;
  }
  values() {
    return Object.keys(this.data).filter((e) => e.startsWith("k-")).map((e) => this.data[e], this);
  }
}
const e1 = {
  /**
   * The SLL(*) prediction mode. This prediction mode ignores the current
   * parser context when making predictions. This is the fastest prediction
   * mode, and provides correct results for many grammars. This prediction
   * mode is more powerful than the prediction mode provided by ANTLR 3, but
   * may result in syntax errors for grammar and input combinations which are
   * not SLL.
   *
   * <p>
   * When using this prediction mode, the parser will either return a correct
   * parse tree (i.e. the same parse tree that would be returned with the
   * {@link //LL} prediction mode), or it will report a syntax error. If a
   * syntax error is encountered when using the {@link //SLL} prediction mode,
   * it may be due to either an actual syntax error in the input or indicate
   * that the particular combination of grammar and input requires the more
   * powerful {@link //LL} prediction abilities to complete successfully.</p>
   *
   * <p>
   * This prediction mode does not provide any guarantees for prediction
   * behavior for syntactically-incorrect inputs.</p>
   */
  SLL: 0,
  /**
   * The LL(*) prediction mode. This prediction mode allows the current parser
   * context to be used for resolving SLL conflicts that occur during
   * prediction. This is the fastest prediction mode that guarantees correct
   * parse results for all combinations of grammars with syntactically correct
   * inputs.
   *
   * <p>
   * When using this prediction mode, the parser will make correct decisions
   * for all syntactically-correct grammar and input combinations. However, in
   * cases where the grammar is truly ambiguous this prediction mode might not
   * report a precise answer for <em>exactly which</em> alternatives are
   * ambiguous.</p>
   *
   * <p>
   * This prediction mode does not provide any guarantees for prediction
   * behavior for syntactically-incorrect inputs.</p>
   */
  LL: 1,
  /**
   *
   * The LL(*) prediction mode with exact ambiguity detection. In addition to
   * the correctness guarantees provided by the {@link //LL} prediction mode,
   * this prediction mode instructs the prediction algorithm to determine the
   * complete and exact set of ambiguous alternatives for every ambiguous
   * decision encountered while parsing.
   *
   * <p>
   * This prediction mode may be used for diagnosing ambiguities during
   * grammar development. Due to the performance overhead of calculating sets
   * of ambiguous alternatives, this prediction mode should be avoided when
   * the exact results are not necessary.</p>
   *
   * <p>
   * This prediction mode does not provide any guarantees for prediction
   * behavior for syntactically-incorrect inputs.</p>
   */
  LL_EXACT_AMBIG_DETECTION: 2,
  /**
   *
   * Computes the SLL prediction termination condition.
   *
   * <p>
   * This method computes the SLL prediction termination condition for both of
   * the following cases.</p>
   *
   * <ul>
   * <li>The usual SLL+LL fallback upon SLL conflict</li>
   * <li>Pure SLL without LL fallback</li>
   * </ul>
   *
   * <p><strong>COMBINED SLL+LL PARSING</strong></p>
   *
   * <p>When LL-fallback is enabled upon SLL conflict, correct predictions are
   * ensured regardless of how the termination condition is computed by this
   * method. Due to the substantially higher cost of LL prediction, the
   * prediction should only fall back to LL when the additional lookahead
   * cannot lead to a unique SLL prediction.</p>
   *
   * <p>Assuming combined SLL+LL parsing, an SLL configuration set with only
   * conflicting subsets should fall back to full LL, even if the
   * configuration sets don't resolve to the same alternative (e.g.
   * {@code {1,2}} and {@code {3,4}}. If there is at least one non-conflicting
   * configuration, SLL could continue with the hopes that more lookahead will
   * resolve via one of those non-conflicting configurations.</p>
   *
   * <p>Here's the prediction termination rule them: SLL (for SLL+LL parsing)
   * stops when it sees only conflicting configuration subsets. In contrast,
   * full LL keeps going when there is uncertainty.</p>
   *
   * <p><strong>HEURISTIC</strong></p>
   *
   * <p>As a heuristic, we stop prediction when we see any conflicting subset
   * unless we see a state that only has one alternative associated with it.
   * The single-alt-state thing lets prediction continue upon rules like
   * (otherwise, it would admit defeat too soon):</p>
   *
   * <p>{@code [12|1|[], 6|2|[], 12|2|[]]. s : (ID | ID ID?) ';' ;}</p>
   *
   * <p>When the ATN simulation reaches the state before {@code ';'}, it has a
   * DFA state that looks like: {@code [12|1|[], 6|2|[], 12|2|[]]}. Naturally
   * {@code 12|1|[]} and {@code 12|2|[]} conflict, but we cannot stop
   * processing this node because alternative to has another way to continue,
   * via {@code [6|2|[]]}.</p>
   *
   * <p>It also let's us continue for this rule:</p>
   *
   * <p>{@code [1|1|[], 1|2|[], 8|3|[]] a : A | A | A B ;}</p>
   *
   * <p>After matching input A, we reach the stop state for rule A, state 1.
   * State 8 is the state right before B. Clearly alternatives 1 and 2
   * conflict and no amount of further lookahead will separate the two.
   * However, alternative 3 will be able to continue and so we do not stop
   * working on this state. In the previous example, we're concerned with
   * states associated with the conflicting alternatives. Here alt 3 is not
   * associated with the conflicting configs, but since we can continue
   * looking for input reasonably, don't declare the state done.</p>
   *
   * <p><strong>PURE SLL PARSING</strong></p>
   *
   * <p>To handle pure SLL parsing, all we have to do is make sure that we
   * combine stack contexts for configurations that differ only by semantic
   * predicate. From there, we can do the usual SLL termination heuristic.</p>
   *
   * <p><strong>PREDICATES IN SLL+LL PARSING</strong></p>
   *
   * <p>SLL decisions don't evaluate predicates until after they reach DFA stop
   * states because they need to create the DFA cache that works in all
   * semantic situations. In contrast, full LL evaluates predicates collected
   * during start state computation so it can ignore predicates thereafter.
   * This means that SLL termination detection can totally ignore semantic
   * predicates.</p>
   *
   * <p>Implementation-wise, {@link ATNConfigSet} combines stack contexts but not
   * semantic predicate contexts so we might see two configurations like the
   * following.</p>
   *
   * <p>{@code (s, 1, x, {}), (s, 1, x', {p})}</p>
   *
   * <p>Before testing these configurations against others, we have to merge
   * {@code x} and {@code x'} (without modifying the existing configurations).
   * For example, we test {@code (x+x')==x''} when looking for conflicts in
   * the following configurations.</p>
   *
   * <p>{@code (s, 1, x, {}), (s, 1, x', {p}), (s, 2, x'', {})}</p>
   *
   * <p>If the configuration set has predicates (as indicated by
   * {@link ATNConfigSet//hasSemanticContext}), this algorithm makes a copy of
   * the configurations to strip out all of the predicates so that a standard
   * {@link ATNConfigSet} will merge everything ignoring predicates.</p>
   */
  hasSLLConflictTerminatingPrediction: function(t, e) {
    if (e1.allConfigsInRuleStopStates(e))
      return !0;
    if (t === e1.SLL && e.hasSemanticContext) {
      const i = new U1();
      for (let s = 0; s < e.items.length; s++) {
        let r = e.items[s];
        r = new c1({ semanticContext: j2.NONE }, r), i.add(r);
      }
      e = i;
    }
    const n = e1.getConflictingAltSubsets(e);
    return e1.hasConflictingAltSet(n) && !e1.hasStateAssociatedWithOneAlt(e);
  },
  /**
   * Checks if any configuration in {@code configs} is in a
   * {@link RuleStopState}. Configurations meeting this condition have reached
   * the end of the decision rule (local context) or end of start rule (full
   * context).
   *
   * @param configs the configuration set to test
   * @return {@code true} if any configuration in {@code configs} is in a
   * {@link RuleStopState}, otherwise {@code false}
   */
  hasConfigInRuleStopState: function(t) {
    for (let e = 0; e < t.items.length; e++)
      if (t.items[e].state instanceof H1)
        return !0;
    return !1;
  },
  /**
   * Checks if all configurations in {@code configs} are in a
   * {@link RuleStopState}. Configurations meeting this condition have reached
   * the end of the decision rule (local context) or end of start rule (full
   * context).
   *
   * @param configs the configuration set to test
   * @return {@code true} if all configurations in {@code configs} are in a
   * {@link RuleStopState}, otherwise {@code false}
   */
  allConfigsInRuleStopStates: function(t) {
    for (let e = 0; e < t.items.length; e++)
      if (!(t.items[e].state instanceof H1))
        return !1;
    return !0;
  },
  /**
   *
   * Full LL prediction termination.
   *
   * <p>Can we stop looking ahead during ATN simulation or is there some
   * uncertainty as to which alternative we will ultimately pick, after
   * consuming more input? Even if there are partial conflicts, we might know
   * that everything is going to resolve to the same minimum alternative. That
   * means we can stop since no more lookahead will change that fact. On the
   * other hand, there might be multiple conflicts that resolve to different
   * minimums. That means we need more look ahead to decide which of those
   * alternatives we should predict.</p>
   *
   * <p>The basic idea is to split the set of configurations {@code C}, into
   * conflicting subsets {@code (s, _, ctx, _)} and singleton subsets with
   * non-conflicting configurations. Two configurations conflict if they have
   * identical {@link ATNConfig//state} and {@link ATNConfig//context} values
   * but different {@link ATNConfig//alt} value, e.g. {@code (s, i, ctx, _)}
   * and {@code (s, j, ctx, _)} for {@code i!=j}.</p>
   *
   * <p>Reduce these configuration subsets to the set of possible alternatives.
   * You can compute the alternative subsets in one pass as follows:</p>
   *
   * <p>{@code A_s,ctx = {i | (s, i, ctx, _)}} for each configuration in
   * {@code C} holding {@code s} and {@code ctx} fixed.</p>
   *
   * <p>Or in pseudo-code, for each configuration {@code c} in {@code C}:</p>
   *
   * <pre>
   * map[c] U= c.{@link ATNConfig//alt alt} // map hash/equals uses s and x, not
   * alt and not pred
   * </pre>
   *
   * <p>The values in {@code map} are the set of {@code A_s,ctx} sets.</p>
   *
   * <p>If {@code |A_s,ctx|=1} then there is no conflict associated with
   * {@code s} and {@code ctx}.</p>
   *
   * <p>Reduce the subsets to singletons by choosing a minimum of each subset. If
   * the union of these alternative subsets is a singleton, then no amount of
   * more lookahead will help us. We will always pick that alternative. If,
   * however, there is more than one alternative, then we are uncertain which
   * alternative to predict and must continue looking for resolution. We may
   * or may not discover an ambiguity in the future, even if there are no
   * conflicting subsets this round.</p>
   *
   * <p>The biggest sin is to terminate early because it means we've made a
   * decision but were uncertain as to the eventual outcome. We haven't used
   * enough lookahead. On the other hand, announcing a conflict too late is no
   * big deal; you will still have the conflict. It's just inefficient. It
   * might even look until the end of file.</p>
   *
   * <p>No special consideration for semantic predicates is required because
   * predicates are evaluated on-the-fly for full LL prediction, ensuring that
   * no configuration contains a semantic context during the termination
   * check.</p>
   *
   * <p><strong>CONFLICTING CONFIGS</strong></p>
   *
   * <p>Two configurations {@code (s, i, x)} and {@code (s, j, x')}, conflict
   * when {@code i!=j} but {@code x=x'}. Because we merge all
   * {@code (s, i, _)} configurations together, that means that there are at
   * most {@code n} configurations associated with state {@code s} for
   * {@code n} possible alternatives in the decision. The merged stacks
   * complicate the comparison of configuration contexts {@code x} and
   * {@code x'}. Sam checks to see if one is a subset of the other by calling
   * merge and checking to see if the merged result is either {@code x} or
   * {@code x'}. If the {@code x} associated with lowest alternative {@code i}
   * is the superset, then {@code i} is the only possible prediction since the
   * others resolve to {@code min(i)} as well. However, if {@code x} is
   * associated with {@code j>i} then at least one stack configuration for
   * {@code j} is not in conflict with alternative {@code i}. The algorithm
   * should keep going, looking for more lookahead due to the uncertainty.</p>
   *
   * <p>For simplicity, I'm doing a equality check between {@code x} and
   * {@code x'} that lets the algorithm continue to consume lookahead longer
   * than necessary. The reason I like the equality is of course the
   * simplicity but also because that is the test you need to detect the
   * alternatives that are actually in conflict.</p>
   *
   * <p><strong>CONTINUE/STOP RULE</strong></p>
   *
   * <p>Continue if union of resolved alternative sets from non-conflicting and
   * conflicting alternative subsets has more than one alternative. We are
   * uncertain about which alternative to predict.</p>
   *
   * <p>The complete set of alternatives, {@code [i for (_,i,_)]}, tells us which
   * alternatives are still in the running for the amount of input we've
   * consumed at this point. The conflicting sets let us to strip away
   * configurations that won't lead to more states because we resolve
   * conflicts to the configuration with a minimum alternate for the
   * conflicting set.</p>
   *
   * <p><strong>CASES</strong></p>
   *
   * <ul>
   *
   * <li>no conflicts and more than 1 alternative in set =&gt; continue</li>
   *
   * <li> {@code (s, 1, x)}, {@code (s, 2, x)}, {@code (s, 3, z)},
   * {@code (s', 1, y)}, {@code (s', 2, y)} yields non-conflicting set
   * {@code {3}} U conflicting sets {@code min({1,2})} U {@code min({1,2})} =
   * {@code {1,3}} =&gt; continue
   * </li>
   *
   * <li>{@code (s, 1, x)}, {@code (s, 2, x)}, {@code (s', 1, y)},
   * {@code (s', 2, y)}, {@code (s'', 1, z)} yields non-conflicting set
   * {@code {1}} U conflicting sets {@code min({1,2})} U {@code min({1,2})} =
   * {@code {1}} =&gt; stop and predict 1</li>
   *
   * <li>{@code (s, 1, x)}, {@code (s, 2, x)}, {@code (s', 1, y)},
   * {@code (s', 2, y)} yields conflicting, reduced sets {@code {1}} U
   * {@code {1}} = {@code {1}} =&gt; stop and predict 1, can announce
   * ambiguity {@code {1,2}}</li>
   *
   * <li>{@code (s, 1, x)}, {@code (s, 2, x)}, {@code (s', 2, y)},
   * {@code (s', 3, y)} yields conflicting, reduced sets {@code {1}} U
   * {@code {2}} = {@code {1,2}} =&gt; continue</li>
   *
   * <li>{@code (s, 1, x)}, {@code (s, 2, x)}, {@code (s', 3, y)},
   * {@code (s', 4, y)} yields conflicting, reduced sets {@code {1}} U
   * {@code {3}} = {@code {1,3}} =&gt; continue</li>
   *
   * </ul>
   *
   * <p><strong>EXACT AMBIGUITY DETECTION</strong></p>
   *
   * <p>If all states report the same conflicting set of alternatives, then we
   * know we have the exact ambiguity set.</p>
   *
   * <p><code>|A_<em>i</em>|&gt;1</code> and
   * <code>A_<em>i</em> = A_<em>j</em></code> for all <em>i</em>, <em>j</em>.</p>
   *
   * <p>In other words, we continue examining lookahead until all {@code A_i}
   * have more than one alternative and all {@code A_i} are the same. If
   * {@code A={{1,2}, {1,3}}}, then regular LL prediction would terminate
   * because the resolved set is {@code {1}}. To determine what the real
   * ambiguity is, we have to know whether the ambiguity is between one and
   * two or one and three so we keep going. We can only stop prediction when
   * we need exact ambiguity detection when the sets look like
   * {@code A={{1,2}}} or {@code {{1,2},{1,2}}}, etc...</p>
   */
  resolvesToJustOneViableAlt: function(t) {
    return e1.getSingleViableAlt(t);
  },
  /**
   * Determines if every alternative subset in {@code altsets} contains more
   * than one alternative.
   *
   * @param altsets a collection of alternative subsets
   * @return {@code true} if every {@link BitSet} in {@code altsets} has
   * {@link BitSet//cardinality cardinality} &gt; 1, otherwise {@code false}
   */
  allSubsetsConflict: function(t) {
    return !e1.hasNonConflictingAltSet(t);
  },
  /**
   * Determines if any single alternative subset in {@code altsets} contains
   * exactly one alternative.
   *
   * @param altsets a collection of alternative subsets
   * @return {@code true} if {@code altsets} contains a {@link BitSet} with
   * {@link BitSet//cardinality cardinality} 1, otherwise {@code false}
   */
  hasNonConflictingAltSet: function(t) {
    for (let e = 0; e < t.length; e++)
      if (t[e].length === 1)
        return !0;
    return !1;
  },
  /**
   * Determines if any single alternative subset in {@code altsets} contains
   * more than one alternative.
   *
   * @param altsets a collection of alternative subsets
   * @return {@code true} if {@code altsets} contains a {@link BitSet} with
   * {@link BitSet//cardinality cardinality} &gt; 1, otherwise {@code false}
   */
  hasConflictingAltSet: function(t) {
    for (let e = 0; e < t.length; e++)
      if (t[e].length > 1)
        return !0;
    return !1;
  },
  /**
   * Determines if every alternative subset in {@code altsets} is equivalent.
   *
   * @param altsets a collection of alternative subsets
   * @return {@code true} if every member of {@code altsets} is equal to the
   * others, otherwise {@code false}
   */
  allSubsetsEqual: function(t) {
    let e = null;
    for (let n = 0; n < t.length; n++) {
      const i = t[n];
      if (e === null)
        e = i;
      else if (i !== e)
        return !1;
    }
    return !0;
  },
  /**
   * Returns the unique alternative predicted by all alternative subsets in
   * {@code altsets}. If no such alternative exists, this method returns
   * {@link ATN//INVALID_ALT_NUMBER}.
   *
   * @param altsets a collection of alternative subsets
   */
  getUniqueAlt: function(t) {
    const e = e1.getAlts(t);
    return e.length === 1 ? e.minValue() : l1.INVALID_ALT_NUMBER;
  },
  /**
   * Gets the complete set of represented alternatives for a collection of
   * alternative subsets. This method returns the union of each {@link BitSet}
   * in {@code altsets}.
   *
   * @param altsets a collection of alternative subsets
   * @return the set of represented alternatives in {@code altsets}
   */
  getAlts: function(t) {
    const e = new K3();
    return t.map(function(n) {
      e.or(n);
    }), e;
  },
  /**
   * This function gets the conflicting alt subsets from a configuration set.
   * For each configuration {@code c} in {@code configs}:
   *
   * <pre>
   * map[c] U= c.{@link ATNConfig//alt alt} // map hash/equals uses s and x, not
   * alt and not pred
   * </pre>
   */
  getConflictingAltSubsets: function(t) {
    const e = new o5();
    return e.hashFunction = function(n) {
      v3.hashStuff(n.state.stateNumber, n.context);
    }, e.equalsFunction = function(n, i) {
      return n.state.stateNumber === i.state.stateNumber && n.context.equals(i.context);
    }, t.items.map(function(n) {
      let i = e.get(n);
      i === null && (i = new K3(), e.set(n, i)), i.add(n.alt);
    }), e.getValues();
  },
  /**
   * Get a map from state to alt subset from a configuration set. For each
   * configuration {@code c} in {@code configs}:
   *
   * <pre>
   * map[c.{@link ATNConfig//state state}] U= c.{@link ATNConfig//alt alt}
   * </pre>
   */
  getStateToAltMap: function(t) {
    const e = new Gd();
    return t.items.map(function(n) {
      let i = e.get(n.state);
      i === null && (i = new K3(), e.set(n.state, i)), i.add(n.alt);
    }), e;
  },
  hasStateAssociatedWithOneAlt: function(t) {
    const e = e1.getStateToAltMap(t).values();
    for (let n = 0; n < e.length; n++)
      if (e[n].length === 1)
        return !0;
    return !1;
  },
  getSingleViableAlt: function(t) {
    let e = null;
    for (let n = 0; n < t.length; n++) {
      const s = t[n].minValue();
      if (e === null)
        e = s;
      else if (e !== s)
        return l1.INVALID_ALT_NUMBER;
    }
    return e;
  }
};
class et extends H4 {
  constructor(e, n, i, s, r, o) {
    o = o || e._ctx, s = s || e.getCurrentToken(), i = i || e.getCurrentToken(), n = n || e.getInputStream(), super({ message: "", recognizer: e, input: n, ctx: o }), this.deadEndConfigs = r, this.startToken = i, this.offendingToken = s;
  }
}
class jd {
  constructor(e) {
    this.defaultMapCtor = e || o5, this.cacheMap = new this.defaultMapCtor();
  }
  get(e, n) {
    const i = this.cacheMap.get(e) || null;
    return i === null ? null : i.get(n) || null;
  }
  set(e, n, i) {
    let s = this.cacheMap.get(e) || null;
    s === null && (s = new this.defaultMapCtor(), this.cacheMap.set(e, s)), s.set(n, i);
  }
}
class qd extends V3 {
  constructor(e, n, i, s) {
    super(n, s), this.parser = e, this.decisionToDFA = i, this.predictionMode = e1.LL, this._input = null, this._startIndex = 0, this._outerContext = null, this._dfa = null, this.mergeCache = null, this.debug = !1, this.debug_closure = !1, this.debug_add = !1, this.debug_list_atn_decisions = !1, this.dfa_debug = !1, this.retry_debug = !1;
  }
  reset() {
  }
  adaptivePredict(e, n, i) {
    (this.debug || this.debug_list_atn_decisions) && console.log("adaptivePredict decision " + n + " exec LA(1)==" + this.getLookaheadName(e) + " line " + e.LT(1).line + ":" + e.LT(1).column), this._input = e, this._startIndex = e.index, this._outerContext = i;
    const s = this.decisionToDFA[n];
    this._dfa = s;
    const r = e.mark(), o = e.index;
    try {
      let l;
      if (s.precedenceDfa ? l = s.getPrecedenceStartState(this.parser.getPrecedence()) : l = s.s0, l === null) {
        i === null && (i = G9.EMPTY), (this.debug || this.debug_list_atn_decisions) && console.log("predictATN decision " + s.decision + " exec LA(1)==" + this.getLookaheadName(e) + ", outerContext=" + i.toString(this.parser.ruleNames));
        const a = !1;
        let C = this.computeStartState(s.atnStartState, G9.EMPTY, a);
        s.precedenceDfa ? (s.s0.configs = C, C = this.applyPrecedenceFilter(C), l = this.addDFAState(s, new h4(null, C)), s.setPrecedenceStartState(this.parser.getPrecedence(), l)) : (l = this.addDFAState(s, new h4(null, C)), s.s0 = l);
      }
      const L = this.execATN(s, l, e, o, i);
      return this.debug && console.log("DFA after predictATN: " + s.toString(this.parser.literalNames, this.parser.symbolicNames)), L;
    } finally {
      this._dfa = null, this.mergeCache = null, e.seek(o), e.release(r);
    }
  }
  /**
   * Performs ATN simulation to compute a predicted alternative based
   *  upon the remaining input, but also updates the DFA cache to avoid
   *  having to traverse the ATN again for the same input sequence.
   *
   * There are some key conditions we're looking for after computing a new
   * set of ATN configs (proposed DFA state):
   *       if the set is empty, there is no viable alternative for current symbol
   *       does the state uniquely predict an alternative?
   *       does the state have a conflict that would prevent us from
   *         putting it on the work list?
   *
   * We also have some key operations to do:
   *       add an edge from previous DFA state to potentially new DFA state, D,
   *         upon current symbol but only if adding to work list, which means in all
   *         cases except no viable alternative (and possibly non-greedy decisions?)
   *       collecting predicates and adding semantic context to DFA accept states
   *       adding rule context to context-sensitive DFA accept states
   *       consuming an input symbol
   *       reporting a conflict
   *       reporting an ambiguity
   *       reporting a context sensitivity
   *       reporting insufficient predicates
   *
   * cover these cases:
   *    dead end
   *    single alt
   *    single alt + preds
   *    conflict
   *    conflict + preds
   *
   */
  execATN(e, n, i, s, r) {
    (this.debug || this.debug_list_atn_decisions) && console.log("execATN decision " + e.decision + " exec LA(1)==" + this.getLookaheadName(i) + " line " + i.LT(1).line + ":" + i.LT(1).column);
    let o, l = n;
    this.debug && console.log("s0 = " + n);
    let L = i.LA(1);
    for (; ; ) {
      let a = this.getExistingTargetState(l, L);
      if (a === null && (a = this.computeTargetState(e, l, L)), a === V3.ERROR) {
        const C = this.noViableAlt(i, r, l.configs, s);
        if (i.seek(s), o = this.getSynValidOrSemInvalidAltThatFinishedDecisionEntryRule(l.configs, r), o !== l1.INVALID_ALT_NUMBER)
          return o;
        throw C;
      }
      if (a.requiresFullContext && this.predictionMode !== e1.SLL) {
        let C = null;
        if (a.predicates !== null) {
          this.debug && console.log("DFA state has preds in DFA sim LL failover");
          const d = i.index;
          if (d !== s && i.seek(s), C = this.evalSemanticContext(a.predicates, r, !0), C.length === 1)
            return this.debug && console.log("Full LL avoided"), C.minValue();
          d !== s && i.seek(d);
        }
        this.dfa_debug && console.log("ctx sensitive state " + r + " in " + a);
        const c = !0, h = this.computeStartState(e.atnStartState, r, c);
        return this.reportAttemptingFullContext(e, C, a.configs, s, i.index), o = this.execATNWithFullContext(e, a, h, i, s, r), o;
      }
      if (a.isAcceptState) {
        if (a.predicates === null)
          return a.prediction;
        const C = i.index;
        i.seek(s);
        const c = this.evalSemanticContext(a.predicates, r, !0);
        if (c.length === 0)
          throw this.noViableAlt(i, r, a.configs, s);
        return c.length === 1 || this.reportAmbiguity(e, a, s, C, !1, c, a.configs), c.minValue();
      }
      l = a, L !== j.EOF && (i.consume(), L = i.LA(1));
    }
  }
  /**
   * Get an existing target state for an edge in the DFA. If the target state
   * for the edge has not yet been computed or is otherwise not available,
   * this method returns {@code null}.
   *
   * @param previousD The current DFA state
   * @param t The next input symbol
   * @return The existing target DFA state for the given input symbol
   * {@code t}, or {@code null} if the target state for this edge is not
   * already cached
   */
  getExistingTargetState(e, n) {
    const i = e.edges;
    return i === null ? null : i[n + 1] || null;
  }
  /**
   * Compute a target state for an edge in the DFA, and attempt to add the
   * computed state and corresponding edge to the DFA.
   *
   * @param dfa The DFA
   * @param previousD The current DFA state
   * @param t The next input symbol
   *
   * @return The computed target DFA state for the given input symbol
   * {@code t}. If {@code t} does not lead to a valid DFA state, this method
   * returns {@link //ERROR
   */
  computeTargetState(e, n, i) {
    const s = this.computeReachSet(n.configs, i, !1);
    if (s === null)
      return this.addDFAEdge(e, n, i, V3.ERROR), V3.ERROR;
    let r = new h4(null, s);
    const o = this.getUniqueAlt(s);
    if (this.debug) {
      const l = e1.getConflictingAltSubsets(s);
      console.log("SLL altSubSets=" + S4(l) + /*", previous=" + previousD.configs + */
      ", configs=" + s + ", predict=" + o + ", allSubsetsConflict=" + e1.allSubsetsConflict(l) + ", conflictingAlts=" + this.getConflictingAlts(s));
    }
    return o !== l1.INVALID_ALT_NUMBER ? (r.isAcceptState = !0, r.configs.uniqueAlt = o, r.prediction = o) : e1.hasSLLConflictTerminatingPrediction(this.predictionMode, s) && (r.configs.conflictingAlts = this.getConflictingAlts(s), r.requiresFullContext = !0, r.isAcceptState = !0, r.prediction = r.configs.conflictingAlts.minValue()), r.isAcceptState && r.configs.hasSemanticContext && (this.predicateDFAState(r, this.atn.getDecisionState(e.decision)), r.predicates !== null && (r.prediction = l1.INVALID_ALT_NUMBER)), r = this.addDFAEdge(e, n, i, r), r;
  }
  predicateDFAState(e, n) {
    const i = n.transitions.length, s = this.getConflictingAltsOrUniqueAlt(e.configs), r = this.getPredsForAmbigAlts(s, e.configs, i);
    r !== null ? (e.predicates = this.getPredicatePredictions(s, r), e.prediction = l1.INVALID_ALT_NUMBER) : e.prediction = s.minValue();
  }
  // comes back with reach.uniqueAlt set to a valid alt
  execATNWithFullContext(e, n, i, s, r, o) {
    (this.debug || this.debug_list_atn_decisions) && console.log("execATNWithFullContext " + i);
    const l = !0;
    let L = !1, a, C = i;
    s.seek(r);
    let c = s.LA(1), h = -1;
    for (; ; ) {
      if (a = this.computeReachSet(C, c, l), a === null) {
        const f = this.noViableAlt(s, o, C, r);
        s.seek(r);
        const x = this.getSynValidOrSemInvalidAltThatFinishedDecisionEntryRule(C, o);
        if (x !== l1.INVALID_ALT_NUMBER)
          return x;
        throw f;
      }
      const d = e1.getConflictingAltSubsets(a);
      if (this.debug && console.log("LL altSubSets=" + d + ", predict=" + e1.getUniqueAlt(d) + ", resolvesToJustOneViableAlt=" + e1.resolvesToJustOneViableAlt(d)), a.uniqueAlt = this.getUniqueAlt(a), a.uniqueAlt !== l1.INVALID_ALT_NUMBER) {
        h = a.uniqueAlt;
        break;
      } else if (this.predictionMode !== e1.LL_EXACT_AMBIG_DETECTION) {
        if (h = e1.resolvesToJustOneViableAlt(d), h !== l1.INVALID_ALT_NUMBER)
          break;
      } else if (e1.allSubsetsConflict(d) && e1.allSubsetsEqual(d)) {
        L = !0, h = e1.getSingleViableAlt(d);
        break;
      }
      C = a, c !== j.EOF && (s.consume(), c = s.LA(1));
    }
    return a.uniqueAlt !== l1.INVALID_ALT_NUMBER ? (this.reportContextSensitivity(e, h, a, r, s.index), h) : (this.reportAmbiguity(e, n, r, s.index, L, null, a), h);
  }
  computeReachSet(e, n, i) {
    this.debug && console.log("in computeReachSet, starting closure: " + e), this.mergeCache === null && (this.mergeCache = new jd());
    const s = new U1(i);
    let r = null;
    for (let l = 0; l < e.items.length; l++) {
      const L = e.items[l];
      if (this.debug && console.log("testing " + this.getTokenName(n) + " at " + L), L.state instanceof H1) {
        (i || n === j.EOF) && (r === null && (r = []), r.push(L), this.debug_add && console.log("added " + L + " to skippedStopStates"));
        continue;
      }
      for (let a = 0; a < L.state.transitions.length; a++) {
        const C = L.state.transitions[a], c = this.getReachableTarget(C, n);
        if (c !== null) {
          const h = new c1({ state: c }, L);
          s.add(h, this.mergeCache), this.debug_add && console.log("added " + h + " to intermediate");
        }
      }
    }
    let o = null;
    if (r === null && n !== j.EOF && (s.items.length === 1 || this.getUniqueAlt(s) !== l1.INVALID_ALT_NUMBER) && (o = s), o === null) {
      o = new U1(i);
      const l = new w3(), L = n === j.EOF;
      for (let a = 0; a < s.items.length; a++)
        this.closure(s.items[a], o, l, !1, i, L);
    }
    if (n === j.EOF && (o = this.removeAllConfigsNotInRuleStopState(o, o === s)), r !== null && (!i || !e1.hasConfigInRuleStopState(o)))
      for (let l = 0; l < r.length; l++)
        o.add(r[l], this.mergeCache);
    return o.items.length === 0 ? null : o;
  }
  /**
   * Return a configuration set containing only the configurations from
   * {@code configs} which are in a {@link RuleStopState}. If all
   * configurations in {@code configs} are already in a rule stop state, this
   * method simply returns {@code configs}.
   *
   * <p>When {@code lookToEndOfRule} is true, this method uses
   * {@link ATN//nextTokens} for each configuration in {@code configs} which is
   * not already in a rule stop state to see if a rule stop state is reachable
   * from the configuration via epsilon-only transitions.</p>
   *
   * @param configs the configuration set to update
   * @param lookToEndOfRule when true, this method checks for rule stop states
   * reachable by epsilon-only transitions from each configuration in
   * {@code configs}.
   *
   * @return {@code configs} if all configurations in {@code configs} are in a
   * rule stop state, otherwise return a new configuration set containing only
   * the configurations from {@code configs} which are in a rule stop state
   */
  removeAllConfigsNotInRuleStopState(e, n) {
    if (e1.allConfigsInRuleStopStates(e))
      return e;
    const i = new U1(e.fullCtx);
    for (let s = 0; s < e.items.length; s++) {
      const r = e.items[s];
      if (r.state instanceof H1) {
        i.add(r, this.mergeCache);
        continue;
      }
      if (n && r.state.epsilonOnlyTransitions && this.atn.nextTokens(r.state).contains(j.EPSILON)) {
        const l = this.atn.ruleToStopState[r.state.ruleIndex];
        i.add(new c1({ state: l }, r), this.mergeCache);
      }
    }
    return i;
  }
  computeStartState(e, n, i) {
    const s = Ge(this.atn, n), r = new U1(i);
    for (let o = 0; o < e.transitions.length; o++) {
      const l = e.transitions[o].target, L = new c1({ state: l, alt: o + 1, context: s }, null), a = new w3();
      this.closure(L, r, a, !0, i, !1);
    }
    return r;
  }
  /**
   * This method transforms the start state computed by
   * {@link //computeStartState} to the special start state used by a
   * precedence DFA for a particular precedence value. The transformation
   * process applies the following changes to the start state's configuration
   * set.
   *
   * <ol>
   * <li>Evaluate the precedence predicates for each configuration using
   * {@link SemanticContext//evalPrecedence}.</li>
   * <li>Remove all configurations which predict an alternative greater than
   * 1, for which another configuration that predicts alternative 1 is in the
   * same ATN state with the same prediction context. This transformation is
   * valid for the following reasons:
   * <ul>
   * <li>The closure block cannot contain any epsilon transitions which bypass
   * the body of the closure, so all states reachable via alternative 1 are
   * part of the precedence alternatives of the transformed left-recursive
   * rule.</li>
   * <li>The "primary" portion of a left recursive rule cannot contain an
   * epsilon transition, so the only way an alternative other than 1 can exist
   * in a state that is also reachable via alternative 1 is by nesting calls
   * to the left-recursive rule, with the outer calls not being at the
   * preferred precedence level.</li>
   * </ul>
   * </li>
   * </ol>
   *
   * <p>
   * The prediction context must be considered by this filter to address
   * situations like the following.
   * </p>
   * <code>
   * <pre>
   * grammar TA;
   * prog: statement* EOF;
   * statement: letterA | statement letterA 'b' ;
   * letterA: 'a';
   * </pre>
   * </code>
   * <p>
   * If the above grammar, the ATN state immediately before the token
   * reference {@code 'a'} in {@code letterA} is reachable from the left edge
   * of both the primary and closure blocks of the left-recursive rule
   * {@code statement}. The prediction context associated with each of these
   * configurations distinguishes between them, and prevents the alternative
   * which stepped out to {@code prog} (and then back in to {@code statement}
   * from being eliminated by the filter.
   * </p>
   *
   * @param configs The configuration set computed by
   * {@link //computeStartState} as the start state for the DFA.
   * @return The transformed configuration set representing the start state
   * for a precedence DFA at a particular precedence level (determined by
   * calling {@link Parser//getPrecedence})
   */
  applyPrecedenceFilter(e) {
    let n;
    const i = [], s = new U1(e.fullCtx);
    for (let r = 0; r < e.items.length; r++) {
      if (n = e.items[r], n.alt !== 1)
        continue;
      const o = n.semanticContext.evalPrecedence(this.parser, this._outerContext);
      o !== null && (i[n.state.stateNumber] = n.context, o !== n.semanticContext ? s.add(new c1({ semanticContext: o }, n), this.mergeCache) : s.add(n, this.mergeCache));
    }
    for (let r = 0; r < e.items.length; r++)
      if (n = e.items[r], n.alt !== 1) {
        if (!n.precedenceFilterSuppressed) {
          const o = i[n.state.stateNumber] || null;
          if (o !== null && o.equals(n.context))
            continue;
        }
        s.add(n, this.mergeCache);
      }
    return s;
  }
  getReachableTarget(e, n) {
    return e.matches(n, 0, this.atn.maxTokenType) ? e.target : null;
  }
  getPredsForAmbigAlts(e, n, i) {
    let s = [];
    for (let o = 0; o < n.items.length; o++) {
      const l = n.items[o];
      e.has(l.alt) && (s[l.alt] = j2.orContext(s[l.alt] || null, l.semanticContext));
    }
    let r = 0;
    for (let o = 1; o < i + 1; o++) {
      const l = s[o] || null;
      l === null ? s[o] = j2.NONE : l !== j2.NONE && (r += 1);
    }
    return r === 0 && (s = null), this.debug && console.log("getPredsForAmbigAlts result " + S4(s)), s;
  }
  getPredicatePredictions(e, n) {
    const i = [];
    let s = !1;
    for (let r = 1; r < n.length; r++) {
      const o = n[r];
      e !== null && e.has(r) && i.push(new ll(o, r)), o !== j2.NONE && (s = !0);
    }
    return s ? i : null;
  }
  /**
   * This method is used to improve the localization of error messages by
   * choosing an alternative rather than throwing a
   * {@link NoViableAltException} in particular prediction scenarios where the
   * {@link //ERROR} state was reached during ATN simulation.
   *
   * <p>
   * The default implementation of this method uses the following
   * algorithm to identify an ATN configuration which successfully parsed the
   * decision entry rule. Choosing such an alternative ensures that the
   * {@link ParserRuleContext} returned by the calling rule will be complete
   * and valid, and the syntax error will be reported later at a more
   * localized location.</p>
   *
   * <ul>
   * <li>If a syntactically valid path or paths reach the end of the decision rule and
   * they are semantically valid if predicated, return the min associated alt.</li>
   * <li>Else, if a semantically invalid but syntactically valid path exist
   * or paths exist, return the minimum associated alt.
   * </li>
   * <li>Otherwise, return {@link ATN//INVALID_ALT_NUMBER}.</li>
   * </ul>
   *
   * <p>
   * In some scenarios, the algorithm described above could predict an
   * alternative which will result in a {@link FailedPredicateException} in
   * the parser. Specifically, this could occur if the <em>only</em> configuration
   * capable of successfully parsing to the end of the decision rule is
   * blocked by a semantic predicate. By choosing this alternative within
   * {@link //adaptivePredict} instead of throwing a
   * {@link NoViableAltException}, the resulting
   * {@link FailedPredicateException} in the parser will identify the specific
   * predicate which is preventing the parser from successfully parsing the
   * decision rule, which helps developers identify and correct logic errors
   * in semantic predicates.
   * </p>
   *
   * @param configs The ATN configurations which were valid immediately before
   * the {@link //ERROR} state was reached
   * @param outerContext The is the \gamma_0 initial parser context from the paper
   * or the parser stack at the instant before prediction commences.
   *
   * @return The value to return from {@link //adaptivePredict}, or
   * {@link ATN//INVALID_ALT_NUMBER} if a suitable alternative was not
   * identified and {@link //adaptivePredict} should report an error instead
   */
  getSynValidOrSemInvalidAltThatFinishedDecisionEntryRule(e, n) {
    const i = this.splitAccordingToSemanticValidity(e, n), s = i[0], r = i[1];
    let o = this.getAltThatFinishedDecisionEntryRule(s);
    return o !== l1.INVALID_ALT_NUMBER || r.items.length > 0 && (o = this.getAltThatFinishedDecisionEntryRule(r), o !== l1.INVALID_ALT_NUMBER) ? o : l1.INVALID_ALT_NUMBER;
  }
  getAltThatFinishedDecisionEntryRule(e) {
    const n = [];
    for (let i = 0; i < e.items.length; i++) {
      const s = e.items[i];
      (s.reachesIntoOuterContext > 0 || s.state instanceof H1 && s.context.hasEmptyPath()) && n.indexOf(s.alt) < 0 && n.push(s.alt);
    }
    return n.length === 0 ? l1.INVALID_ALT_NUMBER : Math.min.apply(null, n);
  }
  /**
   * Walk the list of configurations and split them according to
   * those that have preds evaluating to true/false.  If no pred, assume
   * true pred and include in succeeded set.  Returns Pair of sets.
   *
   * Create a new set so as not to alter the incoming parameter.
   *
   * Assumption: the input stream has been restored to the starting point
   * prediction, which is where predicates need to evaluate.*/
  splitAccordingToSemanticValidity(e, n) {
    const i = new U1(e.fullCtx), s = new U1(e.fullCtx);
    for (let r = 0; r < e.items.length; r++) {
      const o = e.items[r];
      o.semanticContext !== j2.NONE ? o.semanticContext.evaluate(this.parser, n) ? i.add(o) : s.add(o) : i.add(o);
    }
    return [i, s];
  }
  /**
   * Look through a list of predicate/alt pairs, returning alts for the
   * pairs that win. A {@code NONE} predicate indicates an alt containing an
   * unpredicated config which behaves as "always true." If !complete
   * then we stop at the first predicate that evaluates to true. This
   * includes pairs with null predicates.
   */
  evalSemanticContext(e, n, i) {
    const s = new K3();
    for (let r = 0; r < e.length; r++) {
      const o = e[r];
      if (o.pred === j2.NONE) {
        if (s.add(o.alt), !i)
          break;
        continue;
      }
      const l = o.pred.evaluate(this.parser, n);
      if ((this.debug || this.dfa_debug) && console.log("eval pred " + o + "=" + l), l && ((this.debug || this.dfa_debug) && console.log("PREDICT " + o.alt), s.add(o.alt), !i))
        break;
    }
    return s;
  }
  // TODO: If we are doing predicates, there is no point in pursuing
  //     closure operations if we reach a DFA state that uniquely predicts
  //     alternative. We will not be caching that DFA state and it is a
  //     waste to pursue the closure. Might have to advance when we do
  //     ambig detection thought :(
  //
  closure(e, n, i, s, r, o) {
    this.closureCheckingStopState(
      e,
      n,
      i,
      s,
      r,
      0,
      o
    );
  }
  closureCheckingStopState(e, n, i, s, r, o, l) {
    if ((this.debug || this.debug_closure) && (console.log("closure(" + e.toString(this.parser, !0) + ")"), e.reachesIntoOuterContext > 50))
      throw "problem";
    if (e.state instanceof H1)
      if (e.context.isEmpty())
        if (r) {
          n.add(e, this.mergeCache);
          return;
        } else
          this.debug && console.log("FALLING off rule " + this.getRuleName(e.state.ruleIndex));
      else {
        for (let L = 0; L < e.context.length; L++) {
          if (e.context.getReturnState(L) === O2.EMPTY_RETURN_STATE) {
            if (r) {
              n.add(new c1({ state: e.state, context: O2.EMPTY }, e), this.mergeCache);
              continue;
            } else
              this.debug && console.log("FALLING off rule " + this.getRuleName(e.state.ruleIndex)), this.closure_(
                e,
                n,
                i,
                s,
                r,
                o,
                l
              );
            continue;
          }
          const a = this.atn.states[e.context.getReturnState(L)], C = e.context.getParent(L), c = { state: a, alt: e.alt, context: C, semanticContext: e.semanticContext }, h = new c1(c, null);
          h.reachesIntoOuterContext = e.reachesIntoOuterContext, this.closureCheckingStopState(h, n, i, s, r, o - 1, l);
        }
        return;
      }
    this.closure_(e, n, i, s, r, o, l);
  }
  // Do the actual work of walking epsilon edges//
  closure_(e, n, i, s, r, o, l) {
    const L = e.state;
    L.epsilonOnlyTransitions || n.add(e, this.mergeCache);
    for (let a = 0; a < L.transitions.length; a++) {
      if (a === 0 && this.canDropLoopEntryEdgeInLeftRecursiveRule(e))
        continue;
      const C = L.transitions[a], c = s && !(C instanceof sl), h = this.getEpsilonTarget(e, C, c, o === 0, r, l);
      if (h !== null) {
        let d = o;
        if (e.state instanceof H1) {
          if (this._dfa !== null && this._dfa.precedenceDfa && C.outermostPrecedenceReturn === this._dfa.atnStartState.ruleIndex && (h.precedenceFilterSuppressed = !0), h.reachesIntoOuterContext += 1, i.add(h) !== h)
            continue;
          n.dipsIntoOuterContext = !0, d -= 1, this.debug && console.log("dips into outer ctx: " + h);
        } else {
          if (!C.isEpsilon && i.add(h) !== h)
            continue;
          C instanceof l8 && d >= 0 && (d += 1);
        }
        this.closureCheckingStopState(h, n, i, c, r, d, l);
      }
    }
  }
  canDropLoopEntryEdgeInLeftRecursiveRule(e) {
    const n = e.state;
    if (n.stateType !== c2.STAR_LOOP_ENTRY || n.stateType !== c2.STAR_LOOP_ENTRY || !n.isPrecedenceDecision || e.context.isEmpty() || e.context.hasEmptyPath())
      return !1;
    const i = e.context.length;
    for (let l = 0; l < i; l++)
      if (this.atn.states[e.context.getReturnState(l)].ruleIndex !== n.ruleIndex)
        return !1;
    const r = n.transitions[0].target.endState.stateNumber, o = this.atn.states[r];
    for (let l = 0; l < i; l++) {
      const L = e.context.getReturnState(l), a = this.atn.states[L];
      if (a.transitions.length !== 1 || !a.transitions[0].isEpsilon)
        return !1;
      const C = a.transitions[0].target;
      if (!(a.stateType === c2.BLOCK_END && C === n) && a !== o && C !== o && !(C.stateType === c2.BLOCK_END && C.transitions.length === 1 && C.transitions[0].isEpsilon && C.transitions[0].target === n))
        return !1;
    }
    return !0;
  }
  getRuleName(e) {
    return this.parser !== null && e >= 0 ? this.parser.ruleNames[e] : "<rule " + e + ">";
  }
  getEpsilonTarget(e, n, i, s, r, o) {
    switch (n.serializationType) {
      case a2.RULE:
        return this.ruleTransition(e, n);
      case a2.PRECEDENCE:
        return this.precedenceTransition(e, n, i, s, r);
      case a2.PREDICATE:
        return this.predTransition(e, n, i, s, r);
      case a2.ACTION:
        return this.actionTransition(e, n);
      case a2.EPSILON:
        return new c1({ state: n.target }, e);
      case a2.ATOM:
      case a2.RANGE:
      case a2.SET:
        return o && n.matches(j.EOF, 0, 1) ? new c1({ state: n.target }, e) : null;
      default:
        return null;
    }
  }
  actionTransition(e, n) {
    if (this.debug) {
      const i = n.actionIndex === -1 ? 65535 : n.actionIndex;
      console.log("ACTION edge " + n.ruleIndex + ":" + i);
    }
    return new c1({ state: n.target }, e);
  }
  precedenceTransition(e, n, i, s, r) {
    this.debug && (console.log("PRED (collectPredicates=" + i + ") " + n.precedence + ">=_p, ctx dependent=true"), this.parser !== null && console.log("context surrounding pred is " + S4(this.parser.getRuleInvocationStack())));
    let o = null;
    if (i && s)
      if (r) {
        const l = this._input.index;
        this._input.seek(this._startIndex);
        const L = n.getPredicate().evaluate(this.parser, this._outerContext);
        this._input.seek(l), L && (o = new c1({ state: n.target }, e));
      } else {
        const l = j2.andContext(e.semanticContext, n.getPredicate());
        o = new c1({ state: n.target, semanticContext: l }, e);
      }
    else
      o = new c1({ state: n.target }, e);
    return this.debug && console.log("config from pred transition=" + o), o;
  }
  predTransition(e, n, i, s, r) {
    this.debug && (console.log("PRED (collectPredicates=" + i + ") " + n.ruleIndex + ":" + n.predIndex + ", ctx dependent=" + n.isCtxDependent), this.parser !== null && console.log("context surrounding pred is " + S4(this.parser.getRuleInvocationStack())));
    let o = null;
    if (i && (n.isCtxDependent && s || !n.isCtxDependent))
      if (r) {
        const l = this._input.index;
        this._input.seek(this._startIndex);
        const L = n.getPredicate().evaluate(this.parser, this._outerContext);
        this._input.seek(l), L && (o = new c1({ state: n.target }, e));
      } else {
        const l = j2.andContext(e.semanticContext, n.getPredicate());
        o = new c1({ state: n.target, semanticContext: l }, e);
      }
    else
      o = new c1({ state: n.target }, e);
    return this.debug && console.log("config from pred transition=" + o), o;
  }
  ruleTransition(e, n) {
    this.debug && console.log("CALL rule " + this.getRuleName(n.target.ruleIndex) + ", ctx=" + e.context);
    const i = n.followState, s = $1.create(e.context, i.stateNumber);
    return new c1({ state: n.target, context: s }, e);
  }
  getConflictingAlts(e) {
    const n = e1.getConflictingAltSubsets(e);
    return e1.getAlts(n);
  }
  /**
   * Sam pointed out a problem with the previous definition, v3, of
   * ambiguous states. If we have another state associated with conflicting
   * alternatives, we should keep going. For example, the following grammar
   *
   * s : (ID | ID ID?) ';' ;
   *
   * When the ATN simulation reaches the state before ';', it has a DFA
   * state that looks like: [12|1|[], 6|2|[], 12|2|[]]. Naturally
   * 12|1|[] and 12|2|[] conflict, but we cannot stop processing this node
   * because alternative to has another way to continue, via [6|2|[]].
   * The key is that we have a single state that has config's only associated
   * with a single alternative, 2, and crucially the state transitions
   * among the configurations are all non-epsilon transitions. That means
   * we don't consider any conflicts that include alternative 2. So, we
   * ignore the conflict between alts 1 and 2. We ignore a set of
   * conflicting alts when there is an intersection with an alternative
   * associated with a single alt state in the state&rarr;config-list map.
   *
   * It's also the case that we might have two conflicting configurations but
   * also a 3rd nonconflicting configuration for a different alternative:
   * [1|1|[], 1|2|[], 8|3|[]]. This can come about from grammar:
   *
   * a : A | A | A B ;
   *
   * After matching input A, we reach the stop state for rule A, state 1.
   * State 8 is the state right before B. Clearly alternatives 1 and 2
   * conflict and no amount of further lookahead will separate the two.
   * However, alternative 3 will be able to continue and so we do not
   * stop working on this state. In the previous example, we're concerned
   * with states associated with the conflicting alternatives. Here alt
   * 3 is not associated with the conflicting configs, but since we can continue
   * looking for input reasonably, I don't declare the state done. We
   * ignore a set of conflicting alts when we have an alternative
   * that we still need to pursue
   */
  getConflictingAltsOrUniqueAlt(e) {
    let n = null;
    return e.uniqueAlt !== l1.INVALID_ALT_NUMBER ? (n = new K3(), n.add(e.uniqueAlt)) : n = e.conflictingAlts, n;
  }
  getTokenName(e) {
    if (e === j.EOF)
      return "EOF";
    if (this.parser !== null && this.parser.literalNames !== null)
      if (e >= this.parser.literalNames.length && e >= this.parser.symbolicNames.length)
        console.log("" + e + " ttype out of range: " + this.parser.literalNames), console.log("" + this.parser.getInputStream().getTokens());
      else
        return (this.parser.literalNames[e] || this.parser.symbolicNames[e]) + "<" + e + ">";
    return "" + e;
  }
  getLookaheadName(e) {
    return this.getTokenName(e.LA(1));
  }
  /**
   * Used for debugging in adaptivePredict around execATN but I cut
   * it out for clarity now that alg. works well. We can leave this
   * "dead" code for a bit
   */
  dumpDeadEndConfigs(e) {
    console.log("dead end configs: ");
    const n = e.getDeadEndConfigs();
    for (let i = 0; i < n.length; i++) {
      const s = n[i];
      let r = "no edges";
      if (s.state.transitions.length > 0) {
        const o = s.state.transitions[0];
        o instanceof K5 ? r = "Atom " + this.getTokenName(o.label) : o instanceof He && (r = (o instanceof $e ? "~" : "") + "Set " + o.set);
      }
      console.error(s.toString(this.parser, !0) + ":" + r);
    }
  }
  noViableAlt(e, n, i, s) {
    return new et(this.parser, e, e.get(s), e.LT(1), i, n);
  }
  getUniqueAlt(e) {
    let n = l1.INVALID_ALT_NUMBER;
    for (let i = 0; i < e.items.length; i++) {
      const s = e.items[i];
      if (n === l1.INVALID_ALT_NUMBER)
        n = s.alt;
      else if (s.alt !== n)
        return l1.INVALID_ALT_NUMBER;
    }
    return n;
  }
  /**
   * Add an edge to the DFA, if possible. This method calls
   * {@link //addDFAState} to ensure the {@code to} state is present in the
   * DFA. If {@code from} is {@code null}, or if {@code t} is outside the
   * range of edges that can be represented in the DFA tables, this method
   * returns without adding the edge to the DFA.
   *
   * <p>If {@code to} is {@code null}, this method returns {@code null}.
   * Otherwise, this method returns the {@link DFAState} returned by calling
   * {@link //addDFAState} for the {@code to} state.</p>
   *
   * @param dfa The DFA
   * @param from_ The source state for the edge
   * @param t The input symbol
   * @param to The target state for the edge
   *
   * @return If {@code to} is {@code null}, this method returns {@code null};
   * otherwise this method returns the result of calling {@link //addDFAState}
   * on {@code to}
   */
  addDFAEdge(e, n, i, s) {
    if (this.debug && console.log("EDGE " + n + " -> " + s + " upon " + this.getTokenName(i)), s === null)
      return null;
    if (s = this.addDFAState(e, s), n === null || i < -1 || i > this.atn.maxTokenType)
      return s;
    if (n.edges === null && (n.edges = []), n.edges[i + 1] = s, this.debug) {
      const r = this.parser === null ? null : this.parser.literalNames, o = this.parser === null ? null : this.parser.symbolicNames;
      console.log(`DFA=
` + e.toString(r, o));
    }
    return s;
  }
  /**
   * Add state {@code D} to the DFA if it is not already present, and return
   * the actual instance stored in the DFA. If a state equivalent to {@code D}
   * is already in the DFA, the existing state is returned. Otherwise this
   * method returns {@code D} after adding it to the DFA.
   *
   * <p>If {@code D} is {@link //ERROR}, this method returns {@link //ERROR} and
   * does not change the DFA.</p>
   *
   * @param dfa The dfa
   * @param D The DFA state to add
   * @return The state stored in the DFA. This will be either the existing
   * state if {@code D} is already in the DFA, or {@code D} itself if the
   * state was not already present
   */
  addDFAState(e, n) {
    if (n === V3.ERROR)
      return n;
    const i = e.states.get(n);
    return i !== null ? i : (n.stateNumber = e.states.length, n.configs.readOnly || (n.configs.optimizeConfigs(this), n.configs.setReadonly(!0)), e.states.add(n), this.debug && console.log("adding new DFA state: " + n), n);
  }
  reportAttemptingFullContext(e, n, i, s, r) {
    if (this.debug || this.retry_debug) {
      const o = new G2(s, r + 1);
      console.log("reportAttemptingFullContext decision=" + e.decision + ":" + i + ", input=" + this.parser.getTokenStream().getText(o));
    }
    this.parser !== null && this.parser.getErrorListenerDispatch().reportAttemptingFullContext(this.parser, e, s, r, n, i);
  }
  reportContextSensitivity(e, n, i, s, r) {
    if (this.debug || this.retry_debug) {
      const o = new G2(s, r + 1);
      console.log("reportContextSensitivity decision=" + e.decision + ":" + i + ", input=" + this.parser.getTokenStream().getText(o));
    }
    this.parser !== null && this.parser.getErrorListenerDispatch().reportContextSensitivity(this.parser, e, s, r, n, i);
  }
  // If context sensitive parsing, we know it's ambiguity not conflict//
  reportAmbiguity(e, n, i, s, r, o, l) {
    if (this.debug || this.retry_debug) {
      const L = new G2(i, s + 1);
      console.log("reportAmbiguity " + o + ":" + l + ", input=" + this.parser.getTokenStream().getText(L));
    }
    this.parser !== null && this.parser.getErrorListenerDispatch().reportAmbiguity(this.parser, e, i, s, r, o, l);
  }
}
const Kd = { ATN: l1, ATNDeserializer: ol, LexerATNSimulator: L1, ParserATNSimulator: qd, PredictionMode: e1 };
class tt {
  constructor(e, n, i) {
    this.dfa = e, this.literalNames = n || [], this.symbolicNames = i || [];
  }
  toString() {
    if (this.dfa.s0 === null)
      return null;
    let e = "";
    const n = this.dfa.sortedStates();
    for (let i = 0; i < n.length; i++) {
      const s = n[i];
      if (s.edges !== null) {
        const r = s.edges.length;
        for (let o = 0; o < r; o++) {
          const l = s.edges[o] || null;
          l !== null && l.stateNumber !== 2147483647 && (e = e.concat(this.getStateString(s)), e = e.concat("-"), e = e.concat(this.getEdgeLabel(o)), e = e.concat("->"), e = e.concat(this.getStateString(l)), e = e.concat(`
`));
        }
      }
    }
    return e.length === 0 ? null : e;
  }
  getEdgeLabel(e) {
    return e === 0 ? "EOF" : this.literalNames !== null || this.symbolicNames !== null ? this.literalNames[e - 1] || this.symbolicNames[e - 1] : String.fromCharCode(e - 1);
  }
  getStateString(e) {
    const n = (e.isAcceptState ? ":" : "") + "s" + e.stateNumber + (e.requiresFullContext ? "^" : "");
    return e.isAcceptState ? e.predicates !== null ? n + "=>" + S4(e.predicates) : n + "=>" + e.prediction.toString() : n;
  }
}
class Ll extends tt {
  constructor(e) {
    super(e, null);
  }
  getEdgeLabel(e) {
    return "'" + String.fromCharCode(e) + "'";
  }
}
class Yd {
  constructor(e, n) {
    if (n === void 0 && (n = 0), this.atnStartState = e, this.decision = n, this._states = new w3(), this.s0 = null, this.precedenceDfa = !1, e instanceof q4 && e.isPrecedenceDecision) {
      this.precedenceDfa = !0;
      const i = new h4(null, new U1());
      i.edges = [], i.isAcceptState = !1, i.requiresFullContext = !1, this.s0 = i;
    }
  }
  /**
   * Get the start state for a specific precedence value.
   *
   * @param precedence The current precedence.
   * @return The start state corresponding to the specified precedence, or
   * {@code null} if no start state exists for the specified precedence.
   *
   * @throws IllegalStateException if this is not a precedence DFA.
   * @see //isPrecedenceDfa()
   */
  getPrecedenceStartState(e) {
    if (!this.precedenceDfa)
      throw "Only precedence DFAs may contain a precedence start state.";
    return e < 0 || e >= this.s0.edges.length ? null : this.s0.edges[e] || null;
  }
  /**
   * Set the start state for a specific precedence value.
   *
   * @param precedence The current precedence.
   * @param startState The start state corresponding to the specified
   * precedence.
   *
   * @throws IllegalStateException if this is not a precedence DFA.
   * @see //isPrecedenceDfa()
   */
  setPrecedenceStartState(e, n) {
    if (!this.precedenceDfa)
      throw "Only precedence DFAs may contain a precedence start state.";
    e < 0 || (this.s0.edges[e] = n);
  }
  /**
   * Sets whether this is a precedence DFA. If the specified value differs
   * from the current DFA configuration, the following actions are taken;
   * otherwise no changes are made to the current DFA.
   *
   * <ul>
   * <li>The {@link //states} map is cleared</li>
   * <li>If {@code precedenceDfa} is {@code false}, the initial state
   * {@link //s0} is set to {@code null}; otherwise, it is initialized to a new
   * {@link DFAState} with an empty outgoing {@link DFAState//edges} array to
   * store the start states for individual precedence values.</li>
   * <li>The {@link //precedenceDfa} field is updated</li>
   * </ul>
   *
   * @param precedenceDfa {@code true} if this is a precedence DFA; otherwise,
   * {@code false}
   */
  setPrecedenceDfa(e) {
    if (this.precedenceDfa !== e) {
      if (this._states = new w3(), e) {
        const n = new h4(null, new U1());
        n.edges = [], n.isAcceptState = !1, n.requiresFullContext = !1, this.s0 = n;
      } else
        this.s0 = null;
      this.precedenceDfa = e;
    }
  }
  /**
   * Return a list of all states in this DFA, ordered by state number.
   */
  sortedStates() {
    return this._states.values().sort(function(n, i) {
      return n.stateNumber - i.stateNumber;
    });
  }
  toString(e, n) {
    return e = e || null, n = n || null, this.s0 === null ? "" : new tt(this, e, n).toString();
  }
  toLexerString() {
    return this.s0 === null ? "" : new Ll(this).toString();
  }
  get states() {
    return this._states;
  }
}
const Qd = { DFA: Yd, DFASerializer: tt, LexerDFASerializer: Ll, PredPrediction: ll };
class al {
  visitTerminal(e) {
  }
  visitErrorNode(e) {
  }
  enterEveryRule(e) {
  }
  exitEveryRule(e) {
  }
}
class Xd {
  visit(e) {
    return Array.isArray(e) ? e.map(function(n) {
      return n.accept(this);
    }, this) : e.accept(this);
  }
  visitChildren(e) {
    return e.children ? this.visit(e.children) : null;
  }
  visitTerminal(e) {
  }
  visitErrorNode(e) {
  }
}
class F6 {
  /**
   * Performs a walk on the given parse tree starting at the root and going down recursively
   * with depth-first search. On each node, {@link ParseTreeWalker//enterRule} is called before
   * recursively walking down into child nodes, then
   * {@link ParseTreeWalker//exitRule} is called after the recursive call to wind up.
   * @param listener The listener used by the walker to process grammar rules
   * @param t The parse tree to be walked on
   */
  walk(e, n) {
    if (n instanceof K8 || n.isErrorNode !== void 0 && n.isErrorNode())
      e.visitErrorNode(n);
    else if (n instanceof f4)
      e.visitTerminal(n);
    else {
      this.enterRule(e, n);
      for (let s = 0; s < n.getChildCount(); s++) {
        const r = n.getChild(s);
        this.walk(e, r);
      }
      this.exitRule(e, n);
    }
  }
  /**
   * Enters a grammar rule by first triggering the generic event {@link ParseTreeListener//enterEveryRule}
   * then by triggering the event specific to the given parse tree node
   * @param listener The listener responding to the trigger events
   * @param r The grammar rule containing the rule context
   */
  enterRule(e, n) {
    const i = n.getRuleContext();
    e.enterEveryRule(i), i.enterRule(e);
  }
  /**
   * Exits a grammar rule by first triggering the event specific to the given parse tree node
   * then by triggering the generic event {@link ParseTreeListener//exitEveryRule}
   * @param listener The listener responding to the trigger events
   * @param r The grammar rule containing the rule context
   */
  exitRule(e, n) {
    const i = n.getRuleContext();
    i.exitRule(e), e.exitEveryRule(i);
  }
}
F6.DEFAULT = new F6();
const Jd = { Trees: U3, RuleNode: L8, ErrorNode: K8, TerminalNode: f4, ParseTreeListener: al, ParseTreeVisitor: Xd, ParseTreeWalker: F6 };
class T0 extends H4 {
  constructor(e) {
    super({ message: "", recognizer: e, input: e.getInputStream(), ctx: e._ctx }), this.offendingToken = e.getCurrentToken();
  }
}
class Cl extends H4 {
  constructor(e, n, i) {
    super({
      message: eg(n, i || null),
      recognizer: e,
      input: e.getInputStream(),
      ctx: e._ctx
    });
    const r = e._interp.atn.states[e.state].transitions[0];
    r instanceof rl ? (this.ruleIndex = r.ruleIndex, this.predicateIndex = r.predIndex) : (this.ruleIndex = 0, this.predicateIndex = 0), this.predicate = n, this.offendingToken = e.getCurrentToken();
  }
}
function eg(t, e) {
  return e !== null ? e : "failed predicate: {" + t + "}?";
}
class tg extends X8 {
  constructor(e) {
    super(), e = e || !0, this.exactOnly = e;
  }
  reportAmbiguity(e, n, i, s, r, o, l) {
    if (this.exactOnly && !r)
      return;
    const L = "reportAmbiguity d=" + this.getDecisionDescription(e, n) + ": ambigAlts=" + this.getConflictingAlts(o, l) + ", input='" + e.getTokenStream().getText(new G2(i, s)) + "'";
    e.notifyErrorListeners(L);
  }
  reportAttemptingFullContext(e, n, i, s, r, o) {
    const l = "reportAttemptingFullContext d=" + this.getDecisionDescription(e, n) + ", input='" + e.getTokenStream().getText(new G2(i, s)) + "'";
    e.notifyErrorListeners(l);
  }
  reportContextSensitivity(e, n, i, s, r, o) {
    const l = "reportContextSensitivity d=" + this.getDecisionDescription(e, n) + ", input='" + e.getTokenStream().getText(new G2(i, s)) + "'";
    e.notifyErrorListeners(l);
  }
  getDecisionDescription(e, n) {
    const i = n.decision, s = n.atnStartState.ruleIndex, r = e.ruleNames;
    if (s < 0 || s >= r.length)
      return "" + i;
    const o = r[s] || null;
    return o === null || o.length === 0 ? "" + i : `${i} (${o})`;
  }
  /**
   * Computes the set of conflicting or ambiguous alternatives from a
   * configuration set, if that information was not already provided by the
   * parser.
   *
   * @param reportedAlts The set of conflicting or ambiguous alternatives, as
   * reported by the parser.
   * @param configs The conflicting or ambiguous configuration set.
   * @return Returns {@code reportedAlts} if it is not {@code null}, otherwise
   * returns the set of alternatives represented in {@code configs}.
      */
  getConflictingAlts(e, n) {
    if (e !== null)
      return e;
    const i = new K3();
    for (let s = 0; s < n.items.length; s++)
      i.add(n.items[s].alt);
    return `{${i.values().join(", ")}}`;
  }
}
class nt extends Error {
  constructor() {
    super(), Error.captureStackTrace(this, nt);
  }
}
class ng {
  reset(e) {
  }
  recoverInline(e) {
  }
  recover(e, n) {
  }
  sync(e) {
  }
  inErrorRecoveryMode(e) {
  }
  reportError(e) {
  }
}
class it extends ng {
  constructor() {
    super(), this.errorRecoveryMode = !1, this.lastErrorIndex = -1, this.lastErrorStates = null, this.nextTokensContext = null, this.nextTokenState = 0;
  }
  /**
   * <p>The default implementation simply calls {@link //endErrorCondition} to
   * ensure that the handler is not in error recovery mode.</p>
   */
  reset(e) {
    this.endErrorCondition(e);
  }
  /**
   * This method is called to enter error recovery mode when a recognition
   * exception is reported.
   *
   * @param recognizer the parser instance
   */
  beginErrorCondition(e) {
    this.errorRecoveryMode = !0;
  }
  inErrorRecoveryMode(e) {
    return this.errorRecoveryMode;
  }
  /**
   * This method is called to leave error recovery mode after recovering from
   * a recognition exception.
   * @param recognizer
   */
  endErrorCondition(e) {
    this.errorRecoveryMode = !1, this.lastErrorStates = null, this.lastErrorIndex = -1;
  }
  /**
   * {@inheritDoc}
   * <p>The default implementation simply calls {@link //endErrorCondition}.</p>
   */
  reportMatch(e) {
    this.endErrorCondition(e);
  }
  /**
   * {@inheritDoc}
   *
   * <p>The default implementation returns immediately if the handler is already
   * in error recovery mode. Otherwise, it calls {@link //beginErrorCondition}
   * and dispatches the reporting task based on the runtime type of {@code e}
   * according to the following table.</p>
   *
   * <ul>
   * <li>{@link NoViableAltException}: Dispatches the call to
   * {@link //reportNoViableAlternative}</li>
   * <li>{@link InputMismatchException}: Dispatches the call to
   * {@link //reportInputMismatch}</li>
   * <li>{@link FailedPredicateException}: Dispatches the call to
   * {@link //reportFailedPredicate}</li>
   * <li>All other types: calls {@link Parser//notifyErrorListeners} to report
   * the exception</li>
   * </ul>
   */
  reportError(e, n) {
    this.inErrorRecoveryMode(e) || (this.beginErrorCondition(e), n instanceof et ? this.reportNoViableAlternative(e, n) : n instanceof T0 ? this.reportInputMismatch(e, n) : n instanceof Cl ? this.reportFailedPredicate(e, n) : (console.log("unknown recognition error type: " + n.constructor.name), console.log(n.stack), e.notifyErrorListeners(n.getOffendingToken(), n.getMessage(), n)));
  }
  /**
   *
   * {@inheritDoc}
   *
   * <p>The default implementation resynchronizes the parser by consuming tokens
   * until we find one in the resynchronization set--loosely the set of tokens
   * that can follow the current rule.</p>
   *
   */
  recover(e, n) {
    this.lastErrorIndex === e.getInputStream().index && this.lastErrorStates !== null && this.lastErrorStates.indexOf(e.state) >= 0 && e.consume(), this.lastErrorIndex = e._input.index, this.lastErrorStates === null && (this.lastErrorStates = []), this.lastErrorStates.push(e.state);
    const i = this.getErrorRecoverySet(e);
    this.consumeUntil(e, i);
  }
  /**
   * The default implementation of {@link ANTLRErrorStrategy//sync} makes sure
   * that the current lookahead symbol is consistent with what were expecting
   * at this point in the ATN. You can call this anytime but ANTLR only
   * generates code to check before subrules/loops and each iteration.
   *
   * <p>Implements Jim Idle's magic sync mechanism in closures and optional
   * subrules. E.g.,</p>
   *
   * <pre>
   * a : sync ( stuff sync )* ;
   * sync : {consume to what can follow sync} ;
   * </pre>
   *
   * At the start of a sub rule upon error, {@link //sync} performs single
   * token deletion, if possible. If it can't do that, it bails on the current
   * rule and uses the default error recovery, which consumes until the
   * resynchronization set of the current rule.
   *
   * <p>If the sub rule is optional ({@code (...)?}, {@code (...)*}, or block
   * with an empty alternative), then the expected set includes what follows
   * the subrule.</p>
   *
   * <p>During loop iteration, it consumes until it sees a token that can start a
   * sub rule or what follows loop. Yes, that is pretty aggressive. We opt to
   * stay in the loop as long as possible.</p>
   *
   * <p><strong>ORIGINS</strong></p>
   *
   * <p>Previous versions of ANTLR did a poor job of their recovery within loops.
   * A single mismatch token or missing token would force the parser to bail
   * out of the entire rules surrounding the loop. So, for rule</p>
   *
   * <pre>
   * classDef : 'class' ID '{' member* '}'
   * </pre>
   *
   * input with an extra token between members would force the parser to
   * consume until it found the next class definition rather than the next
   * member definition of the current class.
   *
   * <p>This functionality cost a little bit of effort because the parser has to
   * compare token set at the start of the loop and at each iteration. If for
   * some reason speed is suffering for you, you can turn off this
   * functionality by simply overriding this method as a blank { }.</p>
   *
   */
  sync(e) {
    if (this.inErrorRecoveryMode(e))
      return;
    const n = e._interp.atn.states[e.state], i = e.getTokenStream().LA(1), s = e.atn.nextTokens(n);
    if (s.contains(i)) {
      this.nextTokensContext = null, this.nextTokenState = c2.INVALID_STATE_NUMBER;
      return;
    } else if (s.contains(j.EPSILON)) {
      this.nextTokensContext === null && (this.nextTokensContext = e._ctx, this.nextTokensState = e._stateNumber);
      return;
    }
    switch (n.stateType) {
      case c2.BLOCK_START:
      case c2.STAR_BLOCK_START:
      case c2.PLUS_BLOCK_START:
      case c2.STAR_LOOP_ENTRY:
        if (this.singleTokenDeletion(e) !== null)
          return;
        throw new T0(e);
      case c2.PLUS_LOOP_BACK:
      case c2.STAR_LOOP_BACK:
        {
          this.reportUnwantedToken(e);
          const r = new S3();
          r.addSet(e.getExpectedTokens());
          const o = r.addSet(this.getErrorRecoverySet(e));
          this.consumeUntil(e, o);
        }
        break;
    }
  }
  /**
   * This is called by {@link //reportError} when the exception is a
   * {@link NoViableAltException}.
   *
   * @see //reportError
   *
   * @param recognizer the parser instance
   * @param e the recognition exception
   */
  reportNoViableAlternative(e, n) {
    const i = e.getTokenStream();
    let s;
    i !== null ? n.startToken.type === j.EOF ? s = "<EOF>" : s = i.getText(new G2(n.startToken.tokenIndex, n.offendingToken.tokenIndex)) : s = "<unknown input>";
    const r = "no viable alternative at input " + this.escapeWSAndQuote(s);
    e.notifyErrorListeners(r, n.offendingToken, n);
  }
  /**
   * This is called by {@link //reportError} when the exception is an
   * {@link InputMismatchException}.
   *
   * @see //reportError
   *
   * @param recognizer the parser instance
   * @param e the recognition exception
   */
  reportInputMismatch(e, n) {
    const i = "mismatched input " + this.getTokenErrorDisplay(n.offendingToken) + " expecting " + n.getExpectedTokens().toString(e.literalNames, e.symbolicNames);
    e.notifyErrorListeners(i, n.offendingToken, n);
  }
  /**
   * This is called by {@link //reportError} when the exception is a
   * {@link FailedPredicateException}.
   *
   * @see //reportError
   *
   * @param recognizer the parser instance
   * @param e the recognition exception
   */
  reportFailedPredicate(e, n) {
    const s = "rule " + e.ruleNames[e._ctx.ruleIndex] + " " + n.message;
    e.notifyErrorListeners(s, n.offendingToken, n);
  }
  /**
   * This method is called to report a syntax error which requires the removal
   * of a token from the input stream. At the time this method is called, the
   * erroneous symbol is current {@code LT(1)} symbol and has not yet been
   * removed from the input stream. When this method returns,
   * {@code recognizer} is in error recovery mode.
   *
   * <p>This method is called when {@link //singleTokenDeletion} identifies
   * single-token deletion as a viable recovery strategy for a mismatched
   * input error.</p>
   *
   * <p>The default implementation simply returns if the handler is already in
   * error recovery mode. Otherwise, it calls {@link //beginErrorCondition} to
   * enter error recovery mode, followed by calling
   * {@link Parser//notifyErrorListeners}.</p>
   *
   * @param recognizer the parser instance
   *
   */
  reportUnwantedToken(e) {
    if (this.inErrorRecoveryMode(e))
      return;
    this.beginErrorCondition(e);
    const n = e.getCurrentToken(), i = this.getTokenErrorDisplay(n), s = this.getExpectedTokens(e), r = "extraneous input " + i + " expecting " + s.toString(e.literalNames, e.symbolicNames);
    e.notifyErrorListeners(r, n, null);
  }
  /**
   * This method is called to report a syntax error which requires the
   * insertion of a missing token into the input stream. At the time this
   * method is called, the missing token has not yet been inserted. When this
   * method returns, {@code recognizer} is in error recovery mode.
   *
   * <p>This method is called when {@link //singleTokenInsertion} identifies
   * single-token insertion as a viable recovery strategy for a mismatched
   * input error.</p>
   *
   * <p>The default implementation simply returns if the handler is already in
   * error recovery mode. Otherwise, it calls {@link //beginErrorCondition} to
   * enter error recovery mode, followed by calling
   * {@link Parser//notifyErrorListeners}.</p>
   *
   * @param recognizer the parser instance
   */
  reportMissingToken(e) {
    if (this.inErrorRecoveryMode(e))
      return;
    this.beginErrorCondition(e);
    const n = e.getCurrentToken(), s = "missing " + this.getExpectedTokens(e).toString(e.literalNames, e.symbolicNames) + " at " + this.getTokenErrorDisplay(n);
    e.notifyErrorListeners(s, n, null);
  }
  /**
   * <p>The default implementation attempts to recover from the mismatched input
   * by using single token insertion and deletion as described below. If the
   * recovery attempt fails, this method throws an
   * {@link InputMismatchException}.</p>
   *
   * <p><strong>EXTRA TOKEN</strong> (single token deletion)</p>
   *
   * <p>{@code LA(1)} is not what we are looking for. If {@code LA(2)} has the
   * right token, however, then assume {@code LA(1)} is some extra spurious
   * token and delete it. Then consume and return the next token (which was
   * the {@code LA(2)} token) as the successful result of the match operation.</p>
   *
   * <p>This recovery strategy is implemented by {@link
      * //singleTokenDeletion}.</p>
   *
   * <p><strong>MISSING TOKEN</strong> (single token insertion)</p>
   *
   * <p>If current token (at {@code LA(1)}) is consistent with what could come
   * after the expected {@code LA(1)} token, then assume the token is missing
   * and use the parser's {@link TokenFactory} to create it on the fly. The
   * "insertion" is performed by returning the created token as the successful
   * result of the match operation.</p>
   *
   * <p>This recovery strategy is implemented by {@link
      * //singleTokenInsertion}.</p>
   *
   * <p><strong>EXAMPLE</strong></p>
   *
   * <p>For example, Input {@code i=(3;} is clearly missing the {@code ')'}. When
   * the parser returns from the nested call to {@code expr}, it will have
   * call chain:</p>
   *
   * <pre>
   * stat &rarr; expr &rarr; atom
   * </pre>
   *
   * and it will be trying to match the {@code ')'} at this point in the
   * derivation:
   *
   * <pre>
   * =&gt; ID '=' '(' INT ')' ('+' atom)* ';'
   * ^
   * </pre>
   *
   * The attempt to match {@code ')'} will fail when it sees {@code ';'} and
   * call {@link //recoverInline}. To recover, it sees that {@code LA(1)==';'}
   * is in the set of tokens that can follow the {@code ')'} token reference
   * in rule {@code atom}. It can assume that you forgot the {@code ')'}.
   */
  recoverInline(e) {
    const n = this.singleTokenDeletion(e);
    if (n !== null)
      return e.consume(), n;
    if (this.singleTokenInsertion(e))
      return this.getMissingSymbol(e);
    throw new T0(e);
  }
  /**
   * This method implements the single-token insertion inline error recovery
   * strategy. It is called by {@link //recoverInline} if the single-token
   * deletion strategy fails to recover from the mismatched input. If this
   * method returns {@code true}, {@code recognizer} will be in error recovery
   * mode.
   *
   * <p>This method determines whether or not single-token insertion is viable by
   * checking if the {@code LA(1)} input symbol could be successfully matched
   * if it were instead the {@code LA(2)} symbol. If this method returns
   * {@code true}, the caller is responsible for creating and inserting a
   * token with the correct type to produce this behavior.</p>
   *
   * @param recognizer the parser instance
   * @return {@code true} if single-token insertion is a viable recovery
   * strategy for the current mismatched input, otherwise {@code false}
   */
  singleTokenInsertion(e) {
    const n = e.getTokenStream().LA(1), i = e._interp.atn, r = i.states[e.state].transitions[0].target;
    return i.nextTokens(r, e._ctx).contains(n) ? (this.reportMissingToken(e), !0) : !1;
  }
  /**
   * This method implements the single-token deletion inline error recovery
   * strategy. It is called by {@link //recoverInline} to attempt to recover
   * from mismatched input. If this method returns null, the parser and error
   * handler state will not have changed. If this method returns non-null,
   * {@code recognizer} will <em>not</em> be in error recovery mode since the
   * returned token was a successful match.
   *
   * <p>If the single-token deletion is successful, this method calls
   * {@link //reportUnwantedToken} to report the error, followed by
   * {@link Parser//consume} to actually "delete" the extraneous token. Then,
   * before returning {@link //reportMatch} is called to signal a successful
   * match.</p>
   *
   * @param recognizer the parser instance
   * @return the successfully matched {@link Token} instance if single-token
   * deletion successfully recovers from the mismatched input, otherwise
   * {@code null}
   */
  singleTokenDeletion(e) {
    const n = e.getTokenStream().LA(2);
    if (this.getExpectedTokens(e).contains(n)) {
      this.reportUnwantedToken(e), e.consume();
      const s = e.getCurrentToken();
      return this.reportMatch(e), s;
    } else
      return null;
  }
  /**
   * Conjure up a missing token during error recovery.
   *
   * The recognizer attempts to recover from single missing
   * symbols. But, actions might refer to that missing symbol.
   * For example, x=ID {f($x);}. The action clearly assumes
   * that there has been an identifier matched previously and that
   * $x points at that token. If that token is missing, but
   * the next token in the stream is what we want we assume that
   * this token is missing and we keep going. Because we
   * have to return some token to replace the missing token,
   * we have to conjure one up. This method gives the user control
   * over the tokens returned for missing tokens. Mostly,
   * you will want to create something special for identifier
   * tokens. For literals such as '{' and ',', the default
   * action in the parser or tree parser works. It simply creates
   * a CommonToken of the appropriate type. The text will be the token.
   * If you change what tokens must be created by the lexer,
   * override this method to create the appropriate tokens.
   *
   */
  getMissingSymbol(e) {
    const n = e.getCurrentToken(), s = this.getExpectedTokens(e).first();
    let r;
    s === j.EOF ? r = "<missing EOF>" : r = "<missing " + e.literalNames[s] + ">";
    let o = n;
    const l = e.getTokenStream().LT(-1);
    return o.type === j.EOF && l !== null && (o = l), e.getTokenFactory().create(
      o.source,
      s,
      r,
      j.DEFAULT_CHANNEL,
      -1,
      -1,
      o.line,
      o.column
    );
  }
  getExpectedTokens(e) {
    return e.getExpectedTokens();
  }
  /**
   * How should a token be displayed in an error message? The default
   * is to display just the text, but during development you might
   * want to have a lot of information spit out. Override in that case
   * to use t.toString() (which, for CommonToken, dumps everything about
   * the token). This is better than forcing you to override a method in
   * your token objects because you don't have to go modify your lexer
   * so that it creates a new Java type.
   */
  getTokenErrorDisplay(e) {
    if (e === null)
      return "<no token>";
    let n = e.text;
    return n === null && (e.type === j.EOF ? n = "<EOF>" : n = "<" + e.type + ">"), this.escapeWSAndQuote(n);
  }
  escapeWSAndQuote(e) {
    return e = e.replace(/\n/g, "\\n"), e = e.replace(/\r/g, "\\r"), e = e.replace(/\t/g, "\\t"), "'" + e + "'";
  }
  /**
   * Compute the error recovery set for the current rule. During
   * rule invocation, the parser pushes the set of tokens that can
   * follow that rule reference on the stack; this amounts to
   * computing FIRST of what follows the rule reference in the
   * enclosing rule. See LinearApproximator.FIRST().
   * This local follow set only includes tokens
   * from within the rule; i.e., the FIRST computation done by
   * ANTLR stops at the end of a rule.
   *
   * EXAMPLE
   *
   * When you find a "no viable alt exception", the input is not
   * consistent with any of the alternatives for rule r. The best
   * thing to do is to consume tokens until you see something that
   * can legally follow a call to r//or* any rule that called r.
   * You don't want the exact set of viable next tokens because the
   * input might just be missing a token--you might consume the
   * rest of the input looking for one of the missing tokens.
   *
   * Consider grammar:
   *
   * a : '[' b ']'
   * | '(' b ')'
   * ;
   * b : c '^' INT ;
   * c : ID
   * | INT
   * ;
   *
   * At each rule invocation, the set of tokens that could follow
   * that rule is pushed on a stack. Here are the various
   * context-sensitive follow sets:
   *
   * FOLLOW(b1_in_a) = FIRST(']') = ']'
   * FOLLOW(b2_in_a) = FIRST(')') = ')'
   * FOLLOW(c_in_b) = FIRST('^') = '^'
   *
   * Upon erroneous input "[]", the call chain is
   *
   * a -> b -> c
   *
   * and, hence, the follow context stack is:
   *
   * depth follow set start of rule execution
   * 0 <EOF> a (from main())
   * 1 ']' b
   * 2 '^' c
   *
   * Notice that ')' is not included, because b would have to have
   * been called from a different context in rule a for ')' to be
   * included.
   *
   * For error recovery, we cannot consider FOLLOW(c)
   * (context-sensitive or otherwise). We need the combined set of
   * all context-sensitive FOLLOW sets--the set of all tokens that
   * could follow any reference in the call chain. We need to
   * resync to one of those tokens. Note that FOLLOW(c)='^' and if
   * we resync'd to that token, we'd consume until EOF. We need to
   * sync to context-sensitive FOLLOWs for a, b, and c: {']','^'}.
   * In this case, for input "[]", LA(1) is ']' and in the set, so we would
   * not consume anything. After printing an error, rule c would
   * return normally. Rule b would not find the required '^' though.
   * At this point, it gets a mismatched token error and throws an
   * exception (since LA(1) is not in the viable following token
   * set). The rule exception handler tries to recover, but finds
   * the same recovery set and doesn't consume anything. Rule b
   * exits normally returning to rule a. Now it finds the ']' (and
   * with the successful match exits errorRecovery mode).
   *
   * So, you can see that the parser walks up the call chain looking
   * for the token that was a member of the recovery set.
   *
   * Errors are not generated in errorRecovery mode.
   *
   * ANTLR's error recovery mechanism is based upon original ideas:
   *
   * "Algorithms + Data Structures = Programs" by Niklaus Wirth
   *
   * and
   *
   * "A note on error recovery in recursive descent parsers":
   * http://portal.acm.org/citation.cfm?id=947902.947905
   *
   * Later, Josef Grosch had some good ideas:
   *
   * "Efficient and Comfortable Error Recovery in Recursive Descent
   * Parsers":
   * ftp://www.cocolab.com/products/cocktail/doca4.ps/ell.ps.zip
   *
   * Like Grosch I implement context-sensitive FOLLOW sets that are combined
   * at run-time upon error to avoid overhead during parsing.
   */
  getErrorRecoverySet(e) {
    const n = e._interp.atn;
    let i = e._ctx;
    const s = new S3();
    for (; i !== null && i.invokingState >= 0; ) {
      const o = n.states[i.invokingState].transitions[0], l = n.nextTokens(o.followState);
      s.addSet(l), i = i.parentCtx;
    }
    return s.removeOne(j.EPSILON), s;
  }
  // Consume tokens until one matches the given token set.//
  consumeUntil(e, n) {
    let i = e.getTokenStream().LA(1);
    for (; i !== j.EOF && !n.contains(i); )
      e.consume(), i = e.getTokenStream().LA(1);
  }
}
class ig extends it {
  constructor() {
    super();
  }
  /**
   * Instead of recovering from exception {@code e}, re-throw it wrapped
   * in a {@link ParseCancellationException} so it is not caught by the
   * rule function catches. Use {@link Exception//getCause()} to get the
   * original {@link RecognitionException}.
   */
  recover(e, n) {
    let i = e._ctx;
    for (; i !== null; )
      i.exception = n, i = i.parentCtx;
    throw new nt(n);
  }
  /**
   * Make sure we don't attempt to recover inline; if the parser
   * successfully recovers, it won't throw an exception.
   */
  recoverInline(e) {
    this.recover(e, new T0(e));
  }
  // Make sure we don't attempt to recover from problems in subrules.//
  sync(e) {
  }
}
const sg = {
  RecognitionException: H4,
  NoViableAltException: et,
  LexerNoViableAltException: Je,
  InputMismatchException: T0,
  FailedPredicateException: Cl,
  DiagnosticErrorListener: tg,
  BailErrorStrategy: ig,
  DefaultErrorStrategy: it,
  ErrorListener: X8
};
class J4 {
  constructor(e, n) {
    if (this.name = "<empty>", this.strdata = e, this.decodeToUnicodeCodePoints = n || !1, this._index = 0, this.data = [], this.decodeToUnicodeCodePoints)
      for (let i = 0; i < this.strdata.length; ) {
        const s = this.strdata.codePointAt(i);
        this.data.push(s), i += s <= 65535 ? 1 : 2;
      }
    else {
      this.data = new Array(this.strdata.length);
      for (let i = 0; i < this.strdata.length; i++) {
        const s = this.strdata.charCodeAt(i);
        this.data[i] = s;
      }
    }
    this._size = this.data.length;
  }
  /**
   * Reset the stream so that it's in the same state it was
   * when the object was created *except* the data array is not
   * touched.
   */
  reset() {
    this._index = 0;
  }
  consume() {
    if (this._index >= this._size)
      throw "cannot consume EOF";
    this._index += 1;
  }
  LA(e) {
    if (e === 0)
      return 0;
    e < 0 && (e += 1);
    const n = this._index + e - 1;
    return n < 0 || n >= this._size ? j.EOF : this.data[n];
  }
  LT(e) {
    return this.LA(e);
  }
  // mark/release do nothing; we have entire buffer
  mark() {
    return -1;
  }
  release(e) {
  }
  /**
   * consume() ahead until p==_index; can't just set p=_index as we must
   * update line and column. If we seek backwards, just set p
   */
  seek(e) {
    if (e <= this._index) {
      this._index = e;
      return;
    }
    this._index = Math.min(e, this._size);
  }
  getText(e, n) {
    if (n >= this._size && (n = this._size - 1), e >= this._size)
      return "";
    if (this.decodeToUnicodeCodePoints) {
      let i = "";
      for (let s = e; s <= n; s++)
        i += String.fromCodePoint(this.data[s]);
      return i;
    } else
      return this.strdata.slice(e, n + 1);
  }
  toString() {
    return this.strdata;
  }
  get index() {
    return this._index;
  }
  get size() {
    return this._size;
  }
}
const O6 = {}, rg = {
  // Creates an InputStream from a string.
  fromString: function(t) {
    return new J4(t, !0);
  },
  /**
   * Asynchronously creates an InputStream from a blob given the
   * encoding of the bytes in that blob (defaults to 'utf8' if
   * encoding is null).
   *
   * Invokes onLoad(result) on success, onError(error) on
   * failure.
   */
  fromBlob: function(t, e, n, i) {
    const s = new window.FileReader();
    s.onload = function(r) {
      const o = new J4(r.target.result, !0);
      n(o);
    }, s.onerror = i, s.readAsText(t, e);
  },
  /**
   * Creates an InputStream from a Buffer given the
   * encoding of the bytes in that buffer (defaults to 'utf8' if
   * encoding is null).
   */
  fromBuffer: function(t, e) {
    return new J4(t.toString(e), !0);
  },
  /** Asynchronously creates an InputStream from a file on disk given
   * the encoding of the bytes in that file (defaults to 'utf8' if
   * encoding is null).
   *
   * Invokes callback(error, result) on completion.
   */
  fromPath: function(t, e, n) {
    O6.readFile(t, e, function(i, s) {
      let r = null;
      s !== null && (r = new J4(s, !0)), n(i, r);
    });
  },
  /**
   * Synchronously creates an InputStream given a path to a file
   * on disk and the encoding of the bytes in that file (defaults to
   * 'utf8' if encoding is null).
   */
  fromPathSync: function(t, e) {
    const n = O6.readFileSync(t, e);
    return new J4(n, !0);
  }
};
class og extends J4 {
  constructor(e, n) {
    const i = O6.readFileSync(e, "utf8");
    super(i, n), this.fileName = e;
  }
}
class lg {
}
class Lg extends lg {
  constructor(e) {
    super(), this.tokenSource = e, this.tokens = [], this.index = -1, this.fetchedEOF = !1;
  }
  mark() {
    return 0;
  }
  release(e) {
  }
  reset() {
    this.seek(0);
  }
  seek(e) {
    this.lazyInit(), this.index = this.adjustSeekIndex(e);
  }
  get(e) {
    return this.lazyInit(), this.tokens[e];
  }
  consume() {
    let e = !1;
    if (this.index >= 0 ? this.fetchedEOF ? e = this.index < this.tokens.length - 1 : e = this.index < this.tokens.length : e = !1, !e && this.LA(1) === j.EOF)
      throw "cannot consume EOF";
    this.sync(this.index + 1) && (this.index = this.adjustSeekIndex(this.index + 1));
  }
  /**
   * Make sure index {@code i} in tokens has a token.
   *
   * @return {Boolean} {@code true} if a token is located at index {@code i}, otherwise
   * {@code false}.
   * @see //get(int i)
   */
  sync(e) {
    const n = e - this.tokens.length + 1;
    return n > 0 ? this.fetch(n) >= n : !0;
  }
  /**
   * Add {@code n} elements to buffer.
   *
   * @return {Number} The actual number of elements added to the buffer.
   */
  fetch(e) {
    if (this.fetchedEOF)
      return 0;
    for (let n = 0; n < e; n++) {
      const i = this.tokenSource.nextToken();
      if (i.tokenIndex = this.tokens.length, this.tokens.push(i), i.type === j.EOF)
        return this.fetchedEOF = !0, n + 1;
    }
    return e;
  }
  // Get all tokens from start..stop inclusively///
  getTokens(e, n, i) {
    if (i === void 0 && (i = null), e < 0 || n < 0)
      return null;
    this.lazyInit();
    const s = [];
    n >= this.tokens.length && (n = this.tokens.length - 1);
    for (let r = e; r < n; r++) {
      const o = this.tokens[r];
      if (o.type === j.EOF)
        break;
      (i === null || i.contains(o.type)) && s.push(o);
    }
    return s;
  }
  LA(e) {
    return this.LT(e).type;
  }
  LB(e) {
    return this.index - e < 0 ? null : this.tokens[this.index - e];
  }
  LT(e) {
    if (this.lazyInit(), e === 0)
      return null;
    if (e < 0)
      return this.LB(-e);
    const n = this.index + e - 1;
    return this.sync(n), n >= this.tokens.length ? this.tokens[this.tokens.length - 1] : this.tokens[n];
  }
  /**
   * Allowed derived classes to modify the behavior of operations which change
   * the current stream position by adjusting the target token index of a seek
   * operation. The default implementation simply returns {@code i}. If an
   * exception is thrown in this method, the current stream index should not be
   * changed.
   *
   * <p>For example, {@link CommonTokenStream} overrides this method to ensure
   * that
   * the seek target is always an on-channel token.</p>
   *
   * @param {Number} i The target token index.
   * @return {Number} The adjusted target token index.
   */
  adjustSeekIndex(e) {
    return e;
  }
  lazyInit() {
    this.index === -1 && this.setup();
  }
  setup() {
    this.sync(0), this.index = this.adjustSeekIndex(0);
  }
  // Reset this token stream by setting its token source.///
  setTokenSource(e) {
    this.tokenSource = e, this.tokens = [], this.index = -1, this.fetchedEOF = !1;
  }
  /**
   * Given a starting index, return the index of the next token on channel.
   * Return i if tokens[i] is on channel. Return -1 if there are no tokens
   * on channel between i and EOF.
   */
  nextTokenOnChannel(e, n) {
    if (this.sync(e), e >= this.tokens.length)
      return -1;
    let i = this.tokens[e];
    for (; i.channel !== this.channel; ) {
      if (i.type === j.EOF)
        return -1;
      e += 1, this.sync(e), i = this.tokens[e];
    }
    return e;
  }
  /**
   * Given a starting index, return the index of the previous token on channel.
   * Return i if tokens[i] is on channel. Return -1 if there are no tokens
   * on channel between i and 0.
   */
  previousTokenOnChannel(e, n) {
    for (; e >= 0 && this.tokens[e].channel !== n; )
      e -= 1;
    return e;
  }
  /**
   * Collect all tokens on specified channel to the right of
   * the current token up until we see a token on DEFAULT_TOKEN_CHANNEL or
   * EOF. If channel is -1, find any non default channel token.
   */
  getHiddenTokensToRight(e, n) {
    if (n === void 0 && (n = -1), this.lazyInit(), e < 0 || e >= this.tokens.length)
      throw "" + e + " not in 0.." + this.tokens.length - 1;
    const i = this.nextTokenOnChannel(e + 1, V1.DEFAULT_TOKEN_CHANNEL), s = e + 1, r = i === -1 ? this.tokens.length - 1 : i;
    return this.filterForChannel(s, r, n);
  }
  /**
   * Collect all tokens on specified channel to the left of
   * the current token up until we see a token on DEFAULT_TOKEN_CHANNEL.
   * If channel is -1, find any non default channel token.
   */
  getHiddenTokensToLeft(e, n) {
    if (n === void 0 && (n = -1), this.lazyInit(), e < 0 || e >= this.tokens.length)
      throw "" + e + " not in 0.." + this.tokens.length - 1;
    const i = this.previousTokenOnChannel(e - 1, V1.DEFAULT_TOKEN_CHANNEL);
    if (i === e - 1)
      return null;
    const s = i + 1, r = e - 1;
    return this.filterForChannel(s, r, n);
  }
  filterForChannel(e, n, i) {
    const s = [];
    for (let r = e; r < n + 1; r++) {
      const o = this.tokens[r];
      i === -1 ? o.channel !== V1.DEFAULT_TOKEN_CHANNEL && s.push(o) : o.channel === i && s.push(o);
    }
    return s.length === 0 ? null : s;
  }
  getSourceName() {
    return this.tokenSource.getSourceName();
  }
  // Get the text of all tokens in this buffer.///
  getText(e) {
    this.lazyInit(), this.fill(), e == null && (e = new G2(0, this.tokens.length - 1));
    let n = e.start;
    n instanceof j && (n = n.tokenIndex);
    let i = e.stop;
    if (i instanceof j && (i = i.tokenIndex), n === null || i === null || n < 0 || i < 0)
      return "";
    i >= this.tokens.length && (i = this.tokens.length - 1);
    let s = "";
    for (let r = n; r < i + 1; r++) {
      const o = this.tokens[r];
      if (o.type === j.EOF)
        break;
      s = s + o.text;
    }
    return s;
  }
  // Get all tokens from lexer until EOF///
  fill() {
    for (this.lazyInit(); this.fetch(1e3) === 1e3; )
      ;
  }
}
class ag extends Lg {
  constructor(e, n) {
    super(e), this.channel = n === void 0 ? j.DEFAULT_CHANNEL : n;
  }
  adjustSeekIndex(e) {
    return this.nextTokenOnChannel(e, this.channel);
  }
  LB(e) {
    if (e === 0 || this.index - e < 0)
      return null;
    let n = this.index, i = 1;
    for (; i <= e; )
      n = this.previousTokenOnChannel(n - 1, this.channel), i += 1;
    return n < 0 ? null : this.tokens[n];
  }
  LT(e) {
    if (this.lazyInit(), e === 0)
      return null;
    if (e < 0)
      return this.LB(-e);
    let n = this.index, i = 1;
    for (; i < e; )
      this.sync(n + 1) && (n = this.nextTokenOnChannel(n + 1, this.channel)), i += 1;
    return this.tokens[n];
  }
  // Count EOF just once.
  getNumberOfOnChannelTokens() {
    let e = 0;
    this.fill();
    for (let n = 0; n < this.tokens.length; n++) {
      const i = this.tokens[n];
      if (i.channel === this.channel && (e += 1), i.type === j.EOF)
        break;
    }
    return e;
  }
}
class Cg extends al {
  constructor(e) {
    super(), this.parser = e;
  }
  enterEveryRule(e) {
    console.log("enter   " + this.parser.ruleNames[e.ruleIndex] + ", LT(1)=" + this.parser._input.LT(1).text);
  }
  visitTerminal(e) {
    console.log("consume " + e.symbol + " rule " + this.parser.ruleNames[this.parser._ctx.ruleIndex]);
  }
  exitEveryRule(e) {
    console.log("exit    " + this.parser.ruleNames[e.ruleIndex] + ", LT(1)=" + this.parser._input.LT(1).text);
  }
}
let cl = class extends J8 {
  /**
   * this is all the parsing support code essentially; most of it is error
   * recovery stuff.
   */
  constructor(e) {
    super(), this._input = null, this._errHandler = new it(), this._precedenceStack = [], this._precedenceStack.push(0), this._ctx = null, this.buildParseTrees = !0, this._tracer = null, this._parseListeners = null, this._syntaxErrors = 0, this.setInputStream(e);
  }
  // reset the parser's state
  reset() {
    this._input !== null && this._input.seek(0), this._errHandler.reset(this), this._ctx = null, this._syntaxErrors = 0, this.setTrace(!1), this._precedenceStack = [], this._precedenceStack.push(0), this._interp !== null && this._interp.reset();
  }
  /**
   * Match current input symbol against {@code ttype}. If the symbol type
   * matches, {@link ANTLRErrorStrategy//reportMatch} and {@link //consume} are
   * called to complete the match process.
   *
   * <p>If the symbol type does not match,
   * {@link ANTLRErrorStrategy//recoverInline} is called on the current error
   * strategy to attempt recovery. If {@link //getBuildParseTree} is
   * {@code true} and the token index of the symbol returned by
   * {@link ANTLRErrorStrategy//recoverInline} is -1, the symbol is added to
   * the parse tree by calling {@link ParserRuleContext//addErrorNode}.</p>
   *
   * @param ttype the token type to match
   * @return the matched symbol
   * @throws RecognitionException if the current input symbol did not match
   * {@code ttype} and the error strategy could not recover from the
   * mismatched symbol
   */
  match(e) {
    let n = this.getCurrentToken();
    return n.type === e ? (this._errHandler.reportMatch(this), this.consume()) : (n = this._errHandler.recoverInline(this), this.buildParseTrees && n.tokenIndex === -1 && this._ctx.addErrorNode(n)), n;
  }
  /**
   * Match current input symbol as a wildcard. If the symbol type matches
   * (i.e. has a value greater than 0), {@link ANTLRErrorStrategy//reportMatch}
   * and {@link //consume} are called to complete the match process.
   *
   * <p>If the symbol type does not match,
   * {@link ANTLRErrorStrategy//recoverInline} is called on the current error
   * strategy to attempt recovery. If {@link //getBuildParseTree} is
   * {@code true} and the token index of the symbol returned by
   * {@link ANTLRErrorStrategy//recoverInline} is -1, the symbol is added to
   * the parse tree by calling {@link ParserRuleContext//addErrorNode}.</p>
   *
   * @return the matched symbol
   * @throws RecognitionException if the current input symbol did not match
   * a wildcard and the error strategy could not recover from the mismatched
   * symbol
   */
  matchWildcard() {
    let e = this.getCurrentToken();
    return e.type > 0 ? (this._errHandler.reportMatch(this), this.consume()) : (e = this._errHandler.recoverInline(this), this._buildParseTrees && e.tokenIndex === -1 && this._ctx.addErrorNode(e)), e;
  }
  getParseListeners() {
    return this._parseListeners || [];
  }
  /**
   * Registers {@code listener} to receive events during the parsing process.
   *
   * <p>To support output-preserving grammar transformations (including but not
   * limited to left-recursion removal, automated left-factoring, and
   * optimized code generation), calls to listener methods during the parse
   * may differ substantially from calls made by
   * {@link ParseTreeWalker//DEFAULT} used after the parse is complete. In
   * particular, rule entry and exit events may occur in a different order
   * during the parse than after the parser. In addition, calls to certain
   * rule entry methods may be omitted.</p>
   *
   * <p>With the following specific exceptions, calls to listener events are
   * <em>deterministic</em>, i.e. for identical input the calls to listener
   * methods will be the same.</p>
   *
   * <ul>
   * <li>Alterations to the grammar used to generate code may change the
   * behavior of the listener calls.</li>
   * <li>Alterations to the command line options passed to ANTLR 4 when
   * generating the parser may change the behavior of the listener calls.</li>
   * <li>Changing the version of the ANTLR Tool used to generate the parser
   * may change the behavior of the listener calls.</li>
   * </ul>
   *
   * @param listener the listener to add
   *
   * @throws NullPointerException if {@code} listener is {@code null}
   */
  addParseListener(e) {
    if (e === null)
      throw "listener";
    this._parseListeners === null && (this._parseListeners = []), this._parseListeners.push(e);
  }
  /**
   * Remove {@code listener} from the list of parse listeners.
   *
   * <p>If {@code listener} is {@code null} or has not been added as a parse
   * listener, this method does nothing.</p>
   * @param listener the listener to remove
   */
  removeParseListener(e) {
    if (this._parseListeners !== null) {
      const n = this._parseListeners.indexOf(e);
      n >= 0 && this._parseListeners.splice(n, 1), this._parseListeners.length === 0 && (this._parseListeners = null);
    }
  }
  // Remove all parse listeners.
  removeParseListeners() {
    this._parseListeners = null;
  }
  // Notify any parse listeners of an enter rule event.
  triggerEnterRuleEvent() {
    if (this._parseListeners !== null) {
      const e = this._ctx;
      this._parseListeners.forEach(function(n) {
        n.enterEveryRule(e), e.enterRule(n);
      });
    }
  }
  /**
   * Notify any parse listeners of an exit rule event.
   * @see //addParseListener
   */
  triggerExitRuleEvent() {
    if (this._parseListeners !== null) {
      const e = this._ctx;
      this._parseListeners.slice(0).reverse().forEach(function(n) {
        e.exitRule(n), n.exitEveryRule(e);
      });
    }
  }
  getTokenFactory() {
    return this._input.tokenSource._factory;
  }
  // Tell our token source and error strategy about a new way to create tokens.
  setTokenFactory(e) {
    this._input.tokenSource._factory = e;
  }
  /**
   * The ATN with bypass alternatives is expensive to create so we create it
   * lazily.
   *
   * @throws UnsupportedOperationException if the current parser does not
   * implement the {@link //getSerializedATN()} method.
   */
  getATNWithBypassAlts() {
    const e = this.getSerializedATN();
    if (e === null)
      throw "The current parser does not support an ATN with bypass alternatives.";
    let n = this.bypassAltsAtnCache[e];
    if (n === null) {
      const i = new $0();
      i.generateRuleBypassTransitions = !0, n = new ol(i).deserialize(e), this.bypassAltsAtnCache[e] = n;
    }
    return n;
  }
  getInputStream() {
    return this.getTokenStream();
  }
  setInputStream(e) {
    this.setTokenStream(e);
  }
  getTokenStream() {
    return this._input;
  }
  // Set the token stream and reset the parser.
  setTokenStream(e) {
    this._input = null, this.reset(), this._input = e;
  }
  /**
   * Match needs to return the current input symbol, which gets put
   * into the label for the associated token ref; e.g., x=ID.
   */
  getCurrentToken() {
    return this._input.LT(1);
  }
  notifyErrorListeners(e, n, i) {
    n = n || null, i = i || null, n === null && (n = this.getCurrentToken()), this._syntaxErrors += 1;
    const s = n.line, r = n.column;
    this.getErrorListenerDispatch().syntaxError(this, n, s, r, e, i);
  }
  /**
   * Consume and return the {@linkplain //getCurrentToken current symbol}.
   *
   * <p>E.g., given the following input with {@code A} being the current
   * lookahead symbol, this function moves the cursor to {@code B} and returns
   * {@code A}.</p>
   *
   * <pre>
   * A B
   * ^
   * </pre>
   *
   * If the parser is not in error recovery mode, the consumed symbol is added
   * to the parse tree using {@link ParserRuleContext//addChild(Token)}, and
   * {@link ParseTreeListener//visitTerminal} is called on any parse listeners.
   * If the parser <em>is</em> in error recovery mode, the consumed symbol is
   * added to the parse tree using
   * {@link ParserRuleContext//addErrorNode(Token)}, and
   * {@link ParseTreeListener//visitErrorNode} is called on any parse
   * listeners.
   */
  consume() {
    const e = this.getCurrentToken();
    e.type !== j.EOF && this.getInputStream().consume();
    const n = this._parseListeners !== null && this._parseListeners.length > 0;
    if (this.buildParseTrees || n) {
      let i;
      this._errHandler.inErrorRecoveryMode(this) ? i = this._ctx.addErrorNode(e) : i = this._ctx.addTokenNode(e), i.invokingState = this.state, n && this._parseListeners.forEach(function(s) {
        i instanceof K8 || i.isErrorNode !== void 0 && i.isErrorNode() ? s.visitErrorNode(i) : i instanceof f4 && s.visitTerminal(i);
      });
    }
    return e;
  }
  addContextToParseTree() {
    this._ctx.parentCtx !== null && this._ctx.parentCtx.addChild(this._ctx);
  }
  /**
   * Always called by generated parsers upon entry to a rule. Access field
   * {@link //_ctx} get the current context.
   */
  enterRule(e, n, i) {
    this.state = n, this._ctx = e, this._ctx.start = this._input.LT(1), this.buildParseTrees && this.addContextToParseTree(), this.triggerEnterRuleEvent();
  }
  exitRule() {
    this._ctx.stop = this._input.LT(-1), this.triggerExitRuleEvent(), this.state = this._ctx.invokingState, this._ctx = this._ctx.parentCtx;
  }
  enterOuterAlt(e, n) {
    e.setAltNumber(n), this.buildParseTrees && this._ctx !== e && this._ctx.parentCtx !== null && (this._ctx.parentCtx.removeLastChild(), this._ctx.parentCtx.addChild(e)), this._ctx = e;
  }
  /**
   * Get the precedence level for the top-most precedence rule.
   *
   * @return The precedence level for the top-most precedence rule, or -1 if
   * the parser context is not nested within a precedence rule.
   */
  getPrecedence() {
    return this._precedenceStack.length === 0 ? -1 : this._precedenceStack[this._precedenceStack.length - 1];
  }
  enterRecursionRule(e, n, i, s) {
    this.state = n, this._precedenceStack.push(s), this._ctx = e, this._ctx.start = this._input.LT(1), this.triggerEnterRuleEvent();
  }
  // Like {@link //enterRule} but for recursive rules.
  pushNewRecursionContext(e, n, i) {
    const s = this._ctx;
    s.parentCtx = e, s.invokingState = n, s.stop = this._input.LT(-1), this._ctx = e, this._ctx.start = s.start, this.buildParseTrees && this._ctx.addChild(s), this.triggerEnterRuleEvent();
  }
  unrollRecursionContexts(e) {
    this._precedenceStack.pop(), this._ctx.stop = this._input.LT(-1);
    const n = this._ctx, i = this.getParseListeners();
    if (i !== null && i.length > 0)
      for (; this._ctx !== e; )
        this.triggerExitRuleEvent(), this._ctx = this._ctx.parentCtx;
    else
      this._ctx = e;
    n.parentCtx = e, this.buildParseTrees && e !== null && e.addChild(n);
  }
  getInvokingContext(e) {
    let n = this._ctx;
    for (; n !== null; ) {
      if (n.ruleIndex === e)
        return n;
      n = n.parentCtx;
    }
    return null;
  }
  precpred(e, n) {
    return n >= this._precedenceStack[this._precedenceStack.length - 1];
  }
  inContext(e) {
    return !1;
  }
  /**
   * Checks whether or not {@code symbol} can follow the current state in the
   * ATN. The behavior of this method is equivalent to the following, but is
   * implemented such that the complete context-sensitive follow set does not
   * need to be explicitly constructed.
   *
   * <pre>
   * return getExpectedTokens().contains(symbol);
   * </pre>
   *
   * @param symbol the symbol type to check
   * @return {@code true} if {@code symbol} can follow the current state in
   * the ATN, otherwise {@code false}.
   */
  isExpectedToken(e) {
    const n = this._interp.atn;
    let i = this._ctx;
    const s = n.states[this.state];
    let r = n.nextTokens(s);
    if (r.contains(e))
      return !0;
    if (!r.contains(j.EPSILON))
      return !1;
    for (; i !== null && i.invokingState >= 0 && r.contains(j.EPSILON); ) {
      const l = n.states[i.invokingState].transitions[0];
      if (r = n.nextTokens(l.followState), r.contains(e))
        return !0;
      i = i.parentCtx;
    }
    return !!(r.contains(j.EPSILON) && e === j.EOF);
  }
  /**
   * Computes the set of input symbols which could follow the current parser
   * state and context, as given by {@link //getState} and {@link //getContext},
   * respectively.
   *
   * @see ATN//getExpectedTokens(int, RuleContext)
   */
  getExpectedTokens() {
    return this._interp.atn.getExpectedTokens(this.state, this._ctx);
  }
  getExpectedTokensWithinCurrentRule() {
    const e = this._interp.atn, n = e.states[this.state];
    return e.nextTokens(n);
  }
  // Get a rule's index (i.e., {@code RULE_ruleName} field) or -1 if not found.
  getRuleIndex(e) {
    const n = this.getRuleIndexMap()[e];
    return n !== null ? n : -1;
  }
  /**
   * Return List&lt;String&gt; of the rule names in your parser instance
   * leading up to a call to the current rule. You could override if
   * you want more details such as the file/line info of where
   * in the ATN a rule is invoked.
   *
   * this is very useful for error messages.
   */
  getRuleInvocationStack(e) {
    e = e || null, e === null && (e = this._ctx);
    const n = [];
    for (; e !== null; ) {
      const i = e.ruleIndex;
      i < 0 ? n.push("n/a") : n.push(this.ruleNames[i]), e = e.parentCtx;
    }
    return n;
  }
  // For debugging and other purposes.
  getDFAStrings() {
    return this._interp.decisionToDFA.toString();
  }
  // For debugging and other purposes.
  dumpDFA() {
    let e = !1;
    for (let n = 0; n < this._interp.decisionToDFA.length; n++) {
      const i = this._interp.decisionToDFA[n];
      i.states.length > 0 && (e && console.log(), this.printer.println("Decision " + i.decision + ":"), this.printer.print(i.toString(this.literalNames, this.symbolicNames)), e = !0);
    }
  }
  /*
      "			printer = function() {\r\n" +
      "				this.println = function(s) { document.getElementById('output') += s + '\\n'; }\r\n" +
      "				this.print = function(s) { document.getElementById('output') += s; }\r\n" +
      "			};\r\n" +
      */
  getSourceName() {
    return this._input.sourceName;
  }
  /**
   * During a parse is sometimes useful to listen in on the rule entry and exit
   * events as well as token matches. this is for quick and dirty debugging.
   */
  setTrace(e) {
    e ? (this._tracer !== null && this.removeParseListener(this._tracer), this._tracer = new Cg(this), this.addParseListener(this._tracer)) : (this.removeParseListener(this._tracer), this._tracer = null);
  }
};
cl.bypassAltsAtnCache = {};
class cg {
  constructor() {
    this.cache = new o5();
  }
  /**
   * Add a context to the cache and return it. If the context already exists,
   * return that one instead and do not add a new context to the cache.
   * Protect shared cache from unsafe thread access.
   */
  add(e) {
    if (e === O2.EMPTY)
      return O2.EMPTY;
    const n = this.cache.get(e) || null;
    return n !== null ? n : (this.cache.set(e, e), e);
  }
  get(e) {
    return this.cache.get(e) || null;
  }
  get length() {
    return this.cache.length;
  }
}
class ul extends f4 {
  constructor(e) {
    super(), this.parentCtx = null, this.symbol = e;
  }
  getChild(e) {
    return null;
  }
  getSymbol() {
    return this.symbol;
  }
  getParent() {
    return this.parentCtx;
  }
  getPayload() {
    return this.symbol;
  }
  getSourceInterval() {
    if (this.symbol === null)
      return G2.INVALID_INTERVAL;
    const e = this.symbol.tokenIndex;
    return new G2(e, e);
  }
  getChildCount() {
    return 0;
  }
  accept(e) {
    return e.visitTerminal(this);
  }
  getText() {
    return this.symbol.text;
  }
  toString() {
    return this.symbol.type === j.EOF ? "<EOF>" : this.symbol.text;
  }
}
class yi extends ul {
  constructor(e) {
    super(e);
  }
  isErrorNode() {
    return !0;
  }
  accept(e) {
    return e.visitErrorNode(this);
  }
}
let hl = class extends G9 {
  constructor(e, n) {
    e = e || null, n = n || null, super(e, n), this.ruleIndex = -1, this.children = null, this.start = null, this.stop = null, this.exception = null;
  }
  // COPY a ctx (I'm deliberately not using copy constructor)
  copyFrom(e) {
    this.parentCtx = e.parentCtx, this.invokingState = e.invokingState, this.children = null, this.start = e.start, this.stop = e.stop, e.children && (this.children = [], e.children.map(function(n) {
      n instanceof yi && (this.children.push(n), n.parentCtx = this);
    }, this));
  }
  // Double dispatch methods for listeners
  enterRule(e) {
  }
  exitRule(e) {
  }
  // Does not set parent link; other add methods do that
  addChild(e) {
    return this.children === null && (this.children = []), this.children.push(e), e;
  }
  /** Used by enterOuterAlt to toss out a RuleContext previously added as
   * we entered a rule. If we have // label, we will need to remove
   * generic ruleContext object.
   */
  removeLastChild() {
    this.children !== null && this.children.pop();
  }
  addTokenNode(e) {
    const n = new ul(e);
    return this.addChild(n), n.parentCtx = this, n;
  }
  addErrorNode(e) {
    const n = new yi(e);
    return this.addChild(n), n.parentCtx = this, n;
  }
  getChild(e, n) {
    if (n = n || null, this.children === null || e < 0 || e >= this.children.length)
      return null;
    if (n === null)
      return this.children[e];
    for (let i = 0; i < this.children.length; i++) {
      const s = this.children[i];
      if (s instanceof n) {
        if (e === 0)
          return s;
        e -= 1;
      }
    }
    return null;
  }
  getToken(e, n) {
    if (this.children === null || n < 0 || n >= this.children.length)
      return null;
    for (let i = 0; i < this.children.length; i++) {
      const s = this.children[i];
      if (s instanceof f4 && s.symbol.type === e) {
        if (n === 0)
          return s;
        n -= 1;
      }
    }
    return null;
  }
  getTokens(e) {
    if (this.children === null)
      return [];
    {
      const n = [];
      for (let i = 0; i < this.children.length; i++) {
        const s = this.children[i];
        s instanceof f4 && s.symbol.type === e && n.push(s);
      }
      return n;
    }
  }
  getTypedRuleContext(e, n) {
    return this.getChild(n, e);
  }
  getTypedRuleContexts(e) {
    if (this.children === null)
      return [];
    {
      const n = [];
      for (let i = 0; i < this.children.length; i++) {
        const s = this.children[i];
        s instanceof e && n.push(s);
      }
      return n;
    }
  }
  getChildCount() {
    return this.children === null ? 0 : this.children.length;
  }
  getSourceInterval() {
    return this.start === null || this.stop === null ? G2.INVALID_INTERVAL : new G2(this.start.tokenIndex, this.stop.tokenIndex);
  }
};
G9.EMPTY = new hl();
const ug = { arrayToString: S4 }, y = {
  atn: Kd,
  dfa: Qd,
  tree: Jd,
  error: sg,
  Token: j,
  CommonToken: h9,
  CharStreams: rg,
  InputStream: J4,
  FileStream: og,
  CommonTokenStream: ag,
  Lexer: V1,
  Parser: cl,
  PredictionContextCache: cg,
  ParserRuleContext: hl,
  Interval: G2,
  IntervalSet: S3,
  LL1Analyzer: j9,
  Utils: ug
}, hg = [
  4,
  0,
  70,
  570,
  6,
  -1,
  6,
  -1,
  6,
  -1,
  2,
  0,
  7,
  0,
  2,
  1,
  7,
  1,
  2,
  2,
  7,
  2,
  2,
  3,
  7,
  3,
  2,
  4,
  7,
  4,
  2,
  5,
  7,
  5,
  2,
  6,
  7,
  6,
  2,
  7,
  7,
  7,
  2,
  8,
  7,
  8,
  2,
  9,
  7,
  9,
  2,
  10,
  7,
  10,
  2,
  11,
  7,
  11,
  2,
  12,
  7,
  12,
  2,
  13,
  7,
  13,
  2,
  14,
  7,
  14,
  2,
  15,
  7,
  15,
  2,
  16,
  7,
  16,
  2,
  17,
  7,
  17,
  2,
  18,
  7,
  18,
  2,
  19,
  7,
  19,
  2,
  20,
  7,
  20,
  2,
  21,
  7,
  21,
  2,
  22,
  7,
  22,
  2,
  23,
  7,
  23,
  2,
  24,
  7,
  24,
  2,
  25,
  7,
  25,
  2,
  26,
  7,
  26,
  2,
  27,
  7,
  27,
  2,
  28,
  7,
  28,
  2,
  29,
  7,
  29,
  2,
  30,
  7,
  30,
  2,
  31,
  7,
  31,
  2,
  32,
  7,
  32,
  2,
  33,
  7,
  33,
  2,
  34,
  7,
  34,
  2,
  35,
  7,
  35,
  2,
  36,
  7,
  36,
  2,
  37,
  7,
  37,
  2,
  38,
  7,
  38,
  2,
  39,
  7,
  39,
  2,
  40,
  7,
  40,
  2,
  41,
  7,
  41,
  2,
  42,
  7,
  42,
  2,
  43,
  7,
  43,
  2,
  44,
  7,
  44,
  2,
  45,
  7,
  45,
  2,
  46,
  7,
  46,
  2,
  47,
  7,
  47,
  2,
  48,
  7,
  48,
  2,
  49,
  7,
  49,
  2,
  50,
  7,
  50,
  2,
  51,
  7,
  51,
  2,
  52,
  7,
  52,
  2,
  53,
  7,
  53,
  2,
  54,
  7,
  54,
  2,
  55,
  7,
  55,
  2,
  56,
  7,
  56,
  2,
  57,
  7,
  57,
  2,
  58,
  7,
  58,
  2,
  59,
  7,
  59,
  2,
  60,
  7,
  60,
  2,
  61,
  7,
  61,
  2,
  62,
  7,
  62,
  2,
  63,
  7,
  63,
  2,
  64,
  7,
  64,
  2,
  65,
  7,
  65,
  2,
  66,
  7,
  66,
  2,
  67,
  7,
  67,
  2,
  68,
  7,
  68,
  2,
  69,
  7,
  69,
  2,
  70,
  7,
  70,
  2,
  71,
  7,
  71,
  2,
  72,
  7,
  72,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  2,
  1,
  2,
  1,
  2,
  1,
  2,
  1,
  2,
  1,
  2,
  1,
  2,
  1,
  2,
  1,
  2,
  1,
  2,
  1,
  2,
  1,
  3,
  1,
  3,
  1,
  3,
  1,
  3,
  1,
  3,
  1,
  3,
  1,
  3,
  1,
  3,
  1,
  3,
  1,
  4,
  1,
  4,
  1,
  4,
  1,
  4,
  1,
  4,
  1,
  4,
  1,
  4,
  1,
  4,
  1,
  5,
  1,
  5,
  1,
  5,
  1,
  5,
  1,
  5,
  1,
  5,
  1,
  5,
  1,
  5,
  1,
  6,
  1,
  6,
  1,
  6,
  1,
  6,
  1,
  7,
  1,
  7,
  1,
  7,
  1,
  8,
  1,
  8,
  1,
  8,
  1,
  9,
  1,
  9,
  1,
  9,
  1,
  10,
  1,
  10,
  1,
  11,
  1,
  11,
  4,
  11,
  215,
  8,
  11,
  11,
  11,
  12,
  11,
  216,
  1,
  12,
  1,
  12,
  1,
  12,
  1,
  13,
  1,
  13,
  1,
  13,
  1,
  14,
  1,
  14,
  1,
  14,
  1,
  15,
  1,
  15,
  1,
  15,
  1,
  16,
  1,
  16,
  1,
  17,
  1,
  17,
  1,
  18,
  1,
  18,
  1,
  18,
  1,
  19,
  1,
  19,
  1,
  19,
  1,
  20,
  1,
  20,
  1,
  21,
  1,
  21,
  1,
  22,
  1,
  22,
  1,
  23,
  1,
  23,
  1,
  24,
  1,
  24,
  1,
  25,
  1,
  25,
  1,
  26,
  1,
  26,
  1,
  27,
  1,
  27,
  1,
  28,
  1,
  28,
  1,
  29,
  1,
  29,
  1,
  30,
  1,
  30,
  1,
  31,
  1,
  31,
  1,
  32,
  1,
  32,
  1,
  33,
  1,
  33,
  1,
  34,
  1,
  34,
  1,
  34,
  1,
  34,
  1,
  34,
  1,
  35,
  1,
  35,
  1,
  35,
  1,
  35,
  1,
  35,
  1,
  35,
  1,
  36,
  1,
  36,
  1,
  36,
  1,
  36,
  1,
  36,
  1,
  36,
  1,
  36,
  3,
  36,
  287,
  8,
  36,
  1,
  37,
  1,
  37,
  1,
  37,
  1,
  38,
  1,
  38,
  1,
  38,
  1,
  38,
  1,
  38,
  1,
  39,
  1,
  39,
  1,
  39,
  1,
  39,
  1,
  39,
  1,
  39,
  1,
  39,
  1,
  39,
  1,
  39,
  1,
  39,
  1,
  39,
  1,
  39,
  1,
  39,
  1,
  39,
  1,
  39,
  1,
  39,
  1,
  39,
  1,
  39,
  1,
  39,
  1,
  39,
  1,
  39,
  1,
  39,
  1,
  39,
  1,
  39,
  1,
  39,
  1,
  39,
  3,
  39,
  323,
  8,
  39,
  1,
  40,
  1,
  40,
  1,
  40,
  1,
  40,
  1,
  40,
  1,
  40,
  1,
  40,
  1,
  41,
  1,
  41,
  1,
  41,
  1,
  41,
  1,
  42,
  1,
  42,
  1,
  42,
  1,
  42,
  1,
  43,
  1,
  43,
  1,
  43,
  1,
  43,
  1,
  43,
  1,
  43,
  1,
  44,
  1,
  44,
  1,
  44,
  1,
  44,
  1,
  45,
  1,
  45,
  1,
  45,
  1,
  45,
  1,
  45,
  1,
  45,
  1,
  45,
  1,
  45,
  1,
  45,
  1,
  46,
  1,
  46,
  1,
  46,
  1,
  46,
  1,
  46,
  1,
  46,
  1,
  46,
  1,
  46,
  1,
  46,
  1,
  46,
  1,
  46,
  1,
  46,
  3,
  46,
  371,
  8,
  46,
  1,
  47,
  1,
  47,
  1,
  47,
  1,
  47,
  1,
  48,
  1,
  48,
  1,
  48,
  1,
  49,
  1,
  49,
  1,
  49,
  1,
  49,
  1,
  50,
  1,
  50,
  1,
  50,
  1,
  50,
  1,
  50,
  1,
  50,
  1,
  51,
  1,
  51,
  1,
  51,
  1,
  51,
  1,
  51,
  1,
  51,
  1,
  51,
  1,
  51,
  1,
  52,
  1,
  52,
  1,
  52,
  1,
  53,
  1,
  53,
  1,
  53,
  1,
  53,
  1,
  53,
  1,
  53,
  1,
  53,
  1,
  53,
  1,
  53,
  1,
  53,
  1,
  53,
  1,
  53,
  1,
  53,
  1,
  53,
  1,
  53,
  1,
  53,
  3,
  53,
  417,
  8,
  53,
  1,
  54,
  1,
  54,
  1,
  54,
  1,
  54,
  1,
  54,
  1,
  54,
  1,
  54,
  1,
  54,
  1,
  54,
  1,
  54,
  1,
  54,
  1,
  54,
  1,
  54,
  1,
  54,
  1,
  54,
  1,
  54,
  1,
  54,
  1,
  54,
  1,
  54,
  1,
  54,
  1,
  54,
  1,
  54,
  1,
  54,
  1,
  54,
  1,
  54,
  1,
  54,
  3,
  54,
  445,
  8,
  54,
  1,
  55,
  1,
  55,
  5,
  55,
  449,
  8,
  55,
  10,
  55,
  12,
  55,
  452,
  9,
  55,
  1,
  56,
  1,
  56,
  1,
  57,
  1,
  57,
  5,
  57,
  458,
  8,
  57,
  10,
  57,
  12,
  57,
  461,
  9,
  57,
  1,
  58,
  4,
  58,
  464,
  8,
  58,
  11,
  58,
  12,
  58,
  465,
  1,
  59,
  1,
  59,
  1,
  60,
  4,
  60,
  471,
  8,
  60,
  11,
  60,
  12,
  60,
  472,
  1,
  61,
  4,
  61,
  476,
  8,
  61,
  11,
  61,
  12,
  61,
  477,
  1,
  61,
  1,
  61,
  5,
  61,
  482,
  8,
  61,
  10,
  61,
  12,
  61,
  485,
  9,
  61,
  1,
  61,
  1,
  61,
  4,
  61,
  489,
  8,
  61,
  11,
  61,
  12,
  61,
  490,
  3,
  61,
  493,
  8,
  61,
  1,
  62,
  1,
  62,
  1,
  62,
  3,
  62,
  498,
  8,
  62,
  1,
  63,
  1,
  63,
  3,
  63,
  502,
  8,
  63,
  1,
  63,
  1,
  63,
  1,
  64,
  1,
  64,
  1,
  64,
  1,
  64,
  5,
  64,
  510,
  8,
  64,
  10,
  64,
  12,
  64,
  513,
  9,
  64,
  1,
  64,
  3,
  64,
  516,
  8,
  64,
  1,
  65,
  1,
  65,
  1,
  65,
  1,
  65,
  1,
  66,
  1,
  66,
  1,
  66,
  1,
  66,
  5,
  66,
  526,
  8,
  66,
  10,
  66,
  12,
  66,
  529,
  9,
  66,
  1,
  66,
  1,
  66,
  1,
  66,
  1,
  66,
  1,
  67,
  1,
  67,
  1,
  68,
  1,
  68,
  5,
  68,
  539,
  8,
  68,
  10,
  68,
  12,
  68,
  542,
  9,
  68,
  1,
  68,
  1,
  68,
  1,
  68,
  1,
  68,
  5,
  68,
  548,
  8,
  68,
  10,
  68,
  12,
  68,
  551,
  9,
  68,
  1,
  69,
  4,
  69,
  554,
  8,
  69,
  11,
  69,
  12,
  69,
  555,
  1,
  70,
  1,
  70,
  1,
  70,
  1,
  70,
  1,
  71,
  4,
  71,
  563,
  8,
  71,
  11,
  71,
  12,
  71,
  564,
  1,
  72,
  1,
  72,
  1,
  72,
  1,
  72,
  1,
  527,
  0,
  73,
  3,
  1,
  5,
  2,
  7,
  3,
  9,
  4,
  11,
  5,
  13,
  6,
  15,
  7,
  17,
  8,
  19,
  9,
  21,
  10,
  23,
  0,
  25,
  11,
  27,
  12,
  29,
  13,
  31,
  14,
  33,
  15,
  35,
  16,
  37,
  17,
  39,
  18,
  41,
  19,
  43,
  20,
  45,
  21,
  47,
  22,
  49,
  23,
  51,
  24,
  53,
  25,
  55,
  26,
  57,
  27,
  59,
  28,
  61,
  29,
  63,
  30,
  65,
  31,
  67,
  32,
  69,
  33,
  71,
  34,
  73,
  35,
  75,
  36,
  77,
  37,
  79,
  38,
  81,
  39,
  83,
  40,
  85,
  41,
  87,
  42,
  89,
  43,
  91,
  44,
  93,
  45,
  95,
  46,
  97,
  47,
  99,
  48,
  101,
  49,
  103,
  50,
  105,
  51,
  107,
  52,
  109,
  53,
  111,
  54,
  113,
  55,
  115,
  56,
  117,
  57,
  119,
  0,
  121,
  0,
  123,
  58,
  125,
  59,
  127,
  60,
  129,
  61,
  131,
  62,
  133,
  63,
  135,
  64,
  137,
  65,
  139,
  66,
  141,
  67,
  143,
  68,
  145,
  69,
  147,
  70,
  3,
  0,
  1,
  2,
  8,
  2,
  0,
  9,
  9,
  32,
  32,
  3,
  0,
  48,
  57,
  65,
  70,
  97,
  102,
  4,
  0,
  48,
  57,
  65,
  90,
  95,
  95,
  97,
  122,
  3,
  0,
  65,
  90,
  95,
  95,
  97,
  122,
  2,
  0,
  65,
  90,
  97,
  122,
  1,
  0,
  48,
  57,
  3,
  0,
  10,
  10,
  13,
  13,
  34,
  34,
  2,
  0,
  10,
  10,
  13,
  13,
  593,
  0,
  3,
  1,
  0,
  0,
  0,
  0,
  5,
  1,
  0,
  0,
  0,
  0,
  7,
  1,
  0,
  0,
  0,
  0,
  9,
  1,
  0,
  0,
  0,
  0,
  11,
  1,
  0,
  0,
  0,
  0,
  13,
  1,
  0,
  0,
  0,
  0,
  15,
  1,
  0,
  0,
  0,
  0,
  17,
  1,
  0,
  0,
  0,
  0,
  19,
  1,
  0,
  0,
  0,
  0,
  21,
  1,
  0,
  0,
  0,
  0,
  25,
  1,
  0,
  0,
  0,
  0,
  27,
  1,
  0,
  0,
  0,
  0,
  29,
  1,
  0,
  0,
  0,
  0,
  31,
  1,
  0,
  0,
  0,
  0,
  33,
  1,
  0,
  0,
  0,
  0,
  35,
  1,
  0,
  0,
  0,
  0,
  37,
  1,
  0,
  0,
  0,
  0,
  39,
  1,
  0,
  0,
  0,
  0,
  41,
  1,
  0,
  0,
  0,
  0,
  43,
  1,
  0,
  0,
  0,
  0,
  45,
  1,
  0,
  0,
  0,
  0,
  47,
  1,
  0,
  0,
  0,
  0,
  49,
  1,
  0,
  0,
  0,
  0,
  51,
  1,
  0,
  0,
  0,
  0,
  53,
  1,
  0,
  0,
  0,
  0,
  55,
  1,
  0,
  0,
  0,
  0,
  57,
  1,
  0,
  0,
  0,
  0,
  59,
  1,
  0,
  0,
  0,
  0,
  61,
  1,
  0,
  0,
  0,
  0,
  63,
  1,
  0,
  0,
  0,
  0,
  65,
  1,
  0,
  0,
  0,
  0,
  67,
  1,
  0,
  0,
  0,
  0,
  69,
  1,
  0,
  0,
  0,
  0,
  71,
  1,
  0,
  0,
  0,
  0,
  73,
  1,
  0,
  0,
  0,
  0,
  75,
  1,
  0,
  0,
  0,
  0,
  77,
  1,
  0,
  0,
  0,
  0,
  79,
  1,
  0,
  0,
  0,
  0,
  81,
  1,
  0,
  0,
  0,
  0,
  83,
  1,
  0,
  0,
  0,
  0,
  85,
  1,
  0,
  0,
  0,
  0,
  87,
  1,
  0,
  0,
  0,
  0,
  89,
  1,
  0,
  0,
  0,
  0,
  91,
  1,
  0,
  0,
  0,
  0,
  93,
  1,
  0,
  0,
  0,
  0,
  95,
  1,
  0,
  0,
  0,
  0,
  97,
  1,
  0,
  0,
  0,
  0,
  99,
  1,
  0,
  0,
  0,
  0,
  101,
  1,
  0,
  0,
  0,
  0,
  103,
  1,
  0,
  0,
  0,
  0,
  105,
  1,
  0,
  0,
  0,
  0,
  107,
  1,
  0,
  0,
  0,
  0,
  109,
  1,
  0,
  0,
  0,
  0,
  111,
  1,
  0,
  0,
  0,
  0,
  113,
  1,
  0,
  0,
  0,
  0,
  115,
  1,
  0,
  0,
  0,
  0,
  117,
  1,
  0,
  0,
  0,
  0,
  123,
  1,
  0,
  0,
  0,
  0,
  125,
  1,
  0,
  0,
  0,
  0,
  127,
  1,
  0,
  0,
  0,
  0,
  129,
  1,
  0,
  0,
  0,
  0,
  131,
  1,
  0,
  0,
  0,
  0,
  133,
  1,
  0,
  0,
  0,
  0,
  135,
  1,
  0,
  0,
  0,
  0,
  137,
  1,
  0,
  0,
  0,
  0,
  139,
  1,
  0,
  0,
  0,
  1,
  141,
  1,
  0,
  0,
  0,
  1,
  143,
  1,
  0,
  0,
  0,
  2,
  145,
  1,
  0,
  0,
  0,
  2,
  147,
  1,
  0,
  0,
  0,
  3,
  149,
  1,
  0,
  0,
  0,
  5,
  153,
  1,
  0,
  0,
  0,
  7,
  161,
  1,
  0,
  0,
  0,
  9,
  172,
  1,
  0,
  0,
  0,
  11,
  181,
  1,
  0,
  0,
  0,
  13,
  189,
  1,
  0,
  0,
  0,
  15,
  197,
  1,
  0,
  0,
  0,
  17,
  201,
  1,
  0,
  0,
  0,
  19,
  204,
  1,
  0,
  0,
  0,
  21,
  207,
  1,
  0,
  0,
  0,
  23,
  210,
  1,
  0,
  0,
  0,
  25,
  212,
  1,
  0,
  0,
  0,
  27,
  218,
  1,
  0,
  0,
  0,
  29,
  221,
  1,
  0,
  0,
  0,
  31,
  224,
  1,
  0,
  0,
  0,
  33,
  227,
  1,
  0,
  0,
  0,
  35,
  230,
  1,
  0,
  0,
  0,
  37,
  232,
  1,
  0,
  0,
  0,
  39,
  234,
  1,
  0,
  0,
  0,
  41,
  237,
  1,
  0,
  0,
  0,
  43,
  240,
  1,
  0,
  0,
  0,
  45,
  242,
  1,
  0,
  0,
  0,
  47,
  244,
  1,
  0,
  0,
  0,
  49,
  246,
  1,
  0,
  0,
  0,
  51,
  248,
  1,
  0,
  0,
  0,
  53,
  250,
  1,
  0,
  0,
  0,
  55,
  252,
  1,
  0,
  0,
  0,
  57,
  254,
  1,
  0,
  0,
  0,
  59,
  256,
  1,
  0,
  0,
  0,
  61,
  258,
  1,
  0,
  0,
  0,
  63,
  260,
  1,
  0,
  0,
  0,
  65,
  262,
  1,
  0,
  0,
  0,
  67,
  264,
  1,
  0,
  0,
  0,
  69,
  266,
  1,
  0,
  0,
  0,
  71,
  268,
  1,
  0,
  0,
  0,
  73,
  273,
  1,
  0,
  0,
  0,
  75,
  286,
  1,
  0,
  0,
  0,
  77,
  288,
  1,
  0,
  0,
  0,
  79,
  291,
  1,
  0,
  0,
  0,
  81,
  322,
  1,
  0,
  0,
  0,
  83,
  324,
  1,
  0,
  0,
  0,
  85,
  331,
  1,
  0,
  0,
  0,
  87,
  335,
  1,
  0,
  0,
  0,
  89,
  339,
  1,
  0,
  0,
  0,
  91,
  345,
  1,
  0,
  0,
  0,
  93,
  349,
  1,
  0,
  0,
  0,
  95,
  370,
  1,
  0,
  0,
  0,
  97,
  372,
  1,
  0,
  0,
  0,
  99,
  376,
  1,
  0,
  0,
  0,
  101,
  379,
  1,
  0,
  0,
  0,
  103,
  383,
  1,
  0,
  0,
  0,
  105,
  389,
  1,
  0,
  0,
  0,
  107,
  397,
  1,
  0,
  0,
  0,
  109,
  416,
  1,
  0,
  0,
  0,
  111,
  444,
  1,
  0,
  0,
  0,
  113,
  446,
  1,
  0,
  0,
  0,
  115,
  453,
  1,
  0,
  0,
  0,
  117,
  455,
  1,
  0,
  0,
  0,
  119,
  463,
  1,
  0,
  0,
  0,
  121,
  467,
  1,
  0,
  0,
  0,
  123,
  470,
  1,
  0,
  0,
  0,
  125,
  492,
  1,
  0,
  0,
  0,
  127,
  494,
  1,
  0,
  0,
  0,
  129,
  501,
  1,
  0,
  0,
  0,
  131,
  505,
  1,
  0,
  0,
  0,
  133,
  517,
  1,
  0,
  0,
  0,
  135,
  521,
  1,
  0,
  0,
  0,
  137,
  534,
  1,
  0,
  0,
  0,
  139,
  536,
  1,
  0,
  0,
  0,
  141,
  553,
  1,
  0,
  0,
  0,
  143,
  557,
  1,
  0,
  0,
  0,
  145,
  562,
  1,
  0,
  0,
  0,
  147,
  566,
  1,
  0,
  0,
  0,
  149,
  150,
  7,
  0,
  0,
  0,
  150,
  151,
  1,
  0,
  0,
  0,
  151,
  152,
  6,
  0,
  0,
  0,
  152,
  4,
  1,
  0,
  0,
  0,
  153,
  154,
  5,
  99,
  0,
  0,
  154,
  155,
  5,
  111,
  0,
  0,
  155,
  156,
  5,
  110,
  0,
  0,
  156,
  157,
  5,
  115,
  0,
  0,
  157,
  158,
  5,
  116,
  0,
  0,
  158,
  159,
  1,
  0,
  0,
  0,
  159,
  160,
  6,
  1,
  1,
  0,
  160,
  6,
  1,
  0,
  0,
  0,
  161,
  162,
  5,
  114,
  0,
  0,
  162,
  163,
  5,
  101,
  0,
  0,
  163,
  164,
  5,
  97,
  0,
  0,
  164,
  165,
  5,
  100,
  0,
  0,
  165,
  166,
  5,
  111,
  0,
  0,
  166,
  167,
  5,
  110,
  0,
  0,
  167,
  168,
  5,
  108,
  0,
  0,
  168,
  169,
  5,
  121,
  0,
  0,
  169,
  170,
  1,
  0,
  0,
  0,
  170,
  171,
  6,
  2,
  1,
  0,
  171,
  8,
  1,
  0,
  0,
  0,
  172,
  173,
  5,
  115,
  0,
  0,
  173,
  174,
  5,
  116,
  0,
  0,
  174,
  175,
  5,
  97,
  0,
  0,
  175,
  176,
  5,
  116,
  0,
  0,
  176,
  177,
  5,
  105,
  0,
  0,
  177,
  178,
  5,
  99,
  0,
  0,
  178,
  179,
  1,
  0,
  0,
  0,
  179,
  180,
  6,
  3,
  1,
  0,
  180,
  10,
  1,
  0,
  0,
  0,
  181,
  182,
  5,
  97,
  0,
  0,
  182,
  183,
  5,
  119,
  0,
  0,
  183,
  184,
  5,
  97,
  0,
  0,
  184,
  185,
  5,
  105,
  0,
  0,
  185,
  186,
  5,
  116,
  0,
  0,
  186,
  187,
  1,
  0,
  0,
  0,
  187,
  188,
  6,
  4,
  1,
  0,
  188,
  12,
  1,
  0,
  0,
  0,
  189,
  190,
  5,
  116,
  0,
  0,
  190,
  191,
  5,
  105,
  0,
  0,
  191,
  192,
  5,
  116,
  0,
  0,
  192,
  193,
  5,
  108,
  0,
  0,
  193,
  194,
  5,
  101,
  0,
  0,
  194,
  195,
  1,
  0,
  0,
  0,
  195,
  196,
  6,
  5,
  2,
  0,
  196,
  14,
  1,
  0,
  0,
  0,
  197,
  198,
  5,
  58,
  0,
  0,
  198,
  199,
  1,
  0,
  0,
  0,
  199,
  200,
  6,
  6,
  3,
  0,
  200,
  16,
  1,
  0,
  0,
  0,
  201,
  202,
  5,
  60,
  0,
  0,
  202,
  203,
  5,
  60,
  0,
  0,
  203,
  18,
  1,
  0,
  0,
  0,
  204,
  205,
  5,
  62,
  0,
  0,
  205,
  206,
  5,
  62,
  0,
  0,
  206,
  20,
  1,
  0,
  0,
  0,
  207,
  208,
  5,
  45,
  0,
  0,
  208,
  209,
  5,
  62,
  0,
  0,
  209,
  22,
  1,
  0,
  0,
  0,
  210,
  211,
  7,
  1,
  0,
  0,
  211,
  24,
  1,
  0,
  0,
  0,
  212,
  214,
  5,
  35,
  0,
  0,
  213,
  215,
  3,
  23,
  10,
  0,
  214,
  213,
  1,
  0,
  0,
  0,
  215,
  216,
  1,
  0,
  0,
  0,
  216,
  214,
  1,
  0,
  0,
  0,
  216,
  217,
  1,
  0,
  0,
  0,
  217,
  26,
  1,
  0,
  0,
  0,
  218,
  219,
  5,
  124,
  0,
  0,
  219,
  220,
  5,
  124,
  0,
  0,
  220,
  28,
  1,
  0,
  0,
  0,
  221,
  222,
  5,
  38,
  0,
  0,
  222,
  223,
  5,
  38,
  0,
  0,
  223,
  30,
  1,
  0,
  0,
  0,
  224,
  225,
  5,
  61,
  0,
  0,
  225,
  226,
  5,
  61,
  0,
  0,
  226,
  32,
  1,
  0,
  0,
  0,
  227,
  228,
  5,
  33,
  0,
  0,
  228,
  229,
  5,
  61,
  0,
  0,
  229,
  34,
  1,
  0,
  0,
  0,
  230,
  231,
  5,
  62,
  0,
  0,
  231,
  36,
  1,
  0,
  0,
  0,
  232,
  233,
  5,
  60,
  0,
  0,
  233,
  38,
  1,
  0,
  0,
  0,
  234,
  235,
  5,
  62,
  0,
  0,
  235,
  236,
  5,
  61,
  0,
  0,
  236,
  40,
  1,
  0,
  0,
  0,
  237,
  238,
  5,
  60,
  0,
  0,
  238,
  239,
  5,
  61,
  0,
  0,
  239,
  42,
  1,
  0,
  0,
  0,
  240,
  241,
  5,
  43,
  0,
  0,
  241,
  44,
  1,
  0,
  0,
  0,
  242,
  243,
  5,
  45,
  0,
  0,
  243,
  46,
  1,
  0,
  0,
  0,
  244,
  245,
  5,
  42,
  0,
  0,
  245,
  48,
  1,
  0,
  0,
  0,
  246,
  247,
  5,
  47,
  0,
  0,
  247,
  50,
  1,
  0,
  0,
  0,
  248,
  249,
  5,
  37,
  0,
  0,
  249,
  52,
  1,
  0,
  0,
  0,
  250,
  251,
  5,
  94,
  0,
  0,
  251,
  54,
  1,
  0,
  0,
  0,
  252,
  253,
  5,
  33,
  0,
  0,
  253,
  56,
  1,
  0,
  0,
  0,
  254,
  255,
  5,
  59,
  0,
  0,
  255,
  58,
  1,
  0,
  0,
  0,
  256,
  257,
  5,
  44,
  0,
  0,
  257,
  60,
  1,
  0,
  0,
  0,
  258,
  259,
  5,
  61,
  0,
  0,
  259,
  62,
  1,
  0,
  0,
  0,
  260,
  261,
  5,
  40,
  0,
  0,
  261,
  64,
  1,
  0,
  0,
  0,
  262,
  263,
  5,
  41,
  0,
  0,
  263,
  66,
  1,
  0,
  0,
  0,
  264,
  265,
  5,
  123,
  0,
  0,
  265,
  68,
  1,
  0,
  0,
  0,
  266,
  267,
  5,
  125,
  0,
  0,
  267,
  70,
  1,
  0,
  0,
  0,
  268,
  269,
  5,
  116,
  0,
  0,
  269,
  270,
  5,
  114,
  0,
  0,
  270,
  271,
  5,
  117,
  0,
  0,
  271,
  272,
  5,
  101,
  0,
  0,
  272,
  72,
  1,
  0,
  0,
  0,
  273,
  274,
  5,
  102,
  0,
  0,
  274,
  275,
  5,
  97,
  0,
  0,
  275,
  276,
  5,
  108,
  0,
  0,
  276,
  277,
  5,
  115,
  0,
  0,
  277,
  278,
  5,
  101,
  0,
  0,
  278,
  74,
  1,
  0,
  0,
  0,
  279,
  280,
  5,
  110,
  0,
  0,
  280,
  281,
  5,
  105,
  0,
  0,
  281,
  287,
  5,
  108,
  0,
  0,
  282,
  283,
  5,
  110,
  0,
  0,
  283,
  284,
  5,
  117,
  0,
  0,
  284,
  285,
  5,
  108,
  0,
  0,
  285,
  287,
  5,
  108,
  0,
  0,
  286,
  279,
  1,
  0,
  0,
  0,
  286,
  282,
  1,
  0,
  0,
  0,
  287,
  76,
  1,
  0,
  0,
  0,
  288,
  289,
  5,
  105,
  0,
  0,
  289,
  290,
  5,
  102,
  0,
  0,
  290,
  78,
  1,
  0,
  0,
  0,
  291,
  292,
  5,
  101,
  0,
  0,
  292,
  293,
  5,
  108,
  0,
  0,
  293,
  294,
  5,
  115,
  0,
  0,
  294,
  295,
  5,
  101,
  0,
  0,
  295,
  80,
  1,
  0,
  0,
  0,
  296,
  297,
  5,
  119,
  0,
  0,
  297,
  298,
  5,
  104,
  0,
  0,
  298,
  299,
  5,
  105,
  0,
  0,
  299,
  300,
  5,
  108,
  0,
  0,
  300,
  323,
  5,
  101,
  0,
  0,
  301,
  302,
  5,
  102,
  0,
  0,
  302,
  303,
  5,
  111,
  0,
  0,
  303,
  323,
  5,
  114,
  0,
  0,
  304,
  305,
  5,
  102,
  0,
  0,
  305,
  306,
  5,
  111,
  0,
  0,
  306,
  307,
  5,
  114,
  0,
  0,
  307,
  308,
  5,
  101,
  0,
  0,
  308,
  309,
  5,
  97,
  0,
  0,
  309,
  310,
  5,
  99,
  0,
  0,
  310,
  323,
  5,
  104,
  0,
  0,
  311,
  312,
  5,
  102,
  0,
  0,
  312,
  313,
  5,
  111,
  0,
  0,
  313,
  314,
  5,
  114,
  0,
  0,
  314,
  315,
  5,
  69,
  0,
  0,
  315,
  316,
  5,
  97,
  0,
  0,
  316,
  317,
  5,
  99,
  0,
  0,
  317,
  323,
  5,
  104,
  0,
  0,
  318,
  319,
  5,
  108,
  0,
  0,
  319,
  320,
  5,
  111,
  0,
  0,
  320,
  321,
  5,
  111,
  0,
  0,
  321,
  323,
  5,
  112,
  0,
  0,
  322,
  296,
  1,
  0,
  0,
  0,
  322,
  301,
  1,
  0,
  0,
  0,
  322,
  304,
  1,
  0,
  0,
  0,
  322,
  311,
  1,
  0,
  0,
  0,
  322,
  318,
  1,
  0,
  0,
  0,
  323,
  82,
  1,
  0,
  0,
  0,
  324,
  325,
  5,
  114,
  0,
  0,
  325,
  326,
  5,
  101,
  0,
  0,
  326,
  327,
  5,
  116,
  0,
  0,
  327,
  328,
  5,
  117,
  0,
  0,
  328,
  329,
  5,
  114,
  0,
  0,
  329,
  330,
  5,
  110,
  0,
  0,
  330,
  84,
  1,
  0,
  0,
  0,
  331,
  332,
  5,
  110,
  0,
  0,
  332,
  333,
  5,
  101,
  0,
  0,
  333,
  334,
  5,
  119,
  0,
  0,
  334,
  86,
  1,
  0,
  0,
  0,
  335,
  336,
  5,
  112,
  0,
  0,
  336,
  337,
  5,
  97,
  0,
  0,
  337,
  338,
  5,
  114,
  0,
  0,
  338,
  88,
  1,
  0,
  0,
  0,
  339,
  340,
  5,
  103,
  0,
  0,
  340,
  341,
  5,
  114,
  0,
  0,
  341,
  342,
  5,
  111,
  0,
  0,
  342,
  343,
  5,
  117,
  0,
  0,
  343,
  344,
  5,
  112,
  0,
  0,
  344,
  90,
  1,
  0,
  0,
  0,
  345,
  346,
  5,
  111,
  0,
  0,
  346,
  347,
  5,
  112,
  0,
  0,
  347,
  348,
  5,
  116,
  0,
  0,
  348,
  92,
  1,
  0,
  0,
  0,
  349,
  350,
  5,
  99,
  0,
  0,
  350,
  351,
  5,
  114,
  0,
  0,
  351,
  352,
  5,
  105,
  0,
  0,
  352,
  353,
  5,
  116,
  0,
  0,
  353,
  354,
  5,
  105,
  0,
  0,
  354,
  355,
  5,
  99,
  0,
  0,
  355,
  356,
  5,
  97,
  0,
  0,
  356,
  357,
  5,
  108,
  0,
  0,
  357,
  94,
  1,
  0,
  0,
  0,
  358,
  359,
  5,
  115,
  0,
  0,
  359,
  360,
  5,
  101,
  0,
  0,
  360,
  361,
  5,
  99,
  0,
  0,
  361,
  362,
  5,
  116,
  0,
  0,
  362,
  363,
  5,
  105,
  0,
  0,
  363,
  364,
  5,
  111,
  0,
  0,
  364,
  371,
  5,
  110,
  0,
  0,
  365,
  366,
  5,
  102,
  0,
  0,
  366,
  367,
  5,
  114,
  0,
  0,
  367,
  368,
  5,
  97,
  0,
  0,
  368,
  369,
  5,
  109,
  0,
  0,
  369,
  371,
  5,
  101,
  0,
  0,
  370,
  358,
  1,
  0,
  0,
  0,
  370,
  365,
  1,
  0,
  0,
  0,
  371,
  96,
  1,
  0,
  0,
  0,
  372,
  373,
  5,
  114,
  0,
  0,
  373,
  374,
  5,
  101,
  0,
  0,
  374,
  375,
  5,
  102,
  0,
  0,
  375,
  98,
  1,
  0,
  0,
  0,
  376,
  377,
  5,
  97,
  0,
  0,
  377,
  378,
  5,
  115,
  0,
  0,
  378,
  100,
  1,
  0,
  0,
  0,
  379,
  380,
  5,
  116,
  0,
  0,
  380,
  381,
  5,
  114,
  0,
  0,
  381,
  382,
  5,
  121,
  0,
  0,
  382,
  102,
  1,
  0,
  0,
  0,
  383,
  384,
  5,
  99,
  0,
  0,
  384,
  385,
  5,
  97,
  0,
  0,
  385,
  386,
  5,
  116,
  0,
  0,
  386,
  387,
  5,
  99,
  0,
  0,
  387,
  388,
  5,
  104,
  0,
  0,
  388,
  104,
  1,
  0,
  0,
  0,
  389,
  390,
  5,
  102,
  0,
  0,
  390,
  391,
  5,
  105,
  0,
  0,
  391,
  392,
  5,
  110,
  0,
  0,
  392,
  393,
  5,
  97,
  0,
  0,
  393,
  394,
  5,
  108,
  0,
  0,
  394,
  395,
  5,
  108,
  0,
  0,
  395,
  396,
  5,
  121,
  0,
  0,
  396,
  106,
  1,
  0,
  0,
  0,
  397,
  398,
  5,
  105,
  0,
  0,
  398,
  399,
  5,
  110,
  0,
  0,
  399,
  108,
  1,
  0,
  0,
  0,
  400,
  401,
  5,
  64,
  0,
  0,
  401,
  402,
  5,
  83,
  0,
  0,
  402,
  403,
  5,
  116,
  0,
  0,
  403,
  404,
  5,
  97,
  0,
  0,
  404,
  405,
  5,
  114,
  0,
  0,
  405,
  406,
  5,
  116,
  0,
  0,
  406,
  407,
  5,
  101,
  0,
  0,
  407,
  417,
  5,
  114,
  0,
  0,
  408,
  409,
  5,
  64,
  0,
  0,
  409,
  410,
  5,
  115,
  0,
  0,
  410,
  411,
  5,
  116,
  0,
  0,
  411,
  412,
  5,
  97,
  0,
  0,
  412,
  413,
  5,
  114,
  0,
  0,
  413,
  414,
  5,
  116,
  0,
  0,
  414,
  415,
  5,
  101,
  0,
  0,
  415,
  417,
  5,
  114,
  0,
  0,
  416,
  400,
  1,
  0,
  0,
  0,
  416,
  408,
  1,
  0,
  0,
  0,
  417,
  110,
  1,
  0,
  0,
  0,
  418,
  419,
  5,
  64,
  0,
  0,
  419,
  420,
  5,
  82,
  0,
  0,
  420,
  421,
  5,
  101,
  0,
  0,
  421,
  422,
  5,
  116,
  0,
  0,
  422,
  423,
  5,
  117,
  0,
  0,
  423,
  424,
  5,
  114,
  0,
  0,
  424,
  445,
  5,
  110,
  0,
  0,
  425,
  426,
  5,
  64,
  0,
  0,
  426,
  427,
  5,
  114,
  0,
  0,
  427,
  428,
  5,
  101,
  0,
  0,
  428,
  429,
  5,
  116,
  0,
  0,
  429,
  430,
  5,
  117,
  0,
  0,
  430,
  431,
  5,
  114,
  0,
  0,
  431,
  445,
  5,
  110,
  0,
  0,
  432,
  433,
  5,
  64,
  0,
  0,
  433,
  434,
  5,
  82,
  0,
  0,
  434,
  435,
  5,
  101,
  0,
  0,
  435,
  436,
  5,
  112,
  0,
  0,
  436,
  437,
  5,
  108,
  0,
  0,
  437,
  445,
  5,
  121,
  0,
  0,
  438,
  439,
  5,
  64,
  0,
  0,
  439,
  440,
  5,
  114,
  0,
  0,
  440,
  441,
  5,
  101,
  0,
  0,
  441,
  442,
  5,
  112,
  0,
  0,
  442,
  443,
  5,
  108,
  0,
  0,
  443,
  445,
  5,
  121,
  0,
  0,
  444,
  418,
  1,
  0,
  0,
  0,
  444,
  425,
  1,
  0,
  0,
  0,
  444,
  432,
  1,
  0,
  0,
  0,
  444,
  438,
  1,
  0,
  0,
  0,
  445,
  112,
  1,
  0,
  0,
  0,
  446,
  450,
  5,
  64,
  0,
  0,
  447,
  449,
  7,
  2,
  0,
  0,
  448,
  447,
  1,
  0,
  0,
  0,
  449,
  452,
  1,
  0,
  0,
  0,
  450,
  448,
  1,
  0,
  0,
  0,
  450,
  451,
  1,
  0,
  0,
  0,
  451,
  114,
  1,
  0,
  0,
  0,
  452,
  450,
  1,
  0,
  0,
  0,
  453,
  454,
  5,
  46,
  0,
  0,
  454,
  116,
  1,
  0,
  0,
  0,
  455,
  459,
  7,
  3,
  0,
  0,
  456,
  458,
  7,
  2,
  0,
  0,
  457,
  456,
  1,
  0,
  0,
  0,
  458,
  461,
  1,
  0,
  0,
  0,
  459,
  457,
  1,
  0,
  0,
  0,
  459,
  460,
  1,
  0,
  0,
  0,
  460,
  118,
  1,
  0,
  0,
  0,
  461,
  459,
  1,
  0,
  0,
  0,
  462,
  464,
  7,
  4,
  0,
  0,
  463,
  462,
  1,
  0,
  0,
  0,
  464,
  465,
  1,
  0,
  0,
  0,
  465,
  463,
  1,
  0,
  0,
  0,
  465,
  466,
  1,
  0,
  0,
  0,
  466,
  120,
  1,
  0,
  0,
  0,
  467,
  468,
  7,
  5,
  0,
  0,
  468,
  122,
  1,
  0,
  0,
  0,
  469,
  471,
  3,
  121,
  59,
  0,
  470,
  469,
  1,
  0,
  0,
  0,
  471,
  472,
  1,
  0,
  0,
  0,
  472,
  470,
  1,
  0,
  0,
  0,
  472,
  473,
  1,
  0,
  0,
  0,
  473,
  124,
  1,
  0,
  0,
  0,
  474,
  476,
  3,
  121,
  59,
  0,
  475,
  474,
  1,
  0,
  0,
  0,
  476,
  477,
  1,
  0,
  0,
  0,
  477,
  475,
  1,
  0,
  0,
  0,
  477,
  478,
  1,
  0,
  0,
  0,
  478,
  479,
  1,
  0,
  0,
  0,
  479,
  483,
  5,
  46,
  0,
  0,
  480,
  482,
  3,
  121,
  59,
  0,
  481,
  480,
  1,
  0,
  0,
  0,
  482,
  485,
  1,
  0,
  0,
  0,
  483,
  481,
  1,
  0,
  0,
  0,
  483,
  484,
  1,
  0,
  0,
  0,
  484,
  493,
  1,
  0,
  0,
  0,
  485,
  483,
  1,
  0,
  0,
  0,
  486,
  488,
  5,
  46,
  0,
  0,
  487,
  489,
  3,
  121,
  59,
  0,
  488,
  487,
  1,
  0,
  0,
  0,
  489,
  490,
  1,
  0,
  0,
  0,
  490,
  488,
  1,
  0,
  0,
  0,
  490,
  491,
  1,
  0,
  0,
  0,
  491,
  493,
  1,
  0,
  0,
  0,
  492,
  475,
  1,
  0,
  0,
  0,
  492,
  486,
  1,
  0,
  0,
  0,
  493,
  126,
  1,
  0,
  0,
  0,
  494,
  497,
  5,
  36,
  0,
  0,
  495,
  498,
  3,
  123,
  60,
  0,
  496,
  498,
  3,
  125,
  61,
  0,
  497,
  495,
  1,
  0,
  0,
  0,
  497,
  496,
  1,
  0,
  0,
  0,
  498,
  128,
  1,
  0,
  0,
  0,
  499,
  502,
  3,
  123,
  60,
  0,
  500,
  502,
  3,
  125,
  61,
  0,
  501,
  499,
  1,
  0,
  0,
  0,
  501,
  500,
  1,
  0,
  0,
  0,
  502,
  503,
  1,
  0,
  0,
  0,
  503,
  504,
  3,
  119,
  58,
  0,
  504,
  130,
  1,
  0,
  0,
  0,
  505,
  511,
  5,
  34,
  0,
  0,
  506,
  510,
  8,
  6,
  0,
  0,
  507,
  508,
  5,
  34,
  0,
  0,
  508,
  510,
  5,
  34,
  0,
  0,
  509,
  506,
  1,
  0,
  0,
  0,
  509,
  507,
  1,
  0,
  0,
  0,
  510,
  513,
  1,
  0,
  0,
  0,
  511,
  509,
  1,
  0,
  0,
  0,
  511,
  512,
  1,
  0,
  0,
  0,
  512,
  515,
  1,
  0,
  0,
  0,
  513,
  511,
  1,
  0,
  0,
  0,
  514,
  516,
  7,
  6,
  0,
  0,
  515,
  514,
  1,
  0,
  0,
  0,
  515,
  516,
  1,
  0,
  0,
  0,
  516,
  132,
  1,
  0,
  0,
  0,
  517,
  518,
  7,
  7,
  0,
  0,
  518,
  519,
  1,
  0,
  0,
  0,
  519,
  520,
  6,
  65,
  0,
  0,
  520,
  134,
  1,
  0,
  0,
  0,
  521,
  522,
  5,
  47,
  0,
  0,
  522,
  523,
  5,
  47,
  0,
  0,
  523,
  527,
  1,
  0,
  0,
  0,
  524,
  526,
  9,
  0,
  0,
  0,
  525,
  524,
  1,
  0,
  0,
  0,
  526,
  529,
  1,
  0,
  0,
  0,
  527,
  528,
  1,
  0,
  0,
  0,
  527,
  525,
  1,
  0,
  0,
  0,
  528,
  530,
  1,
  0,
  0,
  0,
  529,
  527,
  1,
  0,
  0,
  0,
  530,
  531,
  5,
  10,
  0,
  0,
  531,
  532,
  1,
  0,
  0,
  0,
  532,
  533,
  6,
  66,
  4,
  0,
  533,
  136,
  1,
  0,
  0,
  0,
  534,
  535,
  9,
  0,
  0,
  0,
  535,
  138,
  1,
  0,
  0,
  0,
  536,
  540,
  4,
  68,
  0,
  0,
  537,
  539,
  3,
  3,
  0,
  0,
  538,
  537,
  1,
  0,
  0,
  0,
  539,
  542,
  1,
  0,
  0,
  0,
  540,
  538,
  1,
  0,
  0,
  0,
  540,
  541,
  1,
  0,
  0,
  0,
  541,
  543,
  1,
  0,
  0,
  0,
  542,
  540,
  1,
  0,
  0,
  0,
  543,
  544,
  5,
  61,
  0,
  0,
  544,
  545,
  5,
  61,
  0,
  0,
  545,
  549,
  1,
  0,
  0,
  0,
  546,
  548,
  8,
  7,
  0,
  0,
  547,
  546,
  1,
  0,
  0,
  0,
  548,
  551,
  1,
  0,
  0,
  0,
  549,
  547,
  1,
  0,
  0,
  0,
  549,
  550,
  1,
  0,
  0,
  0,
  550,
  140,
  1,
  0,
  0,
  0,
  551,
  549,
  1,
  0,
  0,
  0,
  552,
  554,
  8,
  7,
  0,
  0,
  553,
  552,
  1,
  0,
  0,
  0,
  554,
  555,
  1,
  0,
  0,
  0,
  555,
  553,
  1,
  0,
  0,
  0,
  555,
  556,
  1,
  0,
  0,
  0,
  556,
  142,
  1,
  0,
  0,
  0,
  557,
  558,
  7,
  7,
  0,
  0,
  558,
  559,
  1,
  0,
  0,
  0,
  559,
  560,
  6,
  70,
  5,
  0,
  560,
  144,
  1,
  0,
  0,
  0,
  561,
  563,
  8,
  7,
  0,
  0,
  562,
  561,
  1,
  0,
  0,
  0,
  563,
  564,
  1,
  0,
  0,
  0,
  564,
  562,
  1,
  0,
  0,
  0,
  564,
  565,
  1,
  0,
  0,
  0,
  565,
  146,
  1,
  0,
  0,
  0,
  566,
  567,
  7,
  7,
  0,
  0,
  567,
  568,
  1,
  0,
  0,
  0,
  568,
  569,
  6,
  72,
  5,
  0,
  569,
  148,
  1,
  0,
  0,
  0,
  27,
  0,
  1,
  2,
  216,
  286,
  322,
  370,
  416,
  444,
  450,
  459,
  465,
  472,
  477,
  483,
  490,
  492,
  497,
  501,
  509,
  511,
  515,
  527,
  540,
  549,
  555,
  564,
  6,
  0,
  1,
  0,
  0,
  3,
  0,
  5,
  2,
  0,
  5,
  1,
  0,
  0,
  2,
  0,
  4,
  0,
  0
], N6 = new y.atn.ATNDeserializer().deserialize(hg), dg = N6.decisionToState.map((t, e) => new y.dfa.DFA(t, e));
class X extends y.Lexer {
  constructor(e) {
    super(e), this._interp = new y.atn.LexerATNSimulator(this, N6, dg, new y.PredictionContextCache());
  }
  get atn() {
    return N6;
  }
}
V2(X, "grammarFileName", "sequenceLexer.g4"), V2(X, "channelNames", [
  "DEFAULT_TOKEN_CHANNEL",
  "HIDDEN",
  "COMMENT_CHANNEL",
  "MODIFIER_CHANNEL"
]), V2(X, "modeNames", ["DEFAULT_MODE", "EVENT", "TITLE_MODE"]), V2(X, "literalNames", [
  null,
  null,
  "'const'",
  "'readonly'",
  "'static'",
  "'await'",
  "'title'",
  "':'",
  "'<<'",
  "'>>'",
  "'->'",
  null,
  "'||'",
  "'&&'",
  "'=='",
  "'!='",
  "'>'",
  "'<'",
  "'>='",
  "'<='",
  "'+'",
  "'-'",
  "'*'",
  "'/'",
  "'%'",
  "'^'",
  "'!'",
  "';'",
  "','",
  "'='",
  "'('",
  "')'",
  "'{'",
  "'}'",
  "'true'",
  "'false'",
  null,
  "'if'",
  "'else'",
  null,
  "'return'",
  "'new'",
  "'par'",
  "'group'",
  "'opt'",
  "'critical'",
  null,
  "'ref'",
  "'as'",
  "'try'",
  "'catch'",
  "'finally'",
  "'in'",
  null,
  null,
  null,
  "'.'"
]), V2(X, "symbolicNames", [
  null,
  "WS",
  "CONSTANT",
  "READONLY",
  "STATIC",
  "AWAIT",
  "TITLE",
  "COL",
  "SOPEN",
  "SCLOSE",
  "ARROW",
  "COLOR",
  "OR",
  "AND",
  "EQ",
  "NEQ",
  "GT",
  "LT",
  "GTEQ",
  "LTEQ",
  "PLUS",
  "MINUS",
  "MULT",
  "DIV",
  "MOD",
  "POW",
  "NOT",
  "SCOL",
  "COMMA",
  "ASSIGN",
  "OPAR",
  "CPAR",
  "OBRACE",
  "CBRACE",
  "TRUE",
  "FALSE",
  "NIL",
  "IF",
  "ELSE",
  "WHILE",
  "RETURN",
  "NEW",
  "PAR",
  "GROUP",
  "OPT",
  "CRITICAL",
  "SECTION",
  "REF",
  "AS",
  "TRY",
  "CATCH",
  "FINALLY",
  "IN",
  "STARTER_LXR",
  "ANNOTATION_RET",
  "ANNOTATION",
  "DOT",
  "ID",
  "INT",
  "FLOAT",
  "MONEY",
  "NUMBER_UNIT",
  "STRING",
  "CR",
  "COMMENT",
  "OTHER",
  "DIVIDER",
  "EVENT_PAYLOAD_LXR",
  "EVENT_END",
  "TITLE_CONTENT",
  "TITLE_END"
]), V2(X, "ruleNames", [
  "WS",
  "CONSTANT",
  "READONLY",
  "STATIC",
  "AWAIT",
  "TITLE",
  "COL",
  "SOPEN",
  "SCLOSE",
  "ARROW",
  "HEX",
  "COLOR",
  "OR",
  "AND",
  "EQ",
  "NEQ",
  "GT",
  "LT",
  "GTEQ",
  "LTEQ",
  "PLUS",
  "MINUS",
  "MULT",
  "DIV",
  "MOD",
  "POW",
  "NOT",
  "SCOL",
  "COMMA",
  "ASSIGN",
  "OPAR",
  "CPAR",
  "OBRACE",
  "CBRACE",
  "TRUE",
  "FALSE",
  "NIL",
  "IF",
  "ELSE",
  "WHILE",
  "RETURN",
  "NEW",
  "PAR",
  "GROUP",
  "OPT",
  "CRITICAL",
  "SECTION",
  "REF",
  "AS",
  "TRY",
  "CATCH",
  "FINALLY",
  "IN",
  "STARTER_LXR",
  "ANNOTATION_RET",
  "ANNOTATION",
  "DOT",
  "ID",
  "UNIT",
  "DIGIT",
  "INT",
  "FLOAT",
  "MONEY",
  "NUMBER_UNIT",
  "STRING",
  "CR",
  "COMMENT",
  "OTHER",
  "DIVIDER",
  "EVENT_PAYLOAD_LXR",
  "EVENT_END",
  "TITLE_CONTENT",
  "TITLE_END"
]);
X.EOF = y.Token.EOF;
X.WS = 1;
X.CONSTANT = 2;
X.READONLY = 3;
X.STATIC = 4;
X.AWAIT = 5;
X.TITLE = 6;
X.COL = 7;
X.SOPEN = 8;
X.SCLOSE = 9;
X.ARROW = 10;
X.COLOR = 11;
X.OR = 12;
X.AND = 13;
X.EQ = 14;
X.NEQ = 15;
X.GT = 16;
X.LT = 17;
X.GTEQ = 18;
X.LTEQ = 19;
X.PLUS = 20;
X.MINUS = 21;
X.MULT = 22;
X.DIV = 23;
X.MOD = 24;
X.POW = 25;
X.NOT = 26;
X.SCOL = 27;
X.COMMA = 28;
X.ASSIGN = 29;
X.OPAR = 30;
X.CPAR = 31;
X.OBRACE = 32;
X.CBRACE = 33;
X.TRUE = 34;
X.FALSE = 35;
X.NIL = 36;
X.IF = 37;
X.ELSE = 38;
X.WHILE = 39;
X.RETURN = 40;
X.NEW = 41;
X.PAR = 42;
X.GROUP = 43;
X.OPT = 44;
X.CRITICAL = 45;
X.SECTION = 46;
X.REF = 47;
X.AS = 48;
X.TRY = 49;
X.CATCH = 50;
X.FINALLY = 51;
X.IN = 52;
X.STARTER_LXR = 53;
X.ANNOTATION_RET = 54;
X.ANNOTATION = 55;
X.DOT = 56;
X.ID = 57;
X.INT = 58;
X.FLOAT = 59;
X.MONEY = 60;
X.NUMBER_UNIT = 61;
X.STRING = 62;
X.CR = 63;
X.COMMENT = 64;
X.OTHER = 65;
X.DIVIDER = 66;
X.EVENT_PAYLOAD_LXR = 67;
X.EVENT_END = 68;
X.TITLE_CONTENT = 69;
X.TITLE_END = 70;
X.COMMENT_CHANNEL = 2;
X.MODIFIER_CHANNEL = 3;
X.EVENT = 1;
X.TITLE_MODE = 2;
X.prototype.sempred = function(t, e, n) {
  switch (e) {
    case 68:
      return this.DIVIDER_sempred(t, n);
    default:
      throw "No registered predicate for:" + e;
  }
};
X.prototype.DIVIDER_sempred = function(t, e) {
  switch (e) {
    case 0:
      return this.column === 0;
    default:
      throw "No predicate with index:" + e;
  }
};
class A extends y.tree.ParseTreeListener {
  // Enter a parse tree produced by sequenceParser#prog.
  enterProg(e) {
  }
  // Exit a parse tree produced by sequenceParser#prog.
  exitProg(e) {
  }
  // Enter a parse tree produced by sequenceParser#title.
  enterTitle(e) {
  }
  // Exit a parse tree produced by sequenceParser#title.
  exitTitle(e) {
  }
  // Enter a parse tree produced by sequenceParser#head.
  enterHead(e) {
  }
  // Exit a parse tree produced by sequenceParser#head.
  exitHead(e) {
  }
  // Enter a parse tree produced by sequenceParser#group.
  enterGroup(e) {
  }
  // Exit a parse tree produced by sequenceParser#group.
  exitGroup(e) {
  }
  // Enter a parse tree produced by sequenceParser#starterExp.
  enterStarterExp(e) {
  }
  // Exit a parse tree produced by sequenceParser#starterExp.
  exitStarterExp(e) {
  }
  // Enter a parse tree produced by sequenceParser#starter.
  enterStarter(e) {
  }
  // Exit a parse tree produced by sequenceParser#starter.
  exitStarter(e) {
  }
  // Enter a parse tree produced by sequenceParser#participant.
  enterParticipant(e) {
  }
  // Exit a parse tree produced by sequenceParser#participant.
  exitParticipant(e) {
  }
  // Enter a parse tree produced by sequenceParser#stereotype.
  enterStereotype(e) {
  }
  // Exit a parse tree produced by sequenceParser#stereotype.
  exitStereotype(e) {
  }
  // Enter a parse tree produced by sequenceParser#label.
  enterLabel(e) {
  }
  // Exit a parse tree produced by sequenceParser#label.
  exitLabel(e) {
  }
  // Enter a parse tree produced by sequenceParser#participantType.
  enterParticipantType(e) {
  }
  // Exit a parse tree produced by sequenceParser#participantType.
  exitParticipantType(e) {
  }
  // Enter a parse tree produced by sequenceParser#name.
  enterName(e) {
  }
  // Exit a parse tree produced by sequenceParser#name.
  exitName(e) {
  }
  // Enter a parse tree produced by sequenceParser#width.
  enterWidth(e) {
  }
  // Exit a parse tree produced by sequenceParser#width.
  exitWidth(e) {
  }
  // Enter a parse tree produced by sequenceParser#block.
  enterBlock(e) {
  }
  // Exit a parse tree produced by sequenceParser#block.
  exitBlock(e) {
  }
  // Enter a parse tree produced by sequenceParser#ret.
  enterRet(e) {
  }
  // Exit a parse tree produced by sequenceParser#ret.
  exitRet(e) {
  }
  // Enter a parse tree produced by sequenceParser#divider.
  enterDivider(e) {
  }
  // Exit a parse tree produced by sequenceParser#divider.
  exitDivider(e) {
  }
  // Enter a parse tree produced by sequenceParser#dividerNote.
  enterDividerNote(e) {
  }
  // Exit a parse tree produced by sequenceParser#dividerNote.
  exitDividerNote(e) {
  }
  // Enter a parse tree produced by sequenceParser#stat.
  enterStat(e) {
  }
  // Exit a parse tree produced by sequenceParser#stat.
  exitStat(e) {
  }
  // Enter a parse tree produced by sequenceParser#par.
  enterPar(e) {
  }
  // Exit a parse tree produced by sequenceParser#par.
  exitPar(e) {
  }
  // Enter a parse tree produced by sequenceParser#opt.
  enterOpt(e) {
  }
  // Exit a parse tree produced by sequenceParser#opt.
  exitOpt(e) {
  }
  // Enter a parse tree produced by sequenceParser#critical.
  enterCritical(e) {
  }
  // Exit a parse tree produced by sequenceParser#critical.
  exitCritical(e) {
  }
  // Enter a parse tree produced by sequenceParser#section.
  enterSection(e) {
  }
  // Exit a parse tree produced by sequenceParser#section.
  exitSection(e) {
  }
  // Enter a parse tree produced by sequenceParser#creation.
  enterCreation(e) {
  }
  // Exit a parse tree produced by sequenceParser#creation.
  exitCreation(e) {
  }
  // Enter a parse tree produced by sequenceParser#ref.
  enterRef(e) {
  }
  // Exit a parse tree produced by sequenceParser#ref.
  exitRef(e) {
  }
  // Enter a parse tree produced by sequenceParser#creationBody.
  enterCreationBody(e) {
  }
  // Exit a parse tree produced by sequenceParser#creationBody.
  exitCreationBody(e) {
  }
  // Enter a parse tree produced by sequenceParser#message.
  enterMessage(e) {
  }
  // Exit a parse tree produced by sequenceParser#message.
  exitMessage(e) {
  }
  // Enter a parse tree produced by sequenceParser#messageBody.
  enterMessageBody(e) {
  }
  // Exit a parse tree produced by sequenceParser#messageBody.
  exitMessageBody(e) {
  }
  // Enter a parse tree produced by sequenceParser#func.
  enterFunc(e) {
  }
  // Exit a parse tree produced by sequenceParser#func.
  exitFunc(e) {
  }
  // Enter a parse tree produced by sequenceParser#from.
  enterFrom(e) {
  }
  // Exit a parse tree produced by sequenceParser#from.
  exitFrom(e) {
  }
  // Enter a parse tree produced by sequenceParser#to.
  enterTo(e) {
  }
  // Exit a parse tree produced by sequenceParser#to.
  exitTo(e) {
  }
  // Enter a parse tree produced by sequenceParser#signature.
  enterSignature(e) {
  }
  // Exit a parse tree produced by sequenceParser#signature.
  exitSignature(e) {
  }
  // Enter a parse tree produced by sequenceParser#invocation.
  enterInvocation(e) {
  }
  // Exit a parse tree produced by sequenceParser#invocation.
  exitInvocation(e) {
  }
  // Enter a parse tree produced by sequenceParser#assignment.
  enterAssignment(e) {
  }
  // Exit a parse tree produced by sequenceParser#assignment.
  exitAssignment(e) {
  }
  // Enter a parse tree produced by sequenceParser#asyncMessage.
  enterAsyncMessage(e) {
  }
  // Exit a parse tree produced by sequenceParser#asyncMessage.
  exitAsyncMessage(e) {
  }
  // Enter a parse tree produced by sequenceParser#content.
  enterContent(e) {
  }
  // Exit a parse tree produced by sequenceParser#content.
  exitContent(e) {
  }
  // Enter a parse tree produced by sequenceParser#construct.
  enterConstruct(e) {
  }
  // Exit a parse tree produced by sequenceParser#construct.
  exitConstruct(e) {
  }
  // Enter a parse tree produced by sequenceParser#type.
  enterType(e) {
  }
  // Exit a parse tree produced by sequenceParser#type.
  exitType(e) {
  }
  // Enter a parse tree produced by sequenceParser#assignee.
  enterAssignee(e) {
  }
  // Exit a parse tree produced by sequenceParser#assignee.
  exitAssignee(e) {
  }
  // Enter a parse tree produced by sequenceParser#methodName.
  enterMethodName(e) {
  }
  // Exit a parse tree produced by sequenceParser#methodName.
  exitMethodName(e) {
  }
  // Enter a parse tree produced by sequenceParser#parameters.
  enterParameters(e) {
  }
  // Exit a parse tree produced by sequenceParser#parameters.
  exitParameters(e) {
  }
  // Enter a parse tree produced by sequenceParser#parameter.
  enterParameter(e) {
  }
  // Exit a parse tree produced by sequenceParser#parameter.
  exitParameter(e) {
  }
  // Enter a parse tree produced by sequenceParser#declaration.
  enterDeclaration(e) {
  }
  // Exit a parse tree produced by sequenceParser#declaration.
  exitDeclaration(e) {
  }
  // Enter a parse tree produced by sequenceParser#tcf.
  enterTcf(e) {
  }
  // Exit a parse tree produced by sequenceParser#tcf.
  exitTcf(e) {
  }
  // Enter a parse tree produced by sequenceParser#tryBlock.
  enterTryBlock(e) {
  }
  // Exit a parse tree produced by sequenceParser#tryBlock.
  exitTryBlock(e) {
  }
  // Enter a parse tree produced by sequenceParser#catchBlock.
  enterCatchBlock(e) {
  }
  // Exit a parse tree produced by sequenceParser#catchBlock.
  exitCatchBlock(e) {
  }
  // Enter a parse tree produced by sequenceParser#finallyBlock.
  enterFinallyBlock(e) {
  }
  // Exit a parse tree produced by sequenceParser#finallyBlock.
  exitFinallyBlock(e) {
  }
  // Enter a parse tree produced by sequenceParser#alt.
  enterAlt(e) {
  }
  // Exit a parse tree produced by sequenceParser#alt.
  exitAlt(e) {
  }
  // Enter a parse tree produced by sequenceParser#ifBlock.
  enterIfBlock(e) {
  }
  // Exit a parse tree produced by sequenceParser#ifBlock.
  exitIfBlock(e) {
  }
  // Enter a parse tree produced by sequenceParser#elseIfBlock.
  enterElseIfBlock(e) {
  }
  // Exit a parse tree produced by sequenceParser#elseIfBlock.
  exitElseIfBlock(e) {
  }
  // Enter a parse tree produced by sequenceParser#elseBlock.
  enterElseBlock(e) {
  }
  // Exit a parse tree produced by sequenceParser#elseBlock.
  exitElseBlock(e) {
  }
  // Enter a parse tree produced by sequenceParser#braceBlock.
  enterBraceBlock(e) {
  }
  // Exit a parse tree produced by sequenceParser#braceBlock.
  exitBraceBlock(e) {
  }
  // Enter a parse tree produced by sequenceParser#loop.
  enterLoop(e) {
  }
  // Exit a parse tree produced by sequenceParser#loop.
  exitLoop(e) {
  }
  // Enter a parse tree produced by sequenceParser#assignmentExpr.
  enterAssignmentExpr(e) {
  }
  // Exit a parse tree produced by sequenceParser#assignmentExpr.
  exitAssignmentExpr(e) {
  }
  // Enter a parse tree produced by sequenceParser#funcExpr.
  enterFuncExpr(e) {
  }
  // Exit a parse tree produced by sequenceParser#funcExpr.
  exitFuncExpr(e) {
  }
  // Enter a parse tree produced by sequenceParser#atomExpr.
  enterAtomExpr(e) {
  }
  // Exit a parse tree produced by sequenceParser#atomExpr.
  exitAtomExpr(e) {
  }
  // Enter a parse tree produced by sequenceParser#orExpr.
  enterOrExpr(e) {
  }
  // Exit a parse tree produced by sequenceParser#orExpr.
  exitOrExpr(e) {
  }
  // Enter a parse tree produced by sequenceParser#additiveExpr.
  enterAdditiveExpr(e) {
  }
  // Exit a parse tree produced by sequenceParser#additiveExpr.
  exitAdditiveExpr(e) {
  }
  // Enter a parse tree produced by sequenceParser#relationalExpr.
  enterRelationalExpr(e) {
  }
  // Exit a parse tree produced by sequenceParser#relationalExpr.
  exitRelationalExpr(e) {
  }
  // Enter a parse tree produced by sequenceParser#plusExpr.
  enterPlusExpr(e) {
  }
  // Exit a parse tree produced by sequenceParser#plusExpr.
  exitPlusExpr(e) {
  }
  // Enter a parse tree produced by sequenceParser#notExpr.
  enterNotExpr(e) {
  }
  // Exit a parse tree produced by sequenceParser#notExpr.
  exitNotExpr(e) {
  }
  // Enter a parse tree produced by sequenceParser#unaryMinusExpr.
  enterUnaryMinusExpr(e) {
  }
  // Exit a parse tree produced by sequenceParser#unaryMinusExpr.
  exitUnaryMinusExpr(e) {
  }
  // Enter a parse tree produced by sequenceParser#creationExpr.
  enterCreationExpr(e) {
  }
  // Exit a parse tree produced by sequenceParser#creationExpr.
  exitCreationExpr(e) {
  }
  // Enter a parse tree produced by sequenceParser#parenthesizedExpr.
  enterParenthesizedExpr(e) {
  }
  // Exit a parse tree produced by sequenceParser#parenthesizedExpr.
  exitParenthesizedExpr(e) {
  }
  // Enter a parse tree produced by sequenceParser#multiplicationExpr.
  enterMultiplicationExpr(e) {
  }
  // Exit a parse tree produced by sequenceParser#multiplicationExpr.
  exitMultiplicationExpr(e) {
  }
  // Enter a parse tree produced by sequenceParser#equalityExpr.
  enterEqualityExpr(e) {
  }
  // Exit a parse tree produced by sequenceParser#equalityExpr.
  exitEqualityExpr(e) {
  }
  // Enter a parse tree produced by sequenceParser#andExpr.
  enterAndExpr(e) {
  }
  // Exit a parse tree produced by sequenceParser#andExpr.
  exitAndExpr(e) {
  }
  // Enter a parse tree produced by sequenceParser#numberAtom.
  enterNumberAtom(e) {
  }
  // Exit a parse tree produced by sequenceParser#numberAtom.
  exitNumberAtom(e) {
  }
  // Enter a parse tree produced by sequenceParser#numberUnitAtom.
  enterNumberUnitAtom(e) {
  }
  // Exit a parse tree produced by sequenceParser#numberUnitAtom.
  exitNumberUnitAtom(e) {
  }
  // Enter a parse tree produced by sequenceParser#moneyAtom.
  enterMoneyAtom(e) {
  }
  // Exit a parse tree produced by sequenceParser#moneyAtom.
  exitMoneyAtom(e) {
  }
  // Enter a parse tree produced by sequenceParser#booleanAtom.
  enterBooleanAtom(e) {
  }
  // Exit a parse tree produced by sequenceParser#booleanAtom.
  exitBooleanAtom(e) {
  }
  // Enter a parse tree produced by sequenceParser#idAtom.
  enterIdAtom(e) {
  }
  // Exit a parse tree produced by sequenceParser#idAtom.
  exitIdAtom(e) {
  }
  // Enter a parse tree produced by sequenceParser#stringAtom.
  enterStringAtom(e) {
  }
  // Exit a parse tree produced by sequenceParser#stringAtom.
  exitStringAtom(e) {
  }
  // Enter a parse tree produced by sequenceParser#nilAtom.
  enterNilAtom(e) {
  }
  // Exit a parse tree produced by sequenceParser#nilAtom.
  exitNilAtom(e) {
  }
  // Enter a parse tree produced by sequenceParser#parExpr.
  enterParExpr(e) {
  }
  // Exit a parse tree produced by sequenceParser#parExpr.
  exitParExpr(e) {
  }
  // Enter a parse tree produced by sequenceParser#condition.
  enterCondition(e) {
  }
  // Exit a parse tree produced by sequenceParser#condition.
  exitCondition(e) {
  }
  // Enter a parse tree produced by sequenceParser#inExpr.
  enterInExpr(e) {
  }
  // Exit a parse tree produced by sequenceParser#inExpr.
  exitInExpr(e) {
  }
}
const gg = [
  4,
  1,
  70,
  608,
  2,
  0,
  7,
  0,
  2,
  1,
  7,
  1,
  2,
  2,
  7,
  2,
  2,
  3,
  7,
  3,
  2,
  4,
  7,
  4,
  2,
  5,
  7,
  5,
  2,
  6,
  7,
  6,
  2,
  7,
  7,
  7,
  2,
  8,
  7,
  8,
  2,
  9,
  7,
  9,
  2,
  10,
  7,
  10,
  2,
  11,
  7,
  11,
  2,
  12,
  7,
  12,
  2,
  13,
  7,
  13,
  2,
  14,
  7,
  14,
  2,
  15,
  7,
  15,
  2,
  16,
  7,
  16,
  2,
  17,
  7,
  17,
  2,
  18,
  7,
  18,
  2,
  19,
  7,
  19,
  2,
  20,
  7,
  20,
  2,
  21,
  7,
  21,
  2,
  22,
  7,
  22,
  2,
  23,
  7,
  23,
  2,
  24,
  7,
  24,
  2,
  25,
  7,
  25,
  2,
  26,
  7,
  26,
  2,
  27,
  7,
  27,
  2,
  28,
  7,
  28,
  2,
  29,
  7,
  29,
  2,
  30,
  7,
  30,
  2,
  31,
  7,
  31,
  2,
  32,
  7,
  32,
  2,
  33,
  7,
  33,
  2,
  34,
  7,
  34,
  2,
  35,
  7,
  35,
  2,
  36,
  7,
  36,
  2,
  37,
  7,
  37,
  2,
  38,
  7,
  38,
  2,
  39,
  7,
  39,
  2,
  40,
  7,
  40,
  2,
  41,
  7,
  41,
  2,
  42,
  7,
  42,
  2,
  43,
  7,
  43,
  2,
  44,
  7,
  44,
  2,
  45,
  7,
  45,
  2,
  46,
  7,
  46,
  2,
  47,
  7,
  47,
  2,
  48,
  7,
  48,
  2,
  49,
  7,
  49,
  2,
  50,
  7,
  50,
  2,
  51,
  7,
  51,
  2,
  52,
  7,
  52,
  2,
  53,
  7,
  53,
  2,
  54,
  7,
  54,
  2,
  55,
  7,
  55,
  1,
  0,
  3,
  0,
  114,
  8,
  0,
  1,
  0,
  1,
  0,
  3,
  0,
  118,
  8,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  3,
  0,
  124,
  8,
  0,
  1,
  0,
  3,
  0,
  127,
  8,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  3,
  0,
  132,
  8,
  0,
  1,
  1,
  1,
  1,
  3,
  1,
  136,
  8,
  1,
  1,
  1,
  3,
  1,
  139,
  8,
  1,
  1,
  2,
  1,
  2,
  4,
  2,
  143,
  8,
  2,
  11,
  2,
  12,
  2,
  144,
  1,
  2,
  1,
  2,
  5,
  2,
  149,
  8,
  2,
  10,
  2,
  12,
  2,
  152,
  9,
  2,
  1,
  2,
  3,
  2,
  155,
  8,
  2,
  1,
  3,
  1,
  3,
  3,
  3,
  159,
  8,
  3,
  1,
  3,
  1,
  3,
  5,
  3,
  163,
  8,
  3,
  10,
  3,
  12,
  3,
  166,
  9,
  3,
  1,
  3,
  1,
  3,
  1,
  3,
  3,
  3,
  171,
  8,
  3,
  1,
  3,
  1,
  3,
  1,
  3,
  3,
  3,
  176,
  8,
  3,
  3,
  3,
  178,
  8,
  3,
  1,
  4,
  1,
  4,
  1,
  4,
  3,
  4,
  183,
  8,
  4,
  1,
  4,
  3,
  4,
  186,
  8,
  4,
  1,
  4,
  3,
  4,
  189,
  8,
  4,
  1,
  5,
  1,
  5,
  1,
  6,
  3,
  6,
  194,
  8,
  6,
  1,
  6,
  3,
  6,
  197,
  8,
  6,
  1,
  6,
  1,
  6,
  3,
  6,
  201,
  8,
  6,
  1,
  6,
  3,
  6,
  204,
  8,
  6,
  1,
  6,
  3,
  6,
  207,
  8,
  6,
  1,
  6,
  1,
  6,
  3,
  6,
  211,
  8,
  6,
  1,
  7,
  1,
  7,
  1,
  7,
  1,
  7,
  1,
  7,
  1,
  7,
  1,
  7,
  3,
  7,
  220,
  8,
  7,
  1,
  7,
  1,
  7,
  3,
  7,
  224,
  8,
  7,
  3,
  7,
  226,
  8,
  7,
  1,
  8,
  1,
  8,
  1,
  8,
  3,
  8,
  231,
  8,
  8,
  1,
  9,
  1,
  9,
  1,
  10,
  1,
  10,
  1,
  11,
  1,
  11,
  1,
  12,
  4,
  12,
  240,
  8,
  12,
  11,
  12,
  12,
  12,
  241,
  1,
  13,
  1,
  13,
  3,
  13,
  246,
  8,
  13,
  1,
  13,
  3,
  13,
  249,
  8,
  13,
  1,
  13,
  1,
  13,
  1,
  13,
  3,
  13,
  254,
  8,
  13,
  3,
  13,
  256,
  8,
  13,
  1,
  14,
  1,
  14,
  1,
  15,
  1,
  15,
  1,
  16,
  1,
  16,
  1,
  16,
  1,
  16,
  1,
  16,
  1,
  16,
  1,
  16,
  1,
  16,
  1,
  16,
  1,
  16,
  1,
  16,
  3,
  16,
  273,
  8,
  16,
  1,
  16,
  1,
  16,
  1,
  16,
  1,
  16,
  1,
  16,
  3,
  16,
  280,
  8,
  16,
  1,
  17,
  1,
  17,
  1,
  17,
  3,
  17,
  285,
  8,
  17,
  1,
  18,
  1,
  18,
  1,
  18,
  3,
  18,
  290,
  8,
  18,
  1,
  19,
  1,
  19,
  1,
  19,
  3,
  19,
  295,
  8,
  19,
  1,
  19,
  3,
  19,
  298,
  8,
  19,
  1,
  19,
  1,
  19,
  3,
  19,
  302,
  8,
  19,
  1,
  20,
  1,
  20,
  1,
  20,
  3,
  20,
  307,
  8,
  20,
  1,
  20,
  3,
  20,
  310,
  8,
  20,
  1,
  20,
  1,
  20,
  1,
  20,
  3,
  20,
  315,
  8,
  20,
  1,
  21,
  1,
  21,
  1,
  21,
  3,
  21,
  320,
  8,
  21,
  1,
  22,
  1,
  22,
  1,
  22,
  1,
  22,
  1,
  22,
  5,
  22,
  327,
  8,
  22,
  10,
  22,
  12,
  22,
  330,
  9,
  22,
  5,
  22,
  332,
  8,
  22,
  10,
  22,
  12,
  22,
  335,
  9,
  22,
  1,
  22,
  1,
  22,
  3,
  22,
  339,
  8,
  22,
  1,
  23,
  3,
  23,
  342,
  8,
  23,
  1,
  23,
  1,
  23,
  1,
  23,
  1,
  23,
  3,
  23,
  348,
  8,
  23,
  1,
  23,
  3,
  23,
  351,
  8,
  23,
  1,
  23,
  3,
  23,
  354,
  8,
  23,
  1,
  23,
  3,
  23,
  357,
  8,
  23,
  1,
  24,
  1,
  24,
  1,
  24,
  3,
  24,
  362,
  8,
  24,
  1,
  25,
  3,
  25,
  365,
  8,
  25,
  1,
  25,
  1,
  25,
  1,
  25,
  3,
  25,
  370,
  8,
  25,
  1,
  25,
  1,
  25,
  1,
  25,
  3,
  25,
  375,
  8,
  25,
  1,
  25,
  1,
  25,
  1,
  25,
  1,
  25,
  1,
  25,
  3,
  25,
  382,
  8,
  25,
  1,
  25,
  1,
  25,
  1,
  25,
  3,
  25,
  387,
  8,
  25,
  1,
  26,
  1,
  26,
  1,
  26,
  5,
  26,
  392,
  8,
  26,
  10,
  26,
  12,
  26,
  395,
  9,
  26,
  1,
  27,
  1,
  27,
  1,
  28,
  1,
  28,
  1,
  29,
  1,
  29,
  3,
  29,
  403,
  8,
  29,
  1,
  30,
  1,
  30,
  3,
  30,
  407,
  8,
  30,
  1,
  30,
  1,
  30,
  1,
  31,
  3,
  31,
  412,
  8,
  31,
  1,
  31,
  1,
  31,
  1,
  31,
  1,
  32,
  1,
  32,
  1,
  32,
  3,
  32,
  420,
  8,
  32,
  1,
  32,
  1,
  32,
  1,
  32,
  3,
  32,
  425,
  8,
  32,
  1,
  32,
  1,
  32,
  1,
  32,
  3,
  32,
  430,
  8,
  32,
  3,
  32,
  432,
  8,
  32,
  1,
  33,
  1,
  33,
  1,
  34,
  1,
  34,
  1,
  35,
  1,
  35,
  1,
  36,
  1,
  36,
  1,
  36,
  1,
  36,
  5,
  36,
  444,
  8,
  36,
  10,
  36,
  12,
  36,
  447,
  9,
  36,
  1,
  36,
  3,
  36,
  450,
  8,
  36,
  1,
  37,
  1,
  37,
  1,
  38,
  1,
  38,
  1,
  38,
  5,
  38,
  457,
  8,
  38,
  10,
  38,
  12,
  38,
  460,
  9,
  38,
  1,
  38,
  3,
  38,
  463,
  8,
  38,
  1,
  39,
  1,
  39,
  3,
  39,
  467,
  8,
  39,
  1,
  40,
  1,
  40,
  1,
  40,
  1,
  41,
  1,
  41,
  5,
  41,
  474,
  8,
  41,
  10,
  41,
  12,
  41,
  477,
  9,
  41,
  1,
  41,
  3,
  41,
  480,
  8,
  41,
  1,
  42,
  1,
  42,
  1,
  42,
  1,
  43,
  1,
  43,
  3,
  43,
  487,
  8,
  43,
  1,
  43,
  1,
  43,
  1,
  44,
  1,
  44,
  1,
  44,
  1,
  45,
  1,
  45,
  5,
  45,
  496,
  8,
  45,
  10,
  45,
  12,
  45,
  499,
  9,
  45,
  1,
  45,
  3,
  45,
  502,
  8,
  45,
  1,
  46,
  1,
  46,
  1,
  46,
  1,
  46,
  1,
  47,
  1,
  47,
  1,
  47,
  1,
  47,
  1,
  47,
  1,
  48,
  1,
  48,
  1,
  48,
  1,
  49,
  1,
  49,
  3,
  49,
  518,
  8,
  49,
  1,
  49,
  1,
  49,
  1,
  50,
  1,
  50,
  1,
  50,
  1,
  50,
  1,
  50,
  1,
  50,
  1,
  50,
  3,
  50,
  529,
  8,
  50,
  1,
  51,
  1,
  51,
  1,
  51,
  1,
  51,
  1,
  51,
  1,
  51,
  1,
  51,
  1,
  51,
  1,
  51,
  3,
  51,
  540,
  8,
  51,
  1,
  51,
  1,
  51,
  1,
  51,
  1,
  51,
  1,
  51,
  1,
  51,
  1,
  51,
  1,
  51,
  1,
  51,
  3,
  51,
  551,
  8,
  51,
  1,
  51,
  1,
  51,
  1,
  51,
  1,
  51,
  1,
  51,
  1,
  51,
  1,
  51,
  1,
  51,
  1,
  51,
  1,
  51,
  1,
  51,
  1,
  51,
  1,
  51,
  1,
  51,
  1,
  51,
  1,
  51,
  1,
  51,
  1,
  51,
  1,
  51,
  1,
  51,
  1,
  51,
  5,
  51,
  574,
  8,
  51,
  10,
  51,
  12,
  51,
  577,
  9,
  51,
  1,
  52,
  1,
  52,
  1,
  52,
  1,
  52,
  1,
  52,
  1,
  52,
  1,
  52,
  3,
  52,
  586,
  8,
  52,
  1,
  53,
  1,
  53,
  1,
  53,
  1,
  53,
  1,
  53,
  1,
  53,
  1,
  53,
  1,
  53,
  1,
  53,
  3,
  53,
  597,
  8,
  53,
  1,
  54,
  1,
  54,
  1,
  54,
  3,
  54,
  602,
  8,
  54,
  1,
  55,
  1,
  55,
  1,
  55,
  1,
  55,
  1,
  55,
  0,
  1,
  102,
  56,
  0,
  2,
  4,
  6,
  8,
  10,
  12,
  14,
  16,
  18,
  20,
  22,
  24,
  26,
  28,
  30,
  32,
  34,
  36,
  38,
  40,
  42,
  44,
  46,
  48,
  50,
  52,
  54,
  56,
  58,
  60,
  62,
  64,
  66,
  68,
  70,
  72,
  74,
  76,
  78,
  80,
  82,
  84,
  86,
  88,
  90,
  92,
  94,
  96,
  98,
  100,
  102,
  104,
  106,
  108,
  110,
  0,
  10,
  2,
  0,
  57,
  57,
  62,
  62,
  2,
  0,
  8,
  8,
  17,
  17,
  2,
  0,
  9,
  9,
  16,
  16,
  2,
  0,
  10,
  10,
  21,
  21,
  1,
  0,
  22,
  24,
  1,
  0,
  20,
  21,
  1,
  0,
  16,
  19,
  1,
  0,
  14,
  15,
  1,
  0,
  58,
  59,
  1,
  0,
  34,
  35,
  678,
  0,
  131,
  1,
  0,
  0,
  0,
  2,
  133,
  1,
  0,
  0,
  0,
  4,
  154,
  1,
  0,
  0,
  0,
  6,
  177,
  1,
  0,
  0,
  0,
  8,
  188,
  1,
  0,
  0,
  0,
  10,
  190,
  1,
  0,
  0,
  0,
  12,
  210,
  1,
  0,
  0,
  0,
  14,
  225,
  1,
  0,
  0,
  0,
  16,
  230,
  1,
  0,
  0,
  0,
  18,
  232,
  1,
  0,
  0,
  0,
  20,
  234,
  1,
  0,
  0,
  0,
  22,
  236,
  1,
  0,
  0,
  0,
  24,
  239,
  1,
  0,
  0,
  0,
  26,
  255,
  1,
  0,
  0,
  0,
  28,
  257,
  1,
  0,
  0,
  0,
  30,
  259,
  1,
  0,
  0,
  0,
  32,
  279,
  1,
  0,
  0,
  0,
  34,
  284,
  1,
  0,
  0,
  0,
  36,
  289,
  1,
  0,
  0,
  0,
  38,
  301,
  1,
  0,
  0,
  0,
  40,
  314,
  1,
  0,
  0,
  0,
  42,
  316,
  1,
  0,
  0,
  0,
  44,
  321,
  1,
  0,
  0,
  0,
  46,
  356,
  1,
  0,
  0,
  0,
  48,
  358,
  1,
  0,
  0,
  0,
  50,
  386,
  1,
  0,
  0,
  0,
  52,
  388,
  1,
  0,
  0,
  0,
  54,
  396,
  1,
  0,
  0,
  0,
  56,
  398,
  1,
  0,
  0,
  0,
  58,
  400,
  1,
  0,
  0,
  0,
  60,
  404,
  1,
  0,
  0,
  0,
  62,
  411,
  1,
  0,
  0,
  0,
  64,
  431,
  1,
  0,
  0,
  0,
  66,
  433,
  1,
  0,
  0,
  0,
  68,
  435,
  1,
  0,
  0,
  0,
  70,
  437,
  1,
  0,
  0,
  0,
  72,
  449,
  1,
  0,
  0,
  0,
  74,
  451,
  1,
  0,
  0,
  0,
  76,
  453,
  1,
  0,
  0,
  0,
  78,
  466,
  1,
  0,
  0,
  0,
  80,
  468,
  1,
  0,
  0,
  0,
  82,
  471,
  1,
  0,
  0,
  0,
  84,
  481,
  1,
  0,
  0,
  0,
  86,
  484,
  1,
  0,
  0,
  0,
  88,
  490,
  1,
  0,
  0,
  0,
  90,
  493,
  1,
  0,
  0,
  0,
  92,
  503,
  1,
  0,
  0,
  0,
  94,
  507,
  1,
  0,
  0,
  0,
  96,
  512,
  1,
  0,
  0,
  0,
  98,
  515,
  1,
  0,
  0,
  0,
  100,
  528,
  1,
  0,
  0,
  0,
  102,
  550,
  1,
  0,
  0,
  0,
  104,
  585,
  1,
  0,
  0,
  0,
  106,
  596,
  1,
  0,
  0,
  0,
  108,
  601,
  1,
  0,
  0,
  0,
  110,
  603,
  1,
  0,
  0,
  0,
  112,
  114,
  3,
  2,
  1,
  0,
  113,
  112,
  1,
  0,
  0,
  0,
  113,
  114,
  1,
  0,
  0,
  0,
  114,
  115,
  1,
  0,
  0,
  0,
  115,
  132,
  5,
  0,
  0,
  1,
  116,
  118,
  3,
  2,
  1,
  0,
  117,
  116,
  1,
  0,
  0,
  0,
  117,
  118,
  1,
  0,
  0,
  0,
  118,
  119,
  1,
  0,
  0,
  0,
  119,
  120,
  3,
  4,
  2,
  0,
  120,
  121,
  5,
  0,
  0,
  1,
  121,
  132,
  1,
  0,
  0,
  0,
  122,
  124,
  3,
  2,
  1,
  0,
  123,
  122,
  1,
  0,
  0,
  0,
  123,
  124,
  1,
  0,
  0,
  0,
  124,
  126,
  1,
  0,
  0,
  0,
  125,
  127,
  3,
  4,
  2,
  0,
  126,
  125,
  1,
  0,
  0,
  0,
  126,
  127,
  1,
  0,
  0,
  0,
  127,
  128,
  1,
  0,
  0,
  0,
  128,
  129,
  3,
  24,
  12,
  0,
  129,
  130,
  5,
  0,
  0,
  1,
  130,
  132,
  1,
  0,
  0,
  0,
  131,
  113,
  1,
  0,
  0,
  0,
  131,
  117,
  1,
  0,
  0,
  0,
  131,
  123,
  1,
  0,
  0,
  0,
  132,
  1,
  1,
  0,
  0,
  0,
  133,
  135,
  5,
  6,
  0,
  0,
  134,
  136,
  5,
  69,
  0,
  0,
  135,
  134,
  1,
  0,
  0,
  0,
  135,
  136,
  1,
  0,
  0,
  0,
  136,
  138,
  1,
  0,
  0,
  0,
  137,
  139,
  5,
  70,
  0,
  0,
  138,
  137,
  1,
  0,
  0,
  0,
  138,
  139,
  1,
  0,
  0,
  0,
  139,
  3,
  1,
  0,
  0,
  0,
  140,
  143,
  3,
  6,
  3,
  0,
  141,
  143,
  3,
  12,
  6,
  0,
  142,
  140,
  1,
  0,
  0,
  0,
  142,
  141,
  1,
  0,
  0,
  0,
  143,
  144,
  1,
  0,
  0,
  0,
  144,
  142,
  1,
  0,
  0,
  0,
  144,
  145,
  1,
  0,
  0,
  0,
  145,
  155,
  1,
  0,
  0,
  0,
  146,
  149,
  3,
  6,
  3,
  0,
  147,
  149,
  3,
  12,
  6,
  0,
  148,
  146,
  1,
  0,
  0,
  0,
  148,
  147,
  1,
  0,
  0,
  0,
  149,
  152,
  1,
  0,
  0,
  0,
  150,
  148,
  1,
  0,
  0,
  0,
  150,
  151,
  1,
  0,
  0,
  0,
  151,
  153,
  1,
  0,
  0,
  0,
  152,
  150,
  1,
  0,
  0,
  0,
  153,
  155,
  3,
  8,
  4,
  0,
  154,
  142,
  1,
  0,
  0,
  0,
  154,
  150,
  1,
  0,
  0,
  0,
  155,
  5,
  1,
  0,
  0,
  0,
  156,
  158,
  5,
  43,
  0,
  0,
  157,
  159,
  3,
  20,
  10,
  0,
  158,
  157,
  1,
  0,
  0,
  0,
  158,
  159,
  1,
  0,
  0,
  0,
  159,
  160,
  1,
  0,
  0,
  0,
  160,
  164,
  5,
  32,
  0,
  0,
  161,
  163,
  3,
  12,
  6,
  0,
  162,
  161,
  1,
  0,
  0,
  0,
  163,
  166,
  1,
  0,
  0,
  0,
  164,
  162,
  1,
  0,
  0,
  0,
  164,
  165,
  1,
  0,
  0,
  0,
  165,
  167,
  1,
  0,
  0,
  0,
  166,
  164,
  1,
  0,
  0,
  0,
  167,
  178,
  5,
  33,
  0,
  0,
  168,
  170,
  5,
  43,
  0,
  0,
  169,
  171,
  3,
  20,
  10,
  0,
  170,
  169,
  1,
  0,
  0,
  0,
  170,
  171,
  1,
  0,
  0,
  0,
  171,
  172,
  1,
  0,
  0,
  0,
  172,
  178,
  5,
  32,
  0,
  0,
  173,
  175,
  5,
  43,
  0,
  0,
  174,
  176,
  3,
  20,
  10,
  0,
  175,
  174,
  1,
  0,
  0,
  0,
  175,
  176,
  1,
  0,
  0,
  0,
  176,
  178,
  1,
  0,
  0,
  0,
  177,
  156,
  1,
  0,
  0,
  0,
  177,
  168,
  1,
  0,
  0,
  0,
  177,
  173,
  1,
  0,
  0,
  0,
  178,
  7,
  1,
  0,
  0,
  0,
  179,
  185,
  5,
  53,
  0,
  0,
  180,
  182,
  5,
  30,
  0,
  0,
  181,
  183,
  3,
  10,
  5,
  0,
  182,
  181,
  1,
  0,
  0,
  0,
  182,
  183,
  1,
  0,
  0,
  0,
  183,
  184,
  1,
  0,
  0,
  0,
  184,
  186,
  5,
  31,
  0,
  0,
  185,
  180,
  1,
  0,
  0,
  0,
  185,
  186,
  1,
  0,
  0,
  0,
  186,
  189,
  1,
  0,
  0,
  0,
  187,
  189,
  5,
  55,
  0,
  0,
  188,
  179,
  1,
  0,
  0,
  0,
  188,
  187,
  1,
  0,
  0,
  0,
  189,
  9,
  1,
  0,
  0,
  0,
  190,
  191,
  7,
  0,
  0,
  0,
  191,
  11,
  1,
  0,
  0,
  0,
  192,
  194,
  3,
  18,
  9,
  0,
  193,
  192,
  1,
  0,
  0,
  0,
  193,
  194,
  1,
  0,
  0,
  0,
  194,
  196,
  1,
  0,
  0,
  0,
  195,
  197,
  3,
  14,
  7,
  0,
  196,
  195,
  1,
  0,
  0,
  0,
  196,
  197,
  1,
  0,
  0,
  0,
  197,
  198,
  1,
  0,
  0,
  0,
  198,
  200,
  3,
  20,
  10,
  0,
  199,
  201,
  3,
  22,
  11,
  0,
  200,
  199,
  1,
  0,
  0,
  0,
  200,
  201,
  1,
  0,
  0,
  0,
  201,
  203,
  1,
  0,
  0,
  0,
  202,
  204,
  3,
  16,
  8,
  0,
  203,
  202,
  1,
  0,
  0,
  0,
  203,
  204,
  1,
  0,
  0,
  0,
  204,
  206,
  1,
  0,
  0,
  0,
  205,
  207,
  5,
  11,
  0,
  0,
  206,
  205,
  1,
  0,
  0,
  0,
  206,
  207,
  1,
  0,
  0,
  0,
  207,
  211,
  1,
  0,
  0,
  0,
  208,
  211,
  3,
  14,
  7,
  0,
  209,
  211,
  3,
  18,
  9,
  0,
  210,
  193,
  1,
  0,
  0,
  0,
  210,
  208,
  1,
  0,
  0,
  0,
  210,
  209,
  1,
  0,
  0,
  0,
  211,
  13,
  1,
  0,
  0,
  0,
  212,
  213,
  5,
  8,
  0,
  0,
  213,
  214,
  3,
  20,
  10,
  0,
  214,
  215,
  5,
  9,
  0,
  0,
  215,
  226,
  1,
  0,
  0,
  0,
  216,
  217,
  5,
  8,
  0,
  0,
  217,
  219,
  3,
  20,
  10,
  0,
  218,
  220,
  5,
  16,
  0,
  0,
  219,
  218,
  1,
  0,
  0,
  0,
  219,
  220,
  1,
  0,
  0,
  0,
  220,
  226,
  1,
  0,
  0,
  0,
  221,
  223,
  7,
  1,
  0,
  0,
  222,
  224,
  7,
  2,
  0,
  0,
  223,
  222,
  1,
  0,
  0,
  0,
  223,
  224,
  1,
  0,
  0,
  0,
  224,
  226,
  1,
  0,
  0,
  0,
  225,
  212,
  1,
  0,
  0,
  0,
  225,
  216,
  1,
  0,
  0,
  0,
  225,
  221,
  1,
  0,
  0,
  0,
  226,
  15,
  1,
  0,
  0,
  0,
  227,
  228,
  5,
  48,
  0,
  0,
  228,
  231,
  3,
  20,
  10,
  0,
  229,
  231,
  5,
  48,
  0,
  0,
  230,
  227,
  1,
  0,
  0,
  0,
  230,
  229,
  1,
  0,
  0,
  0,
  231,
  17,
  1,
  0,
  0,
  0,
  232,
  233,
  5,
  55,
  0,
  0,
  233,
  19,
  1,
  0,
  0,
  0,
  234,
  235,
  7,
  0,
  0,
  0,
  235,
  21,
  1,
  0,
  0,
  0,
  236,
  237,
  5,
  58,
  0,
  0,
  237,
  23,
  1,
  0,
  0,
  0,
  238,
  240,
  3,
  32,
  16,
  0,
  239,
  238,
  1,
  0,
  0,
  0,
  240,
  241,
  1,
  0,
  0,
  0,
  241,
  239,
  1,
  0,
  0,
  0,
  241,
  242,
  1,
  0,
  0,
  0,
  242,
  25,
  1,
  0,
  0,
  0,
  243,
  245,
  5,
  40,
  0,
  0,
  244,
  246,
  3,
  102,
  51,
  0,
  245,
  244,
  1,
  0,
  0,
  0,
  245,
  246,
  1,
  0,
  0,
  0,
  246,
  248,
  1,
  0,
  0,
  0,
  247,
  249,
  5,
  27,
  0,
  0,
  248,
  247,
  1,
  0,
  0,
  0,
  248,
  249,
  1,
  0,
  0,
  0,
  249,
  256,
  1,
  0,
  0,
  0,
  250,
  251,
  5,
  54,
  0,
  0,
  251,
  253,
  3,
  64,
  32,
  0,
  252,
  254,
  5,
  68,
  0,
  0,
  253,
  252,
  1,
  0,
  0,
  0,
  253,
  254,
  1,
  0,
  0,
  0,
  254,
  256,
  1,
  0,
  0,
  0,
  255,
  243,
  1,
  0,
  0,
  0,
  255,
  250,
  1,
  0,
  0,
  0,
  256,
  27,
  1,
  0,
  0,
  0,
  257,
  258,
  3,
  30,
  15,
  0,
  258,
  29,
  1,
  0,
  0,
  0,
  259,
  260,
  5,
  66,
  0,
  0,
  260,
  31,
  1,
  0,
  0,
  0,
  261,
  280,
  3,
  90,
  45,
  0,
  262,
  280,
  3,
  34,
  17,
  0,
  263,
  280,
  3,
  36,
  18,
  0,
  264,
  280,
  3,
  38,
  19,
  0,
  265,
  280,
  3,
  40,
  20,
  0,
  266,
  280,
  3,
  44,
  22,
  0,
  267,
  280,
  3,
  100,
  50,
  0,
  268,
  280,
  3,
  42,
  21,
  0,
  269,
  280,
  3,
  48,
  24,
  0,
  270,
  272,
  3,
  64,
  32,
  0,
  271,
  273,
  5,
  68,
  0,
  0,
  272,
  271,
  1,
  0,
  0,
  0,
  272,
  273,
  1,
  0,
  0,
  0,
  273,
  280,
  1,
  0,
  0,
  0,
  274,
  280,
  3,
  26,
  13,
  0,
  275,
  280,
  3,
  28,
  14,
  0,
  276,
  280,
  3,
  82,
  41,
  0,
  277,
  278,
  5,
  65,
  0,
  0,
  278,
  280,
  6,
  16,
  -1,
  0,
  279,
  261,
  1,
  0,
  0,
  0,
  279,
  262,
  1,
  0,
  0,
  0,
  279,
  263,
  1,
  0,
  0,
  0,
  279,
  264,
  1,
  0,
  0,
  0,
  279,
  265,
  1,
  0,
  0,
  0,
  279,
  266,
  1,
  0,
  0,
  0,
  279,
  267,
  1,
  0,
  0,
  0,
  279,
  268,
  1,
  0,
  0,
  0,
  279,
  269,
  1,
  0,
  0,
  0,
  279,
  270,
  1,
  0,
  0,
  0,
  279,
  274,
  1,
  0,
  0,
  0,
  279,
  275,
  1,
  0,
  0,
  0,
  279,
  276,
  1,
  0,
  0,
  0,
  279,
  277,
  1,
  0,
  0,
  0,
  280,
  33,
  1,
  0,
  0,
  0,
  281,
  282,
  5,
  42,
  0,
  0,
  282,
  285,
  3,
  98,
  49,
  0,
  283,
  285,
  5,
  42,
  0,
  0,
  284,
  281,
  1,
  0,
  0,
  0,
  284,
  283,
  1,
  0,
  0,
  0,
  285,
  35,
  1,
  0,
  0,
  0,
  286,
  287,
  5,
  44,
  0,
  0,
  287,
  290,
  3,
  98,
  49,
  0,
  288,
  290,
  5,
  44,
  0,
  0,
  289,
  286,
  1,
  0,
  0,
  0,
  289,
  288,
  1,
  0,
  0,
  0,
  290,
  37,
  1,
  0,
  0,
  0,
  291,
  297,
  5,
  45,
  0,
  0,
  292,
  294,
  5,
  30,
  0,
  0,
  293,
  295,
  3,
  104,
  52,
  0,
  294,
  293,
  1,
  0,
  0,
  0,
  294,
  295,
  1,
  0,
  0,
  0,
  295,
  296,
  1,
  0,
  0,
  0,
  296,
  298,
  5,
  31,
  0,
  0,
  297,
  292,
  1,
  0,
  0,
  0,
  297,
  298,
  1,
  0,
  0,
  0,
  298,
  299,
  1,
  0,
  0,
  0,
  299,
  302,
  3,
  98,
  49,
  0,
  300,
  302,
  5,
  45,
  0,
  0,
  301,
  291,
  1,
  0,
  0,
  0,
  301,
  300,
  1,
  0,
  0,
  0,
  302,
  39,
  1,
  0,
  0,
  0,
  303,
  309,
  5,
  46,
  0,
  0,
  304,
  306,
  5,
  30,
  0,
  0,
  305,
  307,
  3,
  104,
  52,
  0,
  306,
  305,
  1,
  0,
  0,
  0,
  306,
  307,
  1,
  0,
  0,
  0,
  307,
  308,
  1,
  0,
  0,
  0,
  308,
  310,
  5,
  31,
  0,
  0,
  309,
  304,
  1,
  0,
  0,
  0,
  309,
  310,
  1,
  0,
  0,
  0,
  310,
  311,
  1,
  0,
  0,
  0,
  311,
  315,
  3,
  98,
  49,
  0,
  312,
  315,
  3,
  98,
  49,
  0,
  313,
  315,
  5,
  46,
  0,
  0,
  314,
  303,
  1,
  0,
  0,
  0,
  314,
  312,
  1,
  0,
  0,
  0,
  314,
  313,
  1,
  0,
  0,
  0,
  315,
  41,
  1,
  0,
  0,
  0,
  316,
  319,
  3,
  46,
  23,
  0,
  317,
  320,
  5,
  27,
  0,
  0,
  318,
  320,
  3,
  98,
  49,
  0,
  319,
  317,
  1,
  0,
  0,
  0,
  319,
  318,
  1,
  0,
  0,
  0,
  319,
  320,
  1,
  0,
  0,
  0,
  320,
  43,
  1,
  0,
  0,
  0,
  321,
  322,
  5,
  47,
  0,
  0,
  322,
  323,
  5,
  30,
  0,
  0,
  323,
  333,
  3,
  20,
  10,
  0,
  324,
  328,
  5,
  28,
  0,
  0,
  325,
  327,
  3,
  20,
  10,
  0,
  326,
  325,
  1,
  0,
  0,
  0,
  327,
  330,
  1,
  0,
  0,
  0,
  328,
  326,
  1,
  0,
  0,
  0,
  328,
  329,
  1,
  0,
  0,
  0,
  329,
  332,
  1,
  0,
  0,
  0,
  330,
  328,
  1,
  0,
  0,
  0,
  331,
  324,
  1,
  0,
  0,
  0,
  332,
  335,
  1,
  0,
  0,
  0,
  333,
  331,
  1,
  0,
  0,
  0,
  333,
  334,
  1,
  0,
  0,
  0,
  334,
  336,
  1,
  0,
  0,
  0,
  335,
  333,
  1,
  0,
  0,
  0,
  336,
  338,
  5,
  31,
  0,
  0,
  337,
  339,
  5,
  27,
  0,
  0,
  338,
  337,
  1,
  0,
  0,
  0,
  338,
  339,
  1,
  0,
  0,
  0,
  339,
  45,
  1,
  0,
  0,
  0,
  340,
  342,
  3,
  62,
  31,
  0,
  341,
  340,
  1,
  0,
  0,
  0,
  341,
  342,
  1,
  0,
  0,
  0,
  342,
  343,
  1,
  0,
  0,
  0,
  343,
  344,
  5,
  41,
  0,
  0,
  344,
  350,
  3,
  68,
  34,
  0,
  345,
  347,
  5,
  30,
  0,
  0,
  346,
  348,
  3,
  76,
  38,
  0,
  347,
  346,
  1,
  0,
  0,
  0,
  347,
  348,
  1,
  0,
  0,
  0,
  348,
  349,
  1,
  0,
  0,
  0,
  349,
  351,
  5,
  31,
  0,
  0,
  350,
  345,
  1,
  0,
  0,
  0,
  350,
  351,
  1,
  0,
  0,
  0,
  351,
  357,
  1,
  0,
  0,
  0,
  352,
  354,
  3,
  62,
  31,
  0,
  353,
  352,
  1,
  0,
  0,
  0,
  353,
  354,
  1,
  0,
  0,
  0,
  354,
  355,
  1,
  0,
  0,
  0,
  355,
  357,
  5,
  41,
  0,
  0,
  356,
  341,
  1,
  0,
  0,
  0,
  356,
  353,
  1,
  0,
  0,
  0,
  357,
  47,
  1,
  0,
  0,
  0,
  358,
  361,
  3,
  50,
  25,
  0,
  359,
  362,
  5,
  27,
  0,
  0,
  360,
  362,
  3,
  98,
  49,
  0,
  361,
  359,
  1,
  0,
  0,
  0,
  361,
  360,
  1,
  0,
  0,
  0,
  361,
  362,
  1,
  0,
  0,
  0,
  362,
  49,
  1,
  0,
  0,
  0,
  363,
  365,
  3,
  62,
  31,
  0,
  364,
  363,
  1,
  0,
  0,
  0,
  364,
  365,
  1,
  0,
  0,
  0,
  365,
  374,
  1,
  0,
  0,
  0,
  366,
  367,
  3,
  54,
  27,
  0,
  367,
  368,
  5,
  10,
  0,
  0,
  368,
  370,
  1,
  0,
  0,
  0,
  369,
  366,
  1,
  0,
  0,
  0,
  369,
  370,
  1,
  0,
  0,
  0,
  370,
  371,
  1,
  0,
  0,
  0,
  371,
  372,
  3,
  56,
  28,
  0,
  372,
  373,
  5,
  56,
  0,
  0,
  373,
  375,
  1,
  0,
  0,
  0,
  374,
  369,
  1,
  0,
  0,
  0,
  374,
  375,
  1,
  0,
  0,
  0,
  375,
  376,
  1,
  0,
  0,
  0,
  376,
  387,
  3,
  52,
  26,
  0,
  377,
  387,
  3,
  62,
  31,
  0,
  378,
  379,
  3,
  54,
  27,
  0,
  379,
  380,
  5,
  10,
  0,
  0,
  380,
  382,
  1,
  0,
  0,
  0,
  381,
  378,
  1,
  0,
  0,
  0,
  381,
  382,
  1,
  0,
  0,
  0,
  382,
  383,
  1,
  0,
  0,
  0,
  383,
  384,
  3,
  56,
  28,
  0,
  384,
  385,
  5,
  56,
  0,
  0,
  385,
  387,
  1,
  0,
  0,
  0,
  386,
  364,
  1,
  0,
  0,
  0,
  386,
  377,
  1,
  0,
  0,
  0,
  386,
  381,
  1,
  0,
  0,
  0,
  387,
  51,
  1,
  0,
  0,
  0,
  388,
  393,
  3,
  58,
  29,
  0,
  389,
  390,
  5,
  56,
  0,
  0,
  390,
  392,
  3,
  58,
  29,
  0,
  391,
  389,
  1,
  0,
  0,
  0,
  392,
  395,
  1,
  0,
  0,
  0,
  393,
  391,
  1,
  0,
  0,
  0,
  393,
  394,
  1,
  0,
  0,
  0,
  394,
  53,
  1,
  0,
  0,
  0,
  395,
  393,
  1,
  0,
  0,
  0,
  396,
  397,
  7,
  0,
  0,
  0,
  397,
  55,
  1,
  0,
  0,
  0,
  398,
  399,
  7,
  0,
  0,
  0,
  399,
  57,
  1,
  0,
  0,
  0,
  400,
  402,
  3,
  74,
  37,
  0,
  401,
  403,
  3,
  60,
  30,
  0,
  402,
  401,
  1,
  0,
  0,
  0,
  402,
  403,
  1,
  0,
  0,
  0,
  403,
  59,
  1,
  0,
  0,
  0,
  404,
  406,
  5,
  30,
  0,
  0,
  405,
  407,
  3,
  76,
  38,
  0,
  406,
  405,
  1,
  0,
  0,
  0,
  406,
  407,
  1,
  0,
  0,
  0,
  407,
  408,
  1,
  0,
  0,
  0,
  408,
  409,
  5,
  31,
  0,
  0,
  409,
  61,
  1,
  0,
  0,
  0,
  410,
  412,
  3,
  70,
  35,
  0,
  411,
  410,
  1,
  0,
  0,
  0,
  411,
  412,
  1,
  0,
  0,
  0,
  412,
  413,
  1,
  0,
  0,
  0,
  413,
  414,
  3,
  72,
  36,
  0,
  414,
  415,
  5,
  29,
  0,
  0,
  415,
  63,
  1,
  0,
  0,
  0,
  416,
  417,
  3,
  54,
  27,
  0,
  417,
  418,
  5,
  10,
  0,
  0,
  418,
  420,
  1,
  0,
  0,
  0,
  419,
  416,
  1,
  0,
  0,
  0,
  419,
  420,
  1,
  0,
  0,
  0,
  420,
  421,
  1,
  0,
  0,
  0,
  421,
  422,
  3,
  56,
  28,
  0,
  422,
  424,
  5,
  7,
  0,
  0,
  423,
  425,
  3,
  66,
  33,
  0,
  424,
  423,
  1,
  0,
  0,
  0,
  424,
  425,
  1,
  0,
  0,
  0,
  425,
  432,
  1,
  0,
  0,
  0,
  426,
  427,
  3,
  54,
  27,
  0,
  427,
  429,
  7,
  3,
  0,
  0,
  428,
  430,
  3,
  56,
  28,
  0,
  429,
  428,
  1,
  0,
  0,
  0,
  429,
  430,
  1,
  0,
  0,
  0,
  430,
  432,
  1,
  0,
  0,
  0,
  431,
  419,
  1,
  0,
  0,
  0,
  431,
  426,
  1,
  0,
  0,
  0,
  432,
  65,
  1,
  0,
  0,
  0,
  433,
  434,
  5,
  67,
  0,
  0,
  434,
  67,
  1,
  0,
  0,
  0,
  435,
  436,
  7,
  0,
  0,
  0,
  436,
  69,
  1,
  0,
  0,
  0,
  437,
  438,
  7,
  0,
  0,
  0,
  438,
  71,
  1,
  0,
  0,
  0,
  439,
  450,
  3,
  104,
  52,
  0,
  440,
  445,
  5,
  57,
  0,
  0,
  441,
  442,
  5,
  28,
  0,
  0,
  442,
  444,
  5,
  57,
  0,
  0,
  443,
  441,
  1,
  0,
  0,
  0,
  444,
  447,
  1,
  0,
  0,
  0,
  445,
  443,
  1,
  0,
  0,
  0,
  445,
  446,
  1,
  0,
  0,
  0,
  446,
  450,
  1,
  0,
  0,
  0,
  447,
  445,
  1,
  0,
  0,
  0,
  448,
  450,
  5,
  62,
  0,
  0,
  449,
  439,
  1,
  0,
  0,
  0,
  449,
  440,
  1,
  0,
  0,
  0,
  449,
  448,
  1,
  0,
  0,
  0,
  450,
  73,
  1,
  0,
  0,
  0,
  451,
  452,
  7,
  0,
  0,
  0,
  452,
  75,
  1,
  0,
  0,
  0,
  453,
  458,
  3,
  78,
  39,
  0,
  454,
  455,
  5,
  28,
  0,
  0,
  455,
  457,
  3,
  78,
  39,
  0,
  456,
  454,
  1,
  0,
  0,
  0,
  457,
  460,
  1,
  0,
  0,
  0,
  458,
  456,
  1,
  0,
  0,
  0,
  458,
  459,
  1,
  0,
  0,
  0,
  459,
  462,
  1,
  0,
  0,
  0,
  460,
  458,
  1,
  0,
  0,
  0,
  461,
  463,
  5,
  28,
  0,
  0,
  462,
  461,
  1,
  0,
  0,
  0,
  462,
  463,
  1,
  0,
  0,
  0,
  463,
  77,
  1,
  0,
  0,
  0,
  464,
  467,
  3,
  80,
  40,
  0,
  465,
  467,
  3,
  102,
  51,
  0,
  466,
  464,
  1,
  0,
  0,
  0,
  466,
  465,
  1,
  0,
  0,
  0,
  467,
  79,
  1,
  0,
  0,
  0,
  468,
  469,
  3,
  70,
  35,
  0,
  469,
  470,
  5,
  57,
  0,
  0,
  470,
  81,
  1,
  0,
  0,
  0,
  471,
  475,
  3,
  84,
  42,
  0,
  472,
  474,
  3,
  86,
  43,
  0,
  473,
  472,
  1,
  0,
  0,
  0,
  474,
  477,
  1,
  0,
  0,
  0,
  475,
  473,
  1,
  0,
  0,
  0,
  475,
  476,
  1,
  0,
  0,
  0,
  476,
  479,
  1,
  0,
  0,
  0,
  477,
  475,
  1,
  0,
  0,
  0,
  478,
  480,
  3,
  88,
  44,
  0,
  479,
  478,
  1,
  0,
  0,
  0,
  479,
  480,
  1,
  0,
  0,
  0,
  480,
  83,
  1,
  0,
  0,
  0,
  481,
  482,
  5,
  49,
  0,
  0,
  482,
  483,
  3,
  98,
  49,
  0,
  483,
  85,
  1,
  0,
  0,
  0,
  484,
  486,
  5,
  50,
  0,
  0,
  485,
  487,
  3,
  60,
  30,
  0,
  486,
  485,
  1,
  0,
  0,
  0,
  486,
  487,
  1,
  0,
  0,
  0,
  487,
  488,
  1,
  0,
  0,
  0,
  488,
  489,
  3,
  98,
  49,
  0,
  489,
  87,
  1,
  0,
  0,
  0,
  490,
  491,
  5,
  51,
  0,
  0,
  491,
  492,
  3,
  98,
  49,
  0,
  492,
  89,
  1,
  0,
  0,
  0,
  493,
  497,
  3,
  92,
  46,
  0,
  494,
  496,
  3,
  94,
  47,
  0,
  495,
  494,
  1,
  0,
  0,
  0,
  496,
  499,
  1,
  0,
  0,
  0,
  497,
  495,
  1,
  0,
  0,
  0,
  497,
  498,
  1,
  0,
  0,
  0,
  498,
  501,
  1,
  0,
  0,
  0,
  499,
  497,
  1,
  0,
  0,
  0,
  500,
  502,
  3,
  96,
  48,
  0,
  501,
  500,
  1,
  0,
  0,
  0,
  501,
  502,
  1,
  0,
  0,
  0,
  502,
  91,
  1,
  0,
  0,
  0,
  503,
  504,
  5,
  37,
  0,
  0,
  504,
  505,
  3,
  106,
  53,
  0,
  505,
  506,
  3,
  98,
  49,
  0,
  506,
  93,
  1,
  0,
  0,
  0,
  507,
  508,
  5,
  38,
  0,
  0,
  508,
  509,
  5,
  37,
  0,
  0,
  509,
  510,
  3,
  106,
  53,
  0,
  510,
  511,
  3,
  98,
  49,
  0,
  511,
  95,
  1,
  0,
  0,
  0,
  512,
  513,
  5,
  38,
  0,
  0,
  513,
  514,
  3,
  98,
  49,
  0,
  514,
  97,
  1,
  0,
  0,
  0,
  515,
  517,
  5,
  32,
  0,
  0,
  516,
  518,
  3,
  24,
  12,
  0,
  517,
  516,
  1,
  0,
  0,
  0,
  517,
  518,
  1,
  0,
  0,
  0,
  518,
  519,
  1,
  0,
  0,
  0,
  519,
  520,
  5,
  33,
  0,
  0,
  520,
  99,
  1,
  0,
  0,
  0,
  521,
  522,
  5,
  39,
  0,
  0,
  522,
  523,
  3,
  106,
  53,
  0,
  523,
  524,
  3,
  98,
  49,
  0,
  524,
  529,
  1,
  0,
  0,
  0,
  525,
  526,
  5,
  39,
  0,
  0,
  526,
  529,
  3,
  106,
  53,
  0,
  527,
  529,
  5,
  39,
  0,
  0,
  528,
  521,
  1,
  0,
  0,
  0,
  528,
  525,
  1,
  0,
  0,
  0,
  528,
  527,
  1,
  0,
  0,
  0,
  529,
  101,
  1,
  0,
  0,
  0,
  530,
  531,
  6,
  51,
  -1,
  0,
  531,
  551,
  3,
  104,
  52,
  0,
  532,
  533,
  5,
  21,
  0,
  0,
  533,
  551,
  3,
  102,
  51,
  13,
  534,
  535,
  5,
  26,
  0,
  0,
  535,
  551,
  3,
  102,
  51,
  12,
  536,
  537,
  3,
  56,
  28,
  0,
  537,
  538,
  5,
  56,
  0,
  0,
  538,
  540,
  1,
  0,
  0,
  0,
  539,
  536,
  1,
  0,
  0,
  0,
  539,
  540,
  1,
  0,
  0,
  0,
  540,
  541,
  1,
  0,
  0,
  0,
  541,
  551,
  3,
  52,
  26,
  0,
  542,
  551,
  3,
  42,
  21,
  0,
  543,
  544,
  5,
  30,
  0,
  0,
  544,
  545,
  3,
  102,
  51,
  0,
  545,
  546,
  5,
  31,
  0,
  0,
  546,
  551,
  1,
  0,
  0,
  0,
  547,
  548,
  3,
  62,
  31,
  0,
  548,
  549,
  3,
  102,
  51,
  1,
  549,
  551,
  1,
  0,
  0,
  0,
  550,
  530,
  1,
  0,
  0,
  0,
  550,
  532,
  1,
  0,
  0,
  0,
  550,
  534,
  1,
  0,
  0,
  0,
  550,
  539,
  1,
  0,
  0,
  0,
  550,
  542,
  1,
  0,
  0,
  0,
  550,
  543,
  1,
  0,
  0,
  0,
  550,
  547,
  1,
  0,
  0,
  0,
  551,
  575,
  1,
  0,
  0,
  0,
  552,
  553,
  10,
  11,
  0,
  0,
  553,
  554,
  7,
  4,
  0,
  0,
  554,
  574,
  3,
  102,
  51,
  12,
  555,
  556,
  10,
  10,
  0,
  0,
  556,
  557,
  7,
  5,
  0,
  0,
  557,
  574,
  3,
  102,
  51,
  11,
  558,
  559,
  10,
  9,
  0,
  0,
  559,
  560,
  7,
  6,
  0,
  0,
  560,
  574,
  3,
  102,
  51,
  10,
  561,
  562,
  10,
  8,
  0,
  0,
  562,
  563,
  7,
  7,
  0,
  0,
  563,
  574,
  3,
  102,
  51,
  9,
  564,
  565,
  10,
  7,
  0,
  0,
  565,
  566,
  5,
  13,
  0,
  0,
  566,
  574,
  3,
  102,
  51,
  8,
  567,
  568,
  10,
  6,
  0,
  0,
  568,
  569,
  5,
  12,
  0,
  0,
  569,
  574,
  3,
  102,
  51,
  7,
  570,
  571,
  10,
  5,
  0,
  0,
  571,
  572,
  5,
  20,
  0,
  0,
  572,
  574,
  3,
  102,
  51,
  6,
  573,
  552,
  1,
  0,
  0,
  0,
  573,
  555,
  1,
  0,
  0,
  0,
  573,
  558,
  1,
  0,
  0,
  0,
  573,
  561,
  1,
  0,
  0,
  0,
  573,
  564,
  1,
  0,
  0,
  0,
  573,
  567,
  1,
  0,
  0,
  0,
  573,
  570,
  1,
  0,
  0,
  0,
  574,
  577,
  1,
  0,
  0,
  0,
  575,
  573,
  1,
  0,
  0,
  0,
  575,
  576,
  1,
  0,
  0,
  0,
  576,
  103,
  1,
  0,
  0,
  0,
  577,
  575,
  1,
  0,
  0,
  0,
  578,
  586,
  7,
  8,
  0,
  0,
  579,
  586,
  5,
  61,
  0,
  0,
  580,
  586,
  5,
  60,
  0,
  0,
  581,
  586,
  7,
  9,
  0,
  0,
  582,
  586,
  5,
  57,
  0,
  0,
  583,
  586,
  5,
  62,
  0,
  0,
  584,
  586,
  5,
  36,
  0,
  0,
  585,
  578,
  1,
  0,
  0,
  0,
  585,
  579,
  1,
  0,
  0,
  0,
  585,
  580,
  1,
  0,
  0,
  0,
  585,
  581,
  1,
  0,
  0,
  0,
  585,
  582,
  1,
  0,
  0,
  0,
  585,
  583,
  1,
  0,
  0,
  0,
  585,
  584,
  1,
  0,
  0,
  0,
  586,
  105,
  1,
  0,
  0,
  0,
  587,
  588,
  5,
  30,
  0,
  0,
  588,
  589,
  3,
  108,
  54,
  0,
  589,
  590,
  5,
  31,
  0,
  0,
  590,
  597,
  1,
  0,
  0,
  0,
  591,
  592,
  5,
  30,
  0,
  0,
  592,
  597,
  3,
  108,
  54,
  0,
  593,
  594,
  5,
  30,
  0,
  0,
  594,
  597,
  5,
  31,
  0,
  0,
  595,
  597,
  5,
  30,
  0,
  0,
  596,
  587,
  1,
  0,
  0,
  0,
  596,
  591,
  1,
  0,
  0,
  0,
  596,
  593,
  1,
  0,
  0,
  0,
  596,
  595,
  1,
  0,
  0,
  0,
  597,
  107,
  1,
  0,
  0,
  0,
  598,
  602,
  3,
  104,
  52,
  0,
  599,
  602,
  3,
  102,
  51,
  0,
  600,
  602,
  3,
  110,
  55,
  0,
  601,
  598,
  1,
  0,
  0,
  0,
  601,
  599,
  1,
  0,
  0,
  0,
  601,
  600,
  1,
  0,
  0,
  0,
  602,
  109,
  1,
  0,
  0,
  0,
  603,
  604,
  5,
  57,
  0,
  0,
  604,
  605,
  5,
  52,
  0,
  0,
  605,
  606,
  5,
  57,
  0,
  0,
  606,
  111,
  1,
  0,
  0,
  0,
  87,
  113,
  117,
  123,
  126,
  131,
  135,
  138,
  142,
  144,
  148,
  150,
  154,
  158,
  164,
  170,
  175,
  177,
  182,
  185,
  188,
  193,
  196,
  200,
  203,
  206,
  210,
  219,
  223,
  225,
  230,
  241,
  245,
  248,
  253,
  255,
  272,
  279,
  284,
  289,
  294,
  297,
  301,
  306,
  309,
  314,
  319,
  328,
  333,
  338,
  341,
  347,
  350,
  353,
  356,
  361,
  364,
  369,
  374,
  381,
  386,
  393,
  402,
  406,
  411,
  419,
  424,
  429,
  431,
  445,
  449,
  458,
  462,
  466,
  475,
  479,
  486,
  497,
  501,
  517,
  528,
  539,
  550,
  573,
  575,
  585,
  596,
  601
], D6 = new y.atn.ATNDeserializer().deserialize(gg), fg = D6.decisionToState.map((t, e) => new y.dfa.DFA(t, e)), pg = new y.PredictionContextCache(), R = class R extends y.Parser {
  constructor(e) {
    super(e), this._interp = new y.atn.ParserATNSimulator(this, D6, fg, pg), this.ruleNames = R.ruleNames, this.literalNames = R.literalNames, this.symbolicNames = R.symbolicNames;
  }
  get atn() {
    return D6;
  }
  sempred(e, n, i) {
    switch (n) {
      case 51:
        return this.expr_sempred(e, i);
      default:
        throw "No predicate with index:" + n;
    }
  }
  expr_sempred(e, n) {
    switch (n) {
      case 0:
        return this.precpred(this._ctx, 11);
      case 1:
        return this.precpred(this._ctx, 10);
      case 2:
        return this.precpred(this._ctx, 9);
      case 3:
        return this.precpred(this._ctx, 8);
      case 4:
        return this.precpred(this._ctx, 7);
      case 5:
        return this.precpred(this._ctx, 6);
      case 6:
        return this.precpred(this._ctx, 5);
      default:
        throw "No predicate with index:" + n;
    }
  }
  prog() {
    let e = new dl(this, this._ctx, this.state);
    this.enterRule(e, 0, R.RULE_prog);
    var n = 0;
    try {
      this.state = 131, this._errHandler.sync(this);
      var i = this._interp.adaptivePredict(this._input, 4, this._ctx);
      switch (i) {
        case 1:
          this.enterOuterAlt(e, 1), this.state = 113, this._errHandler.sync(this), n = this._input.LA(1), n === 6 && (this.state = 112, this.title()), this.state = 115, this.match(R.EOF);
          break;
        case 2:
          this.enterOuterAlt(e, 2), this.state = 117, this._errHandler.sync(this), n = this._input.LA(1), n === 6 && (this.state = 116, this.title()), this.state = 119, this.head(), this.state = 120, this.match(R.EOF);
          break;
        case 3:
          this.enterOuterAlt(e, 3), this.state = 123, this._errHandler.sync(this), n = this._input.LA(1), n === 6 && (this.state = 122, this.title()), this.state = 126, this._errHandler.sync(this);
          var i = this._interp.adaptivePredict(this._input, 3, this._ctx);
          i === 1 && (this.state = 125, this.head()), this.state = 128, this.block(), this.state = 129, this.match(R.EOF);
          break;
      }
    } catch (s) {
      if (s instanceof y.error.RecognitionException)
        e.exception = s, this._errHandler.reportError(this, s), this._errHandler.recover(this, s);
      else
        throw s;
    } finally {
      this.exitRule();
    }
    return e;
  }
  title() {
    let e = new st(this, this._ctx, this.state);
    this.enterRule(e, 2, R.RULE_title);
    var n = 0;
    try {
      this.enterOuterAlt(e, 1), this.state = 133, this.match(R.TITLE), this.state = 135, this._errHandler.sync(this), n = this._input.LA(1), n === 69 && (this.state = 134, this.match(R.TITLE_CONTENT)), this.state = 138, this._errHandler.sync(this), n = this._input.LA(1), n === 70 && (this.state = 137, this.match(R.TITLE_END));
    } catch (i) {
      if (i instanceof y.error.RecognitionException)
        e.exception = i, this._errHandler.reportError(this, i), this._errHandler.recover(this, i);
      else
        throw i;
    } finally {
      this.exitRule();
    }
    return e;
  }
  head() {
    let e = new rt(this, this._ctx, this.state);
    this.enterRule(e, 4, R.RULE_head);
    try {
      this.state = 154, this._errHandler.sync(this);
      var n = this._interp.adaptivePredict(this._input, 11, this._ctx);
      switch (n) {
        case 1:
          this.enterOuterAlt(e, 1), this.state = 142, this._errHandler.sync(this);
          var i = 1;
          do {
            switch (i) {
              case 1:
                switch (this.state = 142, this._errHandler.sync(this), this._input.LA(1)) {
                  case 43:
                    this.state = 140, this.group();
                    break;
                  case 8:
                  case 17:
                  case 55:
                  case 57:
                  case 62:
                    this.state = 141, this.participant();
                    break;
                  default:
                    throw new y.error.NoViableAltException(this);
                }
                break;
              default:
                throw new y.error.NoViableAltException(this);
            }
            this.state = 144, this._errHandler.sync(this), i = this._interp.adaptivePredict(this._input, 8, this._ctx);
          } while (i != 2 && i != y.atn.ATN.INVALID_ALT_NUMBER);
          break;
        case 2:
          this.enterOuterAlt(e, 2), this.state = 150, this._errHandler.sync(this);
          for (var i = this._interp.adaptivePredict(this._input, 10, this._ctx); i != 2 && i != y.atn.ATN.INVALID_ALT_NUMBER; ) {
            if (i === 1)
              switch (this.state = 148, this._errHandler.sync(this), this._input.LA(1)) {
                case 43:
                  this.state = 146, this.group();
                  break;
                case 8:
                case 17:
                case 55:
                case 57:
                case 62:
                  this.state = 147, this.participant();
                  break;
                default:
                  throw new y.error.NoViableAltException(this);
              }
            this.state = 152, this._errHandler.sync(this), i = this._interp.adaptivePredict(this._input, 10, this._ctx);
          }
          this.state = 153, this.starterExp();
          break;
      }
    } catch (s) {
      if (s instanceof y.error.RecognitionException)
        e.exception = s, this._errHandler.reportError(this, s), this._errHandler.recover(this, s);
      else
        throw s;
    } finally {
      this.exitRule();
    }
    return e;
  }
  group() {
    let e = new a8(this, this._ctx, this.state);
    this.enterRule(e, 6, R.RULE_group);
    var n = 0;
    try {
      this.state = 177, this._errHandler.sync(this);
      var i = this._interp.adaptivePredict(this._input, 16, this._ctx);
      switch (i) {
        case 1:
          for (this.enterOuterAlt(e, 1), this.state = 156, this.match(R.GROUP), this.state = 158, this._errHandler.sync(this), n = this._input.LA(1), (n === 57 || n === 62) && (this.state = 157, this.name()), this.state = 160, this.match(R.OBRACE), this.state = 164, this._errHandler.sync(this), n = this._input.LA(1); n === 8 || n === 17 || !(n - 55 & -32) && 1 << n - 55 & 133; )
            this.state = 161, this.participant(), this.state = 166, this._errHandler.sync(this), n = this._input.LA(1);
          this.state = 167, this.match(R.CBRACE);
          break;
        case 2:
          this.enterOuterAlt(e, 2), this.state = 168, this.match(R.GROUP), this.state = 170, this._errHandler.sync(this), n = this._input.LA(1), (n === 57 || n === 62) && (this.state = 169, this.name()), this.state = 172, this.match(R.OBRACE);
          break;
        case 3:
          this.enterOuterAlt(e, 3), this.state = 173, this.match(R.GROUP), this.state = 175, this._errHandler.sync(this);
          var i = this._interp.adaptivePredict(this._input, 15, this._ctx);
          i === 1 && (this.state = 174, this.name());
          break;
      }
    } catch (s) {
      if (s instanceof y.error.RecognitionException)
        e.exception = s, this._errHandler.reportError(this, s), this._errHandler.recover(this, s);
      else
        throw s;
    } finally {
      this.exitRule();
    }
    return e;
  }
  starterExp() {
    let e = new ot(this, this._ctx, this.state);
    this.enterRule(e, 8, R.RULE_starterExp);
    var n = 0;
    try {
      switch (this.state = 188, this._errHandler.sync(this), this._input.LA(1)) {
        case 53:
          this.enterOuterAlt(e, 1), this.state = 179, this.match(R.STARTER_LXR), this.state = 185, this._errHandler.sync(this), n = this._input.LA(1), n === 30 && (this.state = 180, this.match(R.OPAR), this.state = 182, this._errHandler.sync(this), n = this._input.LA(1), (n === 57 || n === 62) && (this.state = 181, this.starter()), this.state = 184, this.match(R.CPAR));
          break;
        case 55:
          this.enterOuterAlt(e, 2), this.state = 187, this.match(R.ANNOTATION);
          break;
        default:
          throw new y.error.NoViableAltException(this);
      }
    } catch (i) {
      if (i instanceof y.error.RecognitionException)
        e.exception = i, this._errHandler.reportError(this, i), this._errHandler.recover(this, i);
      else
        throw i;
    } finally {
      this.exitRule();
    }
    return e;
  }
  starter() {
    let e = new lt(this, this._ctx, this.state);
    this.enterRule(e, 10, R.RULE_starter);
    var n = 0;
    try {
      this.enterOuterAlt(e, 1), this.state = 190, n = this._input.LA(1), n === 57 || n === 62 ? (this._errHandler.reportMatch(this), this.consume()) : this._errHandler.recoverInline(this);
    } catch (i) {
      if (i instanceof y.error.RecognitionException)
        e.exception = i, this._errHandler.reportError(this, i), this._errHandler.recover(this, i);
      else
        throw i;
    } finally {
      this.exitRule();
    }
    return e;
  }
  participant() {
    let e = new q9(this, this._ctx, this.state);
    this.enterRule(e, 12, R.RULE_participant);
    var n = 0;
    try {
      this.state = 210, this._errHandler.sync(this);
      var i = this._interp.adaptivePredict(this._input, 25, this._ctx);
      switch (i) {
        case 1:
          this.enterOuterAlt(e, 1), this.state = 193, this._errHandler.sync(this), n = this._input.LA(1), n === 55 && (this.state = 192, this.participantType()), this.state = 196, this._errHandler.sync(this), n = this._input.LA(1), (n === 8 || n === 17) && (this.state = 195, this.stereotype()), this.state = 198, this.name(), this.state = 200, this._errHandler.sync(this);
          var i = this._interp.adaptivePredict(this._input, 22, this._ctx);
          i === 1 && (this.state = 199, this.width()), this.state = 203, this._errHandler.sync(this), n = this._input.LA(1), n === 48 && (this.state = 202, this.label()), this.state = 206, this._errHandler.sync(this), n = this._input.LA(1), n === 11 && (this.state = 205, this.match(R.COLOR));
          break;
        case 2:
          this.enterOuterAlt(e, 2), this.state = 208, this.stereotype();
          break;
        case 3:
          this.enterOuterAlt(e, 3), this.state = 209, this.participantType();
          break;
      }
    } catch (s) {
      if (s instanceof y.error.RecognitionException)
        e.exception = s, this._errHandler.reportError(this, s), this._errHandler.recover(this, s);
      else
        throw s;
    } finally {
      this.exitRule();
    }
    return e;
  }
  stereotype() {
    let e = new Lt(this, this._ctx, this.state);
    this.enterRule(e, 14, R.RULE_stereotype);
    var n = 0;
    try {
      this.state = 225, this._errHandler.sync(this);
      var i = this._interp.adaptivePredict(this._input, 28, this._ctx);
      switch (i) {
        case 1:
          this.enterOuterAlt(e, 1), this.state = 212, this.match(R.SOPEN), this.state = 213, this.name(), this.state = 214, this.match(R.SCLOSE);
          break;
        case 2:
          this.enterOuterAlt(e, 2), this.state = 216, this.match(R.SOPEN), this.state = 217, this.name(), this.state = 219, this._errHandler.sync(this), n = this._input.LA(1), n === 16 && (this.state = 218, this.match(R.GT));
          break;
        case 3:
          this.enterOuterAlt(e, 3), this.state = 221, n = this._input.LA(1), n === 8 || n === 17 ? (this._errHandler.reportMatch(this), this.consume()) : this._errHandler.recoverInline(this), this.state = 223, this._errHandler.sync(this), n = this._input.LA(1), (n === 9 || n === 16) && (this.state = 222, n = this._input.LA(1), n === 9 || n === 16 ? (this._errHandler.reportMatch(this), this.consume()) : this._errHandler.recoverInline(this));
          break;
      }
    } catch (s) {
      if (s instanceof y.error.RecognitionException)
        e.exception = s, this._errHandler.reportError(this, s), this._errHandler.recover(this, s);
      else
        throw s;
    } finally {
      this.exitRule();
    }
    return e;
  }
  label() {
    let e = new at(this, this._ctx, this.state);
    this.enterRule(e, 16, R.RULE_label);
    try {
      this.state = 230, this._errHandler.sync(this);
      var n = this._interp.adaptivePredict(this._input, 29, this._ctx);
      switch (n) {
        case 1:
          this.enterOuterAlt(e, 1), this.state = 227, this.match(R.AS), this.state = 228, this.name();
          break;
        case 2:
          this.enterOuterAlt(e, 2), this.state = 229, this.match(R.AS);
          break;
      }
    } catch (i) {
      if (i instanceof y.error.RecognitionException)
        e.exception = i, this._errHandler.reportError(this, i), this._errHandler.recover(this, i);
      else
        throw i;
    } finally {
      this.exitRule();
    }
    return e;
  }
  participantType() {
    let e = new Ct(this, this._ctx, this.state);
    this.enterRule(e, 18, R.RULE_participantType);
    try {
      this.enterOuterAlt(e, 1), this.state = 232, this.match(R.ANNOTATION);
    } catch (n) {
      if (n instanceof y.error.RecognitionException)
        e.exception = n, this._errHandler.reportError(this, n), this._errHandler.recover(this, n);
      else
        throw n;
    } finally {
      this.exitRule();
    }
    return e;
  }
  name() {
    let e = new U4(this, this._ctx, this.state);
    this.enterRule(e, 20, R.RULE_name);
    var n = 0;
    try {
      this.enterOuterAlt(e, 1), this.state = 234, n = this._input.LA(1), n === 57 || n === 62 ? (this._errHandler.reportMatch(this), this.consume()) : this._errHandler.recoverInline(this);
    } catch (i) {
      if (i instanceof y.error.RecognitionException)
        e.exception = i, this._errHandler.reportError(this, i), this._errHandler.recover(this, i);
      else
        throw i;
    } finally {
      this.exitRule();
    }
    return e;
  }
  width() {
    let e = new ct(this, this._ctx, this.state);
    this.enterRule(e, 22, R.RULE_width);
    try {
      this.enterOuterAlt(e, 1), this.state = 236, this.match(R.INT);
    } catch (n) {
      if (n instanceof y.error.RecognitionException)
        e.exception = n, this._errHandler.reportError(this, n), this._errHandler.recover(this, n);
      else
        throw n;
    } finally {
      this.exitRule();
    }
    return e;
  }
  block() {
    let e = new e7(this, this._ctx, this.state);
    this.enterRule(e, 24, R.RULE_block);
    var n = 0;
    try {
      this.enterOuterAlt(e, 1), this.state = 239, this._errHandler.sync(this), n = this._input.LA(1);
      do
        this.state = 238, this.stat(), this.state = 241, this._errHandler.sync(this), n = this._input.LA(1);
      while (!(n - 32 & -32) && 1 << n - 32 & 2118318013 || n === 65 || n === 66);
    } catch (i) {
      if (i instanceof y.error.RecognitionException)
        e.exception = i, this._errHandler.reportError(this, i), this._errHandler.recover(this, i);
      else
        throw i;
    } finally {
      this.exitRule();
    }
    return e;
  }
  ret() {
    let e = new ut(this, this._ctx, this.state);
    this.enterRule(e, 26, R.RULE_ret);
    var n = 0;
    try {
      switch (this.state = 255, this._errHandler.sync(this), this._input.LA(1)) {
        case 40:
          this.enterOuterAlt(e, 1), this.state = 243, this.match(R.RETURN), this.state = 245, this._errHandler.sync(this);
          var i = this._interp.adaptivePredict(this._input, 31, this._ctx);
          i === 1 && (this.state = 244, this.expr(0)), this.state = 248, this._errHandler.sync(this), n = this._input.LA(1), n === 27 && (this.state = 247, this.match(R.SCOL));
          break;
        case 54:
          this.enterOuterAlt(e, 2), this.state = 250, this.match(R.ANNOTATION_RET), this.state = 251, this.asyncMessage(), this.state = 253, this._errHandler.sync(this), n = this._input.LA(1), n === 68 && (this.state = 252, this.match(R.EVENT_END));
          break;
        default:
          throw new y.error.NoViableAltException(this);
      }
    } catch (s) {
      if (s instanceof y.error.RecognitionException)
        e.exception = s, this._errHandler.reportError(this, s), this._errHandler.recover(this, s);
      else
        throw s;
    } finally {
      this.exitRule();
    }
    return e;
  }
  divider() {
    let e = new ht(this, this._ctx, this.state);
    this.enterRule(e, 28, R.RULE_divider);
    try {
      this.enterOuterAlt(e, 1), this.state = 257, this.dividerNote();
    } catch (n) {
      if (n instanceof y.error.RecognitionException)
        e.exception = n, this._errHandler.reportError(this, n), this._errHandler.recover(this, n);
      else
        throw n;
    } finally {
      this.exitRule();
    }
    return e;
  }
  dividerNote() {
    let e = new dt(this, this._ctx, this.state);
    this.enterRule(e, 30, R.RULE_dividerNote);
    try {
      this.enterOuterAlt(e, 1), this.state = 259, this.match(R.DIVIDER);
    } catch (n) {
      if (n instanceof y.error.RecognitionException)
        e.exception = n, this._errHandler.reportError(this, n), this._errHandler.recover(this, n);
      else
        throw n;
    } finally {
      this.exitRule();
    }
    return e;
  }
  stat() {
    let e = new C8(this, this._ctx, this.state);
    this.enterRule(e, 32, R.RULE_stat);
    var n = 0;
    try {
      this.state = 279, this._errHandler.sync(this);
      var i = this._interp.adaptivePredict(this._input, 36, this._ctx);
      switch (i) {
        case 1:
          this.enterOuterAlt(e, 1), this.state = 261, this.alt();
          break;
        case 2:
          this.enterOuterAlt(e, 2), this.state = 262, this.par();
          break;
        case 3:
          this.enterOuterAlt(e, 3), this.state = 263, this.opt();
          break;
        case 4:
          this.enterOuterAlt(e, 4), this.state = 264, this.critical();
          break;
        case 5:
          this.enterOuterAlt(e, 5), this.state = 265, this.section();
          break;
        case 6:
          this.enterOuterAlt(e, 6), this.state = 266, this.ref();
          break;
        case 7:
          this.enterOuterAlt(e, 7), this.state = 267, this.loop();
          break;
        case 8:
          this.enterOuterAlt(e, 8), this.state = 268, this.creation();
          break;
        case 9:
          this.enterOuterAlt(e, 9), this.state = 269, this.message();
          break;
        case 10:
          this.enterOuterAlt(e, 10), this.state = 270, this.asyncMessage(), this.state = 272, this._errHandler.sync(this), n = this._input.LA(1), n === 68 && (this.state = 271, this.match(R.EVENT_END));
          break;
        case 11:
          this.enterOuterAlt(e, 11), this.state = 274, this.ret();
          break;
        case 12:
          this.enterOuterAlt(e, 12), this.state = 275, this.divider();
          break;
        case 13:
          this.enterOuterAlt(e, 13), this.state = 276, this.tcf();
          break;
        case 14:
          this.enterOuterAlt(e, 14), this.state = 277, e._OTHER = this.match(R.OTHER), console.log("unknown char: " + (e._OTHER === null ? null : e._OTHER.text));
          break;
      }
    } catch (s) {
      if (s instanceof y.error.RecognitionException)
        e.exception = s, this._errHandler.reportError(this, s), this._errHandler.recover(this, s);
      else
        throw s;
    } finally {
      this.exitRule();
    }
    return e;
  }
  par() {
    let e = new gt(this, this._ctx, this.state);
    this.enterRule(e, 34, R.RULE_par);
    try {
      this.state = 284, this._errHandler.sync(this);
      var n = this._interp.adaptivePredict(this._input, 37, this._ctx);
      switch (n) {
        case 1:
          this.enterOuterAlt(e, 1), this.state = 281, this.match(R.PAR), this.state = 282, this.braceBlock();
          break;
        case 2:
          this.enterOuterAlt(e, 2), this.state = 283, this.match(R.PAR);
          break;
      }
    } catch (i) {
      if (i instanceof y.error.RecognitionException)
        e.exception = i, this._errHandler.reportError(this, i), this._errHandler.recover(this, i);
      else
        throw i;
    } finally {
      this.exitRule();
    }
    return e;
  }
  opt() {
    let e = new ft(this, this._ctx, this.state);
    this.enterRule(e, 36, R.RULE_opt);
    try {
      this.state = 289, this._errHandler.sync(this);
      var n = this._interp.adaptivePredict(this._input, 38, this._ctx);
      switch (n) {
        case 1:
          this.enterOuterAlt(e, 1), this.state = 286, this.match(R.OPT), this.state = 287, this.braceBlock();
          break;
        case 2:
          this.enterOuterAlt(e, 2), this.state = 288, this.match(R.OPT);
          break;
      }
    } catch (i) {
      if (i instanceof y.error.RecognitionException)
        e.exception = i, this._errHandler.reportError(this, i), this._errHandler.recover(this, i);
      else
        throw i;
    } finally {
      this.exitRule();
    }
    return e;
  }
  critical() {
    let e = new pt(this, this._ctx, this.state);
    this.enterRule(e, 38, R.RULE_critical);
    var n = 0;
    try {
      this.state = 301, this._errHandler.sync(this);
      var i = this._interp.adaptivePredict(this._input, 41, this._ctx);
      switch (i) {
        case 1:
          this.enterOuterAlt(e, 1), this.state = 291, this.match(R.CRITICAL), this.state = 297, this._errHandler.sync(this), n = this._input.LA(1), n === 30 && (this.state = 292, this.match(R.OPAR), this.state = 294, this._errHandler.sync(this), n = this._input.LA(1), !(n - 34 & -32) && 1 << n - 34 & 528482311 && (this.state = 293, this.atom()), this.state = 296, this.match(R.CPAR)), this.state = 299, this.braceBlock();
          break;
        case 2:
          this.enterOuterAlt(e, 2), this.state = 300, this.match(R.CRITICAL);
          break;
      }
    } catch (s) {
      if (s instanceof y.error.RecognitionException)
        e.exception = s, this._errHandler.reportError(this, s), this._errHandler.recover(this, s);
      else
        throw s;
    } finally {
      this.exitRule();
    }
    return e;
  }
  section() {
    let e = new mt(this, this._ctx, this.state);
    this.enterRule(e, 40, R.RULE_section);
    var n = 0;
    try {
      this.state = 314, this._errHandler.sync(this);
      var i = this._interp.adaptivePredict(this._input, 44, this._ctx);
      switch (i) {
        case 1:
          this.enterOuterAlt(e, 1), this.state = 303, this.match(R.SECTION), this.state = 309, this._errHandler.sync(this), n = this._input.LA(1), n === 30 && (this.state = 304, this.match(R.OPAR), this.state = 306, this._errHandler.sync(this), n = this._input.LA(1), !(n - 34 & -32) && 1 << n - 34 & 528482311 && (this.state = 305, this.atom()), this.state = 308, this.match(R.CPAR)), this.state = 311, this.braceBlock();
          break;
        case 2:
          this.enterOuterAlt(e, 2), this.state = 312, this.braceBlock();
          break;
        case 3:
          this.enterOuterAlt(e, 3), this.state = 313, this.match(R.SECTION);
          break;
      }
    } catch (s) {
      if (s instanceof y.error.RecognitionException)
        e.exception = s, this._errHandler.reportError(this, s), this._errHandler.recover(this, s);
      else
        throw s;
    } finally {
      this.exitRule();
    }
    return e;
  }
  creation() {
    let e = new t7(this, this._ctx, this.state);
    this.enterRule(e, 42, R.RULE_creation);
    try {
      this.enterOuterAlt(e, 1), this.state = 316, this.creationBody(), this.state = 319, this._errHandler.sync(this);
      var n = this._interp.adaptivePredict(this._input, 45, this._ctx);
      n === 1 ? (this.state = 317, this.match(R.SCOL)) : n === 2 && (this.state = 318, this.braceBlock());
    } catch (i) {
      if (i instanceof y.error.RecognitionException)
        e.exception = i, this._errHandler.reportError(this, i), this._errHandler.recover(this, i);
      else
        throw i;
    } finally {
      this.exitRule();
    }
    return e;
  }
  ref() {
    let e = new wt(this, this._ctx, this.state);
    this.enterRule(e, 44, R.RULE_ref);
    var n = 0;
    try {
      for (this.enterOuterAlt(e, 1), this.state = 321, this.match(R.REF), this.state = 322, this.match(R.OPAR), this.state = 323, this.name(), this.state = 333, this._errHandler.sync(this), n = this._input.LA(1); n === 28; ) {
        for (this.state = 324, this.match(R.COMMA), this.state = 328, this._errHandler.sync(this), n = this._input.LA(1); n === 57 || n === 62; )
          this.state = 325, this.name(), this.state = 330, this._errHandler.sync(this), n = this._input.LA(1);
        this.state = 335, this._errHandler.sync(this), n = this._input.LA(1);
      }
      this.state = 336, this.match(R.CPAR), this.state = 338, this._errHandler.sync(this), n = this._input.LA(1), n === 27 && (this.state = 337, this.match(R.SCOL));
    } catch (i) {
      if (i instanceof y.error.RecognitionException)
        e.exception = i, this._errHandler.reportError(this, i), this._errHandler.recover(this, i);
      else
        throw i;
    } finally {
      this.exitRule();
    }
    return e;
  }
  creationBody() {
    let e = new xt(this, this._ctx, this.state);
    this.enterRule(e, 46, R.RULE_creationBody);
    var n = 0;
    try {
      this.state = 356, this._errHandler.sync(this);
      var i = this._interp.adaptivePredict(this._input, 53, this._ctx);
      switch (i) {
        case 1:
          this.enterOuterAlt(e, 1), this.state = 341, this._errHandler.sync(this), n = this._input.LA(1), !(n - 34 & -32) && 1 << n - 34 & 528482311 && (this.state = 340, this.assignment()), this.state = 343, this.match(R.NEW), this.state = 344, this.construct(), this.state = 350, this._errHandler.sync(this);
          var i = this._interp.adaptivePredict(this._input, 51, this._ctx);
          i === 1 && (this.state = 345, this.match(R.OPAR), this.state = 347, this._errHandler.sync(this), n = this._input.LA(1), (!(n & -32) && 1 << n & 1142947840 || !(n - 34 & -32) && 1 << n - 34 & 528482439) && (this.state = 346, this.parameters()), this.state = 349, this.match(R.CPAR));
          break;
        case 2:
          this.enterOuterAlt(e, 2), this.state = 353, this._errHandler.sync(this), n = this._input.LA(1), !(n - 34 & -32) && 1 << n - 34 & 528482311 && (this.state = 352, this.assignment()), this.state = 355, this.match(R.NEW);
          break;
      }
    } catch (s) {
      if (s instanceof y.error.RecognitionException)
        e.exception = s, this._errHandler.reportError(this, s), this._errHandler.recover(this, s);
      else
        throw s;
    } finally {
      this.exitRule();
    }
    return e;
  }
  message() {
    let e = new _t(this, this._ctx, this.state);
    this.enterRule(e, 48, R.RULE_message);
    try {
      this.enterOuterAlt(e, 1), this.state = 358, this.messageBody(), this.state = 361, this._errHandler.sync(this);
      var n = this._interp.adaptivePredict(this._input, 54, this._ctx);
      n === 1 ? (this.state = 359, this.match(R.SCOL)) : n === 2 && (this.state = 360, this.braceBlock());
    } catch (i) {
      if (i instanceof y.error.RecognitionException)
        e.exception = i, this._errHandler.reportError(this, i), this._errHandler.recover(this, i);
      else
        throw i;
    } finally {
      this.exitRule();
    }
    return e;
  }
  messageBody() {
    let e = new vt(this, this._ctx, this.state);
    this.enterRule(e, 50, R.RULE_messageBody);
    try {
      this.state = 386, this._errHandler.sync(this);
      var n = this._interp.adaptivePredict(this._input, 59, this._ctx);
      switch (n) {
        case 1:
          this.enterOuterAlt(e, 1), this.state = 364, this._errHandler.sync(this);
          var n = this._interp.adaptivePredict(this._input, 55, this._ctx);
          n === 1 && (this.state = 363, this.assignment()), this.state = 374, this._errHandler.sync(this);
          var n = this._interp.adaptivePredict(this._input, 57, this._ctx);
          if (n === 1) {
            this.state = 369, this._errHandler.sync(this);
            var n = this._interp.adaptivePredict(this._input, 56, this._ctx);
            n === 1 && (this.state = 366, this.from(), this.state = 367, this.match(R.ARROW)), this.state = 371, this.to(), this.state = 372, this.match(R.DOT);
          }
          this.state = 376, this.func();
          break;
        case 2:
          this.enterOuterAlt(e, 2), this.state = 377, this.assignment();
          break;
        case 3:
          this.enterOuterAlt(e, 3), this.state = 381, this._errHandler.sync(this);
          var n = this._interp.adaptivePredict(this._input, 58, this._ctx);
          n === 1 && (this.state = 378, this.from(), this.state = 379, this.match(R.ARROW)), this.state = 383, this.to(), this.state = 384, this.match(R.DOT);
          break;
      }
    } catch (i) {
      if (i instanceof y.error.RecognitionException)
        e.exception = i, this._errHandler.reportError(this, i), this._errHandler.recover(this, i);
      else
        throw i;
    } finally {
      this.exitRule();
    }
    return e;
  }
  func() {
    let e = new n7(this, this._ctx, this.state);
    this.enterRule(e, 52, R.RULE_func);
    try {
      this.enterOuterAlt(e, 1), this.state = 388, this.signature(), this.state = 393, this._errHandler.sync(this);
      for (var n = this._interp.adaptivePredict(this._input, 60, this._ctx); n != 2 && n != y.atn.ATN.INVALID_ALT_NUMBER; )
        n === 1 && (this.state = 389, this.match(R.DOT), this.state = 390, this.signature()), this.state = 395, this._errHandler.sync(this), n = this._interp.adaptivePredict(this._input, 60, this._ctx);
    } catch (i) {
      if (i instanceof y.error.RecognitionException)
        e.exception = i, this._errHandler.reportError(this, i), this._errHandler.recover(this, i);
      else
        throw i;
    } finally {
      this.exitRule();
    }
    return e;
  }
  from() {
    let e = new i7(this, this._ctx, this.state);
    this.enterRule(e, 54, R.RULE_from);
    var n = 0;
    try {
      this.enterOuterAlt(e, 1), this.state = 396, n = this._input.LA(1), n === 57 || n === 62 ? (this._errHandler.reportMatch(this), this.consume()) : this._errHandler.recoverInline(this);
    } catch (i) {
      if (i instanceof y.error.RecognitionException)
        e.exception = i, this._errHandler.reportError(this, i), this._errHandler.recover(this, i);
      else
        throw i;
    } finally {
      this.exitRule();
    }
    return e;
  }
  to() {
    let e = new l5(this, this._ctx, this.state);
    this.enterRule(e, 56, R.RULE_to);
    var n = 0;
    try {
      this.enterOuterAlt(e, 1), this.state = 398, n = this._input.LA(1), n === 57 || n === 62 ? (this._errHandler.reportMatch(this), this.consume()) : this._errHandler.recoverInline(this);
    } catch (i) {
      if (i instanceof y.error.RecognitionException)
        e.exception = i, this._errHandler.reportError(this, i), this._errHandler.recover(this, i);
      else
        throw i;
    } finally {
      this.exitRule();
    }
    return e;
  }
  signature() {
    let e = new c8(this, this._ctx, this.state);
    this.enterRule(e, 58, R.RULE_signature);
    try {
      this.enterOuterAlt(e, 1), this.state = 400, this.methodName(), this.state = 402, this._errHandler.sync(this);
      var n = this._interp.adaptivePredict(this._input, 61, this._ctx);
      n === 1 && (this.state = 401, this.invocation());
    } catch (i) {
      if (i instanceof y.error.RecognitionException)
        e.exception = i, this._errHandler.reportError(this, i), this._errHandler.recover(this, i);
      else
        throw i;
    } finally {
      this.exitRule();
    }
    return e;
  }
  invocation() {
    let e = new s7(this, this._ctx, this.state);
    this.enterRule(e, 60, R.RULE_invocation);
    var n = 0;
    try {
      this.enterOuterAlt(e, 1), this.state = 404, this.match(R.OPAR), this.state = 406, this._errHandler.sync(this), n = this._input.LA(1), (!(n & -32) && 1 << n & 1142947840 || !(n - 34 & -32) && 1 << n - 34 & 528482439) && (this.state = 405, this.parameters()), this.state = 408, this.match(R.CPAR);
    } catch (i) {
      if (i instanceof y.error.RecognitionException)
        e.exception = i, this._errHandler.reportError(this, i), this._errHandler.recover(this, i);
      else
        throw i;
    } finally {
      this.exitRule();
    }
    return e;
  }
  assignment() {
    let e = new L5(this, this._ctx, this.state);
    this.enterRule(e, 62, R.RULE_assignment);
    try {
      this.enterOuterAlt(e, 1), this.state = 411, this._errHandler.sync(this);
      var n = this._interp.adaptivePredict(this._input, 63, this._ctx);
      n === 1 && (this.state = 410, this.type()), this.state = 413, this.assignee(), this.state = 414, this.match(R.ASSIGN);
    } catch (i) {
      if (i instanceof y.error.RecognitionException)
        e.exception = i, this._errHandler.reportError(this, i), this._errHandler.recover(this, i);
      else
        throw i;
    } finally {
      this.exitRule();
    }
    return e;
  }
  asyncMessage() {
    let e = new r7(this, this._ctx, this.state);
    this.enterRule(e, 64, R.RULE_asyncMessage);
    var n = 0;
    try {
      this.state = 431, this._errHandler.sync(this);
      var i = this._interp.adaptivePredict(this._input, 67, this._ctx);
      switch (i) {
        case 1:
          this.enterOuterAlt(e, 1), this.state = 419, this._errHandler.sync(this);
          var i = this._interp.adaptivePredict(this._input, 64, this._ctx);
          i === 1 && (this.state = 416, this.from(), this.state = 417, this.match(R.ARROW)), this.state = 421, this.to(), this.state = 422, this.match(R.COL), this.state = 424, this._errHandler.sync(this), n = this._input.LA(1), n === 67 && (this.state = 423, this.content());
          break;
        case 2:
          this.enterOuterAlt(e, 2), this.state = 426, this.from(), this.state = 427, n = this._input.LA(1), n === 10 || n === 21 ? (this._errHandler.reportMatch(this), this.consume()) : this._errHandler.recoverInline(this), this.state = 429, this._errHandler.sync(this);
          var i = this._interp.adaptivePredict(this._input, 66, this._ctx);
          i === 1 && (this.state = 428, this.to());
          break;
      }
    } catch (s) {
      if (s instanceof y.error.RecognitionException)
        e.exception = s, this._errHandler.reportError(this, s), this._errHandler.recover(this, s);
      else
        throw s;
    } finally {
      this.exitRule();
    }
    return e;
  }
  content() {
    let e = new Mt(this, this._ctx, this.state);
    this.enterRule(e, 66, R.RULE_content);
    try {
      this.enterOuterAlt(e, 1), this.state = 433, this.match(R.EVENT_PAYLOAD_LXR);
    } catch (n) {
      if (n instanceof y.error.RecognitionException)
        e.exception = n, this._errHandler.reportError(this, n), this._errHandler.recover(this, n);
      else
        throw n;
    } finally {
      this.exitRule();
    }
    return e;
  }
  construct() {
    let e = new Rt(this, this._ctx, this.state);
    this.enterRule(e, 68, R.RULE_construct);
    var n = 0;
    try {
      this.enterOuterAlt(e, 1), this.state = 435, n = this._input.LA(1), n === 57 || n === 62 ? (this._errHandler.reportMatch(this), this.consume()) : this._errHandler.recoverInline(this);
    } catch (i) {
      if (i instanceof y.error.RecognitionException)
        e.exception = i, this._errHandler.reportError(this, i), this._errHandler.recover(this, i);
      else
        throw i;
    } finally {
      this.exitRule();
    }
    return e;
  }
  type() {
    let e = new o7(this, this._ctx, this.state);
    this.enterRule(e, 70, R.RULE_type);
    var n = 0;
    try {
      this.enterOuterAlt(e, 1), this.state = 437, n = this._input.LA(1), n === 57 || n === 62 ? (this._errHandler.reportMatch(this), this.consume()) : this._errHandler.recoverInline(this);
    } catch (i) {
      if (i instanceof y.error.RecognitionException)
        e.exception = i, this._errHandler.reportError(this, i), this._errHandler.recover(this, i);
      else
        throw i;
    } finally {
      this.exitRule();
    }
    return e;
  }
  assignee() {
    let e = new yt(this, this._ctx, this.state);
    this.enterRule(e, 72, R.RULE_assignee);
    var n = 0;
    try {
      this.state = 449, this._errHandler.sync(this);
      var i = this._interp.adaptivePredict(this._input, 69, this._ctx);
      switch (i) {
        case 1:
          this.enterOuterAlt(e, 1), this.state = 439, this.atom();
          break;
        case 2:
          for (this.enterOuterAlt(e, 2), this.state = 440, this.match(R.ID), this.state = 445, this._errHandler.sync(this), n = this._input.LA(1); n === 28; )
            this.state = 441, this.match(R.COMMA), this.state = 442, this.match(R.ID), this.state = 447, this._errHandler.sync(this), n = this._input.LA(1);
          break;
        case 3:
          this.enterOuterAlt(e, 3), this.state = 448, this.match(R.STRING);
          break;
      }
    } catch (s) {
      if (s instanceof y.error.RecognitionException)
        e.exception = s, this._errHandler.reportError(this, s), this._errHandler.recover(this, s);
      else
        throw s;
    } finally {
      this.exitRule();
    }
    return e;
  }
  methodName() {
    let e = new At(this, this._ctx, this.state);
    this.enterRule(e, 74, R.RULE_methodName);
    var n = 0;
    try {
      this.enterOuterAlt(e, 1), this.state = 451, n = this._input.LA(1), n === 57 || n === 62 ? (this._errHandler.reportMatch(this), this.consume()) : this._errHandler.recoverInline(this);
    } catch (i) {
      if (i instanceof y.error.RecognitionException)
        e.exception = i, this._errHandler.reportError(this, i), this._errHandler.recover(this, i);
      else
        throw i;
    } finally {
      this.exitRule();
    }
    return e;
  }
  parameters() {
    let e = new l7(this, this._ctx, this.state);
    this.enterRule(e, 76, R.RULE_parameters);
    var n = 0;
    try {
      this.enterOuterAlt(e, 1), this.state = 453, this.parameter(), this.state = 458, this._errHandler.sync(this);
      for (var i = this._interp.adaptivePredict(this._input, 70, this._ctx); i != 2 && i != y.atn.ATN.INVALID_ALT_NUMBER; )
        i === 1 && (this.state = 454, this.match(R.COMMA), this.state = 455, this.parameter()), this.state = 460, this._errHandler.sync(this), i = this._interp.adaptivePredict(this._input, 70, this._ctx);
      this.state = 462, this._errHandler.sync(this), n = this._input.LA(1), n === 28 && (this.state = 461, this.match(R.COMMA));
    } catch (s) {
      if (s instanceof y.error.RecognitionException)
        e.exception = s, this._errHandler.reportError(this, s), this._errHandler.recover(this, s);
      else
        throw s;
    } finally {
      this.exitRule();
    }
    return e;
  }
  parameter() {
    let e = new u8(this, this._ctx, this.state);
    this.enterRule(e, 78, R.RULE_parameter);
    try {
      this.state = 466, this._errHandler.sync(this);
      var n = this._interp.adaptivePredict(this._input, 72, this._ctx);
      switch (n) {
        case 1:
          this.enterOuterAlt(e, 1), this.state = 464, this.declaration();
          break;
        case 2:
          this.enterOuterAlt(e, 2), this.state = 465, this.expr(0);
          break;
      }
    } catch (i) {
      if (i instanceof y.error.RecognitionException)
        e.exception = i, this._errHandler.reportError(this, i), this._errHandler.recover(this, i);
      else
        throw i;
    } finally {
      this.exitRule();
    }
    return e;
  }
  declaration() {
    let e = new Zt(this, this._ctx, this.state);
    this.enterRule(e, 80, R.RULE_declaration);
    try {
      this.enterOuterAlt(e, 1), this.state = 468, this.type(), this.state = 469, this.match(R.ID);
    } catch (n) {
      if (n instanceof y.error.RecognitionException)
        e.exception = n, this._errHandler.reportError(this, n), this._errHandler.recover(this, n);
      else
        throw n;
    } finally {
      this.exitRule();
    }
    return e;
  }
  tcf() {
    let e = new kt(this, this._ctx, this.state);
    this.enterRule(e, 82, R.RULE_tcf);
    var n = 0;
    try {
      for (this.enterOuterAlt(e, 1), this.state = 471, this.tryBlock(), this.state = 475, this._errHandler.sync(this), n = this._input.LA(1); n === 50; )
        this.state = 472, this.catchBlock(), this.state = 477, this._errHandler.sync(this), n = this._input.LA(1);
      this.state = 479, this._errHandler.sync(this), n = this._input.LA(1), n === 51 && (this.state = 478, this.finallyBlock());
    } catch (i) {
      if (i instanceof y.error.RecognitionException)
        e.exception = i, this._errHandler.reportError(this, i), this._errHandler.recover(this, i);
      else
        throw i;
    } finally {
      this.exitRule();
    }
    return e;
  }
  tryBlock() {
    let e = new Tt(this, this._ctx, this.state);
    this.enterRule(e, 84, R.RULE_tryBlock);
    try {
      this.enterOuterAlt(e, 1), this.state = 481, this.match(R.TRY), this.state = 482, this.braceBlock();
    } catch (n) {
      if (n instanceof y.error.RecognitionException)
        e.exception = n, this._errHandler.reportError(this, n), this._errHandler.recover(this, n);
      else
        throw n;
    } finally {
      this.exitRule();
    }
    return e;
  }
  catchBlock() {
    let e = new h8(this, this._ctx, this.state);
    this.enterRule(e, 86, R.RULE_catchBlock);
    var n = 0;
    try {
      this.enterOuterAlt(e, 1), this.state = 484, this.match(R.CATCH), this.state = 486, this._errHandler.sync(this), n = this._input.LA(1), n === 30 && (this.state = 485, this.invocation()), this.state = 488, this.braceBlock();
    } catch (i) {
      if (i instanceof y.error.RecognitionException)
        e.exception = i, this._errHandler.reportError(this, i), this._errHandler.recover(this, i);
      else
        throw i;
    } finally {
      this.exitRule();
    }
    return e;
  }
  finallyBlock() {
    let e = new St(this, this._ctx, this.state);
    this.enterRule(e, 88, R.RULE_finallyBlock);
    try {
      this.enterOuterAlt(e, 1), this.state = 490, this.match(R.FINALLY), this.state = 491, this.braceBlock();
    } catch (n) {
      if (n instanceof y.error.RecognitionException)
        e.exception = n, this._errHandler.reportError(this, n), this._errHandler.recover(this, n);
      else
        throw n;
    } finally {
      this.exitRule();
    }
    return e;
  }
  alt() {
    let e = new bt(this, this._ctx, this.state);
    this.enterRule(e, 90, R.RULE_alt);
    var n = 0;
    try {
      this.enterOuterAlt(e, 1), this.state = 493, this.ifBlock(), this.state = 497, this._errHandler.sync(this);
      for (var i = this._interp.adaptivePredict(this._input, 76, this._ctx); i != 2 && i != y.atn.ATN.INVALID_ALT_NUMBER; )
        i === 1 && (this.state = 494, this.elseIfBlock()), this.state = 499, this._errHandler.sync(this), i = this._interp.adaptivePredict(this._input, 76, this._ctx);
      this.state = 501, this._errHandler.sync(this), n = this._input.LA(1), n === 38 && (this.state = 500, this.elseBlock());
    } catch (s) {
      if (s instanceof y.error.RecognitionException)
        e.exception = s, this._errHandler.reportError(this, s), this._errHandler.recover(this, s);
      else
        throw s;
    } finally {
      this.exitRule();
    }
    return e;
  }
  ifBlock() {
    let e = new Et(this, this._ctx, this.state);
    this.enterRule(e, 92, R.RULE_ifBlock);
    try {
      this.enterOuterAlt(e, 1), this.state = 503, this.match(R.IF), this.state = 504, this.parExpr(), this.state = 505, this.braceBlock();
    } catch (n) {
      if (n instanceof y.error.RecognitionException)
        e.exception = n, this._errHandler.reportError(this, n), this._errHandler.recover(this, n);
      else
        throw n;
    } finally {
      this.exitRule();
    }
    return e;
  }
  elseIfBlock() {
    let e = new d8(this, this._ctx, this.state);
    this.enterRule(e, 94, R.RULE_elseIfBlock);
    try {
      this.enterOuterAlt(e, 1), this.state = 507, this.match(R.ELSE), this.state = 508, this.match(R.IF), this.state = 509, this.parExpr(), this.state = 510, this.braceBlock();
    } catch (n) {
      if (n instanceof y.error.RecognitionException)
        e.exception = n, this._errHandler.reportError(this, n), this._errHandler.recover(this, n);
      else
        throw n;
    } finally {
      this.exitRule();
    }
    return e;
  }
  elseBlock() {
    let e = new It(this, this._ctx, this.state);
    this.enterRule(e, 96, R.RULE_elseBlock);
    try {
      this.enterOuterAlt(e, 1), this.state = 512, this.match(R.ELSE), this.state = 513, this.braceBlock();
    } catch (n) {
      if (n instanceof y.error.RecognitionException)
        e.exception = n, this._errHandler.reportError(this, n), this._errHandler.recover(this, n);
      else
        throw n;
    } finally {
      this.exitRule();
    }
    return e;
  }
  braceBlock() {
    let e = new Q1(this, this._ctx, this.state);
    this.enterRule(e, 98, R.RULE_braceBlock);
    var n = 0;
    try {
      this.enterOuterAlt(e, 1), this.state = 515, this.match(R.OBRACE), this.state = 517, this._errHandler.sync(this), n = this._input.LA(1), (!(n - 32 & -32) && 1 << n - 32 & 2118318013 || n === 65 || n === 66) && (this.state = 516, this.block()), this.state = 519, this.match(R.CBRACE);
    } catch (i) {
      if (i instanceof y.error.RecognitionException)
        e.exception = i, this._errHandler.reportError(this, i), this._errHandler.recover(this, i);
      else
        throw i;
    } finally {
      this.exitRule();
    }
    return e;
  }
  loop() {
    let e = new Ft(this, this._ctx, this.state);
    this.enterRule(e, 100, R.RULE_loop);
    try {
      this.state = 528, this._errHandler.sync(this);
      var n = this._interp.adaptivePredict(this._input, 79, this._ctx);
      switch (n) {
        case 1:
          this.enterOuterAlt(e, 1), this.state = 521, this.match(R.WHILE), this.state = 522, this.parExpr(), this.state = 523, this.braceBlock();
          break;
        case 2:
          this.enterOuterAlt(e, 2), this.state = 525, this.match(R.WHILE), this.state = 526, this.parExpr();
          break;
        case 3:
          this.enterOuterAlt(e, 3), this.state = 527, this.match(R.WHILE);
          break;
      }
    } catch (i) {
      if (i instanceof y.error.RecognitionException)
        e.exception = i, this._errHandler.reportError(this, i), this._errHandler.recover(this, i);
      else
        throw i;
    } finally {
      this.exitRule();
    }
    return e;
  }
  expr(e) {
    e === void 0 && (e = 0);
    const n = this._ctx, i = this.state;
    let s = new k2(this, this._ctx, i), r = s;
    const o = 102;
    this.enterRecursionRule(s, 102, R.RULE_expr, e);
    var l = 0;
    try {
      this.enterOuterAlt(s, 1), this.state = 550, this._errHandler.sync(this);
      var L = this._interp.adaptivePredict(this._input, 81, this._ctx);
      switch (L) {
        case 1:
          s = new pl(this, s), this._ctx = s, r = s, this.state = 531, this.atom();
          break;
        case 2:
          s = new Ml(this, s), this._ctx = s, r = s, this.state = 532, this.match(R.MINUS), this.state = 533, this.expr(13);
          break;
        case 3:
          s = new vl(this, s), this._ctx = s, r = s, this.state = 534, this.match(R.NOT), this.state = 535, this.expr(12);
          break;
        case 4:
          s = new fl(this, s), this._ctx = s, r = s, this.state = 539, this._errHandler.sync(this);
          var L = this._interp.adaptivePredict(this._input, 80, this._ctx);
          L === 1 && (this.state = 536, this.to(), this.state = 537, this.match(R.DOT)), this.state = 541, this.func();
          break;
        case 5:
          s = new Rl(this, s), this._ctx = s, r = s, this.state = 542, this.creation();
          break;
        case 6:
          s = new yl(this, s), this._ctx = s, r = s, this.state = 543, this.match(R.OPAR), this.state = 544, this.expr(0), this.state = 545, this.match(R.CPAR);
          break;
        case 7:
          s = new gl(this, s), this._ctx = s, r = s, this.state = 547, this.assignment(), this.state = 548, this.expr(1);
          break;
      }
      this._ctx.stop = this._input.LT(-1), this.state = 575, this._errHandler.sync(this);
      for (var a = this._interp.adaptivePredict(this._input, 83, this._ctx); a != 2 && a != y.atn.ATN.INVALID_ALT_NUMBER; ) {
        if (a === 1) {
          this._parseListeners !== null && this.triggerExitRuleEvent(), r = s, this.state = 573, this._errHandler.sync(this);
          var L = this._interp.adaptivePredict(this._input, 82, this._ctx);
          switch (L) {
            case 1:
              if (s = new Al(this, new k2(this, n, i)), this.pushNewRecursionContext(s, o, R.RULE_expr), this.state = 552, !this.precpred(this._ctx, 11))
                throw new y.error.FailedPredicateException(this, "this.precpred(this._ctx, 11)");
              this.state = 553, s.op = this._input.LT(1), l = this._input.LA(1), !(l & -32) && 1 << l & 29360128 ? (this._errHandler.reportMatch(this), this.consume()) : s.op = this._errHandler.recoverInline(this), this.state = 554, this.expr(12);
              break;
            case 2:
              if (s = new wl(this, new k2(this, n, i)), this.pushNewRecursionContext(s, o, R.RULE_expr), this.state = 555, !this.precpred(this._ctx, 10))
                throw new y.error.FailedPredicateException(this, "this.precpred(this._ctx, 10)");
              this.state = 556, s.op = this._input.LT(1), l = this._input.LA(1), l === 20 || l === 21 ? (this._errHandler.reportMatch(this), this.consume()) : s.op = this._errHandler.recoverInline(this), this.state = 557, this.expr(11);
              break;
            case 3:
              if (s = new xl(this, new k2(this, n, i)), this.pushNewRecursionContext(s, o, R.RULE_expr), this.state = 558, !this.precpred(this._ctx, 9))
                throw new y.error.FailedPredicateException(this, "this.precpred(this._ctx, 9)");
              this.state = 559, s.op = this._input.LT(1), l = this._input.LA(1), !(l & -32) && 1 << l & 983040 ? (this._errHandler.reportMatch(this), this.consume()) : s.op = this._errHandler.recoverInline(this), this.state = 560, this.expr(10);
              break;
            case 4:
              if (s = new Zl(this, new k2(this, n, i)), this.pushNewRecursionContext(s, o, R.RULE_expr), this.state = 561, !this.precpred(this._ctx, 8))
                throw new y.error.FailedPredicateException(this, "this.precpred(this._ctx, 8)");
              this.state = 562, s.op = this._input.LT(1), l = this._input.LA(1), l === 14 || l === 15 ? (this._errHandler.reportMatch(this), this.consume()) : s.op = this._errHandler.recoverInline(this), this.state = 563, this.expr(9);
              break;
            case 5:
              if (s = new kl(this, new k2(this, n, i)), this.pushNewRecursionContext(s, o, R.RULE_expr), this.state = 564, !this.precpred(this._ctx, 7))
                throw new y.error.FailedPredicateException(this, "this.precpred(this._ctx, 7)");
              this.state = 565, this.match(R.AND), this.state = 566, this.expr(8);
              break;
            case 6:
              if (s = new ml(this, new k2(this, n, i)), this.pushNewRecursionContext(s, o, R.RULE_expr), this.state = 567, !this.precpred(this._ctx, 6))
                throw new y.error.FailedPredicateException(this, "this.precpred(this._ctx, 6)");
              this.state = 568, this.match(R.OR), this.state = 569, this.expr(7);
              break;
            case 7:
              if (s = new _l(this, new k2(this, n, i)), this.pushNewRecursionContext(s, o, R.RULE_expr), this.state = 570, !this.precpred(this._ctx, 5))
                throw new y.error.FailedPredicateException(this, "this.precpred(this._ctx, 5)");
              this.state = 571, this.match(R.PLUS), this.state = 572, this.expr(6);
              break;
          }
        }
        this.state = 577, this._errHandler.sync(this), a = this._interp.adaptivePredict(this._input, 83, this._ctx);
      }
    } catch (C) {
      if (C instanceof y.error.RecognitionException)
        s.exception = C, this._errHandler.reportError(this, C), this._errHandler.recover(this, C);
      else
        throw C;
    } finally {
      this.unrollRecursionContexts(n);
    }
    return s;
  }
  atom() {
    let e = new c3(this, this._ctx, this.state);
    this.enterRule(e, 104, R.RULE_atom);
    var n = 0;
    try {
      switch (this.state = 585, this._errHandler.sync(this), this._input.LA(1)) {
        case 58:
        case 59:
          e = new Fl(this, e), this.enterOuterAlt(e, 1), this.state = 578, n = this._input.LA(1), n === 58 || n === 59 ? (this._errHandler.reportMatch(this), this.consume()) : this._errHandler.recoverInline(this);
          break;
        case 61:
          e = new Ol(this, e), this.enterOuterAlt(e, 2), this.state = 579, this.match(R.NUMBER_UNIT);
          break;
        case 60:
          e = new bl(this, e), this.enterOuterAlt(e, 3), this.state = 580, this.match(R.MONEY);
          break;
        case 34:
        case 35:
          e = new Tl(this, e), this.enterOuterAlt(e, 4), this.state = 581, n = this._input.LA(1), n === 34 || n === 35 ? (this._errHandler.reportMatch(this), this.consume()) : this._errHandler.recoverInline(this);
          break;
        case 57:
          e = new Sl(this, e), this.enterOuterAlt(e, 5), this.state = 582, this.match(R.ID);
          break;
        case 62:
          e = new El(this, e), this.enterOuterAlt(e, 6), this.state = 583, this.match(R.STRING);
          break;
        case 36:
          e = new Il(this, e), this.enterOuterAlt(e, 7), this.state = 584, this.match(R.NIL);
          break;
        default:
          throw new y.error.NoViableAltException(this);
      }
    } catch (i) {
      if (i instanceof y.error.RecognitionException)
        e.exception = i, this._errHandler.reportError(this, i), this._errHandler.recover(this, i);
      else
        throw i;
    } finally {
      this.exitRule();
    }
    return e;
  }
  parExpr() {
    let e = new a5(this, this._ctx, this.state);
    this.enterRule(e, 106, R.RULE_parExpr);
    try {
      this.state = 596, this._errHandler.sync(this);
      var n = this._interp.adaptivePredict(this._input, 85, this._ctx);
      switch (n) {
        case 1:
          this.enterOuterAlt(e, 1), this.state = 587, this.match(R.OPAR), this.state = 588, this.condition(), this.state = 589, this.match(R.CPAR);
          break;
        case 2:
          this.enterOuterAlt(e, 2), this.state = 591, this.match(R.OPAR), this.state = 592, this.condition();
          break;
        case 3:
          this.enterOuterAlt(e, 3), this.state = 593, this.match(R.OPAR), this.state = 594, this.match(R.CPAR);
          break;
        case 4:
          this.enterOuterAlt(e, 4), this.state = 595, this.match(R.OPAR);
          break;
      }
    } catch (i) {
      if (i instanceof y.error.RecognitionException)
        e.exception = i, this._errHandler.reportError(this, i), this._errHandler.recover(this, i);
      else
        throw i;
    } finally {
      this.exitRule();
    }
    return e;
  }
  condition() {
    let e = new Ot(this, this._ctx, this.state);
    this.enterRule(e, 108, R.RULE_condition);
    try {
      this.state = 601, this._errHandler.sync(this);
      var n = this._interp.adaptivePredict(this._input, 86, this._ctx);
      switch (n) {
        case 1:
          this.enterOuterAlt(e, 1), this.state = 598, this.atom();
          break;
        case 2:
          this.enterOuterAlt(e, 2), this.state = 599, this.expr(0);
          break;
        case 3:
          this.enterOuterAlt(e, 3), this.state = 600, this.inExpr();
          break;
      }
    } catch (i) {
      if (i instanceof y.error.RecognitionException)
        e.exception = i, this._errHandler.reportError(this, i), this._errHandler.recover(this, i);
      else
        throw i;
    } finally {
      this.exitRule();
    }
    return e;
  }
  inExpr() {
    let e = new Nt(this, this._ctx, this.state);
    this.enterRule(e, 110, R.RULE_inExpr);
    try {
      this.enterOuterAlt(e, 1), this.state = 603, this.match(R.ID), this.state = 604, this.match(R.IN), this.state = 605, this.match(R.ID);
    } catch (n) {
      if (n instanceof y.error.RecognitionException)
        e.exception = n, this._errHandler.reportError(this, n), this._errHandler.recover(this, n);
      else
        throw n;
    } finally {
      this.exitRule();
    }
    return e;
  }
};
V2(R, "grammarFileName", "java-escape"), V2(R, "literalNames", [
  null,
  null,
  "'const'",
  "'readonly'",
  "'static'",
  "'await'",
  "'title'",
  "':'",
  "'<<'",
  "'>>'",
  "'->'",
  null,
  "'||'",
  "'&&'",
  "'=='",
  "'!='",
  "'>'",
  "'<'",
  "'>='",
  "'<='",
  "'+'",
  "'-'",
  "'*'",
  "'/'",
  "'%'",
  "'^'",
  "'!'",
  "';'",
  "','",
  "'='",
  "'('",
  "')'",
  "'{'",
  "'}'",
  "'true'",
  "'false'",
  null,
  "'if'",
  "'else'",
  null,
  "'return'",
  "'new'",
  "'par'",
  "'group'",
  "'opt'",
  "'critical'",
  null,
  "'ref'",
  "'as'",
  "'try'",
  "'catch'",
  "'finally'",
  "'in'",
  null,
  null,
  null,
  "'.'"
]), V2(R, "symbolicNames", [
  null,
  "WS",
  "CONSTANT",
  "READONLY",
  "STATIC",
  "AWAIT",
  "TITLE",
  "COL",
  "SOPEN",
  "SCLOSE",
  "ARROW",
  "COLOR",
  "OR",
  "AND",
  "EQ",
  "NEQ",
  "GT",
  "LT",
  "GTEQ",
  "LTEQ",
  "PLUS",
  "MINUS",
  "MULT",
  "DIV",
  "MOD",
  "POW",
  "NOT",
  "SCOL",
  "COMMA",
  "ASSIGN",
  "OPAR",
  "CPAR",
  "OBRACE",
  "CBRACE",
  "TRUE",
  "FALSE",
  "NIL",
  "IF",
  "ELSE",
  "WHILE",
  "RETURN",
  "NEW",
  "PAR",
  "GROUP",
  "OPT",
  "CRITICAL",
  "SECTION",
  "REF",
  "AS",
  "TRY",
  "CATCH",
  "FINALLY",
  "IN",
  "STARTER_LXR",
  "ANNOTATION_RET",
  "ANNOTATION",
  "DOT",
  "ID",
  "INT",
  "FLOAT",
  "MONEY",
  "NUMBER_UNIT",
  "STRING",
  "CR",
  "COMMENT",
  "OTHER",
  "DIVIDER",
  "EVENT_PAYLOAD_LXR",
  "EVENT_END",
  "TITLE_CONTENT",
  "TITLE_END"
]), V2(R, "ruleNames", [
  "prog",
  "title",
  "head",
  "group",
  "starterExp",
  "starter",
  "participant",
  "stereotype",
  "label",
  "participantType",
  "name",
  "width",
  "block",
  "ret",
  "divider",
  "dividerNote",
  "stat",
  "par",
  "opt",
  "critical",
  "section",
  "creation",
  "ref",
  "creationBody",
  "message",
  "messageBody",
  "func",
  "from",
  "to",
  "signature",
  "invocation",
  "assignment",
  "asyncMessage",
  "content",
  "construct",
  "type",
  "assignee",
  "methodName",
  "parameters",
  "parameter",
  "declaration",
  "tcf",
  "tryBlock",
  "catchBlock",
  "finallyBlock",
  "alt",
  "ifBlock",
  "elseIfBlock",
  "elseBlock",
  "braceBlock",
  "loop",
  "expr",
  "atom",
  "parExpr",
  "condition",
  "inExpr"
]);
let u = R;
u.EOF = y.Token.EOF;
u.WS = 1;
u.CONSTANT = 2;
u.READONLY = 3;
u.STATIC = 4;
u.AWAIT = 5;
u.TITLE = 6;
u.COL = 7;
u.SOPEN = 8;
u.SCLOSE = 9;
u.ARROW = 10;
u.COLOR = 11;
u.OR = 12;
u.AND = 13;
u.EQ = 14;
u.NEQ = 15;
u.GT = 16;
u.LT = 17;
u.GTEQ = 18;
u.LTEQ = 19;
u.PLUS = 20;
u.MINUS = 21;
u.MULT = 22;
u.DIV = 23;
u.MOD = 24;
u.POW = 25;
u.NOT = 26;
u.SCOL = 27;
u.COMMA = 28;
u.ASSIGN = 29;
u.OPAR = 30;
u.CPAR = 31;
u.OBRACE = 32;
u.CBRACE = 33;
u.TRUE = 34;
u.FALSE = 35;
u.NIL = 36;
u.IF = 37;
u.ELSE = 38;
u.WHILE = 39;
u.RETURN = 40;
u.NEW = 41;
u.PAR = 42;
u.GROUP = 43;
u.OPT = 44;
u.CRITICAL = 45;
u.SECTION = 46;
u.REF = 47;
u.AS = 48;
u.TRY = 49;
u.CATCH = 50;
u.FINALLY = 51;
u.IN = 52;
u.STARTER_LXR = 53;
u.ANNOTATION_RET = 54;
u.ANNOTATION = 55;
u.DOT = 56;
u.ID = 57;
u.INT = 58;
u.FLOAT = 59;
u.MONEY = 60;
u.NUMBER_UNIT = 61;
u.STRING = 62;
u.CR = 63;
u.COMMENT = 64;
u.OTHER = 65;
u.DIVIDER = 66;
u.EVENT_PAYLOAD_LXR = 67;
u.EVENT_END = 68;
u.TITLE_CONTENT = 69;
u.TITLE_END = 70;
u.RULE_prog = 0;
u.RULE_title = 1;
u.RULE_head = 2;
u.RULE_group = 3;
u.RULE_starterExp = 4;
u.RULE_starter = 5;
u.RULE_participant = 6;
u.RULE_stereotype = 7;
u.RULE_label = 8;
u.RULE_participantType = 9;
u.RULE_name = 10;
u.RULE_width = 11;
u.RULE_block = 12;
u.RULE_ret = 13;
u.RULE_divider = 14;
u.RULE_dividerNote = 15;
u.RULE_stat = 16;
u.RULE_par = 17;
u.RULE_opt = 18;
u.RULE_critical = 19;
u.RULE_section = 20;
u.RULE_creation = 21;
u.RULE_ref = 22;
u.RULE_creationBody = 23;
u.RULE_message = 24;
u.RULE_messageBody = 25;
u.RULE_func = 26;
u.RULE_from = 27;
u.RULE_to = 28;
u.RULE_signature = 29;
u.RULE_invocation = 30;
u.RULE_assignment = 31;
u.RULE_asyncMessage = 32;
u.RULE_content = 33;
u.RULE_construct = 34;
u.RULE_type = 35;
u.RULE_assignee = 36;
u.RULE_methodName = 37;
u.RULE_parameters = 38;
u.RULE_parameter = 39;
u.RULE_declaration = 40;
u.RULE_tcf = 41;
u.RULE_tryBlock = 42;
u.RULE_catchBlock = 43;
u.RULE_finallyBlock = 44;
u.RULE_alt = 45;
u.RULE_ifBlock = 46;
u.RULE_elseIfBlock = 47;
u.RULE_elseBlock = 48;
u.RULE_braceBlock = 49;
u.RULE_loop = 50;
u.RULE_expr = 51;
u.RULE_atom = 52;
u.RULE_parExpr = 53;
u.RULE_condition = 54;
u.RULE_inExpr = 55;
let dl = class extends y.ParserRuleContext {
  constructor(e, n, i) {
    n === void 0 && (n = null), i == null && (i = -1), super(n, i), this.parser = e, this.ruleIndex = u.RULE_prog;
  }
  EOF() {
    return this.getToken(u.EOF, 0);
  }
  title() {
    return this.getTypedRuleContext(st, 0);
  }
  head() {
    return this.getTypedRuleContext(rt, 0);
  }
  block() {
    return this.getTypedRuleContext(e7, 0);
  }
  enterRule(e) {
    e instanceof A && e.enterProg(this);
  }
  exitRule(e) {
    e instanceof A && e.exitProg(this);
  }
}, st = class extends y.ParserRuleContext {
  constructor(e, n, i) {
    n === void 0 && (n = null), i == null && (i = -1), super(n, i), this.parser = e, this.ruleIndex = u.RULE_title;
  }
  TITLE() {
    return this.getToken(u.TITLE, 0);
  }
  TITLE_CONTENT() {
    return this.getToken(u.TITLE_CONTENT, 0);
  }
  TITLE_END() {
    return this.getToken(u.TITLE_END, 0);
  }
  enterRule(e) {
    e instanceof A && e.enterTitle(this);
  }
  exitRule(e) {
    e instanceof A && e.exitTitle(this);
  }
};
class rt extends y.ParserRuleContext {
  constructor(n, i, s) {
    i === void 0 && (i = null), s == null && (s = -1);
    super(i, s);
    V2(this, "group", function(n) {
      return n === void 0 && (n = null), n === null ? this.getTypedRuleContexts(a8) : this.getTypedRuleContext(a8, n);
    });
    V2(this, "participant", function(n) {
      return n === void 0 && (n = null), n === null ? this.getTypedRuleContexts(q9) : this.getTypedRuleContext(q9, n);
    });
    this.parser = n, this.ruleIndex = u.RULE_head;
  }
  starterExp() {
    return this.getTypedRuleContext(ot, 0);
  }
  enterRule(n) {
    n instanceof A && n.enterHead(this);
  }
  exitRule(n) {
    n instanceof A && n.exitHead(this);
  }
}
let a8 = class extends y.ParserRuleContext {
  constructor(n, i, s) {
    i === void 0 && (i = null), s == null && (s = -1);
    super(i, s);
    V2(this, "participant", function(n) {
      return n === void 0 && (n = null), n === null ? this.getTypedRuleContexts(q9) : this.getTypedRuleContext(q9, n);
    });
    this.parser = n, this.ruleIndex = u.RULE_group;
  }
  GROUP() {
    return this.getToken(u.GROUP, 0);
  }
  OBRACE() {
    return this.getToken(u.OBRACE, 0);
  }
  CBRACE() {
    return this.getToken(u.CBRACE, 0);
  }
  name() {
    return this.getTypedRuleContext(U4, 0);
  }
  enterRule(n) {
    n instanceof A && n.enterGroup(this);
  }
  exitRule(n) {
    n instanceof A && n.exitGroup(this);
  }
};
class ot extends y.ParserRuleContext {
  constructor(e, n, i) {
    n === void 0 && (n = null), i == null && (i = -1), super(n, i), this.parser = e, this.ruleIndex = u.RULE_starterExp;
  }
  STARTER_LXR() {
    return this.getToken(u.STARTER_LXR, 0);
  }
  OPAR() {
    return this.getToken(u.OPAR, 0);
  }
  CPAR() {
    return this.getToken(u.CPAR, 0);
  }
  starter() {
    return this.getTypedRuleContext(lt, 0);
  }
  ANNOTATION() {
    return this.getToken(u.ANNOTATION, 0);
  }
  enterRule(e) {
    e instanceof A && e.enterStarterExp(this);
  }
  exitRule(e) {
    e instanceof A && e.exitStarterExp(this);
  }
}
class lt extends y.ParserRuleContext {
  constructor(e, n, i) {
    n === void 0 && (n = null), i == null && (i = -1), super(n, i), this.parser = e, this.ruleIndex = u.RULE_starter;
  }
  ID() {
    return this.getToken(u.ID, 0);
  }
  STRING() {
    return this.getToken(u.STRING, 0);
  }
  enterRule(e) {
    e instanceof A && e.enterStarter(this);
  }
  exitRule(e) {
    e instanceof A && e.exitStarter(this);
  }
}
let q9 = class extends y.ParserRuleContext {
  constructor(e, n, i) {
    n === void 0 && (n = null), i == null && (i = -1), super(n, i), this.parser = e, this.ruleIndex = u.RULE_participant;
  }
  name() {
    return this.getTypedRuleContext(U4, 0);
  }
  participantType() {
    return this.getTypedRuleContext(Ct, 0);
  }
  stereotype() {
    return this.getTypedRuleContext(Lt, 0);
  }
  width() {
    return this.getTypedRuleContext(ct, 0);
  }
  label() {
    return this.getTypedRuleContext(at, 0);
  }
  COLOR() {
    return this.getToken(u.COLOR, 0);
  }
  enterRule(e) {
    e instanceof A && e.enterParticipant(this);
  }
  exitRule(e) {
    e instanceof A && e.exitParticipant(this);
  }
};
class Lt extends y.ParserRuleContext {
  constructor(e, n, i) {
    n === void 0 && (n = null), i == null && (i = -1), super(n, i), this.parser = e, this.ruleIndex = u.RULE_stereotype;
  }
  SOPEN() {
    return this.getToken(u.SOPEN, 0);
  }
  name() {
    return this.getTypedRuleContext(U4, 0);
  }
  SCLOSE() {
    return this.getToken(u.SCLOSE, 0);
  }
  GT() {
    return this.getToken(u.GT, 0);
  }
  LT() {
    return this.getToken(u.LT, 0);
  }
  enterRule(e) {
    e instanceof A && e.enterStereotype(this);
  }
  exitRule(e) {
    e instanceof A && e.exitStereotype(this);
  }
}
class at extends y.ParserRuleContext {
  constructor(e, n, i) {
    n === void 0 && (n = null), i == null && (i = -1), super(n, i), this.parser = e, this.ruleIndex = u.RULE_label;
  }
  AS() {
    return this.getToken(u.AS, 0);
  }
  name() {
    return this.getTypedRuleContext(U4, 0);
  }
  enterRule(e) {
    e instanceof A && e.enterLabel(this);
  }
  exitRule(e) {
    e instanceof A && e.exitLabel(this);
  }
}
class Ct extends y.ParserRuleContext {
  constructor(e, n, i) {
    n === void 0 && (n = null), i == null && (i = -1), super(n, i), this.parser = e, this.ruleIndex = u.RULE_participantType;
  }
  ANNOTATION() {
    return this.getToken(u.ANNOTATION, 0);
  }
  enterRule(e) {
    e instanceof A && e.enterParticipantType(this);
  }
  exitRule(e) {
    e instanceof A && e.exitParticipantType(this);
  }
}
class U4 extends y.ParserRuleContext {
  constructor(e, n, i) {
    n === void 0 && (n = null), i == null && (i = -1), super(n, i), this.parser = e, this.ruleIndex = u.RULE_name;
  }
  ID() {
    return this.getToken(u.ID, 0);
  }
  STRING() {
    return this.getToken(u.STRING, 0);
  }
  enterRule(e) {
    e instanceof A && e.enterName(this);
  }
  exitRule(e) {
    e instanceof A && e.exitName(this);
  }
}
class ct extends y.ParserRuleContext {
  constructor(e, n, i) {
    n === void 0 && (n = null), i == null && (i = -1), super(n, i), this.parser = e, this.ruleIndex = u.RULE_width;
  }
  INT() {
    return this.getToken(u.INT, 0);
  }
  enterRule(e) {
    e instanceof A && e.enterWidth(this);
  }
  exitRule(e) {
    e instanceof A && e.exitWidth(this);
  }
}
class e7 extends y.ParserRuleContext {
  constructor(n, i, s) {
    i === void 0 && (i = null), s == null && (s = -1);
    super(i, s);
    V2(this, "stat", function(n) {
      return n === void 0 && (n = null), n === null ? this.getTypedRuleContexts(C8) : this.getTypedRuleContext(C8, n);
    });
    this.parser = n, this.ruleIndex = u.RULE_block;
  }
  enterRule(n) {
    n instanceof A && n.enterBlock(this);
  }
  exitRule(n) {
    n instanceof A && n.exitBlock(this);
  }
}
let ut = class extends y.ParserRuleContext {
  constructor(e, n, i) {
    n === void 0 && (n = null), i == null && (i = -1), super(n, i), this.parser = e, this.ruleIndex = u.RULE_ret;
  }
  RETURN() {
    return this.getToken(u.RETURN, 0);
  }
  expr() {
    return this.getTypedRuleContext(k2, 0);
  }
  SCOL() {
    return this.getToken(u.SCOL, 0);
  }
  ANNOTATION_RET() {
    return this.getToken(u.ANNOTATION_RET, 0);
  }
  asyncMessage() {
    return this.getTypedRuleContext(r7, 0);
  }
  EVENT_END() {
    return this.getToken(u.EVENT_END, 0);
  }
  enterRule(e) {
    e instanceof A && e.enterRet(this);
  }
  exitRule(e) {
    e instanceof A && e.exitRet(this);
  }
}, ht = class extends y.ParserRuleContext {
  constructor(e, n, i) {
    n === void 0 && (n = null), i == null && (i = -1), super(n, i), this.parser = e, this.ruleIndex = u.RULE_divider;
  }
  dividerNote() {
    return this.getTypedRuleContext(dt, 0);
  }
  enterRule(e) {
    e instanceof A && e.enterDivider(this);
  }
  exitRule(e) {
    e instanceof A && e.exitDivider(this);
  }
};
class dt extends y.ParserRuleContext {
  constructor(e, n, i) {
    n === void 0 && (n = null), i == null && (i = -1), super(n, i), this.parser = e, this.ruleIndex = u.RULE_dividerNote;
  }
  DIVIDER() {
    return this.getToken(u.DIVIDER, 0);
  }
  enterRule(e) {
    e instanceof A && e.enterDividerNote(this);
  }
  exitRule(e) {
    e instanceof A && e.exitDividerNote(this);
  }
}
let C8 = class extends y.ParserRuleContext {
  constructor(e, n, i) {
    n === void 0 && (n = null), i == null && (i = -1), super(n, i), this.parser = e, this.ruleIndex = u.RULE_stat, this._OTHER = null;
  }
  alt() {
    return this.getTypedRuleContext(bt, 0);
  }
  par() {
    return this.getTypedRuleContext(gt, 0);
  }
  opt() {
    return this.getTypedRuleContext(ft, 0);
  }
  critical() {
    return this.getTypedRuleContext(pt, 0);
  }
  section() {
    return this.getTypedRuleContext(mt, 0);
  }
  ref() {
    return this.getTypedRuleContext(wt, 0);
  }
  loop() {
    return this.getTypedRuleContext(Ft, 0);
  }
  creation() {
    return this.getTypedRuleContext(t7, 0);
  }
  message() {
    return this.getTypedRuleContext(_t, 0);
  }
  asyncMessage() {
    return this.getTypedRuleContext(r7, 0);
  }
  EVENT_END() {
    return this.getToken(u.EVENT_END, 0);
  }
  ret() {
    return this.getTypedRuleContext(ut, 0);
  }
  divider() {
    return this.getTypedRuleContext(ht, 0);
  }
  tcf() {
    return this.getTypedRuleContext(kt, 0);
  }
  OTHER() {
    return this.getToken(u.OTHER, 0);
  }
  enterRule(e) {
    e instanceof A && e.enterStat(this);
  }
  exitRule(e) {
    e instanceof A && e.exitStat(this);
  }
};
class gt extends y.ParserRuleContext {
  constructor(e, n, i) {
    n === void 0 && (n = null), i == null && (i = -1), super(n, i), this.parser = e, this.ruleIndex = u.RULE_par;
  }
  PAR() {
    return this.getToken(u.PAR, 0);
  }
  braceBlock() {
    return this.getTypedRuleContext(Q1, 0);
  }
  enterRule(e) {
    e instanceof A && e.enterPar(this);
  }
  exitRule(e) {
    e instanceof A && e.exitPar(this);
  }
}
class ft extends y.ParserRuleContext {
  constructor(e, n, i) {
    n === void 0 && (n = null), i == null && (i = -1), super(n, i), this.parser = e, this.ruleIndex = u.RULE_opt;
  }
  OPT() {
    return this.getToken(u.OPT, 0);
  }
  braceBlock() {
    return this.getTypedRuleContext(Q1, 0);
  }
  enterRule(e) {
    e instanceof A && e.enterOpt(this);
  }
  exitRule(e) {
    e instanceof A && e.exitOpt(this);
  }
}
class pt extends y.ParserRuleContext {
  constructor(e, n, i) {
    n === void 0 && (n = null), i == null && (i = -1), super(n, i), this.parser = e, this.ruleIndex = u.RULE_critical;
  }
  CRITICAL() {
    return this.getToken(u.CRITICAL, 0);
  }
  braceBlock() {
    return this.getTypedRuleContext(Q1, 0);
  }
  OPAR() {
    return this.getToken(u.OPAR, 0);
  }
  CPAR() {
    return this.getToken(u.CPAR, 0);
  }
  atom() {
    return this.getTypedRuleContext(c3, 0);
  }
  enterRule(e) {
    e instanceof A && e.enterCritical(this);
  }
  exitRule(e) {
    e instanceof A && e.exitCritical(this);
  }
}
class mt extends y.ParserRuleContext {
  constructor(e, n, i) {
    n === void 0 && (n = null), i == null && (i = -1), super(n, i), this.parser = e, this.ruleIndex = u.RULE_section;
  }
  SECTION() {
    return this.getToken(u.SECTION, 0);
  }
  braceBlock() {
    return this.getTypedRuleContext(Q1, 0);
  }
  OPAR() {
    return this.getToken(u.OPAR, 0);
  }
  CPAR() {
    return this.getToken(u.CPAR, 0);
  }
  atom() {
    return this.getTypedRuleContext(c3, 0);
  }
  enterRule(e) {
    e instanceof A && e.enterSection(this);
  }
  exitRule(e) {
    e instanceof A && e.exitSection(this);
  }
}
let t7 = class extends y.ParserRuleContext {
  constructor(e, n, i) {
    n === void 0 && (n = null), i == null && (i = -1), super(n, i), this.parser = e, this.ruleIndex = u.RULE_creation;
  }
  creationBody() {
    return this.getTypedRuleContext(xt, 0);
  }
  SCOL() {
    return this.getToken(u.SCOL, 0);
  }
  braceBlock() {
    return this.getTypedRuleContext(Q1, 0);
  }
  enterRule(e) {
    e instanceof A && e.enterCreation(this);
  }
  exitRule(e) {
    e instanceof A && e.exitCreation(this);
  }
}, wt = class extends y.ParserRuleContext {
  constructor(n, i, s) {
    i === void 0 && (i = null), s == null && (s = -1);
    super(i, s);
    V2(this, "name", function(n) {
      return n === void 0 && (n = null), n === null ? this.getTypedRuleContexts(U4) : this.getTypedRuleContext(U4, n);
    });
    V2(this, "COMMA", function(n) {
      return n === void 0 && (n = null), n === null ? this.getTokens(u.COMMA) : this.getToken(u.COMMA, n);
    });
    this.parser = n, this.ruleIndex = u.RULE_ref;
  }
  REF() {
    return this.getToken(u.REF, 0);
  }
  OPAR() {
    return this.getToken(u.OPAR, 0);
  }
  CPAR() {
    return this.getToken(u.CPAR, 0);
  }
  SCOL() {
    return this.getToken(u.SCOL, 0);
  }
  enterRule(n) {
    n instanceof A && n.enterRef(this);
  }
  exitRule(n) {
    n instanceof A && n.exitRef(this);
  }
};
class xt extends y.ParserRuleContext {
  constructor(e, n, i) {
    n === void 0 && (n = null), i == null && (i = -1), super(n, i), this.parser = e, this.ruleIndex = u.RULE_creationBody;
  }
  NEW() {
    return this.getToken(u.NEW, 0);
  }
  construct() {
    return this.getTypedRuleContext(Rt, 0);
  }
  assignment() {
    return this.getTypedRuleContext(L5, 0);
  }
  OPAR() {
    return this.getToken(u.OPAR, 0);
  }
  CPAR() {
    return this.getToken(u.CPAR, 0);
  }
  parameters() {
    return this.getTypedRuleContext(l7, 0);
  }
  enterRule(e) {
    e instanceof A && e.enterCreationBody(this);
  }
  exitRule(e) {
    e instanceof A && e.exitCreationBody(this);
  }
}
let _t = class extends y.ParserRuleContext {
  constructor(e, n, i) {
    n === void 0 && (n = null), i == null && (i = -1), super(n, i), this.parser = e, this.ruleIndex = u.RULE_message;
  }
  messageBody() {
    return this.getTypedRuleContext(vt, 0);
  }
  SCOL() {
    return this.getToken(u.SCOL, 0);
  }
  braceBlock() {
    return this.getTypedRuleContext(Q1, 0);
  }
  enterRule(e) {
    e instanceof A && e.enterMessage(this);
  }
  exitRule(e) {
    e instanceof A && e.exitMessage(this);
  }
};
class vt extends y.ParserRuleContext {
  constructor(e, n, i) {
    n === void 0 && (n = null), i == null && (i = -1), super(n, i), this.parser = e, this.ruleIndex = u.RULE_messageBody;
  }
  func() {
    return this.getTypedRuleContext(n7, 0);
  }
  assignment() {
    return this.getTypedRuleContext(L5, 0);
  }
  to() {
    return this.getTypedRuleContext(l5, 0);
  }
  DOT() {
    return this.getToken(u.DOT, 0);
  }
  from() {
    return this.getTypedRuleContext(i7, 0);
  }
  ARROW() {
    return this.getToken(u.ARROW, 0);
  }
  enterRule(e) {
    e instanceof A && e.enterMessageBody(this);
  }
  exitRule(e) {
    e instanceof A && e.exitMessageBody(this);
  }
}
class n7 extends y.ParserRuleContext {
  constructor(n, i, s) {
    i === void 0 && (i = null), s == null && (s = -1);
    super(i, s);
    V2(this, "signature", function(n) {
      return n === void 0 && (n = null), n === null ? this.getTypedRuleContexts(c8) : this.getTypedRuleContext(c8, n);
    });
    V2(this, "DOT", function(n) {
      return n === void 0 && (n = null), n === null ? this.getTokens(u.DOT) : this.getToken(u.DOT, n);
    });
    this.parser = n, this.ruleIndex = u.RULE_func;
  }
  enterRule(n) {
    n instanceof A && n.enterFunc(this);
  }
  exitRule(n) {
    n instanceof A && n.exitFunc(this);
  }
}
class i7 extends y.ParserRuleContext {
  constructor(e, n, i) {
    n === void 0 && (n = null), i == null && (i = -1), super(n, i), this.parser = e, this.ruleIndex = u.RULE_from;
  }
  ID() {
    return this.getToken(u.ID, 0);
  }
  STRING() {
    return this.getToken(u.STRING, 0);
  }
  enterRule(e) {
    e instanceof A && e.enterFrom(this);
  }
  exitRule(e) {
    e instanceof A && e.exitFrom(this);
  }
}
class l5 extends y.ParserRuleContext {
  constructor(e, n, i) {
    n === void 0 && (n = null), i == null && (i = -1), super(n, i), this.parser = e, this.ruleIndex = u.RULE_to;
  }
  ID() {
    return this.getToken(u.ID, 0);
  }
  STRING() {
    return this.getToken(u.STRING, 0);
  }
  enterRule(e) {
    e instanceof A && e.enterTo(this);
  }
  exitRule(e) {
    e instanceof A && e.exitTo(this);
  }
}
class c8 extends y.ParserRuleContext {
  constructor(e, n, i) {
    n === void 0 && (n = null), i == null && (i = -1), super(n, i), this.parser = e, this.ruleIndex = u.RULE_signature;
  }
  methodName() {
    return this.getTypedRuleContext(At, 0);
  }
  invocation() {
    return this.getTypedRuleContext(s7, 0);
  }
  enterRule(e) {
    e instanceof A && e.enterSignature(this);
  }
  exitRule(e) {
    e instanceof A && e.exitSignature(this);
  }
}
class s7 extends y.ParserRuleContext {
  constructor(e, n, i) {
    n === void 0 && (n = null), i == null && (i = -1), super(n, i), this.parser = e, this.ruleIndex = u.RULE_invocation;
  }
  OPAR() {
    return this.getToken(u.OPAR, 0);
  }
  CPAR() {
    return this.getToken(u.CPAR, 0);
  }
  parameters() {
    return this.getTypedRuleContext(l7, 0);
  }
  enterRule(e) {
    e instanceof A && e.enterInvocation(this);
  }
  exitRule(e) {
    e instanceof A && e.exitInvocation(this);
  }
}
class L5 extends y.ParserRuleContext {
  constructor(e, n, i) {
    n === void 0 && (n = null), i == null && (i = -1), super(n, i), this.parser = e, this.ruleIndex = u.RULE_assignment;
  }
  assignee() {
    return this.getTypedRuleContext(yt, 0);
  }
  ASSIGN() {
    return this.getToken(u.ASSIGN, 0);
  }
  type() {
    return this.getTypedRuleContext(o7, 0);
  }
  enterRule(e) {
    e instanceof A && e.enterAssignment(this);
  }
  exitRule(e) {
    e instanceof A && e.exitAssignment(this);
  }
}
let r7 = class extends y.ParserRuleContext {
  constructor(e, n, i) {
    n === void 0 && (n = null), i == null && (i = -1), super(n, i), this.parser = e, this.ruleIndex = u.RULE_asyncMessage;
  }
  to() {
    return this.getTypedRuleContext(l5, 0);
  }
  COL() {
    return this.getToken(u.COL, 0);
  }
  from() {
    return this.getTypedRuleContext(i7, 0);
  }
  ARROW() {
    return this.getToken(u.ARROW, 0);
  }
  content() {
    return this.getTypedRuleContext(Mt, 0);
  }
  MINUS() {
    return this.getToken(u.MINUS, 0);
  }
  enterRule(e) {
    e instanceof A && e.enterAsyncMessage(this);
  }
  exitRule(e) {
    e instanceof A && e.exitAsyncMessage(this);
  }
};
class Mt extends y.ParserRuleContext {
  constructor(e, n, i) {
    n === void 0 && (n = null), i == null && (i = -1), super(n, i), this.parser = e, this.ruleIndex = u.RULE_content;
  }
  EVENT_PAYLOAD_LXR() {
    return this.getToken(u.EVENT_PAYLOAD_LXR, 0);
  }
  enterRule(e) {
    e instanceof A && e.enterContent(this);
  }
  exitRule(e) {
    e instanceof A && e.exitContent(this);
  }
}
class Rt extends y.ParserRuleContext {
  constructor(e, n, i) {
    n === void 0 && (n = null), i == null && (i = -1), super(n, i), this.parser = e, this.ruleIndex = u.RULE_construct;
  }
  ID() {
    return this.getToken(u.ID, 0);
  }
  STRING() {
    return this.getToken(u.STRING, 0);
  }
  enterRule(e) {
    e instanceof A && e.enterConstruct(this);
  }
  exitRule(e) {
    e instanceof A && e.exitConstruct(this);
  }
}
class o7 extends y.ParserRuleContext {
  constructor(e, n, i) {
    n === void 0 && (n = null), i == null && (i = -1), super(n, i), this.parser = e, this.ruleIndex = u.RULE_type;
  }
  ID() {
    return this.getToken(u.ID, 0);
  }
  STRING() {
    return this.getToken(u.STRING, 0);
  }
  enterRule(e) {
    e instanceof A && e.enterType(this);
  }
  exitRule(e) {
    e instanceof A && e.exitType(this);
  }
}
class yt extends y.ParserRuleContext {
  constructor(n, i, s) {
    i === void 0 && (i = null), s == null && (s = -1);
    super(i, s);
    V2(this, "ID", function(n) {
      return n === void 0 && (n = null), n === null ? this.getTokens(u.ID) : this.getToken(u.ID, n);
    });
    V2(this, "COMMA", function(n) {
      return n === void 0 && (n = null), n === null ? this.getTokens(u.COMMA) : this.getToken(u.COMMA, n);
    });
    this.parser = n, this.ruleIndex = u.RULE_assignee;
  }
  atom() {
    return this.getTypedRuleContext(c3, 0);
  }
  STRING() {
    return this.getToken(u.STRING, 0);
  }
  enterRule(n) {
    n instanceof A && n.enterAssignee(this);
  }
  exitRule(n) {
    n instanceof A && n.exitAssignee(this);
  }
}
class At extends y.ParserRuleContext {
  constructor(e, n, i) {
    n === void 0 && (n = null), i == null && (i = -1), super(n, i), this.parser = e, this.ruleIndex = u.RULE_methodName;
  }
  ID() {
    return this.getToken(u.ID, 0);
  }
  STRING() {
    return this.getToken(u.STRING, 0);
  }
  enterRule(e) {
    e instanceof A && e.enterMethodName(this);
  }
  exitRule(e) {
    e instanceof A && e.exitMethodName(this);
  }
}
class l7 extends y.ParserRuleContext {
  constructor(n, i, s) {
    i === void 0 && (i = null), s == null && (s = -1);
    super(i, s);
    V2(this, "parameter", function(n) {
      return n === void 0 && (n = null), n === null ? this.getTypedRuleContexts(u8) : this.getTypedRuleContext(u8, n);
    });
    V2(this, "COMMA", function(n) {
      return n === void 0 && (n = null), n === null ? this.getTokens(u.COMMA) : this.getToken(u.COMMA, n);
    });
    this.parser = n, this.ruleIndex = u.RULE_parameters;
  }
  enterRule(n) {
    n instanceof A && n.enterParameters(this);
  }
  exitRule(n) {
    n instanceof A && n.exitParameters(this);
  }
}
class u8 extends y.ParserRuleContext {
  constructor(e, n, i) {
    n === void 0 && (n = null), i == null && (i = -1), super(n, i), this.parser = e, this.ruleIndex = u.RULE_parameter;
  }
  declaration() {
    return this.getTypedRuleContext(Zt, 0);
  }
  expr() {
    return this.getTypedRuleContext(k2, 0);
  }
  enterRule(e) {
    e instanceof A && e.enterParameter(this);
  }
  exitRule(e) {
    e instanceof A && e.exitParameter(this);
  }
}
class Zt extends y.ParserRuleContext {
  constructor(e, n, i) {
    n === void 0 && (n = null), i == null && (i = -1), super(n, i), this.parser = e, this.ruleIndex = u.RULE_declaration;
  }
  type() {
    return this.getTypedRuleContext(o7, 0);
  }
  ID() {
    return this.getToken(u.ID, 0);
  }
  enterRule(e) {
    e instanceof A && e.enterDeclaration(this);
  }
  exitRule(e) {
    e instanceof A && e.exitDeclaration(this);
  }
}
class kt extends y.ParserRuleContext {
  constructor(n, i, s) {
    i === void 0 && (i = null), s == null && (s = -1);
    super(i, s);
    V2(this, "catchBlock", function(n) {
      return n === void 0 && (n = null), n === null ? this.getTypedRuleContexts(h8) : this.getTypedRuleContext(h8, n);
    });
    this.parser = n, this.ruleIndex = u.RULE_tcf;
  }
  tryBlock() {
    return this.getTypedRuleContext(Tt, 0);
  }
  finallyBlock() {
    return this.getTypedRuleContext(St, 0);
  }
  enterRule(n) {
    n instanceof A && n.enterTcf(this);
  }
  exitRule(n) {
    n instanceof A && n.exitTcf(this);
  }
}
class Tt extends y.ParserRuleContext {
  constructor(e, n, i) {
    n === void 0 && (n = null), i == null && (i = -1), super(n, i), this.parser = e, this.ruleIndex = u.RULE_tryBlock;
  }
  TRY() {
    return this.getToken(u.TRY, 0);
  }
  braceBlock() {
    return this.getTypedRuleContext(Q1, 0);
  }
  enterRule(e) {
    e instanceof A && e.enterTryBlock(this);
  }
  exitRule(e) {
    e instanceof A && e.exitTryBlock(this);
  }
}
class h8 extends y.ParserRuleContext {
  constructor(e, n, i) {
    n === void 0 && (n = null), i == null && (i = -1), super(n, i), this.parser = e, this.ruleIndex = u.RULE_catchBlock;
  }
  CATCH() {
    return this.getToken(u.CATCH, 0);
  }
  braceBlock() {
    return this.getTypedRuleContext(Q1, 0);
  }
  invocation() {
    return this.getTypedRuleContext(s7, 0);
  }
  enterRule(e) {
    e instanceof A && e.enterCatchBlock(this);
  }
  exitRule(e) {
    e instanceof A && e.exitCatchBlock(this);
  }
}
class St extends y.ParserRuleContext {
  constructor(e, n, i) {
    n === void 0 && (n = null), i == null && (i = -1), super(n, i), this.parser = e, this.ruleIndex = u.RULE_finallyBlock;
  }
  FINALLY() {
    return this.getToken(u.FINALLY, 0);
  }
  braceBlock() {
    return this.getTypedRuleContext(Q1, 0);
  }
  enterRule(e) {
    e instanceof A && e.enterFinallyBlock(this);
  }
  exitRule(e) {
    e instanceof A && e.exitFinallyBlock(this);
  }
}
class bt extends y.ParserRuleContext {
  constructor(n, i, s) {
    i === void 0 && (i = null), s == null && (s = -1);
    super(i, s);
    V2(this, "elseIfBlock", function(n) {
      return n === void 0 && (n = null), n === null ? this.getTypedRuleContexts(d8) : this.getTypedRuleContext(d8, n);
    });
    this.parser = n, this.ruleIndex = u.RULE_alt;
  }
  ifBlock() {
    return this.getTypedRuleContext(Et, 0);
  }
  elseBlock() {
    return this.getTypedRuleContext(It, 0);
  }
  enterRule(n) {
    n instanceof A && n.enterAlt(this);
  }
  exitRule(n) {
    n instanceof A && n.exitAlt(this);
  }
}
let Et = class extends y.ParserRuleContext {
  constructor(e, n, i) {
    n === void 0 && (n = null), i == null && (i = -1), super(n, i), this.parser = e, this.ruleIndex = u.RULE_ifBlock;
  }
  IF() {
    return this.getToken(u.IF, 0);
  }
  parExpr() {
    return this.getTypedRuleContext(a5, 0);
  }
  braceBlock() {
    return this.getTypedRuleContext(Q1, 0);
  }
  enterRule(e) {
    e instanceof A && e.enterIfBlock(this);
  }
  exitRule(e) {
    e instanceof A && e.exitIfBlock(this);
  }
};
class d8 extends y.ParserRuleContext {
  constructor(e, n, i) {
    n === void 0 && (n = null), i == null && (i = -1), super(n, i), this.parser = e, this.ruleIndex = u.RULE_elseIfBlock;
  }
  ELSE() {
    return this.getToken(u.ELSE, 0);
  }
  IF() {
    return this.getToken(u.IF, 0);
  }
  parExpr() {
    return this.getTypedRuleContext(a5, 0);
  }
  braceBlock() {
    return this.getTypedRuleContext(Q1, 0);
  }
  enterRule(e) {
    e instanceof A && e.enterElseIfBlock(this);
  }
  exitRule(e) {
    e instanceof A && e.exitElseIfBlock(this);
  }
}
class It extends y.ParserRuleContext {
  constructor(e, n, i) {
    n === void 0 && (n = null), i == null && (i = -1), super(n, i), this.parser = e, this.ruleIndex = u.RULE_elseBlock;
  }
  ELSE() {
    return this.getToken(u.ELSE, 0);
  }
  braceBlock() {
    return this.getTypedRuleContext(Q1, 0);
  }
  enterRule(e) {
    e instanceof A && e.enterElseBlock(this);
  }
  exitRule(e) {
    e instanceof A && e.exitElseBlock(this);
  }
}
class Q1 extends y.ParserRuleContext {
  constructor(e, n, i) {
    n === void 0 && (n = null), i == null && (i = -1), super(n, i), this.parser = e, this.ruleIndex = u.RULE_braceBlock;
  }
  OBRACE() {
    return this.getToken(u.OBRACE, 0);
  }
  CBRACE() {
    return this.getToken(u.CBRACE, 0);
  }
  block() {
    return this.getTypedRuleContext(e7, 0);
  }
  enterRule(e) {
    e instanceof A && e.enterBraceBlock(this);
  }
  exitRule(e) {
    e instanceof A && e.exitBraceBlock(this);
  }
}
let Ft = class extends y.ParserRuleContext {
  constructor(e, n, i) {
    n === void 0 && (n = null), i == null && (i = -1), super(n, i), this.parser = e, this.ruleIndex = u.RULE_loop;
  }
  WHILE() {
    return this.getToken(u.WHILE, 0);
  }
  parExpr() {
    return this.getTypedRuleContext(a5, 0);
  }
  braceBlock() {
    return this.getTypedRuleContext(Q1, 0);
  }
  enterRule(e) {
    e instanceof A && e.enterLoop(this);
  }
  exitRule(e) {
    e instanceof A && e.exitLoop(this);
  }
};
class k2 extends y.ParserRuleContext {
  constructor(e, n, i) {
    n === void 0 && (n = null), i == null && (i = -1), super(n, i), this.parser = e, this.ruleIndex = u.RULE_expr;
  }
  copyFrom(e) {
    super.copyFrom(e);
  }
}
class gl extends k2 {
  constructor(e, n) {
    super(e), super.copyFrom(n);
  }
  assignment() {
    return this.getTypedRuleContext(L5, 0);
  }
  expr() {
    return this.getTypedRuleContext(k2, 0);
  }
  enterRule(e) {
    e instanceof A && e.enterAssignmentExpr(this);
  }
  exitRule(e) {
    e instanceof A && e.exitAssignmentExpr(this);
  }
}
u.AssignmentExprContext = gl;
class fl extends k2 {
  constructor(e, n) {
    super(e), super.copyFrom(n);
  }
  func() {
    return this.getTypedRuleContext(n7, 0);
  }
  to() {
    return this.getTypedRuleContext(l5, 0);
  }
  DOT() {
    return this.getToken(u.DOT, 0);
  }
  enterRule(e) {
    e instanceof A && e.enterFuncExpr(this);
  }
  exitRule(e) {
    e instanceof A && e.exitFuncExpr(this);
  }
}
u.FuncExprContext = fl;
class pl extends k2 {
  constructor(e, n) {
    super(e), super.copyFrom(n);
  }
  atom() {
    return this.getTypedRuleContext(c3, 0);
  }
  enterRule(e) {
    e instanceof A && e.enterAtomExpr(this);
  }
  exitRule(e) {
    e instanceof A && e.exitAtomExpr(this);
  }
}
u.AtomExprContext = pl;
class ml extends k2 {
  constructor(n, i) {
    super(n);
    V2(this, "expr", function(n) {
      return n === void 0 && (n = null), n === null ? this.getTypedRuleContexts(k2) : this.getTypedRuleContext(k2, n);
    });
    super.copyFrom(i);
  }
  OR() {
    return this.getToken(u.OR, 0);
  }
  enterRule(n) {
    n instanceof A && n.enterOrExpr(this);
  }
  exitRule(n) {
    n instanceof A && n.exitOrExpr(this);
  }
}
u.OrExprContext = ml;
class wl extends k2 {
  constructor(n, i) {
    super(n);
    V2(this, "expr", function(n) {
      return n === void 0 && (n = null), n === null ? this.getTypedRuleContexts(k2) : this.getTypedRuleContext(k2, n);
    });
    this.op = null, super.copyFrom(i);
  }
  PLUS() {
    return this.getToken(u.PLUS, 0);
  }
  MINUS() {
    return this.getToken(u.MINUS, 0);
  }
  enterRule(n) {
    n instanceof A && n.enterAdditiveExpr(this);
  }
  exitRule(n) {
    n instanceof A && n.exitAdditiveExpr(this);
  }
}
u.AdditiveExprContext = wl;
class xl extends k2 {
  constructor(n, i) {
    super(n);
    V2(this, "expr", function(n) {
      return n === void 0 && (n = null), n === null ? this.getTypedRuleContexts(k2) : this.getTypedRuleContext(k2, n);
    });
    this.op = null, super.copyFrom(i);
  }
  LTEQ() {
    return this.getToken(u.LTEQ, 0);
  }
  GTEQ() {
    return this.getToken(u.GTEQ, 0);
  }
  LT() {
    return this.getToken(u.LT, 0);
  }
  GT() {
    return this.getToken(u.GT, 0);
  }
  enterRule(n) {
    n instanceof A && n.enterRelationalExpr(this);
  }
  exitRule(n) {
    n instanceof A && n.exitRelationalExpr(this);
  }
}
u.RelationalExprContext = xl;
class _l extends k2 {
  constructor(n, i) {
    super(n);
    V2(this, "expr", function(n) {
      return n === void 0 && (n = null), n === null ? this.getTypedRuleContexts(k2) : this.getTypedRuleContext(k2, n);
    });
    super.copyFrom(i);
  }
  PLUS() {
    return this.getToken(u.PLUS, 0);
  }
  enterRule(n) {
    n instanceof A && n.enterPlusExpr(this);
  }
  exitRule(n) {
    n instanceof A && n.exitPlusExpr(this);
  }
}
u.PlusExprContext = _l;
class vl extends k2 {
  constructor(e, n) {
    super(e), super.copyFrom(n);
  }
  NOT() {
    return this.getToken(u.NOT, 0);
  }
  expr() {
    return this.getTypedRuleContext(k2, 0);
  }
  enterRule(e) {
    e instanceof A && e.enterNotExpr(this);
  }
  exitRule(e) {
    e instanceof A && e.exitNotExpr(this);
  }
}
u.NotExprContext = vl;
class Ml extends k2 {
  constructor(e, n) {
    super(e), super.copyFrom(n);
  }
  MINUS() {
    return this.getToken(u.MINUS, 0);
  }
  expr() {
    return this.getTypedRuleContext(k2, 0);
  }
  enterRule(e) {
    e instanceof A && e.enterUnaryMinusExpr(this);
  }
  exitRule(e) {
    e instanceof A && e.exitUnaryMinusExpr(this);
  }
}
u.UnaryMinusExprContext = Ml;
class Rl extends k2 {
  constructor(e, n) {
    super(e), super.copyFrom(n);
  }
  creation() {
    return this.getTypedRuleContext(t7, 0);
  }
  enterRule(e) {
    e instanceof A && e.enterCreationExpr(this);
  }
  exitRule(e) {
    e instanceof A && e.exitCreationExpr(this);
  }
}
u.CreationExprContext = Rl;
class yl extends k2 {
  constructor(e, n) {
    super(e), super.copyFrom(n);
  }
  OPAR() {
    return this.getToken(u.OPAR, 0);
  }
  expr() {
    return this.getTypedRuleContext(k2, 0);
  }
  CPAR() {
    return this.getToken(u.CPAR, 0);
  }
  enterRule(e) {
    e instanceof A && e.enterParenthesizedExpr(this);
  }
  exitRule(e) {
    e instanceof A && e.exitParenthesizedExpr(this);
  }
}
u.ParenthesizedExprContext = yl;
class Al extends k2 {
  constructor(n, i) {
    super(n);
    V2(this, "expr", function(n) {
      return n === void 0 && (n = null), n === null ? this.getTypedRuleContexts(k2) : this.getTypedRuleContext(k2, n);
    });
    this.op = null, super.copyFrom(i);
  }
  MULT() {
    return this.getToken(u.MULT, 0);
  }
  DIV() {
    return this.getToken(u.DIV, 0);
  }
  MOD() {
    return this.getToken(u.MOD, 0);
  }
  enterRule(n) {
    n instanceof A && n.enterMultiplicationExpr(this);
  }
  exitRule(n) {
    n instanceof A && n.exitMultiplicationExpr(this);
  }
}
u.MultiplicationExprContext = Al;
class Zl extends k2 {
  constructor(n, i) {
    super(n);
    V2(this, "expr", function(n) {
      return n === void 0 && (n = null), n === null ? this.getTypedRuleContexts(k2) : this.getTypedRuleContext(k2, n);
    });
    this.op = null, super.copyFrom(i);
  }
  EQ() {
    return this.getToken(u.EQ, 0);
  }
  NEQ() {
    return this.getToken(u.NEQ, 0);
  }
  enterRule(n) {
    n instanceof A && n.enterEqualityExpr(this);
  }
  exitRule(n) {
    n instanceof A && n.exitEqualityExpr(this);
  }
}
u.EqualityExprContext = Zl;
class kl extends k2 {
  constructor(n, i) {
    super(n);
    V2(this, "expr", function(n) {
      return n === void 0 && (n = null), n === null ? this.getTypedRuleContexts(k2) : this.getTypedRuleContext(k2, n);
    });
    super.copyFrom(i);
  }
  AND() {
    return this.getToken(u.AND, 0);
  }
  enterRule(n) {
    n instanceof A && n.enterAndExpr(this);
  }
  exitRule(n) {
    n instanceof A && n.exitAndExpr(this);
  }
}
u.AndExprContext = kl;
class c3 extends y.ParserRuleContext {
  constructor(e, n, i) {
    n === void 0 && (n = null), i == null && (i = -1), super(n, i), this.parser = e, this.ruleIndex = u.RULE_atom;
  }
  copyFrom(e) {
    super.copyFrom(e);
  }
}
class Tl extends c3 {
  constructor(e, n) {
    super(e), super.copyFrom(n);
  }
  TRUE() {
    return this.getToken(u.TRUE, 0);
  }
  FALSE() {
    return this.getToken(u.FALSE, 0);
  }
  enterRule(e) {
    e instanceof A && e.enterBooleanAtom(this);
  }
  exitRule(e) {
    e instanceof A && e.exitBooleanAtom(this);
  }
}
u.BooleanAtomContext = Tl;
class Sl extends c3 {
  constructor(e, n) {
    super(e), super.copyFrom(n);
  }
  ID() {
    return this.getToken(u.ID, 0);
  }
  enterRule(e) {
    e instanceof A && e.enterIdAtom(this);
  }
  exitRule(e) {
    e instanceof A && e.exitIdAtom(this);
  }
}
u.IdAtomContext = Sl;
class bl extends c3 {
  constructor(e, n) {
    super(e), super.copyFrom(n);
  }
  MONEY() {
    return this.getToken(u.MONEY, 0);
  }
  enterRule(e) {
    e instanceof A && e.enterMoneyAtom(this);
  }
  exitRule(e) {
    e instanceof A && e.exitMoneyAtom(this);
  }
}
u.MoneyAtomContext = bl;
class El extends c3 {
  constructor(e, n) {
    super(e), super.copyFrom(n);
  }
  STRING() {
    return this.getToken(u.STRING, 0);
  }
  enterRule(e) {
    e instanceof A && e.enterStringAtom(this);
  }
  exitRule(e) {
    e instanceof A && e.exitStringAtom(this);
  }
}
u.StringAtomContext = El;
class Il extends c3 {
  constructor(e, n) {
    super(e), super.copyFrom(n);
  }
  NIL() {
    return this.getToken(u.NIL, 0);
  }
  enterRule(e) {
    e instanceof A && e.enterNilAtom(this);
  }
  exitRule(e) {
    e instanceof A && e.exitNilAtom(this);
  }
}
u.NilAtomContext = Il;
class Fl extends c3 {
  constructor(e, n) {
    super(e), super.copyFrom(n);
  }
  INT() {
    return this.getToken(u.INT, 0);
  }
  FLOAT() {
    return this.getToken(u.FLOAT, 0);
  }
  enterRule(e) {
    e instanceof A && e.enterNumberAtom(this);
  }
  exitRule(e) {
    e instanceof A && e.exitNumberAtom(this);
  }
}
u.NumberAtomContext = Fl;
class Ol extends c3 {
  constructor(e, n) {
    super(e), super.copyFrom(n);
  }
  NUMBER_UNIT() {
    return this.getToken(u.NUMBER_UNIT, 0);
  }
  enterRule(e) {
    e instanceof A && e.enterNumberUnitAtom(this);
  }
  exitRule(e) {
    e instanceof A && e.exitNumberUnitAtom(this);
  }
}
u.NumberUnitAtomContext = Ol;
class a5 extends y.ParserRuleContext {
  constructor(e, n, i) {
    n === void 0 && (n = null), i == null && (i = -1), super(n, i), this.parser = e, this.ruleIndex = u.RULE_parExpr;
  }
  OPAR() {
    return this.getToken(u.OPAR, 0);
  }
  condition() {
    return this.getTypedRuleContext(Ot, 0);
  }
  CPAR() {
    return this.getToken(u.CPAR, 0);
  }
  enterRule(e) {
    e instanceof A && e.enterParExpr(this);
  }
  exitRule(e) {
    e instanceof A && e.exitParExpr(this);
  }
}
class Ot extends y.ParserRuleContext {
  constructor(e, n, i) {
    n === void 0 && (n = null), i == null && (i = -1), super(n, i), this.parser = e, this.ruleIndex = u.RULE_condition;
  }
  atom() {
    return this.getTypedRuleContext(c3, 0);
  }
  expr() {
    return this.getTypedRuleContext(k2, 0);
  }
  inExpr() {
    return this.getTypedRuleContext(Nt, 0);
  }
  enterRule(e) {
    e instanceof A && e.enterCondition(this);
  }
  exitRule(e) {
    e instanceof A && e.exitCondition(this);
  }
}
class Nt extends y.ParserRuleContext {
  constructor(n, i, s) {
    i === void 0 && (i = null), s == null && (s = -1);
    super(i, s);
    V2(this, "ID", function(n) {
      return n === void 0 && (n = null), n === null ? this.getTokens(u.ID) : this.getToken(u.ID, n);
    });
    this.parser = n, this.ruleIndex = u.RULE_inExpr;
  }
  IN() {
    return this.getToken(u.IN, 0);
  }
  enterRule(n) {
    n instanceof A && n.enterInExpr(this);
  }
  exitRule(n) {
    n instanceof A && n.exitInExpr(this);
  }
}
u.ProgContext = dl;
u.TitleContext = st;
u.HeadContext = rt;
u.GroupContext = a8;
u.StarterExpContext = ot;
u.StarterContext = lt;
u.ParticipantContext = q9;
u.StereotypeContext = Lt;
u.LabelContext = at;
u.ParticipantTypeContext = Ct;
u.NameContext = U4;
u.WidthContext = ct;
u.BlockContext = e7;
u.RetContext = ut;
u.DividerContext = ht;
u.DividerNoteContext = dt;
u.StatContext = C8;
u.ParContext = gt;
u.OptContext = ft;
u.CriticalContext = pt;
u.SectionContext = mt;
u.CreationContext = t7;
u.RefContext = wt;
u.CreationBodyContext = xt;
u.MessageContext = _t;
u.MessageBodyContext = vt;
u.FuncContext = n7;
u.FromContext = i7;
u.ToContext = l5;
u.SignatureContext = c8;
u.InvocationContext = s7;
u.AssignmentContext = L5;
u.AsyncMessageContext = r7;
u.ContentContext = Mt;
u.ConstructContext = Rt;
u.TypeContext = o7;
u.AssigneeContext = yt;
u.MethodNameContext = At;
u.ParametersContext = l7;
u.ParameterContext = u8;
u.DeclarationContext = Zt;
u.TcfContext = kt;
u.TryBlockContext = Tt;
u.CatchBlockContext = h8;
u.FinallyBlockContext = St;
u.AltContext = bt;
u.IfBlockContext = Et;
u.ElseIfBlockContext = d8;
u.ElseBlockContext = It;
u.BraceBlockContext = Q1;
u.LoopContext = Ft;
u.ExprContext = k2;
u.AtomContext = c3;
u.ParExprContext = a5;
u.ConditionContext = Ot;
u.InExprContext = Nt;
const Nl = {
  name: "",
  color: void 0,
  comment: void 0,
  explicit: void 0,
  groupId: void 0,
  isStarter: void 0,
  label: void 0,
  stereotype: void 0,
  type: void 0,
  width: void 0,
  assignee: void 0,
  positions: /* @__PURE__ */ new Set(),
  assigneePositions: /* @__PURE__ */ new Set()
};
let mg = class {
  constructor(e, n) {
    this.positions = /* @__PURE__ */ new Set(), this.assigneePositions = /* @__PURE__ */ new Set(), this.name = e, this.mergeOptions(n);
  }
  mergeOptions(e) {
    const {
      stereotype: n,
      width: i,
      groupId: s,
      label: r,
      explicit: o,
      isStarter: l,
      type: L,
      color: a,
      comment: C,
      assignee: c
    } = e;
    this.stereotype || (this.stereotype = n), this.width || (this.width = i), this.groupId || (this.groupId = s), this.explicit || (this.explicit = o), this.isStarter || (this.isStarter = l), this.label || (this.label = r), this.type || (this.type = L), this.color || (this.color = a), this.comment || (this.comment = C), this.assignee || (this.assignee = c);
  }
  AddPosition(e) {
    this.positions.add(e);
  }
  ToValue() {
    return {
      name: this.name,
      stereotype: this.stereotype,
      width: this.width,
      groupId: this.groupId,
      explicit: this.explicit,
      isStarter: this.isStarter,
      label: this.label,
      type: this.type,
      color: this.color,
      comment: this.comment,
      assignee: this.assignee,
      positions: this.positions,
      assigneePositions: this.assigneePositions
    };
  }
}, wg = class {
  constructor() {
    this.participants = /* @__PURE__ */ new Map();
  }
  Add(e, n = {}) {
    if (!e)
      throw new Error("Participant name is required");
    let i = this.Get(e);
    i ? i == null || i.mergeOptions(n) : (i = new mg(e, n), this.participants.set(e, i));
    const { position: s, assigneePosition: r } = n;
    s && i.AddPosition(s), r && i.assigneePositions.add(r);
  }
  // Returns an array of participants that are deduced from messages
  // It does not include the Starter.
  ImplicitArray() {
    return this.Array().filter((e) => {
      var n;
      return !((n = this.Get(e.name)) != null && n.explicit);
    });
  }
  // Items in entries are in the order of entry insertion:
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map
  Array() {
    return Array.from(this.participants.entries()).map((e) => e[1]);
  }
  Names() {
    return Array.from(this.participants.keys());
  }
  First() {
    return this.participants.values().next().value;
  }
  Get(e) {
    return this.participants.get(e);
  }
  Size() {
    return this.participants.size;
  }
  Starter() {
    for (const e of this.participants.values())
      if (e.isStarter)
        return e;
  }
  GetPositions(e) {
    var n;
    return (n = this.participants.get(e)) == null ? void 0 : n.positions;
  }
  GetAssigneePositions(e) {
    var n;
    return (n = this.participants.get(e)) == null ? void 0 : n.assigneePositions;
  }
}, r3, m9 = !1, Dt;
const N1 = new A(), xg = function(t) {
  var d, f, x, k, m, g;
  if (m9)
    return;
  const e = (d = t == null ? void 0 : t.participantType()) == null ? void 0 : d.getFormattedText().replace("@", ""), n = ((f = t == null ? void 0 : t.name()) == null ? void 0 : f.getFormattedText()) || "Missing `Participant`", i = (k = (x = t.stereotype()) == null ? void 0 : x.name()) == null ? void 0 : k.getFormattedText(), s = t.width && t.width() && Number.parseInt(t.width().getText()) || void 0, r = t.label && t.label(), o = (m = r == null ? void 0 : r.name()) == null ? void 0 : m.getFormattedText(), l = !0, L = (g = t.COLOR()) == null ? void 0 : g.getText(), a = t.getComment(), C = t.name();
  let c, h;
  if (r) {
    const w = r.name();
    w && (c = w.start.start, h = w.stop.stop + 1);
  } else
    C && (c = C.start.start, h = C.stop.stop + 1);
  r3.Add(n, {
    isStarter: !1,
    type: e,
    stereotype: i,
    width: s,
    groupId: Dt,
    label: o,
    explicit: l,
    color: L,
    comment: a,
    position: [c, h]
  });
};
N1.enterParticipant = xg;
const Dl = function(t) {
  if (m9)
    return;
  let e = t.getFormattedText();
  const n = r3.Get(e);
  if (n != null && n.label)
    r3.Add(e, { isStarter: !1 });
  else if (n != null && n.assignee) {
    const s = [t.start.start + n.assignee.length + 2, t.stop.stop], r = [
      t.start.start + 1,
      t.start.start + n.assignee.length + 1
    ];
    r3.Add(e, {
      isStarter: !1,
      position: s,
      assigneePosition: r
    });
  } else
    r3.Add(e, {
      isStarter: !1,
      position: [t.start.start, t.stop.stop + 1]
    });
};
N1.enterFrom = Dl;
N1.enterTo = Dl;
N1.enterStarter = function(t) {
  let e = t.getFormattedText();
  r3.Add(e, {
    isStarter: !0,
    position: [t.start.start, t.stop.stop + 1]
  });
};
N1.enterCreation = function(t) {
  var s;
  if (m9)
    return;
  const e = t.Owner(), n = (s = t == null ? void 0 : t.creationBody()) == null ? void 0 : s.construct(), i = r3.Get(e);
  if (n && !(i != null && i.label)) {
    const r = t.Assignee(), o = t.AssigneePosition();
    r3.Add(e, {
      isStarter: !1,
      position: [n.start.start, n.stop.stop + 1],
      assignee: r,
      assigneePosition: o
    });
  } else
    r3.Add(e, {
      isStarter: !1
    });
};
N1.enterRef = function(t) {
  t.Participants().forEach((e) => {
    r3.Add(e.getText(), {
      isStarter: !1,
      position: [e.start.start, e.stop.stop + 1]
    });
  });
};
N1.enterParameters = function() {
  m9 = !0;
};
N1.exitParameters = function() {
  m9 = !1;
};
N1.enterCondition = function() {
  m9 = !0;
};
N1.exitCondition = function() {
  m9 = !1;
};
N1.enterGroup = function(t) {
  var e;
  Dt = (e = t.name()) == null ? void 0 : e.getFormattedText();
};
N1.exitGroup = function() {
  Dt = void 0;
};
N1.enterRet = function(t) {
  if (t.asyncMessage())
    return;
  const e = t.From();
  e && r3.Add(e);
  const n = t.ReturnTo();
  n && r3.Add(n);
};
const _g = y.tree.ParseTreeWalker.DEFAULT;
N1.getParticipants = function(t) {
  return r3 = new wg(), _g.walk(this, t), r3;
};
const vg = y.tree.ParseTreeWalker.DEFAULT;
let X1 = new A(), h1 = 0, O1 = 0;
X1.enterTcf = function() {
  h1++;
};
X1.enterOpt = function() {
  h1++;
};
X1.enterPar = function() {
  h1++;
};
X1.enterAlt = function() {
  h1++;
};
X1.enterLoop = function() {
  h1++;
};
X1.enterSection = function() {
  h1++;
};
X1.enterCritical = function() {
  h1++;
};
X1.exitTcf = function() {
  O1 = Math.max(O1, h1), h1--;
};
X1.exitOpt = function() {
  O1 = Math.max(O1, h1), h1--;
};
X1.exitPar = function() {
  O1 = Math.max(O1, h1), h1--;
};
X1.exitAlt = function() {
  O1 = Math.max(O1, h1), h1--;
};
X1.exitLoop = function() {
  O1 = Math.max(O1, h1), h1--;
};
X1.exitSection = function() {
  O1 = Math.max(O1, h1), h1--;
};
X1.exitCritical = function() {
  O1 = Math.max(O1, h1), h1--;
};
X1.depth = function(t) {
  return function(e) {
    return h1 = 0, O1 = 0, e.children.map(function(n) {
      vg.walk(t, n);
    }), O1;
  };
};
const Mg = u, Rg = Mg.TitleContext;
Rg.prototype.content = function() {
  return this.children.length < 2 ? "" : this.children[1].getText().trim();
};
const Pl = u, P6 = Pl.CreationContext;
P6.prototype.Body = P6.prototype.creationBody;
P6.prototype.isCurrent = function(t) {
  return Bl.bind(this)(t);
};
const B6 = Pl.MessageContext;
B6.prototype.Body = B6.prototype.messageBody;
B6.prototype.isCurrent = function(t) {
  return Bl.bind(this)(t);
};
function Bl(t) {
  try {
    if (t == null)
      return !1;
    const e = this.start.start, n = this.Body().stop.stop + 1;
    return t >= e && t <= n;
  } catch {
    return !1;
  }
}
const L7 = u, e0 = L7.CreationContext, Pt = L7.MessageContext, zl = L7.AsyncMessageContext, Ul = L7.RetContext;
e0.prototype.Assignee = function() {
  var t, e, n;
  return (n = (e = (t = this.creationBody()) == null ? void 0 : t.assignment()) == null ? void 0 : e.assignee()) == null ? void 0 : n.getFormattedText();
};
e0.prototype.AssigneePosition = function() {
  var e, n;
  const t = (n = (e = this.creationBody()) == null ? void 0 : e.assignment()) == null ? void 0 : n.assignee();
  if (t)
    return [t.start.start, t.stop.stop + 1];
};
e0.prototype.Constructor = function() {
  var t, e;
  return (e = (t = this.creationBody()) == null ? void 0 : t.construct()) == null ? void 0 : e.getFormattedText();
};
e0.prototype.To = function() {
  return this.Constructor();
};
e0.prototype.Owner = function() {
  if (!this.Constructor())
    return "Missing Constructor";
  const t = this.Assignee(), e = this.Constructor();
  return t ? `${t}:${e}` : e;
};
Pt.prototype.To = function() {
  var t, e;
  return (e = (t = this.messageBody()) == null ? void 0 : t.to()) == null ? void 0 : e.getFormattedText();
};
Pt.prototype.Owner = function() {
  return this.To() || Bt(this.parentCtx);
};
function Bt(t) {
  for (; t; ) {
    if (t instanceof e0 || t instanceof Pt)
      return t.Owner();
    t = t.parentCtx;
  }
}
zl.prototype.To = function() {
  var t;
  return (t = this.to()) == null ? void 0 : t.getFormattedText();
};
zl.prototype.Owner = function() {
  return this.To() || Bt(this.parentCtx);
};
Ul.prototype.To = function() {
  return this.ReturnTo();
};
Ul.prototype.Owner = function() {
  return this.To() || Bt(this.parentCtx);
};
const yg = u.ProgContext;
yg.prototype.Starter = function() {
  var t, e, n;
  return (n = (e = (t = this.head()) == null ? void 0 : t.starterExp()) == null ? void 0 : e.starter()) == null ? void 0 : n.getFormattedText();
};
const a7 = u, Ag = a7.RetContext, Ai = a7.ProgContext, Zi = a7.MessageContext, Zg = a7.CreationContext;
Ag.prototype.ReturnTo = function() {
  var i, s;
  const n = this.parentCtx.parentCtx.parentCtx;
  if (n instanceof Ai)
    return n.Starter();
  {
    let r = n;
    for (; r && !(r instanceof Zi) && !(r instanceof Zg); ) {
      if (r instanceof Ai)
        return r.Starter();
      r = r.parentCtx;
    }
    return r instanceof Zi && ((s = (i = r.messageBody()) == null ? void 0 : i.from()) == null ? void 0 : s.getFormattedText()) || r.ClosestAncestorStat().Origin();
  }
};
const kg = u, Wl = kg.RefContext;
Wl.prototype.Content = function() {
  return this.name()[0];
};
Wl.prototype.Participants = function() {
  return this.name().slice(1) ?? [];
};
const Tg = y.ParserRuleContext, Hl = u.StatContext, zt = u.ProgContext, Sg = u.MessageContext, bg = u.CreationContext;
Tg.prototype.Origin = function() {
  let t = this.parentCtx;
  for (; t && !(t instanceof Hl || t instanceof zt); )
    t = this.parentCtx;
  return t.Origin();
};
Hl.prototype.Origin = function() {
  let t = this.parentCtx;
  for (; t; ) {
    if (t instanceof zt)
      return t.Starter();
    if (t instanceof Sg || t instanceof bg) {
      const e = t.Owner();
      if (e)
        return e;
    }
    t = t.parentCtx;
  }
};
zt.prototype.Origin = function() {
  return this.Starter();
};
const Eg = u, Ig = Eg.DividerContext;
Ig.prototype.Note = function() {
  var e;
  const t = (e = this.dividerNote()) == null ? void 0 : e.getFormattedText().trim();
  if (!t.startsWith("=="))
    throw new Error("Divider note must start with ==");
  return t == null ? void 0 : t.replace(/^=+|=+$/g, "");
};
const Fg = u.MessageContext, Og = u.AsyncMessageContext, $l = u.CreationContext, Ng = u.RetContext;
Fg.prototype.SignatureText = function() {
  var t, e, n;
  return ((n = (e = (t = this.messageBody()) == null ? void 0 : t.func()) == null ? void 0 : e.signature()) == null ? void 0 : n.map((i) => i == null ? void 0 : i.getFormattedText()).join(".")) ?? "";
};
Og.prototype.SignatureText = function() {
  var t;
  return ((t = this.content()) == null ? void 0 : t.getFormattedText()) ?? "";
};
$l.prototype.SignatureText = function() {
  var n;
  const t = this.creationBody().parameters();
  return `«${((n = t == null ? void 0 : t.parameter()) == null ? void 0 : n.length) > 0 ? t.getFormattedText() : "create"}»`;
};
$l.prototype.isParamValid = function() {
  var t, e;
  return (((e = (t = this.creationBody().parameters()) == null ? void 0 : t.parameter()) == null ? void 0 : e.length) ?? 0) > 0;
};
Ng.prototype.SignatureText = function() {
  var t, e, n;
  return ((e = (t = this.asyncMessage()) == null ? void 0 : t.content()) == null ? void 0 : e.getFormattedText()) ?? ((n = this.expr()) == null ? void 0 : n.getFormattedText()) ?? "";
};
const C7 = u, Vl = C7.MessageContext, Dg = C7.CreationContext, Pg = C7.IfBlockContext, Bg = C7.LoopContext;
class zg {
  constructor(e, n) {
    if (n && !e)
      throw new Error("assignee must be defined if type is defined");
    this.assignee = e || "", this.type = n || "";
  }
  getText() {
    return [this.assignee, this.type].filter(Boolean).join(":");
  }
}
Vl.prototype.Assignment = function() {
  var i, s;
  const t = this.messageBody().assignment(), e = (i = t == null ? void 0 : t.assignee()) == null ? void 0 : i.getFormattedText(), n = (s = t == null ? void 0 : t.type()) == null ? void 0 : s.getFormattedText();
  if (e)
    return new zg(e, n);
};
Vl.prototype.Statements = function() {
  var t, e;
  return ((e = (t = this.braceBlock()) == null ? void 0 : t.block()) == null ? void 0 : e.stat()) || [];
};
Dg.prototype.Statements = function() {
  var t, e;
  return ((e = (t = this.braceBlock()) == null ? void 0 : t.block()) == null ? void 0 : e.stat()) || [];
};
Pg.prototype.Statements = function() {
  var t, e;
  return ((e = (t = this.braceBlock()) == null ? void 0 : t.block()) == null ? void 0 : e.stat()) || [];
};
Bg.prototype.Statements = function() {
  var t, e;
  return ((e = (t = this.braceBlock()) == null ? void 0 : t.block()) == null ? void 0 : e.stat()) || [];
};
const C5 = u, Ug = C5.CreationContext, Wg = C5.StatContext, Gl = C5.MessageContext, jl = C5.AsyncMessageContext, Hg = C5.RetContext;
Ug.prototype.From = function() {
  if (this.parentCtx instanceof Wg)
    return this.ClosestAncestorStat().Origin();
};
Gl.prototype.ProvidedFrom = function() {
  var t, e;
  return (e = (t = this.messageBody()) == null ? void 0 : t.from()) == null ? void 0 : e.getFormattedText();
};
Gl.prototype.From = function() {
  return this.ProvidedFrom() || this.ClosestAncestorStat().Origin();
};
jl.prototype.ProvidedFrom = function() {
  var t;
  return (t = this.from()) == null ? void 0 : t.getFormattedText();
};
jl.prototype.From = function() {
  return this.ProvidedFrom() || this.ClosestAncestorStat().Origin();
};
Hg.prototype.From = function() {
  return this.ClosestAncestorStat().Origin();
};
y.ParserRuleContext.prototype.Key = function() {
  return `${this.start.start}:${this.stop.stop}`;
};
const ql = u, ki = ql.StatContext;
y.ParserRuleContext.prototype.ClosestAncestorStat = function() {
  let t = this;
  for (; !(t instanceof ki); )
    t = t.parentCtx;
  if (t instanceof ki)
    return t;
};
y.ParserRuleContext.prototype.ClosestAncestorBlock = function() {
  var e;
  const t = (e = this.ClosestAncestorStat()) == null ? void 0 : e.parentCtx;
  if (t instanceof ql.BlockContext)
    return t;
  console.warn("Cannot find closest ancestor block for context:", this);
};
y.ParserRuleContext.prototype.getAncestors = function(t) {
  let e = this;
  const n = [];
  for (; e; )
    (!t || t(e)) && n.push(e), e = e.parentCtx;
  return n;
};
function $g(t, e) {
  switch (t) {
    case 0:
      return function() {
        return e.apply(this, arguments);
      };
    case 1:
      return function(n) {
        return e.apply(this, arguments);
      };
    case 2:
      return function(n, i) {
        return e.apply(this, arguments);
      };
    case 3:
      return function(n, i, s) {
        return e.apply(this, arguments);
      };
    case 4:
      return function(n, i, s, r) {
        return e.apply(this, arguments);
      };
    case 5:
      return function(n, i, s, r, o) {
        return e.apply(this, arguments);
      };
    case 6:
      return function(n, i, s, r, o, l) {
        return e.apply(this, arguments);
      };
    case 7:
      return function(n, i, s, r, o, l, L) {
        return e.apply(this, arguments);
      };
    case 8:
      return function(n, i, s, r, o, l, L, a) {
        return e.apply(this, arguments);
      };
    case 9:
      return function(n, i, s, r, o, l, L, a, C) {
        return e.apply(this, arguments);
      };
    case 10:
      return function(n, i, s, r, o, l, L, a, C, c) {
        return e.apply(this, arguments);
      };
    default:
      throw new Error("First argument to _arity must be a non-negative integer no greater than ten");
  }
}
var Kl = $g;
function Vg(t, e) {
  return function() {
    return e.call(this, t.apply(this, arguments));
  };
}
var Gg = Vg;
function jg(t) {
  return t != null && typeof t == "object" && t["@@functional/placeholder"] === !0;
}
var Ut = jg, qg = Ut;
function Kg(t) {
  return function e(n) {
    return arguments.length === 0 || qg(n) ? e : t.apply(this, arguments);
  };
}
var c7 = Kg, z7 = c7, C0 = Ut;
function Yg(t) {
  return function e(n, i) {
    switch (arguments.length) {
      case 0:
        return e;
      case 1:
        return C0(n) ? e : z7(function(s) {
          return t(n, s);
        });
      default:
        return C0(n) && C0(i) ? e : C0(n) ? z7(function(s) {
          return t(s, i);
        }) : C0(i) ? z7(function(s) {
          return t(n, s);
        }) : t(n, i);
    }
  };
}
var Yl = Yg, D5 = c7, y9 = Yl, k1 = Ut;
function Qg(t) {
  return function e(n, i, s) {
    switch (arguments.length) {
      case 0:
        return e;
      case 1:
        return k1(n) ? e : y9(function(r, o) {
          return t(n, r, o);
        });
      case 2:
        return k1(n) && k1(i) ? e : k1(n) ? y9(function(r, o) {
          return t(r, i, o);
        }) : k1(i) ? y9(function(r, o) {
          return t(n, r, o);
        }) : D5(function(r) {
          return t(n, i, r);
        });
      default:
        return k1(n) && k1(i) && k1(s) ? e : k1(n) && k1(i) ? y9(function(r, o) {
          return t(r, o, s);
        }) : k1(n) && k1(s) ? y9(function(r, o) {
          return t(r, i, o);
        }) : k1(i) && k1(s) ? y9(function(r, o) {
          return t(n, r, o);
        }) : k1(n) ? D5(function(r) {
          return t(r, i, s);
        }) : k1(i) ? D5(function(r) {
          return t(n, r, s);
        }) : k1(s) ? D5(function(r) {
          return t(n, i, r);
        }) : t(n, i, s);
    }
  };
}
var Wt = Qg, Ql = Array.isArray || function(e) {
  return e != null && e.length >= 0 && Object.prototype.toString.call(e) === "[object Array]";
};
function Xg(t) {
  return Object.prototype.toString.call(t) === "[object String]";
}
var Jg = Xg, ef = c7, tf = Ql, nf = Jg, sf = /* @__PURE__ */ ef(function(e) {
  return tf(e) ? !0 : !e || typeof e != "object" || nf(e) ? !1 : e.length === 0 ? !0 : e.length > 0 ? e.hasOwnProperty(0) && e.hasOwnProperty(e.length - 1) : !1;
}), rf = sf, of = /* @__PURE__ */ function() {
  function t(e) {
    this.f = e;
  }
  return t.prototype["@@transducer/init"] = function() {
    throw new Error("init not implemented on XWrap");
  }, t.prototype["@@transducer/result"] = function(e) {
    return e;
  }, t.prototype["@@transducer/step"] = function(e, n) {
    return this.f(e, n);
  }, t;
}();
function lf(t) {
  return new of(t);
}
var Lf = lf, af = Kl, Cf = Yl, cf = /* @__PURE__ */ Cf(function(e, n) {
  return af(e.length, function() {
    return e.apply(n, arguments);
  });
}), uf = cf, hf = rf, df = Lf, gf = uf;
function ff(t, e, n) {
  for (var i = 0, s = n.length; i < s; ) {
    if (e = t["@@transducer/step"](e, n[i]), e && e["@@transducer/reduced"]) {
      e = e["@@transducer/value"];
      break;
    }
    i += 1;
  }
  return t["@@transducer/result"](e);
}
function Ti(t, e, n) {
  for (var i = n.next(); !i.done; ) {
    if (e = t["@@transducer/step"](e, i.value), e && e["@@transducer/reduced"]) {
      e = e["@@transducer/value"];
      break;
    }
    i = n.next();
  }
  return t["@@transducer/result"](e);
}
function Si(t, e, n, i) {
  return t["@@transducer/result"](n[i](gf(t["@@transducer/step"], t), e));
}
var bi = typeof Symbol < "u" ? Symbol.iterator : "@@iterator";
function pf(t, e, n) {
  if (typeof t == "function" && (t = df(t)), hf(n))
    return ff(t, e, n);
  if (typeof n["fantasy-land/reduce"] == "function")
    return Si(t, e, n, "fantasy-land/reduce");
  if (n[bi] != null)
    return Ti(t, e, n[bi]());
  if (typeof n.next == "function")
    return Ti(t, e, n);
  if (typeof n.reduce == "function")
    return Si(t, e, n, "reduce");
  throw new TypeError("reduce: list must be array or iterable");
}
var mf = pf, wf = Wt, xf = mf, _f = /* @__PURE__ */ wf(xf), vf = _f, Mf = Ql;
function Rf(t, e) {
  return function() {
    var n = arguments.length;
    if (n === 0)
      return e();
    var i = arguments[n - 1];
    return Mf(i) || typeof i[t] != "function" ? e.apply(this, arguments) : i[t].apply(i, Array.prototype.slice.call(arguments, 0, n - 1));
  };
}
var Xl = Rf, yf = Xl, Af = Wt, Zf = /* @__PURE__ */ Af(
  /* @__PURE__ */ yf("slice", function(e, n, i) {
    return Array.prototype.slice.call(i, e, n);
  })
), kf = Zf, Tf = Xl, Sf = c7, bf = kf, Ef = /* @__PURE__ */ Sf(
  /* @__PURE__ */ Tf(
    "tail",
    /* @__PURE__ */ bf(1, 1 / 0)
  )
), If = Ef, Ff = Kl, Of = Gg, Nf = vf, Df = If;
function Pf() {
  if (arguments.length === 0)
    throw new Error("pipe requires at least one argument");
  return Ff(arguments[0].length, Nf(Of, arguments[0], Df(arguments)));
}
var Bf = Pf;
const zf = /* @__PURE__ */ s4(Bf);
var Uf = Wt, Wf = /* @__PURE__ */ Uf(function(e, n, i) {
  return i.replace(e, n);
}), Hf = Wf;
const t0 = /* @__PURE__ */ s4(Hf), $f = t0(/[\n\r]/g, " "), Vf = t0(/\s+/g, " "), Gf = t0(/\s*([,;.])\s*/g, "$1"), jf = t0(
  /\s*(\()\s*|\s*(\))/g,
  "$1$2"
), qf = t0(/\s+$/g, ""), Kf = t0(/^"(.*)"$/, "$1"), Jl = zf(
  $f,
  Vf,
  Gf,
  jf,
  qf,
  Kf
), eL = (t, e) => {
  let n = e;
  for (t[n] === `
` && n--; n >= 0; ) {
    if (t[n] === `
`)
      return n + 1;
    n--;
  }
  return 0;
}, Yf = (t, e) => {
  const n = eL(t, e);
  if (n === 0)
    return 0;
  let i = n - 2;
  for (; i >= 0; ) {
    if (t[i] === `
`)
      return i + 1;
    i--;
  }
  return 0;
}, Cz = (t, e) => {
  const n = eL(t, e);
  if (n === 0)
    return "";
  const i = Yf(t, e);
  return t.slice(i, n);
};
class Qf extends y.error.ErrorListener {
  syntaxError(e, n, i, s, r) {
  }
}
function Xf(t) {
  const e = new y.InputStream(t), n = new X(e), i = new y.CommonTokenStream(n), s = new u(i);
  return s.addErrorListener(new Qf()), s._syntaxErrors ? null : s.prog();
}
y.ParserRuleContext.prototype.getFormattedText = function() {
  const t = this.parser.getTokenStream().getText(this.getSourceInterval());
  return Jl(t);
};
y.ParserRuleContext.prototype.getComment = function() {
  let t = this.start.tokenIndex, e = X.channelNames.indexOf("COMMENT_CHANNEL");
  this.constructor.name === "BraceBlockContext" && (t = this.stop.tokenIndex);
  let n = this.parser.getTokenStream().getHiddenTokensToLeft(t, e);
  return n && n.map((i) => i.text.substring(2)).join("");
};
y.ParserRuleContext.prototype.returnedValue = function() {
  return this.braceBlock().block().ret().value();
};
const Jf = Xf, tL = u.GroupContext, nL = u.ParticipantContext, c5 = function(t) {
  return N1.getParticipants(t);
};
var g8 = /* @__PURE__ */ ((t) => (t[t.MessageContent = 0] = "MessageContent", t[t.ParticipantName = 1] = "ParticipantName", t))(g8 || {});
let Ht = {};
const iL = {}, z6 = (t) => {
  if (t != null) {
    const e = Ht[t] ?? iL[t];
    return e !== void 0 ? e : null;
  }
  return null;
}, U6 = (t, e, n = !1) => {
  Ht[t] = e, n && (iL[t] = e);
}, sL = () => {
  Ht = {};
};
function ep(t, e) {
  const n = `WidthProviderOnBrowser_${t}_${e}`, i = z6(n);
  if (i != null)
    return i;
  let s = document.querySelector(
    ".textarea-hidden-div"
  );
  if (!s) {
    const o = document.createElement("div");
    o.className = "textarea-hidden-div ", o.style.fontSize = e === g8.MessageContent ? "0.875rem" : "1rem", o.style.fontFamily = "Helvetica, Verdana, serif", o.style.display = "inline", o.style.whiteSpace = "nowrap", o.style.visibility = "hidden", o.style.position = "absolute", o.style.top = "0", o.style.left = "0", o.style.overflow = "hidden", o.style.width = "0px", o.style.paddingLeft = "0px", o.style.paddingRight = "0px", o.style.margin = "0px", o.style.border = "0px", document.body.appendChild(o), s = o;
  }
  s.textContent = t;
  const r = s.scrollWidth;
  return U6(n, r, !0), r;
}
const Ei = 10, rL = 100, tp = 20, np = 10, oL = 15, S0 = (oL - 1) / 2, ip = 80, sp = 70, lL = 1;
var k9 = /* @__PURE__ */ ((t) => (t[t.SyncMessage = 0] = "SyncMessage", t[t.AsyncMessage = 1] = "AsyncMessage", t[t.CreationMessage = 2] = "CreationMessage", t[t.ReturnMessage = 3] = "ReturnMessage", t))(k9 || {});
class rp extends A {
  constructor() {
    super(...arguments), this.isBlind = !1, this.ownableMessages = [], this.enterMessage = (e) => this._addOwnedMessage(k9.SyncMessage)(e), this.enterAsyncMessage = (e) => this._addOwnedMessage(k9.AsyncMessage)(e), this.enterCreation = (e) => this._addOwnedMessage(k9.CreationMessage)(e), this.enterRet = (e) => {
      e.asyncMessage() || this._addOwnedMessage(k9.ReturnMessage)(e);
    }, this._addOwnedMessage = (e) => (n) => {
      if (this.isBlind)
        return;
      const i = n.From(), s = n == null ? void 0 : n.Owner();
      let r = n == null ? void 0 : n.SignatureText();
      if (i === s && n.Assignment) {
        const o = n.Assignment();
        o && (r = `${o.getText()} = ${r}`);
      }
      this.ownableMessages.push({
        from: i,
        signature: r,
        type: e,
        to: s
      });
    };
  }
  enterParameters() {
    this.isBlind = !0;
  }
  exitParameters() {
    this.isBlind = !1;
  }
  result() {
    return this.ownableMessages;
  }
}
function u7(t) {
  const e = y.tree.ParseTreeWalker.DEFAULT, n = new rp();
  return e.walk(n, t), n.result();
}
const K1 = "_STARTER_";
let op = class {
  constructor(e, n, i, s) {
    this.name = e, this.left = n, this.label = i, this.type = s;
  }
  getDisplayName() {
    return this.label || this.name;
  }
  hasIcon() {
    return this.type !== void 0;
  }
};
function lp(t) {
  const e = N1.getParticipants(t), n = Array.from(e.participants.entries()), i = u7(t), s = i.length === 0 && n.length === 0, r = i.some((l) => !l.from);
  return (s || r) && n.unshift([
    K1,
    { ...Nl, name: K1, isStarter: !0 }
  ]), n.map((l, L, a) => {
    const C = l[1], c = L > 0 ? a[L - 1][1].name : "";
    return new op(
      C.name,
      c,
      C.label,
      C.type
    );
  });
}
function h7(t, e) {
  return { position: t, velocity: e };
}
function Ii(t, e) {
  return h7(t.position + e.position, t.velocity + e.velocity);
}
const Fi = Math.sqrt(Number.EPSILON);
function Lp(t, e) {
  const n = t.position - e.position;
  return n < -Fi || Math.abs(n) <= Fi && t.velocity < e.velocity;
}
function ap() {
  return {
    delta: 1 / 0,
    dualLessThan: function(t, e) {
      const n = Lp(t, e);
      return n && ([t, e] = [e, t]), t.velocity < e.velocity && (this.delta = Math.min(
        this.delta,
        (t.position - e.position) / (e.velocity - t.velocity)
      )), n;
    }
  };
}
function Cp(t, e) {
  const n = Array();
  for (let i = 0; i < t; i++) {
    n.push([]);
    for (let s = 0; s < i; s++)
      e[s][i] > 0 && n[i].push({ i: s, length: h7(e[s][i], 0) });
  }
  return n;
}
function cp(t, e) {
  const n = ap();
  let i = h7(0, 0);
  const s = [];
  for (let r = 0; r < t.length; r++) {
    let o = null;
    r > 0 && (i = Ii(i, e[r - 1]));
    for (const l of t[r]) {
      const L = Ii(s[l.i].maximum, l.length);
      n.dualLessThan(i, L) && (o = l.i, i = L);
    }
    s.push({ argument: o, maximum: i });
  }
  return [n.delta, s];
}
function up(t, e, n) {
  let i = t.length - 1;
  for (; i > 0; ) {
    const s = t[i].argument;
    s !== null ? i = s : (i--, n[i].velocity = 0);
  }
}
function hp(t, e) {
  for (let n = 0; n < t.length; n++)
    t[n].position += t[n].velocity * e;
}
function dp(t) {
  const e = [];
  for (const n of t)
    e.push(n.maximum.position);
  return e;
}
function gp(t) {
  const e = t.length, n = Cp(e, t), i = [];
  for (let s = 1; s < e; s++)
    i.push(h7(0, 1));
  for (; ; ) {
    const [s, r] = cp(n, i);
    if (s == 1 / 0)
      return dp(r);
    r[e - 1].maximum.velocity > 0 ? up(r, n, i) : hp(i, s);
  }
}
class fp {
  constructor(e, n) {
    this.m = [], sL(), this.participantModels = lp(e), this.ownableMessages = u7(e), this.widthProvider = n, this.walkThrough();
  }
  orderedParticipantNames() {
    return this.participantModels.map((e) => e.name);
  }
  getPosition(e) {
    if (!e)
      return 0;
    if (!this.getParticipantModel(e))
      return console.error(`Participant ${e} not found`), 0;
    const i = `getPosition_${e}`, s = z6(i);
    if (s != null)
      return s;
    const r = this.participantModels.findIndex(
      (L) => L.name === e
    ), l = this.getParticipantGap(this.participantModels[0]) + gp(this.m)[r];
    return U6(i, l), console.debug(`Position of ${e} is ${l}`), l;
  }
  walkThrough() {
    this.withParticipantGaps(this.participantModels), this.withMessageGaps(this.ownableMessages, this.participantModels);
  }
  half(e) {
    const n = this.getParticipantModel(e);
    return n ? this._getParticipantWidth(n) / 2 : 0;
  }
  left(e) {
    return this.getPosition(e) - this.half(e);
  }
  right(e) {
    return this.getPosition(e) + this.half(e);
  }
  getWidth() {
    const e = this.participantModels[this.participantModels.length - 1].name, n = this.getPosition(e) + this.half(e);
    return Math.max(n, 200);
  }
  distance(e, n) {
    return this.getPosition(n) - this.getPosition(e);
  }
  getMessageWidth(e) {
    const n = this.half(e.to);
    let i = this.widthProvider(
      e.signature,
      g8.MessageContent
    );
    return e.type === k9.CreationMessage && (i += n), i;
  }
  withMessageGaps(e, n) {
    for (const i of e) {
      i.from || (i.from = K1);
      const s = n.findIndex(
        (L) => L.name === i.from
      ), r = n.findIndex((L) => L.name === i.to);
      if (s === -1 || r === -1) {
        console.warn(`Participant ${i.from} or ${i.to} not found`);
        continue;
      }
      const o = Math.min(s, r), l = Math.max(s, r);
      try {
        const L = this.getMessageWidth(i);
        this.m[o][l] = Math.max(
          L + np + oL,
          this.m[o][l]
        );
      } catch {
        console.warn(
          `Could not set message gap between ${i.from} and ${i.to}`
        );
      }
    }
  }
  withParticipantGaps(e) {
    this.m = e.map((n, i) => e.map((s, r) => r - i === 1 ? this.getParticipantGap(s) : 0));
  }
  getParticipantGap(e) {
    return this.half(e.left) + this.half(e.name);
  }
  getParticipantModel(e) {
    return this.participantModels.find((n) => n.name === e);
  }
  _getParticipantWidth(e) {
    const n = `getParticipantWidth_${e.name}`, i = z6(n);
    if (i != null)
      return i;
    const r = e.hasIcon() ? 40 : 0, o = this.widthProvider(
      e.getDisplayName(),
      g8.ParticipantName
    ), l = Math.max(o + r, ip) + tp;
    return U6(n, l), console.debug(
      `Width of ${e.name} is ${l}; labelWidth: ${o}`
    ), l;
  }
}
var j1 = /* @__PURE__ */ ((t) => (t.Static = "static", t.Dynamic = "dynamic", t))(j1 || {});
const LL = () => ({
  state: {
    code: "",
    theme: "theme-default",
    enableScopedTheming: !1,
    themeIconDot: !!localStorage.getItem(`${location.hostname}-zenuml-theme-icon-dot`),
    enableMultiTheme: !0,
    scale: 1,
    selected: [],
    cursor: null,
    showTips: !1,
    mode: "dynamic",
    numbering: !!localStorage.getItem(`${location.hostname}-zenuml-numbering`),
    stickyOffset: 0,
    diagramElement: null,
    onElementClick: (t) => {
      console.log("Element clicked", t);
    },
    onMessageClick: () => {
    },
    onContentChange: () => {
    },
    onThemeChange: () => {
    },
    onEventEmit: () => {
    }
  },
  getters: {
    code: (t) => t.code,
    rootContext: (t) => Jf(t.code),
    title: (t, e) => {
      var n, i;
      return (i = (n = e.rootContext) == null ? void 0 : n.title()) == null ? void 0 : i.content();
    },
    participants: (t, e) => c5(e.rootContext),
    coordinates: (t, e) => new fp(e.rootContext, ep),
    centerOf: (t, e) => (n) => {
      if (!n)
        return console.error("[@zenuml/core] centerOf: entity is undefined"), 0;
      try {
        return e.coordinates.getPosition(n) || 0;
      } catch (i) {
        return console.error(i), 0;
      }
    },
    GroupContext: () => tL,
    ParticipantContext: () => nL,
    cursor: (t) => t.cursor,
    // deprecated, use distances that returns centerOf(to) - centerOf(from)
    distance: (t, e) => (n, i) => e.centerOf(n) - e.centerOf(i),
    distance2: (t, e) => (n, i) => !n || !i ? 0 : e.centerOf(i) - e.centerOf(n),
    onElementClick: (t) => t.onElementClick,
    onMessageClick: (t) => t.onMessageClick,
    diagramElement: (t) => t.diagramElement,
    onContentChange: (t) => t.onContentChange,
    onThemeChange: (t) => t.onThemeChange,
    onEventEmit: (t) => t.onEventEmit
  },
  mutations: {
    code: function(t, e) {
      t.code = e;
    },
    setScale: function(t, e) {
      t.scale = e;
    },
    onSelect: function(t, e) {
      t.selected.includes(e) ? t.selected = t.selected.filter((n) => n !== e) : t.selected.push(e);
    },
    cursor: function(t, e) {
      t.cursor = e;
    },
    toggleNumbering(t, e) {
      e ? localStorage.setItem(`${location.hostname}-zenuml-numbering`, "1") : localStorage.setItem(`${location.hostname}-zenuml-numbering`, ""), t.numbering = e;
    },
    setTheme: function(t, e) {
      var n;
      t.theme = e, (n = t.onThemeChange) == null || n.call(t, {
        theme: e,
        scoped: !!t.enableScopedTheming
      });
    },
    setThemeIconDot: function(t, e) {
      localStorage.setItem(
        `${location.hostname}-zenuml-theme-icon-dot`,
        e ? "1" : ""
      ), t.themeIconDot = e;
    },
    setEnableScopedTheming: function(t, e) {
      var n;
      t.enableScopedTheming = e, (n = t.onThemeChange) == null || n.call(t, {
        theme: t.theme,
        scoped: e
      });
    },
    eventEmit: function(t, e) {
      var n;
      (n = t.onEventEmit) == null || n.call(t, e.event, e.data);
    },
    onEventEmit: function(t, e) {
      t.onEventEmit = e;
    },
    onMessageClick: function(t, e) {
      t.onMessageClick = e;
    },
    onContentChange: function(t, e) {
      t.onContentChange = e;
    },
    onThemeChange: function(t, e) {
      t.onThemeChange = e;
    },
    diagramElement: function(t, e) {
      t.diagramElement = e;
    }
  },
  actions: {
    // Why debounce is here instead of mutation 'code'?
    // Both code and cursor must be mutated together, especially during typing.
    updateCode: function({ commit: t }, e) {
      if (typeof e == "string")
        throw Error(
          "You are using a old version of vue-sequence. New version requires {code, cursor}."
        );
      e.code !== this.state.code && t("code", e.code);
    }
  },
  // TODO: Enable strict for development?
  strict: !1
}), pp = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}, mp = /* @__PURE__ */ _("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "m12 8 8 4-8 4-8-4 8-4Z"
}, null, -1), wp = [
  mp
];
function aL(t, e) {
  return T(), B("svg", pp, wp);
}
const xp = { render: aL }, _p = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: xp,
  render: aL
}, Symbol.toStringTag, { value: "Module" })), vp = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "aria-hidden": "true",
  viewBox: "0 0 24 24"
}, Mp = /* @__PURE__ */ _("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M6 18 18 6M6 6l12 12"
}, null, -1), Rp = [
  Mp
];
function CL(t, e) {
  return T(), B("svg", vp, Rp);
}
const yp = { render: CL }, Ap = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: yp,
  render: CL
}, Symbol.toStringTag, { value: "Module" })), Zp = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  viewBox: "0 0 24 24"
}, kp = /* @__PURE__ */ _("path", { d: "m14 10 7-7M20 10h-6V4M3 21l7-7M4 14h6v6" }, null, -1), Tp = [
  kp
];
function cL(t, e) {
  return T(), B("svg", Zp, Tp);
}
const Sp = { render: cL }, bp = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Sp,
  render: cL
}, Symbol.toStringTag, { value: "Module" })), Ep = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}, Ip = /* @__PURE__ */ _("g", {
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /* @__PURE__ */ _("path", {
    d: "M3 17.3V21h3.7",
    "data-name": "Right"
  }),
  /* @__PURE__ */ _("path", { d: "m10 14-6.2 6.2M14 10l6.2-6.2" }),
  /* @__PURE__ */ _("path", {
    d: "M21 6.7V3h-3.7",
    "data-name": "Right"
  })
], -1), Fp = [
  Ip
];
function uL(t, e) {
  return T(), B("svg", Ep, Fp);
}
const Op = { render: uL }, Np = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Op,
  render: uL
}, Symbol.toStringTag, { value: "Module" })), Dp = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}, Pp = /* @__PURE__ */ _("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "m12 5 7 7-7 7-7-7 7-7ZM12 9v4M12 15v.5"
}, null, -1), Bp = [
  Pp
];
function hL(t, e) {
  return T(), B("svg", Dp, Bp);
}
const zp = { render: hL }, Up = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: zp,
  render: hL
}, Symbol.toStringTag, { value: "Module" })), Wp = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24"
}, Hp = /* @__PURE__ */ _("path", { d: "M6 3v12" }, null, -1), $p = /* @__PURE__ */ _("circle", {
  cx: "18",
  cy: "6",
  r: "3"
}, null, -1), Vp = /* @__PURE__ */ _("circle", {
  cx: "6",
  cy: "18",
  r: "3"
}, null, -1), Gp = /* @__PURE__ */ _("path", { d: "M18 9a9 9 0 0 1-9 9" }, null, -1), jp = [
  Hp,
  $p,
  Vp,
  Gp
];
function dL(t, e) {
  return T(), B("svg", Wp, jp);
}
const qp = { render: dL }, Kp = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: qp,
  render: dL
}, Symbol.toStringTag, { value: "Module" })), Yp = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "currentColor",
  viewBox: "0 0 1024 1024"
}, Qp = /* @__PURE__ */ _("path", { d: "m960 101.84-896.002.002c-35.344 0-64 28.656-64 64v576c0 35.36 28.656 64 64 64h160c20.496 0 32-26.32 32-31.984v-.016c0-5.824-10.88-32.416-32-32.416h-120.96c-21.376 0-38.72-17.344-38.72-38.72V206.002c0-21.391 17.328-38.72 38.72-38.72l818.272-1.007c21.376 0 38.72 17.328 38.72 38.72V702.69c0 21.376-17.344 38.72-38.72 38.72H518.142l75.984-68.912c9.344-8.944 12.369-23.408 3.025-32.336l-5.472-8.064c-9.376-8.945-24.496-8.945-33.84 0L428.111 750.53c-.192.16-.368.224-.528.368l-8.48 8.096c-4.672 4.431-7.008 10.335-6.976 16.223-.032 5.904 2.288 11.777 6.977 16.288l8.48 8.096c.16.16.368.192.528.336L555.84 915.44c9.344 8.944 24.464 8.944 33.84 0l5.472-8.065c9.344-8.944 6.32-23.44-3.025-32.368l-77.135-69.168H960c35.343 0 64-28.64 64-64v-576c0-35.344-28.657-64-64-64z" }, null, -1), Xp = [
  Qp
];
function gL(t, e) {
  return T(), B("svg", Yp, Xp);
}
const Jp = { render: gL }, em = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Jp,
  render: gL
}, Symbol.toStringTag, { value: "Module" })), tm = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "24",
  class: "arrow text-skin-message-arrow"
}, nm = /* @__PURE__ */ _("path", {
  d: "M0 2h28v13H14",
  class: "line stroke-current fill-none stroke-2"
}, null, -1), im = /* @__PURE__ */ _("path", {
  d: "M18 9 8 15l10 6",
  class: "head stroke-current fill-current stroke-2"
}, null, -1), sm = [
  nm,
  im
];
function fL(t, e) {
  return T(), B("svg", tm, sm);
}
const rm = { render: fL }, om = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: rm,
  render: fL
}, Symbol.toStringTag, { value: "Module" })), lm = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  fill: "none",
  viewBox: "0 0 20 20"
}, Lm = /* @__PURE__ */ _("circle", {
  cx: "10",
  cy: "10",
  r: "10",
  fill: "#000",
  "fill-opacity": ".1"
}, null, -1), am = [
  Lm
];
function pL(t, e) {
  return T(), B("svg", lm, am);
}
const Cm = { render: pL }, cm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Cm,
  render: pL
}, Symbol.toStringTag, { value: "Module" })), um = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 100 100"
}, hm = /* @__PURE__ */ _("path", {
  fill: "#000",
  d: "M21.886 32.09V67H17.66V36.523h-.204l-8.523 5.659v-4.296l8.727-5.795h4.227Zm11.662 35.126a2.338 2.338 0 0 1-1.714-.715 2.338 2.338 0 0 1-.715-1.714c0-.666.239-1.237.715-1.714a2.338 2.338 0 0 1 1.714-.715c.666 0 1.237.238 1.714.715.477.477.715 1.048.715 1.714 0 .44-.112.846-.337 1.214a2.52 2.52 0 0 1-.877.891c-.36.216-.765.324-1.215.324Zm8.24-.216v-2.557l9.603-10.511a66.703 66.703 0 0 0 2.784-3.21c.73-.919 1.269-1.78 1.62-2.586a6.26 6.26 0 0 0 .54-2.556c0-1.023-.247-1.909-.74-2.657-.482-.748-1.145-1.326-1.988-1.733-.843-.407-1.79-.61-2.841-.61-1.117 0-2.093.232-2.926.696a4.792 4.792 0 0 0-1.918 1.917c-.445.824-.667 1.79-.667 2.898h-3.353c0-1.705.393-3.2 1.18-4.489a8.192 8.192 0 0 1 3.21-3.011c1.363-.72 2.892-1.08 4.588-1.08 1.704 0 3.215.36 4.53 1.08 1.317.72 2.35 1.69 3.098 2.912.748 1.221 1.122 2.58 1.122 4.077 0 1.07-.195 2.116-.583 3.139-.379 1.013-1.041 2.145-1.988 3.395-.938 1.24-2.24 2.755-3.907 4.545l-6.534 6.989v.227h13.523V67H41.789Zm26.444.216a2.338 2.338 0 0 1-1.714-.715 2.338 2.338 0 0 1-.715-1.714c0-.666.238-1.237.715-1.714a2.338 2.338 0 0 1 1.714-.715c.666 0 1.237.238 1.714.715.477.477.715 1.048.715 1.714 0 .44-.113.846-.338 1.214a2.52 2.52 0 0 1-.877.891c-.36.216-.764.324-1.214.324Zm15.502.102c-1.5 0-2.837-.257-4.012-.772-1.166-.516-2.094-1.232-2.784-2.148-.682-.924-1.053-1.996-1.113-3.216h2.863c.06.75.318 1.398.773 1.943.454.538 1.05.954 1.784 1.25.735.296 1.55.443 2.443.443 1 0 1.887-.174 2.66-.522.772-.349 1.378-.834 1.817-1.455.44-.621.66-1.341.66-2.16 0-.855-.213-1.609-.637-2.26-.424-.66-1.045-1.175-1.863-1.546-.819-.371-1.819-.557-3-.557H81.46v-2.5h1.864c.924 0 1.734-.166 2.431-.5.705-.333 1.254-.803 1.648-1.409.402-.606.602-1.318.602-2.136 0-.788-.174-1.474-.522-2.057a3.575 3.575 0 0 0-1.478-1.364c-.628-.325-1.37-.488-2.227-.488-.803 0-1.56.147-2.273.443a4.234 4.234 0 0 0-1.727 1.261c-.447.546-.69 1.205-.727 1.977h-2.727c.045-1.22.412-2.287 1.102-3.204.69-.924 1.59-1.644 2.704-2.16 1.122-.514 2.353-.772 3.694-.772 1.439 0 2.674.292 3.704.875 1.03.576 1.822 1.337 2.375 2.284.553.947.83 1.97.83 3.068 0 1.311-.345 2.428-1.034 3.353-.682.924-1.61 1.564-2.785 1.92v.182c1.47.242 2.618.867 3.444 1.875.825 1 1.238 2.239 1.238 3.716 0 1.265-.344 2.401-1.034 3.409-.682 1-1.613 1.788-2.795 2.364-1.182.575-2.527.863-4.034.863Z"
}, null, -1), dm = /* @__PURE__ */ _("path", {
  fill: "#000",
  d: "M21.886 32.09h1v-1h-1v1Zm0 34.91v1h1v-1h-1Zm-4.227 0h-1v1h1v-1Zm0-30.477h1v-1h-1v1Zm-.204 0v-1h-.302l-.252.167.553.833Zm-8.523 5.659h-1v1.864l1.553-1.031-.553-.833Zm0-4.296-.553-.833-.447.297v.536h1Zm8.727-5.795v-1h-.302l-.251.167.553.833Zm3.227 0V67h2V32.09h-2Zm1 33.909H17.66v2h4.227v-2Zm-3.227 1V36.523h-2V67h2Zm-1-31.477h-.204v2h.204v-2Zm-.758.167L8.38 41.349l1.106 1.666 8.523-5.66L16.9 35.69Zm-6.97 6.492v-4.296h-2v4.296h2Zm-.446-3.463 8.727-5.795-1.106-1.666-8.727 5.795 1.106 1.666Zm8.174-5.628h4.227v-2H17.66v2ZM31.834 66.5l.708-.707-.708.707Zm0-3.428-.707-.707.707.707Zm3.428 0 .707-.707-.707.707Zm.378 2.928-.854-.52-.005.008-.004.007.863.505Zm-.877.891.514.858.006-.004-.52-.854Zm-1.215-.676a1.34 1.34 0 0 1-1.006-.422l-1.415 1.414a3.337 3.337 0 0 0 2.421 1.008v-2Zm-1.006-.422a1.34 1.34 0 0 1-.423-1.007h-2c0 .935.347 1.76 1.008 2.42l1.415-1.413Zm-.423-1.007c0-.397.13-.715.423-1.007l-1.415-1.414a3.337 3.337 0 0 0-1.008 2.42h2Zm.423-1.007a1.34 1.34 0 0 1 1.006-.422v-2c-.934 0-1.759.346-2.42 1.008l1.414 1.414Zm1.006-.422c.397 0 .715.13 1.007.422l1.414-1.414a3.337 3.337 0 0 0-2.42-1.008v2Zm1.007.422c.292.292.422.61.422 1.007h2c0-.935-.346-1.76-1.008-2.421l-1.414 1.414Zm.422 1.007c0 .261-.064.485-.19.694l1.707 1.041a3.288 3.288 0 0 0 .483-1.735h-2Zm-.2.71a1.52 1.52 0 0 1-.535.541l1.041 1.708c.509-.31.92-.726 1.22-1.24l-1.726-1.01Zm-.529.538a1.317 1.317 0 0 1-.7.18v2c.618 0 1.203-.15 1.73-.466l-1.03-1.714Zm7.54.965h-1v1h1v-1Zm0-2.557-.738-.674-.261.286v.388h1Zm9.603-10.511-.738-.675.738.675Zm2.784-3.21.78.625.003-.004-.783-.621Zm1.62-2.586-.915-.404-.003.005.917.4Zm-.2-5.213-.84.543.005.007.836-.55Zm-1.988-1.733.435-.9-.435.9Zm-5.767.086.483.875.003-.002-.486-.873Zm-1.918 1.917-.875-.483-.005.008.88.475Zm-.667 2.898v1h1v-1h-1Zm-3.353 0h-1v1h1v-1Zm1.18-4.489.853.521-.854-.52Zm3.21-3.011-.467-.885-.003.002.47.883Zm9.119 0 .48-.877-.48.877Zm3.096 2.912-.852.522.852-.522Zm.54 7.216-.935-.355-.002.005.937.35Zm-1.988 3.395-.797-.604h-.001l.798.604Zm-3.907 4.545.73.683.002-.001-.732-.682Zm-6.534 6.989-.73-.683-.27.288v.395h1Zm0 .227h-1v1h1v-1Zm13.523 0h1v-1h-1v1Zm0 3.125v1h1v-1h-1Zm-17.352 0v-2.557h-2V67h2Zm-.262-1.882 9.602-10.512-1.476-1.349L41.05 63.77l1.477 1.349Zm9.602-10.511a67.671 67.671 0 0 0 2.826-3.26l-1.56-1.251a65.769 65.769 0 0 1-2.742 3.16l1.476 1.351Zm2.83-3.264c.766-.965 1.358-1.901 1.752-2.808l-1.834-.798c-.306.704-.793 1.491-1.485 2.363l1.566 1.243Zm1.75-2.803a7.259 7.259 0 0 0 .625-2.96h-2c0 .75-.15 1.465-.454 2.152l1.83.809Zm.625-2.96c0-1.19-.289-2.273-.903-3.206l-1.67 1.1c.37.562.573 1.25.573 2.106h2Zm-.898-3.2a5.792 5.792 0 0 0-2.394-2.09l-.87 1.8c.686.332 1.205.79 1.583 1.376l1.68-1.085Zm-2.394-2.09c-.994-.48-2.093-.71-3.276-.71v2c.92 0 1.715.177 2.406.51l.87-1.8Zm-3.276-.71c-1.258 0-2.407.262-3.413.822l.973 1.747c.661-.368 1.463-.57 2.44-.57v-2Zm-3.41.82a5.791 5.791 0 0 0-2.31 2.31l1.752.966a3.792 3.792 0 0 1 1.525-1.525l-.966-1.751Zm-2.314 2.318c-.537.994-.787 2.13-.787 3.373h2c0-.973.194-1.77.547-2.422l-1.76-.951Zm.213 2.373h-3.353v2h3.353v-2Zm-2.353 1c0-1.545.355-2.856 1.033-3.968l-1.707-1.042c-.894 1.465-1.326 3.146-1.326 5.01h2Zm1.033-3.968a7.193 7.193 0 0 1 2.826-2.65l-.939-1.765a9.192 9.192 0 0 0-3.594 3.373l1.707 1.042Zm2.823-2.648c1.206-.636 2.573-.964 4.122-.964v-2c-1.842 0-3.534.393-5.055 1.195l.933 1.77Zm4.122-.964c1.56 0 2.901.328 4.051.957l.96-1.755c-1.483-.81-3.162-1.202-5.011-1.202v2Zm4.051.957c1.17.64 2.071 1.492 2.724 2.557l1.705-1.044c-.843-1.378-2.007-2.468-3.47-3.267l-.959 1.754Zm2.724 2.557c.647 1.057.975 2.234.975 3.555h2c0-1.672-.421-3.213-1.27-4.6l-1.705 1.045Zm.975 3.555c0 .946-.172 1.872-.518 2.784l1.87.71c.43-1.134.648-2.3.648-3.494h-2Zm-.52 2.789c-.333.891-.936 1.937-1.849 3.14l1.595 1.209c.981-1.296 1.704-2.514 2.128-3.65l-1.873-.7Zm-1.85 3.142c-.908 1.202-2.185 2.69-3.84 4.467l1.464 1.363c1.679-1.803 3.006-3.346 3.972-4.624l-1.595-1.206Zm-3.838 4.465-6.534 6.989 1.46 1.366 6.535-6.989-1.461-1.366Zm-6.804 7.672v.227h2v-.227h-2Zm1 1.227h13.523v-2H46.618v2Zm12.523-1V67h2v-3.125h-2Zm1 2.125H41.789v2H60.14v-2Zm6.377.5.707-.706-.707.707Zm0-3.427-.707-.707.707.707Zm3.428 0 .707-.707-.707.707Zm.377 2.928-.853-.52-.005.008-.005.007.864.505Zm-.877.891.515.858.006-.004-.52-.854Zm-1.214-.676a1.34 1.34 0 0 1-1.007-.422l-1.414 1.414a3.337 3.337 0 0 0 2.42 1.008v-2Zm-1.007-.422a1.34 1.34 0 0 1-.422-1.007h-2c0 .935.346 1.76 1.008 2.42l1.414-1.413Zm-.422-1.007c0-.397.13-.715.422-1.007l-1.414-1.414a3.337 3.337 0 0 0-1.008 2.42h2Zm.422-1.007a1.34 1.34 0 0 1 1.007-.422v-2c-.935 0-1.76.346-2.421 1.008l1.414 1.414Zm1.007-.422c.397 0 .715.13 1.007.422l1.414-1.414a3.337 3.337 0 0 0-2.421-1.008v2Zm1.007.422c.291.292.422.61.422 1.007h2c0-.935-.347-1.76-1.008-2.421l-1.414 1.414Zm.422 1.007c0 .261-.064.485-.191.694l1.707 1.041a3.288 3.288 0 0 0 .484-1.735h-2Zm-.2.71a1.52 1.52 0 0 1-.535.541l1.041 1.708a3.52 3.52 0 0 0 1.22-1.24l-1.727-1.01Zm-.53.538a1.317 1.317 0 0 1-.7.18v2c.618 0 1.203-.15 1.73-.466l-1.03-1.714Zm10.791.51-.404.915.003.001.401-.915Zm-2.784-2.147-.805.593.006.008.8-.601Zm-1.113-3.216v-1h-1.051l.052 1.05.999-.05Zm2.863 0 .997-.08-.074-.92h-.923v1Zm.773 1.943-.768.64.004.005.764-.645Zm1.784 1.25-.373.928.373-.928Zm6.92-1.534-.816-.578.816.578Zm.023-4.42-.84.54.002.005.838-.546Zm-1.863-1.546-.414.91.414-.91Zm-4.864-.557h-1v1h1v-1Zm0-2.5v-1h-1v1h1Zm4.295-.5-.427-.904-.004.002.431.902Zm1.648-1.409-.834-.552-.004.007.838.545Zm.08-4.193.858-.513-.858.513Zm-1.478-1.364-.46.888.005.002.455-.89Zm-4.5-.045.379.925.005-.002-.384-.923Zm-1.727 1.261.774.634.004-.005-.778-.629Zm-.727 1.977v1h.952l.047-.95-1-.05Zm-2.727 0-1-.037-.038 1.037h1.038v-1Zm1.102-3.204.8.601.001-.003-.801-.598Zm2.704-2.16-.417-.908-.002.001.42.908Zm7.398.103-.493.87.005.003.488-.873Zm2.375 2.284-.863.505.863-.505Zm-.204 6.42-.802-.597-.003.004.805.594Zm-2.785 1.921-.29-.957-.71.215v.742h1Zm0 .182h-1v.849l.838.138.162-.987Zm3.444 1.875-.774.634.003.003.77-.637Zm.204 7.125-.825-.565-.001.002.826.563Zm-2.795 2.364.438.898-.438-.898Zm-4.034-.137c-1.385 0-2.582-.237-3.61-.688l-.803 1.831c1.32.58 2.798.857 4.413.857v-2Zm-3.608-.687c-1.028-.454-1.813-1.07-2.389-1.834l-1.598 1.202c.803 1.068 1.874 1.885 3.18 2.461l.807-1.83Zm-2.383-1.827c-.558-.756-.868-1.636-.92-2.672l-1.997.1c.07 1.403.501 2.667 1.308 3.76l1.609-1.188Zm-1.918-1.622h2.863v-2h-2.863v2Zm1.867-.92c.076.943.406 1.79 1 2.503l1.537-1.28c-.314-.377-.499-.826-.544-1.384l-1.993.161Zm1.005 2.508c.572.678 1.308 1.184 2.175 1.533l.746-1.856c-.603-.242-1.056-.569-1.393-.968l-1.528 1.291Zm2.175 1.533c.868.349 1.81.515 2.816.515v-2c-.782 0-1.468-.129-2.07-.37l-.746 1.855Zm2.816.515c1.117 0 2.147-.195 3.07-.611l-.822-1.823c-.622.28-1.364.434-2.248.434v2Zm3.07-.611c.917-.413 1.67-1.006 2.224-1.789l-1.633-1.155c-.325.46-.784.837-1.413 1.12l.822 1.824Zm2.224-1.789c.568-.803.843-1.728.843-2.736h-2c0 .628-.165 1.142-.476 1.581l1.633 1.155Zm.843-2.736c0-1.03-.258-1.977-.799-2.807l-1.676 1.091c.308.473.475 1.033.475 1.716h2Zm-.796-2.803c-.543-.843-1.324-1.476-2.291-1.915l-.827 1.822c.67.303 1.13.701 1.436 1.176l1.682-1.083Zm-2.291-1.915c-.982-.445-2.132-.646-3.413-.646v2c1.082 0 1.932.17 2.586.468l.827-1.822Zm-3.413-.646H81.46v2h1.864v-2Zm-.864 1v-2.5h-2v2.5h2Zm-1-1.5h1.864v-2H81.46v2Zm1.864 0c1.044 0 2.007-.188 2.863-.598l-.863-1.804c-.538.258-1.197.402-2 .402v2Zm2.86-.596c.858-.406 1.555-.994 2.058-1.768l-1.677-1.09c-.285.439-.687.79-1.237 1.05l.855 1.808Zm2.053-1.76c.523-.79.768-1.7.768-2.69h-2c0 .648-.156 1.163-.436 1.585l1.668 1.104Zm.768-2.69c0-.938-.209-1.807-.664-2.569l-1.717 1.026c.242.405.381.907.381 1.544h2Zm-.664-2.569a4.575 4.575 0 0 0-1.88-1.74l-.911 1.78c.478.244.827.572 1.074.986l1.717-1.026Zm-1.876-1.739c-.797-.413-1.704-.6-2.687-.6v2c.73 0 1.308.138 1.767.376l.92-1.776Zm-2.687-.6a6.87 6.87 0 0 0-2.656.52l.767 1.846a4.87 4.87 0 0 1 1.89-.366v-2Zm-2.65.517A5.232 5.232 0 0 0 79 46.94l1.556 1.257a3.234 3.234 0 0 1 1.328-.965l-.757-1.85Zm-2.123 1.553c-.596.728-.906 1.598-.953 2.563l1.998.097c.028-.58.204-1.029.502-1.392l-1.547-1.268Zm.046 1.611h-2.727v2h2.727v-2Zm-1.728 1.038c.038-1.03.343-1.898.902-2.641l-1.598-1.202c-.82 1.09-1.25 2.358-1.303 3.768l1.999.075Zm.904-2.644c.584-.782 1.35-1.4 2.323-1.85l-.84-1.815c-1.254.58-2.29 1.403-3.086 2.469l1.603 1.196Zm2.32-1.849c.98-.45 2.067-.68 3.277-.68v-2c-1.473 0-2.848.283-4.111.863l.835 1.817Zm3.277-.68c1.303 0 2.36.263 3.211.744l.986-1.74c-1.21-.685-2.622-1.005-4.197-1.005v2Zm3.216.747c.887.496 1.544 1.135 2 1.916l1.727-1.01c-.65-1.112-1.577-1.996-2.751-2.652l-.976 1.746Zm2 1.916a4.98 4.98 0 0 1 .693 2.563h2a6.98 6.98 0 0 0-.966-3.572l-1.727 1.008Zm.693 2.563c0 1.126-.293 2.026-.836 2.755l1.603 1.196c.836-1.12 1.233-2.455 1.233-3.95h-2Zm-.84 2.759c-.544.739-1.286 1.259-2.269 1.557l.58 1.914c1.366-.414 2.48-1.174 3.3-2.284l-1.61-1.187Zm-2.979 2.514v.182h2v-.182h-2Zm.838 1.169c1.266.208 2.182.729 2.832 1.522l1.547-1.268c-1.002-1.222-2.381-1.952-4.054-2.228l-.325 1.974Zm2.835 1.525c.657.796 1.01 1.8 1.01 3.079h2c0-1.676-.474-3.149-1.468-4.353l-1.542 1.274Zm1.01 3.079c0 1.071-.289 2.01-.86 2.844l1.65 1.13c.808-1.18 1.21-2.515 1.21-3.974h-2Zm-.861 2.846c-.575.844-1.368 1.521-2.407 2.028l.876 1.797c1.324-.645 2.395-1.543 3.183-2.699l-1.652-1.126Zm-2.407 2.028c-1.027.5-2.218.762-3.596.762v2c1.637 0 3.135-.313 4.472-.965l-.876-1.797Z"
}, null, -1), gm = [
  hm,
  dm
];
function mL(t, e) {
  return T(), B("svg", um, gm);
}
const fm = { render: mL }, pm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: fm,
  render: mL
}, Symbol.toStringTag, { value: "Module" })), mm = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}, wm = /* @__PURE__ */ _("circle", {
  cx: "12",
  cy: "12",
  r: "7",
  stroke: "currentColor",
  "stroke-dasharray": "3 2",
  "stroke-linecap": "round",
  "stroke-width": "1.5"
}, null, -1), xm = [
  wm
];
function wL(t, e) {
  return T(), B("svg", mm, xm);
}
const _m = { render: wL }, vm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: _m,
  render: wL
}, Symbol.toStringTag, { value: "Module" })), Mm = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}, Rm = /* @__PURE__ */ _("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M5 10h14M5 14h14"
}, null, -1), ym = [
  Rm
];
function xL(t, e) {
  return T(), B("svg", Mm, ym);
}
const Am = { render: xL }, Zm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Am,
  render: xL
}, Symbol.toStringTag, { value: "Module" })), km = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  viewBox: "0 0 214.27 214.27"
}, Tm = /* @__PURE__ */ _("path", { d: "M196.926 55.171c-.11-5.785-.215-11.25-.215-16.537a7.5 7.5 0 0 0-7.5-7.5c-32.075 0-56.496-9.218-76.852-29.01a7.498 7.498 0 0 0-10.457 0c-20.354 19.792-44.771 29.01-76.844 29.01a7.5 7.5 0 0 0-7.5 7.5c0 5.288-.104 10.755-.215 16.541-1.028 53.836-2.436 127.567 87.331 158.682a7.495 7.495 0 0 0 4.912 0c89.774-31.116 88.368-104.849 87.34-158.686zm-89.795 143.641c-76.987-27.967-75.823-89.232-74.79-143.351.062-3.248.122-6.396.164-9.482 30.04-1.268 54.062-10.371 74.626-28.285 20.566 17.914 44.592 27.018 74.634 28.285.042 3.085.102 6.231.164 9.477 1.032 54.121 2.195 115.388-74.798 143.356z" }, null, -1), Sm = /* @__PURE__ */ _("path", { d: "m132.958 81.082-36.199 36.197-15.447-15.447a7.501 7.501 0 0 0-10.606 10.607l20.75 20.75a7.477 7.477 0 0 0 5.303 2.196 7.477 7.477 0 0 0 5.303-2.196l41.501-41.5a7.498 7.498 0 0 0 .001-10.606 7.5 7.5 0 0 0-10.606-.001z" }, null, -1), bm = [
  Tm,
  Sm
];
function _L(t, e) {
  return T(), B("svg", km, bm);
}
const Em = { render: _L }, Im = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Em,
  render: _L
}, Symbol.toStringTag, { value: "Module" })), Fm = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}, Om = /* @__PURE__ */ _("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M10 6h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-8M10 6l-4 6 4 6"
}, null, -1), Nm = [
  Om
];
function vL(t, e) {
  return T(), B("svg", Fm, Nm);
}
const Dm = { render: vL }, Pm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Dm,
  render: vL
}, Symbol.toStringTag, { value: "Module" })), Bm = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 15 15"
}, zm = /* @__PURE__ */ _("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M2 1.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0ZM2 5v5h11V5H2Zm0-1a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H2Zm-.5 10a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1ZM4 1.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0ZM3.5 14a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1ZM6 1.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0ZM5.5 14a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1ZM8 1.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0ZM7.5 14a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1ZM10 1.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0ZM9.5 14a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1ZM12 1.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0ZM11.5 14a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1ZM14 1.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0ZM13.5 14a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z",
  "clip-rule": "evenodd"
}, null, -1), Um = [
  zm
];
function ML(t, e) {
  return T(), B("svg", Bm, Um);
}
const Wm = { render: ML }, Hm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Wm,
  render: ML
}, Symbol.toStringTag, { value: "Module" })), $m = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  fill: "none",
  viewBox: "0 0 20 20"
}, Vm = /* @__PURE__ */ _("circle", {
  cx: "10",
  cy: "10",
  r: "10",
  fill: "#4f8cf7",
  "fill-opacity": ".2",
  class: "text-base"
}, null, -1), Gm = /* @__PURE__ */ _("path", {
  stroke: "#4f8cf7",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "m6 10 3 3 5-5"
}, null, -1), jm = [
  Vm,
  Gm
];
function RL(t, e) {
  return T(), B("svg", $m, jm);
}
const qm = { render: RL }, Km = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: qm,
  render: RL
}, Symbol.toStringTag, { value: "Module" })), Ym = {
  xmlns: "http://www.w3.org/2000/svg",
  class: "grayscale h-4 w-4",
  viewBox: "0 0 1024 1024"
}, Qm = /* @__PURE__ */ _("path", {
  fill: "currentColor",
  d: "M42.667 512C42.667 251.733 251.733 42.667 512 42.667s469.333 187.733 469.333 422.4c0 72.533-29.866 145.066-81.066 200.533-51.2 51.2-123.734 81.067-200.534 81.067H614.4c-12.8 0-25.6 12.8-29.867 25.6 0 8.533 4.267 17.066 8.534 21.333 21.333 21.333 29.866 46.933 29.866 76.8 0 64-51.2 110.933-115.2 115.2-256-4.267-465.066-213.333-465.066-473.6zM128 512c0 213.333 170.667 384 384 384 17.067 0 29.867-12.8 29.867-29.867 0-4.266 0-8.533-4.267-12.8l-4.267-4.266c-17.066-21.334-25.6-46.934-29.866-76.8 0-64 51.2-110.934 115.2-110.934H704c51.2 0 102.4-21.333 136.533-55.466 38.4-38.4 55.467-85.334 55.467-136.534C896 281.6 725.333 128 512 128S128 298.667 128 512zm593.067 21.333c-21.334-21.333-25.6-51.2-17.067-76.8 12.8-25.6 38.4-42.666 64-42.666 38.4 0 68.267 34.133 72.533 72.533 0 29.867-17.066 55.467-42.666 64-8.534 4.267-17.067 4.267-25.6 4.267-17.067 0-38.4-8.534-51.2-21.334zm-520.534 0c-21.333-21.333-25.6-51.2-17.066-76.8 12.8-25.6 38.4-42.666 64-42.666 38.4 0 68.266 34.133 72.533 72.533 0 29.867-17.067 55.467-42.667 64-8.533 4.267-17.066 4.267-25.6 4.267-21.333 0-38.4-8.534-51.2-21.334zM580.267 345.6c-21.334-21.333-25.6-51.2-17.067-76.8 12.8-25.6 38.4-42.667 64-42.667 38.4 0 68.267 34.134 72.533 72.534 0 29.866-17.066 55.466-42.666 64-8.534 4.266-17.067 4.266-25.6 4.266-21.334 0-38.4-8.533-51.2-21.333zm-238.934 0c-17.066-21.333-25.6-51.2-12.8-76.8 12.8-25.6 38.4-42.667 64-42.667 38.4 0 68.267 34.134 72.534 72.534 0 29.866-17.067 55.466-42.667 64l-29.867 4.266c-17.066 0-34.133-8.533-51.2-21.333z"
}, null, -1), Xm = [
  Qm
];
function yL(t, e) {
  return T(), B("svg", Ym, Xm);
}
const Jm = { render: yL }, ew = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Jm,
  render: yL
}, Symbol.toStringTag, { value: "Module" })), tw = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024"
}, nw = /* @__PURE__ */ _("path", {
  fill: "currentColor",
  d: "M512 1024C229.248 1024 0 794.752 0 512S229.248 0 512 0s512 229.248 512 512-229.248 512-512 512zm0-938.667C276.352 85.333 85.333 276.352 85.333 512S276.352 938.667 512 938.667 938.667 747.648 938.667 512A426.667 426.667 0 0 0 512 85.333zM512 768a42.667 42.667 0 0 1-42.368-42.667V469.76a42.368 42.368 0 1 1 84.693 0v255.573A42.41 42.41 0 0 1 512 768zm0-426.667a42.325 42.325 0 1 1-.085-84.65 42.325 42.325 0 0 1 .085 84.65zm42.325-42.666z"
}, null, -1), iw = [
  nw
];
function AL(t, e) {
  return T(), B("svg", tw, iw);
}
const sw = { render: AL }, rw = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: sw,
  render: AL
}, Symbol.toStringTag, { value: "Module" })), ow = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  width: "24",
  height: "24",
  baseProfile: "full",
  viewBox: "0 0 76 76"
}, lw = /* @__PURE__ */ _("path", {
  fill: "currentColor",
  d: "M26 22h1v5h-1a5 5 0 0 0-5 5v14a5 5 0 0 0 5 5h1v-4l6.75 6.5L27 60v-4h-1c-5.523 0-10-4.477-10-10V32c0-5.523 4.477-10 10-10Zm7 5h26v5H33v-5Zm3 8h23v5H36v-5Zm-3 8h26v5H33v-5Z"
}, null, -1), Lw = [
  lw
];
function ZL(t, e) {
  return T(), B("svg", ow, Lw);
}
const aw = { render: ZL }, Cw = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: aw,
  render: ZL
}, Symbol.toStringTag, { value: "Module" })), cw = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024"
}, uw = /* @__PURE__ */ _("path", {
  fill: "currentColor",
  d: "M945.067 898.133 755.2 708.267c55.467-64 87.467-149.334 87.467-241.067 0-204.8-168.534-373.333-373.334-373.333S96 264.533 96 469.333s168.533 373.334 373.333 373.334c91.734 0 174.934-34.134 241.067-87.467l189.867 189.867c6.4 6.4 14.933 8.533 23.466 8.533s17.067-2.133 23.467-8.533c8.533-12.8 8.533-34.134-2.133-46.934zM469.333 778.667C298.667 778.667 160 640 160 469.333S298.667 160 469.333 160s309.334 138.667 309.334 309.333S640 778.667 469.333 778.667z"
}, null, -1), hw = /* @__PURE__ */ _("path", {
  fill: "currentColor",
  d: "M597.333 437.333h-96v-96c0-17.066-14.933-32-32-32s-32 14.934-32 32v96h-96c-17.066 0-32 14.934-32 32s14.934 32 32 32h96v96c0 17.067 14.934 32 32 32s32-14.933 32-32v-96h96c17.067 0 32-14.933 32-32s-14.933-32-32-32z"
}, null, -1), dw = [
  uw,
  hw
];
function kL(t, e) {
  return T(), B("svg", cw, dw);
}
const gw = { render: kL }, fw = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: gw,
  render: kL
}, Symbol.toStringTag, { value: "Module" })), pw = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024"
}, mw = /* @__PURE__ */ _("path", {
  fill: "currentColor",
  d: "M637 443H325c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h312c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z"
}, null, -1), ww = /* @__PURE__ */ _("path", {
  fill: "currentColor",
  d: "M921 867 775 721c122.1-148.9 113.6-369.5-26-509-148-148.1-388.4-148.1-537 0-148.1 148.6-148.1 389 0 537 139.5 139.6 360.1 148.1 509 26l146 146c3.2 2.8 8.3 2.8 11 0l43-43c2.8-2.7 2.8-7.8 0-11zM696 696c-118.8 118.7-311.2 118.7-430 0-118.7-118.8-118.7-311.2 0-430 118.8-118.7 311.2-118.7 430 0 118.7 118.8 118.7 311.2 0 430z"
}, null, -1), xw = [
  mw,
  ww
];
function TL(t, e) {
  return T(), B("svg", pw, xw);
}
const _w = { render: TL }, vw = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: _w,
  render: TL
}, Symbol.toStringTag, { value: "Module" })), q1 = {
  __name: "Icon",
  props: {
    name: {
      type: String,
      required: !0
    },
    iconClass: {
      type: String,
      required: !1
    }
  },
  setup(t) {
    const e = t, n = /* @__PURE__ */ Object.assign({ "./icons/alt-fragment.svg": _p, "./icons/close.svg": Ap, "./icons/collapse-expanded.svg": bp, "./icons/collapse-unexpanded.svg": Np, "./icons/critical-fragment.svg": Up, "./icons/debug.svg": Kp, "./icons/loop-fragment.svg": em, "./icons/message-arrow.svg": om, "./icons/non-selected-cycle.svg": cm, "./icons/numbering.svg": pm, "./icons/opt-fragment.svg": vm, "./icons/par-fragment.svg": Zm, "./icons/privacy.svg": Im, "./icons/ref-fragment.svg": Pm, "./icons/section-fragment.svg": Hm, "./icons/selected-cycle.svg": Km, "./icons/theme.svg": ew, "./icons/tip.svg": rw, "./icons/try-catch-fragment.svg": Cw, "./icons/zoom-in.svg": fw, "./icons/zoom-out.svg": vw }), i = I(() => {
      var r;
      const s = `./icons/${e.name}.svg`;
      return (r = n[s]) == null ? void 0 : r.default;
    });
    return (s, r) => (T(), B("span", {
      class: v2(["flex items-center justify-center", t.iconClass]),
      onClick: r[0] || (r[0] = (o) => s.$emit("icon-click"))
    }, [
      (T(), T2(B8(O(i))))
    ], 2));
  }
};
const K2 = (t, e) => {
  const n = t.__vccOpts || t;
  for (const [i, s] of e)
    n[i] = s;
  return n;
}, Mw = {
  name: "Privacy",
  components: { Icon: q1 }
}, Rw = {
  class: "privacy tooltip bottom whitespace-normal flex items-center",
  "data-tooltip": "We (the vendor) do not have access to your data. The diagram is generated in this browser."
};
function yw(t, e, n, i, s, r) {
  const o = i2("Icon");
  return T(), B("div", null, [
    _("div", Rw, [
      N(o, {
        name: "privacy",
        "icon-class": "fill-current h-6 w-6 m-auto"
      })
    ])
  ]);
}
const Aw = /* @__PURE__ */ K2(Mw, [["render", yw], ["__scopeId", "data-v-3e7c8bd7"]]), Zw = {
  name: "DiagramTitle",
  props: ["context"],
  computed: {
    title: function() {
      var t;
      return (t = this.context) == null ? void 0 : t.content();
    }
  }
}, kw = { class: "title text-skin-title text-base font-semibold" };
function Tw(t, e, n, i, s, r) {
  return T(), B("div", kw, m1(r.title), 1);
}
const Sw = /* @__PURE__ */ K2(Zw, [["render", Tw]]);
class bw {
  constructor() {
    this.events = {};
  }
  on(e, n) {
    this.events[e] || (this.events[e] = /* @__PURE__ */ new Set()), console.debug(`Event ${e} ${n} added`), console.debug(this.events), this.events[e].add(n);
  }
  off(e, n) {
    var i;
    console.debug(`Event ${e} ${n} removed`), console.debug(this.events), (i = this.events[e]) == null || i.delete(n);
  }
  emit(e, n) {
    const i = this.events[e];
    i && i.forEach((s) => s(n));
  }
}
const d7 = new bw();
function Ew(t, e, n, i) {
  const s = { label: JSON.stringify(e), action: n, category: i };
  t.commit("eventEmit", { event: "trackEvent", data: s }), d7.emit("trackEvent", s);
}
var SL = { exports: {} }, Iw = {
  aliceblue: [240, 248, 255],
  antiquewhite: [250, 235, 215],
  aqua: [0, 255, 255],
  aquamarine: [127, 255, 212],
  azure: [240, 255, 255],
  beige: [245, 245, 220],
  bisque: [255, 228, 196],
  black: [0, 0, 0],
  blanchedalmond: [255, 235, 205],
  blue: [0, 0, 255],
  blueviolet: [138, 43, 226],
  brown: [165, 42, 42],
  burlywood: [222, 184, 135],
  cadetblue: [95, 158, 160],
  chartreuse: [127, 255, 0],
  chocolate: [210, 105, 30],
  coral: [255, 127, 80],
  cornflowerblue: [100, 149, 237],
  cornsilk: [255, 248, 220],
  crimson: [220, 20, 60],
  cyan: [0, 255, 255],
  darkblue: [0, 0, 139],
  darkcyan: [0, 139, 139],
  darkgoldenrod: [184, 134, 11],
  darkgray: [169, 169, 169],
  darkgreen: [0, 100, 0],
  darkgrey: [169, 169, 169],
  darkkhaki: [189, 183, 107],
  darkmagenta: [139, 0, 139],
  darkolivegreen: [85, 107, 47],
  darkorange: [255, 140, 0],
  darkorchid: [153, 50, 204],
  darkred: [139, 0, 0],
  darksalmon: [233, 150, 122],
  darkseagreen: [143, 188, 143],
  darkslateblue: [72, 61, 139],
  darkslategray: [47, 79, 79],
  darkslategrey: [47, 79, 79],
  darkturquoise: [0, 206, 209],
  darkviolet: [148, 0, 211],
  deeppink: [255, 20, 147],
  deepskyblue: [0, 191, 255],
  dimgray: [105, 105, 105],
  dimgrey: [105, 105, 105],
  dodgerblue: [30, 144, 255],
  firebrick: [178, 34, 34],
  floralwhite: [255, 250, 240],
  forestgreen: [34, 139, 34],
  fuchsia: [255, 0, 255],
  gainsboro: [220, 220, 220],
  ghostwhite: [248, 248, 255],
  gold: [255, 215, 0],
  goldenrod: [218, 165, 32],
  gray: [128, 128, 128],
  green: [0, 128, 0],
  greenyellow: [173, 255, 47],
  grey: [128, 128, 128],
  honeydew: [240, 255, 240],
  hotpink: [255, 105, 180],
  indianred: [205, 92, 92],
  indigo: [75, 0, 130],
  ivory: [255, 255, 240],
  khaki: [240, 230, 140],
  lavender: [230, 230, 250],
  lavenderblush: [255, 240, 245],
  lawngreen: [124, 252, 0],
  lemonchiffon: [255, 250, 205],
  lightblue: [173, 216, 230],
  lightcoral: [240, 128, 128],
  lightcyan: [224, 255, 255],
  lightgoldenrodyellow: [250, 250, 210],
  lightgray: [211, 211, 211],
  lightgreen: [144, 238, 144],
  lightgrey: [211, 211, 211],
  lightpink: [255, 182, 193],
  lightsalmon: [255, 160, 122],
  lightseagreen: [32, 178, 170],
  lightskyblue: [135, 206, 250],
  lightslategray: [119, 136, 153],
  lightslategrey: [119, 136, 153],
  lightsteelblue: [176, 196, 222],
  lightyellow: [255, 255, 224],
  lime: [0, 255, 0],
  limegreen: [50, 205, 50],
  linen: [250, 240, 230],
  magenta: [255, 0, 255],
  maroon: [128, 0, 0],
  mediumaquamarine: [102, 205, 170],
  mediumblue: [0, 0, 205],
  mediumorchid: [186, 85, 211],
  mediumpurple: [147, 112, 219],
  mediumseagreen: [60, 179, 113],
  mediumslateblue: [123, 104, 238],
  mediumspringgreen: [0, 250, 154],
  mediumturquoise: [72, 209, 204],
  mediumvioletred: [199, 21, 133],
  midnightblue: [25, 25, 112],
  mintcream: [245, 255, 250],
  mistyrose: [255, 228, 225],
  moccasin: [255, 228, 181],
  navajowhite: [255, 222, 173],
  navy: [0, 0, 128],
  oldlace: [253, 245, 230],
  olive: [128, 128, 0],
  olivedrab: [107, 142, 35],
  orange: [255, 165, 0],
  orangered: [255, 69, 0],
  orchid: [218, 112, 214],
  palegoldenrod: [238, 232, 170],
  palegreen: [152, 251, 152],
  paleturquoise: [175, 238, 238],
  palevioletred: [219, 112, 147],
  papayawhip: [255, 239, 213],
  peachpuff: [255, 218, 185],
  peru: [205, 133, 63],
  pink: [255, 192, 203],
  plum: [221, 160, 221],
  powderblue: [176, 224, 230],
  purple: [128, 0, 128],
  rebeccapurple: [102, 51, 153],
  red: [255, 0, 0],
  rosybrown: [188, 143, 143],
  royalblue: [65, 105, 225],
  saddlebrown: [139, 69, 19],
  salmon: [250, 128, 114],
  sandybrown: [244, 164, 96],
  seagreen: [46, 139, 87],
  seashell: [255, 245, 238],
  sienna: [160, 82, 45],
  silver: [192, 192, 192],
  skyblue: [135, 206, 235],
  slateblue: [106, 90, 205],
  slategray: [112, 128, 144],
  slategrey: [112, 128, 144],
  snow: [255, 250, 250],
  springgreen: [0, 255, 127],
  steelblue: [70, 130, 180],
  tan: [210, 180, 140],
  teal: [0, 128, 128],
  thistle: [216, 191, 216],
  tomato: [255, 99, 71],
  turquoise: [64, 224, 208],
  violet: [238, 130, 238],
  wheat: [245, 222, 179],
  white: [255, 255, 255],
  whitesmoke: [245, 245, 245],
  yellow: [255, 255, 0],
  yellowgreen: [154, 205, 50]
}, bL = { exports: {} }, Fw = function(e) {
  return !e || typeof e == "string" ? !1 : e instanceof Array || Array.isArray(e) || e.length >= 0 && (e.splice instanceof Function || Object.getOwnPropertyDescriptor(e, e.length - 1) && e.constructor.name !== "String");
}, Ow = Fw, Nw = Array.prototype.concat, Dw = Array.prototype.slice, Oi = bL.exports = function(e) {
  for (var n = [], i = 0, s = e.length; i < s; i++) {
    var r = e[i];
    Ow(r) ? n = Nw.call(n, Dw.call(r)) : n.push(r);
  }
  return n;
};
Oi.wrap = function(t) {
  return function() {
    return t(Oi(arguments));
  };
};
var Pw = bL.exports, Y5 = Iw, u5 = Pw, EL = {};
for (var U7 in Y5)
  Y5.hasOwnProperty(U7) && (EL[Y5[U7]] = U7);
var p3 = SL.exports = {
  to: {},
  get: {}
};
p3.get = function(t) {
  var e = t.substring(0, 3).toLowerCase(), n, i;
  switch (e) {
    case "hsl":
      n = p3.get.hsl(t), i = "hsl";
      break;
    case "hwb":
      n = p3.get.hwb(t), i = "hwb";
      break;
    default:
      n = p3.get.rgb(t), i = "rgb";
      break;
  }
  return n ? { model: i, value: n } : null;
};
p3.get.rgb = function(t) {
  if (!t)
    return null;
  var e = /^#([a-f0-9]{3,4})$/i, n = /^#([a-f0-9]{6})([a-f0-9]{2})?$/i, i = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/, s = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/, r = /(\D+)/, o = [0, 0, 0, 1], l, L, a;
  if (l = t.match(n)) {
    for (a = l[2], l = l[1], L = 0; L < 3; L++) {
      var C = L * 2;
      o[L] = parseInt(l.slice(C, C + 2), 16);
    }
    a && (o[3] = parseInt(a, 16) / 255);
  } else if (l = t.match(e)) {
    for (l = l[1], a = l[3], L = 0; L < 3; L++)
      o[L] = parseInt(l[L] + l[L], 16);
    a && (o[3] = parseInt(a + a, 16) / 255);
  } else if (l = t.match(i)) {
    for (L = 0; L < 3; L++)
      o[L] = parseInt(l[L + 1], 0);
    l[4] && (o[3] = parseFloat(l[4]));
  } else if (l = t.match(s)) {
    for (L = 0; L < 3; L++)
      o[L] = Math.round(parseFloat(l[L + 1]) * 2.55);
    l[4] && (o[3] = parseFloat(l[4]));
  } else
    return (l = t.match(r)) ? l[1] === "transparent" ? [0, 0, 0, 0] : (o = Y5[l[1]], o ? (o[3] = 1, o) : null) : null;
  for (L = 0; L < 3; L++)
    o[L] = N4(o[L], 0, 255);
  return o[3] = N4(o[3], 0, 1), o;
};
p3.get.hsl = function(t) {
  if (!t)
    return null;
  var e = /^hsla?\(\s*([+-]?(?:\d{0,3}\.)?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/, n = t.match(e);
  if (n) {
    var i = parseFloat(n[4]), s = (parseFloat(n[1]) + 360) % 360, r = N4(parseFloat(n[2]), 0, 100), o = N4(parseFloat(n[3]), 0, 100), l = N4(isNaN(i) ? 1 : i, 0, 1);
    return [s, r, o, l];
  }
  return null;
};
p3.get.hwb = function(t) {
  if (!t)
    return null;
  var e = /^hwb\(\s*([+-]?\d{0,3}(?:\.\d+)?)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/, n = t.match(e);
  if (n) {
    var i = parseFloat(n[4]), s = (parseFloat(n[1]) % 360 + 360) % 360, r = N4(parseFloat(n[2]), 0, 100), o = N4(parseFloat(n[3]), 0, 100), l = N4(isNaN(i) ? 1 : i, 0, 1);
    return [s, r, o, l];
  }
  return null;
};
p3.to.hex = function() {
  var t = u5(arguments);
  return "#" + P5(t[0]) + P5(t[1]) + P5(t[2]) + (t[3] < 1 ? P5(Math.round(t[3] * 255)) : "");
};
p3.to.rgb = function() {
  var t = u5(arguments);
  return t.length < 4 || t[3] === 1 ? "rgb(" + Math.round(t[0]) + ", " + Math.round(t[1]) + ", " + Math.round(t[2]) + ")" : "rgba(" + Math.round(t[0]) + ", " + Math.round(t[1]) + ", " + Math.round(t[2]) + ", " + t[3] + ")";
};
p3.to.rgb.percent = function() {
  var t = u5(arguments), e = Math.round(t[0] / 255 * 100), n = Math.round(t[1] / 255 * 100), i = Math.round(t[2] / 255 * 100);
  return t.length < 4 || t[3] === 1 ? "rgb(" + e + "%, " + n + "%, " + i + "%)" : "rgba(" + e + "%, " + n + "%, " + i + "%, " + t[3] + ")";
};
p3.to.hsl = function() {
  var t = u5(arguments);
  return t.length < 4 || t[3] === 1 ? "hsl(" + t[0] + ", " + t[1] + "%, " + t[2] + "%)" : "hsla(" + t[0] + ", " + t[1] + "%, " + t[2] + "%, " + t[3] + ")";
};
p3.to.hwb = function() {
  var t = u5(arguments), e = "";
  return t.length >= 4 && t[3] !== 1 && (e = ", " + t[3]), "hwb(" + t[0] + ", " + t[1] + "%, " + t[2] + "%" + e + ")";
};
p3.to.keyword = function(t) {
  return EL[t.slice(0, 3)];
};
function N4(t, e, n) {
  return Math.min(Math.max(e, t), n);
}
function P5(t) {
  var e = t.toString(16).toUpperCase();
  return e.length < 2 ? "0" + e : e;
}
var Bw = SL.exports;
const IL = /* @__PURE__ */ s4(Bw);
function zw(t) {
  const e = IL.get.rgb(t), [n, i, s] = e;
  return (n * 299 + i * 587 + s * 114) / 1e3;
}
function Uw(t) {
  const e = IL.get.rgb(t), [n, i, s] = e;
  return `rgb(${n}, ${i}, ${s})`;
}
const Ww = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g>
    <path d="M15.5489 4.19771C15.5489 5.18773 15.1485 6.13721 14.4358 6.83726C13.7231 7.53731 12.7565 7.93058 11.7486 7.93058C10.7407 7.93058 9.77403 7.53731 9.06133 6.83726C8.34863 6.13721 7.94824 5.18773 7.94824 4.19771C7.94824 3.20768 8.34863 2.25822 9.06133 1.55818C9.77403 0.858126 10.7407 0.464844 11.7486 0.464844C12.7565 0.464844 13.7231 0.858126 14.4358 1.55818C15.1485 2.25822 15.5489 3.20768 15.5489 4.19771Z" stroke="currentColor"/>
    <path d="M6.54883 11.2152L17.2025 11.2073M11.7471 8.06641V19.5806V8.06641ZM11.7471 19.4385L6.79789 23.5738L11.7471 19.4385ZM11.7551 19.4385L17.1864 23.3055L11.7551 19.4385Z" stroke="currentColor"/>
  </g>
</svg>
`, Hw = `<svg width="101" height="78" viewBox="0 0 101 78" fill="none" xmlns="http://www.w3.org/2000/svg">
	<path d="M96.3563 39.4479C96.3563 48.4904 92.6755 57.1625 86.1237 63.5566C79.5718 69.9506 70.6856 73.5427 61.4199 73.5427C52.1541 73.5427 43.2679 69.9506 36.7161 63.5566C30.1642 57.1625 26.4834 48.4904 26.4834 39.4479C26.4834 30.147 30.1642 21.2271 36.7161 14.6504C43.2679 8.07366 52.1541 4.37891 61.4199 4.37891C70.6856 4.37891 79.5718 8.07366 86.1237 14.6504C92.6755 21.2271 96.3563 30.147 96.3563 39.4479V39.4479Z" stroke="currentColor" stroke-width="4"/>
	<path d="M27.3611 39.4482H3.93945" stroke="currentColor" stroke-width="4"/>
	<path d="M4.91504 4.37891V74.5168" stroke="currentColor" stroke-width="4"/>
</svg>
`, $w = `<svg width="77" height="86" viewBox="0 0 77 86" fill="none" xmlns="http://www.w3.org/2000/svg">
	<g>
		<path d="M74.0149 46.8888C74.0149 51.5755 73.0918 56.2163 71.2983 60.5463C69.5048 64.8762 66.876 68.8105 63.562 72.1245C60.248 75.4385 56.3137 78.0673 51.9838 79.8608C47.6538 81.6543 43.013 82.5774 38.3263 82.5774C33.6396 82.5774 28.9988 81.6543 24.6689 79.8608C20.3389 78.0673 16.4046 75.4385 13.0907 72.1245C9.77666 68.8105 7.14785 64.8762 5.35433 60.5463C3.56081 56.2163 2.6377 51.5755 2.6377 46.8888C2.6377 42.2021 3.56081 37.5613 5.35433 33.2314C7.14785 28.9014 9.77666 24.9671 13.0907 21.6532C16.4046 18.3392 20.3389 15.7104 24.6689 13.9168C28.9988 12.1233 33.6396 11.2002 38.3263 11.2002C43.013 11.2002 47.6538 12.1233 51.9838 13.9168C56.3137 15.7104 60.248 18.3392 63.562 21.6532C66.876 24.9671 69.5048 28.9014 71.2983 33.2314C73.0918 37.5613 74.0149 42.2021 74.0149 46.8888V46.8888Z" stroke="currentColor" stroke-width="4.98203"/>
		<path d="M47.5352 2.30371L37.5352 11.5001L47.5352 20.6966" stroke="currentColor" stroke-width="6"/>
	</g>
</svg>
`, Vw = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M12.258 0.001L12.514 0.005L12.769 0.01L13.022 0.018L13.273 0.028L13.522 0.04L13.769 0.055L14.015 0.071L14.257 0.09L14.498 0.11L14.737 0.133L14.973 0.157L15.206 0.184L15.437 0.212L15.666 0.243L15.891 0.275L16.114 0.309L16.334 0.345L16.551 0.383L16.765 0.423L16.976 0.464L17.184 0.507L17.389 0.552L17.59 0.598L17.788 0.646L17.982 0.696L18.173 0.747L18.36 0.8L18.543 0.854L18.723 0.91L18.898 0.967L19.07 1.026L19.238 1.086L19.401 1.147L19.561 1.21L19.716 1.274L19.866 1.34L19.94 1.373L20.013 1.406L20.084 1.44L20.154 1.474L20.223 1.509L20.291 1.544L20.358 1.579L20.424 1.614L20.488 1.65L20.552 1.686L20.614 1.722L20.674 1.758L20.734 1.795L20.792 1.832L20.85 1.869L20.905 1.907L20.96 1.945L21.013 1.983L21.065 2.021L21.116 2.06L21.166 2.099L21.214 2.138L21.261 2.177L21.306 2.217L21.35 2.257L21.393 2.297L21.434 2.337L21.474 2.378L21.513 2.419L21.55 2.46L21.586 2.501L21.62 2.542L21.653 2.584L21.685 2.626L21.715 2.668L21.744 2.71L21.771 2.752L21.797 2.795L21.821 2.838L21.844 2.881L21.865 2.924L21.885 2.967L21.903 3.011L21.92 3.054L21.935 3.098L21.948 3.142L21.96 3.186L21.971 3.231L21.98 3.275L21.987 3.32L21.993 3.365L21.997 3.41L21.999 3.455L22 3.5V20.5L21.999 20.545L21.997 20.59L21.993 20.635L21.987 20.68L21.98 20.725L21.971 20.769L21.96 20.814L21.948 20.858L21.935 20.902L21.92 20.946L21.903 20.989L21.885 21.033L21.865 21.076L21.844 21.119L21.821 21.162L21.797 21.205L21.771 21.248L21.744 21.29L21.715 21.332L21.685 21.374L21.653 21.416L21.62 21.458L21.586 21.499L21.55 21.54L21.513 21.581L21.474 21.622L21.434 21.663L21.393 21.703L21.35 21.743L21.306 21.783L21.261 21.823L21.214 21.862L21.166 21.901L21.116 21.94L21.065 21.979L21.013 22.017L20.96 22.055L20.905 22.093L20.85 22.131L20.792 22.168L20.734 22.205L20.674 22.242L20.614 22.278L20.552 22.314L20.488 22.35L20.424 22.386L20.358 22.421L20.291 22.456L20.223 22.491L20.154 22.526L20.084 22.56L20.013 22.594L19.94 22.627L19.866 22.66L19.716 22.726L19.561 22.79L19.401 22.853L19.238 22.914L19.07 22.974L18.898 23.033L18.723 23.09L18.543 23.146L18.36 23.2L18.173 23.253L17.982 23.304L17.788 23.354L17.59 23.402L17.389 23.448L17.184 23.493L16.976 23.536L16.765 23.577L16.551 23.617L16.334 23.655L16.114 23.691L15.891 23.725L15.666 23.757L15.437 23.788L15.206 23.816L14.973 23.843L14.737 23.867L14.498 23.89L14.257 23.91L14.015 23.929L13.769 23.945L13.522 23.96L13.273 23.972L13.022 23.982L12.769 23.99L12.514 23.995L12.258 23.999L12 24L11.742 23.999L11.486 23.995L11.231 23.99L10.978 23.982L10.727 23.972L10.478 23.96L10.231 23.945L9.986 23.929L9.743 23.91L9.502 23.89L9.264 23.867L9.028 23.843L8.794 23.816L8.563 23.788L8.335 23.757L8.109 23.725L7.886 23.691L7.666 23.655L7.449 23.617L7.235 23.577L7.024 23.536L6.816 23.493L6.612 23.448L6.411 23.402L6.213 23.354L6.018 23.304L5.828 23.253L5.641 23.2L5.457 23.146L5.278 23.09L5.102 23.033L4.93 22.974L4.763 22.914L4.599 22.853L4.44 22.79L4.285 22.726L4.134 22.66L4.06 22.627L3.988 22.594L3.916 22.56L3.846 22.526L3.777 22.491L3.709 22.456L3.642 22.421L3.576 22.386L3.512 22.35L3.449 22.314L3.387 22.278L3.326 22.242L3.266 22.205L3.208 22.168L3.151 22.131L3.095 22.093L3.04 22.055L2.987 22.017L2.935 21.979L2.884 21.94L2.835 21.901L2.786 21.862L2.74 21.823L2.694 21.783L2.65 21.743L2.607 21.703L2.566 21.663L2.526 21.622L2.487 21.581L2.45 21.54L2.414 21.499L2.38 21.458L2.347 21.416L2.315 21.374L2.285 21.332L2.256 21.29L2.229 21.248L2.203 21.205L2.179 21.162L2.156 21.119L2.135 21.076L2.115 21.033L2.097 20.989L2.08 20.946L2.065 20.902L2.052 20.858L2.04 20.814L2.029 20.769L2.02 20.725L2.013 20.68L2.007 20.635L2.003 20.59L2.001 20.545L2 20.5V3.5L2.001 3.455L2.003 3.41L2.007 3.365L2.013 3.32L2.02 3.275L2.029 3.231L2.04 3.186L2.052 3.142L2.065 3.098L2.08 3.054L2.097 3.011L2.115 2.967L2.135 2.924L2.156 2.881L2.179 2.838L2.203 2.795L2.229 2.752L2.256 2.71L2.285 2.668L2.315 2.626L2.347 2.584L2.38 2.542L2.414 2.501L2.45 2.46L2.487 2.419L2.526 2.378L2.566 2.337L2.607 2.297L2.65 2.257L2.694 2.217L2.74 2.177L2.786 2.138L2.835 2.099L2.884 2.06L2.935 2.021L2.987 1.983L3.04 1.945L3.095 1.907L3.151 1.869L3.208 1.832L3.266 1.795L3.326 1.758L3.387 1.722L3.449 1.686L3.512 1.65L3.576 1.614L3.642 1.579L3.709 1.544L3.777 1.509L3.846 1.474L3.916 1.44L3.988 1.406L4.06 1.373L4.134 1.34L4.285 1.274L4.44 1.21L4.599 1.147L4.763 1.086L4.93 1.026L5.102 0.967L5.278 0.91L5.457 0.854L5.641 0.8L5.828 0.747L6.018 0.696L6.213 0.646L6.411 0.598L6.612 0.552L6.816 0.507L7.024 0.464L7.235 0.423L7.449 0.383L7.666 0.345L7.886 0.309L8.109 0.275L8.335 0.243L8.563 0.212L8.794 0.184L9.028 0.157L9.264 0.133L9.502 0.11L9.743 0.09L9.986 0.071L10.231 0.055L10.478 0.04L10.727 0.028L10.978 0.018L11.231 0.01L11.486 0.005L11.742 0.001L12 0L12.258 0.001V0.001ZM3 20.5V20.51L3.001 20.531L3.004 20.552L3.008 20.574L3.013 20.595L3.019 20.617L3.026 20.639L3.035 20.662L3.045 20.684L3.056 20.707L3.068 20.73L3.081 20.753L3.096 20.776L3.112 20.8L3.129 20.823L3.147 20.847L3.166 20.871L3.187 20.895L3.209 20.92L3.232 20.944L3.256 20.969L3.308 21.018L3.364 21.068L3.425 21.119L3.491 21.17L3.561 21.221L3.636 21.272L3.715 21.324L3.799 21.376L3.887 21.428L3.979 21.48L4.076 21.532L4.178 21.583L4.283 21.635L4.393 21.687L4.507 21.738L4.626 21.789L4.749 21.84L4.876 21.89L5.007 21.94L5.142 21.99L5.281 22.038L5.425 22.087L5.572 22.134L5.724 22.181L5.879 22.228L6.039 22.273L6.202 22.318L6.369 22.361L6.54 22.404L6.716 22.445L6.894 22.486L7.077 22.525L7.264 22.564L7.454 22.601L7.648 22.636L7.845 22.671L8.047 22.704L8.251 22.735L8.46 22.765L8.672 22.794L8.888 22.821L9.107 22.846L9.329 22.87L9.555 22.891L9.785 22.911L10.018 22.929L10.254 22.945L10.494 22.96L10.737 22.972L10.983 22.982L11.232 22.99L11.485 22.995L11.741 22.999L12 23L12.26 22.999L12.517 22.995L12.771 22.99L13.021 22.982L13.268 22.971L13.512 22.959L13.753 22.945L13.99 22.929L14.223 22.911L14.454 22.89L14.68 22.869L14.904 22.845L15.124 22.819L15.34 22.792L15.552 22.764L15.762 22.733L15.967 22.702L16.169 22.668L16.367 22.634L16.561 22.598L16.752 22.561L16.939 22.522L17.122 22.482L17.301 22.442L17.476 22.4L17.648 22.357L17.816 22.313L17.979 22.268L18.139 22.222L18.294 22.176L18.446 22.129L18.594 22.081L18.737 22.032L18.876 21.983L19.012 21.933L19.143 21.883L19.269 21.833L19.392 21.782L19.51 21.73L19.624 21.679L19.734 21.627L19.84 21.575L19.941 21.523L20.037 21.471L20.129 21.419L20.217 21.366L20.3 21.315L20.379 21.263L20.453 21.211L20.523 21.16L20.588 21.109L20.648 21.058L20.704 21.008L20.755 20.958L20.778 20.934L20.801 20.909L20.822 20.885L20.842 20.861L20.861 20.837L20.879 20.813L20.896 20.789L20.911 20.766L20.925 20.742L20.938 20.719L20.95 20.696L20.96 20.673L20.97 20.651L20.978 20.629L20.984 20.607L20.99 20.585L20.994 20.563L20.998 20.542L20.999 20.521L21 20.5V16.373L20.923 16.428L20.843 16.481L20.76 16.535L20.675 16.588L20.588 16.64L20.498 16.692L20.405 16.743L20.31 16.793L20.213 16.843L20.113 16.892L20.011 16.941L19.906 16.989L19.8 17.036L19.691 17.083L19.58 17.129L19.466 17.174L19.351 17.219L19.233 17.263L19.113 17.306L18.991 17.348L18.867 17.39L18.741 17.431L18.613 17.471L18.483 17.511L18.351 17.549L18.217 17.587L18.082 17.624L17.944 17.661L17.805 17.696L17.663 17.731L17.52 17.765L17.376 17.798L17.229 17.83L17.081 17.861L16.931 17.891L16.78 17.921L16.627 17.95L16.473 17.977L16.317 18.004L16.159 18.03L16 18.055L15.839 18.079L15.677 18.102L15.514 18.124L15.349 18.145L15.183 18.165L15.016 18.184L14.847 18.202L14.678 18.219L14.507 18.235L14.334 18.25L14.161 18.264L13.986 18.277L13.811 18.289L13.634 18.3L13.456 18.31L13.277 18.318L13.098 18.326L12.917 18.332L12.735 18.337L12.553 18.341L12.369 18.344L12.185 18.346H11.815L11.631 18.344L11.447 18.341L11.265 18.337L11.083 18.332L10.902 18.326L10.723 18.318L10.544 18.31L10.366 18.3L10.19 18.289L10.014 18.277L9.839 18.264L9.666 18.25L9.494 18.235L9.323 18.219L9.153 18.202L8.984 18.184L8.817 18.165L8.651 18.145L8.486 18.124L8.323 18.102L8.161 18.079L8 18.055L7.841 18.03L7.684 18.004L7.528 17.977L7.373 17.95L7.22 17.921L7.069 17.891L6.919 17.861L6.771 17.83L6.625 17.798L6.48 17.765L6.337 17.731L6.196 17.696L6.056 17.661L5.919 17.624L5.783 17.587L5.649 17.549L5.517 17.511L5.387 17.471L5.259 17.431L5.133 17.39L5.009 17.348L4.887 17.306L4.767 17.262L4.65 17.219L4.534 17.174L4.421 17.129L4.309 17.083L4.2 17.036L4.094 16.989L3.989 16.941L3.887 16.892L3.787 16.843L3.69 16.793L3.595 16.743L3.502 16.691L3.412 16.64L3.325 16.588L3.24 16.535L3.157 16.481L3.077 16.427L3 16.373V20.5V20.5ZM3 14.846V14.857L3.001 14.878L3.004 14.899L3.008 14.92L3.013 14.942L3.019 14.964L3.026 14.986L3.035 15.008L3.045 15.03L3.056 15.053L3.068 15.076L3.081 15.099L3.096 15.123L3.112 15.146L3.129 15.17L3.147 15.194L3.166 15.218L3.187 15.242L3.209 15.266L3.232 15.291L3.256 15.315L3.308 15.365L3.364 15.415L3.425 15.465L3.491 15.516L3.561 15.567L3.636 15.619L3.715 15.67L3.799 15.722L3.887 15.774L3.979 15.826L4.076 15.878L4.178 15.93L4.283 15.982L4.393 16.033L4.507 16.084L4.626 16.136L4.749 16.186L4.876 16.237L5.007 16.287L5.142 16.336L5.281 16.385L5.425 16.433L5.572 16.481L5.724 16.528L5.879 16.574L6.039 16.619L6.202 16.664L6.369 16.708L6.54 16.75L6.716 16.792L6.894 16.832L7.077 16.872L7.264 16.91L7.454 16.947L7.648 16.983L7.845 17.017L8.047 17.05L8.251 17.082L8.46 17.112L8.672 17.14L8.888 17.167L9.107 17.192L9.329 17.216L9.555 17.238L9.785 17.258L10.018 17.276L10.254 17.292L10.494 17.306L10.737 17.318L10.983 17.328L11.232 17.336L11.485 17.342L11.741 17.345L12 17.346L12.26 17.345L12.517 17.342L12.771 17.336L13.021 17.328L13.268 17.318L13.512 17.306L13.753 17.291L13.99 17.275L14.223 17.257L14.454 17.237L14.68 17.215L14.904 17.191L15.124 17.166L15.34 17.139L15.552 17.11L15.762 17.08L15.967 17.048L16.169 17.015L16.367 16.98L16.561 16.944L16.752 16.907L16.939 16.868L17.122 16.829L17.301 16.788L17.476 16.746L17.648 16.703L17.816 16.659L17.979 16.614L18.139 16.569L18.294 16.522L18.446 16.475L18.594 16.427L18.737 16.379L18.876 16.329L19.012 16.28L19.143 16.23L19.269 16.179L19.392 16.128L19.51 16.077L19.624 16.025L19.734 15.973L19.84 15.921L19.941 15.869L20.037 15.817L20.129 15.765L20.217 15.713L20.3 15.661L20.379 15.609L20.453 15.558L20.523 15.506L20.588 15.455L20.648 15.405L20.704 15.354L20.755 15.305L20.778 15.28L20.801 15.256L20.822 15.231L20.842 15.207L20.861 15.183L20.879 15.159L20.896 15.135L20.911 15.112L20.925 15.089L20.938 15.065L20.95 15.043L20.96 15.02L20.97 14.997L20.978 14.975L20.984 14.953L20.99 14.931L20.994 14.91L20.998 14.888L20.999 14.867L21 14.846V10.707L20.923 10.761L20.843 10.815L20.76 10.869L20.675 10.921L20.588 10.974L20.498 11.025L20.405 11.076L20.31 11.127L20.213 11.177L20.113 11.226L20.011 11.275L19.906 11.323L19.8 11.37L19.691 11.417L19.58 11.463L19.466 11.508L19.351 11.552L19.233 11.596L19.113 11.64L18.991 11.682L18.867 11.724L18.741 11.765L18.613 11.805L18.483 11.844L18.351 11.883L18.217 11.921L18.082 11.958L17.944 11.994L17.805 12.03L17.663 12.065L17.52 12.098L17.376 12.131L17.229 12.164L17.081 12.195L16.931 12.225L16.78 12.255L16.627 12.283L16.473 12.311L16.317 12.338L16.159 12.364L16 12.389L15.839 12.413L15.677 12.436L15.514 12.458L15.349 12.479L15.183 12.499L15.016 12.518L14.847 12.536L14.678 12.553L14.507 12.569L14.334 12.584L14.161 12.598L13.986 12.611L13.811 12.623L13.634 12.634L13.456 12.643L13.277 12.652L13.098 12.659L12.917 12.666L12.735 12.671L12.553 12.675L12.369 12.678L12.185 12.68H11.815L11.631 12.678L11.447 12.675L11.265 12.671L11.083 12.666L10.902 12.659L10.723 12.652L10.544 12.643L10.366 12.634L10.19 12.623L10.014 12.611L9.839 12.598L9.666 12.584L9.494 12.569L9.323 12.553L9.153 12.536L8.984 12.518L8.817 12.499L8.651 12.479L8.486 12.458L8.323 12.436L8.161 12.413L8 12.389L7.841 12.364L7.684 12.338L7.528 12.311L7.373 12.283L7.22 12.255L7.069 12.225L6.919 12.195L6.771 12.164L6.625 12.131L6.48 12.098L6.337 12.065L6.196 12.03L6.056 11.994L5.919 11.958L5.783 11.921L5.649 11.883L5.517 11.844L5.387 11.805L5.259 11.765L5.133 11.724L5.009 11.682L4.887 11.639L4.767 11.596L4.65 11.552L4.534 11.508L4.421 11.462L4.309 11.416L4.2 11.37L4.094 11.323L3.989 11.275L3.887 11.226L3.787 11.177L3.69 11.127L3.595 11.076L3.502 11.025L3.412 10.974L3.325 10.921L3.24 10.869L3.157 10.815L3.077 10.761L3 10.707V14.846V14.846ZM3 9.18V9.191L3.001 9.211L3.004 9.233L3.008 9.254L3.013 9.276L3.019 9.297L3.026 9.319L3.035 9.342L3.045 9.364L3.056 9.387L3.068 9.41L3.081 9.433L3.096 9.456L3.112 9.48L3.129 9.504L3.147 9.527L3.166 9.551L3.187 9.576L3.209 9.6L3.232 9.624L3.256 9.649L3.308 9.699L3.364 9.749L3.425 9.799L3.491 9.85L3.561 9.901L3.636 9.953L3.715 10.004L3.799 10.056L3.887 10.108L3.979 10.16L4.076 10.212L4.178 10.264L4.283 10.315L4.393 10.367L4.507 10.418L4.626 10.469L4.749 10.52L4.876 10.57L5.007 10.62L5.142 10.67L5.281 10.719L5.425 10.767L5.572 10.815L5.724 10.862L5.879 10.908L6.039 10.953L6.202 10.998L6.369 11.041L6.54 11.084L6.716 11.126L6.894 11.166L7.077 11.206L7.264 11.244L7.454 11.281L7.648 11.317L7.845 11.351L8.047 11.384L8.251 11.416L8.46 11.446L8.672 11.474L8.888 11.501L9.107 11.526L9.329 11.55L9.555 11.571L9.785 11.591L10.018 11.609L10.254 11.626L10.494 11.64L10.737 11.652L10.983 11.662L11.232 11.67L11.485 11.676L11.741 11.679L12 11.68L12.26 11.679L12.517 11.676L12.771 11.67L13.021 11.662L13.268 11.652L13.512 11.639L13.753 11.625L13.99 11.609L14.223 11.591L14.454 11.571L14.68 11.549L14.904 11.525L15.124 11.5L15.34 11.473L15.552 11.444L15.762 11.414L15.967 11.382L16.169 11.349L16.367 11.314L16.561 11.278L16.752 11.241L16.939 11.202L17.122 11.163L17.301 11.122L17.476 11.08L17.648 11.037L17.816 10.993L17.979 10.948L18.139 10.903L18.294 10.856L18.446 10.809L18.594 10.761L18.737 10.712L18.876 10.663L19.012 10.614L19.143 10.563L19.269 10.513L19.392 10.462L19.51 10.41L19.624 10.359L19.734 10.307L19.84 10.255L19.941 10.203L20.037 10.151L20.129 10.099L20.217 10.047L20.3 9.995L20.379 9.943L20.453 9.891L20.523 9.84L20.588 9.789L20.648 9.738L20.704 9.688L20.755 9.639L20.778 9.614L20.801 9.589L20.822 9.565L20.842 9.541L20.861 9.517L20.879 9.493L20.896 9.469L20.911 9.446L20.925 9.422L20.938 9.399L20.95 9.376L20.96 9.354L20.97 9.331L20.978 9.309L20.984 9.287L20.99 9.265L20.994 9.243L20.998 9.222L20.999 9.201L21 9.18V5.027L20.923 5.081L20.843 5.135L20.76 5.188L20.675 5.241L20.588 5.294L20.498 5.345L20.405 5.396L20.31 5.447L20.213 5.497L20.113 5.546L20.011 5.594L19.906 5.642L19.8 5.69L19.691 5.736L19.58 5.782L19.466 5.828L19.351 5.872L19.233 5.916L19.113 5.959L18.991 6.002L18.867 6.044L18.741 6.085L18.613 6.125L18.483 6.164L18.351 6.203L18.217 6.241L18.082 6.278L17.944 6.314L17.805 6.35L17.663 6.384L17.52 6.418L17.376 6.451L17.229 6.483L17.081 6.515L16.931 6.545L16.78 6.575L16.627 6.603L16.473 6.631L16.317 6.658L16.159 6.684L16 6.708L15.839 6.732L15.677 6.755L15.514 6.778L15.349 6.799L15.183 6.819L15.016 6.838L14.847 6.856L14.678 6.873L14.507 6.889L14.334 6.904L14.161 6.918L13.986 6.931L13.811 6.943L13.634 6.953L13.456 6.963L13.277 6.972L13.098 6.979L12.917 6.985L12.735 6.991L12.553 6.995L12.369 6.998L12.185 6.999L12 7L11.815 6.999L11.631 6.998L11.447 6.995L11.265 6.991L11.083 6.985L10.902 6.979L10.723 6.972L10.544 6.963L10.366 6.953L10.19 6.943L10.014 6.931L9.839 6.918L9.666 6.904L9.494 6.889L9.323 6.873L9.153 6.856L8.984 6.838L8.817 6.819L8.651 6.799L8.486 6.778L8.323 6.755L8.161 6.732L8 6.708L7.841 6.684L7.684 6.658L7.528 6.631L7.373 6.603L7.22 6.575L7.069 6.545L6.919 6.515L6.771 6.483L6.625 6.451L6.48 6.418L6.337 6.384L6.196 6.35L6.056 6.314L5.919 6.278L5.783 6.241L5.649 6.203L5.517 6.164L5.387 6.125L5.259 6.084L5.133 6.043L5.009 6.002L4.887 5.959L4.767 5.916L4.65 5.872L4.534 5.828L4.421 5.782L4.309 5.736L4.2 5.69L4.094 5.642L3.989 5.594L3.887 5.546L3.787 5.496L3.69 5.447L3.595 5.396L3.502 5.345L3.412 5.293L3.325 5.241L3.24 5.188L3.157 5.135L3.077 5.081L3 5.027V9.18V9.18ZM11.74 1.001L11.483 1.005L11.229 1.01L10.979 1.018L10.732 1.029L10.488 1.041L10.247 1.055L10.01 1.071L9.777 1.089L9.546 1.11L9.32 1.132L9.096 1.155L8.876 1.181L8.66 1.208L8.448 1.236L8.238 1.267L8.033 1.299L7.831 1.332L7.633 1.366L7.439 1.402L7.248 1.44L7.061 1.478L6.878 1.518L6.699 1.559L6.524 1.601L6.352 1.644L6.184 1.687L6.021 1.732L5.861 1.778L5.706 1.824L5.554 1.872L5.406 1.92L5.263 1.968L5.124 2.017L4.988 2.067L4.857 2.117L4.731 2.168L4.608 2.219L4.49 2.27L4.376 2.322L4.266 2.374L4.16 2.426L4.059 2.478L3.963 2.53L3.871 2.582L3.783 2.634L3.7 2.686L3.621 2.738L3.547 2.789L3.477 2.841L3.412 2.892L3.352 2.942L3.296 2.992L3.245 3.042L3.222 3.067L3.199 3.091L3.178 3.115L3.158 3.14L3.139 3.164L3.121 3.188L3.104 3.211L3.089 3.235L3.075 3.258L3.062 3.281L3.05 3.304L3.04 3.327L3.03 3.349L3.022 3.371L3.016 3.394L3.01 3.415L3.006 3.437L3.002 3.458L3.001 3.479L3 3.5L3.001 3.521L3.002 3.542L3.006 3.563L3.01 3.585L3.016 3.606L3.022 3.629L3.03 3.651L3.04 3.673L3.05 3.696L3.062 3.719L3.075 3.742L3.089 3.765L3.104 3.789L3.121 3.812L3.139 3.836L3.158 3.86L3.178 3.885L3.199 3.909L3.222 3.933L3.245 3.958L3.296 4.008L3.352 4.058L3.412 4.108L3.477 4.159L3.547 4.211L3.621 4.262L3.7 4.314L3.783 4.366L3.871 4.418L3.963 4.47L4.059 4.522L4.16 4.574L4.266 4.626L4.376 4.678L4.49 4.73L4.608 4.781L4.731 4.832L4.857 4.883L4.988 4.933L5.124 4.983L5.263 5.032L5.406 5.08L5.554 5.128L5.706 5.176L5.861 5.222L6.021 5.268L6.184 5.313L6.352 5.356L6.524 5.399L6.699 5.441L6.878 5.482L7.061 5.522L7.248 5.56L7.439 5.598L7.633 5.634L7.831 5.668L8.033 5.701L8.238 5.733L8.448 5.764L8.66 5.792L8.876 5.819L9.096 5.845L9.32 5.868L9.546 5.89L9.777 5.911L10.01 5.929L10.247 5.945L10.488 5.959L10.732 5.971L10.979 5.982L11.229 5.99L11.483 5.995L11.74 5.999L12 6L12.26 5.999L12.517 5.995L12.771 5.99L13.021 5.982L13.268 5.971L13.512 5.959L13.753 5.945L13.99 5.929L14.223 5.911L14.454 5.89L14.68 5.868L14.904 5.845L15.124 5.819L15.34 5.792L15.552 5.764L15.762 5.733L15.967 5.701L16.169 5.668L16.367 5.634L16.561 5.598L16.752 5.56L16.939 5.522L17.122 5.482L17.301 5.441L17.476 5.399L17.648 5.356L17.816 5.313L17.979 5.268L18.139 5.222L18.294 5.176L18.446 5.128L18.594 5.08L18.737 5.032L18.876 4.983L19.012 4.933L19.143 4.883L19.269 4.832L19.392 4.781L19.51 4.73L19.624 4.678L19.734 4.626L19.84 4.574L19.941 4.522L20.037 4.47L20.129 4.418L20.217 4.366L20.3 4.314L20.379 4.262L20.453 4.211L20.523 4.159L20.588 4.108L20.648 4.058L20.704 4.008L20.755 3.958L20.778 3.933L20.801 3.909L20.822 3.885L20.842 3.86L20.861 3.836L20.879 3.812L20.896 3.789L20.911 3.765L20.925 3.742L20.938 3.719L20.95 3.696L20.96 3.673L20.97 3.651L20.978 3.629L20.984 3.606L20.99 3.585L20.994 3.563L20.998 3.542L20.999 3.521L21 3.5L20.999 3.479L20.998 3.458L20.994 3.437L20.99 3.415L20.984 3.394L20.978 3.371L20.97 3.349L20.96 3.327L20.95 3.304L20.938 3.281L20.925 3.258L20.911 3.235L20.896 3.211L20.879 3.188L20.861 3.164L20.842 3.14L20.822 3.115L20.801 3.091L20.778 3.067L20.755 3.042L20.704 2.992L20.648 2.942L20.588 2.892L20.523 2.841L20.453 2.789L20.379 2.738L20.3 2.686L20.217 2.634L20.129 2.582L20.037 2.53L19.941 2.478L19.84 2.426L19.734 2.374L19.624 2.322L19.51 2.27L19.392 2.219L19.269 2.168L19.143 2.117L19.012 2.067L18.876 2.017L18.737 1.968L18.594 1.92L18.446 1.872L18.294 1.824L18.139 1.778L17.979 1.732L17.816 1.687L17.648 1.644L17.476 1.601L17.301 1.559L17.122 1.518L16.939 1.478L16.752 1.44L16.561 1.402L16.367 1.366L16.169 1.332L15.967 1.299L15.762 1.267L15.552 1.236L15.34 1.208L15.124 1.181L14.904 1.155L14.68 1.132L14.454 1.11L14.223 1.089L13.99 1.071L13.753 1.055L13.512 1.041L13.268 1.029L13.021 1.018L12.771 1.01L12.517 1.005L12.26 1.001L12 1L11.74 1.001V1.001Z" fill="currentColor"/>
</svg>
`, Gw = `<svg width="77" height="80" viewBox="0 0 77 80" fill="none" xmlns="http://www.w3.org/2000/svg">
	<g>
		<path d="M74.0149 38.8888C74.0149 43.5755 73.0918 48.2163 71.2983 52.5463C69.5048 56.8762 66.876 60.8105 63.562 64.1245C60.248 67.4385 56.3137 70.0673 51.9838 71.8608C47.6538 73.6543 43.013 74.5774 38.3263 74.5774C33.6396 74.5774 28.9988 73.6543 24.6689 71.8608C20.3389 70.0673 16.4046 67.4385 13.0907 64.1245C9.77666 60.8105 7.14785 56.8762 5.35433 52.5463C3.56081 48.2163 2.6377 43.5755 2.6377 38.8888C2.6377 34.2021 3.56081 29.5613 5.35433 25.2314C7.14785 20.9014 9.77666 16.9671 13.0907 13.6532C16.4046 10.3392 20.3389 7.71035 24.6689 5.91683C28.9988 4.12331 33.6396 3.2002 38.3263 3.2002C43.013 3.2002 47.6538 4.12331 51.9838 5.91683C56.3137 7.71035 60.248 10.3392 63.562 13.6532C66.876 16.9671 69.5048 20.9014 71.2983 25.2314C73.0918 29.5613 74.0149 34.2021 74.0149 38.8888V38.8888Z" stroke="currentColor" stroke-width="4.98203"/>
		<path d="M2.69922 75.4727L75.6992 75.5154" stroke="currentColor" stroke-width="4"/>
	</g>
</svg>
`, jw = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 64 (93537) - https://sketch.com -->
    <title>Icon-Architecture/16/Arch_Amazon-Cognito_16</title>
    <desc>Created with Sketch.</desc>
    <defs>
        <linearGradient x1="0%" y1="100%" x2="100%" y2="0%" id="linearGradient-1">
            <stop stop-color="#BD0816" offset="0%"></stop>
            <stop stop-color="#FF5252" offset="100%"></stop>
        </linearGradient>
    </defs>
    <g id="Icon-Architecture/16/Arch_Amazon-Cognito_16" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Icon-Architecture-BG/16/Security-Identity-Compliance" fill="url(#linearGradient-1)">
            <rect id="Rectangle" x="0" y="0" width="24" height="24"></rect>
        </g>
        <path d="M15.188,16.891 L13.938,15.891 L14.563,15.11 L15.387,15.769 L17.084,13.223 L17.917,13.778 L15.917,16.778 C15.838,16.894 15.715,16.973 15.578,16.995 C15.551,16.998 15.526,17 15.5,17 C15.388,17 15.278,16.962 15.188,16.891 L15.188,16.891 Z M6,12 L8,12 L8,11 L6,11 L6,12 Z M6.001,10 L9.001,10 L9.001,9 L6.001,9 L6.001,10 Z M18.001,7 L18.001,6.5 C18.001,6.224 17.777,6 17.501,6 L10.501,6 C10.224,6 10.001,6.224 10.001,6.5 L10.001,7 L5,7 L5,5.6 C5,5.281 5.198,5 5.422,5 L18.578,5 C18.803,5 19.001,5.281 19.001,5.6 L19.001,7 L18.001,7 Z M15.625,12 C17.487,12 19.001,13.571 19.001,15.5 C19.001,17.43 17.487,19 15.625,19 C13.764,19 12.25,17.43 12.25,15.5 C12.25,13.571 13.764,12 15.625,12 L15.625,12 Z M20,12 L20,5.6 C20,4.718 19.362,4 18.578,4 L5.422,4 C4.638,4 4,4.718 4,5.6 L4,14.4 C4,15.283 4.638,16 5.422,16 L11.299,16 C11.545,18.244 13.379,20 15.625,20 C18.038,20 20,17.982 20,15.5 C20,13.019 18.038,11 15.625,11 C13.379,11 11.545,12.757 11.299,15 L5.422,15 C5.198,15 5,14.72 5,14.4 L5,8 L10.001,8 L10.001,12 L11.001,12 L11.001,8 L11.001,7 L17,7 L17,8 L17,10 L18.001,10 L18.001,8 L19.001,8 L19.001,12 L20,12 Z" id="Amazon-Cognito_Icon_16_Squid" fill="#FFFFFF"></path>
    </g>
</svg>`, qw = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 64 (93537) - https://sketch.com -->
    <title>Icon-Architecture/16/Arch_AWS-Elastic-Beanstalk_16</title>
    <desc>Created with Sketch.</desc>
    <defs>
        <linearGradient x1="0%" y1="100%" x2="100%" y2="0%" id="linearGradient-1">
            <stop stop-color="#C8511B" offset="0%"></stop>
            <stop stop-color="#FF9900" offset="100%"></stop>
        </linearGradient>
    </defs>
    <g id="Icon-Architecture/16/Arch_AWS-Elastic-Beanstalk_16" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Icon-Architecture-BG/16/Compute" fill="url(#linearGradient-1)">
            <rect id="Rectangle" x="0" y="0" width="24" height="24"></rect>
        </g>
        <path d="M14.9985007,13.6428238 C14.9985007,13.373991 14.7736132,13.1558078 14.4987506,13.1558078 C14.2238881,13.1558078 13.9990005,13.373991 13.9990005,13.6428238 C13.9990005,13.9116567 14.2238881,14.1298398 14.4987506,14.1298398 C14.7736132,14.1298398 14.9985007,13.9116567 14.9985007,13.6428238 M11.0004998,9.7466957 C11.0004998,10.0155285 11.2253873,10.2337117 11.5002499,10.2337117 C11.7751124,10.2337117 12,10.0155285 12,9.7466957 C12,9.47786286 11.7751124,9.25967968 11.5002499,9.25967968 C11.2253873,9.25967968 11.0004998,9.47786286 11.0004998,9.7466957 M8.001999,12.6687918 C8.001999,12.9376246 8.22688656,13.1558078 8.50174913,13.1558078 C8.77661169,13.1558078 9.00149925,12.9376246 9.00149925,12.6687918 C9.00149925,12.399959 8.77661169,12.1817758 8.50174913,12.1817758 C8.22688656,12.1817758 8.001999,12.399959 8.001999,12.6687918 M15.998001,13.6428238 C15.998001,14.2769187 15.5792104,14.8126363 14.9985007,15.0142609 L14.9985007,16.5649199 C14.9985007,16.8337528 14.7746127,17.0519359 14.4987506,17.0519359 L12,17.0519359 L12,19 L11.0004998,19 L11.0004998,16.0779039 L8.50174913,16.0779039 C8.22588706,16.0779039 8.001999,15.8597207 8.001999,15.5908879 L8.001999,14.0402289 C7.42128936,13.8386043 7.00249875,13.3028866 7.00249875,12.6687918 C7.00249875,11.8632673 7.67516242,11.2077437 8.50174913,11.2077437 C9.32833583,11.2077437 10.0009995,11.8632673 10.0009995,12.6687918 C10.0009995,13.3028866 9.5822089,13.8386043 9.00149925,14.0402289 L9.00149925,15.1038719 L11.0004998,15.1038719 L11.0004998,11.1181328 C10.4197901,10.9165082 10.0009995,10.3807906 10.0009995,9.7466957 C10.0009995,8.94117121 10.6736632,8.28564765 11.5002499,8.28564765 C12.3268366,8.28564765 12.9995002,8.94117121 12.9995002,9.7466957 C12.9995002,10.3807906 12.5807096,10.9165082 12,11.1181328 L12,16.0779039 L13.9990005,16.0779039 L13.9990005,15.0142609 C13.4182909,14.8126363 12.9995002,14.2769187 12.9995002,13.6428238 C12.9995002,12.8372993 13.6721639,12.1817758 14.4987506,12.1817758 C15.3253373,12.1817758 15.998001,12.8372993 15.998001,13.6428238 M20,12.0590477 C20,13.8054872 18.8965517,14.9392605 17.0504748,15.0892614 L16.9665167,14.1191255 C17.894053,14.043151 19.0004998,13.6243172 19.0004998,12.0590477 C19.0004998,10.9369628 18.3148426,10.2337117 16.9635182,9.96974904 C16.7406297,9.92591759 16.5767116,9.74182554 16.5627186,9.52072027 C16.4987506,8.45805132 15.888056,8.08207496 15.3843078,8.08207496 C15.0474763,8.08207496 14.7306347,8.23889412 14.5167416,8.51357115 C14.4067966,8.65480579 14.2218891,8.7249361 14.0449775,8.7005853 C13.864068,8.6733124 13.7131434,8.55350646 13.6501749,8.38694698 C13.4312844,7.80739793 13.1174413,7.32232997 12.7186407,6.94635361 C12.2278861,6.48174033 10.8795602,5.48530556 8.97751124,6.24505055 C7.88805597,6.67752077 7.03448276,7.9281779 7.03448276,9.09312021 C7.03448276,9.22169244 7.04247876,9.3512387 7.05847076,9.47786286 C7.08945527,9.7223449 6.92853573,9.9502684 6.68265867,10.0106584 C6.05397301,10.1616333 4.99950025,10.6272207 4.99950025,12.037619 L5.00449775,12.1652172 C5.06246877,13.1850288 5.93203398,14.011982 7.02848576,14.1181515 L6.93053473,15.0873133 C5.34732634,14.9353643 4.09095452,13.7139282 4.007996,12.2470359 L4,12.037619 C4,10.6827405 4.75262369,9.64150024 6.03598201,9.18467922 C6.03498251,9.15448423 6.03498251,9.1233152 6.03498251,9.09312021 C6.03498251,7.53466896 7.13743128,5.92361998 8.59970015,5.34309689 C10.2988506,4.66614462 12.0989505,5.00315971 13.4132934,6.24602458 C13.7631184,6.57524741 14.0589705,6.96583425 14.2978511,7.40999286 C14.6216892,7.21323839 14.9945027,7.10804293 15.3843078,7.10804293 C16.2858571,7.10804293 17.2903548,7.73337149 17.5192404,9.09701634 C19.1224388,9.52072027 20,10.5619605 20,12.0590477" id="AWS-Elastic-Beanstalk_Icon_16_Squid" fill="#FFFFFF"></path>
    </g>
</svg>`, Kw = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 64 (93537) - https://sketch.com -->
    <title>Icon-Architecture/16/Arch_Amazon-Kinesis_16</title>
    <desc>Created with Sketch.</desc>
    <defs>
        <linearGradient x1="0%" y1="100%" x2="100%" y2="0%" id="linearGradient-1">
            <stop stop-color="#4D27A8" offset="0%"></stop>
            <stop stop-color="#A166FF" offset="100%"></stop>
        </linearGradient>
    </defs>
    <g id="Icon-Architecture/16/Arch_Amazon-Kinesis_16" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Icon-Architecture-BG/16/Analytics" fill="url(#linearGradient-1)">
            <rect id="Rectangle" x="0" y="0" width="24" height="24"></rect>
        </g>
        <path d="M6.7337492,17.8414023 L7.72616432,17.8414023 C7.72616432,16.9338898 7.72616432,14.8073456 19,14.8073456 L19,13.8056761 C8.21939463,13.8056761 6.7337492,15.7449082 6.7337492,17.8414023 M8.03778266,20 L9.03019777,20 C9.03019777,18.9632721 9.03019777,16.5342237 19,16.5342237 L19,15.5325543 C9.3408237,15.5325543 8.03778266,17.7903172 8.03778266,20 M5.99241511,9.38931553 L5,9.38931553 C5,10.8287145 5.99340753,11.9105175 9.81718296,12.4994992 C5.99340753,13.0894825 5,14.1712855 5,15.6096828 L5.99241511,15.6096828 C5.99241511,14.3956594 7.47111363,13.0003339 19,13.0003339 L19,11.9986644 C7.47111363,11.9986644 5.99241511,10.6043406 5.99241511,9.38931553 M7.72616432,7.15859766 L6.7337492,7.15859766 C6.7337492,9.25409015 8.21939463,11.1943239 19,11.1943239 L19,10.1926544 C7.72616432,10.1926544 7.72616432,8.06611018 7.72616432,7.15859766 M19,8.46577629 L19,9.46744574 C9.3408237,9.46744574 8.03778266,7.20868114 8.03778266,5 L9.03019777,5 C9.03019777,6.03672788 9.03019777,8.46577629 19,8.46577629" id="Amazon-Kinesis_Icon_16_Squid" fill="#FFFFFF"></path>
    </g>
</svg>`, Yw = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 64 (93537) - https://sketch.com -->
    <title>Icon-Architecture/16/Arch_Amazon-Lightsail_16</title>
    <desc>Created with Sketch.</desc>
    <defs>
        <linearGradient x1="0%" y1="100%" x2="100%" y2="0%" id="linearGradient-1">
            <stop stop-color="#C8511B" offset="0%"></stop>
            <stop stop-color="#FF9900" offset="100%"></stop>
        </linearGradient>
    </defs>
    <g id="Icon-Architecture/16/Arch_Amazon-Lightsail_16" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Icon-Architecture-BG/16/Compute" fill="url(#linearGradient-1)">
            <rect id="Rectangle" x="0" y="0" width="24" height="24"></rect>
        </g>
        <path d="M20,12.5 C20,16.636 16.636,20 12.5,20 C9.458,20 6.738,18.185 5.571,15.376 L6.495,14.992 C7.506,17.427 9.863,19 12.5,19 C16.084,19 19,16.084 19,12.5 C19,8.916 16.084,6 12.5,6 C9.826,6 7.386,7.677 6.429,10.173 L5.495,9.815 C6.6,6.935 9.415,5 12.5,5 C16.636,5 20,8.364 20,12.5 L20,12.5 Z M7,13 L10,13 L10,12 L7,12 L7,13 Z M4,13 L6,13 L6,12 L4,12 L4,13 Z M14.193,9.163 C14.792,10.014 15.392,11.192 15.392,12.501 C15.392,13.794 14.737,15.02 14.188,15.82 C13.856,14.343 13.213,13.192 12.331,12.501 C13.217,11.807 13.862,10.65 14.193,9.163 L14.193,9.163 Z M13.382,17.081 C13.402,17.277 13.537,17.443 13.725,17.504 C13.775,17.521 13.827,17.528 13.879,17.528 C14.018,17.528 14.153,17.47 14.25,17.363 C14.753,16.806 16.392,14.81 16.392,12.501 C16.392,10.33 15.051,8.521 14.251,7.636 C14.118,7.49 13.913,7.434 13.725,7.496 C13.537,7.557 13.403,7.723 13.383,7.919 C13.163,10 12.334,11.541 11.165,12.042 C10.981,12.12 10.862,12.301 10.862,12.501 C10.862,12.701 10.981,12.882 11.165,12.96 C12.334,13.462 13.162,15.002 13.382,17.081 L13.382,17.081 Z" id="Amazon-Lightsail-Icon_16_Squid" fill="#FFFFFF"></path>
    </g>
</svg>`, Qw = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 64 (93537) - https://sketch.com -->
    <title>Icon-Architecture/16/Arch_AWS-SageMaker_16</title>
    <desc>Created with Sketch.</desc>
    <defs>
        <linearGradient x1="0%" y1="100%" x2="100%" y2="0%" id="linearGradient-1">
            <stop stop-color="#055F4E" offset="0%"></stop>
            <stop stop-color="#56C0A7" offset="100%"></stop>
        </linearGradient>
    </defs>
    <g id="Icon-Architecture/16/Arch_AWS-SageMaker_16" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Icon-Architecture-BG/16/Machine-Learning" fill="url(#linearGradient-1)">
            <rect id="Rectangle" x="0" y="0" width="24" height="24"></rect>
        </g>
        <path d="M19.000533,13.6672874 L17.3104344,12.3579393 L16.6857676,13.1152694 L18.5747601,14.5766646 L17.2604611,15.2080958 C17.0895522,15.2894458 16.9816098,15.4579566 16.9816098,15.6419626 L16.9816098,17.2989853 L14.0161914,18.9482603 L12.96875,18.2858386 L12.96875,15.6574578 L14.9986674,15.6574578 L14.9986674,14.6890051 L12.96875,14.6890051 L12.96875,12.7366043 L11.969283,12.7366043 L11.969283,18.2906809 L10.9788113,18.9453549 L9.91038113,18.350725 L11.3546109,16.9532476 L10.6479877,16.2685515 L9.01285981,17.8519718 L8.01839019,17.2989853 L8.01839019,15.6419626 C8.01839019,15.4579566 7.91044776,15.2894458 7.73953891,15.2080958 L5.99946695,14.3732895 L5.99946695,11.0941084 L7.43370203,10.3726111 L9.00186567,11.1047614 L9.00186567,12.477059 L7.72554638,13.3021807 L8.27925107,14.1079334 L9.77845149,13.1394807 C9.9173774,13.0494146 10.0013326,12.8983359 10.0013326,12.7366043 L10.0013326,11.0592442 L11.2776519,10.2341224 L10.7239472,9.42836971 L9.46162047,10.2438069 L7.9244403,9.52715189 L7.9244403,7.24644565 L9.00186567,6.80386274 L9.00186567,8.827929 L10.0013326,8.827929 L10.0013326,6.39323877 L10.958822,6.00004695 L11.969283,6.31188874 L11.969283,9.83124606 C11.969283,9.97941933 12.0392457,10.1188765 12.1591818,10.2108795 L14.6898321,12.147785 L15.3085021,11.3885181 L12.96875,9.59688049 L12.96875,6.30704647 L13.9132463,6.0010154 L16.9976013,7.24838255 L16.9976013,7.95535307 L14.9986674,7.95535307 L14.9986674,8.92380582 L16.9976013,8.92380582 L16.9976013,9.83124606 C16.9976013,10.0152521 17.1055437,10.1827944 17.2734542,10.2641444 L19.000533,11.0989507 L19.000533,13.6672874 Z M19.7241471,10.3668004 L17.9970682,9.53199415 L17.9970682,6.92588779 C17.9970682,6.73026033 17.8761327,6.55400193 17.6892324,6.47943106 L14.1251333,5.03740491 C14.013193,4.99188763 13.8892591,4.98898227 13.7743204,5.02578348 L12.4660181,5.44899733 L11.0857543,5.02287812 C10.9728145,4.98801382 10.8498801,4.99285608 10.7389392,5.03837336 L7.22981077,6.48039952 C7.04490938,6.55593883 6.92497335,6.73122878 6.92497335,6.92588779 L6.92497335,9.53683642 L5.26985608,10.3697058 C5.10394456,10.4529927 5,10.6195666 5,10.7996988 L5,14.6735098 C5,14.8575159 5.10794243,15.0260266 5.27885128,15.1073767 L7.01892324,15.9431514 L7.01892324,17.5788681 C7.01892324,17.7522212 7.1138726,17.9129843 7.26978945,17.9991766 L10.7519323,19.9360821 C10.8288913,19.978694 10.9148454,20 11.0007996,20 C11.0997468,20 11.1966951,19.9719149 11.2816498,19.9157446 L12.4750133,19.129361 L13.7263459,19.9215553 C13.8093017,19.9738518 13.9032516,20 13.9992004,20 C14.0851546,20 14.1711087,19.978694 14.2480677,19.9360821 L17.7302106,17.9991766 C17.8861274,17.9129843 17.9810768,17.7522212 17.9810768,17.5788681 L17.9810768,15.9431514 L19.7221482,15.1073767 C19.893057,15.0260266 20,14.8575159 20,14.6735098 L20,10.7996988 C20,10.6166612 19.893057,10.4481505 19.7241471,10.3668004 L19.7241471,10.3668004 Z" id="AWS-SageMaker_Icon_16_Squid" fill="#FFFFFF"></path>
    </g>
</svg>`, Xw = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/IoT/Res_AWS-IoT_LoRaWAN-Protocol_48</title>
    <g id="Icon-Resource/IoT/Res_AWS-IoT_LoRaWAN-Protocol_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M46,5 C46,3.346 44.654,2 43,2 L5,2 C3.346,2 2,3.346 2,5 L2,28 L4,28 L4,5 C4,4.449 4.448,4 5,4 L43,4 C43.552,4 44,4.449 44,5 L44,28 L46,28 L46,5 Z M37.595,37.442 L37.595,41.875 L36.541,41.875 L36.541,35.58 L37.958,35.58 L39.856,39.995 L39.856,35.58 L40.91,35.58 L40.91,41.875 L39.512,41.875 L37.595,37.442 Z M32.825,39.468 L33.951,39.468 L33.38,36.861 L32.825,39.468 Z M34.47,41.875 L34.143,40.376 L32.635,40.376 L32.316,41.875 L30.981,41.875 L32.726,35.58 L34.134,35.58 L35.868,41.875 L34.47,41.875 Z M28.328,41.875 L27.62,37.233 L26.947,41.875 L25.54,41.875 L24.195,35.58 L25.477,35.58 L26.275,40.585 L26.966,35.834 L28.347,35.834 L29.056,40.503 L29.827,35.58 L31.081,35.58 L29.736,41.875 L28.328,41.875 Z M21.815,41.121 C22.015,41.121 22.215,41.025 22.414,40.831 L22.414,39.94 C22.281,39.898 22.124,39.877 21.942,39.877 C21.767,39.877 21.632,39.933 21.538,40.045 C21.444,40.157 21.397,40.319 21.397,40.531 C21.397,40.713 21.435,40.857 21.511,40.962 C21.587,41.068 21.688,41.121 21.815,41.121 L21.815,41.121 Z M22.597,41.875 L22.487,41.458 C22.384,41.615 22.236,41.744 22.042,41.844 C21.849,41.944 21.651,41.994 21.451,41.994 C21.076,41.994 20.779,41.871 20.562,41.626 C20.343,41.38 20.234,41.043 20.234,40.613 C20.234,40.159 20.367,39.8 20.634,39.536 C20.9,39.273 21.261,39.141 21.715,39.141 C21.902,39.141 22.136,39.178 22.414,39.25 L22.414,38.832 C22.414,38.518 22.374,38.304 22.292,38.192 C22.21,38.08 22.057,38.023 21.833,38.023 C21.47,38.023 21.024,38.121 20.498,38.314 L20.498,37.488 C20.673,37.373 20.903,37.282 21.188,37.215 C21.473,37.148 21.764,37.115 22.061,37.115 C22.587,37.115 22.969,37.235 23.205,37.474 C23.44,37.713 23.56,38.096 23.56,38.624 L23.56,41.875 L22.597,41.875 Z M16.892,38.596 L17.481,38.596 C17.718,38.596 17.898,38.508 18.022,38.333 C18.146,38.157 18.209,37.899 18.209,37.561 C18.209,37.221 18.146,36.964 18.022,36.789 C17.898,36.613 17.718,36.525 17.481,36.525 L16.892,36.525 L16.892,38.596 Z M18.481,41.875 L17.382,39.541 L16.892,39.541 L16.892,41.875 L15.646,41.875 L15.646,35.58 L17.636,35.58 C18.193,35.58 18.637,35.757 18.967,36.111 C19.297,36.465 19.462,36.949 19.462,37.561 C19.462,37.985 19.38,38.351 19.217,38.66 C19.053,38.969 18.82,39.199 18.518,39.35 L19.789,41.875 L18.481,41.875 Z M12.812,41.049 C13.037,41.049 13.199,40.929 13.299,40.69 C13.398,40.451 13.449,40.074 13.449,39.559 C13.449,39.044 13.398,38.666 13.299,38.423 C13.199,38.182 13.037,38.06 12.812,38.06 C12.589,38.06 12.427,38.182 12.326,38.423 C12.228,38.666 12.177,39.044 12.177,39.559 C12.177,40.074 12.228,40.451 12.326,40.69 C12.427,40.929 12.589,41.049 12.812,41.049 L12.812,41.049 Z M12.812,41.994 C12.213,41.994 11.75,41.782 11.423,41.358 C11.096,40.934 10.933,40.334 10.933,39.559 C10.933,38.778 11.096,38.175 11.423,37.751 C11.75,37.327 12.213,37.115 12.812,37.115 C13.412,37.115 13.876,37.327 14.202,37.751 C14.529,38.175 14.693,38.778 14.693,39.559 C14.693,40.334 14.529,40.934 14.202,41.358 C13.876,41.782 13.412,41.994 12.812,41.994 L12.812,41.994 Z M7.135,41.875 L7.135,35.58 L8.406,35.58 L8.406,40.867 L10.551,40.867 L10.551,41.875 L7.135,41.875 Z M4,44 L44,44 L44,33 L4,33 L4,44 Z M45,46 L3,46 C2.447,46 2,45.552 2,45 L2,32 C2,31.448 2.447,31 3,31 L45,31 C45.553,31 46,31.448 46,32 L46,45 C46,45.552 45.553,46 45,46 L45,46 Z" id="Fill-1" fill="#7AA116"></path>
    </g>
</svg>`, Jw = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/IoT/Res_AWS-IoT-Greengrass_Component_48</title>
    <g id="Icon-Resource/IoT/Res_AWS-IoT-Greengrass_Component_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M4,24 C4,22.897 4.897,22 6,22 C7.103,22 8,22.897 8,24 C8,25.103 7.103,26 6,26 C4.897,26 4,25.103 4,24 L4,24 Z M24,4 C25.103,4 26,4.897 26,6 C26,7.103 25.103,8 24,8 C22.897,8 22,7.103 22,6 C22,4.897 22.897,4 24,4 L24,4 Z M10.961,35.532 C9.036,33.336 7.688,30.678 7.06,27.839 C8.749,27.372 10,25.836 10,24 C10,22.179 8.77,20.656 7.103,20.174 C8.604,13.762 13.757,8.646 20.206,7.205 C20.721,8.819 22.217,10 24,10 C25.78,10 27.274,8.823 27.792,7.213 C29.592,7.616 31.31,8.293 32.906,9.255 L33.937,7.542 C32.064,6.413 30.042,5.644 27.92,5.204 C27.55,3.379 25.934,2 24,2 C22.071,2 20.459,3.371 20.083,5.189 C12.612,6.728 6.647,12.679 5.071,20.12 C3.314,20.541 2,22.115 2,24 C2,25.866 3.29,27.426 5.022,27.865 C5.69,31.233 7.27,34.389 9.563,36.963 L7.016,36.924 L6.984,38.924 L11.908,39 L11.924,39 C12.184,39 12.434,38.899 12.62,38.718 C12.811,38.533 12.92,38.28 12.924,38.015 L13,33.015 L11,32.985 L10.961,35.532 Z M42,26 C40.897,26 40,25.103 40,24 C40,22.897 40.897,22 42,22 C43.103,22 44,22.897 44,24 C44,25.103 43.103,26 42,26 L42,26 Z M24,44 C22.897,44 22,43.103 22,42 C22,40.897 22.897,40 24,40 C25.103,40 26,40.897 26,42 C26,43.103 25.103,44 24,44 L24,44 Z M46,24 C46,22.096 44.66,20.503 42.874,20.103 C42.159,16.708 40.558,13.604 38.201,11.043 L41.016,11 L40.984,9 L35.984,9.076 C35.72,9.081 35.467,9.189 35.282,9.38 C35.098,9.57 34.996,9.826 35,10.092 L35.076,15.016 L37.076,14.984 L37.041,12.731 C38.914,14.876 40.209,17.423 40.848,20.189 C39.206,20.687 38,22.198 38,24 C38,25.82 39.229,27.342 40.896,27.825 C39.469,34.305 34.354,39.495 27.854,40.987 C27.402,39.273 25.854,38 24,38 C22.144,38 20.594,39.276 20.145,40.993 C18.329,40.583 16.599,39.904 14.999,38.933 L13.962,40.643 C15.878,41.807 17.963,42.601 20.154,43.041 C20.616,44.74 22.156,46 24,46 C25.847,46 27.39,44.736 27.848,43.033 C35.437,41.483 41.427,35.432 42.931,27.879 C44.688,27.457 46,25.884 46,24 L46,24 Z" id="Fill-1" fill="#7AA116"></path>
    </g>
</svg>`, ex = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/IoT/Res_AWS-IoT_Thing_Coffee-Pot_48</title>
    <g id="Icon-Resource/IoT/Res_AWS-IoT_Thing_Coffee-Pot_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M17.4217,36.1602 C17.2937,36.1082 17.0207,35.6612 17.0687,35.0302 L17.1597,33.8872 C17.1797,33.8082 17.1907,33.7252 17.1907,33.6402 C17.1907,33.0882 16.7297,32.6402 16.1767,32.6402 L15.7987,32.6402 C15.2447,32.6402 14.7157,31.9142 14.5797,30.9122 L11.9447,18.3642 L12.8077,18.0392 L15.7737,26.8752 C15.9227,27.3212 16.3607,27.5992 16.8307,27.5512 C17.2987,27.4992 17.6667,27.1292 17.7157,26.6612 L18.7207,17.0622 L27.4967,17.0622 L29.9987,35.0042 C30.0567,35.6472 29.7807,36.1062 29.6767,36.1562 L17.4217,36.1602 Z M24.8517,13.5472 C25.8837,13.5472 26.7727,14.1722 27.1597,15.0622 L19.0277,15.0622 C19.4147,14.1722 20.3037,13.5472 21.3357,13.5472 L24.8517,13.5472 Z M33.5197,25.0102 C33.5197,26.5222 32.4787,27.8022 31.0617,28.1492 L30.0157,20.6472 C31.9987,20.9752 33.5197,22.6892 33.5197,24.7642 L33.5197,25.0102 Z M34.3987,34.4402 L31.9387,34.4402 L31.3357,30.1202 C33.7317,29.6322 35.5197,27.5282 35.5197,25.0102 L35.5197,24.7642 C35.5197,21.4872 32.9557,18.8042 29.7307,18.5982 L29.3577,15.9252 C29.3567,15.9182 29.3527,15.9132 29.3517,15.9072 C29.2677,13.4902 27.2877,11.5472 24.8517,11.5472 L24.0937,11.5472 L24.0937,9.9102 L22.0937,9.9102 L22.0937,11.5472 L21.3357,11.5472 C18.8897,11.5472 16.9037,13.5052 16.8327,15.9342 C16.8317,15.9422 16.8267,15.9492 16.8257,15.9582 L16.2057,21.8782 L14.3737,16.4202 C14.2867,16.1632 14.0997,15.9512 13.8547,15.8352 C13.6107,15.7182 13.3287,15.7052 13.0727,15.8022 L10.4367,16.7952 C9.9747,16.9692 9.7087,17.4532 9.8107,17.9362 L12.6107,31.2502 C12.8307,32.9182 13.8317,34.1982 15.1007,34.5472 L15.0737,34.8752 C14.9997,35.8672 15.3017,36.8342 15.8837,37.4612 C16.2997,37.9092 16.8377,38.1562 17.3987,38.1562 L29.6767,38.1562 C30.2397,38.1562 30.7807,37.9052 31.1977,37.4492 C31.4517,37.1732 31.6387,36.8232 31.7757,36.4402 L34.3987,36.4402 L34.3987,37.1562 C34.3987,37.7092 34.8457,38.1562 35.3987,38.1562 L38.0337,38.1562 L38.0337,36.1562 L36.3987,36.1562 L36.3987,35.4402 L36.3987,35.3982 L36.3987,34.6402 L38.0337,34.6402 L38.0337,32.6402 L35.3987,32.6402 C34.8457,32.6402 34.3987,33.0882 34.3987,33.6402 L34.3987,34.4402 Z M39.6697,38.5372 C39.6697,39.1632 39.1607,39.6722 38.5347,39.6722 L9.4087,39.6722 C8.7827,39.6722 8.2747,39.1632 8.2747,38.5372 L8.2747,9.4242 C8.2747,8.7982 8.7827,8.2882 9.4087,8.2882 L38.5347,8.2882 C39.1607,8.2882 39.6697,8.7982 39.6697,9.4242 L39.6697,38.5372 Z M45.9457,14.4262 L45.9457,12.4262 L41.6697,12.4262 L41.6697,9.4242 C41.6697,7.6942 40.2637,6.2882 38.5347,6.2882 L35.5197,6.2882 L35.5197,2.0002 L33.5197,2.0002 L33.5197,6.2882 L30.2457,6.2882 L30.2457,2.0002 L28.2457,2.0002 L28.2457,6.2882 L24.9727,6.2882 L24.9727,2.0002 L22.9727,2.0002 L22.9727,6.2882 L19.6987,6.2882 L19.6987,2.0002 L17.6987,2.0002 L17.6987,6.2882 L14.4257,6.2882 L14.4257,2.0002 L12.4257,2.0002 L12.4257,6.2882 L9.4087,6.2882 C7.6807,6.2882 6.2747,7.6942 6.2747,9.4242 L6.2747,12.4262 L1.9997,12.4262 L1.9997,14.4262 L6.2747,14.4262 L6.2747,17.6992 L1.9997,17.6992 L1.9997,19.6992 L6.2747,19.6992 L6.2747,22.9722 L1.9997,22.9722 L1.9997,24.9722 L6.2747,24.9722 L6.2747,28.2462 L1.9997,28.2462 L1.9997,30.2462 L6.2747,30.2462 L6.2747,33.5192 L1.9997,33.5192 L1.9997,35.5192 L6.2747,35.5192 L6.2747,38.5372 C6.2747,40.2652 7.6807,41.6722 9.4087,41.6722 L12.4257,41.6722 L12.4257,45.9452 L14.4257,45.9452 L14.4257,41.6722 L17.6987,41.6722 L17.6987,45.9452 L19.6987,45.9452 L19.6987,41.6722 L22.9727,41.6722 L22.9727,45.9452 L24.9727,45.9452 L24.9727,41.6722 L28.2457,41.6722 L28.2457,45.9452 L30.2457,45.9452 L30.2457,41.6722 L33.5197,41.6722 L33.5197,45.9452 L35.5197,45.9452 L35.5197,41.6722 L38.5347,41.6722 C40.2637,41.6722 41.6697,40.2652 41.6697,38.5372 L41.6697,35.5192 L45.9457,35.5192 L45.9457,33.5192 L41.6697,33.5192 L41.6697,30.2462 L45.9457,30.2462 L45.9457,28.2462 L41.6697,28.2462 L41.6697,24.9722 L45.9457,24.9722 L45.9457,22.9722 L41.6697,22.9722 L41.6697,19.6992 L45.9457,19.6992 L45.9457,17.6992 L41.6697,17.6992 L41.6697,14.4262 L45.9457,14.4262 Z" id="Amazon-IOT-RESOURCES-IoT-thing-coffee-pot_Resource-Icon_light-bg" fill="#7AA116"></path>
    </g>
</svg>`, tx = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/IoT/Res_AWS-IoT_Lambda_Function_48</title>
    <g id="Icon-Resource/IoT/Res_AWS-IoT_Lambda_Function_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M4,23.981 C4,12.963 12.962,4 23.98,4 C34.998,4 43.96,12.963 43.96,23.981 C43.96,34.998 34.998,43.961 23.98,43.961 C12.962,43.961 4,34.998 4,23.981 Z M2,23.981 C2,36.101 11.86,45.961 23.98,45.961 C36.1,45.961 45.96,36.101 45.96,23.981 C45.96,11.86 36.1,2 23.98,2 C11.86,2 2,11.86 2,23.981 Z M17.218,35.219 L11.87,35.219 L18.207,21.943 L20.885,27.47 L17.218,35.219 Z M19.099,19.2 C18.932,18.856 18.583,18.637 18.2,18.637 L18.197,18.637 C17.812,18.638 17.462,18.859 17.297,19.206 L9.382,35.788 C9.234,36.098 9.255,36.462 9.439,36.752 C9.622,37.043 9.941,37.219 10.285,37.219 L17.851,37.219 C18.238,37.219 18.589,36.996 18.755,36.647 L22.898,27.893 C23.027,27.619 23.026,27.301 22.893,27.028 L19.099,19.2 Z M36.093,35.219 L30.648,35.219 L20.746,13.942 C20.582,13.59 20.228,13.364 19.839,13.364 L16.24,13.364 L16.244,9.245 L23.455,9.245 L33.31,30.52 C33.474,30.873 33.828,31.1 34.217,31.1 L36.093,31.1 L36.093,35.219 Z M34.856,29.1 L25.001,7.825 C24.836,7.472 24.483,7.245 24.093,7.245 L15.245,7.245 C14.693,7.245 14.246,7.692 14.245,8.244 L14.239,14.363 C14.239,14.629 14.344,14.883 14.532,15.071 C14.719,15.259 14.973,15.364 15.239,15.364 L19.202,15.364 L29.104,36.641 C29.268,36.993 29.622,37.219 30.01,37.219 L37.093,37.219 C37.646,37.219 38.093,36.772 38.093,36.219 L38.093,30.1 C38.093,29.547 37.646,29.1 37.093,29.1 L34.856,29.1 Z" id="Amazon-IOT-RESOURCES-Lambda-function_Resource-Icon_light-bg" fill="#7AA116"></path>
    </g>
</svg>`, nx = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/IoT/Res_AWS-IoT_Thing_Windfarm_48</title>
    <g id="Icon-Resource/IoT/Res_AWS-IoT_Thing_Windfarm_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M24.589,22.323 C24.557,21.661 25.07,21.096 25.733,21.065 C25.754,21.064 25.773,21.063 25.793,21.063 C26.092,21.063 26.376,21.174 26.598,21.376 C26.837,21.593 26.976,21.888 26.991,22.209 C27.007,22.53 26.895,22.838 26.679,23.076 C26.464,23.313 26.168,23.453 25.846,23.468 C25.218,23.493 24.62,22.987 24.589,22.323 Z M28.043,20.006 L32.852,10.378 L31.063,9.483 L26.259,19.101 C26.054,19.071 25.846,19.059 25.637,19.067 C24.784,19.108 23.996,19.478 23.421,20.112 C23.113,20.45 22.892,20.844 22.754,21.266 L11.692,21.266 L11.692,23.266 L22.761,23.266 C22.931,23.785 23.22,24.259 23.635,24.635 C24.23,25.177 24.988,25.469 25.786,25.469 C25.838,25.469 25.889,25.468 25.941,25.466 C26.165,25.455 26.383,25.419 26.593,25.365 L34.017,32.789 L35.431,31.375 L28.296,24.239 C28.773,23.634 29.025,22.892 28.989,22.115 C28.95,21.309 28.611,20.57 28.043,20.006 Z M26.78,26.678 L26.79,38.126 L24.79,38.128 L24.78,26.68 L26.78,26.678 Z M39.767,38.635 C39.767,39.261 39.259,39.77 38.633,39.77 L9.423,39.77 C8.797,39.77 8.288,39.261 8.288,38.635 L8.288,9.437 C8.288,8.811 8.797,8.301 9.423,8.301 L38.633,8.301 C39.259,8.301 39.767,8.811 39.767,9.437 L39.767,38.635 Z M46.056,14.455 L46.056,12.455 L41.767,12.455 L41.767,9.437 C41.767,7.708 40.361,6.301 38.633,6.301 L35.601,6.301 L35.601,2 L33.601,2 L33.601,6.301 L30.314,6.301 L30.314,2 L28.314,2 L28.314,6.301 L25.028,6.301 L25.028,2 L23.028,2 L23.028,6.301 L19.741,6.301 L19.741,2 L17.741,2 L17.741,6.301 L14.454,6.301 L14.454,2 L12.454,2 L12.454,6.301 L9.423,6.301 C7.694,6.301 6.288,7.708 6.288,9.437 L6.288,12.455 L2,12.455 L2,14.455 L6.288,14.455 L6.288,17.742 L2,17.742 L2,19.742 L6.288,19.742 L6.288,23.028 L2,23.028 L2,25.028 L6.288,25.028 L6.288,28.315 L2,28.315 L2,30.315 L6.288,30.315 L6.288,33.602 L2,33.602 L2,35.602 L6.288,35.602 L6.288,38.635 C6.288,40.364 7.694,41.77 9.423,41.77 L12.454,41.77 L12.454,46.056 L14.454,46.056 L14.454,41.77 L17.741,41.77 L17.741,46.056 L19.741,46.056 L19.741,41.77 L23.028,41.77 L23.028,46.056 L25.028,46.056 L25.028,41.77 L28.314,41.77 L28.314,46.056 L30.314,46.056 L30.314,41.77 L33.601,41.77 L33.601,46.056 L35.601,46.056 L35.601,41.77 L38.633,41.77 C40.361,41.77 41.767,40.364 41.767,38.635 L41.767,35.602 L46.056,35.602 L46.056,33.602 L41.767,33.602 L41.767,30.315 L46.056,30.315 L46.056,28.315 L41.767,28.315 L41.767,25.028 L46.056,25.028 L46.056,23.028 L41.767,23.028 L41.767,19.742 L46.056,19.742 L46.056,17.742 L41.767,17.742 L41.767,14.455 L46.056,14.455 Z" id="Amazon-IOT-RESOURCES-IoT-thing-windfarm_Resource-Icon_light-bg" fill="#7AA116"></path>
    </g>
</svg>`, ix = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/IoT/Res_AWS-IoT_Thing_Vibration-Sensor_48</title>
    <g id="Icon-Resource/IoT/Res_AWS-IoT_Thing_Vibration-Sensor_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M30.449,30.2847 L27.167,32.0547 L26.218,30.2937 L28.258,29.1937 L27.746,25.8807 L29.198,23.9997 L27.746,22.1187 L28.258,18.8057 L26.218,17.7067 L27.167,15.9457 L30.449,17.7157 L29.853,21.5767 L31.725,23.9997 L29.853,26.4237 L30.449,30.2847 Z M37.358,23.9997 L34.303,27.3227 L35.26,32.5187 L29.996,35.8457 L28.928,34.1547 L33.049,31.5507 L32.157,26.7037 L34.641,23.9997 L32.157,21.2967 L33.049,16.4497 L28.928,13.8457 L29.996,12.1547 L35.26,15.4817 L34.303,20.6777 L37.358,23.9997 Z M19.742,29.1937 L21.782,30.2937 L20.833,32.0547 L17.551,30.2847 L18.146,26.4237 L16.274,23.9997 L18.146,21.5767 L17.551,17.7157 L20.833,15.9457 L21.782,17.7067 L19.742,18.8057 L20.254,22.1187 L18.802,23.9997 L20.254,25.8807 L19.742,29.1937 Z M14.951,31.5507 L19.072,34.1547 L18.004,35.8457 L12.74,32.5187 L13.696,27.3227 L10.641,23.9997 L13.696,20.6777 L12.74,15.4817 L18.004,12.1547 L19.072,13.8457 L14.951,16.4497 L15.843,21.2967 L13.358,23.9997 L15.843,26.7037 L14.951,31.5507 Z M24,24.9997 C23.448,24.9997 23,24.5517 23,23.9997 C23,23.4487 23.448,22.9997 24,22.9997 C24.552,22.9997 25,23.4487 25,23.9997 C25,24.5517 24.552,24.9997 24,24.9997 L24,24.9997 Z M24,20.9997 C22.345,20.9997 21,22.3457 21,23.9997 C21,25.6547 22.345,26.9997 24,26.9997 C25.654,26.9997 27,25.6547 27,23.9997 C27,22.3457 25.654,20.9997 24,20.9997 L24,20.9997 Z M39,37.8657 C39,38.4907 38.491,38.9997 37.865,38.9997 L10.135,38.9997 C9.509,38.9997 9,38.4907 9,37.8657 L9,10.1347 C9,9.5097 9.509,8.9997 10.135,8.9997 L37.865,8.9997 C38.491,8.9997 39,9.5097 39,10.1347 L39,37.8657 Z M46,14.9997 L46,12.9997 L41,12.9997 L41,10.1347 C41,8.4067 39.594,6.9997 37.865,6.9997 L35,6.9997 L35,1.9997 L33,1.9997 L33,6.9997 L30,6.9997 L30,1.9997 L28,1.9997 L28,6.9997 L25,6.9997 L25,1.9997 L23,1.9997 L23,6.9997 L20,6.9997 L20,1.9997 L18,1.9997 L18,6.9997 L15,6.9997 L15,1.9997 L13,1.9997 L13,6.9997 L10.135,6.9997 C8.406,6.9997 7,8.4067 7,10.1347 L7,12.9997 L2,12.9997 L2,14.9997 L7,14.9997 L7,17.9997 L2,17.9997 L2,19.9997 L7,19.9997 L7,22.9997 L2,22.9997 L2,24.9997 L7,24.9997 L7,27.9997 L2,27.9997 L2,29.9997 L7,29.9997 L7,32.9997 L2,32.9997 L2,34.9997 L7,34.9997 L7,37.8657 C7,39.5937 8.406,40.9997 10.135,40.9997 L13,40.9997 L13,45.9997 L15,45.9997 L15,40.9997 L18,40.9997 L18,45.9997 L20,45.9997 L20,40.9997 L23,40.9997 L23,45.9997 L25,45.9997 L25,40.9997 L28,40.9997 L28,45.9997 L30,45.9997 L30,40.9997 L33,40.9997 L33,45.9997 L35,45.9997 L35,40.9997 L37.865,40.9997 C39.594,40.9997 41,39.5937 41,37.8657 L41,34.9997 L46,34.9997 L46,32.9997 L41,32.9997 L41,29.9997 L46,29.9997 L46,27.9997 L41,27.9997 L41,24.9997 L46,24.9997 L46,22.9997 L41,22.9997 L41,19.9997 L46,19.9997 L46,17.9997 L41,17.9997 L41,14.9997 L46,14.9997 Z" id="Fill-1" fill="#7AA116"></path>
    </g>
</svg>`, sx = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/IoT/Res_AWS-IoT-Device-Defender_IoT-Device-Jobs_48</title>
    <g id="Icon-Resource/IoT/Res_AWS-IoT-Device-Defender_IoT-Device-Jobs_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M10,17 L21,17 L21,15 L10,15 L10,17 Z M10,12 L27,12 L27,10 L10,10 L10,12 Z M30.5,33 C28.571,33 27,31.43 27,29.5 C27,27.57 28.571,26 30.5,26 C32.43,26 34,27.57 34,29.5 C34,31.43 32.43,33 30.5,33 L30.5,33 Z M30.5,24 C27.467,24 25,26.467 25,29.5 C25,32.533 27.467,35 30.5,35 C33.532,35 36,32.533 36,29.5 C36,26.467 33.532,24 30.5,24 L30.5,24 Z M40,30.528 L39.315,30.488 C38.85,30.465 38.389,30.79 38.282,31.268 C38.083,32.15 37.737,32.986 37.252,33.754 C36.993,34.168 37.069,34.709 37.432,35.033 L37.944,35.49 L36.491,36.944 L36.038,36.436 C35.711,36.07 35.168,35.994 34.756,36.256 C33.989,36.74 33.151,37.088 32.268,37.287 C31.79,37.395 31.461,37.832 31.489,38.32 L31.528,39 L29.471,39 L29.51,38.318 C29.54,37.831 29.209,37.395 28.733,37.286 C27.852,37.087 27.014,36.739 26.245,36.254 C25.833,35.993 25.29,36.068 24.965,36.434 L24.508,36.945 L23.055,35.49 L23.565,35.036 C23.93,34.711 24.006,34.17 23.747,33.756 C23.262,32.988 22.915,32.15 22.715,31.268 C22.608,30.79 22.161,30.465 21.682,30.488 L21,30.527 L21,28.472 L21.687,28.512 C22.149,28.531 22.61,28.211 22.719,27.734 C22.92,26.851 23.266,26.015 23.75,25.25 C24.012,24.837 23.936,24.295 23.571,23.97 L23.055,23.51 L24.51,22.055 L24.969,22.57 C25.295,22.936 25.836,23.01 26.25,22.75 C27.014,22.268 27.85,21.922 28.733,21.723 C29.209,21.614 29.54,21.178 29.51,20.689 L29.471,20 L31.528,20 L31.489,20.69 C31.461,21.178 31.79,21.615 32.266,21.723 C33.149,21.923 33.985,22.27 34.75,22.752 C35.161,23.012 35.704,22.938 36.03,22.572 L36.491,22.055 L37.946,23.51 L37.43,23.969 C37.067,24.294 36.991,24.836 37.25,25.248 C37.735,26.014 38.081,26.85 38.282,27.733 C38.389,28.211 38.85,28.531 39.313,28.512 L40,28.472 L40,30.528 Z M41.686,26.686 C41.487,26.498 41.215,26.404 40.944,26.414 L40.008,26.469 C39.838,25.935 39.624,25.418 39.368,24.921 L40.067,24.297 C40.272,24.113 40.393,23.854 40.401,23.579 C40.409,23.305 40.301,23.038 40.108,22.844 L37.157,19.893 C36.961,19.697 36.694,19.589 36.42,19.6 C36.145,19.607 35.887,19.729 35.704,19.934 L35.077,20.637 C34.581,20.38 34.065,20.166 33.532,19.996 L33.584,19.057 C33.6,18.782 33.502,18.514 33.313,18.313 C33.125,18.113 32.862,18 32.586,18 L28.413,18 C28.137,18 27.875,18.113 27.686,18.313 C27.497,18.514 27.399,18.782 27.415,19.057 L27.467,19.994 C26.936,20.164 26.418,20.378 25.922,20.635 L25.297,19.934 C25.114,19.729 24.854,19.607 24.579,19.6 C24.307,19.592 24.038,19.697 23.844,19.893 L20.893,22.844 C20.698,23.038 20.592,23.305 20.6,23.579 C20.608,23.854 20.729,24.113 20.934,24.297 L21.635,24.922 C21.377,25.419 21.163,25.936 20.993,26.469 L20.057,26.414 C19.786,26.402 19.512,26.498 19.313,26.686 C19.114,26.875 19,27.139 19,27.413 L19,31.587 C19,31.861 19.114,32.125 19.313,32.314 C19.514,32.503 19.772,32.6 20.057,32.586 L20.989,32.532 C21.159,33.066 21.372,33.584 21.629,34.082 L20.934,34.703 C20.729,34.886 20.608,35.146 20.6,35.42 C20.592,35.695 20.698,35.962 20.893,36.156 L23.844,39.107 C24.038,39.303 24.303,39.416 24.579,39.4 C24.854,39.393 25.114,39.271 25.297,39.066 L25.918,38.37 C26.417,38.628 26.934,38.843 27.467,39.014 L27.415,39.943 C27.399,40.217 27.497,40.486 27.686,40.687 C27.875,40.887 28.137,41 28.413,41 L32.586,41 C32.862,41 33.125,40.887 33.315,40.687 C33.502,40.486 33.6,40.217 33.584,39.943 L33.532,39.015 C34.067,38.845 34.584,38.63 35.084,38.371 L35.704,39.066 C35.885,39.271 36.145,39.393 36.42,39.4 C36.668,39.418 36.961,39.303 37.157,39.107 L40.108,36.156 C40.301,35.962 40.409,35.695 40.401,35.421 C40.393,35.146 40.272,34.887 40.067,34.703 L39.368,34.08 C39.625,33.583 39.84,33.065 40.01,32.531 L40.944,32.586 C41.213,32.598 41.487,32.502 41.686,32.314 C41.887,32.125 42,31.861 42,31.587 L42,27.413 C42,27.139 41.887,26.875 41.686,26.686 L41.686,26.686 Z M32,5.414 L36.586,10 L32,10 L32,5.414 Z M38,44 L8,44 L8,4 L30,4 L30,11 C30,11.553 30.448,12 31,12 L38,12 L38,17 L40,17 L40,11 L39.991,11 C39.991,10.74 39.898,10.484 39.708,10.293 L31.708,2.293 C31.516,2.102 31.26,2.01 31,2.01 L31,2 L7,2 C6.448,2 6,2.447 6,3 L6,45 C6,45.553 6.448,46 7,46 L39,46 C39.553,46 40,45.553 40,45 L40,41 L38,41 L38,44 Z" id="AWS-IoT-Device-Defender-RESOURCES-IoT-Device-Jobs_Resource-Icon_light-bg" fill="#7AA116"></path>
    </g>
</svg>`, rx = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/IoT/Res_AWS-IoT-Device-Management_Fleet-Hub_48</title>
    <g id="Icon-Resource/IoT/Res_AWS-IoT-Device-Management_Fleet-Hub_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M29.0596,44 C28.0526,44 26.9436,43.717 25.7026,43.15 C27.4366,41.665 29.0596,39.417 29.8436,37.339 C31.3666,36.773 32.4596,35.317 32.4596,33.6 C32.4596,33.258 32.4036,32.932 32.3226,32.615 C33.6506,31 34.4866,29.059 34.7556,26.99 C36.9886,28.748 38.3366,31.458 38.3366,34.338 C38.3366,39.576 34.0886,44 29.0596,44 L29.0596,44 Z M9.6606,34.338 C9.6606,31.428 10.7246,28.94 12.6036,27.258 C12.9086,29.216 13.7306,31.057 15.0006,32.607 C14.9176,32.926 14.8606,33.255 14.8606,33.6 C14.8606,35.319 15.9556,36.775 17.4806,37.34 C18.2556,39.325 20.0076,41.602 21.8826,43.14 C20.7496,43.621 19.4396,44 18.2596,44 C13.3576,44 9.6606,39.846 9.6606,34.338 L9.6606,34.338 Z M23.6646,16 C27.9846,16 31.7666,19.342 32.6586,23.606 C30.8886,23.002 28.9736,22.847 27.0856,23.166 C26.3876,21.995 25.1206,21.2 23.6606,21.2 C22.2206,21.2 20.9666,21.972 20.2626,23.116 C18.3476,22.842 16.4166,23.063 14.6426,23.73 C15.4916,19.402 19.3026,16 23.6646,16 L23.6646,16 Z M31.2396,30.734 C30.6336,30.146 29.8406,29.762 28.9606,29.651 C28.5206,28.682 27.9386,27.774 27.2366,26.955 C27.4996,26.423 27.6606,25.833 27.6606,25.2 C27.6606,25.164 27.6506,25.131 27.6496,25.095 C29.4386,24.837 31.2386,25.097 32.8466,25.826 C32.7916,27.601 32.2326,29.295 31.2396,30.734 L31.2396,30.734 Z M28.4596,35.6 C27.3576,35.6 26.4596,34.703 26.4596,33.6 C26.4596,32.497 27.3576,31.6 28.4596,31.6 C29.5626,31.6 30.4596,32.497 30.4596,33.6 C30.4596,34.703 29.5626,35.6 28.4596,35.6 L28.4596,35.6 Z M18.8606,31.6 C19.9626,31.6 20.8606,32.497 20.8606,33.6 C20.8606,34.703 19.9626,35.6 18.8606,35.6 C17.7576,35.6 16.8606,34.703 16.8606,33.6 C16.8606,32.497 17.7576,31.6 18.8606,31.6 L18.8606,31.6 Z M20.2086,27.185 C19.5996,27.934 19.0866,28.751 18.6896,29.617 C17.6806,29.661 16.7676,30.071 16.0866,30.729 C15.1196,29.326 14.5636,27.689 14.4806,25.979 C16.0746,25.185 17.8726,24.857 19.6746,25.057 C19.6726,25.105 19.6606,25.151 19.6606,25.2 C19.6606,25.926 19.8696,26.598 20.2086,27.185 L20.2086,27.185 Z M23.6606,27.2 C22.5576,27.2 21.6606,26.303 21.6606,25.2 C21.6606,24.097 22.5576,23.2 23.6606,23.2 C24.7626,23.2 25.6606,24.097 25.6606,25.2 C25.6606,26.303 24.7626,27.2 23.6606,27.2 L23.6606,27.2 Z M24.4596,33.6 C24.4596,34.043 24.5496,34.462 24.6826,34.861 C24.0106,34.923 23.3196,34.914 22.6476,34.828 C22.7746,34.439 22.8606,34.031 22.8606,33.6 C22.8606,32.058 21.9746,30.733 20.6926,30.065 C20.9546,29.558 21.2616,29.075 21.6146,28.619 C22.2146,28.98 22.9096,29.2 23.6606,29.2 C24.4986,29.2 25.2756,28.939 25.9186,28.497 C26.2816,28.948 26.6046,29.426 26.8756,29.931 C25.4566,30.546 24.4596,31.958 24.4596,33.6 L24.4596,33.6 Z M23.8146,42.098 C22.2746,41.036 20.6566,39.183 19.7496,37.492 C20.3806,37.348 20.9466,37.048 21.4256,36.643 C22.1986,36.817 23.0016,36.911 23.8206,36.911 C24.5526,36.911 25.2616,36.826 25.9486,36.688 C26.4246,37.076 26.9806,37.365 27.5986,37.501 C26.7276,39.271 25.2486,41.081 23.8146,42.098 L23.8146,42.098 Z M34.8126,24.612 C34.3436,18.698 29.4926,14 23.6646,14 C17.7656,14 12.8656,18.808 12.4946,24.833 C9.4656,26.824 7.6606,30.321 7.6606,34.338 C7.6606,40.877 12.3166,46 18.2596,46 C20.5106,46 22.7216,45.01 23.8146,44.438 C25.7446,45.484 27.4676,46 29.0596,46 C35.1726,46 40.3366,40.66 40.3366,34.338 C40.3366,30.362 38.2206,26.656 34.8126,24.612 L34.8126,24.612 Z M13.9986,8.001 L15.9976,8.001 L15.9976,6.001 L13.9986,6.001 L13.9986,8.001 Z M9.9996,8.001 L11.9976,8.001 L11.9976,6.001 L9.9996,6.001 L9.9996,8.001 Z M6.0006,8.001 L7.9986,8.001 L7.9986,6.001 L6.0006,6.001 L6.0006,8.001 Z M3.9996,10.001 L43.9996,10.001 L43.9996,4 L3.9996,4 L3.9996,10.001 Z M44.9996,2 L2.9996,2 C2.4476,2 1.9996,2.448 1.9996,3 L1.9996,34 C1.9996,34.552 2.4476,35 2.9996,35 L5.9996,35 L5.9996,33 L3.9996,33 L3.9996,12.001 L43.9996,12.001 L43.9996,33 L41.9996,33 L41.9996,35 L44.9996,35 C45.5526,35 45.9996,34.552 45.9996,34 L45.9996,3 C45.9996,2.448 45.5526,2 44.9996,2 L44.9996,2 Z" id="Fill-1" fill="#7AA116"></path>
    </g>
</svg>`, ox = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/IoT/Res_AWS-IoT_Topic_48</title>
    <g id="Icon-Resource/IoT/Res_AWS-IoT_Topic_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M11,39.954 L11,14.329 C13.77,15.995 19.001,16.648 23.998,16.648 C28.807,16.648 34.168,15.972 36.996,14.241 L36.996,39.954 C36.996,41.568 31.933,43.914 23.998,43.914 C16.063,43.914 11,41.568 11,39.954 Z M38.97,11.32 C38.958,11.169 38.951,11.015 38.916,10.876 C38.578,9.473 37.218,8.279 34.871,7.331 L34.121,9.185 C35.738,9.839 36.804,10.645 36.974,11.351 C36.977,11.367 36.977,11.384 36.979,11.4 C36.813,12.696 32.598,14.477 25.06,14.633 L22.922,14.633 C15.231,14.483 11.104,12.756 11.01,11.466 C11.014,11.426 11.015,11.386 11.025,11.343 C11.192,10.645 12.258,9.839 13.875,9.185 L13.125,7.331 C10.778,8.279 9.418,9.473 9.083,10.867 C9.038,11.045 9.022,11.234 9.015,11.42 L9,11.42 C9,11.44 9.007,11.458 9.008,11.477 C9.007,11.498 9,11.518 9,11.538 L9,39.954 C9,43.825 16.727,45.914 23.998,45.914 C31.269,45.914 38.996,43.825 38.996,39.954 L38.996,11.538 C38.996,11.5 38.984,11.464 38.982,11.425 C38.984,11.39 38.996,11.356 38.996,11.32 L38.97,11.32 Z M23.998,9.001 L18.656,4 L29.34,4 L23.998,9.001 Z M17.124,5.307 L23.314,11.101 C23.507,11.28 23.753,11.37 23.998,11.37 C24.243,11.37 24.489,11.28 24.682,11.101 L30.872,5.307 L30.872,12.536 L32.872,12.536 L32.872,3 C32.872,2.447 32.425,2 31.872,2 L16.124,2 C15.571,2 15.124,2.447 15.124,3 L15.124,12.536 L17.124,12.536 L17.124,5.307 Z" id="Amazon-IOT-RESOURCES-IoT-topic_Resource-Icon_light-bg" fill="#7AA116"></path>
    </g>
</svg>`, lx = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/IoT/Res_AWS-IoT_Certificate_48</title>
    <g id="Icon-Resource/IoT/Res_AWS-IoT_Certificate_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M29.9482,35.041 L31.9482,35.041 L31.9482,45 C31.9482,45.371 31.7422,45.712 31.4142,45.885 C31.2672,45.962 31.1072,46 30.9482,46 C30.7492,46 30.5522,45.94 30.3822,45.824 L24.0202,41.45 L17.6592,45.824 C17.3522,46.034 16.9562,46.058 16.6272,45.885 C16.2992,45.712 16.0932,45.371 16.0932,45 L16.0932,35.041 L18.0932,35.041 L18.0932,43.099 L23.4542,39.412 C23.7962,39.178 24.2452,39.178 24.5872,39.412 L29.9482,43.099 L29.9482,35.041 Z M9.0002,19.02 C9.0002,10.738 15.7382,4 24.0202,4 C32.3022,4 39.0412,10.738 39.0412,19.02 C39.0412,27.303 32.3022,34.041 24.0202,34.041 C15.7382,34.041 9.0002,27.303 9.0002,19.02 Z M7.0002,19.02 C7.0002,28.405 14.6352,36.041 24.0202,36.041 C33.4052,36.041 41.0412,28.405 41.0412,19.02 C41.0412,9.636 33.4052,2 24.0202,2 C14.6352,2 7.0002,9.636 7.0002,19.02 Z M15.2682,19.453 C15.2682,18.987 15.6472,18.608 16.1142,18.608 C16.5802,18.608 16.9592,18.987 16.9592,19.453 C16.9592,19.919 16.5802,20.298 16.1142,20.298 C15.6472,20.298 15.2682,19.919 15.2682,19.453 Z M13.2682,19.453 C13.2682,21.021 14.5452,22.298 16.1142,22.298 C17.6822,22.298 18.9592,21.021 18.9592,19.453 C18.9592,17.885 17.6822,16.608 16.1142,16.608 C14.5452,16.608 13.2682,17.885 13.2682,19.453 Z M34.6482,20.186 L23.7302,20.186 C23.2902,20.186 22.9012,20.474 22.7732,20.895 C22.1182,23.061 20.1832,24.515 17.9592,24.515 C15.1682,24.515 12.8962,22.244 12.8962,19.453 C12.8962,16.662 15.1682,14.392 17.9592,14.392 C20.1832,14.392 22.1182,15.847 22.7732,18.012 C22.9012,18.434 23.2902,18.722 23.7302,18.722 L25.6012,18.722 C25.8792,18.722 26.1432,18.606 26.3322,18.404 L27.1832,17.493 L28.0332,18.404 C28.2222,18.606 28.4872,18.722 28.7642,18.722 L29.8192,18.722 C30.0962,18.722 30.3612,18.606 30.5512,18.404 L31.4002,17.493 L32.2502,18.404 C32.4392,18.606 32.7042,18.722 32.9812,18.722 L34.2052,18.722 L35.2222,19.558 L34.6482,20.186 Z M35.1972,16.948 C35.0182,16.802 34.7942,16.722 34.5622,16.722 L33.4162,16.722 L32.1322,15.345 C31.7532,14.94 31.0482,14.94 30.6692,15.345 L29.3852,16.722 L29.1992,16.722 L27.9152,15.345 C27.7252,15.143 27.4612,15.027 27.1832,15.027 C26.9062,15.027 26.6412,15.143 26.4532,15.345 L25.1672,16.722 L24.4322,16.722 C23.3362,14.104 20.8202,12.392 17.9592,12.392 C14.0642,12.392 10.8962,15.56 10.8962,19.453 C10.8962,23.347 14.0642,26.515 17.9592,26.515 C20.8202,26.515 23.3362,24.804 24.4322,22.186 L35.0902,22.186 C35.3712,22.186 35.6382,22.067 35.8282,21.86 L37.4102,20.128 C37.5952,19.925 37.6882,19.655 37.6692,19.382 C37.6492,19.107 37.5182,18.854 37.3062,18.68 L35.1972,16.948 Z" id="Amazon-IOT-RESOURCES-IoT-certificate_Resource-Icon_light-bg" fill="#7AA116"></path>
    </g>
</svg>`, Lx = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/IoT/Res_AWS-IoT_Thing_Relay_48</title>
    <g id="Icon-Resource/IoT/Res_AWS-IoT_Thing_Relay_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M22,33 L24,33 L24,15 L22,15 L22,33 Z M31,30 C30.173,30 29.5,29.327 29.5,28.5 C29.5,27.672 30.173,27 31,27 C31.827,27 32.5,27.672 32.5,28.5 C32.5,29.327 31.827,30 31,30 L31,30 Z M32.823,25.526 C32.291,25.198 31.67,25 31,25 C29.07,25 27.5,26.57 27.5,28.5 C27.5,30.08 28.56,31.403 30,31.836 L30,36 L32,36 L32,31.836 C33.44,31.403 34.5,30.08 34.5,28.5 C34.5,27.986 34.383,27.502 34.184,27.063 L38.1,21.581 L36.473,20.418 L32.823,25.526 Z M31,18 C31.827,18 32.5,18.672 32.5,19.5 C32.5,20.327 31.827,21 31,21 C30.173,21 29.5,20.327 29.5,19.5 C29.5,18.672 30.173,18 31,18 L31,18 Z M31,23 C32.93,23 34.5,21.429 34.5,19.5 C34.5,17.919 33.44,16.596 32,16.163 L32,12 L30,12 L30,16.163 C28.56,16.596 27.5,17.919 27.5,19.5 C27.5,21.429 29.07,23 31,23 L31,23 Z M18.485,21.363 C19.424,22.017 20,22.939 20,23.977 C20,25.014 19.424,25.937 18.485,26.59 C19.424,27.244 20,28.167 20,29.204 C20,30.982 18.309,32.422 16,32.749 L16,36 L14,36 L14,31.818 C14,31.266 14.447,30.818 15,30.818 C16.717,30.818 18,29.966 18,29.204 C18,28.442 16.717,27.59 15,27.59 C14.447,27.59 14,27.143 14,26.59 C14,26.038 14.447,25.59 15,25.59 C16.717,25.59 18,24.738 18,23.977 C18,23.215 16.717,22.363 15,22.363 C14.447,22.363 14,21.916 14,21.363 C14,20.811 14.447,20.363 15,20.363 C16.717,20.363 18,19.511 18,18.75 C18,17.988 16.717,17.136 15,17.136 C14.447,17.136 14,16.688 14,16.136 L14,12 L16,12 L16,15.205 C18.309,15.531 20,16.971 20,18.75 C20,19.787 19.424,20.71 18.485,21.363 L18.485,21.363 Z M39,37.865 C39,38.491 38.491,39 37.865,39 L10.135,39 C9.509,39 9,38.491 9,37.865 L9,10.135 C9,9.509 9.509,9 10.135,9 L37.865,9 C38.491,9 39,9.509 39,10.135 L39,37.865 Z M46,15 L46,13 L41,13 L41,10.135 C41,8.406 39.594,7 37.865,7 L35,7 L35,2 L33,2 L33,7 L30,7 L30,2 L28,2 L28,7 L25,7 L25,2 L23,2 L23,7 L20,7 L20,2 L18,2 L18,7 L15,7 L15,2 L13,2 L13,7 L10.135,7 C8.406,7 7,8.406 7,10.135 L7,13 L2,13 L2,15 L7,15 L7,18 L2,18 L2,20 L7,20 L7,23 L2,23 L2,25 L7,25 L7,28 L2,28 L2,30 L7,30 L7,33 L2,33 L2,35 L7,35 L7,37.865 C7,39.594 8.406,41 10.135,41 L13,41 L13,46 L15,46 L15,41 L18,41 L18,46 L20,46 L20,41 L23,41 L23,46 L25,46 L25,41 L28,41 L28,46 L30,46 L30,41 L33,41 L33,46 L35,46 L35,41 L37.865,41 C39.594,41 41,39.594 41,37.865 L41,35 L46,35 L46,33 L41,33 L41,30 L46,30 L46,28 L41,28 L41,25 L46,25 L46,23 L41,23 L41,20 L46,20 L46,18 L41,18 L41,15 L46,15 Z" id="Fill-1" fill="#7AA116"></path>
    </g>
</svg>`, ax = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/IoT/Res_AWS-IoT-Analytics_Channel_48</title>
    <g id="Icon-Resource/IoT/Res_AWS-IoT-Analytics_Channel_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M29.049,23.522 C29.049,20.301 31.669,17.681 34.89,17.681 C38.111,17.681 40.731,20.301 40.731,23.522 C40.731,26.743 38.111,29.363 34.89,29.363 C31.669,29.363 29.049,26.743 29.049,23.522 Z M15.368,41.94 C15.368,40.751 16.335,39.783 17.525,39.783 C18.714,39.783 19.682,40.751 19.682,41.94 C19.682,43.13 18.714,44.097 17.525,44.097 C16.335,44.097 15.368,43.13 15.368,41.94 Z M17.525,4 C18.714,4 19.682,4.967 19.682,6.157 C19.682,7.346 18.714,8.314 17.525,8.314 C16.335,8.314 15.368,7.346 15.368,6.157 C15.368,4.967 16.335,4 17.525,4 Z M8,34.573 C8,33.384 8.968,32.416 10.158,32.416 C11.347,32.416 12.315,33.384 12.315,34.573 C12.315,35.762 11.347,36.73 10.158,36.73 C8.968,36.73 8,35.762 8,34.573 Z M10.106,24.049 C10.106,22.859 11.074,21.891 12.263,21.891 C13.453,21.891 14.42,22.859 14.42,24.049 C14.42,25.238 13.453,26.206 12.263,26.206 C11.074,26.206 10.106,25.238 10.106,24.049 Z M8,13.524 C8,12.335 8.968,11.367 10.158,11.367 C11.347,11.367 12.315,12.335 12.315,13.524 C12.315,14.714 11.347,15.681 10.158,15.681 C8.968,15.681 8,14.714 8,13.524 Z M30.107,17.324 L21.074,8.291 C21.452,7.665 21.682,6.94 21.682,6.157 C21.682,3.865 19.817,2 17.525,2 C15.233,2 13.368,3.865 13.368,6.157 C13.368,8.449 15.233,10.314 17.525,10.314 C18.308,10.314 19.034,10.084 19.66,9.705 L28.693,18.738 C28.437,19.068 28.202,19.414 28,19.783 L14.277,13.902 C14.288,13.775 14.315,13.653 14.315,13.524 C14.315,11.232 12.45,9.367 10.158,9.367 C7.866,9.367 6,11.232 6,13.524 C6,15.816 7.866,17.681 10.158,17.681 C11.61,17.681 12.886,16.93 13.629,15.8 L27.285,21.651 C27.173,22.103 27.102,22.57 27.074,23.049 L16.285,23.049 C15.834,21.24 14.208,19.891 12.263,19.891 C9.971,19.891 8.106,21.757 8.106,24.049 C8.106,26.341 9.971,28.206 12.263,28.206 C14.208,28.206 15.834,26.857 16.285,25.049 L27.201,25.049 C27.288,25.488 27.417,25.912 27.575,26.322 L13.629,32.298 C12.886,31.167 11.61,30.416 10.158,30.416 C7.866,30.416 6,32.281 6,34.573 C6,36.865 7.866,38.73 10.158,38.73 C12.45,38.73 14.315,36.865 14.315,34.573 C14.315,34.444 14.288,34.322 14.277,34.195 L28.443,28.125 L28.247,27.668 C28.518,28.1 28.828,28.504 29.176,28.875 L19.66,38.392 C19.034,38.013 18.308,37.783 17.525,37.783 C15.233,37.783 13.368,39.648 13.368,41.94 C13.368,44.232 15.233,46.097 17.525,46.097 C19.817,46.097 21.682,44.232 21.682,41.94 C21.682,41.157 21.452,40.431 21.074,39.806 L30.726,30.154 C31.934,30.916 33.359,31.363 34.89,31.363 C39.213,31.363 42.731,27.845 42.731,23.522 C42.731,19.199 39.213,15.681 34.89,15.681 C33.088,15.681 31.432,16.299 30.107,17.324 Z" id="AWS-IoT-Analytics-Channel_Resource-Icon_light-bg" fill="#7AA116"></path>
    </g>
</svg>`, Cx = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/IoT/Res_AWS-IoT_Thing_Camera_48</title>
    <g id="Icon-Resource/IoT/Res_AWS-IoT_Thing_Camera_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M16.939,20.83 C16.939,21.107 16.693,21.333 16.389,21.333 L13.973,21.333 C13.669,21.333 13.423,21.107 13.423,20.83 L13.423,20.078 C13.423,19.801 13.669,19.575 13.973,19.575 L16.389,19.575 C16.693,19.575 16.939,19.801 16.939,20.078 L16.939,20.83 Z M21.968,25.216 C21.968,23.46 23.396,22.032 25.151,22.032 C26.907,22.032 28.335,23.46 28.335,25.216 C28.335,26.971 26.907,28.398 25.151,28.398 C23.396,28.398 21.968,26.971 21.968,25.216 Z M19.968,25.216 C19.968,28.073 22.293,30.398 25.151,30.398 C28.009,30.398 30.335,28.073 30.335,25.216 C30.335,22.357 28.009,20.032 25.151,20.032 C22.293,20.032 19.968,22.357 19.968,25.216 Z M19.171,25.216 C19.171,21.919 21.854,19.236 25.151,19.236 C28.448,19.236 31.13,21.919 31.13,25.216 C31.13,28.513 28.448,31.195 25.151,31.195 C21.854,31.195 19.171,28.513 19.171,25.216 Z M17.171,25.216 C17.171,29.616 20.751,33.195 25.151,33.195 C29.551,33.195 33.13,29.616 33.13,25.216 C33.13,20.815 29.551,17.236 25.151,17.236 C20.751,17.236 17.171,20.815 17.171,25.216 Z M36.15,32.879 C36.15,33.229 35.865,33.515 35.514,33.515 L12.405,33.515 C12.054,33.515 11.769,33.229 11.769,32.879 L11.769,18.562 C11.769,18.213 12.054,17.928 12.405,17.928 L13.366,17.928 C13.385,17.929 13.403,17.939 13.423,17.939 L16.939,17.939 C16.96,17.939 16.977,17.929 16.998,17.928 L20.491,17.928 C20.964,17.928 21.373,17.596 21.469,17.132 L21.924,14.954 C21.965,14.758 22.102,14.525 22.198,14.424 L28.235,14.424 C28.331,14.525 28.467,14.758 28.508,14.955 L28.964,17.133 C29.061,17.596 29.469,17.928 29.943,17.928 L35.514,17.928 C35.865,17.928 36.15,18.213 36.15,18.562 L36.15,32.879 Z M14.423,15.385 C14.423,15.354 14.425,15.327 14.429,15.303 L15.933,15.303 C15.937,15.327 15.939,15.354 15.939,15.385 L15.939,15.928 L14.423,15.928 L14.423,15.385 Z M30.755,15.928 L30.465,14.546 C30.294,13.725 29.572,12.424 28.361,12.424 L22.072,12.424 C20.861,12.424 20.138,13.725 19.967,14.546 L19.678,15.928 L17.939,15.928 L17.939,15.385 C17.939,14.217 17.176,13.303 16.202,13.303 L14.161,13.303 C13.186,13.303 12.423,14.217 12.423,15.385 L12.423,15.928 L12.405,15.928 C10.952,15.928 9.769,17.109 9.769,18.562 L9.769,32.879 C9.769,34.332 10.952,35.515 12.405,35.515 L35.514,35.515 C36.967,35.515 38.15,34.332 38.15,32.879 L38.15,18.562 C38.15,17.109 36.967,15.928 35.514,15.928 L30.755,15.928 Z M39.664,38.53 C39.664,39.156 39.155,39.665 38.529,39.665 L9.409,39.665 C8.783,39.665 8.274,39.156 8.274,38.53 L8.274,9.423 C8.274,8.797 8.783,8.288 9.409,8.288 L38.529,8.288 C39.155,8.288 39.664,8.797 39.664,9.423 L39.664,38.53 Z M45.937,14.424 L45.937,12.424 L41.664,12.424 L41.664,9.423 C41.664,7.694 40.257,6.288 38.529,6.288 L35.513,6.288 L35.513,2 L33.513,2 L33.513,6.288 L30.241,6.288 L30.241,2 L28.241,2 L28.241,6.288 L24.968,6.288 L24.968,2 L22.968,2 L22.968,6.288 L19.696,6.288 L19.696,2 L17.696,2 L17.696,6.288 L14.423,6.288 L14.423,2 L12.423,2 L12.423,6.288 L9.409,6.288 C7.68,6.288 6.274,7.694 6.274,9.423 L6.274,12.424 L2,12.424 L2,14.424 L6.274,14.424 L6.274,17.696 L2,17.696 L2,19.696 L6.274,19.696 L6.274,22.969 L2,22.969 L2,24.969 L6.274,24.969 L6.274,28.241 L2,28.241 L2,30.241 L6.274,30.241 L6.274,33.515 L2,33.515 L2,35.515 L6.274,35.515 L6.274,38.53 C6.274,40.259 7.68,41.665 9.409,41.665 L12.423,41.665 L12.423,45.937 L14.423,45.937 L14.423,41.665 L17.696,41.665 L17.696,45.937 L19.696,45.937 L19.696,41.665 L22.968,41.665 L22.968,45.937 L24.968,45.937 L24.968,41.665 L28.241,41.665 L28.241,45.937 L30.241,45.937 L30.241,41.665 L33.513,41.665 L33.513,45.937 L35.513,45.937 L35.513,41.665 L38.529,41.665 C40.257,41.665 41.664,40.259 41.664,38.53 L41.664,35.515 L45.937,35.515 L45.937,33.515 L41.664,33.515 L41.664,30.241 L45.937,30.241 L45.937,28.241 L41.664,28.241 L41.664,24.969 L45.937,24.969 L45.937,22.969 L41.664,22.969 L41.664,19.696 L45.937,19.696 L45.937,17.696 L41.664,17.696 L41.664,14.424 L45.937,14.424 Z" id="Amazon-IOT-RESOURCES-IoT-thing-camera_Resource-Icon_light-bg" fill="#7AA116"></path>
    </g>
</svg>`, cx = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/IoT/Res_AWS-IoT_Thing_Door-Lock_48</title>
    <g id="Icon-Resource/IoT/Res_AWS-IoT_Thing_Door-Lock_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M24.7306,29.6857 C24.7306,30.1037 24.3906,30.4437 23.9726,30.4437 C23.5546,30.4437 23.2146,30.1037 23.2146,29.6857 C23.2146,29.2677 23.5546,28.9277 23.9726,28.9277 C24.3906,28.9277 24.7306,29.2677 24.7306,29.6857 Z M21.2146,29.6857 C21.2146,30.8527 21.9466,31.8467 22.9726,32.2487 L22.9726,35.3987 L24.9726,35.3987 L24.9726,32.2487 C25.9986,31.8467 26.7306,30.8527 26.7306,29.6857 C26.7306,28.1647 25.4936,26.9277 23.9726,26.9277 C22.4516,26.9277 21.2146,28.1647 21.2146,29.6857 Z M20.5776,19.1387 C20.5776,17.2667 22.1006,15.7437 23.9726,15.7437 C25.8446,15.7437 27.3676,17.2667 27.3676,19.1387 C27.3676,21.0107 25.8446,22.5327 23.9726,22.5327 C22.1006,22.5327 20.5776,21.0107 20.5776,19.1387 Z M18.5776,19.1387 C18.5776,22.1137 20.9976,24.5327 23.9726,24.5327 C26.9476,24.5327 29.3676,22.1137 29.3676,19.1387 C29.3676,16.1637 26.9476,13.7437 23.9726,13.7437 C20.9976,13.7437 18.5776,16.1637 18.5776,19.1387 Z M30.8826,36.2867 C30.8826,36.6987 30.5466,37.0347 30.1346,37.0347 L17.8096,37.0347 C17.3976,37.0347 17.0626,36.6987 17.0626,36.2867 L17.0626,12.5357 C17.0626,12.1237 17.3976,11.7887 17.8096,11.7887 L30.1346,11.7887 C30.5466,11.7887 30.8826,12.1237 30.8826,12.5357 L30.8826,36.2867 Z M17.8096,9.7887 C16.2946,9.7887 15.0626,11.0217 15.0626,12.5357 L15.0626,36.2867 C15.0626,37.8027 16.2946,39.0347 17.8096,39.0347 L30.1346,39.0347 C31.6506,39.0347 32.8826,37.8027 32.8826,36.2867 L32.8826,12.5357 C32.8826,11.0217 31.6506,9.7887 30.1346,9.7887 L17.8096,9.7887 Z M39.6696,38.5367 C39.6696,39.1627 39.1606,39.6717 38.5356,39.6717 L9.4096,39.6717 C8.7836,39.6717 8.2746,39.1627 8.2746,38.5367 L8.2746,9.4227 C8.2746,8.7967 8.7836,8.2877 9.4096,8.2877 L38.5356,8.2877 C39.1606,8.2877 39.6696,8.7967 39.6696,9.4227 L39.6696,38.5367 Z M45.9456,14.4257 L45.9456,12.4257 L41.6696,12.4257 L41.6696,9.4227 C41.6696,7.6947 40.2636,6.2877 38.5356,6.2877 L35.5196,6.2877 L35.5196,1.9997 L33.5196,1.9997 L33.5196,6.2877 L30.2456,6.2877 L30.2456,1.9997 L28.2456,1.9997 L28.2456,6.2877 L24.9726,6.2877 L24.9726,1.9997 L22.9726,1.9997 L22.9726,6.2877 L19.6996,6.2877 L19.6996,1.9997 L17.6996,1.9997 L17.6996,6.2877 L14.4256,6.2877 L14.4256,1.9997 L12.4256,1.9997 L12.4256,6.2877 L9.4096,6.2877 C7.6806,6.2877 6.2746,7.6947 6.2746,9.4227 L6.2746,12.4257 L1.9996,12.4257 L1.9996,14.4257 L6.2746,14.4257 L6.2746,17.6987 L1.9996,17.6987 L1.9996,19.6987 L6.2746,19.6987 L6.2746,22.9727 L1.9996,22.9727 L1.9996,24.9727 L6.2746,24.9727 L6.2746,28.2457 L1.9996,28.2457 L1.9996,30.2457 L6.2746,30.2457 L6.2746,33.5197 L1.9996,33.5197 L1.9996,35.5197 L6.2746,35.5197 L6.2746,38.5367 C6.2746,40.2657 7.6806,41.6717 9.4096,41.6717 L12.4256,41.6717 L12.4256,45.9457 L14.4256,45.9457 L14.4256,41.6717 L17.6996,41.6717 L17.6996,45.9457 L19.6996,45.9457 L19.6996,41.6717 L22.9726,41.6717 L22.9726,45.9457 L24.9726,45.9457 L24.9726,41.6717 L28.2456,41.6717 L28.2456,45.9457 L30.2456,45.9457 L30.2456,41.6717 L33.5196,41.6717 L33.5196,45.9457 L35.5196,45.9457 L35.5196,41.6717 L38.5356,41.6717 C40.2636,41.6717 41.6696,40.2657 41.6696,38.5367 L41.6696,35.5197 L45.9456,35.5197 L45.9456,33.5197 L41.6696,33.5197 L41.6696,30.2457 L45.9456,30.2457 L45.9456,28.2457 L41.6696,28.2457 L41.6696,24.9727 L45.9456,24.9727 L45.9456,22.9727 L41.6696,22.9727 L41.6696,19.6987 L45.9456,19.6987 L45.9456,17.6987 L41.6696,17.6987 L41.6696,14.4257 L45.9456,14.4257 Z" id="Amazon-IOT-RESOURCES-IoT-thing-door-lock_Resource-Icon_light-bg" fill="#7AA116"></path>
    </g>
</svg>`, ux = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/IoT/Res_AWS-IoT_Policy_48</title>
    <g id="Icon-Resource/IoT/Res_AWS-IoT_Policy_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M28.5196,31.7816 C28.5196,32.4576 29.0666,33.0046 29.7426,33.0046 C30.4196,33.0046 30.9666,32.4576 30.9666,31.7816 C30.9666,31.1056 30.4196,30.5576 29.7426,30.5576 C29.0666,30.5576 28.5196,31.1056 28.5196,31.7816 Z M41.3966,31.4706 L40.7286,31.4706 C40.4896,31.4706 40.2586,31.3846 40.0766,31.2286 L39.6696,30.8776 L39.2626,31.2286 C39.0806,31.3846 38.8486,31.4706 38.6096,31.4706 L37.9026,31.4706 C37.6636,31.4706 37.4316,31.3846 37.2506,31.2286 L36.8436,30.8776 L36.4346,31.2286 C36.2536,31.3846 36.0216,31.4706 35.7826,31.4706 L34.5286,31.4706 C34.1046,31.4706 33.7266,31.2036 33.5856,30.8036 C33.1806,29.6526 31.9766,28.8486 30.6606,28.8486 C28.9716,28.8486 27.5966,30.1636 27.5966,31.7816 C27.5966,33.3986 28.9716,34.7146 30.6606,34.7146 C31.9766,34.7146 33.1806,33.9116 33.5856,32.7596 C33.7266,32.3606 34.1046,32.0926 34.5286,32.0926 L41.6646,32.0926 L41.8376,31.8786 L41.3966,31.4706 Z M42.9196,33.7216 C42.7296,33.9556 42.4436,34.0926 42.1416,34.0926 L35.1736,34.0926 C34.3136,35.6656 32.5536,36.7146 30.6606,36.7146 C27.8686,36.7146 25.5966,34.5016 25.5966,31.7816 C25.5966,29.0616 27.8686,26.8486 30.6606,26.8486 C32.5536,26.8486 34.3136,27.8976 35.1736,29.4706 L35.4116,29.4706 L36.1906,28.8006 C36.5656,28.4786 37.1206,28.4786 37.4956,28.8006 L38.2566,29.4546 L39.0166,28.8006 C39.3916,28.4786 39.9466,28.4786 40.3216,28.8006 L41.0996,29.4706 L41.7896,29.4706 C42.0416,29.4706 42.2846,29.5666 42.4696,29.7376 L43.8826,31.0476 C43.9066,31.0706 43.9166,31.1006 43.9386,31.1246 C43.8136,26.0006 39.6156,21.8696 34.4626,21.8696 C29.2306,21.8696 24.9746,26.1246 24.9746,31.3566 C24.9746,36.5876 29.2306,40.8446 34.4626,40.8446 C39.2886,40.8446 43.2766,37.2186 43.8666,32.5496 L42.9196,33.7216 Z M34.4626,42.8446 C28.1286,42.8446 22.9746,37.6916 22.9746,31.3566 C22.9746,25.0226 28.1286,19.8696 34.4626,19.8696 C40.7976,19.8696 45.9506,25.0226 45.9506,31.3566 C45.9506,37.6916 40.7976,42.8446 34.4626,42.8446 Z M8.6856,35.5306 C8.8746,35.7286 9.1366,35.8406 9.4096,35.8406 C9.6826,35.8406 9.9446,35.7286 10.1346,35.5306 L15.9606,29.4116 L14.5116,28.0336 L9.4096,33.3906 L7.2196,31.0916 L5.7716,32.4706 L8.6856,35.5306 Z M8.0766,25.9336 L10.4286,23.5816 L12.7806,25.9336 L14.1946,24.5196 L11.8426,22.1676 L14.1946,19.8166 L12.7806,18.4026 L10.4286,20.7536 L8.0766,18.4026 L6.6626,19.8166 L9.0136,22.1676 L6.6626,24.5196 L8.0766,25.9336 Z M8.0766,16.3206 L10.4286,13.9686 L12.7806,16.3206 L14.1946,14.9066 L11.8426,12.5546 L14.1946,10.2026 L12.7806,8.7876 L10.4286,11.1406 L8.0766,8.7876 L6.6626,10.2026 L9.0136,12.5546 L6.6626,14.9066 L8.0766,16.3206 Z M22.8656,36.4616 L22.8656,38.4616 L4.1536,38.4616 C2.9666,38.4616 2.0006,37.4956 2.0006,36.3086 L2.0006,7.1536 C2.0006,5.9656 2.9666,4.9996 4.1536,4.9996 L25.4436,4.9996 C26.6316,4.9996 27.5966,5.9656 27.5966,7.1536 L27.5966,20.8666 L25.5966,20.8666 L25.5966,7.1536 C25.5966,7.0676 25.5296,6.9996 25.4436,6.9996 L4.1536,6.9996 C4.0676,6.9996 4.0006,7.0676 4.0006,7.1536 L4.0006,36.3086 C4.0006,36.3946 4.0676,36.4616 4.1536,36.4616 L22.8656,36.4616 Z" id="Amazon-IOT-RESOURCES-IoT-Policy_Resource-Icon_light-bg" fill="#7AA116"></path>
    </g>
</svg>`, hx = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/IoT/Res_AWS-IoT_Thing_FreeRTOS-Device_48</title>
    <g id="Icon-Resource/IoT/Res_AWS-IoT_Thing_FreeRTOS-Device_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M33.572,25.29 C32.606,25.29 31.82,24.504 31.82,23.539 C31.82,22.573 32.606,21.787 33.572,21.787 C34.538,21.787 35.324,22.573 35.324,23.539 C35.324,24.504 34.538,25.29 33.572,25.29 L33.572,25.29 Z M29,30.325 L29,24 L29.867,24 C30.023,25.251 30.789,26.304 31.865,26.86 C31.243,28.244 30.243,29.444 29,30.325 L29,30.325 Z M25,31.85 L25,17.6 C26.088,17.329 26.983,16.586 27.464,15.597 C29.504,16.475 31.106,18.111 31.953,20.169 C31.161,20.552 30.522,21.197 30.159,22 L28,22 C27.447,22 27,22.448 27,23 L27,31.375 C26.361,31.615 25.688,31.776 25,31.85 L25,31.85 Z M21,31.304 L21,23 C21,22.448 20.552,22 20,22 L18.038,22 C17.676,21.198 17.037,20.552 16.246,20.17 C17.092,18.114 18.696,16.477 20.734,15.599 C21.185,16.526 22.002,17.23 23,17.539 L23,31.82 C22.313,31.731 21.637,31.563 21,31.304 L21,31.304 Z M17.58,28.845 C17.548,28.808 17.514,28.771 17.451,28.685 C17.004,28.129 16.632,27.507 16.339,26.856 C17.412,26.299 18.175,25.248 18.33,24 L19,24 L19,30.186 C18.479,29.795 18,29.35 17.58,28.845 L17.58,28.845 Z M12.874,23.539 C12.874,22.573 13.66,21.787 14.626,21.787 C15.592,21.787 16.377,22.573 16.377,23.539 C16.377,24.504 15.592,25.29 14.626,25.29 C13.66,25.29 12.874,24.504 12.874,23.539 L12.874,23.539 Z M24.098,12.218 C25.064,12.218 25.85,13.004 25.85,13.97 C25.85,14.936 25.064,15.722 24.098,15.722 C23.133,15.722 22.346,14.936 22.346,13.97 C22.346,13.004 23.133,12.218 24.098,12.218 L24.098,12.218 Z M33.954,19.825 C32.906,16.941 30.676,14.682 27.812,13.598 C27.623,11.706 26.039,10.218 24.098,10.218 C22.157,10.218 20.573,11.707 20.384,13.6 C17.522,14.684 15.292,16.944 14.245,19.825 C12.357,20.019 10.874,21.6 10.874,23.539 C10.874,25.509 12.406,27.111 14.339,27.261 C14.718,28.219 15.228,29.112 15.856,29.889 C15.917,29.975 15.989,30.061 16.051,30.135 C16.873,31.124 17.881,31.951 19,32.571 L19,37 L21,37 L21,33.426 C21.646,33.63 22.314,33.77 23,33.842 L23,37 L25,37 L25,33.859 C25.685,33.801 26.355,33.679 27,33.49 L27,37 L29,37 L29,32.674 C31.197,31.509 32.933,29.566 33.85,27.262 C35.787,27.117 37.324,25.512 37.324,23.539 C37.324,21.601 35.842,20.02 33.954,19.825 L33.954,19.825 Z M39,37.865 C39,38.491 38.491,39 37.865,39 L10.135,39 C9.509,39 9,38.491 9,37.865 L9,10.135 C9,9.509 9.509,9 10.135,9 L37.865,9 C38.491,9 39,9.509 39,10.135 L39,37.865 Z M46,15 L46,13 L41,13 L41,10.135 C41,8.406 39.593,7 37.865,7 L35,7 L35,2 L33,2 L33,7 L30,7 L30,2 L28,2 L28,7 L25,7 L25,2 L23,2 L23,7 L20,7 L20,2 L18,2 L18,7 L15,7 L15,2 L13,2 L13,7 L10.135,7 C8.406,7 7,8.406 7,10.135 L7,13 L2,13 L2,15 L7,15 L7,18 L2,18 L2,20 L7,20 L7,23 L2,23 L2,25 L7,25 L7,28 L2,28 L2,30 L7,30 L7,33 L2,33 L2,35 L7,35 L7,37.865 C7,39.594 8.406,41 10.135,41 L13,41 L13,46 L15,46 L15,41 L18,41 L18,46 L20,46 L20,41 L23,41 L23,46 L25,46 L25,41 L28,41 L28,46 L30,46 L30,41 L33,41 L33,46 L35,46 L35,41 L37.865,41 C39.593,41 41,39.594 41,37.865 L41,35 L46,35 L46,33 L41,33 L41,30 L46,30 L46,28 L41,28 L41,25 L46,25 L46,23 L41,23 L41,20 L46,20 L46,18 L41,18 L41,15 L46,15 Z" id="Fill-1" fill="#7AA116"></path>
    </g>
</svg>`, dx = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/IoT/Res_AWS-IoT-SiteWise_Asset-Properties_48</title>
    <g id="Icon-Resource/IoT/Res_AWS-IoT-SiteWise_Asset-Properties_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M20,32 C18.346,32 17,33.346 17,35 C17,36.654 18.346,38 20,38 C21.654,38 23,36.654 23,35 C23,33.346 21.654,32 20,32 L20,32 Z M20,40 C17.243,40 15,37.757 15,35 C15,32.243 17.243,30 20,30 C22.757,30 25,32.243 25,35 C25,37.757 22.757,40 20,40 L20,40 Z M29,21 C27.346,21 26,22.346 26,24 C26,25.654 27.346,27 29,27 C30.654,27 32,25.654 32,24 C32,22.346 30.654,21 29,21 L29,21 Z M29,29 C26.243,29 24,26.757 24,24 C24,21.243 26.243,19 29,19 C31.757,19 34,21.243 34,24 C34,26.757 31.757,29 29,29 L29,29 Z M17,10 C15.346,10 14,11.346 14,13 C14,14.654 15.346,16 17,16 C18.654,16 20,14.654 20,13 C20,11.346 18.654,10 17,10 L17,10 Z M17,18 C14.243,18 12,15.757 12,13 C12,10.243 14.243,8 17,8 C19.757,8 22,10.243 22,13 C22,15.757 19.757,18 17,18 L17,18 Z M6,36 L13,36 L13,34 L6,34 L6,36 Z M27,36 L42,36 L42,34 L27,34 L27,36 Z M6,25 L22,25 L22,23 L6,23 L6,25 Z M36,25 L42,25 L42,23 L36,23 L36,25 Z M6,14 L10,14 L10,12 L6,12 L6,14 Z M24,14 L42,14 L42,12 L24,12 L24,14 Z M4,44 L44,44 L44,4 L4,4 L4,44 Z M45,46 L3,46 C2.448,46 2,45.552 2,45 L2,3 C2,2.448 2.448,2 3,2 L45,2 C45.552,2 46,2.448 46,3 L46,45 C46,45.552 45.552,46 45,46 L45,46 Z" id="Fill-1" fill="#7AA116"></path>
    </g>
</svg>`, gx = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/IoT/Res_AWS-IoT_Thing_Temperature-Vibration-Sensor_48</title>
    <g id="Icon-Resource/IoT/Res_AWS-IoT_Thing_Temperature-Vibration-Sensor_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M24,32.9775 C23.448,32.9775 23,32.5285 23,31.9775 C23,31.4265 23.448,30.9775 24,30.9775 C24.552,30.9775 25,31.4265 25,31.9775 C25,32.5285 24.552,32.9775 24,32.9775 L24,32.9775 Z M25,29.1615 L25,17.9995 L23,17.9995 L23,29.1615 C21.839,29.5765 21,30.6755 21,31.9775 C21,33.6315 22.346,34.9775 24,34.9775 C25.654,34.9775 27,33.6315 27,31.9775 C27,30.6755 26.161,29.5765 25,29.1615 L25,29.1615 Z M26.522,35.0815 C25.569,35.8575 24.364,36.1425 23.132,35.8875 C21.588,35.5665 20.356,34.2985 20.069,32.7315 C19.79,31.2055 20.363,29.7345 21.603,28.7975 L22,28.4975 L22,13.9995 C22,12.8965 22.897,11.9995 24,11.9995 C25.103,11.9995 26,12.8965 26,13.9995 L26,28.4985 L26.397,28.7975 C27.416,29.5675 28,30.7265 28,31.9775 C28,33.1865 27.462,34.3175 26.522,35.0815 L26.522,35.0815 Z M28,27.5285 L28,13.9995 C28,11.7945 26.206,9.9995 24,9.9995 C21.794,9.9995 20,11.7945 20,13.9995 L20,27.5295 C18.444,28.9235 17.721,31.0105 18.103,33.0925 C18.535,35.4515 20.393,37.3615 22.726,37.8455 C23.147,37.9335 23.571,37.9765 23.991,37.9765 C25.37,37.9765 26.706,37.5115 27.785,36.6325 C29.192,35.4875 30,33.7905 30,31.9775 C30,30.2645 29.277,28.6685 28,27.5285 L28,27.5285 Z M18.204,25.4215 L16.638,26.6655 L15.49,25.2205 L15.886,22.4155 L14.534,20.4995 L15.886,18.5835 L15.49,15.7795 L16.638,14.3345 L18.204,15.5785 L17.59,16.3515 L17.978,19.0895 L16.981,20.4995 L17.978,21.9105 L17.59,24.6485 L18.204,25.4215 Z M13.8,26.3625 L15.746,28.2895 L14.34,29.7105 L11.655,27.0545 L12.317,23.1185 L10.116,20.4995 L12.317,17.8815 L11.655,13.9455 L14.34,11.2895 L15.746,12.7105 L13.8,14.6375 L14.442,18.4615 L12.729,20.4995 L14.442,22.5385 L13.8,26.3625 Z M30,26.9995 L34,26.9995 L34,24.9995 L30,24.9995 L30,26.9995 Z M30,22.9995 L35,22.9995 L35,20.9995 L30,20.9995 L30,22.9995 Z M30,18.9995 L34,18.9995 L34,16.9995 L30,16.9995 L30,18.9995 Z M30,14.9995 L35,14.9995 L35,12.9995 L30,12.9995 L30,14.9995 Z M39,37.8655 C39,38.4905 38.491,38.9995 37.865,38.9995 L10.135,38.9995 C9.509,38.9995 9,38.4905 9,37.8655 L9,10.1345 C9,9.5095 9.509,8.9995 10.135,8.9995 L37.865,8.9995 C38.491,8.9995 39,9.5095 39,10.1345 L39,37.8655 Z M46,14.9995 L46,12.9995 L41,12.9995 L41,10.1345 C41,8.4065 39.594,6.9995 37.865,6.9995 L35,6.9995 L35,1.9995 L33,1.9995 L33,6.9995 L30,6.9995 L30,1.9995 L28,1.9995 L28,6.9995 L25,6.9995 L25,1.9995 L23,1.9995 L23,6.9995 L20,6.9995 L20,1.9995 L18,1.9995 L18,6.9995 L15,6.9995 L15,1.9995 L13,1.9995 L13,6.9995 L10.135,6.9995 C8.406,6.9995 7,8.4065 7,10.1345 L7,12.9995 L2,12.9995 L2,14.9995 L7,14.9995 L7,17.9995 L2,17.9995 L2,19.9995 L7,19.9995 L7,22.9995 L2,22.9995 L2,24.9995 L7,24.9995 L7,27.9995 L2,27.9995 L2,29.9995 L7,29.9995 L7,32.9995 L2,32.9995 L2,34.9995 L7,34.9995 L7,37.8655 C7,39.5935 8.406,40.9995 10.135,40.9995 L13,40.9995 L13,45.9995 L15,45.9995 L15,40.9995 L18,40.9995 L18,45.9995 L20,45.9995 L20,40.9995 L23,40.9995 L23,45.9995 L25,45.9995 L25,40.9995 L28,40.9995 L28,45.9995 L30,45.9995 L30,40.9995 L33,40.9995 L33,45.9995 L35,45.9995 L35,40.9995 L37.865,40.9995 C39.594,40.9995 41,39.5935 41,37.8655 L41,34.9995 L46,34.9995 L46,32.9995 L41,32.9995 L41,29.9995 L46,29.9995 L46,27.9995 L41,27.9995 L41,24.9995 L46,24.9995 L46,22.9995 L41,22.9995 L41,19.9995 L46,19.9995 L46,17.9995 L41,17.9995 L41,14.9995 L46,14.9995 Z" id="Fill-1" fill="#7AA116"></path>
    </g>
</svg>`, fx = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/IoT/Res_AWS-IoT_Thing_PLC_48</title>
    <g id="Icon-Resource/IoT/Res_AWS-IoT_Thing_PLC_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M39,10.1348 C39,9.5098 38.491,8.9998 37.865,8.9998 L10.135,8.9998 C9.509,8.9998 9,9.5098 9,10.1348 L9,37.8648 C9,38.4908 9.509,38.9998 10.135,38.9998 L37.865,38.9998 C38.491,38.9998 39,38.4908 39,37.8648 L39,10.1348 Z M41,14.9998 L41,17.9998 L46,17.9998 L46,19.9998 L41,19.9998 L41,22.9998 L46,22.9998 L46,24.9998 L41,24.9998 L41,27.9998 L46,27.9998 L46,29.9998 L41,29.9998 L41,32.9998 L46,32.9998 L46,34.9998 L41,34.9998 L41,37.8648 C41,39.5938 39.594,40.9998 37.865,40.9998 L35,40.9998 L35,45.9998 L33,45.9998 L33,40.9998 L30,40.9998 L30,45.9998 L28,45.9998 L28,40.9998 L25,40.9998 L25,45.9998 L23,45.9998 L23,40.9998 L20,40.9998 L20,45.9998 L18,45.9998 L18,40.9998 L15,40.9998 L15,45.9998 L13,45.9998 L13,40.9998 L10.135,40.9998 C8.406,40.9998 7,39.5938 7,37.8648 L7,34.9998 L2,34.9998 L2,32.9998 L7,32.9998 L7,29.9998 L2,29.9998 L2,27.9998 L7,27.9998 L7,24.9998 L2,24.9998 L2,22.9998 L7,22.9998 L7,19.9998 L2,19.9998 L2,17.9998 L7,17.9998 L7,14.9998 L2,14.9998 L2,12.9998 L7,12.9998 L7,10.1348 C7,8.4058 8.406,6.9998 10.135,6.9998 L13,6.9998 L13,1.9998 L15,1.9998 L15,6.9998 L18,6.9998 L18,1.9998 L20,1.9998 L20,6.9998 L23,6.9998 L23,1.9998 L25,1.9998 L25,6.9998 L28,6.9998 L28,1.9998 L30,1.9998 L30,6.9998 L33,6.9998 L33,1.9998 L35,1.9998 L35,6.9998 L37.865,6.9998 C39.594,6.9998 41,8.4058 41,10.1348 L41,12.9998 L46,12.9998 L46,14.9998 L41,14.9998 Z M28,34.9998 L32,34.9998 L32,12.9998 L28,12.9998 L28,34.9998 Z M22,34.9998 L26,34.9998 L26,12.9998 L22,12.9998 L22,34.9998 Z M16,34.9998 L20,34.9998 L20,12.9998 L16,12.9998 L16,34.9998 Z M34,11.9998 L34,35.9998 C34,36.5518 33.553,36.9998 33,36.9998 L28,36.9998 L26,36.9998 L22,36.9998 L20,36.9998 L15,36.9998 C14.447,36.9998 14,36.5518 14,35.9998 L14,11.9998 C14,11.4478 14.447,10.9998 15,10.9998 L33,10.9998 C33.553,10.9998 34,11.4478 34,11.9998 L34,11.9998 Z M29,15.9998 L31,15.9998 L31,13.9998 L29,13.9998 L29,15.9998 Z M23,15.9998 L25,15.9998 L25,13.9998 L23,13.9998 L23,15.9998 Z M17,15.9998 L19,15.9998 L19,13.9998 L17,13.9998 L17,15.9998 Z" id="Fill-1" fill="#7AA116"></path>
    </g>
</svg>`, px = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/IoT/Res_AWS-IoT_Action_48</title>
    <g id="Icon-Resource/IoT/Res_AWS-IoT_Action_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M32.5463,23.2744 C32.9063,23.6594 32.9063,24.2564 32.5463,24.6414 L19.4483,38.6124 L17.9893,37.2454 L30.4453,23.9584 L17.9893,10.6704 L19.4483,9.3024 L32.5463,23.2744 Z M4.0003,23.9584 C4.0003,12.9534 12.9533,4.0004 23.9583,4.0004 C34.9623,4.0004 43.9153,12.9534 43.9153,23.9584 C43.9153,34.9624 34.9623,43.9154 23.9583,43.9154 C12.9533,43.9154 4.0003,34.9624 4.0003,23.9584 Z M2.0003,23.9584 C2.0003,36.0654 11.8513,45.9154 23.9583,45.9154 C36.0663,45.9154 45.9153,36.0654 45.9153,23.9584 C45.9153,11.8504 36.0663,2.0004 23.9583,2.0004 C11.8513,2.0004 2.0003,11.8504 2.0003,23.9584 Z" id="Amazon-IOT-RESOURCES-IoT-action_Resource-Icon_light-bg" fill="#7AA116"></path>
    </g>
</svg>`, mx = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/IoT/Res_AWS-IoT_Alexa_Voice-Service_48</title>
    <g id="Icon-Resource/IoT/Res_AWS-IoT_Alexa_Voice-Service_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M38.9257,43.2585 C41.3957,41.1305 42.9307,38.1495 42.9307,35.0245 C42.9307,30.6655 39.3837,27.1185 35.0247,27.1185 C30.6647,27.1185 27.1177,30.6655 27.1177,35.0245 C27.1177,38.2025 29.0127,41.0605 31.9457,42.3065 C32.2437,42.4325 32.4367,42.7115 32.4367,43.0165 L32.4367,43.7775 C32.1087,43.6805 31.7847,43.5655 31.4697,43.4315 C28.0847,41.9925 25.8977,38.6925 25.8977,35.0245 C25.8977,29.9925 29.9917,25.8975 35.0247,25.8975 C40.0577,25.8975 44.1527,29.9925 44.1527,35.0245 C44.1527,38.3415 42.3407,41.4055 39.4257,43.0195 C39.2637,43.1095 39.0927,43.1795 38.9257,43.2585 Z M29.1177,35.0245 C29.1177,31.7675 31.7677,29.1185 35.0247,29.1185 C38.2807,29.1185 40.9307,31.7675 40.9307,35.0245 C40.9307,38.7115 38.2657,42.1715 34.4367,43.6545 L34.4367,43.0165 C34.4367,41.9075 33.7657,40.9055 32.7267,40.4655 C30.5347,39.5345 29.1177,37.3985 29.1177,35.0245 Z M9.1677,39.7485 C8.6807,39.7485 8.2837,39.3565 8.2837,38.8735 L8.2837,9.1765 C8.2837,8.6945 8.6807,8.3015 9.1677,8.3015 L38.8637,8.3015 C39.3527,8.3015 39.7487,8.6945 39.7487,9.1765 L39.7487,24.9645 C38.3127,24.2875 36.7147,23.8975 35.0247,23.8975 C28.8887,23.8975 23.8977,28.8885 23.8977,35.0245 C23.8977,36.6935 24.2697,38.2995 24.9487,39.7485 L9.1677,39.7485 Z M46.0327,25.0165 L46.0327,23.0165 L41.7487,23.0165 L41.7487,19.7325 L46.0327,19.7325 L46.0327,17.7325 L41.7487,17.7325 L41.7487,14.4485 L46.0327,14.4485 L46.0327,12.4485 L41.7487,12.4485 L41.7487,9.1765 C41.7487,7.5915 40.4547,6.3015 38.8637,6.3015 L35.5837,6.3015 L35.5837,1.9995 L33.5837,1.9995 L33.5837,6.3015 L30.3007,6.3015 L30.3007,1.9995 L28.3007,1.9995 L28.3007,6.3015 L25.0167,6.3015 L25.0167,1.9995 L23.0167,1.9995 L23.0167,6.3015 L19.7327,6.3015 L19.7327,1.9995 L17.7327,1.9995 L17.7327,6.3015 L14.4477,6.3015 L14.4477,1.9995 L12.4477,1.9995 L12.4477,6.3015 L9.1677,6.3015 C7.5777,6.3015 6.2837,7.5915 6.2837,9.1765 L6.2837,12.4485 L1.9997,12.4485 L1.9997,14.4485 L6.2837,14.4485 L6.2837,17.7325 L1.9997,17.7325 L1.9997,19.7325 L6.2837,19.7325 L6.2837,23.0165 L1.9997,23.0165 L1.9997,25.0165 L6.2837,25.0165 L6.2837,28.3005 L1.9997,28.3005 L1.9997,30.3005 L6.2837,30.3005 L6.2837,33.5835 L1.9997,33.5835 L1.9997,35.5835 L6.2837,35.5835 L6.2837,38.8735 C6.2837,40.4585 7.5777,41.7485 9.1677,41.7485 L12.4477,41.7485 L12.4477,46.0335 L14.4477,46.0335 L14.4477,41.7485 L17.7327,41.7485 L17.7327,46.0335 L19.7327,46.0335 L19.7327,41.7485 L23.0167,41.7485 L23.0167,46.0335 L25.0167,46.0335 L25.0167,39.8825 C26.1687,42.2545 28.1507,44.1935 30.6867,45.2715 C32.0597,45.8565 33.5197,46.1525 35.0247,46.1525 C36.9007,46.1525 38.7567,45.6735 40.3937,44.7695 C43.9457,42.8025 46.1527,39.0695 46.1527,35.0245 C46.1527,30.6225 43.5747,26.8195 39.8567,25.0165 L46.0327,25.0165 Z" id="Amazon-IOT-RESOURCES-Alexa-Voice-Service_Resource-Icon_light-bg" fill="#7AA116"></path>
    </g>
</svg>`, wx = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/IoT/Res_AWS-IoT_Alexa_Enabled-Device_48</title>
    <g id="Icon-Resource/IoT/Res_AWS-IoT_Alexa_Enabled-Device_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M26.7341,36.4763 C31.2031,33.6283 34.1151,28.9153 34.1151,23.9333 C34.1151,18.1353 29.3981,13.4173 23.5991,13.4173 C17.8001,13.4173 13.0821,18.1353 13.0821,23.9333 C13.0821,28.1623 15.6031,31.9643 19.5031,33.6203 C20.0541,33.8533 20.4101,34.3753 20.4101,34.9473 L20.4101,36.4683 C19.7781,36.3093 19.1531,36.1223 18.5521,35.8663 C13.7471,33.8233 10.6431,29.1393 10.6431,23.9333 C10.6431,16.7903 16.4551,10.9773 23.5991,10.9773 C30.7421,10.9773 36.5551,16.7903 36.5551,23.9333 C36.5551,28.6423 33.9841,32.9913 29.8441,35.2813 C28.8651,35.8223 27.8151,36.2103 26.7341,36.4763 Z M15.0821,23.9333 C15.0821,19.2373 18.9031,15.4173 23.5991,15.4173 C28.2951,15.4173 32.1151,19.2373 32.1151,23.9333 C32.1151,29.3333 28.1041,34.3853 22.4101,36.3673 L22.4101,34.9473 C22.4101,33.5703 21.5751,32.3263 20.2841,31.7783 C17.1241,30.4373 15.0821,27.3583 15.0821,23.9333 Z M8.6431,23.9333 C8.6431,29.9433 12.2251,35.3493 17.7701,37.7063 C18.8941,38.1833 20.0641,38.5003 21.2601,38.6893 C21.3111,38.6963 21.3591,38.7143 21.4101,38.7143 C21.4121,38.7143 21.4151,38.7133 21.4181,38.7133 C22.1361,38.8183 22.8621,38.8893 23.5991,38.8893 C26.1211,38.8893 28.6151,38.2473 30.8131,37.0313 C35.5881,34.3883 38.5551,29.3703 38.5551,23.9333 C38.5551,15.6863 31.8461,8.9773 23.5991,8.9773 C15.3521,8.9773 8.6431,15.6863 8.6431,23.9333 Z M43.8681,39.4203 C43.8681,41.8733 41.8731,43.8683 39.4211,43.8683 L8.4481,43.8683 C5.9951,43.8683 4.0001,41.8733 4.0001,39.4203 L4.0001,8.4483 C4.0001,5.9953 5.9951,4.0003 8.4481,4.0003 L39.4211,4.0003 C41.8731,4.0003 43.8681,5.9953 43.8681,8.4483 L43.8681,39.4203 Z M8.4481,2.0003 C4.8931,2.0003 2.0001,4.8923 2.0001,8.4483 L2.0001,39.4203 C2.0001,42.9753 4.8931,45.8683 8.4481,45.8683 L39.4211,45.8683 C42.9761,45.8683 45.8681,42.9753 45.8681,39.4203 L45.8681,8.4483 C45.8681,4.8923 42.9761,2.0003 39.4211,2.0003 L8.4481,2.0003 Z" id="Amazon-IOT-RESOURCES-Alexa-enabled-device_Resource-Icon_light-bg" fill="#7AA116"></path>
    </g>
</svg>`, xx = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/IoT/Res_AWS-IoT_Thing_Utility_48</title>
    <g id="Icon-Resource/IoT/Res_AWS-IoT_Thing_Utility_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M31.1651,35.006 C31.1651,34.482 31.8391,33.177 32.3651,32.223 C32.8921,33.178 33.5651,34.482 33.5651,35.006 C33.5651,35.668 33.0271,36.206 32.3651,36.206 C31.7031,36.206 31.1651,35.668 31.1651,35.006 Z M32.3651,29.165 C31.9861,29.165 31.6391,29.379 31.4701,29.718 C31.3761,29.907 31.2161,30.187 31.0261,30.521 C30.0081,32.316 29.1651,33.893 29.1651,35.006 C29.1651,36.77 30.6001,38.206 32.3651,38.206 C34.1301,38.206 35.5651,36.77 35.5651,35.006 C35.5651,33.892 34.7201,32.313 33.7001,30.516 C33.5121,30.184 33.3531,29.905 33.2601,29.718 C33.0901,29.379 32.7441,29.165 32.3651,29.165 Z M33.5651,26.524 L30.2071,26.524 L30.2071,24.879 C30.2071,23.868 29.3851,23.046 28.3751,23.046 L12.6811,23.046 L12.6811,19.723 L28.9211,19.723 C31.4811,19.723 33.5651,21.807 33.5651,24.368 L33.5651,26.524 Z M17.9631,13.323 L28.2851,13.323 L28.2851,12.682 L17.9631,12.682 L17.9631,13.323 Z M24.1241,17.723 L24.1241,15.322 L29.2851,15.322 C29.8381,15.322 30.2851,14.875 30.2851,14.322 L30.2851,11.682 C30.2851,11.129 29.8381,10.682 29.2851,10.682 L16.9631,10.682 C16.4101,10.682 15.9631,11.129 15.9631,11.682 L15.9631,14.322 C15.9631,14.875 16.4101,15.322 16.9631,15.322 L22.1241,15.322 L22.1241,17.723 L11.6811,17.723 C11.1291,17.723 10.6811,18.17 10.6811,18.723 L10.6811,24.046 C10.6811,24.599 11.1291,25.046 11.6811,25.046 L28.2071,25.046 L28.2071,27.524 C28.2071,28.077 28.6541,28.524 29.2071,28.524 L34.5651,28.524 C35.1181,28.524 35.5651,28.077 35.5651,27.524 L35.5651,24.368 C35.5651,20.704 32.5851,17.723 28.9211,17.723 L24.1241,17.723 Z M39.7251,38.592 C39.7251,39.218 39.2171,39.727 38.5911,39.727 L9.4181,39.727 C8.7921,39.727 8.2831,39.218 8.2831,38.592 L8.2831,9.431 C8.2831,8.805 8.7921,8.296 9.4181,8.296 L38.5911,8.296 C39.2171,8.296 39.7251,8.805 39.7251,9.431 L39.7251,38.592 Z M46.0081,14.441 L46.0081,12.441 L41.7251,12.441 L41.7251,9.431 C41.7251,7.702 40.3191,6.296 38.5911,6.296 L35.5651,6.296 L35.5651,2 L33.5651,2 L33.5651,6.296 L30.2851,6.296 L30.2851,2 L28.2851,2 L28.2851,6.296 L25.0041,6.296 L25.0041,2 L23.0041,2 L23.0041,6.296 L19.7231,6.296 L19.7231,2 L17.7231,2 L17.7231,6.296 L14.4421,6.296 L14.4421,2 L12.4421,2 L12.4421,6.296 L9.4181,6.296 C7.6891,6.296 6.2831,7.702 6.2831,9.431 L6.2831,12.441 L2.0001,12.441 L2.0001,14.441 L6.2831,14.441 L6.2831,17.723 L2.0001,17.723 L2.0001,19.723 L6.2831,19.723 L6.2831,23.004 L2.0001,23.004 L2.0001,25.004 L6.2831,25.004 L6.2831,28.284 L2.0001,28.284 L2.0001,30.284 L6.2831,30.284 L6.2831,33.565 L2.0001,33.565 L2.0001,35.565 L6.2831,35.565 L6.2831,38.592 C6.2831,40.32 7.6891,41.727 9.4181,41.727 L12.4421,41.727 L12.4421,46.007 L14.4421,46.007 L14.4421,41.727 L17.7231,41.727 L17.7231,46.007 L19.7231,46.007 L19.7231,41.727 L23.0041,41.727 L23.0041,46.007 L25.0041,46.007 L25.0041,41.727 L28.2851,41.727 L28.2851,46.007 L30.2851,46.007 L30.2851,41.727 L33.5651,41.727 L33.5651,46.007 L35.5651,46.007 L35.5651,41.727 L38.5911,41.727 C40.3191,41.727 41.7251,40.32 41.7251,38.592 L41.7251,35.565 L46.0081,35.565 L46.0081,33.565 L41.7251,33.565 L41.7251,30.284 L46.0081,30.284 L46.0081,28.284 L41.7251,28.284 L41.7251,25.004 L46.0081,25.004 L46.0081,23.004 L41.7251,23.004 L41.7251,19.723 L46.0081,19.723 L46.0081,17.723 L41.7251,17.723 L41.7251,14.441 L46.0081,14.441 Z" id="Amazon-IOT-RESOURCES-IoT-thing-utility_Resource-Icon-light-bg" fill="#7AA116"></path>
    </g>
</svg>`, _x = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/IoT/Res_AWS-IoT_Actuator_48</title>
    <g id="Icon-Resource/IoT/Res_AWS-IoT_Actuator_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M35.573,40.4535463 L37.922,40.4535463 L37.922,38.1045463 L35.573,38.1045463 L35.573,40.4535463 Z M33.573,37.1045463 C33.573,36.5515463 34.02,36.1045463 34.573,36.1045463 L38.922,36.1045463 C39.475,36.1045463 39.922,36.5515463 39.922,37.1045463 L39.922,41.4535463 C39.922,42.0055463 39.475,42.4535463 38.922,42.4535463 L34.573,42.4535463 C34.02,42.4535463 33.573,42.0055463 33.573,41.4535463 L33.573,37.1045463 Z M22.637,40.3895463 L25.635,40.3895463 L24.136,38.3575463 L22.637,40.3895463 Z M19.851,40.7955463 L23.331,36.0785463 C23.708,35.5675463 24.563,35.5675463 24.94,36.0785463 L28.42,40.7955463 C28.643,41.0995463 28.678,41.5035463 28.508,41.8405463 C28.338,42.1765463 27.992,42.3895463 27.615,42.3895463 L20.656,42.3895463 C20.279,42.3895463 19.934,42.1765463 19.764,41.8405463 C19.594,41.5035463 19.628,41.0995463 19.851,40.7955463 Z M11.523,40.6075463 C12.291,40.6075463 12.916,39.9835463 12.916,39.2155463 C12.916,38.4485463 12.291,37.8235463 11.523,37.8235463 C10.756,37.8235463 10.132,38.4485463 10.132,39.2155463 C10.132,39.9835463 10.756,40.6075463 11.523,40.6075463 Z M11.523,35.8235463 C13.394,35.8235463 14.916,37.3445463 14.916,39.2155463 C14.916,41.0855463 13.394,42.6075463 11.523,42.6075463 C9.653,42.6075463 8.132,41.0855463 8.132,39.2155463 C8.132,37.3445463 9.653,35.8235463 11.523,35.8235463 Z M6,43.9325463 L42.271,43.9325463 L42.271,34.6245463 L6,34.6245463 L6,43.9325463 Z M44.271,44.9325463 C44.271,45.4855463 43.824,45.9325463 43.271,45.9325463 L5,45.9325463 C4.447,45.9325463 4,45.4855463 4,44.9325463 L4,33.6245463 C4,33.0725463 4.447,32.6245463 5,32.6245463 L43.271,32.6245463 C43.824,32.6245463 44.271,33.0725463 44.271,33.6245463 L44.271,44.9325463 Z M26.18,17.9055463 C26.18,16.7785463 25.263,15.8615463 24.136,15.8615463 C23.009,15.8615463 22.092,16.7785463 22.092,17.9055463 C22.092,19.0335463 23.009,19.9505463 24.136,19.9505463 C25.263,19.9505463 26.18,19.0335463 26.18,17.9055463 Z M23.136,28.5375463 L23.136,21.8095463 C21.392,21.3615463 20.092,19.7875463 20.092,17.9055463 C20.092,15.6755463 21.906,13.8615463 24.136,13.8615463 C26.365,13.8615463 28.18,15.6755463 28.18,17.9055463 C28.18,19.7875463 26.881,21.3615463 25.136,21.8095463 L25.136,28.5375463 L26.908,26.7665463 L28.322,28.1805463 L24.843,31.6595463 C24.647,31.8545463 24.392,31.9525463 24.136,31.9525463 C23.88,31.9525463 23.624,31.8545463 23.429,31.6595463 L19.949,28.1805463 L21.363,26.7665463 L23.136,28.5375463 Z M4.679,19.9145463 C4.679,16.4725463 6.534,13.8435463 9.689,12.7365463 C9.683,12.5895463 9.68,12.4455463 9.68,12.3035463 C9.68,8.3945463 12.329,4.3365463 15.844,2.8665463 C19.941,1.1545463 24.286,2.0105463 27.466,5.1575463 C28.362,6.0395463 29.112,7.1015463 29.705,8.3245463 C30.888,7.4955463 32.365,7.2265463 33.78,7.6435463 C35.799,8.2405463 37.17,10.0375463 37.533,12.5155463 C40.589,13.2905463 43.593,15.5895463 43.593,19.9755463 C43.593,25.5555463 38.957,27.4035463 36.506,27.6005463 L30.224,27.5945463 L30.225,25.5945463 L36.427,25.6035463 C36.557,25.5875463 41.593,25.0885463 41.593,19.9755463 C41.593,15.6795463 37.981,14.5925463 36.43,14.3245463 C35.913,14.2355463 35.556,13.7645463 35.603,13.2465463 C35.447,11.3325463 34.559,9.9585463 33.213,9.5615463 C32.106,9.2325463 30.914,9.6495463 30.168,10.6215463 C29.988,10.8835463 29.686,11.0565463 29.346,11.0565463 C28.885,11.0565463 28.496,10.7465463 28.381,10.3245463 C27.833,8.8175463 27.053,7.5575463 26.06,6.5805463 C24.817,5.3485463 21.407,2.7065463 16.615,4.7115463 C13.848,5.8695463 11.68,9.2045463 11.68,12.3035463 C11.68,12.6565463 11.704,13.0095463 11.742,13.3465463 C11.8,13.8445463 11.479,14.3085463 10.993,14.4305463 C9.382,14.8365463 6.679,16.0895463 6.679,19.9145463 C6.679,20.0795463 6.687,20.2455463 6.695,20.4035463 C6.876,23.2995463 9.425,25.5775463 12.498,25.5775463 L18.049,25.5855463 L18.045,27.5855463 L12.496,27.5775463 C8.371,27.5775463 4.945,24.4755463 4.698,20.5165463 C4.687,20.3145463 4.679,20.1155463 4.679,19.9145463 Z" id="Amazon-IOT-RESOURCES-IoT-actuator_Resource-Icon_light-bg" fill="#7AA116"></path>
    </g>
</svg>`, vx = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/IoT/Res_AWS-IoT_Thing_Temperature-Sensor_48</title>
    <g id="Icon-Resource/IoT/Res_AWS-IoT_Thing_Temperature-Sensor_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M24,32.9775 C23.448,32.9775 23,32.5285 23,31.9775 C23,31.4265 23.448,30.9775 24,30.9775 C24.552,30.9775 25,31.4265 25,31.9775 C25,32.5285 24.552,32.9775 24,32.9775 L24,32.9775 Z M25,29.1615 L25,17.9995 L23,17.9995 L23,29.1615 C21.839,29.5765 21,30.6755 21,31.9775 C21,33.6315 22.346,34.9775 24,34.9775 C25.654,34.9775 27,33.6315 27,31.9775 C27,30.6755 26.161,29.5765 25,29.1615 L25,29.1615 Z M26.522,35.0815 C25.569,35.8575 24.364,36.1425 23.132,35.8875 C21.588,35.5665 20.356,34.2985 20.069,32.7315 C19.79,31.2055 20.363,29.7345 21.603,28.7975 L22,28.4975 L22,13.9995 C22,12.8965 22.897,11.9995 24,11.9995 C25.103,11.9995 26,12.8965 26,13.9995 L26,28.4985 L26.397,28.7975 C27.416,29.5675 28,30.7265 28,31.9775 C28,33.1865 27.462,34.3175 26.522,35.0815 L26.522,35.0815 Z M28,27.5285 L28,13.9995 C28,11.7945 26.206,9.9995 24,9.9995 C21.794,9.9995 20,11.7945 20,13.9995 L20,27.5295 C18.444,28.9235 17.721,31.0105 18.103,33.0925 C18.535,35.4515 20.393,37.3615 22.726,37.8455 C23.147,37.9335 23.571,37.9765 23.991,37.9765 C25.37,37.9765 26.706,37.5115 27.785,36.6325 C29.192,35.4875 30,33.7905 30,31.9775 C30,30.2645 29.277,28.6685 28,27.5285 L28,27.5285 Z M30,26.9995 L34,26.9995 L34,24.9995 L30,24.9995 L30,26.9995 Z M30,22.9995 L35,22.9995 L35,20.9995 L30,20.9995 L30,22.9995 Z M30,18.9995 L34,18.9995 L34,16.9995 L30,16.9995 L30,18.9995 Z M30,14.9995 L35,14.9995 L35,12.9995 L30,12.9995 L30,14.9995 Z M39,37.8655 C39,38.4905 38.491,38.9995 37.865,38.9995 L10.135,38.9995 C9.509,38.9995 9,38.4905 9,37.8655 L9,10.1345 C9,9.5095 9.509,8.9995 10.135,8.9995 L37.865,8.9995 C38.491,8.9995 39,9.5095 39,10.1345 L39,37.8655 Z M46,14.9995 L46,12.9995 L41,12.9995 L41,10.1345 C41,8.4065 39.594,6.9995 37.865,6.9995 L35,6.9995 L35,1.9995 L33,1.9995 L33,6.9995 L30,6.9995 L30,1.9995 L28,1.9995 L28,6.9995 L25,6.9995 L25,1.9995 L23,1.9995 L23,6.9995 L20,6.9995 L20,1.9995 L18,1.9995 L18,6.9995 L15,6.9995 L15,1.9995 L13,1.9995 L13,6.9995 L10.135,6.9995 C8.406,6.9995 7,8.4065 7,10.1345 L7,12.9995 L2,12.9995 L2,14.9995 L7,14.9995 L7,17.9995 L2,17.9995 L2,19.9995 L7,19.9995 L7,22.9995 L2,22.9995 L2,24.9995 L7,24.9995 L7,27.9995 L2,27.9995 L2,29.9995 L7,29.9995 L7,32.9995 L2,32.9995 L2,34.9995 L7,34.9995 L7,37.8655 C7,39.5935 8.406,40.9995 10.135,40.9995 L13,40.9995 L13,45.9995 L15,45.9995 L15,40.9995 L18,40.9995 L18,45.9995 L20,45.9995 L20,40.9995 L23,40.9995 L23,45.9995 L25,45.9995 L25,40.9995 L28,40.9995 L28,45.9995 L30,45.9995 L30,40.9995 L33,40.9995 L33,45.9995 L35,45.9995 L35,40.9995 L37.865,40.9995 C39.594,40.9995 41,39.5935 41,37.8655 L41,34.9995 L46,34.9995 L46,32.9995 L41,32.9995 L41,29.9995 L46,29.9995 L46,27.9995 L41,27.9995 L41,24.9995 L46,24.9995 L46,22.9995 L41,22.9995 L41,19.9995 L46,19.9995 L46,17.9995 L41,17.9995 L41,14.9995 L46,14.9995 Z" id="Fill-1" fill="#7AA116"></path>
    </g>
</svg>`, Mx = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/IoT/Res_AWS-IoT_HTTP_Protocol_48</title>
    <g id="Icon-Resource/IoT/Res_AWS-IoT_HTTP_Protocol_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M18.8612,43.9609 L40.1962,43.9609 L43.9612,43.9609 L43.9612,40.1969 L43.9612,32.8489 L18.8612,32.8489 L18.8612,43.9609 Z M16.8612,30.8489 L45.9612,30.8489 L45.9612,40.1969 L45.9612,45.9609 L40.1962,45.9609 L16.8612,45.9609 L16.8612,30.8489 Z M7.7642,1.9999 C4.5862,1.9999 2.0002,4.5859 2.0002,7.7649 L2.0002,40.1969 C2.0002,43.3749 4.5862,45.9609 7.7642,45.9609 L15.2382,45.9609 L15.2382,43.9609 L7.7642,43.9609 C5.6882,43.9609 4.0002,42.2729 4.0002,40.1969 L4.0002,7.7649 C4.0002,5.6889 5.6882,3.9999 7.7642,3.9999 L40.1962,3.9999 C42.2722,3.9999 43.9612,5.6889 43.9612,7.7649 L43.9612,29.2259 L45.9612,29.2259 L45.9612,7.7649 C45.9612,4.5859 43.3752,1.9999 40.1962,1.9999 L7.7642,1.9999 Z M40.2092,38.7089 C40.5372,38.7089 40.7942,38.5839 40.9792,38.3309 C41.1652,38.0799 41.2572,37.7339 41.2572,37.2929 C41.2572,36.8459 41.1652,36.4969 40.9792,36.2499 C40.7942,36.0009 40.5372,35.8769 40.2092,35.8769 L39.1712,35.8769 L39.1712,38.7089 L40.2092,38.7089 Z M39.1712,39.5169 L39.1712,42.3389 L38.1842,42.3389 L38.1842,35.0689 L40.3132,35.0689 C40.7052,35.0689 41.0492,35.1629 41.3462,35.3529 C41.6432,35.5409 41.8712,35.8039 42.0292,36.1399 C42.1862,36.4749 42.2642,36.8589 42.2642,37.2929 C42.2642,37.9649 42.0852,38.5039 41.7242,38.9079 C41.3642,39.3139 40.8942,39.5169 40.3132,39.5169 L39.1712,39.5169 Z M32.6142,35.9189 L34.4182,35.9189 L34.4182,42.3389 L35.4352,42.3389 L35.4352,35.9189 L37.2502,35.9189 L37.2502,35.0689 L32.6142,35.0689 L32.6142,35.9189 Z M27.3692,35.9189 L29.1732,35.9189 L29.1732,42.3389 L30.1912,42.3389 L30.1912,35.9189 L32.0062,35.9189 L32.0062,35.0689 L27.3692,35.0689 L27.3692,35.9189 Z M25.4182,35.0689 L26.4352,35.0689 L26.4352,42.3389 L25.4182,42.3389 L25.4182,39.0339 L22.7742,39.0339 L22.7742,42.3389 L21.7572,42.3389 L21.7572,35.0689 L22.7742,35.0689 L22.7742,38.2059 L25.4182,38.2059 L25.4182,35.0689 Z" id="Amazon-IOT-RESOURCES-IoT-HTTP-protocol_Resource-Icon_light-bg" fill="#7AA116"></path>
    </g>
</svg>`, Rx = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/IoT/Res_AWS-IoT-Core_Device-Location_48</title>
    <g id="Icon-Resource/IoT/Res_AWS-IoT-Core_Device-Location_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M35.8342,43.976 L34.8372,38.495 L40.0562,37.65 L43.3522,43.976 L35.8342,43.976 Z M4.9862,43.328 L32.8642,38.814 L33.8022,43.976 L4.6482,43.976 L4.9862,43.328 Z M10.0942,33.523 L15.8342,39.545 L6.1392,41.114 L10.0942,33.523 Z M33.8342,32.976 L37.6212,32.976 L39.0822,35.781 L34.4792,36.526 L33.8342,32.976 Z M45.8872,44.514 L39.1142,31.514 C38.9422,31.184 38.6012,30.976 38.2272,30.976 L29.0002,30.976 L29.0002,32.976 L31.8022,32.976 L32.5062,36.846 L18.2272,39.157 L12.3352,32.976 L18.0002,32.976 L18.0002,30.976 L9.7722,30.976 C9.3992,30.976 9.0582,31.184 8.8862,31.514 L2.1132,44.514 C1.9512,44.824 1.9642,45.196 2.1442,45.495 C2.3262,45.793 2.6502,45.976 3.0002,45.976 L45.0002,45.976 C45.3502,45.976 45.6742,45.793 45.8552,45.495 C46.0362,45.196 46.0492,44.824 45.8872,44.514 L45.8872,44.514 Z M31.1282,7.885 L30.6452,5.944 C31.8832,5.637 33.4642,6.117 34.7712,7.196 C36.0802,8.277 36.8502,9.739 36.7812,11.012 L34.7832,10.904 C34.8112,10.395 34.4212,9.5 33.4982,8.738 C32.5742,7.976 31.6182,7.76 31.1282,7.885 L31.1282,7.885 Z M31.5362,4.072 L31.0542,2.131 C32.8572,1.681 35.1962,2.407 37.1542,4.023 C39.1132,5.641 40.2672,7.8 40.1672,9.659 L38.1692,9.55 C38.2242,8.552 37.5372,6.933 35.8812,5.565 C34.2272,4.2 32.5122,3.83 31.5362,4.072 L31.5362,4.072 Z M22.0002,18.976 C22.0002,17.873 22.8972,16.976 24.0002,16.976 C25.1022,16.976 26.0002,17.873 26.0002,18.976 C26.0002,20.079 25.1022,20.976 24.0002,20.976 C22.8972,20.976 22.0002,20.079 22.0002,18.976 L22.0002,18.976 Z M28.0002,18.976 C28.0002,16.77 26.2062,14.976 24.0002,14.976 C21.7942,14.976 20.0002,16.77 20.0002,18.976 C20.0002,21.182 21.7942,22.976 24.0002,22.976 C26.2062,22.976 28.0002,21.182 28.0002,18.976 L28.0002,18.976 Z M18.0702,12.95 C19.6052,11.339 21.7672,10.415 23.9982,10.415 C26.3662,10.415 28.5752,11.312 30.0612,12.876 C31.4322,14.321 32.0992,16.214 31.9872,18.35 C31.7792,22.373 26.3502,29.154 23.4832,32.319 C21.5282,29.848 16.2192,22.755 16.0092,18.354 C15.9132,16.364 16.6452,14.444 18.0702,12.95 L18.0702,12.95 Z M23.4002,34.844 C23.4102,34.844 23.4212,34.844 23.4322,34.844 C23.7042,34.844 23.9652,34.733 24.1542,34.536 C24.5432,34.13 33.6712,24.525 33.9852,18.454 C34.1252,15.757 33.2692,13.351 31.5112,11.499 C29.6502,9.539 26.9122,8.415 23.9982,8.415 C21.2222,8.415 18.5332,9.565 16.6232,11.57 C14.8162,13.464 13.8902,15.908 14.0112,18.45 C14.2992,24.488 22.3252,34.083 22.6672,34.488 C22.8502,34.705 23.1162,34.835 23.4002,34.844 L23.4002,34.844 Z" id="Fill-1" fill="#7AA116"></path>
    </g>
</svg>`, yx = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/IoT/Res_AWS-IoT_Alexa_Skill_48</title>
    <g id="Icon-Resource/IoT/Res_AWS-IoT_Alexa_Skill_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M26.734,36.476 C31.203,33.628 34.115,28.915 34.115,23.933 C34.115,18.135 29.398,13.417 23.599,13.417 C17.8,13.417 13.082,18.135 13.082,23.933 C13.082,28.162 15.603,31.964 19.503,33.62 C20.054,33.853 20.41,34.375 20.41,34.947 L20.41,36.468 C19.778,36.309 19.153,36.122 18.552,35.866 C13.747,33.823 10.643,29.139 10.643,23.933 C10.643,16.79 16.455,10.977 23.599,10.977 C30.742,10.977 36.555,16.79 36.555,23.933 C36.555,28.642 33.984,32.991 29.844,35.281 C28.865,35.822 27.815,36.21 26.734,36.476 Z M15.082,23.933 C15.082,19.237 18.903,15.417 23.599,15.417 C28.295,15.417 32.115,19.237 32.115,23.933 C32.115,29.333 28.104,34.385 22.41,36.367 L22.41,34.947 C22.41,33.57 21.575,32.326 20.284,31.778 C17.124,30.437 15.082,27.358 15.082,23.933 Z M8.643,23.933 C8.643,29.943 12.225,35.349 17.77,37.706 C18.894,38.183 20.064,38.5 21.26,38.689 C21.311,38.696 21.359,38.714 21.41,38.714 C21.412,38.714 21.415,38.713 21.418,38.713 C22.136,38.818 22.862,38.889 23.599,38.889 C26.121,38.889 28.615,38.247 30.813,37.031 C35.588,34.388 38.555,29.37 38.555,23.933 C38.555,15.686 31.846,8.977 23.599,8.977 C15.352,8.977 8.643,15.686 8.643,23.933 Z M43.868,39.42 C43.868,41.873 41.873,43.868 39.421,43.868 L8.448,43.868 C5.995,43.868 4,41.873 4,39.42 L4,8.448 C4,5.995 5.995,4 8.448,4 L39.421,4 C41.873,4 43.868,5.995 43.868,8.448 L43.868,39.42 Z M8.448,2 C4.893,2 2,4.892 2,8.448 L2,39.42 C2,42.975 4.893,45.868 8.448,45.868 L39.421,45.868 C42.976,45.868 45.868,42.975 45.868,39.42 L45.868,8.448 C45.868,4.892 42.976,2 39.421,2 L8.448,2 Z" id="Amazon-IOT-RESOURCES-Alexa-skill_Resource-Icon_light-bg" fill="#7AA116"></path>
    </g>
</svg>`, Ax = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/IoT/Res_AWS-IoT-Analytics_Notebook_48</title>
    <g id="Icon-Resource/IoT/Res_AWS-IoT-Analytics_Notebook_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M7.972,2 L7.972,7.206 L5,7.206 L5,9.206 L7.972,9.206 L7.972,12.467 L5,12.467 L5,14.467 L7.972,14.467 L7.972,17.781 L5,17.781 L5,19.78 L7.972,19.78 L7.972,23.055 L5,23.055 L5,25.054 L7.972,25.054 L7.972,28.247 L5,28.247 L5,30.247 L7.972,30.247 L7.972,33.48 L5,33.48 L5,35.48 L7.972,35.48 L7.972,38.794 L5,38.794 L5,40.794 L7.972,40.794 L7.972,45.973 L43.586,45.973 L43.586,2 L7.972,2 Z M9.972,4.001 L41.586,4.001 L41.586,43.973 L9.972,43.973 L9.972,40.794 L13.051,40.794 L13.051,38.794 L9.972,38.794 L9.972,35.48 L13.051,35.48 L13.051,33.48 L9.972,33.48 L9.972,30.247 L13.051,30.247 L13.051,28.247 L9.972,28.247 L9.972,25.054 L13.051,25.054 L13.051,23.055 L9.972,23.055 L9.972,19.78 L13.051,19.78 L13.051,17.781 L9.972,17.781 L9.972,14.467 L13.051,14.467 L13.051,12.467 L9.972,12.467 L9.972,9.206 L13.051,9.206 L13.051,7.206 L9.972,7.206 L9.972,4.001 Z M16.861,9.206 L36.559,9.206 L36.559,7.206 L16.861,7.206 L16.861,9.206 Z M16.861,15.594 L36.559,15.594 L36.559,13.593 L16.861,13.593 L16.861,15.594 Z M16.861,21.927 L36.559,21.927 L36.559,19.927 L16.861,19.927 L16.861,21.927 Z M16.861,28.314 L26.764,28.314 L26.764,26.313 L16.861,26.313 L16.861,28.314 Z" id="AWS-IoT-Analytics-Notebook_Resource-Icon_light-bg" fill="#7AA116"></path>
    </g>
</svg>`, Zx = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/IoT/Res_AWS-IoT-Hardware-Board_48</title>
    <g id="Icon-Resource/IoT/Res_AWS-IoT-Hardware-Board_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M37.221,22.981 L40.467,22.981 L40.467,19.736 L37.221,19.736 L37.221,22.981 Z M31.597,22.359 L35.221,22.359 L35.221,24.982 L42.467,24.982 L42.467,17.736 L35.221,17.736 L35.221,20.359 L31.597,20.359 C31.233,19.657 30.509,19.173 29.664,19.173 C28.457,19.173 27.479,20.151 27.479,21.359 C27.479,22.566 28.457,23.544 29.664,23.544 C30.509,23.544 31.234,23.06 31.597,22.359 Z M32.77,40.148 C31.267,43.68 27.818,45.963 23.982,45.963 C20.146,45.963 16.697,43.68 15.194,40.148 L17.034,39.364 C18.222,42.158 20.95,43.963 23.982,43.963 C27.014,43.963 29.742,42.158 30.93,39.364 L32.77,40.148 Z M20.141,37.458 C20.597,39.19 22.177,40.4 23.982,40.4 C25.788,40.4 27.368,39.19 27.824,37.458 L29.757,37.968 C29.07,40.577 26.695,42.4 23.982,42.4 C21.269,42.4 18.895,40.577 18.207,37.968 L20.141,37.458 Z M15.194,7.816 C16.697,4.283 20.146,2 23.982,2 C27.818,2 31.267,4.283 32.77,7.816 L30.93,8.599 C29.742,5.805 27.014,4 23.982,4 C20.95,4 18.222,5.805 17.034,8.599 L15.194,7.816 Z M27.824,10.505 C27.368,8.773 25.788,7.564 23.982,7.564 C22.176,7.564 20.597,8.773 20.141,10.505 L18.207,9.995 C18.894,7.386 21.269,5.564 23.982,5.564 C26.696,5.564 29.071,7.386 29.757,9.995 L27.824,10.505 Z M16.24,33.473 L16.24,24.442 L11.653,19.855 C11.891,19.102 11.721,18.247 11.124,17.65 C10.271,16.796 8.887,16.796 8.034,17.65 C7.18,18.503 7.18,19.887 8.034,20.74 C8.63,21.338 9.486,21.508 10.239,21.269 L14.24,25.27 L14.24,33.473 L9.246,33.473 L9.246,28.975 C9.947,28.61 10.431,27.886 10.431,27.041 C10.431,25.834 9.453,24.856 8.246,24.856 C7.038,24.856 6.06,25.834 6.06,27.041 C6.06,27.886 6.544,28.61 7.246,28.974 L7.246,33.473 L4,33.473 L4,14.49 L15.119,14.49 L15.138,18.3 L19.722,22.885 C19.484,23.638 19.654,24.492 20.25,25.09 C21.104,25.943 22.488,25.943 23.341,25.09 C24.195,24.236 24.195,22.853 23.341,21.999 C22.745,21.401 21.89,21.232 21.136,21.471 L17.134,17.468 L17.119,14.49 L43.964,14.49 L43.964,28.227 L28.538,28.227 C28.173,27.526 27.449,27.041 26.605,27.041 C25.397,27.041 24.418,28.02 24.418,29.227 C24.418,30.434 25.397,31.412 26.605,31.412 C27.45,31.412 28.173,30.928 28.538,30.227 L43.964,30.227 L43.964,33.473 L16.24,33.473 Z M3,12.49 C2.448,12.49 2,12.938 2,13.49 L2,34.473 C2,35.025 2.448,35.473 3,35.473 L44.964,35.473 C45.517,35.473 45.964,35.025 45.964,34.473 L45.964,13.49 C45.964,12.938 45.517,12.49 44.964,12.49 L3,12.49 Z" id="Amazon-IOT-RESOURCES-IoT-IoT-Hardware-Board_Resource-Icon_light-bg" fill="#7AA116"></path>
    </g>
</svg>`, kx = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/IoT/Res_AWS-IoT_Thing_Car_48</title>
    <g id="Icon-Resource/IoT/Res_AWS-IoT_Thing_Car_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M37.0351,28.2461 L36.0801,28.2461 C35.6381,26.6351 34.1751,25.4411 32.4261,25.4411 C30.6771,25.4411 29.2141,26.6351 28.7711,28.2461 L20.5961,28.2461 C20.1531,26.6351 18.6901,25.4411 16.9411,25.4411 C15.1921,25.4411 13.7291,26.6351 13.2871,28.2461 L12.6681,28.2461 L12.6681,25.3521 C12.6681,25.1981 12.7721,25.0821 12.8661,25.0741 C12.9381,25.0681 13.0111,25.0551 13.0801,25.0331 L19.3801,23.0651 C19.9311,22.8621 20.3381,22.3891 20.4631,21.8171 L21.7111,18.0271 C21.7301,17.9691 21.7831,17.9411 21.8241,17.9411 L31.2761,17.9411 C31.4311,17.9411 31.5711,18.0261 31.6181,18.1071 L33.9601,23.1781 C34.0951,23.4681 34.3591,23.6771 34.6731,23.7391 C36.3061,24.0651 37.0351,25.0211 37.0351,26.8381 L37.0351,28.2461 Z M30.6211,29.2461 C30.6211,28.2511 31.4311,27.4411 32.4261,27.4411 C33.4211,27.4411 34.2301,28.2511 34.2301,29.2461 C34.2301,30.2411 33.4211,31.0511 32.4261,31.0511 C31.4311,31.0511 30.6211,30.2411 30.6211,29.2461 Z M15.1371,29.2461 C15.1371,28.2511 15.9461,27.4411 16.9411,27.4411 C17.9361,27.4411 18.7461,28.2511 18.7461,29.2461 C18.7461,30.2411 17.9361,31.0511 16.9411,31.0511 C15.9461,31.0511 15.1371,30.2411 15.1371,29.2461 Z M33.4031,17.2081 C32.9751,16.4271 32.1611,15.9411 31.2761,15.9411 L21.8241,15.9411 C20.9071,15.9411 20.0981,16.5281 19.8101,17.4021 L18.5511,21.2301 L12.5721,23.0961 C11.4951,23.2521 10.6681,24.2191 10.6681,25.3521 L10.6681,27.3671 L9.0311,27.3671 L9.0311,29.3671 L10.8091,29.3671 C11.0491,29.8851 11.5661,30.2461 12.1701,30.2461 L13.2871,30.2461 C13.7291,31.8571 15.1921,33.0511 16.9411,33.0511 C18.6901,33.0511 20.1531,31.8571 20.5961,30.2461 L28.7711,30.2461 C29.2141,31.8571 30.6771,33.0511 32.4261,33.0511 C34.1751,33.0511 35.6381,31.8571 36.0801,30.2461 L37.5421,30.2461 C38.3651,30.2461 39.0351,29.5681 39.0351,28.7361 L39.0351,26.8381 C39.0351,24.2741 37.8111,22.5401 35.5731,21.9011 L33.4031,17.2081 Z M39.6711,38.5371 C39.6711,39.1631 39.1611,39.6721 38.5351,39.6721 L9.4101,39.6721 C8.7841,39.6721 8.2751,39.1631 8.2751,38.5371 L8.2751,9.4231 C8.2751,8.7971 8.7841,8.2881 9.4101,8.2881 L38.5361,8.2881 C39.1621,8.2881 39.6711,8.7971 39.6711,9.4231 L39.6711,38.5371 Z M45.9451,14.4261 L45.9451,12.4261 L41.6711,12.4261 L41.6711,9.4231 C41.6711,7.6941 40.2641,6.2881 38.5361,6.2881 L35.5191,6.2881 L35.5191,2.0001 L33.5191,2.0001 L33.5191,6.2881 L30.2461,6.2881 L30.2461,2.0001 L28.2461,2.0001 L28.2461,6.2881 L24.9721,6.2881 L24.9721,2.0001 L22.9721,2.0001 L22.9721,6.2881 L19.6991,6.2881 L19.6991,2.0001 L17.6991,2.0001 L17.6991,6.2881 L14.4261,6.2881 L14.4261,2.0001 L12.4261,2.0001 L12.4261,6.2881 L9.4101,6.2881 C7.6811,6.2881 6.2751,7.6941 6.2751,9.4231 L6.2751,12.4261 L2.0001,12.4261 L2.0001,14.4261 L6.2751,14.4261 L6.2751,17.6991 L2.0001,17.6991 L2.0001,19.6991 L6.2751,19.6991 L6.2751,22.9731 L2.0001,22.9731 L2.0001,24.9731 L6.2751,24.9731 L6.2751,28.2461 L2.0001,28.2461 L2.0001,30.2461 L6.2751,30.2461 L6.2751,33.5191 L2.0001,33.5191 L2.0001,35.5191 L6.2751,35.5191 L6.2751,38.5371 C6.2751,40.2661 7.6811,41.6721 9.4101,41.6721 L12.4261,41.6721 L12.4261,45.9451 L14.4261,45.9451 L14.4261,41.6721 L17.6991,41.6721 L17.6991,45.9451 L19.6991,45.9451 L19.6991,41.6721 L22.9721,41.6721 L22.9721,45.9451 L24.9721,45.9451 L24.9721,41.6721 L28.2461,41.6721 L28.2461,45.9451 L30.2461,45.9451 L30.2461,41.6721 L33.5191,41.6721 L33.5191,45.9451 L35.5191,45.9451 L35.5191,41.6721 L38.5351,41.6721 C40.2641,41.6721 41.6711,40.2661 41.6711,38.5371 L41.6711,35.5191 L45.9451,35.5191 L45.9451,33.5191 L41.6711,33.5191 L41.6711,30.2461 L45.9451,30.2461 L45.9451,28.2461 L41.6711,28.2461 L41.6711,24.9731 L45.9451,24.9731 L45.9451,22.9731 L41.6711,22.9731 L41.6711,19.6991 L45.9451,19.6991 L45.9451,17.6991 L41.6711,17.6991 L41.6711,14.4261 L45.9451,14.4261 Z" id="Amazon-IOT-RESOURCES-IoT-thing-car_Resource-Icon_light-bg" fill="#7AA116"></path>
    </g>
</svg>`, Tx = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/IoT/Res_AWS-IoT_Thing_Lightbulb_48</title>
    <g id="Icon-Resource/IoT/Res_AWS-IoT_Thing_Lightbulb_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M25.9241,36.0526 L25.9241,36.1566 L21.9861,36.1566 L21.9861,36.0526 C21.9861,35.9896 21.9901,35.9586 21.9781,35.9726 C22.2231,35.6246 22.2511,35.2096 22.0011,34.8646 C21.9971,34.8536 21.9861,34.8106 21.9861,34.7456 L21.9861,34.6406 L25.9241,34.6406 L25.9241,34.7456 C25.9241,34.7986 25.9081,34.8586 25.9311,34.8236 C25.6861,35.1696 25.6601,35.5866 25.9091,35.9326 C25.9131,35.9436 25.9241,35.9866 25.9241,36.0526 Z M21.3611,32.6406 C20.5641,32.6406 19.9861,33.3966 19.9861,34.4376 L19.9861,34.7456 C19.9861,34.9746 20.0161,35.1956 20.0731,35.3986 C20.0161,35.6026 19.9861,35.8246 19.9861,36.0526 L19.9861,36.3616 C19.9861,37.4016 20.5641,38.1566 21.3611,38.1566 L26.5481,38.1566 C27.3451,38.1566 27.9241,37.4016 27.9241,36.3616 L27.9241,36.0526 C27.9241,35.8246 27.8931,35.6026 27.8371,35.3986 C27.8931,35.1956 27.9241,34.9746 27.9241,34.7456 L27.9241,34.4376 C27.9241,33.3966 27.3451,32.6406 26.5481,32.6406 L21.3611,32.6406 Z M26.4881,27.7316 L26.4881,30.0036 L24.9721,30.0036 L24.9721,24.0936 L25.7291,24.0936 L25.7291,22.0936 L22.2151,22.0936 L22.2151,24.0936 L22.9721,24.0936 L22.9721,30.0036 L21.4571,30.0036 L21.4571,27.7316 C21.4571,27.3426 21.2311,26.9896 20.8791,26.8256 C18.2541,25.6036 16.6231,23.0686 16.6231,20.2086 C16.6231,16.1566 19.9201,12.8596 23.9721,12.8596 C28.0251,12.8596 31.3221,16.1566 31.3221,20.2086 C31.3221,23.0686 29.6911,25.6036 27.0661,26.8256 C26.7141,26.9896 26.4881,27.3426 26.4881,27.7316 Z M14.6231,20.2086 C14.6231,23.6396 16.4591,26.7026 19.4571,28.3456 L19.4571,31.0036 C19.4571,31.5566 19.9041,32.0036 20.4571,32.0036 L27.4881,32.0036 C28.0411,32.0036 28.4881,31.5566 28.4881,31.0036 L28.4881,28.3456 C31.4861,26.7016 33.3221,23.6396 33.3221,20.2086 C33.3221,15.0536 29.1281,10.8596 23.9721,10.8596 C18.8171,10.8596 14.6231,15.0536 14.6231,20.2086 Z M39.6701,38.5366 C39.6701,39.1626 39.1611,39.6716 38.5351,39.6716 L9.4091,39.6716 C8.7831,39.6716 8.2741,39.1626 8.2741,38.5366 L8.2741,9.4236 C8.2741,8.7976 8.7831,8.2886 9.4091,8.2886 L38.5351,8.2886 C39.1611,8.2886 39.6701,8.7976 39.6701,9.4236 L39.6701,38.5366 Z M45.9451,14.4256 L45.9451,12.4256 L41.6701,12.4256 L41.6701,9.4236 C41.6701,7.6956 40.2631,6.2886 38.5351,6.2886 L35.5191,6.2886 L35.5191,1.9996 L33.5191,1.9996 L33.5191,6.2886 L30.2461,6.2886 L30.2461,1.9996 L28.2461,1.9996 L28.2461,6.2886 L24.9721,6.2886 L24.9721,1.9996 L22.9721,1.9996 L22.9721,6.2886 L19.6991,6.2886 L19.6991,1.9996 L17.6991,1.9996 L17.6991,6.2886 L14.4261,6.2886 L14.4261,1.9996 L12.4261,1.9996 L12.4261,6.2886 L9.4091,6.2886 C7.6801,6.2886 6.2741,7.6956 6.2741,9.4236 L6.2741,12.4256 L2.0001,12.4256 L2.0001,14.4256 L6.2741,14.4256 L6.2741,17.6996 L2.0001,17.6996 L2.0001,19.6996 L6.2741,19.6996 L6.2741,22.9726 L2.0001,22.9726 L2.0001,24.9726 L6.2741,24.9726 L6.2741,28.2456 L2.0001,28.2456 L2.0001,30.2456 L6.2741,30.2456 L6.2741,33.5196 L2.0001,33.5196 L2.0001,35.5196 L6.2741,35.5196 L6.2741,38.5366 C6.2741,40.2656 7.6801,41.6716 9.4091,41.6716 L12.4261,41.6716 L12.4261,45.9456 L14.4261,45.9456 L14.4261,41.6716 L17.6991,41.6716 L17.6991,45.9456 L19.6991,45.9456 L19.6991,41.6716 L22.9721,41.6716 L22.9721,45.9456 L24.9721,45.9456 L24.9721,41.6716 L28.2461,41.6716 L28.2461,45.9456 L30.2461,45.9456 L30.2461,41.6716 L33.5191,41.6716 L33.5191,45.9456 L35.5191,45.9456 L35.5191,41.6716 L38.5351,41.6716 C40.2631,41.6716 41.6701,40.2656 41.6701,38.5366 L41.6701,35.5196 L45.9451,35.5196 L45.9451,33.5196 L41.6701,33.5196 L41.6701,30.2456 L45.9451,30.2456 L45.9451,28.2456 L41.6701,28.2456 L41.6701,24.9726 L45.9451,24.9726 L45.9451,22.9726 L41.6701,22.9726 L41.6701,19.6996 L45.9451,19.6996 L45.9451,17.6996 L41.6701,17.6996 L41.6701,14.4256 L45.9451,14.4256 Z" id="Amazon-IOT-RESOURCES-IoT-thing-lightbulb_Resource-Icon_light-bg" fill="#7AA116"></path>
    </g>
</svg>`, Sx = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/IoT/Res_AWS-IoT-SiteWise_Asset_48</title>
    <g id="Icon-Resource/IoT/Res_AWS-IoT-SiteWise_Asset_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M7,44 L9,44 L9,42 L7,42 L7,44 Z M10,40 L6,40 C5.448,40 5,40.448 5,41 L5,45 C5,45.552 5.448,46 6,46 L10,46 C10.552,46 11,45.552 11,45 L11,41 C11,40.448 10.552,40 10,40 L10,40 Z M5,36 L7,36 L7,34 L5,34 L5,36 Z M9,37 L9,33 C9,32.448 8.552,32 8,32 L4,32 C3.448,32 3,32.448 3,33 L3,37 C3,37.552 3.448,38 4,38 L8,38 C8.552,38 9,37.552 9,37 L9,37 Z M15,40 L20,40 L20,35 L15,35 L15,40 Z M21,33 L14,33 C13.448,33 13,33.448 13,34 L13,41 C13,41.552 13.448,42 14,42 L21,42 C21.552,42 22,41.552 22,41 L22,34 C22,33.448 21.552,33 21,33 L21,33 Z M31.5,36 C31.224,36 31,35.776 31,35.5 C31,35.224 31.224,35 31.5,35 C31.776,35 32,35.224 32,35.5 C32,35.776 31.776,36 31.5,36 L31.5,36 Z M31.5,34 C30.673,34 30,34.673 30,35.5 C30,36.327 30.673,37 31.5,37 C32.327,37 33,36.327 33,35.5 C33,34.673 32.327,34 31.5,34 L31.5,34 Z M25,44 L44,44 L44,42 L25,42 L25,44 Z M28.179,35.746 C27.905,34.544 28.429,33.308 29.482,32.669 C30.626,31.973 32.125,32.177 33.054,33.163 L39.696,40 L29.149,40 L28.179,35.746 Z M38.773,22.754 C39.43,23.273 40.202,23.571 41.012,23.655 L35.988,33.312 L34.499,31.78 C33.889,31.132 33.127,30.692 32.311,30.458 L38.5,22.567 L38.773,22.754 Z M22,5.818 L42.754,17.389 C43.295,17.744 43.658,18.291 43.773,18.928 C43.89,19.565 43.744,20.204 43.363,20.727 C43.065,21.136 42.653,21.425 42.182,21.575 L42.113,21.539 L42.081,21.599 C41.984,21.625 41.888,21.656 41.786,21.67 C41.148,21.759 40.52,21.585 39.958,21.145 L22,8.842 L22,5.818 Z M24,23.395 L24,29.271 C23.825,29 23.657,28.642 23.526,28.172 L23.231,24.91 C23.22,24.786 23.186,24.665 23.13,24.553 L22.13,22.553 C21.982,22.258 21.699,22.055 21.373,22.009 C21.044,21.964 20.718,22.083 20.496,22.327 C20.131,22.728 19.283,22.979 18.226,23 L18.019,23 C16.958,22.98 16.105,22.729 15.739,22.327 C15.518,22.083 15.188,21.964 14.863,22.009 C14.537,22.055 14.253,22.258 14.105,22.553 L13.105,24.553 C13.05,24.665 13.015,24.786 13.004,24.91 L12.709,28.172 C12.529,28.815 12.262,29.26 12,29.562 L12,23.414 L15.361,20.054 C15.462,19.953 15.541,19.831 15.591,19.696 C15.985,18.638 16.987,17.93 18.107,17.905 L18.128,17.905 C19.248,17.93 20.25,18.638 20.645,19.696 C20.691,19.82 20.761,19.934 20.852,20.03 L24,23.395 Z M17,5.5 C17,4.673 17.673,4 18.5,4 C19.327,4 20,4.673 20,5.5 L20,16.329 C19.49,16.1 18.942,15.95 18.369,15.914 C18.302,15.906 18.234,15.905 18.166,15.905 L18.069,15.905 C18.001,15.904 17.932,15.905 17.867,15.914 C17.57,15.933 17.283,15.989 17,16.061 L17,5.5 Z M45,40 L42.484,40 L37.456,34.824 L43.523,23.161 C44.089,22.857 44.59,22.44 44.98,21.904 C45.686,20.934 45.957,19.75 45.741,18.569 C45.526,17.389 44.855,16.375 43.79,15.679 L21.112,3.033 L21.058,3.129 C20.419,2.439 19.513,2 18.5,2 C16.57,2 15,3.57 15,5.5 L15,17.125 C14.494,17.578 14.079,18.138 13.802,18.785 L10.293,22.293 C10.105,22.48 9.99982718,22.735 9.99982718,23 L9.99982718,30.981 C9.99,31.55 10.415,32.022 11.011,32.105 C11.078,32.115 11.148,32.119 11.221,32.119 C12.308,32.119 14.014,31.076 14.665,28.604 C14.679,28.55 14.688,28.495 14.694,28.439 L14.979,25.278 L15.382,24.471 C16.294,24.891 17.331,24.988 18,25 L18.235,25 L18.254,25 C18.91,24.988 19.942,24.891 20.853,24.471 L21.256,25.278 L21.542,28.439 C21.547,28.495 21.556,28.55 21.57,28.604 C22.151,30.808 23.519,31.838 24.515,32.051 C25.232,32.203 25.612,31.885 25.775,31.682 C25.925,31.497 26.002,31.246 25.999,31 L26,23 C26,22.746 25.903,22.502 25.73,22.317 L22.44,18.801 C22.321,18.519 22.167,18.26 22,18.011 L22,11.267 L36.847,21.435 L29.808,30.409 C29.336,30.524 28.874,30.698 28.444,30.959 C26.653,32.046 25.764,34.148 26.229,36.19 L27.097,40 L24,40 C23.448,40 23,40.448 23,41 L23,45 C23,45.552 23.448,46 24,46 L45,46 C45.552,46 46,45.552 46,45 L46,41 C46,40.448 45.552,40 45,40 L45,40 Z" id="Fill-1" fill="#7AA116"></path>
    </g>
</svg>`, bx = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/IoT/Res_AWS-IoT-SiteWise_Data-Streams_48</title>
    <g id="Icon-Resource/IoT/Res_AWS-IoT-SiteWise_Data-Streams_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M36,2 L36,7 L20,7 L20,14 L22,14 L22,9 L36,9 L36,12 L46,12 L46,2 L36,2 Z M38,10 L44,10 L44,4 L38,4 L38,10 Z M10,16 L10,18 L26,18 L26,38 L28,38 L28,16 L10,16 Z M7,18 L9,18 L9,16 L7,16 L7,18 Z M4,18 L6,18 L6,16 L4,16 L4,18 Z M38,28 L46,28 L46,20 L38,20 L38,28 Z M40,26.001 L44.001,26.001 L44.001,22 L40,22 L40,26.001 Z M22,46 L24,46 L24,21 L22,21 L22,46 Z M30,23 L30,46 L31.999,46 L31.999,25 L37,25 L37,23 L30,23 Z M2,35 L12,35 L12,25 L2,25 L2,35 Z M4,33 L10,33 L10,27 L4,27 L4,33 Z M13.999,29 L13.999,31 L18,31 L18,46 L20,46 L20,29 L13.999,29 Z M26,46 L28,46 L28,40 L26,40 L26,46 Z" id="Fill-1" fill="#7AA116"></path>
    </g>
</svg>`, Ex = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/IoT/Res_AWS-IoT-Greengrass_Component-Nucleus_48</title>
    <g id="Icon-Resource/IoT/Res_AWS-IoT-Greengrass_Component-Nucleus_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M22.2969,21.145 C23.7949,20.199 25.3199,19.431 26.7619,18.89 C27.0739,20.337 27.2729,22.059 27.2729,24.007 C27.2729,25.902 27.0849,27.583 26.7869,29.005 C25.4249,28.498 23.9009,27.757 22.2969,26.744 C20.8419,25.825 19.6249,24.87 18.6309,23.944 C19.6249,23.02 20.8419,22.064 22.2969,21.145 L22.2969,21.145 Z M17.3229,31.885 C17.8879,31.885 18.5029,31.824 19.1639,31.701 L18.7989,29.735 C17.1529,30.041 15.9109,29.882 15.5569,29.319 C15.1439,28.666 15.7149,27.156 17.2489,25.37 C18.4329,26.478 19.7989,27.532 21.2289,28.435 C22.8359,29.45 24.5799,30.317 26.2669,30.929 C25.5869,32.93 24.6879,34.071 23.9619,34.071 C23.3299,34.071 22.5629,33.18 21.9579,31.746 L20.1139,32.523 C21.3519,35.456 22.8899,36.071 23.9619,36.071 C25.8629,36.071 27.2789,34.177 28.1699,31.502 C29.1229,31.736 30.0359,31.878 30.8559,31.878 C32.3809,31.878 33.6059,31.431 34.2649,30.388 C35.1789,28.941 34.6479,26.853 32.7699,24.507 L31.2089,25.757 C32.6999,27.621 32.8759,28.841 32.5729,29.319 C32.1879,29.933 30.7429,30.084 28.6909,29.591 C29.0729,27.84 29.2729,25.906 29.2729,24.007 C29.2729,22.064 29.0629,20.085 28.6619,18.303 C28.8579,18.255 29.0529,18.207 29.2419,18.17 C31.2619,17.779 32.2899,18.12 32.5729,18.569 C32.9549,19.174 32.4659,20.514 31.3269,21.981 L32.9069,23.208 C34.6709,20.935 35.1529,18.909 34.2649,17.501 C33.4139,16.155 31.4949,15.695 28.8599,16.207 C28.6189,16.254 28.3709,16.313 28.1209,16.375 C27.2289,13.773 25.8299,11.943 23.9619,11.943 C22.3969,11.943 20.9999,13.278 20.0279,15.702 L21.8859,16.446 C22.5039,14.902 23.2999,13.943 23.9619,13.943 C24.6719,13.943 25.5489,15.037 26.2239,16.961 C24.6009,17.556 22.8929,18.403 21.2289,19.455 C19.7989,20.357 18.4329,21.411 17.2489,22.519 C15.7149,20.733 15.1439,19.223 15.5569,18.569 C15.8959,18.033 17.0649,17.861 18.6089,18.12 L18.9399,16.147 C15.7799,15.618 14.4399,16.592 13.8649,17.501 C12.7799,19.219 13.8199,21.621 15.8619,23.944 C13.8199,26.268 12.7799,28.67 13.8649,30.388 C14.4889,31.374 15.6899,31.885 17.3229,31.885 L17.3229,31.885 Z M3.9999,24 C3.9999,22.897 4.8979,22 5.9999,22 C7.1029,22 7.9999,22.897 7.9999,24 C7.9999,25.103 7.1029,26 5.9999,26 C4.8979,26 3.9999,25.103 3.9999,24 L3.9999,24 Z M23.9999,4 C25.1029,4 25.9999,4.897 25.9999,6 C25.9999,7.103 25.1029,8 23.9999,8 C22.8979,8 21.9999,7.103 21.9999,6 C21.9999,4.897 22.8979,4 23.9999,4 L23.9999,4 Z M10.9609,35.532 C9.0359,33.336 7.6879,30.678 7.0599,27.839 C8.7489,27.372 9.9999,25.836 9.9999,24 C9.9999,22.179 8.7699,20.656 7.1029,20.174 C8.6049,13.762 13.7569,8.645 20.2059,7.205 C20.7209,8.819 22.2169,10 23.9999,10 C25.7799,10 27.2749,8.823 27.7919,7.213 C29.5919,7.616 31.3099,8.293 32.9059,9.255 L33.9379,7.542 C32.0649,6.413 30.0419,5.644 27.9199,5.204 C27.5499,3.379 25.9339,2 23.9999,2 C22.0709,2 20.4589,3.371 20.0829,5.189 C12.6119,6.728 6.6479,12.679 5.0709,20.12 C3.3149,20.541 1.9999,22.115 1.9999,24 C1.9999,25.866 3.2899,27.426 5.0229,27.865 C5.6909,31.233 7.2699,34.389 9.5639,36.963 L7.0159,36.924 L6.9839,38.924 L11.9079,39 L11.9239,39 C12.1839,39 12.4339,38.899 12.6199,38.718 C12.8109,38.533 12.9199,38.28 12.9239,38.015 L12.9999,33.015 L10.9999,32.985 L10.9609,35.532 Z M41.9999,26 C40.8979,26 39.9999,25.103 39.9999,24 C39.9999,22.897 40.8979,22 41.9999,22 C43.1029,22 43.9999,22.897 43.9999,24 C43.9999,25.103 43.1029,26 41.9999,26 L41.9999,26 Z M23.9999,44 C22.8979,44 21.9999,43.103 21.9999,42 C21.9999,40.897 22.8979,40 23.9999,40 C25.1029,40 25.9999,40.897 25.9999,42 C25.9999,43.103 25.1029,44 23.9999,44 L23.9999,44 Z M45.9999,24 C45.9999,22.096 44.6599,20.503 42.8739,20.103 C42.1589,16.708 40.5579,13.604 38.2009,11.043 L41.0159,11 L40.9839,9 L35.9849,9.076 C35.7199,9.081 35.4669,9.189 35.2819,9.38 C35.0979,9.57 34.9959,9.826 34.9999,10.092 L35.0759,15.016 L37.0759,14.984 L37.0409,12.731 C38.9139,14.876 40.2089,17.423 40.8479,20.189 C39.2059,20.687 37.9999,22.198 37.9999,24 C37.9999,25.82 39.2289,27.342 40.8959,27.825 C39.4689,34.305 34.3539,39.495 27.8539,40.987 C27.4019,39.273 25.8539,38 23.9999,38 C22.1439,38 20.5939,39.276 20.1449,40.993 C18.3289,40.583 16.5989,39.904 14.9989,38.933 L13.9619,40.643 C15.8779,41.807 17.9629,42.601 20.1539,43.041 C20.6159,44.74 22.1559,46 23.9999,46 C25.8469,46 27.3899,44.736 27.8479,43.033 C35.4379,41.483 41.4269,35.432 42.9309,27.879 C44.6879,27.457 45.9999,25.884 45.9999,24 L45.9999,24 Z" id="Fill-1" fill="#7AA116"></path>
    </g>
</svg>`, Ix = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/IoT/Res_AWS-IoT_Thing_House_48</title>
    <g id="Icon-Resource/IoT/Res_AWS-IoT_Thing_House_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M17.941,29.125 L19.457,29.125 L19.457,27.609 L17.941,27.609 L17.941,29.125 Z M16.941,25.609 C16.389,25.609 15.941,26.056 15.941,26.609 L15.941,30.125 C15.941,30.677 16.389,31.125 16.941,31.125 L20.457,31.125 C21.01,31.125 21.457,30.677 21.457,30.125 L21.457,26.609 C21.457,26.056 21.01,25.609 20.457,25.609 L16.941,25.609 Z M34.522,22.964 C34.255,22.964 34.001,23.068 33.813,23.256 C33.625,23.443 33.519,23.698 33.519,23.964 L33.519,34.398 L31.125,34.398 L31.125,26.609 C31.125,26.056 30.678,25.609 30.125,25.609 L24.851,25.609 C24.299,25.609 23.851,26.056 23.851,26.609 L23.851,34.398 L14.426,34.398 L14.426,23.928 C14.426,23.378 13.98,22.93 13.429,22.928 L12.51,22.925 L23.973,12.991 L35.483,22.966 L34.522,22.964 Z M24.628,10.912 C24.251,10.586 23.694,10.586 23.317,10.912 L10.134,22.338 C9.915,22.528 9.789,22.803 9.789,23.093 L9.789,23.92 C9.789,24.47 10.234,24.918 10.786,24.92 L12.426,24.925 L12.426,35.398 C12.426,35.951 12.873,36.398 13.426,36.398 L24.851,36.398 C25.404,36.398 25.851,35.951 25.851,35.398 L25.851,27.609 L29.125,27.609 L29.125,35.398 C29.125,35.951 29.572,36.398 30.125,36.398 L34.519,36.398 C35.072,36.398 35.519,35.951 35.519,35.398 L35.519,24.966 L37.153,24.972 L37.156,24.972 C37.421,24.972 37.675,24.868 37.862,24.68 C38.051,24.493 38.156,24.238 38.156,23.972 L38.156,23.093 C38.156,22.803 38.03,22.528 37.811,22.338 L24.628,10.912 Z M39.67,38.537 C39.67,39.163 39.161,39.672 38.535,39.672 L9.409,39.672 C8.783,39.672 8.274,39.163 8.274,38.537 L8.274,9.423 C8.274,8.797 8.783,8.288 9.409,8.288 L38.535,8.288 C39.161,8.288 39.67,8.797 39.67,9.423 L39.67,38.537 Z M45.945,14.425 L45.945,12.425 L41.67,12.425 L41.67,9.423 C41.67,7.694 40.264,6.288 38.535,6.288 L35.519,6.288 L35.519,2 L33.519,2 L33.519,6.288 L30.246,6.288 L30.246,2 L28.246,2 L28.246,6.288 L24.973,6.288 L24.973,2 L22.973,2 L22.973,6.288 L19.699,6.288 L19.699,2 L17.699,2 L17.699,6.288 L14.426,6.288 L14.426,2 L12.426,2 L12.426,6.288 L9.409,6.288 C7.681,6.288 6.274,7.694 6.274,9.423 L6.274,12.425 L2,12.425 L2,14.425 L6.274,14.425 L6.274,17.699 L2,17.699 L2,19.699 L6.274,19.699 L6.274,22.972 L2,22.972 L2,24.972 L6.274,24.972 L6.274,28.246 L2,28.246 L2,30.246 L6.274,30.246 L6.274,33.519 L2,33.519 L2,35.519 L6.274,35.519 L6.274,38.537 C6.274,40.265 7.681,41.672 9.409,41.672 L12.426,41.672 L12.426,45.945 L14.426,45.945 L14.426,41.672 L17.699,41.672 L17.699,45.945 L19.699,45.945 L19.699,41.672 L22.973,41.672 L22.973,45.945 L24.973,45.945 L24.973,41.672 L28.246,41.672 L28.246,45.945 L30.246,45.945 L30.246,41.672 L33.519,41.672 L33.519,45.945 L35.519,45.945 L35.519,41.672 L38.535,41.672 C40.264,41.672 41.67,40.265 41.67,38.537 L41.67,35.519 L45.945,35.519 L45.945,33.519 L41.67,33.519 L41.67,30.246 L45.945,30.246 L45.945,28.246 L41.67,28.246 L41.67,24.972 L45.945,24.972 L45.945,22.972 L41.67,22.972 L41.67,19.699 L45.945,19.699 L45.945,17.699 L41.67,17.699 L41.67,14.425 L45.945,14.425 Z" id="Amazon-IOT-RESOURCES-IoT-thing-house_Resource-Icon_light-bg" fill="#7AA116"></path>
    </g>
</svg>`, Fx = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/IoT/Res_AWS-IoT_Over-Air-Update_48</title>
    <g id="Icon-Resource/IoT/Res_AWS-IoT_Over-Air-Update_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M18.1091,38.1885 L20.3961,38.1885 L20.3961,36.1885 L14.8481,36.1885 L14.8481,41.6995 L16.8481,41.6995 L16.8481,39.7385 C18.5551,41.1515 20.7111,41.9525 22.9501,41.9525 C28.2251,41.9525 32.5161,37.6615 32.5161,32.3865 L30.5161,32.3865 C30.5161,36.5575 27.1221,39.9525 22.9501,39.9525 C21.1731,39.9525 19.4611,39.3145 18.1091,38.1885 Z M25.6081,28.5285 L31.1561,28.5285 L31.1561,23.0175 L29.1561,23.0175 L29.1561,25.1195 C27.4341,23.6505 25.2351,22.8195 22.9501,22.8195 C17.6751,22.8195 13.3841,27.1105 13.3841,32.3865 L15.3841,32.3865 C15.3841,28.2145 18.7781,24.8195 22.9501,24.8195 C24.6981,24.8195 26.3801,25.4375 27.7211,26.5285 L25.6081,26.5285 L25.6081,28.5285 Z M43.6101,33.4125 C41.1641,35.8415 37.7191,35.8905 37.4451,35.8905 L37.4331,35.8905 L35.1561,35.8895 L35.1581,33.8895 L37.4411,33.8905 C37.4671,33.8905 39.1641,33.8815 40.8031,33.0125 C42.9001,31.8995 43.9651,29.8945 43.9651,27.0525 C43.9651,25.7925 43.6381,23.9065 40.8211,22.0905 C39.3541,21.1425 37.9801,20.8315 37.4581,20.7415 C36.9301,20.6505 36.5701,20.1625 36.6361,19.6345 C36.4751,17.5305 35.8281,16.1605 34.7111,15.5625 C33.3231,14.8185 31.4421,15.2185 30.4291,16.4665 L30.3131,16.6145 C30.0961,16.9115 29.7371,17.0665 29.3671,17.0115 C29.0041,16.9595 28.6971,16.7115 28.5701,16.3665 L28.4321,15.9925 C27.8231,14.3975 26.9711,13.0385 25.9031,11.9635 C24.4981,10.5505 20.6451,7.5065 15.2031,9.8215 C12.0621,11.1555 9.6021,15.0035 9.6021,18.5805 C9.6021,18.9805 9.6261,19.3815 9.6741,19.7725 C9.7351,20.2815 9.4001,20.7555 8.8991,20.8675 C8.8861,20.8705 8.8711,20.8735 8.8561,20.8765 C7.0091,21.3685 4.0001,22.8455 4.0001,27.2285 C4.0001,30.5695 5.8051,32.4115 7.3211,33.3675 C7.8311,33.6895 8.4191,33.8605 9.0201,33.8615 L11.6211,33.8635 L11.6191,35.8635 L9.0181,35.8615 C8.0381,35.8605 7.0821,35.5825 6.2531,35.0585 C4.6651,34.0565 2.0001,31.7055 2.0001,27.2285 C2.0001,21.9585 5.4621,19.9235 7.6171,19.1675 C7.6071,18.9725 7.6021,18.7755 7.6021,18.5805 C7.6021,14.1895 10.5341,9.6325 14.4211,7.9805 C18.9781,6.0465 23.8001,7.0095 27.3211,10.5535 C28.3481,11.5875 29.2031,12.8315 29.8701,14.2625 C31.5331,13.0455 33.8221,12.8195 35.6551,13.7995 C36.8041,14.4145 38.2021,15.8045 38.5761,18.9395 C39.7121,19.2365 40.8891,19.7535 41.9051,20.4095 C44.6371,22.1705 45.9651,24.3445 45.9651,27.0525 C45.9651,29.7215 45.1731,31.8615 43.6101,33.4125 Z" id="Amazon-IOT-RESOURCES-Over-the-air-update_Resource-Icon_light-bg" fill="#7AA116"></path>
    </g>
</svg>`, Ox = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/IoT/Res_AWS-IoT_Thing_Bank_48</title>
    <g id="Icon-Resource/IoT/Res_AWS-IoT_Thing_Bank_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M25.6928,27.4246 C25.6928,27.7536 25.5828,28.0426 25.3628,28.2926 C25.1438,28.5416 24.8688,28.6876 24.5398,28.7266 L24.5398,26.1666 C24.9488,26.3166 25.2428,26.4886 25.4228,26.6836 C25.6028,26.8776 25.6928,27.1246 25.6928,27.4246 Z M23.4318,24.0406 C23.0318,23.8806 22.7448,23.7016 22.5708,23.5016 C22.3968,23.3026 22.3098,23.0576 22.3098,22.7686 C22.3098,22.4186 22.4088,22.1266 22.6088,21.8926 C22.8078,21.6586 23.0818,21.5156 23.4318,21.4656 L23.4318,24.0406 Z M23.4318,18.0226 L23.4318,19.8336 C22.5328,19.9136 21.8098,20.2336 21.2608,20.7916 C20.7118,21.3516 20.4378,22.0546 20.4378,22.9036 C20.4378,23.5416 20.6268,24.0786 21.0068,24.5126 C21.3858,24.9466 21.9948,25.3186 22.8328,25.6276 L23.4318,25.8526 L23.4318,28.7426 C23.0818,28.7116 22.6978,28.6266 22.2788,28.4876 C21.8598,28.3476 21.2908,28.1136 20.5718,27.7836 L20.5718,29.4596 C21.3908,29.9896 22.3438,30.2936 23.4318,30.3736 L23.4318,32.2006 L24.5398,32.2006 L24.5398,30.3586 C25.4678,30.2486 26.2088,29.9166 26.7628,29.3636 C27.3178,28.8096 27.5938,28.1186 27.5938,27.2896 C27.5938,26.6516 27.3998,26.1176 27.0098,25.6876 C26.6208,25.2586 25.9718,24.8786 25.0638,24.5496 L24.5398,24.3556 L24.5398,21.4806 C25.2188,21.5706 25.9718,21.8296 26.8008,22.2586 L26.8008,20.5816 C26.0718,20.1726 25.3188,19.9286 24.5398,19.8486 L24.5398,18.0226 L23.4318,18.0226 Z M35.3458,18.6136 L33.7038,18.6136 C33.1518,18.6136 32.7038,19.0606 32.7038,19.6136 L32.7038,32.9206 C32.7038,33.4736 33.1518,33.9206 33.7038,33.9206 L34.3978,33.9206 L34.3978,34.4646 L13.6358,34.4646 L13.6358,33.9206 L14.3288,33.9206 C14.8818,33.9206 15.3288,33.4736 15.3288,32.9206 L15.3288,19.6136 C15.3288,19.0606 14.8818,18.6136 14.3288,18.6136 L12.6878,18.6136 L12.6878,17.5216 L24.0168,13.6246 L35.3458,17.5216 L35.3458,18.6136 Z M24.3418,11.6216 C24.1308,11.5496 23.9018,11.5496 23.6918,11.6216 L11.3618,15.8626 C10.9588,16.0006 10.6878,16.3806 10.6878,16.8076 L10.6878,19.6136 C10.6878,20.1656 11.1348,20.6136 11.6878,20.6136 L13.3288,20.6136 L13.3288,31.9206 L12.6358,31.9206 C12.0828,31.9206 11.6358,32.3686 11.6358,32.9206 L11.6358,35.4646 C11.6358,36.0176 12.0828,36.4646 12.6358,36.4646 L35.3978,36.4646 C35.9498,36.4646 36.3978,36.0176 36.3978,35.4646 L36.3978,32.9206 C36.3978,32.3686 35.9498,31.9206 35.3978,31.9206 L34.7038,31.9206 L34.7038,20.6136 L36.3458,20.6136 C36.8988,20.6136 37.3458,20.1656 37.3458,19.6136 L37.3458,16.8076 C37.3458,16.3806 37.0738,16.0006 36.6708,15.8626 L24.3418,11.6216 Z M39.7468,38.6146 C39.7468,39.2406 39.2378,39.7486 38.6118,39.7486 L9.4198,39.7486 C8.7938,39.7486 8.2848,39.2406 8.2848,38.6146 L8.2848,9.4336 C8.2848,8.8076 8.7938,8.2986 9.4198,8.2986 L38.6118,8.2986 C39.2378,8.2986 39.7468,8.8076 39.7468,9.4336 L39.7468,38.6146 Z M46.0328,14.4486 L46.0328,12.4486 L41.7468,12.4486 L41.7468,9.4336 C41.7468,7.7046 40.3408,6.2986 38.6118,6.2986 L35.5838,6.2986 L35.5838,1.9996 L33.5838,1.9996 L33.5838,6.2986 L30.3008,6.2986 L30.3008,1.9996 L28.3008,1.9996 L28.3008,6.2986 L25.0168,6.2986 L25.0168,1.9996 L23.0168,1.9996 L23.0168,6.2986 L19.7328,6.2986 L19.7328,1.9996 L17.7328,1.9996 L17.7328,6.2986 L14.4478,6.2986 L14.4478,1.9996 L12.4478,1.9996 L12.4478,6.2986 L9.4198,6.2986 C7.6918,6.2986 6.2848,7.7046 6.2848,9.4336 L6.2848,12.4486 L1.9998,12.4486 L1.9998,14.4486 L6.2848,14.4486 L6.2848,17.7326 L1.9998,17.7326 L1.9998,19.7326 L6.2848,19.7326 L6.2848,23.0166 L1.9998,23.0166 L1.9998,25.0166 L6.2848,25.0166 L6.2848,28.2996 L1.9998,28.2996 L1.9998,30.2996 L6.2848,30.2996 L6.2848,33.5836 L1.9998,33.5836 L1.9998,35.5836 L6.2848,35.5836 L6.2848,38.6146 C6.2848,40.3426 7.6918,41.7486 9.4198,41.7486 L12.4478,41.7486 L12.4478,46.0336 L14.4478,46.0336 L14.4478,41.7486 L17.7328,41.7486 L17.7328,46.0336 L19.7328,46.0336 L19.7328,41.7486 L23.0168,41.7486 L23.0168,46.0336 L25.0168,46.0336 L25.0168,41.7486 L28.3008,41.7486 L28.3008,46.0336 L30.3008,46.0336 L30.3008,41.7486 L33.5838,41.7486 L33.5838,46.0336 L35.5838,46.0336 L35.5838,41.7486 L38.6118,41.7486 C40.3408,41.7486 41.7468,40.3426 41.7468,38.6146 L41.7468,35.5836 L46.0328,35.5836 L46.0328,33.5836 L41.7468,33.5836 L41.7468,30.2996 L46.0328,30.2996 L46.0328,28.2996 L41.7468,28.2996 L41.7468,25.0166 L46.0328,25.0166 L46.0328,23.0166 L41.7468,23.0166 L41.7468,19.7326 L46.0328,19.7326 L46.0328,17.7326 L41.7468,17.7326 L41.7468,14.4486 L46.0328,14.4486 Z" id="Amazon-IOT-RESOURCES-IoT-thing-bank_Resource-Icon_light-bg" fill="#7AA116"></path>
    </g>
</svg>`, Nx = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/IoT/Res_AWS-IoT_Sensor_48</title>
    <g id="Icon-Resource/IoT/Res_AWS-IoT_Sensor_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M22.664,40.3939 L25.674,40.3939 L24.169,38.3539 L22.664,40.3939 Z M19.879,40.7999 L23.364,36.0759 C23.741,35.5639 24.597,35.5639 24.974,36.0759 L28.459,40.7999 C28.683,41.1039 28.717,41.5079 28.547,41.8449 C28.377,42.1809 28.031,42.3939 27.654,42.3939 L20.684,42.3939 C20.307,42.3939 19.961,42.1809 19.791,41.8449 C19.621,41.5079 19.655,41.1039 19.879,40.7999 Z M11.534,40.6319 C12.28,40.6319 12.887,40.0259 12.887,39.2799 C12.887,38.5339 12.28,37.9269 11.534,37.9269 C10.788,37.9269 10.182,38.5339 10.182,39.2799 C10.182,40.0259 10.788,40.6319 11.534,40.6319 Z M11.534,35.9269 C13.383,35.9269 14.887,37.4309 14.887,39.2799 C14.887,41.1279 13.383,42.6319 11.534,42.6319 C9.685,42.6319 8.182,41.1279 8.182,39.2799 C8.182,37.4309 9.685,35.9269 11.534,35.9269 Z M6,43.9429 L42.338,43.9429 L42.338,34.6159 L6,34.6159 L6,43.9429 Z M44.338,44.9429 C44.338,45.4959 43.891,45.9429 43.338,45.9429 L5,45.9429 C4.447,45.9429 4,45.4959 4,44.9429 L4,33.6159 C4,33.0629 4.447,32.6159 5,32.6159 L23.169,32.6159 L23.169,21.2169 L21.391,22.9959 L19.976,21.5819 L23.462,18.0959 C23.852,17.7059 24.485,17.7059 24.876,18.0959 L28.361,21.5819 L26.947,22.9959 L25.169,21.2169 L25.169,32.6159 L43.338,32.6159 C43.891,32.6159 44.338,33.0629 44.338,33.6159 L44.338,44.9429 Z M4.68,19.9419 C4.68,16.4949 6.538,13.8609 9.698,12.7519 C9.692,12.6089 9.689,12.4669 9.689,12.3269 C9.689,8.4109 12.343,4.3469 15.862,2.8729 C19.965,1.1529 24.318,2.0049 27.503,5.1599 C28.401,6.0509 29.152,7.1169 29.745,8.3369 C30.552,7.7689 31.503,7.4579 32.499,7.4579 C34.657,7.4579 37.08,9.0529 37.588,12.5379 C40.65,13.3039 43.658,15.5999 43.658,20.0029 C43.658,25.5919 39.016,27.4419 36.56,27.6399 L26.781,27.6339 L26.783,25.6339 L36.481,25.6429 C36.611,25.6269 41.658,25.1269 41.658,20.0029 C41.658,15.6879 38.043,14.6119 36.489,14.3499 C35.97,14.2619 35.607,13.7879 35.66,13.2639 C35.466,10.4789 33.835,9.4579 32.499,9.4579 C31.604,9.4579 30.763,9.8989 30.189,10.6669 C29.97,10.9629 29.609,11.1089 29.239,11.0589 C28.875,11.0039 28.57,10.7529 28.446,10.4069 C27.897,8.8719 27.106,7.5829 26.096,6.5809 C24.852,5.3489 21.435,2.7009 16.635,4.7179 C13.861,5.8789 11.689,9.2209 11.689,12.3269 C11.689,12.6799 11.714,13.0249 11.752,13.3629 C11.81,13.8609 11.489,14.3249 11.003,14.4469 C9.389,14.8539 6.68,16.1089 6.68,19.9419 C6.68,20.1169 6.687,20.2739 6.695,20.4329 C6.876,23.3339 9.432,25.6169 12.511,25.6169 L21.556,25.6249 L21.554,27.6249 L12.51,27.6169 C8.378,27.6169 4.946,24.5099 4.698,20.5449 C4.687,20.3419 4.68,20.1519 4.68,19.9419 Z" id="Amazon-IOT-RESOURCES-IoT-sensor_Resource-Icon_light-bg" fill="#7AA116"></path>
    </g>
</svg>`, Dx = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/IoT/Res_AWS-IoT-SiteWise_Asset-Hierarchy_48</title>
    <g id="Icon-Resource/IoT/Res_AWS-IoT-SiteWise_Asset-Hierarchy_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M22,8 L26,8 L26,4 L22,4 L22,8 Z M21,10 L27,10 C27.552,10 28,9.552 28,9 L28,3 C28,2.448 27.552,2 27,2 L21,2 C20.448,2 20,2.448 20,3 L20,9 C20,9.552 20.448,10 21,10 L21,10 Z M14,25 L18,25 L18,21 L14,21 L14,25 Z M30,25 L34,25 L34,21 L30,21 L30,25 Z M7,32 L23,32 L23,36 L25,36 L25,32 L41,32 L41,36 L43,36 L43,31 C43,30.448 42.552,30 42,30 L33,30 L33,27 L35,27 C35.552,27 36,26.552 36,26 L36,20 C36,19.448 35.552,19 35,19 L29,19 C28.448,19 28,19.448 28,20 L28,26 C28,26.552 28.448,27 29,27 L31,27 L31,30 L17,30 L17,27 L19,27 C19.552,27 20,26.552 20,26 L20,20 C20,19.448 19.552,19 19,19 L13,19 C12.448,19 12,19.448 12,20 L12,26 C12,26.552 12.448,27 13,27 L15,27 L15,30 L6,30 C5.448,30 5,30.448 5,31 L5,36 L7,36 L7,32 Z M17,17 L15,17 L15,14 C15,13.448 15.448,13 16,13 L23,13 L23,11 L25,11 L25,13 L32,13 C32.552,13 33,13.448 33,14 L33,17 L31,17 L31,15 L17,15 L17,17 Z M40,44 L44,44 L44,40 L40,40 L40,44 Z M45,38 L39,38 C38.448,38 38,38.448 38,39 L38,45 C38,45.552 38.448,46 39,46 L45,46 C45.552,46 46,45.552 46,45 L46,39 C46,38.448 45.552,38 45,38 L45,38 Z M22,44 L26,44 L26,40 L22,40 L22,44 Z M27,38 L21,38 C20.448,38 20,38.448 20,39 L20,45 C20,45.552 20.448,46 21,46 L27,46 C27.552,46 28,45.552 28,45 L28,39 C28,38.448 27.552,38 27,38 L27,38 Z M4,44 L8,44 L8,40 L4,40 L4,44 Z M9,38 L3,38 C2.448,38 2,38.448 2,39 L2,45 C2,45.552 2.448,46 3,46 L9,46 C9.552,46 10,45.552 10,45 L10,39 C10,38.448 9.552,38 9,38 L9,38 Z" id="Fill-1" fill="#7AA116"></path>
    </g>
</svg>`, Px = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/IoT/Res_AWS-IoT-Greengrass_Artifact_48</title>
    <g id="Icon-Resource/IoT/Res_AWS-IoT-Greengrass_Artifact_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M9,24 C9,22.897 8.103,22 7,22 C5.897,22 5,22.897 5,24 C5,25.103 5.897,26 7,26 C8.103,26 9,25.103 9,24 L9,24 Z M42,22 C40.897,22 40,22.897 40,24 C40,25.103 40.897,26 42,26 C43.103,26 44,25.103 44,24 C44,22.897 43.103,22 42,22 L42,22 Z M24.452,42 C23.35,42 22.452,42.897 22.452,44 C22.452,45.103 23.35,46 24.452,46 C25.555,46 26.452,45.103 26.452,44 C26.452,42.897 25.555,42 24.452,42 L24.452,42 Z M24.452,6 C25.555,6 26.452,5.103 26.452,4 C26.452,2.897 25.555,2 24.452,2 C23.35,2 22.452,2.897 22.452,4 C22.452,5.103 23.35,6 24.452,6 L24.452,6 Z M26.577,16.693 L20.473,30.33 L22.299,31.147 L28.403,17.51 L26.577,16.693 Z M30.189,27.804 L34.821,24.424 C35.056,24.252 35.205,23.987 35.229,23.697 C35.252,23.407 35.147,23.122 34.943,22.914 L30.875,18.787 L29.451,20.191 L32.705,23.492 L29.01,26.189 L30.189,27.804 Z M18.688,18.661 L14,22.083 C13.765,22.254 13.616,22.52 13.593,22.81 C13.569,23.1 13.674,23.386 13.879,23.593 L17.961,27.72 L19.383,26.314 L16.118,23.013 L19.867,20.276 L18.688,18.661 Z M41,20 L43,20 L43,14.166 C43,13.809 42.811,13.479 42.502,13.3 L28.039,4.916 L27.035,6.646 L41,14.742 L41,20 Z M41,33.621 L27.065,41.611 L28.06,43.347 L42.497,35.068 C42.809,34.89 43,34.559 43,34.2 L43,28 L41,28 L41,33.621 Z M7.999,28 L5.999,28 L5.999,34.009 C5.999,34.362 6.186,34.69 6.49,34.87 L20.698,43.266 L21.716,41.544 L7.999,33.438 L7.999,28 Z M7.999,20 L5.999,20 L5.999,13.974 C5.999,13.616 6.19,13.285 6.501,13.107 L20.747,4.916 L21.743,6.649 L7.999,14.552 L7.999,20 Z" id="Fill-1" fill="#7AA116"></path>
    </g>
</svg>`, Bx = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/IoT/Res_AWS-IoT_Thing_Travel_48</title>
    <g id="Icon-Resource/IoT/Res_AWS-IoT_Thing_Travel_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M34.515,24.1767 C34.64,24.0517 34.843,24.0517 34.968,24.1767 C35.093,24.3017 35.093,24.5047 34.968,24.6297 L33.307,26.2897 L33.137,25.5537 L34.515,24.1767 Z M31.687,34.2287 L27.182,24.3197 C27.049,24.0277 26.784,23.8167 26.469,23.7527 C26.155,23.6937 25.827,23.7817 25.592,23.9997 L20.686,28.5517 C20.482,28.7407 20.366,29.0067 20.366,29.2847 L20.366,35.0307 L20.086,35.3077 L18.56,30.0657 C18.464,29.7347 18.204,29.4767 17.873,29.3827 L12.709,27.9137 L12.979,27.6447 L18.725,27.6447 C19.008,27.6447 19.278,27.5247 19.467,27.3147 L23.953,22.3427 C24.167,22.1067 24.255,21.7807 24.191,21.4697 C24.125,21.1567 23.915,20.8947 23.625,20.7627 L13.716,16.2577 L14.855,15.1187 L27.369,18.0097 C27.712,18.0857 28.079,17.9787 28.324,17.7187 L31.979,13.8097 C32.822,12.9657 34.78,12.4167 35.155,12.7877 C35.259,12.8937 35.344,13.3427 35.123,14.1117 C34.895,14.9357 34.452,15.6507 34.16,15.9437 L30.227,19.6207 C29.966,19.8647 29.855,20.2287 29.935,20.5757 L32.826,33.0897 L31.687,34.2287 Z M23.329,12.9907 C23.454,12.8657 23.658,12.8657 23.783,12.9907 C23.908,13.1157 23.908,13.3197 23.783,13.4447 L22.414,14.8127 L21.677,14.6427 L23.329,12.9907 Z M35.549,17.3807 C36.174,16.7557 36.764,15.6817 37.048,14.6547 C37.452,13.2527 37.282,12.0877 36.571,11.3757 C35.022,9.8267 31.803,11.1577 30.541,12.4187 L27.256,15.9307 L24.711,15.3427 L25.197,14.8587 C26.101,13.9537 26.101,12.4817 25.197,11.5767 C24.292,10.6727 22.82,10.6727 21.915,11.5767 L19.379,14.1127 L14.764,13.0457 C14.432,12.9687 14.077,13.0697 13.832,13.3137 L11.282,15.8637 C11.049,16.0957 10.947,16.4267 11.004,16.7497 C11.063,17.0727 11.277,17.3457 11.575,17.4817 L21.553,22.0177 L18.281,25.6447 L12.564,25.6447 C12.298,25.6447 12.043,25.7497 11.856,25.9387 L10.093,27.7047 C9.843,27.9557 9.744,28.3207 9.833,28.6627 C9.922,29.0057 10.187,29.2767 10.528,29.3727 L16.794,31.1557 L18.637,37.4857 C18.736,37.8237 19.005,38.0857 19.347,38.1747 C19.43,38.1957 19.514,38.2057 19.597,38.2057 C19.858,38.2057 20.113,38.1037 20.302,37.9147 L22.071,36.1547 C22.259,35.9667 22.366,35.7107 22.366,35.4457 L22.366,29.7217 L25.935,26.4087 L30.463,36.3697 C30.599,36.6687 30.872,36.8817 31.195,36.9407 C31.516,37.0007 31.848,36.8957 32.08,36.6627 L34.631,34.1127 C34.875,33.8677 34.976,33.5167 34.899,33.1807 L33.838,28.5877 L36.382,26.0437 C37.286,25.1397 37.286,23.6667 36.382,22.7627 C35.478,21.8587 34.005,21.8587 33.101,22.7627 L32.607,23.2567 L32.014,20.6887 L35.549,17.3807 Z M39.725,38.5917 C39.725,39.2177 39.216,39.7267 38.59,39.7267 L9.417,39.7267 C8.791,39.7267 8.283,39.2177 8.283,38.5917 L8.283,9.4307 C8.283,8.8047 8.791,8.2957 9.417,8.2957 L38.59,8.2957 C39.216,8.2957 39.725,8.8047 39.725,9.4307 L39.725,38.5917 Z M46.007,14.4427 L46.007,12.4427 L41.725,12.4427 L41.725,9.4307 C41.725,7.7017 40.319,6.2957 38.59,6.2957 L35.566,6.2957 L35.566,1.9997 L33.566,1.9997 L33.566,6.2957 L30.285,6.2957 L30.285,1.9997 L28.285,1.9997 L28.285,6.2957 L25.004,6.2957 L25.004,1.9997 L23.004,1.9997 L23.004,6.2957 L19.723,6.2957 L19.723,1.9997 L17.723,1.9997 L17.723,6.2957 L14.442,6.2957 L14.442,1.9997 L12.442,1.9997 L12.442,6.2957 L9.417,6.2957 C7.689,6.2957 6.283,7.7017 6.283,9.4307 L6.283,12.4427 L2,12.4427 L2,14.4427 L6.283,14.4427 L6.283,17.7227 L2,17.7227 L2,19.7227 L6.283,19.7227 L6.283,23.0037 L2,23.0037 L2,25.0037 L6.283,25.0037 L6.283,28.2847 L2,28.2847 L2,30.2847 L6.283,30.2847 L6.283,33.5657 L2,33.5657 L2,35.5657 L6.283,35.5657 L6.283,38.5917 C6.283,40.3207 7.689,41.7267 9.417,41.7267 L12.442,41.7267 L12.442,46.0077 L14.442,46.0077 L14.442,41.7267 L17.723,41.7267 L17.723,46.0077 L19.723,46.0077 L19.723,41.7267 L23.004,41.7267 L23.004,46.0077 L25.004,46.0077 L25.004,41.7267 L28.285,41.7267 L28.285,46.0077 L30.285,46.0077 L30.285,41.7267 L33.566,41.7267 L33.566,46.0077 L35.566,46.0077 L35.566,41.7267 L38.59,41.7267 C40.319,41.7267 41.725,40.3207 41.725,38.5917 L41.725,35.5657 L46.007,35.5657 L46.007,33.5657 L41.725,33.5657 L41.725,30.2847 L46.007,30.2847 L46.007,28.2847 L41.725,28.2847 L41.725,25.0037 L46.007,25.0037 L46.007,23.0037 L41.725,23.0037 L41.725,19.7227 L46.007,19.7227 L46.007,17.7227 L41.725,17.7227 L41.725,14.4427 L46.007,14.4427 Z" id="Amazon-IOT-RESOURCES-IoT-thing-travel_Resource-Icon_light-bg" fill="#7AA116"></path>
    </g>
</svg>`, zx = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/IoT/Res_AWS-IoT_MQTT_Protocol_48</title>
    <g id="Icon-Resource/IoT/Res_AWS-IoT_MQTT_Protocol_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M31.3459,38.7085 C31.3459,37.7435 31.2019,37.0165 30.9159,36.5265 C30.6299,36.0375 30.2019,35.7925 29.6359,35.7925 C29.0689,35.7925 28.6439,36.0375 28.3559,36.5265 C28.0689,37.0165 27.9259,37.7435 27.9259,38.7085 C27.9259,39.6735 28.0689,40.4035 28.3559,40.8955 C28.6439,41.3885 29.0689,41.6355 29.6359,41.6355 C30.2019,41.6355 30.6299,41.3885 30.9159,40.8955 C31.2019,40.4035 31.3459,39.6735 31.3459,38.7085 Z M18.8609,43.9605 L32.0189,43.9605 C31.5959,43.8745 31.1869,43.7445 30.8009,43.5345 C30.3249,43.2755 29.8889,42.9295 29.4889,42.4965 C28.9369,42.4675 28.4649,42.2995 28.0729,41.9925 C27.6819,41.6845 27.3869,41.2505 27.1869,40.6915 C26.9879,40.1315 26.8879,39.4705 26.8879,38.7085 C26.8879,37.5125 27.1289,36.5835 27.6109,35.9235 C28.0949,35.2625 28.7699,34.9325 29.6359,34.9325 C30.5029,34.9325 31.1789,35.2625 31.6609,35.9235 C32.1439,36.5835 32.3839,37.5125 32.3839,38.7085 C32.3839,39.7025 32.2169,40.5145 31.8819,41.1475 C31.5459,41.7815 31.0659,42.1915 30.4439,42.3795 C30.7239,42.6045 31.0149,42.7755 31.3149,42.8945 C31.6149,43.0125 31.9469,43.0925 32.3119,43.1355 L32.3119,43.9605 L40.1959,43.9605 L43.9609,43.9605 L43.9609,40.1965 L43.9609,32.8485 L18.8609,32.8485 L18.8609,43.9605 Z M16.8609,30.8485 L45.9609,30.8485 L45.9609,40.1965 L45.9609,45.9605 L40.1959,45.9605 L16.8609,45.9605 L16.8609,30.8485 Z M7.7639,1.9995 C4.5859,1.9995 1.9999,4.5855 1.9999,7.7645 L1.9999,40.1965 C1.9999,43.3745 4.5859,45.9605 7.7639,45.9605 L15.2379,45.9605 L15.2379,43.9605 L7.7639,43.9605 C5.6879,43.9605 3.9999,42.2725 3.9999,40.1965 L3.9999,7.7645 C3.9999,5.6885 5.6879,3.9995 7.7639,3.9995 L40.1959,3.9995 C42.2719,3.9995 43.9609,5.6885 43.9609,7.7645 L43.9609,29.2255 L45.9609,29.2255 L45.9609,7.7645 C45.9609,4.5855 43.3749,1.9995 40.1959,1.9995 L7.7639,1.9995 Z M39.9889,42.3375 L41.0079,42.3375 L41.0079,35.9185 L42.8209,35.9185 L42.8209,35.0695 L38.1859,35.0695 L38.1859,35.9185 L39.9889,35.9185 L39.9889,42.3375 Z M34.7439,42.3375 L35.7629,42.3375 L35.7629,35.9185 L37.5769,35.9185 L37.5769,35.0695 L32.9409,35.0695 L32.9409,35.9185 L34.7439,35.9185 L34.7439,42.3375 Z M24.3809,35.0695 L25.4809,35.0695 L25.4809,42.3375 L24.5689,42.3375 L24.5689,36.6425 L23.0799,40.4705 L22.1669,40.4705 L20.6779,36.6425 L20.6779,42.3375 L19.7649,42.3375 L19.7649,35.0695 L20.9089,35.0695 L22.6389,39.5165 L24.3809,35.0695 Z" id="Amazon-IOT-RESOURCES-IoT-MQTT-protocol_Resource-Icon_light-bg" fill="#7AA116"></path>
    </g>
</svg>`, Ux = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/IoT/Res_AWS-IoT_Shadow_48</title>
    <g id="Icon-Resource/IoT/Res_AWS-IoT_Shadow_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M35.437,40.4143 L37.803,40.4143 L37.803,38.0493 L35.437,38.0493 L35.437,40.4143 Z M38.803,42.4143 C39.356,42.4143 39.803,41.9673 39.803,41.4143 L39.803,37.0493 C39.803,36.4963 39.356,36.0493 38.803,36.0493 L34.437,36.0493 C33.884,36.0493 33.437,36.4963 33.437,37.0493 L33.437,41.4143 C33.437,41.9673 33.884,42.4143 34.437,42.4143 L38.803,42.4143 Z M23.958,38.3003 L25.47,40.3503 L22.446,40.3503 L23.958,38.3003 Z M27.451,42.3503 C27.828,42.3503 28.173,42.1383 28.343,41.8023 C28.513,41.4653 28.479,41.0603 28.255,40.7573 L24.763,36.0213 C24.575,35.7663 24.276,35.6153 23.958,35.6153 C23.641,35.6153 23.342,35.7653 23.154,36.0213 L19.661,40.7573 C19.437,41.0603 19.403,41.4653 19.573,41.8023 C19.743,42.1373 20.088,42.3503 20.465,42.3503 L27.451,42.3503 Z M12.654,39.2313 C12.654,39.9793 12.044,40.5893 11.296,40.5893 C10.548,40.5893 9.939,39.9793 9.939,39.2313 C9.939,38.4833 10.548,37.8743 11.296,37.8743 C12.044,37.8743 12.654,38.4833 12.654,39.2313 Z M14.654,39.2313 C14.654,37.3803 13.148,35.8743 11.296,35.8743 C9.445,35.8743 7.939,37.3803 7.939,39.2313 C7.939,41.0833 9.445,42.5893 11.296,42.5893 C13.148,42.5893 14.654,41.0833 14.654,39.2313 Z M5.747,43.9073 L42.168,43.9073 L42.168,34.5553 L5.747,34.5553 L5.747,43.9073 Z M4.747,32.5553 C4.195,32.5553 3.747,33.0033 3.747,33.5553 L3.747,44.9073 C3.747,45.4603 4.195,45.9073 4.747,45.9073 L43.168,45.9073 C43.721,45.9073 44.168,45.4603 44.168,44.9073 L44.168,33.5553 C44.168,33.0033 43.721,32.5553 43.168,32.5553 L4.747,32.5553 Z M32.808,23.0133 L34.31,23.0133 L34.31,21.5123 L32.808,21.5123 L32.808,23.0133 Z M31.808,19.5123 C31.255,19.5123 30.808,19.9603 30.808,20.5123 L30.808,24.0133 C30.808,24.5663 31.255,25.0133 31.808,25.0133 L35.31,25.0133 C35.863,25.0133 36.31,24.5663 36.31,24.0133 L36.31,20.5123 C36.31,19.9603 35.863,19.5123 35.31,19.5123 L31.808,19.5123 Z M22.6,22.9503 L23.376,22.0193 L24.152,22.9503 L22.6,22.9503 Z M24.145,19.8173 C23.954,19.5893 23.673,19.4573 23.376,19.4573 C23.079,19.4573 22.798,19.5893 22.608,19.8163 L19.697,23.3093 C19.449,23.6083 19.395,24.0223 19.56,24.3743 C19.724,24.7253 20.078,24.9503 20.465,24.9503 L26.287,24.9503 C26.674,24.9503 27.028,24.7253 27.192,24.3743 C27.357,24.0233 27.303,23.6083 27.055,23.3103 L24.145,19.8173 Z M12.605,22.2043 C12.605,21.7213 12.997,21.3293 13.48,21.3293 C13.961,21.3293 14.354,21.7213 14.354,22.2043 C14.354,22.6853 13.961,23.0783 13.48,23.0783 C12.997,23.0783 12.605,22.6853 12.605,22.2043 Z M10.605,22.2043 C10.605,23.7893 11.895,25.0783 13.48,25.0783 C15.065,25.0783 16.354,23.7893 16.354,22.2043 C16.354,20.6193 15.065,19.3293 13.48,19.3293 C11.895,19.3293 10.605,20.6193 10.605,22.2043 Z M10.114,25.5693 L36.929,25.5693 L36.929,18.8383 L10.114,18.8383 L10.114,25.5693 Z M37.929,27.5693 C38.482,27.5693 38.929,27.1223 38.929,26.5693 L38.929,17.8383 C38.929,17.2853 38.482,16.8383 37.929,16.8383 L9.114,16.8383 C8.561,16.8383 8.114,17.2853 8.114,17.8383 L8.114,26.5693 C8.114,27.1223 8.561,27.5693 9.114,27.5693 L37.929,27.5693 Z M9.007,15.9643 C9.494,15.8413 9.813,15.3753 9.753,14.8763 C9.705,14.4763 9.681,14.0713 9.681,13.6723 C9.681,10.0613 12.178,6.1783 15.367,4.8303 C16.803,4.2223 18.131,3.9813 19.335,3.9813 C22.759,3.9813 25.177,5.9363 26.233,6.9943 C27.397,8.1593 28.305,9.6493 28.934,11.4253 C29.057,11.7733 29.363,12.0253 29.729,12.0803 C30.09,12.1303 30.46,11.9813 30.68,11.6853 C31.553,10.5063 32.971,9.9983 34.288,10.3813 C35.882,10.8473 36.934,12.4723 37.116,14.7373 C37.05,15.2643 37.412,15.7543 37.939,15.8443 C39.736,16.1523 43.915,17.4143 43.915,22.4603 C43.915,28.4663 38.081,29.0443 37.918,29.0623 L10.744,29.0343 C7.186,29.0303 4.232,26.3583 4.018,22.9513 C4.006,22.7693 4,22.5863 4,22.3953 C4,17.9083 7.137,16.4403 9.007,15.9643 Z M37.998,31.0593 C40.737,30.8373 45.915,28.7543 45.915,22.4603 C45.915,17.4693 42.5,14.8813 39.051,14.0343 C38.669,11.1893 37.131,9.1293 34.85,8.4623 C33.242,7.9883 31.555,8.3303 30.233,9.3233 C29.557,7.8803 28.692,6.6253 27.648,5.5803 C24.08,2.0093 19.199,1.0393 14.587,2.9883 C10.65,4.6523 7.681,9.2453 7.681,13.6723 C7.681,13.8703 7.686,14.0703 7.696,14.2703 C5.514,15.0283 2,17.0773 2,22.3953 C2,22.6293 2.008,22.8553 2.022,23.0763 C2.301,27.5343 6.131,31.0293 10.742,31.0343 L37.998,31.0593 Z" id="Amazon-IOT-RESOURCES-IoT-shadow_Resource-Icon_light-bg" fill="#7AA116"></path>
    </g>
</svg>`, Wx = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/IoT/Res_AWS-IoT_Fire_TV_48</title>
    <g id="Icon-Resource/IoT/Res_AWS-IoT_Fire_TV_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M40.3984,18.7762 C40.7964,19.2682 40.2934,22.6832 38.3464,24.3122 C38.0464,24.5622 37.7614,24.4292 37.8944,24.0982 C38.3324,23.0042 39.3134,20.5542 38.8484,19.9592 C38.3844,19.3642 35.7794,19.6772 34.6094,19.8172 C34.2544,19.8602 34.1994,19.5502 34.5194,19.3252 C36.5974,17.8662 40.0024,18.2872 40.3984,18.7762 Z M7.8824,19.0432 C12.5524,21.7612 18.3284,23.3972 24.2924,23.3972 C28.3174,23.3972 32.7404,22.5612 36.8104,20.8352 C37.4234,20.5752 37.9384,21.2392 37.3374,21.6832 C33.7074,24.3632 28.4444,25.7882 23.9124,25.7882 C17.5594,25.7882 11.8384,23.4392 7.5104,19.5312 C7.1704,19.2232 7.4734,18.8042 7.8824,19.0432 Z M3.9994,32.5622 L43.8884,32.5622 L43.8884,11.0002 L3.9994,11.0002 L3.9994,32.5622 Z M2.9994,9.0002 C2.4474,9.0002 1.9994,9.4472 1.9994,10.0002 L1.9994,33.5622 C1.9994,34.1152 2.4474,34.5622 2.9994,34.5622 L22.9444,34.5622 L22.9444,37.7992 L17.8354,37.7992 L17.8354,39.7992 L30.0524,39.7992 L30.0524,37.7992 L24.9444,37.7992 L24.9444,34.5622 L44.8884,34.5622 C45.4414,34.5622 45.8884,34.1152 45.8884,33.5622 L45.8884,10.0002 C45.8884,9.4472 45.4414,9.0002 44.8884,9.0002 L2.9994,9.0002 Z" id="Amazon-IOT-RESOURCES-Fire-TV_Resource-Icon_light-bg" fill="#7AA116"></path>
    </g>
</svg>`, Hx = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/IoT/Res_AWS-IoT-Greengrass_Connector_48</title>
    <g id="Icon-Resource/IoT/Res_AWS-IoT-Greengrass_Connector_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M29.2267,30.4492 L29.2267,18.0002 L33.2177,18.0002 C36.6507,18.0002 39.4427,20.7932 39.4427,24.2252 C39.4427,27.6572 36.6507,30.4492 33.2177,30.4492 L29.2267,30.4492 Z M45.9997,23.2242 L41.3747,23.2242 C40.8787,19.1602 37.4127,16.0002 33.2177,16.0002 L28.2267,16.0002 C27.6737,16.0002 27.2267,16.4472 27.2267,17.0002 L27.2267,31.4492 C27.2267,32.0022 27.6737,32.4492 28.2267,32.4492 L33.2177,32.4492 C37.4137,32.4492 40.8797,29.2882 41.3757,25.2242 L45.9997,25.2242 L45.9997,23.2242 Z M18.7737,30.4492 L14.7817,30.4492 C11.3497,30.4492 8.5567,27.6572 8.5567,24.2242 C8.5567,20.7922 11.3497,18.0002 14.7817,18.0002 L18.7737,18.0002 L18.7737,30.4492 Z M20.7737,17.0002 C20.7737,16.4472 20.3257,16.0002 19.7737,16.0002 L14.7817,16.0002 C10.5857,16.0002 7.1197,19.1602 6.6237,23.2242 L1.9997,23.2242 L1.9997,25.2242 L6.6237,25.2242 C7.1197,29.2892 10.5857,32.4492 14.7817,32.4492 L19.7737,32.4492 C20.3257,32.4492 20.7737,32.0022 20.7737,31.4492 L20.7737,27.6132 L24.8557,27.6132 L24.8557,25.6132 L20.7737,25.6132 L20.7737,22.8372 L24.8557,22.8372 L24.8557,20.8372 L20.7737,20.8372 L20.7737,17.0002 Z" id="Amazon-AWS-IoT-Greengrass-Connector_Resource-Icon_light-bg" fill="#7AA116"></path>
    </g>
</svg>`, $x = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/IoT/Res_AWS-IoT-Greengrass_Interprocess-Communication_48</title>
    <g id="Icon-Resource/IoT/Res_AWS-IoT-Greengrass_Interprocess-Communication_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M40.6875,15.981 L42.1015,17.395 L37.7265,21.77 C37.5315,21.965 37.2755,22.063 37.0195,22.063 C36.7635,22.063 36.5075,21.965 36.3125,21.77 L31.9375,17.395 L33.3515,15.981 L36.0005,18.629 L36.0005,15.447 C36.0005,12.995 34.0045,11 31.5515,11 L25.9995,11 L25.9995,9 L31.5515,9 C35.1075,9 37.9995,11.892 37.9995,15.447 L37.9995,18.669 L40.6875,15.981 Z M32.7205,33.693 C32.3375,34.089 31.7055,34.103 31.3065,33.72 C31.1145,33.535 31.0055,33.286 30.9995,33.02 C30.9955,32.752 31.0935,32.499 31.2795,32.306 C31.4755,32.103 31.7375,32 31.9995,32 C32.2495,32 32.4995,32.092 32.6925,32.278 C32.6925,32.279 32.6925,32.279 32.6935,32.279 C32.8855,32.464 32.9945,32.713 33.0005,32.98 C33.0045,33.247 32.9065,33.5 32.7205,33.693 L32.7205,33.693 Z M29.8375,30.92 C29.2825,31.498 28.9855,32.257 29.0005,33.059 C29.0165,33.86 29.3435,34.607 29.9205,35.162 C30.5015,35.721 31.2505,35.998 31.9995,35.998 C32.7875,35.998 33.5745,35.69 34.1625,35.079 C34.7175,34.501 35.0145,33.742 34.9995,32.94 C34.9835,32.139 34.6565,31.392 34.0795,30.837 C32.8855,29.689 30.9835,29.729 29.8375,30.92 L29.8375,30.92 Z M38.2115,36.597 L36.0385,36.161 C35.7645,36.104 35.4775,36.168 35.2505,36.335 L34.1725,37.124 C33.9485,37.288 33.8025,37.538 33.7705,37.814 L33.5135,40.003 L30.2605,40.001 L30.0075,37.828 C29.9755,37.554 29.8325,37.305 29.6095,37.14 L28.5175,36.332 C28.2905,36.164 28.0025,36.099 27.7265,36.155 L25.5715,36.586 L24.5685,33.491 L26.5875,32.565 C26.8415,32.449 27.0355,32.231 27.1225,31.966 L27.5315,30.71 C27.6175,30.444 27.5885,30.154 27.4525,29.91 L26.3665,27.977 L28.9995,26.066 L30.4915,27.685 C30.6805,27.891 30.9475,28.007 31.2265,28.007 L31.2325,28.007 L32.5895,28 C32.8675,27.998 33.1305,27.881 33.3195,27.677 L34.8005,26.071 L37.4305,27.985 L36.3485,29.91 C36.2125,30.152 36.1835,30.439 36.2675,30.703 L36.6715,31.974 C36.7575,32.242 36.9525,32.461 37.2085,32.579 L39.2185,33.503 L38.2115,36.597 Z M40.8625,32.057 L38.4445,30.946 L38.3055,30.511 L39.6105,28.189 C39.8585,27.748 39.7365,27.189 39.3265,26.891 L35.2565,23.93 C34.8465,23.631 34.2785,23.687 33.9335,24.061 L32.1435,26.002 L31.6635,26.005 L29.8685,24.057 C29.5225,23.683 28.9555,23.628 28.5455,23.925 L24.4715,26.88 C24.0605,27.178 23.9385,27.737 24.1865,28.18 L25.4935,30.507 L25.3555,30.93 L22.9255,32.044 C22.4645,32.255 22.2355,32.779 22.3915,33.261 L23.9435,38.05 C24.0995,38.533 24.5895,38.821 25.0905,38.722 L27.6845,38.203 L28.0715,38.49 L28.3765,41.115 C28.4355,41.619 28.8625,41.999 29.3695,42 L34.4025,42.004 L34.4035,42.004 C34.9105,42.004 35.3375,41.625 35.3965,41.121 L35.7065,38.48 L36.0775,38.208 L38.6915,38.732 C39.1815,38.833 39.6815,38.544 39.8385,38.062 L41.3965,33.275 C41.5535,32.793 41.3245,32.269 40.8625,32.057 L40.8625,32.057 Z M16.4485,37 L22.0005,37 L22.0005,39 L16.4485,39 C12.8925,39 10.0005,36.107 10.0005,32.552 L10.0005,29.793 L7.3825,32.41 L5.9685,30.996 L10.3435,26.621 C10.7345,26.23 11.3675,26.23 11.7575,26.621 L16.1325,30.996 L14.7185,32.41 L12.0005,29.691 L12.0005,32.552 C12.0005,35.004 13.9955,37 16.4485,37 L16.4485,37 Z M44.0005,39.552 C44.0005,42.004 42.0045,44 39.5515,44 L8.4485,44 C5.9955,44 3.9995,42.004 3.9995,39.552 L3.9995,8.447 C3.9995,5.995 5.9955,4 8.4485,4 L39.5515,4 C42.0045,4 44.0005,5.995 44.0005,8.447 L44.0005,39.552 Z M39.5515,2 L8.4485,2 C4.8925,2 1.9995,4.892 1.9995,8.447 L1.9995,39.552 C1.9995,43.107 4.8925,46 8.4485,46 L39.5515,46 C43.1075,46 45.9995,43.107 45.9995,39.552 L45.9995,8.447 C45.9995,4.892 43.1075,2 39.5515,2 L39.5515,2 Z M15.2795,15.306 C15.4755,15.103 15.7375,15 16.0005,15 C16.2495,15 16.4995,15.092 16.6925,15.278 C16.6925,15.279 16.6925,15.279 16.6935,15.279 C16.8855,15.464 16.9945,15.713 17.0005,15.98 C17.0045,16.247 16.9065,16.5 16.7205,16.693 C16.3385,17.09 15.7065,17.103 15.3065,16.72 C15.1145,16.535 15.0055,16.286 15.0005,16.02 C14.9955,15.752 15.0935,15.499 15.2795,15.306 L15.2795,15.306 Z M15.9995,18.998 C16.7875,18.998 17.5745,18.69 18.1625,18.079 C18.7175,17.501 19.0145,16.742 18.9995,15.94 C18.9835,15.139 18.6565,14.392 18.0795,13.837 C16.8855,12.689 14.9835,12.728 13.8375,13.92 C13.2825,14.498 12.9855,15.257 13.0005,16.059 C13.0165,16.86 13.3435,17.607 13.9205,18.162 C14.5015,18.721 15.2505,18.998 15.9995,18.998 L15.9995,18.998 Z M10.9705,15.565 C11.2245,15.449 11.4175,15.232 11.5035,14.967 L11.9145,13.71 C12.0005,13.444 11.9725,13.154 11.8355,12.91 L10.7495,10.977 L13.3825,9.066 L14.8745,10.685 C15.0635,10.891 15.3305,11.007 15.6095,11.007 L15.6155,11.007 L16.9735,11 C17.2505,10.998 17.5145,10.881 17.7035,10.677 L19.1835,9.071 L21.8135,10.985 L20.7315,12.91 C20.5955,13.152 20.5665,13.439 20.6505,13.703 L21.0545,14.974 C21.1405,15.242 21.3345,15.462 21.5905,15.579 L23.6025,16.503 L22.5945,19.597 L20.4215,19.161 C20.1505,19.105 19.8615,19.168 19.6345,19.334 L18.5555,20.124 C18.3325,20.288 18.1855,20.538 18.1535,20.814 L17.8965,23.003 L14.6435,23.001 L14.3905,20.828 C14.3585,20.554 14.2145,20.305 13.9925,20.14 L12.9005,19.332 C12.6725,19.164 12.3865,19.099 12.1095,19.155 L9.9545,19.586 L8.9525,16.491 L10.9705,15.565 Z M8.3265,21.05 C8.4825,21.533 8.9735,21.819 9.4735,21.722 L12.0675,21.203 L12.4545,21.49 L12.7595,24.115 C12.8185,24.619 13.2455,24.999 13.7515,25 L18.7855,25.004 L18.7865,25.004 C19.2925,25.004 19.7205,24.625 19.7795,24.121 L20.0885,21.48 L20.4605,21.208 L23.0745,21.732 C23.5645,21.832 24.0635,21.543 24.2215,21.062 L25.7805,16.275 C25.9375,15.793 25.7085,15.269 25.2465,15.057 L22.8275,13.946 L22.6885,13.511 L23.9935,11.189 C24.2415,10.748 24.1195,10.189 23.7085,9.891 L19.6395,6.93 C19.2285,6.631 18.6615,6.688 18.3165,7.061 L16.5275,9.002 L16.0455,9.005 L14.2505,7.057 C13.9055,6.683 13.3385,6.628 12.9285,6.925 L8.8545,9.88 C8.4435,10.179 8.3215,10.737 8.5695,11.18 L9.8765,13.507 L9.7395,13.93 L7.3095,15.044 C6.8485,15.256 6.6195,15.779 6.7755,16.261 L8.3265,21.05 Z" id="Fill-1" fill="#7AA116"></path>
    </g>
</svg>`, Vx = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/IoT/Res_AWS-IoT_HTTP2-Protocol_48</title>
    <g id="Icon-Resource/IoT/Res_AWS-IoT_HTTP2-Protocol_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M12.7421,43.9609 L40.1971,43.9609 L43.9611,43.9609 L43.9611,40.1969 L43.9611,32.8489 L12.7421,32.8489 L12.7421,43.9609 Z M10.7421,30.8489 L45.9611,30.8489 L45.9611,40.1969 L45.9611,45.9609 L40.1971,45.9609 L10.7421,45.9609 L10.7421,30.8489 Z M7.7641,1.9999 C4.5861,1.9999 2.0001,4.5859 2.0001,7.7649 L2.0001,40.1969 C2.0001,43.3749 4.5861,45.9609 7.7641,45.9609 L9.1201,45.9609 L9.1201,43.9609 L7.7641,43.9609 C5.6881,43.9609 4.0001,42.2729 4.0001,40.1969 L4.0001,7.7649 C4.0001,5.6889 5.6881,3.9999 7.7641,3.9999 L40.1971,3.9999 C42.2721,3.9999 43.9611,5.6889 43.9611,7.7649 L43.9611,29.2259 L45.9611,29.2259 L45.9611,7.7649 C45.9611,4.5859 43.3751,1.9999 40.1971,1.9999 L7.7641,1.9999 Z M43.0491,41.4679 L40.1951,41.4679 C41.0061,40.4189 41.5801,39.6419 41.9151,39.1339 C42.2521,38.6269 42.4811,38.2019 42.6081,37.8589 C42.7341,37.5179 42.7971,37.1849 42.7971,36.8629 C42.7971,36.2549 42.6461,35.7809 42.3461,35.4409 C42.0461,35.1029 41.6251,34.9329 41.0871,34.9329 C40.7791,34.9329 40.4781,34.9869 40.1851,35.0959 C39.8911,35.2029 39.5871,35.3769 39.2721,35.6139 L39.2721,36.5069 C39.9361,36.0589 40.4851,35.8349 40.9201,35.8349 C41.4861,35.8349 41.7681,36.1979 41.7681,36.9259 C41.7681,37.2549 41.6881,37.6019 41.5271,37.9649 C41.3671,38.3279 41.1011,38.7849 40.7301,39.3329 C40.3601,39.8829 39.8211,40.6219 39.1141,41.5519 L39.1141,42.3389 L43.0491,42.3389 L43.0491,41.4679 Z M34.4781,43.8499 L35.4651,43.8499 L38.3071,34.4289 L37.3211,34.4289 L34.4781,43.8499 Z M33.1301,36.2489 C32.9451,36.0009 32.6871,35.8769 32.3591,35.8769 L31.3201,35.8769 L31.3201,38.7089 L32.3591,38.7089 C32.6871,38.7089 32.9451,38.5839 33.1301,38.3309 C33.3141,38.0799 33.4071,37.7329 33.4071,37.2929 C33.4071,36.8459 33.3141,36.4969 33.1301,36.2489 Z M34.4141,37.2929 C34.4141,37.9649 34.2341,38.5029 33.8751,38.9089 C33.5141,39.3149 33.0441,39.5169 32.4641,39.5169 L31.3201,39.5169 L31.3201,42.3389 L30.3341,42.3389 L30.3341,35.0689 L32.4641,35.0689 C32.8541,35.0689 33.1991,35.1629 33.4971,35.3519 C33.7941,35.5409 34.0211,35.8039 34.1791,36.1389 C34.3371,36.4749 34.4141,36.8589 34.4141,37.2929 Z M24.7641,35.9189 L26.5691,35.9189 L26.5691,42.3389 L27.5861,42.3389 L27.5861,35.9189 L29.4011,35.9189 L29.4011,35.0689 L24.7641,35.0689 L24.7641,35.9189 Z M19.5181,35.9189 L21.3231,35.9189 L21.3231,42.3389 L22.3411,42.3389 L22.3411,35.9189 L24.1551,35.9189 L24.1551,35.0689 L19.5181,35.0689 L19.5181,35.9189 Z M17.5681,35.0689 L18.5861,35.0689 L18.5861,42.3389 L17.5681,42.3389 L17.5681,39.0339 L14.9251,39.0339 L14.9251,42.3389 L13.9071,42.3389 L13.9071,35.0689 L14.9251,35.0689 L14.9251,38.2059 L17.5681,38.2059 L17.5681,35.0689 Z" id="Amazon-IOT-RESOURCES-IoT-HTTP/2-protocol_Resource-Icon_light-bg" fill="#7AA116"></path>
    </g>
</svg>`, Gx = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/IoT/Res_AWS-IoT_Fire-TV_Stick_48</title>
    <g id="Icon-Resource/IoT/Res_AWS-IoT_Fire-TV_Stick_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M31.744,25.1944 C31.492,25.4054 31.251,25.2934 31.363,25.0134 C31.733,24.0904 32.56,22.0254 32.167,21.5234 C31.776,21.0224 29.579,21.2864 28.593,21.4044 C28.294,21.4394 28.247,21.1784 28.517,20.9894 C30.27,19.7584 33.14,20.1144 33.474,20.5264 C33.81,20.9414 33.386,23.8204 31.744,25.1944 Z M19.574,26.4384 C14.217,26.4384 9.394,24.4584 5.745,21.1634 C5.458,20.9044 5.713,20.5504 6.058,20.7514 C9.995,23.0424 14.866,24.4224 19.895,24.4224 C23.287,24.4224 27.017,23.7184 30.449,22.2624 C30.966,22.0434 31.401,22.6034 30.894,22.9774 C27.832,25.2364 23.395,26.4384 19.574,26.4384 Z M40.698,28.8534 L43.941,28.8534 L43.941,18.6214 L40.698,18.6214 L40.698,28.8534 Z M38.698,30.9174 C38.698,31.2244 38.448,31.4744 38.14,31.4744 L4,31.4744 L4,16.0004 L38.14,16.0004 C38.448,16.0004 38.698,16.2504 38.698,16.5574 L38.698,17.6214 L38.698,29.8534 L38.698,30.9174 Z M40.698,16.6214 L40.698,16.5574 C40.698,15.1474 39.55,14.0004 38.14,14.0004 L3,14.0004 C2.448,14.0004 2,14.4474 2,15.0004 L2,32.4744 C2,33.0274 2.448,33.4744 3,33.4744 L38.14,33.4744 C39.55,33.4744 40.698,32.3274 40.698,30.9174 L40.698,30.8534 L44.941,30.8534 C45.494,30.8534 45.941,30.4064 45.941,29.8534 L45.941,17.6214 C45.941,17.0684 45.494,16.6214 44.941,16.6214 L40.698,16.6214 Z" id="Amazon-IOT-RESOURCES-Fire-TV-stick_Resource-Icon_light-bg" fill="#7AA116"></path>
    </g>
</svg>`, jx = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/IoT/Res_AWS-IoT-Core_Device-Advisor_48</title>
    <g id="Icon-Resource/IoT/Res_AWS-IoT-Core_Device-Advisor_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M24.0683481,40.7777 C22.0333481,40.7777 20.2113481,40.0237 19.3123481,38.8087 L20.9203481,37.6187 C21.3463481,38.1957 22.4863481,38.7777 24.0683481,38.7777 C25.6533481,38.7777 26.7923481,38.1947 27.2173481,37.6187 L28.8273481,38.8057 C27.9293481,40.0227 26.1053481,40.7777 24.0683481,40.7777 M30.0903481,41.7607 L31.7003481,42.9497 C30.2833481,44.8667 27.3593481,46.0577 24.0683481,46.0577 C20.7803481,46.0577 17.8563481,44.8677 16.4393481,42.9527 L18.0473481,41.7627 C19.0623481,43.1357 21.4823481,44.0577 24.0683481,44.0577 C26.6563481,44.0577 29.0763481,43.1347 30.0903481,41.7607 M24.0683481,20.6007 C26.1053481,20.6007 27.9283481,21.3557 28.8273481,22.5707 L27.2173481,23.7597 C26.7923481,23.1827 25.6523481,22.6007 24.0683481,22.6007 C22.4863481,22.6007 21.3463481,23.1827 20.9203481,23.7587 L19.3123481,22.5697 C20.2113481,21.3547 22.0333481,20.6007 24.0683481,20.6007 M24.0683481,17.3197 C21.4823481,17.3197 19.0623481,18.2427 18.0473481,19.6147 L16.4393481,18.4247 C17.8573481,16.5097 20.7803481,15.3197 24.0683481,15.3197 C27.3593481,15.3197 30.2833481,16.5107 31.7003481,18.4277 L30.0903481,19.6167 C29.0763481,18.2427 26.6563481,17.3197 24.0683481,17.3197 M4.06534813,22.5107 L2.06534813,22.5107 C2.06534813,17.1477 5.60434813,15.0917 7.78634813,14.3357 L7.75534813,13.7937 C7.75334813,9.2847 10.7243481,4.6677 14.6653481,2.9937 C19.2813481,1.0337 24.1693481,2.0077 27.7413481,5.6017 C28.7883481,6.6537 29.6563481,7.9187 30.3323481,9.3717 C31.7433481,8.3167 33.5893481,7.9817 35.3063481,8.5447 C37.5673481,9.2867 38.9883481,11.3427 39.1993481,14.1147 C42.6933481,14.9807 46.1423481,17.5857 46.1423481,22.5757 L44.1423481,22.5757 C44.1423481,17.5107 39.8773481,16.2297 38.0433481,15.9137 C37.5043481,15.8207 37.1383481,15.3117 37.2253481,14.7707 C37.2263481,12.5787 36.2983481,10.9757 34.6813481,10.4447 C33.2623481,9.9777 31.6903481,10.4937 30.7773481,11.7317 C30.5583481,12.0287 30.1943481,12.1797 29.8253481,12.1277 C29.4593481,12.0727 29.1523481,11.8197 29.0293481,11.4707 C28.4003481,9.6847 27.4893481,8.1847 26.3233481,7.0117 C24.8943481,5.5737 20.9763481,2.4857 15.4463481,4.8347 C12.2543481,6.1907 9.75334813,10.1007 9.75334813,13.7357 L9.82934813,15.0057 C9.85734813,15.4827 9.54334813,15.9137 9.07934813,16.0327 C7.20734813,16.5127 4.06534813,17.9937 4.06534813,22.5107 M39.6453481,36.5467 C37.7373481,36.5467 36.0013481,35.4087 35.2213481,33.6487 C35.0613481,33.2867 34.7033481,33.0527 34.3073481,33.0527 L13.8413481,33.0527 C13.4463481,33.0527 13.0883481,33.2867 12.9273481,33.6487 C12.1483481,35.4087 10.4123481,36.5467 8.50434813,36.5467 C6.91334813,36.5467 5.48234813,35.4107 4.60234813,34.0527 L8.06934813,34.0527 C8.62234813,34.0527 9.06934813,33.6057 9.06934813,33.0527 L9.06934813,28.0527 C9.06934813,27.5007 8.62234813,27.0527 8.06934813,27.0527 L4.66834813,27.0527 C5.55434813,25.6527 6.99034813,24.4777 8.56534813,24.4777 C10.5113481,24.4777 12.2003481,25.6137 12.9713481,27.4417 C13.1283481,27.8127 13.4903481,28.0527 13.8923481,28.0527 L34.3193481,28.0527 C34.7213481,28.0527 35.0853481,27.8117 35.2413481,27.4417 C36.0113481,25.6137 37.6993481,24.4777 39.6463481,24.4777 C41.2223481,24.4777 42.6573481,25.6527 43.5443481,27.0527 L40.0693481,27.0527 C39.5163481,27.0527 39.0693481,27.5007 39.0693481,28.0527 L39.0693481,33.0527 C39.0693481,33.6057 39.5163481,34.0527 40.0693481,34.0527 L43.5463481,34.0527 C42.6673481,35.4107 41.2363481,36.5467 39.6453481,36.5467 M45.9643481,32.4737 C45.7763481,32.2097 45.4723481,32.0527 45.1483481,32.0527 L41.0693481,32.0527 L41.0693481,29.0527 L45.1383481,29.0527 C45.4633481,29.0527 45.7673481,28.8957 45.9553481,28.6317 C46.1423481,28.3667 46.1893481,28.0277 46.0823481,27.7217 C45.1663481,25.1157 42.6613481,22.4777 39.6463481,22.4777 C37.1473481,22.4777 34.8773481,23.8607 33.6913481,26.0527 L14.5203481,26.0527 C13.3343481,23.8607 11.0633481,22.4777 8.56534813,22.4777 C5.55134813,22.4777 3.04734813,25.1157 2.12934813,27.7207 C2.02134813,28.0267 2.06834813,28.3657 2.25634813,28.6307 C2.44334813,28.8957 2.74834813,29.0527 3.07234813,29.0527 L7.06934813,29.0527 L7.06934813,32.0527 L3.00034813,32.0527 C2.67534813,32.0527 2.37234813,32.2097 2.18434813,32.4737 C1.99734813,32.7377 1.94934813,33.0767 2.05534813,33.3827 C2.95134813,35.9487 5.45434813,38.5467 8.50434813,38.5467 C10.9803481,38.5467 13.2513481,37.1947 14.4583481,35.0527 L33.6913481,35.0527 C34.8983481,37.1947 37.1693481,38.5467 39.6453481,38.5467 C42.6953481,38.5467 45.1973481,35.9487 46.0923481,33.3827 C46.1993481,33.0767 46.1513481,32.7377 45.9643481,32.4737" id="Fill-1" fill="#7AA116"></path>
    </g>
</svg>`, qx = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/IoT/Res_AWS-IoT_Thing_Industrial-PC_48</title>
    <g id="Icon-Resource/IoT/Res_AWS-IoT_Thing_Industrial-PC_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M17,29 L21,29 L21,27 L17,27 L17,29 Z M27,29 L33,29 L33,27 L27,27 L27,29 Z M27,26 L33,26 L33,24 L27,24 L27,26 Z M20,26 L23,26 L23,24 L20,24 L20,26 Z M15,26 L18,26 L18,24 L15,24 L15,26 Z M33,20 L33,17 L34.632,17 C34.831,17 35,17.168 35,17.368 L35,20 L33,20 Z M35,30.632 C35,30.832 34.831,31 34.632,31 L13.368,31 C13.169,31 13,30.832 13,30.632 L13,22 L35,22 L35,30.632 Z M13.368,17 L15,17 L15,20 L13,20 L13,17.368 C13,17.168 13.169,17 13.368,17 L13.368,17 Z M17,20 L19,20 L19,17 L17,17 L17,20 Z M21,20 L23,20 L23,17 L21,17 L21,20 Z M25,20 L27,20 L27,17 L25,17 L25,20 Z M29,20 L31,20 L31,17 L29,17 L29,20 Z M34.632,15 L13.368,15 C12.063,15 11,16.063 11,17.368 L11,30.632 C11,31.937 12.063,33 13.368,33 L34.632,33 C35.938,33 37,31.937 37,30.632 L37,22 L37,20 L37,17.368 C37,16.063 35.938,15 34.632,15 L34.632,15 Z M39,37.865 C39,38.491 38.491,39 37.865,39 L10.135,39 C9.509,39 9,38.491 9,37.865 L9,10.135 C9,9.509 9.509,9 10.135,9 L37.865,9 C38.491,9 39,9.509 39,10.135 L39,37.865 Z M46,15 L46,13 L41,13 L41,10.135 C41,8.406 39.594,7 37.865,7 L35,7 L35,2 L33,2 L33,7 L30,7 L30,2 L28,2 L28,7 L25,7 L25,2 L23,2 L23,7 L20,7 L20,2 L18,2 L18,7 L15,7 L15,2 L13,2 L13,7 L10.135,7 C8.406,7 7,8.406 7,10.135 L7,13 L2,13 L2,15 L7,15 L7,18 L2,18 L2,20 L7,20 L7,23 L2,23 L2,25 L7,25 L7,28 L2,28 L2,30 L7,30 L7,33 L2,33 L2,35 L7,35 L7,37.865 C7,39.594 8.406,41 10.135,41 L13,41 L13,46 L15,46 L15,41 L18,41 L18,46 L20,46 L20,41 L23,41 L23,46 L25,46 L25,41 L28,41 L28,46 L30,46 L30,41 L33,41 L33,46 L35,46 L35,41 L37.865,41 C39.594,41 41,39.594 41,37.865 L41,35 L46,35 L46,33 L41,33 L41,30 L46,30 L46,28 L41,28 L41,25 L46,25 L46,23 L41,23 L41,20 L46,20 L46,18 L41,18 L41,15 L46,15 Z" id="Fill-1" fill="#7AA116"></path>
    </g>
</svg>`, Kx = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/IoT/Res_AWS-IoT_Desired-State_48</title>
    <g id="Icon-Resource/IoT/Res_AWS-IoT_Desired-State_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M35.437,36.055 L38.676,36.055 L38.676,32.816 L35.437,32.816 L35.437,36.055 Z M40.676,37.056 C40.676,37.608 40.229,38.056 39.676,38.056 L34.437,38.056 C33.884,38.056 33.437,37.608 33.437,37.056 L33.437,31.816 C33.437,31.264 33.884,30.816 34.437,30.816 L39.676,30.816 C40.229,30.816 40.676,31.264 40.676,31.816 L40.676,37.056 Z M23.104,36.056 L24.811,36.056 L23.957,34.633 L23.104,36.056 Z M20.481,36.541 L23.1,32.175 C23.461,31.573 24.454,31.573 24.815,32.175 L27.435,36.541 C27.621,36.85 27.625,37.234 27.448,37.548 C27.27,37.862 26.938,38.056 26.578,38.056 L21.338,38.056 C20.978,38.056 20.646,37.862 20.468,37.549 C20.29,37.235 20.295,36.851 20.481,36.541 Z M10.86,36.056 C11.512,36.056 12.042,35.524 12.042,34.872 C12.042,34.22 11.512,33.689 10.86,33.689 C10.207,33.689 9.676,34.22 9.676,34.872 C9.676,35.524 10.207,36.056 10.86,36.056 Z M10.86,31.689 C12.615,31.689 14.042,33.117 14.042,34.872 C14.042,36.628 12.615,38.056 10.86,38.056 C9.104,38.056 7.676,36.628 7.676,34.872 C7.676,33.117 9.104,31.689 10.86,31.689 Z M32.817,39.549 L41.296,39.549 L41.296,15.352 L32.817,15.352 L32.817,39.549 Z M30.817,14.352 C30.817,13.799 31.264,13.351 31.817,13.351 L42.295,13.351 C42.848,13.351 43.295,13.799 43.295,14.352 L43.295,40.549 C43.295,41.102 42.848,41.549 42.295,41.549 L31.817,41.549 C31.264,41.549 30.817,41.102 30.817,40.549 L30.817,14.352 Z M19.719,39.549 L28.198,39.549 L28.198,10.112 L19.719,10.112 L19.719,39.549 Z M18.718,41.549 C18.165,41.549 17.718,41.102 17.718,40.549 L17.718,9.112 C17.718,8.56 18.165,8.112 18.718,8.112 L29.198,8.112 C29.75,8.112 30.198,8.56 30.198,9.112 L30.198,40.549 C30.198,41.102 29.75,41.549 29.198,41.549 L18.718,41.549 Z M6.62,39.549 L15.099,39.549 L15.099,22.338 L6.62,22.338 L6.62,39.549 Z M17.099,40.549 C17.099,41.102 16.652,41.549 16.099,41.549 L5.621,41.549 C5.068,41.549 4.621,41.102 4.621,40.549 L4.621,21.338 C4.621,20.785 5.068,20.338 5.621,20.338 L16.099,20.338 C16.652,20.338 17.099,20.785 17.099,21.338 L17.099,40.549 Z M23.236,45.914 L27.294,45.914 L27.294,43.914 L23.236,43.914 L23.236,45.914 Z M17.149,45.914 L21.208,45.914 L21.208,43.914 L17.149,43.914 L17.149,45.914 Z M29.323,45.914 L33.381,45.914 L33.381,43.914 L29.323,43.914 L29.323,45.914 Z M43.915,27.675 L45.915,27.675 L45.915,23.616 L43.915,23.616 L43.915,27.675 Z M43.915,21.588 L45.915,21.588 L45.915,17.53 L43.915,17.53 L43.915,21.588 Z M43.915,15.501 L45.915,15.501 L45.915,11.443 L43.915,11.443 L43.915,15.501 Z M43.22,6.06 C43.675,6.772 43.915,7.598 43.915,8.448 L43.915,9.414 L45.915,9.414 L45.915,8.448 C45.915,7.216 45.566,6.018 44.906,4.983 L43.22,6.06 Z M43.915,39.467 C43.915,39.571 43.912,39.675 43.904,39.778 L45.9,39.917 C45.91,39.768 45.915,39.618 45.915,39.467 L45.915,35.79 L43.915,35.79 L43.915,39.467 Z M41.884,45.445 C43.389,44.836 44.6,43.693 45.296,42.226 L43.49,41.369 C43.009,42.382 42.172,43.171 41.134,43.592 L41.884,45.445 Z M35.41,43.914 L35.41,45.914 L39.531,45.914 L39.467,43.914 L35.41,43.914 Z M43.915,33.761 L45.915,33.761 L45.915,29.703 L43.915,29.703 L43.915,33.761 Z M11.063,45.914 L15.121,45.914 L15.121,43.914 L11.063,43.914 L11.063,45.914 Z M6.069,2.454 C4.56,3.052 3.341,4.188 2.635,5.653 L4.438,6.52 C4.924,5.51 5.765,4.726 6.805,4.313 L6.069,2.454 Z M12.474,4 L12.474,2 L8.419,2.001 L8.418,2.151 L8.449,4 L12.474,4 Z M20.59,4 L24.648,4 L24.648,2 L20.59,2 L20.59,4 Z M4.613,44.649 C5.73,45.477 7.056,45.914 8.449,45.914 L9.034,45.914 L9.034,43.914 L8.449,43.914 C7.488,43.914 6.573,43.612 5.802,43.042 L4.613,44.649 Z M43.274,3.243 C42.163,2.43 40.846,2 39.467,2 L38.85,2 L38.85,4 L39.467,4 C40.418,4 41.327,4.296 42.092,4.856 L43.274,3.243 Z M4,8.448 C4,8.336 4.004,8.225 4.013,8.113 L2.019,7.957 C2.006,8.119 2,8.283 2,8.448 L2,12.092 L4,12.092 L4,8.448 Z M26.677,4 L30.735,4 L30.735,2 L26.677,2 L26.677,4 Z M32.763,4 L36.821,4 L36.821,2 L32.763,2 L32.763,4 Z M14.503,4 L18.561,4 L18.561,2 L14.503,2 L14.503,4 Z M2,24.266 L4,24.266 L4,20.208 L2,20.208 L2,24.266 Z M4,38.468 L2,38.468 L2,39.467 C2,40.685 2.342,41.873 2.99,42.899 L4.681,41.833 C4.236,41.126 4,40.308 4,39.467 L4,38.468 Z M2,30.353 L4,30.353 L4,26.295 L2,26.295 L2,30.353 Z M2,18.179 L4,18.179 L4,14.121 L2,14.121 L2,18.179 Z M2,36.439 L4,36.439 L4,32.38 L2,32.38 L2,36.439 Z" id="Amazon-IOT-RESOURCES-IoT-desired-state_Resource-Icon_light-bg" fill="#7AA116"></path>
    </g>
</svg>`, Yx = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/IoT/Res_AWS-IoT_Echo_48</title>
    <g id="Icon-Resource/IoT/Res_AWS-IoT_Echo_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M33.9437,26.4878 C31.7667,27.6348 28.1137,28.1718 24.4757,28.1718 C20.8327,28.1718 17.1757,27.6338 14.9987,26.4828 L14.9997,41.0268 C16.1437,42.4018 19.2157,43.9018 24.4757,43.9018 C29.7717,43.9018 32.8437,42.3898 33.9657,41.0098 L33.9437,26.4878 Z M14.9987,23.9138 C14.9997,24.5358 17.9137,26.1718 24.4757,26.1718 C30.8997,26.1718 33.8197,24.6068 33.9397,23.9568 L33.9377,22.5538 C31.7597,23.6998 28.1107,24.2358 24.4757,24.2358 C20.8317,24.2358 17.1757,23.6978 14.9987,22.5458 L14.9987,23.9138 Z M14.9987,19.9768 C14.9997,20.5988 17.9137,22.2358 24.4757,22.2358 C30.8267,22.2358 33.7517,20.7038 33.9337,20.0418 L33.9167,9.2578 C31.7637,10.4328 28.0977,10.9828 24.4447,10.9828 C20.8057,10.9828 17.1547,10.4378 14.9977,9.2728 L14.9987,19.9768 Z M24.4447,8.9828 C30.6587,8.9828 33.5677,7.4928 33.8177,6.8178 C33.7327,6.5808 33.5917,6.3608 33.3757,6.1458 C31.5837,4.3608 26.2657,3.9888 24.4087,3.9998 C16.8307,3.9998 15.3487,6.1138 15.0667,6.7948 C15.2587,7.4598 18.1607,8.9828 24.4447,8.9828 Z M35.9667,41.3588 C35.9667,41.6208 35.8637,41.8738 35.6797,42.0618 C34.2947,43.9438 30.6647,45.9018 24.4757,45.9018 C18.1487,45.9018 14.4887,43.8478 13.1747,41.9248 C13.0607,41.7588 12.9997,41.5618 12.9997,41.3608 L12.9997,6.9528 C13.0067,6.4338 13.3857,1.9998 24.4037,1.9998 C25.1537,2.0018 32.0807,2.0358 34.7857,4.7268 C35.5337,5.4718 35.9137,6.3498 35.9137,7.3378 L35.9337,19.9768 L35.9507,19.9768 C35.9507,20.0248 35.9377,20.0698 35.9337,20.1158 L35.9397,23.9138 L35.9507,23.9138 C35.9507,23.9458 35.9417,23.9738 35.9407,24.0048 L35.9667,41.3588 Z M19.1907,5.4138 C20.1307,5.4138 20.8927,5.7868 20.8927,6.2468 C20.8927,6.7068 20.1307,7.0798 19.1907,7.0798 C18.2497,7.0798 17.4877,6.7068 17.4877,6.2468 C17.4877,5.7868 18.2497,5.4138 19.1907,5.4138 Z" id="Amazon-IOT-RESOURCES-Echo_Resource-Icon_light-bg" fill="#7AA116"></path>
    </g>
</svg>`, Qx = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/IoT/Res_AWS-IoT-Greengrass_Recipe_48</title>
    <g id="Icon-Resource/IoT/Res_AWS-IoT-Greengrass_Recipe_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M38,13.106 L37.895,13 L28,13 C27.447,13 27,12.552 27,12 L27,4 L11.075,4 C11.034,4 11,4.034 11,4.075 L11,43.925 C11,43.966 11.034,44 11.075,44 L37.925,44 C37.966,44 38,43.966 38,43.925 L38,13.106 Z M29,4.082 L29,11 L35.899,11 L29,4.082 Z M40,12.692 L40,43.925 C40,45.069 39.069,46 37.925,46 L11.075,46 C9.931,46 9,45.069 9,43.925 L9,4.075 C9,2.931 9.931,2 11.075,2 L29.333,2 C29.599,2 29.854,2.106 30.041,2.294 L39.708,11.986 C39.895,12.174 40,12.428 40,12.692 L40,12.692 Z M23,37 L34,37 L34,35 L23,35 L23,37 Z M23,29 L34,29 L34,27 L23,27 L23,29 Z M15,37 L19,37 L19,35 L15,35 L15,37 Z M15,29 L19,29 L19,27 L15,27 L15,29 Z M15,21 L19,21 L19,19 L15,19 L15,21 Z M23,21 L34,21 L34,19 L23,19 L23,21 Z" id="Fill-1" fill="#7AA116"></path>
    </g>
</svg>`, Xx = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/IoT/Res_AWS-IoT-Greengrass_Component-Private_48</title>
    <g id="Icon-Resource/IoT/Res_AWS-IoT-Greengrass_Component-Private_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M4,24 C4,22.897 4.897,22 6,22 C7.103,22 8,22.897 8,24 C8,25.103 7.103,26 6,26 C4.897,26 4,25.103 4,24 L4,24 Z M24,4 C25.103,4 26,4.897 26,6 C26,7.103 25.103,8 24,8 C22.897,8 22,7.103 22,6 C22,4.897 22.897,4 24,4 L24,4 Z M10.961,35.532 C9.036,33.336 7.688,30.678 7.06,27.839 C8.749,27.372 10,25.836 10,24 C10,22.179 8.77,20.656 7.103,20.174 C8.604,13.762 13.757,8.646 20.206,7.205 C20.721,8.819 22.217,10 24,10 C25.78,10 27.274,8.823 27.792,7.213 C29.592,7.616 31.31,8.293 32.906,9.255 L33.937,7.542 C32.064,6.413 30.042,5.644 27.92,5.204 C27.55,3.379 25.934,2 24,2 C22.071,2 20.459,3.371 20.083,5.189 C12.612,6.728 6.647,12.679 5.071,20.12 C3.314,20.541 2,22.115 2,24 C2,25.866 3.29,27.426 5.022,27.865 C5.69,31.233 7.27,34.389 9.563,36.963 L7.016,36.924 L6.984,38.924 L11.908,39 L11.924,39 C12.184,39 12.434,38.899 12.62,38.718 C12.811,38.533 12.92,38.28 12.924,38.015 L13,33.015 L11,32.985 L10.961,35.532 Z M42,26 C40.897,26 40,25.103 40,24 C40,22.897 40.897,22 42,22 C43.103,22 44,22.897 44,24 C44,25.103 43.103,26 42,26 L42,26 Z M24,44 C22.897,44 22,43.103 22,42 C22,40.897 22.897,40 24,40 C25.103,40 26,40.897 26,42 C26,43.103 25.103,44 24,44 L24,44 Z M46,24 C46,22.096 44.66,20.503 42.874,20.103 C42.159,16.708 40.558,13.604 38.201,11.043 L41.016,11 L40.984,9 L35.984,9.076 C35.72,9.081 35.467,9.189 35.282,9.38 C35.098,9.57 34.996,9.826 35,10.092 L35.076,15.016 L37.076,14.984 L37.041,12.731 C38.914,14.876 40.209,17.423 40.848,20.189 C39.206,20.687 38,22.198 38,24 C38,25.82 39.229,27.342 40.896,27.825 C39.469,34.305 34.354,39.495 27.854,40.987 C27.402,39.273 25.854,38 24,38 C22.144,38 20.594,39.276 20.145,40.993 C18.329,40.583 16.599,39.904 14.999,38.933 L13.962,40.643 C15.878,41.807 17.963,42.601 20.154,43.041 C20.616,44.74 22.156,46 24,46 C25.847,46 27.39,44.736 27.848,43.033 C35.437,41.483 41.427,35.432 42.931,27.879 C44.688,27.457 46,25.884 46,24 L46,24 Z M24,30 C23.448,30 23,29.551 23,29 C23,28.449 23.448,28 24,28 C24.552,28 25,28.449 25,29 C25,29.551 24.552,30 24,30 L24,30 Z M25,26.184 L25,24 L23,24 L23,26.184 C21.839,26.599 21,27.698 21,29 C21,30.654 22.346,32 24,32 C25.654,32 27,30.654 27,29 C27,27.698 26.161,26.599 25,26.184 L25,26.184 Z M31,31.933 C31,32.521 30.521,33 29.934,33 L18.066,33 C17.479,33 17,32.521 17,31.933 L17,24.067 C17,23.479 17.479,23 18.066,23 L29.934,23 C30.521,23 31,23.479 31,24.067 L31,31.933 Z M21.631,14 L26.369,14 C27.819,14 29,15.18 29,16.631 L29,21 L19,21 L19,16.631 C19,15.18 20.181,14 21.631,14 L21.631,14 Z M26.369,12 L21.631,12 C19.077,12 17,14.077 17,16.631 L17,21.202 C15.836,21.638 15,22.752 15,24.067 L15,31.933 C15,33.624 16.376,35 18.066,35 L29.934,35 C31.624,35 33,33.624 33,31.933 L33,24.067 C33,22.752 32.164,21.638 31,21.202 L31,16.631 C31,14.077 28.923,12 26.369,12 L26.369,12 Z" id="Fill-1" fill="#7AA116"></path>
    </g>
</svg>`, Jx = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/IoT/Res_AWS-IoT-Greengrass_Stream-Manager_48</title>
    <g id="Icon-Resource/IoT/Res_AWS-IoT-Greengrass_Stream-Manager_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M13,38 L31,38 L31,36 L13,36 L13,38 Z M2,25 L21,25 L21,23 L2,23 L2,25 Z M2,14 L15,14 L15,12 L2,12 L2,14 Z M7,29 L17,29 L17,27 L7,27 L7,29 Z M41,26 L44,26 L44,23 L41,23 L41,26 Z M45,21 L40,21 C39.447,21 39,21.448 39,22 L39,27 C39,27.552 39.447,28 40,28 L45,28 C45.553,28 46,27.552 46,27 L46,22 C46,21.448 45.553,21 45,21 L45,21 Z M20,15 L26,15 L26,9 L20,9 L20,15 Z M19,17 L27,17 C27.553,17 28,16.552 28,16 L28,8 C28,7.448 27.553,7 27,7 L19,7 C18.447,7 18,7.448 18,8 L18,16 C18,16.552 18.447,17 19,17 L19,17 Z M35,39 L39,39 L39,35 L35,35 L35,39 Z M40,33 L34,33 C33.447,33 33,33.448 33,34 L33,40 C33,40.552 33.447,41 34,41 L40,41 C40.553,41 41,40.552 41,40 L41,34 C41,33.448 40.553,33 40,33 L40,33 Z M36,16 L39,16 L39,13 L36,13 L36,16 Z M35,18 L40,18 C40.553,18 41,17.552 41,17 L41,12 C41,11.448 40.553,11 40,11 L35,11 C34.447,11 34,11.448 34,12 L34,17 C34,17.552 34.447,18 35,18 L35,18 Z M26,29 L33,29 L33,22 L26,22 L26,29 Z M24,21 L24,30 C24,30.552 24.447,31 25,31 L34,31 C34.553,31 35,30.552 35,30 L35,21 C35,20.448 34.553,20 34,20 L25,20 C24.447,20 24,20.448 24,21 L24,21 Z" id="Fill-1" fill="#7AA116"></path>
    </g>
</svg>`, e_ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/IoT/Res_AWS-IoT_Thing_Medical-Emergency_48</title>
    <g id="Icon-Resource/IoT/Res_AWS-IoT_Thing_Medical-Emergency_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M18.8544,23.2578 L22.2584,23.2578 C22.8114,23.2578 23.2584,22.8108 23.2584,22.2578 L23.2584,18.8548 L24.7814,18.8548 L24.7814,22.2578 C24.7814,22.8108 25.2284,23.2578 25.7814,23.2578 L29.1854,23.2578 L29.1854,24.7808 L25.7814,24.7808 C25.2284,24.7808 24.7814,25.2288 24.7814,25.7808 L24.7814,29.1848 L23.2584,29.1848 L23.2584,25.7808 C23.2584,25.2288 22.8114,24.7808 22.2584,24.7808 L18.8544,24.7808 L18.8544,23.2578 Z M21.2584,26.7808 L21.2584,30.1848 C21.2584,30.7368 21.7064,31.1848 22.2584,31.1848 L25.7814,31.1848 C26.3334,31.1848 26.7814,30.7368 26.7814,30.1848 L26.7814,26.7808 L30.1854,26.7808 C30.7384,26.7808 31.1854,26.3338 31.1854,25.7808 L31.1854,22.2578 C31.1854,21.7048 30.7384,21.2578 30.1854,21.2578 L26.7814,21.2578 L26.7814,17.8548 C26.7814,17.3018 26.3334,16.8548 25.7814,16.8548 L22.2584,16.8548 C21.7064,16.8548 21.2584,17.3018 21.2584,17.8548 L21.2584,21.2578 L17.8544,21.2578 C17.3014,21.2578 16.8544,21.7048 16.8544,22.2578 L16.8544,25.7808 C16.8544,26.3338 17.3014,26.7808 17.8544,26.7808 L21.2584,26.7808 Z M15.3314,32.7078 L32.7084,32.7078 L32.7084,15.3308 L15.3314,15.3308 L15.3314,32.7078 Z M14.3314,13.3308 C13.7784,13.3308 13.3314,13.7788 13.3314,14.3308 L13.3314,33.7078 C13.3314,34.2608 13.7784,34.7078 14.3314,34.7078 L33.7084,34.7078 C34.2604,34.7078 34.7084,34.2608 34.7084,33.7078 L34.7084,14.3308 C34.7084,13.7788 34.2604,13.3308 33.7084,13.3308 L14.3314,13.3308 Z M39.7524,38.6188 C39.7524,39.2448 39.2444,39.7538 38.6184,39.7538 L9.4214,39.7538 C8.7954,39.7538 8.2874,39.2448 8.2874,38.6188 L8.2874,9.4348 C8.2874,8.8088 8.7954,8.2998 9.4214,8.2998 L38.6184,8.2998 C39.2444,8.2998 39.7524,8.8088 39.7524,9.4348 L39.7524,38.6188 Z M46.0394,14.4498 L46.0394,12.4498 L41.7524,12.4498 L41.7524,9.4348 C41.7524,7.7058 40.3464,6.2998 38.6184,6.2998 L35.5884,6.2998 L35.5884,1.9998 L33.5884,1.9998 L33.5884,6.2998 L30.3044,6.2998 L30.3044,1.9998 L28.3044,1.9998 L28.3044,6.2998 L25.0194,6.2998 L25.0194,1.9998 L23.0194,1.9998 L23.0194,6.2998 L19.7354,6.2998 L19.7354,1.9998 L17.7354,1.9998 L17.7354,6.2998 L14.4504,6.2998 L14.4504,1.9998 L12.4504,1.9998 L12.4504,6.2998 L9.4214,6.2998 C7.6934,6.2998 6.2874,7.7058 6.2874,9.4348 L6.2874,12.4498 L2.0004,12.4498 L2.0004,14.4498 L6.2874,14.4498 L6.2874,17.7348 L2.0004,17.7348 L2.0004,19.7348 L6.2874,19.7348 L6.2874,23.0198 L2.0004,23.0198 L2.0004,25.0198 L6.2874,25.0198 L6.2874,28.3038 L2.0004,28.3038 L2.0004,30.3038 L6.2874,30.3038 L6.2874,33.5888 L2.0004,33.5888 L2.0004,35.5888 L6.2874,35.5888 L6.2874,38.6188 C6.2874,40.3478 7.6934,41.7538 9.4214,41.7538 L12.4504,41.7538 L12.4504,46.0388 L14.4504,46.0388 L14.4504,41.7538 L17.7354,41.7538 L17.7354,46.0388 L19.7354,46.0388 L19.7354,41.7538 L23.0194,41.7538 L23.0194,46.0388 L25.0194,46.0388 L25.0194,41.7538 L28.3044,41.7538 L28.3044,46.0388 L30.3044,46.0388 L30.3044,41.7538 L33.5884,41.7538 L33.5884,46.0388 L35.5884,46.0388 L35.5884,41.7538 L38.6184,41.7538 C40.3464,41.7538 41.7524,40.3478 41.7524,38.6188 L41.7524,35.5888 L46.0394,35.5888 L46.0394,33.5888 L41.7524,33.5888 L41.7524,30.3038 L46.0394,30.3038 L46.0394,28.3038 L41.7524,28.3038 L41.7524,25.0198 L46.0394,25.0198 L46.0394,23.0198 L41.7524,23.0198 L41.7524,19.7348 L46.0394,19.7348 L46.0394,17.7348 L41.7524,17.7348 L41.7524,14.4498 L46.0394,14.4498 Z" id="Amazon-IOT-RESOURCES-IoT-thing-medical-emergency_Resource-Icon_light-bg" fill="#7AA116"></path>
    </g>
</svg>`, t_ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/IoT/Res_AWS-IoT_Thing_Thermostat_48</title>
    <g id="Icon-Resource/IoT/Res_AWS-IoT_Thing_Thermostat_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M22.8038,31.0451 C22.8038,30.3831 23.3418,29.8451 24.0038,29.8451 C24.6658,29.8451 25.2038,30.3831 25.2038,31.0451 C25.2038,31.7071 24.6658,32.2451 24.0038,32.2451 C23.3418,32.2451 22.8038,31.7071 22.8038,31.0451 Z M25.0038,16.9631 L23.0038,16.9631 L23.0038,17.7231 L21.3628,17.7231 L21.3628,19.7231 L23.0038,19.7231 L23.0038,21.2441 L21.3628,21.2441 L21.3628,23.2441 L23.0038,23.2441 L23.0038,24.7651 L21.3628,24.7651 L21.3628,26.7651 L23.0038,26.7651 L23.0038,28.0201 C21.7308,28.4431 20.8038,29.6321 20.8038,31.0451 C20.8038,32.8091 22.2388,34.2451 24.0038,34.2451 C25.7688,34.2451 27.2038,32.8091 27.2038,31.0451 C27.2038,29.6321 26.2768,28.4431 25.0038,28.0201 L25.0038,16.9631 Z M12.2408,24.0041 C12.2408,22.6151 12.4958,21.2871 12.9408,20.0491 L15.3038,21.1221 L16.1318,19.3021 L13.7688,18.2281 C14.9608,16.1241 16.7838,14.4291 18.9788,13.3861 L19.8858,15.8131 L21.7588,15.1121 L20.8518,12.6831 C21.8568,12.4031 22.9098,12.2421 24.0038,12.2421 C25.3938,12.2421 26.7208,12.4971 27.9588,12.9411 L26.8858,15.3041 L28.7058,16.1321 L29.7788,13.7691 C31.8838,14.9621 33.5788,16.7841 34.6218,18.9781 L32.1938,19.8861 L32.8958,21.7591 L35.3238,20.8511 C35.6048,21.8561 35.7658,22.9101 35.7658,24.0041 C35.7658,30.4891 30.4888,35.7661 24.0038,35.7661 C17.5178,35.7661 12.2408,30.4891 12.2408,24.0041 Z M10.2408,24.0041 C10.2408,31.5921 16.4148,37.7661 24.0038,37.7661 C31.5918,37.7661 37.7658,31.5921 37.7658,24.0041 C37.7658,16.4161 31.5918,10.2421 24.0038,10.2421 C16.4148,10.2421 10.2408,16.4161 10.2408,24.0041 Z M39.7268,38.8521 C39.7268,39.3351 39.3298,39.7261 38.8428,39.7261 L9.1638,39.7261 C8.6778,39.7261 8.2808,39.3351 8.2808,38.8521 L8.2808,9.1741 C8.2808,8.6911 8.6778,8.2991 9.1638,8.2991 L38.8428,8.2991 C39.3298,8.2991 39.7268,8.6911 39.7268,9.1741 L39.7268,38.8521 Z M46.0078,14.4421 L46.0078,12.4421 L41.7268,12.4421 L41.7268,9.1741 C41.7268,7.5891 40.4328,6.2991 38.8428,6.2991 L35.5658,6.2991 L35.5658,2.0001 L33.5658,2.0001 L33.5658,6.2991 L30.2848,6.2991 L30.2848,2.0001 L28.2848,2.0001 L28.2848,6.2991 L25.0038,6.2991 L25.0038,2.0001 L23.0038,2.0001 L23.0038,6.2991 L19.7228,6.2991 L19.7228,2.0001 L17.7228,2.0001 L17.7228,6.2991 L14.4418,6.2991 L14.4418,2.0001 L12.4418,2.0001 L12.4418,6.2991 L9.1638,6.2991 C7.5738,6.2991 6.2808,7.5891 6.2808,9.1741 L6.2808,12.4421 L1.9998,12.4421 L1.9998,14.4421 L6.2808,14.4421 L6.2808,17.7231 L1.9998,17.7231 L1.9998,19.7231 L6.2808,19.7231 L6.2808,23.0041 L1.9998,23.0041 L1.9998,25.0041 L6.2808,25.0041 L6.2808,28.2851 L1.9998,28.2851 L1.9998,30.2851 L6.2808,30.2851 L6.2808,33.5651 L1.9998,33.5651 L1.9998,35.5651 L6.2808,35.5651 L6.2808,38.8521 C6.2808,40.4371 7.5738,41.7261 9.1638,41.7261 L12.4418,41.7261 L12.4418,46.0081 L14.4418,46.0081 L14.4418,41.7261 L17.7228,41.7261 L17.7228,46.0081 L19.7228,46.0081 L19.7228,41.7261 L23.0038,41.7261 L23.0038,46.0081 L25.0038,46.0081 L25.0038,41.7261 L28.2848,41.7261 L28.2848,46.0081 L30.2848,46.0081 L30.2848,41.7261 L33.5658,41.7261 L33.5658,46.0081 L35.5658,46.0081 L35.5658,41.7261 L38.8428,41.7261 C40.4328,41.7261 41.7268,40.4371 41.7268,38.8521 L41.7268,35.5651 L46.0078,35.5651 L46.0078,33.5651 L41.7268,33.5651 L41.7268,30.2851 L46.0078,30.2851 L46.0078,28.2851 L41.7268,28.2851 L41.7268,25.0041 L46.0078,25.0041 L46.0078,23.0041 L41.7268,23.0041 L41.7268,19.7231 L46.0078,19.7231 L46.0078,17.7231 L41.7268,17.7231 L41.7268,14.4421 L46.0078,14.4421 Z" id="Amazon-IOT-RESOURCES-IoT-thing-thermostat_Resource-Icon_light-bg" fill="#7AA116"></path>
    </g>
</svg>`, n_ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/IoT/Res_AWS-IoT-SiteWise_Asset-Model_48</title>
    <g id="Icon-Resource/IoT/Res_AWS-IoT-SiteWise_Asset-Model_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M38,26 C36.897,26 36,25.103 36,24 C36,22.897 36.897,22 38,22 C39.103,22 40,22.897 40,24 C40,25.103 39.103,26 38,26 L38,26 Z M38,20 C35.794,20 34,21.794 34,24 C34,26.206 35.794,28 38,28 C40.206,28 42,26.206 42,24 C42,21.794 40.206,20 38,20 L38,20 Z M29,29 L25,29 L23,29 L19,29 L19,25 L19,23 L19,19 L23,19 L25,19 L29,19 L29,23 L29,25 L29,29 Z M31,23 L31,17 L25,17 L25,14 L24,14 L23,14 L23,17 L17,17 L17,23 L14,23 L14,24 L14,25 L17,25 L17,31 L23,31 L23,34 L24,34 L25,34 L25,31 L31,31 L31,25 L34,25 L34,24 L34,23 L31,23 Z M10,26 C8.897,26 8,25.103 8,24 C8,22.897 8.897,22 10,22 C11.103,22 12,22.897 12,24 C12,25.103 11.103,26 10,26 L10,26 Z M10,20 C7.794,20 6,21.794 6,24 C6,26.206 7.794,28 10,28 C12.206,28 14,26.206 14,24 C14,21.794 12.206,20 10,20 L10,20 Z M24,36 C25.103,36 26,36.897 26,38 C26,39.103 25.103,40 24,40 C22.897,40 22,39.103 22,38 C22,36.897 22.897,36 24,36 L24,36 Z M20,38 C20,40.206 21.794,42 24,42 C26.206,42 28,40.206 28,38 C28,35.794 26.206,34 24,34 C21.794,34 20,35.794 20,38 L20,38 Z M24,12 C22.897,12 22,11.103 22,10 C22,8.897 22.897,8 24,8 C25.103,8 26,8.897 26,10 C26,11.103 25.103,12 24,12 L24,12 Z M28,10 C28,7.794 26.206,6 24,6 C21.794,6 20,7.794 20,10 C20,12.206 21.794,14 24,14 C26.206,14 28,12.206 28,10 L28,10 Z M24,43.5 C13.248,43.5 4.5,34.752 4.5,24 C4.5,13.248 13.248,4.5 24,4.5 C34.752,4.5 43.5,13.248 43.5,24 C43.5,34.752 34.752,43.5 24,43.5 L24,43.5 Z M24,2.5 C12.145,2.5 2.5,12.145 2.5,24 C2.5,35.855 12.145,45.5 24,45.5 C35.855,45.5 45.5,35.855 45.5,24 C45.5,12.145 35.855,2.5 24,2.5 L24,2.5 Z" id="Fill-1" fill="#7AA116"></path>
    </g>
</svg>`, i_ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/IoT/Res_AWS-IoT_Thing_Stacklight_48</title>
    <g id="Icon-Resource/IoT/Res_AWS-IoT_Thing_Stacklight_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M39,37.865 C39,38.49 38.491,39 37.865,39 L10.135,39 C9.509,39 9,38.49 9,37.865 L9,10.135 C9,9.509 9.509,9 10.135,9 L37.865,9 C38.491,9 39,9.509 39,10.135 L39,37.865 Z M46,15 L46,13 L41,13 L41,10.135 C41,8.406 39.594,7 37.865,7 L35,7 L35,2 L33,2 L33,7 L30,7 L30,2 L28,2 L28,7 L25,7 L25,2 L23,2 L23,7 L20,7 L20,2 L18,2 L18,7 L15,7 L15,2 L13,2 L13,7 L10.135,7 C8.406,7 7,8.406 7,10.135 L7,13 L2,13 L2,15 L7,15 L7,18 L2,18 L2,20 L7,20 L7,23 L2,23 L2,25 L7,25 L7,28 L2,28 L2,30 L7,30 L7,33 L2,33 L2,35 L7,35 L7,37.865 C7,39.594 8.406,41 10.135,41 L13,41 L13,46 L15,46 L15,41 L18,41 L18,46 L20,46 L20,41 L23,41 L23,46 L25,46 L25,41 L28,41 L28,46 L30,46 L30,41 L33,41 L33,46 L35,46 L35,41 L37.865,41 C39.594,41 41,39.594 41,37.865 L41,35 L46,35 L46,33 L41,33 L41,30 L46,30 L46,28 L41,28 L41,25 L46,25 L46,23 L41,23 L41,20 L46,20 L46,18 L41,18 L41,15 L46,15 Z M11.992,22 L15.992,22 L15.992,20 L11.992,20 L11.992,22 Z M16.285,24.293 L17.699,25.707 L15.699,27.707 L14.285,26.293 L16.285,24.293 Z M15.699,14.293 L17.699,16.293 L16.285,17.707 L14.285,15.707 L15.699,14.293 Z M31.992,22 L35.992,22 L35.992,20 L31.992,20 L31.992,22 Z M31.699,24.293 L33.699,26.293 L32.285,27.707 L30.285,25.707 L31.699,24.293 Z M31.699,17.707 L30.285,16.293 L32.285,14.293 L33.699,15.707 L31.699,17.707 Z M20.992,29 L26.992,29 L26.992,25 L20.992,25 L20.992,29 Z M20.992,23 L26.992,23 L26.992,19 L20.992,19 L20.992,23 Z M20.992,17 L26.992,17 L26.992,13 L20.992,13 L20.992,17 Z M27.992,11 L19.992,11 C19.439,11 18.992,11.448 18.992,12 L18.992,30 C18.992,30.552 19.439,31 19.992,31 L22.992,31 L22.992,35 L18.992,35 L18.992,37 L28.992,37 L28.992,35 L24.992,35 L24.992,31 L27.992,31 C28.545,31 28.992,30.552 28.992,30 L28.992,12 C28.992,11.448 28.545,11 27.992,11 L27.992,11 Z" id="Fill-1" fill="#7AA116"></path>
    </g>
</svg>`, s_ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/IoT/Res_AWS-IoT_Thing_Temperature-Humidity-Sensor_48</title>
    <g id="Icon-Resource/IoT/Res_AWS-IoT_Thing_Temperature-Humidity-Sensor_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M14.4365,20.378 C13.6485,20.378 13.0065,19.736 13.0065,18.948 C13.0065,18.316 13.8405,16.731 14.4365,15.659 C15.0335,16.732 15.8675,18.316 15.8675,18.948 C15.8675,19.736 15.2255,20.378 14.4365,20.378 L14.4365,20.378 Z M15.3315,13.154 C15.1615,12.816 14.8155,12.602 14.4365,12.602 C14.0575,12.602 13.7105,12.816 13.5415,13.155 C13.4365,13.365 13.2595,13.676 13.0495,14.047 C11.9725,15.944 11.0065,17.747 11.0065,18.948 C11.0065,20.839 12.5445,22.378 14.4365,22.378 C16.3285,22.378 17.8675,20.839 17.8675,18.948 C17.8675,17.745 16.8995,15.941 15.8215,14.042 C15.6125,13.673 15.4355,13.364 15.3315,13.154 L15.3315,13.154 Z M29.9995,27 L33.9995,27 L33.9995,25 L29.9995,25 L29.9995,27 Z M29.9995,23 L34.9995,23 L34.9995,21 L29.9995,21 L29.9995,23 Z M29.9995,19 L33.9995,19 L33.9995,17 L29.9995,17 L29.9995,19 Z M29.9995,15 L34.9995,15 L34.9995,13 L29.9995,13 L29.9995,15 Z M23.9995,32.977 C23.4485,32.977 22.9995,32.528 22.9995,31.977 C22.9995,31.426 23.4485,30.977 23.9995,30.977 C24.5515,30.977 24.9995,31.426 24.9995,31.977 C24.9995,32.528 24.5515,32.977 23.9995,32.977 L23.9995,32.977 Z M24.9995,29.161 L24.9995,18 L22.9995,18 L22.9995,29.161 C21.8385,29.576 20.9995,30.675 20.9995,31.977 C20.9995,33.631 22.3455,34.977 23.9995,34.977 C25.6545,34.977 26.9995,33.631 26.9995,31.977 C26.9995,30.675 26.1615,29.576 24.9995,29.161 L24.9995,29.161 Z M26.5225,35.081 C25.5695,35.857 24.3645,36.142 23.1315,35.887 C21.5875,35.566 20.3565,34.298 20.0695,32.732 C19.7905,31.205 20.3635,29.734 21.6025,28.797 L21.9995,28.497 L21.9995,14 C21.9995,12.897 22.8975,12 23.9995,12 C25.1025,12 25.9995,12.897 25.9995,14 L25.9995,28.498 L26.3975,28.797 C27.4155,29.567 27.9995,30.726 27.9995,31.977 C27.9995,33.186 27.4615,34.317 26.5225,35.081 L26.5225,35.081 Z M27.9995,27.528 L27.9995,14 C27.9995,11.794 26.2065,10 23.9995,10 C21.7935,10 19.9995,11.794 19.9995,14 L19.9995,27.529 C18.4445,28.923 17.7205,31.01 18.1025,33.092 C18.5355,35.451 20.3925,37.361 22.7255,37.845 C23.1475,37.933 23.5715,37.976 23.9915,37.976 C25.3705,37.976 26.7065,37.511 27.7855,36.632 C29.1925,35.487 29.9995,33.79 29.9995,31.977 C29.9995,30.264 29.2775,28.669 27.9995,27.528 L27.9995,27.528 Z M38.9995,37.865 C38.9995,38.49 38.4915,39 37.8655,39 L10.1345,39 C9.5085,39 8.9995,38.49 8.9995,37.865 L8.9995,10.134 C8.9995,9.509 9.5085,9 10.1345,9 L37.8655,9 C38.4915,9 38.9995,9.509 38.9995,10.134 L38.9995,37.865 Z M45.9995,15 L45.9995,13 L40.9995,13 L40.9995,10.134 C40.9995,8.406 39.5935,7 37.8655,7 L34.9995,7 L34.9995,2 L32.9995,2 L32.9995,7 L29.9995,7 L29.9995,2 L27.9995,2 L27.9995,7 L24.9995,7 L24.9995,2 L22.9995,2 L22.9995,7 L19.9995,7 L19.9995,2 L17.9995,2 L17.9995,7 L14.9995,7 L14.9995,2 L12.9995,2 L12.9995,7 L10.1345,7 C8.4065,7 6.9995,8.406 6.9995,10.134 L6.9995,13 L1.9995,13 L1.9995,15 L6.9995,15 L6.9995,18 L1.9995,18 L1.9995,20 L6.9995,20 L6.9995,23 L1.9995,23 L1.9995,25 L6.9995,25 L6.9995,28 L1.9995,28 L1.9995,30 L6.9995,30 L6.9995,33 L1.9995,33 L1.9995,35 L6.9995,35 L6.9995,37.865 C6.9995,39.593 8.4065,41 10.1345,41 L12.9995,41 L12.9995,46 L14.9995,46 L14.9995,41 L17.9995,41 L17.9995,46 L19.9995,46 L19.9995,41 L22.9995,41 L22.9995,46 L24.9995,46 L24.9995,41 L27.9995,41 L27.9995,46 L29.9995,46 L29.9995,41 L32.9995,41 L32.9995,46 L34.9995,46 L34.9995,41 L37.8655,41 C39.5935,41 40.9995,39.593 40.9995,37.865 L40.9995,35 L45.9995,35 L45.9995,33 L40.9995,33 L40.9995,30 L45.9995,30 L45.9995,28 L40.9995,28 L40.9995,25 L45.9995,25 L45.9995,23 L40.9995,23 L40.9995,20 L45.9995,20 L45.9995,18 L40.9995,18 L40.9995,15 L45.9995,15 Z" id="Fill-1" fill="#7AA116"></path>
    </g>
</svg>`, r_ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/IoT/Res_AWS-IoT-Greengrass_Component-Public_48</title>
    <g id="Icon-Resource/IoT/Res_AWS-IoT-Greengrass_Component-Public_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M4,24 C4,22.897 4.897,22 6,22 C7.103,22 8,22.897 8,24 C8,25.103 7.103,26 6,26 C4.897,26 4,25.103 4,24 L4,24 Z M24,4 C25.103,4 26,4.897 26,6 C26,7.103 25.103,8 24,8 C22.897,8 22,7.103 22,6 C22,4.897 22.897,4 24,4 L24,4 Z M10.961,35.532 C9.036,33.336 7.688,30.678 7.06,27.839 C8.749,27.372 10,25.836 10,24 C10,22.179 8.77,20.656 7.103,20.174 C8.604,13.762 13.757,8.646 20.206,7.205 C20.721,8.819 22.217,10 24,10 C25.78,10 27.274,8.823 27.792,7.213 C29.592,7.616 31.31,8.293 32.906,9.255 L33.937,7.542 C32.064,6.413 30.042,5.644 27.92,5.204 C27.55,3.379 25.934,2 24,2 C22.071,2 20.459,3.371 20.083,5.189 C12.612,6.728 6.647,12.679 5.071,20.12 C3.314,20.541 2,22.115 2,24 C2,25.866 3.29,27.426 5.022,27.865 C5.69,31.233 7.27,34.389 9.563,36.963 L7.016,36.924 L6.984,38.924 L11.908,39 L11.924,39 C12.184,39 12.434,38.899 12.62,38.718 C12.811,38.533 12.92,38.28 12.924,38.015 L13,33.015 L11,32.985 L10.961,35.532 Z M42,26 C40.897,26 40,25.103 40,24 C40,22.897 40.897,22 42,22 C43.103,22 44,22.897 44,24 C44,25.103 43.103,26 42,26 L42,26 Z M24,44 C22.897,44 22,43.103 22,42 C22,40.897 22.897,40 24,40 C25.103,40 26,40.897 26,42 C26,43.103 25.103,44 24,44 L24,44 Z M46,24 C46,22.096 44.66,20.503 42.874,20.103 C42.159,16.708 40.558,13.604 38.201,11.043 L41.016,11 L40.984,9 L35.984,9.076 C35.72,9.081 35.467,9.189 35.282,9.38 C35.098,9.57 34.996,9.826 35,10.092 L35.076,15.016 L37.076,14.984 L37.041,12.731 C38.914,14.876 40.209,17.423 40.848,20.189 C39.206,20.687 38,22.198 38,24 C38,25.82 39.229,27.342 40.896,27.825 C39.469,34.305 34.354,39.495 27.854,40.987 C27.402,39.273 25.854,38 24,38 C22.144,38 20.594,39.276 20.145,40.993 C18.329,40.583 16.599,39.904 14.999,38.933 L13.962,40.643 C15.878,41.807 17.963,42.601 20.154,43.041 C20.616,44.74 22.156,46 24,46 C25.847,46 27.39,44.736 27.848,43.033 C35.437,41.483 41.427,35.432 42.931,27.879 C44.688,27.457 46,25.884 46,24 L46,24 Z M24,28 C24.552,28 25,28.449 25,29 C25,29.551 24.552,30 24,30 C23.448,30 23,29.551 23,29 C23,28.449 23.448,28 24,28 L24,28 Z M24,32 C25.654,32 27,30.654 27,29 C27,27.698 26.161,26.599 25,26.184 L25,24 L23,24 L23,26.184 C21.839,26.599 21,27.698 21,29 C21,30.654 22.346,32 24,32 L24,32 Z M31,24.067 L31,31.933 C31,32.521 30.521,33 29.934,33 L18.066,33 C17.479,33 17,32.521 17,31.933 L17,24.067 C17,23.479 17.479,23 18.066,23 L29.934,23 C30.521,23 31,23.479 31,24.067 L31,24.067 Z M21.631,14 L26.032,14 C27.198,14 28.11,14.457 28.474,15.223 L30.28,14.366 C29.578,12.885 27.99,12 26.032,12 L21.631,12 C19.077,12 17,14.077 17,16.631 L17,21.202 C15.836,21.638 15,22.752 15,24.067 L15,31.933 C15,33.624 16.376,35 18.066,35 L29.934,35 C31.624,35 33,33.624 33,31.933 L33,24.067 C33,22.376 31.624,21 29.934,21 L19,21 L19,16.631 C19,15.18 20.181,14 21.631,14 L21.631,14 Z" id="Fill-1" fill="#7AA116"></path>
    </g>
</svg>`, o_ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/IoT/Res_AWS-IoT_Sailboat_48</title>
    <g id="Icon-Resource/IoT/Res_AWS-IoT_Sailboat_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M21.841,26.881 C20.512,25.552 18.728,24.82 16.817,24.82 L16.817,26.82 C18.194,26.82 19.476,27.344 20.427,28.295 C21.378,29.246 21.902,30.528 21.902,31.906 L23.902,31.906 C23.902,29.994 23.17,28.21 21.841,26.881 L21.841,26.881 Z M16.791,16.271 L16.783,18.271 C24.304,18.298 30.422,24.415 30.422,31.906 L32.422,31.906 C32.422,23.316 25.41,16.302 16.791,16.271 L16.791,16.271 Z M16.787,7.751 L16.787,9.751 C29.003,9.751 38.942,19.69 38.942,31.906 L40.942,31.906 C40.942,18.587 30.106,7.751 16.787,7.751 L16.787,7.751 Z M17,42 L31,42 L31,40 L17,40 L17,42 Z M6,32 L8,32 L8,16 L6,16 L6,32 Z M7,38 C5.346,38 4,39.345 4,41 C4,42.654 5.346,44 7,44 C8.654,44 10,42.654 10,41 C10,39.345 8.654,38 7,38 L7,38 Z M7,46 C4.243,46 2,43.756 2,41 C2,38.243 4.243,36 7,36 C9.757,36 12,38.243 12,41 C12,43.756 9.757,46 7,46 L7,46 Z M7,4 C5.346,4 4,5.345 4,7 C4,8.654 5.346,10 7,10 C8.654,10 10,8.654 10,7 C10,5.345 8.654,4 7,4 L7,4 Z M7,12 C4.243,12 2,9.756 2,7 C2,4.243 4.243,2 7,2 C9.757,2 12,4.243 12,7 C12,9.756 9.757,12 7,12 L7,12 Z M41,38 C39.346,38 38,39.345 38,41 C38,42.654 39.346,44 41,44 C42.654,44 44,42.654 44,41 C44,39.345 42.654,38 41,38 L41,38 Z M41,46 C38.243,46 36,43.756 36,41 C36,38.243 38.243,36 41,36 C43.757,36 46,38.243 46,41 C46,43.756 43.757,46 41,46 L41,46 Z" id="Fill-1" fill="#7AA116"></path>
    </g>
</svg>`, l_ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/IoT/Res_AWS-IoT-Rule_48</title>
    <g id="Icon-Resource/IoT/Res_AWS-IoT-Rule_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M33.0811,9.1075 C31.6731,9.1075 30.5271,7.9615 30.5271,6.5535 C30.5271,5.1455 31.6731,4.0005 33.0811,4.0005 C34.4891,4.0005 35.6351,5.1455 35.6351,6.5535 C35.6351,7.9615 34.4891,9.1075 33.0811,9.1075 L33.0811,9.1075 Z M13.0001,8.1835 L17.1191,8.1835 L17.1191,4.0635 L13.0001,4.0635 L13.0001,8.1835 Z M33.0811,2.0005 C30.5701,2.0005 28.5271,4.0435 28.5271,6.5535 C28.5271,7.3635 28.7581,8.1135 29.1301,8.7735 L24.2491,12.0825 L19.1191,8.6055 L19.1191,3.0635 C19.1191,2.5105 18.6721,2.0635 18.1191,2.0635 L12.0001,2.0635 C11.4471,2.0635 11.0001,2.5105 11.0001,3.0635 L11.0001,9.1835 C11.0001,9.7365 11.4471,10.1835 12.0001,10.1835 L17.8841,10.1835 L23.3251,13.8715 L23.3251,16.2745 L25.3251,16.2745 L25.3251,13.7685 L30.4761,10.2785 C31.2161,10.7965 32.1111,11.1075 33.0811,11.1075 C35.5921,11.1075 37.6351,9.0645 37.6351,6.5535 C37.6351,4.0435 35.5921,2.0005 33.0811,2.0005 L33.0811,2.0005 Z M24.3411,44.2595 C18.3111,44.2595 14.9351,42.7435 14.8201,42.1005 L14.8211,26.3645 C17.0381,27.5125 20.7721,28.0565 24.3411,28.0565 C27.9091,28.0565 31.6441,27.5125 33.8611,26.3645 L33.8611,42.0965 C33.7451,42.7435 30.3661,44.2595 24.3411,44.2595 L24.3411,44.2595 Z M35.8441,23.8815 C35.8351,23.7365 35.8231,23.5875 35.7841,23.4605 C35.4921,22.4295 34.4361,21.6155 32.5561,20.9695 L31.9071,22.8625 C33.2341,23.3175 33.7151,23.7555 33.8321,23.9475 C33.5301,24.6285 30.2001,26.0565 24.3411,26.0565 C18.4741,26.0565 15.1471,24.6285 14.8501,23.9495 C14.9631,23.7595 15.4411,23.3195 16.7741,22.8625 L16.1261,20.9695 C14.2451,21.6155 13.1891,22.4295 12.8971,23.4585 C12.8581,23.5945 12.8471,23.7405 12.8381,23.8815 L12.8201,23.8815 C12.8201,23.9045 12.8281,23.9235 12.8291,23.9455 C12.8281,23.9645 12.8201,23.9855 12.8201,24.0045 L12.8201,42.1005 C12.8201,44.9585 18.7921,46.2595 24.3411,46.2595 C29.8901,46.2595 35.8611,44.9585 35.8611,42.1005 L35.8611,24.0045 C35.8611,23.9845 35.8531,23.9655 35.8521,23.9455 C35.8531,23.9235 35.8611,23.9045 35.8611,23.8815 L35.8441,23.8815 Z M24.3411,22.1335 L20.9551,18.9635 L27.7271,18.9635 L24.3411,22.1335 Z M31.3971,24.2145 L31.3971,17.9635 C31.3971,17.4115 30.9501,16.9635 30.3971,16.9635 L18.2531,16.9635 C17.7001,16.9635 17.2531,17.4115 17.2531,17.9635 L17.2531,24.2145 L19.2531,24.2145 L19.2531,20.1115 L23.6571,24.2335 C23.8501,24.4145 24.0951,24.5035 24.3411,24.5035 C24.5861,24.5035 24.8321,24.4145 25.0241,24.2345 L29.3971,20.1405 L29.3971,24.2145 L31.3971,24.2145 Z" id="Amazon-IOT-RESOURCES-IoT-IoT-Rule_Resource-Icon_light-bg" fill="#7AA116"></path>
    </g>
</svg>`, L_ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/IoT/Res_AWS-IoT_Thing_Bicycle_48</title>
    <g id="Icon-Resource/IoT/Res_AWS-IoT_Thing_Bicycle_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M27.6063,29.2417 C27.6063,27.8777 28.2593,26.6757 29.2573,25.8927 L30.9683,29.6557 L32.7883,28.8267 L31.0713,25.0507 C31.3333,24.9997 31.6023,24.9687 31.8783,24.9687 C34.2333,24.9687 36.1503,26.8857 36.1503,29.2417 C36.1503,31.5967 34.2333,33.5137 31.8783,33.5137 C29.5233,33.5137 27.6063,31.5967 27.6063,29.2417 Z M27.6273,22.3067 L28.4063,24.0217 C27.4513,24.6587 26.6853,25.5527 26.1953,26.6017 L27.6273,22.3067 Z M24.4503,25.5137 L20.1263,20.5757 L26.0973,20.5757 L24.4503,25.5137 Z M16.0613,33.5137 C13.7053,33.5137 11.7883,31.5967 11.7883,29.2417 C11.7883,26.9537 13.5993,25.0957 15.8593,24.9897 L15.0783,29.0517 L17.0433,29.4307 L17.8253,25.3617 C19.3003,26.0357 20.3333,27.5167 20.3333,29.2417 C20.3333,31.5967 18.4163,33.5137 16.0613,33.5137 Z M30.2293,23.1967 L28.5403,19.4817 L28.9333,17.9397 L29.8243,17.9397 L29.8243,15.9397 L26.2953,15.9397 L26.2953,17.9397 L26.8693,17.9397 L26.7073,18.5757 L18.7213,18.5757 L18.1993,16.1857 L20.4563,16.1817 L20.4523,14.1817 L17.3823,14.1867 C17.2853,14.1867 17.1893,14.2017 17.0963,14.2297 C16.6803,14.3547 16.3423,14.6527 16.1703,15.0457 C16.0313,15.3617 15.9363,15.8757 16.2353,16.5687 L16.8983,19.5977 L16.2473,22.9787 C16.1853,22.9767 16.1233,22.9687 16.0613,22.9687 C12.6023,22.9687 9.7883,25.7827 9.7883,29.2417 C9.7883,32.7007 12.6023,35.5137 16.0613,35.5137 C19.5203,35.5137 22.3333,32.7007 22.3333,29.2417 C22.3333,26.5387 20.6123,24.2377 18.2113,23.3567 L18.5173,21.7727 L24.0963,28.1437 C24.3313,28.4127 24.6953,28.5327 25.0453,28.4647 C25.3693,28.3997 25.6313,28.1747 25.7603,27.8747 C25.6613,28.3157 25.6063,28.7717 25.6063,29.2417 C25.6063,32.7007 28.4193,35.5137 31.8783,35.5137 C35.3373,35.5137 38.1503,32.7007 38.1503,29.2417 C38.1503,25.7827 35.3373,22.9687 31.8783,22.9687 C31.3063,22.9687 30.7553,23.0527 30.2293,23.1967 Z M39.6643,38.5307 C39.6643,39.1567 39.1553,39.6647 38.5293,39.6647 L9.4093,39.6647 C8.7833,39.6647 8.2743,39.1567 8.2743,38.5307 L8.2743,9.4227 C8.2743,8.7967 8.7833,8.2877 9.4093,8.2877 L38.5293,8.2877 C39.1553,8.2877 39.6643,8.7967 39.6643,9.4227 L39.6643,38.5307 Z M45.9393,14.4237 L45.9393,12.4237 L41.6643,12.4237 L41.6643,9.4227 C41.6643,7.6947 40.2583,6.2877 38.5293,6.2877 L35.5153,6.2877 L35.5153,1.9997 L33.5153,1.9997 L33.5153,6.2877 L30.2423,6.2877 L30.2423,1.9997 L28.2423,1.9997 L28.2423,6.2877 L24.9693,6.2877 L24.9693,1.9997 L22.9693,1.9997 L22.9693,6.2877 L19.6963,6.2877 L19.6963,1.9997 L17.6963,1.9997 L17.6963,6.2877 L14.4243,6.2877 L14.4243,1.9997 L12.4243,1.9997 L12.4243,6.2877 L9.4093,6.2877 C7.6813,6.2877 6.2743,7.6947 6.2743,9.4227 L6.2743,12.4237 L2.0003,12.4237 L2.0003,14.4237 L6.2743,14.4237 L6.2743,17.6967 L2.0003,17.6967 L2.0003,19.6967 L6.2743,19.6967 L6.2743,22.9687 L2.0003,22.9687 L2.0003,24.9687 L6.2743,24.9687 L6.2743,28.2417 L2.0003,28.2417 L2.0003,30.2417 L6.2743,30.2417 L6.2743,33.5137 L2.0003,33.5137 L2.0003,35.5137 L6.2743,35.5137 L6.2743,38.5307 C6.2743,40.2587 7.6813,41.6647 9.4093,41.6647 L12.4243,41.6647 L12.4243,45.9377 L14.4243,45.9377 L14.4243,41.6647 L17.6963,41.6647 L17.6963,45.9377 L19.6963,45.9377 L19.6963,41.6647 L22.9693,41.6647 L22.9693,45.9377 L24.9693,45.9377 L24.9693,41.6647 L28.2423,41.6647 L28.2423,45.9377 L30.2423,45.9377 L30.2423,41.6647 L33.5153,41.6647 L33.5153,45.9377 L35.5153,45.9377 L35.5153,41.6647 L38.5293,41.6647 C40.2583,41.6647 41.6643,40.2587 41.6643,38.5307 L41.6643,35.5137 L45.9393,35.5137 L45.9393,33.5137 L41.6643,33.5137 L41.6643,30.2417 L45.9393,30.2417 L45.9393,28.2417 L41.6643,28.2417 L41.6643,24.9687 L45.9393,24.9687 L45.9393,22.9687 L41.6643,22.9687 L41.6643,19.6967 L45.9393,19.6967 L45.9393,17.6967 L41.6643,17.6967 L41.6643,14.4237 L45.9393,14.4237 Z" id="Amazon-IOT-RESOURCES-IoT-thing-bicycle_Resource-Icon_light-bg" fill="#7AA116"></path>
    </g>
</svg>`, a_ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/IoT/Res_AWS-IoT_Reported-State_48</title>
    <g id="Icon-Resource/IoT/Res_AWS-IoT_Reported-State_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M23.9921,34.6826 L24.8501,36.1126 L23.1341,36.1126 L23.9921,34.6826 Z M26.6161,38.1126 C26.9761,38.1126 27.3081,37.9186 27.4861,37.6056 C27.6641,37.2916 27.6591,36.9076 27.4731,36.5976 L24.8491,32.2236 C24.4881,31.6216 23.4961,31.6216 23.1351,32.2236 L20.5111,36.5976 C20.3251,36.9076 20.3201,37.2916 20.4981,37.6056 C20.6761,37.9186 21.0081,38.1126 21.3681,38.1126 L26.6161,38.1126 Z M12.0581,34.9246 C12.0581,35.5796 11.5261,36.1126 10.8721,36.1126 C10.2181,36.1126 9.6851,35.5796 9.6851,34.9246 C9.6851,34.2706 10.2181,33.7386 10.8721,33.7386 C11.5261,33.7386 12.0581,34.2706 12.0581,34.9246 Z M14.0581,34.9246 C14.0581,33.1676 12.6291,31.7386 10.8721,31.7386 C9.1151,31.7386 7.6851,33.1676 7.6851,34.9246 C7.6851,36.6826 9.1151,38.1126 10.8721,38.1126 C12.6291,38.1126 14.0581,36.6826 14.0581,34.9246 Z M19.7441,39.6106 L28.2401,39.6106 L28.2401,10.1226 L19.7441,10.1226 L19.7441,39.6106 Z M18.7441,8.1216 C18.1911,8.1216 17.7441,8.5696 17.7441,9.1216 L17.7441,40.6106 C17.7441,41.1626 18.1911,41.6106 18.7441,41.6106 L29.2401,41.6106 C29.7931,41.6106 30.2401,41.1626 30.2401,40.6106 L30.2401,9.1216 C30.2401,8.5696 29.7931,8.1216 29.2401,8.1216 L18.7441,8.1216 Z M6.6241,39.6106 L15.1201,39.6106 L15.1201,22.3686 L6.6241,22.3686 L6.6241,39.6106 Z M5.6241,20.3686 C5.0711,20.3686 4.6241,20.8156 4.6241,21.3686 L4.6241,40.6106 C4.6241,41.1626 5.0711,41.6106 5.6241,41.6106 L16.1201,41.6106 C16.6731,41.6106 17.1201,41.1626 17.1201,40.6106 L17.1201,21.3686 C17.1201,20.8156 16.6731,20.3686 16.1201,20.3686 L5.6241,20.3686 Z M43.9841,39.5366 C43.9841,41.9896 41.9891,43.9846 39.5361,43.9846 L8.4481,43.9846 C5.9951,43.9846 4.0001,41.9896 4.0001,39.5366 L4.0001,8.4476 C4.0001,5.9956 5.9951,3.9996 8.4481,3.9996 L39.5361,3.9996 C41.9891,3.9996 43.9841,5.9956 43.9841,8.4476 L43.9841,39.5366 Z M8.4481,1.9996 C4.8921,1.9996 2.0001,4.8926 2.0001,8.4476 L2.0001,39.5366 C2.0001,43.0916 4.8921,45.9846 8.4481,45.9846 L39.5361,45.9846 C43.0921,45.9846 45.9841,43.0916 45.9841,39.5366 L45.9841,8.4476 C45.9841,4.8926 43.0921,1.9996 39.5361,1.9996 L8.4481,1.9996 Z" id="Amazon-IOT-RESOURCES-IoT-reported-state_Resource-Icon_light-bg" fill="#7AA116"></path>
    </g>
</svg>`, C_ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/IoT/Res_AWS-IoT_Simulator_48</title>
    <g id="Icon-Resource/IoT/Res_AWS-IoT_Simulator_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M26.3232,18.8043 C26.3232,18.5153 26.0882,18.2793 25.7992,18.2793 C25.5102,18.2793 25.2762,18.5153 25.2762,18.8043 C25.2762,19.0933 25.5102,19.3273 25.7992,19.3273 C26.0882,19.3273 26.3232,19.0933 26.3232,18.8043 Z M21.7682,14.4373 C21.7682,14.7263 22.0022,14.9613 22.2912,14.9613 C22.5802,14.9613 22.8152,14.7263 22.8152,14.4373 C22.8152,14.1483 22.5802,13.9143 22.2912,13.9143 C22.0022,13.9143 21.7682,14.1483 21.7682,14.4373 Z M18.5092,11.1573 L18.5092,17.8043 L23.4842,17.8043 C23.8722,16.9083 24.7632,16.2793 25.7992,16.2793 C27.1912,16.2793 28.3232,17.4123 28.3232,18.8043 C28.3232,20.1953 27.1912,21.3273 25.7992,21.3273 C24.7632,21.3273 23.8722,20.6983 23.4842,19.8043 L18.5092,19.8043 L18.5092,22.2163 L29.5692,22.2163 L29.5692,15.4373 L24.6062,15.4373 C24.2172,16.3333 23.3272,16.9613 22.2912,16.9613 C20.9002,16.9613 19.7682,15.8293 19.7682,14.4373 C19.7682,13.0463 20.9002,11.9143 22.2912,11.9143 C23.3272,11.9143 24.2172,12.5423 24.6062,13.4373 L29.5692,13.4373 L29.5692,11.1573 L18.5092,11.1573 Z M30.5692,9.1573 C31.1212,9.1573 31.5692,9.6043 31.5692,10.1573 L31.5692,23.2163 C31.5692,23.7683 31.1212,24.2163 30.5692,24.2163 L17.5092,24.2163 C16.9562,24.2163 16.5092,23.7683 16.5092,23.2163 L16.5092,10.1573 C16.5092,9.6043 16.9562,9.1573 17.5092,9.1573 L30.5692,9.1573 Z M20.4682,34.4613 C20.4682,34.9893 20.8992,35.4203 21.4272,35.4203 C21.9552,35.4203 22.3862,34.9893 22.3862,34.4613 C22.3862,33.9323 21.9552,33.5023 21.4272,33.5023 C20.8992,33.5023 20.4682,33.9323 20.4682,34.4613 Z M27.6102,40.5563 C27.6102,40.0273 27.1792,39.5973 26.6512,39.5973 C26.1222,39.5973 25.6922,40.0273 25.6922,40.5563 C25.6922,41.0843 26.1222,41.5143 26.6512,41.5143 C27.1792,41.5143 27.6102,41.0843 27.6102,40.5563 Z M30.4392,43.9083 L30.4392,35.4993 L24.1882,35.4993 C23.7662,36.6183 22.6922,37.4203 21.4272,37.4203 C19.7952,37.4203 18.4682,36.0933 18.4682,34.4613 C18.4682,32.8293 19.7952,31.5023 21.4272,31.5023 C22.7202,31.5023 23.8102,32.3413 24.2112,33.4993 L30.4392,33.4993 L30.4392,31.1083 L17.6392,31.1083 L17.6392,39.5173 L23.8892,39.5173 C24.3122,38.3983 25.3852,37.5973 26.6512,37.5973 C28.2822,37.5973 29.6102,38.9243 29.6102,40.5563 C29.6102,42.1863 28.2822,43.5143 26.6512,43.5143 C25.3572,43.5143 24.2672,42.6753 23.8652,41.5173 L17.6392,41.5173 L17.6392,43.9083 L30.4392,43.9083 Z M32.4392,44.9083 C32.4392,45.4613 31.9912,45.9083 31.4392,45.9083 L16.6392,45.9083 C16.0862,45.9083 15.6392,45.4613 15.6392,44.9083 L15.6392,30.1083 C15.6392,29.5563 16.0862,29.1083 16.6392,29.1083 L31.4392,29.1083 C31.9912,29.1083 32.4392,29.5563 32.4392,30.1083 L32.4392,44.9083 Z M36.8562,27.6233 L12.8242,27.5993 C8.6952,27.5993 5.2672,24.4953 5.0202,20.5333 C5.0092,20.3313 5.0002,20.1303 5.0002,19.9313 C5.0002,16.4843 6.8582,13.8523 10.0162,12.7453 C10.0092,12.5993 10.0062,12.4553 10.0062,12.3133 C10.0062,8.4003 12.6582,4.3403 16.1752,2.8673 C20.2762,1.1533 24.6242,2.0113 27.8072,5.1603 C28.3582,5.7013 28.8492,6.3093 29.2632,6.9653 L27.5732,8.0333 C27.2402,7.5083 26.8472,7.0203 26.4032,6.5853 C25.1572,5.3513 21.7492,2.7033 16.9462,4.7133 C14.1762,5.8723 12.0062,9.2113 12.0062,12.3133 C12.0062,12.6663 12.0302,13.0193 12.0692,13.3563 C12.1262,13.8543 11.8062,14.3183 11.3202,14.4403 C9.7062,14.8473 7.0002,16.0993 7.0002,19.9313 C7.0002,20.0973 7.0092,20.2633 7.0172,20.4203 C7.1972,23.3193 9.7492,25.5993 12.8252,25.5993 L36.7772,25.6263 C36.9062,25.6103 41.9482,25.1113 41.9482,19.9923 C41.9482,15.6923 38.3332,14.6023 36.7782,14.3343 C36.2632,14.2453 35.9052,13.7733 35.9532,13.2563 C35.7452,10.6653 34.3362,9.5993 33.0762,9.4683 L33.2832,7.4793 C35.1522,7.6743 37.3972,9.1203 37.8842,12.5263 C40.9432,13.3033 43.9482,15.6033 43.9482,19.9923 C43.9482,25.5773 39.3092,27.4263 36.8562,27.6233 Z" id="Amazon-IOT-RESOURCES-IoT-simulator_Resource-Icon_light-bg" fill="#7AA116"></path>
    </g>
</svg>`, c_ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/IoT/Res_AWS-IoT_Thing_Police-Emergency_48</title>
    <g id="Icon-Resource/IoT/Res_AWS-IoT_Thing_Police-Emergency_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M23.9929,34.2149 C23.0979,33.6349 21.3109,32.6249 19.2339,32.2519 C17.9239,32.0169 14.8759,31.1899 14.8759,28.6049 C14.8759,27.4659 15.3049,26.7269 15.8019,25.8699 C16.2929,25.0229 16.8499,24.0639 16.8499,22.7539 C16.8499,21.1179 16.0889,19.8679 15.4889,19.1389 C16.0019,18.5139 16.7619,17.5839 17.3369,16.8599 C18.3549,17.6509 19.4949,18.0769 20.6329,18.0769 C21.9229,18.0769 23.0119,17.6349 23.9929,16.6979 C24.9749,17.6349 26.0629,18.0769 27.3539,18.0769 C28.4909,18.0769 29.6319,17.6509 30.6479,16.8599 C31.2249,17.5839 31.9829,18.5139 32.4959,19.1389 C31.8969,19.8679 31.1359,21.1179 31.1359,22.7539 C31.1359,24.0639 31.6919,25.0229 32.1839,25.8699 C32.6809,26.7269 33.1099,27.4659 33.1099,28.6049 C33.1099,31.1899 30.0619,32.0169 28.7509,32.2519 C26.6759,32.6249 24.8889,33.6349 23.9929,34.2149 Z M35.2459,19.3309 L34.6039,18.5519 C34.5779,18.5229 32.1349,15.5609 31.5819,14.8039 L30.8699,13.8259 L30.0439,14.7099 C29.2199,15.5919 28.2639,16.0769 27.3539,16.0769 C26.6469,16.0769 25.7909,15.8999 24.7869,14.5889 L23.9929,13.5509 L23.1989,14.5889 C22.1949,15.8999 21.3389,16.0769 20.6329,16.0769 C19.7219,16.0769 18.7659,15.5919 17.9409,14.7099 L17.1149,13.8249 L16.4019,14.8039 C15.8519,15.5609 13.4069,18.5219 13.3819,18.5519 L12.7519,19.3249 L13.5199,19.9619 C13.5329,19.9739 14.8499,21.0849 14.8499,22.7539 C14.8499,23.5259 14.5069,24.1169 14.0719,24.8659 C13.5389,25.7839 12.8759,26.9269 12.8759,28.6049 C12.8759,31.4459 15.1209,33.5459 18.8809,34.2209 C21.3109,34.6559 23.3639,36.2089 23.3849,36.2249 L23.9939,36.6879 L24.6019,36.2249 C24.6219,36.2089 26.6759,34.6559 29.1049,34.2209 C32.8649,33.5459 35.1099,31.4459 35.1099,28.6049 C35.1099,26.9269 34.4459,25.7839 33.9129,24.8659 C33.4789,24.1169 33.1359,23.5259 33.1359,22.7539 C33.1359,21.0849 34.4519,19.9739 34.4609,19.9659 L35.2459,19.3309 Z M39.7059,38.5739 C39.7059,39.1999 39.1969,39.7089 38.5709,39.7089 L9.4139,39.7089 C8.7879,39.7089 8.2789,39.1999 8.2789,38.5739 L8.2789,9.4289 C8.2789,8.8029 8.7879,8.2939 9.4139,8.2939 L38.5709,8.2939 C39.1969,8.2939 39.7059,8.8029 39.7059,9.4289 L39.7059,38.5739 Z M45.9859,14.4369 L45.9859,12.4369 L41.7059,12.4369 L41.7059,9.4289 C41.7059,7.6999 40.2999,6.2939 38.5709,6.2939 L35.5499,6.2939 L35.5499,1.9999 L33.5499,1.9999 L33.5499,6.2939 L30.2719,6.2939 L30.2719,1.9999 L28.2719,1.9999 L28.2719,6.2939 L24.9929,6.2939 L24.9929,1.9999 L22.9929,1.9999 L22.9929,6.2939 L19.7149,6.2939 L19.7149,1.9999 L17.7149,1.9999 L17.7149,6.2939 L14.4369,6.2939 L14.4369,1.9999 L12.4369,1.9999 L12.4369,6.2939 L9.4139,6.2939 C7.6859,6.2939 6.2789,7.6999 6.2789,9.4289 L6.2789,12.4369 L1.9999,12.4369 L1.9999,14.4369 L6.2789,14.4369 L6.2789,17.7159 L1.9999,17.7159 L1.9999,19.7159 L6.2789,19.7159 L6.2789,22.9939 L1.9999,22.9939 L1.9999,24.9939 L6.2789,24.9939 L6.2789,28.2729 L1.9999,28.2729 L1.9999,30.2729 L6.2789,30.2729 L6.2789,33.5509 L1.9999,33.5509 L1.9999,35.5509 L6.2789,35.5509 L6.2789,38.5739 C6.2789,40.3029 7.6859,41.7089 9.4139,41.7089 L12.4369,41.7089 L12.4369,45.9869 L14.4369,45.9869 L14.4369,41.7089 L17.7149,41.7089 L17.7149,45.9869 L19.7149,45.9869 L19.7149,41.7089 L22.9929,41.7089 L22.9929,45.9869 L24.9929,45.9869 L24.9929,41.7089 L28.2719,41.7089 L28.2719,45.9869 L30.2719,45.9869 L30.2719,41.7089 L33.5499,41.7089 L33.5499,45.9869 L35.5499,45.9869 L35.5499,41.7089 L38.5709,41.7089 C40.2999,41.7089 41.7059,40.3029 41.7059,38.5739 L41.7059,35.5509 L45.9859,35.5509 L45.9859,33.5509 L41.7059,33.5509 L41.7059,30.2729 L45.9859,30.2729 L45.9859,28.2729 L41.7059,28.2729 L41.7059,24.9939 L45.9859,24.9939 L45.9859,22.9939 L41.7059,22.9939 L41.7059,19.7159 L45.9859,19.7159 L45.9859,17.7159 L41.7059,17.7159 L41.7059,14.4369 L45.9859,14.4369 Z" id="Amazon-IOT-RESOURCES-IoT-thing-police-emergency_Resource-Icon_light-bg" fill="#7AA116"></path>
    </g>
</svg>`, u_ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/IoT/Res_AWS-IoT-Analytics_Data-Store_48</title>
    <g id="Icon-Resource/IoT/Res_AWS-IoT-Analytics_Data-Store_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M17.632,40 L22.632,40 L22.632,38 L17.632,38 L17.632,40 Z M13.632,40 L15.632,40 L15.632,38 L13.632,38 L13.632,40 Z M17.632,30 L22.632,30 L22.632,28 L17.632,28 L17.632,30 Z M13.632,30 L15.632,30 L15.632,28 L13.632,28 L13.632,30 Z M17.632,19 L22.632,19 L22.632,17 L17.632,17 L17.632,19 Z M13.632,19 L15.632,19 L15.632,17 L13.632,17 L13.632,19 Z M11,19.211 L11,11.527 C13.376,13.269 17.723,14.316 23.264,14.316 C28.375,14.316 33.528,13.321 36.264,11.392 L36.264,19.211 C36.264,21.178 30.925,23.368 23.264,23.368 C15.688,23.368 11,21.21 11,19.211 Z M11,29.554 L11,22.579 C13.376,24.319 17.723,25.368 23.264,25.368 C28.246,25.368 33.488,24.451 36.264,22.495 L36.264,29.554 C36.264,31.508 30.925,33.685 23.264,33.685 C15.587,33.685 11,31.584 11,29.554 Z M11,39.843 L11,32.907 C13.376,34.641 17.723,35.685 23.264,35.685 C28.246,35.685 33.488,34.771 36.264,32.823 L36.264,39.843 C36.264,41.809 30.925,44 23.264,44 C15.587,44 11,41.887 11,39.843 Z M36.264,8.158 C36.264,10.125 30.925,12.316 23.264,12.316 C15.688,12.316 11,10.158 11,8.158 C11,6.158 15.688,4 23.264,4 C30.925,4 36.264,6.191 36.264,8.158 Z M9,8.158 L9,39.843 C9,43.525 14.732,46 23.264,46 C30.488,46 38.264,44.073 38.264,39.843 L38.264,8.158 C38.264,4.115 30.718,2 23.264,2 C14.732,2 9,4.475 9,8.158 Z" id="AWS-IoT-Analytics-Data-Store_Resource-Icon_light-bg" fill="#7AA116"></path>
    </g>
</svg>`, h_ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/IoT/Res_AWS-IoT-Device-Tester_48</title>
    <g id="Icon-Resource/IoT/Res_AWS-IoT-Device-Tester_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M21,4.52292229 L21,7.03192229 C21,7.58492229 21.447,8.03192229 22,8.03192229 L26,8.03192229 C26.553,8.03192229 27,7.58492229 27,7.03192229 L27,4.57592229 C27.869,5.27292229 28.545,6.26692229 28.545,7.34092229 C28.545,9.01292229 27.538,10.2829223 26.54,10.7999223 C26.208,10.9719223 26,11.3149223 26,11.6879223 L26,28.3559223 C26,28.7289223 26.208,29.0709223 26.54,29.2429223 C27.538,29.7609223 28.545,31.0309223 28.545,32.7019223 C28.545,33.7759223 27.869,34.7709223 27,35.4679223 L27,33.0319223 C27,32.4799223 26.553,32.0319223 26,32.0319223 L22,32.0319223 C21.447,32.0319223 21,32.4799223 21,33.0319223 L21,35.4699223 C20.158,34.7779223 19.507,33.7859223 19.507,32.7019223 C19.507,31.0399223 20.497,29.7579223 21.478,29.2249223 C21.8,29.0499223 22,28.7119223 22,28.3459223 L22,11.6469223 C22,11.2799223 21.8,10.9429223 21.478,10.7679223 C20.497,10.2339223 19.507,8.95192229 19.507,7.29092229 C19.507,6.20692229 20.158,5.21492229 21,4.52292229 L21,4.52292229 Z M20,12.1979223 L20,27.7939223 C18.488,28.8689223 17.507,30.7669223 17.507,32.7019223 C17.507,35.2589223 19.593,37.3689223 21.653,38.1299223 C21.766,38.1719223 21.883,38.1919223 22,38.1919223 C22.201,38.1919223 22.401,38.1309223 22.571,38.0129223 C22.84,37.8259223 23,37.5199223 23,37.1919223 L23,34.0319223 L25,34.0319223 L25,37.1839223 C25,37.5119223 25.161,37.8189223 25.431,38.0059223 C25.7,38.1919223 26.043,38.2359223 26.352,38.1199223 C28.436,37.3369223 30.545,35.2249223 30.545,32.7019223 C30.545,30.7139223 29.563,28.8499223 28,27.7899223 L28,12.2539223 C29.563,11.1929223 30.545,9.32992229 30.545,7.34092229 C30.545,4.81792229 28.436,2.70592229 26.352,1.92292229 C26.043,1.80692229 25.7,1.85192229 25.431,2.03692229 C25.161,2.22392229 25,2.53092229 25,2.85892229 L25,6.03192229 L23,6.03192229 L23,2.79992229 C23,2.47292229 22.84,2.16692229 22.571,1.97992229 C22.302,1.79192229 21.958,1.74892229 21.653,1.86192229 C19.593,2.62392229 17.507,4.73292229 17.507,7.29092229 C17.507,9.22592229 18.488,11.1229223 20,12.1979223 L20,12.1979223 Z M17.254,22.2819223 C16.846,22.5869223 16.409,23.4599223 16.416,24.6569223 C16.422,25.8539223 16.867,26.7219223 17.279,27.0229223 L16.1,28.6379223 C15.069,27.8859223 14.424,26.3639223 14.416,24.6669223 C14.406,22.9719223 15.035,21.4439223 16.055,20.6809223 L17.254,22.2819223 Z M11.044,24.6369223 C11.055,26.7839223 11.875,28.3399223 12.682,28.9309223 L11.502,30.5449223 C9.999,29.4459223 9.057,27.1869223 9.044,24.6479223 C9.031,22.1079223 9.948,19.8389223 11.438,18.7259223 L12.636,20.3269223 C11.836,20.9259223 11.033,22.4899223 11.044,24.6369223 L11.044,24.6369223 Z M30.567,27.0229223 C30.979,26.7229223 31.424,25.8539223 31.431,24.6569223 C31.437,23.4609223 31,22.5869223 30.592,22.2819223 L31.791,20.6809223 C32.811,21.4439223 33.438,22.9709223 33.431,24.6669223 C33.421,26.3649223 32.776,27.8869223 31.747,28.6379223 L30.567,27.0229223 Z M36.802,24.6369223 C36.813,22.4909223 36.011,20.9259223 35.211,20.3269223 L36.408,18.7259223 C37.899,19.8409223 38.816,22.1099223 38.802,24.6479223 C38.789,27.1879223 37.847,29.4469223 36.344,30.5449223 L35.164,28.9299223 C35.972,28.3409223 36.791,26.7849223 36.802,24.6369223 L36.802,24.6369223 Z M44,43.0319223 C44,43.7099223 43.73,44.0319223 42.197,44.0319223 L5.803,44.0319223 C4.182,44.0319223 4.013,43.2479223 4,43.0319223 L4,42.0319223 L5,42.0319223 L7,42.0319223 L41,42.0319223 L43,42.0319223 L44,42.0319223 L44,43.0319223 Z M45,40.0319223 L43,40.0319223 L43,17.4349223 C43,15.3439223 41.491,15.0319223 40.592,15.0319223 L30,15.0319223 L30,17.0319223 L40.592,17.0319223 C40.867,17.0319223 40.975,17.0879223 40.969,17.0769223 C41,17.1429223 41,17.3389223 41,17.4349223 L41,40.0319223 L7,40.0319223 L7,17.4349223 C7,17.3369223 7,17.1359223 7.016,17.0929223 C7.017,17.0929223 7.111,17.0319223 7.408,17.0319223 L18,17.0319223 L18,15.0319223 L7.408,15.0319223 C6.509,15.0319223 5,15.3439223 5,17.4349223 L5,40.0319223 L3,40.0319223 C2.447,40.0319223 2,40.4799223 2,41.0319223 L2,43.0319223 C2,44.0699223 2.795,46.0319223 5.803,46.0319223 L42.197,46.0319223 C45.34,46.0319223 46,44.4009223 46,43.0319223 L46,41.0319223 C46,40.4799223 45.553,40.0319223 45,40.0319223 L45,40.0319223 Z" id="Fill-1" fill="#7AA116"></path>
    </g>
</svg>`, d_ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/IoT/Res_AWS-IoT-Analytics_Pipeline_48</title>
    <g id="Icon-Resource/IoT/Res_AWS-IoT-Analytics_Pipeline_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M23,21 L29,21 L29,19 L23,19 L23,21 Z M31,21 L33,21 L33,19 L31,19 L31,21 Z M44,34 L37,34 L37,32 L37,16 L37,14 L44,14 L44,34 Z M13,31 L35,31 L35,17 L13,17 L13,31 Z M11,34 L4,34 L4,14 L11,14 L11,16 L11,32 L11,34 Z M36,12 C35.447,12 35,12.447 35,13 L35,15 L13,15 L13,13 C13,12.447 12.553,12 12,12 L3,12 C2.447,12 2,12.447 2,13 L2,35 C2,35.553 2.447,36 3,36 L12,36 C12.553,36 13,35.553 13,35 L13,33 L35,33 L35,35 C35,35.553 35.447,36 36,36 L45,36 C45.553,36 46,35.553 46,35 L46,13 C46,12.447 45.553,12 45,12 L36,12 Z" id="Amazon-IOT-RESOURCES-IoT-Pipeline_Resource-Icon_light-bg" fill="#7AA116"></path>
    </g>
</svg>`, g_ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/IoT/Res_AWS-IoT_Thing_Factory_48</title>
    <g id="Icon-Resource/IoT/Res_AWS-IoT_Thing_Factory_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M30.246,31.762 L31.762,31.762 L31.762,30.246 L30.246,30.246 L30.246,31.762 Z M28.246,32.761 C28.246,33.314 28.693,33.761 29.246,33.761 L32.762,33.761 C33.314,33.761 33.762,33.314 33.762,32.761 L33.762,29.246 C33.762,28.693 33.314,28.246 32.762,28.246 L29.246,28.246 C28.693,28.246 28.246,28.693 28.246,29.246 L28.246,32.761 Z M16.183,31.761 L17.699,31.761 L17.699,30.245 L16.183,30.245 L16.183,31.761 Z M15.184,28.246 C14.631,28.246 14.184,28.693 14.184,29.246 L14.184,32.761 C14.184,33.314 14.631,33.761 15.184,33.761 L18.699,33.761 C19.252,33.761 19.699,33.314 19.699,32.761 L19.699,29.246 C19.699,28.693 19.252,28.246 18.699,28.246 L15.184,28.246 Z M23.214,23.851 L24.73,23.851 L24.73,22.335 L23.214,22.335 L23.214,23.851 Z M22.215,20.336 C21.662,20.336 21.215,20.783 21.215,21.336 L21.215,24.851 C21.215,25.404 21.662,25.851 22.215,25.851 L25.73,25.851 C26.283,25.851 26.73,25.404 26.73,24.851 L26.73,21.336 C26.73,20.783 26.283,20.336 25.73,20.336 L22.215,20.336 Z M16.183,23.851 L17.699,23.851 L17.699,22.335 L16.183,22.335 L16.183,23.851 Z M15.184,20.336 C14.631,20.336 14.184,20.783 14.184,21.336 L14.184,24.851 C14.184,25.404 14.631,25.851 15.184,25.851 L18.699,25.851 C19.252,25.851 19.699,25.404 19.699,24.851 L19.699,21.336 C19.699,20.783 19.252,20.336 18.699,20.336 L15.184,20.336 Z M35.277,35.277 L26.73,35.277 L26.73,29.246 C26.73,28.693 26.283,28.246 25.73,28.246 L22.215,28.246 C21.662,28.246 21.215,28.693 21.215,29.246 L21.215,35.277 L12.668,35.277 L12.668,13.945 L28.923,19.505 C29.228,19.61 29.566,19.559 29.828,19.372 C30.09,19.184 30.246,18.882 30.246,18.558 L30.246,13.547 L30.883,13.547 L30.883,19.464 C30.883,19.891 31.154,20.271 31.559,20.41 L35.277,21.681 L35.277,35.277 Z M32.883,18.749 L32.883,12.547 C32.883,11.994 32.435,11.547 31.883,11.547 L29.246,11.547 C28.693,11.547 28.246,11.994 28.246,12.547 L28.246,17.16 L11.991,11.6 C11.685,11.495 11.348,11.5462553 11.086,11.733 C10.824,11.921 10.668,12.223 10.668,12.547 L10.668,36.277 C10.668,36.83 11.115,37.277 11.668,37.277 L22.215,37.277 C22.767,37.277 23.215,36.83 23.215,36.277 L23.215,30.246 L24.73,30.246 L24.73,36.277 C24.73,36.83 25.178,37.277 25.73,37.277 L36.277,37.277 C36.83,37.277 37.277,36.83 37.277,36.277 L37.277,20.966 C37.277,20.539 37.006,20.159 36.6,20.02 L32.883,18.749 Z M39.67,38.537 C39.67,39.163 39.161,39.672 38.535,39.672 L9.409,39.672 C8.783,39.672 8.274,39.163 8.274,38.537 L8.274,9.424 C8.274,8.798 8.783,8.289 9.409,8.289 L38.535,8.289 C39.161,8.289 39.67,8.798 39.67,9.424 L39.67,38.537 Z M45.945,14.425 L45.945,12.425 L41.67,12.425 L41.67,9.424 C41.67,7.695 40.264,6.289 38.535,6.289 L35.519,6.289 L35.519,2 L33.519,2 L33.519,6.289 L30.246,6.289 L30.246,2 L28.246,2 L28.246,6.289 L24.973,6.289 L24.973,2 L22.973,2 L22.973,6.289 L19.699,6.289 L19.699,2 L17.699,2 L17.699,6.289 L14.426,6.289 L14.426,2 L12.426,2 L12.426,6.289 L9.409,6.289 C7.681,6.289 6.274,7.695 6.274,9.424 L6.274,12.425 L2,12.425 L2,14.425 L6.274,14.425 L6.274,17.699 L2,17.699 L2,19.699 L6.274,19.699 L6.274,22.972 L2,22.972 L2,24.972 L6.274,24.972 L6.274,28.246 L2,28.246 L2,30.246 L6.274,30.246 L6.274,33.519 L2,33.519 L2,35.519 L6.274,35.519 L6.274,38.537 C6.274,40.265 7.681,41.672 9.409,41.672 L12.426,41.672 L12.426,45.945 L14.426,45.945 L14.426,41.672 L17.699,41.672 L17.699,45.945 L19.699,45.945 L19.699,41.672 L22.973,41.672 L22.973,45.945 L24.973,45.945 L24.973,41.672 L28.246,41.672 L28.246,45.945 L30.246,45.945 L30.246,41.672 L33.519,41.672 L33.519,45.945 L35.519,45.945 L35.519,41.672 L38.535,41.672 C40.264,41.672 41.67,40.265 41.67,38.537 L41.67,35.519 L45.945,35.519 L45.945,33.519 L41.67,33.519 L41.67,30.246 L45.945,30.246 L45.945,28.246 L41.67,28.246 L41.67,24.972 L45.945,24.972 L45.945,22.972 L41.67,22.972 L41.67,19.699 L45.945,19.699 L45.945,17.699 L41.67,17.699 L41.67,14.425 L45.945,14.425 Z" id="Amazon-IOT-RESOURCES-IoT-thing-factory_Resource-Icon_light-bg" fill="#7AA116"></path>
    </g>
</svg>`, f_ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/IoT/Res_AWS-IoT_Thing_Humidity-Sensor_48</title>
    <g id="Icon-Resource/IoT/Res_AWS-IoT_Thing_Humidity-Sensor_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M30.115,21.9995 C28.758,21.9995 27.654,20.8955 27.654,19.5385 C27.654,18.0605 29.072,15.9065 30.115,14.5655 C31.159,15.9065 32.577,18.0605 32.577,19.5385 C32.577,20.8955 31.472,21.9995 30.115,21.9995 L30.115,21.9995 Z M29.372,12.3305 C28.991,12.7535 25.654,16.5485 25.654,19.5385 C25.654,21.9985 27.655,23.9995 30.115,23.9995 C32.575,23.9995 34.577,21.9985 34.577,19.5385 C34.577,16.5485 31.239,12.7535 30.858,12.3305 C30.479,11.9085 29.751,11.9095 29.372,12.3305 L29.372,12.3305 Z M16.423,22.9995 C15.638,22.9995 15,22.3615 15,21.5765 C15,20.7805 15.711,19.5575 16.421,18.5925 C17.103,19.5235 17.845,20.7675 17.845,21.5765 C17.845,22.3615 17.207,22.9995 16.423,22.9995 L16.423,22.9995 Z M19.845,21.5765 C19.845,19.3725 17.44,16.6355 17.166,16.3305 C16.787,15.9085 16.058,15.9085 15.679,16.3305 C15.405,16.6355 13,19.3725 13,21.5765 C13,23.4635 14.535,24.9995 16.423,24.9995 C18.31,24.9995 19.845,23.4635 19.845,21.5765 L19.845,21.5765 Z M23.5,33.9995 C21.57,33.9995 20,32.4295 20,30.4995 C20,28.3835 22.107,25.2935 23.5,23.5515 C24.892,25.2935 27,28.3835 27,30.4995 C27,32.4295 25.429,33.9995 23.5,33.9995 L23.5,33.9995 Z M22.757,21.3305 C22.562,21.5465 18,26.6605 18,30.4995 C18,33.5325 20.468,35.9995 23.5,35.9995 C26.532,35.9995 29,33.5325 29,30.4995 C29,26.6605 24.437,21.5465 24.243,21.3305 C23.864,20.9085 23.136,20.9085 22.757,21.3305 L22.757,21.3305 Z M39,37.8655 C39,38.4905 38.491,38.9995 37.865,38.9995 L10.135,38.9995 C9.509,38.9995 9,38.4905 9,37.8655 L9,10.1345 C9,9.5095 9.509,8.9995 10.135,8.9995 L37.865,8.9995 C38.491,8.9995 39,9.5095 39,10.1345 L39,37.8655 Z M46,14.9995 L46,12.9995 L41,12.9995 L41,10.1345 C41,8.4065 39.594,6.9995 37.865,6.9995 L35,6.9995 L35,1.9995 L33,1.9995 L33,6.9995 L30,6.9995 L30,1.9995 L28,1.9995 L28,6.9995 L25,6.9995 L25,1.9995 L23,1.9995 L23,6.9995 L20,6.9995 L20,1.9995 L18,1.9995 L18,6.9995 L15,6.9995 L15,1.9995 L13,1.9995 L13,6.9995 L10.135,6.9995 C8.406,6.9995 7,8.4065 7,10.1345 L7,12.9995 L2,12.9995 L2,14.9995 L7,14.9995 L7,17.9995 L2,17.9995 L2,19.9995 L7,19.9995 L7,22.9995 L2,22.9995 L2,24.9995 L7,24.9995 L7,27.9995 L2,27.9995 L2,29.9995 L7,29.9995 L7,32.9995 L2,32.9995 L2,34.9995 L7,34.9995 L7,37.8655 C7,39.5935 8.406,40.9995 10.135,40.9995 L13,40.9995 L13,45.9995 L15,45.9995 L15,40.9995 L18,40.9995 L18,45.9995 L20,45.9995 L20,40.9995 L23,40.9995 L23,45.9995 L25,45.9995 L25,40.9995 L28,40.9995 L28,45.9995 L30,45.9995 L30,40.9995 L33,40.9995 L33,45.9995 L35,45.9995 L35,40.9995 L37.865,40.9995 C39.594,40.9995 41,39.5935 41,37.8655 L41,34.9995 L46,34.9995 L46,32.9995 L41,32.9995 L41,29.9995 L46,29.9995 L46,27.9995 L41,27.9995 L41,24.9995 L46,24.9995 L46,22.9995 L41,22.9995 L41,19.9995 L46,19.9995 L46,17.9995 L41,17.9995 L41,14.9995 L46,14.9995 Z" id="Fill-1" fill="#7AA116"></path>
    </g>
</svg>`, p_ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/IoT/Res_AWS-IoT-Greengrass_Protocol_48</title>
    <g id="Icon-Resource/IoT/Res_AWS-IoT-Greengrass_Protocol_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M19,25 L23,25 L23,23 L19,23 L19,25 Z M13,25 L17,25 L17,23 L13,23 L13,25 Z M7,25 L11,25 L11,23 L7,23 L7,25 Z M4,29 L44,29 L44,19 L4,19 L4,29 Z M35.917,42 C35.09,42 34.417,41.327 34.417,40.5 C34.417,39.673 35.09,39 35.917,39 C36.744,39 37.417,39.673 37.417,40.5 C37.417,41.327 36.744,42 35.917,42 L35.917,42 Z M25.501,42.5 C25.501,43.327 24.828,44 24.001,44 C23.174,44 22.501,43.327 22.501,42.5 C22.501,41.673 23.174,41 24.001,41 C24.828,41 25.501,41.673 25.501,42.5 L25.501,42.5 Z M11.917,42 C11.09,42 10.417,41.327 10.417,40.5 C10.417,39.673 11.09,39 11.917,39 C12.744,39 13.417,39.673 13.417,40.5 C13.417,41.327 12.744,42 11.917,42 L11.917,42 Z M10.499,7.5 C10.499,6.673 11.172,6 11.999,6 C12.826,6 13.499,6.673 13.499,7.5 C13.499,8.327 12.826,9 11.999,9 C11.172,9 10.499,8.327 10.499,7.5 L10.499,7.5 Z M22.499,5.5 C22.499,4.673 23.172,4 23.999,4 C24.826,4 25.499,4.673 25.499,5.5 C25.499,6.327 24.826,7 23.999,7 C23.172,7 22.499,6.327 22.499,5.5 L22.499,5.5 Z M34.501,7.5 C34.501,6.673 35.174,6 36.001,6 C36.828,6 37.501,6.673 37.501,7.5 C37.501,8.327 36.828,9 36.001,9 C35.174,9 34.501,8.327 34.501,7.5 L34.501,7.5 Z M45,17 L33.379,17 L36.696,13.783 C36.891,13.595 37,13.336 37,13.065 L37,10.837 C38.441,10.404 39.501,9.08 39.501,7.5 C39.501,5.57 37.931,4 36.001,4 C34.071,4 32.501,5.57 32.501,7.5 C32.501,9.08 33.56,10.403 35,10.836 L35,12.642 L30.506,17 L25,17 L25,8.836 C26.44,8.403 27.499,7.08 27.499,5.5 C27.499,3.57 25.929,2 23.999,2 C22.069,2 20.499,3.57 20.499,5.5 C20.499,7.08 21.559,8.404 23,8.837 L23,17 L17.492,17 L13,12.642 L13,10.836 C14.44,10.403 15.499,9.08 15.499,7.5 C15.499,5.57 13.929,4 11.999,4 C10.069,4 8.499,5.57 8.499,7.5 C8.499,9.08 9.559,10.404 11,10.837 L11,13.065 C11,13.336 11.109,13.595 11.304,13.783 L14.62,17 L3,17 C2.447,17 2,17.448 2,18 L2,30 C2,30.552 2.447,31 3,31 L15.023,31 L11.302,34.625 C11.109,34.813 11,35.072 11,35.341 L11,37.137 C9.517,37.543 8.417,38.89 8.417,40.5 C8.417,42.43 9.987,44 11.917,44 C13.847,44 15.417,42.43 15.417,40.5 C15.417,38.951 14.397,37.648 13,37.189 L13,35.763 L17.89,31 L23,31 L23,39.164 C21.56,39.597 20.501,40.92 20.501,42.5 C20.501,44.43 22.071,46 24.001,46 C25.931,46 27.501,44.43 27.501,42.5 C27.501,40.92 26.441,39.596 25,39.163 L25,31 L30.086,31 L35,35.765 L35,37.137 C33.517,37.543 32.417,38.89 32.417,40.5 C32.417,42.43 33.987,44 35.917,44 C37.847,44 39.417,42.43 39.417,40.5 C39.417,38.951 38.397,37.648 37,37.189 L37,35.341 C37,35.071 36.891,34.812 36.696,34.624 L32.959,31 L45,31 C45.553,31 46,30.552 46,30 L46,18 C46,17.448 45.553,17 45,17 L45,17 Z" id="Fill-1" fill="#7AA116"></path>
    </g>
</svg>`, m_ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/IoT/Res_AWS-IoT_Servo_48</title>
    <g id="Icon-Resource/IoT/Res_AWS-IoT_Servo_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M22.3422,25.4737 L23.9692,23.0347 L25.5952,25.4737 L22.3422,25.4737 Z M24.8012,20.6767 C24.6152,20.3987 24.3032,20.2317 23.9692,20.2317 C23.6352,20.2317 23.3222,20.3987 23.1372,20.6767 L19.6422,25.9187 C19.4382,26.2257 19.4182,26.6197 19.5922,26.9457 C19.7662,27.2707 20.1052,27.4737 20.4742,27.4737 L27.4632,27.4737 C27.8322,27.4737 28.1712,27.2707 28.3452,26.9457 C28.5192,26.6197 28.5002,26.2257 28.2952,25.9187 L24.8012,20.6767 Z M10.5532,23.8527 C10.5532,22.9587 11.2802,22.2317 12.1742,22.2317 C13.0682,22.2317 13.7952,22.9587 13.7952,23.8527 C13.7952,24.7457 13.0682,25.4737 12.1742,25.4737 C11.2802,25.4737 10.5532,24.7457 10.5532,23.8527 Z M8.5532,23.8527 C8.5532,25.8497 10.1772,27.4737 12.1742,27.4737 C14.1712,27.4737 15.7952,25.8497 15.7952,23.8527 C15.7952,21.8557 14.1712,20.2317 12.1742,20.2317 C10.1772,20.2317 8.5532,21.8557 8.5532,23.8527 Z M43.9372,37.7047 L23.0952,37.7047 C23.1602,37.4937 23.1752,37.2687 23.0962,37.0577 L22.0032,34.1737 C21.9042,33.9117 21.6972,33.7027 21.4372,33.5987 C21.1782,33.4967 20.8852,33.5057 20.6312,33.6287 L19.8912,33.9887 C19.7422,33.8147 19.5842,33.6477 19.4192,33.4887 L19.8302,32.7717 C19.9702,32.5277 20.0002,32.2357 19.9132,31.9667 C19.8272,31.6997 19.6322,31.4807 19.3752,31.3637 L16.5632,30.0877 C16.3072,29.9717 16.0122,29.9687 15.7522,30.0807 C15.4932,30.1937 15.2942,30.4097 15.2032,30.6767 L14.9362,31.4607 C14.7062,31.4427 14.4762,31.4377 14.2482,31.4387 L14.0292,30.6397 C13.9552,30.3677 13.7702,30.1397 13.5192,30.0117 C13.2662,29.8837 12.9732,29.8697 12.7102,29.9677 L9.8272,31.0597 C9.5652,31.1597 9.3562,31.3657 9.2522,31.6267 C9.1492,31.8887 9.1602,32.1817 9.2832,32.4337 L9.6462,33.1767 C9.4712,33.3257 9.3032,33.4817 9.1432,33.6447 L8.4252,33.2337 C8.1832,33.0937 7.8902,33.0617 7.6202,33.1497 C7.3532,33.2357 7.1332,33.4307 7.0172,33.6877 L5.7412,36.5007 C5.6252,36.7567 5.6222,37.0507 5.7342,37.3087 C5.8042,37.4737 5.9272,37.6007 6.0692,37.7047 L4.0002,37.7047 L4.0002,9.9997 L24.8432,9.9997 C24.7772,10.2117 24.7622,10.4367 24.8422,10.6477 L25.9342,13.5307 C26.0332,13.7927 26.2382,14.0007 26.4992,14.1047 C26.7612,14.2107 27.0542,14.1997 27.3062,14.0757 L28.0462,13.7167 C28.1952,13.8907 28.3522,14.0577 28.5182,14.2167 L28.1082,14.9327 C27.9672,15.1767 27.9372,15.4687 28.0232,15.7377 C28.1102,16.0047 28.3052,16.2237 28.5622,16.3407 L31.3752,17.6177 C31.6312,17.7327 31.9262,17.7367 32.1862,17.6237 C32.4452,17.5117 32.6442,17.2947 32.7352,17.0287 L33.0002,16.2477 C33.2292,16.2667 33.4632,16.2757 33.6892,16.2707 L33.9082,17.0677 C33.9832,17.3377 34.1682,17.5657 34.4182,17.6927 C34.5612,17.7657 34.7162,17.8017 34.8722,17.8017 C34.9912,17.8017 35.1112,17.7807 35.2242,17.7387 L38.1072,16.6557 C38.3692,16.5557 38.5792,16.3517 38.6842,16.0907 C38.7882,15.8297 38.7782,15.5367 38.6552,15.2847 L38.2962,14.5377 C38.4722,14.3887 38.6412,14.2297 38.8032,14.0637 L39.5092,14.4707 C39.7542,14.6117 40.0462,14.6437 40.3152,14.5567 C40.5832,14.4707 40.8032,14.2747 40.9202,14.0177 L42.1962,11.2037 C42.3132,10.9477 42.3162,10.6537 42.2032,10.3947 C42.1322,10.2307 42.0102,10.1037 41.8682,9.9997 L43.9372,9.9997 L43.9372,37.7047 Z M9.1872,37.7047 L9.1982,37.6437 C9.2912,37.1557 9.0132,36.6737 8.5432,36.5107 L8.0162,36.3277 L8.3852,35.5147 L8.8632,35.7887 C9.3012,36.0407 9.8542,35.9257 10.1572,35.5257 C10.5152,35.0547 10.9512,34.6487 11.4562,34.3167 C11.8772,34.0397 12.0272,33.4947 11.8062,33.0417 L11.5622,32.5417 L12.3912,32.2277 L12.5372,32.7657 C12.6732,33.2557 13.1612,33.5707 13.6522,33.4907 C14.2182,33.4047 14.8122,33.4237 15.4222,33.5437 C15.9142,33.6477 16.4022,33.3607 16.5632,32.8857 L16.7402,32.3657 L17.5482,32.7317 L17.2732,33.2107 C17.0232,33.6477 17.1362,34.2027 17.5372,34.5057 C18.0182,34.8697 18.4292,35.3047 18.7592,35.7997 C19.0342,36.2137 19.5762,36.3647 20.0282,36.1447 L20.5202,35.9057 L20.8362,36.7387 L20.3052,36.8847 C19.9132,36.9927 19.6352,37.3217 19.5792,37.7047 L9.1872,37.7047 Z M38.7532,9.9997 C38.7492,10.0177 38.7462,10.0357 38.7422,10.0527 C38.6392,10.5467 38.9202,11.0407 39.3992,11.2037 L39.9192,11.3817 L39.5542,12.1877 L39.0852,11.9167 C38.6472,11.6637 38.0932,11.7787 37.7882,12.1797 C37.4222,12.6617 36.9862,13.0717 36.4892,13.3977 C36.0712,13.6727 35.9202,14.2157 36.1382,14.6677 L36.3792,15.1677 L35.5462,15.4807 L35.3992,14.9467 C35.2792,14.5077 34.8792,14.2117 34.4362,14.2117 C34.3902,14.2117 34.3442,14.2147 34.2972,14.2217 C33.7032,14.3037 33.1072,14.2847 32.5262,14.1627 C32.0352,14.0557 31.5362,14.3397 31.3742,14.8197 L31.1962,15.3397 L30.3892,14.9737 L30.6632,14.4947 C30.9142,14.0577 30.8012,13.5027 30.4002,13.1997 C29.9192,12.8357 29.5082,12.4007 29.1782,11.9057 C28.9022,11.4907 28.3622,11.3387 27.9092,11.5607 L27.4172,11.7987 L27.1032,10.9677 L27.6402,10.8217 C28.0322,10.7137 28.3102,10.3847 28.3662,9.9997 L38.7532,9.9997 Z M39.8522,7.9997 L27.3152,7.9997 L3.0002,7.9997 C2.4472,7.9997 2.0002,8.4477 2.0002,8.9997 L2.0002,38.7047 C2.0002,39.2577 2.4472,39.7047 3.0002,39.7047 L8.0942,39.7047 L20.6312,39.7047 L44.9372,39.7047 C45.4892,39.7047 45.9372,39.2577 45.9372,38.7047 L45.9372,8.9997 C45.9372,8.4477 45.4892,7.9997 44.9372,7.9997 L39.8522,7.9997 Z" id="Amazon-IOT-RESOURCES-IoT-servo_Resource-Icon_light-bg" fill="#7AA116"></path>
    </g>
</svg>`, w_ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/IoT/Res_AWS-IoT-Analytics_Dataset_48</title>
    <g id="Icon-Resource/IoT/Res_AWS-IoT-Analytics_Dataset_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M6,40.457 L34.888,40.457 L34.888,2 L6,2 L6,40.457 Z M8,38.457 L32.889,38.457 L32.889,4 L8,4 L8,38.457 Z M36.651,5.557 L36.651,7.557 L39.33,7.557 L39.33,44 L12.56,44 L12.56,42.178 L10.56,42.178 L10.56,46 L41.33,46 L41.33,5.557 L36.651,5.557 Z M28.175,10.176 L30.555,10.176 L30.555,8.176 L28.175,8.176 L28.175,10.176 Z M10.25,10.176 L26.588,10.176 L26.588,8.176 L10.25,8.176 L10.25,10.176 Z M19.332,16.223 L30.556,16.223 L30.556,14.223 L19.332,14.223 L19.332,16.223 Z M14.08,16.223 L17.933,16.223 L17.933,14.223 L14.08,14.223 L14.08,16.223 Z M10.25,16.223 L12.266,16.223 L12.266,14.223 L10.25,14.223 L10.25,16.223 Z M18.35,22.269 L30.556,22.269 L30.556,20.269 L18.35,20.269 L18.35,22.269 Z M10.25,22.269 L16.838,22.269 L16.838,20.269 L10.25,20.269 L10.25,22.269 Z M10.25,28.315 L30.556,28.315 L30.556,26.315 L10.25,26.315 L10.25,28.315 Z M26.928,34.286 L30.556,34.286 L30.556,32.285 L26.928,32.285 L26.928,34.286 Z M10.25,34.286 L24.963,34.286 L24.963,32.285 L10.25,32.285 L10.25,34.286 Z" id="Amazon-IOT-RESOURCES-IoT-Data-Set_Resource-Icon_light-bg" fill="#7AA116"></path>
    </g>
</svg>`, x_ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/IoT/Res_AWS-IoT-Greengrass_Component-Machine-Learning_48</title>
    <g id="Icon-Resource/IoT/Res_AWS-IoT-Greengrass_Component-Machine-Learning_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M4,24 C4,22.897 4.897,22 6,22 C7.103,22 8,22.897 8,24 C8,25.103 7.103,26 6,26 C4.897,26 4,25.103 4,24 L4,24 Z M24,4 C25.103,4 26,4.897 26,6 C26,7.103 25.103,8 24,8 C22.897,8 22,7.103 22,6 C22,4.897 22.897,4 24,4 L24,4 Z M10.961,35.532 C9.036,33.336 7.688,30.678 7.06,27.839 C8.749,27.372 10,25.836 10,24 C10,22.179 8.77,20.656 7.103,20.174 C8.604,13.762 13.757,8.646 20.206,7.205 C20.721,8.819 22.217,10 24,10 C25.78,10 27.274,8.823 27.792,7.213 C29.593,7.616 31.31,8.294 32.905,9.255 L33.938,7.542 C32.065,6.414 30.043,5.644 27.92,5.205 C27.55,3.379 25.934,2 24,2 C22.071,2 20.459,3.371 20.083,5.189 C12.612,6.728 6.647,12.679 5.071,20.12 C3.314,20.541 2,22.115 2,24 C2,25.866 3.29,27.426 5.022,27.865 C5.69,31.233 7.27,34.389 9.563,36.963 L7.016,36.924 L6.984,38.924 L11.908,39 L11.924,39 C12.184,39 12.434,38.899 12.62,38.718 C12.811,38.533 12.92,38.28 12.924,38.015 L13,33.015 L11,32.985 L10.961,35.532 Z M42,26 C40.897,26 40,25.103 40,24 C40,22.897 40.897,22 42,22 C43.103,22 44,22.897 44,24 C44,25.103 43.103,26 42,26 L42,26 Z M24,44 C22.897,44 22,43.103 22,42 C22,40.897 22.897,40 24,40 C25.103,40 26,40.897 26,42 C26,43.103 25.103,44 24,44 L24,44 Z M46,24 C46,22.096 44.66,20.503 42.874,20.103 C42.159,16.709 40.558,13.605 38.201,11.043 L41.016,11 L40.984,9 L35.984,9.076 C35.72,9.081 35.467,9.189 35.282,9.38 C35.098,9.57 34.996,9.826 35,10.092 L35.076,15.016 L37.076,14.984 L37.041,12.731 C38.914,14.877 40.209,17.423 40.848,20.189 C39.206,20.687 38,22.198 38,24 C38,25.82 39.229,27.342 40.896,27.825 C39.469,34.305 34.354,39.495 27.854,40.987 C27.402,39.273 25.854,38 24,38 C22.144,38 20.594,39.276 20.145,40.993 C18.33,40.583 16.6,39.905 14.999,38.933 L13.962,40.643 C15.88,41.808 17.964,42.602 20.154,43.041 C20.616,44.74 22.156,46 24,46 C25.847,46 27.39,44.736 27.848,43.033 C35.437,41.483 41.427,35.432 42.931,27.879 C44.688,27.457 46,25.884 46,24 L46,24 Z M20.972,33.488 L16.478,30.831 L16.478,29 L19,29 L19,31 L21,31 L21,28 C21,27.448 20.553,27 20,27 L16,27 L16,27.005 C15.98,26.993 15.966,26.977 15.945,26.966 L13.478,25.662 L13.478,21.768 L15.947,20.453 C16.273,20.279 16.478,19.939 16.478,19.57 L16.478,19 L21,19 L21,17 L16.478,17 L16.478,16.716 L21.002,14.126 L22.828,15.296 L22.828,21 L19,21 C18.447,21 18,21.448 18,22 L18,25 L20,25 L20,23 L22.828,23 L22.828,32.413 L20.972,33.488 Z M26.919,14.107 L31.478,16.716 L31.478,19.57 C31.478,19.939 31.682,20.279 32.008,20.453 L34.478,21.768 L34.478,22 L30,22 C29.447,22 29,22.448 29,23 L29,25 L26,25 L26,27 L30,27 C30.553,27 31,26.552 31,26 L31,24 L34.478,24 L34.478,25.662 L32.01,26.966 C31.683,27.139 31.478,27.479 31.478,27.85 L31.478,30.831 L28,32.887 L28,31 L29,31 L29,29 L27,29 C26.447,29 26,29.448 26,30 L26,32.855 L24.828,32.127 L24.828,20 L29,20 C29.553,20 30,19.552 30,19 L30,17 L28,17 L28,18 L24.828,18 L24.828,15.283 L26.919,14.107 Z M26.46,35.496 C26.622,35.597 26.805,35.647 26.988,35.647 C27.164,35.647 27.34,35.601 27.497,35.508 L32.986,32.262 C33.291,32.082 33.478,31.755 33.478,31.401 L33.478,28.453 L35.945,27.148 C36.272,26.975 36.478,26.635 36.478,26.264 L36.478,21.167 C36.478,20.797 36.273,20.458 35.947,20.284 L33.478,18.969 L33.478,16.136 C33.478,15.777 33.285,15.446 32.975,15.268 L27.42,12.089 C27.114,11.916 26.74,11.914 26.433,12.086 L23.818,13.556 L21.57,12.116 C21.257,11.914 20.857,11.905 20.534,12.089 L14.98,15.268 C14.67,15.446 14.478,15.777 14.478,16.136 L14.478,18.969 L12.008,20.284 C11.682,20.458 11.478,20.797 11.478,21.167 L11.478,26.264 C11.478,26.635 11.683,26.975 12.01,27.148 L14.478,28.453 L14.478,31.401 C14.478,31.755 14.664,32.082 14.969,32.262 L20.458,35.508 C20.77,35.692 21.156,35.694 21.468,35.512 L23.992,34.049 L23.988,34.042 L24.122,34.042 L26.46,35.496 Z" id="Fill-1" fill="#7AA116"></path>
    </g>
</svg>`, __ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/IoT/Res_AWS-IoT_Thing_Generic_48</title>
    <g id="Icon-Resource/IoT/Res_AWS-IoT_Thing_Generic_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M20.4567,22.094 C19.5547,22.094 18.8207,21.359 18.8207,20.457 C18.8207,19.555 19.5547,18.82 20.4567,18.82 C21.3597,18.82 22.0937,19.555 22.0937,20.457 C22.0937,21.359 21.3597,22.094 20.4567,22.094 Z M27.4887,25.852 C28.3907,25.852 29.1247,26.586 29.1247,27.488 C29.1247,28.391 28.3907,29.125 27.4887,29.125 C26.5857,29.125 25.8517,28.391 25.8517,27.488 C25.8517,26.586 26.5857,25.852 27.4887,25.852 Z M15.3047,32.641 L15.3047,28.488 L24.0087,28.488 C24.4477,30.006 25.8327,31.125 27.4887,31.125 C29.4927,31.125 31.1247,29.493 31.1247,27.488 C31.1247,25.483 29.4927,23.852 27.4887,23.852 C25.8327,23.852 24.4477,24.971 24.0087,26.488 L15.3047,26.488 L15.3047,15.305 L32.6407,15.305 L32.6407,19.457 L23.9367,19.457 C23.4977,17.939 22.1137,16.82 20.4567,16.82 C18.4517,16.82 16.8207,18.452 16.8207,20.457 C16.8207,22.462 18.4517,24.094 20.4567,24.094 C22.1137,24.094 23.4977,22.975 23.9367,21.457 L32.6407,21.457 L32.6407,32.641 L15.3047,32.641 Z M14.3047,13.305 C13.7517,13.305 13.3047,13.752 13.3047,14.305 L13.3047,33.641 C13.3047,34.193 13.7517,34.641 14.3047,34.641 L33.6407,34.641 C34.1937,34.641 34.6407,34.193 34.6407,33.641 L34.6407,14.305 C34.6407,13.752 34.1937,13.305 33.6407,13.305 L14.3047,13.305 Z M39.6697,38.537 C39.6697,39.163 39.1607,39.672 38.5347,39.672 L9.4097,39.672 C8.7837,39.672 8.2757,39.163 8.2757,38.537 L8.2757,9.423 C8.2757,8.797 8.7837,8.288 9.4097,8.288 L38.5347,8.288 C39.1607,8.288 39.6697,8.797 39.6697,9.423 L39.6697,38.537 Z M45.9457,14.426 L45.9457,12.426 L41.6697,12.426 L41.6697,9.423 C41.6697,7.694 40.2637,6.288 38.5347,6.288 L35.5197,6.288 L35.5197,2 L33.5197,2 L33.5197,6.288 L30.2457,6.288 L30.2457,2 L28.2457,2 L28.2457,6.288 L24.9727,6.288 L24.9727,2 L22.9727,2 L22.9727,6.288 L19.6987,6.288 L19.6987,2 L17.6987,2 L17.6987,6.288 L14.4257,6.288 L14.4257,2 L12.4257,2 L12.4257,6.288 L9.4097,6.288 C7.6817,6.288 6.2757,7.694 6.2757,9.423 L6.2757,12.426 L1.9997,12.426 L1.9997,14.426 L6.2757,14.426 L6.2757,17.699 L1.9997,17.699 L1.9997,19.699 L6.2757,19.699 L6.2757,22.973 L1.9997,22.973 L1.9997,24.973 L6.2757,24.973 L6.2757,28.246 L1.9997,28.246 L1.9997,30.246 L6.2757,30.246 L6.2757,33.52 L1.9997,33.52 L1.9997,35.52 L6.2757,35.52 L6.2757,38.537 C6.2757,40.266 7.6817,41.672 9.4097,41.672 L12.4257,41.672 L12.4257,45.945 L14.4257,45.945 L14.4257,41.672 L17.6987,41.672 L17.6987,45.945 L19.6987,45.945 L19.6987,41.672 L22.9727,41.672 L22.9727,45.945 L24.9727,45.945 L24.9727,41.672 L28.2457,41.672 L28.2457,45.945 L30.2457,45.945 L30.2457,41.672 L33.5197,41.672 L33.5197,45.945 L35.5197,45.945 L35.5197,41.672 L38.5347,41.672 C40.2637,41.672 41.6697,40.266 41.6697,38.537 L41.6697,35.52 L45.9457,35.52 L45.9457,33.52 L41.6697,33.52 L41.6697,30.246 L45.9457,30.246 L45.9457,28.246 L41.6697,28.246 L41.6697,24.973 L45.9457,24.973 L45.9457,22.973 L41.6697,22.973 L41.6697,19.699 L45.9457,19.699 L45.9457,17.699 L41.6697,17.699 L41.6697,14.426 L45.9457,14.426 Z" id="Amazon-IOT-RESOURCES-IoT-thing-generic_Resource-Icon_light-bg" fill="#7AA116"></path>
    </g>
</svg>`, v_ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/IoT/Res_AWS-IoT_Device-Gateway_48</title>
    <g id="Icon-Resource/IoT/Res_AWS-IoT_Device-Gateway_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M20.4426,21.3965 C20.4426,21.9415 20.8856,22.3855 21.4306,22.3855 C21.9756,22.3855 22.4186,21.9415 22.4186,21.3965 C22.4186,20.8515 21.9756,20.4085 21.4306,20.4085 C20.8856,20.4085 20.4426,20.8515 20.4426,21.3965 Z M27.7656,27.5125 C27.7656,26.9685 27.3226,26.5245 26.7776,26.5245 C26.2326,26.5245 25.7886,26.9685 25.7886,27.5125 C25.7886,28.0575 26.2326,28.5015 26.7776,28.5015 C27.3226,28.5015 27.7656,28.0575 27.7656,27.5125 Z M30.6856,31.0225 L30.6856,22.4055 L24.2316,22.4055 C23.8156,23.5555 22.7226,24.3855 21.4306,24.3855 C19.7836,24.3855 18.4426,23.0445 18.4426,21.3965 C18.4426,19.7495 19.7836,18.4085 21.4306,18.4085 C22.7296,18.4085 23.8256,19.2465 24.2376,20.4055 L30.6856,20.4055 L30.6856,17.8885 L17.5316,17.8885 L17.5316,26.5215 L23.9716,26.5215 C24.3826,25.3625 25.4796,24.5245 26.7776,24.5245 C28.4246,24.5245 29.7656,25.8655 29.7656,27.5125 C29.7656,29.1605 28.4246,30.5015 26.7776,30.5015 C25.4856,30.5015 24.3926,29.6725 23.9766,28.5215 L17.5316,28.5215 L17.5316,31.0225 L30.6856,31.0225 Z M16.5316,33.0225 C15.9786,33.0225 15.5316,32.5755 15.5316,32.0225 L15.5316,16.8885 C15.5316,16.3365 15.9786,15.8885 16.5316,15.8885 L31.6856,15.8885 C32.2386,15.8885 32.6856,16.3365 32.6856,16.8885 L32.6856,32.0225 C32.6856,32.5755 32.2386,33.0225 31.6856,33.0225 L16.5316,33.0225 Z M44.1426,14.7815 L36.8896,7.4365 L36.8896,41.9375 L44.1426,37.5865 L44.1426,14.7815 Z M46.1426,38.1525 C46.1426,38.5045 45.9576,38.8295 45.6576,39.0105 L36.4046,44.5615 C36.2456,44.6565 36.0676,44.7045 35.8896,44.7045 C35.7196,44.7045 35.5496,44.6615 35.3966,44.5745 C35.0826,44.3965 34.8896,44.0645 34.8896,43.7045 L34.8896,39.5985 L32.1496,39.5985 L32.1496,37.5985 L34.8896,37.5985 L34.8896,11.1975 L32.1496,11.1975 L32.1496,9.1975 L34.8896,9.1975 L34.8896,5.0005 C34.8896,4.5955 35.1346,4.2285 35.5096,4.0755 C35.8846,3.9205 36.3156,4.0095 36.6016,4.2985 L45.8546,13.6695 C46.0386,13.8555 46.1426,14.1085 46.1426,14.3715 L46.1426,38.1525 Z M11.2526,7.4365 L3.9996,14.7815 L3.9996,37.5865 L11.2526,41.9375 L11.2526,7.4365 Z M13.2526,37.5985 L16.0326,37.5985 L16.0326,39.5985 L13.2526,39.5985 L13.2526,43.7045 C13.2526,44.0645 13.0596,44.3965 12.7456,44.5745 C12.5926,44.6615 12.4226,44.7045 12.2526,44.7045 C12.0746,44.7045 11.8966,44.6565 11.7386,44.5615 L2.4856,39.0105 C2.1846,38.8295 1.9996,38.5045 1.9996,38.1525 L1.9996,14.3715 C1.9996,14.1085 2.1036,13.8555 2.2876,13.6695 L11.5406,4.2985 C11.8266,4.0095 12.2576,3.9205 12.6326,4.0755 C13.0076,4.2285 13.2526,4.5955 13.2526,5.0005 L13.2526,9.1975 L16.0326,9.1975 L16.0326,11.1975 L13.2526,11.1975 L13.2526,37.5985 Z M18.9726,39.5985 L22.6736,39.5985 L22.6736,37.5985 L18.9726,37.5985 L18.9726,39.5985 Z M25.5086,39.5985 L29.2876,39.5985 L29.2876,37.5985 L25.5086,37.5985 L25.5086,39.5985 Z M18.9726,11.1975 L22.6736,11.1975 L22.6736,9.1975 L18.9726,9.1975 L18.9726,11.1975 Z M25.5086,11.1975 L29.2876,11.1975 L29.2876,9.1975 L25.5086,9.1975 L25.5086,11.1975 Z" id="Amazon-IOT-RESOURCES-Device-Gateway_Resource-Icon_light-bg" fill="#7AA116"></path>
    </g>
</svg>`, M_ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/IoT/Res_AWS-IoT_Thing_Cart_48</title>
    <g id="Icon-Resource/IoT/Res_AWS-IoT_Thing_Cart_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M31.2597,27.3672 L19.0397,27.3672 L16.0777,17.9412 L34.2207,17.9412 L31.2597,27.3672 Z M32.6407,33.6402 C32.6407,34.3012 32.1037,34.8382 31.4437,34.8382 C30.7827,34.8382 30.2457,34.3012 30.2457,33.6402 C30.2457,32.9802 30.7827,32.4432 31.4437,32.4432 C32.1037,32.4432 32.6407,32.9802 32.6407,33.6402 Z M17.9417,33.6402 C17.9417,32.9802 18.4787,32.4432 19.1387,32.4432 C19.7987,32.4432 20.3357,32.9802 20.3357,33.6402 C20.3357,34.3012 19.7987,34.8382 19.1387,34.8382 C18.4787,34.8382 17.9417,34.3012 17.9417,33.6402 Z M15.9597,15.9412 L15.3737,13.6432 C15.1967,13.0002 14.6437,12.5162 14.0207,12.4372 L11.0667,11.5862 L10.5117,13.5082 L13.4947,14.3672 L14.1017,16.7452 C13.9007,17.0982 13.8447,17.5092 13.9687,17.9012 L17.2317,28.2832 C17.4357,28.9312 18.0507,29.3672 18.7617,29.3672 L19.7187,29.3672 L19.1927,30.4492 C19.1737,30.4482 19.1567,30.4432 19.1387,30.4432 C17.3757,30.4432 15.9417,31.8782 15.9417,33.6402 C15.9417,35.4032 17.3757,36.8382 19.1387,36.8382 C20.5497,36.8382 21.7377,35.9122 22.1597,34.6402 L28.4217,34.6402 C28.8447,35.9122 30.0317,36.8382 31.4437,36.8382 C33.2057,36.8382 34.6407,35.4032 34.6407,33.6402 C34.6407,31.8782 33.2057,30.4432 31.4437,30.4432 C30.0317,30.4432 28.8447,31.3692 28.4217,32.6402 L22.1597,32.6402 C21.9577,32.0332 21.5827,31.5102 21.0877,31.1252 L21.9437,29.3672 L31.5367,29.3672 C32.2487,29.3672 32.8637,28.9312 33.0687,28.2832 L36.3297,17.9012 C36.4717,17.4522 36.3907,16.9742 36.1097,16.5912 C35.8117,16.1842 35.3217,15.9412 34.7997,15.9412 L15.9597,15.9412 Z M39.6697,38.5372 C39.6697,39.1632 39.1607,39.6722 38.5347,39.6722 L9.4087,39.6722 C8.7827,39.6722 8.2747,39.1632 8.2747,38.5372 L8.2747,9.4242 C8.2747,8.7982 8.7827,8.2892 9.4087,8.2892 L38.5347,8.2892 C39.1607,8.2892 39.6697,8.7982 39.6697,9.4242 L39.6697,38.5372 Z M45.9457,14.4262 L45.9457,12.4262 L41.6697,12.4262 L41.6697,9.4242 C41.6697,7.6952 40.2637,6.2892 38.5347,6.2892 L35.5197,6.2892 L35.5197,2.0002 L33.5197,2.0002 L33.5197,6.2892 L30.2457,6.2892 L30.2457,2.0002 L28.2457,2.0002 L28.2457,6.2892 L24.9727,6.2892 L24.9727,2.0002 L22.9727,2.0002 L22.9727,6.2892 L19.6987,6.2892 L19.6987,2.0002 L17.6987,2.0002 L17.6987,6.2892 L14.4257,6.2892 L14.4257,2.0002 L12.4257,2.0002 L12.4257,6.2892 L9.4087,6.2892 C7.6807,6.2892 6.2747,7.6952 6.2747,9.4242 L6.2747,12.4262 L1.9997,12.4262 L1.9997,14.4262 L6.2747,14.4262 L6.2747,17.6992 L1.9997,17.6992 L1.9997,19.6992 L6.2747,19.6992 L6.2747,22.9722 L1.9997,22.9722 L1.9997,24.9722 L6.2747,24.9722 L6.2747,28.2462 L1.9997,28.2462 L1.9997,30.2462 L6.2747,30.2462 L6.2747,33.5192 L1.9997,33.5192 L1.9997,35.5192 L6.2747,35.5192 L6.2747,38.5372 C6.2747,40.2652 7.6807,41.6722 9.4087,41.6722 L12.4257,41.6722 L12.4257,45.9452 L14.4257,45.9452 L14.4257,41.6722 L17.6987,41.6722 L17.6987,45.9452 L19.6987,45.9452 L19.6987,41.6722 L22.9727,41.6722 L22.9727,45.9452 L24.9727,45.9452 L24.9727,41.6722 L28.2457,41.6722 L28.2457,45.9452 L30.2457,45.9452 L30.2457,41.6722 L33.5197,41.6722 L33.5197,45.9452 L35.5197,45.9452 L35.5197,41.6722 L38.5347,41.6722 C40.2637,41.6722 41.6697,40.2652 41.6697,38.5372 L41.6697,35.5192 L45.9457,35.5192 L45.9457,33.5192 L41.6697,33.5192 L41.6697,30.2462 L45.9457,30.2462 L45.9457,28.2462 L41.6697,28.2462 L41.6697,24.9722 L45.9457,24.9722 L45.9457,22.9722 L41.6697,22.9722 L41.6697,19.6992 L45.9457,19.6992 L45.9457,17.6992 L41.6697,17.6992 L41.6697,14.4262 L45.9457,14.4262 Z" id="Amazon-IOT-RESOURCES-IoT-thing-cart_Resource-Icon_light-bg" fill="#7AA116"></path>
    </g>
</svg>`, R_ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Machine-Learning/Res_Amazon-Rekognition_Video_48</title>
    <g id="Icon-Resource/Machine-Learning/Res_Amazon-Rekognition_Video_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M27.2689,22.2744 L24.1519,20.4934 L24.1519,24.0554 L27.2689,22.2744 Z M30.2849,22.2744 C30.2849,22.6324 30.0919,22.9644 29.7809,23.1424 L23.6479,26.6474 C23.4949,26.7354 23.3229,26.7794 23.1519,26.7794 C22.9779,26.7794 22.8049,26.7344 22.6499,26.6444 C22.3409,26.4644 22.1519,26.1354 22.1519,25.7794 L22.1519,18.7703905 C22.1519,18.4144 22.3409,18.0854 22.6499,17.9054 C22.9569,17.7274 23.3379,17.7244 23.6479,17.9024 L29.7809,21.4064 C30.0919,21.5844 30.2849,21.9154 30.2849,22.2744 L30.2849,22.2744 Z M19.7709,28.2834 L31.7889,28.2834 L31.7889,16.2654 L19.7709,16.2654 L19.7709,28.2834 Z M17.7709,29.2834 L17.7709,15.2654 C17.7709,14.7124 18.2179,14.2654 18.7709,14.2654 L32.7889,14.2654 C33.3409,14.2654 33.7889,14.7124 33.7889,15.2654 L33.7889,29.2834 C33.7889,29.8364 33.3409,30.2834 32.7889,30.2834 L18.7709,30.2834 C18.2179,30.2834 17.7709,29.8364 17.7709,29.2834 L17.7709,29.2834 Z M17.0979,34.5004 C15.7279,33.5234 14.5309,32.3254 13.5549,30.9544 L4.7329,39.7774 C4.2599,40.2504 3.9999,40.8784 3.9999,41.5484 C3.9999,42.2194 4.2599,42.8484 4.7329,43.3214 C5.6779,44.2664 7.3319,44.2664 8.2779,43.3214 L17.0979,34.5004 Z M12.7709,22.2744 C12.7709,29.4534 18.6109,35.2934 25.7889,35.2934 C32.9659,35.2934 38.8059,29.4534 38.8059,22.2744 C38.8059,15.0964 32.9659,9.2564 25.7889,9.2564 C18.6109,9.2564 12.7709,15.0964 12.7709,22.2744 L12.7709,22.2744 Z M18.8469,35.5794 L9.6919,44.7354 C8.8419,45.5864 7.7099,46.0534 6.5049,46.0534 C5.2999,46.0534 4.1679,45.5854 3.3189,44.7354 C2.4689,43.8854 1.9999,42.7544 1.9999,41.5484 C1.9999,40.3434 2.4689,39.2124 3.3189,38.3634 L12.4779,29.2034 C11.3929,27.1284 10.7709,24.7744 10.7709,22.2744 C10.7709,13.9944 17.5079,7.2564 25.7889,7.2564 C34.0689,7.2564 40.8059,13.9944 40.8059,22.2744 C40.8059,30.5554 34.0689,37.2934 25.7889,37.2934 C23.2839,37.2934 20.9249,36.6684 18.8469,35.5794 L18.8469,35.5794 Z M9.4219,30.4014 C8.1559,27.8874 7.5139,25.1534 7.5139,22.2744 C7.5139,19.1394 8.3209,16.0494 9.8469,13.3374 L8.1049,12.3574 C6.4099,15.3684 5.5139,18.7964 5.5139,22.2744 C5.5139,25.4234 6.2479,28.5454 7.6349,31.3014 L9.4219,30.4014 Z M46.0629,22.2744 C46.0629,33.4544 36.9679,42.5484 25.7889,42.5484 C22.6119,42.5484 19.5709,41.8364 16.7479,40.4294 L17.6399,38.6384 C20.1829,39.9064 22.9239,40.5484 25.7889,40.5484 C35.8649,40.5484 44.0629,32.3504 44.0629,22.2744 C44.0629,12.1984 35.8649,4.0004 25.7889,4.0004 C23.2569,4.0004 20.8099,4.5084 18.5139,5.5104 L17.7129,3.6784 C20.2629,2.5644 22.9799,2.0004 25.7889,2.0004 C36.9679,2.0004 46.0629,11.0944 46.0629,22.2744 L46.0629,22.2744 Z" id="Amazon-Rekognition_Amazon-Rekognition-video_Resource-Icon_light-bg" fill="#01A88D"></path>
    </g>
</svg>`, y_ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Machine-Learning/Res_Amazon-SageMaker_Model_48</title>
    <g id="Icon-Resource/Machine-Learning/Res_Amazon-SageMaker_Model_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M29.9559,29.8297 C29.9559,30.3157 29.5599,30.7117 29.0749,30.7117 C28.5889,30.7117 28.1929,30.3157 28.1929,29.8297 C28.1929,29.3447 28.5889,28.9487 29.0749,28.9487 C29.5599,28.9487 29.9559,29.3447 29.9559,29.8297 L29.9559,29.8297 Z M32.8379,11.8947 C32.3519,11.8947 31.9559,11.4997 31.9559,11.0137 C31.9559,10.5267 32.3519,10.1317 32.8379,10.1317 C33.3239,10.1317 33.7199,10.5267 33.7199,11.0137 C33.7199,11.4997 33.3239,11.8947 32.8379,11.8947 L32.8379,11.8947 Z M29.4189,20.6907 C29.4189,21.1767 29.0229,21.5717 28.5369,21.5717 C28.0509,21.5717 27.6549,21.1767 27.6549,20.6907 C27.6549,20.2047 28.0509,19.8087 28.5369,19.8087 C29.0229,19.8087 29.4189,20.2047 29.4189,20.6907 L29.4189,20.6907 Z M34.1059,36.2817 C34.1059,35.7957 34.5019,35.3997 34.9879,35.3997 C35.4749,35.3997 35.8699,35.7957 35.8699,36.2817 C35.8699,36.7667 35.4749,37.1627 34.9879,37.1627 C34.5019,37.1627 34.1059,36.7667 34.1059,36.2817 L34.1059,36.2817 Z M38.5299,31.3027 C38.2149,31.4787 38.0199,31.8117 38.0199,32.1737 L38.0199,38.3647 L30.8809,42.5867 L30.8809,37.5507 L32.4139,37.5507 C32.8859,38.5017 33.8559,39.1627 34.9879,39.1627 C36.5769,39.1627 37.8699,37.8707 37.8699,36.2817 C37.8699,34.6927 36.5769,33.3997 34.9879,33.3997 C33.6539,33.3997 32.5379,34.3167 32.2119,35.5507 L29.8809,35.5507 C29.3279,35.5507 28.8809,35.9977 28.8809,36.5507 L28.8809,43.7687 L28.4759,44.0087 L24.9679,41.9757 L24.9679,16.0457 L27.8059,16.0457 L27.8059,17.9147 C26.5719,18.2407 25.6549,19.3557 25.6549,20.6907 C25.6549,22.2797 26.9479,23.5717 28.5369,23.5717 C30.1259,23.5717 31.4189,22.2797 31.4189,20.6907 C31.4189,19.5587 30.7569,18.5877 29.8059,18.1167 L29.8059,16.0457 L33.1059,16.0457 C33.6589,16.0457 34.1059,15.5987 34.1059,15.0457 L34.1059,13.5877 C35.0579,13.1167 35.7199,12.1447 35.7199,11.0137 C35.7199,9.4247 34.4269,8.1317 32.8379,8.1317 C31.2489,8.1317 29.9559,9.4247 29.9559,11.0137 C29.9559,12.3487 30.8729,13.4637 32.1059,13.7897 L32.1059,14.0457 L24.9679,14.0457 L24.9679,6.8037 L29.3659,4.1697 L38.5579,9.7737 L38.5589,15.9377 C38.5589,16.2987 38.7519,16.6307 39.0649,16.8087 L43.9339,19.5687 L43.9349,22.6467 L34.7199,22.6467 C34.1669,22.6467 33.7199,23.0947 33.7199,23.6467 L33.7199,28.5607 L31.6489,28.5607 C31.1779,27.6097 30.2069,26.9487 29.0749,26.9487 C27.4859,26.9487 26.1929,28.2407 26.1929,29.8297 C26.1929,31.4187 27.4859,32.7117 29.0749,32.7117 C30.4099,32.7117 31.5239,31.7947 31.8509,30.5607 L34.7199,30.5607 C35.2719,30.5607 35.7199,30.1137 35.7199,29.5607 L35.7199,24.6467 L43.9349,24.6467 L43.9349,28.2597 L38.5299,31.3027 Z M17.2469,28.4107 C17.7329,28.4107 18.1289,28.8067 18.1289,29.2927 C18.1289,29.7787 17.7329,30.1747 17.2469,30.1747 C16.7609,30.1747 16.3649,29.7787 16.3649,29.2927 C16.3649,28.8067 16.7609,28.4107 17.2469,28.4107 L17.2469,28.4107 Z M15.8279,12.6267 C15.8279,12.1407 16.2239,11.7447 16.7099,11.7447 C17.1949,11.7447 17.5909,12.1407 17.5909,12.6267 C17.5909,13.1127 17.1949,13.5087 16.7099,13.5087 C16.2239,13.5087 15.8279,13.1127 15.8279,12.6267 L15.8279,12.6267 Z M12.2149,20.6907 C12.2149,21.1767 11.8189,21.5717 11.3329,21.5717 C10.8479,21.5717 10.4519,21.1767 10.4519,20.6907 C10.4519,20.2047 10.8479,19.8087 11.3329,19.8087 C11.8189,19.8087 12.2149,20.2047 12.2149,20.6907 L12.2149,20.6907 Z M17.4399,37.8937 C17.4399,37.4077 17.8359,37.0127 18.3219,37.0127 C18.8089,37.0127 19.2039,37.4077 19.2039,37.8937 C19.2039,38.3807 18.8089,38.7757 18.3219,38.7757 C17.8359,38.7757 17.4399,38.3807 17.4399,37.8937 L17.4399,37.8937 Z M18.9119,44.0027 L9.3759,38.3627 L9.3769,32.1727 C9.3769,31.8087 9.1789,31.4727 8.8589,31.2967 L8.5009,31.0997 L11.1399,31.0997 L11.1399,38.1627 C11.1399,38.7157 11.5869,39.1627 12.1399,39.1627 L15.7479,39.1627 C16.2189,40.1137 17.1899,40.7757 18.3219,40.7757 C19.9109,40.7757 21.2039,39.4827 21.2039,37.8937 C21.2039,36.3057 19.9109,35.0127 18.3219,35.0127 C16.9879,35.0127 15.8719,35.9297 15.5459,37.1627 L13.1399,37.1627 L13.1399,30.0997 C13.1399,29.5467 12.6919,29.0997 12.1399,29.0997 L4.8639,29.0997 L4.0009,28.6247 L3.9999,19.5677 L8.8689,16.8067 C9.1829,16.6287 9.3759,16.2967 9.3759,15.9357 L9.3769,13.3567 L10.6019,13.3567 L10.6019,17.9147 C9.3689,18.2407 8.4519,19.3557 8.4519,20.6907 C8.4519,22.2797 9.7439,23.5717 11.3329,23.5717 C12.9219,23.5717 14.2149,22.2797 14.2149,20.6907 C14.2149,19.5597 13.5539,18.5887 12.6019,18.1167 L12.6019,13.3567 L13.9339,13.3567 C14.2599,14.5917 15.3749,15.5087 16.7099,15.5087 C18.2989,15.5087 19.5909,14.2157 19.5909,12.6267 C19.5909,11.0377 18.2989,9.7447 16.7099,9.7447 C15.5789,9.7447 14.6069,10.4057 14.1359,11.3567 L9.3769,11.3567 L9.3769,9.7717 L18.5679,4.1687 L22.9679,6.8027 L22.9679,18.3467 L16.9779,18.3467 C16.4259,18.3467 15.9779,18.7937 15.9779,19.3467 L15.9779,26.7187 C15.0269,27.1887 14.3649,28.1607 14.3649,29.2927 C14.3649,30.8817 15.6579,32.1747 17.2469,32.1747 C18.8359,32.1747 20.1289,30.8817 20.1289,29.2927 C20.1289,27.9577 19.2119,26.8427 17.9779,26.5167 L17.9779,20.3467 L22.9679,20.3467 L22.9679,41.5897 L18.9119,44.0027 Z M45.9339,18.9867 C45.9339,18.6267 45.7399,18.2947 45.4269,18.1167 L40.5589,15.3557 L40.5579,9.2127 C40.5579,8.8637 40.3759,8.5407 40.0779,8.3587 L29.8919,2.1477 C29.5739,1.9547 29.1769,1.9517 28.8569,2.1427 L23.9689,5.0697 L19.0769,2.1427 C18.7569,1.9507 18.3589,1.9527 18.0429,2.1467 L7.8559,8.3567 C7.5589,8.5387 7.3769,8.8617 7.3769,9.2107 L7.3759,15.3537 L2.5069,18.1157 C2.1929,18.2937 1.9999,18.6257 1.9999,18.9857 L2.0009,29.2157 C2.0009,29.5807 2.1989,29.9157 2.5179,30.0917 L7.3769,32.7637 L7.3759,38.9337 C7.3759,39.2867 7.5619,39.6137 7.8669,39.7937 L18.4049,46.0257 C18.7209,46.2127 19.1099,46.2127 19.4259,46.0247 L23.6399,43.5177 L27.9789,46.0317 C28.1339,46.1217 28.3079,46.1667 28.4799,46.1667 C28.6559,46.1667 28.8319,46.1197 28.9889,46.0267 L39.5289,39.7957 C39.8339,39.6157 40.0199,39.2887 40.0199,38.9347 L40.0199,32.7587 L45.4249,29.7157 C45.7399,29.5387 45.9349,29.2057 45.9349,28.8447 L45.9339,18.9867 Z" id="Amazon-Machine-Learning_Model-Icon_light-bg" fill="#01A88D"></path>
    </g>
</svg>`, A_ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Machine-Learning/Res_Amazon-Textract_Analyze-Lending_48</title>
    <g id="Icon-Resource/Machine-Learning/Res_Amazon-Textract_Analyze-Lending_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M12,34 C16.411,34 20,30.411 20,26 C20,21.589 16.411,18 12,18 C7.589,18 4,21.589 4,26 C4,30.411 7.589,34 12,34 L12,34 Z M20.338,31.509 C19.594,32.63 18.631,33.593 17.509,34.337 L22.586,39.414 C23.342,40.169 24.658,40.169 25.414,39.414 C25.792,39.036 26,38.534 26,38 C26,37.466 25.792,36.963 25.414,36.585 L20.338,31.509 Z M12,36 C6.486,36 2,31.514 2,26 C2,20.486 6.486,16 12,16 C17.514,16 22,20.486 22,26 C22,27.287 21.747,28.514 21.302,29.645 L26.828,35.171 C27.584,35.927 28,36.932 28,38 C28,39.068 27.584,40.073 26.828,40.828 C26.073,41.583 25.068,42 24,42 C22.932,42 21.927,41.583 21.172,40.828 L15.646,35.302 C14.514,35.747 13.287,36 12,36 L12,36 Z M29,26 L36,26 L36,24 L29,24 L29,26 Z M24,21 L36,21 L36,19 L24,19 L24,21 Z M30,36 L36,36 L36,34 L30,34 L30,36 Z M27,31 L36,31 L36,29 L27,29 L27,31 Z M34,14 L37.586,14 L34,10.414 L34,14 Z M40.707,14.293 C40.895,14.48 41,14.735 41,15 L41,45 C41,45.552 40.553,46 40,46 L12,46 C11.447,46 11,45.552 11,45 L11,38 L13,38 L13,44 L39,44 L39,16 L33,16 C32.447,16 32,15.552 32,15 L32,9 L13,9 L13,14 L11,14 L11,8 C11,7.448 11.447,7 12,7 L33,7 C33.266,7 33.52,7.105 33.707,7.293 L40.707,14.293 Z M46,12 L46,40 C46,40.552 45.553,41 45,41 L43,41 L43,39 L44,39 L44,12.414 L35.586,4 L18,4 L18,5 L16,5 L16,3 C16,2.448 16.447,2 17,2 L36,2 C36.266,2 36.52,2.105 36.707,2.293 L45.707,11.293 C45.895,11.48 46,11.735 46,12 L46,12 Z" id="Fill-1" fill="#01A88D"></path>
    </g>
</svg>`, Z_ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Machine-Learning/Res_Amazon-SageMaker_Shadow-Testing_48</title>
    <g id="Icon-Resource/Machine-Learning/Res_Amazon-SageMaker_Shadow-Testing_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M24,36.5859 L20.707,33.2929 L19.293,34.7069 L23.293,38.7069 C23.488,38.9019 23.744,38.9999 24,38.9999 C24.256,38.9999 24.512,38.9019 24.707,38.7069 L32.707,30.7069 L31.293,29.2929 L24,36.5859 Z M43.587,40.4329 L31.162,22.5709 C31.046,22.4029 30.983,22.2039 30.983,21.9999 L30.983,6.9999 C30.983,6.4479 31.431,5.9999 31.983,5.9999 L32,5.9999 C32.552,5.9999 33,5.5509 33,4.9999 C33,4.4489 32.552,3.9999 32,3.9999 L22,3.9999 C21.448,3.9999 21,4.4489 21,4.9999 C21,5.5509 21.448,5.9999 22,5.9999 C22.553,5.9999 23,6.4479 23,6.9999 L23,21.9999 C23,22.2039 22.938,22.4029 22.821,22.5709 L10.396,40.4329 C9.903,41.1399 9.849,42.0179 10.247,42.7809 C10.646,43.5439 11.398,43.9999 12.26,43.9999 L41.724,43.9999 C42.585,43.9999 43.337,43.5439 43.736,42.7809 C44.135,42.0179 44.079,41.1399 43.587,40.4329 L43.587,40.4329 Z M8.275,40.2099 C8.397,39.8909 8.552,39.5809 8.753,39.2909 L14,31.7489 L14,8.9999 C14,8.4479 14.447,7.9999 15,7.9999 C15.552,7.9999 16,7.5509 16,6.9999 C16,6.4489 15.552,5.9999 15,5.9999 L5,5.9999 C4.448,5.9999 4,6.4489 4,6.9999 C4,7.5509 4.448,7.9999 5,7.9999 C5.553,7.9999 6,8.4479 6,8.9999 L6,37.2029 C6,38.6019 6.948,39.8279 8.275,40.2099 L8.275,40.2099 Z M45.509,43.7069 C44.77,45.1219 43.319,45.9999 41.724,45.9999 L12.26,45.9999 C10.664,45.9999 9.214,45.1219 8.475,43.7079 C8.227,43.2339 8.083,42.7289 8.024,42.2189 C5.691,41.7029 4,39.5979 4,37.2029 L4,9.8289 C2.836,9.4159 2,8.3039 2,6.9999 C2,5.3459 3.346,3.9999 5,3.9999 L15,3.9999 C16.654,3.9999 18,5.3459 18,6.9999 C18,8.3039 17.164,9.4159 16,9.8289 L16,28.8739 L21,21.6869 L21,7.8289 C19.836,7.4159 19,6.3039 19,4.9999 C19,3.3459 20.346,1.9999 22,1.9999 L32,1.9999 C33.654,1.9999 35,3.3459 35,4.9999 C35,6.3099 34.156,7.4259 32.983,7.8349 L32.983,21.6869 L45.229,39.2909 C46.141,40.6009 46.248,42.2929 45.509,43.7069 L45.509,43.7069 Z M7.009,22.5909 L8.593,21.0069 L7.009,19.4219 L8.423,18.0079 L10.007,19.5929 L11.591,18.0079 L13.005,19.4219 L11.421,21.0069 L13.005,22.5909 L11.591,24.0049 L10.007,22.4209 L8.423,24.0049 L7.009,22.5909 Z" id="Fill-1" fill="#01A88D"></path>
    </g>
</svg>`, k_ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Machine-Learning/Res_Amazon-DevOps-Guru_Insights_48</title>
    <g id="Icon-Resource/Machine-Learning/Res_Amazon-DevOps-Guru_Insights_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M25.439,46.165 C25.782,45.997 26,45.648 26,45.267 L26,38 L42.067,38 C44.235,38 46,36.239 46,34.074 L46,26.845 L44,26.845 L44,34.074 C44,35.136 43.133,36 42.067,36 L25,36 C24.447,36 24,36.448 24,37 L24,43.223 L14.98,36.211 C14.805,36.075 14.588,36 14.366,36 L5.973,36 C4.885,36 4,35.158 4,34.123 L4,13.878 C4,12.843 4.885,12 5.973,12 L16.585,12 L16.585,10 L5.973,10 C3.782,10 2,11.74 2,13.878 L2,34.123 C2,36.261 3.782,38 5.973,38 L14.023,38 L24.386,46.056 C24.564,46.195 24.781,46.267 25,46.267 C25.149,46.267 25.299,46.233 25.439,46.165 L25.439,46.165 Z M6,17 L13,17 L13,15 L6,15 L6,17 Z M6,25 L17,25 L17,23 L6,23 L6,25 Z M6,29 L17,29 L17,27 L6,27 L6,29 Z M6,33 L23,33 L23,31 L6,31 L6,33 Z M29.943,27.823 C29.971,27.335 29.642,26.899 29.165,26.791 C27.998,26.526 26.891,26.067 25.876,25.426 C25.462,25.164 24.921,25.241 24.596,25.606 L23.809,26.488 L21.512,24.191 L22.394,23.405 C22.758,23.08 22.835,22.539 22.574,22.125 C21.934,21.111 21.476,20.004 21.213,18.836 C21.106,18.359 20.681,18.036 20.181,18.057 L19,18.125 L19,14.876 L20.185,14.944 C20.681,14.979 21.109,14.643 21.217,14.166 C21.481,13.002 21.94,11.897 22.58,10.884 C22.841,10.47 22.766,9.929 22.401,9.603 L21.512,8.81 L23.809,6.513 L24.602,7.401 C24.926,7.765 25.467,7.841 25.881,7.581 C26.894,6.942 27.999,6.485 29.165,6.222 C29.642,6.114 29.971,5.677 29.943,5.189 L29.875,4 L33.124,4 L33.056,5.191 C33.028,5.679 33.357,6.115 33.834,6.223 C34.998,6.486 36.102,6.944 37.115,7.583 C37.529,7.844 38.069,7.768 38.395,7.403 L39.189,6.513 L41.487,8.81 L40.601,9.601 C40.235,9.926 40.16,10.468 40.421,10.881 C41.061,11.894 41.519,12.999 41.783,14.166 C41.892,14.643 42.323,14.979 42.815,14.944 L44,14.876 L44,18.125 L42.817,18.057 C42.317,18.033 41.892,18.358 41.784,18.836 C41.522,20.002 41.064,21.108 40.423,22.123 C40.163,22.536 40.239,23.077 40.604,23.402 L41.487,24.191 L39.19,26.488 L38.405,25.608 C38.08,25.243 37.538,25.165 37.125,25.429 C36.111,26.069 35.004,26.527 33.835,26.791 C33.357,26.899 33.028,27.336 33.056,27.824 L33.124,29 L29.876,29 L29.943,27.823 Z M34.91,30.687 C35.099,30.487 35.197,30.218 35.181,29.943 L35.1,28.526 C35.918,28.282 36.707,27.956 37.457,27.55 L38.402,28.609 C38.585,28.815 38.845,28.936 39.12,28.943 C39.386,28.953 39.661,28.845 39.856,28.651 L43.65,24.856 C43.845,24.662 43.95,24.396 43.942,24.121 C43.935,23.846 43.814,23.586 43.608,23.403 L42.545,22.454 C42.95,21.704 43.276,20.916 43.52,20.101 L44.942,20.182 C45.212,20.19 45.486,20.1 45.686,19.911 C45.886,19.722 46,19.458 46,19.184 L46,13.817 C46,13.542 45.886,13.279 45.686,13.09 C45.486,12.902 45.221,12.807 44.942,12.819 L43.518,12.9 C43.273,12.084 42.947,11.298 42.543,10.549 L43.608,9.598 C43.814,9.415 43.935,9.155 43.942,8.88 C43.95,8.605 43.845,8.339 43.65,8.144 L39.856,4.351 C39.661,4.156 39.384,4.038 39.12,4.058 C38.845,4.066 38.585,4.186 38.402,4.392 L37.447,5.462 C36.698,5.057 35.913,4.732 35.1,4.488 L35.181,3.057 C35.197,2.783 35.099,2.514 34.91,2.314 C34.721,2.114 34.458,2 34.183,2 L28.816,2 C28.542,2 28.278,2.114 28.089,2.314 C27.9,2.514 27.802,2.783 27.818,3.057 L27.899,4.487 C27.085,4.73 26.299,5.056 25.55,5.459 L24.597,4.392 C24.414,4.186 24.154,4.066 23.879,4.058 C23.6,4.04 23.338,4.156 23.144,4.351 L19.349,8.144 C19.155,8.339 19.049,8.605 19.057,8.88 C19.064,9.155 19.185,9.415 19.39,9.598 L20.459,10.551 C20.053,11.3 19.727,12.086 19.483,12.9 L18.057,12.819 C17.78,12.801 17.513,12.901 17.313,13.09 C17.113,13.279 17,13.542 17,13.817 L17,19.184 C17,19.458 17.113,19.722 17.313,19.911 C17.513,20.1 17.786,20.203 18.057,20.182 L19.478,20.101 C19.721,20.918 20.047,21.706 20.452,22.457 L19.391,23.403 C19.185,23.586 19.064,23.846 19.057,24.121 C19.049,24.396 19.154,24.662 19.349,24.856 L23.144,28.651 C23.337,28.845 23.597,28.95 23.879,28.943 C24.154,28.936 24.414,28.815 24.597,28.609 L25.544,27.548 C26.295,27.954 27.083,28.281 27.899,28.525 L27.818,29.943 C27.802,30.218 27.9,30.487 28.089,30.687 C28.278,30.887 28.542,31 28.816,31 L34.183,31 C34.458,31 34.721,30.887 34.91,30.687 L34.91,30.687 Z M30.845,19.748 L35.926,14.667 L34.512,13.253 L30.138,17.627 L28.487,15.976 L27.073,17.39 L29.431,19.748 C29.619,19.936 29.873,20.041 30.138,20.041 C30.403,20.041 30.658,19.936 30.845,19.748 L30.845,19.748 Z M41.314,15.64 L40.198,16.236 C40.071,12.033 36.911,8.413 32.61,7.859 C28.888,7.376 25.293,9.326 23.658,12.699 L25.458,13.571 C26.717,10.972 29.487,9.473 32.356,9.843 C35.439,10.239 37.761,12.684 38.148,15.631 L37.707,15.195 L36.302,16.619 L38.909,19.191 L42.256,17.404 L41.314,15.64 Z M39.341,20.301 C37.872,23.335 34.814,25.213 31.508,25.213 C31.138,25.213 30.764,25.19 30.389,25.142 C26.088,24.588 22.928,20.968 22.801,16.765 L21.685,17.361 L20.743,15.597 L24.09,13.81 L26.697,16.382 L25.293,17.806 L24.851,17.37 C25.238,20.317 27.56,22.762 30.644,23.158 C33.51,23.528 36.283,22.028 37.542,19.429 L39.341,20.301 Z" id="Fill-1" fill="#01A88D"></path>
    </g>
</svg>`, T_ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Machine-Learning/Res_Amazon-SageMaker_Notebook_48</title>
    <g id="Icon-Resource/Machine-Learning/Res_Amazon-SageMaker_Notebook_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M7.972,2 L7.972,7.206 L5,7.206 L5,9.205 L7.972,9.205 L7.972,12.467 L5,12.467 L5,14.467 L7.972,14.467 L7.972,17.78 L5,17.78 L5,19.78 L7.972,19.78 L7.972,23.054 L5,23.054 L5,25.053 L7.972,25.053 L7.972,28.246 L5,28.246 L5,30.246 L7.972,30.246 L7.972,33.479 L5,33.479 L5,35.479 L7.972,35.479 L7.972,38.793 L5,38.793 L5,40.793 L7.972,40.793 L7.972,45.972 L43.586,45.972 L43.586,2 L7.972,2 Z M9.972,4 L41.586,4 L41.586,43.972 L9.972,43.972 L9.972,40.793 L13.052,40.793 L13.052,38.793 L9.972,38.793 L9.972,35.479 L13.052,35.479 L13.052,33.479 L9.972,33.479 L9.972,30.246 L13.052,30.246 L13.052,28.246 L9.972,28.246 L9.972,25.053 L13.052,25.053 L13.052,23.054 L9.972,23.054 L9.972,19.78 L13.052,19.78 L13.052,17.78 L9.972,17.78 L9.972,14.467 L13.052,14.467 L13.052,12.467 L9.972,12.467 L9.972,9.205 L13.052,9.205 L13.052,7.206 L9.972,7.206 L9.972,4 Z M16.862,9.205 L36.56,9.205 L36.56,7.205 L16.862,7.205 L16.862,9.205 Z M16.862,15.594 L36.56,15.594 L36.56,13.594 L16.862,13.594 L16.862,15.594 Z M16.862,21.927 L36.56,21.927 L36.56,19.926 L16.862,19.926 L16.862,21.927 Z M16.862,28.313 L26.764,28.313 L26.764,26.313 L16.862,26.313 L16.862,28.313 Z" id="Amazon-Machine-Learning_Notebook-Icon_light-bg" fill="#01A88D"></path>
    </g>
</svg>`, S_ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Machine-Learning/Res_Amazon-SageMaker_Canvas_48</title>
    <g id="Icon-Resource/Machine-Learning/Res_Amazon-SageMaker_Canvas_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M30.5865,31 L39.6725,39.26 L38.3275,40.74 L28.9995,32.26 L28.9995,36 L26.9995,36 L26.9995,30 C26.9995,29.448 27.4475,29 27.9995,29 L33.9995,29 L33.9995,31 L30.5865,31 Z M40.9995,22 L40.9995,33 L38.9995,33 L38.9995,23 L15.9995,23 L15.9995,40 L31.9995,40 L31.9995,42 L14.9995,42 C14.4475,42 13.9995,41.552 13.9995,41 L13.9995,22 C13.9995,21.448 14.4475,21 14.9995,21 L39.9995,21 C40.5525,21 40.9995,21.448 40.9995,22 L40.9995,22 Z M34.9995,17 L30.9995,17 L30.9995,15 L35.9995,15 C36.5525,15 36.9995,15.448 36.9995,16 L36.9995,19 L34.9995,19 L34.9995,17 Z M14.9995,17 L27.9995,17 L27.9995,15 L14.9995,15 L14.9995,17 Z M7.9995,15 L11.9995,15 L11.9995,17 L8.9995,17 L8.9995,19 L6.9995,19 L6.9995,16 C6.9995,15.448 7.4475,15 7.9995,15 L7.9995,15 Z M6.9995,27 L8.9995,27 L8.9995,22 L6.9995,22 L6.9995,27 Z M8.9995,32 L11.9995,32 L11.9995,34 L7.9995,34 C7.4475,34 6.9995,33.552 6.9995,33 L6.9995,30 L8.9995,30 L8.9995,32 Z M12.9995,8 L16.9995,8 L16.9995,6 L12.9995,6 L12.9995,8 Z M6.9995,8 L10.9995,8 L10.9995,6 L6.9995,6 L6.9995,8 Z M3.9995,44 L43.9995,44 L43.9995,12 L3.9995,12 L3.9995,44 Z M3.9995,10 L43.9995,10 L43.9995,4 L3.9995,4 L3.9995,10 Z M44.9995,2 L2.9995,2 C2.4475,2 1.9995,2.448 1.9995,3 L1.9995,45 C1.9995,45.552 2.4475,46 2.9995,46 L44.9995,46 C45.5525,46 45.9995,45.552 45.9995,45 L45.9995,3 C45.9995,2.448 45.5525,2 44.9995,2 L44.9995,2 Z" id="Fill-1" fill="#01A88D"></path>
    </g>
</svg>`, b_ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Machine-Learning/Res_Amazon-SageMaker_Train_48</title>
    <g id="Icon-Resource/Machine-Learning/Res_Amazon-SageMaker_Train_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M6.464,31.135 L26.571,31.135 L26.571,29.135 L6.464,29.135 L6.464,31.135 Z M6.464,36.724 L26.571,36.724 L26.571,34.724 L6.464,34.724 L6.464,36.724 Z M43.666,31.431 L36.481,24.245 C35.995,24.838 35.446,25.377 34.849,25.859 L42.044,33.053 C42.49,33.499 43.218,33.501 43.666,33.053 C44.113,32.606 44.113,31.878 43.666,31.431 L43.666,31.431 Z M29.252,28.241 C28.79,28.3 28.323,28.34 27.846,28.34 C25.059,28.34 22.515,27.308 20.556,25.614 L6.464,25.614 L6.464,23.614 L18.738,23.614 C18.023,22.608 17.473,21.48 17.121,20.265 L4,20.265 L4,39.968 L29.252,39.968 L29.252,28.241 Z M18.676,17.17 C18.676,22.227 22.789,26.34 27.846,26.34 C32.902,26.34 37.016,22.227 37.016,17.17 C37.016,12.114 32.902,8 27.846,8 C22.789,8 18.676,12.114 18.676,17.17 L18.676,17.17 Z M45.999,32.241 C45.999,33.084 45.673,33.874 45.08,34.467 C44.467,35.08 43.661,35.387 42.854,35.387 C42.049,35.387 41.243,35.08 40.63,34.467 L33.157,26.994 C32.554,27.322 31.916,27.592 31.252,27.805 L31.252,40.968 C31.252,41.521 30.805,41.968 30.252,41.968 L3,41.968 C2.447,41.968 2,41.521 2,40.968 L2,19.265 C2,18.712 2.447,18.265 3,18.265 L16.731,18.265 C16.696,17.905 16.676,17.539 16.676,17.17 C16.676,11.011 21.686,6 27.846,6 C34.005,6 39.016,11.011 39.016,17.17 C39.016,19.124 38.509,20.96 37.624,22.559 L45.08,30.017 C45.673,30.61 45.999,31.4 45.999,32.241 L45.999,32.241 Z M25.178,21.835 L21.769,18.973 L23.057,17.442 L25.746,19.7 L32.391,12.745 L33.837,14.126 L26.544,21.76 C26.349,21.965 26.085,22.07 25.821,22.07 C25.594,22.07 25.365,21.992 25.178,21.835 L25.178,21.835 Z" id="Amazon-Machine-Learning_Train-Icon_light-bg" fill="#01A88D"></path>
    </g>
</svg>`, E_ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Machine-Learning/Res_Amazon-SageMaker_Geospatial-ML_48</title>
    <g id="Icon-Resource/Machine-Learning/Res_Amazon-SageMaker_Geospatial-ML_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M31,35.5 C31,33.019 33.019,31 35.5,31 C37.981,31 40,33.019 40,35.5 C40,37.981 37.981,40 35.5,40 C33.019,40 31,37.981 31,35.5 L31,35.5 Z M42,35.5 C42,31.916 39.084,29 35.5,29 C31.916,29 29,31.916 29,35.5 C29,39.084 31.916,42 35.5,42 C36.932,42 38.252,41.529 39.328,40.742 L44.293,45.707 L45.707,44.293 L40.742,39.328 C41.529,38.252 42,36.932 42,35.5 L42,35.5 Z M8.646,36.795 C10.345,36.298 12.368,35.888 14.616,35.589 C15.59,38.783 16.954,41.42 18.595,43.238 C14.655,42.129 11.201,39.856 8.646,36.795 L8.646,36.795 Z M18.595,4.762 C16.954,6.58 15.589,9.217 14.616,12.411 C12.368,12.112 10.345,11.703 8.645,11.206 C11.2,8.145 14.655,5.871 18.595,4.762 L18.595,4.762 Z M39.354,11.205 C37.655,11.702 35.632,12.112 33.384,12.411 C32.41,9.217 31.046,6.58 29.405,4.762 C33.345,5.871 36.799,8.144 39.354,11.205 L39.354,11.205 Z M33.912,14.362 C36.469,14.009 38.737,13.512 40.624,12.899 C42.579,15.816 43.764,19.278 43.949,23 L34.976,23 C34.909,19.894 34.536,16.979 33.912,14.362 L33.912,14.362 Z M25,14.985 C27.409,14.956 29.733,14.827 31.905,14.6 C32.531,17.139 32.906,19.997 32.976,23 L25,23 L25,14.985 Z M13.024,25 C13.091,28.106 13.464,31.021 14.088,33.638 C11.531,33.991 9.263,34.488 7.376,35.101 C5.422,32.184 4.236,28.722 4.051,25 L13.024,25 Z M13.024,23 L4.051,23 C4.236,19.278 5.421,15.816 7.376,12.899 C9.263,13.512 11.532,14.009 14.088,14.362 C13.464,16.98 13.091,19.894 13.024,23 L13.024,23 Z M23,14.985 L23,23 L15.024,23 C15.094,19.997 15.469,17.139 16.095,14.6 C18.267,14.827 20.591,14.956 23,14.985 L23,14.985 Z M23,4.139 L23,12.984 C20.806,12.956 18.663,12.844 16.651,12.644 C18.111,8.048 20.406,4.81 23,4.139 L23,4.139 Z M25,4.139 C27.594,4.81 29.889,8.048 31.349,12.644 C29.337,12.844 27.194,12.956 25,12.984 L25,4.139 Z M23,33.015 C20.591,33.044 18.267,33.173 16.095,33.4 C15.469,30.861 15.094,28.003 15.024,25 L23,25 L23,33.015 Z M16.651,35.356 C18.663,35.156 20.806,35.044 23,35.016 L23,43.861 C20.406,43.19 18.111,39.952 16.651,35.356 L16.651,35.356 Z M25,43.955 L25,25 L43.954,25 C43.847,27.173 43.415,29.293 42.622,31.311 L44.483,32.042 C45.49,29.481 46,26.776 46,24 C46,11.869 36.131,2 24,2 C11.869,2 2,11.869 2,24 C2,36.131 11.869,46 24,46 C26.676,46 29.29,45.525 31.771,44.588 L31.064,42.717 C29.121,43.451 27.084,43.853 25,43.955 L25,43.955 Z" id="Fill-1" fill="#01A88D"></path>
    </g>
</svg>`, I_ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Machine-Learning/Res_Amazon-Rekognition_Image_48</title>
    <g id="Icon-Resource/Machine-Learning/Res_Amazon-Rekognition_Image_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M17.0609,34.4258 C15.6959,33.4518 14.5009,32.2578 13.5289,30.8918 L4.7299,39.6928 C3.7559,40.6658 3.7559,42.2508 4.7299,43.2248 C5.6709,44.1658 7.3219,44.1658 8.2629,43.2248 L17.0609,34.4258 Z M12.7489,22.2298 C12.7489,29.3888 18.5749,35.2138 25.7349,35.2138 C32.8939,35.2138 38.7189,29.3888 38.7189,22.2298 C38.7189,15.0698 32.8939,9.2438 25.7349,9.2438 C18.5749,9.2438 12.7489,15.0698 12.7489,22.2298 L12.7489,22.2298 Z M18.8099,35.5048 L9.6769,44.6388 C8.8299,45.4878 7.6999,45.9548 6.4969,45.9548 C5.2929,45.9548 4.1639,45.4878 3.3159,44.6388 C1.5619,42.8848 1.5619,40.0318 3.3159,38.2788 L12.4519,29.1408 C11.3699,27.0708 10.7489,24.7228 10.7489,22.2298 C10.7489,13.9668 17.4719,7.2438 25.7349,7.2438 C33.9979,7.2438 40.7189,13.9668 40.7189,22.2298 C40.7189,30.4918 33.9979,37.2138 25.7349,37.2138 C23.2359,37.2138 20.8829,36.5908 18.8099,35.5048 L18.8099,35.5048 Z M9.4089,30.3368 C8.1459,27.8268 7.5049,25.0998 7.5049,22.2298 C7.5049,19.1028 8.3099,16.0198 9.8319,13.3148 L8.0899,12.3338 C6.3989,15.3388 5.5049,18.7598 5.5049,22.2298 C5.5049,25.3698 6.2369,28.4848 7.6219,31.2358 L9.4089,30.3368 Z M28.7849,19.6068 C29.5079,19.6068 30.0959,19.0198 30.0959,18.2958 C30.0959,17.5718 29.5079,16.9848 28.7849,16.9848 C28.0599,16.9848 27.4729,17.5718 27.4729,18.2958 C27.4729,19.0198 28.0599,19.6068 28.7849,19.6068 L28.7849,19.6068 Z M19.7329,16.2368 L19.7329,25.6378 L24.0059,20.8588 C24.2639,20.5608 24.6529,20.4098 25.0629,20.3908 C25.4719,20.3968 25.8559,20.5828 26.1159,20.9008 L28.4549,23.7508 L31.7179,20.1548 L31.7179,16.2368 L19.7329,16.2368 Z M31.7179,28.2218 L31.7179,23.1298 L29.4649,25.6118 C29.2249,25.8988 28.8389,26.0768 28.4299,26.0768 L28.4199,26.0768 C28.0069,26.0738 27.6209,25.8888 27.3579,25.5688 L25.0229,22.7218 L20.1049,28.2218 L31.7179,28.2218 Z M17.7329,28.3078 L17.7329,16.1508 C17.7329,15.0958 18.5919,14.2368 19.6479,14.2368 L31.8039,14.2368 C32.8599,14.2368 33.7179,15.0958 33.7179,16.1508 L33.7179,28.3078 C33.7179,29.3638 32.8599,30.2218 31.8039,30.2218 L19.6479,30.2218 C18.5919,30.2218 17.7329,29.3638 17.7329,28.3078 L17.7329,28.3078 Z M45.9629,22.2298 C45.9629,33.3838 36.8889,42.4588 25.7349,42.4588 C22.5659,42.4588 19.5309,41.7468 16.7129,40.3438 L17.6059,38.5528 C20.1429,39.8178 22.8779,40.4588 25.7349,40.4588 C35.7859,40.4588 43.9629,32.2808 43.9629,22.2298 C43.9629,12.1778 35.7859,3.9998 25.7349,3.9998 C23.2099,3.9998 20.7679,4.5078 18.4779,5.5078 L17.6769,3.6748 C20.2219,2.5638 22.9329,1.9998 25.7349,1.9998 C36.8889,1.9998 45.9629,11.0748 45.9629,22.2298 L45.9629,22.2298 Z" id="Amazon-Rekognition_Amazon-Rekognition-image_Resource-Icon_light-bg" fill="#01A88D"></path>
    </g>
</svg>`, F_ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Quantum-Technologies/Res_Amazon-Braket_Embedded-Simulator_48</title>
    <g id="Icon-Resource/Quantum-Technologies/Res_Amazon-Braket_Embedded-Simulator_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M33,25.999 L35,25.999 L35,22 L33,22 L33,25.999 Z M13.001,25.999 L15.001,25.999 L15.001,22 L13.001,22 L13.001,25.999 Z M22.001,34.999 L26,34.999 L26,32.999 L22.001,32.999 L22.001,34.999 Z M22.001,15 L26,15 L26,13 L22.001,13 L22.001,15 Z M33,31.899 L35,31.899 L35,27.999 L33,27.999 L33,31.899 Z M28,34.999 L32,34.999 L32,32.999 L28,32.999 L28,34.999 Z M16.101,34.999 L20.001,34.999 L20.001,32.999 L16.101,32.999 L16.101,34.999 Z M13.001,31.999 L15.001,31.999 L15.001,27.999 L13.001,27.999 L13.001,31.999 Z M28,15 L32,15 L32,13 L28,13 L28,15 Z M33,20 L35,20 L35,16 L33,16 L33,20 Z M13.001,20 L15.001,20 L15.001,16 L13.001,16 L13.001,20 Z M16.001,15 L20.001,15 L20.001,13 L16.001,13 L16.001,15 Z M9,39 L39,39 L39,9 L9,9 L9,39 Z M46,13 L46,11 L41,11 L41,8 C41,7.448 40.553,7 40,7 L37,7 L37,2 L35,2 L35,7 L31,7 L31,2 L29,2 L29,7 L25,7 L25,2 L23,2 L23,7 L19,7 L19,2 L17,2 L17,7 L13,7 L13,2 L11,2 L11,7 L8,7 C7.447,7 7,7.448 7,8 L7,11 L2,11 L2,13 L7,13 L7,17 L2,17 L2,19 L7,19 L7,23 L2,23 L2,25 L7,25 L7,29 L2,29 L2,31 L7,31 L7,35 L2,35 L2,37 L7,37 L7,40 C7,40.552 7.447,41 8,41 L11,41 L11,46 L13,46 L13,41 L17,41 L17,46 L19,46 L19,41 L23,41 L23,46 L25,46 L25,41 L29,41 L29,46 L31,46 L31,41 L35,41 L35,46 L37,46 L37,41 L40,41 C40.553,41 41,40.552 41,40 L41,37 L46,37 L46,35 L41,35 L41,31 L46,31 L46,29 L41,29 L41,25 L46,25 L46,23 L41,23 L41,19 L46,19 L46,17 L41,17 L41,13 L46,13 Z" id="Fill-1" fill="#ED7100"></path>
    </g>
</svg>`, O_ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Quantum-Technologies/Res_Amazon-Braket_Noise-Simulator_48</title>
    <g id="Icon-Resource/Quantum-Technologies/Res_Amazon-Braket_Noise-Simulator_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M19.537,29.474 L20.086,31.397 C18.754,31.777 17.369,31.97 15.971,31.97 C13.106,31.97 10.308,31.131 7.912,29.601 L7.912,36.756 C7.912,40.074 5.936,46 2,46 L2,44 C4.232,44 5.912,39.606 5.912,36.756 L5.912,2 L7.912,2 L7.912,4.397 C10.306,2.866 13.093,2.03 15.971,2.03 C24.224,2.03 30.94,8.745 30.94,17 C30.94,17.166 30.937,17.33 30.932,17.495 L28.933,17.432 C28.937,17.288 28.94,17.144 28.94,17 C28.94,9.848 23.122,4.03 15.971,4.03 C13.03,4.03 10.199,5.035 7.912,6.853 L7.912,27.155 C10.196,28.968 13.046,29.97 15.971,29.97 C17.183,29.97 18.384,29.803 19.537,29.474 M39.287,31.337 C39.566,31.559 39.832,31.78 40.086,32 C39.832,32.221 39.566,32.441 39.287,32.663 C39.292,32.442 39.3,32.221 39.3,32 C39.3,31.777 39.291,31.558 39.287,31.337 M36.785,37.717 C36.465,37.605 36.141,37.486 35.814,37.356 C36.007,37.25 36.2,37.147 36.392,37.036 C36.583,36.926 36.771,36.808 36.96,36.695 C36.907,37.047 36.849,37.387 36.785,37.717 M33.484,44 C32.583,44 31.448,42.424 30.651,39.68 C31.574,39.365 32.524,38.978 33.482,38.537 C34.445,38.981 35.394,39.362 36.319,39.677 C35.521,42.422 34.386,44 33.484,44 M30.01,36.695 C30.199,36.808 30.385,36.925 30.577,37.036 C30.772,37.149 30.969,37.252 31.164,37.361 C30.834,37.491 30.509,37.611 30.185,37.724 C30.122,37.392 30.062,37.049 30.01,36.695 M26.873,32 C27.134,31.776 27.403,31.552 27.683,31.33 C27.678,31.554 27.67,31.778 27.67,32 C27.67,32.223 27.678,32.447 27.683,32.671 C27.403,32.449 27.134,32.225 26.873,32 M23.093,26 C23.405,25.457 24.611,25.026 27.058,25.441 C27.449,25.508 27.855,25.599 28.267,25.702 C28.074,26.672 27.933,27.691 27.832,28.727 C26.966,29.341 26.148,29.974 25.41,30.62 C25.119,30.318 24.841,30.015 24.591,29.714 C23.008,27.805 22.778,26.544 23.093,26 M31.164,26.64 C30.968,26.748 30.77,26.853 30.577,26.964 C30.385,27.076 30.198,27.192 30.01,27.306 C30.062,26.952 30.122,26.609 30.185,26.277 C30.509,26.39 30.834,26.51 31.164,26.64 M37.3,32 C37.3,32.752 37.27,33.467 37.226,34.161 C36.648,34.546 36.043,34.929 35.392,35.304 C34.758,35.67 34.122,36.007 33.488,36.321 C32.85,36.006 32.211,35.67 31.577,35.304 C30.942,34.938 30.333,34.555 29.743,34.162 C29.699,33.469 29.67,32.752 29.67,32 C29.67,31.248 29.699,30.532 29.743,29.838 C30.333,29.446 30.942,29.063 31.577,28.697 C32.228,28.321 32.863,27.988 33.487,27.679 C34.121,27.994 34.758,28.33 35.392,28.697 C36.043,29.072 36.647,29.454 37.224,29.839 C37.27,30.549 37.3,31.269 37.3,32 M36.786,26.284 C36.849,26.618 36.907,26.957 36.959,27.306 C36.769,27.192 36.583,27.074 36.392,26.964 C36.2,26.853 36.006,26.75 35.812,26.643 C36.144,26.513 36.469,26.394 36.786,26.284 M43.877,26 C44.328,26.782 43.526,28.558 41.542,30.625 C40.8,29.975 39.992,29.345 39.147,28.743 C39.05,27.684 38.905,26.668 38.716,25.708 C41.493,25.026 43.427,25.22 43.877,26 M45.609,25 C44.516,23.11 41.627,22.933 38.249,23.771 C38.068,23.143 37.87,22.543 37.645,21.993 L35.794,22.748 C35.991,23.232 36.167,23.769 36.328,24.333 C35.392,24.651 34.44,25.037 33.493,25.468 C32.531,25.026 31.578,24.637 30.651,24.321 C31.448,21.577 32.583,20 33.484,20 C33.969,20 34.428,20.45 34.728,20.827 L36.293,19.581 C35.253,18.275 34.191,18 33.484,18 C31.302,18 29.704,20.416 28.74,23.76 C28.282,23.646 27.83,23.544 27.394,23.47 C23.518,22.808 21.974,23.938 21.36,25 C20.747,26.063 20.542,27.965 23.052,30.991 C23.33,31.327 23.641,31.664 23.964,32 C23.654,32.323 23.356,32.645 23.088,32.967 L24.623,34.249 C24.864,33.96 25.131,33.67 25.41,33.38 C26.148,34.027 26.965,34.661 27.832,35.274 C27.933,36.31 28.074,37.329 28.267,38.299 C27.855,38.402 27.449,38.493 27.058,38.559 C24.611,38.976 23.406,38.544 23.093,38 C22.796,37.487 23.105,36.659 23.316,36.21 L21.506,35.36 C20.673,37.133 20.967,38.318 21.36,39 C21.847,39.844 22.919,40.728 25.276,40.727 C25.891,40.727 26.593,40.667 27.394,40.531 C27.83,40.456 28.282,40.355 28.74,40.241 C29.704,43.585 31.302,46 33.484,46 C35.667,46 37.266,43.585 38.228,40.241 C38.87,40.4 39.496,40.529 40.092,40.61 L40.359,38.628 C39.836,38.557 39.278,38.44 38.702,38.296 C38.896,37.324 39.038,36.303 39.138,35.265 C39.986,34.66 40.798,34.028 41.542,33.375 C43.526,35.442 44.328,37.219 43.877,38 C43.63,38.429 42.988,38.601 42.494,38.671 L42.771,40.651 C44.466,40.413 45.25,39.622 45.609,39 C46.702,37.107 45.403,34.51 42.982,32 C45.403,29.491 46.702,26.894 45.609,25" id="Fill-1" fill="#ED7100"></path>
    </g>
</svg>`, N_ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Quantum-Technologies/Res_Amazon-Braket_Chip_48</title>
    <g id="Icon-Resource/Quantum-Technologies/Res_Amazon-Braket_Chip_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M33.131,4.08174784 C32.92,4.02674784 32.709,4.00074784 32.501,4.00074784 C31.391,4.00074784 30.375,4.74674784 30.082,5.86974784 C29.735,7.20374784 30.536,8.57074784 31.869,8.91874784 C33.205,9.26874784 34.57,8.46374784 34.918,7.13074784 C35.266,5.79674784 34.464,4.42974784 33.131,4.08174784 L33.131,4.08174784 Z M22.131,10.0817478 C21.92,10.0267478 21.709,10.0007478 21.501,10.0007478 C20.391,10.0007478 19.375,10.7467478 19.082,11.8697478 C18.735,13.2037478 19.536,14.5707478 20.869,14.9187478 C22.206,15.2667478 23.57,14.4637478 23.918,13.1307478 C24.266,11.7967478 23.464,10.4297478 22.131,10.0817478 L22.131,10.0817478 Z M16,20.4997478 C16,19.1217478 14.879,17.9997478 13.5,17.9997478 C12.121,17.9997478 11,19.1217478 11,20.4997478 C11,21.8787478 12.121,22.9997478 13.5,22.9997478 C14.879,22.9997478 16,21.8787478 16,20.4997478 L16,20.4997478 Z M12,15.9997478 L12,16.2767478 C12.472,16.1087478 12.972,15.9997478 13.5,15.9997478 C14.228,15.9997478 14.904,16.1897478 15.514,16.4977478 C15.725,16.2807478 15.932,16.0637478 16.148,15.8487478 C16.6,15.3967478 17.057,14.9727478 17.513,14.5407478 C17.027,13.5917478 16.858,12.4757478 17.147,11.3657478 C17.18,11.2367478 17.238,11.1237478 17.282,10.9997478 L12,10.9997478 L12,15.9997478 Z M9,31.4997478 C9,30.1217478 7.879,28.9997478 6.5,28.9997478 C5.121,28.9997478 4,30.1217478 4,31.4997478 C4,32.8787478 5.121,33.9997478 6.5,33.9997478 C7.879,33.9997478 9,32.8787478 9,31.4997478 L9,31.4997478 Z M46.107,8.03374784 L44.122,8.27874784 C43.988,7.19974784 43.609,6.33974784 42.993,5.72574784 C41.781,4.51174784 39.561,4.24174784 36.701,4.91774784 C37.019,5.75974784 37.097,6.70074784 36.854,7.63474784 L36.854,7.63574784 C36.326,9.65674784 34.497,10.9997478 32.499,10.9997478 C32.124,10.9997478 31.744,10.9527478 31.365,10.8537478 C30.075,10.5177478 29.077,9.64374784 28.513,8.54074784 C28.342,8.64474784 28.172,8.74574784 28,8.85274784 L28,8.99974784 L27.758,8.99974784 C27.012,9.47274784 26.263,9.97674784 25.512,10.5107478 C25.978,11.4497478 26.138,12.5437478 25.854,13.6347478 L25.854,13.6357478 C25.326,15.6567478 23.497,16.9997478 21.499,16.9997478 C21.124,16.9997478 20.744,16.9527478 20.365,16.8537478 C19.777,16.7007478 19.247,16.4337478 18.789,16.0867478 C18.38,16.4767478 17.968,16.8567478 17.562,17.2637478 C17.391,17.4337478 17.227,17.6057478 17.059,17.7777478 C17.641,18.5367478 18,19.4727478 18,20.4997478 C18,22.9817478 15.982,24.9997478 13.5,24.9997478 C12.726,24.9997478 12.008,24.7857478 11.371,24.4397478 C10.539,25.5687478 9.762,26.6997478 9.069,27.8147478 C10.234,28.6287478 11,29.9747478 11,31.4997478 C11,33.9817478 8.982,35.9997478 6.5,35.9997478 C6.102,35.9997478 5.722,35.9317478 5.354,35.8337478 C4.492,38.9797478 4.718,41.3887478 6.024,42.6947478 C6.719,43.3897478 7.725,43.7827478 9.012,43.8617478 L8.889,45.8577478 C7.1,45.7487478 5.66,45.1597478 4.61,44.1087478 C2.684,42.1827478 2.341,38.9987478 3.562,34.8797478 C2.613,34.0547478 2,32.8537478 2,31.4997478 C2,29.0187478 4.019,26.9997478 6.5,26.9997478 C6.891,26.9997478 7.264,27.0657478 7.625,27.1597478 L7.257,26.9337478 C8.031,25.6737478 8.913,24.3937478 9.858,23.1217478 C9.827,23.0797478 9.791,23.0427478 9.762,22.9997478 L6,22.9997478 L6,20.9997478 L9.051,20.9997478 C9.032,20.8337478 9,20.6717478 9,20.4997478 C9,19.5757478 9.281,18.7157478 9.762,17.9997478 L6,17.9997478 L6,15.9997478 L10,15.9997478 L10,12.9997478 L6,12.9997478 L6,10.9997478 L10,10.9997478 L10,9.99974784 C10,9.44774784 10.447,8.99974784 11,8.99974784 L11,4.99974784 L13,4.99974784 L13,8.99974784 L16,8.99974784 L16,4.99974784 L18,4.99974784 L18,8.99974784 L18.701,8.99974784 C19.36,8.47574784 20.152,8.13774784 21,8.04074784 L21,4.99974784 L23,4.99974784 L23,8.28174784 C23.459,8.44574784 23.888,8.66074784 24.257,8.94774784 C24.838,8.53274784 25.42,8.13174784 26,7.75074784 L26,4.99974784 L28,4.99974784 L28,6.51274784 C28.006,6.50874784 28.012,6.50474784 28.018,6.50174784 C28.018,6.12574784 28.047,5.74674784 28.147,5.36574784 C28.773,2.96374784 31.236,1.52074784 33.635,2.14574784 C34.353,2.33274784 34.971,2.69874784 35.487,3.16374784 C39.455,2.05374784 42.54,2.44474784 44.407,4.31074784 C45.346,5.24874784 45.917,6.50074784 46.107,8.03374784 L46.107,8.03374784 Z M40,9.99974784 L38,9.99974784 L38,36.9997478 L12,36.9997478 L12,35.9997478 L10,35.9997478 L10,37.9997478 C10,38.5527478 10.447,38.9997478 11,38.9997478 L11,42.9997478 L13,42.9997478 L13,38.9997478 L16,38.9997478 L16,42.9997478 L18,42.9997478 L18,38.9997478 L21,38.9997478 L21,42.9997478 L23,42.9997478 L23,38.9997478 L26,38.9997478 L26,42.9997478 L28,42.9997478 L28,38.9997478 L31,38.9997478 L31,42.9997478 L33,42.9997478 L33,38.9997478 L36,38.9997478 L36,42.9997478 L38,42.9997478 L38,38.9997478 L39,38.9997478 C39.553,38.9997478 40,38.5527478 40,37.9997478 L43,37.9997478 L43,35.9997478 L40,35.9997478 L40,32.9997478 L43,32.9997478 L43,30.9997478 L40,30.9997478 L40,27.9997478 L43,27.9997478 L43,25.9997478 L40,25.9997478 L40,22.9997478 L43,22.9997478 L43,20.9997478 L40,20.9997478 L40,17.9997478 L43,17.9997478 L43,15.9997478 L40,15.9997478 L40,12.9997478 L43,12.9997478 L43,10.9997478 L40,10.9997478 L40,9.99974784 Z M18,25.9997478 L18,29.9997478 L31,29.9997478 L31,16.9997478 L28,16.9997478 L28,14.9997478 L32,14.9997478 C32.553,14.9997478 33,15.4477478 33,15.9997478 L33,30.9997478 C33,31.5527478 32.553,31.9997478 32,31.9997478 L17,31.9997478 C16.447,31.9997478 16,31.5527478 16,30.9997478 L16,25.9997478 L18,25.9997478 Z" id="Fill-1" fill="#ED7100"></path>
    </g>
</svg>`, D_ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Quantum-Technologies/Res_Amazon-Braket_Simulator-1_48</title>
    <g id="Icon-Resource/Quantum-Technologies/Res_Amazon-Braket_Simulator-1_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M39,39.94 C39,39.973 38.973,40 38.939,40 L8,39.94 L8.061,9 L39,9.06 L39,39.94 Z M46,11 L46,9 L41,9 L41,9.06 C41,7.924 40.075,7 38.939,7 L39,7 L39,2 L37,2 L37,7 L32,7 L32,2 L30,2 L30,7 L25,7 L25,2 L23,2 L23,7 L18,7 L18,2 L16,2 L16,7 L11,7 L11,2 L9,2 L9,7 L8.061,7 C6.945,7 6.039,7.893 6.006,9 L2,9 L2,11 L6,11 L6,16 L2,16 L2,18 L6,18 L6,23 L2,23 L2,25 L6,25 L6,30 L2,30 L2,32 L6,32 L6,37 L2,37 L2,39 L6,39 L6,39.94 C6,41.076 6.925,42 8.061,42 L9,42 L9,46 L11,46 L11,42 L16,42 L16,46 L18,46 L18,42 L23,42 L23,46 L25,46 L25,42 L30,42 L30,46 L32,46 L32,42 L37,42 L37,46 L39,46 L39,41.994 C40.107,41.961 41,41.055 41,39.94 L41,39 L46,39 L46,37 L41,37 L41,32 L46,32 L46,30 L41,30 L41,25 L46,25 L46,23 L41,23 L41,18 L46,18 L46,16 L41,16 L41,11 L46,11 Z M20.742,29.085 C20.945,29.207 21.146,29.333 21.35,29.45 C21.556,29.569 21.762,29.679 21.969,29.793 C21.614,29.932 21.268,30.061 20.929,30.178 C20.861,29.826 20.799,29.461 20.742,29.085 L20.742,29.085 Z M17.555,24.338 C17.831,24.1 18.117,23.863 18.415,23.628 C18.41,23.866 18.401,24.106 18.401,24.344 C18.401,24.579 18.41,24.816 18.414,25.052 C18.114,24.813 17.827,24.575 17.555,24.338 L17.555,24.338 Z M13.715,18.234 C14.177,17.433 16.163,17.234 19.01,17.938 C18.813,18.927 18.667,19.967 18.565,21.024 C17.681,21.65 16.848,22.296 16.094,22.956 C14.07,20.847 13.254,19.033 13.715,18.234 L13.715,18.234 Z M21.969,18.895 C21.763,19.009 21.556,19.118 21.35,19.237 C21.144,19.357 20.945,19.481 20.743,19.603 C20.799,19.226 20.861,18.861 20.929,18.51 C21.268,18.627 21.614,18.755 21.969,18.895 L21.969,18.895 Z M27.672,18.499 C27.741,18.859 27.804,19.229 27.859,19.607 C27.655,19.483 27.454,19.357 27.246,19.237 C27.04,19.118 26.828,19.006 26.619,18.891 C26.974,18.75 27.325,18.62 27.672,18.499 L27.672,18.499 Z M30.83,17.657 C32.918,17.301 34.471,17.523 34.88,18.234 C35.291,18.945 34.706,20.4 33.354,22.03 C33.098,22.34 32.81,22.652 32.51,22.963 C31.756,22.303 30.922,21.656 30.037,21.029 C29.937,19.95 29.793,18.905 29.599,17.922 C30.019,17.818 30.433,17.725 30.83,17.657 L30.83,17.657 Z M30.193,24.344 C30.193,24.103 30.185,23.866 30.181,23.627 C30.479,23.864 30.769,24.104 31.048,24.344 C30.769,24.585 30.479,24.823 30.18,25.061 C30.185,24.821 30.193,24.582 30.193,24.344 L30.193,24.344 Z M22.35,27.718 C21.686,27.334 21.067,26.943 20.477,26.55 C20.432,25.842 20.401,25.111 20.401,24.344 C20.401,23.576 20.432,22.844 20.477,22.136 C21.078,21.735 21.701,21.344 22.35,20.97 C22.998,20.596 23.648,20.252 24.296,19.931 C24.932,20.246 25.581,20.586 26.246,20.97 C26.895,21.344 27.518,21.736 28.12,22.136 C28.166,22.858 28.193,23.594 28.193,24.344 C28.193,25.112 28.163,25.844 28.118,26.553 C27.517,26.953 26.894,27.344 26.246,27.718 C25.581,28.102 24.932,28.442 24.295,28.757 C23.647,28.436 22.997,28.092 22.35,27.718 L22.35,27.718 Z M27.664,30.187 C27.318,30.065 26.968,29.936 26.615,29.795 C26.825,29.68 27.039,29.57 27.246,29.45 C27.452,29.332 27.65,29.207 27.852,29.086 C27.795,29.465 27.732,29.832 27.664,30.187 L27.664,30.187 Z M24.298,36.564 C23.373,36.564 22.208,34.944 21.394,32.128 C22.352,31.802 23.327,31.412 24.295,30.97 C25.277,31.422 26.251,31.82 27.197,32.142 C26.383,34.95 25.22,36.564 24.298,36.564 L24.298,36.564 Z M12.131,27.767 C11.286,29.564 11.584,30.763 11.982,31.454 C12.685,32.669 14.118,33.187 15.948,33.187 C17.012,33.187 18.215,32.999 19.479,32.684 C20.455,36.096 22.078,38.564 24.298,38.564 C26.513,38.564 28.134,36.106 29.11,32.704 C29.564,32.817 30.012,32.918 30.442,32.993 L30.784,31.023 C30.396,30.955 29.992,30.864 29.583,30.762 C29.781,29.768 29.927,28.725 30.029,27.664 C30.917,27.035 31.754,26.386 32.51,25.724 C32.81,26.036 33.098,26.348 33.354,26.658 C34.706,28.288 35.291,29.742 34.88,30.454 C34.625,30.896 33.968,31.073 33.461,31.144 L33.74,33.125 C35.455,32.883 36.249,32.083 36.612,31.454 C37.49,29.933 36.881,27.776 34.894,25.381 C34.607,25.036 34.288,24.69 33.955,24.344 C34.288,23.998 34.607,23.652 34.894,23.307 C36.881,20.912 37.49,18.755 36.612,17.234 C35.733,15.713 33.562,15.163 30.494,15.686 C30.052,15.761 29.592,15.865 29.126,15.981 C28.992,15.518 28.852,15.066 28.695,14.645 L26.82,15.34 C26.961,15.719 27.088,16.125 27.208,16.542 C26.257,16.866 25.277,17.265 24.289,17.72 C23.322,17.279 22.35,16.885 21.394,16.561 C22.208,13.744 23.373,12.124 24.298,12.124 C24.796,12.124 25.269,12.585 25.577,12.972 L27.14,11.724 C26.084,10.401 25.012,10.124 24.298,10.124 C22.078,10.124 20.456,12.59 19.479,16 C16.038,15.141 13.092,15.314 11.982,17.234 C10.875,19.153 12.193,21.786 14.65,24.332 C14.327,24.668 14.017,25.003 13.737,25.337 L15.272,26.62 C15.524,26.318 15.804,26.016 16.097,25.712 C16.86,26.383 17.693,27.033 18.564,27.654 C18.666,28.714 18.812,29.757 19.01,30.75 C16.162,31.453 14.176,31.254 13.715,30.454 C13.409,29.925 13.726,29.077 13.941,28.619 L12.131,27.767 Z" id="Fill-1" fill="#ED7100"></path>
    </g>
</svg>`, P_ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Quantum-Technologies/Res_Amazon-Braket_Managed-Simulator_48</title>
    <g id="Icon-Resource/Quantum-Technologies/Res_Amazon-Braket_Managed-Simulator_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M24,20.769 C25.781,20.769 27.23,22.218 27.23,24 C27.23,25.782 25.781,27.231 24,27.231 C22.219,27.231 20.77,25.782 20.77,24 C20.77,22.218 22.219,20.769 24,20.769 L24,20.769 Z M24,29.231 C26.884,29.231 29.23,26.884 29.23,24 C29.23,21.116 26.884,18.769 24,18.769 C21.116,18.769 18.77,21.116 18.77,24 C18.77,26.884 21.116,29.231 24,29.231 L24,29.231 Z M14,22.708 L15.36,22.708 C15.814,22.708 16.211,22.403 16.327,21.964 C16.507,21.285 16.778,20.63 17.136,20.015 C17.364,19.623 17.3,19.126 16.979,18.806 L16.016,17.842 L17.842,16.016 L18.806,16.979 C19.127,17.301 19.622,17.364 20.016,17.136 C20.63,16.779 21.285,16.507 21.964,16.327 C22.402,16.211 22.708,15.814 22.708,15.36 L22.708,14 L25.292,14 L25.292,15.36 C25.292,15.814 25.598,16.211 26.036,16.327 C26.715,16.507 27.37,16.779 27.984,17.136 C28.377,17.364 28.874,17.301 29.194,16.979 L30.158,16.016 L31.984,17.842 L31.021,18.806 C30.7,19.126 30.636,19.623 30.864,20.015 C31.222,20.63 31.493,21.285 31.673,21.964 C31.789,22.403 32.186,22.708 32.64,22.708 L34,22.708 L34,25.291 L32.64,25.291 C32.186,25.291 31.789,25.597 31.673,26.036 C31.493,26.715 31.222,27.37 30.864,27.985 C30.636,28.377 30.7,28.873 31.021,29.194 L31.984,30.158 L30.158,31.984 L29.194,31.021 C28.874,30.699 28.377,30.635 27.984,30.864 C27.37,31.221 26.715,31.493 26.036,31.673 C25.598,31.789 25.292,32.186 25.292,32.64 L25.292,34 L22.708,34 L22.708,32.64 C22.708,32.186 22.402,31.789 21.964,31.673 C21.285,31.493 20.63,31.221 20.016,30.864 C19.622,30.635 19.127,30.699 18.806,31.021 L17.842,31.984 L16.016,30.158 L16.979,29.194 C17.3,28.873 17.364,28.377 17.136,27.985 C16.778,27.37 16.507,26.715 16.327,26.036 C16.211,25.597 15.814,25.291 15.36,25.291 L14,25.291 L14,22.708 Z M13.458,27.291 L14.622,27.291 C14.743,27.635 14.884,27.973 15.042,28.303 L14.22,29.125 C13.943,29.401 13.791,29.768 13.791,30.158 C13.791,30.548 13.943,30.915 14.219,31.189 L16.812,33.782 C17.381,34.352 18.306,34.35 18.873,33.782 L19.697,32.957 C20.027,33.116 20.364,33.256 20.708,33.377 L20.708,34.541 C20.708,35.346 21.362,36 22.167,36 L25.833,36 C26.638,36 27.292,35.346 27.292,34.541 L27.292,33.377 C27.636,33.256 27.973,33.116 28.303,32.957 L29.127,33.782 C29.695,34.35 30.62,34.352 31.188,33.782 L33.78,31.19 C34.057,30.915 34.209,30.548 34.209,30.158 C34.209,29.768 34.057,29.401 33.781,29.126 L32.958,28.303 C33.116,27.973 33.257,27.635 33.378,27.291 L34.542,27.291 C35.346,27.291 36,26.637 36,25.833 L36,22.166 C36,21.363 35.346,20.708 34.542,20.708 L33.378,20.708 C33.257,20.365 33.116,20.027 32.958,19.697 L33.78,18.874 C34.057,18.599 34.209,18.232 34.209,17.842 C34.209,17.452 34.057,17.085 33.781,16.811 L31.188,14.218 C30.62,13.649 29.695,13.651 29.127,14.218 L28.303,15.042 C27.973,14.884 27.636,14.744 27.292,14.623 L27.292,13.458 C27.292,12.654 26.638,12 25.833,12 L22.167,12 C21.362,12 20.708,12.654 20.708,13.458 L20.708,14.623 C20.364,14.744 20.027,14.884 19.697,15.042 L18.873,14.218 C18.306,13.651 17.381,13.649 16.812,14.218 L14.22,16.81 C13.943,17.085 13.791,17.452 13.791,17.842 C13.791,18.232 13.943,18.599 14.219,18.873 L15.042,19.697 C14.884,20.027 14.743,20.365 14.622,20.708 L13.458,20.708 C12.654,20.708 12,21.363 12,22.166 L12,25.833 C12,26.637 12.654,27.291 13.458,27.291 L13.458,27.291 Z M9,39 L39,39 L39,9 L9,9 L9,39 Z M46,13 L46,11 L41,11 L41,8 C41,7.448 40.553,7 40,7 L37,7 L37,2 L35,2 L35,7 L31,7 L31,2 L29,2 L29,7 L25,7 L25,2 L23,2 L23,7 L19,7 L19,2 L17,2 L17,7 L13,7 L13,2 L11,2 L11,7 L8,7 C7.447,7 7,7.448 7,8 L7,11 L2,11 L2,13 L7,13 L7,17 L2,17 L2,19 L7,19 L7,23 L2,23 L2,25 L7,25 L7,29 L2,29 L2,31 L7,31 L7,35 L2,35 L2,37 L7,37 L7,40 C7,40.552 7.447,41 8,41 L11,41 L11,46 L13,46 L13,41 L17,41 L17,46 L19,46 L19,41 L23,41 L23,46 L25,46 L25,41 L29,41 L29,46 L31,46 L31,41 L35,41 L35,46 L37,46 L37,41 L40,41 C40.553,41 41,40.552 41,40 L41,37 L46,37 L46,35 L41,35 L41,31 L46,31 L46,29 L41,29 L41,25 L46,25 L46,23 L41,23 L41,19 L46,19 L46,17 L41,17 L41,13 L46,13 Z" id="Fill-1" fill="#ED7100"></path>
    </g>
</svg>`, B_ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Quantum-Technologies/Res_Amazon-Braket_Simulator-3_48</title>
    <g id="Icon-Resource/Quantum-Technologies/Res_Amazon-Braket_Simulator-3_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M9,39 L39,39 L39,9 L9,9 L9,39 Z M41,13 L41,17 L46,17 L46,19 L41,19 L41,23 L46,23 L46,25 L41,25 L41,29 L46,29 L46,31 L41,31 L41,35 L46,35 L46,37 L41,37 L41,40 C41,40.552 40.553,41 40,41 L37,41 L37,46 L35,46 L35,41 L31,41 L31,46 L29,46 L29,41 L25,41 L25,46 L23,46 L23,41 L19,41 L19,46 L17,46 L17,41 L13,41 L13,46 L11,46 L11,41 L8,41 C7.447,41 7,40.552 7,40 L7,37 L2,37 L2,35 L7,35 L7,31 L2,31 L2,29 L7,29 L7,25 L2,25 L2,23 L7,23 L7,19 L2,19 L2,17 L7,17 L7,13 L2,13 L2,11 L7,11 L7,8 C7,7.448 7.447,7 8,7 L11,7 L11,2 L13,2 L13,7 L17,7 L17,2 L19,2 L19,7 L23,7 L23,2 L25,2 L25,7 L29,7 L29,2 L31,2 L31,7 L35,7 L35,2 L37,2 L37,7 L40,7 C40.553,7 41,7.448 41,8 L41,11 L46,11 L46,13 L41,13 Z M10.402,14.914 L10.402,12.914 C14.444,12.914 16.179,18.552 18.015,24.522 C19.52,29.416 21.226,34.962 23.938,34.962 C26.654,34.962 28.363,29.446 29.87,24.58 C31.729,18.58 33.484,12.914 37.598,12.914 L37.598,14.914 C34.958,14.914 33.271,20.363 31.781,25.171 C29.985,30.968 28.129,36.962 23.938,36.962 C19.748,36.962 17.895,30.937 16.103,25.11 C14.633,20.331 12.967,14.914 10.402,14.914 L10.402,14.914 Z" id="Fill-1" fill="#ED7100"></path>
    </g>
</svg>`, z_ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Quantum-Technologies/Res_Amazon-Braket_Chandelier_48</title>
    <g id="Icon-Resource/Quantum-Technologies/Res_Amazon-Braket_Chandelier_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M22,44 L26,44 L26,41 L22,41 L22,44 Z M28,40 L28,45 C28,45.552 27.553,46 27,46 L21,46 C20.447,46 20,45.552 20,45 L20,40 C20,39.448 20.447,39 21,39 L27,39 C27.553,39 28,39.448 28,40 L28,40 Z M11,2 L9,2 L9,7 C9,7.552 9.447,8 10,8 L13,8 L13,6 L11,6 L11,2 Z M37,2 L37,6 L35,6 L35,8 L38,8 C38.553,8 39,7.552 39,7 L39,2 L37,2 Z M14,31 L34,31 L34,29 L14,29 L14,31 Z M14,16 L34,16 L34,14 L14,14 L14,16 Z M30,27 L32,27 L32,18 L30,18 L30,27 Z M26,27 L28,27 L28,18 L26,18 L26,27 Z M20,27 L22,27 L22,18 L20,18 L20,27 Z M16,27 L18,27 L18,18 L16,18 L16,27 Z M32,12 L32,3 L30,3 L30,12 L30,13 L32,13 L32,12 Z M26,13 L28,13 L28,3 L26,3 L26,13 Z M25,37 L27,37 L27,32 L25,32 L25,37 Z M21,37 L23,37 L23,32 L21,32 L21,37 Z M20,13 L22,13 L22,3 L20,3 L20,13 Z M18,13 L16,13 L16,12 L16,3 L18,3 L18,12 L18,13 Z" id="Fill-1" fill="#ED7100"></path>
    </g>
</svg>`, U_ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Quantum-Technologies/Res_Amazon-Braket_Tensor-Network_48</title>
    <g id="Icon-Resource/Quantum-Technologies/Res_Amazon-Braket_Tensor-Network_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M39.296,31.351 C39.574,31.572 39.841,31.794 40.101,32.018 C39.842,32.241 39.574,32.463 39.296,32.684 C39.301,32.462 39.309,32.239 39.309,32.018 C39.309,31.793 39.3,31.573 39.296,31.351 L39.296,31.351 Z M36.795,37.725 C36.477,37.613 36.155,37.495 35.83,37.366 C36.022,37.26 36.213,37.159 36.404,37.048 C36.596,36.937 36.781,36.822 36.969,36.708 C36.916,37.059 36.858,37.397 36.795,37.725 L36.795,37.725 Z M33.5,44 C32.601,44 31.468,42.427 30.672,39.688 C31.593,39.373 32.542,38.987 33.498,38.547 C34.459,38.99 35.407,39.37 36.329,39.684 C35.533,42.425 34.4,44 33.5,44 L33.5,44 Z M30.031,36.708 C30.219,36.822 30.404,36.937 30.596,37.048 C30.79,37.161 30.984,37.263 31.18,37.371 C30.852,37.5 30.527,37.619 30.206,37.731 C30.143,37.401 30.084,37.061 30.031,36.708 L30.031,36.708 Z M26.9,32.018 C27.158,31.794 27.426,31.572 27.704,31.351 C27.699,31.574 27.692,31.796 27.692,32.018 C27.692,32.239 27.699,32.462 27.704,32.684 C27.426,32.463 27.158,32.241 26.9,32.018 L26.9,32.018 Z M23.123,26.026 C23.437,25.483 24.646,25.053 27.081,25.469 C27.471,25.535 27.876,25.626 28.288,25.728 C28.096,26.697 27.953,27.714 27.854,28.748 C26.989,29.36 26.174,29.993 25.436,30.637 C25.146,30.335 24.868,30.034 24.619,29.734 C23.038,27.828 22.81,26.569 23.123,26.026 L23.123,26.026 Z M31.179,26.665 C30.984,26.772 30.789,26.875 30.596,26.987 C30.404,27.098 30.219,27.214 30.031,27.327 C30.084,26.975 30.143,26.634 30.206,26.304 C30.527,26.416 30.851,26.536 31.179,26.665 L31.179,26.665 Z M37.309,32.018 C37.309,32.768 37.279,33.483 37.235,34.176 C36.647,34.567 36.038,34.95 35.404,35.316 C34.772,35.682 34.136,36.017 33.504,36.331 C32.867,36.016 32.229,35.681 31.596,35.316 C30.962,34.95 30.354,34.567 29.765,34.176 C29.721,33.483 29.692,32.768 29.692,32.018 C29.692,31.267 29.721,30.552 29.765,29.859 C30.354,29.468 30.962,29.085 31.596,28.72 C32.231,28.353 32.866,28.017 33.5,27.703 C34.134,28.017 34.77,28.353 35.404,28.72 C36.037,29.085 36.646,29.467 37.234,29.858 C37.279,30.567 37.309,31.287 37.309,32.018 L37.309,32.018 Z M36.794,26.304 C36.858,26.638 36.916,26.978 36.968,27.326 C36.779,27.213 36.596,27.098 36.404,26.987 C36.211,26.875 36.016,26.772 35.821,26.665 C36.15,26.536 36.473,26.416 36.794,26.304 L36.794,26.304 Z M39.919,25.469 C42.358,25.053 43.565,25.485 43.877,26.026 C44.191,26.569 43.962,27.828 42.381,29.734 C42.132,30.034 41.854,30.336 41.564,30.638 C40.829,29.995 40.018,29.365 39.155,28.754 C39.058,27.698 38.913,26.684 38.724,25.726 C39.132,25.624 39.533,25.535 39.919,25.469 L39.919,25.469 Z M43.009,32.018 C43.332,31.682 43.642,31.346 43.92,31.011 C46.427,27.988 46.223,26.088 45.609,25.026 C44.996,23.965 43.452,22.838 39.582,23.497 C39.152,23.571 38.707,23.671 38.254,23.783 C38.074,23.163 37.879,22.568 37.656,22.023 L35.805,22.778 C36,23.257 36.174,23.789 36.334,24.346 C35.41,24.661 34.459,25.048 33.5,25.489 C32.543,25.049 31.594,24.663 30.672,24.348 C31.468,21.608 32.601,20.035 33.5,20.035 C33.983,20.035 34.442,20.484 34.741,20.86 L36.306,19.613 C35.265,18.309 34.205,18.035 33.5,18.035 C31.319,18.035 29.724,20.447 28.761,23.787 C28.304,23.673 27.853,23.572 27.418,23.497 C23.551,22.839 22.004,23.965 21.391,25.026 C20.777,26.088 20.573,27.988 23.08,31.011 C23.358,31.346 23.667,31.682 23.99,32.017 C23.681,32.339 23.384,32.661 23.115,32.982 L24.65,34.264 C24.891,33.976 25.157,33.687 25.436,33.397 C26.174,34.042 26.988,34.675 27.854,35.288 C27.953,36.322 28.096,37.338 28.288,38.307 C27.876,38.409 27.471,38.5 27.081,38.567 C24.644,38.982 23.437,38.551 23.123,38.009 C22.827,37.497 23.136,36.67 23.346,36.223 L21.535,35.372 C20.703,37.144 20.997,38.328 21.391,39.009 C21.877,39.851 22.948,40.735 25.302,40.735 C25.916,40.735 26.617,40.675 27.418,40.538 C27.853,40.464 28.304,40.363 28.762,40.248 C29.724,43.588 31.319,46 33.5,46 C35.68,46 37.276,43.588 38.238,40.249 C38.879,40.407 39.503,40.536 40.097,40.617 L40.366,38.635 C39.844,38.564 39.287,38.448 38.713,38.304 C38.905,37.336 39.047,36.321 39.147,35.288 C40.012,34.675 40.826,34.043 41.564,33.398 C41.854,33.7 42.132,34.001 42.381,34.302 C43.962,36.208 44.191,37.467 43.877,38.009 C43.63,38.436 42.99,38.609 42.496,38.678 L42.775,40.659 C44.467,40.421 45.25,39.63 45.609,39.009 C46.223,37.947 46.427,36.047 43.92,33.025 C43.642,32.69 43.332,32.353 43.009,32.018 L43.009,32.018 Z M14,43 L16,43 L16,41 L14,41 L14,43 Z M7,32 L9,32 L9,30 L7,30 L7,32 Z M10,20 L12,20 L12,18 L10,18 L10,20 Z M21,6 L23,6 L23,4 L21,4 L21,6 Z M4,6 L6,6 L6,4 L4,4 L4,6 Z M11,29 C11,28.448 10.553,28 10,28 L9.212,28 L11.629,22 L13,22 C13.553,22 14,21.553 14,21 L14,17.255 L21.924,8 L24,8 C24.553,8 25,7.553 25,7 L25,3 C25,2.448 24.553,2 24,2 L20,2 C19.447,2 19,2.448 19,3 L19,7 C19,7.345 19.186,7.634 19.45,7.814 L12.442,16 L9.774,16 L6.654,8 L7,8 C7.553,8 8,7.553 8,7 L8,3 C8,2.448 7.553,2 7,2 L3,2 C2.447,2 2,2.448 2,3 L2,7 C2,7.553 2.447,8 3,8 L4.508,8 L8.006,16.972 C8.006,16.982 8,16.99 8,17 L8,21 C8,21.553 8.447,22 9,22 L9.473,22 L7.055,28 L6,28 C5.447,28 5,28.448 5,29 L5,33 C5,33.553 5.447,34 6,34 L8.023,34 L12.008,39.959 C12.008,39.974 12,39.986 12,40 L12,44 C12,44.553 12.447,45 13,45 L17,45 C17.553,45 18,44.553 18,44 L18,40 C18,39.448 17.553,39 17,39 L13.774,39 L10.378,33.924 C10.742,33.775 11,33.419 11,33 L11,32 L20,32 L20,30 L11,30 L11,29 Z M36,6 L38,6 L38,4 L36,4 L36,6 Z M35.504,16.247 L37.77,8 L39,8 C39.553,8 40,7.553 40,7 L40,3 C40,2.448 39.553,2 39,2 L35,2 C34.447,2 34,2.448 34,3 L34,7 C34,7.553 34.447,8 35,8 L35.696,8 L33.576,15.717 L35.504,16.247 Z" id="Fill-1" fill="#ED7100"></path>
    </g>
</svg>`, W_ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Quantum-Technologies/Res_Amazon-Braket_Simulator-4_48</title>
    <g id="Icon-Resource/Quantum-Technologies/Res_Amazon-Braket_Simulator-4_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M9,39 L39,39 L39,9 L9,9 L9,39 Z M41,13 L41,17 L46,17 L46,19 L41,19 L41,23 L46,23 L46,25 L41,25 L41,29 L46,29 L46,31 L41,31 L41,35 L46,35 L46,37 L41,37 L41,40 C41,40.552 40.553,41 40,41 L37,41 L37,46 L35,46 L35,41 L31,41 L31,46 L29,46 L29,41 L25,41 L25,46 L23,46 L23,41 L19,41 L19,46 L17,46 L17,41 L13,41 L13,46 L11,46 L11,41 L8,41 C7.447,41 7,40.552 7,40 L7,37 L2,37 L2,35 L7,35 L7,31 L2,31 L2,29 L7,29 L7,25 L2,25 L2,23 L7,23 L7,19 L2,19 L2,17 L7,17 L7,13 L2,13 L2,11 L7,11 L7,8 C7,7.448 7.447,7 8,7 L11,7 L11,2 L13,2 L13,7 L17,7 L17,2 L19,2 L19,7 L23,7 L23,2 L25,2 L25,7 L29,7 L29,2 L31,2 L31,7 L35,7 L35,2 L37,2 L37,7 L40,7 C40.553,7 41,7.448 41,8 L41,11 L46,11 L46,13 L41,13 Z M21.845,25 L10,25 L10,23 L21.324,23 L18.362,20.038 L19.776,18.624 L23.853,22.7 L27.928,18.624 L29.342,20.038 L26.38,23 L37,23 L37,25 L25.969,25 L29.454,28.485 L28.04,29.899 L23.907,25.766 L19.773,29.899 L18.359,28.485 L21.845,25 Z" id="Fill-1" fill="#ED7100"></path>
    </g>
</svg>`, H_ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Quantum-Technologies/Res_Amazon-Braket_QPU_48</title>
    <g id="Icon-Resource/Quantum-Technologies/Res_Amazon-Braket_QPU_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M39.448,32.318 C39.448,32.52 39.44,32.722 39.436,32.924 C39.688,32.723 39.929,32.521 40.166,32.318 C39.929,32.115 39.688,31.912 39.436,31.712 C39.439,31.914 39.448,32.114 39.448,32.318 L39.448,32.318 Z M37.111,36.946 C36.939,37.049 36.771,37.155 36.596,37.256 C36.423,37.356 36.249,37.448 36.075,37.545 C36.371,37.661 36.662,37.768 36.952,37.87 C37.01,37.57 37.063,37.264 37.111,36.946 L37.111,36.946 Z M36.488,39.83 C35.594,39.524 34.676,39.155 33.744,38.727 C32.817,39.153 31.898,39.527 31.005,39.833 C31.778,42.488 32.875,44.013 33.746,44.013 C34.618,44.013 35.715,42.487 36.488,39.83 L36.488,39.83 Z M30.541,37.876 C30.833,37.774 31.128,37.666 31.426,37.549 C31.249,37.451 31.072,37.358 30.895,37.256 C30.72,37.155 30.552,37.049 30.381,36.946 C30.429,37.266 30.483,37.575 30.541,37.876 L30.541,37.876 Z M28.055,32.924 C28.052,32.722 28.044,32.52 28.044,32.318 C28.044,32.116 28.052,31.914 28.055,31.711 C27.803,31.912 27.562,32.114 27.326,32.318 C27.562,32.521 27.803,32.723 28.055,32.924 L28.055,32.924 Z M25.079,30.07 C25.318,30.359 25.584,30.648 25.862,30.938 C26.577,30.313 27.367,29.701 28.204,29.109 C28.301,28.107 28.437,27.122 28.624,26.184 C28.228,26.087 27.84,26 27.466,25.936 C25.092,25.531 23.92,25.946 23.618,26.47 C23.315,26.994 23.54,28.215 25.079,30.07 L25.079,30.07 Z M30.541,26.76 C30.483,27.061 30.429,27.369 30.381,27.689 C30.552,27.586 30.72,27.481 30.895,27.38 C31.071,27.278 31.249,27.184 31.426,27.087 C31.127,26.969 30.833,26.862 30.541,26.76 L30.541,26.76 Z M37.376,30.219 C36.803,29.839 36.213,29.467 35.596,29.112 C34.98,28.756 34.362,28.429 33.746,28.123 C33.13,28.429 32.511,28.756 31.895,29.112 C31.279,29.467 30.687,29.839 30.115,30.22 C30.072,30.893 30.044,31.589 30.044,32.318 C30.044,33.047 30.072,33.742 30.115,34.416 C30.687,34.796 31.279,35.168 31.895,35.524 C32.511,35.879 33.131,36.204 33.749,36.51 C34.364,36.205 34.981,35.879 35.596,35.524 C36.213,35.168 36.804,34.796 37.377,34.416 C37.42,33.742 37.448,33.047 37.448,32.318 C37.448,31.608 37.42,30.908 37.376,30.219 L37.376,30.219 Z M36.066,27.087 C36.243,27.184 36.421,27.278 36.596,27.38 C36.77,27.48 36.937,27.585 37.108,27.688 C37.06,27.372 37.008,27.064 36.95,26.76 C36.658,26.862 36.364,26.969 36.066,27.087 L36.066,27.087 Z M38.88,26.181 C39.062,27.11 39.203,28.092 39.298,29.115 C40.132,29.706 40.917,30.316 41.629,30.938 C41.908,30.648 42.174,30.359 42.413,30.07 C43.952,28.215 44.177,26.994 43.874,26.47 C43.572,25.947 42.4,25.532 40.026,25.936 C39.656,25.999 39.27,26.085 38.88,26.181 L38.88,26.181 Z M43.952,33.289 C46.412,36.254 46.209,38.121 45.606,39.165 C45.254,39.777 44.483,40.556 42.818,40.789 L42.541,38.809 C43.018,38.742 43.637,38.576 43.874,38.166 C44.177,37.641 43.952,36.421 42.413,34.566 C42.174,34.277 41.908,33.987 41.629,33.697 C40.914,34.322 40.126,34.934 39.288,35.527 C39.191,36.527 39.054,37.511 38.869,38.449 C39.423,38.586 39.96,38.699 40.464,38.767 L40.194,40.749 C39.619,40.671 39.013,40.546 38.394,40.393 C37.449,43.657 35.884,46.013 33.746,46.013 C31.608,46.013 30.043,43.657 29.097,40.394 C28.656,40.503 28.221,40.6 27.802,40.672 C27.018,40.805 26.332,40.864 25.73,40.864 C23.418,40.864 22.364,39.994 21.886,39.165 C21.498,38.494 21.208,37.328 22.026,35.588 L23.837,36.44 C23.633,36.872 23.334,37.672 23.618,38.165 C23.92,38.689 25.088,39.104 27.466,38.7 C27.84,38.636 28.228,38.549 28.624,38.451 C28.437,37.513 28.301,36.528 28.204,35.527 C27.366,34.934 26.577,34.321 25.862,33.697 C25.595,33.975 25.341,34.253 25.109,34.529 L23.574,33.247 C23.833,32.937 24.118,32.627 24.416,32.317 C24.105,31.993 23.807,31.67 23.54,31.347 C21.08,28.382 21.283,26.514 21.886,25.47 C22.488,24.426 24.003,23.317 27.802,23.964 C28.221,24.036 28.656,24.133 29.097,24.242 C30.043,20.979 31.608,18.623 33.746,18.623 C34.44,18.623 35.483,18.892 36.507,20.174 L34.942,21.422 C34.652,21.057 34.209,20.623 33.746,20.623 C32.875,20.623 31.778,22.148 31.005,24.803 C31.898,25.109 32.818,25.484 33.746,25.91 C34.675,25.483 35.595,25.108 36.49,24.802 C36.336,24.265 36.168,23.753 35.979,23.291 L37.831,22.536 C38.046,23.064 38.236,23.638 38.41,24.238 C38.846,24.131 39.275,24.035 39.689,23.964 C43.489,23.315 45.003,24.426 45.606,25.47 C46.209,26.514 46.412,28.382 43.952,31.347 C43.683,31.67 43.386,31.994 43.075,32.318 C43.386,32.642 43.683,32.965 43.952,33.289 L43.952,33.289 Z M14,14 L32,14 L32,15 L34,15 L34,13 C34,12.448 33.552,12 33,12 L13,12 C12.447,12 12,12.448 12,13 L12,33 C12,33.552 12.447,34 13,34 L19,34 L19,32 L14,32 L14,14 Z M9,37 L19,37 L19,39 L18,39 L18,44 L16,44 L16,39 L13,39 L13,44 L11,44 L11,39 L8,39 C7.447,39 7,38.552 7,38 L7,35 L2,35 L2,33 L7,33 L7,30 L2,30 L2,28 L7,28 L7,24 L2,24 L2,22 L7,22 L7,18 L2,18 L2,16 L7,16 L7,12 L2,12 L2,10 L7,10 L7,8 C7,7.448 7.447,7 8,7 L11,7 L11,2 L13,2 L13,7 L16,7 L16,2 L18,2 L18,7 L22,7 L22,2 L24,2 L24,7 L28,7 L28,2 L30,2 L30,7 L33,7 L33,2 L35,2 L35,7 L38,7 C38.552,7 39,7.448 39,8 L39,10 L44,10 L44,12 L39,12 L39,16 L44,16 L44,18 L39,18 L38,18 L37,18 L37,17 L37,9 L9,9 L9,37 Z" id="Fill-1" fill="#ED7100"></path>
    </g>
</svg>`, $_ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Quantum-Technologies/Res_Amazon-Braket_State-Vector_48</title>
    <g id="Icon-Resource/Quantum-Technologies/Res_Amazon-Braket_State-Vector_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M19.22,25.571 C18.236,25.793 17.155,25.926 16,25.976 L16,33 L14,33 L14,25.966 C10.235,25.802 7.301,24.716 5.293,22.707 C2.985,20.399 2,18.094 2,15 L2,4 L4,4 L4,15 C4,17.58 4.759,19.344 6.707,21.293 C8.336,22.923 10.793,23.815 14,23.968 L14,4 L16,4 L16,23.976 C17.003,23.929 17.936,23.81 18.781,23.62 L19.22,25.571 Z M27.101,19.421 L25.286,18.578 C25.774,17.531 26,16.394 26,15 L26,4 L28,4 L28,15 C28,16.673 27.706,18.119 27.101,19.421 L27.101,19.421 Z M39.296,29.35 C39.574,29.571 39.841,29.793 40.101,30.017 C39.842,30.24 39.574,30.463 39.296,30.683 C39.301,30.461 39.309,30.238 39.309,30.017 C39.309,29.792 39.3,29.572 39.296,29.35 L39.296,29.35 Z M36.795,35.724 C36.477,35.613 36.156,35.494 35.83,35.365 C36.022,35.259 36.213,35.158 36.405,35.048 C36.596,34.937 36.782,34.821 36.969,34.708 C36.916,35.058 36.859,35.396 36.795,35.724 L36.795,35.724 Z M33.5,42 C32.601,42 31.468,40.426 30.672,37.687 C31.593,37.373 32.542,36.986 33.498,36.547 C34.459,36.989 35.407,37.369 36.329,37.684 C35.533,40.425 34.4,42 33.5,42 L33.5,42 Z M30.032,34.708 C30.219,34.821 30.405,34.937 30.596,35.048 C30.79,35.16 30.985,35.262 31.18,35.37 C30.852,35.499 30.528,35.618 30.206,35.731 C30.143,35.401 30.084,35.06 30.032,34.708 L30.032,34.708 Z M26.9,30.017 C27.158,29.794 27.426,29.571 27.704,29.35 C27.699,29.573 27.692,29.795 27.692,30.017 C27.692,30.238 27.699,30.461 27.704,30.683 C27.426,30.463 27.158,30.24 26.9,30.017 L26.9,30.017 Z M23.123,24.026 C23.437,23.483 24.646,23.053 27.081,23.468 C27.471,23.534 27.876,23.626 28.288,23.728 C28.096,24.696 27.953,25.713 27.854,26.747 C26.99,27.36 26.174,27.992 25.436,28.636 C25.146,28.335 24.868,28.033 24.619,27.733 C23.038,25.827 22.81,24.568 23.123,24.026 L23.123,24.026 Z M31.179,24.664 C30.985,24.772 30.789,24.875 30.596,24.987 C30.405,25.097 30.219,25.213 30.032,25.326 C30.084,24.974 30.143,24.634 30.206,24.303 C30.528,24.416 30.851,24.535 31.179,24.664 L31.179,24.664 Z M37.309,30.017 C37.309,30.767 37.28,31.483 37.236,32.175 C36.647,32.567 36.038,32.949 35.405,33.315 C34.772,33.681 34.136,34.016 33.504,34.33 C32.867,34.015 32.229,33.68 31.596,33.315 C30.962,32.949 30.354,32.567 29.765,32.175 C29.721,31.483 29.692,30.767 29.692,30.017 C29.692,29.266 29.721,28.551 29.765,27.859 C30.354,27.467 30.962,27.085 31.596,26.719 C32.231,26.353 32.866,26.016 33.5,25.702 C34.134,26.016 34.77,26.353 35.405,26.719 C36.037,27.085 36.646,27.467 37.235,27.858 C37.28,28.567 37.309,29.286 37.309,30.017 L37.309,30.017 Z M36.794,24.303 C36.858,24.637 36.916,24.977 36.968,25.325 C36.78,25.213 36.596,25.097 36.405,24.987 C36.211,24.875 36.016,24.772 35.822,24.664 C36.15,24.535 36.473,24.415 36.794,24.303 L36.794,24.303 Z M39.919,23.468 C42.358,23.053 43.565,23.484 43.877,24.026 C44.191,24.568 43.962,25.827 42.381,27.733 C42.132,28.033 41.854,28.335 41.564,28.637 C40.829,27.994 40.018,27.364 39.156,26.754 C39.058,25.697 38.913,24.683 38.724,23.725 C39.132,23.624 39.533,23.534 39.919,23.468 L39.919,23.468 Z M43.009,30.017 C43.332,29.681 43.642,29.345 43.92,29.01 C46.427,25.988 46.223,24.088 45.61,23.026 C44.996,21.964 43.452,20.837 39.582,21.497 C39.153,21.57 38.707,21.67 38.254,21.782 C38.074,21.162 37.879,20.568 37.657,20.023 L35.805,20.778 C36,21.257 36.174,21.788 36.334,22.345 C35.41,22.66 34.459,23.048 33.5,23.488 C32.543,23.049 31.594,22.662 30.672,22.347 C31.468,19.608 32.601,18.034 33.5,18.034 C33.983,18.034 34.442,18.483 34.741,18.86 L36.306,17.613 C35.265,16.308 34.205,16.034 33.5,16.034 C31.32,16.034 29.724,18.446 28.761,21.786 C28.304,21.673 27.853,21.571 27.418,21.497 C23.551,20.838 22.004,21.964 21.391,23.026 C20.778,24.087 20.574,25.988 23.08,29.01 C23.358,29.345 23.667,29.681 23.991,30.016 C23.681,30.338 23.384,30.66 23.116,30.981 L24.651,32.263 C24.891,31.975 25.157,31.686 25.436,31.397 C26.174,32.042 26.989,32.674 27.854,33.287 C27.953,34.321 28.096,35.338 28.288,36.306 C27.876,36.408 27.471,36.5 27.081,36.566 C24.644,36.98 23.437,36.551 23.123,36.008 C22.827,35.496 23.136,34.669 23.346,34.222 L21.535,33.371 C20.703,35.143 20.997,36.327 21.391,37.009 C21.877,37.851 22.949,38.734 25.302,38.734 C25.916,38.734 26.617,38.674 27.418,38.537 C27.853,38.463 28.304,38.362 28.762,38.248 C29.724,41.588 31.32,44 33.5,44 C35.68,44 37.277,41.588 38.239,38.248 C38.879,38.406 39.503,38.535 40.097,38.616 L40.366,36.634 C39.844,36.564 39.287,36.447 38.713,36.303 C38.906,35.336 39.047,34.32 39.147,33.287 C40.012,32.675 40.826,32.042 41.564,31.397 C41.854,31.699 42.132,32.001 42.381,32.301 C43.962,34.207 44.191,35.466 43.877,36.008 C43.63,36.436 42.991,36.608 42.496,36.677 L42.776,38.658 C44.467,38.42 45.25,37.63 45.61,37.009 C46.223,35.946 46.427,34.047 43.92,31.024 C43.642,30.689 43.332,30.353 43.009,30.017 L43.009,30.017 Z" id="Fill-1" fill="#ED7100"></path>
    </g>
</svg>`, V_ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Quantum-Technologies/Res_Amazon-Braket_Simulator-2_48</title>
    <g id="Icon-Resource/Quantum-Technologies/Res_Amazon-Braket_Simulator-2_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M9,39 L39,39 L39,9 L9,9 L9,39 Z M41,13 L41,17 L46,17 L46,19 L41,19 L41,23 L46,23 L46,25 L41,25 L41,29 L46,29 L46,31 L41,31 L41,35 L46,35 L46,37 L41,37 L41,40 C41,40.552 40.553,41 40,41 L37,41 L37,46 L35,46 L35,41 L31,41 L31,46 L29,46 L29,41 L25,41 L25,46 L23,46 L23,41 L19,41 L19,46 L17,46 L17,41 L13,41 L13,46 L11,46 L11,41 L8,41 C7.447,41 7,40.552 7,40 L7,37 L2,37 L2,35 L7,35 L7,31 L2,31 L2,29 L7,29 L7,25 L2,25 L2,23 L7,23 L7,19 L2,19 L2,17 L7,17 L7,13 L2,13 L2,11 L7,11 L7,8 C7,7.448 7.447,7 8,7 L11,7 L11,2 L13,2 L13,7 L17,7 L17,2 L19,2 L19,7 L23,7 L23,2 L25,2 L25,7 L29,7 L29,2 L31,2 L31,7 L35,7 L35,2 L37,2 L37,7 L40,7 C40.553,7 41,7.448 41,8 L41,11 L46,11 L46,13 L41,13 Z M34.655,23.921 C33.553,23.921 32.655,23.024 32.655,21.921 C32.655,20.818 33.553,19.921 34.655,19.921 C35.758,19.921 36.655,20.818 36.655,21.921 C36.655,23.024 35.758,23.921 34.655,23.921 L34.655,23.921 Z M24.146,33.909 C23.943,31.892 22.256,30.305 20.186,30.305 C19.086,30.305 18.09,30.751 17.366,31.471 C15.164,29.567 13.899,26.854 13.899,23.921 C13.899,22.237 14.339,20.614 15.135,19.154 C15.631,19.375 16.177,19.503 16.754,19.503 C18.96,19.503 20.754,17.708 20.754,15.503 C20.754,15.148 20.692,14.81 20.605,14.482 C21.659,14.113 22.762,13.921 23.899,13.921 C27.399,13.921 30.554,15.717 32.372,18.645 C31.337,19.369 30.655,20.565 30.655,21.921 C30.655,23.802 31.965,25.374 33.717,25.798 C32.85,30.339 28.906,33.792 24.146,33.909 L24.146,33.909 Z M22.147,34.693 L22.147,34.694 C21.965,35.627 21.14,36.305 20.186,36.305 C19.083,36.305 18.186,35.408 18.186,34.305 C18.186,33.202 19.083,32.305 20.186,32.305 C21.288,32.305 22.186,33.202 22.186,34.305 C22.186,34.437 22.173,34.568 22.147,34.693 L22.147,34.693 Z M16.754,13.503 C17.856,13.503 18.754,14.4 18.754,15.503 C18.754,16.606 17.856,17.503 16.754,17.503 C15.651,17.503 14.754,16.606 14.754,15.503 C14.754,14.4 15.651,13.503 16.754,13.503 L16.754,13.503 Z M38.655,21.921 C38.655,19.716 36.861,17.921 34.655,17.921 C34.537,17.921 34.426,17.946 34.311,17.956 C32.172,14.216 28.25,11.921 23.899,11.921 C22.417,11.921 20.984,12.202 19.621,12.724 C18.894,11.974 17.879,11.503 16.754,11.503 C14.548,11.503 12.754,13.297 12.754,15.503 C12.754,16.389 13.053,17.201 13.542,17.864 C12.468,19.698 11.899,21.775 11.899,23.921 C11.899,27.57 13.524,30.941 16.35,33.233 C16.254,33.576 16.186,33.931 16.186,34.305 C16.186,36.511 17.979,38.305 20.186,38.305 C21.843,38.305 23.303,37.28 23.899,35.786 L23.899,35.921 C29.893,35.921 34.859,31.5 35.745,25.751 C37.419,25.273 38.655,23.747 38.655,21.921 L38.655,21.921 Z M23.899,25.921 C22.797,25.921 21.899,25.024 21.899,23.921 C21.899,22.818 22.797,21.921 23.899,21.921 C25.002,21.921 25.899,22.818 25.899,23.921 C25.899,25.024 25.002,25.921 23.899,25.921 L23.899,25.921 Z M23.899,19.921 C21.693,19.921 19.899,21.716 19.899,23.921 C19.899,26.127 21.693,27.921 23.899,27.921 C26.105,27.921 27.899,26.127 27.899,23.921 C27.899,21.716 26.105,19.921 23.899,19.921 L23.899,19.921 Z" id="Fill-1" fill="#ED7100"></path>
    </g>
</svg>`, G_ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Analytics/Res_Amazon-OpenSearch-Service_Observability_48</title>
    <g id="Icon-Resource/Analytics/Res_Amazon-OpenSearch-Service_Observability_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M25,27 L27,27 L27,20 L25,20 L25,27 Z M21,22 L21,17 L23,17 L23,19 L23,27 L21,27 L21,22 Z M17,27 L19,27 L19,23 L17,23 L17,27 Z M28,29 C28.553,29 29,28.552 29,28 L29,19 C29,18.448 28.553,18 28,18 L25,18 L25,16 C25,15.448 24.553,15 24,15 L20,15 C19.447,15 19,15.448 19,16 L19,21 L16,21 C15.447,21 15,21.448 15,22 L15,28 C15,28.552 15.447,29 16,29 L28,29 Z M39.37,17.263 L41.3,16.737 C41.765,18.444 42,20.215 42,22 C42,24.545 41.528,27.025 40.599,29.369 L38.739,28.631 C39.576,26.523 40,24.292 40,22 C40,20.393 39.788,18.798 39.37,17.263 L39.37,17.263 Z M28.632,38.739 L29.368,40.599 C27.023,41.528 24.544,42 22,42 C15.467,42 9.425,38.825 5.699,33.58 L5.345,35.195 L3.392,34.766 L4.317,30.549 C4.374,30.289 4.531,30.064 4.755,29.921 C4.978,29.777 5.248,29.728 5.509,29.787 L9.727,30.713 L9.297,32.666 L7.178,32.201 C10.518,37.051 16.03,40 22,40 C24.291,40 26.521,39.576 28.632,38.739 L28.632,38.739 Z M4.63,26.737 L2.7,27.263 C2.235,25.556 2,23.785 2,22 C2,10.972 10.972,2 22,2 C28.533,2 34.575,5.175 38.301,10.419 L38.655,8.805 L40.608,9.234 L39.683,13.451 C39.626,13.71 39.469,13.936 39.245,14.079 C39.083,14.183 38.896,14.237 38.706,14.237 C38.635,14.237 38.563,14.229 38.491,14.213 L34.273,13.287 L34.703,11.334 L36.822,11.799 C33.482,6.949 27.97,4 22,4 C12.075,4 4,12.075 4,22 C4,23.607 4.212,25.202 4.63,26.737 L4.63,26.737 Z M43.271,43.225 C42.329,44.166 40.679,44.166 39.737,43.225 L29.991,33.479 C31.367,32.519 32.563,31.32 33.518,29.94 L43.271,39.692 C44.244,40.666 44.244,42.251 43.271,43.225 L43.271,43.225 Z M10,22 C10,15.383 15.383,10 22,10 C28.617,10 34,15.383 34,22 C34,28.617 28.617,34 22,34 C15.383,34 10,28.617 10,22 L10,22 Z M44.685,38.278 L34.557,28.151 C35.472,26.291 36,24.208 36,22 C36,14.28 29.72,8 22,8 C14.28,8 8,14.28 8,22 C8,29.72 14.28,36 22,36 C24.232,36 26.337,35.461 28.212,34.528 L38.323,44.639 C39.171,45.488 40.301,45.955 41.504,45.955 C42.707,45.955 43.837,45.488 44.685,44.639 C46.438,42.885 46.438,40.032 44.685,38.278 L44.685,38.278 Z" id="Fill-1" fill="#8C4FFF"></path>
    </g>
</svg>`, j_ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Analytics/Res_Amazon-Redshift_RA3_48</title>
    <g id="Icon-Resource/Analytics/Res_Amazon-Redshift_RA3_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M40,17 L44,17 L44,13 L40,13 L40,17 Z M26.069,17.883 L30.369,10 L33,10 C33.133,10 33.258,9.971 33.373,9.925 L38,13.401 L38,14.702 L26.069,17.883 Z M36.826,28.035 L36.802,28.035 C36.802,29.911 31.544,32 24,32 C16.929,32 11.946,30.24 11.07,28.524 C11.267,26.456 16.059,24.22 23,24.02 L23,29 L25,29 L25,24.02 C31.411,24.204 35.99,26.115 36.826,28.035 L36.826,28.035 Z M24,44 C16.015,44 11.072,41.794 11.072,39.75 L11.072,39.748 L11.056,31.266 C13.879,33.135 19.071,34 24,34 C29.147,34 34.33,32.993 36.983,31.048 L37,39.75 C37,41.794 32.029,44 24,44 L24,44 Z M10,13.301 L14.708,9.941 C14.802,9.97 14.896,10 15,10 L17.781,10 L22.081,17.883 L10,14.662 L10,13.301 Z M4,17 L8,17 L8,13 L4,13 L4,17 Z M16,4 L20,4 L20,8 L18.969,8 L18.953,7.971 L18.9,8 L16,8 L16,4 Z M22,9 L22,7 L26,7 L26,9 C26,9.552 26.447,10 27,10 L28.091,10 L24.075,17.362 L20.06,10 L21,10 C21.553,10 22,9.552 22,9 L22,9 Z M28,4 L32,4 L32,8 L29.25,8 L29.197,7.971 L29.182,8 L28,8 L28,4 Z M45,11 L39,11 C38.776,11 38.581,11.087 38.414,11.211 L34,7.895 L34,3 C34,2.448 33.553,2 33,2 L27,2 C26.447,2 26,2.448 26,3 L26,5 L22,5 L22,3 C22,2.448 21.553,2 21,2 L15,2 C14.447,2 14,2.448 14,3 L14,7.989 L9.534,11.176 C9.377,11.074 9.201,11 9,11 L3,11 C2.447,11 2,11.448 2,12 L2,18 C2,18.552 2.447,19 3,19 L9,19 C9.553,19 10,18.552 10,18 L10,16.732 L23,20.199 L23,22.021 C14.982,22.236 9.051,25.012 9.051,28.657 L9.051,28.816 L9.037,28.82 C9.041,28.833 9.048,28.843 9.051,28.855 L9.072,39.752 C9.074,43.489 15.073,46 24,46 C31.466,46 39,44.067 39,39.748 L38.979,28.655 C38.979,25.012 33.034,22.236 25,22.021 L25,20.239 L38,16.772 L38,18 C38,18.552 38.447,19 39,19 L45,19 C45.553,19 46,18.552 46,18 L46,12 C46,11.448 45.553,11 45,11 L45,11 Z M29.127,41.836 C28.659,41.836 28.212,41.722 27.786,41.494 L27.786,40.792 C28.29,41.002 28.722,41.107 29.082,41.107 C29.43,41.107 29.697,41.004 29.883,40.797 C30.069,40.59 30.162,40.297 30.162,39.919 C30.162,39.559 30.073,39.283 29.896,39.091 C29.72,38.899 29.46,38.803 29.118,38.803 C28.938,38.803 28.722,38.818 28.47,38.848 L28.47,38.272 L29.955,36.202 L27.858,36.202 L27.858,35.482 L30.81,35.482 L30.81,36.148 L29.379,38.137 C29.877,38.143 30.274,38.307 30.571,38.628 C30.868,38.949 31.017,39.379 31.017,39.919 C31.017,40.513 30.849,40.981 30.513,41.323 C30.177,41.665 29.715,41.836 29.127,41.836 L29.127,41.836 Z M23.322,39.37 L24.871,39.37 L24.097,36.319 L23.322,39.37 Z M25.474,41.719 L25.042,40.036 L23.16,40.036 L22.737,41.719 L21.847,41.719 L23.646,35.482 L24.592,35.482 L26.392,41.719 L25.474,41.719 Z M17.688,38.506 L18.58,38.506 C18.874,38.506 19.101,38.404 19.259,38.2 C19.418,37.996 19.498,37.705 19.498,37.327 C19.498,36.955 19.42,36.67 19.264,36.472 C19.107,36.274 18.889,36.175 18.606,36.175 L17.688,36.175 L17.688,38.506 Z M16.852,41.719 L16.852,35.482 L18.696,35.482 C19.201,35.482 19.605,35.647 19.912,35.977 C20.218,36.307 20.371,36.754 20.371,37.318 C20.371,37.727 20.277,38.079 20.092,38.376 C19.905,38.673 19.642,38.893 19.3,39.037 L20.677,41.719 L19.741,41.719 L18.49,39.199 L17.688,39.199 L17.688,41.719 L16.852,41.719 Z" id="Fill-1" fill="#8C4FFF"></path>
    </g>
</svg>`, q_ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Analytics/Res_Amazon-Redshift_Streaming-Ingestion_48</title>
    <g id="Icon-Resource/Analytics/Res_Amazon-Redshift_Streaming-Ingestion_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M9,43 C9,42.449 8.552,42 8,42 C7.448,42 7,42.449 7,43 C7,43.551 7.448,44 8,44 C8.552,44 9,43.551 9,43 L9,43 Z M11,34 C11,34.551 11.448,35 12,35 C12.552,35 13,34.551 13,34 C13,33.449 12.552,33 12,33 C11.448,33 11,33.449 11,34 L11,34 Z M21,36 C21,36.551 21.448,37 22,37 C22.552,37 23,36.551 23,36 C23,35.449 22.552,35 22,35 C21.448,35 21,35.449 21,36 L21,36 Z M24,27 C24,27.551 24.448,28 25,28 C25.552,28 26,27.551 26,27 C26,26.449 25.552,26 25,26 C24.448,26 24,26.449 24,27 L24,27 Z M10.211,40.99 C10.696,41.523 11,42.224 11,43 C11,44.654 9.654,46 8,46 C6.346,46 5,44.654 5,43 C5,41.346 6.346,40 8,40 C8.151,40 8.295,40.023 8.44,40.044 L10.054,36.264 C9.414,35.714 9,34.908 9,34 C9,32.346 10.346,31 12,31 C13.654,31 15,32.346 15,34 C15,34.023 14.994,34.045 14.993,34.068 L19.178,35.02 C19.587,33.848 20.691,33 22,33 C22.013,33 22.024,33.004 22.037,33.004 L23.405,29.531 C22.564,28.999 22,28.067 22,27 C22,25.346 23.346,24 25,24 C26.654,24 28,25.346 28,27 C28,28.522 26.857,29.769 25.386,29.961 L23.91,33.706 C24.57,34.257 25,35.075 25,36 C25,37.654 23.654,39 22,39 C20.727,39 19.643,38.199 19.208,37.077 L14.259,35.952 C13.709,36.589 12.905,37 12,37 C11.972,37 11.946,36.993 11.918,36.992 L10.211,40.99 Z M31.291,11.986 L30.709,13.899 C32.97,14.586 34,15.497 34,16.052 C34,16.607 32.97,17.517 30.709,18.205 L31.291,20.118 C32.375,19.788 33.278,19.389 34,18.939 L34,41 C34,41.711 32.578,42.636 30.165,43.271 C30.004,43.313 29.844,43.355 29.677,43.394 C29.459,43.445 29.238,43.494 29.007,43.54 C28.635,43.612 28.253,43.676 27.861,43.731 C27.711,43.753 27.558,43.773 27.404,43.792 C26.93,43.85 26.448,43.898 25.954,43.931 C25.861,43.938 25.764,43.942 25.669,43.948 C25.119,43.979 24.563,44 24,44 C17.988,44 14,42.216 14,41.036 L14,39 L12,39 L12,41.036 C12,44.295 18.037,46 24,46 C24.61,46 25.219,45.977 25.824,45.942 C25.908,45.937 25.992,45.934 26.075,45.928 C26.631,45.891 27.178,45.836 27.718,45.768 C27.839,45.753 27.959,45.738 28.079,45.721 C28.588,45.65 29.086,45.568 29.569,45.47 C29.698,45.444 29.82,45.415 29.946,45.387 C30.362,45.295 30.767,45.194 31.155,45.082 C31.221,45.063 31.296,45.049 31.361,45.03 L31.36,45.026 C34.091,44.197 36,42.846 36,41 L36,16 L35.994,16 C35.959,14.324 34.296,12.899 31.291,11.986 L31.291,11.986 Z M14,18.894 C14.601,19.284 15.317,19.639 16.169,19.942 L16.841,18.059 C14.878,17.359 14,16.485 14,15.929 C14,15.438 14.731,14.626 16.792,13.95 L16.169,12.05 C12.542,13.24 12,14.991 12,15.929 C12,15.953 12.008,15.976 12.008,16 L12,16 L12,29 L14,29 L14,18.894 Z M41.999,4 L43.999,4 L43.999,2 L41.999,2 L41.999,4 Z M37.999,4 L39.999,4 L39.999,2 L37.999,2 L37.999,4 Z M8,8 L10,8 L10,6 L8,6 L8,8 Z M4,8 L6,8 L6,6 L4,6 L4,8 Z M27,20 L29,20 L29,6 L12,6 L12,8 L27,8 L27,20 Z M19,20 L21,20 L21,10 L19,10 L19,20 Z M20,4 L35.999,4 L35.999,2 L20,2 L20,4 Z M23,22 L25,22 L25,11 L23,11 L23,22 Z" id="Fill-1" fill="#8C4FFF"></path>
    </g>
</svg>`, K_ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Analytics/Res_Amazon-EMR_EMR-Engine_48</title>
    <g id="Icon-Resource/Analytics/Res_Amazon-EMR_EMR-Engine_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M44.065,34.99 C44.065,35.503 43.638,35.92 43.114,35.92 L40.881,35.92 C40.357,35.92 39.93,35.503 39.93,34.99 L39.93,33.415 C39.93,32.862 39.483,32.415 38.93,32.415 L34.548,32.415 C33.996,32.415 33.548,32.862 33.548,33.415 L33.548,35.795 C33.548,37.313 32.305,38.549 30.778,38.549 L23.74,38.549 C22.198,38.549 20.943,37.313 20.943,35.795 L20.943,35.167 C20.943,34.614 20.496,34.167 19.943,34.167 L8.905,34.167 C8.616,34.167 8.381,33.94 8.381,33.661 L8.381,17.747 C8.381,17.233 8.809,16.815 9.335,16.815 L15.232,16.815 C15.785,16.815 16.232,16.368 16.232,15.815 L16.232,13.877 C16.232,13.603 16.462,13.382 16.745,13.382 L26.026,13.382 C26.308,13.382 26.538,13.603 26.538,13.877 L26.538,15.815 C26.538,16.368 26.985,16.815 27.538,16.815 L32.622,16.815 C33.147,16.815 33.575,17.233 33.575,17.747 L33.575,19.468 C33.575,20.02 34.022,20.468 34.575,20.468 L38.898,20.468 C39.451,20.468 39.898,20.02 39.898,19.468 L39.898,17.868 C39.898,17.355 40.325,16.938 40.85,16.938 L43.114,16.938 C43.638,16.938 44.065,17.355 44.065,17.868 L44.065,34.99 Z M43.114,14.938 L40.85,14.938 C39.222,14.938 37.898,16.253 37.898,17.868 L37.898,18.468 L35.575,18.468 L35.575,17.747 C35.575,16.131 34.25,14.815 32.622,14.815 L28.538,14.815 L28.538,13.877 C28.538,12.501 27.411,11.382 26.026,11.382 L22.403,11.382 L22.403,9 L27.538,9 L27.538,7 L15.269,7 L15.269,9 L20.403,9 L20.403,11.382 L16.745,11.382 C15.359,11.382 14.232,12.501 14.232,13.877 L14.232,14.815 L9.335,14.815 C7.707,14.815 6.381,16.131 6.381,17.747 L6.381,24.527 L4,24.527 L4,15.887 L2,15.887 L2,35.167 L4,35.167 L4,26.527 L6.381,26.527 L6.381,33.661 C6.381,35.043 7.513,36.167 8.905,36.167 L18.958,36.167 C19.15,38.615 21.221,40.549 23.74,40.549 L30.778,40.549 C33.409,40.549 35.548,38.416 35.548,35.795 L35.548,34.415 L37.93,34.415 L37.93,34.99 C37.93,36.605 39.254,37.92 40.881,37.92 L43.114,37.92 C44.741,37.92 46.065,36.605 46.065,34.99 L46.065,17.868 C46.065,16.253 44.741,14.938 43.114,14.938 L43.114,14.938 Z" id="Icon-Resource/48/Amazon-EMR_EMR-Engine" fill="#8C4FFF"></path>
    </g>
</svg>`, Ni = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Analytics/Res_Amazon-Redshift_Query-Editor-v2.0_48</title>
    <g id="Icon-Resource/Analytics/Res_Amazon-Redshift_Query-Editor-v2.0_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M16,4 C24.029,4 29,6.076 29,8 C29,9.924 24.029,12 16,12 C8.122,12 4,9.988 4,8 C4,6.012 8.122,4 16,4 M16,44 C8.486,44 4,42.505 4,40 L4,33.438 C6.053,35.152 9.693,36 15,36 L15,34 C4,34 4,30.237 4,29 L4,21.438 C6.053,23.152 9.693,24 15,24 L15,22 C4,22 4,18.237 4,17 L4,11.408 C6.299,13.055 10.475,14 16,14 C21.118,14 26.268,13.127 29,11.243 L29,15 L31,15 L31,8 C31,3.855 23.466,2 16,2 C7.364,2 2,4.299 2,8 L2,40 C2,42.737 4.429,46 16,46 C22.104,46 26.202,45.296 28.528,43.849 L27.472,42.151 C25.5,43.378 21.641,44 16,44 M43.583,43.583 C43.303,43.863 42.973,44.045 42.678,44.083 C42.449,44.111 42.261,44.053 42.115,43.908 L35.931,37.579 C36.534,37.085 37.087,36.533 37.58,35.929 L43.914,42.093 C44.064,42.243 44.122,42.43 44.091,42.665 C44.051,42.966 43.865,43.301 43.583,43.583 M19,28.6 C19,23.306 23.307,19 28.6,19 C33.893,19 38.199,23.306 38.199,28.6 C38.199,33.893 33.893,38.199 28.6,38.199 C23.307,38.199 19,33.893 19,28.6 M45.318,40.669 L38.722,34.249 C39.659,32.575 40.199,30.65 40.199,28.6 C40.199,22.204 34.996,17 28.6,17 C22.203,17 17,22.204 17,28.6 C17,34.996 22.203,40.199 28.6,40.199 C30.651,40.199 32.577,39.659 34.251,38.72 L40.693,45.314 C41.2,45.821 41.854,46.09 42.563,46.09 C42.685,46.09 42.808,46.083 42.931,46.067 C43.667,45.973 44.401,45.593 44.997,44.998 C45.593,44.402 45.975,43.668 46.073,42.93 C46.187,42.073 45.923,41.273 45.318,40.669 M28.6,34 C25.571,34 23.199,31.628 23.199,28.6 C23.199,25.571 25.571,23.199 28.6,23.199 C31.628,23.199 34,25.571 34,28.6 C34,31.628 31.628,34 28.6,34 M28.6,21.199 C24.45,21.199 21.199,24.45 21.199,28.6 C21.199,32.75 24.45,36 28.6,36 C32.749,36 36,32.75 36,28.6 C36,24.45 32.749,21.199 28.6,21.199" id="Fill-6" fill="#8C4FFF"></path>
    </g>
</svg>`, Y_ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Analytics/Res_Amazon-EMR_HDFS-Cluster_48</title>
    <g id="Icon-Resource/Analytics/Res_Amazon-EMR_HDFS-Cluster_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M36.931,26.479 C36.443,26.545 36.061,26.946 36.061,27.453 L36.061,30.431 L33.733,29.655 L36.418,25.73 L36.931,26.479 Z M38.061,34.313 L43.921,34.313 L43.921,28.453 L38.061,28.453 L38.061,34.313 Z M33.694,39.452 L33.694,37.059 C33.694,36.506 33.246,36.059 32.694,36.059 L29.35,36.059 L32.558,31.371 L36.061,32.54 L36.061,35.313 C36.061,35.866 36.508,36.313 37.061,36.313 L37.895,36.313 C36.377,37.464 34.816,38.624 33.694,39.452 L33.694,39.452 Z M25.835,43.919 L31.694,43.919 L31.694,38.059 L25.835,38.059 L25.835,43.919 Z M4,29.946 L15.974,29.946 L15.974,17.972 L4,17.972 L4,29.946 Z M25.834,9.859 L31.693,9.859 L31.693,4 L25.834,4 L25.834,9.859 Z M37.896,11.606 L37.061,11.606 C36.508,11.606 36.061,12.053 36.061,12.606 L36.061,15.378 L32.558,16.547 L29.35,11.859 L32.694,11.859 C33.246,11.859 33.694,11.412 33.694,10.859 L33.694,8.467 C34.816,9.294 36.378,10.455 37.896,11.606 L37.896,11.606 Z M38.061,19.466 L43.921,19.466 L43.921,13.606 L38.061,13.606 L38.061,19.466 Z M33.732,18.263 L36.061,17.486 L36.061,20.466 C36.061,20.973 36.443,21.374 36.931,21.44 L36.418,22.189 L33.732,18.263 Z M17.974,24.4 L17.974,23.518 L31.759,18.92 L35.206,23.959 L31.759,28.998 L17.974,24.4 Z M24.243,11.643 C24.41,11.77 24.608,11.859 24.834,11.859 L26.927,11.859 L30.585,17.205 L17.974,21.41 L17.974,16.972 C17.974,16.901 17.948,16.838 17.934,16.772 L24.243,11.643 Z M24.834,36.059 C24.608,36.059 24.41,36.148 24.242,36.275 L17.934,31.146 C17.948,31.08 17.974,31.017 17.974,30.946 L17.974,26.507 L30.585,30.713 L26.927,36.059 L24.834,36.059 Z M39.335,21.466 L44.921,21.466 C45.474,21.466 45.921,21.019 45.921,20.466 L45.921,12.606 C45.921,12.053 45.474,11.606 44.921,11.606 L41.178,11.606 C38.557,9.558 34.9,6.869 33.694,5.985 L33.694,3 C33.694,2.447 33.246,2 32.694,2 L24.834,2 C24.282,2 23.834,2.447 23.834,3 L23.834,9.396 L15.745,15.972 L3,15.972 C2.448,15.972 2,16.419 2,16.972 L2,30.946 C2,31.499 2.448,31.946 3,31.946 L15.745,31.946 L23.834,38.523 L23.834,44.919 C23.834,45.472 24.282,45.919 24.834,45.919 L32.694,45.919 C33.246,45.919 33.694,45.472 33.694,44.919 L33.694,41.934 C34.9,41.049 38.556,38.36 41.178,36.313 L44.921,36.313 C45.474,36.313 45.921,35.866 45.921,35.313 L45.921,27.453 C45.921,26.9 45.474,26.453 44.921,26.453 L39.335,26.453 L37.629,23.959 L39.335,21.466 Z" id="Icon-Resource/48/Amazon-EMR_Cluster" fill="#8C4FFF"></path>
    </g>
</svg>`, Q_ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Analytics/Res_Amazon-MSK_Amazon-MSK-Connect_48</title>
    <g id="Icon-Resource/Analytics/Res_Amazon-MSK_Amazon-MSK-Connect_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M29.035,38.3799 L30.133,39.4029 L23.998,45.9999 L17.865,39.4029 L18.964,38.3799 L23,42.7229 L23,27.1029 L7.961,19.3869 L9.981,24.9579 L8.569,25.4689 L5.501,16.9989 L14.17,14.5539 L14.579,15.9979 L8.871,17.6069 L24,25.3689 L39.126,17.6079 L33.422,15.9999 L33.83,14.5549 L42.501,17.0019 L39.431,25.4699 L38.019,24.9599 L40.041,19.3849 L25,27.1029 L25,42.7199 L29.035,38.3799 Z M41.5,37.9999 C40.121,37.9999 39,36.8789 39,35.4999 C39,34.1219 40.121,32.9999 41.5,32.9999 C42.879,32.9999 44,34.1219 44,35.4999 C44,36.8789 42.879,37.9999 41.5,37.9999 L41.5,37.9999 Z M41.5,30.9999 C40.984,30.9999 40.496,31.1049 40.035,31.2659 L35.473,23.9699 L33.778,25.0299 L38.33,32.3109 C37.738,32.8999 37.315,33.6539 37.122,34.4949 L27,34.4949 L27,36.4949 L37.119,36.4949 C37.574,38.4979 39.361,39.9999 41.5,39.9999 C43.981,39.9999 46,37.9819 46,35.4999 C46,33.0189 43.981,30.9999 41.5,30.9999 L41.5,30.9999 Z M6.5,37.9999 C5.121,37.9999 4,36.8789 4,35.4999 C4,34.1219 5.121,32.9999 6.5,32.9999 C7.879,32.9999 9,34.1219 9,35.4999 C9,36.8789 7.879,37.9999 6.5,37.9999 L6.5,37.9999 Z M21,36.4949 L21,34.4949 L10.878,34.4949 C10.684,33.6539 10.262,32.8999 9.67,32.3109 L14.222,25.0299 L12.526,23.9699 L7.965,31.2659 C7.503,31.1049 7.015,30.9999 6.5,30.9999 C4.018,30.9999 2,33.0189 2,35.4999 C2,37.9819 4.018,39.9999 6.5,39.9999 C8.639,39.9999 10.426,38.4979 10.881,36.4949 L21,36.4949 Z M24,4.9999 C25.379,4.9999 26.5,6.1219 26.5,7.4999 C26.5,8.8789 25.379,9.9999 24,9.9999 C22.621,9.9999 21.5,8.8789 21.5,7.4999 C21.5,6.1219 22.621,4.9999 24,4.9999 L24,4.9999 Z M17.453,19.8629 L22.536,11.7349 C22.997,11.8949 23.484,11.9999 24,11.9999 C24.515,11.9999 25.003,11.8949 25.465,11.7339 L30.547,19.8629 L32.242,18.8019 L27.17,10.6899 C27.99,9.8739 28.5,8.7459 28.5,7.4999 C28.5,5.0189 26.481,2.9999 24,2.9999 C21.518,2.9999 19.5,5.0189 19.5,7.4999 C19.5,8.7459 20.01,9.8739 20.831,10.6899 L15.758,18.8019 L17.453,19.8629 Z" id="Fill-1" fill="#8C4FFF"></path>
    </g>
</svg>`, X_ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Analytics/Res_AWS-Glue_Data-Catalog_48</title>
    <g id="Icon-Resource/Analytics/Res_AWS-Glue_Data-Catalog_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M21.306,18.375 C23.678,18.932 26.68,19 28,19 C29.321,19 32.323,18.932 34.695,18.375 L29,29.764 L29,33 L27,33 L27,29.764 L21.306,18.375 Z M28,15 C31.95,15 34.573,15.561 35.617,16 C34.573,16.441 31.95,17 28,17 C24.051,17 21.429,16.441 20.384,16 C21.429,15.561 24.051,15 28,15 L28,15 Z M31,35 L31,30.236 L37.642,16.952 C37.868,16.674 38,16.359 38,16 C38,13.217 30.346,13 28,13 C25.655,13 18,13.217 18,16 C18,16.359 18.131,16.674 18.358,16.952 L25,30.236 L25,35 L31,35 Z M4,2 L9,2 L9,4 L6,4 L6,44 L9,44 L9,46 L4,46 L4,2 Z M16,42 L40,42 L40,40 L16,40 L16,42 Z M16,38 L40,38 L40,36 L16,36 L16,38 Z M16,12 L40,12 L40,10 L16,10 L16,12 Z M16,8 L40,8 L40,6 L16,6 L16,8 Z M13,44 L42,44 L42,4 L13,4 L13,44 Z M11,46 L44,46 L44,2 L11,2 L11,46 Z" id="Icon-Resource/48/AWS-Glue_Data-Catalog" fill="#8C4FFF"></path>
    </g>
</svg>`, J_ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Analytics/Res_Amazon-DataZone_Data-Portal_48</title>
    <g id="Icon-Resource/Analytics/Res_Amazon-DataZone_Data-Portal_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M16,34.999 L18,34.999 L18,32.999 L16,32.999 L16,34.999 Z M15,30.999 C14.447,30.999 14,31.447 14,31.999 L14,35.999 C14,36.551 14.447,36.999 15,36.999 L19,36.999 C19.553,36.999 20,36.551 20,35.999 L20,31.999 C20,31.447 19.553,30.999 19,30.999 L15,30.999 Z M24,26 L26,26 L26,24 L24,24 L24,26 Z M28,27 L28,23 C28,22.448 27.553,22 27,22 L23,22 C22.447,22 22,22.448 22,23 L22,27 C22,27.552 22.447,28 23,28 L27,28 C27.553,28 28,27.552 28,27 L28,27 Z M26,38 L30,38 L30,34 L26,34 L26,38 Z M25,40 L31,40 C31.553,40 32,39.552 32,39 L32,33 C32,32.448 31.553,32 31,32 L25,32 C24.447,32 24,32.448 24,33 L24,39 C24,39.552 24.447,40 25,40 L25,40 Z M36,30 L38,30 L38,28 L36,28 L36,30 Z M35,26 C34.447,26 34,26.448 34,27 L34,31 C34,31.552 34.447,32 35,32 L39,32 C39.553,32 40,31.552 40,31 L40,27 C40,26.448 39.553,26 39,26 L35,26 Z M20,6 L18,6 L18,4 L20,4 L20,2 L22,2 L22,4 L24,4 L24,6 L22,6 L22,8 L20,8 L20,6 Z M39.413,13.389 C40.205,13.389 40.982,13.61 41.66,14.03 C42.716,14.685 43.456,15.772 43.72,17 L35.104,17 C35.543,14.937 37.309,13.389 39.413,13.389 L39.413,13.389 Z M39.413,7 C40.56,7 41.492,7.933 41.492,9.08 C41.492,10.226 40.56,11.159 39.413,11.159 C38.267,11.159 37.334,10.226 37.334,9.08 C37.334,7.933 38.267,7 39.413,7 L39.413,7 Z M33,18 C33,18.552 33.447,19 34,19 L44.826,19 C45.379,19 45.826,18.552 45.826,18 C45.826,15.692 44.634,13.52 42.713,12.33 C42.543,12.225 42.364,12.141 42.187,12.053 C42.985,11.307 43.492,10.255 43.492,9.08 C43.492,6.83 41.662,5 39.413,5 C37.164,5 35.334,6.83 35.334,9.08 C35.334,10.253 35.84,11.305 36.636,12.05 C34.489,13.12 33,15.381 33,18 L33,18 Z M30.413,4 C31.56,4 32.492,4.933 32.492,6.08 C32.492,7.226 31.56,8.159 30.413,8.159 C29.267,8.159 28.334,7.226 28.334,6.08 C28.334,4.933 29.267,4 30.413,4 L30.413,4 Z M24,15 C24,15.552 24.447,16 25,16 L32,16 L32,14 L26.104,14 C26.543,11.937 28.309,10.389 30.413,10.389 C31.205,10.389 31.982,10.61 32.66,11.03 L33.713,9.33 C33.543,9.225 33.364,9.141 33.187,9.053 C33.985,8.307 34.492,7.255 34.492,6.08 C34.492,3.83 32.662,2 30.413,2 C28.164,2 26.334,3.83 26.334,6.08 C26.334,7.253 26.84,8.305 27.636,9.05 C25.489,10.12 24,12.381 24,15 L24,15 Z M4,44 L4,18 L8,18 L8,44.011 L4.086,44.012 C4.056,44 4.001,43.943 4,44 L4,44 Z M44,21 L44.013,43.915 C43.999,43.946 43.947,43.999 44,44 L10,44.01 L10,18 L21.999,18 L21.999,16 L4,16 L4,12 L4.001,12 L22,12 L22,10 L4.001,10 C2.86,10 2,10.791 2,11.84 L2,44 C2,45.022 2.969,45.994 4,46 L44,46 C45.028,46 46,45.028 46,44 L46,21 L44,21 Z" id="Fill-1" fill="#8C4FFF"></path>
    </g>
</svg>`, ev = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Analytics/Res_Amazon-DataZone_Business-Data-Catalog_48</title>
    <g id="Icon-Resource/Analytics/Res_Amazon-DataZone_Business-Data-Catalog_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M36,30 C35.448,30 35,29.551 35,29 C35,28.449 35.448,28 36,28 C36.552,28 37,28.449 37,29 C37,29.551 36.552,30 36,30 L36,30 Z M28,30 C27.448,30 27,29.551 27,29 C27,28.449 27.448,28 28,28 C28.552,28 29,28.449 29,29 C29,29.551 28.552,30 28,30 L28,30 Z M20,30 C19.448,30 19,29.551 19,29 C19,28.449 19.448,28 20,28 C20.552,28 21,28.449 21,29 C21,29.551 20.552,30 20,30 L20,30 Z M28,17 C28.552,17 29,17.449 29,18 C29,18.551 28.552,19 28,19 C27.448,19 27,18.551 27,18 C27,17.449 27.448,17 28,17 L28,17 Z M33,29 C33,30.654 34.346,32 36,32 C37.654,32 39,30.654 39,29 C39,27.698 38.161,26.598 37,26.184 L37,23 C37,22.448 36.553,22 36,22 L29,22 L29,20.816 C30.161,20.402 31,19.302 31,18 C31,16.346 29.654,15 28,15 C26.346,15 25,16.346 25,18 C25,19.302 25.839,20.402 27,20.816 L27,22 L20,22 C19.447,22 19,22.448 19,23 L19,26.184 C17.839,26.598 17,27.698 17,29 C17,30.654 18.346,32 20,32 C21.654,32 23,30.654 23,29 C23,27.698 22.161,26.598 21,26.184 L21,24 L27,24 L27,26.184 C25.839,26.598 25,27.698 25,29 C25,30.654 26.346,32 28,32 C29.654,32 31,30.654 31,29 C31,27.698 30.161,26.598 29,26.184 L29,24 L35,24 L35,26.184 C33.839,26.598 33,27.698 33,29 L33,29 Z M5,2 L9,2 L9,4 L6,4 L6,44 L9,44 L9,46 L5,46 C4.447,46 4,45.552 4,45 L4,3 C4,2.448 4.447,2 5,2 L5,2 Z M16,42 L40,42 L40,40 L16,40 L16,42 Z M16,38 L40,38 L40,36 L16,36 L16,38 Z M16,12 L40,12 L40,10 L16,10 L16,12 Z M16,8 L40,8 L40,6 L16,6 L16,8 Z M13,44 L42,44 L42,4 L13,4 L13,44 Z M43,2 L12,2 C11.447,2 11,2.448 11,3 L11,45 C11,45.552 11.447,46 12,46 L43,46 C43.553,46 44,45.552 44,45 L44,3 C44,2.448 43.553,2 43,2 L43,2 Z" id="Fill-1" fill="#8C4FFF"></path>
    </g>
</svg>`, tv = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Analytics/Res_Amazon-DataZone_Data-Projects_48</title>
    <g id="Icon-Resource/Analytics/Res_Amazon-DataZone_Data-Projects_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M21,16 L35,16 L35,14 L21,14 L21,16 Z M21,11 L31,11 L31,9 L21,9 L21,11 Z M38,28 L38,35 L35,35 L35,21 L33,21 L33,35 L30,35 L30,24 L28,24 L28,35 L26,35 L26,37 L42,37 L42,35 L40,35 L40,28 L38,28 Z M19.66,33.03 C18.982,32.61 18.205,32.389 17.413,32.389 C15.309,32.389 13.543,33.937 13.104,36 L21.72,36 C21.456,34.772 20.716,33.685 19.66,33.03 L19.66,33.03 Z M15.334,28.19 C15.334,29.336 16.267,30.27 17.413,30.27 C18.56,30.27 19.492,29.336 19.492,28.19 C19.492,27.043 18.56,26.111 17.413,26.111 C16.267,26.111 15.334,27.043 15.334,28.19 L15.334,28.19 Z M21.492,28.19 C21.492,29.327 21.022,30.355 20.269,31.096 C20.418,31.172 20.57,31.241 20.713,31.33 C22.634,32.52 23.826,34.692 23.826,37 C23.826,37.552 23.379,38 22.826,38 L12,38 C11.447,38 11,37.552 11,37 C11,34.415 12.45,32.178 14.552,31.092 C13.802,30.351 13.334,29.325 13.334,28.19 C13.334,25.941 15.164,24.111 17.413,24.111 C19.662,24.111 21.492,25.941 21.492,28.19 L21.492,28.19 Z M6.334,23.731 C6.334,24.878 7.267,25.811 8.413,25.811 C9.56,25.811 10.492,24.878 10.492,23.731 C10.492,22.585 9.56,21.652 8.413,21.652 C7.267,21.652 6.334,22.585 6.334,23.731 L6.334,23.731 Z M10,34 L3,34 C2.447,34 2,33.552 2,33 C2,30.274 3.609,27.929 5.899,26.919 C4.953,26.171 4.334,25.028 4.334,23.731 C4.334,21.482 6.164,19.652 8.413,19.652 C10.662,19.652 12.492,21.482 12.492,23.731 C12.492,25.027 11.873,26.171 10.928,26.918 C11.198,27.037 11.46,27.174 11.713,27.33 L10.66,29.03 C9.982,28.61 9.205,28.389 8.413,28.389 C6.309,28.389 4.543,29.937 4.104,32 L10,32 L10,34 Z M38,10 L42.586,10 L38,5.414 L38,10 Z M46,11 L46,40 C46,41.122 45.121,42 44,42 L18,42 L18,40 L44,40 L44,12 L37,12 C36.447,12 36,11.552 36,11 L36,4 L18.037,4 L18,22 L16,22 L16,4 C16,2.897 16.914,2 18.037,2 L37,2 C37.266,2 37.52,2.105 37.707,2.293 L45.707,10.293 C45.895,10.48 46,10.735 46,11 L46,11 Z M12,40 L10,40 L10,44 C10,45.103 10.914,46 12.037,46 L37.963,46 L37.963,44 L12,44 L12,40 Z M12,18 L10,18 L10,7 C10,5.897 10.914,5 12.037,5 L14,5 L14,7 L12.037,7 L12,18 Z" id="Fill-1" fill="#8C4FFF"></path>
    </g>
</svg>`, nv = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Analytics/Res_Amazon-Redshift_Dense-Storage-Node_48</title>
    <g id="Icon-Resource/Analytics/Res_Amazon-Redshift_Dense-Storage-Node_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M18.339,24.646 C18.447,24.908 18.502,25.224 18.502,25.595 C18.502,26.315 18.271,26.884 17.804,27.305 C17.338,27.726 16.696,27.935 15.878,27.935 C15.522,27.935 15.165,27.894 14.81,27.811 C14.453,27.728 14.154,27.618 13.912,27.481 L13.912,26.289 C14.193,26.394 14.509,26.483 14.861,26.555 C15.214,26.627 15.514,26.664 15.765,26.664 C16.128,26.664 16.404,26.578 16.594,26.408 C16.783,26.238 16.878,25.993 16.878,25.674 C16.878,25.44 16.812,25.242 16.679,25.079 C16.547,24.916 16.324,24.75 16.014,24.584 L15.401,24.254 C14.841,23.951 14.439,23.625 14.196,23.277 C13.953,22.928 13.832,22.504 13.832,22.004 C13.832,21.542 13.94,21.138 14.152,20.794 C14.362,20.45 14.652,20.184 15.02,19.999 C15.388,19.813 15.81,19.72 16.287,19.72 C16.886,19.72 17.48,19.857 18.07,20.129 L18.07,21.334 C17.457,21.107 16.915,20.993 16.446,20.993 C16.128,20.993 15.878,21.073 15.696,21.232 C15.514,21.391 15.423,21.61 15.423,21.891 C15.423,22.125 15.483,22.319 15.6,22.47 C15.717,22.622 15.943,22.789 16.276,22.97 L16.889,23.3 C17.283,23.512 17.596,23.724 17.827,23.936 C18.058,24.149 18.229,24.384 18.339,24.646 L18.339,24.646 Z M11.288,23.936 C11.288,24.823 11.167,25.48 10.925,25.908 C10.682,26.335 10.315,26.549 9.821,26.549 L9.151,26.549 L9.151,21.107 L9.811,21.107 C10.318,21.107 10.692,21.317 10.93,21.738 C11.168,22.158 11.288,22.815 11.288,23.709 L11.288,23.936 Z M9.936,19.891 L7.561,19.891 L7.561,27.765 L9.992,27.765 C10.947,27.765 11.674,27.432 12.175,26.765 C12.674,26.099 12.924,25.118 12.924,23.823 C12.924,22.535 12.67,21.557 12.163,20.891 C11.655,20.224 10.912,19.891 9.936,19.891 L9.936,19.891 Z M36.959,26.5 C36.471,26.566 36.089,26.967 36.089,27.474 L36.089,30.457 L33.756,29.678 L36.444,25.749 L36.959,26.5 Z M38.089,34.34 L43.956,34.34 L43.956,28.474 L38.089,28.474 L38.089,34.34 Z M33.719,39.485 L33.719,37.088 C33.719,36.536 33.272,36.088 32.719,36.088 L29.37,36.088 L32.582,31.394 L36.089,32.564 L36.089,35.34 C36.089,35.893 36.536,36.34 37.089,36.34 L37.928,36.34 C36.407,37.494 34.842,38.656 33.719,39.485 L33.719,39.485 Z M25.853,43.956 L31.719,43.956 L31.719,38.089 L25.853,38.089 L25.853,43.956 Z M23.104,31.97 C23.656,31.97 24.104,31.523 24.104,30.97 L24.104,28.565 L30.61,30.736 L26.947,36.088 L24.853,36.088 C24.625,36.088 24.427,36.177 24.259,36.304 L18.927,31.97 L23.104,31.97 Z M4,29.97 L22.104,29.97 L22.104,17.985 L4,17.985 L4,29.97 Z M24.259,11.651 C24.427,11.778 24.626,11.867 24.853,11.867 L26.947,11.867 L30.61,17.219 L24.104,19.391 L24.104,16.985 C24.104,16.432 23.656,15.985 23.104,15.985 L18.928,15.985 L24.259,11.651 Z M25.853,9.866 L31.719,9.866 L31.719,4 L25.853,4 L25.853,9.866 Z M37.928,11.615 L37.089,11.615 C36.536,11.615 36.089,12.062 36.089,12.615 L36.089,15.391 L32.582,16.561 L29.37,11.867 L32.719,11.867 C33.272,11.867 33.719,11.419 33.719,10.867 L33.719,8.471 C34.842,9.299 36.407,10.461 37.928,11.615 L37.928,11.615 Z M38.089,19.482 L43.956,19.482 L43.956,13.615 L38.089,13.615 L38.089,19.482 Z M33.756,18.277 L36.089,17.499 L36.089,20.482 C36.089,20.989 36.471,21.39 36.959,21.456 L36.444,22.208 L33.756,18.277 Z M24.104,21.499 L31.783,18.935 L35.234,23.978 L31.783,29.02 L24.104,26.458 L24.104,21.499 Z M39.364,21.482 L44.956,21.482 C45.509,21.482 45.956,21.035 45.956,20.482 L45.956,12.615 C45.956,12.062 45.509,11.615 44.956,11.615 L41.209,11.615 C38.585,9.565 34.926,6.874 33.719,5.989 L33.719,3 C33.719,2.448 33.272,2 32.719,2 L24.853,2 C24.3,2 23.853,2.448 23.853,3 L23.853,9.403 L15.755,15.985 L3,15.985 C2.447,15.985 2,16.432 2,16.985 L2,30.97 C2,31.523 2.447,31.97 3,31.97 L15.755,31.97 L23.853,38.553 L23.853,44.956 C23.853,45.508 24.3,45.956 24.853,45.956 L32.719,45.956 C33.272,45.956 33.719,45.508 33.719,44.956 L33.719,41.967 C34.926,41.083 38.585,38.39 41.209,36.34 L44.956,36.34 C45.509,36.34 45.956,35.893 45.956,35.34 L45.956,27.474 C45.956,26.921 45.509,26.474 44.956,26.474 L39.364,26.474 L37.656,23.978 L39.364,21.482 Z" id="Fill-18" fill="#8C4FFF"></path>
    </g>
</svg>`, iv = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Analytics/Res_AWS-Glue_Data-Quality_48</title>
    <g id="Icon-Resource/Analytics/Res_AWS-Glue_Data-Quality_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M30.283,24.375 L31.845,25.624 L27.845,30.624 C27.648,30.87 27.358,31 27.063,31 C26.873,31 26.679,30.945 26.51,30.832 L23.51,28.832 L24.619,27.167 L26.856,28.659 L30.283,24.375 Z M43.491,43.436 C43.006,43.923 42.272,44.236 41.819,43.783 L35.356,37.168 C36.043,36.612 36.669,35.985 37.225,35.298 L43.846,41.741 C44.286,42.181 44,42.927 43.491,43.436 L43.491,43.436 Z M17.054,27.472 C17.054,21.698 21.753,17 27.527,17 C33.302,17 38,21.698 38,27.472 C38,33.247 33.302,37.944 27.527,37.944 C21.753,37.944 17.054,33.247 17.054,27.472 L17.054,27.472 Z M45.25,40.317 L38.367,33.618 C39.401,31.802 40,29.707 40,27.472 C40,20.595 34.405,15 27.527,15 C20.649,15 15.054,20.595 15.054,27.472 C15.054,34.349 20.649,39.944 27.527,39.944 C29.764,39.944 31.859,39.345 33.676,38.31 L40.397,45.189 C40.935,45.728 41.628,45.992 42.352,45.992 C43.227,45.992 44.149,45.606 44.905,44.85 C46.296,43.459 46.448,41.515 45.25,40.317 L45.25,40.317 Z M27.527,34.689 C23.48,34.689 20.309,31.519 20.309,27.472 C20.309,23.425 23.48,20.254 27.527,20.254 C31.574,20.254 34.745,23.425 34.745,27.472 C34.745,31.519 31.574,34.689 27.527,34.689 L27.527,34.689 Z M27.527,18.254 C22.358,18.254 18.309,22.303 18.309,27.472 C18.309,32.641 22.358,36.689 27.527,36.689 C32.696,36.689 36.745,32.641 36.745,27.472 C36.745,22.303 32.696,18.254 27.527,18.254 L27.527,18.254 Z M16.064,4 C23.687,4 29,6.107 29,8 C29,9.966 24.535,12 17.064,12 C9.365,12 4,9.892 4,8 C4,6.033 8.512,4 16.064,4 L16.064,4 Z M16.135,44 C8.539,44 4,41.878 4,39.828 L4,32.509 C6.288,34.367 10.329,35.646 15.039,35.768 L15.09,33.769 C8.554,33.601 4,31.12 4,29 L4,22.465 C5.92,23.971 9.093,25.051 12.981,25.375 L13.147,23.382 C7.497,22.912 4,20.741 4,19 L4,11.193 C6.785,13.104 12.055,14 17.064,14 C22.441,14 26.668,12.992 29,11.316 L29,13 L31,13 L31,8 C31,3.877 23.258,2 16.064,2 C7.652,2 2,4.411 2,8 L2,39.828 C2,43.52 7.68,46 16.135,46 C22.227,46 27.419,44.68 29.684,42.555 L28.315,41.096 C26.465,42.833 21.569,44 16.135,44 L16.135,44 Z" id="Fill-1" fill="#8C4FFF"></path>
    </g>
</svg>`, sv = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Analytics/Res_AWS-Glue_Crawler_48</title>
    <g id="Icon-Resource/Analytics/Res_AWS-Glue_Crawler_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M34,44 C32.269,44 30.712,42.889 29.615,41.125 L34,38.202 L38.384,41.125 C37.288,42.889 35.73,44 34,44 L34,44 Z M33,28.071 L33,36.465 L28.734,39.31 C28.267,38.028 28,36.561 28,35 C28,30.959 29.81,28.49 33,28.071 L33,28.071 Z M34,24 C34.901,24 35.678,24.955 35.917,26.21 C35.283,26.072 34.639,26 34,26 C33.361,26 32.716,26.072 32.083,26.21 C32.322,24.955 33.099,24 34,24 L34,24 Z M40,35 C40,36.561 39.733,38.028 39.266,39.31 L35,36.465 L35,28.071 C38.19,28.49 40,30.959 40,35 L40,35 Z M46,30 L44,30 C44,31.916 42.85,32.976 41.917,33.523 C41.735,31.78 41.238,30.382 40.521,29.293 C41.597,28.517 43,26.942 43,24 L41,24 C41,26.283 39.864,27.347 39.18,27.785 C38.808,27.472 38.413,27.202 37.998,26.977 C37.994,25.965 37.748,25.024 37.329,24.238 C37.832,23.759 38.422,22.989 38.749,21.852 C39.48,21.555 40,20.838 40,20 C40,18.898 39.103,18 38,18 C36.897,18 36,18.898 36,20 C36,20.624 36.293,21.175 36.742,21.542 C36.545,22.083 36.271,22.469 36.03,22.717 C35.434,22.272 34.744,22 34,22 C33.256,22 32.566,22.272 31.969,22.717 C31.729,22.469 31.454,22.083 31.258,21.542 C31.707,21.175 32,20.624 32,20 C32,18.898 31.103,18 30,18 C28.897,18 28,18.898 28,20 C28,20.838 28.519,21.555 29.251,21.852 C29.578,22.989 30.168,23.759 30.67,24.238 C30.252,25.024 30.006,25.965 30.002,26.977 C29.585,27.203 29.188,27.475 28.814,27.791 C28.133,27.353 27,26.282 27,24 L25,24 C25,26.942 26.402,28.517 27.478,29.293 C26.762,30.382 26.264,31.78 26.083,33.523 C25.15,32.976 24,31.916 24,30 L22,30 C22,33.274 24.332,35.044 26.026,35.728 C26.083,36.904 26.271,38.03 26.576,39.078 C25.49,39.373 22,40.517 22,43 L24,43 C24,42.221 25.918,41.305 27.243,40.971 L27.182,40.726 C28.589,43.883 31.115,46 34,46 C36.885,46 39.41,43.883 40.818,40.726 L40.757,40.971 C42.082,41.305 44,42.221 44,43 L46,43 C46,40.517 42.51,39.373 41.424,39.078 C41.729,38.03 41.917,36.904 41.973,35.728 C43.667,35.044 46,33.274 46,30 L46,30 Z M17,15 L44,15 L44,10 L17,10 L17,15 Z M9,23 L15,23 L15,17 L9,17 L9,23 Z M9,30 L15,30 L15,25 L9,25 L9,30 Z M4,30 L7,30 L7,10 L4,10 L4,30 Z M4,8 L7,8 L7,4 L4,4 L4,8 Z M9,15 L15,15 L15,10 L9,10 L9,15 Z M9,8 L44,8 L44,4 L9,4 L9,8 Z M45,2 L3,2 C2.447,2 2,2.447 2,3 L2,31 C2,31.553 2.447,32 3,32 L20,32 L20,30 L17,30 L17,25 L22,25 L22,23 L17,23 L17,17 L44,17 L44,21 L46,21 L46,3 C46,2.447 45.553,2 45,2 L45,2 Z" id="Icon-Resource/48/AWS-Glue_Crawler" fill="#8C4FFF"></path>
    </g>
</svg>`, rv = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Analytics/Res_Amazon-Quicksight_Paginated-Reports_48</title>
    <g id="Icon-Resource/Analytics/Res_Amazon-Quicksight_Paginated-Reports_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M27,32 L33,32 L33,30 L27,30 L27,32 Z M27,28 L33,28 L33,26 L27,26 L27,28 Z M27,24 L33,24 L33,22 L27,22 L27,24 Z M27,20 L33,20 L33,18 L27,18 L27,20 Z M22,32 L25,32 L25,30 L22,30 L22,32 Z M22,28 L25,28 L25,26 L22,26 L22,28 Z M22,24 L25,24 L25,22 L22,22 L22,24 Z M22,20 L25,20 L25,18 L22,18 L22,20 Z M20,34 L35,34 L35,16 L20,16 L20,34 Z M36,14 L19,14 C18.447,14 18,14.448 18,15 L18,35 C18,35.553 18.447,36 19,36 L36,36 C36.553,36 37,35.553 37,35 L37,15 C37,14.448 36.553,14 36,14 L36,14 Z M36,42 L38,42 L38,45 C38,45.552 37.553,46 37,46 L8,46 C7.447,46 7,45.552 7,45 L7,7 C7,6.448 7.447,6 8,6 L11,6 L11,8 L9,8 L9,44 L36,44 L36,42 Z M15,38 L15,4 L32,4 L32,11 C32,11.553 32.447,12 33,12 L40,12 L40,38 L15,38 Z M34,5.415 L38.586,10 L34,10 L34,5.415 Z M41.991,11 C41.991,10.741 41.898,10.485 41.707,10.293 L33.707,2.293 C33.516,2.102 33.26,2.01 33,2.01 L33,2 L14,2 C13.447,2 13,2.448 13,3 L13,39 C13,39.553 13.447,40 14,40 L41,40 C41.553,40 42,39.553 42,39 L42,11 L41.991,11 Z" id="Fill-1" fill="#8C4FFF"></path>
    </g>
</svg>`, ov = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Analytics/Res_AWS-Lake-Formation_Data-Lake_48</title>
    <g id="Icon-Resource/Analytics/Res_AWS-Lake-Formation_Data-Lake_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M46,31 L46,33 C45.815,33.107 45.479,33.933 45.3,34.376 C44.824,35.545 44.232,37 42.745,37 C41.258,37 40.666,35.545 40.19,34.376 C40.011,33.933 39.675,33.107 39.458,32.992 C39.307,33.108 38.972,33.934 38.792,34.376 C38.316,35.545 37.726,37 36.24,37 C34.755,37 34.163,35.545 33.688,34.376 C33.509,33.933 33.174,33.108 32.957,32.991 C32.809,33.108 32.474,33.933 32.294,34.376 C31.819,35.545 31.228,37 29.742,37 C28.258,37 27.668,35.545 27.193,34.376 C27.014,33.933 26.68,33.108 26.463,32.991 C26.314,33.108 25.979,33.934 25.8,34.377 C25.325,35.546 24.734,37 23.249,37 C21.764,37 21.173,35.546 20.698,34.377 C20.519,33.934 20.184,33.108 19.967,32.992 L20,31 C21.485,31 22.077,32.455 22.552,33.624 C22.731,34.067 23.066,34.892 23.283,35.009 C23.432,34.892 23.767,34.067 23.946,33.624 C24.421,32.455 25.013,31 26.498,31 C27.982,31 28.572,32.455 29.047,33.624 C29.227,34.067 29.561,34.892 29.777,35.009 C29.926,34.892 30.261,34.066 30.44,33.623 C30.915,32.454 31.506,31 32.991,31 C34.477,31 35.067,32.454 35.542,33.623 C35.722,34.066 36.057,34.892 36.273,35.008 C36.424,34.892 36.759,34.066 36.938,33.624 C37.414,32.455 38.005,31 39.49,31 C40.977,31 41.568,32.454 42.043,33.623 C42.224,34.066 42.56,34.893 42.777,35.008 C42.931,34.893 43.267,34.066 43.447,33.623 C43.922,32.454 44.514,31 46,31 L46,31 Z M46,24 L46,26 C45.815,26.107 45.479,26.933 45.3,27.376 C44.824,28.545 44.232,30 42.745,30 C41.258,30 40.666,28.545 40.19,27.376 C40.011,26.933 39.675,26.107 39.458,25.992 C39.307,26.108 38.972,26.934 38.792,27.376 C38.316,28.545 37.726,30 36.24,30 C34.755,30 34.163,28.545 33.688,27.376 C33.509,26.933 33.174,26.108 32.957,25.991 C32.809,26.108 32.474,26.933 32.294,27.376 C31.819,28.545 31.228,30 29.742,30 C28.258,30 27.668,28.545 27.193,27.376 C27.014,26.933 26.68,26.108 26.463,25.991 C26.314,26.108 25.979,26.934 25.8,27.377 C25.325,28.546 24.734,30 23.249,30 C21.764,30 21.173,28.546 20.698,27.377 C20.519,26.934 20.184,26.108 19.967,25.992 L20,24 C21.485,24 22.077,25.455 22.552,26.624 C22.731,27.067 23.066,27.892 23.283,28.009 C23.432,27.892 23.767,27.067 23.946,26.624 C24.421,25.455 25.013,24 26.498,24 C27.982,24 28.572,25.455 29.047,26.624 C29.227,27.067 29.561,27.892 29.777,28.009 C29.926,27.892 30.261,27.066 30.44,26.623 C30.915,25.454 31.506,24 32.991,24 C34.477,24 35.067,25.454 35.542,26.623 C35.722,27.066 36.057,27.892 36.273,28.008 C36.424,27.892 36.759,27.066 36.938,26.624 C37.414,25.455 38.005,24 39.49,24 C40.977,24 41.568,25.454 42.043,26.623 C42.224,27.066 42.56,27.893 42.777,28.008 C42.931,27.893 43.267,27.066 43.447,26.623 C43.922,25.454 44.514,24 46,24 L46,24 Z M46,16 L46,18 C45.815,18.107 45.479,18.933 45.3,19.376 C44.824,20.545 44.232,22 42.745,22 C41.258,22 40.666,20.545 40.19,19.376 C40.011,18.933 39.675,18.107 39.458,17.992 C39.307,18.108 38.972,18.934 38.792,19.376 C38.316,20.545 37.726,22 36.24,22 C34.755,22 34.163,20.545 33.688,19.376 C33.509,18.933 33.174,18.108 32.957,17.991 C32.809,18.108 32.474,18.933 32.294,19.376 C31.819,20.545 31.228,22 29.742,22 C28.258,22 27.668,20.545 27.193,19.376 C27.014,18.933 26.68,18.108 26.463,17.991 C26.314,18.108 25.979,18.934 25.8,19.377 C25.325,20.546 24.734,22 23.249,22 C21.764,22 21.173,20.546 20.698,19.377 C20.519,18.934 20.184,18.108 19.967,17.992 L20,16 C21.485,16 22.077,17.455 22.552,18.624 C22.731,19.067 23.066,19.892 23.283,20.009 C23.432,19.892 23.767,19.067 23.946,18.624 C24.421,17.455 25.013,16 26.498,16 C27.982,16 28.572,17.455 29.047,18.624 C29.227,19.067 29.561,19.892 29.777,20.009 C29.926,19.892 30.261,19.066 30.44,18.623 C30.915,17.454 31.506,16 32.991,16 C34.477,16 35.067,17.454 35.542,18.623 C35.722,19.066 36.057,19.892 36.273,20.008 C36.424,19.892 36.759,19.066 36.938,18.624 C37.414,17.455 38.005,16 39.49,16 C40.977,16 41.568,17.454 42.043,18.623 C42.224,19.066 42.56,19.893 42.777,20.008 C42.931,19.893 43.267,19.066 43.447,18.623 C43.922,17.454 44.514,16 46,16 L46,16 Z M16.136,4 C23.717,4 29,6.165 29,8.107 C29,10.051 23.717,12.216 16.136,12.216 C8.64,12.216 4,10.083 4,8.107 C4,6.132 8.64,4 16.136,4 L16.136,4 Z M29,39.486 C29,41.43 23.717,43.595 16.136,43.595 C8.539,43.595 4,41.506 4,39.486 L4,32.637 C6.358,34.349 10.658,35.378 16.136,35.378 L16.136,33.378 C8.539,33.378 4,31.303 4,29.297 L4,22.409 C6.358,24.128 10.658,25.162 16.136,25.162 L16.136,23.162 C8.64,23.162 4,21.029 4,19.054 L4,11.463 C6.358,13.182 10.658,14.216 16.136,14.216 C21.19,14.216 26.285,13.231 29,11.326 L29,15 L31,15 L31,8 L30.987,8 C30.852,4.062 23.454,2 16.136,2 C7.765,2 2.123,4.407 2.011,8 L2,8 L2,39.486 C2,43.14 7.681,45.595 16.136,45.595 C23.295,45.595 31,43.684 31,39.486 L31,38 L29,38 L29,39.486 Z" id="Icon-Resource/48/AWS-Lake-Formation_Data-Lake" fill="#8C4FFF"></path>
    </g>
</svg>`, lv = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Analytics/Res_Amazon-OpenSearch-Service_UltraWarm-Node_48</title>
    <g id="Icon-Resource/Analytics/Res_Amazon-OpenSearch-Service_UltraWarm-Node_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M39.536,42.459 L40.583,34.919 C38.024,34.086 34.894,32.706 33.265,31.96 C33.048,32.088 32.799,32.166 32.53,32.166 C31.724,32.166 31.069,31.511 31.069,30.705 C31.069,29.899 31.724,29.244 32.53,29.244 C33.083,29.244 33.559,29.556 33.807,30.01 C35.693,30.883 38.547,32.121 40.863,32.904 L41.723,26.708 C39.405,27.874 35.727,28.477 32.069,28.477 C28.398,28.477 24.706,27.87 22.389,26.696 L24.454,42.467 C24.456,42.482 24.458,42.497 24.459,42.512 C24.863,43.062 27.711,44.04 31.994,44.04 C36.278,44.04 39.126,43.062 39.53,42.512 C39.531,42.494 39.533,42.477 39.536,42.459 M22.015,23.836 L22.022,23.894 C22.286,24.86 26.048,26.477 32.069,26.477 C38.074,26.477 41.83,24.869 42.113,23.902 L42.123,23.834 C41.73,23.192 38.497,21.097 32.069,21.097 C25.636,21.097 22.403,23.196 22.015,23.836 M45.758,33.829 C45.84,34.269 45.726,34.7 45.439,35.042 C45.108,35.436 44.615,35.632 43.894,35.632 C43.51,35.632 43.052,35.57 42.527,35.459 L41.524,42.68 C41.398,45.334 35.258,46.04 31.994,46.04 C28.729,46.04 22.583,45.334 22.465,42.675 L20.009,23.917 L20.016,23.916 C20.013,23.872 20,23.831 20,23.787 C20,21.568 24.957,19.097 32.069,19.097 C39.182,19.097 44.139,21.568 44.139,23.787 C44.139,23.834 44.124,23.877 44.122,23.923 L44.129,23.924 L43.108,31.272 C44.799,32.241 45.606,33.018 45.758,33.829 M46,7 L46,17 L44,17 L44,7 C44,5.345 42.654,4 41,4 L7,4 C5.346,4 4,5.345 4,7 L4,41 C4,42.654 5.346,44 7,44 L19,44 L19,46 L7,46 C4.243,46 2,43.756 2,41 L2,7 C2,4.243 4.243,2 7,2 L41,2 C43.757,2 46,4.243 46,7" id="Fill-1" fill="#8C4FFF"></path>
    </g>
</svg>`, Lv = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Analytics/Res_Amazon-CloudSearch_Search-Documents_48</title>
    <g id="Icon-Resource/Analytics/Res_Amazon-CloudSearch_Search-Documents_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M41.406,14.6378 L38.823,16.5748 L41.406,18.5128 L41.406,14.6378 Z M43.406,12.6378 L43.406,20.5128 C43.406,20.8918 43.192,21.2378 42.853,21.4078 C42.712,21.4778 42.558,21.5128 42.406,21.5128 C42.193,21.5128 41.982,21.4448 41.806,21.3128 L36.557,17.3748 C36.305,17.1868 36.157,16.8898 36.157,16.5748 C36.157,16.2608 36.305,15.9638 36.557,15.7758 L41.806,11.8378 C42.108,11.6108 42.513,11.5738 42.853,11.7428 C43.192,11.9128 43.406,12.2588 43.406,12.6378 L43.406,12.6378 Z M9.243,16.5748 L6.66,14.6378 L6.66,18.5128 L9.243,16.5748 Z M11.51,17.3748 L6.26,21.3128 C6.084,21.4448 5.872,21.5128 5.66,21.5128 C5.508,21.5128 5.354,21.4778 5.213,21.4078 C4.874,21.2378 4.66,20.8918 4.66,20.5128 L4.66,12.6378 C4.66,12.2588 4.874,11.9128 5.213,11.7428 C5.552,11.5738 5.957,11.6108 6.26,11.8378 L11.51,15.7758 C11.761,15.9638 11.91,16.2608 11.91,16.5748 C11.91,16.8898 11.761,17.1868 11.51,17.3748 L11.51,17.3748 Z M12.66,40.7628 L35.41,40.7628 L35.41,38.7628 L12.66,38.7628 L12.66,40.7628 Z M12.66,35.5128 L35.41,35.5128 L35.41,33.5128 L12.66,33.5128 L12.66,35.5128 Z M12.66,30.2628 L35.41,30.2628 L35.41,28.2628 L12.66,28.2628 L12.66,30.2628 Z M12.66,25.0128 L35.41,25.0128 L35.41,23.0128 L12.66,23.0128 L12.66,25.0128 Z M12.66,19.7628 L35.41,19.7628 L35.41,17.7628 L12.66,17.7628 L12.66,19.7628 Z M12.769,14.5128 L35.41,14.5128 L35.41,12.5128 L12.769,12.5128 L12.769,14.5128 Z M12.66,9.2628 L35.41,9.2628 L35.41,7.2628 L12.66,7.2628 L12.66,9.2628 Z M37.91,44.0128 L10.16,44.0128 L10.16,21.3878 L8.16,21.3878 L8.16,46.0128 L39.91,46.0128 L39.91,21.3878 L37.91,21.3878 L37.91,44.0128 Z M10.16,11.7628 L8.16,11.7628 L8.16,2.0128 L39.91,2.0128 L39.91,11.7628 L37.91,11.7628 L37.91,4.0128 L10.16,4.0128 L10.16,11.7628 Z" id="Icon-Resource/48/CloudSearch-Search_Documents" fill="#8C4FFF"></path>
    </g>
</svg>`, av = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Analytics/Res_Amazon-OpenSearch-Service_OpenSearch-Ingestion_48</title>
    <g id="Icon-Resource/Analytics/Res_Amazon-OpenSearch-Service_OpenSearch-Ingestion_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M4,40 L12,40 L12,32 L4,32 L4,40 Z M13,30 C13.553,30 14,30.448 14,31 L14,41 C14,41.552 13.553,42 13,42 L3,42 C2.447,42 2,41.552 2,41 L2,31 C2,30.448 2.447,30 3,30 L13,30 Z M11,26 L18,26 L18,19 L11,19 L11,26 Z M10,28 C9.447,28 9,27.552 9,27 L9,18 C9,17.448 9.447,17 10,17 L19,17 C19.553,17 20,17.448 20,18 L20,27 C20,27.552 19.553,28 19,28 L10,28 Z M4,13 L9,13 L9,8 L4,8 L4,13 Z M2,14 L2,7 C2,6.448 2.447,6 3,6 L10,6 C10.553,6 11,6.448 11,7 L11,14 C11,14.552 10.553,15 10,15 L3,15 C2.447,15 2,14.552 2,14 L2,14 Z M27.137,8.008 L27.199,8.102 C29.243,11.169 32.665,13 36.352,13 L40.586,13 L38.293,15.293 L39.707,16.707 L43.707,12.707 C44.098,12.316 44.098,11.684 43.707,11.293 L39.707,7.293 L38.293,8.707 L40.586,11 L36.352,11 C33.335,11 30.536,9.502 28.863,6.992 L28.801,6.898 C26.757,3.831 23.335,2 19.648,2 L2,2 L2,4 L19.648,4 C22.665,4 25.464,5.498 27.137,8.008 L27.137,8.008 Z M41,21 C39.346,21 38,22.346 38,24 C38,25.654 39.346,27 41,27 C42.654,27 44,25.654 44,24 C44,22.346 42.654,21 41,21 L41,21 Z M41,19 C43.757,19 46,21.243 46,24 C46,26.757 43.757,29 41,29 C38.243,29 36,26.757 36,24 C36,21.243 38.243,19 41,19 L41,19 Z M23,25 L29.586,25 L27.293,27.293 L28.707,28.707 L32.707,24.707 C33.098,24.316 33.098,23.684 32.707,23.293 L28.707,19.293 L27.293,20.707 L29.586,23 L23,23 L23,25 Z M43.707,35.293 C44.098,35.684 44.098,36.316 43.707,36.707 L39.707,40.707 L38.293,39.293 L40.586,37 L36.352,37 C33.335,37 30.536,38.498 28.863,41.008 L28.801,41.102 C26.757,44.169 23.335,46 19.648,46 L2,46 L2,44 L19.648,44 C22.665,44 25.464,42.502 27.137,39.992 L27.199,39.898 C29.243,36.831 32.665,35 36.352,35 L40.586,35 L38.293,32.707 L39.707,31.293 L43.707,35.293 Z" id="Fill-1" fill="#8C4FFF"></path>
    </g>
</svg>`, Cv = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Analytics/Res_Amazon-Athena_Data-Source-Connectors_48</title>
    <g id="Icon-Resource/Analytics/Res_Amazon-Athena_Data-Source-Connectors_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M4.984,24.002 C4.446,24.002 4,24.45 4,25 C4,25.551 4.448,26 5,26 L13,26 C13.551,26 14,25.551 14,25 C14,24.449 13.551,24 13,24 C12.447,24 12,23.552 12,23 C12,22.449 11.551,22 11,22 C10.553,22.041 10.029,21.781 9.878,21.348 C9.596,20.542 8.841,20 8,20 C6.897,20 6,20.897 6,22 C6,22.217 6.042,22.439 6.129,22.677 C6.246,22.999 6.19,23.358 5.981,23.63 C5.772,23.9 5.434,24.045 5.097,24.015 C5.084,24.014 5.002,24.004 4.987,24.002 L4.984,24.002 Z M13,28 L5,28 C3.345,28 2,26.654 2,25 C2,23.695 2.838,22.582 4.004,22.17 C4.001,22.113 4,22.057 4,22 C4,19.794 5.794,18 8,18 C9.451,18 10.771,18.795 11.471,20.037 C12.612,20.218 13.541,21.044 13.871,22.129 C15.101,22.503 16,23.648 16,25 C16,26.654 14.654,28 13,28 L13,28 Z M29,44 C27.615,44 27,43.597 27,43.444 L27,41.707 C27.571,41.891 28.237,42 29,42 C29.75,42 30.422,41.878 31.003,41.675 L31.006,43.405 C30.927,43.58 30.239,44 29,44 L29,44 Z M29,39 C30.171,39 30.796,39.298 30.971,39.457 C30.801,39.651 30.129,40 29,40 C27.702,40 27.087,39.65 27,39.544 L27,39.505 C27.12,39.358 27.768,39 29,39 L29,39 Z M33,39.444 C33,37.982 31.392,37 29,37 C26.607,37 25,37.982 25,39.444 C25,39.463 25.006,39.481 25.007,39.5 L25,39.5 L25,43.444 C25,44.997 26.57,46 29,46 C31.317,46 33,44.925 33,43.444 L33,39.5 L32.992,39.5 C32.992,39.481 33,39.463 33,39.444 L33,39.444 Z M29,9 C27.615,9 27,8.597 27,8.444 L27,6.707 C27.571,6.891 28.237,7 29,7 C29.75,7 30.422,6.878 31.003,6.675 L31.006,8.405 C30.927,8.58 30.239,9 29,9 L29,9 Z M29,4 C30.171,4 30.796,4.298 30.971,4.457 C30.801,4.651 30.129,5 29,5 C27.702,5 27.087,4.65 27,4.544 L27,4.505 C27.12,4.358 27.768,4 29,4 L29,4 Z M33,4.444 C33,2.982 31.392,2 29,2 C26.607,2 25,2.982 25,4.444 C25,4.463 25.006,4.481 25.007,4.5 L25,4.5 L25,8.444 C25,9.997 26.57,11 29,11 C31.317,11 33,9.925 33,8.444 L33,4.5 L32.992,4.5 C32.992,4.481 33,4.463 33,4.444 L33,4.444 Z M29,19 C31.756,19 34,21.243 34,24 C34,26.757 31.756,29 29,29 C26.243,29 24,26.757 24,24 C24,21.243 26.243,19 29,19 L29,19 Z M29,31 C32.859,31 36,27.86 36,24 C36,20.14 32.859,17 29,17 C25.481,17 22.567,19.613 22.08,23 L17,23 L17,25 L22.08,25 C22.567,28.387 25.481,31 29,31 L29,31 Z M43.535,38.535 C42.916,39.153 41.908,39.153 41.289,38.535 L35.561,32.808 C36.414,32.171 37.17,31.415 37.807,30.562 L43.535,36.289 C43.835,36.588 44,36.987 44,37.412 C44,37.836 43.835,38.235 43.535,38.535 L43.535,38.535 Z M44.949,34.875 L38.879,28.805 C39.59,27.351 40,25.725 40,24 C40,17.935 35.065,13 29,13 C23.975,13 19.736,16.39 18.426,21 L20.525,21 C21.764,17.51 25.09,15 29,15 C33.963,15 38,19.038 38,24 C38,28.962 33.963,33 29,33 C25.09,33 21.764,30.49 20.525,27 L18.426,27 C19.736,31.61 23.975,35 29,35 C30.724,35 32.351,34.59 33.805,33.88 L39.875,39.95 C40.574,40.648 41.493,40.998 42.412,40.998 C43.331,40.998 44.25,40.648 44.949,39.949 C46.348,38.55 46.348,36.273 44.949,34.875 L44.949,34.875 Z M12.462,33.36 C12.122,32.76 11.81,32.133 11.536,31.497 L13.374,30.707 C13.618,31.276 13.897,31.836 14.202,32.374 L12.462,33.36 Z M14.932,36.772 C14.462,36.254 14.014,35.703 13.602,35.135 L15.221,33.961 C15.59,34.47 15.991,34.963 16.413,35.427 L14.932,36.772 Z M18.091,39.558 C17.517,39.154 16.96,38.715 16.435,38.253 L17.757,36.752 C18.227,37.166 18.727,37.56 19.242,37.922 L18.091,39.558 Z M21.788,41.583 C21.14,41.317 20.5,41.012 19.883,40.674 L20.842,38.919 C21.395,39.222 21.968,39.495 22.547,39.733 L21.788,41.583 Z M20.42,9.321 L19.408,7.595 C20.013,7.241 20.645,6.916 21.286,6.631 L22.098,8.459 C21.526,8.713 20.961,9.003 20.42,9.321 L20.42,9.321 Z M17.397,11.575 L16.032,10.114 C16.547,9.633 17.091,9.177 17.652,8.761 L18.845,10.365 C18.345,10.737 17.858,11.145 17.397,11.575 L17.397,11.575 Z M14.941,14.438 L13.289,13.312 C13.682,12.733 14.114,12.17 14.572,11.636 L16.089,12.939 C15.68,13.416 15.294,13.92 14.941,14.438 L14.941,14.438 Z M13.177,17.769 L11.316,17.036 C11.573,16.383 11.87,15.738 12.2,15.118 L13.965,16.055 C13.672,16.609 13.407,17.186 13.177,17.769 L13.177,17.769 Z" id="Fill-1" fill="#8C4FFF"></path>
    </g>
</svg>`, cv = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Analytics/Res_Amazon-OpenSearch-Service_Cluster-Administrator-Node_48</title>
    <g id="Icon-Resource/Analytics/Res_Amazon-OpenSearch-Service_Cluster-Administrator-Node_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M36.868,33 C36.868,30.962 35.21,29.304 33.172,29.304 C31.134,29.304 29.476,30.962 29.476,33 C29.476,35.038 31.134,36.696 33.172,36.696 C35.21,36.696 36.868,35.038 36.868,33 L36.868,33 Z M38.868,33 C38.868,36.141 36.312,38.696 33.172,38.696 C30.031,38.696 27.476,36.141 27.476,33 C27.476,29.859 30.031,27.304 33.172,27.304 C36.312,27.304 38.868,29.859 38.868,33 L38.868,33 Z M44.172,31.673 L43.236,31.727 C42.777,31.75 42.311,31.426 42.204,30.949 C41.972,29.925 41.57,28.954 41.008,28.065 C40.747,27.651 40.823,27.11 41.187,26.785 L41.888,26.16 L40.012,24.284 L39.384,24.988 C39.056,25.353 38.515,25.428 38.103,25.167 C37.216,24.606 36.247,24.205 35.222,23.973 C34.746,23.865 34.417,23.429 34.445,22.941 L34.498,22 L31.846,22 L31.899,22.939 C31.928,23.428 31.598,23.864 31.122,23.972 C30.096,24.204 29.125,24.605 28.238,25.166 C27.824,25.426 27.282,25.351 26.958,24.986 L26.332,24.284 L24.456,26.16 L25.158,26.786 C25.523,27.112 25.599,27.654 25.338,28.067 C24.775,28.957 24.372,29.926 24.14,30.95 C24.031,31.426 23.561,31.75 23.108,31.727 L22.172,31.673 L22.172,34.326 L23.105,34.273 C23.569,34.255 24.031,34.575 24.138,35.053 C24.367,36.076 24.769,37.047 25.332,37.94 C25.593,38.354 25.516,38.895 25.151,39.22 L24.456,39.84 L26.332,41.716 L26.953,41.02 C27.278,40.653 27.821,40.579 28.233,40.84 C29.125,41.404 30.097,41.807 31.122,42.038 C31.598,42.146 31.928,42.583 31.899,43.071 L31.847,44 L34.498,44 L34.445,43.072 C34.417,42.583 34.746,42.147 35.222,42.04 C36.251,41.807 37.223,41.404 38.113,40.842 C38.525,40.582 39.067,40.656 39.393,41.022 L40.013,41.716 L41.888,39.84 L41.19,39.218 C40.826,38.893 40.75,38.352 41.011,37.938 C41.573,37.045 41.975,36.074 42.205,35.052 C42.312,34.575 42.763,34.255 43.237,34.273 L44.172,34.326 L44.172,31.673 Z M45.858,29.888 C46.058,30.077 46.172,30.34 46.172,30.615 L46.172,35.385 C46.172,35.66 46.058,35.923 45.858,36.112 C45.659,36.3 45.388,36.397 45.115,36.383 L43.937,36.316 C43.73,36.99 43.461,37.642 43.13,38.268 L44.01,39.053 C44.215,39.236 44.336,39.496 44.344,39.771 C44.351,40.045 44.245,40.312 44.051,40.506 L40.678,43.879 C40.483,44.074 40.195,44.182 39.942,44.171 C39.667,44.164 39.407,44.042 39.224,43.837 L38.443,42.961 C37.818,43.292 37.165,43.563 36.488,43.771 L36.555,44.942 C36.57,45.217 36.472,45.486 36.283,45.686 C36.095,45.886 35.832,46 35.556,46 L30.787,46 C30.512,46 30.249,45.886 30.059,45.686 C29.871,45.486 29.773,45.217 29.789,44.942 L29.856,43.77 C29.181,43.562 28.528,43.291 27.903,42.959 L27.119,43.837 C26.936,44.043 26.677,44.164 26.401,44.171 C26.129,44.179 25.86,44.074 25.666,43.879 L22.293,40.506 C22.098,40.312 21.992,40.045 22,39.77 C22.008,39.495 22.129,39.235 22.335,39.052 L23.213,38.269 C22.882,37.644 22.611,36.991 22.405,36.316 L21.228,36.383 C20.959,36.398 20.684,36.3 20.485,36.112 C20.285,35.923 20.172,35.66 20.172,35.385 L20.172,30.615 C20.172,30.34 20.285,30.077 20.485,29.888 C20.684,29.699 20.958,29.604 21.228,29.616 L22.41,29.684 C22.617,29.01 22.888,28.359 23.219,27.736 L22.335,26.948 C22.129,26.765 22.008,26.505 22,26.23 C21.992,25.955 22.098,25.689 22.293,25.495 L25.666,22.122 C25.86,21.927 26.131,21.817 26.401,21.829 C26.677,21.837 26.935,21.958 27.119,22.163 L27.908,23.047 C28.53,22.717 29.181,22.447 29.856,22.24 L29.789,21.057 C29.773,20.782 29.871,20.513 30.06,20.313 C30.249,20.113 30.512,20 30.787,20 L35.556,20 C35.832,20 36.095,20.113 36.283,20.312 C36.472,20.513 36.57,20.782 36.555,21.056 L36.488,22.242 C37.161,22.449 37.811,22.719 38.433,23.048 L39.224,22.163 C39.408,21.958 39.667,21.837 39.942,21.829 C40.22,21.814 40.483,21.927 40.678,22.122 L44.051,25.495 C44.245,25.689 44.351,25.955 44.344,26.23 C44.336,26.505 44.215,26.765 44.01,26.948 L43.127,27.735 C43.458,28.358 43.727,29.01 43.935,29.684 L45.115,29.616 C45.388,29.605 45.659,29.699 45.858,29.888 L45.858,29.888 Z M7,44 L19,44 L19,46 L7,46 C4.243,46 2,43.757 2,41 L2,7 C2,4.243 4.243,2 7,2 L41,2 C43.757,2 46,4.243 46,7 L46,20 L44,20 L44,7 C44,5.346 42.654,4 41,4 L7,4 C5.346,4 4,5.346 4,7 L4,41 C4,42.654 5.346,44 7,44 L7,44 Z" id="Fill-1" fill="#8C4FFF"></path>
    </g>
</svg>`, uv = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Analytics/Res_Amazon-OpenSearch-Service_OpenSearch-Dashboards_48</title>
    <g id="Icon-Resource/Analytics/Res_Amazon-OpenSearch-Service_OpenSearch-Dashboards_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M27.54,28 L29.186,28 L30.985,30.436 C31.213,30.744 31.599,30.898 31.973,30.825 C32.35,30.755 32.653,30.476 32.754,30.106 L34.243,24.687 L36.837,34 L24.961,34 L27.54,28 Z M35.199,20.667 C35.079,20.234 34.686,19.935 34.236,19.935 L34.234,19.935 C33.785,19.936 33.391,20.236 33.272,20.67 L31.371,27.591 L30.496,26.406 C30.308,26.151 30.009,26 29.691,26 L26.882,26 C26.482,26 26.121,26.238 25.963,26.605 L22.784,34 L21.023,34 L21.023,36 L41.023,36 L41.023,34 L38.912,34 L35.199,20.667 Z M11.023,36 L13.023,36 L13.023,23 L11.023,23 L11.023,36 Z M15.023,36 L17.023,36 L17.023,21 L15.023,21 L15.023,36 Z M7.023,36 L9.023,36 L9.023,28 L7.023,28 L7.023,36 Z M14.023,14 L16.023,14 L16.023,12 L14.023,12 L14.023,14 Z M10.023,14 L12.023,14 L12.023,12 L10.023,12 L10.023,14 Z M6.023,14 L8.023,14 L8.023,12 L6.023,12 L6.023,14 Z M4,39 L4.018,17 L44.023,17 L44.023,38.994 L4,39 Z M44.023,10 L44.023,15 L4.019,15 L4.023,10 L44.023,10 Z M44.146,8 L3.9,8 C2.865,8 2.023,8.842 2.023,9.875 L1.99999642,39.128 C1.998,40.154 2.834,40.994 3.87,41 L44.146,40.994 C45.182,40.994 46.023,40.152 46.023,39.117 L46.023,9.877 C46.023,8.842 45.182,8 44.146,8 L44.146,8 Z" id="Fill-1" fill="#8C4FFF"></path>
    </g>
</svg>`, hv = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Analytics/Res_Amazon-OpenSearch-Service_Index_48</title>
    <g id="Icon-Resource/Analytics/Res_Amazon-OpenSearch-Service_Index_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M21,32 L27,32 L27,30 L21,30 L21,32 Z M16,34 L32,34 L32,28 L16,28 L16,34 Z M33,26 L15,26 C14.447,26 14,26.448 14,27 L14,35 C14,35.552 14.447,36 15,36 L33,36 C33.553,36 34,35.552 34,35 L34,27 C34,26.448 33.553,26 33,26 L33,26 Z M11,12 L17,12 L17,10 L11,10 L11,12 Z M25,10 L31,10 L31,8 L25,8 L25,10 Z M4,44 L44,44 L44,16 L4,16 L4,44 Z M22,4 L34,4 L34,9 C34,9.552 34.447,10 35,10 L40,10 L40,14 L22,14 L22,4 Z M36,5.261 L38.645,8 L36,8 L36,5.261 Z M45,14 L42,14 L42,9 C42,8.741 41.899,8.492 41.72,8.305 L35.927,2.305 C35.738,2.11 35.479,2 35.207,2 L21,2 C20.447,2 20,2.448 20,3 L20,14 L8,14 L8,7 L18,7 L18,5 L7,5 C6.447,5 6,5.448 6,6 L6,14 L3,14 C2.447,14 2,14.448 2,15 L2,45 C2,45.552 2.447,46 3,46 L45,46 C45.553,46 46,45.552 46,45 L46,15 C46,14.448 45.553,14 45,14 L45,14 Z" id="Fill-1" fill="#8C4FFF"></path>
    </g>
</svg>`, dv = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Analytics/Res_AWS-Glue_AWS-Glue-for-Ray_48</title>
    <g id="Icon-Resource/Analytics/Res_AWS-Glue_AWS-Glue-for-Ray_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M41,44 C39.346,44 38,42.654 38,41 C38,39.346 39.346,38 41,38 C42.654,38 44,39.346 44,41 C44,42.654 42.654,44 41,44 L41,44 Z M28.107,31.107 L27.046,29.917 C26.72,29.551 26.177,29.478 25.766,29.738 C24.547,30.508 23.216,31.06 21.809,31.377 C21.331,31.485 21.002,31.922 21.03,32.41 L21.121,34 L16.879,34 L16.97,32.409 C16.998,31.92 16.669,31.484 16.192,31.376 C14.79,31.06 13.459,30.507 12.236,29.735 C11.822,29.474 11.28,29.549 10.956,29.915 L9.893,31.107 L6.894,28.107 L8.085,27.044 C8.449,26.719 8.525,26.178 8.265,25.765 C7.495,24.546 6.944,23.215 6.628,21.809 C6.52,21.331 6.075,21.007 5.595,21.03 L4,21.121 L4,16.878 L5.601,16.97 C6.051,16.995 6.523,16.669 6.633,16.193 C6.95,14.792 7.502,13.463 8.272,12.244 C8.533,11.831 8.457,11.289 8.093,10.964 L6.894,9.894 L9.894,6.894 L10.963,8.092 C11.287,8.457 11.831,8.532 12.242,8.272 C13.461,7.503 14.79,6.954 16.191,6.637 C16.669,6.529 16.998,6.093 16.97,5.605 L16.879,4 L21.121,4 L21.03,5.606 C21.002,6.094 21.331,6.53 21.808,6.638 C23.21,6.956 24.538,7.507 25.754,8.274 C26.167,8.535 26.707,8.459 27.034,8.095 L28.106,6.894 L31.106,9.894 L29.909,10.961 C29.545,11.287 29.469,11.829 29.729,12.242 C30.5,13.459 31.051,14.789 31.368,16.192 C31.476,16.669 31.937,16.995 32.4,16.97 L34,16.878 L34,21.121 L32.402,21.03 C31.937,21.007 31.478,21.331 31.37,21.808 C31.054,23.212 30.502,24.542 29.732,25.762 C29.472,26.175 29.548,26.717 29.912,27.042 L31.106,28.107 L28.107,31.107 Z M21,42 C21,43.103 20.103,44 19,44 C17.897,44 17,43.103 17,42 C17,40.897 17.897,40 19,40 C20.103,40 21,40.897 21,42 L21,42 Z M42,17 C43.103,17 44,17.897 44,19 C44,20.103 43.103,21 42,21 C40.897,21 40,20.103 40,19 C40,17.897 40.897,17 42,17 L42,17 Z M41,36 C40.068,36 39.205,36.273 38.457,36.719 L31.89,30.152 L33.27,28.772 C33.464,28.578 33.57,28.312 33.562,28.037 C33.555,27.762 33.434,27.502 33.229,27.319 L31.857,26.097 C32.388,25.138 32.807,24.126 33.109,23.074 L34.943,23.179 C35.213,23.193 35.487,23.096 35.687,22.907 C35.887,22.718 36,22.455 36,22.18 L36,20 L38.142,20 C38.589,21.72 40.141,23 42,23 C44.206,23 46,21.206 46,19 C46,16.794 44.206,15 42,15 C40.141,15 38.589,16.28 38.142,18 L36,18 L36,15.82 C36,15.545 35.887,15.282 35.687,15.093 C35.487,14.904 35.214,14.803 34.943,14.821 L33.107,14.926 C32.805,13.875 32.385,12.864 31.854,11.906 L33.229,10.681 C33.434,10.498 33.555,10.239 33.562,9.963 C33.57,9.688 33.464,9.422 33.27,9.228 L28.772,4.731 C28.578,4.536 28.311,4.43 28.037,4.438 C27.763,4.446 27.503,4.567 27.319,4.772 L26.089,6.15 C25.133,5.621 24.124,5.203 23.073,4.9 L23.178,3.057 C23.193,2.782 23.096,2.513 22.906,2.313 C22.718,2.113 22.455,2 22.18,2 L15.82,2 C15.545,2 15.282,2.113 15.094,2.313 C14.904,2.513 14.807,2.782 14.822,3.057 L14.927,4.897 C13.876,5.2 12.866,5.618 11.908,6.147 L10.681,4.772 C10.497,4.567 10.238,4.446 9.963,4.438 C9.693,4.433 9.422,4.536 9.228,4.731 L4.73,9.228 C4.536,9.422 4.43,9.688 4.437,9.963 C4.445,10.238 4.566,10.498 4.771,10.681 L6.147,11.909 C5.617,12.867 5.197,13.876 4.895,14.926 L3.057,14.821 C2.781,14.803 2.513,14.904 2.313,15.093 C2.113,15.282 2,15.545 2,15.82 L2,22.18 C2,22.455 2.113,22.718 2.313,22.907 C2.514,23.096 2.768,23.194 3.058,23.179 L4.888,23.074 C5.19,24.127 5.609,25.14 6.14,26.099 L4.771,27.319 C4.566,27.502 4.445,27.762 4.437,28.037 C4.43,28.312 4.536,28.578 4.73,28.772 L9.228,33.27 C9.422,33.464 9.691,33.573 9.963,33.562 C10.238,33.554 10.498,33.434 10.681,33.228 L11.901,31.86 C12.862,32.392 13.875,32.812 14.927,33.115 L14.822,34.943 C14.807,35.218 14.904,35.487 15.094,35.687 C15.282,35.887 15.545,36 15.82,36 L18,36 L18,38.142 C16.279,38.589 15,40.142 15,42 C15,44.206 16.794,46 19,46 C21.206,46 23,44.206 23,42 C23,40.142 21.721,38.589 20,38.142 L20,36 L22.18,36 C22.455,36 22.718,35.887 22.906,35.687 C23.096,35.487 23.193,35.218 23.178,34.943 L23.073,33.117 C24.128,32.813 25.142,32.394 26.102,31.862 L27.319,33.228 C27.502,33.434 27.762,33.554 28.037,33.562 C28.312,33.576 28.578,33.464 28.772,33.27 L30.476,31.566 L36.974,38.063 C36.369,38.89 36,39.899 36,41 C36,43.757 38.243,46 41,46 C43.757,46 46,43.757 46,41 C46,38.243 43.757,36 41,36 L41,36 Z M20,18 L23,18 L23,20 L20,20 L20,23 L18,23 L18,20 L15,20 L15,18 L18,18 L18,15 L20,15 L20,18 Z M19,25 C15.691,25 13,22.309 13,19 C13,15.691 15.691,13 19,13 C22.309,13 25,15.691 25,19 C25,22.309 22.309,25 19,25 L19,25 Z M19,11 C14.589,11 11,14.589 11,19 C11,23.411 14.589,27 19,27 C23.411,27 27,23.411 27,19 C27,14.589 23.411,11 19,11 L19,11 Z" id="Fill-1" fill="#8C4FFF"></path>
    </g>
</svg>`, gv = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Analytics/Res_Amazon-Redshift_Data-Sharing-Governance_48</title>
    <g id="Icon-Resource/Analytics/Res_Amazon-Redshift_Data-Sharing-Governance_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M23.065,43.818 L23.065,45.818 C21.648,45.818 20.381,45.064 19.554,43.887 C18.727,45.064 17.461,45.818 16.044,45.818 C14.627,45.818 13.36,45.064 12.533,43.887 C11.705,45.064 10.438,45.818 9.021,45.818 C7.604,45.818 6.337,45.064 5.51,43.887 C4.683,45.064 3.417,45.818 2,45.818 L2,43.818 C3.384,43.818 4.51,42.392 4.51,40.639 L6.51,40.639 C6.51,42.392 7.636,43.818 9.021,43.818 C10.406,43.818 11.533,42.392 11.533,40.639 L13.533,40.639 C13.533,42.392 14.659,43.818 16.044,43.818 C17.428,43.818 18.554,42.392 18.554,40.639 L20.554,40.639 C20.554,42.392 21.68,43.818 23.065,43.818 L23.065,43.818 Z M30.5,37.818 C28.928,37.818 27.468,37.025 26.524,35.836 C25.688,37.047 24.35,37.818 22.815,37.818 C21.247,37.818 19.82,37.033 18.908,35.838 C18.041,37.041 16.67,37.818 15.13,37.818 C13.592,37.818 12.195,37.025 11.304,35.819 C10.407,37.025 8.997,37.818 7.445,37.818 L7.445,35.818 C8.97,35.818 10.309,34.416 10.309,32.818 L12.309,32.818 C12.309,34.444 13.601,35.818 15.13,35.818 C16.642,35.818 17.873,34.472 17.873,32.818 L19.873,32.818 C19.873,34.416 21.248,35.818 22.815,35.818 C24.456,35.818 25.436,34.293 25.436,32.818 L27.436,32.818 C27.436,34.36 28.925,35.818 30.5,35.818 C32.124,35.818 33,34.272 33,32.818 L35,32.818 C35,35.669 33.065,37.818 30.5,37.818 L30.5,37.818 Z M2,29.996 L2,27.996 C3.384,27.996 4.51,26.57 4.51,24.818 L6.51,24.818 C6.51,26.57 7.636,27.996 9.021,27.996 C10.406,27.996 11.533,26.57 11.533,24.818 L13.533,24.818 C13.533,26.57 14.659,27.996 16.044,27.996 C17.428,27.996 18.554,26.57 18.554,24.818 L20.554,24.818 C20.554,26.57 21.68,27.996 23.065,27.996 L23.065,29.996 C21.648,29.996 20.381,29.242 19.554,28.066 C18.727,29.242 17.461,29.996 16.044,29.996 C14.627,29.996 13.36,29.242 12.533,28.066 C11.705,29.242 10.438,29.996 9.021,29.996 C7.604,29.996 6.337,29.242 5.51,28.066 C4.683,29.242 3.417,29.996 2,29.996 L2,29.996 Z M41.387,10.527 C40.756,9.606 39.698,9 38.5,9 C36.786,9 35.362,10.24 35.063,11.87 C34.077,11.949 33.05,12 31.979,12 C24.367,12 19.215,10.018 19,8.123 L19,8 L18.979,8 C18.979,6.068 24.15,4 31.847,4 C39.441,4 43.979,6.033 43.979,8 C43.979,8 43.979,8.001 43.979,8.001 L43.958,8.001 L43.958,8.125 C43.855,9.26 42.448,10.075 41.387,10.527 L41.387,10.527 Z M38.5,14 C37.672,14 37,13.327 37,12.5 C37,11.672 37.672,11 38.5,11 C39.327,11 40,11.672 40,12.5 C40,13.327 39.327,14 38.5,14 L38.5,14 Z M34.5,24 C33.672,24 33,23.327 33,22.5 C33,21.672 33.672,21 34.5,21 C35.327,21 36,21.672 36,22.5 C36,23.327 35.327,24 34.5,24 L34.5,24 Z M24.5,22 C23.672,22 23,21.327 23,20.5 C23,19.672 23.672,19 24.5,19 C25.327,19 26,19.672 26,20.5 C26,21.327 25.327,22 24.5,22 L24.5,22 Z M45.958,8.363 C45.971,8.238 45.979,8.116 45.979,8 C45.979,4.355 40.432,2 31.847,2 C24.447,2 16.979,3.855 16.979,8 C16.979,8.059 16.996,8.113 17,8.172 L17,23 L19,23 L19,11.215 C21.781,13.111 27.01,14 31.979,14 C33.122,14 34.219,13.946 35.275,13.859 C35.548,14.505 36.013,15.049 36.594,15.428 L35.16,19.066 C34.946,19.025 34.726,19 34.5,19 C32.996,19 31.722,19.957 31.228,21.291 L27.994,20.555 C27.994,20.536 28,20.519 28,20.5 C28,18.57 26.429,17 24.5,17 C22.57,17 21,18.57 21,20.5 C21,22.429 22.57,24 24.5,24 C25.699,24 26.759,23.392 27.389,22.469 L31.105,23.314 C31.474,24.85 32.851,26 34.5,26 C36.429,26 38,24.429 38,22.5 C38,21.52 37.593,20.637 36.942,20.001 L38.52,15.998 C40.44,15.986 42,14.422 42,12.5 C42,12.479 41.994,12.46 41.993,12.439 C42.793,12.112 43.442,11.759 43.962,11.391 L44,39.818 C44,41.757 39.794,43.818 32,43.818 C31.006,43.818 30.021,43.783 29.072,43.714 L28.927,45.71 C29.925,45.781 30.959,45.818 32,45.818 C40.504,45.818 46,43.463 46,39.817 L45.958,8.363 Z" id="Fill-1" fill="#8C4FFF"></path>
    </g>
</svg>`, fv = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Analytics/Res_Amazon-Redshift_Auto-copy_48</title>
    <g id="Icon-Resource/Analytics/Res_Amazon-Redshift_Auto-copy_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M12.6875,43.9719 C7.3635,43.9719 6.8025,42.9969 6.7975,42.9799 L4.4695,29.5589 C6.9195,30.4829 10.5175,30.5889 12.0005,30.5889 C13.2375,30.5889 17.7915,30.5059 20.6375,29.4009 L19.6145,36.5579 C17.5965,35.8909 15.2855,34.9309 13.9845,34.3499 C13.9085,33.5939 13.2755,32.9999 12.5005,32.9999 C11.6725,32.9999 11.0005,33.6729 11.0005,34.4999 C11.0005,35.3269 11.6725,35.9999 12.5005,35.9999 C12.5795,35.9999 12.6555,35.9889 12.7315,35.9769 C14.0265,36.5759 16.8895,37.7889 19.3265,38.5679 L18.6965,42.9779 C18.6915,42.9879 18.0605,43.9719 12.6875,43.9719 M12.0005,25.3499 C17.1815,25.3499 20.4145,26.3489 20.9585,26.9699 C20.4145,27.5899 17.1815,28.5889 12.0005,28.5889 C6.2805,28.5889 4.1055,27.3799 3.9995,26.9759 C4.1055,26.5589 6.2805,25.3499 12.0005,25.3499 M23.0785,39.3749 C23.7725,39.3749 24.1305,39.1809 24.3845,38.8829 C24.6535,38.5679 24.7575,38.1699 24.6785,37.7629 C24.5255,36.9709 23.7385,36.2849 21.8185,35.2679 L22.9905,27.0829 L22.9805,27.0819 C22.9835,27.0429 23.0005,27.0099 23.0005,26.9699 C23.0005,23.5239 13.8365,23.3499 12.0005,23.3499 C9.6545,23.3499 1.9995,23.6109 1.9995,26.9699 C1.9995,27.1119 2.0325,27.2399 2.0585,27.3709 L4.8255,43.3099 C5.1175,45.1259 7.6155,45.9719 12.6875,45.9719 C17.8395,45.9719 20.3745,45.1259 20.6695,43.2929 L21.2685,39.1119 C22.0505,39.2949 22.6335,39.3749 23.0785,39.3749 M41.4115,10.5629 C40.7835,9.6219 39.7135,8.9999 38.4995,8.9999 C36.7705,8.9999 35.3395,10.2639 35.0595,11.9149 C34.0805,11.9939 33.0635,12.0439 31.9995,12.0439 C24.2235,12.0439 18.9995,9.9639 18.9995,8.0219 C18.9995,6.0799 24.1705,3.9999 31.8685,3.9999 C39.4615,3.9999 43.9995,6.0449 43.9995,8.0219 C43.9995,9.2309 42.5115,10.0909 41.4115,10.5629 M38.4995,13.9999 C37.6725,13.9999 36.9995,13.3269 36.9995,12.4999 C36.9995,11.6729 37.6725,10.9999 38.4995,10.9999 C39.3275,10.9999 39.9995,11.6729 39.9995,12.4999 C39.9995,13.3269 39.3275,13.9999 38.4995,13.9999 M34.4995,23.9999 C33.6725,23.9999 32.9995,23.3269 32.9995,22.4999 C32.9995,21.6729 33.6725,20.9999 34.4995,20.9999 C35.3275,20.9999 35.9995,21.6729 35.9995,22.4999 C35.9995,23.3269 35.3275,23.9999 34.4995,23.9999 M24.5005,21.9999 C23.6725,21.9999 23.0005,21.3269 23.0005,20.4999 C23.0005,19.6729 23.6725,18.9999 24.5005,18.9999 C25.3275,18.9999 26.0005,19.6729 26.0005,20.4999 C26.0005,21.3269 25.3275,21.9999 24.5005,21.9999 M31.8685,1.9999 C24.4675,1.9999 16.9995,3.8619 16.9995,8.0219 L16.9995,21.9999 L18.9995,21.9999 L18.9995,11.2329 C21.7755,13.1469 27.0175,14.0439 31.9995,14.0439 C33.1455,14.0439 34.2435,13.9889 35.2985,13.9019 C35.5795,14.5409 36.0465,15.0759 36.6305,15.4479 L35.2075,19.0719 C34.9795,19.0249 34.7425,18.9999 34.4995,18.9999 C32.9695,18.9999 31.6795,19.9939 31.2055,21.3649 L27.9865,20.6299 C27.9885,20.5859 28.0005,20.5449 28.0005,20.4999 C28.0005,18.5699 26.4295,16.9999 24.5005,16.9999 C22.5705,16.9999 21.0005,18.5699 21.0005,20.4999 C21.0005,22.4299 22.5705,23.9999 24.5005,23.9999 C25.6695,23.9999 26.7015,23.4179 27.3375,22.5329 L31.1325,23.3999 C31.5325,24.8919 32.8835,25.9999 34.4995,25.9999 C36.4295,25.9999 37.9995,24.4299 37.9995,22.4999 C37.9995,21.5379 37.6095,20.6659 36.9785,20.0329 L38.5635,15.9939 C40.4635,15.9589 41.9995,14.4079 41.9995,12.4999 C41.9995,12.4939 41.9985,12.4889 41.9985,12.4829 C42.8145,12.1499 43.4735,11.7879 43.9995,11.4119 L43.9995,39.9779 C43.9995,41.9269 39.7975,43.9979 32.0095,43.9999 C28.7625,43.9989 25.6695,43.6199 23.2985,42.9319 L22.7425,44.8529 C25.3225,45.6019 28.5235,45.9979 31.9995,45.9999 L31.9995,45.9999 C32.0035,45.9999 32.0065,45.9999 32.0095,45.9999 C32.0135,45.9999 32.0165,45.9999 32.0205,45.9999 L32.0205,45.9999 C40.5135,45.9959 46.0005,43.6329 46.0005,39.9779 L46.0005,8.0219 C46.0005,4.3639 40.4535,1.9999 31.8685,1.9999" id="Fill-1" fill="#8C4FFF"></path>
    </g>
</svg>`, pv = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Analytics/Res_Amazon-Redshift_Dense-Compute-Node_48</title>
    <g id="Icon-Resource/Analytics/Res_Amazon-Redshift_Dense-Compute-Node_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M17.423,26.541 C17.771,26.541 18.267,26.45 18.909,26.27 L18.909,27.518 C18.41,27.752 17.851,27.87 17.23,27.87 C15.11,27.87 14.051,26.53 14.051,23.851 C14.051,22.526 14.327,21.512 14.879,20.808 C15.432,20.104 16.227,19.752 17.264,19.752 C17.793,19.752 18.312,19.854 18.819,20.059 L18.819,21.308 C18.297,21.148 17.842,21.069 17.456,21.069 C16.859,21.069 16.419,21.278 16.14,21.699 C15.86,22.119 15.72,22.783 15.72,23.692 L15.72,23.953 C15.72,24.847 15.856,25.501 16.128,25.917 C16.401,26.333 16.832,26.541 17.423,26.541 L17.423,26.541 Z M11.28,23.919 C11.28,24.805 11.159,25.462 10.917,25.89 C10.675,26.316 10.308,26.53 9.816,26.53 L9.147,26.53 L9.147,21.091 L9.805,21.091 C10.312,21.091 10.685,21.302 10.923,21.722 C11.161,22.142 11.28,22.799 11.28,23.692 L11.28,23.919 Z M9.93,19.877 L7.557,19.877 L7.557,27.745 L9.986,27.745 C10.941,27.745 11.666,27.412 12.166,26.746 C12.666,26.08 12.915,25.1 12.915,23.805 C12.915,22.519 12.661,21.542 12.154,20.876 C11.648,20.21 10.905,19.877 9.93,19.877 L9.93,19.877 Z M36.93,26.48 C36.442,26.548 36.061,26.948 36.061,27.454 L36.061,30.433 L33.732,29.655 L36.417,25.731 L36.93,26.48 Z M38.061,34.313 L43.92,34.313 L43.92,28.454 L38.061,28.454 L38.061,34.313 Z M33.694,39.452 L33.694,37.061 C33.694,36.508 33.246,36.061 32.694,36.061 L29.349,36.061 L32.558,31.371 L36.061,32.54 L36.061,35.313 C36.061,35.866 36.508,36.313 37.061,36.313 L37.896,36.313 C36.378,37.465 34.816,38.625 33.694,39.452 L33.694,39.452 Z M25.835,43.92 L31.694,43.92 L31.694,38.061 L25.835,38.061 L25.835,43.92 Z M23.087,31.947 C23.64,31.947 24.087,31.5 24.087,30.947 L24.087,28.545 L30.585,30.713 L26.926,36.061 L24.834,36.061 C24.608,36.061 24.409,36.149 24.241,36.276 L18.917,31.947 L23.087,31.947 Z M4,29.948 L22.087,29.948 L22.087,17.974 L4,17.974 L4,29.948 Z M24.241,11.645 C24.409,11.771 24.608,11.86 24.834,11.86 L26.926,11.86 L30.585,17.208 L24.087,19.376 L24.087,16.974 C24.087,16.421 23.64,15.974 23.087,15.974 L18.917,15.974 L24.241,11.645 Z M25.834,9.86 L31.693,9.86 L31.693,4 L25.834,4 L25.834,9.86 Z M37.896,11.607 L37.061,11.607 C36.508,11.607 36.061,12.055 36.061,12.607 L36.061,15.381 L32.558,16.55 L29.349,11.86 L32.694,11.86 C33.246,11.86 33.694,11.413 33.694,10.86 L33.694,8.469 C34.816,9.296 36.378,10.456 37.896,11.607 L37.896,11.607 Z M38.061,19.467 L43.92,19.467 L43.92,13.608 L38.061,13.608 L38.061,19.467 Z M33.732,18.266 L36.061,17.488 L36.061,20.467 C36.061,20.973 36.442,21.373 36.93,21.44 L36.417,22.19 L33.732,18.266 Z M24.087,21.483 L31.759,18.924 L35.205,23.96 L31.759,28.997 L24.087,26.437 L24.087,21.483 Z M39.334,21.467 L44.92,21.467 C45.473,21.467 45.92,21.02 45.92,20.467 L45.92,12.607 C45.92,12.055 45.473,11.607 44.92,11.607 L41.178,11.607 C38.557,9.56 34.9,6.87 33.694,5.986 L33.694,3 C33.694,2.447 33.246,2 32.694,2 L24.834,2 C24.281,2 23.834,2.447 23.834,3 L23.834,9.396 L15.745,15.974 L3,15.974 C2.447,15.974 2,16.421 2,16.974 L2,30.947 C2,31.5 2.447,31.947 3,31.947 L15.745,31.947 L23.834,38.523 L23.834,44.92 C23.834,45.473 24.281,45.92 24.834,45.92 L32.694,45.92 C33.246,45.92 33.694,45.473 33.694,44.92 L33.694,41.935 C34.9,41.051 38.557,38.361 41.178,36.313 L44.92,36.313 C45.473,36.313 45.92,35.866 45.92,35.313 L45.92,27.454 C45.92,26.901 45.473,26.454 44.92,26.454 L39.334,26.454 L37.628,23.96 L39.334,21.467 Z" id="Fill-19" fill="#8C4FFF"></path>
    </g>
</svg>`, mv = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Analytics/Res_Amazon-Redshift_ML_48</title>
    <g id="Icon-Resource/Analytics/Res_Amazon-Redshift_ML_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M41.391,10.527 C40.76,9.604 39.701,8.996 38.5,8.996 C36.785,8.996 35.36,10.239 35.064,11.87 C34.078,11.95 33.051,12 31.98,12 C24.369,12 19.215,10.019 19,8.123 L19,7.996 L18.981,7.996 C18.989,6.065 24.157,4 31.848,4 C39.438,4 43.975,6.032 43.98,7.997 L43.958,7.997 L43.958,8.126 C43.856,9.259 42.451,10.074 41.391,10.527 L41.391,10.527 Z M38.5,13.996 C37.673,13.996 37,13.323 37,12.496 C37,11.669 37.673,10.996 38.5,10.996 C39.328,10.996 40,11.669 40,12.496 C40,13.323 39.328,13.996 38.5,13.996 L38.5,13.996 Z M34.5,23.996 C33.673,23.996 33,23.323 33,22.496 C33,21.669 33.673,20.996 34.5,20.996 C35.328,20.996 36,21.669 36,22.496 C36,23.323 35.328,23.996 34.5,23.996 L34.5,23.996 Z M24.5,21.996 C23.673,21.996 23,21.323 23,20.496 C23,19.669 23.673,18.996 24.5,18.996 C25.328,18.996 26,19.669 26,20.496 C26,21.323 25.328,21.996 24.5,21.996 L24.5,21.996 Z M22,32.506 L22,36.374 L19.608,37.393 C19.24,37.55 19,37.912 19,38.313 L19,41.327 L15.758,43.803 L14,42.848 L14,26.256 L16.116,25.221 L19,27.658 L19,30.42 C19,30.802 19.218,31.151 19.563,31.319 L22,32.506 Z M12,42.846 L10.234,43.801 L7,41.33 L7,38.417 C7,38.016 6.761,37.654 6.392,37.497 L4,36.478 L4.001,34.404 L4,32.506 L6.438,31.319 C6.783,31.151 7,30.802 7,30.42 L7,27.304 L9.843,25.201 L12,26.256 L12,42.846 Z M45.959,8.363 C45.971,8.239 45.98,8.117 45.98,8 C45.98,4.355 40.433,2 31.848,2 C24.448,2 16.98,3.856 16.98,8 C16.98,8.059 16.997,8.114 17,8.172 L17,20.996 L19,20.996 L19,11.216 C21.782,13.112 27.011,14 31.98,14 C33.123,14 34.221,13.946 35.278,13.86 C35.551,14.504 36.016,15.047 36.596,15.425 L35.162,19.063 C34.948,19.021 34.727,18.996 34.5,18.996 C32.995,18.996 31.721,19.956 31.227,21.291 L27.995,20.556 C27.995,20.536 28,20.516 28,20.496 C28,18.566 26.43,16.996 24.5,16.996 C22.571,16.996 21,18.566 21,20.496 C21,21.497 21.429,22.396 22.106,23.035 L19.784,25.702 L16.909,23.273 C16.605,23.016 16.179,22.964 15.824,23.138 L13,24.518 L10.176,23.138 C9.84,22.975 9.444,23.011 9.142,23.232 L5.406,25.995 C5.151,26.184 5,26.483 5,26.799 L5,29.794 L2.563,30.982 C2.218,31.149 2,31.498 2,31.881 L2,37.139 C2,37.54 2.24,37.902 2.609,38.059 L5,39.078 L5,41.825 C5,42.136 5.146,42.43 5.393,42.619 L9.533,45.782 C9.847,46.023 10.27,46.055 10.616,45.868 L12.999,44.58 L15.372,45.87 C15.522,45.951 15.686,45.991 15.85,45.991 C16.065,45.991 16.279,45.922 16.456,45.786 L20.607,42.617 C20.855,42.427 21,42.133 21,41.822 L21,38.974 L23.393,37.954 C23.761,37.797 24,37.435 24,37.034 L24,31.881 C24,31.499 23.783,31.15 23.438,30.982 L21,29.795 L21,27.351 L23.967,23.942 C24.142,23.969 24.318,23.996 24.5,23.996 C25.698,23.996 26.755,23.389 27.387,22.469 L31.107,23.315 C31.478,24.849 32.854,25.996 34.5,25.996 C36.43,25.996 38,24.425 38,22.496 C38,21.517 37.594,20.633 36.945,19.998 L38.523,15.993 C40.442,15.981 42,14.418 42,12.496 C42,12.476 41.995,12.459 41.995,12.439 C42.793,12.112 43.481,11.759 44,11.392 L44.037,39.819 C44.037,41.757 39.794,43.819 32,43.819 C28.404,43.819 25.069,43.367 22.61,42.547 L21.977,44.444 C24.634,45.331 28.194,45.819 32,45.819 C40.505,45.819 46,43.464 46,39.817 L45.959,8.363 Z" id="Fill-1" fill="#8C4FFF"></path>
    </g>
</svg>`, wv = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Analytics/Res_Amazon-OpenSearch-Service_Traces_48</title>
    <g id="Icon-Resource/Analytics/Res_Amazon-OpenSearch-Service_Traces_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M18,8 L34,8 L34,10 L23,10 L23,22 C23,22.967 23.524,24 24.995,24 L34,24 L34,26 L24.995,26 C24.213,26 23.556,25.806 23,25.502 L23,38.198 C23,39.192 23.809,40 24.802,40 L34,40 L34,42 L24.802,42 C22.705,42 21,40.294 21,38.198 L21,10 L18,10 L18,8 Z M41,44 C39.346,44 38,42.654 38,41 C38,39.346 39.346,38 41,38 C42.654,38 44,39.346 44,41 C44,42.654 42.654,44 41,44 L41,44 Z M41,36 C38.243,36 36,38.243 36,41 C36,43.757 38.243,46 41,46 C43.757,46 46,43.757 46,41 C46,38.243 43.757,36 41,36 L41,36 Z M41,28 C39.346,28 38,26.654 38,25 C38,23.346 39.346,22 41,22 C42.654,22 44,23.346 44,25 C44,26.654 42.654,28 41,28 L41,28 Z M41,20 C38.243,20 36,22.243 36,25 C36,27.757 38.243,30 41,30 C43.757,30 46,27.757 46,25 C46,22.243 43.757,20 41,20 L41,20 Z M41,6 C42.654,6 44,7.346 44,9 C44,10.654 42.654,12 41,12 C39.346,12 38,10.654 38,9 C38,7.346 39.346,6 41,6 L41,6 Z M41,14 C43.757,14 46,11.757 46,9 C46,6.243 43.757,4 41,4 C38.243,4 36,6.243 36,9 C36,11.757 38.243,14 41,14 L41,14 Z M4,14 L14,14 L14,4 L4,4 L4,14 Z M15,2 L3,2 C2.447,2 2,2.448 2,3 L2,15 C2,15.552 2.447,16 3,16 L15,16 C15.553,16 16,15.552 16,15 L16,3 C16,2.448 15.553,2 15,2 L15,2 Z" id="Fill-1" fill="#8C4FFF"></path>
    </g>
</svg>`, xv = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Analytics/Res_Amazon-EMR_Cluster_48</title>
    <g id="Icon-Resource/Analytics/Res_Amazon-EMR_Cluster_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M36.946,26.491 C36.458,26.557 36.076,26.958 36.076,27.465 L36.076,30.446 L33.745,29.669 L36.433,25.74 L36.946,26.491 Z M38.076,34.329 L43.94,34.329 L43.94,28.465 L38.076,28.465 L38.076,34.329 Z M33.708,39.47 L33.708,37.076 C33.708,36.523 33.26,36.076 32.708,36.076 L29.36,36.076 L32.571,31.385 L36.076,32.553 L36.076,35.329 C36.076,35.882 36.523,36.329 37.076,36.329 L37.913,36.329 C36.394,37.481 34.831,38.642 33.708,39.47 L33.708,39.47 Z M25.844,43.94 L31.708,43.94 L31.708,38.076 L25.844,38.076 L25.844,43.94 Z M10.426,33.455 C6.423,33.455 4.106,32.304 4,31.82 L3.999,18.747 C5.648,19.546 8.087,19.927 10.426,19.927 C12.766,19.927 15.205,19.546 16.853,18.747 L16.854,31.812 C16.745,32.303 14.426,33.455 10.426,33.455 L10.426,33.455 Z M16.678,16.519 C16.07,17.07 13.88,17.927 10.426,17.927 C6.966,17.927 4.773,17.067 4.172,16.521 C4.774,15.97 6.966,15.112 10.426,15.112 C13.88,15.112 16.07,15.968 16.678,16.519 L16.678,16.519 Z M25.843,9.864 L31.707,9.864 L31.707,4 L25.843,4 L25.843,9.864 Z M37.913,11.611 L37.076,11.611 C36.523,11.611 36.076,12.058 36.076,12.611 L36.076,15.387 L32.571,16.555 L29.36,11.864 L32.708,11.864 C33.26,11.864 33.708,11.417 33.708,10.864 L33.708,8.47 C34.831,9.298 36.394,10.459 37.913,11.611 L37.913,11.611 Z M38.076,19.475 L43.94,19.475 L43.94,13.611 L38.076,13.611 L38.076,19.475 Z M33.745,18.271 L36.076,17.494 L36.076,20.475 C36.076,20.982 36.458,21.384 36.946,21.449 L36.433,22.2 L33.745,18.271 Z M18.853,24.701 L18.853,23.239 L31.772,18.929 L35.221,23.97 L31.772,29.011 L18.853,24.701 Z M24.25,11.648 C24.418,11.775 24.617,11.864 24.843,11.864 L26.937,11.864 L30.598,17.214 L18.853,21.132 L18.853,16.748 C18.853,16.669 18.837,16.595 18.828,16.519 C18.837,16.443 18.853,16.37 18.853,16.291 L18.801,16.291 C18.789,16.232 18.761,16.178 18.743,16.121 L24.25,11.648 Z M24.843,36.076 C24.617,36.076 24.418,36.165 24.25,36.293 L18.844,31.903 C18.845,31.875 18.853,31.848 18.853,31.82 L18.853,26.808 L30.598,30.726 L26.937,36.076 L24.843,36.076 Z M39.351,21.475 L44.94,21.475 C45.493,21.475 45.94,21.028 45.94,20.475 L45.94,12.611 C45.94,12.058 45.493,11.611 44.94,11.611 L41.195,11.611 C38.573,9.562 34.915,6.872 33.708,5.987 L33.708,3 C33.708,2.447 33.26,2 32.708,2 L24.843,2 C24.291,2 23.843,2.447 23.843,3 L23.843,9.4 L17.428,14.611 C15.811,13.594 13.058,13.112 10.426,13.112 C6.625,13.112 2.551,14.111 2.051,16.291 L2,16.291 C2,16.37 2.016,16.443 2.025,16.519 C2.016,16.595 2,16.669 2,16.748 L2,31.82 C2,34.317 6.368,35.455 10.426,35.455 C13.298,35.455 16.316,34.883 17.842,33.665 L23.843,38.54 L23.843,44.94 C23.843,45.493 24.291,45.94 24.843,45.94 L32.708,45.94 C33.26,45.94 33.708,45.493 33.708,44.94 L33.708,41.953 C34.915,41.068 38.573,38.378 41.195,36.329 L44.94,36.329 C45.493,36.329 45.94,35.882 45.94,35.329 L45.94,27.465 C45.94,26.912 45.493,26.465 44.94,26.465 L39.351,26.465 L37.644,23.97 L39.351,21.475 Z" id="Fill-6" fill="#8C4FFF"></path>
    </g>
</svg>`, _v = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Analytics/Res_Amazon-OpenSearch-Service_Data-Node_48</title>
    <g id="Icon-Resource/Analytics/Res_Amazon-OpenSearch-Service_Data-Node_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M43.911,42.5127 C43.944,42.2657 43.849,42.1377 43.774,42.0627 L38.212,36.6497 C37.808,37.1687 37.358,37.6467 36.868,38.0847 L42.256,43.5987 C42.593,43.9327 43.167,43.6057 43.473,43.3007 C43.718,43.0557 43.877,42.7687 43.911,42.5127 L43.911,42.5127 Z M29.591,38.8797 C34.52,38.8797 38.53,34.8697 38.53,29.9397 C38.53,25.0107 34.52,20.9997 29.591,20.9997 C24.661,20.9997 20.651,25.0107 20.651,29.9397 C20.651,34.8697 24.661,38.8797 29.591,38.8797 L29.591,38.8797 Z M45.179,40.6387 C45.751,41.2117 46.002,41.9677 45.893,42.7767 C45.802,43.4707 45.443,44.1587 44.887,44.7157 C44.213,45.3887 43.389,45.7337 42.604,45.7337 C41.95,45.7337 41.323,45.4927 40.834,45.0057 L35.247,39.2867 C33.594,40.2907 31.662,40.8797 29.591,40.8797 C23.558,40.8797 18.651,35.9717 18.651,29.9397 C18.651,23.9077 23.558,18.9997 29.591,18.9997 C35.623,18.9997 40.53,23.9077 40.53,29.9397 C40.53,31.7387 40.086,33.4327 39.314,34.9307 L45.179,40.6387 Z M46,6.9997 L46,28.9997 L44,28.9997 L44,6.9997 C44,5.3457 42.654,3.9997 41,3.9997 L7,3.9997 C5.346,3.9997 4,5.3457 4,6.9997 L4,40.9997 C4,42.6547 5.346,43.9997 7,43.9997 L29,43.9997 L29,45.9997 L7,45.9997 C4.243,45.9997 2,43.7567 2,40.9997 L2,6.9997 C2,4.2427 4.243,1.9997 7,1.9997 L41,1.9997 C43.757,1.9997 46,4.2427 46,6.9997 L46,6.9997 Z" id="Fill-1" fill="#8C4FFF"></path>
    </g>
</svg>`, vv = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Analytics/Res_AWS-Data-Exchange-for-APIs_48</title>
    <g id="Icon-Resource/Analytics/Res_AWS-Data-Exchange-for-APIs_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M14,34.007 L34,34.007 L34,14.007 L14,14.007 L14,34.007 Z M35,12.007 C35.553,12.007 36,12.455 36,13.007 L36,35.007 C36,35.559 35.553,36.007 35,36.007 L13,36.007 C12.447,36.007 12,35.559 12,35.007 L12,13.007 C12,12.455 12.447,12.007 13,12.007 L35,12.007 Z M25.793,29.714 L27.207,28.3 L22.914,24.007 L27.207,19.714 L25.793,18.3 L20.793,23.3 C20.402,23.691 20.402,24.323 20.793,24.714 L25.793,29.714 Z M7.707,10.3 L5.414,8.007 L43,8.007 L43,6.007 L5.414,6.007 L7.707,3.714 L6.293,2.3 L2.293,6.3 C1.902,6.691 1.902,7.323 2.293,7.714 L6.293,11.714 L7.707,10.3 Z M45.707,41.714 L41.707,45.714 L40.293,44.3 L42.586,42.007 L5,42.007 L5,40.007 L42.586,40.007 L40.293,37.714 L41.707,36.3 L45.707,40.3 C46.098,40.691 46.098,41.323 45.707,41.714 L45.707,41.714 Z" id="Fill-1" fill="#8C4FFF"></path>
    </g>
</svg>`, Mv = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/End-User-Computing/Res_Amazon-WorkSpaces-Family_Amazon-WorkSpaces_48</title>
    <g id="Icon-Resource/End-User-Computing/Res_Amazon-WorkSpaces-Family_Amazon-WorkSpaces_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M5.0307,10.5417085 L13.0237,6.12870845 L16.9237,8.07870845 L8.9917,12.8387085 L5.0307,10.5417085 Z M7.9997,26.1307085 L3.9997,23.4647085 L3.9997,12.2567085 L7.9997,14.5757085 L7.9997,26.1307085 Z M19.5147,8.85670845 C19.8267,8.66970845 20.0137,8.32570845 19.9987,7.96070845 C19.9857,7.59670845 19.7737,7.26870845 19.4477,7.10470845 L13.4477,4.10470845 C13.1537,3.95870845 12.8047,3.96570845 12.5167,4.12370845 L2.5167,9.64470845 L2.5177,9.64670845 C2.5127,9.64970845 2.5067,9.65070845 2.5007,9.65370845 C2.1917,9.83270845 1.9997,10.1627085 1.9997,10.5207085 L1.9997,23.9997085 C1.9997,24.3337085 2.1667,24.6457085 2.4457,24.8317085 L8.4457,28.8317085 C8.6127,28.9437085 8.8057,28.9997085 8.9997,28.9997085 C9.1617,28.9997085 9.3247,28.9607085 9.4717,28.8817085 C9.7967,28.7067085 9.9997,28.3677085 9.9997,27.9997085 L9.9997,14.5657085 L19.5147,8.85670845 Z M33.8197,26.6657085 L36.4077,28.1827085 L35.3957,29.9087085 L32.8077,28.3907085 L33.8197,26.6657085 Z M38.1347,29.1977085 L40.7177,30.7227085 L39.6997,32.4447085 L37.1167,30.9187085 L38.1347,29.1977085 Z M14.9997,33.4647085 L14.9997,27.4867085 L17.6157,25.4447085 L16.3847,23.8687085 L14.9997,24.9497085 L14.9997,17.7657085 L20.2027,20.8867085 L18.5067,22.2117085 L19.7377,23.7877085 L22.0397,21.9897085 L27.9997,25.5657085 L27.9997,42.1307085 L14.9997,33.4647085 Z M20.9997,12.9657085 L20.9997,13.9997085 L22.9997,13.9997085 L22.9997,11.7657085 L29.0147,8.15770845 L42.9597,16.0657085 L29.0187,23.8447085 L22.9997,20.2337085 L22.9997,16.9997085 L20.9997,16.9997085 L20.9997,19.0337085 L15.9437,15.9997085 L20.9997,12.9657085 Z M42.4407,31.7397085 L41.4227,33.4617085 L43.0437,34.4187085 L29.9997,42.2347085 L29.9997,26.7447085 L31.0817,27.3797085 L32.0937,25.6537085 L31.0137,25.0207085 L43.9997,17.7757085 L43.9997,32.6607085 L42.4407,31.7397085 Z M45.9997,16.0737085 C45.9997,15.7137085 45.8067,15.3817085 45.4927,15.2037085 L29.4927,6.12970845 C29.1797,5.95170845 28.7947,5.95470845 28.4857,6.14170845 L13.4857,15.1417085 C13.1847,15.3227085 12.9997,15.6487085 12.9997,15.9997085 L12.9997,33.9997085 C12.9997,34.3337085 13.1667,34.6457085 13.4457,34.8317085 L28.4457,44.8317085 C28.6127,44.9437085 28.8057,44.9997085 28.9997,44.9997085 C29.1617,44.9997085 29.3247,44.9607085 29.4717,44.8817085 C29.4867,44.8737085 29.4967,44.8617085 29.5107,44.8527085 L29.5137,44.8577085 L45.5137,35.2707085 C45.8157,35.0897085 45.9997,34.7637085 45.9997,34.4127085 L45.9997,16.0737085 Z" id="Fill-1" fill="#01A88D"></path>
    </g>
</svg>`, Rv = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/End-User-Computing/Res_Amazon-WorkSpaces-Family_Amazon-WorkSpaces-Core_48</title>
    <g id="Icon-Resource/End-User-Computing/Res_Amazon-WorkSpaces-Family_Amazon-WorkSpaces-Core_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M46,22.448209 C46,29.424209 41.96,30.993209 40.545,30.993209 L39,30.993209 L39,28.993209 L40.545,28.993209 C41.274,28.993209 44,27.883209 44,22.448209 C44,17.423209 39.744,16.150209 37.914,15.837209 C37.378,15.744209 37.014,15.240209 37.094,14.702209 C37.096,12.525209 36.174,10.936209 34.566,10.406209 C33.144,9.93520902 31.573,10.449209 30.661,11.681209 C30.44,11.978209 30.078,12.131209 29.709,12.075209 C29.344,12.020209 29.038,11.768209 28.915,11.420209 C28.288,9.64720902 27.38,8.15720902 26.216,6.99220902 C24.791,5.56520902 20.881,2.49420902 15.358,4.83020902 C12.172,6.17720902 9.677,10.058209 9.677,13.666209 L9.753,14.926209 C9.781,15.404209 9.467,15.835209 9.003,15.954209 C7.135,16.431209 4,17.902209 4,22.384209 C4,25.754209 5.832,27.612209 7.369,28.578209 C7.838,28.872209 8.311,28.992209 9.001,28.993209 L8.999,30.993209 C7.943,30.992209 7.087,30.762209 6.305,30.271209 C4.697,29.261209 2,26.893209 2,22.384209 C2,17.053209 5.531,15.009209 7.71,14.256209 L7.679,13.725209 C7.677,9.24220902 10.645,4.65120902 14.579,2.98820902 C19.187,1.03920902 24.065,2.00920902 27.631,5.57920902 C28.676,6.62520902 29.542,7.88020902 30.217,9.32420902 C31.628,8.27320902 33.475,7.94020902 35.193,8.50620902 C37.441,9.24820902 38.856,11.288209 39.068,14.036209 C42.557,14.897209 46,17.487209 46,22.448209 L46,22.448209 Z M25,43.254209 L25,31.568209 L35,25.734209 L35,37.419209 L25,43.254209 Z M13.006,25.738209 L23,31.568209 L23,43.250209 L13.006,37.419209 L13.006,25.738209 Z M24.004,18.152209 L34.016,23.993209 L24,29.836209 L14,24.003209 L24.004,18.152209 Z M36.504,23.130209 L24.507,16.130209 C24.195,15.947209 23.81,15.948209 23.498,16.130209 L11.584,23.098209 C11.326,23.220209 11.121,23.449209 11.038,23.739209 C11.002,23.866209 10.992,23.996209 11.006,24.122209 L11.006,37.993209 C11.006,38.349209 11.194,38.678209 11.502,38.857209 L23.499,45.857209 C23.654,45.948209 23.829,45.993209 24.003,45.993209 C24.177,45.993209 24.352,45.948209 24.507,45.857209 L36.504,38.857209 C36.812,38.678209 37,38.349209 37,37.993209 L37,23.993209 C37,23.638209 36.812,23.309209 36.504,23.130209 L36.504,23.130209 Z" id="Fill-1" fill="#01A88D"></path>
    </g>
</svg>`, yv = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/End-User-Computing/Res_Amazon-WorkSpaces-Family_Amazon-WorkSpaces-Web_48</title>
    <g id="Icon-Resource/End-User-Computing/Res_Amazon-WorkSpaces-Family_Amazon-WorkSpaces-Web_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M25,42.26 L25,30.574 L35,24.741 L35,36.425 L25,42.26 Z M13,24.744 L23,30.574 L23,42.257 L13,36.425 L13,24.744 Z M24.004,17.158 L34.016,22.999 L24,28.842 L14,23.009 L24.004,17.158 Z M36.504,22.136 L24.507,15.136 C24.195,14.953 23.81,14.954 23.498,15.136 L11.584,22.104 C11.326,22.226 11.121,22.456 11.038,22.745 C11.002,22.872 10.992,23.002 11.006,23.128 L11.006,37 C11.006,37.355 11.194,37.684 11.502,37.863 L23.499,44.863 C23.654,44.954 23.829,45 24.003,45 C24.177,45 24.352,44.954 24.507,44.863 L36.504,37.863 C36.812,37.684 37,37.355 37,37 L37,23 C37,22.644 36.812,22.315 36.504,22.136 L36.504,22.136 Z M13.012,7 C13.012,7.552 12.564,8 12.012,8 C11.46,8 11.012,7.552 11.012,7 C11.012,6.447 11.46,6 12.012,6 C12.564,6 13.012,6.447 13.012,7 L13.012,7 Z M10.012,7 C10.012,7.552 9.564,8 9.012,8 C8.46,8 8.012,7.552 8.012,7 C8.012,6.447 8.46,6 9.012,6 C9.564,6 10.012,6.447 10.012,7 L10.012,7 Z M7.012,7 C7.012,7.552 6.564,8 6.012,8 C5.46,8 5.012,7.552 5.012,7 C5.012,6.447 5.46,6 6.012,6 C6.564,6 7.012,6.447 7.012,7 L7.012,7 Z M40,31 L42,31 L42,13 L40,13 L40,31 Z M4,9 L4,5 L44,5 L44,9 L4,9 Z M44,3 L4,3 C2.897,3 2,3.896 2,5 L2.002,33 C2.002,34.103 2.899,35 4.002,35 L9,35 L9,33 L4,33 L4,11 L44,11 L44,33 L39,33 L39,35 L44,35 C45.103,35 46,34.103 46,33 L46,5 C46,3.896 45.103,3 44,3 L44,3 Z" id="Fill-1" fill="#01A88D"></path>
    </g>
</svg>`, Av = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Security-Identity-and-Compliance/Res_AWS-Directory-Service_Simple-AD_48</title>
    <g id="Icon-Resource/Security-Identity-and-Compliance/Res_AWS-Directory-Service_Simple-AD_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M43.8808,41.2608 L43.8798,26.3408 C42.0338,27.2478 39.1728,27.6758 36.4378,27.6758 C33.7018,27.6758 30.8418,27.2478 28.9958,26.3418 L28.9958,41.2718 C29.1178,41.7538 31.5948,43.0518 36.4378,43.0518 C41.2808,43.0518 43.7578,41.7538 43.8808,41.2608 L43.8808,41.2608 Z M28.9958,23.8958 C29.1188,24.3778 31.5968,25.6758 36.4378,25.6758 C41.2658,25.6758 43.7428,24.3848 43.8798,23.8888 L43.8798,23.7958 C43.7578,23.3138 41.2808,22.0158 36.4378,22.0158 C31.6078,22.0158 29.1318,23.3068 28.9958,23.8028 L28.9958,23.8958 Z M45.8798,23.7938 L45.8798,23.7958 L45.8798,41.2718 C45.8798,43.8688 40.9848,45.0518 36.4378,45.0518 C31.8908,45.0518 26.9958,43.8688 26.9958,41.2718 L26.9958,23.7958 L26.9958,23.7938 C26.9978,21.1988 31.8918,20.0158 36.4378,20.0158 C40.9848,20.0158 45.8778,21.1988 45.8798,23.7938 L45.8798,23.7938 Z M26.0948,35.2488 C26.0948,35.8018 25.6478,36.2488 25.0948,36.2488 L2.9998,36.2488 C2.6428,36.2488 2.3128,36.0588 2.1338,35.7488 C1.9548,35.4398 1.9548,35.0588 2.1338,34.7488 L20.7528,2.4998 C20.9318,2.1908 21.2618,1.9998 21.6188,1.9998 C21.9768,1.9998 22.3068,2.1908 22.4848,2.4998 L31.3568,17.8658 C31.6328,18.3448 31.4688,18.9558 30.9898,19.2328 C30.5128,19.5068 29.8998,19.3448 29.6238,18.8658 L21.6188,4.9998 L4.7328,34.2488 L25.0948,34.2488 C25.6478,34.2488 26.0948,34.6968 26.0948,35.2488 L26.0948,35.2488 Z" id="AWS-Directory-Service_Simple-AD_Resource-Icon_light-bg" fill="#DD344C"></path>
    </g>
</svg>`, Zv = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Security-Identity-and-Compliance/Res_AWS-WAF_Bad-Bot_48</title>
    <g id="Icon-Resource/Security-Identity-and-Compliance/Res_AWS-WAF_Bad-Bot_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M24,35 C21.586,35 19.565,33.279 19.102,31 L28.898,31 C28.435,33.279 26.414,35 24,35 L24,35 Z M24,25 C26.414,25 28.435,26.721 28.898,29 L19.102,29 C19.565,26.721 21.586,25 24,25 L24,25 Z M24,23 C20.141,23 17,26.14 17,30 C17,33.86 20.141,37 24,37 C27.859,37 31,33.86 31,30 C31,26.14 27.859,23 24,23 L24,23 Z M34,30 C34,34.962 29.963,39 25,39 L23,39 C18.037,39 14,34.962 14,30 C14,25.038 18.037,21 23,21 L25,21 C27.031,21 28.9,21.684 30.408,22.823 L30.518,22.993 L30.581,22.952 C32.66,24.603 34,27.146 34,30 L34,30 Z M22.291,17 L25.707,17 C27.131,17 28.332,18.126 28.779,19.683 C27.599,19.249 26.329,19 25,19 L23,19 C21.67,19 20.4,19.249 19.219,19.684 C19.666,18.126 20.867,17 22.291,17 L22.291,17 Z M22,8 C22,6.897 22.897,6 24,6 C25.103,6 26,6.897 26,8 C26,9.103 25.103,10 24,10 C22.897,10 22,9.103 22,8 L22,8 Z M46,17 L46,15 L39.221,15 L30.942,20.34 C30.652,17.341 28.416,15 25.707,15 L25,15 L25,11.858 C26.721,11.411 28,9.858 28,8 C28,5.794 26.206,4 24,4 C21.794,4 20,5.794 20,8 C20,9.858 21.279,11.411 23,11.858 L23,15 L22.291,15 C19.453,15 17.139,17.57 17.032,20.772 C16.997,20.796 16.958,20.816 16.923,20.839 L9.49,15 L2,15 L2,17 L8.799,17 L15.329,22.131 C14.477,22.962 13.763,23.931 13.214,25 L2,25 L2,27 L12.427,27 C12.155,27.955 12,28.959 12,30 C12,30.684 12.071,31.351 12.191,32 L2,32 L2,34 L12.764,34 C13.333,35.452 14.196,36.756 15.289,37.833 L8.212,42 L2,42 L2,44 L8.757,44 L16.949,39.177 C18.687,40.326 20.766,41 23,41 L25,41 C27.216,41 29.277,40.336 31.006,39.204 L38.565,44 L46,44 L46,42 L39.146,42 L32.656,37.882 C33.774,36.796 34.657,35.475 35.236,34 L46,34 L46,32 L35.809,32 C35.929,31.351 36,30.684 36,30 C36,28.959 35.845,27.955 35.573,27 L46,27 L46,25 L34.786,25 C34.167,23.794 33.332,22.721 32.332,21.823 L39.811,17 L46,17 Z" id="Fill-1" fill="#DD344C"></path>
    </g>
</svg>`, kv = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Security-Identity-and-Compliance/Res_AWS-Identity-Access-Management_AWS-STS_48</title>
    <g id="Icon-Resource/Security-Identity-and-Compliance/Res_AWS-Identity-Access-Management_AWS-STS_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M4,36.251 L44,36.251 L44,12 L4,12 L4,36.251 Z M45,10 L3,10 C2.448,10 2,10.447 2,11 L2,37.251 C2,37.804 2.448,38.251 3,38.251 L45,38.251 C45.553,38.251 46,37.804 46,37.251 L46,11 C46,10.447 45.553,10 45,10 L45,10 Z M12.169,22.481 C13.091,22.481 13.841,23.231 13.841,24.153 C13.841,25.075 13.091,25.825 12.169,25.825 C11.247,25.825 10.497,25.075 10.497,24.153 C10.497,23.231 11.247,22.481 12.169,22.481 L12.169,22.481 Z M12.169,27.825 C14.194,27.825 15.841,26.178 15.841,24.153 C15.841,22.129 14.194,20.481 12.169,20.481 C10.145,20.481 8.497,22.129 8.497,24.153 C8.497,26.178 10.145,27.825 12.169,27.825 L12.169,27.825 Z M14.841,16.375 C18.245,16.375 21.221,18.549 22.246,21.783 C22.378,22.199 22.764,22.481 23.2,22.481 L25.909,22.481 C26.174,22.481 26.428,22.376 26.616,22.189 L28.199,20.606 L29.782,22.189 C29.969,22.376 30.223,22.481 30.489,22.481 L32.015,22.481 C32.281,22.481 32.534,22.376 32.722,22.189 L34.305,20.606 L35.888,22.189 C36.076,22.376 36.329,22.481 36.595,22.481 L38.509,22.481 L40.534,24.254 L39.189,25.825 L23.2,25.825 C22.764,25.825 22.378,26.107 22.246,26.523 C21.221,29.758 18.245,31.932 14.841,31.932 C10.552,31.932 7.063,28.442 7.063,24.153 C7.063,19.864 10.552,16.375 14.841,16.375 L14.841,16.375 Z M14.841,33.932 C18.872,33.932 22.425,31.507 23.903,27.825 L39.649,27.825 C39.941,27.825 40.218,27.697 40.409,27.476 L42.698,24.804 C43.054,24.388 43.009,23.762 42.596,23.4 L39.543,20.729 C39.362,20.569 39.127,20.481 38.885,20.481 L37.009,20.481 L35.012,18.485 C34.621,18.095 33.989,18.095 33.598,18.485 L31.601,20.481 L30.903,20.481 L28.906,18.485 C28.515,18.095 27.882,18.095 27.492,18.485 L25.494,20.481 L23.903,20.481 C22.425,16.8 18.871,14.375 14.841,14.375 C9.45,14.375 5.063,18.762 5.063,24.153 C5.063,29.545 9.45,33.932 14.841,33.932 L14.841,33.932 Z" id="AWS-Identity-and-Access-Management_AWS-STS_Resource-Icon_light-bg" fill="#DD344C"></path>
    </g>
</svg>`, Tv = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Security-Identity-and-Compliance/Res_AWS-Identity-Access-Management_Add-on_48</title>
    <g id="Icon-Resource/Security-Identity-and-Compliance/Res_AWS-Identity-Access-Management_Add-on_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M10.149,26.404 C8.975,26.404 8.021,25.45 8.021,24.277 C8.021,23.103 8.975,22.149 10.149,22.149 C11.323,22.149 12.277,23.103 12.277,24.277 C12.277,25.45 11.323,26.404 10.149,26.404 L10.149,26.404 Z M10.149,20.149 C7.873,20.149 6.021,22.001 6.021,24.277 C6.021,26.552 7.873,28.404 10.149,28.404 C12.425,28.404 14.277,26.552 14.277,24.277 C14.277,22.001 12.425,20.149 10.149,20.149 L10.149,20.149 Z M41.86,26.404 L23.062,26.404 C22.627,26.404 22.241,26.686 22.109,27.102 C20.886,30.961 17.337,33.553 13.277,33.553 C8.162,33.553 4,29.392 4,24.277 C4,19.162 8.162,15 13.277,15 C17.337,15 20.886,17.592 22.109,21.451 C22.241,21.867 22.627,22.149 23.062,22.149 L26.234,22.149 C26.5,22.149 26.753,22.044 26.941,21.856 L28.915,19.883 L30.889,21.856 C31.077,22.044 31.331,22.149 31.596,22.149 L33.383,22.149 C33.649,22.149 33.903,22.044 34.09,21.856 L36.064,19.883 L38.038,21.856 C38.225,22.044 38.479,22.149 38.745,22.149 L41.049,22.149 L43.597,24.378 L41.86,26.404 Z M45.659,23.524 L42.084,20.396 C41.902,20.237 41.668,20.149 41.425,20.149 L39.159,20.149 L36.771,17.761 C36.38,17.371 35.748,17.371 35.357,17.761 L32.969,20.149 L32.01,20.149 L29.622,17.761 C29.231,17.371 28.598,17.371 28.208,17.761 L25.82,20.149 L23.769,20.149 C22.091,15.843 17.964,13 13.277,13 C7.058,13 2,18.058 2,24.277 C2,30.495 7.058,35.553 13.277,35.553 C17.964,35.553 22.091,32.71 23.769,28.404 L42.32,28.404 C42.612,28.404 42.889,28.276 43.079,28.054 L45.759,24.927 C46.117,24.511 46.072,23.885 45.659,23.524 L45.659,23.524 Z" id="Icon-Resource/Security-Identity-and-Compliance/Res_Add-On_48" fill="#DD344C"></path>
    </g>
</svg>`, Sv = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Security-Identity-and-Compliance/Res_Amazon-Inspector_Agent_48</title>
    <g id="Icon-Resource/Security-Identity-and-Compliance/Res_Amazon-Inspector_Agent_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M23.1026,24.688 C21.6706,26.121 19.0896,25.87 17.3526,24.132 C15.6146,22.395 15.3646,19.815 16.7966,18.383 C17.4036,17.776 18.2476,17.455 19.1696,17.455 C19.5186,17.455 19.8776,17.501 20.2406,17.594 C21.0906,17.814 21.8886,18.279 22.5466,18.938 C24.2866,20.676 24.5356,23.256 23.1026,24.688 L23.1026,24.688 Z M25.8296,20.477 C25.4986,19.37 24.8816,18.332 24.0176,17.467 C23.5796,17.03 23.0926,16.658 22.5756,16.349 L23.2746,12.852 L21.2356,12.445 L20.6146,15.552 C19.4036,15.268 18.2026,15.339 17.1476,15.741 C16.8506,14.677 16.2136,13.389 14.3706,12.613 L13.5636,14.529 C14.8656,15.078 15.0846,15.903 15.2756,16.861 C14.3176,16.671 13.4926,16.451 12.9436,15.148 L11.0276,15.956 C11.8056,17.802 13.0956,18.438 14.1606,18.733 C13.7526,19.809 13.6926,21.016 13.9686,22.199 L10.8596,22.821 L11.2676,24.86 L14.7636,24.161 C15.0676,24.671 15.4376,25.159 15.8816,25.603 C16.6856,26.407 17.6246,26.975 18.6036,27.315 L18.6036,29.381 L20.6836,29.381 L20.6836,27.687 C20.7016,27.688 20.7196,27.69 20.7376,27.69 C22.1706,27.69 23.5456,27.186 24.5736,26.159 C25.5226,25.209 26.0506,23.949 26.1026,22.556 L28.2816,22.556 L28.2816,20.477 L25.8296,20.477 Z M19.1046,30.666 C13.2806,30.666 8.5416,25.927 8.5416,20.104 C8.5416,14.279 13.2806,9.541 19.1046,9.541 C24.9286,9.541 29.6656,14.279 29.6656,20.104 C29.6656,25.927 24.9286,30.666 19.1046,30.666 L19.1046,30.666 Z M19.1046,7.462 C12.1336,7.462 6.4616,13.133 6.4616,20.104 C6.4616,27.074 12.1336,32.745 19.1046,32.745 C26.0756,32.745 31.7466,27.074 31.7466,20.104 C31.7466,13.133 26.0756,7.462 19.1046,7.462 L19.1046,7.462 Z M43.3566,41.843 C42.5086,42.784 41.0566,42.858 40.1196,42.012 L30.2116,33.084 C31.3746,32.086 32.4116,30.945 33.2726,29.673 L43.1876,38.607 C44.1266,39.453 44.2026,40.905 43.3566,41.843 L43.3566,41.843 Z M4.0806,20.104 C4.0806,11.819 10.8196,5.079 19.1046,5.079 C27.3886,5.079 34.1276,11.819 34.1276,20.104 C34.1276,28.388 27.3886,35.128 19.1046,35.128 C10.8196,35.128 4.0806,28.388 4.0806,20.104 L4.0806,20.104 Z M44.5806,37.062 L34.3406,27.835 C35.5256,25.51 36.2076,22.887 36.2076,20.104 C36.2076,10.672 28.5356,3 19.1046,3 C9.6726,3 1.9996,10.672 1.9996,20.104 C1.9996,29.535 9.6726,37.208 19.1046,37.208 C22.5846,37.208 25.8226,36.157 28.5266,34.364 L38.7276,43.557 C39.5616,44.308 40.6076,44.678 41.6516,44.678 C42.8466,44.678 44.0396,44.192 44.9016,43.236 C46.5146,41.446 46.3706,38.676 44.5806,37.062 L44.5806,37.062 Z" id="AWS-Amazon-Inspector_Agent_Resource-Icon_light-bg" fill="#DD344C"></path>
    </g>
</svg>`, bv = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Security-Identity-and-Compliance/Res_AWS-Identity-Access-Management_Encrypted-Data_48</title>
    <g id="Icon-Resource/Security-Identity-and-Compliance/Res_AWS-Identity-Access-Management_Encrypted-Data_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M22.8353,28.1396 C23.0343,27.9406 23.3003,27.8306 23.5823,27.8306 L23.5833,27.8306 C23.8653,27.8306 24.1313,27.9416 24.3313,28.1406 C24.5303,28.3406 24.6403,28.6056 24.6403,28.8876 L24.6403,28.8886 C24.6403,29.1716 24.5293,29.4376 24.3293,29.6366 C24.1303,29.8356 23.8663,29.9456 23.5833,29.9456 L23.5813,29.9456 C22.9993,29.9456 22.5253,29.4706 22.5253,28.8886 C22.5253,28.6056 22.6363,28.3396 22.8353,28.1396 L22.8353,28.1396 Z M22.5823,31.7636 L22.5823,35.2906 L24.5823,35.2906 L24.5823,31.7666 C25.0123,31.6176 25.4103,31.3836 25.7423,31.0526 C26.3203,30.4746 26.6403023,29.7066 26.6403023,28.8896 C26.6413,28.0736 26.3223,27.3046 25.7453,26.7276 C25.1683,26.1496 24.4003,25.8306 23.5843,25.8306 L23.5813,25.8306 C22.7663,25.8306 21.9983,26.1486 21.4213,26.7256 C20.8443,27.3026 20.5263,28.0706 20.5253,28.8876 C20.5253,30.2216 21.3903,31.3476 22.5823,31.7636 L22.5823,31.7636 Z M32.1763,37.7826 L15.0193,37.7746 L15.0233,24.0736 L32.1833,24.0806 L32.1763,37.7826 Z M19.3493,18.8556 C19.3533,17.6756 19.8013,16.5696 20.6103,15.7406 C21.4093,14.9226 22.4663,14.4736 23.5873,14.4736 L23.6023,14.4736 C24.7243,14.4766 25.7763,14.9366 26.5683,15.7656 C27.3673,16.6046 27.8063,17.7186 27.8023271,18.9076 L27.8023271,22.0786 L19.3333,22.0756 L19.3493,18.8556 Z M33.1833,22.0806 L29.8023,22.0796 L29.8023,18.9106 C29.8083,17.2066 29.1733,15.5996 28.0163,14.3856 C26.8453,13.1586 25.2793,12.4786 23.6073,12.4736 L23.5873,12.4736 C21.9233,12.4736 20.3583,13.1366 19.1803,14.3426 C18.0053,15.5456 17.3553,17.1466 17.3493,18.8476 L17.3333,22.0746 L14.0233,22.0736 C13.7593,22.0736 13.5043,22.1786 13.3163,22.3666 C13.1293,22.5536 13.0233,22.8076 13.0233,23.0736 L13.0193,38.7746 C13.0193,39.3266 13.4663,39.7746 14.0193,39.7746 L33.1763,39.7826 C33.7283,39.7826 34.1763,39.3346 34.1763,38.7826 L34.1833,23.0806 C34.1833,22.8166 34.0773,22.5616 33.8903,22.3736 C33.7023,22.1866 33.4483,22.0806 33.1833,22.0806 L33.1833,22.0806 Z M39.1643,43.3116 C39.1643,43.6316 38.9043,43.8916 38.5853,43.8916 L8.5803,43.8916 C8.2603,43.8916 8.0003,43.6316 8.0003,43.3116 L8.0003,4.5796 C8.0003,4.2596 8.2603,3.9996 8.5803,3.9996 L29.5643,3.9996 L29.5643,12.6006 C29.5643,13.1536 30.0123,13.6006 30.5643,13.6006 L39.1643,13.6006 L39.1643,25.1776 L39.1643,43.3116 Z M31.5643,5.4136 L37.7503,11.6006 L31.5643,11.6006 L31.5643,5.4136 Z M30.9793,1.9996 L8.5803,1.9996 C7.1573,1.9996 6.0003,3.1576 6.0003,4.5796 L6.0003,43.3116 C6.0003,44.7346 7.1573,45.8916 8.5803,45.8916 L38.5853,45.8916 C40.0073,45.8916 41.1643,44.7346 41.1643,43.3116 L41.1643,25.1776 L41.1643,13.1796 L41.1643,12.1866 L30.9793,1.9996 Z" id="AWS-Identity-and-Access-Management_Encrypted-data_-Resource-Icon_light-bg" fill="#DD344C"></path>
    </g>
</svg>`, Ev = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Security-Identity-and-Compliance/Res_AWS-Identity-Access-Management_MFA-Token_48</title>
    <g id="Icon-Resource/Security-Identity-and-Compliance/Res_AWS-Identity-Access-Management_MFA-Token_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M32.6258,24.794 L34.3778,19.673 L36.1458,24.794 L32.6258,24.794 Z M35.4808,17.913 L33.3698,17.913 L29.3128,29.001 L31.2658,29.001 L32.1608,26.218 L36.5938,26.218 L37.5218,29.001 L39.4748,29.001 L35.4808,17.913 Z M24.8648,22.682 L28.7858,22.682 L28.7858,24.249 L24.8648,24.249 L24.8648,29.001 L22.9128,29.001 L22.9128,17.913 L29.6488,17.913 L29.6488,19.481 L24.8648,19.481 L24.8648,22.682 Z M18.2078,17.913 L20.3208,17.913 L20.3208,29.001 L18.5288,29.001 L18.5288,20.696 L15.6488,26.218 L13.8898,26.218 L11.1048,20.729 L11.1048,29.001 L9.3128,29.001 L9.3128,17.913 L11.4888,17.913 L14.8158,24.521 L18.2078,17.913 Z M24.0008,44.002 C12.9728,44.002 3.9998,35.029 3.9998,24.001 C3.9998,12.973 12.9728,4 24.0008,4 C35.0298,4 44.0028,12.973 44.0028,24.001 C44.0028,35.029 35.0298,44.002 24.0008,44.002 L24.0008,44.002 Z M24.0008,2 C11.8688,2 1.9998,11.869 1.9998,24.001 C1.9998,36.133 11.8688,46.002 24.0008,46.002 C36.1328,46.002 46.0028,36.133 46.0028,24.001 C46.0028,11.869 36.1328,2 24.0008,2 L24.0008,2 Z" id="AWS-Identity-and-Access-Management_MFA-token_Resource-Icon_light-bg" fill="#DD344C"></path>
    </g>
</svg>`, Iv = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Security-Identity-and-Compliance/Res_AWS-Directory-Service_AD-Connector_48</title>
    <g id="Icon-Resource/Security-Identity-and-Compliance/Res_AWS-Directory-Service_AD-Connector_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M33.2208,33.0176 C33.2208,34.3736 34.0988,35.5296 35.3158,35.9456 L35.3158,30.0886 C34.0988,30.5046 33.2208,31.6616 33.2208,33.0176 M31.3028,33.8336 L4.1178,33.8336 C3.3538,33.8336 2.6688,33.4386 2.2858,32.7766 C1.9048,32.1146 1.9058,31.3236 2.2878,30.6616 L17.0698,5.0576 C17.4518,4.3956 18.1368,3.9996 18.9018,3.9996 L18.9028,3.9996 C19.6658,4.0006 20.3508,4.3966 20.7328,5.0576 L29.7528,20.6806 C30.0298,21.1596 29.8658,21.7706 29.3868,22.0466 C28.9088,22.3226 28.2968,22.1596 28.0208,21.6806 L18.9998,6.0576 C18.9918,6.0416 18.9668,5.9996 18.9018,5.9996 C18.8348,5.9996 18.8108,6.0416 18.8008,6.0586 L4.0198,31.6626 C4.0098,31.6786 3.9868,31.7196 4.0188,31.7766 C4.0518,31.8336 4.0998,31.8336 4.1178,31.8336 L31.3728,31.8336 C31.9098,29.5956 33.9148,27.9226 36.3158,27.9226 C36.8678,27.9226 37.3158,28.3706 37.3158,28.9226 L37.3158,29.7086 L40.3778,29.7086 C40.9308,29.7086 41.3778,30.1566 41.3778,30.7086 C41.3778,31.2616 40.9308,31.7086 40.3778,31.7086 L37.3158,31.7086 L37.3158,34.3256 L40.3778,34.3256 C40.9308,34.3256 41.3778,34.7726 41.3778,35.3256 C41.3778,35.8776 40.9308,36.3256 40.3778,36.3256 L37.3158,36.3256 L37.3158,37.1116 C37.3158,37.6636 36.8678,38.1116 36.3158,38.1116 C33.7848,38.1116 31.6978,36.2536 31.3028,33.8336 M45.9418,33.0176 C45.9418,39.3946 40.7528,44.5826 34.3748,44.5826 C29.4178,44.5826 25.0168,41.4316 23.4218,36.7426 C23.2438,36.2186 23.5248,35.6506 24.0468,35.4726 C24.5768,35.2966 25.1388,35.5756 25.3168,36.0976 C26.6348,39.9766 30.2748,42.5826 34.3748,42.5826 C39.6508,42.5826 43.9418,38.2916 43.9418,33.0176 C43.9418,27.7426 39.6508,23.4516 34.3748,23.4516 C30.3648,23.4516 26.7498,25.9826 25.3808,29.7496 C25.1928,30.2686 24.6208,30.5386 24.0998,30.3476 C23.5808,30.1596 23.3128,29.5856 23.5018,29.0666 C25.1568,24.5116 29.5268,21.4516 34.3748,21.4516 C40.7528,21.4516 45.9418,26.6396 45.9418,33.0176" id="AWS-Directory-Service_AD-Connector_Resource-Icon_light-bg" fill="#DD344C"></path>
    </g>
</svg>`, Fv = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Security-Identity-and-Compliance/Res_AWS-Identity-Access-Management_Permissions_48</title>
    <g id="Icon-Resource/Security-Identity-and-Compliance/Res_AWS-Identity-Access-Management_Permissions_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M20.2899,18.04 L21.7039,19.454 L14.7059,26.452 C14.5109,26.647 14.2549,26.745 13.9989,26.745 C13.7429,26.745 13.4869,26.647 13.2919,26.452 L9.7919,22.953 L11.2059,21.539 L13.9989,24.331 L20.2899,18.04 Z M20.2899,6.667 L21.7039,8.081 L14.7059,15.079 C14.5109,15.274 14.2549,15.372 13.9989,15.372 C13.7429,15.372 13.4869,15.274 13.2919,15.079 L9.7919,11.58 L11.2059,10.166 L13.9989,12.958 L20.2899,6.667 Z M19.9549,32.576 L16.7259,35.806 L19.9549,39.035 L18.5409,40.449 L15.3109,37.22 L12.0809,40.449 L10.6669,39.035 L13.8969,35.806 L10.6669,32.576 L12.0809,31.162 L15.3109,34.392 L18.5409,31.162 L19.9549,32.576 Z M39.2429,43.186 C39.2429,43.63 38.8819,43.991 38.4379,43.991 L8.8059,43.991 C8.3609,43.991 7.9999,43.63 7.9999,43.186 L7.9999,4.806 C7.9999,4.361 8.3609,4 8.8059,4 L38.4379,4 C38.8819,4 39.2429,4.361 39.2429,4.806 L39.2429,43.186 Z M38.4379,2 L8.8059,2 C7.2589,2 5.9999,3.259 5.9999,4.806 L5.9999,43.186 C5.9999,44.732 7.2589,45.991 8.8059,45.991 L38.4379,45.991 C39.9849,45.991 41.2429,44.732 41.2429,43.186 L41.2429,4.806 C41.2429,3.259 39.9849,2 38.4379,2 L38.4379,2 Z" id="AWS-Identity-and-Access-Management_Permissions_Resource-Icon_light-bg" fill="#DD344C"></path>
    </g>
</svg>`, Ov = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Security-Identity-and-Compliance/Res_AWS-WAF_Labels_48</title>
    <g id="Icon-Resource/Security-Identity-and-Compliance/Res_AWS-WAF_Labels_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M13,33.009 L41,33.009 L41,31.009 L13,31.009 L13,33.009 Z M13,25.009 L46,25.009 L46,23.009 L13,23.009 L13,25.009 Z M19,11.009 C19,12.112 18.103,13.009 17,13.009 C15.897,13.009 15,12.112 15,11.009 C15,9.906 15.897,9.009 17,9.009 C18.103,9.009 19,9.906 19,11.009 L19,11.009 Z M21,11.009 C21,8.803 19.206,7.009 17,7.009 C14.794,7.009 13,8.803 13,11.009 C13,13.215 14.794,15.009 17,15.009 C19.206,15.009 21,13.215 21,11.009 L21,11.009 Z M32,46.009 L2,46.009 L2,12.487 L11.068,2.009 L22.923,2 L32,12.487 L32,20.009 L30,20.009 L30,13.232 L22.009,4.001 L11.982,4.009 L4,13.232 L4,44.009 L30,44.009 L30,37.009 L32,37.009 L32,46.009 Z" id="Fill-1" fill="#DD344C"></path>
    </g>
</svg>`, Nv = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Security-Identity-and-Compliance/Res_AWS-Certificate-Manager_Certificate-Authority_48</title>
    <g id="Icon-Resource/Security-Identity-and-Compliance/Res_AWS-Certificate-Manager_Certificate-Authority_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M29.0706,20.5469 L23.2436,26.6649 C23.0536,26.8629 22.7926,26.9759 22.5186,26.9759 C22.2456,26.9759 21.9836,26.8629 21.7956,26.6649 L18.8816,23.6069 L20.3296,22.2279 L22.5186,24.5259 L27.6226,19.1679 L29.0706,20.5469 Z M20.6056,32.0939 L20.6056,37.8489 L23.3426,35.6099 C23.7106,35.3089 24.2416,35.3089 24.6086,35.6099 L27.3456,37.8489 L27.3456,32.0939 L29.3456,32.0939 L29.3456,39.9589 C29.3456,40.3459 29.1236,40.6969 28.7746,40.8619 C28.6376,40.9279 28.4916,40.9589 28.3456,40.9589 C28.1196,40.9589 27.8946,40.8819 27.7136,40.7339 L23.9756,37.6759 L20.2386,40.7339 C19.9396,40.9769 19.5266,41.0289 19.1766,40.8619 C18.8286,40.6969 18.6056,40.3459 18.6056,39.9589 L18.6056,32.0939 L20.6056,32.0939 Z M23.9756,29.3459 C20.1896,29.3459 17.1096,26.2659 17.1096,22.4799 C17.1096,18.6939 20.1896,15.6139 23.9756,15.6139 C27.7606,15.6139 30.8416,18.6939 30.8416,22.4799 C30.8416,26.2659 27.7606,29.3459 23.9756,29.3459 L23.9756,29.3459 Z M32.8416,22.4799 C32.8416,17.5909 28.8646,13.6139 23.9756,13.6139 C19.0876,13.6139 15.1096,17.5909 15.1096,22.4799 C15.1096,27.3679 19.0876,31.3459 23.9756,31.3459 C28.8646,31.3459 32.8416,27.3679 32.8416,22.4799 L32.8416,22.4799 Z M4.0006,9.2439 L43.9016,9.2439 L43.9016,5.9999 L4.0006,5.9999 L4.0006,9.2439 Z M45.9016,10.2419 L45.9016,4.9999 C45.9016,4.4469 45.4546,3.9999 44.9016,3.9999 L3.0006,3.9999 C2.4476,3.9999 2.0006,4.4469 2.0006,4.9999 L2.0006,10.2439 L2.0006,43.4549 C2.0006,44.0079 2.4476,44.4549 3.0006,44.4549 L31.8416,44.4549 L31.8416,42.4549 L4.0006,42.4549 L4.0006,11.2439 L43.9036,11.2439 L43.9496,42.4549 L40.5816,42.4549 L40.5816,44.4549 L44.9516,44.4549 C45.2166,44.4549 45.4716,44.3499 45.6596,44.1619 C45.8466,43.9739 45.9516,43.7189 45.9516,43.4529 L45.9016,10.2419 Z" id="AWS-Certificate-Manager_Certificate-authority_Resource-Icon_light-bg" fill="#DD344C"></path>
    </g>
</svg>`, Dv = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Security-Identity-and-Compliance/Res_AWS-Identity-Access-Management_AWS-STS-Alternate_48</title>
    <g id="Icon-Resource/Security-Identity-and-Compliance/Res_AWS-Identity-Access-Management_AWS-STS-Alternate_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M24.5823,17.0908 L18.3463,17.0908 L18.3463,15.0908 L22.5823,15.0908 L22.5823,9.1098 L24.5823,9.1098 L24.5823,17.0908 Z M23.5823,7.4908 C27.8433,7.4908 31.3103,10.9568 31.3103,15.2178 C31.3103,19.4788 27.8433,22.9448 23.5823,22.9448 C19.3213,22.9448 15.8553,19.4788 15.8553,15.2178 C15.8553,10.9568 19.3213,7.4908 23.5823,7.4908 L23.5823,7.4908 Z M23.5823,24.9448 C28.9463,24.9448 33.3103,20.5818 33.3103,15.2178 C33.3103,9.8548 28.9463,5.4908 23.5823,5.4908 C18.2193,5.4908 13.8553,9.8548 13.8553,15.2178 C13.8553,20.5818 18.2193,24.9448 23.5823,24.9448 L23.5823,24.9448 Z M33.8433,36.8308 C34.1323,37.1778 34.2763,37.6238 34.2763,38.1688 C34.2763,38.9508 33.9973,39.5738 33.4393,40.0378 C32.8813,40.5028 32.1303,40.7348 31.1853,40.7348 C30.2483,40.7348 29.4343,40.5688 28.7413,40.2338 L28.7413,39.2568 C29.5973,39.5418 30.4033,39.6848 31.1613,39.6848 C31.7393,39.6848 32.1933,39.5588 32.5223,39.3058 C32.8533,39.0528 33.0183,38.7108 33.0183,38.2788 C33.0183,37.9788 32.9223,37.7278 32.7313,37.5278 C32.5393,37.3278 32.2163,37.1388 31.7593,36.9598 L30.5743,36.5068 C29.9063,36.2558 29.4213,35.9498 29.1203,35.5908 C28.8183,35.2328 28.6683,34.7808 28.6683,34.2348 C28.6683,33.7788 28.7823,33.3738 29.0103,33.0188 C29.2383,32.6638 29.5663,32.3868 29.9943,32.1818 C30.4213,31.9798 30.9253,31.8758 31.5033,31.8758 C32.2353,31.8758 32.9893,32.0238 33.7633,32.3168 L33.7633,33.3068 C32.9403,33.0538 32.2163,32.9268 31.5883,32.9268 C31.0593,32.9268 30.6493,33.0348 30.3603,33.2508 C30.0713,33.4668 29.9273,33.7748 29.9273,34.1738 C29.9273,34.4998 30.0243,34.7578 30.2203,34.9498 C30.4163,35.1408 30.7773,35.3348 31.3083,35.5298 L32.4193,35.9448 C33.0793,36.1908 33.5533,36.4858 33.8433,36.8308 L33.8433,36.8308 Z M21.1293,32.0598 L27.7763,32.0598 L27.7763,33.0858 L25.0753,33.0858 L25.0753,40.5278 L23.8303,40.5278 L23.8303,33.0858 L21.1293,33.0858 L21.1293,32.0598 Z M19.8653,36.8308 C20.1543,37.1778 20.2993,37.6238 20.2993,38.1688 C20.2993,38.9508 20.0203,39.5738 19.4623,40.0378 C18.9033,40.5028 18.1523,40.7348 17.2073,40.7348 C16.2703,40.7348 15.4563,40.5688 14.7643,40.2338 L14.7643,39.2568 C15.6193,39.5418 16.4263,39.6848 17.1843,39.6848 C17.7623,39.6848 18.2163,39.5588 18.5453,39.3058 C18.8753,39.0528 19.0403,38.7108 19.0403,38.2788 C19.0403,37.9788 18.9443,37.7278 18.7543,37.5278 C18.5613,37.3278 18.2383,37.1388 17.7823,36.9598 L16.5973,36.5068 C15.9293,36.2558 15.4433,35.9498 15.1433,35.5908 C14.8413,35.2328 14.6903,34.7808 14.6903,34.2348 C14.6903,33.7788 14.8053,33.3738 15.0323,33.0188 C15.2613,32.6638 15.5893,32.3868 16.0173,32.1818 C16.4433,31.9798 16.9473,31.8758 17.5253,31.8758 C18.2583,31.8758 19.0123,32.0238 19.7853,32.3168 L19.7853,33.3068 C18.9633,33.0538 18.2383,32.9268 17.6103,32.9268 C17.0813,32.9268 16.6723,33.0348 16.3833,33.2508 C16.0943,33.4668 15.9493,33.7748 15.9493,34.1738 C15.9493,34.4998 16.0473,34.7578 16.2423,34.9498 C16.4383,35.1408 16.8003,35.3348 17.3303,35.5298 L18.4413,35.9448 C19.1023,36.1908 19.5753,36.4858 19.8653,36.8308 L19.8653,36.8308 Z M39.1643,43.0858 C39.1643,43.5298 38.8033,43.8918 38.3593,43.8918 L8.8063,43.8918 C8.3613,43.8918 8.0003,43.5298 8.0003,43.0858 L8.0003,4.8058 C8.0003,4.3618 8.3613,3.9998 8.8063,3.9998 L38.3593,3.9998 C38.8033,3.9998 39.1643,4.3618 39.1643,4.8058 L39.1643,43.0858 Z M38.3593,1.9998 L8.8063,1.9998 C7.2593,1.9998 6.0003,3.2588 6.0003,4.8058 L6.0003,43.0858 C6.0003,44.6328 7.2593,45.8918 8.8063,45.8918 L38.3593,45.8918 C39.9063,45.8918 41.1643,44.6328 41.1643,43.0858 L41.1643,4.8058 C41.1643,3.2588 39.9063,1.9998 38.3593,1.9998 L38.3593,1.9998 Z" id="AWS-Identity-and-Access-Management_AWS-STS-alternate_-Resource-Icon_light-bg" fill="#DD344C"></path>
    </g>
</svg>`, Pv = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Security-Identity-and-Compliance/Res_AWS-Directory-Service_AWS-Managed-Microsoft-AD_48</title>
    <g id="Icon-Resource/Security-Identity-and-Compliance/Res_AWS-Directory-Service_AWS-Managed-Microsoft-AD_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M40.9858,34.4859 L40.2448,34.2129 C39.8898,34.0829 39.6428,33.9529 39.5038,33.8229 C39.3648,33.6929 39.2948,33.5279 39.2948,33.3279 C39.2948,32.8029 39.6798,32.5409 40.4518,32.5409 C40.9158,32.5409 41.4288,32.6299 41.9918,32.8059 L41.9918,31.9479 C41.4318,31.7359 40.8808,31.6309 40.3378,31.6309 C39.6838,31.6309 39.1638,31.7909 38.7768,32.1119 C38.3908,32.4329 38.1978,32.8679 38.1978,33.4159 C38.1978,33.8119 38.3078,34.1399 38.5298,34.4019 C38.7498,34.6649 39.1048,34.8899 39.5918,35.0789 L40.3688,35.3799 C40.7058,35.5089 40.9418,35.6389 41.0758,35.7679 C41.2088,35.8979 41.2758,36.0629 41.2758,36.2629 C41.2758,36.5469 41.1658,36.7629 40.9438,36.9139 C40.7238,37.0639 40.4068,37.1389 39.9938,37.1389 C39.7448,37.1389 39.4638,37.1119 39.1528,37.0599 C38.8418,37.0069 38.5448,36.9329 38.2598,36.8389 L38.2598,37.6959 C38.4958,37.8079 38.7688,37.8959 39.0828,37.9569 C39.3948,38.0189 39.7078,38.0499 40.0198,38.0499 C40.7508,38.0499 41.3258,37.8809 41.7438,37.5419 C42.1628,37.2029 42.3718,36.7359 42.3718,36.1399 C42.3718,35.7389 42.2628,35.4099 42.0458,35.1489 C41.8268,34.8899 41.4738,34.6699 40.9858,34.4859 L40.9858,34.4859 Z M33.9618,35.4239 L32.1228,31.7709 L30.9208,31.7709 L30.9208,37.8999 L31.9108,37.8999 L31.9108,33.3279 L33.4488,36.3609 L34.4228,36.3609 L36.0138,33.3099 L36.0138,37.8999 L37.0048,37.8999 L37.0048,31.7709 L35.8368,31.7709 L33.9618,35.4239 Z M43.9648,41.2999 L43.9638,26.3419 C42.1148,27.2519 39.2468,27.6799 36.5048,27.6799 C33.7628,27.6799 30.8948,27.2519 29.0468,26.3419 L29.0468,41.3109 C29.1678,41.7959 31.6458,43.0969 36.5048,43.0969 C41.3628,43.0969 43.8418,41.7959 43.9648,41.2999 L43.9648,41.2999 Z M29.0468,23.8949 C29.1688,24.3789 31.6478,25.6799 36.5048,25.6799 C41.3478,25.6799 43.8278,24.3849 43.9638,23.8879 L43.9638,23.7999 C43.8408,23.3169 41.3608,22.0149 36.5048,22.0149 C31.6608,22.0149 29.1808,23.3099 29.0468,23.8069 L29.0468,23.8949 Z M45.9638,23.7979 L45.9638,23.7999 L45.9638,41.3109 C45.9638,43.9129 41.0598,45.0969 36.5048,45.0969 C31.9488,45.0969 27.0468,43.9129 27.0468,41.3109 L27.0468,23.7999 L27.0468,23.7979 C27.0478,21.1989 31.9508,20.0149 36.5048,20.0149 C41.0588,20.0149 45.9618,21.1989 45.9638,23.7979 L45.9638,23.7979 Z M26.1388,35.2769 C26.1388,35.8299 25.6918,36.2769 25.1388,36.2769 L3.0008,36.2769 C2.6428,36.2769 2.3128,36.0869 2.1338,35.7769 C1.9558,35.4669 1.9558,35.0869 2.1338,34.7769 L20.7898,2.4649 C21.1468,1.8449 22.1648,1.8449 22.5218,2.4649 L31.4108,17.8599 C31.6868,18.3389 31.5228,18.9499 31.0448,19.2259 C30.5658,19.5019 29.9548,19.3389 29.6778,18.8599 L21.6558,4.9649 L4.7328,34.2769 L25.1388,34.2769 C25.6918,34.2769 26.1388,34.7239 26.1388,35.2769 L26.1388,35.2769 Z" id="AWS-Directory-Service_AWS-Managed-Microsoft-AD_Resource-Icon_light-bg" fill="#DD344C"></path>
    </g>
</svg>`, Bv = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Security-Identity-and-Compliance/Res_AWS-Security-Hub_Finding_48</title>
    <g id="Icon-Resource/Security-Identity-and-Compliance/Res_AWS-Security-Hub_Finding_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M20.3008,37.6528 L20.3008,9.8528 L11.4338,13.0198 L11.4338,29.3918 C11.4338,30.7008 13.0198,37.1028 20.3008,37.6528 L20.3008,37.6528 Z M31.1668,24.7308 L31.1668,13.0198 L22.3008,9.8528 L22.3008,37.7048 L23.6148,37.7028 L23.6148,39.7028 L21.3008,39.7068 C12.2458,39.7068 9.4338,32.1458 9.4338,29.3918 L9.4338,12.3148 C9.4338,11.8918 9.6988,11.5148 10.0978,11.3738 L20.9648,7.4928 C21.1818,7.4148 21.4198,7.4148 21.6368,7.4928 L32.5028,11.3738 C32.9018,11.5148 33.1668,11.8918 33.1668,12.3148 L33.1668,24.7308 L31.1668,24.7308 Z M21.3008,43.1398 C6.1738,43.1398 5.9998,28.4648 5.9998,27.8398 L5.9998,9.8998 L21.3008,4.0708 L36.6008,9.8998 L36.6008,23.1778 L38.6008,23.1778 L38.6008,9.2108 C38.6008,8.7958 38.3448,8.4238 37.9568,8.2758 L21.6568,2.0658 C21.4268,1.9778 21.1748,1.9778 20.9448,2.0658 L4.6438,8.2758 C4.2558,8.4238 3.9998,8.7958 3.9998,9.2108 L3.9998,27.8398 C3.9998,33.8238 7.6158,45.1398 21.3008,45.1398 C22.6788,45.1398 24.0008,45.0358 25.2308,44.8298 L24.9008,42.8568 C23.7798,43.0448 22.5688,43.1398 21.3008,43.1398 L21.3008,43.1398 Z M42.8538,35.6318 C42.8538,31.0288 39.1088,27.2838 34.5058,27.2838 C29.9028,27.2838 26.1568,31.0288 26.1568,35.6318 C26.1568,40.1978 29.8918,43.9128 34.4818,43.9128 C39.0978,43.9128 42.8538,40.1978 42.8538,35.6318 L42.8538,35.6318 Z M44.8538,35.6318 C44.8538,41.2998 40.1998,45.9128 34.4818,45.9128 C28.7888,45.9128 24.1568,41.2998 24.1568,35.6318 C24.1568,29.9248 28.7998,25.2838 34.5058,25.2838 C40.2118,25.2838 44.8538,29.9248 44.8538,35.6318 L44.8538,35.6318 Z M33.4818,41.8068 L35.4818,41.8068 L35.4818,40.2548 L33.4818,40.2548 L33.4818,41.8068 Z M33.5058,38.6248 L35.5058,38.6248 L35.5058,30.1648 L33.5058,30.1648 L33.5058,38.6248 Z" id="AWS-Security-Hub_Finding_Resource-Icon_light-bg" fill="#DD344C"></path>
    </g>
</svg>`, zv = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Security-Identity-and-Compliance/Res_AWS-WAF_Rule_48</title>
    <g id="Icon-Resource/Security-Identity-and-Compliance/Res_AWS-WAF_Rule_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M2,2 L2,16 L2,17 L2,30 L2,31 L2,46 L46,46 L46,2 L2,2 Z M4,16.001 L44.001,16.001 L44.001,4 L4,4 L4,16.001 Z M4,30 L44.001,30 L44.001,18 L4,18 L4,30 Z M4,44.001 L44.001,44.001 L44.001,32 L4,32 L4,44.001 Z M35.151,11.008 L32.578,9.184 L31.422,10.816 L35.371,13.617 L40.707,8.28 L39.293,6.866 L35.151,11.008 Z M35.151,25.008 L32.578,23.184 L31.422,24.816 L35.371,27.617 L40.707,22.281 L39.293,20.867 L35.151,25.008 Z M36,36.646 L33.647,34.293 L32.233,35.707 L34.586,38.06 L32.233,40.414 L33.647,41.829 L36,39.475 L38.354,41.829 L39.768,40.414 L37.414,38.06 L39.768,35.707 L38.354,34.293 L36,36.646 Z" id="Fill-1" fill="#DD344C"></path>
    </g>
</svg>`, Uv = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Security-Identity-and-Compliance/Res_AWS-Identity-Access-Management_Role_48</title>
    <g id="Icon-Resource/Security-Identity-and-Compliance/Res_AWS-Identity-Access-Management_Role_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M44.0827,32.581 C43.9267,32.592 43.7697,32.604 43.6207,32.619 C43.0987,32.662 42.5527,32.714 42.0007,32.772 L41.8327,32.79 C40.0677,32.972 38.0697,33.177 37.1187,33.047 C36.5247,32.962 35.4307,32.487 34.2707,31.984 C32.3047,31.132 29.8567,30.07 27.6437,29.9 C24.5977,29.666 19.3347,30.24 15.9407,31.831 C13.9787,31.743 12.1587,31.215 10.7447,30.343 C10.7387,30.071 10.7327,29.799 10.7327,29.694 C10.7327,25.558 12.6707,21.679 16.0527,19.044 C18.3497,17.701 20.9967,16.992 23.7127,16.992 C29.8337,16.992 35.2657,20.609 37.3847,25.934 L36.5717,25.934 C35.7577,25.934 35.0757,26.51 34.9087,27.274 C34.7707,27.222 34.6447,27.175 34.4967,27.118 C32.4677,26.335 29.6837,25.264 26.4657,25.455 C21.7607,25.731 19.4457,26.015 17.6227,26.535 L18.1717,28.459 C19.8397,27.982 22.0397,27.719 26.5827,27.451 C29.3667,27.293 31.9197,28.269 33.7767,28.984 C34.1717,29.137 34.5287,29.27 34.8677,29.391 L34.8677,29.596 C34.8677,30.535 35.6327,31.3 36.5717,31.3 L40.2187,31.3 C41.1557,31.3 41.9197,30.538 41.9227,29.602 L42.2767,29.57 C42.8697,29.517 43.4147,29.464 43.8717,29.419 L44.0827,29.398 L44.0827,32.581 Z M9.7987,34.249 C7.1487,34.612 5.0567,34.288 4.1907,33.753 C4.7157,33.382 5.9007,32.863 6.7347,32.499 C7.4567,32.184 8.1877,31.851 8.8947,31.495 C10.0487,32.374 11.4777,33.033 13.0597,33.426 C12.1447,33.794 11.0117,34.084 9.7987,34.249 L9.7987,34.249 Z M36.8677,29.3 L39.9227,29.3 L39.9227,27.934 L36.8677,27.934 L36.8677,29.3 Z M26.5857,13 C34.9537,13 41.9817,19.295 43.0167,27.492 C42.7287,27.52 42.4247,27.549 42.1037,27.578 L41.9187,27.594 C41.8947,26.676 41.1437,25.934 40.2187,25.934 L39.5077,25.934 C37.3067,19.457 30.9317,14.992 23.7127,14.992 C21.0387,14.992 18.4227,15.604 16.0717,16.767 C16.0887,16.753 16.1027,16.738 16.1177,16.725 C19.0587,14.323 22.7757,13 26.5857,13 L26.5857,13 Z M45.5267,27.794 C45.3817,27.663 45.2107,27.568 45.0287,27.496 C43.9827,18.185 36.0497,11 26.5857,11 C22.3167,11 18.1497,12.483 14.8537,15.175 C10.5007,18.719 8.0047,23.97 8.0047,29.581 C8.0047,29.622 8.0077,29.663 8.0077,29.704 C7.3407,30.039 6.6357,30.359 5.9347,30.666 C3.7987,31.6 2.2557,32.274 2.0257,33.492 C1.9677,33.801 1.9577,34.406 2.5457,34.994 C3.5827,36.031 5.5727,36.403 7.5947,36.403 C8.4367,36.403 9.2827,36.339 10.0687,36.231 C11.4077,36.049 13.9077,35.558 15.6047,34.316 C18.2827,32.375 24.3377,31.649 27.4907,31.894 C29.3697,32.039 31.6457,33.026 33.4757,33.819 C34.8717,34.426 35.9757,34.904 36.8417,35.027 C38.0327,35.19 39.9777,34.99 42.0367,34.779 L42.2097,34.762 C42.7477,34.704 43.2777,34.654 43.8017,34.611 C44.0167,34.59 44.2297,34.575 44.5137,34.555 C45.3937,34.493 46.0827,33.755 46.0827,32.875 L46.0827,29.046 C46.0827,28.568 45.8807,28.112 45.5267,27.794 L45.5267,27.794 Z" id="AWS-Identity-and-Access-Management_Role_Resource-Icon_light-bg" fill="#DD344C"></path>
    </g>
</svg>`, Wv = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Security-Identity-and-Compliance/Res_AWS-Identity-Access-Management_Long-Term-Security-Credential_48</title>
    <g id="Icon-Resource/Security-Identity-and-Compliance/Res_AWS-Identity-Access-Management_Long-Term-Security-Credential_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M43.9593,37.7715 L45.9593,37.7715 L45.9593,42.1415 C45.9593,42.6945 45.5123,43.1415 44.9593,43.1415 L3.0003,43.1415 C2.4473,43.1415 2.0003,42.6945 2.0003,42.1415 L2.0003,37.7715 L4.0003,37.7715 L4.0003,41.1415 L43.9593,41.1415 L43.9593,37.7715 Z M39.3383,11.6215 C40.1433,11.6215 40.7973,12.2765 40.7973,13.0815 C40.7973,13.8855 40.1433,14.5405 39.3383,14.5405 C38.5333,14.5405 37.8783,13.8855 37.8783,13.0815 C37.8783,12.2765 38.5333,11.6215 39.3383,11.6215 L39.3383,11.6215 Z M39.3383,16.5405 C41.2453,16.5405 42.7973,14.9885 42.7973,13.0815 C42.7973,11.1725 41.2453,9.6215 39.3383,9.6215 C37.4303,9.6215 35.8783,11.1725 35.8783,13.0815 C35.8783,14.9885 37.4303,16.5405 39.3383,16.5405 L39.3383,16.5405 Z M14.5003,11.6215 L29.1843,11.6215 C29.6193,11.6215 30.0053,11.3385 30.1373,10.9225 C31.0703,7.9785 33.7793,6.0005 36.8783,6.0005 C40.7823,6.0005 43.9593,9.1765 43.9593,13.0815 C43.9593,16.9855 40.7823,20.1625 36.8783,20.1625 C33.7793,20.1625 31.0703,18.1835 30.1373,15.2385 C30.0053,14.8225 29.6193,14.5405 29.1843,14.5405 L26.6883,14.5405 C26.4233,14.5405 26.1693,14.6455 25.9813,14.8335 L24.5803,16.2345 L23.1803,14.8335 C22.9923,14.6455 22.7383,14.5405 22.4733,14.5405 L21.0663,14.5405 C20.8013,14.5405 20.5473,14.6455 20.3593,14.8335 L18.9593,16.2345 L17.5583,14.8335 C17.3703,14.6455 17.1163,14.5405 16.8513,14.5405 L15.1183,14.5405 L13.3353,12.9805 L14.5003,11.6215 Z M14.0843,16.2925 C14.2663,16.4525 14.5003,16.5405 14.7423,16.5405 L16.4373,16.5405 L18.2523,18.3555 C18.6273,18.7305 19.2913,18.7305 19.6663,18.3555 L21.4803,16.5405 L22.0593,16.5405 L23.8733,18.3555 C24.0613,18.5425 24.3143,18.6485 24.5803,18.6485 C24.8463,18.6485 25.1003,18.5425 25.2873,18.3555 L27.1033,16.5405 L28.4823,16.5405 C29.8673,19.9315 33.1533,22.1625 36.8783,22.1625 C41.8853,22.1625 45.9593,18.0875 45.9593,13.0815 C45.9593,8.0745 41.8853,4.0005 36.8783,4.0005 C33.1533,4.0005 29.8673,6.2305 28.4823,9.6215 L14.0403,9.6215 C13.7483,9.6215 13.4713,9.7495 13.2813,9.9705 L11.1723,12.4305 C10.8153,12.8465 10.8603,13.4725 11.2733,13.8345 L14.0843,16.2925 Z M8.6223,27.7845 C9.4273,27.7845 10.0813,28.4385 10.0813,29.2435 C10.0813,30.0475 9.4273,30.7035 8.6223,30.7035 C7.8173,30.7035 7.1623,30.0475 7.1623,29.2435 C7.1623,28.4385 7.8173,27.7845 8.6223,27.7845 L8.6223,27.7845 Z M8.6223,32.7035 C10.5293,32.7035 12.0813,31.1515 12.0813,29.2435 C12.0813,27.3355 10.5293,25.7845 8.6223,25.7845 C6.7143,25.7845 5.1623,27.3355 5.1623,29.2435 C5.1623,31.1515 6.7143,32.7035 8.6223,32.7035 L8.6223,32.7035 Z M11.0813,22.1625 C14.1813,22.1625 16.8903,24.1405 17.8233,27.0855 C17.9553,27.5015 18.3413,27.7845 18.7763,27.7845 L21.2713,27.7845 C21.5363,27.7845 21.7903,27.6785 21.9783,27.4915 L23.3793,26.0895 L24.7803,27.4915 C24.9683,27.6785 25.2223,27.7845 25.4873,27.7845 L26.8933,27.7845 C27.1583,27.7845 27.4123,27.6785 27.6003,27.4915 L29.0013,26.0895 L30.4013,27.4915 C30.5893,27.6785 30.8433,27.7845 31.1083,27.7845 L32.8413,27.7845 L34.6243,29.3435 L33.4603,30.7035 L18.7763,30.7035 C18.3413,30.7035 17.9553,30.9855 17.8233,31.4015 C16.8903,34.3465 14.1813,36.3255 11.0813,36.3255 C7.1773,36.3255 4.0003,33.1485 4.0003,29.2435 C4.0003,25.3385 7.1773,22.1625 11.0813,22.1625 L11.0813,22.1625 Z M11.0813,38.3255 C14.8073,38.3255 18.0933,36.0945 19.4783,32.7035 L33.9203,32.7035 C34.2123,32.7035 34.4893,32.5755 34.6803,32.3535 L36.7873,29.8935 C37.1443,29.4775 37.0993,28.8515 36.6863,28.4905 L33.8753,26.0315 C33.6933,25.8725 33.4593,25.7845 33.2173,25.7845 L31.5223,25.7845 L29.7083,23.9685 C29.5213,23.7815 29.2673,23.6755 29.0013,23.6755 C28.7353,23.6755 28.4813,23.7815 28.2943,23.9685 L26.4793,25.7845 L25.9013,25.7845 L24.0863,23.9685 C23.6953,23.5785 23.0633,23.5785 22.6723,23.9685 L20.8563,25.7845 L19.4783,25.7845 C18.0933,22.3925 14.8073,20.1625 11.0813,20.1625 C6.0743,20.1625 2.0003,24.2365 2.0003,29.2435 C2.0003,34.2505 6.0743,38.3255 11.0813,38.3255 L11.0813,38.3255 Z" id="AWS-Identity-and-Access-Management_Long-term-security-credential_Resource-Icon_light-bg" fill="#DD344C"></path>
    </g>
</svg>`, Hv = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Security-Identity-and-Compliance/Res_AWS-Identity-Access-Management_Temporary-Security-Credential_48</title>
    <g id="Icon-Resource/Security-Identity-and-Compliance/Res_AWS-Identity-Access-Management_Temporary-Security-Credential_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M35.201,29.6397 L37.201,29.6397 L37.201,37.6297 L30.959,37.6297 L30.959,35.6297 L35.201,35.6297 L35.201,29.6397 Z M36.201,43.4937 C31.934,43.4937 28.464,40.0227 28.464,35.7557 C28.464,31.4897 31.934,28.0187 36.201,28.0187 C40.468,28.0187 43.938,31.4897 43.938,35.7557 C43.938,40.0227 40.468,43.4937 36.201,43.4937 L36.201,43.4937 Z M36.201,26.0187 C30.832,26.0187 26.464,30.3867 26.464,35.7557 C26.464,41.1247 30.832,45.4937 36.201,45.4937 C41.57,45.4937 45.938,41.1247 45.938,35.7557 C45.938,30.3867 41.57,26.0187 36.201,26.0187 L36.201,26.0187 Z M4,38.2507 L24.843,38.2507 L24.843,40.2507 L3,40.2507 C2.447,40.2507 2,39.8037 2,39.2507 L2,34.8817 L4,34.8817 L4,38.2507 Z M39.319,9.6187 C40.124,9.6187 40.778,10.2737 40.778,11.0777 C40.778,11.8817 40.124,12.5357 39.319,12.5357 C38.515,12.5357 37.861,11.8817 37.861,11.0777 C37.861,10.2737 38.515,9.6187 39.319,9.6187 L39.319,9.6187 Z M39.319,14.5357 C41.226,14.5357 42.778,12.9847 42.778,11.0777 C42.778,9.1697 41.226,7.6187 39.319,7.6187 C37.412,7.6187 35.861,9.1697 35.861,11.0777 C35.861,12.9847 37.412,14.5357 39.319,14.5357 L39.319,14.5357 Z M14.494,9.6187 L29.17,9.6187 C29.605,9.6187 29.991,9.3367 30.123,8.9207 C31.056,5.9777 33.764,3.9997 36.861,3.9997 C40.763,3.9997 43.938,7.1747 43.938,11.0777 C43.938,14.9797 40.763,18.1547 36.861,18.1547 C33.764,18.1547 31.056,16.1767 30.123,13.2347 C29.991,12.8187 29.605,12.5357 29.17,12.5357 L26.677,12.5357 C26.411,12.5357 26.157,12.6417 25.97,12.8287 L24.569,14.2287 L23.17,12.8287 C22.982,12.6417 22.728,12.5357 22.463,12.5357 L21.057,12.5357 C20.792,12.5357 20.538,12.6417 20.35,12.8287 L18.95,14.2287 L17.551,12.8287 C17.363,12.6417 17.109,12.5357 16.844,12.5357 L15.112,12.5357 L13.33,10.9767 L14.494,9.6187 Z M14.078,14.2887 C14.26,14.4487 14.494,14.5357 14.736,14.5357 L16.43,14.5357 L18.243,16.3497 C18.634,16.7407 19.266,16.7407 19.657,16.3497 L21.472,14.5357 L22.049,14.5357 L23.862,16.3497 C24.253,16.7407 24.886,16.7407 25.276,16.3497 L27.091,14.5357 L28.47,14.5357 C29.853,17.9257 33.138,20.1547 36.861,20.1547 C41.866,20.1547 45.938,16.0817 45.938,11.0777 C45.938,6.0727 41.866,1.9997 36.861,1.9997 C33.138,1.9997 29.853,4.2297 28.47,7.6187 L14.034,7.6187 C13.742,7.6187 13.465,7.7467 13.275,7.9677 L11.168,10.4257 C10.81,10.8427 10.855,11.4687 11.268,11.8297 L14.078,14.2887 Z M2,26.3547 C2,21.3517 6.07,17.2817 11.073,17.2817 C14.802,17.2817 18.089,19.5097 19.472,22.8997 L20.847,22.8997 L22.659,21.0857 C23.034,20.7107 23.698,20.7107 24.073,21.0857 L25.886,22.8997 L26.465,22.8997 L28.277,21.0857 C28.668,20.6967 29.3,20.6957 29.69,21.0847 L31.512,22.8997 L33.204,22.8997 C33.445,22.8997 33.678,22.9867 33.86,23.1447 L34.674,23.8517 L33.361,25.3617 L32.83,24.8997 L31.098,24.8997 C30.834,24.8997 30.58,24.7947 30.392,24.6077 L28.986,23.2057 L27.586,24.6067 C27.398,24.7937 27.144,24.8997 26.879,24.8997 L25.472,24.8997 C25.206,24.8997 24.952,24.7937 24.764,24.6067 L23.366,23.2067 L21.968,24.6067 C21.78,24.7937 21.526,24.8997 21.261,24.8997 L18.77,24.8997 C18.334,24.8997 17.948,24.6177 17.817,24.2017 C16.886,21.2587 14.176,19.2817 11.073,19.2817 C7.173,19.2817 4,22.4537 4,26.3547 C4,30.2597 7.173,33.4367 11.073,33.4367 C14.176,33.4367 16.886,31.4587 17.817,28.5167 C17.948,28.1007 18.334,27.8187 18.77,27.8187 L27.211,27.8187 L27.211,29.8187 L19.472,29.8187 C18.089,33.2077 14.802,35.4367 11.073,35.4367 C6.07,35.4367 2,31.3627 2,26.3547 L2,26.3547 Z M8.618,27.8167 C7.814,27.8167 7.16,27.1617 7.16,26.3587 C7.16,25.5547 7.814,24.9007 8.618,24.9007 C9.423,24.9007 10.077,25.5547 10.077,26.3587 C10.077,27.1617 9.423,27.8167 8.618,27.8167 L8.618,27.8167 Z M8.618,22.9007 C6.711,22.9007 5.16,24.4517 5.16,26.3587 C5.16,28.2657 6.711,29.8167 8.618,29.8167 C10.525,29.8167 12.077,28.2657 12.077,26.3587 C12.077,24.4517 10.525,22.9007 8.618,22.9007 L8.618,22.9007 Z" id="AWS-Identity-and-Access-Management_Temporary-security-credential_Resource-Icon_dark-bg" fill="#DD344C"></path>
    </g>
</svg>`, $v = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Security-Identity-and-Compliance/Res_AWS-WAF_Filtering-Rule_48</title>
    <g id="Icon-Resource/Security-Identity-and-Compliance/Res_AWS-WAF_Filtering-Rule_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M25.7781,30.4726 C25.6791,30.6316 25.6271,30.8146 25.6271,31.0016 L25.6271,35.5946 C25.4371,35.6786 25.2471,35.7646 25.0561,35.8516 C24.1611,36.2566 23.2441,36.6726 22.3761,36.8746 L22.3761,31.0016 C22.3761,30.8146 22.3231,30.6306 22.2231,30.4716 L13.8211,17.0326 C15.8711,17.4796 19.0631,17.7946 24.0051,17.7946 C28.9221,17.7946 32.1081,17.4826 34.1591,17.0386 L25.7781,30.4726 Z M24.0051,13.9516 C29.3891,13.9516 32.9991,14.4336 34.7271,14.8726 C33.0001,15.3136 29.3901,15.7946 24.0051,15.7946 C18.6201,15.7946 15.0101,15.3136 13.2831,14.8726 C15.0101,14.4336 18.6201,13.9516 24.0051,13.9516 L24.0051,13.9516 Z M24.0051,11.9516 C12.0981,11.9516 10.3211,13.7826 10.3211,14.8726 C10.3211,15.0456 10.3671,15.2386 10.4901,15.4386 L10.4731,15.4496 L20.3761,31.2886 L20.3761,38.0016 C20.3761,38.5546 20.8231,39.0016 21.3761,39.0016 C22.9501,39.0016 24.4411,38.3266 25.8821,37.6726 C26.2611,37.5006 26.6371,37.3296 27.0091,37.1756 C27.3831,37.0206 27.6271,36.6566 27.6271,36.2516 L27.6271,31.2876 L37.4461,15.5476 C37.6271,15.3086 37.6891,15.0766 37.6891,14.8726 C37.6891,13.7826 35.9111,11.9516 24.0051,11.9516 L24.0051,11.9516 Z M24.0011,44.0026 C12.9721,44.0026 4.0001,35.0306 4.0001,24.0006 C4.0001,12.9726 12.9721,3.9996 24.0011,3.9996 C35.0301,3.9996 44.0031,12.9726 44.0031,24.0006 C44.0031,35.0306 35.0301,44.0026 24.0011,44.0026 L24.0011,44.0026 Z M24.0011,1.9996 C11.8691,1.9996 2.0001,11.8686 2.0001,24.0006 C2.0001,36.1326 11.8691,46.0026 24.0011,46.0026 C36.1321,46.0026 46.0031,36.1326 46.0031,24.0006 C46.0031,11.8686 36.1321,1.9996 24.0011,1.9996 L24.0011,1.9996 Z" id="AWS-WAF_Filtering-rule_Resource-Icon_light-bg" fill="#DD344C"></path>
    </g>
</svg>`, Vv = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Security-Identity-and-Compliance/Res_AWS-WAF_Bot_48</title>
    <g id="Icon-Resource/Security-Identity-and-Compliance/Res_AWS-WAF_Bot_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M36.975,32.975 C35.653,34.297 33.348,34.297 32.026,32.975 C31.365,32.314 31,31.435 31,30.5 C31,29.565 31.365,28.686 32.026,28.025 C32.687,27.364 33.566,27 34.5,27 C35.435,27 36.314,27.364 36.975,28.025 C37.636,28.686 38,29.565 38,30.5 C38,31.435 37.636,32.314 36.975,32.975 L36.975,32.975 Z M34.5,25 C33.032,25 31.65,25.572 30.612,26.611 C29.573,27.649 29,29.031 29,30.5 C29,31.969 29.573,33.35 30.612,34.389 C31.65,35.428 33.032,36 34.5,36 C35.969,36 37.351,35.428 38.389,34.389 C39.428,33.35 40,31.969 40,30.5 C40,29.031 39.428,27.649 38.389,26.611 C37.351,25.572 35.969,25 34.5,25 L34.5,25 Z M15.975,32.975 C14.653,34.297 12.348,34.297 11.026,32.975 C10.365,32.314 10,31.435 10,30.5 C10,29.565 10.365,28.686 11.026,28.025 C11.687,27.364 12.566,27 13.5,27 C14.435,27 15.314,27.364 15.975,28.025 C16.636,28.686 17,29.565 17,30.5 C17,31.435 16.636,32.314 15.975,32.975 L15.975,32.975 Z M13.5,25 C12.032,25 10.65,25.572 9.612,26.611 C8.573,27.649 8,29.031 8,30.5 C8,31.969 8.573,33.35 9.612,34.389 C10.65,35.428 12.032,36 13.5,36 C14.969,36 16.351,35.428 17.389,34.389 C18.428,33.35 19,31.969 19,30.5 C19,29.031 18.428,27.649 17.389,26.611 C16.351,25.572 14.969,25 13.5,25 L13.5,25 Z M44,39.581 C44,39.812 43.813,40 43.581,40 L4.419,40 C4.188,40 4,39.812 4,39.581 L4,20.651 C4,20.292 4.292,20 4.651,20 L43.35,20 C43.708,20 44,20.292 44,20.651 L44,39.581 Z M22.179,14.911 L26.322,14.911 C28.246,14.911 29.855,16.226 30.338,18 L18.163,18 C18.646,16.226 20.254,14.911 22.179,14.911 L22.179,14.911 Z M22,6 C22,4.897 22.898,4 24,4 C25.103,4 26,4.897 26,6 C26,7.103 25.103,8 24,8 C22.898,8 22,7.103 22,6 L22,6 Z M43.35,18 L32.398,18 C31.881,15.112 29.357,12.911 26.322,12.911 L25,12.911 L25,9.858 C26.721,9.411 28,7.858 28,6 C28,3.794 26.206,2 24,2 C21.794,2 20,3.794 20,6 C20,7.858 21.28,9.411 23,9.858 L23,12.911 L22.179,12.911 C19.144,12.911 16.62,15.112 16.103,18 L4.651,18 C3.189,18 2,19.189 2,20.651 L2,39.581 C2,40.915 3.085,42 4.419,42 L17,42 L17,46 L19,46 L19,42 L29,42 L29,46 L31,46 L31,42 L43.581,42 C44.915,42 46,40.915 46,39.581 L46,20.651 C46,19.189 44.812,18 43.35,18 L43.35,18 Z" id="Fill-1" fill="#DD344C"></path>
    </g>
</svg>`, Gv = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Security-Identity-and-Compliance/Res_AWS-Shield_AWS-Shield-Advanced_48</title>
    <g id="Icon-Resource/Security-Identity-and-Compliance/Res_AWS-Shield_AWS-Shield-Advanced_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M36.0802,35.1109 L39.1182,35.1109 L39.1182,37.1109 L36.0802,37.1109 L36.0802,40.1489 L34.0802,40.1489 L34.0802,37.1109 L31.0422,37.1109 L31.0422,35.1109 L34.0802,35.1109 L34.0802,32.0729 L36.0802,32.0729 L36.0802,35.1109 Z M35.0802,42.3799 C31.6242,42.3799 28.8122,39.5669 28.8122,36.1109 C28.8122,32.6549 31.6242,29.8419 35.0802,29.8419 C38.5362,29.8419 41.3492,32.6549 41.3492,36.1109 C41.3492,39.5669 38.5362,42.3799 35.0802,42.3799 L35.0802,42.3799 Z M21.1592,38.2829 C13.0002,37.6849 12.6702,29.9679 12.6612,29.6499 L12.6612,13.3789 L21.1592,10.1099 L21.1592,38.2829 Z M26.8122,36.1109 C26.8122,36.5029 26.8502,36.8849 26.9022,37.2619 C25.8172,37.8319 24.5652,38.1749 23.1592,38.2839 L23.1592,10.1099 L31.6572,13.3789 L31.6572,28.5929 C28.8042,29.8979 26.8122,32.7729 26.8122,36.1109 L26.8122,36.1109 Z M22.1592,43.9849 C17.5692,43.9849 13.9392,42.6229 11.3702,39.9349 C6.7122,35.0599 7.00308412,27.3509 7.0082,27.2279 L7.0082,10.1379 L22.1592,4.0779 L37.3102,10.1379 L37.3112,27.2739 C37.3112,27.2789 37.3252,27.6059 37.3092,28.1559 C36.5992,27.9569 35.8532,27.8419 35.0802,27.8419 C34.5952,27.8419 34.1212,27.8929 33.6572,27.9739 L33.6572,12.6919 C33.6572,12.2779 33.4022,11.9069 33.0172,11.7579 L22.5182,7.7199 C22.2862,7.6319 22.0322,7.6319 21.8002,7.7199 L11.3022,11.7579 C10.9162,11.9069 10.6612,12.2779 10.6612,12.6919 L10.6612,29.6719 C10.6642,29.7789 11.0232,40.3409 22.1592,40.3409 C24.1352,40.3409 25.8942,39.9609 27.4322,39.2399 C27.9282,40.4489 28.7042,41.5119 29.6782,42.3559 C27.5722,43.4319 25.0552,43.9849 22.1592,43.9849 L22.1592,43.9849 Z M39.2692,28.9939 C39.3402,27.9109 39.3112,27.2279 39.3102,27.2279 L39.3102,9.4619 C39.3102,9.0519 39.0612,8.6849 38.6822,8.5329 L22.5302,2.0719 C22.2922,1.9759 22.0262,1.9759 21.7882,2.0719 L5.6372,8.5329 C5.2572,8.6849 5.0082,9.0519 5.0082,9.4619 L5.0092,27.1809 C4.9922,27.5299 4.6642,35.8009 9.9142,41.3049 C12.8752,44.4109 16.9952,45.9849 22.1592,45.9849 C25.8292,45.9849 28.9852,45.1719 31.5672,43.5849 C32.6352,44.0899 33.8232,44.3799 35.0802,44.3799 C39.6402,44.3799 43.3492,40.6709 43.3492,36.1109 C43.3492,33.0809 41.7062,30.4339 39.2692,28.9939 L39.2692,28.9939 Z" id="AWS-Shield_AWS-Shield-Advanced_Resource-Icon_light-bg" fill="#DD344C"></path>
    </g>
</svg>`, Di = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Security-Identity-and-Compliance/Res_AWS-Identity-Access-Management_IAM-Access-Analyzer_48</title>
    <g id="Icon-Resource/Security-Identity-and-Compliance/Res_AWS-Identity-Access-Management_IAM-Access-Analyzer_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M15,25.001 L19,25.001 L19,23.001 L15,23.001 L15,25.001 Z M4,27.001 L11,27.001 L11,20.001 L4,20.001 L4,27.001 Z M12,29.001 L3,29.001 C2.448,29.001 2,28.553 2,28.001 L2,19.001 C2,18.448 2.448,18.001 3,18.001 L12,18.001 C12.552,18.001 13,18.448 13,19.001 L13,28.001 C13,28.553 12.552,29.001 12,29.001 L12,29.001 Z M43.2,27.001 L40,21.891 L36.8,27.001 L43.2,27.001 Z M45.87,28.481 C45.696,28.799 45.362,28.998 45,29.0010017 L35,29.0010017 C34.448,29.002 33.999,28.555 33.9979861,28.003 C33.997,27.815 34.05,27.631 34.149,27.471 L39.149,19.471 C39.44,19.001 40.058,18.857 40.526,19.148 C40.658,19.229 40.769,19.34 40.851,19.471 L45.851,27.471 C46.038,27.779 46.046,28.165 45.87,28.481 L45.87,28.481 Z M43,41.001 C43,39.344 41.657,38.001 40,38.001 C38.343,38.001 37,39.344 37,41.001 C37,42.658 38.343,44.001 40,44.001 C41.657,44.001 43,42.658 43,41.001 L43,41.001 Z M45,41.001 C45.003,43.762 42.767,46.003 40.005,46.0060018 C37.625,46.008 35.573,44.333 35.101,42.001 L7,42.001 C6.448,42.001 6,41.553 6,41.001 L6,31.001 L8,31.001 L8,40.001 L35.101,40.001 C35.649,37.295 38.288,35.546 40.995,36.096 C43.327,36.569 45.003,38.621 45,41.001 L45,41.001 Z M22,25.001 L26,25.001 L26,23.001 L22,23.001 L22,25.001 Z M37,7.001 C37,8.658 38.343,10.001 40,10.001 C41.657,10.001 43,8.658 43,7.001 C43,5.344 41.657,4.001 40,4.001 C38.343,4.001 37,5.344 37,7.001 L37,7.001 Z M8,16.001 L6,16.001 L6,7.001 C6,6.448 6.448,6.001 7,6.001 L35.101,6.001 C35.652,3.295 38.294,1.55 40.999,2.102 C43.704,2.654 45.45,5.295 44.897,8.001 C44.346,10.706 41.704,12.452 38.999,11.9 C37.035,11.499 35.501,9.965 35.101,8.001 L8,8.001 L8,16.001 Z M29,25.001 L33,25.001 L33,23.001 L29,23.001 L29,25.001 Z" id="AWS-Identity-and-Access-Management_AWS-IAM-Access-Analyzer_Resource-Icon_light-bg" fill="#DD344C"></path>
    </g>
</svg>`, jv = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Security-Identity-and-Compliance/Res_AWS-WAF_Bot-Control_48</title>
    <g id="Icon-Resource/Security-Identity-and-Compliance/Res_AWS-WAF_Bot-Control_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M32,26.5 C32,26.1 31.844,25.723 31.561,25.44 L31.561,25.439 C31.269,25.147 30.884,25.001 30.5,25.001 C30.116,25.001 29.731,25.147 29.439,25.439 C29.156,25.723 29,26.1 29,26.5 C29,26.9 29.156,27.277 29.439,27.56 C30.023,28.145 30.977,28.146 31.561,27.561 C31.844,27.277 32,26.9 32,26.5 L32,26.5 Z M32.975,24.025 C33.636,24.686 34,25.565 34,26.5 C34,27.435 33.636,28.314 32.975,28.975 C32.292,29.657 31.396,29.998 30.5,29.998 C29.604,29.998 28.708,29.657 28.025,28.975 C27.364,28.314 27,27.435 27,26.5 C27,25.565 27.364,24.686 28.025,24.025 C29.391,22.662 31.609,22.661 32.975,24.025 L32.975,24.025 Z M19,26.5 C19,26.1 18.844,25.723 18.561,25.44 C18.269,25.147 17.884,25.001 17.5,25.001 C17.116,25.001 16.731,25.147 16.439,25.439 C16.156,25.723 16,26.1 16,26.5 C16,26.9 16.156,27.277 16.439,27.56 C17.023,28.145 17.977,28.146 18.561,27.561 L18.561,27.56 C18.844,27.277 19,26.9 19,26.5 L19,26.5 Z M19.975,24.025 C20.636,24.686 21,25.565 21,26.5 C21,27.435 20.636,28.314 19.975,28.975 C19.292,29.657 18.396,29.998 17.5,29.998 C16.604,29.998 15.708,29.657 15.025,28.975 C14.364,28.314 14,27.435 14,26.5 C14,25.565 14.364,24.686 15.025,24.025 C16.391,22.662 18.609,22.66 19.975,24.025 L19.975,24.025 Z M35,21.651 C35,21.292 34.708,21 34.35,21 L13.65,21 C13.292,21 13,21.292 13,21.651 L13,31.581 C13,31.812 13.188,32 13.419,32 L34.581,32 C34.813,32 35,31.812 35,31.581 L35,21.651 Z M21.04,19 L26.944,19 C26.616,18.395 26.003,18 25.293,18 L22.707,18 C21.985,18 21.363,18.408 21.04,19 L21.04,19 Z M23,12 C23,12.551 23.448,13 24,13 C24.552,13 25,12.551 25,12 C25,11.449 24.552,11 24,11 C23.448,11 23,11.449 23,12 L23,12 Z M37,31.581 C37,32.915 35.915,34 34.581,34 L28,34 L28,38 L26,38 L26,34 L22,34 L22,38 L20,38 L20,34 L13.419,34 C12.085,34 11,32.915 11,31.581 L11,21.651 C11,20.189 12.188,19 13.65,19 L18.917,19 C19.328,17.284 20.866,16 22.707,16 L23,16 L23,14.815 C21.839,14.401 21,13.302 21,12 C21,10.346 22.346,9 24,9 C25.654,9 27,10.346 27,12 C27,13.302 26.161,14.401 25,14.816 L25,16 L25.293,16 C27.134,16 28.672,17.284 29.083,19 L34.35,19 C35.812,19 37,20.189 37,21.651 L37,31.581 Z M7.489,35.95 L9.11,34.777 C7.029,31.902 5.859,28.538 5.676,25 L8,25 L8,23 L5.679,23 C5.871,19.483 7.04,16.14 9.11,13.281 L7.489,12.108 C5.172,15.311 3.873,19.059 3.679,23 L2,23 L2,25 L3.676,25 C3.861,28.962 5.16,32.731 7.489,35.95 L7.489,35.95 Z M34.747,38.918 C31.88,40.993 28.527,42.162 25,42.351 L25,40 L23,40 L23,42.351 C19.472,42.163 16.118,40.994 13.25,38.918 L12.078,40.539 C15.289,42.862 19.049,44.161 23,44.351 L23,46 L25,46 L25,44.351 C28.951,44.16 32.709,42.862 35.919,40.539 L34.747,38.918 Z M13.25,9.14 C16.118,7.064 19.472,5.896 23,5.708 L23,8 L25,8 L25,5.708 C28.527,5.896 31.88,7.065 34.747,9.14 L35.919,7.52 C32.709,5.196 28.951,3.897 25,3.708 L25,2 L23,2 L23,3.708 C19.048,3.897 15.289,5.196 12.078,7.52 L13.25,9.14 Z M44.319,23 C44.125,19.059 42.826,15.311 40.509,12.108 L38.888,13.281 C40.958,16.14 42.127,19.483 42.319,23 L40,23 L40,25 L42.322,25 C42.139,28.538 40.969,31.902 38.888,34.777 L40.509,35.95 C42.838,32.731 44.137,28.962 44.322,25 L46,25 L46,23 L44.319,23 Z M37.026,12.416 L43.186,6.256 L41.771,4.842 L35.612,11.002 L37.026,12.416 Z M10.972,35.642 L4.812,41.802 L6.226,43.216 L12.386,37.056 L10.972,35.642 Z M11.706,10.293 L3.586,2.173 L2.172,3.587 L10.292,11.708 L11.706,10.293 Z M37.706,36.293 L45.826,44.413 L44.412,45.827 L36.292,37.708 L37.706,36.293 Z" id="Fill-1" fill="#DD344C"></path>
    </g>
</svg>`, qv = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Security-Identity-and-Compliance/Res_AWS-Identity-Access-Management_IAM-Roles-Anywhere_48</title>
    <g id="Icon-Resource/Security-Identity-and-Compliance/Res_AWS-Identity-Access-Management_IAM-Roles-Anywhere_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M43.95,41.723 C43.641,41.743 43.286,41.765 42.905,41.786 L42.639,41.81 C41.098,41.958 39.397,42.071 38.46,41.797 L37.95,41.669 C37.508,41.53 37.057,41.34 36.549,41.124 C35.147,40.53 33.39,39.795 31.401,39.839 L31.35,37.84 C33.791,37.765 35.834,38.649 37.33,39.284 C37.774,39.472 38.166,39.64 38.5,39.747 L38.985,39.868 C39.09,39.898 39.249,39.924 39.467,39.942 L39.416,39.731 C38.336,35.383 34.271,32.23 29.533,32.071 C27.577,32 25.673,32.447 23.994,33.351 C21.515,35.159 20.039,37.886 19.938,40.842 C19.937,40.897 19.935,41.026 19.934,41.169 C20.886,41.768 22.103,42.147 23.423,42.259 C26.075,41.138 29.975,40.901 32.143,41.141 C33.812,41.326 35.609,42.178 37.053,42.863 C37.841,43.237 38.655,43.623 39.054,43.694 C39.714,43.807 41.17,43.708 42.453,43.619 L42.59,43.61 C42.998,43.579 43.404,43.555 43.791,43.536 C43.823,43.535 43.855,43.533 43.888,43.531 L43.95,41.723 Z M19.513,43.826 C19.823,43.779 20.131,43.708 20.433,43.629 C19.615,43.32 18.869,42.916 18.236,42.423 C17.749,42.641 17.253,42.848 16.763,43.043 C16.328,43.216 15.756,43.443 15.333,43.646 C16.016,43.89 17.236,44.056 18.847,43.894 L19.513,43.826 Z M31.746,29.204 C29.744,29.141 27.782,29.581 26.023,30.456 C27.181,30.171 28.383,30.035 29.6,30.072 C35.227,30.261 40.062,34.037 41.358,39.255 L41.514,39.898 C41.798,39.877 42.102,39.852 42.449,39.819 C42.624,39.803 42.747,39.792 42.801,39.789 C42.94,39.781 43.069,39.773 43.202,39.765 C42.533,33.966 37.678,29.404 31.746,29.204 L31.746,29.204 Z M45.967,41.242 L45.872,44.058 C45.846,44.844 45.209,45.482 44.421,45.51 C44.194,45.518 44.051,45.523 43.907,45.533 C43.515,45.552 43.127,45.576 42.731,45.604 L42.591,45.614 C41.057,45.72 39.612,45.819 38.711,45.664 C38.04,45.545 37.226,45.159 36.196,44.67 C34.887,44.049 33.259,43.277 31.924,43.129 C29.597,42.869 25.185,43.296 23.295,44.573 C22.293,45.254 20.573,45.785 19.019,45.892 L18.788,45.908 C18.677,45.917 18.553,45.926 18.416,45.933 L18.268,45.944 L18.267,45.941 C18.064,45.951 17.839,45.957 17.599,45.957 C16.193,45.957 14.293,45.744 13.327,44.71 C12.826,44.175 12.855,43.631 12.917,43.355 C13.147,42.328 14.353,41.848 16.024,41.184 C16.493,40.998 16.963,40.802 17.414,40.6 C17.577,36.419 19.575,32.573 22.909,30.04 C25.447,28.105 28.613,27.095 31.812,27.205 C38.859,27.443 44.596,32.953 45.216,39.891 C45.321,39.952 45.421,40.021 45.51,40.107 C45.815,40.402 45.982,40.816 45.967,41.242 L45.967,41.242 Z M20,23 L23,23 L23,20 L20,20 L20,23 Z M25,19 L25,24 C25,24.552 24.553,25 24,25 L19,25 C18.447,25 18,24.552 18,24 L18,19 C18,18.448 18.447,18 19,18 L24,18 C24.553,18 25,18.448 25,19 L25,19 Z M10,23 L13,23 L13,20 L10,20 L10,23 Z M15,19 L15,24 C15,24.552 14.553,25 14,25 L9,25 C8.447,25 8,24.552 8,24 L8,19 C8,18.448 8.447,18 9,18 L14,18 C14.553,18 15,18.448 15,19 L15,19 Z M20,13 L23,13 L23,10 L20,10 L20,13 Z M25,14 C25,14.552 24.553,15 24,15 L19,15 C18.447,15 18,14.552 18,14 L18,9 C18,8.448 18.447,8 19,8 L24,8 C24.553,8 25,8.448 25,9 L25,14 Z M10,13 L13,13 L13,10 L10,10 L10,13 Z M15,14 C15,14.552 14.553,15 14,15 L9,15 C8.447,15 8,14.552 8,14 L8,9 C8,8.448 8.447,8 9,8 L14,8 C14.553,8 15,8.448 15,9 L15,14 Z M20,31 L12,31 C11.448,31 11,31.449 11,32 L11,46 L10,46 L9,46 L4.333,46 C3.047,46 2,45.082 2,43.955 L2,4.045 C2,2.917 3.047,2 4.333,2 L28.667,2 C29.953,2 31,2.917 31,4.045 L31,25 L29,25 L29,4.045 C28.994,4.083 28.874,4 28.667,4 L4.333,4 C4.128,4 4.005,4.085 3.982,4.116 L4,43.955 C4.004,43.914 4.125,44 4.333,44 L9,44 L9,32 C9,30.346 10.346,29 12,29 L20,29 L20,31 Z" id="Fill-1" fill="#DD344C"></path>
    </g>
</svg>`, Kv = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Security-Identity-and-Compliance/Res_AWS-Identity-Access-Management_Data-Encryption-Key_48</title>
    <g id="Icon-Resource/Security-Identity-and-Compliance/Res_AWS-Identity-Access-Management_Data-Encryption-Key_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M28.3714,32.8701 C28.5014,32.7411 28.6724,32.6701 28.8544,32.6701 L28.8554,32.6701 C29.0394,32.6701 29.2124,32.7411 29.3424,32.8711 C29.4714,33.0011 29.5414,33.1721 29.5414,33.3541 L29.5414,33.3561 C29.5414,33.5401 29.4704,33.7121 29.3404,33.8421 C29.2114,33.9711 29.0394,34.0421 28.8554,34.0421 L28.8544,34.0421 C28.4764,34.0421 28.1704,33.7341 28.1704,33.3561 C28.1704,33.1731 28.2414,33.0001 28.3714,32.8701 L28.3714,32.8701 Z M27.8554,35.8451 L27.8554,38.6551 L29.8554,38.6551 L29.8554,35.8481 C30.1864,35.7151 30.4924,35.5171 30.7544,35.2571 C31.2614,34.7501 31.5404,34.0761 31.5414107,33.3581 C31.5434,32.6411 31.2644,31.9671 30.7574,31.4591 C30.2504,30.9501 29.5744,30.6701 28.8564,30.6701 L28.8534,30.6701 C27.3754,30.6701 26.1724,31.8741 26.1704,33.3551 C26.1704,34.4831 26.8694,35.4471 27.8554,35.8451 L27.8554,35.8451 Z M35.7184,40.4651 L21.9874,40.4591 L21.9914,29.3511 L35.7244,29.3581 L35.7184,40.4651 Z M25.4874,24.8331 C25.4904,23.8461 25.8514,22.9211 26.5054,22.2301 C27.1404,21.5591 27.9764,21.1901 28.8614,21.1901 L28.8724,21.1901 C30.7214,21.1961 32.2194,22.8491 32.213418,24.8761 L32.2124,27.3561 L25.4754,27.3531 L25.4874,24.8331 Z M36.7244,27.3581 L34.2124,27.3571 L34.2134,24.8791 C34.2234,21.7521 31.8294,19.2001 28.8784,19.1901 L28.8614,19.1901 C27.4214,19.1901 26.0684,19.7811 25.0524,20.8561 C24.0484,21.9181 23.4924,23.3281 23.4874,24.8251 L23.4754,27.3521 L20.9914,27.3511 C20.7264,27.3511 20.4724,27.4571 20.2844,27.6441 C20.0974,27.8321 19.9914,28.0861 19.9914,28.3511 L19.9874,41.4591 C19.9874,42.0111 20.4344,42.4591 20.9874,42.4591 L36.7184,42.4651 C37.2694,42.4651 37.7184,42.0171 37.7184,41.4651 L37.7244,28.3581 C37.7244,28.0941 37.6184,27.8391 37.4314,27.6511 C37.2434,27.4641 36.9894,27.3581 36.7244,27.3581 L36.7244,27.3581 Z M15.7634,11.4691 C15.3644,11.4691 15.0404,11.1441 15.0404,10.7461 C15.0404,10.3471 15.3644,10.0221 15.7634,10.0221 C16.1624,10.0221 16.4864,10.3471 16.4864,10.7461 C16.4864,11.1441 16.1624,11.4691 15.7634,11.4691 L15.7634,11.4691 Z M15.7634,8.0221 C14.2624,8.0221 13.0404,9.2441 13.0404,10.7461 C13.0404,12.2471 14.2624,13.4691 15.7634,13.4691 C17.2654,13.4691 18.4864,12.2471 18.4864,10.7461 C18.4864,9.2441 17.2654,8.0221 15.7634,8.0221 L15.7634,8.0221 Z M17.1844,16.1861 C16.7684,16.3181 16.4864,16.7041 16.4864,17.1401 L16.4864,18.8881 C16.4864,19.1531 16.5924,19.4071 16.7794,19.5951 L17.5494,20.3641 L16.7794,21.1351 C16.5924,21.3221 16.4864,21.5771 16.4864,21.8421 L16.4864,22.8261 C16.4864,23.0921 16.5924,23.3461 16.7794,23.5331 L17.5494,24.3031 L16.7794,25.0731 C16.5924,25.2611 16.4864,25.5161 16.4864,25.7801 L16.4864,26.8811 L15.6624,27.8231 L15.0404,27.2891 L15.0404,17.1401 C15.0404,16.7041 14.7584,16.3181 14.3424,16.1861 C12.4044,15.5721 11.1014,13.7891 11.1014,11.7491 C11.1014,9.1791 13.1924,7.0871 15.7634,7.0871 C18.3334,7.0871 20.4254,9.1791 20.4254,11.7491 C20.4254,13.7891 19.1224,15.5721 17.1844,16.1861 L17.1844,16.1861 Z M19.6704,21.0711 C20.0604,20.6811 20.0604,20.0481 19.6704,19.6571 L18.4864,18.4741 L18.4864,17.8281 C20.8704,16.7711 22.4254,14.4131 22.4254,11.7491 C22.4254,8.0751 19.4364,5.0871 15.7634,5.0871 C12.0904,5.0871 9.1014,8.0751 9.1014,11.7491 C9.1014,14.4131 10.6564,16.7711 13.0404,17.8281 L13.0404,27.7491 C13.0404,28.0411 13.1684,28.3181 13.3894,28.5081 L15.1114,29.9851 C15.3004,30.1471 15.5314,30.2261 15.7634,30.2261 C16.0414,30.2261 16.3174,30.1111 16.5164,29.8851 L18.2394,27.9151 C18.3984,27.7331 18.4864,27.4991 18.4864,27.2571 L18.4864,26.1941 L19.6704,25.0101 C20.0604,24.6191 20.0604,23.9861 19.6704,23.5961 L18.4864,22.4121 L18.4864,22.2561 L19.6704,21.0711 Z M39.2214,43.1561 C39.2214,43.6001 38.8594,43.9621 38.4154,43.9621 L8.8064,43.9621 C8.3614,43.9621 8.0004,43.6001 8.0004,43.1561 L8.0004,4.8061 C8.0004,4.3611 8.3614,4.0001 8.8064,4.0001 L38.4154,4.0001 C38.8594,4.0001 39.2214,4.3611 39.2214,4.8061 L39.2214,43.1561 Z M38.4154,2.0001 L8.8064,2.0001 C7.2594,2.0001 6.0004,3.2591 6.0004,4.8061 L6.0004,43.1561 C6.0004,44.7031 7.2594,45.9621 8.8064,45.9621 L38.4154,45.9621 C39.9624,45.9621 41.2214,44.7031 41.2214,43.1561 L41.2214,4.8061 C41.2214,3.2591 39.9624,2.0001 38.4154,2.0001 L38.4154,2.0001 Z" id="AWS-Identity-and-Access-Management_Data-Encryption-Key_-Resource-Icon_light-bg" fill="#DD344C"></path>
    </g>
</svg>`, Yv = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Security-Identity-and-Compliance/Res_AWS-Network-Firewall_Endpoints_48</title>
    <g id="Icon-Resource/Security-Identity-and-Compliance/Res_AWS-Network-Firewall_Endpoints_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M45.41225,23.293 L41.97425,19.855 L40.55925,21.269 L42.29125,23 L35.82825,23 L35.82825,25 L42.29125,25 L40.55925,26.731 L41.97425,28.146 L45.41225,24.707 C45.80325,24.316 45.80325,23.684 45.41225,23.293 L45.41225,23.293 Z M7.12125,21.293 L5.70725,19.879 L2.29325,23.293 C1.90225,23.684 1.90225,24.316 2.29325,24.707 L5.70725,28.121 L7.12125,26.707 L5.41425,25 L11.82825,25 L11.82825,23 L5.41425,23 L7.12125,21.293 Z M31.82825,25 L24.82825,25 L24.82825,28 L29.82825,28 L31.82825,28 L31.82825,25 Z M28.82825,30 L23.82825,30 L21.82825,30 L21.82825,33 L28.82825,33 L28.82825,30 Z M15.82825,28 L20.82825,28 L22.82825,28 L22.82825,25 L15.82825,25 L15.82825,28 Z M17.63025,23 L23.82825,23 L29.93425,23 C29.91225,21.739 29.59925,20.842 29.24725,20.241 C28.58325,21.485 27.49325,21.901 26.85325,21.929 C26.57725,21.93 26.31625,21.841 26.11925,21.652 C25.92225,21.463 25.81025,21.202 25.81025,20.93 C25.81025,17.192 23.48725,15.295 21.55725,14.363 C22.01325,15.626 22.18425,17.336 21.40925,19.466 C21.27525,19.833 20.93925,20.088 20.55025,20.12 C20.14425,20.15 19.78625,19.951 19.59625,19.61 C19.39525,19.251 19.02525,18.711 18.59125,18.244 C18.77325,19.536 18.74225,21.135 17.90525,22.406 C17.79425,22.601 17.71025,22.8 17.63025,23 L17.63025,23 Z M33.82825,24 L33.82825,29 C33.82825,29.552 33.38125,30 32.82825,30 L30.82825,30 L30.82825,34 C30.82825,34.552 30.38125,35 29.82825,35 L20.82825,35 C20.27525,35 19.82825,34.552 19.82825,34 L19.82825,30 L14.82825,30 C14.27525,30 13.82825,29.552 13.82825,29 L13.82825,24 C13.82825,23.448 14.27525,23 14.82825,23 L15.54225,23 C15.68425,22.458 15.87525,21.93 16.15525,21.439 C16.16325,21.426 16.21725,21.334 16.22525,21.321 C17.13025,19.947 16.47225,17.501 16.14125,16.674 C16.01925,16.366 16.05725,16.016 16.24325,15.742 C16.42925,15.467 16.73925,15.302 17.07025,15.302 C18.20325,15.302 19.19225,15.996 19.93325,16.753 C19.98225,14.54 18.61625,13.378 18.54325,13.317 C18.19625,13.03 18.08025,12.545 18.26425,12.134 C18.44725,11.724 18.87625,11.48 19.32425,11.552 C21.94025,11.952 26.63425,14.011 27.62425,18.979 C27.69525,18.768 27.75325,18.512 27.78625,18.199 C27.82125,17.865 28.02125,17.571 28.31825,17.417 C28.61825,17.262 28.97425,17.267 29.26625,17.429 C29.37425,17.49 31.88225,18.936 31.93725,23 L32.82825,23 C33.38125,23 33.82825,23.448 33.82825,24 L33.82825,24 Z M4.75025,18 C7.30625,9.895 14.89025,4 23.82825,4 C32.76625,4 40.35025,9.895 42.90625,18 L44.98925,18 C42.37125,8.777 33.87925,2 23.82825,2 C13.77725,2 5.28525,8.777 2.66725,18 L4.75025,18 Z M44.98925,30 C42.37125,39.223 33.87925,46 23.82825,46 C13.77725,46 5.28525,39.223 2.66725,30 L4.75025,30 C7.30625,38.105 14.89025,44 23.82825,44 C32.76625,44 40.35025,38.105 42.90625,30 L44.98925,30 Z" id="Fill-1" fill="#DD344C"></path>
    </g>
</svg>`, Qv = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Security-Identity-and-Compliance/Res_AWS-WAF_Managed-Rule_48</title>
    <g id="Icon-Resource/Security-Identity-and-Compliance/Res_AWS-WAF_Managed-Rule_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M13,10.0615 C14.72,10.0615 16.118,11.4605 16.118,13.1795 C16.118,14.8985 14.72,16.2975 13,16.2975 C11.28,16.2975 9.882,14.8985 9.882,13.1795 C9.882,11.4605 11.28,10.0615 13,10.0615 L13,10.0615 Z M13,18.2975 C15.822,18.2975 18.118,16.0015 18.118,13.1795 C18.118,10.3575 15.822,8.0615 13,8.0615 C10.178,8.0615 7.882,10.3575 7.882,13.1795 C7.882,16.0015 10.178,18.2975 13,18.2975 L13,18.2975 Z M4.18,11.9625 L6.064,11.9625 L6.262,11.2185 C6.419,10.6255 6.667,10.1755 6.976,9.6485 L7.366,8.9815 L6.032,7.6525 L7.52,6.1715 L8.312,6.9595 L8.938,7.4525 L9.602,7.0675 C10.144,6.7535 10.501,6.5455 11.037,6.4045 L11.782,6.2075 L11.782,4.3595 L14.218,4.3595 L14.218,6.2355 L14.959,6.4345 C15.482,6.5745 15.833,6.7815 16.446,7.1435 L17.118,7.5405 L18.426,6.2135 L19.878,7.6855 L18.565,9.0165 L18.943,9.6755 C19.296,10.2895 19.502,10.6635 19.646,11.2145 L19.841,11.9625 L21.82,11.9625 L21.82,14.3965 L19.934,14.3965 L19.736,15.1405 C19.59,15.6945 19.369,16.0845 19.023,16.6755 L18.631,17.3445 L19.965,18.6705 L18.478,20.1495 L17.142,18.8215 L16.376,19.2645 C15.844,19.5735 15.492,19.7775 14.964,19.9155 L14.218,20.1125 L14.218,21.9995 L11.782,21.9995 L11.782,20.1155 L11.039,19.9175 C10.46,19.7635 10.028,19.5245 9.482,19.2045 L8.813,18.8125 L7.489,20.1455 L6.014,18.6595 L6.801,17.8675 L7.292,17.2415 L6.908,16.5795 C6.595,16.0375 6.388,15.6785 6.246,15.1425 L6.051,14.3965 L4.18,14.3965 L4.18,11.9625 Z M3.589,16.3965 L4.562,16.3965 C4.648,16.6035 4.744,16.7985 4.849,16.9945 L4.181,17.6675 C3.639,18.2145 3.639,19.1045 4.181,19.6525 L6.49,21.9775 C7.023,22.5135 7.955,22.5145 8.488,21.9775 L9.151,21.3105 C9.354,21.4155 9.561,21.5135 9.782,21.6035 L9.782,22.5905 C9.782,23.3675 10.414,23.9995 11.191,23.9995 L14.809,23.9995 C15.586,23.9995 16.218,23.3675 16.218,22.5905 L16.218,21.5995 C16.428,21.5125 16.622,21.4165 16.813,21.3145 L17.484,21.9835 C18.035,22.5275 18.926,22.5275 19.471,21.9825 L21.796,19.6715 C22.064,19.4045 22.213,19.0495 22.213,18.6705 C22.213,18.2925 22.064,17.9365 21.797,17.6715 L21.132,17.0105 C21.234,16.8165 21.331,16.6145 21.42,16.3965 L22.411,16.3965 C23.188,16.3965 23.82,15.7655 23.82,14.9885 L23.82,11.3715 C23.82,10.5945 23.188,9.9625 22.411,9.9625 L21.334,9.9625 C21.246,9.7445 21.149,9.5415 21.048,9.3465 L21.711,8.6755 C22.25,8.1295 22.25,7.2415 21.711,6.6955 L19.431,4.3835 C18.895,3.8405 17.955,3.8425 17.423,4.3835 L16.784,5.0305 C16.603,4.9325 16.417,4.8405 16.218,4.7565 L16.218,3.7685 C16.218,2.9915 15.586,2.3595 14.809,2.3595 L11.191,2.3595 C10.414,2.3595 9.782,2.9915 9.782,3.7685 L9.782,4.7215 C9.576,4.8075 9.381,4.9025 9.185,5.0075 L8.515,4.3405 C7.97,3.7945 7.077,3.7915 6.524,4.3395 L4.202,6.6525 C3.934,6.9195 3.785,7.2745 3.785,7.6535 C3.785,8.0315 3.934,8.3865 4.2,8.6515 L4.871,9.3185 C4.766,9.5225 4.666,9.7355 4.575,9.9625 L3.589,9.9625 C2.812,9.9625 2.18,10.5945 2.18,11.3715 L2.18,14.9885 C2.18,15.7655 2.812,16.3965 3.589,16.3965 L3.589,16.3965 Z M32.592,40.4145 L34.945,38.0605 L32.592,35.7075 L34.006,34.2925 L36.359,36.6465 L38.713,34.2925 L40.127,35.7075 L37.773,38.0605 L40.127,40.4145 L38.713,41.8285 L36.359,39.4745 L34.006,41.8285 L32.592,40.4145 Z M41.066,22.2805 L35.73,27.6165 L31.781,24.8155 L32.937,23.1845 L35.51,25.0085 L39.652,20.8665 L41.066,22.2805 Z M41.066,8.2805 L35.73,13.6165 L31.781,10.8155 L32.937,9.1845 L35.51,11.0085 L39.652,6.8665 L41.066,8.2805 Z M4,43.9995 L44,43.9995 L44,31.9995 L4,31.9995 L4,43.9995 Z M23,1.9995 L23,3.9995 L44,3.9995 L44,15.9995 L26,15.9995 L26,17.9995 L44,17.9995 L44,29.9995 L4,29.9995 L4,22.9995 L2,22.9995 L2,29.9995 L2,30.9995 L2,45.9995 L46,45.9995 L46,30.9995 L46,29.9995 L46,16.9995 L46,15.9995 L46,1.9995 L23,1.9995 Z" id="Fill-1" fill="#DD344C"></path>
    </g>
</svg>`, Xv = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Security-Identity-and-Compliance/Res_AWS-Key-Management-Service_External-Key-Store_48</title>
    <g id="Icon-Resource/Security-Identity-and-Compliance/Res_AWS-Key-Management-Service_External-Key-Store_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M35.9852963,24.031 L40.9852963,24.031 L40.9852963,22.031 L35.9852963,22.031 L35.9852963,24.031 Z M35.9852963,33.031 L40.9852963,33.031 L40.9852963,31.031 L35.9852963,31.031 L35.9852963,33.031 Z M35.9852963,42.031 L40.9852963,42.031 L40.9852963,40.031 L35.9852963,40.031 L35.9852963,42.031 Z M43.9852963,39.031 L45.9852963,39.031 L45.9852963,44.131 C45.9852963,45.178 45.1332963,46.031 44.0852963,46.031 L21.8812963,46.031 C20.8362963,46.031 19.9852963,45.181 19.9852963,44.136 L19.9852963,39.031 L21.9852963,39.031 L21.9852963,44.031 L43.9852963,44.031 L43.9852963,39.031 Z M43.9852963,30.031 L45.9852963,30.031 L45.9852963,35.136 C45.9852963,36.181 45.1352963,37.031 44.0902963,37.031 L21.8812963,37.031 C20.8362963,37.031 19.9852963,36.181 19.9852963,35.136 L19.9852963,30.031 L21.9852963,30.031 L21.9852963,35.031 L43.9852963,35.031 L43.9852963,30.031 Z M45.9852963,20.479 L45.9852963,25.995 C45.9852963,27.118 45.1292963,28.031 44.0772963,28.031 L21.8932963,28.031 C20.8422963,28.031 19.9852963,27.118 19.9852963,25.995 L19.9852963,25.031 L21.9852963,25.031 L21.9852963,25.995 C21.9872963,26.015 21.9842963,26.026 21.9772963,26.031 L43.9682963,26.031 L43.9852963,20.479 C43.9852963,20.211 43.8602963,20.05 43.8082963,20.028 L31.5872963,20.031 L31.5872963,18.031 L43.8272963,18.031 C45.0172963,18.031 45.9852963,19.129 45.9852963,20.479 L45.9852963,20.479 Z M20.0842963,14.136 C19.7002963,13.909 19.4282963,13.546 19.3172963,13.114 C19.2062963,12.682 19.2702963,12.232 19.4972963,11.848 C19.7242963,11.464 20.0882963,11.192 20.5192963,11.081 C20.6582963,11.045 20.7992963,11.028 20.9372963,11.028 C21.2332963,11.028 21.5242963,11.107 21.7852963,11.261 C22.1692963,11.489 22.4412963,11.852 22.5532963,12.284 C22.6632963,12.716 22.5992963,13.165 22.3722963,13.55 C22.1442963,13.933 21.7812963,14.206 21.3492963,14.317 C20.9182963,14.427 20.4692963,14.364 20.0852963,14.136 L20.0842963,14.136 Z M21.8472963,16.254 C22.7962963,16.01 23.5942963,15.412 24.0932963,14.569 C24.5932963,13.725 24.7332963,12.737 24.4902963,11.787 C24.2462963,10.838 23.6472963,10.04 22.8042963,9.54 C21.0602963,8.508 18.8062963,9.089 17.7762963,10.83 C17.2762963,11.674 17.1362963,12.661 17.3802963,13.611 C17.6232963,14.56 18.2222963,15.358 19.0652963,15.857 C19.6392963,16.197 20.2792963,16.37 20.9292963,16.37 C21.2342963,16.37 21.5422963,16.332 21.8472963,16.254 L21.8472963,16.254 Z M18.7972963,20.996 C18.3642963,20.891 17.9182963,21.077 17.6932963,21.457 L7.91029632,37.989 L3.84929632,39.031 L3.66529632,35.607 L4.90929632,33.504 C5.04529632,33.275 5.08329632,33.003 5.01729632,32.746 L4.30129632,29.952 L7.09529632,29.236 C7.35129632,29.17 7.57229632,29.005 7.70729632,28.777 L9.10529632,26.413 C9.24129632,26.184 9.27929632,25.912 9.21429632,25.655 L8.49729632,22.862 L11.2912963,22.145 C11.5492963,22.079 11.7682963,21.913 11.9032963,21.685 L13.7722963,18.526 C13.9702963,18.193 13.9572963,17.778 13.7412963,17.458 C11.5762963,14.243 11.8052963,10.066 14.3112963,7.062 C16.5902963,4.331 20.5012963,3.293 23.8262963,4.537 C26.2662963,5.45 28.1522963,7.356 29.0032963,9.767 C29.8542963,12.179 29.5962963,14.825 28.2952963,17.024 C26.3682963,20.281 22.4602963,21.916 18.7972963,20.996 L18.7972963,20.996 Z M30.0162963,18.043 C31.6192963,15.332 31.9372963,12.073 30.8892963,9.101 C29.8412963,6.131 27.5222963,3.784 24.5272963,2.664 C20.3552963,1.102 15.6342963,2.356 12.7762963,5.781 C9.83329632,9.307 9.44629632,14.156 11.7402963,18.033 L10.3932963,20.31 L7.03229632,21.173 C6.49729632,21.31 6.17529632,21.855 6.31129632,22.39 L7.17429632,25.751 L6.19729632,27.402 L2.83629632,28.263 C2.57929632,28.329 2.35829632,28.495 2.22429632,28.723 C2.08829632,28.951 2.05029632,29.224 2.11529632,29.481 L2.97729632,32.842 L1.79029632,34.849 C1.68929632,35.019 1.64129632,35.215 1.65129632,35.412 L1.91729632,40.356 C1.93329632,40.656 2.08329632,40.931 2.32429632,41.109 C2.49829632,41.236 2.70529632,41.302 2.91629632,41.302 C2.99929632,41.302 3.08229632,41.292 3.16429632,41.271 L8.80829632,39.824 C9.06429632,39.758 9.28529632,39.593 9.42029632,39.364 L19.0482963,23.093 C23.3432963,23.844 27.7712963,21.836 30.0162963,18.043 L30.0162963,18.043 Z" id="Fill-1" fill="#DD344C"></path>
    </g>
</svg>`, Jv = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Blockchain/Res_Amazon-Managed-Blockchain_Blockchain_48</title>
    <g id="Icon-Resource/Blockchain/Res_Amazon-Managed-Blockchain_Blockchain_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M7.167,25.71 L10.71,25.71 L10.71,22.167 L7.167,22.167 L7.167,25.71 Z M10.936,20.167 L6.941,20.167 C5.963,20.167 5.167,20.963 5.167,21.941 L5.167,25.936 C5.167,26.914 5.963,27.71 6.941,27.71 L10.936,27.71 C11.914,27.71 12.71,26.914 12.71,25.936 L12.71,21.941 C12.71,20.963 11.914,20.167 10.936,20.167 L10.936,20.167 Z M37.258,25.71 L40.801,25.71 L40.801,22.167 L37.258,22.167 L37.258,25.71 Z M37.032,27.71 L41.026,27.71 C42.005,27.71 42.801,26.914 42.801,25.936 L42.801,21.941 C42.801,20.963 42.005,20.167 41.026,20.167 L37.032,20.167 C36.054,20.167 35.258,20.963 35.258,21.941 L35.258,25.936 C35.258,26.914 36.054,27.71 37.032,27.71 L37.032,27.71 Z M22.213,25.71 L25.756,25.71 L25.756,22.167 L22.213,22.167 L22.213,25.71 Z M25.981,20.167 L21.986,20.167 C21.009,20.167 20.213,20.963 20.213,21.941 L20.213,25.936 C20.213,26.914 21.009,27.71 21.986,27.71 L25.981,27.71 C26.96,27.71 27.756,26.914 27.756,25.936 L27.756,21.941 C27.756,20.963 26.96,20.167 25.981,20.167 L25.981,20.167 Z M43.968,28.877 L34.402,28.877 C34.327,28.873 34.19,28.824 34.09,28.772 L34.09,24.918 L28.923,24.918 L28.923,28.877 L19.357,28.877 C19.281,28.873 19.145,28.824 19.045,28.772 L19.045,24.918 L13.878,24.918 L13.878,28.772 C13.778,28.824 13.642,28.873 13.571,28.877 L4,28.877 L4,19 L13.637,18.999 C13.677,19.003 13.742,19.028 13.797,19.057 L13.797,22.959 L19.126,22.959 L19.126,19.056 C19.18,19.027 19.242,19.003 19.277,19 L28.923,19 L28.923,22.959 L34.172,22.959 L34.172,19.056 C34.224,19.027 34.288,19.003 34.322,19 L43.968,19 L43.968,28.877 Z M44.149,17 L34.322,17 C33.425,17 32.172,17.703 32.172,18.848 L32.172,20.959 L30.923,20.959 L30.923,18.848 C30.923,17.829 30.107,17 29.104,17 L19.277,17 C18.379,17 17.126,17.703 17.126,18.848 L17.126,20.959 L15.797,20.959 L15.797,18.848 C15.797,17.703 14.544,17 13.645,17 L3.819,17 C2.816,17 2,17.829 2,18.848 L2,29.029 C2,30.048 2.816,30.877 3.819,30.877 L13.571,30.877 C14.376,30.877 15.878,30.242 15.878,29.029 L15.878,26.918 L17.045,26.918 L17.045,29.029 C17.045,30.242 18.547,30.877 19.351,30.877 L29.104,30.877 C30.107,30.877 30.923,30.048 30.923,29.029 L30.923,26.918 L32.09,26.918 L32.09,29.029 C32.09,30.242 33.592,30.877 34.396,30.877 L44.149,30.877 C45.152,30.877 45.968,30.048 45.968,29.029 L45.968,18.848 C45.968,17.829 45.152,17 44.149,17 L44.149,17 Z" id="Amazon-Managed-Blockchain-Blockchain_Resource-Icon_light-bg" fill="#ED7100"></path>
    </g>
</svg>`, eM = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Application-Integration/Res_Amazon-EventBridge_Saas-Partner-Event_48</title>
    <g id="Icon-Resource/Application-Integration/Res_Amazon-EventBridge_Saas-Partner-Event_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M31.084,20.877 L25.023,24.333 L24.984,31.31 L31.046,27.855 L31.084,20.877 Z M16.858,27.821 L22.983,31.402 L23.023,24.241 L16.898,20.66 L16.858,27.821 Z M17.855,18.902 L24.103,22.555 L30.267,19.04 L24.021,15.388 L17.855,18.902 Z M24.47,33.905 C24.316,33.992 24.146,34.036 23.975,34.036 C23.839,34.036 23.707,34 23.58,33.945 L15.351,29.257 C15.042,29.076 14.854,28.745 14.8548202,28.388 L14.908,18.917 C14.91,18.592 15.075,18.296 15.338,18.111 L23.532,13.364 C23.842,13.189 24.223,13.19 24.532,13.37 L32.618,18.302 C32.914,18.485 33.096,18.807 33.0940324,19.156 L33.043,28.443 C33.041,28.8 32.849,29.129 32.538,29.307 L24.47,33.905 Z M33.454,4.026 L31.614,3.241 L28.811,9.816 L30.65,10.602 L33.454,4.026 Z M42.132,11.32 L40.931,9.721 L35.179,14.039 L36.38,15.639 L42.132,11.32 Z M38.792,22.837 L45.95,21.931 L45.698,19.946 L38.54,20.853 L38.792,22.837 Z M37.233,30.272 L43.88,33.022 L44.644,31.174 L37.997,28.424 L37.233,30.272 Z M32.117,35.948 L36.471,41.617 L38.057,40.398 L33.703,34.73 L32.117,35.948 Z M24.818,38.338 L25.713,45.407 L27.697,45.155 L26.803,38.086 L24.818,38.338 Z M14.495,43.38 L16.335,44.165 L19.14,37.591 L17.3,36.806 L14.495,43.38 Z M5.817,36.087 L7.019,37.687 L12.771,33.367 L11.569,31.768 L5.817,36.087 Z M9.158,24.57 L2,25.477 L2.252,27.461 L9.41,26.555 L9.158,24.57 Z M10.716,17.135 L4.069,14.385 L3.306,16.232 L9.952,18.982 L10.716,17.135 Z M11.479,5.789 L9.893,7.008 L14.246,12.678 L15.832,11.459 L11.479,5.789 Z M21.146,9.32 L20.252,2.252 L22.236,2 L23.131,9.068 L21.146,9.32 Z" id="Amazon-EventBridge-Saas-Partner-Event_48" fill="#E7157B"></path>
    </g>
</svg>`, tM = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Application-Integration/Res_Amazon-EventBridge_Schema_48</title>
    <g id="Icon-Resource/Application-Integration/Res_Amazon-EventBridge_Schema_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M19,27.25 L19,21.476 L24,18.589 L29,21.476 L29,27.25 L24,30.136 L19,27.25 Z M24,32.291 C24.173,32.291 24.346,32.247 24.5,32.157 L30.5,28.693 C30.81,28.515 31,28.185 31,27.827 L31,20.899 C31,20.542 30.81,20.211 30.5,20.033 L24.5,16.568 C24.191,16.39 23.809,16.39 23.5,16.568 L17.5,20.033 C17.19,20.211 17,20.542 17,20.899 L17,27.827 C17,28.185 17.19,28.515 17.5,28.693 L23.5,32.157 C23.654,32.247 23.827,32.291 24,32.291 L24,32.291 Z M32.707,17.707 L31.293,16.293 L37.293,10.293 L38.707,11.707 L32.707,17.707 Z M15.293,31.293 L16.707,32.707 L10.707,38.707 L9.293,37.293 L15.293,31.293 Z M16.293,17.707 L10.293,11.707 L11.707,10.293 L17.707,16.293 L16.293,17.707 Z M32.707,31.293 L38.707,37.293 L37.293,38.707 L31.293,32.707 L32.707,31.293 Z M34,26 L40,26 L40,24 L34,24 L34,26 Z M8,26 L14,26 L14,24 L8,24 L8,26 Z M23,13 L25,13 L25,7 L23,7 L23,13 Z M23,41 L25,41 L25,36 L23,36 L23,41 Z M4,44 L44,44 L44,4 L4,4 L4,44 Z M46,3 C46,2.448 45.553,2 45,2 L3,2 C2.447,2 2,2.448 2,3 L2,45 C2,45.552 2.447,46 3,46 L45,46 C45.553,46 46,45.552 46,45 L46,3 Z" id="Fill-4" fill="#E7157B"></path>
    </g>
</svg>`, nM = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Application-Integration/Res_Amazon-MQ_Broker_48</title>
    <g id="Icon-Resource/Application-Integration/Res_Amazon-MQ_Broker_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M7.078,33.754875 C6.463,32.704875 5.947,31.589875 5.544,30.441875 L7.431,29.778875 C7.792,30.806875 8.254,31.803875 8.805,32.743875 L7.078,33.754875 Z M7.114,19.441875 L5.19,18.896875 C5.62,17.379875 6.238,15.917875 7.029,14.550875 L8.76,15.551875 C8.053,16.775875 7.499,18.083875 7.114,19.441875 L7.114,19.441875 Z M16.586,8.48487502 L15.767,6.66087502 C20.696,4.44687502 26.476,4.44587502 31.409,6.66087502 L30.591,8.48487502 C26.175,6.50387502 20.996,6.50487502 16.586,8.48487502 L16.586,8.48487502 Z M38.417,15.551875 L40.147,14.550875 C40.939,15.918875 41.557,17.380875 41.985,18.896875 L40.061,19.440875 C39.678,18.084875 39.125,16.775875 38.417,15.551875 L38.417,15.551875 Z M39.745,29.778875 L41.632,30.441875 C41.241,31.555875 40.741,32.641875 40.148,33.669875 L38.416,32.668875 C38.948,31.748875 39.394,30.776875 39.745,29.778875 L39.745,29.778875 Z M30.591,39.734875 L31.409,41.559875 C28.943,42.666875 26.311,43.227875 23.588,43.227875 C20.863,43.227875 18.232,42.666875 15.767,41.559875 L16.586,39.734875 C20.997,41.715875 26.176,41.715875 30.591,39.734875 L30.591,39.734875 Z M11.5,40.109875 C10.121,40.109875 9,38.988875 9,37.609875 C9,36.231875 10.121,35.109875 11.5,35.109875 C12.879,35.109875 14,36.231875 14,37.609875 C14,38.988875 12.879,40.109875 11.5,40.109875 L11.5,40.109875 Z M11.5,33.109875 C9.018,33.109875 7,35.128875 7,37.609875 C7,40.091875 9.018,42.109875 11.5,42.109875 C13.981,42.109875 16,40.091875 16,37.609875 C16,35.128875 13.981,33.109875 11.5,33.109875 L11.5,33.109875 Z M35.5,40.109875 C34.121,40.109875 33,38.988875 33,37.609875 C33,36.231875 34.121,35.109875 35.5,35.109875 C36.879,35.109875 38,36.231875 38,37.609875 C38,38.988875 36.879,40.109875 35.5,40.109875 L35.5,40.109875 Z M35.5,33.109875 C33.018,33.109875 31,35.128875 31,37.609875 C31,40.091875 33.018,42.109875 35.5,42.109875 C37.981,42.109875 40,40.091875 40,37.609875 C40,35.128875 37.981,33.109875 35.5,33.109875 L35.5,33.109875 Z M4,24.609875 C4,23.231875 5.121,22.109875 6.5,22.109875 C7.879,22.109875 9,23.231875 9,24.609875 C9,25.988875 7.879,27.109875 6.5,27.109875 C5.121,27.109875 4,25.988875 4,24.609875 L4,24.609875 Z M10.949,25.109875 L14.136,25.109875 L13.169,26.553875 L14.831,27.666875 L16.831,24.680875 C17.056,24.344875 17.057,23.906875 16.833,23.570875 L14.833,20.557875 L13.167,21.662875 L14.127,23.109875 L10.724,23.109875 C10.102,21.367875 8.453,20.109875 6.5,20.109875 C4.018,20.109875 2,22.128875 2,24.609875 C2,27.091875 4.018,29.109875 6.5,29.109875 C8.81,29.109875 10.697,27.353875 10.949,25.109875 L10.949,25.109875 Z M41.5,27.109875 C40.121,27.109875 39,25.988875 39,24.609875 C39,23.231875 40.121,22.109875 41.5,22.109875 C42.879,22.109875 44,23.231875 44,24.609875 C44,25.988875 42.879,27.109875 41.5,27.109875 L41.5,27.109875 Z M41.5,20.109875 C39.018,20.109875 37,22.128875 37,24.609875 C37,27.091875 39.018,29.109875 41.5,29.109875 C43.981,29.109875 46,27.091875 46,24.609875 C46,22.128875 43.981,20.109875 41.5,20.109875 L41.5,20.109875 Z M11.5,8.10987502 C12.879,8.10987502 14,9.23187502 14,10.609875 C14,11.988875 12.879,13.109875 11.5,13.109875 C10.121,13.109875 9,11.988875 9,10.609875 C9,9.23187502 10.121,8.10987502 11.5,8.10987502 L11.5,8.10987502 Z M11.5,15.109875 C13.981,15.109875 16,13.091875 16,10.609875 C16,8.12887502 13.981,6.10987502 11.5,6.10987502 C9.018,6.10987502 7,8.12887502 7,10.609875 C7,13.091875 9.018,15.109875 11.5,15.109875 L11.5,15.109875 Z M35.5,8.10987502 C36.879,8.10987502 38,9.23187502 38,10.609875 C38,11.988875 36.879,13.109875 35.5,13.109875 C34.121,13.109875 33,11.988875 33,10.609875 C33,9.23187502 34.121,8.10987502 35.5,8.10987502 L35.5,8.10987502 Z M35.5,15.109875 C37.981,15.109875 40,13.091875 40,10.609875 C40,8.12887502 37.981,6.10987502 35.5,6.10987502 C33.018,6.10987502 31,8.12887502 31,10.609875 C31,13.091875 33.018,15.109875 35.5,15.109875 L35.5,15.109875 Z M32.168,26.555875 L33.131,25.110875 L31,25.110875 L31,23.110875 L33.132,23.110875 L32.168,21.664875 L33.832,20.555875 L35.832,23.554875 C36.056,23.890875 36.056,24.327875 35.832,24.663875 L33.832,27.664875 L32.168,26.555875 Z M28.191,28.314875 C26.881,27.873875 25.441,27.652875 24.002,27.652875 C22.562,27.652875 21.123,27.873875 19.812,28.314875 C20.248,27.040875 20.48,25.612875 20.48,24.109875 C20.48,22.608875 20.248,21.179875 19.812,19.905875 C22.433,20.788875 25.57,20.788875 28.191,19.905875 C27.756,21.179875 27.523,22.608875 27.523,24.109875 C27.523,25.612875 27.756,27.040875 28.191,28.314875 L28.191,28.314875 Z M31.716,17.810875 C31.911,17.615875 32.009,17.359875 32.009,17.103875 C32.009,16.847875 31.911,16.591875 31.716,16.396875 C31.325,16.005875 30.692,16.005875 30.302,16.396875 C27.358,19.339875 20.645,19.339875 17.702,16.396875 C17.311,16.005875 16.679,16.005875 16.288,16.396875 C16.093,16.591875 15.995,16.847875 15.995,17.103875 C15.995,17.359875 16.093,17.615875 16.288,17.810875 C17.661,19.183875 18.48,21.538875 18.48,24.109875 C18.48,26.681875 17.661,29.036875 16.288,30.409875 C16.093,30.605875 15.995,30.860875 15.995,31.116875 C15.995,31.372875 16.093,31.628875 16.288,31.823875 C16.679,32.214875 17.311,32.214875 17.702,31.823875 C20.645,28.880875 27.358,28.880875 30.302,31.823875 C30.497,32.019875 30.753,32.116875 31.009,32.116875 C31.265,32.116875 31.52,32.019875 31.716,31.823875 C31.911,31.628875 32.009,31.372875 32.009,31.116875 C32.009,30.860875 31.911,30.605875 31.716,30.409875 C30.343,29.036875 29.523,26.681875 29.523,24.109875 C29.523,21.538875 30.343,19.183875 31.716,17.810875 L31.716,17.810875 Z" id="Fill-1" fill="#E7157B"></path>
    </g>
</svg>`, iM = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Application-Integration/Res_Amazon-EventBridge_Schema-Registry_48</title>
    <g id="Icon-Resource/Application-Integration/Res_Amazon-EventBridge_Schema-Registry_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M38,35.943 L34.5,37.964 L31,35.943 L31,31.901 L34.5,29.881 L38,31.901 L38,35.943 Z M39.5,30.458 L35,27.86 C34.691,27.681 34.309,27.681 34,27.86 L29.5,30.458 C29.19,30.637 29,30.967 29,31.324 L29,36.52 C29,36.878 29.19,37.208 29.5,37.386 L34,39.985 C34.154,40.074 34.327,40.118 34.5,40.118 C34.673,40.118 34.846,40.074 35,39.985 L39.5,37.386 C39.81,37.208 40,36.878 40,36.52 L40,31.324 C40,30.967 39.81,30.637 39.5,30.458 L39.5,30.458 Z M17,35.943 L13.5,37.964 L10,35.943 L10,31.901 L13.5,29.881 L17,31.901 L17,35.943 Z M18.5,30.458 L14,27.86 C13.691,27.681 13.309,27.681 13,27.86 L8.5,30.458 C8.19,30.637 8,30.967 8,31.324 L8,36.52 C8,36.878 8.19,37.208 8.5,37.386 L13,39.985 C13.154,40.074 13.327,40.118 13.5,40.118 C13.673,40.118 13.846,40.074 14,39.985 L18.5,37.386 C18.81,37.208 19,36.878 19,36.52 L19,31.324 C19,30.967 18.81,30.637 18.5,30.458 L18.5,30.458 Z M31,10.901 L34.5,8.881 L38,10.901 L38,14.943 L34.5,16.964 L31,14.943 L31,10.901 Z M29.5,16.386 L34,18.985 C34.154,19.074 34.327,19.118 34.5,19.118 C34.673,19.118 34.846,19.074 35,18.985 L39.5,16.386 C39.81,16.208 40,15.878 40,15.52 L40,10.324 C40,9.967 39.81,9.637 39.5,9.458 L35,6.86 C34.691,6.681 34.309,6.681 34,6.86 L29.5,9.458 C29.19,9.637 29,9.967 29,10.324 L29,15.52 C29,15.878 29.19,16.208 29.5,16.386 L29.5,16.386 Z M10,10.901 L13.5,8.881 L17,10.901 L17,14.943 L13.5,16.964 L10,14.943 L10,10.901 Z M8.5,16.386 L13,18.985 C13.154,19.074 13.327,19.118 13.5,19.118 C13.673,19.118 13.846,19.074 14,18.985 L18.5,16.386 C18.81,16.208 19,15.878 19,15.52 L19,10.324 C19,9.967 18.81,9.637 18.5,9.458 L14,6.86 C13.691,6.681 13.309,6.681 13,6.86 L8.5,9.458 C8.19,9.637 8,9.967 8,10.324 L8,15.52 C8,15.878 8.19,16.208 8.5,16.386 L8.5,16.386 Z M25,44 L44,44 L44,25 L25,25 L25,44 Z M4,44 L23,44 L23,25 L4,25 L4,44 Z M4,23 L23,23 L23,4 L4,4 L4,23 Z M25,23 L44,23 L44,4 L25,4 L25,23 Z M45,2 L3,2 C2.447,2 2,2.447 2,3 L2,45 C2,45.552 2.447,46 3,46 L45,46 C45.553,46 46,45.552 46,45 L46,3 C46,2.447 45.553,2 45,2 L45,2 Z" id="Fill-1" fill="#E7157B"></path>
    </g>
</svg>`, sM = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Application-Integration/Res_Amazon-EventBridge_Default-Event-Bus_48</title>
    <g id="Icon-Resource/Application-Integration/Res_Amazon-EventBridge_Default-Event-Bus_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M11.001,39.001 L37.001,39.001 L37.001,37.001 L11.001,37.001 L11.001,39.001 Z M35.88,12.009 L34.153,10.998 L30.544,17.16 L32.271,18.17 L35.88,12.009 Z M42.567,18.594 L36.323,22.147 L37.312,23.885 L43.556,20.332 L42.567,18.594 Z M39.002,28.995 L39,30.995 L46,31.001 L46.002,29.001 L39.002,28.995 Z M2,31.001 L9,31.007 L9.002,29.007 L2.002,29.001 L2,31.001 Z M5.454,18.562 L4.462,20.298 L10.701,23.863 L11.693,22.126 L5.454,18.562 Z M17.48,17.148 L13.882,10.981 L12.153,11.989 L15.751,18.156 L17.48,17.148 Z M25.001,9.002 L23.001,9 L22.994,16 L24.994,16.002 L25.001,9.002 Z M13.095,27.196 L18.114,18.501 C18.293,18.192 18.623,18.001 18.981,18.001 L29.021,18.001 C29.378,18.001 29.708,18.192 29.887,18.501 L34.907,27.196 C35.086,27.505 35.086,27.886 34.907,28.196 L31.071,34.838 L29.339,33.838 L32.887,27.696 L28.443,20.001 L19.558,20.001 L15.115,27.696 L18.662,33.838 L16.93,34.838 L13.095,28.196 C12.916,27.886 12.916,27.505 13.095,27.196 L13.095,27.196 Z" id="Amazon-EventBridge_Default-Event-Bus_Resource-Icon_dark-bg" fill="#E7157B"></path>
    </g>
</svg>`, rM = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Application-Integration/Res_Amazon-Simple-Notification-Service_Email-Notification_48</title>
    <g id="Icon-Resource/Application-Integration/Res_Amazon-Simple-Notification-Service_Email-Notification_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M28.194,17 L28.194,11.109 L27.251,11.109 L25.355,14.722 L23.451,11.109 L22.482,11.109 L22.482,17 L23.281,17 L23.281,12.359 L24.947,15.495 L25.738,15.495 L27.395,12.367 L27.395,17 L28.194,17 Z M30.633,14.781 L32.614,14.781 L31.62,11.892 L30.633,14.781 Z M30.413,15.436 L29.885,17 L28.993,17 L31.169,11.109 L32.104,11.109 L34.28,17 L33.379,17 L32.835,15.436 L30.413,15.436 Z M21.378,11.807 L21.378,11.109 L17.714,11.109 L17.714,17 L21.378,17 L21.378,16.303 L18.581,16.303 L18.581,14.314 L20.926,14.314 L20.926,13.617 L18.581,13.617 L18.581,11.807 L21.378,11.807 Z M35.113,17 L35.98,17 L35.98,11.109 L35.113,11.109 L35.113,17 Z M37.442,11.109 L37.442,17 L41.089,17 L41.089,16.286 L38.309,16.286 L38.309,11.109 L37.442,11.109 Z M4,8 C4,10.206 5.794,12 8,12 C10.206,12 12,10.206 12,8 C12,5.794 10.206,4 8,4 C5.794,4 4,5.794 4,8 L4,8 Z M2,8 C2,4.691 4.691,2 8,2 C11.308,2 14,4.691 14,8 C14,11.309 11.308,14 8,14 C4.691,14 2,11.309 2,8 L2,8 Z M44,41.5 L46,41.5 L46,39.5 L44,39.5 L44,41.5 Z M45,35 L43.5,35 L43.5,37 L44,37 L44,37.5 L46,37.5 L46,36 C46,35.447 45.552,35 45,35 L45,35 Z M31.5,37 L34.5,37 L34.5,35 L31.5,35 L31.5,37 Z M25.5,37 L28.5,37 L28.5,35 L25.5,35 L25.5,37 Z M37.5,37 L40.5,37 L40.5,35 L37.5,35 L37.5,37 Z M13.5,37 L16.5,37 L16.5,35 L13.5,35 L13.5,37 Z M19.5,37 L22.5,37 L22.5,35 L19.5,35 L19.5,37 Z M7.5,37 L10.5,37 L10.5,35 L7.5,35 L7.5,37 Z M2,36 L2,37.5 L4,37.5 L4,37 L4.5,37 L4.5,35 L3,35 C2.447,35 2,35.447 2,36 L2,36 Z M2,41.5 L4,41.5 L4,39.5 L2,39.5 L2,41.5 Z M4,43.5 L2,43.5 L2,45 C2,45.553 2.447,46 3,46 L4.5,46 L4.5,44 L4,44 L4,43.5 Z M37.5,46 L40.5,46 L40.5,44 L37.5,44 L37.5,46 Z M25.5,46 L28.5,46 L28.5,44 L25.5,44 L25.5,46 Z M13.5,46 L16.5,46 L16.5,44 L13.5,44 L13.5,46 Z M7.5,46 L10.5,46 L10.5,44 L7.5,44 L7.5,46 Z M31.5,46 L34.5,46 L34.5,44 L31.5,44 L31.5,46 Z M19.5,46 L22.5,46 L22.5,44 L19.5,44 L19.5,46 Z M44,44 L43.5,44 L43.5,46 L45,46 C45.552,46 46,45.553 46,45 L46,43.5 L44,43.5 L44,44 Z M44,28.5 L46,28.5 L46,26.5 L44,26.5 L44,28.5 Z M45,22 L43.5,22 L43.5,24 L44,24 L44,24.5 L46,24.5 L46,23 C46,22.447 45.552,22 45,22 L45,22 Z M31.5,24 L34.5,24 L34.5,22 L31.5,22 L31.5,24 Z M19.5,24 L22.5,24 L22.5,22 L19.5,22 L19.5,24 Z M7.5,24 L10.5,24 L10.5,22 L7.5,22 L7.5,24 Z M25.5,24 L28.5,24 L28.5,22 L25.5,22 L25.5,24 Z M13.5,24 L16.5,24 L16.5,22 L13.5,22 L13.5,24 Z M37.5,24 L40.5,24 L40.5,22 L37.5,22 L37.5,24 Z M2,23 L2,24.5 L4,24.5 L4,24 L4.5,24 L4.5,22 L3,22 C2.447,22 2,22.447 2,23 L2,23 Z M2,28.5 L4,28.5 L4,26.5 L2,26.5 L2,28.5 Z M4,30.5 L2,30.5 L2,32 C2,32.553 2.447,33 3,33 L4.5,33 L4.5,31 L4,31 L4,30.5 Z M7.5,33 L10.5,33 L10.5,31 L7.5,31 L7.5,33 Z M19.5,33 L22.5,33 L22.5,31 L19.5,31 L19.5,33 Z M13.5,33 L16.5,33 L16.5,31 L13.5,31 L13.5,33 Z M37.5,33 L40.5,33 L40.5,31 L37.5,31 L37.5,33 Z M31.5,33 L34.5,33 L34.5,31 L31.5,31 L31.5,33 Z M25.5,33 L28.5,33 L28.5,31 L25.5,31 L25.5,33 Z M44,31 L43.5,31 L43.5,33 L45,33 C45.552,33 46,32.553 46,32 L46,30.5 L44,30.5 L44,31 Z M46,9 L46,19 C46,19.553 45.552,20 45,20 L3,20 C2.447,20 2,19.553 2,19 L2,15 L4,15 L4,18 L44,18 L44,10 L16,10 L16,8 L45,8 C45.552,8 46,8.447 46,9 L46,9 Z" id="Amazon-Simple-Notification-Service_Email-notification_Resource-Icon_light-bg" fill="#E7157B"></path>
    </g>
</svg>`, oM = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Application-Integration/Res_Amazon-EventBridge-Event_48</title>
    <g id="Icon-Resource/Application-Integration/Res_Amazon-EventBridge-Event_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M30.58,10.58 L28.74,9.795 L31.538,3.237 L33.378,4.022 L30.58,10.58 Z M36.295,15.605 L35.094,14.006 L40.831,9.698 L42.032,11.298 L36.295,15.605 Z M38.447,20.802 L45.587,19.898 L45.839,21.883 L38.699,22.786 L38.447,20.802 Z M37.907,28.354 L44.538,31.098 L43.773,32.945 L37.143,30.202 L37.907,28.354 Z M33.625,34.644 L37.968,40.3 L36.382,41.518 L32.039,35.863 L33.625,34.644 Z M26.743,37.995 L27.635,45.046 L25.65,45.296 L24.759,38.245 L26.743,37.995 Z M17.259,36.716 L19.099,37.501 L16.301,44.059 L14.461,43.274 L17.259,36.716 Z M11.544,31.69 L12.745,33.29 L7.008,37.598 L5.807,35.998 L11.544,31.69 Z M9.392,26.494 L2.252,27.398 L2,25.414 L9.14,24.51 L9.392,26.494 Z M9.932,18.941 L3.302,16.198 L4.065,14.351 L10.696,17.094 L9.932,18.941 Z M14.214,12.651 L9.871,6.997 L11.457,5.778 L15.8,11.433 L14.214,12.651 Z M21.096,9.301 L20.204,2.25 L22.188,2 L23.08,9.051 L21.096,9.301 Z M28.039,30.999 L19.379,30.999 L15.048,23.499 L19.379,15.999 L28.039,15.999 L32.369,23.499 L28.039,30.999 Z M34.39,22.999 L29.482,14.499 C29.304,14.189 28.974,13.999 28.616,13.999 L18.802,13.999 C18.444,13.999 18.114,14.189 17.935,14.499 L13.027,22.999 C12.849,23.309 12.849,23.689 13.027,23.999 L17.935,32.499 C18.114,32.809 18.444,32.999 18.802,32.999 L28.616,32.999 C28.974,32.999 29.304,32.809 29.482,32.499 L34.39,23.999 C34.568,23.689 34.568,23.309 34.39,22.999 L34.39,22.999 Z" id="Icon-Resource/48/Amazon-EventBridge-Event" fill="#E7157B"></path>
    </g>
</svg>`, lM = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Application-Integration/Res_Amazon-Simple-Notification-Service_HTTP-Notification_48</title>
    <g id="Icon-Resource/Application-Integration/Res_Amazon-Simple-Notification-Service_HTTP-Notification_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M17.715,11.11 L17.715,17.001 L18.582,17.001 L18.582,14.34 L21.524,14.34 L21.524,17.001 L22.39,17.001 L22.39,11.11 L21.524,11.11 L21.524,13.643 L18.582,13.643 L18.582,11.11 L17.715,11.11 Z M31.111,17.001 L31.111,11.823 L32.989,11.823 L32.989,11.11 L28.365,11.11 L28.365,11.823 L30.243,11.823 L30.243,17.001 L31.111,17.001 Z M34.672,14.034 L35.888,14.034 C36.244,14.034 36.514,13.938 36.694,13.749 C36.876,13.559 36.967,13.282 36.967,12.921 C36.967,12.172 36.607,11.797 35.888,11.797 L34.672,11.797 L34.672,14.034 Z M34.672,14.721 L34.672,17.001 L33.83,17.001 L33.83,11.11 L35.964,11.11 C36.536,11.11 36.992,11.272 37.332,11.598 C37.672,11.924 37.842,12.364 37.842,12.921 C37.842,13.469 37.672,13.907 37.332,14.233 C36.992,14.559 36.536,14.721 35.964,14.721 L34.672,14.721 Z M25.977,17.001 L25.977,11.823 L27.856,11.823 L27.856,11.11 L23.232,11.11 L23.232,11.823 L25.11,11.823 L25.11,17.001 L25.977,17.001 Z M4,8 C4,10.206 5.794,12 8,12 C10.206,12 12,10.206 12,8 C12,5.794 10.206,4 8,4 C5.794,4 4,5.794 4,8 L4,8 Z M2,8 C2,4.691 4.692,2 8,2 C11.309,2 14,4.691 14,8 C14,11.308 11.309,14 8,14 C4.692,14 2,11.308 2,8 L2,8 Z M44,41.5 L46,41.5 L46,39.5 L44,39.5 L44,41.5 Z M45,35 L43.5,35 L43.5,37 L44,37 L44,37.5 L46,37.5 L46,36 C46,35.447 45.553,35 45,35 L45,35 Z M19.5,37 L22.5,37 L22.5,35 L19.5,35 L19.5,37 Z M25.5,37 L28.5,37 L28.5,35 L25.5,35 L25.5,37 Z M13.5,37 L16.5,37 L16.5,35 L13.5,35 L13.5,37 Z M31.5,37 L34.5,37 L34.5,35 L31.5,35 L31.5,37 Z M37.5,37 L40.5,37 L40.5,35 L37.5,35 L37.5,37 Z M7.5,37 L10.5,37 L10.5,35 L7.5,35 L7.5,37 Z M2,36 L2,37.5 L4,37.5 L4,37 L4.5,37 L4.5,35 L3,35 C2.447,35 2,35.447 2,36 L2,36 Z M2,41.5 L4,41.5 L4,39.5 L2,39.5 L2,41.5 Z M4,43.5 L2,43.5 L2,45 C2,45.552 2.447,46 3,46 L4.5,46 L4.5,44 L4,44 L4,43.5 Z M25.5,46 L28.5,46 L28.5,44 L25.5,44 L25.5,46 Z M7.5,46 L10.5,46 L10.5,44 L7.5,44 L7.5,46 Z M31.5,46 L34.5,46 L34.5,44 L31.5,44 L31.5,46 Z M37.5,46 L40.5,46 L40.5,44 L37.5,44 L37.5,46 Z M13.5,46 L16.5,46 L16.5,44 L13.5,44 L13.5,46 Z M19.5,46 L22.5,46 L22.5,44 L19.5,44 L19.5,46 Z M44,44 L43.5,44 L43.5,46 L45,46 C45.553,46 46,45.552 46,45 L46,43.5 L44,43.5 L44,44 Z M44,28.5 L46,28.5 L46,26.5 L44,26.5 L44,28.5 Z M45,22 L43.5,22 L43.5,24 L44,24 L44,24.5 L46,24.5 L46,23 C46,22.447 45.553,22 45,22 L45,22 Z M37.5,24 L40.5,24 L40.5,22 L37.5,22 L37.5,24 Z M31.5,24 L34.5,24 L34.5,22 L31.5,22 L31.5,24 Z M25.5,24 L28.5,24 L28.5,22 L25.5,22 L25.5,24 Z M19.5,24 L22.5,24 L22.5,22 L19.5,22 L19.5,24 Z M13.5,24 L16.5,24 L16.5,22 L13.5,22 L13.5,24 Z M7.5,24 L10.5,24 L10.5,22 L7.5,22 L7.5,24 Z M2,23 L2,24.5 L4,24.5 L4,24 L4.5,24 L4.5,22 L3,22 C2.447,22 2,22.447 2,23 L2,23 Z M2,28.5 L4,28.5 L4,26.5 L2,26.5 L2,28.5 Z M4,30.5 L2,30.5 L2,32 C2,32.552 2.447,33 3,33 L4.5,33 L4.5,31 L4,31 L4,30.5 Z M7.5,33 L10.5,33 L10.5,31 L7.5,31 L7.5,33 Z M31.5,33 L34.5,33 L34.5,31 L31.5,31 L31.5,33 Z M37.5,33 L40.5,33 L40.5,31 L37.5,31 L37.5,33 Z M25.5,33 L28.5,33 L28.5,31 L25.5,31 L25.5,33 Z M13.5,33 L16.5,33 L16.5,31 L13.5,31 L13.5,33 Z M19.5,33 L22.5,33 L22.5,31 L19.5,31 L19.5,33 Z M44,31 L43.5,31 L43.5,33 L45,33 C45.553,33 46,32.552 46,32 L46,30.5 L44,30.5 L44,31 Z M46,9 L46,19 C46,19.552 45.553,20 45,20 L3,20 C2.447,20 2,19.552 2,19 L2,15 L4,15 L4,18 L44,18 L44,10 L16,10 L16,8 L45,8 C45.553,8 46,8.447 46,9 L46,9 Z" id="Amazon-Simple-Notification-Service_HTTP-notification_Resource-Icon_light-bg" fill="#E7157B"></path>
    </g>
</svg>`, LM = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Application-Integration/Res_Amazon-EventBridge_Pipes_48</title>
    <g id="Icon-Resource/Application-Integration/Res_Amazon-EventBridge_Pipes_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M18.033,37 L26.033,37 L26.033,39 L18.033,39 C13.622,39 10.033,35.411 10.033,31 C10.033,26.589 13.622,23 18.033,23 L30.033,23 C33.342,23 36.033,20.309 36.033,17 C36.033,13.691 33.342,11 30.033,11 L22.033,11 L22.033,9 L30.033,9 C34.444,9 38.033,12.589 38.033,17 C38.033,21.411 34.444,25 30.033,25 L18.033,25 C14.724,25 12.033,27.691 12.033,31 C12.033,34.309 14.724,37 18.033,37 L18.033,37 Z M40.42,44 L33.58,44 L30.151,38 L33.58,32 L40.42,32 L43.848,38 L40.42,44 Z M45.868,37.504 L41.868,30.504 C41.69,30.192 41.358,30 41,30 L33,30 C32.641,30 32.309,30.192 32.132,30.504 L28.132,37.504 C27.956,37.812 27.956,38.188 28.132,38.496 L32.132,45.496 C32.309,45.808 32.641,46 33,46 L41,46 C41.358,46 41.69,45.808 41.868,45.496 L45.868,38.496 C46.044,38.188 46.044,37.812 45.868,37.504 L45.868,37.504 Z M7.58,16 L4.151,10 L7.58,4 L14.42,4 L17.848,10 L14.42,16 L7.58,16 Z M15.868,17.496 L19.868,10.496 C20.044,10.188 20.044,9.812 19.868,9.504 L15.868,2.504 C15.69,2.192 15.358,2 15,2 L7,2 C6.641,2 6.309,2.192 6.132,2.504 L2.132,9.504 C1.956,9.812 1.956,10.188 2.132,10.496 L6.132,17.496 C6.309,17.808 6.641,18 7,18 L15,18 C15.358,18 15.69,17.808 15.868,17.496 L15.868,17.496 Z" id="Fill-1" fill="#E7157B"></path>
    </g>
</svg>`, aM = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Application-Integration/Res_Amazon-EventBridge_Rule_48</title>
    <g id="Icon-Resource/Application-Integration/Res_Amazon-EventBridge_Rule_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M23.8532,36.592 L24.6372,42.78 L22.6522,43.032 L21.8692,36.844 L23.8532,36.592 Z M15.2952,35.437 L17.1352,36.223 L14.6792,41.978 L12.8402,41.193 L15.2952,35.437 Z M29.8692,33.593 L33.6802,38.556 L32.0952,39.774 L28.2832,34.812 L29.8692,33.593 Z M10.3182,30.977 L11.5192,32.576 L6.4842,36.357 L5.2832,34.758 L10.3182,30.977 Z M25.7212,15.768 C26.0782,15.768 26.4082,15.958 26.5872,16.268 L28.0962,18.884 L26.3642,19.884 L25.1432,17.768 L17.4542,17.768 L13.6092,24.427 L17.4542,31.086 L25.1432,31.086 L27.1422,27.623 L28.8752,28.623 L26.5872,32.586 C26.4082,32.895 26.0782,33.086 25.7212,33.086 L16.8772,33.086 C16.5192,33.086 16.1892,32.895 16.0112,32.586 L11.5892,24.927 C11.4102,24.617 11.4102,24.236 11.5892,23.927 L16.0112,16.268 C16.1892,15.958 16.5192,15.768 16.8772,15.768 L25.7212,15.768 Z M39.6072,17.275 L45.5412,23.209 C45.9312,23.6 45.9312,24.232 45.5412,24.623 L39.6072,30.557 L38.1932,29.143 L42.4202,24.916 L20.7122,24.916 L20.7122,22.916 L42.4202,22.916 L38.1932,18.689 L39.6072,17.275 Z M8.2662,24.651 L8.5182,26.636 L2.2522,27.429 L2.0002,25.444 L8.2662,24.651 Z M3.8772,15.743 L9.6942,18.151 L8.9292,19.999 L3.1112,17.591 L3.8772,15.743 Z M36.0222,11.675 L37.2232,13.274 L32.1882,17.056 L30.9872,15.456 L36.0222,11.675 Z M10.4132,8.258 L14.2242,13.221 L12.6382,14.439 L8.8272,9.477 L10.4132,8.258 Z M27.8272,6.054 L29.6672,6.839 L27.2122,12.595 L25.3722,11.81 L27.8272,6.054 Z M19.8552,5 L20.6382,11.188 L18.6542,11.44 L17.8712,5.252 L19.8552,5 Z" id="Amazon-EventBridge-Rule" fill="#E7157B"></path>
    </g>
</svg>`, CM = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Application-Integration/Res_Amazon-API-Gateway_Endpoint_48</title>
    <g id="Icon-Resource/Application-Integration/Res_Amazon-API-Gateway_Endpoint_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M25.909,24.955 L27.817,24.955 L27.817,23.046 L25.909,23.046 L25.909,24.955 Z M23.045,24.955 L24.954,24.955 L24.954,23.046 L23.045,23.046 L23.045,24.955 Z M20.182,24.955 L22.091,24.955 L22.091,23.046 L20.182,23.046 L20.182,24.955 Z M37.318,31.003 L30.728,36.802 L30.728,11.332 L37.318,17.13 L37.318,31.003 Z M30.944,8.926 C30.74,8.839 29.856,8.579 29.242,8.92 L28.728,9.205 L28.728,38.929 L29.242,39.214 C29.471,39.341 29.737,39.385 29.993,39.385 C30.421,39.385 30.816,39.263 30.944,39.208 L31.092,39.146 L38.565,32.569 C39.028,32.299 39.318,31.813 39.318,31.284 L39.318,16.849 C39.318,16.321 39.029,15.835 38.566,15.564 L31.092,8.988 L30.944,8.926 Z M17.273,36.803 L10.682,31.004 L10.682,17.129 L17.273,11.331 L17.273,36.803 Z M17.055,8.926 L16.907,8.988 L9.432,15.565 C8.971,15.836 8.682,16.321 8.682,16.849 L8.682,31.284 C8.682,31.812 8.971,32.299 9.433,32.568 L16.907,39.146 L17.055,39.208 C17.182,39.263 17.578,39.385 18.006,39.385 C18.261,39.385 18.527,39.341 18.756,39.215 L19.273,38.93 L19.273,9.204 L18.756,8.919 C18.144,8.582 17.258,8.839 17.055,8.926 L17.055,8.926 Z M44,32.284 L32.284,44 L15.715,44 L4,32.284 L4,15.716 L15.715,4 L32.284,4 L44,15.716 L44,32.284 Z M33.112,2 L14.887,2 L2,14.888 L2,33.112 L14.887,46 L33.112,46 L46,33.112 L46,14.888 L33.112,2 Z" id="AWS-Amazon-API-Gateway_Endpoint_Resource-Icon_light-bg" fill="#E7157B"></path>
    </g>
</svg>`, cM = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Application-Integration/Res_Amazon-EventBridge_Scheduler_48</title>
    <g id="Icon-Resource/Application-Integration/Res_Amazon-EventBridge_Scheduler_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M15,16 L18.92,16 L18.92,14 L15.92,14 L15.92,11 L14,11 L14,15 C14,15.552 14.447,16 15,16 L15,16 Z M5.293,24.293 L6.707,25.707 L9.707,22.707 L8.293,21.293 L5.293,24.293 Z M8.707,8.293 L5.707,5.293 L4.293,6.707 L7.293,9.707 L8.707,8.293 Z M15.92,6 L16,6 L16,2 L15.92,2 L14,2 L14,6 L15.92,6 Z M25.707,6.707 L24.293,5.293 L21.293,8.293 L22.707,9.707 L25.707,6.707 Z M8.92,15 C8.92,18.309 11.611,21 14.92,21 C18.229,21 20.92,18.309 20.92,15 C20.92,11.691 18.229,9 14.92,9 C11.611,9 8.92,11.691 8.92,15 L8.92,15 Z M6.92,15 C6.92,10.589 10.509,7 14.92,7 C19.331,7 22.92,10.589 22.92,15 C22.92,19.411 19.331,23 14.92,23 C10.509,23 6.92,19.411 6.92,15 L6.92,15 Z M18,38 L22,38 L22,36 L18,36 L18,38 Z M18,33 L22,33 L22,31 L18,31 L18,33 Z M18,28 L22,28 L22,26 L18,26 L18,28 Z M36,38 L40,38 L40,36 L36,36 L36,38 Z M36,33 L40,33 L40,31 L36,31 L36,33 Z M36,28 L40,28 L40,26 L36,26 L36,28 Z M27,38 L31,38 L31,36 L27,36 L27,38 Z M27,33 L31,33 L31,31 L27,31 L27,33 Z M27,28 L31,28 L31,26 L27,26 L27,28 Z M45,12 L42,12 L42,10 L40,10 L40,12 L35.92,12 L35.92,10 L34,10 L34,12 L29.92,12 L29.92,10 L28,10 L28,12 L25,12 L25,14 L28,14 L28,16 L29.92,16 L29.92,14 L34,14 L34,16 L35.92,16 L35.92,14 L40,14 L40,16 L41.92,16 L41.92,14 L44,14 L44,18 L25,18 L25,20 L44,20 L44,43 L14,43 L14,26 L12,26 L12,44 C12,44.552 12.447,45 13,45 L45,45 C45.553,45 46,44.552 46,44 L46,19 L46,13 C46,12.448 45.553,12 45,12 L45,12 Z M2,17 L5.976,17 L5.976,15 L2,15 L2,17 Z" id="Fill-1" fill="#E7157B"></path>
    </g>
</svg>`, Pi = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Application-Integration/Res_Amazon-Simple-Queue-Service_Queue_48</title>
    <g id="Icon-Resource/Application-Integration/Res_Amazon-Simple-Queue-Service_Queue_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M37.449,22.261 L37.449,26.221 L35.026,24.207 L37.449,22.261 Z M37.81,29.121 C37.993,29.273 38.22,29.352 38.449,29.352 C38.594,29.352 38.738,29.321 38.874,29.257 C39.224,29.092 39.449,28.74 39.449,28.352 L39.449,20.176 C39.449,19.791 39.228,19.441 38.882,19.275 C38.535,19.108 38.123,19.156 37.823,19.397 L32.819,23.414 C32.585,23.602 32.448,23.885 32.4449503,24.185 C32.442,24.486 32.575,24.771 32.806,24.963 L37.81,29.121 Z M10.527,22.307 L12.951,24.322 L10.527,26.267 L10.527,22.307 Z M9.095,29.253 C9.232,29.32 9.38,29.352 9.527,29.352 C9.751,29.352 9.972,29.277 10.153,29.132 L15.158,25.115 C15.392,24.927 15.529,24.644 15.5320497,24.344 C15.535,24.043 15.402,23.758 15.171,23.566 L10.166,19.407 C9.868,19.16 9.453,19.107 9.102,19.271 C8.752,19.436 8.527,19.788 8.527,20.176 L8.527,28.352 C8.527,28.737 8.748,29.087 9.095,29.253 L9.095,29.253 Z M28.368,34.027 L30.368,34.027 L30.368,14.747 L28.368,14.747 L28.368,34.027 Z M23.121,34.027 L25.121,34.027 L25.121,14.747 L23.121,14.747 L23.121,34.027 Z M17.711,34.027 L19.711,34.027 L19.711,14.747 L17.711,14.747 L17.711,34.027 Z M3.999,35.773 L43.977,35.773 L43.977,13.001 L3.999,13.001 L3.999,35.773 Z M44.977,11 L3,11 C2.447,11 2,11.448 2,12 L2,36.773 C2,37.325 2.447,37.773 3,37.773 L44.977,37.773 C45.53,37.773 45.977,37.325 45.977,36.773 L45.977,12 C45.977,11.448 45.53,11 44.977,11 L44.977,11 Z" id="Amazon-Simple-Notification-Service_Queue" fill="#E7157B"></path>
    </g>
</svg>`, uM = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Application-Integration/Res_Amazon-Simple-Queue-Service_Message_48</title>
    <g id="Icon-Resource/Application-Integration/Res_Amazon-Simple-Queue-Service_Message_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M36.5,4 L38.5,4 L38.5,2 L36.5,2 L36.5,4 Z M33,2 L34.5,2 L34.5,4 L34,4 L34,4.5 L32,4.5 L32,3 C32,2.448 32.447,2 33,2 L33,2 Z M32,34.5 L34,34.5 L34,31.5 L32,31.5 L32,34.5 Z M32,40.5 L34,40.5 L34,37.5 L32,37.5 L32,40.5 Z M32,28.5 L34,28.5 L34,25.5 L32,25.5 L32,28.5 Z M32,10.5 L34,10.5 L34,7.5 L32,7.5 L32,10.5 Z M32,16.5 L34,16.5 L34,13.5 L32,13.5 L32,16.5 Z M32,22.5 L34,22.5 L34,19.5 L32,19.5 L32,22.5 Z M34,44 L34.5,44 L34.5,46 L33,46 C32.447,46 32,45.553 32,45 L32,43.5 L34,43.5 L34,44 Z M36.5,46 L38.5,46 L38.5,44 L36.5,44 L36.5,46 Z M41,43.5 L43,43.5 L43,45 C43,45.553 42.553,46 42,46 L40.5,46 L40.5,44 L41,44 L41,43.5 Z M41,40.5 L43,40.5 L43,37.5 L41,37.5 L41,40.5 Z M41,34.5 L43,34.5 L43,31.5 L41,31.5 L41,34.5 Z M41,16.5 L43,16.5 L43,13.5 L41,13.5 L41,16.5 Z M41,10.5 L43,10.5 L43,7.5 L41,7.5 L41,10.5 Z M41,28.5 L43,28.5 L43,25.5 L41,25.5 L41,28.5 Z M41,22.5 L43,22.5 L43,19.5 L41,19.5 L41,22.5 Z M43,3 L43,4.5 L41,4.5 L41,4 L40.5,4 L40.5,2 L42,2 C42.553,2 43,2.448 43,3 L43,3 Z M23.5,4 L25.5,4 L25.5,2 L23.5,2 L23.5,4 Z M20,2 L21.5,2 L21.5,4 L21,4 L21,4.5 L19,4.5 L19,3 C19,2.448 19.447,2 20,2 L20,2 Z M19,10.5 L21,10.5 L21,7.5 L19,7.5 L19,10.5 Z M19,34.5 L21,34.5 L21,31.5 L19,31.5 L19,34.5 Z M19,28.5 L21,28.5 L21,25.5 L19,25.5 L19,28.5 Z M19,22.5 L21,22.5 L21,19.5 L19,19.5 L19,22.5 Z M19,40.5 L21,40.5 L21,37.5 L19,37.5 L19,40.5 Z M19,16.5 L21,16.5 L21,13.5 L19,13.5 L19,16.5 Z M21,44 L21.5,44 L21.5,46 L20,46 C19.447,46 19,45.553 19,45 L19,43.5 L21,43.5 L21,44 Z M23.5,46 L25.5,46 L25.5,44 L23.5,44 L23.5,46 Z M28,43.5 L30,43.5 L30,45 C30,45.553 29.553,46 29,46 L27.5,46 L27.5,44 L28,44 L28,43.5 Z M28,10.5 L30,10.5 L30,7.5 L28,7.5 L28,10.5 Z M28,16.5 L30,16.5 L30,13.5 L28,13.5 L28,16.5 Z M28,22.5 L30,22.5 L30,19.5 L28,19.5 L28,22.5 Z M28,40.5 L30,40.5 L30,37.5 L28,37.5 L28,40.5 Z M28,28.5 L30,28.5 L30,25.5 L28,25.5 L28,28.5 Z M28,34.5 L30,34.5 L30,31.5 L28,31.5 L28,34.5 Z M30,3 L30,4.5 L28,4.5 L28,4 L27.5,4 L27.5,2 L29,2 C29.553,2 30,2.448 30,3 L30,3 Z M7,44 L15,44 L15,4 L7,4 L7,44 Z M16,2 L6,2 C5.447,2 5,2.448 5,3 L5,45 C5,45.553 5.447,46 6,46 L16,46 C16.553,46 17,45.553 17,45 L17,3 C17,2.448 16.553,2 16,2 L16,2 Z" id="Amazon-Simple-Notification-Service_Message_48" fill="#E7157B"></path>
    </g>
</svg>`, hM = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Application-Integration/Res_Amazon-EventBridge_Custom-Event-Bus_48</title>
    <g id="Icon-Resource/Application-Integration/Res_Amazon-EventBridge_Custom-Event-Bus_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M43.717,22.782 L42.433,21.233 L41.329,22.147 L42.613,23.697 L43.717,22.782 Z M26.847,36.768 L25.563,35.22 L23.053,37.3 L22.575,39.003 L24.337,38.849 L26.847,36.768 Z M27.102,33.942 L28.387,35.492 L41.074,24.973 L39.79,23.425 L27.102,33.942 Z M45.764,23.683 L25.373,40.588 C25.216,40.718 25.024,40.797 24.821,40.814 L21.309,41.121 C21.28,41.124 21.251,41.125 21.222,41.125 C20.926,41.125 20.643,40.993 20.452,40.763 C20.242,40.511 20.17,40.171 20.259,39.855 L21.211,36.46 C21.266,36.263 21.379,36.09 21.535,35.96 L41.926,19.055 C42.131,18.886 42.396,18.806 42.657,18.829 C42.922,18.854 43.165,18.982 43.334,19.186 L45.895,22.275 C46.247,22.701 46.189,23.331 45.764,23.683 L45.764,23.683 Z M31.1,6.91 L29.26,6.125 L26.673,12.19 L28.513,12.975 L31.1,6.91 Z M39.08,13.67 L37.879,12.07 L32.572,16.054 L33.774,17.654 L39.08,13.67 Z M13.466,43.154 L15.306,43.939 L17.893,37.874 L16.053,37.089 L13.466,43.154 Z M5.486,36.394 L6.687,37.994 L11.993,34.01 L10.792,32.41 L5.486,36.394 Z M8.604,25.755 L2,26.591 L2.252,28.575 L8.856,27.739 L8.604,25.755 Z M10.081,18.901 L3.95,16.364 L3.185,18.212 L9.316,20.749 L10.081,18.901 Z M14.832,13.688 L10.817,8.459 L9.231,9.678 L13.246,14.907 L14.832,13.688 Z M21.581,11.521 L20.756,5 L18.772,5.252 L19.597,11.773 L21.581,11.521 Z M16.71,33.125 L12.003,24.972 C11.824,24.663 11.824,24.282 12.003,23.972 L16.71,15.82 C16.889,15.511 17.219,15.32 17.576,15.32 L26.989,15.32 C27.347,15.32 27.677,15.511 27.856,15.82 L32.563,23.972 L30.83,24.972 L26.412,17.32 L18.154,17.32 L14.024,24.472 L18.154,31.625 L22.033,31.625 L22.033,33.625 L17.576,33.625 C17.219,33.625 16.889,33.434 16.71,33.125 L16.71,33.125 Z" id="Amazon-EventBridge_Custom-Event-Bus_Resource-Icon_light-bg" fill="#E7157B"></path>
    </g>
</svg>`, Bi = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Application-Integration/Res_Amazon-Simple-Notification-Service_Topic_48</title>
    <g id="Icon-Resource/Application-Integration/Res_Amazon-Simple-Notification-Service_Topic_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M44,38.5 L46,38.5 L46,36.5 L44,36.5 L44,38.5 Z M46,33 L46,34.5 L44,34.5 L44,34 L43.5,34 L43.5,32 L45,32 C45.553,32 46,32.447 46,33 L46,33 Z M13.5,34 L16.5,34 L16.5,32 L13.5,32 L13.5,34 Z M37.5,34 L40.5,34 L40.5,32 L37.5,32 L37.5,34 Z M19.5,34 L22.5,34 L22.5,32 L19.5,32 L19.5,34 Z M7.5,34 L10.5,34 L10.5,32 L7.5,32 L7.5,34 Z M31.5,34 L34.5,34 L34.5,32 L31.5,32 L31.5,34 Z M25.5,34 L28.5,34 L28.5,32 L25.5,32 L25.5,34 Z M3,32 L4.5,32 L4.5,34 L4,34 L4,34.5 L2,34.5 L2,33 C2,32.447 2.447,32 3,32 L3,32 Z M2,38.5 L4,38.5 L4,36.5 L2,36.5 L2,38.5 Z M4,41 L4.5,41 L4.5,43 L3,43 C2.447,43 2,42.553 2,42 L2,40.5 L4,40.5 L4,41 Z M19.5,43 L22.5,43 L22.5,41 L19.5,41 L19.5,43 Z M31.5,43 L34.5,43 L34.5,41 L31.5,41 L31.5,43 Z M37.5,43 L40.5,43 L40.5,41 L37.5,41 L37.5,43 Z M7.5,43 L10.5,43 L10.5,41 L7.5,41 L7.5,43 Z M25.5,43 L28.5,43 L28.5,41 L25.5,41 L25.5,43 Z M13.5,43 L16.5,43 L16.5,41 L13.5,41 L13.5,43 Z M44,40.5 L46,40.5 L46,42 C46,42.553 45.553,43 45,43 L43.5,43 L43.5,41 L44,41 L44,40.5 Z M44,25.5 L46,25.5 L46,23.5 L44,23.5 L44,25.5 Z M46,20 L46,21.5 L44,21.5 L44,21 L43.5,21 L43.5,19 L45,19 C45.553,19 46,19.447 46,20 L46,20 Z M31.5,21 L34.5,21 L34.5,19 L31.5,19 L31.5,21 Z M7.5,21 L10.5,21 L10.5,19 L7.5,19 L7.5,21 Z M37.5,21 L40.5,21 L40.5,19 L37.5,19 L37.5,21 Z M13.5,21 L16.5,21 L16.5,19 L13.5,19 L13.5,21 Z M19.5,21 L22.5,21 L22.5,19 L19.5,19 L19.5,21 Z M25.5,21 L28.5,21 L28.5,19 L25.5,19 L25.5,21 Z M3,19 L4.5,19 L4.5,21 L4,21 L4,21.5 L2,21.5 L2,20 C2,19.447 2.447,19 3,19 L3,19 Z M2,25.5 L4,25.5 L4,23.5 L2,23.5 L2,25.5 Z M4,28 L4.5,28 L4.5,30 L3,30 C2.447,30 2,29.553 2,29 L2,27.5 L4,27.5 L4,28 Z M19.5,30 L22.5,30 L22.5,28 L19.5,28 L19.5,30 Z M31.5,30 L34.5,30 L34.5,28 L31.5,28 L31.5,30 Z M7.5,30 L10.5,30 L10.5,28 L7.5,28 L7.5,30 Z M13.5,30 L16.5,30 L16.5,28 L13.5,28 L13.5,30 Z M37.5,30 L40.5,30 L40.5,28 L37.5,28 L37.5,30 Z M25.5,30 L28.5,30 L28.5,28 L25.5,28 L25.5,30 Z M44,27.5 L46,27.5 L46,29 C46,29.553 45.553,30 45,30 L43.5,30 L43.5,28 L44,28 L44,27.5 Z M4,15 L44,15 L44,7 L4,7 L4,15 Z M45,5 L3,5 C2.447,5 2,5.447 2,6 L2,16 C2,16.553 2.447,17 3,17 L45,17 C45.553,17 46,16.553 46,16 L46,6 C46,5.447 45.553,5 45,5 L45,5 Z" id="Amazon-Simple-Notification-Service_Topic_Resource-Icon_light-bg" fill="#E7157B"></path>
    </g>
</svg>`, dM = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Management-Governance/Res_AWS-Systems-Manager_Patch-Manager_48</title>
    <g id="Icon-Resource/Management-Governance/Res_AWS-Systems-Manager_Patch-Manager_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M24.027,2 L19.856,6.172 L21.269,7.585 L24.027,4.829 L28.465,9.266 L29.879,7.852 L24.027,2 Z M30.744,17.169 L32.744,17.169 L32.744,4.306 L30.744,4.306 L30.744,17.169 Z M34.174,20.598 L36.174,20.598 L36.174,7.736 L34.174,7.736 L34.174,20.598 Z M11.165,10.45 L24.027,10.45 L24.027,8.45 L11.165,8.45 L11.165,10.45 Z M37.604,24.028 L39.604,24.028 L39.604,11.166 L37.604,11.166 L37.604,24.028 Z M7.735,13.88 L20.596,13.88 L20.596,11.88 L7.735,11.88 L7.735,13.88 Z M4.305,17.31 L17.166,17.31 L17.166,15.31 L4.305,15.31 L4.305,17.31 Z M2,24.028 L6.171,28.199 L7.585,26.784 L4.828,24.028 L9.265,19.59 L7.851,18.176 L2,24.028 Z M40.468,21.271 L43.227,24.028 L38.788,28.465 L40.202,29.879 L46.055,24.028 L41.883,19.857 L40.468,21.271 Z M8.45,36.889 L10.45,36.889 L10.45,24.027 L8.45,24.027 L8.45,36.889 Z M11.88,40.318 L13.88,40.318 L13.88,27.457 L11.88,27.457 L11.88,40.318 Z M30.029,32.745 L42.89,32.745 L42.89,30.744 L30.029,30.744 L30.029,32.745 Z M15.31,43.749 L17.31,43.749 L17.31,30.887 L15.31,30.887 L15.31,43.749 Z M26.599,36.174 L39.461,36.174 L39.461,34.174 L26.599,34.174 L26.599,36.174 Z M23.169,39.604 L36.031,39.604 L36.031,37.604 L23.169,37.604 L23.169,39.604 Z M18.174,40.203 L24.027,46.055 L28.198,41.884 L26.784,40.47 L24.027,43.227 L19.588,38.789 L18.174,40.203 Z" id="AWS-System-Manager_patch-manager_Resource-Icon_light-bg" fill="#E7157B"></path>
    </g>
</svg>`, gM = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Management-Governance/Res_AWS-CloudFormation_Template_48</title>
    <g id="Icon-Resource/Management-Governance/Res_AWS-CloudFormation_Template_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M22.734,38.089 L37.593,38.089 L37.593,36.089 L22.734,36.089 L22.734,38.089 Z M22.734,25.852 L37.593,25.852 L37.593,23.852 L22.734,23.852 L22.734,25.852 Z M22.734,13.615 L37.593,13.615 L37.593,11.615 L22.734,11.615 L22.734,13.615 Z M14.118,37.838 L18.237,37.838 L18.237,33.719 L14.118,33.719 L14.118,37.838 Z M13.118,39.838 L19.238,39.838 C19.79,39.838 20.238,39.391 20.238,38.838 L20.238,32.719 C20.238,32.166 19.79,31.719 19.238,31.719 L13.118,31.719 C12.566,31.719 12.118,32.166 12.118,32.719 L12.118,38.838 C12.118,39.391 12.566,39.838 13.118,39.838 L13.118,39.838 Z M14.118,25.6 L18.237,25.6 L18.237,21.481 L14.118,21.481 L14.118,25.6 Z M13.118,27.601 L19.238,27.601 C19.79,27.601 20.238,27.153 20.238,26.601 L20.238,20.481 C20.238,19.929 19.79,19.481 19.238,19.481 L13.118,19.481 C12.566,19.481 12.118,19.929 12.118,20.481 L12.118,26.601 C12.118,27.153 12.566,27.601 13.118,27.601 L13.118,27.601 Z M14.118,13.363 L18.237,13.363 L18.237,9.244 L14.118,9.244 L14.118,13.363 Z M13.118,15.363 L19.238,15.363 C19.79,15.363 20.238,14.916 20.238,14.363 L20.238,8.244 C20.238,7.691 19.79,7.244 19.238,7.244 L13.118,7.244 C12.566,7.244 12.118,7.691 12.118,8.244 L12.118,14.363 C12.118,14.916 12.566,15.363 13.118,15.363 L13.118,15.363 Z M8,43.956 L40.963,43.956 L40.963,4 L8,4 L8,43.956 Z M41.963,2 L7,2 C6.448,2 6,2.447 6,3 L6,44.956 C6,45.509 6.448,45.956 7,45.956 L41.963,45.956 C42.516,45.956 42.963,45.509 42.963,44.956 L42.963,3 C42.963,2.447 42.516,2 41.963,2 L41.963,2 Z" id="AWS-CloudFormation_template_Resource-Icon_light-bg" fill="#E7157B"></path>
    </g>
</svg>`, fM = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Management-Governance/Res_AWS-OpsWorks_Layers_48</title>
    <g id="Icon-Resource/Management-Governance/Res_AWS-OpsWorks_Layers_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M4,43.92 L43.92,43.92 L43.92,30.199 L4,30.199 L4,43.92 Z M44.92,28.199 L3,28.199 C2.448,28.199 2,28.647 2,29.199 L2,44.92 C2,45.473 2.448,45.92 3,45.92 L44.92,45.92 C45.473,45.92 45.92,45.473 45.92,44.92 L45.92,29.199 C45.92,28.647 45.473,28.199 44.92,28.199 L44.92,28.199 Z M4,17.72 L43.92,17.72 L43.92,4 L4,4 L4,17.72 Z M44.92,2 L3,2 C2.448,2 2,2.447 2,3 L2,18.72 C2,19.273 2.448,19.72 3,19.72 L44.92,19.72 C45.473,19.72 45.92,19.273 45.92,18.72 L45.92,3 C45.92,2.447 45.473,2 44.92,2 L44.92,2 Z" id="AWS-OpsWorks-layers_Resource-Icon_light-bg" fill="#E7157B"></path>
    </g>
</svg>`, pM = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Management-Governance/Res_Amazon-CloudWatch_Metrics-Insights_48</title>
    <g id="Icon-Resource/Management-Governance/Res_Amazon-CloudWatch_Metrics-Insights_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M19.0117,34.688 L19.0027,27.92 C18.0477,28.271 16.8087,28.478 15.3427,28.478 C14.0667,28.478 12.3017,28.306 10.9847,27.8 L10.9997,34.75 C11.0497,34.806 11.5317,35.196 12.8957,35.427 C13.2477,35.487 13.6227,35.532 14.0157,35.56 C14.1737,35.572 14.3357,35.58 14.4997,35.586 C14.8297,35.598 15.1697,35.598 15.4997,35.586 C15.6637,35.58 15.8257,35.572 15.9847,35.56 C16.3767,35.532 16.7517,35.487 17.1037,35.427 C18.4687,35.196 18.9497,34.806 19.0117,34.688 L19.0117,34.688 Z M14.9997,25.015 C12.9807,25.015 11.7797,25.426 11.2657,25.726 C11.7667,26.02 13.1987,26.478 15.3427,26.478 C17.4477,26.478 18.5107,26.027 18.8897,25.774 C18.5227,25.54 17.2797,25.015 14.9997,25.015 L14.9997,25.015 Z M14.9997,23.015 C17.9867,23.015 20.9997,23.894 20.9997,25.859 L20.9997,34.75 C20.9997,35.514 20.5367,36.874 17.4387,37.399 C17.0277,37.469 16.5877,37.522 16.1277,37.555 C15.9457,37.568 15.7597,37.578 15.5727,37.585 C15.3837,37.592 15.1927,37.595 14.9997,37.595 C14.8077,37.595 14.6157,37.592 14.4277,37.585 C14.2407,37.578 14.0547,37.568 13.8717,37.555 C13.4117,37.522 12.9727,37.469 12.5607,37.399 C9.4627,36.874 8.9997,35.514 8.9997,34.75 L8.9997,25.859 C8.9997,23.894 12.0137,23.015 14.9997,23.015 L14.9997,23.015 Z M39.9997,5.5 C39.9997,6.327 40.6727,7 41.4997,7 C42.3267,7 42.9997,6.327 42.9997,5.5 C42.9997,4.673 42.3267,4 41.4997,4 C40.6727,4 39.9997,4.673 39.9997,5.5 L39.9997,5.5 Z M29.9997,22.5 C29.9997,21.673 29.3267,21 28.4997,21 C27.6727,21 26.9997,21.673 26.9997,22.5 C26.9997,23.327 27.6727,24 28.4997,24 C29.3267,24 29.9997,23.327 29.9997,22.5 L29.9997,22.5 Z M16.4997,12 C17.3267,12 17.9997,11.327 17.9997,10.5 C17.9997,9.673 17.3267,9 16.4997,9 C15.6727,9 14.9997,9.673 14.9997,10.5 C14.9997,11.327 15.6727,12 16.4997,12 L16.4997,12 Z M37.9997,5.5 C37.9997,3.57 39.5707,2 41.4997,2 C43.4297,2 44.9997,3.57 44.9997,5.5 C44.9997,7.43 43.4297,9 41.4997,9 C41.2757,9 41.0577,8.974 40.8457,8.934 L31.7107,21.114 C31.8957,21.539 31.9997,22.007 31.9997,22.5 C31.9997,24.43 30.4297,26 28.4997,26 C26.5707,26 24.9997,24.43 24.9997,22.5 C24.9997,21.962 25.1317,21.458 25.3507,21.002 L17.9987,13.65 C17.5427,13.868 17.0377,14 16.4997,14 C14.5707,14 12.9997,12.43 12.9997,10.5 C12.9997,8.57 14.5707,7 16.4997,7 C18.4297,7 19.9997,8.57 19.9997,10.5 C19.9997,11.163 19.8047,11.777 19.4827,12.306 L26.6937,19.517 C27.2227,19.196 27.8367,19 28.4997,19 C29.1927,19 29.8347,19.208 30.3787,19.557 L39.0507,7.994 C38.4037,7.358 37.9997,6.476 37.9997,5.5 L37.9997,5.5 Z M21.9997,44 L23.9997,44 L23.9997,41 L21.9997,41 L21.9997,44 Z M43.0637,39 L43.0497,33 L22.9997,33 L22.9997,31 L43.0447,31 L42.9997,12 L44.9997,12 L44.9997,39.063 C44.9997,40.131 44.1307,41 43.0637,41 L25.9997,41 L25.9997,44 L33.9997,44 L33.9997,46 L24.9997,46 L20.9997,46 L12.9997,46 L12.9997,44 L19.9997,44 L19.9997,41 L3.9517,41 C2.8757,41 1.9997,40.125 1.9997,39.048 L1.9997,33 L1.9997,31 L1.9997,27 L3.9997,27 L3.9997,31 L6.9997,31 L6.9997,33 L3.9997,33 L3.9997,39.048 L43.0637,39 Z M3.9997,18 L1.9997,18 L1.9997,10.937 C1.9997,9.869 2.8687,9 3.9367,9 L8.2647,9 C9.0947,5.178 12.5007,2.305 16.5677,2.305 C20.6347,2.305 24.0397,5.178 24.8697,9 L33.9997,9 L33.9997,11 L25.0597,11 C25.0397,11.886 24.8887,12.757 24.6017,13.588 L22.7107,12.934 C22.9477,12.251 23.0677,11.535 23.0677,10.805 C23.0677,7.221 20.1517,4.305 16.5677,4.305 C12.9837,4.305 10.0677,7.221 10.0677,10.805 C10.0677,14.389 12.9837,17.305 16.5677,17.305 C17.3277,17.305 18.0727,17.175 18.7807,16.919 L19.4597,18.8 C18.5327,19.135 17.5607,19.305 16.5677,19.305 C14.2377,19.305 12.1247,18.361 10.5877,16.838 L3.7507,24.081 L2.2957,22.708 L9.3357,15.25 C8.5687,14.007 8.1127,12.556 8.0777,11 L3.9367,11 L3.9997,18 Z" id="Fill-1" fill="#E7157B"></path>
    </g>
</svg>`, mM = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Management-Governance/Res_Amazon-CloudWatch_Data-Protection_48</title>
    <g id="Icon-Resource/Management-Governance/Res_Amazon-CloudWatch_Data-Protection_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M31.999,30.972 L32.001,30.972 C32.535,30.972 33.036,30.764 33.413,30.388 C33.792,30.01 34,29.508 34,28.973 L34,28.972 C34.001,28.438 33.793,27.936 33.416,27.558 C33.038,27.18 32.536,26.972 32.001,26.972 L31.999,26.972 C31.465,26.972 30.964,27.18 30.587,27.556 C30.209,27.934 30.001,28.437 30,28.972 C30,30.075 30.896,30.972 31.999,30.972 L31.999,30.972 Z M31,36.973 L31,32.83 C29.28,32.383 28,30.83 28,28.971 C28.001,27.901 28.418,26.897 29.173,26.142 C29.928,25.388 30.931,24.972 31.997,24.972 L32.002,24.972 C33.07,24.972 34.075,25.389 34.831,26.145 C35.586,26.901 36.001,27.906 36,28.974 C36,30.043 35.583,31.048 34.827,31.803 C34.315,32.315 33.683,32.656 33,32.831 L33,36.973 L31,36.973 Z M24.981,19.974 L39.034,19.98 L39.033,12.992 C39.039,11.143 38.32,9.398 37.008,8.074 C35.688,6.743 33.932,6.006 32.061,6 L32.039,6 C30.178,6 28.419,6.733 27.084,8.065 C25.751,9.395 25.014,11.145 25.008,12.991 L24.981,19.974 Z M46,20.982 L45.991,41.973 C45.991,42.526 45.543,42.973 44.991,42.973 L19,42.963 C18.447,42.963 18,42.514 18,41.962 L18.004,28.972 L20.004,28.972 L20,40.963 L43.991,40.972 L44,21.981 L20.007,21.972 L20.006,22.972 L18.006,22.972 L18.007,20.972 C18.007,20.419 18.455,19.972 19.007,19.972 L22.981,19.973 L23.008,12.984 C23.016,10.606 23.961,8.356 25.672,6.65 C27.385,4.94 29.645,4 32.038,4 L32.067,4 C34.474,4.008 36.732,4.955 38.429,6.666 C40.116,8.369 41.041,10.617 41.033,12.995 L41.034,19.98 L45,19.982 C45.266,19.982 45.52,20.087 45.707,20.275 C45.895,20.463 46,20.717 46,20.982 L46,20.982 Z M2,34.973 L14,34.973 L14,32.973 L2,32.973 L2,34.973 Z M2,18.972 L14,18.972 L14,16.972 L2,16.972 L2,18.972 Z M2,26.972 L25.999,26.972 L25.999,24.972 L2,24.972 L2,26.972 Z M2,42.973 L15.999,42.973 L15.999,40.973 L2,40.973 L2,42.973 Z M2,10.972 L17.999,10.972 L17.999,8.972 L2,8.972 L2,10.972 Z" id="Fill-1" fill="#E7157B"></path>
    </g>
</svg>`, wM = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Management-Governance/Res_Amazon-CloudWatch_Alarm_48</title>
    <g id="Icon-Resource/Management-Governance/Res_Amazon-CloudWatch_Alarm_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M41.4246,40.6675 L34.6366,40.6675 L34.6366,19.8305 C36.8216,20.5265 39.2386,20.5265 41.4246,19.8305 L41.4246,40.6675 Z M41.9946,17.4595 C39.4996,18.6475 36.5596,18.6465 34.0666,17.4595 C33.7586,17.3125 33.3946,17.3335 33.1026,17.5165 C32.8126,17.6995 32.6366,18.0185 32.6366,18.3615 L32.6366,41.6675 C32.6366,42.2205 33.0836,42.6675 33.6366,42.6675 L42.4246,42.6675 C42.9776,42.6675 43.4246,42.2205 43.4246,41.6675 L43.4246,18.3615 C43.4246,18.0185 43.2486,17.6995 42.9586,17.5165 C42.6676,17.3335 42.3036,17.3115 41.9946,17.4595 L41.9946,17.4595 Z M38.0306,4.0005 C40.8716,4.0005 43.1826,6.3115 43.1826,9.1515 C43.1826,11.9925 40.8716,14.3035 38.0306,14.3035 C35.1906,14.3035 32.8796,11.9925 32.8796,9.1515 C32.8796,6.3115 35.1906,4.0005 38.0306,4.0005 L38.0306,4.0005 Z M38.0306,16.3035 C41.9746,16.3035 45.1826,13.0955 45.1826,9.1515 C45.1826,5.2085 41.9746,2.0005 38.0306,2.0005 C34.0876,2.0005 30.8796,5.2085 30.8796,9.1515 C30.8796,13.0955 34.0876,16.3035 38.0306,16.3035 L38.0306,16.3035 Z M2.0006,46.1835 L45.9406,46.1835 L45.9406,44.1835 L2.0006,44.1835 L2.0006,46.1835 Z M20.5756,40.6675 L27.3636,40.6675 L27.3636,27.7285 L20.5756,27.7285 L20.5756,40.6675 Z M19.5756,42.6675 L28.3636,42.6675 C28.9166,42.6675 29.3636,42.2205 29.3636,41.6675 L29.3636,26.7285 C29.3636,26.1755 28.9166,25.7285 28.3636,25.7285 L19.5756,25.7285 C19.0236,25.7285 18.5756,26.1755 18.5756,26.7285 L18.5756,41.6675 C18.5756,42.2205 19.0236,42.6675 19.5756,42.6675 L19.5756,42.6675 Z M6.5156,40.6675 L13.3036,40.6675 L13.3036,23.3345 L6.5156,23.3345 L6.5156,40.6675 Z M5.5156,42.6675 L14.3036,42.6675 C14.8566,42.6675 15.3036,42.2205 15.3036,41.6675 L15.3036,22.3345 C15.3036,21.7815 14.8566,21.3345 14.3036,21.3345 L5.5156,21.3345 C4.9626,21.3345 4.5156,21.7815 4.5156,22.3345 L4.5156,41.6675 C4.5156,42.2205 4.9626,42.6675 5.5156,42.6675 L5.5156,42.6675 Z" id="Amazon-Cloudwatch_alarm_Resource-Icon_light-bg" fill="#E7157B"></path>
    </g>
</svg>`, xM = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Management-Governance/Res_AWS-Trusted-Advisor_Checklist-Security_48</title>
    <g id="Icon-Resource/Management-Governance/Res_AWS-Trusted-Advisor_Checklist-Security_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M44.0002,31.9766 L28.4962,31.9696 L28.4912,43.9786 L43.9942,43.9856 L44.0002,31.9766 Z M31.9792,29.9716 L40.4712,29.9746 L40.4702,27.2676 C40.4772,25.0626 38.5872,23.2646 36.2572,23.2566 L36.2422,23.2566 C33.9052,23.2566 32.0002,25.0316 31.9932,27.2176 L31.9792,29.9716 Z M46.0002,30.9766 L45.9942,44.9856 C45.9942,45.5386 45.5462,45.9856 44.9942,45.9856 L27.4912,45.9786 C26.9382,45.9786 26.4912,45.5306 26.4912,44.9786 L26.4962,30.9696 C26.4962,30.7046 26.6022,30.4506 26.7892,30.2626 C26.9772,30.0756 27.2312,29.9696 27.4962,29.9696 L29.9792,29.9706 L29.9932,27.2096 C30.0042,23.9236 32.8062,21.2566 36.2422,21.2566 L36.2632,21.2566 C39.6962,21.2686 42.4802,23.9656 42.4702,27.2706 L42.4712,29.9756 L45.0002,29.9766 C45.2662,29.9766 45.5202,30.0816 45.7072,30.2696 C45.8952,30.4566 46.0002,30.7116 46.0002,30.9766 L46.0002,30.9766 Z M6.3272,26.6716 L4.9212,28.0936 L7.7202,30.8636 C7.9072,31.0486 8.1602,31.1526 8.4232,31.1526 C8.4462,31.1526 8.4702,31.1516 8.4942,31.1496 C8.7812,31.1286 9.0462,30.9866 9.2202,30.7556 L13.4182,25.2156 L11.8242,24.0086 L8.3152,28.6386 L6.3272,26.6716 Z M11.8242,14.6786 L8.3152,19.3086 L6.3272,17.3416 L4.9212,18.7636 L7.7202,21.5336 C7.9072,21.7186 8.1602,21.8226 8.4232,21.8226 C8.4462,21.8226 8.4702,21.8216 8.4942,21.8196 C8.7812,21.7986 9.0462,21.6566 9.2202,21.4256 L13.4182,15.8856 L11.8242,14.6786 Z M11.8242,5.3486 L8.3152,9.9786 L6.3272,8.0116 L4.9212,9.4336 L7.7202,12.2036 C7.9072,12.3886 8.1602,12.4926 8.4232,12.4926 C8.4462,12.4926 8.4702,12.4916 8.4942,12.4896 C8.7812,12.4686 9.0462,12.3266 9.2202,12.0956 L13.4182,6.5556 L11.8242,5.3486 Z M15.2462,29.3666 L26.6162,29.3666 L26.6162,27.3666 L15.2462,27.3666 L15.2462,29.3666 Z M15.2462,20.6196 L26.6162,20.6196 L26.6162,18.6196 L15.2462,18.6196 L15.2462,20.6196 Z M15.2462,10.9976 L26.6162,10.9976 L26.6162,8.9976 L15.2462,8.9976 L15.2462,10.9976 Z M4.0002,34.3646 L24.8672,34.3646 L24.8672,36.3646 L3.0002,36.3646 C2.4472,36.3646 2.0002,35.9166 2.0002,35.3646 L2.0002,2.9996 C2.0002,2.4476 2.4472,1.9996 3.0002,1.9996 L29.2402,1.9996 C29.7932,1.9996 30.2402,2.4476 30.2402,2.9996 L30.2402,23.9936 L28.2402,23.9936 L28.2402,3.9996 L4.0002,3.9996 L4.0002,34.3646 Z" id="AWS-Trusted-Advisor_checklist-security_Resource-Icon_light-bg" fill="#E7157B"></path>
    </g>
</svg>`, _M = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Management-Governance/Res_AWS-Trusted-Advisor_Checklist-Performance_48</title>
    <g id="Icon-Resource/Management-Governance/Res_AWS-Trusted-Advisor_Checklist-Performance_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M40.501,42.375 L42.501,42.375 L42.501,34.5 L40.501,34.5 L40.501,42.375 Z M36.126,42.375 L38.126,42.375 L38.126,38.875 L36.126,38.875 L36.126,42.375 Z M31.751,42.375 L33.751,42.375 L33.751,37.125 L31.751,37.125 L31.751,42.375 Z M27.376,42.375 L29.376,42.375 L29.376,38.875 L27.376,38.875 L27.376,42.375 Z M32.779,34.808 L36.611,37.107 C36.844,37.246 37.124,37.284 37.385,37.216 C37.646,37.146 37.868,36.973 38,36.735 L41.547,30.353 L41.714,31.166 L43.673,30.762 L42.966,27.334 C42.853,26.794 42.335,26.45 41.784,26.557 L38.356,27.263 L38.76,29.222 L40.033,28.96 L36.754,34.86 L33.265,32.768 C32.932,32.567 32.518,32.578 32.196,32.793 L26.946,36.293 L28.055,37.957 L32.779,34.808 Z M25.876,44 L44.001,44 L44.001,25.875 L25.876,25.875 L25.876,44 Z M46.001,24.875 L46.001,45 C46.001,45.553 45.553,46 45.001,46 L24.876,46 C24.323,46 23.876,45.553 23.876,45 L23.876,24.875 C23.876,24.322 24.323,23.875 24.876,23.875 L45.001,23.875 C45.553,23.875 46.001,24.322 46.001,24.875 L46.001,24.875 Z M6.328,26.68 L4.922,28.102 L7.722,30.872 C7.91,31.058 8.163,31.161 8.426,31.161 C8.449,31.161 8.472,31.16 8.497,31.158 C8.784,31.138 9.049,30.995 9.222,30.766 L13.423,25.224 L11.829,24.015 L8.318,28.647 L6.328,26.68 Z M11.829,14.682 L8.318,19.314 L6.328,17.346 L4.922,18.768 L7.722,21.539 C7.91,21.725 8.163,21.828 8.426,21.828 C8.449,21.828 8.472,21.827 8.497,21.825 C8.784,21.805 9.049,21.662 9.222,21.433 L13.423,15.891 L11.829,14.682 Z M11.829,5.349 L8.318,9.98 L6.328,8.013 L4.922,9.435 L7.722,12.205 C7.91,12.391 8.163,12.494 8.426,12.494 C8.449,12.494 8.472,12.493 8.497,12.491 C8.784,12.471 9.049,12.328 9.222,12.099 L13.423,6.558 L11.829,5.349 Z M15.251,29.375 L22.251,29.375 L22.251,27.375 L15.251,27.375 L15.251,29.375 Z M15.251,20.625 L26.626,20.625 L26.626,18.625 L15.251,18.625 L15.251,20.625 Z M15.251,11 L26.626,11 L26.626,9 L15.251,9 L15.251,11 Z M4,34.375 L22.251,34.375 L22.251,36.375 L3,36.375 C2.447,36.375 2,35.928 2,35.375 L2,3 C2,2.447 2.447,2 3,2 L29.251,2 C29.803,2 30.251,2.447 30.251,3 L30.251,22.25 L28.251,22.25 L28.251,4 L4,4 L4,34.375 Z" id="AWS-Trusted-Advisor_checklist-performance_Resource-Icon_dark-bg" fill="#E7157B"></path>
    </g>
</svg>`, vM = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Management-Governance/Res_Amazon-CloudWatch_Rule_48</title>
    <g id="Icon-Resource/Management-Governance/Res_Amazon-CloudWatch_Rule_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M2.042,2 L2.042,14.473 L13.06,14.497 L15.725,17.13 L45.967,17.079 L45.951,4.607 L16.537,4.607 L13.888,2 L2.042,2 Z M13.882,12.499 L4.043,12.477 L4.043,4 L13.07,4 L15.719,6.607 L43.953,6.607 L43.965,15.082 L16.546,15.127 L13.882,12.499 Z M37.94,9.454 L36.048,7.556 L34.631,8.968 L36.526,10.868 L34.624,12.77 L36.038,14.184 L37.938,12.285 L39.838,14.192 L41.254,12.78 L39.352,10.871 L41.253,8.969 L39.839,7.555 L37.94,9.454 Z M2,15.968 L2,28.468 L13.061,28.468 L15.71,31.09 L45.96,31.076 L45.945,18.617 L16.528,18.607 L13.948,15.968 L2,15.968 Z M4,17.968 L13.106,17.968 L15.687,20.607 L43.947,20.617 L43.959,29.076 L16.533,29.09 L13.883,26.468 L4,26.468 L4,17.968 Z M35.419,25.276 L34.299,24.158 L32.885,25.572 L35.297,27.985 L41.229,23.023 L39.946,21.49 L35.419,25.276 Z M2,29.95 L2,42.451 L13.084,42.438 L15.741,45.022 L45.951,45.074 L45.96,32.586 L16.532,32.587 L13.819,29.95 L2,29.95 Z M4,31.95 L13.007,31.95 L15.719,34.588 L43.959,34.585 L43.953,43.07 L16.555,43.024 L13.895,40.438 L4,40.449 L4,31.95 Z M35.179,39.211 L34.06,38.093 L32.646,39.507 L35.058,41.92 L40.99,36.958 L39.706,35.424 L35.179,39.211 Z" id="Amazon-Cloudwatch_rule_Resource-Icon_light-bg" fill="#E7157B"></path>
    </g>
</svg>`, MM = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Management-Governance/Res_AWS-OpsWorks_Resources_48</title>
    <g id="Icon-Resource/Management-Governance/Res_AWS-OpsWorks_Resources_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M25.2278,43.3628 L25.2278,25.0668 L41.4558,15.6978 L41.4558,33.9938 L25.2278,43.3628 Z M6.9998,15.6978 L23.2278,25.0668 L23.2278,43.3628 L6.9998,33.9938 L6.9998,15.6978 Z M24.2278,4.1538 L40.8368,13.7448 L24.2278,23.3358 L7.6178,13.7448 L24.2278,4.1538 Z M42.9558,12.6578 L24.7278,2.1338 C24.4188,1.9558 24.0368,1.9558 23.7278,2.1338 L5.4998,12.6578 C5.1908,12.8368 4.9998,13.1668 4.9998,13.5238 L4.9998,34.5708 C4.9998,34.9278 5.1908,35.2588 5.4998,35.4368 L23.7278,45.9608 C23.8818,46.0498 24.0548,46.0938 24.2278,46.0938 C24.4008,46.0938 24.5738,46.0498 24.7278,45.9608 L42.9558,35.4368 C43.2648,35.2588 43.4558,34.9278 43.4558,34.5708 L43.4558,13.5238 C43.4558,13.1668 43.2648,12.8368 42.9558,12.6578 L42.9558,12.6578 Z" id="AWS-OpsWorks-resources_Resource-Icon_light-bg" fill="#E7157B"></path>
    </g>
</svg>`, RM = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Management-Governance/Res_Amazon-CloudWatch_Event-Time-Based_48</title>
    <g id="Icon-Resource/Management-Governance/Res_Amazon-CloudWatch_Event-Time-Based_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M39.0691,11.9052 L33.6821,11.9052 L33.6821,9.9052 L37.0691,9.9052 L37.0691,5.6392 L39.0691,5.6392 L39.0691,11.9052 Z M38.0691,4.0002 C41.3981,4.0002 44.1061,6.7092 44.1061,10.0382 C44.1061,13.3672 41.3981,16.0762 38.0691,16.0762 C34.7401,16.0762 32.0311,13.3672 32.0311,10.0382 C32.0311,6.7092 34.7401,4.0002 38.0691,4.0002 L38.0691,4.0002 Z M38.0691,18.0762 C42.5011,18.0762 46.1061,14.4702 46.1061,10.0382 C46.1061,5.6052 42.5011,2.0002 38.0691,2.0002 C33.6361,2.0002 30.0311,5.6052 30.0311,10.0382 C30.0311,14.4702 33.6361,18.0762 38.0691,18.0762 L38.0691,18.0762 Z M41.4671,40.7092 L34.6701,40.7092 L34.6701,21.1552 C36.8571,21.8152 39.2801,21.8152 41.4671,21.1552 L41.4671,40.7092 Z M42.0571,18.8022 C39.5511,19.9292 36.5881,19.9292 34.0801,18.8022 C33.7721,18.6652 33.4121,18.6902 33.1271,18.8752 C32.8411,19.0592 32.6701,19.3762 32.6701,19.7152 L32.6701,41.7092 C32.6701,42.2612 33.1171,42.7092 33.6701,42.7092 L42.4671,42.7092 C43.0201,42.7092 43.4671,42.2612 43.4671,41.7092 L43.4671,19.7152 C43.4671,19.3762 43.2961,19.0592 43.0101,18.8752 C42.7251,18.6892 42.3651,18.6642 42.0571,18.8022 L42.0571,18.8022 Z M2.0001,46.2272 L45.9861,46.2272 L45.9861,44.2272 L2.0001,44.2272 L2.0001,46.2272 Z M20.5941,40.7092 L27.3911,40.7092 L27.3911,27.7532 L20.5941,27.7532 L20.5941,40.7092 Z M19.5941,42.7092 L28.3911,42.7092 C28.9441,42.7092 29.3911,42.2612 29.3911,41.7092 L29.3911,26.7532 C29.3911,26.2002 28.9441,25.7532 28.3911,25.7532 L19.5941,25.7532 C19.0421,25.7532 18.5941,26.2002 18.5941,26.7532 L18.5941,41.7092 C18.5941,42.2612 19.0421,42.7092 19.5941,42.7092 L19.5941,42.7092 Z M6.5181,40.7082 L13.3161,40.7082 L13.3161,23.3542 L6.5181,23.3542 L6.5181,40.7082 Z M5.5181,42.7092 L14.3161,42.7092 C14.8691,42.7092 15.3161,42.2612 15.3161,41.7092 L15.3161,22.3542 C15.3161,21.8012 14.8691,21.3542 14.3161,21.3542 L5.5181,21.3542 C4.9651,21.3542 4.5181,21.8012 4.5181,22.3542 L4.5181,41.7092 C4.5181,42.2612 4.9651,42.7092 5.5181,42.7092 L5.5181,42.7092 Z" id="Amazon-Cloudwatch_Event-time-based_Resource-Icon_light-bg" fill="#E7157B"></path>
    </g>
</svg>`, yM = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Management-Governance/Res_AWS-Organizations_Management-Account_48</title>
    <g id="Icon-Resource/Management-Governance/Res_AWS-Organizations_Management-Account_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M10.303,11.5034199 C10.312,11.9504199 10.494,12.3684199 10.818,12.6784199 C11.14,12.9884199 11.564,13.1504199 12.012,13.1464199 C12.459,13.1374199 12.876,12.9554199 13.187,12.6324199 L13.187,12.6314199 C13.497,12.3094199 13.663,11.8854199 13.655,11.4384199 C13.646,10.9904199 13.463,10.5734199 13.14,10.2624199 C12.825,9.96041991 12.414,9.79541991 11.98,9.79541991 C11.968,9.79541991 11.957,9.79541991 11.946,9.79541991 C11.498,9.80441991 11.081,9.98641991 10.771,10.3094199 C10.46,10.6314199 10.294,11.0564199 10.303,11.5034199 L10.303,11.5034199 Z M9.431,14.1204199 C8.723,13.4394199 8.323,12.5244199 8.304,11.5424199 C8.284,10.5614199 8.649,9.63041991 9.329,8.92241991 C10.735,7.46241991 13.065,7.41641991 14.527,8.82141991 C15.235,9.50241991 15.635,10.4174199 15.654,11.3994199 C15.673,12.3804199 15.309,13.3104199 14.628,14.0184199 C13.907,14.7674199 12.944,15.1444199 11.978,15.1444199 C11.061,15.1444199 10.143,14.8044199 9.431,14.1204199 L9.431,14.1204199 Z M4.229,12.1264199 L5.301,15.4364199 L7.592,14.9774199 C7.869,14.9204199 8.157,14.9854199 8.383,15.1544199 L9.524,15.9994199 C9.746,16.1634199 9.89,16.4124199 9.922,16.6874199 L10.192,18.9964199 L13.67,18.9994199 L13.944,16.6724199 C13.976,16.3964199 14.121,16.1464199 14.346,15.9824199 L15.473,15.1574199 C15.699,14.9914199 15.987,14.9274199 16.26,14.9834199 L18.57,15.4464199 L19.647,12.1384199 L17.51,11.1564199 C17.254,11.0394199 17.06,10.8194199 16.974,10.5514199 L16.55,9.22441991 C16.466,8.95941991 16.495,8.67141991 16.632,8.42941991 L17.782,6.38341991 L14.969,4.33641991 L13.395,6.04541991 C13.206,6.24941991 12.943,6.36541991 12.665,6.36741991 L11.246,6.37541991 L11.24,6.37541991 C10.961,6.37541991 10.695,6.25841991 10.505,6.05241991 L8.92,4.33241991 L6.103,6.37541991 L7.258,8.43041991 C7.395,8.67341991 7.423,8.96341991 7.337,9.22941991 L6.909,10.5424199 C6.823,10.8084199 6.629,11.0254199 6.375,11.1424199 L4.229,12.1264199 Z M2.052,11.8964199 C1.896,11.4134199 2.125,10.8904199 2.586,10.6784199 L5.143,9.50641991 L5.299,9.02741991 L3.923,6.57841991 C3.675,6.13541991 3.797,5.57641991 4.208,5.27841991 L8.466,2.19041991 C8.875,1.89341991 9.445,1.94841991 9.788,2.32341991 L11.677,4.37341991 L12.219,4.36941991 L14.102,2.32641991 C14.447,1.95341991 15.015,1.89741991 15.425,2.19541991 L19.678,5.29041991 C20.088,5.58841991 20.21,6.14741991 19.962,6.58841991 L18.588,9.03041991 L18.745,9.52341991 L21.29,10.6924199 C21.752,10.9044199 21.982,11.4284199 21.824,11.9104199 L20.197,16.9114199 C20.038,17.3944199 19.54,17.6804199 19.049,17.5824199 L16.299,17.0304199 L15.879,17.3384199 L15.553,20.1174199 C15.493,20.6204199 15.067,21.0004199 14.56,21.0004199 L14.559,21.0004199 L9.3,20.9954199 C8.793,20.9954199 8.366,20.6154199 8.308,20.1114199 L7.986,17.3484199 L7.55,17.0254199 L4.821,17.5714199 C4.319,17.6704199 3.829,17.3824199 3.673,16.8994199 L2.052,11.8964199 Z M29,35.0004199 C29,37.7574199 31.243,40.0004199 34,40.0004199 C36.757,40.0004199 39,37.7574199 39,35.0004199 C39,32.2434199 36.757,30.0004199 34,30.0004199 C31.243,30.0004199 29,32.2434199 29,35.0004199 L29,35.0004199 Z M27,35.0004199 C27,31.1404199 30.141,28.0004199 34,28.0004199 C37.86,28.0004199 41,31.1404199 41,35.0004199 C41,38.8604199 37.86,42.0004199 34,42.0004199 C30.141,42.0004199 27,38.8604199 27,35.0004199 L27,35.0004199 Z M31.083,22.0004199 L38.579,22.0004199 L34.831,14.5034199 L31.083,22.0004199 Z M28.615,23.5264199 C28.432,23.2314199 28.415,22.8634199 28.571,22.5534199 L33.937,11.8204199 C34.277,11.1434199 35.386,11.1434199 35.726,11.8204199 L41.092,22.5534199 C41.247,22.8634199 41.231,23.2314199 41.048,23.5264199 C40.865,23.8204199 40.544,24.0004199 40.198,24.0004199 L29.465,24.0004199 C29.118,24.0004199 28.797,23.8204199 28.615,23.5264199 L28.615,23.5264199 Z M13,34.0004199 L22,34.0004199 L22,25.0004199 L13,25.0004199 L13,34.0004199 Z M12,23.0004199 L23,23.0004199 C23.553,23.0004199 24,23.4484199 24,24.0004199 L24,35.0004199 C24,35.5524199 23.553,36.0004199 23,36.0004199 L12,36.0004199 C11.448,36.0004199 11,35.5524199 11,35.0004199 L11,24.0004199 C11,23.4484199 11.448,23.0004199 12,23.0004199 L12,23.0004199 Z M46,3.00041991 L46,45.0004199 C46,45.5524199 45.553,46.0004199 45,46.0004199 L3,46.0004199 C2.448,46.0004199 2,45.5524199 2,45.0004199 L2,22.0004199 L4,22.0004199 L4,44.0004199 L44,44.0004199 L44,4.00041991 L22,4.00041991 L22,2.00041991 L45,2.00041991 C45.553,2.00041991 46,2.44841991 46,3.00041991 L46,3.00041991 Z" id="Fill-1" fill="#E7157B"></path>
    </g>
</svg>`, AM = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Management-Governance/Res_AWS-License-Manager_License-Blending_48</title>
    <g id="Icon-Resource/Management-Governance/Res_AWS-License-Manager_License-Blending_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M34.021,38 L17.021,38 L17.021,40 L34.097,40 C35.158,40 36.021,39.137 36.021,38.076 L36.021,35 L34.021,35 L34.021,38 Z M27.021,4.746 L27.021,11 L33.289,11 L27.021,4.746 Z M11.021,22 L9.021,22 L9.021,3.924 C9.021,2.863 9.884,2 10.945,2 L26.688,2 C26.953,2 27.207,2.105 27.394,2.292 L35.727,10.608 C35.916,10.796 36.021,11.05 36.021,11.316 L36.021,15 L34.021,15 L34.021,13 L26.021,13 C25.468,13 25.021,12.552 25.021,12 L25.021,4 L11.021,4 L11.021,22 Z M45.144,21.389 L43.355,22.283 C43.791,23.155 44.021,24.115 44.021,25.061 C44.021,28.335 41.372,31 38.116,31 L28.138,31 L29.951,29.187 L28.537,27.773 L25.11,31.2 C24.922,31.387 24.817,31.642 24.817,31.907 C24.817,32.172 24.922,32.426 25.11,32.614 L28.537,36.04 L29.951,34.625 L28.325,33 L38.116,33 C42.475,33 46.021,29.438 46.021,25.061 C46.021,23.807 45.717,22.537 45.144,21.389 L45.144,21.389 Z M30.578,17 C26.218,17 22.672,20.562 22.672,24.939 C22.672,26.192 22.975,27.462 23.548,28.61 L25.337,27.718 C24.903,26.845 24.672,25.884 24.672,24.939 C24.672,21.665 27.322,19 30.578,19 L39.809,19 L38.132,20.677 L39.546,22.091 L42.972,18.665 C43.363,18.274 43.363,17.641 42.972,17.25 L39.546,13.824 L38.132,15.238 L39.894,17 L30.578,17 Z M28.054,44 L16.021,44 L16.021,46 L28.054,46 C29.139,46 30.021,45.118 30.021,44.033 L30.021,42 L28.021,42 L28.054,44 Z M3.988,8 L7.021,8 L7.021,6 L3.988,6 C2.903,6 2.021,6.882 2.021,7.967 L2.021,24 L4.021,24 L3.988,8 Z M11.18,31.618 C11.18,30.879 10.58,30.279 9.841,30.279 C9.103,30.279 8.502,30.879 8.502,31.618 C8.502,32.356 9.103,32.957 9.841,32.957 C10.58,32.957 11.18,32.356 11.18,31.618 L11.18,31.618 Z M13.18,31.618 C13.18,33.459 11.682,34.957 9.841,34.957 C8,34.957 6.502,33.459 6.502,31.618 C6.502,29.777 8,28.279 9.841,28.279 C11.682,28.279 13.18,29.777 13.18,31.618 L13.18,31.618 Z M15.711,31.633 C15.711,31.356 15.515,31.117 15.245,31.063 C14.875,30.988 14.578,30.712 14.477,30.349 C14.371,29.964 14.218,29.598 14.025,29.26 C13.843,28.942 13.849,28.551 14.042,28.239 C14.1,28.144 14.129,28.044 14.129,27.941 C14.129,27.519 13.642,27.207 13.25,27.447 C12.939,27.639 12.547,27.645 12.23,27.464 C11.89,27.27 11.524,27.118 11.141,27.012 C10.777,26.912 10.5,26.615 10.426,26.244 C10.373,25.974 10.132,25.777 9.856,25.777 C9.58,25.777 9.34,25.974 9.286,26.245 C9.211,26.615 8.935,26.912 8.571,27.012 C8.189,27.118 7.824,27.27 7.483,27.464 C7.164,27.645 6.773,27.639 6.463,27.448 C6.069,27.207 5.583,27.519 5.583,27.941 C5.583,28.044 5.612,28.144 5.67,28.239 C5.862,28.55 5.869,28.941 5.688,29.258 C5.494,29.598 5.342,29.965 5.236,30.349 C5.135,30.712 4.838,30.989 4.468,31.063 C4.197,31.117 4,31.356 4,31.633 C4,31.909 4.197,32.149 4.468,32.203 C4.838,32.277 5.135,32.553 5.236,32.917 C5.342,33.301 5.494,33.667 5.688,34.007 C5.869,34.325 5.862,34.715 5.67,35.026 C5.612,35.122 5.583,35.222 5.583,35.324 C5.583,35.748 6.068,36.061 6.463,35.818 C6.624,35.719 6.805,35.67 6.987,35.67 C7.158,35.67 7.329,35.714 7.483,35.802 C7.824,35.996 8.189,36.148 8.571,36.253 C8.935,36.354 9.211,36.65 9.286,37.021 C9.34,37.292 9.58,37.488 9.856,37.488 C10.132,37.488 10.373,37.292 10.426,37.022 C10.5,36.651 10.777,36.354 11.141,36.253 C11.524,36.148 11.89,35.996 12.23,35.802 C12.547,35.62 12.939,35.626 13.25,35.819 C13.643,36.059 14.129,35.748 14.129,35.324 C14.129,35.222 14.1,35.122 14.042,35.026 C13.849,34.715 13.843,34.323 14.025,34.006 C14.218,33.667 14.371,33.301 14.477,32.917 C14.578,32.553 14.875,32.277 15.245,32.203 C15.515,32.149 15.711,31.909 15.711,31.633 L15.711,31.633 Z M16.129,35.324 C16.129,36.748 14.971,37.906 13.547,37.906 C13.279,37.906 13.013,37.863 12.757,37.78 C12.572,37.868 12.38,37.947 12.186,38.018 C11.766,38.897 10.866,39.488 9.856,39.488 C8.847,39.488 7.948,38.897 7.526,38.018 C7.332,37.947 7.141,37.868 6.955,37.78 C6.7,37.863 6.433,37.906 6.165,37.906 C4.741,37.906 3.583,36.748 3.583,35.324 C3.583,35.056 3.625,34.789 3.709,34.534 C3.622,34.348 3.542,34.157 3.472,33.963 C2.592,33.542 2,32.643 2,31.633 C2,30.623 2.592,29.723 3.472,29.303 C3.542,29.108 3.622,28.918 3.709,28.732 C3.625,28.477 3.583,28.21 3.583,27.941 C3.583,26.518 4.741,25.359 6.165,25.359 C6.433,25.359 6.7,25.402 6.955,25.486 C7.141,25.398 7.332,25.319 7.526,25.248 C7.948,24.369 8.847,23.777 9.856,23.777 C10.866,23.777 11.766,24.369 12.186,25.248 C12.38,25.319 12.572,25.398 12.757,25.486 C13.013,25.402 13.279,25.359 13.547,25.359 C14.971,25.359 16.129,26.518 16.129,27.941 C16.129,28.209 16.086,28.476 16.002,28.731 C16.09,28.917 16.17,29.108 16.241,29.303 C17.121,29.724 17.711,30.624 17.711,31.633 C17.711,32.642 17.121,33.542 16.241,33.963 C16.17,34.158 16.09,34.349 16.002,34.535 C16.086,34.79 16.129,35.056 16.129,35.324 L16.129,35.324 Z M12.021,39 L14.021,39 L14.021,45 C14.021,45.384 13.8,45.735 13.455,45.901 C13.317,45.967 13.168,46.0000266 13.021,46.0000266 C12.798,46.0000266 12.577,45.925 12.396,45.781 L9.521,43.481 L6.646,45.781 C6.345,46.021 5.936,46.068 5.587,45.901 C5.242,45.735 5.021,45.384 5.021,45 L5.021,39 L7.021,39 L7.021,42.919 L8.896,41.419 C9.261,41.127 9.781,41.127 10.146,41.419 L12.021,42.919 L12.021,39 Z" id="Fill-1" fill="#E7157B"></path>
    </g>
</svg>`, ZM = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Management-Governance/Res_Amazon-CloudWatch_Event-Event-Based_48</title>
    <g id="Icon-Resource/Management-Governance/Res_Amazon-CloudWatch_Event-Event-Based_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M34.522,40.526 L41.278,40.526 L41.278,19.76 L34.522,19.76 L34.522,40.526 Z M33.522,17.76 C32.969,17.76 32.522,18.208 32.522,18.76 L32.522,41.526 C32.522,42.079 32.969,42.526 33.522,42.526 L42.278,42.526 C42.831,42.526 43.278,42.079 43.278,41.526 L43.278,18.76 C43.278,18.208 42.831,17.76 42.278,17.76 L33.522,17.76 Z M32.77,4.417 C32.77,4.187 32.958,4 33.188,4 L42.612,4 C42.842,4 43.029,4.187 43.029,4.417 L43.029,13.841 C43.029,14.071 42.842,14.258 42.612,14.258 L33.188,14.258 C32.958,14.258 32.77,14.071 32.77,13.841 L32.77,4.417 Z M33.188,16.258 L42.612,16.258 C43.945,16.258 45.029,15.174 45.029,13.841 L45.029,4.417 C45.029,3.084 43.945,2 42.612,2 L33.188,2 C31.855,2 30.77,3.084 30.77,4.417 L30.77,13.841 C30.77,15.174 31.855,16.258 33.188,16.258 L33.188,16.258 Z M2,46.029 L45.78,46.029 L45.78,44.029 L2,44.029 L2,46.029 Z M20.512,40.526 L27.268,40.526 L27.268,27.641 L20.512,27.641 L20.512,40.526 Z M19.512,42.526 L28.268,42.526 C28.821,42.526 29.268,42.079 29.268,41.526 L29.268,26.641 C29.268,26.089 28.821,25.641 28.268,25.641 L19.512,25.641 C18.96,25.641 18.512,26.089 18.512,26.641 L18.512,41.526 C18.512,42.079 18.96,42.526 19.512,42.526 L19.512,42.526 Z M6.503,40.526 L13.259,40.526 L13.259,23.263 L6.503,23.263 L6.503,40.526 Z M5.503,42.526 L14.259,42.526 C14.811,42.526 15.259,42.079 15.259,41.526 L15.259,22.263 C15.259,21.711 14.811,21.263 14.259,21.263 L5.503,21.263 C4.95,21.263 4.503,21.711 4.503,22.263 L4.503,41.526 C4.503,42.079 4.95,42.526 5.503,42.526 L5.503,42.526 Z" id="Amazon-Cloudwatch_Event-event-based_Resource-Icon_light-bg" fill="#E7157B"></path>
    </g>
</svg>`, kM = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Management-Governance/Res_Amazon-CloudWatch_Synthetics_48</title>
    <g id="Icon-Resource/Management-Governance/Res_Amazon-CloudWatch_Synthetics_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M33,30 L29.519,30 L25.885,36.164 L20.941,25.288 L18.503,30 L15,30 L15,28 L17.286,28 L21.059,20.712 L26.115,31.836 L28.376,28 L33,28 L33,30 Z M15.5,33 L21.947,33 L21.947,35 L15.5,35 C12.468,35 10,32.533 10,29.5 L10,28.5 C10,25.467 12.468,23 15.5,23 L17,23 L17,25 L15.5,25 C13.57,25 12,26.57 12,28.5 L12,29.5 C12,31.43 13.57,33 15.5,33 L15.5,33 Z M38,28.5 L38,29.5 C38,32.533 35.532,35 32.5,35 L30.105,35 L30.105,33 L32.5,33 C34.43,33 36,31.43 36,29.5 L36,28.5 C36,26.57 34.43,25 32.5,25 L25.053,25 L25.053,23 L32.5,23 C35.532,23 38,25.467 38,28.5 L38,28.5 Z M44,31.534 C44,31.791 43.791,32 43.534,32 L41,32 L41,37.375 C37.114,41.059 30.799,43.248 24,43.248 C17.201,43.248 10.886,41.059 7,37.375 L7,32 L4.466,32 C4.209,32 4,31.791 4,31.534 L4,26.466 C4,26.209 4.209,26 4.466,26 L7.473,26 L7.665,25.248 C9.751,17.076 16.01,12 24,12 C32.729,12 38.993,18.812 40.455,25.222 L40.632,26 L43.534,26 C43.791,26 44,26.209 44,26.466 L44,31.534 Z M22.5,5.5 C22.5,4.673 23.173,4 24,4 C24.827,4 25.5,4.673 25.5,5.5 C25.5,6.327 24.827,7 24,7 C23.173,7 22.5,6.327 22.5,5.5 L22.5,5.5 Z M43.534,24 L42.208,24 C40.312,17.171 33.987,10.513 25,10.045 L25,8.837 C26.44,8.403 27.5,7.08 27.5,5.5 C27.5,3.57 25.93,2 24,2 C22.07,2 20.5,3.57 20.5,5.5 C20.5,7.08 21.56,8.403 23,8.837 L23,10.039 C14.78,10.435 8.345,15.679 5.933,24 L4.466,24 C3.106,24 2,25.106 2,26.466 L2,31.534 C2,32.894 3.106,34 4.466,34 L5,34 L5,38.21 L5.293,38.503 C9.579,42.79 16.397,45.248 24,45.248 C31.603,45.248 38.421,42.79 42.707,38.503 L43,38.21 L43,34 L43.534,34 C44.894,34 46,32.894 46,31.534 L46,26.466 C46,25.106 44.894,24 43.534,24 L43.534,24 Z" id="Fill-1" fill="#E7157B"></path>
    </g>
</svg>`, TM = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Management-Governance/Res_AWS-Systems-Manager_State-Manager_48</title>
    <g id="Icon-Resource/Management-Governance/Res_AWS-Systems-Manager_State-Manager_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M35.417,36.035 L38.653,36.035 L38.653,32.799 L35.417,32.799 L35.417,36.035 Z M34.417,38.036 L39.653,38.036 C40.206,38.036 40.653,37.588 40.653,37.036 L40.653,31.799 C40.653,31.246 40.206,30.799 39.653,30.799 L34.417,30.799 C33.864,30.799 33.417,31.246 33.417,31.799 L33.417,37.036 C33.417,37.588 33.864,38.036 34.417,38.036 L34.417,38.036 Z M23.944,34.616 L24.796,36.036 L23.093,36.036 L23.944,34.616 Z M21.326,38.036 L26.562,38.036 C26.923,38.036 27.255,37.842 27.432,37.529 C27.61,37.214 27.605,36.829 27.42,36.521 L24.802,32.158 C24.44,31.556 23.448,31.556 23.087,32.158 L20.469,36.521 C20.283,36.829 20.278,37.214 20.456,37.529 C20.634,37.842 20.966,38.036 21.326,38.036 L21.326,38.036 Z M10.854,33.672 C11.506,33.672 12.036,34.202 12.036,34.854 C12.036,35.505 11.506,36.036 10.854,36.036 C10.203,36.036 9.673,35.505 9.673,34.854 C9.673,34.202 10.203,33.672 10.854,33.672 L10.854,33.672 Z M10.854,38.036 C12.608,38.036 14.036,36.608 14.036,34.854 C14.036,33.1 12.608,31.672 10.854,31.672 C9.1,31.672 7.673,33.1 7.673,34.854 C7.673,36.608 9.1,38.036 10.854,38.036 L10.854,38.036 Z M32.798,39.527 L41.271,39.527 L41.271,23.2 L32.798,23.2 L32.798,39.527 Z M31.799,21.2 C31.246,21.2 30.799,21.647 30.799,22.2 L30.799,40.527 C30.799,41.079 31.246,41.527 31.799,41.527 L42.271,41.527 C42.824,41.527 43.271,41.079 43.271,40.527 L43.271,22.2 C43.271,21.647 42.824,21.2 42.271,21.2 L31.799,21.2 Z M19.707,39.527 L28.18,39.527 L28.18,19.71 L19.707,19.71 L19.707,39.527 Z M29.18,17.709 L18.708,17.709 C18.155,17.709 17.708,18.157 17.708,18.709 L17.708,40.527 C17.708,41.079 18.155,41.527 18.708,41.527 L29.18,41.527 C29.733,41.527 30.18,41.079 30.18,40.527 L30.18,18.709 C30.18,18.157 29.733,17.709 29.18,17.709 L29.18,17.709 Z M6.618,39.527 L15.09,39.527 L15.09,30.181 L6.618,30.181 L6.618,39.527 Z M16.09,28.181 L5.618,28.181 C5.065,28.181 4.618,28.628 4.618,29.181 L4.618,40.527 C4.618,41.079 5.065,41.527 5.618,41.527 L16.09,41.527 C16.642,41.527 17.09,41.079 17.09,40.527 L17.09,29.181 C17.09,28.628 16.642,28.181 16.09,28.181 L16.09,28.181 Z M8.363,10.728 L24.69,10.728 L24.69,9.237 L8.363,9.237 L8.363,10.728 Z M7.363,12.728 L25.69,12.728 C26.243,12.728 26.69,12.281 26.69,11.728 L26.69,8.237 C26.69,7.684 26.243,7.237 25.69,7.237 L7.363,7.237 C6.81,7.237 6.363,7.684 6.363,8.237 L6.363,11.728 C6.363,12.281 6.81,12.728 7.363,12.728 L7.363,12.728 Z M31.362,8.364 C32.013,8.364 32.544,8.894 32.544,9.545 C32.544,10.198 32.013,10.728 31.362,10.728 C30.711,10.728 30.18,10.198 30.18,9.545 C30.18,8.894 30.711,8.364 31.362,8.364 L31.362,8.364 Z M31.362,12.728 C33.116,12.728 34.544,11.3 34.544,9.545 C34.544,7.791 33.116,6.364 31.362,6.364 C29.608,6.364 28.18,7.791 28.18,9.545 C28.18,11.3 29.608,12.728 31.362,12.728 L31.362,12.728 Z M39.217,8.364 C39.868,8.364 40.398,8.894 40.398,9.545 C40.398,10.198 39.868,10.728 39.217,10.728 C38.565,10.728 38.035,10.198 38.035,9.545 C38.035,8.894 38.565,8.364 39.217,8.364 L39.217,8.364 Z M39.217,12.728 C40.97,12.728 42.398,11.3 42.398,9.545 C42.398,7.791 40.97,6.364 39.217,6.364 C37.463,6.364 36.035,7.791 36.035,9.545 C36.035,11.3 37.463,12.728 39.217,12.728 L39.217,12.728 Z M43.889,39.442 C43.889,41.895 41.894,43.89 39.441,43.89 L8.447,43.89 C5.995,43.89 4,41.895 4,39.442 L4,8.449 C4,5.995 5.995,4 8.447,4 L39.441,4 C41.894,4 43.889,5.995 43.889,8.449 L43.889,39.442 Z M39.441,2 L8.447,2 C4.892,2 2,4.893 2,8.449 L2,39.442 C2,42.997 4.892,45.89 8.447,45.89 L39.441,45.89 C42.997,45.89 45.889,42.997 45.889,39.442 L45.889,8.449 C45.889,4.893 42.997,2 39.441,2 L39.441,2 Z" id="AWS-System-Manager_state-manager_Resource-Icon_light-bg" fill="#E7157B"></path>
    </g>
</svg>`, SM = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Management-Governance/Res_AWS-CloudFormation_Stack_48</title>
    <g id="Icon-Resource/Management-Governance/Res_AWS-CloudFormation_Stack_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M2,15.353 L45.92,15.353 L45.92,2 L2,2 L2,15.353 Z M4,13.354 L43.92,13.354 L43.92,4 L4,4 L4,13.354 Z M24.706,30.201 L45.92,30.201 L45.92,16.847 L24.706,16.847 L24.706,30.201 Z M26.706,28.2 L43.92,28.2 L43.92,18.847 L26.706,18.847 L26.706,28.2 Z M2,30.201 L23.213,30.201 L23.213,16.847 L2,16.847 L2,30.201 Z M4,28.2 L21.213,28.2 L21.213,18.847 L4,18.847 L4,28.2 Z M32.567,45.047 L45.92,45.047 L45.92,31.694 L32.567,31.694 L32.567,45.047 Z M34.566,43.047 L43.92,43.047 L43.92,33.693 L34.566,33.693 L34.566,43.047 Z M16.847,45.047 L31.073,45.047 L31.073,31.694 L16.847,31.694 L16.847,45.047 Z M18.847,43.047 L29.074,43.047 L29.074,33.693 L18.847,33.693 L18.847,43.047 Z M2,45.047 L15.352,45.047 L15.352,31.694 L2,31.694 L2,45.047 Z M4,43.047 L13.353,43.047 L13.353,33.693 L4,33.693 L4,43.047 Z" id="AWS-CloudFormation_stack_Resource-Icon_light-bg" fill="#E7157B"></path>
    </g>
</svg>`, bM = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Management-Governance/Res_AWS-OpsWorks_Instances_48</title>
    <g id="Icon-Resource/Management-Governance/Res_AWS-OpsWorks_Instances_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M19.738,43.966 L28.23,43.966 L28.23,35.475 L19.738,35.475 L19.738,43.966 Z M29.23,33.475 L18.738,33.475 C18.185,33.475 17.738,33.922 17.738,34.475 L17.738,44.966 C17.738,45.519 18.185,45.966 18.738,45.966 L29.23,45.966 C29.782,45.966 30.23,45.519 30.23,44.966 L30.23,34.475 C30.23,33.922 29.782,33.475 29.23,33.475 L29.23,33.475 Z M35.475,43.966 L43.967,43.966 L43.967,35.475 L35.475,35.475 L35.475,43.966 Z M44.967,33.475 L34.475,33.475 C33.922,33.475 33.475,33.922 33.475,34.475 L33.475,44.966 C33.475,45.519 33.922,45.966 34.475,45.966 L44.967,45.966 C45.52,45.966 45.967,45.519 45.967,44.966 L45.967,34.475 C45.967,33.922 45.52,33.475 44.967,33.475 L44.967,33.475 Z M4,43.966 L12.492,43.966 L12.492,35.475 L4,35.475 L4,43.966 Z M13.492,33.475 L3,33.475 C2.448,33.475 2,33.922 2,34.475 L2,44.966 C2,45.519 2.448,45.966 3,45.966 L13.492,45.966 C14.045,45.966 14.492,45.519 14.492,44.966 L14.492,34.475 C14.492,33.922 14.045,33.475 13.492,33.475 L13.492,33.475 Z M19.738,28.229 L28.23,28.229 L28.23,19.738 L19.738,19.738 L19.738,28.229 Z M29.23,17.737 L18.738,17.737 C18.185,17.737 17.738,18.185 17.738,18.737 L17.738,29.229 C17.738,29.781 18.185,30.229 18.738,30.229 L29.23,30.229 C29.782,30.229 30.23,29.781 30.23,29.229 L30.23,18.737 C30.23,18.185 29.782,17.737 29.23,17.737 L29.23,17.737 Z M35.475,28.229 L43.967,28.229 L43.967,19.738 L35.475,19.738 L35.475,28.229 Z M44.967,17.737 L34.475,17.737 C33.922,17.737 33.475,18.185 33.475,18.737 L33.475,29.229 C33.475,29.781 33.922,30.229 34.475,30.229 L44.967,30.229 C45.52,30.229 45.967,29.781 45.967,29.229 L45.967,18.737 C45.967,18.185 45.52,17.737 44.967,17.737 L44.967,17.737 Z M4,28.229 L12.492,28.229 L12.492,19.738 L4,19.738 L4,28.229 Z M13.492,17.737 L3,17.737 C2.448,17.737 2,18.185 2,18.737 L2,29.229 C2,29.781 2.448,30.229 3,30.229 L13.492,30.229 C14.045,30.229 14.492,29.781 14.492,29.229 L14.492,18.737 C14.492,18.185 14.045,17.737 13.492,17.737 L13.492,17.737 Z M19.738,12.491 L28.23,12.491 L28.23,4 L19.738,4 L19.738,12.491 Z M29.23,2 L18.738,2 C18.185,2 17.738,2.447 17.738,3 L17.738,13.491 C17.738,14.044 18.185,14.491 18.738,14.491 L29.23,14.491 C29.782,14.491 30.23,14.044 30.23,13.491 L30.23,3 C30.23,2.447 29.782,2 29.23,2 L29.23,2 Z M35.475,12.491 L43.967,12.491 L43.967,4 L35.475,4 L35.475,12.491 Z M44.967,2 L34.475,2 C33.922,2 33.475,2.447 33.475,3 L33.475,13.491 C33.475,14.044 33.922,14.491 34.475,14.491 L44.967,14.491 C45.52,14.491 45.967,14.044 45.967,13.491 L45.967,3 C45.967,2.447 45.52,2 44.967,2 L44.967,2 Z M4,12.491 L12.492,12.491 L12.492,4 L4,4 L4,12.491 Z M13.492,2 L3,2 C2.448,2 2,2.447 2,3 L2,13.491 C2,14.044 2.448,14.491 3,14.491 L13.492,14.491 C14.045,14.491 14.492,14.044 14.492,13.491 L14.492,3 C14.492,2.447 14.045,2 13.492,2 L13.492,2 Z" id="AWS-OpsWorks-instances_Resource-Icon_light-bg" fill="#E7157B"></path>
    </g>
</svg>`, EM = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Management-Governance/Res_AWS-Systems-Manager_Run-Command_48</title>
    <g id="Icon-Resource/Management-Governance/Res_AWS-Systems-Manager_Run-Command_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M2,27.6299 L10.815,27.6299 L10.815,25.6299 L2,25.6299 L2,27.6299 Z M2,21.4599 L12.578,21.4599 L12.578,19.4599 L2,19.4599 L2,21.4599 Z M2,15.2889 L14.341,15.2889 L14.341,13.2889 L2,13.2889 L2,15.2889 Z M34.715,25.6299 L20.91,25.6299 L22.174,20.5779 L35.979,20.5779 L34.715,25.6299 Z M20.611,18.5779 L18.35,27.6299 L36.277,27.6299 L38.539,18.5779 L20.611,18.5779 Z M38.279,36.7729 C38.24,36.9559 38.076,37.0889 37.889,37.0889 L13.424,37.0889 C13.258,37.0889 13.158,36.9959 13.113,36.9409 C13.069,36.8859 12.999,36.7689 13.033,36.6069 L17.566,15.2399 L42.846,15.2399 L38.279,36.7729 Z M19,9.9999 L43.466,9.9999 C43.631,9.9999 43.731,10.0929 43.776,10.1479 C43.82,10.2029 43.891,10.3189 43.856,10.4829 L43.271,13.2399 L17.99,13.2399 L18.611,10.3169 C18.65,10.1329 18.813,9.9999 19,9.9999 L19,9.9999 Z M45.329,8.8889 C44.872,8.3239 44.193,7.9999 43.466,7.9999 L19,7.9999 C17.873,7.9999 16.887,8.7999 16.653,9.9019 L11.076,36.1929 C10.926,36.9029 11.102,37.6349 11.56,38.1999 C12.017,38.7649 12.696,39.0889 13.424,39.0889 L37.889,39.0889 C39.015,39.0889 40.001,38.2899 40.236,37.1879 L45.813,10.8969 C45.963,10.1859 45.787,9.4529 45.329,8.8889 L45.329,8.8889 Z" id="AWS-System-Manager_run-command_Resource-Icon_light-bg" fill="#E7157B"></path>
    </g>
</svg>`, IM = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Management-Governance/Res_AWS-OpsWorks_Deployments_48</title>
    <g id="Icon-Resource/Management-Governance/Res_AWS-OpsWorks_Deployments_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M42.5066,38.6768 L35.4876,45.6958 C35.2926,45.8908 35.0366,45.9888 34.7806,45.9888 C34.5256,45.9888 34.2696,45.8908 34.0736,45.6958 L27.0556,38.6768 L28.4696,37.2628 L33.7806,42.5738 L33.7806,25.9338 C33.7806,25.7268 33.6686,25.5308 33.4736,25.3998 L24.2526,19.1808 L15.0326,25.3998 C14.8406,25.5298 14.7256,25.7298 14.7256,25.9338 L14.7256,42.5738 L20.0366,37.2628 L21.4506,38.6768 L14.4326,45.6958 C14.2366,45.8908 13.9816,45.9888 13.7256,45.9888 C13.4696,45.9888 13.2136,45.8908 13.0186,45.6958 L5.9996,38.6768 L7.4136,37.2628 L12.7256,42.5738 L12.7256,25.9338 C12.7256,25.0638 13.1696,24.2438 13.9136,23.7418 L23.2526,17.4438 L23.2526,1.9998 L25.2526,1.9998 L25.2526,17.4428 L34.5916,23.7408 C35.3356,24.2428 35.7806,25.0638 35.7806,25.9338 L35.7806,42.5738 L41.0926,37.2628 L42.5066,38.6768 Z" id="AWS-OpsWorks-deployments_Resource-Icon_light-bg" fill="#E7157B"></path>
    </g>
</svg>`, FM = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Management-Governance/Res_AWS-Systems-Manager_Automation_48</title>
    <g id="Icon-Resource/Management-Governance/Res_AWS-Systems-Manager_Automation_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M36.1575,15.6748 L37.9405,16.5808 L34.9715,22.4158 C34.7965,22.7618 34.4455,22.9628 34.0795,22.9628 C33.9435,22.9628 33.8045,22.9348 33.6735,22.8758 L27.4805,20.1118 L28.2955,18.2848 L32.1665,20.0128 C30.6755,16.9678 27.5405,14.9228 24.0335,14.9228 C19.7535,14.9228 16.0235,17.9678 15.1655,22.1628 L13.2065,21.7628 C14.2545,16.6408 18.8075,12.9228 24.0335,12.9228 C28.4855,12.9228 32.4405,15.6248 34.1655,19.5908 L36.1575,15.6748 Z M32.9025,25.7818 L34.8615,26.1828 C33.8165,31.3038 29.2625,35.0218 24.0345,35.0218 C19.9175,35.0218 16.2675,32.7818 14.3675,29.3268 L13.6235,32.8868 L11.6665,32.4768 L13.0065,26.0688 C13.1155,25.5478 13.6265,25.2118 14.1385,25.2848 L20.8385,26.3338 L20.5295,28.3108 L15.7215,27.5578 C17.1235,30.8378 20.3525,33.0218 24.0345,33.0218 C28.3165,33.0218 32.0465,29.9768 32.9025,25.7818 L32.9025,25.7818 Z M43.9455,27.0818 L41.5225,26.9448 C41.0565,26.9208 40.5975,27.2438 40.4905,27.7228 C40.0675,29.5958 39.3325,31.3708 38.3035,33.0018 C38.0435,33.4148 38.1195,33.9558 38.4835,34.2808 L40.2945,35.8968 L35.8975,40.2938 L34.2875,38.4888 C33.9615,38.1238 33.4185,38.0498 33.0075,38.3098 C31.3805,39.3388 29.6015,40.0748 27.7215,40.4998 C27.2455,40.6088 26.9165,41.0448 26.9445,41.5318 L27.0825,43.9448 L20.8635,43.9448 L21.0015,41.5298 C21.0295,41.0428 20.7005,40.6068 20.2235,40.4978 C18.3505,40.0738 16.5735,39.3368 14.9405,38.3068 C14.5285,38.0468 13.9855,38.1218 13.6615,38.4868 L12.0495,40.2938 L7.6515,35.8968 L9.4585,34.2848 C9.8225,33.9598 9.8985,33.4188 9.6375,33.0058 C8.6115,31.3788 7.8765,29.6018 7.4525,27.7228 C7.3445,27.2438 6.8815,26.9208 6.4205,26.9448 L4.0005,27.0818 L4.0005,20.8628 L6.4275,21.0008 C6.9045,21.0238 7.3495,20.6998 7.4595,20.2248 C7.8835,18.3538 8.6205,16.5798 9.6485,14.9508 C9.9095,14.5378 9.8335,13.9958 9.4695,13.6708 L7.6505,12.0488 L12.0495,7.6508 L13.6705,9.4678 C13.9945,9.8318 14.5375,9.9058 14.9495,9.6478 C16.5755,8.6218 18.3495,7.8878 20.2225,7.4648 C20.7005,7.3578 21.0295,6.9208 21.0015,6.4328 L20.8635,3.9998 L27.0825,3.9998 L26.9445,6.4348 C26.9165,6.9228 27.2455,7.3588 27.7215,7.4668 C29.5925,7.8898 31.3655,8.6238 32.9935,9.6518 C33.4035,9.9098 33.9465,9.8348 34.2725,9.4718 L35.8965,7.6518 L40.2945,12.0478 L38.4795,13.6668 C38.1155,13.9918 38.0395,14.5338 38.3005,14.9468 C39.3285,16.5738 40.0645,18.3498 40.4885,20.2238 C40.5955,20.6998 41.0565,21.0238 41.5205,21.0008 L43.9455,20.8628 L43.9455,27.0818 Z M45.6325,19.0778 C45.4325,18.8898 45.1575,18.7888 44.8885,18.8068 L42.2335,18.9568 C41.8165,17.4368 41.2125,15.9798 40.4285,14.6088 L42.4165,12.8358 C42.6215,12.6538 42.7425,12.3938 42.7505,12.1178 C42.7585,11.8438 42.6515,11.5768 42.4575,11.3828 L36.5625,5.4878 C36.3685,5.2938 36.0905,5.2018 35.8275,5.1958 C35.5525,5.2028 35.2925,5.3238 35.1095,5.5288 L33.3315,7.5228 C31.9605,6.7408 30.5055,6.1378 28.9875,5.7218 L29.1385,3.0568 C29.1545,2.7818 29.0565,2.5128 28.8675,2.3138 C28.6785,2.1128 28.4165,1.9998 28.1405,1.9998 L19.8045,1.9998 C19.5295,1.9998 19.2665,2.1128 19.0785,2.3138 C18.8885,2.5128 18.7915,2.7818 18.8065,3.0568 L18.9585,5.7198 C17.4375,6.1348 15.9815,6.7378 14.6115,7.5188 L12.8365,5.5288 C12.6525,5.3238 12.3935,5.2028 12.1185,5.1958 C11.8355,5.2048 11.5775,5.2938 11.3835,5.4878 L5.4885,11.3828 C5.2945,11.5768 5.1875,11.8428 5.1955,12.1178 C5.2035,12.3938 5.3245,12.6528 5.5295,12.8358 L7.5195,14.6128 C6.7365,15.9838 6.1325,17.4398 5.7155,18.9578 L3.0565,18.8068 C2.7885,18.7878 2.5125,18.8898 2.3135,19.0778 C2.1135,19.2668 2.0005,19.5288 2.0005,19.8048 L2.0005,28.1408 C2.0005,28.4158 2.1135,28.6788 2.3135,28.8668 C2.5125,29.0558 2.7895,29.1518 3.0565,29.1388 L5.7075,28.9878 C6.1235,30.5128 6.7275,31.9718 7.5095,33.3438 L5.5295,35.1098 C5.3245,35.2918 5.2035,35.5518 5.1955,35.8268 C5.1875,36.1018 5.2945,36.3678 5.4885,36.5628 L11.3835,42.4568 C11.5775,42.6518 11.8325,42.7418 12.1185,42.7498 C12.3935,42.7418 12.6535,42.6208 12.8365,42.4158 L14.6025,40.4358 C15.9775,41.2198 17.4365,41.8248 18.9575,42.2418 L18.8065,44.8878 C18.7915,45.1618 18.8885,45.4308 19.0785,45.6308 C19.2665,45.8308 19.5295,45.9448 19.8045,45.9448 L28.1405,45.9448 C28.4165,45.9448 28.6785,45.8308 28.8675,45.6308 C29.0565,45.4308 29.1545,45.1618 29.1385,44.8878 L28.9885,42.2448 C30.5135,41.8268 31.9735,41.2228 33.3455,40.4388 L35.1095,42.4158 C35.2925,42.6208 35.5525,42.7418 35.8275,42.7498 C36.0935,42.7448 36.3685,42.6518 36.5625,42.4568 L42.4575,36.5628 C42.6515,36.3678 42.7585,36.1018 42.7505,35.8268 C42.7425,35.5518 42.6215,35.2918 42.4165,35.1098 L40.4325,33.3398 C41.2165,31.9668 41.8195,30.5088 42.2355,28.9878 L44.8885,29.1388 C45.1565,29.1508 45.4325,29.0558 45.6325,28.8668 C45.8325,28.6788 45.9455,28.4158 45.9455,28.1408 L45.9455,19.8048 C45.9455,19.5288 45.8325,19.2668 45.6325,19.0778 L45.6325,19.0778 Z" id="AWS-System-Manager_automation_Resource-Icon_light-bg" fill="#E7157B"></path>
    </g>
</svg>`, OM = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Management-Governance/Res_AWS-Systems-Manager_Change-Calendar_48</title>
    <g id="Icon-Resource/Management-Governance/Res_AWS-Systems-Manager_Change-Calendar_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M41.958,26.206 L43.938,26.489 C42.506,36.503 33.726,44.348 23.948,44.348 C15.346,44.348 7.52,38.273 4.787,29.992 L3.896,32.664 L2,32.031 L4,26.031 C4.103,25.721 4.352,25.481 4.665,25.389 C4.979,25.298 5.318,25.363 5.573,25.567 L10.573,29.567 L9.323,31.128 L6.555,28.913 C8.879,36.629 16.045,42.348 23.948,42.348 C32.753,42.348 40.664,35.257 41.958,26.206 L41.958,26.206 Z M5.938,22.489 L3.958,22.206 C5.419,11.997 14.199,4 23.948,4 C32.543,4 40.378,10.219 43.115,18.686 L44,16.031 L45.896,16.664 L43.896,22.664 C43.794,22.974 43.545,23.214 43.231,23.307 C43.139,23.334 43.043,23.348 42.948,23.348 C42.724,23.348 42.503,23.272 42.323,23.128 L37.323,19.128 L38.573,17.567 L41.353,19.791 C39.03,11.875 31.848,6 23.948,6 C15.172,6 7.261,13.243 5.938,22.489 L5.938,22.489 Z M28.948,32 L30.948,32 L30.948,30 L28.948,30 L28.948,32 Z M28.948,28 L30.948,28 L30.948,26 L28.948,26 L28.948,28 Z M24.948,32 L26.948,32 L26.948,30 L24.948,30 L24.948,32 Z M24.948,28 L26.948,28 L26.948,26 L24.948,26 L24.948,28 Z M20.948,32 L22.948,32 L22.948,30 L20.948,30 L20.948,32 Z M20.948,28 L22.948,28 L22.948,26 L20.948,26 L20.948,28 Z M16.948,32 L18.948,32 L18.948,30 L16.948,30 L16.948,32 Z M16.948,28 L18.948,28 L18.948,26 L16.948,26 L16.948,28 Z M16.948,24 L18.948,24 L18.948,22 L16.948,22 L16.948,24 Z M28.948,24 L30.948,24 L30.948,22 L28.948,22 L28.948,24 Z M24.948,24 L26.948,24 L26.948,22 L24.948,22 L24.948,24 Z M20.948,24 L22.948,24 L22.948,22 L20.948,22 L20.948,24 Z M20.948,15 L20.948,16 L22.948,16 L22.948,15 L24.948,15 L24.948,16 L26.948,16 L26.948,15 L28.948,15 L28.948,16 L30.948,16 L30.948,15 L32.948,15 L32.948,18 L14.948,18 L14.948,15 L16.948,15 L16.948,16 L18.948,16 L18.948,15 L20.948,15 Z M14.948,34 L32.948,34 L32.948,20 L14.948,20 L14.948,34 Z M16.948,12 L16.948,13 L13.948,13 C13.396,13 12.948,13.448 12.948,14 L12.948,19 L12.948,35 C12.948,35.552 13.396,36 13.948,36 L33.948,36 C34.501,36 34.948,35.552 34.948,35 L34.948,19 L34.948,14 C34.948,13.448 34.501,13 33.948,13 L30.948,13 L30.948,12 L28.948,12 L28.948,13 L26.948,13 L26.948,12 L24.948,12 L24.948,13 L22.948,13 L22.948,12 L20.948,12 L20.948,13 L18.948,13 L18.948,12 L16.948,12 Z" id="Fill-1" fill="#E7157B"></path>
    </g>
</svg>`, NM = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Management-Governance/Res_AWS-Organizations_Organizational-Unit_48</title>
    <g id="Icon-Resource/Management-Governance/Res_AWS-Organizations_Organizational-Unit_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M34,30 C36.757,30 39,32.243 39,35 C39,37.757 36.757,40 34,40 C31.243,40 29,37.757 29,35 C29,32.243 31.243,30 34,30 L34,30 Z M34,42 C37.859,42 41,38.86 41,35 C41,31.14 37.859,28 34,28 C30.141,28 27,31.14 27,35 C27,38.86 30.141,42 34,42 L34,42 Z M35.831,15.503 L39.579,23 L32.083,23 L35.831,15.503 Z M30.465,25 L41.197,25 C41.544,25 41.865,24.82 42.048,24.526 C42.23,24.231 42.247,23.863 42.092,23.553 L36.726,12.82 C36.386,12.143 35.276,12.143 34.937,12.82 L29.57,23.553 C29.415,23.863 29.432,24.231 29.614,24.526 C29.797,24.82 30.118,25 30.465,25 L30.465,25 Z M14,32 L23,32 L23,23 L14,23 L14,32 Z M13,34 L24,34 C24.553,34 25,33.552 25,33 L25,22 C25,21.448 24.553,21 24,21 L13,21 C12.447,21 12,21.448 12,22 L12,33 C12,33.552 12.447,34 13,34 L13,34 Z M4,38 L6,38 L6,40 L3,40 C2.447,40 2,39.552 2,39 L2,3 C2,2.448 2.447,2 3,2 L39,2 C39.553,2 40,2.448 40,3 L40,6 L38,6 L38,4 L4,4 L4,38 Z M10,44 L44,44 L44,10 L10,10 L10,44 Z M45,8 L9,8 C8.447,8 8,8.448 8,9 L8,45 C8,45.552 8.447,46 9,46 L45,46 C45.553,46 46,45.552 46,45 L46,9 C46,8.448 45.553,8 45,8 L45,8 Z" id="Fill-1" fill="#E7157B"></path>
    </g>
</svg>`, DM = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Management-Governance/Res_AWS-Systems-Manager_Session-Manager_48</title>
    <g id="Icon-Resource/Management-Governance/Res_AWS-Systems-Manager_Session-Manager_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M4,41 L25,41 L25,39 L4,39 L4,41 Z M14,44 L15,44 L15,43 L14,43 L14,44 Z M25,37 L4,37 L4,25 L10,25 L10,23 L3,23 C2.447,23 2,23.448 2,24 L2,42 C2,42.552 2.447,43 3,43 L12,43 L12,44 L8,44 L8,46 L21,46 L21,44 L17,44 L17,43 L26,43 C26.553,43 27,42.552 27,42 L27,36 L25,36 L25,37 Z M27,7 L29,7 L29,5 L27,5 L27,7 Z M27,13 L29,13 L29,11 L27,11 L27,13 Z M26,8 L44,8 L44,4 L26,4 L26,8 Z M45,2 L25,2 C24.447,2 24,2.448 24,3 L24,12 L26,12 L26,10 L44,10 L44,14 L29,14 L29,16 L44,16 L44,20 L37,20 L37,22 L45,22 C45.553,22 46,21.552 46,21 L46,20 L46,14.336 L46,14 L46,8.075 L46,3 C46,2.448 45.553,2 45,2 L45,2 Z M34.481,32 L16.955,31.981 C15.012,31.979 13.144,30.387 12.958,28.571 C12.94,28.401 12.932,28.224 12.932,28.039 C12.932,25.421 14.727,24.532 15.841,24.233 C15.874,24.227 15.907,24.218 15.939,24.208 C16.405,24.068 16.703,23.613 16.644,23.13 C16.614,22.889 16.6,22.644 16.6,22.395 C16.6,20.226 18.15,17.806 20.056,16.999 C23.427,15.572 25.812,17.45 26.684,18.322 C27.397,19.039 27.956,19.959 28.346,21.058 C28.469,21.407 28.774,21.659 29.141,21.714 C29.511,21.769 29.873,21.616 30.093,21.319 C30.566,20.677 31.328,20.397 32.035,20.603 C32.911,20.859 33.494,21.78 33.607,23.077 C33.562,23.59 33.919,24.059 34.435,24.147 C35.506,24.332 38,25.084 38,28.081 C38,31.574 34.764,31.97 34.481,32 L34.481,32 Z M35.528,22.346 C35.211,20.483 34.146,19.136 32.596,18.683 C31.586,18.389 30.536,18.541 29.657,19.062 C29.232,18.245 28.712,17.524 28.1,16.91 C25.69,14.494 22.392,13.838 19.276,15.157 C16.61,16.286 14.6,19.397 14.6,22.395 C14.6,22.442 14.6,22.489 14.601,22.536 C12.287,23.433 10.932,25.437 10.932,28.039 C10.932,28.297 10.944,28.543 10.969,28.777 C11.257,31.595 13.997,33.979 16.953,33.981 L34.562,33.997 C36.442,33.844 40,32.411 40,28.081 C40,24.756 37.81,22.983 35.528,22.346 L35.528,22.346 Z" id="Fill-1" fill="#E7157B"></path>
    </g>
</svg>`, PM = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Management-Governance/Res_AWS-Trusted-Advisor_Checklist-Cost_48</title>
    <g id="Icon-Resource/Management-Governance/Res_AWS-Trusted-Advisor_Checklist-Cost_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M27.3655,27.0527 C27.3655,27.0047 27.3535,26.9117 27.2735,26.8317 C27.1975,26.7557 27.1125,26.7407 27.0535,26.7407 C27.0055,26.7407 26.9125,26.7517 26.8325,26.8317 C26.7525,26.9117 26.7405,27.0047 26.7405,27.0527 C26.7405,27.1127 26.7565,27.1977 26.8315,27.2727 C27.0125,27.4547 27.1365,27.4097 27.2725,27.2747 L27.2745,27.2727 C27.3495,27.1977 27.3655,27.1127 27.3655,27.0527 L27.3655,27.0527 Z M28.6885,25.4187 C29.1245,25.8547 29.3655,26.4357 29.3655,27.0527 C29.3655,27.6707 29.1245,28.2507 28.6875,28.6877 C28.2515,29.1237 27.6715,29.3657 27.0535,29.3657 C26.4355,29.3657 25.8545,29.1237 25.4185,28.6877 C24.9815,28.2517 24.7405,27.6707 24.7405,27.0527 C24.7405,26.4357 24.9815,25.8547 25.4185,25.4177 C26.2925,24.5447 27.8165,24.5457 28.6885,25.4187 L28.6885,25.4187 Z M43.5785,36.2437 L31.4565,24.1207 L24.1215,24.1207 L24.1215,31.4557 L36.2445,43.5777 L43.5785,36.2437 Z M45.6995,36.9507 L36.9515,45.6987 C36.7565,45.8947 36.5005,45.9917 36.2445,45.9917 C35.9885,45.9917 35.7325,45.8947 35.5375,45.6987 L22.4145,32.5767 C22.2265,32.3897 22.1215,32.1357 22.1215,31.8697 L22.1215,23.1207 C22.1215,22.5687 22.5685,22.1207 23.1215,22.1207 L31.8705,22.1207 C32.1365,22.1207 32.3895,22.2267 32.5775,22.4137 L45.6995,35.5367 C46.0905,35.9277 46.0905,36.5607 45.6995,36.9507 L45.6995,36.9507 Z M6.3285,26.6757 L4.9225,28.0977 L7.7205,30.8667 C7.9085,31.0527 8.1615,31.1567 8.4245,31.1567 C8.4475,31.1567 8.4705,31.1557 8.4955,31.1537 C8.7825,31.1327 9.0475,30.9907 9.2205,30.7607 L13.4205,25.2207 L11.8265,24.0117 L8.3165,28.6427 L6.3285,26.6757 Z M11.8265,14.6807 L8.3165,19.3117 L6.3285,17.3437 L4.9225,18.7657 L7.7205,21.5357 C7.9085,21.7217 8.1615,21.8247 8.4245,21.8247 C8.4475,21.8247 8.4705,21.8237 8.4955,21.8227 C8.7825,21.8017 9.0475,21.6587 9.2205,21.4287 L13.4205,15.8877 L11.8265,14.6807 Z M11.8265,5.3487 L8.3165,9.9797 L6.3285,8.0127 L4.9225,9.4347 L7.7205,12.2037 C7.9085,12.3897 8.1615,12.4927 8.4245,12.4927 C8.4475,12.4927 8.4705,12.4917 8.4955,12.4897 C8.7825,12.4697 9.0475,12.3267 9.2205,12.0977 L13.4205,6.5577 L11.8265,5.3487 Z M15.2485,29.3697 L20.4975,29.3697 L20.4975,27.3697 L15.2485,27.3697 L15.2485,29.3697 Z M15.2485,20.6217 L26.6215,20.6217 L26.6215,18.6217 L15.2485,18.6217 L15.2485,20.6217 Z M15.2485,10.9987 L26.6215,10.9987 L26.6215,8.9987 L15.2485,8.9987 L15.2485,10.9987 Z M4.0005,34.3687 L23.1215,34.3687 L23.1215,36.3687 L3.0005,36.3687 C2.4475,36.3687 2.0005,35.9217 2.0005,35.3687 L2.0005,2.9997 C2.0005,2.4477 2.4475,1.9997 3.0005,1.9997 L29.2455,1.9997 C29.7985,1.9997 30.2455,2.4477 30.2455,2.9997 L30.2455,20.4967 L28.2455,20.4967 L28.2455,3.9997 L4.0005,3.9997 L4.0005,34.3687 Z" id="AWS-Trusted-Advisor_checklist-cost_Resource-Icon_light-bg" fill="#E7157B"></path>
    </g>
</svg>`, BM = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Management-Governance/Res_AWS-OpsWorks_Stack2_48</title>
    <g id="Icon-Resource/Management-Governance/Res_AWS-OpsWorks_Stack2_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M4,43.953 L43.953,43.953 L43.953,4 L4,4 L4,43.953 Z M44.953,2 L3,2 C2.448,2 2,2.447 2,3 L2,44.953 C2,45.506 2.448,45.953 3,45.953 L44.953,45.953 C45.506,45.953 45.953,45.506 45.953,44.953 L45.953,3 C45.953,2.447 45.506,2 44.953,2 L44.953,2 Z" id="AWS-OpsWorks-stack2_Resource-Icon_dark-bg" fill="#E7157B"></path>
    </g>
</svg>`, zM = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Management-Governance/Res_AWS-License-Manager_Application-Discovery_48</title>
    <g id="Icon-Resource/Management-Governance/Res_AWS-License-Manager_Application-Discovery_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M15.833,15.684 C15.846,15.684 15.858,15.684 15.871,15.684 C16.099,15.684 16.315,15.767 16.483,15.922 C16.661,16.086 16.766,16.309 16.775,16.552 C16.785,16.793 16.701,17.024 16.537,17.202 C16.373,17.38 16.15,17.484 15.908,17.494 C15.406,17.513 14.986,17.126 14.966,16.627 C14.945,16.128 15.334,15.705 15.833,15.684 L15.833,15.684 Z M8.97,13.962 L8.512,23.761 L16.245,31.485 C17.145,31.567 18.2,31.71 19.1,31.619 L10.472,23.001 L10.835,15.233 C11.672,15.775 12.419,16.228 12.977,16.553 C12.977,16.606 12.966,16.657 12.968,16.711 C13.033,18.27 14.322,19.495 15.869,19.495 C15.91,19.495 15.951,19.494 15.992,19.492 C16.768,19.46 17.484,19.127 18.01,18.556 C18.534,17.985 18.806,17.243 18.773,16.468 C18.707,14.867 17.347,13.622 15.749,13.686 C14.932,13.72 14.209,14.093 13.704,14.661 C12.828,14.142 11.885,13.54 10.944,12.894 L11.019,11.308 L22.711,10.741 L31.537,19.557 C31.652,18.689 31.586,17.815 31.539,16.942 L23.468,8.78 L9.18,9.472 L9.083,11.543 C6.611,9.641 4.526,7.553 4.301,5.962 C4.225,5.42 4.377,4.993 4.838,4.533 C4.856,4.514 5.291,4.064 6.068,4.102 C7.241,4.171 8.705,5.323 10.161,7.304 L10.693,8.115 L12.365,7.017 L11.803,6.163 C9.876,3.538 7.957,2.171 6.102,2.102 C4.403,2.033 3.434,3.097 3.387,3.158 C2.524,4.013 2.156,5.08 2.321,6.242 C2.699,8.917 5.979,11.822 8.97,13.962 L8.97,13.962 Z M43.163,43.259 C42.27,44.15 40.821,44.15 39.929,43.259 L28.483,31.813 C29.709,30.893 30.802,29.811 31.731,28.593 L43.163,40.025 C43.593,40.454 43.829,41.028 43.829,41.642 C43.829,42.255 43.593,42.829 43.163,43.259 L43.163,43.259 Z M32.867,26.901 C34.302,24.45 35.138,21.608 35.138,18.569 C35.138,9.433 27.705,2 18.569,2 C16.208,2 13.966,2.505 11.931,3.398 L13.259,5.017 C14.906,4.369 16.694,4 18.569,4 C26.603,4 33.138,10.536 33.138,18.569 C33.138,22.305 31.713,25.706 29.393,28.287 C28.784,28.963 28.116,29.581 27.394,30.134 C24.941,32.01 21.888,33.138 18.569,33.138 C15.085,33.138 11.885,31.906 9.376,29.858 C8.646,29.264 7.977,28.601 7.374,27.878 C5.27,25.352 4,22.107 4,18.569 C4,16.672 4.376,14.864 5.038,13.2 L3.488,11.745 C2.541,13.829 2,16.135 2,18.569 C2,27.705 9.433,35.138 18.569,35.138 C21.559,35.138 24.357,34.331 26.782,32.94 L38.515,44.673 C39.351,45.509 40.448,45.927 41.546,45.927 C42.644,45.927 43.741,45.509 44.577,44.673 C45.385,43.866 45.829,42.789 45.829,41.642 C45.829,40.494 45.385,39.417 44.577,38.611 L32.867,26.901 Z" id="Fill-1" fill="#E7157B"></path>
    </g>
</svg>`, UM = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Management-Governance/Res_AWS-Systems-Manager_OpsCenter_48</title>
    <g id="Icon-Resource/Management-Governance/Res_AWS-Systems-Manager_OpsCenter_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M14.4093,14.748 L12.9953,16.162 L20.8003,23.967 L37.3023,3.797 L35.7533,2.531 L20.6513,20.99 L14.4093,14.748 Z M43.0083,37.685 L38.2393,33.26 L33.0923,38.407 L37.8473,42.805 C39.2813,44.198 41.5473,44.167 42.9223,42.755 C44.3433,41.363 44.3733,39.097 43.0083,37.685 L43.0083,37.685 Z M30.6283,36.128 L31.6233,37.048 L36.7733,31.897 L35.8533,31.044 C35.2163,31.969 34.4993,32.849 33.6883,33.66 C32.7483,34.602 31.7193,35.42 30.6283,36.128 L30.6283,36.128 Z M44.3393,44.167 C43.2583,45.277 41.8133,45.836 40.3653,45.836 C38.9633,45.836 37.5573,45.312 36.4733,44.259 L28.8013,37.162 C26.2713,38.419 23.4753,39.102 20.5693,39.103 L20.5573,39.103 C15.6043,39.103 10.9483,37.177 7.4433,33.676 C3.9363,30.173 2.0033,25.514 2.00025985,20.557 C1.9953,18.141 2.4573,15.782 3.3753,13.548 L5.2243,14.308 C4.5343,15.988 4.1513,17.752 4.0463,19.556 L9.1453,19.556 L9.1453,21.556 L4.0493,21.556 C4.2923,25.602 5.9663,29.373 8.8563,32.261 C11.7463,35.146 15.5163,36.814 19.5583,37.055 L19.5583,31.969 L21.5583,31.969 L21.5583,37.055 C25.6073,36.813 29.3833,35.141 32.2733,32.247 C35.1573,29.36 36.8253,25.594 37.0673,21.556 L31.9713,21.556 L31.9713,19.556 L37.0813,19.556 C36.9133,16.744 36.0393,14.024 34.5173,11.639 L36.2033,10.562 C38.1063,13.547 39.1143,16.995 39.1163,20.534 C39.1183,23.646 38.3563,26.643 36.9243,29.31 L44.4073,36.258 C46.5733,38.494 46.5253,42.025 44.3393,44.167 L44.3393,44.167 Z M9.7983,8.005 L8.4933,6.489 C6.8573,7.897 5.4893,9.567 4.4293,11.453 L6.1713,12.434 C7.1183,10.752 8.3393,9.262 9.7983,8.005 L9.7983,8.005 Z M11.5673,6.646 L10.4813,4.967 C16.5673,1.031 24.4463,1.01 30.5523,4.911 L29.4753,6.597 C27.0553,5.05 24.3233,4.198 21.5583,4.032 L21.5583,9.143 L19.5583,9.143 L19.5583,4.035 C16.7643,4.203 14.0053,5.07 11.5673,6.646 L11.5673,6.646 Z" id="AWS-System-Manager_OpsCenter_Resource-Icon_light-bg" fill="#E7157B"></path>
    </g>
</svg>`, WM = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Management-Governance/Res_AWS-Systems-Manager_Inventory_48</title>
    <g id="Icon-Resource/Management-Governance/Res_AWS-Systems-Manager_Inventory_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M23.945,2 L2,14.54 L2,46.041 L45.89,46.041 L45.89,14.54 L23.945,2 Z M4,15.7 L23.945,4.302 L43.89,15.7 L43.89,44.041 L4,44.041 L4,15.7 Z M7.237,42.55 L40.654,42.55 L40.654,16.114 L7.237,16.114 L7.237,42.55 Z M9.236,40.551 L38.653,40.551 L38.653,18.115 L9.236,18.115 L9.236,40.551 Z M17.709,25.097 L23.199,25.097 L23.199,19.605 L17.709,19.605 L17.709,25.097 Z M19.709,23.096 L21.199,23.096 L21.199,21.605 L19.709,21.605 L19.709,23.096 Z M10.728,25.097 L16.218,25.097 L16.218,19.605 L10.728,19.605 L10.728,25.097 Z M12.727,23.096 L14.217,23.096 L14.217,21.605 L12.727,21.605 L12.727,23.096 Z M24.69,32.078 L30.181,32.078 L30.181,26.586 L24.69,26.586 L24.69,32.078 Z M26.691,30.077 L28.181,30.077 L28.181,28.587 L26.691,28.587 L26.691,30.077 Z M17.709,32.078 L23.199,32.078 L23.199,26.586 L17.709,26.586 L17.709,32.078 Z M19.709,30.077 L21.199,30.077 L21.199,28.587 L19.709,28.587 L19.709,30.077 Z M10.728,32.078 L16.218,32.078 L16.218,26.586 L10.728,26.586 L10.728,32.078 Z M12.727,30.077 L14.217,30.077 L14.217,28.587 L12.727,28.587 L12.727,30.077 Z M31.672,39.059 L37.164,39.059 L37.164,33.567 L31.672,33.567 L31.672,39.059 Z M33.672,37.059 L35.163,37.059 L35.163,35.568 L33.672,35.568 L33.672,37.059 Z M24.69,39.059 L30.181,39.059 L30.181,33.567 L24.69,33.567 L24.69,39.059 Z M26.691,37.059 L28.181,37.059 L28.181,35.568 L26.691,35.568 L26.691,37.059 Z M17.709,39.059 L23.199,39.059 L23.199,33.567 L17.709,33.567 L17.709,39.059 Z M19.709,37.059 L21.199,37.059 L21.199,35.568 L19.709,35.568 L19.709,37.059 Z M10.728,39.059 L16.218,39.059 L16.218,33.567 L10.728,33.567 L10.728,39.059 Z M12.727,37.059 L14.217,37.059 L14.217,35.568 L12.727,35.568 L12.727,37.059 Z" id="AWS-System-Manager_inventory_Resource-Icon_light-bg" fill="#E7157B"></path>
    </g>
</svg>`, HM = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Management-Governance/Res_AWS-OpsWorks_Permissions_48</title>
    <g id="Icon-Resource/Management-Governance/Res_AWS-OpsWorks_Permissions_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M24.2908,28.3223 L24.2928,28.3223 C24.8118,28.3223 25.2998,28.5243 25.6658,28.8913 C26.0318,29.2583 26.2328,29.7443 26.2318037,30.2613 L26.2318037,30.2623 C26.2318037,30.7813 26.0298,31.2683 25.6638,31.6353 C25.2978,32.0003 24.8118,32.2013 24.2928,32.2013 L24.2908,32.2013 C23.2218,32.2013 22.3528,31.3313 22.3528,30.2613 C22.3538,29.1923 23.2228,28.3223 24.2908,28.3223 L24.2908,28.3223 Z M23.2918,34.0563 L23.2918,39.2263 L25.2918,39.2263 L25.2918,34.0573 C25.9598,33.8843 26.5768,33.5503 27.0768,33.0503 C27.8218,32.3053 28.2318018,31.3163 28.2318018,30.2633 C28.2328,29.2123 27.8248,28.2223 27.0808,27.4783 C26.3368,26.7323 25.3468,26.3223 24.2938,26.3223 L24.2888,26.3223 C22.1208,26.3223 20.3548,28.0883 20.3528,30.2603 C20.3528,32.0863 21.6058,33.6113 23.2918,34.0563 L23.2918,34.0563 Z M37.5748,43.9843 L10.9998,43.9723 L11.0068,23.6523 L37.5848,23.6633 L37.5748,43.9843 Z M16.4238,11.7853 C16.4368,7.4873 19.9748,4.0003 24.3128,4.0003 L24.3398,4.0003 C28.6668,4.0133 32.1768,7.5443 32.163836,11.8733 L32.163836,21.6603 L16.3928,21.6543 L16.4238,11.7853 Z M39.2918,21.9563 C39.1038,21.7683 38.8508,21.6633 38.5848,21.6633 L34.1638,21.6613 L34.1638,11.8763 C34.1808,6.4473 29.7758,2.0173 24.3458,2.0003 L24.3128,2.0003 C18.8748,2.0003 14.4408,6.3813 14.4238,11.7793 L14.3928,21.6543 L10.0068,21.6523 C9.7418,21.6523 9.4868,21.7583 9.2998,21.9453 C9.1118,22.1333 9.0068,22.3863 9.0068,22.6523 L8.9998,44.9723 C8.9998,45.5243 9.4468,45.9723 9.9998,45.9723 L38.5748,45.9843 C39.1268,45.9843 39.5748,45.5373 39.5748,44.9843 L39.5848,22.6633 C39.5848,22.3983 39.4788,22.1433 39.2918,21.9563 L39.2918,21.9563 Z" id="AWS-OpsWorks-permissions_Resource-Icon_light-bg" fill="#E7157B"></path>
    </g>
</svg>`, $M = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Management-Governance/Res_AWS-OpsWorks_Apps_48</title>
    <g id="Icon-Resource/Management-Governance/Res_AWS-OpsWorks_Apps_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M45.8967,3 C45.8967,2.447 45.4497,2 44.8967,2 L3.0007,2 C2.4477,2 2.0007,2.447 2.0007,3 L2.0007,14.348 L4.0007,14.348 L4.0007,4 L43.8967,4 L43.8967,14.348 L45.8967,14.348 L45.8967,3 Z M4.0007,43.896 L43.8967,43.896 L43.8967,17.965 L4.0007,17.965 L4.0007,43.896 Z M44.8967,45.896 L3.0007,45.896 C2.4477,45.896 2.0007,45.449 2.0007,44.896 L2.0007,16.966 C2.0007,16.413 2.4477,15.966 3.0007,15.966 L44.8967,15.966 C45.4497,15.966 45.8967,16.413 45.8967,16.966 L45.8967,44.896 C45.8967,45.449 45.4497,45.896 44.8967,45.896 L44.8967,45.896 Z" id="AWS-OpsWorks-Apps_Resource-Icon_light-bg" fill="#E7157B"></path>
    </g>
</svg>`, VM = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Management-Governance/Res_AWS-CloudFormation_Change-Set_48</title>
    <g id="Icon-Resource/Management-Governance/Res_AWS-CloudFormation_Change-Set_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M24.6072,39.9121 L18.2622,39.9121 L18.2622,37.9121 L24.6072,37.9121 L23.6862,36.9911 L25.1002,35.5771 L27.7282,38.2051 C28.1192,38.5961 28.1192,39.2281 27.7282,39.6191 L25.1002,42.2471 L23.6862,40.8331 L24.6072,39.9121 Z M24.6072,25.8971 L18.2622,25.8971 L18.2622,23.8971 L24.6072,23.8971 L23.6862,22.9761 L25.1002,21.5621 L27.7282,24.1901 C28.1192,24.5811 28.1192,25.2141 27.7282,25.6041 L25.1002,28.2321 L23.6862,26.8181 L24.6072,25.8971 Z M24.6072,11.8831 L18.2622,11.8831 L18.2622,9.8831 L24.6072,9.8831 L23.6862,8.9621 L25.1002,7.5481 L27.7282,10.1761 C28.1192,10.5661 28.1192,11.1991 27.7282,11.5901 L25.1002,14.2181 L23.6862,12.8041 L24.6072,11.8831 Z M38.2392,36.1151 L35.8802,38.4751 L38.2392,40.8331 L36.8252,42.2471 L34.4662,39.8891 L32.1082,42.2471 L30.6942,40.8331 L33.0522,38.4751 L30.6942,36.1151 L32.1082,34.7011 L34.4662,37.0591 L36.8252,34.7011 L38.2392,36.1151 Z M33.5902,9.4201 L35.8222,13.3871 L31.3592,13.3871 L33.5902,9.4201 Z M29.6492,15.3871 L37.5322,15.3871 C37.8872,15.3871 38.2152,15.1981 38.3952,14.8911 C38.5752,14.5851 38.5782,14.2061 38.4032,13.8961 L34.4612,6.8901 C34.1082,6.2611 33.0732,6.2611 32.7192,6.8901 L28.7782,13.8961 C28.6032,14.2061 28.6062,14.5851 28.7862,14.8911 C28.9652,15.1981 29.2942,15.3871 29.6492,15.3871 L29.6492,15.3871 Z M37.4082,24.4601 C37.4082,24.8791 36.2912,25.6491 34.4662,25.6491 C32.6422,25.6491 31.5252,24.8791 31.5252,24.4601 C31.5252,24.0401 32.6422,23.2691 34.4662,23.2691 C36.2912,23.2691 37.4082,24.0401 37.4082,24.4601 L37.4082,24.4601 Z M29.5252,24.4601 C29.5252,26.2781 31.6492,27.6491 34.4662,27.6491 C37.2842,27.6491 39.4082,26.2781 39.4082,24.4601 C39.4082,22.6411 37.2842,21.2691 34.4662,21.2691 C31.6492,21.2691 29.5252,22.6411 29.5252,24.4601 L29.5252,24.4601 Z M12.5692,34.6561 C13.6692,34.6561 14.6342,36.2351 14.6342,38.0361 C14.6342,39.8371 13.6692,41.4161 12.5692,41.4161 C11.4682,41.4161 10.5032,39.8371 10.5032,38.0361 C10.5032,36.2351 11.4682,34.6561 12.5692,34.6561 L12.5692,34.6561 Z M12.5692,43.4161 C14.8482,43.4161 16.6342,41.0531 16.6342,38.0361 C16.6342,35.0191 14.8482,32.6561 12.5692,32.6561 C10.2892,32.6561 8.5032,35.0191 8.5032,38.0361 C8.5032,41.0531 10.2892,43.4161 12.5692,43.4161 L12.5692,43.4161 Z M12.5692,22.3931 C13.7082,22.3931 14.6342,23.3201 14.6342,24.4601 C14.6342,25.5991 13.7082,26.5251 12.5692,26.5251 C11.4292,26.5251 10.5032,25.5991 10.5032,24.4601 C10.5032,23.3201 11.4292,22.3931 12.5692,22.3931 L12.5692,22.3931 Z M12.5692,28.5251 C14.8102,28.5251 16.6342,26.7011 16.6342,24.4601 C16.6342,22.2181 14.8102,20.3931 12.5692,20.3931 C10.3272,20.3931 8.5032,22.2181 8.5032,24.4601 C8.5032,26.7011 10.3272,28.5251 12.5692,28.5251 L12.5692,28.5251 Z M10.5032,13.3871 L14.6352,13.3871 L14.6352,9.2551 L10.5032,9.2551 L10.5032,13.3871 Z M9.5032,15.3871 L15.6342,15.3871 C16.1872,15.3871 16.6342,14.9391 16.6342,14.3871 L16.6342,8.2551 C16.6342,7.7021 16.1872,7.2551 15.6342,7.2551 L9.5032,7.2551 C8.9502,7.2551 8.5032,7.7021 8.5032,8.2551 L8.5032,14.3871 C8.5032,14.9391 8.9502,15.3871 9.5032,15.3871 L9.5032,15.3871 Z M7.0002,44.0441 L40.0362,44.0441 L40.0362,4.0001 L7.0002,4.0001 L7.0002,44.0441 Z M41.0362,2.0001 L6.0002,2.0001 C5.4472,2.0001 5.0002,2.4471 5.0002,3.0001 L5.0002,45.0441 C5.0002,45.5971 5.4472,46.0441 6.0002,46.0441 L41.0362,46.0441 C41.5882,46.0441 42.0362,45.5971 42.0362,45.0441 L42.0362,3.0001 C42.0362,2.4471 41.5882,2.0001 41.0362,2.0001 L41.0362,2.0001 Z" id="AWS-CloudFormation_change-set_Resource-Icon_light-bg" fill="#E7157B"></path>
    </g>
</svg>`, GM = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Management-Governance/Res_AWS-Systems-Manager_Documents_48</title>
    <g id="Icon-Resource/Management-Governance/Res_AWS-Systems-Manager_Documents_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M20.114,31.103 L34.976,31.103 L34.976,29.103 L20.114,29.103 L20.114,31.103 Z M20.114,24.983 L38.473,24.983 L38.473,22.983 L20.114,22.983 L20.114,24.983 Z M20.114,18.862 L27.983,18.862 L27.983,16.862 L20.114,16.862 L20.114,18.862 Z M8,36.971 L8.748,36.971 L8.748,38.971 L7,38.971 C6.448,38.971 6,38.524 6,37.971 L6,3 C6,2.447 6.448,2 7,2 L23.611,2 L23.611,4 L8,4 L8,36.971 Z M13.245,40.468 L14.868,40.468 L14.868,42.468 L12.245,42.468 C11.693,42.468 11.245,42.021 11.245,41.468 L11.245,6.497 C11.245,5.944 11.693,5.497 12.245,5.497 L27.983,5.497 L27.983,7.497 L13.245,7.497 L13.245,40.468 Z M18.491,43.965 L18.491,10.994 L31.354,10.994 L31.354,18.736 C31.354,19.289 31.801,19.736 32.354,19.736 L40.096,19.736 L40.096,43.965 L18.491,43.965 Z M33.354,12.408 L38.682,17.736 L33.354,17.736 L33.354,12.408 Z M41.803,18.029 L33.061,9.287 C32.873,9.1 32.619,8.994 32.354,8.994 L17.491,8.994 C16.939,8.994 16.491,9.442 16.491,9.994 L16.491,44.965 C16.491,45.518 16.939,45.965 17.491,45.965 L41.096,45.965 C41.649,45.965 42.096,45.518 42.096,44.965 L42.096,18.736 C42.096,18.471 41.99,18.217 41.803,18.029 L41.803,18.029 Z" id="AWS-System-Manager_documents_Resource-Icon_light-bg" fill="#E7157B"></path>
    </g>
</svg>`, jM = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Management-Governance/Res_AWS-Systems-Manager_Application-Manager_48</title>
    <g id="Icon-Resource/Management-Governance/Res_AWS-Systems-Manager_Application-Manager_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M39,23.9766689 C39,20.9486689 38.103,18.0306689 36.404,15.5396689 L38.057,14.4136689 C39.982,17.2376689 41,20.5446689 41,23.9766689 L39,23.9766689 Z M27.751,38.5046689 L28.249,40.4406689 C26.869,40.7966689 25.439,40.9766689 24,40.9766689 C23.289,40.9766689 22.574,40.9326689 21.876,40.8446689 L22.124,38.8606689 C23.987,39.0936689 25.932,38.9726689 27.751,38.5046689 L27.751,38.5046689 Z M9,23.9766689 L7,23.9766689 C7,20.3936689 8.103,16.9646689 10.188,14.0636689 L11.812,15.2306689 C9.973,17.7896689 9,20.8146689 9,23.9766689 L9,23.9766689 Z M17.037,10.7216689 C17.522,10.5976689 17.841,10.1336689 17.782,9.63666889 C17.763,9.46666889 17.752,9.29466889 17.752,9.11866889 C17.752,7.60566889 18.824,5.91966889 20.142,5.35866889 C20.748,5.10066889 21.309,4.99766889 21.817,4.99766889 C23.267,4.99766889 24.291,5.83166889 24.738,6.28266889 C25.23,6.77966889 25.634,7.44766889 25.903,8.21366889 C26.026,8.56266889 26.333,8.81566889 26.699,8.87066889 C27.07,8.92366889 27.433,8.77266889 27.652,8.47366889 C27.939,8.08266889 28.379,7.91566889 28.796,8.03966889 C29.331,8.19566889 29.69,8.78466889 29.769,9.62466889 C29.736,10.1276689 30.088,10.5846689 30.597,10.6726689 C31.498,10.8286689 33.01,11.3806689 33.01,13.3316689 C33.01,15.6326689 30.993,15.9416689 30.678,15.9766689 L17.774,15.9626689 C16.494,15.9616689 15.205,14.8906689 15.069,13.7156689 C15.055,13.5836689 15.046,13.4456689 15.046,13.3006689 C15.046,11.5906689 16.129,10.9546689 17.037,10.7216689 L17.037,10.7216689 Z M17.772,17.9626689 L30.758,17.9736689 C32.229,17.8526689 35.01,16.7286689 35.01,13.3316689 C35.01,10.7996689 33.399,9.41466889 31.679,8.88066889 C31.395,7.47966889 30.558,6.46966889 29.355,6.11966889 C28.634,5.90866889 27.883,5.98066889 27.226,6.29666889 C26.926,5.76466889 26.569,5.28866889 26.158,4.87466889 C24.302,3.00366889 21.76,2.49666889 19.358,3.51866889 C17.322,4.38466889 15.782,6.75366889 15.752,9.04966889 C14.042,9.78266889 13.046,11.3216689 13.046,13.3006689 C13.046,13.5266689 13.059,13.7416689 13.083,13.9456689 C13.334,16.1206689 15.481,17.9606689 17.772,17.9626689 L17.772,17.9626689 Z M18.154,41.8036689 C17.933,42.0226689 17.59,42.0366689 17.386,41.8326689 L13.697,38.1516689 C13.978,37.8966689 14.24,37.6206689 14.477,37.3236689 L18.185,41.0416689 C18.386,41.2436689 18.372,41.5846689 18.154,41.8036689 L18.154,41.8036689 Z M4,32.9766689 C4,30.2196689 6.243,27.9766689 9,27.9766689 C11.757,27.9766689 14,30.2196689 14,32.9766689 C14,35.7336689 11.757,37.9766689 9,37.9766689 C6.243,37.9766689 4,35.7336689 4,32.9766689 L4,32.9766689 Z M15.511,35.5286689 C15.823,34.7366689 16,33.8776689 16,32.9766689 C16,29.1166689 12.859,25.9766689 9,25.9766689 C5.141,25.9766689 2,29.1166689 2,32.9766689 C2,36.8366689 5.141,39.9766689 9,39.9766689 C10.077,39.9766689 11.093,39.7246689 12.005,39.2886689 L15.974,43.2476689 C16.459,43.7336689 17.099,43.9756689 17.742,43.9756689 C18.4,43.9756689 19.062,43.7226689 19.566,43.2186689 C20.564,42.2226689 20.58,40.6116689 19.601,39.6296689 L15.511,35.5286689 Z M37,38.9766689 C33.629,38.9766689 30,37.4126689 30,33.9766689 C30,31.9266689 30.948,29.5206689 33,28.4146689 L33,32.9766689 C33,33.5286689 33.447,33.9766689 34,33.9766689 L40,33.9766689 C40.553,33.9766689 41,33.5286689 41,32.9766689 L41,28.4146689 C43.052,29.5206689 44,31.9266689 44,33.9766689 C44,37.4126689 40.371,38.9766689 37,38.9766689 L37,38.9766689 Z M46,33.9766689 C46,30.0826689 43.627,26.8036689 40.229,26.0036689 C39.93,25.9326689 39.619,26.0026689 39.379,26.1926689 C39.14,26.3826689 39,26.6706689 39,26.9766689 L39,31.9766689 L35,31.9766689 L35,26.9766689 C35,26.6706689 34.86,26.3826689 34.621,26.1926689 C34.382,26.0026689 34.068,25.9336689 33.771,26.0036689 C30.373,26.8036689 28,30.0826689 28,33.9766689 C28,36.8926689 29.962,39.2266689 33,40.3126689 L33,43.9766689 L35,43.9766689 L35,40.8206689 C35.638,40.9206689 36.305,40.9766689 37,40.9766689 C37.695,40.9766689 38.362,40.9206689 39,40.8206689 L39,43.9766689 L41,43.9766689 L41,40.3126689 C44.038,39.2266689 46,36.8926689 46,33.9766689 L46,33.9766689 Z" id="Fill-1" fill="#E7157B"></path>
    </g>
</svg>`, qM = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Management-Governance/Res_AWS-Organizations_Account_48</title>
    <g id="Icon-Resource/Management-Governance/Res_AWS-Organizations_Account_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M32,28 C35.309,28 38,30.691 38,34 C38,37.309 35.309,40 32,40 C28.691,40 26,37.309 26,34 C26,30.691 28.691,28 32,28 L32,28 Z M32,42 C36.411,42 40,38.411 40,34 C40,29.589 36.411,26 32,26 C27.589,26 24,29.589 24,34 C24,38.411 27.589,42 32,42 L32,42 Z M34,9.236 L38.882,19 L29.118,19 L34,9.236 Z M27.5,21 L40.5,21 C40.847,21 41.168,20.82 41.351,20.526 C41.533,20.231 41.55,19.863 41.395,19.553 L34.895,6.553 C34.555,5.875 33.445,5.875 33.105,6.553 L26.605,19.553 C26.45,19.863 26.467,20.231 26.649,20.526 C26.832,20.82 27.153,21 27.5,21 L27.5,21 Z M9,29 L20,29 L20,18 L9,18 L9,29 Z M8,31 L21,31 C21.553,31 22,30.552 22,30 L22,17 C22,16.448 21.553,16 21,16 L8,16 C7.447,16 7,16.448 7,17 L7,30 C7,30.552 7.447,31 8,31 L8,31 Z M4,44 L44,44 L44,4 L4,4 L4,44 Z M45,2 L3,2 C2.447,2 2,2.448 2,3 L2,45 C2,45.552 2.447,46 3,46 L45,46 C45.553,46 46,45.552 46,45 L46,3 C46,2.448 45.553,2 45,2 L45,2 Z" id="Fill-1" fill="#E7157B"></path>
    </g>
</svg>`, KM = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Management-Governance/Res_AWS-CloudTrail_CloudTrail-Lake_48</title>
    <g id="Icon-Resource/Management-Governance/Res_AWS-CloudTrail_CloudTrail-Lake_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M3.592,31.842 L5.567,32.158 C6.031,29.254 8.863,27.569 10.684,27.131 C11.153,27.045 11.503,26.634 11.503,26.146 C11.503,26.094 11.499,26.043 11.491,25.992 C11.45,25.674 11.43,25.352 11.43,25.035 C11.43,24.196 11.629,23.281 12.005,22.388 L10.161,21.612 C9.683,22.748 9.43,23.932 9.43,25.035 C9.43,25.161 9.433,25.287 9.438,25.413 C6.846,26.3 4.119,28.547 3.592,31.842 L3.592,31.842 Z M2,36 L8,36 L8,34 L2,34 L2,36 Z M2,44 L7,44 L7,42 L2,42 L2,44 Z M6,40 L10,40 L10,38 L6,38 L6,40 Z M2,40 L4,40 L4,38 L2,38 L2,40 Z M26.332,34 C24.598,34 23.668,34.656 22.922,35.183 C22.249,35.657 21.764,36 20.664,36 C19.566,36 19.08,35.657 18.409,35.183 C17.662,34.656 16.734,34 15,34 L10,34 L10,36 L15,36 C16.099,36 16.584,36.343 17.255,36.817 C18.002,37.344 18.931,38 20.664,38 C22.399,38 23.328,37.344 24.074,36.817 C24.747,36.343 25.233,36 26.332,36 C27.432,36 27.917,36.343 28.59,36.817 C29.336,37.344 30.266,38 32,38 L32,36 C30.901,36 30.415,35.657 29.742,35.183 C28.996,34.656 28.067,34 26.332,34 L26.332,34 Z M26.332,42 C24.598,42 23.668,42.656 22.922,43.183 C22.249,43.657 21.764,44 20.664,44 C19.566,44 19.08,43.657 18.409,43.183 C17.662,42.656 16.734,42 15,42 L9,42 L9,44 L15,44 C16.099,44 16.584,44.343 17.255,44.817 C18.002,45.344 18.931,46 20.664,46 C22.399,46 23.328,45.344 24.074,44.817 C24.747,44.343 25.233,44 26.332,44 C27.432,44 27.917,44.343 28.59,44.817 C29.336,45.344 30.266,46 32,46 L32,44 C30.901,44 30.415,43.657 29.742,43.183 C28.996,42.656 28.067,42 26.332,42 L26.332,42 Z M26.332,38 C24.598,38 23.668,38.656 22.922,39.183 C22.249,39.657 21.764,40 20.664,40 C19.566,40 19.08,39.657 18.409,39.183 C17.662,38.656 16.734,38 15,38 L12,38 L12,40 L15,40 C16.099,40 16.584,40.343 17.255,40.817 C18.002,41.344 18.931,42 20.664,42 C22.399,42 23.328,41.344 24.074,40.817 C24.747,40.343 25.233,40 26.332,40 C27.432,40 27.917,40.343 28.59,40.817 C29.336,41.344 30.266,42 32,42 L32,40 C30.901,40 30.415,39.657 29.742,39.183 C28.996,38.656 28.067,38 26.332,38 L26.332,38 Z M21,4 L23,4 L23,2 L21,2 L21,4 Z M17,7 L19,7 L19,5 L17,5 L17,7 Z M12,6 L14,6 L14,4 L12,4 L12,6 Z M11.769,11 L15.857,17.792 C15.95,17.948 16,18.126 16,18.308 L16,21 L18,21 L18,18.308 C18,18.126 18.05,17.948 18.144,17.792 L22.232,11 L11.769,11 Z M9.144,10.516 C8.957,10.207 8.952,9.822 9.13,9.508 C9.307,9.194 9.64,9 10,9 L24,9 C24.361,9 24.694,9.194 24.87,9.508 C25.048,9.822 25.043,10.207 24.857,10.516 L20,18.586 L20,22 C20,22.552 19.553,23 19,23 L15,23 C14.447,23 14,22.552 14,22 L14,18.586 L9.144,10.516 Z M45.213,33.965 C45.213,39.843 40.384,41.789 37.831,41.997 L34,42 L34,40 L37.75,40 C37.893,39.984 43.213,39.452 43.213,33.965 C43.213,29.351 39.398,28.197 37.757,27.915 C37.233,27.825 36.872,27.342 36.933,26.817 C36.766,24.755 35.814,23.279 34.373,22.858 C33.19,22.51 31.913,22.974 31.128,24.038 C30.908,24.335 30.539,24.486 30.176,24.433 C29.81,24.378 29.504,24.126 29.381,23.777 C28.804,22.144 27.97,20.774 26.903,19.704 C25.826,18.625 24.542,17.819 23.187,17.371 L23.814,15.472 C25.465,16.017 27.023,16.992 28.319,18.292 C29.269,19.245 30.061,20.384 30.682,21.693 C31.91,20.804 33.456,20.506 34.935,20.938 C37.06,21.559 38.498,23.468 38.865,26.107 C42.063,26.91 45.213,29.326 45.213,33.965 L45.213,33.965 Z" id="Fill-1" fill="#E7157B"></path>
    </g>
</svg>`, YM = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Management-Governance/Res_AWS-Systems-Manager_Maintenance-Windows_48</title>
    <g id="Icon-Resource/Management-Governance/Res_AWS-Systems-Manager_Maintenance-Windows_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M25.0002,23.875 L31.8752,23.875 L31.8752,25.875 L24.0002,25.875 C23.4472,25.875 23.0002,25.428 23.0002,24.875 L23.0002,14.375 L25.0002,14.375 L25.0002,23.875 Z M24.0002,35.25 C17.7972,35.25 12.7502,30.203 12.7502,24 C12.7502,17.797 17.7972,12.75 24.0002,12.75 C30.2032,12.75 35.2502,17.797 35.2502,24 C35.2502,30.203 30.2032,35.25 24.0002,35.25 L24.0002,35.25 Z M24.0002,10.75 C16.6942,10.75 10.7502,16.694 10.7502,24 C10.7502,31.306 16.6942,37.25 24.0002,37.25 C31.3062,37.25 37.2502,31.306 37.2502,24 C37.2502,16.694 31.3062,10.75 24.0002,10.75 L24.0002,10.75 Z M44.0002,27.114 L41.5732,26.977 C41.1162,26.957 40.6482,27.276 40.5412,27.754 C40.1172,29.633 39.3802,31.412 38.3522,33.041 C38.0912,33.455 38.1672,33.996 38.5312,34.321 L40.3452,35.939 L35.9402,40.345 L34.3282,38.537 C34.0022,38.17 33.4602,38.098 33.0482,38.356 C31.4172,39.388 29.6372,40.125 27.7562,40.55 C27.2782,40.657 26.9492,41.095 26.9782,41.582 L27.1152,44 L20.8862,44 L21.0232,41.58 C21.0522,41.093 20.7232,40.656 20.2462,40.548 C18.3702,40.124 16.5912,39.386 14.9572,38.354 C14.5442,38.094 14.0022,38.168 13.6772,38.533 L12.0612,40.345 L7.6562,35.939 L9.4662,34.325 C9.8302,34 9.9062,33.459 9.6462,33.046 C8.6162,31.413 7.8802,29.633 7.4572,27.755 C7.3502,27.277 6.8922,26.957 6.4252,26.977 L4.0002,27.114 L4.0002,20.885 L6.4322,21.022 C6.9152,21.035 7.3542,20.723 7.4642,20.245 C7.8892,18.372 8.6262,16.596 9.6562,14.966 C9.9172,14.553 9.8412,14.011 9.4772,13.686 L7.6552,12.061 L12.0622,7.655 L13.6852,9.475 C14.0092,9.839 14.5522,9.913 14.9642,9.654 C16.5942,8.628 18.3702,7.892 20.2462,7.469 C20.7232,7.361 21.0522,6.925 21.0232,6.437 L20.8862,4 L27.1152,4 L26.9782,6.438 C26.9492,6.926 27.2782,7.362 27.7552,7.471 C29.6272,7.895 31.4032,8.63 33.0332,9.658 C33.4432,9.917 33.9862,9.842 34.3132,9.479 L35.9392,7.655 L40.3452,12.061 L38.5272,13.682 C38.1632,14.007 38.0872,14.549 38.3482,14.962 C39.3772,16.59 40.1142,18.368 40.5392,20.245 C40.6472,20.723 41.0922,21.035 41.5712,21.022 L44.0002,20.885 L44.0002,27.114 Z M45.6872,19.1 C45.4872,18.911 45.2182,18.81 44.9432,18.828 L42.2832,18.979 C41.8662,17.455 41.2612,15.995 40.4772,14.623 L42.4672,12.848 C42.6722,12.665 42.7932,12.405 42.8012,12.13 C42.8092,11.855 42.7022,11.589 42.5082,11.395 L36.6052,5.492 C36.4112,5.298 36.1372,5.211 35.8702,5.199 C35.5952,5.207 35.3362,5.328 35.1522,5.533 L33.3712,7.529 C31.9992,6.747 30.5412,6.143 29.0212,5.726 L29.1722,3.057 C29.1872,2.782 29.0902,2.513 28.9002,2.313 C28.7122,2.113 28.4492,2 28.1742,2 L19.8272,2 C19.5522,2 19.2892,2.113 19.1012,2.313 C18.9112,2.513 18.8132,2.782 18.8292,3.057 L18.9802,5.724 C17.4582,6.14 15.9992,6.743 14.6262,7.525 L12.8492,5.533 C12.6662,5.328 12.4062,5.207 12.1312,5.199 C11.8542,5.214 11.5912,5.298 11.3962,5.492 L5.4932,11.395 C5.2992,11.589 5.1922,11.854 5.2002,12.13 C5.2082,12.405 5.3292,12.664 5.5342,12.848 L7.5272,14.626 C6.7422,16 6.1372,17.458 5.7202,18.979 L3.0572,18.828 C2.7762,18.809 2.5132,18.911 2.3132,19.1 C2.1132,19.288 2.0002,19.551 2.0002,19.826 L2.0002,28.173 C2.0002,28.448 2.1132,28.711 2.3132,28.899 C2.5132,29.088 2.7782,29.187 3.0572,29.171 L5.7122,29.021 C6.1282,30.546 6.7322,32.008 7.5172,33.384 L5.5342,35.152 C5.3292,35.335 5.2082,35.595 5.2002,35.87 C5.1922,36.145 5.2992,36.411 5.4932,36.605 L11.3962,42.508 C11.5912,42.702 11.8512,42.806 12.1312,42.801 C12.4062,42.793 12.6662,42.672 12.8492,42.467 L14.6182,40.482 C15.9952,41.269 17.4562,41.875 18.9792,42.293 L18.8292,44.943 C18.8132,45.218 18.9112,45.486 19.1012,45.687 C19.2892,45.887 19.5522,46 19.8272,46 L28.1742,46 C28.4492,46 28.7122,45.887 28.9002,45.687 C29.0902,45.486 29.1872,45.218 29.1722,44.943 L29.0212,42.295 C30.5492,41.878 32.0122,41.271 33.3872,40.486 L35.1522,42.466 C35.3352,42.672 35.5952,42.792 35.8702,42.801 C36.1122,42.809 36.4112,42.702 36.6052,42.508 L42.5082,36.605 C42.7022,36.411 42.8092,36.145 42.8012,35.87 C42.7932,35.595 42.6722,35.336 42.4672,35.152 L40.4802,33.38 C41.2642,32.006 41.8692,30.545 42.2862,29.021 L44.9432,29.171 C45.2172,29.186 45.4872,29.088 45.6872,28.899 C45.8872,28.711 46.0002,28.448 46.0002,28.173 L46.0002,19.826 C46.0002,19.551 45.8872,19.288 45.6872,19.1 L45.6872,19.1 Z" id="AWS-System-Manager_maintenance-windows_Resource-Icon_light-bg" fill="#E7157B"></path>
    </g>
</svg>`, QM = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Management-Governance/Res_AWS-Systems-Manager_Incident-Manager_48</title>
    <g id="Icon-Resource/Management-Governance/Res_AWS-Systems-Manager_Incident-Manager_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M22.8408,15.3737048 L21.7798,13.6787048 C23.4628,12.6257048 25.3198,11.9467048 27.2988,11.6627048 L27.5838,13.6417048 C25.8818,13.8867048 24.2858,14.4697048 22.8408,15.3737048 L22.8408,15.3737048 Z M21.5358,16.3157048 C18.8628,18.5277048 17.2448,21.7727048 17.0988,25.2217048 L15.1008,25.1367048 C15.2718,21.1237048 17.1528,17.3467048 20.2608,14.7747048 L21.5358,16.3157048 Z M22.8088,22.8617048 C22.4078,23.8577048 22.2788,24.9507048 22.4328,26.0207048 L20.4518,26.3057048 C20.2478,24.8867048 20.4218,23.4377048 20.9528,22.1157048 L22.8088,22.8617048 Z M23.3808,21.7677048 L21.7108,20.6667048 C22.9918,18.7227048 25.0478,17.4167048 27.3528,17.0847048 L27.6378,19.0647048 C25.8998,19.3147048 24.3478,20.2997048 23.3808,21.7677048 L23.3808,21.7677048 Z M22.9998,30.9937048 L8.9558,30.9937048 C7.7818,30.9937048 6.9278,30.5497048 6.3138,30.1627048 C4.7038,29.1517048 1.9998,26.7847048 1.9998,22.3007048 C1.9998,16.9847048 5.5408,14.9527048 7.7268,14.2047048 L7.6948,13.6767048 C7.6938,9.20670483 10.6678,4.63570483 14.6128,2.98570483 C19.2208,1.04470483 24.1068,2.00470483 27.6778,5.56170483 C28.7238,6.60070483 29.5938,7.85270483 30.2748,9.29770483 C31.6918,8.24470483 33.5488,7.90970483 35.2748,8.48170483 C37.5208,9.22370483 38.9338,11.2547048 39.1468,13.9867048 C41.4608,14.5707048 45.9708,16.4697048 45.9708,22.3697048 L45.9718,22.6707048 C45.9741852,23.1217048 45.9768,23.8627048 45.9698,24.0187048 L43.9718,23.9307048 C43.9788,23.7847048 43.9738,23.0987048 43.9718,22.6807048 L43.9708,22.3697048 C43.9708,17.3537048 39.7868,16.0927048 37.9868,15.7827048 C37.7178,15.7367048 37.4788,15.5817048 37.3258,15.3537048 C37.1808,15.1357048 37.1258,14.8707048 37.1738,14.6147048 C37.1458,12.4427048 36.2288,10.9027048 34.6468,10.3807048 C33.2178,9.90670483 31.6368,10.4167048 30.7218,11.6507048 C30.5028,11.9477048 30.1338,12.0957048 29.7728,12.0447048 C29.4068,11.9907048 29.1028,11.7397048 28.9778,11.3927048 C28.3418,9.61970483 27.4298,8.13470483 26.2668,6.97970483 C24.8378,5.55670483 20.9168,2.49570483 15.3878,4.82970483 C12.1938,6.16570483 9.6938,10.0247048 9.6938,13.6167048 L9.7708,14.8767048 C9.7998,15.3567048 9.4838,15.7887048 9.0168,15.9067048 C7.1438,16.3787048 3.9998,17.8377048 3.9998,22.3007048 C3.9998,25.6457048 5.8378,27.5017048 7.3788,28.4697048 C7.9778,28.8477048 8.4188,28.9937048 8.9558,28.9937048 L22.9998,28.9937048 L22.9998,30.9937048 Z M35.7668,42.7787048 L37.7668,42.7787048 C37.7668,44.5407048 36.3328,45.9747048 34.5698,45.9747048 C32.8078,45.9747048 31.3738,44.5407048 31.3738,42.7787048 L33.3738,42.7787048 C33.3738,43.4377048 33.9108,43.9747048 34.5698,43.9747048 C35.2298,43.9747048 35.7668,43.4377048 35.7668,42.7787048 L35.7668,42.7787048 Z M43.9998,38.7727048 C43.9998,39.4457048 43.4518,39.9937048 42.7788,39.9937048 L26.2208,39.9937048 C25.5478,39.9937048 24.9998,39.4457048 24.9998,38.7727048 L24.9998,38.2147048 C24.9998,37.5417048 25.5478,36.9937048 26.2208,36.9937048 L42.7788,36.9937048 C43.4518,36.9937048 43.9998,37.5417048 43.9998,38.2147048 L43.9998,38.7727048 Z M27.9998,29.1547048 C27.9998,25.9357048 29.5028,23.6077048 32.0208,22.9297048 C32.4568,22.8117048 32.7608,22.4157048 32.7608,21.9637048 L32.7608,19.8787048 C32.7608,19.5327048 32.9608,19.2027048 33.3108,18.9757048 C34.0168,18.5167048 34.6428,18.7297048 34.9518,18.8977048 C35.4468,19.1657048 35.7148,19.6117048 35.7148,19.8947048 L35.7148,21.7627048 C35.7148,22.2297048 36.0378,22.6347048 36.4928,22.7377048 C39.2738,23.3697048 40.9998,25.8757048 40.9998,29.2797048 L40.9998,34.9937048 L27.9998,34.9937048 L27.9998,29.1547048 Z M42.9998,35.0157048 L42.9998,29.2797048 C42.9998,25.2047048 40.9958,22.1077048 37.7148,21.0057048 L37.7148,19.8947048 C37.7148,18.8177048 37.0048,17.7357048 35.9058,17.1397048 C34.7318,16.5027048 33.3528,16.5607048 32.2198,17.2987048 C31.3068,17.8937048 30.7608,18.8577048 30.7608,19.8787048 L30.7608,21.2387048 C27.7638,22.3827048 25.9998,25.2847048 25.9998,29.1547048 L25.9998,34.9937048 L26.2208,34.9937048 C24.4448,34.9937048 22.9998,36.4387048 22.9998,38.2147048 L22.9998,38.7727048 C22.9998,40.5487048 24.4448,41.9937048 26.2208,41.9937048 L42.7788,41.9937048 C44.5558,41.9937048 45.9998,40.5487048 45.9998,38.7727048 L45.9998,38.2147048 C45.9998,36.5147048 44.6718,35.1317048 42.9998,35.0157048 L42.9998,35.0157048 Z" id="Fill-1" fill="#E7157B"></path>
    </g>
</svg>`, XM = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Management-Governance/Res_Amazon-CloudWatch_Evidently_48</title>
    <g id="Icon-Resource/Management-Governance/Res_Amazon-CloudWatch_Evidently_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M9.5,21 C10.879,21 12,22.122 12,23.5 C12,24.878 10.879,26 9.5,26 C8.121,26 7,24.878 7,23.5 C7,22.122 8.121,21 9.5,21 L9.5,21 Z M23.5,12 C24.879,12 26,13.122 26,14.5 C26,15.878 24.879,17 23.5,17 C22.121,17 21,15.878 21,14.5 C21,13.122 22.121,12 23.5,12 L23.5,12 Z M39.5,4 C40.879,4 42,5.122 42,6.5 C42,7.878 40.879,9 39.5,9 C38.121,9 37,7.878 37,6.5 C37,5.122 38.121,4 39.5,4 L39.5,4 Z M9.5,28 C11.981,28 14,25.981 14,23.5 C14,22.89 13.875,22.309 13.654,21.778 L20.496,17.868 L20.451,17.789 C21.254,18.534 22.32,19 23.5,19 C25.981,19 28,16.981 28,14.5 C28,14.053 27.914,13.63 27.793,13.222 L35.898,9.169 C36.718,10.274 38.021,11 39.5,11 C41.981,11 44,8.981 44,6.5 C44,4.019 41.981,2 39.5,2 C37.019,2 35,4.019 35,6.5 C35,6.787 35.033,7.067 35.085,7.339 L26.81,11.477 C25.987,10.576 24.814,10 23.5,10 C21.019,10 19,12.019 19,14.5 C19,15.11 19.125,15.691 19.346,16.222 L12.504,20.132 L12.549,20.211 C11.746,19.466 10.68,19 9.5,19 C7.019,19 5,21.019 5,23.5 C5,25.981 7.019,28 9.5,28 L9.5,28 Z M42,41 C42,42.654 40.654,44 39,44 C37.346,44 36,42.654 36,41 L36,15 L42,15 L42,41 Z M46,13 L32,13 L32,15 L34,15 L34,41 C34,43.757 36.243,46 39,46 C41.757,46 44,43.757 44,41 L44,15 L46,15 L46,13 Z M27,41 C27,42.654 25.654,44 24,44 C22.346,44 21,42.654 21,41 L21,23 L27,23 L27,41 Z M17,23 L19,23 L19,41 C19,43.757 21.243,46 24,46 C26.757,46 29,43.757 29,41 L29,23 L31,23 L31,21 L17,21 L17,23 Z M12,41 C12,42.654 10.654,44 9,44 C7.346,44 6,42.654 6,41 L6,31 L12,31 L12,41 Z M2,31 L4,31 L4,41 C4,43.757 6.243,46 9,46 C11.757,46 14,43.757 14,41 L14,31 L16,31 L16,29 L2,29 L2,31 Z" id="Fill-3" fill="#E7157B"></path>
    </g>
</svg>`, JM = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Management-Governance/Res_Amazon-CloudWatch_RUM_48</title>
    <g id="Icon-Resource/Management-Governance/Res_Amazon-CloudWatch_RUM_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M41.945,40.906 L36.316,35.638 L42.394,29.5 C43.55,31.067 44.177,32.959 44.177,34.927 C44.177,37.153 43.387,39.246 41.945,40.906 L41.945,40.906 Z M25.882,35.465 C25.871,35.286 25.867,35.107 25.867,34.927 C25.867,30.219 29.44,26.328 34.017,25.826 L34.017,35.528 C34.017,35.785 34.123,36.018 34.289,36.199 L34.149,36.349 L40.474,42.269 C38.904,43.439 37.012,44.082 35.022,44.082 C30.178,44.082 26.164,40.299 25.882,35.465 L25.882,35.465 Z M18.091,20.895 C20.543,20.895 22.946,21.58 25.041,22.878 C26.35,23.689 27.492,24.717 28.469,25.92 C25.916,27.782 24.182,30.694 23.913,34.021 L4.534,34.021 C5.029,26.696 10.92,20.895 18.091,20.895 L18.091,20.895 Z M10.791,11.401 C10.791,7.375 14.067,4.1 18.092,4.1 C22.118,4.1 25.392,7.375 25.392,11.401 C25.392,15.427 22.118,18.702 18.092,18.702 C14.067,18.702 10.791,15.427 10.791,11.401 L10.791,11.401 Z M42.474,27.014 C42.211,27.034 41.94,27.117 41.748,27.31 L36.017,33.097 L36.017,24.772 C36.017,24.506 35.912,24.252 35.724,24.065 C35.537,23.877 35.283,23.772 35.017,23.772 C33.288,23.772 31.657,24.18 30.195,24.886 C29.042,23.412 27.674,22.157 26.093,21.177 C24.975,20.485 23.778,19.951 22.536,19.569 C25.427,17.99 27.392,14.921 27.392,11.401 C27.392,6.272 23.22,2.1 18.092,2.1 C12.963,2.1 8.791,6.272 8.791,11.401 C8.791,14.922 10.758,17.991 13.65,19.57 C7.211,21.554 2.5,27.725 2.5,35.021 C2.5,35.573 2.947,36.021 3.5,36.021 L23.933,36.021 C24.486,41.695 29.268,46.082 35.022,46.082 C37.958,46.082 40.73,44.95 42.825,42.896 C44.987,40.783 46.177,37.953 46.177,34.927 C46.177,32.101 45.117,29.404 43.191,27.333 C43.005,27.133 42.747,27.018 42.474,27.014 L42.474,27.014 Z M39.017,18.075 C40.872,18.28 42.63,19.051 44.038,20.276 L39.017,25.346 L39.017,18.075 Z M37.636,28.702 C37.759,28.753 37.889,28.777 38.017,28.777 C38.279,28.777 38.536,28.674 38.728,28.481 L46.169,20.966 C46.546,20.586 46.556,19.975 46.191,19.582 C44.089,17.319 41.111,16.021 38.017,16.021 C37.464,16.021 37.017,16.468 37.017,17.021 L37.017,27.777 C37.017,28.183 37.262,28.548 37.636,28.702 L37.636,28.702 Z" id="Fill-1" fill="#E7157B"></path>
    </g>
</svg>`, eR = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Management-Governance/Res_AWS-Systems-Manager_Parameter-Store_48</title>
    <g id="Icon-Resource/Management-Governance/Res_AWS-Systems-Manager_Parameter-Store_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M35.5886,36.7588 C35.5886,37.1338 35.8946,37.4408 36.2696,37.4408 L36.2706,37.4408 C36.4516,37.4408 36.6226,37.3698 36.7506,37.2418 C36.8796,37.1128 36.9506,36.9418 36.9506,36.7588 L36.9506,36.7568 C36.9506,36.5758 36.8806,36.4048 36.7526,36.2778 C36.6236,36.1488 36.4526,36.0768 36.2706,36.0768 L36.2696,36.0768 C36.0876,36.0768 35.9166,36.1478 35.7886,36.2768 C35.6596,36.4048 35.5886,36.5758 35.5886,36.7588 L35.5886,36.7588 Z M33.5886,36.7578 C33.5896,36.0408 33.8686,35.3678 34.3746,34.8618 C34.8806,34.3558 35.5536,34.0768 36.2686,34.0768 L36.2716,34.0768 C36.9876,34.0768 37.6616,34.3568 38.1686,34.8638 C38.6746,35.3718 38.9526,36.0448 38.9506107,36.7608 C38.9496,37.4778 38.6706,38.1508 38.1646,38.6558 C37.9046,38.9158 37.6006,39.1128 37.2696,39.2458 L37.2706,42.0428 L35.2706,42.0428 L35.2696,39.2428 C34.2856,38.8458 33.5886,37.8828 33.5886,36.7578 L33.5886,36.7578 Z M43.1156,32.7748 L29.4286,32.7688 L29.4246,43.8378 L43.1096,43.8448 L43.1156,32.7748 Z M32.9016,30.7708 L39.614618,30.7728 L39.614618,28.3028 C39.6206,26.2818 38.1276,24.6358 36.2866,24.6298 L36.2756,24.6298 C35.3936,24.6298 34.5606,24.9978 33.9276,25.6658 C33.2766,26.3548 32.9166,27.2758 32.9136,28.2598 L32.9016,30.7708 Z M45.1156,31.7748 L45.1096,44.8448 C45.1096,45.3978 44.6616,45.8448 44.1096,45.8448 L28.4246,45.8378 C27.8716,45.8378 27.4246,45.3898 27.4246,44.8378 L27.4286,31.7688 C27.4286,31.5028 27.5336,31.2488 27.7216,31.0618 C27.9086,30.8738 28.1636,30.7688 28.4286,30.7688 L30.9016,30.7698 L30.9136,28.2518 C30.9186,26.7588 31.4726,25.3518 32.4746,24.2918 C33.4886,23.2198 34.8386,22.6298 36.2756,22.6298 L36.2926,22.6298 C39.2366,22.6398 41.6246,25.1858 41.6146,28.3058 L41.6146,30.7738 L44.1156,30.7748 C44.3816,30.7748 44.6356,30.8798 44.8226,31.0678 C45.0106,31.2548 45.1156,31.5098 45.1156,31.7748 L45.1156,31.7748 Z M14.4756,31.0248 L21.4496,31.0248 L21.4496,29.0248 L14.4756,29.0248 L14.4756,31.0248 Z M14.4756,27.5378 L21.4496,27.5378 L21.4496,25.5378 L14.4756,25.5378 L14.4756,27.5378 Z M14.4756,24.0508 L21.4496,24.0508 L21.4496,22.0508 L14.4756,22.0508 L14.4756,24.0508 Z M12.9056,33.3838 L23.1096,33.3838 L23.1096,19.6928 L12.9056,19.6928 L12.9056,33.3838 Z M25.1096,18.6928 L25.1096,34.3838 C25.1096,34.9368 24.6626,35.3838 24.1096,35.3838 L11.9056,35.3838 C11.3536,35.3838 10.9056,34.9368 10.9056,34.3838 L10.9056,18.6928 C10.9056,18.1398 11.3536,17.6928 11.9056,17.6928 L24.1096,17.6928 C24.6626,17.6928 25.1096,18.1398 25.1096,18.6928 L25.1096,18.6928 Z M5.9406,8.9748 L30.0166,8.9748 L26.4706,3.9998 L9.4856,3.9998 L5.9406,8.9748 Z M3.1106,10.4328 C2.9396,10.0998 2.9686,9.6988 3.1856,9.3948 L8.1556,2.4198 C8.3436,2.1558 8.6476,1.9998 8.9706,1.9998 L26.9856,1.9998 C27.3096,1.9998 27.6126,2.1558 27.8006,2.4198 L32.7716,9.3948 C32.9876,9.6988 33.0176,10.0998 32.8456,10.4328 C32.6746,10.7658 32.3306,10.9748 31.9566,10.9748 L3.9996,10.9748 C3.6256,10.9748 3.2816,10.7658 3.1106,10.4328 L3.1106,10.4328 Z M5.0496,39.4868 L24.9376,39.4868 L24.9376,41.4868 L4.0496,41.4868 C3.4966,41.4868 3.0496,41.0388 3.0496,40.4868 L3.0496,13.4618 C3.0496,12.9088 3.4966,12.4618 4.0496,12.4618 L31.9546,12.4618 C32.5076,12.4618 32.9546,12.9088 32.9546,13.4618 L32.9546,22.1788 L30.9546,22.1788 L30.9546,14.4618 L5.0496,14.4618 L5.0496,39.4868 Z" id="AWS-System-Manager_Parameter-Store_Resource-Icon_light-bg" fill="#E7157B"></path>
    </g>
</svg>`, zi = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Management-Governance/Res_Amazon-CloudWatch_Logs_48</title>
    <g id="Icon-Resource/Management-Governance/Res_Amazon-CloudWatch_Logs_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M29.4998,17.0004 C26.2418,17.0004 23.4708,19.0924 22.4378,22.0004 L24.6068,22.0004 C25.5198,20.2224 27.3678,19.0004 29.4998,19.0004 C32.5318,19.0004 34.9998,21.4674 34.9998,24.5004 C34.9998,27.5324 32.5318,30.0004 29.4998,30.0004 C27.7958,30.0004 26.2708,29.2214 25.2608,28.0004 L22.8718,28.0004 C24.1318,30.3764 26.6288,32.0004 29.4998,32.0004 C33.6358,32.0004 36.9998,28.6364 36.9998,24.5004 C36.9998,20.3644 33.6358,17.0004 29.4998,17.0004 L29.4998,17.0004 Z M1.9998,33.0004 L14.9998,33.0004 L14.9998,31.0004 L1.9998,31.0004 L1.9998,33.0004 Z M1.9998,18.0004 L14.9998,18.0004 L14.9998,16.0004 L1.9998,16.0004 L1.9998,18.0004 Z M1.9998,26.0004 L28.9998,26.0004 L28.9998,24.0004 L1.9998,24.0004 L1.9998,26.0004 Z M43.8428,35.7384 L38.8178,31.2134 C38.3998,31.7924 37.9318,32.3304 37.4148,32.8214 L42.4118,37.3294 C42.8478,37.7224 43.5278,37.6874 43.9228,37.2494 C44.3148,36.8124 44.2798,36.1344 43.8428,35.7384 L43.8428,35.7384 Z M45.4088,38.5884 C44.8028,39.2594 43.9658,39.6004 43.1248,39.6004 C42.3938,39.6004 41.6588,39.3414 41.0738,38.8154 L35.8338,34.0894 C34.0168,35.2934 31.8398,36.0004 29.4998,36.0004 C24.3798,36.0004 20.0328,32.6344 18.5488,28.0004 L20.6768,28.0004 C22.0738,31.5094 25.4988,34.0004 29.4998,34.0004 C34.7378,34.0004 38.9998,29.7384 38.9998,24.5004 C38.9998,19.2624 34.7378,15.0004 29.4998,15.0004 C25.1278,15.0004 21.4458,17.9734 20.3448,22.0004 L18.2818,22.0004 C19.4278,16.8574 24.0188,13.0004 29.4998,13.0004 C35.8408,13.0004 40.9998,18.1584 40.9998,24.5004 C40.9998,26.2774 40.5828,27.9554 39.8588,29.4604 L45.1828,34.2544 C46.4368,35.3884 46.5378,37.3314 45.4088,38.5884 L45.4088,38.5884 Z M1.9998,41.0004 L20.9998,41.0004 L20.9998,39.0004 L1.9998,39.0004 L1.9998,41.0004 Z M1.9998,10.0004 L22.9998,10.0004 L22.9998,8.0004 L1.9998,8.0004 L1.9998,10.0004 Z" id="Amazon-Cloudwatch_Logs_Resource-Icon_light-bg" fill="#E7157B"></path>
    </g>
</svg>`, tR = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Management-Governance/Res_AWS-Systems-Manager_Change-Manager_48</title>
    <g id="Icon-Resource/Management-Governance/Res_AWS-Systems-Manager_Change-Manager_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M43.938,26.489 C42.505,36.503 33.725,44.347 23.948,44.347 C15.345,44.347 7.52,38.273 4.787,29.992 L3.896,32.664 L2,32.031 L4,26.031 C4.102,25.721 4.351,25.481 4.665,25.388 C4.979,25.297 5.318,25.363 5.573,25.567 L10.573,29.567 L9.323,31.128 L6.554,28.913 C8.878,36.629 16.045,42.347 23.948,42.347 C32.752,42.347 40.664,35.257 41.958,26.206 L43.938,26.489 Z M5.938,22.489 L3.958,22.206 C5.418,11.997 14.199,4 23.948,4 C32.543,4 40.377,10.218 43.115,18.686 L44,16.031 L45.896,16.664 L43.896,22.664 C43.793,22.974 43.544,23.214 43.231,23.306 C43.138,23.334 43.042,23.347 42.948,23.347 C42.723,23.347 42.502,23.272 42.323,23.128 L37.323,19.128 L38.573,17.567 L41.353,19.791 C39.029,11.875 31.848,6 23.948,6 C15.171,6 7.26,13.243 5.938,22.489 L5.938,22.489 Z M19.948,30 L28.948,30 L28.948,28 L19.948,28 L19.948,30 Z M19.948,26 L28.948,26 L28.948,24 L19.948,24 L19.948,26 Z M19.948,22 L28.948,22 L28.948,20 L19.948,20 L19.948,22 Z M32.502,30.12 L33.657,31.217 L31.387,33.373 L30.158,32.205 C29.84,31.905 29.367,31.845 28.985,32.055 C28.268,32.452 27.501,32.755 26.704,32.955 C26.259,33.067 25.948,33.467 25.948,33.925 L25.948,36 L22.948,36 L22.948,34.289 C22.948,33.841 22.649,33.447 22.216,33.326 C21.47,33.118 20.75,32.803 20.075,32.39 C19.673,32.145 19.153,32.212 18.827,32.554 L17.73,33.709 L15.574,31.439 L16.742,30.21 C17.042,29.894 17.103,29.42 16.892,29.038 C16.495,28.319 16.192,27.551 15.993,26.756 C15.881,26.312 15.481,26 15.023,26 L12.948,26 L12.948,23 L14.659,23 C15.108,23 15.501,22.7 15.623,22.268 C15.83,21.522 16.144,20.802 16.557,20.127 C16.804,19.724 16.736,19.205 16.393,18.88 L15.239,17.782 L17.508,15.626 L18.738,16.794 C19.055,17.095 19.529,17.154 19.911,16.944 C20.627,16.547 21.395,16.245 22.191,16.045 C22.636,15.933 22.948,15.533 22.948,15.075 L22.948,13 L25.948,13 L25.948,14.71 C25.948,15.159 26.247,15.553 26.679,15.674 C27.425,15.882 28.146,16.197 28.821,16.61 C29.223,16.857 29.744,16.788 30.069,16.446 L31.166,15.29 L33.322,17.56 L32.154,18.79 C31.853,19.106 31.792,19.581 32.003,19.963 C32.401,20.681 32.703,21.448 32.903,22.243 C33.014,22.688 33.415,23 33.873,23 L35.948,23 L35.948,26 L34.237,26 C33.788,26 33.394,26.299 33.273,26.732 C33.066,27.477 32.751,28.197 32.338,28.873 C32.091,29.275 32.16,29.795 32.502,30.12 L32.502,30.12 Z M36.429,21 L34.625,21 C34.475,20.541 34.297,20.091 34.091,19.655 L35.087,18.606 C35.643,18.019 35.643,17.101 35.086,16.515 L32.265,13.544 C31.979,13.244 31.579,13.073 31.166,13.073 L31.164,13.073 C30.75,13.073 30.349,13.246 30.064,13.546 L29.154,14.505 C28.761,14.304 28.359,14.129 27.948,13.981 L27.948,12.518 C27.948,11.681 27.266,11 26.429,11 L22.466,11 C21.629,11 20.948,11.681 20.948,12.518 L20.948,14.323 C20.489,14.472 20.039,14.651 19.602,14.857 L18.555,13.862 C17.966,13.302 17.047,13.304 16.462,13.861 L13.494,16.681 C13.193,16.967 13.021,17.368 13.021,17.782 C13.021,18.197 13.193,18.598 13.494,18.883 L14.453,19.794 C14.252,20.186 14.078,20.589 13.929,21 L12.466,21 C11.629,21 10.948,21.681 10.948,22.518 L10.948,26.481 C10.948,27.319 11.629,28 12.466,28 L14.271,28 C14.42,28.459 14.598,28.908 14.804,29.345 L13.807,30.395 C13.252,30.981 13.252,31.899 13.809,32.485 L16.63,35.456 C16.917,35.755 17.317,35.927 17.73,35.927 L17.732,35.927 C18.146,35.926 18.546,35.754 18.832,35.454 L19.742,34.495 C20.134,34.695 20.537,34.87 20.948,35.019 L20.948,36.481 C20.948,37.319 21.629,38 22.466,38 L26.429,38 C27.266,38 27.948,37.319 27.948,36.481 L27.948,34.677 C28.408,34.527 28.857,34.349 29.293,34.143 L30.34,35.138 C30.93,35.697 31.849,35.696 32.433,35.138 L35.402,32.318 C35.703,32.033 35.875,31.632 35.875,31.218 C35.875,30.803 35.703,30.402 35.402,30.116 L34.443,29.205 C34.643,28.813 34.818,28.41 34.966,28 L36.429,28 C37.266,28 37.948,27.319 37.948,26.481 L37.948,22.518 C37.948,21.681 37.266,21 36.429,21 L36.429,21 Z" id="Fill-1" fill="#E7157B"></path>
    </g>
</svg>`, nR = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Management-Governance/Res_AWS-OpsWorks_Monitoring_48</title>
    <g id="Icon-Resource/Management-Governance/Res_AWS-OpsWorks_Monitoring_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M44.0359,38.6515 L3.9999,38.6515 L3.9999,28.6175 L13.7169,16.4705 L23.4639,22.9675 C23.8849,23.2485 24.4449,23.1715 24.7739,22.7915 L35.4879,10.4285 L44.0359,18.2005 L44.0359,38.6515 Z M45.7089,17.0175 L36.0759,8.2595 C35.8769,8.0785 35.6259,7.9845 35.3439,8.0025 C35.0749,8.0175 34.8239,8.1415 34.6469,8.3445 L23.8399,20.8145 L14.0629,14.2975 C13.6299,14.0095 13.0519,14.1015 12.7269,14.5055 L2.2189,27.6415 C2.0769,27.8195 1.9999,28.0395 1.9999,28.2665 L1.9999,39.6515 C1.9999,40.2045 2.4469,40.6515 2.9999,40.6515 L45.0359,40.6515 C45.5889,40.6515 46.0359,40.2045 46.0359,39.6515 L46.0359,17.7575 C46.0359,17.4765 45.9169,17.2075 45.7089,17.0175 L45.7089,17.0175 Z" id="AWS-OpsWorks-monitoring_Resource-Icon_dark-bg" fill="#E7157B"></path>
    </g>
</svg>`, iR = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Management-Governance/Res_AWS-Systems-Manager_Compliance_48</title>
    <g id="Icon-Resource/Management-Governance/Res_AWS-Systems-Manager_Compliance_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M11,37 L26,37 L26,39 L10,39 C9.447,39 9,38.552 9,38 L9,15 C9,14.448 9.447,14 10,14 L30,14 C30.553,14 31,14.448 31,15 L31,21 L29,21 L29,16 L11,16 L11,37 Z M13.502,6 L17.184,6 C17.598,7.161 18.698,8 20,8 C21.302,8 22.402,7.161 22.816,6 L26.615,6 L27.74,10 L12.377,10 L13.502,6 Z M20,4 C20.552,4 21,4.449 21,5 C21,5.551 20.552,6 20,6 C19.448,6 19,5.551 19,5 C19,4.449 19.448,4 20,4 L20,4 Z M11.057,12 L29.061,12 C29.374,12 29.669,11.854 29.857,11.604 C30.047,11.354 30.108,11.031 30.023,10.729 L28.336,4.729 C28.215,4.298 27.821,4 27.373,4 L22.816,4 C22.402,2.839 21.302,2 20,2 C18.698,2 17.598,2.839 17.184,4 L12.744,4 C12.296,4 11.902,4.298 11.781,4.729 L10.094,10.729 C10.009,11.031 10.07,11.354 10.26,11.604 C10.448,11.854 10.743,12 11.057,12 L11.057,12 Z M32.353,8 L31,8 L31,6 L32.353,6 C33.812,6 35,7.275 35,8.842 L35,20 L33,20 L33,8.842 C33,8.386 32.703,8 32.353,8 L32.353,8 Z M7.647,41 L25,41 L25,43 L7.647,43 C6.187,43 5,41.725 5,40.158 L5,8.842 C5,7.275 6.187,6 7.647,6 L9,6 L9,8 L7.647,8 C7.297,8 7,8.386 7,8.842 L7,40.158 C7,40.614 7.297,41 7.647,41 L7.647,41 Z M39.471,31.096 C39.326,31.296 39.26,31.542 39.286,31.787 L39.426,33.132 L38.189,33.683 C37.963,33.783 37.782,33.964 37.682,34.19 L37.133,35.426 L35.787,35.286 C35.542,35.26 35.297,35.326 35.097,35.471 L34,36.265 L32.903,35.471 C32.731,35.346 32.526,35.28 32.316,35.28 C32.282,35.28 32.247,35.282 32.213,35.286 L30.867,35.426 L30.317,34.189 C30.217,33.964 30.036,33.783 29.81,33.683 L28.574,33.132 L28.714,31.787 C28.74,31.542 28.674,31.296 28.529,31.096 L27.735,30 L28.529,28.904 C28.674,28.704 28.74,28.458 28.714,28.213 L28.574,26.868 L29.811,26.317 C30.037,26.217 30.218,26.036 30.318,25.81 L30.867,24.574 L32.213,24.714 C32.455,24.737 32.703,24.674 32.903,24.529 L34,23.735 L35.097,24.529 C35.297,24.674 35.542,24.737 35.787,24.714 L37.133,24.574 L37.683,25.811 C37.783,26.036 37.964,26.217 38.19,26.317 L39.426,26.868 L39.286,28.213 C39.26,28.458 39.326,28.704 39.471,28.904 L40.265,30 L39.471,31.096 Z M38.316,42.051 C37.957,41.932 37.56,42.025 37.293,42.293 L36.447,43.139 L34.824,38.137 L35.96,37.314 L37.485,37.474 L39.328,42.389 L38.316,42.051 Z M32.225,42.81 L31.707,42.293 C31.44,42.025 31.043,41.932 30.684,42.051 L29.412,42.475 L30.666,37.458 L32.04,37.314 L32.859,37.908 L32.74,37.896 L32.225,42.81 Z M42.31,29.413 L41.314,28.04 L41.49,26.353 C41.535,25.922 41.298,25.511 40.902,25.335 L39.354,24.646 L38.665,23.097 C38.489,22.703 38.076,22.468 37.647,22.509 L35.96,22.686 L34.587,21.69 C34.237,21.437 33.763,21.437 33.413,21.69 L32.04,22.686 L30.353,22.509 C29.927,22.469 29.512,22.703 29.335,23.098 L28.646,24.646 L27.098,25.335 C26.702,25.511 26.464,25.922 26.51,26.353 L26.686,28.04 L25.69,29.413 C25.437,29.763 25.437,30.237 25.69,30.587 L26.686,31.96 L26.51,33.647 C26.465,34.078 26.702,34.489 27.098,34.665 L28.646,35.354 L28.956,36.052 L27.03,43.757 C26.941,44.111 27.053,44.486 27.32,44.734 C27.588,44.983 27.972,45.065 28.316,44.949 L30.729,44.144 L32.293,45.707 C32.483,45.898 32.739,46 33,46 C33.112,46 33.225,45.981 33.334,45.942 C33.697,45.814 33.954,45.488 33.994,45.104 L34.236,42.803 L35.049,45.309 C35.156,45.64 35.428,45.891 35.767,45.972 C35.844,45.991 35.922,46 36,46 C36.262,46 36.518,45.897 36.707,45.707 L38.271,44.144 L40.684,44.949 C41.051,45.071 41.452,44.971 41.72,44.694 C41.987,44.417 42.071,44.01 41.937,43.649 L39.067,35.997 L39.354,35.354 L40.902,34.665 C41.298,34.489 41.536,34.078 41.49,33.647 L41.314,31.96 L42.31,30.587 C42.563,30.237 42.563,29.763 42.31,29.413 L42.31,29.413 Z" id="Fill-1" fill="#E7157B"></path>
    </g>
</svg>`, sR = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Management-Governance/Res_AWS-Systems-Manager_Distributor_48</title>
    <g id="Icon-Resource/Management-Governance/Res_AWS-Systems-Manager_Distributor_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M19,18 L29,18 L29,16 L19,16 L19,18 Z M23.375,13.781 L18.375,9.781 L19.625,8.219 L23,10.919 L23,2 L25,2 L25,10.919 L28.375,8.219 L29.625,9.781 L24.625,13.781 C24.442,13.927 24.221,14 24,14 C23.779,14 23.558,13.927 23.375,13.781 L23.375,13.781 Z M29.061,31.174 L25.391,24.933 L39.623,17.335 L43.591,24.114 L29.061,31.174 Z M39,36.526 C37.558,37.472 31.153,40.581 25,43.436 L25,28.215 L27.805,32.984 C27.99,33.299 28.323,33.478 28.668,33.478 C28.815,33.478 28.964,33.445 29.105,33.377 L39,28.569 L39,36.526 Z M9,28.501 L18.891,33.375 C19.033,33.444 19.184,33.478 19.332,33.478 C19.677,33.478 20.01,33.3 20.195,32.984 L23,28.215 L23,43.383 L9,36.394 L9,28.501 Z M8.372,17.333 L22.609,24.933 L18.942,31.17 L4.411,24.011 L8.372,17.333 Z M45.863,24.036 L40.863,15.495 C40.771,15.338 40.636,15.23 40.488,15.146 L40.496,15.132 L33.496,11.132 L32.504,12.868 L37.933,15.97 L24,23.408 L10.178,16.029 L16.447,12.895 L15.553,11.105 L7.553,15.105 L7.561,15.121 C7.394,15.204 7.241,15.318 7.14,15.49 L2.14,23.92 C1.998,24.16 1.962,24.448 2.041,24.715 C2.121,24.982 2.308,25.204 2.558,25.327 L7,27.516 L7,37.013 C7,37.392 7.214,37.738 7.554,37.907 L23.554,45.895 L23.558,45.886 C23.697,45.956 23.847,46 24,46 C24.143,46 24.285,45.97 24.418,45.908 C41,38.274 41,37.754 41,36.967 L41,27.597 L45.438,25.441 C45.688,25.319 45.876,25.098 45.957,24.832 C46.038,24.565 46.004,24.277 45.863,24.036 L45.863,24.036 Z" id="Fill-1" fill="#E7157B"></path>
    </g>
</svg>`, rR = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Management-Governance/Res_Amazon-CloudWatch_Cross-account-Observability_48</title>
    <g id="Icon-Resource/Management-Governance/Res_Amazon-CloudWatch_Cross-account-Observability_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M26.014,43.982 C24.911,43.982 24.014,43.085 24.014,41.982 C24.014,40.879 24.911,39.982 26.014,39.982 C27.117,39.982 28.014,40.879 28.014,41.982 C28.014,43.085 27.117,43.982 26.014,43.982 L26.014,43.982 Z M14.014,32.982 C12.911,32.982 12.014,32.085 12.014,30.982 C12.014,29.879 12.911,28.982 14.014,28.982 C15.117,28.982 16.014,29.879 16.014,30.982 C16.014,32.085 15.117,32.982 14.014,32.982 L14.014,32.982 Z M37.014,24.982 C38.117,24.982 39.014,25.879 39.014,26.982 C39.014,28.085 38.117,28.982 37.014,28.982 C35.911,28.982 35.014,28.085 35.014,26.982 C35.014,25.879 35.911,24.982 37.014,24.982 L37.014,24.982 Z M35.851,30.789 C36.222,30.903 36.607,30.982 37.014,30.982 C39.22,30.982 41.014,29.188 41.014,26.982 C41.014,24.776 39.22,22.982 37.014,22.982 C34.808,22.982 33.014,24.776 33.014,26.982 C33.014,28.052 33.442,29.02 34.129,29.739 L27.338,38.225 C26.922,38.077 26.481,37.982 26.014,37.982 C25.455,37.982 24.923,38.099 24.439,38.307 L17.768,32.315 C17.918,31.896 18.014,31.452 18.014,30.982 C18.014,28.776 16.22,26.982 14.014,26.982 C11.808,26.982 10.014,28.776 10.014,30.982 C10.014,31.382 10.091,31.761 10.201,32.125 L2.4,38.192 L3.628,39.772 L11.239,33.852 C11.959,34.549 12.935,34.982 14.014,34.982 C15.019,34.982 15.928,34.597 16.631,33.982 L22.848,39.566 C22.332,40.239 22.014,41.071 22.014,41.982 C22.014,44.188 23.808,45.982 26.014,45.982 C28.22,45.982 30.014,44.188 30.014,41.982 C30.014,40.97 29.624,40.054 29.002,39.349 L35.851,30.789 Z M46.012,27.154 C45.966,29.554 44.986,31.795 43.252,33.464 C41.561,35.092 39.353,35.982 37.018,35.982 C36.959,35.982 36.901,35.982 36.841,35.981 C36.523,35.974 36.206,35.951 35.896,35.913 L36.142,33.928 C36.384,33.958 36.63,33.976 36.879,33.981 C38.742,34.029 40.516,33.321 41.866,32.023 C43.214,30.725 43.977,28.982 44.012,27.116 C44.048,25.25 43.353,23.48 42.055,22.13 C40.756,20.782 39.014,20.019 37.148,19.983 C35.335,19.951 33.512,20.643 32.162,21.941 C30.814,23.239 30.051,24.982 30.016,26.848 C29.992,28.077 30.293,29.293 30.888,30.364 L29.138,31.334 C28.373,29.955 27.986,28.39 28.016,26.809 C28.062,24.41 29.042,22.169 30.776,20.5 C32.509,18.832 34.768,17.943 37.187,17.983 C39.586,18.03 41.827,19.01 43.495,20.744 C45.164,22.478 46.058,24.754 46.012,27.154 L46.012,27.154 Z M25.386,4 C27.28,4 28.821,5.511 28.821,7.37 C28.821,9.228 27.28,10.74 25.386,10.74 C23.492,10.74 21.951,9.228 21.951,7.37 C21.951,5.511 23.492,4 25.386,4 L25.386,4 Z M25.373,13.036 C26.57,13.036 27.742,13.371 28.764,14.006 C29.737,14.61 30.552,15.469 31.121,16.489 L32.868,15.514 C32.133,14.198 31.079,13.089 29.819,12.307 C29.429,12.065 29.018,11.866 28.599,11.692 C29.943,10.713 30.821,9.143 30.821,7.37 C30.821,4.409 28.383,2 25.386,2 C22.389,2 19.951,4.409 19.951,7.37 C19.951,9.139 20.825,10.706 22.165,11.685 C20.398,12.419 18.876,13.741 17.892,15.491 L19.636,16.471 C20.826,14.352 23.025,13.036 25.373,13.036 L25.373,13.036 Z M11.373,17.036 C12.57,17.036 13.742,17.371 14.764,18.006 C16.495,19.081 17.662,20.931 17.951,22.982 L4.793,22.982 C5.259,19.624 8.033,17.036 11.373,17.036 L11.373,17.036 Z M11.386,8 C13.28,8 14.821,9.511 14.821,11.37 C14.821,13.228 13.28,14.74 11.386,14.74 C9.492,14.74 7.951,13.228 7.951,11.37 C7.951,9.511 9.492,8 11.386,8 L11.386,8 Z M3.725,24.982 L19.022,24.982 C19.575,24.982 20.022,24.534 20.022,23.982 C20.022,20.857 18.411,17.916 15.819,16.307 C15.429,16.065 15.018,15.866 14.599,15.692 C15.943,14.713 16.821,13.143 16.821,11.37 C16.821,8.409 14.383,6 11.386,6 C8.389,6 5.951,8.409 5.951,11.37 C5.951,13.137 6.823,14.703 8.161,15.683 C4.98,17.005 2.725,20.224 2.725,23.982 C2.725,24.534 3.172,24.982 3.725,24.982 L3.725,24.982 Z" id="Fill-1" fill="#E7157B"></path>
    </g>
</svg>`, oR = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Management-Governance/Res_AWS-Trusted-Advisor_Checklist-Fault-Tolerant_48</title>
    <g id="Icon-Resource/Management-Governance/Res_AWS-Trusted-Advisor_Checklist-Fault-Tolerant_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M33.6259,40.2598 C33.2759,40.2598 32.9909,40.3688 32.7719,40.5878 C32.5539,40.8068 32.4439,41.0908 32.4439,41.4408 C32.4439,41.7908 32.5539,42.0748 32.7719,42.2938 C32.9909,42.5128 33.2759,42.6218 33.6259,42.6218 C33.9759,42.6218 34.2609,42.5128 34.4799,42.2938 C34.6979,42.0748 34.8079,41.7908 34.8079,41.4408 C34.8079,41.0908 34.6979,40.8068 34.4799,40.5878 C34.2609,40.3688 33.9759,40.2598 33.6259,40.2598 L33.6259,40.2598 Z M32.5759,33.3828 L32.8649,39.4198 L34.3869,39.4198 L34.6759,33.3828 C34.3259,33.2158 33.9759,33.1328 33.6259,33.1328 C33.2759,33.1328 32.9259,33.2158 32.5759,33.3828 L32.5759,33.3828 Z M43.2479,43.9998 L33.6259,27.7158 L24.0029,43.9998 L43.2479,43.9998 Z M45.8689,45.4958 C45.6909,45.8078 45.3599,45.9998 45.0009,45.9998 L22.2499,45.9998 C21.8909,45.9998 21.5599,45.8078 21.3819,45.4948 C21.2029,45.1838 21.2059,44.8008 21.3889,44.4908 L32.7649,25.2408 C32.9449,24.9368 33.2719,24.7498 33.6259,24.7498 C33.9799,24.7498 34.3069,24.9368 34.4869,25.2408 L45.8619,44.4908 C46.0449,44.8008 46.0479,45.1838 45.8689,45.4958 L45.8689,45.4958 Z M6.3279,26.6798 L4.9219,28.1018 L7.7229,30.8718 C7.9099,31.0578 8.1629,31.1608 8.4259,31.1608 C8.4489,31.1608 8.4729,31.1598 8.4969,31.1578 C8.7839,31.1378 9.0489,30.9948 9.2229,30.7648 L13.4219,25.2238 L11.8279,24.0168 L8.3179,28.6478 L6.3279,26.6798 Z M11.8279,14.6828 L8.3169,19.3148 L6.3279,17.3468 L4.9219,18.7688 L7.7229,21.5388 C7.9099,21.7248 8.1629,21.8278 8.4259,21.8278 C8.4489,21.8278 8.4739,21.8268 8.4969,21.8248 C8.7839,21.8048 9.0489,21.6618 9.2229,21.4318 L13.4219,15.8898 L11.8279,14.6828 Z M11.8279,5.3498 L8.3179,9.9808 L6.3279,8.0128 L4.9219,9.4348 L7.7229,12.2048 C7.9099,12.3908 8.1629,12.4938 8.4259,12.4938 C8.4489,12.4938 8.4729,12.4928 8.4969,12.4908 C8.7839,12.4708 9.0489,12.3278 9.2229,12.0978 L13.4219,6.5568 L11.8279,5.3498 Z M15.2499,29.3748 L26.6259,29.3748 L26.6259,27.3748 L15.2499,27.3748 L15.2499,29.3748 Z M15.2499,20.6248 L26.6259,20.6248 L26.6259,18.6248 L15.2499,18.6248 L15.2499,20.6248 Z M15.2499,10.9998 L26.6259,10.9998 L26.6259,8.9998 L15.2499,8.9998 L15.2499,10.9998 Z M24.8749,36.3748 L2.9999,36.3748 C2.4469,36.3748 1.9999,35.9278 1.9999,35.3748 L1.9999,2.9998 C1.9999,2.4468 2.4469,1.9998 2.9999,1.9998 L29.2509,1.9998 C29.8039,1.9998 30.2509,2.4468 30.2509,2.9998 L30.2509,28.3748 L28.2509,28.3748 L28.2509,3.9998 L3.9999,3.9998 L3.9999,34.3748 L24.8749,34.3748 L24.8749,36.3748 Z" id="AWS-Trusted-Advisor_checklist-fault-tolerant_Resource-Icon_light-bg" fill="#E7157B"></path>
    </g>
</svg>`, lR = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Management-Governance/Res_AWS-Trusted-Advisor_Checklist_48</title>
    <g id="Icon-Resource/Management-Governance/Res_AWS-Trusted-Advisor_Checklist_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M13.2849,41.291 L9.7889,37.795 L11.2029,36.381 L13.8839,39.062 L18.4359,32.992 L20.0359,34.191 L14.7919,41.184 C14.6179,41.416 14.3519,41.561 14.0629,41.581 C14.0389,41.583 14.0149,41.584 13.9919,41.584 C13.7269,41.584 13.4729,41.479 13.2849,41.291 L13.2849,41.291 Z M13.2849,27.307 L9.7889,23.811 L11.2029,22.396 L13.8839,25.077 L18.4359,19.008 L20.0359,20.207 L14.7919,27.199 C14.6179,27.432 14.3519,27.576 14.0629,27.597 C14.0389,27.599 14.0149,27.6 13.9919,27.6 C13.7269,27.6 13.4729,27.495 13.2849,27.307 L13.2849,27.307 Z M13.2849,13.321 L9.7889,9.825 L11.2029,8.411 L13.8839,11.092 L18.4359,5.022 L20.0359,6.222 L14.7919,13.214 C14.6179,13.446 14.3519,13.591 14.0629,13.611 C14.0389,13.613 14.0149,13.614 13.9919,13.614 C13.7269,13.614 13.4729,13.51 13.2849,13.321 L13.2849,13.321 Z M22.7329,39.836 L37.5919,39.836 L37.5919,37.836 L22.7329,37.836 L22.7329,39.836 Z M22.7329,26.726 L37.5919,26.726 L37.5919,24.726 L22.7329,24.726 L22.7329,26.726 Z M22.7329,12.74 L37.5919,12.74 L37.5919,10.74 L22.7329,10.74 L22.7329,12.74 Z M7.9999,43.954 L40.9619,43.954 L40.9619,4 L7.9999,4 L7.9999,43.954 Z M41.9619,2 L6.9999,2 C6.4469,2 5.9999,2.447 5.9999,3 L5.9999,44.954 C5.9999,45.507 6.4469,45.954 6.9999,45.954 L41.9619,45.954 C42.5139,45.954 42.9619,45.507 42.9619,44.954 L42.9619,3 C42.9619,2.447 42.5139,2 41.9619,2 L41.9619,2 Z" id="AWS-Trusted-Advisor_checklist_Resource-Icon_light-bg" fill="#E7157B"></path>
    </g>
</svg>`, LR = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Networking-and-Content-Delivery/Res_Amazon-Route-53_Route-Table_48</title>
    <g id="Icon-Resource/Networking-and-Content-Delivery/Res_Amazon-Route-53_Route-Table_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M4,43.07 L43.944,43.07 L43.944,33.711 L4,33.711 L4,43.07 Z M45.944,32.711 L45.944,44.07 C45.944,44.623 45.497,45.07 44.944,45.07 L3,45.07 C2.447,45.07 2,44.623 2,44.07 L2,32.711 C2,32.158 2.447,31.711 3,31.711 L44.944,31.711 C45.497,31.711 45.944,32.158 45.944,32.711 L45.944,32.711 Z M4,28.214 L43.944,28.214 L43.944,18.855 L4,18.855 L4,28.214 Z M45.944,17.855 L45.944,29.215 C45.944,29.767 45.497,30.215 44.944,30.215 L3,30.215 C2.447,30.215 2,29.767 2,29.215 L2,17.855 C2,17.302 2.447,16.855 3,16.855 L44.944,16.855 C45.497,16.855 45.944,17.302 45.944,17.855 L45.944,17.855 Z M4,13.359 L43.944,13.359 L43.944,4 L4,4 L4,13.359 Z M45.944,3 L45.944,14.359 C45.944,14.912 45.497,15.359 44.944,15.359 L3,15.359 C2.447,15.359 2,14.912 2,14.359 L2,3 C2,2.447 2.447,2 3,2 L44.944,2 C45.497,2 45.944,2.447 45.944,3 L45.944,3 Z M39.399,38.417 C39.399,39.273 39.479,39.893 39.64,40.278 C39.801,40.663 40.058,40.854 40.411,40.854 C40.763,40.854 41.02,40.663 41.181,40.278 C41.342,39.893 41.422,39.273 41.422,38.417 C41.422,37.566 41.342,36.949 41.181,36.564 C41.02,36.179 40.763,35.987 40.411,35.987 C40.058,35.987 39.801,36.179 39.64,36.564 C39.479,36.949 39.399,37.566 39.399,38.417 L39.399,38.417 Z M38.986,40.758 C38.661,40.222 38.499,39.442 38.499,38.417 C38.499,37.391 38.661,36.612 38.986,36.079 C39.311,35.546 39.786,35.279 40.411,35.279 C41.036,35.279 41.511,35.546 41.835,36.079 C42.161,36.612 42.323,37.391 42.323,38.417 C42.323,39.448 42.161,40.23 41.835,40.762 C41.511,41.296 41.036,41.562 40.411,41.562 C39.786,41.562 39.311,41.295 38.986,40.758 L38.986,40.758 Z M37.107,41.536 C37.273,41.536 37.409,41.485 37.51,41.383 C37.612,41.282 37.664,41.146 37.664,40.977 C37.664,40.808 37.612,40.673 37.51,40.571 C37.409,40.468 37.273,40.418 37.107,40.418 C36.94,40.418 36.804,40.468 36.703,40.571 C36.601,40.673 36.55,40.808 36.55,40.977 C36.55,41.146 36.601,41.282 36.703,41.383 C36.804,41.485 36.94,41.536 37.107,41.536 L37.107,41.536 Z M35.584,40.723 L33.059,40.723 C33.777,39.849 34.285,39.202 34.582,38.779 C34.878,38.357 35.083,38.003 35.194,37.717 C35.305,37.432 35.362,37.156 35.362,36.887 C35.362,36.381 35.228,35.986 34.961,35.703 C34.696,35.421 34.325,35.279 33.849,35.279 C33.576,35.279 33.31,35.325 33.05,35.415 C32.791,35.505 32.521,35.649 32.243,35.847 L32.243,36.591 C32.83,36.217 33.316,36.031 33.7,36.031 C34.202,36.031 34.452,36.334 34.452,36.94 C34.452,37.214 34.38,37.502 34.239,37.805 C34.095,38.108 33.861,38.488 33.533,38.945 C33.205,39.402 32.728,40.018 32.103,40.794 L32.103,41.449 L35.584,41.449 L35.584,40.723 Z M30.498,41.536 C30.665,41.536 30.799,41.485 30.902,41.383 C31.003,41.282 31.055,41.146 31.055,40.977 C31.055,40.808 31.003,40.673 30.902,40.571 C30.799,40.468 30.665,40.418 30.498,40.418 C30.331,40.418 30.196,40.468 30.094,40.571 C29.992,40.673 29.941,40.808 29.941,40.977 C29.941,41.146 29.992,41.282 30.094,41.383 C30.196,41.485 30.331,41.536 30.498,41.536 L30.498,41.536 Z M26.255,38.784 C26.255,39.507 26.337,40.035 26.502,40.37 C26.666,40.705 26.923,40.872 27.276,40.872 C27.865,40.872 28.159,40.462 28.159,39.64 C28.159,39.261 28.082,38.971 27.926,38.77 C27.772,38.57 27.543,38.468 27.24,38.468 C26.918,38.468 26.59,38.55 26.255,38.714 L26.255,38.784 Z M25.842,40.841 C25.536,40.361 25.383,39.62 25.383,38.618 C25.383,37.54 25.568,36.714 25.936,36.14 C26.304,35.566 26.828,35.279 27.508,35.279 C27.718,35.279 27.931,35.305 28.145,35.358 C28.358,35.411 28.545,35.48 28.706,35.568 L28.706,36.206 C28.551,36.135 28.375,36.079 28.177,36.036 C27.979,35.992 27.794,35.969 27.62,35.969 C27.181,35.969 26.853,36.143 26.636,36.49 C26.419,36.837 26.295,37.388 26.265,38.146 C26.661,37.913 27.07,37.796 27.491,37.796 C27.96,37.796 28.336,37.96 28.618,38.286 C28.9,38.612 29.041,39.046 29.041,39.588 C29.041,40.194 28.878,40.674 28.558,41.029 C28.236,41.384 27.799,41.562 27.25,41.562 C26.618,41.562 26.149,41.322 25.842,40.841 L25.842,40.841 Z M22.635,41.449 L23.517,41.449 L23.517,35.393 L22.71,35.393 L21.252,36.223 L21.252,36.94 L22.635,36.284 L22.635,41.449 Z M19.377,41.536 C19.544,41.536 19.679,41.485 19.782,41.383 C19.883,41.282 19.935,41.146 19.935,40.977 C19.935,40.808 19.883,40.673 19.782,40.571 C19.679,40.468 19.544,40.418 19.377,40.418 C19.211,40.418 19.076,40.468 18.974,40.571 C18.872,40.673 18.821,40.808 18.821,40.977 C18.821,41.146 18.872,41.282 18.974,41.383 C19.076,41.485 19.211,41.536 19.377,41.536 L19.377,41.536 Z M17.855,40.723 L15.331,40.723 C16.048,39.849 16.556,39.202 16.852,38.779 C17.15,38.357 17.354,38.003 17.465,37.717 C17.577,37.432 17.633,37.156 17.633,36.887 C17.633,36.381 17.5,35.986 17.233,35.703 C16.967,35.421 16.596,35.279 16.121,35.279 C15.847,35.279 15.582,35.325 15.322,35.415 C15.061,35.505 14.793,35.649 14.514,35.847 L14.514,36.591 C15.101,36.217 15.587,36.031 15.971,36.031 C16.473,36.031 16.723,36.334 16.723,36.94 C16.723,37.214 16.652,37.502 16.51,37.805 C16.367,38.108 16.132,38.488 15.804,38.945 C15.476,39.402 15,40.018 14.375,40.794 L14.375,41.449 L17.855,41.449 L17.855,40.723 Z M10.429,41.449 L11.339,41.449 L13.28,36.04 L13.28,35.393 L9.734,35.393 L9.734,36.118 L12.398,36.118 L10.429,41.449 Z M7.004,41.449 L7.886,41.449 L7.886,35.393 L7.079,35.393 L5.621,36.223 L5.621,36.94 L7.004,36.284 L7.004,41.449 Z M39.399,23.237 C39.399,24.093 39.479,24.715 39.64,25.099 C39.801,25.483 40.058,25.675 40.411,25.675 C40.763,25.675 41.02,25.483 41.181,25.099 C41.342,24.715 41.422,24.093 41.422,23.237 C41.422,22.387 41.342,21.769 41.181,21.385 C41.02,21.001 40.763,20.808 40.411,20.808 C40.058,20.808 39.801,21.001 39.64,21.385 C39.479,21.769 39.399,22.387 39.399,23.237 L39.399,23.237 Z M38.986,25.58 C38.661,25.044 38.499,24.263 38.499,23.237 C38.499,22.213 38.661,21.433 38.986,20.9 C39.311,20.367 39.786,20.1 40.411,20.1 C41.036,20.1 41.511,20.367 41.835,20.9 C42.161,21.433 42.323,22.213 42.323,23.237 C42.323,24.268 42.161,25.05 41.835,25.584 C41.511,26.117 41.036,26.383 40.411,26.383 C39.786,26.383 39.311,26.116 38.986,25.58 L38.986,25.58 Z M37.107,26.357 C37.273,26.357 37.409,26.306 37.51,26.204 C37.612,26.102 37.664,25.967 37.664,25.798 C37.664,25.629 37.612,25.494 37.51,25.391 C37.409,25.29 37.273,25.239 37.107,25.239 C36.94,25.239 36.804,25.29 36.703,25.391 C36.601,25.494 36.55,25.629 36.55,25.798 C36.55,25.967 36.601,26.102 36.703,26.204 C36.804,26.306 36.94,26.357 37.107,26.357 L37.107,26.357 Z M33.755,26.27 L34.637,26.27 L34.637,20.214 L33.83,20.214 L32.373,21.045 L32.373,21.76 L33.755,21.105 L33.755,26.27 Z M30.498,26.357 C30.665,26.357 30.799,26.306 30.902,26.204 C31.003,26.102 31.055,25.967 31.055,25.798 C31.055,25.629 31.003,25.494 30.902,25.391 C30.799,25.29 30.665,25.239 30.498,25.239 C30.331,25.239 30.196,25.29 30.094,25.391 C29.992,25.494 29.941,25.629 29.941,25.798 C29.941,25.967 29.992,26.102 30.094,26.204 C30.196,26.306 30.331,26.357 30.498,26.357 L30.498,26.357 Z M26.255,23.605 C26.255,24.327 26.337,24.856 26.502,25.191 C26.666,25.526 26.923,25.693 27.276,25.693 C27.865,25.693 28.159,25.283 28.159,24.462 C28.159,24.083 28.082,23.793 27.926,23.591 C27.772,23.39 27.543,23.29 27.24,23.29 C26.918,23.29 26.59,23.372 26.255,23.535 L26.255,23.605 Z M25.842,25.663 C25.536,25.182 25.383,24.441 25.383,23.438 C25.383,22.361 25.568,21.535 25.936,20.961 C26.304,20.387 26.828,20.1 27.508,20.1 C27.718,20.1 27.931,20.127 28.145,20.179 C28.358,20.231 28.545,20.301 28.706,20.389 L28.706,21.027 C28.551,20.957 28.375,20.9 28.177,20.856 C27.979,20.812 27.794,20.791 27.62,20.791 C27.181,20.791 26.853,20.964 26.636,21.311 C26.419,21.657 26.295,22.21 26.265,22.966 C26.661,22.734 27.07,22.617 27.491,22.617 C27.96,22.617 28.336,22.78 28.618,23.106 C28.9,23.433 29.041,23.867 29.041,24.409 C29.041,25.014 28.878,25.495 28.558,25.85 C28.236,26.206 27.799,26.383 27.25,26.383 C26.618,26.383 26.149,26.143 25.842,25.663 L25.842,25.663 Z M22.635,26.27 L23.517,26.27 L23.517,20.214 L22.71,20.214 L21.252,21.045 L21.252,21.76 L22.635,21.105 L22.635,26.27 Z M19.377,26.357 C19.544,26.357 19.679,26.306 19.782,26.204 C19.883,26.102 19.935,25.967 19.935,25.798 C19.935,25.629 19.883,25.494 19.782,25.391 C19.679,25.29 19.544,25.239 19.377,25.239 C19.211,25.239 19.076,25.29 18.974,25.391 C18.872,25.494 18.821,25.629 18.821,25.798 C18.821,25.967 18.872,26.102 18.974,26.204 C19.076,26.306 19.211,26.357 19.377,26.357 L19.377,26.357 Z M17.855,25.545 L15.331,25.545 C16.048,24.671 16.556,24.022 16.852,23.6 C17.15,23.178 17.354,22.824 17.465,22.539 C17.577,22.253 17.633,21.976 17.633,21.708 C17.633,21.202 17.5,20.807 17.233,20.524 C16.967,20.242 16.596,20.1 16.121,20.1 C15.847,20.1 15.582,20.145 15.322,20.236 C15.061,20.326 14.793,20.47 14.514,20.669 L14.514,21.411 C15.101,21.039 15.587,20.852 15.971,20.852 C16.473,20.852 16.723,21.155 16.723,21.76 C16.723,22.035 16.652,22.323 16.51,22.626 C16.367,22.929 16.132,23.309 15.804,23.766 C15.476,24.223 15,24.84 14.375,25.615 L14.375,26.27 L17.855,26.27 L17.855,25.545 Z M10.429,26.27 L11.339,26.27 L13.28,20.861 L13.28,20.214 L9.734,20.214 L9.734,20.939 L12.398,20.939 L10.429,26.27 Z M7.004,26.27 L7.886,26.27 L7.886,20.214 L7.079,20.214 L5.621,21.045 L5.621,21.76 L7.004,21.105 L7.004,26.27 Z M39.399,8.917 C39.399,9.773 39.479,10.394 39.64,10.779 C39.801,11.163 40.058,11.355 40.411,11.355 C40.763,11.355 41.02,11.163 41.181,10.779 C41.342,10.394 41.422,9.773 41.422,8.917 C41.422,8.067 41.342,7.449 41.181,7.065 C41.02,6.68 40.763,6.488 40.411,6.488 C40.058,6.488 39.801,6.68 39.64,7.065 C39.479,7.449 39.399,8.067 39.399,8.917 L39.399,8.917 Z M38.986,11.259 C38.661,10.723 38.499,9.943 38.499,8.917 C38.499,7.892 38.661,7.113 38.986,6.58 C39.311,6.047 39.786,5.78 40.411,5.78 C41.036,5.78 41.511,6.047 41.835,6.58 C42.161,7.113 42.323,7.892 42.323,8.917 C42.323,9.948 42.161,10.73 41.835,11.263 C41.511,11.797 41.036,12.063 40.411,12.063 C39.786,12.063 39.311,11.795 38.986,11.259 L38.986,11.259 Z M37.107,12.037 C37.273,12.037 37.409,11.986 37.51,11.883 C37.612,11.782 37.664,11.646 37.664,11.477 C37.664,11.308 37.612,11.174 37.51,11.071 C37.409,10.969 37.273,10.919 37.107,10.919 C36.94,10.919 36.804,10.969 36.703,11.071 C36.601,11.174 36.55,11.308 36.55,11.477 C36.55,11.646 36.601,11.782 36.703,11.883 C36.804,11.986 36.94,12.037 37.107,12.037 L37.107,12.037 Z M32.791,8.917 C32.791,9.773 32.871,10.394 33.031,10.779 C33.193,11.163 33.449,11.355 33.801,11.355 C34.154,11.355 34.412,11.163 34.572,10.779 C34.734,10.394 34.813,9.773 34.813,8.917 C34.813,8.067 34.734,7.449 34.572,7.065 C34.412,6.68 34.154,6.488 33.801,6.488 C33.449,6.488 33.193,6.68 33.031,7.065 C32.871,7.449 32.791,8.067 32.791,8.917 L32.791,8.917 Z M32.377,11.259 C32.052,10.723 31.89,9.943 31.89,8.917 C31.89,7.892 32.052,7.113 32.377,6.58 C32.703,6.047 33.177,5.78 33.801,5.78 C34.427,5.78 34.902,6.047 35.226,6.58 C35.552,7.113 35.714,7.892 35.714,8.917 C35.714,9.948 35.552,10.73 35.226,11.263 C34.902,11.797 34.427,12.063 33.801,12.063 C33.177,12.063 32.703,11.795 32.377,11.259 L32.377,11.259 Z M30.498,12.037 C30.665,12.037 30.799,11.986 30.902,11.883 C31.003,11.782 31.055,11.646 31.055,11.477 C31.055,11.308 31.003,11.174 30.902,11.071 C30.799,10.969 30.665,10.919 30.498,10.919 C30.331,10.919 30.196,10.969 30.094,11.071 C29.992,11.174 29.941,11.308 29.941,11.477 C29.941,11.646 29.992,11.782 30.094,11.883 C30.196,11.986 30.331,12.037 30.498,12.037 L30.498,12.037 Z M26.255,9.284 C26.255,10.007 26.337,10.536 26.502,10.871 C26.666,11.206 26.923,11.373 27.276,11.373 C27.865,11.373 28.159,10.962 28.159,10.14 C28.159,9.761 28.082,9.472 27.926,9.271 C27.772,9.07 27.543,8.969 27.24,8.969 C26.918,8.969 26.59,9.051 26.255,9.215 L26.255,9.284 Z M25.842,11.342 C25.536,10.861 25.383,10.12 25.383,9.118 C25.383,8.041 25.568,7.215 25.936,6.64 C26.304,6.067 26.828,5.78 27.508,5.78 C27.718,5.78 27.931,5.806 28.145,5.858 C28.358,5.911 28.545,5.981 28.706,6.068 L28.706,6.707 C28.551,6.636 28.375,6.58 28.177,6.536 C27.979,6.492 27.794,6.47 27.62,6.47 C27.181,6.47 26.853,6.643 26.636,6.991 C26.419,7.337 26.295,7.889 26.265,8.646 C26.661,8.414 27.07,8.297 27.491,8.297 C27.96,8.297 28.336,8.46 28.618,8.786 C28.9,9.112 29.041,9.547 29.041,10.089 C29.041,10.694 28.878,11.174 28.558,11.53 C28.236,11.885 27.799,12.063 27.25,12.063 C26.618,12.063 26.149,11.823 25.842,11.342 L25.842,11.342 Z M22.635,11.95 L23.517,11.95 L23.517,5.893 L22.71,5.893 L21.252,6.723 L21.252,7.44 L22.635,6.785 L22.635,11.95 Z M19.377,12.037 C19.544,12.037 19.679,11.986 19.782,11.883 C19.883,11.782 19.935,11.646 19.935,11.477 C19.935,11.308 19.883,11.174 19.782,11.071 C19.679,10.969 19.544,10.919 19.377,10.919 C19.211,10.919 19.076,10.969 18.974,11.071 C18.872,11.174 18.821,11.308 18.821,11.477 C18.821,11.646 18.872,11.782 18.974,11.883 C19.076,11.986 19.211,12.037 19.377,12.037 L19.377,12.037 Z M17.855,11.224 L15.331,11.224 C16.048,10.35 16.556,9.702 16.852,9.28 C17.15,8.858 17.354,8.504 17.465,8.218 C17.577,7.932 17.633,7.656 17.633,7.387 C17.633,6.882 17.5,6.487 17.233,6.204 C16.967,5.922 16.596,5.78 16.121,5.78 C15.847,5.78 15.582,5.825 15.322,5.916 C15.061,6.006 14.793,6.15 14.514,6.348 L14.514,7.091 C15.101,6.718 15.587,6.532 15.971,6.532 C16.473,6.532 16.723,6.835 16.723,7.44 C16.723,7.715 16.652,8.003 16.51,8.305 C16.367,8.608 16.132,8.989 15.804,9.446 C15.476,9.903 15,10.519 14.375,11.294 L14.375,11.95 L17.855,11.95 L17.855,11.224 Z M10.429,11.95 L11.339,11.95 L13.28,6.541 L13.28,5.893 L9.734,5.893 L9.734,6.619 L12.398,6.619 L10.429,11.95 Z M7.004,6.785 L5.621,7.44 L5.621,6.723 L7.079,5.893 L7.886,5.893 L7.886,11.95 L7.004,11.95 L7.004,6.785 Z" id="AWS-Amazon-Route-53_Route-table_Resource-Icon_light-bg" fill="#8C4FFF"></path>
    </g>
</svg>`, aR = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Networking-and-Content-Delivery/Res_Amazon-CloudFront_Download-Distribution_48</title>
    <g id="Icon-Resource/Networking-and-Content-Delivery/Res_Amazon-CloudFront_Download-Distribution_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M15.9581,27.6694 L17.3721,29.0834 L15.9581,30.4974 L14.5441,29.0834 L15.9581,27.6694 Z M18.8531,30.5644 L21.8131,33.5244 L20.3991,34.9394 L17.4381,31.9784 L18.8531,30.5644 Z M29.1501,30.5644 L30.5641,31.9784 L27.6041,34.9394 L26.1891,33.5244 L29.1501,30.5644 Z M32.0451,27.6694 L33.4591,29.0834 L32.0451,30.4974 L30.6311,29.0834 L32.0451,27.6694 Z M25.0011,35.2984 L26.1221,36.4194 L24.7081,37.8344 C24.5131,38.0294 24.2571,38.1274 24.0011,38.1274 C23.7451,38.1274 23.4891,38.0294 23.2941,37.8344 L21.8801,36.4194 L23.0011,35.2984 L23.0011,34.2524 L25.0011,34.2524 L25.0011,35.2984 Z M23.0011,16.4624 L25.0011,16.4624 L25.0011,12.9044 L23.0011,12.9044 L23.0011,16.4624 Z M23.0011,21.7994 L25.0011,21.7994 L25.0011,18.2414 L23.0011,18.2414 L23.0011,21.7994 Z M23.0011,27.1364 L25.0011,27.1364 L25.0011,23.5784 L23.0011,23.5784 L23.0011,27.1364 Z M23.0011,32.4734 L25.0011,32.4734 L25.0011,28.9154 L23.0011,28.9154 L23.0011,32.4734 Z M23.0011,11.1254 L25.0011,11.1254 L25.0011,9.1254 L23.0011,9.1254 L23.0011,11.1254 Z M24.0011,44.0024 C12.9731,44.0024 4.0001,35.0294 4.0001,24.0014 C4.0001,12.9724 12.9731,4.0004 24.0011,4.0004 C35.0291,4.0004 44.0021,12.9724 44.0021,24.0014 C44.0021,35.0294 35.0291,44.0024 24.0011,44.0024 L24.0011,44.0024 Z M24.0011,2.0004 C11.8691,2.0004 2.0001,11.8694 2.0001,24.0014 C2.0001,36.1324 11.8691,46.0024 24.0011,46.0024 C36.1331,46.0024 46.0021,36.1324 46.0021,24.0014 C46.0021,11.8694 36.1331,2.0004 24.0011,2.0004 L24.0011,2.0004 Z" id="AWS-Amazon-CloudFront_Download-distribution_Resource-Icon_light-bg" fill="#8C4FFF"></path>
    </g>
</svg>`, CR = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Networking-and-Content-Delivery/Res_Amazon-Route-53_Routing-Controls_48</title>
    <g id="Icon-Resource/Networking-and-Content-Delivery/Res_Amazon-Route-53_Routing-Controls_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M34.0547,39.446 C29.3917,40.284 25.4597,42.74 23.9917,43.752 C22.5247,42.74 18.5917,40.284 13.9287,39.446 C12.0487,39.108 6.7407,37.829 4.7607,34.011 L16.4637,34.011 C16.7157,36.255 18.6027,38.011 20.9127,38.011 C23.2237,38.011 25.1107,36.255 25.3627,34.011 L43.2227,34.011 C41.2427,37.829 35.9347,39.108 34.0547,39.446 L34.0547,39.446 Z M23.4127,33.511 C23.4127,34.89 22.2917,36.011 20.9127,36.011 C19.5337,36.011 18.4127,34.89 18.4127,33.511 C18.4127,32.133 19.5337,31.011 20.9127,31.011 C22.2917,31.011 23.4127,32.133 23.4127,33.511 L23.4127,33.511 Z M5.2787,26.011 L28.4637,26.011 C28.7157,28.255 30.6027,30.011 32.9127,30.011 C35.2237,30.011 37.1107,28.255 37.3627,26.011 L42.7047,26.011 C43.4267,27.385 43.9837,28.847 43.9837,30.82 C43.9837,31.237 43.9477,31.633 43.8847,32.011 L25.1367,32.011 C24.5157,30.269 22.8667,29.011 20.9127,29.011 C18.9597,29.011 17.3107,30.269 16.6897,32.011 L4.0987,32.011 C4.0357,31.633 3.9997,31.237 3.9997,30.82 C3.9997,28.847 4.5567,27.385 5.2787,26.011 L5.2787,26.011 Z M4.9407,11.199 C6.0947,9.796 8.6337,6.698 10.0267,4.916 C12.1477,6.849 14.5947,7.902 17.0187,7.902 C19.7187,7.902 21.9597,6.837 23.9917,4.569 C26.0237,6.837 28.2647,7.902 30.9647,7.902 C33.3887,7.902 35.8357,6.849 37.9567,4.916 C39.3497,6.698 41.8887,9.796 43.0427,11.199 C42.2107,12.071 40.8987,13.735 40.2617,16.011 L23.1367,16.011 C22.5157,14.269 20.8667,13.011 18.9127,13.011 C16.9597,13.011 15.3107,14.269 14.6897,16.011 L7.7217,16.011 C7.0847,13.735 5.7727,12.071 4.9407,11.199 L4.9407,11.199 Z M16.4127,17.511 C16.4127,16.133 17.5337,15.011 18.9127,15.011 C20.2917,15.011 21.4127,16.133 21.4127,17.511 C21.4127,18.89 20.2917,20.011 18.9127,20.011 C17.5337,20.011 16.4127,18.89 16.4127,17.511 L16.4127,17.511 Z M35.4127,25.511 C35.4127,26.89 34.2917,28.011 32.9127,28.011 C31.5337,28.011 30.4127,26.89 30.4127,25.511 C30.4127,24.133 31.5337,23.011 32.9127,23.011 C34.2917,23.011 35.4127,24.133 35.4127,25.511 L35.4127,25.511 Z M37.1367,24.011 C36.5157,22.269 34.8667,21.011 32.9127,21.011 C30.9597,21.011 29.3107,22.269 28.6897,24.011 L6.4097,24.011 C7.2867,22.471 8.0957,20.832 8.0957,18.68 C8.0957,18.449 8.0667,18.234 8.0507,18.011 L14.4637,18.011 C14.7157,20.255 16.6027,22.011 18.9127,22.011 C21.2237,22.011 23.1107,20.255 23.3627,18.011 L39.9327,18.011 C39.9167,18.234 39.8877,18.449 39.8877,18.68 C39.8877,20.832 40.6967,22.471 41.5737,24.011 L37.1367,24.011 Z M43.6467,23.603 C42.7027,21.977 41.8877,20.573 41.8877,18.68 C41.8877,14.682 45.0067,12.084 45.0357,12.06 C45.2427,11.892 45.3747,11.648 45.4027,11.383 C45.4287,11.117 45.3487,10.852 45.1787,10.646 C45.1267,10.584 40.0337,4.413 38.8707,2.818 C38.6967,2.577 38.4217,2.427 38.1237,2.409 C37.8427,2.388 37.5357,2.506 37.3327,2.724 C35.4157,4.773 33.1547,5.902 30.9647,5.902 C28.5487,5.902 26.6437,4.819 24.7857,2.392 C24.5967,2.145 24.3037,2 23.9917,2 C23.6807,2 23.3877,2.145 23.1987,2.392 C21.3397,4.819 19.4337,5.902 17.0187,5.902 C14.8287,5.902 12.5677,4.773 10.6507,2.724 C10.4467,2.506 10.1397,2.387 9.8597,2.409 C9.5617,2.427 9.2867,2.577 9.1127,2.818 C7.9497,4.413 2.8567,10.584 2.8047,10.646 C2.6357,10.851 2.5567,11.116 2.5817,11.381 C2.6087,11.645 2.7397,11.89 2.9457,12.058 C2.9767,12.084 6.0957,14.682 6.0957,18.68 C6.0957,20.573 5.2807,21.977 4.3367,23.603 C3.2417,25.49 1.9997,27.629 1.9997,30.82 C1.9997,36.152 6.3267,40.113 13.5757,41.415 C18.8887,42.369 23.3387,45.742 23.3837,45.777 C23.5627,45.914 23.7777,45.983 23.9917,45.983 C24.2067,45.983 24.4217,45.914 24.6007,45.777 C24.6457,45.742 29.0957,42.369 34.4087,41.415 C41.6567,40.113 45.9837,36.152 45.9837,30.82 C45.9837,27.629 44.7427,25.49 43.6467,23.603 L43.6467,23.603 Z" id="Fill-1" fill="#8C4FFF"></path>
    </g>
</svg>`, cR = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Networking-and-Content-Delivery/Res_Amazon-Route-53_Application-Recovery-Controller_48</title>
    <g id="Icon-Resource/Networking-and-Content-Delivery/Res_Amazon-Route-53_Application-Recovery-Controller_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M28.4775,30.0118 C27.6505,30.0118 26.9775,29.3388 26.9775,28.5118 C26.9775,27.6848 27.6505,27.0118 28.4775,27.0118 C29.3045,27.0118 29.9775,27.6848 29.9775,28.5118 C29.9775,29.3388 29.3045,30.0118 28.4775,30.0118 L28.4775,30.0118 Z M19.9775,35.0118 L19.9775,30.0118 L25.3295,30.0118 C25.6735,30.7338 26.2555,31.3148 26.9775,31.6608 L26.9775,35.0118 L19.9775,35.0118 Z M28.4775,25.0118 C26.7185,25.0118 25.2735,26.3208 25.0285,28.0118 L12.9775,28.0118 L12.9775,23.0118 L10.9775,23.0118 L10.9775,30.0118 L17.9775,30.0118 L17.9775,37.0118 L28.9775,37.0118 L28.9775,31.9608 C30.1595,31.7898 31.1475,31.0338 31.6385,29.9898 L36.9775,29.9898 L36.9775,27.9898 L31.9245,27.9898 C31.6695,26.3088 30.2285,25.0118 28.4775,25.0118 L28.4775,25.0118 Z M20.4775,21.0118 C19.6505,21.0118 18.9775,20.3388 18.9775,19.5118 C18.9775,18.6848 19.6505,18.0118 20.4775,18.0118 C21.3045,18.0118 21.9775,18.6848 21.9775,19.5118 C21.9775,20.3388 21.3045,21.0118 20.4775,21.0118 L20.4775,21.0118 Z M20.4775,16.0118 C20.3065,16.0118 20.1425,16.0388 19.9775,16.0628 L19.9775,13.0118 L26.9775,13.0118 L26.9775,18.0118 L28.9775,18.0118 L28.9775,11.0118 L17.9775,11.0118 L17.9775,17.0698 C17.4705,17.5898 17.1345,18.2668 17.0275,19.0188 L10.9775,19.0188 L10.9775,21.0188 L17.3325,21.0188 C17.8985,22.1938 19.0895,23.0118 20.4775,23.0118 C21.8685,23.0118 23.0625,22.1898 23.6255,21.0118 L34.9775,21.0118 L34.9775,26.0118 L36.9775,26.0118 L36.9775,19.0118 L23.9265,19.0118 C23.6815,17.3208 22.2365,16.0118 20.4775,16.0118 L20.4775,16.0118 Z M34.0545,39.4468 C29.3915,40.2838 25.4595,42.7408 23.9925,43.7518 C22.5245,42.7408 18.5915,40.2838 13.9285,39.4468 C11.5995,39.0278 3.9995,37.1698 3.9995,30.8208 C3.9995,28.1678 5.0035,26.4388 6.0665,24.6078 C7.0645,22.8888 8.0955,21.1118 8.0955,18.6798 C8.0955,15.0168 6.0705,12.3838 4.9405,11.1998 C6.0945,9.7968 8.6335,6.6988 10.0265,4.9168 C12.1475,6.8498 14.5945,7.9018 17.0185,7.9018 C19.7185,7.9018 21.9595,6.8368 23.9925,4.5688 C26.0235,6.8368 28.2645,7.9018 30.9645,7.9018 C33.3885,7.9018 35.8355,6.8498 37.9565,4.9168 C39.3495,6.6988 41.8885,9.7968 43.0425,11.1998 C41.9135,12.3838 39.8875,15.0168 39.8875,18.6798 C39.8875,21.1118 40.9185,22.8888 41.9165,24.6078 C42.9795,26.4388 43.9835,28.1678 43.9835,30.8208 C43.9835,37.1698 36.3835,39.0278 34.0545,39.4468 L34.0545,39.4468 Z M43.6465,23.6038 C42.7035,21.9778 41.8875,20.5738 41.8875,18.6798 C41.8875,14.6818 45.0065,12.0848 45.0365,12.0608 C45.2435,11.8928 45.3745,11.6488 45.4025,11.3828 C45.4285,11.1168 45.3485,10.8518 45.1785,10.6458 C45.1265,10.5838 40.0345,4.4128 38.8715,2.8178 C38.6965,2.5768 38.4215,2.4278 38.1235,2.4088 C37.8425,2.3878 37.5365,2.5058 37.3325,2.7238 C35.4155,4.7738 33.1545,5.9018 30.9645,5.9018 C28.5485,5.9018 26.6435,4.8198 24.7865,2.3918 C24.5965,2.1448 24.3035,1.9998 23.9925,1.9998 C23.6805,1.9998 23.3875,2.1448 23.1985,2.3918 C21.3395,4.8198 19.4335,5.9018 17.0185,5.9018 C14.8295,5.9018 12.5675,4.7738 10.6505,2.7238 C10.4475,2.5058 10.1395,2.3868 9.8595,2.4088 C9.5615,2.4278 9.2875,2.5768 9.1125,2.8178 C7.9495,4.4128 2.8565,10.5838 2.8045,10.6458 C2.6355,10.8508 2.5565,11.1158 2.5815,11.3808 C2.6085,11.6458 2.7395,11.8898 2.9455,12.0588 C2.9765,12.0848 6.0955,14.6818 6.0955,18.6798 C6.0955,20.5738 5.2805,21.9778 4.3365,23.6038 C3.2415,25.4908 1.9995,27.6298 1.9995,30.8208 C1.9995,36.1528 6.3275,40.1128 13.5755,41.4148 C18.8885,42.3688 23.3385,45.7428 23.3835,45.7768 C23.5625,45.9138 23.7775,45.9828 23.9925,45.9828 C24.2065,45.9828 24.4215,45.9138 24.6005,45.7768 C24.6455,45.7428 29.0955,42.3688 34.4085,41.4148 C41.6565,40.1128 45.9835,36.1528 45.9835,30.8208 C45.9835,27.6298 44.7425,25.4908 43.6465,23.6038 L43.6465,23.6038 Z" id="Fill-1" fill="#8C4FFF"></path>
    </g>
</svg>`, uR = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Networking-and-Content-Delivery/Res_Amazon-VPC_Traffic-Mirroring_48</title>
    <g id="Icon-Resource/Networking-and-Content-Delivery/Res_Amazon-VPC_Traffic-Mirroring_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M10.0904,26.916 C10.4814,27.307 10.4814,27.939 10.0904,28.33 C9.8954,28.525 9.6394,28.623 9.3834,28.623 C9.1274,28.623 8.8714,28.525 8.6764,28.33 L5.9404,25.595 C5.5494,25.204 5.5494,24.571 5.9404,24.181 L8.6764,21.444 C9.0674,21.054 9.6994,21.054 10.0904,21.444 C10.4814,21.835 10.4814,22.468 10.0904,22.858 L9.0614,23.888 L13.9434,23.888 L13.9434,25.888 L9.0624,25.888 L10.0904,26.916 Z M42.0094,25.595 L39.2734,28.33 C39.0774,28.525 38.8214,28.623 38.5664,28.623 C38.3104,28.623 38.0544,28.525 37.8594,28.33 C37.4684,27.939 37.4684,27.307 37.8594,26.916 L38.8884,25.888 L37.6534,25.888 L37.6534,23.888 L38.8884,23.888 L37.8594,22.858 C37.4684,22.468 37.4684,21.835 37.8594,21.444 C38.2494,21.054 38.8824,21.054 39.2734,21.444 L42.0094,24.181 C42.4004,24.571 42.4004,25.204 42.0094,25.595 L42.0094,25.595 Z M34.0064,25.888 L36.7414,25.888 L36.7414,23.888 L34.0064,23.888 L34.0064,25.888 Z M30.2084,14.14 L28.2744,16.074 L26.8604,14.66 L28.7944,12.726 L30.2084,14.14 Z M25.7104,19.415 L27.7104,19.415 L27.7104,16.68 L25.7104,16.68 L25.7104,19.415 Z M25.7104,23.063 L27.7104,23.063 L27.7104,20.327 L25.7104,20.327 L25.7104,23.063 Z M25.7104,26.711 L27.7104,26.711 L27.7104,23.976 L25.7104,23.976 L25.7104,26.711 Z M25.7104,30.359 L27.7104,30.359 L27.7104,27.623 L25.7104,27.623 L25.7104,30.359 Z M25.7104,34.006 L27.7104,34.006 L27.7104,31.271 L25.7104,31.271 L25.7104,34.006 Z M25.7104,37.655 L27.7104,37.655 L27.7104,34.919 L25.7104,34.919 L25.7104,37.655 Z M31.1824,12.208 L25.8174,12.208 L25.8174,10.208 L33.1824,10.208 L33.1824,17.592 L31.1824,17.592 L31.1824,12.208 Z M18.1814,12.208 L22.2384,16.266 L22.2384,37.655 L20.2384,37.655 L20.2384,17.094 L16.7844,13.64 L16.7844,17.592 L14.7844,17.592 L14.7844,10.208 L22.1514,10.208 L22.1514,12.208 L18.1814,12.208 Z M33.9184,29.447 L35.9184,29.447 L35.9184,35.919 L29.4464,35.919 L29.4464,33.919 L32.5044,33.919 L30.5634,31.978 L31.9774,30.564 L33.9184,32.505 L33.9184,29.447 Z M35.6114,20.136 L34.1974,18.722 L36.9464,15.973 L38.3614,17.387 L35.6114,20.136 Z M30.5634,22.356 L33.2724,19.647 L34.6864,21.062 L31.9774,23.77 L30.5634,22.356 Z M30.2704,26.711 L32.2704,26.711 L32.2704,24.029 L30.2704,24.029 L30.2704,26.711 Z M30.2704,30.359 L32.2704,30.359 L32.2704,27.704 L30.2704,27.704 L30.2704,30.359 Z M15.4454,33.919 L18.5024,33.919 L18.5024,35.919 L12.0304,35.919 L12.0304,29.447 L14.0304,29.447 L14.0304,32.505 L15.6794,30.857 L15.6794,23.478 L9.5884,17.387 L11.0024,15.973 L17.6794,22.649 L17.6794,31.686 L15.4454,33.919 Z M23.9744,43.95 C12.9604,43.95 3.9994,34.989 3.9994,23.976 C3.9994,12.961 12.9604,4 23.9744,4 C34.9884,4 43.9494,12.961 43.9494,23.976 C43.9494,34.989 34.9884,43.95 23.9744,43.95 L23.9744,43.95 Z M23.9744,2 C11.8574,2 1.9994,11.858 1.9994,23.976 C1.9994,36.093 11.8574,45.95 23.9744,45.95 C36.0914,45.95 45.9494,36.093 45.9494,23.976 C45.9494,11.858 36.0914,2 23.9744,2 L23.9744,2 Z" id="AWS-Amazon-VPC_Traffic-Mirroring_Resource-Icon_light-bg" fill="#8C4FFF"></path>
    </g>
</svg>`, hR = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Networking-and-Content-Delivery/Res_Amazon-VPC_Reachability-Analyzer_48</title>
    <g id="Icon-Resource/Networking-and-Content-Delivery/Res_Amazon-VPC_Reachability-Analyzer_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M42,40 C42,41.103 41.103,42 40,42 C38.897,42 38,41.103 38,40 C38,38.897 38.897,38 40,38 C41.103,38 42,38.897 42,40 M10,8 C10,9.103 9.103,10 8,10 C6.897,10 6,9.103 6,8 C6,6.897 6.897,6 8,6 C9.103,6 10,6.897 10,8 M40,44 C37.794,44 36,42.206 36,40 C36,37.794 37.794,36 40,36 C42.206,36 44,37.794 44,40 C44,42.206 42.206,44 40,44 M24,20 C26.206,20 28,21.794 28,24 C28,26.206 26.206,28 24,28 C21.794,28 20,26.206 20,24 C20,21.794 21.794,20 24,20 M8,12 C5.794,12 4,10.206 4,8 C4,5.794 5.794,4 8,4 C10.206,4 12,5.794 12,8 C12,10.206 10.206,12 8,12 M40,34 C37.033,34 34.568,36.167 34.09,39 L14,39 C10.141,39 7,35.86 7,32 C7,28.14 10.141,25 14,25 L18.09,25 C18.568,27.833 21.033,30 24,30 C26.967,30 29.432,27.833 29.91,25 L34,25 C38.963,25 43,20.962 43,16 C43,11.038 38.963,7 34,7 L13.91,7 C13.432,4.167 10.967,2 8,2 C4.691,2 2,4.691 2,8 C2,11.309 4.691,14 8,14 C10.967,14 13.432,11.833 13.91,9 L34,9 C37.859,9 41,12.14 41,16 C41,19.86 37.859,23 34,23 L29.91,23 C29.432,20.167 26.967,18 24,18 C21.033,18 18.568,20.167 18.09,23 L14,23 C9.037,23 5,27.038 5,32 C5,36.962 9.037,41 14,41 L34.09,41 C34.568,43.833 37.033,46 40,46 C43.309,46 46,43.309 46,40 C46,36.691 43.309,34 40,34" id="Fill-1" fill="#8C4FFF"></path>
    </g>
</svg>`, dR = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Networking-and-Content-Delivery/Res_AWS-Cloud-Map_Namespace_48</title>
    <g id="Icon-Resource/Networking-and-Content-Delivery/Res_AWS-Cloud-Map_Namespace_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M26.994,42.01925 C25.467,42.83525 24.383,43.58925 23.994,43.87225 C23.811,43.73925 23.464,43.49525 22.994,43.19225 L22.994,37.94625 L26.994,37.94625 L26.994,42.01925 Z M15.994,39.97125 C15.4,39.80325 14.789,39.65925 14.163,39.54625 C12.775,39.29625 11.518,38.93525 10.388,38.48625 L15.994,32.82225 L15.994,39.97125 Z M4.698,33.68225 C4.24,32.71225 4,31.65425 4,30.52425 C4,27.77325 5.062,25.94325 6.091,24.17125 C6.519,23.43325 6.932,22.70925 7.264,21.94625 L15.994,21.94625 L15.994,23.09725 L4.698,33.68225 Z M4.651,11.65525 C5.459,10.67525 9.186,6.14525 10.448,4.47325 C12.121,6.18725 14.047,7.25325 15.994,7.58425 L15.994,14.94625 L7.051,14.94625 C6.235,13.22625 5.096,12.06625 4.651,11.65525 L4.651,11.65525 Z M22.994,5.20625 C23.333,4.87025 23.667,4.50925 23.994,4.09925 C24.941,5.28625 25.932,6.15925 26.994,6.75325 L26.994,19.94625 L22.994,19.94625 L22.994,5.20625 Z M43.913,29.34125 C43.958,29.71825 43.988,30.10725 43.988,30.52425 C43.988,35.03025 40.188,38.40325 33.825,39.54625 C32.075,39.86125 30.43,40.42725 28.994,41.05125 L28.994,36.94625 C28.994,36.39425 28.547,35.94625 27.994,35.94625 L21.994,35.94625 C21.441,35.94625 20.994,36.39425 20.994,36.94625 L20.994,42.01925 C20.125,41.55525 19.111,41.07325 17.994,40.64225 L17.994,30.39025 C17.994,29.98525 17.749,29.62025 17.375,29.46525 C16.997,29.31225 16.568,29.39925 16.283,29.68725 L8.482,37.56625 C7.408,36.94125 6.513,36.20725 5.811,35.37925 L17.678,24.26025 C17.88,24.07225 17.994,23.80725 17.994,23.53125 L17.994,20.94625 C17.994,20.39425 17.547,19.94625 16.994,19.94625 L7.854,19.94625 C7.911,19.58425 7.95,19.21325 7.95,18.81625 C7.95,18.15525 7.87,17.53325 7.74,16.94625 L16.994,16.94625 C17.547,16.94625 17.994,16.49825 17.994,15.94625 L17.994,7.66525 C19.066,7.57425 20.06,7.27625 20.994,6.75325 L20.994,20.94625 C20.994,21.49825 21.441,21.94625 21.994,21.94625 L27.994,21.94625 C28.547,21.94625 28.994,21.49825 28.994,20.94625 L28.994,7.51625 C29.548,7.63925 30.12,7.70625 30.719,7.70625 C33.091,7.70625 35.503,6.56125 37.54,4.47325 C38.803,6.14625 42.53,10.67625 43.335,11.65325 C43.085,11.88125 42.616,12.34525 42.11,13.00625 C42.73,13.28725 43.31,13.63825 43.844,14.04925 C44.354,13.41025 44.777,13.04825 44.784,13.04125 C45.143,12.74925 45.377,12.31925 45.425,11.85425 C45.47,11.39425 45.327,10.92525 45.031,10.56625 C44.401,9.80525 39.99,4.44325 38.977,3.05525 C38.669,2.63225 38.193,2.37225 37.682,2.34025 C37.157,2.30125 36.649,2.50325 36.286,2.89125 C34.589,4.70625 32.611,5.70625 30.719,5.70625 C28.631,5.70625 27.035,4.78725 25.384,2.62925 C24.739,1.79025 23.249,1.79025 22.604,2.62925 C20.953,4.78725 19.357,5.70625 17.269,5.70625 C15.377,5.70625 13.399,4.70625 11.701,2.89025 C11.33,2.49425 10.817,2.29025 10.316,2.33925 C9.795,2.37225 9.319,2.63225 9.011,3.05525 C7.998,4.44325 3.587,9.80525 2.955,10.56825 C2.661,10.92325 2.519,11.39225 2.564,11.85325 C2.609,12.31425 2.841,12.74625 3.195,13.03525 C3.223,13.05725 5.95,15.37325 5.95,18.81625 C5.95,20.42925 5.249,21.63825 4.359,23.16925 C3.308,24.98025 2,27.23425 2,30.52425 C2,36.07725 6.415,40.18625 13.809,41.51525 C18.718,42.39625 22.889,45.54025 22.926,45.56925 C23.229,45.80325 23.608,45.93225 23.994,45.93225 C24.378,45.93225 24.756,45.80425 25.057,45.57325 C25.098,45.54125 29.273,42.39525 34.179,41.51525 C41.573,40.18625 45.988,36.07725 45.988,30.52425 C45.988,29.07925 45.728,27.84225 45.356,26.74725 C44.906,27.62525 44.415,28.50325 43.913,29.34125 L43.913,29.34125 Z M22.994,30.94625 L26.994,30.94625 L26.994,26.94625 L22.994,26.94625 L22.994,30.94625 Z M27.994,24.94625 L21.994,24.94625 C21.441,24.94625 20.994,25.39425 20.994,25.94625 L20.994,31.94625 C20.994,32.49825 21.441,32.94625 21.994,32.94625 L27.994,32.94625 C28.547,32.94625 28.994,32.49825 28.994,31.94625 L28.994,25.94625 C28.994,25.39425 28.547,24.94625 27.994,24.94625 L27.994,24.94625 Z M38.835,18.97625 C37.84,18.97625 37.03,19.78625 37.03,20.78125 C37.03,21.77725 37.84,22.58625 38.835,22.58625 C39.83,22.58625 40.64,21.77725 40.64,20.78125 C40.64,19.78625 39.83,18.97625 38.835,18.97625 L38.835,18.97625 Z M38.835,24.58625 C36.737,24.58625 35.03,22.87925 35.03,20.78125 C35.03,18.68325 36.737,16.97625 38.835,16.97625 C40.932,16.97625 42.64,18.68325 42.64,20.78125 C42.64,22.87925 40.932,24.58625 38.835,24.58625 L38.835,24.58625 Z M38.526,15.72825 C35.643,15.72825 33.299,18.07325 33.299,20.95625 C33.299,23.16425 36.559,28.35225 38.526,31.20225 C40.493,28.35225 43.755,23.16425 43.755,20.95625 C43.755,18.07325 41.409,15.72825 38.526,15.72825 L38.526,15.72825 Z M38.526,33.93225 L38.526,33.93225 C38.207,33.93225 37.906,33.78025 37.719,33.52225 C37.061,32.62125 31.299,24.61625 31.299,20.95625 C31.299,16.97025 34.541,13.72825 38.526,13.72825 C42.512,13.72825 45.755,16.97025 45.755,20.95625 C45.755,24.61625 39.991,32.62125 39.334,33.52225 C39.145,33.78025 38.846,33.93225 38.526,33.93225 L38.526,33.93225 Z" id="AWS-Cloud-Map-Namespace_Resource-Icon_light-bg" fill="#8C4FFF"></path>
    </g>
</svg>`, gR = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Networking-and-Content-Delivery/Res_AWS-Transit-Gateway_Attachment_48</title>
    <g id="Icon-Resource/Networking-and-Content-Delivery/Res_AWS-Transit-Gateway_Attachment_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M24,44 C12.972,44 4,35.028 4,24 C4,12.972 12.972,4 24,4 C35.028,4 44,12.972 44,24 C44,35.028 35.028,44 24,44 M24,2 C11.869,2 2,11.869 2,24 C2,36.131 11.869,46 24,46 C36.131,46 46,36.131 46,24 C46,11.869 36.131,2 24,2 M36,27 C34.346,27 33,25.654 33,24 C33,22.346 34.346,21 36,21 C37.654,21 39,22.346 39,24 C39,25.654 37.654,27 36,27 M12,27 C10.346,27 9,25.654 9,24 C9,22.346 10.346,21 12,21 C13.654,21 15,22.346 15,24 C15,25.654 13.654,27 12,27 M36,19 C33.586,19 31.566,20.721 31.101,23 L16.899,23 C16.434,20.721 14.414,19 12,19 C9.243,19 7,21.243 7,24 C7,26.757 9.243,29 12,29 C14.414,29 16.434,27.279 16.899,25 L31.101,25 C31.566,27.279 33.586,29 36,29 C38.757,29 41,26.757 41,24 C41,21.243 38.757,19 36,19" id="Fill-1" fill="#8C4FFF"></path>
    </g>
</svg>`, fR = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Networking-and-Content-Delivery/Res_Amazon-VPC_Internet-Gateway_48</title>
    <g id="Icon-Resource/Networking-and-Content-Delivery/Res_Amazon-VPC_Internet-Gateway_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M33.4312,35.1778 L31.9332,35.1778 L31.9332,17.5018 C31.9332,17.1088 31.7022,16.7518 31.3442,16.5908 L31.2522,16.5488 C29.2432,15.6418 27.1642,14.7028 24.1762,14.7028 C21.0532,14.7028 18.7612,15.7118 16.4952,16.8368 C16.1552,17.0058 15.9402,17.3528 15.9402,17.7328 L15.9402,35.1778 L14.4772,35.1778 L14.4772,16.3118 C16.9112,14.3328 20.4202,13.2048 24.1862,13.2048 C27.6872,13.2048 31.0252,14.2018 33.4312,15.9528 L33.4312,35.1778 Z M24.1862,11.2048 C19.7612,11.2048 15.6172,12.6238 12.8152,15.0998 C12.6002,15.2888 12.4772,15.5618 12.4772,15.8488 L12.4772,36.1778 C12.4772,36.7308 12.9242,37.1778 13.4772,37.1778 L16.9402,37.1778 C17.4932,37.1778 17.9402,36.7308 17.9402,36.1778 L17.9402,18.3558 C19.8592,17.4288 21.7192,16.7028 24.1762,16.7028 C26.5112,16.7028 28.2092,17.3778 29.9332,18.1488 L29.9332,36.1778 C29.9332,36.7308 30.3802,37.1778 30.9332,37.1778 L34.4312,37.1778 C34.9842,37.1778 35.4312,36.7308 35.4312,36.1778 L35.4312,15.4578 C35.4312,15.1538 35.2922,14.8658 35.0532,14.6748 C32.2792,12.4698 28.3182,11.2048 24.1862,11.2048 L24.1862,11.2048 Z M23.9542,43.9088 C12.9522,43.9088 3.9992,34.9568 3.9992,23.9538 C3.9992,12.9508 12.9522,3.9998 23.9542,3.9998 C34.9572,3.9998 43.9092,12.9508 43.9092,23.9538 C43.9092,34.9568 34.9572,43.9088 23.9542,43.9088 L23.9542,43.9088 Z M23.9542,1.9998 C11.8482,1.9998 1.9992,11.8488 1.9992,23.9538 C1.9992,36.0608 11.8482,45.9088 23.9542,45.9088 C36.0602,45.9088 45.9092,36.0608 45.9092,23.9538 C45.9092,11.8488 36.0602,1.9998 23.9542,1.9998 L23.9542,1.9998 Z" id="AWS-Amazon-VPC_Internet-gateway_Resource-Icon_light-bg" fill="#8C4FFF"></path>
    </g>
</svg>`, pR = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Networking-and-Content-Delivery/Res_Amazon-CloudFront_Edge-Location_48</title>
    <g id="Icon-Resource/Networking-and-Content-Delivery/Res_Amazon-CloudFront_Edge-Location_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M4,43.889 L4,29.036 C7.767,27.035 11.783,25.622 15.963,24.829 L15.963,31.926 L31.926,31.926 L31.926,24.829 C36.105,25.622 40.121,27.035 43.889,29.036 L43.889,43.889 L4,43.889 Z M17.963,29.926 L29.926,29.926 L29.926,17.963 L17.963,17.963 L17.963,29.926 Z M43.889,4 L43.889,26.781 C40.104,24.883 36.091,23.55 31.926,22.797 L31.926,15.963 L15.963,15.963 L15.963,22.797 C11.798,23.55 7.784,24.883 4,26.781 L4,4 L43.889,4 Z M2,45.889 L45.889,45.889 L45.889,2 L2,2 L2,45.889 Z" id="AWS-Amazon-CloudFront_edge-location_Resource-Icon_light-bg" fill="#8C4FFF"></path>
    </g>
</svg>`, mR = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Networking-and-Content-Delivery/Res_AWS-Cloud-WAN_Segment-Network_48</title>
    <g id="Icon-Resource/Networking-and-Content-Delivery/Res_AWS-Cloud-WAN_Segment-Network_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M27.999799,38.81 L27.999799,43.839 C35.980799,42.405 42.405799,35.98 43.839799,27.999 L38.810799,27.999 C37.526799,33.319 33.318799,37.527 27.999799,38.81 L27.999799,38.81 Z M26.999799,45.999 C26.756799,45.999 26.519799,45.91 26.335799,45.747 C26.121799,45.557 25.999799,45.285 25.999799,44.999 L25.999799,37.999 C25.999799,37.515 26.346799,37.101 26.821799,37.015 C31.985799,36.082 36.082799,31.986 37.015799,26.821 C37.101799,26.345 37.516799,25.999 37.999799,25.999 L44.999799,25.999 C45.285799,25.999 45.557799,26.121 45.747799,26.335 C45.936799,26.549 46.025799,26.833 45.992799,27.117 C44.831799,36.892 36.893799,44.83 27.117799,45.992 C27.078799,45.997 27.038799,45.999 26.999799,45.999 L26.999799,45.999 Z M4.15979897,27.999 C5.59379897,35.98 12.018799,42.405 19.999799,43.839 L19.999799,38.81 C14.680799,37.527 10.472799,33.319 9.18879897,27.999 L4.15979897,27.999 Z M20.999799,45.999 C20.960799,45.999 20.921799,45.997 20.881799,45.992 C11.105799,44.83 3.16779897,36.892 2.00679897,27.117 C1.97379897,26.833 2.06179897,26.549 2.25179897,26.335 C2.44179897,26.121 2.71379897,25.999 2.99979897,25.999 L9.99979897,25.999 C10.482799,25.999 10.897799,26.345 10.983799,26.821 C11.916799,31.986 16.013799,36.082 21.177799,37.015 C21.652799,37.101 21.999799,37.515 21.999799,37.999 L21.999799,44.999 C21.999799,45.285 21.877799,45.557 21.663799,45.747 C21.479799,45.91 21.242799,45.999 20.999799,45.999 L20.999799,45.999 Z M38.810799,19.999 L43.839799,19.999 C42.405799,12.018 35.980799,5.593 27.999799,4.159 L27.999799,9.188 C33.318799,10.471 37.526799,14.679 38.810799,19.999 L38.810799,19.999 Z M44.999799,21.999 L37.999799,21.999 C37.516799,21.999 37.101799,21.653 37.015799,21.177 C36.082799,16.012 31.985799,11.915 26.821799,10.983 C26.346799,10.897 25.999799,10.483 25.999799,9.999 L25.999799,2.999 C25.999799,2.713 26.121799,2.441 26.335799,2.251 C26.548799,2.062 26.829799,1.976 27.117799,2.006 C36.893799,3.168 44.831799,11.106 45.992799,20.881 C46.025799,21.165 45.936799,21.449 45.747799,21.663 C45.557799,21.877 45.285799,21.999 44.999799,21.999 L44.999799,21.999 Z M4.15979897,19.999 L9.18879897,19.999 C10.472799,14.679 14.680799,10.471 19.999799,9.188 L19.999799,4.159 C12.018799,5.593 5.59379897,12.018 4.15979897,19.999 L4.15979897,19.999 Z M9.99979897,21.999 L2.99979897,21.999 C2.71379897,21.999 2.44179897,21.877 2.25179897,21.663 C2.06179897,21.449 1.97379897,21.165 2.00679897,20.881 C3.16779897,11.106 11.105799,3.168 20.881799,2.006 C21.162799,1.975 21.450799,2.061 21.663799,2.251 C21.877799,2.441 21.999799,2.713 21.999799,2.999 L21.999799,9.999 C21.999799,10.483 21.652799,10.897 21.177799,10.983 C16.013799,11.915 11.916799,16.012 10.983799,21.177 C10.897799,21.653 10.482799,21.999 9.99979897,21.999 L9.99979897,21.999 Z" id="Fill-1" fill="#8C4FFF"></path>
    </g>
</svg>`, wR = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Networking-and-Content-Delivery/Res_AWS-Cloud-Map_Service_48</title>
    <g id="Icon-Resource/Networking-and-Content-Delivery/Res_AWS-Cloud-Map_Service_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M4,33 L4,5 L24,5 L24,7 L7,7 L7,33 L4,33 Z M40.943,34.14 L40.943,36.14 C42.019,36.14 44.126,37.201 44.126,39.656 C44.126,43.842 40.29,43.996 39.856,44 L21.628,44 C18.314,44 16,42.27 16,39.793 L16,39.48 C16,37.058 18.644,35.994 20.267,35.569 C20.3,35.563 20.334,35.555 20.368,35.545 C20.834,35.404 21.131,34.95 21.073,34.467 C21.055,34.315 21.065,34.134 21.071,33.96 C21.075,33.841 21.079,33.725 21.079,33.617 C21.079,31.555 22.695,28.563 24.858,27.646 C27.279,26.623 29.303,27.379 30.573,28.191 L31.651,26.506 C29.28,24.99 26.593,24.741 24.078,25.805 C21.368,26.953 19.079,30.531 19.079,33.617 L19.074,33.833 C16.969,34.507 15.468,35.606 14.667,37 L9,37 L9,9 L29,9 L29,22 L31,22 L31,7 L26,7 L26,3 L2,3 L2,35 L7,35 L7,39 L14.043,39 C14.029,39.16 14,39.315 14,39.48 L14,39.793 C14,43.39 17.208,46 21.628,46 L39.856,46 C42.025,46 46.126,44.674 46.126,39.656 C46.126,36.057 43.116,34.14 40.943,34.14 L40.943,34.14 Z M37.944,24 C39.593,24 40.79,25.197 40.79,26.847 C40.79,27.918 39.315,30.611 37.944,32.742 C36.572,30.611 35.098,27.919 35.098,26.847 C35.098,25.197 36.295,24 37.944,24 L37.944,24 Z M37.944,35.539 C38.271,35.539 38.577,35.38 38.764,35.112 C39.437,34.149 42.79,29.23 42.79,26.847 C42.79,24.084 40.707,22 37.944,22 C35.182,22 33.098,24.084 33.098,26.847 C33.098,29.23 36.452,34.15 37.125,35.112 C37.312,35.38 37.618,35.539 37.944,35.539 L37.944,35.539 Z" id="AWS-Cloud-Map-Service_Resource-Icon_light-bg" fill="#8C4FFF"></path>
    </g>
</svg>`, xR = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Networking-and-Content-Delivery/Res_AWS-App-Mesh_Virtual-Router_48</title>
    <g id="Icon-Resource/Networking-and-Content-Delivery/Res_AWS-App-Mesh_Virtual-Router_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M36,32.043 C35.543,32.498 34.801,32.498 34.344,32.043 C33.888,31.586 33.888,30.844 34.344,30.387 C34.801,29.93 35.543,29.93 36,30.387 C36.456,30.843 36.456,31.587 36,32.043 M25.187,37.982 C24.557,38.613 23.527,38.613 22.895,37.982 C22.263,37.35 22.263,36.321 22.895,35.689 C23.527,35.057 24.555,35.059 25.187,35.689 C25.493,35.995 25.662,36.402 25.662,36.836 C25.662,37.269 25.493,37.676 25.187,37.982 M22.895,23.209 C23.211,22.893 23.626,22.735 24.041,22.735 C24.456,22.735 24.871,22.893 25.187,23.209 C25.819,23.841 25.819,24.87 25.187,25.502 C24.555,26.135 23.527,26.135 22.895,25.502 C22.263,24.87 22.263,23.841 22.895,23.209 M22.895,9.931 C23.211,9.614 23.626,9.457 24.041,9.457 C24.456,9.457 24.871,9.614 25.187,9.931 C25.819,10.563 25.819,11.592 25.187,12.224 C24.555,12.856 23.527,12.856 22.895,12.224 C22.263,11.592 22.263,10.563 22.895,9.931 M34.344,16.34 C34.565,16.118 34.857,16.007 35.148,16.007 C35.439,16.007 35.731,16.118 35.953,16.34 C36.396,16.783 36.396,17.506 35.953,17.948 C35.509,18.394 34.786,18.393 34.344,17.949 C34.129,17.734 34.011,17.448 34.011,17.145 C34.011,16.84 34.129,16.555 34.344,16.34 M13.606,32.918 C13.177,33.35 12.424,33.35 11.992,32.918 C11.547,32.473 11.547,31.748 11.992,31.303 C12.215,31.08 12.507,30.969 12.8,30.969 C13.092,30.969 13.385,31.08 13.607,31.303 C13.823,31.519 13.942,31.806 13.942,32.11 C13.942,32.415 13.823,32.702 13.606,32.918 M12.168,18.56 C12.375,18.353 12.647,18.249 12.92,18.249 C13.192,18.249 13.465,18.353 13.672,18.56 C14.087,18.975 14.087,19.649 13.672,20.064 C13.258,20.479 12.582,20.479 12.168,20.064 C11.753,19.649 11.753,18.975 12.168,18.56 M37.414,28.973 C36.178,27.736 34.166,27.736 32.93,28.973 C32.124,29.778 31.854,30.911 32.098,31.947 L27.084,34.881 C26.945,34.665 26.787,34.461 26.602,34.275 C26.143,33.816 25.586,33.522 25,33.361 L25,27.829 C25.586,27.669 26.143,27.376 26.602,26.916 C27.512,26.006 27.826,24.73 27.562,23.558 L33.259,19.633 C33.817,20.056 34.479,20.28 35.148,20.28 C35.952,20.28 36.756,19.975 37.368,19.363 C38.59,18.139 38.59,16.148 37.367,14.926 C36.182,13.74 34.115,13.74 32.93,14.926 C32.337,15.518 32.011,16.306 32.011,17.145 C32.011,17.432 32.062,17.708 32.137,17.978 L26.6,21.793 C26.141,21.335 25.584,21.041 25,20.881 L25,14.552 C25.586,14.391 26.143,14.097 26.602,13.638 C28.014,12.226 28.014,9.929 26.602,8.517 C25.189,7.105 22.893,7.105 21.48,8.517 C20.068,9.929 20.068,12.226 21.48,13.638 C21.918,14.075 22.445,14.36 23,14.527 L23,20.905 C22.445,21.071 21.918,21.357 21.48,21.795 C20.068,23.207 20.068,25.504 21.48,26.916 C21.918,27.354 22.445,27.64 23,27.806 L23,33.386 C22.445,33.552 21.918,33.838 21.48,34.275 C21.282,34.474 21.119,34.692 20.977,34.921 L15.922,32.315 C15.927,32.247 15.942,32.18 15.942,32.11 C15.942,31.271 15.615,30.481 15.021,29.889 C14.721,29.587 14.371,29.362 14,29.209 L14,22.172 C14.396,22.023 14.769,21.797 15.086,21.479 C16.28,20.284 16.28,18.34 15.086,17.146 C13.893,15.95 11.947,15.95 10.754,17.146 C9.56,18.34 9.56,20.284 10.754,21.479 C11.113,21.839 11.545,22.076 12,22.22 L12,29.087 C11.479,29.224 10.984,29.481 10.578,29.889 C9.985,30.481 9.658,31.271 9.658,32.11 C9.658,32.95 9.985,33.739 10.578,34.332 C11.171,34.926 11.96,35.253 12.8,35.253 C13.64,35.253 14.429,34.926 15.021,34.333 C15.072,34.282 15.109,34.223 15.156,34.17 L20.426,36.888 C20.439,37.798 20.787,38.704 21.48,39.397 C22.187,40.103 23.113,40.455 24.041,40.455 C24.968,40.455 25.896,40.102 26.602,39.397 C27.279,38.72 27.652,37.819 27.66,36.862 L33.158,33.644 C33.742,34.128 34.453,34.384 35.172,34.384 C35.983,34.384 36.796,34.074 37.414,33.457 C38.649,32.221 38.649,30.209 37.414,28.973 M24,44 C12.972,44 4,35.028 4,24 C4,12.972 12.972,4 24,4 C35.028,4 44,12.972 44,24 C44,35.028 35.028,44 24,44 M24,2 C11.869,2 2,11.869 2,24 C2,36.131 11.869,46 24,46 C36.131,46 46,36.131 46,24 C46,11.869 36.131,2 24,2" id="AWS-App-Mesh-Virtual-Router_Resource-Icon_light-bg" fill="#8C4FFF"></path>
    </g>
</svg>`, _R = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Networking-and-Content-Delivery/Res_Amazon-VPC_Endpoints_48</title>
    <g id="Icon-Resource/Networking-and-Content-Delivery/Res_Amazon-VPC_Endpoints_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M20.6197,27.6015 L22.0337,29.0155 L26.3967,24.6515 C26.7877,24.2605 26.7877,23.6275 26.3967,23.2375 L22.0337,18.8735 L20.6197,20.2885 L23.2757,22.9445 L6.4907,22.9445 L6.4907,24.9445 L23.2767,24.9445 L20.6197,27.6015 Z M43.8897,23.9445 C43.8897,12.9475 34.9417,3.9995 23.9447,3.9995 C12.9467,3.9995 3.9997,12.9475 3.9997,23.9445 C3.9997,34.9425 12.9467,43.8895 23.9447,43.8895 C34.9417,43.8895 43.8897,34.9425 43.8897,23.9445 L43.8897,23.9445 Z M45.8897,23.9445 C45.8897,36.0445 36.0457,45.8895 23.9447,45.8895 C11.8447,45.8895 1.9997,36.0445 1.9997,23.9445 C1.9997,11.8435 11.8447,1.9995 23.9447,1.9995 C36.0457,1.9995 45.8897,11.8435 45.8897,23.9445 L45.8897,23.9445 Z M15.9627,26.5625 L15.9627,27.0165 C15.9627,27.0765 15.9677,27.1355 15.9777,27.1945 C16.0417,27.5435 17.5967,35.7575 23.9447,35.7575 C30.2927,35.7575 31.8477,27.5435 31.9107,27.1945 C31.9217,27.1355 31.9267,27.0765 31.9267,27.0165 L31.9267,16.4655 C31.9267,16.0575 31.6787,15.6905 31.2997,15.5385 L24.3177,12.7275 C24.0797,12.6315 23.8097,12.6315 23.5717,12.7275 L16.5897,15.5385 C16.2107,15.6905 15.9627,16.0575 15.9627,16.4655 L15.9627,21.3265 L17.9627,21.3265 L17.9627,17.1415 L23.9447,14.7335 L29.9267,17.1415 L29.9267,26.9175 C29.7647,27.6895 28.3467,33.7575 23.9447,33.7575 C19.5427,33.7575 18.1247,27.6895 17.9627,26.9175 L17.9627,26.5625 L15.9627,26.5625 Z M35.4167,13.3245 L35.4167,26.6755 C35.4167,31.2075 33.0187,39.7805 23.9447,39.7805 C19.2227,39.7805 15.7337,37.3375 13.8537,32.7165 C12.8547,30.2675 12.5767,27.8485 12.5007,26.6245 L14.4967,26.4995 C14.5527,27.3865 14.7807,29.6945 15.7067,31.9615 C17.2767,35.8235 20.0487,37.7805 23.9447,37.7805 C33.2797,37.7805 33.4157,27.1275 33.4167,26.6745 L33.4167,13.9995 L23.9447,10.1865 L14.4727,13.9995 L14.4727,21.3265 L12.4727,21.3265 L12.4727,13.3245 C12.4727,12.9155 12.7207,12.5485 13.0987,12.3965 L23.5717,8.1805 C23.8097,8.0845 24.0797,8.0845 24.3177,8.1805 L34.7897,12.3965 C35.1687,12.5485 35.4167,12.9155 35.4167,13.3245 L35.4167,13.3245 Z" id="AWS-Amazon-VPC_Endpoints_Resource-Icon_light-bg" fill="#8C4FFF"></path>
    </g>
</svg>`, vR = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Networking-and-Content-Delivery/Res_Amazon-VPC_VPN-Connection_48</title>
    <g id="Icon-Resource/Networking-and-Content-Delivery/Res_Amazon-VPC_VPN-Connection_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M43.5938631,15.2041 C43.5968,15.4721 43.4928,15.7281 43.3048,15.9191 L38.9358,20.3361 L37.5138,18.9301 L40.1318,16.2821 L7.4778,16.2821 L10.1258,18.8941 L8.7218,20.3181 L4.2978,15.9541 C4.1078,15.7661 3.9998,15.5101 3.9998,15.2421 C3.9998,14.9751 4.1078,14.7181 4.2978,14.5301 L8.7218,10.1661 L10.1258,11.5901 L7.3968,14.2821 L40.1828,14.2821 L37.4248,11.6261 L38.8118,10.1841 L43.2868,14.4951 C43.4808,14.6811 43.5908,14.9361 43.5938631,15.2041 L43.5938631,15.2041 Z M16.4758,12.5851 L14.4758,12.5851 L14.4758,12.2001 C14.4948,6.5741 18.8698,2.0001 24.2298,2.0001 C29.6248,2.0191 33.9678,6.6361 33.9478688,12.2921 L33.9478688,12.5851 L31.9478,12.5851 L31.9478,12.2881 C31.9638,7.7311 28.5158,4.0161 24.2608,4.0001 C19.9698,4.0001 16.4908,7.6801 16.4758,12.2041 L16.4758,12.5851 Z M22.8008,28.8161 C23.1648,28.4521 23.6488,28.2521 24.1638,28.2521 L24.1658,28.2521 C24.6828,28.2521 25.1678,28.4531 25.5328,28.8181 C25.8978,29.1831 26.0978,29.6671 26.0968037,30.1831 L26.0968037,30.1831 C26.0968037,30.7001 25.8958,31.1851 25.5308,31.5511 C25.1658,31.9141 24.6828,32.1141 24.1668,32.1141 L24.1648,32.1141 C23.1008,32.1141 22.2348,31.2481 22.2348,30.1831 C22.2358,29.6671 22.4368,29.1811 22.8008,28.8161 L22.8008,28.8161 Z M23.1658,33.9701 L23.1658,39.1221 L25.1658,39.1221 L25.1658,33.9711 C25.8298,33.7961 26.4448,33.4641 26.9438,32.9661 C27.6868,32.2241 28.0968018,31.2361 28.0968018,30.1841 C28.0978,29.1351 27.6908,28.1471 26.9478,27.4051 C26.2048,26.6611 25.2178,26.2521 24.1668,26.2521 L24.1618,26.2521 C23.1138,26.2521 22.1278,26.6601 21.3868,27.4021 C20.6448,28.1431 20.2358,29.1311 20.2348,30.1831 C20.2348,32.0031 21.4848,33.5241 23.1658,33.9701 L23.1658,33.9701 Z M37.1618,44.0191 L11.1598,44.0081 L11.1668,24.1341 L37.1718,24.1441 L37.1618,44.0191 Z M38.1718,22.1441 L33.9478,22.1421 L33.9478,17.8821 L31.9478,17.8821 L31.9478,22.1411 L16.4758,22.1361 L16.4758,17.8821 L14.4758,17.8821 L14.4758,22.1361 L10.1668,22.1341 C9.9028,22.1341 9.6478,22.2391 9.4598,22.4271 C9.2728,22.6141 9.1668,22.8681 9.1668,23.1341 L9.1598,45.0081 C9.1598,45.5591 9.6078,46.0081 10.1598,46.0081 L38.1618,46.0191 C38.7138,46.0191 39.1618,45.5721 39.1618,45.0191 L39.1718,23.1441 C39.1718,22.8801 39.0668,22.6251 38.8788,22.4371 C38.6918,22.2501 38.4378,22.1441 38.1718,22.1441 L38.1718,22.1441 Z" id="AWS-Amazon-VPC_VPN-connection_Resource-Icon_light-bg" fill="#8C4FFF"></path>
    </g>
</svg>`, MR = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Networking-and-Content-Delivery/Res_Amazon-CloudFront_Streaming-Distribution_48</title>
    <g id="Icon-Resource/Networking-and-Content-Delivery/Res_Amazon-CloudFront_Streaming-Distribution_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M31.1309,28.5088 L32.5449,29.9228 L24.6799,37.7868 C24.4849,37.9828 24.2289,38.0798 23.9729,38.0798 C23.7169,38.0798 23.4609,37.9828 23.2659,37.7868 L15.4019,29.9228 L16.8159,28.5088 L22.9729,34.6658 L22.9729,9.1168 L24.9729,9.1168 L24.9729,34.6658 L31.1309,28.5088 Z M23.9729,43.9448 C12.9599,43.9448 3.9999,34.9858 3.9999,23.9728 C3.9999,12.9598 12.9599,3.9998 23.9729,3.9998 C34.9849,3.9998 43.9449,12.9598 43.9449,23.9728 C43.9449,34.9858 34.9849,43.9448 23.9729,43.9448 L23.9729,43.9448 Z M23.9729,1.9998 C11.8569,1.9998 1.9999,11.8568 1.9999,23.9728 C1.9999,36.0878 11.8569,45.9448 23.9729,45.9448 C36.0889,45.9448 45.9449,36.0878 45.9449,23.9728 C45.9449,11.8568 36.0889,1.9998 23.9729,1.9998 L23.9729,1.9998 Z" id="AWS-Amazon-CloudFront_streaming-distribution_Resource-Icon_light-bg" fill="#8C4FFF"></path>
    </g>
</svg>`, RR = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Networking-and-Content-Delivery/Res_Amazon-VPC_Peering-Connection_48</title>
    <g id="Icon-Resource/Networking-and-Content-Delivery/Res_Amazon-VPC_Peering-Connection_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M30.6055,25.6368 C30.6055,25.2538 30.6055,24.2358 28.9355,23.8938 C28.4915,23.8028 28.1645,23.4248 28.1375,22.9718 C28.0995,22.3148 27.8295,21.9068 27.4315,21.9068 C27.2485,21.9068 27.0725,22.0008 26.9485,22.1648 C26.7285,22.4588 26.3685,22.6078 26.0015,22.5548 C25.6375,22.4998 25.3335,22.2518 25.2085,21.9068 C25.0125,21.3658 24.7265,20.9008 24.3815,20.5608 C24.0655,20.2468 23.3415,19.6688 22.3165,19.6688 C21.9565,19.6688 21.5585,19.7408 21.1285,19.9188 C20.2085,20.3038 19.4595,21.4568 19.4595,22.4898 C19.4595,22.6118 19.4665,22.7288 19.4805,22.8458 C19.5405,23.3458 19.2185,23.8108 18.7315,23.9338 C17.8465,24.1568 17.3975,24.7208 17.3975,25.6118 L17.4025,25.7578 C17.4475,26.5858 18.4185,27.3468 19.4385,27.3468 L28.8285,27.3468 C30.6055,27.3468 30.6055,26.0598 30.6055,25.6368 L30.6055,25.6368 Z M32.6055,25.6368 C32.6055,28.3178 30.6755,29.3048 28.9765,29.3458 C28.9595,29.3468 28.9425,29.3468 28.9245,29.3468 L19.4385,29.3468 C17.3555,29.3468 15.5085,27.7498 15.4055,25.8598 C15.4005,25.7738 15.3975,25.6968 15.3975,25.6118 C15.3975,24.0768 16.1565,22.8738 17.4645,22.2678 C17.5605,20.5108 18.7725,18.7358 20.3585,18.0738 C22.2795,17.2768 24.3065,17.6718 25.7885,19.1388 C26.0665,19.4128 26.3145,19.7238 26.5315,20.0698 C27.7795,19.5998 29.5565,20.1578 30.0285,22.1208 C31.6755,22.6828 32.6055,23.9348 32.6055,25.6368 L32.6055,25.6368 Z M44.0015,24.0008 C44.0015,12.9728 35.0295,3.9998 24.0015,3.9998 C12.9725,3.9998 4.0005,12.9728 4.0005,24.0008 C4.0005,35.0298 12.9725,44.0018 24.0015,44.0018 C35.0295,44.0018 44.0015,35.0298 44.0015,24.0008 L44.0015,24.0008 Z M46.0015,24.0008 C46.0015,36.1328 36.1325,46.0018 24.0015,46.0018 C11.8695,46.0018 2.0005,36.1328 2.0005,24.0008 C2.0005,11.8688 11.8695,1.9998 24.0015,1.9998 C36.1325,1.9998 46.0015,11.8688 46.0015,24.0008 L46.0015,24.0008 Z M11.6735,20.3638 L10.2595,18.9498 L5.9145,23.2938 C5.7265,23.4818 5.6215,23.7358 5.6215,24.0008 C5.6215,24.2668 5.7265,24.5208 5.9145,24.7078 L10.2595,29.0538 L11.6735,27.6398 L9.0355,25.0008 L13.9905,25.0008 L13.9905,23.0008 L9.0355,23.0008 L11.6735,20.3638 Z M42.0885,23.2938 L37.7435,18.9498 L36.3295,20.3638 L38.9675,23.0008 L33.9855,23.0008 L33.9855,25.0008 L38.9675,25.0008 L36.3295,27.6398 L37.7435,29.0538 L42.0885,24.7078 C42.2765,24.5208 42.3815,24.2668 42.3815,24.0008 C42.3815,23.7358 42.2765,23.4818 42.0885,23.2938 L42.0885,23.2938 Z M25.0015,38.9678 L25.0015,30.9758 L23.0015,30.9758 L23.0015,38.9678 L20.3635,36.3288 L18.9495,37.7428 L23.2935,42.0888 C23.4815,42.2768 23.7355,42.3818 24.0015,42.3818 C24.2665,42.3818 24.5205,42.2768 24.7085,42.0888 L29.0535,37.7428 L27.6395,36.3288 L25.0015,38.9678 Z M20.3635,11.6728 L18.9495,10.2588 L23.2935,5.9138 C23.6845,5.5238 24.3175,5.5238 24.7085,5.9138 L29.0535,10.2588 L27.6395,11.6728 L25.0015,9.0348 L25.0015,16.2748 L23.0015,16.2748 L23.0015,9.0348 L20.3635,11.6728 Z" id="AWS-Amazon-VPC_Peering-connection_Resource-Icon_light-bg" fill="#8C4FFF"></path>
    </g>
</svg>`, yR = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Networking-and-Content-Delivery/Res_Amazon-Route-53_Resolver-DNS-Firewall_48</title>
    <g id="Icon-Resource/Networking-and-Content-Delivery/Res_Amazon-Route-53_Resolver-DNS-Firewall_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M23.818,35.53875 C20.825,35.53875 18.078,34.02875 16.469,31.49975 C15.2,29.50575 15.178,26.92675 16.414,24.76975 L16.45,24.70875 C17.881,22.53575 17.58,19.62675 17.139,17.71875 C18.29,18.55575 19.302,20.04075 19.663,20.68775 C19.853,21.02975 20.228,21.23275 20.616,21.19875 C21.006,21.16775 21.342,20.91275 21.476,20.54475 C22.775,16.97775 22.169,14.26975 21.267,12.47575 C22.849,13.12375 24.794,14.24575 26.185,16.12675 C27.831,18.35175 28.4,21.22175 27.877,24.65575 C27.814,25.06275 28.007,25.46675 28.364,25.67275 C28.721,25.87775 29.167,25.84475 29.488,25.58875 C29.557,25.53375 30.907,24.42975 31.629,21.79975 C32.091,22.56275 32.522,23.74475 32.522,25.49775 C32.522,29.24775 31.391,35.53875 23.818,35.53875 M31.472,18.83775 C31.178,18.68075 30.826,18.67975 30.532,18.83475 C30.237,18.99075 30.04,19.28275 30.005,19.61475 C29.983,19.82675 29.956,20.02975 29.924,20.22475 C29.639,18.23475 28.923,16.46075 27.781,14.92075 C24.532,10.54475 19.033,9.71275 18.8,9.67975 C18.362,9.61375 17.926,9.85775 17.746,10.26875 C17.565,10.67975 17.683,11.16275 18.031,11.44675 C18.157,11.55075 20.732,13.71675 20.12,17.83775 C19.074,16.55975 17.479,15.11675 15.615,15.11675 C15.283,15.11675 14.972,15.28175 14.787,15.55675 C14.6,15.83175 14.563,16.18175 14.687,16.48975 C15.191,17.74375 16.191,21.46675 14.783,23.60375 C14.772,23.61975 14.723,23.70075 14.714,23.71675 L14.686,23.76375 C14.683,23.76775 14.681,23.77175 14.679,23.77575 C13.073,26.57875 13.112,29.95075 14.782,32.57375 C16.759,35.68275 20.137,37.53875 23.818,37.53875 C33.751,37.53875 34.522,28.32275 34.522,25.49775 C34.522,20.52975 31.596,18.90475 31.472,18.83775 M34.387,38.73275 C29.816,39.55375 25.918,41.78975 24.015,43.03875 C22.113,41.78975 18.214,39.55375 13.643,38.73275 C11.381,38.32575 4,36.53775 4,30.59875 C4,28.06675 4.945,26.43775 6.041,24.55175 C7.093,22.73775 8.287,20.68175 8.287,17.89275 C8.287,14.30075 6.602,11.60375 5.273,10.03575 C6.522,8.51375 8.27,6.37175 9.527,4.78975 C11.739,6.55775 14.258,7.51975 16.717,7.51975 C19.496,7.51975 21.893,6.50875 24.015,4.43575 C26.137,6.50875 28.535,7.51975 31.313,7.51975 C33.773,7.51975 36.292,6.55775 38.504,4.79075 C39.818,6.44575 41.63,8.66175 42.757,10.03675 C41.428,11.60475 39.744,14.30075 39.744,17.89275 C39.744,20.68375 40.938,22.73875 41.993,24.55375 C43.087,26.43975 44.031,28.06775 44.031,30.59875 C44.031,36.53775 36.649,38.32575 34.387,38.73275 M43.72,23.54675 C42.704,21.79775 41.744,20.14475 41.744,17.89275 C41.744,14.43175 43.656,11.93975 44.797,10.76375 C45.15,10.39775 45.173,9.82475 44.85,9.43275 C43.715,8.05375 40.917,4.64175 39.431,2.73675 C39.259,2.51675 39.004,2.37775 38.724,2.35575 C38.446,2.32875 38.171,2.42775 37.964,2.61775 C35.939,4.48875 33.577,5.51975 31.313,5.51975 C28.774,5.51975 26.693,4.50375 24.764,2.32175 C24.385,1.89275 23.645,1.89275 23.266,2.32175 C21.338,4.50375 19.256,5.51975 16.717,5.51975 C14.454,5.51975 12.091,4.48875 10.066,2.61775 C9.86,2.42775 9.586,2.32875 9.306,2.35575 C9.027,2.37775 8.771,2.51675 8.599,2.73675 C7.216,4.50875 4.611,7.69275 3.18,9.43275 C2.857,9.82575 2.881,10.39775 3.234,10.76375 C4.375,11.93975 6.287,14.43175 6.287,17.89275 C6.287,20.14375 5.327,21.79675 4.31,23.54775 C3.174,25.50475 2,27.52775 2,30.59875 C2,38.08875 10.641,40.22475 13.29,40.70175 C17.995,41.54675 21.96,44.03575 23.445,45.06675 C23.617,45.18475 23.816,45.24475 24.015,45.24475 C24.214,45.24475 24.414,45.18475 24.586,45.06675 C26.071,44.03575 30.036,41.54675 34.741,40.70175 C37.389,40.22475 46.031,38.08875 46.031,30.59875 C46.031,27.52975 44.857,25.50675 43.72,23.54675" id="Fill-1" fill="#8C4FFF"></path>
    </g>
</svg>`, AR = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Networking-and-Content-Delivery/Res_Amazon-Route-53-Hosted-Zone_48</title>
    <g id="Icon-Resource/Networking-and-Content-Delivery/Res_Amazon-Route-53-Hosted-Zone_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M33.4488,39.3643 C28.8848,40.1843 25.0338,42.5853 23.5848,43.5833 C22.1358,42.5853 18.2848,40.1843 13.7198,39.3643 C11.4398,38.9553 3.9998,37.1363 3.9998,30.9253 C3.9998,28.3293 4.9828,26.6353 6.0238,24.8433 C7.0038,23.1543 8.0158,21.4103 8.0158,19.0203 C8.0158,15.4343 6.0408,12.8533 4.9278,11.6843 C6.0608,10.3063 8.5278,7.2973 9.8918,5.5523 C11.9708,7.4423 14.3708,8.4703 16.7468,8.4703 C19.3928,8.4703 21.5918,7.4293 23.5848,5.2123 C25.5768,7.4293 27.7748,8.4703 30.4228,8.4703 C32.7988,8.4703 35.1968,7.4423 37.2758,5.5523 C38.6398,7.2963 41.1068,10.3063 42.2408,11.6843 C41.1278,12.8533 39.1518,15.4343 39.1518,19.0203 C39.1518,21.4103 40.1648,23.1543 41.1438,24.8433 C42.1848,26.6353 43.1688,28.3293 43.1688,30.9253 C43.1688,37.1363 35.7288,38.9553 33.4488,39.3643 M42.8748,23.8383 C41.9498,22.2463 41.1518,20.8713 41.1518,19.0203 C41.1518,15.1103 44.2038,12.5673 44.2328,12.5443 L45.0178,11.9093 L44.3758,11.1303 C44.3248,11.0693 39.3318,5.0173 38.1898,3.4543 L37.4768,2.4783 L36.6518,3.3613 C34.7758,5.3663 32.5638,6.4703 30.4228,6.4703 C28.0598,6.4703 26.1968,5.4123 24.3788,3.0373 L23.5848,2.0003 L22.7908,3.0363 C20.9718,5.4113 19.1078,6.4703 16.7468,6.4703 C14.6038,6.4703 12.3918,5.3663 10.5158,3.3613 L9.6898,2.4773 L8.9778,3.4553 C7.8378,5.0173 2.8448,11.0693 2.7938,11.1303 L2.1508,11.9093 L2.9358,12.5443 C2.9678,12.5693 6.0158,15.0803 6.0158,19.0203 C6.0158,20.8713 5.2188,22.2463 4.2938,23.8383 C3.2188,25.6913 1.9998,27.7913 1.9998,30.9253 C1.9998,36.1653 6.2488,40.0553 13.3668,41.3333 C18.5718,42.2673 22.9318,45.5733 22.9758,45.6063 L23.5858,46.0723 L24.1928,45.6063 C24.2368,45.5733 28.5968,42.2673 33.8028,41.3333 C40.9198,40.0553 45.1688,36.1653 45.1688,30.9253 C45.1688,27.7913 43.9498,25.6913 42.8748,23.8383" id="AWS-Amazon-Route-53-Hosted-zone_Resource-Icon_dark-bg" fill="#8C4FFF"></path>
    </g>
</svg>`, ZR = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Networking-and-Content-Delivery/Res_Amazon-VPC_VPN-Gateway_48</title>
    <g id="Icon-Resource/Networking-and-Content-Delivery/Res_Amazon-VPC_VPN-Gateway_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M24.0015,25.4385 C24.6565,25.4385 25.1885,25.9705 25.1885,26.6255 C25.1885,27.2815 24.6565,27.8135 24.0015,27.8135 C23.3465,27.8135 22.8135,27.2815 22.8135,26.6255 C22.8135,25.9705 23.3465,25.4385 24.0015,25.4385 L24.0015,25.4385 Z M23.0015,29.6365 L23.0015,32.6915 L25.0015,32.6915 L25.0015,29.6365 C26.2685,29.2145 27.1895,28.0325 27.1895,26.6255 C27.1895,24.8685 25.7595,23.4385 24.0015,23.4385 C22.2435,23.4385 20.8135,24.8685 20.8135,26.6255 C20.8135,28.0325 21.7345,29.2145 23.0015,29.6365 L23.0015,29.6365 Z M24.0015,44.0015 C12.9725,44.0015 3.9995,35.0295 3.9995,24.0015 C3.9995,12.9725 12.9725,4.0005 24.0015,4.0005 C35.0295,4.0005 44.0025,12.9725 44.0025,24.0015 C44.0025,35.0295 35.0295,44.0015 24.0015,44.0015 L24.0015,44.0015 Z M24.0015,2.0005 C11.8695,2.0005 1.9995,11.8695 1.9995,24.0015 C1.9995,36.1325 11.8695,46.0015 24.0015,46.0015 C36.1335,46.0015 46.0025,36.1325 46.0025,24.0015 C46.0025,11.8695 36.1335,2.0005 24.0015,2.0005 L24.0015,2.0005 Z M32.6195,34.3765 L15.3755,34.3695 L15.3805,21.5005 L32.6265,21.5075 L32.6195,34.3765 Z M19.7545,16.0965 C19.7585,14.9175 20.2075,13.8135 21.0195,12.9845 C21.8205,12.1675 22.8815,11.7165 24.0075,11.7165 L24.0225,11.7165 C25.1475,11.7195 26.2045,12.1795 26.9985,13.0095 C27.7995,13.8475 28.2385,14.9605 28.2345271,16.1485 L28.2345271,19.5055 L19.7385,19.5025 L19.7545,16.0965 Z M33.6265,19.5075 L30.2345,19.5065 L30.2345,16.1515 C30.2405,14.4485 29.6045,12.8405 28.4435,11.6275 C27.2715,10.4005 25.7025,9.7215 24.0275,9.7165 L24.0075,9.7165 C22.3395,9.7165 20.7725,10.3795 19.5915,11.5845 C18.4125,12.7875 17.7605,14.3875 17.7545,16.0885 L17.7385,19.5015 L14.3805,19.5015 C14.1155,19.5015 13.8605,19.6065 13.6735,19.7935 C13.4855,19.9815 13.3805,20.2355 13.3805,20.5015 L13.3755,35.3695 C13.3755,35.9205 13.8225,36.3695 14.3755,36.3695 L33.6195,36.3765 C34.1715,36.3765 34.6195,35.9295 34.6195,35.3765 L34.6265,20.5075 C34.6265,20.2435 34.5215,19.9885 34.3335,19.8005 C34.1465,19.6135 33.8925,19.5075 33.6265,19.5075 L33.6265,19.5075 Z" id="AWS-Amazon-VPC_VPN-gateway_Resource-Icon_light-bg" fill="#8C4FFF"></path>
    </g>
</svg>`, Ui = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Networking-and-Content-Delivery/Res_Amazon-CloudFront_Functions_48</title>
    <g id="Icon-Resource/Networking-and-Content-Delivery/Res_Amazon-CloudFront_Functions_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M31.9,33.508 C31.014,33.508 30.294,32.787 30.294,31.901 C30.294,31.015 31.014,30.294 31.9,30.294 C32.787,30.294 33.507,31.015 33.507,31.901 C33.507,32.787 32.787,33.508 31.9,33.508 L31.9,33.508 Z M31.9,28.294 C29.912,28.294 28.294,29.912 28.294,31.901 C28.294,33.89 29.912,35.508 31.9,35.508 C33.889,35.508 35.507,33.89 35.507,31.901 C35.507,29.912 33.889,28.294 31.9,28.294 L31.9,28.294 Z M15.782,24.103 C14.896,24.103 14.175,23.382 14.175,22.496 C14.175,21.61 14.896,20.889 15.782,20.889 C16.669,20.889 17.389,21.61 17.389,22.496 C17.389,23.382 16.669,24.103 15.782,24.103 L15.782,24.103 Z M15.782,18.889 C13.794,18.889 12.175,20.507 12.175,22.496 C12.175,24.485 13.794,26.103 15.782,26.103 C17.771,26.103 19.389,24.485 19.389,22.496 C19.389,20.507 17.771,18.889 15.782,18.889 L15.782,18.889 Z M25.779,10.666 C26.666,10.666 27.386,11.387 27.386,12.273 C27.386,13.159 26.666,13.88 25.779,13.88 C24.893,13.88 24.172,13.159 24.172,12.273 C24.172,11.387 24.893,10.666 25.779,10.666 L25.779,10.666 Z M25.779,15.88 C27.768,15.88 29.386,14.262 29.386,12.273 C29.386,10.284 27.768,8.666 25.779,8.666 C23.791,8.666 22.172,10.284 22.172,12.273 C22.172,14.262 23.791,15.88 25.779,15.88 L25.779,15.88 Z M18.853,19.116 L17.175,18.027 C18.521,15.953 19.676,14.578 21.164,13.281 L22.478,14.788 C21.141,15.954 20.09,17.208 18.853,19.116 L18.853,19.116 Z M29.203,28.173 L27.822,29.62 C25.246,27.162 22.675,25.547 19.732,24.537 L20.38,22.645 C23.607,23.753 26.41,25.509 29.203,28.173 L29.203,28.173 Z M29.274,15.12 C31.754,18.902 33.149,23.052 33.422,27.458 L31.426,27.582 C31.175,23.528 29.888,19.704 27.602,16.217 L29.274,15.12 Z M44,27.115 L41.572,26.977 C41.109,26.945 40.647,27.278 40.54,27.756 C40.117,29.63 39.38,31.409 38.351,33.043 C38.09,33.456 38.167,33.997 38.531,34.322 L40.344,35.94 L35.94,40.345 L35.161,39.472 C35.693,37.536 34.752,35.589 34.706,35.498 L32.915,36.389 C32.921,36.402 33.341,37.282 33.336,38.24 C33.236,38.265 33.137,38.3 33.046,38.358 C32.529,38.685 31.992,38.971 31.445,39.238 C31.796,38.383 32.107,37.512 32.357,36.647 L30.437,36.09 C30.026,37.507 29.449,38.948 28.772,40.275 C28.435,40.373 28.098,40.473 27.754,40.55 C27.277,40.658 26.948,41.095 26.976,41.583 L27.115,44 L20.884,44 L21.023,41.581 C21.051,41.093 20.722,40.656 20.246,40.549 C18.969,40.26 17.743,39.815 16.571,39.242 C15.488,36.464 14.865,33.484 14.865,31.003 C14.865,29.894 15.059,28.968 15.284,27.897 L15.45,27.088 L13.487,26.701 L13.326,27.486 C13.088,28.618 12.865,29.687 12.865,31.003 C12.865,33.214 13.311,35.773 14.105,38.266 C13.946,38.32 13.795,38.401 13.675,38.534 L12.06,40.345 L7.655,35.94 L9.465,34.325 C9.83,34 9.906,33.459 9.645,33.046 C8.617,31.416 7.88,29.636 7.457,27.756 C7.349,27.278 6.884,26.945 6.424,26.977 L4,27.115 L4,20.885 L6.431,21.024 C6.884,21.048 7.354,20.723 7.463,20.246 C7.887,18.373 8.626,16.597 9.656,14.966 C9.917,14.552 9.84,14.011 9.476,13.686 L7.655,12.061 L12.06,7.655 L13.684,9.475 C14.009,9.84 14.552,9.915 14.963,9.655 C16.071,8.958 17.25,8.406 18.478,7.984 C19.428,8.482 20.712,9.213 21.865,10.088 L23.074,8.494 C22.348,7.943 21.581,7.45 20.861,7.023 C20.969,6.852 21.036,6.652 21.023,6.437 L20.884,4 L27.115,4 L26.976,6.439 C26.948,6.927 27.277,7.363 27.754,7.471 C28.562,7.654 29.348,7.906 30.117,8.204 C29.996,8.25 29.872,8.296 29.754,8.341 C29.478,8.447 29.207,8.55 28.946,8.645 L29.626,10.526 C29.898,10.427 30.18,10.32 30.468,10.21 C31.214,9.925 31.979,9.639 32.694,9.465 C32.806,9.531 32.922,9.589 33.033,9.659 C33.444,9.918 33.987,9.844 34.312,9.479 L35.939,7.655 L40.344,12.061 L38.527,13.682 C38.163,14.008 38.087,14.549 38.347,14.962 C39.377,16.593 40.114,18.37 40.538,20.246 C40.645,20.722 41.109,21.048 41.57,21.024 L44,20.885 L44,27.115 Z M45.686,19.099 C45.487,18.91 45.215,18.814 44.943,18.828 L42.283,18.98 C41.866,17.457 41.26,15.998 40.476,14.624 L42.466,12.848 C42.671,12.665 42.793,12.405 42.8,12.131 C42.808,11.856 42.702,11.59 42.507,11.395 L36.605,5.493 C36.411,5.298 36.144,5.194 35.87,5.2 C35.594,5.208 35.336,5.329 35.152,5.534 L33.371,7.53 C31.999,6.747 30.541,6.143 29.02,5.727 L29.171,3.057 C29.187,2.782 29.089,2.513 28.9,2.314 C28.712,2.113 28.449,2 28.173,2 L19.826,2 C19.55,2 19.288,2.113 19.099,2.314 C18.91,2.513 18.812,2.782 18.828,3.057 L18.979,5.724 C17.458,6.14 15.999,6.744 14.626,7.527 L12.847,5.534 C12.664,5.329 12.405,5.208 12.129,5.2 C11.861,5.196 11.588,5.298 11.394,5.493 L5.492,11.395 C5.297,11.59 5.191,11.856 5.199,12.131 C5.207,12.405 5.328,12.665 5.533,12.848 L7.527,14.627 C6.742,16.001 6.136,17.459 5.719,18.98 L3.056,18.828 C2.781,18.813 2.512,18.91 2.313,19.099 C2.113,19.288 2,19.551 2,19.826 L2,28.174 C2,28.449 2.113,28.712 2.313,28.901 C2.512,29.09 2.782,29.19 3.056,29.173 L5.712,29.021 C6.128,30.548 6.733,32.009 7.516,33.384 L5.533,35.153 C5.328,35.336 5.207,35.595 5.199,35.87 C5.191,36.145 5.297,36.411 5.492,36.606 L11.394,42.508 C11.588,42.703 11.859,42.816 12.129,42.8 C12.405,42.793 12.665,42.672 12.847,42.466 L14.617,40.484 C15.994,41.269 17.455,41.876 18.979,42.293 L18.828,44.943 C18.812,45.217 18.91,45.487 19.098,45.687 C19.288,45.887 19.55,46 19.826,46 L28.173,46 C28.449,46 28.712,45.887 28.901,45.687 C29.089,45.487 29.187,45.217 29.171,44.943 L29.02,42.296 C30.547,41.878 32.01,41.272 33.385,40.487 L35.152,42.466 C35.335,42.672 35.594,42.793 35.87,42.8 C36.147,42.819 36.411,42.703 36.605,42.508 L42.507,36.606 C42.702,36.411 42.808,36.145 42.8,35.87 C42.793,35.595 42.671,35.336 42.466,35.153 L40.48,33.381 C41.264,32.005 41.869,30.544 42.285,29.021 L44.943,29.173 C45.214,29.189 45.487,29.09 45.686,28.901 C45.886,28.712 46,28.449 46,28.174 L46,19.826 C46,19.551 45.886,19.288 45.686,19.099 L45.686,19.099 Z" id="Fill-1" fill="#8C4FFF"></path>
    </g>
</svg>`, kR = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Networking-and-Content-Delivery/Res_Amazon-VPC_Elastic-Network-Adapter_48</title>
    <g id="Icon-Resource/Networking-and-Content-Delivery/Res_Amazon-VPC_Elastic-Network-Adapter_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M17.187,24.701 L21.299,24.701 L21.299,20.589 L17.187,20.589 L17.187,24.701 Z M23.3,24.701 L27.412,24.701 L27.412,20.589 L23.3,20.589 L23.3,24.701 Z M16.187,26.701 L28.412,26.701 C28.964,26.701 29.412,26.254 29.412,25.701 L29.412,19.589 C29.412,19.036 28.964,18.589 28.412,18.589 L16.187,18.589 C15.634,18.589 15.187,19.036 15.187,19.589 L15.187,25.701 C15.187,26.254 15.634,26.701 16.187,26.701 L16.187,26.701 Z M12.821,17.097 L32.65,17.097 L32.65,28.193 L30.158,28.193 C29.605,28.193 29.158,28.64 29.158,29.193 L29.158,30.813 L26.791,30.813 L26.791,29.193 C26.791,28.64 26.344,28.193 25.791,28.193 L22.299,28.193 C21.747,28.193 21.299,28.64 21.299,29.193 L21.299,30.813 L14.568,30.813 L14.568,29.193 C14.568,28.64 14.121,28.193 13.568,28.193 L12.821,28.193 L12.821,17.097 Z M10.821,16.097 L10.821,29.193 C10.821,29.746 11.268,30.193 11.821,30.193 L12.568,30.193 L12.568,31.813 C12.568,32.366 13.015,32.813 13.568,32.813 L22.299,32.813 C22.852,32.813 23.299,32.366 23.299,31.813 L23.299,30.193 L24.791,30.193 L24.791,31.813 C24.791,32.366 25.239,32.813 25.791,32.813 L30.158,32.813 C30.71,32.813 31.158,32.366 31.158,31.813 L31.158,30.193 L33.65,30.193 C34.203,30.193 34.65,29.746 34.65,29.193 L34.65,16.097 C34.65,15.544 34.203,15.097 33.65,15.097 L11.821,15.097 C11.268,15.097 10.821,15.544 10.821,16.097 L10.821,16.097 Z M9.329,14.349 L9.329,33.559 C9.329,34.112 8.881,34.559 8.329,34.559 L5.185,34.559 L5.185,32.559 L7.329,32.559 L7.329,15.349 L5.185,15.349 L5.185,13.349 L8.329,13.349 C8.881,13.349 9.329,13.797 9.329,14.349 L9.329,14.349 Z M30.285,41.91 L30.285,37.052 C30.285,36.499 29.837,36.052 29.285,36.052 L4.486,36.052 C4.213,36.052 4,35.849 4,35.596 L4.089,12.317 C4.089,12.059 4.302,11.857 4.575,11.857 L29.373,11.857 C29.641,11.857 29.897,11.751 30.084,11.56 C30.273,11.37 30.376,11.113 30.373,10.846 L30.319,6.045 L43.751,23.955 L30.285,41.91 Z M45.801,23.355 L30.084,2.399 C29.826,2.054 29.372,1.916 28.963,2.052 C28.553,2.191 28.28,2.578 28.285,3.011 L28.362,9.857 L4.575,9.857 C3.205,9.857 2.089,10.961 2.089,12.313 L2,35.592 C2,36.948 3.116,38.052 4.486,38.052 L28.285,38.052 L28.285,44.91 C28.285,45.341 28.56,45.723 28.968,45.858 C29.073,45.893 29.179,45.91 29.285,45.91 C29.593,45.91 29.892,45.766 30.084,45.51 L45.801,24.555 C46.068,24.199 46.068,23.711 45.801,23.355 L45.801,23.355 Z" id="AWS-Amazon-VPC_Elastic-Network-Adapter_Resource-Icon_light-bg" fill="#8C4FFF"></path>
    </g>
</svg>`, TR = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Networking-and-Content-Delivery/Res_AWS-App-Mesh_Virtual-Gateway_48</title>
    <g id="Icon-Resource/Networking-and-Content-Delivery/Res_AWS-App-Mesh_Virtual-Gateway_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M26.0811,37.3026 C26.0811,36.8006 25.8861,36.3296 25.5321,35.9766 C25.1791,35.6226 24.7081,35.4276 24.2061,35.4276 C23.7051,35.4276 23.2341,35.6226 22.8811,35.9766 C22.5271,36.3296 22.3321,36.8006 22.3321,37.3026 C22.3321,37.8036 22.5271,38.2746 22.8811,38.6276 C23.5891,39.3356 24.8261,39.3336 25.5321,38.6276 C25.8861,38.2746 26.0811,37.8036 26.0811,37.3026 L26.0811,37.3026 Z M22.8811,24.9406 C23.5891,25.6486 24.8261,25.6466 25.5321,24.9406 C25.8861,24.5866 26.0811,24.1156 26.0811,23.6146 C26.0811,23.1136 25.8861,22.6426 25.5321,22.2886 C25.1781,21.9346 24.7071,21.7396 24.2061,21.7396 C23.7061,21.7396 23.2351,21.9346 22.8811,22.2886 C22.5271,22.6426 22.3321,23.1136 22.3321,23.6146 C22.3321,24.1156 22.5271,24.5866 22.8811,24.9406 L22.8811,24.9406 Z M22.8811,10.3766 C23.5891,11.0846 24.8261,11.0826 25.5321,10.3766 C25.8861,10.0236 26.0811,9.5526 26.0811,9.0506 C26.0811,8.5496 25.8861,8.0786 25.5321,7.7256 C25.1791,7.3716 24.7081,7.1766 24.2061,7.1766 C23.7051,7.1766 23.2341,7.3716 22.8811,7.7256 C22.5271,8.0786 22.3321,8.5496 22.3321,9.0506 C22.3321,9.5526 22.5271,10.0236 22.8811,10.3766 L22.8811,10.3766 Z M12.3021,32.1186 C12.3021,31.6176 12.1061,31.1476 11.7531,30.7936 C11.3881,30.4286 10.9071,30.2456 10.4271,30.2456 C9.9461,30.2456 9.4661,30.4286 9.1011,30.7936 C8.3701,31.5256 8.3701,32.7146 9.1011,33.4456 C9.8311,34.1756 11.0221,34.1756 11.7531,33.4456 C12.1061,33.0916 12.3021,32.6206 12.3021,32.1186 L12.3021,32.1186 Z M8.5521,17.4726 C8.5521,17.9736 8.7471,18.4446 9.1011,18.7976 C9.8311,19.5286 11.0221,19.5286 11.7531,18.7976 C12.1061,18.4446 12.3021,17.9736 12.3021,17.4726 C12.3021,16.9706 12.1061,16.4996 11.7531,16.1466 C11.3881,15.7816 10.9071,15.5986 10.4271,15.5986 C9.9461,15.5986 9.4661,15.7816 9.1011,16.1466 C8.7471,16.4996 8.5521,16.9706 8.5521,17.4726 L8.5521,17.4726 Z M35.9851,14.2346 C35.9851,14.7356 36.1811,15.2056 36.5341,15.5596 C37.2651,16.2896 38.4561,16.2896 39.1861,15.5596 C39.5401,15.2056 39.7351,14.7356 39.7351,14.2346 C39.7351,13.7336 39.5401,13.2626 39.1861,12.9076 C38.8211,12.5426 38.3411,12.3606 37.8601,12.3606 C37.3801,12.3606 36.8991,12.5426 36.5341,12.9076 C36.1811,13.2616 35.9851,13.7326 35.9851,14.2346 L35.9851,14.2346 Z M36.5341,31.0176 C37.2671,31.7476 38.4561,31.7476 39.1861,31.0176 C39.9171,30.2856 39.9171,29.0966 39.1861,28.3646 C38.4561,27.6346 37.2651,27.6346 36.5341,28.3646 C35.8041,29.0966 35.8041,30.2856 36.5341,31.0176 L36.5341,31.0176 Z M28.0721,37.2346 C28.0901,38.2486 27.7191,39.2696 26.9461,40.0416 C26.1911,40.7976 25.1991,41.1746 24.2061,41.1746 C23.2141,41.1746 22.2221,40.7976 21.4671,40.0416 C20.7271,39.3026 20.3551,38.3356 20.3401,37.3646 L13.6161,34.3096 C13.4831,34.5016 13.3381,34.6886 13.1671,34.8596 C12.4111,35.6156 11.4191,35.9926 10.4271,35.9926 C9.4351,35.9926 8.4421,35.6156 7.6861,34.8596 C6.1771,33.3496 6.1761,30.8916 7.6861,29.3796 C8.0721,28.9936 8.5211,28.7096 9.0001,28.5206 L9.0001,21.0716 C8.5211,20.8816 8.0721,20.5976 7.6861,20.2116 C6.1761,18.7006 6.1761,16.2426 7.6861,14.7326 C9.1981,13.2206 11.6551,13.2206 13.1671,14.7326 C14.6781,16.2426 14.6781,18.7006 13.1671,20.2116 C12.5581,20.8206 11.7931,21.1716 11.0001,21.2896 L11.0001,28.3026 C11.7931,28.4196 12.5581,28.7716 13.1671,29.3796 C13.9961,30.2096 14.3531,31.3236 14.2721,32.4106 L20.8501,35.4006 C21.0181,35.1026 21.2131,34.8156 21.4671,34.5626 C21.9101,34.1176 22.4401,33.8216 23.0001,33.6376 L23.0001,27.2796 C22.4401,27.0966 21.9101,26.7986 21.4671,26.3546 C19.9561,24.8436 19.9561,22.3856 21.4671,20.8746 C21.8991,20.4416 22.4331,20.1526 23.0001,19.9756 L23.0001,12.7156 C22.4401,12.5316 21.9101,12.2356 21.4671,11.7906 C19.9561,10.2806 19.9561,7.8226 21.4671,6.3116 C22.9781,4.7996 25.4381,4.8016 26.9461,6.3116 C28.4571,7.8226 28.4571,10.2806 26.9461,11.7906 C26.3941,12.3436 25.7141,12.6896 25.0001,12.8366 L25.0001,19.8586 C25.7241,20.0006 26.4091,20.3366 26.9461,20.8746 C26.9581,20.8866 26.9651,20.9006 26.9771,20.9116 L34.2501,15.6226 C33.7191,14.2376 34.0061,12.6086 35.1201,11.4936 C36.6321,9.9846 39.0891,9.9846 40.6011,11.4936 C42.1111,13.0046 42.1111,15.4626 40.6011,16.9736 C39.8451,17.7286 38.8521,18.1066 37.8601,18.1066 C36.9981,18.1066 36.1441,17.8026 35.4361,17.2316 L27.9491,22.6756 C28.2681,23.9526 27.9421,25.3586 26.9461,26.3546 C26.3941,26.9066 25.7141,27.2526 25.0001,27.4016 L25.0001,33.5156 C25.7141,33.6626 26.3941,34.0096 26.9461,34.5626 C27.1551,34.7716 27.3281,35.0006 27.4791,35.2406 L34.2131,30.9556 C33.7461,29.5986 34.0391,28.0326 35.1201,26.9506 C36.6301,25.4416 39.0891,25.4416 40.6011,26.9506 C42.1101,28.4616 42.1101,30.9206 40.6011,32.4316 C39.8461,33.1866 38.8521,33.5646 37.8601,33.5646 C36.9581,33.5646 36.0641,33.2356 35.3401,32.6106 L28.0721,37.2346 Z M14.0001,43.4476 L4.0001,38.9026 L4.0001,9.3586 L14.0001,4.5846 L14.0001,10.1766 L16.0001,10.1766 L16.0001,2.9996 C16.0001,2.6566 15.8241,2.3366 15.5331,2.1546 C15.2431,1.9706 14.8801,1.9496 14.5691,2.0976 L2.5691,7.8246 C2.2221,7.9906 2.0001,8.3416 2.0001,8.7276 L2.0001,39.5456 C2.0001,39.9386 2.2291,40.2936 2.5861,40.4556 L14.5861,45.9096 C14.7181,45.9706 14.8591,45.9996 15.0001,45.9996 C15.1891,45.9996 15.3771,45.9466 15.5411,45.8406 C15.8271,45.6566 16.0001,45.3396 16.0001,44.9996 L16.0001,38.1766 L14.0001,38.1766 L14.0001,43.4476 Z M46.0001,8.9046 L46.0001,39.7226 C46.0001,40.1156 45.7701,40.4706 45.4141,40.6326 L33.4141,46.0866 C33.2821,46.1476 33.1411,46.1766 33.0001,46.1766 C32.8101,46.1766 32.6231,46.1226 32.4591,46.0176 C32.1731,45.8326 32.0001,45.5166 32.0001,45.1766 L32.0001,38.1766 L34.0001,38.1766 L34.0001,43.6236 L44.0001,39.0786 L44.0001,9.5346 L34.0001,4.7616 L34.0001,10.1766 L32.0001,10.1766 L32.0001,3.1766 C32.0001,2.8326 32.1761,2.5136 32.4671,2.3306 C32.7571,2.1476 33.1211,2.1256 33.4311,2.2746 L45.4311,8.0016 C45.7781,8.1676 46.0001,8.5186 46.0001,8.9046 L46.0001,8.9046 Z" id="AWS-App-Mesh-Virtual-Gateway_Resource-Icon_light-bg" fill="#8C4FFF"></path>
    </g>
</svg>`, SR = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Networking-and-Content-Delivery/Res_Amazon-Route-53_Resolver-Query-Logging_48</title>
    <g id="Icon-Resource/Networking-and-Content-Delivery/Res_Amazon-Route-53_Resolver-Query-Logging_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M17.002,24.9645 L31.002,24.9645 L31.002,22.9645 L17.002,22.9645 L17.002,24.9645 Z M17.002,30.9645 L31.002,30.9645 L31.002,28.9645 L17.002,28.9645 L17.002,30.9645 Z M17.002,18.9645 L31.002,18.9645 L31.002,16.9645 L17.002,16.9645 L17.002,18.9645 Z M16.002,34.9645 L32.002,34.9645 L32.002,12.9645 L16.002,12.9645 L16.002,34.9645 Z M33.002,10.9645 L15.002,10.9645 C14.449,10.9645 14.002,11.4115 14.002,11.9645 L14.002,35.9645 C14.002,36.5165 14.449,36.9645 15.002,36.9645 L33.002,36.9645 C33.555,36.9645 34.002,36.5165 34.002,35.9645 L34.002,11.9645 C34.002,11.4115 33.555,10.9645 33.002,10.9645 L33.002,10.9645 Z M34.055,39.4255 C29.392,40.2625 25.459,42.7195 23.991,43.7305 C22.523,42.7195 18.592,40.2625 13.929,39.4255 C11.6,39.0075 4,37.1485 4,30.7995 C4,28.1465 5.004,26.4175 6.066,24.5865 C7.064,22.8675 8.096,21.0905 8.096,18.6595 C8.096,14.9955 6.07,12.3625 4.94,11.1785 C6.094,9.7755 8.634,6.6775 10.025,4.8955 C12.146,6.8285 14.594,7.8805 17.019,7.8805 C19.718,7.8805 21.959,6.8155 23.991,4.5475 C26.023,6.8155 28.265,7.8805 30.965,7.8805 C33.389,7.8805 35.837,6.8285 37.957,4.8955 C39.35,6.6775 41.889,9.7755 43.043,11.1785 C41.913,12.3625 39.888,14.9955 39.888,18.6595 C39.888,21.0905 40.919,22.8675 41.917,24.5865 C42.979,26.4175 43.983,28.1465 43.983,30.7995 C43.983,37.1485 36.384,39.0075 34.055,39.4255 L34.055,39.4255 Z M43.646,23.5825 C42.703,21.9565 41.888,20.5525 41.888,18.6595 C41.888,14.6615 45.007,12.0635 45.036,12.0395 C45.243,11.8715 45.375,11.6275 45.402,11.3615 C45.429,11.0955 45.349,10.8305 45.179,10.6245 C45.127,10.5625 40.034,4.3925 38.87,2.7965 C38.694,2.5555 38.421,2.4065 38.123,2.3875 C37.829,2.3705 37.535,2.4855 37.332,2.7025 C35.416,4.7525 33.155,5.8805 30.965,5.8805 C28.55,5.8805 26.644,4.7985 24.785,2.3705 C24.406,1.8765 23.576,1.8765 23.197,2.3705 C21.339,4.7985 19.434,5.8805 17.019,5.8805 C14.828,5.8805 12.566,4.7525 10.65,2.7025 C10.446,2.4855 10.137,2.3655 9.859,2.3875 C9.562,2.4065 9.287,2.5555 9.112,2.7965 C7.949,4.3925 2.856,10.5625 2.805,10.6245 C2.636,10.8295 2.557,11.0945 2.582,11.3595 C2.608,11.6245 2.739,11.8685 2.945,12.0375 C2.977,12.0635 6.096,14.6615 6.096,18.6595 C6.096,20.5525 5.28,21.9565 4.337,23.5825 C3.241,25.4695 2,27.6085 2,30.7995 C2,36.1315 6.327,40.0925 13.575,41.3935 C18.888,42.3475 23.338,45.7215 23.383,45.7555 C23.562,45.8925 23.776,45.9615 23.991,45.9615 C24.206,45.9615 24.421,45.8925 24.6,45.7555 C24.645,45.7215 29.095,42.3475 34.408,41.3935 C41.656,40.0925 45.983,36.1315 45.983,30.7995 C45.983,27.6085 44.742,25.4695 43.646,23.5825 L43.646,23.5825 Z" id="Fill-1" fill="#8C4FFF"></path>
    </g>
</svg>`, bR = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Networking-and-Content-Delivery/Res_Elastic-Load-Balancing_Classic-Load-Balancer_48</title>
    <g id="Icon-Resource/Networking-and-Content-Delivery/Res_Elastic-Load-Balancing_Classic-Load-Balancer_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M24.0015,44.002 C12.9725,44.002 3.9995,35.029 3.9995,24.001 C3.9995,12.973 12.9725,4 24.0015,4 C35.0295,4 44.0025,12.973 44.0025,24.001 C44.0025,35.029 35.0295,44.002 24.0015,44.002 L24.0015,44.002 Z M24.0015,2 C11.8695,2 1.9995,11.869 1.9995,24.001 C1.9995,36.133 11.8695,46.002 24.0015,46.002 C36.1335,46.002 46.0025,36.133 46.0025,24.001 C46.0025,11.869 36.1335,2 24.0015,2 L24.0015,2 Z M27.0645,27.235 C27.4605,27.235 27.7835,27.551 27.7835,27.939 C27.7835,28.326 27.4605,28.642 27.0645,28.642 C26.6675,28.642 26.3445,28.326 26.3445,27.939 C26.3445,27.551 26.6675,27.235 27.0645,27.235 L27.0645,27.235 Z M20.0635,25.142 C19.6665,25.142 19.3435,24.826 19.3435,24.439 C19.3435,24.051 19.6665,23.735 20.0635,23.735 C20.4605,23.735 20.7835,24.051 20.7835,24.439 C20.7835,24.826 20.4605,25.142 20.0635,25.142 L20.0635,25.142 Z M27.0645,20.275 C27.4295,20.275 27.7265,20.573 27.7265,20.939 C27.7265,21.304 27.4295,21.601 27.0645,21.601 C26.6985,21.601 26.4005,21.304 26.4005,20.939 C26.4005,20.573 26.6985,20.275 27.0645,20.275 L27.0645,20.275 Z M22.7615,24.216 L25.3195,22.934 C25.7885,23.344 26.3945,23.601 27.0645,23.601 C28.5315,23.601 29.7265,22.406 29.7265,20.939 C29.7265,19.47 28.5315,18.275 27.0645,18.275 C25.5955,18.275 24.4005,19.47 24.4005,20.939 C24.4005,21.009 24.4165,21.076 24.4225,21.146 L21.8635,22.428 C21.3825,22.002 20.7565,21.735 20.0635,21.735 C18.5635,21.735 17.3435,22.948 17.3435,24.439 C17.3435,25.929 18.5635,27.142 20.0635,27.142 C20.8445,27.142 21.5445,26.809 22.0405,26.283 L24.3805,27.583 C24.3645,27.7 24.3445,27.816 24.3445,27.939 C24.3445,29.429 25.5635,30.642 27.0645,30.642 C28.5635,30.642 29.7835,29.429 29.7835,27.939 C29.7835,26.448 28.5635,25.235 27.0645,25.235 C26.4195,25.235 25.8335,25.469 25.3665,25.843 L22.7805,24.407 C22.7795,24.342 22.7675,24.28 22.7615,24.216 L22.7615,24.216 Z M24.4385,31.751 C20.4065,31.751 17.1255,28.508 17.1255,24.521 C17.1255,20.533 20.4065,17.289 24.4385,17.289 C28.4715,17.289 31.7515,20.533 31.7515,24.521 C31.7515,28.508 28.4715,31.751 24.4385,31.751 L24.4385,31.751 Z M24.4385,15.289 C19.3035,15.289 15.1255,19.431 15.1255,24.521 C15.1255,29.61 19.3035,33.751 24.4385,33.751 C29.5735,33.751 33.7515,29.61 33.7515,24.521 C33.7515,19.431 29.5735,15.289 24.4385,15.289 L24.4385,15.289 Z M14.5005,37.002 L14.5005,10.128 L29.1265,10.125 L29.1265,14.375 C29.1265,14.928 29.5735,15.375 30.1265,15.375 L34.3765,15.375 L34.3765,37.002 L14.5005,37.002 Z M31.1265,11.539 L32.9625,13.375 L31.1265,13.375 L31.1265,11.539 Z M36.0835,13.668 L30.8335,8.418 C30.6425,8.227 30.3875,8.134 30.1265,8.134 L30.1265,8.125 L13.5005,8.128 C12.9475,8.128 12.5005,8.576 12.5005,9.128 L12.5005,38.002 C12.5005,38.555 12.9475,39.002 13.5005,39.002 L35.3765,39.002 C35.9295,39.002 36.3765,38.555 36.3765,38.002 L36.3765,14.375 L36.3675,14.375 C36.3675,14.115 36.2745,13.859 36.0835,13.668 L36.0835,13.668 Z" id="AWS-Elastic-Load-Balancing_Classic-Load-Balancer_Resource-Icon_light-bg" fill="#8C4FFF"></path>
    </g>
</svg>`, ER = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Networking-and-Content-Delivery/Res_Amazon-Route-53_Resolver_48</title>
    <g id="Icon-Resource/Networking-and-Content-Delivery/Res_Amazon-Route-53_Resolver_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M32.978,32.012 C31.324,32.012 29.978,30.666 29.978,29.012 C29.978,27.358 31.324,26.012 32.978,26.012 C34.632,26.012 35.978,27.358 35.978,29.012 C35.978,30.666 34.632,32.012 32.978,32.012 M20.978,17.012 C20.978,15.358 22.324,14.012 23.978,14.012 C25.632,14.012 26.978,15.358 26.978,17.012 C26.978,18.666 25.632,20.012 23.978,20.012 C22.324,20.012 20.978,18.666 20.978,17.012 M14.978,32.012 C13.324,32.012 11.978,30.666 11.978,29.012 C11.978,27.358 13.324,26.012 14.978,26.012 C16.632,26.012 17.978,27.358 17.978,29.012 C17.978,30.666 16.632,32.012 14.978,32.012 M32.978,24.012 C32.23,24.012 31.527,24.189 30.889,24.484 L27.717,20.297 C28.492,19.416 28.978,18.275 28.978,17.012 C28.978,14.255 26.735,12.012 23.978,12.012 C21.221,12.012 18.978,14.255 18.978,17.012 C18.978,18.204 19.415,19.286 20.115,20.147 L16.895,24.397 C16.304,24.151 15.657,24.012 14.978,24.012 C12.221,24.012 9.978,26.255 9.978,29.012 C9.978,31.769 12.221,34.012 14.978,34.012 C17.735,34.012 19.978,31.769 19.978,29.012 C19.978,27.655 19.43,26.426 18.549,25.524 L21.662,21.416 C22.358,21.784 23.138,22.012 23.978,22.012 C24.749,22.012 25.472,21.822 26.125,21.508 L29.282,25.675 C28.48,26.562 27.978,27.725 27.978,29.012 C27.978,31.769 30.221,34.012 32.978,34.012 C35.735,34.012 37.978,31.769 37.978,29.012 C37.978,26.255 35.735,24.012 32.978,24.012 M34.055,39.447 C29.392,40.284 25.46,42.741 23.993,43.752 C22.525,42.741 18.592,40.284 13.929,39.447 C11.6,39.028 4,37.17 4,30.821 C4,28.168 5.004,26.439 6.067,24.608 C7.065,22.889 8.096,21.112 8.096,18.68 C8.096,15.017 6.071,12.384 4.941,11.2 C6.095,9.797 8.634,6.699 10.027,4.917 C12.148,6.85 14.595,7.902 17.019,7.902 C19.719,7.902 21.96,6.837 23.993,4.569 C26.024,6.837 28.265,7.902 30.965,7.902 C33.389,7.902 35.836,6.85 37.957,4.917 C39.35,6.699 41.889,9.797 43.043,11.2 C41.914,12.384 39.888,15.017 39.888,18.68 C39.888,21.112 40.919,22.889 41.917,24.608 C42.98,26.439 43.984,28.168 43.984,30.821 C43.984,37.17 36.384,39.028 34.055,39.447 M43.647,23.604 C42.704,21.978 41.888,20.574 41.888,18.68 C41.888,14.682 45.007,12.085 45.037,12.061 C45.244,11.893 45.375,11.649 45.403,11.383 C45.429,11.117 45.349,10.852 45.179,10.646 C45.127,10.584 40.035,4.413 38.872,2.818 C38.697,2.577 38.422,2.428 38.124,2.409 C37.842,2.388 37.537,2.506 37.333,2.724 C35.416,4.774 33.155,5.902 30.965,5.902 C28.549,5.902 26.644,4.82 24.787,2.392 C24.597,2.145 24.304,2 23.993,2 C23.681,2 23.388,2.145 23.199,2.392 C21.34,4.82 19.434,5.902 17.019,5.902 C14.83,5.902 12.568,4.774 10.651,2.724 C10.448,2.506 10.14,2.387 9.86,2.409 C9.562,2.428 9.288,2.577 9.113,2.818 C7.95,4.413 2.857,10.584 2.805,10.646 C2.636,10.851 2.557,11.116 2.582,11.381 C2.609,11.646 2.74,11.89 2.946,12.059 C2.977,12.085 6.096,14.682 6.096,18.68 C6.096,20.574 5.281,21.978 4.337,23.604 C3.242,25.491 2,27.63 2,30.821 C2,36.153 6.328,40.113 13.576,41.415 C18.889,42.369 23.339,45.743 23.384,45.777 C23.563,45.914 23.778,45.983 23.993,45.983 C24.207,45.983 24.422,45.914 24.601,45.777 C24.646,45.743 29.096,42.369 34.409,41.415 C41.657,40.113 45.984,36.153 45.984,30.821 C45.984,27.63 44.743,25.491 43.647,23.604" id="Fill-1" fill="#8C4FFF"></path>
    </g>
</svg>`, IR = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Networking-and-Content-Delivery/Res_AWS-Cloud-WAN_Core-Network-Edge_48</title>
    <g id="Icon-Resource/Networking-and-Content-Delivery/Res_AWS-Cloud-WAN_Core-Network-Edge_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M42,26 C40.897,26 40,25.103 40,24 C40,22.897 40.897,22 42,22 C43.103,22 44,22.897 44,24 C44,25.103 43.103,26 42,26 M25,36.949 L25,30.92 C28.059,30.479 30.479,28.059 30.92,25 L36.949,25 C36.461,31.37 31.37,36.461 25,36.949 M24,44 C22.897,44 22,43.103 22,42 C22,40.897 22.897,40 24,40 C25.103,40 26,40.897 26,42 C26,43.103 25.103,44 24,44 M11.051,25 L17.08,25 C17.521,28.059 19.941,30.479 23,30.92 L23,36.949 C16.63,36.461 11.539,31.37 11.051,25 M23,11.051 L23,17.08 C19.941,17.521 17.521,19.941 17.08,23 L11.051,23 C11.539,16.63 16.63,11.539 23,11.051 M24,4 C25.103,4 26,4.897 26,6 C26,7.103 25.103,8 24,8 C22.897,8 22,7.103 22,6 C22,4.897 22.897,4 24,4 M24,29 C21.243,29 19,26.757 19,24 C19,21.243 21.243,19 24,19 C26.757,19 29,21.243 29,24 C29,26.757 26.757,29 24,29 M36.949,23 L30.92,23 C30.479,19.941 28.059,17.521 25,17.08 L25,11.051 C31.37,11.539 36.461,16.63 36.949,23 M6,26 C4.897,26 4,25.103 4,24 C4,22.897 4.897,22 6,22 C7.103,22 8,22.897 8,24 C8,25.103 7.103,26 6,26 M42,20 C40.683,20 39.524,20.647 38.794,21.631 C37.777,15.258 32.742,10.223 26.369,9.206 C27.353,8.476 28,7.316 28,6 C28,3.794 26.206,2 24,2 C21.794,2 20,3.794 20,6 C20,7.316 20.647,8.476 21.631,9.206 C15.258,10.223 10.223,15.258 9.206,21.631 C8.476,20.647 7.317,20 6,20 C3.794,20 2,21.794 2,24 C2,26.206 3.794,28 6,28 C7.317,28 8.476,27.353 9.206,26.369 C10.223,32.742 15.258,37.777 21.631,38.794 C20.647,39.524 20,40.684 20,42 C20,44.206 21.794,46 24,46 C26.206,46 28,44.206 28,42 C28,40.684 27.353,39.524 26.369,38.794 C32.742,37.777 37.777,32.742 38.794,26.369 C39.524,27.353 40.683,28 42,28 C44.206,28 46,26.206 46,24 C46,21.794 44.206,20 42,20" id="Fill-1" fill="#8C4FFF"></path>
    </g>
</svg>`, FR = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Networking-and-Content-Delivery/Res_AWS-App-Mesh_Virtual-Service_48</title>
    <g id="Icon-Resource/Networking-and-Content-Delivery/Res_AWS-App-Mesh_Virtual-Service_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M43.2422,35.9375 C42.6522,36.5275 41.6952,36.5275 41.1052,35.9375 C40.8202,35.6525 40.6632,35.2735 40.6632,34.8705 C40.6632,34.4655 40.8202,34.0865 41.1052,33.8015 C41.4002,33.5065 41.7872,33.3605 42.1742,33.3605 C42.5602,33.3605 42.9472,33.5065 43.2422,33.8015 C43.8312,34.3905 43.8312,35.3485 43.2422,35.9375 L43.2422,35.9375 Z M30.9582,42.5835 C30.3882,43.1545 29.3942,43.1565 28.8222,42.5835 C28.2332,41.9955 28.2332,41.0365 28.8222,40.4475 C29.1162,40.1535 29.5042,40.0055 29.8902,40.0055 C30.2772,40.0055 30.6642,40.1535 30.9582,40.4475 C31.5472,41.0365 31.5472,41.9955 30.9582,42.5835 L30.9582,42.5835 Z M21.3322,36.9955 C21.2522,36.1925 20.9162,35.4455 20.3392,34.8685 C19.9602,34.4885 19.4962,34.2305 19.0002,34.0685 L19.0002,27.8635 C19.4882,27.6955 19.9492,27.4295 20.3392,27.0415 C21.7082,25.6715 21.7082,23.4455 20.3392,22.0765 C18.9692,20.7065 16.7432,20.7085 15.3752,22.0765 C14.0062,23.4455 14.0062,25.6715 15.3752,27.0415 C15.8402,27.5055 16.4052,27.7985 17.0002,27.9485 L17.0002,33.9865 C16.3962,34.1295 15.8262,34.4165 15.3752,34.8685 C14.7962,35.4475 14.4612,36.1965 14.3812,36.9995 L9.0002,36.9995 L9.0002,9.0005 L29.0002,9.0005 L29.0002,13.4915 C28.4092,13.6375 27.8512,13.9185 27.4082,14.3635 C26.7452,15.0255 26.3802,15.9075 26.3802,16.8445 C26.3802,17.7835 26.7452,18.6655 27.4082,19.3275 C27.8542,19.7735 28.4042,20.0715 29.0002,20.2275 L29.0002,26.1835 C28.4182,26.3355 27.8642,26.6245 27.4082,27.0805 C26.0392,28.4495 26.0392,30.6755 27.4082,32.0445 C27.8542,32.4925 28.4042,32.7905 29.0002,32.9455 L29.0002,38.1365 C28.4182,38.2895 27.8642,38.5785 27.4082,39.0335 C27.2442,39.1975 27.1022,39.3755 26.9772,39.5605 L21.3322,36.9955 Z M18.9252,25.6265 C18.3352,26.2135 17.3792,26.2155 16.7892,25.6265 C16.2002,25.0385 16.2002,24.0795 16.7892,23.4905 C17.0842,23.1965 17.4712,23.0485 17.8562,23.0485 C18.2432,23.0485 18.6302,23.1965 18.9252,23.4905 C19.5132,24.0795 19.5132,25.0385 18.9252,25.6265 L18.9252,25.6265 Z M18.9252,38.4175 C18.3562,38.9885 17.3612,38.9905 16.7892,38.4175 C16.5042,38.1325 16.3462,37.7535 16.3462,37.3505 C16.3462,36.9475 16.5042,36.5675 16.7892,36.2825 C17.0742,35.9975 17.4532,35.8395 17.8562,35.8395 C18.2612,35.8395 18.6392,35.9975 18.9252,36.2825 C19.2102,36.5675 19.3672,36.9465 19.3672,37.3505 C19.3672,37.7535 19.2102,38.1325 18.9252,38.4175 L18.9252,38.4175 Z M4.0002,32.9995 L4.0002,5.0005 L24.0002,5.0005 L24.0002,7.0005 L7.0002,7.0005 L7.0002,32.9995 L4.0002,32.9995 Z M30.9582,17.9135 C30.3882,18.4835 29.3922,18.4835 28.8222,17.9135 C28.5372,17.6275 28.3802,17.2495 28.3802,16.8445 C28.3802,16.4415 28.5372,16.0625 28.8222,15.7775 C29.1072,15.4925 29.4862,15.3345 29.8892,15.3345 C30.2942,15.3345 30.6732,15.4925 30.9582,15.7775 C31.2432,16.0625 31.4002,16.4415 31.4002,16.8445 C31.4002,17.2495 31.2432,17.6275 30.9582,17.9135 L30.9582,17.9135 Z M30.9582,30.6305 C30.3882,31.2015 29.3942,31.2025 28.8222,30.6305 C28.2332,30.0415 28.2332,29.0835 28.8222,28.4945 C29.1162,28.2005 29.5042,28.0525 29.8902,28.0525 C30.2772,28.0525 30.6642,28.2005 30.9582,28.4945 C31.5472,29.0835 31.5472,30.0415 30.9582,30.6305 L30.9582,30.6305 Z M41.1052,20.3025 C41.3992,20.0085 41.7862,19.8615 42.1742,19.8615 C42.5602,19.8615 42.9472,20.0085 43.2422,20.3025 C43.8302,20.8915 43.8302,21.8505 43.2422,22.4395 C42.6522,23.0275 41.6952,23.0275 41.1052,22.4395 C40.5162,21.8505 40.5162,20.8915 41.1052,20.3025 L41.1052,20.3025 Z M44.6562,32.3875 C43.2872,31.0185 41.0602,31.0185 39.6912,32.3875 C39.0282,33.0495 38.6632,33.9315 38.6632,34.8705 C38.6632,35.2335 38.7332,35.5825 38.8392,35.9185 L32.8872,39.7075 C32.7422,39.4685 32.5782,39.2395 32.3722,39.0335 C31.9742,38.6345 31.5012,38.3675 31.0002,38.2015 L31.0002,32.8785 C31.5102,32.7085 31.9812,32.4355 32.3722,32.0445 C33.1932,31.2235 33.5122,30.0935 33.3472,29.0255 L40.0532,24.1485 C40.6792,24.6255 41.4222,24.8785 42.1742,24.8785 C43.0722,24.8785 43.9712,24.5375 44.6562,23.8535 C46.0242,22.4845 46.0242,20.2575 44.6562,18.8885 C43.2872,17.5195 41.0582,17.5195 39.6912,18.8885 C38.7072,19.8735 38.4432,21.2985 38.8752,22.5335 L32.4652,27.1945 C32.4312,27.1585 32.4082,27.1155 32.3722,27.0805 C31.9742,26.6815 31.5012,26.4145 31.0002,26.2475 L31.0002,20.1615 C31.5102,19.9915 31.9812,19.7185 32.3722,19.3275 C33.0352,18.6655 33.4002,17.7835 33.4002,16.8445 C33.4002,15.9075 33.0352,15.0255 32.3722,14.3635 C31.9842,13.9755 31.5082,13.7145 31.0002,13.5535 L31.0002,7.0005 L26.0002,7.0005 L26.0002,2.9995 L2.0002,2.9995 L2.0002,35.0005 L7.0002,35.0005 L7.0002,39.0005 L14.7752,39.0005 C14.9372,39.2995 15.1272,39.5845 15.3752,39.8325 C16.0382,40.4955 16.9192,40.8605 17.8562,40.8605 C18.7952,40.8605 19.6772,40.4955 20.3392,39.8325 C20.5842,39.5875 20.7722,39.3055 20.9322,39.0095 L26.3842,41.4875 C26.3772,42.3955 26.7172,43.3065 27.4082,43.9985 C28.0702,44.6615 28.9522,45.0265 29.8892,45.0265 C30.8282,45.0265 31.7102,44.6615 32.3722,43.9985 C32.9922,43.3775 33.3162,42.5805 33.3752,41.7675 L39.9642,37.5745 C40.6072,38.0995 41.3862,38.3775 42.1742,38.3775 C43.0732,38.3775 43.9712,38.0365 44.6562,37.3515 C46.0252,35.9835 46.0252,33.7555 44.6562,32.3875 L44.6562,32.3875 Z" id="AWS-App-Mesh-Virtual-Service_Resource-Icon_light-bg" fill="#8C4FFF"></path>
    </g>
</svg>`, OR = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Networking-and-Content-Delivery/Res_Amazon-VPC_Flow-Logs_48</title>
    <g id="Icon-Resource/Networking-and-Content-Delivery/Res_Amazon-VPC_Flow-Logs_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M42.2071,24.708 L37.8321,29.083 L36.4181,27.669 L39.0861,25.001 L7.3751,25.001 L7.3751,23.001 L39.0861,23.001 L36.4181,20.332 L37.8321,18.918 L42.2071,23.294 C42.5981,23.685 42.5981,24.317 42.2071,24.708 L42.2071,24.708 Z M17.0001,33.751 L30.1251,33.751 L30.1251,31.751 L17.0001,31.751 L17.0001,33.751 Z M17.0001,29.376 L30.1251,29.376 L30.1251,27.376 L17.0001,27.376 L17.0001,29.376 Z M17.0001,20.625 L30.1251,20.625 L30.1251,18.625 L17.0001,18.625 L17.0001,20.625 Z M17.0001,16.25 L30.1251,16.25 L30.1251,14.25 L17.0001,14.25 L17.0001,16.25 Z M31.7501,26.626 L33.7501,26.626 L33.7501,37.126 C33.7501,37.679 33.3031,38.126 32.7501,38.126 L14.3751,38.126 C13.8221,38.126 13.3751,37.679 13.3751,37.126 L13.3751,26.626 L15.3751,26.626 L15.3751,36.126 L31.7501,36.126 L31.7501,26.626 Z M15.3751,21.375 L13.3751,21.375 L13.3751,10.875 C13.3751,10.322 13.8221,9.875 14.3751,9.875 L32.7501,9.875 C33.3031,9.875 33.7501,10.322 33.7501,10.875 L33.7501,21.375 L31.7501,21.375 L31.7501,11.875 L15.3751,11.875 L15.3751,21.375 Z M24.0001,44.001 C12.9721,44.001 4.0001,35.029 4.0001,24.001 C4.0001,12.973 12.9721,4 24.0001,4 C35.0281,4 44.0001,12.973 44.0001,24.001 C44.0001,35.029 35.0281,44.001 24.0001,44.001 L24.0001,44.001 Z M24.0001,2 C11.8691,2 2.0001,11.869 2.0001,24.001 C2.0001,36.132 11.8691,46.001 24.0001,46.001 C36.1311,46.001 46.0001,36.132 46.0001,24.001 C46.0001,11.869 36.1311,2 24.0001,2 L24.0001,2 Z" id="AWS-Amazon-VPC_Flow-logs_Resource-Icon_light-bg" fill="#8C4FFF"></path>
    </g>
</svg>`, NR = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Networking-and-Content-Delivery/Res_AWS-Cloud-Map_Resource_48</title>
    <g id="Icon-Resource/Networking-and-Content-Delivery/Res_AWS-Cloud-Map_Resource_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M36.3555,34.8279 C36.0285,34.5009 35.5985,34.3379 35.1685,34.3379 C34.7395,34.3379 34.3095,34.5009 33.9825,34.8279 C33.3285,35.4819 33.3285,36.5479 33.9825,37.2019 C34.6365,37.8559 35.7015,37.8559 36.3555,37.2019 C37.0095,36.5479 37.0095,35.4819 36.3555,34.8279 M26.6535,41.2119 L26.5975,41.1239 C26.5295,41.0229 26.4535,40.9259 26.3645,40.8369 C25.9705,40.4429 25.4535,40.2459 24.9355,40.2459 C24.4175,40.2459 23.9005,40.4429 23.5065,40.8369 C22.7195,41.6239 22.7195,42.9059 23.5065,43.6929 C24.2935,44.4799 25.5775,44.4799 26.3645,43.6929 C27.0375,43.0209 27.1285,41.9899 26.6535,41.2119 M23.5065,32.0179 C24.2025,32.7139 25.3315,32.7139 26.0265,32.0179 C26.7205,31.3239 26.7205,30.1929 26.0265,29.4989 C25.6785,29.1509 25.2225,28.9779 24.7665,28.9779 C24.3105,28.9779 23.8545,29.1509 23.5065,29.4989 C22.8125,30.1929 22.8125,31.3239 23.5065,32.0179 M23.5065,20.3379 C24.2785,21.1069 25.5305,21.1069 26.3015,20.3379 C27.0715,19.5669 27.0715,18.3129 26.3015,17.5439 C25.9165,17.1589 25.4105,16.9659 24.9045,16.9659 C24.3985,16.9659 23.8925,17.1589 23.5065,17.5439 C22.7365,18.3139 22.7365,19.5669 23.5065,20.3379 M33.5095,22.8769 C33.5095,23.3069 33.6775,23.7129 33.9825,24.0169 C34.6115,24.6459 35.6345,24.6459 36.2635,24.0169 C36.8915,23.3889 36.8925,22.3649 36.2635,21.7359 C35.9595,21.4319 35.5535,21.2639 35.1235,21.2639 C34.6915,21.2639 34.2875,21.4319 33.9825,21.7359 C33.6775,22.0409 33.5095,22.4449 33.5095,22.8769 M14.1915,39.2729 C14.5405,38.9249 14.7325,38.4619 14.7325,37.9689 C14.7325,37.4759 14.5405,37.0129 14.1915,36.6639 C13.8325,36.3049 13.3595,36.1249 12.8865,36.1249 C12.4155,36.1249 11.9425,36.3049 11.5835,36.6639 C10.8645,37.3839 10.8645,38.5549 11.5835,39.2729 C12.3025,39.9929 13.4735,39.9909 14.1915,39.2729 M11.5835,26.7789 C12.2335,27.4299 13.2935,27.4299 13.9445,26.7789 C14.2595,26.4639 14.4335,26.0449 14.4335,25.5989 C14.4335,25.1519 14.2595,24.7329 13.9445,24.4179 C13.6285,24.1019 13.2095,23.9289 12.7635,23.9289 C12.3175,23.9289 11.8985,24.1019 11.5835,24.4179 C10.9315,25.0689 10.9315,26.1279 11.5835,26.7789 M37.7695,33.4139 C39.2045,34.8489 39.2045,37.1819 37.7695,38.6159 C37.0525,39.3329 36.1105,39.6909 35.1685,39.6909 C34.3395,39.6909 33.5175,39.3959 32.8415,38.8389 L28.8335,41.3369 C29.1435,42.6489 28.8005,44.0859 27.7785,45.1069 C26.9945,45.8909 25.9645,46.2829 24.9355,46.2829 C23.9065,46.2829 22.8765,45.8909 22.0925,45.1069 C21.4555,44.4699 21.0915,43.6689 20.9725,42.8389 L15.7775,40.4779 C15.7175,40.5469 15.6695,40.6229 15.6055,40.6869 C14.8565,41.4369 13.8725,41.8109 12.8875,41.8109 C11.9025,41.8109 10.9185,41.4369 10.1685,40.6869 C8.6695,39.1889 8.6695,36.7499 10.1685,35.2499 C10.6895,34.7289 11.3285,34.4009 11.9975,34.2419 L11.9975,29.1829 C11.3095,29.0379 10.6765,28.7019 10.1685,28.1929 C9.4755,27.5009 9.0945,26.5789 9.0945,25.5989 C9.0945,24.6179 9.4755,23.6959 10.1685,23.0039 C11.5535,21.6169 13.9715,21.6169 15.3585,23.0039 C16.0515,23.6969 16.4335,24.6179 16.4335,25.5989 C16.4335,26.5789 16.0515,27.5009 15.3585,28.1929 C14.9685,28.5829 14.5015,28.8619 13.9975,29.0419 L13.9975,34.3069 C14.5845,34.4829 15.1425,34.7859 15.6055,35.2499 C16.3325,35.9759 16.7325,36.9419 16.7325,37.9689 C16.7325,38.2119 16.7065,38.4499 16.6625,38.6839 L21.2105,40.7509 C21.4075,40.2669 21.7015,39.8139 22.0925,39.4229 C22.6365,38.8799 23.2995,38.5369 23.9975,38.3699 L23.9975,34.4549 C23.2985,34.3109 22.6325,33.9739 22.0925,33.4319 C20.6185,31.9579 20.6185,29.5589 22.0925,28.0849 C22.6325,27.5439 23.2985,27.2059 23.9975,27.0609 L23.9975,22.7989 C23.2995,22.6359 22.6355,22.2949 22.0925,21.7519 C20.5425,20.2019 20.5425,17.6799 22.0925,16.1299 C23.6435,14.5789 26.1655,14.5789 27.7155,16.1299 C29.2655,17.6799 29.2655,20.2009 27.7155,21.7519 C27.2215,22.2459 26.6255,22.5639 25.9975,22.7439 L25.9975,27.1979 C26.3685,27.3259 26.7185,27.5149 27.0425,27.7609 L31.7505,24.1509 C31.5975,23.7479 31.5095,23.3199 31.5095,22.8769 C31.5095,21.9109 31.8855,21.0039 32.5685,20.3219 C33.9315,18.9579 36.3125,18.9559 37.6775,20.3219 C39.0855,21.7299 39.0855,24.0219 37.6775,25.4319 C36.9735,26.1359 36.0475,26.4869 35.1225,26.4869 C34.3555,26.4869 33.5955,26.2309 32.9555,25.7469 L28.2715,29.3389 C28.8225,30.7039 28.5445,32.3269 27.4405,33.4319 C27.0215,33.8519 26.5235,34.1379 25.9975,34.3189 L25.9975,38.4069 C26.6485,38.5849 27.2675,38.9119 27.7785,39.4229 C27.8225,39.4679 27.8535,39.5189 27.8945,39.5649 L31.7015,37.1939 C31.2665,35.9099 31.5465,34.4359 32.5685,33.4139 C34.0015,31.9799 36.3355,31.9799 37.7695,33.4139 M45.9955,22.5379 C45.9955,28.8599 40.7485,30.9129 37.9745,31.1149 L37.9015,30.1179 L37.8255,29.1209 C38.0775,29.1009 43.9955,28.5639 43.9955,22.5379 C43.9955,17.4839 39.7395,16.2069 37.9095,15.8909 C37.3745,15.7999 37.0095,15.2959 37.0895,14.7589 C37.0915,12.5619 36.1675,10.9629 34.5535,10.4319 C33.1295,9.9659 31.5685,10.4819 30.6605,11.7169 C30.4405,12.0159 30.0785,12.1619 29.7075,12.1129 C29.3405,12.0579 29.0345,11.8059 28.9115,11.4569 C28.2825,9.6729 27.3745,8.1759 26.2105,7.0059 C24.7855,5.5719 20.8705,2.4889 15.3575,4.8339 C12.1715,6.1869 9.6755,10.0889 9.6755,13.7149 L9.7515,14.9819 C9.7805,15.4599 9.4655,15.8909 9.0015,16.0099 C7.1335,16.4889 4.0005,17.9659 4.0005,22.4739 C4.0005,25.8629 5.8335,27.7299 7.3705,28.7009 L6.3035,30.3919 C4.6965,29.3779 2.0005,27.0009 2.0005,22.4739 C2.0005,17.1199 5.5315,15.0679 7.7095,14.3119 L7.6775,13.7729 C7.6755,9.2729 10.6425,4.6639 14.5765,2.9929 C19.1795,1.0349 24.0625,2.0089 27.6285,5.5959 C28.6725,6.6449 29.5395,7.9059 30.2135,9.3569 C31.6215,8.3059 33.4625,7.9699 35.1775,8.5319 C37.4345,9.2739 38.8535,11.3259 39.0645,14.0919 C42.5515,14.9559 45.9955,17.5559 45.9955,22.5379" id="AWS-Cloud-Map-Resource_Resource-Icon_light-bg" fill="#8C4FFF"></path>
    </g>
</svg>`, DR = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Networking-and-Content-Delivery/Res_AWS-Direct-Connect_Gateway_48</title>
    <g id="Icon-Resource/Networking-and-Content-Delivery/Res_AWS-Direct-Connect_Gateway_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <polygon id="AWS-Direct-Connect-Gateway_Resource-Icon_light-bg" fill="#8C4FFF" points="24.279 2 5.779 12.68 6.778 14.413 23.278 4.886 23.278 22.938 7.328 22.938 11.485 18.781 10.072 17.367 3 24.437 10.072 31.507 11.485 30.094 6.328 24.937 23.278 24.937 23.278 42.992 6.778 33.466 5.779 35.198 24.279 45.879 42.778 35.198 41.779 33.466 25.279 42.992 25.279 24.937 41.999 24.937 37.402 29.536 38.816 30.949 45.886 23.879 38.816 16.808 37.402 18.222 42.116 22.938 25.279 22.938 25.279 4.886 41.779 14.413 42.778 12.68"></polygon>
    </g>
</svg>`, PR = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Networking-and-Content-Delivery/Res_Amazon-VPC_Network-Access-Analyzer_48</title>
    <g id="Icon-Resource/Networking-and-Content-Delivery/Res_Amazon-VPC_Network-Access-Analyzer_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M37,39.121 L42,39.121 L42,37.121 L37,37.121 L37,39.121 Z M32,41.121 C32.023,41.121 32.047,41.12 32.071,41.118 C32.36,41.098 32.626,40.953 32.8,40.721 L35.8,36.721 L34.2,35.521 L31.892,38.598 L30.707,37.414 L29.293,38.828 L31.293,40.828 C31.481,41.016 31.735,41.121 32,41.121 L32,41.121 Z M37,32.121 L42,32.121 L42,30.121 L37,30.121 L37,32.121 Z M32,34.121 C32.023,34.121 32.047,34.12 32.071,34.118 C32.36,34.098 32.626,33.953 32.8,33.721 L35.8,29.721 L34.2,28.521 L31.892,31.598 L30.707,30.414 L29.293,31.828 L31.293,33.828 C31.481,34.016 31.735,34.121 32,34.121 L32,34.121 Z M28,43.993 L44,43.993 L44,24.993 L28,24.993 L28,43.993 Z M46,23.993 L46,44.993 C46,45.545 45.553,45.993 45,45.993 L27,45.993 C26.447,45.993 26,45.545 26,44.993 L26,23.993 C26,23.441 26.447,22.993 27,22.993 L45,22.993 C45.553,22.993 46,23.441 46,23.993 L46,23.993 Z M20,25.993 C20.256,25.993 20.512,25.895 20.707,25.7 L23.707,22.7 L22.293,21.286 L21,22.579 L21,13.407 L22.293,14.7 L23.707,13.286 L20.707,10.286 C20.316,9.895 19.684,9.895 19.293,10.286 L16.293,13.286 L17.707,14.7 L19,13.407 L19,22.579 L17.707,21.286 L16.293,22.7 L19.293,25.7 C19.488,25.895 19.744,25.993 20,25.993 L20,25.993 Z M14.707,21.7 L17.707,18.7 C18.098,18.309 18.098,17.677 17.707,17.286 L14.707,14.286 L13.293,15.7 L14.586,16.993 L11,16.993 L11,18.993 L14.586,18.993 L13.293,20.286 L14.707,21.7 Z M25.414,18.993 L29,18.993 L29,16.993 L25.414,16.993 L26.707,15.7 L25.293,14.286 L22.293,17.286 C21.902,17.677 21.902,18.309 22.293,18.7 L25.293,21.7 L26.707,20.286 L25.414,18.993 Z M12,28.993 L24,28.993 L24,30.993 L12,30.993 C11.49,30.993 11.039,30.997 10.635,31 C10.315,31.003 10.021,31.005 9.748,31.005 C8.272,31.005 7.389,30.935 6.396,30.447 C4.368,29.45 2,26.764 2,22.475 C2,17.122 5.532,15.07 7.71,14.313 L7.679,13.774 C7.677,9.274 10.644,4.664 14.578,2.993 C19.185,1.035 24.066,2.008 27.632,5.596 C28.677,6.646 29.543,7.907 30.218,9.357 C31.626,8.306 33.469,7.971 35.182,8.533 C37.443,9.276 38.864,11.335 39.069,14.11 C41.577,14.828 45.002,17.006 45.97,20.878 L44.03,21.364 C43.083,17.577 39.294,16.13 37.913,15.892 C37.377,15.8 37.014,15.296 37.094,14.759 C37.096,12.562 36.171,10.963 34.558,10.433 C33.14,9.967 31.572,10.483 30.662,11.717 C30.443,12.014 30.07,12.168 29.71,12.113 C29.344,12.058 29.037,11.805 28.914,11.456 C28.287,9.674 27.378,8.177 26.214,7.006 C24.788,5.572 20.878,2.49 15.359,4.833 C12.173,6.187 9.677,10.089 9.677,13.716 L9.753,14.983 C9.781,15.461 9.467,15.891 9.004,16.011 C7.135,16.49 4,17.968 4,22.475 C4,25.845 5.766,27.909 7.278,28.652 C7.997,29.006 8.604,29.016 10.618,29 C11.027,28.997 11.484,28.993 12,28.993 L12,28.993 Z" id="Fill-1" fill="#8C4FFF"></path>
    </g>
</svg>`, BR = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Networking-and-Content-Delivery/Res_Elastic-Load-Balancing_Application-Load-Balancer_48</title>
    <g id="Icon-Resource/Networking-and-Content-Delivery/Res_Elastic-Load-Balancing_Application-Load-Balancer_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M33.69,34.375 L36.035,34.375 L36.035,32 L33.69,32 L33.69,34.375 Z M26.751,34.375 L29.126,34.375 L29.126,32 L26.751,32 L26.751,34.375 Z M18.876,34.375 L21.251,34.375 L21.251,32 L18.876,32 L18.876,34.375 Z M11.966,34.375 L14.251,34.375 L14.251,32 L11.966,32 L11.966,34.375 Z M18.001,16.875 L30.001,16.875 L30.001,11 L18.001,11 L18.001,16.875 Z M37.035,30 L35.501,30 L35.501,26.625 C35.501,26.072 35.053,25.625 34.501,25.625 L32.001,25.625 L32.001,22.25 C32.001,21.697 31.553,21.25 31.001,21.25 L25.001,21.25 L25.001,18.875 L31.001,18.875 C31.553,18.875 32.001,18.428 32.001,17.875 L32.001,10 C32.001,9.447 31.553,9 31.001,9 L17.001,9 C16.448,9 16.001,9.447 16.001,10 L16.001,17.875 C16.001,18.428 16.448,18.875 17.001,18.875 L23.001,18.875 L23.001,21.25 L17.001,21.25 C16.448,21.25 16.001,21.697 16.001,22.25 L16.001,25.625 L13.501,25.625 C12.948,25.625 12.501,26.072 12.501,26.625 L12.501,30 L10.965,30 C10.413,30 9.965,30.447 9.965,31 L9.965,35.375 C9.965,35.928 10.413,36.375 10.965,36.375 L15.251,36.375 C15.803,36.375 16.251,35.928 16.251,35.375 L16.251,31 C16.251,30.447 15.803,30 15.251,30 L14.501,30 L14.501,27.625 L18.626,27.625 L18.626,30 L17.876,30 C17.323,30 16.876,30.447 16.876,31 L16.876,35.375 C16.876,35.928 17.323,36.375 17.876,36.375 L22.251,36.375 C22.803,36.375 23.251,35.928 23.251,35.375 L23.251,31 C23.251,30.447 22.803,30 22.251,30 L20.626,30 L20.626,26.625 C20.626,26.072 20.178,25.625 19.626,25.625 L18.001,25.625 L18.001,23.25 L30.001,23.25 L30.001,25.625 L28.376,25.625 C27.823,25.625 27.376,26.072 27.376,26.625 L27.376,30 L25.751,30 C25.198,30 24.751,30.447 24.751,31 L24.751,35.375 C24.751,35.928 25.198,36.375 25.751,36.375 L30.126,36.375 C30.678,36.375 31.126,35.928 31.126,35.375 L31.126,31 C31.126,30.447 30.678,30 30.126,30 L29.376,30 L29.376,27.625 L33.501,27.625 L33.501,30 L32.69,30 C32.137,30 31.69,30.447 31.69,31 L31.69,35.375 C31.69,35.928 32.137,36.375 32.69,36.375 L37.035,36.375 C37.587,36.375 38.035,35.928 38.035,35.375 L38.035,31 C38.035,30.447 37.587,30 37.035,30 L37.035,30 Z M24.001,44 C12.972,44 4,35.028 4,24 C4,12.972 12.972,4 24.001,4 C35.029,4 44.001,12.972 44.001,24 C44.001,35.028 35.029,44 24.001,44 L24.001,44 Z M24.001,2 C11.869,2 2,11.869 2,24 C2,36.131 11.869,46 24.001,46 C36.131,46 46.001,36.131 46.001,24 C46.001,11.869 36.131,2 24.001,2 L24.001,2 Z" id="AWS-Elastic-Load-Balancing_-Application-Load-Balancer_Resource-Icon_light-bg" fill="#8C4FFF"></path>
    </g>
</svg>`, Wi = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Networking-and-Content-Delivery/Res_Amazon-VPC_Virtual-private-cloud-VPC_48</title>
    <g id="Icon-Resource/Networking-and-Content-Delivery/Res_Amazon-VPC_Virtual-private-cloud-VPC_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M40,25.976844 L36.499,24.507844 L36.499,38.877844 C39.906,38.147844 39.998,34.179844 40,33.994844 L40,25.976844 Z M34.499,38.922844 L34.499,24.507844 L31,25.976844 L31,34.003844 C31.008,34.465844 31.183,38.338844 34.499,38.922844 L34.499,38.922844 Z M35.112,22.081844 C35.358,21.976844 35.638,21.977844 35.886,22.080844 L41.387,24.389844 C41.759,24.545844 42,24.908844 42,25.311844 L42,34.003844 C41.978,36.430844 40.562,41.003844 35.37,41.003844 C30.393,41.003844 29.026,36.431844 29,34.014844 L29,25.311844 C29,24.908844 29.241,24.545844 29.613,24.389844 L35.112,22.081844 Z M44,22.791844 L35.492,19.091844 L26.9998912,22.667844 L26.9998912,33.024844 C26.999,33.089844 26.963,38.008844 29.807,40.893844 C31.187,42.293844 33.059,43.003844 35.37,43.003844 C43.808,43.003844 43.996,33.424844 44,33.017844 L44,22.791844 Z M46,22.135844 L46,33.024844 C45.973,37.172844 43.716,45.003844 35.37,45.003844 C32.498,45.003844 30.145,44.089844 28.373,42.287844 C24.941,38.796844 24.996,33.242844 25,33.007844 L25,22.003844 C25,21.601844 25.241,21.237844 25.612,21.081844 L35.111,17.081844 C35.363,16.975844 35.647,16.977844 35.897,17.086844 L45.398,21.218844 C45.764,21.377844 46,21.737844 46,22.135844 L46,22.135844 Z M11,30.003844 L22,30.003844 L22,32.003844 L11,32.003844 C6.216,32.003844 2.271,28.482844 2.02,23.987844 C2.002,23.812844 2,23.598844 2,23.384844 C2,18.085844 5.654,16.037844 7.919,15.277844 C7.902,15.062844 7.891,14.842844 7.891,14.625844 C7.891,10.038844 10.658,5.70084404 14.621,4.07884404 C19.58,2.04984404 25.235,2.93684404 28.695,6.28484404 C29.718,7.28184404 30.604,8.59584404 31.343,10.205844 C32.299,9.42184404 33.392,9.00384404 34.523,9.00384404 C37.234,9.00384404 40.281,11.295844 40.9,15.061844 C43.069,15.343844 44.936,16.638844 45.896,18.581844 L44.104,19.468844 C43.34,17.924844 41.806,17.003844 40,17.003844 C39.471,17.003844 39.033,16.590844 39.002,16.062844 C38.807,12.761844 36.275,11.003844 34.523,11.003844 C33.55,11.003844 32.582,11.573844 31.797,12.607844 C31.575,12.898844 31.217,13.049844 30.852,12.992844 C30.49,12.937844 30.187,12.690844 30.062,12.347844 C29.327,10.345844 28.398,8.78884404 27.302,7.71984404 C24.407,4.91684404 19.614,4.19584404 15.379,5.92984404 C11.775,7.40484404 9.891,11.420844 9.891,14.625844 C9.891,15.025844 9.947,15.502844 9.993,15.885844 C10.053,16.385844 9.73,16.852844 9.24,16.974844 C7.283,17.458844 4,18.936844 4,23.384844 C4,23.534844 3.998,23.684844 4.013,23.835844 C4.209,27.311844 7.276,30.003844 11,30.003844 L11,30.003844 Z" id="Fill-1" fill="#8C4FFF"></path>
    </g>
</svg>`, zR = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Networking-and-Content-Delivery/Res_Amazon-VPC_Carrier-Gateway_48</title>
    <g id="Icon-Resource/Networking-and-Content-Delivery/Res_Amazon-VPC_Carrier-Gateway_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M28.95,19.05 C30.271,20.372 31,22.13 31,24 C31,25.869 30.271,27.627 28.95,28.949 L30.364,30.363 C32.064,28.663 33,26.404 33,24 C33,21.596 32.064,19.336 30.364,17.636 L28.95,19.05 Z M25,38.22 L25,30.5 L23,30.5 L23,38.223 L18.964,33.88 L17.865,34.903 L23.998,41.5 L30.133,34.903 L29.035,33.88 L25,38.22 Z M44,24 C44,12.972 35.028,4 24,4 C12.971,4 4,12.972 4,24 C4,35.028 12.971,44 24,44 C35.028,44 44,35.028 44,24 L44,24 Z M46,24 C46,36.131 36.131,46 24,46 C11.869,46 2,36.131 2,24 C2,11.869 11.869,2 24,2 C36.131,2 46,11.869 46,24 L46,24 Z M34.606,13.393 L33.192,14.807 C35.647,17.263 37,20.528 37,24 C37,27.472 35.647,30.737 33.192,33.192 L34.606,34.606 C37.439,31.773 39,28.006 39,24 C39,19.993 37.439,16.226 34.606,13.393 L34.606,13.393 Z M17,24 C17,22.13 17.728,20.372 19.05,19.05 L17.636,17.636 C15.935,19.336 15,21.596 15,24 C15,26.404 15.935,28.663 17.636,30.363 L19.05,28.949 C17.728,27.627 17,25.869 17,24 L17,24 Z M24,22 C22.897,22 22,22.897 22,24 C22,25.103 22.897,26 24,26 C25.102,26 26,25.103 26,24 C26,22.897 25.102,22 24,22 L24,22 Z M24,20 C26.206,20 28,21.794 28,24 C28,26.205 26.206,28 24,28 C21.794,28 20,26.205 20,24 C20,21.794 21.794,20 24,20 L24,20 Z M23,9.777 L23,17.5 L25,17.5 L25,9.779 L29.035,14.12 L30.133,13.097 L23.998,6.5 L17.865,13.097 L18.964,14.12 L23,9.777 Z M14.807,14.807 C12.352,17.263 11,20.528 11,24 C11,27.472 12.352,30.737 14.807,33.192 L13.393,34.606 C10.56,31.773 9,28.006 9,24 C9,19.993 10.56,16.226 13.393,13.393 L14.807,14.807 Z" id="Fill-1" fill="#8C4FFF"></path>
    </g>
</svg>`, UR = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Networking-and-Content-Delivery/Res_Amazon-VPC_Elastic-Network-Interface_48</title>
    <g id="Icon-Resource/Networking-and-Content-Delivery/Res_Amazon-VPC_Elastic-Network-Interface_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M22.376,25.627 L26.502,25.627 L26.502,21.501 L22.376,21.501 L22.376,25.627 Z M28.502,25.627 L32.627,25.627 L32.627,21.501 L28.502,21.501 L28.502,25.627 Z M21.376,27.627 L33.627,27.627 C34.179,27.627 34.627,27.18 34.627,26.627 L34.627,20.501 C34.627,19.948 34.179,19.501 33.627,19.501 L21.376,19.501 C20.823,19.501 20.376,19.948 20.376,20.501 L20.376,26.627 C20.376,27.18 20.823,27.627 21.376,27.627 L21.376,27.627 Z M37.877,29.127 L35.377,29.127 C34.824,29.127 34.377,29.574 34.377,30.127 L34.377,31.752 L32.002,31.752 L32.002,30.127 C32.002,29.574 31.554,29.127 31.002,29.127 L27.502,29.127 C26.949,29.127 26.502,29.574 26.502,30.127 L26.502,31.752 L19.751,31.752 L19.751,30.127 C19.751,29.574 19.303,29.127 18.751,29.127 L18.001,29.127 L18.001,18.001 L37.877,18.001 L37.877,29.127 Z M38.877,16.001 L17.001,16.001 C16.448,16.001 16.001,16.448 16.001,17.001 L16.001,30.127 C16.001,30.68 16.448,31.127 17.001,31.127 L17.751,31.127 L17.751,32.752 C17.751,33.305 18.198,33.752 18.751,33.752 L27.502,33.752 C28.054,33.752 28.502,33.305 28.502,32.752 L28.502,31.127 L30.002,31.127 L30.002,32.752 C30.002,33.305 30.449,33.752 31.002,33.752 L35.377,33.752 C35.929,33.752 36.377,33.305 36.377,32.752 L36.377,31.127 L38.877,31.127 C39.429,31.127 39.877,30.68 39.877,30.127 L39.877,17.001 C39.877,16.448 39.429,16.001 38.877,16.001 L38.877,16.001 Z M14.501,15.251 L14.501,34.502 C14.501,35.055 14.053,35.502 13.501,35.502 L10.35,35.502 L10.35,33.502 L12.501,33.502 L12.501,16.251 L10.35,16.251 L10.35,14.251 L13.501,14.251 C14.053,14.251 14.501,14.698 14.501,15.251 L14.501,15.251 Z M24.002,44.003 C12.972,44.003 4,35.03 4,24.001 C4,12.973 12.972,4 24.002,4 C35.03,4 44.002,12.973 44.002,24.001 C44.002,35.03 35.03,44.003 24.002,44.003 L24.002,44.003 Z M24.002,2 C11.87,2 2,11.869 2,24.001 C2,36.133 11.87,46.003 24.002,46.003 C36.133,46.003 46.002,36.133 46.002,24.001 C46.002,11.869 36.133,2 24.002,2 L24.002,2 Z" id="AWS-Amazon-VPC_Elastic-network-interface_Resource-Icon_light-bg" fill="#8C4FFF"></path>
    </g>
</svg>`, WR = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Networking-and-Content-Delivery/Res_AWS-Cloud-WAN_Transit-Gateway-Route-Table-Attachment_48</title>
    <g id="Icon-Resource/Networking-and-Content-Delivery/Res_AWS-Cloud-WAN_Transit-Gateway-Route-Table-Attachment_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M42,26 C40.897,26 40,25.103 40,24 C40,22.897 40.897,22 42,22 C43.103,22 44,22.897 44,24 C44,25.103 43.103,26 42,26 L42,26 Z M13,26 L35,26 L35,22 L13,22 L13,26 Z M6,26 C4.897,26 4,25.103 4,24 C4,22.897 4.897,22 6,22 C7.103,22 8,22.897 8,24 C8,25.103 7.103,26 6,26 L6,26 Z M42,20 C40.141,20 38.589,21.28 38.142,23 L37,23 L37,21 C37,20.448 36.553,20 36,20 L12,20 C11.447,20 11,20.448 11,21 L11,23 L9.858,23 C9.411,21.28 7.859,20 6,20 C3.794,20 2,21.794 2,24 C2,26.206 3.794,28 6,28 C7.859,28 9.411,26.72 9.858,25 L11,25 L11,27 C11,27.552 11.447,28 12,28 L36,28 C36.553,28 37,27.552 37,27 L37,25 L38.142,25 C38.589,26.72 40.141,28 42,28 C44.206,28 46,26.206 46,24 C46,21.794 44.206,20 42,20 L42,20 Z M13,17 L35,17 L35,13 L13,13 L13,17 Z M22,6 C22,4.897 22.897,4 24,4 C25.103,4 26,4.897 26,6 C26,7.103 25.103,8 24,8 C22.897,8 22,7.103 22,6 L22,6 Z M12,19 L36,19 C36.553,19 37,18.552 37,18 L37,12 C37,11.448 36.553,11 36,11 L25,11 L25,9.858 C26.721,9.411 28,7.858 28,6 C28,3.794 26.206,2 24,2 C21.794,2 20,3.794 20,6 C20,7.858 21.279,9.411 23,9.858 L23,11 L12,11 C11.447,11 11,11.448 11,12 L11,18 C11,18.552 11.447,19 12,19 L12,19 Z M13,35 L35,35 L35,31 L13,31 L13,35 Z M26,42 C26,43.103 25.103,44 24,44 C22.897,44 22,43.103 22,42 C22,40.897 22.897,40 24,40 C25.103,40 26,40.897 26,42 L26,42 Z M36,29 L12,29 C11.447,29 11,29.448 11,30 L11,36 C11,36.552 11.447,37 12,37 L23,37 L23,38.142 C21.279,38.589 20,40.142 20,42 C20,44.206 21.794,46 24,46 C26.206,46 28,44.206 28,42 C28,40.142 26.721,38.589 25,38.142 L25,37 L36,37 C36.553,37 37,36.552 37,36 L37,30 C37,29.448 36.553,29 36,29 L36,29 Z" id="Fill-1" fill="#8C4FFF"></path>
    </g>
</svg>`, HR = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Networking-and-Content-Delivery/Res_Amazon-Route-53_Readiness-Checks_48</title>
    <g id="Icon-Resource/Networking-and-Content-Delivery/Res_Amazon-Route-53_Readiness-Checks_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M43.983,30.82 C43.983,28.168 42.979,26.438 41.917,24.607 C40.919,22.888 39.887,21.112 39.887,18.68 C39.887,15.016 41.913,12.383 43.043,11.199 C41.888,9.796 39.349,6.698 37.957,4.916 C35.836,6.849 33.388,7.902 30.964,7.902 C28.264,7.902 26.023,6.837 23.992,4.569 C21.96,6.837 19.718,7.902 17.018,7.902 C14.594,7.902 12.147,6.849 10.026,4.916 C8.633,6.698 6.094,9.796 4.94,11.199 C6.07,12.383 8.095,15.016 8.095,18.68 C8.095,21.112 7.064,22.888 6.066,24.607 C5.004,26.438 4,28.168 4,30.82 C4,37.169 11.599,39.028 13.928,39.446 C18.591,40.284 22.524,42.74 23.992,43.752 C25.46,42.74 29.391,40.284 34.054,39.446 C36.383,39.028 43.983,37.169 43.983,30.82 L43.983,30.82 Z M45.983,30.82 C45.983,36.152 41.656,40.112 34.408,41.415 C29.095,42.369 24.645,45.742 24.6,45.777 C24.421,45.914 24.207,45.983 23.992,45.983 C23.777,45.983 23.562,45.914 23.383,45.777 C23.338,45.742 18.888,42.369 13.575,41.415 C6.327,40.112 2,36.152 2,30.82 C2,27.629 3.241,25.49 4.337,23.603 C5.28,21.977 6.095,20.573 6.095,18.68 C6.095,14.682 2.976,12.084 2.945,12.058 C2.739,11.89 2.608,11.645 2.582,11.381 C2.556,11.116 2.635,10.851 2.804,10.646 C2.856,10.584 7.949,4.413 9.112,2.818 C9.287,2.577 9.561,2.427 9.859,2.409 C10.139,2.387 10.447,2.506 10.65,2.724 C12.567,4.773 14.829,5.902 17.018,5.902 C19.433,5.902 21.339,4.819 23.198,2.392 C23.387,2.145 23.68,2 23.992,2 C24.303,2 24.596,2.145 24.786,2.392 C26.643,4.819 28.548,5.902 30.964,5.902 C33.154,5.902 35.416,4.773 37.333,2.724 C37.536,2.506 37.841,2.388 38.124,2.409 C38.421,2.427 38.696,2.577 38.871,2.818 C40.034,4.413 45.127,10.584 45.178,10.646 C45.348,10.852 45.428,11.117 45.402,11.383 C45.375,11.648 45.243,11.892 45.036,12.06 C45.006,12.084 41.887,14.682 41.887,18.68 C41.887,20.573 42.703,21.977 43.646,23.603 C44.742,25.49 45.983,27.629 45.983,30.82 L45.983,30.82 Z M34.898,16.37 L36.312,17.784 L21.828,32.269 C21.632,32.464 21.377,32.562 21.121,32.562 C20.865,32.562 20.609,32.464 20.414,32.269 L14.532,26.387 L15.946,24.973 L21.121,30.148 L34.898,16.37 Z" id="Fill-1" fill="#8C4FFF"></path>
    </g>
</svg>`, $R = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Networking-and-Content-Delivery/Res_AWS-App-Mesh_Virtual-Node_48</title>
    <g id="Icon-Resource/Networking-and-Content-Delivery/Res_AWS-App-Mesh_Virtual-Node_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M4,44 L44,44 L44,4 L4,4 L4,44 Z M45,2 L3,2 C2.447,2 2,2.447 2,3 L2,45 C2,45.553 2.447,46 3,46 L45,46 C45.553,46 46,45.553 46,45 L46,3 C46,2.447 45.553,2 45,2 L45,2 Z M8.494,16.742 C8.876,16.36 9.378,16.169 9.88,16.169 C10.382,16.169 10.884,16.36 11.266,16.742 C12.029,17.506 12.029,18.749 11.266,19.513 C10.502,20.276 9.258,20.276 8.494,19.513 C7.73,18.749 7.73,17.506 8.494,16.742 L8.494,16.742 Z M11.266,34.592 C10.502,35.355 9.258,35.355 8.494,34.592 C7.73,33.828 7.73,32.585 8.494,31.821 C8.876,31.439 9.378,31.248 9.88,31.248 C10.382,31.248 10.884,31.439 11.266,31.821 C12.029,32.585 12.029,33.828 11.266,34.592 L11.266,34.592 Z M22.68,37.156 C23.062,36.774 23.563,36.583 24.065,36.583 C24.567,36.583 25.069,36.774 25.451,37.156 C26.215,37.92 26.215,39.163 25.451,39.927 C24.687,40.69 23.443,40.69 22.68,39.927 C21.916,39.163 21.916,37.92 22.68,37.156 L22.68,37.156 Z M22.68,23.065 C23.062,22.684 23.563,22.492 24.065,22.492 C24.567,22.492 25.069,22.684 25.451,23.065 C26.215,23.829 26.215,25.072 25.451,25.836 C24.687,26.6 23.443,26.6 22.68,25.836 C21.916,25.072 21.916,23.829 22.68,23.065 L22.68,23.065 Z M22.68,8.074 C23.062,7.692 23.563,7.501 24.065,7.501 C24.567,7.501 25.069,7.692 25.451,8.074 C26.215,8.838 26.215,10.081 25.451,10.845 C24.687,11.608 23.443,11.608 22.68,10.845 C21.916,10.081 21.916,8.838 22.68,8.074 L22.68,8.074 Z M36.735,13.408 C37.117,13.026 37.618,12.836 38.12,12.836 C38.622,12.836 39.124,13.026 39.506,13.408 C40.27,14.173 40.27,15.416 39.506,16.18 C38.741,16.943 37.498,16.943 36.735,16.18 C35.972,15.416 35.972,14.172 36.735,13.408 L36.735,13.408 Z M36.735,29.321 C37.117,28.939 37.619,28.748 38.121,28.748 C38.622,28.748 39.124,28.939 39.506,29.321 C40.27,30.085 40.27,31.328 39.506,32.092 C38.741,32.856 37.498,32.854 36.735,32.092 C35.972,31.328 35.972,30.085 36.735,29.321 L36.735,29.321 Z M7.08,30.407 C5.536,31.951 5.536,34.462 7.08,36.006 C7.852,36.778 8.866,37.164 9.88,37.164 C10.894,37.164 11.908,36.778 12.68,36.006 C12.86,35.824 13.017,35.628 13.155,35.424 L20.112,38.586 C20.123,39.585 20.505,40.58 21.266,41.341 C22.037,42.113 23.052,42.499 24.065,42.499 C25.079,42.499 26.094,42.113 26.865,41.341 C27.659,40.547 28.038,39.498 28.015,38.456 L35.528,33.675 C36.271,34.323 37.19,34.664 38.121,34.664 C39.135,34.664 40.148,34.277 40.92,33.506 C42.464,31.962 42.464,29.451 40.92,27.907 C39.376,26.363 36.863,26.365 35.321,27.907 C34.21,29.02 33.911,30.629 34.401,32.021 L27.424,36.461 C27.267,36.207 27.086,35.963 26.865,35.742 C26.333,35.21 25.683,34.874 25,34.709 L25,28.283 C25.683,28.118 26.333,27.782 26.865,27.25 C27.888,26.227 28.218,24.782 27.886,23.473 L35.626,17.843 C36.352,18.437 37.231,18.752 38.121,18.752 C39.135,18.752 40.148,18.365 40.92,17.594 C42.463,16.051 42.463,13.539 40.92,11.994 C39.375,10.451 36.864,10.451 35.321,11.994 C34.177,13.139 33.886,14.814 34.438,16.234 L26.912,21.709 C26.895,21.69 26.883,21.669 26.865,21.651 C26.333,21.119 25.683,20.783 25,20.617 L25,13.292 C25.683,13.127 26.333,12.791 26.865,12.259 C28.409,10.715 28.409,8.204 26.865,6.66 C25.322,5.115 22.809,5.115 21.266,6.66 C19.722,8.204 19.722,10.715 21.266,12.259 C21.763,12.757 22.366,13.076 23,13.254 L23,20.656 C22.366,20.833 21.763,21.153 21.266,21.651 C19.722,23.195 19.722,25.706 21.266,27.25 C21.763,27.748 22.366,28.067 23,28.244 L23,34.747 C22.366,34.924 21.763,35.244 21.266,35.742 C21,36.008 20.798,36.309 20.623,36.621 L13.808,33.523 C13.896,32.406 13.532,31.26 12.68,30.407 C12.196,29.924 11.614,29.609 11,29.429 L11,21.905 C11.614,21.725 12.196,21.41 12.68,20.927 C14.224,19.383 14.224,16.872 12.68,15.328 C11.137,13.783 8.623,13.783 7.08,15.328 C5.536,16.872 5.536,19.383 7.08,20.927 C7.626,21.474 8.297,21.816 9,21.977 L9,29.357 C8.296,29.518 7.626,29.86 7.08,30.407 L7.08,30.407 Z" id="AWS-App-Mesh-Virtual-Node_Resource-Icon_light-bg" fill="#8C4FFF"></path>
    </g>
</svg>`, VR = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Networking-and-Content-Delivery/Res_Elastic-Load-Balancing_Gateway-Load-Balancer_48</title>
    <g id="Icon-Resource/Networking-and-Content-Delivery/Res_Elastic-Load-Balancing_Gateway-Load-Balancer_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M17.955,29.333 L19.369,30.747 L16.796,33.32 C16.608,33.507 16.354,33.613 16.089,33.613 C15.823,33.613 15.569,33.507 15.382,33.32 L12.809,30.747 L14.224,29.333 L15,30.109 L15,17.72 L14.14,18.58 L12.726,17.166 L15.299,14.593 C15.486,14.406 15.74,14.3 16.006,14.3 C16.271,14.3 16.525,14.406 16.713,14.593 L19.285,17.166 L17.871,18.58 L17,17.708 L17,30.288 L17.955,29.333 Z M13.87,24.705 L11.297,27.278 L9.883,25.864 L10.747,25 L5.36,25 L5.36,23 L10.75,23 L9.883,22.133 L11.297,20.719 L13.87,23.291 C14.058,23.479 14.163,23.733 14.163,23.998 C14.163,24.263 14.058,24.518 13.87,24.705 L13.87,24.705 Z M21.922,25.864 L20.508,27.278 L17.934,24.705 C17.747,24.518 17.642,24.263 17.642,23.998 C17.642,23.733 17.747,23.479 17.934,23.291 L20.508,20.719 L21.922,22.133 L21.055,23 L26.36,23 L26.36,25 L21.058,25 L21.922,25.864 Z M24,44 C12.972,44 4,35.028 4,24 C4,12.972 12.972,4 24,4 C35.028,4 44,12.972 44,24 C44,35.028 35.028,44 24,44 L24,44 Z M24,2 C11.869,2 2,11.869 2,24 C2,36.131 11.869,46 24,46 C36.131,46 46,36.131 46,24 C46,11.869 36.131,2 24,2 L24,2 Z M35,34.36 L37,34.36 L37,32.36 L35,32.36 L35,34.36 Z M38,30.36 L34,30.36 C33.447,30.36 33,30.808 33,31.36 L33,32.36 L23,32.36 L23,29.36 L21,29.36 L21,33.36 C21,33.912 21.447,34.36 22,34.36 L33,34.36 L33,35.36 C33,35.912 33.447,36.36 34,36.36 L38,36.36 C38.553,36.36 39,35.912 39,35.36 L39,31.36 C39,30.808 38.553,30.36 38,30.36 L38,30.36 Z M35,25 L37,25 L37,23 L35,23 L35,25 Z M38,21 L34,21 C33.447,21 33,21.447 33,22 L33,23 L29,23 L29,25 L33,25 L33,26 C33,26.552 33.447,27 34,27 L38,27 C38.553,27 39,26.552 39,26 L39,22 C39,21.447 38.553,21 38,21 L38,21 Z M35,15.36 L37,15.36 L37,13.36 L35,13.36 L35,15.36 Z M38,11.36 L34,11.36 C33.447,11.36 33,11.808 33,12.36 L33,13.36 L22,13.36 C21.447,13.36 21,13.808 21,14.36 L21,18.36 L23,18.36 L23,15.36 L33,15.36 L33,16.36 C33,16.912 33.447,17.36 34,17.36 L38,17.36 C38.553,17.36 39,16.912 39,16.36 L39,12.36 C39,11.808 38.553,11.36 38,11.36 L38,11.36 Z" id="Gateway-Load-Balancer_Resource-Icon_light-bg" fill="#8C4FFF"></path>
    </g>
</svg>`, GR = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Networking-and-Content-Delivery/Res_Amazon-VPC_Router_48</title>
    <g id="Icon-Resource/Networking-and-Content-Delivery/Res_Amazon-VPC_Router_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M42.8282,23 L42.8282,25 L29.3112,25 L31.9492,27.638 L30.5352,29.052 L26.1902,24.707 C25.8002,24.316 25.8002,23.684 26.1902,23.293 L30.5352,18.948 L31.9492,20.362 L29.3112,23 L42.8282,23 Z M21.8102,24.707 L17.4662,29.052 L16.0522,27.638 L18.6892,25 L5.1732,25 L5.1732,23 L18.6892,23 L16.0522,20.362 L17.4662,18.948 L21.8102,23.293 C22.2012,23.684 22.2012,24.316 21.8102,24.707 L21.8102,24.707 Z M27.6382,36.328 L29.0522,37.742 L24.7072,42.087 C24.5122,42.282 24.2562,42.38 24.0002,42.38 C23.7442,42.38 23.4882,42.282 23.2932,42.087 L18.9482,37.742 L20.3622,36.328 L23.0002,38.966 L23.0002,9.325 L20.4152,12.341 L18.8952,11.04 L23.2402,5.971 C23.6212,5.527 24.3792,5.527 24.7602,5.971 L29.1042,11.04 L27.5852,12.341 L25.0002,9.325 L25.0002,38.966 L27.6382,36.328 Z M24.0002,44 C12.9722,44 4.0002,35.028 4.0002,24 C4.0002,12.972 12.9722,4 24.0002,4 C35.0282,4 44.0002,12.972 44.0002,24 C44.0002,35.028 35.0282,44 24.0002,44 L24.0002,44 Z M24.0002,2 C11.8692,2 2.0002,11.869 2.0002,24 C2.0002,36.131 11.8692,46 24.0002,46 C36.1312,46 46.0002,36.131 46.0002,24 C46.0002,11.869 36.1312,2 24.0002,2 L24.0002,2 Z" id="AWS-Amazon-VPC_Router_Resource-Icon_light-bg" fill="#8C4FFF"></path>
    </g>
</svg>`, jR = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Networking-and-Content-Delivery/Res_AWS-App-Mesh_Mesh_48</title>
    <g id="Icon-Resource/Networking-and-Content-Delivery/Res_AWS-App-Mesh_Mesh_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M42.52125,33.852 C41.55825,34.815 39.87625,34.815 38.91425,33.852 C37.91825,32.857 37.91825,31.239 38.91425,30.244 C39.41125,29.747 40.06425,29.498 40.71725,29.498 C41.37125,29.498 42.02425,29.747 42.52125,30.244 C43.00225,30.725 43.26825,31.367 43.26825,32.048 C43.26825,32.73 43.00225,33.371 42.52125,33.852 M25.29525,43.254 C24.30125,44.248 22.68125,44.248 21.68725,43.254 C21.20625,42.773 20.94025,42.131 20.94025,41.45 C20.94025,40.768 21.20625,40.127 21.68725,39.646 C22.16825,39.164 22.80925,38.899 23.49125,38.899 C24.17225,38.899 24.81425,39.164 25.29525,39.646 C26.29025,40.64 26.29025,42.259 25.29525,43.254 M21.68725,22.737 C22.18425,22.24 22.83725,21.991 23.49125,21.991 C24.14425,21.991 24.79725,22.24 25.29525,22.737 C26.29025,23.732 26.29025,25.35 25.29525,26.345 C24.33325,27.308 22.65025,27.308 21.68725,26.345 C20.69225,25.35 20.69225,23.732 21.68725,22.737 M20.94025,6.551 C20.94025,5.87 21.20625,5.229 21.68725,4.748 C22.16825,4.266 22.80925,4 23.49125,4 C24.17225,4 24.81325,4.266 25.29525,4.748 C26.29025,5.743 26.29025,7.361 25.29525,8.356 C24.30225,9.349 22.68225,9.351 21.68725,8.356 C21.20625,7.874 20.94025,7.233 20.94025,6.551 M5.74525,36.852 C4.75025,35.857 4.75025,34.239 5.74525,33.244 C6.24225,32.747 6.89525,32.498 7.54925,32.498 C8.20325,32.498 8.85625,32.747 9.35325,33.244 C10.07325,33.963 10.26325,35.007 9.94225,35.908 L9.79225,36.238 C9.67625,36.457 9.53825,36.667 9.35325,36.852 C8.36025,37.845 6.74025,37.847 5.74525,36.852 M5.74525,15.149 C6.24225,14.652 6.89525,14.404 7.54925,14.404 C8.20325,14.404 8.85625,14.652 9.35325,15.149 C10.34725,16.144 10.34725,17.762 9.35325,18.757 C8.36025,19.75 6.74025,19.752 5.74525,18.757 C4.75025,17.762 4.75025,16.144 5.74525,15.149 M38.91425,11.149 C39.41125,10.652 40.06425,10.403 40.71725,10.403 C41.37125,10.403 42.02425,10.652 42.52125,11.149 C43.51625,12.144 43.51625,13.762 42.52125,14.757 C41.55825,15.72 39.87625,15.72 38.91425,14.757 C37.91825,13.762 37.91825,12.144 38.91425,11.149 M43.93525,28.83 C42.16225,27.054 39.27325,27.054 37.50025,28.83 C36.18125,30.148 35.84625,32.08 36.48725,33.714 L27.53625,39.41 C27.32425,38.988 27.06125,38.583 26.70925,38.232 C26.09825,37.621 25.33825,37.215 24.51625,37.026 L24.51625,28.965 C25.33825,28.776 26.09825,28.371 26.70925,27.759 C27.86225,26.607 28.25225,24.986 27.90725,23.504 L37.72925,16.361 C38.55925,17.089 39.60225,17.504 40.71725,17.504 C41.93325,17.504 43.07725,17.031 43.93525,16.171 C45.70925,14.397 45.70925,11.509 43.93525,9.735 C42.16225,7.959 39.27325,7.959 37.50025,9.735 C36.14525,11.089 35.83325,13.088 36.54525,14.749 L27.00625,21.687 C26.90825,21.565 26.82325,21.436 26.70925,21.323 C26.08425,20.698 25.32025,20.306 24.51625,20.121 L24.51625,10.971 C25.32025,10.787 26.08525,10.394 26.70925,9.77 C28.48325,7.996 28.48325,5.108 26.70925,3.333 C25.85025,2.474 24.70725,2 23.49125,2 C22.27525,2 21.13125,2.474 20.27325,3.333 C19.41425,4.192 18.94025,5.335 18.94025,6.551 C18.94025,7.767 19.41425,8.911 20.27325,9.77 C20.91125,10.408 21.69425,10.806 22.51625,10.986 L22.51625,20.106 C21.69425,20.286 20.91125,20.685 20.27325,21.323 C18.49925,23.097 18.49925,25.985 20.27325,27.759 C20.89725,28.383 21.67325,28.797 22.51625,28.981 L22.51625,37.01 C21.67325,37.194 20.89725,37.608 20.27325,38.232 C19.96125,38.542 19.72025,38.901 19.51425,39.277 L12.02025,35.867 C12.27825,34.446 11.86325,32.926 10.76725,31.83 C10.12725,31.19 9.34025,30.79 8.51625,30.612 L8.51625,21.39 C9.34125,21.212 10.12725,20.812 10.76725,20.171 C12.54125,18.397 12.54125,15.509 10.76725,13.735 C8.99225,11.961 6.10625,11.963 4.33125,13.735 C2.55625,15.509 2.55625,18.397 4.33125,20.171 C4.95425,20.794 5.71525,21.185 6.51625,21.371 L6.51625,30.631 C5.71525,30.818 4.95425,31.208 4.33125,31.83 C2.55625,33.604 2.55625,36.492 4.33125,38.266 C5.21825,39.154 6.38325,39.597 7.54925,39.597 C8.71425,39.597 9.87925,39.154 10.76725,38.266 C10.94225,38.091 11.08625,37.898 11.22725,37.703 L18.96225,41.222 C18.95925,41.298 18.94025,41.373 18.94025,41.45 C18.94025,42.665 19.41425,43.809 20.27325,44.668 C21.16025,45.555 22.32525,45.999 23.49125,45.999 C24.65625,45.999 25.82225,45.555 26.70925,44.668 C27.59425,43.784 28.03625,42.623 28.04025,41.461 L37.62025,35.365 C38.46525,36.155 39.55325,36.599 40.71725,36.599 C41.93325,36.599 43.07725,36.125 43.93525,35.266 C44.79425,34.408 45.26825,33.264 45.26825,32.048 C45.26825,30.832 44.79425,29.689 43.93525,28.83" id="AWS-App-Mesh-Mesh_Resource-Icon_light-bg" fill="#8C4FFF"></path>
    </g>
</svg>`, qR = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Networking-and-Content-Delivery/Res_Amazon-VPC_NAT-Gateway_48</title>
    <g id="Icon-Resource/Networking-and-Content-Delivery/Res_Amazon-VPC_NAT-Gateway_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M13.6255,35.9209 L13.6255,33.0829 L15.3995,34.5019 L13.6255,35.9209 Z M13.2505,30.2209 C12.9495,29.9799 12.5365,29.9329 12.1915,30.1009 C11.8465,30.2679 11.6255,30.6169 11.6255,31.0019 L11.6255,38.0019 C11.6255,38.3869 11.8465,38.7359 12.1915,38.9029 C12.3305,38.9699 12.4785,39.0019 12.6255,39.0019 C12.8485,39.0019 13.0695,38.9279 13.2505,38.7829 L17.6255,35.2829 C17.8625,35.0929 18.0005,34.8059 18.0005,34.5019 C18.0005,34.1979 17.8625,33.9109 17.6255,33.7209 L13.2505,30.2209 Z M37.2515,26.8369 L37.2515,22.9149 L39.2125,24.8759 L37.2515,26.8369 Z M41.3335,24.1689 L36.9585,19.7939 C36.6725,19.5079 36.2445,19.4219 35.8685,19.5769 C35.4945,19.7319 35.2515,20.0969 35.2515,20.5009 L35.2515,23.8759 L27.6255,23.8759 L27.6255,14.3759 C27.6255,13.8229 27.1785,13.3759 26.6255,13.3759 L18.9315,13.3759 L18.9315,15.3759 L25.6255,15.3759 L25.6255,23.8759 L18.7505,23.8759 L18.7505,25.8759 L25.6255,25.8759 L25.6255,34.3769 L18.9315,34.3769 L18.9315,36.3769 L26.6255,36.3769 C27.1785,36.3769 27.6255,35.9299 27.6255,35.3769 L27.6255,25.8759 L35.2515,25.8759 L35.2515,29.2519 C35.2515,29.6559 35.4955,30.0219 35.8685,30.1759 C35.9925,30.2279 36.1225,30.2519 36.2515,30.2519 C36.5115,30.2519 36.7675,30.1499 36.9585,29.9589 L41.3335,25.5829 C41.7245,25.1919 41.7245,24.5599 41.3335,24.1689 L41.3335,24.1689 Z M13.6255,26.2959 L13.6255,23.4569 L15.3995,24.8759 L13.6255,26.2959 Z M13.2505,20.5949 C12.9495,20.3539 12.5365,20.3079 12.1915,20.4749 C11.8465,20.6419 11.6255,20.9909 11.6255,21.3759 L11.6255,28.3769 C11.6255,28.7619 11.8465,29.1109 12.1915,29.2779 C12.3305,29.3449 12.4785,29.3769 12.6255,29.3769 C12.8485,29.3769 13.0695,29.3029 13.2505,29.1579 L17.6255,25.6569 C17.8625,25.4669 18.0005,25.1799 18.0005,24.8759 C18.0005,24.5719 17.8625,24.2849 17.6255,24.0949 L13.2505,20.5949 Z M13.6255,15.7949 L13.6255,12.9569 L15.3995,14.3759 L13.6255,15.7949 Z M13.2505,10.0949 C12.9495,9.8539 12.5365,9.8069 12.1915,9.9749 C11.8465,10.1419 11.6255,10.4909 11.6255,10.8759 L11.6255,17.8759 C11.6255,18.2609 11.8465,18.6099 12.1915,18.7769 C12.3305,18.8439 12.4785,18.8759 12.6255,18.8759 C12.8485,18.8759 13.0695,18.8019 13.2505,18.6569 L17.6255,15.1569 C17.8625,14.9669 18.0005,14.6799 18.0005,14.3759 C18.0005,14.0719 17.8625,13.7849 17.6255,13.5949 L13.2505,10.0949 Z M24.0005,44.0029 C12.9725,44.0029 3.9995,35.0299 3.9995,24.0009 C3.9995,12.9729 12.9725,3.9999 24.0005,3.9999 C35.0295,3.9999 44.0025,12.9729 44.0025,24.0009 C44.0025,35.0299 35.0295,44.0029 24.0005,44.0029 L24.0005,44.0029 Z M24.0005,1.9999 C11.8685,1.9999 1.9995,11.8689 1.9995,24.0009 C1.9995,36.1329 11.8685,46.0029 24.0005,46.0029 C36.1325,46.0029 46.0025,36.1329 46.0025,24.0009 C46.0025,11.8689 36.1325,1.9999 24.0005,1.9999 L24.0005,1.9999 Z" id="AWS-Amazon-VPC_NAT-gateway_Resource-Icon_light-bg" fill="#8C4FFF"></path>
    </g>
</svg>`, KR = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Networking-and-Content-Delivery/Res_Amazon-VPC_Network-Access-Control-List_48</title>
    <g id="Icon-Resource/Networking-and-Content-Delivery/Res_Amazon-VPC_Network-Access-Control-List_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M32.625,35.376 L34.625,35.376 L34.625,12.625 L32.625,12.625 L32.625,35.376 Z M13.375,35.376 L15.375,35.376 L15.375,12.625 L13.375,12.625 L13.375,35.376 Z M39.625,25.486 L37.843,24.001 L39.625,22.515 L39.625,25.486 Z M41.049,19.475 C40.701,19.311 40.284,19.363 39.984,19.611 L35.64,23.232 C35.412,23.423 35.28,23.704 35.28,24.001 C35.28,24.298 35.412,24.579 35.64,24.77 L39.985,28.39 C40.168,28.542 40.396,28.621 40.625,28.621 C40.77,28.621 40.914,28.59 41.049,28.526 C41.4,28.362 41.625,28.009 41.625,27.621 L41.625,20.38 C41.625,19.992 41.4,19.639 41.049,19.475 L41.049,19.475 Z M8.375,25.486 L8.375,22.515 L10.157,24.001 L8.375,25.486 Z M8.016,19.611 C7.717,19.364 7.302,19.31 6.951,19.475 C6.6,19.639 6.375,19.992 6.375,20.38 L6.375,27.621 C6.375,28.009 6.6,28.362 6.951,28.526 C7.086,28.59 7.231,28.621 7.375,28.621 C7.605,28.621 7.832,28.542 8.015,28.39 L12.36,24.77 C12.588,24.579 12.72,24.298 12.72,24.001 C12.72,23.704 12.588,23.423 12.36,23.232 L8.016,19.611 Z M24,44.001 C12.972,44.001 4,35.029 4,24.001 C4,12.973 12.972,4 24,4 C35.028,4 44,12.973 44,24.001 C44,35.029 35.028,44.001 24,44.001 L24,44.001 Z M24,2 C11.869,2 2,11.869 2,24.001 C2,36.132 11.869,46.001 24,46.001 C36.131,46.001 46,36.132 46,24.001 C46,11.869 36.131,2 24,2 L24,2 Z M28.246,29.126 L19.75,29.121 L19.752,22.376 L28.25,22.38 L28.246,29.126 Z M22.379,19.051 C22.381,18.499 22.566,17.987 22.902,17.608 C23.206,17.268 23.598,17.079 24.007,17.079 L24.012,17.079 C24.901,17.082 25.622,17.977 25.6190093,19.076 L25.618,20.379 L22.373,20.377 L22.379,19.051 Z M29.25,20.38 L27.618,20.379 L27.619,19.079 C27.626,16.88 26.01,15.086 24.018,15.079 L24.007,15.079 C23.018,15.079 22.095,15.506 21.406,16.281 C20.747,17.024 20.382,18.006 20.379,19.043 L20.373,20.377 L18.752,20.376 C18.487,20.376 18.232,20.481 18.045,20.669 C17.857,20.856 17.752,21.11 17.752,21.376 L17.75,30.121 C17.75,30.673 18.197,31.121 18.75,31.121 L29.246,31.126 C29.511,31.126 29.766,31.021 29.953,30.833 C30.141,30.646 30.246,30.392 30.246,30.126 L30.25,21.38 C30.25,21.115 30.145,20.86 29.957,20.673 C29.77,20.485 29.516,20.38 29.25,20.38 L29.25,20.38 Z" id="AWS-Amazon-VPC_Network-access-control-list_Resource-Icon_light-bg" fill="#8C4FFF"></path>
    </g>
</svg>`, YR = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Networking-and-Content-Delivery/Res_Amazon-VPC_Customer-Gateway_48</title>
    <g id="Icon-Resource/Networking-and-Content-Delivery/Res_Amazon-VPC_Customer-Gateway_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M42.2081,24.707 L37.8331,29.082 L36.4191,27.668 L39.0871,25 L25.0001,25 L25.0001,39.086 L27.6681,36.418 L29.0821,37.832 L24.7071,42.207 C24.5121,42.402 24.2561,42.5 24.0001,42.5 C23.7441,42.5 23.4881,42.402 23.2931,42.207 L18.9181,37.832 L20.3321,36.418 L23.0001,39.086 L23.0001,25 L8.9151,25 L11.5831,27.668 L10.1691,29.082 L5.7941,24.707 C5.4031,24.316 5.4031,23.684 5.7941,23.293 L10.1691,18.917 L11.5831,20.331 L8.9151,23 L23.0001,23 L23.0001,8.913 L20.3321,11.581 L18.9181,10.167 L23.2931,5.792 C23.6841,5.401 24.3161,5.401 24.7071,5.792 L29.0821,10.167 L27.6681,11.581 L25.0001,8.913 L25.0001,23 L39.0871,23 L36.4191,20.331 L37.8331,18.917 L42.2081,23.293 C42.5991,23.684 42.5991,24.316 42.2081,24.707 M24.0001,44 C12.9721,44 4.0001,35.028 4.0001,24 C4.0001,12.972 12.9721,4 24.0001,4 C35.0281,4 44.0001,12.972 44.0001,24 C44.0001,35.028 35.0281,44 24.0001,44 M24.0001,2 C11.8691,2 2.0001,11.869 2.0001,24 C2.0001,36.131 11.8691,46 24.0001,46 C36.1311,46 46.0001,36.131 46.0001,24 C46.0001,11.869 36.1311,2 24.0001,2" id="AWS-Amazon-VPC_Customer-gateway_Resource-Icon_light-bg" fill="#8C4FFF"></path>
    </g>
</svg>`, QR = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Networking-and-Content-Delivery/Res_Elastic-Load-Balancing_Network-Load-Balancer_48</title>
    <g id="Icon-Resource/Networking-and-Content-Delivery/Res_Elastic-Load-Balancing_Network-Load-Balancer_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M24.0015,44.0029 C12.9725,44.0029 3.9995,35.0299 3.9995,24.0009 C3.9995,12.9729 12.9725,3.9999 24.0015,3.9999 C35.0295,3.9999 44.0025,12.9729 44.0025,24.0009 C44.0025,35.0299 35.0295,44.0029 24.0015,44.0029 L24.0015,44.0029 Z M24.0015,1.9999 C11.8695,1.9999 1.9995,11.8689 1.9995,24.0009 C1.9995,36.1329 11.8695,46.0029 24.0015,46.0029 C36.1335,46.0029 46.0025,36.1329 46.0025,24.0009 C46.0025,11.8689 36.1335,1.9999 24.0015,1.9999 L24.0015,1.9999 Z M29.0835,23.2939 C29.4745,23.6849 29.4745,24.3169 29.0835,24.7079 L26.1405,27.6539 L24.7265,26.2399 L25.9645,25.0009 L18.7505,25.0009 L18.7505,23.0009 L25.9645,23.0009 L24.7265,21.7619 L26.1405,20.3479 L29.0835,23.2939 Z M32.0015,35.2519 L35.2515,35.2519 L35.2515,32.0019 L32.0015,32.0019 L32.0015,35.2519 Z M36.2515,30.0019 L31.0015,30.0019 C30.4485,30.0019 30.0015,30.4489 30.0015,31.0019 L30.0015,36.2519 C30.0015,36.8049 30.4485,37.2519 31.0015,37.2519 L36.2515,37.2519 C36.8045,37.2519 37.2515,36.8049 37.2515,36.2519 L37.2515,31.0019 C37.2515,30.4489 36.8045,30.0019 36.2515,30.0019 L36.2515,30.0019 Z M17.6665,18.7409 L24.9615,14.8909 L23.3945,14.4659 L23.9175,12.5359 L27.9365,13.6249 C28.4695,13.7699 28.7835,14.3179 28.6395,14.8519 L27.5505,18.8729 L25.6205,18.3499 L26.1085,16.5469 L18.6005,20.5109 L17.6665,18.7409 Z M32.0015,16.0009 L35.2515,16.0009 L35.2515,12.7509 L32.0015,12.7509 L32.0015,16.0009 Z M36.2515,10.7509 L31.0015,10.7509 C30.4485,10.7509 30.0015,11.1979 30.0015,11.7509 L30.0015,17.0009 C30.0015,17.5539 30.4485,18.0009 31.0015,18.0009 L36.2515,18.0009 C36.8045,18.0009 37.2515,17.5539 37.2515,17.0009 L37.2515,11.7509 C37.2515,11.1979 36.8045,10.7509 36.2515,10.7509 L36.2515,10.7509 Z M8.3455,27.3469 L15.0355,27.3469 L15.0355,20.6569 L8.3455,20.6569 L8.3455,27.3469 Z M16.0355,18.6559 L7.3455,18.6559 C6.7925,18.6559 6.3455,19.1039 6.3455,19.6559 L6.3455,28.3469 C6.3455,28.8989 6.7925,29.3469 7.3455,29.3469 L16.0355,29.3469 C16.5885,29.3469 17.0355,28.8989 17.0355,28.3469 L17.0355,19.6559 C17.0355,19.1039 16.5885,18.6559 16.0355,18.6559 L16.0355,18.6559 Z M28.6395,33.1499 C28.7835,33.6839 28.4695,34.2319 27.9365,34.3769 L23.9175,35.4669 L23.3945,33.5369 L24.9625,33.1119 L17.6665,29.2619 L18.6005,27.4919 L26.1085,31.4549 L25.6205,29.6519 L27.5505,29.1289 L28.6395,33.1499 Z M32.0015,25.6259 L35.2515,25.6259 L35.2515,22.3759 L32.0015,22.3759 L32.0015,25.6259 Z M36.2515,20.3759 L31.0015,20.3759 C30.4485,20.3759 30.0015,20.8229 30.0015,21.3759 L30.0015,26.6259 C30.0015,27.1789 30.4485,27.6259 31.0015,27.6259 L36.2515,27.6259 C36.8045,27.6259 37.2515,27.1789 37.2515,26.6259 L37.2515,21.3759 C37.2515,20.8229 36.8045,20.3759 36.2515,20.3759 L36.2515,20.3759 Z" id="AWS-Elastic-Load-Balancing_Network-Load-Balancer_Resource-Icon_light-bg" fill="#8C4FFF"></path>
    </g>
</svg>`, XR = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Storage/Res_Amazon-Simple-Storage-Service_S3-Replication_48</title>
    <g id="Icon-Resource/Storage/Res_Amazon-Simple-Storage-Service_S3-Replication_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M35.9688,7.5751 C34.7058,7.3321 33.4078,7.1501 32.1358,7.0201 C29.7558,5.9771 25.4428,5.0001 19.4068,5.0001 C8.7148,5.0001 4.0738,7.8121 4.0068,8.7411 L4.0278,8.8901 C4.2328,9.4211 5.6768,10.3991 9.3168,11.1291 C8.8018,11.6701 8.4278,12.2711 8.2358,12.9411 C6.8238,12.6251 5.4888,12.2171 4.4178,11.6831 L7.8418,36.1411 C7.8478,36.1871 7.8518,36.2341 7.8518,36.2801 C7.8928,36.4371 8.5448,37.1201 10.8698,37.7591 L11.1678,39.8881 C7.7108,39.0831 5.9128,37.8991 5.8528,36.3611 L2.0678,9.3141 C2.0548,9.2621 2.0538,9.2041 2.0438,9.1501 L2.0098,8.9021 L2.0038,8.8541 C2.0018,8.8071 1.9998,8.8111 1.9998,8.7631 C1.9998,5.0201 10.9688,3.0001 19.4068,3.0001 C26.8648,3.0001 34.3878,4.5691 35.9688,7.5751 L35.9688,7.5751 Z M41.8978,28.9801 L42.0318,27.9631 C43.0308,28.5721 43.5248,28.9941 43.7648,29.2521 C43.4468,29.2651 42.8648,29.2111 41.8978,28.9801 L41.8978,28.9801 Z M38.2368,41.4051 C38.2308,41.4491 38.2288,41.4801 38.2288,41.5241 C38.1998,41.6381 37.8338,42.0761 36.5738,42.5681 C35.9438,42.8141 35.1978,43.0361 34.3568,43.2271 C32.1778,43.7251 29.5048,44.0001 26.8288,44.0001 C19.7228,44.0001 15.6188,42.2641 15.4338,41.5371 C15.4338,41.4901 15.4298,41.4441 15.4238,41.3981 L12.0008,16.9451 C15.3108,18.6061 21.4688,19.2541 26.9898,19.2541 C32.3158,19.2541 38.2488,18.6111 41.4688,16.9701 L39.9518,28.4301 C36.0848,27.2031 31.0308,24.9241 28.7518,23.8631 C28.6028,22.9541 27.8178,22.2561 26.8658,22.2561 C25.8088,22.2561 24.9478,23.1161 24.9478,24.1741 C24.9478,25.2301 25.8088,26.0911 26.8658,26.0911 C27.2888,26.0911 27.6768,25.9491 27.9938,25.7171 C30.6868,26.9701 35.7758,29.2441 39.6868,30.4451 L38.2368,41.4051 Z M26.9898,10.2571 C36.5618,10.2571 41.8028,12.7141 41.8628,13.9971 L41.8498,14.0901 C41.6638,15.2621 36.7068,17.2541 26.9898,17.2541 C17.0728,17.2541 11.8048,15.2321 11.6018,14.0901 L11.5888,13.9971 C11.6568,13.0681 16.2968,10.2571 26.9898,10.2571 L26.9898,10.2571 Z M45.9548,29.1881 C45.7638,28.1601 44.6558,27.1371 42.3158,25.8151 L43.8588,14.1511 C43.8618,14.1071 43.8668,14.0651 43.8668,14.0201 C43.8668,10.2361 35.3768,8.2571 26.9898,8.2571 C18.5508,8.2571 9.58164,10.2761 9.58164,14.0201 C9.58164,14.0671 9.5808,14.0681 9.5838,14.1151 L9.5918,14.1591 L13.4348,41.6181 C13.5678,44.8311 21.4898,46.0001 26.8288,46.0001 C29.6508,46.0001 32.4828,45.7081 34.8008,45.1781 C35.7378,44.9651 36.5788,44.7141 37.3018,44.4301 C39.1998,43.6891 40.1838,42.7411 40.2258,41.6131 L41.6338,30.9701 C42.4518,31.1541 43.1408,31.2511 43.7058,31.2511 C44.5978,31.2511 45.1998,31.0221 45.5898,30.5621 C45.9178,30.1761 46.0478,29.6871 45.9548,29.1881 L45.9548,29.1881 Z" id="AWS-Amazon-Simple-Storage_S3-Replication_Resource-Icon_light-bg" fill="#7AA116"></path>
    </g>
</svg>`, JR = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Storage/Res_Amazon-Simple-Storage-Service_S3-One-Zone-IA_48</title>
    <g id="Icon-Resource/Storage/Res_Amazon-Simple-Storage-Service_S3-One-Zone-IA_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M39.625,36 C39.35,36 39.125,35.775 39.125,35.5 C39.125,35.225 39.35,35 39.625,35 C39.9,35 40.125,35.225 40.125,35.5 C40.125,35.775 39.9,36 39.625,36 M39.625,33 C38.246,33 37.125,34.121 37.125,35.5 C37.125,36.879 38.246,38 39.625,38 C41.004,38 42.125,36.879 42.125,35.5 C42.125,34.121 41.004,33 39.625,33 M39.455,43.192 C37.737,40.52 35.66,36.779 35.66,35.22 C35.66,32.962 37.362,31.125 39.455,31.125 C41.548,31.125 43.25,32.962 43.25,35.22 C43.25,36.779 41.173,40.52 39.455,43.192 M39.455,29.125 C36.26,29.125 33.66,31.859 33.66,35.22 C33.66,38.257 38.122,44.828 38.631,45.567 C38.818,45.838 39.126,46 39.455,46 C39.784,46 40.092,45.838 40.279,45.567 C40.788,44.828 45.25,38.257 45.25,35.22 C45.25,31.859 42.65,29.125 39.455,29.125 M22.869,4 C33.273,4 40.604,7.223 40.739,9.012 L40.714,9.208 C40.691,9.292 40.643,9.379 40.592,9.466 C40.574,9.495 40.565,9.523 40.545,9.553 C40.485,9.638 40.402,9.724 40.316,9.812 C40.285,9.843 40.264,9.874 40.229,9.905 C40.134,9.993 40.016,10.081 39.896,10.169 C39.853,10.2 39.816,10.232 39.77,10.265 C39.639,10.354 39.484,10.444 39.328,10.534 C39.275,10.565 39.229,10.596 39.174,10.626 C39,10.72 38.806,10.813 38.605,10.906 C38.551,10.933 38.503,10.958 38.445,10.983 C38.221,11.085 37.973,11.185 37.717,11.284 C37.674,11.3 37.637,11.317 37.592,11.334 C37.297,11.445 36.982,11.555 36.65,11.661 C36.639,11.665 36.629,11.669 36.617,11.673 C33.477,12.677 28.707,13.462 22.874,13.462 C14.447,13.462 8.235,11.821 5.952,10.251 C5.779,10.132 5.631,10.014 5.504,9.896 C5.487,9.881 5.477,9.866 5.461,9.851 C5.355,9.749 5.264,9.647 5.194,9.549 C5.176,9.521 5.167,9.494 5.15,9.467 C5.098,9.38 5.051,9.294 5.027,9.21 L5.002,9.013 C5.138,7.224 12.467,4 22.869,4 M43.158,26.423 C42.868,26.479 42.127,26.508 40.458,26.101 L40.678,24.466 C42.419,25.522 42.985,26.147 43.158,26.423 M34.393,42.286 C33.688,42.568 32.804,42.836 31.769,43.08 C29.172,43.673 26.014,44 22.874,44 C14.415,44 9.278,41.832 9.278,40.879 C9.278,40.834 9.275,40.79 9.27,40.746 L5.441,12.271 C5.671,12.404 5.916,12.534 6.172,12.659 C6.331,12.736 6.502,12.81 6.67,12.884 C6.814,12.948 6.957,13.011 7.107,13.071 C7.297,13.149 7.491,13.225 7.691,13.298 C7.826,13.348 7.966,13.396 8.105,13.442 C8.865,13.705 9.688,13.941 10.564,14.153 C10.677,14.181 10.789,14.208 10.904,14.233 C11.197,14.302 11.494,14.366 11.797,14.429 C11.873,14.444 11.951,14.459 12.029,14.475 C13.055,14.679 14.13,14.851 15.241,14.991 C15.307,15 15.371,15.009 15.436,15.017 C17.002,15.21 18.625,15.34 20.262,15.407 L20.408,15.413 C21.229,15.445 22.052,15.467 22.869,15.467 C23.677,15.467 24.488,15.445 25.299,15.415 C25.375,15.411 25.451,15.408 25.528,15.405 C26.7,15.356 27.864,15.274 29.007,15.161 C29.077,15.153 29.148,15.147 29.219,15.141 C29.557,15.105 29.89,15.067 30.223,15.026 C30.354,15.011 30.486,14.993 30.617,14.977 C30.941,14.935 31.263,14.893 31.58,14.845 C31.623,14.839 31.664,14.831 31.707,14.825 C32.326,14.731 32.93,14.626 33.52,14.513 C33.686,14.479 33.853,14.448 34.016,14.415 C34.267,14.362 34.513,14.309 34.756,14.253 C34.943,14.21 35.125,14.166 35.307,14.122 C35.531,14.066 35.757,14.013 35.975,13.954 C36.326,13.859 36.67,13.761 37.001,13.657 C37.177,13.603 37.342,13.544 37.511,13.487 C37.712,13.419 37.911,13.351 38.104,13.279 C38.268,13.218 38.428,13.156 38.584,13.093 C38.782,13.013 38.972,12.931 39.158,12.847 C39.287,12.788 39.42,12.732 39.543,12.673 C39.809,12.544 40.062,12.411 40.298,12.273 L38.514,25.551 C33.955,24.118 27.88,21.353 25.119,20.054 C25.12,20.036 25.125,20.019 25.125,20 C25.125,18.897 24.228,18 23.125,18 C22.022,18 21.125,18.897 21.125,20 C21.125,21.103 22.022,22 23.125,22 C23.461,22 23.772,21.909 24.051,21.762 C27.184,23.242 33.503,26.115 38.244,27.561 L38.21,27.812 L40.066,28.063 C41.14,28.321 42.021,28.455 42.731,28.455 C43.722,28.455 44.389,28.203 44.814,27.697 C45.164,27.28 45.302,26.757 45.202,26.221 C44.986,25.069 43.662,23.854 40.967,22.318 L42.668,9.65 C42.673,9.628 42.679,9.604 42.682,9.581 L42.732,9.192 C42.738,9.149 42.741,9.105 42.741,9.063 C42.741,4.9 32.269,2 22.869,2 C13.472,2 3,4.9 3,9.063 C3,9.105 3.003,9.149 3.009,9.192 L3.06,9.581 C3.061,9.593 3.064,9.604 3.066,9.616 L7.279,40.956 C7.41,44.629 16.886,46 22.874,46 C26.159,46 29.477,45.655 32.221,45.028 C33.359,44.76 34.341,44.462 35.127,44.147 C35.419,44.033 35.693,43.911 35.938,43.798 L35.097,41.983 C34.887,42.081 34.653,42.186 34.393,42.286" id="Amazon-Simple-Storage_Service-One-Zone-IA_Resource-Icon_light-bg" fill="#7AA116"></path>
    </g>
</svg>`, ey = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Storage/Res_AWS-Backup_Legal-Hold_48</title>
    <g id="Icon-Resource/Storage/Res_AWS-Backup_Legal-Hold_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M25,30 L27,30 L27,22 L25,22 L25,30 Z M21,30 L23,30 L23,22 L21,22 L21,30 Z M34,26 C34,31.514 29.514,36 24,36 C18.486,36 14,31.514 14,26 L16,26 C16,30.411 19.589,34 24,34 C28.411,34 32,30.411 32,26 C32,21.589 28.411,18 24,18 C22.037,18 20.178,18.74 18.738,20 L20,20 L20,22 L17.074,22 C17.067,22.011 17.059,22.02 17.053,22.031 L16.998,22 L16,22 C15.447,22 15,21.552 15,21 L15,17 L17,17 L17,18.87 C18.848,17.062 21.354,16 24,16 C29.514,16 34,20.486 34,26 L34,26 Z M42,21 C40.897,21 40,20.103 40,19 C40,17.897 40.897,17 42,17 C43.103,17 44,17.897 44,19 C44,20.103 43.103,21 42,21 L42,21 Z M35.166,38.017 C35.11,38.014 35.057,38 35,38 C33.141,38 31.589,39.28 31.142,41 L16.858,41 C16.411,39.28 14.859,38 13,38 C12.943,38 12.89,38.014 12.834,38.017 L8.08,22.4 C9.227,21.696 10,20.441 10,19 C10,18.487 9.894,18 9.718,17.549 L21.463,9.066 C22.155,9.641 23.032,10 24,10 C24.968,10 25.845,9.641 26.537,9.066 L38.282,17.549 C38.106,18 38,18.487 38,19 C38,20.441 38.773,21.696 39.92,22.4 L35.166,38.017 Z M35,44 C33.897,44 33,43.103 33,42 C33,40.897 33.897,40 35,40 C36.103,40 37,40.897 37,42 C37,43.103 36.103,44 35,44 L35,44 Z M13,44 C11.897,44 11,43.103 11,42 C11,40.897 11.897,40 13,40 C14.103,40 15,40.897 15,42 C15,43.103 14.103,44 13,44 L13,44 Z M4,19 C4,17.897 4.897,17 6,17 C7.103,17 8,17.897 8,19 C8,20.103 7.103,21 6,21 C4.897,21 4,20.103 4,19 L4,19 Z M24,4 C25.103,4 26,4.897 26,6 C26,7.103 25.103,8 24,8 C22.897,8 22,7.103 22,6 C22,4.897 22.897,4 24,4 L24,4 Z M42,15 C41.032,15 40.155,15.359 39.462,15.934 L27.718,7.451 C27.894,7 28,6.513 28,6 C28,3.794 26.206,2 24,2 C21.794,2 20,3.794 20,6 C20,6.513 20.106,7 20.282,7.451 L8.538,15.934 C7.845,15.359 6.968,15 6,15 C3.794,15 2,16.794 2,19 C2,21.206 3.794,23 6,23 C6.057,23 6.11,22.986 6.166,22.983 L10.92,38.6 C9.773,39.304 9,40.559 9,42 C9,44.206 10.794,46 13,46 C14.859,46 16.411,44.72 16.858,43 L31.142,43 C31.589,44.72 33.141,46 35,46 C37.206,46 39,44.206 39,42 C39,40.559 38.227,39.304 37.08,38.6 L41.833,22.983 C41.89,22.986 41.943,23 42,23 C44.206,23 46,21.206 46,19 C46,16.794 44.206,15 42,15 L42,15 Z" id="Fill-1" fill="#7AA116"></path>
    </g>
</svg>`, ty = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Storage/Res_AWS-Storage-Gateway_Noncached-Volume_48</title>
    <g id="Icon-Resource/Storage/Res_AWS-Storage-Gateway_Noncached-Volume_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M39.2429,43.9912 L30.7449,43.9912 L30.7449,38.8672 C30.7449,38.3142 30.2979,37.8672 29.7449,37.8672 L17.4979,37.8672 C16.9449,37.8672 16.4979,38.3142 16.4979,38.8672 L16.4979,43.9912 L7.9999,43.9912 L7.9999,4.0002 L39.2429,4.0002 L39.2429,43.9912 Z M40.2429,2.0002 L6.9999,2.0002 C6.4469,2.0002 5.9999,2.4472 5.9999,3.0002 L5.9999,44.9912 C5.9999,45.5442 6.4469,45.9912 6.9999,45.9912 L17.4979,45.9912 C18.0509,45.9912 18.4979,45.5442 18.4979,44.9912 L18.4979,39.8672 L28.7449,39.8672 L28.7449,44.9912 C28.7449,45.5442 29.1919,45.9912 29.7449,45.9912 L40.2429,45.9912 C40.7959,45.9912 41.2429,45.5442 41.2429,44.9912 L41.2429,3.0002 C41.2429,2.4472 40.7959,2.0002 40.2429,2.0002 L40.2429,2.0002 Z" id="AWS-Storage-Gateway_Noncached-volume_Resource-Icon_dark-bg" fill="#7AA116"></path>
    </g>
</svg>`, W7 = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Storage/Res_Amazon-Elastic-File-System_Standard_48</title>
    <g id="Icon-Resource/Storage/Res_Amazon-Elastic-File-System_Standard_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M41,40 L41,17.654 C41,15.894 40.109,14 38.154,14 L36,14 L36,16 L38.154,16 C38.95,16 39,17.641 39,17.654 L39,39 L4,39 L4,17.664 C4.008,17.273 4.166,16 5.846,16 L7,16 L7,14 L5.846,14 C3.024,14 2,16.185 2,17.654 L2,40 C2,40.552 2.447,41 3,41 L40,41 C40.553,41 41,40.552 41,40 L41,40 Z M25.347,15 C25.347,14.307 25.576,12.71 25.812,12 L30,12 L30,10 L25.257,10 C25.068,10 24.885,10.053 24.726,10.153 C23.853,10.701 23.528,12.748 23.411,14 L13,14 L13,16 L24.347,16 C24.899,16 25.347,15.552 25.347,15 L25.347,15 Z M24,33 C24,34.103 24.897,35 26,35 C27.103,35 28,34.103 28,33 C28,31.897 27.103,31 26,31 C24.897,31 24,31.897 24,33 L24,33 Z M22,33 C22,30.794 23.794,29 26,29 C28.206,29 30,30.794 30,33 C30,35.206 28.206,37 26,37 C23.794,37 22,35.206 22,33 L22,33 Z M26.437,25 L24.611,21.609 L22.785,25 L26.437,25 Z M28.111,27 L21.111,27 C20.76,27 20.434,26.815 20.253,26.513 C20.072,26.21 20.064,25.836 20.23,25.526 L23.73,19.026 C24.08,18.378 25.143,18.378 25.492,19.026 L28.992,25.526 C29.158,25.836 29.15,26.21 28.97,26.513 C28.789,26.815 28.463,27 28.111,27 L28.111,27 Z M12,32 L15,32 L15,29 L12,29 L12,32 Z M16,27 C16.553,27 17,27.448 17,28 L17,33 C17,33.552 16.553,34 16,34 L11,34 C10.447,34 10,33.552 10,33 L10,28 C10,27.448 10.447,27 11,27 L16,27 Z M43.079,20.004 L42.979,22.001 C43.542,22.029 44,22.51 44,23.074 L44,44 L9,44 L9,43 L7,43 L7,45 L7,45.001 C7.001,45.553 7.448,46 8,46 L45,46 C45.553,46 46,45.552 46,45 L46,23.074 C46,21.434 44.717,20.085 43.079,20.004 L43.079,20.004 Z M20,5.401 L20,12 L22,12 L22,5.427 L23.296,6.71 L24.704,5.29 L21.675,2.29 C21.487,2.104 21.234,2 20.971,2 L20.966,2 C20.7,2.001 20.446,2.108 20.26,2.296 L17.289,5.296 L18.711,6.704 L20,5.401 Z M6.283,18.697 L9.269,21.767 C9.456,21.959 9.714,22.069 9.982,22.069 L9.985,22.069 C10.254,22.069 10.511,21.961 10.699,21.77 L13.714,18.701 L12.286,17.299 L11,18.609 L11,10 L9,10 L9,18.622 L7.717,17.303 L6.283,18.697 Z M30.707,17.293 L32,18.586 L32,10 L34,10 L34,18.586 L35.293,17.293 L36.707,18.707 L33.707,21.707 C33.512,21.902 33.256,22 33,22 C32.744,22 32.488,21.902 32.293,21.707 L29.293,18.707 L30.707,17.293 Z" id="Fill-1" fill="#7AA116"></path>
    </g>
</svg>`, Hi = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Storage/Res_Amazon-Simple-Storage-Service_Bucket-With-Objects_48</title>
    <g id="Icon-Resource/Storage/Res_Amazon-Simple-Storage-Service_Bucket-With-Objects_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M40.354,26.059 L40.576,24.412 C42.336,25.484 42.887,26.107 43.049,26.372 C42.579,26.512 41.631,26.385 40.354,26.059 L40.354,26.059 Z M22.727,20.038 C22.727,19.989 22.767,19.948 22.817,19.948 C22.832,19.948 22.841,19.957 22.854,19.963 L22.785,20.103 C22.753,20.094 22.727,20.076 22.727,20.038 L22.727,20.038 Z M36.373,40.637 C36.367,40.682 36.364,40.726 36.364,40.771 C36.364,40.923 35.987,41.507 34.31,42.17 C33.562,42.465 32.679,42.731 31.684,42.959 C29.118,43.553 25.968,43.88 22.816,43.88 C14.388,43.88 9.271,41.721 9.271,40.771 C9.271,40.726 9.268,40.682 9.262,40.637 L5.44,12.253 C5.685,12.396 5.95,12.533 6.226,12.666 C6.295,12.7 6.372,12.732 6.444,12.765 C6.692,12.879 6.95,12.99 7.218,13.097 C7.326,13.14 7.435,13.182 7.545,13.224 C7.826,13.33 8.116,13.431 8.416,13.529 C8.496,13.555 8.573,13.583 8.655,13.609 C9.037,13.729 9.432,13.843 9.84,13.952 C9.943,13.979 10.05,14.004 10.156,14.031 C10.476,14.113 10.804,14.191 11.139,14.265 C11.272,14.295 11.404,14.324 11.539,14.353 C11.911,14.431 12.289,14.505 12.673,14.576 C12.75,14.589 12.823,14.605 12.9,14.618 C13.36,14.699 13.83,14.773 14.306,14.842 C14.434,14.861 14.564,14.877 14.693,14.895 C15.059,14.945 15.427,14.992 15.8,15.035 C15.947,15.052 16.093,15.069 16.24,15.085 C16.685,15.133 17.133,15.176 17.585,15.214 C17.638,15.219 17.69,15.224 17.743,15.229 C18.245,15.27 18.751,15.303 19.259,15.331 C19.401,15.339 19.542,15.346 19.685,15.353 C20.069,15.372 20.453,15.388 20.837,15.4 C20.988,15.405 21.137,15.41 21.288,15.413 C21.798,15.425 22.308,15.434 22.816,15.434 C23.324,15.434 23.833,15.425 24.344,15.413 C24.495,15.41 24.644,15.405 24.794,15.4 C25.179,15.388 25.564,15.372 25.948,15.353 C26.09,15.346 26.231,15.339 26.373,15.331 C26.881,15.303 27.388,15.27 27.891,15.229 C27.942,15.224 27.991,15.219 28.041,15.215 C28.496,15.177 28.947,15.133 29.394,15.084 C29.541,15.069 29.685,15.052 29.83,15.036 C30.206,14.992 30.578,14.945 30.946,14.894 C31.072,14.876 31.199,14.861 31.325,14.842 C31.803,14.773 32.275,14.699 32.737,14.618 C32.808,14.605 32.877,14.59 32.949,14.578 C33.339,14.506 33.722,14.431 34.099,14.352 C34.231,14.324 34.361,14.295 34.491,14.266 C34.83,14.191 35.162,14.112 35.486,14.029 C35.587,14.003 35.691,13.979 35.792,13.952 C36.201,13.843 36.599,13.729 36.982,13.608 C37.06,13.583 37.133,13.557 37.21,13.532 C37.514,13.432 37.809,13.33 38.093,13.222 C38.201,13.182 38.307,13.14 38.412,13.099 C38.684,12.991 38.946,12.878 39.196,12.762 C39.265,12.73 39.339,12.7 39.407,12.667 C39.684,12.534 39.949,12.396 40.195,12.253 L38.413,25.49 C34.792,24.328 29.708,22.221 24.897,19.933 C24.84,18.83 23.934,17.948 22.817,17.948 C21.665,17.948 20.727,18.885 20.727,20.038 C20.727,21.192 21.665,22.129 22.817,22.129 C23.269,22.129 23.686,21.982 24.028,21.737 C28.341,23.805 33.845,26.246 38.143,27.487 L36.373,40.637 Z M22.816,4 C33.188,4 40.496,7.212 40.632,8.995 L40.606,9.202 C40.587,9.263 40.548,9.327 40.515,9.39 C40.488,9.441 40.469,9.492 40.433,9.543 C40.388,9.607 40.323,9.671 40.263,9.736 C40.213,9.788 40.173,9.841 40.115,9.894 C40.043,9.959 39.953,10.024 39.868,10.089 C39.796,10.144 39.734,10.198 39.654,10.252 C39.558,10.317 39.444,10.382 39.334,10.447 C39.242,10.502 39.157,10.558 39.054,10.613 C38.937,10.676 38.801,10.74 38.671,10.802 C38.555,10.859 38.448,10.915 38.322,10.971 C38.183,11.033 38.026,11.093 37.875,11.155 C37.739,11.21 37.609,11.267 37.462,11.322 C37.301,11.382 37.123,11.441 36.951,11.499 C36.793,11.553 36.644,11.609 36.478,11.662 C36.298,11.718 36.101,11.773 35.911,11.829 C35.732,11.88 35.562,11.934 35.375,11.984 C35.177,12.038 34.963,12.087 34.756,12.138 C34.557,12.188 34.365,12.24 34.156,12.287 C33.941,12.335 33.708,12.381 33.484,12.427 C33.266,12.473 33.056,12.52 32.83,12.563 C32.588,12.609 32.331,12.65 32.08,12.693 C31.852,12.732 31.632,12.774 31.398,12.81 C31.132,12.851 30.851,12.886 30.576,12.924 C30.338,12.956 30.108,12.993 29.864,13.022 C29.578,13.057 29.276,13.085 28.98,13.117 C28.731,13.143 28.49,13.172 28.234,13.196 C27.91,13.225 27.57,13.246 27.236,13.271 C26.995,13.288 26.761,13.31 26.514,13.325 C26.134,13.348 25.739,13.362 25.346,13.377 C25.131,13.386 24.924,13.4 24.706,13.406 C24.089,13.424 23.458,13.434 22.816,13.434 C22.172,13.434 21.542,13.424 20.926,13.406 C20.715,13.4 20.514,13.386 20.306,13.378 C19.907,13.363 19.504,13.348 19.118,13.325 C18.882,13.311 18.661,13.29 18.431,13.274 C18.084,13.248 17.733,13.226 17.397,13.196 C17.156,13.173 16.928,13.146 16.693,13.121 C16.383,13.088 16.067,13.059 15.767,13.022 C15.538,12.995 15.323,12.96 15.099,12.93 C14.808,12.89 14.512,12.853 14.233,12.81 C14.013,12.776 13.808,12.737 13.595,12.701 C13.33,12.655 13.057,12.612 12.801,12.563 C12.587,12.522 12.389,12.477 12.183,12.435 C11.946,12.385 11.702,12.338 11.475,12.287 C11.278,12.242 11.096,12.193 10.907,12.146 C10.688,12.092 10.463,12.039 10.256,11.984 C10.079,11.936 9.917,11.884 9.747,11.835 C9.547,11.777 9.341,11.72 9.154,11.661 C8.994,11.61 8.85,11.557 8.699,11.505 C8.521,11.444 8.336,11.383 8.17,11.322 C8.029,11.268 7.905,11.214 7.772,11.161 C7.617,11.097 7.454,11.035 7.311,10.97 C7.189,10.916 7.084,10.861 6.971,10.806 C6.838,10.742 6.699,10.677 6.58,10.613 C6.478,10.558 6.395,10.503 6.303,10.449 C6.193,10.383 6.077,10.318 5.98,10.252 C5.901,10.198 5.838,10.144 5.768,10.09 C5.683,10.025 5.591,9.959 5.52,9.894 C5.461,9.841 5.42,9.788 5.372,9.736 C5.312,9.671 5.247,9.607 5.202,9.543 C5.165,9.492 5.146,9.441 5.12,9.39 C5.086,9.327 5.046,9.263 5.029,9.202 L5.002,8.995 C5.139,7.212 12.446,4 22.816,4 L22.816,4 Z M45.084,26.158 C44.872,25.013 43.553,23.8 40.865,22.263 L42.575,9.567 L42.575,9.564 L42.575,9.563 L42.625,9.175 C42.631,9.132 42.634,9.088 42.634,9.045 C42.634,4.894 32.19,2 22.816,2 C13.444,2 3,4.894 3,9.045 C3,9.088 3.003,9.132 3.009,9.175 L3.06,9.563 L3.06,9.564 L3.06,9.567 L7.272,40.848 C7.404,44.512 16.848,45.88 22.816,45.88 C26.115,45.88 29.424,45.536 32.134,44.909 C33.225,44.658 34.204,44.362 35.045,44.03 C37.204,43.176 38.319,42.106 38.363,40.848 L40.095,27.979 C41.041,28.179 41.902,28.301 42.618,28.301 C43.583,28.301 44.306,28.097 44.697,27.63 C45.045,27.215 45.183,26.692 45.084,26.158 L45.084,26.158 Z M12.654,26.43 L15.25,22.103 L17.846,26.43 L12.654,26.43 Z M20.483,27.922 C20.661,27.609 20.656,27.224 20.47,26.915 L16.107,19.645 C15.746,19.043 14.753,19.043 14.392,19.645 L10.03,26.915 C9.844,27.225 9.839,27.609 10.017,27.923 C10.195,28.237 10.527,28.43 10.887,28.43 L19.613,28.43 C19.973,28.43 20.305,28.237 20.483,27.922 L20.483,27.922 Z M29.646,29.302 C31.259,29.302 32.572,30.625 32.572,32.252 C32.572,33.878 31.259,35.202 29.646,35.202 C28.033,35.202 26.72,33.878 26.72,32.252 C26.72,30.625 28.033,29.302 29.646,29.302 L29.646,29.302 Z M29.646,37.202 C32.362,37.202 34.572,34.982 34.572,32.252 C34.572,29.523 32.362,27.302 29.646,27.302 C26.93,27.302 24.72,29.523 24.72,32.252 C24.72,34.982 26.93,37.202 29.646,37.202 L29.646,37.202 Z M14.599,38.645 L19.496,38.645 L19.496,33.666 L14.599,33.666 L14.599,38.645 Z M20.496,31.665 L13.598,31.665 C13.045,31.665 12.598,32.113 12.598,32.665 L12.598,39.645 C12.598,40.198 13.045,40.645 13.598,40.645 L20.496,40.645 C21.048,40.645 21.496,40.198 21.496,39.645 L21.496,32.665 C21.496,32.113 21.048,31.665 20.496,31.665 L20.496,31.665 Z" id="AWS-Amazon-Simple-Storage_Bucket-with-objects_Resource-Icon_light-bg" fill="#7AA116"></path>
    </g>
</svg>`, ny = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Storage/Res_AWS-Storage-Gateway_File-Gateway_48</title>
    <g id="Icon-Resource/Storage/Res_AWS-Storage-Gateway_File-Gateway_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M19.8711,4 C14.1281,4 10.5851,5.666 7.0001,7.736 L7.0001,46 L5.0001,46 L5.0001,7.161 C5.0001,6.806 5.1881,6.478 5.4941,6.298 C9.3611,4.033 13.3701,2 19.8711,2 C25.9131,2 30.3391,4.281 33.8951,6.115 L34.2001,6.272 C34.5331,6.443 34.7421,6.786 34.7421,7.161 L34.7421,24.5 L32.7421,24.5 L32.7421,7.771 C29.2611,5.978 25.3041,4 19.8711,4 L19.8711,4 Z M41.7991,44.1 L16.2941,44.1 L16.2941,26.521 L22.6191,26.521 L23.4751,28.294 C23.6421,28.639 23.9921,28.858 24.3761,28.858 L41.7991,28.858 L41.7991,44.1 Z M42.7991,26.858 L25.0031,26.858 L24.1461,25.086 C23.9791,24.741 23.6301,24.521 23.2461,24.521 L15.2941,24.521 C14.7411,24.521 14.2941,24.969 14.2941,25.521 L14.2941,45.1 C14.2941,45.652 14.7411,46.1 15.2941,46.1 L42.7991,46.1 C43.3511,46.1 43.7991,45.652 43.7991,45.1 L43.7991,27.858 C43.7991,27.306 43.3511,26.858 42.7991,26.858 L42.7991,26.858 Z" id="AWS-Storage-Gateway_File-Gateway_Resource-Icon_light-bg" fill="#7AA116"></path>
    </g>
</svg>`, iy = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Storage/Res_AWS-Storage-Gateway_Amazon-FSx-File-Gateway_48</title>
    <g id="Icon-Resource/Storage/Res_AWS-Storage-Gateway_Amazon-FSx-File-Gateway_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M42.532,28.826 L45.696,24.252 L44.065,24.252 L41.604,27.896 L40.899,28.909 L44.234,33.865 L44.278,33.931 L45.993,33.931 L42.532,28.826 Z M37.245,33.931 L38.894,33.931 L41.132,30.542 L40.375,29.434 L37.245,33.931 Z M41.215,27.19 L39.274,24.318 L39.23,24.252 L37.532,24.252 L40.354,28.378 L41.215,27.19 Z M34.788,27.723 L33.084,27.046 C32.535,26.832 32.111,26.63 31.821,26.445 C31.548,26.271 31.35,26.078 31.235,25.872 C31.12,25.668 31.062,25.388 31.062,25.037 C31.062,24.411 31.253,23.945 31.643,23.614 C32.461,22.923 34.154,22.94 36.205,23.69 L36.473,23.788 L36.473,22.532 L36.356,22.479 C35.89,22.265 35.387,22.097 34.861,21.978 C34.335,21.86 33.825,21.8 33.344,21.8 C32.269,21.8 31.386,22.103 30.72,22.701 C30.048,23.305 29.707,24.102 29.707,25.071 C29.707,25.787 29.915,26.4 30.326,26.891 C30.729,27.372 31.36,27.788 32.203,28.128 L34.051,28.871 C34.655,29.112 35.096,29.383 35.36,29.677 C35.615,29.962 35.739,30.296 35.739,30.699 C35.739,31.379 35.506,31.901 35.024,32.294 C34.006,33.126 32.119,33.058 30.041,32.278 L29.77,32.177 L29.77,33.43 L29.881,33.486 C30.827,33.96 31.918,34.201 33.122,34.201 C34.302,34.201 35.269,33.878 36,33.243 C36.736,32.601 37.11,31.751 37.11,30.716 C37.11,30.001 36.919,29.395 36.542,28.917 C36.173,28.446 35.583,28.044 34.788,27.723 L34.788,27.723 Z M22.83,33.92 L24.17,33.92 L24.17,28.605 L28.61,28.605 L28.61,27.33 L24.17,27.33 L24.17,23.356 L29.423,23.356 L29.423,22.081 L22.83,22.081 L22.83,33.92 Z M30,20 L32,20 L32,7.073 C32,6.735 31.811,6.425 31.511,6.27 L31.203,6.112 C27.648,4.28 23.03,2 17,2 C10.507,2 6.307,4.031 2.446,6.294 C2.17,6.456 2,6.752 2,7.073 L2,46 L4,46 L4,7.5 C7.621,5.404 11.189,4 17,4 C22.498,4 26.486,5.69 30,7.5 L30,20 Z M37,36 L37,45 C37,45.55 36.55,46 36,46 L8.914,46 C8.415,46 8.011,45.597 8.011,45.098 L8,26.001 C8,25.451 8.449,25 9,25 L17,25 C17.228,25 17.497,25.169 17.596,25.375 L18.441,26.724 C18.522,26.893 18.693,27 18.88,27 L21,27 L21,29 L18,29 C17.653,29 17.5,29 17.203,28.209 L16.618,27.288 C16.547,27.114 16.188,27 16,27 L10,27 L10,44 L35,44 L35,36 L37,36 Z" id="Fill-1" fill="#7AA116"></path>
    </g>
</svg>`, sy = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Storage/Res_Amazon-Simple-Storage-Service_S3-Glacier-Instant-Retrieval_48</title>
    <g id="Icon-Resource/Storage/Res_Amazon-Simple-Storage-Service_S3-Glacier-Instant-Retrieval_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M8.17216744,21.129 C8.46316744,21.129 8.73916744,21.255 8.93016744,21.476 C9.11916744,21.696 9.20416744,21.988 9.16116744,22.276 C8.91316744,23.939 8.66616744,25.694 8.47016744,27.191 C9.10416744,26.147 9.80916744,24.967 10.4741674,23.837 L13.4281674,18.128 L11.0891674,18.129 C10.7741674,18.129 10.4771674,17.98 10.2871674,17.727 C10.0991674,17.475 10.0401674,17.148 10.1301674,16.845 L12.1201674,10.129 L5.52616744,10.129 L4.03516744,21.129 L8.17216744,21.129 Z M7.10316744,32.129 C6.81216744,32.129 6.52516744,31.997 6.33416744,31.776 C5.99316744,31.38 5.82916744,31.191 7.01316744,23.129 L3.77716744,23.129 C3.28716744,23.129 2.76116744,22.891 2.43616744,22.523 C2.11316744,22.161 1.95716744,21.672 2.01016744,21.185 L3.56316744,9.764 C3.65716744,8.89 4.46816744,8.129 5.33016744,8.129 L12.4321674,8.129 C13.0071674,8.129 13.5471674,8.411 13.8781674,8.884 C14.2041674,9.352 14.2861674,9.953 14.0981674,10.493 L12.4281674,16.129 L13.9401674,16.129 C14.4181674,16.093 14.9291674,16.315 15.2651674,16.707 C15.6031674,17.099 15.7311674,17.633 15.6171674,18.171 C15.5991674,18.258 15.5681674,18.343 15.5271674,18.423 L12.2231674,24.805 C7.91216744,32.129 7.80516744,32.129 7.10316744,32.129 L7.10316744,32.129 Z M45.8391674,36.435 L44.4431674,35.003 L42.2621674,37.129 L39.1141674,37.129 L40.7351674,34.317 L43.5911674,33.552 L43.0731674,31.621 L40.7561674,32.241 L40.1741674,29.957 L38.2361674,30.45 L38.9771674,33.362 L37.3971674,36.103 L35.7881674,33.321 L36.5541674,30.462 L34.6221674,29.945 L34.0011674,32.262 L31.7321674,31.624 L31.1911674,33.549 L34.0801674,34.362 L35.6811674,37.129 L32.4761674,37.129 L30.3601674,35.012 L28.9451674,36.426 L30.6421674,38.123 L28.9541674,39.769 L30.3511674,41.2 L32.4741674,39.129 L35.6491674,39.129 L34.0541674,41.887 L31.2021674,42.651 L31.7201674,44.583 L34.0371674,43.962 L34.6191674,46.246 L36.5571674,45.753 L35.8151674,42.836 L37.3971674,40.101 L39.0041674,42.887 L38.2391674,45.741 L40.1711674,46.258 L40.7921674,43.941 L43.0621674,44.579 L43.6031674,42.654 L40.7081674,41.84 L39.1451674,39.129 L42.3711674,39.129 L44.4341674,41.191 L45.8481674,39.777 L44.1511674,38.081 L45.8391674,36.435 Z M41.6041674,24.429 L41.3131674,26.068 C43.0691674,26.508 43.8401674,26.479 44.1401674,26.423 C43.9601674,26.146 43.3781674,25.502 41.6041674,24.429 L41.6041674,24.429 Z M8.23816744,6.992 L7.31716744,5.218 C11.1371674,3.233 17.4751674,2 23.8561674,2 C33.2551674,2 43.7281674,4.9 43.7281674,9.063 C43.7281674,9.107 43.7251674,9.151 43.7191674,9.195 L43.6671674,9.583 C43.6641674,9.606 43.6581674,9.628 43.6541674,9.651 L41.9511674,22.317 C44.6461674,23.852 45.9721674,25.069 46.1881674,26.221 C46.2871674,26.756 46.1501674,27.28 45.8001674,27.696 C45.3751674,28.203 44.7081674,28.4550034 43.7191674,28.4550034 C42.8011674,28.456 41.6051674,28.238 40.0661674,27.806 C35.3141674,26.483 28.5281674,23.408 25.1641674,21.821 C24.8571674,22.013 24.4971674,22.129 24.1101674,22.129 C23.0071674,22.129 22.1101674,21.232 22.1101674,20.129 C22.1101674,19.026 23.0071674,18.129 24.1101674,18.129 C25.1861674,18.129 26.0601674,18.985 26.1021674,20.052 C28.8371674,21.338 34.8311674,24.068 39.3811674,25.512 L39.8851674,22.678 L41.2841674,12.269 C37.6701674,14.375 30.5941674,15.466 23.8561674,15.466 C20.9971674,15.466 18.0931674,15.265 15.4571674,14.884 L15.7421674,12.905 C18.2861674,13.272 21.0921674,13.466 23.8561674,13.466 C34.1341674,13.466 41.1181674,11.025 41.6941674,9.246 L41.7261674,9.011 C41.5871674,7.222 34.2581674,4 23.8561674,4 C17.8681674,4 11.7381674,5.174 8.23816744,6.992 L8.23816744,6.992 Z M29.6651674,43.631 L29.9191674,45.615 C27.9251674,45.87 25.8871674,46 23.8601674,46 C17.8721674,46 8.39716744,44.629 8.26616744,40.956 L7.29716744,33.75 L9.27916744,33.483 L10.2561674,40.745 C10.2621674,40.79 10.2651674,40.834 10.2651674,40.879 C10.2651674,41.832 15.4011674,44 23.8601674,44 C25.8021674,44 27.7551674,43.876 29.6651674,43.631 L29.6651674,43.631 Z" id="Fill-1" fill="#7AA116"></path>
    </g>
</svg>`, ry = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Storage/Res_Amazon-File-Cache_On-premises-NFS-linked-datasets_48</title>
    <g id="Icon-Resource/Storage/Res_Amazon-File-Cache_On-premises-NFS-linked-datasets_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M18,31 C18,29.346 16.654,28 15,28 L15,26 C17.757,26 20,28.243 20,31 C20,33.757 17.757,36 15,36 L13,36 C10.243,36 8,33.757 8,31 L10,31 C10,32.654 11.346,34 13,34 L15,34 C16.654,34 18,32.654 18,31 L18,31 Z M4,31 C4,32.654 5.346,34 7,34 L7,36 C4.243,36 2,33.757 2,31 C2,28.243 4.243,26 7,26 L9,26 C11.757,26 14,28.243 14,31 L12,31 C12,29.346 10.654,28 9,28 L7,28 C5.346,28 4,29.346 4,31 L4,31 Z M32,23 L34,23 L34,21 L32,21 L32,23 Z M38,23 L40,23 L40,21 L38,21 L38,23 Z M20,9 L22,9 L22,7 L20,7 L20,9 Z M14,9 L16,9 L16,7 L14,7 L14,9 Z M13,16 L41,16 L41,14 L13,14 L13,16 Z M10,12 L44,12 L44,4 L10,4 L10,12 Z M34,44 L41,44 L41,42 L34,42 L34,44 Z M13,44 L20,44 L20,42 L13,42 L13,44 Z M44.082,14 C45.14,14 46,13.14 46,12.083 L46,3.917 C46,2.86 45.14,2 44.082,2 L10,2 C8.897,2 8,2.897 8,4 L8,12.083 C8,13.14 8.86,14 9.918,14 L11,14 L11,16 L9.918,16 C8.86,16 8,16.86 8,17.917 L8,24 L10,24 L10,18 L44,18 L44,26 L22,26 L22,28 L41,28 L41,30 L22,30 L22,32 L44,32 L44,40 L10,40 L10,38 L8,38 L8,40 C8,41.103 8.897,42 10,42 L11,42 L11,45 C11,45.552 11.447,46 12,46 L21,46 C21.553,46 22,45.552 22,45 L22,42 L32,42 L32,45 C32,45.552 32.447,46 33,46 L42,46 C42.553,46 43,45.552 43,45 L43,42 L44,42 C45.103,42 46,41.103 46,40 L46,32 C46,30.897 45.103,30 44,30 L43,30 L43,28 L44.082,28 C45.14,28 46,27.14 46,26.083 L46,18 C46,16.897 45.103,16 44,16 L43,16 L43,14 L44.082,14 Z" id="Fill-1" fill="#7AA116"></path>
    </g>
</svg>`, oy = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Storage/Res_Amazon-Simple-Storage-Service_S3-Standard-IA_48</title>
    <g id="Icon-Resource/Storage/Res_Amazon-Simple-Storage-Service_S3-Standard-IA_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M44.001,40.793 L45.415,42.207 L41.915,45.707 C41.72,45.902 41.464,46 41.208,46 C40.952,46 40.696,45.902 40.501,45.707 L37.001,42.207 L38.415,40.793 L40.208,42.586 L40.208,32.539 L38.415,34.332 L37.001,32.918 L40.501,29.418 C40.892,29.027 41.524,29.027 41.915,29.418 L45.415,32.918 L44.001,34.332 L42.208,32.539 L42.208,42.586 L44.001,40.793 Z M22.87,4 C33.272,4 40.602,7.222 40.74,9.012 L40.714,9.21 C40.691,9.29 40.645,9.373 40.597,9.456 C40.577,9.489 40.566,9.522 40.543,9.556 C40.488,9.635 40.408,9.717 40.329,9.798 C40.293,9.835 40.267,9.871 40.227,9.908 C40.139,9.988 40.029,10.069 39.92,10.15 C39.867,10.189 39.824,10.229 39.766,10.269 C39.647,10.35 39.506,10.431 39.366,10.512 C39.299,10.551 39.24,10.591 39.168,10.63 C39.014,10.713 38.838,10.796 38.663,10.879 C38.586,10.915 38.52,10.952 38.439,10.987 C38.242,11.075 38.024,11.162 37.805,11.249 C37.729,11.278 37.661,11.309 37.582,11.339 C37.33,11.434 37.057,11.526 36.777,11.618 C36.718,11.638 36.664,11.658 36.604,11.677 C36.273,11.782 35.923,11.886 35.557,11.985 C35.541,11.99 35.525,11.995 35.51,11.999 C32.402,12.843 28.059,13.463 22.874,13.463 C14.458,13.463 8.25,11.826 5.961,10.257 C5.939,10.241 5.924,10.227 5.902,10.212 C5.756,10.108 5.621,10.005 5.51,9.901 C5.479,9.874 5.459,9.846 5.432,9.817 C5.343,9.729 5.259,9.641 5.198,9.554 C5.171,9.516 5.158,9.479 5.137,9.44 C5.094,9.364 5.05,9.288 5.029,9.214 L5.002,9.012 C5.141,7.222 12.47,4 22.87,4 L22.87,4 Z M43.158,26.423 C42.868,26.479 42.13,26.509 40.459,26.102 L40.68,24.466 C42.419,25.523 42.985,26.147 43.158,26.423 L43.158,26.423 Z M31.768,43.08 C29.177,43.673 26.018,44 22.874,44 C14.415,44 9.279,41.832 9.279,40.879 C9.279,40.834 9.276,40.79 9.271,40.746 L5.441,12.272 C5.674,12.407 5.923,12.538 6.184,12.665 C6.326,12.734 6.48,12.8 6.629,12.866 C6.793,12.939 6.957,13.012 7.13,13.081 C7.305,13.152 7.483,13.222 7.667,13.29 C7.828,13.349 7.994,13.405 8.161,13.463 C8.561,13.599 8.977,13.729 9.409,13.851 C9.522,13.882 9.627,13.916 9.741,13.946 C9.987,14.013 10.242,14.075 10.497,14.137 C10.647,14.173 10.795,14.21 10.947,14.244 C11.213,14.306 11.482,14.364 11.756,14.421 C11.885,14.447 12.015,14.472 12.145,14.497 C13.106,14.686 14.111,14.847 15.147,14.98 C15.268,14.995 15.388,15.011 15.509,15.025 C15.846,15.066 16.184,15.106 16.525,15.141 C16.6,15.148 16.675,15.155 16.75,15.162 C17.869,15.273 19.01,15.354 20.158,15.403 C20.273,15.408 20.389,15.413 20.504,15.417 C20.863,15.431 21.223,15.442 21.582,15.449 C21.632,15.45 21.682,15.45 21.73,15.451 C22.111,15.458 22.492,15.467 22.87,15.467 C23.236,15.467 23.605,15.458 23.973,15.452 C24.04,15.45 24.107,15.45 24.176,15.449 C24.522,15.442 24.865,15.431 25.211,15.418 C25.35,15.413 25.487,15.407 25.625,15.401 C25.966,15.387 26.305,15.37 26.644,15.351 C26.721,15.346 26.796,15.34 26.873,15.335 C27.532,15.293 28.186,15.24 28.834,15.178 C28.979,15.163 29.123,15.151 29.267,15.136 C29.568,15.105 29.865,15.07 30.163,15.034 C30.342,15.013 30.518,14.99 30.694,14.967 C30.98,14.93 31.268,14.892 31.549,14.851 C31.726,14.824 31.897,14.795 32.072,14.767 C32.535,14.693 32.988,14.614 33.435,14.528 C33.64,14.489 33.845,14.45 34.046,14.409 C34.276,14.361 34.503,14.312 34.728,14.261 C34.939,14.212 35.147,14.162 35.352,14.111 C35.557,14.061 35.762,14.012 35.96,13.958 C36.321,13.861 36.673,13.761 37.013,13.654 C37.174,13.604 37.326,13.55 37.482,13.497 C37.697,13.425 37.91,13.352 38.116,13.275 C38.272,13.217 38.426,13.157 38.575,13.097 C38.783,13.014 38.98,12.927 39.176,12.84 C39.297,12.784 39.424,12.731 39.54,12.675 C39.807,12.546 40.061,12.413 40.298,12.274 L38.516,25.552 C33.959,24.12 27.881,21.353 25.119,20.054 C25.12,20.036 25.125,20.019 25.125,20 C25.125,18.897 24.228,18 23.125,18 C22.022,18 21.125,18.897 21.125,20 C21.125,21.103 22.022,22 23.125,22 C23.461,22 23.772,21.909 24.051,21.762 C27.186,23.243 33.508,26.118 38.246,27.562 L38.114,28.541 L40.097,28.805 L40.191,28.095 C41.211,28.335 42.049,28.456 42.732,28.456 C43.723,28.456 44.39,28.203 44.814,27.697 C45.164,27.28 45.302,26.757 45.202,26.221 C44.986,25.07 43.662,23.854 40.968,22.319 L42.668,9.651 C42.674,9.628 42.679,9.606 42.682,9.583 L42.733,9.194 C42.739,9.15 42.742,9.106 42.742,9.063 C42.742,4.9 32.27,2 22.87,2 C13.472,2 3,4.9 3,9.063 C3,9.106 3.003,9.15 3.009,9.194 L3.061,9.583 C3.062,9.589 3.063,9.596 3.064,9.602 L7.28,40.956 C7.411,44.629 16.887,46 22.874,46 C26.164,46 29.48,45.655 32.217,45.028 C33.28,44.782 34.213,44.503 34.989,44.199 L34.261,42.336 C33.573,42.605 32.734,42.856 31.768,43.08 L31.768,43.08 Z" id="Amazon-Simple-Storage_Service-Standard-IA_Resource-Icon_light-bg" fill="#7AA116"></path>
    </g>
</svg>`, ly = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Storage/Res_Amazon-Simple-Storage-Service_General-Access-Points_48</title>
    <g id="Icon-Resource/Storage/Res_Amazon-Simple-Storage-Service_General-Access-Points_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M30.5762,21.9659 C29.2062,21.9659 28.0912,23.0809 28.0912,24.4509 C28.0912,25.8209 29.2062,26.9359 30.5762,26.9359 C31.9462,26.9359 33.0602,25.8209 33.0602,24.4509 C33.0602,23.0809 31.9462,21.9659 30.5762,21.9659 L30.5762,21.9659 Z M30.5762,19.9659 C33.0492,19.9659 35.0602,21.9779 35.0602,24.4509 C35.0602,26.9239 33.0492,28.9359 30.5762,28.9359 C28.1022,28.9359 26.0912,26.9239 26.0912,24.4509 C26.0912,21.9779 28.1022,19.9659 30.5762,19.9659 L30.5762,19.9659 Z M30.2062,14.8899 L28.0422,10.9329 L25.7862,14.8899 L30.2062,14.8899 Z M32.7692,15.4099 C32.9392,15.7199 32.9322,16.0959 32.7532,16.3999 C32.5722,16.7029 32.2462,16.8899 31.8922,16.8899 L24.0641905,16.8899 C23.7082,16.8899 23.3792,16.6999 23.2002,16.3919 C23.0202,16.0839 23.0192,15.7039 23.1952,15.3949 L27.1912,8.3869 C27.3712,8.0709 27.6992,7.8919 28.0692,7.8819 C28.4312,7.8849 28.7642,8.0839 28.9372,8.4029 L32.7692,15.4099 Z M13.8572,21.9949 L17.9192,21.9949 L17.9192,17.9319 L13.8572,17.9319 L13.8572,21.9949 Z M18.9192,15.9319 C19.4722,15.9319 19.9192,16.3789 19.9192,16.9319 L19.9192,22.9949 C19.9192,23.5479 19.4722,23.9949 18.9192,23.9949 L12.8562,23.9949 C12.3042,23.9949 11.8562,23.5479 11.8562,22.9949 L11.8562,16.9319 C11.8562,16.3789 12.3042,15.9319 12.8562,15.9319 L18.9192,15.9319 Z M25.0092,42.5059 L25.0092,30.2919 L23.0092,30.2919 L23.0092,42.5859 L19.7642,39.3419 L18.3502,40.7559 L23.2622,45.6669 C23.4572,45.8619 23.7132,45.9599 23.9692,45.9599 C24.2242,45.9599 24.4802,45.8619 24.6762,45.6669 L29.5972,40.7449 L28.1832,39.3309 L25.0092,42.5059 Z M41.8022,19.9019 C41.8022,28.5559 35.4512,35.9619 26.9502,37.5109 L26.9502,35.5439 C34.5012,34.1679 39.8022,27.5889 39.8022,19.9019 C39.8022,11.1339 32.6682,3.9999 23.9002,3.9999 C15.1332,3.9999 8.0002,11.1339 8.0002,19.9019 C8.0002,27.5499 13.2632,34.1219 20.7672,35.5289 L20.7672,37.4939 C12.3172,35.9109 6.0002,28.5119 6.0002,19.9019 C6.0002,10.0299 14.0302,1.9999 23.9002,1.9999 C33.7712,1.9999 41.8022,10.0299 41.8022,19.9019 L41.8022,19.9019 Z" id="Amazon-Simple-Storage_General-Access-Points_Resource-Icon_light-bg" fill="#7AA116"></path>
    </g>
</svg>`, Ly = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Storage/Res_Amazon-Simple-Storage-Service_S3-Object-Lambda-Access-Points_48</title>
    <g id="Icon-Resource/Storage/Res_Amazon-Simple-Storage-Service_S3-Object-Lambda-Access-Points_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M26.512,41.141 L27.901,42.579 L24.634,45.735 C24.441,45.922 24.19,46.016 23.94,46.016 C23.678,46.016 23.417,45.913 23.221,45.711 L20.063,42.447 L21.5,41.057 L23,42.607 L23,34 L25,34 L25,42.6 L26.512,41.141 Z M27.229,37.878 L26.801,35.924 C32.506,34.674 36.647,29.521 36.647,23.671 C36.647,16.755 31.02,11.128 24.104,11.128 C17.187,11.128 11.56,16.755 11.56,23.671 C11.56,29.501 15.514,34.518 21.175,35.871 L20.71,37.817 C14.145,36.247 9.56,30.43 9.56,23.671 C9.56,15.652 16.084,9.128 24.104,9.128 C32.122,9.128 38.647,15.652 38.647,23.671 C38.647,30.454 33.845,36.429 27.229,37.878 L27.229,37.878 Z M46,19.826 L46,28.173 C46,28.448 45.887,28.711 45.687,28.9 C45.488,29.089 45.215,29.189 44.944,29.172 L42.285,29.02 C41.869,30.543 41.265,32.004 40.481,33.38 L42.467,35.152 C42.672,35.335 42.793,35.594 42.801,35.87 C42.809,36.144 42.702,36.411 42.508,36.605 L36.606,42.507 C36.411,42.703 36.148,42.818 35.87,42.8 C35.595,42.792 35.335,42.671 35.153,42.466 L33.386,40.486 C32.137,41.199 30.81,41.766 29.431,42.178 L28.859,40.261 C30.335,39.821 31.744,39.181 33.047,38.357 C33.458,38.095 34.001,38.17 34.327,38.537 L35.94,40.345 L40.345,35.939 L38.532,34.322 C38.167,33.996 38.091,33.455 38.352,33.042 C39.381,31.409 40.117,29.63 40.54,27.755 C40.648,27.277 41.11,26.945 41.573,26.976 L44,27.115 L44,20.885 L41.571,21.023 C41.11,21.047 40.646,20.722 40.538,20.245 C40.115,18.37 39.377,16.592 38.347,14.962 C38.086,14.549 38.162,14.007 38.527,13.682 L40.345,12.06 L35.94,7.655 L34.313,9.479 C33.988,9.844 33.445,9.918 33.033,9.659 C31.405,8.631 29.628,7.895 27.754,7.471 C27.278,7.363 26.949,6.927 26.977,6.438 L27.116,4 L20.885,4 L21.024,6.436 C21.052,6.925 20.723,7.361 20.246,7.469 C18.37,7.892 16.594,8.628 14.964,9.655 C14.553,9.914 14.01,9.839 13.685,9.475 L12.061,7.655 L7.656,12.06 L9.477,13.685 C9.841,14.011 9.917,14.552 9.657,14.966 C8.626,16.597 7.888,18.373 7.464,20.246 C7.355,20.723 6.885,21.047 6.432,21.023 L4,20.885 L4,27.115 L6.425,26.976 C6.885,26.945 7.35,27.277 7.457,27.755 C7.881,29.636 8.617,31.416 9.646,33.045 C9.907,33.459 9.83,34 9.465,34.326 L7.656,35.939 L12.061,40.345 L13.676,38.534 C14.001,38.166 14.543,38.093 14.956,38.353 C16.226,39.156 17.594,39.784 19.022,40.223 L18.436,42.135 C17.108,41.727 15.826,41.173 14.617,40.483 L12.848,42.466 C12.665,42.671 12.406,42.792 12.13,42.8 C12.12,42.8 12.112,42.8 12.102,42.8 C11.837,42.8 11.582,42.695 11.395,42.507 L5.492,36.605 C5.298,36.411 5.192,36.144 5.2,35.869 C5.207,35.594 5.328,35.334 5.534,35.151 L7.517,33.384 C6.734,32.009 6.128,30.547 5.712,29.02 L3.057,29.172 C2.783,29.19 2.513,29.089 2.314,28.9 C2.114,28.711 2,28.448 2,28.173 L2,19.826 C2,19.551 2.114,19.288 2.314,19.099 C2.513,18.91 2.782,18.812 3.057,18.828 L5.72,18.979 C6.137,17.458 6.742,16 7.528,14.626 L5.533,12.848 C5.328,12.665 5.207,12.405 5.2,12.13 C5.192,11.855 5.298,11.589 5.492,11.395 L11.395,5.493 C11.589,5.298 11.862,5.196 12.13,5.2 C12.406,5.208 12.664,5.328 12.848,5.534 L14.626,7.526 C15.999,6.744 17.458,6.14 18.98,5.724 L18.828,3.057 C18.813,2.782 18.91,2.513 19.1,2.313 C19.288,2.113 19.551,2 19.826,2 L28.174,2 C28.449,2 28.712,2.113 28.901,2.313 C29.09,2.513 29.188,2.782 29.172,3.057 L29.021,5.726 C30.541,6.143 31.999,6.747 33.371,7.53 L35.153,5.534 C35.336,5.328 35.595,5.208 35.87,5.2 C36.145,5.193 36.411,5.298 36.606,5.493 L42.508,11.395 C42.702,11.589 42.809,11.855 42.801,12.13 C42.793,12.406 42.672,12.665 42.467,12.848 L40.477,14.623 C41.261,15.997 41.866,17.456 42.283,18.979 L44.944,18.828 C45.216,18.813 45.488,18.91 45.687,19.099 C45.887,19.288 46,19.551 46,19.826 L46,19.826 Z M27,26 C28.103,26 29,26.897 29,28 C29,29.103 28.103,30 27,30 C25.898,30 25,29.103 25,28 C25,26.897 25.898,26 27,26 L27,26 Z M27,32 C29.206,32 31,30.205 31,28 C31,25.794 29.206,24 27,24 C24.794,24 23,25.794 23,28 C23,30.205 24.794,32 27,32 L27,32 Z M28.438,17.09 L30.03,20 L26.779,20 L28.438,17.09 Z M25.057,22 L31.716,22 C32.07,22 32.396,21.814 32.576,21.51 C32.756,21.206 32.763,20.83 32.593,20.52 L29.333,14.56 C29.159,14.242 28.827,14.043 28.465,14.04 C28.138,14.051 27.768,14.23 27.588,14.544 L24.189,20.504 C24.012,20.814 24.013,21.194 24.193,21.502 C24.371,21.81 24.7,22 25.057,22 L25.057,22 Z M16,25 L19,25 L19,22 L16,22 L16,25 Z M15,20 C14.448,20 14,20.448 14,21 L14,26 C14,26.552 14.448,27 15,27 L20,27 C20.553,27 21,26.552 21,26 L21,21 C21,20.448 20.553,20 20,20 L15,20 Z" id="Fill-1" fill="#7AA116"></path>
    </g>
</svg>`, ay = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Storage/Res_Amazon-Simple-Storage-Service_S3-Object-Lock_48</title>
    <g id="Icon-Resource/Storage/Res_Amazon-Simple-Storage-Service_S3-Object-Lock_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M37.5,39.5 C37.5,39.943 37.305,40.336 37,40.611 L37,42 L35,42 L35,40.611 C34.695,40.336 34.5,39.943 34.5,39.5 C34.5,38.672 35.172,38 36,38 C36.828,38 37.5,38.672 37.5,39.5 L37.5,39.5 Z M25.194,28.307 C25.194,29.685 26.315,30.807 27.694,30.807 L27.694,32.807 C25.213,32.807 23.194,30.788 23.194,28.307 C23.194,25.825 25.213,23.807 27.694,23.807 C28.989,23.807 30.223,24.366 31.078,25.34 L29.574,26.66 C29.099,26.118 28.414,25.807 27.694,25.807 C26.315,25.807 25.194,26.928 25.194,28.307 L25.194,28.307 Z M21.416,4 C30.229,4 36.696,6.83 36.832,8.347 L36.812,8.501 C36.796,8.554 36.763,8.608 36.732,8.663 C36.71,8.703 36.695,8.742 36.665,8.783 C36.622,8.84 36.562,8.899 36.505,8.957 C36.466,8.997 36.435,9.036 36.389,9.076 C36.334,9.124 36.262,9.173 36.198,9.221 C36.124,9.276 36.058,9.331 35.972,9.386 C35.952,9.399 35.926,9.412 35.905,9.425 C33.855,10.698 28.568,12 21.416,12 C14.243,12 8.945,10.69 6.91,9.414 C6.896,9.405 6.878,9.396 6.864,9.387 C6.772,9.328 6.701,9.27 6.623,9.211 C6.564,9.167 6.498,9.122 6.447,9.078 C6.398,9.034 6.364,8.992 6.322,8.949 C6.269,8.894 6.211,8.838 6.171,8.784 C6.139,8.741 6.123,8.7 6.1,8.657 C6.071,8.605 6.038,8.552 6.023,8.501 L6.002,8.346 C6.141,6.829 12.606,4 21.416,4 L21.416,4 Z M39.127,22.281 C39.157,22.366 39.163,22.438 39.105,22.553 C39.094,22.577 39.03,22.619 38.919,22.656 C38.469,22.805 37.78,22.789 36.925,22.649 L37.188,20.701 C38.012,21.144 38.939,21.738 39.127,22.281 L39.127,22.281 Z M21.416,38.659 C14.107,38.659 9.853,36.822 9.726,36.074 C9.726,36.03 9.723,35.985 9.717,35.941 L6.415,11.417 C9.658,13.184 15.682,14.096 21.416,14.096 C27.151,14.096 33.176,13.184 36.42,11.417 L34.967,22.201 C31.722,21.299 27.36,19.465 23.985,17.856 C23.91,16.821 23.053,16 22,16 C20.897,16 20,16.897 20,18 C20,19.103 20.897,20 22,20 C22.413,20 22.797,19.874 23.116,19.659 C25.798,20.944 30.722,23.163 34.7,24.188 L34.474,25.867 L36.456,26.133 L36.663,24.597 C37.209,24.681 37.731,24.738 38.192,24.738 C38.711,24.738 39.17,24.68 39.55,24.554 C40.334,24.293 40.714,23.808 40.895,23.447 C41.187,22.863 41.229,22.232 41.016,21.623 C40.523,20.209 38.748,19.216 37.471,18.597 L38.781,8.866 C38.781,8.865 38.781,8.864 38.781,8.863 C38.781,8.862 38.781,8.862 38.781,8.862 L38.825,8.524 C38.831,8.481 38.834,8.438 38.834,8.395 C38.834,4.626 29.654,2 21.416,2 C13.179,2 4,4.626 4,8.395 C4,8.439 4.003,8.483 4.009,8.527 L4.054,8.865 C4.054,8.865 4.054,8.865 4.054,8.865 C4.054,8.865 4.054,8.866 4.054,8.866 L7.728,36.152 C7.853,39.457 15.955,40.659 21.416,40.659 C22.647,40.659 23.883,40.605 25.089,40.498 L24.911,38.505 C23.765,38.607 22.589,38.659 21.416,38.659 L21.416,38.659 Z M12.724,24 L15,20.016 L17.276,24 L12.724,24 Z M19.865,25.502 C20.044,25.194 20.045,24.813 19.868,24.504 L15.868,17.504 C15.513,16.881 14.487,16.881 14.132,17.504 L10.132,24.504 C9.955,24.813 9.956,25.194 10.135,25.502 C10.314,25.81 10.644,26 10.9999958,26 L18.9999958,26 C19.356,26 19.686,25.81 19.865,25.502 L19.865,25.502 Z M15,34 L19,34 L19,30 L15,30 L15,34 Z M14,36 L20,36 C20.553,36 21,35.552 21,35 L21,29 C21,28.448 20.553,28 20,28 L14,28 C13.447,28 13,28.448 13,29 L13,35 C13,35.552 13.447,36 14,36 L14,36 Z M42,44 L30,44 L30,36 L32,36 L40,36 L42,36 L42,44 Z M33,32 C33,30.897 33.897,30 35,30 L37,30 C38.103,30 39,30.897 39,32 L39,34 L33,34 L33,32 Z M43,34 L41,34 L41,32 C41,29.794 39.206,28 37,28 L35,28 C32.794,28 31,29.794 31,32 L31,34 L29,34 C28.447,34 28,34.448 28,35 L28,45 C28,45.552 28.447,46 29,46 L43,46 C43.553,46 44,45.552 44,45 L44,35 C44,34.448 43.553,34 43,34 L43,34 Z" id="Fill-1" fill="#7AA116"></path>
    </g>
</svg>`, Cy = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Storage/Res_AWS-Backup_Virtual-Machine_48</title>
    <g id="Icon-Resource/Storage/Res_AWS-Backup_Virtual-Machine_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M5.4146,44 L10.9996,44 L10.9996,46 L1.9996,46 L1.9996,37 L3.9996,37 L3.9996,42.586 L9.2926,37.293 L10.7066,38.708 L5.4146,44 Z M43.9996,37 L45.9996,37 L45.9996,46 L36.9996,46 L36.9996,44 L42.5856,44 L37.2926,38.707 L38.7066,37.293 L43.9996,42.586 L43.9996,37 Z M3.9996,11 L1.9996,11 L1.9996,2 L10.9996,2 L10.9996,4 L5.4146,4 L10.7066,9.292 L9.2926,10.707 L3.9996,5.414 L3.9996,11 Z M45.9996,2 L45.9996,11 L43.9996,11 L43.9996,5.414 L38.7066,10.707 L37.2926,9.293 L42.5856,4 L36.9996,4 L36.9996,2 L45.9996,2 Z M23.9996,39 C22.8976,39 21.9996,38.103 21.9996,37 C21.9996,35.897 22.8976,35 23.9996,35 C25.1026,35 25.9996,35.897 25.9996,37 C25.9996,38.103 25.1026,39 23.9996,39 L23.9996,39 Z M6.9996,26 C5.8976,26 4.9996,25.103 4.9996,24 C4.9996,22.897 5.8976,22 6.9996,22 C8.1026,22 8.9996,22.897 8.9996,24 C8.9996,25.103 8.1026,26 6.9996,26 L6.9996,26 Z M23.9996,9 C25.1026,9 25.9996,9.897 25.9996,11 C25.9996,12.103 25.1026,13 23.9996,13 C22.8976,13 21.9996,12.103 21.9996,11 C21.9996,9.897 22.8976,9 23.9996,9 L23.9996,9 Z M40.9996,22 C42.1026,22 42.9996,22.897 42.9996,24 C42.9996,25.103 42.1026,26 40.9996,26 C39.8976,26 38.9996,25.103 38.9996,24 C38.9996,22.897 39.8976,22 40.9996,22 L40.9996,22 Z M23.9996,33 C23.2076,33 22.4716,33.239 21.8496,33.638 L10.7586,25.319 C10.9046,24.904 10.9996,24.465 10.9996,24 C10.9996,23.535 10.9046,23.096 10.7586,22.681 L21.8496,14.362 C22.4716,14.761 23.2076,15 23.9996,15 C24.7926,15 25.5276,14.761 26.1506,14.362 L37.2416,22.681 C37.0956,23.096 36.9996,23.535 36.9996,24 C36.9996,24.465 37.0956,24.904 37.2416,25.319 L26.1506,33.638 C25.5276,33.239 24.7926,33 23.9996,33 L23.9996,33 Z M38.3586,26.981 C39.0646,27.607 39.9836,28 40.9996,28 C43.2066,28 44.9996,26.206 44.9996,24 C44.9996,21.794 43.2066,20 40.9996,20 C39.9836,20 39.0646,20.393 38.3586,21.019 L27.5086,12.882 C27.8116,12.318 27.9996,11.684 27.9996,11 C27.9996,8.794 26.2066,7 23.9996,7 C21.7936,7 19.9996,8.794 19.9996,11 C19.9996,11.684 20.1886,12.318 20.4916,12.882 L9.6416,21.019 C8.9356,20.393 8.0166,20 6.9996,20 C4.7936,20 2.9996,21.794 2.9996,24 C2.9996,26.206 4.7936,28 6.9996,28 C8.0166,28 8.9356,27.607 9.6416,26.981 L20.4916,35.118 C20.1886,35.682 19.9996,36.316 19.9996,37 C19.9996,39.206 21.7936,41 23.9996,41 C26.2066,41 27.9996,39.206 27.9996,37 C27.9996,36.316 27.8116,35.682 27.5086,35.118 L38.3586,26.981 Z" id="Fill-1" fill="#7AA116"></path>
    </g>
</svg>`, cy = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Storage/Res_Amazon-Elastic-Block-Store_Volume-gp3_48</title>
    <g id="Icon-Resource/Storage/Res_Amazon-Elastic-Block-Store_Volume-gp3_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M30.0089713,32.759 C29.3049713,32.759 28.6149713,32.612 27.9409713,32.319 L27.9409713,31.285 C28.7429713,31.556 29.4169713,31.692 29.9639713,31.692 C30.4809713,31.692 30.8809713,31.576 31.1609713,31.345 C31.4419713,31.114 31.5819713,30.786 31.5819713,30.361 C31.5819713,29.554 31.0729713,29.151 30.0549713,29.151 C29.7279713,29.151 29.3749713,29.173 28.9969713,29.217 L28.9969713,28.37 L31.1639713,26.016 L28.0509713,26.016 L28.0509713,24.971 L32.5939713,24.971 L32.5939713,25.972 L30.3059713,28.216 C30.4069713,28.209 30.5089713,28.205 30.6099713,28.205 C31.0379713,28.205 31.4259713,28.295 31.7729713,28.474 C32.1199713,28.654 32.3969713,28.909 32.6029713,29.239 C32.8099713,29.569 32.9129713,29.946 32.9129713,30.372 C32.9129713,30.834 32.7959713,31.245 32.5609713,31.604 C32.3259713,31.964 31.9889713,32.246 31.5489713,32.451 C31.1089713,32.656 30.5949713,32.759 30.0089713,32.759 L30.0089713,32.759 Z M22.9579713,28.271 C23.3609713,27.992 23.8009713,27.853 24.2779713,27.853 C24.7469713,27.853 25.0929713,28.009 25.3179713,28.321 C25.5409713,28.632 25.6529713,29.111 25.6529713,29.756 C25.6529713,30.409 25.5389713,30.894 25.3119713,31.214 C25.0849713,31.532 24.7359713,31.692 24.2669713,31.692 C23.8049713,31.692 23.3679713,31.549 22.9579713,31.263 L22.9579713,28.271 Z M22.9579713,32.11 C23.1709713,32.301 23.4199713,32.449 23.7059713,32.555 C23.9919713,32.662 24.2889713,32.715 24.5969713,32.715 C25.0809713,32.715 25.5029713,32.587 25.8619713,32.33 C26.2209713,32.073 26.4959713,31.719 26.6869713,31.268 C26.8779713,30.818 26.9729713,30.299 26.9729713,29.712 C26.9729713,28.832 26.7659713,28.132 26.3509713,27.611 C25.9369713,27.091 25.3819713,26.83 24.6849713,26.83 C24.3469713,26.83 24.0229713,26.892 23.7109713,27.017 C23.3999713,27.142 23.1149713,27.322 22.8589713,27.556 L22.7379713,26.995 L21.6599713,26.995 L21.6599713,34.86 L22.9579713,34.86 L22.9579713,32.11 Z M16.8029713,28.282 C17.0199713,27.989 17.3519713,27.842 17.7989713,27.842 C18.2319713,27.842 18.6389713,27.974 19.0199713,28.238 L19.0199713,31.054 C18.6309713,31.34 18.2199713,31.483 17.7879713,31.483 C16.9149713,31.483 16.4789713,30.867 16.4789713,29.635 C16.4789713,29.027 16.5869713,28.575 16.8029713,28.282 L16.8029713,28.282 Z M17.4029713,32.484 C18.0039713,32.484 18.5429713,32.279 19.0199713,31.868 L19.0199713,32.341 C19.0199713,32.913 18.8949713,33.325 18.6459713,33.578 C18.3969713,33.831 17.9969713,33.958 17.4469713,33.958 C16.9039713,33.958 16.2919713,33.844 15.6099713,33.617 L15.6099713,34.541 C16.2139713,34.842 16.8549713,34.992 17.5329713,34.992 C18.4249713,34.992 19.1119713,34.75 19.5939713,34.266 C20.0769713,33.782 20.3179713,33.096 20.3179713,32.209 L20.3179713,26.995 L19.2179713,26.995 L19.1079713,27.501 C18.6389713,27.054 18.0849713,26.83 17.4469713,26.83 C16.9779713,26.83 16.5709713,26.951 16.2259713,27.193 C15.8809713,27.435 15.6169713,27.77 15.4339713,28.199 C15.2509713,28.629 15.1589713,29.122 15.1589713,29.679 C15.1589713,30.53 15.3629713,31.21 15.7699713,31.719 C16.1759713,32.229 16.7209713,32.484 17.4029713,32.484 L17.4029713,32.484 Z M8.06897127,44 L40.0689713,44 L40.0689713,15 L8.06897127,15 L8.06897127,44 Z M41.0689713,13 L7.06897127,13 C6.51697127,13 6.06897127,13.448 6.06897127,14 L6.06897127,45 C6.06897127,45.552 6.51697127,46 7.06897127,46 L41.0689713,46 C41.6209713,46 42.0689713,45.552 42.0689713,45 L42.0689713,14 C42.0689713,13.448 41.6209713,13 41.0689713,13 L41.0689713,13 Z M13.5329713,4 L34.4679713,4.002 L38.9929713,10 L9.00697127,10 L13.5329713,4 Z M6.99997127,12 L40.9999713,12 C41.3799713,12 41.7259713,11.786 41.8949713,11.446 C42.0639713,11.107 42.0269713,10.701 41.7989713,10.398 L35.7649713,2.4 C35.5759713,2.15 35.2799713,2.002 34.9669713,2.002 L13.0349713,2 C12.7209713,2 12.4259713,2.148 12.2369713,2.398 L6.20197127,10.398 C5.97297127,10.701 5.93597127,11.107 6.10497127,11.446 C6.27397127,11.786 6.62097127,12 6.99997127,12 L6.99997127,12 Z" id="Fill-1" fill="#7AA116"></path>
    </g>
</svg>`, uy = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Storage/Res_Amazon-Elastic-File-System_File-System_48</title>
    <g id="Icon-Resource/Storage/Res_Amazon-Elastic-File-System_File-System_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M37.2366623,11.621 L42.2336623,11.621 L42.2336623,6.624 L37.2366623,6.624 L37.2366623,11.621 Z M36.1116623,13.595 L36.1116623,15.245 L38.1116623,15.245 L38.1116623,13.621 L38.7356623,13.621 L38.7356623,15.245 L40.7356623,15.245 L40.7356623,13.621 L41.3596623,13.621 L41.3596623,15.245 L43.3596623,15.245 L43.3596623,13.595 C43.8066623,13.537 44.1496623,13.193 44.2076623,12.746 L45.8576623,12.746 L45.8576623,10.746 L44.2336623,10.746 L44.2336623,10.123 L45.8576623,10.123 L45.8576623,8.123 L44.2336623,8.123 L44.2336623,7.499 L45.8576623,7.499 L45.8576623,5.499 L44.2076623,5.499 C44.1496623,5.051 43.8066623,4.708 43.3596623,4.649 L43.3596623,3 L41.3596623,3 L41.3596623,4.624 L40.7356623,4.624 L40.7356623,3 L38.7356623,3 L38.7356623,4.624 L38.1116623,4.624 L38.1116623,3 L36.1116623,3 L36.1116623,4.649 C35.6626623,4.708 35.3206623,5.05 35.2616623,5.499 L33.6126623,5.499 L33.6126623,7.499 L35.2366623,7.499 L35.2366623,8.123 L33.6126623,8.123 L33.6126623,10.123 L35.2366623,10.123 L35.2366623,10.746 L33.6126623,10.746 L33.6126623,12.746 L35.2616623,12.746 C35.3206623,13.194 35.6626623,13.537 36.1116623,13.595 L36.1116623,13.595 Z M22.3676623,11.621 L27.3646623,11.621 L27.3646623,6.624 L22.3676623,6.624 L22.3676623,11.621 Z M21.2426623,13.595 L21.2426623,15.245 L23.2426623,15.245 L23.2426623,13.621 L23.8666623,13.621 L23.8666623,15.245 L25.8666623,15.245 L25.8666623,13.621 L26.4906623,13.621 L26.4906623,15.245 L28.4906623,15.245 L28.4906623,13.595 C28.9376623,13.537 29.2806623,13.193 29.3386623,12.746 L30.9886623,12.746 L30.9886623,10.746 L29.3646623,10.746 L29.3646623,10.123 L30.9886623,10.123 L30.9886623,8.123 L29.3646623,8.123 L29.3646623,7.499 L30.9886623,7.499 L30.9886623,5.499 L29.3386623,5.499 C29.2806623,5.051 28.9376623,4.708 28.4906623,4.649 L28.4906623,3 L26.4906623,3 L26.4906623,4.624 L25.8666623,4.624 L25.8666623,3 L23.8666623,3 L23.8666623,4.624 L23.2426623,4.624 L23.2426623,3 L21.2426623,3 L21.2426623,4.649 C20.7936623,4.708 20.4506623,5.05 20.3926623,5.499 L18.7426623,5.499 L18.7426623,7.499 L20.3676623,7.499 L20.3676623,8.123 L18.7426623,8.123 L18.7426623,10.123 L20.3676623,10.123 L20.3676623,10.746 L18.7426623,10.746 L18.7426623,12.746 L20.3926623,12.746 C20.4506623,13.194 20.7936623,13.537 21.2426623,13.595 L21.2426623,13.595 Z M7.49866234,11.621 L12.4956623,11.621 L12.4956623,6.624 L7.49866234,6.624 L7.49866234,11.621 Z M6.37266234,13.595 L6.37266234,15.245 L8.37266234,15.245 L8.37266234,13.621 L8.99666234,13.621 L8.99666234,15.245 L10.9966623,15.245 L10.9966623,13.621 L11.6206623,13.621 L11.6206623,15.245 L13.6206623,15.245 L13.6206623,13.595 C14.0696623,13.537 14.4116623,13.194 14.4706623,12.746 L16.1196623,12.746 L16.1196623,10.746 L14.4956623,10.746 L14.4956623,10.123 L16.1196623,10.123 L16.1196623,8.123 L14.4956623,8.123 L14.4956623,7.499 L16.1196623,7.499 L16.1196623,5.499 L14.4706623,5.499 C14.4116623,5.05 14.0696623,4.708 13.6206623,4.649 L13.6206623,3 L11.6206623,3 L11.6206623,4.624 L10.9966623,4.624 L10.9966623,3 L8.99666234,3 L8.99666234,4.624 L8.37266234,4.624 L8.37266234,3 L6.37266234,3 L6.37266234,4.649 C5.92566234,4.708 5.58166234,5.051 5.52466234,5.499 L3.87466234,5.499 L3.87466234,7.499 L5.49866234,7.499 L5.49866234,8.123 L3.87466234,8.123 L3.87466234,10.123 L5.49866234,10.123 L5.49866234,10.746 L3.87466234,10.746 L3.87466234,12.746 L5.52466234,12.746 C5.58166234,13.193 5.92566234,13.537 6.37266234,13.595 L6.37266234,13.595 Z M37.3346623,28.477 L43.4426623,42.23 L10.6516623,42.23 L4.53866234,28.477 L37.3346623,28.477 Z M6.87666234,24.979 L39.8116623,24.979 L41.7386623,33.463 L38.8996623,27.071 C38.7396623,26.709 38.3806623,26.477 37.9856623,26.477 L7.21766234,26.477 L6.87666234,24.979 Z M10.9966623,22.361 C10.9966623,21.828 11.4186623,21.393 11.9386623,21.393 L31.4436623,21.393 C31.9956623,21.393 32.4436623,20.946 32.4436623,20.393 L32.4436623,18.25 C32.4436623,18.092 32.5546623,17.973 32.7026623,17.973 L36.9456623,17.973 C37.0956623,17.973 37.2126623,18.094 37.2126623,18.25 L37.2126623,20.393 C37.2126623,20.946 37.6596623,21.393 38.2126623,21.393 L43.0406623,21.393 C43.5606623,21.393 43.9826623,21.828 43.9826623,22.361 L43.9826623,34.311 L41.5846623,23.757 C41.4816623,23.302 41.0756623,22.979 40.6096623,22.979 L10.9966623,22.979 L10.9966623,22.361 Z M43.0406623,19.393 L39.2126623,19.393 L39.2126623,18.25 C39.2126623,16.995 38.1956623,15.973 36.9456623,15.973 L32.7026623,15.973 C31.4566623,15.973 30.4436623,16.995 30.4436623,18.25 L30.4436623,19.393 L11.9386623,19.393 C10.3166623,19.393 8.99666234,20.724 8.99666234,22.361 L8.99666234,22.979 L5.62366234,22.979 C5.31966234,22.979 5.03266234,23.118 4.84266234,23.355 C4.65266234,23.593 4.58066234,23.904 4.64966234,24.201 L5.16666234,26.477 L2.99966234,26.477 C2.66066234,26.477 2.34566234,26.648 2.16066234,26.932 C1.97766234,27.216 1.94866234,27.574 2.08566234,27.883 L9.07266234,43.604 C9.22066234,43.97 9.57666234,44.23 9.99666234,44.23 L44.9826623,44.23 C45.5346623,44.23 45.9826623,43.783 45.9826623,43.23 L45.9826623,22.361 C45.9826623,20.724 44.6626623,19.393 43.0406623,19.393 L43.0406623,19.393 Z" id="AWS-Amazon-Elastic-File-System_File-system_Resource-Icon_light-bg" fill="#7AA116"></path>
    </g>
</svg>`, hy = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Storage/Res_AWS-Snowball_Snowball-Import-Export_48</title>
    <g id="Icon-Resource/Storage/Res_AWS-Snowball_Snowball-Import-Export_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M2.1262,26.4736 L22.4362,26.4736 L18.9202,30.0096 L20.3382,31.4196 L25.5502,26.1786 C25.9382,25.7886 25.9382,25.1586 25.5502,24.7686 L20.3382,19.5266 L18.9202,20.9366 L22.4372,24.4736 L2.1262,24.4736 L2.1262,26.4736 Z M45.6092,24.7686 L40.3972,19.5266 L38.9802,20.9366 L42.4962,24.4736 L27.4622,24.4736 L27.4622,26.4736 L42.4952,26.4736 L38.9802,30.0096 L40.3972,31.4196 L45.6092,26.1786 C45.9972,25.7886 45.9972,25.1586 45.6092,24.7686 L45.6092,24.7686 Z M20.4732,12.4946 L27.4622,12.4946 L27.4622,10.4946 L20.4732,10.4946 L20.4732,12.4946 Z M37.1982,30.7146 L37.1982,28.0946 L35.1982,28.0946 L35.1982,29.7146 L23.9682,29.7146 L23.9682,31.7146 L36.1982,31.7146 C36.7512,31.7146 37.1982,31.2676 37.1982,30.7146 L37.1982,30.7146 Z M11.6102,28.0946 L11.6102,30.7146 C11.6102,31.2676 12.0582,31.7146 12.6102,31.7146 L17.8522,31.7146 L17.8522,29.7146 L13.6102,29.7146 L13.6102,28.0946 L11.6102,28.0946 Z M11.6102,19.3576 L11.6102,22.8526 L13.6102,22.8526 L13.6102,20.3576 L17.8522,20.3576 L17.8522,18.3576 L12.6102,18.3576 C12.0582,18.3576 11.6102,18.8046 11.6102,19.3576 L11.6102,19.3576 Z M37.1982,22.8526 L37.1982,19.3576 C37.1982,18.8046 36.7512,18.3576 36.1982,18.3576 L23.9682,18.3576 L23.9682,20.3576 L35.1982,20.3576 L35.1982,22.8526 L37.1982,22.8526 Z M41.1082,6.9996 L6.8262,6.9996 C4.1652,6.9996 2.0002,9.2286 2.0002,11.9666 L2.0002,22.8526 L4.0002,22.8526 L4.0002,11.9666 C4.0002,10.3306 5.2682,8.9996 6.8262,8.9996 L41.1082,8.9996 C42.6672,8.9996 43.9362,10.3306 43.9362,11.9666 L43.9362,21.7866 L45.9362,21.7866 L45.9362,11.9666 C45.9362,9.2286 43.7712,6.9996 41.1082,6.9996 L41.1082,6.9996 Z M43.9362,36.3596 C43.9362,37.9946 42.6672,39.3256 41.1082,39.3256 L6.8262,39.3256 C5.2682,39.3256 4.0002,37.9946 4.0002,36.3596 L4.0002,28.0946 L2.0002,28.0946 L2.0002,36.3596 C2.0002,39.0976 4.1652,41.3256 6.8262,41.3256 L41.1082,41.3256 C43.7712,41.3256 45.9362,39.0976 45.9362,36.3596 L45.9362,29.1606 L43.9362,29.1606 L43.9362,36.3596 Z M5.4942,28.0946 L5.4942,34.9256 C5.4942,36.5276 6.7942,37.8306 8.3912,37.8306 L39.5452,37.8306 C41.1422,37.8306 42.4402,36.5276 42.4402,34.9256 L42.4402,32.4626 L40.4402,32.4626 L40.4402,34.9256 C40.4402,35.4156 40.0302,35.8306 39.5452,35.8306 L8.3912,35.8306 C7.9042,35.8306 7.4942,35.4156 7.4942,34.9256 L7.4942,28.0946 L5.4942,28.0946 Z M18.8902,13.9896 L29.0452,13.9896 L30.0112,11.1706 C30.1492,10.7666 30.5292,10.4946 30.9572,10.4946 L39.5452,10.4946 C41.1422,10.4946 42.4402,11.7976 42.4402,13.3996 L42.4402,18.4846 L40.4402,18.4846 L40.4402,13.3996 C40.4402,12.9096 40.0302,12.4946 39.5452,12.4946 L31.6722,12.4946 L30.7062,15.3136 C30.5672,15.7176 30.1882,15.9896 29.7602,15.9896 L18.1752,15.9896 C17.7472,15.9896 17.3672,15.7176 17.2292,15.3136 L16.2642,12.4946 L8.3912,12.4946 C7.9042,12.4946 7.4942,12.9096 7.4942,13.3996 L7.4942,22.8526 L5.4942,22.8526 L5.4942,13.3996 C5.4942,11.7976 6.7942,10.4946 8.3912,10.4946 L16.9792,10.4946 C17.4062,10.4946 17.7862,10.7666 17.9252,11.1706 L18.8902,13.9896 Z" id="AWS-Snowball_Snowball-import-export_Resource-Icon_light-bg" fill="#7AA116"></path>
    </g>
</svg>`, dy = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Storage/Res_Amazon-Simple-Storage-Service_Object_48</title>
    <g id="Icon-Resource/Storage/Res_Amazon-Simple-Storage-Service_Object_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M23.971,43.9414 C12.959,43.9414 4,34.9824 4,23.9704 C4,12.9594 12.959,4.0004 23.971,4.0004 C34.983,4.0004 43.942,12.9594 43.942,23.9704 C43.942,34.9824 34.983,43.9414 23.971,43.9414 M23.971,2.0004 C11.857,2.0004 2,11.8564 2,23.9704 C2,36.0854 11.857,45.9414 23.971,45.9414 C36.085,45.9414 45.942,36.0854 45.942,23.9704 C45.942,11.8564 36.085,2.0004 23.971,2.0004" id="AWS-Amazon-Simple-Storage_Object_Resource-Icon_dark-bg" fill="#7AA116"></path>
    </g>
</svg>`, gy = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Storage/Res_AWS-Storage-Gateway_Cached-Volume_48</title>
    <g id="Icon-Resource/Storage/Res_AWS-Storage-Gateway_Cached-Volume_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M36.5442,14.3457 L32.8672,14.3457 L32.8672,7.0877 L36.5442,7.0877 L36.5442,7.9047 L33.8832,7.9047 L33.8832,10.1887 L36.0832,10.1887 L36.0832,11.0047 L33.8832,11.0047 L33.8832,13.5297 L36.5442,13.5297 L36.5442,14.3457 Z M27.6412,14.3457 L26.6252,14.3457 L26.6252,7.0877 L27.6412,7.0877 L27.6412,10.2187 L30.2802,10.2187 L30.2802,7.0877 L31.2972,7.0877 L31.2972,14.3457 L30.2802,14.3457 L30.2802,11.0467 L27.6412,11.0467 L27.6412,14.3457 Z M21.2112,10.7427 C21.2112,9.5207 21.4522,8.5927 21.9342,7.9567 C22.4142,7.3227 23.1242,7.0047 24.0592,7.0047 C24.5062,7.0047 24.9562,7.0987 25.4102,7.2867 L25.4102,8.1147 C24.9422,7.9677 24.5312,7.8947 24.1752,7.8947 C23.5192,7.8947 23.0382,8.1097 22.7342,8.5377 C22.4312,8.9677 22.2792,9.6577 22.2792,10.6077 L22.2792,10.8587 C22.2792,11.8087 22.4262,12.4947 22.7192,12.9217 C23.0122,13.3477 23.4832,13.5607 24.1332,13.5607 C24.4462,13.5607 24.9002,13.4727 25.4932,13.2977 L25.4932,14.1257 C25.0402,14.3417 24.5482,14.4497 24.0182,14.4497 C22.1472,14.4497 21.2112,13.2147 21.2112,10.7427 L21.2112,10.7427 Z M18.0902,8.0617 L18.9902,11.6127 L17.1892,11.6127 L18.0902,8.0617 Z M17.0012,12.3877 L19.1902,12.3877 L19.6912,14.3457 L20.7602,14.3457 L18.6652,7.0877 L17.5662,7.0877 L15.4722,14.3457 L16.5082,14.3457 L17.0012,12.3877 Z M10.7492,10.7427 C10.7492,9.5207 10.9902,8.5927 11.4722,7.9567 C11.9522,7.3227 12.6612,7.0047 13.5972,7.0047 C14.0442,7.0047 14.4942,7.0987 14.9482,7.2867 L14.9482,8.1147 C14.4812,7.9677 14.0692,7.8947 13.7132,7.8947 C13.0572,7.8947 12.5762,8.1097 12.2732,8.5377 C11.9692,8.9677 11.8172,9.6577 11.8172,10.6077 L11.8172,10.8587 C11.8172,11.8087 11.9642,12.4947 12.2572,12.9217 C12.5502,13.3477 13.0222,13.5607 13.6712,13.5607 C13.9842,13.5607 14.4392,13.4727 15.0312,13.2977 L15.0312,14.1257 C14.5782,14.3417 14.0862,14.4497 13.5562,14.4497 C11.6852,14.4497 10.7492,13.2147 10.7492,10.7427 L10.7492,10.7427 Z M39.1642,43.8917 L30.6912,43.8917 L30.6912,38.7827 C30.6912,38.2297 30.2442,37.7827 29.6912,37.7827 L17.4732,37.7827 C16.9202,37.7827 16.4732,38.2297 16.4732,38.7827 L16.4732,43.8917 L8.0002,43.8917 L8.0002,3.9997 L39.1642,3.9997 L39.1642,43.8917 Z M40.1642,1.9997 L7.0002,1.9997 C6.4472,1.9997 6.0002,2.4477 6.0002,2.9997 L6.0002,44.8917 C6.0002,45.4447 6.4472,45.8917 7.0002,45.8917 L17.4732,45.8917 C18.0252,45.8917 18.4732,45.4447 18.4732,44.8917 L18.4732,39.7827 L28.6912,39.7827 L28.6912,44.8917 C28.6912,45.4447 29.1392,45.8917 29.6912,45.8917 L40.1642,45.8917 C40.7172,45.8917 41.1642,45.4447 41.1642,44.8917 L41.1642,2.9997 C41.1642,2.4477 40.7172,1.9997 40.1642,1.9997 L40.1642,1.9997 Z" id="AWS-Storage-Gateway_Cached-volume_Resource-Icon_light-bg" fill="#7AA116"></path>
    </g>
</svg>`, fy = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Storage/Res_Amazon-Simple-Storage-Service_S3-Object-Lambda_48</title>
    <g id="Icon-Resource/Storage/Res_Amazon-Simple-Storage-Service_S3-Object-Lambda_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M36.128,31.9852352 L36.169,31.6732352 C36.42,31.8382352 36.626,31.9842352 36.78,32.1062352 C36.603,32.0812352 36.386,32.0422352 36.128,31.9852352 L36.128,31.9852352 Z M31.556,42.8602352 C31.065,43.0542352 30.482,43.2292352 29.823,43.3812352 C28.107,43.7772352 26.001,43.9962352 23.891,43.9962352 C18.745,43.9962352 15.337,42.7672352 15.042,42.2142352 C15.042,42.1692352 15.039,42.1242352 15.033,42.0802352 L12.525,23.4592352 C12.553,23.4712352 12.586,23.4822352 12.613,23.4942352 C12.935,23.6442352 13.277,23.7842352 13.643,23.9142352 C13.721,23.9432352 13.806,23.9672352 13.886,23.9942352 C14.192,24.0972352 14.51,24.1942352 14.839,24.2852352 C14.956,24.3172352 15.073,24.3492352 15.193,24.3802352 C15.578,24.4792352 15.973,24.5712352 16.378,24.6542352 C16.408,24.6612352 16.438,24.6682352 16.468,24.6742352 C16.905,24.7622352 17.355,24.8392352 17.807,24.9092352 C17.934,24.9292352 18.061,24.9472352 18.189,24.9652352 C18.551,25.0182352 18.913,25.0652352 19.276,25.1072352 C19.382,25.1192352 19.485,25.1322352 19.59,25.1442352 C20.043,25.1922352 20.494,25.2332352 20.94,25.2662352 C21.039,25.2732352 21.134,25.2782352 21.232,25.2842352 C21.593,25.3092352 21.946,25.3282352 22.296,25.3422352 C22.416,25.3472352 22.535,25.3522352 22.653,25.3562352 C23.078,25.3702352 23.495,25.3802352 23.891,25.3802352 C24.357,25.3802352 24.827,25.3692352 25.299,25.3542352 C25.432,25.3492352 25.565,25.3432352 25.698,25.3382352 C26.065,25.3222352 26.43,25.3022352 26.795,25.2782352 C26.916,25.2702352 27.036,25.2632352 27.157,25.2542352 C27.627,25.2182352 28.095,25.1752352 28.557,25.1242352 C28.63,25.1152352 28.7,25.1052352 28.773,25.0962352 C29.164,25.0502352 29.551,24.9982352 29.932,24.9402352 C30.061,24.9212352 30.188,24.9012352 30.316,24.8802352 C30.677,24.8202352 31.031,24.7552352 31.379,24.6852352 C31.464,24.6682352 31.552,24.6522352 31.636,24.6342352 C32.054,24.5462352 32.456,24.4482352 32.846,24.3422352 C32.939,24.3172352 33.026,24.2892352 33.118,24.2632352 C33.417,24.1772352 33.704,24.0872352 33.982,23.9902352 C34.086,23.9542352 34.19,23.9182352 34.29,23.8812352 C34.603,23.7642352 34.9,23.6422352 35.177,23.5112352 C35.201,23.5002352 35.232,23.4902352 35.257,23.4782352 L34.19,31.4362352 C31.363,30.5082352 27.803,28.9092352 25.898,28.0222352 C25.695,27.4332352 25.142,27.0072352 24.485,27.0072352 C23.658,27.0072352 22.985,27.6802352 22.985,28.5072352 C22.985,29.3342352 23.658,30.0072352 24.485,30.0072352 C24.711,30.0072352 24.923,29.9532352 25.115,29.8632352 C27.305,30.8842352 30.999,32.5312352 33.92,33.4512352 L32.755,42.1362352 C32.713,42.2232352 32.415,42.5212352 31.556,42.8602352 L31.556,42.8602352 Z M39.289,32.2562352 C39.127,31.3952352 38.266,30.5572352 36.461,29.5082352 L37.59,21.1272352 L37.59,21.1262352 L37.625,20.8642352 C37.631,20.8202352 37.634,20.7762352 37.634,20.7312352 C37.634,19.5292352 36.626,18.4662352 34.639,17.5712352 L33.818,19.3952352 C35.205,20.0202352 35.582,20.5482352 35.629,20.7032352 L35.621,20.7602352 C35.611,20.7892352 35.591,20.8212352 35.573,20.8522352 C35.557,20.8812352 35.543,20.9092352 35.519,20.9392352 C35.493,20.9702352 35.458,21.0042352 35.425,21.0372352 C35.393,21.0682352 35.363,21.0992352 35.324,21.1322352 C35.284,21.1652352 35.233,21.2002352 35.186,21.2342352 C35.138,21.2682352 35.093,21.3022352 35.037,21.3382352 C34.983,21.3722352 34.919,21.4062352 34.858,21.4412352 C34.795,21.4772352 34.733,21.5132352 34.662,21.5502352 C34.594,21.5862352 34.515,21.6212352 34.44,21.6562352 C34.361,21.6932352 34.286,21.7312352 34.199,21.7682352 C34.118,21.8032352 34.026,21.8382352 33.939,21.8732352 C33.844,21.9102352 33.753,21.9482352 33.65,21.9852352 C33.556,22.0212352 33.451,22.0552352 33.35,22.0892352 C33.241,22.1262352 33.136,22.1642352 33.02,22.2002352 C32.911,22.2352352 32.791,22.2682352 32.676,22.3012352 C32.554,22.3372352 32.436,22.3732352 32.307,22.4082352 C32.185,22.4412352 32.052,22.4722352 31.923,22.5042352 C31.787,22.5382352 31.656,22.5722352 31.513,22.6052352 C31.378,22.6362352 31.232,22.6652352 31.09,22.6952352 C30.941,22.7262352 30.798,22.7582352 30.643,22.7882352 C30.49,22.8182352 30.326,22.8442352 30.168,22.8722352 C30.011,22.8992352 29.859,22.9272352 29.697,22.9532352 C29.524,22.9802352 29.341,23.0042352 29.162,23.0292352 C29,23.0512352 28.844,23.0762352 28.677,23.0962352 C28.484,23.1202352 28.281,23.1402352 28.082,23.1612352 C27.916,23.1792352 27.755,23.1992352 27.584,23.2142352 C27.366,23.2352352 27.136,23.2502352 26.91,23.2662352 C26.746,23.2782352 26.589,23.2932352 26.421,23.3032352 C26.165,23.3192352 25.898,23.3292352 25.633,23.3392352 C25.483,23.3462352 25.341,23.3552352 25.189,23.3602352 C24.767,23.3732352 24.334,23.3802352 23.891,23.3802352 C23.447,23.3802352 23.016,23.3732352 22.594,23.3602352 C22.437,23.3552352 22.288,23.3452352 22.134,23.3392352 C21.875,23.3282352 21.612,23.3192352 21.361,23.3032352 C21.192,23.2932352 21.033,23.2782352 20.868,23.2662352 C20.644,23.2502352 20.416,23.2352352 20.198,23.2142352 C20.029,23.1992352 19.869,23.1792352 19.704,23.1622352 C19.504,23.1402352 19.299,23.1212352 19.106,23.0962352 C18.94,23.0762352 18.783,23.0512352 18.622,23.0292352 C18.443,23.0042352 18.259,22.9812352 18.086,22.9532352 C17.923,22.9272352 17.77,22.8992352 17.612,22.8712352 C17.454,22.8442352 17.293,22.8182352 17.142,22.7892352 C16.984,22.7582352 16.839,22.7262352 16.689,22.6942352 C16.549,22.6652352 16.404,22.6362352 16.272,22.6062352 C16.127,22.5722352 15.994,22.5382352 15.857,22.5042352 C15.731,22.4722352 15.599,22.4412352 15.478,22.4082352 C15.346,22.3732352 15.226,22.3362352 15.101,22.2992352 C14.988,22.2672352 14.872,22.2352352 14.766,22.2012352 C14.647,22.1632352 14.538,22.1252352 14.426,22.0872352 C14.328,22.0532352 14.227,22.0202352 14.135,21.9862352 C14.03,21.9482352 13.939,21.9102352 13.842,21.8722352 C13.756,21.8372352 13.665,21.8032352 13.585,21.7682352 C13.498,21.7312352 13.422,21.6932352 13.342,21.6562352 C13.268,21.6212352 13.19,21.5862352 13.122,21.5512352 C13.051,21.5142352 12.99,21.4782352 12.926,21.4422352 C12.865,21.4072352 12.801,21.3722352 12.746,21.3382352 C12.691,21.3032352 12.647,21.2692352 12.599,21.2352352 C12.551,21.2012352 12.5,21.1662352 12.46,21.1322352 C12.421,21.1002352 12.392,21.0692352 12.36,21.0382352 C12.326,21.0052352 12.29,20.9712352 12.265,20.9392352 C12.241,20.9102352 12.228,20.8832352 12.212,20.8552352 C12.192,20.8232352 12.172,20.7912352 12.162,20.7602352 L12.155,20.7032352 C12.2,20.5492352 12.581,20.0152352 13.988,19.3842352 L13.172,17.5592352 C11.167,18.4572352 10.15,19.5242352 10.15,20.7312352 C10.15,20.7752352 10.153,20.8182352 10.159,20.8602352 L10.193,21.1232352 L10.193,21.1232352 L10.193,21.1272352 L13.044,42.2932352 C13.168,45.2192352 20.172,45.9962352 23.891,45.9962352 C26.148,45.9962352 28.415,45.7592352 30.274,45.3302352 C31.028,45.1562352 31.707,44.9512352 32.29,44.7212352 C33.874,44.0942352 34.697,43.2782352 34.739,42.2932352 L35.86,33.9692352 C36.412,34.0822352 36.896,34.1462352 37.302,34.1462352 C38.077,34.1462352 38.607,33.9392352 38.957,33.5212352 C39.257,33.1642352 39.375,32.7152352 39.289,32.2562352 L39.289,32.2562352 Z M17.888,32.0072352 L18.829,30.4382352 L19.771,32.0072352 L17.888,32.0072352 Z M22.406,33.5002352 C22.584,33.1862352 22.579,32.8012352 22.394,32.4922352 L19.687,27.9802352 C19.506,27.6792352 19.181,27.4952352 18.829,27.4952352 C18.478,27.4952352 18.152,27.6792352 17.972,27.9802352 L15.264,32.4922352 C15.078,32.8012352 15.073,33.1862352 15.251,33.5002352 C15.429,33.8132352 15.761,34.0072352 16.121,34.0072352 L21.536,34.0072352 C21.897,34.0072352 22.229,33.8132352 22.406,33.5002352 L22.406,33.5002352 Z M28.485,38.0072352 C27.658,38.0072352 26.985,37.3342352 26.985,36.5072352 C26.985,35.6802352 27.658,35.0072352 28.485,35.0072352 C29.313,35.0072352 29.985,35.6802352 29.985,36.5072352 C29.985,37.3342352 29.313,38.0072352 28.485,38.0072352 L28.485,38.0072352 Z M28.485,33.0072352 C26.556,33.0072352 24.985,34.5772352 24.985,36.5072352 C24.985,38.4372352 26.556,40.0072352 28.485,40.0072352 C30.415,40.0072352 31.985,38.4372352 31.985,36.5072352 C31.985,34.5772352 30.415,33.0072352 28.485,33.0072352 L28.485,33.0072352 Z M18.985,40.0072352 L20.985,40.0072352 L20.985,38.0072352 L18.985,38.0072352 L18.985,40.0072352 Z M21.985,36.0072352 L17.985,36.0072352 C17.433,36.0072352 16.985,36.4552352 16.985,37.0072352 L16.985,41.0072352 C16.985,41.5592352 17.433,42.0072352 17.985,42.0072352 L21.985,42.0072352 C22.538,42.0072352 22.985,41.5592352 22.985,41.0072352 L22.985,37.0072352 C22.985,36.4552352 22.538,36.0072352 21.985,36.0072352 L21.985,36.0072352 Z M22.842,10.9022352 C23.136,10.5962352 23.529,10.4422352 23.923,10.4422352 C24.297,10.4422352 24.672,10.5812352 24.962,10.8602352 C25.559,11.4332352 25.577,12.3842352 25.004,12.9812352 C24.726,13.2702352 24.353,13.4332352 23.952,13.4412352 C23.551,13.4352352 23.172,13.3002352 22.883,13.0222352 C22.595,12.7452352 22.431,12.3712352 22.423,11.9712352 C22.415,11.5702352 22.565,11.1902352 22.842,10.9022352 L22.842,10.9022352 Z M23.922,15.4402352 C24.841,15.4402352 25.76,15.0802352 26.445,14.3672352 C27.783,12.9762352 27.739,10.7562352 26.349,9.41823523 C24.957,8.08123523 22.736,8.12523523 21.4,9.51523523 C20.752,10.1892352 20.405,11.0752352 20.424,12.0092352 C20.441,12.9442352 20.823,13.8172352 21.497,14.4642352 C22.175,15.1162352 23.049,15.4402352 23.922,15.4402352 L23.922,15.4402352 Z M18.213,11.9052352 C18.467,11.7892352 18.66,11.5712352 18.747,11.3062352 L19.186,9.96023523 C19.272,9.69423523 19.243,9.40423523 19.107,9.16023523 L17.911,7.03323523 L20.836,4.91223523 L22.477,6.69323523 C22.666,6.89923523 22.933,7.01623523 23.212,7.01623523 L23.218,7.01623523 L24.673,7.00723523 C24.95,7.00623523 25.214,6.88923523 25.402,6.68523523 L27.032,4.91723523 L29.953,7.04323523 L28.763,9.16123523 C28.627,9.40223523 28.598,9.69023523 28.682,9.95423523 L29.115,11.3152352 C29.201,11.5832352 29.396,11.8022352 29.65,11.9202352 L31.863,12.9372352 L30.745,16.3722352 L28.355,15.8922352 C28.082,15.8362352 27.793,15.9002352 27.567,16.0662352 L26.411,16.9122352 C26.187,17.0762352 26.041,17.3262352 26.009,17.6032352 L25.727,20.0112352 L22.114,20.0082352 L21.836,17.6172352 C21.804,17.3432352 21.66,17.0942352 21.438,16.9292352 L20.268,16.0642352 C20.04,15.8962352 19.753,15.8312352 19.477,15.8872352 L17.105,16.3612352 L15.992,12.9242352 L18.213,11.9052352 Z M15.477,17.8242352 C15.633,18.3082352 16.122,18.5932352 16.624,18.4972352 L19.435,17.9352352 L19.899,18.2792352 L20.231,21.1232352 C20.289,21.6262352 20.716,22.0062352 21.223,22.0072352 L26.615,22.0122352 L26.616,22.0122352 C27.123,22.0122352 27.551,21.6322352 27.609,21.1292352 L27.944,18.2682352 L28.394,17.9402352 L31.225,18.5072352 C31.715,18.6052352 32.214,18.3192352 32.372,17.8372352 L34.041,12.7092352 C34.198,12.2272352 33.969,11.7032352 33.508,11.4912352 L30.887,10.2872352 L30.72,9.76123523 L32.133,7.24723523 C32.381,6.80523523 32.259,6.24723523 31.849,5.94823523 L27.488,2.77623523 C27.077,2.47823523 26.51,2.53323523 26.165,2.90723523 L24.227,5.00923523 L23.649,5.01323523 L21.704,2.90323523 C21.36,2.52823523 20.789,2.47323523 20.382,2.77123523 L16.017,5.93723523 C15.606,6.23523523 15.483,6.79423523 15.732,7.23623523 L17.148,9.75723523 L16.981,10.2702352 L14.35,11.4772352 C13.889,11.6892352 13.659,12.2122352 13.816,12.6942352 L15.477,17.8242352 Z" id="Fill-1" fill="#7AA116"></path>
    </g>
</svg>`, py = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Storage/Res_AWS-Backup_Gateway_48</title>
    <g id="Icon-Resource/Storage/Res_AWS-Backup_Gateway_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M42,21 C40.897,21 40,20.103 40,19 C40,17.897 40.897,17 42,17 C43.103,17 44,17.897 44,19 C44,20.103 43.103,21 42,21 L42,21 Z M34.296,37.03 C34.196,37.022 34.101,37 34,37 C33.268,37 32.588,37.204 32,37.549 L32,20.659 C32,20.364 31.87,20.083 31.644,19.894 L31.528,19.796 C27.106,16.056 20.72,16.102 16.344,19.904 C16.126,20.094 16,20.369 16,20.659 L16,37.549 C15.412,37.204 14.732,37 14,37 C13.899,37 13.804,37.022 13.704,37.03 L8.195,22.338 C9.28,21.622 10,20.395 10,19 C10,18.511 9.899,18.047 9.738,17.613 L21.812,9.341 C22.442,9.755 23.192,10 24,10 C24.808,10 25.558,9.755 26.188,9.341 L38.262,17.613 C38.101,18.047 38,18.511 38,19 C38,20.395 38.72,21.622 39.805,22.338 L34.296,37.03 Z M34,43 C32.897,43 32,42.103 32,41 C32,39.897 32.897,39 34,39 C35.103,39 36,39.897 36,41 C36,42.103 35.103,43 34,43 L34,43 Z M18,40 L18,21.127 C21.576,18.276 26.41,18.27 30,21.129 L30,40 L18,40 Z M14,43 C12.897,43 12,42.103 12,41 C12,39.897 12.897,39 14,39 C15.103,39 16,39.897 16,41 C16,42.103 15.103,43 14,43 L14,43 Z M6,21 C4.897,21 4,20.103 4,19 C4,17.897 4.897,17 6,17 C7.103,17 8,17.897 8,19 C8,20.103 7.103,21 6,21 L6,21 Z M24,4 C25.103,4 26,4.897 26,6 C26,7.103 25.103,8 24,8 C22.897,8 22,7.103 22,6 C22,4.897 22.897,4 24,4 L24,4 Z M42,15 C41.008,15 40.111,15.376 39.412,15.976 L27.532,7.837 C27.821,7.284 28,6.666 28,6 C28,3.794 26.206,2 24,2 C21.794,2 20,3.794 20,6 C20,6.666 20.179,7.284 20.468,7.837 L8.588,15.976 C7.889,15.376 6.992,15 6,15 C3.794,15 2,16.794 2,19 C2,21.206 3.794,23 6,23 C6.101,23 6.196,22.978 6.296,22.97 L11.805,37.662 C10.72,38.378 10,39.605 10,41 C10,43.206 11.794,45 14,45 C15.859,45 17.411,43.72 17.858,42 L30.142,42 C30.589,43.72 32.141,45 34,45 C36.206,45 38,43.206 38,41 C38,39.605 37.28,38.378 36.195,37.662 L41.704,22.97 C41.804,22.978 41.899,23 42,23 C44.206,23 46,21.206 46,19 C46,16.794 44.206,15 42,15 L42,15 Z" id="Fill-1" fill="#7AA116"></path>
    </g>
</svg>`, my = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Storage/Res_AWS-Backup_Recovery-Time-Objective_48</title>
    <g id="Icon-Resource/Storage/Res_AWS-Backup_Recovery-Time-Objective_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M26.606,38.281 C29.163,38.281 31.593,37.474 33.636,35.947 C33.938,35.721 34.228,35.482 34.506,35.229 C34.646,35.102 34.782,34.972 34.914,34.84 C35.717,34.037 36.398,33.126 36.939,32.13 C37.031,31.963 37.116,31.796 37.197,31.626 C37.967,30.03 38.357,28.316 38.357,26.53 C38.357,21.024 34.614,16.316 29.255,15.081 L29.705,13.132 C35.976,14.577 40.357,20.087 40.357,26.53 C40.357,28.619 39.9,30.625 39,32.492 C38.905,32.691 38.802,32.891 38.696,33.087 C38.064,34.25 37.267,35.316 36.329,36.254 C36.174,36.408 36.015,36.561 35.851,36.709 C35.527,37.004 35.186,37.285 34.834,37.549 C32.443,39.336 29.597,40.281 26.606,40.281 C19.023,40.281 12.853,34.112 12.853,26.53 L14.855,26.468 L14.853,26.546 C14.853,33.01 20.126,38.281 26.606,38.281 L26.606,38.281 Z M26.056,25.182 C26.755,25.182 27.325,25.751 27.325,26.45 C27.325,27.149 26.755,27.718 26.056,27.718 C25.357,27.718 24.789,27.149 24.789,26.45 C24.789,25.751 25.357,25.182 26.056,25.182 L26.056,25.182 Z M22.789,26.45 C22.789,28.252 24.254,29.718 26.056,29.718 C27.859,29.718 29.325,28.252 29.325,26.45 C29.325,24.976 28.338,23.742 26.996,23.336 L26.939,13.994 L24.939,14.006 L24.996,23.374 C23.716,23.817 22.789,25.021 22.789,26.45 L22.789,26.45 Z M5,20 L16,20 L16,18 L5,18 L5,20 Z M2,24 L13,24 L13,22 L2,22 L2,24 Z M23,7.497 L23,4.654 C23,4.294 23.293,4 23.654,4 L28.345,4 C28.706,4 29,4.294 29,4.655 L29,7.337 C26.998,7.082 24.974,7.135 23,7.497 L23,7.497 Z M39.314,11.988 L41.015,10.288 L42.129,11.402 L43.543,9.988 L39.901,6.345 L38.487,7.76 L39.601,8.874 L37.735,10.74 C35.652,9.262 33.365,8.253 31,7.696 L31,4.655 C31,3.191 29.809,2 28.345,2 L23.654,2 C22.19,2 21,3.191 21,4.654 L21,7.965 C18.057,8.832 15.299,10.397 13,12.633 L13,11 L11,11 L11,15 C11,15.552 11.447,16 12,16 L16,16 L16,14 L14.457,14 C20.503,8.177 30.052,7.479 36.917,12.597 C44.61,18.331 46.204,29.256 40.469,36.949 C34.735,44.642 23.809,46.235 16.117,40.502 C11.704,37.213 9.152,32.166 9.114,26.655 L7.114,26.668 C7.156,32.812 10.002,38.438 14.921,42.105 C18.395,44.695 22.46,45.944 26.492,45.944 C32.416,45.944 38.268,43.248 42.073,38.144 C48.152,29.989 46.831,18.587 39.314,11.988 L39.314,11.988 Z" id="Fill-1" fill="#7AA116"></path>
    </g>
</svg>`, wy = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Storage/Res_AWS-Backup_Vault-Lock_48</title>
    <g id="Icon-Resource/Storage/Res_AWS-Backup_Vault-Lock_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M15.863,33.96 C21.978,38.517 30.658,37.251 35.217,31.136 C39.773,25.022 38.507,16.34 32.393,11.783 C26.479,7.376 18.176,8.429 13.513,14.035 L16.013,14.068 L15.986,16.068 L10.919,16 C10.654,15.997 10.401,15.888 10.216,15.698 C10.031,15.507 9.928,15.252 9.932,14.986 L10,9.986 L12,10.014 L11.963,12.775 C17.297,6.344 26.813,5.13 33.589,10.179 C40.587,15.396 42.036,25.334 36.82,32.332 C33.717,36.495 28.941,38.695 24.108,38.695 C20.818,38.695 17.503,37.676 14.668,35.564 C10.654,32.572 8.333,27.981 8.298,22.968 L10.298,22.955 C10.328,27.335 12.356,31.347 15.863,33.96 L15.863,33.96 Z M35,44 L39,44 L39,43 L35,43 L35,44 Z M9,44 L13,44 L13,43 L9,43 L9,44 Z M45,2 L3,2 C2.447,2 2,2.448 2,3 L2,11 L4,11 L4,4 L44,4 L44,41 L4,41 L4,33 L2,33 L2,42 C2,42.552 2.447,43 3,43 L7,43 L7,45 C7,45.552 7.447,46 8,46 L14,46 C14.552,46 15,45.552 15,45 L15,43 L33,43 L33,45 C33,45.552 33.447,46 34,46 L40,46 C40.552,46 41,45.552 41,45 L41,43 L45,43 C45.552,43 46,42.552 46,42 L46,3 C46,2.448 45.552,2 45,2 L45,2 Z M2,27 L4,27 L4,17 L2,17 L2,27 Z M20,28 L28,28 L28,22 L20,22 L20,28 Z M22,18 C22,16.897 22.897,16 24,16 C25.102,16 26,16.897 26,18 L26,20 L22,20 L22,18 Z M24,14 C21.794,14 20,15.794 20,18 L20,20 L19,20 C18.447,20 18,20.448 18,21 L18,29 C18,29.552 18.447,30 19,30 L29,30 C29.552,30 30,29.552 30,29 L30,21 C30,20.448 29.552,20 29,20 L28,20 L28,18 C28,15.794 26.206,14 24,14 L24,14 Z" id="Fill-1" fill="#7AA116"></path>
    </g>
</svg>`, xy = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Storage/Res_AWS-Storage-Gateway_Virtual-Tape-Library_48</title>
    <g id="Icon-Resource/Storage/Res_AWS-Storage-Gateway_Virtual-Tape-Library_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M16.1868,22.3711 C18.7708,22.3711 20.8728,24.4741 20.8728,27.0581 C20.8728,29.6421 18.7708,31.7441 16.1868,31.7441 C13.6028,31.7441 11.4998,29.6421 11.4998,27.0581 C11.4998,24.4741 13.6028,22.3711 16.1868,22.3711 L16.1868,22.3711 Z M26.3728,27.0581 C26.3728,24.4741 28.4748,22.3711 31.0588,22.3711 C33.6428,22.3711 35.7448,24.4741 35.7448,27.0581 C35.7448,29.6421 33.6428,31.7441 31.0588,31.7441 C28.4748,31.7441 26.3728,29.6421 26.3728,27.0581 L26.3728,27.0581 Z M16.1868,33.7441 C16.3338,33.7441 16.4788,33.7311 16.6238,33.7221 L16.6238,33.7441 L31.4968,33.7441 L31.4968,33.7221 C34.9788,33.4951 37.7448,30.5971 37.7448,27.0581 C37.7448,23.3711 34.7458,20.3711 31.0588,20.3711 C27.3728,20.3711 24.3728,23.3711 24.3728,27.0581 C24.3728,28.8821 25.1088,30.5361 26.2968,31.7441 L20.9478,31.7441 C22.1358,30.5361 22.8728,28.8821 22.8728,27.0581 C22.8728,23.3711 19.8738,20.3711 16.1868,20.3711 C12.4998,20.3711 9.4998,23.3711 9.4998,27.0581 C9.4998,30.7441 12.4998,33.7441 16.1868,33.7441 L16.1868,33.7441 Z M32.0568,15.2471 L28.0868,15.2471 L28.0868,7.3661 L29.1908,7.3661 L29.1908,14.3261 L32.0568,14.3261 L32.0568,15.2471 Z M24.0048,8.2871 L22.0488,8.2871 L22.0488,7.3661 L27.0758,7.3661 L27.0758,8.2871 L25.1088,8.2871 L25.1088,15.2471 L24.0048,15.2471 L24.0048,8.2871 Z M18.1148,15.2471 L15.8398,7.3661 L17.0558,7.3661 L18.7168,14.0531 L20.3888,7.3661 L21.5598,7.3661 L19.2858,15.2471 L18.1148,15.2471 Z M39.2448,43.9911 L30.7468,43.9911 L30.7468,38.8671 C30.7468,38.3141 30.2988,37.8671 29.7468,37.8671 L17.4988,37.8671 C16.9458,37.8671 16.4988,38.3141 16.4988,38.8671 L16.4988,43.9911 L7.9998,43.9911 L7.9998,4.0001 L39.2448,4.0001 L39.2448,43.9911 Z M40.2448,2.0001 L6.9998,2.0001 C6.4478,2.0001 5.9998,2.4471 5.9998,3.0001 L5.9998,44.9911 C5.9998,45.5441 6.4478,45.9911 6.9998,45.9911 L17.4988,45.9911 C18.0508,45.9911 18.4988,45.5441 18.4988,44.9911 L18.4988,39.8671 L28.7468,39.8671 L28.7468,44.9911 C28.7468,45.5441 29.1938,45.9911 29.7468,45.9911 L40.2448,45.9911 C40.7968,45.9911 41.2448,45.5441 41.2448,44.9911 L41.2448,3.0001 C41.2448,2.4471 40.7968,2.0001 40.2448,2.0001 L40.2448,2.0001 Z" id="AWS-Storage-Gateway_Virtual-tape-library_Resource-Icon_light-bg" fill="#7AA116"></path>
    </g>
</svg>`, _y = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Storage/Res_Amazon-Elastic-Block-Store_Amazon-Data-Lifecycle-Manager_48</title>
    <g id="Icon-Resource/Storage/Res_Amazon-Elastic-Block-Store_Amazon-Data-Lifecycle-Manager_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M41.7998,34.5498 C41.1938,34.5498 40.6998,34.0568 40.6998,33.4498 C40.6998,32.8438 41.1938,32.3498 41.7998,32.3498 C42.4058,32.3498 42.9008,32.8438 42.9008,33.4498 C42.9008,34.0568 42.4058,34.5498 41.7998,34.5498 L41.7998,34.5498 Z M41.7998,30.3498 C40.0908,30.3498 38.6998,31.7408 38.6998,33.4498 C38.6998,34.3198 39.0628,35.1038 39.6418,35.6678 C36.1048,40.8998 30.3108,43.9998 23.9498,43.9998 C18.8108,43.9998 13.9988,41.9758 10.4038,38.3008 L8.9738,39.6988 C12.9488,43.7618 18.2678,45.9998 23.9498,45.9998 C31.0908,45.9998 37.5838,42.4638 41.4738,36.5168 C41.5828,36.5288 41.6878,36.5498 41.7998,36.5498 C43.5098,36.5498 44.9008,35.1588 44.9008,33.4498 C44.9008,31.7408 43.5098,30.3498 41.7998,30.3498 L41.7998,30.3498 Z M6.1008,34.5498 C5.4938,34.5498 4.9998,34.0568 4.9998,33.4498 C4.9998,32.8438 5.4938,32.3498 6.1008,32.3498 C6.7068,32.3498 7.1998,32.8438 7.1998,33.4498 C7.1998,34.0568 6.7068,34.5498 6.1008,34.5498 L6.1008,34.5498 Z M6.1008,30.3498 C5.9898,30.3498 5.8848,30.3718 5.7768,30.3828 C5.2718,28.6578 4.9998,26.8708 4.9998,25.0498 C4.9998,17.1898 9.9438,10.0558 17.3008,7.2998 L16.5998,5.4258 C8.4648,8.4748 2.9998,16.3608 2.9998,25.0498 C2.9998,27.1618 3.3298,29.2338 3.9458,31.2288 C3.3648,31.7928 2.9998,32.5788 2.9998,33.4498 C2.9998,35.1588 4.3908,36.5498 6.1008,36.5498 C7.8098,36.5498 9.1998,35.1588 9.1998,33.4498 C9.1998,31.7408 7.8098,30.3498 6.1008,30.3498 L6.1008,30.3498 Z M23.9498,3.9998 C24.5568,3.9998 25.0498,4.4938 25.0498,5.0998 C25.0498,5.7068 24.5568,6.1998 23.9498,6.1998 C23.3438,6.1998 22.8508,5.7068 22.8508,5.0998 C22.8508,4.4938 23.3438,3.9998 23.9498,3.9998 L23.9498,3.9998 Z M23.9498,8.1998 C25.2208,8.1998 26.3138,7.4298 26.7908,6.3328 C36.0328,7.7148 42.9008,15.5948 42.9008,25.0498 C42.9008,25.6668 42.8698,26.2898 42.8108,26.9028 L44.8008,27.0968 C44.8668,26.4198 44.9008,25.7308 44.9008,25.0498 C44.9008,14.5468 37.2358,5.8028 26.9428,4.3348 C26.5998,2.9968 25.3938,1.9998 23.9498,1.9998 C22.2408,1.9998 20.8508,3.3908 20.8508,5.0998 C20.8508,6.8098 22.2408,8.1998 23.9498,8.1998 L23.9498,8.1998 Z M32.9498,16.1458 L32.9498,33.9548 C32.9498,34.7058 31.5028,35.7598 28.3258,36.2998 C28.2828,36.3068 28.2288,36.3148 28.1658,36.3228 C27.2348,36.4448 24.3408,36.6418 23.9708,36.6488 C22.4708,36.5558 20.0908,36.3878 19.5728,36.2998 C16.3978,35.7598 14.9498,34.7058 14.9498,33.9548 L14.9498,16.1458 C14.9498,15.1778 17.9578,13.4498 23.9498,13.4498 C29.9428,13.4498 32.9498,15.1778 32.9498,16.1458 L32.9498,16.1458 Z M12.9498,16.1458 L12.9498,33.9548 C12.9498,36.0188 15.2418,37.5928 19.2378,38.2718 C20.0618,38.4118 23.5158,38.6498 23.9498,38.6498 C24.3848,38.6498 27.8388,38.4118 28.6608,38.2718 C32.6578,37.5928 34.9498,36.0188 34.9498,33.9548 L34.9498,16.1458 C34.9498,13.3808 30.4268,11.4498 23.9498,11.4498 C17.4738,11.4498 12.9498,13.3808 12.9498,16.1458 L12.9498,16.1458 Z M23.2918,24.4168 C23.4608,24.2408 23.6888,24.1418 23.9328,24.1368 C23.9388,24.1368 23.9458,24.1368 23.9508,24.1368 C24.1878,24.1368 24.4118,24.2268 24.5828,24.3918 C24.7588,24.5608 24.8588,24.7878 24.8628,25.0318 C24.8678,25.2758 24.7778,25.5068 24.6088,25.6828 C24.4398,25.8588 24.2118,25.9588 23.9678,25.9628 C23.7408,26.0008 23.4918,25.8778 23.3178,25.7088 C23.1418,25.5398 23.0418,25.3118 23.0368,25.0688 C23.0318,24.8238 23.1228,24.5928 23.2918,24.4168 L23.2918,24.4168 Z M21.0368,25.1068 C21.0528,25.8848 21.3698,26.6108 21.9308,27.1498 C22.4948,27.6928 23.2228,27.9618 23.9488,27.9618 C24.7148,27.9618 25.4788,27.6628 26.0498,27.0688 C26.5888,26.5078 26.8778,25.7708 26.8628,24.9928 C26.8478,24.2148 26.5298,23.4888 25.9698,22.9498 C24.8108,21.8368 22.9638,21.8728 21.8508,23.0308 C21.3118,23.5918 21.0228,24.3288 21.0368,25.1068 L21.0368,25.1068 Z M24.4898,21.5038 C24.7678,21.5028 25.0308,21.3858 25.2198,21.1818 L26.2308,20.0858 L27.9428,21.3318 L27.2028,22.6478 C27.0678,22.8898 27.0378,23.1768 27.1218,23.4418 L27.4358,24.4248 C27.5218,24.6938 27.7158,24.9128 27.9718,25.0298 L29.3458,25.6618 L28.6908,27.6758 L27.2038,27.3778 C26.9308,27.3218 26.6438,27.3848 26.4168,27.5508 L25.5808,28.1628 C25.3568,28.3268 25.2108,28.5768 25.1788,28.8538 L25.0038,30.3488 L22.8858,30.3468 L22.7128,28.8638 C22.6808,28.5898 22.5368,28.3408 22.3148,28.1758 L21.4688,27.5498 C21.2408,27.3828 20.9538,27.3158 20.6778,27.3738 L19.2058,27.6678 L18.5538,25.6528 L19.9348,25.0188 C20.1888,24.9028 20.3818,24.6858 20.4688,24.4208 L20.7858,23.4468 C20.8718,23.1808 20.8438,22.8908 20.7068,22.6478 L19.9638,21.3248 L21.6788,20.0818 L22.6968,21.1878 C22.8878,21.3948 23.1218,21.5028 23.4388,21.5098 L24.4898,21.5038 Z M22.5468,18.0728 C22.2028,17.6978 21.6338,17.6438 21.2248,17.9408 L18.0698,20.2288 C17.6578,20.5278 17.5358,21.0858 17.7838,21.5288 L18.7478,23.2438 L18.7018,23.3838 L16.9108,24.2058 C16.4498,24.4178 16.2208,24.9408 16.3768,25.4228 L17.5778,29.1318 C17.7348,29.6138 18.2248,29.8998 18.7258,29.8038 L20.6358,29.4218 L20.7768,29.5258 L21.0018,31.4618 C21.0608,31.9658 21.4878,32.3458 21.9938,32.3458 L25.8928,32.3498 L25.8938,32.3498 C26.4008,32.3498 26.8278,31.9698 26.8868,31.4668 L27.1138,29.5188 L27.2428,29.4248 L29.1698,29.8118 C29.6598,29.9118 30.1588,29.6228 30.3178,29.1408 L31.5238,25.4338 C31.6808,24.9508 31.4508,24.4278 30.9888,24.2158 L29.2068,23.3968 L29.1598,23.2488 L30.1218,21.5358 C30.3698,21.0938 30.2478,20.5358 29.8388,20.2378 L26.6878,17.9448 C26.2768,17.6458 25.7068,17.7018 25.3628,18.0748 L24.0438,19.5068 L23.8688,19.5078 L22.5468,18.0728 Z" id="Fill-1" fill="#7AA116"></path>
    </g>
</svg>`, vy = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Storage/Res_AWS-Backup_Backup-Plan_48</title>
    <g id="Icon-Resource/Storage/Res_AWS-Backup_Backup-Plan_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M39,44 L39,12 L32,12 C31.447,12 31,11.552 31,11 L31,4 L9,4 L9,44 L39,44 Z M33,10 L37.586,10 L33,5.414 L33,10 Z M41,11 L41,45 C41,45.552 40.553,46 40,46 L8,46 C7.447,46 7,45.552 7,45 L7,3 C7,2.448 7.447,2 8,2 L32,2 L32,2.01 C32.26,2.01 32.516,2.102 32.707,2.293 L40.707,10.293 C40.898,10.484 40.99,10.74 40.991,11 L41,11 Z M34.579,36.424 L32.914,38.089 L31.249,36.424 L29.835,37.838 L31.5,39.503 L29.835,41.168 L31.249,42.583 L32.914,40.917 L34.579,42.583 L35.993,41.168 L34.328,39.503 L35.993,37.838 L34.579,36.424 Z M15.5,12 C16.327,12 17,11.327 17,10.5 C17,9.673 16.327,9 15.5,9 C14.673,9 14,9.673 14,10.5 C14,11.327 14.673,12 15.5,12 L15.5,12 Z M15.5,14 C13.57,14 12,12.43 12,10.5 C12,8.57 13.57,7 15.5,7 C17.43,7 19,8.57 19,10.5 C19,12.43 17.43,14 15.5,14 L15.5,14 Z M25.527,36.876 C24.993,36.954 24.459,36.992001 23.929,36.992001 C21.596,36.993 19.334,36.247 17.43,34.827 C14.662,32.764 13.061,29.599 13.037,26.143 L15.037,26.129 C15.057,28.953 16.364,31.538 18.625,33.223 C20.534,34.646 22.879,35.238 25.239,34.897 C27.595,34.553 29.677,33.312 31.1,31.403 C34.037,27.462 33.221,21.866 29.28,18.928 C25.604,16.187 20.487,16.717 17.432,20 L19,20 L19,22 L15,22 C14.447,22 14,21.552 14,21 L14,17 L16,17 L16,18.606 C19.743,14.614 25.986,13.978 30.476,17.324 C35.301,20.921 36.3,27.773 32.703,32.598 C30.961,34.936 28.412,36.455 25.527,36.876 L25.527,36.876 Z" id="Fill-1" fill="#7AA116"></path>
    </g>
</svg>`, My = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Storage/Res_Amazon-File-Cache_S3-linked-datasets_48</title>
    <g id="Icon-Resource/Storage/Res_Amazon-File-Cache_S3-linked-datasets_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M8,31 L10,31 C10,32.654 11.346,34 13,34 L15,34 C16.654,34 18,32.654 18,31 C18,29.346 16.654,28 15,28 L15,26 C17.757,26 20,28.243 20,31 C20,33.757 17.757,36 15,36 L13,36 C10.243,36 8,33.757 8,31 M4,31 C4,32.654 5.346,34 7,34 L7,36 C4.243,36 2,33.757 2,31 C2,28.243 4.243,26 7,26 L9,26 C11.757,26 14,28.243 14,31 L12,31 C12,29.346 10.654,28 9,28 L7,28 C5.346,28 4,29.346 4,31 M41.757,28.033 L41.944,26.554 C43.324,27.439 43.781,27.969 43.931,28.214 C43.678,28.266 43.071,28.305 41.757,28.033 M24.275,12.5 C13.002,12.5 6.942,10.372 6.109,8.955 L6.041,8.469 C6.463,6.808 13.297,4 24.275,4 C35.55,4 41.842,6.868 42.224,8.476 L42.161,8.97 C41.339,10.52 35.052,12.5 24.275,12.5 M45.968,28.004 C45.766,26.92 44.598,25.782 42.221,24.377 L44.114,9.467 C44.208,9.2 44.261,8.922 44.261,8.631 C44.261,8.564 44.251,8.499 44.246,8.433 L44.253,8.376 L44.241,8.374 C43.831,4.379 33.895,2 24.275,2 C14.505,2 4.413,4.385 4.019,8.388 L4.01,8.39 L4.016,8.431 C4.01,8.497 4,8.563 4,8.631 C4,8.94 4.062,9.234 4.169,9.516 L6.214,24 L8.234,24 L6.504,11.749 C10.271,13.73 17.663,14.5 24.275,14.5 C30.803,14.5 38.101,13.728 41.809,11.74 L40.069,25.442 L40.062,25.454 L40.067,25.457 L39.804,27.532 C35.407,26.248 29.296,23.54 26.077,22.055 C26.107,21.918 26.124,21.777 26.124,21.631 C26.124,20.528 25.229,19.631 24.131,19.631 C23.031,19.631 22.137,20.528 22.137,21.631 C22.137,22.734 23.031,23.631 24.131,23.631 C24.291,23.631 24.444,23.607 24.593,23.572 C28.034,25.178 34.756,28.188 39.549,29.541 L38.142,40.622 C38.137,40.664 38.134,40.706 38.134,40.748 C38.134,40.925 37.756,41.536 36.032,42.23 C35.275,42.535 34.379,42.81 33.366,43.047 C30.76,43.662 27.562,44 24.36,44 C20.73,44 17.085,43.56 14.36,42.792 C11.281,41.924 10.589,41.002 10.589,40.748 C10.589,40.701 10.586,40.655 10.579,40.608 L10.211,38 L8.19,38 L8.59,40.829 C8.725,44.594 18.306,46 24.36,46 C27.711,46 31.072,45.643 33.824,44.994 C34.935,44.734 35.928,44.428 36.779,44.086 C38.964,43.205 40.092,42.107 40.133,40.82 L41.504,30.019 C42.258,30.168 42.915,30.252 43.462,30.252 C44.467,30.252 45.144,29.999 45.573,29.49 C45.929,29.071 46.068,28.543 45.968,28.004" id="Fill-1" fill="#7AA116"></path>
    </g>
</svg>`, Ry = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Storage/Res_AWS-Backup_AWS-Backup-for-AWS-CloudFormation_48</title>
    <g id="Icon-Resource/Storage/Res_AWS-Backup_AWS-Backup-for-AWS-CloudFormation_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M43.118,33.733 C43.307,33.441 43.487,33.146 43.658,32.845 C43.772,32.644 43.881,32.44 43.987,32.233 C44.153,31.913 44.311,31.589 44.457,31.261 C44.543,31.065 44.624,30.867 44.704,30.668 C44.845,30.316 44.977,29.962 45.095,29.603 C45.157,29.412 45.215,29.22 45.271,29.027 C45.381,28.652 45.479,28.275 45.563,27.894 C45.607,27.699 45.645,27.503 45.682,27.305 C45.753,26.921 45.813,26.536 45.859,26.148 C45.884,25.936 45.905,25.723 45.923,25.509 C45.954,25.137 45.973,24.763 45.98,24.387 C45.983,24.257 46,24.13 46,24 C46,23.878 45.984,23.76 45.981,23.638 C45.974,23.313 45.957,22.988 45.932,22.662 C45.909,22.358 45.882,22.056 45.844,21.756 C45.829,21.638 45.827,21.52 45.81,21.401 C45.787,21.243 45.746,21.092 45.719,20.935 C45.664,20.616 45.604,20.3 45.533,19.987 C45.468,19.704 45.393,19.424 45.316,19.145 C45.24,18.875 45.163,18.606 45.074,18.341 C44.965,18.008 44.842,17.683 44.714,17.359 C44.637,17.164 44.56,16.97 44.476,16.779 C44.31,16.397 44.127,16.024 43.934,15.656 C43.869,15.531 43.804,15.405 43.736,15.282 C43.511,14.876 43.27,14.482 43.014,14.096 C42.957,14.01 42.901,13.923 42.843,13.838 C42.575,13.447 42.29,13.068 41.99,12.698 C41.923,12.615 41.855,12.531 41.786,12.449 C41.497,12.105 41.193,11.772 40.876,11.448 C40.773,11.342 40.669,11.237 40.563,11.134 C40.274,10.852 39.974,10.58 39.664,10.316 C39.51,10.185 39.353,10.056 39.195,9.929 C39.046,9.811 38.909,9.682 38.756,9.568 C38.614,9.462 38.463,9.375 38.318,9.274 C38.131,9.142 37.94,9.015 37.747,8.89 C37.446,8.695 37.142,8.509 36.832,8.333 C36.64,8.225 36.445,8.121 36.249,8.019 C35.92,7.849 35.588,7.687 35.251,7.538 C35.062,7.454 34.871,7.376 34.679,7.299 C34.322,7.156 33.963,7.023 33.599,6.903 C33.411,6.841 33.221,6.784 33.03,6.729 C32.655,6.619 32.277,6.521 31.896,6.436 C31.699,6.393 31.5,6.354 31.301,6.317 C30.921,6.246 30.54,6.187 30.156,6.141 C29.938,6.115 29.72,6.094 29.5,6.076 C29.133,6.046 28.766,6.027 28.397,6.02 C28.264,6.017 28.134,6 28,6 C27.787,6 27.577,6.011 27.366,6.018 C27.277,6.021 27.189,6.021 27.101,6.025 C26.54,6.053 25.985,6.108 25.436,6.186 C25.424,6.187 25.413,6.187 25.401,6.189 C25.389,6.191 25.379,6.194 25.367,6.196 C21.873,6.701 18.652,8.208 16.036,10.551 C15.993,10.589 15.95,10.626 15.908,10.664 C15.597,10.948 15.293,11.24 15,11.548 L15,8 L13,8 L13,14 C13,14.552 13.447,15 14,15 L20,15 L20,13 L16.395,13 C16.509,12.879 16.63,12.765 16.748,12.648 C17.002,12.395 17.259,12.146 17.528,11.912 C17.722,11.743 17.923,11.583 18.125,11.424 C18.364,11.235 18.607,11.054 18.855,10.88 C19.088,10.717 19.324,10.558 19.565,10.407 C19.791,10.267 20.023,10.138 20.255,10.01 C20.526,9.86 20.796,9.707 21.076,9.573 C21.275,9.478 21.481,9.399 21.684,9.312 C22.746,8.857 23.862,8.518 25.02,8.299 C25.302,8.247 25.581,8.189 25.867,8.151 C26.111,8.118 26.355,8.102 26.6,8.08 C26.969,8.049 27.34,8.023 27.714,8.016 C27.925,8.012 28.135,8.013 28.345,8.017 C28.678,8.024 29.009,8.04 29.337,8.067 C29.529,8.083 29.721,8.102 29.912,8.125 C30.255,8.166 30.595,8.218 30.931,8.281 C31.11,8.314 31.287,8.349 31.464,8.388 C31.802,8.463 32.135,8.55 32.464,8.646 C32.637,8.696 32.81,8.748 32.981,8.804 C33.301,8.909 33.616,9.026 33.927,9.151 C34.103,9.221 34.278,9.293 34.451,9.37 C34.747,9.501 35.037,9.643 35.324,9.791 C35.502,9.883 35.68,9.978 35.856,10.077 C36.129,10.232 36.397,10.396 36.66,10.566 C36.833,10.678 37.004,10.793 37.174,10.912 C37.439,11.098 37.697,11.291 37.95,11.492 C38.092,11.605 38.231,11.72 38.368,11.837 C38.643,12.071 38.91,12.312 39.168,12.564 C39.262,12.655 39.353,12.748 39.445,12.842 C39.726,13.13 39.998,13.426 40.257,13.735 C40.317,13.806 40.375,13.879 40.433,13.951 C40.7,14.281 40.956,14.62 41.196,14.97 C41.246,15.043 41.295,15.118 41.343,15.192 C41.572,15.537 41.787,15.891 41.989,16.254 C42.048,16.361 42.105,16.47 42.162,16.578 C42.334,16.907 42.496,17.242 42.646,17.583 C42.72,17.752 42.789,17.924 42.857,18.095 C42.971,18.383 43.079,18.673 43.177,18.969 C43.255,19.206 43.326,19.447 43.393,19.689 C43.461,19.933 43.526,20.179 43.584,20.428 C43.648,20.711 43.702,20.998 43.752,21.287 C43.792,21.522 43.83,21.757 43.86,21.996 C43.895,22.272 43.919,22.547 43.94,22.822 C43.961,23.103 43.977,23.385 43.983,23.67 C43.988,23.898 43.986,24.125 43.982,24.352 C43.975,24.682 43.959,25.01 43.932,25.335 C43.916,25.529 43.897,25.721 43.874,25.914 C43.833,26.257 43.781,26.598 43.718,26.934 C43.685,27.111 43.65,27.288 43.611,27.463 C43.536,27.802 43.449,28.137 43.352,28.467 C43.302,28.639 43.251,28.81 43.195,28.98 C43.09,29.301 42.973,29.616 42.848,29.928 C42.777,30.104 42.706,30.279 42.629,30.453 C42.498,30.747 42.358,31.035 42.21,31.32 C42.116,31.502 42.02,31.683 41.919,31.861 C41.766,32.13 41.606,32.392 41.439,32.651 C41.323,32.83 41.204,33.008 41.08,33.184 C40.914,33.42 40.74,33.65 40.562,33.876 C40.379,34.109 40.188,34.332 39.995,34.552 C39.794,34.78 39.596,35.01 39.382,35.226 C39.253,35.358 39.115,35.478 38.981,35.605 C38.018,36.517 36.947,37.315 35.781,37.967 C35.709,38.007 35.64,38.052 35.567,38.091 C35.214,38.281 34.849,38.451 34.481,38.615 C34.326,38.684 34.17,38.753 34.013,38.817 C33.685,38.95 33.351,39.071 33.013,39.183 C32.783,39.259 32.55,39.326 32.316,39.391 C32.026,39.473 31.734,39.553 31.437,39.618 C31.105,39.69 30.768,39.744 30.43,39.795 C30.208,39.829 29.988,39.872 29.763,39.897 C29.182,39.96 28.594,39.999 28,40 C25.824,40 23.714,39.571 21.731,38.725 L20.946,40.565 C22.873,41.386 24.907,41.836 27,41.95 L27,42 L28.001,42 C28.57,41.999 29.133,41.965 29.691,41.914 C29.767,41.907 29.843,41.902 29.919,41.894 C30.478,41.835 31.029,41.749 31.574,41.641 C31.607,41.634 31.639,41.627 31.672,41.621 C35.948,40.744 39.75,38.352 42.43,34.756 C42.533,34.618 42.618,34.47 42.717,34.33 C42.855,34.134 42.988,33.935 43.118,33.733 L43.118,33.733 Z M19.535,25.236 L16.535,36.236 L18.464,36.763 L21.464,25.763 L19.535,25.236 Z M14.293,26.293 L10.293,30.293 C9.902,30.683 9.902,31.316 10.293,31.707 L14.293,35.707 L15.707,34.293 L12.414,31 L15.707,27.707 L14.293,26.293 Z M23.707,35.707 L27.707,31.707 C28.097,31.316 28.097,30.683 27.707,30.293 L23.707,26.293 L22.293,27.707 L25.586,31 L22.293,34.293 L23.707,35.707 Z M30,29.948 L30,31.965 C32.216,31.685 36,29.98 36,25.185 C36,21.303 33.404,19.257 30.734,18.55 C30.395,16.358 29.172,14.774 27.378,14.25 C26.168,13.896 24.909,14.109 23.882,14.782 C23.377,13.767 22.747,12.878 22,12.126 L22,15.52 C22.213,15.93 22.412,16.357 22.576,16.821 C22.699,17.17 23.004,17.422 23.371,17.477 C23.735,17.531 24.103,17.379 24.323,17.082 C24.928,16.262 25.909,15.902 26.817,16.17 C27.932,16.495 28.671,17.652 28.807,19.273 C28.756,19.791 29.114,20.266 29.633,20.355 C30.946,20.58 34,21.503 34,25.185 C34,28.891 31.049,29.756 30,29.948 L30,29.948 Z M8.337,18.462 C8.337,18.764 8.354,19.062 8.39,19.354 C8.448,19.837 8.151,20.292 7.685,20.432 C7.652,20.442 7.619,20.45 7.586,20.457 C6.218,20.82 4,21.909 4,25.135 C4,25.342 4.008,25.541 4.027,25.733 C4.223,27.818 5.895,29.506 8,29.894 L8,31.911 C4.869,31.498 2.326,29.018 2.036,25.922 C2.012,25.672 2,25.408 2,25.135 C2,22.096 3.606,19.764 6.341,18.754 C6.338,18.657 6.337,18.559 6.337,18.462 C6.337,15.28 8.299,12.009 11,10.473 L11,12.894 C9.429,14.243 8.337,16.407 8.337,18.462 L8.337,18.462 Z" id="Fill-1" fill="#7AA116"></path>
    </g>
</svg>`, yy = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Storage/Res_AWS-Storage-Gateway_Tape-Gateway_48</title>
    <g id="Icon-Resource/Storage/Res_AWS-Storage-Gateway_Tape-Gateway_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M41.458,41.769 L33.72,41.769 C32.952,42.594 32.081,43.319 31.123,43.922 L39.692,43.922 L41.458,41.769 Z M24.236,43.922 C30.283,43.922 35.202,39.002 35.202,32.956 C35.202,26.909 30.283,21.99 24.236,21.99 C18.189,21.99 13.271,26.909 13.271,32.956 C13.271,39.002 18.189,43.922 24.236,43.922 L24.236,43.922 Z M44.345,41.403 L40.939,45.556 C40.749,45.788 40.466,45.922 40.166,45.922 L23.996,45.922 C23.967,45.922 23.943,45.909 23.916,45.906 C16.915,45.734 11.271,39.998 11.271,32.956 C11.271,25.806 17.087,19.99 24.236,19.99 C31.386,19.99 37.202,25.806 37.202,32.956 C37.202,35.457 36.479,37.787 35.247,39.769 L43.571,39.769 C43.958,39.769 44.31,39.992 44.476,40.341 C44.641,40.691 44.59,41.104 44.345,41.403 L44.345,41.403 Z M24.236,38.106 C27.076,38.106 29.386,35.795 29.386,32.956 C29.386,30.116 27.076,27.806 24.236,27.806 C21.396,27.806 19.086,30.116 19.086,32.956 C19.086,35.795 21.396,38.106 24.236,38.106 L24.236,38.106 Z M24.236,40.106 C20.294,40.106 17.086,36.898 17.086,32.956 C17.086,29.013 20.294,25.806 24.236,25.806 C28.179,25.806 31.386,29.013 31.386,32.956 C31.386,36.898 28.179,40.106 24.236,40.106 L24.236,40.106 Z M17.523,4 C11.934,4 8.485,5.619 5,7.632 L5,44.922 L3,44.922 L3,7.057 C3,6.703 3.188,6.373 3.494,6.195 C7.266,3.984 11.176,2 17.523,2 C23.421,2 27.738,4.227 31.208,6.015 L31.504,6.168 C31.837,6.339 32.046,6.682 32.046,7.057 L32.046,19.234 L30.046,19.234 L30.046,7.666 C26.657,5.921 22.808,4 17.523,4 L17.523,4 Z" id="AWS-Storage-Gateway_Tape-Gateway_Resource-Icon_light-bg" fill="#7AA116"></path>
    </g>
</svg>`, Ay = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Storage/Res_AWS-Backup_AWS-Backup-Support-for-VMware-Workloads_48</title>
    <g id="Icon-Resource/Storage/Res_AWS-Backup_AWS-Backup-Support-for-VMware-Workloads_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M23.9996,29.0334686 C23.9996,29.7704686 23.5946,30.4084686 22.9996,30.7554686 L22.9996,35.0334686 L20.9996,35.0334686 L20.9996,30.7554686 C20.4046,30.4084686 19.9996,29.7704686 19.9996,29.0334686 C19.9996,27.9304686 20.8966,27.0334686 21.9996,27.0334686 C23.1026,27.0334686 23.9996,27.9304686 23.9996,29.0334686 L23.9996,29.0334686 Z M12.9996,38.0334686 L30.9996,38.0334686 L30.9996,23.0334686 L12.9996,23.0334686 L12.9996,38.0334686 Z M36.9996,43.0334686 L6.9996,43.0334686 L6.9996,40.0334686 L12.7276,40.0334686 L31.2716,40.0334686 L36.9996,40.0334686 L36.9996,43.0334686 Z M26.9996,21.0334686 L16.9996,21.0334686 L16.9996,16.1684686 C16.9996,14.2634686 17.9926,13.0334686 19.5286,13.0334686 L24.4706,13.0334686 C26.0066,13.0334686 26.9996,14.2634686 26.9996,16.1684686 L26.9996,21.0334686 Z M10.6506,29.0044686 C7.1426,29.0014686 4.1886,26.3674686 3.9266,23.0084686 C3.9086,22.7854686 3.8996,22.5554686 3.8996,22.3174686 C3.8996,17.8394686 6.9976,16.3444686 8.8826,15.8494686 C9.3426,15.7564686 9.6846,15.3494686 9.6846,14.8674686 C9.6846,14.8194686 9.6806,14.7714686 9.6736,14.7244686 C9.6286,14.3304686 9.6046,13.9314686 9.6046,13.5384686 C9.6046,9.90246864 12.1146,5.99146864 15.3186,4.63446864 C20.8676,2.28446864 24.8016,5.37446864 26.2366,6.81246864 C27.4066,7.98746864 28.3196,9.48846864 28.9506,11.2744686 C29.0746,11.6234686 29.3806,11.8754686 29.7466,11.9304686 C30.1096,11.9824686 30.4786,11.8324686 30.6986,11.5354686 C31.5746,10.3484686 33.0006,9.83246864 34.3226,10.2194686 C35.9276,10.6884686 36.9866,12.3264686 37.1696,14.6114686 C37.1036,15.1384686 37.4656,15.6274686 37.9926,15.7174686 C39.7986,16.0284686 43.9996,17.2984686 43.9996,22.3834686 C43.9996,28.4324686 38.1366,29.0154686 37.9726,29.0334686 L32.9996,29.0284686 L32.9996,22.7614686 C32.9996,21.8084686 32.2246,21.0334686 31.2716,21.0334686 L28.9996,21.0334686 L28.9996,16.1684686 C28.9996,13.1454686 27.1376,11.0334686 24.4706,11.0334686 L19.5286,11.0334686 C16.8616,11.0334686 14.9996,13.1454686 14.9996,16.1684686 L14.9996,21.0334686 L12.7276,21.0334686 C11.7746,21.0334686 10.9996,21.8084686 10.9996,22.7614686 L10.9996,29.0044686 L10.6506,29.0044686 Z M38.0526,31.0304686 C40.8016,30.8064686 45.9996,28.7124686 45.9996,22.3834686 C45.9996,17.3614686 42.5686,14.7584686 39.1046,13.9084686 C38.7236,11.0434686 37.1766,8.96946864 34.8836,8.29946864 C33.2706,7.82746864 31.5766,8.16946864 30.2506,9.17046864 C29.5726,7.71746864 28.7026,6.45346864 27.6526,5.40046864 C24.0706,1.80746864 19.1676,0.83546864 14.5396,2.79246864 C10.5866,4.46746864 7.6046,9.08646864 7.6046,13.5384686 C7.6046,13.7404686 7.6096,13.9424686 7.6206,14.1454686 C5.4316,14.9074686 1.8996,16.9674686 1.8996,22.3174686 C1.8996,22.6094686 1.9106,22.8914686 1.9326,23.1644686 C2.2756,27.5564686 6.1036,31.0004686 10.6496,31.0044686 L10.9996,31.0044686 L10.9996,38.0334686 L5.9996,38.0334686 C5.4466,38.0334686 4.9996,38.4814686 4.9996,39.0334686 L4.9996,44.0334686 C4.9996,44.5854686 5.4466,45.0334686 5.9996,45.0334686 L37.9996,45.0334686 C38.5526,45.0334686 38.9996,44.5854686 38.9996,44.0334686 L38.9996,39.0334686 C38.9996,38.4814686 38.5526,38.0334686 37.9996,38.0334686 L32.9996,38.0334686 L32.9996,31.0274686 L38.0526,31.0304686 Z" id="Fill-1" fill="#7AA116"></path>
    </g>
</svg>`, Zy = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Storage/Res_Amazon-Elastic-File-System_One-Zone-Infrequent-Access_48</title>
    <g id="Icon-Resource/Storage/Res_Amazon-Elastic-File-System_One-Zone-Infrequent-Access_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M40,9 C40,8.449 39.552,8 39,8 C38.448,8 38,8.449 38,9 C38,9.551 38.448,10 39,10 C39.552,10 40,9.551 40,9 L40,9 Z M42,9 C42,10.654 40.654,12 39,12 C37.346,12 36,10.654 36,9 C36,7.346 37.346,6 39,6 C40.654,6 42,7.346 42,9 L42,9 Z M43.992,8.833 C44.061,7.55 43.659,6.411 42.833,5.54 C41.904,4.561 40.508,4 39,4 C37.581,4 36.215,4.58 35.251,5.592 C34.39,6.496 33.947,7.648 34.005,8.837 C34.121,11.234 37.104,15.242 38.933,17.405 C39.405,16.769 40.074,15.875 40.854,14.861 L41.35,14.2 C42.047,13.247 42.624,12.349 43.057,11.539 L43.354,10.95 C43.744,10.126 43.962,9.406 43.992,8.833 L43.992,8.833 Z M45.99,8.938 C45.945,9.785 45.671,10.73 45.151,11.828 L44.837,12.45 C44.834,12.457 44.83,12.464 44.826,12.471 C44.349,13.367 43.72,14.349 42.956,15.391 L42.446,16.07 C40.913,18.066 39.813,19.583 39.81,19.587 C39.633,19.83 39.356,19.981 39.058,19.999 C39.038,20 39.019,20 39,20 C38.721,20 38.453,19.883 38.263,19.676 C37.644,19 32.202,12.958 32.007,8.934 C31.923,7.193 32.561,5.517 33.803,4.212 C35.143,2.807 37.037,2 39,2 C41.054,2 42.979,2.789 44.283,4.163 C45.497,5.442 46.087,7.094 45.99,8.938 L45.99,8.938 Z M18,15 L20.854,15 C21.103,15.71 21.346,17.408 21.346,18 C21.346,18.552 21.793,19 22.346,19 L34,19 L34,17 L23.285,17 C23.155,15.614 22.755,13.252 21.524,13.018 C21.463,13.006 21.399,13 21.337,13 L18,13 L18,15 Z M42.592,19.592 C42.858,19.956 43,20.511 43,21.199 L43,44 L4,44 L4,21.199 C4,20.625 4.1,19.848 4.576,19.403 C4.911,19.09 5.416,18.955 6.154,19 L8.885,19 C9.438,19 9.885,18.552 9.885,18 C9.885,17.488 10.273,15.695 10.575,15 L12,15 L12,13 L10.158,13 C8.779,13 8.209,15.542 7.997,17.001 L6.222,17.002 C4.987,16.913 3.955,17.245 3.21,17.942 C2.658,18.458 2,19.442 2,21.199 L2,45 C2,45.552 2.447,46 3,46 L44,46 C44.553,46 45,45.552 45,45 L45,21.199 C45,20.066 44.731,19.127 44.203,18.408 L42.592,19.592 Z M33,37.5 C33,38.878 34.121,40 35.5,40 C36.879,40 38,38.878 38,37.5 C38,36.122 36.879,35 35.5,35 C34.121,35 33,36.122 33,37.5 L33,37.5 Z M35.5,33 C37.981,33 40,35.019 40,37.5 C40,39.981 37.981,42 35.5,42 C33.019,42 31,39.981 31,37.5 C31,35.019 33.019,33 35.5,33 L35.5,33 Z M21.374,36 L25.445,36 L23.452,32.355 L21.374,36 Z M18.788,37.502 C18.608,37.194 18.607,36.814 18.783,36.504 L22.602,29.809 C22.78,29.497 23.111,29.305 23.471,29.305 L23.479,29.305 C23.842,29.308 24.174,29.507 24.348,29.825 L28.009,36.52 C28.179,36.83 28.172,37.206 27.992,37.51 C27.812,37.814 27.485,38 27.132,38 L19.6519905,38 C19.296,38 18.967,37.811 18.788,37.502 L18.788,37.502 Z M10,40 L14,40 L14,36 L10,36 L10,40 Z M16,35 L16,41 C16,41.552 15.553,42 15,42 L9,42 C8.447,42 8,41.552 8,41 L8,35 C8,34.448 8.447,34 9,34 L15,34 C15.553,34 16,34.448 16,35 L16,35 Z M17.292,18.283 L14.999,20.597 L12.708,18.285 L11.288,19.693 L14.289,22.722 C14.477,22.911 14.732,23.018 14.999,23.018 C15.266,23.018 15.521,22.911 15.709,22.721 L18.712,19.69 L17.292,18.283 Z M15.001,6.443 L17.292,8.754 L18.712,7.346 L15.711,4.318 C15.336,3.939 14.666,3.939 14.291,4.318 L11.288,7.348 L12.708,8.756 L15.001,6.443 Z M14,17 L16,17 L16,10 L14,10 L14,17 Z" id="Fill-1" fill="#7AA116"></path>
    </g>
</svg>`, ky = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Storage/Res_Amazon-Simple-Storage-Service_S3-Replication-Time-Control_48</title>
    <g id="Icon-Resource/Storage/Res_Amazon-Simple-Storage-Service_S3-Replication-Time-Control_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M26.4646,36.9998 L23.4646,36.9998 C22.9116,36.9998 22.4646,36.5528 22.4646,35.9998 L22.4646,31.9998 L24.4646,31.9998 L24.4646,34.9998 L26.4646,34.9998 L26.4646,36.9998 Z M23.4996,30.9998 C21.0186,30.9998 18.9996,33.0188 18.9996,35.4998 C18.9996,37.9808 21.0186,39.9998 23.4996,39.9998 C25.9816,39.9998 27.9996,37.9808 27.9996,35.4998 C27.9996,33.0188 25.9816,30.9998 23.4996,30.9998 L23.4996,30.9998 Z M23.4996,41.9998 C19.9156,41.9998 16.9996,39.0838 16.9996,35.4998 C16.9996,31.9158 19.9156,28.9998 23.4996,28.9998 C27.0836,28.9998 29.9996,31.9158 29.9996,35.4998 C29.9996,39.0838 27.0836,41.9998 23.4996,41.9998 L23.4996,41.9998 Z M35.9686,7.5748 C34.7056,7.3318 33.4086,7.1498 32.1366,7.0208 C29.7556,5.9778 25.4426,4.9998 19.4076,4.9998 C8.7156,4.9998 4.0746,7.8128 4.0066,8.7408 L4.0266,8.8908 C4.2336,9.4208 5.6776,10.3988 9.3176,11.1288 C8.8016,11.6698 8.4276,12.2708 8.2346,12.9408 C6.8246,12.6248 5.4876,12.2168 4.4186,11.6838 L7.8416,36.1418 C7.8486,36.1878 7.8516,36.2338 7.8516,36.2798 C7.8936,36.4378 8.5446,37.1208 10.8696,37.7588 L11.1686,39.8898 C7.7106,39.0828 5.9126,37.8988 5.8536,36.3608 L2.0676,9.3138 C2.0546,9.2618 2.0536,9.2048 2.0446,9.1498 L2.0096,8.9018 L2.0036,8.8558 C2.0006,8.8098 1.9996,8.8118 1.9996,8.7638 C1.9996,5.0208 10.9686,2.9998 19.4076,2.9998 C26.8646,2.9998 34.3886,4.5688 35.9686,7.5748 L35.9686,7.5748 Z M41.8976,28.9798 L42.0316,27.9628 C43.0296,28.5718 43.5246,28.9938 43.7656,29.2518 C43.4456,29.2668 42.8646,29.2108 41.8976,28.9798 L41.8976,28.9798 Z M38.2356,41.4048 C38.2306,41.4488 38.2286,41.4798 38.2286,41.5238 C38.1996,41.6388 37.8346,42.0758 36.5736,42.5678 C35.9436,42.8138 35.1976,43.0358 34.3566,43.2278 C32.1786,43.7258 29.5056,43.9998 26.8296,43.9998 C19.7236,43.9998 15.6196,42.2648 15.4336,41.5368 C15.4336,41.4898 15.4306,41.4438 15.4236,41.3978 L12.0006,16.9448 C15.3106,18.6058 21.4686,19.2538 26.9896,19.2538 C32.3156,19.2538 38.2486,18.6108 41.4686,16.9698 L39.9526,28.4308 C36.0856,27.2028 31.0306,24.9238 28.7526,23.8628 C28.6036,22.9538 27.8176,22.2558 26.8656,22.2558 C25.8096,22.2558 24.9486,23.1158 24.9486,24.1738 C24.9486,25.2298 25.8096,26.0908 26.8656,26.0908 C27.2886,26.0908 27.6766,25.9488 27.9936,25.7168 C30.6866,26.9698 35.7756,29.2438 39.6866,30.4448 L38.2356,41.4048 Z M26.9896,10.2568 C36.5616,10.2568 41.8036,12.7138 41.8616,13.9968 L41.8506,14.0898 C41.6636,15.2618 36.7066,17.2538 26.9896,17.2538 C17.0716,17.2538 11.8046,15.2318 11.6016,14.0898 L11.5886,13.9968 C11.6566,13.0678 16.2976,10.2568 26.9896,10.2568 L26.9896,10.2568 Z M45.9556,29.1878 C45.7636,28.1598 44.6556,27.1368 42.3166,25.8148 L43.8596,14.1508 C43.8606,14.1068 43.8676,14.0648 43.8676,14.0208 C43.8676,10.2358 35.3766,8.2568 26.9896,8.2568 C18.5506,8.2568 9.5816,10.2758 9.5816,14.0208 C9.5816,14.0668 9.5816,14.0678 9.5846,14.1148 L9.5916,14.1588 L13.4356,41.6178 C13.5676,44.8308 21.4896,45.9998 26.8296,45.9998 C29.6516,45.9998 32.4826,45.7078 34.8016,45.1778 C35.7376,44.9648 36.5786,44.7138 37.3016,44.4308 C39.1996,43.6888 40.1836,42.7408 40.2266,41.6128 L41.6346,30.9708 C42.4516,31.1538 43.1406,31.2508 43.7066,31.2508 C44.5976,31.2508 45.1996,31.0218 45.5896,30.5628 C45.9186,30.1758 46.0486,29.6878 45.9556,29.1878 L45.9556,29.1878 Z" id="AWS-Amazon-Simple-Storage_S3-Replication-Time-Control_Resource-Icon_light-bg" fill="#7AA116"></path>
    </g>
</svg>`, Ty = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Storage/Res_AWS-Backup_Storage_48</title>
    <g id="Icon-Resource/Storage/Res_AWS-Backup_Storage_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M22,31 L26,31 L26,29 L22,29 L22,31 Z M17,33.007 L17,27 L31,27 L31,33 L17,33.007 Z M19,17 L24,17 L24,20.933 C24,21.485 24.447,21.933 25,21.933 L29,21.933 L29,25 L19,25 L19,17 Z M28.5,20 L26,20 L26,17.458 L28.5,20 Z M31.993,25 L31,25 L31,20.246 C31,19.991 30.902,19.746 30.728,19.561 L26.728,15.314 C26.539,15.114 26.275,15 26,15 L18.472,15 C17.66,15 17,15.66 17,16.472 L17,25 L16,25 C15.447,25 15,25.448 15,26 L15,33.007 C15,34.106 15.895,35 16.993,35 L31,35 C32.099,35 32.993,34.106 32.993,33.007 L32.993,26 C32.993,25.448 32.546,25 31.993,25 L31.993,25 Z M42,21 C40.897,21 40,20.103 40,19 C40,17.897 40.897,17 42,17 C43.103,17 44,17.897 44,19 C44,20.103 43.103,21 42,21 L42,21 Z M34.296,37.03 C34.196,37.022 34.101,37 34,37 C32.141,37 30.589,38.28 30.142,40 L17.858,40 C17.411,38.28 15.859,37 14,37 C13.899,37 13.804,37.022 13.704,37.03 L8.195,22.338 C9.28,21.622 10,20.395 10,19 C10,18.511 9.899,18.047 9.738,17.613 L21.812,9.341 C22.442,9.755 23.192,10 24,10 C24.808,10 25.558,9.755 26.188,9.341 L38.262,17.613 C38.101,18.047 38,18.511 38,19 C38,20.395 38.72,21.622 39.805,22.338 L34.296,37.03 Z M34,43 C32.897,43 32,42.103 32,41 C32,39.897 32.897,39 34,39 C35.103,39 36,39.897 36,41 C36,42.103 35.103,43 34,43 L34,43 Z M14,43 C12.897,43 12,42.103 12,41 C12,39.897 12.897,39 14,39 C15.103,39 16,39.897 16,41 C16,42.103 15.103,43 14,43 L14,43 Z M4,19 C4,17.897 4.897,17 6,17 C7.103,17 8,17.897 8,19 C8,20.103 7.103,21 6,21 C4.897,21 4,20.103 4,19 L4,19 Z M24,4 C25.103,4 26,4.897 26,6 C26,7.103 25.103,8 24,8 C22.897,8 22,7.103 22,6 C22,4.897 22.897,4 24,4 L24,4 Z M42,15 C41.008,15 40.111,15.376 39.412,15.976 L27.532,7.837 C27.821,7.284 28,6.666 28,6 C28,3.794 26.206,2 24,2 C21.794,2 20,3.794 20,6 C20,6.666 20.179,7.284 20.468,7.837 L8.588,15.976 C7.889,15.376 6.992,15 6,15 C3.794,15 2,16.794 2,19 C2,21.206 3.794,23 6,23 C6.101,23 6.196,22.978 6.296,22.97 L11.805,37.662 C10.72,38.378 10,39.605 10,41 C10,43.206 11.794,45 14,45 C15.859,45 17.411,43.72 17.858,42 L30.142,42 C30.589,43.72 32.141,45 34,45 C36.206,45 38,43.206 38,41 C38,39.605 37.28,38.378 36.195,37.662 L41.704,22.97 C41.804,22.978 41.899,23 42,23 C44.206,23 46,21.206 46,19 C46,16.794 44.206,15 42,15 L42,15 Z" id="Fill-1" fill="#7AA116"></path>
    </g>
</svg>`, Sy = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Storage/Res_Amazon-Elastic-File-System_Intelligent-Tiering_48</title>
    <g id="Icon-Resource/Storage/Res_Amazon-Elastic-File-System_Intelligent-Tiering_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M21.954,12.8 C21.954,14.33 20.71,15.574 19.18,15.574 C17.649,15.574 16.405,14.33 16.405,12.8 C16.405,11.27 17.649,10.026 19.18,10.026 C20.71,10.026 21.954,11.27 21.954,12.8 L21.954,12.8 Z M23.954,12.8 C23.954,10.167 21.812,8.026 19.18,8.026 C16.547,8.026 14.405,10.167 14.405,12.8 C14.405,15.433 16.547,17.574 19.18,17.574 C21.812,17.574 23.954,15.433 23.954,12.8 L23.954,12.8 Z M18.147,19.092 L17.405,18.895 C16.883,18.756 16.492,18.54 15.998,18.25 L15.329,17.858 L14.129,19.066 L12.894,17.822 L13.557,17.155 L14.047,16.527 L13.664,15.864 C13.383,15.378 13.197,15.055 13.071,14.578 L12.876,13.832 L11.18,13.832 L11.18,11.768 L12.888,11.768 L13.085,11.024 C13.225,10.493 13.451,10.085 13.73,9.607 L14.121,8.939 L12.912,7.735 L14.156,6.496 L14.822,7.159 L15.439,7.658 L16.103,7.273 C16.596,6.988 16.921,6.799 17.402,6.672 L18.147,6.475 L18.147,4.8 L20.212,4.8 L20.212,6.5 L20.953,6.698 C21.422,6.824 21.74,7.012 22.296,7.34 L22.968,7.737 L24.153,6.535 L25.366,7.764 L24.176,8.97 L24.554,9.629 C24.844,10.137 25.055,10.503 25.189,11.021 L25.386,11.768 L27.18,11.768 L27.18,13.832 L25.47,13.832 L25.272,14.575 C25.142,15.071 24.951,15.408 24.627,15.963 L24.236,16.632 L25.444,17.833 L24.199,19.07 L22.987,17.866 L22.236,18.301 C21.753,18.582 21.433,18.768 20.958,18.893 L20.212,19.089 L20.212,20.8 L18.147,20.8 L18.147,19.092 Z M22.212,21.425 L22.212,20.571 C22.368,20.505 22.516,20.433 22.658,20.358 L23.228,20.925 C23.763,21.459 24.633,21.459 25.169,20.926 L27.301,18.808 C27.562,18.548 27.706,18.201 27.706,17.832 C27.706,17.464 27.562,17.117 27.301,16.857 L26.734,16.295 C26.81,16.147 26.884,15.994 26.952,15.832 L27.805,15.832 C28.562,15.832 29.18,15.216 29.18,14.457 L29.18,11.143 C29.18,10.384 28.562,9.768 27.805,9.768 L26.873,9.768 C26.806,9.605 26.733,9.452 26.657,9.303 L27.224,8.729 C27.747,8.197 27.747,7.332 27.223,6.799 L25.131,4.678 C24.87,4.415 24.522,4.27 24.152,4.27 L24.15,4.27 C23.779,4.271 23.433,4.416 23.174,4.679 L22.632,5.229 C22.497,5.158 22.358,5.09 22.212,5.026 L22.212,4.175 C22.212,3.417 21.595,2.8 20.837,2.8 L17.522,2.8 C16.765,2.8 16.147,3.417 16.147,4.175 L16.147,4.994 C15.993,5.06 15.845,5.132 15.698,5.208 L15.129,4.641 C14.612,4.121 13.701,4.123 13.186,4.639 L11.057,6.76 C10.795,7.02 10.651,7.366 10.651,7.735 C10.651,8.104 10.795,8.45 11.056,8.709 L11.627,9.278 C11.548,9.435 11.473,9.597 11.402,9.768 L10.555,9.768 C9.797,9.768 9.18,10.384 9.18,11.143 L9.18,14.457 C9.18,15.216 9.797,15.832 10.555,15.832 L11.393,15.832 C11.459,15.986 11.53,16.134 11.607,16.28 L11.036,16.855 C10.509,17.387 10.509,18.255 11.038,18.791 L13.152,20.92 C13.674,21.445 14.587,21.446 15.104,20.921 L15.668,20.354 C15.822,20.433 15.98,20.507 16.147,20.576 L16.147,21.425 C16.147,22.183 16.765,22.8 17.522,22.8 L20.837,22.8 C21.595,22.8 22.212,22.183 22.212,21.425 L22.212,21.425 Z M41,39.98 L41,17.633 C41,15.874 40.109,13.98 38.154,13.98 L34.771,13.98 C34.583,12.674 34.126,10.502 33.141,10.066 C33.013,10.009 32.875,9.98 32.735,9.98 L31,9.98 L31,11.98 L32.234,11.98 C32.524,12.678 32.885,14.358 32.885,14.98 C32.885,15.532 33.332,15.98 33.885,15.98 L38.154,15.98 C38.95,15.98 39,17.621 39,17.633 L39,38.98 L4,38.98 L4,17.643 C4.008,17.253 4.166,15.98 5.846,15.98 L7,15.98 L7,13.98 L5.846,13.98 C3.024,13.98 2,16.165 2,17.633 L2,39.98 C2,40.532 2.447,40.98 3,40.98 L40,40.98 C40.553,40.98 41,40.532 41,39.98 L41,39.98 Z M35,32.98 C35,34.083 34.102,34.98 33,34.98 C31.897,34.98 31,34.083 31,32.98 C31,31.877 31.897,30.98 33,30.98 C34.102,30.98 35,31.877 35,32.98 L35,32.98 Z M37,32.98 C37,30.774 35.206,28.98 33,28.98 C30.794,28.98 29,30.774 29,32.98 C29,35.185 30.794,36.98 33,36.98 C35.206,36.98 37,35.185 37,32.98 L37,32.98 Z M21.5,27.589 L23.326,30.98 L19.674,30.98 L21.5,27.589 Z M25.858,32.492 C26.039,32.19 26.047,31.816 25.881,31.506 L22.381,25.006 C22.031,24.358 20.969,24.358 20.619,25.006 L17.119,31.506 C16.953,31.816 16.961,32.19 17.142,32.492 C17.322,32.795 17.648,32.98 18,32.98 L25,32.98 C25.351,32.98 25.678,32.795 25.858,32.492 L25.858,32.492 Z M8,34.98 L11,34.98 L11,31.98 L8,31.98 L8,34.98 Z M13,35.98 L13,30.98 C13,30.427 12.553,29.98 12,29.98 L7,29.98 C6.447,29.98 6,30.427 6,30.98 L6,35.98 C6,36.532 6.447,36.98 7,36.98 L12,36.98 C12.553,36.98 13,36.532 13,35.98 L13,35.98 Z M45,45.98 L8,45.98 C7.448,45.98 7.001,45.533 7,44.981 L7,44.98 L7,42.98 L9,42.98 L9,43.98 L44,43.98 L44,23.053 C44,22.49 43.542,22.009 42.979,21.981 L43.079,19.984 C44.717,20.065 46,21.413 46,23.053 L46,44.98 C46,45.532 45.553,45.98 45,45.98 L45,45.98 Z" id="Fill-1" fill="#7AA116"></path>
    </g>
</svg>`, by = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Storage/Res_Amazon-Simple-Storage-Service_S3-Glacier-Deep-Archive_48</title>
    <g id="Icon-Resource/Storage/Res_Amazon-Simple-Storage-Service_S3-Glacier-Deep-Archive_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M43.8584,39.7657 L45.0154,40.9217 L43.6014,42.3357 L42.1544,40.8897 L42.1544,40.9097 L40.1054,40.9097 L41.0154,42.4897 L43.1754,43.0967 L42.6344,45.0227 L41.0904,44.5877 L40.6674,46.1677 L38.7354,45.6507 L39.3044,43.5247 L38.2984,41.7787 L37.3094,43.4887 L37.8634,45.6617 L35.9254,46.1567 L35.5304,44.6027 L33.9504,45.0257 L33.4324,43.0937 L35.5564,42.5257 L36.4914,40.9097 L34.4584,40.9097 L32.9854,42.3447 L31.5884,40.9127 L32.7374,39.7937 L31.5804,38.6367 L32.9944,37.2227 L34.6804,38.9097 L36.6414,38.9097 L35.5764,37.0687 L33.4204,36.4617 L33.9624,34.5367 L35.5044,34.9707 L35.9284,33.3907 L37.8604,33.9087 L37.2904,36.0367 L38.2984,37.7807 L39.2854,36.0687 L38.7324,33.8967 L40.6704,33.4027 L41.0654,34.9567 L42.6464,34.5337 L43.1644,36.4647 L41.0364,37.0357 L39.9554,38.9097 L41.8734,38.9097 L43.6104,37.2137 L45.0064,38.6457 L43.8584,39.7657 Z M29.5554,39.7657 L30.7124,40.9217 L29.2974,42.3357 L27.8714,40.9097 L25.8024,40.9097 L26.7134,42.4897 L28.8724,43.0967 L28.3314,45.0227 L26.7884,44.5877 L26.3644,46.1677 L24.4324,45.6507 L25.0024,43.5267 L23.9944,41.7787 L23.0054,43.4877 L23.5594,45.6627 L21.6224,46.1557 L21.2264,44.6027 L19.6464,45.0257 L19.1294,43.0937 L21.2534,42.5257 L22.1874,40.9097 L20.1554,40.9097 L18.6824,42.3447 L17.2864,40.9127 L18.4344,39.7937 L17.2774,38.6367 L18.6914,37.2227 L20.3784,38.9097 L22.3374,38.9097 L21.2724,37.0677 L19.1174,36.4617 L19.6584,34.5367 L21.2024,34.9707 L21.6254,33.3907 L23.5564,33.9087 L22.9864,36.0377 L23.9944,37.7807 L24.9824,36.0677 L24.4294,33.8967 L26.3674,33.4027 L26.7624,34.9557 L28.3424,34.5337 L28.8604,36.4647 L26.7344,37.0357 L25.6524,38.9097 L27.5704,38.9097 L29.3064,37.2137 L30.7034,38.6457 L29.5554,39.7657 Z M22.8844,3.9997 C33.2964,3.9997 40.6334,7.2267 40.7694,9.0187 L40.7444,9.2107 C40.7204,9.3017 40.6704,9.3937 40.6134,9.4877 C40.5994,9.5107 40.5924,9.5327 40.5764,9.5557 C40.5124,9.6477 40.4244,9.7417 40.3304,9.8347 C40.3044,9.8607 40.2884,9.8847 40.2614,9.9097 C40.1584,10.0037 40.0334,10.0987 39.9004,10.1947 C39.8664,10.2197 39.8394,10.2447 39.8024,10.2697 C39.6604,10.3677 39.4944,10.4647 39.3224,10.5627 C39.2814,10.5847 39.2494,10.6087 39.2074,10.6307 C39.0174,10.7337 38.8064,10.8357 38.5864,10.9377 C38.5484,10.9537 38.5174,10.9717 38.4804,10.9897 C38.2354,11.0987 37.9684,11.2067 37.6884,11.3147 C37.6664,11.3237 37.6474,11.3307 37.6254,11.3397 C34.5434,12.5017 29.3724,13.4717 22.8884,13.4717 C14.4574,13.4717 8.2394,11.8297 5.9534,10.2577 C5.9524,10.2567 5.9514,10.2547 5.9494,10.2537 C5.7784,10.1367 5.6304,10.0197 5.5044,9.9037 C5.4874,9.8877 5.4764,9.8717 5.4604,9.8557 C5.3554,9.7547 5.2634,9.6537 5.1944,9.5547 C5.1754,9.5277 5.1674,9.5007 5.1504,9.4727 C5.0974,9.3857 5.0504,9.2997 5.0274,9.2157 L5.0024,9.0187 C5.1374,7.2267 12.4734,3.9997 22.8844,3.9997 L22.8844,3.9997 Z M43.1854,26.4437 C42.8954,26.4977 42.1514,26.5267 40.4824,26.1197 L40.7034,24.4817 C42.4354,25.5347 43.0084,26.1687 43.1854,26.4437 L43.1854,26.4437 Z M23.1544,19.9087 L24.1544,19.9097 L23.1554,19.9107 C23.1544,19.9107 23.1544,19.9097 23.1544,19.9087 L23.1544,19.9087 Z M9.2824,40.9097 C9.2824,40.8647 9.2794,40.8207 9.2734,40.7767 L5.4414,12.2777 C5.6714,12.4117 5.9184,12.5417 6.1764,12.6677 C6.3324,12.7437 6.4994,12.8157 6.6634,12.8877 C6.8104,12.9537 6.9604,13.0187 7.1154,13.0817 C7.3014,13.1577 7.4924,13.2317 7.6874,13.3037 C7.8294,13.3567 7.9754,13.4057 8.1214,13.4557 C8.8784,13.7157 9.6954,13.9507 10.5654,14.1617 C10.6794,14.1887 10.7944,14.2157 10.9104,14.2437 C11.2034,14.3107 11.4984,14.3757 11.8004,14.4377 C11.8794,14.4537 11.9604,14.4687 12.0394,14.4847 C13.0644,14.6877 14.1384,14.8607 15.2504,15.0007 C15.3144,15.0087 15.3794,15.0177 15.4444,15.0267 C17.0114,15.2187 18.6364,15.3497 20.2744,15.4167 C20.3244,15.4187 20.3734,15.4207 20.4234,15.4227 C21.2444,15.4547 22.0664,15.4767 22.8844,15.4767 C23.6944,15.4767 24.5074,15.4547 25.3214,15.4237 C25.3934,15.4207 25.4654,15.4177 25.5394,15.4147 C26.7244,15.3657 27.9044,15.2837 29.0604,15.1667 C29.1164,15.1617 29.1724,15.1577 29.2284,15.1517 C29.5744,15.1157 29.9164,15.0767 30.2564,15.0347 C30.3794,15.0197 30.5004,15.0037 30.6214,14.9887 C30.9534,14.9457 31.2844,14.9017 31.6094,14.8537 C31.6234,14.8517 31.6364,14.8487 31.6504,14.8467 C32.3064,14.7487 32.9454,14.6377 33.5684,14.5167 C33.7224,14.4867 33.8794,14.4567 34.0314,14.4257 C34.2894,14.3717 34.5414,14.3177 34.7914,14.2597 C34.9684,14.2197 35.1424,14.1767 35.3154,14.1347 C35.5484,14.0777 35.7814,14.0217 36.0054,13.9597 C36.3344,13.8717 36.6524,13.7807 36.9614,13.6847 C37.1644,13.6217 37.3574,13.5557 37.5524,13.4907 C37.7464,13.4247 37.9374,13.3587 38.1234,13.2897 C38.2924,13.2277 38.4574,13.1627 38.6184,13.0987 C38.8094,13.0207 38.9924,12.9417 39.1724,12.8607 C39.3084,12.7997 39.4474,12.7417 39.5764,12.6777 C39.8394,12.5497 40.0914,12.4167 40.3274,12.2807 L38.5384,25.5697 C33.9794,24.1357 27.9024,21.3687 25.1384,20.0697 C25.1424,20.0157 25.1544,19.9637 25.1544,19.9097 C25.1544,18.8067 24.2564,17.9097 23.1544,17.9097 C22.0514,17.9097 21.1544,18.8067 21.1544,19.9097 C21.1544,21.0117 22.0514,21.9097 23.1544,21.9097 C23.4454,21.9097 23.7204,21.8427 23.9704,21.7307 C27.0704,23.1977 33.4754,26.1177 38.2674,27.5787 L37.7044,31.7637 L39.6864,32.0337 L40.2134,28.1137 C41.2364,28.3547 42.0774,28.4757 42.7624,28.4757 C43.7534,28.4757 44.4204,28.2227 44.8454,27.7167 C45.1954,27.2997 45.3334,26.7757 45.2334,26.2397 C45.0174,25.0867 43.6914,23.8697 40.9924,22.3327 L42.6954,9.6747 C42.7014,9.6457 42.7094,9.6167 42.7124,9.5867 L42.7624,9.1987 C42.7684,9.1557 42.7714,9.1117 42.7714,9.0687 C42.7714,4.9037 32.2914,1.9997 22.8844,1.9997 C13.4794,1.9997 3.0004,4.9037 3.0004,9.0687 C3.0004,9.1117 3.0034,9.1557 3.0084,9.1987 L3.0594,9.5867 C3.0604,9.5987 3.0644,9.6107 3.0664,9.6217 L7.2834,40.9867 C7.3804,43.8087 12.8434,45.0497 16.1114,45.5407 L16.4084,43.5627 C10.9704,42.7467 9.2824,41.3317 9.2824,40.9097 L9.2824,40.9097 Z" id="Amazon-Simple-Storage_Service-Glacier-Deep-Archive_Resource-Icon_light-bg" fill="#7AA116"></path>
    </g>
</svg>`, Ey = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Storage/Res_Amazon-Simple-Storage-Service_S3-Select_48</title>
    <g id="Icon-Resource/Storage/Res_Amazon-Simple-Storage-Service_S3-Select_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M38.122,39.521 C38.042,39.668 38,39.833 38,40 L38,44 L35,44 L35,40 C35,39.833 34.958,39.668 34.878,39.521 L29.684,30 L43.315,30 L38.122,39.521 Z M45.86,28.49 C45.68,28.186 45.352,28 45,28 L28,28 C27.647,28 27.32,28.186 27.14,28.49 C26.96,28.793 26.953,29.169 27.122,29.479 L33,40.255 L33,45 C33,45.552 33.447,46 34,46 L39,46 C39.553,46 40,45.552 40,45 L40,40.255 L45.878,29.479 C46.047,29.169 46.04,28.793 45.86,28.49 L45.86,28.49 Z M19.416,4 C28.227,4 34.693,6.751 34.832,8.227 L34.809,8.406 C34.306,9.879 28.15,11.976 19.416,11.976 C10.681,11.976 4.525,9.878 4.026,8.405 L4.002,8.226 C4.143,6.75 10.607,4 19.416,4 L19.416,4 Z M37.127,22.16 C37.157,22.246 37.163,22.317 37.105,22.432 C37.094,22.456 37.03,22.499 36.919,22.536 C36.469,22.685 35.78,22.669 34.925,22.53 L35.188,20.58 C36.012,21.023 36.939,21.618 37.127,22.16 L37.127,22.16 Z M27.125,37.739 C24.894,38.254 22.157,38.539 19.416,38.539 C12.107,38.539 7.852,36.701 7.726,35.954 C7.726,35.91 7.723,35.865 7.717,35.821 L4.413,11.282 C7.652,13.055 13.672,13.976 19.416,13.976 C25.161,13.976 31.182,13.055 34.421,11.282 L32.967,22.082 C29.718,21.179 25.349,19.34 21.973,17.729 C21.839,16.755 21.01,16 20,16 C18.897,16 18,16.897 18,18 C18,19.103 18.897,20 20,20 C20.456,20 20.872,19.841 21.209,19.583 C23.911,20.874 28.768,23.054 32.7,24.067 L32.474,25.746 L34.456,26.013 L34.663,24.477 C35.209,24.56 35.731,24.617 36.192,24.617 C36.711,24.617 37.17,24.56 37.55,24.433 C38.334,24.172 38.714,23.688 38.894,23.327 C39.186,22.743 39.228,22.112 39.016,21.502 C38.523,20.088 36.748,19.095 35.471,18.476 L36.781,8.746 L36.78,8.745 C36.781,8.744 36.781,8.743 36.781,8.741 L36.825,8.403 C36.831,8.361 36.834,8.317 36.834,8.274 C36.834,4.521 27.828,2 19.416,2 C11.005,2 2,4.521 2,8.274 C2,8.318 2.003,8.362 2.009,8.406 L2.054,8.744 C2.054,8.745 2.054,8.745 2.054,8.746 L2.054,8.746 L5.727,36.032 C5.852,39.336 13.955,40.539 19.416,40.539 C22.304,40.539 25.202,40.236 27.575,39.688 C28.533,39.467 29.393,39.208 30.131,38.916 L29.396,37.056 C28.751,37.311 27.987,37.54 27.125,37.739 L27.125,37.739 Z M10.724,24 L13,20.016 L15.276,24 L10.724,24 Z M17.865,25.502 C18.044,25.194 18.045,24.813 17.868,24.504 L13.868,17.504 C13.513,16.881 12.487,16.881 12.132,17.504 L8.132,24.504 C7.955,24.813 7.956,25.194 8.135,25.502 C8.314,25.81 8.643,26 8.99999579,26 L16.9999958,26 C17.356,26 17.685,25.81 17.865,25.502 L17.865,25.502 Z M23.194,28.197 C23.194,29.57 24.311,30.687 25.684,30.687 L25.684,32.687 C23.209,32.687 21.194,30.672 21.194,28.197 C21.194,25.721 23.209,23.707 25.684,23.707 C26.965,23.707 28.188,24.256 29.041,25.215 L27.547,26.544 C27.073,26.012 26.394,25.707 25.684,25.707 C24.311,25.707 23.194,26.824 23.194,28.197 L23.194,28.197 Z M13,34 L17,34 L17,30 L13,30 L13,34 Z M12,36 L18,36 C18.553,36 19,35.552 19,35 L19,29 C19,28.448 18.553,28 18,28 L12,28 C11.447,28 11,28.448 11,29 L11,35 C11,35.552 11.447,36 12,36 L12,36 Z" id="Fill-1" fill="#7AA116"></path>
    </g>
</svg>`, Iy = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Storage/Res_Amazon-Simple-Storage-Service_S3-On-Outposts_48</title>
    <g id="Icon-Resource/Storage/Res_Amazon-Simple-Storage-Service_S3-On-Outposts_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M42.416,22.305 C42.206,21.444 37.853,19.487 31.461,19.487 C25.069,19.487 20.717,21.444 20.507,22.305 L20.515,22.363 C20.858,23.228 25.154,24.754 31.461,24.754 C37.704,24.754 41.971,23.259 42.391,22.39 L42.397,22.338 L42.411,22.34 L42.416,22.305 Z M42.037,25.015 C39.16,26.343 34.353,26.754 31.461,26.754 C28.562,26.754 23.745,26.341 20.871,25.008 L21.901,32.656 C22.672,32.939 23.395,33.396 24.03,34.024 C24.396,34.386 24.717,34.799 24.989,35.26 C25.601,34.988 26.292,34.935 26.959,35.131 C28.064,35.459 28.84,36.371 29.114,37.631 C29.562,37.778 30.006,37.986 30.4,38.236 C31.768,39.101 32.461,40.234 32.461,41.604 C32.461,42.529 32.25,43.323 31.853,43.991 C33.695,43.965 35.516,43.771 37.015,43.425 C37.631,43.283 38.174,43.12 38.631,42.939 C39.336,42.66 39.631,42.413 39.709,42.313 C39.71,42.294 39.713,42.275 39.715,42.256 L40.785,34.305 C37.887,33.384 34.217,31.726 32.24,30.797 C32.021,30.923 31.77,31 31.5,31 C30.673,31 30,30.327 30,29.5 C30,28.673 30.673,28 31.5,28 C32.104,28 32.624,28.362 32.861,28.879 C34.43,29.619 38.141,31.324 41.057,32.29 L42.037,25.015 Z M30.461,41.604 C30.461,41.128 30.326,40.556 29.33,39.925 C28.938,39.677 28.457,39.487 28.042,39.417 C27.536,39.331 27.184,38.88 27.21,38.379 C27.143,37.676 26.84,37.181 26.391,37.049 C26.029,36.943 25.655,37.08 25.411,37.407 C25.189,37.701 24.821,37.846 24.462,37.795 C24.099,37.741 23.794,37.491 23.67,37.144 C23.425,36.461 23.073,35.889 22.625,35.447 C22.222,35.049 21.301,34.314 19.996,34.314 C19.537,34.314 19.031,34.405 18.483,34.633 C17.305,35.124 16.346,36.598 16.346,37.919 C16.346,38.071 16.354,38.22 16.373,38.366 C16.436,38.867 16.114,39.337 15.624,39.46 C14.82,39.662 13.862,40.211 13.862,41.681 C13.862,42.878 14.523,43.534 15.078,43.875 C15.212,43.957 15.368,44 15.531,44 L28.122,44.013 L28.127,44.013 C28.518,44.011 30.461,43.879 30.461,41.604 L30.461,41.604 Z M14.348,37.786 C14.406,35.702 15.834,33.571 17.714,32.787 C18.418,32.494 19.134,32.355 19.84,32.334 L18.543,22.709 L18.544,22.709 C18.543,22.708 18.543,22.707 18.543,22.705 L18.511,22.459 C18.505,22.416 18.502,22.373 18.502,22.329 C18.502,20.954 19.933,19.825 22.074,19 L22,19 L22,5 C22,4.449 21.552,4 21,4 L5,4 C4.448,4 4,4.449 4,5 L4,40 C4,40.552 4.448,41 5,41 L11.909,41 C12.111,39.523 12.98,38.38 14.348,37.786 L14.348,37.786 Z M15.529,46 C14.996,45.999 14.479,45.854 14.032,45.579 C13.401,45.192 12.444,44.389 12.049,43 L8,43 L8,46 L6,46 L6,43 L5,43 C3.346,43 2,41.655 2,40 L2,5 C2,3.346 3.346,2 5,2 L21,2 C22.654,2 24,3.346 24,5 L24,18.389 C26.234,17.807 28.887,17.487 31.461,17.487 C37.693,17.487 44.421,19.339 44.421,22.329 C44.421,22.373 44.418,22.416 44.412,22.459 L44.38,22.705 C44.375,22.747 44.367,22.788 44.356,22.829 C44.354,22.838 44.349,22.845 44.347,22.853 L43.312,30.529 C45.008,31.518 45.819,32.314 45.974,33.137 C46.058,33.586 45.941,34.025 45.648,34.374 C45.308,34.78 44.796,34.981 44.048,34.981 C43.674,34.981 43.233,34.925 42.733,34.825 L41.704,42.469 C41.663,43.418 40.877,44.202 39.366,44.799 C38.816,45.017 38.176,45.21 37.464,45.373 C35.716,45.778 33.584,46 31.461,46 L28.131,46 L15.529,46 Z M8,19 L19,19 L19,17 L8,17 L8,19 Z M8,24 L16,24 L16,22 L8,22 L8,24 Z M8,14 L19,14 L19,12 L8,12 L8,14 Z" id="Fill-4" fill="#7AA116"></path>
    </g>
</svg>`, Fy = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Storage/Res_AWS-Storage-Gateway_Amazon-S3-File-Gateway_48</title>
    <g id="Icon-Resource/Storage/Res_AWS-Storage-Gateway_Amazon-S3-File-Gateway_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M31,7.5 C27.486,5.689 23.498,4 18,4 C12.189,4 8.621,5.404 5,7.5 L5,46 L3,46 L3,7.072 C3,6.752 3.17,6.456 3.446,6.294 C7.308,4.031 11.507,2 18,2 C24.03,2 28.648,4.279 32.203,6.111 L32.511,6.27 C32.812,6.425 33,6.734 33,7.072 L33,16 L31,16 L31,7.5 Z M38,37 L38,45 C38,45.55 37.55,46 37,46 L9.914,46 C9.415,46 9.012,45.596 9.011,45.098 L9,26 C9,25.45 9.449,25 10,25 L18,25 C18.229,25 18.497,25.168 18.597,25.375 L19.441,26.724 C19.522,26.893 19.693,27 19.88,27 L27,27 L27,29 L19,29 C18.653,29 18.5,29 18.203,28.209 L17.618,27.288 C17.547,27.114 17.188,27 17,27 L11,27 L11,44 L36,44 L36,37 L38,37 Z M35.979,32.995 C32.967,32.995 32.139,32.558 31.97,32.44 L30.4,23.282 C32.569,23.992 35.495,24.026 36,24.026 C36.506,24.026 39.438,23.992 41.608,23.28 L41.046,26.635 C39.688,26.14 38.234,25.449 37.417,25.057 C37.219,24.46 36.662,24.026 36,24.026 C35.173,24.026 34.5,24.699 34.5,25.526 C34.5,26.354 35.173,27.026 36,27.026 C36.22,27.026 36.427,26.976 36.615,26.891 C37.544,27.335 39.187,28.113 40.71,28.637 L40.073,32.432 C39.894,32.554 39.034,32.995 35.979,32.995 L35.979,32.995 Z M36,20.026 C39.137,20.026 41.155,20.611 41.829,21.026 C41.155,21.442 39.137,22.026 36,22.026 C32.863,22.026 30.845,21.442 30.171,21.026 C30.845,20.611 32.863,20.026 36,20.026 L36,20.026 Z M44.933,27.773 C44.804,27.107 44.17,26.587 43.177,26.02 L43.986,21.192 L43.975,21.19 C43.979,21.134 44,21.084 44,21.026 C44,18.11 36.818,18.026 36,18.026 C35.182,18.026 28,18.11 28,21.026 C28,21.085 28.021,21.136 28.026,21.193 L28.015,21.195 L30.013,32.862 C30.254,34.337 32.094,34.995 35.979,34.995 C39.921,34.995 41.786,34.337 42.028,32.866 L42.648,29.169 C42.979,29.231 43.264,29.263 43.51,29.263 C44.053,29.263 44.409,29.112 44.667,28.807 C44.908,28.52 45.005,28.143 44.933,27.773 L44.933,27.773 Z" id="Fill-1" fill="#7AA116"></path>
    </g>
</svg>`, Oy = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Storage/Res_Amazon-Simple-Storage-Service-Glacier_Archive_48</title>
    <g id="Icon-Resource/Storage/Res_Amazon-Simple-Storage-Service-Glacier_Archive_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M23.7007,25.3115 C25.2437,25.3115 26.4987,26.5665 26.4987,28.1095 C26.4987,29.6525 25.2437,30.9075 23.7007,30.9075 C22.1577,30.9075 20.9027,29.6525 20.9027,28.1095 C20.9027,26.5665 22.1577,25.3115 23.7007,25.3115 L23.7007,25.3115 Z M18.9027,28.1095 C18.9027,30.4225 20.5487,32.3585 22.7307,32.8085 L22.7307,39.8495 L24.7307,39.8495 L24.7307,32.7895 C26.8817,32.3155 28.4987,30.4005 28.4987,28.1095 C28.4987,27.5365 28.3807,26.9945 28.1947,26.4835 L34.7287,22.7085 L33.7287,20.9765 L27.1427,24.7815 C26.2697,23.8785 25.0527,23.3115 23.7007,23.3115 C22.3477,23.3115 21.1307,23.8775 20.2577,24.7815 L13.6727,20.9765 L12.6727,22.7085 L19.2057,26.4835 C19.0197,26.9935 18.9027,27.5365 18.9027,28.1095 L18.9027,28.1095 Z M31.9267,25.6205 C32.1727,26.4195 32.2977,27.2575 32.2977,28.1095 C32.2977,32.0315 29.6457,35.4535 25.8487,36.4305 L25.3507,34.4935 C28.2627,33.7445 30.2977,31.1185 30.2977,28.1095 C30.2977,27.4575 30.2027,26.8185 30.0137,26.2075 L31.9267,25.6205 Z M22.0517,34.4935 L21.5537,36.4305 C17.7567,35.4535 15.1047,32.0315 15.1047,28.1095 C15.1047,27.2555 15.2297,26.4175 15.4747,25.6205 L17.3877,26.2075 C17.1997,26.8155 17.1047,27.4555 17.1047,28.1095 C17.1047,31.1185 19.1387,33.7445 22.0517,34.4935 L22.0517,34.4935 Z M19.0977,23.3845 L17.6997,21.9555 C19.3097,20.3795 21.4417,19.5125 23.7007,19.5125 C25.9597,19.5125 28.0907,20.3795 29.7027,21.9555 L28.3047,23.3845 C27.0687,22.1775 25.4337,21.5125 23.7007,21.5125 C21.9677,21.5125 20.3327,22.1775 19.0977,23.3845 L19.0977,23.3845 Z M13.4377,3.9995 L33.9647,3.9995 L38.3977,9.8965 L9.0037,9.8965 L13.4377,3.9995 Z M7.0007,11.8965 L40.4007,11.8965 C40.7797,11.8965 41.1267,11.6825 41.2957,11.3425 C41.4657,11.0035 41.4287,10.5985 41.1997,10.2955 L35.2627,2.3995 C35.0737,2.1475 34.7777,1.9995 34.4637,1.9995 L12.9387,1.9995 C12.6247,1.9995 12.3287,2.1475 12.1397,2.3995 L6.2017,10.2955 C5.9727,10.5985 5.9357,11.0035 6.1057,11.3425 C6.2747,11.6825 6.6217,11.8965 7.0007,11.8965 L7.0007,11.8965 Z M8.0607,44.1135 L39.4007,44.1135 L39.4007,15.4055 L8.0607,15.4055 L8.0607,44.1135 Z M40.4007,13.4055 L7.0607,13.4055 C6.5087,13.4055 6.0607,13.8525 6.0607,14.4055 L6.0607,45.1135 C6.0607,45.6655 6.5087,46.1135 7.0607,46.1135 L40.4007,46.1135 C40.9537,46.1135 41.4007,45.6655 41.4007,45.1135 L41.4007,14.4055 C41.4007,13.8525 40.9537,13.4055 40.4007,13.4055 L40.4007,13.4055 Z" id="AWS-Amazon-S3-Glacier_Archive_Resource-Icon_dark-bg" fill="#7AA116"></path>
    </g>
</svg>`, Ny = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Storage/Res_AWS-Backup_Virtual-Machine-Monitor_48</title>
    <g id="Icon-Resource/Storage/Res_AWS-Backup_Virtual-Machine-Monitor_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M41.94,34.4116 C42.306,34.7666 42.507,35.2446 42.507,35.7556 C42.507,36.2666 42.306,36.7446 41.939,37.0996 L36.831,42.0666 C36.099,42.7796 34.952,42.7806 34.216,42.0666 L32.073,39.9826 C31.064,40.5006 30.012,40.9256 28.932,41.2526 L28.932,44.1246 C28.932,45.1586 28.091,45.9996 27.057,45.9996 L19.807,45.9996 C18.773,45.9996 17.932,45.1586 17.932,44.1246 L17.932,41.2526 C16.852,40.9256 15.8,40.5006 14.792,39.9826 L12.648,42.0666 C11.914,42.7806 10.765,42.7806 10.033,42.0656 L4.924,37.0996 C4.558,36.7446 4.357,36.2666 4.357,35.7556 C4.357,35.2446 4.558,34.7666 4.925,34.4116 L7.004,32.3886 C6.359,31.1936 5.855,29.9346 5.502,28.6376 L7.432,28.1126 C7.806,29.4866 8.372,30.8126 9.115,32.0526 C9.352,32.4506 9.286,32.9596 8.954,33.2836 L6.411,35.7556 L11.34,40.5476 L13.923,38.0366 C14.242,37.7256 14.727,37.6656 15.113,37.8836 C16.395,38.6086 17.764,39.1616 19.181,39.5246 C19.624,39.6386 19.932,40.0366 19.932,40.4936 L19.932,43.9996 L26.932,43.9996 L26.932,40.4936 C26.932,40.0366 27.241,39.6386 27.683,39.5246 C29.1,39.1616 30.469,38.6086 31.752,37.8836 C32.138,37.6656 32.622,37.7256 32.941,38.0366 L35.524,40.5476 L40.454,35.7556 L37.911,33.2836 C37.579,32.9596 37.512,32.4506 37.75,32.0526 C38.493,30.8126 39.058,29.4866 39.432,28.1126 L41.362,28.6376 C41.009,29.9346 40.505,31.1936 39.86,32.3886 L41.94,34.4116 Z M4.924,13.5886 C4.558,13.2326 4.357,12.7556 4.357,12.2446 C4.357,11.7336 4.558,11.2556 4.925,10.8996 L10.034,5.9336 C10.765,5.2206 11.914,5.2186 12.647,5.9326 L14.792,8.0176 C15.8,7.4996 16.852,7.0746 17.932,6.7476 L17.932,3.8746 C17.932,2.8416 18.773,1.9996 19.807,1.9996 L27.057,1.9996 C28.091,1.9996 28.932,2.8416 28.932,3.8746 L28.932,6.7476 C30.012,7.0746 31.064,7.4996 32.073,8.0176 L34.216,5.9326 C34.951,5.2206 36.099,5.2196 36.832,5.9346 L41.94,10.9006 C42.306,11.2556 42.507,11.7336 42.507,12.2446 C42.507,12.7556 42.306,13.2326 41.939,13.5886 L39.86,15.6116 C40.505,16.8066 41.009,18.0646 41.362,19.3626 L39.432,19.8876 C39.058,18.5136 38.493,17.1876 37.75,15.9476 C37.512,15.5496 37.579,15.0396 37.911,14.7166 L40.454,12.2446 L35.523,7.4526 L32.941,9.9626 C32.622,10.2736 32.138,10.3346 31.752,10.1166 C30.469,9.3916 29.1,8.8386 27.683,8.4746 C27.241,8.3616 26.932,7.9626 26.932,7.5066 L26.932,3.9996 L19.932,3.9996 L19.932,7.5066 C19.932,7.9626 19.624,8.3616 19.181,8.4746 C17.764,8.8386 16.395,9.3916 15.113,10.1166 C14.727,10.3346 14.242,10.2736 13.923,9.9626 L11.341,7.4526 L6.411,12.2446 L8.954,14.7166 C9.286,15.0396 9.352,15.5496 9.115,15.9476 C8.372,17.1876 7.806,18.5136 7.432,19.8876 L5.502,19.3626 C5.855,18.0646 6.359,16.8066 7.004,15.6116 L4.924,13.5886 Z M7.406,22.7916 C8.181,22.7916 8.812,23.4226 8.812,24.1986 C8.812,24.9736 8.181,25.6046 7.406,25.6046 C6.63,25.6046 6,24.9736 6,24.1986 C6,23.4226 6.63,22.7916 7.406,22.7916 L7.406,22.7916 Z M23.648,11.3626 C24.423,11.3626 25.054,11.9936 25.054,12.7686 C25.054,13.5436 24.423,14.1746 23.648,14.1746 C22.873,14.1746 22.242,13.5436 22.242,12.7686 C22.242,11.9936 22.873,11.3626 23.648,11.3626 L23.648,11.3626 Z M39.89,22.7916 C40.666,22.7916 41.296,23.4226 41.296,24.1986 C41.296,24.9736 40.666,25.6046 39.89,25.6046 C39.115,25.6046 38.484,24.9736 38.484,24.1986 C38.484,23.4226 39.115,22.7916 39.89,22.7916 L39.89,22.7916 Z M23.628,37.6516 C22.852,37.6516 22.221,37.0206 22.221,36.2446 C22.221,35.4696 22.852,34.8386 23.628,34.8386 C24.403,34.8386 25.034,35.4696 25.034,36.2446 C25.034,37.0206 24.403,37.6516 23.628,37.6516 L23.628,37.6516 Z M10.468,22.7336 L21.252,15.1856 C21.868,15.7956 22.714,16.1746 23.648,16.1746 C24.582,16.1746 25.428,15.7956 26.044,15.1856 L36.828,22.7336 C36.614,23.1796 36.484,23.6716 36.484,24.1986 C36.484,24.9016 36.698,25.5556 37.065,26.0996 L26.024,33.8286 C25.408,33.2176 24.561,32.8386 23.628,32.8386 C22.694,32.8386 21.847,33.2176 21.231,33.8286 L10.216,26.1176 C10.591,25.5706 10.812,24.9106 10.812,24.1986 C10.812,23.6716 10.682,23.1796 10.468,22.7336 L10.468,22.7336 Z M7.406,27.6046 C7.856,27.6046 8.284,27.5126 8.677,27.3526 L8.617,27.4396 L20.286,35.6076 C20.246,35.8146 20.221,36.0266 20.221,36.2446 C20.221,38.1236 21.75,39.6516 23.628,39.6516 C25.505,39.6516 27.034,38.1236 27.034,36.2446 C27.034,36.0266 27.009,35.8146 26.969,35.6076 L38.638,27.4396 L38.566,27.3366 C38.974,27.5086 39.421,27.6046 39.89,27.6046 C41.768,27.6046 43.296,26.0766 43.296,24.1986 C43.296,22.3196 41.768,20.7916 39.89,20.7916 C39.274,20.7916 38.704,20.9686 38.205,21.2566 L26.99,13.4056 C27.029,13.1986 27.054,12.9866 27.054,12.7686 C27.054,10.8906 25.526,9.3626 23.648,9.3626 C21.77,9.3626 20.242,10.8906 20.242,12.7686 C20.242,12.9866 20.267,13.1986 20.306,13.4056 L9.091,21.2566 C8.592,20.9686 8.022,20.7916 7.406,20.7916 C5.528,20.7916 4,22.3196 4,24.1986 C4,26.0766 5.528,27.6046 7.406,27.6046 L7.406,27.6046 Z" id="Fill-1" fill="#7AA116"></path>
    </g>
</svg>`, Dy = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Storage/Res_Amazon-Simple-Storage-Service_S3-Multi-Region-Access-Points_48</title>
    <g id="Icon-Resource/Storage/Res_Amazon-Simple-Storage-Service_S3-Multi-Region-Access-Points_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M28.001,15 L29.408,12.186 L30.814,15 L28.001,15 Z M30.303,9.503 C30.133,9.164 29.787,8.95 29.408,8.95 C29.029,8.95 28.684,9.164 28.514,9.503 L25.488,15.553 C25.333,15.863 25.35,16.231 25.532,16.526 C25.714,16.82 26.036,17 26.383,17 L32.433,17 C32.779,17 33.101,16.821 33.283,16.526 C33.466,16.231 33.482,15.863 33.327,15.553 L30.303,9.503 Z M27,26 C25.897,26 25,25.103 25,24 C25,22.897 25.897,22 27,22 C28.103,22 29,22.897 29,24 C29,25.103 28.103,26 27,26 L27,26 Z M27,20 C24.794,20 23,21.794 23,24 C23,26.206 24.794,28 27,28 C29.206,28 31,26.206 31,24 C31,21.794 29.206,20 27,20 L27,20 Z M18,18 L21,18 L21,15 L18,15 L18,18 Z M23,14 C23,13.448 22.553,13 22,13 L17,13 C16.447,13 16,13.448 16,14 L16,19 C16,19.552 16.447,20 17,20 L22,20 C22.553,20 23,19.552 23,19 L23,14 Z M41.5,44 C40.121,44 39,42.878 39,41.5 C39,40.122 40.121,39 41.5,39 C42.879,39 44,40.122 44,41.5 C44,42.878 42.879,44 41.5,44 L41.5,44 Z M24.995,34.676 C22.459,32.443 13.264,23.869 12.94,16.694 C12.778,13.102 13.913,9.842 16.137,7.516 C18.335,5.216 21.4,4 25,4 C28.744,4 31.836,5.168 33.938,7.377 C36.077,9.623 37.107,12.843 36.918,16.69 C36.566,23.858 27.503,32.436 24.995,34.676 L24.995,34.676 Z M27,41.5 C27,42.878 25.879,44 24.5,44 C23.121,44 22,42.878 22,41.5 C22,40.122 23.121,39 24.5,39 C25.879,39 27,40.122 27,41.5 L27,41.5 Z M10,41.5 C10,42.878 8.879,44 7.5,44 C6.121,44 5,42.878 5,41.5 C5,40.122 6.121,39 7.5,39 C8.879,39 10,40.122 10,41.5 L10,41.5 Z M43,37.276 L43,30 C43,29.448 42.553,29 42,29 L33.162,29 C36.05,25.377 38.712,20.956 38.916,16.788 C39.132,12.381 37.912,8.649 35.388,5.998 C32.897,3.382 29.306,2 25,2 C20.841,2 17.275,3.43 14.69,6.134 C12.086,8.859 10.755,12.642 10.942,16.784 C11.13,20.954 13.819,25.376 16.742,29 L8,29 C7.447,29 7,29.448 7,30 L7,37.051 C4.756,37.303 3,39.19 3,41.5 C3,43.981 5.019,46 7.5,46 C9.981,46 12,43.981 12,41.5 C12,39.547 10.742,37.898 9,37.276 L9,31 L18.441,31 C20.641,33.461 22.722,35.353 23.736,36.236 L23.712,37.08 C21.606,37.455 20,39.288 20,41.5 C20,43.981 22.019,46 24.5,46 C26.981,46 29,43.981 29,41.5 C29,39.441 27.602,37.719 25.71,37.186 L25.724,36.697 C26.25,36.252 28.777,34.063 31.482,31 L41,31 L41,37.051 C38.756,37.303 37,39.19 37,41.5 C37,43.981 39.019,46 41.5,46 C43.981,46 46,43.981 46,41.5 C46,39.547 44.742,37.898 43,37.276 L43,37.276 Z" id="Fill-1" fill="#7AA116"></path>
    </g>
</svg>`, Py = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Storage/Res_AWS-Backup_Backup-Vault_48</title>
    <g id="Icon-Resource/Storage/Res_AWS-Backup_Backup-Vault_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M10.298,22.955 L8.298,22.969 C8.333,27.982 10.654,32.573 14.668,35.564 C17.503,37.677 20.819,38.696 24.109,38.696 C28.942,38.696 33.717,36.496 36.82,32.332 C42.036,25.334 40.587,15.396 33.589,10.18 C26.813,5.13 17.297,6.345 11.963,12.775 L12,10.014 L10,9.987 L9.933,14.987 C9.929,15.252 10.031,15.508 10.216,15.698 C10.402,15.888 10.654,15.997 10.919,16 L15.986,16.068 L16.014,14.068 L13.513,14.035 C18.176,8.43 26.479,7.376 32.394,11.783 C38.507,16.341 39.774,25.023 35.217,31.137 C30.658,37.251 21.979,38.517 15.863,33.96 C12.357,31.347 10.328,27.335 10.298,22.955 L10.298,22.955 Z M24,19 C21.794,19 20,20.795 20,23 C20,25.206 21.794,27 24,27 C26.206,27 28,25.206 28,23 C28,20.795 26.206,19 24,19 L24,19 Z M16.946,28.78 L19.175,26.552 C18.441,25.556 18,24.33 18,23 C18,21.622 18.473,20.353 19.257,19.339 L16.947,17.191 L18.309,15.727 L20.729,17.977 C21.671,17.362 22.793,17 24,17 C25.342,17 26.577,17.448 27.577,18.195 L29.982,15.726 L31.414,17.121 L28.965,19.636 C29.617,20.597 30,21.754 30,23 C30,24.252 29.613,25.415 28.955,26.377 L31.414,28.756 L30.024,30.194 L27.565,27.815 C26.567,28.556 25.336,29 24,29 C22.742,29 21.574,28.61 20.61,27.946 L18.361,30.194 L16.946,28.78 Z M35,44 L39,44 L39,43 L35,43 L35,44 Z M9,44 L13,44 L13,43 L9,43 L9,44 Z M46,3 L46,42 C46,42.553 45.553,43 45,43 L41,43 L41,45 C41,45.553 40.553,46 40,46 L34,46 C33.447,46 33,45.553 33,45 L33,43 L15,43 L15,45 C15,45.553 14.553,46 14,46 L8,46 C7.447,46 7,45.553 7,45 L7,43 L3,43 C2.447,43 2,42.553 2,42 L2,33 L4,33 L4,41 L44,41 L44,4 L4,4 L4,11 L2,11 L2,3 C2,2.448 2.447,2 3,2 L45,2 C45.553,2 46,2.448 46,3 L46,3 Z M2,27 L4,27 L4,17 L2,17 L2,27 Z" id="Fill-1" fill="#7AA116"></path>
    </g>
</svg>`, By = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Storage/Res_AWS-Backup_Audit-Manager_48</title>
    <g id="Icon-Resource/Storage/Res_AWS-Backup_Audit-Manager_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M44,19 C44,17.897 43.103,17 42,17 C40.897,17 40,17.897 40,19 C40,20.103 40.897,21 42,21 C43.103,21 44,20.103 44,19 L44,19 Z M39.92,22.4 C38.773,21.696 38,20.441 38,19 C38,18.487 38.106,18 38.282,17.549 L26.537,9.066 C25.845,9.641 24.968,10 24,10 C23.032,10 22.155,9.641 21.463,9.066 L9.718,17.549 C9.894,18 10,18.487 10,19 C10,20.441 9.227,21.696 8.08,22.4 L12.834,38.017 C12.89,38.014 12.943,38 13,38 C14.859,38 16.411,39.28 16.858,41 L31.142,41 C31.589,39.28 33.141,38 35,38 C35.057,38 35.11,38.014 35.166,38.017 L39.92,22.4 Z M37,42 C37,40.897 36.103,40 35,40 C33.897,40 33,40.897 33,42 C33,43.103 33.897,44 35,44 C36.103,44 37,43.103 37,42 L37,42 Z M15,42 C15,40.897 14.103,40 13,40 C11.897,40 11,40.897 11,42 C11,43.103 11.897,44 13,44 C14.103,44 15,43.103 15,42 L15,42 Z M6,21 C7.103,21 8,20.103 8,19 C8,17.897 7.103,17 6,17 C4.897,17 4,17.897 4,19 C4,20.103 4.897,21 6,21 L6,21 Z M22,6 C22,7.103 22.897,8 24,8 C25.103,8 26,7.103 26,6 C26,4.897 25.103,4 24,4 C22.897,4 22,4.897 22,6 L22,6 Z M46,19 C46,21.206 44.206,23 42,23 C41.943,23 41.89,22.986 41.833,22.983 L37.08,38.6 C38.227,39.304 39,40.559 39,42 C39,44.206 37.206,46 35,46 C33.141,46 31.589,44.72 31.142,43 L16.858,43 C16.411,44.72 14.859,46 13,46 C10.794,46 9,44.206 9,42 C9,40.559 9.773,39.304 10.92,38.6 L6.166,22.983 C6.11,22.986 6.057,23 6,23 C3.794,23 2,21.206 2,19 C2,16.794 3.794,15 6,15 C6.968,15 7.845,15.359 8.538,15.934 L20.282,7.451 C20.106,7 20,6.513 20,6 C20,3.794 21.794,2 24,2 C26.206,2 28,3.794 28,6 C28,6.513 27.894,7 27.718,7.451 L39.462,15.934 C40.155,15.359 41.032,15 42,15 C44.206,15 46,16.794 46,19 L46,19 Z M35,26 C35,32.065 30.065,37 24,37 C17.935,37 13,32.065 13,26 L15,26 L16.963,26 L18.769,23.269 C18.963,22.975 19.291,22.801 19.653,22.822 C20.006,22.84 20.324,23.043 20.488,23.356 L22.718,27.607 L25.092,21.631 C25.238,21.264 25.586,21.017 25.98,21.001 C26.371,20.988 26.742,21.202 26.917,21.556 L29.12,26 L31,26 L31,28 L28.5,28 C28.12,28 27.772,27.785 27.604,27.444 L26.122,24.455 L23.773,30.369 C23.629,30.732 23.286,30.978 22.896,30.999 C22.879,31 22.861,31 22.844,31 C22.474,31 22.132,30.795 21.958,30.464 L19.503,25.784 L18.334,27.552 C18.149,27.832 17.836,28 17.5,28 L15.232,28 C16.145,32.002 19.725,35 24,35 C28.963,35 33,30.962 33,26 C33,21.038 28.963,17 24,17 C21.426,17 19.009,18.125 17.319,20 L19,20 L19,22 L15,22 C14.447,22 14,21.552 14,21 L14,17 L16,17 L16,18.477 C18.056,16.297 20.939,15 24,15 C30.065,15 35,19.935 35,26 L35,26 Z" id="Fill-1" fill="#7AA116"></path>
    </g>
</svg>`, zy = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Storage/Res_Amazon-File-Cache_Hybrid-NFS-linked-datasets_48</title>
    <g id="Icon-Resource/Storage/Res_Amazon-File-Cache_Hybrid-NFS-linked-datasets_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M15,34 L13,34 C11.346,34 10,32.654 10,31 L8,31 C8,33.757 10.243,36 13,36 L15,36 C17.757,36 20,33.757 20,31 C20,28.243 17.757,26 15,26 L15,28 C16.654,28 18,29.346 18,31 C18,32.654 16.654,34 15,34 L15,34 Z M7,28 L9,28 C10.654,28 12,29.346 12,31 L14,31 C14,28.243 11.757,26 9,26 L7,26 C4.243,26 2,28.243 2,31 C2,33.757 4.243,36 7,36 L7,34 C5.346,34 4,32.654 4,31 C4,29.346 5.346,28 7,28 L7,28 Z M10,18 L26,18 L22.4,20.7 L23.6,22.3 L29.6,17.8 C29.852,17.611 30,17.315 30,17 C30,16.685 29.852,16.389 29.6,16.2 L23.6,11.7 L22.4,13.3 L26,16 L9,16 C8.447,16 8,16.448 8,17 L8,24 L10,24 L10,18 Z M36,44 L10,44 L10,38.09 L8,38.09 L8,45 C8,45.552 8.447,46 9,46 L37,46 C37.553,46 38,45.552 38,45 L38,34 L36,34 L36,44 Z M46,3 L46,31 C46,31.552 45.553,32 45,32 L29,32 L32.6,34.7 L31.4,36.3 L25.4,31.8 C25.148,31.611 25,31.315 25,31 C25,30.685 25.148,30.389 25.4,30.2 L31.4,25.7 L32.6,27.3 L29,30 L44,30 L44,4 L18,4 L18,14 L16,14 L16,3 C16,2.448 16.447,2 17,2 L45,2 C45.553,2 46,2.448 46,3 L46,3 Z" id="Fill-1" fill="#7AA116"></path>
    </g>
</svg>`, Uy = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Storage/Res_Amazon-Elastic-File-System_Elastic-Throughput_48</title>
    <g id="Icon-Resource/Storage/Res_Amazon-Elastic-File-System_Elastic-Throughput_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M10.104,13 L11.433,13 C11.863,13 12.273,13.185 12.557,13.507 C12.842,13.829 12.975,14.259 12.921,14.686 L12.473,18.273 L17.036,12 L15,12 C14.664,12 14.35,11.831 14.165,11.55 C13.98,11.27 13.948,10.915 14.081,10.606 L16.483,5 L10.905,5 L10.104,13 Z M8.44,14.506 C8.156,14.193 8.017,13.772 8.059,13.351 L8.959,4.351 C9.036,3.581 9.677,3 10.452,3 L17.242,3 C17.748,3 18.215,3.252 18.494,3.675 C18.772,4.097 18.819,4.627 18.62,5.091 L16.516,10 L17.036,10 C17.791,10 18.474,10.418 18.818,11.092 C19.161,11.766 19.098,12.564 18.653,13.176 L11.808,22.588 C11.616,22.853 11.312,23 11,23 C10.876,23 10.751,22.978 10.631,22.93 C10.208,22.762 9.951,22.329 10.007,21.876 L10.867,15 L9.552,15 C9.129,15 8.724,14.82 8.44,14.506 L8.44,14.506 Z M19.618,31 L23.381,31 L21.5,27.236 L19.618,31 Z M17.105,31.553 L20.605,24.553 C20.945,23.875 22.054,23.875 22.394,24.553 L25.894,31.553 C26.049,31.863 26.033,32.231 25.85,32.526 C25.667,32.82 25.346,33 25,33 L18,33 C17.653,33 17.332,32.82 17.149,32.526 C16.966,32.231 16.95,31.863 17.105,31.553 L17.105,31.553 Z M33,35 C34.102,35 35,34.103 35,33 C35,31.897 34.102,31 33,31 C31.897,31 31,31.897 31,33 C31,34.103 31.897,35 33,35 L33,35 Z M33,37 C30.793,37 29,35.206 29,33 C29,30.794 30.793,29 33,29 C35.206,29 37,30.794 37,33 C37,35.206 35.206,37 33,37 L33,37 Z M8,35 L12,35 L12,31 L8,31 L8,35 Z M6,30 C6,29.448 6.447,29 7,29 L13,29 C13.552,29 14,29.448 14,30 L14,36 C14,36.552 13.552,37 13,37 L7,37 C6.447,37 6,36.552 6,36 L6,30 Z M45,19 L43,19 L43,21 L44,21 L44,44 L9,44 L9,43 L7,43 L7,45 C7,45.552 7.447,46 8,46 L45,46 C45.552,46 46,45.552 46,45 L46,20 C46,19.448 45.552,19 45,19 L45,19 Z M40,41 L3,41 C2.447,41 2,40.552 2,40 L2,17 C2,15.346 3.345,14 5,14 L6,14 L6,16 L5,16 C4.448,16 4,16.449 4,17 L4,39 L39,39 L39,17 C39,16.449 38.551,16 38,16 L34,16 C33.541,16 33.141,15.688 33.03,15.243 L32.219,12 L25.781,12 L24.969,15.243 C24.858,15.688 24.458,16 24,16 L21,16 L21,14 L23.218,14 L23.84,11.515 C24.063,10.623 24.861,10 25.781,10 L32.218,10 C33.138,10 33.936,10.623 34.159,11.515 L34.781,14 L38,14 C39.654,14 41,15.346 41,17 L41,40 C41,40.552 40.552,41 40,41 L40,41 Z" id="Fill-1" fill="#7AA116"></path>
    </g>
</svg>`, Wy = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Storage/Res_AWS-Backup_AWS-Backup-support-for-Amazon-S3_48</title>
    <g id="Icon-Resource/Storage/Res_AWS-Backup_AWS-Backup-support-for-Amazon-S3_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M39.5230246,40.8829 C39.5170246,40.9259 39.5150246,40.9589 39.5150246,41.0029 C39.4880246,41.1189 39.1210246,41.5609 37.8450246,42.0599 C37.2100246,42.3069 36.4590246,42.5309 35.6110246,42.7239 C33.4170246,43.2259 30.7240246,43.5019 28.0290246,43.5019 C20.8510246,43.5019 16.7250246,41.7499 16.5450246,41.0139 C16.5450246,40.9679 16.5430246,40.9219 16.5360246,40.8759 L15.4330246,32.9969 C16.1480246,33.0979 16.8720246,33.1539 17.6010246,33.1539 C19.0610246,33.1539 20.5400246,32.9399 21.9970246,32.5079 L20.2840246,35.7629 L22.0530246,36.6949 L24.8450246,31.3899 C25.1030246,30.9009 24.9150246,30.2969 24.4260246,30.0389 L19.1220246,27.2469 L18.1900246,29.0169 L21.2730246,30.6389 C19.2250246,31.2199 17.1350246,31.2819 15.1420246,30.9139 L13.0880246,16.2369 C16.4150246,17.9139 22.6230246,18.5679 28.1900246,18.5679 C33.5590246,18.5679 39.5420246,17.9199 42.7800246,16.2639 L39.5230246,40.8829 Z M45.1710246,13.4349 L45.1610246,13.4339 C45.1630246,13.3889 45.1800246,13.3489 45.1800246,13.3039 C45.1800246,9.5649 37.0570246,8.2219 34.5670246,7.8999 L34.3110246,9.8829 C40.8690246,10.7319 43.1230246,12.5469 43.1750246,13.2769 L43.1620246,13.3739 C42.9760246,14.5559 37.9820246,16.5679 28.1900246,16.5679 C18.1970246,16.5679 12.8900246,14.5269 12.6870246,13.3739 L12.6730246,13.2769 C12.7350246,12.4439 15.7980246,10.5419 22.7980246,9.7889 L22.5840246,7.7999 C16.8230246,8.4209 10.6680246,10.1919 10.6680246,13.3039 C10.6680246,13.3519 10.6860246,13.3939 10.6890246,13.4409 L10.6770246,13.4429 L13.0440246,30.3539 C9.45802457,29.0769 6.41902457,26.3219 4.93302457,22.5059 C2.21802457,15.5309 5.68302457,7.6479 12.6580246,4.9329 C16.0380246,3.6169 19.7240246,3.6959 23.0440246,5.1549 C26.3620246,6.6129 28.9150246,9.2779 30.2280246,12.6509 L30.3060246,12.8559 L32.1750246,12.1449 L32.0930246,11.9299 C30.5850246,8.0539 27.6560246,4.9979 23.8480246,3.3239 C20.0390246,1.6499 15.8070246,1.5609 11.9310246,3.0699 C8.05502457,4.5779 4.99902457,7.5069 3.32502457,11.3149 C1.65102457,15.1229 1.56002457,19.3549 3.07002457,23.2309 C4.90902457,27.9539 8.81602457,31.2649 13.3520246,32.5529 L14.5470246,41.0959 C14.6790246,44.3269 22.6540246,45.5019 28.0290246,45.5019 C30.8700246,45.5019 33.7210246,45.2079 36.0550246,44.6739 C37.0000246,44.4589 37.8460246,44.2059 38.5730246,43.9229 C40.4820246,43.1759 41.4700246,42.2239 41.5130246,41.0909 L45.1710246,13.4349 Z" id="Fill-1" fill="#7AA116"></path>
    </g>
</svg>`, Hy = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Storage/Res_Amazon-Simple-Storage-Service_S3-Standard_48</title>
    <g id="Icon-Resource/Storage/Res_Amazon-Simple-Storage-Service_S3-Standard_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M40.542,26.158 L40.764,24.513 C42.502,25.572 43.074,26.207 43.251,26.481 C42.958,26.538 42.217,26.566 40.542,26.158 L40.542,26.158 Z M36.547,40.836 C36.541,40.881 36.538,40.925 36.538,40.97 C36.538,41.124 36.158,41.714 34.472,42.381 C33.722,42.677 32.833,42.943 31.831,43.175 C29.249,43.771 26.082,44.1 22.914,44.1 C14.439,44.1 9.293,41.926 9.293,40.97 C9.293,40.925 9.29,40.881 9.284,40.836 L5.441,12.293 C5.689,12.437 5.956,12.576 6.235,12.711 C6.311,12.747 6.393,12.781 6.47,12.816 C6.715,12.929 6.97,13.039 7.235,13.145 C7.344,13.188 7.453,13.23 7.564,13.273 C7.848,13.379 8.141,13.482 8.443,13.581 C8.522,13.606 8.598,13.635 8.68,13.66 C9.062,13.78 9.459,13.894 9.869,14.004 C9.975,14.031 10.085,14.057 10.192,14.085 C10.514,14.166 10.84,14.245 11.174,14.319 C11.309,14.349 11.442,14.379 11.578,14.407 C11.953,14.486 12.334,14.561 12.723,14.632 C12.797,14.645 12.87,14.661 12.945,14.674 C13.407,14.756 13.879,14.83 14.356,14.898 C14.487,14.918 14.62,14.934 14.752,14.953 C15.119,15.003 15.488,15.05 15.862,15.094 C16.01,15.11 16.155,15.127 16.303,15.143 C16.753,15.191 17.205,15.235 17.662,15.274 C17.713,15.278 17.762,15.283 17.813,15.288 C18.318,15.329 18.827,15.362 19.338,15.391 C19.48,15.399 19.623,15.405 19.766,15.413 C20.152,15.431 20.54,15.447 20.928,15.46 C21.078,15.465 21.227,15.47 21.376,15.473 C21.89,15.486 22.402,15.494 22.914,15.494 C23.426,15.494 23.939,15.486 24.453,15.473 C24.602,15.47 24.751,15.465 24.9,15.46 C25.289,15.447 25.676,15.431 26.063,15.413 C26.206,15.405 26.348,15.399 26.49,15.391 C27.001,15.362 27.511,15.329 28.017,15.288 C28.065,15.284 28.113,15.278 28.162,15.274 C28.621,15.236 29.076,15.191 29.527,15.142 C29.674,15.127 29.818,15.11 29.964,15.094 C30.341,15.05 30.713,15.003 31.082,14.952 C31.212,14.934 31.342,14.918 31.471,14.899 C31.95,14.83 32.424,14.755 32.888,14.674 C32.957,14.661 33.023,14.647 33.093,14.635 C33.488,14.563 33.877,14.486 34.258,14.406 C34.389,14.379 34.519,14.349 34.648,14.321 C34.99,14.245 35.324,14.165 35.651,14.082 C35.752,14.055 35.855,14.031 35.955,14.005 C36.369,13.895 36.771,13.78 37.157,13.658 C37.23,13.635 37.298,13.61 37.369,13.587 C37.682,13.485 37.984,13.38 38.275,13.269 C38.381,13.23 38.484,13.189 38.588,13.148 C38.861,13.039 39.125,12.927 39.378,12.809 C39.447,12.777 39.522,12.746 39.591,12.713 C39.872,12.578 40.141,12.438 40.391,12.293 L38.598,25.607 C34.027,24.172 27.931,21.395 25.164,20.095 C25.161,18.995 24.266,18.1 23.165,18.1 C22.063,18.1 21.165,18.998 21.165,20.1 C21.165,21.203 22.063,22.1 23.165,22.1 C23.525,22.1 23.859,21.997 24.152,21.829 C27.312,23.32 33.604,26.178 38.327,27.617 L36.547,40.836 Z M22.914,4 C33.344,4 40.692,7.231 40.83,9.026 L40.803,9.235 C40.785,9.295 40.746,9.357 40.715,9.42 C40.687,9.472 40.667,9.525 40.629,9.579 C40.584,9.641 40.521,9.705 40.463,9.767 C40.412,9.822 40.369,9.877 40.309,9.932 C40.238,9.996 40.148,10.061 40.064,10.126 C39.992,10.181 39.928,10.236 39.846,10.293 C39.748,10.358 39.632,10.424 39.521,10.49 C39.43,10.545 39.346,10.599 39.244,10.654 C39.119,10.721 38.975,10.789 38.836,10.856 C38.729,10.908 38.628,10.962 38.511,11.013 C38.357,11.082 38.186,11.149 38.02,11.217 C37.895,11.266 37.779,11.317 37.646,11.367 C37.468,11.433 37.27,11.499 37.078,11.564 C36.938,11.612 36.805,11.661 36.658,11.709 C36.453,11.773 36.23,11.836 36.014,11.898 C35.858,11.943 35.711,11.99 35.549,12.033 C35.322,12.095 35.076,12.153 34.835,12.212 C34.664,12.254 34.502,12.298 34.324,12.338 C34.069,12.396 33.797,12.45 33.529,12.505 C33.349,12.542 33.177,12.581 32.99,12.616 C32.706,12.671 32.403,12.72 32.105,12.769 C31.919,12.802 31.741,12.836 31.55,12.865 C31.244,12.913 30.921,12.954 30.603,12.997 C30.402,13.024 30.211,13.054 30.006,13.079 C29.673,13.12 29.323,13.154 28.978,13.189 C28.773,13.21 28.576,13.234 28.367,13.254 C28.021,13.285 27.658,13.308 27.301,13.334 C27.076,13.35 26.861,13.371 26.633,13.385 C26.252,13.407 25.856,13.421 25.465,13.436 C25.246,13.445 25.036,13.459 24.814,13.466 C24.194,13.484 23.561,13.494 22.914,13.494 C22.268,13.494 21.634,13.484 21.014,13.466 C20.793,13.459 20.584,13.445 20.366,13.437 C19.974,13.421 19.577,13.407 19.196,13.385 C18.971,13.371 18.758,13.35 18.536,13.335 C18.176,13.308 17.811,13.285 17.462,13.254 C17.258,13.235 17.066,13.211 16.866,13.19 C16.516,13.154 16.161,13.121 15.823,13.079 C15.625,13.054 15.438,13.025 15.244,13 C14.92,12.956 14.591,12.914 14.279,12.865 C14.096,12.837 13.925,12.804 13.746,12.773 C13.439,12.722 13.13,12.672 12.838,12.616 C12.662,12.583 12.501,12.546 12.331,12.512 C12.053,12.454 11.77,12.398 11.504,12.338 C11.338,12.3 11.187,12.259 11.025,12.22 C10.773,12.158 10.518,12.097 10.279,12.033 C10.127,11.992 9.99,11.948 9.846,11.906 C9.617,11.841 9.385,11.775 9.171,11.708 C9.033,11.664 8.911,11.618 8.779,11.574 C8.577,11.505 8.369,11.436 8.182,11.366 C8.059,11.32 7.952,11.272 7.836,11.225 C7.66,11.155 7.479,11.085 7.318,11.013 C7.209,10.964 7.115,10.914 7.014,10.865 C6.867,10.795 6.716,10.724 6.585,10.653 C6.49,10.601 6.412,10.551 6.325,10.499 C6.209,10.429 6.086,10.36 5.984,10.291 C5.906,10.238 5.846,10.185 5.776,10.133 C5.689,10.065 5.596,9.998 5.522,9.931 C5.463,9.878 5.422,9.825 5.373,9.771 C5.313,9.707 5.248,9.642 5.203,9.579 C5.165,9.525 5.146,9.473 5.119,9.421 C5.086,9.358 5.047,9.296 5.029,9.235 L5.002,9.026 C5.141,7.231 12.487,4 22.914,4 L22.914,4 Z M45.297,26.277 C45.081,25.123 43.754,23.904 41.053,22.367 L42.771,9.6 L42.771,9.599 L42.771,9.598 L42.823,9.209 C42.829,9.165 42.832,9.121 42.832,9.077 C42.832,4.906 32.335,2 22.914,2 C13.495,2 3,4.906 3,9.077 C3,9.121 3.003,9.165 3.009,9.209 L3.061,9.598 L3.061,9.599 L3.061,9.6 L7.294,41.047 C7.425,44.726 16.916,46.1 22.914,46.1 C26.229,46.1 29.556,45.754 32.281,45.124 C33.38,44.87 34.363,44.573 35.206,44.241 C37.373,43.384 38.493,42.308 38.537,41.047 L40.273,28.151 C41.298,28.392 42.14,28.514 42.826,28.514 C43.817,28.514 44.484,28.262 44.909,27.755 C45.26,27.338 45.397,26.813 45.297,26.277 L45.297,26.277 Z" id="Amazon-Simple-Storage_Service-Standard_Resource-Icon_light-bg" fill="#7AA116"></path>
    </g>
</svg>`, $y = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Storage/Res_Amazon-Elastic-File-System_One-Zone_48</title>
    <g id="Icon-Resource/Storage/Res_Amazon-Elastic-File-System_One-Zone_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M40,9 C40,8.449 39.552,8 39,8 C38.448,8 38,8.449 38,9 C38,9.551 38.448,10 39,10 C39.552,10 40,9.551 40,9 L40,9 Z M42,9 C42,10.654 40.654,12 39,12 C37.346,12 36,10.654 36,9 C36,7.346 37.346,6 39,6 C40.654,6 42,7.346 42,9 L42,9 Z M43.992,8.833 C44.061,7.55 43.659,6.411 42.833,5.54 C41.904,4.561 40.508,4 39,4 C37.581,4 36.215,4.58 35.251,5.592 C34.39,6.496 33.947,7.648 34.005,8.837 C34.121,11.234 37.104,15.242 38.933,17.405 C39.405,16.769 40.074,15.875 40.854,14.861 L41.35,14.2 C42.047,13.247 42.624,12.349 43.057,11.539 L43.354,10.95 C43.744,10.126 43.962,9.406 43.992,8.833 L43.992,8.833 Z M45.99,8.938 C45.945,9.785 45.671,10.73 45.151,11.828 L44.837,12.45 C44.834,12.457 44.83,12.464 44.826,12.471 C44.349,13.367 43.72,14.349 42.956,15.391 L42.446,16.07 C40.913,18.066 39.813,19.583 39.81,19.587 C39.633,19.83 39.356,19.981 39.058,19.999 C39.038,20 39.019,20 39,20 C38.721,20 38.453,19.883 38.263,19.676 C37.644,19 32.202,12.958 32.007,8.934 C31.923,7.193 32.561,5.517 33.803,4.212 C35.143,2.807 37.037,2 39,2 C41.054,2 42.979,2.789 44.283,4.163 C45.497,5.442 46.087,7.094 45.99,8.938 L45.99,8.938 Z M14.885,18 C14.885,17.488 15.273,15.695 15.575,15 L21.854,15 C22.103,15.71 22.346,17.408 22.346,18 C22.346,18.552 22.793,19 23.346,19 L25,19 L25,17 L24.285,17 C24.155,15.614 23.755,13.252 22.524,13.018 C22.463,13.006 22.399,13 22.337,13 L15.158,13 C13.779,13 13.209,15.541 12.997,17 L12,17 L12,19 L13.885,19 C14.438,19 14.885,18.552 14.885,18 L14.885,18 Z M31,19 L35,19 L35,17 L31,17 L31,19 Z M42.592,19.592 C42.858,19.956 43,20.511 43,21.199 L43,44 L4,44 L4,21.199 C4,19.555 4.544,19 6.154,19 L6.154,17 C3.437,17 2,18.452 2,21.199 L2,45 C2,45.552 2.447,46 3,46 L44,46 C44.553,46 45,45.552 45,45 L45,21.199 C45,20.066 44.731,19.127 44.203,18.408 L42.592,19.592 Z M33,37.5 C33,38.878 34.121,40 35.5,40 C36.879,40 38,38.878 38,37.5 C38,36.122 36.879,35 35.5,35 C34.121,35 33,36.122 33,37.5 L33,37.5 Z M35.5,33 C37.981,33 40,35.019 40,37.5 C40,39.981 37.981,42 35.5,42 C33.019,42 31,39.981 31,37.5 C31,35.019 33.019,33 35.5,33 L35.5,33 Z M25.342,36 L23.476,32.463 L21.645,36 L25.342,36 Z M24.353,29.838 L27.885,36.533 C28.048,36.843 28.037,37.216 27.856,37.517 C27.676,37.816 27.351,38 27,38 L20,38 C19.651,38 19.327,37.818 19.146,37.52 C18.964,37.221 18.951,36.85 19.112,36.54 L22.58,29.845 C22.751,29.514 23.092,29.306 23.464,29.305 L23.468,29.305 C23.839,29.305 24.179,29.51 24.353,29.838 L24.353,29.838 Z M10,40 L14,40 L14,36 L10,36 L10,40 Z M15,34 C15.553,34 16,34.448 16,35 L16,41 C16,41.552 15.553,42 15,42 L9,42 C8.447,42 8,41.552 8,41 L8,35 C8,34.448 8.447,34 9,34 L15,34 Z M24.293,22.707 L27.293,25.707 C27.488,25.902 27.744,26 28,26 C28.256,26 28.512,25.902 28.707,25.707 L31.707,22.707 L30.293,21.293 L29,22.586 L29,13 L27,13 L27,22.586 L25.707,21.293 L24.293,22.707 Z M18,5.415 L18,11 L20,11 L20,5.414 L21.293,6.707 L22.707,5.293 L19.708,2.293 C19.521,2.105 19.267,2 19.001,2 C18.735,2 18.481,2.105 18.294,2.293 L15.293,5.293 L16.707,6.707 L18,5.415 Z M6.707,22.293 L8,23.586 L8,16 L10,16 L10,23.586 L11.293,22.293 L12.707,23.707 L9.707,26.707 C9.512,26.902 9.256,27 9,27 C8.744,27 8.488,26.902 8.293,26.707 L5.293,23.707 L6.707,22.293 Z" id="Fill-1" fill="#7AA116"></path>
    </g>
</svg>`, Vy = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Storage/Res_AWS-Storage-Gateway_Volume-Gateway_48</title>
    <g id="Icon-Resource/Storage/Res_AWS-Storage-Gateway_Volume-Gateway_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M20.523,4 C14.936,4 11.487,5.618 8,7.632 L8,44.923 L6,44.923 L6,7.057 C6,6.701 6.188,6.373 6.494,6.193 C10.267,3.983 14.178,2 20.523,2 C26.418,2 30.734,4.225 34.203,6.013 L34.504,6.167 C34.837,6.339 35.046,6.682 35.046,7.057 L35.046,15.605 L33.046,15.605 L33.046,7.666 C29.658,5.921 25.807,4 20.523,4 L20.523,4 Z M30.951,24.485 C24.544,24.485 21.239,22.713 21.239,21.957 C21.239,21.201 24.544,19.43 30.951,19.43 C37.358,19.43 40.663,21.201 40.663,21.957 C40.663,22.713 37.358,24.485 30.951,24.485 L30.951,24.485 Z M40.663,25.417 C40.663,26.173 37.358,27.944 30.951,27.944 C24.544,27.944 21.239,26.173 21.239,25.417 L21.239,24.64 C23.49,25.896 27.31,26.485 30.951,26.485 C34.591,26.485 38.412,25.896 40.663,24.64 L40.663,25.417 Z M40.663,37.727 C40.663,38.482 37.358,40.254 30.951,40.254 C24.544,40.254 21.239,38.482 21.239,37.727 L21.239,28.1 C23.49,29.354 27.31,29.944 30.951,29.944 C34.591,29.944 38.412,29.354 40.663,28.1 L40.663,37.727 Z M40.663,41.396 C40.663,42.151 37.358,43.923 30.951,43.923 C24.544,43.923 21.239,42.151 21.239,41.396 L21.239,40.409 C23.49,41.664 27.31,42.254 30.951,42.254 C34.591,42.254 38.412,41.664 40.663,40.409 L40.663,41.396 Z M30.951,17.43 C25.31,17.43 19.239,18.847 19.239,21.957 L19.239,41.396 C19.239,44.506 25.31,45.923 30.951,45.923 C36.591,45.923 42.663,44.506 42.663,41.396 L42.663,21.957 C42.663,18.847 36.591,17.43 30.951,17.43 L30.951,17.43 Z" id="AWS-Storage-Gateway_Volume-Gateway_Resource-Icon_light-bg" fill="#7AA116"></path>
    </g>
</svg>`, Gy = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Storage/Res_AWS-Backup_Backup-Restore_48</title>
    <g id="Icon-Resource/Storage/Res_AWS-Backup_Backup-Restore_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M15.969,30.995794 L13.969,30.995794 L13.969,33.995794 C13.969,34.547794 14.416,34.995794 14.969,34.995794 L25.969,34.995794 L25.969,32.995794 L15.969,32.995794 L15.969,30.995794 Z M37.969,33.234794 L37.969,32.473794 C36.463,32.940794 34.585,33.012794 33.587,33.012794 C32.558,33.012794 30.519,32.925794 28.969,32.382794 L28.97,33.261794 C29.01,33.347794 29.508,33.827794 31.137,34.104794 C31.527,34.170794 31.943,34.219794 32.377,34.250794 C32.554,34.264794 32.733,34.273794 32.913,34.279794 C33.279,34.292794 33.657,34.292794 34.021,34.279794 C34.202,34.273794 34.38,34.264794 34.556,34.250794 C34.992,34.219794 35.407,34.170794 35.798,34.104794 C37.427,33.827794 37.925,33.347794 37.969,33.234794 L37.969,33.234794 Z M33.451,22.451794 C31.033,22.451794 29.694,22.968794 29.183,23.318794 C29.88,23.713794 31.441,24.093794 33.572,24.093794 C35.721,24.093794 37.158,23.718794 37.848,23.374794 C37.467,23.072794 36.094,22.451794 33.451,22.451794 L33.451,22.451794 Z M28.97,30.183794 C29.327,30.477794 30.804,31.011794 33.59,31.011794 C35.969,31.011794 37.377,30.630794 37.969,30.334794 L37.968,28.986794 C36.372,29.494794 34.383,29.553794 33.59,29.553794 C32.775,29.553794 30.607,29.490794 28.969,28.905794 L28.97,30.183794 Z M28.969,25.396794 L28.97,26.683794 C29.317,26.988794 30.795,27.552794 33.592,27.552794 C35.991,27.552794 37.388,27.137794 37.969,26.839794 L37.968,25.491794 C36.825,25.877794 35.307,26.094794 33.592,26.094794 C31.758,26.094794 30.14,25.839794 28.969,25.396794 L28.969,25.396794 Z M39.969,23.480794 L39.969,27.687794 L39.974,27.690794 C39.973,27.693794 39.97,27.695794 39.969,27.697794 L39.969,31.196794 L39.971,31.197794 C39.97,31.198794 39.97,31.199794 39.969,31.200794 L39.969,33.260794 C39.969,34.068794 39.471,35.509794 36.135,36.076794 C35.679,36.153794 35.197,36.210794 34.701,36.246794 C34.503,36.260794 34.3,36.271794 34.093,36.279794 C33.888,36.286794 33.68,36.290794 33.469,36.290794 C33.258,36.290794 33.05,36.286794 32.844,36.279794 C32.638,36.271794 32.434,36.260794 32.235,36.246794 C31.74,36.210794 31.258,36.153794 30.803,36.076794 C27.467,35.509794 26.969,34.069794 26.969,33.260794 L26.969,23.480794 C26.969,21.388794 30.234,20.451794 33.469,20.451794 C36.704,20.451794 39.969,21.388794 39.969,23.480794 L39.969,23.480794 Z M32.969,14.995794 L21.969,14.995794 L21.969,16.995794 L31.969,16.995794 L31.969,18.995794 L33.969,18.995794 L33.969,15.995794 C33.969,15.443794 33.522,14.995794 32.969,14.995794 L32.969,14.995794 Z M18.969,27.075794 L18.969,26.274794 C17.445,26.775794 15.494,26.853794 14.47,26.853794 C13.466,26.853794 11.503,26.769794 9.969,26.263794 L9.97,27.102794 C10.01,27.188794 10.508,27.668794 12.137,27.945794 C12.527,28.011794 12.943,28.061794 13.377,28.092794 C13.554,28.105794 13.733,28.114794 13.913,28.120794 C14.279,28.133794 14.657,28.133794 15.021,28.120794 C15.202,28.114794 15.38,28.105794 15.556,28.092794 C15.992,28.061794 16.407,28.011794 16.798,27.945794 C18.427,27.668794 18.925,27.188794 18.969,27.075794 L18.969,27.075794 Z M14.451,16.292794 C11.946,16.292794 10.594,16.848794 10.129,17.197794 C10.858,17.578794 12.391,17.934794 14.454,17.934794 C16.673,17.934794 18.138,17.535794 18.798,17.182794 C18.366,16.870794 17.007,16.292794 14.451,16.292794 L14.451,16.292794 Z M18.968,19.287794 C17.812,19.701794 16.252,19.935794 14.475,19.935794 C12.7,19.935794 11.13,19.696794 9.969,19.280794 L9.97,20.613794 C10.478,20.927794 11.937,21.392794 14.475,21.392794 C17.052,21.392794 18.475,20.914794 18.969,20.616794 L18.968,19.287794 Z M9.97,24.107794 C10.482,24.408794 11.937,24.852794 14.473,24.852794 C17.02,24.852794 18.46,24.415794 18.969,24.114794 L18.968,22.788794 C17.354,23.332794 15.285,23.394794 14.473,23.394794 C13.677,23.394794 11.591,23.336794 9.969,22.789794 L9.97,24.107794 Z M20.969,17.322794 L20.969,27.101794 C20.969,27.910794 20.471,29.350794 17.135,29.916794 C16.676,29.995794 16.194,30.052794 15.701,30.087794 C15.503,30.101794 15.3,30.113794 15.093,30.120794 C14.888,30.127794 14.68,30.131794 14.469,30.131794 C14.258,30.131794 14.05,30.127794 13.844,30.120794 C13.638,30.113794 13.434,30.101794 13.235,30.087794 C12.743,30.052794 12.262,29.995794 11.803,29.916794 C8.467,29.351794 7.969,27.910794 7.969,27.101794 L7.969,17.322794 C7.969,15.229794 11.234,14.292794 14.469,14.292794 C17.704,14.292794 20.969,15.229794 20.969,17.322794 L20.969,17.322794 Z M37.68,41.020794 C36.37,42.089794 34.92,42.988794 33.378,43.683794 C30.297,45.071794 27.084,45.740794 23.94,45.740794 C19.24,45.740794 14.684,44.245794 10.848,41.400794 C5.274,37.266794 2.048,30.922794 2,23.995794 L4.114,23.981794 C4.157,30.270794 7.071,36.029794 12.105,39.782794 C16.358,42.951794 21.589,44.271794 26.837,43.509794 C33.404,42.552794 39.011,38.465794 41.989,32.249794 C43.063,30.006794 43.684,27.553794 43.808,25.069794 C44.152,18.179794 41.161,11.911794 35.837,7.94179404 C27.779,1.93579404 16.626,2.99379404 9.787,9.99579404 L11.969,9.99579404 L11.969,11.995794 L7.974,11.995794 C7.97,12.000794 7.966,12.004794 7.962,12.009794 L7.944,11.995794 L6.969,11.995794 C6.416,11.995794 5.969,11.547794 5.969,10.995794 L5.969,5.99579404 L7.969,5.99579404 L7.969,8.89179404 C16.6,-0.261205957 31.822,-0.611205957 40.798,9.73479404 C42.464,11.655794 43.772,13.880794 44.63,16.274794 C47.855,25.270794 45.189,34.893794 37.68,41.020794 L37.68,41.020794 Z" id="Fill-1" fill="#7AA116"></path>
    </g>
</svg>`, jy = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Storage/Res_Amazon-Elastic-Block-Store_Multiple-Volumes_48</title>
    <g id="Icon-Resource/Storage/Res_Amazon-Elastic-Block-Store_Multiple-Volumes_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M7.917,7 L2,14.836 L30.607,14.699 L25.475,7 L7.917,7 Z M8.912,9.001 L24.405,9.001 L26.883,12.716 L6.032,12.817 L8.912,9.001 Z M29.17,9.736 L29.17,11.736 L33.143,11.736 L35.198,14.456 L31.596,14.441 L31.589,16.441 L39.227,16.473 L34.139,9.736 L29.17,9.736 Z M38.275,12.515 L38.275,14.515 L41.222,14.515 L42.458,16.151 L40.146,16.141 L40.139,18.141 L46.487,18.166 L46.487,18.165 L42.219,12.515 L38.275,12.515 Z M2.379,41.101 L30.281,41.101 L30.281,15.6 L2.379,15.6 L2.379,41.101 Z M4.38,39.101 L28.281,39.101 L28.281,17.6 L4.38,17.6 L4.38,39.101 Z M31.646,17.213 L31.646,19.213 L36.918,19.213 L36.918,36.709 L31.646,36.709 L31.646,38.71 L38.918,38.71 L38.918,17.213 L31.646,17.213 Z M40.235,18.948 L40.235,20.949 L44.197,20.949 L44.197,34.375 L40.235,34.375 L40.235,36.375 L46.197,36.375 L46.197,18.948 L40.235,18.948 Z" id="AWS-Amazon-Elastic-Block-Store_Multiple-Volumes_Resource-Icon_light-bg" fill="#7AA116"></path>
    </g>
</svg>`, qy = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Storage/Res_Amazon-Simple-Storage-Service_S3-Storage-Lens_48</title>
    <g id="Icon-Resource/Storage/Res_Amazon-Simple-Storage-Service_S3-Storage-Lens_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M10.604,25.036 L10.604,23.036 C13.781,23.036 16.365,25.62 16.365,28.797 L14.365,28.797 C14.365,26.723 12.677,25.036 10.604,25.036 M40.813,26.016 L41.097,24.266 C43.145,25.466 43.771,26.158 43.956,26.453 C43.641,26.513 42.789,26.537 40.813,26.016 M23.641,13.481 C13.299,13.481 6.293,11.012 5.779,9.228 L5.75,9.019 C5.889,7.227 13.227,4 23.641,4 C34.056,4 41.395,7.227 41.534,9.019 L41.505,9.228 C40.991,11.012 33.984,13.481 23.641,13.481 M17,28.5 C17,32.084 14.083,35 10.5,35 C6.916,35 4,32.084 4,28.5 C4,24.916 6.916,22 10.5,22 C14.083,22 17,24.916 17,28.5 M45.999,26.249 C45.774,25.051 44.36,23.785 41.438,22.16 L43.471,9.619 C43.473,9.61 43.469,9.6 43.47,9.591 L43.475,9.591 L43.527,9.203 C43.533,9.159 43.536,9.115 43.536,9.071 C43.536,4.904 33.051,2 23.641,2 C14.232,2 3.749,4.904 3.749,9.071 C3.749,9.115 3.751,9.159 3.757,9.203 L3.809,9.591 L3.82,9.59 C3.823,9.612 3.815,9.634 3.82,9.656 L6.142,21.216 C3.666,22.703 2,25.407 2,28.5 C2,33.187 5.813,37 10.5,37 C11.498,37 12.453,36.818 13.343,36.5 L18.108,45.665 L19.883,44.743 L15.138,35.614 C17.459,34.095 19,31.476 19,28.5 C19,23.813 15.186,20 10.5,20 C9.634,20 8.8,20.132 8.013,20.373 L6.414,12.411 C10.094,14.435 17.034,15.481 23.641,15.481 C30.33,15.481 37.359,14.41 41.004,12.336 L38.88,25.441 C34.419,23.991 28.708,21.397 25.988,20.12 C25.99,20.079 26,20.041 26,20 C26,18.897 25.102,18 24,18 C22.897,18 22,18.897 22,20 C22,21.103 22.897,22 24,22 C24.308,22 24.597,21.924 24.858,21.799 C27.901,23.236 33.885,25.956 38.556,27.439 L36.35,41.046 C35.918,41.636 32.515,44.051 23.641,44.051 L23.641,46.051 C32.912,46.051 38.122,43.317 38.327,41.355 L40.492,27.997 C41.731,28.316 42.74,28.485 43.528,28.485 C44.518,28.485 45.186,28.233 45.611,27.726 C45.96,27.309 46.098,26.785 45.999,26.249" id="Fill-1" fill="#7AA116"></path>
    </g>
</svg>`, Ky = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Storage/Res_AWS-Backup_Compute_48</title>
    <g id="Icon-Resource/Storage/Res_AWS-Backup_Compute_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M42,21 C40.897,21 40,20.103 40,19 C40,17.897 40.897,17 42,17 C43.103,17 44,17.897 44,19 C44,20.103 43.103,21 42,21 L42,21 Z M34.296,37.03 C34.196,37.022 34.101,37 34,37 C32.141,37 30.589,38.28 30.142,40 L17.858,40 C17.411,38.28 15.859,37 14,37 C13.899,37 13.804,37.022 13.704,37.03 L8.195,22.338 C9.28,21.622 10,20.395 10,19 C10,18.511 9.899,18.047 9.738,17.613 L21.812,9.341 C22.442,9.755 23.192,10 24,10 C24.808,10 25.558,9.755 26.188,9.341 L38.262,17.613 C38.101,18.047 38,18.511 38,19 C38,20.395 38.72,21.622 39.805,22.338 L34.296,37.03 Z M34,43 C32.897,43 32,42.103 32,41 C32,39.897 32.897,39 34,39 C35.103,39 36,39.897 36,41 C36,42.103 35.103,43 34,43 L34,43 Z M14,43 C12.897,43 12,42.103 12,41 C12,39.897 12.897,39 14,39 C15.103,39 16,39.897 16,41 C16,42.103 15.103,43 14,43 L14,43 Z M4,19 C4,17.897 4.897,17 6,17 C7.103,17 8,17.897 8,19 C8,20.103 7.103,21 6,21 C4.897,21 4,20.103 4,19 L4,19 Z M24,4 C25.103,4 26,4.897 26,6 C26,7.103 25.103,8 24,8 C22.897,8 22,7.103 22,6 C22,4.897 22.897,4 24,4 L24,4 Z M42,15 C41.008,15 40.111,15.376 39.412,15.976 L27.532,7.837 C27.821,7.284 28,6.666 28,6 C28,3.794 26.206,2 24,2 C21.794,2 20,3.794 20,6 C20,6.666 20.179,7.284 20.468,7.837 L8.588,15.976 C7.889,15.376 6.992,15 6,15 C3.794,15 2,16.794 2,19 C2,21.206 3.794,23 6,23 C6.101,23 6.196,22.978 6.296,22.97 L11.805,37.662 C10.72,38.378 10,39.605 10,41 C10,43.206 11.794,45 14,45 C15.859,45 17.411,43.72 17.858,42 L30.142,42 C30.589,43.72 32.141,45 34,45 C36.206,45 38,43.206 38,41 C38,39.605 37.28,38.378 36.195,37.662 L41.704,22.97 C41.804,22.978 41.899,23 42,23 C44.206,23 46,21.206 46,19 C46,16.794 44.206,15 42,15 L42,15 Z M29,29.525 C29,29.787 28.787,30 28.525,30 L19.475,30 C19.213,30 19,29.787 19,29.525 L19,20.475 C19,20.213 19.213,20 19.475,20 L28.525,20 C28.787,20 29,20.213 29,20.475 L29,29.525 Z M29,18.048 L29,15 L27,15 L27,18 L25,18 L25,15 L23,15 L23,18 L21,18 L21,15 L19,15 L19,18.048 C18.016,18.24 17.24,19.016 17.048,20 L14,20 L14,22 L17,22 L17,24 L14,24 L14,26 L17,26 L17,28 L14,28 L14,30 L17.048,30 C17.24,30.984 18.016,31.76 19,31.952 L19,35 L21,35 L21,32 L23,32 L23,35 L25,35 L25,32 L27,32 L27,35 L29,35 L29,31.952 C29.984,31.76 30.76,30.984 30.952,30 L34,30 L34,28 L31,28 L31,26 L34,26 L34,24 L31,24 L31,22 L34,22 L34,20 L30.952,20 C30.76,19.016 29.984,18.24 29,18.048 L29,18.048 Z" id="Fill-1" fill="#7AA116"></path>
    </g>
</svg>`, Yy = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Storage/Res_Amazon-Simple-Storage-Service_VPC-Access-Points_48</title>
    <g id="Icon-Resource/Storage/Res_Amazon-Simple-Storage-Service_VPC-Access-Points_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M32.2275,25.4649 C32.2275,24.0949 31.1125,22.9799 29.7425,22.9799 C28.3725,22.9799 27.2565,24.0949 27.2565,25.4649 C27.2565,26.8349 28.3725,27.9489 29.7425,27.9489 C31.1125,27.9489 32.2275,26.8349 32.2275,25.4649 L32.2275,25.4649 Z M34.2275,25.4649 C34.2275,27.9379 32.2155,29.9489 29.7425,29.9489 C27.2685,29.9489 25.2565,27.9379 25.2565,25.4649 C25.2565,22.9909 27.2685,20.9799 29.7425,20.9799 C32.2155,20.9799 34.2275,22.9909 34.2275,25.4649 L34.2275,25.4649 Z M30.4535,15.9029 L28.2895,11.9459 L26.0325,15.9029 L30.4535,15.9029 Z M33.0165,16.4239 C33.1865,16.7339 33.1795,17.1099 32.9995,17.4129 C32.8195,17.7169 32.4935,17.9029 32.1395,17.9029 L24.3105,17.9029 C23.9545,17.9029 23.6245,17.7139 23.4465,17.4049 C23.2665,17.0979 23.2655,16.7179 23.4425,16.4079 L27.4395,9.4009 C27.6185,9.0859 27.9705,8.8659 28.3165,8.8959 C28.6785,8.8989 29.0105,9.0979 29.1845,9.4159 L33.0165,16.4239 Z M15.1835,23.0079 L19.2465,23.0079 L19.2465,18.9449 L15.1835,18.9449 L15.1835,23.0079 Z M20.2465,16.9449 C20.7985,16.9449 21.2465,17.3929 21.2465,17.9449 L21.2465,24.0089 C21.2465,24.5619 20.7985,25.0089 20.2465,25.0089 L14.1825,25.0089 C13.6295,25.0089 13.1825,24.5619 13.1825,24.0089 L13.1825,17.9449 C13.1825,17.3929 13.6295,16.9449 14.1825,16.9449 L20.2465,16.9449 Z M25.2555,42.4399 L25.2555,30.2259 L23.2555,30.2259 L23.2555,42.5199 L20.0115,39.2759 L18.5975,40.6899 L23.5085,45.6009 C23.6965,45.7879 23.9505,45.8939 24.2155,45.8939 C24.4815,45.8939 24.7355,45.7879 24.9225,45.6009 L29.8435,40.6789 L28.4295,39.2649 L25.2555,42.4399 Z M39.4675,8.6939 L39.4675,22.9279 C39.4675,31.4019 34.8665,36.8779 27.0815,37.9529 L27.0815,35.9729 C33.8675,35.0349 37.4675,30.4019 37.4675,22.9279 L37.4675,8.6939 L24.2175,3.9969 L10.9655,8.7419 L10.9995,22.9279 C10.9995,30.4019 14.6005,35.0349 21.3875,35.9729 L21.3875,37.9529 C13.6015,36.8779 8.9995,31.4019 8.9995,22.9279 L8.9995,8.6939 C8.9995,7.8699 9.5205,7.1329 10.2955,6.8589 L23.5795,2.1139 C23.9985,1.9619 24.4655,1.9619 24.8915,2.1139 L38.1735,6.8599 C38.9475,7.1329 39.4675,7.8699 39.4675,8.6939 L39.4675,8.6939 Z" id="Amazon-Simple-Storage_VPC-Access-Points_Resource-Icon_light-bg" fill="#7AA116"></path>
    </g>
</svg>`, Qy = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Storage/Res_Amazon-Simple-Storage-Service_S3-Batch-Operations_48</title>
    <g id="Icon-Resource/Storage/Res_Amazon-Simple-Storage-Service_S3-Batch-Operations_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M9.584,39.43 L13.421,35.593 L14.835,37.007 L10.302,41.54 C10.106,41.736 9.851,41.833 9.595,41.833 C9.344,41.833 9.093,41.74 8.898,41.552 L6.834,39.552 L8.227,38.115 L9.584,39.43 Z M14.835,27.34 L10.302,31.873 C10.106,32.069 9.851,32.166 9.595,32.166 C9.344,32.166 9.093,32.073 8.898,31.885 L6.834,29.885 L8.227,28.448 L9.584,29.763 L13.421,25.926 L14.835,27.34 Z M14.835,17.674 L10.302,22.207 C10.106,22.402 9.851,22.5 9.595,22.5 C9.344,22.5 9.093,22.406 8.898,22.218 L6.834,20.218 L8.227,18.782 L9.584,20.097 L13.421,16.26 L14.835,17.674 Z M14.835,8.007 L10.302,12.54 C10.106,12.736 9.851,12.833 9.595,12.833 C9.344,12.833 9.093,12.74 8.898,12.552 L6.834,10.552 L8.227,9.115 L9.584,10.43 L13.421,6.593 L14.835,8.007 Z M34,37 L36,37 L36,45 C36,45.552 35.553,46 35,46 L3,46 C2.447,46 2,45.552 2,45 L2,3 C2,2.448 2.447,2 3,2 L35,2 C35.553,2 36,2.448 36,3 L36,14 L34,14 L34,4 L4,4 L4,44 L34,44 L34,37 Z M25,26 L24,26 L24,24 L25,24 L25,20 L27,20 L27,24 L28,24 L28,26 L27,26 L27,31 L25,31 L25,26 Z M32,29 L31,29 L31,27 L32,27 L32,20 L34,20 L34,27 L35,27 L35,29 L34,29 L34,31 L32,31 L32,29 Z M39,24 L38,24 L38,22 L39,22 L39,20 L41,20 L41,22 L42,22 L42,24 L41,24 L41,31 L39,31 L39,24 Z M22,33 L44,33 L44,18 L22,18 L22,33 Z M45,16 L21,16 C20.447,16 20,16.448 20,17 L20,34 C20,34.552 20.447,35 21,35 L45,35 C45.553,35 46,34.552 46,34 L46,17 C46,16.448 45.553,16 45,16 L45,16 Z" id="Fill-1" fill="#7AA116"></path>
    </g>
</svg>`, Xy = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Storage/Res_Amazon-Elastic-File-System_Standard-Infrequent-Access_48</title>
    <g id="Icon-Resource/Storage/Res_Amazon-Elastic-File-System_Standard-Infrequent-Access_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M41,39.00025 L41,16.65425 C41,14.89425 40.109,13.00025 38.154,13.00025 L34.771,13.00025 C34.583,11.69425 34.126,9.52225 33.141,9.08625 C33.013,9.02925 32.875,9.00025 32.735,9.00025 L25.257,9.00025 C25.069,9.00025 24.885,9.05325 24.726,9.15325 C23.853,9.70025 23.528,11.74825 23.41,13.00025 L21,13.00025 L21,15.00025 L24.346,15.00025 C24.898,15.00025 25.346,14.55225 25.346,14.00025 C25.346,13.30725 25.575,11.70925 25.811,11.00025 L32.234,11.00025 C32.524,11.69825 32.885,13.37825 32.885,14.00025 C32.885,14.55225 33.332,15.00025 33.885,15.00025 L38.154,15.00025 C38.95,15.00025 39,16.64125 39,16.65425 L39,38.00025 L4,38.00025 L4,16.66425 C4.008,16.27325 4.166,15.00025 5.846,15.00025 L9,15.00025 L9,13.00025 L5.846,13.00025 C3.024,13.00025 2,15.18525 2,16.65425 L2,39.00025 C2,39.55225 2.447,40.00025 3,40.00025 L40,40.00025 C40.553,40.00025 41,39.55225 41,39.00025 L41,39.00025 Z M32,33.00025 C33.103,33.00025 34,32.10325 34,31.00025 C34,29.89725 33.103,29.00025 32,29.00025 C30.897,29.00025 30,29.89725 30,31.00025 C30,32.10325 30.897,33.00025 32,33.00025 L32,33.00025 Z M32,35.00025 C29.794,35.00025 28,33.20625 28,31.00025 C28,28.79425 29.794,27.00025 32,27.00025 C34.206,27.00025 36,28.79425 36,31.00025 C36,33.20625 34.206,35.00025 32,35.00025 L32,35.00025 Z M19.674,27.00025 L23.326,27.00025 L21.5,23.60925 L19.674,27.00025 Z M17.119,27.52625 L20.619,21.02625 C20.969,20.37825 22.031,20.37825 22.381,21.02625 L25.881,27.52625 C26.047,27.83625 26.039,28.21025 25.858,28.51325 C25.678,28.81525 25.352,29.00025 25,29.00025 L18,29.00025 C17.648,29.00025 17.322,28.81525 17.142,28.51325 C16.961,28.21025 16.953,27.83625 17.119,27.52625 L17.119,27.52625 Z M9,31.00025 L12,31.00025 L12,28.00025 L9,28.00025 L9,31.00025 Z M13,26.00025 C13.553,26.00025 14,26.44825 14,27.00025 L14,32.00025 C14,32.55225 13.553,33.00025 13,33.00025 L8,33.00025 C7.447,33.00025 7,32.55225 7,32.00025 L7,27.00025 C7,26.44825 7.447,26.00025 8,26.00025 L13,26.00025 Z M15,19.00025 C15.256,19.00025 15.512,18.90225 15.707,18.70725 L18.707,15.70725 L17.293,14.29325 L15,16.58625 L12.707,14.29325 L11.293,15.70725 L14.293,18.70725 C14.488,18.90225 14.744,19.00025 15,19.00025 L15,19.00025 Z M15,4.41425 L17.293,6.70725 L18.707,5.29325 L15.707,2.29325 C15.316,1.90225 14.684,1.90225 14.293,2.29325 L11.293,5.29325 L12.707,6.70725 L15,4.41425 Z M14,13.00025 L16,13.00025 L16,8.00025 L14,8.00025 L14,13.00025 Z M46,22.07425 L46,44.00025 C46,44.55225 45.553,45.00025 45,45.00025 L8,45.00025 C7.448,45.00025 7.001,44.55325 7,44.00125 L7,44.00025 L7,42.00025 L9,42.00025 L9,43.00025 L44,43.00025 L44,22.07425 C44,21.51025 43.542,21.02925 42.979,21.00125 L43.079,19.00425 C44.717,19.08525 46,20.43425 46,22.07425 L46,22.07425 Z" id="Fill-1" fill="#7AA116"></path>
    </g>
</svg>`, Jy = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Storage/Res_Amazon-Simple-Storage-Service_S3-Intelligent-Tiering_48</title>
    <g id="Icon-Resource/Storage/Res_Amazon-Simple-Storage-Service_S3-Intelligent-Tiering_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M38.6221,35.3212 C38.6221,36.2882 39.2581,36.6402 40.5931,37.0242 C40.7261,37.0622 40.8481,37.0972 40.9521,37.1312 C41.0401,37.1592 41.1411,37.1882 41.2501,37.2192 C42.2731,37.5132 44.6691,38.2012 44.6691,40.8442 C44.6691,42.6992 43.2221,44.0662 41.1751,44.2552 L41.1751,46.0002 L39.1751,46.0002 L39.1751,44.0552 C38.7461,43.9182 38.3471,43.7262 38.0021,43.4772 C37.1121,42.8372 36.6221,41.8872 36.6221,40.8042 L38.6221,40.8042 C38.6221,41.9822 39.9791,42.2932 40.6971,42.2932 C41.4301,42.2932 42.6691,41.9882 42.6691,40.8442 C42.6691,39.8782 42.0331,39.5252 40.6981,39.1412 C40.5651,39.1032 40.4431,39.0682 40.3391,39.0352 C40.2511,39.0072 40.1501,38.9772 40.0411,38.9462 C39.0181,38.6522 36.6221,37.9652 36.6221,35.3212 C36.6221,34.2532 37.0891,33.3222 37.9351,32.7012 C38.2941,32.4382 38.7161,32.2392 39.1751,32.1052 L39.1751,30.0002 L41.1751,30.0002 L41.1751,31.9612 C42.9671,32.1922 44.6691,33.3902 44.6691,35.4412 L42.6691,35.4412 C42.6691,34.3192 41.3941,33.9122 40.5391,33.9122 C39.9841,33.9122 39.4671,34.0582 39.1181,34.3142 C38.7841,34.5582 38.6221,34.8882 38.6221,35.3212 M40.5611,26.1722 L40.7821,24.5252 C42.5221,25.5842 43.0971,26.2192 43.2721,26.4942 C42.9821,26.5502 42.2391,26.5822 40.5611,26.1722 M22.9241,13.5012 C12.6181,13.5012 5.6141,11.0512 5.0321,9.2662 L5.0021,9.0312 C5.1381,7.2352 12.4891,4.0002 22.9241,4.0002 C33.3581,4.0002 40.7111,7.2342 40.8501,9.0302 L40.8181,9.2652 C40.2391,11.0502 33.2331,13.5012 22.9241,13.5012 M23.1741,20.0002 L23.1751,19.0002 L23.1761,19.9992 C23.1761,20.0002 23.1751,20.0002 23.1741,20.0002 M45.3181,26.2902 C45.1021,25.1352 43.7741,23.9172 41.0711,22.3772 L42.7771,9.6732 C42.7821,9.6492 42.7881,9.6272 42.7911,9.6022 L42.8431,9.2132 C42.8491,9.1692 42.8511,9.1252 42.8511,9.0812 C42.8511,4.9082 32.3501,2.0002 22.9241,2.0002 C13.5001,2.0002 3.0001,4.9082 3.0001,9.0812 C3.0001,9.1242 3.0031,9.1672 3.0091,9.2102 L3.0591,9.5992 C3.0591,9.6052 3.0611,9.6092 3.0621,9.6152 L7.2921,41.0662 C7.4231,44.7482 16.9251,46.1232 22.9291,46.1232 C26.2241,46.1232 29.5501,45.7772 32.3011,45.1482 C33.4331,44.8832 34.4171,44.5842 35.2261,44.2602 C35.5521,44.1312 35.8511,44.0002 36.1291,43.8692 L35.2811,42.0582 C35.0341,42.1742 34.7701,42.2892 34.4831,42.4042 C33.7681,42.6902 32.8801,42.9582 31.8501,43.2002 C29.2461,43.7952 26.0781,44.1232 22.9291,44.1232 C14.4431,44.1232 9.2911,41.9462 9.2911,40.9892 C9.2911,40.9442 9.2881,40.9002 9.2821,40.8562 L5.4401,12.2912 C9.0611,14.4052 16.1631,15.5012 22.9241,15.5012 C29.6841,15.5012 36.7851,14.4062 40.4071,12.2922 L38.6161,25.6212 C34.0361,24.1812 27.9271,21.3992 25.1651,20.0992 C25.1671,20.0662 25.1751,20.0342 25.1751,20.0002 C25.1751,18.8972 24.2771,18.0002 23.1751,18.0002 C22.0721,18.0002 21.1751,18.8972 21.1751,20.0002 C21.1751,21.1022 22.0721,22.0002 23.1751,22.0002 C23.4911,22.0002 23.7871,21.9192 24.0541,21.7872 C27.1751,23.2632 33.5611,26.1732 38.3471,27.6312 L38.1371,29.1942 L40.1191,29.4602 L40.2931,28.1652 C41.3161,28.4062 42.1571,28.5272 42.8441,28.5272 C43.8371,28.5272 44.5051,28.2742 44.9311,27.7672 C45.2801,27.3502 45.4181,26.8262 45.3181,26.2902" id="Amazon-Simple-Storage_Service-Intelligent-Tiering_Resource-Icon_light-bg" fill="#7AA116"></path>
    </g>
</svg>`, eA = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Storage/Res_AWS-Backup_Recovery-Point-Objective_48</title>
    <g id="Icon-Resource/Storage/Res_AWS-Backup_Recovery-Point-Objective_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M23.1110276,16.8529511 L23.5450276,31.7729511 L24.4180276,31.7729511 L24.8500276,16.8529511 C24.2890276,16.6949511 23.6710276,16.6949511 23.1110276,16.8529511 M21.5730276,32.8019511 L21.0910276,16.2099511 C21.0810276,15.8209511 21.2970276,15.4609511 21.6450276,15.2869511 C23.1120276,14.5539511 24.8490276,14.5529511 26.3160276,15.2869511 C26.6650276,15.4609511 26.8810276,15.8209511 26.8700276,16.2099511 L26.3890276,32.8019511 C26.3740276,33.3429511 25.9300276,33.7729511 25.3890276,33.7729511 L22.5730276,33.7729511 C22.0320276,33.7729511 21.5890276,33.3429511 21.5730276,32.8019511 M22.7480276,38.5509511 C22.7480276,39.0799511 22.9390276,39.3379511 23.0840276,39.4869511 C23.2210276,39.6279511 23.4650276,39.8179511 23.9810276,39.8179511 C24.4960276,39.8179511 24.7400276,39.6279511 24.8800276,39.4849511 C25.0220276,39.3379511 25.2140276,39.0799511 25.2140276,38.5509511 C25.2140276,38.0219511 25.0220276,37.7649511 24.8790276,37.6169511 C24.7400276,37.4739511 24.4950276,37.2839511 23.9810276,37.2839511 C23.4660276,37.2839511 23.2210276,37.4739511 23.0820276,37.6169511 C22.8540276,37.8519511 22.7480276,38.1489511 22.7480276,38.5509511 M20.7480276,38.5509511 C20.7480276,37.6219511 21.0500276,36.8389511 21.6480276,36.2229511 C22.2480276,35.6079511 23.0530276,35.2839511 23.9810276,35.2839511 C24.9080276,35.2839511 25.7140276,35.6079511 26.3110276,36.2219511 C26.9110276,36.8369511 27.2140276,37.6209511 27.2140276,38.5509511 C27.2140276,39.4809511 26.9110276,40.2649511 26.3120276,40.8799511 C25.7150276,41.4939511 24.9090276,41.8179511 23.9810276,41.8179511 C23.0530276,41.8179511 22.2470276,41.4939511 21.6500276,40.8809511 C21.0500276,40.2639511 20.7480276,39.4799511 20.7480276,38.5509511 M45.4630276,40.0729511 C45.0560276,39.3859511 43.8350276,37.2709511 42.9190276,35.6859511 L41.1860276,36.6859511 C42.1060276,38.2779511 43.3340276,40.4009511 43.7450276,41.0969511 C44.0450276,41.5959511 44.0290276,42.2379511 43.7030276,42.8129511 C43.3630276,43.4139511 42.7840276,43.7729511 42.1550276,43.7729511 L5.80602757,43.7729511 C5.17702757,43.7729511 4.59802757,43.4139511 4.25802757,42.8129511 C3.93202757,42.2379511 3.91802757,41.5959511 4.22002757,41.0909511 L13.1530276,25.9849511 C13.2090276,25.8909511 13.2570276,25.7999511 13.2960276,25.7129511 L13.3090276,25.7209511 C13.3250276,25.6949511 13.7010276,25.0579511 22.3910276,10.3619511 C22.7010276,9.84595109 23.2960276,9.53795109 23.9800276,9.53795109 C24.6660276,9.53795109 25.2600276,9.84595109 25.5670276,10.3559511 L32.6150276,22.2749511 C33.6750276,24.0689511 34.2940276,25.1149511 34.7160276,25.6879511 L34.6550276,25.7259511 L36.7530276,29.2719511 L37.6530276,30.7299511 L39.3540276,29.6799511 L38.4640276,28.2379511 C37.3730276,26.3929511 36.7410276,25.3239511 36.3110276,24.7419511 L36.3750276,24.7039511 L27.2850276,9.33295109 C26.6100276,8.20895109 25.3750276,7.53795109 23.9800276,7.53795109 C22.5870276,7.53795109 21.3510276,8.20895109 20.6730276,9.33895109 L11.7410276,24.4439511 C11.6850276,24.5379511 11.6370276,24.6289511 11.5980276,24.7169511 L11.5850276,24.7079511 C11.5690276,24.7349511 11.1890276,25.3769511 2.50302757,40.0669511 C1.82702757,41.1919511 1.83302757,42.5869511 2.51702757,43.7979511 C3.20702757,45.0159511 4.46702757,45.7729511 5.80602757,45.7729511 L42.1550276,45.7729511 C43.4940276,45.7729511 44.7540276,45.0159511 45.4440276,43.7979511 C46.1290276,42.5869511 46.1350276,41.1929511 45.4630276,40.0729511 M5.04202757,21.6049511 L2.47402757,17.8219511 L4.12902757,16.6989511 L5.31702757,18.4499511 C6.10602757,14.1669511 8.23202757,10.2689511 11.5010276,7.27795109 C15.4690276,3.64795109 20.6130276,1.78395109 25.9870276,2.01995109 C37.0780276,2.51395109 45.6990276,11.9379511 45.2060276,23.0299511 C44.9260276,29.3099511 41.8130276,34.9889511 36.6660276,38.6109511 L35.5150276,36.9749511 C40.1520276,33.7129511 42.9560276,28.5979511 43.2080276,22.9409511 C43.6520276,12.9509511 35.8860276,4.46195109 25.8970276,4.01795109 C21.0660276,3.79695109 16.4240276,5.48395109 12.8500276,8.75395109 C9.88702757,11.4639511 7.96602757,15.0009511 7.26702757,18.8869511 L9.09002757,17.6489511 L10.2140276,19.3049511 L6.43002757,21.8719511 C6.25802757,21.9879511 6.06302757,22.0439511 5.87002757,22.0439511 C5.54902757,22.0439511 5.23502757,21.8909511 5.04202757,21.6049511" id="Fill-1" fill="#7AA116"></path>
    </g>
</svg>`, tA = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Storage/Res_AWS-Backup_Compliance-Reporting_48</title>
    <g id="Icon-Resource/Storage/Res_AWS-Backup_Compliance-Reporting_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M15.271,10 L32.55,10 L31.3,6 L26.815,6 C26.401,7.162 25.301,8 24,8 C22.698,8 21.598,7.162 21.184,6 L16.521,6 L15.271,10 Z M23,5 C23,5.551 23.448,6 24,6 C24.551,6 25,5.551 25,5 C25,4.449 24.551,4 24,4 C23.448,4 23,4.449 23,5 L23,5 Z M13.105,11.592 C12.917,11.336 12.861,11.005 12.957,10.702 L14.832,4.702 C14.961,4.284 15.348,4 15.786,4 L21.184,4 C21.598,2.838 22.698,2 24,2 C25.301,2 26.401,2.838 26.815,4 L32.036,4 C32.473,4 32.86,4.284 32.99,4.702 L34.865,10.702 C34.96,11.005 34.905,11.336 34.716,11.592 C34.528,11.849 34.229,12 33.911,12 L13.911,12 C13.592,12 13.293,11.849 13.105,11.592 L13.105,11.592 Z M39,6 L36,6 L36,8 L39,8 C39.551,8 40,8.449 40,9 L40,43 C40,43.551 39.551,44 39,44 L9,44 C8.448,44 8,43.551 8,43 L8,9 C8,8.449 8.448,8 9,8 L12,8 L12,6 L9,6 C7.345,6 6,7.346 6,9 L6,43 C6,44.654 7.345,46 9,46 L39,46 C40.654,46 42,44.654 42,43 L42,9 C42,7.346 40.654,6 39,6 L39,6 Z M14.5,27.5 C14.5,32.738 18.761,37 24,37 C29.238,37 33.5,32.738 33.5,27.5 C33.5,22.262 29.238,18 24,18 C18.761,18 14.5,22.262 14.5,27.5 L14.5,27.5 Z M12.5,27.5 C12.5,21.159 17.659,16 24,16 C30.34,16 35.5,21.159 35.5,27.5 C35.5,33.841 30.34,39 24,39 C17.659,39 12.5,33.841 12.5,27.5 L12.5,27.5 Z M21.26,31.745 L18.002,28.487 L19.417,27.073 L21.967,29.624 L28.248,23.343 L29.662,24.757 L22.674,31.745 C22.487,31.933 22.233,32.038 21.967,32.038 C21.702,32.038 21.448,31.933 21.26,31.745 L21.26,31.745 Z" id="Fill-1" fill="#7AA116"></path>
    </g>
</svg>`, nA = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Storage/Res_Amazon-Elastic-Block-Store_Snapshot_48</title>
    <g id="Icon-Resource/Storage/Res_Amazon-Elastic-Block-Store_Snapshot_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M36.1992,30.791 L36.2782,30.208 C36.7902,30.537 37.1402,30.802 37.3492,30.991 C37.0482,30.971 36.6542,30.899 36.1992,30.791 L36.1992,30.791 Z M22.7372,26.535 C22.7372,26.429 22.8232,26.342 22.9292,26.342 C22.9602,26.342 22.9822,26.362 23.0082,26.375 L22.8612,26.674 C22.7952,26.653 22.7372,26.614 22.7372,26.535 L22.7372,26.535 Z M32.7042,41.835 C32.7032,41.839 32.5272,42.208 31.3422,42.676 C30.8032,42.889 30.1622,43.082 29.4352,43.249 C27.5532,43.684 25.2412,43.924 22.9282,43.924 C17.1472,43.924 13.4392,42.544 13.1622,41.882 C13.1622,41.837 13.1592,41.793 13.1532,41.749 L10.3892,21.228 C10.4372,21.252 10.4972,21.271 10.5462,21.294 C10.8732,21.451 11.2192,21.601 11.5912,21.738 C11.6202,21.749 11.6452,21.761 11.6762,21.771 C12.0802,21.917 12.5132,22.05 12.9602,22.174 C13.0822,22.208 13.2062,22.24 13.3302,22.272 C13.7052,22.37 14.0882,22.461 14.4822,22.545 C14.5772,22.565 14.6692,22.587 14.7642,22.607 C15.2432,22.704 15.7322,22.79 16.2282,22.868 C16.3492,22.887 16.4712,22.903 16.5942,22.921 C16.9992,22.98 17.4062,23.034 17.8142,23.082 C17.9382,23.096 18.0612,23.111 18.1852,23.124 C18.6872,23.179 19.1862,23.225 19.6802,23.261 C19.7662,23.268 19.8492,23.271 19.9352,23.277 C20.3552,23.306 20.7682,23.329 21.1752,23.346 C21.3032,23.351 21.4292,23.356 21.5562,23.36 C22.0272,23.376 22.4902,23.386 22.9282,23.386 C23.3672,23.386 23.8302,23.376 24.3012,23.36 C24.4282,23.356 24.5542,23.351 24.6832,23.346 C25.0912,23.329 25.5052,23.306 25.9272,23.277 C26.0112,23.271 26.0922,23.268 26.1772,23.261 C26.6702,23.225 27.1682,23.179 27.6692,23.125 C27.7972,23.111 27.9242,23.095 28.0522,23.081 C28.4572,23.034 28.8592,22.98 29.2622,22.921 C29.3862,22.903 29.5092,22.887 29.6322,22.867 C30.1272,22.79 30.6162,22.704 31.0952,22.607 C31.1912,22.587 31.2832,22.565 31.3792,22.544 C31.7722,22.461 32.1552,22.37 32.5302,22.272 C32.6542,22.24 32.7772,22.208 32.8982,22.174 C33.3452,22.049 33.7782,21.917 34.1832,21.771 C34.2152,21.76 34.2412,21.748 34.2712,21.736 C34.6422,21.6 34.9872,21.451 35.3142,21.294 C35.3632,21.271 35.4232,21.252 35.4702,21.228 L34.2622,30.228 C31.6532,29.365 28.0762,27.877 24.7122,26.283 C24.5882,25.406 23.8402,24.728 22.9292,24.728 C21.9322,24.728 21.1222,25.539 21.1222,26.535 C21.1222,27.532 21.9322,28.342 22.9292,28.342 C23.2622,28.342 23.5712,28.246 23.8392,28.088 C28.0672,30.116 31.4522,31.501 33.9912,32.249 L32.7042,41.835 Z M22.9282,14.922 C30.5962,14.922 35.7142,17.326 35.8562,18.354 L35.8442,18.451 C35.8332,18.485 35.8092,18.521 35.7892,18.557 C35.7712,18.588 35.7572,18.619 35.7312,18.651 C35.7032,18.687 35.6632,18.725 35.6262,18.762 C35.5912,18.797 35.5592,18.832 35.5162,18.868 C35.4712,18.906 35.4162,18.944 35.3632,18.983 C35.3102,19.021 35.2622,19.059 35.2002,19.099 C35.1412,19.136 35.0712,19.175 35.0052,19.213 C34.9332,19.254 34.8662,19.295 34.7862,19.337 C34.7142,19.375 34.6302,19.414 34.5502,19.452 C34.4602,19.495 34.3742,19.538 34.2752,19.581 C34.1902,19.618 34.0942,19.655 34.0032,19.692 C33.8942,19.737 33.7892,19.781 33.6712,19.825 C33.5722,19.862 33.4632,19.898 33.3572,19.935 C33.2312,19.978 33.1102,20.022 32.9752,20.065 C32.8632,20.102 32.7392,20.136 32.6222,20.171 C32.4792,20.214 32.3412,20.257 32.1892,20.298 C32.0622,20.333 31.9242,20.366 31.7902,20.4 C31.6342,20.44 31.4822,20.481 31.3172,20.519 C31.1742,20.552 31.0192,20.583 30.8702,20.616 C30.7002,20.652 30.5362,20.689 30.3582,20.724 C30.1992,20.755 30.0272,20.784 29.8612,20.813 C29.6802,20.845 29.5052,20.879 29.3172,20.909 C29.1372,20.938 28.9452,20.963 28.7582,20.989 C28.5702,21.016 28.3882,21.045 28.1942,21.069 C27.9902,21.095 27.7732,21.116 27.5612,21.14 C27.3722,21.16 27.1872,21.183 26.9922,21.202 C26.7622,21.223 26.5202,21.239 26.2822,21.257 C26.0922,21.272 25.9072,21.289 25.7112,21.301 C25.4462,21.318 25.1682,21.328 24.8942,21.339 C24.7142,21.347 24.5402,21.358 24.3562,21.364 C23.8922,21.378 23.4162,21.386 22.9282,21.386 C22.4402,21.386 21.9652,21.378 21.5012,21.364 C21.3232,21.359 21.1552,21.348 20.9792,21.34 C20.7002,21.328 20.4172,21.318 20.1452,21.301 C19.9652,21.29 19.7952,21.274 19.6192,21.261 C19.3652,21.242 19.1072,21.224 18.8632,21.201 C18.6882,21.185 18.5252,21.164 18.3552,21.146 C18.1232,21.121 17.8862,21.097 17.6612,21.069 C17.4882,21.047 17.3272,21.021 17.1592,20.998 C16.9502,20.968 16.7372,20.94 16.5362,20.908 C16.3712,20.881 16.2172,20.852 16.0562,20.823 C15.8682,20.791 15.6762,20.758 15.4962,20.723 C15.3382,20.692 15.1922,20.659 15.0412,20.626 C14.8712,20.59 14.6972,20.555 14.5362,20.518 C14.3912,20.484 14.2602,20.448 14.1222,20.414 C13.9682,20.375 13.8092,20.336 13.6632,20.296 C13.5292,20.26 13.4072,20.222 13.2802,20.184 C13.1452,20.144 13.0062,20.104 12.8792,20.064 C12.7592,20.025 12.6512,19.986 12.5382,19.947 C12.4182,19.906 12.2942,19.865 12.1812,19.823 C12.0772,19.784 11.9852,19.744 11.8872,19.705 C11.7842,19.663 11.6762,19.621 11.5802,19.579 C11.4902,19.54 11.4122,19.5 11.3302,19.461 C11.2422,19.419 11.1492,19.377 11.0692,19.335 C10.9962,19.297 10.9342,19.259 10.8692,19.221 C10.7962,19.18 10.7202,19.138 10.6562,19.097 C10.5992,19.06 10.5532,19.024 10.5042,18.988 C10.4472,18.947 10.3882,18.906 10.3422,18.867 C10.3012,18.833 10.2702,18.799 10.2372,18.766 C10.1982,18.727 10.1562,18.688 10.1282,18.65 C10.1022,18.619 10.0892,18.589 10.0712,18.559 C10.0502,18.522 10.0262,18.485 10.0152,18.45 L10.0032,18.354 C10.1452,17.326 15.2622,14.922 22.9282,14.922 L22.9282,14.922 Z M39.6692,31.017 C39.4982,30.1 38.5532,29.194 36.5692,28.043 L37.8122,18.817 L37.8122,18.816 L37.8122,18.816 L37.8502,18.529 C37.8562,18.485 37.8592,18.441 37.8592,18.397 C37.8592,15.123 30.1392,12.922 22.9282,12.922 C15.7192,12.922 8.0002,15.123 8.0002,18.397 C8.0002,18.441 8.0032,18.485 8.0092,18.529 L8.0472,18.816 L8.0472,18.816 L8.0472,18.817 L11.1642,41.962 C11.2892,44.867 18.2412,45.924 22.9282,45.924 C25.3882,45.924 27.8592,45.666 29.8862,45.198 C30.7082,45.008 31.4452,44.787 32.0772,44.537 C33.7722,43.866 34.6532,42.999 34.6952,41.961 L35.9382,32.731 C36.5532,32.846 37.0972,32.907 37.5592,32.907 C38.4092,32.907 38.9982,32.712 39.3252,32.322 C39.6352,31.954 39.7572,31.491 39.6692,31.017 L39.6692,31.017 Z M12.6212,13.481 L10.6212,13.481 L10.6212,10.861 C10.6212,10.309 11.0682,9.861 11.6212,9.861 L34.3302,9.861 C34.8832,9.861 35.3302,10.309 35.3302,10.861 L35.3302,13.481 L33.3302,13.481 L33.3302,11.861 L12.6212,11.861 L12.6212,13.481 Z M16.0952,4 L29.8552,4 L32.0442,6.367 L13.9072,6.367 L16.0952,4 Z M11.6212,8.367 L34.3302,8.367 C34.7272,8.367 35.0872,8.132 35.2462,7.768 C35.4052,7.404 35.3342,6.98 35.0642,6.688 L31.0272,2.321 C30.8382,2.116 30.5722,2 30.2932,2 L15.6582,2 C15.3792,2 15.1132,2.116 14.9242,2.321 L10.8872,6.688 C10.6172,6.98 10.5462,7.404 10.7052,7.768 C10.8642,8.132 11.2232,8.367 11.6212,8.367 L11.6212,8.367 Z" id="AWS-Amazon-Elastic-Block-Store_Snapshot_Resource-Icon_light-bg" fill="#7AA116"></path>
    </g>
</svg>`, iA = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Storage/Res_AWS-Backup_Database_48</title>
    <g id="Icon-Resource/Storage/Res_AWS-Backup_Database_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M24,20.7676 C20.278,20.7676 18,19.4726 18,18.7676 L18,18.6636 C18,18.1056 19.727,16.7676 24,16.7676 C28.273,16.7676 30,18.1056 30,18.6636 L30,18.7676 C30,19.4726 27.722,20.7676 24,20.7676 L24,20.7676 Z M24.008,33.7616 L23.992,33.7616 C21.099,33.7406 18,33.0276 18,31.9996 L18,21.4996 C19.541,22.3376 21.778,22.7676 24,22.7676 C26.222,22.7676 28.459,22.3376 30,21.4996 L30,31.9996 C30,33.0276 26.901,33.7406 24.008,33.7616 L24.008,33.7616 Z M24,14.7676 C19.215,14.7676 16,16.3336 16,18.6636 L16,31.9996 C16,35.4366 22.106,35.7476 23.987,35.7616 L23.998,35.7616 L24.022,35.7616 C25.894,35.7476 32,35.4366 32,31.9996 L32,18.6636 C32,16.3336 28.785,14.7676 24,14.7676 L24,14.7676 Z M42,20.9996 C40.897,20.9996 40,20.1026 40,18.9996 C40,17.8966 40.897,16.9996 42,16.9996 C43.103,16.9996 44,17.8966 44,18.9996 C44,20.1026 43.103,20.9996 42,20.9996 L42,20.9996 Z M34.296,37.0296 C34.196,37.0226 34.101,36.9996 34,36.9996 C32.141,36.9996 30.589,38.2796 30.142,39.9996 L17.858,39.9996 C17.411,38.2796 15.859,36.9996 14,36.9996 C13.899,36.9996 13.804,37.0226 13.704,37.0296 L8.195,22.3376 C9.28,21.6216 10,20.3946 10,18.9996 C10,18.5106 9.899,18.0466 9.738,17.6136 L21.812,9.3416 C22.442,9.7556 23.192,9.9996 24,9.9996 C24.808,9.9996 25.558,9.7556 26.188,9.3416 L38.262,17.6136 C38.101,18.0466 38,18.5106 38,18.9996 C38,20.3946 38.72,21.6216 39.805,22.3376 L34.296,37.0296 Z M34,42.9996 C32.897,42.9996 32,42.1026 32,40.9996 C32,39.8966 32.897,38.9996 34,38.9996 C35.103,38.9996 36,39.8966 36,40.9996 C36,42.1026 35.103,42.9996 34,42.9996 L34,42.9996 Z M14,42.9996 C12.897,42.9996 12,42.1026 12,40.9996 C12,39.8966 12.897,38.9996 14,38.9996 C15.103,38.9996 16,39.8966 16,40.9996 C16,42.1026 15.103,42.9996 14,42.9996 L14,42.9996 Z M4,18.9996 C4,17.8966 4.897,16.9996 6,16.9996 C7.103,16.9996 8,17.8966 8,18.9996 C8,20.1026 7.103,20.9996 6,20.9996 C4.897,20.9996 4,20.1026 4,18.9996 L4,18.9996 Z M24,3.9996 C25.103,3.9996 26,4.8966 26,5.9996 C26,7.1026 25.103,7.9996 24,7.9996 C22.897,7.9996 22,7.1026 22,5.9996 C22,4.8966 22.897,3.9996 24,3.9996 L24,3.9996 Z M42,14.9996 C41.008,14.9996 40.111,15.3756 39.412,15.9756 L27.532,7.8376 C27.821,7.2846 28,6.6656 28,5.9996 C28,3.7946 26.206,1.9996 24,1.9996 C21.794,1.9996 20,3.7946 20,5.9996 C20,6.6656 20.179,7.2846 20.468,7.8376 L8.588,15.9756 C7.889,15.3756 6.992,14.9996 6,14.9996 C3.794,14.9996 2,16.7946 2,18.9996 C2,21.2056 3.794,22.9996 6,22.9996 C6.101,22.9996 6.196,22.9776 6.296,22.9706 L11.805,37.6626 C10.72,38.3786 10,39.6056 10,40.9996 C10,43.2056 11.794,44.9996 14,44.9996 C15.859,44.9996 17.411,43.7206 17.858,41.9996 L30.142,41.9996 C30.589,43.7206 32.141,44.9996 34,44.9996 C36.206,44.9996 38,43.2056 38,40.9996 C38,39.6056 37.28,38.3786 36.195,37.6626 L41.704,22.9706 C41.804,22.9776 41.899,22.9996 42,22.9996 C44.206,22.9996 46,21.2056 46,18.9996 C46,16.7946 44.206,14.9996 42,14.9996 L42,14.9996 Z" id="Fill-1" fill="#7AA116"></path>
    </g>
</svg>`, sA = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Storage/Res_AWS-Backup_AWS-Backup-support-for-Amazon-FSx-for-NetApp-ONTAP_48</title>
    <g id="Icon-Resource/Storage/Res_AWS-Backup_AWS-Backup-support-for-Amazon-FSx-for-NetApp-ONTAP_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M45.8105,21.4039 C45.1165,16.6469 42.6115,12.4449 38.7565,9.5709 C34.9035,6.6979 30.1615,5.4979 25.4015,6.1919 C21.3775,6.7789 17.7615,8.6739 14.9995,11.5719 L14.9995,8.0019 L12.9995,8.0019 L12.9995,14.0019 C12.9995,14.5539 13.4475,15.0019 13.9995,15.0019 L19.9995,15.0019 L19.9995,13.0019 L16.3955,13.0019 C18.8555,10.3969 22.0905,8.6959 25.6905,8.1709 C29.9135,7.5539 34.1335,8.6199 37.5615,11.1749 C40.9885,13.7289 43.2145,17.4639 43.8315,21.6929 C44.4485,25.9209 43.3815,30.1369 40.8275,33.5629 C37.7805,37.6519 33.1045,39.9979 27.9995,40.0019 L26.9995,40.0019 L26.9995,42.0019 L28.0005,42.0019 C33.7445,41.9979 39.0025,39.3579 42.4305,34.7579 C45.3035,30.9039 46.5045,26.1609 45.8105,21.4039 L45.8105,21.4039 Z M22.9995,35.5149 L14.8475,22.4719 C14.6115,22.0929 14.1505,21.9199 13.7245,22.0409 C13.2955,22.1639 12.9995,22.5559 12.9995,23.0019 L12.9995,40.0019 L14.9995,40.0019 L14.9995,26.4889 L23.1525,39.5319 C23.3375,39.8299 23.6615,40.0019 23.9995,40.0019 C24.0915,40.0019 24.1845,39.9889 24.2755,39.9639 C24.7045,39.8409 24.9995,39.4479 24.9995,39.0019 L24.9995,22.0019 L22.9995,22.0019 L22.9995,35.5149 Z M28.8075,19.2759 C28.7565,19.7939 29.1145,20.2679 29.6335,20.3569 C30.9465,20.5829 33.9995,21.5049 33.9995,25.1869 C33.9995,29.4849 30.0255,29.9649 29.6575,30.0019 L26.9995,30.0019 L26.9995,32.0019 L29.7385,31.9989 C31.9045,31.8229 35.9995,30.1729 35.9995,25.1869 C35.9995,21.3059 33.4045,19.2599 30.7345,18.5519 C30.3955,16.3609 29.1725,14.7769 27.3785,14.2519 C26.1675,13.8989 24.9095,14.1109 23.8815,14.7859 C23.6435,14.3079 23.3765,13.8559 23.0825,13.4319 L21.4405,14.5719 C21.9005,15.2359 22.2825,15.9929 22.5755,16.8229 C22.6995,17.1719 23.0045,17.4239 23.3715,17.4789 C23.7355,17.5309 24.1035,17.3819 24.3235,17.0839 C24.9285,16.2649 25.9095,15.9049 26.8175,16.1719 C27.9325,16.4979 28.6715,17.6539 28.8075,19.2759 L28.8075,19.2759 Z M8.3365,18.4649 C8.3365,18.7669 8.3545,19.0649 8.3905,19.3569 C8.4485,19.8399 8.1515,20.2949 7.6855,20.4339 C7.6525,20.4449 7.6195,20.4519 7.5855,20.4589 C6.2185,20.8229 3.9995,21.9119 3.9995,25.1369 C3.9995,25.3439 4.0085,25.5439 4.0275,25.7349 C4.2505,28.1139 6.3955,29.9779 8.9115,29.9809 L11.0005,29.9829 L10.9985,31.9829 L8.9095,31.9809 C5.3725,31.9769 2.3545,29.3169 2.0365,25.9249 C2.0125,25.6749 1.9995,25.4109 1.9995,25.1369 C1.9995,22.0979 3.6065,19.7669 6.3415,18.7569 C6.3385,18.6589 6.3365,18.5619 6.3365,18.4649 C6.3365,15.5579 7.9845,12.4779 10.4355,10.7999 L11.5645,12.4499 C9.6645,13.7509 8.3365,16.2239 8.3365,18.4649 L8.3365,18.4649 Z" id="Fill-1" fill="#7AA116"></path>
    </g>
</svg>`, H7 = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Storage/Res_Amazon-Simple-Storage-Service_S3-Glacier-Flexible-Retrieval_48</title>
    <g id="Icon-Resource/Storage/Res_Amazon-Simple-Storage-Service_S3-Glacier-Flexible-Retrieval_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M43.165,38.0811 L44.861,39.7781 L43.447,41.1921 L41.256,39.0001 L38.084,39.0001 L39.722,41.8411 L42.616,42.6541 L42.075,44.5801 L39.807,43.9411 L39.185,46.2591 L37.253,45.7411 L38.019,42.8901 L36.411,40.1021 L34.829,42.8371 L35.571,45.7531 L33.634,46.2471 L33.052,43.9621 L30.733,44.5831 L30.216,42.6511 L33.067,41.8881 L34.738,39.0001 L31.621,39.0001 L29.364,41.2011 L27.968,39.7691 L29.656,38.1231 L27.959,36.4271 L29.373,35.0131 L31.361,37.0001 L34.62,37.0001 L33.095,34.3631 L30.204,33.5501 L30.745,31.6241 L33.015,32.2631 L33.637,29.9451 L35.568,30.4631 L34.802,33.3211 L36.411,36.1031 L37.991,33.3621 L37.25,30.4511 L39.187,29.9571 L39.769,32.2421 L42.087,31.6211 L42.604,33.5531 L39.747,34.3191 L38.202,37.0001 L41.409,37.0001 L43.456,35.0041 L44.852,36.4351 L43.165,38.0811 Z M22.869,4.0001 C33.272,4.0001 40.602,7.2241 40.739,9.0131 L40.714,9.2101 C40.691,9.2911 40.644,9.3761 40.595,9.4601 C40.576,9.4911 40.566,9.5221 40.544,9.5551 C40.487,9.6361 40.407,9.7181 40.327,9.8001 C40.292,9.8361 40.267,9.8721 40.226,9.9091 C40.139,9.9891 40.028,10.0691 39.921,10.1501 C39.867,10.1901 39.823,10.2291 39.765,10.2691 C39.647,10.3491 39.509,10.4291 39.37,10.5091 C39.302,10.5501 39.241,10.5901 39.167,10.6301 C39.017,10.7121 38.844,10.7931 38.673,10.8741 C38.593,10.9121 38.521,10.9501 38.436,10.9881 C38.245,11.0731 38.034,11.1571 37.821,11.2411 C37.739,11.2741 37.665,11.3081 37.579,11.3391 C37.335,11.4311 37.071,11.5201 36.802,11.6091 C36.733,11.6321 36.671,11.6551 36.601,11.6791 C36.286,11.7781 35.951,11.8761 35.604,11.9721 C35.569,11.9811 35.54,11.9911 35.505,12.0011 C32.398,12.8431 28.056,13.4631 22.874,13.4631 C14.452,13.4631 8.243,11.8231 5.956,10.2541 C5.946,10.2471 5.939,10.2401 5.93,10.2331 C5.769,10.1211 5.626,10.0101 5.507,9.8991 C5.484,9.8791 5.47,9.8581 5.45,9.8391 C5.351,9.7421 5.262,9.6451 5.195,9.5511 C5.175,9.5201 5.165,9.4911 5.147,9.4611 C5.097,9.3771 5.051,9.2931 5.027,9.2111 L5.002,9.0131 C5.139,7.2241 12.468,4.0001 22.869,4.0001 L22.869,4.0001 Z M43.157,26.4231 C42.865,26.4781 42.126,26.5091 40.458,26.1011 L40.677,24.4661 C42.417,25.5221 42.984,26.1471 43.157,26.4231 L43.157,26.4231 Z M23.117,19.9991 L24.117,20.0001 L23.118,20.0011 C23.117,20.0011 23.117,20.0001 23.117,19.9991 L23.117,19.9991 Z M22.874,44.0001 C14.415,44.0001 9.278,41.8321 9.278,40.8791 C9.278,40.8341 9.275,40.7901 9.269,40.7461 L5.441,12.2711 C5.674,12.4071 5.921,12.5371 6.181,12.6641 C6.326,12.7351 6.483,12.8021 6.636,12.8701 C6.796,12.9401 6.958,13.0121 7.126,13.0801 C7.304,13.1511 7.484,13.2221 7.67,13.2911 C7.827,13.3491 7.991,13.4051 8.155,13.4611 C8.573,13.6031 9.009,13.7391 9.464,13.8661 C9.557,13.8931 9.645,13.9211 9.739,13.9461 C9.987,14.0131 10.244,14.0751 10.502,14.1381 C10.648,14.1741 10.795,14.2101 10.944,14.2441 C11.212,14.3061 11.482,14.3641 11.759,14.4211 C11.884,14.4471 12.011,14.4711 12.137,14.4951 C13.103,14.6851 14.111,14.8471 15.153,14.9801 C15.27,14.9951 15.387,15.0111 15.505,15.0251 C15.844,15.0661 16.185,15.1051 16.528,15.1421 C16.599,15.1481 16.669,15.1541 16.739,15.1611 C17.864,15.2731 19.009,15.3531 20.161,15.4031 C20.274,15.4081 20.388,15.4131 20.501,15.4171 C20.862,15.4311 21.222,15.4421 21.583,15.4491 C21.632,15.4501 21.679,15.4501 21.728,15.4511 C22.108,15.4581 22.489,15.4671 22.869,15.4671 C23.234,15.4671 23.602,15.4581 23.969,15.4521 C24.038,15.4501 24.106,15.4501 24.177,15.4491 C24.52,15.4421 24.863,15.4311 25.208,15.4181 C25.349,15.4131 25.489,15.4071 25.63,15.4011 C25.968,15.3861 26.304,15.3701 26.64,15.3511 L26.897,15.3331 C27.542,15.2921 28.181,15.2401 28.814,15.1791 C28.968,15.1651 29.12,15.1511 29.272,15.1361 C29.568,15.1041 29.861,15.0701 30.153,15.0351 C30.339,15.0131 30.522,14.9891 30.706,14.9661 C30.987,14.9291 31.267,14.8921 31.542,14.8521 C31.747,14.8211 31.946,14.7871 32.147,14.7551 C32.577,14.6861 32.998,14.6121 33.412,14.5331 C33.628,14.4921 33.843,14.4511 34.054,14.4071 C34.278,14.3601 34.498,14.3121 34.717,14.2631 C34.937,14.2131 35.153,14.1601 35.368,14.1071 C35.564,14.0591 35.763,14.0111 35.954,13.9601 C36.319,13.8621 36.675,13.7601 37.019,13.6521 C37.172,13.6041 37.315,13.5531 37.465,13.5031 C37.689,13.4281 37.91,13.3521 38.123,13.2721 C38.274,13.2161 38.423,13.1581 38.567,13.1011 C38.782,13.0141 38.987,12.9251 39.188,12.8341 C39.305,12.7811 39.425,12.7301 39.536,12.6771 C39.804,12.5471 40.06,12.4131 40.298,12.2741 L38.513,25.5511 C33.953,24.1181 27.87,21.3471 25.112,20.0511 C25.112,20.0331 25.117,20.0181 25.117,20.0001 C25.117,18.8971 24.22,18.0001 23.117,18.0001 C22.015,18.0001 21.117,18.8971 21.117,20.0001 C21.117,21.1021 22.015,22.0001 23.117,22.0001 C23.454,22.0001 23.768,21.9081 24.047,21.7601 C27.18,23.2401 33.504,26.1161 38.243,27.5601 L38.157,28.1981 L40.14,28.4661 L40.189,28.0951 C41.209,28.3341 42.048,28.4551 42.731,28.4551 C43.722,28.4551 44.389,28.2031 44.814,27.6961 C45.164,27.2801 45.302,26.7571 45.201,26.2221 C44.986,25.0711 43.661,23.8541 40.966,22.3191 L42.669,9.6481 C42.673,9.6261 42.679,9.6031 42.682,9.5811 L42.732,9.1931 C42.738,9.1501 42.741,9.1061 42.741,9.0631 C42.741,4.9001 32.269,2.0001 22.869,2.0001 C13.472,2.0001 3,4.9001 3,9.0631 C3,9.1061 3.003,9.1501 3.009,9.1931 L3.06,9.5811 L3.065,9.6131 L7.279,40.9561 C7.41,44.6291 16.886,46.0001 22.874,46.0001 C24.904,46.0001 26.942,45.8711 28.933,45.6161 L28.679,43.6321 C26.772,43.8761 24.819,44.0001 22.874,44.0001 L22.874,44.0001 Z" id="Amazon-Simple-Storage-Service_Glacier-Flexible-Retrieval_Resource-Icon" fill="#7AA116"></path>
    </g>
</svg>`, rA = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Storage/Res_Amazon-Simple-Storage-Service_Bucket_48</title>
    <g id="Icon-Resource/Storage/Res_Amazon-Simple-Storage-Service_Bucket_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M40.5038,26.1601 L40.7278,24.4941 C42.5118,25.5811 43.0628,26.2091 43.2228,26.4741 C42.7498,26.6171 41.7948,26.4911 40.5038,26.1601 L40.5038,26.1601 Z M22.8018,20.1111 C22.8018,20.0581 22.8448,20.0151 22.8978,20.0151 C22.9128,20.0151 22.9238,20.0251 22.9368,20.0321 L22.8638,20.1791 C22.8308,20.1691 22.8018,20.1491 22.8018,20.1111 L22.8018,20.1111 Z M36.5138,40.7981 C36.5078,40.8431 36.5048,40.8871 36.5048,40.9311 C36.5048,41.0861 36.1258,41.6751 34.4408,42.3401 C33.6898,42.6371 32.8028,42.9031 31.8028,43.1331 C29.2278,43.7291 26.0638,44.0571 22.8958,44.0571 C14.4298,44.0571 9.2888,41.8871 9.2888,40.9311 C9.2888,40.8871 9.2858,40.8431 9.2798,40.7981 L5.4408,12.2851 C5.6878,12.4291 5.9528,12.5661 6.2308,12.7001 C6.3098,12.7381 6.3958,12.7741 6.4778,12.8121 C6.7178,12.9231 6.9668,13.0301 7.2268,13.1341 C7.3388,13.1781 7.4518,13.2221 7.5668,13.2651 C7.8428,13.3691 8.1278,13.4691 8.4228,13.5651 C8.5098,13.5941 8.5928,13.6241 8.6808,13.6511 C9.0598,13.7701 9.4528,13.8841 9.8578,13.9911 C9.9708,14.0211 10.0878,14.0501 10.2028,14.0781 C10.5148,14.1581 10.8328,14.2341 11.1578,14.3061 C11.2988,14.3381 11.4388,14.3691 11.5808,14.3981 C11.9458,14.4751 12.3188,14.5491 12.6978,14.6181 C12.7798,14.6331 12.8588,14.6491 12.9418,14.6641 C13.3998,14.7441 13.8688,14.8181 14.3448,14.8881 C14.4788,14.9071 14.6148,14.9241 14.7508,14.9421 C15.1108,14.9921 15.4758,15.0381 15.8438,15.0811 C15.9938,15.0981 16.1448,15.1161 16.2968,15.1331 C16.7408,15.1801 17.1888,15.2231 17.6398,15.2621 C17.6928,15.2661 17.7468,15.2721 17.8018,15.2761 C18.3058,15.3171 18.8128,15.3501 19.3208,15.3801 C19.4658,15.3881 19.6108,15.3941 19.7568,15.4011 C20.1408,15.4201 20.5248,15.4351 20.9088,15.4481 C21.0598,15.4531 21.2088,15.4581 21.3588,15.4621 C21.8718,15.4731 22.3848,15.4821 22.8958,15.4821 C23.4058,15.4821 23.9188,15.4731 24.4318,15.4621 C24.5818,15.4581 24.7328,15.4531 24.8828,15.4481 C25.2678,15.4351 25.6508,15.4201 26.0338,15.4011 C26.1808,15.3941 26.3258,15.3881 26.4718,15.3801 C26.9808,15.3501 27.4868,15.3171 27.9898,15.2761 C28.0458,15.2711 28.1008,15.2651 28.1558,15.2621 C28.6068,15.2231 29.0518,15.1801 29.4938,15.1331 C29.6478,15.1161 29.7988,15.0981 29.9508,15.0811 C30.3168,15.0381 30.6808,14.9921 31.0398,14.9431 C31.1768,14.9251 31.3148,14.9071 31.4498,14.8871 C31.9248,14.8181 32.3928,14.7441 32.8518,14.6641 C32.9348,14.6491 33.0158,14.6331 33.0988,14.6171 C33.4768,14.5491 33.8478,14.4751 34.2128,14.3981 C34.3558,14.3691 34.4948,14.3381 34.6358,14.3061 C34.9608,14.2331 35.2788,14.1571 35.5918,14.0781 C35.7058,14.0491 35.8228,14.0211 35.9358,13.9921 C36.3418,13.8841 36.7348,13.7701 37.1138,13.6511 C37.2008,13.6241 37.2828,13.5951 37.3678,13.5661 C37.6648,13.4701 37.9518,13.3691 38.2298,13.2641 C38.3428,13.2221 38.4548,13.1791 38.5658,13.1351 C38.8278,13.0301 39.0788,12.9221 39.3218,12.8101 C39.4008,12.7731 39.4848,12.7381 39.5628,12.7011 C39.8408,12.5671 40.1068,12.4291 40.3538,12.2851 L38.5618,25.5911 C34.9248,24.4241 29.8168,22.3071 24.9818,20.0081 C24.9268,18.9011 24.0178,18.0151 22.8978,18.0151 C21.7418,18.0151 20.8018,18.9561 20.8018,20.1111 C20.8018,21.2661 21.7418,22.2061 22.8978,22.2061 C23.3518,22.2061 23.7698,22.0571 24.1128,21.8101 C28.4448,23.8891 33.9758,26.3421 38.2928,27.5881 L36.5138,40.7981 Z M22.8958,4.0001 C33.3148,4.0001 40.6558,7.2281 40.7918,9.0211 L40.7658,9.2291 C40.7478,9.2911 40.7088,9.3541 40.6758,9.4181 C40.6488,9.4701 40.6288,9.5201 40.5918,9.5731 C40.5478,9.6351 40.4828,9.6981 40.4258,9.7611 C40.3748,9.8161 40.3318,9.8711 40.2708,9.9271 C40.2028,9.9881 40.1158,10.0511 40.0348,10.1131 C39.9598,10.1711 39.8938,10.2281 39.8078,10.2871 C39.7168,10.3471 39.6078,10.4091 39.5058,10.4711 C39.4068,10.5301 39.3158,10.5901 39.2048,10.6491 C39.0948,10.7091 38.9658,10.7671 38.8448,10.8271 C38.7208,10.8881 38.6048,10.9481 38.4688,11.0091 C38.3398,11.0661 38.1928,11.1231 38.0548,11.1801 C37.9048,11.2401 37.7638,11.3021 37.6038,11.3611 C37.4558,11.4171 37.2898,11.4711 37.1328,11.5251 C36.9618,11.5841 36.7978,11.6441 36.6158,11.7021 C36.4468,11.7561 36.2608,11.8061 36.0818,11.8591 C35.8918,11.9151 35.7088,11.9721 35.5088,12.0261 C35.3168,12.0781 35.1098,12.1261 34.9098,12.1761 C34.7028,12.2271 34.5028,12.2801 34.2858,12.3301 C34.0698,12.3791 33.8378,12.4241 33.6118,12.4711 C33.3938,12.5161 33.1818,12.5641 32.9538,12.6071 C32.7138,12.6531 32.4568,12.6941 32.2068,12.7371 C31.9768,12.7761 31.7538,12.8181 31.5148,12.8551 C31.2548,12.8951 30.9788,12.9311 30.7088,12.9681 C30.4648,13.0011 30.2268,13.0381 29.9748,13.0681 C29.6818,13.1041 29.3728,13.1341 29.0698,13.1651 C28.8258,13.1911 28.5898,13.2201 28.3398,13.2421 C28.0038,13.2731 27.6518,13.2961 27.3058,13.3201 C27.0728,13.3381 26.8478,13.3581 26.6098,13.3731 C26.2308,13.3951 25.8338,13.4091 25.4408,13.4261 C25.2248,13.4341 25.0148,13.4471 24.7938,13.4541 C24.1748,13.4721 23.5418,13.4821 22.8958,13.4821 C22.2498,13.4821 21.6168,13.4721 20.9968,13.4541 C20.7748,13.4471 20.5628,13.4331 20.3428,13.4251 C19.9528,13.4091 19.5598,13.3951 19.1818,13.3731 C18.9318,13.3571 18.6938,13.3361 18.4488,13.3181 C18.1158,13.2941 17.7758,13.2721 17.4528,13.2421 C17.2018,13.2201 16.9658,13.1901 16.7208,13.1651 C16.4178,13.1341 16.1088,13.1041 15.8168,13.0681 C15.5668,13.0381 15.3298,13.0021 15.0868,12.9681 C14.8168,12.9311 14.5388,12.8961 14.2778,12.8551 C14.0298,12.8171 13.7978,12.7731 13.5588,12.7321 C13.3178,12.6901 13.0708,12.6511 12.8398,12.6071 C12.6078,12.5631 12.3928,12.5151 12.1688,12.4691 C11.9468,12.4221 11.7188,12.3781 11.5058,12.3291 C11.2898,12.2801 11.0908,12.2271 10.8838,12.1761 C10.6838,12.1261 10.4758,12.0781 10.2848,12.0261 C10.0818,11.9721 9.8968,11.9141 9.7038,11.8571 C9.5278,11.8061 9.3448,11.7551 9.1778,11.7021 C8.9928,11.6431 8.8268,11.5831 8.6538,11.5221 C8.4988,11.4691 8.3358,11.4161 8.1908,11.3611 C8.0288,11.3021 7.8878,11.2391 7.7378,11.1791 C7.5998,11.1221 7.4528,11.0651 7.3248,11.0091 C7.1908,10.9481 7.0738,10.8881 6.9498,10.8271 C6.8288,10.7671 6.6988,10.7091 6.5888,10.6481 C6.4788,10.5891 6.3868,10.5291 6.2868,10.4691 C6.1858,10.4081 6.0768,10.3471 5.9868,10.2871 C5.8998,10.2271 5.8318,10.1691 5.7558,10.1101 C5.6768,10.0491 5.5908,9.9871 5.5248,9.9271 C5.4618,9.8701 5.4178,9.8131 5.3658,9.7581 C5.3098,9.6961 5.2468,9.6341 5.2028,9.5731 C5.1648,9.5191 5.1458,9.4671 5.1178,9.4131 C5.0858,9.3511 5.0468,9.2891 5.0298,9.2291 L5.0018,9.0201 C5.1408,7.2271 12.4798,4.0001 22.8958,4.0001 L22.8958,4.0001 Z M45.2548,26.2571 C45.0418,25.1071 43.7168,23.8891 41.0178,22.3471 L42.7338,9.5951 L42.7338,9.5911 L42.7338,9.5901 L42.7848,9.2001 C42.7908,9.1571 42.7938,9.1141 42.7938,9.0711 C42.7938,4.9041 32.3078,2.0001 22.8958,2.0001 C13.4848,2.0001 2.9998,4.9041 2.9998,9.0711 C2.9998,9.1151 3.0028,9.1591 3.0088,9.2031 L3.0608,9.5931 L3.0608,9.5951 L7.2898,41.0091 C7.4208,44.6851 16.9028,46.0571 22.8958,46.0571 C26.2108,46.0571 29.5338,45.7111 32.2528,45.0821 C33.3478,44.8301 34.3308,44.5331 35.1748,44.2001 C37.3408,43.3451 38.4598,42.2711 38.5038,41.0091 L40.2448,28.0801 C41.1968,28.2821 42.0618,28.4051 42.7808,28.4051 C43.7498,28.4051 44.4748,28.2001 44.8668,27.7321 C45.2168,27.3161 45.3548,26.7921 45.2548,26.2571 L45.2548,26.2571 Z" id="AWS-Amazon-Simple-Storage_Bucket_Resource-Icon_light-bg" fill="#7AA116"></path>
    </g>
</svg>`, $i = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Storage/Res_Amazon-Elastic-Block-Store_Volume_48</title>
    <g id="Icon-Resource/Storage/Res_Amazon-Elastic-Block-Store_Volume_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M13.4185,4 L33.8805,4 L38.2965,9.873 L9.0035,9.873 L13.4185,4 Z M7.0005,11.873 L40.2995,11.873 C40.6785,11.873 41.0245,11.659 41.1935,11.319 C41.3635,10.98 41.3265,10.575 41.0985,10.272 L35.1785,2.399 C34.9895,2.147 34.6935,2 34.3795,2 L12.9195,2 C12.6055,2 12.3095,2.147 12.1205,2.399 L6.2015,10.272 C5.9735,10.575 5.9365,10.98 6.1065,11.319 C6.2745,11.659 6.6215,11.873 7.0005,11.873 L7.0005,11.873 Z M8.0605,43.985 L39.2995,43.985 L39.2995,15.371 L8.0605,15.371 L8.0605,43.985 Z M40.2995,13.371 L7.0605,13.371 C6.5075,13.371 6.0605,13.818 6.0605,14.371 L6.0605,44.985 C6.0605,45.538 6.5075,45.985 7.0605,45.985 L40.2995,45.985 C40.8525,45.985 41.2995,45.538 41.2995,44.985 L41.2995,14.371 C41.2995,13.818 40.8525,13.371 40.2995,13.371 L40.2995,13.371 Z" id="AWS-Amazon-Elastic-Block-Store_Volume_Resource-Icon_light-bg" fill="#7AA116"></path>
    </g>
</svg>`, oA = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Storage/Res_Amazon-Simple-Storage-Service-Glacier_Vault_48</title>
    <g id="Icon-Resource/Storage/Res_Amazon-Simple-Storage-Service-Glacier_Vault_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M26.3723,4 L34.2783,4 L38.4503,10.748 L26.3723,10.748 L26.3723,4 Z M25.3723,12.748 L40.2443,12.748 C40.6063,12.748 40.9413,12.552 41.1173,12.235 C41.2943,11.918 41.2853,11.53 41.0953,11.223 L35.6863,2.475 C35.5043,2.18 35.1833,2 34.8363,2 L25.3723,2 C24.8193,2 24.3723,2.447 24.3723,3 L24.3723,11.748 C24.3723,12.301 24.8193,12.748 25.3723,12.748 L25.3723,12.748 Z M20.8723,10.748 L8.7943,10.748 L12.9663,4 L20.8723,4 L20.8723,10.748 Z M21.8723,2 L12.4083,2 C12.0613,2 11.7403,2.18 11.5583,2.475 L6.1493,11.223 C5.9593,11.53 5.9503,11.918 6.1273,12.235 C6.3033,12.552 6.6383,12.748 7.0003,12.748 L21.8723,12.748 C22.4253,12.748 22.8723,12.301 22.8723,11.748 L22.8723,3 C22.8723,2.447 22.4253,2 21.8723,2 L21.8723,2 Z M26.3723,43.992 L39.2443,43.992 L39.2443,16.248 L26.3723,16.248 L26.3723,43.992 Z M40.2443,14.248 L25.3723,14.248 C24.8193,14.248 24.3723,14.695 24.3723,15.248 L24.3723,44.992 C24.3723,45.545 24.8193,45.992 25.3723,45.992 L40.2443,45.992 C40.7973,45.992 41.2443,45.545 41.2443,44.992 L41.2443,15.248 C41.2443,14.695 40.7973,14.248 40.2443,14.248 L40.2443,14.248 Z M8.0003,43.992 L20.8723,43.992 L20.8723,16.248 L8.0003,16.248 L8.0003,43.992 Z M21.8723,14.248 L7.0003,14.248 C6.4473,14.248 6.0003,14.695 6.0003,15.248 L6.0003,44.992 C6.0003,45.545 6.4473,45.992 7.0003,45.992 L21.8723,45.992 C22.4253,45.992 22.8723,45.545 22.8723,44.992 L22.8723,15.248 C22.8723,14.695 22.4253,14.248 21.8723,14.248 L21.8723,14.248 Z" id="AWS-Amazon-S3-Glacier_Vault_Resource-Icon_light-bg" fill="#7AA116"></path>
    </g>
</svg>`, lA = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Containers/Res_Amazon-Elastic-Kubernetes-Service_EKS-on-Outposts_48</title>
    <g id="Icon-Resource/Containers/Res_Amazon-Elastic-Kubernetes-Service_EKS-on-Outposts_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M4,33.4387227 L21.017,43.8377227 L27,40.4197227 L27,36.9997227 C25.773,36.9997227 24.423,36.7427227 23.434,35.8677227 L23.447,35.8947227 L21.447,36.8947227 C21.14,37.0467227 20.778,37.0327227 20.485,36.8567227 L10.485,30.8567227 C10.185,30.6767227 10,30.3507227 10,29.9997227 L10,16.9997227 C10,16.6547227 10.178,16.3347227 10.47,16.1517227 L18,11.4457227 L18,4.8037227 L4,13.5537227 L4,33.4387227 Z M24,31.9997227 C24,33.5577227 24.363,34.9997227 27,34.9997227 L27,31.9997227 C27,31.4477227 27.447,30.9997227 28,30.9997227 L40,30.9997227 C40.553,30.9997227 41,31.4477227 41,31.9997227 L41,34.9997227 C43.131,34.9997227 44,34.4197227 44,32.9997227 C44,30.1767227 41.496,30.0057227 40.994,29.9997227 C40.446,29.9937227 40,29.5477227 40,28.9997227 C39.999,28.9537227 39.95,27.5927227 38.553,26.8947227 C37.235,26.2337227 35.72,27.6957227 35.704,27.7097227 C35.417,27.9927227 34.986,28.0767227 34.615,27.9197227 C34.243,27.7647227 34,27.4027227 34,26.9997227 C34,25.3457227 32.654,23.9997227 31,23.9997227 C29.346,23.9997227 28,25.3457227 28,26.9997227 L28,27.9997227 C28,28.4587227 27.687,28.8587227 27.242,28.9697227 C27.213,28.9777227 24,29.8237227 24,31.9997227 L24,31.9997227 Z M33,16.9997227 L33,22.4317227 C34.242,22.9777227 35.228,24.0037227 35.697,25.2857227 C36.564,24.8287227 37.747,24.4837227 39,24.9217227 L39,13.5717227 L24,4.7487227 L24,11.4117227 L32.485,16.1257227 C32.803,16.3017227 33,16.6367227 33,16.9997227 L33,16.9997227 Z M39,32.9997227 L29,32.9997227 L29,43.9997227 L33,43.9997227 L33,41.9997227 L35,41.9997227 L35,43.9997227 L39,43.9997227 L39,32.9997227 Z M2,33.9997227 L2,12.9997227 C2,12.6547227 2.178,12.3347227 2.47,12.1517227 L18.47,2.1517227 C18.778,1.9597227 19.168,1.9487227 19.484,2.1257227 C19.803,2.3017227 20,2.6357227 20,2.9997227 L20,11.9997227 C20,12.3447227 19.822,12.6647227 19.53,12.8477227 L12,17.5537227 L12,29.4337227 L21.044,34.8597227 L22.345,34.2097227 C22.129,33.6027227 22,32.8787227 22,31.9997227 C22,30.8187227 22.459,29.8957227 23.088,29.1797227 L19,23.9997227 L19,29.9997227 L17,29.9997227 L17,16.9997227 L19,16.9997227 L19,22.2407227 L23.463,16.9997227 L25.708,16.9997227 L20.65,23.3397227 L24.527,27.9917227 C25.065,27.6637227 25.592,27.4297227 26,27.2747227 L26,26.9997227 C26,24.2427227 28.243,21.9997227 31,21.9997227 L31,17.5877227 L22.515,12.8737227 C22.197,12.6977227 22,12.3627227 22,11.9997227 L22,2.9997227 C22,2.6407227 22.192,2.3097227 22.504,2.1317227 C22.815,1.9537227 23.199,1.9567227 23.507,2.1377227 L40.507,12.1377227 C40.812,12.3177227 41,12.6457227 41,12.9997227 L41,26.3507227 C41.479,26.9497227 41.736,27.5797227 41.863,28.0767227 C43.635,28.3777227 46,29.6367227 46,32.9997227 C46,34.4937227 45.351,36.9997227 41,36.9997227 L41,44.9997227 C41,45.5517227 40.553,45.9997227 40,45.9997227 L28,45.9997227 C27.447,45.9997227 27,45.5517227 27,44.9997227 L27,42.7227227 L21.496,45.8677227 C21.342,45.9557227 21.171,45.9997227 21,45.9997227 C20.819,45.9997227 20.639,45.9507227 20.479,45.8537227 L2.479,34.8537227 C2.182,34.6707227 2,34.3477227 2,33.9997227 L2,33.9997227 Z M35,40.9997227 L37,40.9997227 L37,38.9997227 L35,38.9997227 L35,40.9997227 Z M31,40.9997227 L33,40.9997227 L33,38.9997227 L31,38.9997227 L31,40.9997227 Z M31,36.9997227 L33,36.9997227 L33,34.9997227 L31,34.9997227 L31,36.9997227 Z M35,36.9997227 L37,36.9997227 L37,34.9997227 L35,34.9997227 L35,36.9997227 Z" id="Fill-1" fill="#ED7100"></path>
    </g>
</svg>`, LA = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Containers/Res_Amazon-Elastic-Container-Service_Container-2_48</title>
    <g id="Icon-Resource/Containers/Res_Amazon-Elastic-Container-Service_Container-2_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M18.863,29.233 L29.102,29.233 L29.102,18.994 L18.863,18.994 L18.863,29.233 Z M17.737,31.014 L17.737,32.857 L19.737,32.857 L19.737,31.234 L21.234,31.234 L21.234,32.857 L23.234,32.857 L23.234,31.234 L24.731,31.234 L24.731,32.857 L26.731,32.857 L26.731,31.234 L28.228,31.234 L28.228,32.857 L30.228,32.857 L30.228,31.014 C30.502,30.861 30.728,30.635 30.882,30.36 L32.725,30.36 L32.725,28.36 L31.102,28.36 L31.102,26.863 L32.725,26.863 L32.725,24.863 L31.102,24.863 L31.102,23.365 L32.725,23.365 L32.725,21.365 L31.102,21.365 L31.102,19.868 L32.725,19.868 L32.725,17.868 L30.882,17.868 C30.729,17.594 30.502,17.367 30.228,17.214 L30.228,15.371 L28.228,15.371 L28.228,16.994 L26.731,16.994 L26.731,15.371 L24.731,15.371 L24.731,16.994 L23.234,16.994 L23.234,15.371 L21.234,15.371 L21.234,16.994 L19.737,16.994 L19.737,15.371 L17.737,15.371 L17.737,17.214 C17.461,17.367 17.236,17.594 17.082,17.868 L15.24,17.868 L15.24,19.868 L16.863,19.868 L16.863,21.365 L15.24,21.365 L15.24,23.365 L16.863,23.365 L16.863,24.863 L15.24,24.863 L15.24,26.863 L16.863,26.863 L16.863,28.36 L15.24,28.36 L15.24,30.36 L17.082,30.36 C17.236,30.635 17.461,30.861 17.737,31.014 L17.737,31.014 Z M39.593,33.731 L41.593,33.731 L41.593,14.498 L39.593,14.498 L39.593,33.731 Z M34.347,33.731 L36.347,33.731 L36.347,14.498 L34.347,14.498 L34.347,33.731 Z M11.616,33.731 L13.616,33.731 L13.616,14.498 L11.616,14.498 L11.616,33.731 Z M6.371,33.731 L8.371,33.731 L8.371,14.498 L6.371,14.498 L6.371,33.731 Z M4,36.228 L43.964,36.228 L43.964,12 L4,12 L4,36.228 Z M44.964,10 L3,10 C2.448,10 2,10.447 2,11 L2,37.228 C2,37.78 2.448,38.228 3,38.228 L44.964,38.228 C45.517,38.228 45.964,37.78 45.964,37.228 L45.964,11 C45.964,10.447 45.517,10 44.964,10 L44.964,10 Z" id="Amazon-Elastic-Container-Service-Container-2_Resource-Icon_light-bg" fill="#ED7100"></path>
    </g>
</svg>`, aA = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Containers/Res_Amazon-Elastic-Container-Registry_Image_48</title>
    <g id="Icon-Resource/Containers/Res_Amazon-Elastic-Container-Registry_Image_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M19.9998,14.9998 C21.6538,14.9998 22.9998,16.3458 22.9998,17.9998 C22.9998,19.6538 21.6538,20.9998 19.9998,20.9998 C18.3458,20.9998 16.9998,19.6538 16.9998,17.9998 C16.9998,16.3458 18.3458,14.9998 19.9998,14.9998 L19.9998,14.9998 Z M19.9998,22.9998 C22.7568,22.9998 24.9998,20.7568 24.9998,17.9998 C24.9998,15.2428 22.7568,12.9998 19.9998,12.9998 C17.2428,12.9998 14.9998,15.2428 14.9998,17.9998 C14.9998,20.7568 17.2428,22.9998 19.9998,22.9998 L19.9998,22.9998 Z M3.9998,43.9998 L3.9998,34.4138 L11.9998,26.4138 L27.2928,41.7068 L28.7068,40.2928 L20.9138,32.4998 L31.9998,21.4138 L43.9998,33.4138 L43.9998,43.9998 L3.9998,43.9998 Z M43.9998,3.9998 L43.9998,30.5858 L32.7068,19.2928 C32.3158,18.9018 31.6838,18.9018 31.2928,19.2928 L19.4998,31.0858 L12.7068,24.2928 C12.3158,23.9018 11.6838,23.9018 11.2928,24.2928 L3.9998,31.5858 L3.9998,3.9998 L43.9998,3.9998 Z M44.9998,1.9998 L2.9998,1.9998 C2.4468,1.9998 1.9998,2.4468 1.9998,2.9998 L1.9998,44.9998 C1.9998,45.5528 2.4468,45.9998 2.9998,45.9998 L44.9998,45.9998 C45.5528,45.9998 45.9998,45.5528 45.9998,44.9998 L45.9998,2.9998 C45.9998,2.4468 45.5528,1.9998 44.9998,1.9998 L44.9998,1.9998 Z" id="Amazon-Elastic-Container-Registry_Image_Resource-Icon_light-bg" fill="#ED7100"></path>
    </g>
</svg>`, CA = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Containers/Res_Amazon-Elastic-Container-Service_Task_48</title>
    <g id="Icon-Resource/Containers/Res_Amazon-Elastic-Container-Service_Task_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M20.25,36.375 L36,36.375 L36,34.375 L20.25,34.375 L20.25,36.375 Z M20.25,24.125 L36,24.125 L36,22.125 L20.25,22.125 L20.25,24.125 Z M20.25,11.875 L36,11.875 L36,9.875 L20.25,9.875 L20.25,11.875 Z M13.375,37 L16.625,37 L16.625,33.75 L13.375,33.75 L13.375,37 Z M12.375,39 L17.625,39 C18.178,39 18.625,38.553 18.625,38 L18.625,32.75 C18.625,32.198 18.178,31.75 17.625,31.75 L12.375,31.75 C11.822,31.75 11.375,32.198 11.375,32.75 L11.375,38 C11.375,38.553 11.822,39 12.375,39 L12.375,39 Z M13.375,24.75 L16.625,24.75 L16.625,21.5 L13.375,21.5 L13.375,24.75 Z M12.375,26.75 L17.625,26.75 C18.178,26.75 18.625,26.303 18.625,25.75 L18.625,20.5 C18.625,19.948 18.178,19.5 17.625,19.5 L12.375,19.5 C11.822,19.5 11.375,19.948 11.375,20.5 L11.375,25.75 C11.375,26.303 11.822,26.75 12.375,26.75 L12.375,26.75 Z M13.375,12.5 L16.625,12.5 L16.625,9.25 L13.375,9.25 L13.375,12.5 Z M12.375,14.5 L17.625,14.5 C18.178,14.5 18.625,14.053 18.625,13.5 L18.625,8.25 C18.625,7.698 18.178,7.25 17.625,7.25 L12.375,7.25 C11.822,7.25 11.375,7.698 11.375,8.25 L11.375,13.5 C11.375,14.053 11.822,14.5 12.375,14.5 L12.375,14.5 Z M9,44 L38.5,44 L38.5,4 L9,4 L9,44 Z M39.5,2 L8,2 C7.447,2 7,2.448 7,3 L7,45 C7,45.553 7.447,46 8,46 L39.5,46 C40.053,46 40.5,45.553 40.5,45 L40.5,3 C40.5,2.448 40.053,2 39.5,2 L39.5,2 Z" id="Amazon-Elastic-Container-Service_Task_Resource-Icon_light-bg" fill="#ED7100"></path>
    </g>
</svg>`, cA = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Containers/Res_Amazon-Elastic-Container-Service_Service_48</title>
    <g id="Icon-Resource/Containers/Res_Amazon-Elastic-Container-Service_Service_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M24.933,38.213 L37.674,38.213 L37.674,36.213 L24.933,36.213 L24.933,38.213 Z M24.933,28.303 L37.674,28.303 L37.674,26.303 L24.933,26.303 L24.933,28.303 Z M24.933,18.393 L37.674,18.393 L37.674,16.393 L24.933,16.393 L24.933,18.393 Z M19.561,38.337 L21.808,38.337 L21.808,36.09 L19.561,36.09 L19.561,38.337 Z M18.561,40.337 L22.808,40.337 C23.361,40.337 23.808,39.89 23.808,39.337 L23.808,35.09 C23.808,34.537 23.361,34.09 22.808,34.09 L18.561,34.09 C18.009,34.09 17.561,34.537 17.561,35.09 L17.561,39.337 C17.561,39.89 18.009,40.337 18.561,40.337 L18.561,40.337 Z M19.561,28.427 L21.808,28.427 L21.808,26.18 L19.561,26.18 L19.561,28.427 Z M18.561,30.427 L22.808,30.427 C23.361,30.427 23.808,29.98 23.808,29.427 L23.808,25.18 C23.808,24.627 23.361,24.18 22.808,24.18 L18.561,24.18 C18.009,24.18 17.561,24.627 17.561,25.18 L17.561,29.427 C17.561,29.98 18.009,30.427 18.561,30.427 L18.561,30.427 Z M19.561,18.517 L21.808,18.517 L21.808,16.27 L19.561,16.27 L19.561,18.517 Z M18.561,20.517 L22.808,20.517 C23.361,20.517 23.808,20.07 23.808,19.517 L23.808,15.27 C23.808,14.717 23.361,14.27 22.808,14.27 L18.561,14.27 C18.009,14.27 17.561,14.717 17.561,15.27 L17.561,19.517 C17.561,20.07 18.009,20.517 18.561,20.517 L18.561,20.517 Z M16.023,44 L39.506,44 L39.506,12.022 L16.023,12.022 L16.023,44 Z M14.022,11.023 L14.022,39.753 L11.775,39.753 L11.775,7.776 L35.259,7.776 L35.259,10.023 L15.022,10.023 C14.469,10.023 14.022,10.47 14.022,11.023 L14.022,11.023 Z M9.775,6.776 L9.775,35.978 L8,35.978 L8,4 L31.483,4 L31.483,5.776 L10.775,5.776 C10.222,5.776 9.775,6.223 9.775,6.776 L9.775,6.776 Z M40.506,10.023 L37.259,10.023 L37.259,6.776 C37.259,6.223 36.811,5.776 36.259,5.776 L33.483,5.776 L33.483,3 C33.483,2.448 33.036,2 32.483,2 L7,2 C6.447,2 6,2.448 6,3 L6,36.978 C6,37.531 6.447,37.978 7,37.978 L9.775,37.978 L9.775,40.753 C9.775,41.306 10.222,41.753 10.775,41.753 L14.022,41.753 L14.022,45 C14.022,45.553 14.469,46 15.022,46 L40.506,46 C41.058,46 41.506,45.553 41.506,45 L41.506,11.023 C41.506,10.47 41.058,10.023 40.506,10.023 L40.506,10.023 Z" id="Amazon-Elastic-Container-Service_Service_Resource-Icon_light-bg" fill="#ED7100"></path>
    </g>
</svg>`, uA = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Containers/Res_Amazon-Elastic-Container-Service_Container-1_48</title>
    <g id="Icon-Resource/Containers/Res_Amazon-Elastic-Container-Service_Container-1_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M38.725,33.7354 L40.725,33.7354 L40.725,14.4974 L38.725,14.4974 L38.725,33.7354 Z M33.479,33.7354 L35.479,33.7354 L35.479,14.4974 L33.479,14.4974 L33.479,33.7354 Z M28.232,33.7354 L30.232,33.7354 L30.232,14.4974 L28.232,14.4974 L28.232,33.7354 Z M22.986,33.7354 L24.986,33.7354 L24.986,14.4974 L22.986,14.4974 L22.986,33.7354 Z M17.739,33.7354 L19.739,33.7354 L19.739,14.4974 L17.739,14.4974 L17.739,33.7354 Z M12.493,33.7354 L14.493,33.7354 L14.493,14.4974 L12.493,14.4974 L12.493,33.7354 Z M7.246,33.7354 L9.246,33.7354 L9.246,14.4974 L7.246,14.4974 L7.246,33.7354 Z M3.999,36.2324 L43.972,36.2324 L43.972,12.0004 L3.999,12.0004 L3.999,36.2324 Z M44.972,9.9994 L3,9.9994 C2.447,9.9994 2,10.4474 2,10.9994 L2,37.2324 C2,37.7844 2.447,38.2324 3,38.2324 L44.972,38.2324 C45.525,38.2324 45.972,37.7844 45.972,37.2324 L45.972,10.9994 C45.972,10.4474 45.525,9.9994 44.972,9.9994 L44.972,9.9994 Z" id="Amazon-Elastic-Container-Service-Container-1_Resource-Icon_light-bg" fill="#ED7100"></path>
    </g>
</svg>`, hA = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Containers/Res_Amazon-Elastic-Container-Registry_Registry_48</title>
    <g id="Icon-Resource/Containers/Res_Amazon-Elastic-Container-Registry_Registry_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M35.207,37.954 L37.207,37.954 L37.207,34.459 L35.207,34.459 L35.207,37.954 Z M31.711,37.954 L33.711,37.954 L33.711,34.459 L31.711,34.459 L31.711,37.954 Z M28.216,37.954 L30.216,37.954 L30.216,34.459 L28.216,34.459 L28.216,37.954 Z M26.721,39.576 L38.702,39.576 L38.702,32.837 L26.721,32.837 L26.721,39.576 Z M39.702,30.837 L25.72,30.837 C25.168,30.837 24.72,31.284 24.72,31.837 L24.72,40.576 C24.72,41.129 25.168,41.576 25.72,41.576 L39.702,41.576 C40.255,41.576 40.702,41.129 40.702,40.576 L40.702,31.837 C40.702,31.284 40.255,30.837 39.702,30.837 L39.702,30.837 Z M35.207,25.721 L37.207,25.721 L37.207,22.225 L35.207,22.225 L35.207,25.721 Z M31.711,25.721 L33.711,25.721 L33.711,22.225 L31.711,22.225 L31.711,25.721 Z M28.216,25.721 L30.216,25.721 L30.216,22.225 L28.216,22.225 L28.216,25.721 Z M26.721,27.342 L38.702,27.342 L38.702,20.604 L26.721,20.604 L26.721,27.342 Z M39.702,18.604 L25.72,18.604 C25.168,18.604 24.72,19.051 24.72,19.604 L24.72,28.342 C24.72,28.895 25.168,29.342 25.72,29.342 L39.702,29.342 C40.255,29.342 40.702,28.895 40.702,28.342 L40.702,19.604 C40.702,19.051 40.255,18.604 39.702,18.604 L39.702,18.604 Z M35.207,13.486 L37.207,13.486 L37.207,9.991 L35.207,9.991 L35.207,13.486 Z M31.711,13.486 L33.711,13.486 L33.711,9.991 L31.711,9.991 L31.711,13.486 Z M28.216,13.486 L30.216,13.486 L30.216,9.991 L28.216,9.991 L28.216,13.486 Z M26.721,15.108 L38.702,15.108 L38.702,8.369 L26.721,8.369 L26.721,15.108 Z M39.702,6.369 L25.72,6.369 C25.168,6.369 24.72,6.817 24.72,7.369 L24.72,16.108 C24.72,16.661 25.168,17.108 25.72,17.108 L39.702,17.108 C40.255,17.108 40.702,16.661 40.702,16.108 L40.702,7.369 C40.702,6.817 40.255,6.369 39.702,6.369 L39.702,6.369 Z M17.729,37.954 L19.729,37.954 L19.729,34.459 L17.729,34.459 L17.729,37.954 Z M14.234,37.954 L16.234,37.954 L16.234,34.459 L14.234,34.459 L14.234,37.954 Z M10.738,37.954 L12.738,37.954 L12.738,34.459 L10.738,34.459 L10.738,37.954 Z M9.243,39.576 L21.224,39.576 L21.224,32.837 L9.243,32.837 L9.243,39.576 Z M22.224,30.837 L8.243,30.837 C7.69,30.837 7.243,31.284 7.243,31.837 L7.243,40.576 C7.243,41.129 7.69,41.576 8.243,41.576 L22.224,41.576 C22.777,41.576 23.224,41.129 23.224,40.576 L23.224,31.837 C23.224,31.284 22.777,30.837 22.224,30.837 L22.224,30.837 Z M17.729,25.721 L19.729,25.721 L19.729,22.225 L17.729,22.225 L17.729,25.721 Z M14.234,25.721 L16.234,25.721 L16.234,22.225 L14.234,22.225 L14.234,25.721 Z M10.738,25.721 L12.738,25.721 L12.738,22.225 L10.738,22.225 L10.738,25.721 Z M9.243,27.342 L21.224,27.342 L21.224,20.604 L9.243,20.604 L9.243,27.342 Z M22.224,18.604 L8.243,18.604 C7.69,18.604 7.243,19.051 7.243,19.604 L7.243,28.342 C7.243,28.895 7.69,29.342 8.243,29.342 L22.224,29.342 C22.777,29.342 23.224,28.895 23.224,28.342 L23.224,19.604 C23.224,19.051 22.777,18.604 22.224,18.604 L22.224,18.604 Z M17.729,13.486 L19.729,13.486 L19.729,9.991 L17.729,9.991 L17.729,13.486 Z M14.234,13.486 L16.234,13.486 L16.234,9.991 L14.234,9.991 L14.234,13.486 Z M10.738,13.486 L12.738,13.486 L12.738,9.991 L10.738,9.991 L10.738,13.486 Z M9.243,15.108 L21.224,15.108 L21.224,8.369 L9.243,8.369 L9.243,15.108 Z M22.224,6.369 L8.243,6.369 C7.69,6.369 7.243,6.817 7.243,7.369 L7.243,16.108 C7.243,16.661 7.69,17.108 8.243,17.108 L22.224,17.108 C22.777,17.108 23.224,16.661 23.224,16.108 L23.224,7.369 C23.224,6.817 22.777,6.369 22.224,6.369 L22.224,6.369 Z M43.945,39.497 C43.945,41.95 41.95,43.945 39.497,43.945 L8.448,43.945 C5.995,43.945 4,41.95 4,39.497 L4,8.448 C4,5.995 5.995,4 8.448,4 L39.497,4 C41.95,4 43.945,5.995 43.945,8.448 L43.945,39.497 Z M39.497,2 L8.448,2 C4.892,2 2,4.893 2,8.448 L2,39.497 C2,43.053 4.892,45.945 8.448,45.945 L39.497,45.945 C43.053,45.945 45.945,43.053 45.945,39.497 L45.945,8.448 C45.945,4.893 43.053,2 39.497,2 L39.497,2 Z" id="Amazon-Elastic-Container-Registry-Registry_Resource-Icon_light-bg" fill="#ED7100"></path>
    </g>
</svg>`, Vi = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Containers/Res_Amazon-Elastic-Container-Service_Container-3_48</title>
    <g id="Icon-Resource/Containers/Res_Amazon-Elastic-Container-Service_Container-3_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M26.112,31.6134 L28.861,31.6134 L28.861,29.7384 L26.112,29.7384 L26.112,31.6134 Z M17.117,23.9904 L30.858,23.9904 L30.858,16.3714 L17.117,16.3714 L17.117,23.9904 Z M17.993,31.8624 L29.984,31.8624 L29.984,29.4894 L17.993,29.4894 L17.993,31.8624 Z M16.117,25.9914 L22.989,25.9914 L22.989,27.4894 L16.992,27.4894 C16.44,27.4894 15.992,27.9364 15.992,28.4894 L15.992,32.8624 C15.992,33.4144 16.44,33.8624 16.992,33.8624 L30.984,33.8624 C31.536,33.8624 31.984,33.4144 31.984,32.8624 L31.984,28.4894 C31.984,27.9364 31.536,27.4894 30.984,27.4894 L24.989,27.4894 L24.989,25.9914 L31.859,25.9914 C32.411,25.9914 32.859,25.5434 32.859,24.9914 L32.859,15.3714 C32.859,14.8194 32.411,14.3714 31.859,14.3714 L16.117,14.3714 C15.565,14.3714 15.117,14.8194 15.117,15.3714 L15.117,24.9914 C15.117,25.5434 15.565,25.9914 16.117,25.9914 L16.117,25.9914 Z M39.603,33.7364 L41.603,33.7364 L41.603,14.4984 L39.603,14.4984 L39.603,33.7364 Z M34.357,33.7364 L36.357,33.7364 L36.357,14.4984 L34.357,14.4984 L34.357,33.7364 Z M11.62,33.7364 L13.62,33.7364 L13.62,14.4984 L11.62,14.4984 L11.62,33.7364 Z M6.373,33.7364 L8.373,33.7364 L8.373,14.4984 L6.373,14.4984 L6.373,33.7364 Z M4,36.2344 L43.976,36.2344 L43.976,12.0004 L4,12.0004 L4,36.2344 Z M44.976,9.9994 L3,9.9994 C2.448,9.9994 2,10.4474 2,10.9994 L2,37.2344 C2,37.7864 2.448,38.2344 3,38.2344 L44.976,38.2344 C45.529,38.2344 45.976,37.7864 45.976,37.2344 L45.976,10.9994 C45.976,10.4474 45.529,9.9994 44.976,9.9994 L44.976,9.9994 Z" id="Amazon-Elastic-Container-Service-Container-3_Resource-Icon_light-bg" fill="#ED7100"></path>
    </g>
</svg>`, dA = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Containers/Res_Amazon-Elastic-Container-Service_CopiIoT-CLI_48</title>
    <g id="Icon-Resource/Containers/Res_Amazon-Elastic-Container-Service_CopiIoT-CLI_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M21.53,28.0406411 L9.673,17.2606411 L8.327,18.7406411 L18.469,27.9606411 L8.367,36.2266411 L9.633,37.7746411 L21.53,28.0406411 Z M19,37.0006411 L35,37.0006411 L35,35.0006411 L19,35.0006411 L19,37.0006411 Z M38,18.0006411 C38,17.6376411 37.802,17.3026411 37.485,17.1266411 L29,12.4126411 L29,5.66164113 L44,13.6026411 L44,31.1966411 L38,27.4466411 L38,18.0006411 Z M45.484,33.8746411 C45.802,33.6986411 46,33.3646411 46,33.0006411 L46,13.0006411 C46,12.6296411 45.795,12.2906411 45.467,12.1166411 L28.467,3.11664113 C28.157,2.95164113 27.783,2.96264113 27.484,3.14364113 C27.183,3.32464113 27,3.64964113 27,4.00064113 L27,13.0006411 C27,13.3636411 27.197,13.6986411 27.514,13.8746411 L36,18.5886411 L36,28.0006411 C36,28.3456411 36.177,28.6656411 36.469,28.8486411 L44.469,33.8486411 C44.632,33.9496411 44.815,34.0006411 45,34.0006411 C45.167,34.0006411 45.334,33.9586411 45.484,33.8746411 L45.484,33.8746411 Z M14.023,6.00064113 L23,6.00064113 L23,4.00064113 L14.023,4.00064113 L14.023,6.00064113 Z M44,44.0006411 L4,44.0006411 C2.912,43.9916411 2,43.0756411 2,42.0006411 L2,6.00064113 C2,4.91664113 2.916,4.00064113 4,4.00064113 L10,4.00064113 L10,6.00064113 L4,6.00064113 L4,42.0006411 L44,42.0006411 L44,38.0006411 L46,38.0006411 L46,42.0006411 C46,43.0846411 45.084,44.0006411 44,44.0006411 L44,44.0006411 Z" id="Fill-1" fill="#ED7100"></path>
    </g>
</svg>`, gA = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Containers/Res_Amazon-Elastic-Container-Service_ECS-Service-Connect_48</title>
    <g id="Icon-Resource/Containers/Res_Amazon-Elastic-Container-Service_ECS-Service-Connect_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M44,37.5 C44,38.327 43.327,39 42.5,39 C41.673,39 41,38.327 41,37.5 C41,36.673 41.673,36 42.5,36 C43.327,36 44,36.673 44,37.5 L44,37.5 Z M42.5,16.001 C43.327,16.001 44,16.674 44,17.501 C44,18.328 43.327,19.001 42.5,19.001 C41.673,19.001 41,18.328 41,17.501 C41,16.674 41.673,16.001 42.5,16.001 L42.5,16.001 Z M10,42 L32,42 L32,12 L10,12 L10,42 Z M8,11 L8,36 L4,36 L4,6 L26,6 L26,10 L9,10 C8.447,10 8,10.448 8,11 L8,11 Z M42.5,26.001 C43.327,26.001 44,26.674 44,27.501 C44,28.328 43.327,29.001 42.5,29.001 C41.673,29.001 41,28.328 41,27.501 C41,26.674 41.673,26.001 42.5,26.001 L42.5,26.001 Z M42.5,31.001 C44.43,31.001 46,29.431 46,27.501 C46,25.571 44.43,24.001 42.5,24.001 C41.109,24.001 39.915,24.823 39.351,26.001 L36.204,26.001 L40.923,20.608 C41.399,20.851 41.93,21.001 42.5,21.001 C44.43,21.001 46,19.431 46,17.501 C46,15.571 44.43,14.001 42.5,14.001 C40.57,14.001 39,15.571 39,17.501 C39,18.131 39.181,18.715 39.474,19.226 L34,25.482 L34,11 C34,10.448 33.553,10 33,10 L28,10 L28,5 C28,4.448 27.553,4 27,4 L3,4 C2.447,4 2,4.448 2,5 L2,37 C2,37.552 2.447,38 3,38 L8,38 L8,43 C8,43.552 8.447,44 9,44 L33,44 C33.553,44 34,43.552 34,43 L34,28.628 L39.508,35.711 C39.193,36.236 39,36.844 39,37.5 C39,39.43 40.57,41 42.5,41 C44.43,41 46,39.43 46,37.5 C46,35.57 44.43,34 42.5,34 C41.957,34 41.448,34.135 40.989,34.357 L36.045,28.001 L39.051,28.001 C39.296,29.693 40.742,31.001 42.5,31.001 L42.5,31.001 Z M20,37 L30,37 L30,35 L20,35 L20,37 Z M20,28 L30,28 L30,26 L20,26 L20,28 Z M20,19 L30,19 L30,17 L20,17 L20,19 Z M14,37 L16,37 L16,35 L14,35 L14,37 Z M13,39 L17,39 C17.553,39 18,38.552 18,38 L18,34 C18,33.448 17.553,33 17,33 L13,33 C12.447,33 12,33.448 12,34 L12,38 C12,38.552 12.447,39 13,39 L13,39 Z M14,28 L16,28 L16,26 L14,26 L14,28 Z M13,30 L17,30 C17.553,30 18,29.552 18,29 L18,25 C18,24.448 17.553,24 17,24 L13,24 C12.447,24 12,24.448 12,25 L12,29 C12,29.552 12.447,30 13,30 L13,30 Z M14,19 L16,19 L16,17 L14,17 L14,19 Z M13,21 L17,21 C17.553,21 18,20.552 18,20 L18,16 C18,15.448 17.553,15 17,15 L13,15 C12.447,15 12,15.448 12,16 L12,20 C12,20.552 12.447,21 13,21 L13,21 Z" id="Fill-1" fill="#ED7100"></path>
    </g>
</svg>`, fA = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Compute/Res_Amazon-EC2_AWS-Microservice-Extractor-for-.NET_48</title>
    <g id="Icon-Resource/Compute/Res_Amazon-EC2_AWS-Microservice-Extractor-for-.NET_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M24,4.1127 L37.621,10.7637 L24,16.7387 L10.379,10.7637 L24,4.1127 Z M8,25.4007 C8.283,25.4007 8.554,25.2797 8.743,25.0697 L13.243,20.0697 L11.757,18.7317 L9,21.7947 L9,12.3437 L23,18.4847 L23,28.8477 L20.243,25.7837 L18.757,27.1217 L23.257,32.1217 C23.446,32.3327 23.717,32.4527 24,32.4527 C24.283,32.4527 24.554,32.3327 24.743,32.1217 L29.243,27.1217 L27.757,25.7837 L25,28.8477 L25,18.4847 L39,12.3437 L39,21.7947 L36.243,18.7317 L34.757,20.0697 L39.257,25.0697 C39.446,25.2797 39.717,25.4007 40,25.4007 C40.283,25.4007 40.554,25.2797 40.743,25.0697 L45.243,20.0697 L43.757,18.7317 L41,21.7947 L41,10.8127 C41,10.4307 40.782,10.0817 40.438,9.9147 L24.438,2.1017 C24.163,1.9657 23.837,1.9657 23.562,2.1017 L7.562,9.9147 C7.218,10.0817 7,10.4307 7,10.8127 L7,21.7947 L4.243,18.7317 L2.757,20.0697 L7.257,25.0697 C7.446,25.2797 7.717,25.4007 8,25.4007 L8,25.4007 Z M40,36.9357 C37.794,36.9357 36,35.1417 36,32.9357 C36,30.7307 37.794,28.9357 40,28.9357 C42.206,28.9357 44,30.7307 44,32.9357 C44,35.1417 42.206,36.9357 40,36.9357 L40,36.9357 Z M24,43.9527 C21.794,43.9527 20,42.1587 20,39.9527 C20,37.7477 21.794,35.9527 24,35.9527 C26.206,35.9527 28,37.7477 28,39.9527 C28,42.1587 26.206,43.9527 24,43.9527 L24,43.9527 Z M8,36.9357 C5.794,36.9357 4,35.1417 4,32.9357 C4,30.7307 5.794,28.9357 8,28.9357 C10.206,28.9357 12,30.7307 12,32.9357 C12,35.1417 10.206,36.9357 8,36.9357 L8,36.9357 Z M40,26.9357 C36.691,26.9357 34,29.6277 34,32.9357 C34,33.4397 34.069,33.9267 34.187,34.3937 L29.012,36.6637 C27.939,35.0337 26.094,33.9527 24,33.9527 C21.906,33.9527 20.061,35.0327 18.988,36.6637 L13.813,34.3937 C13.931,33.9267 14,33.4397 14,32.9357 C14,29.6277 11.309,26.9357 8,26.9357 C4.691,26.9357 2,29.6277 2,32.9357 C2,36.2447 4.691,38.9357 8,38.9357 C10.094,38.9357 11.938,37.8567 13.012,36.2267 L18.186,38.4967 C18.069,38.9637 18,39.4497 18,39.9527 C18,43.2617 20.691,45.9527 24,45.9527 C27.309,45.9527 30,43.2617 30,39.9527 C30,39.4497 29.931,38.9637 29.814,38.4957 L34.988,36.2257 C36.062,37.8557 37.906,38.9357 40,38.9357 C43.309,38.9357 46,36.2447 46,32.9357 C46,29.6277 43.309,26.9357 40,26.9357 L40,26.9357 Z" id="Fill-1" fill="#ED7100"></path>
    </g>
</svg>`, pA = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Compute/Res_Amazon-EC2_AMI_48</title>
    <g id="Icon-Resource/Compute/Res_Amazon-EC2_AMI_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M30.143,37.727 L38.599,37.727 L38.599,26.656 L30.143,26.656 L30.143,37.727 Z M9.229,37.727 L17.686,37.727 L17.686,26.656 L9.229,26.656 L9.229,37.727 Z M19.686,37.727 L28.143,37.727 L28.143,26.656 L19.686,26.656 L19.686,37.727 Z M39.599,24.656 L8.229,24.656 C7.676,24.656 7.229,25.104 7.229,25.656 L7.229,38.727 C7.229,39.279 7.676,39.727 8.229,39.727 L39.599,39.727 C40.151,39.727 40.599,39.279 40.599,38.727 L40.599,25.656 C40.599,25.104 40.151,24.656 39.599,24.656 L39.599,24.656 Z M30.143,19.428 L38.599,19.428 L38.599,10.971 L30.143,10.971 L30.143,19.428 Z M9.229,19.428 L17.686,19.428 L17.686,10.971 L9.229,10.971 L9.229,19.428 Z M19.686,19.428 L28.143,19.428 L28.143,10.971 L19.686,10.971 L19.686,19.428 Z M39.599,8.971 L8.229,8.971 C7.676,8.971 7.229,9.419 7.229,9.971 L7.229,20.428 C7.229,20.98 7.676,21.428 8.229,21.428 L39.599,21.428 C40.151,21.428 40.599,20.98 40.599,20.428 L40.599,9.971 C40.599,9.419 40.151,8.971 39.599,8.971 L39.599,8.971 Z M43.827,39.379 C43.827,41.832 41.832,43.827 39.38,43.827 L8.448,43.827 C5.995,43.827 4,41.832 4,39.379 L4,8.448 C4,5.995 5.995,4 8.448,4 L39.38,4 C41.832,4 43.827,5.995 43.827,8.448 L43.827,39.379 Z M39.38,2 L8.448,2 C4.893,2 2,4.892 2,8.448 L2,39.379 C2,42.934 4.893,45.827 8.448,45.827 L39.38,45.827 C42.935,45.827 45.827,42.934 45.827,39.379 L45.827,8.448 C45.827,4.892 42.935,2 39.38,2 L39.38,2 Z" id="Amazon-Containers-AMI_Resource-Icon_light-bg" fill="#ED7100"></path>
    </g>
</svg>`, mA = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Compute/Res_AWS-Elastic-Beanstalk_Deployment_48</title>
    <g id="Icon-Resource/Compute/Res_AWS-Elastic-Beanstalk_Deployment_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M13.302,5.892 L16.901,9.49 L15.487,10.904 L13.595,9.013 L13.595,19.392 L11.595,19.392 L11.595,9.013 L9.704,10.904 L8.29,9.49 L11.888,5.892 C12.279,5.501 12.911,5.501 13.302,5.892 M12.595,21.191 C7.856,21.191 4,17.334 4,12.595 C4,7.856 7.856,4 12.595,4 C17.334,4 21.191,7.856 21.191,12.595 C21.191,17.334 17.334,21.191 12.595,21.191 M23.191,12.595 C23.191,6.753 18.438,2 12.595,2 C6.753,2 2,6.753 2,12.595 C2,18.438 6.753,23.191 12.595,23.191 C18.438,23.191 23.191,18.438 23.191,12.595 M38.687,22.807 C34.119,27.468 26.783,28.166 22.744,28.1630096 C26.443,25.331 30.238,21.959 33.851,18.277 C37.607,14.444 41.043,10.382 43.9251333,6.397 C43.936,10.511 43.275,18.121 38.687,22.807 M45.784,3.303 C45.783,3.295 45.779,3.288 45.778,3.281 C45.764,3.186 45.74,3.092 45.7,3.003 C45.698,2.999 45.695,2.996 45.693,2.992 C45.684,2.973 45.671,2.959 45.661,2.942 C45.622,2.87 45.576,2.804 45.522,2.745 C45.5,2.722 45.479,2.704 45.455,2.683 C45.402,2.634 45.344,2.592 45.281,2.556 C45.254,2.541 45.231,2.527 45.203,2.514 C45.112,2.472 45.015,2.44 44.912,2.427 C44.373,2.357 31.587,0.888 24.406,8.225 C24.392,8.238 24.382,8.252 24.369,8.265 C24.362,8.272 24.354,8.279 24.347,8.287 C24.204,8.437 24.063,8.587 23.893,8.779 C23.819,8.862 23.747,8.943 23.682,9.025 L23.679,9.028 C23.675,9.032 23.671,9.037 23.668,9.04 L24.449,9.664 L25.22,10.301 C25.409,10.073 25.607,9.852 25.827,9.631 C26.158,9.292 26.507,8.977 26.866,8.678 C26.981,8.583 27.103,8.5 27.219,8.41 C27.47,8.214 27.722,8.02 27.984,7.842 C28.125,7.746 28.274,7.659 28.418,7.567 C28.665,7.411 28.912,7.256 29.165,7.114 C29.319,7.029 29.474,6.95 29.629,6.87 C29.885,6.737 30.141,6.606 30.401,6.487 C30.555,6.415 30.711,6.349 30.866,6.282 C31.136,6.166 31.406,6.055 31.68,5.953 C31.826,5.897 31.974,5.843 32.122,5.79 C32.413,5.688 32.704,5.592 32.996,5.502 C33.126,5.462 33.255,5.423 33.384,5.386 C33.707,5.293 34.03,5.207 34.351,5.129 C34.448,5.106 34.545,5.08 34.642,5.058 C35.017,4.971 35.39,4.893 35.76,4.824 C35.801,4.816 35.842,4.806 35.882,4.799 C38.454,4.328 40.838,4.255 42.472,4.288 C42.508,4.288 42.541,4.289 42.576,4.29 C42.717,4.293 42.842,4.298 42.971,4.302 C40.021,8.499 36.401,12.817 32.423,16.876 C28.572,20.802 24.512,24.373 20.602,27.281 C20.598,27.173 20.594,27.056 20.591,26.939 C20.589,26.868 20.587,26.794 20.586,26.719 C20.581,26.489 20.578,26.241 20.578,25.982 C20.578,25.836 20.578,25.69 20.58,25.537 C20.582,25.389 20.583,25.242 20.586,25.087 C20.594,24.783 20.605,24.465 20.621,24.136 C20.625,24.05 20.629,23.964 20.634,23.877 C20.656,23.464 20.686,23.038 20.727,22.596 L19.731,22.504 L18.737,22.393 L18.735,22.413 C18.734,22.418 18.734,22.424 18.733,22.43 L18.689,22.915 C18.677,23.079 18.668,23.232 18.659,23.386 C18.552,25.014 18.563,26.413 18.603,27.424 L18.573,27.424 L18.573,45.742 L20.573,45.742 L20.573,30.095 C21.097,30.128 21.821,30.161 22.702,30.161 C27.04,30.161 35.04,29.385 40.115,24.206 C47.284,16.884 45.849,3.854 45.784,3.303" id="Amazon-Elastic-Beanstalk-Deployment_Resource-Icon_light-bg" fill="#ED7100"></path>
    </g>
</svg>`, Gi = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Compute/Res_AWS-Lambda_Lambda-Function_48</title>
    <g id="Icon-Resource/Compute/Res_AWS-Lambda_Lambda-Function_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M24,44 C12.972,44 4,35.028 4,24 C4,12.972 12.972,4 24,4 C35.028,4 44,12.972 44,24 C44,35.028 35.028,44 24,44 L24,44 Z M24,2 C11.869,2 2,11.869 2,24 C2,36.131 11.869,46 24,46 C36.131,46 46,36.131 46,24 C46,11.869 36.131,2 24,2 L24,2 Z M17.231,35.25 L11.876,35.25 L18.221,21.959 L20.902,27.492 L17.231,35.25 Z M19.114,19.215 C18.946,18.87 18.597,18.651 18.214,18.651 L18.211,18.651 C17.826,18.652 17.477,18.874 17.312,19.221 L9.389,35.819 C9.24,36.129 9.262,36.493 9.445,36.783 C9.628,37.074 9.947,37.25 10.291,37.25 L17.864,37.25 C18.251,37.25 18.603,37.027 18.769,36.678 L22.915,27.915 C23.044,27.642 23.043,27.323 22.911,27.051 L19.114,19.215 Z M36.125,35.25 L30.673,35.25 L20.761,13.953 C20.597,13.601 20.243,13.375 19.854,13.375 L16.251,13.375 L16.255,9.25 L23.475,9.25 L33.339,30.545 C33.503,30.898 33.856,31.125 34.246,31.125 L36.125,31.125 L36.125,35.25 Z M37.125,29.125 L34.885,29.125 L25.021,7.83 C24.856,7.477 24.503,7.25 24.113,7.25 L15.256,7.25 C14.704,7.25 14.257,7.697 14.256,8.249 L14.25,14.374 C14.25,14.64 14.355,14.894 14.543,15.082 C14.73,15.27 14.984,15.375 15.25,15.375 L19.217,15.375 L29.129,36.672 C29.293,37.024 29.646,37.25 30.035,37.25 L37.125,37.25 C37.678,37.25 38.125,36.803 38.125,36.25 L38.125,30.125 C38.125,29.572 37.678,29.125 37.125,29.125 L37.125,29.125 Z" id="Amazon-Lambda-Lambda-Function_Resource-Icon_light-bg" fill="#ED7100"></path>
    </g>
</svg>
`, ji = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Compute/Res_Amazon-EC2_Instance_48</title>
    <g id="Icon-Resource/Compute/Res_Amazon-EC2_Instance_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M9,39 L39,39 L39,9 L9,9 L9,39 Z M46,13 L46,11 L41,11 L41,8 C41,7.448 40.552,7 40,7 L37,7 L37,2 L35,2 L35,7 L31,7 L31,2 L29,2 L29,7 L25,7 L25,2 L23,2 L23,7 L19,7 L19,2 L17,2 L17,7 L13,7 L13,2 L11,2 L11,7 L8,7 C7.447,7 7,7.448 7,8 L7,11 L2,11 L2,13 L7,13 L7,17 L2,17 L2,19 L7,19 L7,23 L2,23 L2,25 L7,25 L7,29 L2,29 L2,31 L7,31 L7,35 L2,35 L2,37 L7,37 L7,40 C7,40.553 7.447,41 8,41 L11,41 L11,46 L13,46 L13,41 L17,41 L17,46 L19,46 L19,41 L23,41 L23,46 L25,46 L25,41 L29,41 L29,46 L31,46 L31,41 L35,41 L35,46 L37,46 L37,41 L40,41 C40.552,41 41,40.553 41,40 L41,37 L46,37 L46,35 L41,35 L41,31 L46,31 L46,29 L41,29 L41,25 L46,25 L46,23 L41,23 L41,19 L46,19 L46,17 L41,17 L41,13 L46,13 Z" id="Amazon-EC2-Instance_Resource-Icon_light-bg" fill="#ED7100"></path>
    </g>
</svg>
`, wA = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Compute/Res_Amazon-EC2_Auto-Scaling_48</title>
    <g id="Icon-Resource/Compute/Res_Amazon-EC2_Auto-Scaling_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M45.92,23.08125 L37.912,23.08125 L41.734,19.25825 L40.32,17.84425 L34.731,23.43525 C34.34,23.82525 34.34,24.45825 34.731,24.84925 L40.32,30.43825 L41.734,29.02425 L37.791,25.08125 L45.92,25.08125 L45.92,23.08125 Z M7.597,17.84425 L6.183,19.25825 L10.006,23.08125 L2,23.08125 L2,25.08125 L10.126,25.08125 L6.183,29.02425 L7.597,30.43825 L13.187,24.84925 C13.577,24.45825 13.577,23.82525 13.187,23.43525 L7.597,17.84425 Z M18.81,29.23125 L29.108,29.23125 L29.108,18.93225 L18.81,18.93225 L18.81,29.23125 Z M30.892,17.81025 L32.743,17.81025 L32.743,19.81025 L31.108,19.81025 L31.108,21.32425 L32.743,21.32425 L32.743,23.32425 L31.108,23.32425 L31.108,24.83825 L32.743,24.83825 L32.743,26.83825 L31.108,26.83825 L31.108,28.35225 L32.743,28.35225 L32.743,30.35225 L30.892,30.35225 C30.737,30.63125 30.509,30.85925 30.23,31.01425 L30.23,32.86525 L28.23,32.86525 L28.23,31.23025 L26.717,31.23025 L26.717,32.86525 L24.717,32.86525 L24.717,31.23025 L23.203,31.23025 L23.203,32.86525 L21.203,32.86525 L21.203,31.23025 L19.69,31.23025 L19.69,32.86525 L17.69,32.86525 L17.69,31.01425 C17.411,30.85925 17.183,30.63125 17.028,30.35225 L15.176,30.35225 L15.176,28.35225 L16.811,28.35225 L16.811,26.83825 L15.176,26.83825 L15.176,24.83825 L16.811,24.83825 L16.811,23.32425 L15.176,23.32425 L15.176,21.32425 L16.811,21.32425 L16.811,19.81025 L15.176,19.81025 L15.176,17.81025 L17.028,17.81025 C17.183,17.53125 17.411,17.30325 17.69,17.14825 L17.69,15.29825 L19.69,15.29825 L19.69,16.93225 L21.203,16.93225 L21.203,15.29825 L23.203,15.29825 L23.203,16.93225 L24.717,16.93225 L24.717,15.29825 L26.717,15.29825 L26.717,16.93225 L28.23,16.93225 L28.23,15.29825 L30.23,15.29825 L30.23,17.14825 C30.509,17.30325 30.737,17.53125 30.892,17.81025 L30.892,17.81025 Z M24.961,42.74725 L24.961,34.62225 L22.961,34.62225 L22.961,42.75125 L19.075,38.86625 L17.661,40.28025 L23.251,45.87025 C23.446,46.06525 23.702,46.16325 23.958,46.16325 C24.214,46.16325 24.47,46.06525 24.665,45.87025 L30.256,40.28025 L28.842,38.86625 L24.961,42.74725 Z M19.075,9.29725 L17.661,7.88325 L23.251,2.29325 C23.642,1.90225 24.274,1.90225 24.665,2.29325 L30.256,7.88325 L28.842,9.29725 L24.961,5.41625 L24.961,13.54125 L22.961,13.54125 L22.961,5.41225 L19.075,9.29725 Z" id="Amazon-EC2-Auto-Scaling_Resource-Icon_light-bg" fill="#ED7100"></path>
    </g>
</svg>`, xA = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Compute/Res_Amazon-EC2_Spot-Instance_48</title>
    <g id="Icon-Resource/Compute/Res_Amazon-EC2_Spot-Instance_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M3.675,24.96 L2,24.96 L2,22.96 L3.675,22.96 C3.864,19.016 5.161,15.264 7.481,12.061 L9.1,13.232 C7.03,16.093 5.863,19.439 5.675,22.96 L7.271,22.96 L7.271,24.96 L5.675,24.96 C5.863,28.481 7.03,31.827 9.101,34.689 L7.48,35.86 C5.161,32.656 3.864,28.904 3.675,24.96 L3.675,24.96 Z M35.861,40.44 C32.657,42.761 28.906,44.057 24.96,44.246 L24.96,45.862 L22.96,45.862 L22.96,44.246 C19.016,44.057 15.265,42.761 12.061,40.44 L13.233,38.821 C16.094,40.892 19.44,42.059 22.96,42.246 L22.96,40.649 L24.96,40.649 L24.96,42.246 C28.482,42.059 31.828,40.892 34.689,38.821 L35.861,40.44 Z M12.061,7.481 C15.265,5.16 19.016,3.864 22.96,3.674 L22.96,2 L24.96,2 L24.96,3.674 C28.906,3.864 32.657,5.16 35.861,7.481 L34.689,9.1 C31.828,7.029 28.482,5.862 24.96,5.674 L24.96,7.271 L22.96,7.271 L22.96,5.674 C19.44,5.862 16.094,7.029 13.233,9.1 L12.061,7.481 Z M45.92,24.96 L44.247,24.96 C44.057,28.904 42.761,32.656 40.442,35.86 L38.821,34.689 C40.892,31.827 42.059,28.481 42.247,24.96 L40.65,24.96 L40.65,22.96 L42.247,22.96 C42.059,19.439 40.892,16.093 38.821,13.232 L40.441,12.061 C42.761,15.264 44.057,19.016 44.247,22.96 L45.92,22.96 L45.92,24.96 Z M35.551,10.956 L41.699,4.807 L43.113,6.221 L36.965,12.37 L35.551,10.956 Z M12.37,36.965 L6.221,43.113 L4.807,41.699 L10.956,35.551 L12.37,36.965 Z M31.695,30.28 L43.113,41.699 L41.699,43.113 L30.28,31.694 L31.695,30.28 Z M16.226,17.64 L4.807,6.221 L6.221,4.807 L17.64,16.226 L16.226,17.64 Z M33.501,22.96 L33.501,14.419 L24.96,14.419 L24.96,16.904 L22.96,16.904 L22.96,13.827 C22.96,13.051 23.592,12.419 24.368,12.419 L34.093,12.419 C34.869,12.419 35.501,13.051 35.501,13.827 L35.501,23.552 C35.501,24.328 34.869,24.96 34.093,24.96 L30.987,24.96 L30.987,22.96 L33.501,22.96 Z M14.42,24.96 L14.42,33.501 L22.96,33.501 L22.96,30.987 L24.96,30.987 L24.96,34.093 C24.96,34.869 24.328,35.501 23.552,35.501 L13.828,35.501 C13.052,35.501 12.42,34.869 12.42,34.093 L12.42,24.368 C12.42,23.592 13.052,22.96 13.828,22.96 L16.933,22.96 L16.933,24.96 L14.42,24.96 Z M19.69,28.231 L28.231,28.231 L28.231,19.69 L19.69,19.69 L19.69,28.231 Z M30.231,28.579 L30.231,19.341 C30.231,18.431 29.489,17.689 28.579,17.689 L19.341,17.689 C18.431,17.689 17.69,18.431 17.69,19.341 L17.69,28.579 C17.69,29.489 18.431,30.231 19.341,30.231 L28.579,30.231 C29.489,30.231 30.231,29.489 30.231,28.579 L30.231,28.579 Z" id="Amazon-EC2-Spot-Instance_Resource-Icon_light-bg" fill="#ED7100"></path>
    </g>
</svg>`, _A = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Compute/Res_AWS-Elastic-Beanstalk_Application_48</title>
    <g id="Icon-Resource/Compute/Res_AWS-Elastic-Beanstalk_Application_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M30.3558008,22.791794 C25.7258008,27.520794 18.2428008,28.219794 14.1828008,28.215811 C17.9428008,25.339794 21.7928008,21.918794 25.4478008,18.188794 C29.2668008,14.289794 32.7538008,10.168794 35.6678008,6.13679399 C35.6828008,10.294794 35.0198008,18.029794 30.3558008,22.791794 M18.3428008,8.50579399 C18.4578008,8.41079399 18.5768008,8.32379399 18.6928008,8.23179399 C18.9348008,8.04179399 19.1798008,7.85679399 19.4318008,7.68379399 C19.5708008,7.58779399 19.7108008,7.49579399 19.8528008,7.40479399 C20.0968008,7.24779399 20.3438008,7.09879399 20.5948008,6.95579399 C20.7388008,6.87379399 20.8798008,6.79179399 21.0258008,6.71479399 C21.3018008,6.56679399 21.5828008,6.43079399 21.8658008,6.29879399 C21.9858008,6.24179399 22.1038008,6.18179399 22.2238008,6.12779399 C22.6228008,5.95179399 23.0238008,5.78879399 23.4278008,5.64079399 C23.5358008,5.60079399 23.6428008,5.56779399 23.7498008,5.53079399 C24.0548008,5.42379399 24.3618008,5.32079399 24.6688008,5.22879399 C24.8318008,5.17979399 24.9948008,5.13479399 25.1578008,5.08979399 C25.4108008,5.01879399 25.6638008,4.95079399 25.9158008,4.88879399 C26.0878008,4.84679399 26.2588008,4.80579399 26.4308008,4.76679399 C26.6778008,4.71179399 26.9228008,4.66079399 27.1678008,4.61179399 C27.3328008,4.57979399 27.4988008,4.54579399 27.6628008,4.51779399 C27.9308008,4.46879399 28.1958008,4.42779399 28.4598008,4.38879399 C28.5898008,4.36879399 28.7238008,4.34579399 28.8528008,4.32779399 C29.2258008,4.27579399 29.5908008,4.23279399 29.9498008,4.19679399 C30.1088008,4.18079399 30.2608008,4.16879399 30.4178008,4.15479399 C30.6288008,4.13679399 30.8398008,4.11779399 31.0448008,4.10379399 C31.2118008,4.09179399 31.3748008,4.08279399 31.5358008,4.07379399 C31.7198008,4.06279399 31.9018008,4.05479399 32.0788008,4.04779399 C32.2348008,4.04079399 32.3898008,4.03479399 32.5408008,4.03079399 C32.7118008,4.02579399 32.8778008,4.02279399 33.0418008,4.02079399 C33.1778008,4.02079399 33.3178008,4.01779399 33.4468008,4.01779399 C33.6968008,4.01679399 33.9358008,4.01879399 34.1598008,4.02279399 C34.2678008,4.02479399 34.3648008,4.02779399 34.4658008,4.03079399 C34.5518008,4.03379399 34.6338008,4.03579399 34.7148008,4.03879399 C31.7338008,8.28179399 28.0638008,12.659794 24.0178008,16.788794 C20.1278008,20.760794 16.0148008,24.379794 12.0418008,27.332794 C12.0398008,27.265794 12.0378008,27.191794 12.0348008,27.120794 C12.0298008,26.969794 12.0248008,26.816794 12.0218008,26.648794 C12.0198008,26.528794 12.0198008,26.394794 12.0188008,26.266794 C12.0178008,26.103794 12.0158008,25.942794 12.0158008,25.768794 C12.0168008,25.605794 12.0218008,25.429794 12.0258008,25.258794 C12.0288008,25.091794 12.0298008,24.931794 12.0358008,24.756794 C12.0458008,24.423794 12.0618008,24.076794 12.0838008,23.717794 C12.0908008,23.585794 12.1038008,23.444794 12.1138008,23.309794 C12.1308008,23.060794 12.1488008,22.812794 12.1718008,22.554794 C12.1868008,22.392794 12.2078008,22.223794 12.2248008,22.057794 C12.2518008,21.815794 12.2768008,21.574794 12.3078008,21.326794 C12.3308008,21.149794 12.3598008,20.967794 12.3848008,20.787794 C12.4208008,20.542794 12.4578008,20.297794 12.4998008,20.049794 C12.5308008,19.861794 12.5678008,19.673794 12.6028008,19.483794 C12.6498008,19.236794 12.6988008,18.988794 12.7518008,18.738794 C12.7938008,18.545794 12.8398008,18.351794 12.8858008,18.156794 C12.9458008,17.907794 13.0078008,17.658794 13.0758008,17.408794 C13.1278008,17.213794 13.1838008,17.017794 13.2428008,16.821794 C13.3158008,16.571794 13.3948008,16.321794 13.4778008,16.072794 C13.5428008,15.878794 13.6088008,15.685794 13.6778008,15.491794 C13.7688008,15.241794 13.8678008,14.993794 13.9678008,14.745794 C14.0438008,14.557794 14.1208008,14.367794 14.2028008,14.181794 C14.3128008,13.932794 14.4328008,13.686794 14.5538008,13.440794 C14.6418008,13.262794 14.7278008,13.081794 14.8228008,12.904794 C14.9588008,12.652794 15.1058008,12.406794 15.2538008,12.160794 C15.3508008,12.000794 15.4428008,11.837794 15.5448008,11.679794 C15.7188008,11.412794 15.9098008,11.155794 16.0998008,10.898794 C16.1948008,10.772794 16.2808008,10.640794 16.3788008,10.516794 C16.6768008,10.142794 16.9918008,9.77879399 17.3308008,9.43379399 C17.6538008,9.10379399 17.9938008,8.79779399 18.3428008,8.50579399 M37.5268008,3.04079399 C37.5258008,3.03279399 37.5218008,3.02579399 37.5208008,3.01879399 C37.5068008,2.92379399 37.4838008,2.82979399 37.4428008,2.74079399 C37.4408008,2.73679399 37.4378008,2.73279399 37.4358008,2.72979399 C37.4268008,2.71079399 37.4148008,2.69679399 37.4048008,2.67979399 C37.3658008,2.60679399 37.3188008,2.54179399 37.2648008,2.48279399 C37.2438008,2.45979399 37.2208008,2.43979399 37.1978008,2.41979399 C37.1438008,2.37179399 37.0868008,2.33079399 37.0248008,2.29479399 C36.9988008,2.27979399 36.9728008,2.26479399 36.9458008,2.25179399 C36.8538008,2.20979399 36.7568008,2.17779399 36.6548008,2.16479399 C36.1088008,2.09579399 23.1688008,0.61579399 15.9018008,8.03379399 C10.1068008,13.948794 9.86380075,23.538794 10.0348008,27.451794 L10.0078008,27.451794 L10.0078008,45.989794 L12.0078008,45.989794 L12.0078008,30.146794 C12.6038008,30.187794 13.3858008,30.226794 14.3398008,30.226794 C18.8428008,30.226794 26.6898008,29.393794 31.7848008,24.190794 C39.0428008,16.782794 37.5918008,3.59879399 37.5268008,3.04079399" id="Amazon-Elastic-Beanstalk-Application_Resource-Icon_light-bg" fill="#ED7100"></path>
    </g>
</svg>`, vA = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Compute/Res_Amazon-EC2_Instance-with-CloudWatch_48</title>
    <g id="Icon-Resource/Compute/Res_Amazon-EC2_Instance-with-CloudWatch_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M37.545,37.089 C37.325,37.308 36.971,37.308 36.753,37.089 L32.934,33.272 C33.216,33.019 33.48,32.746 33.718,32.451 L37.547,36.298 C37.764,36.516 37.763,36.87 37.545,37.089 L37.545,37.089 Z M23.418,28.123 C23.418,25.413 25.623,23.208 28.333,23.208 C31.043,23.208 33.248,25.413 33.248,28.123 C33.248,30.833 31.043,33.038 28.333,33.038 C25.623,33.038 23.418,30.833 23.418,28.123 L23.418,28.123 Z M34.759,30.662 C35.071,29.875 35.248,29.02 35.248,28.123 C35.248,24.311 32.146,21.208 28.333,21.208 C24.521,21.208 21.418,24.311 21.418,28.123 C21.418,31.936 24.521,35.038 28.333,35.038 C29.367,35.038 30.346,34.803 31.229,34.395 L35.339,38.503 C35.838,39.002 36.493,39.252 37.149,39.252 C37.805,39.252 38.46,39.002 38.959,38.503 C39.956,37.506 39.958,35.884 38.964,34.887 L34.759,30.662 Z M30.254,24.945 L29.065,26.553 C28.309,25.994 27.246,26.155 26.691,26.905 C26.42,27.27 26.309,27.717 26.375,28.165 C26.441,28.613 26.679,29.009 27.043,29.278 L25.852,30.886 C25.059,30.298 24.542,29.436 24.397,28.459 C24.252,27.483 24.495,26.507 25.083,25.714 C26.298,24.076 28.617,23.733 30.254,24.945 L30.254,24.945 Z M39.76,25.443 C39.76,28.56 38.066,30.161 36.647,30.956 L35.67,29.21 C37.057,28.435 37.76,27.167 37.76,25.443 C37.76,22.107 34.975,21.274 33.777,21.07 C33.511,21.025 33.273,20.872 33.12,20.649 C32.984,20.45 32.926,20.211 32.951,19.975 C32.778,18.01 31.664,17.128 30.619,17.128 C29.969,17.128 29.355,17.453 28.935,18.02 C28.714,18.316 28.351,18.463 27.983,18.413 C27.619,18.359 27.314,18.108 27.19,17.76 C26.757,16.55 26.136,15.535 25.344,14.742 C24.378,13.777 21.73,11.704 17.991,13.283 C15.838,14.191 14.151,16.81 14.151,19.245 C14.151,19.52 14.167,19.794 14.199,20.059 C14.233,20.342 14.144,20.627 13.954,20.841 C13.809,21.004 13.615,21.114 13.403,21.157 C12.161,21.484 10.133,22.467 10.133,25.399 C10.133,27.642 11.355,28.878 12.38,29.52 C12.694,29.72 13.066,29.826 13.458,29.83 L20.244,29.837 L20.242,31.837 L13.446,31.83 C12.671,31.822 11.936,31.609 11.312,31.211 C10.128,30.47 8.133,28.724 8.133,25.399 C8.133,22.576 9.619,20.408 12.154,19.458 C12.152,19.387 12.151,19.317 12.151,19.245 C12.151,16.012 14.327,12.656 17.213,11.441 C20.587,10.017 24.153,10.723 26.758,13.328 C27.444,14.015 28.025,14.822 28.494,15.741 C29.129,15.344 29.858,15.128 30.619,15.128 C32.41,15.128 34.417,16.429 34.877,19.266 C37.36,19.936 39.76,21.842 39.76,25.443 L39.76,25.443 Z M43.827,39.38 C43.827,41.832 41.832,43.827 39.379,43.827 L8.448,43.827 C5.995,43.827 4,41.832 4,39.38 L4,8.448 C4,5.995 5.995,4 8.448,4 L39.379,4 C41.832,4 43.827,5.995 43.827,8.448 L43.827,39.38 Z M39.379,2 L8.448,2 C4.893,2 2,4.893 2,8.448 L2,39.38 C2,42.935 4.893,45.827 8.448,45.827 L39.379,45.827 C42.935,45.827 45.827,42.935 45.827,39.38 L45.827,8.448 C45.827,4.893 42.935,2 39.379,2 L39.379,2 Z" id="Amazon-EC2-Instance-with-CloudWatch_Resource-Icon_light-bg" fill="#ED7100"></path>
    </g>
</svg>`, MA = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Compute/Res_Amazon-EC2_Rescue_48</title>
    <g id="Icon-Resource/Compute/Res_Amazon-EC2_Rescue_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M31.073,26.453 L39.553,26.453 L39.553,21.467 L31.073,21.467 L31.073,26.453 Z M28.453,36.367 L28.453,32.09 C29.989,31.241 31.243,29.987 32.091,28.453 L36.367,28.453 C35.041,32.115 32.116,35.04 28.453,36.367 L28.453,36.367 Z M21.467,39.554 L26.453,39.554 L26.453,31.074 L21.467,31.074 L21.467,39.554 Z M11.553,28.453 L15.831,28.453 C16.678,29.987 17.933,31.242 19.466,32.09 L19.466,36.367 C15.805,35.04 12.881,32.115 11.553,28.453 L11.553,28.453 Z M8.367,26.453 L16.846,26.453 L16.846,21.467 L8.367,21.467 L8.367,26.453 Z M19.466,11.553 L19.466,15.83 C17.933,16.677 16.679,17.931 15.83,19.467 L11.553,19.467 C12.88,15.805 15.804,12.879 19.466,11.553 L19.466,11.553 Z M21.466,16.846 L26.452,16.846 L26.452,8.366 L21.466,8.366 L21.466,16.846 Z M28.388,29.75 C28.253,29.359 27.891,29.073 27.453,29.073 L20.466,29.073 C20.029,29.073 19.668,29.359 19.532,29.75 C19.019,29.359 18.562,28.902 18.17,28.388 C18.561,28.253 18.846,27.892 18.846,27.453 L18.846,20.467 C18.846,20.029 18.561,19.667 18.17,19.532 C18.562,19.019 19.019,18.562 19.532,18.17 C19.668,18.562 20.029,18.847 20.466,18.847 L27.453,18.847 C27.891,18.847 28.253,18.562 28.388,18.169 C28.901,18.562 29.359,19.019 29.751,19.531 C29.359,19.667 29.073,20.029 29.073,20.467 L29.073,27.453 C29.073,27.892 29.359,28.253 29.751,28.388 C29.359,28.901 28.901,29.359 28.388,29.75 L28.388,29.75 Z M36.367,19.467 L32.091,19.467 C31.243,17.931 29.987,16.677 28.453,15.83 L28.453,11.553 C32.116,12.879 35.041,15.804 36.367,19.467 L36.367,19.467 Z M40.553,19.467 L38.498,19.467 C37.031,14.7 33.22,10.889 28.453,9.423 L28.453,7.366 C28.453,6.814 28.006,6.366 27.453,6.366 L20.466,6.366 C19.914,6.366 19.466,6.814 19.466,7.366 L19.466,9.423 C14.701,10.89 10.89,14.699 9.423,19.467 L7.367,19.467 C6.814,19.467 6.367,19.914 6.367,20.467 L6.367,27.453 C6.367,28.006 6.814,28.453 7.367,28.453 L9.424,28.453 C10.89,33.22 14.701,37.029 19.466,38.497 L19.466,40.554 C19.466,41.107 19.914,41.554 20.466,41.554 L27.453,41.554 C28.006,41.554 28.453,41.107 28.453,40.554 L28.453,38.497 C33.22,37.03 37.03,33.22 38.497,28.453 L40.553,28.453 C41.106,28.453 41.553,28.006 41.553,27.453 L41.553,20.467 C41.553,19.914 41.106,19.467 40.553,19.467 L40.553,19.467 Z M43.92,39.472 C43.92,41.925 41.925,43.92 39.472,43.92 L8.448,43.92 C5.995,43.92 4,41.925 4,39.472 L4,8.447 C4,5.995 5.995,4 8.448,4 L39.472,4 C41.925,4 43.92,5.995 43.92,8.447 L43.92,39.472 Z M39.472,2 L8.448,2 C4.892,2 2,4.893 2,8.447 L2,39.472 C2,43.028 4.892,45.92 8.448,45.92 L39.472,45.92 C43.027,45.92 45.92,43.028 45.92,39.472 L45.92,8.447 C45.92,4.893 43.027,2 39.472,2 L39.472,2 Z" id="Amazon-EC2-Rescue_Resource-Icon_light-bg" fill="#ED7100"></path>
    </g>
</svg>`, RA = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Compute/Res_Amazon-EC2_Instances_48</title>
    <g id="Icon-Resource/Compute/Res_Amazon-EC2_Instances_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M4.131,22.96 L9.986,22.96 L9.986,24.96 L4.131,24.96 C2.956,24.96 2,24.004 2,22.829 L2,4.131 C2,2.956 2.956,2 4.131,2 L22.829,2 C24.004,2 24.96,2.956 24.96,4.131 L24.96,10.86 L22.96,10.86 L22.96,4.131 C22.96,4.059 22.902,4 22.829,4 L4.131,4 C4.059,4 4,4.059 4,4.131 L4,22.829 C4,22.901 4.059,22.96 4.131,22.96 L4.131,22.96 Z M13.737,33.44 L21.279,33.44 L21.279,35.44 L13.737,35.44 C12.563,35.44 11.607,34.484 11.607,33.31 L11.607,14.61 C11.607,13.436 12.563,12.48 13.737,12.48 L32.436,12.48 C33.61,12.48 34.567,13.436 34.567,14.61 L34.567,21.34 L32.567,21.34 L32.567,14.61 C32.567,14.538 32.508,14.48 32.436,14.48 L13.737,14.48 C13.665,14.48 13.607,14.538 13.607,14.61 L13.607,33.31 C13.607,33.382 13.665,33.44 13.737,33.44 L13.737,33.44 Z M43.85,43.92 L24.96,43.85 L24.96,25.091 C24.96,25.019 25.019,24.96 25.091,24.96 L43.789,24.96 C43.861,24.96 43.92,25.019 43.92,25.091 L43.85,43.92 Z M43.789,22.96 L25.091,22.96 C23.916,22.96 22.96,23.916 22.96,25.091 L22.96,43.85 C22.96,44.991 23.889,45.92 25.03,45.92 L43.85,45.92 C44.991,45.92 45.92,44.991 45.92,43.85 L45.92,25.091 C45.92,23.916 44.964,22.96 43.789,22.96 L43.789,22.96 Z" id="Amazon-EC2-Instances_Resource-Icon_light-bg" fill="#ED7100"></path>
    </g>
</svg>`, yA = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Compute/Res_Amazon-EC2_DB-Instance_48</title>
    <g id="Icon-Resource/Compute/Res_Amazon-EC2_DB-Instance_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M43.284,42.092 L43.284,29.848 C41.817,30.552 39.744,30.888 37.751,30.888 C35.393,30.888 33.511,30.558 32.217,29.951 L32.217,42.092 C32.217,42.638 34.24,44.356 37.751,44.356 C41.261,44.356 43.284,42.638 43.284,42.092 M32.217,27.355 C32.217,27.996 34.139,28.888 37.751,28.888 C41.559,28.888 43.284,27.71 43.284,27.353 C43.284,27.027 41.619,26 37.751,26 C34.055,26 32.294,26.97 32.217,27.355 M45.284,27.353 L45.284,42.092 C45.284,44.363 41.763,46.356 37.751,46.356 C33.737,46.356 30.217,44.363 30.217,42.092 L30.217,27.353 C30.217,24.878 34.275,24 37.751,24 C41.392,24 45.284,24.881 45.284,27.353 M27,35 L27,40 L25,40 L25,36 L22,36 L22,40 L20,40 L20,36 L17,36 L17,40 L15,40 L15,36 L12,36 L12,40 L10,40 L10,36 L7,36 C6.447,36 6,35.553 6,35 L6,32 L2,32 L2,30 L6,30 L6,27 L2,27 L2,25 L6,25 L6,22 L2,22 L2,20 L6,20 L6,17 L2,17 L2,15 L6,15 L6,12 L2,12 L2,10 L6,10 L6,7 C6,6.447 6.447,6 7,6 L10,6 L10,2 L12,2 L12,6 L15,6 L15,2 L17,2 L17,6 L20,6 L20,2 L22,2 L22,6 L25,6 L25,2 L27,2 L27,6 L30,6 L30,2 L32,2 L32,6 L35,6 C35.553,6 36,6.447 36,7 L36,10 L40,10 L40,12 L36,12 L36,15 L40,15 L40,17 L36,17 L36,20 L40,20 L40,22 L35,22 C34.447,22 34,21.553 34,21 L34,8 L8,8 L8,34 L26,34 C26.553,34 27,34.447 27,35" id="Amazon-EC2-DB-instance_Resource-Icon_light-bg" fill="#ED7100"></path>
    </g>
</svg>`, AA = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Compute/Res_Amazon-EC2_Elastic-IP-Address_48</title>
    <g id="Icon-Resource/Compute/Res_Amazon-EC2_Elastic-IP-Address_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M43.62,24.058 L43.62,23.794 L43.742,23.926 L43.62,24.058 Z M10.926,30.852 C7.106,30.852 4,27.746 4,23.926 C4,20.107 7.106,17 10.926,17 C14.745,17 17.851,20.107 17.851,23.926 C17.851,27.746 14.745,30.852 10.926,30.852 L10.926,30.852 Z M45.839,23.246 L39.398,16.31 L37.933,17.671 L42.813,22.926 L19.792,22.926 C19.293,18.474 15.51,15 10.926,15 C6.004,15 2,19.004 2,23.926 C2,28.848 6.004,32.852 10.926,32.852 C15.51,32.852 19.293,29.378 19.792,24.926 L42.813,24.926 L37.933,30.181 L39.398,31.542 L45.839,24.607 C46.195,24.223 46.195,23.629 45.839,23.246 L45.839,23.246 Z" id="Amazon-EC2-Elastic-IP-address_Resource-Icon_light-bg" fill="#ED7100"></path>
    </g>
</svg>`, ZA = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Database/Res_Amazon-RDS_Optimized-Writes_48</title>
    <g id="Icon-Resource/Database/Res_Amazon-RDS_Optimized-Writes_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M43.7578,17.0608 L36.5518,14.2328 L35.4938,16.9278 L42.6928,19.7748 L43.7578,17.0608 Z M41.9618,21.6358 L34.7628,18.7898 L29.2508,32.8318 L31.8248,33.8418 L35.9598,23.7808 L37.8098,24.5418 L33.6868,34.5728 L36.4568,35.6598 L41.9618,21.6358 Z M29.3918,42.8538 L35.1518,37.2958 L29.0528,34.9018 L29.3918,42.8538 Z M45.9848,16.8608 L37.9528,37.3218 C37.8598,37.5598 37.6808,37.7328 37.4678,37.8398 L29.1818,45.8368 C28.9918,46.0198 28.7408,46.1168 28.4868,46.1168 C28.3618,46.1168 28.2368,46.0938 28.1158,46.0458 C27.7508,45.8998 27.5048,45.5528 27.4878,45.1598 L27.0008,33.7348 L27.0248,33.7338 C26.9428,33.5068 26.9358,33.2578 27.0248,33.0318 L35.0558,12.5708 C35.2568,12.0568 35.8368,11.8028 36.3518,12.0058 L45.4188,15.5648 C45.6658,15.6618 45.8638,15.8528 45.9708,16.0958 C46.0758,16.3388 46.0808,16.6138 45.9848,16.8608 L45.9848,16.8608 Z M4.0138,8.1618 C4.0138,10.1628 8.6508,12.3218 16.1418,12.3218 C23.7198,12.3218 28.9998,10.1288 28.9998,8.1618 C28.9998,6.1928 23.7198,3.9998 16.1418,3.9998 C8.6508,3.9998 4.0138,6.1608 4.0138,8.1618 L4.0138,8.1618 Z M24.6918,42.9968 L25.2368,44.9198 C22.6888,45.6428 19.5878,46.0238 16.2708,46.0238 C7.7358,46.0238 1.9998,43.5478 1.9998,39.8628 L1.9998,8.0248 L2.0268,8.0248 C2.1678,4.4168 7.7978,1.9998 16.1418,1.9998 C23.4398,1.9998 30.8138,4.0708 30.9838,8.0248 L30.9998,8.0248 L30.9998,17.0248 L28.9998,17.0248 L28.9998,11.4088 C26.2868,13.3298 21.1938,14.3218 16.1418,14.3218 C10.6578,14.3218 6.3548,13.2748 3.9998,11.5358 L3.9998,39.8628 C3.9998,41.9088 8.5898,44.0238 16.2708,44.0238 C19.4058,44.0238 22.3188,43.6678 24.6918,42.9968 L24.6918,42.9968 Z M7.9998,23.0248 L19.9998,23.0248 L19.9998,21.0248 L7.9998,21.0248 L7.9998,23.0248 Z M6.9998,27.0248 L26.9998,27.0248 L26.9998,25.0248 L6.9998,25.0248 L6.9998,27.0248 Z M9.9998,31.0248 L15.9998,31.0248 L15.9998,29.0248 L9.9998,29.0248 L9.9998,31.0248 Z M18.9998,31.0248 L23.9998,31.0248 L23.9998,29.0248 L18.9998,29.0248 L18.9998,31.0248 Z" id="Fill-1" fill="#C925D1"></path>
    </g>
</svg>`, kA = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Database/Res_Amazon-DynamoDB_Standard-Access-Table-Class_48</title>
    <g id="Icon-Resource/Database/Res_Amazon-DynamoDB_Standard-Access-Table-Class_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M15.714,37.707 C15.519,37.902 15.263,38 15.007,38 C14.751,38 14.495,37.902 14.3,37.707 L11.3,34.707 L12.714,33.293 L14.007,34.586 L14.007,25.414 L12.714,26.707 L11.3,25.293 L14.3,22.293 C14.691,21.902 15.323,21.902 15.714,22.293 L18.714,25.293 L17.3,26.707 L16.007,25.414 L16.007,34.586 L17.3,33.293 L18.714,34.707 L15.714,37.707 Z M8.007,29.414 L8.007,38.586 L9.3,37.293 L10.714,38.707 L7.714,41.707 C7.519,41.902 7.263,42 7.007,42 C6.751,42 6.495,41.902 6.3,41.707 L3.3,38.707 L4.714,37.293 L6.007,38.586 L6.007,29.414 L4.714,30.707 L3.3,29.293 L6.3,26.293 C6.691,25.902 7.323,25.902 7.714,26.293 L10.714,29.293 L9.3,30.707 L8.007,29.414 Z M23.602,40 C26.739,40 29.521,39.665 31.787,39.134 L31.396,41.033 C31.38,41.11 31.379,41.187 31.369,41.264 C28.964,41.749 26.281,42 23.602,42 C20.408,42 17.586,41.681 15.238,41.111 L16.935,39.411 C18.831,39.778 21.068,40 23.602,40 L23.602,40 Z M23.602,4 C32.091,4 38.007,6.442 38.007,8.635 C38.007,10.827 32.091,13.27 23.602,13.27 C15.204,13.27 10.007,10.864 10.007,8.635 C10.007,6.406 15.204,4 23.602,4 L23.602,4 Z M10.007,12.126 C12.559,14.085 17.396,15.27 23.602,15.27 C29.318,15.27 35.071,14.145 38.007,11.974 L38.007,17.5 L40.007,17.5 L40.007,8.635 C40.007,4.279 31.754,2 23.602,2 C14.274,2 8.007,4.666 8.007,8.635 L8.007,23.193 L10.007,23.193 L10.007,12.126 Z M35.253,40.265 L37.324,30.202 C37.385,29.907 37.31,29.601 37.12,29.368 C36.93,29.135 36.646,29 36.345,29 L32.875,29 L36.875,21 L42.49,21 L38.6,27.485 C38.414,27.794 38.409,28.179 38.587,28.493 C38.765,28.806 39.097,29 39.457,29 L42.873,29 L35.253,40.265 Z M45.64,27.531 C45.467,27.204 45.127,27 44.757,27 L41.224,27 L45.114,20.515 C45.3,20.206 45.305,19.821 45.127,19.507 C44.949,19.194 44.617,19 44.257,19 L36.257,19 C35.878,19 35.532,19.214 35.362,19.553 L30.362,29.553 C30.207,29.863 30.224,30.231 30.406,30.526 C30.589,30.821 30.91,31 31.257,31 L35.118,31 L32.277,44.798 C32.181,45.266 32.429,45.736 32.868,45.921 C32.994,45.975 33.126,46 33.257,46 C33.58,46 33.895,45.842 34.085,45.561 L45.585,28.561 C45.792,28.254 45.814,27.858 45.64,27.531 L45.64,27.531 Z" id="Fill-1" fill="#C925D1"></path>
    </g>
</svg>`, TA = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Database/Res_Amazon-Aurora_Amazon-RDS-Instance-Aternate_48</title>
    <g id="Icon-Resource/Database/Res_Amazon-Aurora_Amazon-RDS-Instance-Aternate_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M23.8176,23.376 C23.9266,23.638 23.9826,23.953 23.9826,24.324 C23.9826,25.043 23.7506,25.612 23.2846,26.032 C22.8186,26.452 22.1776,26.662 21.3606,26.662 C21.0046,26.662 20.6486,26.62 20.2936,26.537 C19.9376,26.454 19.6386,26.345 19.3966,26.208 L19.3966,25.017 C19.6766,25.122 19.9936,25.211 20.3436,25.283 C20.6966,25.355 20.9976,25.392 21.2476,25.392 C21.6106,25.392 21.8856,25.306 22.0756,25.136 C22.2646,24.966 22.3596,24.722 22.3596,24.403 C22.3596,24.169 22.2926,23.971 22.1606,23.808 C22.0286,23.645 21.8066,23.48 21.4966,23.314 L20.8836,22.985 C20.3246,22.683 19.9216,22.356 19.6796,22.009 C19.4376,21.661 19.3166,21.237 19.3166,20.737 C19.3166,20.276 19.4236,19.873 19.6346,19.528 C19.8466,19.185 20.1356,18.92 20.5046,18.733 C20.8706,18.549 21.2926,18.456 21.7686,18.456 C22.3666,18.456 22.9616,18.592 23.5506,18.865 L23.5506,20.068 C22.9376,19.841 22.3966,19.728 21.9276,19.728 C21.6106,19.728 21.3606,19.807 21.1786,19.966 C20.9976,20.124 20.9066,20.345 20.9066,20.624 C20.9066,20.858 20.9646,21.051 21.0826,21.203 C21.1996,21.354 21.4246,21.521 21.7576,21.702 L22.3706,22.031 C22.7636,22.243 23.0766,22.455 23.3066,22.667 C23.5376,22.879 23.7086,23.115 23.8176,23.376 L23.8176,23.376 Z M16.7756,22.667 C16.7756,23.552 16.6536,24.208 16.4126,24.637 C16.1696,25.063 15.8016,25.277 15.3106,25.277 L14.6406,25.277 L14.6406,19.841 L15.2986,19.841 C15.8056,19.841 16.1786,20.051 16.4176,20.471 C16.6556,20.891 16.7756,21.548 16.7756,22.44 L16.7756,22.667 Z M15.4236,18.626 L13.0516,18.626 L13.0516,26.492 L15.4806,26.492 C16.4336,26.492 17.1606,26.159 17.6606,25.493 C18.1606,24.827 18.4096,23.848 18.4096,22.554 C18.4096,21.267 18.1556,20.292 17.6496,19.625 C17.1416,18.96 16.4006,18.626 15.4236,18.626 L15.4236,18.626 Z M9.9696,22.065 C9.8156,22.285 9.5896,22.395 9.2956,22.395 L8.5576,22.395 L8.5576,19.807 L9.2956,19.807 C9.5896,19.807 9.8156,19.916 9.9696,20.137 C10.1256,20.355 10.2036,20.677 10.2036,21.101 C10.2036,21.524 10.1256,21.846 9.9696,22.065 L9.9696,22.065 Z M11.4636,22.475 C11.6676,22.088 11.7696,21.63 11.7696,21.101 C11.7696,20.337 11.5626,19.733 11.1516,19.29 C10.7386,18.848 10.1846,18.626 9.4886,18.626 L7.0026,18.626 L7.0026,26.492 L8.5576,26.492 L8.5576,23.575 L9.1706,23.575 L10.5446,26.492 L12.1776,26.492 L10.5886,23.337 C10.9666,23.147 11.2586,22.859 11.4636,22.475 L11.4636,22.475 Z M41.2626,9.625 C41.4936,9.913 41.6096,10.333 41.6096,10.885 L41.6096,15.142 L40.0536,15.142 L40.0536,11.328 C40.0536,10.995 40.0086,10.753 39.9176,10.602 C39.8276,10.45 39.6716,10.374 39.4526,10.374 C39.2176,10.374 38.9606,10.465 38.6796,10.647 L38.6796,15.142 L37.1256,15.142 L37.1256,9.342 L38.3966,9.342 L38.5216,9.863 C39.1276,9.417 39.7066,9.194 40.2586,9.194 C40.6966,9.194 41.0316,9.338 41.2626,9.625 L41.2626,9.625 Z M34.2936,13.66 C34.1696,13.96 33.9656,14.109 33.6866,14.109 C33.4066,14.109 33.2046,13.96 33.0796,13.66 C32.9556,13.362 32.8916,12.891 32.8916,12.248 C32.8916,11.604 32.9556,11.131 33.0796,10.828 C33.2046,10.525 33.4066,10.374 33.6866,10.374 C33.9656,10.374 34.1696,10.525 34.2936,10.828 C34.4196,11.131 34.4806,11.604 34.4806,12.248 C34.4806,12.891 34.4196,13.362 34.2936,13.66 L34.2936,13.66 Z M33.6866,9.194 C32.9376,9.194 32.3586,9.459 31.9496,9.988 C31.5416,10.519 31.3376,11.271 31.3376,12.248 C31.3376,13.216 31.5416,13.965 31.9496,14.494 C32.3586,15.024 32.9376,15.289 33.6866,15.289 C34.4356,15.289 35.0146,15.024 35.4226,14.494 C35.8316,13.965 36.0366,13.216 36.0366,12.248 C36.0366,11.271 35.8316,10.519 35.4226,9.988 C35.0146,9.459 34.4356,9.194 33.6866,9.194 L33.6866,9.194 Z M28.2386,13.949 L30.6336,13.949 L30.6336,15.142 L26.6046,15.142 L26.6046,14.041 L28.9536,10.533 L26.6946,10.533 L26.6946,9.342 L30.5886,9.342 L30.5886,10.442 L28.2386,13.949 Z M24.2426,13.836 C23.9926,14.078 23.7446,14.199 23.4946,14.199 C23.3346,14.199 23.2086,14.134 23.1136,14.001 C23.0186,13.868 22.9706,13.688 22.9706,13.462 C22.9706,13.197 23.0306,12.995 23.1476,12.855 C23.2646,12.715 23.4336,12.646 23.6526,12.646 C23.8796,12.646 24.0766,12.672 24.2426,12.725 L24.2426,13.836 Z M23.7996,9.194 C23.4286,9.194 23.0656,9.235 22.7106,9.319 C22.3546,9.402 22.0676,9.516 21.8486,9.659 L21.8486,10.692 C22.5066,10.45 23.0626,10.329 23.5156,10.329 C23.7966,10.329 23.9876,10.399 24.0896,10.539 C24.1916,10.68 24.2426,10.945 24.2426,11.339 L24.2426,11.861 C23.8946,11.772 23.6026,11.725 23.3686,11.725 C22.8016,11.725 22.3516,11.89 22.0176,12.219 C21.6856,12.548 21.5186,12.996 21.5186,13.564 C21.5186,14.102 21.6546,14.523 21.9276,14.829 C22.1996,15.137 22.5706,15.289 23.0396,15.289 C23.2896,15.289 23.5356,15.227 23.7776,15.103 C24.0196,14.977 24.2056,14.816 24.3346,14.62 L24.4696,15.142 L25.6726,15.142 L25.6726,11.078 C25.6726,10.42 25.5256,9.941 25.2306,9.643 C24.9346,9.344 24.4586,9.194 23.7996,9.194 L23.7996,9.194 Z M18.8636,15.142 L18.8636,11.316 C18.8636,10.991 18.8186,10.753 18.7326,10.602 C18.6446,10.45 18.5006,10.374 18.2956,10.374 C18.0766,10.374 17.8266,10.465 17.5466,10.647 C17.5536,10.685 17.5576,10.727 17.5576,10.772 L17.5576,10.908 L17.5576,15.142 L16.0036,15.142 L16.0036,11.316 C16.0036,10.991 15.9596,10.753 15.8726,10.602 C15.7856,10.45 15.6396,10.374 15.4346,10.374 C15.2236,10.374 14.9766,10.465 14.6976,10.647 L14.6976,15.142 L13.1416,15.142 L13.1416,9.342 L14.4136,9.342 L14.5396,9.863 C15.1436,9.417 15.7116,9.194 16.2416,9.194 C16.7786,9.194 17.1566,9.425 17.3766,9.887 C17.9966,9.425 18.5716,9.194 19.1006,9.194 C19.5246,9.194 19.8506,9.34 20.0776,9.631 C20.3036,9.923 20.4186,10.341 20.4186,10.885 L20.4186,15.142 L18.8636,15.142 Z M8.6026,12.134 L9.2956,8.876 L10.0096,12.134 L8.6026,12.134 Z M8.4786,7.276 L6.2986,15.142 L7.9676,15.142 L8.3646,13.27 L10.2486,13.27 L10.6576,15.142 L12.4056,15.142 L10.2376,7.276 L8.4786,7.276 Z M43.9086,39.461 C43.9086,41.913 41.9136,43.908 39.4616,43.908 L8.4476,43.908 C5.9956,43.908 4.0006,41.913 4.0006,39.461 L4.0006,8.447 C4.0006,5.995 5.9956,4 8.4476,4 L39.4616,4 C41.9136,4 43.9086,5.995 43.9086,8.447 L43.9086,39.461 Z M39.4616,2 L8.4476,2 C4.8926,2 2.0006,4.893 2.0006,8.447 L2.0006,39.461 C2.0006,43.016 4.8926,45.908 8.4476,45.908 L39.4616,45.908 C43.0156,45.908 45.9086,43.016 45.9086,39.461 L45.9086,8.447 C45.9086,4.893 43.0156,2 39.4616,2 L39.4616,2 Z" id="Amazon-DATABASEAmazon-Aurora-Amazon-RDS-instance-alternate_Resource-Icon_light-bg" fill="#C925D1"></path>
    </g>
</svg>`, SA = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Database/Res_Amazon-DynamoDB_Attributes_48</title>
    <g id="Icon-Resource/Database/Res_Amazon-DynamoDB_Attributes_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M12.625,40.5 C11.487,40.5 10.562,39.575 10.562,38.437 C10.562,37.3 11.487,36.375 12.625,36.375 C13.763,36.375 14.688,37.3 14.688,38.437 C14.688,39.575 13.763,40.5 12.625,40.5 L12.625,40.5 Z M12.625,34.375 C10.385,34.375 8.563,36.197 8.563,38.437 C8.563,40.678 10.385,42.5 12.625,42.5 C14.865,42.5 16.687,40.678 16.687,38.437 C16.687,36.197 14.865,34.375 12.625,34.375 L12.625,34.375 Z M12.625,25.625 C11.487,25.625 10.562,24.7 10.562,23.563 C10.562,22.425 11.487,21.5 12.625,21.5 C13.763,21.5 14.688,22.425 14.688,23.563 C14.688,24.7 13.763,25.625 12.625,25.625 L12.625,25.625 Z M12.625,19.5 C10.385,19.5 8.563,21.322 8.563,23.563 C8.563,25.803 10.385,27.625 12.625,27.625 C14.865,27.625 16.687,25.803 16.687,23.563 C16.687,21.322 14.865,19.5 12.625,19.5 L12.625,19.5 Z M12.625,10.75 C11.487,10.75 10.562,9.825 10.562,8.688 C10.562,7.55 11.487,6.625 12.625,6.625 C13.763,6.625 14.688,7.55 14.688,8.688 C14.688,9.825 13.763,10.75 12.625,10.75 L12.625,10.75 Z M12.625,4.625 C10.385,4.625 8.563,6.447 8.563,8.688 C8.563,10.928 10.385,12.75 12.625,12.75 C14.865,12.75 16.687,10.928 16.687,8.688 C16.687,6.447 14.865,4.625 12.625,4.625 L12.625,4.625 Z M26.75,43.125 L44,43.125 L44,33.75 L26.75,33.75 L26.75,43.125 Z M24.75,45.125 L46,45.125 L46,31.75 L24.75,31.75 L24.75,45.125 Z M26.75,28.25 L44,28.25 L44,18.875 L26.75,18.875 L26.75,28.25 Z M24.75,30.25 L46,30.25 L46,16.875 L24.75,16.875 L24.75,30.25 Z M26.75,13.375 L44,13.375 L44,4 L26.75,4 L26.75,13.375 Z M24.75,15.375 L46,15.375 L46,2 L24.75,2 L24.75,15.375 Z M4,43.125 L21.25,43.125 L21.25,33.75 L4,33.75 L4,43.125 Z M2,45.125 L23.25,45.125 L23.25,31.75 L2,31.75 L2,45.125 Z M4,28.25 L21.25,28.25 L21.25,18.875 L4,18.875 L4,28.25 Z M2,30.25 L23.25,30.25 L23.25,16.875 L2,16.875 L2,30.25 Z M4,13.375 L21.25,13.375 L21.25,4 L4,4 L4,13.375 Z M2,15.375 L23.25,15.375 L23.25,2 L2,2 L2,15.375 Z" id="Amazon-DATABASE_Amazon-DynamoDB_Attributes_Resource-Icon_light-bg" fill="#C925D1"></path>
    </g>
</svg>`, bA = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Database/Res_Amazon-Aurora-MySQL-Instance-Alternate_48</title>
    <g id="Icon-Resource/Database/Res_Amazon-Aurora-MySQL-Instance-Alternate_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M36.6101,15.8721 L39.2891,15.8721 L39.2891,17.1311 L35.0211,17.1311 L35.0211,9.2661 L36.6101,9.2661 L36.6101,15.8721 Z M31.6621,15.3041 C31.4041,15.7801 31.0261,16.0191 30.5271,16.0191 C30.0281,16.0191 29.6491,15.7801 29.3911,15.3041 C29.1341,14.8271 29.0061,14.1241 29.0061,13.1921 C29.0061,12.2391 29.1311,11.5321 29.3811,11.0701 C29.6311,10.6081 30.0121,10.3781 30.5271,10.3781 C31.0411,10.3781 31.4231,10.6081 31.6731,11.0701 C31.9231,11.5321 32.0481,12.2391 32.0481,13.1921 C32.0481,14.1241 31.9191,14.8271 31.6621,15.3041 L31.6621,15.3041 Z M33.1661,15.7251 C33.5091,15.0511 33.6821,14.2061 33.6821,13.1921 C33.6821,11.8921 33.4061,10.8831 32.8531,10.1681 C32.3001,9.4531 31.5261,9.0961 30.5271,9.0961 C29.5281,9.0961 28.7531,9.4531 28.2001,10.1681 C27.6471,10.8831 27.3711,11.8921 27.3711,13.1921 C27.3711,14.4641 27.6321,15.4571 28.1551,16.1721 C28.6771,16.8881 29.4151,17.2631 30.3681,17.3021 C30.7611,17.7701 31.2341,18.1601 31.7871,18.4711 C32.3391,18.7811 32.9141,18.9811 33.5111,19.0721 L33.5111,17.7781 C33.0951,17.7331 32.7441,17.6571 32.4561,17.5521 C32.1691,17.4441 31.9081,17.2981 31.6731,17.1081 C32.3241,16.8591 32.8211,16.3971 33.1661,15.7251 L33.1661,15.7251 Z M26.2421,14.0161 C26.3511,14.2761 26.4071,14.5931 26.4071,14.9641 C26.4071,15.6831 26.1731,16.2521 25.7091,16.6721 C25.2431,17.0921 24.6011,17.3021 23.7851,17.3021 C23.4291,17.3021 23.0741,17.2601 22.7181,17.1771 C22.3631,17.0941 22.0631,16.9831 21.8211,16.8471 L21.8211,15.6561 C22.1011,15.7621 22.4171,15.8511 22.7681,15.9231 C23.1221,15.9941 23.4221,16.0301 23.6721,16.0301 C24.0351,16.0301 24.3111,15.9451 24.5001,15.7741 C24.6881,15.6041 24.7841,15.3611 24.7841,15.0431 C24.7841,14.8091 24.7171,14.6101 24.5851,14.4471 C24.4531,14.2841 24.2311,14.1201 23.9221,13.9531 L23.3081,13.6241 C22.7481,13.3211 22.3471,12.9961 22.1051,12.6471 C21.8631,12.3001 21.7421,11.8761 21.7421,11.3771 C21.7421,10.9151 21.8471,10.5131 22.0591,10.1681 C22.2711,9.8241 22.5601,9.5601 22.9271,9.3731 C23.2961,9.1881 23.7161,9.0961 24.1941,9.0961 C24.7911,9.0961 25.3851,9.2311 25.9761,9.5041 L25.9761,10.7071 C25.3621,10.4801 24.8221,10.3661 24.3521,10.3661 C24.0351,10.3661 23.7851,10.4461 23.6031,10.6041 C23.4221,10.7641 23.3311,10.9831 23.3311,11.2631 C23.3311,11.4981 23.3891,11.6901 23.5061,11.8421 C23.6251,11.9931 23.8491,12.1601 24.1821,12.3421 L24.7961,12.6711 C25.1881,12.8821 25.5011,13.0951 25.7311,13.3061 C25.9631,13.5181 26.1321,13.7551 26.2421,14.0161 L26.2421,14.0161 Z M19.6421,11.3311 L21.2421,11.3311 L19.3241,18.0171 C19.1651,18.5761 18.9531,18.9811 18.6881,19.2311 C18.4231,19.4811 18.0761,19.6051 17.6441,19.6051 C17.3181,19.6051 16.9861,19.5491 16.6451,19.4351 L16.6451,18.3921 C16.8491,18.4211 17.0311,18.4361 17.1901,18.4361 C17.4771,18.4361 17.6931,18.3601 17.8371,18.2101 C17.9811,18.0581 18.0761,17.8051 18.1211,17.4491 L18.1431,17.2441 L16.2701,11.3311 L17.9171,11.3311 L18.7901,15.5991 L19.6421,11.3311 Z M13.6821,9.2661 L15.4541,9.2661 L15.4541,17.1311 L14.0351,17.1311 L14.0351,11.6151 L12.7081,15.1901 L11.3571,15.1901 L10.0401,11.6491 L10.0401,17.1311 L8.6211,17.1311 L8.6211,9.2661 L10.4371,9.2661 L12.0601,13.6691 L13.6821,9.2661 Z M43.9091,40.1211 C43.9091,42.2101 42.2101,43.9091 40.1211,43.9091 L7.7881,43.9091 C5.6991,43.9091 4.0001,42.2101 4.0001,40.1211 L4.0001,7.7881 C4.0001,5.6991 5.6991,4.0001 7.7881,4.0001 L40.1211,4.0001 C42.2101,4.0001 43.9091,5.6991 43.9091,7.7881 L43.9091,40.1211 Z M40.1211,2.0001 L7.7881,2.0001 C4.5961,2.0001 2.0001,4.5971 2.0001,7.7881 L2.0001,40.1211 C2.0001,43.3121 4.5961,45.9091 7.7881,45.9091 L40.1211,45.9091 C43.3121,45.9091 45.9091,43.3121 45.9091,40.1211 L45.9091,7.7881 C45.9091,4.5971 43.3121,2.0001 40.1211,2.0001 L40.1211,2.0001 Z" id="Amazon-DATABASEAmazon-Aurora-MySQL-instance-alternate_Resource-Icon_light-bg" fill="#C925D1"></path>
    </g>
</svg>`, EA = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Database/Res_Amazon-DynamoDB_Item_48</title>
    <g id="Icon-Resource/Database/Res_Amazon-DynamoDB_Item_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M30.1807,12.5992 C30.1807,9.7832 32.4727,7.4912 35.2897,7.4912 C38.1067,7.4912 40.3987,9.7832 40.3987,12.5992 C40.3987,15.4162 38.1067,17.7082 35.2897,17.7082 C32.4727,17.7082 30.1807,15.4162 30.1807,12.5992 L30.1807,12.5992 Z M28.1807,12.5992 C28.1807,16.5192 31.3697,19.7082 35.2897,19.7082 C39.2097,19.7082 42.3987,16.5192 42.3987,12.5992 C42.3987,8.6792 39.2097,5.4912 35.2897,5.4912 C31.3697,5.4912 28.1807,8.6792 28.1807,12.5992 L28.1807,12.5992 Z M4.0007,43.8892 L21.1997,43.8892 L21.1997,26.6902 L4.0007,26.6902 L4.0007,43.8892 Z M2.0007,45.8892 L23.1997,45.8892 L23.1997,24.6902 L2.0007,24.6902 L2.0007,45.8892 Z M26.6907,43.8892 L43.8897,43.8892 L43.8897,26.6902 L26.6907,26.6902 L26.6907,43.8892 Z M24.6907,45.8892 L45.8897,45.8892 L45.8897,24.6902 L24.6907,24.6902 L24.6907,45.8892 Z M3.9997,21.1982 L21.1987,21.1982 L21.1987,3.9992 L3.9997,3.9992 L3.9997,21.1982 Z M1.9997,23.1992 L23.1987,23.1992 L23.1987,2.0002 L1.9997,2.0002 L1.9997,23.1992 Z M26.6907,21.1992 L43.8897,21.1992 L43.8897,4.0002 L26.6907,4.0002 L26.6907,21.1992 Z M24.6907,23.1982 L45.8897,23.1982 L45.8897,1.9992 L24.6907,1.9992 L24.6907,23.1982 Z" id="Amazon-DATABASE_Amazon-DynamoDB_Item_Resource-Icon_light-bg" fill="#C925D1"></path>
    </g>
</svg>`, IA = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Database/Res_Amazon-Aurora-PostgreSQL-Instance-Alternate_48</title>
    <g id="Icon-Resource/Database/Res_Amazon-Aurora-PostgreSQL-Instance-Alternate_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M43.908,39.814 C43.908,42.072 42.071,43.909 39.814,43.909 L8.094,43.909 C5.837,43.909 4,42.072 4,39.814 L4,8.094 C4,5.836 5.837,4 8.094,4 L39.814,4 C42.071,4 43.908,5.836 43.908,8.094 L43.908,39.814 Z M39.814,2 L8.094,2 C4.733,2 2,4.734 2,8.094 L2,39.814 C2,43.174 4.733,45.909 8.094,45.909 L39.814,45.909 C43.175,45.909 45.908,43.174 45.908,39.814 L45.908,8.094 C45.908,4.734 43.175,2 39.814,2 L39.814,2 Z M40.953,14.516 L43.153,14.516 L43.153,15.223 L40.105,15.223 L40.105,9.172 L40.953,9.172 L40.953,14.516 Z M36.648,14.638 C36.177,14.638 35.822,14.433 35.584,14.022 C35.345,13.612 35.225,13.005 35.225,12.202 C35.225,11.399 35.345,10.793 35.584,10.386 C35.822,9.979 36.177,9.775 36.648,9.775 C37.12,9.775 37.475,9.979 37.714,10.386 C37.952,10.793 38.071,11.399 38.071,12.202 C38.071,13.005 37.952,13.612 37.714,14.022 C37.475,14.433 37.12,14.638 36.648,14.638 L36.648,14.638 Z M38.516,14.232 C38.796,13.706 38.936,13.029 38.936,12.202 C38.936,11.207 38.735,10.434 38.334,9.883 C37.932,9.334 37.37,9.059 36.648,9.059 C35.927,9.059 35.365,9.334 34.963,9.883 C34.561,10.434 34.361,11.207 34.361,12.202 C34.361,12.836 34.444,13.386 34.609,13.852 C34.775,14.318 35.021,14.679 35.347,14.935 C35.674,15.191 36.066,15.331 36.526,15.354 C36.858,15.715 37.221,16.002 37.617,16.218 C38.013,16.434 38.432,16.571 38.875,16.628 L38.875,15.886 C38.572,15.852 38.296,15.785 38.046,15.686 C37.795,15.586 37.554,15.444 37.32,15.258 C37.839,15.101 38.237,14.758 38.516,14.232 L38.516,14.232 Z M33.265,12.647 C33.443,12.91 33.531,13.223 33.531,13.59 C33.531,14.12 33.366,14.546 33.034,14.87 C32.702,15.192 32.26,15.354 31.707,15.354 C31.438,15.354 31.181,15.324 30.934,15.262 C30.686,15.202 30.472,15.113 30.293,14.997 L30.293,14.324 C30.769,14.528 31.232,14.629 31.68,14.629 C31.989,14.629 32.232,14.543 32.409,14.368 C32.587,14.193 32.676,13.952 32.676,13.643 C32.676,13.223 32.443,12.895 31.977,12.656 L31.357,12.342 C30.968,12.144 30.685,11.917 30.511,11.661 C30.336,11.405 30.249,11.09 30.249,10.717 C30.249,10.223 30.403,9.823 30.712,9.517 C31.019,9.211 31.425,9.059 31.926,9.059 C32.315,9.059 32.752,9.164 33.235,9.374 L33.235,10.054 C32.839,9.874 32.423,9.784 31.986,9.784 C31.713,9.784 31.496,9.864 31.336,10.024 C31.176,10.184 31.095,10.401 31.095,10.674 C31.095,10.889 31.151,11.073 31.262,11.224 C31.372,11.376 31.555,11.518 31.811,11.652 L32.431,11.966 C32.809,12.159 33.088,12.385 33.265,12.647 L33.265,12.647 Z M28.707,12.516 C28.704,12.557 28.703,12.595 28.703,12.629 L27.132,12.629 C27.149,12.193 27.232,11.863 27.381,11.639 C27.529,11.416 27.737,11.302 28.005,11.302 C28.243,11.302 28.421,11.392 28.537,11.569 C28.653,11.747 28.712,12.022 28.712,12.394 C28.712,12.435 28.711,12.476 28.707,12.516 L28.707,12.516 Z M28.04,10.674 C27.498,10.674 27.082,10.875 26.791,11.277 C26.5,11.678 26.354,12.254 26.354,13.005 C26.354,13.791 26.5,14.376 26.791,14.76 C27.082,15.145 27.524,15.336 28.118,15.336 C28.59,15.336 29.003,15.226 29.358,15.004 L29.358,14.403 C28.956,14.583 28.59,14.673 28.258,14.673 C27.868,14.673 27.584,14.557 27.407,14.324 C27.228,14.091 27.137,13.712 27.132,13.189 L29.367,13.189 C29.413,12.967 29.436,12.726 29.436,12.463 C29.436,11.876 29.318,11.431 29.083,11.128 C28.847,10.826 28.499,10.674 28.04,10.674 L28.04,10.674 Z M25.69,10.761 C25.784,10.761 25.877,10.77 25.971,10.788 L25.971,11.547 C25.807,11.524 25.677,11.512 25.577,11.512 C25.246,11.512 24.943,11.621 24.669,11.835 L24.669,15.223 L23.848,15.223 L23.848,10.796 L24.53,10.796 L24.608,11.329 C24.765,11.131 24.929,10.987 25.101,10.897 C25.273,10.807 25.47,10.761 25.69,10.761 L25.69,10.761 Z M21.867,14.131 C21.599,14.353 21.346,14.463 21.107,14.463 C20.816,14.463 20.6,14.336 20.462,14.084 C20.322,13.831 20.252,13.442 20.252,12.918 C20.252,12.382 20.317,11.988 20.448,11.735 C20.579,11.482 20.785,11.355 21.064,11.355 C21.326,11.355 21.594,11.46 21.867,11.669 L21.867,14.131 Z M21.937,11.154 C21.599,10.84 21.247,10.683 20.881,10.683 C20.438,10.683 20.086,10.886 19.824,11.294 C19.562,11.702 19.431,12.252 19.431,12.944 C19.431,13.381 19.488,13.764 19.601,14.092 C19.715,14.421 19.879,14.677 20.095,14.861 C20.31,15.043 20.566,15.135 20.863,15.135 C21.212,15.135 21.547,14.987 21.867,14.691 L21.867,15.013 C21.867,15.526 21.791,15.892 21.64,16.114 C21.488,16.335 21.232,16.445 20.872,16.445 C20.54,16.445 20.156,16.355 19.72,16.174 L19.72,16.803 C20.092,17.019 20.499,17.127 20.941,17.127 C22.099,17.127 22.679,16.408 22.679,14.969 L22.679,10.796 L21.998,10.796 L21.937,11.154 Z M18.304,14.603 C18.485,14.603 18.663,14.574 18.838,14.516 L18.838,15.118 C18.587,15.223 18.322,15.276 18.043,15.276 C17.681,15.276 17.416,15.176 17.244,14.979 C17.072,14.781 16.986,14.475 16.986,14.062 L16.986,11.46 L16.367,11.46 L16.367,10.918 L17.021,10.814 L17.143,9.556 L17.807,9.556 L17.807,10.796 L18.82,10.796 L18.82,11.46 L17.807,11.46 L17.807,14.001 C17.807,14.222 17.844,14.377 17.917,14.467 C17.989,14.558 18.118,14.603 18.304,14.603 L18.304,14.603 Z M15.882,13.311 C16.008,13.498 16.069,13.727 16.069,14.001 C16.069,14.403 15.944,14.725 15.694,14.969 C15.444,15.214 15.109,15.336 14.69,15.336 C14.242,15.336 13.835,15.229 13.468,15.013 L13.468,14.419 C13.922,14.6 14.315,14.691 14.646,14.691 C14.862,14.691 15.029,14.633 15.148,14.52 C15.267,14.407 15.328,14.245 15.328,14.036 C15.328,13.786 15.168,13.582 14.847,13.424 L14.28,13.145 C13.756,12.889 13.494,12.487 13.494,11.94 C13.494,11.568 13.616,11.265 13.861,11.033 C14.105,10.799 14.423,10.683 14.812,10.683 C15.179,10.683 15.531,10.776 15.869,10.962 L15.869,11.556 C15.549,11.405 15.22,11.329 14.883,11.329 C14.684,11.329 14.527,11.381 14.411,11.487 C14.295,11.59 14.236,11.734 14.236,11.914 C14.236,12.06 14.275,12.182 14.354,12.281 C14.432,12.379 14.565,12.476 14.752,12.569 L15.284,12.831 C15.557,12.964 15.757,13.125 15.882,13.311 L15.882,13.311 Z M11.765,14.267 C11.62,14.538 11.395,14.673 11.094,14.673 C10.791,14.673 10.566,14.538 10.421,14.267 C10.275,13.997 10.203,13.576 10.203,13.005 C10.203,12.435 10.275,12.016 10.421,11.749 C10.566,11.48 10.791,11.346 11.094,11.346 C11.395,11.346 11.62,11.48 11.765,11.749 C11.911,12.016 11.983,12.435 11.983,13.005 C11.983,13.576 11.911,13.997 11.765,14.267 L11.765,14.267 Z M11.094,10.683 C10.54,10.683 10.117,10.883 9.823,11.286 C9.529,11.687 9.382,12.26 9.382,13.005 C9.382,13.756 9.529,14.333 9.823,14.734 C10.117,15.135 10.54,15.336 11.094,15.336 C11.646,15.336 12.069,15.135 12.363,14.734 C12.657,14.333 12.804,13.756 12.804,13.005 C12.804,12.26 12.657,11.687 12.363,11.286 C12.069,10.883 11.646,10.683 11.094,10.683 L11.094,10.683 Z M7.632,11.888 C7.477,12.097 7.263,12.202 6.99,12.202 L6.125,12.202 L6.125,9.844 L6.99,9.844 C7.263,9.844 7.477,9.948 7.632,10.155 C7.786,10.361 7.863,10.651 7.863,11.023 C7.863,11.39 7.786,11.678 7.632,11.888 L7.632,11.888 Z M7.937,9.408 C7.689,9.252 7.403,9.172 7.077,9.172 L5.304,9.172 L5.304,15.223 L6.125,15.223 L6.125,12.875 L7.077,12.875 C7.56,12.875 7.952,12.706 8.251,12.368 C8.551,12.03 8.701,11.583 8.701,11.023 C8.701,10.663 8.636,10.342 8.505,10.063 C8.374,9.784 8.184,9.565 7.937,9.408 L7.937,9.408 Z" id="Amazon-DATABASEAmazon-Aurora-PostgreSQL-instance-alternate_Resource-Icon_light-bg" fill="#C925D1"></path>
    </g>
</svg>`, FA = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Database/Res_Amazon-DynamoDB_Items_48</title>
    <g id="Icon-Resource/Database/Res_Amazon-DynamoDB_Items_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M35.375,40.5 C34.237,40.5 33.312,39.575 33.312,38.437 C33.312,37.3 34.237,36.375 35.375,36.375 C36.513,36.375 37.438,37.3 37.438,38.437 C37.438,39.575 36.513,40.5 35.375,40.5 L35.375,40.5 Z M35.375,34.375 C33.135,34.375 31.313,36.197 31.313,38.437 C31.313,40.678 33.135,42.5 35.375,42.5 C37.615,42.5 39.437,40.678 39.437,38.437 C39.437,36.197 37.615,34.375 35.375,34.375 L35.375,34.375 Z M35.375,25.625 C34.237,25.625 33.312,24.7 33.312,23.563 C33.312,22.425 34.237,21.5 35.375,21.5 C36.513,21.5 37.438,22.425 37.438,23.563 C37.438,24.7 36.513,25.625 35.375,25.625 L35.375,25.625 Z M35.375,19.5 C33.135,19.5 31.313,21.322 31.313,23.563 C31.313,25.803 33.135,27.625 35.375,27.625 C37.615,27.625 39.437,25.803 39.437,23.563 C39.437,21.322 37.615,19.5 35.375,19.5 L35.375,19.5 Z M35.375,6.625 C36.513,6.625 37.438,7.55 37.438,8.688 C37.438,9.825 36.513,10.75 35.375,10.75 C34.237,10.75 33.312,9.825 33.312,8.688 C33.312,7.55 34.237,6.625 35.375,6.625 L35.375,6.625 Z M35.375,12.75 C37.615,12.75 39.437,10.928 39.437,8.688 C39.437,6.447 37.615,4.625 35.375,4.625 C33.135,4.625 31.313,6.447 31.313,8.688 C31.313,10.928 33.135,12.75 35.375,12.75 L35.375,12.75 Z M4,43.125 L21.25,43.125 L21.25,33.75 L4,33.75 L4,43.125 Z M2,45.125 L23.25,45.125 L23.25,31.75 L2,31.75 L2,45.125 Z M4,28.25 L21.25,28.25 L21.25,18.875 L4,18.875 L4,28.25 Z M2,30.25 L23.25,30.25 L23.25,16.875 L2,16.875 L2,30.25 Z M4,13.375 L21.25,13.375 L21.25,4 L4,4 L4,13.375 Z M2,15.375 L23.25,15.375 L23.25,2 L2,2 L2,15.375 Z M26.75,43.125 L44,43.125 L44,33.75 L26.75,33.75 L26.75,43.125 Z M24.75,45.125 L46,45.125 L46,31.75 L24.75,31.75 L24.75,45.125 Z M26.75,28.25 L44,28.25 L44,18.875 L26.75,18.875 L26.75,28.25 Z M24.75,30.25 L46,30.25 L46,16.875 L24.75,16.875 L24.75,30.25 Z M26.75,13.375 L44,13.375 L44,4 L26.75,4 L26.75,13.375 Z M24.75,15.375 L46,15.375 L46,2 L24.75,2 L24.75,15.375 Z" id="Amazon-DATABASE_Amazon-DynamoDB_Items_Resource-Icon_light-bg" fill="#C925D1"></path>
    </g>
</svg>`, OA = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Database/Res_Amazon-Aurora_Amazon-Aurora-Instance-alternate_48</title>
    <g id="Icon-Resource/Database/Res_Amazon-Aurora_Amazon-Aurora-Instance-alternate_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M34.2512,25.9737 C34.0112,26.2057 33.7712,26.3237 33.5302,26.3237 C33.3782,26.3237 33.2552,26.2587 33.1652,26.1317 C33.0732,26.0047 33.0282,25.8317 33.0282,25.6137 C33.0282,25.3587 33.0852,25.1637 33.1972,25.0297 C33.3102,24.8947 33.4722,24.8277 33.6842,24.8277 C33.9012,24.8277 34.0912,24.8527 34.2512,24.9047 L34.2512,25.9737 Z M33.8252,21.5097 C33.4692,21.5097 33.1192,21.5497 32.7782,21.6297 C32.4362,21.7097 32.1592,21.8197 31.9472,21.9567 L31.9472,22.9517 C32.5812,22.7177 33.1152,22.6017 33.5522,22.6017 C33.8212,22.6017 34.0062,22.6687 34.1032,22.8037 C34.2022,22.9387 34.2512,23.1947 34.2512,23.5727 L34.2512,24.0747 C33.9162,23.9877 33.6362,23.9437 33.4102,23.9437 C32.8652,23.9437 32.4322,24.1017 32.1112,24.4177 C31.7912,24.7347 31.6322,25.1657 31.6322,25.7117 C31.6322,26.2287 31.7632,26.6337 32.0242,26.9287 C32.2872,27.2237 32.6442,27.3707 33.0942,27.3707 C33.3342,27.3707 33.5712,27.3107 33.8032,27.1907 C34.0362,27.0707 34.2142,26.9157 34.3382,26.7267 L34.4702,27.2287 L35.6262,27.2287 L35.6262,23.3217 C35.6262,22.6887 35.4842,22.2287 35.2002,21.9417 C34.9162,21.6547 34.4582,21.5097 33.8252,21.5097 L33.8252,21.5097 Z M30.8132,21.5967 C30.9302,21.5967 31.0452,21.6087 31.1622,21.6297 L31.1622,22.9517 C30.9582,22.9137 30.7662,22.8967 30.5832,22.8967 C30.2342,22.8967 29.9022,22.9837 29.5912,23.1587 L29.5912,27.2287 L28.0952,27.2287 L28.0952,21.6517 L29.3172,21.6517 L29.4812,22.3717 C29.7002,22.1037 29.9162,21.9067 30.1312,21.7827 C30.3462,21.6597 30.5732,21.5967 30.8132,21.5967 L30.8132,21.5967 Z M25.3732,25.8047 C25.2532,26.0917 25.0582,26.2357 24.7892,26.2357 C24.5202,26.2357 24.3252,26.0917 24.2052,25.8047 C24.0842,25.5177 24.0242,25.0647 24.0242,24.4457 C24.0242,23.8277 24.0842,23.3727 24.2052,23.0807 C24.3252,22.7897 24.5202,22.6447 24.7892,22.6447 C25.0582,22.6447 25.2532,22.7897 25.3732,23.0807 C25.4932,23.3727 25.5532,23.8277 25.5532,24.4457 C25.5532,25.0647 25.4932,25.5177 25.3732,25.8047 L25.3732,25.8047 Z M24.7892,21.5097 C24.0692,21.5097 23.5122,21.7647 23.1192,22.2737 C22.7272,22.7837 22.5292,23.5067 22.5292,24.4457 C22.5292,25.3767 22.7272,26.0967 23.1192,26.6067 C23.5122,27.1167 24.0692,27.3707 24.7892,27.3707 C25.5092,27.3707 26.0652,27.1167 26.4582,26.6067 C26.8522,26.0967 27.0482,25.3767 27.0482,24.4457 C27.0482,23.5067 26.8522,22.7837 26.4582,22.2737 C26.0652,21.7647 25.5092,21.5097 24.7892,21.5097 L24.7892,21.5097 Z M21.7442,21.5967 C21.8602,21.5967 21.9772,21.6087 22.0932,21.6297 L22.0932,22.9517 C21.8902,22.9137 21.6972,22.8967 21.5152,22.8967 C21.1652,22.8967 20.8342,22.9837 20.5222,23.1587 L20.5222,27.2287 L19.0262,27.2287 L19.0262,21.6517 L20.2492,21.6517 L20.4132,22.3717 C20.6312,22.1037 20.8472,21.9067 21.0622,21.7827 C21.2752,21.6597 21.5042,21.5967 21.7442,21.5967 L21.7442,21.5967 Z M16.2432,21.6517 L17.7392,21.6517 L17.7392,27.2287 L16.5172,27.2287 L16.3972,26.7267 C15.8362,27.1567 15.2972,27.3707 14.7812,27.3707 C14.3742,27.3707 14.0642,27.2287 13.8542,26.9447 C13.6432,26.6607 13.5372,26.2507 13.5372,25.7117 L13.5372,21.6517 L15.0322,21.6517 L15.0322,25.2437 C15.0322,25.5987 15.0722,25.8537 15.1522,26.0067 C15.2322,26.1597 15.3672,26.2357 15.5572,26.2357 C15.7742,26.2357 16.0032,26.1517 16.2432,25.9847 L16.2432,21.6517 Z M9.1932,24.3357 L9.8592,21.2037 L10.5462,24.3357 L9.1932,24.3357 Z M9.0732,19.6657 L6.9782,27.2287 L8.5822,27.2287 L8.9642,25.4277 L10.7752,25.4277 L11.1692,27.2287 L12.8502,27.2287 L10.7652,19.6657 L9.0732,19.6657 Z M40.5982,10.5747 C40.8192,10.8507 40.9302,11.2537 40.9302,11.7857 L40.9302,15.8777 L39.4362,15.8777 L39.4362,12.2107 C39.4362,11.8917 39.3912,11.6587 39.3042,11.5127 C39.2172,11.3677 39.0662,11.2937 38.8562,11.2937 C38.6302,11.2937 38.3832,11.3817 38.1142,11.5557 L38.1142,15.8777 L36.6192,15.8777 L36.6192,10.3007 L37.8422,10.3007 L37.9622,10.8037 C38.5432,10.3737 39.1012,10.1597 39.6312,10.1597 C40.0542,10.1597 40.3752,10.2977 40.5982,10.5747 L40.5982,10.5747 Z M32.7292,11.7317 C32.8482,11.4407 33.0432,11.2937 33.3122,11.2937 C33.5812,11.2937 33.7752,11.4407 33.8972,11.7317 C34.0162,12.0227 34.0752,12.4777 34.0752,13.0947 C34.0752,13.7137 34.0162,14.1667 33.8972,14.4537 C33.7752,14.7417 33.5812,14.8847 33.3122,14.8847 C33.0432,14.8847 32.8482,14.7417 32.7292,14.4537 C32.6082,14.1667 32.5482,13.7137 32.5482,13.0947 C32.5482,12.4777 32.6082,12.0227 32.7292,11.7317 L32.7292,11.7317 Z M33.3122,16.0207 C34.0332,16.0207 34.5892,15.7657 34.9812,15.2567 C35.3752,14.7467 35.5712,14.0277 35.5712,13.0947 C35.5712,12.1567 35.3752,11.4327 34.9812,10.9237 C34.5892,10.4137 34.0332,10.1597 33.3122,10.1597 C32.5922,10.1597 32.0352,10.4137 31.6432,10.9237 C31.2502,11.4327 31.0532,12.1567 31.0532,13.0947 C31.0532,14.0277 31.2502,14.7467 31.6432,15.2567 C32.0352,15.7657 32.5922,16.0207 33.3122,16.0207 L33.3122,16.0207 Z M30.3772,15.8777 L26.5032,15.8777 L26.5032,14.8207 L28.7612,11.4477 L26.5902,11.4477 L26.5902,10.3007 L30.3322,10.3007 L30.3322,11.3607 L28.0732,14.7327 L30.3772,14.7327 L30.3772,15.8777 Z M24.2322,14.6227 C23.9922,14.8557 23.7522,14.9727 23.5122,14.9727 C23.3592,14.9727 23.2372,14.9097 23.1472,14.7817 C23.0562,14.6547 23.0102,14.4817 23.0102,14.2637 C23.0102,14.0087 23.0662,13.8137 23.1792,13.6797 C23.2912,13.5447 23.4532,13.4777 23.6652,13.4777 C23.8832,13.4777 24.0722,13.5027 24.2322,13.5537 L24.2322,14.6227 Z M23.3922,12.5927 C22.8472,12.5927 22.4132,12.7517 22.0932,13.0677 C21.7722,13.3837 21.6132,13.8157 21.6132,14.3617 C21.6132,14.8777 21.7442,15.2847 22.0062,15.5777 C22.2692,15.8727 22.6252,16.0207 23.0752,16.0207 C23.3152,16.0207 23.5532,15.9597 23.7842,15.8397 C24.0182,15.7207 24.1952,15.5657 24.3192,15.3757 L24.4512,15.8777 L25.6072,15.8777 L25.6072,11.9707 C25.6072,11.3377 25.4662,10.8777 25.1822,10.5907 C24.8972,10.3037 24.4392,10.1597 23.8072,10.1597 C23.4502,10.1597 23.1012,10.1997 22.7602,10.2797 C22.4172,10.3597 22.1412,10.4687 21.9292,10.6067 L21.9292,11.6007 C22.5632,11.3677 23.0972,11.2507 23.5332,11.2507 C23.8032,11.2507 23.9872,11.3187 24.0842,11.4527 C24.1842,11.5867 24.2322,11.8437 24.2322,12.2217 L24.2322,12.7247 C23.8972,12.6377 23.6172,12.5927 23.3922,12.5927 L23.3922,12.5927 Z M19.0592,12.2007 C19.0592,11.8877 19.0182,11.6587 18.9342,11.5127 C18.8502,11.3677 18.7102,11.2937 18.5142,11.2937 C18.3032,11.2937 18.0632,11.3817 17.7942,11.5557 C17.8012,11.5927 17.8042,11.6327 17.8042,11.6767 L17.8042,11.8077 L17.8042,15.8777 L16.3102,15.8777 L16.3102,12.2007 C16.3102,11.8877 16.2682,11.6587 16.1842,11.5127 C16.1012,11.3677 15.9602,11.2937 15.7642,11.2937 C15.5602,11.2937 15.3222,11.3817 15.0542,11.5557 L15.0542,15.8777 L13.5592,15.8777 L13.5592,10.3007 L14.7812,10.3007 L14.9012,10.8037 C15.4832,10.3737 16.0282,10.1597 16.5382,10.1597 C17.0562,10.1597 17.4192,10.3807 17.6302,10.8257 C18.2262,10.3807 18.7792,10.1597 19.2882,10.1597 C19.6962,10.1597 20.0092,10.2997 20.2272,10.5787 C20.4452,10.8597 20.5552,11.2617 20.5552,11.7857 L20.5552,15.8777 L19.0592,15.8777 L19.0592,12.2007 Z M9.1932,12.9867 L9.8592,9.8537 L10.5462,12.9867 L9.1932,12.9867 Z M9.0732,8.3147 L6.9782,15.8777 L8.5822,15.8777 L8.9642,14.0777 L10.7752,14.0777 L11.1692,15.8777 L12.8502,15.8777 L10.7652,8.3147 L9.0732,8.3147 Z M43.9082,39.4607 C43.9082,41.9137 41.9132,43.9097 39.4612,43.9097 L8.4472,43.9097 C5.9952,43.9097 4.0002,41.9137 4.0002,39.4607 L4.0002,8.4487 C4.0002,5.9947 5.9952,3.9997 8.4472,3.9997 L39.4612,3.9997 C41.9132,3.9997 43.9082,5.9947 43.9082,8.4487 L43.9082,39.4607 Z M39.4612,1.9997 L8.4472,1.9997 C4.8932,1.9997 2.0002,4.8927 2.0002,8.4487 L2.0002,39.4607 C2.0002,43.0167 4.8932,45.9097 8.4472,45.9097 L39.4612,45.9097 C43.0162,45.9097 45.9082,43.0167 45.9082,39.4607 L45.9082,8.4487 C45.9082,4.8927 43.0162,1.9997 39.4612,1.9997 L39.4612,1.9997 Z" id="Amazon-DATABASEAmazon--Aurora-Amazon-Aurora-instance_Resource-Icon_light-bg" fill="#C925D1"></path>
    </g>
</svg>`, NA = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Database/Res_Amazon-Aurora-SQL-Server-Instance-Alternate_48</title>
    <g id="Icon-Resource/Database/Res_Amazon-Aurora-SQL-Server-Instance-Alternate_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M42.4685,9.5693 C42.5615,9.5693 42.6555,9.5793 42.7475,9.5953 L42.7475,10.6523 C42.5855,10.6233 42.4305,10.6083 42.2845,10.6083 C42.0055,10.6083 41.7405,10.6783 41.4905,10.8183 L41.4905,14.0753 L40.2945,14.0753 L40.2945,9.6143 L41.2725,9.6143 L41.4045,10.1893 C41.5775,9.9743 41.7515,9.8173 41.9225,9.7173 C42.0945,9.6193 42.2775,9.5693 42.4685,9.5693 L42.4685,9.5693 Z M38.4605,11.3943 L37.2905,11.3943 C37.3145,10.6733 37.5345,10.3123 37.9535,10.3123 C38.1295,10.3123 38.2575,10.3803 38.3385,10.5163 C38.4195,10.6543 38.4605,10.8793 38.4605,11.1933 L38.4605,11.3943 Z M39.4735,11.3153 C39.4735,10.1053 38.9795,9.5003 37.9895,9.5003 C37.4135,9.5003 36.9715,9.7013 36.6665,10.1023 C36.3615,10.5043 36.2075,11.0863 36.2075,11.8483 C36.2075,13.4093 36.8305,14.1883 38.0765,14.1883 C38.3155,14.1883 38.5545,14.1593 38.7925,14.1013 C39.0315,14.0433 39.2325,13.9623 39.3955,13.8563 L39.3955,13.0613 C39.2025,13.1323 39.0095,13.1883 38.8155,13.2323 C38.6185,13.2763 38.4545,13.2983 38.3215,13.2983 C37.9655,13.2983 37.7095,13.2103 37.5535,13.0363 C37.3965,12.8613 37.3085,12.5643 37.2905,12.1453 L39.3865,12.1453 C39.4445,11.8953 39.4735,11.6183 39.4735,11.3153 L39.4735,11.3153 Z M34.6285,9.6143 L35.8595,9.6143 L34.5235,14.0753 L33.3975,14.0753 L32.0525,9.6143 L33.3195,9.6143 L33.9645,12.7923 L34.6285,9.6143 Z M31.3635,9.5693 C31.4555,9.5693 31.5485,9.5793 31.6425,9.5953 L31.6425,10.6523 C31.4795,10.6233 31.3255,10.6083 31.1795,10.6083 C30.9005,10.6083 30.6345,10.6783 30.3855,10.8183 L30.3855,14.0753 L29.1895,14.0753 L29.1895,9.6143 L30.1665,9.6143 L30.2975,10.1893 C30.4735,9.9743 30.6455,9.8173 30.8175,9.7173 C30.9895,9.6193 31.1705,9.5693 31.3635,9.5693 L31.3635,9.5693 Z M27.3555,11.3943 L26.1865,11.3943 C26.2085,10.6733 26.4295,10.3123 26.8495,10.3123 C27.0245,10.3123 27.1525,10.3803 27.2335,10.5163 C27.3155,10.6543 27.3555,10.8793 27.3555,11.1933 L27.3555,11.3943 Z M28.3685,11.3153 C28.3685,10.1053 27.8735,9.5003 26.8845,9.5003 C26.3085,9.5003 25.8665,9.7013 25.5615,10.1023 C25.2565,10.5043 25.1035,11.0863 25.1035,11.8483 C25.1035,13.4093 25.7255,14.1883 26.9725,14.1883 C27.2105,14.1883 27.4485,14.1593 27.6875,14.1013 C27.9265,14.0433 28.1265,13.9623 28.2895,13.8563 L28.2895,13.0613 C28.0975,13.1323 27.9055,13.1883 27.7095,13.2323 C27.5145,13.2763 27.3495,13.2983 27.2155,13.2983 C26.8615,13.2983 26.6055,13.2103 26.4475,13.0363 C26.2905,12.8613 26.2025,12.5643 26.1865,12.1453 L28.2815,12.1453 C28.3395,11.8953 28.3685,11.6183 28.3685,11.3153 L28.3685,11.3153 Z M24.3565,11.6773 C24.4405,11.8793 24.4825,12.1223 24.4825,12.4073 C24.4825,12.9603 24.3045,13.3983 23.9465,13.7213 C23.5875,14.0443 23.0945,14.2063 22.4665,14.2063 C22.1925,14.2063 21.9195,14.1733 21.6445,14.1093 C21.3715,14.0463 21.1415,13.9623 20.9555,13.8563 L20.9555,12.9403 C21.1705,13.0213 21.4145,13.0903 21.6855,13.1453 C21.9545,13.2013 22.1875,13.2283 22.3785,13.2283 C22.6575,13.2283 22.8705,13.1623 23.0155,13.0323 C23.1615,12.9003 23.2345,12.7133 23.2345,12.4683 C23.2345,12.2883 23.1835,12.1343 23.0815,12.0093 C22.9805,11.8853 22.8095,11.7573 22.5715,11.6303 L22.0995,11.3773 C21.6685,11.1443 21.3605,10.8943 21.1745,10.6263 C20.9875,10.3593 20.8945,10.0323 20.8945,9.6483 C20.8945,9.2933 20.9765,8.9833 21.1395,8.7183 C21.3015,8.4533 21.5245,8.2513 21.8065,8.1073 C22.0885,7.9653 22.4135,7.8933 22.7805,7.8933 C23.2395,7.8933 23.6975,7.9983 24.1515,8.2083 L24.1515,9.1323 C23.6795,8.9593 23.2635,8.8713 22.9035,8.8713 C22.6575,8.8713 22.4665,8.9323 22.3265,9.0543 C22.1875,9.1773 22.1165,9.3453 22.1165,9.5603 C22.1165,9.7413 22.1615,9.8893 22.2515,10.0063 C22.3425,10.1233 22.5155,10.2513 22.7725,10.3903 L23.2425,10.6433 C23.5455,10.8063 23.7855,10.9693 23.9635,11.1323 C24.1415,11.2963 24.2715,11.4773 24.3565,11.6773 L24.3565,11.6773 Z M16.5985,13.1063 L18.6595,13.1063 L18.6595,14.0753 L15.3765,14.0753 L15.3765,8.0243 L16.5985,8.0243 L16.5985,13.1063 Z M12.7925,12.6703 C12.5945,13.0363 12.3035,13.2193 11.9195,13.2193 C11.5345,13.2193 11.2435,13.0363 11.0465,12.6703 C10.8485,12.3023 10.7495,11.7613 10.7495,11.0463 C10.7495,10.3123 10.8455,9.7683 11.0375,9.4133 C11.2305,9.0573 11.5245,8.8803 11.9195,8.8803 C12.3155,8.8803 12.6085,9.0573 12.8015,9.4133 C12.9925,9.7683 13.0895,10.3123 13.0895,11.0463 C13.0895,11.7613 12.9905,12.3023 12.7925,12.6703 L12.7925,12.6703 Z M13.9485,12.9923 C14.2135,12.4743 14.3465,11.8253 14.3465,11.0463 C14.3465,10.0443 14.1335,9.2683 13.7095,8.7183 C13.2835,8.1693 12.6885,7.8933 11.9195,7.8933 C11.1505,7.8933 10.5545,8.1693 10.1285,8.7183 C9.7045,9.2683 9.4915,10.0443 9.4915,11.0463 C9.4915,12.0233 9.6925,12.7873 10.0945,13.3373 C10.4955,13.8873 11.0635,14.1763 11.7965,14.2063 C12.0995,14.5663 12.4635,14.8673 12.8885,15.1053 C13.3135,15.3433 13.7565,15.4983 14.2155,15.5673 L14.2155,14.5733 C13.8965,14.5383 13.6245,14.4793 13.4035,14.3973 C13.1825,14.3163 12.9825,14.2033 12.8015,14.0573 C13.3015,13.8653 13.6845,13.5103 13.9485,12.9923 L13.9485,12.9923 Z M8.6235,11.6773 C8.7075,11.8793 8.7495,12.1223 8.7495,12.4073 C8.7495,12.9603 8.5715,13.3983 8.2135,13.7213 C7.8555,14.0443 7.3615,14.2063 6.7345,14.2063 C6.4595,14.2063 6.1865,14.1733 5.9115,14.1093 C5.6395,14.0463 5.4085,13.9623 5.2235,13.8563 L5.2235,12.9403 C5.4385,13.0213 5.6815,13.0903 5.9515,13.1453 C6.2225,13.2013 6.4535,13.2283 6.6465,13.2283 C6.9245,13.2283 7.1385,13.1623 7.2825,13.0323 C7.4285,12.9003 7.5015,12.7133 7.5015,12.4683 C7.5015,12.2883 7.4495,12.1343 7.3485,12.0093 C7.2465,11.8853 7.0765,11.7573 6.8375,11.6303 L6.3655,11.3773 C5.9355,11.1443 5.6265,10.8943 5.4415,10.6263 C5.2545,10.3593 5.1615,10.0323 5.1615,9.6483 C5.1615,9.2933 5.2435,8.9833 5.4055,8.7183 C5.5695,8.4533 5.7915,8.2513 6.0735,8.1073 C6.3565,7.9653 6.6815,7.8933 7.0475,7.8933 C7.5075,7.8933 7.9645,7.9983 8.4185,8.2083 L8.4185,9.1323 C7.9465,8.9593 7.5305,8.8713 7.1705,8.8713 C6.9245,8.8713 6.7345,8.9323 6.5945,9.0543 C6.4535,9.1773 6.3845,9.3453 6.3845,9.5603 C6.3845,9.7413 6.4285,9.8893 6.5195,10.0063 C6.6095,10.1233 6.7815,10.2513 7.0385,10.3903 L7.5095,10.6433 C7.8135,10.8063 8.0525,10.9693 8.2315,11.1323 C8.4075,11.2963 8.5385,11.4773 8.6235,11.6773 L8.6235,11.6773 Z M43.9085,40.1173 C43.9085,42.2083 42.2075,43.9083 40.1165,43.9083 L7.7905,43.9083 C5.6995,43.9083 3.9995,42.2083 3.9995,40.1173 L3.9995,7.7913 C3.9995,5.7003 5.6995,4.0003 7.7905,4.0003 L40.1165,4.0003 C42.2075,4.0003 43.9085,5.7003 43.9085,7.7913 L43.9085,40.1173 Z M40.1165,2.0003 L7.7905,2.0003 C4.5975,2.0003 1.9995,4.5973 1.9995,7.7913 L1.9995,40.1173 C1.9995,43.3103 4.5975,45.9083 7.7905,45.9083 L40.1165,45.9083 C43.3105,45.9083 45.9085,43.3103 45.9085,40.1173 L45.9085,7.7913 C45.9085,4.5973 43.3105,2.0003 40.1165,2.0003 L40.1165,2.0003 Z" id="Amazon-DATABASEAmazon-Aurora-SQL-Server-instance-alternate_Resource-Icon_light-bg" fill="#C925D1"></path>
    </g>
</svg>`, qi = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Database/Res_Amazon-Aurora_Amazon-RDS-Instance_48</title>
    <g id="Icon-Resource/Database/Res_Amazon-Aurora_Amazon-RDS-Instance_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M21.2395,25.3828 C20.9905,25.3828 20.6895,25.3468 20.3375,25.2758 C19.9865,25.2028 19.6705,25.1138 19.3905,25.0088 L19.3905,26.1988 C19.6325,26.3358 19.9305,26.4448 20.2865,26.5288 C20.6415,26.6118 20.9975,26.6538 21.3525,26.6538 C22.1705,26.6538 22.8105,26.4438 23.2755,26.0238 C23.7415,25.6048 23.9735,25.0348 23.9735,24.3168 C23.9735,23.9458 23.9185,23.6298 23.8095,23.3688 C23.6995,23.1088 23.5295,22.8718 23.2995,22.6598 C23.0675,22.4478 22.7565,22.2368 22.3625,22.0248 L21.7505,21.6948 C21.4175,21.5148 21.1925,21.3478 21.0745,21.1958 C20.9585,21.0448 20.8985,20.8518 20.8985,20.6168 C20.8985,20.3378 20.9905,20.1178 21.1725,19.9598 C21.3525,19.8008 21.6025,19.7208 21.9205,19.7208 C22.3885,19.7208 22.9295,19.8338 23.5435,20.0618 L23.5435,18.8598 C22.9535,18.5868 22.3585,18.4498 21.7615,18.4498 C21.2855,18.4498 20.8635,18.5428 20.4965,18.7288 C20.1295,18.9138 19.8405,19.1788 19.6285,19.5228 C19.4175,19.8668 19.3105,20.2698 19.3105,20.7308 C19.3105,21.2308 19.4305,21.6538 19.6735,22.0018 C19.9155,22.3498 20.3165,22.6748 20.8775,22.9778 L21.4885,23.3068 C21.7995,23.4728 22.0205,23.6378 22.1525,23.7998 C22.2845,23.9628 22.3505,24.1608 22.3505,24.3958 C22.3505,24.7138 22.2575,24.9568 22.0675,25.1268 C21.8785,25.2978 21.6025,25.3828 21.2395,25.3828 L21.2395,25.3828 Z M16.7695,22.4328 C16.7695,21.5408 16.6505,20.8848 16.4115,20.4638 C16.1745,20.0448 15.8015,19.8338 15.2945,19.8338 L14.6355,19.8338 L14.6355,25.2698 L15.3045,25.2698 C15.7975,25.2698 16.1635,25.0558 16.4065,24.6288 C16.6475,24.1998 16.7695,23.5438 16.7695,22.6598 L16.7695,22.4328 Z M17.6425,19.6188 C18.1495,20.2848 18.4025,21.2598 18.4025,22.5458 C18.4025,23.8398 18.1535,24.8198 17.6545,25.4858 C17.1545,26.1508 16.4285,26.4838 15.4755,26.4838 L13.0485,26.4838 L13.0485,18.6208 L15.4195,18.6208 C16.3945,18.6208 17.1355,18.9538 17.6425,19.6188 L17.6425,19.6188 Z M10.2005,21.0938 C10.2005,20.6708 10.1225,20.3498 9.9685,20.1298 C9.8125,19.9098 9.5875,19.8008 9.2925,19.8008 L8.5545,19.8008 L8.5545,22.3878 L9.2925,22.3878 C9.5875,22.3878 9.8125,22.2788 9.9685,22.0588 C10.1225,21.8388 10.2005,21.5178 10.2005,21.0938 L10.2005,21.0938 Z M10.5865,23.3298 L12.1745,26.4838 L10.5415,26.4838 L9.1685,23.5678 L8.5545,23.5678 L8.5545,26.4838 L7.0015,26.4838 L7.0015,18.6208 L9.4855,18.6208 C10.1815,18.6208 10.7355,18.8418 11.1475,19.2848 C11.5595,19.7268 11.7655,20.3298 11.7655,21.0938 C11.7655,21.6228 11.6635,22.0808 11.4605,22.4668 C11.2555,22.8528 10.9645,23.1408 10.5865,23.3298 L10.5865,23.3298 Z M41.5935,15.1378 L41.5935,10.8828 C41.5935,10.3308 41.4775,9.9108 41.2475,9.6228 C41.0155,9.3358 40.6805,9.1928 40.2435,9.1928 C39.6905,9.1928 39.1125,9.4158 38.5075,9.8618 L38.3825,9.3398 L37.1115,9.3398 L37.1115,15.1378 L38.6655,15.1378 L38.6655,10.6448 C38.9455,10.4628 39.2025,10.3718 39.4365,10.3718 C39.6565,10.3718 39.8115,10.4478 39.9025,10.5988 C39.9935,10.7508 40.0385,10.9928 40.0385,11.3248 L40.0385,15.1378 L41.5935,15.1378 Z M34.4685,12.2448 C34.4685,11.6018 34.4055,11.1288 34.2805,10.8258 C34.1565,10.5238 33.9535,10.3718 33.6745,10.3718 C33.3945,10.3718 33.1915,10.5238 33.0665,10.8258 C32.9425,11.1288 32.8795,11.6018 32.8795,12.2448 C32.8795,12.8878 32.9425,13.3588 33.0665,13.6568 C33.1915,13.9558 33.3945,14.1058 33.6745,14.1058 C33.9535,14.1058 34.1565,13.9558 34.2805,13.6568 C34.4055,13.3588 34.4685,12.8878 34.4685,12.2448 L34.4685,12.2448 Z M35.4105,9.9868 C35.8185,10.5158 36.0225,11.2688 36.0225,12.2448 C36.0225,13.2128 35.8185,13.9608 35.4105,14.4898 C35.0025,15.0208 34.4235,15.2848 33.6745,15.2848 C32.9265,15.2848 32.3465,15.0208 31.9375,14.4898 C31.5295,13.9608 31.3255,13.2128 31.3255,12.2448 C31.3255,11.2688 31.5295,10.5158 31.9375,9.9868 C32.3465,9.4568 32.9265,9.1928 33.6745,9.1928 C34.4235,9.1928 35.0025,9.4568 35.4105,9.9868 L35.4105,9.9868 Z M26.5945,15.1378 L30.6225,15.1378 L30.6225,13.9458 L28.2285,13.9458 L30.5765,10.4408 L30.5765,9.3398 L26.6845,9.3398 L26.6845,10.5308 L28.9425,10.5308 L26.5945,14.0368 L26.5945,15.1378 Z M24.2335,13.8328 L24.2335,12.7208 C24.0675,12.6678 23.8715,12.6418 23.6435,12.6418 C23.4255,12.6418 23.2565,12.7118 23.1395,12.8518 C23.0215,12.9908 22.9635,13.1948 22.9635,13.4578 C22.9635,13.6858 23.0105,13.8648 23.1055,13.9968 C23.2005,14.1298 23.3265,14.1948 23.4855,14.1948 C23.7355,14.1948 23.9845,14.0738 24.2335,13.8328 L24.2335,13.8328 Z M23.7695,15.0988 C23.5265,15.2228 23.2815,15.2848 23.0315,15.2848 C22.5625,15.2848 22.1915,15.1328 21.9205,14.8248 C21.6475,14.5198 21.5105,14.0978 21.5105,13.5608 C21.5105,12.9928 21.6775,12.5448 22.0105,12.2158 C22.3435,11.8868 22.7935,11.7228 23.3605,11.7228 C23.5945,11.7228 23.8855,11.7688 24.2335,11.8588 L24.2335,11.3368 C24.2335,10.9438 24.1825,10.6768 24.0815,10.5368 C23.9785,10.3978 23.7885,10.3268 23.5085,10.3268 C23.0535,10.3268 22.4985,10.4478 21.8415,10.6898 L21.8415,9.6568 C22.0595,9.5138 22.3465,9.4008 22.7025,9.3178 C23.0575,9.2348 23.4215,9.1928 23.7915,9.1928 C24.4495,9.1928 24.9265,9.3418 25.2215,9.6408 C25.5165,9.9398 25.6645,10.4178 25.6645,11.0758 L25.6645,15.1378 L24.4615,15.1378 L24.3255,14.6158 C24.1965,14.8128 24.0105,14.9728 23.7695,15.0988 L23.7695,15.0988 Z M20.4105,15.1378 L20.4105,10.8828 C20.4105,10.3378 20.2975,9.9208 20.0705,9.6288 C19.8435,9.3378 19.5175,9.1928 19.0945,9.1928 C18.5655,9.1928 17.9905,9.4228 17.3705,9.8848 C17.1505,9.4228 16.7725,9.1928 16.2365,9.1928 C15.7065,9.1928 15.1385,9.4158 14.5345,9.8618 L14.4085,9.3398 L13.1375,9.3398 L13.1375,15.1378 L14.6925,15.1378 L14.6925,10.6448 C14.9715,10.4628 15.2185,10.3718 15.4295,10.3718 C15.6345,10.3718 15.7805,10.4478 15.8675,10.5988 C15.9545,10.7508 15.9975,10.9888 15.9975,11.3148 L15.9975,15.1378 L17.5515,15.1378 L17.5515,10.9048 L17.5515,10.7698 C17.5515,10.7238 17.5485,10.6828 17.5405,10.6448 C17.8205,10.4628 18.0705,10.3718 18.2895,10.3718 C18.4935,10.3718 18.6385,10.4478 18.7265,10.5988 C18.8125,10.7508 18.8565,10.9888 18.8565,11.3148 L18.8565,15.1378 L20.4105,15.1378 Z M10.0085,12.1318 L9.2925,8.8748 L8.6005,12.1318 L10.0085,12.1318 Z M12.4015,15.1378 L10.6545,15.1378 L10.2455,13.2658 L8.3625,13.2658 L7.9655,15.1378 L6.2975,15.1378 L8.4755,7.2758 L10.2345,7.2758 L12.4015,15.1378 Z M44.0025,30.0058 L44.0025,26.4708 C42.2715,27.4138 39.6485,27.9028 37.0365,27.9028 C34.4245,27.9028 31.8015,27.4138 30.0715,26.4708 L30.0715,30.0058 C30.0715,30.6348 32.4405,32.1098 37.0365,32.1098 C41.6325,32.1098 44.0025,30.6348 44.0025,30.0058 L44.0025,30.0058 Z M44.0025,36.1038 L44.0025,32.6778 C42.2715,33.6208 39.6485,34.1098 37.0365,34.1098 C34.4245,34.1098 31.8015,33.6208 30.0715,32.6778 L30.0715,36.1038 C30.0715,36.7328 32.4405,38.2068 37.0365,38.2068 C41.6325,38.2068 44.0025,36.7328 44.0025,36.1038 L44.0025,36.1038 Z M44.0025,41.5478 L44.0025,38.7758 C42.2715,39.7188 39.6485,40.2068 37.0365,40.2068 C34.4245,40.2068 31.8015,39.7188 30.0715,38.7758 L30.0715,41.5478 C30.0715,42.1768 32.4405,43.6518 37.0365,43.6518 C41.6325,43.6518 44.0025,42.1768 44.0025,41.5478 L44.0025,41.5478 Z M30.0715,23.7988 C30.0715,24.4278 32.4405,25.9028 37.0365,25.9028 C41.6325,25.9028 44.0025,24.4278 44.0025,23.7988 C44.0025,23.1698 41.6325,21.6948 37.0365,21.6948 C32.4405,21.6948 30.0715,23.1698 30.0715,23.7988 L30.0715,23.7988 Z M46.0025,23.7988 L46.0025,41.5478 C46.0025,44.2418 41.4915,45.6518 37.0365,45.6518 C32.5815,45.6518 28.0715,44.2418 28.0715,41.5478 L28.0715,23.7988 C28.0715,21.1048 32.5815,19.6958 37.0365,19.6958 C41.4915,19.6958 46.0025,21.1048 46.0025,23.7988 L46.0025,23.7988 Z M7.7545,43.8918 L27.4365,43.8918 L27.4365,45.8918 L7.7545,45.8918 C4.5815,45.8918 2.0005,43.3108 2.0005,40.1378 L2.0005,7.7548 C2.0005,4.5818 4.5815,1.9998 7.7545,1.9998 L40.1365,1.9998 C43.3095,1.9998 45.8915,4.5818 45.8915,7.7548 L45.8915,20.4548 L43.8915,20.4548 L43.8915,7.7548 C43.8915,5.6848 42.2075,3.9998 40.1365,3.9998 L7.7545,3.9998 C5.6835,3.9998 4.0005,5.6848 4.0005,7.7548 L4.0005,40.1378 C4.0005,42.2078 5.6835,43.8918 7.7545,43.8918 L7.7545,43.8918 Z" id="Amazon-DATABASEAmazon-Aurora-Amazon-RDS-instance_Res_48" fill="#C925D1"></path>
    </g>
</svg>`, DA = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Database/Res_Amazon-RDS_Multi-AZ_48</title>
    <g id="Icon-Resource/Database/Res_Amazon-RDS_Multi-AZ_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M38.19,30.446 C34.106,30.446 32.001,29.29 32.001,28.797 L32.001,26.21 C33.696,26.908 35.977,27.193 37.962,27.193 C40.52,27.193 42.596,26.789 44.001,26.083 L44.001,28.797 C44.001,29.373 42.004,30.446 38.19,30.446 L38.19,30.446 Z M38.19,16.247 C42.059,16.247 44.001,17.38 44.001,18.015 C44.001,18.65 42.059,19.783 38.19,19.783 C34.106,19.783 32.001,18.544 32.001,18.015 C32.001,17.486 34.106,16.247 38.19,16.247 L38.19,16.247 Z M32.001,20.591 C33.602,21.399 35.944,21.783 38.19,21.783 C40.618,21.783 42.626,21.371 44.001,20.662 L44.001,23.473 C43.995,24.092 41.979,25.193 37.962,25.193 C35.116,25.193 32.941,24.613 32.001,23.979 L32.001,20.591 Z M12.244,38.381 C6.889,38.381 4.001,36.942 4.001,35.587 L4.001,31.037 C6.088,32.242 9.506,32.81 12.769,32.81 C16.34,32.81 19.212,32.196 21.001,31.141 L21.001,35.587 C21.001,36.758 17.958,38.381 12.244,38.381 L12.244,38.381 Z M12.77,9.7 C18.086,9.7 21.025,11.237 21.025,12.3 C21.025,12.315 21.018,12.331 21.017,12.346 L21.001,12.346 L21.001,12.445 C20.752,13.497 17.849,14.899 12.77,14.899 C7.417,14.899 4.001,13.359 4.001,12.3 C4.001,11.24 7.417,9.7 12.77,9.7 L12.77,9.7 Z M4.001,20.017 L4.001,15.118 C6.088,16.327 9.506,16.899 12.77,16.899 C16.333,16.899 19.209,16.272 21.001,15.21 L21.001,20.159 C20.775,21.176 18.087,22.612 12.769,22.612 C7.424,22.612 4.011,21.077 4.001,20.017 L4.001,20.017 Z M12.769,24.612 C16.344,24.612 19.213,23.995 21.001,22.936 L21.001,28.38 C20.768,29.387 18.072,30.81 12.769,30.81 C7.424,30.81 4.011,29.287 4.001,28.235 L4.001,22.831 C6.088,24.041 9.506,24.612 12.769,24.612 L12.769,24.612 Z M46.002,23.47 L46.001,23.47 L46.001,18.346 L45.971,18.346 C45.987,18.237 46.001,18.128 46.001,18.015 C46.001,15.761 42.862,14.247 38.19,14.247 C34.246,14.247 30.001,15.426 30.001,18.015 C30.001,18.129 30.019,18.238 30.035,18.346 L30.001,18.346 L30.001,22.041 L23.001,22.041 L23.001,20.337 C23.003,20.32 23.009,20.304 23.01,20.287 L23.001,20.286 L23.001,12.558 C23.009,12.472 23.025,12.387 23.025,12.3 C23.025,9.549 18.904,7.7 12.77,7.7 C7.584,7.7 2.001,9.14 2.001,12.3 C2.001,12.316 2.005,12.33 2.006,12.346 L2.001,12.346 L2.001,20.012 L2,20.012 C2,20.015 2.001,20.018 2.001,20.021 L2.001,28.23 L2,28.23 C2,28.233 2.001,28.235 2.001,28.238 L2.001,35.587 C2.001,38.544 5.925,40.381 12.244,40.381 C18.677,40.381 23.001,38.454 23.001,35.587 L23.001,28.566 C23.002,28.557 23.005,28.548 23.006,28.538 L23.001,28.538 L23.001,24.041 L30.001,24.041 L30.001,28.797 C30.001,31.318 34.114,32.446 38.19,32.446 C42.935,32.446 46.001,31.014 46.001,28.797 L46.001,23.481 C46.001,23.477 46.002,23.474 46.002,23.47 L46.002,23.47 Z" id="Fill-1" fill="#C925D1"></path>
    </g>
</svg>`, PA = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Database/Res_Amazon-DocumentDB_Elastic-Clusters_48</title>
    <g id="Icon-Resource/Database/Res_Amazon-DocumentDB_Elastic-Clusters_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M27.9229,34.009 C30.9139,33.502 31.9999,32.53 31.9999,32.001 L31.9999,29.52 C30.0539,30.437 26.9669,30.806 23.9999,30.806 C21.0329,30.806 17.9459,30.437 15.9999,29.52 L15.9999,32.001 C15.9999,32.53 17.0859,33.502 20.0769,34.009 C20.7399,34.121 21.4439,34.205 22.1699,34.257 C22.4669,34.279 22.7669,34.295 23.0699,34.305 C23.6839,34.328 24.3189,34.328 24.9279,34.305 C25.2339,34.295 25.5329,34.279 25.8279,34.257 C26.5559,34.205 27.2599,34.121 27.9229,34.009 L27.9229,34.009 Z M15.9999,27.094 C16.1199,27.593 18.5929,28.806 23.9999,28.806 C29.4009,28.806 31.8739,27.597 31.9999,27.09 L31.9999,23.953 C30.0129,24.908 26.8599,25.29 23.9999,25.29 C21.1409,25.29 17.9869,24.908 15.9999,23.953 L15.9999,27.094 Z M15.9999,21.506 C16.1059,22.01 18.6419,23.29 23.9999,23.29 C29.3589,23.29 31.8949,22.01 31.9999,21.501 L31.9999,18.357 C30.0799,19.321 27.0349,19.774 23.9999,19.774 C20.9649,19.774 17.9199,19.321 15.9999,18.357 L15.9999,21.506 Z M16.0189,15.905 C16.2279,16.458 18.8139,17.774 23.9999,17.774 C29.1829,17.774 31.7689,16.459 31.9809,15.903 C31.7849,15.076 29.0569,13.677 23.9999,13.677 C18.9389,13.677 16.2109,15.078 16.0189,15.905 L16.0189,15.905 Z M28.2569,35.981 C27.5309,36.104 26.7629,36.196 25.9729,36.252 C25.6539,36.275 25.3289,36.293 24.9999,36.304 C24.6719,36.317 24.3379,36.322 23.9999,36.322 C23.6619,36.322 23.3279,36.317 22.9979,36.304 C22.6709,36.293 22.3459,36.275 22.0259,36.252 C21.2369,36.196 20.4689,36.104 19.7429,35.981 C16.0929,35.362 13.9999,33.911 13.9999,32.001 L13.9999,15.998 C13.9999,15.973 14.0069,15.949 14.0079,15.924 C14.0069,15.903 13.9999,15.883 13.9999,15.861 L14.0139,15.861 C14.1609,13.391 18.2199,11.677 23.9999,11.677 C29.7799,11.677 33.8389,13.391 33.9859,15.861 L33.9999,15.861 C33.9999,15.883 33.9929,15.903 33.9929,15.924 C33.9929,15.949 33.9999,15.973 33.9999,15.998 L33.9999,32.001 C33.9999,33.911 31.9069,35.362 28.2569,35.981 L28.2569,35.981 Z M44.9999,2 L38.9999,2 L38.9999,4 L42.5859,4 L36.5429,10.043 L37.9569,11.457 L43.9999,5.414 L43.9999,9 L45.9999,9 L45.9999,3 C45.9999,2.447 45.5529,2 44.9999,2 L44.9999,2 Z M1.9999,20 L3.9999,20 L3.9999,13 L1.9999,13 L1.9999,20 Z M1.9999,33 L3.9999,33 L3.9999,26 L1.9999,26 L1.9999,33 Z M43.9999,22 L45.9999,22 L45.9999,15 L43.9999,15 L43.9999,22 Z M43.9999,35 L45.9999,35 L45.9999,28 L43.9999,28 L43.9999,35 Z M3.9999,4 L6.9999,4 L6.9999,2 L2.9999,2 C2.4469,2 1.9999,2.447 1.9999,3 L1.9999,7 L3.9999,7 L3.9999,4 Z M12.9999,4 L19.9999,4 L19.9999,2 L12.9999,2 L12.9999,4 Z M25.9999,4 L32.9999,4 L32.9999,2 L25.9999,2 L25.9999,4 Z M14.9999,46 L21.9999,46 L21.9999,44 L14.9999,44 L14.9999,46 Z M27.9999,46 L34.9999,46 L34.9999,44 L27.9999,44 L27.9999,46 Z M43.9999,43.999 L40.9999,44 L40.9999,46 L44.9999,45.999 C45.5529,45.999 45.9999,45.551 45.9999,44.999 L45.9999,41 L43.9999,41 L43.9999,43.999 Z M11.4569,37.957 L5.4139,44 L8.9999,44 L8.9999,46 L2.9999,46 C2.4469,46 1.9999,45.552 1.9999,45 L1.9999,39 L3.9999,39 L3.9999,42.586 L10.0429,36.543 L11.4569,37.957 Z" id="Fill-1" fill="#C925D1"></path>
    </g>
</svg>`, BA = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Database/Res_Amazon-RDS_Trusted-Language-Extensions-for-PostgreSQL_48</title>
    <g id="Icon-Resource/Database/Res_Amazon-RDS_Trusted-Language-Extensions-for-PostgreSQL_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M26.033,30 L35.033,30 L35.033,28 L26.033,28 L26.033,30 Z M20.413,25.327 C19.064,25.327 18.391,24.375 18.391,22.471 C18.391,21.53 18.558,20.834 18.892,20.38 C19.226,19.927 19.739,19.7 20.431,19.7 C21.099,19.7 21.728,19.904 22.317,20.312 L22.317,24.664 C21.717,25.106 21.082,25.327 20.413,25.327 L20.413,25.327 Z M21.739,28.566 C21.354,28.957 20.736,29.152 19.887,29.152 C19.048,29.152 18.102,28.976 17.047,28.625 L17.047,30.053 C17.981,30.518 18.972,30.75 20.02,30.75 C21.396,30.75 22.459,30.376 23.204,29.628 C23.95,28.88 24.323,27.82 24.323,26.449 L24.323,18.391 L22.623,18.391 L22.453,19.173 C21.728,18.482 20.872,18.136 19.887,18.136 C19.161,18.136 18.532,18.323 17.999,18.697 C17.467,19.071 17.059,19.589 16.775,20.253 C16.492,20.916 16.351,21.678 16.351,22.539 C16.351,23.854 16.665,24.905 17.294,25.693 C17.923,26.481 18.765,26.874 19.818,26.874 C20.747,26.874 21.58,26.557 22.317,25.922 L22.317,26.653 C22.317,27.537 22.125,28.174 21.739,28.566 L21.739,28.566 Z M9.007,20.363 C9.63,19.932 10.31,19.717 11.046,19.717 C11.771,19.717 12.307,19.958 12.653,20.44 C12.998,20.922 13.171,21.661 13.171,22.658 C13.171,23.667 12.995,24.418 12.645,24.911 C12.293,25.403 11.755,25.65 11.029,25.65 C10.315,25.65 9.641,25.429 9.007,24.987 L9.007,20.363 Z M9.007,26.296 C9.335,26.591 9.721,26.82 10.162,26.984 C10.604,27.149 11.063,27.231 11.539,27.231 C12.287,27.231 12.938,27.033 13.494,26.636 C14.05,26.239 14.475,25.693 14.77,24.996 C15.063,24.298 15.211,23.497 15.211,22.59 C15.211,21.23 14.891,20.148 14.251,19.343 C13.61,18.539 12.752,18.136 11.676,18.136 C11.154,18.136 10.652,18.233 10.171,18.425 C9.689,18.618 9.25,18.896 8.854,19.258 L8.666,18.391 L7,18.391 L7,30.546 L9.007,30.546 L9.007,26.296 Z M32.033,4.65 L36.88,9 L32.033,9 L32.033,4.65 Z M39.701,8.844 L32.359,2.256 C32.176,2.091 31.937,2 31.691,2 L8.033,2 C7.48,2 7.033,2.448 7.033,3 L7.033,15 L9.033,15 L9.033,4 L30.033,4 L30.033,10 C30.033,10.552 30.48,11 31.033,11 L38.033,11 L38.033,44 L9.033,44 L9.033,34 L7.033,34 L7.033,45 C7.033,45.552 7.48,46 8.033,46 L39.033,46 C39.586,46 40.033,45.552 40.033,45 L40.033,9.588 C40.033,9.304 39.912,9.034 39.701,8.844 L39.701,8.844 Z" id="Fill-1" fill="#C925D1"></path>
    </g>
</svg>`, zA = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Database/Res_Amazon-Aurora-SQL-Server-Instance_48</title>
    <g id="Icon-Resource/Database/Res_Amazon-Aurora-SQL-Server-Instance_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M43.9636,29.9805 L43.9636,26.4505 C42.2346,27.3925 39.6146,27.8795 37.0056,27.8795 C34.3976,27.8795 31.7756,27.3925 30.0476,26.4505 L30.0476,29.9805 C30.0476,30.6085 32.4146,32.0815 37.0056,32.0815 C41.5966,32.0815 43.9636,30.6085 43.9636,29.9805 L43.9636,29.9805 Z M43.9636,36.0735 L43.9636,32.6515 C42.2346,33.5935 39.6146,34.0815 37.0056,34.0815 C34.3976,34.0815 31.7756,33.5935 30.0476,32.6515 L30.0476,36.0735 C30.0476,36.7015 32.4146,38.1735 37.0056,38.1735 C41.5966,38.1735 43.9636,36.7015 43.9636,36.0735 L43.9636,36.0735 Z M43.9636,41.5125 L43.9636,38.7445 C42.2346,39.6865 39.6146,40.1735 37.0056,40.1735 C34.3976,40.1735 31.7756,39.6865 30.0476,38.7445 L30.0476,41.5125 C30.0476,42.1405 32.4146,43.6135 37.0056,43.6135 C41.5966,43.6135 43.9636,42.1405 43.9636,41.5125 L43.9636,41.5125 Z M30.0476,23.7795 C30.0476,24.4075 32.4146,25.8795 37.0056,25.8795 C41.5966,25.8795 43.9636,24.4075 43.9636,23.7795 C43.9636,23.1515 41.5966,21.6785 37.0056,21.6785 C32.4146,21.6785 30.0476,23.1515 30.0476,23.7795 L30.0476,23.7795 Z M45.9636,23.7795 L45.9636,41.5125 C45.9636,44.2055 41.4566,45.6135 37.0056,45.6135 C32.5546,45.6135 28.0476,44.2055 28.0476,41.5125 L28.0476,23.7795 C28.0476,21.0865 32.5546,19.6785 37.0056,19.6785 C41.4566,19.6785 45.9636,21.0865 45.9636,23.7795 L45.9636,23.7795 Z M3.9996,40.1035 L3.9996,7.7505 C3.9996,5.6825 5.6826,4.0005 7.7496,4.0005 L40.1036,4.0005 C42.1706,4.0005 43.8536,5.6825 43.8536,7.7505 L43.8536,20.4385 L45.8536,20.4385 L45.8536,7.7505 C45.8536,4.5795 43.2746,2.0005 40.1036,2.0005 L7.7496,2.0005 C4.5786,2.0005 1.9996,4.5795 1.9996,7.7505 L1.9996,40.1035 C1.9996,43.2745 4.5786,45.8535 7.7496,45.8535 L27.4136,45.8535 L27.4136,43.8535 L7.7496,43.8535 C5.6826,43.8535 3.9996,42.1705 3.9996,40.1035 L3.9996,40.1035 Z M41.3526,10.1805 L41.2216,9.6055 L40.2456,9.6055 L40.2456,14.0605 L41.4396,14.0605 L41.4396,10.8085 C41.6896,10.6685 41.9536,10.5985 42.2336,10.5985 C42.3786,10.5985 42.5326,10.6145 42.6946,10.6425 L42.6946,9.5875 C42.6026,9.5705 42.5086,9.5615 42.4166,9.5615 C42.2246,9.5615 42.0416,9.6115 41.8716,9.7095 C41.6996,9.8085 41.5266,9.9655 41.3526,10.1805 L41.3526,10.1805 Z M38.4136,11.1835 C38.4136,10.8695 38.3726,10.6445 38.2916,10.5075 C38.2106,10.3715 38.0826,10.3025 37.9076,10.3025 C37.4896,10.3025 37.2686,10.6635 37.2456,11.3835 L38.4136,11.3835 L38.4136,11.1835 Z M39.3376,12.1335 L37.2456,12.1335 C37.2636,12.5525 37.3506,12.8485 37.5066,13.0235 C37.6636,13.1975 37.9186,13.2855 38.2746,13.2855 C38.4076,13.2855 38.5716,13.2625 38.7676,13.2185 C38.9616,13.1755 39.1556,13.1195 39.3466,13.0485 L39.3466,13.8425 C39.1846,13.9475 38.9836,14.0295 38.7446,14.0865 C38.5066,14.1445 38.2686,14.1735 38.0296,14.1735 C36.7866,14.1735 36.1636,13.3955 36.1636,11.8375 C36.1636,11.0765 36.3166,10.4955 36.6216,10.0935 C36.9276,9.6925 37.3666,9.4915 37.9426,9.4915 C38.9306,9.4915 39.4256,10.0965 39.4256,11.3055 C39.4256,11.6075 39.3956,11.8835 39.3376,12.1335 L39.3376,12.1335 Z M33.2776,9.6055 L32.0146,9.6055 L33.3576,14.0605 L34.4816,14.0605 L35.8166,9.6055 L34.5866,9.6055 L33.9236,12.7795 L33.2776,9.6055 Z M30.2616,10.1805 L30.1316,9.6055 L29.1536,9.6055 L29.1536,14.0605 L30.3496,14.0605 L30.3496,10.8085 C30.5986,10.6685 30.8636,10.5985 31.1436,10.5985 C31.2876,10.5985 31.4426,10.6145 31.6046,10.6425 L31.6046,9.5875 C31.5116,9.5705 31.4186,9.5615 31.3246,9.5615 C31.1336,9.5615 30.9516,9.6115 30.7796,9.7095 C30.6096,9.8085 30.4366,9.9655 30.2616,10.1805 L30.2616,10.1805 Z M26.1546,11.3835 L27.3226,11.3835 L27.3226,11.1835 C27.3226,10.8695 27.2816,10.6445 27.2006,10.5075 C27.1196,10.3715 26.9926,10.3025 26.8176,10.3025 C26.3996,10.3025 26.1786,10.6635 26.1546,11.3835 L26.1546,11.3835 Z M28.2566,13.8425 C28.0936,13.9475 27.8936,14.0295 27.6546,14.0865 C27.4166,14.1445 27.1786,14.1735 26.9406,14.1735 C25.6956,14.1735 25.0726,13.3955 25.0726,11.8375 C25.0726,11.0765 25.2266,10.4955 25.5306,10.0935 C25.8366,9.6925 26.2766,9.4915 26.8536,9.4915 C27.8406,9.4915 28.3346,10.0965 28.3346,11.3055 C28.3346,11.6075 28.3056,11.8835 28.2476,12.1335 L26.1546,12.1335 C26.1726,12.5525 26.2606,12.8485 26.4166,13.0235 C26.5736,13.1975 26.8286,13.2855 27.1836,13.2855 C27.3176,13.2855 27.4816,13.2625 27.6776,13.2185 C27.8716,13.1755 28.0646,13.1195 28.2566,13.0485 L28.2566,13.8425 Z M22.3536,13.2145 C22.1606,13.2145 21.9306,13.1875 21.6606,13.1315 C21.3896,13.0775 21.1476,13.0085 20.9316,12.9265 L20.9316,13.8425 C21.1166,13.9475 21.3476,14.0315 21.6206,14.0955 C21.8946,14.1595 22.1666,14.1915 22.4406,14.1915 C23.0676,14.1915 23.5616,14.0295 23.9186,13.7085 C24.2766,13.3845 24.4536,12.9475 24.4536,12.3945 C24.4536,12.1115 24.4126,11.8685 24.3276,11.6675 C24.2436,11.4665 24.1126,11.2855 23.9356,11.1225 C23.7586,10.9595 23.5186,10.7965 23.2166,10.6335 L22.7446,10.3805 C22.4896,10.2425 22.3166,10.1145 22.2266,9.9975 C22.1366,9.8805 22.0916,9.7335 22.0916,9.5525 C22.0916,9.3375 22.1606,9.1685 22.3006,9.0465 C22.4406,8.9245 22.6316,8.8645 22.8766,8.8645 C23.2366,8.8645 23.6516,8.9515 24.1226,9.1255 L24.1226,8.2015 C23.6696,7.9925 23.2136,7.8875 22.7536,7.8875 C22.3876,7.8875 22.0646,7.9595 21.7806,8.1015 C21.5006,8.2445 21.2766,8.4475 21.1156,8.7115 C20.9516,8.9765 20.8696,9.2855 20.8696,9.6405 C20.8696,10.0235 20.9636,10.3495 21.1496,10.6165 C21.3356,10.8845 21.6436,11.1335 22.0736,11.3665 L22.5446,11.6195 C22.7826,11.7475 22.9526,11.8745 23.0556,11.9985 C23.1566,12.1245 23.2076,12.2765 23.2076,12.4565 C23.2076,12.7005 23.1356,12.8875 22.9896,13.0185 C22.8446,13.1495 22.6316,13.2145 22.3536,13.2145 L22.3536,13.2145 Z M15.3606,8.0185 L15.3606,14.0605 L18.6396,14.0605 L18.6396,13.0925 L16.5806,13.0925 L16.5806,8.0185 L15.3606,8.0185 Z M13.0756,11.0355 C13.0756,10.3025 12.9806,9.7595 12.7876,9.4045 C12.5966,9.0495 12.3026,8.8735 11.9066,8.8735 C11.5126,8.8735 11.2196,9.0495 11.0266,9.4045 C10.8346,9.7595 10.7386,10.3025 10.7386,11.0355 C10.7386,11.7505 10.8376,12.2915 11.0346,12.6575 C11.2336,13.0235 11.5246,13.2065 11.9066,13.2065 C12.2916,13.2065 12.5816,13.0235 12.7786,12.6575 C12.9766,12.2915 13.0756,11.7505 13.0756,11.0355 L13.0756,11.0355 Z M12.7876,14.0425 C12.9686,14.1885 13.1696,14.3015 13.3896,14.3825 C13.6096,14.4645 13.8816,14.5225 14.2006,14.5575 L14.2006,15.5515 C13.7416,15.4815 13.2996,15.3275 12.8756,15.0895 C12.4506,14.8515 12.0876,14.5515 11.7856,14.1915 C11.0526,14.1625 10.4856,13.8735 10.0846,13.3245 C9.6846,12.7745 9.4846,12.0115 9.4846,11.0355 C9.4846,10.0355 9.6946,9.2605 10.1196,8.7115 C10.5446,8.1625 11.1406,7.8875 11.9066,7.8875 C12.6756,7.8875 13.2706,8.1625 13.6946,8.7115 C14.1196,9.2605 14.3316,10.0355 14.3316,11.0355 C14.3316,11.8145 14.1996,12.4615 13.9346,12.9785 C13.6696,13.4975 13.2886,13.8505 12.7876,14.0425 L12.7876,14.0425 Z M7.2776,13.0185 C7.4236,12.8875 7.4956,12.7005 7.4956,12.4565 C7.4956,12.2765 7.4436,12.1245 7.3436,11.9985 C7.2406,11.8745 7.0706,11.7475 6.8326,11.6195 L6.3616,11.3665 C5.9316,11.1335 5.6226,10.8845 5.4376,10.6165 C5.2516,10.3495 5.1576,10.0235 5.1576,9.6405 C5.1576,9.2855 5.2396,8.9765 5.4026,8.7115 C5.5656,8.4475 5.7886,8.2445 6.0686,8.1015 C6.3526,7.9595 6.6756,7.8875 7.0416,7.8875 C7.5016,7.8875 7.9576,7.9925 8.4106,8.2015 L8.4106,9.1255 C7.9406,8.9515 7.5246,8.8645 7.1646,8.8645 C6.9196,8.8645 6.7286,8.9245 6.5886,9.0465 C6.4486,9.1685 6.3796,9.3375 6.3796,9.5525 C6.3796,9.7335 6.4246,9.8805 6.5146,9.9975 C6.6046,10.1145 6.7776,10.2425 7.0326,10.3805 L7.5046,10.6335 C7.8066,10.7965 8.0466,10.9595 8.2236,11.1225 C8.4006,11.2855 8.5316,11.4665 8.6156,11.6675 C8.7006,11.8685 8.7416,12.1115 8.7416,12.3945 C8.7416,12.9475 8.5646,13.3845 8.2066,13.7085 C7.8496,14.0295 7.3566,14.1915 6.7286,14.1915 C6.4546,14.1915 6.1816,14.1595 5.9076,14.0955 C5.6356,14.0315 5.4046,13.9475 5.2196,13.8425 L5.2196,12.9265 C5.4356,13.0085 5.6776,13.0775 5.9476,13.1315 C6.2186,13.1875 6.4486,13.2145 6.6416,13.2145 C6.9196,13.2145 7.1316,13.1495 7.2776,13.0185 L7.2776,13.0185 Z" id="Amazon-DATABASEAmazon-Aurora-SQL-Server-instance_Resource-Icon_light-bg" fill="#C925D1"></path>
    </g>
</svg>`, UA = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Database/Res_Amazon-DynamoDB_Global-secondary-index_48</title>
    <g id="Icon-Resource/Database/Res_Amazon-DynamoDB_Global-secondary-index_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M22.901,11.836 L45.8,11.836 L45.8,2 L22.901,2 L22.901,11.836 Z M24.9,9.836 L43.799,9.836 L43.799,3.999 L24.9,3.999 L24.9,9.836 Z M12.45,11.836 L21.417,11.836 L21.417,2 L12.45,2 L12.45,11.836 Z M14.451,9.836 L19.417,9.836 L19.417,3.999 L14.451,3.999 L14.451,9.836 Z M2,11.836 L10.967,11.836 L10.967,2 L2,2 L2,11.836 Z M4,9.836 L8.967,9.836 L8.967,3.999 L4,3.999 L4,9.836 Z M22.901,23.158 L45.8,23.158 L45.8,13.32 L22.901,13.32 L22.901,23.158 Z M24.9,21.157 L43.799,21.157 L43.799,15.32 L24.9,15.32 L24.9,21.157 Z M12.45,23.158 L21.417,23.158 L21.417,13.32 L12.45,13.32 L12.45,23.158 Z M14.451,21.157 L19.417,21.157 L19.417,15.32 L14.451,15.32 L14.451,21.157 Z M2,23.158 L10.967,23.158 L10.967,13.32 L2,13.32 L2,23.158 Z M4,21.157 L8.967,21.157 L8.967,15.32 L4,15.32 L4,21.157 Z M22.901,34.478 L45.8,34.478 L45.8,24.641 L22.901,24.641 L22.901,34.478 Z M24.9,32.478 L43.799,32.478 L43.799,26.641 L24.9,26.641 L24.9,32.478 Z M12.45,34.478 L21.417,34.478 L21.417,24.641 L12.45,24.641 L12.45,34.478 Z M14.451,32.478 L19.417,32.478 L19.417,26.641 L14.451,26.641 L14.451,32.478 Z M2,34.478 L10.967,34.478 L10.967,24.641 L2,24.641 L2,34.478 Z M4,32.478 L8.967,32.478 L8.967,26.641 L4,26.641 L4,32.478 Z M22.901,45.799 L45.8,45.799 L45.8,35.961 L22.901,35.961 L22.901,45.799 Z M24.9,43.799 L43.799,43.799 L43.799,37.961 L24.9,37.961 L24.9,43.799 Z M12.45,45.799 L21.417,45.799 L21.417,35.961 L12.45,35.961 L12.45,45.799 Z M14.451,43.799 L19.417,43.799 L19.417,37.961 L14.451,37.961 L14.451,43.799 Z M2,45.799 L10.967,45.799 L10.967,35.961 L2,35.961 L2,45.799 Z M4,43.799 L8.967,43.799 L8.967,37.961 L4,37.961 L4,43.799 Z" id="Amazon-DATABASE_Amazon-DynamoDB_Global-Secondary-Index_Resource-Icon_light-bg" fill="#C925D1"></path>
    </g>
</svg>`, WA = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Database/Res_Amazon-Aurora-Oracle-Instance_48</title>
    <g id="Icon-Resource/Database/Res_Amazon-Aurora-Oracle-Instance_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M39.1755,13.039 C39.1755,12.554 39.1135,12.204 38.9865,11.991 C38.8605,11.779 38.6615,11.674 38.3915,11.674 C37.7415,11.674 37.3995,12.233 37.3635,13.351 L39.1755,13.351 L39.1755,13.039 Z M40.6105,14.515 L37.3635,14.515 C37.3915,15.163 37.5265,15.623 37.7695,15.894 C38.0135,16.164 38.4095,16.3 38.9585,16.3 C39.1665,16.3 39.4205,16.266 39.7235,16.198 C40.0265,16.131 40.3255,16.043 40.6225,15.935 L40.6225,17.166 C40.3705,17.328 40.0605,17.454 39.6905,17.544 C39.3205,17.635 38.9505,17.68 38.5805,17.68 C36.6515,17.68 35.6865,16.471 35.6865,14.055 C35.6865,12.873 35.9225,11.972 36.3955,11.349 C36.8695,10.726 37.5525,10.416 38.4465,10.416 C39.9785,10.416 40.7455,11.353 40.7455,13.229 C40.7455,13.699 40.6985,14.127 40.6105,14.515 L40.6105,14.515 Z M32.3045,7.494 L32.3045,15.745 C32.3045,16.368 32.4385,16.83 32.7035,17.132 C32.9695,17.434 33.3735,17.585 33.9135,17.585 C34.3115,17.585 34.6715,17.517 34.9955,17.382 L34.9955,16.138 C34.8075,16.164 34.6755,16.178 34.6045,16.178 C34.4235,16.178 34.3045,16.131 34.2455,16.036 C34.1865,15.942 34.1575,15.776 34.1575,15.542 L34.1575,7.494 L32.3045,7.494 Z M30.4105,17.51 C30.6985,17.434 30.9385,17.328 31.1275,17.193 L31.1275,15.962 C30.6855,16.133 30.2795,16.218 29.9095,16.218 C29.4415,16.218 29.1035,16.057 28.8965,15.732 C28.6885,15.406 28.5845,14.88 28.5845,14.148 L28.5845,13.96 C28.5845,13.229 28.6905,12.7 28.9035,12.37 C29.1135,12.041 29.4635,11.876 29.9505,11.876 C30.3025,11.876 30.6855,11.953 31.1005,12.106 L31.1005,10.875 C30.6225,10.605 30.1175,10.47 29.5855,10.47 C28.6835,10.47 27.9825,10.783 27.4835,11.41 C26.9825,12.037 26.7315,12.923 26.7315,14.068 C26.7315,15.231 26.9665,16.115 27.4355,16.719 C27.9045,17.323 28.5945,17.626 29.5045,17.626 C29.8205,17.626 30.1215,17.587 30.4105,17.51 L30.4105,17.51 Z M23.7685,14.623 C23.5715,14.56 23.3365,14.527 23.0665,14.527 C22.8045,14.527 22.6035,14.61 22.4635,14.777 C22.3235,14.945 22.2545,15.185 22.2545,15.502 C22.2545,15.772 22.3105,15.986 22.4235,16.144 C22.5365,16.302 22.6875,16.381 22.8765,16.381 C23.1735,16.381 23.4725,16.236 23.7685,15.948 L23.7685,14.623 Z M23.7685,13.595 L23.7685,12.973 C23.7685,12.504 23.7075,12.185 23.5865,12.018 C23.4655,11.852 23.2375,11.768 22.9045,11.768 C22.3625,11.768 21.6995,11.912 20.9155,12.2 L20.9155,10.971 C21.1765,10.799 21.5185,10.664 21.9435,10.564 C22.3665,10.466 22.7995,10.416 23.2415,10.416 C24.0265,10.416 24.5945,10.594 24.9465,10.95 C25.2975,11.307 25.4735,11.876 25.4735,12.661 L25.4735,17.503 L24.0395,17.503 L23.8775,16.881 C23.7245,17.116 23.5025,17.308 23.2145,17.456 C22.9255,17.605 22.6335,17.68 22.3355,17.68 C21.7765,17.68 21.3345,17.496 21.0095,17.132 C20.6855,16.767 20.5235,16.264 20.5235,15.623 C20.5235,14.946 20.7215,14.413 21.1175,14.021 C21.5145,13.628 22.0515,13.432 22.7275,13.432 C23.0065,13.432 23.3545,13.485 23.7685,13.595 L23.7685,13.595 Z M17.8575,11.484 L17.6545,10.592 L16.1405,10.592 L16.1405,17.503 L17.9935,17.503 L17.9935,12.458 C18.3805,12.241 18.7915,12.134 19.2245,12.134 C19.4495,12.134 19.6885,12.156 19.9415,12.2 L19.9415,10.564 C19.7975,10.537 19.6525,10.523 19.5085,10.523 C19.2105,10.523 18.9285,10.601 18.6625,10.754 C18.3975,10.907 18.1285,11.15 17.8575,11.484 L17.8575,11.484 Z M12.7185,12.81 C12.7185,11.674 12.5695,10.831 12.2725,10.28 C11.9735,9.73 11.5185,9.455 10.9045,9.455 C10.2915,9.455 9.8365,9.73 9.5395,10.28 C9.2405,10.831 9.0935,11.674 9.0935,12.81 C9.0935,13.919 9.2465,14.758 9.5535,15.326 C9.8595,15.894 10.3105,16.178 10.9045,16.178 C11.5005,16.178 11.9515,15.894 12.2585,15.326 C12.5655,14.758 12.7185,13.919 12.7185,12.81 L12.7185,12.81 Z M13.6785,9.205 C14.3355,10.058 14.6655,11.259 14.6655,12.81 C14.6655,14.361 14.3355,15.565 13.6785,16.421 C13.0205,17.278 12.0965,17.706 10.9045,17.706 C9.7155,17.706 8.7905,17.278 8.1325,16.421 C7.4735,15.565 7.1455,14.361 7.1455,12.81 C7.1455,11.259 7.4735,10.058 8.1325,9.205 C8.7905,8.352 9.7155,7.927 10.9045,7.927 C12.0965,7.927 13.0205,8.352 13.6785,9.205 L13.6785,9.205 Z M44.0005,30.004 L44.0005,26.47 C42.2715,27.413 39.6475,27.901 37.0345,27.901 C34.4235,27.901 31.8005,27.413 30.0705,26.47 L30.0705,30.004 C30.0705,30.633 32.4405,32.107 37.0345,32.107 C41.6305,32.107 44.0005,30.633 44.0005,30.004 L44.0005,30.004 Z M44.0005,36.101 L44.0005,32.676 C42.2715,33.619 39.6475,34.107 37.0345,34.107 C34.4235,34.107 31.8005,33.619 30.0705,32.676 L30.0705,36.101 C30.0705,36.73 32.4405,38.205 37.0345,38.205 C41.6305,38.205 44.0005,36.73 44.0005,36.101 L44.0005,36.101 Z M44.0005,41.546 L44.0005,38.773 C42.2715,39.717 39.6475,40.205 37.0345,40.205 C34.4235,40.205 31.8005,39.717 30.0705,38.773 L30.0705,41.546 C30.0705,42.175 32.4405,43.649 37.0345,43.649 C41.6305,43.649 44.0005,42.175 44.0005,41.546 L44.0005,41.546 Z M30.0705,23.798 C30.0705,24.427 32.4405,25.901 37.0345,25.901 C41.6305,25.901 44.0005,24.427 44.0005,23.798 C44.0005,23.169 41.6305,21.694 37.0345,21.694 C32.4405,21.694 30.0705,23.169 30.0705,23.798 L30.0705,23.798 Z M46.0005,23.798 L46.0005,41.546 C46.0005,44.24 41.4895,45.649 37.0345,45.649 C32.5795,45.649 28.0705,44.24 28.0705,41.546 L28.0705,23.798 C28.0705,21.103 32.5795,19.694 37.0345,19.694 C41.4895,19.694 46.0005,21.103 46.0005,23.798 L46.0005,23.798 Z M7.7545,43.89 L27.4355,43.89 L27.4355,45.89 L7.7545,45.89 C4.5815,45.89 1.9995,43.309 1.9995,40.136 L1.9995,7.755 C1.9995,4.582 4.5815,2 7.7545,2 L40.1355,2 C43.3085,2 45.8895,4.582 45.8895,7.755 L45.8895,20.454 L43.8895,20.454 L43.8895,7.755 C43.8895,5.685 42.2055,4 40.1355,4 L7.7545,4 C5.6845,4 3.9995,5.685 3.9995,7.755 L3.9995,40.136 C3.9995,42.206 5.6845,43.89 7.7545,43.89 L7.7545,43.89 Z" id="Amazon-DATABASEAmazon-Aurora-Oracle-instance_Resource-Icon_light-bg" fill="#C925D1"></path>
    </g>
</svg>`, HA = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Database/Res_Amazon-Aurora-Oracle-Instance-Alternate_48</title>
    <g id="Icon-Resource/Database/Res_Amazon-Aurora-Oracle-Instance-Alternate_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M43.9084,39.461 C43.9084,41.914 41.9134,43.909 39.4614,43.909 L8.4474,43.909 C5.9954,43.909 4.0004,41.914 4.0004,39.461 L4.0004,8.448 C4.0004,5.995 5.9954,4 8.4474,4 L39.4614,4 C41.9134,4 43.9084,5.995 43.9084,8.448 L43.9084,39.461 Z M39.4614,2 L8.4474,2 C4.8924,2 2.0004,4.893 2.0004,8.448 L2.0004,39.461 C2.0004,43.017 4.8924,45.909 8.4474,45.909 L39.4614,45.909 C43.0154,45.909 45.9084,43.017 45.9084,39.461 L45.9084,8.448 C45.9084,4.893 43.0154,2 39.4614,2 L39.4614,2 Z M39.1844,13.361 L37.3734,13.361 C37.4084,12.243 37.7514,11.684 38.4004,11.684 C38.6714,11.684 38.8694,11.789 38.9954,12.001 C39.1214,12.214 39.1844,12.564 39.1844,13.049 L39.1844,13.361 Z M40.7554,13.239 C40.7554,11.363 39.9874,10.426 38.4554,10.426 C37.5614,10.426 36.8794,10.736 36.4044,11.358 C35.9314,11.982 35.6954,12.883 35.6954,14.065 C35.6954,16.482 36.6604,17.69 38.5904,17.69 C38.9604,17.69 39.3294,17.645 39.6994,17.554 C40.0694,17.464 40.3804,17.338 40.6324,17.176 L40.6324,15.945 C40.3354,16.053 40.0354,16.141 39.7324,16.208 C39.4294,16.275 39.1764,16.31 38.9684,16.31 C38.4184,16.31 38.0224,16.174 37.7784,15.904 C37.5344,15.633 37.4004,15.173 37.3734,14.524 L40.6194,14.524 C40.7084,14.137 40.7554,13.709 40.7554,13.239 L40.7554,13.239 Z M34.6134,16.188 C34.6844,16.188 34.8164,16.174 35.0054,16.148 L35.0054,17.393 C34.6804,17.526 34.3204,17.595 33.9234,17.595 C33.3834,17.595 32.9784,17.443 32.7134,17.142 C32.4464,16.84 32.3134,16.378 32.3134,15.755 L32.3134,7.504 L34.1674,7.504 L34.1674,15.552 C34.1674,15.786 34.1954,15.952 34.2544,16.046 C34.3134,16.141 34.4324,16.188 34.6134,16.188 L34.6134,16.188 Z M29.9194,16.228 C30.2894,16.228 30.6944,16.143 31.1374,15.972 L31.1374,17.203 C30.9474,17.338 30.7084,17.443 30.4204,17.52 C30.1314,17.597 29.8294,17.636 29.5134,17.636 C28.6034,17.636 27.9134,17.333 27.4444,16.73 C26.9754,16.125 26.7404,15.241 26.7404,14.078 C26.7404,12.934 26.9904,12.047 27.4924,11.42 C27.9914,10.793 28.6924,10.48 29.5954,10.48 C30.1274,10.48 30.6324,10.615 31.1094,10.885 L31.1094,12.117 C30.6944,11.963 30.3104,11.886 29.9604,11.886 C29.4724,11.886 29.1234,12.051 28.9124,12.38 C28.6994,12.71 28.5944,13.239 28.5944,13.97 L28.5944,14.158 C28.5944,14.89 28.6974,15.417 28.9054,15.742 C29.1124,16.066 29.4504,16.228 29.9194,16.228 L29.9194,16.228 Z M23.7774,15.958 C23.4814,16.247 23.1824,16.391 22.8864,16.391 C22.6964,16.391 22.5454,16.312 22.4324,16.154 C22.3194,15.996 22.2634,15.782 22.2634,15.512 C22.2634,15.196 22.3334,14.955 22.4724,14.787 C22.6124,14.621 22.8124,14.537 23.0754,14.537 C23.3464,14.537 23.5804,14.569 23.7774,14.633 L23.7774,15.958 Z M23.2514,10.426 C22.8084,10.426 22.3764,10.476 21.9524,10.574 C21.5274,10.674 21.1854,10.809 20.9254,10.981 L20.9254,12.211 C21.7084,11.922 22.3714,11.778 22.9134,11.778 C23.2464,11.778 23.4744,11.861 23.5964,12.028 C23.7174,12.195 23.7774,12.514 23.7774,12.982 L23.7774,13.605 C23.3634,13.496 23.0154,13.442 22.7364,13.442 C22.0604,13.442 21.5234,13.638 21.1274,14.031 C20.7304,14.423 20.5324,14.956 20.5324,15.633 C20.5324,16.274 20.6944,16.776 21.0184,17.142 C21.3444,17.506 21.7854,17.69 22.3444,17.69 C22.6424,17.69 22.9344,17.615 23.2234,17.466 C23.5124,17.317 23.7334,17.126 23.8874,16.891 L24.0494,17.513 L25.4824,17.513 L25.4824,12.671 C25.4824,11.886 25.3064,11.316 24.9554,10.96 C24.6034,10.604 24.0354,10.426 23.2514,10.426 L23.2514,10.426 Z M19.5174,10.533 C19.6614,10.533 19.8064,10.547 19.9504,10.574 L19.9504,12.211 C19.6974,12.166 19.4594,12.144 19.2334,12.144 C18.8014,12.144 18.3894,12.251 18.0034,12.468 L18.0034,17.513 L16.1494,17.513 L16.1494,10.602 L17.6644,10.602 L17.8664,11.494 C18.1374,11.16 18.4064,10.917 18.6724,10.764 C18.9374,10.61 19.2204,10.533 19.5174,10.533 L19.5174,10.533 Z M12.2674,15.336 C11.9614,15.904 11.5104,16.188 10.9144,16.188 C10.3194,16.188 9.8684,15.904 9.5624,15.336 C9.2564,14.768 9.1014,13.929 9.1014,12.819 C9.1014,11.684 9.2504,10.841 9.5494,10.29 C9.8454,9.74 10.3014,9.465 10.9144,9.465 C11.5274,9.465 11.9824,9.74 12.2814,10.29 C12.5784,10.841 12.7274,11.684 12.7274,12.819 C12.7274,13.929 12.5744,14.768 12.2674,15.336 L12.2674,15.336 Z M10.9144,7.937 C9.7244,7.937 8.8004,8.362 8.1414,9.215 C7.4824,10.067 7.1534,11.269 7.1534,12.819 C7.1534,14.371 7.4824,15.575 8.1414,16.431 C8.8004,17.288 9.7244,17.716 10.9144,17.716 C12.1054,17.716 13.0294,17.288 13.6874,16.431 C14.3454,15.575 14.6754,14.371 14.6754,12.819 C14.6754,11.269 14.3454,10.067 13.6874,9.215 C13.0294,8.362 12.1054,7.937 10.9144,7.937 L10.9144,7.937 Z" id="Amazon-DATABASEAmazon-Aurora-Oracle-instance-alternate_Resource-Icon_light-bg" fill="#C925D1"></path>
    </g>
</svg>`, $A = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Database/Res_Amazon-DynamoDB_Stream_48</title>
    <g id="Icon-Resource/Database/Res_Amazon-DynamoDB_Stream_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M2,4 L46,4 L46,2 L2,2 L2,4 Z M2,46 L46,46 L46,44 L2,44 L2,46 Z M30.887,33.616 L38.611,35.696 L43.813,16.384 L36.088,14.304 L30.887,33.616 Z M39.317,37.922 C39.23,37.922 39.143,37.911 39.058,37.888 L29.401,35.287 C29.145,35.218 28.927,35.05 28.795,34.82 C28.662,34.59 28.627,34.317 28.695,34.061 L34.417,12.818 C34.486,12.562 34.654,12.344 34.884,12.211 C35.113,12.08 35.387,12.043 35.643,12.112 L45.298,14.713 C45.831,14.857 46.147,15.405 46.004,15.939 L40.283,37.182 C40.214,37.438 40.046,37.656 39.816,37.789 C39.663,37.876 39.491,37.922 39.317,37.922 L39.317,37.922 Z M17,34 L25,34 L25,14 L17,14 L17,34 Z M26,36 L16,36 C15.447,36 15,35.552 15,35 L15,13 C15,12.448 15.447,12 16,12 L26,12 C26.553,12 27,12.448 27,13 L27,35 C27,35.552 26.553,36 26,36 L26,36 Z M4,34 L12,34 L12,14 L4,14 L4,34 Z M13,36 L3,36 C2.447,36 2,35.552 2,35 L2,13 C2,12.448 2.447,12 3,12 L13,12 C13.553,12 14,12.448 14,13 L14,35 C14,35.552 13.553,36 13,36 L13,36 Z" id="Fill-1" fill="#C925D1"></path>
    </g>
</svg>`, VA = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Database/Res_Amazon-Aurora_Trusted-Language-Extensions-for-PostgreSQL_48</title>
    <g id="Icon-Resource/Database/Res_Amazon-Aurora_Trusted-Language-Extensions-for-PostgreSQL_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M26.033,30 L35.033,30 L35.033,28 L26.033,28 L26.033,30 Z M20.413,25.327 C19.064,25.327 18.391,24.375 18.391,22.471 C18.391,21.53 18.558,20.834 18.892,20.38 C19.226,19.927 19.739,19.7 20.431,19.7 C21.099,19.7 21.728,19.904 22.317,20.312 L22.317,24.664 C21.717,25.106 21.082,25.327 20.413,25.327 L20.413,25.327 Z M21.739,28.566 C21.354,28.957 20.736,29.152 19.887,29.152 C19.048,29.152 18.102,28.976 17.047,28.625 L17.047,30.053 C17.981,30.518 18.972,30.75 20.02,30.75 C21.396,30.75 22.459,30.376 23.204,29.628 C23.95,28.88 24.323,27.82 24.323,26.449 L24.323,18.391 L22.623,18.391 L22.453,19.173 C21.728,18.482 20.872,18.136 19.887,18.136 C19.161,18.136 18.532,18.323 17.999,18.697 C17.467,19.071 17.059,19.589 16.775,20.253 C16.492,20.916 16.351,21.678 16.351,22.539 C16.351,23.854 16.665,24.905 17.294,25.693 C17.923,26.481 18.765,26.874 19.818,26.874 C20.747,26.874 21.58,26.557 22.317,25.922 L22.317,26.653 C22.317,27.537 22.125,28.174 21.739,28.566 L21.739,28.566 Z M9.007,20.363 C9.63,19.932 10.31,19.717 11.046,19.717 C11.771,19.717 12.307,19.958 12.653,20.44 C12.998,20.922 13.171,21.661 13.171,22.658 C13.171,23.667 12.995,24.418 12.645,24.911 C12.293,25.403 11.755,25.65 11.029,25.65 C10.315,25.65 9.641,25.429 9.007,24.987 L9.007,20.363 Z M9.007,26.296 C9.335,26.591 9.721,26.82 10.162,26.984 C10.604,27.149 11.063,27.231 11.539,27.231 C12.287,27.231 12.938,27.033 13.494,26.636 C14.05,26.239 14.475,25.693 14.77,24.996 C15.063,24.298 15.211,23.497 15.211,22.59 C15.211,21.23 14.891,20.148 14.251,19.343 C13.61,18.539 12.752,18.136 11.676,18.136 C11.154,18.136 10.652,18.233 10.171,18.425 C9.689,18.618 9.25,18.896 8.854,19.258 L8.666,18.391 L7,18.391 L7,30.546 L9.007,30.546 L9.007,26.296 Z M32.033,4.65 L36.88,9 L32.033,9 L32.033,4.65 Z M39.701,8.844 L32.359,2.256 C32.176,2.091 31.937,2 31.691,2 L8.033,2 C7.48,2 7.033,2.448 7.033,3 L7.033,15 L9.033,15 L9.033,4 L30.033,4 L30.033,10 C30.033,10.552 30.48,11 31.033,11 L38.033,11 L38.033,44 L9.033,44 L9.033,34 L7.033,34 L7.033,45 C7.033,45.552 7.48,46 8.033,46 L39.033,46 C39.586,46 40.033,45.552 40.033,45 L40.033,9.588 C40.033,9.304 39.912,9.034 39.701,8.844 L39.701,8.844 Z" id="Fill-1" fill="#C925D1"></path>
    </g>
</svg>`, GA = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Database/Res_Amazon-DynamoDB_Amazon-DynamoDB-Accelerator_48</title>
    <g id="Icon-Resource/Database/Res_Amazon-DynamoDB_Amazon-DynamoDB-Accelerator_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M6,35 L30,35 L30,33 L6,33 L6,35 Z M2,27.927 L17,27.927 L17,25.927 L2,25.927 L2,27.927 Z M22,31 L22,27.927 L19.084,27.927 L19.084,25.927 L22,25.927 L22,23 L24,23 L24,25.927 L27,25.927 L27,27.927 L24,27.927 L24,31 L22,31 Z M34.4,39.656 L36.959,29.981 C37.038,29.681 36.974,29.361 36.784,29.114 C36.596,28.869 36.303,28.725 35.992,28.725 L31.608,28.725 L35.641,20 L42.011,20 L38.004,26.474 C37.813,26.782 37.805,27.17 37.98,27.487 C38.157,27.804 38.492,28 38.854,28 L42.842,28 L34.4,39.656 Z M45.691,26.545 C45.521,26.211 45.177,26 44.801,26 L40.649,26 L44.656,19.527 C44.847,19.218 44.855,18.83 44.68,18.514 C44.503,18.196 44.168,18 43.806,18 L35.001,18 C34.611,18 34.257,18.227 34.093,18.58 L29.137,29.305 C28.994,29.615 29.019,29.976 29.202,30.264 C29.387,30.551 29.704,30.725 30.045,30.725 L34.693,30.725 L31.095,44.335 C30.972,44.801 31.198,45.288 31.633,45.494 C31.771,45.56 31.917,45.591 32.062,45.591 C32.374,45.591 32.678,45.445 32.871,45.178 L45.61,27.587 C45.831,27.282 45.862,26.88 45.691,26.545 L45.691,26.545 Z M28.448,40.084 L28.749,42.061 C27.238,42.291 25.661,42.408 24.063,42.408 C16.853,42.408 9.553,40.37 9.553,36.475 L11.553,36.475 C11.553,38.117 16.313,40.408 24.063,40.408 C25.561,40.408 27.036,40.299 28.448,40.084 L28.448,40.084 Z M11.033,9.754 C11.033,7.84 16.464,5 23.966,5 C31.763,5 37,7.572 37,9.976 C37,11.638 31.936,14.053 24,14.053 C16.159,14.053 11.121,11.695 11.002,10.035 L11.033,9.754 Z M11,13.123 C13.768,15.042 18.991,16.053 24,16.053 C29.009,16.053 34.232,15.042 37,13.123 L37,16 L39,16 L39,10 L38.997,10 C38.997,9.992 39,9.985 39,9.976 C39,5.934 32.677,3 23.966,3 C15.933,3 9.136,6.047 9.034,9.672 L9,9.976 C9,9.985 9.003,9.992 9.003,10 L9,10 L9,24 L11,24 L11,13.123 Z" id="Amazon-DATABASE_Amazon-DynamoDB_Amazon-DynamoDB-Accelerator_Resource-Icon_light-bg" fill="#C925D1"></path>
    </g>
</svg>`, Ki = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Database/Res_Amazon-ElastiCache_ElastiCache-for-Redis_48</title>
    <g id="Icon-Resource/Database/Res_Amazon-ElastiCache_ElastiCache-for-Redis_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M43.5078,11.4717 C43.5078,12.2927 44.1808,12.9607 45.0078,12.9607 C45.5608,12.9607 46.0078,13.4087 46.0078,13.9607 L46.0078,29.8937 C46.0078,30.4467 45.5608,30.8937 45.0078,30.8937 L37.2288,30.8937 L37.2288,28.8937 L40.8968,28.8937 L40.8968,27.0037 L37.2288,27.0037 L37.2288,25.0037 L41.8968,25.0037 C42.4488,25.0037 42.8968,25.4507 42.8968,26.0037 L42.8968,28.8937 L44.0078,28.8937 L44.0078,14.8157 C42.5638,14.3857 41.5078,13.0497 41.5078,11.4717 C41.5078,9.8937 42.5638,8.5577 44.0078,8.1277 L44.0078,5.9997 L3.9998,5.9997 L3.9998,8.1267 C5.4448,8.5577 6.5008,9.8937 6.5008,11.4717 C6.5008,13.0497 5.4448,14.3857 3.9998,14.8167 L3.9998,28.8937 L5.1118,28.8937 L5.1118,26.0037 C5.1118,25.4507 5.5598,25.0037 6.1118,25.0037 L10.7788,25.0037 L10.7788,27.0037 L7.1118,27.0037 L7.1118,28.8937 L10.7788,28.8937 L10.7788,30.8937 L2.9998,30.8937 C2.4468,30.8937 1.9998,30.4467 1.9998,29.8937 L1.9998,13.9607 C1.9998,13.4087 2.4468,12.9607 2.9998,12.9607 C3.8278,12.9607 4.5008,12.2927 4.5008,11.4717 C4.5008,10.6507 3.8278,9.9827 2.9998,9.9827 C2.4468,9.9827 1.9998,9.5347 1.9998,8.9827 L1.9998,4.9997 C1.9998,4.4477 2.4468,3.9997 2.9998,3.9997 L45.0078,3.9997 C45.5608,3.9997 46.0078,4.4477 46.0078,4.9997 L46.0078,8.9827 C46.0078,9.5347 45.5608,9.9827 45.0078,9.9827 C44.1808,9.9827 43.5078,10.6507 43.5078,11.4717 L43.5078,11.4717 Z M24.1958,33.0557 L22.1168,33.0557 L22.1168,29.1187 L24.2448,29.1187 C25.5418,29.1187 26.1908,29.7757 26.1908,31.0877 C26.1908,32.4007 25.5258,33.0557 24.1958,33.0557 L24.1958,33.0557 Z M27.7228,33.0217 C28.1158,32.4627 28.3128,31.7947 28.3128,31.0197 C28.3128,29.9477 27.9618,29.0937 27.2598,28.4607 C26.5588,27.8267 25.6258,27.5107 24.4618,27.5107 L20.0288,27.5107 L20.0288,39.3707 L22.1168,39.3707 L22.1168,34.6647 L24.2048,34.6647 L26.9778,39.3707 L29.0658,39.3707 L26.0018,34.3057 C26.7548,34.0087 27.3288,33.5807 27.7228,33.0217 L27.7228,33.0217 Z M10.2238,21.1147 L11.5578,21.1147 L11.5578,23.1147 L9.2238,23.1147 C8.6708,23.1147 8.2238,22.6667 8.2238,22.1147 L8.2238,8.8897 C8.2238,8.3367 8.6708,7.8897 9.2238,7.8897 L13.8918,7.8897 C14.4448,7.8897 14.8918,8.3367 14.8918,8.8897 L14.8918,15.1127 L12.8918,15.1127 L12.8918,9.8897 L10.2238,9.8897 L10.2238,21.1147 Z M37.7848,21.1147 L37.7848,9.8897 L35.1168,9.8897 L35.1168,15.1127 L33.1168,15.1127 L33.1168,8.8897 C33.1168,8.3367 33.5648,7.8897 34.1168,7.8897 L38.7848,7.8897 C39.3378,7.8897 39.7848,8.3367 39.7848,8.8897 L39.7848,22.1147 C39.7848,22.6667 39.3378,23.1147 38.7848,23.1147 L37.2288,23.1147 L37.2288,21.1147 L37.7848,21.1147 Z M30.0058,14.3347 L30.0058,9.8897 L26.5608,9.8897 L26.5608,13.5567 L24.5608,13.5567 L24.5608,8.8897 C24.5608,8.3367 25.0078,7.8897 25.5608,7.8897 L31.0058,7.8897 C31.5588,7.8897 32.0058,8.3367 32.0058,8.8897 L32.0058,14.3347 L30.0058,14.3347 Z M21.4478,13.5567 L21.4478,9.8897 L18.0028,9.8897 L18.0028,14.3347 L16.0028,14.3347 L16.0028,8.8897 C16.0028,8.3367 16.4498,7.8897 17.0028,7.8897 L22.4478,7.8897 C23.0008,7.8897 23.4478,8.3367 23.4478,8.8897 L23.4478,13.5567 L21.4478,13.5567 Z M31.7328,30.3597 C32.6258,30.0767 33.3328,29.7677 33.8958,29.4447 L33.8958,33.7187 C33.8958,34.0657 33.1588,34.8127 31.1308,35.4517 L31.7328,37.3607 C32.6258,37.0777 33.3328,36.7687 33.8958,36.4457 L33.8958,40.2597 C33.8958,41.1897 30.1408,42.8957 24.0058,42.8957 C17.8688,42.8957 14.1128,41.1897 14.1128,40.2597 L14.1128,36.4477 C14.6808,36.7727 15.3968,37.0847 16.3038,37.3687 L16.9018,35.4607 C14.8558,34.8207 14.1128,34.0687 14.1128,33.7187 L14.1128,29.4457 C14.6808,29.7717 15.3968,30.0837 16.3038,30.3677 L16.9018,28.4597 C14.8558,27.8197 14.1128,27.0677 14.1128,26.7177 L14.1128,22.4287 C16.3698,23.7387 20.2178,24.3587 23.8948,24.3587 C27.7568,24.3587 31.6388,23.6777 33.8958,22.3657 L33.8958,26.7177 C33.8958,27.0647 33.1588,27.8117 31.1308,28.4507 L31.7328,30.3597 Z M23.8948,17.0127 C30.0818,17.0127 33.8688,18.7427 33.8688,19.6857 C33.8688,20.6277 30.0818,22.3587 23.8948,22.3587 C17.5758,22.3587 14.1298,20.5927 14.1298,19.6857 C14.1298,18.7787 17.5758,17.0127 23.8948,17.0127 L23.8948,17.0127 Z M35.8818,19.6857 C35.8818,16.6177 29.8448,15.0127 23.8948,15.0127 C18.2288,15.0127 12.1218,16.4747 12.1218,19.6857 L12.1218,19.7907 L12.1128,40.2597 C12.1128,43.3027 18.0958,44.8957 24.0058,44.8957 C29.9138,44.8957 35.8958,43.3027 35.8958,40.2597 L35.8818,19.7907 L35.8818,19.6857 Z" id="Amazon-DATABASE_Amazon-ElastiCache_Elasticache-for-Redis_Resource-Icon_light-bg" fill="#C925D1"></path>
    </g>
</svg>`, jA = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Database/Res_Amazon-RDS-Proxy-Instance_48</title>
    <g id="Icon-Resource/Database/Res_Amazon-RDS-Proxy-Instance_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M44.1751,29.9927 L44.1751,26.2347 C42.4711,27.2357 39.7541,27.7537 37.0531,27.7537 C34.3521,27.7537 31.6351,27.2357 29.9311,26.2347 L29.9311,29.9927 C29.9311,30.7527 32.4451,32.2317 37.0531,32.2317 C41.6611,32.2317 44.1751,30.7527 44.1751,29.9927 L44.1751,29.9927 Z M44.1751,36.1157 L44.1751,32.4677 C42.4711,33.4687 39.7541,33.9847 37.0531,33.9847 C34.3521,33.9847 31.6351,33.4687 29.9311,32.4677 L29.9311,36.1157 C29.9311,36.8757 32.4451,38.3547 37.0531,38.3547 C41.6611,38.3547 44.1751,36.8757 44.1751,36.1157 L44.1751,36.1157 Z M44.1751,41.5827 L44.1751,38.5907 C42.4711,39.5917 39.7541,40.1077 37.0531,40.1077 C34.3521,40.1077 31.6351,39.5917 29.9311,38.5907 L29.9311,41.5827 C29.9311,42.3427 32.4451,43.8217 37.0531,43.8217 C41.6611,43.8217 44.1751,42.3427 44.1751,41.5827 L44.1751,41.5827 Z M29.9311,23.7607 C29.9311,24.5207 32.4451,26.0007 37.0531,26.0007 C41.6611,26.0007 44.1751,24.5207 44.1751,23.7607 C44.1751,22.9997 41.6611,21.5197 37.0531,21.5197 C32.4451,21.5197 29.9311,22.9997 29.9311,23.7607 L29.9311,23.7607 Z M45.9271,23.7607 L45.9271,41.5827 C45.9271,44.2037 41.4621,45.5747 37.0531,45.5747 C32.6431,45.5747 28.1781,44.2037 28.1781,41.5827 L28.1781,23.7607 C28.1781,21.1387 32.6431,19.7677 37.0531,19.7677 C41.4621,19.7677 45.9271,21.1387 45.9271,23.7607 L45.9271,23.7607 Z M37.9171,11.7937 C37.8841,12.0537 37.8161,12.2397 37.7101,12.3507 C37.6051,12.4617 37.4461,12.5167 37.2371,12.5167 C37.1201,12.5167 36.9881,12.5057 36.8381,12.4827 L36.8381,13.2487 C37.0871,13.3327 37.3311,13.3737 37.5691,13.3737 C37.8841,13.3737 38.1391,13.2827 38.3321,13.0987 C38.5271,12.9167 38.6811,12.6197 38.7981,12.2097 L40.2001,7.3117 L39.0291,7.3117 L38.4071,10.4377 L37.7681,7.3117 L36.5641,7.3117 L37.9341,11.6437 L37.9171,11.7937 Z M36.2491,11.5607 L35.0121,9.4247 L36.1831,7.3117 L35.0621,7.3117 L34.4881,8.6177 L33.8651,7.3117 L32.6461,7.3117 L33.8171,9.4247 L32.6291,11.5607 L33.7501,11.5607 L34.3391,10.2137 L35.0291,11.5607 L36.2491,11.5607 Z M30.2091,10.4757 C30.1161,10.2567 30.0711,9.9117 30.0711,9.4407 C30.0711,8.9697 30.1161,8.6227 30.2091,8.4007 C30.3001,8.1797 30.4471,8.0677 30.6531,8.0677 C30.8581,8.0677 31.0061,8.1797 31.0971,8.4007 C31.1881,8.6227 31.2351,8.9697 31.2351,9.4407 C31.2351,9.9117 31.1881,10.2567 31.0971,10.4757 C31.0061,10.6947 30.8581,10.8047 30.6531,10.8047 C30.4471,10.8047 30.3001,10.6947 30.2091,10.4757 L30.2091,10.4757 Z M31.9231,11.0867 C32.2221,10.6987 32.3711,10.1497 32.3711,9.4407 C32.3711,8.7247 32.2221,8.1747 31.9231,7.7857 C31.6241,7.3977 31.2001,7.2037 30.6531,7.2037 C30.1051,7.2037 29.6811,7.3977 29.3821,7.7857 C29.0831,8.1747 28.9341,8.7247 28.9341,9.4407 C28.9341,10.1497 29.0831,10.6987 29.3821,11.0867 C29.6811,11.4747 30.1051,11.6687 30.6531,11.6687 C31.2001,11.6687 31.6241,11.4747 31.9231,11.0867 L31.9231,11.0867 Z M27.4051,11.5607 L27.4051,8.4597 C27.6441,8.3267 27.8961,8.2597 28.1611,8.2597 C28.3001,8.2597 28.4461,8.2737 28.6021,8.3017 L28.6021,7.2957 C28.5131,7.2787 28.4241,7.2697 28.3361,7.2697 C28.1541,7.2697 27.9801,7.3167 27.8181,7.4117 C27.6541,7.5067 27.4881,7.6557 27.3221,7.8607 L27.1981,7.3117 L26.2691,7.3117 L26.2691,11.5607 L27.4051,11.5607 Z M23.0801,6.6637 L23.6191,6.6637 C23.8351,6.6637 24.0001,6.7437 24.1131,6.9047 C24.2271,7.0647 24.2841,7.3007 24.2841,7.6107 C24.2841,7.9217 24.2271,8.1577 24.1131,8.3177 C24.0001,8.4787 23.8351,8.5587 23.6191,8.5587 L23.0801,8.5587 L23.0801,6.6637 Z M23.7611,9.4247 C24.2701,9.4247 24.6761,9.2617 24.9771,8.9367 C25.2791,8.6127 25.4301,8.1717 25.4301,7.6107 C25.4301,7.0517 25.2791,6.6087 24.9771,6.2847 C24.6761,5.9607 24.2701,5.7987 23.7611,5.7987 L21.9431,5.7987 L21.9431,11.5607 L23.0801,11.5607 L23.0801,9.4247 L23.7611,9.4247 Z M17.5171,9.2327 C17.7431,9.3547 17.9051,9.4747 18.0021,9.5947 C18.0991,9.7137 18.1481,9.8587 18.1481,10.0307 C18.1481,10.2637 18.0781,10.4417 17.9411,10.5667 C17.8021,10.6917 17.6001,10.7547 17.3341,10.7547 C17.1521,10.7547 16.9321,10.7277 16.6741,10.6757 C16.4171,10.6227 16.1861,10.5567 15.9811,10.4797 L15.9811,11.3527 C16.1581,11.4527 16.3761,11.5327 16.6371,11.5947 C16.8971,11.6547 17.1571,11.6857 17.4171,11.6857 C18.0151,11.6857 18.4851,11.5317 18.8241,11.2237 C19.1651,10.9167 19.3351,10.4997 19.3351,9.9717 C19.3351,9.7007 19.2951,9.4697 19.2151,9.2787 C19.1341,9.0877 19.0101,8.9137 18.8411,8.7587 C18.6721,8.6037 18.4451,8.4487 18.1561,8.2927 L17.7081,8.0517 C17.4641,7.9197 17.3001,7.7977 17.2141,7.6857 C17.1281,7.5747 17.0851,7.4337 17.0851,7.2617 C17.0851,7.0567 17.1521,6.8957 17.2841,6.7797 C17.4171,6.6637 17.6001,6.6047 17.8321,6.6047 C18.1751,6.6047 18.5711,6.6877 19.0201,6.8537 L19.0201,5.9727 C18.5881,5.7737 18.1541,5.6737 17.7161,5.6737 C17.3671,5.6737 17.0591,5.7417 16.7901,5.8777 C16.5221,6.0137 16.3101,6.2077 16.1551,6.4597 C16.0001,6.7117 15.9231,7.0077 15.9231,7.3457 C15.9231,7.7117 16.0111,8.0207 16.1891,8.2757 C16.3651,8.5317 16.6591,8.7697 17.0691,8.9917 L17.5171,9.2327 Z M12.9841,6.6877 C13.3541,6.6877 13.6271,6.8427 13.8011,7.1497 C13.9761,7.4577 14.0631,7.9377 14.0631,8.5927 L14.0631,8.7587 C14.0631,9.4067 13.9741,9.8887 13.7971,10.2017 C13.6191,10.5137 13.3521,10.6717 12.9911,10.6717 L12.5011,10.6717 L12.5011,6.6877 L12.9841,6.6877 Z M13.1161,11.5607 C13.8141,11.5607 14.3451,11.3167 14.7101,10.8287 C15.0751,10.3417 15.2581,9.6237 15.2581,8.6757 C15.2581,7.7327 15.0721,7.0177 14.7011,6.5297 C14.3311,6.0427 13.7881,5.7987 13.0741,5.7987 L11.3391,5.7987 L11.3391,11.5607 L13.1161,11.5607 Z M8.0521,6.6637 L8.5911,6.6637 C8.8071,6.6637 8.9721,6.7437 9.0851,6.9047 C9.1981,7.0647 9.2561,7.3007 9.2561,7.6107 C9.2561,7.9217 9.1981,8.1577 9.0851,8.3177 C8.9721,8.4787 8.8071,8.5587 8.5911,8.5587 L8.0521,8.5587 L8.0521,6.6637 Z M10.7001,11.5607 L9.5371,9.2497 C9.8151,9.1107 10.0281,8.8997 10.1771,8.6177 C10.3261,8.3347 10.4021,7.9997 10.4021,7.6107 C10.4021,7.0517 10.2501,6.6087 9.9481,6.2847 C9.6471,5.9607 9.2411,5.7987 8.7331,5.7987 L6.9141,5.7987 L6.9141,11.5607 L8.0521,11.5607 L8.0521,9.4247 L8.5001,9.4247 L9.5051,11.5607 L10.7001,11.5607 Z M27.4131,45.8157 L7.6511,45.8157 C4.5341,45.8157 2.0001,43.2807 2.0001,40.1657 L2.0001,7.6497 C2.0001,4.5347 4.5341,1.9997 7.6511,1.9997 L40.1651,1.9997 C43.2811,1.9997 45.8161,4.5347 45.8161,7.6497 L45.8161,20.4027 L44.0641,20.4027 L44.0641,7.6497 C44.0641,5.5007 42.3151,3.7527 40.1651,3.7527 L7.6511,3.7527 C5.5011,3.7527 3.7521,5.5007 3.7521,7.6497 L3.7521,40.1657 C3.7521,42.3147 5.5011,44.0627 7.6511,44.0627 L27.4131,44.0627 L27.4131,45.8157 Z" id="Amazon-DATABASE_Amazon-RDS-Proxy_Resource-Icon_light-bg" fill="#C925D1"></path>
    </g>
</svg>`, qA = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Database/Res_Amazon-DynamoDB_Standard-Infrequent-Access-Table-Class_48</title>
    <g id="Icon-Resource/Database/Res_Amazon-DynamoDB_Standard-Infrequent-Access-Table-Class_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M12.714,35.707 L9.714,38.707 C9.519,38.902 9.263,39 9.007,39 C8.751,39 8.495,38.902 8.3,38.707 L5.3,35.707 L6.714,34.293 L8.007,35.586 L8.007,26.414 L6.714,27.707 L5.3,26.293 L8.3,23.293 C8.691,22.902 9.323,22.902 9.714,23.293 L12.714,26.293 L11.3,27.707 L10.007,26.414 L10.007,35.586 L11.3,34.293 L12.714,35.707 Z M23.602,4 C32.091,4 38.007,6.442 38.007,8.635 C38.007,10.827 32.091,13.27 23.602,13.27 C15.204,13.27 10.007,10.864 10.007,8.635 C10.007,6.406 15.204,4 23.602,4 L23.602,4 Z M10.007,20.143 L10.007,12.126 C12.559,14.085 17.396,15.27 23.602,15.27 C29.318,15.27 35.071,14.145 38.007,11.974 L38.007,17.5 L40.007,17.5 L40.007,8.635 C40.007,4.279 31.754,2 23.602,2 C14.274,2 8.007,4.666 8.007,8.635 L8.007,20.143 C8.664,19.974 9.35,19.974 10.007,20.143 L10.007,20.143 Z M23.602,40 C26.739,40 29.521,39.665 31.787,39.134 L31.396,41.033 C31.38,41.11 31.379,41.187 31.369,41.264 C28.964,41.749 26.281,42 23.602,42 C19.425,42 15.741,41.448 12.948,40.404 C12.777,40.34 12.626,40.268 12.463,40.2 L14.01,38.653 C16.516,39.52 19.895,40 23.602,40 L23.602,40 Z M35.253,40.265 L37.324,30.202 C37.385,29.907 37.31,29.601 37.12,29.368 C36.93,29.135 36.646,29 36.345,29 L32.875,29 L36.875,21 L42.49,21 L38.6,27.485 C38.414,27.794 38.409,28.179 38.587,28.493 C38.765,28.806 39.097,29 39.457,29 L42.873,29 L35.253,40.265 Z M45.64,27.531 C45.467,27.204 45.127,27 44.757,27 L41.224,27 L45.114,20.515 C45.3,20.206 45.305,19.821 45.127,19.507 C44.949,19.194 44.617,19 44.257,19 L36.257,19 C35.878,19 35.532,19.214 35.362,19.553 L30.362,29.553 C30.207,29.863 30.224,30.231 30.406,30.526 C30.589,30.821 30.91,31 31.257,31 L35.118,31 L32.277,44.798 C32.181,45.266 32.429,45.736 32.868,45.921 C32.994,45.975 33.126,46 33.257,46 C33.58,46 33.895,45.842 34.085,45.561 L45.585,28.561 C45.792,28.254 45.814,27.858 45.64,27.531 L45.64,27.531 Z" id="Fill-1" fill="#C925D1"></path>
    </g>
</svg>`, KA = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Database/Res_Amazon-Aurora-MySQL-Instance_48</title>
    <g id="Icon-Resource/Database/Res_Amazon-Aurora-MySQL-Instance_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M43.9636,29.9804 L43.9636,26.4504 C42.2346,27.3924 39.6146,27.8794 37.0056,27.8794 C34.3966,27.8794 31.7756,27.3924 30.0466,26.4504 L30.0466,29.9804 C30.0466,30.6084 32.4136,32.0814 37.0056,32.0814 C41.5966,32.0814 43.9636,30.6084 43.9636,29.9804 L43.9636,29.9804 Z M43.9636,36.0724 L43.9636,32.6514 C42.2346,33.5934 39.6146,34.0814 37.0056,34.0814 C34.3966,34.0814 31.7756,33.5934 30.0466,32.6514 L30.0466,36.0724 C30.0466,36.7004 32.4136,38.1724 37.0056,38.1724 C41.5966,38.1724 43.9636,36.7004 43.9636,36.0724 L43.9636,36.0724 Z M43.9636,41.5114 L43.9636,38.7434 C42.2346,39.6854 39.6146,40.1724 37.0056,40.1724 C34.3966,40.1724 31.7756,39.6854 30.0466,38.7434 L30.0466,41.5114 C30.0466,42.1394 32.4136,43.6124 37.0056,43.6124 C41.5966,43.6124 43.9636,42.1394 43.9636,41.5114 L43.9636,41.5114 Z M30.0466,23.7794 C30.0466,24.4074 32.4136,25.8794 37.0056,25.8794 C41.5966,25.8794 43.9636,24.4074 43.9636,23.7794 C43.9636,23.1514 41.5966,21.6784 37.0056,21.6784 C32.4136,21.6784 30.0466,23.1514 30.0466,23.7794 L30.0466,23.7794 Z M45.9636,23.7794 L45.9636,41.5114 C45.9636,44.2044 41.4566,45.6124 37.0056,45.6124 C32.5536,45.6124 28.0466,44.2044 28.0466,41.5114 L28.0466,23.7794 C28.0466,21.0864 32.5536,19.6784 37.0056,19.6784 C41.4566,19.6784 45.9636,21.0864 45.9636,23.7794 L45.9636,23.7794 Z M3.9996,40.1024 L3.9996,7.7504 C3.9996,5.6824 5.6826,4.0004 7.7496,4.0004 L40.1026,4.0004 C42.1696,4.0004 43.8526,5.6824 43.8526,7.7504 L43.8526,20.4384 L45.8526,20.4384 L45.8526,7.7504 C45.8526,4.5794 43.2736,2.0004 40.1026,2.0004 L7.7496,2.0004 C4.5786,2.0004 1.9996,4.5794 1.9996,7.7504 L1.9996,40.1024 C1.9996,43.2734 4.5786,45.8524 7.7496,45.8524 L27.4136,45.8524 L27.4136,43.8524 L7.7496,43.8524 C5.6826,43.8524 3.9996,42.1694 3.9996,40.1024 L3.9996,40.1024 Z M34.9776,8.3844 L34.9776,16.2404 L39.2396,16.2404 L39.2396,14.9814 L36.5656,14.9814 L36.5656,8.3844 L34.9776,8.3844 Z M32.0086,12.3064 C32.0086,11.3544 31.8836,10.6484 31.6346,10.1874 C31.3856,9.7264 31.0026,9.4964 30.4896,9.4964 C29.9766,9.4964 29.5946,9.7264 29.3446,10.1874 C29.0956,10.6484 28.9716,11.3544 28.9716,12.3064 C28.9716,13.2364 29.0986,13.9394 29.3566,14.4154 C29.6126,14.8914 29.9906,15.1294 30.4896,15.1294 C30.9876,15.1294 31.3656,14.8914 31.6226,14.4154 C31.8796,13.9394 32.0086,13.2364 32.0086,12.3064 L32.0086,12.3064 Z M31.6346,16.2174 C31.8686,16.4064 32.1296,16.5534 32.4166,16.6594 C32.7036,16.7644 33.0556,16.8414 33.4706,16.8864 L33.4706,18.1784 C32.8736,18.0874 32.2986,17.8864 31.7476,17.5784 C31.1956,17.2674 30.7236,16.8784 30.3306,16.4104 C29.3786,16.3724 28.6426,15.9974 28.1206,15.2824 C27.5996,14.5674 27.3376,13.5774 27.3376,12.3064 C27.3376,11.0064 27.6136,10.0004 28.1656,9.2864 C28.7176,8.5724 29.4916,8.2144 30.4896,8.2144 C31.4866,8.2144 32.2616,8.5724 32.8136,9.2864 C33.3646,10.0004 33.6406,11.0064 33.6406,12.3064 C33.6406,13.3194 33.4686,14.1624 33.1246,14.8344 C32.7806,15.5074 32.2836,15.9674 31.6346,16.2174 L31.6346,16.2174 Z M23.6436,15.1394 C23.3936,15.1394 23.0946,15.1044 22.7416,15.0324 C22.3906,14.9604 22.0756,14.8734 21.7956,14.7664 L21.7956,15.9574 C22.0366,16.0924 22.3356,16.2034 22.6916,16.2854 C23.0466,16.3694 23.4016,16.4104 23.7566,16.4104 C24.5716,16.4104 25.2126,16.2014 25.6776,15.7814 C26.1426,15.3614 26.3746,14.7924 26.3746,14.0754 C26.3746,13.7044 26.3186,13.3894 26.2106,13.1284 C26.1016,12.8684 25.9316,12.6314 25.7006,12.4194 C25.4696,12.2094 25.1576,11.9974 24.7656,11.7854 L24.1526,11.4564 C23.8206,11.2764 23.5966,11.1094 23.4796,10.9584 C23.3606,10.8064 23.3036,10.6144 23.3036,10.3794 C23.3036,10.1004 23.3936,9.8804 23.5746,9.7224 C23.7566,9.5634 24.0056,9.4844 24.3236,9.4844 C24.7916,9.4844 25.3316,9.5974 25.9446,9.8244 L25.9446,8.6234 C25.3556,8.3504 24.7616,8.2144 24.1646,8.2144 C23.6886,8.2144 23.2676,8.3074 22.9016,8.4924 C22.5336,8.6774 22.2446,8.9424 22.0326,9.2864 C21.8216,9.6294 21.7166,10.0324 21.7166,10.4934 C21.7166,10.9924 21.8376,11.4154 22.0786,11.7624 C22.3206,12.1104 22.7216,12.4354 23.2796,12.7374 L23.8926,13.0654 C24.2026,13.2324 24.4246,13.3974 24.5556,13.5594 C24.6886,13.7214 24.7546,13.9204 24.7546,14.1544 C24.7546,14.4724 24.6586,14.7154 24.4706,14.8854 C24.2816,15.0554 24.0056,15.1394 23.6436,15.1394 L23.6436,15.1394 Z M17.8166,17.3164 C17.6736,17.4674 17.4566,17.5434 17.1706,17.5434 C17.0116,17.5434 16.8306,17.5284 16.6256,17.4994 L16.6256,18.5414 C16.9666,18.6554 17.2986,18.7104 17.6236,18.7104 C18.0546,18.7104 18.4016,18.5864 18.6656,18.3364 C18.9316,18.0874 19.1436,17.6834 19.3016,17.1244 L21.2176,10.4484 L19.6186,10.4484 L18.7686,14.7094 L17.8966,10.4484 L16.2516,10.4484 L18.1226,16.3534 L18.1006,16.5564 C18.0546,16.9134 17.9606,17.1664 17.8166,17.3164 L17.8166,17.3164 Z M14.0196,16.2404 L14.0196,10.7314 L12.6936,14.3014 L11.3446,14.3014 L10.0286,10.7654 L10.0286,16.2404 L8.6116,16.2404 L8.6116,8.3844 L10.4266,8.3844 L12.0476,12.7834 L13.6676,8.3844 L15.4366,8.3844 L15.4366,16.2404 L14.0196,16.2404 Z" id="Amazon-DATABASEAmazon-Aurora-MySQL-instance_Resource-Icon_light-bg" fill="#C925D1"></path>
    </g>
</svg>`, YA = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Database/Res_Amazon-Aurora-PIOPS-Instance_48</title>
    <g id="Icon-Resource/Database/Res_Amazon-Aurora-PIOPS-Instance_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M41.4631,37.9053 C41.5721,38.1663 41.6271,38.4813 41.6271,38.8523 C41.6271,39.5713 41.3951,40.1403 40.9291,40.5613 C40.4641,40.9803 39.8221,41.1903 39.0061,41.1903 C38.6501,41.1903 38.2941,41.1493 37.9391,41.0653 C37.5821,40.9823 37.2831,40.8733 37.0411,40.7363 L37.0411,39.5453 C37.3211,39.6513 37.6381,39.7403 37.9891,39.8113 C38.3411,39.8843 38.6431,39.9193 38.8921,39.9193 C39.2551,39.9193 39.5301,39.8353 39.7201,39.6643 C39.9091,39.4933 40.0041,39.2503 40.0041,38.9313 C40.0041,38.6973 39.9391,38.4993 39.8061,38.3363 C39.6731,38.1743 39.4511,38.0093 39.1421,37.8423 L38.5281,37.5123 C37.9691,37.2103 37.5681,36.8853 37.3261,36.5373 C37.0841,36.1883 36.9631,35.7643 36.9631,35.2663 C36.9631,34.8033 37.0681,34.4013 37.2791,34.0573 C37.4911,33.7133 37.7811,33.4483 38.1481,33.2623 C38.5161,33.0773 38.9381,32.9843 39.4141,32.9843 C40.0121,32.9843 40.6061,33.1213 41.1961,33.3923 L41.1961,34.5953 C40.5831,34.3693 40.0421,34.2563 39.5721,34.2563 C39.2551,34.2563 39.0061,34.3353 38.8231,34.4933 C38.6431,34.6533 38.5511,34.8723 38.5511,35.1513 C38.5511,35.3873 38.6101,35.5803 38.7281,35.7313 C38.8451,35.8833 39.0691,36.0493 39.4021,36.2303 L40.0151,36.5593 C40.4091,36.7723 40.7211,36.9833 40.9511,37.1953 C41.1841,37.4073 41.3531,37.6433 41.4631,37.9053 L41.4631,37.9053 Z M34.2331,36.5933 C34.0771,36.8133 33.8531,36.9233 33.5581,36.9233 L32.8181,36.9233 L32.8181,34.3353 L33.5581,34.3353 C33.8531,34.3353 34.0771,34.4453 34.2331,34.6643 C34.3881,34.8843 34.4651,35.2063 34.4651,35.6303 C34.4651,36.0533 34.3881,36.3753 34.2331,36.5933 L34.2331,36.5933 Z M33.7501,33.1553 L31.2641,33.1553 L31.2641,41.0203 L32.8181,41.0203 L32.8181,38.1033 L33.7501,38.1033 C34.4451,38.1033 35.0001,37.8823 35.4121,37.4393 C35.8251,36.9973 36.0311,36.3933 36.0311,35.6303 C36.0311,34.8643 35.8251,34.2603 35.4121,33.8183 C35.0001,33.3763 34.4451,33.1553 33.7501,33.1553 L33.7501,33.1553 Z M27.9041,39.1933 C27.6471,39.6703 27.2691,39.9083 26.7711,39.9083 C26.2711,39.9083 25.8921,39.6703 25.6351,39.1933 C25.3771,38.7163 25.2491,38.0123 25.2491,37.0813 C25.2491,36.1283 25.3741,35.4213 25.6231,34.9593 C25.8731,34.4983 26.2551,34.2663 26.7711,34.2663 C27.2831,34.2663 27.6661,34.4983 27.9161,34.9593 C28.1651,35.4213 28.2901,36.1283 28.2901,37.0813 C28.2901,38.0123 28.1621,38.7163 27.9041,39.1933 L27.9041,39.1933 Z M26.7711,32.9843 C25.7711,32.9843 24.9951,33.3423 24.4421,34.0573 C23.8901,34.7713 23.6131,35.7803 23.6131,37.0813 C23.6131,38.3843 23.8901,39.3933 24.4421,40.1123 C24.9951,40.8313 25.7711,41.1903 26.7711,41.1903 C27.7691,41.1903 28.5441,40.8313 29.0961,40.1123 C29.6491,39.3933 29.9251,38.3843 29.9251,37.0813 C29.9251,35.7803 29.6491,34.7713 29.0961,34.0573 C28.5441,33.3423 27.7691,32.9843 26.7711,32.9843 L26.7711,32.9843 Z M20.6411,41.0203 L22.2301,41.0203 L22.2301,33.1553 L20.6411,33.1553 L20.6411,41.0203 Z M17.5481,36.5933 C17.3931,36.8133 17.1681,36.9233 16.8721,36.9233 L16.1351,36.9233 L16.1351,34.3353 L16.8721,34.3353 C17.1681,34.3353 17.3931,34.4453 17.5481,34.6643 C17.7021,34.8843 17.7801,35.2063 17.7801,35.6303 C17.7801,36.0533 17.7021,36.3753 17.5481,36.5933 L17.5481,36.5933 Z M17.0661,33.1553 L14.5791,33.1553 L14.5791,41.0203 L16.1351,41.0203 L16.1351,38.1033 L17.0661,38.1033 C17.7611,38.1033 18.3161,37.8823 18.7291,37.4393 C19.1411,36.9973 19.3471,36.3933 19.3471,35.6303 C19.3471,34.8643 19.1411,34.2603 18.7291,33.8183 C18.3161,33.3763 17.7611,33.1553 17.0661,33.1553 L17.0661,33.1553 Z M43.9081,40.1203 C43.9081,42.2093 42.2091,43.9083 40.1201,43.9083 L7.7881,43.9083 C5.6991,43.9083 4.0001,42.2093 4.0001,40.1203 L4.0001,7.7883 C4.0001,5.6993 5.6991,4.0003 7.7881,4.0003 L40.1201,4.0003 C42.2091,4.0003 43.9081,5.6993 43.9081,7.7883 L43.9081,40.1203 Z M40.1201,2.0003 L7.7881,2.0003 C4.5971,2.0003 2.0001,4.5963 2.0001,7.7883 L2.0001,40.1203 C2.0001,43.3113 4.5971,45.9083 7.7881,45.9083 L40.1201,45.9083 C43.3121,45.9083 45.9081,43.3113 45.9081,40.1203 L45.9081,7.7883 C45.9081,4.5963 43.3121,2.0003 40.1201,2.0003 L40.1201,2.0003 Z" id="Amazon-DATABASEAmazon-Aurora-PIOPS_Resource-Icon_light-bg" fill="#C925D1"></path>
    </g>
</svg>`, QA = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Database/Res_AWS-Database-Migration-Service_Database-migration-workflow-or-job_48</title>
    <g id="Icon-Resource/Database/Res_AWS-Database-Migration-Service_Database-migration-workflow-or-job_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M24.0361,41.0684 C16.6311,41.0684 12.0001,39.0004 12.0001,37.0834 L12.0001,36.9034 L12.0001,34.0474 C13.5571,35.2334 15.9761,36.1134 19.0001,36.5734 L19.0001,39.0054 L21.0001,39.0054 L21.0001,36.8134 C21.9671,36.8944 22.9801,36.9384 24.0361,36.9384 C25.0641,36.9384 26.0551,36.8984 27.0001,36.8204 L27.0001,40.9464 C26.0691,41.0234 25.0851,41.0684 24.0361,41.0684 L24.0361,41.0684 Z M12.0001,26.0664 L12.0001,22.5074 C14.3261,24.1444 18.5851,25.1304 24.0151,25.1304 C29.4221,25.1304 33.6681,24.1544 36.0001,22.5304 L36.0001,26.0664 C36.0001,26.7544 34.3411,28.0084 29.7671,28.6494 C28.7861,28.7874 27.7501,28.8894 26.6861,28.9524 C26.2521,28.9774 25.8101,28.9984 25.3621,29.0104 C24.4651,29.0384 23.5321,29.0384 22.6371,29.0104 C22.1881,28.9984 21.7471,28.9774 21.3121,28.9524 C20.2491,28.8894 19.2131,28.7874 18.2311,28.6494 C13.6591,28.0084 12.0001,26.7544 12.0001,26.0664 L12.0001,26.0664 Z M24.0001,4.0004 C31.8791,4.0004 36.0021,5.9294 36.0021,6.9644 L36.0021,7.1334 L36.0021,7.2374 C36.0021,8.0344 32.3171,10.1314 24.0571,10.1314 C15.7981,10.1314 12.0061,8.1464 12.0061,7.3494 L12.0061,7.2374 L12.0061,6.9644 C12.0061,5.9294 16.1211,4.0004 24.0001,4.0004 L24.0001,4.0004 Z M12.0001,16.6314 C14.5621,18.2914 19.2901,19.0624 23.9951,19.0624 C28.7061,19.0624 33.4391,18.2894 36.0001,16.6254 L36.0021,19.1994 L36.0021,19.3474 C36.0021,21.1674 31.4081,23.1314 24.0151,23.1314 C16.6231,23.1314 12.0021,21.1674 12.0021,19.3474 L12.0001,19.1504 L12.0001,16.6314 Z M12.0001,9.8554 C14.5801,11.4044 19.4391,12.1314 24.0571,12.1314 C28.6111,12.1314 33.3931,11.4224 36.0001,9.9184 L36.0001,13.4974 L36.0001,13.6484 C36.0001,15.0444 31.6881,17.0624 23.9951,17.0624 C16.3021,17.0624 12.0051,15.0444 12.0051,13.6484 L12.0001,13.4874 L12.0001,9.8554 Z M38.0001,37.0834 L38.0001,37.0064 L36.0001,37.0064 L36.0001,37.2614 C35.7971,38.6484 33.2521,40.0784 29.0001,40.7194 L29.0001,36.5844 C32.0101,36.1344 34.4281,35.2704 36.0001,34.1034 L36.0001,35.0064 L38.0001,35.0064 L37.9991,30.9494 L37.9991,30.7844 L37.9991,30.6804 L38.0001,30.0054 L36.0001,30.0054 L36.0001,30.8714 C35.7971,32.3534 33.2521,33.8814 29.0001,34.5664 L29.0001,33.0054 L27.0001,33.0054 L27.0001,34.8084 C26.0691,34.8894 25.0851,34.9384 24.0361,34.9384 C22.9601,34.9384 21.9511,34.8864 21.0001,34.8004 L21.0001,30.9334 C21.0651,30.9374 21.1291,30.9444 21.1941,30.9484 C21.6471,30.9754 22.1081,30.9964 22.5761,31.0104 C23.0441,31.0244 23.5191,31.0314 24.0001,31.0314 C24.4791,31.0314 24.9551,31.0244 25.4231,31.0104 C25.8901,30.9964 26.3511,30.9754 26.8051,30.9484 C27.9211,30.8824 29.0121,30.7754 30.0461,30.6304 C35.1751,29.9114 38.0001,28.2914 38.0001,26.0664 L38.0001,6.9644 C38.0001,3.5354 30.9691,2.0004 24.0001,2.0004 C17.0311,2.0004 10.0001,3.5354 10.0001,6.9644 L10.0001,26.0664 C10.0001,28.2914 12.8251,29.9124 17.9531,30.6304 C18.2941,30.6774 18.6481,30.7144 19.0001,30.7544 L19.0001,34.5534 C14.6111,33.8334 12.0021,32.2124 12.0021,30.6804 L12.0021,30.4874 L12.0021,30.0054 L10.0001,30.0054 L10.0001,45.0064 L12.0001,45.0064 L12.0001,40.3514 C14.3281,42.0474 18.5961,43.0684 24.0361,43.0684 C25.0681,43.0684 26.0571,43.0314 27.0001,42.9604 L27.0001,46.0054 L29.0001,46.0054 L29.0001,42.7434 C32.0281,42.3254 34.4361,41.5144 36.0001,40.4064 L36.0001,45.0064 L38.0001,45.0064 L38.0001,37.3484 C37.9981,37.2594 38.0001,37.2204 38.0001,37.1304 L38.0001,37.0834 Z" id="Amazon-DATABASE_AWS-Database-Migration-Service_Database-migration-workflow-job_Resource-Icon_light-bg" fill="#C925D1"></path>
    </g>
</svg>`, XA = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Database/Res_Amazon-DynamoDB_Attribute_48</title>
    <g id="Icon-Resource/Database/Res_Amazon-DynamoDB_Attribute_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M12.5996,17.7089 C9.7836,17.7089 7.4916,15.4169 7.4916,12.5999 C7.4916,9.7829 9.7836,7.4909 12.5996,7.4909 C15.4166,7.4909 17.7086,9.7829 17.7086,12.5999 C17.7086,15.4169 15.4166,17.7089 12.5996,17.7089 L12.5996,17.7089 Z M12.5996,5.4909 C8.6796,5.4909 5.4916,8.6799 5.4916,12.5999 C5.4916,16.5199 8.6796,19.7089 12.5996,19.7089 C16.5196,19.7089 19.7086,16.5199 19.7086,12.5999 C19.7086,8.6799 16.5196,5.4909 12.5996,5.4909 L12.5996,5.4909 Z M26.6906,43.8889 L43.8896,43.8889 L43.8896,26.6899 L26.6906,26.6899 L26.6906,43.8889 Z M24.6906,45.8899 L45.8896,45.8899 L45.8896,24.6909 L24.6906,24.6909 L24.6906,45.8899 Z M3.9996,43.8889 L21.1986,43.8889 L21.1986,26.6899 L3.9996,26.6899 L3.9996,43.8889 Z M1.9996,45.8899 L23.1986,45.8899 L23.1986,24.6909 L1.9996,24.6909 L1.9996,45.8899 Z M26.6906,21.1989 L43.8896,21.1989 L43.8896,3.9999 L26.6906,3.9999 L26.6906,21.1989 Z M24.6906,23.1989 L45.8896,23.1989 L45.8896,1.9999 L24.6906,1.9999 L24.6906,23.1989 Z M3.9996,21.1989 L21.1986,21.1989 L21.1986,3.9999 L3.9996,3.9999 L3.9996,21.1989 Z M1.9996,23.1989 L23.1986,23.1989 L23.1986,1.9999 L1.9996,1.9999 L1.9996,23.1989 Z" id="Amazon-DATABASE_Amazon-DynamoDB_Attribute_Resource-Icon_light-bg" fill="#C925D1"></path>
    </g>
</svg>`, JA = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Database/Res_Amazon-RDS_Blue-Green-Deployments_48</title>
    <g id="Icon-Resource/Database/Res_Amazon-RDS_Blue-Green-Deployments_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M35.8506,24.326 L32.0576,28.119 L30.6436,26.705 L35.1436,22.205 C35.5346,21.814 36.1666,21.814 36.5576,22.205 L41.0576,26.705 L39.6436,28.119 L35.8506,24.326 Z M30.6436,31.705 L35.1436,27.205 C35.5346,26.814 36.1666,26.814 36.5576,27.205 L41.0576,31.705 L39.6436,33.119 L35.8506,29.326 L32.0576,33.119 L30.6436,31.705 Z M27.8106,28.057 L24.9336,30.934 L23.5196,29.52 L24.6686,28.37 L16.0176,28.37 L16.0176,26.37 L24.7096,26.37 L23.5196,25.18 L24.9336,23.766 L27.8106,26.643 C27.9976,26.83 28.1036,27.085 28.1036,27.35 C28.1036,27.615 27.9976,27.869 27.8106,28.057 L27.8106,28.057 Z M35.7816,15.592 C31.1286,15.592 28.0036,14.146 28.0036,12.796 C28.0036,11.446 31.1286,10 35.7816,10 C40.9016,10 44.0456,11.629 44.0456,12.796 C44.0456,13.964 40.9016,15.592 35.7816,15.592 L35.7816,15.592 Z M46.0456,12.796 C46.0456,9.647 40.8816,8 35.7816,8 C29.9336,8 26.0036,9.928 26.0036,12.796 C26.0036,12.873 26.0176,12.946 26.0236,13.021 L26.0176,13.021 L26.0176,21.37 L28.0176,21.37 L28.0176,15.888 C29.7316,16.961 32.4416,17.592 35.7816,17.592 C38.9056,17.592 42.0466,16.971 44.0176,15.769 L44.0176,36.052 C44.0176,37.185 41.0816,38.824 35.7746,38.824 C30.9836,38.824 28.0176,37.385 28.0176,36.052 L28.0176,33.37 L26.0176,33.37 L26.0176,36.052 C26.0176,38.906 29.9386,40.824 35.7746,40.824 C40.7076,40.824 46.0176,39.33 46.0176,36.052 L46.0176,13.07 C46.0266,12.979 46.0456,12.89 46.0456,12.796 L46.0456,12.796 Z M12.2596,10 C16.9096,10 20.0326,11.446 20.0326,12.796 C20.0326,14.146 16.9096,15.592 12.2596,15.592 C7.1426,15.592 3.9996,13.964 3.9996,12.796 C3.9996,11.629 7.1426,10 12.2596,10 L12.2596,10 Z M20.0176,36.052 C20.0176,37.385 17.0516,38.824 12.2606,38.824 C6.9536,38.824 4.0176,37.185 4.0176,36.052 L4.0176,31.488 C6.0196,32.721 9.2596,33.302 12.3536,33.302 L12.3536,31.302 C7.2086,31.302 4.0506,29.685 4.0506,28.526 L4.0176,28.526 L4.0176,23.923 C6.0196,25.156 9.2596,25.737 12.3536,25.737 L12.3536,23.737 C7.2086,23.737 4.0506,22.12 4.0506,20.961 L4.0176,20.961 L4.0176,15.763 C5.9866,16.969 9.1326,17.592 12.2596,17.592 C15.5966,17.592 18.3046,16.962 20.0176,15.889 L20.0176,21.37 L22.0176,21.37 L22.0176,13.084 L22.0076,13.084 C22.0166,12.988 22.0326,12.894 22.0326,12.796 C22.0326,9.928 18.1046,8 12.2596,8 C7.1616,8 1.9996,9.647 1.9996,12.796 C1.9996,12.855 2.0136,12.909 2.0176,12.966 L2.0176,36.052 C2.0176,39.33 7.3276,40.824 12.2606,40.824 C18.0966,40.824 22.0176,38.906 22.0176,36.052 L22.0176,33.37 L20.0176,33.37 L20.0176,36.052 Z" id="Fill-1" fill="#C925D1"></path>
    </g>
</svg>`, Yi = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Database/Res_Amazon-DynamoDB_Table_48</title>
    <g id="Icon-Resource/Database/Res_Amazon-DynamoDB_Table_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M13.355,11.862 L45.928,11.862 L45.928,2 L13.355,2 L13.355,11.862 Z M15.355,9.862 L43.927,9.862 L43.927,4.001 L15.355,4.001 L15.355,9.862 Z M2,11.862 L11.861,11.862 L11.861,2 L2,2 L2,11.862 Z M4,9.862 L9.862,9.862 L9.862,4.001 L4,4.001 L4,9.862 Z M13.355,23.217 L45.928,23.217 L45.928,13.356 L13.355,13.356 L13.355,23.217 Z M15.355,21.217 L43.927,21.217 L43.927,15.356 L15.355,15.356 L15.355,21.217 Z M2,23.217 L11.861,23.217 L11.861,13.356 L2,13.356 L2,23.217 Z M4,21.217 L9.862,21.217 L9.862,15.356 L4,15.356 L4,21.217 Z M13.355,34.572 L45.928,34.572 L45.928,24.711 L13.355,24.711 L13.355,34.572 Z M15.355,32.572 L43.927,32.572 L43.927,26.71 L15.355,26.71 L15.355,32.572 Z M2,34.572 L11.861,34.572 L11.861,24.711 L2,24.711 L2,34.572 Z M4,32.572 L9.862,32.572 L9.862,26.71 L4,26.71 L4,32.572 Z M13.355,45.927 L45.928,45.927 L45.928,36.066 L13.355,36.066 L13.355,45.927 Z M15.355,43.928 L43.927,43.928 L43.927,38.066 L15.355,38.066 L15.355,43.928 Z M2,45.927 L11.861,45.927 L11.861,36.066 L2,36.066 L2,45.927 Z M4,43.928 L9.862,43.928 L9.862,38.066 L4,38.066 L4,43.928 Z" id="Amazon-DATABASE_Amazon-DynamoDB_Table_Resource-Icon_light-bg" fill="#C925D1"></path>
    </g>
</svg>`, eZ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Database/Res_Amazon-Aurora-Instance_48</title>
    <g id="Icon-Resource/Database/Res_Amazon-Aurora-Instance_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M43.9538,41.606 L43.9538,38.889 C42.1608,39.827 39.5038,40.261 37.0878,40.261 C34.6548,40.261 32.0088,39.825 30.2218,38.889 L30.2218,41.606 C30.2218,42.413 32.8948,43.955 37.0878,43.955 C41.2798,43.955 43.9538,42.413 43.9538,41.606 L43.9538,41.606 Z M30.2218,24.415 C30.2218,25.03 32.5578,26.474 37.0878,26.474 C41.6178,26.474 43.9538,25.03 43.9538,24.415 C43.9538,23.799 41.6178,22.355 37.0878,22.355 C32.5578,22.355 30.2218,23.799 30.2218,24.415 L30.2218,24.415 Z M43.9538,27.07 C42.2428,27.995 39.6598,28.474 37.0878,28.474 C34.5158,28.474 31.9328,27.995 30.2218,27.07 L30.2218,30.332 C30.7598,31.147 33.3138,32.204 37.0878,32.204 C40.5868,32.204 43.2218,31.273 43.9228,30.398 C43.9358,30.381 43.9418,30.366 43.9538,30.35 L43.9538,27.07 Z M30.2218,36.389 C30.7578,37.206 33.3108,38.261 37.0878,38.261 C40.9878,38.261 43.4258,37.176 43.9538,36.394 L43.9538,32.819 C42.3158,33.682 39.8538,34.204 37.0878,34.204 C34.6568,34.204 32.0098,33.767 30.2218,32.832 L30.2218,36.389 Z M45.9458,24.341 L45.9538,24.341 L45.9538,41.606 C45.9538,44.044 42.0588,45.955 37.0878,45.955 C32.1158,45.955 28.2218,44.044 28.2218,41.606 L28.2218,24.341 L28.2288,24.341 C28.3128,21.725 32.7238,20.355 37.0878,20.355 C41.4518,20.355 45.8628,21.725 45.9458,24.341 L45.9458,24.341 Z M27.4208,18.695 C27.2998,18.656 27.1548,18.637 26.9888,18.637 C26.8298,18.637 26.7068,18.688 26.6218,18.79 C26.5358,18.893 26.4928,19.041 26.4928,19.235 C26.4928,19.4 26.5268,19.532 26.5968,19.629 C26.6658,19.726 26.7578,19.774 26.8738,19.774 C27.0558,19.774 27.2378,19.686 27.4208,19.509 L27.4208,18.695 Z M28.4638,20.463 L27.5868,20.463 L27.4868,20.082 C27.3928,20.225 27.2578,20.343 27.0818,20.434 C26.9038,20.525 26.7248,20.572 26.5428,20.572 C26.1998,20.572 25.9308,20.459 25.7308,20.235 C25.5318,20.011 25.4328,19.703 25.4328,19.309 C25.4328,18.894 25.5548,18.566 25.7978,18.325 C26.0398,18.085 26.3688,17.964 26.7828,17.964 C26.9538,17.964 27.1668,17.997 27.4208,18.064 L27.4208,17.681 C27.4208,17.394 27.3828,17.199 27.3078,17.097 C27.2348,16.994 27.0958,16.943 26.8908,16.943 C26.5578,16.943 26.1528,17.031 25.6738,17.209 L25.6738,16.453 C25.8338,16.348 26.0428,16.265 26.3028,16.204 C26.5618,16.143 26.8268,16.112 27.0978,16.112 C27.5778,16.112 27.9258,16.222 28.1408,16.44 C28.3558,16.659 28.4638,17.009 28.4638,17.491 L28.4638,20.463 Z M23.8838,17.366 C24.1218,17.233 24.3728,17.167 24.6388,17.167 C24.7758,17.167 24.9228,17.18 25.0768,17.209 L25.0768,16.204 C24.9878,16.187 24.8998,16.179 24.8118,16.179 C24.6298,16.179 24.4568,16.226 24.2938,16.32 C24.1308,16.414 23.9678,16.563 23.8018,16.768 L23.6768,16.22 L22.7498,16.22 L22.7498,20.463 L23.8838,20.463 L23.8838,17.366 Z M19.6608,18.346 C19.6608,18.817 19.7058,19.162 19.7978,19.38 C19.8878,19.599 20.0358,19.708 20.2398,19.708 C20.4438,19.708 20.5928,19.599 20.6828,19.38 C20.7748,19.162 20.8198,18.817 20.8198,18.346 C20.8198,17.875 20.7748,17.529 20.6828,17.308 C20.5928,17.086 20.4438,16.976 20.2398,16.976 C20.0358,16.976 19.8878,17.086 19.7978,17.308 C19.7058,17.529 19.6608,17.875 19.6608,18.346 L19.6608,18.346 Z M18.9738,19.99 C18.6758,19.603 18.5248,19.055 18.5248,18.346 C18.5248,17.632 18.6758,17.082 18.9738,16.694 C19.2708,16.306 19.6938,16.112 20.2398,16.112 C20.7868,16.112 21.2088,16.306 21.5068,16.694 C21.8048,17.082 21.9548,17.632 21.9548,18.346 C21.9548,19.055 21.8048,19.603 21.5068,19.99 C21.2088,20.378 20.7868,20.572 20.2398,20.572 C19.6938,20.572 19.2708,20.378 18.9738,19.99 L18.9738,19.99 Z M17.0018,17.366 C17.2398,17.233 17.4898,17.167 17.7558,17.167 C17.8938,17.167 18.0408,17.18 18.1948,17.209 L18.1948,16.204 C18.1068,16.187 18.0178,16.179 17.9298,16.179 C17.7478,16.179 17.5758,16.226 17.4118,16.32 C17.2498,16.414 17.0848,16.563 16.9198,16.768 L16.7958,16.22 L15.8678,16.22 L15.8678,20.463 L17.0018,20.463 L17.0018,17.366 Z M11.7018,16.22 L11.7018,19.309 C11.7018,19.719 11.7818,20.031 11.9418,20.247 C12.1018,20.463 12.3368,20.572 12.6458,20.572 C13.0378,20.572 13.4468,20.408 13.8718,20.082 L13.9628,20.463 L14.8908,20.463 L14.8908,16.22 L13.7568,16.22 L13.7568,19.517 C13.5738,19.645 13.3998,19.708 13.2338,19.708 C13.0908,19.708 12.9888,19.65 12.9278,19.534 C12.8678,19.418 12.8368,19.224 12.8368,18.952 L12.8368,16.22 L11.7018,16.22 Z M9.4328,18.263 L8.9108,15.879 L8.4058,18.263 L9.4328,18.263 Z M9.5988,14.71 L11.1808,20.463 L9.9048,20.463 L9.6068,19.093 L8.2318,19.093 L7.9418,20.463 L6.7248,20.463 L8.3148,14.71 L9.5988,14.71 Z M32.4888,12.16 L32.4888,9.046 C32.4888,8.642 32.4048,8.335 32.2368,8.124 C32.0678,7.914 31.8228,7.809 31.5038,7.809 C31.0998,7.809 30.6788,7.972 30.2358,8.299 L30.1448,7.917 L29.2188,7.917 L29.2188,12.16 L30.3518,12.16 L30.3518,8.872 C30.5568,8.738 30.7438,8.672 30.9158,8.672 C31.0758,8.672 31.1878,8.728 31.2548,8.838 C31.3208,8.949 31.3548,9.126 31.3548,9.37 L31.3548,12.16 L32.4888,12.16 Z M26.1278,10.043 C26.1278,10.513 26.1738,10.858 26.2658,11.077 C26.3558,11.295 26.5048,11.404 26.7088,11.404 C26.9128,11.404 27.0598,11.295 27.1508,11.077 C27.2418,10.858 27.2878,10.513 27.2878,10.043 C27.2878,9.572 27.2418,9.226 27.1508,9.005 C27.0598,8.783 26.9128,8.672 26.7088,8.672 C26.5048,8.672 26.3558,8.783 26.2658,9.005 C26.1738,9.226 26.1278,9.572 26.1278,10.043 L26.1278,10.043 Z M25.4408,11.687 C25.1428,11.299 24.9938,10.752 24.9938,10.043 C24.9938,9.328 25.1428,8.778 25.4408,8.39 C25.7398,8.002 26.1618,7.809 26.7088,7.809 C27.2548,7.809 27.6778,8.002 27.9748,8.39 C28.2728,8.778 28.4228,9.328 28.4228,10.043 C28.4228,10.752 28.2728,11.299 27.9748,11.687 C27.6778,12.074 27.2548,12.268 26.7088,12.268 C26.1618,12.268 25.7398,12.074 25.4408,11.687 L25.4408,11.687 Z M24.4798,11.288 L22.7328,11.288 L24.4468,8.722 L24.4468,7.917 L21.6068,7.917 L21.6068,8.789 L23.2558,8.789 L21.5408,11.355 L21.5408,12.16 L24.4798,12.16 L24.4798,11.288 Z M18.8908,10.931 C18.8908,11.097 18.9248,11.229 18.9938,11.326 C19.0628,11.422 19.1558,11.471 19.2708,11.471 C19.4538,11.471 19.6358,11.382 19.8178,11.206 L19.8178,10.391 C19.6968,10.353 19.5538,10.333 19.3878,10.333 C19.2268,10.333 19.1038,10.384 19.0188,10.487 C18.9328,10.589 18.8908,10.738 18.8908,10.931 L18.8908,10.931 Z M18.9398,12.268 C18.5988,12.268 18.3278,12.155 18.1288,11.932 C17.9298,11.707 17.8308,11.399 17.8308,11.005 C17.8308,10.591 17.9518,10.262 18.1948,10.022 C18.4378,9.781 18.7668,9.66 19.1818,9.66 C19.3508,9.66 19.5638,9.694 19.8178,9.76 L19.8178,9.378 C19.8178,9.09 19.7798,8.896 19.7068,8.793 C19.6328,8.691 19.4928,8.64 19.2888,8.64 C18.9568,8.64 18.5518,8.728 18.0708,8.905 L18.0708,8.149 C18.2308,8.044 18.4398,7.961 18.6998,7.9 C18.9598,7.839 19.2248,7.809 19.4948,7.809 C19.9748,7.809 20.3238,7.918 20.5378,8.137 C20.7548,8.355 20.8618,8.705 20.8618,9.188 L20.8618,12.16 L19.9838,12.16 L19.8848,11.778 C19.7908,11.921 19.6548,12.039 19.4788,12.13 C19.3018,12.222 19.1228,12.268 18.9398,12.268 L18.9398,12.268 Z M15.7978,8.838 C15.8608,8.949 15.8928,9.124 15.8928,9.362 L15.8928,12.16 L17.0268,12.16 L17.0268,9.046 C17.0268,8.647 16.9448,8.341 16.7788,8.128 C16.6128,7.916 16.3758,7.809 16.0668,7.809 C15.6808,7.809 15.2598,7.978 14.8078,8.315 C14.6478,7.978 14.3708,7.809 13.9788,7.809 C13.5938,7.809 13.1798,7.972 12.7368,8.299 L12.6458,7.917 L11.7188,7.917 L11.7188,12.16 L12.8528,12.16 L12.8528,8.872 C13.0578,8.738 13.2368,8.672 13.3918,8.672 C13.5398,8.672 13.6468,8.728 13.7108,8.838 C13.7728,8.949 13.8058,9.124 13.8058,9.362 L13.8058,12.16 L14.9398,12.16 L14.9398,9.063 L14.9398,8.963 C14.9398,8.93 14.9378,8.899 14.9328,8.872 C15.1368,8.738 15.3188,8.672 15.4778,8.672 C15.6278,8.672 15.7338,8.728 15.7978,8.838 L15.7978,8.838 Z M9.4328,9.959 L8.9108,7.576 L8.4058,9.959 L9.4328,9.959 Z M11.1808,12.16 L9.9048,12.16 L9.6068,10.79 L8.2318,10.79 L7.9418,12.16 L6.7248,12.16 L8.3148,6.406 L9.5988,6.406 L11.1808,12.16 Z M45.9538,7.762 L45.9538,20.481 L43.9538,20.481 L43.9538,7.762 C43.9538,5.688 42.2668,4 40.1918,4 L7.7618,4 C5.6868,4 3.9998,5.688 3.9998,7.762 L3.9998,40.193 C3.9998,42.267 5.6868,43.955 7.7618,43.955 L27.4738,43.955 L27.4738,45.955 L7.7618,45.955 C4.5848,45.955 1.9998,43.37 1.9998,40.193 L1.9998,7.762 C1.9998,4.585 4.5848,2 7.7618,2 L40.1918,2 C43.3688,2 45.9538,4.585 45.9538,7.762 L45.9538,7.762 Z" id="Amazon-Aurora_Resource-Icon_light-bg" fill="#C925D1"></path>
    </g>
</svg>`, tZ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Database/Res_Amazon-Aurora-MariaDB-Instance_48</title>
    <g id="Icon-Resource/Database/Res_Amazon-Aurora-MariaDB-Instance_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M40.3469,13.5147 C40.3469,13.1517 40.2659,12.8707 40.1019,12.6757 C39.9389,12.4787 39.7029,12.3807 39.3989,12.3807 L38.6139,12.3807 L38.6139,14.6267 L39.4859,14.6267 C39.7609,14.6267 39.9739,14.5327 40.1239,14.3427 C40.2729,14.1547 40.3469,13.8777 40.3469,13.5147 L40.3469,13.5147 Z M38.6139,11.3457 L39.2249,11.3457 C39.4789,11.3457 39.6779,11.2537 39.8249,11.0727 C39.9689,10.8917 40.0419,10.6367 40.0419,10.3097 C40.0419,9.9757 39.9779,9.7147 39.8519,9.5307 C39.7239,9.3447 39.5469,9.2517 39.3219,9.2517 L38.6139,9.2517 L38.6139,11.3457 Z M40.6189,11.7487 C41.0189,11.8867 41.3239,12.1117 41.5299,12.4237 C41.7379,12.7367 41.8409,13.1257 41.8409,13.5907 C41.8409,14.2377 41.6299,14.7537 41.2079,15.1387 C40.7859,15.5247 40.2229,15.7167 39.5189,15.7167 L37.1749,15.7167 L37.1749,8.1617 L39.4529,8.1617 C40.0559,8.1617 40.5499,8.3477 40.9359,8.7177 C41.3209,9.0877 41.5139,9.5727 41.5139,10.1677 C41.5139,10.5457 41.4379,10.8687 41.2839,11.1387 C41.1319,11.4077 40.9099,11.6117 40.6189,11.7487 L40.6189,11.7487 Z M34.3199,11.8247 C34.3199,10.9667 34.2039,10.3367 33.9749,9.9337 C33.7469,9.5307 33.3889,9.3277 32.9029,9.3277 L32.2699,9.3277 L32.2699,14.5497 L32.9119,14.5497 C33.3839,14.5497 33.7369,14.3447 33.9699,13.9347 C34.2009,13.5237 34.3199,12.8937 34.3199,12.0427 L34.3199,11.8247 Z M35.1589,9.1207 C35.6449,9.7607 35.8879,10.6997 35.8879,11.9337 C35.8879,13.1757 35.6489,14.1187 35.1689,14.7567 C34.6889,15.3967 33.9929,15.7167 33.0759,15.7167 L30.7429,15.7167 L30.7429,8.1617 L33.0219,8.1617 C33.9589,8.1617 34.6709,8.4827 35.1589,9.1207 L35.1589,9.1207 Z M28.0069,13.3947 C27.8469,13.3437 27.6579,13.3187 27.4399,13.3187 C27.2299,13.3187 27.0679,13.3857 26.9549,13.5207 C26.8419,13.6557 26.7849,13.8487 26.7849,14.1027 C26.7849,14.3217 26.8309,14.4937 26.9219,14.6207 C27.0129,14.7477 27.1349,14.8117 27.2869,14.8117 C27.5279,14.8117 27.7669,14.6957 28.0069,14.4627 L28.0069,13.3947 Z M28.0939,15.2147 C27.9699,15.4047 27.7919,15.5587 27.5599,15.6787 C27.3269,15.7987 27.0909,15.8587 26.8509,15.8587 C26.4009,15.8587 26.0439,15.7107 25.7839,15.4167 C25.5219,15.1217 25.3909,14.7177 25.3909,14.2017 C25.3909,13.6567 25.5509,13.2257 25.8699,12.9107 C26.1899,12.5937 26.6219,12.4357 27.1669,12.4357 C27.3929,12.4357 27.6729,12.4787 28.0069,12.5667 L28.0069,12.0647 C28.0069,11.6867 27.9569,11.4307 27.8599,11.2957 C27.7619,11.1617 27.5769,11.0947 27.3099,11.0947 C26.8729,11.0947 26.3389,11.2107 25.7059,11.4437 L25.7059,10.4517 C25.9169,10.3127 26.1939,10.2037 26.5349,10.1237 C26.8769,10.0447 27.2249,10.0047 27.5819,10.0047 C28.2139,10.0047 28.6719,10.1477 28.9549,10.4347 C29.2389,10.7217 29.3799,11.1817 29.3799,11.8137 L29.3799,15.7167 L28.2249,15.7167 L28.0939,15.2147 Z M22.7849,15.7167 L24.2779,15.7167 L24.2779,10.1467 L22.7849,10.1467 L22.7849,15.7167 Z M24.1689,7.8077 C24.0099,7.6597 23.7999,7.5837 23.5369,7.5837 C23.2679,7.5837 23.0539,7.6597 22.8949,7.8077 C22.7359,7.9557 22.6559,8.1587 22.6559,8.4127 C22.6559,8.6677 22.7359,8.8687 22.8949,9.0177 C23.0539,9.1667 23.2679,9.2417 23.5369,9.2417 C23.7999,9.2417 24.0099,9.1667 24.1689,9.0177 C24.3289,8.8687 24.4089,8.6677 24.4089,8.4127 C24.4089,8.1587 24.3289,7.9557 24.1689,7.8077 L24.1689,7.8077 Z M20.3989,10.8657 L20.2349,10.1467 L19.0139,10.1467 L19.0139,15.7167 L20.5069,15.7167 L20.5069,11.6507 C20.8189,11.4767 21.1509,11.3887 21.4979,11.3887 C21.6809,11.3887 21.8729,11.4077 22.0759,11.4437 L22.0759,10.1237 C21.9599,10.1027 21.8439,10.0917 21.7289,10.0917 C21.4889,10.0917 21.2609,10.1537 21.0469,10.2777 C20.8319,10.4007 20.6169,10.5967 20.3989,10.8657 L20.3989,10.8657 Z M16.3759,13.3947 C16.2159,13.3437 16.0279,13.3187 15.8099,13.3187 C15.5979,13.3187 15.4369,13.3857 15.3249,13.5207 C15.2119,13.6557 15.1559,13.8487 15.1559,14.1027 C15.1559,14.3217 15.1999,14.4937 15.2919,14.6207 C15.3819,14.7477 15.5039,14.8117 15.6569,14.8117 C15.8969,14.8117 16.1369,14.6957 16.3759,14.4627 L16.3759,13.3947 Z M16.3759,12.5667 L16.3759,12.0647 C16.3759,11.6867 16.3269,11.4307 16.2289,11.2957 C16.1309,11.1617 15.9479,11.0947 15.6779,11.0947 C15.2429,11.0947 14.7069,11.2107 14.0759,11.4437 L14.0759,10.4517 C14.2859,10.3127 14.5629,10.2037 14.9049,10.1237 C15.2449,10.0447 15.5949,10.0047 15.9509,10.0047 C16.5829,10.0047 17.0409,10.1477 17.3239,10.4347 C17.6089,10.7217 17.7489,11.1817 17.7489,11.8137 L17.7489,15.7167 L16.5939,15.7167 L16.4629,15.2147 C16.3389,15.4047 16.1609,15.5587 15.9289,15.6787 C15.6969,15.7987 15.4599,15.8587 15.2199,15.8587 C14.7699,15.8587 14.4129,15.7107 14.1529,15.4167 C13.8899,15.1217 13.7599,14.7177 13.7599,14.2017 C13.7599,13.6567 13.9189,13.2257 14.2399,12.9107 C14.5599,12.5937 14.9929,12.4357 15.5369,12.4357 C15.7619,12.4357 16.0409,12.4787 16.3759,12.5667 L16.3759,12.5667 Z M12.5819,15.7167 L12.5819,8.1617 L10.8819,8.1617 L9.3239,12.3917 L7.7639,8.1617 L6.0199,8.1617 L6.0199,15.7167 L7.3819,15.7167 L7.3819,10.4517 L8.6469,13.8527 L9.9449,13.8527 L11.2189,10.4187 L11.2189,15.7167 L12.5819,15.7167 Z M43.9709,29.9857 L43.9709,26.4537 C42.2429,27.3977 39.6209,27.8847 37.0119,27.8847 C34.4029,27.8847 31.7809,27.3967 30.0519,26.4537 L30.0519,29.9857 C30.0519,30.6147 32.4199,32.0867 37.0119,32.0867 C41.6039,32.0867 43.9709,30.6147 43.9709,29.9857 L43.9709,29.9857 Z M43.9709,36.0787 L43.9709,32.6567 C42.2429,33.5997 39.6209,34.0867 37.0119,34.0867 C34.4029,34.0867 31.7809,33.5997 30.0519,32.6567 L30.0519,36.0787 C30.0519,36.7067 32.4199,38.1797 37.0119,38.1797 C41.6039,38.1797 43.9709,36.7067 43.9709,36.0787 L43.9709,36.0787 Z M43.9709,41.5197 L43.9709,38.7497 C42.2429,39.6927 39.6209,40.1797 37.0119,40.1797 C34.4029,40.1797 31.7809,39.6927 30.0519,38.7497 L30.0519,41.5197 C30.0519,42.1477 32.4199,43.6197 37.0119,43.6197 C41.6039,43.6197 43.9709,42.1477 43.9709,41.5197 L43.9709,41.5197 Z M30.0519,23.7837 C30.0519,24.4117 32.4199,25.8847 37.0119,25.8847 C41.6039,25.8847 43.9709,24.4117 43.9709,23.7837 C43.9709,23.1557 41.6039,21.6827 37.0119,21.6827 C32.4199,21.6827 30.0519,23.1557 30.0519,23.7837 L30.0519,23.7837 Z M45.9709,23.7837 L45.9709,41.5197 C45.9709,44.2117 41.4639,45.6197 37.0119,45.6197 C32.5599,45.6197 28.0519,44.2117 28.0519,41.5197 L28.0519,23.7837 C28.0519,21.0907 32.5599,19.6827 37.0119,19.6827 C41.4639,19.6827 45.9709,21.0907 45.9709,23.7837 L45.9709,23.7837 Z M7.7509,43.8607 L27.4189,43.8607 L27.4189,45.8607 L7.7509,45.8607 C4.5799,45.8607 1.9999,43.2807 1.9999,40.1097 L1.9999,7.7507 C1.9999,4.5797 4.5799,1.9997 7.7509,1.9997 L40.1099,1.9997 C43.2809,1.9997 45.8609,4.5797 45.8609,7.7507 L45.8609,20.4427 L43.8609,20.4427 L43.8609,7.7507 C43.8609,5.6827 42.1779,3.9997 40.1099,3.9997 L7.7509,3.9997 C5.6829,3.9997 3.9999,5.6827 3.9999,7.7507 L3.9999,40.1097 C3.9999,42.1777 5.6829,43.8607 7.7509,43.8607 L7.7509,43.8607 Z" id="Amazon-DATABASEAmazon-Aurora-MariaDB-instance_Resource-Icon_light-bg" fill="#C925D1"></path>
    </g>
</svg>`, nZ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Database/Res_Amazon-ElastiCache_ElastiCache-for-Memcached_48</title>
    <g id="Icon-Resource/Database/Res_Amazon-ElastiCache_ElastiCache-for-Memcached_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M43.4482,11.4629 C43.4482,12.2819 44.1192,12.9479 44.9442,12.9479 C45.4972,12.9479 45.9442,13.3959 45.9442,13.9479 L45.9442,29.8569 C45.9442,30.4089 45.4972,30.8569 44.9442,30.8569 L37.1772,30.8569 L37.1772,28.8569 L40.8382,28.8569 L40.8382,26.9729 L37.1772,26.9729 L37.1772,24.9729 L41.8382,24.9729 C42.3902,24.9729 42.8382,25.4199 42.8382,25.9729 L42.8382,28.8569 L43.9442,28.8569 L43.9442,14.8029 C42.5022,14.3729 41.4482,13.0379 41.4482,11.4629 C41.4482,9.8879 42.5022,8.5529 43.9442,8.1229 L43.9442,5.9999 L4.0002,5.9999 L4.0002,8.1229 C5.4422,8.5529 6.4962,9.8879 6.4962,11.4629 C6.4962,13.0379 5.4422,14.3729 4.0002,14.8029 L4.0002,28.8569 L5.1062,28.8569 L5.1062,25.9729 C5.1062,25.4199 5.5532,24.9729 6.1062,24.9729 L10.7672,24.9729 L10.7672,26.9729 L7.1062,26.9729 L7.1062,28.8569 L10.7672,28.8569 L10.7672,30.8569 L3.0002,30.8569 C2.4472,30.8569 2.0002,30.4089 2.0002,29.8569 L2.0002,13.9479 C2.0002,13.3959 2.4472,12.9479 3.0002,12.9479 C3.8252,12.9479 4.4962,12.2819 4.4962,11.4629 C4.4962,10.6439 3.8252,9.9779 3.0002,9.9779 C2.4472,9.9779 2.0002,9.5299 2.0002,8.9779 L2.0002,4.9999 C2.0002,4.4469 2.4472,3.9999 3.0002,3.9999 L44.9442,3.9999 C45.4972,3.9999 45.9442,4.4469 45.9442,4.9999 L45.9442,8.9779 C45.9442,9.5299 45.4972,9.9779 44.9442,9.9779 C44.1192,9.9779 43.4482,10.6439 43.4482,11.4629 L43.4482,11.4629 Z M27.5932,27.3089 L29.8482,27.3089 L29.8482,39.1509 L27.9342,39.1509 L27.9342,30.2819 L24.8582,36.1779 L22.9792,36.1779 L20.0052,30.3169 L20.0052,39.1509 L18.0912,39.1509 L18.0912,27.3089 L20.4152,27.3089 L23.9692,34.3659 L27.5932,27.3089 Z M10.2142,21.0889 L11.5442,21.0889 L11.5442,23.0889 L9.2142,23.0889 C8.6612,23.0889 8.2142,22.6419 8.2142,22.0889 L8.2142,8.8839 C8.2142,8.3309 8.6612,7.8839 9.2142,7.8839 L13.8742,7.8839 C14.4272,7.8839 14.8742,8.3309 14.8742,8.8839 L14.8742,15.0989 L12.8742,15.0989 L12.8742,9.8839 L10.2142,9.8839 L10.2142,21.0889 Z M37.7302,21.0889 L37.7302,9.8839 L35.0702,9.8839 L35.0702,15.0989 L33.0702,15.0989 L33.0702,8.8839 C33.0702,8.3309 33.5172,7.8839 34.0702,7.8839 L38.7302,7.8839 C39.2832,7.8839 39.7302,8.3309 39.7302,8.8839 L39.7302,22.0889 C39.7302,22.6419 39.2832,23.0889 38.7302,23.0889 L37.1772,23.0889 L37.1772,21.0889 L37.7302,21.0889 Z M29.9632,14.3209 L29.9632,9.8839 L26.5252,9.8839 L26.5252,13.5449 L24.5252,13.5449 L24.5252,8.8839 C24.5252,8.3309 24.9722,7.8839 25.5252,7.8839 L30.9632,7.8839 C31.5152,7.8839 31.9632,8.3309 31.9632,8.8839 L31.9632,14.3209 L29.9632,14.3209 Z M21.4192,13.5449 L21.4192,9.8839 L17.9812,9.8839 L17.9812,14.3209 L15.9812,14.3209 L15.9812,8.8839 C15.9812,8.3309 16.4282,7.8839 16.9812,7.8839 L22.4192,7.8839 C22.9712,7.8839 23.4192,8.3309 23.4192,8.8839 L23.4192,13.5449 L21.4192,13.5449 Z M31.6892,30.1549 C32.5812,29.8739 33.2862,29.5659 33.8462,29.2439 L33.8462,33.5099 C33.8462,33.8559 33.1122,34.6009 31.0882,35.2399 L31.6892,37.1469 C32.5812,36.8649 33.2862,36.5569 33.8462,36.2349 L33.8462,40.0409 C33.8462,40.8269 30.4872,42.6709 23.9732,42.6709 C17.4582,42.6709 14.0972,40.8269 14.0972,40.0409 L14.0972,36.2359 C14.6652,36.5609 15.3782,36.8729 16.2832,37.1559 L16.8812,35.2479 C14.8392,34.6089 14.0972,33.8589 14.0972,33.5099 L14.0972,29.2449 C14.6652,29.5699 15.3782,29.8819 16.2832,30.1649 L16.8812,28.2569 C14.8392,27.6169 14.0972,26.8669 14.0972,26.5189 L14.0972,22.2079 C16.3502,23.5009 20.1822,24.1699 23.9952,24.1699 C27.7812,24.1699 31.5892,23.5099 33.8462,22.2339 L33.8462,26.5189 C33.8462,26.8639 33.1122,27.6089 31.0882,28.2489 L31.6892,30.1549 Z M23.9952,16.8239 C30.1422,16.8239 33.9042,18.5549 33.9042,19.4969 C33.9042,20.4399 30.1422,22.1699 23.9952,22.1699 C17.8442,22.1699 14.0812,20.4399 14.0812,19.4969 C14.0812,18.5549 17.8442,16.8239 23.9952,16.8239 L23.9952,16.8239 Z M23.9952,14.8239 C18.0742,14.8239 12.0972,16.4299 12.0972,19.4969 C12.0972,19.5869 12.0962,19.6939 12.0972,19.7589 L12.0972,40.0409 C12.0972,43.0799 18.0722,44.6709 23.9732,44.6709 C29.8742,44.6709 35.8662,43.0799 35.8662,40.0409 L35.8662,20.2899 C35.8712,20.1209 35.8662,19.6579 35.8662,19.4969 C35.8662,16.4299 29.9132,14.8239 23.9952,14.8239 L23.9952,14.8239 Z" id="Amazon-DATABASE_Amazon-ElastiCache_ElastiCache-for-Memcached_Resource-Icon_light-bg" fill="#C925D1"></path>
    </g>
</svg>`, iZ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Database/Res_Amazon-RDS-Proxy-Instance-Alternate_48</title>
    <g id="Icon-Resource/Database/Res_Amazon-RDS-Proxy-Instance-Alternate_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M28.33,26.61 L26.525,20.911 L28.111,20.911 L28.954,25.024 L29.774,20.911 L31.316,20.911 L29.468,27.354 C29.315,27.894 29.11,28.284 28.855,28.525 C28.601,28.764 28.265,28.885 27.849,28.885 C27.536,28.885 27.215,28.831 26.887,28.721 L26.887,27.715 C27.083,27.745 27.259,27.758 27.411,27.758 C27.687,27.758 27.896,27.685 28.035,27.54 C28.173,27.394 28.265,27.149 28.309,26.807 L28.33,26.61 Z M24.502,26.501 L23.595,24.728 L22.816,26.501 L21.34,26.501 L22.904,23.689 L21.362,20.911 L22.971,20.911 L23.791,22.629 L24.546,20.911 L26.022,20.911 L24.479,23.689 L26.11,26.501 L24.502,26.501 Z M18.736,25.506 C19.007,25.506 19.201,25.362 19.322,25.073 C19.442,24.785 19.502,24.331 19.502,23.712 C19.502,23.091 19.442,22.635 19.322,22.344 C19.201,22.052 19.007,21.907 18.736,21.907 C18.467,21.907 18.271,22.052 18.152,22.344 C18.03,22.635 17.971,23.091 17.971,23.712 C17.971,24.331 18.03,24.785 18.152,25.073 C18.271,25.362 18.467,25.506 18.736,25.506 L18.736,25.506 Z M18.736,26.643 C18.016,26.643 17.456,26.388 17.063,25.877 C16.669,25.367 16.472,24.644 16.472,23.712 C16.472,22.77 16.669,22.045 17.063,21.535 C17.456,21.023 18.016,20.769 18.736,20.769 C19.459,20.769 20.017,21.023 20.41,21.535 C20.805,22.045 21.001,22.77 21.001,23.712 C21.001,24.644 20.805,25.367 20.41,25.877 C20.017,26.388 19.459,26.643 18.736,26.643 L18.736,26.643 Z M12.961,26.501 L12.961,20.911 L14.186,20.911 L14.351,21.632 C14.569,21.363 14.786,21.167 15.002,21.043 C15.217,20.919 15.444,20.856 15.685,20.856 C15.802,20.856 15.918,20.867 16.035,20.888 L16.035,22.213 C15.831,22.176 15.638,22.158 15.455,22.158 C15.105,22.158 14.772,22.246 14.46,22.42 L14.46,26.501 L12.961,26.501 Z M8.761,22.551 L9.472,22.551 C9.756,22.551 9.974,22.446 10.122,22.235 C10.272,22.023 10.347,21.714 10.347,21.304 C10.347,20.896 10.272,20.586 10.122,20.375 C9.974,20.163 9.756,20.058 9.472,20.058 L8.761,20.058 L8.761,22.551 Z M8.761,23.689 L8.761,26.501 L7.263,26.501 L7.263,18.92 L9.657,18.92 C10.329,18.92 10.862,19.133 11.261,19.559 C11.657,19.986 11.856,20.568 11.856,21.304 C11.856,22.042 11.657,22.623 11.261,23.049 C10.862,23.476 10.329,23.689 9.657,23.689 L8.761,23.689 Z M20.641,11.744 C20.101,11.452 19.714,11.138 19.48,10.802 C19.248,10.467 19.132,10.059 19.132,9.578 C19.132,9.132 19.233,8.745 19.437,8.413 C19.641,8.081 19.92,7.826 20.274,7.646 C20.628,7.468 21.034,7.379 21.493,7.379 C22.069,7.379 22.643,7.509 23.211,7.773 L23.211,8.932 C22.62,8.714 22.099,8.604 21.647,8.604 C21.341,8.604 21.101,8.68 20.925,8.834 C20.75,8.987 20.663,9.199 20.663,9.468 C20.663,9.694 20.72,9.881 20.832,10.026 C20.945,10.172 21.162,10.333 21.483,10.507 L22.073,10.825 C22.452,11.029 22.753,11.233 22.976,11.437 C23.198,11.641 23.362,11.87 23.468,12.121 C23.573,12.373 23.627,12.677 23.627,13.035 C23.627,13.727 23.402,14.276 22.954,14.68 C22.506,15.086 21.888,15.288 21.101,15.288 C20.757,15.288 20.415,15.248 20.071,15.168 C19.728,15.088 19.44,14.981 19.207,14.85 L19.207,13.702 C19.476,13.803 19.782,13.89 20.121,13.96 C20.46,14.029 20.75,14.063 20.991,14.063 C21.341,14.063 21.606,13.981 21.789,13.816 C21.972,13.652 22.062,13.418 22.062,13.112 C22.062,12.885 21.999,12.694 21.871,12.537 C21.743,12.38 21.53,12.221 21.231,12.061 L20.641,11.744 Z M14.624,8.714 L14.624,13.954 L15.269,13.954 C15.744,13.954 16.098,13.748 16.33,13.336 C16.564,12.923 16.681,12.291 16.681,11.437 L16.681,11.218 C16.681,10.358 16.565,9.725 16.336,9.32 C16.106,8.916 15.747,8.714 15.258,8.714 L14.624,8.714 Z M13.093,15.124 L13.093,7.543 L15.379,7.543 C16.319,7.543 17.034,7.864 17.523,8.506 C18.012,9.147 18.256,10.089 18.256,11.328 C18.256,12.575 18.016,13.52 17.533,14.161 C17.053,14.802 16.352,15.124 15.434,15.124 L13.093,15.124 Z M8.761,11.174 L9.472,11.174 C9.756,11.174 9.974,11.069 10.122,10.857 C10.272,10.646 10.347,10.336 10.347,9.927 C10.347,9.519 10.272,9.21 10.122,8.998 C9.974,8.786 9.756,8.68 9.472,8.68 L8.761,8.68 L8.761,11.174 Z M10.675,15.124 L9.351,12.312 L8.761,12.312 L8.761,15.124 L7.263,15.124 L7.263,7.543 L9.657,7.543 C10.329,7.543 10.862,7.756 11.261,8.183 C11.657,8.609 11.856,9.191 11.856,9.927 C11.856,10.438 11.758,10.88 11.561,11.252 C11.364,11.623 11.083,11.9 10.719,12.083 L12.25,15.124 L10.675,15.124 Z M7.643,3.75 C5.496,3.75 3.75,5.496 3.75,7.642 L3.75,40.113 C3.75,42.26 5.496,44.006 7.643,44.006 L40.113,44.006 C42.26,44.006 44.006,42.26 44.006,40.113 L44.006,7.642 C44.006,5.496 42.26,3.75 40.113,3.75 L7.643,3.75 Z M40.113,45.756 L7.643,45.756 C4.531,45.756 2,43.225 2,40.113 L2,7.642 C2,4.531 4.531,2 7.643,2 L40.113,2 C43.225,2 45.756,4.531 45.756,7.642 L45.756,40.113 C45.756,43.225 43.225,45.756 40.113,45.756 L40.113,45.756 Z" id="Amazon-DATABASE_Amazon-RDS-Proxy-Alternate_Resource-Icon_light-bg" fill="#C925D1"></path>
    </g>
</svg>`, sZ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Database/Res_Amazon-Aurora-PostgreSQL-Instance_48</title>
    <g id="Icon-Resource/Database/Res_Amazon-Aurora-PostgreSQL-Instance_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M37.0056,32.082 C32.4146,32.082 30.0476,30.609 30.0476,29.981 L30.0476,26.451 C31.7766,27.394 34.3976,27.881 37.0056,27.881 C39.6146,27.881 42.2346,27.394 43.9636,26.451 L43.9636,29.981 C43.9636,30.609 41.5966,32.082 37.0056,32.082 L37.0056,32.082 Z M37.0056,38.174 C32.4146,38.174 30.0476,36.701 30.0476,36.073 L30.0476,32.652 C31.7766,33.595 34.3976,34.082 37.0056,34.082 C39.6146,34.082 42.2346,33.595 43.9636,32.652 L43.9636,36.073 C43.9636,36.701 41.5966,38.174 37.0056,38.174 L37.0056,38.174 Z M37.0056,43.613 C32.4146,43.613 30.0476,42.141 30.0476,41.513 L30.0476,38.744 C31.7766,39.686 34.3976,40.174 37.0056,40.174 C39.6146,40.174 42.2346,39.686 43.9636,38.744 L43.9636,41.513 C43.9636,42.141 41.5966,43.613 37.0056,43.613 L37.0056,43.613 Z M37.0056,21.68 C41.5966,21.68 43.9636,23.152 43.9636,23.78 C43.9636,24.408 41.5966,25.881 37.0056,25.881 C32.4146,25.881 30.0476,24.408 30.0476,23.78 C30.0476,23.152 32.4146,21.68 37.0056,21.68 L37.0056,21.68 Z M37.0056,19.68 C32.5546,19.68 28.0476,21.088 28.0476,23.78 L28.0476,41.513 C28.0476,44.205 32.5546,45.613 37.0056,45.613 C41.4566,45.613 45.9636,44.205 45.9636,41.513 L45.9636,23.78 C45.9636,21.088 41.4566,19.68 37.0056,19.68 L37.0056,19.68 Z M7.7496,43.853 L27.4136,43.853 L27.4136,45.853 L7.7496,45.853 C4.5786,45.853 1.9996,43.274 1.9996,40.103 L1.9996,7.751 C1.9996,4.58 4.5786,2 7.7496,2 L40.1036,2 C43.2746,2 45.8536,4.58 45.8536,7.751 L45.8536,20.439 L43.8536,20.439 L43.8536,7.751 C43.8536,5.683 42.1706,4 40.1036,4 L7.7496,4 C5.6826,4 3.9996,5.683 3.9996,7.751 L3.9996,40.103 C3.9996,42.171 5.6826,43.853 7.7496,43.853 L7.7496,43.853 Z M40.6286,7.805 L40.6286,13.141 L42.8256,13.141 L42.8256,13.848 L39.7826,13.848 L39.7826,7.805 L40.6286,7.805 Z M36.3296,13.263 C35.8596,13.263 35.5046,13.059 35.2666,12.648 C35.0276,12.238 34.9086,11.633 34.9086,10.83 C34.9086,10.028 35.0276,9.424 35.2666,9.017 C35.5046,8.61 35.8596,8.406 36.3296,8.406 C36.8006,8.406 37.1546,8.61 37.3946,9.017 C37.6316,9.424 37.7506,10.028 37.7506,10.83 C37.7506,11.633 37.6316,12.238 37.3946,12.648 C37.1546,13.059 36.8006,13.263 36.3296,13.263 L36.3296,13.263 Z M38.1956,12.857 C38.4746,12.331 38.6136,11.656 38.6136,10.83 C38.6136,9.836 38.4136,9.064 38.0126,8.515 C37.6116,7.966 37.0506,7.691 36.3296,7.691 C35.6096,7.691 35.0486,7.966 34.6476,8.515 C34.2456,9.064 34.0456,9.836 34.0456,10.83 C34.0456,11.464 34.1286,12.013 34.2936,12.478 C34.4596,12.943 34.7046,13.304 35.0306,13.56 C35.3566,13.815 35.7486,13.954 36.2076,13.978 C36.5396,14.339 36.9016,14.626 37.2976,14.842 C37.6926,15.057 38.1116,15.193 38.5536,15.251 L38.5536,14.51 C38.2506,14.476 37.9756,14.408 37.7256,14.31 C37.4756,14.21 37.2346,14.068 37.0016,13.882 C37.5186,13.725 37.9166,13.384 38.1956,12.857 L38.1956,12.857 Z M32.0966,12.993 C32.2746,12.818 32.3626,12.577 32.3626,12.269 C32.3626,11.851 32.1306,11.522 31.6656,11.284 L31.0456,10.97 C30.6566,10.772 30.3746,10.546 30.1996,10.29 C30.0266,10.034 29.9386,9.72 29.9386,9.348 C29.9386,8.854 30.0926,8.454 30.4016,8.149 C30.7086,7.844 31.1126,7.691 31.6126,7.691 C32.0016,7.691 32.4386,7.796 32.9206,8.005 L32.9206,8.686 C32.5256,8.505 32.1096,8.415 31.6736,8.415 C31.4006,8.415 31.1846,8.495 31.0246,8.654 C30.8636,8.814 30.7846,9.031 30.7846,9.305 C30.7846,9.52 30.8396,9.702 30.9496,9.853 C31.0606,10.005 31.2436,10.147 31.4996,10.281 L32.1176,10.595 C32.4966,10.787 32.7746,11.014 32.9506,11.274 C33.1286,11.537 33.2176,11.851 33.2176,12.217 C33.2176,12.746 33.0516,13.172 32.7206,13.494 C32.3886,13.816 31.9466,13.978 31.3956,13.978 C31.1266,13.978 30.8696,13.947 30.6226,13.887 C30.3756,13.825 30.1626,13.737 29.9826,13.621 L29.9826,12.949 C30.4586,13.153 30.9206,13.254 31.3686,13.254 C31.6766,13.254 31.9196,13.167 32.0966,12.993 L32.0966,12.993 Z M27.0736,10.268 C27.2226,10.044 27.4306,9.932 27.6976,9.932 C27.9366,9.932 28.1126,10.02 28.2296,10.198 C28.3456,10.376 28.4036,10.65 28.4036,11.021 C28.4036,11.062 28.4016,11.103 28.3996,11.145 C28.3966,11.185 28.3956,11.223 28.3956,11.258 L26.8256,11.258 C26.8436,10.821 26.9256,10.492 27.0736,10.268 L27.0736,10.268 Z M29.0496,13.027 C28.6486,13.208 28.2816,13.298 27.9506,13.298 C27.5616,13.298 27.2766,13.182 27.1006,12.949 C26.9226,12.717 26.8316,12.339 26.8256,11.815 L29.0586,11.815 C29.1046,11.595 29.1276,11.353 29.1276,11.092 C29.1276,10.505 29.0096,10.061 28.7746,9.758 C28.5386,9.456 28.1916,9.305 27.7326,9.305 C27.1926,9.305 26.7766,9.505 26.4856,9.906 C26.1946,10.307 26.0496,10.883 26.0496,11.633 C26.0496,12.417 26.1946,13.001 26.4856,13.386 C26.7766,13.769 27.2176,13.961 27.8116,13.961 C28.2816,13.961 28.6936,13.851 29.0496,13.629 L29.0496,13.027 Z M24.7986,9.526 C24.9696,9.436 25.1656,9.392 25.3866,9.392 C25.4806,9.392 25.5726,9.4 25.6656,9.418 L25.6656,10.177 C25.5026,10.153 25.3716,10.142 25.2736,10.142 C24.9426,10.142 24.6406,10.249 24.3666,10.464 L24.3666,13.848 L23.5466,13.848 L23.5466,9.427 L24.2276,9.427 L24.3056,9.958 C24.4626,9.761 24.6266,9.617 24.7986,9.526 L24.7986,9.526 Z M20.8096,13.089 C20.5186,13.089 20.3036,12.962 20.1646,12.709 C20.0256,12.456 19.9546,12.068 19.9546,11.545 C19.9546,11.011 20.0206,10.616 20.1516,10.363 C20.2816,10.11 20.4866,9.984 20.7666,9.984 C21.0266,9.984 21.2946,10.089 21.5676,10.299 L21.5676,12.757 C21.3006,12.978 21.0476,13.089 20.8096,13.089 L20.8096,13.089 Z M21.3416,14.736 C21.1906,14.958 20.9346,15.067 20.5736,15.067 C20.2426,15.067 19.8596,14.978 19.4236,14.798 L19.4236,15.426 C19.7956,15.641 20.2016,15.748 20.6446,15.748 C21.8006,15.748 22.3796,15.03 22.3796,13.595 L22.3796,9.427 L21.6986,9.427 L21.6386,9.784 C21.3006,9.47 20.9486,9.313 20.5826,9.313 C20.1416,9.313 19.7896,9.517 19.5276,9.924 C19.2666,10.33 19.1356,10.88 19.1356,11.571 C19.1356,12.008 19.1926,12.39 19.3056,12.718 C19.4186,13.046 19.5826,13.303 19.7986,13.485 C20.0136,13.668 20.2696,13.76 20.5656,13.76 C20.9136,13.76 21.2486,13.612 21.5676,13.315 L21.5676,13.638 C21.5676,14.149 21.4916,14.516 21.3416,14.736 L21.3416,14.736 Z M16.6936,12.687 L16.6936,10.089 L16.0746,10.089 L16.0746,9.549 L16.7296,9.444 L16.8506,8.188 L17.5136,8.188 L17.5136,9.427 L18.5256,9.427 L18.5256,10.089 L17.5136,10.089 L17.5136,12.627 C17.5136,12.848 17.5496,13.003 17.6226,13.093 C17.6946,13.183 17.8246,13.228 18.0106,13.228 C18.1906,13.228 18.3676,13.199 18.5426,13.141 L18.5426,13.742 C18.2926,13.848 18.0276,13.899 17.7486,13.899 C17.3886,13.899 17.1226,13.801 16.9506,13.603 C16.7796,13.405 16.6936,13.101 16.6936,12.687 L16.6936,12.687 Z M14.8596,13.145 C14.9776,13.032 15.0376,12.87 15.0376,12.661 C15.0376,12.411 14.8776,12.208 14.5576,12.051 L13.9906,11.772 C13.4676,11.517 13.2066,11.115 13.2066,10.569 C13.2066,10.197 13.3286,9.895 13.5716,9.662 C13.8166,9.43 14.1336,9.313 14.5236,9.313 C14.8896,9.313 15.2406,9.406 15.5776,9.593 L15.5776,10.185 C15.2576,10.034 14.9296,9.958 14.5926,9.958 C14.3956,9.958 14.2376,10.011 14.1216,10.115 C14.0056,10.22 13.9476,10.362 13.9476,10.543 C13.9476,10.688 13.9866,10.81 14.0656,10.909 C14.1436,11.008 14.2766,11.103 14.4616,11.196 L14.9936,11.458 C15.2676,11.592 15.4656,11.752 15.5906,11.937 C15.7166,12.124 15.7776,12.353 15.7776,12.627 C15.7776,13.027 15.6536,13.351 15.4036,13.595 C15.1536,13.839 14.8186,13.961 14.4016,13.961 C13.9526,13.961 13.5466,13.853 13.1806,13.638 L13.1806,13.045 C13.6336,13.226 14.0266,13.315 14.3576,13.315 C14.5716,13.315 14.7386,13.259 14.8596,13.145 L14.8596,13.145 Z M11.4806,12.893 C11.3346,13.163 11.1106,13.298 10.8086,13.298 C10.5066,13.298 10.2816,13.163 10.1376,12.893 C9.9916,12.622 9.9186,12.202 9.9186,11.633 C9.9186,11.062 9.9916,10.645 10.1376,10.377 C10.2816,10.109 10.5066,9.976 10.8086,9.976 C11.1106,9.976 11.3346,10.109 11.4806,10.377 C11.6246,10.645 11.6976,11.062 11.6976,11.633 C11.6976,12.202 11.6246,12.622 11.4806,12.893 L11.4806,12.893 Z M10.8086,9.313 C10.2566,9.313 9.8336,9.514 9.5396,9.915 C9.2466,10.316 9.0996,10.889 9.0996,11.633 C9.0996,12.382 9.2466,12.958 9.5396,13.358 C9.8336,13.76 10.2566,13.961 10.8086,13.961 C11.3606,13.961 11.7836,13.76 12.0766,13.358 C12.3706,12.958 12.5176,12.382 12.5176,11.633 C12.5176,10.889 12.3706,10.316 12.0766,9.915 C11.7836,9.514 11.3606,9.313 10.8086,9.313 L10.8086,9.313 Z M7.3516,10.517 C7.1966,10.726 6.9836,10.83 6.7106,10.83 L5.8476,10.83 L5.8476,8.476 L6.7106,8.476 C6.9836,8.476 7.1966,8.579 7.3516,8.785 C7.5056,8.992 7.5826,9.281 7.5826,9.653 C7.5826,10.02 7.5056,10.307 7.3516,10.517 L7.3516,10.517 Z M7.6566,8.04 C7.4086,7.884 7.1226,7.805 6.7976,7.805 L5.0276,7.805 L5.0276,13.848 L5.8476,13.848 L5.8476,11.502 L6.7976,11.502 C7.2796,11.502 7.6706,11.333 7.9706,10.996 C8.2696,10.659 8.4196,10.211 8.4196,9.653 C8.4196,9.293 8.3546,8.974 8.2236,8.694 C8.0926,8.415 7.9036,8.197 7.6566,8.04 L7.6566,8.04 Z" id="Amazon-DATABASEAmazon-Aurora-PostgreSQL-instance_Resource-Icon_light-bg" fill="#C925D1"></path>
    </g>
</svg>`, rZ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Database/Res_Amazon-Aurora-MariaDB-Instance-Alternate_48</title>
    <g id="Icon-Resource/Database/Res_Amazon-Aurora-MariaDB-Instance-Alternate_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M40.187,14.362 C40.037,14.551 39.824,14.646 39.547,14.646 L38.673,14.646 L38.673,12.396 L39.46,12.396 C39.766,12.396 40.001,12.495 40.165,12.692 C40.329,12.888 40.411,13.169 40.411,13.532 C40.411,13.896 40.335,14.173 40.187,14.362 L40.187,14.362 Z M38.673,9.262 L39.383,9.262 C39.61,9.262 39.787,9.355 39.915,9.542 C40.041,9.726 40.105,9.987 40.105,10.322 C40.105,10.649 40.032,10.905 39.887,11.087 C39.74,11.268 39.541,11.359 39.287,11.359 L38.673,11.359 L38.673,9.262 Z M40.684,11.763 C40.974,11.626 41.197,11.422 41.349,11.152 C41.502,10.883 41.58,10.558 41.58,10.18 C41.58,9.583 41.385,9.098 41,8.727 C40.614,8.356 40.119,8.171 39.515,8.171 L37.233,8.171 L37.233,15.738 L39.581,15.738 C40.286,15.738 40.851,15.546 41.273,15.159 C41.696,14.773 41.907,14.257 41.907,13.609 C41.907,13.143 41.803,12.754 41.595,12.44 C41.388,12.127 41.083,11.902 40.684,11.763 L40.684,11.763 Z M34.373,12.058 C34.373,12.91 34.254,13.542 34.023,13.953 C33.789,14.364 33.436,14.569 32.963,14.569 L32.319,14.569 L32.319,9.339 L32.953,9.339 C33.44,9.339 33.799,9.542 34.028,9.945 C34.257,10.349 34.373,10.98 34.373,11.84 L34.373,12.058 Z M33.072,8.171 L30.791,8.171 L30.791,15.738 L33.126,15.738 C34.044,15.738 34.743,15.418 35.224,14.777 C35.704,14.137 35.944,13.193 35.944,11.949 C35.944,10.712 35.7,9.772 35.212,9.132 C34.725,8.491 34.011,8.171 33.072,8.171 L33.072,8.171 Z M28.049,14.482 C27.808,14.716 27.569,14.832 27.329,14.832 C27.175,14.832 27.053,14.768 26.962,14.64 C26.872,14.513 26.826,14.34 26.826,14.122 C26.826,13.867 26.882,13.673 26.996,13.538 C27.108,13.403 27.27,13.336 27.481,13.336 C27.7,13.336 27.889,13.361 28.049,13.412 L28.049,14.482 Z M27.624,10.016 C27.266,10.016 26.917,10.056 26.575,10.135 C26.233,10.216 25.956,10.325 25.745,10.464 L25.745,11.458 C26.378,11.224 26.914,11.108 27.35,11.108 C27.62,11.108 27.803,11.175 27.902,11.309 C27.999,11.444 28.049,11.701 28.049,12.08 L28.049,12.583 C27.714,12.495 27.434,12.451 27.208,12.451 C26.662,12.451 26.229,12.61 25.909,12.926 C25.588,13.243 25.428,13.675 25.428,14.22 C25.428,14.737 25.56,15.142 25.822,15.438 C26.083,15.732 26.44,15.88 26.891,15.88 C27.132,15.88 27.369,15.82 27.601,15.7 C27.834,15.58 28.012,15.425 28.136,15.236 L28.267,15.738 L29.425,15.738 L29.425,11.829 C29.425,11.195 29.283,10.735 28.999,10.447 C28.715,10.16 28.256,10.016 27.624,10.016 L27.624,10.016 Z M22.819,15.738 L24.314,15.738 L24.314,10.158 L22.819,10.158 L22.819,15.738 Z M24.205,7.815 C24.366,7.965 24.446,8.167 24.446,8.422 C24.446,8.677 24.366,8.879 24.205,9.028 C24.045,9.176 23.834,9.252 23.572,9.252 C23.302,9.252 23.087,9.176 22.928,9.028 C22.768,8.879 22.688,8.677 22.688,8.422 C22.688,8.167 22.768,7.965 22.928,7.815 C23.087,7.667 23.302,7.591 23.572,7.591 C23.834,7.591 24.045,7.667 24.205,7.815 L24.205,7.815 Z M21.76,10.103 C21.876,10.103 21.992,10.115 22.109,10.135 L22.109,11.458 C21.905,11.422 21.712,11.403 21.53,11.403 C21.181,11.403 20.849,11.491 20.537,11.665 L20.537,15.738 L19.041,15.738 L19.041,10.158 L20.264,10.158 L20.427,10.879 C20.646,10.609 20.863,10.413 21.078,10.29 C21.291,10.166 21.519,10.103 21.76,10.103 L21.76,10.103 Z M16.398,14.482 C16.159,14.716 15.918,14.832 15.677,14.832 C15.525,14.832 15.403,14.768 15.312,14.64 C15.22,14.513 15.176,14.34 15.176,14.122 C15.176,13.867 15.232,13.673 15.345,13.538 C15.458,13.403 15.62,13.336 15.831,13.336 C16.049,13.336 16.238,13.361 16.398,13.412 L16.398,14.482 Z M15.972,10.016 C15.616,10.016 15.266,10.056 14.924,10.135 C14.583,10.216 14.305,10.325 14.094,10.464 L14.094,11.458 C14.727,11.224 15.263,11.108 15.7,11.108 C15.969,11.108 16.153,11.175 16.25,11.309 C16.35,11.444 16.398,11.701 16.398,12.08 L16.398,12.583 C16.063,12.495 15.784,12.451 15.558,12.451 C15.012,12.451 14.579,12.61 14.258,12.926 C13.937,13.243 13.778,13.675 13.778,14.22 C13.778,14.737 13.908,15.142 14.17,15.438 C14.433,15.732 14.79,15.88 15.241,15.88 C15.481,15.88 15.717,15.82 15.951,15.7 C16.183,15.58 16.362,15.425 16.486,15.236 L16.617,15.738 L17.774,15.738 L17.774,11.829 C17.774,11.195 17.632,10.735 17.348,10.447 C17.065,10.16 16.606,10.016 15.972,10.016 L15.972,10.016 Z M10.895,8.171 L12.598,8.171 L12.598,15.738 L11.233,15.738 L11.233,10.431 L9.956,13.871 L8.657,13.871 L7.389,10.464 L7.389,15.738 L6.025,15.738 L6.025,8.171 L7.772,8.171 L9.333,12.408 L10.895,8.171 Z M43.932,39.484 C43.932,41.937 41.937,43.932 39.484,43.932 L8.448,43.932 C5.996,43.932 4,41.937 4,39.484 L4,8.448 C4,5.995 5.996,4 8.448,4 L39.484,4 C41.937,4 43.932,5.995 43.932,8.448 L43.932,39.484 Z M39.484,2 L8.448,2 C4.893,2 2,4.892 2,8.448 L2,39.484 C2,43.04 4.893,45.932 8.448,45.932 L39.484,45.932 C43.04,45.932 45.932,43.04 45.932,39.484 L45.932,8.448 C45.932,4.892 43.04,2 39.484,2 L39.484,2 Z" id="Amazon-DATABASEAmazon-Aurora-MariaDB-instance-alternate_Resource-Icon_light-bg" fill="#C925D1"></path>
    </g>
</svg>`, oZ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Database/Res_Amazon-ElastiCache_Cache-Node_48</title>
    <g id="Icon-Resource/Database/Res_Amazon-ElastiCache_Cache-Node_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M33.8887,7.289 L37.8607,7.289 L37.8607,8.172 L34.9867,8.172 L34.9867,10.639 L37.3627,10.639 L37.3627,11.521 L34.9867,11.521 L34.9867,14.248 L37.8607,14.248 L37.8607,15.131 L33.8887,15.131 L33.8887,7.289 Z M31.0937,7.289 L32.1917,7.289 L32.1917,15.131 L31.0937,15.131 L31.0937,11.566 L28.2427,11.566 L28.2427,15.131 L27.1447,15.131 L27.1447,7.289 L28.2427,7.289 L28.2427,10.673 L31.0937,10.673 L31.0937,7.289 Z M24.4507,14.282 C24.7907,14.282 25.2817,14.188 25.9227,13.999 L25.9227,14.893 C25.4317,15.127 24.9007,15.244 24.3267,15.244 C22.3057,15.244 21.2947,13.909 21.2947,11.238 C21.2947,9.919 21.5547,8.915 22.0757,8.228 C22.5957,7.542 23.3617,7.199 24.3717,7.199 C24.8547,7.199 25.3417,7.301 25.8317,7.505 L25.8317,8.398 C25.3257,8.24 24.8817,8.161 24.4967,8.161 C23.7867,8.161 23.2687,8.393 22.9407,8.856 C22.6127,9.32 22.4487,10.065 22.4487,11.092 L22.4487,11.363 C22.4487,12.389 22.6077,13.132 22.9237,13.592 C23.2417,14.052 23.7497,14.282 24.4507,14.282 L24.4507,14.282 Z M16.9497,12.178 L17.9227,8.342 L18.8957,12.178 L16.9497,12.178 Z M17.3577,7.289 L15.0937,15.131 L16.2137,15.131 L16.7457,13.015 L19.1117,13.015 L19.6547,15.131 L20.8087,15.131 L18.5447,7.289 L17.3577,7.289 Z M13.1477,14.282 C13.4877,14.282 13.9777,14.188 14.6187,13.999 L14.6187,14.893 C14.1277,15.127 13.5967,15.244 13.0237,15.244 C11.0017,15.244 9.9917,13.909 9.9917,11.238 C9.9917,9.919 10.2507,8.915 10.7717,8.228 C11.2917,7.542 12.0577,7.199 13.0687,7.199 C13.5507,7.199 14.0377,7.301 14.5287,7.505 L14.5287,8.398 C14.0227,8.24 13.5777,8.161 13.1937,8.161 C12.4837,8.161 11.9647,8.393 11.6367,8.856 C11.3087,9.32 11.1447,10.065 11.1447,11.092 L11.1447,11.363 C11.1447,12.389 11.3037,13.132 11.6197,13.592 C11.9377,14.052 12.4467,14.282 13.1477,14.282 L13.1477,14.282 Z M43.7787,39.331 C43.7787,41.783 41.7837,43.778 39.3307,43.778 L8.4487,43.778 C5.9947,43.778 3.9997,41.783 3.9997,39.331 L3.9997,8.448 C3.9997,5.995 5.9947,4 8.4487,4 L39.3307,4 C41.7837,4 43.7787,5.995 43.7787,8.448 L43.7787,39.331 Z M39.3307,2 L8.4487,2 C4.8927,2 1.9997,4.893 1.9997,8.448 L1.9997,39.331 C1.9997,42.886 4.8927,45.778 8.4487,45.778 L39.3307,45.778 C42.8857,45.778 45.7787,42.886 45.7787,39.331 L45.7787,8.448 C45.7787,4.893 42.8857,2 39.3307,2 L39.3307,2 Z" id="Amazon-DATABASE_Amazon-ElastiCache_Cache-Node_Resource-Icon_light-bg" fill="#C925D1"></path>
    </g>
</svg>`, lZ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Database/Res_Amazon-RDS_Multi-AZ-DB-Cluster_48</title>
    <g id="Icon-Resource/Database/Res_Amazon-RDS_Multi-AZ-DB-Cluster_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M38.189,13.07 C34.105,13.07 32,11.871 32,11.36 L32,8.272 C33.601,9.07 35.943,9.45 38.189,9.45 C40.617,9.45 42.625,9.043 44,8.342 L44,11.36 C44,11.973 42.058,13.07 38.189,13.07 L38.189,13.07 Z M38.189,18.329 C34.105,18.329 32,17.174 32,16.68 L32,13.925 C33.578,14.704 35.889,15.07 38.189,15.07 C40.639,15.07 42.636,14.679 44,13.993 L44,16.68 C44,17.256 42.003,18.329 38.189,18.329 L38.189,18.329 Z M38.189,29.514 C42.003,29.514 44,30.637 44,31.239 C44,31.841 42.003,32.964 38.189,32.964 C34.105,32.964 32,31.755 32,31.239 C32,30.723 34.105,29.514 38.189,29.514 L38.189,29.514 Z M38.189,38.584 C34.105,38.584 32,37.385 32,36.873 L32,33.786 C33.601,34.584 35.943,34.964 38.189,34.964 C40.617,34.964 42.625,34.557 44,33.856 L44,36.873 C44,37.487 42.058,38.584 38.189,38.584 L38.189,38.584 Z M38.189,43.843 C34.105,43.843 32,42.688 32,42.195 L32,39.439 C33.578,40.218 35.889,40.584 38.189,40.584 C40.639,40.584 42.636,40.193 44,39.507 L44,42.195 C44,42.77 42.003,43.843 38.189,43.843 L38.189,43.843 Z M12.243,30.21 C7.21,30.21 4,28.763 4,27.767 L4,23.614 C5.993,24.75 9.188,25.286 12.243,25.286 C15.582,25.286 18.29,24.697 20,23.695 L20,27.767 C20,28.791 17.304,30.21 12.243,30.21 L12.243,30.21 Z M12.243,36.932 C6.831,36.932 4,35.366 4,34.527 L4,30.545 C5.993,31.676 9.188,32.21 12.243,32.21 C15.582,32.21 18.29,31.623 20,30.625 L20,34.527 C20,35.535 17.304,36.932 12.243,36.932 L12.243,36.932 Z M4,16.196 C5.993,17.332 9.188,17.868 12.243,17.868 C15.582,17.868 18.29,17.279 20,16.277 L20,20.824 C20,21.857 17.304,23.286 12.243,23.286 C7.21,23.286 4,21.828 4,20.824 L4,16.196 Z M12.243,10.945 C17.237,10.945 20,12.4 20,13.406 C20,14.413 17.237,15.868 12.243,15.868 C6.831,15.868 4,14.266 4,13.406 C4,12.547 6.831,10.945 12.243,10.945 L12.243,10.945 Z M38.189,4 C42.003,4 44,5.123 44,5.725 C44,6.327 42.003,7.45 38.189,7.45 C34.105,7.45 32,6.241 32,5.725 C32,5.209 34.105,4 38.189,4 L38.189,4 Z M46,5.725 C46,3.497 42.861,2 38.189,2 C34.245,2 30,3.166 30,5.725 C30,5.793 30.014,5.856 30.02,5.922 L30,5.922 L30,16.508 L22,22.108 L22,13.922 L21.947,13.922 C21.98,13.754 22,13.582 22,13.406 C22,10.737 18.079,8.945 12.243,8.945 C7.578,8.945 2.585,10.195 2.053,12.922 L2,12.922 L2,34.527 C2,37.554 7.309,38.932 12.243,38.932 C18.169,38.932 22,37.203 22,34.527 L22,25.95 L30,31.55 L30,42.195 C30,44.715 34.113,45.843 38.189,45.843 C42.934,45.843 46,44.411 46,42.195 L46,30.922 L45.971,30.922 C45.685,28.871 42.634,27.514 38.189,27.514 C35.214,27.514 32.071,28.178 30.704,29.601 L22.743,24.029 L30.795,18.393 C32.183,19.717 35.193,20.329 38.189,20.329 C42.934,20.329 46,18.897 46,16.68 L46,5.922 L45.982,5.922 C45.988,5.856 46,5.792 46,5.725 L46,5.725 Z" id="Fill-1" fill="#C925D1"></path>
    </g>
</svg>`, LZ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Migration-and-Transfer/Res_AWS-Transfer-Family_AWS-FTPS_48</title>
    <g id="Icon-Resource/Migration-and-Transfer/Res_AWS-Transfer-Family_AWS-FTPS_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M45.502,10.8818 L36.913,2.2928 C36.523,1.9028 35.89,1.9028 35.499,2.2928 L26.91,10.8818 C26.624,11.1678 26.538,11.5978 26.693,11.9718 C26.848,12.3458 27.213,12.5888 27.617,12.5888 L31.985,12.5888 L31.985,16.9558 L31.985,21.2508 L31.985,24.4708 C31.985,25.0238 32.433,25.4708 32.985,25.4708 L35.939,25.4708 L29.765,31.6458 L23.591,25.4708 L26.544,25.4708 C27.097,25.4708 27.544,25.0238 27.544,24.4708 L27.544,16.9558 L25.544,16.9558 L25.544,23.4708 L21.177,23.4708 C20.773,23.4708 20.407,23.7138 20.253,24.0878 C20.098,24.4618 20.184,24.8918 20.47,25.1778 L29.058,33.7668 C29.245,33.9538 29.499,34.0598 29.765,34.0598 C30.03,34.0598 30.284,33.9538 30.472,33.7668 L39.061,25.1778 C39.347,24.8918 39.433,24.4618 39.277,24.0878 C39.123,23.7138 38.758,23.4708 38.354,23.4708 L33.985,23.4708 L33.985,21.2508 L33.985,16.9558 L33.985,11.5888 C33.985,11.0358 33.538,10.5888 32.985,10.5888 L30.031,10.5888 L36.206,4.4138 L42.381,10.5888 L39.427,10.5888 C38.874,10.5888 38.427,11.0358 38.427,11.5888 L38.427,19.1768 L36.206,19.1768 L36.206,21.1768 L41.648,21.1768 L41.648,43.8678 L39.696,43.8678 L39.696,45.8678 L42.648,45.8678 C43.2,45.8678 43.648,45.4208 43.648,44.8678 L43.648,20.1768 C43.648,19.6238 43.2,19.1768 42.648,19.1768 L40.427,19.1768 L40.427,12.5888 L44.795,12.5888 C45.199,12.5888 45.564,12.3458 45.719,11.9718 C45.874,11.5978 45.788,11.1678 45.502,10.8818 L45.502,10.8818 Z M9.294,42.7218 L9.294,21.1768 L23.323,21.1768 L23.323,19.1768 L8.294,19.1768 C7.741,19.1768 7.294,19.6238 7.294,20.1768 L7.294,42.7218 C7.294,43.3538 6.779,43.8678 6.147,43.8678 C5.515,43.8678 5,43.3538 5,42.7218 L5,13.6618 L15.399,13.6618 L17.585,16.4938 C17.774,16.7388 18.067,16.8828 18.377,16.8828 L23.323,16.8828 L23.323,14.8828 L18.868,14.8828 L16.683,12.0508 C16.493,11.8058 16.2,11.6618 15.891,11.6618 L4,11.6618 C3.447,11.6618 3,12.1098 3,12.6618 L3,42.7218 C3,44.4568 4.411,45.8678 6.147,45.8678 L11.515,45.8678 L11.515,43.8678 L9.07,43.8678 C9.211,43.5118 9.294,43.1268 9.294,42.7218 L9.294,42.7218 Z M37.588,41.5228 C37.326,41.2818 36.971,41.0418 36.525,40.8018 L35.83,40.4278 C35.451,40.2218 35.195,40.0328 35.063,39.8608 C34.93,39.6898 34.863,39.4708 34.863,39.2038 C34.863,38.8868 34.967,38.6368 35.172,38.4568 C35.379,38.2768 35.662,38.1868 36.023,38.1868 C36.555,38.1868 37.17,38.3158 37.865,38.5718 L37.865,37.2068 C37.195,36.8988 36.522,36.7428 35.842,36.7428 C35.301,36.7428 34.822,36.8488 34.406,37.0588 C33.99,37.2698 33.66,37.5698 33.42,37.9608 C33.18,38.3518 33.061,38.8088 33.061,39.3328 C33.061,39.8998 33.197,40.3808 33.473,40.7758 C33.746,41.1708 34.201,41.5398 34.838,41.8838 L35.533,42.2568 C35.885,42.4458 36.137,42.6328 36.287,42.8178 C36.438,43.0018 36.512,43.2278 36.512,43.4938 C36.512,43.8548 36.404,44.1318 36.189,44.3248 C35.975,44.5178 35.662,44.6138 35.25,44.6138 C34.967,44.6138 34.625,44.5738 34.227,44.4918 C33.826,44.4108 33.467,44.3098 33.15,44.1898 L33.15,45.5418 C33.424,45.6968 33.764,45.8208 34.168,45.9158 C34.57,46.0098 34.975,46.0578 35.379,46.0578 C36.307,46.0578 37.033,45.8198 37.563,45.3428 C38.09,44.8658 38.356,44.2198 38.356,43.4028 C38.356,42.9838 38.293,42.6238 38.168,42.3278 C38.043,42.0308 37.85,41.7638 37.588,41.5228 L37.588,41.5228 Z M30.227,39.7448 C30.227,39.2638 30.139,38.8998 29.963,38.6508 C29.785,38.4018 29.531,38.2768 29.195,38.2768 L28.357,38.2768 L28.357,41.2138 L29.195,41.2138 C29.531,41.2138 29.785,41.0888 29.963,40.8398 C30.139,40.5908 30.227,40.2268 30.227,39.7448 L30.227,39.7448 Z M31.303,37.6908 C31.77,38.1928 32.004,38.8778 32.004,39.7448 C32.004,40.6118 31.77,41.2978 31.303,41.7998 C30.834,42.3018 30.205,42.5538 29.414,42.5538 L28.357,42.5538 L28.357,45.8638 L26.594,45.8638 L26.594,36.9368 L29.414,36.9368 C30.205,36.9368 30.834,37.1878 31.303,37.6908 L31.303,37.6908 Z M19.494,38.3658 L21.633,38.3658 L21.633,45.8638 L23.438,45.8638 L23.438,38.3658 L25.576,38.3658 L25.576,36.9368 L19.494,36.9368 L19.494,38.3658 Z M14.098,36.9368 L18.748,36.9368 L18.748,38.3158 L15.9,38.3158 L15.9,40.7238 L18.129,40.7238 L18.129,42.1028 L15.9,42.1028 L15.9,45.8638 L14.098,45.8638 L14.098,36.9368 Z" id="AWS-Transfer-Family-AWS-FTPS_Resource-Icon_light-bg" fill="#01A88D"></path>
    </g>
</svg>`, aZ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Migration-and-Transfer/Res_AWS-Transfer-Family_AWS-SFTP_48</title>
    <g id="Icon-Resource/Migration-and-Transfer/Res_AWS-Transfer-Family_AWS-SFTP_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M36.5742,39.5566 C36.5742,39.0756 36.4862,38.7086 36.3082,38.4586 C36.1332,38.2086 35.8772,38.0846 35.5412,38.0846 L34.7012,38.0846 L34.7012,41.0296 L35.5412,41.0296 C35.8772,41.0296 36.1332,40.9046 36.3082,40.6556 C36.4862,40.4056 36.5742,40.0386 36.5742,39.5566 L36.5742,39.5566 Z M37.6522,37.4966 C38.1212,38.0006 38.3572,38.6876 38.3572,39.5566 C38.3572,40.4266 38.1212,41.1136 37.6522,41.6176 C37.1832,42.1206 36.5532,42.3726 35.7602,42.3726 L34.7012,42.3726 L34.7012,45.6926 L32.9312,45.6926 L32.9312,36.7416 L35.7602,36.7416 C36.5532,36.7416 37.1832,36.9936 37.6522,37.4966 L37.6522,37.4966 Z M25.8142,38.1746 L27.9592,38.1746 L27.9592,45.6926 L29.7672,45.6926 L29.7672,38.1746 L31.9102,38.1746 L31.9102,36.7416 L25.8142,36.7416 L25.8142,38.1746 Z M20.4022,45.6926 L22.2112,45.6926 L22.2112,41.9206 L24.4452,41.9206 L24.4452,40.5386 L22.2112,40.5386 L22.2112,38.1226 L25.0642,38.1226 L25.0642,36.7416 L20.4022,36.7416 L20.4022,45.6926 Z M18.3032,41.3396 C18.0412,41.0986 17.6852,40.8576 17.2382,40.6166 L16.5412,40.2416 C16.1622,40.0356 15.9042,39.8456 15.7712,39.6726 C15.6382,39.5006 15.5722,39.2816 15.5722,39.0146 C15.5722,38.6966 15.6762,38.4466 15.8812,38.2656 C16.0882,38.0846 16.3732,37.9946 16.7342,37.9946 C17.2672,37.9946 17.8832,38.1226 18.5822,38.3816 L18.5822,37.0126 C17.9102,36.7026 17.2322,36.5476 16.5532,36.5476 C16.0102,36.5476 15.5312,36.6536 15.1132,36.8646 C14.6952,37.0756 14.3652,37.3756 14.1252,37.7676 C13.8832,38.1606 13.7632,38.6186 13.7632,39.1436 C13.7632,39.7116 13.9002,40.1946 14.1762,40.5896 C14.4512,40.9866 14.9082,41.3566 15.5452,41.7016 L16.2442,42.0766 C16.5952,42.2656 16.8472,42.4526 16.9982,42.6376 C17.1482,42.8236 17.2242,43.0486 17.2242,43.3156 C17.2242,43.6776 17.1172,43.9546 16.9022,44.1486 C16.6872,44.3426 16.3732,44.4396 15.9592,44.4396 C15.6762,44.4396 15.3322,44.3986 14.9312,44.3166 C14.5312,44.2356 14.1722,44.1336 13.8532,44.0136 L13.8532,45.3686 C14.1292,45.5246 14.4692,45.6496 14.8752,45.7436 C15.2792,45.8386 15.6832,45.8856 16.0882,45.8856 C17.0172,45.8856 17.7482,45.6476 18.2772,45.1686 C18.8062,44.6916 19.0722,44.0436 19.0722,43.2256 C19.0722,42.8036 19.0102,42.4446 18.8852,42.1466 C18.7602,41.8496 18.5662,41.5806 18.3032,41.3396 L18.3032,41.3396 Z M45.6092,10.9036 L36.9982,2.2926 C36.6072,1.9026 35.9742,1.9026 35.5842,2.2926 L26.9732,10.9036 C26.6872,11.1896 26.6012,11.6196 26.7572,11.9936 C26.9112,12.3676 27.2762,12.6106 27.6802,12.6106 L32.0622,12.6106 L32.0622,16.9926 L32.0622,21.2976 L32.0622,24.5276 C32.0622,25.0796 32.5102,25.5276 33.0622,25.5276 L36.0302,25.5276 L29.8332,31.7246 L23.6362,25.5276 L26.6032,25.5276 C27.1562,25.5276 27.6032,25.0796 27.6032,24.5276 L27.6032,16.9926 L25.6032,16.9926 L25.6032,23.5276 L21.2212,23.5276 C20.8172,23.5276 20.4522,23.7706 20.2982,24.1446 C20.1422,24.5186 20.2282,24.9486 20.5142,25.2346 L29.1262,33.8456 C29.3212,34.0406 29.5772,34.1386 29.8332,34.1386 C30.0892,34.1386 30.3452,34.0406 30.5402,33.8456 L39.1512,25.2346 C39.4372,24.9486 39.5232,24.5186 39.3682,24.1446 C39.2142,23.7706 38.8482,23.5276 38.4442,23.5276 L34.0622,23.5276 L34.0622,21.2976 L34.0622,16.9926 L34.0622,11.6106 C34.0622,11.0576 33.6152,10.6106 33.0622,10.6106 L30.0952,10.6106 L36.2912,4.4136 L42.4882,10.6106 L39.5202,10.6106 C38.9682,10.6106 38.5202,11.0576 38.5202,11.6106 L38.5202,19.2216 L36.2912,19.2216 L36.2912,21.2216 L41.7502,21.2216 L41.7502,43.9786 L39.4562,43.9786 L39.4562,45.9786 L42.7502,45.9786 C43.3032,45.9786 43.7502,45.5316 43.7502,44.9786 L43.7502,20.2216 C43.7502,19.6686 43.3032,19.2216 42.7502,19.2216 L40.5202,19.2216 L40.5202,12.6106 L44.9022,12.6106 C45.3062,12.6106 45.6722,12.3666 45.8262,11.9936 C45.9812,11.6196 45.8952,11.1896 45.6092,10.9036 L45.6092,10.9036 Z M9.0802,43.9786 L11.5342,43.9786 L11.5342,45.9786 L6.1522,45.9786 C4.4142,45.9786 3.0002,44.5646 3.0002,42.8266 L3.0002,12.6876 C3.0002,12.1346 3.4472,11.6876 4.0002,11.6876 L15.9222,11.6876 C16.2312,11.6876 16.5242,11.8306 16.7132,12.0766 L18.9062,14.9156 L23.3752,14.9156 L23.3752,16.9156 L18.4152,16.9156 C18.1052,16.9156 17.8122,16.7726 17.6242,16.5276 L15.4302,13.6876 L5.0002,13.6876 L5.0002,42.8266 C5.0002,43.4616 5.5162,43.9786 6.1522,43.9786 C6.7882,43.9786 7.3052,43.4616 7.3052,42.8266 L7.3052,20.2216 C7.3052,19.6686 7.7532,19.2216 8.3052,19.2216 L23.3752,19.2216 L23.3752,21.2216 L9.3052,21.2216 L9.3052,42.8266 C9.3052,43.2336 9.2212,43.6206 9.0802,43.9786 L9.0802,43.9786 Z" id="AWS-Transfer-Family-AWS-SFTP_Resource-Icon_light-bg" fill="#01A88D"></path>
    </g>
</svg>`, CZ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Migration-and-Transfer/Res_AWS-Mainframe-Modernization_Runtime_48</title>
    <g id="Icon-Resource/Migration-and-Transfer/Res_AWS-Mainframe-Modernization_Runtime_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M28.743,12 L22.343,17 L28.743,22 L39.673,22 L46.072,17 L39.673,12 L28.743,12 Z M25.591,17 L29.432,14 L38.984,14 L42.824,17 L38.984,20 L29.432,20 L25.591,17 Z M8.001,14 L22,14 L22,12 L8.001,12 L8.001,14 Z M3,18 L19,18 L19,16 L3,16 L3,18 Z M12,22 L23,22 L23,20 L12,20 L12,22 Z M22.743,27 L16.343,32 L22.743,37 L33.673,37 L40.073,32 L33.673,27 L22.743,27 Z M19.591,32 L23.432,29 L32.984,29 L36.825,32 L32.984,35 L23.432,35 L19.591,32 Z M9.001,29 L17.001,29 L17.001,27 L9.001,27 L9.001,29 Z M2,33.001 L13,33.001 L13,31 L2,31 L2,33.001 Z M5,37 L17.001,37 L17.001,35 L5,35 L5,37 Z" id="Fill-1" fill="#01A88D"></path>
    </g>
</svg>`, cZ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Migration-and-Transfer/Res_AWS-Transfer-Family_AWS-FTP_48</title>
    <g id="Icon-Resource/Migration-and-Transfer/Res_AWS-Transfer-Family_AWS-FTP_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M30.2783,39.832 C30.2783,39.35 30.1903,38.984 30.0133,38.734 C29.8373,38.485 29.5813,38.36 29.2463,38.36 L28.4073,38.36 L28.4073,41.304 L29.2463,41.304 C29.5813,41.304 29.8373,41.179 30.0133,40.929 C30.1903,40.68 30.2783,40.313 30.2783,39.832 L30.2783,39.832 Z M31.3563,37.773 C31.8253,38.276 32.0593,38.963 32.0593,39.832 C32.0593,40.701 31.8253,41.387 31.3563,41.891 C30.8863,42.394 30.2573,42.645 29.4653,42.645 L28.4073,42.645 L28.4073,45.963 L26.6383,45.963 L26.6383,37.018 L29.4653,37.018 C30.2573,37.018 30.8863,37.269 31.3563,37.773 L31.3563,37.773 Z M19.5253,38.45 L21.6683,38.45 L21.6683,45.963 L23.4753,45.963 L23.4753,38.45 L25.6183,38.45 L25.6183,37.018 L19.5253,37.018 L19.5253,38.45 Z M14.1183,45.963 L15.9243,45.963 L15.9243,42.194 L18.1583,42.194 L18.1583,40.812 L15.9243,40.812 L15.9243,38.399 L18.7773,38.399 L18.7773,37.018 L14.1183,37.018 L14.1183,45.963 Z M45.5823,10.898 L36.9763,2.293 C36.5863,1.902 35.9533,1.902 35.5623,2.293 L26.9573,10.898 C26.6713,11.185 26.5853,11.614 26.7403,11.988 C26.8943,12.362 27.2593,12.605 27.6643,12.605 L32.0433,12.605 L32.0433,16.983 L32.0433,21.286 L32.0433,24.513 C32.0433,25.065 32.4903,25.513 33.0433,25.513 L36.0073,25.513 L29.8153,31.704 L23.6253,25.513 L26.5893,25.513 C27.1413,25.513 27.5893,25.065 27.5893,24.513 L27.5893,16.983 L25.5893,16.983 L25.5893,23.513 L21.2113,23.513 C20.8063,23.513 20.4413,23.756 20.2873,24.13 C20.1323,24.504 20.2173,24.934 20.5043,25.22 L29.1083,33.825 C29.2963,34.013 29.5493,34.118 29.8153,34.118 C30.0813,34.118 30.3353,34.013 30.5223,33.825 L39.1283,25.22 C39.4143,24.934 39.5003,24.504 39.3443,24.13 C39.1903,23.756 38.8253,23.513 38.4213,23.513 L34.0433,23.513 L34.0433,21.286 L34.0433,16.983 L34.0433,11.605 C34.0433,11.053 33.5953,10.605 33.0433,10.605 L30.0783,10.605 L36.2693,4.414 L42.4613,10.605 L39.4963,10.605 C38.9433,10.605 38.4963,11.053 38.4963,11.605 L38.4963,19.21 L36.2693,19.21 L36.2693,21.21 L41.7233,21.21 L41.7233,43.95 L33.3473,43.95 L33.3473,45.95 L42.7233,45.95 C43.2763,45.95 43.7233,45.503 43.7233,44.95 L43.7233,20.21 C43.7233,19.657 43.2763,19.21 42.7233,19.21 L40.4963,19.21 L40.4963,12.605 L44.8753,12.605 C45.2793,12.605 45.6443,12.362 45.7993,11.988 C45.9543,11.614 45.8683,11.185 45.5823,10.898 L45.5823,10.898 Z M9.0773,43.95 L11.5303,43.95 L11.5303,45.95 L6.1513,45.95 C4.4143,45.95 3.0003,44.536 3.0003,42.799 L3.0003,12.681 C3.0003,12.128 3.4473,11.681 4.0003,11.681 L15.9143,11.681 C16.2233,11.681 16.5163,11.824 16.7063,12.069 L18.8963,14.908 L23.3613,14.908 L23.3613,16.908 L18.4053,16.908 C18.0953,16.908 17.8023,16.765 17.6133,16.52 L15.4233,13.681 L5.0003,13.681 L5.0003,42.799 C5.0003,43.434 5.5163,43.95 6.1513,43.95 C6.7863,43.95 7.3023,43.434 7.3023,42.799 L7.3023,20.21 C7.3023,19.657 7.7503,19.21 8.3023,19.21 L23.3613,19.21 L23.3613,21.21 L9.3023,21.21 L9.3023,42.799 C9.3023,43.206 9.2183,43.593 9.0773,43.95 L9.0773,43.95 Z" id="AWS-Transfer-Family-AWS-FTP_Resource-Icon_light-bg" fill="#01A88D"></path>
    </g>
</svg>`, uZ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Migration-and-Transfer/Res_AWS-Migration-Hub_Refactor-Spaces-Environments_48</title>
    <g id="Icon-Resource/Migration-and-Transfer/Res_AWS-Migration-Hub_Refactor-Spaces-Environments_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M31.707,26.293 L35.707,30.293 L34.293,31.707 L31,28.414 L27.707,31.707 L26.293,30.293 L30.293,26.293 C30.684,25.902 31.316,25.902 31.707,26.293 L31.707,26.293 Z M31.707,31.293 L35.707,35.293 L34.293,36.707 L31,33.414 L27.707,36.707 L26.293,35.293 L30.293,31.293 C30.684,30.902 31.316,30.902 31.707,31.293 L31.707,31.293 Z M23,39 L39,39 L39,23 L23,23 L23,39 Z M21,22 L21,40 C21,40.552 21.447,41 22,41 L40,41 C40.553,41 41,40.552 41,40 L41,22 C41,21.448 40.553,21 40,21 L22,21 C21.447,21 21,21.448 21,22 L21,22 Z M7,26 L7,8 C7,7.448 7.447,7 8,7 L26,7 C26.553,7 27,7.448 27,8 L27,19 L25,19 L25,9 L9,9 L9,25 L19,25 L19,27 L8,27 C7.447,27 7,26.552 7,26 L7,26 Z M17,14.414 L13.707,17.707 L12.293,16.293 L16.293,12.293 C16.684,11.902 17.316,11.902 17.707,12.293 L21.707,16.293 L20.293,17.707 L17,14.414 Z M12.293,21.293 L16.293,17.293 C16.684,16.902 17.316,16.902 17.707,17.293 L20.326,19.912 L18.912,21.326 L17,19.414 L13.707,22.707 L12.293,21.293 Z M4,44 L44,44 L44,4 L4,4 L4,44 Z M45,2 L3,2 C2.447,2 2,2.448 2,3 L2,45 C2,45.552 2.447,46 3,46 L45,46 C45.553,46 46,45.552 46,45 L46,3 C46,2.448 45.553,2 45,2 L45,2 Z" id="Fill-1" fill="#01A88D"></path>
    </g>
</svg>`, hZ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Migration-and-Transfer/Res_AWS-Mainframe-Modernization_Developer_48</title>
    <g id="Icon-Resource/Migration-and-Transfer/Res_AWS-Mainframe-Modernization_Developer_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M13.03,8 L15.03,8 L15.03,6 L13.03,6 L13.03,8 Z M10.03,8 L12.03,8 L12.03,6 L10.03,6 L10.03,8 Z M7.03,8 L9.03,8 L9.03,6 L7.03,6 L7.03,8 Z M33.318,19.466 C33.709,19.856 33.709,20.489 33.318,20.88 L29.437,24.762 L28.022,23.348 L31.197,20.173 L28.022,16.998 L29.437,15.583 L33.318,19.466 Z M18.256,16.998 L15.081,20.173 L18.256,23.348 L16.842,24.762 L12.96,20.88 C12.569,20.489 12.569,19.856 12.96,19.466 L16.842,15.583 L18.256,16.998 Z M24.192,14.529 L26.05,15.272 L21.833,25.816 L19.976,25.073 L24.192,14.529 Z M33.671,43 L14.37,43 L5.561,36.119 L12.012,29.999 L35.988,29.996 L42.478,36.121 L33.671,43 Z M5.045,11 L42.03,11 L42.03,28 L5.03,28.004 L5.045,11 Z M42.03,5 L42.03,9 L5.03,9 L5.034,5 L42.03,5 Z M38.902,30 L42.27,30 C43.24,30 44.03,29.236 44.03,28.298 L44.03,4.701 C44.03,3.763 43.24,3 42.27,3 L4.791,3 C3.82,3 3.03,3.763 3.03,4.699 L3.01,28.296 C3.008,29.23 3.792,29.994 4.766,30 L9.105,30 L2.5,36.265 L13.681,45 L34.362,45 L45.542,36.266 L38.902,30 Z" id="Fill-1" fill="#01A88D"></path>
    </g>
</svg>`, dZ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Migration-and-Transfer/Res_AWS-Application-Discovery-Service_AWS-Discovery-Agent_48</title>
    <g id="Icon-Resource/Migration-and-Transfer/Res_AWS-Application-Discovery-Service_AWS-Discovery-Agent_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M23.2001347,15.4482 C23.6941347,15.3632 24.0341347,14.8832 24.0211347,14.3872 C24.0271347,13.1552 24.5121347,12.2902 25.3551347,12.0132 C26.0881347,11.7732 26.9011347,12.0422 27.3751347,12.6852 C27.5951347,12.9842 27.9581347,13.1392 28.3281347,13.0822 C28.6941347,13.0272 29.0001347,12.7752 29.1241347,12.4252 C29.5001347,11.3592 30.0391347,10.4682 30.7271347,9.7742 C31.5661347,8.9302 33.8641347,7.1152 37.1141347,8.4942 C38.9511347,9.2742 40.4451347,11.6172 40.4471347,13.6582 L40.3981347,14.4892 C40.3701347,14.9662 40.6841347,15.3972 41.1471347,15.5162 C42.2131347,15.7892 44.0001347,16.6332 44.0001347,19.2052 C44.0001347,21.1602 42.9461347,22.2352 42.0621347,22.7942 C41.8461347,22.9302 41.5551347,22.9962 41.1751347,22.9972 L33.0001347,22.9972 L33.0001347,24.9972 L41.1761347,24.9972 C41.9361347,24.9962 42.5951347,24.8232 43.1311347,24.4852 C44.2021347,23.8082 46.0001347,22.2222 46.0001347,19.2052 C46.0001347,16.6682 44.6841347,14.7132 42.4381347,13.8342 L42.4451347,13.7172 C42.4451347,10.7922 40.4891347,7.7552 37.8961347,6.6532 C34.8641347,5.3652 31.6531347,6.0042 29.3091347,8.3652 C28.7201347,8.9582 28.2181347,9.6532 27.8071347,10.4402 C26.8881347,9.9072 25.7741347,9.7712 24.7311347,10.1132 C23.2411347,10.6022 22.2791347,11.9002 22.0661347,13.6532 C20.9101347,13.9692 19.9531347,14.5112 19.2681347,15.2442 L20.7311347,16.6092 C21.4071347,15.8852 22.4471347,15.5782 23.2001347,15.4482 L23.2001347,15.4482 Z M6.26713475,18.7002 L7.68913475,17.2942 L5.41813475,14.9972 L18.0001347,14.9972 L18.0001347,12.9972 L5.39813475,12.9972 L7.69913475,10.7052 L6.28913475,9.2882 L2.29513475,13.2652 C1.90413475,13.6542 1.90113475,14.2852 2.28913475,14.6772 L6.26713475,18.7002 Z M41.7261347,29.2932 L40.3041347,30.7002 L42.5791347,32.9972 L30.0001347,32.9972 L30.0001347,34.9972 L42.5991347,34.9972 L40.2951347,37.2882 L41.7051347,38.7062 L45.7051347,34.7292 C46.0961347,34.3412 46.0981347,33.7092 45.7111347,33.3172 L41.7261347,29.2932 Z M34.1211347,36.5642 L35.8791347,37.5192 C34.1621347,40.6742 30.3911347,40.9832 30.2311347,40.9942 L7.75313475,40.9972 C6.84213475,40.9952 6.09113475,40.8012 5.45413475,40.4012 C4.16413475,39.5922 2.00013475,37.6942 2.00013475,34.0782 C2.00013475,30.9882 3.64013475,28.6192 6.43313475,27.6012 L6.41913475,27.3572 C6.41713475,23.7732 8.78413475,20.1152 11.9231347,18.7882 C15.5981347,17.2382 19.4831347,18.0082 22.3211347,20.8512 C23.0941347,21.6242 23.7441347,22.5412 24.2621347,23.5902 C25.3861347,22.8502 26.7971347,22.6372 28.1191347,23.0742 C29.9141347,23.6662 31.0581347,25.2612 31.2701347,27.4112 C32.5941347,27.7652 34.6171347,28.6172 35.7901347,30.6252 L34.0631347,31.6342 C33.0351347,29.8752 30.9691347,29.3492 30.1281347,29.2052 C29.5921347,29.1132 29.2281347,28.6112 29.3071347,28.0732 C29.3061347,26.5132 28.6451347,25.3542 27.4921347,24.9732 C26.4741347,24.6392 25.3541347,25.0052 24.7001347,25.8872 C24.4791347,26.1842 24.1131347,26.3392 23.7491347,26.2812 C23.3831347,26.2262 23.0771347,25.9742 22.9541347,25.6262 C22.4751347,24.2762 21.7871347,23.1452 20.9071347,22.2642 C19.8291347,21.1852 16.8721347,18.8682 12.7021347,20.6312 C10.2991347,21.6462 8.41713475,24.5742 8.41713475,27.2982 L8.47513475,28.2652 C8.50413475,28.7432 8.18913475,29.1752 7.72413475,29.2932 C6.33413475,29.6482 4.00013475,30.7422 4.00013475,34.0782 C4.00013475,36.5982 5.36913475,37.9872 6.51613475,38.7072 C6.82613475,38.9012 7.23113475,38.9962 7.75513475,38.9972 L30.1591347,38.9972 C30.1221347,38.9962 32.9361347,38.7422 34.1211347,36.5642 L34.1211347,36.5642 Z" id="Fill-1" fill="#01A88D"></path>
    </g>
</svg>`, gZ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Migration-and-Transfer/Res_AWS-Mainframe-Modernization_Compiler_48</title>
    <g id="Icon-Resource/Migration-and-Transfer/Res_AWS-Mainframe-Modernization_Compiler_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M29.471,23.2368 L32.646,20.0618 L29.471,16.8868 L30.885,15.4728 L34.767,19.3548 C35.158,19.7448 35.158,20.3778 34.767,20.7688 L30.885,24.6508 L29.471,23.2368 Z M14.408,20.7688 C14.018,20.3778 14.018,19.7448 14.408,19.3548 L18.29,15.4728 L19.704,16.8868 L16.53,20.0618 L19.704,23.2368 L18.29,24.6508 L14.408,20.7688 Z M23.282,25.7048 L21.424,24.9618 L25.641,14.4188 L27.498,15.1618 L23.282,25.7048 Z M33.873,43.9998 L14.081,43.9998 L5.091,36.9778 L11.59,31.6018 L13.901,33.8608 C14.55,34.4938 15.603,34.4918 16.248,33.8608 L17.8,32.3428 C18.503,32.6968 19.232,32.9928 19.979,33.2298 L19.979,35.3198 C19.979,36.2468 20.733,36.9998 21.659,36.9998 L27.299,36.9998 C28.225,36.9998 28.979,36.2468 28.979,35.3198 L28.979,33.4388 C29.698,33.1998 30.399,32.9028 31.075,32.5488 L32.548,34.0558 C33.187,34.7078 34.315,34.7078 34.951,34.0558 L36.894,32.0678 L42.861,36.9798 L33.873,43.9998 Z M11.284,21.9998 L8.979,21.9998 L8.979,16.9998 L11.502,16.9998 C11.958,16.9998 12.357,16.6918 12.47,16.2508 C12.751,15.1658 13.175,14.1198 13.732,13.1408 C13.952,12.7528 13.889,12.2668 13.577,11.9478 L11.768,10.0958 L15.207,6.5758 L16.987,8.3958 C17.311,8.7278 17.818,8.7928 18.213,8.5558 C19.167,7.9878 20.186,7.5558 21.241,7.2698 C21.676,7.1518 21.979,6.7568 21.979,6.3048 L21.979,3.9998 L26.979,3.9998 L26.979,6.5238 C26.979,6.9798 27.287,7.3778 27.729,7.4918 C28.812,7.7718 29.858,8.1958 30.838,8.7538 C31.225,8.9738 31.711,8.9118 32.032,8.5998 L33.883,6.7888 L37.402,10.2288 L35.582,12.0068 C35.252,12.3298 35.186,12.8368 35.422,13.2338 C35.99,14.1868 36.422,15.2058 36.709,16.2618 C36.827,16.6978 37.223,16.9998 37.674,16.9998 L39.979,16.9998 L39.979,21.9998 L37.455,21.9998 C36.999,21.9998 36.601,22.3078 36.488,22.7498 C36.207,23.8338 35.783,24.8798 35.226,25.8598 C35.005,26.2468 35.069,26.7338 35.38,27.0518 L37.19,28.9038 L36.748,29.3568 L36.592,29.2278 L35.321,30.7718 L35.345,30.7918 L33.75,32.4238 L31.971,30.6038 C31.649,30.2748 31.141,30.2088 30.744,30.4438 C29.79,31.0118 28.772,31.4448 27.717,31.7298 C27.282,31.8478 26.979,32.2438 26.979,32.6948 L26.979,34.9998 L21.979,34.9998 L21.979,32.4768 C21.979,32.0208 21.67,31.6228 21.229,31.5078 C20.146,31.2278 19.1,30.8038 18.119,30.2468 C17.734,30.0268 17.246,30.0888 16.926,30.4008 L15.075,32.2108 L11.556,28.7718 L13.375,26.9928 C13.705,26.6708 13.772,26.1628 13.535,25.7668 C12.968,24.8128 12.535,23.7938 12.248,22.7378 C12.13,22.3028 11.735,21.9998 11.284,21.9998 L11.284,21.9998 Z M38.297,30.6318 L38.837,30.0798 C39.473,29.4318 39.473,28.3778 38.838,27.7308 L37.323,26.1788 C37.676,25.4758 37.972,24.7478 38.208,23.9998 L40.299,23.9998 C41.225,23.9998 41.979,23.2468 41.979,22.3198 L41.979,16.6798 C41.979,15.7538 41.225,14.9998 40.299,14.9998 L38.417,14.9998 C38.178,14.2808 37.881,13.5788 37.528,12.9028 L39.034,11.4308 C39.361,11.1118 39.54,10.6848 39.54,10.2288 C39.54,9.7728 39.361,9.3448 39.034,9.0278 L35.057,5.1388 C34.408,4.5068 33.355,4.5078 32.709,5.1398 L31.158,6.6568 C30.454,6.3028 29.726,6.0068 28.979,5.7708 L28.979,3.6798 C28.979,2.7538 28.225,1.9998 27.299,1.9998 L21.659,1.9998 C20.733,1.9998 19.979,2.7538 19.979,3.6798 L19.979,5.5618 C19.26,5.7998 18.559,6.0968 17.882,6.4508 L16.409,4.9448 C15.771,4.2918 14.643,4.2918 14.006,4.9448 L10.12,8.9208 C9.485,9.5688 9.485,10.6228 10.119,11.2698 L11.635,12.8208 C11.283,13.5238 10.986,14.2528 10.749,14.9998 L8.659,14.9998 C7.733,14.9998 6.979,15.7538 6.979,16.6798 L6.979,22.3198 C6.979,23.2468 7.733,23.9998 8.659,23.9998 L10.54,23.9998 C10.78,24.7188 11.076,25.4208 11.43,26.0968 L9.924,27.5698 C9.597,27.8878 9.417,28.3148 9.417,28.7708 C9.417,29.2278 9.597,29.6548 9.923,29.9718 L10.151,30.1948 L1.9,37.0228 L13.392,45.9998 L34.563,45.9998 L46.058,37.0208 L38.297,30.6318 Z" id="Fill-1" fill="#01A88D"></path>
    </g>
</svg>`, fZ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Migration-and-Transfer/Res_AWS-Migration-Hub_Refactor-Spaces-Applications_48</title>
    <g id="Icon-Resource/Migration-and-Transfer/Res_AWS-Migration-Hub_Refactor-Spaces-Applications_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M31,34 C31,37.86 27.859,41 24,41 C20.141,41 17,37.86 17,34 C17,31.215 18.639,28.811 21,27.685 L21,30.026 C19.793,30.939 19,32.373 19,34 C19,36.757 21.243,39 24,39 C26.757,39 29,36.757 29,34 C29,32.373 28.207,30.939 27,30.026 L27,27.685 C29.361,28.811 31,31.215 31,34 L31,34 Z M12,24 C13.654,24 15,25.346 15,27 C15,28.654 13.654,30 12,30 C10.346,30 9,28.654 9,27 C9,25.346 10.346,24 12,24 L12,24 Z M18,21 L30,21 L30,9 L18,9 L18,21 Z M36,24 C37.654,24 39,25.346 39,27 C39,28.654 37.654,30 36,30 C34.346,30 33,28.654 33,27 C33,25.346 34.346,24 36,24 L36,24 Z M12,32 C14.44,32 16.471,30.24 16.907,27.924 C19.458,27.535 21.481,25.538 21.91,23 L23,23 L23,32 L25,32 L25,23 L26.09,23 C26.519,25.538 28.542,27.535 31.093,27.924 C31.529,30.24 33.56,32 36,32 C38.757,32 41,29.757 41,27 C41,24.243 38.757,22 36,22 C33.623,22 31.635,23.672 31.131,25.899 C29.669,25.573 28.517,24.443 28.142,23 L31,23 C31.553,23 32,22.552 32,22 L32,8 C32,7.448 31.553,7 31,7 L17,7 C16.447,7 16,7.448 16,8 L16,22 C16,22.552 16.447,23 17,23 L19.858,23 C19.483,24.443 18.331,25.573 16.869,25.899 C16.365,23.672 14.377,22 12,22 C9.243,22 7,24.243 7,27 C7,29.757 9.243,32 12,32 L12,32 Z M24.707,15.043 L28.207,18.543 L26.793,19.957 L24,17.164 L21.207,19.957 L19.793,18.543 L23.293,15.043 C23.684,14.652 24.316,14.652 24.707,15.043 L24.707,15.043 Z M24.707,10.543 L28.207,14.043 L26.793,15.457 L24,12.664 L21.207,15.457 L19.793,14.043 L23.293,10.543 C23.684,10.152 24.316,10.152 24.707,10.543 L24.707,10.543 Z M4,44 L44,44 L44,4 L4,4 L4,44 Z M45,2 L3,2 C2.447,2 2,2.448 2,3 L2,45 C2,45.552 2.447,46 3,46 L45,46 C45.553,46 46,45.552 46,45 L46,3 C46,2.448 45.553,2 45,2 L45,2 Z" id="Fill-1" fill="#01A88D"></path>
    </g>
</svg>`, pZ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Migration-and-Transfer/Res_AWS-Application-Discovery-Service_AWS-Agentless-Collector_48</title>
    <g id="Icon-Resource/Migration-and-Transfer/Res_AWS-Application-Discovery-Service_AWS-Agentless-Collector_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M33,26.9986 C33,23.6886 30.309,20.9956 27,20.9956 C23.691,20.9956 21,23.6886 21,26.9986 C21,30.3086 23.691,33.0006 27,33.0006 C30.309,33.0006 33,30.3086 33,26.9986 L33,26.9986 Z M35,26.9986 C35,31.4116 31.411,35.0006 27,35.0006 C22.589,35.0006 19,31.4116 19,26.9986 C19,22.5856 22.589,18.9956 27,18.9956 C31.411,18.9956 35,22.5856 35,26.9986 L35,26.9986 Z M43.548,41.1446 L36.64,34.1066 C35.966,35.0206 35.168,35.8336 34.267,36.5236 L41.215,43.5446 C41.814,44.1536 42.872,44.1286 43.496,43.4946 C44.147,42.8336 44.171,41.7796 43.548,41.1446 L43.548,41.1446 Z M27,37.0006 C32.509,37.0006 36.99,32.5156 36.99,27.0006 C36.99,21.4866 32.509,17.0006 27,17.0006 C21.491,17.0006 17.009,21.4866 17.009,27.0006 C17.009,32.5156 21.491,37.0006 27,37.0006 L27,37.0006 Z M44.976,39.7436 C46.357,41.1526 46.333,43.4646 44.92,44.8986 C44.22,45.6096 43.292,46.0006 42.31,46.0006 C41.354,46.0006 40.46,45.6276 39.792,44.9506 L32.547,37.6296 C30.887,38.5016 29.002,39.0006 27,39.0006 C20.388,39.0006 15.009,33.6176 15.009,27.0006 C15.009,20.3846 20.388,15.0006 27,15.0006 C33.611,15.0006 38.99,20.3846 38.99,27.0006 C38.99,28.9236 38.525,30.7356 37.718,32.3486 L44.976,39.7436 Z M29,13.9996 L42,13.9996 L42,11.9996 L29,11.9996 L29,13.9996 Z M29,8.9996 L42,8.9996 L42,6.9996 L29,6.9996 L29,8.9996 Z M44.472,1.9996 L26.529,1.9996 C25.687,1.9996 25,2.6866 25,3.5286 L25,12.9996 L27,12.9996 L27,3.9996 L44,3.9996 L43.997,36.9996 L44,36.9996 C45.104,36.9986 46,36.1006 46,34.9966 L46,3.5276 C46,2.6856 45.314,1.9996 44.472,1.9996 L44.472,1.9996 Z M6,13.9996 L19,13.9996 L19,11.9996 L6,11.9996 L6,13.9996 Z M6,8.9996 L19,8.9996 L19,6.9996 L6,6.9996 L6,8.9996 Z M4,36.9996 L18,36.9996 L18,38.9996 L3.529,38.9996 C2.687,38.9996 2,38.3136 2,37.4716 L2,3.5276 C2,2.6856 2.686,1.9996 3.528,1.9996 L21.472,1.9996 C22.314,1.9996 23,2.6856 23,3.5276 L23,12.9996 L21,12.9996 L21,3.9996 L4,3.9996 L4,36.9996 Z" id="Fill-1" fill="#01A88D"></path>
    </g>
</svg>`, mZ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Migration-and-Transfer/Res_AWS-Mainframe-Modernization_Analyzer_48</title>
    <g id="Icon-Resource/Migration-and-Transfer/Res_AWS-Mainframe-Modernization_Analyzer_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M30.007,10 L41.007,10 L41.007,8 L30.007,8 L30.007,10 Z M16.007,10 L23.007,10 L23.007,8 L16.007,8 L16.007,10 Z M31.007,16 L46.007,16 L46.007,14 L31.007,14 L31.007,16 Z M12.007,11 C12.007,14.86 15.148,18 19.007,18 C22.866,18 26.007,14.86 26.007,11 C26.007,7.14 22.866,4 19.007,4 C15.148,4 12.007,7.14 12.007,11 L12.007,11 Z M12.776,17.479 L3.714,26.541 L2.3,25.126 L11.49,15.936 C10.555,14.518 10.007,12.822 10.007,11 C10.007,6.038 14.044,2 19.007,2 C23.97,2 28.007,6.038 28.007,11 C28.007,15.962 23.97,20 19.007,20 C16.589,20 14.394,19.036 12.776,17.479 L12.776,17.479 Z M14.007,40 L37.007,40 L37.007,38 L14.007,38 L14.007,40 Z M8.007,34 L28.007,34 L28.007,32 L8.007,32 L8.007,34 Z M14.007,28 L37.007,28 L37.007,26 L14.007,26 L14.007,28 Z M27.007,22 L46.007,22 L46.007,20 L27.007,20 L27.007,22 Z M37.774,31.463 L45.501,37.5 L34.62,46 L14.73,46 L3.85,37.5 L7.219,34.867 L8.451,36.443 L7.098,37.5 L15.419,44 L33.931,44 L42.253,37.5 L36.543,33.04 L37.774,31.463 Z" id="Fill-1" fill="#01A88D"></path>
    </g>
</svg>`, wZ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Migration-and-Transfer/Res_AWS-DataSync_Discovery_48</title>
    <g id="Icon-Resource/Migration-and-Transfer/Res_AWS-DataSync_Discovery_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M13.0081,28.0372862 L13.0081,10.0372862 L19.0081,10.0372862 L19.0081,15.0372862 C19.0081,15.5892862 19.4551,16.0372862 20.0081,16.0372862 L25.0081,16.0372862 L25.0081,28.0372862 L13.0081,28.0372862 Z M21.0081,11.4512862 L23.5941,14.0372862 L21.0081,14.0372862 L21.0081,11.4512862 Z M20.0081,8.03728617 L12.0081,8.03728617 C11.4551,8.03728617 11.0081,8.48528617 11.0081,9.03728617 L11.0081,29.0372862 C11.0081,29.5892862 11.4551,30.0372862 12.0081,30.0372862 L26.0081,30.0372862 C26.5611,30.0372862 27.0081,29.5892862 27.0081,29.0372862 L27.0081,15.0372862 C27.0081,14.7722862 26.9031,14.5172862 26.7151,14.3302862 L20.7151,8.33028617 C20.5281,8.14228617 20.2741,8.03728617 20.0081,8.03728617 L20.0081,8.03728617 Z M33.0081,12.0372862 L46.0081,12.0372862 L46.0081,10.0372862 L33.0081,10.0372862 L33.0081,12.0372862 Z M29.0081,16.0372862 L37.0081,16.0372862 L37.0081,14.0372862 L29.0081,14.0372862 L29.0081,16.0372862 Z M39.0081,16.0372862 L44.0081,16.0372862 L44.0081,14.0372862 L39.0081,14.0372862 L39.0081,16.0372862 Z M31.0081,20.0372862 L45.0081,20.0372862 L45.0081,18.0372862 L31.0081,18.0372862 L31.0081,20.0372862 Z M43.0901,43.1162862 C41.9481,44.2742862 39.9931,44.3112862 38.8881,43.1942862 L28.3931,32.5722862 C30.0091,31.3092862 31.3961,29.7432862 32.4661,27.9402862 L43.1721,38.8292862 C44.3141,39.9912862 44.2781,41.9142862 43.0901,43.1162862 L43.0901,43.1162862 Z M33.4181,26.0552862 C33.8311,25.1082862 34.1731,24.1172862 34.4141,23.0802862 L32.4671,22.6262862 C31.0281,28.8042862 25.9601,33.3462862 19.8591,33.9292862 C11.9311,34.6832862 4.8571,28.6002862 4.0701,20.3682862 C3.2851,12.1342862 9.0891,4.82028617 17.0081,4.06428617 C21.5341,3.63128617 25.9081,5.38628617 29.0121,8.87528617 L30.5061,7.54628617 C26.9751,3.57528617 21.9751,1.58228617 16.8191,2.07328617 C7.8021,2.93428617 1.1901,11.2262862 2.0801,20.5582862 C2.9201,29.3602862 10.1421,35.9922862 18.5291,35.9922862 C19.0311,35.9922862 19.5381,35.9682862 20.0481,35.9202862 C22.4551,35.6902862 24.7131,34.9122862 26.7131,33.7172862 L37.4651,44.5992862 C38.3821,45.5272862 39.6081,46.0372862 40.9191,46.0372862 L40.9201,46.0372862 C42.2721,46.0372862 43.5481,45.4982862 44.5141,44.5212862 C46.4641,42.5462862 46.5021,39.3642862 44.5981,37.4272862 L33.4181,26.0552862 Z" id="Fill-1" fill="#01A88D"></path>
    </g>
</svg>`, xZ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Migration-and-Transfer/Res_AWS-Migration-Hub_Refactor-Spaces-Services_48</title>
    <g id="Icon-Resource/Migration-and-Transfer/Res_AWS-Migration-Hub_Refactor-Spaces-Services_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M15,24 C15,28.962 19.037,33 24,33 C28.963,33 33,28.962 33,24 C33,19.038 28.963,15 24,15 C19.037,15 15,19.038 15,24 L15,24 Z M16.966,32.448 L3.707,45.707 L2.293,44.293 L15.552,31.034 C13.961,29.125 13,26.673 13,24 C13,17.935 17.935,13 24,13 C30.065,13 35,17.935 35,24 C35,30.065 30.065,35 24,35 C21.327,35 18.875,34.039 16.966,32.448 L16.966,32.448 Z M24,20.664 L27.793,24.457 L29.207,23.043 L24.707,18.543 C24.316,18.152 23.684,18.152 23.293,18.543 L18.793,23.043 L20.207,24.457 L24,20.664 Z M24,25.664 L27.793,29.457 L29.207,28.043 L24.707,23.543 C24.316,23.152 23.684,23.152 23.293,23.543 L18.793,28.043 L20.207,29.457 L24,25.664 Z M46,20.5 L46,27.5 C46,28.534 45.159,29.375 44.125,29.375 L41.246,29.375 C40.923,30.414 40.503,31.424 39.993,32.392 L42.031,34.43 C42.386,34.784 42.581,35.255 42.581,35.756 C42.581,36.256 42.386,36.728 42.031,37.082 L37.081,42.031 C36.373,42.739 35.14,42.741 34.43,42.031 L32.392,39.993 C31.422,40.503 30.412,40.923 29.375,41.246 L29.375,44.125 C29.375,45.159 28.534,46 27.5,46 L20.5,46 C19.466,46 18.625,45.159 18.625,44.125 L18.625,41.246 C17.588,40.923 16.578,40.503 15.608,39.993 L13.57,42.031 C12.861,42.741 11.628,42.739 10.919,42.031 L10.59,41.703 L12.004,40.288 L12.244,40.529 L14.727,38.047 C15.048,37.725 15.544,37.662 15.937,37.89 C17.181,38.613 18.508,39.164 19.881,39.527 C20.319,39.643 20.625,40.04 20.625,40.494 L20.625,44 L27.375,44 L27.375,40.494 C27.375,40.04 27.681,39.643 28.119,39.527 C29.492,39.164 30.819,38.613 32.063,37.89 C32.456,37.662 32.952,37.725 33.273,38.047 L35.756,40.529 L40.529,35.756 L38.047,33.273 C37.726,32.953 37.661,32.456 37.89,32.063 C38.612,30.822 39.163,29.495 39.527,28.119 C39.644,27.681 40.04,27.375 40.494,27.375 L44,27.375 L44,20.625 L40.494,20.625 C40.04,20.625 39.644,20.319 39.527,19.881 C39.163,18.505 38.612,17.178 37.89,15.937 C37.661,15.544 37.726,15.047 38.047,14.727 L40.529,12.245 L35.756,7.471 L33.273,9.953 C32.952,10.275 32.456,10.338 32.063,10.11 C30.819,9.387 29.492,8.836 28.119,8.473 C27.681,8.357 27.375,7.96 27.375,7.506 L27.375,4 L20.625,4 L20.625,7.506 C20.625,7.96 20.319,8.357 19.881,8.473 C18.508,8.836 17.181,9.387 15.937,10.11 C15.544,10.338 15.048,10.275 14.727,9.953 L12.244,7.471 L7.471,12.244 L9.953,14.727 C10.274,15.047 10.339,15.544 10.11,15.937 C9.388,17.178 8.837,18.505 8.473,19.881 C8.356,20.319 7.96,20.625 7.506,20.625 L4,20.625 L4,27.375 L7.506,27.375 C7.96,27.375 8.356,27.681 8.473,28.119 C8.837,29.495 9.388,30.822 10.11,32.063 C10.339,32.456 10.274,32.953 9.953,33.273 L7.471,35.755 L7.73,36.014 L6.316,37.429 L5.969,37.082 C5.614,36.728 5.419,36.256 5.419,35.756 C5.419,35.255 5.614,34.784 5.969,34.43 L8.007,32.392 C7.497,31.424 7.077,30.414 6.754,29.375 L3.875,29.375 C2.841,29.375 2,28.534 2,27.5 L2,20.5 C2,19.466 2.841,18.625 3.875,18.625 L6.754,18.625 C7.077,17.586 7.497,16.576 8.007,15.608 L5.969,13.57 C5.614,13.216 5.419,12.745 5.419,12.244 C5.419,11.744 5.614,11.272 5.969,10.918 L10.919,5.969 C11.628,5.26 12.861,5.259 13.57,5.969 L15.608,8.007 C16.578,7.497 17.588,7.077 18.625,6.754 L18.625,3.875 C18.625,2.841 19.466,2 20.5,2 L27.5,2 C28.534,2 29.375,2.841 29.375,3.875 L29.375,6.754 C30.412,7.077 31.422,7.497 32.392,8.007 L34.43,5.969 C35.14,5.259 36.373,5.26 37.081,5.969 L42.031,10.918 C42.386,11.272 42.581,11.744 42.581,12.244 C42.581,12.745 42.386,13.216 42.031,13.57 L39.993,15.608 C40.503,16.576 40.923,17.586 41.246,18.625 L44.125,18.625 C45.159,18.625 46,19.466 46,20.5 L46,20.5 Z" id="Fill-1" fill="#01A88D"></path>
    </g>
</svg>`, _Z = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Migration-and-Transfer/Res_AWS-Datasync_Agent_48</title>
    <g id="Icon-Resource/Migration-and-Transfer/Res_AWS-Datasync_Agent_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M44.0004,8.0762 C44.0004,5.8282 42.1724,4.0002 39.9244,4.0002 L8.0754,4.0002 C5.8284,4.0002 4.0004,5.8282 4.0004,8.0762 L4.0004,39.8592 C4.0004,42.1082 5.8304,43.9382 8.0794,43.9382 L39.9244,43.9382 C42.1724,43.9382 44.0004,42.1102 44.0004,39.8622 L44.0004,8.0762 Z M46.0004,8.0762 L46.0004,39.8622 C46.0004,43.2122 43.2744,45.9382 39.9244,45.9382 L8.0794,45.9382 C4.7284,45.9382 2.0004,43.2102 2.0004,39.8592 L2.0004,8.0762 C2.0004,4.7252 4.7264,2.0002 8.0754,2.0002 L39.9244,2.0002 C43.2744,2.0002 46.0004,4.7252 46.0004,8.0762 L46.0004,8.0762 Z M33.2854,12.7282 C32.9844,12.4882 32.5714,12.4422 32.2274,12.6072 C31.8814,12.7742 31.6604,13.1242 31.6604,13.5092 L31.6604,15.9982 L25.8094,15.9982 L25.8094,17.9982 L32.6604,17.9982 C33.2134,17.9982 33.6604,17.5502 33.6604,16.9982 L33.6604,15.5892 L39.0634,19.9122 L33.6604,24.2352 L33.6604,23.1142 C33.6604,22.5612 33.2134,22.1142 32.6604,22.1142 L15.5184,22.1142 L15.5184,19.9122 C15.5184,19.5282 15.2974,19.1772 14.9514,19.0112 C14.6034,18.8432 14.1934,18.8912 13.8934,19.1312 L5.8884,25.5342 C5.6504,25.7242 5.5134,26.0122 5.5134,26.3152 C5.5134,26.6192 5.6504,26.9072 5.8884,27.0962 L13.8934,33.4992 C14.0734,33.6442 14.2954,33.7192 14.5184,33.7192 C14.6654,33.7192 14.8134,33.6862 14.9514,33.6192 C15.2974,33.4532 15.5184,33.1032 15.5184,32.7192 L15.5184,30.1282 L21.3454,30.1282 L21.3454,28.1282 L14.5184,28.1282 C13.9654,28.1282 13.5184,28.5762 13.5184,29.1282 L13.5184,30.6382 L8.1134,26.3152 L13.5184,21.9932 L13.5184,23.1142 C13.5184,23.6662 13.9654,24.1142 14.5184,24.1142 L31.6604,24.1142 L31.6604,26.3152 C31.6604,26.7002 31.8814,27.0502 32.2274,27.2172 C32.5744,27.3832 32.9844,27.3362 33.2854,27.0962 L41.2894,20.6932 C41.5264,20.5032 41.6644,20.2162 41.6644,19.9122 C41.6644,19.6082 41.5264,19.3212 41.2894,19.1312 L33.2854,12.7282 Z M28.3244,30.1602 L41.4804,30.1602 L41.4804,28.1602 L28.3244,28.1602 L28.3244,30.1602 Z M23.1334,30.1602 L26.6344,30.1602 L26.6344,28.1602 L23.1334,28.1602 L23.1334,30.1602 Z M8.4524,17.9982 L19.2974,17.9982 L19.2974,15.9982 L8.4524,15.9982 L8.4524,17.9982 Z M20.5684,17.9982 L23.9164,17.9982 L23.9164,15.9982 L20.5684,15.9982 L20.5684,17.9982 Z" id="AWS-Datasync-Agent_Resource-Icon_light-bg" fill="#01A88D"></path>
    </g>
</svg>`, vZ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Migration-and-Transfer/Res_AWS-Mainframe-Modernization_Converter_48</title>
    <g id="Icon-Resource/Migration-and-Transfer/Res_AWS-Mainframe-Modernization_Converter_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M22.997,13 L26.997,13 L26.997,9 L22.997,9 L22.997,13 Z M24.997,35 C23.894,35 22.997,35.897 22.997,37 C22.997,38.103 23.894,39 24.997,39 C26.099,39 26.997,38.103 26.997,37 C26.997,35.897 26.099,35 24.997,35 L24.997,35 Z M25.997,15 L25.997,33.142 C27.717,33.589 28.997,35.142 28.997,37 C28.997,39.206 27.203,41 24.997,41 C22.791,41 20.997,39.206 20.997,37 C20.997,35.142 22.276,33.589 23.997,33.142 L23.997,15 L20.997,15 L20.997,7 L28.997,7 L28.997,15 L25.997,15 Z M20.997,20 L20.997,18 L14.16,18 L5.198,11 L14.16,4 L33.952,4 L42.914,11 L33.952,18 L27.997,18 L27.997,20 L34.641,20 L46.162,11 L34.641,2 L13.471,2 L1.95,11 L13.471,20 L20.997,20 Z M34.641,28 L46.162,37 L34.641,46 L13.471,46 L1.95,37 L13.471,28 L20.997,28 L20.997,30 L14.16,30 L5.198,37 L14.16,44 L33.952,44 L42.914,37 L33.952,30 L27.997,30 L27.997,28 L34.641,28 Z" id="Fill-1" fill="#01A88D"></path>
    </g>
</svg>`, MZ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Migration-and-Transfer/Res_AWS-Transfer-Family_AWS-AS2_48</title>
    <g id="Icon-Resource/Migration-and-Transfer/Res_AWS-Transfer-Family_AWS-AS2_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M33.49,42.0302 C33.899,41.4232 34.181,40.9112 34.336,40.4932 C34.491,40.0752 34.568,39.6732 34.568,39.2852 C34.568,38.5282 34.37,37.9312 33.974,37.4962 C33.578,37.0622 33.036,36.8442 32.346,36.8442 C31.933,36.8442 31.529,36.9132 31.133,37.0512 C30.736,37.1892 30.319,37.4042 29.88,37.6972 L29.88,39.1822 C30.698,38.6392 31.383,38.3682 31.933,38.3682 C32.192,38.3682 32.389,38.4542 32.527,38.6272 C32.665,38.7992 32.734,39.0492 32.734,39.3762 C32.734,39.7722 32.644,40.1812 32.463,40.6032 C32.282,41.0252 31.978,41.5502 31.553,42.1782 C31.126,42.8072 30.509,43.6472 29.699,44.6972 L29.699,45.9892 L34.84,45.9892 L34.84,44.5302 L31.624,44.5302 C32.459,43.4702 33.081,42.6372 33.49,42.0302 L33.49,42.0302 Z M27.858,41.6362 C27.595,41.3952 27.24,41.1542 26.793,40.9132 L26.095,40.5382 C25.717,40.3322 25.46,40.1422 25.327,39.9702 C25.193,39.7982 25.127,39.5782 25.127,39.3112 C25.127,38.9922 25.23,38.7432 25.436,38.5622 C25.643,38.3812 25.928,38.2912 26.289,38.2912 C26.823,38.2912 27.438,38.4202 28.136,38.6782 L28.136,37.3092 C27.465,36.9992 26.788,36.8442 26.108,36.8442 C25.565,36.8442 25.086,36.9492 24.668,37.1602 C24.25,37.3722 23.921,37.6732 23.679,38.0652 C23.438,38.4572 23.318,38.9152 23.318,39.4402 C23.318,40.0092 23.456,40.4912 23.731,40.8872 C24.007,41.2832 24.464,41.6542 25.1,41.9982 L25.799,42.3722 C26.151,42.5622 26.403,42.7492 26.553,42.9342 C26.704,43.1192 26.78,43.3452 26.78,43.6132 C26.78,43.9742 26.672,44.2522 26.457,44.4462 C26.242,44.6392 25.928,44.7362 25.514,44.7362 C25.23,44.7362 24.887,44.6962 24.487,44.6132 C24.087,44.5312 23.727,44.4302 23.409,44.3102 L23.409,45.6662 C23.684,45.8212 24.024,45.9462 24.429,46.0412 C24.834,46.1352 25.238,46.1832 25.643,46.1832 C26.573,46.1832 27.303,45.9442 27.833,45.4662 C28.362,44.9882 28.627,44.3402 28.627,43.5222 C28.627,43.1002 28.564,42.7402 28.439,42.4442 C28.314,42.1462 28.121,41.8772 27.858,41.6362 L27.858,41.6362 Z M19.999,42.5662 L19.185,38.8592 L18.397,42.5662 L19.999,42.5662 Z M20.258,37.0382 L22.724,45.9892 L20.735,45.9892 L20.27,43.8582 L18.127,43.8582 L17.675,45.9892 L15.775,45.9892 L18.256,37.0382 L20.258,37.0382 Z M45.609,10.8922 L36.998,2.2812 C36.623,1.9062 35.959,1.9062 35.584,2.2812 L26.973,10.8922 C26.687,11.1782 26.601,11.6092 26.757,11.9822 C26.911,12.3562 27.276,12.5992 27.68,12.5992 L32.062,12.5992 L32.062,16.9812 L32.062,21.2862 L32.062,24.5162 C32.062,25.0682 32.51,25.5162 33.062,25.5162 L36.03,25.5162 L29.833,31.7132 L23.636,25.5162 L26.604,25.5162 C27.157,25.5162 27.604,25.0682 27.604,24.5162 L27.604,16.9812 L25.604,16.9812 L25.604,23.5162 L21.221,23.5162 C20.817,23.5162 20.452,23.7592 20.298,24.1332 C20.142,24.5072 20.228,24.9372 20.514,25.2232 L29.126,33.8342 C29.321,34.0292 29.577,34.1272 29.833,34.1272 C30.089,34.1272 30.344,34.0292 30.54,33.8342 L39.151,25.2232 C39.437,24.9372 39.523,24.5072 39.368,24.1332 C39.214,23.7592 38.848,23.5162 38.444,23.5162 L34.062,23.5162 L34.062,21.2862 L34.062,16.9812 L34.062,11.5992 C34.062,11.0472 33.615,10.5992 33.062,10.5992 L30.094,10.5992 L36.291,4.4022 L42.488,10.5992 L39.52,10.5992 C38.968,10.5992 38.52,11.0472 38.52,11.5992 L38.52,19.2102 L36.291,19.2102 L36.291,21.2102 L41.75,21.2102 L41.75,43.9672 L39.456,43.9672 L39.456,45.9672 L42.75,45.9672 C43.303,45.9672 43.75,45.5192 43.75,44.9672 L43.75,20.2102 C43.75,19.6582 43.303,19.2102 42.75,19.2102 L40.52,19.2102 L40.52,12.5992 L44.902,12.5992 C45.306,12.5992 45.672,12.3562 45.826,11.9822 C45.981,11.6082 45.895,11.1782 45.609,10.8922 L45.609,10.8922 Z M9.08,43.9672 L11.535,43.9672 L11.535,45.9672 L6.152,45.9672 C4.414,45.9672 3,44.5522 3,42.8142 L3,12.6762 C3,12.1232 3.447,11.6762 4,11.6762 L15.922,11.6762 C16.231,11.6762 16.524,11.8192 16.714,12.0642 L18.906,14.9052 L23.375,14.9052 L23.375,16.9052 L18.415,16.9052 C18.105,16.9052 17.812,16.7612 17.623,16.5162 L15.43,13.6762 L5,13.6762 L5,42.8142 C5,43.4502 5.516,43.9672 6.152,43.9672 C6.788,43.9672 7.305,43.4502 7.305,42.8142 L7.305,20.2102 C7.305,19.6582 7.753,19.2102 8.305,19.2102 L23.375,19.2102 L23.375,21.2102 L9.305,21.2102 L9.305,42.8142 C9.305,43.2222 9.222,43.6092 9.08,43.9672 L9.08,43.9672 Z" id="Fill-1" fill="#01A88D"></path>
    </g>
</svg>`, RZ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Migration-and-Transfer/Res_AWS-Application-Discovery-Service_Migration-Evaluator-Collector_48</title>
    <g id="Icon-Resource/Migration-and-Transfer/Res_AWS-Application-Discovery-Service_Migration-Evaluator-Collector_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M14.859,18.1156 L13,16.2196 L13,22.9956 C13,23.5486 12.552,23.9956 12,23.9956 L7.363,23.9956 C6.512,23.9956 5.81,23.8156 5.213,23.4456 C4.014,22.7036 2,20.9616 2,17.6406 C2,14.8226 3.503,12.6586 6.065,11.7126 L6.056,11.5666 C6.054,8.2786 8.251,4.9296 11.164,3.7176 C14.563,2.3016 18.16,3.0076 20.79,5.6006 C21.486,6.2876 22.076,7.0986 22.549,8.0226 C23.598,7.3736 24.899,7.1976 26.112,7.6026 C27.692,8.1306 28.729,9.4826 28.999,11.3046 C30.509,11.3066 32.129,11.6026 32.84,12.7106 L31.159,13.7916 C30.997,13.5416 30.035,13.1976 28.133,13.3376 C27.82,13.3596 27.534,13.2436 27.327,13.0216 C27.12,12.7986 27.026,12.4946 27.07,12.1946 C27.068,10.8506 26.489,9.8376 25.478,9.4996 C24.571,9.1966 23.567,9.5146 22.983,10.2916 C22.761,10.5856 22.394,10.7356 22.034,10.6796 C21.671,10.6246 21.367,10.3746 21.242,10.0296 C20.809,8.8236 20.184,7.8126 19.385,7.0246 C18.407,6.0596 15.718,3.9846 11.933,5.5636 C9.795,6.4536 8.054,9.1196 8.054,11.5066 L8.108,12.3746 C8.137,12.8546 7.82,13.2876 7.354,13.4046 C6.101,13.7196 4,14.6896 4,17.6406 C4,19.8736 5.233,21.1056 6.267,21.7446 C6.539,21.9136 6.897,21.9956 7.364,21.9956 L11,21.9956 L11,16.2386 L9.133,18.1046 L7.719,16.6906 L11.319,13.0906 C11.506,12.9036 11.76,12.7976 12.026,12.7976 L12.031,12.7976 C12.297,12.7996 12.553,12.9076 12.74,13.0976 L16.287,16.7156 L14.859,18.1156 Z M27,32.9956 C23.691,32.9956 21,30.3036 21,26.9936 C21,23.6836 23.691,20.9906 27,20.9906 C30.308,20.9906 33,23.6836 33,26.9936 C33,30.3036 30.308,32.9956 27,32.9956 L27,32.9956 Z M27,18.9906 C22.588,18.9906 19,22.5806 19,26.9936 C19,31.4066 22.588,34.9956 27,34.9956 C31.411,34.9956 35,31.4066 35,26.9936 C35,22.5806 31.411,18.9906 27,18.9906 L27,18.9906 Z M43.496,43.4906 C43.173,43.8166 42.753,43.9956 42.309,43.9956 C41.893,43.9956 41.505,43.8346 41.214,43.5406 L34.267,36.5186 C35.167,35.8286 35.965,35.0156 36.639,34.1016 L43.547,41.1396 C44.171,41.7746 44.147,42.8286 43.496,43.4906 L43.496,43.4906 Z M17.008,26.9956 C17.008,21.4816 21.491,16.9956 27,16.9956 C32.508,16.9956 36.99,21.4816 36.99,26.9956 C36.99,32.5106 32.508,36.9956 27,36.9956 C21.491,36.9956 17.008,32.5106 17.008,26.9956 L17.008,26.9956 Z M44.975,39.7386 L37.718,32.3436 C38.524,30.7316 38.99,28.9186 38.99,26.9956 C38.99,20.3796 33.611,14.9956 27,14.9956 C20.387,14.9956 15.008,20.3796 15.008,26.9956 C15.008,33.6126 20.387,38.9956 27,38.9956 C29.001,38.9956 30.886,38.4956 32.547,37.6246 L39.792,44.9456 C40.46,45.6226 41.353,45.9956 42.308,45.9956 L42.309,45.9956 C43.292,45.9956 44.219,45.6046 44.92,44.8936 C46.333,43.4596 46.357,41.1476 44.975,39.7386 L44.975,39.7386 Z" id="Fill-1" fill="#01A88D"></path>
    </g>
</svg>`, yZ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Media-Services/Res_AWS-Cloud-Digital-Interface_48</title>
    <g id="Icon-Resource/Media-Services/Res_AWS-Cloud-Digital-Interface_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M7.5,40 C6.121,40 5,38.878 5,37.5 C5,36.122 6.121,35 7.5,35 C8.879,35 10,36.122 10,37.5 C10,38.878 8.879,40 7.5,40 L7.5,40 Z M44,24 C44,35.028 35.028,44 24,44 C19.42,44 15.019,42.421 11.475,39.566 C11.799,38.944 12,38.249 12,37.5 C12,35.019 9.981,33 7.5,33 C5.019,33 3,35.019 3,37.5 C3,39.981 5.019,42 7.5,42 C8.509,42 9.432,41.654 10.184,41.091 C14.09,44.252 18.945,46 24,46 C36.131,46 46,36.131 46,24 L44,24 Z M40.5,8 C41.879,8 43,9.122 43,10.5 C43,11.878 41.879,13 40.5,13 C39.121,13 38,11.878 38,10.5 C38,9.122 39.121,8 40.5,8 L40.5,8 Z M24,4 C28.58,4 32.981,5.579 36.525,8.434 C36.201,9.056 36,9.751 36,10.5 C36,12.981 38.019,15 40.5,15 C42.981,15 45,12.981 45,10.5 C45,8.019 42.981,6 40.5,6 C39.491,6 38.568,6.346 37.816,6.909 C33.91,3.748 29.055,2 24,2 C11.869,2 2,11.869 2,24 L4,24 C4,12.972 12.972,4 24,4 L24,4 Z M22,20.772 L27.912,23.984 L22,27.222 L22,20.772 Z M20.489,18.231 C20.186,18.412 20,18.738 20,19.091 L20,28.909 C20,29.262 20.187,29.589 20.49,29.77 C20.647,29.862 20.823,29.909 21,29.909 C21.165,29.909 21.33,29.868 21.48,29.786 L30.48,24.858 C30.801,24.682 31.001,24.345 31,23.979 C30.999,23.613 30.799,23.277 30.478,23.102 L21.478,18.212 C21.167,18.045 20.793,18.051 20.489,18.231 L20.489,18.231 Z M34,29.774 L24,35.547 L14,29.774 L14,18.226 L24,12.453 L34,18.226 L34,29.774 Z M24.5,10.432 C24.191,10.253 23.809,10.253 23.5,10.432 L12.5,16.783 C12.19,16.961 12,17.292 12,17.649 L12,30.351 C12,30.708 12.19,31.039 12.5,31.217 L23.5,37.568 C23.654,37.657 23.827,37.702 24,37.702 C24.173,37.702 24.346,37.657 24.5,37.568 L35.5,31.217 C35.81,31.039 36,30.708 36,30.351 L36,17.649 C36,17.292 35.81,16.961 35.5,16.783 L24.5,10.432 Z" id="Fill-1" fill="#ED7100"></path>
    </g>
</svg>`, AZ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Media-Services/Res_AWS-Elemental-MediaConnect_Gateway_48</title>
    <g id="Icon-Resource/Media-Services/Res_AWS-Elemental-MediaConnect_Gateway_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M22.000739,21.2011 L27.094739,23.9681 L22.000739,26.7571 L22.000739,21.2011 Z M20.489739,18.6601 C20.186739,18.8401 20.000739,19.1671 20.000739,19.5191 L20.000739,28.4451 C20.000739,28.7981 20.187739,29.1251 20.490739,29.3051 C20.647739,29.3981 20.823739,29.4451 21.000739,29.4451 C21.165739,29.4451 21.330739,29.4041 21.480739,29.3221 L29.662739,24.8421 C29.983739,24.6661 30.183739,24.3291 30.1827427,23.9631 C30.181739,23.5971 29.980739,23.2611 29.659739,23.0861 L21.478739,18.6401 C21.167739,18.4731 20.793739,18.4791 20.489739,18.6601 L20.489739,18.6601 Z M43.955739,25.4221 C43.842739,25.9441 43.532739,26.3911 43.083739,26.6801 C42.634739,26.9711 42.099739,27.0661 41.577739,26.9541 C41.056739,26.8411 40.608739,26.5311 40.319739,26.0821 C40.029739,25.6331 39.933739,25.0981 40.045739,24.5761 C40.158739,24.0551 40.468739,23.6081 40.916739,23.3191 C40.917739,23.3191 40.917739,23.3191 40.917739,23.3181 C41.243739,23.1081 41.616739,22.9991 41.995739,22.9991 C42.138739,22.9991 42.280739,23.0141 42.423739,23.0451 C42.944739,23.1581 43.392739,23.4681 43.681739,23.9161 C43.971739,24.3661 44.067739,24.9001 43.955739,25.4221 L43.955739,25.4221 Z M33.000739,29.1791 L24.000739,34.3741 L15.000739,29.1791 L15.000739,18.7861 L24.000739,13.5901 L33.000739,18.7861 L33.000739,29.1791 Z M35.423739,40.0451 C35.944739,40.1581 36.392739,40.4681 36.681739,40.9161 C36.971739,41.3661 37.067739,41.9001 36.955739,42.4221 C36.842739,42.9441 36.532739,43.3911 36.083739,43.6801 C35.634739,43.9701 35.099739,44.0641 34.577739,43.9541 C34.056739,43.8411 33.608739,43.5311 33.319739,43.0821 C33.029739,42.6331 32.933739,42.0981 33.045739,41.5761 C33.158739,41.0551 33.468739,40.6081 33.916739,40.3191 C33.917739,40.3191 33.917739,40.3191 33.917739,40.3181 C34.243739,40.1081 34.616739,39.9991 34.995739,39.9991 C35.138739,39.9991 35.280739,40.0141 35.423739,40.0451 L35.423739,40.0451 Z M13.681739,43.0821 C13.392739,43.5311 12.944739,43.8411 12.423739,43.9541 C11.896739,44.0671 11.365739,43.9691 10.916739,43.6801 C10.468739,43.3911 10.158739,42.9441 10.045739,42.4221 C9.93373899,41.9001 10.029739,41.3661 10.319739,40.9161 C10.608739,40.4681 11.056739,40.1581 11.577739,40.0451 C11.720739,40.0141 11.862739,39.9991 12.005739,39.9991 C12.384739,39.9991 12.757739,40.1081 13.083739,40.3181 C13.083739,40.3191 13.083739,40.3191 13.084739,40.3191 C13.532739,40.6081 13.842739,41.0551 13.955739,41.5761 C14.067739,42.0981 13.971739,42.6331 13.681739,43.0821 L13.681739,43.0821 Z M7.95573899,25.4221 C7.84273899,25.9441 7.53273899,26.3911 7.08373899,26.6801 C6.63473899,26.9711 6.09973899,27.0661 5.57773899,26.9541 C5.05673899,26.8411 4.60873899,26.5311 4.31973899,26.0821 C4.02973899,25.6331 3.93373899,25.0981 4.04573899,24.5761 C4.15873899,24.0551 4.46873899,23.6081 4.91673899,23.3191 C4.91773899,23.3191 4.91773899,23.3191 4.91773899,23.3181 C5.24373899,23.1081 5.61673899,22.9991 5.99573899,22.9991 C6.13873899,22.9991 6.28073899,23.0141 6.42373899,23.0451 C6.94473899,23.1581 7.39273899,23.4681 7.68173899,23.9161 C7.97173899,24.3661 8.06773899,24.9001 7.95573899,25.4221 L7.95573899,25.4221 Z M11.577739,7.9541 C11.056739,7.8411 10.608739,7.5311 10.319739,7.0821 C10.029739,6.6331 9.93373899,6.0981 10.045739,5.5761 C10.158739,5.0551 10.468739,4.6081 10.916739,4.3191 C10.917739,4.3191 10.917739,4.3191 10.917739,4.3181 C11.243739,4.1081 11.616739,3.9991 11.995739,3.9991 C12.138739,3.9991 12.280739,4.0141 12.423739,4.0451 C12.944739,4.1581 13.392739,4.4681 13.681739,4.9161 C13.971739,5.3661 14.067739,5.9001 13.955739,6.4221 C13.842739,6.9441 13.532739,7.3911 13.083739,7.6801 C12.634739,7.9701 12.100739,8.0651 11.577739,7.9541 L11.577739,7.9541 Z M33.319739,4.9161 C33.608739,4.4681 34.056739,4.1581 34.577739,4.0451 C34.720739,4.0141 34.862739,3.9991 35.005739,3.9991 C35.384739,3.9991 35.757739,4.1081 36.083739,4.3181 C36.083739,4.3191 36.083739,4.3191 36.084739,4.3191 C36.532739,4.6081 36.842739,5.0551 36.955739,5.5761 C37.067739,6.0981 36.971739,6.6331 36.681739,7.0821 C36.392739,7.5311 35.944739,7.8411 35.423739,7.9541 C34.897739,8.0671 34.365739,7.9691 33.916739,7.6801 C33.468739,7.3911 33.158739,6.9441 33.045739,6.4221 C32.933739,5.9001 33.029739,5.3661 33.319739,4.9161 L33.319739,4.9161 Z M45.362739,22.8331 C44.168739,20.9801 41.690739,20.4421 39.833739,21.6381 C38.982739,22.1861 38.392739,23.0241 38.140739,23.9991 L35.000739,23.9991 L35.000739,18.2091 C35.000739,17.8511 34.810739,17.5211 34.500739,17.3431 L30.595739,15.0881 L33.941739,9.8531 C34.287739,9.9481 34.641739,9.9981 34.993739,9.9981 C36.309739,9.9981 37.598739,9.3511 38.362739,8.1651 C38.940739,7.2671 39.135739,6.1981 38.909739,5.1541 C38.684739,4.1091 38.064739,3.2161 37.167739,2.6381 C35.311739,1.4401 32.833739,1.9791 31.638739,3.8331 C31.060739,4.7311 30.865739,5.8011 31.091739,6.8451 C31.259739,7.6231 31.646739,8.3151 32.203739,8.8581 L28.861739,14.0871 L24.500739,11.5691 C24.191739,11.3901 23.809739,11.3901 23.500739,11.5691 L18.391739,14.5191 L14.822739,8.8291 C15.364739,8.2901 15.744739,7.6101 15.909739,6.8451 C16.135739,5.8011 15.940739,4.7311 15.362739,3.8331 C14.167739,1.9801 11.690739,1.4411 9.83373899,2.6381 C8.93673899,3.2161 8.31673899,4.1091 8.09173899,5.1541 C7.86573899,6.1981 8.06073899,7.2671 8.63873899,8.1651 C9.40273899,9.3511 10.691739,9.9981 12.007739,9.9981 C12.372739,9.9981 12.740739,9.9471 13.099739,9.8441 L16.659739,15.5191 L13.500739,17.3431 C13.190739,17.5211 13.000739,17.8511 13.000739,18.2091 L13.000739,23.9991 L9.85673899,23.9991 C9.75073899,23.5931 9.59673899,23.1971 9.36273899,22.8331 C8.16773899,20.9801 5.68973899,20.4421 3.83373899,21.6381 C2.93673899,22.2161 2.31673899,23.1091 2.09173899,24.1541 C1.86573899,25.1981 2.06073899,26.2671 2.63873899,27.1651 C3.40273899,28.3511 4.69173899,28.9981 6.00773899,28.9981 C6.74873899,28.9981 7.49873899,28.7921 8.16673899,28.3621 C9.01873899,27.8131 9.60873899,26.9751 9.86073899,25.9991 L13.000739,25.9991 L13.000739,29.7561 C13.000739,30.1131 13.190739,30.4431 13.500739,30.6221 L16.872739,32.5691 L13.285739,38.2251 C11.587739,37.6471 9.65273899,38.2601 8.63873899,39.8331 C8.06073899,40.7311 7.86573899,41.8011 8.09173899,42.8451 C8.31673899,43.8891 8.93673899,44.7831 9.83373899,45.3611 C10.502739,45.7921 11.252739,45.9981 11.993739,45.9981 C13.309739,45.9981 14.598739,45.3511 15.362739,44.1651 C15.940739,43.2671 16.135739,42.1981 15.909739,41.1541 C15.759739,40.4581 15.421739,39.8401 14.955739,39.3271 L18.606739,33.5701 L23.500739,36.3951 C23.654739,36.4851 23.827739,36.5291 24.000739,36.5291 C24.173739,36.5291 24.346739,36.4851 24.500739,36.3951 L28.695739,33.9731 L32.106739,39.2551 C31.606739,39.7811 31.248739,40.4261 31.091739,41.1541 C30.865739,42.1981 31.060739,43.2671 31.638739,44.1651 C32.402739,45.3511 33.691739,45.9981 35.007739,45.9981 C35.748739,45.9981 36.498739,45.7921 37.166739,45.3621 C38.064739,44.7831 38.684739,43.8891 38.909739,42.8451 C39.135739,41.8011 38.940739,40.7311 38.362739,39.8331 C37.366739,38.2881 35.481739,37.6741 33.805739,38.2001 L30.429739,32.9721 L34.500739,30.6221 C34.810739,30.4431 35.000739,30.1131 35.000739,29.7561 L35.000739,25.9991 L38.144739,25.9991 C38.250739,26.4061 38.404739,26.8021 38.638739,27.1651 C39.402739,28.3511 40.691739,28.9981 42.007739,28.9981 C42.748739,28.9981 43.498739,28.7921 44.166739,28.3621 C45.064739,27.7831 45.684739,26.8891 45.909739,25.8451 C46.135739,24.8011 45.940739,23.7311 45.362739,22.8331 L45.362739,22.8331 Z" id="Fill-1" fill="#ED7100"></path>
    </g>
</svg>`, ZZ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Robotics/Res_AWS-RoboMaker_Cloud-Extensions-ROS_48</title>
    <g id="Icon-Resource/Robotics/Res_AWS-RoboMaker_Cloud-Extensions-ROS_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M23.9675,43.2587 C23.4005,43.2587 22.9385,42.7967 22.9385,42.2297 C22.9385,41.6617 23.4005,41.2007 23.9675,41.2007 C24.5345,41.2007 24.9965,41.6617 24.9965,42.2297 C24.9965,42.7967 24.5345,43.2587 23.9675,43.2587 M23.9675,39.2007 C22.2975,39.2007 20.9385,40.5597 20.9385,42.2297 C20.9385,43.8997 22.2975,45.2587 23.9675,45.2587 C25.6375,45.2587 26.9965,43.8997 26.9965,42.2297 C26.9965,40.5597 25.6375,39.2007 23.9675,39.2007 M14.4985,32.4077 C15.0665,32.4077 15.5275,32.8697 15.5275,33.4377 C15.5275,34.0047 15.0665,34.4657 14.4985,34.4657 C13.9315,34.4657 13.4695,34.0047 13.4695,33.4377 C13.4695,32.8697 13.9315,32.4077 14.4985,32.4077 M14.4985,36.4657 C16.1685,36.4657 17.5275,35.1077 17.5275,33.4377 C17.5275,31.7677 16.1685,30.4077 14.4985,30.4077 C12.8285,30.4077 11.4695,31.7677 11.4695,33.4377 C11.4695,35.1077 12.8285,36.4657 14.4985,36.4657 M14.4985,15.5277 C13.9315,15.5277 13.4695,15.0667 13.4695,14.4987 C13.4695,13.9317 13.9315,13.4697 14.4985,13.4697 C15.0665,13.4697 15.5275,13.9317 15.5275,14.4987 C15.5275,15.0667 15.0665,15.5277 14.4985,15.5277 M17.5275,14.4987 C17.5275,12.8287 16.1685,11.4697 14.4985,11.4697 C12.8285,11.4697 11.4695,12.8287 11.4695,14.4987 C11.4695,16.1687 12.8285,17.5277 14.4985,17.5277 C16.1685,17.5277 17.5275,16.1687 17.5275,14.4987 M33.4375,6.7347 C32.8695,6.7347 32.4075,6.2737 32.4075,5.7057 C32.4075,5.1387 32.8695,4.6767 33.4375,4.6767 C34.0045,4.6767 34.4655,5.1387 34.4655,5.7057 C34.4655,6.2737 34.0045,6.7347 33.4375,6.7347 M33.4375,2.6767 C31.7675,2.6767 30.4075,4.0357 30.4075,5.7057 C30.4075,7.3757 31.7675,8.7347 33.4375,8.7347 C35.1075,8.7347 36.4655,7.3757 36.4655,5.7057 C36.4655,4.0357 35.1075,2.6767 33.4375,2.6767 M42.2295,43.2587 C41.6615,43.2587 41.2005,42.7967 41.2005,42.2297 C41.2005,41.6617 41.6615,41.2007 42.2295,41.2007 C42.7965,41.2007 43.2585,41.6617 43.2585,42.2297 C43.2585,42.7967 42.7965,43.2587 42.2295,43.2587 M42.2295,39.2007 C40.5595,39.2007 39.2005,40.5597 39.2005,42.2297 C39.2005,43.8997 40.5595,45.2587 42.2295,45.2587 C43.8995,45.2587 45.2585,43.8997 45.2585,42.2297 C45.2585,40.5597 43.8995,39.2007 42.2295,39.2007 M33.4375,34.4657 C32.8695,34.4657 32.4075,34.0047 32.4075,33.4377 C32.4075,32.8697 32.8695,32.4077 33.4375,32.4077 C34.0045,32.4077 34.4655,32.8697 34.4655,33.4377 C34.4655,34.0047 34.0045,34.4657 33.4375,34.4657 M33.4375,30.4077 C31.7675,30.4077 30.4075,31.7677 30.4075,33.4377 C30.4075,35.1077 31.7675,36.4657 33.4375,36.4657 C35.1075,36.4657 36.4655,35.1077 36.4655,33.4377 C36.4655,31.7677 35.1075,30.4077 33.4375,30.4077 M33.4375,24.9967 C32.8695,24.9967 32.4075,24.5347 32.4075,23.9677 C32.4075,23.4007 32.8695,22.9387 33.4375,22.9387 C34.0045,22.9387 34.4655,23.4007 34.4655,23.9677 C34.4655,24.5347 34.0045,24.9967 33.4375,24.9967 M33.4375,20.9387 C31.7675,20.9387 30.4075,22.2977 30.4075,23.9677 C30.4075,25.6377 31.7675,26.9967 33.4375,26.9967 C35.1075,26.9967 36.4655,25.6377 36.4655,23.9677 C36.4655,22.2977 35.1075,20.9387 33.4375,20.9387 M5.7055,5.3817 C5.8845,5.3817 6.0295,5.5277 6.0295,5.7057 C6.0295,5.8847 5.8845,6.0297 5.7055,6.0297 C5.5275,6.0297 5.3815,5.8847 5.3815,5.7057 C5.3815,5.5277 5.5275,5.3817 5.7055,5.3817 M5.7055,7.3817 C6.6295,7.3817 7.3815,6.6297 7.3815,5.7057 C7.3815,4.7807 6.6295,4.0297 5.7055,4.0297 C4.7805,4.0297 4.0295,4.7807 4.0295,5.7057 C4.0295,6.6297 4.7805,7.3817 5.7055,7.3817 M5.7055,42.5537 C5.5275,42.5537 5.3815,42.4077 5.3815,42.2297 C5.3815,42.0507 5.5275,41.9057 5.7055,41.9057 C5.8845,41.9057 6.0295,42.0507 6.0295,42.2297 C6.0295,42.4077 5.8845,42.5537 5.7055,42.5537 M5.7055,40.5537 C4.7805,40.5537 4.0295,41.3057 4.0295,42.2297 C4.0295,43.1547 4.7805,43.9057 5.7055,43.9057 C6.6295,43.9057 7.3815,43.1547 7.3815,42.2297 C7.3815,41.3057 6.6295,40.5537 5.7055,40.5537 M23.2905,31.8407 C23.4695,31.8407 23.6145,31.9867 23.6145,32.1647 C23.6145,32.3437 23.4695,32.4877 23.2905,32.4877 C23.1125,32.4877 22.9675,32.3437 22.9675,32.1647 C22.9675,31.9867 23.1125,31.8407 23.2905,31.8407 M23.2905,33.8407 C24.2155,33.8407 24.9675,33.0887 24.9675,32.1647 C24.9675,31.2397 24.2155,30.4877 23.2905,30.4877 C22.3665,30.4877 21.6145,31.2397 21.6145,32.1647 C21.6145,33.0887 22.3665,33.8407 23.2905,33.8407 M23.2905,23.6447 C23.4695,23.6447 23.6145,23.7887 23.6145,23.9677 C23.6145,24.1467 23.4695,24.2907 23.2905,24.2907 C23.1125,24.2907 22.9675,24.1467 22.9675,23.9677 C22.9675,23.7887 23.1125,23.6447 23.2905,23.6447 M23.2905,25.6447 C24.2155,25.6447 24.9675,24.8927 24.9675,23.9677 C24.9675,23.0427 24.2155,22.2907 23.2905,22.2907 C22.3665,22.2907 21.6145,23.0427 21.6145,23.9677 C21.6145,24.8927 22.3665,25.6447 23.2905,25.6447 M14.8215,23.9677 C14.8215,24.1467 14.6775,24.2907 14.4985,24.2907 C14.3205,24.2907 14.1745,24.1467 14.1745,23.9677 C14.1745,23.7887 14.3205,23.6447 14.4985,23.6447 C14.6775,23.6447 14.8215,23.7887 14.8215,23.9677 M12.8215,23.9677 C12.8215,24.8927 13.5735,25.6447 14.4985,25.6447 C15.4225,25.6447 16.1745,24.8927 16.1745,23.9677 C16.1745,23.0427 15.4225,22.2907 14.4985,22.2907 C13.5735,22.2907 12.8215,23.0427 12.8215,23.9677 M5.7055,33.7607 C5.5275,33.7607 5.3815,33.6157 5.3815,33.4377 C5.3815,33.2587 5.5275,33.1127 5.7055,33.1127 C5.8845,33.1127 6.0295,33.2587 6.0295,33.4377 C6.0295,33.6157 5.8845,33.7607 5.7055,33.7607 M5.7055,31.7607 C4.7805,31.7607 4.0295,32.5127 4.0295,33.4377 C4.0295,34.3617 4.7805,35.1127 5.7055,35.1127 C6.6295,35.1127 7.3815,34.3617 7.3815,33.4377 C7.3815,32.5127 6.6295,31.7607 5.7055,31.7607 M23.9675,5.3817 C24.1465,5.3817 24.2905,5.5277 24.2905,5.7057 C24.2905,5.8847 24.1465,6.0297 23.9675,6.0297 C23.7885,6.0297 23.6445,5.8847 23.6445,5.7057 C23.6445,5.5277 23.7885,5.3817 23.9675,5.3817 M23.9675,7.3817 C24.8925,7.3817 25.6445,6.6297 25.6445,5.7057 C25.6445,4.7807 24.8925,4.0297 23.9675,4.0297 C23.0425,4.0297 22.2905,4.7807 22.2905,5.7057 C22.2905,6.6297 23.0425,7.3817 23.9675,7.3817 M33.1135,14.4987 C33.1135,14.3207 33.2585,14.1747 33.4375,14.1747 C33.6155,14.1747 33.7605,14.3207 33.7605,14.4987 C33.7605,14.6777 33.6155,14.8217 33.4375,14.8217 C33.2585,14.8217 33.1135,14.6777 33.1135,14.4987 M35.1135,14.4987 C35.1135,13.5737 34.3615,12.8217 33.4375,12.8217 C32.5125,12.8217 31.7605,13.5737 31.7605,14.4987 C31.7605,15.4227 32.5125,16.1747 33.4375,16.1747 C34.3615,16.1747 35.1135,15.4227 35.1135,14.4987 M41.9055,33.4377 C41.9055,33.2587 42.0505,33.1127 42.2295,33.1127 C42.4075,33.1127 42.5535,33.2587 42.5535,33.4377 C42.5535,33.6157 42.4075,33.7607 42.2295,33.7607 C42.0505,33.7607 41.9055,33.6157 41.9055,33.4377 M43.9055,33.4377 C43.9055,32.5127 43.1545,31.7607 42.2295,31.7607 C41.3055,31.7607 40.5535,32.5127 40.5535,33.4377 C40.5535,34.3617 41.3055,35.1127 42.2295,35.1127 C43.1545,35.1127 43.9055,34.3617 43.9055,33.4377 M33.4375,42.5537 C33.2585,42.5537 33.1135,42.4077 33.1135,42.2297 C33.1135,42.0507 33.2585,41.9057 33.4375,41.9057 C33.6155,41.9057 33.7605,42.0507 33.7605,42.2297 C33.7605,42.4077 33.6155,42.5537 33.4375,42.5537 M33.4375,40.5537 C32.5125,40.5537 31.7605,41.3057 31.7605,42.2297 C31.7605,43.1547 32.5125,43.9057 33.4375,43.9057 C34.3615,43.9057 35.1135,43.1547 35.1135,42.2297 C35.1135,41.3057 34.3615,40.5537 33.4375,40.5537 M42.2295,5.3817 C42.4075,5.3817 42.5535,5.5277 42.5535,5.7057 C42.5535,5.8847 42.4075,6.0297 42.2295,6.0297 C42.0505,6.0297 41.9055,5.8847 41.9055,5.7057 C41.9055,5.5277 42.0505,5.3817 42.2295,5.3817 M42.2295,7.3817 C43.1545,7.3817 43.9055,6.6297 43.9055,5.7057 C43.9055,4.7807 43.1545,4.0297 42.2295,4.0297 C41.3055,4.0297 40.5535,4.7807 40.5535,5.7057 C40.5535,6.6297 41.3055,7.3817 42.2295,7.3817 M5.7055,16.2037 C4.7655,16.2037 3.9995,15.4397 3.9995,14.4987 C3.9995,13.5587 4.7655,12.7927 5.7055,12.7927 C6.6465,12.7927 7.4105,13.5587 7.4105,14.4987 C7.4105,15.4397 6.6465,16.2037 5.7055,16.2037 M5.7055,10.7927 C3.6615,10.7927 1.9995,12.4547 1.9995,14.4987 C1.9995,16.5417 3.6615,18.2037 5.7055,18.2037 C7.7485,18.2037 9.4105,16.5417 9.4105,14.4987 C9.4105,12.4547 7.7485,10.7927 5.7055,10.7927 M5.7055,25.6727 C4.7655,25.6727 3.9995,24.9077 3.9995,23.9677 C3.9995,23.0277 4.7655,22.2627 5.7055,22.2627 C6.6465,22.2627 7.4105,23.0277 7.4105,23.9677 C7.4105,24.9077 6.6465,25.6727 5.7055,25.6727 M5.7055,20.2627 C3.6615,20.2627 1.9995,21.9247 1.9995,23.9677 C1.9995,26.0107 3.6615,27.6727 5.7055,27.6727 C7.7485,27.6727 9.4105,26.0107 9.4105,23.9677 C9.4105,21.9247 7.7485,20.2627 5.7055,20.2627 M14.4985,43.9357 C13.5585,43.9357 12.7925,43.1697 12.7925,42.2297 C12.7925,41.2887 13.5585,40.5247 14.4985,40.5247 C15.4395,40.5247 16.2035,41.2887 16.2035,42.2297 C16.2035,43.1697 15.4395,43.9357 14.4985,43.9357 M14.4985,38.5247 C12.4545,38.5247 10.7925,40.1867 10.7925,42.2297 C10.7925,44.2737 12.4545,45.9357 14.4985,45.9357 C16.5415,45.9357 18.2035,44.2737 18.2035,42.2297 C18.2035,40.1867 16.5415,38.5247 14.4985,38.5247 M14.4985,7.4107 C13.5585,7.4107 12.7925,6.6467 12.7925,5.7057 C12.7925,4.7657 13.5585,3.9997 14.4985,3.9997 C15.4395,3.9997 16.2035,4.7657 16.2035,5.7057 C16.2035,6.6467 15.4395,7.4107 14.4985,7.4107 M14.4985,1.9997 C12.4545,1.9997 10.7925,3.6617 10.7925,5.7057 C10.7925,7.7487 12.4545,9.4107 14.4985,9.4107 C16.5415,9.4107 18.2035,7.7487 18.2035,5.7057 C18.2035,3.6617 16.5415,1.9997 14.4985,1.9997 M23.9675,16.2037 C23.0275,16.2037 22.2625,15.4397 22.2625,14.4987 C22.2625,13.5587 23.0275,12.7927 23.9675,12.7927 C24.9075,12.7927 25.6735,13.5587 25.6735,14.4987 C25.6735,15.4397 24.9075,16.2037 23.9675,16.2037 M23.9675,10.7927 C21.9245,10.7927 20.2625,12.4547 20.2625,14.4987 C20.2625,16.5417 21.9245,18.2037 23.9675,18.2037 C26.0115,18.2037 27.6735,16.5417 27.6735,14.4987 C27.6735,12.4547 26.0115,10.7927 23.9675,10.7927 M42.2295,25.6727 C41.2885,25.6727 40.5245,24.9077 40.5245,23.9677 C40.5245,23.0277 41.2885,22.2627 42.2295,22.2627 C43.1695,22.2627 43.9355,23.0277 43.9355,23.9677 C43.9355,24.9077 43.1695,25.6727 42.2295,25.6727 M42.2295,20.2627 C40.1865,20.2627 38.5245,21.9247 38.5245,23.9677 C38.5245,26.0107 40.1865,27.6727 42.2295,27.6727 C44.2735,27.6727 45.9355,26.0107 45.9355,23.9677 C45.9355,21.9247 44.2735,20.2627 42.2295,20.2627 M42.2295,12.7927 C43.1695,12.7927 43.9355,13.5587 43.9355,14.4987 C43.9355,15.4397 43.1695,16.2037 42.2295,16.2037 C41.2885,16.2037 40.5245,15.4397 40.5245,14.4987 C40.5245,13.5587 41.2885,12.7927 42.2295,12.7927 M42.2295,18.2037 C44.2735,18.2037 45.9355,16.5417 45.9355,14.4987 C45.9355,12.4547 44.2735,10.7927 42.2295,10.7927 C40.1865,10.7927 38.5245,12.4547 38.5245,14.4987 C38.5245,16.5417 40.1865,18.2037 42.2295,18.2037" id="AWS-Robo-Maker_Cloud-extensions-ROS_Resource-Icon_light-bg" fill="#DD344C"></path>
    </g>
</svg>`, kZ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Robotics/Res_AWS-RoboMaker_Simulation_48</title>
    <g id="Icon-Resource/Robotics/Res_AWS-RoboMaker_Simulation_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M43.4075,15.9072 C43.4075,15.7242 43.2585,15.5752 43.0745,15.5752 C42.8915,15.5752 42.7425,15.7242 42.7425,15.9072 C42.7425,16.0902 42.8915,16.2392 43.0745,16.2392 C43.2585,16.2392 43.4075,16.0902 43.4075,15.9072 L43.4075,15.9072 Z M45.3565,15.9072 C45.3565,17.1652 44.3335,18.1882 43.0745,18.1882 C41.8165,18.1882 40.7935,17.1652 40.7935,15.9072 C40.7935,14.6492 41.8165,13.6262 43.0745,13.6262 C44.3335,13.6262 45.3565,14.6492 45.3565,15.9072 L45.3565,15.9072 Z M25.9065,23.3252 C25.9065,23.6232 26.1485,23.8652 26.4465,23.8652 C26.7445,23.8652 26.9865,23.6232 26.9865,23.3252 C26.9865,23.0272 26.7445,22.7842 26.4465,22.7842 C26.1485,22.7842 25.9065,23.0272 25.9065,23.3252 L25.9065,23.3252 Z M26.4465,20.7842 C27.8465,20.7842 28.9865,21.9242 28.9865,23.3252 C28.9865,24.7252 27.8465,25.8652 26.4465,25.8652 C25.0465,25.8652 23.9065,24.7252 23.9065,23.3252 C23.9065,21.9242 25.0465,20.7842 26.4465,20.7842 L26.4465,20.7842 Z M43.0875,23.2542 C43.3685,23.2542 43.5975,23.0252 43.5975,22.7442 C43.5975,22.4632 43.3685,22.2342 43.0875,22.2342 C42.8055,22.2342 42.5775,22.4632 42.5775,22.7442 C42.5775,23.0252 42.8055,23.2542 43.0875,23.2542 L43.0875,23.2542 Z M43.0875,24.2542 C42.2555,24.2542 41.5775,23.5762 41.5775,22.7442 C41.5775,21.9122 42.2555,21.2342 43.0875,21.2342 C43.9205,21.2342 44.5975,21.9122 44.5975,22.7442 C44.5975,23.5762 43.9205,24.2542 43.0875,24.2542 L43.0875,24.2542 Z M26.4465,18.8362 C26.7425,18.8362 26.9825,18.5952 26.9825,18.3002 C26.9825,18.0042 26.7425,17.7632 26.4465,17.7632 C26.1505,17.7632 25.9105,18.0042 25.9105,18.3002 C25.9105,18.5952 26.1505,18.8362 26.4465,18.8362 L26.4465,18.8362 Z M26.4465,19.5862 C25.7375,19.5862 25.1605,19.0092 25.1605,18.3002 C25.1605,17.5912 25.7375,17.0132 26.4465,17.0132 C27.1555,17.0132 27.7325,17.5912 27.7325,18.3002 C27.7325,19.0092 27.1555,19.5862 26.4465,19.5862 L26.4465,19.5862 Z M39.1235,20.3952 C39.1235,20.0062 38.8055,19.6882 38.4165,19.6882 C38.0265,19.6882 37.7095,20.0062 37.7095,20.3952 C37.7095,20.7852 38.0265,21.1022 38.4165,21.1022 C38.8055,21.1022 39.1235,20.7852 39.1235,20.3952 L39.1235,20.3952 Z M41.1235,20.3952 C41.1235,21.8872 39.9085,23.1022 38.4165,23.1022 C36.9245,23.1022 35.7095,21.8872 35.7095,20.3952 C35.7095,18.9032 36.9245,17.6882 38.4165,17.6882 C39.9085,17.6882 41.1235,18.9032 41.1235,20.3952 L41.1235,20.3952 Z M26.6465,29.1572 C26.6465,29.0532 26.5605,28.9682 26.4565,28.9682 C26.3515,28.9682 26.2665,29.0532 26.2665,29.1572 C26.2665,29.3662 26.6465,29.3662 26.6465,29.1572 L26.6465,29.1572 Z M28.5955,29.1572 C28.5955,30.3372 27.6365,31.2962 26.4565,31.2962 C25.2765,31.2962 24.3175,30.3372 24.3175,29.1572 C24.3175,27.9772 25.2765,27.0182 26.4565,27.0182 C27.6365,27.0182 28.5955,27.9772 28.5955,29.1572 L28.5955,29.1572 Z M32.0355,29.7002 C32.3315,29.7002 32.5715,29.4602 32.5715,29.1642 C32.5715,28.8682 32.3315,28.6282 32.0355,28.6282 C31.7395,28.6282 31.4995,28.8682 31.4995,29.1642 C31.4995,29.4602 31.7395,29.7002 32.0355,29.7002 L32.0355,29.7002 Z M32.0355,30.4502 C31.3265,30.4502 30.7495,29.8732 30.7495,29.1642 C30.7495,28.4552 31.3265,27.8782 32.0355,27.8782 C32.7445,27.8782 33.3215,28.4552 33.3215,29.1642 C33.3215,29.8732 32.7445,30.4502 32.0355,30.4502 L32.0355,30.4502 Z M41.9615,30.2412 C41.9615,30.6312 42.2785,30.9482 42.6685,30.9482 C43.0575,30.9482 43.3755,30.6312 43.3755,30.2412 C43.3755,29.8512 43.0575,29.5342 42.6685,29.5342 C42.2785,29.5342 41.9615,29.8512 41.9615,30.2412 L41.9615,30.2412 Z M42.6685,27.5342 C44.1605,27.5342 45.3755,28.7492 45.3755,30.2412 C45.3755,31.7332 44.1605,32.9482 42.6685,32.9482 C41.1765,32.9482 39.9615,31.7332 39.9615,30.2412 C39.9615,28.7492 41.1765,27.5342 42.6685,27.5342 L42.6685,27.5342 Z M19.4705,26.1232 C20.5515,26.0902 20.7115,25.0062 20.7715,24.5982 C20.8525,24.0472 20.9295,23.6912 21.3115,23.4172 C21.7615,23.0932 22.2435,22.8942 22.7435,22.8272 L22.4775,20.8442 C21.6585,20.9552 20.8505,21.2832 20.1415,21.7942 C19.1175,22.5322 18.9075,23.5612 18.8105,24.1832 C17.0115,24.4812 14.7845,25.8822 14.7845,28.9872 C14.7845,30.5952 15.2615,31.8702 16.2015,32.7752 C17.4865,34.0122 19.2005,34.0792 19.5355,34.0792 C19.5695,34.0792 19.5895,34.0782 19.5935,34.0782 L32.7715,34.0782 C32.8475,34.0782 34.6575,34.0682 36.1085,33.1972 C38.0705,32.0192 39.2835,28.8982 37.9145,25.7152 C37.1475,23.9312 35.7095,23.4952 34.6575,23.1772 C34.4035,23.0992 34.1605,23.0252 33.9435,22.9402 C33.9085,22.4862 33.8005,21.7202 33.0735,20.6302 C31.2655,17.9182 28.5675,18.3432 28.4565,18.3622 L28.7795,20.3352 C28.8445,20.3302 30.3395,20.1342 31.4095,21.7392 C31.9095,22.4902 31.9355,22.8822 31.9575,23.1962 C31.9795,23.5302 32.0255,24.2242 32.7935,24.6142 C33.2185,24.8302 33.6545,24.9632 34.0775,25.0912 C35.0995,25.4002 35.6965,25.6192 36.0765,26.5042 C37.0975,28.8802 36.0855,30.8792 35.0795,31.4822 C34.1105,32.0632 32.7825,32.0782 32.7715,32.0782 L19.5625,32.0782 C19.5425,32.0772 18.3715,32.0992 17.5765,31.3232 C17.0515,30.8092 16.7845,30.0232 16.7845,28.9872 C16.7845,26.2402 19.3615,26.1272 19.4705,26.1232 L19.4705,26.1232 Z M4.0005,12.1362 L11.3565,12.1362 L11.3565,8.0002 L4.0005,8.0002 L4.0005,12.1362 Z M4.0005,32.8452 L11.3565,32.8452 L11.3565,27.4782 L4.0005,27.4782 L4.0005,32.8452 Z M4.0005,18.8402 L11.3565,18.8402 L11.3565,14.1362 L4.0005,14.1362 L4.0005,18.8402 Z M4.0005,25.4782 L11.3565,25.4782 L11.3565,20.8392 L4.0005,20.8392 L4.0005,25.4782 Z M45.9915,6.0002 L45.9915,8.0002 L13.3565,8.0002 L13.3565,41.2032 C13.3565,41.7562 12.9095,42.2032 12.3565,42.2032 L3.0005,42.2032 L3.0005,40.2032 L11.3565,40.2032 L11.3565,34.8452 L4.0005,34.8452 L4.0005,38.8922 L2.0005,38.8922 L2.0005,7.0002 C2.0005,6.4472 2.4475,6.0002 3.0005,6.0002 L45.9915,6.0002 Z M14.6795,42.1652 L45.9915,42.1652 L45.9915,40.1652 L14.6795,40.1652 L14.6795,42.1652 Z M5.4125,11.0302 L6.9525,11.0302 L6.9525,9.0302 L5.4125,9.0302 L5.4125,11.0302 Z M14.6795,11.0302 L45.9915,11.0302 L45.9915,9.0302 L14.6795,9.0302 L14.6795,11.0302 Z" id="AWS-Robo-Maker_Simulation_Resource-Icon_light-bg" fill="#DD344C"></path>
    </g>
</svg>`, TZ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Robotics/Res_AWS-RoboMaker_Fleet-Management_48</title>
    <g id="Icon-Resource/Robotics/Res_AWS-RoboMaker_Fleet-Management_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M33.106,20.963 C32.795,19.913 32.424,18.919 31.99,18.087 C33.456,18.45 34.82,19.117 36.001,20.04 C35.424,20.386 34.652,20.714 33.677,20.88 C33.494,20.912 33.297,20.936 33.106,20.963 M32.272,27.221 L26.504,27.221 C26.593,25.885 26.821,24.45 27.123,23.107 C27.884,23.167 28.673,23.204 29.491,23.204 C30.225,23.204 30.929,23.172 31.616,23.124 C31.935,24.469 32.175,25.9 32.272,27.221 M40.971,27.654 C41.336,27.654 41.633,27.951 41.633,28.316 C41.633,28.681 41.336,28.978 40.971,28.978 C40.606,28.978 40.309,28.681 40.309,28.316 C40.309,27.951 40.606,27.654 40.971,27.654 M31.671,33.418 C30.97,33.368 30.244,33.34 29.491,33.34 C28.66,33.34 27.856,33.378 27.082,33.44 C26.777,32.053 26.553,30.576 26.484,29.221 L32.298,29.221 C32.226,30.556 31.991,32.029 31.671,33.418 M33.677,35.663 C34.726,35.842 35.553,36.207 36.138,36.583 C34.929,37.559 33.515,38.258 31.995,38.635 C32.454,37.758 32.84,36.699 33.161,35.588 C33.334,35.613 33.511,35.635 33.677,35.663 M29.352,38.925 C28.84,38.788 28.162,37.339 27.589,35.408 C28.205,35.368 28.835,35.34 29.491,35.34 C30.053,35.34 30.604,35.361 31.144,35.392 C30.551,37.331 29.854,38.796 29.352,38.925 M24.622,35.793 C24.924,35.728 25.247,35.673 25.577,35.622 C25.877,36.695 26.24,37.718 26.671,38.573 C25.24,38.178 23.916,37.487 22.773,36.555 C23.221,36.255 23.826,35.964 24.622,35.793 M17.921,28.978 C17.556,28.978 17.259,28.681 17.259,28.316 C17.259,27.951 17.556,27.654 17.921,27.654 C18.287,27.654 18.584,27.951 18.584,28.316 C18.584,28.681 18.287,28.978 17.921,28.978 M24.623,20.751 C23.903,20.596 23.333,20.344 22.896,20.075 C24.011,19.193 25.292,18.531 26.67,18.149 C26.263,18.96 25.915,19.919 25.624,20.93 C25.277,20.878 24.94,20.818 24.623,20.751 M29.315,17.791 C29.815,17.921 30.49,19.304 31.075,21.156 C30.556,21.184 30.029,21.204 29.491,21.204 C28.853,21.204 28.238,21.177 27.638,21.139 C28.194,19.294 28.837,17.925 29.315,17.791 M37.498,21.452 C38.105,22.153 38.633,22.93 39.043,23.785 L40.846,22.921 C38.76,18.568 34.296,15.756 29.473,15.756 C24.657,15.756 20.196,18.562 18.108,22.904 L19.911,23.771 C20.312,22.936 20.829,22.178 21.418,21.491 C22.167,22.045 23.134,22.476 24.203,22.706 C24.502,22.77 24.823,22.823 25.145,22.876 C24.806,24.474 24.599,26.034 24.512,27.221 L20.341,27.221 C19.922,26.299 18.998,25.654 17.921,25.654 C16.454,25.654 15.259,26.848 15.259,28.316 C15.259,29.783 16.454,30.978 17.921,30.978 C19.07,30.978 20.042,30.242 20.414,29.221 L24.492,29.221 C24.561,30.391 24.759,32.006 25.104,33.675 C24.796,33.725 24.489,33.776 24.202,33.838 C23.089,34.077 22.085,34.537 21.327,35.124 C20.744,34.424 20.234,33.654 19.841,32.806 L18.027,33.645 C20.083,38.092 24.576,40.966 29.473,40.966 C34.332,40.966 38.809,38.125 40.88,33.729 L39.072,32.877 C38.677,33.713 38.168,34.472 37.585,35.163 C36.648,34.458 35.398,33.927 34.013,33.692 C33.895,33.671 33.77,33.657 33.65,33.639 C34.008,31.971 34.216,30.366 34.29,29.221 L38.478,29.221 C38.851,30.242 39.823,30.978 40.971,30.978 C42.439,30.978 43.633,29.783 43.633,28.316 C43.633,26.848 42.439,25.654 40.971,25.654 C39.894,25.654 38.969,26.299 38.55,27.221 L34.264,27.221 C34.169,26.046 33.95,24.495 33.599,22.902 C33.733,22.882 33.882,22.875 34.013,22.852 C35.353,22.625 36.57,22.122 37.498,21.452 M29.434,44.339 C29.069,44.339 28.772,44.042 28.772,43.677 C28.772,43.312 29.069,43.015 29.434,43.015 C29.799,43.015 30.096,43.312 30.096,43.677 C30.096,44.042 29.799,44.339 29.434,44.339 M29.434,41.015 C28.412,41.015 27.533,41.6 27.087,42.447 C20.192,41.321 15.063,35.354 15.063,28.295 C15.063,23.676 17.308,19.31 21.068,16.616 L19.904,14.99 C15.621,18.059 13.063,23.033 13.063,28.295 C13.063,36.383 18.973,43.213 26.897,44.441 C27.228,45.536 28.233,46.339 29.434,46.339 C30.902,46.339 32.096,45.145 32.096,43.677 C32.096,42.209 30.902,41.015 29.434,41.015 M6.587,33.516 C6.587,33.423 6.664,33.347 6.756,33.347 C6.849,33.347 6.925,33.423 6.925,33.516 C6.925,33.702 6.587,33.702 6.587,33.516 M6.756,31.847 C5.836,31.847 5.087,32.596 5.087,33.516 C5.087,34.436 5.836,35.185 6.756,35.185 C7.676,35.185 8.425,34.436 8.425,33.516 C8.425,32.596 7.676,31.847 6.756,31.847 M6.733,5.627 C6.826,5.627 6.902,5.703 6.902,5.796 C6.902,5.982 6.564,5.982 6.564,5.796 C6.564,5.703 6.64,5.627 6.733,5.627 M6.733,7.464 C7.653,7.464 8.402,6.716 8.402,5.796 C8.402,4.876 7.653,4.127 6.733,4.127 C5.813,4.127 5.064,4.876 5.064,5.796 C5.064,6.716 5.813,7.464 6.733,7.464 M15.562,14.928 C15.562,15.114 15.225,15.114 15.225,14.928 C15.225,14.835 15.3,14.759 15.393,14.759 C15.486,14.759 15.562,14.835 15.562,14.928 M13.725,14.928 C13.725,15.848 14.473,16.597 15.393,16.597 C16.313,16.597 17.062,15.848 17.062,14.928 C17.062,14.007 16.313,13.259 15.393,13.259 C14.473,13.259 13.725,14.007 13.725,14.928 M24.155,5.614 C24.248,5.614 24.324,5.69 24.324,5.783 C24.324,5.968 23.986,5.968 23.986,5.783 C23.986,5.69 24.062,5.614 24.155,5.614 M24.155,7.451 C25.075,7.451 25.824,6.703 25.824,5.783 C25.824,4.862 25.075,4.114 24.155,4.114 C23.235,4.114 22.486,4.862 22.486,5.783 C22.486,6.703 23.235,7.451 24.155,7.451 M33.219,4.715 C33.807,4.715 34.286,5.193 34.286,5.781 C34.286,6.369 33.807,6.848 33.219,6.848 C32.631,6.848 32.153,6.369 32.153,5.781 C32.153,5.193 32.631,4.715 33.219,4.715 M33.219,8.848 C34.91,8.848 36.286,7.472 36.286,5.781 C36.286,4.09 34.91,2.715 33.219,2.715 C31.529,2.715 30.153,4.09 30.153,5.781 C30.153,7.472 31.529,8.848 33.219,8.848 M6.525,25.067 C5.937,25.067 5.459,24.589 5.459,24.001 C5.459,23.413 5.937,22.934 6.525,22.934 C7.113,22.934 7.591,23.413 7.591,24.001 C7.591,24.589 7.113,25.067 6.525,25.067 M6.525,20.934 C4.835,20.934 3.459,22.31 3.459,24.001 C3.459,25.692 4.835,27.067 6.525,27.067 C8.215,27.067 9.591,25.692 9.591,24.001 C9.591,22.31 8.215,20.934 6.525,20.934 M13.298,5.762 C13.298,4.791 14.088,4 15.06,4 C16.032,4 16.822,4.791 16.822,5.762 C16.822,6.733 16.032,7.524 15.06,7.524 C14.088,7.524 13.298,6.733 13.298,5.762 M18.822,5.762 C18.822,3.688 17.134,2 15.06,2 C12.986,2 11.298,3.688 11.298,5.762 C11.298,7.836 12.986,9.524 15.06,9.524 C17.134,9.524 18.822,7.836 18.822,5.762 M6.761,15.916 C5.79,15.916 5,15.126 5,14.154 C5,13.183 5.79,12.393 6.761,12.393 C7.733,12.393 8.523,13.183 8.523,14.154 C8.523,15.126 7.733,15.916 6.761,15.916 M6.761,10.393 C4.687,10.393 3,12.08 3,14.154 C3,16.229 4.687,17.916 6.761,17.916 C8.835,17.916 10.523,16.229 10.523,14.154 C10.523,12.08 8.835,10.393 6.761,10.393 M29.434,13.616 C29.069,13.616 28.772,13.319 28.772,12.954 C28.772,12.589 29.069,12.292 29.434,12.292 C29.799,12.292 30.096,12.589 30.096,12.954 C30.096,13.319 29.799,13.616 29.434,13.616 M31.959,12.15 C31.615,11.077 30.62,10.292 29.434,10.292 C27.966,10.292 26.772,11.486 26.772,12.954 C26.772,14.422 27.966,15.616 29.434,15.616 C30.471,15.616 31.363,15.013 31.801,14.145 C38.698,15.283 43.776,21.18 43.776,28.295 C43.776,32.899 41.544,37.255 37.804,39.949 L38.974,41.572 C43.233,38.503 45.776,33.54 45.776,28.295 C45.776,20.13 39.904,13.376 31.959,12.15" id="AWS-Robo-Maker_Fleet-Management_Resource-Icon_light-bg" fill="#DD344C"></path>
    </g>
</svg>`, SZ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Robotics/Res_AWS-RoboMaker_Development-Environment_48</title>
    <g id="Icon-Resource/Robotics/Res_AWS-RoboMaker_Development-Environment_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M22.2644,35.627 C22.2644,36.263 22.7824,36.78 23.4174,36.78 C24.0534,36.78 24.5714,36.263 24.5714,35.627 C24.5714,34.991 24.0534,34.475 23.4174,34.475 C22.7824,34.475 22.2644,34.991 22.2644,35.627 L22.2644,35.627 Z M23.4174,32.475 C25.1564,32.475 26.5714,33.889 26.5714,35.627 C26.5714,37.365 25.1564,38.78 23.4174,38.78 C21.6794,38.78 20.2644,37.365 20.2644,35.627 C20.2644,33.889 21.6794,32.475 23.4174,32.475 L23.4174,32.475 Z M24.0104,27.459 C23.7564,27.459 23.5494,27.666 23.5494,27.921 C23.5494,28.176 23.7564,28.383 24.0104,28.383 C24.2654,28.383 24.4724,28.176 24.4724,27.921 C24.4724,27.666 24.2654,27.459 24.0104,27.459 L24.0104,27.459 Z M24.0104,26.383 C24.8594,26.383 25.5494,27.073 25.5494,27.921 C25.5494,28.769 24.8594,29.459 24.0104,29.459 C23.1624,29.459 22.4724,28.769 22.4724,27.921 C22.4724,27.073 23.1624,26.383 24.0104,26.383 L24.0104,26.383 Z M36.8934,30.599 L34.4224,33.069 L35.8364,34.483 L36.6004,33.72 L36.6004,40.592 L38.6004,40.592 L38.6004,33.72 L39.3644,34.483 L40.7784,33.069 L38.3074,30.599 C37.9164,30.208 37.2844,30.208 36.8934,30.599 L36.8934,30.599 Z M44.0134,35.65 C44.0134,32.114 41.1364,29.237 37.6004,29.237 C34.0644,29.237 31.1874,32.114 31.1874,35.65 C31.1874,39.187 34.0644,42.064 37.6004,42.064 C41.1364,42.064 44.0134,39.187 44.0134,35.65 L44.0134,35.65 Z M46.0134,35.65 C46.0134,40.289 42.2394,44.064 37.6004,44.064 C32.9614,44.064 29.1874,40.289 29.1874,35.65 C29.1874,31.012 32.9614,27.237 37.6004,27.237 C42.2394,27.237 46.0134,31.012 46.0134,35.65 L46.0134,35.65 Z M19.3264,13.818 L36.3034,13.818 L36.3034,26.162 L38.3034,26.162 L38.3034,12.818 C38.3034,12.266 37.8564,11.818 37.3034,11.818 L18.3264,11.818 C17.7744,11.818 17.3274,12.266 17.3274,12.818 L17.3274,41.284 C17.3274,41.837 17.7744,42.284 18.3264,42.284 L30.1874,42.284 L30.1874,40.284 L19.3264,40.284 L19.3264,13.818 Z M11.5354,29.223 C11.5354,29.562 11.8114,29.838 12.1504,29.838 C12.4894,29.838 12.7654,29.562 12.7654,29.223 C12.7654,28.884 12.4894,28.607 12.1504,28.607 C11.8114,28.607 11.5354,28.884 11.5354,29.223 L11.5354,29.223 Z M9.5354,29.223 C9.5354,27.78 10.7084,26.607 12.1504,26.607 C13.5924,26.607 14.7654,27.78 14.7654,29.223 C14.7654,30.665 13.5924,31.838 12.1504,31.838 C10.7084,31.838 9.5354,30.665 9.5354,29.223 L9.5354,29.223 Z M12.7654,14.15 C12.7654,13.812 12.4894,13.536 12.1504,13.536 C11.8114,13.536 11.5354,13.812 11.5354,14.15 C11.5354,14.489 11.8114,14.766 12.1504,14.766 C12.4894,14.766 12.7654,14.489 12.7654,14.15 L12.7654,14.15 Z M12.1504,16.766 C10.7084,16.766 9.5354,15.593 9.5354,14.15 C9.5354,12.709 10.7084,11.536 12.1504,11.536 C13.5924,11.536 14.7654,12.709 14.7654,14.15 C14.7654,15.593 13.5924,16.766 12.1504,16.766 L12.1504,16.766 Z M26.6074,7.152 C26.6074,7.491 26.8834,7.768 27.2224,7.768 C27.5614,7.768 27.8374,7.491 27.8374,7.152 C27.8374,6.814 27.5614,6.538 27.2224,6.538 C26.8834,6.538 26.6074,6.814 26.6074,7.152 L26.6074,7.152 Z M24.6074,7.152 C24.6074,5.711 25.7804,4.538 27.2224,4.538 C28.6644,4.538 29.8374,5.711 29.8374,7.152 C29.8374,8.595 28.6644,9.768 27.2224,9.768 C25.7804,9.768 24.6074,8.595 24.6074,7.152 L24.6074,7.152 Z M4.6914,7.152 C4.6914,7.407 4.8984,7.614 5.1534,7.614 C5.4074,7.614 5.6144,7.407 5.6144,7.152 C5.6144,6.898 5.4074,6.691 5.1534,6.691 C4.8984,6.691 4.6914,6.898 4.6914,7.152 L4.6914,7.152 Z M3.6144,7.152 C3.6144,6.305 4.3044,5.614 5.1534,5.614 C6.0004,5.614 6.6914,6.305 6.6914,7.152 C6.6914,8.001 6.0004,8.691 5.1534,8.691 C4.3044,8.691 3.6144,8.001 3.6144,7.152 L3.6144,7.152 Z M5.6144,36.221 C5.6144,35.966 5.4074,35.759 5.1534,35.759 C4.8984,35.759 4.6914,35.966 4.6914,36.221 C4.6914,36.475 4.8984,36.682 5.1534,36.682 C5.4074,36.682 5.6144,36.475 5.6144,36.221 L5.6144,36.221 Z M6.6914,36.221 C6.6914,37.068 6.0004,37.759 5.1534,37.759 C4.3044,37.759 3.6144,37.068 3.6144,36.221 C3.6144,35.372 4.3044,34.682 5.1534,34.682 C6.0004,34.682 6.6914,35.372 6.6914,36.221 L6.6914,36.221 Z M12.1504,21.225 C11.8954,21.225 11.6884,21.432 11.6884,21.687 C11.6884,21.941 11.8954,22.148 12.1504,22.148 C12.4054,22.148 12.6124,21.941 12.6124,21.687 C12.6124,21.432 12.4054,21.225 12.1504,21.225 L12.1504,21.225 Z M12.1504,20.148 C12.9974,20.148 13.6884,20.839 13.6884,21.687 C13.6884,22.534 12.9974,23.225 12.1504,23.225 C11.3024,23.225 10.6124,22.534 10.6124,21.687 C10.6124,20.839 11.3024,20.148 12.1504,20.148 L12.1504,20.148 Z M5.6144,29.223 C5.6144,28.968 5.4074,28.761 5.1534,28.761 C4.8984,28.761 4.6914,28.968 4.6914,29.223 C4.6914,29.478 4.8984,29.685 5.1534,29.685 C5.4074,29.685 5.6144,29.478 5.6144,29.223 L5.6144,29.223 Z M6.6914,29.223 C6.6914,30.07 6.0004,30.761 5.1534,30.761 C4.3044,30.761 3.6144,30.07 3.6144,29.223 C3.6144,28.375 4.3044,27.685 5.1534,27.685 C6.0004,27.685 6.6914,28.375 6.6914,29.223 L6.6914,29.223 Z M19.2244,7.152 C19.2244,7.407 19.4314,7.614 19.6864,7.614 C19.9414,7.614 20.1484,7.407 20.1484,7.152 C20.1484,6.898 19.9414,6.691 19.6864,6.691 C19.4314,6.691 19.2244,6.898 19.2244,7.152 L19.2244,7.152 Z M18.1484,7.152 C18.1484,6.305 18.8384,5.614 19.6864,5.614 C20.5344,5.614 21.2244,6.305 21.2244,7.152 C21.2244,8.001 20.5344,8.691 19.6864,8.691 C18.8384,8.691 18.1484,8.001 18.1484,7.152 L18.1484,7.152 Z M33.6264,17.67 C33.3724,17.67 33.1654,17.877 33.1654,18.132 C33.1654,18.387 33.3724,18.594 33.6264,18.594 C33.8814,18.594 34.0884,18.387 34.0884,18.132 C34.0884,17.877 33.8814,17.67 33.6264,17.67 L33.6264,17.67 Z M33.6264,16.594 C34.4754,16.594 35.1654,17.284 35.1654,18.132 C35.1654,18.98 34.4754,19.67 33.6264,19.67 C32.7794,19.67 32.0884,18.98 32.0884,18.132 C32.0884,17.284 32.7794,16.594 33.6264,16.594 L33.6264,16.594 Z M33.7584,7.152 C33.7584,7.407 33.9654,7.614 34.2204,7.614 C34.4754,7.614 34.6824,7.407 34.6824,7.152 C34.6824,6.898 34.4754,6.691 34.2204,6.691 C33.9654,6.691 33.7584,6.898 33.7584,7.152 L33.7584,7.152 Z M32.6824,7.152 C32.6824,6.305 33.3724,5.614 34.2204,5.614 C35.0684,5.614 35.7584,6.305 35.7584,7.152 C35.7584,8.001 35.0684,8.691 34.2204,8.691 C33.3724,8.691 32.6824,8.001 32.6824,7.152 L32.6824,7.152 Z M6.3054,14.15 C6.3054,13.515 5.7884,12.997 5.1534,12.997 C4.5174,12.997 3.9994,13.515 3.9994,14.15 C3.9994,14.786 4.5174,15.304 5.1534,15.304 C5.7884,15.304 6.3054,14.786 6.3054,14.15 L6.3054,14.15 Z M8.3054,14.15 C8.3054,15.889 6.8914,17.304 5.1534,17.304 C3.4144,17.304 1.9994,15.889 1.9994,14.15 C1.9994,12.412 3.4144,10.997 5.1534,10.997 C6.8914,10.997 8.3054,12.412 8.3054,14.15 L8.3054,14.15 Z M6.3054,21.687 C6.3054,21.051 5.7884,20.533 5.1534,20.533 C4.5174,20.533 3.9994,21.051 3.9994,21.687 C3.9994,22.322 4.5174,22.84 5.1534,22.84 C5.7884,22.84 6.3054,22.322 6.3054,21.687 L6.3054,21.687 Z M8.3054,21.687 C8.3054,23.425 6.8914,24.84 5.1534,24.84 C3.4144,24.84 1.9994,23.425 1.9994,21.687 C1.9994,19.948 3.4144,18.533 5.1534,18.533 C6.8914,18.533 8.3054,19.948 8.3054,21.687 L8.3054,21.687 Z M13.3034,36.221 C13.3034,35.585 12.7854,35.067 12.1504,35.067 C11.5144,35.067 10.9964,35.585 10.9964,36.221 C10.9964,36.856 11.5144,37.373 12.1504,37.373 C12.7854,37.373 13.3034,36.856 13.3034,36.221 L13.3034,36.221 Z M15.3034,36.221 C15.3034,37.959 13.8884,39.373 12.1504,39.373 C10.4114,39.373 8.9964,37.959 8.9964,36.221 C8.9964,34.482 10.4114,33.067 12.1504,33.067 C13.8884,33.067 15.3034,34.482 15.3034,36.221 L15.3034,36.221 Z M13.3034,7.152 C13.3034,6.517 12.7854,6 12.1504,6 C11.5144,6 10.9964,6.517 10.9964,7.152 C10.9964,7.788 11.5144,8.306 12.1504,8.306 C12.7854,8.306 13.3034,7.788 13.3034,7.152 L13.3034,7.152 Z M15.3034,7.152 C15.3034,8.891 13.8884,10.306 12.1504,10.306 C10.4114,10.306 8.9964,8.891 8.9964,7.152 C8.9964,5.414 10.4114,4 12.1504,4 C13.8884,4 15.3034,5.414 15.3034,7.152 L15.3034,7.152 Z M26.0564,24.071 L31.3164,24.071 L31.3164,22.071 L26.0564,22.071 L26.0564,24.071 Z M21.8274,22.061 L24.1644,19.724 L21.8274,17.388 L23.2424,15.974 L26.2854,19.017 C26.4734,19.204 26.5784,19.458 26.5784,19.724 C26.5784,19.989 26.4734,20.243 26.2854,20.431 L23.2424,23.475 L21.8274,22.061 Z" id="AWS-Robo-Maker_Development-environment_Resource-Icon_light-bg" fill="#DD344C"></path>
    </g>
</svg>`, bZ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Front-End-Web-Mobile/Res_AWS-Amplify_AWS-Amplify-Studio_48</title>
    <g id="Icon-Resource/Front-End-Web-Mobile/Res_AWS-Amplify_AWS-Amplify-Studio_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M6,11 L31,11 L31,9 L6,9 L6,11 Z M33,11 L41,11 L41,9 L33,9 L33,11 Z M14.213,27.861 C15.425,27.499 16.784,27.915 17.565,28.99 L20.365,32.868 C20.687,33.316 21.312,33.418 21.761,33.094 C22.209,32.771 22.31,32.146 21.986,31.697 L19.194,27.829 C19.191,27.825 19.188,27.821 19.186,27.817 L11.152,16.688 C10.821,16.228 10.925,15.584 11.385,15.251 C11.846,14.918 12.49,15.024 12.822,15.484 L16.806,21.003 C16.812,21.013 16.82,21.024 16.828,21.035 L21.138,27.006 C21.46,27.452 22.086,27.555 22.533,27.231 C22.981,26.908 23.082,26.283 22.759,25.835 L18.437,19.845 C18.121,19.387 18.229,18.755 18.682,18.427 C19.141,18.097 19.787,18.199 20.119,18.659 L21.079,19.99 C21.089,20.004 21.098,20.017 21.107,20.03 L24.428,24.631 C24.751,25.077 25.376,25.18 25.823,24.856 C26.271,24.533 26.372,23.908 26.049,23.46 L22.713,18.837 C22.563,18.618 22.505,18.355 22.547,18.093 C22.591,17.821 22.738,17.583 22.961,17.422 C23.186,17.262 23.458,17.199 23.728,17.241 C23.998,17.285 24.236,17.432 24.397,17.655 L25.708,19.471 C25.712,19.476 25.715,19.48 25.718,19.484 L28.335,23.11 C28.657,23.557 29.283,23.659 29.73,23.335 C30.179,23.012 30.279,22.386 29.956,21.939 L27.334,18.305 C27.009,17.845 27.114,17.206 27.571,16.876 C27.796,16.716 28.068,16.653 28.338,16.695 C28.608,16.739 28.847,16.886 29.008,17.109 L32.915,22.52 C32.934,22.549 34.789,25.444 35.261,27.381 C35.705,29.204 38.284,33.227 39.459,34.998 L30.423,41.521 C29.581,40.479 27.889,38.891 25.199,38.517 C22.293,38.114 20.299,36.189 20.019,35.906 L14.213,27.861 Z M30.771,43.736 L41.413,36.054 C41.853,35.737 41.96,35.127 41.654,34.679 C40.549,33.06 37.594,28.507 37.204,26.907 C36.652,24.642 34.68,21.566 34.566,21.393 L30.63,15.939 C30.156,15.282 29.456,14.85 28.657,14.721 C27.855,14.592 27.057,14.781 26.401,15.255 C26.092,15.478 25.837,15.749 25.64,16.051 C25.203,15.638 24.653,15.365 24.047,15.267 C23.245,15.137 22.446,15.327 21.791,15.8 C21.442,16.052 21.156,16.368 20.945,16.729 C19.926,16.062 18.555,16.052 17.512,16.806 C17.219,17.017 16.975,17.272 16.782,17.554 L14.443,14.313 C13.465,12.958 11.565,12.652 10.215,13.63 C8.86,14.608 8.554,16.504 9.531,17.859 L15.217,25.736 C14.125,25.689 13.063,26.017 12.134,26.688 C11.919,26.843 11.773,27.078 11.731,27.34 C11.689,27.601 11.753,27.869 11.908,28.084 L18.438,37.133 C18.461,37.165 18.486,37.196 18.513,37.225 C18.615,37.336 21.068,39.964 24.924,40.499 C27.896,40.911 29.252,43.303 29.306,43.401 C29.442,43.654 29.682,43.836 29.962,43.9 C30.036,43.917 30.111,43.925 30.186,43.925 C30.394,43.925 30.599,43.86 30.771,43.736 L30.771,43.736 Z M45,18 L35,18 L35,16 L44,16 L44,6 L4,5.925 L4,16 L7,16 L7,18 L3,18 C2.447,18 2,17.552 2,17 L2,5 C2,4.447 2.447,4 3,4 L45,4 C45.553,4 46,4.447 46,5 L46,17 C46,17.552 45.553,18 45,18 L45,18 Z" id="Fill-1" fill="#DD344C"></path>
    </g>
</svg>`, EZ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Front-End-Web-Mobile/Res_Amazon-Location-Service_Map _48</title>
    <g id="Icon-Resource/Front-End-Web-Mobile/Res_Amazon-Location-Service_Map-_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M42.2059363,24.7523015 L32.1979363,22.2503015 L34.8669363,4.4583015 L43.9999363,8.6103015 L42.2059363,24.7523015 Z M33.9949363,41.1993015 L32.2189363,24.3163015 L42.1529363,26.8003015 L43.9299363,43.6833015 L33.9949363,41.1993015 Z M6.90593629,24.1393015 L17.9839363,25.8443015 L16.1899363,43.7883015 L4.20993629,41.2203015 L6.90593629,24.1393015 Z M4.22093629,4.3833015 L17.1159363,7.7813015 L18.0069363,23.8243015 L6.95093629,22.1233015 L4.22093629,4.3833015 Z M30.1919363,22.1333015 L20.0109363,23.8303015 L19.1179363,7.7693015 L32.8619363,4.3333015 L30.1919363,22.1333015 Z M19.9929363,25.8603015 L30.1909363,24.1603015 L31.9829363,41.1873015 L18.2019363,43.7713015 L19.9929363,25.8603015 Z M46.0679363,8.1103015 C46.1159363,7.6803015 45.8819363,7.2683015 45.4879363,7.0893015 L34.4879363,2.0893015 C34.2819363,1.9963015 34.0499363,1.9753015 33.8319363,2.0293015 L18.0809363,5.9673015 L3.25493629,2.0613015 C2.93093629,1.9743015 2.58093629,2.0593015 2.33093629,2.2853015 C2.07993629,2.5103015 1.95993629,2.8473015 2.01193629,3.1803015 L5.06193629,22.9983015 L2.08693629,41.8443015 C2.00393629,42.3683015 2.34593629,42.8663015 2.86393629,42.9783015 L16.8639363,45.9783015 C16.9929363,46.0053015 17.1259363,46.0063015 17.2589363,45.9823015 L33.0439363,43.0233015 L44.8319363,45.9703015 C44.9119363,45.9903015 44.9929363,46.0003015 45.0739363,46.0003015 C45.3119363,46.0003015 45.5459363,45.9143015 45.7299363,45.7543015 C45.9769363,45.5413015 46.1019363,45.2193015 46.0679363,44.8953015 L44.0799363,26.0023015 L46.0679363,8.1103015 Z" id="Fill-1" fill="#DD344C"></path>
    </g>
</svg>`, IZ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Front-End-Web-Mobile/Res_Amazon-Location-Service_Place_48</title>
    <g id="Icon-Resource/Front-End-Web-Mobile/Res_Amazon-Location-Service_Place_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M24,4 C15.729,4 9,9.832 9,17 C9,22.726 13.427,27.853 19.766,29.468 C20.819,29.736 21.635,30.581 21.892,31.672 L24,40.634 L26.108,31.672 C26.365,30.581 27.181,29.736 28.235,29.468 C34.573,27.853 39,22.726 39,17 C39,9.832 32.271,4 24,4 M24,46 C23.536,46 23.133,45.681 23.026,45.229 L19.944,32.13 C19.86,31.773 19.597,31.489 19.272,31.407 C12.046,29.565 7,23.641 7,17 C7,8.729 14.626,2 24,2 C33.374,2 41,8.729 41,17 C41,23.641 35.954,29.564 28.729,31.407 C28.403,31.489 28.14,31.773 28.056,32.13 L24.974,45.229 C24.867,45.681 24.464,46 24,46 M24,12 C21.243,12 19,14.243 19,17 C19,19.757 21.243,22 24,22 C26.757,22 29,19.757 29,17 C29,14.243 26.757,12 24,12 M24,24 C20.141,24 17,20.86 17,17 C17,13.14 20.141,10 24,10 C27.859,10 31,13.14 31,17 C31,20.86 27.859,24 24,24" id="Fill-1" fill="#DD344C"></path>
    </g>
</svg>`, FZ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Front-End-Web-Mobile/Res_Amazon-Location-Service_Track _48</title>
    <g id="Icon-Resource/Front-End-Web-Mobile/Res_Amazon-Location-Service_Track-_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M42,24 C40.897,24 40,23.103 40,22 C40,20.897 40.897,20 42,20 C43.103,20 44,20.897 44,22 C44,23.103 43.103,24 42,24 M30,37 C28.897,37 28,36.103 28,35 C28,33.897 28.897,33 30,33 C31.103,33 32,33.897 32,35 C32,36.103 31.103,37 30,37 M20,27 C20,25.897 20.897,25 22,25 C23.103,25 24,25.897 24,27 C24,28.103 23.103,29 22,29 C20.897,29 20,28.103 20,27 M6,44 C4.897,44 4,43.103 4,42 C4,40.897 4.897,40 6,40 C7.103,40 8,40.897 8,42 C8,43.103 7.103,44 6,44 M23,6 C23,4.897 23.897,4 25,4 C26.103,4 27,4.897 27,6 C27,7.103 26.103,8 25,8 C23.897,8 23,7.103 23,6 M6,8 C4.897,8 4,7.103 4,6 C4,4.897 4.897,4 6,4 C7.103,4 8,4.897 8,6 C8,7.103 7.103,8 6,8 M42,18 C40.998,18 40.093,18.383 39.391,18.993 L28.34,8.19 C28.755,7.561 29,6.809 29,6 C29,3.794 27.206,2 25,2 C23.142,2 21.589,3.28 21.142,5 L9.858,5 C9.411,3.28 7.858,2 6,2 C3.794,2 2,3.794 2,6 C2,8.206 3.794,10 6,10 C7.858,10 9.411,8.72 9.858,7 L21.142,7 C21.589,8.72 23.142,10 25,10 C25.67,10 26.291,9.819 26.847,9.527 L38.245,20.669 C38.096,21.088 38,21.531 38,22 C38,22.792 38.238,23.526 38.637,24.147 L31.845,31.472 C31.29,31.181 30.669,31 30,31 C29.15,31 28.366,31.27 27.718,31.723 L25.092,29.506 C25.651,28.818 26,27.953 26,27 C26,24.794 24.206,23 22,23 C19.794,23 18,24.794 18,27 C18,27.661 18.177,28.275 18.461,28.825 L8.05,38.583 C7.448,38.221 6.752,38 6,38 C3.794,38 2,39.794 2,42 C2,44.206 3.794,46 6,46 C8.206,46 10,44.206 10,42 C10,41.273 9.79,40.6 9.45,40.011 L19.783,30.326 C20.419,30.75 21.181,31 22,31 C22.507,31 22.986,30.896 23.433,30.723 L26.422,33.247 C26.16,33.779 26,34.369 26,35 C26,37.206 27.794,39 30,39 C32.206,39 34,37.206 34,35 C34,34.189 33.754,33.436 33.337,32.804 L40.108,25.502 C40.674,25.81 41.313,26 42,26 C44.206,26 46,24.206 46,22 C46,19.794 44.206,18 42,18" id="Fill-1" fill="#DD344C"></path>
    </g>
</svg>`, OZ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Front-End-Web-Mobile/Res_Amazon-Location-Service_Geofence_48</title>
    <g id="Icon-Resource/Front-End-Web-Mobile/Res_Amazon-Location-Service_Geofence_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M42.0827316,24.0408067 L33.4677316,24.4158067 L29.9577316,12.7148067 C29.8167316,12.2448067 29.3517316,11.9538067 28.8707316,12.0098067 L21.6217316,12.9558067 L21.9567316,5.9258067 L43.8957316,4.0968067 L42.0827316,24.0408067 Z M21.5247316,14.9848067 L28.2857316,14.1028067 L31.4067316,24.5048067 L21.0507316,24.9548067 L21.5247316,14.9848067 Z M33.8487316,32.6428067 L19.7287316,43.9378067 L4.1017316,41.1808067 L6.9037316,16.8928067 L19.5107316,15.2478067 L19.0007316,25.9548067 C18.9867316,26.2348067 19.0927316,26.5078067 19.2907316,26.7078067 C19.4787316,26.8958067 19.7337316,27.0018067 19.9997316,27.0018067 C20.0147316,27.0018067 20.0287316,27.0008067 20.0427316,27.0008067 L31.9997316,26.4808067 L33.8487316,32.6428067 Z M45.7097316,2.2968067 C45.5017316,2.0868067 45.2087316,1.9748067 44.9167316,2.0048067 L20.9167316,4.0048067 C20.4167316,4.0468067 20.0247316,4.4528067 20.0007316,4.9548067 L19.6067316,13.2188067 L5.8707316,15.0098067 C5.4147316,15.0698067 5.0597316,15.4308067 5.0067316,15.8868067 L2.0067316,41.8868067 C1.9457316,42.4128067 2.3057316,42.8948067 2.8257316,42.9868067 L19.8257316,45.9868067 C19.8837316,45.9968067 19.9417316,46.0018067 19.9997316,46.0018067 C20.2257316,46.0018067 20.4457316,45.9258067 20.6247316,45.7828067 L35.6247316,33.7828067 C35.9427316,33.5278067 36.0747316,33.1048067 35.9577316,32.7148067 L34.0607316,26.3918067 L43.0427316,26.0008067 C43.5437316,25.9788067 43.9497316,25.5908067 43.9957316,25.0918067 L45.9957316,3.0918067 C46.0217316,2.7978067 45.9177316,2.5068067 45.7097316,2.2968067 L45.7097316,2.2968067 Z" id="Fill-1" fill="#DD344C"></path>
    </g>
</svg>`, NZ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Front-End-Web-Mobile/Res_Amazon-Location-Service_Routes_48</title>
    <g id="Icon-Resource/Front-End-Web-Mobile/Res_Amazon-Location-Service_Routes_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M14.293,7 L17.793,7 L17.793,5 L14.293,5 L14.293,7 Z M19.793,7 L23.293,7 L23.293,5 L19.793,5 L19.793,7 Z M32.352,14.813 L33.768,13.4 L36.24,15.877 L34.824,17.291 L32.352,14.813 Z M25.142,7.587 C25.018,7.462 24.877,7.355 24.725,7.268 L25.719,5.532 C26.025,5.708 26.308,5.924 26.558,6.175 L28.47,8.091 L27.054,9.503 L25.142,7.587 Z M28.467,10.919 L29.883,9.506 L32.355,11.984 L30.939,13.397 L28.467,10.919 Z M13.148,33.778 L14.539,35.216 L12.382,37.301 L10.991,35.862 L13.148,33.778 Z M29.253,33.532 C29.312,33.586 29.379,33.635 29.45,33.674 L28.483,35.424 C28.272,35.308 28.075,35.166 27.897,35.002 L26.048,33.294 L27.405,31.825 L29.253,33.532 Z M19.112,28.017 C19.734,27.415 20.597,27.113 21.453,27.186 L21.285,29.179 C20.957,29.174 20.689,29.274 20.502,29.455 L19.572,30.353 L18.184,28.914 L19.112,28.017 Z M23.732,28.433 L25.937,30.468 L24.579,31.937 L22.375,29.902 L23.732,28.433 Z M16.746,30.304 L18.135,31.742 L15.977,33.827 L14.588,32.388 L16.746,30.304 Z M6,44 C4.897,44 4,43.103 4,42 C4,40.897 4.897,40 6,40 C7.103,40 8,40.897 8,42 C8,43.103 7.103,44 6,44 L6,44 Z M9.553,37.252 L8.13,38.627 C7.512,38.235 6.784,38 6,38 C3.794,38 2,39.794 2,42 C2,44.206 3.794,46 6,46 C8.206,46 10,44.206 10,42 C10,41.305 9.807,40.661 9.493,40.091 L10.943,38.69 L9.553,37.252 Z M32.179,31.729 L33.69,33.039 L32.199,34.761 C31.96,35.036 31.679,35.263 31.36,35.435 L30.407,33.677 C30.513,33.62 30.607,33.543 30.688,33.451 L32.179,31.729 Z M35.452,27.949 L36.964,29.258 L35,31.526 L33.488,30.217 L35.452,27.949 Z M6,4 C7.103,4 8,4.897 8,6 C8,7.103 7.103,8 6,8 C4.897,8 4,7.103 4,6 C4,4.897 4.897,4 6,4 L6,4 Z M6,10 C7.858,10 9.411,8.72 9.858,7 L12.293,7 L12.293,5 L9.858,5 C9.411,3.28 7.858,2 6,2 C3.794,2 2,3.794 2,6 C2,8.206 3.794,10 6,10 L6,10 Z M42,24 C40.897,24 40,23.103 40,22 C40,20.897 40.897,20 42,20 C43.103,20 44,20.897 44,22 C44,23.103 43.103,24 42,24 L42,24 Z M42,18 C40.988,18 40.073,18.39 39.368,19.012 L37.652,17.293 L36.236,18.706 L38.233,20.707 C38.093,21.115 38,21.545 38,22 C38,22.822 38.25,23.587 38.678,24.223 L36.761,26.437 L38.272,27.747 L40.182,25.542 C40.729,25.825 41.342,26 42,26 C44.206,26 46,24.206 46,22 C46,19.794 44.206,18 42,18 L42,18 Z" id="Fill-1" fill="#DD344C"></path>
    </g>
</svg>`, DZ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Developer-Tools/Res_AWS-Cloud9_Cloud9_48</title>
    <g id="Icon-Resource/Developer-Tools/Res_AWS-Cloud9_Cloud9_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M37.8624,36.1201 L9.1094,36.1201 C8.3834,36.1191 7.8134,35.9821 7.3714,35.7031 C5.8334,34.7321 4.0004,32.8631 4.0004,29.4741 C4.0004,24.9681 7.1344,23.4891 9.0044,23.0101 C9.4664,22.8911 9.7814,22.4601 9.7534,21.9821 L9.6764,20.7151 C9.6764,17.0881 12.1734,13.1851 15.3594,11.8331 C16.7954,11.2231 18.1214,10.9801 19.3234,10.9801 C22.7444,10.9801 25.1594,12.9431 26.2144,14.0051 C27.3774,15.1751 28.2854,16.6721 28.9144,18.4561 C29.0374,18.8051 29.3434,19.0581 29.7104,19.1121 C30.0824,19.1631 30.4424,19.0151 30.6624,18.7161 C31.5724,17.4811 33.1384,16.9691 34.5574,17.4321 C36.1714,17.9621 37.0954,19.5611 37.0934,21.7591 C37.0134,22.2961 37.3784,22.8001 37.9134,22.8911 C39.7434,23.2071 44.0004,24.4841 44.0004,29.5391 C44.0004,35.4021 38.3984,36.0701 37.8624,36.1201 L37.8624,36.1201 Z M39.0684,21.0921 C38.8574,18.3251 37.4384,16.2731 35.1814,15.5321 C33.4674,14.9681 31.6264,15.3051 30.2164,16.3571 C29.5424,14.9061 28.6754,13.6441 27.6324,12.5951 C24.0664,9.0071 19.1854,8.0371 14.5784,9.9911 C10.6434,11.6621 7.6764,16.2721 7.6784,20.7731 L7.7104,21.3121 C5.5324,22.0691 2.0004,24.1221 2.0004,29.4741 C2.0004,34.0011 4.6964,36.3801 6.3024,37.3941 C7.0744,37.8821 7.9924,38.1191 9.1084,38.1201 L37.9054,38.1201 C37.9294,38.1201 37.9544,38.1191 37.9784,38.1171 C40.7534,37.9151 46.0004,35.8611 46.0004,29.5391 C46.0004,24.5571 42.5564,21.9571 39.0684,21.0921 L39.0684,21.0921 Z M26.7794,26.0371 C26.3524,26.2761 25.8834,26.4641 25.3704,26.5971 C24.8564,26.7301 24.3464,26.7971 23.8404,26.7971 C22.9604,26.7971 22.2934,26.5541 21.8404,26.0661 C21.3854,25.5801 21.1594,24.8701 21.1594,23.9361 C21.1594,23.0571 21.3964,22.3531 21.8704,21.8261 C22.3424,21.3001 22.9724,21.0371 23.7594,21.0371 C25.7324,21.0371 26.7394,22.6101 26.7794,25.7571 L26.7794,26.0371 Z M23.7994,19.3961 C22.8804,19.3961 22.0664,19.5991 21.3594,20.0071 C20.6524,20.4131 20.1094,20.9671 19.7294,21.6671 C19.3494,22.3661 19.1594,23.1631 19.1594,24.0571 C19.1594,25.4031 19.5364,26.4641 20.2904,27.2361 C21.0434,28.0101 22.0664,28.3961 23.3594,28.3961 C23.9724,28.3961 24.5734,28.3071 25.1594,28.1271 C25.7464,27.9461 26.2794,27.6961 26.7594,27.3771 C26.6664,29.0301 26.2904,30.2501 25.6304,31.0371 C24.9694,31.8231 24.0004,32.2171 22.7194,32.2171 C21.8004,32.2171 20.7934,31.9701 19.6994,31.4761 L19.6994,32.9971 C20.5804,33.5691 21.6794,33.8561 23.0004,33.8561 C24.8404,33.8561 26.2594,33.1831 27.2594,31.8371 C28.2594,30.4901 28.7594,28.5631 28.7594,26.0571 C28.7594,23.8841 28.3364,22.2301 27.4894,21.0971 C26.6424,19.9641 25.4134,19.3961 23.7994,19.3961 L23.7994,19.3961 Z" id="AWS_AWS-Cloud9_Resource-Icon_light-bg" fill="#C925D1"></path>
    </g>
</svg>`, PZ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Business-Applications/Res_Amazon-Simple-Email-Service_Email_48</title>
    <g id="Icon-Resource/Business-Applications/Res_Amazon-Simple-Email-Service_Email_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M10.3032,14.3134 C10.2782,14.4964 10.2652,14.7174 10.2652,14.9744 L10.2652,15.1304 C10.2652,15.1854 10.2722,15.2434 10.2842,15.3044 C10.0022,15.6104 9.6842,15.7644 9.3282,15.7644 C8.7162,15.7644 8.4102,15.1394 8.4102,13.8904 C8.4102,12.8374 8.5612,11.9674 8.8612,11.2814 C9.1602,10.5964 9.5312,10.2524 9.9722,10.2524 C10.2172,10.2524 10.4982,10.3634 10.8172,10.5844 L10.3032,14.3134 Z M5.2692,20.1734 C6.1752,20.7244 7.2652,21.0004 8.5382,21.0004 C9.5802,21.0004 10.5102,20.7914 11.3312,20.3754 L11.3312,18.7584 C10.4372,19.0884 9.5802,19.2544 8.7592,19.2544 C7.4122,19.2544 6.3742,18.8164 5.6462,17.9404 C4.9162,17.0664 4.5532,15.7944 4.5532,14.1294 C4.5532,12.7464 4.7912,11.4994 5.2692,10.3914 C5.7462,9.2824 6.4262,8.3974 7.3092,7.7364 C8.1902,7.0754 9.1822,6.7454 10.2842,6.7454 C11.7052,6.7454 12.7852,7.1464 13.5272,7.9474 C14.2672,8.7504 14.6382,9.9224 14.6382,11.4654 C14.6382,12.2124 14.5552,12.9114 14.3892,13.5604 C14.2252,14.2094 13.9912,14.7444 13.6922,15.1674 C13.3922,15.5894 13.0762,15.8014 12.7452,15.8014 C12.5742,15.8014 12.4402,15.7364 12.3422,15.6084 C12.2432,15.4804 12.1952,15.3044 12.1952,15.0844 C12.1952,14.8894 12.2062,14.7174 12.2322,14.5704 L13.0212,8.8574 L11.3132,8.8574 L11.0932,9.5004 C10.6392,8.8884 10.0822,8.5824 9.4202,8.5824 C8.8822,8.5824 8.3652,8.8174 7.8682,9.2894 C7.3722,9.7614 6.9652,10.4214 6.6472,11.2724 C6.3282,12.1254 6.1692,13.0634 6.1692,14.0924 C6.1692,15.1704 6.3652,15.9974 6.7572,16.5724 C7.1492,17.1484 7.7242,17.4364 8.4842,17.4364 C8.8392,17.4364 9.2092,17.3444 9.5962,17.1614 C9.9812,16.9774 10.3212,16.7264 10.6152,16.4074 C10.8102,16.7264 11.0742,16.9704 11.4052,17.1414 C11.7352,17.3134 12.1152,17.3994 12.5432,17.3994 C13.2662,17.3994 13.9302,17.1544 14.5372,16.6644 C15.1432,16.1744 15.6232,15.4774 15.9792,14.5704 C16.3342,13.6644 16.5122,12.6234 16.5122,11.4474 C16.5122,10.1124 16.2732,8.9644 15.7952,8.0034 C15.3172,7.0424 14.6162,6.3014 13.6922,5.7804 C12.7672,5.2594 11.6562,5.0004 10.3582,5.0004 C8.9252,5.0004 7.6112,5.3784 6.4172,6.1394 C5.2242,6.8974 4.2712,7.9724 3.5612,9.3624 C2.8502,10.7524 2.4952,12.3544 2.4952,14.1664 C2.4952,15.5874 2.7312,16.8054 3.2022,17.8214 C3.6742,18.8384 4.3632,19.6224 5.2692,20.1734 L5.2692,20.1734 Z M23.3542,31.9804 C23.5392,32.1344 23.7672,32.2114 23.9942,32.2114 C24.2222,32.2114 24.4492,32.1344 24.6352,31.9804 L27.6682,29.4534 L42.2252,41.5844 L5.7632,41.5844 L20.3222,29.4524 L23.3542,31.9804 Z M29.2312,28.1504 L43.9892,15.8524 L43.9892,40.4484 L29.2312,28.1504 Z M44.9892,12.7164 L18.5452,12.7164 L18.5452,14.7164 L42.2252,14.7164 L23.9942,29.9104 L13.3682,21.0494 L12.0872,22.5844 L18.7592,28.1494 L4.0002,40.4484 L4.0002,22.0704 L2.0002,22.0704 L2.0002,42.5844 C2.0002,43.1364 2.4482,43.5844 3.0002,43.5844 L44.9892,43.5844 C45.5412,43.5844 45.9892,43.1364 45.9892,42.5844 L45.9892,13.7164 C45.9892,13.1644 45.5412,12.7164 44.9892,12.7164 L44.9892,12.7164 Z" id="Amazon-Amazon-Simple-Email-Service-Email_Resource-Icon_light-bg" fill="#DD344C"></path>
    </g>
</svg>`, BZ = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon-Resource/Business-Applications/Res_Amazon-Pinpoint_Journey_48</title>
    <g id="Icon-Resource/Business-Applications/Res_Amazon-Pinpoint_Journey_48" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M42.96,21 C42.96,19.897 42.063,19 40.96,19 C39.857,19 38.96,19.897 38.96,21 C38.96,22.103 39.857,23 40.96,23 C42.063,23 42.96,22.103 42.96,21 L42.96,21 Z M37.96,37 C37.96,35.897 37.063,35 35.96,35 C34.857,35 33.96,35.897 33.96,37 C33.96,38.103 34.857,39 35.96,39 C37.063,39 37.96,38.103 37.96,37 L37.96,37 Z M28.96,20.5 C28.96,19.122 27.839,18 26.46,18 C25.081,18 23.96,19.122 23.96,20.5 C23.96,21.878 25.081,23 26.46,23 C27.839,23 28.96,21.878 28.96,20.5 L28.96,20.5 Z M18.131,30.008 L14.522,33.609 L13.109,32.193 L16.65,28.661 C15.994,28.283 15.244,28.05 14.435,28.05 C11.967,28.05 9.96,30.057 9.96,32.525 C9.96,34.993 11.967,37 14.435,37 C16.902,37 18.91,34.993 18.91,32.525 C18.91,31.592 18.622,30.726 18.131,30.008 L18.131,30.008 Z M21.46,10 C22.839,10 23.96,8.878 23.96,7.5 C23.96,6.122 22.839,5 21.46,5 C20.081,5 18.96,6.122 18.96,7.5 C18.96,8.878 20.081,10 21.46,10 L21.46,10 Z M44.96,21 C44.96,23.206 43.166,25 40.96,25 C40.911,25 40.866,24.987 40.817,24.985 L38.149,33.659 C39.237,34.375 39.96,35.603 39.96,37 C39.96,39.206 38.166,41 35.96,41 C33.754,41 31.96,39.206 31.96,37 C31.96,34.794 33.754,33 35.96,33 C36.06,33 36.152,33.022 36.25,33.029 L38.901,24.412 C38.035,23.887 37.392,23.048 37.117,22.05 L30.668,22.05 C30.033,23.767 28.395,25 26.46,25 C25.523,25 24.654,24.711 23.934,24.22 L19.56,28.583 C20.403,29.676 20.91,31.041 20.91,32.525 C20.91,36.095 18.005,39 14.435,39 C10.864,39 7.96,36.095 7.96,32.525 C7.96,28.955 10.864,26.05 14.435,26.05 C15.801,26.05 17.066,26.478 18.112,27.202 L22.582,22.743 C22.197,22.08 21.96,21.32 21.96,20.5 C21.96,19.047 22.664,17.766 23.735,16.943 L21.611,11.985 C21.56,11.986 21.512,12 21.46,12 C18.979,12 16.96,9.981 16.96,7.5 C16.96,5.019 18.979,3 21.46,3 C23.941,3 25.96,5.019 25.96,7.5 C25.96,9.219 24.981,10.698 23.56,11.456 L25.548,16.094 C25.843,16.033 26.148,16 26.46,16 C28.787,16 30.685,17.782 30.914,20.05 L37.087,20.05 C37.516,18.304 39.083,17 40.96,17 C43.166,17 44.96,18.794 44.96,21 L44.96,21 Z M24.699,27.294 C25.524,28.901 25.96,30.711 25.96,32.53 C25.96,38.86 20.811,44.01 14.481,44.01 C8.15,44.01 3,38.86 3,32.53 C3,26.2 8.15,21.05 14.481,21.05 C16.326,21.05 18.088,21.475 19.719,22.313 L18.805,24.092 C17.46,23.4 16.005,23.05 14.481,23.05 C9.253,23.05 5,27.303 5,32.53 C5,37.757 9.253,42.01 14.481,42.01 C19.707,42.01 23.96,37.757 23.96,32.53 C23.96,31.006 23.61,29.552 22.92,28.208 L24.699,27.294 Z" id="Fill-1" fill="#DD344C"></path>
    </g>
</svg>`, zZ = '<svg id="bdb56329-4717-4410-aa13-4505ecaa4e46" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><defs><linearGradient id="ba2610c3-a45a-4e7e-a0c0-285cfd7e005d" x1="13.25" y1="13.02" x2="8.62" y2="4.25" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#1988d9" /><stop offset="0.9" stop-color="#54aef0" /></linearGradient><linearGradient id="bd8f618b-4f2f-4cb7-aff0-2fd2d211326d" x1="11.26" y1="10.47" x2="14.46" y2="15.99" gradientUnits="userSpaceOnUse"><stop offset="0.1" stop-color="#54aef0" /><stop offset="0.29" stop-color="#4fabee" /><stop offset="0.51" stop-color="#41a2e9" /><stop offset="0.74" stop-color="#2a93e0" /><stop offset="0.88" stop-color="#1988d9" /></linearGradient></defs><title>Icon-identity-221</title><polygon points="1.01 10.19 8.93 15.33 16.99 10.17 18 11.35 8.93 17.19 0 11.35 1.01 10.19" fill="#50e6ff" /><polygon points="1.61 9.53 8.93 0.81 16.4 9.54 8.93 14.26 1.61 9.53" fill="#fff" /><polygon points="8.93 0.81 8.93 14.26 1.61 9.53 8.93 0.81" fill="#50e6ff" /><polygon points="8.93 0.81 8.93 14.26 16.4 9.54 8.93 0.81" fill="url(#ba2610c3-a45a-4e7e-a0c0-285cfd7e005d)" /><polygon points="8.93 7.76 16.4 9.54 8.93 14.26 8.93 7.76" fill="#53b1e0" /><polygon points="8.93 14.26 1.61 9.53 8.93 7.76 8.93 14.26" fill="#9cebff" /><polygon points="8.93 17.19 18 11.35 16.99 10.17 8.93 15.33 8.93 17.19" fill="url(#bd8f618b-4f2f-4cb7-aff0-2fd2d211326d)" /></svg>', UZ = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><defs><linearGradient id="fdd5d44a-d038-42da-afe7-cecaad9f8ff9" x1="6.49" y1="17.38" x2="6.49" y2="0.44" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#949494" /><stop offset="0.53" stop-color="#a2a2a2" /><stop offset="1" stop-color="#b3b3b3" /></linearGradient><linearGradient id="bf4a560d-147b-4f76-9d70-f90bc5f8ddd6" x1="10.06" y1="13.89" x2="16.48" y2="13.89" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#005ba1" /><stop offset="0.07" stop-color="#0060a9" /><stop offset="0.36" stop-color="#0071c8" /><stop offset="0.52" stop-color="#0078d4" /><stop offset="0.64" stop-color="#0074cd" /><stop offset="0.82" stop-color="#006abb" /><stop offset="1" stop-color="#005ba1" /></linearGradient></defs><g id="a55981fb-ccb2-4f5b-acf6-743ff717cb3a"><g><path d="M11,9.57a6.72,6.72,0,0,0-2.23.32,6.64,6.64,0,0,0,2.23.33,6.56,6.56,0,0,0,2.23-.33A6.63,6.63,0,0,0,11,9.57Z" fill="#198ab3" /><g><path d="M11.47,16.81a.57.57,0,0,1-.58.57H2.09a.56.56,0,0,1-.57-.57V1A.57.57,0,0,1,2.09.44h8.8a.58.58,0,0,1,.58.57Z" fill="url(#fdd5d44a-d038-42da-afe7-cecaad9f8ff9)" /><path d="M3,6.38A1.08,1.08,0,0,1,4.06,5.3H9a1.08,1.08,0,0,1,1.08,1.08h0A1.08,1.08,0,0,1,9,7.47H4.06A1.08,1.08,0,0,1,3,6.38Z" fill="#003067" /><path d="M3,3.17A1.08,1.08,0,0,1,4.06,2.09H9a1.08,1.08,0,0,1,1.08,1.08h0A1.08,1.08,0,0,1,9,4.25H4.06A1.08,1.08,0,0,1,3,3.17Z" fill="#003067" /><circle cx="4.11" cy="3.17" r="0.73" fill="#50e6ff" /><circle cx="4.11" cy="6.38" r="0.73" fill="#50e6ff" /></g><path d="M13.27,11.38c-1.77,0-3.21-.53-3.21-1.17V16.4c0,.63,1.42,1.15,3.17,1.16h0c1.78,0,3.21-.52,3.21-1.16V10.21C16.48,10.85,15.05,11.38,13.27,11.38Z" fill="url(#bf4a560d-147b-4f76-9d70-f90bc5f8ddd6)" /><path d="M16.48,10.21c0,.64-1.43,1.17-3.21,1.17s-3.21-.53-3.21-1.17,1.44-1.16,3.21-1.16,3.21.52,3.21,1.16" fill="#e6e6e6" /><path d="M15.73,10.12c0,.41-1.1.74-2.46.74s-2.46-.33-2.46-.74,1.1-.74,2.46-.74,2.46.33,2.46.74" fill="#50e6ff" /><path d="M13.68,8.66l2.13-2.13a.11.11,0,0,0-.08-.19H14.49c0-2.57-1.37-5.13-3.84-5.13a6.68,6.68,0,0,1,2,5.13H11.47a.11.11,0,0,0-.08.19l2.13,2.13A.12.12,0,0,0,13.68,8.66Z" fill="#50e6ff" /></g></g></svg>', WZ = '<svg id="b300f0d1-2ad8-4418-a1c5-23d0b9d21841" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><defs><linearGradient id="b8cad6fd-ec7f-45e9-be2a-125e8b87bd03" x1="10.79" y1="2.17" x2="10.79" y2="16.56" gradientUnits="userSpaceOnUse"><stop offset="0.18" stop-color="#5ea0ef" /><stop offset="1" stop-color="#0078d4" /></linearGradient></defs><title>Icon-web-43</title><rect x="3.7" y="5.49" width="1.18" height="5.26" rx="0.52" transform="translate(-3.83 12.41) rotate(-90)" fill="#b3b3b3" /><rect x="2.04" y="7.88" width="1.18" height="5.26" rx="0.52" transform="translate(-7.88 13.14) rotate(-90)" fill="#a3a3a3" /><rect x="3.7" y="10.26" width="1.18" height="5.26" rx="0.52" transform="translate(-8.6 17.19) rotate(-90)" fill="#7a7a7a" /><path d="M18,11a3.28,3.28,0,0,0-2.81-3.18,4.13,4.13,0,0,0-4.21-4,4.23,4.23,0,0,0-4,2.8,3.89,3.89,0,0,0-3.38,3.8,4,4,0,0,0,4.06,3.86l.36,0h6.58l.17,0A3.32,3.32,0,0,0,18,11Z" fill="url(#b8cad6fd-ec7f-45e9-be2a-125e8b87bd03)" /></svg>', HZ = '<svg id="f9ed9690-6753-43a7-8b32-d66ac7b8a99a" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><defs><linearGradient id="f710a364-083f-494c-9d96-89b92ee2d5a8" x1="0.5" y1="9.77" x2="9" y2="9.77" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#005ba1" /><stop offset="0.07" stop-color="#0060a9" /><stop offset="0.36" stop-color="#0071c8" /><stop offset="0.52" stop-color="#0078d4" /><stop offset="0.64" stop-color="#0074cd" /><stop offset="0.81" stop-color="#006abb" /><stop offset="0.99" stop-color="#005ba1" /></linearGradient></defs><title>Icon-databases-126</title><g><path d="M13.25,10.48V6.57a.14.14,0,0,0-.24-.1l-4,4L4.85,14.63V17.5H16.93a.56.56,0,0,0,.57-.57V6.57a.14.14,0,0,0-.24-.1Z" fill="#005ba1" /><path d="M4.75,3.58C2.4,3.58.5,2.89.5,2V7.67h0v9.26a.56.56,0,0,0,.57.57H9V2C9,2.89,7.1,3.58,4.75,3.58Z" fill="url(#f710a364-083f-494c-9d96-89b92ee2d5a8)" /><rect x="12.91" y="12.97" width="2.27" height="2.27" rx="0.28" fill="#fff" /><rect x="8.97" y="12.97" width="2.27" height="2.27" rx="0.28" fill="#fff" /><rect x="5.03" y="12.97" width="2.27" height="2.27" rx="0.28" fill="#fff" /><path d="M9,2c0,.85-1.9,1.54-4.25,1.54S.5,2.89.5,2,2.4.5,4.75.5,9,1.19,9,2" fill="#eaeaea" /><path d="M8,1.91c0,.55-1.46,1-3.26,1s-3.26-.43-3.26-1S3,.94,4.75.94,8,1.37,8,1.91" fill="#50e6ff" /><path d="M4.75,2.14a8.07,8.07,0,0,0-2.58.37,7.64,7.64,0,0,0,2.58.38,7.64,7.64,0,0,0,2.58-.38A8.07,8.07,0,0,0,4.75,2.14Z" fill="#198ab3" /></g></svg>', $Z = '<svg id="f4337506-5d95-4e80-b7ca-68498c6e008e" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><defs><linearGradient id="ba420277-700e-42cc-9de9-5388a5c16e54" x1="9" y1="16.97" x2="9" y2="1.03" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#0078d4" /><stop offset="0.16" stop-color="#1380da" /><stop offset="0.53" stop-color="#3c91e5" /><stop offset="0.82" stop-color="#559cec" /><stop offset="1" stop-color="#5ea0ef" /></linearGradient></defs><title>Icon-devops-261</title><path id="a91f0ca4-8fb7-4019-9c09-0a52e2c05754" d="M17,4v9.74l-4,3.28-6.2-2.26V17L3.29,12.41l10.23.8V4.44Zm-3.41.49L7.85,1V3.29L2.58,4.84,1,6.87v4.61l2.26,1V6.57Z" fill="url(#ba420277-700e-42cc-9de9-5388a5c16e54)" /></svg>', VZ = '<svg id="a2c88306-fa03-4e5b-b192-401f0b77808b" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><defs><linearGradient id="b403aca7-f387-4434-96b4-ae157edc835f" x1="-175.993" y1="-343.723" x2="-175.993" y2="-359.232" gradientTransform="translate(212.573 370.548) scale(1.156 1.029)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#fea11b" /><stop offset="0.284" stop-color="#fea51a" /><stop offset="0.547" stop-color="#feb018" /><stop offset="0.8" stop-color="#ffc314" /><stop offset="1" stop-color="#ffd70f" /></linearGradient></defs><title>Icon-compute-29</title><g><path d="M2.37,7.475H3.2a.267.267,0,0,1,.267.267v6.148a.533.533,0,0,1-.533.533H2.1a0,0,0,0,1,0,0V7.741a.267.267,0,0,1,.267-.267Z" transform="translate(12.507 16.705) rotate(134.919)" fill="#50e6ff" /><path d="M2.325,3.6h.833a.267.267,0,0,1,.267.267v6.583a0,0,0,0,1,0,0H2.591a.533.533,0,0,1-.533-.533V3.865A.267.267,0,0,1,2.325,3.6Z" transform="translate(5.759 0.114) rotate(44.919)" fill="#1490df" /></g><g><path d="M14.53,7.475h.833a.533.533,0,0,1,.533.533v6.148a.267.267,0,0,1-.267.267H14.8a.267.267,0,0,1-.267-.267V7.475a0,0,0,0,1,0,0Z" transform="translate(12.223 -7.555) rotate(45.081)" fill="#50e6ff" /><path d="M15.108,3.6h.833a0,0,0,0,1,0,0v6.583a.267.267,0,0,1-.267.267h-.833a.267.267,0,0,1-.267-.267V4.131a.533.533,0,0,1,.533-.533Z" transform="translate(31.022 1.222) rotate(135.081)" fill="#1490df" /></g><path d="M8.459,9.9H4.87a.193.193,0,0,1-.2-.181.166.166,0,0,1,.018-.075L8.991,1.13a.206.206,0,0,1,.186-.106h4.245a.193.193,0,0,1,.2.181.165.165,0,0,1-.035.1L8.534,7.966h4.928a.193.193,0,0,1,.2.181.176.176,0,0,1-.052.122L5.421,16.788c-.077.046-.624.5-.356-.189h0Z" fill="url(#b403aca7-f387-4434-96b4-ae157edc835f)" /></svg>', GZ = `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><defs><linearGradient id="f67d1585-6164-4ad0-b2dd-f9cc59b2969f" x1="9.908" y1="15.943" x2="7.516" y2="2.383" gradientUnits="userSpaceOnUse"><stop offset="0.15" stop-color="#0078d4" /><stop offset="0.8" stop-color="#5ea0ef" /><stop offset="1" stop-color="#83b9f9" /></linearGradient></defs><g id="a4fd1868-54fe-4ca6-8ff6-3b01866dc27b"><path d="M14.49,7.15A5.147,5.147,0,0,0,9.24,2.164,5.272,5.272,0,0,0,4.216,5.653,4.869,4.869,0,0,0,0,10.4a4.946,4.946,0,0,0,5.068,4.814H13.82A4.292,4.292,0,0,0,18,11.127,4.105,4.105,0,0,0,14.49,7.15Z" fill="url(#f67d1585-6164-4ad0-b2dd-f9cc59b2969f)" /><path d="M12.9,11.4V8H12v4.13h2.46V11.4ZM5.76,9.73a1.825,1.825,0,0,1-.51-.31.441.441,0,0,1-.12-.32.342.342,0,0,1,.15-.3.683.683,0,0,1,.42-.12,1.62,1.62,0,0,1,1,.29V8.11a2.58,2.58,0,0,0-1-.16,1.641,1.641,0,0,0-1.09.34,1.08,1.08,0,0,0-.42.89c0,.51.32.91,1,1.21a2.907,2.907,0,0,1,.62.36.419.419,0,0,1,.15.32.381.381,0,0,1-.16.31.806.806,0,0,1-.45.11,1.66,1.66,0,0,1-1.09-.42V12a2.173,2.173,0,0,0,1.07.24,1.877,1.877,0,0,0,1.18-.33A1.08,1.08,0,0,0,6.84,11a1.048,1.048,0,0,0-.25-.7A2.425,2.425,0,0,0,5.76,9.73ZM11,11.32A2.191,2.191,0,0,0,11,9a1.808,1.808,0,0,0-.7-.75,2,2,0,0,0-1-.26,2.112,2.112,0,0,0-1.08.27A1.856,1.856,0,0,0,7.49,9a2.465,2.465,0,0,0-.26,1.14,2.256,2.256,0,0,0,.24,1,1.766,1.766,0,0,0,.69.74,2.056,2.056,0,0,0,1,.3l.86,1h1.21L10,12.08A1.79,1.79,0,0,0,11,11.32Zm-1-.25a.941.941,0,0,1-.76.35.916.916,0,0,1-.76-.36,1.523,1.523,0,0,1-.29-1,1.529,1.529,0,0,1,.29-1,1,1,0,0,1,.78-.37.869.869,0,0,1,.75.37,1.619,1.619,0,0,1,.27,1A1.459,1.459,0,0,1,10,11.07Z" fill="#f2f2f2" /></g>​
</svg>`, jZ = '<svg id="b089cfca-0de1-451c-a1ca-6680ea50cb4f" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><defs><radialGradient id="b25d0836-964a-4c84-8c20-855f66e8345e" cx="-105.006" cy="-10.409" r="5.954" gradientTransform="translate(117.739 19.644) scale(1.036 1.027)" gradientUnits="userSpaceOnUse"><stop offset="0.183" stop-color="#5ea0ef" /><stop offset="1" stop-color="#0078d4" /></radialGradient><clipPath id="b36c7f5d-2ef1-4760-8a25-eeb9661f4e47"><path d="M14.969,7.53A6.137,6.137,0,1,1,7.574,2.987,6.137,6.137,0,0,1,14.969,7.53Z" fill="none" /></clipPath></defs><title>Icon-databases-121</title><path d="M2.954,5.266a.175.175,0,0,1-.176-.176h0A2.012,2.012,0,0,0,.769,3.081a.176.176,0,0,1-.176-.175h0a.176.176,0,0,1,.176-.176A2.012,2.012,0,0,0,2.778.72.175.175,0,0,1,2.954.544h0A.175.175,0,0,1,3.13.72h0A2.012,2.012,0,0,0,5.139,2.729a.175.175,0,0,1,.176.176h0a.175.175,0,0,1-.176.176h0A2.011,2.011,0,0,0,3.13,5.09.177.177,0,0,1,2.954,5.266Z" fill="#50e6ff" /><path d="M15.611,17.456a.141.141,0,0,1-.141-.141h0a1.609,1.609,0,0,0-1.607-1.607.141.141,0,0,1-.141-.14h0a.141.141,0,0,1,.141-.141h0a1.608,1.608,0,0,0,1.607-1.607.141.141,0,0,1,.141-.141h0a.141.141,0,0,1,.141.141h0a1.608,1.608,0,0,0,1.607,1.607.141.141,0,1,1,0,.282h0a1.609,1.609,0,0,0-1.607,1.607A.141.141,0,0,1,15.611,17.456Z" fill="#50e6ff" /><g><path d="M14.969,7.53A6.137,6.137,0,1,1,7.574,2.987,6.137,6.137,0,0,1,14.969,7.53Z" fill="url(#b25d0836-964a-4c84-8c20-855f66e8345e)" /><g clip-path="url(#b36c7f5d-2ef1-4760-8a25-eeb9661f4e47)"><path d="M5.709,13.115A1.638,1.638,0,1,0,5.714,9.84,1.307,1.307,0,0,0,5.721,9.7,1.651,1.651,0,0,0,4.06,8.064H2.832a6.251,6.251,0,0,0,1.595,5.051Z" fill="#f2f2f2" /><path d="M15.045,7.815c0-.015,0-.03-.007-.044a5.978,5.978,0,0,0-1.406-2.88,1.825,1.825,0,0,0-.289-.09,1.806,1.806,0,0,0-2.3,1.663,2,2,0,0,0-.2-.013,1.737,1.737,0,0,0-.581,3.374,1.451,1.451,0,0,0,.541.1h2.03A13.453,13.453,0,0,0,15.045,7.815Z" fill="#f2f2f2" /></g></g><path d="M17.191,3.832c-.629-1.047-2.1-1.455-4.155-1.149a14.606,14.606,0,0,0-2.082.452,6.456,6.456,0,0,1,1.528.767c.241-.053.483-.116.715-.151A7.49,7.49,0,0,1,14.3,3.662a2.188,2.188,0,0,1,1.959.725h0c.383.638.06,1.729-.886,3a16.723,16.723,0,0,1-4.749,4.051A16.758,16.758,0,0,1,4.8,13.7c-1.564.234-2.682,0-3.065-.636s-.06-1.73.886-2.995c.117-.157.146-.234.279-.392a6.252,6.252,0,0,1,.026-1.63A11.552,11.552,0,0,0,1.756,9.419C.517,11.076.181,12.566.809,13.613a3.165,3.165,0,0,0,2.9,1.249,8.434,8.434,0,0,0,1.251-.1,17.855,17.855,0,0,0,6.219-2.4,17.808,17.808,0,0,0,5.061-4.332C17.483,6.369,17.819,4.88,17.191,3.832Z" fill="#50e6ff" /></svg>', qZ = '<svg id="b5b638e5-1de7-4378-8f50-7c3738e5874c" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><defs><linearGradient id="e20ae4ca-8128-4625-bcc6-863bc1bc51d9" x1="5.05" y1="10.55" x2="5.05" y2="13.48" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#76bc2d" /><stop offset="1" stop-color="#5e9624" /></linearGradient><linearGradient id="b6fa89de-29eb-462e-97de-5bdbdaeb090e" x1="12.84" y1="10.57" x2="12.84" y2="13.5" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#76bc2d" /><stop offset="1" stop-color="#5e9624" /></linearGradient></defs><title>Icon-integration-204</title><g><path d="M3.19,15.6a2.49,2.49,0,0,1-1.53-.38,1.7,1.7,0,0,1-.45-1.36V10.33c0-.58-.23-.89-.71-.89V8.56c.48,0,.71-.31.71-.92V4.17a1.79,1.79,0,0,1,.45-1.39A2.29,2.29,0,0,1,3.19,2.4v.89c-.51,0-.79.27-.79.85v3.4c0,.78-.23,1.26-.74,1.46a1.42,1.42,0,0,1,.74,1.46v3.37a1.25,1.25,0,0,0,.17.68.74.74,0,0,0,.58.2l0,.89Z" fill="#949494" /><path d="M14.81,2.4a2.49,2.49,0,0,1,1.53.38,1.7,1.7,0,0,1,.45,1.36V7.67c0,.58.23.89.71.89v.88c-.48,0-.71.31-.71.92v3.43a1.8,1.8,0,0,1-.45,1.4,2.28,2.28,0,0,1-1.53.41v-.89c.51,0,.79-.27.79-.85v-3.4c0-.78.23-1.26.74-1.46a1.42,1.42,0,0,1-.74-1.46V4.17a1.25,1.25,0,0,0-.17-.68.74.74,0,0,0-.58-.2Z" fill="#949494" /><path d="M9.41,8.35V7.08h-.9V8.35a.18.18,0,0,1-.18.18H5a.36.36,0,0,0-.36.36v1.65h.9V9.63a.18.18,0,0,1,.17-.18h6.54a.18.18,0,0,1,.18.18v.93h.89V8.89a.36.36,0,0,0-.35-.36H9.59A.18.18,0,0,1,9.41,8.35Z" fill="#005ba1" /><path d="M10.61,3.21H7.25a.38.38,0,0,0-.38.37V6.94a.37.37,0,0,0,.38.37h3.36A.37.37,0,0,0,11,6.94V3.58A.38.38,0,0,0,10.61,3.21Zm-.32,3.17a.25.25,0,0,1-.25.24H7.81a.25.25,0,0,1-.25-.24V4.15a.25.25,0,0,1,.25-.25H10a.25.25,0,0,1,.25.25Z" fill="#0078d4" /><rect x="3.58" y="10.55" width="2.94" height="2.94" rx="0.27" fill="url(#e20ae4ca-8128-4625-bcc6-863bc1bc51d9)" /><rect x="11.38" y="10.57" width="2.94" height="2.94" rx="0.27" fill="url(#b6fa89de-29eb-462e-97de-5bdbdaeb090e)" /></g></svg>', KZ = '<svg id="fd454f1c-5506-44b8-874e-8814b8b2f70b" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><defs><linearGradient id="f34d9569-2bd0-4002-8f16-3d01d8106cb5" x1="8.88" y1="12.21" x2="8.88" y2="0.21" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#0078d4" /><stop offset="0.82" stop-color="#5ea0ef" /></linearGradient><linearGradient id="bdb45a0b-eb58-4970-a60a-fb2ce314f866" x1="8.88" y1="16.84" x2="8.88" y2="12.21" gradientUnits="userSpaceOnUse"><stop offset="0.15" stop-color="#ccc" /><stop offset="1" stop-color="#707070" /></linearGradient></defs><title>Icon-compute-21</title><rect x="-0.12" y="0.21" width="18" height="12" rx="0.6" fill="url(#f34d9569-2bd0-4002-8f16-3d01d8106cb5)" /><polygon points="11.88 4.46 11.88 7.95 8.88 9.71 8.88 6.21 11.88 4.46" fill="#50e6ff" /><polygon points="11.88 4.46 8.88 6.22 5.88 4.46 8.88 2.71 11.88 4.46" fill="#c3f1ff" /><polygon points="8.88 6.22 8.88 9.71 5.88 7.95 5.88 4.46 8.88 6.22" fill="#9cebff" /><polygon points="5.88 7.95 8.88 6.21 8.88 9.71 5.88 7.95" fill="#c3f1ff" /><polygon points="11.88 7.95 8.88 6.21 8.88 9.71 11.88 7.95" fill="#9cebff" /><path d="M12.49,15.84c-1.78-.28-1.85-1.56-1.85-3.63H7.11c0,2.07-.06,3.35-1.84,3.63a1,1,0,0,0-.89,1h9A1,1,0,0,0,12.49,15.84Z" fill="url(#bdb45a0b-eb58-4970-a60a-fb2ce314f866)" /></svg>', YZ = '<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24"><defs><style>.cls-1{fill:#669df6;}.cls-1,.cls-2,.cls-3{fill-rule:evenodd;}.cls-2{fill:#aecbfa;}.cls-3{fill:#4285f4;}</style></defs><title>Icon_24px_BigTable_Color</title><g data-name="Product Icons"><g ><path class="cls-1" d="M16.22,6.45,12,3.94a2.86,2.86,0,0,1-1.25-1.71s.16-.32.38-.2,3.5,2.06,5.25,3.1c.63.37.24,2,.24,2A.77.77,0,0,0,16.22,6.45Z"/><path class="cls-2" d="M17.49,12.69a.35.35,0,0,1-.16.33l-1,.68V5.75c0-.27.17-.56-.06-.7l.92.68a.73.73,0,0,1,.35.65Z"/><path class="cls-1" d="M12,13.6a.36.36,0,0,1-.2-.06L8.34,11.48v.9L12,14.56l.29-.57s-.22-.39-.29-.39Z"/><path class="cls-1" d="M12.2,15.4a.36.36,0,0,1-.4,0L8.34,13.34V14a.42.42,0,0,0,.19.35l3.28,2a.37.37,0,0,0,.38,0,2,2,0,0,0,.2-.52l-.19-.39Z"/><path class="cls-2" d="M12,12.73l3.66-2.18v-.43a.39.39,0,0,0-.19-.34l-3.28-2a.37.37,0,0,0-.38,0l-3.28,2a.41.41,0,0,0-.19.34v.43L12,12.73Z"/><path class="cls-1" d="M12,11.83,8.53,9.78a.41.41,0,0,0-.19.34v.43L12,12.73l.28-.56L12,11.83Z"/><path class="cls-3" d="M12,13.6v1l3.66-2.18v-.9L12.2,13.54a.65.65,0,0,1-.2.06Z"/><path class="cls-3" d="M12.2,15.4a.36.36,0,0,1-.2.06c0,.28,0,.9,0,.9a.5.5,0,0,0,.21-.05l3.28-2a.39.39,0,0,0,.19-.35v-.66L12.2,15.4Z"/><path class="cls-3" d="M15.47,9.78,12,11.83v.9l3.66-2.18v-.43a.39.39,0,0,0-.19-.34Z"/><path class="cls-1" d="M7.78,17.53,11.93,20a2.72,2.72,0,0,1,1.28,1.8.18.18,0,0,1-.28.18L7.48,18.75c-.53-.32-.07-1.88-.07-1.88A.77.77,0,0,0,7.78,17.53Z"/><path class="cls-2" d="M6.51,17.73V11.17a.41.41,0,0,1,.19-.33l1-.59v7.91c0,.27,0,.69.21.83l-1.06-.66A.75.75,0,0,1,6.51,17.73Z"/><path class="cls-1" d="M10.16,5.46a.75.75,0,0,0-.74,0L5.22,8a2.63,2.63,0,0,1-2.08.26.23.23,0,0,1,0-.4c.18-.09,6.32-3.74,6.32-3.74.23-.14.74,1.39.74,1.39Z"/><path class="cls-2" d="M10.15,4.08l5.32,3.15a.37.37,0,0,1,.2.31V8.72L9,4.76a.75.75,0,0,0-.74,0l1.18-.69a.71.71,0,0,1,.73,0Z"/><path class="cls-1" d="M13.82,18.49a.73.73,0,0,0,.74,0L18.76,16a2.63,2.63,0,0,1,2.1-.25.21.21,0,0,1,0,.38l-6.33,3.75c-.22.14-.74-1.4-.74-1.4Z"/><path class="cls-2" d="M8.51,16.75a.56.56,0,0,1-.17-.33V15.26L15,19.19a.69.69,0,0,0,.73,0l-1.18.7a.7.7,0,0,1-.74,0Z"/><path class="cls-1" d="M6.26,9.81a.76.76,0,0,0-.37.65v5a2.75,2.75,0,0,1-.87,2,.18.18,0,0,1-.3-.13V9.77c0-.28,1.54,0,1.54,0Z"/><path class="cls-2" d="M9.77,6.52a.34.34,0,0,1,.36,0l1,.59L5.05,10.67a.77.77,0,0,0-.37.66V9.94a.72.72,0,0,1,.38-.64Z"/><path class="cls-1" d="M18.17,13.44v-5a2.81,2.81,0,0,1,.84-2s.33-.11.31.21,0,7.37,0,7.37c-.31.37-1.61,0-1.61,0A.81.81,0,0,0,18.17,13.44Z"/><path class="cls-2" d="M19,14.61l-4.74,2.85a.35.35,0,0,1-.37,0l-1-.57L19,13.22a.77.77,0,0,0,.37-.66V14C19.35,14.23,19,14.61,19,14.61Z"/></g></g></svg>', QZ = '<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24"><defs><style>.cls-1{fill:#aecbfa;}.cls-1,.cls-2,.cls-3{fill-rule:evenodd;}.cls-2{fill:#669df6;}.cls-3{fill:#4285f4;}</style></defs><title>Icon_24px_BigQuery_Color</title><g data-name="Product Icons"><g ><path class="cls-1" d="M6.73,10.83v2.63A4.91,4.91,0,0,0,8.44,15.2V10.83Z"/><path class="cls-2" d="M9.89,8.41v7.53A7.62,7.62,0,0,0,11,16,8,8,0,0,0,12,16V8.41Z"/><path class="cls-1" d="M13.64,11.86v3.29a5,5,0,0,0,1.7-1.82V11.86Z"/><path class="cls-3" d="M17.74,16.32l-1.42,1.42a.42.42,0,0,0,0,.6l3.54,3.54a.42.42,0,0,0,.59,0l1.43-1.43a.42.42,0,0,0,0-.59l-3.54-3.54a.42.42,0,0,0-.6,0"/><path class="cls-2" d="M11,2a9,9,0,1,0,9,9,9,9,0,0,0-9-9m0,15.69A6.68,6.68,0,1,1,17.69,11,6.68,6.68,0,0,1,11,17.69"/></g></g></svg>', XZ = '<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24"><defs><style>.cls-1{fill:none;}.cls-2{fill:#669df6;}.cls-2,.cls-3,.cls-4{fill-rule:evenodd;}.cls-3{fill:#aecbfa;}.cls-4{fill:#4285f4;}</style></defs><title>Icon_24px_CDN_Color</title><g data-name="Product Icons"><rect class="cls-1" x="2" y="2" width="20" height="20"/><g ><polygon id="Fill-1" class="cls-2" points="12 2 12 4.41 15.13 7.63 15.13 5.21 12 2"/><polygon id="Fill-1-Copy-2" class="cls-2" points="19.5 12 16.38 15.13 18.88 15.13 22 12 19.5 12"/><polygon id="Fill-1-Copy-3" class="cls-2" points="4.5 12 7.63 15.13 5.13 15.13 2 12 4.5 12"/><polygon id="Fill-1-Copy" class="cls-2" points="12 22 12 19.59 15.13 16.38 15.13 18.79 12 22"/><polygon id="Fill-2" class="cls-3" points="12 2 8.88 5.21 8.88 7.63 12 4.41 12 2"/><polygon id="Fill-2-Copy-2" class="cls-3" points="18.88 8.88 16.38 8.88 19.5 12 22 12 18.88 8.88"/><polygon id="Fill-2-Copy-3" class="cls-3" points="5.13 8.88 7.63 8.88 4.5 12 2 12 5.13 8.88"/><polygon id="Fill-2-Copy" class="cls-3" points="12 22 8.88 18.79 8.88 16.38 12 19.59 12 22"/><polygon id="Fill-9" class="cls-3" points="15.13 15.13 8.88 15.13 8.88 8.88 15.13 8.88 15.13 15.13"/><polygon id="Fill-10" class="cls-2" points="15.13 8.88 15.13 15.13 8.88 15.13 15.13 8.88"/><polygon class="cls-4" points="15.13 8.88 15.13 15.13 12 12 15.13 8.88"/></g></g></svg>', JZ = '<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24"><defs><style>.cls-1{fill:#4285f4;}.cls-2{fill:#669df6;}.cls-3{fill:#aecbfa;}.cls-4{fill:#fff;}</style></defs><title>Icon_24px_DNS_Color</title><g data-name="Product Icons"><g data-name="colored-32/dns"><g ><polygon id="Fill-1" class="cls-1" points="13 18 11 18 11 8 13 8 13 18"/><polygon id="Fill-2" class="cls-2" points="2 21 22 21 22 19 2 19 2 21"/><polygon id="Fill-3" class="cls-3" points="10 22 14 22 14 18 10 18 10 22"/></g></g><rect class="cls-3" x="2" y="2" width="20" height="6"/><rect class="cls-2" x="12" y="2" width="10" height="6"/><rect class="cls-4" x="4" y="4" width="2" height="2"/><rect class="cls-3" x="2" y="10" width="20" height="6"/><rect class="cls-2" x="12" y="10" width="10" height="6"/><rect class="cls-4" x="4" y="12" width="2" height="2"/></g></svg>', ek = '<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24"><defs><style>.cls-1{fill:#4285f4;}.cls-1,.cls-2,.cls-3{fill-rule:evenodd;}.cls-2{fill:#aecbfa;}.cls-3{fill:#669df6;}</style></defs><title>Icon_24px_Interconnect_Color</title><g data-name="Product Icons"><g ><polygon id="Fill-3" class="cls-1" points="2 13 6 13 6 11 2 11 2 13"/><polygon id="Fill-6" class="cls-2" points="15 17 5 17 5 7 15 7 15 17"/><polygon id="Fill-1" class="cls-1" points="17.33 13 22 13 22 11 17.33 11 17.33 13"/><polygon class="cls-3" points="8 3 8 5 17 5 17 19 8 19 8 21 19 21 19 19 19 5 19 3 8 3"/><polygon id="Fill-7" class="cls-3" points="15 17 10 17 10 7 15 7 15 17"/></g></g></svg>', tk = '<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24"><defs><style>.cls-1{fill:none;}.cls-2{fill:#669df6;}.cls-3{fill:#4285f4;}.cls-4{fill:#aecbfa;}</style></defs><title>Icon_24px_LoadBalancing_Color</title><g data-name="Product Icons"><g data-name="colored-32/load-balancing"><rect class="cls-1" width="24" height="24"/><g ><rect class="cls-2" x="18" y="12" width="2" height="4"/><rect class="cls-2" x="11" y="12" width="2" height="4"/><rect class="cls-2" x="4" y="12" width="2" height="4"/><polygon id="Fill-2" class="cls-3" points="13 11 11 11 11 7 13 7 13 11"/><rect class="cls-2" x="4" y="11" width="16" height="2"/><rect class="cls-4" x="6" y="2" width="12" height="5"/><rect class="cls-2" x="12" y="2" width="6" height="5"/><rect class="cls-4" x="16" y="16" width="6" height="6"/><rect class="cls-4" x="2" y="16" width="6" height="6"/><rect class="cls-2" x="5" y="16" width="3" height="6"/><rect class="cls-4" x="9" y="16" width="6" height="6"/><rect class="cls-2" x="12" y="16" width="3" height="6"/><rect class="cls-2" x="19" y="16" width="3" height="6"/></g></g></g></svg>', nk = '<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24"><defs><style>.cls-1{fill:#aecbfa;}.cls-1,.cls-2,.cls-3{fill-rule:evenodd;}.cls-2{fill:#669df6;}.cls-3{fill:#4285f4;}</style></defs><title>Icon_24px_SQL_Color</title><g data-name="Product Icons"><g ><polygon class="cls-1" points="4.67 10.44 4.67 13.45 12 17.35 12 14.34 4.67 10.44"/><polygon class="cls-1" points="4.67 15.09 4.67 18.1 12 22 12 18.99 4.67 15.09"/><polygon class="cls-2" points="12 17.35 19.33 13.45 19.33 10.44 12 14.34 12 17.35"/><polygon class="cls-2" points="12 22 19.33 18.1 19.33 15.09 12 18.99 12 22"/><polygon class="cls-3" points="19.33 8.91 19.33 5.9 12 2 12 5.01 19.33 8.91"/><polygon class="cls-2" points="12 2 4.67 5.9 4.67 8.91 12 5.01 12 2"/><polygon class="cls-1" points="4.67 5.87 4.67 8.89 12 12.79 12 9.77 4.67 5.87"/><polygon class="cls-2" points="12 12.79 19.33 8.89 19.33 5.87 12 9.77 12 12.79"/></g></g></svg>', ik = '<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24"><defs><style>.cls-1{fill:#aecbfa;}.cls-2{fill:#669df6;}.cls-3{fill:#4285f4;}.cls-4{fill:#fff;}</style></defs><title>Icon_24px_CloudStorage_Color</title><g data-name="Product Icons"><rect class="cls-1" x="2" y="4" width="20" height="7"/><rect class="cls-2" x="20" y="4" width="2" height="7"/><polygon class="cls-3" points="22 4 20 4 20 11 22 4"/><rect class="cls-2" x="2" y="4" width="2" height="7"/><rect class="cls-4" x="6" y="7" width="6" height="1"/><rect class="cls-4" x="15" y="6" width="3" height="3" rx="1.5"/><rect class="cls-1" x="2" y="13" width="20" height="7"/><rect class="cls-2" x="20" y="13" width="2" height="7"/><polygon class="cls-3" points="22 13 20 13 20 20 22 13"/><rect class="cls-2" x="2" y="13" width="2" height="7"/><rect class="cls-4" x="6" y="16" width="6" height="1"/><rect class="cls-4" x="15" y="15" width="3" height="3" rx="1.5"/></g></svg>', sk = `<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M14.7110701,8.84507935 C14.7717439,8.84507935 14.8231931,8.88719721 14.8413458,8.94564457 L14.8483412,8.99213893 L14.8483412,9.80096662 C14.8483412,9.86590813 14.8090267,9.92106136 14.7544697,9.94052499 L14.7110701,9.9480262 L14.1619856,9.9480262 L14.1619856,11.3971513 C14.1619856,11.4393574 14.1689102,11.4810733 14.1822916,11.5204472 L14.2071478,11.5775199 L17.9097614,18.3983638 C18.0128912,18.5897093 18.0276241,18.8190863 17.9539599,19.0212979 L17.9097614,19.1198381 L16.5667009,21.6392628 C16.4635711,21.8306084 16.2854576,21.9589644 16.0851783,21.9917325 L15.983436,22 L8.01656405,22 C7.8103044,22 7.61750853,21.8989791 7.49086453,21.7295356 L7.43329911,21.6392628 L6.09023859,19.1198381 C5.98710877,18.9284926 5.97237594,18.6991157 6.0460401,18.496904 L6.09023859,18.3983638 L9.78310593,11.5775199 C9.80278146,11.5409511 9.8205962,11.5011143 9.83028652,11.4598613 L9.83794574,11.3971513 L9.83794574,9.9480262 L9.28886131,9.9480262 C9.22824239,9.9480262 9.17676023,9.90586128 9.15859212,9.84743274 L9.1515902,9.80096662 L9.1515902,8.99213893 C9.1515902,8.9271386 9.19094857,8.87202066 9.24548803,8.85257351 L9.28886131,8.84507935 L14.7110701,8.84507935 Z M13.1324523,9.9480262 L10.867479,9.9480262 L10.867479,11.6220054 C10.867479,11.7170243 10.8499898,11.810761 10.8163145,11.8979731 L10.7772919,11.9828161 L7.23720733,18.5909383 C7.18910754,18.6801741 7.17948758,18.7860688 7.2083826,18.8820057 L7.23727597,18.9516755 L8.15266835,20.6500666 C8.20076815,20.7393612 8.28154945,20.8012203 8.37354086,20.8223922 L8.44430082,20.8304352 L9.572,20.83 L8.57527805,18.9792271 C8.52717825,18.8899325 8.51755829,18.7840732 8.54641817,18.6881527 L8.57527805,18.6184899 L9.44379234,17.006864 L15.913,17.006 L15.399,16.047 L13.0053393,16.0472267 L12.6160384,15.3248701 L15.012,15.324 L14.292,13.979 L11.8745205,13.9792234 L11.4852196,13.2568668 L13.904,13.256 L13.2227081,11.9828161 C13.1783867,11.9005363 13.1497785,11.8099843 13.1382445,11.7164027 L13.1324523,11.6220054 L13.1324523,9.9480262 Z M16.347,17.815 L13.9560996,17.8156917 L14.3454004,18.5509896 L16.741,18.55 L16.347,17.815 Z M10.630604,5.77278412 C11.0025401,5.77278412 11.3040561,6.09587402 11.3040561,6.49433196 C11.3040561,6.89278989 11.0025401,7.21580626 10.630604,7.21580626 C10.258668,7.21580626 9.95715197,6.89278989 9.95715197,6.49433196 C9.95715197,6.09587402 10.258668,5.77278412 10.630604,5.77278412 Z M13.1716089,4.22465851 C13.7295473,4.22465851 14.1818556,4.7091463 14.1818556,5.30686996 C14.1818556,5.9045201 13.7295473,6.38908141 13.1716089,6.38908141 C12.6136705,6.38908141 12.1614308,5.9045201 12.1614308,5.30686996 C12.1614308,4.7091463 12.6136705,4.22465851 13.1716089,4.22465851 Z M11.6407615,2 C12.0126976,2 12.3142822,2.3230899 12.3142822,2.72154783 C12.3142822,3.12000576 12.0126976,3.44302213 11.6407615,3.44302213 C11.2688941,3.44302213 10.9673095,3.12000576 10.9673095,2.72154783 C10.9673095,2.3230899 11.2688941,2 11.6407615,2 Z" fill="#4285F4"></path>
    </g>
</svg>`, rk = '<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24"><defs><style>.cls-1{fill:none;}.cls-2{fill:#aecbfa;}.cls-2,.cls-3,.cls-4{fill-rule:evenodd;}.cls-3{fill:#4285f4;}.cls-4{fill:#669df6;}</style></defs><title>Icon_24px_DataProc_Color</title><g data-name="Product Icons"><rect class="cls-1" x="2" y="2" width="20" height="20"/><g ><polygon class="cls-2" points="17.85 14.2 7.67 20.08 6.69 18.4 16.88 12.51 17.85 14.2"/><polygon class="cls-2" points="7.63 18.16 7.63 6.4 9.5 6.4 9.5 16.75 7.63 18.16"/><polygon class="cls-2" points="9.56 9.69 9.3 7.33 19.49 13.2 18.52 14.88 9.56 9.69"/><path class="cls-3" d="M14.39,10.26,9.3,7.33l.26,2.36,1.51.86a4,4,0,0,0,3.32-.29Z"/><path class="cls-2" d="M8.13,8.29h0a3.78,3.78,0,1,1,3.27,1.89A3.8,3.8,0,0,1,8.13,8.29ZM13,5.49a1.84,1.84,0,0,0-1.59-.92A1.83,1.83,0,0,0,9.57,6.4a1.84,1.84,0,1,0,3.67,0A1.8,1.8,0,0,0,13,5.49Z"/><path class="cls-3" d="M7.63,12.94v5.22L9.5,16.75V15.12a3.29,3.29,0,0,0-1.87-2.18Z"/><path class="cls-3" d="M13.33,16.81l4.52-2.61-2.21-1L14.39,14a4.23,4.23,0,0,0-1.06,2.86Z"/><path class="cls-2" d="M2.51,18.7h0a3.77,3.77,0,0,1,1.38-5.16,3.72,3.72,0,0,1,2.86-.38A3.78,3.78,0,1,1,2.51,18.7Zm4.85-2.81A1.79,1.79,0,0,0,6.25,15a1.83,1.83,0,0,0-2.06,2.69h0a1.83,1.83,0,1,0,3.17-1.84Z"/><path class="cls-2" d="M14.33,18.36h0a3.79,3.79,0,0,1,0-3.77,3.79,3.79,0,0,1,5.16-1.39,3.78,3.78,0,0,1,1.38,5.16,3.78,3.78,0,0,1-6.54,0Zm4.86-2.81a2,2,0,0,0-.67-.67,1.85,1.85,0,0,0-2.51.68,1.86,1.86,0,0,0,0,1.83,1.83,1.83,0,0,0,2.07.85,1.82,1.82,0,0,0,1.11-.85,1.88,1.88,0,0,0,0-1.84Z"/><path class="cls-4" d="M9.49,16.15s-2.34,2-2.8,2.25l2.86-1.65a4.07,4.07,0,0,0-.06-.6Z"/><path class="cls-4" d="M10.15,10S9.56,6.72,9.56,6.4V9.69a3.47,3.47,0,0,0,.59.27Z"/><path class="cls-4" d="M15.3,13.47s2.76,1.15,3.22,1.41l-2.86-1.64a1.69,1.69,0,0,0-.36.23Z"/></g></g></svg>', ok = '<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24"><defs><style>.cls-1{fill:#669df6;}.cls-1,.cls-2{fill-rule:evenodd;}.cls-2{fill:#4285f4;}</style></defs><title>Icon_24px_IAM_Color</title><g data-name="Product Icons"><g ><path class="cls-1" d="M12,2,3.79,5.42v5.63c0,5.06,3.5,9.8,8.21,11,4.71-1.15,8.21-5.89,8.21-10.95V5.42Zm0,3.79a2.63,2.63,0,1,1-1.86.77A2.63,2.63,0,0,1,12,5.79Zm4.11,11.15A8.64,8.64,0,0,1,12,19.87a8.64,8.64,0,0,1-4.11-2.93V14.69c0-1.67,2.74-2.52,4.11-2.52s4.11.85,4.11,2.52v2.25Z"/><path class="cls-2" d="M12,2V5.79a2.63,2.63,0,1,1,0,5.26v1.12c1.37,0,4.11.85,4.11,2.52v2.25A8.64,8.64,0,0,1,12,19.87V22c4.71-1.15,8.21-5.89,8.21-10.95V5.42Z"/></g></g></svg>', lk = `<svg version="1.1" baseProfile="tiny" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
	 x="0px" y="0px" width="24px" height="24px" viewBox="0 0 24 24" overflow="visible" xml:space="preserve">
<g >
	<g transform="translate(4.000000, 1.000000)">
		<path fill="#85A4E6" d="M8,0l-9,4v6c0,5.6,3.8,10.7,9,12c5.2-1.3,9-6.4,9-12V4L8,0z M8,11h7c-0.5,4.1-3.3,7.8-7,8.9V11l-7,0V5.3
			l7-3.1V11z"/>
		<path fill="#5C85DE" d="M8,0v22c5.2-1.3,9-6.4,9-12V4L8,0z M15,11c-0.5,4.1-3.3,7.8-7,8.9V11L15,11z"/>
		<path fill-rule="evenodd" fill="#3367D6" d="M17,11h-2c0,0,0,0.3-0.1,0.6L17,11z"/>
		<polygon fill-rule="evenodd" fill="#3367D6" points="-1,11 1,11 1,10.4 		"/>
	</g>
</g>
</svg>
`, Lk = '<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24"><defs><style>.cls-1{fill:#aecbfa;}.cls-2{fill:#669df6;}.cls-3{fill:#4285f4;}</style></defs><title>Icon_24px_VirtualPrivateCloud_Color</title><g data-name="Product Icons"><rect class="cls-1" x="16" y="2" width="6" height="6"/><rect class="cls-2" x="19" y="2" width="3" height="6"/><rect class="cls-1" x="16" y="16" width="6" height="6"/><rect class="cls-2" x="19" y="16" width="3" height="6"/><rect class="cls-1" x="2" y="2" width="6" height="6"/><rect class="cls-2" x="5" y="2" width="3" height="6"/><rect class="cls-1" x="2" y="16" width="6" height="6"/><rect class="cls-2" x="5" y="16" width="3" height="6"/><rect class="cls-2" x="8" y="4" width="8" height="2"/><rect class="cls-2" x="8" y="18" width="8" height="2"/><rect class="cls-2" x="18" y="8" width="2" height="8"/><rect class="cls-2" x="4" y="8" width="2" height="8"/><rect class="cls-3" x="4" y="8" width="2" height="2"/><rect class="cls-3" x="18" y="8" width="2" height="2"/><rect class="cls-3" x="8" y="4" width="2" height="2"/><rect class="cls-3" x="8" y="18" width="2" height="2"/></g></svg>', ak = '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24"><defs><style>.cls-1{filter:url(#luminosity-noclip);}.cls-2{fill:#669df6;}.cls-3{mask:url(#mask);}.cls-4{fill:#4285f4;}.cls-5{fill:#aecbfa;}</style><filter id="luminosity-noclip" x="4.64" y="4.19" width="14.73" height="12.76" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-color="#fff" result="bg"/><feBlend in="SourceGraphic" in2="bg"/></filter><mask id="mask" x="4.64" y="4.19" width="14.73" height="12.76" maskUnits="userSpaceOnUse"><circle class="cls-1" cx="12" cy="12.23" r="3.58"/></mask></defs><title>Icon_24px_Pub-Sub_Color</title><g data-name="Product Icons"><circle class="cls-2" cx="18.97" cy="8.21" r="1.72"/><circle class="cls-2" cx="5.03" cy="8.21" r="1.72"/><circle class="cls-2" cx="12" cy="20.28" r="1.72"/><g class="cls-3"><rect class="cls-4" x="14.69" y="10.22" width="1.59" height="8.04" transform="matrix(0.5, -0.87, 0.87, 0.5, -4.59, 20.53)"/><rect class="cls-4" x="4.49" y="13.45" width="8.04" height="1.59" transform="translate(-5.98 6.17) rotate(-30)"/><rect class="cls-4" x="11.2" y="4.19" width="1.59" height="8.04"/></g><circle class="cls-5" cx="12" cy="12.23" r="2.78"/><circle class="cls-5" cx="5.03" cy="16.25" r="2.19"/><circle class="cls-5" cx="18.97" cy="16.25" r="2.19"/><circle class="cls-5" cx="12" cy="4.19" r="2.19"/></g></svg>', Ck = '<svg id="Artwork" xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24"><circle cx="11.45" cy="11.51" r="2.89" style="fill:#669df6"/><path d="M18.05,6.81a8.12,8.12,0,0,0-4.94-3.23l-.27,1.3A6.79,6.79,0,1,1,6.65,6.74l-1-.94a8.1,8.1,0,1,0,13,2.12A1.31,1.31,0,0,1,18.05,6.81Z" style="fill:#aecbfa"/><path d="M14.46,20.42a2,2,0,1,1,0-3.93" style="fill:#669df6"/><path d="M14.46,16.49a2,2,0,1,1,0,3.93" style="fill:#4285f4"/><path d="M19.38,8.1a1.34,1.34,0,0,1,0-2.67v-1h0a2.38,2.38,0,0,0,0,4.75Z" style="fill:#669df6"/><path d="M19.38,5.43a1.34,1.34,0,0,1,0,2.67v1h0a2.38,2.38,0,0,0,0-4.75Z" style="fill:#4285f4"/><path d="M4.22,12.78a2,2,0,1,1,0-3.93" style="fill:#669df6"/><path d="M4.22,8.85a2,2,0,0,1,0,3.93" style="fill:#4285f4"/></svg>', ck = '<svg id="Artwork" xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24"><polygon points="11.19 11.35 15.75 3.51 6.75 3.51 2.25 11.35 11.19 11.35" style="fill:#aecbfa"/><polygon points="2.25 12.65 6.74 20.49 15.73 20.49 11.25 12.65 2.25 12.65" style="fill:#4285f4"/><path d="M21.75,12l-4.5-7.87L12.74,12l4.51,7.87Z" style="fill:#669df6"/></svg>', uk = '<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24"><defs><style>.cls-1{fill:none;}.cls-2{fill:#669df6;}.cls-3{fill:#aecbfa;}.cls-4{fill:#4285f4;}</style></defs><title>Icon_24px_VisionAPI_Color</title><g data-name="Product Icons"><g data-name="colored-32/vision"><rect class="cls-1" width="24" height="24"/><g ><polygon class="cls-2" points="6 12 12 16.99 12 20 2 12 6 12"/><polygon id="Shape-2" data-name="Shape" class="cls-2" points="12 16.99 18 12 22 12 12 20 12 16.99"/><polygon id="Shape-3" data-name="Shape" class="cls-3" points="2 12 12 4 12 7.01 6 12 2 12"/><polygon id="Shape-4" data-name="Shape" class="cls-3" points="12 7.01 18 12 22 12 12 4 12 7.01"/><circle id="Oval" class="cls-4" cx="12" cy="12" r="2"/></g></g></g></svg>', hk = `<?xml version="1.0" encoding="utf-8"?><!-- Uploaded to: SVG Repo, www.svgrepo.com, Generator: SVG Repo Mixer Tools -->
<svg width="800px" height="800px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M7.78799 2H16.212C17.0305 1.99999 17.7061 1.99998 18.2561 2.04565C18.8274 2.0931 19.3523 2.19496 19.8439 2.45035C20.5745 2.82985 21.1702 3.42553 21.5497 4.1561C21.805 4.64774 21.9069 5.17258 21.9543 5.74393C22 6.29394 22 6.96949 22 7.78802V11.212C22 12.0305 22 12.7061 21.9543 13.2561C21.9069 13.8274 21.805 14.3523 21.5497 14.8439C21.1702 15.5745 20.5745 16.1702 19.8439 16.5497C19.3523 16.805 18.8274 16.9069 18.2561 16.9544C17.7061 17 17.0305 17 16.212 17H13V19H17C17.5523 19 18 19.4477 18 20C18 20.5523 17.5523 21 17 21H7C6.44772 21 6 20.5523 6 20C6 19.4477 6.44772 19 7 19H11V17H7.78798C6.96946 17 6.29393 17 5.74393 16.9544C5.17258 16.9069 4.64774 16.805 4.1561 16.5497C3.42553 16.1702 2.82985 15.5745 2.45035 14.8439C2.19496 14.3523 2.0931 13.8274 2.04565 13.2561C1.99998 12.7061 1.99999 12.0305 2 11.212V7.78799C1.99999 6.96947 1.99998 6.29393 2.04565 5.74393C2.0931 5.17258 2.19496 4.64774 2.45035 4.1561C2.82985 3.42553 3.42553 2.82985 4.1561 2.45035C4.64774 2.19496 5.17258 2.0931 5.74393 2.04565C6.29393 1.99998 6.96947 1.99999 7.78799 2ZM16.17 15C17.041 15 17.6331 14.9992 18.0905 14.9612C18.536 14.9242 18.7634 14.8572 18.9219 14.7748C19.2872 14.5851 19.5851 14.2872 19.7748 13.9219C19.8572 13.7634 19.9242 13.536 19.9612 13.0905C19.9992 12.6331 20 12.041 20 11.17V7.83C20 6.95898 19.9992 6.36686 19.9612 5.90945C19.9242 5.46401 19.8572 5.23663 19.7748 5.07805C19.5851 4.71277 19.2872 4.41493 18.9219 4.22517C18.7634 4.1428 18.536 4.07578 18.0905 4.03879C17.6331 4.0008 17.041 4 16.17 4H7.83C6.95898 4 6.36686 4.0008 5.90945 4.03879C5.46401 4.07578 5.23663 4.1428 5.07805 4.22517C4.71277 4.41493 4.41493 4.71277 4.22517 5.07805C4.1428 5.23663 4.07578 5.46401 4.03879 5.90945C4.0008 6.36686 4 6.95898 4 7.83V11.17C4 12.041 4.0008 12.6331 4.03879 13.0905C4.07578 13.536 4.1428 13.7634 4.22517 13.9219C4.41493 14.2872 4.71277 14.5851 5.07805 14.7748C5.23663 14.8572 5.46401 14.9242 5.90945 14.9612C6.36686 14.9992 6.95898 15 7.83 15H16.17Z" fill="#0F1729"/>
</svg>`, dk = `<?xml version="1.0" encoding="utf-8"?><!-- Uploaded to: SVG Repo, www.svgrepo.com, Generator: SVG Repo Mixer Tools -->\r
<svg width="800px" height="800px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\r
<path d="M2 18C2 17.0681 2 16.6022 2.15224 16.2346C2.35523 15.7446 2.74458 15.3552 3.23463 15.1522C3.60218 15 4.06812 15 5 15H19C19.9319 15 20.3978 15 20.7654 15.1522C21.2554 15.3552 21.6448 15.7446 21.8478 16.2346C22 16.6022 22 17.0681 22 18C22 18.9319 22 19.3978 21.8478 19.7654C21.6448 20.2554 21.2554 20.6448 20.7654 20.8478C20.3978 21 19.9319 21 19 21H5C4.06812 21 3.60218 21 3.23463 20.8478C2.74458 20.6448 2.35523 20.2554 2.15224 19.7654C2 19.3978 2 18.9319 2 18Z" stroke="#1C274C" stroke-width="1.5"/>\r
<path d="M2 12C2 11.0681 2 10.6022 2.15224 10.2346C2.35523 9.74458 2.74458 9.35523 3.23463 9.15224C3.60218 9 4.06812 9 5 9H19C19.9319 9 20.3978 9 20.7654 9.15224C21.2554 9.35523 21.6448 9.74458 21.8478 10.2346C22 10.6022 22 11.0681 22 12C22 12.9319 22 13.3978 21.8478 13.7654C21.6448 14.2554 21.2554 14.6448 20.7654 14.8478C20.3978 15 19.9319 15 19 15H5C4.06812 15 3.60218 15 3.23463 14.8478C2.74458 14.6448 2.35523 14.2554 2.15224 13.7654C2 13.3978 2 12.9319 2 12Z" stroke="#1C274C" stroke-width="1.5"/>\r
<path d="M2 6C2 5.06812 2 4.60218 2.15224 4.23463C2.35523 3.74458 2.74458 3.35523 3.23463 3.15224C3.60218 3 4.06812 3 5 3H19C19.9319 3 20.3978 3 20.7654 3.15224C21.2554 3.35523 21.6448 3.74458 21.8478 4.23463C22 4.60218 22 5.06812 22 6C22 6.93188 22 7.39782 21.8478 7.76537C21.6448 8.25542 21.2554 8.64477 20.7654 8.84776C20.3978 9 19.9319 9 19 9H5C4.06812 9 3.60218 9 3.23463 8.84776C2.74458 8.64477 2.35523 8.25542 2.15224 7.76537C2 7.39782 2 6.93188 2 6Z" stroke="#1C274C" stroke-width="1.5"/>\r
<circle cx="5" cy="12" r="1" fill="#1C274C"/>\r
<circle cx="5" cy="6" r="1" fill="#1C274C"/>\r
<circle cx="5" cy="18" r="1" fill="#1C274C"/>\r
</svg>`, gk = `<?xml version="1.0" encoding="utf-8"?><!-- Uploaded to: SVG Repo, www.svgrepo.com, Generator: SVG Repo Mixer Tools -->\r
<svg width="800px" height="800px" viewBox="0 0 192 192" xmlns="http://www.w3.org/2000/svg" fill="none"><circle cx="96" cy="96" r="74" stroke="#000000" stroke-width="12"/><ellipse cx="96" cy="96" stroke="#000000" stroke-width="12" rx="30" ry="74"/><path stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-width="12" d="M28 72h136M28 120h136"/></svg>`, fk = `<?xml version="1.0" encoding="UTF-8"?>\r
\r
<!-- Uploaded to: SVG Repo, www.svgrepo.com, Generator: SVG Repo Mixer Tools -->\r
<svg width="800px" height="800px" viewBox="0 0 48 48" id="b" xmlns="http://www.w3.org/2000/svg">\r
\r
<defs>\r
\r
<style>.c{fill:none;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;}</style>\r
\r
</defs>\r
\r
<g>\r
\r
<path class="c" d="m7.1972,25.8996c.2982.3882.6722.5328,1.1924.5328h.72c.67,0,1.2132-.5432,1.2132-1.2132v-.0052c0-.67-.5431-1.2132-1.2132-1.2132h-.7942c-.6707,0-1.2145-.5437-1.2145-1.2145h0c0-.6722.5449-1.2171,1.2171-1.2171h.716c.5202,0,.8942.1446,1.1924.5328"/>\r
\r
<g>\r
\r
<g>\r
\r
<line class="c" x1="13.1777" y1="24.0005" x2="14.7631" y2="24.0005"/>\r
\r
<polyline class="c" points="15.1861 26.4319 12.7546 26.4319 12.7546 21.5687 15.1861 21.5687"/>\r
\r
<path class="c" d="m17.6177,26.4321v-4.8632h1.5921c.9001,0,1.6298.7312,1.6298,1.6333s-.7297,1.6333-1.6298,1.6333h-1.5921"/>\r
\r
<line class="c" x1="19.2104" y1="24.8357" x2="20.8019" y2="26.4309"/>\r
\r
<polyline class="c" points="26.4926 21.569 24.8817 26.4322 23.2707 21.569"/>\r
\r
<path class="c" d="m28.9246,21.5689v4.8634"/>\r
\r
</g>\r
\r
<path class="c" d="m34.5781,24.8216c0,.8897-.7212,1.6109-1.6109,1.6109s-1.6109-.7212-1.6109-1.6109v-1.6413c0-.8897.7212-1.6109,1.6109-1.6109h0c.8897,0,1.6109.7212,1.6109,1.6109"/>\r
\r
<line class="c" x1="37.0096" y1="24.0005" x2="38.595" y2="24.0005"/>\r
\r
<polyline class="c" points="39.4412 26.4319 37.0096 26.4319 37.0096 21.5687 39.4412 21.5687"/>\r
\r
</g>\r
\r
</g>\r
\r
<g>\r
\r
<path class="c" d="m28.8737,42.5l-4.4403-13.6619m-3.1416-9.6665l-4.4434-13.6716"/>\r
\r
<path class="c" d="m28.8737,42.5l4.4304-13.6315m3.1743-9.767l4.4206-13.6011"/>\r
\r
<path class="c" d="m16.8483,5.5002h24.0508"/>\r
\r
</g>\r
\r
</svg>`, pk = `<?xml version="1.0" ?>
\r<!-- Uploaded to: SVG Repo, www.svgrepo.com, Generator: SVG Repo Mixer Tools -->
<svg fill="#000000" width="800px" height="800px" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
\r<title/>
\r<g data-name="Joy Stick" id="Joy_Stick">
\r<path d="M20,18.5H12a1,1,0,0,1-1-1v-2a1,1,0,0,1,1-1h8a1,1,0,0,1,1,1v2A1,1,0,0,1,20,18.5Zm-7-2h0Z"/>
\r<path d="M52,18.5H44a1,1,0,0,1-1-1v-2a1,1,0,0,1,1-1h8a1,1,0,0,1,1,1v2A1,1,0,0,1,52,18.5Zm-7-2h0Z"/>
\r<path d="M55.7,49.5H49.58a7,7,0,0,1-6.5-4.13A11.4,11.4,0,0,0,32.62,38.5H31.38a11.4,11.4,0,0,0-10.46,6.87,7,7,0,0,1-6.5,4.13H8.3a4.33,4.33,0,0,1-4.2-5.41L11,17.25a1,1,0,0,1,1-.75H52a1,1,0,0,1,1,.75L59.9,44.09a4.33,4.33,0,0,1-4.2,5.41Zm-24.32-13h1.24a13.38,13.38,0,0,1,12.29,8.08,5,5,0,0,0,4.67,2.92H55.7A2.33,2.33,0,0,0,58,44.59L51.23,18.5H12.77L6,44.59A2.33,2.33,0,0,0,8.3,47.5h6.12a5,5,0,0,0,4.67-2.92A13.38,13.38,0,0,1,31.38,36.5Z"/>
\r<path d="M21,34.5H17a1,1,0,0,1-1-1v-2H14a1,1,0,0,1-1-1v-4a1,1,0,0,1,1-1h2v-2a1,1,0,0,1,1-1h4a1,1,0,0,1,1,1v2h2a1,1,0,0,1,1,1v4a1,1,0,0,1-1,1H22v2A1,1,0,0,1,21,34.5Zm-3-2h2v-2a1,1,0,0,1,1-1h2v-2H21a1,1,0,0,1-1-1v-2H18v2a1,1,0,0,1-1,1H15v2h2a1,1,0,0,1,1,1Z"/>
\r<path d="M46,26.5a2,2,0,1,1,2-2A2,2,0,0,1,46,26.5Zm0-2Z"/>
\r<path d="M46,34.5a2,2,0,1,1,2-2A2,2,0,0,1,46,34.5Zm0-2Z"/>
\r<path d="M50,30.5a2,2,0,1,1,2-2A2,2,0,0,1,50,30.5Zm0-2Z"/>
\r<path d="M42,30.5a2,2,0,1,1,2-2A2,2,0,0,1,42,30.5Zm0-2Z"/>
\r</g>
\r</svg>`, mk = `<?xml version="1.0" encoding="iso-8859-1"?>\r
<!-- Uploaded to: SVG Repo, www.svgrepo.com, Generator: SVG Repo Mixer Tools -->\r
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">\r
<svg fill="#000000" height="800px" width="800px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" \r
	 viewBox="0 0 380 380" xml:space="preserve">\r
<g>\r
	<path d="M91.425,157.435c-1.065-2.297-3.366-3.767-5.897-3.767c-0.005,0-0.01,0-0.015,0c-2.537,0.006-4.839,1.487-5.895,3.794\r
		L47.402,227.83c-1.494,3.264-0.06,7.122,3.204,8.616c0.877,0.401,1.797,0.591,2.702,0.591c2.464,0,4.821-1.409,5.914-3.796\r
		l8.08-17.649h36.75l8.193,17.677c1.51,3.257,5.373,4.674,8.631,3.164c3.257-1.51,4.673-5.374,3.164-8.631L91.425,157.435z\r
		 M73.254,202.592l12.311-26.888l12.462,26.888H73.254z"/>\r
	<path d="M166.496,152.865H135.07c-3.59,0-6.5,2.91-6.5,6.5v71.17c0,3.59,2.91,6.5,6.5,6.5c3.59,0,6.5-2.91,6.5-6.5V203.5h24.926\r
		c13.96,0,25.316-11.357,25.316-25.316C191.813,164.223,180.456,152.865,166.496,152.865z M166.496,190.5H141.57v-24.635h24.926\r
		c6.792,0,12.316,5.526,12.316,12.318C178.813,184.975,173.288,190.5,166.496,190.5z"/>\r
	<path d="M203.313,152.865c-3.59,0-6.5,2.91-6.5,6.5v71.17c0,3.59,2.91,6.5,6.5,6.5s6.5-2.91,6.5-6.5v-71.17\r
		C209.813,155.775,206.902,152.865,203.313,152.865z"/>\r
	<path d="M368.317,46.487H11.684C5.241,46.487,0,51.73,0,58.173v263.656c0,6.442,5.241,11.684,11.684,11.684h356.634\r
		c6.442,0,11.683-5.242,11.683-11.684V58.173C380,51.73,374.76,46.487,368.317,46.487z M280.949,259.268\r
		c5.162-12.192,17.053-20.07,30.295-20.07c4.411,0,8.721,0.878,12.813,2.61c16.696,7.072,24.529,26.408,17.461,43.105\r
		c-5.167,12.191-17.058,20.068-30.294,20.068c0,0,0,0-0.001,0c-4.411,0-8.721-0.878-12.81-2.611\r
		c-8.089-3.424-14.361-9.793-17.659-17.935C277.455,276.294,277.524,267.356,280.949,259.268z M320.868,79.771\r
		c6.844,0,12.387,5.547,12.387,12.387c0,6.842-5.543,12.387-12.387,12.387c-6.839,0-12.385-5.545-12.385-12.387\r
		C308.483,85.318,314.029,79.771,320.868,79.771z M283.715,79.771c6.839,0,12.386,5.547,12.386,12.387\r
		c0,6.842-5.547,12.387-12.386,12.387c-6.839,0-12.387-5.545-12.387-12.387C271.328,85.318,276.876,79.771,283.715,79.771z\r
		 M246.561,79.771c6.839,0,12.381,5.547,12.381,12.387c0,6.842-5.542,12.387-12.381,12.387c-6.844,0-12.387-5.545-12.387-12.387\r
		C234.175,85.318,239.718,79.771,246.561,79.771z M21.27,314.01V141.424H358.73v67.274c-1.537-2.202-3.677-4.02-6.327-5.143\r
		l-20.614-8.726c-1.835-0.778-3.771-1.172-5.754-1.172c-5.956,0-11.303,3.54-13.623,9.02l-1.253,2.959\r
		c-9.227,0.129-18.381,2.255-26.728,6.193l-2.426-2.107c-1.174-1.018-2.499-1.841-3.932-2.447c-1.841-0.779-3.782-1.174-5.771-1.174\r
		c-4.276,0-8.341,1.858-11.154,5.099l-14.671,16.915c-2.583,2.986-3.855,6.794-3.581,10.735c0.285,3.941,2.084,7.535,5.064,10.115\r
		l2.417,2.098c-2.755,8.849-3.563,18.179-2.365,27.344l-2.749,1.654c-6.981,4.2-9.242,13.302-5.039,20.293L249.044,315H22.26\r
		C21.714,315,21.27,314.556,21.27,314.01z"/>\r
</g>\r
</svg>`, wk = `<?xml version="1.0" encoding="iso-8859-1"?>\r
<!-- Uploaded to: SVG Repo, www.svgrepo.com, Generator: SVG Repo Mixer Tools -->\r
<svg fill="#000000" height="800px" width="800px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" \r
	 viewBox="0 0 56 56" xml:space="preserve">\r
<g>\r
	<g>\r
		<path d="M47,5c-3.7,0-6.882,2.245-8.264,5.444L26.117,3.561c-1.749-0.954-4.483-0.956-6.228-0.004L3.153,12.686\r
			C1.385,13.65,0,15.987,0,18.007v19.984c0,2.02,1.385,4.356,3.153,5.321l16.737,9.129c0.872,0.476,1.992,0.714,3.111,0.714\r
			s2.238-0.238,3.11-0.714l16.736-9.129C44.615,42.349,46,40.014,46,37.998V22.941C46.329,22.977,46.662,23,47,23\r
			c4.962,0,9-4.037,9-9S51.962,5,47,5z M44,22.597v15.4c0,1.283-0.986,2.946-2.111,3.56l-16.736,9.129\r
			c-1.147,0.625-3.16,0.625-4.306,0L4.111,41.557C2.986,40.944,2,39.278,2,37.992V18.007c0-1.286,0.986-2.952,2.111-3.565\r
			l16.736-9.129c1.146-0.627,3.162-0.624,4.312,0.004l12.991,7.085C38.057,12.922,38,13.454,38,14c0,3.918,2.521,7.25,6.023,8.483\r
			C44.018,22.522,44,22.557,44,22.597z M47,21c-3.86,0-7-3.141-7-7s3.14-7,7-7s7,3.141,7,7S50.86,21,47,21z"/>\r
		<path d="M47,9c-1.654,0-3,1.346-3,3c0,0.771,0.3,1.468,0.78,2c-0.48,0.532-0.78,1.229-0.78,2c0,1.654,1.346,3,3,3s3-1.346,3-3\r
			c0-0.771-0.3-1.468-0.78-2c0.48-0.532,0.78-1.229,0.78-2C50,10.345,48.654,9,47,9z M47,11c0.551,0,1,0.448,1,1s-0.449,1-1,1\r
			s-1-0.448-1-1S46.449,11,47,11z M47,17c-0.551,0-1-0.448-1-1s0.449-1,1-1s1,0.448,1,1S47.551,17,47,17z"/>\r
		<path d="M23,30.374c0,1.665-1.636,3.126-3.5,3.126S16,32.039,16,30.374V21h-5v9.374c0,4.48,3.813,8.126,8.5,8.126\r
			s8.5-3.646,8.5-8.126V21h-5V30.374z M25,30.374V23h1v7.374c0,3.378-2.916,6.126-6.5,6.126S13,33.752,13,30.374V23h1v7.374\r
			c0,2.778,2.519,5.126,5.5,5.126S25,33.152,25,30.374z"/>\r
		<path d="M30,38h5V21h-5V38z M32,23h1v13h-1V23z"/>\r
	</g>\r
</g>\r
</svg>`, xk = `<?xml version="1.0" encoding="utf-8"?>\r
\r
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">\r
<!-- Uploaded to: SVG Repo, www.svgrepo.com, Generator: SVG Repo Mixer Tools -->\r
<svg height="800px" width="800px" version="1.1" id="_x32_" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" \r
	 viewBox="0 0 512 512"  xml:space="preserve">\r
<style type="text/css">\r
	.st0{fill:#000000;}\r
</style>\r
<g>\r
	<path class="st0" d="M341.601,0H170.399c-29.292,0-53.121,23.828-53.121,53.121v405.756c0,29.292,23.83,53.123,53.121,53.123\r
		h171.202c29.292,0,53.121-23.83,53.121-53.119V53.121C394.722,23.828,370.893,0,341.601,0z M234.91,453.434\r
		c0-0.536,0.452-0.988,0.988-0.988H276.1c0.536,0,0.988,0.452,0.988,0.988v13.684c0,0.536-0.452,0.988-0.988,0.988h-40.202\r
		c-0.536,0-0.988-0.452-0.988-0.988V453.434z M277.088,429.684c0,0.536-0.452,0.988-0.988,0.988h-40.202\r
		c-0.536,0-0.988-0.452-0.988-0.988V416c0-0.534,0.452-0.984,0.988-0.984H276.1c0.536,0,0.988,0.45,0.988,0.984V429.684z\r
		 M277.088,392.25c0,0.545-0.443,0.988-0.988,0.988h-40.202c-0.546,0-0.988-0.442-0.988-0.988v-13.68\r
		c0-0.536,0.452-0.988,0.988-0.988H276.1c0.536,0,0.988,0.452,0.988,0.988V392.25z M255.999,351.476\r
		c-13.461,0-24.414-10.951-24.414-24.412c0-13.462,10.953-24.416,24.414-24.416c13.463,0,24.416,10.953,24.416,24.416\r
		C280.415,340.524,269.462,351.476,255.999,351.476z M170.397,36.304h171.202c10.004,0,18.142,8.137,18.142,18.144v225.136H152.257\r
		V54.449C152.257,44.441,160.395,36.304,170.397,36.304z M211.35,315.983v22.162h-43.742l-13.906-22.162H211.35z M203.025,429.684\r
		c0,0.536-0.452,0.988-0.986,0.988h-40.204c-0.534,0-0.986-0.452-0.986-0.988V416c0-0.542,0.443-0.984,0.986-0.984h40.204\r
		c0.544,0,0.986,0.443,0.986,0.984V429.684z M203.025,392.25c0,0.545-0.442,0.988-0.986,0.988h-40.204\r
		c-0.543,0-0.986-0.442-0.986-0.988v-13.68c0-0.536,0.452-0.988,0.986-0.988h40.204c0.534,0,0.986,0.452,0.986,0.988V392.25z\r
		 M160.849,467.118v-13.684c0-0.536,0.452-0.988,0.986-0.988h40.204c0.534,0,0.986,0.452,0.986,0.988v13.684\r
		c0,0.536-0.452,0.988-0.986,0.988h-40.204C161.302,468.106,160.849,467.654,160.849,467.118z M358.295,315.983l-13.905,22.162\r
		h-43.742v-22.162H358.295z M351.151,429.684c0,0.536-0.452,0.988-0.988,0.988h-40.202c-0.536,0-0.988-0.452-0.988-0.988V416\r
		c0-0.542,0.443-0.984,0.988-0.984h40.202c0.546,0,0.988,0.443,0.988,0.984V429.684z M351.151,392.25\r
		c0,0.545-0.442,0.988-0.988,0.988h-40.202c-0.545,0-0.988-0.442-0.988-0.988v-13.68c0-0.536,0.452-0.988,0.988-0.988h40.202\r
		c0.536,0,0.988,0.452,0.988,0.988V392.25z M308.973,467.118v-13.684c0-0.536,0.452-0.988,0.988-0.988h40.202\r
		c0.536,0,0.988,0.452,0.988,0.988v13.684c0,0.536-0.452,0.988-0.988,0.988h-40.202\r
		C309.425,468.106,308.973,467.654,308.973,467.118z"/>\r
</g>\r
</svg>`, _k = `<?xml version="1.0" encoding="utf-8"?><!--\r
 // 16pxls (c) by Paul mackenzie <paul@whatspauldoing.com>\r
 //\r
 // 16pxls is licensed under a\r
 // Creative Commons Attribution-ShareAlike 4.0 International License.\r
 //\r
 // You should have received a copy of the license along with this\r
 // work. If not, see <http://creativecommons.org/licenses/by-sa/4.0/>.\r
-->\r
\r
<svg fill="#000000" width="800px" height="800px" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">\r
    <path d="M14 3.5L8.5 9 7 7.5 12.5 2H10V0h6v6h-2V3.5zM6 0v2H2v12h12v-4h2v6H0V0h6z" fill-rule="evenodd"/>\r
</svg>`, vk = `<?xml version="1.0" ?>
\r<!-- Uploaded to: SVG Repo, www.svgrepo.com, Generator: SVG Repo Mixer Tools -->
<svg fill="#000000" width="800px" height="800px" viewBox="0 0 512 512" version="1.1" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
\r<g id="_x32_1_x2C__Application_x2C__bookmark_x2C__browser_x2C__favourite_x2C__page">
\r<g id="XMLID_858_">
\r<g id="XMLID_55_">
\r<path d="M241,276H96c-2.761,0-5-2.238-5-5v-70c0-2.761,2.239-5,5-5h145c2.761,0,5,2.239,5,5v70     C246,273.762,243.761,276,241,276z M101,266h135v-60H101V266z" id="XMLID_421_"/>
\r</g>
\r<g id="XMLID_868_">
\r<g id="XMLID_869_">
\r<g id="XMLID_54_">
\r<path d="M406,391H96c-2.761,0-5-2.238-5-5V146c0-2.761,2.239-5,5-5h310c2.762,0,5,2.239,5,5v240       C411,388.762,408.762,391,406,391z M101,381h300V151H101V381z" id="XMLID_414_"/>
\r</g>
\r<g id="XMLID_870_">
\r<g id="XMLID_871_">
\r<g id="XMLID_872_">
\r<g id="XMLID_873_">
\r<g id="XMLID_874_">
\r<g id="XMLID_875_">
\r<g id="XMLID_876_">
\r<g id="XMLID_53_">
\r<path d="M456,151H56c-2.761,0-5-2.239-5-5s2.239-5,5-5h400c2.762,0,5,2.239,5,5S458.762,151,456,151z" id="XMLID_418_"/>
\r</g>
\r<g id="XMLID_52_">
\r<path d="M426.499,446H85.501C66.477,446,51,430.523,51,411.499V101              c0-19.024,15.477-34.501,34.501-34.501H426.5c19.023,0,34.5,15.477,34.5,34.5v310.5              C461,430.523,445.522,446,426.499,446z M85.501,76.499C71.991,76.499,61,87.49,61,101v310.499              C61,425.009,71.991,436,85.501,436h340.998c13.51,0,24.501-10.991,24.501-24.501v-310.5c0-13.509-10.99-24.5-24.5-24.5              H85.501z" id="XMLID_415_"/>
\r</g>
\r<g id="XMLID_51_">
\r<path d="M411,131c-11.028,0-20-8.972-20-20s8.972-20,20-20s20,8.972,20,20S422.028,131,411,131z               M411,101c-5.514,0-10,4.486-10,10s4.486,10,10,10s10-4.486,10-10S416.514,101,411,101z" id="XMLID_411_"/>
\r</g>
\r<g id="XMLID_50_">
\r<path d="M361,131c-11.028,0-20-8.972-20-20s8.972-20,20-20s20,8.972,20,20S372.028,131,361,131z               M361,101c-5.514,0-10,4.486-10,10s4.486,10,10,10s10-4.486,10-10S366.514,101,361,101z" id="XMLID_408_"/>
\r</g>
\r<g id="XMLID_49_">
\r<path d="M311,131c-11.028,0-20-8.972-20-20s8.972-20,20-20s20,8.972,20,20S322.028,131,311,131z               M311,101c-5.514,0-10,4.486-10,10s4.486,10,10,10s10-4.486,10-10S316.514,101,311,101z" id="XMLID_405_"/>
\r</g>
\r<g id="XMLID_48_">
\r<path d="M141,151c-2.761,0-5-2.239-5-5V71c0-2.761,2.239-5,5-5s5,2.239,5,5v75              C146,148.761,143.761,151,141,151z" id="XMLID_404_"/>
\r</g>
\r</g>
\r</g>
\r</g>
\r</g>
\r</g>
\r</g>
\r</g>
\r</g>
\r</g>
\r<g id="XMLID_859_">
\r<g id="XMLID_47_">
\r<path d="M336,391c-41.355,0-75-33.645-75-75s33.645-75,75-75s75,33.645,75,75S377.355,391,336,391z M336,251      c-35.841,0-65,29.159-65,65s29.159,65,65,65s65-29.159,65-65S371.841,251,336,251z" id="XMLID_401_"/>
\r</g>
\r<g id="XMLID_46_">
\r<path d="M363.726,359.161c-1.031,0-2.063-0.318-2.938-0.955L336,340.198l-24.787,18.008      c-1.752,1.273-4.125,1.273-5.877,0c-1.753-1.273-2.486-3.53-1.816-5.59l9.467-29.139L288.2,305.469      c-1.753-1.273-2.486-3.53-1.816-5.59c0.669-2.061,2.589-3.455,4.755-3.455h30.639l9.468-29.139      c0.669-2.061,2.589-3.455,4.755-3.455s4.086,1.395,4.755,3.455l9.468,29.139h30.639c2.166,0,4.086,1.395,4.755,3.455      c0.67,2.06-0.063,4.316-1.816,5.59l-24.786,18.009l9.467,29.139c0.67,2.06-0.063,4.316-1.816,5.59      C365.788,358.843,364.757,359.161,363.726,359.161z M336,329.018c1.031,0,2.063,0.318,2.938,0.955l15.277,11.099l-5.835-17.959      c-0.67-2.06,0.063-4.316,1.816-5.59l15.275-11.099H346.59c-2.166,0-4.086-1.395-4.755-3.455L336,285.011l-5.835,17.958      c-0.669,2.061-2.589,3.455-4.755,3.455h-18.883l15.275,11.099c1.753,1.273,2.486,3.53,1.816,5.59l-5.835,17.959l15.277-11.099      C333.938,329.336,334.969,329.018,336,329.018z" id="XMLID_395_"/>
\r</g>
\r</g>
\r</g>
\r</g>
\r<g id="Layer_1"/>
\r</svg>`, Mk = `<?xml version="1.0" encoding="utf-8"?><!-- Uploaded to: SVG Repo, www.svgrepo.com, Generator: SVG Repo Mixer Tools -->
<svg fill="#000000" width="800px" height="800px" viewBox="0 0 32 32" id="icon" xmlns="http://www.w3.org/2000/svg">
  <defs>
    <style>
      .cls-1 {
        fill: none;
      }
    </style>
  </defs>
  <path d="M8,30H2V24H8ZM4,28H6V26H4Z" transform="translate(0 0)"/>
  <path d="M19,30H13V24h6Zm-4-2h2V26H15Z" transform="translate(0 0)"/>
  <path d="M30,30H24V24h6Zm-4-2h2V26H26Z" transform="translate(0 0)"/>
  <path d="M16,10a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,10Zm0-6a2,2,0,1,0,2,2A2.002,2.002,0,0,0,16,4Z" transform="translate(0 0)"/>
  <path d="M26,16H21a4.0045,4.0045,0,0,1-4-4H15a4.0045,4.0045,0,0,1-4,4H6a2.0023,2.0023,0,0,0-2,2v4H6V18h5A5.9694,5.9694,0,0,0,15,16.46V22h2V16.46A5.9694,5.9694,0,0,0,21,18h5v4h2V18A2.0023,2.0023,0,0,0,26,16Z" transform="translate(0 0)"/>
  <rect id="_Transparent_Rectangle_" data-name="&lt;Transparent Rectangle&gt;" class="cls-1" width="32" height="32"/>
</svg>`, Rk = `<?xml version="1.0" encoding="UTF-8" standalone="no"?>\r
<!-- Uploaded to: SVG Repo, www.svgrepo.com, Generator: SVG Repo Mixer Tools -->\r
<svg width="800px" height="800px" viewBox="0 -1 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\r
    \r
    <title>network_3 [#1116]</title>\r
    <desc>Created with Sketch.</desc>\r
    <defs>\r
\r
</defs>\r
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">\r
        <g id="Dribbble-Light-Preview" transform="translate(-140.000000, -3280.000000)" fill="#000000">\r
            <g id="icons" transform="translate(56.000000, 160.000000)">\r
                <path d="M92,3124 L96,3124 L96,3120 L92,3120 L92,3124 Z M92,3138 L96,3138 L96,3134 L92,3134 L92,3138 Z M100,3138 L104,3138 L104,3134 L100,3134 L100,3138 Z M84,3138 L88,3138 L88,3134 L84,3134 L84,3138 Z M87,3132 L85,3132 L85,3128 L93,3128 L93,3126 L95,3126 L95,3128 L103,3128 L103,3132 L101,3132 L101,3130 L95,3130 L95,3132 L93,3132 L93,3130 L87,3130 L87,3132 Z" id="network_3-[#1116]">\r
\r
</path>\r
            </g>\r
        </g>\r
    </g>\r
</svg>`, yk = `<?xml version="1.0" ?>
\r<!-- Uploaded to: SVG Repo, www.svgrepo.com, Generator: SVG Repo Mixer Tools -->
<svg width="800px" height="800px" viewBox="0 0 1000 1000" id="Layer_2" version="1.1" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
\r<g>
\r<path d="M152.09,182.23v58.88h695.82v-58.88c0-16.5-13.5-30-30-30H182.09   C165.59,152.23,152.09,165.73,152.09,182.23z M767,196.67c0-6.88,5.62-12.5,12.5-12.5h28.37c3.43,0,6.56,1.4,8.83,3.67   c2.26,2.27,3.67,5.39,3.67,8.83c0,6.87-5.63,12.5-12.5,12.5H779.5c-3.44,0-6.56-1.41-8.83-3.67C768.4,203.23,767,200.11,767,196.67   z M690.33,196.67c0-6.88,5.63-12.5,12.5-12.5h28.37c3.44,0,6.56,1.4,8.83,3.67c2.27,2.27,3.67,5.39,3.67,8.83   c0,6.87-5.62,12.5-12.5,12.5h-28.37c-3.43,0-6.56-1.41-8.83-3.67C691.74,203.23,690.33,200.11,690.33,196.67z M613.67,196.67   c0-6.88,5.62-12.5,12.5-12.5h28.37c3.44,0,6.56,1.4,8.83,3.67c2.26,2.27,3.67,5.39,3.67,8.83c0,6.87-5.63,12.5-12.5,12.5h-28.37   c-3.44,0-6.57-1.41-8.83-3.67C615.08,203.23,613.67,200.11,613.67,196.67z" style="fill:#231F20;"/>
\r<path d="M495.51,575.63c-84.49,0-152.99,18.06-152.99,40.33c0,0.39,0.03,0.77,0.07,1.16h-0.07v73.49   c0,22.28,68.5,40.34,152.99,40.34c84.5,0,153-18.06,153-40.34v-73.49h-0.07c0.04-0.39,0.07-0.77,0.07-1.16   C648.51,593.69,580.01,575.63,495.51,575.63z M382.25,678.29c-6.9,0-12.5-5.6-12.5-12.5c0-6.91,5.6-12.5,12.5-12.5   s12.5,5.59,12.5,12.5C394.75,672.69,389.15,678.29,382.25,678.29z" style="fill:#231F20;"/>
\r<path d="M647.74,728.72c-9.62,5.63-22.28,10.53-37.67,14.59c-30.92,8.15-71.6,12.64-114.56,12.64   c-42.95,0-83.63-4.49-114.55-12.64c-15.4-4.06-28.06-8.96-37.67-14.59c-0.51,1.34-0.77,2.69-0.77,4.07c0,0.38,0.03,0.77,0.07,1.15   h-0.07v73.5c0,22.27,68.5,40.33,152.99,40.33c84.5,0,153-18.06,153-40.33v-73.5h-0.07c0.04-0.38,0.07-0.77,0.07-1.15   C648.51,731.41,648.25,730.06,647.74,728.72z M382.25,800.74c-6.9,0-12.5-5.6-12.5-12.5c0-6.9,5.6-12.5,12.5-12.5   s12.5,5.6,12.5,12.5C394.75,795.14,389.15,800.74,382.25,800.74z" style="fill:#231F20;"/>
\r<path d="M495.51,345.96c-43.65,0-79.16,35.51-79.16,79.16c0,43.66,35.51,79.17,79.16,79.17   c43.6,0,79.07-35.42,79.17-78.99c0-0.06-0.01-0.12-0.01-0.18s0.01-0.12,0.01-0.18C574.58,381.37,539.11,345.96,495.51,345.96z    M540.19,456.08c-2.42,3.5-6.32,5.38-10.28,5.38c-2.46,0-4.94-0.72-7.11-2.22l-34.41-23.84c-3.37-2.34-5.38-6.18-5.38-10.28v-44.33   c0-6.9,5.6-12.5,12.5-12.5c6.91,0,12.5,5.6,12.5,12.5v37.79l29.03,20.11C542.71,442.62,544.13,450.41,540.19,456.08z" style="fill:#231F20;"/>
\r<path d="M152.09,630.6c0,16.5,13.5,30,30,30h135.43v-43.48c0-0.18,0-0.36,0.01-0.54   c-0.01-0.2-0.01-0.41-0.01-0.62c0-10.07,4.13-24.65,23.8-36.91c9.83-6.13,23.17-11.44,39.64-15.78   c27.9-7.36,63.76-11.73,102.05-12.51v-22.22c-47.46-5.71-85.21-43.45-90.91-90.92h-13.92c-6.9,0-12.5-5.59-12.5-12.5   c0-6.9,5.6-12.5,12.5-12.5h13.92c5.7-47.46,43.45-85.21,90.91-90.91v-13.92c0-6.9,5.6-12.5,12.5-12.5c6.91,0,12.5,5.6,12.5,12.5   v13.92c47.47,5.7,85.22,43.45,90.92,90.91h13.9c6.91,0,12.5,5.6,12.5,12.5c0,6.91-5.59,12.5-12.5,12.5h-13.9   c-5.7,47.47-43.45,85.21-90.92,90.92v22.22c38.3,0.78,74.16,5.15,102.06,12.51c16.47,4.34,29.81,9.65,39.64,15.78   c19.67,12.26,23.8,26.84,23.8,36.91c0,0.2,0,0.41-0.01,0.62c0.01,0.18,0.01,0.36,0.01,0.54v43.48h144.4c16.5,0,30-13.5,30-30   V266.11H152.09V630.6z M737.73,571.96c-2.27,2.26-5.39,3.67-8.83,3.67h-36.95c-6.88,0-12.5-5.63-12.5-12.5   c0-3.44,1.41-6.56,3.67-8.83c2.26-2.27,5.39-3.67,8.83-3.67h36.95c6.87,0,12.5,5.62,12.5,12.5   C741.4,566.57,739.99,569.69,737.73,571.96z M737.73,368.29c-2.27,2.26-5.39,3.67-8.83,3.67h-36.95c-6.88,0-12.5-5.63-12.5-12.5   c0-3.44,1.41-6.57,3.67-8.83c2.26-2.26,5.39-3.67,8.83-3.67h36.95c6.87,0,12.5,5.62,12.5,12.5   C741.4,362.89,739.99,366.02,737.73,368.29z M762,301.03c2.26-2.26,5.39-3.67,8.83-3.67h32.74c6.87,0,12.5,5.63,12.5,12.5   c0,3.44-1.41,6.57-3.67,8.83c-2.27,2.26-5.4,3.67-8.83,3.67h-32.74c-6.88,0-12.5-5.62-12.5-12.5   C758.33,306.43,759.74,303.3,762,301.03z M762,350.63c2.26-2.26,5.39-3.67,8.83-3.67h32.74c6.87,0,12.5,5.62,12.5,12.5   c0,3.43-1.41,6.56-3.67,8.83c-2.27,2.26-5.4,3.67-8.83,3.67h-32.74c-6.88,0-12.5-5.63-12.5-12.5   C758.33,356.02,759.74,352.89,762,350.63z M762,554.3c2.26-2.27,5.39-3.67,8.83-3.67h32.74c6.87,0,12.5,5.62,12.5,12.5   c0,3.44-1.41,6.56-3.67,8.83c-2.27,2.26-5.4,3.67-8.83,3.67h-32.74c-6.88,0-12.5-5.63-12.5-12.5   C758.33,559.69,759.74,556.57,762,554.3z M621.17,301.03c2.27-2.26,5.39-3.67,8.83-3.67h98.9c6.87,0,12.5,5.63,12.5,12.5   c0,3.44-1.41,6.57-3.67,8.83c-2.27,2.26-5.39,3.67-8.83,3.67H630c-6.88,0-12.5-5.62-12.5-12.5   C617.5,306.43,618.9,303.3,621.17,301.03z M253.29,301.03c2.27-2.26,5.39-3.67,8.83-3.67h98.9c6.88,0,12.5,5.63,12.5,12.5   c0,3.44-1.4,6.57-3.67,8.83s-5.39,3.67-8.83,3.67h-98.9c-6.87,0-12.5-5.62-12.5-12.5C249.62,306.43,251.03,303.3,253.29,301.03z    M253.29,350.63c2.27-2.26,5.39-3.67,8.83-3.67h36.95c6.88,0,12.5,5.62,12.5,12.5c0,3.43-1.41,6.56-3.67,8.83   c-2.26,2.26-5.39,3.67-8.83,3.67h-36.95c-6.87,0-12.5-5.63-12.5-12.5C249.62,356.02,251.03,352.89,253.29,350.63z M253.29,554.3   c2.27-2.27,5.39-3.67,8.83-3.67h36.95c6.88,0,12.5,5.62,12.5,12.5c0,3.44-1.41,6.56-3.67,8.83c-2.26,2.26-5.39,3.67-8.83,3.67   h-36.95c-6.87,0-12.5-5.63-12.5-12.5C249.62,559.69,251.03,556.57,253.29,554.3z M178.63,301.03c2.27-2.26,5.39-3.67,8.83-3.67   h32.73c6.88,0,12.5,5.63,12.5,12.5c0,3.44-1.41,6.57-3.67,8.83c-2.26,2.26-5.39,3.67-8.83,3.67h-32.73c-6.88,0-12.5-5.62-12.5-12.5   C174.96,306.43,176.36,303.3,178.63,301.03z M178.63,350.63c2.27-2.26,5.39-3.67,8.83-3.67h32.73c6.88,0,12.5,5.62,12.5,12.5   c0,3.43-1.41,6.56-3.67,8.83c-2.26,2.26-5.39,3.67-8.83,3.67h-32.73c-6.88,0-12.5-5.63-12.5-12.5   C174.96,356.02,176.36,352.89,178.63,350.63z M178.63,554.3c2.27-2.27,5.39-3.67,8.83-3.67h32.73c6.88,0,12.5,5.62,12.5,12.5   c0,3.44-1.41,6.56-3.67,8.83c-2.26,2.26-5.39,3.67-8.83,3.67h-32.73c-6.88,0-12.5-5.63-12.5-12.5   C174.96,559.69,176.36,556.57,178.63,554.3z" style="fill:#231F20;"/>
\r</g>
\r</svg>`, Ak = `<?xml version="1.0" encoding="utf-8"?><!-- Uploaded to: SVG Repo, www.svgrepo.com, Generator: SVG Repo Mixer Tools -->
<svg fill="#000000" height="800px" width="800px" id="Layer_1" data-name="Layer 1"\r
    xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">\r
    <path class="cls-1" d="M8,2a6,6,0,1,0,6,6A6,6,0,0,0,8,2Zm4.08905,2.52631h-1.868A5.59977,5.59977,0,0,0,9.36719,2.814,5.3637,5.3637,0,0,1,12.08905,4.52631ZM9.36719,13.186a5.5999,5.5999,0,0,0,.85388-1.71228h1.868A5.36312,5.36312,0,0,1,9.36719,13.186Zm3.18127-2.34387H10.402a10.65713,10.65713,0,0,0,.20782-1.1867l-.68676.3435c-.05.29419-.10639.57959-.17566.8432H8.23712l-1.26275.63159H9.55743C9.14484,12.6474,8.55414,13.36841,8,13.36841c-.51727,0-1.06445-.63373-1.47089-1.67206l-.56005.28015A5.01956,5.01956,0,0,0,6.63281,13.186,5.363,5.363,0,0,1,3.911,11.47369h.31671a.96008.96008,0,0,1-.01715-.17022V10.8421h-.759a5.32985,5.32985,0,0,1-.80408-2.5263h1.563V7.6842h-1.563A5.32943,5.32943,0,0,1,3.4516,5.1579h.759V4.69043a.95019.95019,0,0,1,.0166-.16412H3.911A5.36353,5.36353,0,0,1,6.63281,2.814,5.01929,5.01929,0,0,0,5.97,4.02106L6.53,4.30145c.40631-1.037.95312-1.66986,1.47-1.66986.55414,0,1.14484.72095,1.55743,1.89472H6.97913l1.26141.63159h1.5069c.06921.2633.12555.5484.17553.84234l.68683.34394A10.64628,10.64628,0,0,0,10.402,5.1579h2.14642a5.33,5.33,0,0,1,.804,2.5263h-.67127a.91929.91929,0,0,1-.00055.6316h.67182A5.33045,5.33045,0,0,1,12.54846,10.8421ZM11.929,7.71088,5.3338,4.40881a.32738.32738,0,0,0-.49164.28156v6.6131a.32677.32677,0,0,0,.32685.32794l.14831-.03516L11.915,8.29639a.32563.32563,0,0,0,.014-.58551ZM5.84229,10.21576V5.78021l4.43164,2.21973Z"/>\r
</svg>`, Zk = `<?xml version="1.0" encoding="utf-8"?><!-- Uploaded to: SVG Repo, www.svgrepo.com, Generator: SVG Repo Mixer Tools -->
<svg fill="#000000" width="800px" height="800px" viewBox="0 0 32 32" id="icon" xmlns="http://www.w3.org/2000/svg">
  <defs>
    <style>
      .cls-1 {
        fill: none;
      }
    </style>
  </defs>
  <path d="M28,28H4a2.0021,2.0021,0,0,1-2-2V21H4v5H28V21h2v5A2.0021,2.0021,0,0,1,28,28Z" transform="translate(0 0)"/>
  <rect x="7" y="21" width="18" height="2"/>
  <rect x="7" y="16" width="18" height="2"/>
  <rect x="7" y="11" width="18" height="2"/>
  <rect x="7" y="6" width="18" height="2"/>
  <rect id="_Transparent_Rectangle_" data-name="&lt;Transparent Rectangle&gt;" class="cls-1" width="32" height="32"/>
</svg>`, kk = `<?xml version="1.0" encoding="utf-8"?>\r
\r
<!-- Uploaded to: SVG Repo, www.svgrepo.com, Generator: SVG Repo Mixer Tools -->
<svg fill="#000000" height="800px" width="800px" version="1.1" id="Icons" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" \r
	 viewBox="0 0 32 32" xml:space="preserve">\r
<path d="M13,23c0-1.4,0.3-2.8,0.9-4c-0.2,0-0.4-0.1-0.5-0.2l-1.6-1.4l-5.1,4.4C6.5,21.9,6.2,22,6,22c-0.3,0-0.6-0.1-0.8-0.3\r
	c-0.4-0.4-0.3-1,0.1-1.4l4.9-4.2l-4.9-4.2c-0.4-0.4-0.5-1-0.1-1.4c0.4-0.4,1-0.5,1.4-0.1l7.3,6.4l7.3-6.4c0.4-0.4,1-0.3,1.4,0.1\r
	c0.4,0.4,0.3,1-0.1,1.4L21,13.2c0.6-0.1,1.3-0.2,2-0.2c1.4,0,2.8,0.3,4,0.8V9c0-1.7-1.3-3-3-3H4C2.3,6,1,7.3,1,9v14c0,1.7,1.3,3,3,3\r
	h9.5C13.2,25.1,13,24,13,23z"/>\r
<path d="M28.7,17.3c-3.1-3.1-8.2-3.1-11.3,0s-3.1,8.2,0,11.3s8.2,3.1,11.3,0S31.8,20.5,28.7,17.3z M26,24h-3c-0.6,0-1-0.4-1-1v-4\r
	c0-0.6,0.4-1,1-1s1,0.4,1,1v3h2c0.6,0,1,0.4,1,1S26.6,24,26,24z"/>\r
</svg>`, Tk = `<?xml version="1.0" encoding="iso-8859-1"?>\r
<!-- Uploaded to: SVG Repo, www.svgrepo.com, Generator: SVG Repo Mixer Tools -->\r
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">\r
<svg fill="#000000" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" \r
	 width="800px" height="800px" viewBox="0 0 493.862 493.862"\r
	 xml:space="preserve">\r
<g>\r
	<path d="M491.618,241.409h-4.588v-13.946h4.588c0.006,0.001,0.012,0.001,0.016,0c1.229,0,2.229-0.998,2.229-2.229\r
		c0-0.479-0.15-0.923-0.408-1.287l-6.702-12.064c-0.394-0.707-1.14-1.146-1.948-1.146H328.899v-34.123\r
		c0-0.025-0.007-0.047-0.008-0.072c1.609-1.525,2.62-3.676,2.62-6.063c0-2.387-1.011-4.538-2.62-6.063\r
		c0.001-0.024,0.008-0.047,0.008-0.072v-36.352c0-7.556-5.594-18.429-13.632-20.337V98.91c0-1.23-0.998-2.229-2.229-2.229\r
		c-1.231,0-2.229,0.998-2.229,2.229v8.641c-8.415,1.565-13.873,12.813-13.873,20.442c0,0.357,0.092,0.689,0.241,0.988v21.774\r
		h-47.906V104.25c0-1.231-0.997-2.229-2.228-2.229s-2.229,0.998-2.229,2.229v46.505h-48.146v-22.763\r
		c0-7.554-5.354-18.659-13.632-20.393v-8.69c0-1.23-0.998-2.229-2.229-2.229s-2.229,0.998-2.229,2.229v8.69\r
		c-8.278,1.734-13.632,12.838-13.632,20.393v36.352c0,0.025,0.006,0.047,0.007,0.071c-1.61,1.525-2.621,3.676-2.621,6.063\r
		c0,2.387,1.011,4.539,2.621,6.063c-0.001,0.024-0.007,0.046-0.007,0.071v34.123H9.044c-0.81,0-1.555,0.439-1.948,1.146\r
		l-6.816,12.271c-0.383,0.691-0.373,1.532,0.027,2.213s1.131,1.098,1.921,1.098h4.587v13.946H2.229c-0.79,0-1.521,0.417-1.921,1.098\r
		c-0.4,0.681-0.411,1.523-0.027,2.213l6.535,11.765v138.47c0,1.229,0.998,2.229,2.229,2.229h65.774c1.231,0,2.229-0.998,2.229-2.229\r
		v-44.306c0-2.388,0.761-4.669,2.202-6.599c0.505-0.679,0.584-1.583,0.204-2.337c-0.692-1.373-1.043-2.838-1.043-4.355\r
		c0-3.576,5.496-9.168,9.7-12.525c4.203,3.357,9.699,8.949,9.699,12.525c0,1.518-0.351,2.982-1.043,4.355\r
		c-0.38,0.754-0.301,1.658,0.204,2.337c1.441,1.93,2.203,4.211,2.203,6.599v44.306c0,1.229,0.998,2.229,2.229,2.229h65.774h27.265\r
		h28.719c1.231,0,2.229-0.998,2.229-2.229v-70.115c0-11.941,9.715-21.656,21.656-21.656c11.939,0,21.654,9.715,21.654,21.656v70.115\r
		c0,1.229,0.998,2.229,2.229,2.229h28.479h27.264h65.773c1.231,0,2.229-0.998,2.229-2.229v-44.306c0-2.388,0.763-4.669,2.203-6.599\r
		c0.506-0.679,0.584-1.583,0.204-2.337c-0.692-1.373-1.044-2.838-1.044-4.355c0-3.576,5.497-9.168,9.699-12.525\r
		c4.203,3.357,9.699,8.949,9.699,12.525c0,1.518-0.352,2.982-1.044,4.355c-0.381,0.754-0.302,1.658,0.204,2.337\r
		c1.44,1.93,2.202,4.211,2.202,6.599v44.306c0,1.229,0.998,2.229,2.229,2.229h65.774c1.231,0,2.229-0.998,2.229-2.229v-138.47\r
		l6.534-11.765c0.384-0.69,0.374-1.532-0.025-2.213C493.141,241.826,492.407,241.409,491.618,241.409z M482.573,241.409H329.14\r
		v-13.946h153.434V241.409z M280.846,241.409v-26.215h6.107v26.215H280.846z M270.281,241.409v-26.215h6.107v26.215H270.281z\r
		 M259.717,241.409v-26.215h6.105v26.215H259.717z M249.151,241.409v-26.215h6.107v26.215H249.151z M238.588,241.409v-26.215h6.107\r
		v26.215H238.588z M228.022,241.409v-26.215h6.108v26.215H228.022z M217.458,241.409v-26.215h6.107v26.215H217.458z\r
		 M206.893,241.409v-26.215H213v26.215H206.893z M196.997,241.409c-0.614-4.735-3.073-10.206-6.737-13.946h0.659\r
		c4.612,0,8.363-3.751,8.363-8.363c0-1.41-0.354-2.739-0.974-3.905h4.127v26.215L196.997,241.409L196.997,241.409z M166.792,170.479\r
		c0-2.154,1.752-3.906,3.906-3.906h20.221c2.154,0,3.906,1.752,3.906,3.906c0,2.154-1.752,3.906-3.906,3.906h-20.221\r
		C168.543,174.385,166.792,172.633,166.792,170.479z M196.669,178.843h100.509v31.895H196.669V178.843z M327.054,170.479\r
		c0,2.154-1.752,3.906-3.905,3.906h-20.221c-2.154,0-3.906-1.752-3.906-3.906c0-2.154,1.752-3.906,3.906-3.906h20.221\r
		C325.302,166.574,327.054,168.326,327.054,170.479z M302.928,215.193h20.221c2.153,0,3.905,1.752,3.905,3.905\r
		c0,2.154-1.752,3.906-3.905,3.906h-20.221c-2.154,0-3.906-1.752-3.906-3.906C299.021,216.947,300.773,215.193,302.928,215.193z\r
		 M323.148,227.463h1.293v2.633c-0.671-0.942-1.403-1.827-2.192-2.633H323.148z M312.797,227.463\r
		c5.298,0,10.489,7.198,11.645,13.639v0.307h-1.293h-20.221h-1.362C302.537,234.8,307.526,227.463,312.797,227.463z\r
		 M192.504,241.409h-1.586h-20.221h-1.121c0.97-6.609,5.96-13.946,11.231-13.946C186.19,227.463,191.462,234.892,192.504,241.409z\r
		 M170.698,223.006c-2.154,0-3.906-1.752-3.906-3.906c0-2.153,1.752-3.905,3.906-3.905h20.221c2.154,0,3.906,1.752,3.906,3.905\r
		c0,2.154-1.752,3.906-3.906,3.906H170.698z M170.698,227.463h0.815c-0.762,0.806-1.465,1.691-2.107,2.632v-2.632H170.698z\r
		 M166.792,249.771c0-2.152,1.752-3.906,3.906-3.906h20.221c2.154,0,3.906,1.751,3.906,3.906s-1.752,3.905-3.906,3.905h-20.221\r
		C168.543,253.677,166.792,251.925,166.792,249.771z M291.411,215.193h4.128c-0.62,1.167-0.975,2.495-0.975,3.905\r
		c0,4.612,3.751,8.363,8.363,8.363h0.573c-3.549,3.751-5.847,9.24-6.42,13.946h-5.672v-26.214H291.411z M299.021,249.771\r
		c0-2.152,1.752-3.906,3.906-3.906h20.221c2.153,0,3.905,1.751,3.905,3.906s-1.752,3.905-3.905,3.905h-20.221\r
		C300.773,253.677,299.021,251.925,299.021,249.771z M487.831,223.006h-3.028H330.539c0.618-1.167,0.974-2.495,0.974-3.906\r
		c0-1.41-0.354-2.739-0.974-3.905H483.49L487.831,223.006z M324.441,178.843v31.895h-1.293h-20.221h-1.293v-31.895h1.293h20.221\r
		H324.441z M302.928,162.116h-1.293v-31.894h22.807v31.895h-1.293L302.928,162.116L302.928,162.116z M312.797,111.817\r
		c5.271,0,10.438,7.429,11.46,13.946h-22.691C302.537,119.155,307.526,111.817,312.797,111.817z M296.937,155.213v9.443\r
		c-1.466,1.507-2.372,3.56-2.372,5.823c0,1.41,0.354,2.739,0.975,3.906h-97.23c0.62-1.167,0.974-2.496,0.974-3.906\r
		c0-2.384-1.007-4.532-2.612-6.056v-0.079v-9.131H296.937z M180.808,111.817c5.271,0,10.261,7.337,11.231,13.946h-22.462\r
		C170.547,119.155,175.538,111.817,180.808,111.817z M169.405,162.116v-31.894h22.807v22.763v9.132h-1.293h-20.221L169.405,162.116\r
		L169.405,162.116z M190.918,178.843h1.293v31.895h-1.293h-18.971h-1.25h-1.292v-31.895h1.292H190.918z M10.355,215.193h152.952\r
		c-0.619,1.167-0.974,2.495-0.974,3.905c0,1.411,0.354,2.74,0.974,3.906H9.044H6.017L10.355,215.193z M11.273,227.463h153.674\r
		v13.946H11.273V227.463z M9.044,245.866h154.263c-0.619,1.167-0.974,2.496-0.974,3.906c0,1.411,0.354,2.739,0.974,3.905H10.355\r
		l-4.339-7.811H9.044z M101.298,342.488c0.644-1.639,0.969-3.358,0.969-5.131c0-7.5-11.524-16.169-12.839-17.133\r
		c-0.784-0.576-1.851-0.576-2.635,0c-1.314,0.964-12.839,9.633-12.839,17.133c0,1.771,0.325,3.492,0.969,5.131\r
		c-1.53,2.456-2.333,5.251-2.333,8.16v42.076H11.273v-134.59h153.674v134.59h-61.317v-42.076\r
		C103.63,347.739,102.828,344.944,101.298,342.488z M169.405,392.725v-134.59h1.292h20.221h1.293v134.59H169.405z M247.043,298.725\r
		c-14.398,0-26.113,11.714-26.113,26.113v67.887h-24.262V255.906c0-0.023-0.006-0.048-0.007-0.07c1.609-1.525,2.62-3.676,2.62-6.063\r
		c0-1.409-0.354-2.737-0.974-3.906h97.23c-0.62,1.167-0.975,2.497-0.975,3.906c0,2.388,1.011,4.539,2.62,6.063\r
		c-0.001,0.023-0.007,0.047-0.007,0.07v136.818h-24.021v-67.887C273.156,310.438,261.441,298.725,247.043,298.725z M301.635,258.135\r
		h1.293h20.221h1.293v134.59h-22.807V258.135z M482.573,392.725h-61.316v-42.076c0-2.909-0.803-5.704-2.333-8.16\r
		c0.644-1.639,0.97-3.358,0.97-5.131c0-7.5-11.523-16.169-12.838-17.133c-0.785-0.576-1.852-0.576-2.637,0\r
		c-1.313,0.964-12.839,9.633-12.839,17.133c0,1.771,0.325,3.492,0.97,5.131c-1.53,2.456-2.333,5.251-2.333,8.16v42.076H328.9\r
		v-134.59h153.674L482.573,392.725L482.573,392.725z M483.49,253.677H330.539c0.618-1.166,0.974-2.494,0.974-3.905\r
		c0-1.41-0.354-2.738-0.974-3.906h154.264h3.028L483.49,253.677z"/>\r
</g>\r
</svg>`, Sk = `<?xml version="1.0" encoding="utf-8"?><!-- Uploaded to: SVG Repo, www.svgrepo.com, Generator: SVG Repo Mixer Tools -->\r
<svg width="800px" height="800px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\r
<path fill-rule="evenodd" clip-rule="evenodd" d="M10 5C8.34315 5 7 6.34315 7 8C7 9.65685 8.34315 11 10 11C11.6569 11 13 9.65685 13 8C13 6.34315 11.6569 5 10 5ZM13.5058 11.565C14.4281 10.6579 15 9.39576 15 8C15 5.23858 12.7614 3 10 3C7.23858 3 5 5.23858 5 8C5 9.39827 5.57396 10.6625 6.49914 11.5699C3.74942 12.5366 2 14.6259 2 17C2 17.5523 2.44772 18 3 18C3.55228 18 4 17.5523 4 17C4 15.2701 5.93073 13 10 13C12.6152 13 14.4051 13.9719 15.2988 15.1157C15.6389 15.5509 16.2673 15.628 16.7025 15.288C17.1377 14.9479 17.2148 14.3195 16.8748 13.8843C16.0904 12.8804 14.9401 12.0686 13.5058 11.565ZM22.6139 15.2106C23.0499 15.5497 23.1284 16.178 22.7894 16.6139L18.1227 22.6139C17.9485 22.8379 17.6875 22.9773 17.4045 22.9975C17.1216 23.0177 16.8434 22.9167 16.6392 22.7198L14.3059 20.4698C13.9083 20.0865 13.8968 19.4534 14.2802 19.0559C14.6635 18.6583 15.2966 18.6468 15.6941 19.0302L17.2268 20.5081L21.2106 15.3861C21.5497 14.9501 22.178 14.8716 22.6139 15.2106Z" fill="#000000"/>\r
</svg>`, bk = `<?xml version="1.0" encoding="utf-8"?>\r
\r
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">\r
<!-- Uploaded to: SVG Repo, www.svgrepo.com, Generator: SVG Repo Mixer Tools -->\r
<svg fill="#000000" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" \r
	 width="800px" height="800px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve">\r
<path d="M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r
	c-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"/>\r
<path d="M256,176H128v160h128h128V176H256z M256,192h89.719L256,255.75L166.281,192H256z M144,196.531l54.5,36.859L144,292.812\r
	V196.531z M256,320h-92.406l45.562-79.422L256,272.25l46.844-31.672L348.406,320H256z M368,292.812l-54.5-59.422l54.5-36.859\r
	V292.812z"/>\r
</svg>`, Ek = `<?xml version="1.0" encoding="utf-8"?><!-- Uploaded to: SVG Repo, www.svgrepo.com, Generator: SVG Repo Mixer Tools -->\r
<svg width="800px" height="800px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">\r
  <title>github</title>\r
  <rect width="24" height="24" fill="none"/>\r
  <path d="M12,2A10,10,0,0,0,8.84,21.5c.5.08.66-.23.66-.5V19.31C6.73,19.91,6.14,18,6.14,18A2.69,2.69,0,0,0,5,16.5c-.91-.62.07-.6.07-.6a2.1,2.1,0,0,1,1.53,1,2.15,2.15,0,0,0,2.91.83,2.16,2.16,0,0,1,.63-1.34C8,16.17,5.62,15.31,5.62,11.5a3.87,3.87,0,0,1,1-2.71,3.58,3.58,0,0,1,.1-2.64s.84-.27,2.75,1a9.63,9.63,0,0,1,5,0c1.91-1.29,2.75-1,2.75-1a3.58,3.58,0,0,1,.1,2.64,3.87,3.87,0,0,1,1,2.71c0,3.82-2.34,4.66-4.57,4.91a2.39,2.39,0,0,1,.69,1.85V21c0,.27.16.59.67.5A10,10,0,0,0,12,2Z"/>\r
</svg>`, Ik = `<?xml version="1.0" encoding="utf-8"?><!-- Uploaded to: SVG Repo, www.svgrepo.com, Generator: SVG Repo Mixer Tools -->
<svg width="800px" height="800px" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none"><path fill="#000000" d="M12.342 4.536l.15-.227.262.159.116.083c.28.216.869.768.996 1.684.223-.04.448-.06.673-.06.534 0 .893.124 1.097.227l.105.057.068.045.191.156-.066.2a2.044 2.044 0 01-.47.73c-.29.299-.8.652-1.609.698l-.178.005h-.148c-.37.977-.867 2.078-1.702 3.066a7.081 7.081 0 01-1.74 1.488 7.941 7.941 0 01-2.549.968c-.644.125-1.298.187-1.953.185-1.45 0-2.73-.288-3.517-.792-.703-.449-1.243-1.182-1.606-2.177a8.25 8.25 0 01-.461-2.83.516.516 0 01.432-.516l.068-.005h10.54l.092-.007.149-.016c.256-.034.646-.11.92-.27-.328-.543-.421-1.178-.268-1.854a3.3 3.3 0 01.3-.81l.108-.187zM2.89 5.784l.04.007a.127.127 0 01.077.082l.006.04v1.315l-.006.041a.127.127 0 01-.078.082l-.039.006H1.478a.124.124 0 01-.117-.088l-.007-.04V5.912l.007-.04a.127.127 0 01.078-.083l.039-.006H2.89zm1.947 0l.039.007a.127.127 0 01.078.082l.006.04v1.315l-.007.041a.127.127 0 01-.078.082l-.039.006H3.424a.125.125 0 01-.117-.088L3.3 7.23V5.913a.13.13 0 01.085-.123l.039-.007h1.413zm1.976 0l.039.007a.127.127 0 01.077.082l.007.04v1.315l-.007.041a.127.127 0 01-.078.082l-.039.006H5.4a.124.124 0 01-.117-.088l-.006-.04V5.912l.006-.04a.127.127 0 01.078-.083l.039-.006h1.413zm1.952 0l.039.007a.127.127 0 01.078.082l.007.04v1.315a.13.13 0 01-.085.123l-.04.006H7.353a.124.124 0 01-.117-.088l-.006-.04V5.912l.006-.04a.127.127 0 01.078-.083l.04-.006h1.412zm1.97 0l.039.007a.127.127 0 01.078.082l.006.04v1.315a.13.13 0 01-.085.123l-.039.006H9.322a.124.124 0 01-.117-.088l-.006-.04V5.912l.006-.04a.127.127 0 01.078-.083l.04-.006h1.411zM4.835 3.892l.04.007a.127.127 0 01.077.081l.007.041v1.315a.13.13 0 01-.085.123l-.039.007H3.424a.125.125 0 01-.117-.09l-.007-.04V4.021a.13.13 0 01.085-.122l.039-.007h1.412zm1.976 0l.04.007a.127.127 0 01.077.081l.007.041v1.315a.13.13 0 01-.085.123l-.039.007H5.4a.125.125 0 01-.117-.09l-.006-.04V4.021l.006-.04a.127.127 0 01.078-.082l.039-.007h1.412zm1.953 0c.054 0 .1.037.117.088l.007.041v1.315a.13.13 0 01-.085.123l-.04.007H7.353a.125.125 0 01-.117-.09l-.006-.04V4.021l.006-.04a.127.127 0 01.078-.082l.04-.007h1.412zm0-1.892c.054 0 .1.037.117.088l.007.04v1.316a.13.13 0 01-.085.123l-.04.006H7.353a.124.124 0 01-.117-.088l-.006-.04V2.128l.006-.04a.127.127 0 01.078-.082L7.353 2h1.412z"/></svg>`, Fk = `<?xml version="1.0" encoding="utf-8"?><!-- Uploaded to: SVG Repo, www.svgrepo.com, Generator: SVG Repo Mixer Tools -->\r
<svg width="800px" height="800px" viewBox="0 0 48 48" id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg"><defs><style>.cls-1{fill:none;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;}</style></defs><path id="path50" class="cls-1" d="M24,42h0l7.18-22.1H16.82L24,42Z"/><path id="path66" class="cls-1" d="M6.76,19.86h0L4.57,26.57a1.5,1.5,0,0,0,.54,1.67L24,42,6.76,19.86Z"/><path id="path74" class="cls-1" d="M6.76,19.86H16.82L12.49,6.55a.74.74,0,0,0-1.41,0L6.76,19.86Z"/><path id="path82" class="cls-1" d="M41.25,19.86h0l2.18,6.71a1.5,1.5,0,0,1-.54,1.67L24,42l17.25-22.1Z"/><path id="path86" class="cls-1" d="M41.25,19.86H31.18L35.51,6.55a.74.74,0,0,1,1.41,0l4.33,13.31Z"/><polygon class="cls-1" points="24 41.96 31.18 19.86 41.25 19.86 24 41.96"/><polygon class="cls-1" points="24 41.96 6.76 19.86 16.82 19.86 24 41.96"/></svg>`, Ok = `<?xml version="1.0" encoding="utf-8"?>

<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<!-- Uploaded to: SVG Repo, www.svgrepo.com, Generator: SVG Repo Mixer Tools -->
<svg width="800px" height="800px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
<path fill="#444444" d="M16.392 2.991c-0.627 0.053-1.097 0.14-1.539 0.283-0.27 0.088-0.859 0.311-1.073 0.406-0.173 0.076-0.928 0.491-1.406 0.77-0.834 0.488-1.265 0.952-1.466 1.582-0.040 0.123-0.057 0.153-0.097 0.175-0.198 0.108-0.386 0.276-0.513 0.459-0.195 0.285-0.335 0.726-0.379 1.198-0.010 0.11-0.023 0.238-0.027 0.286l-0.008 0.086-0.195 0.171c-0.536 0.473-1.11 1.118-1.534 1.727-0.879 1.261-1.469 2.767-1.679 4.277-0.075 0.544-0.092 0.8-0.092 1.423s0.017 0.878 0.092 1.423c0.136 0.985 0.453 2.018 0.897 2.94 0.521 1.080 1.288 2.118 2.147 2.909l0.245 0.225 0.020 0.313c0.012 0.171 0.028 0.517 0.035 0.769 0.018 0.582 0.042 0.682 0.186 0.805 0.083 0.071 0.216 0.136 0.488 0.238 0.11 0.042 0.458 0.201 0.774 0.354 0.802 0.391 1.062 0.496 1.461 0.592 0.28 0.068 0.344 0.076 0.709 0.088l0.349 0.010 0.113 0.391c0.205 0.699 0.376 1.266 0.471 1.556 0.118 0.358 0.273 0.777 0.298 0.8 0.025 0.027 0.271 0.1 0.529 0.158 0.93 0.21 2.38 0.238 3.766 0.072 0.469-0.057 0.792-0.233 0.907-0.494 0.030-0.067 0.032-0.090 0.017-0.19-0.008-0.062-0.022-0.208-0.027-0.323l-0.012-0.21 0.148-0.028c0.484-0.093 0.726-0.22 0.832-0.436 0.035-0.073 0.045-0.121 0.052-0.261 0.012-0.215-0.008-0.353-0.113-0.819-0.142-0.614-0.17-0.847-0.133-1.068l0.021-0.12 0.105-0.035c0.225-0.075 0.325-0.186 0.325-0.364v-0.086l0.105-0.048c0.25-0.113 0.524-0.165 0.927-0.178l0.291-0.008 0.047 0.082c0.027 0.043 0.075 0.113 0.11 0.153 0.062 0.072 0.065 0.073 0.236 0.103 0.523 0.090 1.060 0.091 1.469 0.005 0.318-0.067 0.424-0.12 0.586-0.293 0.301-0.325 0.509-0.949 0.508-1.536 0-0.26-0.015-0.351-0.12-0.716-0.146-0.507-0.336-1.023-0.478-1.298-0.088-0.171-0.225-0.321-0.373-0.409-0.053-0.030-0.096-0.062-0.096-0.070 0-0.007 0.038-0.080 0.085-0.163 0.133-0.236 0.399-0.797 0.513-1.075 0.389-0.97 0.612-1.932 0.702-3.034 0.025-0.309 0.025-1.135 0-1.448-0.088-1.093-0.311-2.060-0.702-3.033-0.13-0.323-0.454-0.983-0.631-1.285-0.403-0.684-0.894-1.328-1.448-1.897l-0.259-0.266-0.030-0.329c-0.101-1.155-0.373-2.098-0.782-2.724-0.298-0.456-0.913-1.115-1.466-1.569-0.657-0.541-1.453-0.845-2.571-0.985-0.198-0.025-1.13-0.047-1.315-0.032zM17.649 3.619c0.637 0.103 1.268 0.301 1.835 0.579 0.399 0.196 0.601 0.344 0.927 0.681 0.228 0.236 0.812 0.963 0.845 1.053 0.012 0.028 0.005 0.030-0.067 0.020-0.304-0.040-0.454-0.028-0.629 0.055-0.215 0.1-0.336 0.27-0.345 0.481-0.002 0.038 0.002 0.075 0.007 0.080s0.037-0.010 0.072-0.033c0.131-0.090 0.233-0.117 0.449-0.117 0.181 0 0.215 0.005 0.358 0.055 0.228 0.077 0.398 0.183 0.574 0.359 0.321 0.319 0.431 0.699 0.491 1.706 0.030 0.486 0.040 1.459 0.018 1.764-0.095 1.343-0.451 2.588-1.008 3.534-0.123 0.21-0.552 0.852-0.656 0.982-0.138 0.171-0.318 0.333-0.518 0.463-0.601 0.391-1.233 0.646-1.824 0.739-0.241 0.037-0.691 0.037-0.905 0-0.228-0.040-0.567-0.16-0.874-0.309-0.8-0.391-1.338-0.909-2.201-2.122l-0.106-0.15 0.010 0.083c0.051 0.373 0.268 0.755 0.707 1.256 0.507 0.576 0.879 0.915 1.2 1.095 0.060 0.033 0.12 0.072 0.133 0.085 0.022 0.020 0.013 0.022-0.058 0.012-0.047-0.005-0.176-0.015-0.291-0.020-0.338-0.017-0.562 0.053-0.674 0.208l-0.050 0.070-0.175-0.010c-0.97-0.055-1.557-0.235-1.907-0.586-0.381-0.381-0.927-1.646-1.047-2.428-0.040-0.253-0.030-0.278 0.16-0.484 0.21-0.226 0.246-0.309 0.196-0.454-0.018-0.052-0.022-0.053-0.093-0.043-0.097 0.013-0.151 0.042-0.329 0.178-0.082 0.062-0.171 0.122-0.2 0.131-0.155 0.060-0.409 0.050-0.589-0.023-0.448-0.181-0.852-0.767-0.973-1.408-0.035-0.181-0.035-0.506 0-0.647 0.080-0.325 0.293-0.617 0.566-0.777 0.198-0.117 0.471-0.17 0.706-0.142 0.376 0.048 0.584 0.3 0.737 0.895l0.055 0.213 0.18-0.003c0.298-0.003 0.539-0.083 0.631-0.208 0.033-0.043 0.033-0.048 0.005-0.233-0.017-0.103-0.061-0.316-0.101-0.471-0.19-0.751-0.188-0.87 0.032-1.922 0.102-0.486 0.128-0.686 0.13-0.94 0.002-0.238-0.028-0.426-0.095-0.624-0.023-0.067-0.042-0.141-0.042-0.165 0-0.055 0.111-0.258 0.25-0.454 0.138-0.198 0.576-0.639 0.832-0.835 0.243-0.188 0.691-0.484 0.982-0.649 0.869-0.493 1.176-0.581 1.988-0.567 0.344 0.005 0.461 0.013 0.682 0.048zM14.321 4.080c0.088 0.070 0.020 0.193-0.135 0.243-0.060 0.018-0.113 0.053-0.178 0.115-0.052 0.048-0.17 0.146-0.265 0.216-0.261 0.196-0.348 0.295-0.544 0.621-0.213 0.353-0.316 0.489-0.413 0.551-0.098 0.063-0.188 0.075-0.378 0.052-0.2-0.027-0.303-0.010-0.662 0.108-0.313 0.101-0.429 0.125-0.429 0.088 0-0.013 0.037-0.087 0.083-0.161 0.321-0.541 0.924-1.047 1.722-1.448 0.288-0.145 0.461-0.218 0.782-0.33 0.28-0.098 0.348-0.106 0.416-0.055zM12.617 6.27c0.065 0.171 0.087 0.304 0.095 0.576 0.008 0.316-0.007 0.496-0.088 1.018-0.090 0.586-0.098 0.667-0.098 0.965 0 0.315 0.012 0.393 0.108 0.721 0.075 0.256 0.098 0.454 0.065 0.536-0.023 0.056-0.077 0.091-0.168 0.108l-0.060 0.012-0.012-0.113c-0.030-0.298-0.18-0.566-0.423-0.759-0.24-0.19-0.504-0.283-0.81-0.283-0.213 0-0.363 0.033-0.572 0.13-0.075 0.033-0.138 0.058-0.143 0.053-0.022-0.022-0.047-0.471-0.048-0.845 0-0.341 0.005-0.458 0.030-0.589 0.082-0.444 0.225-0.699 0.547-0.97 0.338-0.283 0.712-0.464 1.138-0.553 0.211-0.043 0.23-0.047 0.335-0.050 0.080-0.002 0.088 0.002 0.105 0.043zM9.948 8.998c0.017 0.015 0.027 0.058 0.028 0.115 0 0.050 0.007 0.091 0.015 0.091 0.007 0 0.012 0.037 0.012 0.083 0 0.045-0.007 0.083-0.015 0.083-0.007 0-0.010 0.018-0.007 0.038 0.005 0.023-0.003 0.052-0.018 0.067-0.015 0.013-0.027 0.033-0.027 0.043s-0.007 0.018-0.017 0.018c-0.008 0-0.017 0.010-0.017 0.023s-0.012 0.027-0.025 0.033c-0.013 0.005-0.025 0.020-0.025 0.033s-0.010 0.032-0.023 0.038c-0.022 0.013-0.143 0.361-0.143 0.413 0 0.013-0.005 0.025-0.012 0.025-0.008 0-0.013 0.025-0.015 0.053 0 0.030-0.010 0.145-0.022 0.255-0.052 0.486 0.083 1.158 0.334 1.664 0.288 0.578 0.782 0.983 1.336 1.097l0.1 0.022 0.005 0.065c0.025 0.354 0.175 0.795 0.378 1.113 0.208 0.326 0.273 0.519 0.225 0.666-0.035 0.108-0.13 0.178-0.591 0.441-0.975 0.557-1.657 0.968-1.98 1.196-0.091 0.065-0.301 0.188-0.464 0.271-0.426 0.22-0.557 0.353-0.586 0.596-0.020 0.171 0.065 0.512 0.253 1.023 0.060 0.165 0.153 0.424 0.206 0.576 0.053 0.153 0.168 0.459 0.255 0.682 0.226 0.582 0.285 0.779 0.393 1.301 0.073 0.348 0.201 1.201 0.201 1.329 0 0.095-0.473-0.418-0.87-0.944-0.85-1.125-1.434-2.43-1.707-3.814-0.070-0.354-0.123-0.717-0.112-0.764 0.007-0.025 0.003-0.040-0.008-0.040-0.013 0-0.017-0.025-0.010-0.083 0.007-0.055 0.003-0.083-0.008-0.083s-0.015-0.035-0.007-0.108c0.008-0.076 0.005-0.108-0.008-0.108s-0.015-0.043-0.007-0.158c0.008-0.11 0.007-0.158-0.007-0.158s-0.018-0.11-0.018-0.358c0-0.248 0.005-0.358 0.018-0.358s0.015-0.048 0.007-0.158c-0.008-0.115-0.007-0.158 0.007-0.158s0.017-0.032 0.008-0.108c-0.008-0.073-0.005-0.108 0.007-0.108s0.015-0.028 0.008-0.083c-0.007-0.052-0.003-0.083 0.007-0.083 0.012 0 0.015-0.030 0.008-0.075-0.003-0.042 0-0.075 0.008-0.075s0.012-0.027 0.008-0.058c-0.003-0.032 0-0.058 0.008-0.058s0.012-0.027 0.008-0.058c-0.003-0.032 0-0.058 0.008-0.058s0.013-0.023 0.008-0.050c-0.003-0.028 0-0.050 0.007-0.050 0.008 0 0.017-0.043 0.018-0.095 0.002-0.053 0.010-0.098 0.018-0.101 0.008-0.002 0.012-0.023 0.007-0.045-0.003-0.023 0-0.042 0.007-0.042 0.008 0 0.017-0.035 0.017-0.078 0.002-0.043 0.010-0.082 0.020-0.085s0.015-0.015 0.010-0.027c-0.023-0.058 0.285-1.138 0.328-1.155 0.008-0.003 0.015-0.022 0.015-0.040 0-0.048 0.068-0.23 0.085-0.23 0.008 0 0.015-0.018 0.015-0.042s0.008-0.042 0.017-0.042c0.010 0 0.017-0.018 0.017-0.042s0.008-0.042 0.017-0.042c0.010 0 0.017-0.018 0.017-0.040 0-0.023 0.012-0.052 0.025-0.067 0.013-0.013 0.025-0.033 0.025-0.045 0-0.035 0.040-0.131 0.053-0.131 0.007 0 0.013-0.012 0.013-0.025 0-0.032 0.087-0.213 0.108-0.228 0.010-0.007 0.035-0.052 0.057-0.1 0.1-0.23 0.125-0.278 0.147-0.286 0.012-0.005 0.022-0.025 0.022-0.043s0.015-0.047 0.033-0.062c0.018-0.017 0.033-0.042 0.033-0.058 0-0.015 0.013-0.042 0.032-0.058 0.017-0.017 0.035-0.050 0.042-0.076 0.005-0.025 0.018-0.045 0.027-0.045 0.010 0 0.017-0.012 0.017-0.025s0.007-0.025 0.015-0.025c0.008 0 0.020-0.018 0.025-0.042 0.007-0.023 0.018-0.042 0.027-0.042 0.010 0 0.017-0.012 0.017-0.025s0.007-0.025 0.015-0.025c0.008 0 0.020-0.018 0.025-0.042 0.007-0.023 0.018-0.042 0.027-0.042 0.010 0 0.017-0.012 0.017-0.025s0.008-0.025 0.017-0.025c0.010 0 0.017-0.012 0.017-0.025s0.008-0.025 0.017-0.025c0.010 0 0.017-0.012 0.017-0.025s0.008-0.025 0.017-0.025c0.010 0 0.017-0.012 0.017-0.025 0-0.015 0.012-0.030 0.025-0.035 0.013-0.007 0.025-0.020 0.025-0.033s0.008-0.023 0.017-0.023c0.010 0 0.017-0.010 0.017-0.023s0.012-0.027 0.025-0.033c0.013-0.005 0.025-0.020 0.025-0.035 0-0.013 0.008-0.025 0.017-0.025 0.010 0 0.017-0.010 0.017-0.023s0.012-0.027 0.025-0.033c0.013-0.005 0.025-0.020 0.025-0.033 0-0.012 0.012-0.027 0.025-0.033 0.013-0.005 0.025-0.020 0.025-0.033 0-0.012 0.012-0.027 0.025-0.033 0.013-0.005 0.025-0.020 0.025-0.033 0-0.015 0.015-0.033 0.033-0.043s0.033-0.027 0.033-0.038 0.015-0.030 0.033-0.042c0.018-0.012 0.033-0.030 0.033-0.042s0.015-0.030 0.033-0.042c0.018-0.012 0.033-0.030 0.033-0.042s0.023-0.038 0.050-0.058c0.028-0.022 0.050-0.046 0.050-0.058s0.027-0.042 0.058-0.067c0.032-0.025 0.058-0.055 0.058-0.065s0.045-0.060 0.1-0.108c0.055-0.050 0.1-0.098 0.1-0.107 0-0.023 0.321-0.348 0.343-0.348 0.012 0 0.023-0.015 0.028-0.033 0.010-0.040 0.038-0.043 0.073-0.007zM22.807 9.715c1.236 1.444 1.979 3.175 2.198 5.13 0.035 0.326 0.050 1.285 0.025 1.657-0.083 1.198-0.383 2.336-0.895 3.418-0.098 0.205-0.323 0.624-0.409 0.759l-0.043 0.068-0.161 0.022c-0.416 0.052-1.018 0.255-1.554 0.524-0.161 0.081-0.183 0.087-0.183 0.050 0-0.013 0.055-0.176 0.123-0.361 0.255-0.699 0.504-1.451 0.777-2.343 0.083-0.27 0.218-0.704 0.3-0.965 0.181-0.577 0.22-0.749 0.211-0.965-0.010-0.323-0.11-0.434-1.243-1.408-0.314-0.27-0.564-0.518-0.609-0.607-0.065-0.125-0.005-0.311 0.226-0.702 0.175-0.294 0.268-0.499 0.379-0.837 0.25-0.749 0.429-1.569 0.524-2.395 0.037-0.305 0.076-0.839 0.076-1.007 0-0.175 0.015-0.266 0.041-0.266 0.010 0 0.108 0.103 0.216 0.228zM21.043 15.262c0.055 0.047 0.291 0.271 0.524 0.499s0.508 0.478 0.607 0.556c0.268 0.21 0.398 0.341 0.459 0.468 0.053 0.106 0.053 0.108 0.043 0.294-0.012 0.193-0.070 0.488-0.203 1.040-0.171 0.701-0.449 1.529-0.86 2.558-0.268 0.669-0.328 0.76-0.534 0.82-0.17 0.048-0.206 0.053-0.652 0.070-0.411 0.017-0.549 0.037-0.674 0.1-0.078 0.040-0.1 0.042-0.1 0.007s0.118-0.236 0.749-1.271c0.492-0.807 0.854-1.413 0.92-1.543 0.025-0.045 0.023-0.053-0.005-0.098-0.017-0.027-0.078-0.103-0.138-0.17-0.108-0.122-0.162-0.208-0.162-0.261 0-0.015 0.027-0.105 0.057-0.196 0.235-0.691 0.115-1.819-0.233-2.207-0.076-0.085-0.21-0.168-0.27-0.168-0.045 0-0.17-0.087-0.17-0.118 0-0.017 0.073-0.085 0.171-0.161 0.093-0.072 0.203-0.17 0.245-0.216 0.042-0.045 0.087-0.083 0.1-0.085 0.013 0 0.070 0.037 0.125 0.083zM12.377 15.763c0.041 0.040 0.175 0.183 0.293 0.321 0.118 0.137 0.258 0.298 0.309 0.356 0.17 0.195 0.552 0.424 1.401 0.84l0.524 0.258 0.022 0.135c0.052 0.334 0.356 1.391 0.476 1.642 0.158 0.336 0.348 0.434 0.637 0.329 0.063-0.023 0.125-0.042 0.135-0.042 0.058 0-0.013 0.16-0.156 0.349-0.188 0.25-0.228 0.409-0.138 0.546 0.048 0.073 0.198 0.178 0.404 0.283 0.506 0.26 1.118 0.552 1.419 0.677 0.193 0.080 0.353 0.156 0.353 0.166 0 0.015-0.073 0.023-0.261 0.032-1.396 0.058-2.22 0.123-3.523 0.278-0.368 0.043-0.591 0.063-0.606 0.053-0.038-0.023-0.083-0.16-0.103-0.308-0.028-0.23-0.020-0.958 0.017-1.428 0.018-0.233 0.033-0.489 0.033-0.567 0-0.419-0.201-0.416-0.278 0.005-0.027 0.155-0.023 0.276 0.028 0.835 0.037 0.378 0.043 0.835 0.017 1.008-0.010 0.060-0.032 0.158-0.052 0.22-0.030 0.105-0.037 0.113-0.078 0.113-0.068-0.002-0.173-0.055-0.354-0.183-0.215-0.151-0.298-0.193-0.316-0.163-0.040 0.062-0.002 0.166 0.107 0.293 0.105 0.12 0.121 0.225 0.046 0.308-0.038 0.047-0.070 0.058-0.205 0.087-0.218 0.047-0.313 0.116-0.313 0.233 0 0.040 0.003 0.042 0.105 0.042 0.057 0 0.246-0.008 0.423-0.020 0.319-0.018 0.477-0.010 0.639 0.037l0.060 0.017 0.012 0.138c0.037 0.434 0.173 1.564 0.311 2.544 0.053 0.391 0.098 0.719 0.098 0.727 0 0.040-0.418 0-0.765-0.073-0.559-0.118-1.015-0.305-1.955-0.799-0.301-0.158-0.607-0.316-0.677-0.351l-0.13-0.063v-0.151c0-0.346-0.067-1.27-0.135-1.889-0.191-1.741-0.584-3.33-1.132-4.579-0.063-0.143-0.115-0.271-0.115-0.283 0-0.013 0.155-0.14 0.344-0.281 1.102-0.827 1.845-1.291 2.643-1.649 0.138-0.062 0.275-0.111 0.305-0.113 0.042 0 0.073 0.017 0.132 0.070zM20.531 16.283c0.17 0.087 0.29 0.476 0.341 1.101 0.027 0.341-0.022 0.674-0.116 0.802l-0.030 0.038-0.273-0.018c-0.441-0.028-1-0.111-1.263-0.188l-0.073-0.020 0.002-0.258c0.002-0.141 0.003-0.263 0.003-0.27 0-0.017 0.115-0.073 0.175-0.087 0.065-0.013 0.253-0.032 0.313-0.030 0.025 0.002 0.045-0.005 0.045-0.012 0-0.017-0.181-0.070-0.275-0.078-0.037-0.005-0.076-0.012-0.088-0.015-0.010-0.003-0.055 0-0.098 0.007-0.103 0.020-0.128 0.003-0.155-0.093-0.012-0.043-0.037-0.108-0.053-0.145-0.027-0.053-0.028-0.067-0.010-0.078 0.012-0.008 0.028-0.015 0.037-0.015 0.007 0 0.145-0.086 0.308-0.195 0.488-0.321 0.697-0.436 0.854-0.462 0.030-0.007 0.055-0.012 0.057-0.013 0.017-0.017 0.26 0.007 0.301 0.028zM19.271 16.284c0 0.013-0.015 0.032-0.032 0.042-0.018 0.008-0.17 0.125-0.336 0.258l-0.305 0.241-0.093 0.003c-0.356 0.012-0.627-0.032-0.837-0.133-0.161-0.080-0.328-0.195-0.328-0.228s0.075-0.048 0.13-0.027c0.083 0.033 0.276 0.068 0.393 0.068 0.161 0 0.423-0.042 0.75-0.12 0.273-0.065 0.567-0.125 0.629-0.128 0.015-0.002 0.028 0.010 0.028 0.023zM13.785 16.366c0.121 0.040 0.334 0.072 0.681 0.101 0.473 0.038 0.463 0.037 0.463 0.095 0 0.027-0.015 0.107-0.032 0.176-0.018 0.072-0.038 0.168-0.045 0.215-0.010 0.082-0.015 0.088-0.055 0.088-0.076 0-0.373-0.080-0.559-0.148-0.451-0.17-0.721-0.379-0.682-0.531 0.020-0.078 0.038-0.088 0.097-0.053 0.030 0.017 0.090 0.042 0.133 0.057zM15.822 16.424c0.018 0.008 0.037 0.013 0.042 0.010 0.023-0.023 0.677 0.193 0.904 0.299 0.349 0.165 0.441 0.213 0.626 0.335 0.105 0.070 0.283 0.138 0.381 0.148 0.023 0.002 0.050 0.005 0.060 0.005 0.010 0.002 0.018 0.033 0.020 0.068 0.003 0.062-0.002 0.068-0.073 0.108s-0.228 0.095-0.253 0.090c-0.012-0.002-0.060 0.010-0.25 0.063-0.088 0.025-0.108 0.067-0.023 0.050 0.097-0.020 0.582 0.117 0.632 0.178 0.010 0.012 0.013 0.085 0.008 0.186l-0.010 0.168-0.068 0.048c-0.037 0.028-0.195 0.155-0.351 0.285-0.155 0.128-0.343 0.278-0.416 0.329-0.309 0.223-0.968 0.476-1.241 0.476-0.080 0-0.098-0.007-0.138-0.048-0.027-0.028-0.050-0.067-0.053-0.088-0.005-0.035-0.107-0.326-0.141-0.404-0.072-0.162-0.191-0.524-0.208-0.629-0.005-0.030-0.012-0.072-0.017-0.095-0.038-0.191-0.057-0.686-0.033-0.948 0.005-0.068 0.010-0.136 0.012-0.15 0.010-0.123 0.105-0.353 0.173-0.416 0.070-0.065 0.153-0.093 0.275-0.090 0.062 0.002 0.126 0.012 0.145 0.022zM18.569 17.141c0.091 0.040 0.111 0.062 0.161 0.17 0.062 0.132 0.058 0.309-0.007 0.431-0.067 0.13-0.163 0.18-0.338 0.181-0.203 0-0.198 0.003-0.251-0.24-0.027-0.115-0.042-0.218-0.037-0.226 0.005-0.010 0.002-0.017-0.007-0.017-0.012 0-0.018-0.042-0.018-0.105 0-0.097 0.003-0.105 0.047-0.127 0.21-0.105 0.324-0.121 0.449-0.068zM18.932 18.188c0.038 0.018 0.13 0.073 0.203 0.125 0.165 0.115 0.291 0.175 0.401 0.188l0.085 0.010v0.1c0 0.056-0.007 0.185-0.017 0.285-0.008 0.102-0.023 0.368-0.033 0.592-0.025 0.567-0.053 0.845-0.135 1.348-0.035 0.223-0.088 0.408-0.116 0.413-0.032 0.005-0.225-0.388-0.506-1.037-0.354-0.817-0.552-1.193-0.8-1.527-0.060-0.082-0.106-0.158-0.103-0.17 0.003-0.013 0.043-0.068 0.088-0.125l0.083-0.102 0.075 0.012c0.123 0.018 0.173 0.010 0.353-0.068 0.196-0.085 0.306-0.096 0.423-0.043zM20.478 18.481c0.125 0.033 0.271 0.111 0.369 0.198 0.1 0.088 0.205 0.221 0.205 0.26 0 0.033-0.496 0.895-0.79 1.374-0.281 0.458-0.666 1.008-0.717 1.028-0.033 0.013-0.030-0.010 0.027-0.228 0.12-0.468 0.216-1.157 0.275-1.959 0.013-0.188 0.025-0.403 0.025-0.479 0-0.135 0.002-0.138 0.047-0.155 0.176-0.068 0.393-0.083 0.561-0.040zM17.71 18.9c0.359 0.508 0.581 0.935 1.038 2.022 0.095 0.228 0.173 0.424 0.173 0.438 0 0.040-0.048 0.030-0.336-0.068-0.516-0.178-0.995-0.381-1.563-0.664-0.398-0.198-0.78-0.406-0.78-0.422 0-0.007 0.015-0.062 0.035-0.12 0.090-0.278 0.283-0.547 0.554-0.776 0.16-0.135 0.734-0.536 0.769-0.537 0.010 0 0.060 0.058 0.11 0.128zM23.987 21.283c0.171 0.083 0.344 0.255 0.426 0.424 0.105 0.216 0.216 0.592 0.378 1.258 0.067 0.276 0.075 0.334 0.083 0.566 0.007 0.225 0.003 0.276-0.027 0.404-0.087 0.366-0.296 0.647-0.579 0.78-0.278 0.131-0.979 0.185-1.338 0.103-0.092-0.020-0.115-0.032-0.115-0.057 0-0.053 0.213-0.12 0.612-0.193 0.321-0.058 0.468-0.092 0.478-0.108 0.008-0.013-0.023-0.023-0.2-0.067-0.105-0.027-0.636-0.027-0.94-0.002-0.123 0.012-0.346 0.025-0.494 0.030l-0.268 0.012-0.010-0.090c-0.005-0.050-0.033-0.323-0.062-0.606-0.072-0.732-0.146-1.208-0.241-1.539l-0.027-0.091 0.072-0.062c0.138-0.118 0.456-0.26 1.027-0.453 0.323-0.11 0.531-0.195 0.661-0.271 0.153-0.090 0.203-0.105 0.333-0.1 0.090 0.005 0.143 0.018 0.231 0.060zM21.218 22.142c0.063 0.038 0.22 0.463 0.291 0.782 0.081 0.366 0.15 1.057 0.138 1.403l-0.005 0.171-0.216 0.073c-0.118 0.040-0.263 0.078-0.319 0.083l-0.102 0.012-0.010-0.072c-0.005-0.040-0.022-0.19-0.035-0.331-0.015-0.141-0.072-0.546-0.127-0.899-0.1-0.647-0.165-1.117-0.165-1.19 0-0.038 0.007-0.040 0.13-0.047 0.171-0.010 0.394-0.002 0.419 0.013zM17.865 22.15c0.381 0.023 1.067 0.102 1.102 0.125 0.008 0.005 0.053 0.378 0.070 0.574 0.023 0.273 0.032 0.426 0.060 1.123 0.025 0.562 0.032 0.656 0.083 1.198 0.032 0.333 0.055 0.769 0.075 1.423 0.030 0.982 0.067 1.464 0.143 1.92 0.022 0.136 0.038 0.25 0.037 0.251-0.017 0.010-0.285 0.078-0.446 0.115-0.478 0.105-0.945 0.15-1.523 0.15-0.671-0.002-1.181-0.052-1.789-0.173-0.275-0.055-0.724-0.168-0.74-0.186-0.003-0.003-0.053-0.163-0.113-0.356-0.428-1.38-0.727-2.737-0.959-4.341-0.093-0.637-0.188-1.459-0.173-1.473 0.018-0.017 0.88-0.156 1.27-0.208 0.537-0.068 1.142-0.121 1.672-0.146 0.263-0.013 0.994-0.010 1.231 0.005zM20.123 22.258c0.090 0.334 0.15 0.819 0.23 1.864 0.028 0.356 0.057 0.709 0.065 0.782 0.010 0.087 0.010 0.136-0.002 0.143-0.017 0.010-0.479 0.095-0.79 0.145-0.125 0.020-0.188 0.023-0.188 0.013s-0.012-0.165-0.025-0.343c-0.055-0.73-0.076-1.208-0.087-1.877-0.005-0.386-0.005-0.702 0-0.702s0.057-0.012 0.113-0.027c0.125-0.032 0.353-0.053 0.537-0.050 0.133 0.002 0.133 0.002 0.146 0.052zM20.080 25.588c0.030 0.008 0.038 0.027 0.047 0.111 0.007 0.056 0.053 0.298 0.103 0.536 0.125 0.596 0.158 0.809 0.168 1.098l0.010 0.25-0.19 0.062c-0.105 0.033-0.226 0.068-0.273 0.078-0.091 0.018-0.374 0.043-0.374 0.033 0-0.003-0.015-0.25-0.035-0.547-0.018-0.298-0.038-0.764-0.043-1.037l-0.010-0.494h0.053c0.030 0 0.127-0.018 0.215-0.040 0.088-0.023 0.185-0.045 0.211-0.048 0.028-0.003 0.058-0.008 0.066-0.008 0.010-0.002 0.033 0.002 0.052 0.007zM15.91 6.154c-0.14 0.023-0.336 0.111-0.524 0.236-0.158 0.103-0.414 0.363-0.521 0.526-0.143 0.218-0.236 0.509-0.211 0.659 0.012 0.067 0.088 0.165 0.128 0.165 0.012 0 0.052-0.062 0.088-0.138 0.142-0.29 0.358-0.569 0.556-0.716 0.115-0.085 0.295-0.166 0.446-0.203 0.095-0.023 0.167-0.027 0.358-0.020 0.13 0.005 0.255 0.013 0.276 0.020 0.032 0.010 0.040 0.003 0.062-0.048 0.040-0.093 0.032-0.163-0.028-0.253-0.117-0.173-0.381-0.27-0.629-0.228zM21.285 7.951c0 0.226 0.055 0.449 0.203 0.819 0.045 0.113 0.080 0.221 0.076 0.241-0.008 0.053-0.158 0.090-0.451 0.11-0.258 0.018-0.283 0.022-0.406 0.053-0.065 0.017-0.072 0.023-0.072 0.068 0 0.16 0.115 0.306 0.276 0.354 0.261 0.075 0.709-0.062 0.945-0.286 0.145-0.14 0.143-0.13 0.025-0.326-0.096-0.158-0.289-0.544-0.491-0.982-0.045-0.1-0.087-0.18-0.093-0.18-0.008 0-0.013 0.058-0.013 0.128zM17.033 7.921c-0.040 0.235 0.108 0.689 0.374 1.145 0.060 0.101 0.1 0.188 0.097 0.21-0.012 0.086-0.268 0.158-0.486 0.136-0.065-0.007-0.22-0.030-0.343-0.052-0.3-0.053-0.34-0.053-0.364 0.005-0.047 0.113-0.050 0.156-0.023 0.223 0.073 0.186 0.369 0.298 0.79 0.298 0.348 0 0.483-0.045 0.679-0.226 0.082-0.077 0.105-0.11 0.126-0.186 0.030-0.103 0.023-0.206-0.020-0.29-0.015-0.030-0.112-0.14-0.213-0.246-0.21-0.22-0.255-0.293-0.419-0.679-0.062-0.145-0.128-0.295-0.148-0.336l-0.038-0.073-0.012 0.072zM19.185 8.224c-0.025 0.013-0.030 0.040-0.030 0.138 0 0.456 0.265 1.055 0.729 1.657 0.12 0.153 0.523 0.637 0.687 0.824 0.166 0.19 0.223 0.351 0.181 0.527-0.027 0.113-0.093 0.245-0.13 0.258-0.015 0.005-0.185 0.083-0.378 0.173-0.446 0.206-0.596 0.268-0.782 0.321-0.221 0.062-0.388 0.083-0.567 0.072-0.29-0.017-0.349-0.073-0.438-0.418-0.028-0.108-0.052-0.201-0.052-0.203 0-0.003-0.006-0.007-0.017-0.007-0.028 0-0.098 0.16-0.117 0.273-0.035 0.196 0.035 0.443 0.171 0.601l0.058 0.067 0.251 0.005c0.679 0.017 1.306-0.186 2.072-0.667l0.248-0.156 0.028-0.115c0.015-0.063 0.047-0.168 0.070-0.231 0.023-0.065 0.052-0.16 0.062-0.211 0.033-0.16 0.020-0.185-0.261-0.461-0.724-0.709-1.513-1.805-1.607-2.236-0.018-0.081-0.043-0.146-0.072-0.178-0.043-0.053-0.063-0.058-0.108-0.032zM10.973 10.034c-0.16 0.055-0.28 0.185-0.343 0.374-0.040 0.117-0.037 0.123 0.035 0.058 0.1-0.097 0.136-0.115 0.231-0.115 0.047 0 0.092 0.007 0.097 0.017 0.005 0.008-0.010 0.078-0.035 0.153-0.037 0.115-0.046 0.176-0.053 0.364-0.008 0.261 0.018 0.429 0.095 0.589 0.098 0.205 0.096 0.208 0.105-0.226 0.008-0.339 0.013-0.403 0.045-0.501 0.058-0.181 0.171-0.258 0.309-0.213 0.083 0.028 0.148 0.112 0.261 0.343 0.057 0.115 0.126 0.235 0.156 0.27l0.053 0.062 0.012-0.115c0.052-0.478-0.22-0.93-0.637-1.058-0.131-0.040-0.218-0.042-0.331-0.002zM21.193 12.342c-0.634 0.336-0.855 0.423-1.213 0.481-0.081 0.013-0.155 0.033-0.163 0.045-0.015 0.025-0.018 0.426-0.003 0.516 0.010 0.062 0.013 0.063 0.080 0.063 0.113 0 0.363-0.060 0.516-0.121 0.384-0.156 0.762-0.534 1.033-1.032 0.033-0.062 0.058-0.111 0.055-0.111-0.002 0-0.14 0.072-0.305 0.16zM17.068 12.667c0.115 0.213 0.419 0.446 0.764 0.579 0.414 0.163 1.065 0.264 1.572 0.248l0.158-0.005-0.003-0.225c-0.002-0.123-0.010-0.258-0.017-0.3l-0.015-0.075-0.572-0.010c-0.942-0.017-1.426-0.091-1.904-0.29-0.027-0.012-0.025-0.002 0.017 0.077zM16.714 13.166c-0.085 0.025-0.096 0.067-0.040 0.141 0.027 0.037 0.087 0.102 0.135 0.148 0.047 0.045 0.153 0.178 0.236 0.294s0.196 0.266 0.253 0.333c0.294 0.344 0.619 0.463 1.266 0.463 0.531 0 1.018-0.098 1.185-0.24 0.052-0.043 0.171-0.21 0.171-0.238 0-0.008-0.271-0.012-0.604-0.008-0.995 0.012-1.409-0.045-1.817-0.245-0.276-0.136-0.469-0.321-0.579-0.554-0.048-0.103-0.058-0.113-0.103-0.111-0.027 0-0.075 0.008-0.103 0.017zM18.845 18.77c-0.1 0.060-0.113 0.206-0.028 0.291 0.123 0.123 0.321 0.033 0.321-0.146 0-0.050-0.012-0.075-0.057-0.12-0.067-0.067-0.153-0.076-0.236-0.025zM19.097 19.651c-0.090 0.030-0.141 0.1-0.141 0.191 0 0.052 0.012 0.076 0.057 0.122 0.048 0.048 0.068 0.057 0.133 0.057 0.060 0 0.087-0.010 0.13-0.048 0.048-0.043 0.055-0.058 0.055-0.133 0-0.072-0.006-0.092-0.050-0.133-0.052-0.050-0.126-0.073-0.183-0.055zM23.232 22.017c-0.409 0.073-0.742 0.24-0.932 0.466l-0.070 0.083h0.078c0.175 0 0.358-0.076 0.757-0.316 0.241-0.145 0.384-0.22 0.483-0.25 0.083-0.027-0.138-0.015-0.316 0.017zM22.887 22.715c-0.116 0.022-0.253 0.076-0.313 0.125-0.042 0.035-0.047 0.045-0.025 0.060 0.037 0.025 0.587 0.005 0.973-0.035 0.175-0.018 0.331-0.033 0.349-0.035 0.055-0.003-0.14-0.060-0.308-0.088-0.19-0.033-0.558-0.048-0.677-0.027zM22.737 23.406c-0.093 0.025-0.213 0.081-0.228 0.105s0.235 0.037 0.913 0.047c0.567 0.006 0.627 0.005 0.579-0.017-0.078-0.037-0.371-0.106-0.563-0.135-0.21-0.032-0.586-0.032-0.702 0z"></path>
</svg>`, Nk = `<?xml version="1.0" encoding="utf-8"?>\r
<!-- Uploaded to: SVG Repo, www.svgrepo.com, Generator: SVG Repo Mixer Tools -->
<svg fill="#000000" width="800px" height="800px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg">\r
<title>postgresql</title>\r
<path d="M24.295 9.929c-0.010 0.155-0.082 0.292-0.191 0.387l-0.001 0.001c-0.131 0.143-0.306 0.243-0.504 0.278l-0.005 0.001c-0.028 0.004-0.061 0.007-0.094 0.007h-0c-0.001 0-0.003 0-0.004 0-0.312 0-0.58-0.189-0.694-0.46l-0.002-0.005c-0.030-0.221 0.33-0.388 0.701-0.44s0.764 0.011 0.794 0.231zM14.385 10.443c-0.121 0.311-0.418 0.528-0.766 0.528-0.004 0-0.007-0-0.011-0h0.001c-0 0-0 0-0 0-0.036 0-0.070-0.003-0.105-0.007l0.004 0c-0.261-0.047-0.483-0.191-0.63-0.392l-0.002-0.003c-0.082-0.094-0.132-0.219-0.132-0.354 0-0 0-0.001 0-0.001v0c0.012-0.077 0.055-0.143 0.115-0.185l0.001-0.001c0.152-0.084 0.334-0.133 0.528-0.133 0.083 0 0.164 0.009 0.242 0.026l-0.007-0.001c0.395 0.055 0.803 0.242 0.764 0.523zM25.403 18.086l-0.107-0.134-0.044-0.055c0.457-0.846 0.725-1.853 0.725-2.921 0-0.488-0.056-0.962-0.162-1.418l0.008 0.042c-0.070-0.453-0.111-0.976-0.111-1.508 0-0.007 0-0.014 0-0.021v0.001c0.023-0.501 0.076-0.97 0.158-1.429l-0.010 0.066c0.089-0.464 0.14-0.998 0.14-1.544 0-0.051-0-0.101-0.001-0.151l0 0.008c0.012-0.049 0.019-0.104 0.019-0.162 0-0.027-0.002-0.053-0.004-0.079l0 0.003c-0.4-1.58-1.151-2.949-2.168-4.073l0.007 0.008c-0.911-1.068-2.031-1.929-3.3-2.523l-0.060-0.025c0.696-0.149 1.496-0.234 2.316-0.234 0.075 0 0.15 0.001 0.225 0.002l-0.011-0c0.045-0.001 0.097-0.002 0.15-0.002 2.378 0 4.496 1.109 5.866 2.838l0.012 0.016c0.028 0.036 0.056 0.077 0.080 0.12l0.003 0.005c0.904 1.694-0.345 7.842-3.732 13.172zM25.117 9.322c-0.016 0.455-0.064 0.886-0.14 1.307l0.008-0.055c-0.078 0.425-0.134 0.931-0.157 1.445l-0.001 0.025c-0 0.017-0 0.036-0 0.056 0 0.567 0.042 1.124 0.124 1.668l-0.008-0.061c0.085 0.377 0.134 0.809 0.134 1.254 0 0.763-0.144 1.493-0.407 2.162l0.014-0.040c-0.076-0.131-0.155-0.289-0.224-0.453l-0.011-0.029c-0.066-0.159-0.209-0.416-0.406-0.77-0.769-1.38-2.571-4.611-1.649-5.929 0.474-0.678 1.676-0.707 2.722-0.579zM24.406 20.907c-0.051-1.039 0.336-1.148 0.746-1.263q0.085-0.023 0.169-0.051c0.050 0.044 0.105 0.087 0.162 0.125l0.005 0.003c0.62 0.273 1.342 0.431 2.102 0.431 0.592 0 1.161-0.096 1.693-0.274l-0.038 0.011c-0.344 0.293-0.736 0.544-1.16 0.738l-0.031 0.013c-0.644 0.264-1.391 0.429-2.173 0.454l-0.010 0c-0.119 0.018-0.256 0.029-0.395 0.029-0.386 0-0.754-0.080-1.087-0.224l0.018 0.007zM23.293 22.933c-0.021 0.221-0.045 0.47-0.077 0.745l-0.182 0.548c-0.014 0.040-0.022 0.086-0.023 0.134v0c0.001 0.027 0.001 0.058 0.001 0.089 0 0.355-0.053 0.699-0.151 1.022l0.006-0.025c-0.116 0.389-0.196 0.84-0.223 1.305l-0.001 0.016c-0.052 1.684-1.355 3.047-3.008 3.194l-0.013 0.001c-1.894 0.406-2.23-0.621-2.526-1.527q-0.045-0.142-0.096-0.283c-0.16-0.652-0.252-1.401-0.252-2.171 0-0.36 0.020-0.715 0.059-1.065l-0.004 0.043c0.006-0.128 0.009-0.279 0.009-0.43 0-1.026-0.154-2.016-0.441-2.948l0.019 0.071q0.008-0.55 0.024-1.114c0-0.003 0-0.008 0-0.012 0-0.046-0.007-0.090-0.020-0.132l0.001 0.003c-0.014-0.1-0.033-0.188-0.058-0.273l0.003 0.013c-0.141-0.521-0.496-0.941-0.964-1.164l-0.011-0.005c-0.176-0.088-0.384-0.14-0.605-0.14-0.104 0-0.205 0.011-0.302 0.033l0.009-0.002c0.128-0.47 0.26-0.854 0.412-1.228l-0.026 0.073 0.066-0.177c0.074-0.2 0.167-0.407 0.266-0.626 0.546-1.124 0.865-2.445 0.865-3.841 0-0.938-0.144-1.842-0.411-2.692l0.017 0.063c-0.183-1.108-1.135-1.943-2.281-1.943-0.18 0-0.356 0.021-0.524 0.060l0.016-0.003c-0.796 0.104-1.516 0.338-2.171 0.682l0.035-0.017q-0.124 0.063-0.245 0.13c0.091-2.147 0.896-4.090 2.181-5.615l-0.012 0.014c0.118-0.119 0.242-0.232 0.37-0.338l0.009-0.007c0.069-0.014 0.13-0.042 0.182-0.081l-0.001 0.001c0.893-0.654 2.014-1.047 3.227-1.047 0.097 0 0.193 0.002 0.288 0.007l-0.013-0.001c0.526 0.008 1.034 0.044 1.534 0.108l-0.067-0.007c2.043 0.393 3.787 1.463 5.032 2.963l0.011 0.014c0.748 0.869 1.354 1.887 1.766 2.998l0.022 0.069c-0.257-0.069-0.552-0.109-0.856-0.109-0.983 0-1.868 0.416-2.49 1.081l-0.002 0.002c-1.24 1.773 0.679 5.215 1.601 6.869 0.169 0.303 0.315 0.565 0.361 0.676 0.26 0.601 0.587 1.118 0.98 1.577l-0.007-0.008c0.087 0.109 0.171 0.214 0.236 0.306-0.501 0.144-1.401 0.478-1.319 2.146-0.015 0.195-0.053 0.558-0.104 1.018-0.054 0.269-0.098 0.597-0.123 0.93l-0.002 0.028zM14.091 17.219l-0.066 0.176c-0.137 0.328-0.279 0.745-0.397 1.172l-0.019 0.081c-0.893-0.013-1.695-0.395-2.261-1.001l-0.002-0.002c-0.632-0.667-1.020-1.57-1.020-2.564 0-0.198 0.015-0.392 0.045-0.582l-0.003 0.021c0.097-0.72 0.153-1.551 0.153-2.396 0-0.502-0.020-0.999-0.058-1.491l0.004 0.065c-0.006-0.107-0.012-0.201-0.015-0.275 0.805-0.611 1.824-0.98 2.929-0.98 0.132 0 0.262 0.005 0.391 0.015l-0.017-0.001c0.554 0.129 0.971 0.588 1.037 1.153l0.001 0.006c0.238 0.728 0.375 1.566 0.375 2.435 0 1.266-0.291 2.464-0.809 3.532l0.021-0.048c-0.105 0.233-0.204 0.453-0.289 0.682zM11.474 22.203c-0.205-0.052-0.385-0.128-0.549-0.227l0.009 0.005c0.172-0.073 0.375-0.134 0.585-0.173l0.019-0.003c1.604-0.33 1.851-0.563 2.392-1.25 0.124-0.157 0.264-0.336 0.459-0.553 0.040-0.045 0.072-0.099 0.091-0.159l0.001-0.003c0.213-0.189 0.34-0.137 0.546-0.052 0.227 0.125 0.395 0.336 0.46 0.587l0.001 0.007c0.023 0.065 0.037 0.139 0.037 0.217 0 0.125-0.035 0.242-0.095 0.341l0.002-0.003c-0.645 0.882-1.676 1.449-2.839 1.449-0.4 0-0.785-0.067-1.144-0.191l0.025 0.007zM3.967 15.846c-0.651-1.985-1.181-4.34-1.494-6.764l-0.021-0.199c-0.061-0.322-0.095-0.693-0.095-1.071 0-1.806 0.789-3.427 2.041-4.537l0.006-0.005c2.295-1.623 6.048-0.676 7.633-0.163l-0.012 0.012c-1.535 1.872-2.466 4.292-2.466 6.928 0 0.090 0.001 0.18 0.003 0.27l-0-0.013c-0 0.103 0.008 0.249 0.020 0.449 0.033 0.41 0.052 0.888 0.052 1.371 0 0.802-0.052 1.592-0.154 2.367l0.010-0.091c-0.033 0.206-0.051 0.444-0.051 0.686 0 1.231 0.482 2.35 1.269 3.177l-0.002-0.002q0.151 0.158 0.315 0.297c-0.433 0.464-1.375 1.49-2.377 2.696-0.709 0.853-1.199 0.689-1.36 0.636-0.685-0.368-1.222-0.939-1.538-1.631l-0.009-0.022c-0.684-1.252-1.286-2.708-1.73-4.232l-0.039-0.157zM30.445 19.403c-0.019-0.057-0.043-0.106-0.072-0.151l0.002 0.003c-0.174-0.329-0.596-0.427-1.259-0.29-2.066 0.426-2.866 0.164-3.156-0.024 1.617-2.452 2.918-5.292 3.751-8.326l0.049-0.209c0.339-1.313 0.997-4.403 0.153-5.913-0.059-0.112-0.122-0.208-0.192-0.298l0.003 0.004c-1.563-1.955-3.948-3.196-6.623-3.196-0.076 0-0.152 0.001-0.227 0.003l0.011-0c-0.042-0.001-0.091-0.001-0.141-0.001-1.342 0-2.633 0.22-3.838 0.625l0.085-0.025q-0.321-0.060-0.645-0.102c-0.488-0.093-1.053-0.151-1.631-0.16l-0.008-0c-0.083-0.004-0.18-0.006-0.278-0.006-1.315 0-2.538 0.394-3.557 1.071l0.024-0.015c-1.071-0.401-5.984-2.056-9.025 0.098-1.489 1.27-2.426 3.147-2.426 5.244 0 0.405 0.035 0.802 0.102 1.188l-0.006-0.041c0.335 2.698 0.879 5.126 1.632 7.461l-0.079-0.284c0.493 1.716 1.103 3.201 1.852 4.6l-0.061-0.124c0.433 0.984 1.182 1.764 2.116 2.225l0.026 0.012c0.168 0.049 0.361 0.078 0.561 0.078 0.742 0 1.392-0.391 1.756-0.979l0.005-0.009c1.001-1.204 1.987-2.282 2.43-2.758 0.502 0.279 1.097 0.451 1.731 0.471l0.006 0 0.001 0.005q-0.158 0.188-0.309 0.382c-0.424 0.538-0.512 0.649-1.875 0.93-0.388 0.080-1.418 0.292-1.433 1.014-0 0.004-0 0.008-0 0.013 0 0.147 0.043 0.284 0.117 0.399l-0.002-0.003c0.312 0.395 0.751 0.678 1.254 0.788l0.015 0.003c0.399 0.13 0.859 0.205 1.335 0.205 1.1 0 2.106-0.398 2.884-1.058l-0.006 0.005c-0.024 0.418-0.037 0.908-0.037 1.401 0 1.753 0.171 3.467 0.496 5.125l-0.027-0.167c0.382 1.373 1.616 2.367 3.084 2.38h0.002c0.369-0.003 0.726-0.046 1.070-0.124l-0.033 0.006c1.919-0.171 3.431-1.705 3.567-3.619l0.001-0.012c0.188-1.088 0.502-3.593 0.673-5.125 0.008-0.065 0.034-0.123 0.072-0.171l-0.001 0.001c0.001-0.001 0.087-0.059 0.534 0.038l0.055 0.009 0.317 0.028 0.019 0.001c0.095 0.004 0.207 0.007 0.319 0.007 1.024 0 2.002-0.2 2.895-0.564l-0.051 0.018c0.805-0.373 2.256-1.29 1.993-2.087z"></path>\r
</svg>`, Dk = `<?xml version="1.0" encoding="utf-8"?><!-- Uploaded to: SVG Repo, www.svgrepo.com, Generator: SVG Repo Mixer Tools -->
<svg fill="#000000" width="800px" height="800px" viewBox="0 0 14 14" role="img" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path d="m 9.6693761,6.3223595 c -0.02637,-0.304584 -0.08225,-0.608381 -0.160162,-0.903915 -0.24595,-0.932249 -0.655605,-1.824752 -1.233292,-2.598413 -0.157408,-0.210927 -0.327409,-0.412409 -0.509215,-0.602873 -0.187315,-0.196366 -0.395094,-0.376598 -0.525743,-0.620974 -0.08264,-0.154654 -0.161343,-0.311274 -0.241621,-0.467108 -0.0012,0.0488 -0.0043,0.09759 -0.0043,0.145996 0,-0.0488 0.0035,-0.09759 0.0043,-0.14639 -0.01495,-0.03738 -0.02991,-0.07516 -0.05116,-0.128681 -0.0087,0.02951 -0.01417,0.03975 -0.01417,0.05076 -0.0067,0.253821 -0.150718,0.426182 -0.32977,0.587132 -0.201482,0.181019 -0.389191,0.377386 -0.582803,0.567062 0.0067,0.0087 0.01417,0.01731 0.02164,0.02597 -0.0075,-0.0087 -0.01495,-0.01692 -0.02164,-0.02597 -0.57572,0.757133 -1.0829674,1.566604 -1.3816491,2.475241 -0.086968,0.264446 -0.1554404,0.534794 -0.2034499,0.809078 -0.1019216,0.582803 -0.1491441,1.149078 -0.1164819,1.739358 0.018102,0.326228 0.075162,0.647341 0.1601627,0.963337 0.3089132,1.147898 0.9361842,2.0998235 1.7936642,2.9089005 0.159376,0.150325 0.331344,0.286875 0.497803,0.430118 3.93e-4,-0.0016 7.87e-4,-0.0028 0.0012,-0.0043 -3.94e-4,0.0016 -7.88e-4,0.0028 -0.0012,0.0043 0.0244,0.08421 0.04919,0.168426 0.07359,0.25264 0.02282,0.130648 0.04565,0.261297 0.06847,0.391946 0.01102,0.136157 0.02164,0.272709 0.03266,0.408867 -3.94e-4,0.08303 -0.0039,0.166459 0.0012,0.249098 0.0012,0.02125 0.02912,0.04093 0.04447,0.06139 3.94e-4,-7.87e-4 7.87e-4,-0.0016 0.0016,-0.0024 -3.93e-4,7.87e-4 -7.87e-4,0.0016 -0.0016,0.0024 0.04644,0.01613 0.09248,0.03266 0.138913,0.0488 0.04171,0.01613 0.08343,0.03266 0.144422,0.05627 -0.0091,-0.136158 -0.01692,-0.249886 -0.02479,-0.363614 -3.94e-4,-0.119236 -7.87e-4,-0.238865 -0.0012,-0.358102 -0.0024,0.0028 -0.0055,0.0055 -0.0083,0.0083 0.0028,-0.0028 0.0055,-0.0055 0.0083,-0.0083 0.01653,-0.181806 0.03345,-0.363612 0.04998,-0.54542 0.0122,-0.03974 0.024,-0.0791 0.0362,-0.118843 0.03463,-0.06139 0.06887,-0.122384 0.103496,-0.183773 0.127894,-0.103103 0.265232,-0.196367 0.382108,-0.310881 0.210927,-0.207385 0.42146,-0.417131 0.609956,-0.644193 0.244769,-0.294353 0.455696,-0.6158575 0.62491,-0.9605815 0.481275,-0.980258 0.704007,-2.073457 0.615465,-3.163508 -7.87e-4,-0.0094 -0.0016,-0.01928 -0.0024,-0.02912 z"/></svg>`, Pk = `<?xml version="1.0" encoding="utf-8"?><!-- Uploaded to: SVG Repo, www.svgrepo.com, Generator: SVG Repo Mixer Tools -->
<svg width="800px" height="800px" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none"><path fill="#000000" fill-rule="evenodd" d="M5.374 15c-.335 0-.66-.153-.874-.431l-3.254-4.172a1.15 1.15 0 01-.214-.978l1.165-5.207c.074-.345.298-.623.605-.776l4.715-2.32c.15-.078.317-.116.485-.116.168 0 .335.038.485.115L13.2 3.426c.308.153.532.432.606.777l1.165 5.207c.074.345 0 .7-.214.978L11.5 14.566c-.214.268-.54.434-.875.434h-5.25zm7.718-5.835l.031.008a.308.308 0 01.26.371.306.306 0 01-.396.223h-.004l-.003-.001-.003-.001-.03-.007-.05-.01a2.548 2.548 0 01-.274-.106 2.87 2.87 0 00-.533-.156.242.242 0 00-.171.063 4.76 4.76 0 00-.131-.023 3.972 3.972 0 01-1.764 2.212c.015.042.032.083.051.123a.239.239 0 00-.023.18c.074.17.165.332.271.484.06.078.114.16.164.244l.028.057.012.025a.306.306 0 01-.381.44.307.307 0 01-.172-.18 2.608 2.608 0 00-.01-.02l-.028-.058a2.545 2.545 0 01-.089-.28 2.835 2.835 0 00-.21-.512.242.242 0 00-.156-.095 5.926 5.926 0 01-.03-.053l-.035-.064a3.97 3.97 0 01-2.824-.007l-.069.125a.249.249 0 00-.132.064c-.104.17-.184.355-.237.548a2.525 2.525 0 01-.088.28l-.025.05-.013.027v.001a.307.307 0 11-.553-.261l.014-.03.026-.052c.05-.085.104-.166.164-.244.108-.156.2-.322.277-.496a.302.302 0 00-.028-.173l.056-.133A3.972 3.972 0 014.22 9.532l-.134.023a.34.34 0 00-.176-.062 2.872 2.872 0 00-.533.156c-.09.04-.181.075-.274.105l-.05.011-.03.007H3.02l-.002.002h-.005a.308.308 0 01-.397-.349.306.306 0 01.261-.245l.004-.001h.003l.006-.002c.024-.006.054-.014.076-.018.097-.013.195-.021.293-.023.186-.013.37-.043.549-.09a.422.422 0 00.131-.133l.128-.037a3.938 3.938 0 01.624-2.752l-.097-.087a.338.338 0 00-.062-.176 2.854 2.854 0 00-.455-.319 2.557 2.557 0 01-.254-.148 1.129 1.129 0 01-.063-.05l-.004-.004a.323.323 0 01-.076-.45.295.295 0 01.244-.107.365.365 0 01.213.08l.022.017c.016.013.034.026.046.037.071.067.139.139.202.213.125.137.263.262.412.372.056.03.121.036.182.018l.11.078a3.938 3.938 0 012.552-1.224l.007-.129a.332.332 0 00.1-.157 2.844 2.844 0 00-.034-.554 2.555 2.555 0 01-.042-.29v-.053-.025-.004-.004A.306.306 0 018 2.82a.308.308 0 01.306.337v.087a2.53 2.53 0 01-.041.29 2.85 2.85 0 00-.035.553.242.242 0 00.1.153v.007l.007.13c.967.087 1.87.522 2.54 1.223l.116-.083a.34.34 0 00.186-.02c.149-.11.287-.235.412-.373a2.53 2.53 0 01.202-.213l.051-.04.017-.014a.308.308 0 01.472.388.307.307 0 01-.09.09c-.008.005-.017.012-.025.02l-.043.033a2.549 2.549 0 01-.254.148 2.865 2.865 0 00-.455.32.24.24 0 00-.058.172 4.458 4.458 0 01-.05.044l-.058.053c.542.806.769 1.783.637 2.745l.123.036c.031.056.077.101.132.132.18.048.364.078.55.09.097.003.195.01.292.024l.058.013zm-2.875-3.1l-1.308.925-.004-.002a.27.27 0 01-.43-.205v-.001l-.091-1.598a3.183 3.183 0 011.833.882zM7.754 7.818h.492l.306.381-.11.476L8 8.886l-.443-.213-.11-.475.307-.381zM7.29 5.24c.107-.024.216-.043.326-.056l-.09 1.6-.008.004a.268.268 0 01-.293.256.27.27 0 01-.135-.05l-.002.001-1.316-.93c.419-.41.945-.696 1.518-.825zM5.296 6.663l1.201 1.071-.001.007a.269.269 0 01-.106.462l-.001.005-1.54.443a3.134 3.134 0 01.447-1.988zm1.608 2.846l-.612 1.474a3.16 3.16 0 01-1.27-1.586L6.6 9.13l.003.003a.265.265 0 01.18.029.27.27 0 01.117.341l.004.006zm1.806 1.896c-.572.13-1.17.1-1.726-.088l.777-1.4h.001a.27.27 0 01.475-.001h.006l.779 1.402a3.286 3.286 0 01-.312.087zm1.004-.416L9.096 9.5l.001-.003a.269.269 0 01.296-.37l.003-.004 1.593.269a3.147 3.147 0 01-1.275 1.597zm1.442-2.343L9.61 8.201l-.002-.006a.27.27 0 01-.185-.343.27.27 0 01.08-.12L9.5 7.73l1.195-1.067c.366.594.527 1.29.46 1.983z" clip-rule="evenodd"/></svg>`, Bk = `<?xml version="1.0" encoding="utf-8"?><!-- Uploaded to: SVG Repo, www.svgrepo.com, Generator: SVG Repo Mixer Tools -->
<svg fill="#000000" width="800px" height="800px" viewBox="0 0 24 24" role="img" xmlns="http://www.w3.org/2000/svg"><path d="M9.71 2.136a1.43 1.43 0 0 0-2.047 0h-.007a1.48 1.48 0 0 0-.421 1.042c0 .41.161.777.422 1.039l.007.007c.257.264.616.426 1.019.426.404 0 .766-.162 1.027-.426l.003-.007c.261-.262.421-.629.421-1.039 0-.408-.159-.777-.421-1.042H9.71zM8.683 22.295c.404 0 .766-.167 1.027-.429l.003-.008c.261-.261.421-.631.421-1.036 0-.41-.159-.778-.421-1.044H9.71a1.42 1.42 0 0 0-1.027-.432 1.4 1.4 0 0 0-1.02.432h-.007c-.26.266-.422.634-.422 1.044 0 .406.161.775.422 1.036l.007.008c.258.262.617.429 1.02.429zm7.89-4.462c.359-.096.683-.33.882-.684l.027-.052a1.47 1.47 0 0 0 .114-1.067 1.454 1.454 0 0 0-.675-.896l-.021-.014a1.425 1.425 0 0 0-1.078-.132c-.36.091-.684.335-.881.686-.2.349-.241.75-.146 1.119.099.363.33.691.675.896h.002c.346.203.737.239 1.101.144zm-6.405-7.342a2.083 2.083 0 0 0-1.485-.627c-.58 0-1.103.242-1.482.627-.378.385-.612.916-.612 1.507s.233 1.124.612 1.514a2.08 2.08 0 0 0 2.967 0c.379-.39.612-.923.612-1.514s-.233-1.122-.612-1.507zm-.835-2.51c.843.141 1.6.552 2.178 1.144h.004c.092.093.182.196.265.299l1.446-.851a3.176 3.176 0 0 1-.047-1.808 3.149 3.149 0 0 1 1.456-1.926l.025-.016a3.062 3.062 0 0 1 2.345-.306c.77.21 1.465.721 1.898 1.482v.002c.431.757.518 1.626.313 2.408a3.145 3.145 0 0 1-1.456 1.928l-.198.118h-.02a3.095 3.095 0 0 1-2.154.201 3.127 3.127 0 0 1-1.514-.944l-1.444.848a4.162 4.162 0 0 1 0 2.879l1.444.846c.413-.47.939-.789 1.514-.944a3.041 3.041 0 0 1 2.371.319l.048.023v.002a3.17 3.17 0 0 1 1.408 1.906 3.215 3.215 0 0 1-.313 2.405l-.026.053-.003-.005a3.147 3.147 0 0 1-1.867 1.436 3.096 3.096 0 0 1-2.371-.318v-.006a3.156 3.156 0 0 1-1.456-1.927 3.175 3.175 0 0 1 .047-1.805l-1.446-.848a3.905 3.905 0 0 1-.265.294l-.004.005a3.938 3.938 0 0 1-2.178 1.138v1.699a3.09 3.09 0 0 1 1.56.862l.002.004c.565.572.914 1.368.914 2.243 0 .873-.35 1.664-.914 2.239l-.002.009a3.1 3.1 0 0 1-2.21.931 3.1 3.1 0 0 1-2.206-.93h-.002v-.009a3.186 3.186 0 0 1-.916-2.239c0-.875.35-1.672.916-2.243v-.004h.002a3.1 3.1 0 0 1 1.558-.862v-1.699a3.926 3.926 0 0 1-2.176-1.138l-.006-.005a4.098 4.098 0 0 1-1.173-2.874c0-1.122.452-2.136 1.173-2.872h.006a3.947 3.947 0 0 1 2.176-1.144V6.289a3.137 3.137 0 0 1-1.558-.864h-.002v-.004a3.192 3.192 0 0 1-.916-2.243c0-.871.35-1.669.916-2.243l.002-.002A3.084 3.084 0 0 1 8.683 0c.861 0 1.641.355 2.21.932v.002h.002c.565.574.914 1.372.914 2.243 0 .876-.35 1.667-.914 2.243l-.002.005a3.142 3.142 0 0 1-1.56.864v1.692zm8.121-1.129-.012-.019a1.452 1.452 0 0 0-.87-.668 1.43 1.43 0 0 0-1.103.146h.002c-.347.2-.58.529-.677.896-.095.365-.054.768.146 1.119l.007.009c.2.347.519.579.874.673.357.103.755.059 1.098-.144l.019-.009a1.47 1.47 0 0 0 .657-.885 1.493 1.493 0 0 0-.141-1.118"/></svg>`, zk = `<?xml version="1.0" encoding="utf-8"?><!-- Uploaded to: SVG Repo, www.svgrepo.com, Generator: SVG Repo Mixer Tools -->
<svg fill="#000000" width="800px" height="800px" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
  <path d="M15.027 20.771h-12.881c-0.484-1.541-0.724-3.151-0.719-4.771 0-1.667 0.24-3.265 0.719-4.771h21.147c2.64-0.011 4.781 2.131 4.776 4.771 0.015 2.625-2.109 4.765-4.735 4.771zM14.427 22.375h-11.692c1.229 2.823 3.265 5.224 5.853 6.907 2.589 1.719 5.636 2.636 8.745 2.625 5.531 0 10.375-2.828 13.24-7.068-1.521-1.573-3.609-2.469-5.803-2.479zM24.771 9.64c2.271 0 4.333-0.957 5.803-2.468-3.24-4.828-8.855-7.511-14.652-7-5.791 0.516-10.848 4.14-13.187 9.468z"/>
</svg>`, Uk = `<?xml version="1.0" encoding="utf-8"?><!-- Uploaded to: SVG Repo, www.svgrepo.com, Generator: SVG Repo Mixer Tools -->
<svg width="800px" height="800px" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none"><path fill="#000000" d="M12.549 1h-4.55l1.407 4.38h4.548l-3.68 2.61 1.406 4.405c2.37-1.725 3.143-4.336 2.274-7.016L12.55 1zM2.045 5.38h4.55L8 1H3.45L2.045 5.38c-.868 2.68-.094 5.29 2.275 7.015L5.725 7.99l-3.68-2.612zm2.275 7.015L8 15l3.68-2.605L8 9.745l-3.68 2.65z"/></svg>`, Wk = `<?xml version="1.0" encoding="utf-8"?><!-- Uploaded to: SVG Repo, www.svgrepo.com, Generator: SVG Repo Mixer Tools -->
<svg fill="#000000" width="800px" height="800px" viewBox="0 -2 28 28" xmlns="http://www.w3.org/2000/svg"><path d="m27.994 14.729c-.012.267-.365.566-1.091.945-1.495.778-9.236 3.967-10.883 4.821-.589.419-1.324.67-2.116.67-.641 0-1.243-.164-1.768-.452l.019.01c-1.304-.622-9.539-3.95-11.023-4.659-.741-.35-1.119-.653-1.132-.933v2.83c0 .282.39.583 1.132.933 1.484.709 9.722 4.037 11.023 4.659.504.277 1.105.44 1.744.44.795 0 1.531-.252 2.132-.681l-.011.008c1.647-.859 9.388-4.041 10.883-4.821.76-.396 1.096-.7 1.096-.982s0-2.791 0-2.791z"/><path d="m27.992 10.115c-.013.267-.365.565-1.09.944-1.495.778-9.236 3.967-10.883 4.821-.59.421-1.326.672-2.121.672-.639 0-1.24-.163-1.763-.449l.019.01c-1.304-.627-9.539-3.955-11.023-4.664-.741-.35-1.119-.653-1.132-.933v2.83c0 .282.39.583 1.132.933 1.484.709 9.721 4.037 11.023 4.659.506.278 1.108.442 1.749.442.793 0 1.527-.251 2.128-.677l-.011.008c1.647-.859 9.388-4.043 10.883-4.821.76-.397 1.096-.7 1.096-.984s0-2.791 0-2.791z"/><path d="m27.992 5.329c.014-.285-.358-.534-1.107-.81-1.451-.533-9.152-3.596-10.624-4.136-.528-.242-1.144-.383-1.794-.383-.734 0-1.426.18-2.035.498l.024-.012c-1.731.622-9.924 3.835-11.381 4.405-.729.287-1.086.552-1.073.834v2.83c0 .282.39.583 1.132.933 1.484.709 9.721 4.038 11.023 4.66.504.277 1.105.439 1.744.439.795 0 1.531-.252 2.133-.68l-.011.008c1.647-.859 9.388-4.043 10.883-4.821.76-.397 1.096-.7 1.096-.984s0-2.791 0-2.791h-.009zm-17.967 2.684 6.488-.996-1.96 2.874zm14.351-2.588-4.253 1.68-3.835-1.523 4.246-1.679 3.838 1.517zm-11.265-2.785-.628-1.157 1.958.765 1.846-.604-.499 1.196 1.881.7-2.426.252-.543 1.311-.879-1.457-2.8-.252 2.091-.754zm-4.827 1.632c1.916 0 3.467.602 3.467 1.344s-1.559 1.344-3.467 1.344-3.474-.603-3.474-1.344 1.553-1.344 3.474-1.344z"/></svg>`, W6 = {
  actor: Ww,
  boundary: Hw,
  control: $w,
  database: Vw,
  entity: Gw,
  awsiotlora: Xw,
  awsiotgreengrasscomponent: Jw,
  cloudwatch: zi,
  cloudfront: Ui,
  cognito: jw,
  dynamodb: Yi,
  ebs: $i,
  ec2: ji,
  ecs: Vi,
  efs: W7,
  elasticache: Ki,
  elasticbeantalk: qw,
  elasticfilesystem: W7,
  glacier: H7,
  s3glacier: H7,
  iam: Di,
  kinesis: Kw,
  lambda: Gi,
  lightsail: Yw,
  rds: qi,
  redshift: Ni,
  s3: Hi,
  sns: Bi,
  sqs: Pi,
  sagemaker: Qw,
  vpc: Wi,
  awsiotthingcoffeepot: ex,
  awsiotlambda: tx,
  awsiotthingwindfarm: nx,
  awsiotthingvibrationsensor: ix,
  awsiotdevicedefenderjobs: sx,
  awsiotdevicemanagementfleethub: rx,
  awsiottopic: ox,
  awsiotcertificate: lx,
  awsiotthingrelay: Lx,
  awsiotanalyticschannel: ax,
  awsiotthingcamera: Cx,
  awsiotthingdoorlock: cx,
  awsiotpolicy: ux,
  awsiotthingfreertos: hx,
  awsiotsitewiseassetproperties: dx,
  awsiotthingtempvibrationsensor: gx,
  awsiotthingplc: fx,
  awsiotaction: px,
  awsiotalexavoice: mx,
  awsiotalexaenabled: wx,
  awsiotthingutility: xx,
  awsiotactuator: _x,
  awsiotthingtempsensor: vx,
  awsiothttpprotocol: Mx,
  awsiotcoredevicelocation: Rx,
  awsiotalexaskill: yx,
  awsiotanalyticsnotebook: Ax,
  awsiothardwareboard: Zx,
  awsiotthingcar: kx,
  awsiotthinglightbulb: Tx,
  awsiotsitewiseasset: Sx,
  awsiotsitewisedatastreams: bx,
  awsiotgreengrasscomponentnucleus: Ex,
  awsiotthinghouse: Ix,
  awsiotoverairupdate: Fx,
  awsiotthingbank: Ox,
  awsiotsensor: Nx,
  awsiotsitewiseassethierarchy: Dx,
  awsiotgreengrassartifact: Px,
  awsiotthingtravel: Bx,
  awsiotmqttprotocol: zx,
  awsiotshadow: Ux,
  awsiotfiretv: Wx,
  awsiotgreengrassconnector: Hx,
  awsiotgreengrassipc: $x,
  awsiothttp2protocol: Vx,
  awsiotfiretvstick: Gx,
  awsiotcoredeviceadvisor: jx,
  awsiotthingindustrialpc: qx,
  awsiotdesiredstate: Kx,
  awsiotecho: Yx,
  awsiotgreengrassrecipe: Qx,
  awsiotgreengrasscomponentprivate: Xx,
  awsiotgreengrassstreammanager: Jx,
  awsiotthingmedicalemergency: e_,
  awsiotthingthermostat: t_,
  awsiotsitewiseassetmodel: n_,
  awsiotthingstacklight: i_,
  awsiotthingtemphumiditysensor: s_,
  awsiotgreengrasscomponentpublic: r_,
  awsiotsailboat: o_,
  awsiotrule: l_,
  awsiotthingbicycle: L_,
  awsiotreportedstate: a_,
  awsiotsimulator: C_,
  awsiotthingpoliceemergency: c_,
  awsiotanalyticsdatastore: u_,
  awsiotdevicetester: h_,
  awsiotanalyticspipeline: d_,
  awsiotthingfactory: g_,
  awsiotthinghumiditysensor: f_,
  awsiotgreengrassprotocol: p_,
  awsiotservo: m_,
  awsiotanalyticsdataset: w_,
  awsiotgreengrassmachinelearning: x_,
  awsiotthinggeneric: __,
  awsiotdevicegateway: v_,
  awsiotthingcart: M_,
  amazonrekognitionvideo: R_,
  amazonsagemakermodel: y_,
  amazonsagemakeranalyzelending: A_,
  amazonsagemakershadowtesting: Z_,
  amazondevopsguruinsights: k_,
  amazonsagemakernotebook: T_,
  amazonsagemakercanvas: S_,
  amazonsagemakertrain: b_,
  amazonsagemakergeospatialml: E_,
  amazonrekognitionimage: I_,
  amazonbraketsimulator: F_,
  amazonbraketnoisesimulator: O_,
  amazonbraketchip: N_,
  amazonbraketsimulator1: D_,
  amazonbraketmanagedsimulator: P_,
  amazonbraketsimulator3: B_,
  amazonbraketchandelier: z_,
  amazonbrakettensornetwork: U_,
  amazonbraketsimulator4: W_,
  amazonbraketqpu: H_,
  amazonbraketstatevector: $_,
  amazonbraketsimulator2: V_,
  amazonopensearchobservability: G_,
  amazonredshiftra3: j_,
  amazonredshiftstreaming: q_,
  amazonemrengine: K_,
  amazonredshiftqueryeditor: Ni,
  amazonehrhdfscluster: Y_,
  amazonmskconnect: Q_,
  awsgluedatacatalog: X_,
  amazondatzonedataportal: J_,
  amazondatzonebusinessdatacatalog: ev,
  amazondatzonedataprojects: tv,
  amazonredshiftdensestorage: nv,
  awsgluedataquality: iv,
  awsgluecrawler: sv,
  amazonquicksightreports: rv,
  awslakeformationdatalake: ov,
  amazonopensearchultrawarm: lv,
  amazoncloudsearchsearchdocuments: Lv,
  amazonopensearchingestion: av,
  amazonathenadatasource: Cv,
  amazonopensearchadminnode: cv,
  amazonopensearchdashboards: uv,
  amazonopensearchindex: hv,
  awsglueray: dv,
  amazonredshiftdatasharing: gv,
  amazonredshiftautocopy: fv,
  amazonredshiftdensecompute: pv,
  amazonredshiftml: mv,
  amazonopensearchtraces: wv,
  amazonemrcluster: xv,
  amazonopensearchdatanode: _v,
  awsdataexchangeapi: vv,
  amazonworkspaces: Mv,
  amazonworkspacescore: Rv,
  amazonworkspacesweb: yv,
  awsdirservicesimplead: Av,
  awswafbadbot: Zv,
  awsidentityaccesssts: kv,
  awsidentityaccessaddon: Tv,
  amazoninspectoragent: Sv,
  awsidentityaccessdataencryption: bv,
  awsidentityaccessmfatoken: Ev,
  awsdirserviceadconnector: Iv,
  awsidentityaccesspermissions: Fv,
  awswaflabels: Ov,
  awscertmgrca: Nv,
  awsidentityaccessstsalt: Dv,
  awsdirservicemanagedmsad: Pv,
  awssecurityhubfinding: Bv,
  awswafrule: zv,
  awsidentityaccessrole: Uv,
  awsidentityaccesslongtermcredential: Wv,
  awsidentityaccesstempcredential: Hv,
  awswaffilteringrule: $v,
  awswafbot: Vv,
  awsshieldadvanced: Gv,
  awsidentityaccessanalyzer: Di,
  awswafbotcontrol: jv,
  awsidentityaccessrolesanywhere: qv,
  awsidentityaccessdataencryptionkey: Kv,
  awsnetworkfirewallendpoints: Yv,
  awswafmanagedrule: Qv,
  awskeymanagementexternalkeystore: Xv,
  amazonblockchain: Jv,
  amazoneventbridgesaas: eM,
  amazoneventbridgeschema: tM,
  amazonmqbroker: nM,
  amazoneventbridgeschemaregistry: iM,
  amazoneventbridgedefaultbus: sM,
  amazonsnsnotification: rM,
  amazoneventbridgeevent: oM,
  amazonnshttpnotification: lM,
  amazoneventbridgepipes: LM,
  amazoneventbridgerule: aM,
  amazonapigatewayendpoint: CM,
  amazoneventbridgescheduler: cM,
  amazonsqsqueue: Pi,
  amazonsqsmessage: uM,
  amazoneventbridgecustomeventbus: hM,
  amazonsnstopic: Bi,
  awsssmpatchmanager: dM,
  awscloudformationtemplate: gM,
  awsopsworkslayers: fM,
  amazoncloudwatchmetricsinsights: pM,
  amazoncloudwatchdataprotection: mM,
  amazoncloudwatchalarm: wM,
  awstrustedadvisorchecksecurity: xM,
  awstrustedadvisorcheckperformance: _M,
  amazoncloudwatchrule: vM,
  awsopsworksresources: MM,
  amazoncloudwatcheventtime: RM,
  awsorgsmanagementaccount: yM,
  awslicensemanagerlicenseblending: AM,
  amazoncloudwatcheventevent: ZM,
  amazoncloudwatchsynthetics: kM,
  awsssmstatemanager: TM,
  awscloudformationstack: SM,
  awsopsworksinstances: bM,
  awsssmruncommand: EM,
  awsopsworksdeployments: IM,
  awsssmautomation: FM,
  awsssmchangecalendar: OM,
  awsorgsorganizationalunit: NM,
  awsssmsessionmanager: DM,
  awstrustedadvisorcheckcost: PM,
  awsopsworksstack2: BM,
  awslicensemanagerapplicationdiscovery: zM,
  awsssmopscenter: UM,
  awsssminventory: WM,
  awsopsworkspermissions: HM,
  awsopsworksapps: $M,
  awscloudformationchangeset: VM,
  awsssmdocuments: GM,
  awsssmapplicationmanager: jM,
  awsorgsaccount: qM,
  awscloudtrailcloudtraillake: KM,
  awsssmmaintenancewindows: YM,
  awssmmincidentmanager: QM,
  amazoncloudwatchevidently: XM,
  amazoncloudwatchrum: JM,
  awsssmparameterstore: eR,
  amazoncloudwatchlogs: zi,
  awsssmchangemanager: tR,
  awsopsworksmonitoring: nR,
  awsssmcompliance: iR,
  awsssmdistributor: sR,
  amazoncloudwatchobservability: rR,
  awstrustedadvisorcheckfault: oR,
  awstrustedadvisorchecklist: lR,
  amazonroute53routetable: LR,
  amazoncloudfrontdistribution: aR,
  amazonroute53routingcontrols: CR,
  amazonroute53arc: cR,
  amazonvpctrafficmirroring: uR,
  amazonvpcreachabilityanalyzer: hR,
  awscloudmapnamespace: dR,
  awstransitgatewayattachment: gR,
  amazonvpcigw: fR,
  amazoncloudfrontedgelocation: pR,
  awscloudwansegmentnetwork: mR,
  awscloudmapservice: wR,
  awsappmeshvirtualrouter: xR,
  amazonvpcendpoints: _R,
  amazonvpcvpnconnection: vR,
  amazoncloudfrontstreaming: MR,
  amazonvpcpeering: RR,
  amazonroute53resolverdnsfirewall: yR,
  amazonroute53hostedzone: AR,
  amazonvpcvpngateway: ZR,
  amazoncloudfrontfunctions: Ui,
  amazoneaelasticnetworkadapter: kR,
  awsappmeshvirtualgateway: TR,
  amazonroute53resolverlogging: SR,
  elasticlbclassic: bR,
  amazonroute53resolver: ER,
  awscloudwancorenetworkedge: IR,
  awsappmeshvirtualservice: FR,
  amazonvpcflowlogs: OR,
  awscloudmapresource: NR,
  awsdirectconnectgateway: DR,
  amazonvpcnetworkaccessanalyzer: PR,
  elasticlbapp: BR,
  amazonvpcvpc: Wi,
  amazonvpccarriergateway: zR,
  amazoneaelasticnetworkinterface: UR,
  awscloudwanrouteattachment: WR,
  amazonroute53readiness: HR,
  awsappmeshvirtualnode: $R,
  elasticlbgateway: VR,
  amazonvpcrouter: GR,
  awsappmeshmesh: jR,
  amazonvpcnatgateway: qR,
  amazonvpcnetworkacl: KR,
  amazonvpccustomer: YR,
  elasticlbnetwork: QR,
  amazons3replication: XR,
  amazons3onezone: JR,
  awsbackuplegalhold: ey,
  awsstoragegateaway: ty,
  amazonefsstandard: W7,
  amazons3bucket: Hi,
  awsstoragegateawayfile: ny,
  awsfsxfile: iy,
  amazons3glacierinstant: sy,
  amazonfilecache: ry,
  amazons3standardia: oy,
  amazons3generalaccess: ly,
  amazons3lambda: Ly,
  amazons3objectlock: ay,
  awsbackupvirtualmachine: Cy,
  amazonec2gp3: cy,
  amazonefsfilesys: uy,
  awssnowballimportexport: hy,
  amazons3object: dy,
  awsbackupcache: gy,
  amazons3lambdaobject: fy,
  awsbackupgateway: py,
  awsbackuprto: my,
  awsbackupvaultlock: wy,
  awsbackupvirtualtape: xy,
  amazonebsdatalifecycle: _y,
  awsbackupplan: vy,
  amazonfilecaches3: My,
  awsbackupcloudformation: Ry,
  awsbackuptapegateway: yy,
  awsbackupvmware: Ay,
  amazonefsonezoneia: Zy,
  amazons3replicationtime: ky,
  awsbackupstorage: Ty,
  amazonefsintelligenttiering: Sy,
  amazons3glacierdeep: by,
  amazons3select: Ey,
  amazons3outposts: Iy,
  awsfilegateway: Fy,
  amazons3glacier: Oy,
  awsbackupvmmonitor: Ny,
  amazons3multiregion: Dy,
  awsbackupvault: Py,
  awsbackupauditmanager: By,
  amazonfilecachehybridnfs: zy,
  amazonefselasticthroughput: Uy,
  awsbackupawsbackupfors3: Wy,
  amazons3standard: Hy,
  amazonefsonezone: $y,
  awsstoragegateawayvolume: Vy,
  awsbackuprestore: Gy,
  amazonebsvolumes: jy,
  amazons3lens: qy,
  awsbackupcompute: Ky,
  amazonvpclogs: Yy,
  amazons3batch: Qy,
  amazonefsinfrequent: Xy,
  amazons3tiering: Jy,
  awsbackuprpo: eA,
  awsbackupcompliance: tA,
  amazonebssnapshot: nA,
  awsbackupdatabase: iA,
  awsbackupfsx: sA,
  amazons3glacierflex: H7,
  amazons3bucketobject: rA,
  amazonebsvolume: $i,
  amazons3vault: oA,
  amazoneksoutposts: lA,
  amazonecscontainer2: LA,
  amazonecrimage: aA,
  amazonecstask: CA,
  amazonecsservice: cA,
  amazonecscontainer1: uA,
  amazonecrregistry: hA,
  amazonecscontainer3: Vi,
  amazonecscopilotcli: dA,
  amazonecsserviceconnect: gA,
  amazonec2extractor: fA,
  amazonec2ami: pA,
  awselasticbeanstalkdeployment: mA,
  awslambdafunction: Gi,
  amazonec2instance: ji,
  amazonec2autoscaling: wA,
  amazonec2spotinstance: xA,
  awselasticbeanstalkapp: _A,
  amazonec2instancecloudwatch: vA,
  amazonec2rescue: MA,
  amazonec2instances: RA,
  amazonec2dbinstance: yA,
  amazonec2elasticip: AA,
  amazonrdsoptimizedwrites: ZA,
  amazondynamodbtblclass: kA,
  amazonrdsinstancealternate: TA,
  amazondynamodbattributes: SA,
  amazonrdsauroramysqlalternative: bA,
  amazondynamodbitem: EA,
  amazonrdsaurorapgsqlalt: IA,
  amazondynamodbitems: FA,
  amazonrdsauroraalternate: OA,
  amazonrdsaurorasqlalt: NA,
  amazonrdsinstance: qi,
  amazonrdsmultiaz: DA,
  amazondocdbelasticclusters: PA,
  amazonrdstrustedextpgsql: BA,
  amazonrdsaurorasql: zA,
  amazondynamodbglobal: UA,
  amazonrdsoracle: WA,
  amazonrdsoraclealternate: HA,
  amazondynamodbstream: $A,
  amazonrdstrustedpgsql: VA,
  amazondax: GA,
  amazonelasticache4redis: Ki,
  amazonrdsproxy: jA,
  amazondynamodbaccesstable: qA,
  amazonrdsauroramysql: KA,
  amazonrdspiops: YA,
  awsdbmigrationserviceworkflow: QA,
  amazondynamodbattribute: XA,
  amazonrdsbluegreendeploy: JA,
  amazondynamodbtable: Yi,
  amazonrdsaurorainstance: eZ,
  amazonrdsauroradbinstance: tZ,
  amazonelasticache4memcached: nZ,
  amazonrdsproxyalternate: iZ,
  amazonrdsaurorapgsql: sZ,
  amazonrdsauroradbinstancealternate: rZ,
  amazonelasticachecachenode: oZ,
  amazonrdsmultiazcluster: lZ,
  awstransferfamilyftps: LZ,
  awstransferfamilysftp: aZ,
  awsmainframemodruntime: CZ,
  awstransferfamilyftp: cZ,
  awsmigrationhubrefactor: uZ,
  awsmainframemoddeveloper: hZ,
  awsdiscoveryagent: dZ,
  awsmainframemodcompiler: gZ,
  awsmigrationhubrefactorapp: fZ,
  awsdiscoveryagentlesscollector: pZ,
  awsmainframemodanalyzer: mZ,
  awsdatasyndiscovery: wZ,
  awsmigrationhubrefactorservice: xZ,
  awsdatasyngagent: _Z,
  awsmainframemodconverter: vZ,
  awstransferfamilyas2: MZ,
  awsdiscoverymigrationevaluator: RZ,
  awscloudinterface: yZ,
  awsmediaconnectgateway: AZ,
  awsrobomakercloudextensions: ZZ,
  awsrobomakersimulation: kZ,
  awsrobomakerfleetmanagement: TZ,
  awsrobomakerdevenv: SZ,
  awsamplifystudio: bZ,
  amazonlocationmap: EZ,
  amazonlocationplace: IZ,
  amazonlocationtrack: FZ,
  amazonlocationgeofence: OZ,
  amazonlocationroutes: NZ,
  awscloud9: DZ,
  amazonemailservice: PZ,
  amazonpinpointjourney: BZ,
  azureactivedirectory: zZ,
  azurebackup: UZ,
  azurecdn: WZ,
  azuredatafactory: HZ,
  azuredevops: $Z,
  azurefunction: VZ,
  azuresql: GZ,
  cosmosdb: jZ,
  logicapps: qZ,
  virtualmachine: KZ,
  bigtable: YZ,
  bigquery: QZ,
  cloudcdn: XZ,
  clouddns: JZ,
  cloudinterconnect: ek,
  cloudloadbalancing: tk,
  cloudsql: nk,
  cloudstorage: ik,
  datalab: sk,
  dataproc: rk,
  googleiam: ok,
  googlesecurity: lk,
  googlevpc: Lk,
  pubsub: ak,
  securityscanner: Ck,
  stackdriver: ck,
  visionapi: uk,
  client: hk,
  server: dk,
  browser: gk,
  service: fk,
  controller: pk,
  api: mk,
  ui: wk,
  mobile: xk,
  externalsystem: _k,
  application: vk,
  loadbalancer: Mk,
  network: Rk,
  cache: yk,
  webserver: Ak,
  messagequeue: Zk,
  scheduler: kk,
  gateway: Tk,
  authenticationservice: Sk,
  mailserver: bk,
  github: Ek,
  docker: Ik,
  gitlab: Fk,
  jenkins: Ok,
  postgresql: Nk,
  mongodb: Dk,
  kubernetes: Pk,
  apachekafka: Bk,
  elasticsearch: zk,
  auth0: Uk,
  redis: Wk
};
function FL() {
  const t = R2(0), e = R2(0), n = () => {
    t.value = document.documentElement.scrollTop, e.value = document.documentElement.scrollLeft;
  };
  return s1(() => {
    n(), document.addEventListener("scroll", n);
  }), x1(() => {
    document.removeEventListener("scroll", n);
  }), [t, e];
}
const H6 = 10, Hk = 1, Qi = 20;
function $k() {
  let t = document.getElementById(
    "zenuml-intersection-detector-container"
  ), e = Array.from(
    document.getElementsByClassName("zenuml-intersection-detector")
  );
  return t && e.length === H6 ? { detectorContainer: t, detectors: e } : (t = document.createElement("div"), t.id = "zenuml-intersection-detector-container", Object.assign(t.style, {
    position: "absolute",
    top: "0",
    left: "0",
    opacity: "0",
    pointerEvents: "none"
  }), e = new Array(H6).fill(0).map(() => {
    const n = document.createElement("div");
    return n.className = "zenuml-intersection-detector", Object.assign(n.style, {
      position: "absolute",
      top: "0",
      left: "0",
      width: "100%"
    }), t == null || t.appendChild(n), n;
  }), document.body.appendChild(t), { detectorContainer: t, detectors: e });
}
function OL() {
  const t = R2(0);
  let e;
  return s1(() => {
    const { detectorContainer: n, detectors: i } = $k(), s = document.documentElement.scrollHeight - Qi, r = document.documentElement.scrollWidth - Qi;
    n.style.height = s + "px", n.style.width = r + "px";
    const o = Math.ceil(
      document.documentElement.scrollHeight / H6
    ), l = [...Array(o + 1).keys()].map((L) => L / o).filter((L) => L >= 0 && L <= 1);
    i.forEach((L, a) => {
      L.style.top = a * o + "px", L.style.height = o + "px";
    }), e = new IntersectionObserver(
      ([L]) => {
        (L.intersectionRect.top - L.boundingClientRect.top > Hk || L.target === i[0]) && (t.value = L.intersectionRect.top);
      },
      {
        threshold: l
      }
    ), i.forEach((L) => {
      e.observe(L);
    });
  }), x1(() => {
    e == null || e.disconnect();
  }), t;
}
function NL(t) {
  let e = 0, n = t;
  for (; n; )
    e += n.offsetTop, n = n.offsetParent;
  return e;
}
const V0 = /[!@#$%^&*()+-,.?''":{}|<>/\s]/, f8 = (t) => {
  const e = R2(!1);
  function n(l) {
    e.value = l;
  }
  async function i(l) {
    l.preventDefault(), l.stopPropagation(), n(!0), await P4();
    const L = document.createRange();
    if (!l.target)
      return;
    L.selectNodeContents(l.target), L.collapse(!1);
    const a = window.getSelection();
    a && (a == null || a.removeAllRanges(), a == null || a.addRange(L));
  }
  async function s(l) {
    await P4(), e.value && (n(!1), t(l));
  }
  function r(l) {
    l.key === "Enter" && (l.preventDefault(), l.stopPropagation());
  }
  function o(l) {
    (l.key === "Enter" || l.key === "Escape" || l.key === "Tab") && (n(!1), t(l));
  }
  return {
    editing: e,
    handleDblClick: i,
    handleBlur: s,
    handleKeydown: r,
    handleKeyup: o
  };
}, Vk = { class: "flex items-center justify-center" }, Gk = ["contenteditable"], jk = /* @__PURE__ */ _("span", null, ":", -1), qk = ["contenteditable"], Kk = /* @__PURE__ */ q2({
  __name: "ParticipantLabel",
  props: {
    labelText: null,
    labelPositions: null,
    assignee: null,
    assigneePositions: null
  },
  setup(t) {
    const e = t, n = ["Missing Constructor", "ZenUML"], { labelText: i, labelPositions: s, assigneePositions: r } = g9(e), o = F3(), l = I(() => o.state.mode), L = I(() => o.getters.code), a = I(
      () => o.getters.onContentChange || (() => {
      })
    );
    function C(f) {
      o.dispatch("updateCode", { code: f }), a.value(f);
    }
    function c(f) {
      return function(x) {
        x.preventDefault(), x.stopPropagation();
        const k = x.target;
        if (!(k instanceof HTMLElement))
          return;
        let m = k.innerText.trim() ?? "";
        if (m === "" || m === i.value) {
          k.innerText = i.value;
          return;
        }
        if (m.includes(" ") && (m = m.replace(/\s+/g, " ")), V0.test(m) && (m = m.replace(/"/g, ""), m = `"${m}"`, V0.lastIndex = 0), !f || f.length === 0)
          return;
        let g = L.value;
        for (const w of f) {
          const [Z, b] = w;
          g = g.slice(0, Z) + m + g.slice(b);
        }
        C(g);
      };
    }
    const h = f8(
      c((s == null ? void 0 : s.value) ?? [])
    ), d = f8(
      c((r == null ? void 0 : r.value) ?? [])
    );
    return (f, x) => (T(), B("div", Vk, [
      t.assignee ? (T(), B(P2, { key: 0 }, [
        _("label", {
          title: "Double click to edit",
          class: v2(["name px-1 leading-4 cursor-text right hover:text-skin-message-hover hover:bg-skin-message-hover", {
            "py-1 cursor-text": O(d).editing
          }]),
          contenteditable: O(d).editing && O(l) === O(j1).Dynamic,
          onDblclick: x[0] || (x[0] = //@ts-ignore
          (...k) => O(d).handleDblClick && O(d).handleDblClick(...k)),
          onBlur: x[1] || (x[1] = //@ts-ignore
          (...k) => O(d).handleBlur && O(d).handleBlur(...k)),
          onKeyup: x[2] || (x[2] = //@ts-ignore
          (...k) => O(d).handleKeyup && O(d).handleKeyup(...k)),
          onKeydown: x[3] || (x[3] = //@ts-ignore
          (...k) => O(d).handleKeydown && O(d).handleKeydown(...k))
        }, m1(t.assignee), 43, Gk),
        jk
      ], 64)) : x2("", !0),
      _("label", {
        title: "Double click to edit",
        class: v2(["name px-1 leading-4 cursor-text right hover:text-skin-message-hover hover:bg-skin-message-hover", {
          "py-1 cursor-text": O(h).editing
        }]),
        contenteditable: O(h).editing && O(l) === O(j1).Dynamic && n.indexOf(O(i)) === -1,
        onDblclick: x[4] || (x[4] = //@ts-ignore
        (...k) => O(h).handleDblClick && O(h).handleDblClick(...k)),
        onBlur: x[5] || (x[5] = //@ts-ignore
        (...k) => O(h).handleBlur && O(h).handleBlur(...k)),
        onKeyup: x[6] || (x[6] = //@ts-ignore
        (...k) => O(h).handleKeyup && O(h).handleKeyup(...k)),
        onKeydown: x[7] || (x[7] = //@ts-ignore
        (...k) => O(h).handleKeydown && O(h).handleKeydown(...k))
      }, m1(O(i)), 43, qk)
    ]));
  }
}), Yk = 10, Qk = {
  name: "Participant",
  components: {
    ParticipantLabel: Kk
  },
  setup(t) {
    const e = F3(), n = R2(null);
    if (e.state.mode === j1.Static)
      return { translate: 0, participant: n };
    const i = I(() => {
      const L = e.getters.participants.GetPositions(
        t.entity.name
      );
      return Array.from(L ?? []).sort((C, c) => c[0] - C[0]);
    }), s = I(() => {
      const L = e.getters.participants.GetAssigneePositions(
        t.entity.name
      );
      return Array.from(L ?? []).sort((C, c) => c[0] - C[0]);
    }), r = OL(), [o] = FL();
    return { translate: I(() => {
      var h;
      const L = t.offsetTop2 || 0;
      let a = r.value + o.value;
      r.value > Yk && (e != null && e.state.stickyOffset) && (a += e == null ? void 0 : e.state.stickyOffset);
      const C = ((h = e == null ? void 0 : e.state.diagramElement) == null ? void 0 : h.clientHeight) || 0, c = e != null && e.state.diagramElement ? NL(e == null ? void 0 : e.state.diagramElement) : 0;
      return a < L + c ? 0 : Math.min(a - c, C - sp) - L;
    }), participant: n, labelPositions: i, assigneePositions: s };
  },
  props: {
    entity: {
      type: Object,
      required: !0
    },
    // offsetTop is a standard HTML property, so we use offsetTop2.
    offsetTop2: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      color: void 0
    };
  },
  mounted() {
    this.updateFontColor();
  },
  updated() {
    this.updateFontColor();
  },
  computed: {
    isDefaultStarter() {
      return this.entity.name === K1;
    },
    selected() {
      return this.$store.state.selected.includes(this.entity.name);
    },
    stereotype() {
      return this.entity.stereotype;
    },
    labelText() {
      return this.entity.assignee ? this.entity.name.split(":")[1] : this.entity.label || this.entity.name;
    },
    comment() {
      return this.entity.comment;
    },
    icon() {
      var t;
      return this.isDefaultStarter ? W6.actor : W6[(t = this.entity.type) == null ? void 0 : t.toLowerCase()];
    },
    backgroundColor() {
      try {
        return this.entity.color ? this.entity.color && Uw(this.entity.color) : void 0;
      } catch {
        return;
      }
    }
  },
  methods: {
    onSelect() {
      this.$store.commit("onSelect", this.entity.name);
    },
    updateFontColor() {
      if (!this.entity.color) {
        this.color = void 0;
        return;
      }
      let t = window.getComputedStyle(this.$refs.participant).getPropertyValue("background-color");
      if (!t) {
        this.color = void 0;
        return;
      }
      let e = zw(t);
      this.color = e > 128 ? "#000" : "#fff";
    }
  }
}, Xk = { class: "flex items-center justify-center" }, Jk = ["innerHTML", "aria-description"], eT = {
  key: 1,
  class: "h-5 group flex flex-col justify-center"
}, tT = {
  key: 0,
  class: "interface leading-4"
};
function nT(t, e, n, i, s, r) {
  const o = i2("ParticipantLabel");
  return T(), B("div", {
    class: v2(["participant bg-skin-participant shadow-participant border-skin-participant text-skin-participant rounded text-base leading-4 flex flex-col justify-center z-10 h-10 top-8", { selected: r.selected }]),
    ref: "participant",
    style: w2({
      backgroundColor: r.isDefaultStarter ? void 0 : r.backgroundColor,
      color: r.isDefaultStarter ? void 0 : s.color,
      transform: `translateY(${i.translate}px)`
    }),
    onClick: e[0] || (e[0] = (...l) => r.onSelect && r.onSelect(...l))
  }, [
    _("div", Xk, [
      r.icon ? (T(), B("div", {
        key: 0,
        innerHTML: r.icon,
        class: "h-6 w-6 mr-1 flex-shrink-0 [&>svg]:w-full [&>svg]:h-full",
        "aria-description": `icon for ${n.entity.name}`
      }, null, 8, Jk)) : x2("", !0),
      r.isDefaultStarter ? x2("", !0) : (T(), B("div", eT, [
        r.stereotype ? (T(), B("label", tT, "«" + m1(r.stereotype) + "»", 1)) : x2("", !0),
        N(o, {
          labelText: r.labelText,
          labelPositions: i.labelPositions,
          assignee: n.entity.assignee,
          assigneePositions: i.assigneePositions
        }, null, 8, ["labelText", "labelPositions", "assignee", "assigneePositions"])
      ]))
    ])
  ], 6);
}
const DL = /* @__PURE__ */ K2(Qk, [["render", nT]]);
const c0 = y8.child({ name: "LifeLine" }), iT = {
  name: "life-line",
  components: { Participant: DL },
  props: [
    "entity",
    "context",
    "groupLeft",
    "inGroup",
    "renderParticipants",
    "renderLifeLine"
  ],
  data: () => ({
    translateX: 0,
    top: 24
  }),
  computed: {
    ...R3(["centerOf"]),
    ...q8(["scale"]),
    debug() {
      return !!localStorage.zenumlDebug;
    },
    left() {
      return this.centerOf(this.entity.name) - (this.groupLeft || 0);
    }
  },
  mounted() {
    c0.debug(`LifeLine mounted for ${this.entity.name}`), this.$nextTick(() => {
      this.setTop(), c0.debug(`nextTick after updated for ${this.entity.name}`);
    }), d7.on(
      "participant_set_top",
      () => (
        // eslint-disable-next-line vue/valid-next-tick
        this.$nextTick(() => this.setTop())
      )
    );
  },
  updated() {
    c0.debug(`updated for ${this.entity.name}`), this.$nextTick(() => {
      this.setTop(), c0.debug(`nextTick after updated for ${this.entity.name}`);
    });
  },
  methods: {
    onSelect() {
      this.$store.commit("onSelect", this.entity.name);
    },
    setTop() {
      var s;
      const t = this.entity.name.replace(
        // eslint-disable-next-line no-useless-escape
        /([ #;&,.+*~\':"!^$[\]()=>|\/@])/g,
        "\\$1"
      ), e = this.$store.getters.diagramElement, n = e == null ? void 0 : e.querySelector(`[data-to="${t}"]`), i = (n == null ? void 0 : n.offsetParent) != null;
      if (n && ((s = n.attributes["data-type"]) == null ? void 0 : s.value) === "creation" && i) {
        c0.debug(`First message to ${this.entity.name} is creation`);
        const r = this.$el.getBoundingClientRect().y, o = n.getBoundingClientRect().y;
        this.top = (o - r) / this.scale;
      }
    }
  }
}, sT = ["id", "entity-type"], rT = {
  key: 1,
  class: "line w0 mx-auto flex-grow w-px"
};
function oT(t, e, n, i, s, r) {
  var l;
  const o = i2("participant");
  return T(), B("div", {
    id: n.entity.name,
    "entity-type": (l = n.entity.type) == null ? void 0 : l.toLowerCase(),
    class: v2(["lifeline absolute flex flex-col h-full", { "transform -translate-x-1/2": n.renderParticipants }]),
    style: w2({ paddingTop: t.top + "px", left: r.left + "px" })
  }, [
    n.renderParticipants ? (T(), T2(o, {
      key: 0,
      entity: n.entity,
      offsetTop2: t.top
    }, null, 8, ["entity", "offsetTop2"])) : x2("", !0),
    n.renderLifeLine ? (T(), B("div", rT)) : x2("", !0)
  ], 14, sT);
}
const PL = /* @__PURE__ */ K2(iT, [["render", oT], ["__scopeId", "data-v-f23e44f2"]]), Xi = 2, lT = {
  name: "lifeline-group",
  props: ["context", "renderParticipants", "renderLifeLine"],
  computed: {
    ...R3(["coordinates"]),
    name() {
      var t, e;
      return (e = (t = this.context) == null ? void 0 : t.name()) == null ? void 0 : e.getFormattedText();
    },
    left() {
      const t = this.entities[0].name;
      return this.coordinates.left(t) + Xi;
    },
    right() {
      const t = this.entities.slice(0).pop().name;
      return this.coordinates.right(t) - Xi;
    },
    entities() {
      return c5(this.context).Array();
    }
  },
  methods: {
    // Helper method to determine if a participant has an icon
  },
  components: {
    LifeLine: PL
  }
}, LT = {
  key: 0,
  class: "z-10 absolute flex items-center justify-center w-full bg-skin-frame"
}, aT = { class: "font-semibold text-skin-lifeline-group-name" }, CT = { class: "lifeline-group relative flex-grow" };
function cT(t, e, n, i, s, r) {
  const o = i2("life-line");
  return r.entities.length > 0 ? (T(), B("div", {
    key: 0,
    class: v2(["lifeline-group-container absolute flex flex-col flex-grow h-full", { "outline-dashed outline-skin-primary": n.renderLifeLine }]),
    style: w2({
      left: `${r.left}px`,
      width: `${r.right - r.left}px`
    })
  }, [
    n.renderParticipants && r.name ? (T(), B("div", LT, [
      _("span", aT, m1(r.name), 1)
    ])) : x2("", !0),
    _("div", CT, [
      (T(!0), B(P2, null, e4(r.entities, (l) => (T(), T2(o, {
        inGroup: "true",
        key: l.name,
        ref_for: !0,
        ref: l.name,
        entity: l,
        "group-left": r.left,
        "render-life-line": n.renderLifeLine,
        renderParticipants: n.renderParticipants
      }, null, 8, ["entity", "group-left", "render-life-line", "renderParticipants"]))), 128))
    ])
  ], 6)) : x2("", !0);
}
const uT = /* @__PURE__ */ K2(lT, [["render", cT]]), Ji = y8.child({ name: "LifeLineLayer" }), hT = 70, dT = 10, gT = {
  name: "life-line-layer",
  props: ["context", "renderParticipants", "renderLifeLine", "leftGap"],
  setup() {
    const e = F3(), n = I(() => e.state.mode);
    if (n.value === j1.static)
      return { translate: 0, RenderMode: j1, mode: n };
    const i = OL(), [s] = FL();
    return { translate: I(() => {
      var a;
      let o = i.value + s.value;
      i.value > dT && (e != null && e.state.stickyOffset) && (o += e == null ? void 0 : e.state.stickyOffset);
      const l = ((a = e == null ? void 0 : e.state.diagramElement) == null ? void 0 : a.clientHeight) || 0, L = e != null && e.state.diagramElement ? NL(e == null ? void 0 : e.state.diagramElement) : 0;
      return o <= 0 + L ? 0 : Math.min(o - L, l - hT) - 0;
    }), RenderMode: j1, mode: n };
  },
  computed: {
    ...R3([
      "coordinates",
      "participants",
      "GroupContext",
      "ParticipantContext",
      "centerOf"
    ]),
    participantNames() {
      return this.participants.Names();
    },
    debug() {
      return !!localStorage.zenumlDebug;
    },
    starterParticipant() {
      const t = this.coordinates.orderedParticipantNames();
      return t.length === 0 ? null : t[0] === K1 ? {
        ...Nl,
        name: K1,
        explicit: !1,
        isStarter: !0
      } : null;
    },
    starterOnTheLeft() {
      var t;
      return !!this.starterParticipant && !((t = this.starterParticipant) != null && t.explicit);
    },
    implicitParticipants() {
      return this.participants.ImplicitArray();
    },
    explicitGroupAndParticipants() {
      var t;
      return (t = this.context) == null ? void 0 : t.children.filter((e) => {
        const n = e instanceof tL, i = e instanceof nL;
        return n || i;
      });
    }
  },
  methods: {
    ...Qo(["increaseGeneration"]),
    getParticipantEntity(t) {
      return c5(t).First();
    }
  },
  updated() {
    Ji.debug("LifeLineLayer updated");
  },
  mounted() {
    Ji.debug("LifeLineLayer mounted");
  },
  components: {
    LifeLine: PL,
    LifeLineGroup: uT
  }
}, fT = ["data-participant-names"], pT = { class: "z-lifeline-container relative grow" };
function mT(t, e, n, i, s, r) {
  const o = i2("life-line"), l = i2("life-line-group");
  return T(), B("div", {
    class: "life-line-layer lifeline-layer z-30 absolute h-full flex flex-col top-0 pt-2",
    "data-participant-names": r.participantNames,
    style: w2({
      "min-width": i.mode === i.RenderMode.Dynamic ? "200px" : "auto",
      width: `calc(100% - ${n.leftGap}px)`,
      pointerEvents: n.renderParticipants ? "none" : "all"
    })
  }, [
    _("div", pT, [
      r.starterOnTheLeft ? (T(), T2(o, {
        key: 0,
        entity: r.starterParticipant,
        class: "starter",
        renderParticipants: n.renderParticipants,
        renderLifeLine: n.renderLifeLine
      }, null, 8, ["entity", "renderParticipants", "renderLifeLine"])) : x2("", !0),
      (T(!0), B(P2, null, e4(r.explicitGroupAndParticipants, (L, a) => (T(), B(P2, null, [
        L instanceof t.GroupContext ? (T(), T2(l, {
          key: a,
          context: L,
          renderParticipants: n.renderParticipants,
          renderLifeLine: n.renderLifeLine
        }, null, 8, ["context", "renderParticipants", "renderLifeLine"])) : x2("", !0),
        L instanceof t.ParticipantContext ? (T(), T2(o, {
          key: a,
          entity: r.getParticipantEntity(L),
          renderParticipants: n.renderParticipants,
          renderLifeLine: n.renderLifeLine
        }, null, 8, ["entity", "renderParticipants", "renderLifeLine"])) : x2("", !0)
      ], 64))), 256)),
      (T(!0), B(P2, null, e4(r.implicitParticipants, (L) => (T(), T2(o, {
        key: L.name,
        entity: L,
        renderParticipants: n.renderParticipants,
        renderLifeLine: n.renderLifeLine
      }, null, 8, ["entity", "renderParticipants", "renderLifeLine"]))), 128))
    ])
  ], 12, fT);
}
const $7 = /* @__PURE__ */ K2(gT, [["render", mT]]), wT = { class: "message-layer relative z-30 pt-24 pb-10" }, es = /* @__PURE__ */ q2({
  __name: "MessageLayer",
  props: {
    context: null
  },
  setup(t) {
    const e = v0(() => import("./StylePanel-c6e01b46.js")), n = y8.child({ name: "MessageLayer" }), i = F3(), s = I(() => i.getters.centerOf), r = I(() => i.getters.rootContext), o = I(() => s.value(l.value) + 1), l = I(() => {
      const L = u7(r.value);
      return L.length === 0 ? K1 : L[0].from || K1;
    });
    return s1(() => {
      n.debug("MessageLayer mounted");
    }), t5(() => {
      n.debug("MessageLayer updated");
    }), (L, a) => {
      const C = i2("block");
      return T(), B("div", wT, [
        N(C, {
          context: t.context,
          style: w2({ "padding-left": O(o) + "px" }),
          origin: O(l)
        }, null, 8, ["context", "style", "origin"]),
        N(O(e))
      ]);
    };
  }
});
function p8(t) {
  return [t.Origin() || K1, ...c5(t).Names()];
}
const xT = y.tree.ParseTreeWalker.DEFAULT;
class $t extends A {
  constructor(e) {
    super(), this.frameRoot = null, this.parents = [], this._orderedParticipants = e;
  }
  // TODO: extract a module to get local participants
  getLocalParticipants(e) {
    return [
      e.Origin() || K1,
      ...c5(e).ImplicitArray().map((n) => n.name)
    ];
  }
  getLeft(e) {
    const n = p8(e);
    return this._orderedParticipants.find((i) => n.includes(i)) || "";
  }
  getRight(e) {
    return this._orderedParticipants.slice().reverse().find((n) => p8(e).includes(n)) || "";
  }
  enterFragment(e, n) {
    var s;
    const i = {
      type: n,
      left: this.getLeft(e),
      right: this.getRight(e),
      children: []
    };
    this.frameRoot || (this.frameRoot = i), this.parents.length > 0 && ((s = this.parents[this.parents.length - 1].children) == null || s.push(i)), this.parents.push(i);
  }
  exitFragment() {
    this.parents.pop();
  }
  enterTcf(e) {
    this.enterFragment(e, "tcf");
  }
  enterOpt(e) {
    this.enterFragment(e, "opt");
  }
  enterPar(e) {
    this.enterFragment(e, "par");
  }
  enterAlt(e) {
    this.enterFragment(e, "alt");
  }
  enterLoop(e) {
    this.enterFragment(e, "loop");
  }
  enterSection(e) {
    this.enterFragment(e, "section");
  }
  enterCritical(e) {
    this.enterFragment(e, "critical");
  }
  enterRef(e) {
    this.enterFragment(e, "ref");
  }
  exitTcf() {
    this.exitFragment();
  }
  exitOpt() {
    this.exitFragment();
  }
  exitPar() {
    this.exitFragment();
  }
  exitAlt() {
    this.exitFragment();
  }
  exitLoop() {
    this.exitFragment();
  }
  exitSection() {
    this.exitFragment();
  }
  exitCritical() {
    this.exitFragment();
  }
  exitRef() {
    this.exitFragment();
  }
  getFrame(e) {
    return e.children.map((n) => {
      xT.walk(this, n);
    }), this.frameRoot;
  }
}
function $6(t, e) {
  if (!t.children || t.children.length === 0)
    return 1;
  let n = 0;
  for (const i of t.children)
    e === "LEFT" && i.left !== t.left || e === "RIGHT" && i.right !== t.right || (n = Math.max(n, $6(i, e)));
  return n + 1;
}
function Vt(t) {
  return t ? {
    type: t.type,
    left: Ei * $6(
      t,
      "LEFT"
      /* LEFT */
    ),
    right: Ei * $6(
      t,
      "RIGHT"
      /* RIGHT */
    )
  } : { left: 0, right: 0 };
}
function BL(t, e) {
  const n = e.orderedParticipantNames(), i = p8(t), s = n.find((c) => i.includes(c)) || "", r = n.slice().reverse().find((c) => i.includes(c)) || "", l = new $t(n).getFrame(t), L = Vt(l), a = _T(
    t,
    r,
    e
  ), C = e.distance(s, r) + e.half(s) + e.half(r);
  return Math.max(C, rL) + L.left + L.right + a;
}
function _T(t, e, n) {
  const s = u7(t).filter((r) => r.from === r.to).map(
    (r) => n.getMessageWidth(r) - n.distance(r.from || K1, e) - n.half(e)
  );
  return Math.max.apply(null, [0, ...s]);
}
const Gt = /* @__PURE__ */ q2({
  __name: "SeqDiagram",
  setup(t) {
    const e = F3(), n = I(() => e.state.theme), i = I(() => e.state.mode), s = I(() => e.getters.rootContext), r = I(() => e.getters.coordinates), o = I(() => BL(s.value, r.value) - l.value), l = I(() => {
      const a = r.value.orderedParticipantNames(), c = new $t(a).getFrame(s.value);
      return c ? Vt(c).left : 0;
    }), L = R2(null);
    return e.commit("diagramElement", L), (a, C) => (T(), B("div", {
      class: v2(["zenuml sequence-diagram relative box-border text-left overflow-visible px-2.5", O(n)]),
      ref_key: "diagramRef",
      ref: L
    }, [
      _("div", {
        style: w2({ paddingLeft: `${O(l)}px` }),
        class: "relative z-container"
      }, [
        O(i) === O(j1).Dynamic ? (T(), B(P2, { key: 0 }, [
          N($7, {
            leftGap: O(l),
            context: O(s).head(),
            renderParticipants: !1,
            renderLifeLine: !0
          }, null, 8, ["leftGap", "context"]),
          N(es, {
            context: O(s).block(),
            style: w2({ width: `${O(o)}px` })
          }, null, 8, ["context", "style"]),
          N($7, {
            leftGap: O(l),
            context: O(s).head(),
            renderParticipants: !0,
            renderLifeLine: !1
          }, null, 8, ["leftGap", "context"])
        ], 64)) : x2("", !0),
        O(i) === O(j1).Static ? (T(), B(P2, { key: 1 }, [
          N($7, {
            leftGap: O(l),
            context: O(s).head(),
            renderParticipants: !0,
            renderLifeLine: !0
          }, null, 8, ["leftGap", "context"]),
          N(es, {
            context: O(s).block(),
            style: w2({ width: `${O(o)}px` })
          }, null, 8, ["context", "style"])
        ], 64)) : x2("", !0)
      ], 4)
    ], 2));
  }
});
const vT = {
  name: "IconList",
  props: ["types"],
  computed: {},
  methods: {
    icon(t) {
      return W6[t == null ? void 0 : t.toLowerCase()];
    }
  }
}, MT = {
  role: "list",
  class: "mt-3 grid grid-cols-4 gap-5 sm:gap-6 sm:grid-cols-6 lg:grid-cols-8"
}, RT = { class: "h-12 flex items-center justify-center bg-gray-50 text-sm font-medium rounded-t-md" }, yT = ["innerHTML", "alt"], AT = { class: "flex items-center justify-center border-t border-r border-b border-gray-200 bg-white rounded-b-md" }, ZT = { class: "px-2 py-2 text-xs" }, kT = { class: "text-gray-900 font-medium hover:text-gray-600" };
function TT(t, e, n, i, s, r) {
  return T(), B("ul", MT, [
    (T(!0), B(P2, null, e4(n.types, (o) => (T(), B("li", {
      key: o,
      class: "col-span-1 flex flex-col shadow-sm rounded-md"
    }, [
      _("div", RT, [
        r.icon ? (T(), B("i", {
          key: 0,
          innerHTML: r.icon(o),
          class: "object-contain h-8 w-8 m-auto [&>svg]:w-full [&>svg]:h-full",
          alt: `icon for ${o}`
        }, null, 8, yT)) : x2("", !0)
      ]),
      _("div", AT, [
        _("div", ZT, [
          _("span", kT, "@" + m1(o), 1)
        ])
      ])
    ]))), 128))
  ]);
}
const ST = /* @__PURE__ */ K2(vT, [["render", TT]]), bT = {
  name: "TipsDialog",
  components: { Icon: q1, IconList: ST },
  computed: {
    standardTypes() {
      return ["Actor", "Boundary", "Control", "Database", "Entity"];
    },
    awsServices() {
      return [
        "CloudWatch",
        "CloudFront",
        "Cognito",
        "DynamoDB",
        "EBS",
        "EC2",
        "ECS",
        "EFS",
        "ElastiCache",
        "ElasticBeantalk",
        "ElasticFileSystem",
        "Glacier",
        "IAM",
        "Kinesis",
        "Lambda",
        "LightSail",
        "RDS",
        "Redshift",
        "S3",
        "SNS",
        "SQS",
        "Sagemaker",
        "VPC"
      ];
    },
    azureServices() {
      return [
        "AzureActiveDirectory",
        "AzureBackup",
        "AzureCDN",
        "AzureDataFactory",
        "AzureDevOps",
        "AzureFunction",
        "AzureSQL",
        "CosmosDB",
        "LogicApps",
        "VirtualMachine"
      ];
    },
    googleServices() {
      return [
        "BigTable",
        "BigQuery",
        "CloudCDN",
        "CloudDNS",
        "CloudInterconnect",
        "CloudLoadBalancing",
        "CloudSQL",
        "CloudStorage",
        "DataLab",
        "DataProc",
        "GoogleIAM",
        "GoogleSecurity",
        "GoogleVPC",
        "PubSub",
        "SecurityScanner",
        "StackDriver",
        "VisionAPI"
      ];
    }
  },
  methods: {
    closeTipsDialog() {
      var t;
      this.$store.state.showTips = !1;
      try {
        (t = this.$gtag) == null || t.event("close", {
          event_category: "help",
          event_label: "tips dialog"
        });
      } catch (e) {
        console.error(e);
      }
    }
  }
}, ET = { class: "flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block" }, IT = /* @__PURE__ */ _("div", {
  class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity",
  "aria-hidden": "true"
}, null, -1), FT = /* @__PURE__ */ _("span", {
  class: "hidden sm:inline-block sm:align-middle sm:h-screen",
  "aria-hidden": "true"
}, "​", -1), OT = { class: "z-40 inline-block align-bottom bg-white rounded-lg px-4 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:p-2" }, NT = { class: "bg-white px-4 py-5 border-b border-gray-200 sm:px-6" }, DT = /* @__PURE__ */ _("h3", { class: "text-xl leading-6 font-medium text-gray-900 inline-block" }, " ZenUML Tips ", -1), PT = /* @__PURE__ */ _("span", { class: "sr-only" }, "Close menu", -1), BT = { class: "relative bg-white pb-32 mt-4 overflow-hidden" }, zT = { class: "relative" }, UT = { class: "lg:mx-auto lg:max-w-11/12 lg:px-8" }, WT = /* @__PURE__ */ W8(`<div class="grid lg:grid-cols-3 sm:grid-cols-2 grid-cols-1"><div><div class="px-4 max-w-full mx-auto sm:px-6 lg:max-w-none lg:mx-0"><h2 class="mt-4 mb-4 text-lg leading-6 font-medium text-gray-900"> Declare Participants </h2><pre class="text-xs w-full bg-gray-50 text-gray-600 p-2 rounded-lg"><code>// Define a Starter (optional)
@Starter(A)

// Show icons
@EC2 A

// Use &#39;group&#39; keyword
group GroupName {  B  C }

// Use alias
S as Service

// Use stereotype
&lt;&lt;servlet&gt;&gt; ServiceX</code></pre></div><div class="px-4 max-w-7xl mx-auto sm:px-6 lg:max-w-none lg:mx-0"><h2 class="mt-4 mb-4 text-lg leading-6 font-medium text-gray-900"> Divider </h2><pre class="text-xs w-full bg-gray-50 text-gray-600 p-2 rounded-lg"><code>A.method()
==divider name==
B.method()
</code></pre></div></div><div class="px-4 w-full mx-auto lg:max-w-none lg:mx-0"><h2 class="mt-4 mb-4 text-lg leading-6 font-medium text-gray-900"> Fragments </h2><pre class="text-xs w-full bg-gray-50 text-gray-600 p-2 rounded-lg"><code>// Alt (AKA if/else)
if(condition1) {}
else if (condition2) {}
else {}

// \`loop\`, \`for\`, \`forEach\`, \`while\`
// are treated the same
forEach(records) {}

// Opt
opt {}

// Par
par {}

// Section
section(ID) {} / frame(ID) {};

// Critical
critical {}

// Try Catch Finally
try {} catch() {} finally {}
</code></pre></div><div class="px-4 w-full mx-auto lg:max-w-none lg:mx-0"><h2 class="mt-4 mb-4 text-lg leading-6 font-medium text-gray-900"> Messages </h2><pre class="text-xs w-full bg-gray-50 text-gray-600 p-2 rounded-lg"><code>//Creation
new ParticipantName()

//Sync Message
A.method
A-&gt;B.method

//Async Message
A-&gt;B: async message

//Reply Message, three styles
x = A.method
A.method() {
  return x
}
A.method() {
  @return A-&gt;B: message
}</code></pre></div></div>`, 1), HT = { class: "px-4 max-w-7xl mx-auto sm:px-6 lg:max-w-none lg:mx-0" }, $T = /* @__PURE__ */ _("h2", { class: "mt-8 mb-4 text-lg leading-6 font-medium text-gray-900" }, " Builtin Icons ", -1), VT = /* @__PURE__ */ _("p", { class: "text-sm text-gray-500" }, [
  /* @__PURE__ */ q3(" Use "),
  /* @__PURE__ */ _("span", { class: "rounded inline-block bg-gray-50 text-gray-600" }, [
    /* @__PURE__ */ _("code", { class: "text-xs" }, "@Actor TheParticipant")
  ]),
  /* @__PURE__ */ q3(" to define the type of the participant. ")
], -1), GT = /* @__PURE__ */ _("hr", { class: "mt-4" }, null, -1), jT = /* @__PURE__ */ _("hr", { class: "mt-4" }, null, -1), qT = /* @__PURE__ */ _("hr", { class: "mt-4" }, null, -1);
function KT(t, e, n, i, s, r) {
  const o = i2("Icon"), l = i2("IconList");
  return T(), B("div", ET, [
    IT,
    FT,
    _("div", OT, [
      _("div", null, [
        _("div", NT, [
          DT,
          _("button", {
            type: "button",
            onClick: e[0] || (e[0] = (L) => r.closeTipsDialog()),
            class: "float-right bg-white rounded-md inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500"
          }, [
            PT,
            N(o, {
              name: "close",
              "icon-class": "h-6 w-6"
            })
          ])
        ]),
        _("div", null, [
          _("div", BT, [
            _("div", zT, [
              _("div", UT, [
                WT,
                _("div", HT, [
                  $T,
                  VT,
                  N(l, { types: r.standardTypes }, null, 8, ["types"]),
                  GT,
                  N(l, { types: r.awsServices }, null, 8, ["types"]),
                  jT,
                  N(l, { types: r.azureServices }, null, 8, ["types"]),
                  qT,
                  N(l, { types: r.googleServices }, null, 8, ["types"])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]);
}
const YT = /* @__PURE__ */ K2(bT, [["render", KT]]), QT = {
  name: "point",
  props: ["fill", "rtl"]
}, XT = {
  key: 0,
  class: "arrow stroke-2",
  height: "10",
  width: "10",
  viewBox: "0 0 3 6"
}, JT = /* @__PURE__ */ _("path", {
  d: "M4.42834 2.657C4.68727 2.81236 4.68727 3.18764 4.42834 3.343L0.605799 5.63652C0.339189 5.79649 1.66376e-08 5.60444 2.97152e-08 5.29352L2.22651e-07 0.706476C2.35729e-07 0.395559 0.339189 0.203513 0.605799 0.363479L4.42834 2.657Z",
  fill: "currentColor",
  stroke: "none"
}, null, -1), eS = [
  JT
], tS = {
  key: 1,
  class: "arrow stroke-2",
  height: "10",
  width: "10",
  viewBox: "0 0 2 8.5"
}, nS = /* @__PURE__ */ _("path", {
  d: "M1 1L4.14331 4.29299C4.14704 4.2969 4.14699 4.30306 4.1432 4.30691L1 7.5",
  stroke: "currentColor",
  "stroke-linecap": "round",
  fill: "none"
}, null, -1), iS = [
  nS
], sS = {
  key: 2,
  class: "arrow stroke-2",
  height: "10",
  width: "10",
  viewBox: "1 0 5 6"
}, rS = /* @__PURE__ */ _("path", {
  d: "M0.571662 2.657C0.312726 2.81236 0.312726 3.18764 0.571662 3.343L4.3942 5.63652C4.66081 5.79649 5 5.60444 5 5.29352L5 0.706476C5 0.395559 4.66081 0.203513 4.3942 0.363479L0.571662 2.657Z",
  fill: "currentColor",
  stroke: "none"
}, null, -1), oS = [
  rS
], lS = {
  key: 3,
  class: "arrow stroke-2",
  height: "10",
  width: "10",
  viewBox: "2 0 5 9"
}, LS = /* @__PURE__ */ _("path", {
  d: "M4.14844 1L1.00441 4.54711C1.00101 4.55094 1.00106 4.55671 1.00451 4.56049L4.14844 8",
  stroke: "currentColor",
  "stroke-linecap": "round",
  fill: "none"
}, null, -1), aS = [
  LS
];
function CS(t, e, n, i, s, r) {
  return T(), B("div", {
    class: v2(["point text-skin-message-arrow", { filled: n.fill, open: !n.fill, "right-to-left": n.rtl }])
  }, [
    !n.rtl && n.fill ? (T(), B("svg", XT, eS)) : x2("", !0),
    !n.rtl && !n.fill ? (T(), B("svg", tS, iS)) : x2("", !0),
    n.rtl && n.fill ? (T(), B("svg", sS, oS)) : x2("", !0),
    n.rtl && !n.fill ? (T(), B("svg", lS, aS)) : x2("", !0)
  ], 2);
}
const cS = /* @__PURE__ */ K2(QT, [["render", CS]]), uS = ["contenteditable"], g7 = /* @__PURE__ */ q2({
  __name: "MessageLabel",
  props: {
    labelText: { default: "" },
    labelPosition: null,
    isAsync: { type: Boolean, default: !1 },
    isSelf: { type: Boolean, default: !1 }
  },
  setup(t) {
    const e = t, { labelText: n, labelPosition: i, isAsync: s } = g9(e), r = F3(), o = I(() => r.state.mode), l = I(() => r.getters.code), L = I(
      () => r.getters.onContentChange || (() => {
      })
    ), a = I(() => Jl(n.value));
    function C(m) {
      r.dispatch("updateCode", { code: m }), L.value(m);
    }
    function c(m) {
      m.preventDefault(), m.stopPropagation();
      const g = m.target;
      if (!(g instanceof HTMLElement))
        return;
      let w = g.innerText.trim() ?? "";
      if (w === "" || w === n.value) {
        g.innerText = n.value;
        return;
      }
      w.includes(" ") && (w = w.replace(/\s+/g, " ")), !s.value && V0.test(w) && (w = w.replace(/"/g, ""), w = `"${w}"`, V0.lastIndex = 0);
      const [Z, b] = i.value;
      if (Z === -1 || b === -1) {
        console.warn("labelPosition is not set");
        return;
      }
      const z = l.value.slice(0, Z) + w + l.value.slice(b + 1);
      C(z);
    }
    const { editing: h, handleDblClick: d, handleBlur: f, handleKeydown: x, handleKeyup: k } = f8(c);
    return (m, g) => (T(), B("label", {
      title: "Double click to edit",
      class: v2(["px-1 cursor-text right hover:text-skin-message-hover hover:bg-skin-message-hover", {
        "cursor-text": O(h)
      }]),
      contenteditable: O(h) && O(o) === O(j1).Dynamic,
      onDblclick: g[0] || (g[0] = //@ts-ignore
      (...w) => O(d) && O(d)(...w)),
      onBlur: g[1] || (g[1] = //@ts-ignore
      (...w) => O(f) && O(f)(...w)),
      onKeyup: g[2] || (g[2] = //@ts-ignore
      (...w) => O(k) && O(k)(...w)),
      onKeydown: g[3] || (g[3] = //@ts-ignore
      (...w) => O(x) && O(x)(...w))
    }, m1(O(a)), 43, uS));
  }
}), hS = {
  key: 0,
  class: "absolute text-xs right-[100%] top-0 pr-1 group-hover:hidden text-gray-500 font-thin"
}, N3 = /* @__PURE__ */ q2({
  __name: "Numbering",
  props: {
    number: null
  },
  setup(t) {
    const e = F3(), n = I(() => e.state.numbering);
    return (i, s) => O(n) ? (T(), B("div", hS, m1(t.number), 1)) : x2("", !0);
  }
}), dS = { class: "name group text-center flex-grow relative hover:text-skin-message-hover hover:bg-skin-message-hover" }, gS = { class: "inline-block static min-h-[1em]" }, h5 = /* @__PURE__ */ q2({
  __name: "Message",
  props: {
    context: null,
    content: null,
    rtl: { type: [String, Boolean] },
    type: null,
    textStyle: null,
    classNames: null,
    number: null
  },
  setup(t) {
    const e = t, { context: n, content: i, rtl: s, type: r, textStyle: o, classNames: l, number: L } = g9(e), a = F3(), C = R2(), c = I(() => (r == null ? void 0 : r.value) === "async"), h = I(() => a.state.mode), d = I(() => {
      var b;
      if (h.value === j1.Static)
        return !1;
      switch (r == null ? void 0 : r.value) {
        case "sync":
        case "async":
        case "return":
          return !0;
        case "creation":
          return ((b = n == null ? void 0 : n.value) == null ? void 0 : b.isParamValid()) > 0;
        default:
          return !1;
      }
    }), f = I(() => {
      if (h.value === j1.Static)
        return !1;
      switch (r == null ? void 0 : r.value) {
        case "sync":
        case "async":
        case "return":
        case "creation":
          return !0;
        default:
          return !1;
      }
    }), x = /«([^»]+)»/, k = I(() => {
      var b;
      switch (r == null ? void 0 : r.value) {
        case "creation":
          return ((b = i == null ? void 0 : i.value.match(x)) == null ? void 0 : b[1]) || "";
        case "sync":
        case "async":
        case "return":
        default:
          return (i == null ? void 0 : i.value) || "";
      }
    }), m = I(() => {
      var K, E, L2, t2, u2, N2, m2;
      let b = -1, z = -1;
      switch (r == null ? void 0 : r.value) {
        case "sync":
          {
            const P = (E = (K = n == null ? void 0 : n.value) == null ? void 0 : K.messageBody().func()) == null ? void 0 : E.signature()[0];
            [b, z] = [P == null ? void 0 : P.start.start, P == null ? void 0 : P.stop.stop];
          }
          break;
        case "async":
          {
            const P = (L2 = n == null ? void 0 : n.value) == null ? void 0 : L2.content();
            [b, z] = [P == null ? void 0 : P.start.start, P == null ? void 0 : P.stop.stop];
          }
          break;
        case "creation":
          {
            const P = (u2 = (t2 = n == null ? void 0 : n.value) == null ? void 0 : t2.creationBody()) == null ? void 0 : u2.parameters();
            [b, z] = [P == null ? void 0 : P.start.start, P == null ? void 0 : P.stop.stop];
          }
          break;
        case "return":
          if ((n == null ? void 0 : n.value) instanceof u.MessageContext) {
            const P = (m2 = (N2 = n.value.messageBody().func()) == null ? void 0 : N2.signature()) == null ? void 0 : m2[0];
            [b, z] = [P == null ? void 0 : P.start.start, P == null ? void 0 : P.stop.stop];
          } else if ((n == null ? void 0 : n.value) instanceof u.AtomExprContext) {
            const P = n.value.atom();
            [b, z] = [P == null ? void 0 : P.start.start, P == null ? void 0 : P.stop.stop];
          } else if ((n == null ? void 0 : n.value) instanceof u.ContentContext)
            [b, z] = [n.value.start.start, n.value.stop.stop];
          else if ((n == null ? void 0 : n.value) instanceof u.AssignmentContext) {
            const P = n.value.assignee();
            [b, z] = [P.start.start, P.stop.stop];
          }
          break;
      }
      return [b, z];
    }), g = I(() => {
      switch (r == null ? void 0 : r.value) {
        case "sync":
        case "async":
          return "solid";
        case "creation":
        case "return":
          return "dashed";
      }
      return "";
    }), w = I(() => {
      switch (r == null ? void 0 : r.value) {
        case "sync":
          return !0;
        case "async":
        case "creation":
        case "return":
        default:
          return !1;
      }
    }), Z = () => {
      f.value && a.getters.onMessageClick(n, C.value);
    };
    return (b, z) => (T(), B("div", {
      class: v2(["message leading-none border-skin-message-arrow border-b-2 flex items-end", {
        "flex-row-reverse": O(s),
        return: O(r) === "return",
        "right-to-left": O(s)
      }]),
      style: w2({ "border-bottom-style": O(g) || void 0 }),
      onClick: Z,
      ref_key: "messageRef",
      ref: C
    }, [
      _("div", dS, [
        _("div", gS, [
          _("div", {
            style: w2(O(o)),
            class: v2(O(l))
          }, [
            O(d) ? (T(), B(P2, { key: 0 }, [
              H0(_("span", null, "«", 512), [
                [$9, O(r) === "creation"]
              ]),
              N(g7, {
                labelText: O(k) ?? "",
                labelPosition: O(m),
                isAsync: O(c)
              }, null, 8, ["labelText", "labelPosition", "isAsync"]),
              H0(_("span", null, "»", 512), [
                [$9, O(r) === "creation"]
              ])
            ], 64)) : (T(), B(P2, { key: 1 }, [
              q3(m1(O(i)), 1)
            ], 64))
          ], 6)
        ])
      ]),
      N(cS, {
        class: "flex-shrink-0 transform translate-y-1/2 -my-px",
        fill: O(w),
        rtl: O(s)
      }, null, 8, ["fill", "rtl"]),
      N(N3, { number: O(L) }, null, 8, ["number"])
    ], 6));
  }
}), fS = {
  name: "WidthProvider",
  components: { Message: h5 },
  data: function() {
    return {
      text: "abcd"
    };
  },
  methods: {
    width: function(t, e) {
      return console.log(t, e), this.text = t, this.$el.clientWidth;
    }
  },
  mounted() {
    this.$store.state.widthProvider = this;
  }
}, pS = { class: "hidden" };
function mS(t, e, n, i, s, r) {
  const o = i2("message");
  return T(), B("div", pS, [
    N(o, {
      content: t.text,
      rtl: !1,
      type: "sync"
    }, null, 8, ["content"])
  ]);
}
const wS = /* @__PURE__ */ K2(fS, [["render", mS]]);
function xS(t, e) {
  if (t.match(/^[a-z]+:\/\//i))
    return t;
  if (t.match(/^\/\//))
    return window.location.protocol + t;
  if (t.match(/^[a-z]+:/i))
    return t;
  const n = document.implementation.createHTMLDocument(), i = n.createElement("base"), s = n.createElement("a");
  return n.head.appendChild(i), n.body.appendChild(s), e && (i.href = e), s.href = t, s.href;
}
const _S = (() => {
  let t = 0;
  const e = () => (
    // eslint-disable-next-line no-bitwise
    `0000${(Math.random() * 36 ** 4 << 0).toString(36)}`.slice(-4)
  );
  return () => (t += 1, `u${e()}${t}`);
})();
function W4(t) {
  const e = [];
  for (let n = 0, i = t.length; n < i; n++)
    e.push(t[n]);
  return e;
}
function m8(t, e) {
  const i = (t.ownerDocument.defaultView || window).getComputedStyle(t).getPropertyValue(e);
  return i ? parseFloat(i.replace("px", "")) : 0;
}
function vS(t) {
  const e = m8(t, "border-left-width"), n = m8(t, "border-right-width");
  return t.clientWidth + e + n;
}
function MS(t) {
  const e = m8(t, "border-top-width"), n = m8(t, "border-bottom-width");
  return t.clientHeight + e + n;
}
function zL(t, e = {}) {
  const n = e.width || vS(t), i = e.height || MS(t);
  return { width: n, height: i };
}
function RS() {
  let t, e;
  try {
    e = process;
  } catch {
  }
  const n = e && e.env ? e.env.devicePixelRatio : null;
  return n && (t = parseInt(n, 10), Number.isNaN(t) && (t = 1)), t || window.devicePixelRatio || 1;
}
const u3 = 16384;
function yS(t) {
  (t.width > u3 || t.height > u3) && (t.width > u3 && t.height > u3 ? t.width > t.height ? (t.height *= u3 / t.width, t.width = u3) : (t.width *= u3 / t.height, t.height = u3) : t.width > u3 ? (t.height *= u3 / t.width, t.width = u3) : (t.width *= u3 / t.height, t.height = u3));
}
function AS(t, e = {}) {
  return t.toBlob ? new Promise((n) => {
    t.toBlob(n, e.type ? e.type : "image/png", e.quality ? e.quality : 1);
  }) : new Promise((n) => {
    const i = window.atob(t.toDataURL(e.type ? e.type : void 0, e.quality ? e.quality : void 0).split(",")[1]), s = i.length, r = new Uint8Array(s);
    for (let o = 0; o < s; o += 1)
      r[o] = i.charCodeAt(o);
    n(new Blob([r], {
      type: e.type ? e.type : "image/png"
    }));
  });
}
function w8(t) {
  return new Promise((e, n) => {
    const i = new Image();
    i.decode = () => e(i), i.onload = () => e(i), i.onerror = n, i.crossOrigin = "anonymous", i.decoding = "async", i.src = t;
  });
}
async function ZS(t) {
  return Promise.resolve().then(() => new XMLSerializer().serializeToString(t)).then(encodeURIComponent).then((e) => `data:image/svg+xml;charset=utf-8,${e}`);
}
async function kS(t, e, n) {
  const i = "http://www.w3.org/2000/svg", s = document.createElementNS(i, "svg"), r = document.createElementNS(i, "foreignObject");
  return s.setAttribute("width", `${e}`), s.setAttribute("height", `${n}`), s.setAttribute("viewBox", `0 0 ${e} ${n}`), r.setAttribute("width", "100%"), r.setAttribute("height", "100%"), r.setAttribute("x", "0"), r.setAttribute("y", "0"), r.setAttribute("externalResourcesRequired", "true"), s.appendChild(r), r.appendChild(t), ZS(s);
}
function TS(t) {
  const e = t.getPropertyValue("content");
  return `${t.cssText} content: '${e.replace(/'|"/g, "")}';`;
}
function SS(t) {
  return W4(t).map((e) => {
    const n = t.getPropertyValue(e), i = t.getPropertyPriority(e);
    return `${e}: ${n}${i ? " !important" : ""};`;
  }).join(" ");
}
function bS(t, e, n) {
  const i = `.${t}:${e}`, s = n.cssText ? TS(n) : SS(n);
  return document.createTextNode(`${i}{${s}}`);
}
function ts(t, e, n) {
  const i = window.getComputedStyle(t, n), s = i.getPropertyValue("content");
  if (s === "" || s === "none")
    return;
  const r = _S();
  try {
    e.className = `${e.className} ${r}`;
  } catch {
    return;
  }
  const o = document.createElement("style");
  o.appendChild(bS(r, n, i)), e.appendChild(o);
}
function ES(t, e) {
  ts(t, e, ":before"), ts(t, e, ":after");
}
const ns = "application/font-woff", is = "image/jpeg", IS = {
  woff: ns,
  woff2: ns,
  ttf: "application/font-truetype",
  eot: "application/vnd.ms-fontobject",
  png: "image/png",
  jpg: is,
  jpeg: is,
  gif: "image/gif",
  tiff: "image/tiff",
  svg: "image/svg+xml",
  webp: "image/webp"
};
function FS(t) {
  const e = /\.([^./]*?)$/g.exec(t);
  return e ? e[1] : "";
}
function jt(t) {
  const e = FS(t).toLowerCase();
  return IS[e] || "";
}
function OS(t) {
  return t.split(/,/)[1];
}
function V6(t) {
  return t.search(/^(data:)/) !== -1;
}
function UL(t, e) {
  return `data:${e};base64,${t}`;
}
async function WL(t, e, n) {
  const i = await fetch(t, e);
  if (i.status === 404)
    throw new Error(`Resource "${i.url}" not found`);
  const s = await i.blob();
  return new Promise((r, o) => {
    const l = new FileReader();
    l.onerror = o, l.onloadend = () => {
      try {
        r(n({ res: i, result: l.result }));
      } catch (L) {
        o(L);
      }
    }, l.readAsDataURL(s);
  });
}
const V7 = {};
function NS(t, e, n) {
  let i = t.replace(/\?.*/, "");
  return n && (i = t), /ttf|otf|eot|woff2?/i.test(i) && (i = i.replace(/.*\//, "")), e ? `[${e}]${i}` : i;
}
async function qt(t, e, n) {
  const i = NS(t, e, n.includeQueryParams);
  if (V7[i] != null)
    return V7[i];
  n.cacheBust && (t += (/\?/.test(t) ? "&" : "?") + (/* @__PURE__ */ new Date()).getTime());
  let s;
  try {
    const r = await WL(t, n.fetchRequestInit, ({ res: o, result: l }) => (e || (e = o.headers.get("Content-Type") || ""), OS(l)));
    s = UL(r, e);
  } catch (r) {
    s = n.imagePlaceholder || "";
    let o = `Failed to fetch resource: ${t}`;
    r && (o = typeof r == "string" ? r : r.message), o && console.warn(o);
  }
  return V7[i] = s, s;
}
async function DS(t) {
  const e = t.toDataURL();
  return e === "data:," ? t.cloneNode(!1) : w8(e);
}
async function PS(t, e) {
  if (t.currentSrc) {
    const r = document.createElement("canvas"), o = r.getContext("2d");
    r.width = t.clientWidth, r.height = t.clientHeight, o == null || o.drawImage(t, 0, 0, r.width, r.height);
    const l = r.toDataURL();
    return w8(l);
  }
  const n = t.poster, i = jt(n), s = await qt(n, i, e);
  return w8(s);
}
async function BS(t) {
  var e;
  try {
    if (!((e = t == null ? void 0 : t.contentDocument) === null || e === void 0) && e.body)
      return await f7(t.contentDocument.body, {}, !0);
  } catch {
  }
  return t.cloneNode(!1);
}
async function zS(t, e) {
  return t instanceof HTMLCanvasElement ? DS(t) : t instanceof HTMLVideoElement ? PS(t, e) : t instanceof HTMLIFrameElement ? BS(t) : t.cloneNode(!1);
}
const US = (t) => t.tagName != null && t.tagName.toUpperCase() === "SLOT";
async function WS(t, e, n) {
  var i;
  const s = US(t) && t.assignedNodes ? W4(t.assignedNodes()) : W4(((i = t.shadowRoot) !== null && i !== void 0 ? i : t).childNodes);
  return s.length === 0 || t instanceof HTMLVideoElement || await s.reduce((r, o) => r.then(() => f7(o, n)).then((l) => {
    l && e.appendChild(l);
  }), Promise.resolve()), e;
}
function HS(t, e) {
  const n = e.style;
  if (!n)
    return;
  const i = window.getComputedStyle(t);
  i.cssText ? (n.cssText = i.cssText, n.transformOrigin = i.transformOrigin) : W4(i).forEach((s) => {
    let r = i.getPropertyValue(s);
    s === "font-size" && r.endsWith("px") && (r = `${Math.floor(parseFloat(r.substring(0, r.length - 2))) - 0.1}px`), n.setProperty(s, r, i.getPropertyPriority(s));
  });
}
function $S(t, e) {
  t instanceof HTMLTextAreaElement && (e.innerHTML = t.value), t instanceof HTMLInputElement && e.setAttribute("value", t.value);
}
function VS(t, e) {
  if (t instanceof HTMLSelectElement) {
    const n = e, i = Array.from(n.children).find((s) => t.value === s.getAttribute("value"));
    i && i.setAttribute("selected", "");
  }
}
function GS(t, e) {
  return e instanceof Element && (HS(t, e), ES(t, e), $S(t, e), VS(t, e)), e;
}
async function jS(t, e) {
  const n = t.querySelectorAll ? t.querySelectorAll("use") : [];
  if (n.length === 0)
    return t;
  const i = {};
  for (let r = 0; r < n.length; r++) {
    const l = n[r].getAttribute("xlink:href");
    if (l) {
      const L = t.querySelector(l), a = document.querySelector(l);
      !L && a && !i[l] && (i[l] = await f7(a, e, !0));
    }
  }
  const s = Object.values(i);
  if (s.length) {
    const r = "http://www.w3.org/1999/xhtml", o = document.createElementNS(r, "svg");
    o.setAttribute("xmlns", r), o.style.position = "absolute", o.style.width = "0", o.style.height = "0", o.style.overflow = "hidden", o.style.display = "none";
    const l = document.createElementNS(r, "defs");
    o.appendChild(l);
    for (let L = 0; L < s.length; L++)
      l.appendChild(s[L]);
    t.appendChild(o);
  }
  return t;
}
async function f7(t, e, n) {
  return !n && e.filter && !e.filter(t) ? null : Promise.resolve(t).then((i) => zS(i, e)).then((i) => WS(t, i, e)).then((i) => GS(t, i)).then((i) => jS(i, e));
}
const HL = /url\((['"]?)([^'"]+?)\1\)/g, qS = /url\([^)]+\)\s*format\((["']?)([^"']+)\1\)/g, KS = /src:\s*(?:url\([^)]+\)\s*format\([^)]+\)[,;]\s*)+/g;
function YS(t) {
  const e = t.replace(/([.*+?^${}()|\[\]\/\\])/g, "\\$1");
  return new RegExp(`(url\\(['"]?)(${e})(['"]?\\))`, "g");
}
function QS(t) {
  const e = [];
  return t.replace(HL, (n, i, s) => (e.push(s), n)), e.filter((n) => !V6(n));
}
async function XS(t, e, n, i, s) {
  try {
    const r = n ? xS(e, n) : e, o = jt(e);
    let l;
    if (s) {
      const L = await s(r);
      l = UL(L, o);
    } else
      l = await qt(r, o, i);
    return t.replace(YS(e), `$1${l}$3`);
  } catch {
  }
  return t;
}
function JS(t, { preferredFontFormat: e }) {
  return e ? t.replace(KS, (n) => {
    for (; ; ) {
      const [i, , s] = qS.exec(n) || [];
      if (!s)
        return "";
      if (s === e)
        return `src: ${i};`;
    }
  }) : t;
}
function $L(t) {
  return t.search(HL) !== -1;
}
async function VL(t, e, n) {
  if (!$L(t))
    return t;
  const i = JS(t, n);
  return QS(i).reduce((r, o) => r.then((l) => XS(l, o, e, n)), Promise.resolve(i));
}
async function eb(t, e) {
  var n;
  const i = (n = t.style) === null || n === void 0 ? void 0 : n.getPropertyValue("background");
  if (i) {
    const s = await VL(i, null, e);
    t.style.setProperty("background", s, t.style.getPropertyPriority("background"));
  }
}
async function tb(t, e) {
  if (!(t instanceof HTMLImageElement && !V6(t.src)) && !(t instanceof SVGImageElement && !V6(t.href.baseVal)))
    return;
  const n = t instanceof HTMLImageElement ? t.src : t.href.baseVal, i = await qt(n, jt(n), e);
  await new Promise((s, r) => {
    t.onload = s, t.onerror = r;
    const o = t;
    o.decode && (o.decode = s), t instanceof HTMLImageElement ? (t.srcset = "", t.src = i) : t.href.baseVal = i;
  });
}
async function nb(t, e) {
  const i = W4(t.childNodes).map((s) => GL(s, e));
  await Promise.all(i).then(() => t);
}
async function GL(t, e) {
  t instanceof Element && (await eb(t, e), await tb(t, e), await nb(t, e));
}
function ib(t, e) {
  const { style: n } = t;
  e.backgroundColor && (n.backgroundColor = e.backgroundColor), e.width && (n.width = `${e.width}px`), e.height && (n.height = `${e.height}px`);
  const i = e.style;
  return i != null && Object.keys(i).forEach((s) => {
    n[s] = i[s];
  }), t;
}
const ss = {};
async function rs(t) {
  let e = ss[t];
  if (e != null)
    return e;
  const i = await (await fetch(t)).text();
  return e = { url: t, cssText: i }, ss[t] = e, e;
}
async function os(t, e) {
  let n = t.cssText;
  const i = /url\(["']?([^"')]+)["']?\)/g, r = (n.match(/url\([^)]+\)/g) || []).map(async (o) => {
    let l = o.replace(i, "$1");
    return l.startsWith("https://") || (l = new URL(l, t.url).href), WL(l, e.fetchRequestInit, ({ result: L }) => (n = n.replace(o, `url(${L})`), [o, L]));
  });
  return Promise.all(r).then(() => n);
}
function ls(t) {
  if (t == null)
    return [];
  const e = [], n = /(\/\*[\s\S]*?\*\/)/gi;
  let i = t.replace(n, "");
  const s = new RegExp("((@.*?keyframes [\\s\\S]*?){([\\s\\S]*?}\\s*?)})", "gi");
  for (; ; ) {
    const L = s.exec(i);
    if (L === null)
      break;
    e.push(L[0]);
  }
  i = i.replace(s, "");
  const r = /@import[\s\S]*?url\([^)]*\)[\s\S]*?;/gi, o = "((\\s*?(?:\\/\\*[\\s\\S]*?\\*\\/)?\\s*?@media[\\s\\S]*?){([\\s\\S]*?)}\\s*?})|(([\\s\\S]*?){([\\s\\S]*?)})", l = new RegExp(o, "gi");
  for (; ; ) {
    let L = r.exec(i);
    if (L === null) {
      if (L = l.exec(i), L === null)
        break;
      r.lastIndex = l.lastIndex;
    } else
      l.lastIndex = r.lastIndex;
    e.push(L[0]);
  }
  return e;
}
async function sb(t, e) {
  const n = [], i = [];
  return t.forEach((s) => {
    if ("cssRules" in s)
      try {
        W4(s.cssRules || []).forEach((r, o) => {
          if (r.type === CSSRule.IMPORT_RULE) {
            let l = o + 1;
            const L = r.href, a = rs(L).then((C) => os(C, e)).then((C) => ls(C).forEach((c) => {
              try {
                s.insertRule(c, c.startsWith("@import") ? l += 1 : s.cssRules.length);
              } catch (h) {
                console.error("Error inserting rule from remote css", {
                  rule: c,
                  error: h
                });
              }
            })).catch((C) => {
              console.error("Error loading remote css", C.toString());
            });
            i.push(a);
          }
        });
      } catch (r) {
        const o = t.find((l) => l.href == null) || document.styleSheets[0];
        s.href != null && i.push(rs(s.href).then((l) => os(l, e)).then((l) => ls(l).forEach((L) => {
          o.insertRule(L, s.cssRules.length);
        })).catch((l) => {
          console.error("Error loading remote stylesheet", l.toString());
        })), console.error("Error inlining remote css file", r.toString());
      }
  }), Promise.all(i).then(() => (t.forEach((s) => {
    if ("cssRules" in s)
      try {
        W4(s.cssRules || []).forEach((r) => {
          n.push(r);
        });
      } catch (r) {
        console.error(`Error while reading CSS rules from ${s.href}`, r.toString());
      }
  }), n));
}
function rb(t) {
  return t.filter((e) => e.type === CSSRule.FONT_FACE_RULE).filter((e) => $L(e.style.getPropertyValue("src")));
}
async function ob(t, e) {
  if (t.ownerDocument == null)
    throw new Error("Provided element is not within a Document");
  const n = W4(t.ownerDocument.styleSheets), i = await sb(n, e);
  return rb(i);
}
async function lb(t, e) {
  const n = await ob(t, e);
  return (await Promise.all(n.map((s) => {
    const r = s.parentStyleSheet ? s.parentStyleSheet.href : null;
    return VL(s.cssText, r, e);
  }))).join(`
`);
}
async function Lb(t, e) {
  const n = e.fontEmbedCSS != null ? e.fontEmbedCSS : e.skipFonts ? null : await lb(t, e);
  if (n) {
    const i = document.createElement("style"), s = document.createTextNode(n);
    i.appendChild(s), t.firstChild ? t.insertBefore(i, t.firstChild) : t.appendChild(i);
  }
}
async function jL(t, e = {}) {
  const { width: n, height: i } = zL(t, e), s = await f7(t, e, !0);
  return await Lb(s, e), await GL(s, e), ib(s, e), await kS(s, n, i);
}
async function Kt(t, e = {}) {
  const { width: n, height: i } = zL(t, e), s = await jL(t, e), r = await w8(s), o = document.createElement("canvas"), l = o.getContext("2d"), L = e.pixelRatio || RS(), a = e.canvasWidth || n, C = e.canvasHeight || i;
  return o.width = a * L, o.height = C * L, e.skipAutoScale || yS(o), o.style.width = `${a}`, o.style.height = `${C}`, e.backgroundColor && (l.fillStyle = e.backgroundColor, l.fillRect(0, 0, o.width, o.height)), l.drawImage(r, 0, 0, o.width, o.height), o;
}
async function ab(t, e = {}) {
  return (await Kt(t, e)).toDataURL();
}
async function Cb(t, e = {}) {
  return (await Kt(t, e)).toDataURL("image/jpeg", e.quality || 1);
}
async function cb(t, e = {}) {
  const n = await Kt(t, e);
  return await AS(n);
}
const ub = {}.VITE_APP_GIT_HASH, hb = {}.VITE_APP_GIT_BRANCH, db = {
  name: "Debug",
  components: { Icon: q1 },
  data() {
    return {
      commitHash: ub,
      gitBranch: hb
    };
  },
  computed: {
    debug() {
      return !!localStorage.zenumlDebug;
    }
  }
}, gb = { class: "flex flex-nowrap m-2 text-sm" }, fb = { class: "ml-4 text-xs inline-flex items-center font-bold leading-sm px-3 py-1 bg-green-200 text-green-700 rounded-sm" }, pb = { class: "inline-block px-2" };
function mb(t, e, n, i, s, r) {
  const o = i2("Icon");
  return H0((T(), B("div", null, [
    _("div", gb, [
      _("div", fb, [
        N(o, {
          name: "debug",
          "icon-class": "h-4 w-4"
        }),
        _("span", pb, m1(s.gitBranch) + ":" + m1(s.commitHash), 1)
      ])
    ])
  ], 512)), [
    [$9, r.debug]
  ]);
}
const wb = /* @__PURE__ */ K2(db, [["render", mb]]);
function i4(t, e, ...n) {
  if (t in e) {
    let s = e[t];
    return typeof s == "function" ? s(...n) : s;
  }
  let i = new Error(`Tried to handle "${t}" but there is no handler defined. Only defined handlers are: ${Object.keys(e).map((s) => `"${s}"`).join(", ")}.`);
  throw Error.captureStackTrace && Error.captureStackTrace(i, i4), i;
}
var x8 = ((t) => (t[t.None = 0] = "None", t[t.RenderStrategy = 1] = "RenderStrategy", t[t.Static = 2] = "Static", t))(x8 || {}), b4 = ((t) => (t[t.Unmount = 0] = "Unmount", t[t.Hidden = 1] = "Hidden", t))(b4 || {});
function D1({ visible: t = !0, features: e = 0, ourProps: n, theirProps: i, ...s }) {
  var r;
  let o = KL(i, n), l = Object.assign(s, { props: o });
  if (t || e & 2 && o.static)
    return G7(l);
  if (e & 1) {
    let L = (r = o.unmount) == null || r ? 0 : 1;
    return i4(L, { 0() {
      return null;
    }, 1() {
      return G7({ ...s, props: { ...o, hidden: !0, style: { display: "none" } } });
    } });
  }
  return G7(l);
}
function G7({ props: t, attrs: e, slots: n, slot: i, name: s }) {
  var r, o;
  let { as: l, ...L } = Yt(t, ["unmount", "static"]), a = (r = n.default) == null ? void 0 : r.call(n, i), C = {};
  if (i) {
    let c = !1, h = [];
    for (let [d, f] of Object.entries(i))
      typeof f == "boolean" && (c = !0), f === !0 && h.push(d);
    c && (C["data-headlessui-state"] = h.join(" "));
  }
  if (l === "template") {
    if (a = qL(a ?? []), Object.keys(L).length > 0 || Object.keys(e).length > 0) {
      let [c, ...h] = a ?? [];
      if (!_b(c) || h.length > 0)
        throw new Error(['Passing props on "template"!', "", `The current component <${s} /> is rendering a "template".`, "However we need to passthrough the following props:", Object.keys(L).concat(Object.keys(e)).map((x) => x.trim()).filter((x, k, m) => m.indexOf(x) === k).sort((x, k) => x.localeCompare(k)).map((x) => `  - ${x}`).join(`
`), "", "You can apply a few solutions:", ['Add an `as="..."` prop, to ensure that we render an actual element instead of a "template".', "Render a single element as the child so that we can forward the props onto that element."].map((x) => `  - ${x}`).join(`
`)].join(`
`));
      let d = KL((o = c.props) != null ? o : {}, L), f = T3(c, d);
      for (let x in d)
        x.startsWith("on") && (f.props || (f.props = {}), f.props[x] = d[x]);
      return f;
    }
    return Array.isArray(a) && a.length === 1 ? a[0] : a;
  }
  return f1(l, Object.assign({}, L, C), { default: () => a });
}
function qL(t) {
  return t.flatMap((e) => e.type === P2 ? qL(e.children) : [e]);
}
function KL(...t) {
  if (t.length === 0)
    return {};
  if (t.length === 1)
    return t[0];
  let e = {}, n = {};
  for (let i of t)
    for (let s in i)
      s.startsWith("on") && typeof i[s] == "function" ? (n[s] != null || (n[s] = []), n[s].push(i[s])) : e[s] = i[s];
  if (e.disabled || e["aria-disabled"])
    return Object.assign(e, Object.fromEntries(Object.keys(n).map((i) => [i, void 0])));
  for (let i in n)
    Object.assign(e, { [i](s, ...r) {
      let o = n[i];
      for (let l of o) {
        if (s instanceof Event && s.defaultPrevented)
          return;
        l(s, ...r);
      }
    } });
  return e;
}
function xb(t) {
  let e = Object.assign({}, t);
  for (let n in e)
    e[n] === void 0 && delete e[n];
  return e;
}
function Yt(t, e = []) {
  let n = Object.assign({}, t);
  for (let i of e)
    i in n && delete n[i];
  return n;
}
function _b(t) {
  return t == null ? !1 : typeof t.type == "string" || typeof t.type == "object" || typeof t.type == "function";
}
let vb = 0;
function Mb() {
  return ++vb;
}
function L4() {
  return Mb();
}
var k4 = ((t) => (t.Space = " ", t.Enter = "Enter", t.Escape = "Escape", t.Backspace = "Backspace", t.Delete = "Delete", t.ArrowLeft = "ArrowLeft", t.ArrowUp = "ArrowUp", t.ArrowRight = "ArrowRight", t.ArrowDown = "ArrowDown", t.Home = "Home", t.End = "End", t.PageUp = "PageUp", t.PageDown = "PageDown", t.Tab = "Tab", t))(k4 || {});
function a1(t) {
  var e;
  return t == null || t.value == null ? null : (e = t.value.$el) != null ? e : t.value;
}
let YL = Symbol("Context");
var f3 = ((t) => (t[t.Open = 1] = "Open", t[t.Closed = 2] = "Closed", t[t.Closing = 4] = "Closing", t[t.Opening = 8] = "Opening", t))(f3 || {});
function Rb() {
  return Qt() !== null;
}
function Qt() {
  return u1(YL, null);
}
function yb(t) {
  a3(YL, t);
}
var Ab = Object.defineProperty, Zb = (t, e, n) => e in t ? Ab(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n, Ls = (t, e, n) => (Zb(t, typeof e != "symbol" ? e + "" : e, n), n);
class kb {
  constructor() {
    Ls(this, "current", this.detect()), Ls(this, "currentId", 0);
  }
  set(e) {
    this.current !== e && (this.currentId = 0, this.current = e);
  }
  reset() {
    this.set(this.detect());
  }
  nextId() {
    return ++this.currentId;
  }
  get isServer() {
    return this.current === "server";
  }
  get isClient() {
    return this.current === "client";
  }
  detect() {
    return typeof window > "u" || typeof document > "u" ? "server" : "client";
  }
}
let d5 = new kb();
function Y3(t) {
  if (d5.isServer)
    return null;
  if (t instanceof Node)
    return t.ownerDocument;
  if (t != null && t.hasOwnProperty("value")) {
    let e = a1(t);
    if (e)
      return e.ownerDocument;
  }
  return document;
}
function Tb({ container: t, accept: e, walk: n, enabled: i }) {
  x3(() => {
    let s = t.value;
    if (!s || i !== void 0 && !i.value)
      return;
    let r = Y3(t);
    if (!r)
      return;
    let o = Object.assign((L) => e(L), { acceptNode: e }), l = r.createTreeWalker(s, NodeFilter.SHOW_ELEMENT, o, !1);
    for (; l.nextNode(); )
      n(l.currentNode);
  });
}
let G6 = ["[contentEditable=true]", "[tabindex]", "a[href]", "area[href]", "button:not([disabled])", "iframe", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])"].map((t) => `${t}:not([tabindex='-1'])`).join(",");
var k3 = ((t) => (t[t.First = 1] = "First", t[t.Previous = 2] = "Previous", t[t.Next = 4] = "Next", t[t.Last = 8] = "Last", t[t.WrapAround = 16] = "WrapAround", t[t.NoScroll = 32] = "NoScroll", t))(k3 || {}), _8 = ((t) => (t[t.Error = 0] = "Error", t[t.Overflow = 1] = "Overflow", t[t.Success = 2] = "Success", t[t.Underflow = 3] = "Underflow", t))(_8 || {}), Sb = ((t) => (t[t.Previous = -1] = "Previous", t[t.Next = 1] = "Next", t))(Sb || {});
function bb(t = document.body) {
  return t == null ? [] : Array.from(t.querySelectorAll(G6)).sort((e, n) => Math.sign((e.tabIndex || Number.MAX_SAFE_INTEGER) - (n.tabIndex || Number.MAX_SAFE_INTEGER)));
}
var QL = ((t) => (t[t.Strict = 0] = "Strict", t[t.Loose = 1] = "Loose", t))(QL || {});
function Eb(t, e = 0) {
  var n;
  return t === ((n = Y3(t)) == null ? void 0 : n.body) ? !1 : i4(e, { 0() {
    return t.matches(G6);
  }, 1() {
    let i = t;
    for (; i !== null; ) {
      if (i.matches(G6))
        return !0;
      i = i.parentElement;
    }
    return !1;
  } });
}
var Ib = ((t) => (t[t.Keyboard = 0] = "Keyboard", t[t.Mouse = 1] = "Mouse", t))(Ib || {});
typeof window < "u" && typeof document < "u" && (document.addEventListener("keydown", (t) => {
  t.metaKey || t.altKey || t.ctrlKey || (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0), document.addEventListener("click", (t) => {
  t.detail === 1 ? delete document.documentElement.dataset.headlessuiFocusVisible : t.detail === 0 && (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0));
function l9(t) {
  t == null || t.focus({ preventScroll: !0 });
}
let Fb = ["textarea", "input"].join(",");
function Ob(t) {
  var e, n;
  return (n = (e = t == null ? void 0 : t.matches) == null ? void 0 : e.call(t, Fb)) != null ? n : !1;
}
function XL(t, e = (n) => n) {
  return t.slice().sort((n, i) => {
    let s = e(n), r = e(i);
    if (s === null || r === null)
      return 0;
    let o = s.compareDocumentPosition(r);
    return o & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : o & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
  });
}
function P9(t, e, { sorted: n = !0, relativeTo: i = null, skipElements: s = [] } = {}) {
  var r;
  let o = (r = Array.isArray(t) ? t.length > 0 ? t[0].ownerDocument : document : t == null ? void 0 : t.ownerDocument) != null ? r : document, l = Array.isArray(t) ? n ? XL(t) : t : bb(t);
  s.length > 0 && l.length > 1 && (l = l.filter((f) => !s.includes(f))), i = i ?? o.activeElement;
  let L = (() => {
    if (e & 5)
      return 1;
    if (e & 10)
      return -1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), a = (() => {
    if (e & 1)
      return 0;
    if (e & 2)
      return Math.max(0, l.indexOf(i)) - 1;
    if (e & 4)
      return Math.max(0, l.indexOf(i)) + 1;
    if (e & 8)
      return l.length - 1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), C = e & 32 ? { preventScroll: !0 } : {}, c = 0, h = l.length, d;
  do {
    if (c >= h || c + h <= 0)
      return 0;
    let f = a + c;
    if (e & 16)
      f = (f + h) % h;
    else {
      if (f < 0)
        return 3;
      if (f >= h)
        return 1;
    }
    d = l[f], d == null || d.focus(C), c += L;
  } while (d !== o.activeElement);
  return e & 6 && Ob(d) && d.select(), 2;
}
function B5(t, e, n) {
  d5.isServer || x3((i) => {
    document.addEventListener(t, e, n), i(() => document.removeEventListener(t, e, n));
  });
}
function JL(t, e, n) {
  d5.isServer || x3((i) => {
    window.addEventListener(t, e, n), i(() => window.removeEventListener(t, e, n));
  });
}
function Nb(t, e, n = I(() => !0)) {
  function i(r, o) {
    if (!n.value || r.defaultPrevented)
      return;
    let l = o(r);
    if (l === null || !l.getRootNode().contains(l))
      return;
    let L = function a(C) {
      return typeof C == "function" ? a(C()) : Array.isArray(C) || C instanceof Set ? C : [C];
    }(t);
    for (let a of L) {
      if (a === null)
        continue;
      let C = a instanceof HTMLElement ? a : a1(a);
      if (C != null && C.contains(l) || r.composed && r.composedPath().includes(C))
        return;
    }
    return !Eb(l, QL.Loose) && l.tabIndex !== -1 && r.preventDefault(), e(r, l);
  }
  let s = R2(null);
  B5("pointerdown", (r) => {
    var o, l;
    n.value && (s.value = ((l = (o = r.composedPath) == null ? void 0 : o.call(r)) == null ? void 0 : l[0]) || r.target);
  }, !0), B5("mousedown", (r) => {
    var o, l;
    n.value && (s.value = ((l = (o = r.composedPath) == null ? void 0 : o.call(r)) == null ? void 0 : l[0]) || r.target);
  }, !0), B5("click", (r) => {
    s.value && (i(r, () => s.value), s.value = null);
  }, !0), B5("touchend", (r) => i(r, () => r.target instanceof HTMLElement ? r.target : null), !0), JL("blur", (r) => i(r, () => window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null), !0);
}
var G0 = ((t) => (t[t.None = 1] = "None", t[t.Focusable = 2] = "Focusable", t[t.Hidden = 4] = "Hidden", t))(G0 || {});
let v8 = q2({ name: "Hidden", props: { as: { type: [Object, String], default: "div" }, features: { type: Number, default: 1 } }, setup(t, { slots: e, attrs: n }) {
  return () => {
    let { features: i, ...s } = t, r = { "aria-hidden": (i & 2) === 2 ? !0 : void 0, style: { position: "fixed", top: 1, left: 1, width: 1, height: 0, padding: 0, margin: -1, overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0", ...(i & 4) === 4 && (i & 2) !== 2 && { display: "none" } } };
    return D1({ ourProps: r, theirProps: s, slot: {}, attrs: n, slots: e, name: "Hidden" });
  };
} });
function ea(t = {}, e = null, n = []) {
  for (let [i, s] of Object.entries(t))
    na(n, ta(e, i), s);
  return n;
}
function ta(t, e) {
  return t ? t + "[" + e + "]" : e;
}
function na(t, e, n) {
  if (Array.isArray(n))
    for (let [i, s] of n.entries())
      na(t, ta(e, i.toString()), s);
  else
    n instanceof Date ? t.push([e, n.toISOString()]) : typeof n == "boolean" ? t.push([e, n ? "1" : "0"]) : typeof n == "string" ? t.push([e, n]) : typeof n == "number" ? t.push([e, `${n}`]) : n == null ? t.push([e, ""]) : ea(n, e, t);
}
function Db(t) {
  var e, n;
  let i = (e = t == null ? void 0 : t.form) != null ? e : t.closest("form");
  if (i) {
    for (let s of i.elements)
      if (s !== t && (s.tagName === "INPUT" && s.type === "submit" || s.tagName === "BUTTON" && s.type === "submit" || s.nodeName === "INPUT" && s.type === "image")) {
        s.click();
        return;
      }
    (n = i.requestSubmit) == null || n.call(i);
  }
}
function Pb(t, e, n) {
  let i = R2(n == null ? void 0 : n.value), s = I(() => t.value !== void 0);
  return [I(() => s.value ? t.value : i.value), function(r) {
    return s.value || (i.value = r), e == null ? void 0 : e(r);
  }];
}
function Bb() {
  return /iPhone/gi.test(window.navigator.platform) || /Mac/gi.test(window.navigator.platform) && window.navigator.maxTouchPoints > 0;
}
function Xt(t) {
  typeof queueMicrotask == "function" ? queueMicrotask(t) : Promise.resolve().then(t).catch((e) => setTimeout(() => {
    throw e;
  }));
}
function g5() {
  let t = [], e = { addEventListener(n, i, s, r) {
    return n.addEventListener(i, s, r), e.add(() => n.removeEventListener(i, s, r));
  }, requestAnimationFrame(...n) {
    let i = requestAnimationFrame(...n);
    e.add(() => cancelAnimationFrame(i));
  }, nextFrame(...n) {
    e.requestAnimationFrame(() => {
      e.requestAnimationFrame(...n);
    });
  }, setTimeout(...n) {
    let i = setTimeout(...n);
    e.add(() => clearTimeout(i));
  }, microTask(...n) {
    let i = { current: !0 };
    return Xt(() => {
      i.current && n[0]();
    }), e.add(() => {
      i.current = !1;
    });
  }, style(n, i, s) {
    let r = n.style.getPropertyValue(i);
    return Object.assign(n.style, { [i]: s }), this.add(() => {
      Object.assign(n.style, { [i]: r });
    });
  }, group(n) {
    let i = g5();
    return n(i), this.add(() => i.dispose());
  }, add(n) {
    return t.push(n), () => {
      let i = t.indexOf(n);
      if (i >= 0)
        for (let s of t.splice(i, 1))
          s();
    };
  }, dispose() {
    for (let n of t.splice(0))
      n();
  } };
  return e;
}
var _0 = ((t) => (t[t.Forwards = 0] = "Forwards", t[t.Backwards = 1] = "Backwards", t))(_0 || {});
function zb() {
  let t = R2(0);
  return JL("keydown", (e) => {
    e.key === "Tab" && (t.value = e.shiftKey ? 1 : 0);
  }), t;
}
function ia(t, e, n, i) {
  d5.isServer || x3((s) => {
    t = t ?? window, t.addEventListener(e, n, i), s(() => t.removeEventListener(e, n, i));
  });
}
function Ub(t) {
  function e() {
    document.readyState !== "loading" && (t(), document.removeEventListener("DOMContentLoaded", e));
  }
  typeof window < "u" && typeof document < "u" && (document.addEventListener("DOMContentLoaded", e), e());
}
function sa(t) {
  if (!t)
    return /* @__PURE__ */ new Set();
  if (typeof t == "function")
    return new Set(t());
  let e = /* @__PURE__ */ new Set();
  for (let n of t.value) {
    let i = a1(n);
    i instanceof HTMLElement && e.add(i);
  }
  return e;
}
var ra = ((t) => (t[t.None = 1] = "None", t[t.InitialFocus = 2] = "InitialFocus", t[t.TabLock = 4] = "TabLock", t[t.FocusLock = 8] = "FocusLock", t[t.RestoreFocus = 16] = "RestoreFocus", t[t.All = 30] = "All", t))(ra || {});
let u0 = Object.assign(q2({ name: "FocusTrap", props: { as: { type: [Object, String], default: "div" }, initialFocus: { type: Object, default: null }, features: { type: Number, default: 30 }, containers: { type: [Object, Function], default: R2(/* @__PURE__ */ new Set()) } }, inheritAttrs: !1, setup(t, { attrs: e, slots: n, expose: i }) {
  let s = R2(null);
  i({ el: s, $el: s });
  let r = I(() => Y3(s)), o = R2(!1);
  s1(() => o.value = !0), x1(() => o.value = !1), Hb({ ownerDocument: r }, I(() => o.value && !!(t.features & 16)));
  let l = $b({ ownerDocument: r, container: s, initialFocus: I(() => t.initialFocus) }, I(() => o.value && !!(t.features & 2)));
  Vb({ ownerDocument: r, container: s, containers: t.containers, previousActiveElement: l }, I(() => o.value && !!(t.features & 8)));
  let L = zb();
  function a(d) {
    let f = a1(s);
    f && ((x) => x())(() => {
      i4(L.value, { [_0.Forwards]: () => {
        P9(f, k3.First, { skipElements: [d.relatedTarget] });
      }, [_0.Backwards]: () => {
        P9(f, k3.Last, { skipElements: [d.relatedTarget] });
      } });
    });
  }
  let C = R2(!1);
  function c(d) {
    d.key === "Tab" && (C.value = !0, requestAnimationFrame(() => {
      C.value = !1;
    }));
  }
  function h(d) {
    if (!o.value)
      return;
    let f = sa(t.containers);
    a1(s) instanceof HTMLElement && f.add(a1(s));
    let x = d.relatedTarget;
    x instanceof HTMLElement && x.dataset.headlessuiFocusGuard !== "true" && (oa(f, x) || (C.value ? P9(a1(s), i4(L.value, { [_0.Forwards]: () => k3.Next, [_0.Backwards]: () => k3.Previous }) | k3.WrapAround, { relativeTo: d.target }) : d.target instanceof HTMLElement && l9(d.target)));
  }
  return () => {
    let d = {}, f = { ref: s, onKeydown: c, onFocusout: h }, { features: x, initialFocus: k, containers: m, ...g } = t;
    return f1(P2, [!!(x & 4) && f1(v8, { as: "button", type: "button", "data-headlessui-focus-guard": !0, onFocus: a, features: G0.Focusable }), D1({ ourProps: f, theirProps: { ...e, ...g }, slot: d, attrs: e, slots: n, name: "FocusTrap" }), !!(x & 4) && f1(v8, { as: "button", type: "button", "data-headlessui-focus-guard": !0, onFocus: a, features: G0.Focusable })]);
  };
} }), { features: ra }), e9 = [];
Ub(() => {
  function t(e) {
    e.target instanceof HTMLElement && e.target !== document.body && e9[0] !== e.target && (e9.unshift(e.target), e9 = e9.filter((n) => n != null && n.isConnected), e9.splice(10));
  }
  window.addEventListener("click", t, { capture: !0 }), window.addEventListener("mousedown", t, { capture: !0 }), window.addEventListener("focus", t, { capture: !0 }), document.body.addEventListener("click", t, { capture: !0 }), document.body.addEventListener("mousedown", t, { capture: !0 }), document.body.addEventListener("focus", t, { capture: !0 });
});
function Wb(t) {
  let e = R2(e9.slice());
  return m3([t], ([n], [i]) => {
    i === !0 && n === !1 ? Xt(() => {
      e.value.splice(0);
    }) : i === !1 && n === !0 && (e.value = e9.slice());
  }, { flush: "post" }), () => {
    var n;
    return (n = e.value.find((i) => i != null && i.isConnected)) != null ? n : null;
  };
}
function Hb({ ownerDocument: t }, e) {
  let n = Wb(e);
  s1(() => {
    x3(() => {
      var i, s;
      e.value || ((i = t.value) == null ? void 0 : i.activeElement) === ((s = t.value) == null ? void 0 : s.body) && l9(n());
    }, { flush: "post" });
  }), x1(() => {
    e.value && l9(n());
  });
}
function $b({ ownerDocument: t, container: e, initialFocus: n }, i) {
  let s = R2(null), r = R2(!1);
  return s1(() => r.value = !0), x1(() => r.value = !1), s1(() => {
    m3([e, n, i], (o, l) => {
      if (o.every((a, C) => (l == null ? void 0 : l[C]) === a) || !i.value)
        return;
      let L = a1(e);
      L && Xt(() => {
        var a, C;
        if (!r.value)
          return;
        let c = a1(n), h = (a = t.value) == null ? void 0 : a.activeElement;
        if (c) {
          if (c === h) {
            s.value = h;
            return;
          }
        } else if (L.contains(h)) {
          s.value = h;
          return;
        }
        c ? l9(c) : P9(L, k3.First | k3.NoScroll) === _8.Error && console.warn("There are no focusable elements inside the <FocusTrap />"), s.value = (C = t.value) == null ? void 0 : C.activeElement;
      });
    }, { immediate: !0, flush: "post" });
  }), s;
}
function Vb({ ownerDocument: t, container: e, containers: n, previousActiveElement: i }, s) {
  var r;
  ia((r = t.value) == null ? void 0 : r.defaultView, "focus", (o) => {
    if (!s.value)
      return;
    let l = sa(n);
    a1(e) instanceof HTMLElement && l.add(a1(e));
    let L = i.value;
    if (!L)
      return;
    let a = o.target;
    a && a instanceof HTMLElement ? oa(l, a) ? (i.value = a, l9(a)) : (o.preventDefault(), o.stopPropagation(), l9(L)) : l9(i.value);
  }, !0);
}
function oa(t, e) {
  for (let n of t)
    if (n.contains(e))
      return !0;
  return !1;
}
let j7 = /* @__PURE__ */ new Map(), h0 = /* @__PURE__ */ new Map();
function as(t, e = R2(!0)) {
  x3((n) => {
    var i;
    if (!e.value)
      return;
    let s = a1(t);
    if (!s)
      return;
    n(function() {
      var o;
      if (!s)
        return;
      let l = (o = h0.get(s)) != null ? o : 1;
      if (l === 1 ? h0.delete(s) : h0.set(s, l - 1), l !== 1)
        return;
      let L = j7.get(s);
      L && (L["aria-hidden"] === null ? s.removeAttribute("aria-hidden") : s.setAttribute("aria-hidden", L["aria-hidden"]), s.inert = L.inert, j7.delete(s));
    });
    let r = (i = h0.get(s)) != null ? i : 0;
    h0.set(s, r + 1), r === 0 && (j7.set(s, { "aria-hidden": s.getAttribute("aria-hidden"), inert: s.inert }), s.setAttribute("aria-hidden", "true"), s.inert = !0);
  });
}
let la = Symbol("ForcePortalRootContext");
function Gb() {
  return u1(la, !1);
}
let j6 = q2({ name: "ForcePortalRoot", props: { as: { type: [Object, String], default: "template" }, force: { type: Boolean, default: !1 } }, setup(t, { slots: e, attrs: n }) {
  return a3(la, t.force), () => {
    let { force: i, ...s } = t;
    return D1({ theirProps: s, ourProps: {}, slot: {}, slots: e, attrs: n, name: "ForcePortalRoot" });
  };
} });
function jb(t) {
  let e = Y3(t);
  if (!e) {
    if (t === null)
      return null;
    throw new Error(`[Headless UI]: Cannot find ownerDocument for contextElement: ${t}`);
  }
  let n = e.getElementById("headlessui-portal-root");
  if (n)
    return n;
  let i = e.createElement("div");
  return i.setAttribute("id", "headlessui-portal-root"), e.body.appendChild(i);
}
let La = q2({ name: "Portal", props: { as: { type: [Object, String], default: "div" } }, setup(t, { slots: e, attrs: n }) {
  let i = R2(null), s = I(() => Y3(i)), r = Gb(), o = u1(aa, null), l = R2(r === !0 || o == null ? jb(i.value) : o.resolveTarget());
  x3(() => {
    r || o != null && (l.value = o.resolveTarget());
  });
  let L = u1(q6, null);
  return s1(() => {
    let a = a1(i);
    a && L && x1(L.register(a));
  }), x1(() => {
    var a, C;
    let c = (a = s.value) == null ? void 0 : a.getElementById("headlessui-portal-root");
    c && l.value === c && l.value.children.length <= 0 && ((C = l.value.parentElement) == null || C.removeChild(l.value));
  }), () => {
    if (l.value === null)
      return null;
    let a = { ref: i, "data-headlessui-portal": "" };
    return f1(oo, { to: l.value }, D1({ ourProps: a, theirProps: t, slot: {}, attrs: n, slots: e, name: "Portal" }));
  };
} }), q6 = Symbol("PortalParentContext");
function qb() {
  let t = u1(q6, null), e = R2([]);
  function n(r) {
    return e.value.push(r), t && t.register(r), () => i(r);
  }
  function i(r) {
    let o = e.value.indexOf(r);
    o !== -1 && e.value.splice(o, 1), t && t.unregister(r);
  }
  let s = { register: n, unregister: i, portals: e };
  return [e, q2({ name: "PortalWrapper", setup(r, { slots: o }) {
    return a3(q6, s), () => {
      var l;
      return (l = o.default) == null ? void 0 : l.call(o);
    };
  } })];
}
let aa = Symbol("PortalGroupContext"), Kb = q2({ name: "PortalGroup", props: { as: { type: [Object, String], default: "template" }, target: { type: Object, default: null } }, setup(t, { attrs: e, slots: n }) {
  let i = J3({ resolveTarget() {
    return t.target;
  } });
  return a3(aa, i), () => {
    let { target: s, ...r } = t;
    return D1({ theirProps: r, ourProps: {}, slot: {}, attrs: e, slots: n, name: "PortalGroup" });
  };
} }), Ca = Symbol("StackContext");
var K6 = ((t) => (t[t.Add = 0] = "Add", t[t.Remove = 1] = "Remove", t))(K6 || {});
function Yb() {
  return u1(Ca, () => {
  });
}
function Qb({ type: t, enabled: e, element: n, onUpdate: i }) {
  let s = Yb();
  function r(...o) {
    i == null || i(...o), s(...o);
  }
  s1(() => {
    m3(e, (o, l) => {
      o ? r(0, t, n) : l === !0 && r(1, t, n);
    }, { immediate: !0, flush: "sync" });
  }), x1(() => {
    e.value && r(1, t, n);
  }), a3(Ca, r);
}
let ca = Symbol("DescriptionContext");
function Xb() {
  let t = u1(ca, null);
  if (t === null)
    throw new Error("Missing parent");
  return t;
}
function Jt({ slot: t = R2({}), name: e = "Description", props: n = {} } = {}) {
  let i = R2([]);
  function s(r) {
    return i.value.push(r), () => {
      let o = i.value.indexOf(r);
      o !== -1 && i.value.splice(o, 1);
    };
  }
  return a3(ca, { register: s, slot: t, name: e, props: n }), I(() => i.value.length > 0 ? i.value.join(" ") : void 0);
}
q2({ name: "Description", props: { as: { type: [Object, String], default: "p" }, id: { type: String, default: () => `headlessui-description-${L4()}` } }, setup(t, { attrs: e, slots: n }) {
  let i = Xb();
  return s1(() => x1(i.register(t.id))), () => {
    let { name: s = "Description", slot: r = R2({}), props: o = {} } = i, { id: l, ...L } = t, a = { ...Object.entries(o).reduce((C, [c, h]) => Object.assign(C, { [c]: O(h) }), {}), id: l };
    return D1({ ourProps: a, theirProps: L, slot: r.value, attrs: e, slots: n, name: s });
  };
} });
function Jb(t) {
  let e = Lr(t.getSnapshot());
  return x1(t.subscribe(() => {
    e.value = t.getSnapshot();
  })), e;
}
function eE(t, e) {
  let n = t(), i = /* @__PURE__ */ new Set();
  return { getSnapshot() {
    return n;
  }, subscribe(s) {
    return i.add(s), () => i.delete(s);
  }, dispatch(s, ...r) {
    let o = e[s].call(n, ...r);
    o && (n = o, i.forEach((l) => l()));
  } };
}
function tE() {
  let t;
  return { before({ doc: e }) {
    var n;
    let i = e.documentElement;
    t = ((n = e.defaultView) != null ? n : window).innerWidth - i.clientWidth;
  }, after({ doc: e, d: n }) {
    let i = e.documentElement, s = i.clientWidth - i.offsetWidth, r = t - s;
    n.style(i, "paddingRight", `${r}px`);
  } };
}
function nE() {
  if (!Bb())
    return {};
  let t;
  return { before() {
    t = window.pageYOffset;
  }, after({ doc: e, d: n, meta: i }) {
    function s(o) {
      return i.containers.flatMap((l) => l()).some((l) => l.contains(o));
    }
    if (window.getComputedStyle(e.documentElement).scrollBehavior !== "auto") {
      let o = g5();
      o.style(e.documentElement, "scroll-behavior", "auto"), n.add(() => n.microTask(() => o.dispose()));
    }
    n.style(e.body, "marginTop", `-${t}px`), window.scrollTo(0, 0);
    let r = null;
    n.addEventListener(e, "click", (o) => {
      if (o.target instanceof HTMLElement)
        try {
          let l = o.target.closest("a");
          if (!l)
            return;
          let { hash: L } = new URL(l.href), a = e.querySelector(L);
          a && !s(a) && (r = a);
        } catch {
        }
    }, !0), n.addEventListener(e, "touchmove", (o) => {
      o.target instanceof HTMLElement && !s(o.target) && o.preventDefault();
    }, { passive: !1 }), n.add(() => {
      window.scrollTo(0, window.pageYOffset + t), r && r.isConnected && (r.scrollIntoView({ block: "nearest" }), r = null);
    });
  } };
}
function iE() {
  return { before({ doc: t, d: e }) {
    e.style(t.documentElement, "overflow", "hidden");
  } };
}
function sE(t) {
  let e = {};
  for (let n of t)
    Object.assign(e, n(e));
  return e;
}
let t9 = eE(() => /* @__PURE__ */ new Map(), { PUSH(t, e) {
  var n;
  let i = (n = this.get(t)) != null ? n : { doc: t, count: 0, d: g5(), meta: /* @__PURE__ */ new Set() };
  return i.count++, i.meta.add(e), this.set(t, i), this;
}, POP(t, e) {
  let n = this.get(t);
  return n && (n.count--, n.meta.delete(e)), this;
}, SCROLL_PREVENT({ doc: t, d: e, meta: n }) {
  let i = { doc: t, d: e, meta: sE(n) }, s = [nE(), tE(), iE()];
  s.forEach(({ before: r }) => r == null ? void 0 : r(i)), s.forEach(({ after: r }) => r == null ? void 0 : r(i));
}, SCROLL_ALLOW({ d: t }) {
  t.dispose();
}, TEARDOWN({ doc: t }) {
  this.delete(t);
} });
t9.subscribe(() => {
  let t = t9.getSnapshot(), e = /* @__PURE__ */ new Map();
  for (let [n] of t)
    e.set(n, n.documentElement.style.overflow);
  for (let n of t.values()) {
    let i = e.get(n.doc) === "hidden", s = n.count !== 0;
    (s && !i || !s && i) && t9.dispatch(n.count > 0 ? "SCROLL_PREVENT" : "SCROLL_ALLOW", n), n.count === 0 && t9.dispatch("TEARDOWN", n);
  }
});
function rE(t, e, n) {
  let i = Jb(t9), s = I(() => {
    let r = t.value ? i.value.get(t.value) : void 0;
    return r ? r.count > 0 : !1;
  });
  return m3([t, e], ([r, o], [l], L) => {
    if (!r || !o)
      return;
    t9.dispatch("PUSH", r, n);
    let a = !1;
    L(() => {
      a || (t9.dispatch("POP", l ?? r, n), a = !0);
    });
  }, { immediate: !0 }), s;
}
function oE({ defaultContainers: t = [], portals: e, mainTreeNodeRef: n } = {}) {
  let i = R2(null), s = Y3(i);
  function r() {
    var o;
    let l = [];
    for (let L of t)
      L !== null && (L instanceof HTMLElement ? l.push(L) : "value" in L && L.value instanceof HTMLElement && l.push(L.value));
    if (e != null && e.value)
      for (let L of e.value)
        l.push(L);
    for (let L of (o = s == null ? void 0 : s.querySelectorAll("html > *, body > *")) != null ? o : [])
      L !== document.body && L !== document.head && L instanceof HTMLElement && L.id !== "headlessui-portal-root" && (L.contains(a1(i)) || l.some((a) => L.contains(a)) || l.push(L));
    return l;
  }
  return { resolveContainers: r, contains(o) {
    return r().some((l) => l.contains(o));
  }, mainTreeNodeRef: i, MainTreeNode() {
    return n != null ? null : f1(v8, { features: G0.Hidden, ref: i });
  } };
}
var lE = ((t) => (t[t.Open = 0] = "Open", t[t.Closed = 1] = "Closed", t))(lE || {});
let Y6 = Symbol("DialogContext");
function f5(t) {
  let e = u1(Y6, null);
  if (e === null) {
    let n = new Error(`<${t} /> is missing a parent <Dialog /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, f5), n;
  }
  return e;
}
let z5 = "DC8F892D-2EBD-447C-A4C8-A03058436FF4", LE = q2({ name: "Dialog", inheritAttrs: !1, props: { as: { type: [Object, String], default: "div" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, open: { type: [Boolean, String], default: z5 }, initialFocus: { type: Object, default: null }, id: { type: String, default: () => `headlessui-dialog-${L4()}` } }, emits: { close: (t) => !0 }, setup(t, { emit: e, attrs: n, slots: i, expose: s }) {
  var r;
  let o = R2(!1);
  s1(() => {
    o.value = !0;
  });
  let l = R2(0), L = Qt(), a = I(() => t.open === z5 && L !== null ? (L.value & f3.Open) === f3.Open : t.open), C = R2(null), c = I(() => Y3(C));
  if (s({ el: C, $el: C }), !(t.open !== z5 || L !== null))
    throw new Error("You forgot to provide an `open` prop to the `Dialog`.");
  if (typeof a.value != "boolean")
    throw new Error(`You provided an \`open\` prop to the \`Dialog\`, but the value is not a boolean. Received: ${a.value === z5 ? void 0 : t.open}`);
  let h = I(() => o.value && a.value ? 0 : 1), d = I(() => h.value === 0), f = I(() => l.value > 1), x = u1(Y6, null) !== null, [k, m] = qb(), { resolveContainers: g, mainTreeNodeRef: w, MainTreeNode: Z } = oE({ portals: k, defaultContainers: [I(() => {
    var s2;
    return (s2 = m2.panelRef.value) != null ? s2 : C.value;
  })] }), b = I(() => f.value ? "parent" : "leaf"), z = I(() => L !== null ? (L.value & f3.Closing) === f3.Closing : !1), K = I(() => x || z.value ? !1 : d.value), E = I(() => {
    var s2, g2, J2;
    return (J2 = Array.from((g2 = (s2 = c.value) == null ? void 0 : s2.querySelectorAll("body > *")) != null ? g2 : []).find((S2) => S2.id === "headlessui-portal-root" ? !1 : S2.contains(a1(w)) && S2 instanceof HTMLElement)) != null ? J2 : null;
  });
  as(E, K);
  let L2 = I(() => f.value ? !0 : d.value), t2 = I(() => {
    var s2, g2, J2;
    return (J2 = Array.from((g2 = (s2 = c.value) == null ? void 0 : s2.querySelectorAll("[data-headlessui-portal]")) != null ? g2 : []).find((S2) => S2.contains(a1(w)) && S2 instanceof HTMLElement)) != null ? J2 : null;
  });
  as(t2, L2), Qb({ type: "Dialog", enabled: I(() => h.value === 0), element: C, onUpdate: (s2, g2) => {
    if (g2 === "Dialog")
      return i4(s2, { [K6.Add]: () => l.value += 1, [K6.Remove]: () => l.value -= 1 });
  } });
  let u2 = Jt({ name: "DialogDescription", slot: I(() => ({ open: a.value })) }), N2 = R2(null), m2 = { titleId: N2, panelRef: R2(null), dialogState: h, setTitleId(s2) {
    N2.value !== s2 && (N2.value = s2);
  }, close() {
    e("close", !1);
  } };
  a3(Y6, m2);
  let P = I(() => !(!d.value || f.value));
  Nb(g, (s2, g2) => {
    m2.close(), P4(() => g2 == null ? void 0 : g2.focus());
  }, P);
  let W2 = I(() => !(f.value || h.value !== 0));
  ia((r = c.value) == null ? void 0 : r.defaultView, "keydown", (s2) => {
    W2.value && (s2.defaultPrevented || s2.key === k4.Escape && (s2.preventDefault(), s2.stopPropagation(), m2.close()));
  });
  let $ = I(() => !(z.value || h.value !== 0 || x));
  return rE(c, $, (s2) => {
    var g2;
    return { containers: [...(g2 = s2.containers) != null ? g2 : [], g] };
  }), x3((s2) => {
    if (h.value !== 0)
      return;
    let g2 = a1(C);
    if (!g2)
      return;
    let J2 = new ResizeObserver((S2) => {
      for (let y1 of S2) {
        let E2 = y1.target.getBoundingClientRect();
        E2.x === 0 && E2.y === 0 && E2.width === 0 && E2.height === 0 && m2.close();
      }
    });
    J2.observe(g2), s2(() => J2.disconnect());
  }), () => {
    let { id: s2, open: g2, initialFocus: J2, ...S2 } = t, y1 = { ...n, ref: C, id: s2, role: "dialog", "aria-modal": h.value === 0 ? !0 : void 0, "aria-labelledby": N2.value, "aria-describedby": u2.value }, E2 = { open: h.value === 0 };
    return f1(j6, { force: !0 }, () => [f1(La, () => f1(Kb, { target: C.value }, () => f1(j6, { force: !1 }, () => f1(u0, { initialFocus: J2, containers: g, features: d.value ? i4(b.value, { parent: u0.features.RestoreFocus, leaf: u0.features.All & ~u0.features.FocusLock }) : u0.features.None }, () => f1(m, {}, () => D1({ ourProps: y1, theirProps: { ...S2, ...n }, slot: E2, attrs: n, slots: i, visible: h.value === 0, features: x8.RenderStrategy | x8.Static, name: "Dialog" })))))), f1(Z)]);
  };
} });
q2({ name: "DialogOverlay", props: { as: { type: [Object, String], default: "div" }, id: { type: String, default: () => `headlessui-dialog-overlay-${L4()}` } }, setup(t, { attrs: e, slots: n }) {
  let i = f5("DialogOverlay");
  function s(r) {
    r.target === r.currentTarget && (r.preventDefault(), r.stopPropagation(), i.close());
  }
  return () => {
    let { id: r, ...o } = t;
    return D1({ ourProps: { id: r, "aria-hidden": !0, onClick: s }, theirProps: o, slot: { open: i.dialogState.value === 0 }, attrs: e, slots: n, name: "DialogOverlay" });
  };
} });
q2({ name: "DialogBackdrop", props: { as: { type: [Object, String], default: "div" }, id: { type: String, default: () => `headlessui-dialog-backdrop-${L4()}` } }, inheritAttrs: !1, setup(t, { attrs: e, slots: n, expose: i }) {
  let s = f5("DialogBackdrop"), r = R2(null);
  return i({ el: r, $el: r }), s1(() => {
    if (s.panelRef.value === null)
      throw new Error("A <DialogBackdrop /> component is being used, but a <DialogPanel /> component is missing.");
  }), () => {
    let { id: o, ...l } = t, L = { id: o, ref: r, "aria-hidden": !0 };
    return f1(j6, { force: !0 }, () => f1(La, () => D1({ ourProps: L, theirProps: { ...e, ...l }, slot: { open: s.dialogState.value === 0 }, attrs: e, slots: n, name: "DialogBackdrop" })));
  };
} });
let aE = q2({ name: "DialogPanel", props: { as: { type: [Object, String], default: "div" }, id: { type: String, default: () => `headlessui-dialog-panel-${L4()}` } }, setup(t, { attrs: e, slots: n, expose: i }) {
  let s = f5("DialogPanel");
  i({ el: s.panelRef, $el: s.panelRef });
  function r(o) {
    o.stopPropagation();
  }
  return () => {
    let { id: o, ...l } = t, L = { id: o, ref: s.panelRef, onClick: r };
    return D1({ ourProps: L, theirProps: l, slot: { open: s.dialogState.value === 0 }, attrs: e, slots: n, name: "DialogPanel" });
  };
} }), CE = q2({ name: "DialogTitle", props: { as: { type: [Object, String], default: "h2" }, id: { type: String, default: () => `headlessui-dialog-title-${L4()}` } }, setup(t, { attrs: e, slots: n }) {
  let i = f5("DialogTitle");
  return s1(() => {
    i.setTitleId(t.id), x1(() => i.setTitleId(null));
  }), () => {
    let { id: s, ...r } = t;
    return D1({ ourProps: { id: s }, theirProps: r, slot: { open: i.dialogState.value === 0 }, attrs: e, slots: n, name: "DialogTitle" });
  };
} }), ua = Symbol("LabelContext");
function ha() {
  let t = u1(ua, null);
  if (t === null) {
    let e = new Error("You used a <Label /> component, but it is not inside a parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(e, ha), e;
  }
  return t;
}
function da({ slot: t = {}, name: e = "Label", props: n = {} } = {}) {
  let i = R2([]);
  function s(r) {
    return i.value.push(r), () => {
      let o = i.value.indexOf(r);
      o !== -1 && i.value.splice(o, 1);
    };
  }
  return a3(ua, { register: s, slot: t, name: e, props: n }), I(() => i.value.length > 0 ? i.value.join(" ") : void 0);
}
let cE = q2({ name: "Label", props: { as: { type: [Object, String], default: "label" }, passive: { type: [Boolean], default: !1 }, id: { type: String, default: () => `headlessui-label-${L4()}` } }, setup(t, { slots: e, attrs: n }) {
  let i = ha();
  return s1(() => x1(i.register(t.id))), () => {
    let { name: s = "Label", slot: r = {}, props: o = {} } = i, { id: l, passive: L, ...a } = t, C = { ...Object.entries(o).reduce((c, [h, d]) => Object.assign(c, { [h]: O(d) }), {}), id: l };
    return L && (delete C.onClick, delete C.htmlFor, delete a.onClick), D1({ ourProps: C, theirProps: a, slot: r, attrs: n, slots: e, name: s });
  };
} });
function uE(t, e) {
  return t === e;
}
let ga = Symbol("RadioGroupContext");
function fa(t) {
  let e = u1(ga, null);
  if (e === null) {
    let n = new Error(`<${t} /> is missing a parent <RadioGroup /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, fa), n;
  }
  return e;
}
let hE = q2({ name: "RadioGroup", emits: { "update:modelValue": (t) => !0 }, props: { as: { type: [Object, String], default: "div" }, disabled: { type: [Boolean], default: !1 }, by: { type: [String, Function], default: () => uE }, modelValue: { type: [Object, String, Number, Boolean], default: void 0 }, defaultValue: { type: [Object, String, Number, Boolean], default: void 0 }, form: { type: String, optional: !0 }, name: { type: String, optional: !0 }, id: { type: String, default: () => `headlessui-radiogroup-${L4()}` } }, inheritAttrs: !1, setup(t, { emit: e, attrs: n, slots: i, expose: s }) {
  let r = R2(null), o = R2([]), l = da({ name: "RadioGroupLabel" }), L = Jt({ name: "RadioGroupDescription" });
  s({ el: r, $el: r });
  let [a, C] = Pb(I(() => t.modelValue), (f) => e("update:modelValue", f), I(() => t.defaultValue)), c = { options: o, value: a, disabled: I(() => t.disabled), firstOption: I(() => o.value.find((f) => !f.propsRef.disabled)), containsCheckedOption: I(() => o.value.some((f) => c.compare(I2(f.propsRef.value), I2(t.modelValue)))), compare(f, x) {
    if (typeof t.by == "string") {
      let k = t.by;
      return (f == null ? void 0 : f[k]) === (x == null ? void 0 : x[k]);
    }
    return t.by(f, x);
  }, change(f) {
    var x;
    if (t.disabled || c.compare(I2(a.value), I2(f)))
      return !1;
    let k = (x = o.value.find((m) => c.compare(I2(m.propsRef.value), I2(f)))) == null ? void 0 : x.propsRef;
    return k != null && k.disabled ? !1 : (C(f), !0);
  }, registerOption(f) {
    o.value.push(f), o.value = XL(o.value, (x) => x.element);
  }, unregisterOption(f) {
    let x = o.value.findIndex((k) => k.id === f);
    x !== -1 && o.value.splice(x, 1);
  } };
  a3(ga, c), Tb({ container: I(() => a1(r)), accept(f) {
    return f.getAttribute("role") === "radio" ? NodeFilter.FILTER_REJECT : f.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
  }, walk(f) {
    f.setAttribute("role", "none");
  } });
  function h(f) {
    if (!r.value || !r.value.contains(f.target))
      return;
    let x = o.value.filter((k) => k.propsRef.disabled === !1).map((k) => k.element);
    switch (f.key) {
      case k4.Enter:
        Db(f.currentTarget);
        break;
      case k4.ArrowLeft:
      case k4.ArrowUp:
        if (f.preventDefault(), f.stopPropagation(), P9(x, k3.Previous | k3.WrapAround) === _8.Success) {
          let k = o.value.find((m) => {
            var g;
            return m.element === ((g = Y3(r)) == null ? void 0 : g.activeElement);
          });
          k && c.change(k.propsRef.value);
        }
        break;
      case k4.ArrowRight:
      case k4.ArrowDown:
        if (f.preventDefault(), f.stopPropagation(), P9(x, k3.Next | k3.WrapAround) === _8.Success) {
          let k = o.value.find((m) => {
            var g;
            return m.element === ((g = Y3(m.element)) == null ? void 0 : g.activeElement);
          });
          k && c.change(k.propsRef.value);
        }
        break;
      case k4.Space:
        {
          f.preventDefault(), f.stopPropagation();
          let k = o.value.find((m) => {
            var g;
            return m.element === ((g = Y3(m.element)) == null ? void 0 : g.activeElement);
          });
          k && c.change(k.propsRef.value);
        }
        break;
    }
  }
  let d = I(() => {
    var f;
    return (f = a1(r)) == null ? void 0 : f.closest("form");
  });
  return s1(() => {
    m3([d], () => {
      if (!d.value || t.defaultValue === void 0)
        return;
      function f() {
        c.change(t.defaultValue);
      }
      return d.value.addEventListener("reset", f), () => {
        var x;
        (x = d.value) == null || x.removeEventListener("reset", f);
      };
    }, { immediate: !0 });
  }), () => {
    let { disabled: f, name: x, id: k, form: m, ...g } = t, w = { ref: r, id: k, role: "radiogroup", "aria-labelledby": l.value, "aria-describedby": L.value, onKeydown: h };
    return f1(P2, [...x != null && a.value != null ? ea({ [x]: a.value }).map(([Z, b]) => f1(v8, xb({ features: G0.Hidden, key: Z, as: "input", type: "hidden", hidden: !0, readOnly: !0, form: m, name: Z, value: b }))) : [], D1({ ourProps: w, theirProps: { ...n, ...Yt(g, ["modelValue", "defaultValue", "by"]) }, slot: {}, attrs: n, slots: i, name: "RadioGroup" })]);
  };
} });
var dE = ((t) => (t[t.Empty = 1] = "Empty", t[t.Active = 2] = "Active", t))(dE || {});
let gE = q2({ name: "RadioGroupOption", props: { as: { type: [Object, String], default: "div" }, value: { type: [Object, String, Number, Boolean] }, disabled: { type: Boolean, default: !1 }, id: { type: String, default: () => `headlessui-radiogroup-option-${L4()}` } }, setup(t, { attrs: e, slots: n, expose: i }) {
  let s = fa("RadioGroupOption"), r = da({ name: "RadioGroupLabel" }), o = Jt({ name: "RadioGroupDescription" }), l = R2(null), L = I(() => ({ value: t.value, disabled: t.disabled })), a = R2(1);
  i({ el: l, $el: l });
  let C = I(() => a1(l));
  s1(() => s.registerOption({ id: t.id, element: C, propsRef: L })), x1(() => s.unregisterOption(t.id));
  let c = I(() => {
    var g;
    return ((g = s.firstOption.value) == null ? void 0 : g.id) === t.id;
  }), h = I(() => s.disabled.value || t.disabled), d = I(() => s.compare(I2(s.value.value), I2(t.value))), f = I(() => h.value ? -1 : d.value || !s.containsCheckedOption.value && c.value ? 0 : -1);
  function x() {
    var g;
    s.change(t.value) && (a.value |= 2, (g = a1(l)) == null || g.focus());
  }
  function k() {
    a.value |= 2;
  }
  function m() {
    a.value &= -3;
  }
  return () => {
    let { id: g, value: w, disabled: Z, ...b } = t, z = { checked: d.value, disabled: h.value, active: !!(a.value & 2) }, K = { id: g, ref: l, role: "radio", "aria-checked": d.value ? "true" : "false", "aria-labelledby": r.value, "aria-describedby": o.value, "aria-disabled": h.value ? !0 : void 0, tabIndex: f.value, onClick: h.value ? void 0 : x, onFocus: h.value ? void 0 : k, onBlur: h.value ? void 0 : m };
    return D1({ ourProps: K, theirProps: b, slot: z, attrs: e, slots: n, name: "RadioGroupOption" });
  };
} }), Cs = cE;
function fE(t) {
  let e = { called: !1 };
  return (...n) => {
    if (!e.called)
      return e.called = !0, t(...n);
  };
}
function q7(t, ...e) {
  t && e.length > 0 && t.classList.add(...e);
}
function U5(t, ...e) {
  t && e.length > 0 && t.classList.remove(...e);
}
var Q6 = ((t) => (t.Finished = "finished", t.Cancelled = "cancelled", t))(Q6 || {});
function pE(t, e) {
  let n = g5();
  if (!t)
    return n.dispose;
  let { transitionDuration: i, transitionDelay: s } = getComputedStyle(t), [r, o] = [i, s].map((l) => {
    let [L = 0] = l.split(",").filter(Boolean).map((a) => a.includes("ms") ? parseFloat(a) : parseFloat(a) * 1e3).sort((a, C) => C - a);
    return L;
  });
  return r !== 0 ? n.setTimeout(() => e("finished"), r + o) : e("finished"), n.add(() => e("cancelled")), n.dispose;
}
function cs(t, e, n, i, s, r) {
  let o = g5(), l = r !== void 0 ? fE(r) : () => {
  };
  return U5(t, ...s), q7(t, ...e, ...n), o.nextFrame(() => {
    U5(t, ...n), q7(t, ...i), o.add(pE(t, (L) => (U5(t, ...i, ...e), q7(t, ...s), l(L))));
  }), o.add(() => U5(t, ...e, ...n, ...i, ...s)), o.add(() => l("cancelled")), o.dispose;
}
function j4(t = "") {
  return t.split(" ").filter((e) => e.trim().length > 1);
}
let en = Symbol("TransitionContext");
var mE = ((t) => (t.Visible = "visible", t.Hidden = "hidden", t))(mE || {});
function wE() {
  return u1(en, null) !== null;
}
function xE() {
  let t = u1(en, null);
  if (t === null)
    throw new Error("A <TransitionChild /> is used but it is missing a parent <TransitionRoot />.");
  return t;
}
function _E() {
  let t = u1(tn, null);
  if (t === null)
    throw new Error("A <TransitionChild /> is used but it is missing a parent <TransitionRoot />.");
  return t;
}
let tn = Symbol("NestingContext");
function p7(t) {
  return "children" in t ? p7(t.children) : t.value.filter(({ state: e }) => e === "visible").length > 0;
}
function pa(t) {
  let e = R2([]), n = R2(!1);
  s1(() => n.value = !0), x1(() => n.value = !1);
  function i(r, o = b4.Hidden) {
    let l = e.value.findIndex(({ id: L }) => L === r);
    l !== -1 && (i4(o, { [b4.Unmount]() {
      e.value.splice(l, 1);
    }, [b4.Hidden]() {
      e.value[l].state = "hidden";
    } }), !p7(e) && n.value && (t == null || t()));
  }
  function s(r) {
    let o = e.value.find(({ id: l }) => l === r);
    return o ? o.state !== "visible" && (o.state = "visible") : e.value.push({ id: r, state: "visible" }), () => i(r, b4.Unmount);
  }
  return { children: e, register: s, unregister: i };
}
let ma = x8.RenderStrategy, X6 = q2({ props: { as: { type: [Object, String], default: "div" }, show: { type: [Boolean], default: null }, unmount: { type: [Boolean], default: !0 }, appear: { type: [Boolean], default: !1 }, enter: { type: [String], default: "" }, enterFrom: { type: [String], default: "" }, enterTo: { type: [String], default: "" }, entered: { type: [String], default: "" }, leave: { type: [String], default: "" }, leaveFrom: { type: [String], default: "" }, leaveTo: { type: [String], default: "" } }, emits: { beforeEnter: () => !0, afterEnter: () => !0, beforeLeave: () => !0, afterLeave: () => !0 }, setup(t, { emit: e, attrs: n, slots: i, expose: s }) {
  let r = R2(0);
  function o() {
    r.value |= f3.Opening, e("beforeEnter");
  }
  function l() {
    r.value &= ~f3.Opening, e("afterEnter");
  }
  function L() {
    r.value |= f3.Closing, e("beforeLeave");
  }
  function a() {
    r.value &= ~f3.Closing, e("afterLeave");
  }
  if (!wE() && Rb())
    return () => f1(wa, { ...t, onBeforeEnter: o, onAfterEnter: l, onBeforeLeave: L, onAfterLeave: a }, i);
  let C = R2(null), c = I(() => t.unmount ? b4.Unmount : b4.Hidden);
  s({ el: C, $el: C });
  let { show: h, appear: d } = xE(), { register: f, unregister: x } = _E(), k = R2(h.value ? "visible" : "hidden"), m = { value: !0 }, g = L4(), w = { value: !1 }, Z = pa(() => {
    !w.value && k.value !== "hidden" && (k.value = "hidden", x(g), a());
  });
  s1(() => {
    let m2 = f(g);
    x1(m2);
  }), x3(() => {
    if (c.value === b4.Hidden && g) {
      if (h.value && k.value !== "visible") {
        k.value = "visible";
        return;
      }
      i4(k.value, { hidden: () => x(g), visible: () => f(g) });
    }
  });
  let b = j4(t.enter), z = j4(t.enterFrom), K = j4(t.enterTo), E = j4(t.entered), L2 = j4(t.leave), t2 = j4(t.leaveFrom), u2 = j4(t.leaveTo);
  s1(() => {
    x3(() => {
      if (k.value === "visible") {
        let m2 = a1(C);
        if (m2 instanceof Comment && m2.data === "")
          throw new Error("Did you forget to passthrough the `ref` to the actual DOM node?");
      }
    });
  });
  function N2(m2) {
    let P = m.value && !d.value, W2 = a1(C);
    !W2 || !(W2 instanceof HTMLElement) || P || (w.value = !0, h.value && o(), h.value || L(), m2(h.value ? cs(W2, b, z, K, E, ($) => {
      w.value = !1, $ === Q6.Finished && l();
    }) : cs(W2, L2, t2, u2, E, ($) => {
      w.value = !1, $ === Q6.Finished && (p7(Z) || (k.value = "hidden", x(g), a()));
    })));
  }
  return s1(() => {
    m3([h], (m2, P, W2) => {
      N2(W2), m.value = !1;
    }, { immediate: !0 });
  }), a3(tn, Z), yb(I(() => i4(k.value, { visible: f3.Open, hidden: f3.Closed }) | r.value)), () => {
    let { appear: m2, show: P, enter: W2, enterFrom: $, enterTo: s2, entered: g2, leave: J2, leaveFrom: S2, leaveTo: y1, ...E2 } = t, U = { ref: C }, Q = { ...E2, ...d.value && h.value && d5.isServer ? { class: v2([n.class, E2.class, ...b, ...z]) } : {} };
    return D1({ theirProps: Q, ourProps: U, slot: {}, slots: i, attrs: n, features: ma, visible: k.value === "visible", name: "TransitionChild" });
  };
} }), vE = X6, wa = q2({ inheritAttrs: !1, props: { as: { type: [Object, String], default: "div" }, show: { type: [Boolean], default: null }, unmount: { type: [Boolean], default: !0 }, appear: { type: [Boolean], default: !1 }, enter: { type: [String], default: "" }, enterFrom: { type: [String], default: "" }, enterTo: { type: [String], default: "" }, entered: { type: [String], default: "" }, leave: { type: [String], default: "" }, leaveFrom: { type: [String], default: "" }, leaveTo: { type: [String], default: "" } }, emits: { beforeEnter: () => !0, afterEnter: () => !0, beforeLeave: () => !0, afterLeave: () => !0 }, setup(t, { emit: e, attrs: n, slots: i }) {
  let s = Qt(), r = I(() => t.show === null && s !== null ? (s.value & f3.Open) === f3.Open : t.show);
  x3(() => {
    if (![!0, !1].includes(r.value))
      throw new Error('A <Transition /> is used but it is missing a `:show="true | false"` prop.');
  });
  let o = R2(r.value ? "visible" : "hidden"), l = pa(() => {
    o.value = "hidden";
  }), L = R2(!0), a = { show: r, appear: I(() => t.appear || !L.value) };
  return s1(() => {
    x3(() => {
      L.value = !1, r.value ? o.value = "visible" : p7(l) || (o.value = "hidden");
    });
  }), a3(tn, l), a3(en, a), () => {
    let C = Yt(t, ["show", "appear", "unmount", "onBeforeEnter", "onBeforeLeave", "onAfterEnter", "onAfterLeave"]), c = { unmount: t.unmount };
    return D1({ ourProps: { ...c, as: "template" }, theirProps: {}, slot: {}, slots: { ...i, default: () => [f1(vE, { onBeforeEnter: () => e("beforeEnter"), onAfterEnter: () => e("afterEnter"), onBeforeLeave: () => e("beforeLeave"), onAfterLeave: () => e("afterLeave"), ...n, ...c, ...C }, i.default)] }, attrs: {}, features: ma, visible: o.value === "visible", name: "Transition" });
  };
} });
const ME = `<svg width="64" height="42" viewBox="0 0 64 42" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0.5" y="0.5" width="63" height="41" rx="3.5" fill="white"/>
<rect x="0.5" y="0.5" width="63" height="41" rx="3.5" stroke="#E6E7EB"/>
<rect x="4" y="6" width="16" height="6" fill="#F2F4F7"/>
<rect x="44" y="6" width="16" height="6" fill="#F2F4F7"/>
<rect x="24" y="6" width="16" height="6" fill="#F2F4F7"/>
<path d="M8 8H16V10H8V8Z" fill="#D0D5DD"/>
<rect x="28" y="8" width="8" height="2" fill="#D0D5DD"/>
<rect x="48" y="8" width="8" height="2" fill="#D0D5DD"/>
<rect x="11" y="14" width="2" height="20" fill="#D0D5DD"/>
<rect x="31" y="14" width="2" height="6" fill="#D0D5DD"/>
<rect x="51" y="28" width="2" height="6" fill="#D0D5DD"/>
<line x1="13" y1="16.75" x2="31" y2="16.75" stroke="#98A2B3" stroke-width="0.5"/>
<line x1="13" y1="30.75" x2="51" y2="30.75" stroke="#98A2B3" stroke-width="0.5"/>
</svg>
`, RE = `<svg width="64" height="42" viewBox="0 0 64 42" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0.5" y="0.5" width="63" height="41" rx="3.5" fill="#FCFCFD"/>
<rect x="0.5" y="0.5" width="63" height="41" rx="3.5" stroke="#E6E7EB"/>
<rect x="4" y="6" width="16" height="6" fill="#D1E0FF"/>
<rect x="44" y="6" width="16" height="6" fill="#D1E0FF"/>
<rect x="24" y="6" width="16" height="6" fill="#D1E0FF"/>
<rect x="8" y="8" width="8" height="2" fill="#475467"/>
<rect x="28" y="8" width="8" height="2" fill="#475467"/>
<rect x="48" y="8" width="8" height="2" fill="#475467"/>
<rect x="11" y="14" width="2" height="20" fill="#D1E0FF"/>
<rect x="31" y="14" width="2" height="6" fill="#D1E0FF"/>
<rect x="51" y="28" width="2" height="6" fill="#D1E0FF"/>
<line x1="13" y1="16.75" x2="31" y2="16.75" stroke="#98A2B3" stroke-width="0.5"/>
<line x1="13" y1="30.75" x2="51" y2="30.75" stroke="#98A2B3" stroke-width="0.5"/>
</svg>
`, yE = `<svg width="64" height="42" viewBox="0 0 64 42" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0.5" y="0.5" width="63" height="41" rx="3.5" fill="#1F242F"/>
<rect x="0.5" y="0.5" width="63" height="41" rx="3.5" stroke="#E6E7EB"/>
<rect x="4" y="6" width="16" height="6" fill="#536FFF"/>
<rect x="44" y="6" width="16" height="6" fill="#536FFF"/>
<rect x="24" y="6" width="16" height="6" fill="#536FFF"/>
<rect x="8" y="8" width="8" height="2" fill="#F5F5F6"/>
<rect x="28" y="8" width="8" height="2" fill="#F5F5F6"/>
<rect x="48" y="8" width="8" height="2" fill="#F5F5F6"/>
<rect x="11" y="14" width="2" height="20" fill="#536FFF"/>
<rect x="31" y="14" width="2" height="6" fill="#536FFF"/>
<rect x="51" y="28" width="2" height="6" fill="#536FFF"/>
<line x1="13" y1="16.75" x2="31" y2="16.75" stroke="#EBEBEB" stroke-width="0.5"/>
<line x1="13" y1="30.75" x2="51" y2="30.75" stroke="#EBEBEB" stroke-width="0.5"/>
</svg>
`, AE = `<svg width="64" height="42" viewBox="0 0 64 42" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0.5" y="0.5" width="63" height="41" rx="3.5" fill="#1F242F"/>
<rect x="0.5" y="0.5" width="63" height="41" rx="3.5" stroke="#E6E7EB"/>
<rect x="4" y="6" width="16" height="6" fill="#34D399"/>
<rect x="44" y="6" width="16" height="6" fill="#34D399"/>
<rect x="24" y="6" width="16" height="6" fill="#34D399"/>
<rect x="8" y="8" width="8" height="2" fill="#08895A"/>
<rect x="28" y="8" width="8" height="2" fill="#08895A"/>
<rect x="48" y="8" width="8" height="2" fill="#08895A"/>
<rect x="11" y="14" width="2" height="20" fill="#08895A"/>
<rect x="31" y="14" width="2" height="6" fill="#08895A"/>
<rect x="51" y="28" width="2" height="6" fill="#08895A"/>
<line x1="13" y1="16.75" x2="31" y2="16.75" stroke="#34D399" stroke-width="0.5"/>
<line x1="13" y1="30.75" x2="51" y2="30.75" stroke="#34D399" stroke-width="0.5"/>
</svg>
`;
const ZE = {
  key: 0,
  class: "dot"
}, kE = /* @__PURE__ */ _("div", { class: "fixed inset-0 bg-black bg-opacity-25" }, null, -1), TE = { class: "fixed inset-0 overflow-y-auto" }, SE = { class: "flex min-h-full items-center justify-center p-4 text-center" }, bE = { class: "px-6" }, EE = /* @__PURE__ */ _("p", { class: "text-gray-500 text-sm" }, "Customize your UI theme", -1), IE = { class: "mt-4 ml-[-0.5rem] px-2 max-h-72 overflow-y-auto" }, FE = { class: "pb-4" }, OE = { class: "space-y-2" }, NE = { class: "flex w-full items-center justify-between" }, DE = { class: "flex items-center text-sm text-gray-900" }, PE = ["innerHTML"], BE = { class: "pt-6 px-6 border-t flex items-center gap-2" }, zE = ["checked"], UE = /* @__PURE__ */ _("label", {
  for: "scopeTheming",
  class: "select-none"
}, "Apply to this diagram only", -1), WE = {
  __name: "ThemeSelect",
  setup(t) {
    const e = R2(!1), n = [
      {
        name: "Legacy",
        id: "theme-default",
        icon: ME
      },
      {
        name: "Clear Light",
        id: "theme-clean-light",
        icon: RE
      },
      {
        name: "Clear Dark",
        id: "theme-clean-dark",
        icon: yE
      },
      {
        name: "Neon Dark",
        id: "theme-neon",
        icon: AE
      }
    ], i = F3(), s = I(() => i.state.theme || n[0].id), r = I(
      () => i.state.enableScopedTheming || !1
    ), o = R2(i.state.themeIconDot), l = () => {
      e.value = !1, c("theme-close-modal");
    }, L = () => {
      e.value = !0, o.value = !0, i.commit("setThemeIconDot", !0), c("theme-open-modal");
    }, a = (h) => {
      i.commit("setTheme", h), c("theme-select");
    }, C = (h) => {
      i.commit("setEnableScopedTheming", h), c("theme-enable-scoped");
    }, c = (h) => {
      Ew(
        i,
        {
          theme: s.value,
          enableScopedTheming: r.value
        },
        h,
        "sequence"
      );
    };
    return (h, d) => (T(), B(P2, null, [
      _("button", {
        type: "button",
        class: "flex items-center icon-container",
        onClick: L
      }, [
        N(q1, { name: "theme" }),
        o.value ? x2("", !0) : (T(), B("span", ZE))
      ]),
      N(O(wa), {
        appear: "",
        show: e.value,
        as: "template"
      }, {
        default: h3(() => [
          N(O(LE), {
            as: "div",
            onClose: l,
            class: "relative z-10"
          }, {
            default: h3(() => [
              N(O(X6), {
                as: "template",
                enter: "duration-300 ease-out",
                "enter-from": "opacity-0",
                "enter-to": "opacity-100",
                leave: "duration-200 ease-in",
                "leave-from": "opacity-100",
                "leave-to": "opacity-0"
              }, {
                default: h3(() => [
                  kE
                ], void 0, !0),
                _: 1
              }),
              _("div", TE, [
                _("div", SE, [
                  N(O(X6), {
                    as: "template",
                    enter: "duration-300 ease-out",
                    "enter-from": "opacity-0 scale-95",
                    "enter-to": "opacity-100 scale-100",
                    leave: "duration-200 ease-in",
                    "leave-from": "opacity-100 scale-100",
                    "leave-to": "opacity-0 scale-95"
                  }, {
                    default: h3(() => [
                      N(O(aE), { class: "w-full max-w-md transform overflow-hidden rounded-2xl bg-white py-6 text-left align-middle shadow-xl transition-all" }, {
                        default: h3(() => [
                          _("div", bE, [
                            N(O(CE), {
                              as: "h3",
                              class: "text-lg font-semibold leading-6 text-gray-900"
                            }, {
                              default: h3(() => [
                                q3(" Theme ")
                              ], void 0, !0),
                              _: 1
                            }),
                            EE,
                            _("div", IE, [
                              _("div", FE, [
                                N(O(hE), {
                                  "model-value": O(s),
                                  "onUpdate:modelValue": a
                                }, {
                                  default: h3(() => [
                                    N(O(Cs), { class: "sr-only" }, {
                                      default: h3(() => [
                                        q3("Server size")
                                      ], void 0, !0),
                                      _: 1
                                    }),
                                    _("div", OE, [
                                      (T(), B(P2, null, e4(n, (f) => N(O(gE), {
                                        as: "template",
                                        key: f.id,
                                        value: f.id
                                      }, {
                                        default: h3(({ checked: x }) => [
                                          _("div", {
                                            class: v2([[
                                              x ? "border-2 text-gray-900 border-primary" : "border-2 border-transparent"
                                            ], "relative flex items-center cursor-pointer rounded-lg px-4 py-3 shadow-md"])
                                          }, [
                                            _("div", NE, [
                                              _("div", DE, [
                                                x ? (T(), T2(q1, {
                                                  key: 0,
                                                  name: "selected-cycle",
                                                  "icon-class": "h-5 w-5 fill-none"
                                                })) : (T(), T2(q1, {
                                                  key: 1,
                                                  name: "non-selected-cycle",
                                                  "icon-class": "h-5 w-5"
                                                })),
                                                N(O(Cs), {
                                                  as: "p",
                                                  class: v2([
                                                    "text-gray-900",
                                                    "font-medium ml-2"
                                                  ])
                                                }, {
                                                  default: h3(() => [
                                                    q3(m1(f.name), 1)
                                                  ], void 0, !0),
                                                  _: 2
                                                }, 1032, ["class"])
                                              ])
                                            ]),
                                            _("span", {
                                              class: "inline-block w-20 border rounded-md overflow-hidden",
                                              innerHTML: f.icon
                                            }, null, 8, PE)
                                          ], 2)
                                        ]),
                                        _: 2
                                      }, 1032, ["value"])), 64))
                                    ])
                                  ], void 0, !0),
                                  _: 1
                                }, 8, ["model-value"])
                              ])
                            ])
                          ]),
                          _("div", BE, [
                            _("input", {
                              type: "checkbox",
                              id: "scopeTheming",
                              checked: O(r),
                              onChange: d[0] || (d[0] = (f) => C(f.target.checked))
                            }, null, 40, zE),
                            UE
                          ])
                        ], void 0, !0),
                        _: 1
                      })
                    ], void 0, !0),
                    _: 1
                  })
                ])
              ])
            ], void 0, !0),
            _: 1
          })
        ], void 0, !0),
        _: 1
      }, 8, ["show"])
    ], 64));
  }
}, HE = {
  name: "DiagramFrame",
  setup() {
    return {
      RenderMode: j1
    };
  },
  computed: {
    ...q8([
      "showTips",
      "scale",
      "theme",
      "numbering",
      "enableMultiTheme",
      "mode"
    ]),
    ...R3(["rootContext"]),
    title() {
      var t;
      return this.rootContext || console.error(
        "`rootContext` is empty. Please make sure `store` is properly configured."
      ), (t = this.rootContext) == null ? void 0 : t.title();
    }
  },
  mounted() {
    this.$el.__vue__ = this;
  },
  methods: {
    ...Qo(["setScale", "toggleNumbering"]),
    showTipsDialog() {
      var t;
      this.$store.state.showTips = !0;
      try {
        (t = this.$gtag) == null || t.event("view", {
          event_category: "help",
          event_label: "tips dialog"
        });
      } catch (e) {
        console.error(e);
      }
    },
    toPng() {
      return ab(this.$refs.export, {
        backgroundColor: "white",
        filter: (t) => {
          var e;
          return !((e = t == null ? void 0 : t.classList) != null && e.contains("hide-export"));
        }
      });
    },
    toSvg() {
      return jL(this.$refs.export, {
        backgroundColor: "white",
        filter: (t) => {
          var e;
          return !((e = t == null ? void 0 : t.classList) != null && e.contains("hide-export"));
        }
      });
    },
    toBlob() {
      return cb(this.$refs.export, {
        backgroundColor: "white",
        filter: (t) => {
          var e;
          return !((e = t == null ? void 0 : t.classList) != null && e.contains("hide-export"));
        }
      });
    },
    toJpeg() {
      return Cb(this.$refs.export, {
        backgroundColor: "white",
        filter: (t) => {
          var e;
          return !((e = t == null ? void 0 : t.classList) != null && e.contains("hide-export"));
        }
      });
    },
    zoomIn() {
      const t = Math.min(1, this.scale + 0.1);
      this.setScale(t);
    },
    zoomOut() {
      this.setScale(this.scale - 0.1);
    },
    setTheme(t) {
      this.theme = t;
    },
    setStyle(t) {
      const e = "zenuml-style";
      let n = document.getElementById(e);
      n || (n = document.createElement("style"), n.id = e, document.head.append(n)), n.textContent = t;
    },
    setRemoteCss(t) {
      const e = new URL(t).hostname;
      if (e === "https://github.com" || e === "https://githubusercontent.com") {
        fetch(
          t.replace("github.com", "raw.githubusercontent.com").replace("blob/", "")
        ).then((s) => s.text()).then((s) => {
          this.setStyle(s);
        });
        return;
      }
      const n = "zenuml-remote-css";
      let i = document.getElementById(n);
      i || (i = document.createElement("link"), i.id = n, i.rel = "stylesheet", document.head.append(i)), i.href = t;
    }
  },
  components: {
    Icon: q1,
    Debug: wb,
    WidthProvider: wS,
    TipsDialog: YT,
    DiagramTitle: Sw,
    SeqDiagram: Gt,
    Privacy: Aw,
    ThemeSelect: WE
  }
}, $E = { class: "frame text-skin-base bg-skin-frame border-skin-frame relative m-1 origin-top-left whitespace-nowrap border rounded" }, VE = { ref: "content" }, GE = { class: "header text-skin-title bg-skin-title border-skin-frame border-b p-1 flex justify-between rounded-t" }, jE = { class: "left hide-export" }, qE = { class: "right flex-grow flex justify-between" }, KE = {
  key: 0,
  class: "fixed z-40 inset-0 overflow-y-auto",
  "aria-labelledby": "modal-title",
  role: "dialog",
  "aria-modal": "true"
}, YE = { class: "footer rounded text-skin-control bg-skin-title px-4 py-1 flex justify-between items-center gap-3" }, QE = { class: "flex items-center gap-3 color-base" }, XE = { class: "flex items-center" }, JE = ["checked"], eI = {
  for: "order-display",
  title: "Numbering the diagram",
  class: "select-none"
}, tI = { class: "zoom-controls flex hide-export gap-1" }, nI = { class: "w-12 block text-center" }, iI = /* @__PURE__ */ _("a", {
  target: "_blank",
  href: "https://zenuml.com",
  class: "brand text-xs hover:underline"
}, "ZenUML.com", -1);
function sI(t, e, n, i, s, r) {
  const o = i2("debug"), l = i2("diagram-title"), L = i2("privacy"), a = i2("TipsDialog"), C = i2("seq-diagram"), c = i2("Icon"), h = i2("ThemeSelect"), d = i2("width-provider");
  return T(), B("div", {
    ref: "export",
    class: v2(["zenuml p-1 bg-skin-canvas", t.theme]),
    style: { display: "inline-block" }
  }, [
    N(o),
    _("div", $E, [
      _("div", VE, [
        _("div", GE, [
          _("div", jE, [
            ke(t.$slots, "default")
          ]),
          _("div", qE, [
            N(l, { context: r.title }, null, 8, ["context"]),
            N(L, { class: "hide-export flex items-center" })
          ])
        ]),
        _("div", null, [
          t.showTips ? (T(), B("div", KE, [
            N(a)
          ])) : x2("", !0)
        ]),
        N(C, {
          ref: "diagram",
          style: w2({ transform: `scale(${t.scale})` }),
          class: "origin-top-left"
        }, null, 8, ["style"])
      ], 512),
      _("div", YE, [
        t.mode === i.RenderMode.Dynamic ? (T(), B(P2, { key: 0 }, [
          _("div", QE, [
            _("button", {
              class: "bottom-1 flex items-center left-1 hide-export",
              onClick: e[0] || (e[0] = (f) => r.showTipsDialog())
            }, [
              N(c, {
                name: "tip",
                "icon-class": "filter grayscale w-4 h-4"
              })
            ]),
            t.enableMultiTheme ? (T(), T2(h, { key: 0 })) : x2("", !0),
            _("div", XE, [
              _("input", {
                type: "checkbox",
                id: "order-display",
                class: "mr-1",
                checked: t.numbering,
                onInput: e[1] || (e[1] = (f) => t.toggleNumbering(!t.numbering))
              }, null, 40, JE),
              _("label", eI, [
                N(c, {
                  name: "numbering",
                  "icon-class": "w-6 h-6"
                })
              ])
            ])
          ]),
          _("div", tI, [
            _("button", {
              class: "zoom-in",
              onClick: e[2] || (e[2] = (f) => r.zoomIn())
            }, [
              N(c, {
                name: "zoom-in",
                "icon-class": "w-4 h-4"
              })
            ]),
            _("label", nI, m1(Number(t.scale * 100).toFixed(0)) + "%", 1),
            _("button", {
              class: "zoom-out",
              onClick: e[3] || (e[3] = (f) => r.zoomOut())
            }, [
              N(c, {
                name: "zoom-out",
                "icon-class": "w-4 h-4"
              })
            ])
          ]),
          iI
        ], 64)) : x2("", !0)
      ]),
      N(d)
    ])
  ], 2);
}
const xa = /* @__PURE__ */ K2(HE, [["render", sI]]), rI = "3.31.1";
function _a() {
  return {
    baseUrl: null,
    breaks: !1,
    extensions: null,
    gfm: !0,
    headerIds: !0,
    headerPrefix: "",
    highlight: null,
    langPrefix: "language-",
    mangle: !0,
    pedantic: !1,
    renderer: null,
    sanitize: !1,
    sanitizer: null,
    silent: !1,
    smartLists: !1,
    smartypants: !1,
    tokenizer: null,
    walkTokens: null,
    xhtml: !1
  };
}
let n0 = _a();
function oI(t) {
  n0 = t;
}
const lI = /[&<>"']/, LI = /[&<>"']/g, aI = /[<>"']|&(?!#?\w+;)/, CI = /[<>"']|&(?!#?\w+;)/g, cI = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;"
}, us = (t) => cI[t];
function M1(t, e) {
  if (e) {
    if (lI.test(t))
      return t.replace(LI, us);
  } else if (aI.test(t))
    return t.replace(CI, us);
  return t;
}
const uI = /&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/ig;
function va(t) {
  return t.replace(uI, (e, n) => (n = n.toLowerCase(), n === "colon" ? ":" : n.charAt(0) === "#" ? n.charAt(1) === "x" ? String.fromCharCode(parseInt(n.substring(2), 16)) : String.fromCharCode(+n.substring(1)) : ""));
}
const hI = /(^|[^\[])\^/g;
function t1(t, e) {
  t = t.source || t, e = e || "";
  const n = {
    replace: (i, s) => (s = s.source || s, s = s.replace(hI, "$1"), t = t.replace(i, s), n),
    getRegex: () => new RegExp(t, e)
  };
  return n;
}
const dI = /[^\w:]/g, gI = /^$|^[a-z][a-z0-9+.-]*:|^[?#]/i;
function hs(t, e, n) {
  if (t) {
    let i;
    try {
      i = decodeURIComponent(va(n)).replace(dI, "").toLowerCase();
    } catch {
      return null;
    }
    if (i.indexOf("javascript:") === 0 || i.indexOf("vbscript:") === 0 || i.indexOf("data:") === 0)
      return null;
  }
  e && !gI.test(n) && (n = wI(e, n));
  try {
    n = encodeURI(n).replace(/%25/g, "%");
  } catch {
    return null;
  }
  return n;
}
const W5 = {}, fI = /^[^:]+:\/*[^/]*$/, pI = /^([^:]+:)[\s\S]*$/, mI = /^([^:]+:\/*[^/]*)[\s\S]*$/;
function wI(t, e) {
  W5[" " + t] || (fI.test(t) ? W5[" " + t] = t + "/" : W5[" " + t] = Q5(t, "/", !0)), t = W5[" " + t];
  const n = t.indexOf(":") === -1;
  return e.substring(0, 2) === "//" ? n ? e : t.replace(pI, "$1") + e : e.charAt(0) === "/" ? n ? e : t.replace(mI, "$1") + e : t + e;
}
const M8 = { exec: function() {
} };
function D3(t) {
  let e = 1, n, i;
  for (; e < arguments.length; e++) {
    n = arguments[e];
    for (i in n)
      Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
  }
  return t;
}
function ds(t, e) {
  const n = t.replace(/\|/g, (r, o, l) => {
    let L = !1, a = o;
    for (; --a >= 0 && l[a] === "\\"; )
      L = !L;
    return L ? "|" : " |";
  }), i = n.split(/ \|/);
  let s = 0;
  if (i[0].trim() || i.shift(), i[i.length - 1].trim() || i.pop(), i.length > e)
    i.splice(e);
  else
    for (; i.length < e; )
      i.push("");
  for (; s < i.length; s++)
    i[s] = i[s].trim().replace(/\\\|/g, "|");
  return i;
}
function Q5(t, e, n) {
  const i = t.length;
  if (i === 0)
    return "";
  let s = 0;
  for (; s < i; ) {
    const r = t.charAt(i - s - 1);
    if (r === e && !n)
      s++;
    else if (r !== e && n)
      s++;
    else
      break;
  }
  return t.substr(0, i - s);
}
function xI(t, e) {
  if (t.indexOf(e[1]) === -1)
    return -1;
  const n = t.length;
  let i = 0, s = 0;
  for (; s < n; s++)
    if (t[s] === "\\")
      s++;
    else if (t[s] === e[0])
      i++;
    else if (t[s] === e[1] && (i--, i < 0))
      return s;
  return -1;
}
function Ma(t) {
  t && t.sanitize && !t.silent && console.warn("marked(): sanitize and sanitizer parameters are deprecated since version 0.7.0, should not be used and will be removed in the future. Read more here: https://marked.js.org/#/USING_ADVANCED.md#options");
}
function gs(t, e) {
  if (e < 1)
    return "";
  let n = "";
  for (; e > 1; )
    e & 1 && (n += t), e >>= 1, t += t;
  return n + t;
}
function fs(t, e, n, i) {
  const s = e.href, r = e.title ? M1(e.title) : null, o = t[1].replace(/\\([\[\]])/g, "$1");
  if (t[0].charAt(0) !== "!") {
    i.state.inLink = !0;
    const l = {
      type: "link",
      raw: n,
      href: s,
      title: r,
      text: o,
      tokens: i.inlineTokens(o, [])
    };
    return i.state.inLink = !1, l;
  } else
    return {
      type: "image",
      raw: n,
      href: s,
      title: r,
      text: M1(o)
    };
}
function _I(t, e) {
  const n = t.match(/^(\s+)(?:```)/);
  if (n === null)
    return e;
  const i = n[1];
  return e.split(`
`).map((s) => {
    const r = s.match(/^\s+/);
    if (r === null)
      return s;
    const [o] = r;
    return o.length >= i.length ? s.slice(i.length) : s;
  }).join(`
`);
}
class nn {
  constructor(e) {
    this.options = e || n0;
  }
  space(e) {
    const n = this.rules.block.newline.exec(e);
    if (n && n[0].length > 0)
      return {
        type: "space",
        raw: n[0]
      };
  }
  code(e) {
    const n = this.rules.block.code.exec(e);
    if (n) {
      const i = n[0].replace(/^ {1,4}/gm, "");
      return {
        type: "code",
        raw: n[0],
        codeBlockStyle: "indented",
        text: this.options.pedantic ? i : Q5(i, `
`)
      };
    }
  }
  fences(e) {
    const n = this.rules.block.fences.exec(e);
    if (n) {
      const i = n[0], s = _I(i, n[3] || "");
      return {
        type: "code",
        raw: i,
        lang: n[2] ? n[2].trim() : n[2],
        text: s
      };
    }
  }
  heading(e) {
    const n = this.rules.block.heading.exec(e);
    if (n) {
      let i = n[2].trim();
      if (/#$/.test(i)) {
        const r = Q5(i, "#");
        (this.options.pedantic || !r || / $/.test(r)) && (i = r.trim());
      }
      const s = {
        type: "heading",
        raw: n[0],
        depth: n[1].length,
        text: i,
        tokens: []
      };
      return this.lexer.inline(s.text, s.tokens), s;
    }
  }
  hr(e) {
    const n = this.rules.block.hr.exec(e);
    if (n)
      return {
        type: "hr",
        raw: n[0]
      };
  }
  blockquote(e) {
    const n = this.rules.block.blockquote.exec(e);
    if (n) {
      const i = n[0].replace(/^ *> ?/gm, "");
      return {
        type: "blockquote",
        raw: n[0],
        tokens: this.lexer.blockTokens(i, []),
        text: i
      };
    }
  }
  list(e) {
    let n = this.rules.block.list.exec(e);
    if (n) {
      let i, s, r, o, l, L, a, C, c, h, d, f, x = n[1].trim();
      const k = x.length > 1, m = {
        type: "list",
        raw: "",
        ordered: k,
        start: k ? +x.slice(0, -1) : "",
        loose: !1,
        items: []
      };
      x = k ? `\\d{1,9}\\${x.slice(-1)}` : `\\${x}`, this.options.pedantic && (x = k ? x : "[*+-]");
      const g = new RegExp(`^( {0,3}${x})((?: [^\\n]*)?(?:\\n|$))`);
      for (; e && (f = !1, !(!(n = g.exec(e)) || this.rules.block.hr.test(e))); ) {
        if (i = n[0], e = e.substring(i.length), C = n[2].split(`
`, 1)[0], c = e.split(`
`, 1)[0], this.options.pedantic ? (o = 2, d = C.trimLeft()) : (o = n[2].search(/[^ ]/), o = o > 4 ? 1 : o, d = C.slice(o), o += n[1].length), L = !1, !C && /^ *$/.test(c) && (i += c + `
`, e = e.substring(c.length + 1), f = !0), !f) {
          const Z = new RegExp(`^ {0,${Math.min(3, o - 1)}}(?:[*+-]|\\d{1,9}[.)])`);
          for (; e && (h = e.split(`
`, 1)[0], C = h, this.options.pedantic && (C = C.replace(/^ {1,4}(?=( {4})*[^ ])/g, "  ")), !Z.test(C)); ) {
            if (C.search(/[^ ]/) >= o || !C.trim())
              d += `
` + C.slice(o);
            else if (!L)
              d += `
` + C;
            else
              break;
            !L && !C.trim() && (L = !0), i += h + `
`, e = e.substring(h.length + 1);
          }
        }
        m.loose || (a ? m.loose = !0 : /\n *\n *$/.test(i) && (a = !0)), this.options.gfm && (s = /^\[[ xX]\] /.exec(d), s && (r = s[0] !== "[ ] ", d = d.replace(/^\[[ xX]\] +/, ""))), m.items.push({
          type: "list_item",
          raw: i,
          task: !!s,
          checked: r,
          loose: !1,
          text: d
        }), m.raw += i;
      }
      m.items[m.items.length - 1].raw = i.trimRight(), m.items[m.items.length - 1].text = d.trimRight(), m.raw = m.raw.trimRight();
      const w = m.items.length;
      for (l = 0; l < w; l++) {
        this.lexer.state.top = !1, m.items[l].tokens = this.lexer.blockTokens(m.items[l].text, []);
        const Z = m.items[l].tokens.filter((z) => z.type === "space"), b = Z.every((z) => {
          const K = z.raw.split("");
          let E = 0;
          for (const L2 of K)
            if (L2 === `
` && (E += 1), E > 1)
              return !0;
          return !1;
        });
        !m.loose && Z.length && b && (m.loose = !0, m.items[l].loose = !0);
      }
      return m;
    }
  }
  html(e) {
    const n = this.rules.block.html.exec(e);
    if (n) {
      const i = {
        type: "html",
        raw: n[0],
        pre: !this.options.sanitizer && (n[1] === "pre" || n[1] === "script" || n[1] === "style"),
        text: n[0]
      };
      return this.options.sanitize && (i.type = "paragraph", i.text = this.options.sanitizer ? this.options.sanitizer(n[0]) : M1(n[0]), i.tokens = [], this.lexer.inline(i.text, i.tokens)), i;
    }
  }
  def(e) {
    const n = this.rules.block.def.exec(e);
    if (n)
      return n[3] && (n[3] = n[3].substring(1, n[3].length - 1)), {
        type: "def",
        tag: n[1].toLowerCase().replace(/\s+/g, " "),
        raw: n[0],
        href: n[2],
        title: n[3]
      };
  }
  table(e) {
    const n = this.rules.block.table.exec(e);
    if (n) {
      const i = {
        type: "table",
        header: ds(n[1]).map((s) => ({ text: s })),
        align: n[2].replace(/^ *|\| *$/g, "").split(/ *\| */),
        rows: n[3] ? n[3].replace(/\n[ \t]*$/, "").split(`
`) : []
      };
      if (i.header.length === i.align.length) {
        i.raw = n[0];
        let s = i.align.length, r, o, l, L;
        for (r = 0; r < s; r++)
          /^ *-+: *$/.test(i.align[r]) ? i.align[r] = "right" : /^ *:-+: *$/.test(i.align[r]) ? i.align[r] = "center" : /^ *:-+ *$/.test(i.align[r]) ? i.align[r] = "left" : i.align[r] = null;
        for (s = i.rows.length, r = 0; r < s; r++)
          i.rows[r] = ds(i.rows[r], i.header.length).map((a) => ({ text: a }));
        for (s = i.header.length, o = 0; o < s; o++)
          i.header[o].tokens = [], this.lexer.inlineTokens(i.header[o].text, i.header[o].tokens);
        for (s = i.rows.length, o = 0; o < s; o++)
          for (L = i.rows[o], l = 0; l < L.length; l++)
            L[l].tokens = [], this.lexer.inlineTokens(L[l].text, L[l].tokens);
        return i;
      }
    }
  }
  lheading(e) {
    const n = this.rules.block.lheading.exec(e);
    if (n) {
      const i = {
        type: "heading",
        raw: n[0],
        depth: n[2].charAt(0) === "=" ? 1 : 2,
        text: n[1],
        tokens: []
      };
      return this.lexer.inline(i.text, i.tokens), i;
    }
  }
  paragraph(e) {
    const n = this.rules.block.paragraph.exec(e);
    if (n) {
      const i = {
        type: "paragraph",
        raw: n[0],
        text: n[1].charAt(n[1].length - 1) === `
` ? n[1].slice(0, -1) : n[1],
        tokens: []
      };
      return this.lexer.inline(i.text, i.tokens), i;
    }
  }
  text(e) {
    const n = this.rules.block.text.exec(e);
    if (n) {
      const i = {
        type: "text",
        raw: n[0],
        text: n[0],
        tokens: []
      };
      return this.lexer.inline(i.text, i.tokens), i;
    }
  }
  escape(e) {
    const n = this.rules.inline.escape.exec(e);
    if (n)
      return {
        type: "escape",
        raw: n[0],
        text: M1(n[1])
      };
  }
  tag(e) {
    const n = this.rules.inline.tag.exec(e);
    if (n)
      return !this.lexer.state.inLink && /^<a /i.test(n[0]) ? this.lexer.state.inLink = !0 : this.lexer.state.inLink && /^<\/a>/i.test(n[0]) && (this.lexer.state.inLink = !1), !this.lexer.state.inRawBlock && /^<(pre|code|kbd|script)(\s|>)/i.test(n[0]) ? this.lexer.state.inRawBlock = !0 : this.lexer.state.inRawBlock && /^<\/(pre|code|kbd|script)(\s|>)/i.test(n[0]) && (this.lexer.state.inRawBlock = !1), {
        type: this.options.sanitize ? "text" : "html",
        raw: n[0],
        inLink: this.lexer.state.inLink,
        inRawBlock: this.lexer.state.inRawBlock,
        text: this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(n[0]) : M1(n[0]) : n[0]
      };
  }
  link(e) {
    const n = this.rules.inline.link.exec(e);
    if (n) {
      const i = n[2].trim();
      if (!this.options.pedantic && /^</.test(i)) {
        if (!/>$/.test(i))
          return;
        const o = Q5(i.slice(0, -1), "\\");
        if ((i.length - o.length) % 2 === 0)
          return;
      } else {
        const o = xI(n[2], "()");
        if (o > -1) {
          const L = (n[0].indexOf("!") === 0 ? 5 : 4) + n[1].length + o;
          n[2] = n[2].substring(0, o), n[0] = n[0].substring(0, L).trim(), n[3] = "";
        }
      }
      let s = n[2], r = "";
      if (this.options.pedantic) {
        const o = /^([^'"]*[^\s])\s+(['"])(.*)\2/.exec(s);
        o && (s = o[1], r = o[3]);
      } else
        r = n[3] ? n[3].slice(1, -1) : "";
      return s = s.trim(), /^</.test(s) && (this.options.pedantic && !/>$/.test(i) ? s = s.slice(1) : s = s.slice(1, -1)), fs(n, {
        href: s && s.replace(this.rules.inline._escapes, "$1"),
        title: r && r.replace(this.rules.inline._escapes, "$1")
      }, n[0], this.lexer);
    }
  }
  reflink(e, n) {
    let i;
    if ((i = this.rules.inline.reflink.exec(e)) || (i = this.rules.inline.nolink.exec(e))) {
      let s = (i[2] || i[1]).replace(/\s+/g, " ");
      if (s = n[s.toLowerCase()], !s || !s.href) {
        const r = i[0].charAt(0);
        return {
          type: "text",
          raw: r,
          text: r
        };
      }
      return fs(i, s, i[0], this.lexer);
    }
  }
  emStrong(e, n, i = "") {
    let s = this.rules.inline.emStrong.lDelim.exec(e);
    if (!s || s[3] && i.match(/[\p{L}\p{N}]/u))
      return;
    const r = s[1] || s[2] || "";
    if (!r || r && (i === "" || this.rules.inline.punctuation.exec(i))) {
      const o = s[0].length - 1;
      let l, L, a = o, C = 0;
      const c = s[0][0] === "*" ? this.rules.inline.emStrong.rDelimAst : this.rules.inline.emStrong.rDelimUnd;
      for (c.lastIndex = 0, n = n.slice(-1 * e.length + o); (s = c.exec(n)) != null; ) {
        if (l = s[1] || s[2] || s[3] || s[4] || s[5] || s[6], !l)
          continue;
        if (L = l.length, s[3] || s[4]) {
          a += L;
          continue;
        } else if ((s[5] || s[6]) && o % 3 && !((o + L) % 3)) {
          C += L;
          continue;
        }
        if (a -= L, a > 0)
          continue;
        if (L = Math.min(L, L + a + C), Math.min(o, L) % 2) {
          const d = e.slice(1, o + s.index + L);
          return {
            type: "em",
            raw: e.slice(0, o + s.index + L + 1),
            text: d,
            tokens: this.lexer.inlineTokens(d, [])
          };
        }
        const h = e.slice(2, o + s.index + L - 1);
        return {
          type: "strong",
          raw: e.slice(0, o + s.index + L + 1),
          text: h,
          tokens: this.lexer.inlineTokens(h, [])
        };
      }
    }
  }
  codespan(e) {
    const n = this.rules.inline.code.exec(e);
    if (n) {
      let i = n[2].replace(/\n/g, " ");
      const s = /[^ ]/.test(i), r = /^ /.test(i) && / $/.test(i);
      return s && r && (i = i.substring(1, i.length - 1)), i = M1(i, !0), {
        type: "codespan",
        raw: n[0],
        text: i
      };
    }
  }
  br(e) {
    const n = this.rules.inline.br.exec(e);
    if (n)
      return {
        type: "br",
        raw: n[0]
      };
  }
  del(e) {
    const n = this.rules.inline.del.exec(e);
    if (n)
      return {
        type: "del",
        raw: n[0],
        text: n[2],
        tokens: this.lexer.inlineTokens(n[2], [])
      };
  }
  autolink(e, n) {
    const i = this.rules.inline.autolink.exec(e);
    if (i) {
      let s, r;
      return i[2] === "@" ? (s = M1(this.options.mangle ? n(i[1]) : i[1]), r = "mailto:" + s) : (s = M1(i[1]), r = s), {
        type: "link",
        raw: i[0],
        text: s,
        href: r,
        tokens: [
          {
            type: "text",
            raw: s,
            text: s
          }
        ]
      };
    }
  }
  url(e, n) {
    let i;
    if (i = this.rules.inline.url.exec(e)) {
      let s, r;
      if (i[2] === "@")
        s = M1(this.options.mangle ? n(i[0]) : i[0]), r = "mailto:" + s;
      else {
        let o;
        do
          o = i[0], i[0] = this.rules.inline._backpedal.exec(i[0])[0];
        while (o !== i[0]);
        s = M1(i[0]), i[1] === "www." ? r = "http://" + s : r = s;
      }
      return {
        type: "link",
        raw: i[0],
        text: s,
        href: r,
        tokens: [
          {
            type: "text",
            raw: s,
            text: s
          }
        ]
      };
    }
  }
  inlineText(e, n) {
    const i = this.rules.inline.text.exec(e);
    if (i) {
      let s;
      return this.lexer.state.inRawBlock ? s = this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(i[0]) : M1(i[0]) : i[0] : s = M1(this.options.smartypants ? n(i[0]) : i[0]), {
        type: "text",
        raw: i[0],
        text: s
      };
    }
  }
}
const _2 = {
  newline: /^(?: *(?:\n|$))+/,
  code: /^( {4}[^\n]+(?:\n(?: *(?:\n|$))*)?)+/,
  fences: /^ {0,3}(`{3,}(?=[^`\n]*\n)|~{3,})([^\n]*)\n(?:|([\s\S]*?)\n)(?: {0,3}\1[~`]* *(?=\n|$)|$)/,
  hr: /^ {0,3}((?:- *){3,}|(?:_ *){3,}|(?:\* *){3,})(?:\n+|$)/,
  heading: /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/,
  blockquote: /^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/,
  list: /^( {0,3}bull)( [^\n]+?)?(?:\n|$)/,
  html: "^ {0,3}(?:<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?(?:\\?>\\n*|$)|<![A-Z][\\s\\S]*?(?:>\\n*|$)|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n *)+\\n|$)|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$)|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$))",
  def: /^ {0,3}\[(label)\]: *(?:\n *)?<?([^\s>]+)>?(?:(?: +(?:\n *)?| *\n *)(title))? *(?:\n+|$)/,
  table: M8,
  lheading: /^([^\n]+)\n {0,3}(=+|-+) *(?:\n+|$)/,
  // regex template, placeholders will be replaced according to different paragraph
  // interruption rules of commonmark and the original markdown spec:
  _paragraph: /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/,
  text: /^[^\n]+/
};
_2._label = /(?!\s*\])(?:\\.|[^\[\]\\])+/;
_2._title = /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/;
_2.def = t1(_2.def).replace("label", _2._label).replace("title", _2._title).getRegex();
_2.bullet = /(?:[*+-]|\d{1,9}[.)])/;
_2.listItemStart = t1(/^( *)(bull) */).replace("bull", _2.bullet).getRegex();
_2.list = t1(_2.list).replace(/bull/g, _2.bullet).replace("hr", "\\n+(?=\\1?(?:(?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$))").replace("def", "\\n+(?=" + _2.def.source + ")").getRegex();
_2._tag = "address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|section|source|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul";
_2._comment = /<!--(?!-?>)[\s\S]*?(?:-->|$)/;
_2.html = t1(_2.html, "i").replace("comment", _2._comment).replace("tag", _2._tag).replace("attribute", / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex();
_2.paragraph = t1(_2._paragraph).replace("hr", _2.hr).replace("heading", " {0,3}#{1,6} ").replace("|lheading", "").replace("|table", "").replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", _2._tag).getRegex();
_2.blockquote = t1(_2.blockquote).replace("paragraph", _2.paragraph).getRegex();
_2.normal = D3({}, _2);
_2.gfm = D3({}, _2.normal, {
  table: "^ *([^\\n ].*\\|.*)\\n {0,3}(?:\\| *)?(:?-+:? *(?:\\| *:?-+:? *)*)(?:\\| *)?(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)"
  // Cells
});
_2.gfm.table = t1(_2.gfm.table).replace("hr", _2.hr).replace("heading", " {0,3}#{1,6} ").replace("blockquote", " {0,3}>").replace("code", " {4}[^\\n]").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", _2._tag).getRegex();
_2.gfm.paragraph = t1(_2._paragraph).replace("hr", _2.hr).replace("heading", " {0,3}#{1,6} ").replace("|lheading", "").replace("table", _2.gfm.table).replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", _2._tag).getRegex();
_2.pedantic = D3({}, _2.normal, {
  html: t1(
    `^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:"[^"]*"|'[^']*'|\\s[^'"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))`
  ).replace("comment", _2._comment).replace(/tag/g, "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b").getRegex(),
  def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
  heading: /^(#{1,6})(.*)(?:\n+|$)/,
  fences: M8,
  // fences not supported
  paragraph: t1(_2.normal._paragraph).replace("hr", _2.hr).replace("heading", ` *#{1,6} *[^
]`).replace("lheading", _2.lheading).replace("blockquote", " {0,3}>").replace("|fences", "").replace("|list", "").replace("|html", "").getRegex()
});
const C2 = {
  escape: /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/,
  autolink: /^<(scheme:[^\s\x00-\x1f<>]*|email)>/,
  url: M8,
  tag: "^comment|^</[a-zA-Z][\\w:-]*\\s*>|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>",
  // CDATA section
  link: /^!?\[(label)\]\(\s*(href)(?:\s+(title))?\s*\)/,
  reflink: /^!?\[(label)\]\[(ref)\]/,
  nolink: /^!?\[(ref)\](?:\[\])?/,
  reflinkSearch: "reflink|nolink(?!\\()",
  emStrong: {
    lDelim: /^(?:\*+(?:([punct_])|[^\s*]))|^_+(?:([punct*])|([^\s_]))/,
    //        (1) and (2) can only be a Right Delimiter. (3) and (4) can only be Left.  (5) and (6) can be either Left or Right.
    //        () Skip orphan delim inside strong    (1) #***                (2) a***#, a***                   (3) #***a, ***a                 (4) ***#              (5) #***#                 (6) a***a
    rDelimAst: /^[^_*]*?\_\_[^_*]*?\*[^_*]*?(?=\_\_)|[punct_](\*+)(?=[\s]|$)|[^punct*_\s](\*+)(?=[punct_\s]|$)|[punct_\s](\*+)(?=[^punct*_\s])|[\s](\*+)(?=[punct_])|[punct_](\*+)(?=[punct_])|[^punct*_\s](\*+)(?=[^punct*_\s])/,
    rDelimUnd: /^[^_*]*?\*\*[^_*]*?\_[^_*]*?(?=\*\*)|[punct*](\_+)(?=[\s]|$)|[^punct*_\s](\_+)(?=[punct*\s]|$)|[punct*\s](\_+)(?=[^punct*_\s])|[\s](\_+)(?=[punct*])|[punct*](\_+)(?=[punct*])/
    // ^- Not allowed for _
  },
  code: /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/,
  br: /^( {2,}|\\)\n(?!\s*$)/,
  del: M8,
  text: /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/,
  punctuation: /^([\spunctuation])/
};
C2._punctuation = "!\"#$%&'()+\\-.,/:;<=>?@\\[\\]`^{|}~";
C2.punctuation = t1(C2.punctuation).replace(/punctuation/g, C2._punctuation).getRegex();
C2.blockSkip = /\[[^\]]*?\]\([^\)]*?\)|`[^`]*?`|<[^>]*?>/g;
C2.escapedEmSt = /\\\*|\\_/g;
C2._comment = t1(_2._comment).replace("(?:-->|$)", "-->").getRegex();
C2.emStrong.lDelim = t1(C2.emStrong.lDelim).replace(/punct/g, C2._punctuation).getRegex();
C2.emStrong.rDelimAst = t1(C2.emStrong.rDelimAst, "g").replace(/punct/g, C2._punctuation).getRegex();
C2.emStrong.rDelimUnd = t1(C2.emStrong.rDelimUnd, "g").replace(/punct/g, C2._punctuation).getRegex();
C2._escapes = /\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/g;
C2._scheme = /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/;
C2._email = /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/;
C2.autolink = t1(C2.autolink).replace("scheme", C2._scheme).replace("email", C2._email).getRegex();
C2._attribute = /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/;
C2.tag = t1(C2.tag).replace("comment", C2._comment).replace("attribute", C2._attribute).getRegex();
C2._label = /(?:\[(?:\\.|[^\[\]\\])*\]|\\.|`[^`]*`|[^\[\]\\`])*?/;
C2._href = /<(?:\\.|[^\n<>\\])+>|[^\s\x00-\x1f]*/;
C2._title = /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/;
C2.link = t1(C2.link).replace("label", C2._label).replace("href", C2._href).replace("title", C2._title).getRegex();
C2.reflink = t1(C2.reflink).replace("label", C2._label).replace("ref", _2._label).getRegex();
C2.nolink = t1(C2.nolink).replace("ref", _2._label).getRegex();
C2.reflinkSearch = t1(C2.reflinkSearch, "g").replace("reflink", C2.reflink).replace("nolink", C2.nolink).getRegex();
C2.normal = D3({}, C2);
C2.pedantic = D3({}, C2.normal, {
  strong: {
    start: /^__|\*\*/,
    middle: /^__(?=\S)([\s\S]*?\S)__(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,
    endAst: /\*\*(?!\*)/g,
    endUnd: /__(?!_)/g
  },
  em: {
    start: /^_|\*/,
    middle: /^()\*(?=\S)([\s\S]*?\S)\*(?!\*)|^_(?=\S)([\s\S]*?\S)_(?!_)/,
    endAst: /\*(?!\*)/g,
    endUnd: /_(?!_)/g
  },
  link: t1(/^!?\[(label)\]\((.*?)\)/).replace("label", C2._label).getRegex(),
  reflink: t1(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace("label", C2._label).getRegex()
});
C2.gfm = D3({}, C2.normal, {
  escape: t1(C2.escape).replace("])", "~|])").getRegex(),
  _extended_email: /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/,
  url: /^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/,
  _backpedal: /(?:[^?!.,:;*_~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_~)]+(?!$))+/,
  del: /^(~~?)(?=[^\s~])([\s\S]*?[^\s~])\1(?=[^~]|$)/,
  text: /^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/
});
C2.gfm.url = t1(C2.gfm.url, "i").replace("email", C2.gfm._extended_email).getRegex();
C2.breaks = D3({}, C2.gfm, {
  br: t1(C2.br).replace("{2,}", "*").getRegex(),
  text: t1(C2.gfm.text).replace("\\b_", "\\b_| {2,}\\n").replace(/\{2,\}/g, "*").getRegex()
});
function vI(t) {
  return t.replace(/---/g, "—").replace(/--/g, "–").replace(/(^|[-\u2014/(\[{"\s])'/g, "$1‘").replace(/'/g, "’").replace(/(^|[-\u2014/(\[{\u2018\s])"/g, "$1“").replace(/"/g, "”").replace(/\.{3}/g, "…");
}
function ps(t) {
  let e = "", n, i;
  const s = t.length;
  for (n = 0; n < s; n++)
    i = t.charCodeAt(n), Math.random() > 0.5 && (i = "x" + i.toString(16)), e += "&#" + i + ";";
  return e;
}
class p4 {
  constructor(e) {
    this.tokens = [], this.tokens.links = /* @__PURE__ */ Object.create(null), this.options = e || n0, this.options.tokenizer = this.options.tokenizer || new nn(), this.tokenizer = this.options.tokenizer, this.tokenizer.options = this.options, this.tokenizer.lexer = this, this.inlineQueue = [], this.state = {
      inLink: !1,
      inRawBlock: !1,
      top: !0
    };
    const n = {
      block: _2.normal,
      inline: C2.normal
    };
    this.options.pedantic ? (n.block = _2.pedantic, n.inline = C2.pedantic) : this.options.gfm && (n.block = _2.gfm, this.options.breaks ? n.inline = C2.breaks : n.inline = C2.gfm), this.tokenizer.rules = n;
  }
  /**
   * Expose Rules
   */
  static get rules() {
    return {
      block: _2,
      inline: C2
    };
  }
  /**
   * Static Lex Method
   */
  static lex(e, n) {
    return new p4(n).lex(e);
  }
  /**
   * Static Lex Inline Method
   */
  static lexInline(e, n) {
    return new p4(n).inlineTokens(e);
  }
  /**
   * Preprocessing
   */
  lex(e) {
    e = e.replace(/\r\n|\r/g, `
`).replace(/\t/g, "    "), this.blockTokens(e, this.tokens);
    let n;
    for (; n = this.inlineQueue.shift(); )
      this.inlineTokens(n.src, n.tokens);
    return this.tokens;
  }
  /**
   * Lexing
   */
  blockTokens(e, n = []) {
    this.options.pedantic && (e = e.replace(/^ +$/gm, ""));
    let i, s, r, o;
    for (; e; )
      if (!(this.options.extensions && this.options.extensions.block && this.options.extensions.block.some((l) => (i = l.call({ lexer: this }, e, n)) ? (e = e.substring(i.raw.length), n.push(i), !0) : !1))) {
        if (i = this.tokenizer.space(e)) {
          e = e.substring(i.raw.length), i.raw.length === 1 && n.length > 0 ? n[n.length - 1].raw += `
` : n.push(i);
          continue;
        }
        if (i = this.tokenizer.code(e)) {
          e = e.substring(i.raw.length), s = n[n.length - 1], s && (s.type === "paragraph" || s.type === "text") ? (s.raw += `
` + i.raw, s.text += `
` + i.text, this.inlineQueue[this.inlineQueue.length - 1].src = s.text) : n.push(i);
          continue;
        }
        if (i = this.tokenizer.fences(e)) {
          e = e.substring(i.raw.length), n.push(i);
          continue;
        }
        if (i = this.tokenizer.heading(e)) {
          e = e.substring(i.raw.length), n.push(i);
          continue;
        }
        if (i = this.tokenizer.hr(e)) {
          e = e.substring(i.raw.length), n.push(i);
          continue;
        }
        if (i = this.tokenizer.blockquote(e)) {
          e = e.substring(i.raw.length), n.push(i);
          continue;
        }
        if (i = this.tokenizer.list(e)) {
          e = e.substring(i.raw.length), n.push(i);
          continue;
        }
        if (i = this.tokenizer.html(e)) {
          e = e.substring(i.raw.length), n.push(i);
          continue;
        }
        if (i = this.tokenizer.def(e)) {
          e = e.substring(i.raw.length), s = n[n.length - 1], s && (s.type === "paragraph" || s.type === "text") ? (s.raw += `
` + i.raw, s.text += `
` + i.raw, this.inlineQueue[this.inlineQueue.length - 1].src = s.text) : this.tokens.links[i.tag] || (this.tokens.links[i.tag] = {
            href: i.href,
            title: i.title
          });
          continue;
        }
        if (i = this.tokenizer.table(e)) {
          e = e.substring(i.raw.length), n.push(i);
          continue;
        }
        if (i = this.tokenizer.lheading(e)) {
          e = e.substring(i.raw.length), n.push(i);
          continue;
        }
        if (r = e, this.options.extensions && this.options.extensions.startBlock) {
          let l = 1 / 0;
          const L = e.slice(1);
          let a;
          this.options.extensions.startBlock.forEach(function(C) {
            a = C.call({ lexer: this }, L), typeof a == "number" && a >= 0 && (l = Math.min(l, a));
          }), l < 1 / 0 && l >= 0 && (r = e.substring(0, l + 1));
        }
        if (this.state.top && (i = this.tokenizer.paragraph(r))) {
          s = n[n.length - 1], o && s.type === "paragraph" ? (s.raw += `
` + i.raw, s.text += `
` + i.text, this.inlineQueue.pop(), this.inlineQueue[this.inlineQueue.length - 1].src = s.text) : n.push(i), o = r.length !== e.length, e = e.substring(i.raw.length);
          continue;
        }
        if (i = this.tokenizer.text(e)) {
          e = e.substring(i.raw.length), s = n[n.length - 1], s && s.type === "text" ? (s.raw += `
` + i.raw, s.text += `
` + i.text, this.inlineQueue.pop(), this.inlineQueue[this.inlineQueue.length - 1].src = s.text) : n.push(i);
          continue;
        }
        if (e) {
          const l = "Infinite loop on byte: " + e.charCodeAt(0);
          if (this.options.silent) {
            console.error(l);
            break;
          } else
            throw new Error(l);
        }
      }
    return this.state.top = !0, n;
  }
  inline(e, n) {
    this.inlineQueue.push({ src: e, tokens: n });
  }
  /**
   * Lexing/Compiling
   */
  inlineTokens(e, n = []) {
    let i, s, r, o = e, l, L, a;
    if (this.tokens.links) {
      const C = Object.keys(this.tokens.links);
      if (C.length > 0)
        for (; (l = this.tokenizer.rules.inline.reflinkSearch.exec(o)) != null; )
          C.includes(l[0].slice(l[0].lastIndexOf("[") + 1, -1)) && (o = o.slice(0, l.index) + "[" + gs("a", l[0].length - 2) + "]" + o.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex));
    }
    for (; (l = this.tokenizer.rules.inline.blockSkip.exec(o)) != null; )
      o = o.slice(0, l.index) + "[" + gs("a", l[0].length - 2) + "]" + o.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
    for (; (l = this.tokenizer.rules.inline.escapedEmSt.exec(o)) != null; )
      o = o.slice(0, l.index) + "++" + o.slice(this.tokenizer.rules.inline.escapedEmSt.lastIndex);
    for (; e; )
      if (L || (a = ""), L = !1, !(this.options.extensions && this.options.extensions.inline && this.options.extensions.inline.some((C) => (i = C.call({ lexer: this }, e, n)) ? (e = e.substring(i.raw.length), n.push(i), !0) : !1))) {
        if (i = this.tokenizer.escape(e)) {
          e = e.substring(i.raw.length), n.push(i);
          continue;
        }
        if (i = this.tokenizer.tag(e)) {
          e = e.substring(i.raw.length), s = n[n.length - 1], s && i.type === "text" && s.type === "text" ? (s.raw += i.raw, s.text += i.text) : n.push(i);
          continue;
        }
        if (i = this.tokenizer.link(e)) {
          e = e.substring(i.raw.length), n.push(i);
          continue;
        }
        if (i = this.tokenizer.reflink(e, this.tokens.links)) {
          e = e.substring(i.raw.length), s = n[n.length - 1], s && i.type === "text" && s.type === "text" ? (s.raw += i.raw, s.text += i.text) : n.push(i);
          continue;
        }
        if (i = this.tokenizer.emStrong(e, o, a)) {
          e = e.substring(i.raw.length), n.push(i);
          continue;
        }
        if (i = this.tokenizer.codespan(e)) {
          e = e.substring(i.raw.length), n.push(i);
          continue;
        }
        if (i = this.tokenizer.br(e)) {
          e = e.substring(i.raw.length), n.push(i);
          continue;
        }
        if (i = this.tokenizer.del(e)) {
          e = e.substring(i.raw.length), n.push(i);
          continue;
        }
        if (i = this.tokenizer.autolink(e, ps)) {
          e = e.substring(i.raw.length), n.push(i);
          continue;
        }
        if (!this.state.inLink && (i = this.tokenizer.url(e, ps))) {
          e = e.substring(i.raw.length), n.push(i);
          continue;
        }
        if (r = e, this.options.extensions && this.options.extensions.startInline) {
          let C = 1 / 0;
          const c = e.slice(1);
          let h;
          this.options.extensions.startInline.forEach(function(d) {
            h = d.call({ lexer: this }, c), typeof h == "number" && h >= 0 && (C = Math.min(C, h));
          }), C < 1 / 0 && C >= 0 && (r = e.substring(0, C + 1));
        }
        if (i = this.tokenizer.inlineText(r, vI)) {
          e = e.substring(i.raw.length), i.raw.slice(-1) !== "_" && (a = i.raw.slice(-1)), L = !0, s = n[n.length - 1], s && s.type === "text" ? (s.raw += i.raw, s.text += i.text) : n.push(i);
          continue;
        }
        if (e) {
          const C = "Infinite loop on byte: " + e.charCodeAt(0);
          if (this.options.silent) {
            console.error(C);
            break;
          } else
            throw new Error(C);
        }
      }
    return n;
  }
}
class sn {
  constructor(e) {
    this.options = e || n0;
  }
  code(e, n, i) {
    const s = (n || "").match(/\S*/)[0];
    if (this.options.highlight) {
      const r = this.options.highlight(e, s);
      r != null && r !== e && (i = !0, e = r);
    }
    return e = e.replace(/\n$/, "") + `
`, s ? '<pre><code class="' + this.options.langPrefix + M1(s, !0) + '">' + (i ? e : M1(e, !0)) + `</code></pre>
` : "<pre><code>" + (i ? e : M1(e, !0)) + `</code></pre>
`;
  }
  blockquote(e) {
    return `<blockquote>
` + e + `</blockquote>
`;
  }
  html(e) {
    return e;
  }
  heading(e, n, i, s) {
    return this.options.headerIds ? "<h" + n + ' id="' + this.options.headerPrefix + s.slug(i) + '">' + e + "</h" + n + `>
` : "<h" + n + ">" + e + "</h" + n + `>
`;
  }
  hr() {
    return this.options.xhtml ? `<hr/>
` : `<hr>
`;
  }
  list(e, n, i) {
    const s = n ? "ol" : "ul", r = n && i !== 1 ? ' start="' + i + '"' : "";
    return "<" + s + r + `>
` + e + "</" + s + `>
`;
  }
  listitem(e) {
    return "<li>" + e + `</li>
`;
  }
  checkbox(e) {
    return "<input " + (e ? 'checked="" ' : "") + 'disabled="" type="checkbox"' + (this.options.xhtml ? " /" : "") + "> ";
  }
  paragraph(e) {
    return "<p>" + e + `</p>
`;
  }
  table(e, n) {
    return n && (n = "<tbody>" + n + "</tbody>"), `<table>
<thead>
` + e + `</thead>
` + n + `</table>
`;
  }
  tablerow(e) {
    return `<tr>
` + e + `</tr>
`;
  }
  tablecell(e, n) {
    const i = n.header ? "th" : "td";
    return (n.align ? "<" + i + ' align="' + n.align + '">' : "<" + i + ">") + e + "</" + i + `>
`;
  }
  // span level renderer
  strong(e) {
    return "<strong>" + e + "</strong>";
  }
  em(e) {
    return "<em>" + e + "</em>";
  }
  codespan(e) {
    return "<code>" + e + "</code>";
  }
  br() {
    return this.options.xhtml ? "<br/>" : "<br>";
  }
  del(e) {
    return "<del>" + e + "</del>";
  }
  link(e, n, i) {
    if (e = hs(this.options.sanitize, this.options.baseUrl, e), e === null)
      return i;
    let s = '<a href="' + M1(e) + '"';
    return n && (s += ' title="' + n + '"'), s += ">" + i + "</a>", s;
  }
  image(e, n, i) {
    if (e = hs(this.options.sanitize, this.options.baseUrl, e), e === null)
      return i;
    let s = '<img src="' + e + '" alt="' + i + '"';
    return n && (s += ' title="' + n + '"'), s += this.options.xhtml ? "/>" : ">", s;
  }
  text(e) {
    return e;
  }
}
class Ra {
  // no need for block level renderers
  strong(e) {
    return e;
  }
  em(e) {
    return e;
  }
  codespan(e) {
    return e;
  }
  del(e) {
    return e;
  }
  html(e) {
    return e;
  }
  text(e) {
    return e;
  }
  link(e, n, i) {
    return "" + i;
  }
  image(e, n, i) {
    return "" + i;
  }
  br() {
    return "";
  }
}
class ya {
  constructor() {
    this.seen = {};
  }
  serialize(e) {
    return e.toLowerCase().trim().replace(/<[!\/a-z].*?>/ig, "").replace(/[\u2000-\u206F\u2E00-\u2E7F\\'!"#$%&()*+,./:;<=>?@[\]^`{|}~]/g, "").replace(/\s/g, "-");
  }
  /**
   * Finds the next safe (unique) slug to use
   */
  getNextSafeSlug(e, n) {
    let i = e, s = 0;
    if (this.seen.hasOwnProperty(i)) {
      s = this.seen[e];
      do
        s++, i = e + "-" + s;
      while (this.seen.hasOwnProperty(i));
    }
    return n || (this.seen[e] = s, this.seen[i] = 0), i;
  }
  /**
   * Convert string to unique id
   * @param {object} options
   * @param {boolean} options.dryrun Generates the next unique slug without updating the internal accumulator.
   */
  slug(e, n = {}) {
    const i = this.serialize(e);
    return this.getNextSafeSlug(i, n.dryrun);
  }
}
class m4 {
  constructor(e) {
    this.options = e || n0, this.options.renderer = this.options.renderer || new sn(), this.renderer = this.options.renderer, this.renderer.options = this.options, this.textRenderer = new Ra(), this.slugger = new ya();
  }
  /**
   * Static Parse Method
   */
  static parse(e, n) {
    return new m4(n).parse(e);
  }
  /**
   * Static Parse Inline Method
   */
  static parseInline(e, n) {
    return new m4(n).parseInline(e);
  }
  /**
   * Parse Loop
   */
  parse(e, n = !0) {
    let i = "", s, r, o, l, L, a, C, c, h, d, f, x, k, m, g, w, Z, b, z;
    const K = e.length;
    for (s = 0; s < K; s++) {
      if (d = e[s], this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[d.type] && (z = this.options.extensions.renderers[d.type].call({ parser: this }, d), z !== !1 || !["space", "hr", "heading", "code", "table", "blockquote", "list", "html", "paragraph", "text"].includes(d.type))) {
        i += z || "";
        continue;
      }
      switch (d.type) {
        case "space":
          continue;
        case "hr": {
          i += this.renderer.hr();
          continue;
        }
        case "heading": {
          i += this.renderer.heading(
            this.parseInline(d.tokens),
            d.depth,
            va(this.parseInline(d.tokens, this.textRenderer)),
            this.slugger
          );
          continue;
        }
        case "code": {
          i += this.renderer.code(
            d.text,
            d.lang,
            d.escaped
          );
          continue;
        }
        case "table": {
          for (c = "", C = "", l = d.header.length, r = 0; r < l; r++)
            C += this.renderer.tablecell(
              this.parseInline(d.header[r].tokens),
              { header: !0, align: d.align[r] }
            );
          for (c += this.renderer.tablerow(C), h = "", l = d.rows.length, r = 0; r < l; r++) {
            for (a = d.rows[r], C = "", L = a.length, o = 0; o < L; o++)
              C += this.renderer.tablecell(
                this.parseInline(a[o].tokens),
                { header: !1, align: d.align[o] }
              );
            h += this.renderer.tablerow(C);
          }
          i += this.renderer.table(c, h);
          continue;
        }
        case "blockquote": {
          h = this.parse(d.tokens), i += this.renderer.blockquote(h);
          continue;
        }
        case "list": {
          for (f = d.ordered, x = d.start, k = d.loose, l = d.items.length, h = "", r = 0; r < l; r++)
            g = d.items[r], w = g.checked, Z = g.task, m = "", g.task && (b = this.renderer.checkbox(w), k ? g.tokens.length > 0 && g.tokens[0].type === "paragraph" ? (g.tokens[0].text = b + " " + g.tokens[0].text, g.tokens[0].tokens && g.tokens[0].tokens.length > 0 && g.tokens[0].tokens[0].type === "text" && (g.tokens[0].tokens[0].text = b + " " + g.tokens[0].tokens[0].text)) : g.tokens.unshift({
              type: "text",
              text: b
            }) : m += b), m += this.parse(g.tokens, k), h += this.renderer.listitem(m, Z, w);
          i += this.renderer.list(h, f, x);
          continue;
        }
        case "html": {
          i += this.renderer.html(d.text);
          continue;
        }
        case "paragraph": {
          i += this.renderer.paragraph(this.parseInline(d.tokens));
          continue;
        }
        case "text": {
          for (h = d.tokens ? this.parseInline(d.tokens) : d.text; s + 1 < K && e[s + 1].type === "text"; )
            d = e[++s], h += `
` + (d.tokens ? this.parseInline(d.tokens) : d.text);
          i += n ? this.renderer.paragraph(h) : h;
          continue;
        }
        default: {
          const E = 'Token with "' + d.type + '" type was not found.';
          if (this.options.silent) {
            console.error(E);
            return;
          } else
            throw new Error(E);
        }
      }
    }
    return i;
  }
  /**
   * Parse Inline Tokens
   */
  parseInline(e, n) {
    n = n || this.renderer;
    let i = "", s, r, o;
    const l = e.length;
    for (s = 0; s < l; s++) {
      if (r = e[s], this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[r.type] && (o = this.options.extensions.renderers[r.type].call({ parser: this }, r), o !== !1 || !["escape", "html", "link", "image", "strong", "em", "codespan", "br", "del", "text"].includes(r.type))) {
        i += o || "";
        continue;
      }
      switch (r.type) {
        case "escape": {
          i += n.text(r.text);
          break;
        }
        case "html": {
          i += n.html(r.text);
          break;
        }
        case "link": {
          i += n.link(r.href, r.title, this.parseInline(r.tokens, n));
          break;
        }
        case "image": {
          i += n.image(r.href, r.title, r.text);
          break;
        }
        case "strong": {
          i += n.strong(this.parseInline(r.tokens, n));
          break;
        }
        case "em": {
          i += n.em(this.parseInline(r.tokens, n));
          break;
        }
        case "codespan": {
          i += n.codespan(r.text);
          break;
        }
        case "br": {
          i += n.br();
          break;
        }
        case "del": {
          i += n.del(this.parseInline(r.tokens, n));
          break;
        }
        case "text": {
          i += n.text(r.text);
          break;
        }
        default: {
          const L = 'Token with "' + r.type + '" type was not found.';
          if (this.options.silent) {
            console.error(L);
            return;
          } else
            throw new Error(L);
        }
      }
    }
    return i;
  }
}
function M2(t, e, n) {
  if (typeof t > "u" || t === null)
    throw new Error("marked(): input parameter is undefined or null");
  if (typeof t != "string")
    throw new Error("marked(): input parameter is of type " + Object.prototype.toString.call(t) + ", string expected");
  if (typeof e == "function" && (n = e, e = null), e = D3({}, M2.defaults, e || {}), Ma(e), n) {
    const i = e.highlight;
    let s;
    try {
      s = p4.lex(t, e);
    } catch (l) {
      return n(l);
    }
    const r = function(l) {
      let L;
      if (!l)
        try {
          e.walkTokens && M2.walkTokens(s, e.walkTokens), L = m4.parse(s, e);
        } catch (a) {
          l = a;
        }
      return e.highlight = i, l ? n(l) : n(null, L);
    };
    if (!i || i.length < 3 || (delete e.highlight, !s.length))
      return r();
    let o = 0;
    M2.walkTokens(s, function(l) {
      l.type === "code" && (o++, setTimeout(() => {
        i(l.text, l.lang, function(L, a) {
          if (L)
            return r(L);
          a != null && a !== l.text && (l.text = a, l.escaped = !0), o--, o === 0 && r();
        });
      }, 0));
    }), o === 0 && r();
    return;
  }
  try {
    const i = p4.lex(t, e);
    return e.walkTokens && M2.walkTokens(i, e.walkTokens), m4.parse(i, e);
  } catch (i) {
    if (i.message += `
Please report this to https://github.com/markedjs/marked.`, e.silent)
      return "<p>An error occurred:</p><pre>" + M1(i.message + "", !0) + "</pre>";
    throw i;
  }
}
M2.options = M2.setOptions = function(t) {
  return D3(M2.defaults, t), oI(M2.defaults), M2;
};
M2.getDefaults = _a;
M2.defaults = n0;
M2.use = function(...t) {
  const e = D3({}, ...t), n = M2.defaults.extensions || { renderers: {}, childTokens: {} };
  let i;
  t.forEach((s) => {
    if (s.extensions && (i = !0, s.extensions.forEach((r) => {
      if (!r.name)
        throw new Error("extension name required");
      if (r.renderer) {
        const o = n.renderers ? n.renderers[r.name] : null;
        o ? n.renderers[r.name] = function(...l) {
          let L = r.renderer.apply(this, l);
          return L === !1 && (L = o.apply(this, l)), L;
        } : n.renderers[r.name] = r.renderer;
      }
      if (r.tokenizer) {
        if (!r.level || r.level !== "block" && r.level !== "inline")
          throw new Error("extension level must be 'block' or 'inline'");
        n[r.level] ? n[r.level].unshift(r.tokenizer) : n[r.level] = [r.tokenizer], r.start && (r.level === "block" ? n.startBlock ? n.startBlock.push(r.start) : n.startBlock = [r.start] : r.level === "inline" && (n.startInline ? n.startInline.push(r.start) : n.startInline = [r.start]));
      }
      r.childTokens && (n.childTokens[r.name] = r.childTokens);
    })), s.renderer) {
      const r = M2.defaults.renderer || new sn();
      for (const o in s.renderer) {
        const l = r[o];
        r[o] = (...L) => {
          let a = s.renderer[o].apply(r, L);
          return a === !1 && (a = l.apply(r, L)), a;
        };
      }
      e.renderer = r;
    }
    if (s.tokenizer) {
      const r = M2.defaults.tokenizer || new nn();
      for (const o in s.tokenizer) {
        const l = r[o];
        r[o] = (...L) => {
          let a = s.tokenizer[o].apply(r, L);
          return a === !1 && (a = l.apply(r, L)), a;
        };
      }
      e.tokenizer = r;
    }
    if (s.walkTokens) {
      const r = M2.defaults.walkTokens;
      e.walkTokens = function(o) {
        s.walkTokens.call(this, o), r && r.call(this, o);
      };
    }
    i && (e.extensions = n), M2.setOptions(e);
  });
};
M2.walkTokens = function(t, e) {
  for (const n of t)
    switch (e.call(M2, n), n.type) {
      case "table": {
        for (const i of n.header)
          M2.walkTokens(i.tokens, e);
        for (const i of n.rows)
          for (const s of i)
            M2.walkTokens(s.tokens, e);
        break;
      }
      case "list": {
        M2.walkTokens(n.items, e);
        break;
      }
      default:
        M2.defaults.extensions && M2.defaults.extensions.childTokens && M2.defaults.extensions.childTokens[n.type] ? M2.defaults.extensions.childTokens[n.type].forEach(function(i) {
          M2.walkTokens(n[i], e);
        }) : n.tokens && M2.walkTokens(n.tokens, e);
    }
};
M2.parseInline = function(t, e) {
  if (typeof t > "u" || t === null)
    throw new Error("marked.parseInline(): input parameter is undefined or null");
  if (typeof t != "string")
    throw new Error("marked.parseInline(): input parameter is of type " + Object.prototype.toString.call(t) + ", string expected");
  e = D3({}, M2.defaults, e || {}), Ma(e);
  try {
    const n = p4.lexInline(t, e);
    return e.walkTokens && M2.walkTokens(n, e.walkTokens), m4.parseInline(n, e);
  } catch (n) {
    if (n.message += `
Please report this to https://github.com/markedjs/marked.`, e.silent)
      return "<p>An error occurred:</p><pre>" + M1(n.message + "", !0) + "</pre>";
    throw n;
  }
};
M2.Parser = m4;
M2.parser = m4.parse;
M2.Renderer = sn;
M2.TextRenderer = Ra;
M2.Lexer = p4;
M2.lexer = p4.lex;
M2.Tokenizer = nn;
M2.Slugger = ya;
M2.parse = M2;
M2.options;
M2.setOptions;
M2.use;
M2.walkTokens;
M2.parseInline;
m4.parse;
p4.lex;
/*! @license DOMPurify 3.1.5 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.1.5/LICENSE */
const {
  entries: Aa,
  setPrototypeOf: ms,
  isFrozen: MI,
  getPrototypeOf: RI,
  getOwnPropertyDescriptor: yI
} = Object;
let {
  freeze: Y1,
  seal: b3,
  create: Za
} = Object, {
  apply: J6,
  construct: ee
} = typeof Reflect < "u" && Reflect;
Y1 || (Y1 = function(e) {
  return e;
});
b3 || (b3 = function(e) {
  return e;
});
J6 || (J6 = function(e, n, i) {
  return e.apply(n, i);
});
ee || (ee = function(e, n) {
  return new e(...n);
});
const H5 = M3(Array.prototype.forEach), ws = M3(Array.prototype.pop), d0 = M3(Array.prototype.push), X5 = M3(String.prototype.toLowerCase), K7 = M3(String.prototype.toString), xs = M3(String.prototype.match), g0 = M3(String.prototype.replace), AI = M3(String.prototype.indexOf), ZI = M3(String.prototype.trim), E3 = M3(Object.prototype.hasOwnProperty), B1 = M3(RegExp.prototype.test), f0 = kI(TypeError);
function M3(t) {
  return function(e) {
    for (var n = arguments.length, i = new Array(n > 1 ? n - 1 : 0), s = 1; s < n; s++)
      i[s - 1] = arguments[s];
    return J6(t, e, i);
  };
}
function kI(t) {
  return function() {
    for (var e = arguments.length, n = new Array(e), i = 0; i < e; i++)
      n[i] = arguments[i];
    return ee(t, n);
  };
}
function D2(t, e) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : X5;
  ms && ms(t, null);
  let i = e.length;
  for (; i--; ) {
    let s = e[i];
    if (typeof s == "string") {
      const r = n(s);
      r !== s && (MI(e) || (e[i] = r), s = r);
    }
    t[s] = !0;
  }
  return t;
}
function TI(t) {
  for (let e = 0; e < t.length; e++)
    E3(t, e) || (t[e] = null);
  return t;
}
function K4(t) {
  const e = Za(null);
  for (const [n, i] of Aa(t))
    E3(t, n) && (Array.isArray(i) ? e[n] = TI(i) : i && typeof i == "object" && i.constructor === Object ? e[n] = K4(i) : e[n] = i);
  return e;
}
function $5(t, e) {
  for (; t !== null; ) {
    const i = yI(t, e);
    if (i) {
      if (i.get)
        return M3(i.get);
      if (typeof i.value == "function")
        return M3(i.value);
    }
    t = RI(t);
  }
  function n() {
    return null;
  }
  return n;
}
const _s = Y1(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "section", "select", "shadow", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), Y7 = Y1(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), Q7 = Y1(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), SI = Y1(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), X7 = Y1(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), bI = Y1(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), vs = Y1(["#text"]), Ms = Y1(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns", "slot"]), J7 = Y1(["accent-height", "accumulate", "additive", "alignment-baseline", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), Rs = Y1(["accent", "accentunder", "align", "bevelled", "close", "columnsalign", "columnlines", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lspace", "lquote", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), V5 = Y1(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), EI = b3(/\{\{[\w\W]*|[\w\W]*\}\}/gm), II = b3(/<%[\w\W]*|[\w\W]*%>/gm), FI = b3(/\${[\w\W]*}/gm), OI = b3(/^data-[\-\w.\u00B7-\uFFFF]/), NI = b3(/^aria-[\-\w]+$/), ka = b3(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), DI = b3(/^(?:\w+script|data):/i), PI = b3(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), Ta = b3(/^html$/i), BI = b3(/^[a-z][.\w]*(-[.\w]+)+$/i);
var ys = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  MUSTACHE_EXPR: EI,
  ERB_EXPR: II,
  TMPLIT_EXPR: FI,
  DATA_ATTR: OI,
  ARIA_ATTR: NI,
  IS_ALLOWED_URI: ka,
  IS_SCRIPT_OR_DATA: DI,
  ATTR_WHITESPACE: PI,
  DOCTYPE_NAME: Ta,
  CUSTOM_ELEMENT: BI
});
const p0 = {
  element: 1,
  attribute: 2,
  text: 3,
  cdataSection: 4,
  entityReference: 5,
  // Deprecated
  entityNode: 6,
  // Deprecated
  progressingInstruction: 7,
  comment: 8,
  document: 9,
  documentType: 10,
  documentFragment: 11,
  notation: 12
  // Deprecated
}, zI = function() {
  return typeof window > "u" ? null : window;
}, UI = function(e, n) {
  if (typeof e != "object" || typeof e.createPolicy != "function")
    return null;
  let i = null;
  const s = "data-tt-policy-suffix";
  n && n.hasAttribute(s) && (i = n.getAttribute(s));
  const r = "dompurify" + (i ? "#" + i : "");
  try {
    return e.createPolicy(r, {
      createHTML(o) {
        return o;
      },
      createScriptURL(o) {
        return o;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + r + " could not be created."), null;
  }
};
function Sa() {
  let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : zI();
  const e = (f2) => Sa(f2);
  if (e.version = "3.1.5", e.removed = [], !t || !t.document || t.document.nodeType !== p0.document)
    return e.isSupported = !1, e;
  let {
    document: n
  } = t;
  const i = n, s = i.currentScript, {
    DocumentFragment: r,
    HTMLTemplateElement: o,
    Node: l,
    Element: L,
    NodeFilter: a,
    NamedNodeMap: C = t.NamedNodeMap || t.MozNamedAttrMap,
    HTMLFormElement: c,
    DOMParser: h,
    trustedTypes: d
  } = t, f = L.prototype, x = $5(f, "cloneNode"), k = $5(f, "nextSibling"), m = $5(f, "childNodes"), g = $5(f, "parentNode");
  if (typeof o == "function") {
    const f2 = n.createElement("template");
    f2.content && f2.content.ownerDocument && (n = f2.content.ownerDocument);
  }
  let w, Z = "";
  const {
    implementation: b,
    createNodeIterator: z,
    createDocumentFragment: K,
    getElementsByTagName: E
  } = n, {
    importNode: L2
  } = i;
  let t2 = {};
  e.isSupported = typeof Aa == "function" && typeof g == "function" && b && b.createHTMLDocument !== void 0;
  const {
    MUSTACHE_EXPR: u2,
    ERB_EXPR: N2,
    TMPLIT_EXPR: m2,
    DATA_ATTR: P,
    ARIA_ATTR: W2,
    IS_SCRIPT_OR_DATA: $,
    ATTR_WHITESPACE: s2,
    CUSTOM_ELEMENT: g2
  } = ys;
  let {
    IS_ALLOWED_URI: J2
  } = ys, S2 = null;
  const y1 = D2({}, [..._s, ...Y7, ...Q7, ...X7, ...vs]);
  let E2 = null;
  const U = D2({}, [...Ms, ...J7, ...Rs, ...V5]);
  let Q = Object.seal(Za(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), b2 = null, F2 = null, n1 = !0, J1 = !0, w1 = !1, A1 = !0, d1 = !1, p = !0, v = !1, S = !1, D = !1, F = !1, V = !1, J = !1, G = !0, q = !1;
  const W = "user-content-";
  let H = !0, l2 = !1, n2 = {}, r2 = null;
  const A2 = D2({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
  let z2 = null;
  const H2 = D2({}, ["audio", "video", "img", "source", "image", "track"]);
  let Q2 = null;
  const o2 = D2({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), h2 = "http://www.w3.org/1998/Math/MathML", y2 = "http://www.w3.org/2000/svg", Z2 = "http://www.w3.org/1999/xhtml";
  let o1 = Z2, C1 = !1, b1 = null;
  const m5 = D2({}, [h2, y2, Z2], K7);
  let s0 = null;
  const nC = ["application/xhtml+xml", "text/html"], iC = "text/html";
  let v1 = null, w9 = null;
  const sC = n.createElement("form"), Cn = function(M) {
    return M instanceof RegExp || M instanceof Function;
  }, _7 = function() {
    let M = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!(w9 && w9 === M)) {
      if ((!M || typeof M != "object") && (M = {}), M = K4(M), s0 = // eslint-disable-next-line unicorn/prefer-includes
      nC.indexOf(M.PARSER_MEDIA_TYPE) === -1 ? iC : M.PARSER_MEDIA_TYPE, v1 = s0 === "application/xhtml+xml" ? K7 : X5, S2 = E3(M, "ALLOWED_TAGS") ? D2({}, M.ALLOWED_TAGS, v1) : y1, E2 = E3(M, "ALLOWED_ATTR") ? D2({}, M.ALLOWED_ATTR, v1) : U, b1 = E3(M, "ALLOWED_NAMESPACES") ? D2({}, M.ALLOWED_NAMESPACES, K7) : m5, Q2 = E3(M, "ADD_URI_SAFE_ATTR") ? D2(
        K4(o2),
        // eslint-disable-line indent
        M.ADD_URI_SAFE_ATTR,
        // eslint-disable-line indent
        v1
        // eslint-disable-line indent
      ) : o2, z2 = E3(M, "ADD_DATA_URI_TAGS") ? D2(
        K4(H2),
        // eslint-disable-line indent
        M.ADD_DATA_URI_TAGS,
        // eslint-disable-line indent
        v1
        // eslint-disable-line indent
      ) : H2, r2 = E3(M, "FORBID_CONTENTS") ? D2({}, M.FORBID_CONTENTS, v1) : A2, b2 = E3(M, "FORBID_TAGS") ? D2({}, M.FORBID_TAGS, v1) : {}, F2 = E3(M, "FORBID_ATTR") ? D2({}, M.FORBID_ATTR, v1) : {}, n2 = E3(M, "USE_PROFILES") ? M.USE_PROFILES : !1, n1 = M.ALLOW_ARIA_ATTR !== !1, J1 = M.ALLOW_DATA_ATTR !== !1, w1 = M.ALLOW_UNKNOWN_PROTOCOLS || !1, A1 = M.ALLOW_SELF_CLOSE_IN_ATTR !== !1, d1 = M.SAFE_FOR_TEMPLATES || !1, p = M.SAFE_FOR_XML !== !1, v = M.WHOLE_DOCUMENT || !1, F = M.RETURN_DOM || !1, V = M.RETURN_DOM_FRAGMENT || !1, J = M.RETURN_TRUSTED_TYPE || !1, D = M.FORCE_BODY || !1, G = M.SANITIZE_DOM !== !1, q = M.SANITIZE_NAMED_PROPS || !1, H = M.KEEP_CONTENT !== !1, l2 = M.IN_PLACE || !1, J2 = M.ALLOWED_URI_REGEXP || ka, o1 = M.NAMESPACE || Z2, Q = M.CUSTOM_ELEMENT_HANDLING || {}, M.CUSTOM_ELEMENT_HANDLING && Cn(M.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (Q.tagNameCheck = M.CUSTOM_ELEMENT_HANDLING.tagNameCheck), M.CUSTOM_ELEMENT_HANDLING && Cn(M.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (Q.attributeNameCheck = M.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), M.CUSTOM_ELEMENT_HANDLING && typeof M.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements == "boolean" && (Q.allowCustomizedBuiltInElements = M.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), d1 && (J1 = !1), V && (F = !0), n2 && (S2 = D2({}, vs), E2 = [], n2.html === !0 && (D2(S2, _s), D2(E2, Ms)), n2.svg === !0 && (D2(S2, Y7), D2(E2, J7), D2(E2, V5)), n2.svgFilters === !0 && (D2(S2, Q7), D2(E2, J7), D2(E2, V5)), n2.mathMl === !0 && (D2(S2, X7), D2(E2, Rs), D2(E2, V5))), M.ADD_TAGS && (S2 === y1 && (S2 = K4(S2)), D2(S2, M.ADD_TAGS, v1)), M.ADD_ATTR && (E2 === U && (E2 = K4(E2)), D2(E2, M.ADD_ATTR, v1)), M.ADD_URI_SAFE_ATTR && D2(Q2, M.ADD_URI_SAFE_ATTR, v1), M.FORBID_CONTENTS && (r2 === A2 && (r2 = K4(r2)), D2(r2, M.FORBID_CONTENTS, v1)), H && (S2["#text"] = !0), v && D2(S2, ["html", "head", "body"]), S2.table && (D2(S2, ["tbody"]), delete b2.tbody), M.TRUSTED_TYPES_POLICY) {
        if (typeof M.TRUSTED_TYPES_POLICY.createHTML != "function")
          throw f0('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
        if (typeof M.TRUSTED_TYPES_POLICY.createScriptURL != "function")
          throw f0('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
        w = M.TRUSTED_TYPES_POLICY, Z = w.createHTML("");
      } else
        w === void 0 && (w = UI(d, s)), w !== null && typeof Z == "string" && (Z = w.createHTML(""));
      Y1 && Y1(M), w9 = M;
    }
  }, cn = D2({}, ["mi", "mo", "mn", "ms", "mtext"]), un = D2({}, ["foreignobject", "annotation-xml"]), rC = D2({}, ["title", "style", "font", "a", "script"]), hn = D2({}, [...Y7, ...Q7, ...SI]), dn = D2({}, [...X7, ...bI]), oC = function(M) {
    let Y = g(M);
    (!Y || !Y.tagName) && (Y = {
      namespaceURI: o1,
      tagName: "template"
    });
    const d2 = X5(M.tagName), i1 = X5(Y.tagName);
    return b1[M.namespaceURI] ? M.namespaceURI === y2 ? Y.namespaceURI === Z2 ? d2 === "svg" : Y.namespaceURI === h2 ? d2 === "svg" && (i1 === "annotation-xml" || cn[i1]) : !!hn[d2] : M.namespaceURI === h2 ? Y.namespaceURI === Z2 ? d2 === "math" : Y.namespaceURI === y2 ? d2 === "math" && un[i1] : !!dn[d2] : M.namespaceURI === Z2 ? Y.namespaceURI === y2 && !un[i1] || Y.namespaceURI === h2 && !cn[i1] ? !1 : !dn[d2] && (rC[d2] || !hn[d2]) : !!(s0 === "application/xhtml+xml" && b1[M.namespaceURI]) : !1;
  }, P3 = function(M) {
    d0(e.removed, {
      element: M
    });
    try {
      M.parentNode.removeChild(M);
    } catch {
      M.remove();
    }
  }, w5 = function(M, Y) {
    try {
      d0(e.removed, {
        attribute: Y.getAttributeNode(M),
        from: Y
      });
    } catch {
      d0(e.removed, {
        attribute: null,
        from: Y
      });
    }
    if (Y.removeAttribute(M), M === "is" && !E2[M])
      if (F || V)
        try {
          P3(Y);
        } catch {
        }
      else
        try {
          Y.setAttribute(M, "");
        } catch {
        }
  }, gn = function(M) {
    let Y = null, d2 = null;
    if (D)
      M = "<remove></remove>" + M;
    else {
      const Z1 = xs(M, /^[\r\n\t ]+/);
      d2 = Z1 && Z1[0];
    }
    s0 === "application/xhtml+xml" && o1 === Z2 && (M = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + M + "</body></html>");
    const i1 = w ? w.createHTML(M) : M;
    if (o1 === Z2)
      try {
        Y = new h().parseFromString(i1, s0);
      } catch {
      }
    if (!Y || !Y.documentElement) {
      Y = b.createDocument(o1, "template", null);
      try {
        Y.documentElement.innerHTML = C1 ? Z : i1;
      } catch {
      }
    }
    const E1 = Y.body || Y.documentElement;
    return M && d2 && E1.insertBefore(n.createTextNode(d2), E1.childNodes[0] || null), o1 === Z2 ? E.call(Y, v ? "html" : "body")[0] : v ? Y.documentElement : E1;
  }, fn = function(M) {
    return z.call(
      M.ownerDocument || M,
      M,
      // eslint-disable-next-line no-bitwise
      a.SHOW_ELEMENT | a.SHOW_COMMENT | a.SHOW_TEXT | a.SHOW_PROCESSING_INSTRUCTION | a.SHOW_CDATA_SECTION,
      null
    );
  }, pn = function(M) {
    return M instanceof c && (typeof M.nodeName != "string" || typeof M.textContent != "string" || typeof M.removeChild != "function" || !(M.attributes instanceof C) || typeof M.removeAttribute != "function" || typeof M.setAttribute != "function" || typeof M.namespaceURI != "string" || typeof M.insertBefore != "function" || typeof M.hasChildNodes != "function");
  }, mn = function(M) {
    return typeof l == "function" && M instanceof l;
  }, a4 = function(M, Y, d2) {
    t2[M] && H5(t2[M], (i1) => {
      i1.call(e, Y, d2, w9);
    });
  }, wn = function(M) {
    let Y = null;
    if (a4("beforeSanitizeElements", M, null), pn(M))
      return P3(M), !0;
    const d2 = v1(M.nodeName);
    if (a4("uponSanitizeElement", M, {
      tagName: d2,
      allowedTags: S2
    }), M.hasChildNodes() && !mn(M.firstElementChild) && B1(/<[/\w]/g, M.innerHTML) && B1(/<[/\w]/g, M.textContent) || M.nodeType === p0.progressingInstruction || p && M.nodeType === p0.comment && B1(/<[/\w]/g, M.data))
      return P3(M), !0;
    if (!S2[d2] || b2[d2]) {
      if (!b2[d2] && _n(d2) && (Q.tagNameCheck instanceof RegExp && B1(Q.tagNameCheck, d2) || Q.tagNameCheck instanceof Function && Q.tagNameCheck(d2)))
        return !1;
      if (H && !r2[d2]) {
        const i1 = g(M) || M.parentNode, E1 = m(M) || M.childNodes;
        if (E1 && i1) {
          const Z1 = E1.length;
          for (let e3 = Z1 - 1; e3 >= 0; --e3) {
            const B3 = x(E1[e3], !0);
            B3.__removalCount = (M.__removalCount || 0) + 1, i1.insertBefore(B3, k(M));
          }
        }
      }
      return P3(M), !0;
    }
    return M instanceof L && !oC(M) || (d2 === "noscript" || d2 === "noembed" || d2 === "noframes") && B1(/<\/no(script|embed|frames)/i, M.innerHTML) ? (P3(M), !0) : (d1 && M.nodeType === p0.text && (Y = M.textContent, H5([u2, N2, m2], (i1) => {
      Y = g0(Y, i1, " ");
    }), M.textContent !== Y && (d0(e.removed, {
      element: M.cloneNode()
    }), M.textContent = Y)), a4("afterSanitizeElements", M, null), !1);
  }, xn = function(M, Y, d2) {
    if (G && (Y === "id" || Y === "name") && (d2 in n || d2 in sC))
      return !1;
    if (!(J1 && !F2[Y] && B1(P, Y))) {
      if (!(n1 && B1(W2, Y))) {
        if (!E2[Y] || F2[Y]) {
          if (
            // First condition does a very basic check if a) it's basically a valid custom element tagname AND
            // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
            !(_n(M) && (Q.tagNameCheck instanceof RegExp && B1(Q.tagNameCheck, M) || Q.tagNameCheck instanceof Function && Q.tagNameCheck(M)) && (Q.attributeNameCheck instanceof RegExp && B1(Q.attributeNameCheck, Y) || Q.attributeNameCheck instanceof Function && Q.attributeNameCheck(Y)) || // Alternative, second condition checks if it's an `is`-attribute, AND
            // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            Y === "is" && Q.allowCustomizedBuiltInElements && (Q.tagNameCheck instanceof RegExp && B1(Q.tagNameCheck, d2) || Q.tagNameCheck instanceof Function && Q.tagNameCheck(d2)))
          )
            return !1;
        } else if (!Q2[Y]) {
          if (!B1(J2, g0(d2, s2, ""))) {
            if (!((Y === "src" || Y === "xlink:href" || Y === "href") && M !== "script" && AI(d2, "data:") === 0 && z2[M])) {
              if (!(w1 && !B1($, g0(d2, s2, "")))) {
                if (d2)
                  return !1;
              }
            }
          }
        }
      }
    }
    return !0;
  }, _n = function(M) {
    return M !== "annotation-xml" && xs(M, g2);
  }, vn = function(M) {
    a4("beforeSanitizeAttributes", M, null);
    const {
      attributes: Y
    } = M;
    if (!Y)
      return;
    const d2 = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: E2
    };
    let i1 = Y.length;
    for (; i1--; ) {
      const E1 = Y[i1], {
        name: Z1,
        namespaceURI: e3,
        value: B3
      } = E1, r0 = v1(Z1);
      let P1 = Z1 === "value" ? B3 : ZI(B3);
      if (d2.attrName = r0, d2.attrValue = P1, d2.keepAttr = !0, d2.forceKeepAttr = void 0, a4("uponSanitizeAttribute", M, d2), P1 = d2.attrValue, d2.forceKeepAttr || (w5(Z1, M), !d2.keepAttr))
        continue;
      if (!A1 && B1(/\/>/i, P1)) {
        w5(Z1, M);
        continue;
      }
      if (p && B1(/((--!?|])>)|<\/(style|title)/i, P1)) {
        w5(Z1, M);
        continue;
      }
      d1 && H5([u2, N2, m2], (Rn) => {
        P1 = g0(P1, Rn, " ");
      });
      const Mn = v1(M.nodeName);
      if (xn(Mn, r0, P1)) {
        if (q && (r0 === "id" || r0 === "name") && (w5(Z1, M), P1 = W + P1), w && typeof d == "object" && typeof d.getAttributeType == "function" && !e3)
          switch (d.getAttributeType(Mn, r0)) {
            case "TrustedHTML": {
              P1 = w.createHTML(P1);
              break;
            }
            case "TrustedScriptURL": {
              P1 = w.createScriptURL(P1);
              break;
            }
          }
        try {
          e3 ? M.setAttributeNS(e3, Z1, P1) : M.setAttribute(Z1, P1), pn(M) ? P3(M) : ws(e.removed);
        } catch {
        }
      }
    }
    a4("afterSanitizeAttributes", M, null);
  }, lC = function f2(M) {
    let Y = null;
    const d2 = fn(M);
    for (a4("beforeSanitizeShadowDOM", M, null); Y = d2.nextNode(); )
      a4("uponSanitizeShadowNode", Y, null), !wn(Y) && (Y.content instanceof r && f2(Y.content), vn(Y));
    a4("afterSanitizeShadowDOM", M, null);
  };
  return e.sanitize = function(f2) {
    let M = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, Y = null, d2 = null, i1 = null, E1 = null;
    if (C1 = !f2, C1 && (f2 = "<!-->"), typeof f2 != "string" && !mn(f2))
      if (typeof f2.toString == "function") {
        if (f2 = f2.toString(), typeof f2 != "string")
          throw f0("dirty is not a string, aborting");
      } else
        throw f0("toString is not a function");
    if (!e.isSupported)
      return f2;
    if (S || _7(M), e.removed = [], typeof f2 == "string" && (l2 = !1), l2) {
      if (f2.nodeName) {
        const B3 = v1(f2.nodeName);
        if (!S2[B3] || b2[B3])
          throw f0("root node is forbidden and cannot be sanitized in-place");
      }
    } else if (f2 instanceof l)
      Y = gn("<!---->"), d2 = Y.ownerDocument.importNode(f2, !0), d2.nodeType === p0.element && d2.nodeName === "BODY" || d2.nodeName === "HTML" ? Y = d2 : Y.appendChild(d2);
    else {
      if (!F && !d1 && !v && // eslint-disable-next-line unicorn/prefer-includes
      f2.indexOf("<") === -1)
        return w && J ? w.createHTML(f2) : f2;
      if (Y = gn(f2), !Y)
        return F ? null : J ? Z : "";
    }
    Y && D && P3(Y.firstChild);
    const Z1 = fn(l2 ? f2 : Y);
    for (; i1 = Z1.nextNode(); )
      wn(i1) || (i1.content instanceof r && lC(i1.content), vn(i1));
    if (l2)
      return f2;
    if (F) {
      if (V)
        for (E1 = K.call(Y.ownerDocument); Y.firstChild; )
          E1.appendChild(Y.firstChild);
      else
        E1 = Y;
      return (E2.shadowroot || E2.shadowrootmode) && (E1 = L2.call(i, E1, !0)), E1;
    }
    let e3 = v ? Y.outerHTML : Y.innerHTML;
    return v && S2["!doctype"] && Y.ownerDocument && Y.ownerDocument.doctype && Y.ownerDocument.doctype.name && B1(Ta, Y.ownerDocument.doctype.name) && (e3 = "<!DOCTYPE " + Y.ownerDocument.doctype.name + `>
` + e3), d1 && H5([u2, N2, m2], (B3) => {
      e3 = g0(e3, B3, " ");
    }), w && J ? w.createHTML(e3) : e3;
  }, e.setConfig = function() {
    let f2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    _7(f2), S = !0;
  }, e.clearConfig = function() {
    w9 = null, S = !1;
  }, e.isValidAttribute = function(f2, M, Y) {
    w9 || _7({});
    const d2 = v1(f2), i1 = v1(M);
    return xn(d2, i1, Y);
  }, e.addHook = function(f2, M) {
    typeof M == "function" && (t2[f2] = t2[f2] || [], d0(t2[f2], M));
  }, e.removeHook = function(f2) {
    if (t2[f2])
      return ws(t2[f2]);
  }, e.removeHooks = function(f2) {
    t2[f2] && (t2[f2] = []);
  }, e.removeAllHooks = function() {
    t2 = {};
  }, e;
}
var WI = Sa();
function rn(t) {
  return t instanceof Map ? t.clear = t.delete = t.set = function() {
    throw new Error("map is read-only");
  } : t instanceof Set && (t.add = t.clear = t.delete = function() {
    throw new Error("set is read-only");
  }), Object.freeze(t), Object.getOwnPropertyNames(t).forEach(function(e) {
    var n = t[e];
    typeof n == "object" && !Object.isFrozen(n) && rn(n);
  }), t;
}
var ba = rn, HI = rn;
ba.default = HI;
class As {
  /**
   * @param {CompiledMode} mode
   */
  constructor(e) {
    e.data === void 0 && (e.data = {}), this.data = e.data, this.isMatchIgnored = !1;
  }
  ignoreMatch() {
    this.isMatchIgnored = !0;
  }
}
function B9(t) {
  return t.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
}
function E4(t, ...e) {
  const n = /* @__PURE__ */ Object.create(null);
  for (const i in t)
    n[i] = t[i];
  return e.forEach(function(i) {
    for (const s in i)
      n[s] = i[s];
  }), /** @type {T} */
  n;
}
const $I = "</span>", Zs = (t) => !!t.kind;
class VI {
  /**
   * Creates a new HTMLRenderer
   *
   * @param {Tree} parseTree - the parse tree (must support `walk` API)
   * @param {{classPrefix: string}} options
   */
  constructor(e, n) {
    this.buffer = "", this.classPrefix = n.classPrefix, e.walk(this);
  }
  /**
   * Adds texts to the output stream
   *
   * @param {string} text */
  addText(e) {
    this.buffer += B9(e);
  }
  /**
   * Adds a node open to the output stream (if needed)
   *
   * @param {Node} node */
  openNode(e) {
    if (!Zs(e))
      return;
    let n = e.kind;
    e.sublanguage || (n = `${this.classPrefix}${n}`), this.span(n);
  }
  /**
   * Adds a node close to the output stream (if needed)
   *
   * @param {Node} node */
  closeNode(e) {
    Zs(e) && (this.buffer += $I);
  }
  /**
   * returns the accumulated buffer
  */
  value() {
    return this.buffer;
  }
  // helpers
  /**
   * Builds a span element
   *
   * @param {string} className */
  span(e) {
    this.buffer += `<span class="${e}">`;
  }
}
class on {
  constructor() {
    this.rootNode = { children: [] }, this.stack = [this.rootNode];
  }
  get top() {
    return this.stack[this.stack.length - 1];
  }
  get root() {
    return this.rootNode;
  }
  /** @param {Node} node */
  add(e) {
    this.top.children.push(e);
  }
  /** @param {string} kind */
  openNode(e) {
    const n = { kind: e, children: [] };
    this.add(n), this.stack.push(n);
  }
  closeNode() {
    if (this.stack.length > 1)
      return this.stack.pop();
  }
  closeAllNodes() {
    for (; this.closeNode(); )
      ;
  }
  toJSON() {
    return JSON.stringify(this.rootNode, null, 4);
  }
  /**
   * @typedef { import("./html_renderer").Renderer } Renderer
   * @param {Renderer} builder
   */
  walk(e) {
    return this.constructor._walk(e, this.rootNode);
  }
  /**
   * @param {Renderer} builder
   * @param {Node} node
   */
  static _walk(e, n) {
    return typeof n == "string" ? e.addText(n) : n.children && (e.openNode(n), n.children.forEach((i) => this._walk(e, i)), e.closeNode(n)), e;
  }
  /**
   * @param {Node} node
   */
  static _collapse(e) {
    typeof e != "string" && e.children && (e.children.every((n) => typeof n == "string") ? e.children = [e.children.join("")] : e.children.forEach((n) => {
      on._collapse(n);
    }));
  }
}
class GI extends on {
  /**
   * @param {*} options
   */
  constructor(e) {
    super(), this.options = e;
  }
  /**
   * @param {string} text
   * @param {string} kind
   */
  addKeyword(e, n) {
    e !== "" && (this.openNode(n), this.addText(e), this.closeNode());
  }
  /**
   * @param {string} text
   */
  addText(e) {
    e !== "" && this.add(e);
  }
  /**
   * @param {Emitter & {root: DataNode}} emitter
   * @param {string} name
   */
  addSublanguage(e, n) {
    const i = e.root;
    i.kind = n, i.sublanguage = !0, this.add(i);
  }
  toHTML() {
    return new VI(this, this.options).value();
  }
  finalize() {
    return !0;
  }
}
function jI(t) {
  return new RegExp(t.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&"), "m");
}
function j0(t) {
  return t ? typeof t == "string" ? t : t.source : null;
}
function qI(...t) {
  return t.map((n) => j0(n)).join("");
}
function KI(...t) {
  return "(" + t.map((n) => j0(n)).join("|") + ")";
}
function YI(t) {
  return new RegExp(t.toString() + "|").exec("").length - 1;
}
function QI(t, e) {
  const n = t && t.exec(e);
  return n && n.index === 0;
}
const XI = /\[(?:[^\\\]]|\\.)*\]|\(\??|\\([1-9][0-9]*)|\\./;
function JI(t, e = "|") {
  let n = 0;
  return t.map((i) => {
    n += 1;
    const s = n;
    let r = j0(i), o = "";
    for (; r.length > 0; ) {
      const l = XI.exec(r);
      if (!l) {
        o += r;
        break;
      }
      o += r.substring(0, l.index), r = r.substring(l.index + l[0].length), l[0][0] === "\\" && l[1] ? o += "\\" + String(Number(l[1]) + s) : (o += l[0], l[0] === "(" && n++);
    }
    return o;
  }).map((i) => `(${i})`).join(e);
}
const eF = /\b\B/, Ea = "[a-zA-Z]\\w*", ln = "[a-zA-Z_]\\w*", Ln = "\\b\\d+(\\.\\d+)?", Ia = "(-?)(\\b0[xX][a-fA-F0-9]+|(\\b\\d+(\\.\\d*)?|\\.\\d+)([eE][-+]?\\d+)?)", Fa = "\\b(0b[01]+)", tF = "!|!=|!==|%|%=|&|&&|&=|\\*|\\*=|\\+|\\+=|,|-|-=|/=|/|:|;|<<|<<=|<=|<|===|==|=|>>>=|>>=|>=|>>>|>>|>|\\?|\\[|\\{|\\(|\\^|\\^=|\\||\\|=|\\|\\||~", nF = (t = {}) => {
  const e = /^#![ ]*\//;
  return t.binary && (t.begin = qI(
    e,
    /.*\b/,
    t.binary,
    /\b.*/
  )), E4({
    className: "meta",
    begin: e,
    end: /$/,
    relevance: 0,
    /** @type {ModeCallback} */
    "on:begin": (n, i) => {
      n.index !== 0 && i.ignoreMatch();
    }
  }, t);
}, q0 = {
  begin: "\\\\[\\s\\S]",
  relevance: 0
}, iF = {
  className: "string",
  begin: "'",
  end: "'",
  illegal: "\\n",
  contains: [q0]
}, sF = {
  className: "string",
  begin: '"',
  end: '"',
  illegal: "\\n",
  contains: [q0]
}, Oa = {
  begin: /\b(a|an|the|are|I'm|isn't|don't|doesn't|won't|but|just|should|pretty|simply|enough|gonna|going|wtf|so|such|will|you|your|they|like|more)\b/
}, m7 = function(t, e, n = {}) {
  const i = E4(
    {
      className: "comment",
      begin: t,
      end: e,
      contains: []
    },
    n
  );
  return i.contains.push(Oa), i.contains.push({
    className: "doctag",
    begin: "(?:TODO|FIXME|NOTE|BUG|OPTIMIZE|HACK|XXX):",
    relevance: 0
  }), i;
}, rF = m7("//", "$"), oF = m7("/\\*", "\\*/"), lF = m7("#", "$"), LF = {
  className: "number",
  begin: Ln,
  relevance: 0
}, aF = {
  className: "number",
  begin: Ia,
  relevance: 0
}, CF = {
  className: "number",
  begin: Fa,
  relevance: 0
}, cF = {
  className: "number",
  begin: Ln + "(%|em|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc|px|deg|grad|rad|turn|s|ms|Hz|kHz|dpi|dpcm|dppx)?",
  relevance: 0
}, uF = {
  // this outer rule makes sure we actually have a WHOLE regex and not simply
  // an expression such as:
  //
  //     3 / something
  //
  // (which will then blow up when regex's `illegal` sees the newline)
  begin: /(?=\/[^/\n]*\/)/,
  contains: [{
    className: "regexp",
    begin: /\//,
    end: /\/[gimuy]*/,
    illegal: /\n/,
    contains: [
      q0,
      {
        begin: /\[/,
        end: /\]/,
        relevance: 0,
        contains: [q0]
      }
    ]
  }]
}, hF = {
  className: "title",
  begin: Ea,
  relevance: 0
}, dF = {
  className: "title",
  begin: ln,
  relevance: 0
}, gF = {
  // excludes method names from keyword processing
  begin: "\\.\\s*" + ln,
  relevance: 0
}, fF = function(t) {
  return Object.assign(
    t,
    {
      /** @type {ModeCallback} */
      "on:begin": (e, n) => {
        n.data._beginMatch = e[1];
      },
      /** @type {ModeCallback} */
      "on:end": (e, n) => {
        n.data._beginMatch !== e[1] && n.ignoreMatch();
      }
    }
  );
};
var G5 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  MATCH_NOTHING_RE: eF,
  IDENT_RE: Ea,
  UNDERSCORE_IDENT_RE: ln,
  NUMBER_RE: Ln,
  C_NUMBER_RE: Ia,
  BINARY_NUMBER_RE: Fa,
  RE_STARTERS_RE: tF,
  SHEBANG: nF,
  BACKSLASH_ESCAPE: q0,
  APOS_STRING_MODE: iF,
  QUOTE_STRING_MODE: sF,
  PHRASAL_WORDS_MODE: Oa,
  COMMENT: m7,
  C_LINE_COMMENT_MODE: rF,
  C_BLOCK_COMMENT_MODE: oF,
  HASH_COMMENT_MODE: lF,
  NUMBER_MODE: LF,
  C_NUMBER_MODE: aF,
  BINARY_NUMBER_MODE: CF,
  CSS_NUMBER_MODE: cF,
  REGEXP_MODE: uF,
  TITLE_MODE: hF,
  UNDERSCORE_TITLE_MODE: dF,
  METHOD_GUARD: gF,
  END_SAME_AS_BEGIN: fF
});
function pF(t, e) {
  t.input[t.index - 1] === "." && e.ignoreMatch();
}
function mF(t, e) {
  e && t.beginKeywords && (t.begin = "\\b(" + t.beginKeywords.split(" ").join("|") + ")(?!\\.)(?=\\b|\\s)", t.__beforeBegin = pF, t.keywords = t.keywords || t.beginKeywords, delete t.beginKeywords, t.relevance === void 0 && (t.relevance = 0));
}
function wF(t, e) {
  Array.isArray(t.illegal) && (t.illegal = KI(...t.illegal));
}
function xF(t, e) {
  if (t.match) {
    if (t.begin || t.end)
      throw new Error("begin & end are not supported with match");
    t.begin = t.match, delete t.match;
  }
}
function _F(t, e) {
  t.relevance === void 0 && (t.relevance = 1);
}
const vF = [
  "of",
  "and",
  "for",
  "in",
  "not",
  "or",
  "if",
  "then",
  "parent",
  // common variable name
  "list",
  // common variable name
  "value"
  // common variable name
], MF = "keyword";
function Na(t, e, n = MF) {
  const i = {};
  return typeof t == "string" ? s(n, t.split(" ")) : Array.isArray(t) ? s(n, t) : Object.keys(t).forEach(function(r) {
    Object.assign(
      i,
      Na(t[r], e, r)
    );
  }), i;
  function s(r, o) {
    e && (o = o.map((l) => l.toLowerCase())), o.forEach(function(l) {
      const L = l.split("|");
      i[L[0]] = [r, RF(L[0], L[1])];
    });
  }
}
function RF(t, e) {
  return e ? Number(e) : yF(t) ? 0 : 1;
}
function yF(t) {
  return vF.includes(t.toLowerCase());
}
function AF(t, { plugins: e }) {
  function n(l, L) {
    return new RegExp(
      j0(l),
      "m" + (t.case_insensitive ? "i" : "") + (L ? "g" : "")
    );
  }
  class i {
    constructor() {
      this.matchIndexes = {}, this.regexes = [], this.matchAt = 1, this.position = 0;
    }
    // @ts-ignore
    addRule(L, a) {
      a.position = this.position++, this.matchIndexes[this.matchAt] = a, this.regexes.push([a, L]), this.matchAt += YI(L) + 1;
    }
    compile() {
      this.regexes.length === 0 && (this.exec = () => null);
      const L = this.regexes.map((a) => a[1]);
      this.matcherRe = n(JI(L), !0), this.lastIndex = 0;
    }
    /** @param {string} s */
    exec(L) {
      this.matcherRe.lastIndex = this.lastIndex;
      const a = this.matcherRe.exec(L);
      if (!a)
        return null;
      const C = a.findIndex((h, d) => d > 0 && h !== void 0), c = this.matchIndexes[C];
      return a.splice(0, C), Object.assign(a, c);
    }
  }
  class s {
    constructor() {
      this.rules = [], this.multiRegexes = [], this.count = 0, this.lastIndex = 0, this.regexIndex = 0;
    }
    // @ts-ignore
    getMatcher(L) {
      if (this.multiRegexes[L])
        return this.multiRegexes[L];
      const a = new i();
      return this.rules.slice(L).forEach(([C, c]) => a.addRule(C, c)), a.compile(), this.multiRegexes[L] = a, a;
    }
    resumingScanAtSamePosition() {
      return this.regexIndex !== 0;
    }
    considerAll() {
      this.regexIndex = 0;
    }
    // @ts-ignore
    addRule(L, a) {
      this.rules.push([L, a]), a.type === "begin" && this.count++;
    }
    /** @param {string} s */
    exec(L) {
      const a = this.getMatcher(this.regexIndex);
      a.lastIndex = this.lastIndex;
      let C = a.exec(L);
      if (this.resumingScanAtSamePosition() && !(C && C.index === this.lastIndex)) {
        const c = this.getMatcher(0);
        c.lastIndex = this.lastIndex + 1, C = c.exec(L);
      }
      return C && (this.regexIndex += C.position + 1, this.regexIndex === this.count && this.considerAll()), C;
    }
  }
  function r(l) {
    const L = new s();
    return l.contains.forEach((a) => L.addRule(a.begin, { rule: a, type: "begin" })), l.terminatorEnd && L.addRule(l.terminatorEnd, { type: "end" }), l.illegal && L.addRule(l.illegal, { type: "illegal" }), L;
  }
  function o(l, L) {
    const a = (
      /** @type CompiledMode */
      l
    );
    if (l.isCompiled)
      return a;
    [
      // do this early so compiler extensions generally don't have to worry about
      // the distinction between match/begin
      xF
    ].forEach((c) => c(l, L)), t.compilerExtensions.forEach((c) => c(l, L)), l.__beforeBegin = null, [
      mF,
      // do this later so compiler extensions that come earlier have access to the
      // raw array if they wanted to perhaps manipulate it, etc.
      wF,
      // default to 1 relevance if not specified
      _F
    ].forEach((c) => c(l, L)), l.isCompiled = !0;
    let C = null;
    if (typeof l.keywords == "object" && (C = l.keywords.$pattern, delete l.keywords.$pattern), l.keywords && (l.keywords = Na(l.keywords, t.case_insensitive)), l.lexemes && C)
      throw new Error("ERR: Prefer `keywords.$pattern` to `mode.lexemes`, BOTH are not allowed. (see mode reference) ");
    return C = C || l.lexemes || /\w+/, a.keywordPatternRe = n(C, !0), L && (l.begin || (l.begin = /\B|\b/), a.beginRe = n(l.begin), l.endSameAsBegin && (l.end = l.begin), !l.end && !l.endsWithParent && (l.end = /\B|\b/), l.end && (a.endRe = n(l.end)), a.terminatorEnd = j0(l.end) || "", l.endsWithParent && L.terminatorEnd && (a.terminatorEnd += (l.end ? "|" : "") + L.terminatorEnd)), l.illegal && (a.illegalRe = n(
      /** @type {RegExp | string} */
      l.illegal
    )), l.contains || (l.contains = []), l.contains = [].concat(...l.contains.map(function(c) {
      return ZF(c === "self" ? l : c);
    })), l.contains.forEach(function(c) {
      o(
        /** @type Mode */
        c,
        a
      );
    }), l.starts && o(l.starts, L), a.matcher = r(a), a;
  }
  if (t.compilerExtensions || (t.compilerExtensions = []), t.contains && t.contains.includes("self"))
    throw new Error("ERR: contains `self` is not supported at the top-level of a language.  See documentation.");
  return t.classNameAliases = E4(t.classNameAliases || {}), o(
    /** @type Mode */
    t
  );
}
function Da(t) {
  return t ? t.endsWithParent || Da(t.starts) : !1;
}
function ZF(t) {
  return t.variants && !t.cachedVariants && (t.cachedVariants = t.variants.map(function(e) {
    return E4(t, { variants: null }, e);
  })), t.cachedVariants ? t.cachedVariants : Da(t) ? E4(t, { starts: t.starts ? E4(t.starts) : null }) : Object.isFrozen(t) ? E4(t) : t;
}
var kF = "10.7.3";
function TF(t) {
  return !!(t || t === "");
}
function SF(t) {
  const e = {
    props: ["language", "code", "autodetect"],
    data: function() {
      return {
        detectedLanguage: "",
        unknownLanguage: !1
      };
    },
    computed: {
      className() {
        return this.unknownLanguage ? "" : "hljs " + this.detectedLanguage;
      },
      highlighted() {
        if (!this.autoDetect && !t.getLanguage(this.language))
          return console.warn(`The language "${this.language}" you specified could not be found.`), this.unknownLanguage = !0, B9(this.code);
        let i = {};
        return this.autoDetect ? (i = t.highlightAuto(this.code), this.detectedLanguage = i.language) : (i = t.highlight(this.language, this.code, this.ignoreIllegals), this.detectedLanguage = this.language), i.value;
      },
      autoDetect() {
        return !this.language || TF(this.autodetect);
      },
      ignoreIllegals() {
        return !0;
      }
    },
    // this avoids needing to use a whole Vue compilation pipeline just
    // to build Highlight.js
    render(i) {
      return i("pre", {}, [
        i("code", {
          class: this.className,
          domProps: { innerHTML: this.highlighted }
        })
      ]);
    }
    // template: `<pre><code :class="className" v-html="highlighted"></code></pre>`
  };
  return { Component: e, VuePlugin: {
    install(i) {
      i.component("highlightjs", e);
    }
  } };
}
const bF = {
  "after:highlightElement": ({ el: t, result: e, text: n }) => {
    const i = ks(t);
    if (!i.length)
      return;
    const s = document.createElement("div");
    s.innerHTML = e.value, e.value = EF(i, ks(s), n);
  }
};
function te(t) {
  return t.nodeName.toLowerCase();
}
function ks(t) {
  const e = [];
  return function n(i, s) {
    for (let r = i.firstChild; r; r = r.nextSibling)
      r.nodeType === 3 ? s += r.nodeValue.length : r.nodeType === 1 && (e.push({
        event: "start",
        offset: s,
        node: r
      }), s = n(r, s), te(r).match(/br|hr|img|input/) || e.push({
        event: "stop",
        offset: s,
        node: r
      }));
    return s;
  }(t, 0), e;
}
function EF(t, e, n) {
  let i = 0, s = "";
  const r = [];
  function o() {
    return !t.length || !e.length ? t.length ? t : e : t[0].offset !== e[0].offset ? t[0].offset < e[0].offset ? t : e : e[0].event === "start" ? t : e;
  }
  function l(C) {
    function c(h) {
      return " " + h.nodeName + '="' + B9(h.value) + '"';
    }
    s += "<" + te(C) + [].map.call(C.attributes, c).join("") + ">";
  }
  function L(C) {
    s += "</" + te(C) + ">";
  }
  function a(C) {
    (C.event === "start" ? l : L)(C.node);
  }
  for (; t.length || e.length; ) {
    let C = o();
    if (s += B9(n.substring(i, C[0].offset)), i = C[0].offset, C === t) {
      r.reverse().forEach(L);
      do
        a(C.splice(0, 1)[0]), C = o();
      while (C === t && C.length && C[0].offset === i);
      r.reverse().forEach(l);
    } else
      C[0].event === "start" ? r.push(C[0].node) : r.pop(), a(C.splice(0, 1)[0]);
  }
  return s + B9(n.substr(i));
}
const Ts = {}, e6 = (t) => {
  console.error(t);
}, Ss = (t, ...e) => {
  console.log(`WARN: ${t}`, ...e);
}, A3 = (t, e) => {
  Ts[`${t}/${e}`] || (console.log(`Deprecated as of ${t}. ${e}`), Ts[`${t}/${e}`] = !0);
}, t6 = B9, bs = E4, Es = Symbol("nomatch"), IF = function(t) {
  const e = /* @__PURE__ */ Object.create(null), n = /* @__PURE__ */ Object.create(null), i = [];
  let s = !0;
  const r = /(^(<[^>]+>|\t|)+|\n)/gm, o = "Could not find the language '{}', did you forget to load/include a language module?", l = { disableAutodetect: !0, name: "Plain text", contains: [] };
  let L = {
    noHighlightRe: /^(no-?highlight)$/i,
    languageDetectRe: /\blang(?:uage)?-([\w-]+)\b/i,
    classPrefix: "hljs-",
    tabReplace: null,
    useBR: !1,
    languages: null,
    // beta configuration options, subject to change, welcome to discuss
    // https://github.com/highlightjs/highlight.js/issues/1086
    __emitter: GI
  };
  function a(U) {
    return L.noHighlightRe.test(U);
  }
  function C(U) {
    let Q = U.className + " ";
    Q += U.parentNode ? U.parentNode.className : "";
    const b2 = L.languageDetectRe.exec(Q);
    if (b2) {
      const F2 = W2(b2[1]);
      return F2 || (Ss(o.replace("{}", b2[1])), Ss("Falling back to no-highlight mode for this block.", U)), F2 ? b2[1] : "no-highlight";
    }
    return Q.split(/\s+/).find((F2) => a(F2) || W2(F2));
  }
  function c(U, Q, b2, F2) {
    let n1 = "", J1 = "";
    typeof Q == "object" ? (n1 = U, b2 = Q.ignoreIllegals, J1 = Q.language, F2 = void 0) : (A3("10.7.0", "highlight(lang, code, ...args) has been deprecated."), A3("10.7.0", `Please use highlight(code, options) instead.
https://github.com/highlightjs/highlight.js/issues/2277`), J1 = U, n1 = Q);
    const w1 = {
      code: n1,
      language: J1
    };
    S2("before:highlight", w1);
    const A1 = w1.result ? w1.result : h(w1.language, w1.code, b2, F2);
    return A1.code = w1.code, S2("after:highlight", A1), A1;
  }
  function h(U, Q, b2, F2) {
    function n1(o2, h2) {
      const y2 = G.case_insensitive ? h2[0].toLowerCase() : h2[0];
      return Object.prototype.hasOwnProperty.call(o2.keywords, y2) && o2.keywords[y2];
    }
    function J1() {
      if (!H.keywords) {
        n2.addText(r2);
        return;
      }
      let o2 = 0;
      H.keywordPatternRe.lastIndex = 0;
      let h2 = H.keywordPatternRe.exec(r2), y2 = "";
      for (; h2; ) {
        y2 += r2.substring(o2, h2.index);
        const Z2 = n1(H, h2);
        if (Z2) {
          const [o1, C1] = Z2;
          if (n2.addText(y2), y2 = "", A2 += C1, o1.startsWith("_"))
            y2 += h2[0];
          else {
            const b1 = G.classNameAliases[o1] || o1;
            n2.addKeyword(h2[0], b1);
          }
        } else
          y2 += h2[0];
        o2 = H.keywordPatternRe.lastIndex, h2 = H.keywordPatternRe.exec(r2);
      }
      y2 += r2.substr(o2), n2.addText(y2);
    }
    function w1() {
      if (r2 === "")
        return;
      let o2 = null;
      if (typeof H.subLanguage == "string") {
        if (!e[H.subLanguage]) {
          n2.addText(r2);
          return;
        }
        o2 = h(H.subLanguage, r2, !0, l2[H.subLanguage]), l2[H.subLanguage] = /** @type {CompiledMode} */
        o2.top;
      } else
        o2 = f(r2, H.subLanguage.length ? H.subLanguage : null);
      H.relevance > 0 && (A2 += o2.relevance), n2.addSublanguage(o2.emitter, o2.language);
    }
    function A1() {
      H.subLanguage != null ? w1() : J1(), r2 = "";
    }
    function d1(o2) {
      return o2.className && n2.openNode(G.classNameAliases[o2.className] || o2.className), H = Object.create(o2, { parent: { value: H } }), H;
    }
    function p(o2, h2, y2) {
      let Z2 = QI(o2.endRe, y2);
      if (Z2) {
        if (o2["on:end"]) {
          const o1 = new As(o2);
          o2["on:end"](h2, o1), o1.isMatchIgnored && (Z2 = !1);
        }
        if (Z2) {
          for (; o2.endsParent && o2.parent; )
            o2 = o2.parent;
          return o2;
        }
      }
      if (o2.endsWithParent)
        return p(o2.parent, h2, y2);
    }
    function v(o2) {
      return H.matcher.regexIndex === 0 ? (r2 += o2[0], 1) : (Q2 = !0, 0);
    }
    function S(o2) {
      const h2 = o2[0], y2 = o2.rule, Z2 = new As(y2), o1 = [y2.__beforeBegin, y2["on:begin"]];
      for (const C1 of o1)
        if (C1 && (C1(o2, Z2), Z2.isMatchIgnored))
          return v(h2);
      return y2 && y2.endSameAsBegin && (y2.endRe = jI(h2)), y2.skip ? r2 += h2 : (y2.excludeBegin && (r2 += h2), A1(), !y2.returnBegin && !y2.excludeBegin && (r2 = h2)), d1(y2), y2.returnBegin ? 0 : h2.length;
    }
    function D(o2) {
      const h2 = o2[0], y2 = Q.substr(o2.index), Z2 = p(H, o2, y2);
      if (!Z2)
        return Es;
      const o1 = H;
      o1.skip ? r2 += h2 : (o1.returnEnd || o1.excludeEnd || (r2 += h2), A1(), o1.excludeEnd && (r2 = h2));
      do
        H.className && n2.closeNode(), !H.skip && !H.subLanguage && (A2 += H.relevance), H = H.parent;
      while (H !== Z2.parent);
      return Z2.starts && (Z2.endSameAsBegin && (Z2.starts.endRe = Z2.endRe), d1(Z2.starts)), o1.returnEnd ? 0 : h2.length;
    }
    function F() {
      const o2 = [];
      for (let h2 = H; h2 !== G; h2 = h2.parent)
        h2.className && o2.unshift(h2.className);
      o2.forEach((h2) => n2.openNode(h2));
    }
    let V = {};
    function J(o2, h2) {
      const y2 = h2 && h2[0];
      if (r2 += o2, y2 == null)
        return A1(), 0;
      if (V.type === "begin" && h2.type === "end" && V.index === h2.index && y2 === "") {
        if (r2 += Q.slice(h2.index, h2.index + 1), !s) {
          const Z2 = new Error("0 width match regex");
          throw Z2.languageName = U, Z2.badRule = V.rule, Z2;
        }
        return 1;
      }
      if (V = h2, h2.type === "begin")
        return S(h2);
      if (h2.type === "illegal" && !b2) {
        const Z2 = new Error('Illegal lexeme "' + y2 + '" for mode "' + (H.className || "<unnamed>") + '"');
        throw Z2.mode = H, Z2;
      } else if (h2.type === "end") {
        const Z2 = D(h2);
        if (Z2 !== Es)
          return Z2;
      }
      if (h2.type === "illegal" && y2 === "")
        return 1;
      if (H2 > 1e5 && H2 > h2.index * 3)
        throw new Error("potential infinite loop, way more iterations than matches");
      return r2 += y2, y2.length;
    }
    const G = W2(U);
    if (!G)
      throw e6(o.replace("{}", U)), new Error('Unknown language: "' + U + '"');
    const q = AF(G, { plugins: i });
    let W = "", H = F2 || q;
    const l2 = {}, n2 = new L.__emitter(L);
    F();
    let r2 = "", A2 = 0, z2 = 0, H2 = 0, Q2 = !1;
    try {
      for (H.matcher.considerAll(); ; ) {
        H2++, Q2 ? Q2 = !1 : H.matcher.considerAll(), H.matcher.lastIndex = z2;
        const o2 = H.matcher.exec(Q);
        if (!o2)
          break;
        const h2 = Q.substring(z2, o2.index), y2 = J(h2, o2);
        z2 = o2.index + y2;
      }
      return J(Q.substr(z2)), n2.closeAllNodes(), n2.finalize(), W = n2.toHTML(), {
        // avoid possible breakage with v10 clients expecting
        // this to always be an integer
        relevance: Math.floor(A2),
        value: W,
        language: U,
        illegal: !1,
        emitter: n2,
        top: H
      };
    } catch (o2) {
      if (o2.message && o2.message.includes("Illegal"))
        return {
          illegal: !0,
          illegalBy: {
            msg: o2.message,
            context: Q.slice(z2 - 100, z2 + 100),
            mode: o2.mode
          },
          sofar: W,
          relevance: 0,
          value: t6(Q),
          emitter: n2
        };
      if (s)
        return {
          illegal: !1,
          relevance: 0,
          value: t6(Q),
          emitter: n2,
          language: U,
          top: H,
          errorRaised: o2
        };
      throw o2;
    }
  }
  function d(U) {
    const Q = {
      relevance: 0,
      emitter: new L.__emitter(L),
      value: t6(U),
      illegal: !1,
      top: l
    };
    return Q.emitter.addText(U), Q;
  }
  function f(U, Q) {
    Q = Q || L.languages || Object.keys(e);
    const b2 = d(U), F2 = Q.filter(W2).filter(s2).map(
      (d1) => h(d1, U, !1)
    );
    F2.unshift(b2);
    const n1 = F2.sort((d1, p) => {
      if (d1.relevance !== p.relevance)
        return p.relevance - d1.relevance;
      if (d1.language && p.language) {
        if (W2(d1.language).supersetOf === p.language)
          return 1;
        if (W2(p.language).supersetOf === d1.language)
          return -1;
      }
      return 0;
    }), [J1, w1] = n1, A1 = J1;
    return A1.second_best = w1, A1;
  }
  function x(U) {
    return L.tabReplace || L.useBR ? U.replace(r, (Q) => Q === `
` ? L.useBR ? "<br>" : Q : L.tabReplace ? Q.replace(/\t/g, L.tabReplace) : Q) : U;
  }
  function k(U, Q, b2) {
    const F2 = Q ? n[Q] : b2;
    U.classList.add("hljs"), F2 && U.classList.add(F2);
  }
  const m = {
    "before:highlightElement": ({ el: U }) => {
      L.useBR && (U.innerHTML = U.innerHTML.replace(/\n/g, "").replace(/<br[ /]*>/g, `
`));
    },
    "after:highlightElement": ({ result: U }) => {
      L.useBR && (U.value = U.value.replace(/\n/g, "<br>"));
    }
  }, g = /^(<[^>]+>|\t)+/gm, w = {
    "after:highlightElement": ({ result: U }) => {
      L.tabReplace && (U.value = U.value.replace(
        g,
        (Q) => Q.replace(/\t/g, L.tabReplace)
      ));
    }
  };
  function Z(U) {
    let Q = null;
    const b2 = C(U);
    if (a(b2))
      return;
    S2(
      "before:highlightElement",
      { el: U, language: b2 }
    ), Q = U;
    const F2 = Q.textContent, n1 = b2 ? c(F2, { language: b2, ignoreIllegals: !0 }) : f(F2);
    S2("after:highlightElement", { el: U, result: n1, text: F2 }), U.innerHTML = n1.value, k(U, b2, n1.language), U.result = {
      language: n1.language,
      // TODO: remove with version 11.0
      re: n1.relevance,
      relavance: n1.relevance
    }, n1.second_best && (U.second_best = {
      language: n1.second_best.language,
      // TODO: remove with version 11.0
      re: n1.second_best.relevance,
      relavance: n1.second_best.relevance
    });
  }
  function b(U) {
    U.useBR && (A3("10.3.0", "'useBR' will be removed entirely in v11.0"), A3("10.3.0", "Please see https://github.com/highlightjs/highlight.js/issues/2559")), L = bs(L, U);
  }
  const z = () => {
    if (z.called)
      return;
    z.called = !0, A3("10.6.0", "initHighlighting() is deprecated.  Use highlightAll() instead."), document.querySelectorAll("pre code").forEach(Z);
  };
  function K() {
    A3("10.6.0", "initHighlightingOnLoad() is deprecated.  Use highlightAll() instead."), E = !0;
  }
  let E = !1;
  function L2() {
    if (document.readyState === "loading") {
      E = !0;
      return;
    }
    document.querySelectorAll("pre code").forEach(Z);
  }
  function t2() {
    E && L2();
  }
  typeof window < "u" && window.addEventListener && window.addEventListener("DOMContentLoaded", t2, !1);
  function u2(U, Q) {
    let b2 = null;
    try {
      b2 = Q(t);
    } catch (F2) {
      if (e6("Language definition for '{}' could not be registered.".replace("{}", U)), s)
        e6(F2);
      else
        throw F2;
      b2 = l;
    }
    b2.name || (b2.name = U), e[U] = b2, b2.rawDefinition = Q.bind(null, t), b2.aliases && $(b2.aliases, { languageName: U });
  }
  function N2(U) {
    delete e[U];
    for (const Q of Object.keys(n))
      n[Q] === U && delete n[Q];
  }
  function m2() {
    return Object.keys(e);
  }
  function P(U) {
    A3("10.4.0", "requireLanguage will be removed entirely in v11."), A3("10.4.0", "Please see https://github.com/highlightjs/highlight.js/pull/2844");
    const Q = W2(U);
    if (Q)
      return Q;
    throw new Error("The '{}' language is required, but not loaded.".replace("{}", U));
  }
  function W2(U) {
    return U = (U || "").toLowerCase(), e[U] || e[n[U]];
  }
  function $(U, { languageName: Q }) {
    typeof U == "string" && (U = [U]), U.forEach((b2) => {
      n[b2.toLowerCase()] = Q;
    });
  }
  function s2(U) {
    const Q = W2(U);
    return Q && !Q.disableAutodetect;
  }
  function g2(U) {
    U["before:highlightBlock"] && !U["before:highlightElement"] && (U["before:highlightElement"] = (Q) => {
      U["before:highlightBlock"](
        Object.assign({ block: Q.el }, Q)
      );
    }), U["after:highlightBlock"] && !U["after:highlightElement"] && (U["after:highlightElement"] = (Q) => {
      U["after:highlightBlock"](
        Object.assign({ block: Q.el }, Q)
      );
    });
  }
  function J2(U) {
    g2(U), i.push(U);
  }
  function S2(U, Q) {
    const b2 = U;
    i.forEach(function(F2) {
      F2[b2] && F2[b2](Q);
    });
  }
  function y1(U) {
    return A3("10.2.0", "fixMarkup will be removed entirely in v11.0"), A3("10.2.0", "Please see https://github.com/highlightjs/highlight.js/issues/2534"), x(U);
  }
  function E2(U) {
    return A3("10.7.0", "highlightBlock will be removed entirely in v12.0"), A3("10.7.0", "Please use highlightElement now."), Z(U);
  }
  Object.assign(t, {
    highlight: c,
    highlightAuto: f,
    highlightAll: L2,
    fixMarkup: y1,
    highlightElement: Z,
    // TODO: Remove with v12 API
    highlightBlock: E2,
    configure: b,
    initHighlighting: z,
    initHighlightingOnLoad: K,
    registerLanguage: u2,
    unregisterLanguage: N2,
    listLanguages: m2,
    getLanguage: W2,
    registerAliases: $,
    requireLanguage: P,
    autoDetection: s2,
    inherit: bs,
    addPlugin: J2,
    // plugins for frameworks
    vuePlugin: SF(t).VuePlugin
  }), t.debugMode = function() {
    s = !1;
  }, t.safeMode = function() {
    s = !0;
  }, t.versionString = kF;
  for (const U in G5)
    typeof G5[U] == "object" && ba(G5[U]);
  return Object.assign(t, G5), t.addPlugin(m), t.addPlugin(bF), t.addPlugin(w), t;
};
var FF = IF({}), OF = FF;
const L9 = /* @__PURE__ */ s4(OF);
function NF(t) {
  return {
    name: "Plain text",
    aliases: [
      "text",
      "txt"
    ],
    disableAutodetect: !0
  };
}
var DF = NF;
const PF = /* @__PURE__ */ s4(DF), Is = "[A-Za-z$_][0-9A-Za-z$_]*", BF = [
  "as",
  // for exports
  "in",
  "of",
  "if",
  "for",
  "while",
  "finally",
  "var",
  "new",
  "function",
  "do",
  "return",
  "void",
  "else",
  "break",
  "catch",
  "instanceof",
  "with",
  "throw",
  "case",
  "default",
  "try",
  "switch",
  "continue",
  "typeof",
  "delete",
  "let",
  "yield",
  "const",
  "class",
  // JS handles these with a special rule
  // "get",
  // "set",
  "debugger",
  "async",
  "await",
  "static",
  "import",
  "from",
  "export",
  "extends"
], zF = [
  "true",
  "false",
  "null",
  "undefined",
  "NaN",
  "Infinity"
], UF = [
  "Intl",
  "DataView",
  "Number",
  "Math",
  "Date",
  "String",
  "RegExp",
  "Object",
  "Function",
  "Boolean",
  "Error",
  "Symbol",
  "Set",
  "Map",
  "WeakSet",
  "WeakMap",
  "Proxy",
  "Reflect",
  "JSON",
  "Promise",
  "Float64Array",
  "Int16Array",
  "Int32Array",
  "Int8Array",
  "Uint16Array",
  "Uint32Array",
  "Float32Array",
  "Array",
  "Uint8Array",
  "Uint8ClampedArray",
  "ArrayBuffer",
  "BigInt64Array",
  "BigUint64Array",
  "BigInt"
], WF = [
  "EvalError",
  "InternalError",
  "RangeError",
  "ReferenceError",
  "SyntaxError",
  "TypeError",
  "URIError"
], HF = [
  "setInterval",
  "setTimeout",
  "clearInterval",
  "clearTimeout",
  "require",
  "exports",
  "eval",
  "isFinite",
  "isNaN",
  "parseFloat",
  "parseInt",
  "decodeURI",
  "decodeURIComponent",
  "encodeURI",
  "encodeURIComponent",
  "escape",
  "unescape"
], $F = [
  "arguments",
  "this",
  "super",
  "console",
  "window",
  "document",
  "localStorage",
  "module",
  "global"
  // Node.js
], VF = [].concat(
  HF,
  $F,
  UF,
  WF
);
function GF(t) {
  return t ? typeof t == "string" ? t : t.source : null;
}
function Fs(t) {
  return ne("(?=", t, ")");
}
function ne(...t) {
  return t.map((n) => GF(n)).join("");
}
function jF(t) {
  const e = (Z, { after: b }) => {
    const z = "</" + Z[0].slice(1);
    return Z.input.indexOf(z, b) !== -1;
  }, n = Is, i = {
    begin: "<>",
    end: "</>"
  }, s = {
    begin: /<[A-Za-z0-9\\._:-]+/,
    end: /\/[A-Za-z0-9\\._:-]+>|\/>/,
    /**
     * @param {RegExpMatchArray} match
     * @param {CallbackResponse} response
     */
    isTrulyOpeningTag: (Z, b) => {
      const z = Z[0].length + Z.index, K = Z.input[z];
      if (K === "<") {
        b.ignoreMatch();
        return;
      }
      K === ">" && (e(Z, { after: z }) || b.ignoreMatch());
    }
  }, r = {
    $pattern: Is,
    keyword: BF,
    literal: zF,
    built_in: VF
  }, o = "[0-9](_?[0-9])*", l = `\\.(${o})`, L = "0|[1-9](_?[0-9])*|0[0-7]*[89][0-9]*", a = {
    className: "number",
    variants: [
      // DecimalLiteral
      { begin: `(\\b(${L})((${l})|\\.)?|(${l}))[eE][+-]?(${o})\\b` },
      { begin: `\\b(${L})\\b((${l})\\b|\\.)?|(${l})\\b` },
      // DecimalBigIntegerLiteral
      { begin: "\\b(0|[1-9](_?[0-9])*)n\\b" },
      // NonDecimalIntegerLiteral
      { begin: "\\b0[xX][0-9a-fA-F](_?[0-9a-fA-F])*n?\\b" },
      { begin: "\\b0[bB][0-1](_?[0-1])*n?\\b" },
      { begin: "\\b0[oO][0-7](_?[0-7])*n?\\b" },
      // LegacyOctalIntegerLiteral (does not include underscore separators)
      // https://tc39.es/ecma262/#sec-additional-syntax-numeric-literals
      { begin: "\\b0[0-7]+n?\\b" }
    ],
    relevance: 0
  }, C = {
    className: "subst",
    begin: "\\$\\{",
    end: "\\}",
    keywords: r,
    contains: []
    // defined later
  }, c = {
    begin: "html`",
    end: "",
    starts: {
      end: "`",
      returnEnd: !1,
      contains: [
        t.BACKSLASH_ESCAPE,
        C
      ],
      subLanguage: "xml"
    }
  }, h = {
    begin: "css`",
    end: "",
    starts: {
      end: "`",
      returnEnd: !1,
      contains: [
        t.BACKSLASH_ESCAPE,
        C
      ],
      subLanguage: "css"
    }
  }, d = {
    className: "string",
    begin: "`",
    end: "`",
    contains: [
      t.BACKSLASH_ESCAPE,
      C
    ]
  }, x = {
    className: "comment",
    variants: [
      t.COMMENT(
        /\/\*\*(?!\/)/,
        "\\*/",
        {
          relevance: 0,
          contains: [
            {
              className: "doctag",
              begin: "@[A-Za-z]+",
              contains: [
                {
                  className: "type",
                  begin: "\\{",
                  end: "\\}",
                  relevance: 0
                },
                {
                  className: "variable",
                  begin: n + "(?=\\s*(-)|$)",
                  endsParent: !0,
                  relevance: 0
                },
                // eat spaces (not newlines) so we can find
                // types or variables
                {
                  begin: /(?=[^\n])\s/,
                  relevance: 0
                }
              ]
            }
          ]
        }
      ),
      t.C_BLOCK_COMMENT_MODE,
      t.C_LINE_COMMENT_MODE
    ]
  }, k = [
    t.APOS_STRING_MODE,
    t.QUOTE_STRING_MODE,
    c,
    h,
    d,
    a,
    t.REGEXP_MODE
  ];
  C.contains = k.concat({
    // we need to pair up {} inside our subst to prevent
    // it from ending too early by matching another }
    begin: /\{/,
    end: /\}/,
    keywords: r,
    contains: [
      "self"
    ].concat(k)
  });
  const m = [].concat(x, C.contains), g = m.concat([
    // eat recursive parens in sub expressions
    {
      begin: /\(/,
      end: /\)/,
      keywords: r,
      contains: ["self"].concat(m)
    }
  ]), w = {
    className: "params",
    begin: /\(/,
    end: /\)/,
    excludeBegin: !0,
    excludeEnd: !0,
    keywords: r,
    contains: g
  };
  return {
    name: "Javascript",
    aliases: ["js", "jsx", "mjs", "cjs"],
    keywords: r,
    // this will be extended by TypeScript
    exports: { PARAMS_CONTAINS: g },
    illegal: /#(?![$_A-z])/,
    contains: [
      t.SHEBANG({
        label: "shebang",
        binary: "node",
        relevance: 5
      }),
      {
        label: "use_strict",
        className: "meta",
        relevance: 10,
        begin: /^\s*['"]use (strict|asm)['"]/
      },
      t.APOS_STRING_MODE,
      t.QUOTE_STRING_MODE,
      c,
      h,
      d,
      x,
      a,
      {
        // object attr container
        begin: ne(
          /[{,\n]\s*/,
          // we need to look ahead to make sure that we actually have an
          // attribute coming up so we don't steal a comma from a potential
          // "value" container
          //
          // NOTE: this might not work how you think.  We don't actually always
          // enter this mode and stay.  Instead it might merely match `,
          // <comments up next>` and then immediately end after the , because it
          // fails to find any actual attrs. But this still does the job because
          // it prevents the value contain rule from grabbing this instead and
          // prevening this rule from firing when we actually DO have keys.
          Fs(ne(
            // we also need to allow for multiple possible comments inbetween
            // the first key:value pairing
            /(((\/\/.*$)|(\/\*(\*[^/]|[^*])*\*\/))\s*)*/,
            n + "\\s*:"
          ))
        ),
        relevance: 0,
        contains: [
          {
            className: "attr",
            begin: n + Fs("\\s*:"),
            relevance: 0
          }
        ]
      },
      {
        // "value" container
        begin: "(" + t.RE_STARTERS_RE + "|\\b(case|return|throw)\\b)\\s*",
        keywords: "return throw case",
        contains: [
          x,
          t.REGEXP_MODE,
          {
            className: "function",
            // we have to count the parens to make sure we actually have the
            // correct bounding ( ) before the =>.  There could be any number of
            // sub-expressions inside also surrounded by parens.
            begin: "(\\([^()]*(\\([^()]*(\\([^()]*\\)[^()]*)*\\)[^()]*)*\\)|" + t.UNDERSCORE_IDENT_RE + ")\\s*=>",
            returnBegin: !0,
            end: "\\s*=>",
            contains: [
              {
                className: "params",
                variants: [
                  {
                    begin: t.UNDERSCORE_IDENT_RE,
                    relevance: 0
                  },
                  {
                    className: null,
                    begin: /\(\s*\)/,
                    skip: !0
                  },
                  {
                    begin: /\(/,
                    end: /\)/,
                    excludeBegin: !0,
                    excludeEnd: !0,
                    keywords: r,
                    contains: g
                  }
                ]
              }
            ]
          },
          {
            // could be a comma delimited list of params to a function call
            begin: /,/,
            relevance: 0
          },
          {
            className: "",
            begin: /\s/,
            end: /\s*/,
            skip: !0
          },
          {
            // JSX
            variants: [
              { begin: i.begin, end: i.end },
              {
                begin: s.begin,
                // we carefully check the opening tag to see if it truly
                // is a tag and not a false positive
                "on:begin": s.isTrulyOpeningTag,
                end: s.end
              }
            ],
            subLanguage: "xml",
            contains: [
              {
                begin: s.begin,
                end: s.end,
                skip: !0,
                contains: ["self"]
              }
            ]
          }
        ],
        relevance: 0
      },
      {
        className: "function",
        beginKeywords: "function",
        end: /[{;]/,
        excludeEnd: !0,
        keywords: r,
        contains: [
          "self",
          t.inherit(t.TITLE_MODE, { begin: n }),
          w
        ],
        illegal: /%/
      },
      {
        // prevent this from getting swallowed up by function
        // since they appear "function like"
        beginKeywords: "while if switch catch for"
      },
      {
        className: "function",
        // we have to count the parens to make sure we actually have the correct
        // bounding ( ).  There could be any number of sub-expressions inside
        // also surrounded by parens.
        begin: t.UNDERSCORE_IDENT_RE + "\\([^()]*(\\([^()]*(\\([^()]*\\)[^()]*)*\\)[^()]*)*\\)\\s*\\{",
        // end parens
        returnBegin: !0,
        contains: [
          w,
          t.inherit(t.TITLE_MODE, { begin: n })
        ]
      },
      // hack: prevents detection of keywords in some circumstances
      // .keyword()
      // $keyword = x
      {
        variants: [
          { begin: "\\." + n },
          { begin: "\\$" + n }
        ],
        relevance: 0
      },
      {
        // ES6 class
        className: "class",
        beginKeywords: "class",
        end: /[{;=]/,
        excludeEnd: !0,
        illegal: /[:"[\]]/,
        contains: [
          { beginKeywords: "extends" },
          t.UNDERSCORE_TITLE_MODE
        ]
      },
      {
        begin: /\b(?=constructor)/,
        end: /[{;]/,
        excludeEnd: !0,
        contains: [
          t.inherit(t.TITLE_MODE, { begin: n }),
          "self",
          w
        ]
      },
      {
        begin: "(get|set)\\s+(?=" + n + "\\()",
        end: /\{/,
        keywords: "get set",
        contains: [
          t.inherit(t.TITLE_MODE, { begin: n }),
          { begin: /\(\)/ },
          // eat to avoid empty params
          w
        ]
      },
      {
        begin: /\$[(.]/
        // relevance booster for a pattern common to JS libs: `$(something)` and `$.something`
      }
    ]
  };
}
var qF = jF;
const KF = /* @__PURE__ */ s4(qF);
function YF(t) {
  return t ? typeof t == "string" ? t : t.source : null;
}
function QF(...t) {
  return t.map((n) => YF(n)).join("");
}
function XF(t) {
  const e = {}, n = {
    begin: /\$\{/,
    end: /\}/,
    contains: [
      "self",
      {
        begin: /:-/,
        contains: [e]
      }
      // default values
    ]
  };
  Object.assign(e, {
    className: "variable",
    variants: [
      { begin: QF(
        /\$[\w\d#@][\w\d_]*/,
        // negative look-ahead tries to avoid matching patterns that are not
        // Perl at all like $ident$, @ident@, etc.
        "(?![\\w\\d])(?![$])"
      ) },
      n
    ]
  });
  const i = {
    className: "subst",
    begin: /\$\(/,
    end: /\)/,
    contains: [t.BACKSLASH_ESCAPE]
  }, s = {
    begin: /<<-?\s*(?=\w+)/,
    starts: {
      contains: [
        t.END_SAME_AS_BEGIN({
          begin: /(\w+)/,
          end: /(\w+)/,
          className: "string"
        })
      ]
    }
  }, r = {
    className: "string",
    begin: /"/,
    end: /"/,
    contains: [
      t.BACKSLASH_ESCAPE,
      e,
      i
    ]
  };
  i.contains.push(r);
  const o = {
    className: "",
    begin: /\\"/
  }, l = {
    className: "string",
    begin: /'/,
    end: /'/
  }, L = {
    begin: /\$\(\(/,
    end: /\)\)/,
    contains: [
      { begin: /\d+#[0-9a-f]+/, className: "number" },
      t.NUMBER_MODE,
      e
    ]
  }, a = [
    "fish",
    "bash",
    "zsh",
    "sh",
    "csh",
    "ksh",
    "tcsh",
    "dash",
    "scsh"
  ], C = t.SHEBANG({
    binary: `(${a.join("|")})`,
    relevance: 10
  }), c = {
    className: "function",
    begin: /\w[\w\d_]*\s*\(\s*\)\s*\{/,
    returnBegin: !0,
    contains: [t.inherit(t.TITLE_MODE, { begin: /\w[\w\d_]*/ })],
    relevance: 0
  };
  return {
    name: "Bash",
    aliases: ["sh", "zsh"],
    keywords: {
      $pattern: /\b[a-z._-]+\b/,
      keyword: "if then else elif fi for while in do done case esac function",
      literal: "true false",
      built_in: (
        // Shell built-ins
        // http://www.gnu.org/software/bash/manual/html_node/Shell-Builtin-Commands.html
        "break cd continue eval exec exit export getopts hash pwd readonly return shift test times trap umask unset alias bind builtin caller command declare echo enable help let local logout mapfile printf read readarray source type typeset ulimit unalias set shopt autoload bg bindkey bye cap chdir clone comparguments compcall compctl compdescribe compfiles compgroups compquote comptags comptry compvalues dirs disable disown echotc echoti emulate fc fg float functions getcap getln history integer jobs kill limit log noglob popd print pushd pushln rehash sched setcap setopt stat suspend ttyctl unfunction unhash unlimit unsetopt vared wait whence where which zcompile zformat zftp zle zmodload zparseopts zprof zpty zregexparse zsocket zstyle ztcp"
      )
    },
    contains: [
      C,
      // to catch known shells and boost relevancy
      t.SHEBANG(),
      // to catch unknown shells but still highlight the shebang
      c,
      L,
      t.HASH_COMMENT_MODE,
      s,
      r,
      o,
      l,
      e
    ]
  };
}
var JF = XF;
const eO = /* @__PURE__ */ s4(JF);
function tO(t) {
  var e = "true false yes no null", n = "[\\w#;/?:@&=+$,.~*'()[\\]]+", i = {
    className: "attr",
    variants: [
      { begin: "\\w[\\w :\\/.-]*:(?=[ 	]|$)" },
      { begin: '"\\w[\\w :\\/.-]*":(?=[ 	]|$)' },
      // double quoted keys
      { begin: "'\\w[\\w :\\/.-]*':(?=[ 	]|$)" }
      // single quoted keys
    ]
  }, s = {
    className: "template-variable",
    variants: [
      { begin: /\{\{/, end: /\}\}/ },
      // jinja templates Ansible
      { begin: /%\{/, end: /\}/ }
      // Ruby i18n
    ]
  }, r = {
    className: "string",
    relevance: 0,
    variants: [
      { begin: /'/, end: /'/ },
      { begin: /"/, end: /"/ },
      { begin: /\S+/ }
    ],
    contains: [
      t.BACKSLASH_ESCAPE,
      s
    ]
  }, o = t.inherit(r, {
    variants: [
      { begin: /'/, end: /'/ },
      { begin: /"/, end: /"/ },
      { begin: /[^\s,{}[\]]+/ }
    ]
  }), l = "[0-9]{4}(-[0-9][0-9]){0,2}", L = "([Tt \\t][0-9][0-9]?(:[0-9][0-9]){2})?", a = "(\\.[0-9]*)?", C = "([ \\t])*(Z|[-+][0-9][0-9]?(:[0-9][0-9])?)?", c = {
    className: "number",
    begin: "\\b" + l + L + a + C + "\\b"
  }, h = {
    end: ",",
    endsWithParent: !0,
    excludeEnd: !0,
    keywords: e,
    relevance: 0
  }, d = {
    begin: /\{/,
    end: /\}/,
    contains: [h],
    illegal: "\\n",
    relevance: 0
  }, f = {
    begin: "\\[",
    end: "\\]",
    contains: [h],
    illegal: "\\n",
    relevance: 0
  }, x = [
    i,
    {
      className: "meta",
      begin: "^---\\s*$",
      relevance: 10
    },
    {
      // multi line string
      // Blocks start with a | or > followed by a newline
      //
      // Indentation of subsequent lines must be the same to
      // be considered part of the block
      className: "string",
      begin: "[\\|>]([1-9]?[+-])?[ ]*\\n( +)[^ ][^\\n]*\\n(\\2[^\\n]+\\n?)*"
    },
    {
      // Ruby/Rails erb
      begin: "<%[%=-]?",
      end: "[%-]?%>",
      subLanguage: "ruby",
      excludeBegin: !0,
      excludeEnd: !0,
      relevance: 0
    },
    {
      // named tags
      className: "type",
      begin: "!\\w+!" + n
    },
    // https://yaml.org/spec/1.2/spec.html#id2784064
    {
      // verbatim tags
      className: "type",
      begin: "!<" + n + ">"
    },
    {
      // primary tags
      className: "type",
      begin: "!" + n
    },
    {
      // secondary tags
      className: "type",
      begin: "!!" + n
    },
    {
      // fragment id &ref
      className: "meta",
      begin: "&" + t.UNDERSCORE_IDENT_RE + "$"
    },
    {
      // fragment reference *ref
      className: "meta",
      begin: "\\*" + t.UNDERSCORE_IDENT_RE + "$"
    },
    {
      // array listing
      className: "bullet",
      // TODO: remove |$ hack when we have proper look-ahead support
      begin: "-(?=[ ]|$)",
      relevance: 0
    },
    t.HASH_COMMENT_MODE,
    {
      beginKeywords: e,
      keywords: { literal: e }
    },
    c,
    // numbers are any valid C-style number that
    // sit isolated from other words
    {
      className: "number",
      begin: t.C_NUMBER_RE + "\\b",
      relevance: 0
    },
    d,
    f,
    r
  ], k = [...x];
  return k.pop(), k.push(o), h.contains = k, {
    name: "YAML",
    case_insensitive: !0,
    aliases: ["yml"],
    contains: x
  };
}
var nO = tO;
const iO = /* @__PURE__ */ s4(nO);
L9.registerLanguage("plaintext", PF);
L9.registerLanguage("javascript", KF);
L9.registerLanguage("bash", eO);
L9.registerLanguage("yaml", iO);
const sO = {
  codespan(t) {
    let n = /(GET|HEAD|POST|PUT|DELETE|CONNECT|OPTIONS|TRACE|PATCH)\s+(.+)/gi.exec(t);
    return (n == null ? void 0 : n.length) === 3 ? `
          <code class="rest-api">
          <span class="http-method-${n[1].toLowerCase()}">${n[1]}</span>
          <span class="http-path">${n[2]}</span>
          </code>
        ` : `<code>${t}</code>`;
  }
};
M2.setOptions({
  highlight: function(t, e) {
    if (!e)
      return L9.highlightAuto(t).value;
    const n = L9.getLanguage(e) ? e : "plaintext";
    return L9.highlight(n, t).value;
  },
  breaks: !0
});
M2.use({ renderer: sO });
const rO = {
  name: "comment",
  props: ["comment", "commentObj"],
  computed: {
    markedComment() {
      var e, n;
      const t = ((e = this.commentObj) == null ? void 0 : e.text) && M2.parse((n = this.commentObj) == null ? void 0 : n.text) || this.comment && M2.parse(this.comment);
      return WI.sanitize(t);
    },
    commentStyle() {
      var t;
      return (t = this.commentObj) == null ? void 0 : t.commentStyle;
    },
    classNames() {
      var t;
      return (t = this.commentObj) == null ? void 0 : t.commentClassNames;
    }
  }
}, oO = { class: "comments text-skin-comment min-w-[100px] flex text-left opacity-50 hover:opacity-100" }, lO = ["innerHTML"];
function LO(t, e, n, i, s, r) {
  return T(), B("div", oO, [
    _("div", {
      innerHTML: r.markedComment,
      class: v2(r.classNames),
      style: w2(r.commentStyle)
    }, null, 14, lO)
  ]);
}
const p5 = /* @__PURE__ */ K2(rO, [["render", LO], ["__scopeId", "data-v-05f7b74d"]]);
const aO = {
  props: ["collapsed"],
  emits: ["click"]
}, CO = { class: "collapsible-header" }, cO = /* @__PURE__ */ W8('<g id="SVGRepo_bgCarrier" stroke-width="0" data-v-175097b8></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" data-v-175097b8></g><g id="SVGRepo_iconCarrier" data-v-175097b8><line x1="13" y1="2" x2="13" y2="10" data-v-175097b8></line><polyline points="9 7 13 11 17 7" data-v-175097b8></polyline><line x1="13" y1="23" x2="13" y2="15" data-v-175097b8></line><polyline points="9 19 13 15 17 19" data-v-175097b8></polyline></g>', 3), uO = [
  cO
], hO = /* @__PURE__ */ W8('<g id="SVGRepo_bgCarrier" stroke-width="0" data-v-175097b8></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" data-v-175097b8></g><g id="SVGRepo_iconCarrier" data-v-175097b8><line x1="13" y1="1" x2="13" y2="9" data-v-175097b8></line><polyline points="9 5 13 1 17 5" data-v-175097b8></polyline><line x1="13" y1="13" x2="13" y2="13" data-v-175097b8></line><line x1="13" y1="24" x2="13" y2="17" data-v-175097b8></line><polyline points="9 20 13 24 17 20" data-v-175097b8></polyline></g>', 3), dO = [
  hO
];
function gO(t, e, n, i, s, r) {
  return T(), B("div", CO, [
    (T(), B("svg", {
      width: "20px",
      height: "20px",
      class: v2([{ hidden: n.collapsed, expanded: !n.collapsed }, "collapse-button cursor-pointer"]),
      onClick: e[0] || (e[0] = (o) => t.$emit("click", o)),
      viewBox: "0 0 25 25",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      stroke: "currentColor",
      "stroke-width": "1",
      "stroke-linecap": "round",
      "stroke-linejoin": "miter"
    }, uO, 2)),
    (T(), B("svg", {
      width: "20px",
      height: "20px",
      class: v2([{ hidden: !n.collapsed }, "cursor-pointer"]),
      onClick: e[1] || (e[1] = (o) => t.$emit("click", o)),
      viewBox: "0 0 25 25",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      stroke: "currentColor",
      "stroke-width": "1",
      "stroke-linecap": "round",
      "stroke-linejoin": "miter"
    }, dO, 2))
  ]);
}
const fO = /* @__PURE__ */ K2(aO, [["render", gO], ["__scopeId", "data-v-175097b8"]]);
const pO = {
  name: "occurrence",
  props: ["context", "participant", "rtl", "number"],
  data: function() {
    return {
      center: 0,
      collapsed: !1
    };
  },
  computed: {
    ...R3(["centerOf", "messageLayerLeft"]),
    ...q8(["code"]),
    debug() {
      return !!localStorage.zenumlDebug;
    },
    computedCenter: function() {
      try {
        return this.centerOf(this.participant);
      } catch (t) {
        return console.error(t), 0;
      }
    },
    hasAnyStatementsExceptReturn: function() {
      var i;
      let t = this.context.braceBlock();
      if (!t)
        return !1;
      let e = ((i = t.block()) == null ? void 0 : i.stat()) || [], n = e.length;
      return n > 1 ? !0 : n === 1 && e[0].ret() == null;
    }
  },
  // The following code will cause the Block to be created and mounted AFTER the occurrence (and upto DiagramFrame) is updated.
  // Block must be defined globally to ensure that it is rendered in the same time cycle as the whole diagram.
  // components: {
  //   Block: () => import('../../../Block.vue')
  // },
  methods: {
    toggle() {
      this.collapsed = !this.collapsed, d7.$emit("participant_set_top");
    }
  },
  components: { CollapseButton: fO },
  watch: {
    context() {
      this.collapsed && (this.collapsed = !1);
    }
  }
}, Pa = (t) => (r4("data-v-2d5b6cca"), t = t(), o4(), t), mO = ["data-belongs-to", "data-x-offset", "data-debug-center-of"], wO = {
  key: 0,
  class: "absolute w-full left-0 bg-amber-700 h-3 -top-1 flex justify-center items-center"
}, xO = /* @__PURE__ */ Pa(() => /* @__PURE__ */ _("div", { class: "w-px h-full bg-black" }, null, -1)), _O = [
  xO
], vO = {
  key: 1,
  class: "absolute w-full left-0 bg-amber-700 h-3 -bottom-1 flex justify-center items-center"
}, MO = /* @__PURE__ */ Pa(() => /* @__PURE__ */ _("div", { class: "w-px h-full bg-black" }, null, -1)), RO = [
  MO
];
function yO(t, e, n, i, s, r) {
  const o = i2("collapse-button"), l = i2("block");
  return T(), B("div", {
    class: v2(["occurrence min-h-6 shadow-occurrence border-skin-occurrence bg-skin-occurrence rounded-sm border-2 relative left-full", { "right-to-left": n.rtl }]),
    "data-el-type": "occurrence",
    "data-belongs-to": n.participant,
    "data-x-offset": t.center,
    "data-debug-center-of": r.computedCenter
  }, [
    r.debug ? (T(), B("div", wO, _O)) : x2("", !0),
    r.debug ? (T(), B("div", vO, RO)) : x2("", !0),
    r.hasAnyStatementsExceptReturn ? (T(), T2(o, {
      key: 2,
      collapsed: t.collapsed,
      onClick: this.toggle
    }, null, 8, ["collapsed", "onClick"])) : x2("", !0),
    this.context.braceBlock() ? (T(), T2(l, {
      key: 3,
      origin: n.participant,
      context: n.context.braceBlock().block(),
      number: n.number,
      collapsed: t.collapsed
    }, null, 8, ["origin", "context", "number", "collapsed"])) : x2("", !0)
  ], 10, mO);
}
const Ba = /* @__PURE__ */ K2(pO, [["render", yO], ["__scopeId", "data-v-2d5b6cca"]]);
class i0 {
  constructor(e, n, i, s) {
    this.start = { line: e, col: n }, this.stop = { line: i, col: s };
  }
  static from(e) {
    const n = e.start, i = e.stop;
    return new i0(
      n.line,
      n.column,
      i.line,
      i.column + i.text.length
    );
  }
}
class n6 {
  constructor(e, n) {
    this.position = e, this.layers = n;
  }
  /**
   * centerToEdge is used for translateX calculations.
   */
  centerToEdge(e) {
    return e.rightEdgeOfRightWall() - this.centerOfRightWall();
  }
  /**
   * edgeOffset is used for interactionWidth calculations.
   */
  edgeOffset(e) {
    const n = e.position < this.position;
    let i, s;
    n ? (i = e, s = this) : (i = this, s = e);
    const r = i.rightEdgeOfRightWall(), l = s.leftEdgeOfRightWall() - r - lL;
    return n ? l * -1 : l;
  }
  centerOfRightWall() {
    return this.layers <= 1 ? this.position : this.position + S0 * (this.layers - 1);
  }
  rightEdgeOfRightWall() {
    return this.position + S0 * this.layers;
  }
  leftEdgeOfRightWall() {
    return this.layers === 0 ? this.position : this.centerOfRightWall() - S0;
  }
}
const w7 = q2({
  props: {
    origin: {
      type: null,
      required: !0
    },
    context: {
      type: null,
      required: !0
    }
  },
  computed: {
    ...R3(["centerOf"]),
    isSelf: function() {
      return this.source === this.target;
    },
    originLayers: function() {
      return this.depthOnParticipant(this.context, this.origin);
    },
    sourceLayers: function() {
      return this.depthOnParticipant(this.context, this.source);
    },
    targetLayers: function() {
      return this.depthOnParticipant4Stat(this.target);
    },
    anchor2Origin: function() {
      return new n6(this.centerOf(this.origin), this.originLayers);
    },
    anchor2Source: function() {
      return new n6(this.centerOf(this.source), this.sourceLayers);
    },
    anchor2Target: function() {
      return new n6(this.centerOf(this.target), this.targetLayers);
    },
    interactionWidth: function() {
      return Math.abs(this.anchor2Source.edgeOffset(this.anchor2Target));
    },
    translateX: function() {
      const t = this.rightToLeft ? this.anchor2Target : this.anchor2Source;
      return this.anchor2Origin.centerToEdge(t);
    }
  },
  methods: {
    depthOnParticipant(t, e) {
      return t == null ? void 0 : t.getAncestors((n) => this.isSync(n) ? n.Owner() === e : !1).length;
    },
    depthOnParticipant4Stat(t) {
      var n, i;
      if (!(this.context instanceof u.StatContext))
        return 0;
      const e = (i = (n = this.context) == null ? void 0 : n.children) == null ? void 0 : i[0];
      return e ? this.depthOnParticipant(e, t) : 0;
    },
    isSync(t) {
      const e = t instanceof u.MessageContext, n = t instanceof u.CreationContext;
      return e || n;
    }
  }
}), x7 = q2({
  computed: {
    ...R3(["distance2"]),
    rightToLeft() {
      return this.distance2(this.source, this.target) < 0;
    }
  }
});
const AO = {
  name: "creation",
  props: ["context", "comment", "commentObj", "number"],
  mixins: [w7, x7],
  computed: {
    ...R3(["cursor", "onElementClick", "distance2", "centerOf"]),
    ...q8(["numbering"]),
    source() {
      return this.origin;
    },
    target() {
      var t;
      return (t = this.creation) == null ? void 0 : t.Owner();
    },
    creation() {
      var t;
      return (t = this.context) == null ? void 0 : t.creation();
    },
    signature() {
      var t;
      return (t = this.creation) == null ? void 0 : t.SignatureText();
    },
    assignee() {
      var s;
      function t(r) {
        return r && r.getFormattedText() || "";
      }
      let e = (s = this.creation) == null ? void 0 : s.creationBody().assignment();
      if (!e)
        return "";
      let n = t(e.assignee());
      const i = t(e.type());
      return n + (i ? ":" + i : "");
    },
    isCurrent() {
      var t;
      return (t = this.creation) == null ? void 0 : t.isCurrent(this.cursor);
    },
    messageTextStyle() {
      var t;
      return (t = this.commentObj) == null ? void 0 : t.messageStyle;
    },
    messageClassNames() {
      var t;
      return (t = this.commentObj) == null ? void 0 : t.messageClassNames;
    }
  },
  mounted() {
    this.layoutMessageContainer();
  },
  updated() {
    this.layoutMessageContainer();
  },
  methods: {
    layoutMessageContainer() {
      (() => {
        if (!this.$refs.participantPlaceHolder || !this.$refs.messageContainer)
          return;
        const e = this.$refs.participantPlaceHolder.offsetWidth / 2;
        this.$refs.messageContainer.style.width = `calc(100% + ${e + S0}px`, this.rightToLeft && (this.$refs.messageContainer.style.transform = `translateX( ${-(e + S0 + lL)}px`);
      })();
    },
    onClick() {
      this.onElementClick(i0.from(this.context));
    }
  },
  components: {
    Participant: DL,
    Comment: p5,
    Occurrence: Ba,
    Message: h5
  }
}, ZO = ["data-origin", "data-signature"], kO = ["data-to"], TO = {
  ref: "participantPlaceHolder",
  class: "invisible right-0 flex flex-col justify-center flex-shrink-0"
};
function SO(t, e, n, i, s, r) {
  const o = i2("comment"), l = i2("message"), L = i2("participant"), a = i2("occurrence");
  return T(), B("div", {
    "data-origin": t.origin,
    class: v2(["interaction creation sync text-center transform", {
      "right-to-left": t.rightToLeft,
      "-translate-x-full-minus-1": t.rightToLeft,
      highlight: r.isCurrent
    }]),
    onClick: e[0] || (e[0] = s5((...C) => r.onClick && r.onClick(...C), ["stop"])),
    "data-signature": r.signature,
    style: w2({
      transform: "translateX(" + t.translateX + "px)",
      width: t.interactionWidth + "px"
    })
  }, [
    n.comment ? (T(), T2(o, {
      key: 0,
      commentObj: n.commentObj
    }, null, 8, ["commentObj"])) : x2("", !0),
    _("div", {
      ref: "messageContainer",
      "data-type": "creation",
      class: v2(["message-container pointer-events-none flex items-center h-10 relative", { "flex-row-reverse": t.rightToLeft }]),
      "data-to": r.target
    }, [
      N(l, {
        ref: "messageEl",
        class: "invocation w-full transform -translate-y-1/2 pointer-events-auto",
        context: r.creation,
        content: r.signature,
        rtl: t.rightToLeft,
        type: "creation",
        number: n.number,
        classNames: r.messageClassNames,
        textStyle: r.messageTextStyle
      }, null, 8, ["context", "content", "rtl", "number", "classNames", "textStyle"]),
      _("div", TO, [
        N(L, {
          entity: { name: r.target }
        }, null, 8, ["entity"])
      ], 512)
    ], 10, kO),
    N(a, {
      context: r.creation,
      class: "pointer-events-auto",
      participant: r.target,
      number: n.number
    }, null, 8, ["context", "participant", "number"]),
    r.assignee ? (T(), T2(l, {
      key: 1,
      class: "return transform -translate-y-full pointer-events-auto",
      context: r.creation.creationBody().assignment(),
      content: r.assignee,
      rtl: !t.rightToLeft,
      type: "return",
      number: `${n.number}.${r.creation.Statements().length + 1}`,
      classNames: r.messageClassNames,
      textStyle: r.messageTextStyle
    }, null, 8, ["context", "content", "rtl", "number", "classNames", "textStyle"])) : x2("", !0)
  ], 14, ZO);
}
const bO = /* @__PURE__ */ K2(AO, [["render", SO], ["__scopeId", "data-v-94821d68"]]), EO = { class: "name text-left group px-px hover:text-skin-message-hover hover:bg-skin-message-hover relative min-h-[1em] w-full" }, IO = { class: "label" }, FO = { key: 0 }, OO = { class: "assignee px-1" }, NO = /* @__PURE__ */ _("span", null, "=", -1), DO = /* @__PURE__ */ _("svg", {
  class: "arrow text-skin-message-arrow",
  width: "30",
  height: "24"
}, [
  /* @__PURE__ */ _("polyline", {
    class: "line stroke-current fill-none stroke-2",
    points: "0,2 28,2 28,15 14,15"
  }),
  /* @__PURE__ */ _("polyline", {
    class: "head stroke-current fill-current stroke-2",
    points: "18,9 8,15 18,21"
  })
], -1), PO = /* @__PURE__ */ q2({
  __name: "SelfInvocation",
  props: {
    context: null,
    number: null,
    textStyle: null,
    classNames: null
  },
  setup(t) {
    const e = t, { context: n } = g9(e), i = F3(), s = R2(), r = I(() => {
      const a = n == null ? void 0 : n.value.messageBody().func();
      return a ? [a.start.start, a.stop.stop] : [-1, -1];
    }), o = I(() => {
      let a = n == null ? void 0 : n.value.Assignment();
      return a ? a.getText() : "";
    }), l = I(() => n == null ? void 0 : n.value.SignatureText()), L = () => {
      i.getters.onMessageClick(n, s.value);
    };
    return (a, C) => (T(), B("div", {
      class: "self-invocation message leading-none self flex items-start flex-col",
      style: { "border-width": "0" },
      onClick: L,
      ref_key: "messageRef",
      ref: s
    }, [
      _("label", EO, [
        N(N3, { number: t.number }, null, 8, ["number"]),
        _("div", IO, [
          O(o) ? (T(), B("span", FO, [
            _("span", OO, m1(O(o)), 1),
            NO
          ])) : x2("", !0),
          N(g7, {
            style: w2(t.textStyle),
            class: v2(t.classNames),
            labelText: O(l),
            labelPosition: O(r),
            isSelf: !0
          }, null, 8, ["style", "class", "labelText", "labelPosition"])
        ])
      ]),
      DO
    ], 512));
  }
});
const BO = {
  name: "interaction",
  props: ["context", "commentObj", "number"],
  mixins: [w7, x7],
  computed: {
    // add tracker to the mapGetters
    ...R3(["participants", "cursor", "onElementClick", "centerOf"]),
    hasComment() {
      var t;
      return ((t = this.commentObj) == null ? void 0 : t.text) !== "";
    },
    messageTextStyle() {
      var t;
      return (t = this.commentObj) == null ? void 0 : t.messageStyle;
    },
    messageClassNames() {
      var t;
      return (t = this.commentObj) == null ? void 0 : t.messageClassNames;
    },
    message: function() {
      var t;
      return (t = this.context) == null ? void 0 : t.message();
    },
    statements: function() {
      return this.message.Statements();
    },
    source: function() {
      var t;
      return ((t = this.message) == null ? void 0 : t.From()) || K1;
    },
    target: function() {
      var t, e;
      return ((e = (t = this.context) == null ? void 0 : t.message()) == null ? void 0 : e.Owner()) || K1;
    },
    assignee: function() {
      var e;
      let t = (e = this.message) == null ? void 0 : e.Assignment();
      return t ? t.getText() : "";
    },
    signature: function() {
      var t;
      return (t = this.message) == null ? void 0 : t.SignatureText();
    },
    isCurrent: function() {
      var t;
      return (t = this.message) == null ? void 0 : t.isCurrent(this.cursor);
    }
  },
  methods: {
    onClick() {
      this.onElementClick(i0.from(this.context));
    }
  },
  components: {
    Message: h5,
    SelfInvocation: PO,
    Comment: p5,
    Occurrence: Ba
  }
}, zO = ["data-to", "data-origin", "data-source", "data-target", "data-origin-layers", "data-source-layers", "data-target-layers", "data-signature"];
function UO(t, e, n, i, s, r) {
  const o = i2("comment"), l = i2("self-invocation"), L = i2("message"), a = i2("occurrence");
  return T(), B("div", {
    class: v2(["interaction sync inline-block", {
      highlight: r.isCurrent,
      self: t.isSelf,
      "right-to-left": t.rightToLeft
    }]),
    onClick: e[0] || (e[0] = s5((...C) => r.onClick && r.onClick(...C), ["stop"])),
    "data-to": r.target,
    "data-origin": t.origin,
    "data-source": r.source,
    "data-target": r.target,
    "data-origin-layers": t.originLayers,
    "data-source-layers": t.sourceLayers,
    "data-target-layers": t.targetLayers,
    "data-type": "interaction",
    "data-signature": r.signature,
    style: w2({
      width: t.isSelf ? void 0 : t.interactionWidth + "px",
      transform: "translateX(" + t.translateX + "px)"
    })
  }, [
    r.hasComment ? (T(), T2(o, {
      key: 0,
      commentObj: n.commentObj
    }, null, 8, ["commentObj"])) : x2("", !0),
    t.isSelf ? (T(), T2(l, {
      key: 1,
      classNames: r.messageClassNames,
      textStyle: r.messageTextStyle,
      context: r.message,
      number: n.number
    }, null, 8, ["classNames", "textStyle", "context", "number"])) : (T(), T2(L, {
      key: 2,
      class: "text-center",
      classNames: r.messageClassNames,
      textStyle: r.messageTextStyle,
      context: r.message,
      content: r.signature,
      rtl: t.rightToLeft,
      type: "sync",
      number: n.number
    }, null, 8, ["classNames", "textStyle", "context", "content", "rtl", "number"])),
    N(a, {
      context: r.message,
      participant: r.target,
      rtl: t.rightToLeft,
      number: n.number
    }, null, 8, ["context", "participant", "rtl", "number"]),
    r.assignee && !t.isSelf ? (T(), T2(L, {
      key: 3,
      class: "return transform -translate-y-full",
      context: r.message,
      content: r.assignee,
      rtl: !t.rightToLeft,
      type: "return",
      number: `${n.number}.${r.statements.length + 1}`,
      classNames: r.messageClassNames,
      textStyle: r.messageTextStyle
    }, null, 8, ["context", "content", "rtl", "number", "classNames", "textStyle"])) : x2("", !0)
  ], 14, zO);
}
const WO = /* @__PURE__ */ K2(BO, [["render", UO], ["__scopeId", "data-v-c2a2c2be"]]), HO = (t) => (r4("data-v-0083f8a9"), t = t(), o4(), t), $O = {
  class: "message self flex items-start flex-col",
  style: { "border-width": "0" }
}, VO = { class: "name group px-px hover:text-skin-message-hover hover:bg-skin-message-hover min-h-[1em]" }, GO = /* @__PURE__ */ HO(() => /* @__PURE__ */ _("svg", {
  class: "arrow text-skin-message-arrow",
  width: "34",
  height: "34"
}, [
  /* @__PURE__ */ _("polyline", {
    class: "stroke-current stroke-2 fill-none",
    points: "0,2 28,2 28,25 1,25"
  }),
  /* @__PURE__ */ _("polyline", {
    class: "head stroke-current stroke-2 fill-none",
    points: "11,19 1,25 11,31"
  })
], -1)), jO = /* @__PURE__ */ q2({
  __name: "SelfInvocation-async",
  props: {
    context: null,
    number: null,
    textStyle: null,
    classNames: null
  },
  setup(t) {
    const e = t, { context: n } = g9(e), i = I(() => n == null ? void 0 : n.value.content()), s = I(() => i.value ? [i.value.start.start, i.value.stop.stop] : [-1, -1]), r = I(() => {
      var o;
      return (o = i.value) == null ? void 0 : o.getFormattedText();
    });
    return (o, l) => (T(), B("div", $O, [
      _("label", VO, [
        N(N3, { number: t.number }, null, 8, ["number"]),
        N(g7, {
          style: w2(t.textStyle),
          class: v2(t.classNames),
          labelText: O(r),
          labelPosition: O(s),
          isAsync: !0,
          isSelf: !0
        }, null, 8, ["style", "class", "labelText", "labelPosition"])
      ]),
      GO
    ]));
  }
});
const qO = /* @__PURE__ */ K2(jO, [["__scopeId", "data-v-0083f8a9"]]);
function i6(t) {
  return t == null;
}
const KO = {
  name: "interaction-async",
  props: ["context", "comment", "commentObj", "number"],
  mixins: [w7, x7],
  computed: {
    ...R3(["distance", "centerOf", "cursor", "onElementClick"]),
    asyncMessage: function() {
      var t;
      return (t = this.context) == null ? void 0 : t.asyncMessage();
    },
    signature: function() {
      var t, e;
      return (e = (t = this.asyncMessage) == null ? void 0 : t.content()) == null ? void 0 : e.getFormattedText();
    },
    providedSource: function() {
      var t;
      return (t = this.asyncMessage) == null ? void 0 : t.ProvidedFrom();
    },
    source: function() {
      return this.providedSource || this.origin;
    },
    target: function() {
      var t, e;
      return (e = (t = this.asyncMessage) == null ? void 0 : t.to()) == null ? void 0 : e.getFormattedText();
    },
    isCurrent: function() {
      const t = this.asyncMessage.start.start, e = this.asyncMessage.stop.stop + 1;
      return i6(this.cursor) || i6(t) || i6(e) ? !1 : this.cursor >= t && this.cursor <= e;
    },
    messageTextStyle() {
      var t;
      return (t = this.commentObj) == null ? void 0 : t.messageStyle;
    },
    messageClassNames() {
      var t;
      return (t = this.commentObj) == null ? void 0 : t.messageClassNames;
    }
  },
  methods: {
    onClick() {
      this.onElementClick(i0.from(this.context));
    }
  },
  components: {
    Comment: p5,
    SelfInvocationAsync: qO,
    Message: h5
  }
}, YO = ["data-origin", "data-to", "data-source", "data-target", "data-signature"];
function QO(t, e, n, i, s, r) {
  const o = i2("comment"), l = i2("self-invocation-async"), L = i2("message");
  return T(), B("div", {
    "data-origin": t.origin,
    "data-to": r.target,
    "data-source": r.source,
    "data-target": r.target,
    class: v2(["interaction async", {
      "left-to-right": !t.rightToLeft,
      "right-to-left": t.rightToLeft,
      highlight: r.isCurrent,
      "self-invocation": t.isSelf
    }]),
    onClick: e[0] || (e[0] = s5((...a) => r.onClick && r.onClick(...a), ["stop"])),
    "data-signature": r.signature,
    style: w2({
      width: t.interactionWidth + "px",
      transform: "translateX(" + t.translateX + "px)"
    })
  }, [
    n.comment ? (T(), T2(o, {
      key: 0,
      commentObj: n.commentObj
    }, null, 8, ["commentObj"])) : x2("", !0),
    t.isSelf ? (T(), T2(l, {
      key: 1,
      classNames: r.messageClassNames,
      textStyle: r.messageTextStyle,
      context: r.asyncMessage,
      number: n.number
    }, null, 8, ["classNames", "textStyle", "context", "number"])) : (T(), T2(L, {
      key: 2,
      classNames: r.messageClassNames,
      textStyle: r.messageTextStyle,
      context: r.asyncMessage,
      content: r.signature,
      rtl: t.rightToLeft,
      type: "async",
      number: n.number
    }, null, 8, ["classNames", "textStyle", "context", "content", "rtl", "number"]))
  ], 14, YO);
}
const XO = /* @__PURE__ */ K2(KO, [["render", QO], ["__scopeId", "data-v-7a7a6216"]]);
const JO = {
  components: { Icon: q1 },
  props: ["label", "collapsed"],
  emits: ["click"]
}, eN = { class: "collapsible-header" }, tN = { class: "mb-0" };
function nN(t, e, n, i, s, r) {
  const o = i2("Icon");
  return T(), B("div", eN, [
    _("label", tN, m1(n.label), 1),
    n.collapsed ? (T(), T2(o, {
      key: 1,
      name: "collapse-unexpanded",
      "icon-class": "w-4 h-4 cursor-pointer",
      onIconClick: e[1] || (e[1] = (l) => t.$emit("click", l))
    })) : (T(), T2(o, {
      key: 0,
      name: "collapse-expanded",
      "icon-class": `w-4 h-4 collapse-button cursor-pointer ${n.collapsed ? "" : "expanded"}`,
      onIconClick: e[0] || (e[0] = (l) => t.$emit("click", l))
    }, null, 8, ["icon-class"]))
  ]);
}
const iN = /* @__PURE__ */ K2(JO, [["render", nN], ["__scopeId", "data-v-048a5186"]]), $4 = {
  props: ["origin"],
  computed: {
    ...R3(["coordinates"]),
    leftParticipant: function() {
      const t = this.coordinates.orderedParticipantNames(), e = p8(this.context);
      return t.find((n) => e.includes(n));
    },
    border: function() {
      const t = this.coordinates.orderedParticipantNames(), n = new $t(t).getFrame(this.context);
      return Vt(n);
    },
    offsetX: function() {
      let t = this.coordinates.half(this.leftParticipant);
      return console.debug(
        `left participant: ${this.leftParticipant} ${t}`
      ), (this.origin ? this.coordinates.distance(this.leftParticipant, this.origin) : 0) + this.border.left + t;
    },
    paddingLeft: function() {
      let t = this.coordinates.half(this.leftParticipant);
      return this.border.left + t;
    },
    fragmentStyle: function() {
      return {
        // +1px for the border of the fragment
        transform: "translateX(" + (this.offsetX + 1) * -1 + "px)",
        width: BL(this.context, this.coordinates) + "px",
        minWidth: rL + "px"
      };
    }
  },
  data: function() {
    return { collapsed: !1 };
  },
  methods: {
    toggle() {
      this.collapsed = !this.collapsed, d7.emit("participant_set_top");
    }
  },
  components: { CollapseButton: iN },
  watch: {
    context() {
      this.collapsed && (this.collapsed = !1);
    }
  }
}, sN = (t) => {
  const e = {
    loop: "FragmentLoop",
    alt: "FragmentAlt",
    par: "FragmentPar",
    opt: "FragmentOpt",
    section: "FragmentSection",
    critical: "FragmentCritical",
    tcf: "FragmentTryCatchFinally",
    creation: "Creation",
    message: "Interaction",
    asyncMessage: "InteractionAsync",
    divider: "Divider",
    ret: "Return"
  }, n = Object.keys(e).find((i) => t[i]() !== null) || "";
  return e[n];
}, b0 = (t) => t && t.stat() ? t.stat().filter((e) => sN(e) !== "Divider").length : 0, za = (t, e) => {
  if (t) {
    const n = t.split(".");
    return n[n.length - 1] = Number(n[n.length - 1]) + e, n.join(".");
  } else
    return String(e);
}, rN = /* @__PURE__ */ _("label", null, "[", -1), oN = ["contenteditable"], lN = /* @__PURE__ */ _("label", null, "]", -1), Ua = /* @__PURE__ */ q2({
  __name: "ConditionLabel",
  props: {
    condition: null
  },
  setup(t) {
    const e = t, n = /\b(\w+)\s*==\s*(\w+)\b/g, { condition: i } = g9(e), s = F3(), r = I(() => s.state.mode), o = I(() => s.getters.code), l = I(
      () => s.getters.onContentChange || (() => {
      })
    ), L = I(() => {
      var k;
      return ((k = i == null ? void 0 : i.value) == null ? void 0 : k.getFormattedText()) ?? "";
    });
    function a(k) {
      s.dispatch("updateCode", { code: k }), l.value(k);
    }
    function C(k) {
      var b, z, K, E;
      k.preventDefault(), k.stopPropagation();
      const m = k.target;
      if (!(m instanceof HTMLElement))
        return;
      let g = m.innerText.trim() ?? "";
      if (g === "") {
        m.innerText = L.value;
        return;
      }
      V0.test(g) && !n.test(g) && (g = g.replace(/"/g, ""), g = `"${g}"`);
      const [w, Z] = [
        (z = (b = i.value) == null ? void 0 : b.start) == null ? void 0 : z.start,
        (E = (K = i.value) == null ? void 0 : K.stop) == null ? void 0 : E.stop
      ];
      if (w === -1 || Z === -1) {
        console.warn("labelPosition is not set");
        return;
      }
      a(o.value.slice(0, w) + g + o.value.slice(Z + 1));
    }
    const { editing: c, handleDblClick: h, handleBlur: d, handleKeydown: f, handleKeyup: x } = f8(C);
    return (k, m) => (T(), B(P2, null, [
      rN,
      _("label", {
        title: "Double click to edit",
        class: v2(["bg-skin-frame opacity-65 condition px-1 cursor-text hover:text-skin-message-hover hover:bg-skin-message-hover", {
          "cursor-text": O(c)
        }]),
        contenteditable: O(c) && O(r) === O(j1).Dynamic,
        onDblclick: m[0] || (m[0] = //@ts-ignore
        (...g) => O(h) && O(h)(...g)),
        onBlur: m[1] || (m[1] = //@ts-ignore
        (...g) => O(d) && O(d)(...g)),
        onKeyup: m[2] || (m[2] = //@ts-ignore
        (...g) => O(x) && O(x)(...g)),
        onKeydown: m[3] || (m[3] = //@ts-ignore
        (...g) => O(f) && O(f)(...g))
      }, m1(O(L)), 43, oN),
      lN
    ], 64));
  }
});
const LN = {
  name: "fragment-alt",
  props: ["context", "comment", "commentObj", "number"],
  mixins: [$4],
  components: {
    ConditionLabel: Ua,
    Numbering: N3,
    Icon: q1
  },
  setup(t) {
    const e = I(() => t.context.alt()), n = I(() => {
      var a;
      return (a = e.value) == null ? void 0 : a.ifBlock();
    }), i = I(() => {
      var a;
      return (a = e.value) == null ? void 0 : a.elseIfBlock();
    }), s = I(
      () => {
        var a, C, c;
        return (c = (C = (a = e.value) == null ? void 0 : a.elseBlock()) == null ? void 0 : C.braceBlock()) == null ? void 0 : c.block();
      }
    ), r = I(
      () => {
        var a, C, c;
        return (c = (C = (a = e.value) == null ? void 0 : a.ifBlock()) == null ? void 0 : C.braceBlock()) == null ? void 0 : c.block();
      }
    ), o = I(() => {
      var C;
      const a = [b0(r.value)];
      return (C = e.value) != null && C.elseIfBlock() && e.value.elseIfBlock().forEach((c) => {
        a.push(
          a[a.length - 1] + b0(L(c))
        );
      }), a;
    });
    function l(a) {
      var C;
      return (C = a == null ? void 0 : a.parExpr()) == null ? void 0 : C.condition();
    }
    function L(a) {
      var C;
      return (C = a == null ? void 0 : a.braceBlock()) == null ? void 0 : C.block();
    }
    return {
      alt: e,
      blockInIfBlock: r,
      ifBlock: n,
      elseIfBlocks: i,
      elseBlock: s,
      blockLengthAcc: o,
      conditionFromIfElseBlock: l,
      blockInElseIfBlock: L,
      increaseNumber: za,
      blockLength: b0
    };
  }
}, Wa = (t) => (r4("data-v-a693f0a4"), t = t(), o4(), t), aN = ["data-origin", "data-left-participant", "data-frame-padding-left", "data-frame-padding-right"], CN = { class: "segment" }, cN = { class: "header bg-skin-fragment-header text-skin-fragment-header leading-4 rounded-t relative" }, uN = { class: "name font-semibold p-1 border-b" }, hN = { class: "p-0 flex items-center" }, dN = { class: "segment" }, gN = { class: "text-skin-fragment flex" }, fN = /* @__PURE__ */ Wa(() => /* @__PURE__ */ _("label", { class: "else-if hidden" }, "else if", -1)), pN = {
  key: 0,
  class: "segment mt-2 border-t border-solid"
}, mN = /* @__PURE__ */ Wa(() => /* @__PURE__ */ _("div", { class: "text-skin-fragment" }, [
  /* @__PURE__ */ _("label", { class: "p-1" }, "[else]")
], -1));
function wN(t, e, n, i, s, r) {
  const o = i2("comment"), l = i2("Numbering"), L = i2("Icon"), a = i2("collapse-button"), C = i2("ConditionLabel"), c = i2("block");
  return T(), B("div", {
    "data-origin": t.origin,
    "data-left-participant": t.leftParticipant,
    "data-frame-padding-left": t.border.left,
    "data-frame-padding-right": t.border.right,
    class: "fragment alt border-skin-fragment rounded",
    style: w2(t.fragmentStyle)
  }, [
    _("div", CN, [
      n.commentObj.text ? (T(), T2(o, {
        key: 0,
        comment: n.comment,
        commentObj: n.commentObj
      }, null, 8, ["comment", "commentObj"])) : x2("", !0),
      _("div", cN, [
        N(l, { number: n.number }, null, 8, ["number"]),
        _("div", uN, [
          _("label", hN, [
            N(L, {
              name: "alt-fragment",
              "icon-class": "w-5 h-5 mr-1 text-skin-fragment-header"
            }),
            N(a, {
              label: "Alt",
              collapsed: t.collapsed,
              onClick: this.toggle,
              style: w2(n.commentObj.messageStyle),
              class: v2(n.commentObj.messageClassNames)
            }, null, 8, ["collapsed", "onClick", "style", "class"])
          ])
        ])
      ])
    ]),
    _("div", {
      class: v2({ hidden: t.collapsed })
    }, [
      _("div", dN, [
        _("div", gN, [
          N(C, {
            condition: i.conditionFromIfElseBlock(i.ifBlock)
          }, null, 8, ["condition"])
        ]),
        i.blockInIfBlock ? (T(), T2(c, {
          key: 0,
          origin: t.leftParticipant,
          style: w2({ paddingLeft: `${t.paddingLeft}px` }),
          context: i.blockInIfBlock,
          number: `${n.number}.1`,
          incremental: ""
        }, null, 8, ["origin", "style", "context", "number"])) : x2("", !0)
      ]),
      (T(!0), B(P2, null, e4(i.elseIfBlocks, (h, d) => (T(), B("div", {
        key: d + 500,
        class: "segment mt-2 border-t border-solid"
      }, [
        (T(), B("div", {
          class: "text-skin-fragment",
          key: d + 1e3
        }, [
          fN,
          N(C, {
            condition: i.conditionFromIfElseBlock(h)
          }, null, 8, ["condition"])
        ])),
        (T(), T2(c, {
          origin: t.leftParticipant,
          style: w2({ paddingLeft: `${t.paddingLeft}px` }),
          context: i.blockInElseIfBlock(h),
          key: d + 2e3,
          number: `${n.number}.${i.blockLengthAcc[d] + 1}`,
          incremental: ""
        }, null, 8, ["origin", "style", "context", "number"]))
      ]))), 128)),
      i.elseBlock ? (T(), B("div", pN, [
        mN,
        N(c, {
          origin: t.leftParticipant,
          style: w2({ paddingLeft: `${t.paddingLeft}px` }),
          context: i.elseBlock,
          number: `${n.number}.${i.blockLengthAcc[i.blockLengthAcc.length - 1] + 1}`,
          incremental: ""
        }, null, 8, ["origin", "style", "context", "number"])
      ])) : x2("", !0)
    ], 2)
  ], 12, aN);
}
const xN = /* @__PURE__ */ K2(LN, [["render", wN], ["__scopeId", "data-v-a693f0a4"]]);
const _N = {
  name: "fragment-par",
  props: ["context", "comment", "commentObj", "number"],
  mixins: [$4],
  computed: {
    par: function() {
      return this.context.par();
    }
  },
  components: {
    Numbering: N3,
    Icon: q1
  }
}, vN = ["data-origin", "data-left-participant", "data-frame-padding-left", "data-frame-padding-right"], MN = { class: "header bg-skin-fragment-header text-skin-fragment-header leading-4 rounded-t relative" }, RN = { class: "name font-semibold p-1 border-b" }, yN = { class: "p-0 flex items-center" };
function AN(t, e, n, i, s, r) {
  const o = i2("comment"), l = i2("Numbering"), L = i2("Icon"), a = i2("collapse-button"), C = i2("block");
  return T(), B("div", {
    "data-origin": t.origin,
    "data-left-participant": t.leftParticipant,
    "data-frame-padding-left": t.border.left,
    "data-frame-padding-right": t.border.right,
    class: "fragment par border-skin-fragment rounded",
    style: w2(t.fragmentStyle)
  }, [
    n.commentObj.text ? (T(), T2(o, {
      key: 0,
      comment: n.comment,
      commentObj: n.commentObj
    }, null, 8, ["comment", "commentObj"])) : x2("", !0),
    _("div", MN, [
      N(l, { number: n.number }, null, 8, ["number"]),
      _("div", RN, [
        _("label", yN, [
          N(L, {
            name: "par-fragment",
            "icon-class": "w-5 h-5 mr-1 text-skin-fragment-header"
          }),
          N(a, {
            label: "Par",
            collapsed: t.collapsed,
            onClick: this.toggle,
            style: w2(n.commentObj.messageStyle),
            class: v2(n.commentObj.messageClassNames)
          }, null, 8, ["collapsed", "onClick", "style", "class"])
        ])
      ])
    ]),
    r.par.braceBlock() ? (T(), T2(C, {
      key: 1,
      origin: t.leftParticipant,
      class: v2({ hidden: t.collapsed }),
      style: w2({ paddingLeft: `${t.paddingLeft}px` }),
      context: r.par.braceBlock().block(),
      number: `${n.number}.1`,
      incremental: ""
    }, null, 8, ["origin", "class", "style", "context", "number"])) : x2("", !0)
  ], 12, vN);
}
const ZN = /* @__PURE__ */ K2(_N, [["render", AN], ["__scopeId", "data-v-ae917d51"]]);
const kN = {
  name: "fragment-loop",
  props: ["context", "comment", "commentObj", "number"],
  mixins: [$4],
  components: {
    ConditionLabel: Ua,
    Numbering: N3,
    Icon: q1
  },
  setup(t) {
    const e = I(() => t.context.loop()), n = I(() => {
      var i, s;
      return (s = (i = e.value) == null ? void 0 : i.braceBlock()) == null ? void 0 : s.block();
    });
    return {
      loop: e,
      blockInLoop: n,
      getConditionFromBlock: () => {
        var i, s;
        return (s = (i = e.value) == null ? void 0 : i.parExpr()) == null ? void 0 : s.condition();
      }
    };
  }
}, TN = ["data-origin", "data-left-participant", "data-frame-padding-left", "data-frame-padding-right"], SN = { class: "header text-skin-fragment-header bg-skin-fragment-header leading-4 relative" }, bN = { class: "name font-semibold p-1 border-b" }, EN = { class: "p-0 flex items-center" }, IN = { class: "segment" }, FN = { class: "text-skin-fragment" };
function ON(t, e, n, i, s, r) {
  const o = i2("comment"), l = i2("Numbering"), L = i2("Icon"), a = i2("collapse-button"), C = i2("ConditionLabel"), c = i2("block");
  return T(), B("div", {
    "data-origin": t.origin,
    "data-left-participant": t.leftParticipant,
    "data-frame-padding-left": t.border.left,
    "data-frame-padding-right": t.border.right,
    class: "fragment loop border-skin-fragment rounded",
    style: w2(t.fragmentStyle)
  }, [
    n.commentObj.text ? (T(), T2(o, {
      key: 0,
      comment: n.comment,
      commentObj: n.commentObj
    }, null, 8, ["comment", "commentObj"])) : x2("", !0),
    _("div", SN, [
      N(l, { number: n.number }, null, 8, ["number"]),
      _("div", bN, [
        _("label", EN, [
          N(L, {
            name: "loop-fragment",
            "icon-class": "w-5 h-5 mr-1 text-skin-fragment-header"
          }),
          N(a, {
            label: "Loop",
            collapsed: t.collapsed,
            onClick: this.toggle,
            style: w2(n.commentObj.messageStyle),
            class: v2(n.commentObj.messageClassNames)
          }, null, 8, ["collapsed", "onClick", "style", "class"])
        ])
      ])
    ]),
    _("div", {
      class: v2({ hidden: t.collapsed })
    }, [
      _("div", IN, [
        _("div", FN, [
          N(C, {
            condition: i.getConditionFromBlock(i.blockInLoop)
          }, null, 8, ["condition"])
        ]),
        N(c, {
          origin: t.leftParticipant,
          style: w2({ paddingLeft: `${t.paddingLeft}px` }),
          context: i.blockInLoop,
          number: `${n.number}.1`,
          incremental: ""
        }, null, 8, ["origin", "style", "context", "number"])
      ])
    ], 2)
  ], 12, TN);
}
const NN = /* @__PURE__ */ K2(kN, [["render", ON], ["__scopeId", "data-v-96d7c297"]]);
const DN = {
  name: "fragment-opt",
  props: ["context", "comment", "commentObj", "number"],
  mixins: [$4],
  computed: {
    opt: function() {
      return this.context.opt();
    }
  },
  components: {
    Numbering: N3,
    Icon: q1
  }
}, PN = ["data-origin", "data-left-participant", "data-frame-padding-left", "data-frame-padding-right"], BN = { class: "header bg-skin-fragment-header text-skin-fragment-header leading-4 relative" }, zN = { class: "name font-semibold p-1 border-b" }, UN = { class: "p-0 flex items-center" };
function WN(t, e, n, i, s, r) {
  var c, h;
  const o = i2("comment"), l = i2("Numbering"), L = i2("Icon"), a = i2("collapse-button"), C = i2("block");
  return T(), B("div", {
    "data-origin": t.origin,
    "data-left-participant": t.leftParticipant,
    "data-frame-padding-left": t.border.left,
    "data-frame-padding-right": t.border.right,
    class: "fragment opt border-skin-fragment rounded",
    style: w2(t.fragmentStyle)
  }, [
    n.commentObj.text ? (T(), T2(o, {
      key: 0,
      comment: n.comment,
      commentObj: n.commentObj
    }, null, 8, ["comment", "commentObj"])) : x2("", !0),
    _("div", BN, [
      N(l, { number: n.number }, null, 8, ["number"]),
      _("div", zN, [
        _("label", UN, [
          N(L, {
            name: "opt-fragment",
            "icon-class": "w-5 h-5 mr-1 text-skin-fragment-header"
          }),
          N(a, {
            label: "Opt",
            collapsed: t.collapsed,
            onClick: this.toggle,
            style: w2(n.commentObj.textStyle),
            class: v2(n.commentObj.classNames)
          }, null, 8, ["collapsed", "onClick", "style", "class"])
        ])
      ])
    ]),
    N(C, {
      origin: t.leftParticipant,
      class: v2({ hidden: t.collapsed }),
      style: w2({ paddingLeft: `${t.paddingLeft}px` }),
      context: (h = (c = r.opt) == null ? void 0 : c.braceBlock()) == null ? void 0 : h.block(),
      number: `${n.number}.1`,
      incremental: ""
    }, null, 8, ["origin", "class", "style", "context", "number"])
  ], 12, PN);
}
const HN = /* @__PURE__ */ K2(DN, [["render", WN], ["__scopeId", "data-v-1c12291c"]]);
var $N = typeof x5 == "object" && x5 && x5.Object === Object && x5, VN = $N, GN = VN, jN = typeof self == "object" && self && self.Object === Object && self, qN = GN || jN || Function("return this")(), KN = qN, YN = KN, QN = YN.Symbol, an = QN;
function XN(t, e) {
  for (var n = -1, i = t == null ? 0 : t.length, s = Array(i); ++n < i; )
    s[n] = e(t[n], n, t);
  return s;
}
var JN = XN, eD = Array.isArray, tD = eD, Os = an, Ha = Object.prototype, nD = Ha.hasOwnProperty, iD = Ha.toString, m0 = Os ? Os.toStringTag : void 0;
function sD(t) {
  var e = nD.call(t, m0), n = t[m0];
  try {
    t[m0] = void 0;
    var i = !0;
  } catch {
  }
  var s = iD.call(t);
  return i && (e ? t[m0] = n : delete t[m0]), s;
}
var rD = sD, oD = Object.prototype, lD = oD.toString;
function LD(t) {
  return lD.call(t);
}
var aD = LD, Ns = an, CD = rD, cD = aD, uD = "[object Null]", hD = "[object Undefined]", Ds = Ns ? Ns.toStringTag : void 0;
function dD(t) {
  return t == null ? t === void 0 ? hD : uD : Ds && Ds in Object(t) ? CD(t) : cD(t);
}
var gD = dD;
function fD(t) {
  return t != null && typeof t == "object";
}
var pD = fD, mD = gD, wD = pD, xD = "[object Symbol]";
function _D(t) {
  return typeof t == "symbol" || wD(t) && mD(t) == xD;
}
var vD = _D, Ps = an, MD = JN, RD = tD, yD = vD, AD = 1 / 0, Bs = Ps ? Ps.prototype : void 0, zs = Bs ? Bs.toString : void 0;
function $a(t) {
  if (typeof t == "string")
    return t;
  if (RD(t))
    return MD(t, $a) + "";
  if (yD(t))
    return zs ? zs.call(t) : "";
  var e = t + "";
  return e == "0" && 1 / t == -AD ? "-0" : e;
}
var ZD = $a, kD = ZD;
function TD(t) {
  return t == null ? "" : kD(t);
}
var Va = TD;
function SD(t, e, n) {
  var i = -1, s = t.length;
  e < 0 && (e = -e > s ? 0 : s + e), n = n > s ? s : n, n < 0 && (n += s), s = e > n ? 0 : n - e >>> 0, e >>>= 0;
  for (var r = Array(s); ++i < s; )
    r[i] = t[i + e];
  return r;
}
var bD = SD, ED = bD;
function ID(t, e, n) {
  var i = t.length;
  return n = n === void 0 ? i : n, !e && n >= i ? t : ED(t, e, n);
}
var FD = ID, OD = "\\ud800-\\udfff", ND = "\\u0300-\\u036f", DD = "\\ufe20-\\ufe2f", PD = "\\u20d0-\\u20ff", BD = ND + DD + PD, zD = "\\ufe0e\\ufe0f", UD = "\\u200d", WD = RegExp("[" + UD + OD + BD + zD + "]");
function HD(t) {
  return WD.test(t);
}
var Ga = HD;
function $D(t) {
  return t.split("");
}
var VD = $D, ja = "\\ud800-\\udfff", GD = "\\u0300-\\u036f", jD = "\\ufe20-\\ufe2f", qD = "\\u20d0-\\u20ff", KD = GD + jD + qD, YD = "\\ufe0e\\ufe0f", QD = "[" + ja + "]", ie = "[" + KD + "]", se = "\\ud83c[\\udffb-\\udfff]", XD = "(?:" + ie + "|" + se + ")", qa = "[^" + ja + "]", Ka = "(?:\\ud83c[\\udde6-\\uddff]){2}", Ya = "[\\ud800-\\udbff][\\udc00-\\udfff]", JD = "\\u200d", Qa = XD + "?", Xa = "[" + YD + "]?", eP = "(?:" + JD + "(?:" + [qa, Ka, Ya].join("|") + ")" + Xa + Qa + ")*", tP = Xa + Qa + eP, nP = "(?:" + [qa + ie + "?", ie, Ka, Ya, QD].join("|") + ")", iP = RegExp(se + "(?=" + se + ")|" + nP + tP, "g");
function sP(t) {
  return t.match(iP) || [];
}
var rP = sP, oP = VD, lP = Ga, LP = rP;
function aP(t) {
  return lP(t) ? LP(t) : oP(t);
}
var CP = aP, cP = FD, uP = Ga, hP = CP, dP = Va;
function gP(t) {
  return function(e) {
    e = dP(e);
    var n = uP(e) ? hP(e) : void 0, i = n ? n[0] : e.charAt(0), s = n ? cP(n, 1).join("") : e.slice(1);
    return i[t]() + s;
  };
}
var fP = gP, pP = fP, mP = pP("toUpperCase"), wP = mP, xP = Va, _P = wP;
function vP(t) {
  return _P(xP(t).toLowerCase());
}
var MP = vP;
const RP = /* @__PURE__ */ s4(MP);
const yP = {
  name: "fragment-section",
  props: ["context", "comment", "commentObj", "number"],
  mixins: [$4],
  components: {
    Numbering: N3,
    Icon: q1
  },
  setup(t) {
    const e = I(() => t.context.section()), n = I(() => {
      var o;
      return (o = e.value) == null ? void 0 : o.braceBlock();
    }), i = I(() => {
      var o, l;
      return (l = (o = e.value) == null ? void 0 : o.atom()) == null ? void 0 : l.getFormattedText();
    }), s = I(() => {
      var o;
      return (o = n.value) == null ? void 0 : o.block();
    });
    return {
      label: I(() => i.value ?? RP("section")),
      braceBlock: n,
      blockInSection: s
    };
  }
}, AP = (t) => (r4("data-v-ee384594"), t = t(), o4(), t), ZP = ["data-origin", "data-left-participant", "data-frame-padding-left", "data-frame-padding-right"], kP = { class: "segment" }, TP = { class: "header bg-skin-fragment-header text-skin-fragment-header leading-4 rounded-t relative" }, SP = { class: "name font-semibold p-1 border-b" }, bP = { class: "p-0 flex items-center" }, EP = { class: "segment" }, IP = /* @__PURE__ */ AP(() => /* @__PURE__ */ _("div", { class: "text-skin-fragment flex" }, null, -1));
function FP(t, e, n, i, s, r) {
  const o = i2("comment"), l = i2("Numbering"), L = i2("Icon"), a = i2("collapse-button"), C = i2("block");
  return T(), B("div", {
    "data-origin": t.origin,
    "data-left-participant": t.leftParticipant,
    "data-frame-padding-left": t.border.left,
    "data-frame-padding-right": t.border.right,
    class: "fragment section border-skin-fragment rounded",
    style: w2(t.fragmentStyle)
  }, [
    _("div", kP, [
      n.commentObj.text ? (T(), T2(o, {
        key: 0,
        comment: n.comment,
        commentObj: n.commentObj
      }, null, 8, ["comment", "commentObj"])) : x2("", !0),
      _("div", TP, [
        N(l, { number: n.number }, null, 8, ["number"]),
        _("div", SP, [
          _("label", bP, [
            N(L, {
              name: "section-fragment",
              "icon-class": "w-5 h-5 mr-1 text-skin-fragment-header"
            }),
            N(a, {
              label: i.label,
              collapsed: t.collapsed,
              onClick: this.toggle,
              style: w2(n.commentObj.messageStyle),
              class: v2(n.commentObj.messageClassNames)
            }, null, 8, ["label", "collapsed", "onClick", "style", "class"])
          ])
        ])
      ])
    ]),
    _("div", {
      class: v2({ hidden: t.collapsed })
    }, [
      _("div", EP, [
        IP,
        i.blockInSection ? (T(), T2(C, {
          key: 0,
          origin: t.leftParticipant,
          style: w2({ paddingLeft: `${t.paddingLeft}px` }),
          context: i.blockInSection,
          number: n.number
        }, null, 8, ["origin", "style", "context", "number"])) : x2("", !0)
      ])
    ], 2)
  ], 12, ZP);
}
const OP = /* @__PURE__ */ K2(yP, [["render", FP], ["__scopeId", "data-v-ee384594"]]);
const NP = {
  name: "fragment-critical",
  components: { Numbering: N3, Icon: q1 },
  props: ["context", "comment", "commentObj", "number"],
  mixins: [$4],
  setup(t) {
    const e = I(() => t.context.critical()), n = I(() => {
      var o;
      return (o = e.value) == null ? void 0 : o.braceBlock();
    }), i = I(() => {
      var o, l;
      return (l = (o = e.value) == null ? void 0 : o.atom()) == null ? void 0 : l.getFormattedText();
    }), s = I(() => {
      var o;
      return (o = n.value) == null ? void 0 : o.block();
    });
    return {
      label: I(
        () => i.value ? `Critical:${i.value}` : "Critical"
      ),
      braceBlock: n,
      blockInCritical: s
    };
  }
}, DP = (t) => (r4("data-v-5fd4cae0"), t = t(), o4(), t), PP = ["data-origin", "data-left-participant", "data-frame-padding-left", "data-frame-padding-right"], BP = { class: "segment" }, zP = { class: "header bg-skin-fragment-header text-skin-fragment-header leading-4 rounded-t relative" }, UP = { class: "name font-semibold p-1 border-b" }, WP = { class: "p-0 flex items-center" }, HP = { class: "segment" }, $P = /* @__PURE__ */ DP(() => /* @__PURE__ */ _("div", { class: "text-skin-fragment flex" }, null, -1));
function VP(t, e, n, i, s, r) {
  const o = i2("comment"), l = i2("Numbering"), L = i2("Icon"), a = i2("collapse-button"), C = i2("block");
  return T(), B("div", {
    "data-origin": t.origin,
    "data-left-participant": t.leftParticipant,
    "data-frame-padding-left": t.border.left,
    "data-frame-padding-right": t.border.right,
    class: "fragment critical border-skin-fragment rounded",
    style: w2(t.fragmentStyle)
  }, [
    _("div", BP, [
      n.commentObj.text ? (T(), T2(o, {
        key: 0,
        comment: n.comment,
        commentObj: n.commentObj
      }, null, 8, ["comment", "commentObj"])) : x2("", !0),
      _("div", zP, [
        N(l, { number: n.number }, null, 8, ["number"]),
        _("div", UP, [
          _("label", WP, [
            N(L, {
              name: "critical-fragment",
              "icon-class": "w-5 h-5 mr-1 text-skin-fragment-header"
            }),
            N(a, {
              label: i.label,
              collapsed: t.collapsed,
              onClick: this.toggle,
              style: w2(n.commentObj.messageStyle),
              class: v2(n.commentObj.messageClassNames)
            }, null, 8, ["label", "collapsed", "onClick", "style", "class"])
          ])
        ])
      ])
    ]),
    _("div", {
      class: v2({ hidden: t.collapsed })
    }, [
      _("div", HP, [
        $P,
        i.blockInCritical ? (T(), T2(C, {
          key: 0,
          origin: t.leftParticipant,
          style: w2({ paddingLeft: `${t.paddingLeft}px` }),
          context: i.blockInCritical,
          number: `${n.number}.1`,
          incremental: ""
        }, null, 8, ["origin", "style", "context", "number"])) : x2("", !0)
      ])
    ], 2)
  ], 12, PP);
}
const GP = /* @__PURE__ */ K2(NP, [["render", VP], ["__scopeId", "data-v-5fd4cae0"]]);
const jP = {
  name: "fragment-section",
  props: ["context", "comment", "commentObj", "number"],
  components: {
    MessageLabel: g7,
    Numbering: N3
  },
  mixins: [$4],
  setup(t) {
    const e = I(() => t.context.ref().Content()), n = I(() => {
      var s;
      return (s = e.value) == null ? void 0 : s.getFormattedText();
    }), i = I(() => {
      var s, r;
      return [
        (s = e.value) == null ? void 0 : s.start.start,
        (r = e.value) == null ? void 0 : r.stop.stop
      ];
    });
    return {
      contentLabel: n,
      contentPosition: i
    };
  }
}, qP = (t) => (r4("data-v-2321fa2c"), t = t(), o4(), t), KP = ["data-origin", "data-left-participant", "data-frame-padding-left", "data-frame-padding-right"], YP = { class: "header bg-skin-fragment-header text-skin-fragment-header leading-4 rounded-t absolute top-0 left-0" }, QP = { class: "text-skin-fragment relative w-9 h-8 -top-[1px] -left-[1px]" }, XP = /* @__PURE__ */ qP(() => /* @__PURE__ */ _("div", { class: "polygon-border absolute inset-0" }, null, -1)), JP = { class: "polygon-content bg-skin-frame text-skin-fragment-header absolute inset-[1px] flex flex-col items-center justify-center" };
function eB(t, e, n, i, s, r) {
  const o = i2("Numbering"), l = i2("comment"), L = i2("MessageLabel");
  return T(), B("div", {
    "data-origin": t.leftParticipant,
    "data-left-participant": t.leftParticipant,
    "data-frame-padding-left": t.border.left,
    "data-frame-padding-right": t.border.right,
    class: "fragment bg-skin-frame border-skin-fragment relative rounded min-w-[140px] w-max py-4 px-2 flex justify-center items-center flex-col",
    style: w2({ ...t.fragmentStyle, paddingLeft: `${t.paddingLeft}px` })
  }, [
    _("div", YP, [
      N(o, { number: n.number }, null, 8, ["number"]),
      n.commentObj.text ? (T(), T2(l, {
        key: 0,
        class: "absolute -top-4 left-0",
        comment: n.comment,
        commentObj: n.commentObj
      }, null, 8, ["comment", "commentObj"])) : x2("", !0),
      _("div", QP, [
        XP,
        _("div", JP, [
          _("span", {
            class: v2(["flex items-center justify-center font-semibold", n.commentObj.messageClassNames]),
            style: w2(n.commentObj.messageStyle)
          }, " Ref ", 6)
        ])
      ])
    ]),
    N(L, {
      class: "text-skin-title mt-3 mb-2",
      labelText: i.contentLabel,
      labelPosition: i.contentPosition
    }, null, 8, ["labelText", "labelPosition"])
  ], 12, KP);
}
const tB = /* @__PURE__ */ K2(jP, [["render", eB], ["__scopeId", "data-v-2321fa2c"]]);
const nB = {
  name: "fragment-tcf",
  props: ["context", "comment", "commentObj", "number"],
  mixins: [$4],
  components: {
    Numbering: N3,
    Icon: q1
  },
  computed: {
    tcf: function() {
      return this.context.tcf();
    },
    blockInTryBlock: function() {
      var t, e, n;
      return (n = (e = (t = this.tcf) == null ? void 0 : t.tryBlock()) == null ? void 0 : e.braceBlock()) == null ? void 0 : n.block();
    },
    finallyBlock: function() {
      var t, e, n;
      return (n = (e = (t = this.tcf) == null ? void 0 : t.finallyBlock()) == null ? void 0 : e.braceBlock()) == null ? void 0 : n.block();
    },
    blockLengthAcc() {
      var e;
      const t = [b0(this.blockInTryBlock)];
      return (e = this.tcf) != null && e.catchBlock() && this.tcf.catchBlock().forEach((n) => {
        t.push(
          t[t.length - 1] + b0(this.blockInCatchBlock(n))
        );
      }), t;
    }
  },
  methods: {
    exception(t) {
      var e, n;
      return (n = (e = t == null ? void 0 : t.invocation()) == null ? void 0 : e.parameters()) == null ? void 0 : n.getFormattedText();
    },
    blockInCatchBlock(t) {
      var e;
      return (e = t == null ? void 0 : t.braceBlock()) == null ? void 0 : e.block();
    }
  }
}, Ja = (t) => (r4("data-v-c045ab66"), t = t(), o4(), t), iB = ["data-origin", "data-left-participant", "data-frame-padding-left", "data-frame-padding-right"], sB = { class: "segment" }, rB = { class: "header bg-skin-fragment-header text-skin-fragment-header leading-4 rounded-t relative" }, oB = { class: "name font-semibold p-1 border-b" }, lB = { class: "p-0 flex items-center" }, LB = { class: "segment" }, aB = /* @__PURE__ */ Ja(() => /* @__PURE__ */ _("label", { class: "keyword catch p-1" }, "catch", -1)), CB = { class: "exception p-1" }, cB = {
  key: 0,
  class: "segment mt-2 border-t border-solid"
}, uB = /* @__PURE__ */ Ja(() => /* @__PURE__ */ _("div", { class: "header flex text-skin-fragment finally" }, [
  /* @__PURE__ */ _("label", { class: "keyword finally bg-skin-frame opacity-65 px-1 inline-block" }, "finally")
], -1));
function hB(t, e, n, i, s, r) {
  const o = i2("comment"), l = i2("Numbering"), L = i2("Icon"), a = i2("collapse-button"), C = i2("block");
  return T(), B("div", {
    "data-origin": t.origin,
    "data-left-participant": t.leftParticipant,
    "data-frame-padding-left": t.border.left,
    "data-frame-padding-right": t.border.right,
    class: "fragment tcf border-skin-fragment rounded",
    style: w2(t.fragmentStyle)
  }, [
    _("div", sB, [
      n.commentObj.text ? (T(), T2(o, {
        key: 0,
        comment: n.comment,
        commentObj: n.commentObj
      }, null, 8, ["comment", "commentObj"])) : x2("", !0),
      _("div", rB, [
        N(l, { number: n.number }, null, 8, ["number"]),
        _("div", oB, [
          _("label", lB, [
            N(L, {
              name: "try-catch-fragment",
              "icon-class": "w-5 h-5 mr-1 text-skin-fragment-header"
            }),
            N(a, {
              label: "Try",
              collapsed: t.collapsed,
              onClick: this.toggle,
              style: w2(n.commentObj.messageStyle),
              class: v2(n.commentObj.messageClassNames)
            }, null, 8, ["collapsed", "onClick", "style", "class"])
          ])
        ])
      ])
    ]),
    _("div", {
      class: v2({ hidden: t.collapsed })
    }, [
      _("div", LB, [
        r.blockInTryBlock ? (T(), T2(C, {
          key: 0,
          origin: t.leftParticipant,
          style: w2({ paddingLeft: `${t.paddingLeft}px` }),
          context: r.blockInTryBlock,
          number: `${n.number}.1`,
          incremental: ""
        }, null, 8, ["origin", "style", "context", "number"])) : x2("", !0)
      ]),
      (T(!0), B(P2, null, e4(r.tcf.catchBlock(), (c, h) => (T(), B("div", {
        key: h + 500,
        class: "segment mt-2 border-t border-solid"
      }, [
        (T(), B("div", {
          class: "header inline-block bg-skin-frame opacity-65",
          key: h + 1e3
        }, [
          aB,
          _("label", CB, m1(r.exception(c)), 1)
        ])),
        (T(), T2(C, {
          origin: t.leftParticipant,
          style: w2({ paddingLeft: `${t.paddingLeft}px` }),
          context: r.blockInCatchBlock(c),
          key: h + 2e3,
          number: `${n.number}.${r.blockLengthAcc[h] + 1}`,
          incremental: ""
        }, null, 8, ["origin", "style", "context", "number"]))
      ]))), 128)),
      r.finallyBlock ? (T(), B("div", cB, [
        uB,
        N(C, {
          origin: t.leftParticipant,
          style: w2({ paddingLeft: `${t.paddingLeft}px` }),
          context: r.finallyBlock,
          number: `${n.number}.${r.blockLengthAcc[r.blockLengthAcc.length - 1] + 1}`,
          incremental: ""
        }, null, 8, ["origin", "style", "context", "number"])
      ])) : x2("", !0)
    ], 2)
  ], 12, iB);
}
const dB = /* @__PURE__ */ K2(nB, [["render", hB], ["__scopeId", "data-v-c045ab66"]]);
const gB = {
  name: "return",
  props: ["context", "comment", "commentObj", "number"],
  mixins: [w7, x7],
  computed: {
    ...R3(["cursor", "onElementClick"]),
    /**
     * ret
     *  : RETURN expr? SCOL?
     *  | ANNOTATION_RET asyncMessage EVENT_END?
     *  ;
     */
    ret: function() {
      var t;
      return (t = this.context) == null ? void 0 : t.ret();
    },
    asyncMessage: function() {
      var t;
      return (t = this.ret) == null ? void 0 : t.asyncMessage();
    },
    signature: function() {
      var t, e, n, i, s;
      return ((e = (t = this.asyncMessage) == null ? void 0 : t.content()) == null ? void 0 : e.getFormattedText()) || ((s = (i = (n = this.context) == null ? void 0 : n.ret()) == null ? void 0 : i.expr()) == null ? void 0 : s.getFormattedText());
    },
    source: function() {
      var t, e;
      return ((t = this.asyncMessage) == null ? void 0 : t.From()) || ((e = this.ret) == null ? void 0 : e.From()) || K1;
    },
    target: function() {
      var t, e, n, i;
      return (
        // TODO: move this logic to the parser (ReturnTo)
        ((e = (t = this.asyncMessage) == null ? void 0 : t.to()) == null ? void 0 : e.getFormattedText()) || ((i = (n = this.context) == null ? void 0 : n.ret()) == null ? void 0 : i.ReturnTo()) || K1
      );
    },
    isCurrent: function() {
      return !1;
    },
    messageTextStyle() {
      var t;
      return (t = this.commentObj) == null ? void 0 : t.messageStyle;
    },
    messageClassNames() {
      var t;
      return (t = this.commentObj) == null ? void 0 : t.messageClassNames;
    },
    messageContext() {
      var t, e, n;
      return ((t = this.asyncMessage) == null ? void 0 : t.content()) || ((n = (e = this.context) == null ? void 0 : e.ret()) == null ? void 0 : n.expr());
    }
  },
  methods: {
    onClick() {
      this.onElementClick(i0.from(this.context));
    }
  },
  components: {
    Comment: p5,
    Message: h5
  }
}, fB = (t) => (r4("data-v-1501de70"), t = t(), o4(), t), pB = ["data-signature", "data-origin", "data-to", "data-source", "data-target"], mB = {
  key: 1,
  class: "flex items-center"
}, wB = /* @__PURE__ */ fB(() => /* @__PURE__ */ _("svg", {
  class: "w-3 h-3 flex-shrink-0 fill-current m-1",
  viewBox: "0 0 512 512"
}, [
  /* @__PURE__ */ _("path", {
    class: "cls-1",
    d: "M256 0C114.84 0 0 114.84 0 256s114.84 256 256 256 256-114.84 256-256S397.16 0 256 0Zm0 469.33c-117.63 0-213.33-95.7-213.33-213.33S138.37 42.67 256 42.67 469.33 138.37 469.33 256 373.63 469.33 256 469.33Z"
  }),
  /* @__PURE__ */ _("path", {
    class: "cls-1",
    d: "M288 192h-87.16l27.58-27.58a21.33 21.33 0 1 0-30.17-30.17l-64 64a21.33 21.33 0 0 0 0 30.17l64 64a21.33 21.33 0 0 0 30.17-30.17l-27.58-27.58H288a53.33 53.33 0 0 1 0 106.67h-32a21.33 21.33 0 0 0 0 42.66h32a96 96 0 0 0 0-192Z"
  })
], -1)), xB = { class: "name" };
function _B(t, e, n, i, s, r) {
  const o = i2("comment"), l = i2("Message");
  return T(), B("div", {
    class: v2(["interaction return relative", {
      "right-to-left": t.rightToLeft,
      highlight: r.isCurrent
    }]),
    onClick: e[0] || (e[0] = s5((...L) => r.onClick && r.onClick(...L), ["stop"])),
    "data-type": "return",
    "data-signature": r.signature,
    "data-origin": t.origin,
    "data-to": r.target,
    "data-source": r.source,
    "data-target": r.target,
    style: w2({
      width: t.interactionWidth + "px",
      transform: "translateX(" + t.translateX + "px)"
    })
  }, [
    n.comment ? (T(), T2(o, {
      key: 0,
      commentObj: n.commentObj
    }, null, 8, ["commentObj"])) : x2("", !0),
    t.isSelf ? (T(), B("div", mB, [
      wB,
      _("span", xB, m1(r.signature), 1)
    ])) : x2("", !0),
    t.isSelf ? x2("", !0) : (T(), T2(l, {
      key: 2,
      classNames: r.messageClassNames,
      textStyle: r.messageTextStyle,
      context: r.messageContext,
      content: r.signature,
      rtl: t.rightToLeft,
      type: "return",
      number: n.number
    }, null, 8, ["classNames", "textStyle", "context", "content", "rtl", "number"]))
  ], 14, pB);
}
const vB = /* @__PURE__ */ K2(gB, [["render", _B], ["__scopeId", "data-v-1501de70"]]), MB = [
  "aliceblue",
  "antiquewhite",
  "aqua",
  "aquamarine",
  "azure",
  "beige",
  "bisque",
  "black",
  "blanchedalmond",
  "blue",
  "blueviolet",
  "brown",
  "burlywood",
  "cadetblue",
  "chartreuse",
  "chocolate",
  "coral",
  "cornflowerblue",
  "cornsilk",
  "crimson",
  "cyan",
  "darkblue",
  "darkcyan",
  "darkgoldenrod",
  "darkgray",
  "darkgreen",
  "darkgrey",
  "darkkhaki",
  "darkmagenta",
  "darkolivegreen",
  "darkorange",
  "darkorchid",
  "darkred",
  "darksalmon",
  "darkseagreen",
  "darkslateblue",
  "darkslategray",
  "darkslategrey",
  "darkturquoise",
  "darkviolet",
  "deeppink",
  "deepskyblue",
  "dimgray",
  "dimgrey",
  "dodgerblue",
  "firebrick",
  "floralwhite",
  "forestgreen",
  "fuchsia",
  "gainsboro",
  "ghostwhite",
  "gold",
  "goldenrod",
  "gray",
  "green",
  "greenyellow",
  "grey",
  "honeydew",
  "hotpink",
  "indianred",
  "indigo",
  "ivory",
  "khaki",
  "lavender",
  "lavenderblush",
  "lawngreen",
  "lemonchiffon",
  "lightblue",
  "lightcoral",
  "lightcyan",
  "lightgoldenrodyellow",
  "lightgray",
  "lightgreen",
  "lightgrey",
  "lightpink",
  "lightsalmon",
  "lightseagreen",
  "lightskyblue",
  "lightslategray",
  "lightslategrey",
  "lightsteelblue",
  "lightyellow",
  "lime",
  "limegreen",
  "linen",
  "magenta",
  "maroon",
  "mediumaquamarine",
  "mediumblue",
  "mediumorchid",
  "mediumpurple",
  "mediumseagreen",
  "mediumslateblue",
  "mediumspringgreen",
  "mediumturquoise",
  "mediumvioletred",
  "midnightblue",
  "mintcream",
  "mistyrose",
  "moccasin",
  "navajowhite",
  "navy",
  "oldlace",
  "olive",
  "olivedrab",
  "orange",
  "orangered",
  "orchid",
  "palegoldenrod",
  "palegreen",
  "paleturquoise",
  "palevioletred",
  "papayawhip",
  "peachpuff",
  "peru",
  "pink",
  "plum",
  "powderblue",
  "purple",
  "rebeccapurple",
  "red",
  "rosybrown",
  "royalblue",
  "saddlebrown",
  "salmon",
  "sandybrown",
  "seagreen",
  "seashell",
  "sienna",
  "silver",
  "skyblue",
  "slateblue",
  "slategray",
  "slategrey",
  "snow",
  "springgreen",
  "steelblue",
  "tan",
  "teal",
  "thistle",
  "tomato",
  "turquoise",
  "violet",
  "wheat",
  "white",
  "whitesmoke",
  "yellow",
  "yellowgreen"
], RB = ["italic", "oblique"], yB = ["bold", "bolder", "lighter"], AB = ["underline", "overline", "line-through"], E0 = (t) => {
  const e = {}, n = [];
  return t.forEach((i) => {
    switch (!0) {
      case MB.includes(i):
        e.color = i;
        break;
      case RB.includes(i):
        e.fontStyle = i;
        break;
      case yB.includes(i):
        e.fontWeight = i;
        break;
      case AB.includes(i):
        e.textDecoration = i;
        break;
      default:
        n.push(i);
    }
  }), { textStyle: e, classNames: n };
};
const ZB = {
  name: "divider",
  props: ["context", "origin"],
  computed: {
    ...R3(["participants", "centerOf"]),
    /* Dividers have the same width as the lifeline layer */
    width() {
      let t = this.participants.Names().pop();
      return this.centerOf(t) + 10;
    },
    centerOfOrigin() {
      return this.centerOf(this.origin);
    },
    note: function() {
      return this.context.divider().Note();
    },
    messageStyle() {
      if (this.note.trim().indexOf("[") === 0 && this.note.indexOf("]") !== -1) {
        const t = this.note.indexOf("["), e = this.note.indexOf("]"), [n, i] = [
          this.note.slice(t + 1, e),
          this.note.slice(e + 1)
        ];
        return { style: E0(n.split(",").map((s) => s.trim())), note: i };
      }
      return { style: E0([]), note: this.note };
    }
  }
}, eC = (t) => (r4("data-v-376dd717"), t = t(), o4(), t), kB = ["data-origin"], TB = /* @__PURE__ */ eC(() => /* @__PURE__ */ _("div", { class: "left bg-skin-divider" }, null, -1)), SB = /* @__PURE__ */ eC(() => /* @__PURE__ */ _("div", { class: "right bg-skin-divider" }, null, -1));
function bB(t, e, n, i, s, r) {
  return T(), B("div", {
    class: "divider",
    "data-origin": n.origin,
    style: w2({
      width: r.width + "px",
      transform: "translateX(" + (-1 * r.centerOfOrigin + 10) + "px)"
    })
  }, [
    TB,
    _("div", {
      class: v2(["name", r.messageStyle.style.classNames]),
      style: w2(r.messageStyle.style.textStyle)
    }, m1(r.messageStyle.note), 7),
    SB
  ], 12, kB);
}
const EB = /* @__PURE__ */ K2(ZB, [["render", bB], ["__scopeId", "data-v-376dd717"]]);
function IB(t) {
  const e = {
    "<>": /* @__PURE__ */ new Set(),
    "()": /* @__PURE__ */ new Set(),
    "[]": /* @__PURE__ */ new Set()
  }, n = /<([^>]*)>|\(([^)]*)\)|\[([^\]]*)\]|([^<>()[\]\s]+)/g;
  let i, s;
  for (; i = n.exec(t); ) {
    if (i[4]) {
      s !== void 0 && (s = i.index);
      break;
    }
    s = i.index + i[0].length, i[1] && i[1].split(",").forEach((r) => e["<>"].add(r.trim())), i[2] && i[2].split(",").forEach((r) => e["()"].add(r.trim())), i[3] && i[3].split(",").forEach((r) => e["[]"].add(r.trim()));
  }
  return [
    Array.from(e["<>"]),
    Array.from(e["()"]),
    Array.from(e["[]"]),
    t.slice(s)
  ];
}
let FB = class {
  // Raw comment contains all spaces and newlines
  constructor(e) {
    this.text = "", this.classNames = [], this.textStyle = {}, this.commentStyle = {}, this.messageStyle = {}, this.commentClassNames = [], this.messageClassNames = [];
    const n = e.slice(0, -1).split(`
`), i = n[n.length - 1], [s, r, o, l] = IB(i), { textStyle: L, classNames: a } = E0(s), { textStyle: C, classNames: c } = E0(r), { textStyle: h, classNames: d } = E0(o);
    this.text = (n.slice(0, n.length - 1).join(`
`) + `
` + l).trim(), this.textStyle = { ...h, ...L, ...C }, this.classNames = [
      ...d,
      ...a,
      ...c
    ], this.commentStyle = { ...h, ...L }, this.messageStyle = { ...h, ...C }, this.commentClassNames = [...d, ...a], this.messageClassNames = [...d, ...c];
  }
};
const OB = {
  name: "statement",
  props: ["origin", "context", "number", "collapsed"],
  computed: {
    comment: function() {
      return this.context.getComment() ? this.context.getComment() : "";
    },
    commentObj: function() {
      return new FB(this.comment);
    },
    subStatement: function() {
      let t = this, e = {
        loop: "FragmentLoop",
        alt: "FragmentAlt",
        par: "FragmentPar",
        opt: "FragmentOpt",
        section: "FragmentSection",
        critical: "FragmentCritical",
        tcf: "FragmentTryCatchFinally",
        ref: "FragmentRef",
        creation: "Creation",
        message: "Interaction",
        asyncMessage: "InteractionAsync",
        divider: "Divider",
        ret: "Return"
      }, n = Object.keys(e).find((i) => t.context[i]() !== null);
      return e[n];
    },
    collapsedCheck: function() {
      return this.collapsed && this.subStatement !== "Return";
    }
  },
  components: {
    Creation: bO,
    Interaction: WO,
    InteractionAsync: XO,
    FragmentAlt: xN,
    FragmentPar: ZN,
    FragmentOpt: HN,
    FragmentSection: OP,
    FragmentCritical: GP,
    FragmentRef: tB,
    FragmentTryCatchFinally: dB,
    FragmentLoop: NN,
    Divider: EB,
    Return: vB
  }
};
function NB(t, e, n, i, s, r) {
  return T(), T2(B8(r.subStatement), {
    class: v2(["text-left text-sm text-skin-message", { hidden: r.collapsedCheck }]),
    origin: n.origin,
    context: n.context,
    comment: r.comment,
    commentObj: r.commentObj,
    number: n.number
  }, null, 8, ["origin", "class", "context", "comment", "commentObj", "number"]);
}
const DB = /* @__PURE__ */ K2(OB, [["render", NB]]), PB = ["data-origin"], BB = ["data-origin"], zB = /* @__PURE__ */ q2({
  __name: "Block",
  props: {
    origin: null,
    context: null,
    number: null,
    incremental: { type: Boolean },
    collapsed: { type: Boolean }
  },
  setup(t) {
    const e = t, n = I(() => {
      var s;
      return ((s = e.context) == null ? void 0 : s.stat()) || [];
    }), i = (s) => e.number ? e.incremental ? za(e.number, s) : `${e.number}.${s + 1}` : String(s + 1);
    return (s, r) => (T(), B("div", {
      class: "block",
      "data-origin": t.origin
    }, [
      (T(!0), B(P2, null, e4(O(n), (o, l) => (T(), B("div", {
        class: "statement-container my-4",
        "data-origin": t.origin,
        key: l
      }, [
        N(DB, {
          origin: t.origin,
          context: o,
          collapsed: t.collapsed,
          number: i(l)
        }, null, 8, ["origin", "context", "collapsed", "number"])
      ], 8, BB))), 128))
    ], 8, PB));
  }
});
function UB(t) {
  const e = Math.floor(t / 1e3), n = Math.floor(t % 1e3), i = Math.floor((t % 1e3 - n) * 1e3);
  return e + "s " + n + "ms " + i + "μs";
}
const WB = (t, e) => {
  const i = tC() - e;
  return console.debug(t + " cost: " + UB(i)), i;
}, tC = () => performance.now(), HB = y8.child({ name: "core" });
class $B {
  constructor(e, n = !1) {
    this._lastRenderingCostMilliseconds = 0, this.initialRender = !0, this.el = e, this.store = Yo(LL()), this.app = r5(n ? Gt : xa), this.app.component("Comment", p5), this.app.component("Block", zB), this.app.use(this.store), this.app.mount(this.el), this.addPortalRootElement();
  }
  // DON'T REMOVE: headlessui portal root hack
  // ref: https://github.com/tailwindlabs/headlessui/discussions/666#discussioncomment-4966117
  addPortalRootElement() {
    const e = document.createElement("div");
    e.id = "headlessui-portal-root", e.className = "zenuml", e.append(document.createElement("div")), document.body.append(e);
  }
  async render(e, n) {
    return this._currentTimeout && (console.debug("rendering clearTimeout"), clearTimeout(this._currentTimeout)), HB.debug("rendering", e, n), this._code = e === void 0 ? this._code : e, this._theme = (n == null ? void 0 : n.theme) || this._theme, this.store.state.stickyOffset = (n == null ? void 0 : n.stickyOffset) || 0, this.store.state.theme = this._theme || "default", this.store.state.enableScopedTheming = (n == null ? void 0 : n.enableScopedTheming) || !1, this.store.state.mode = (n == null ? void 0 : n.mode) || j1.Dynamic, this.initialRender ? (this.initialRender = !1, await this.doRender(n)) : this._currentTimeout = setTimeout(
      async () => await this.doRender(n),
      this.calculateDebounceMilliseconds()
    ), this;
  }
  async doRender(e) {
    console.debug("rendering start");
    const n = tC();
    sL(), this.store.commit("onContentChange", (e == null ? void 0 : e.onContentChange) || (() => {
    })), this.store.commit("onThemeChange", (e == null ? void 0 : e.onThemeChange) || (() => {
    })), this.store.commit("onEventEmit", (e == null ? void 0 : e.onEventEmit) || (() => {
    })), (e == null ? void 0 : e.enableMultiTheme) !== void 0 && (this.store.state.enableMultiTheme = e == null ? void 0 : e.enableMultiTheme), await this.store.dispatch("updateCode", { code: this._code }), this._lastRenderingCostMilliseconds = WB(
      "rendering end",
      n
    );
  }
  calculateDebounceMilliseconds() {
    let e = this._lastRenderingCostMilliseconds;
    return e > 2e3 && (e = 2e3), console.debug("rendering debounce: " + e + "ms"), e;
  }
  get code() {
    return this._code;
  }
  get theme() {
    return this._theme;
  }
  async getPng() {
    return this.el.children[0].__vue__.toPng();
  }
}
$B.version = rI;
const hz = {
  createApp: r5,
  createStore: Yo,
  Store: LL,
  SeqDiagram: Gt,
  DiagramFrame: xa
};
export {
  _ as A,
  B,
  e4 as C,
  v2 as D,
  m1 as E,
  P2 as F,
  eL as G,
  Cz as H,
  Yf as I,
  sp as P,
  wa as S,
  i5 as T,
  La as U,
  hz as V,
  $B as Z,
  _c as a,
  s1 as b,
  I as c,
  W0 as d,
  x3 as e,
  x2 as f,
  VC as g,
  f1 as h,
  X6 as i,
  T3 as j,
  q2 as k,
  GB as l,
  $8 as m,
  P4 as n,
  GC as o,
  a3 as p,
  F3 as q,
  R2 as r,
  Lr as s,
  Cr as t,
  O as u,
  NL as v,
  m3 as w,
  T as x,
  T2 as y,
  h3 as z
};
//# sourceMappingURL=core-93d86384.js.map
